
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec782"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec782"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ecd4d", function(module, exports) {

$parcel$export(module.exports, "compile", () => $a55c527d369bf9c1$export$ef7acd7185315e22);
/**
* vue v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ parcelRequire("eeJ70");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};
$parcel$exportWildcard(module.exports, $eeJ70);

});
parcelRegister("eeJ70", function(module, exports) {

$parcel$export(module.exports, "nodeOps", () => $a5d55dc64ccb07cf$export$de4fb7f5030605d3);
$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "useCssVars", () => $a5d55dc64ccb07cf$export$ef28b76f07940108);
$parcel$export(module.exports, "patchProp", () => $a5d55dc64ccb07cf$export$cd4aa0842d13df8b);
$parcel$export(module.exports, "defineCustomElement", () => $a5d55dc64ccb07cf$export$a00e2346eabbdbef);
$parcel$export(module.exports, "VueElement", () => $a5d55dc64ccb07cf$export$b337c1a55163dbe3);
$parcel$export(module.exports, "defineSSRCustomElement", () => $a5d55dc64ccb07cf$export$6debb2e68f212638);
$parcel$export(module.exports, "createSSRApp", () => $a5d55dc64ccb07cf$export$35800275c0037383);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "render", () => $a5d55dc64ccb07cf$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "useHost", () => $a5d55dc64ccb07cf$export$da5acfe93a94e37d);
$parcel$export(module.exports, "useShadowRoot", () => $a5d55dc64ccb07cf$export$64d45095031fa749);
$parcel$export(module.exports, "useCssModule", () => $a5d55dc64ccb07cf$export$9300d5b90d56e3d1);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $a5d55dc64ccb07cf$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "vModelDynamic", () => $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
$parcel$export(module.exports, "hydrate", () => $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
$parcel$export(module.exports, "initDirectivesForSSR", () => $a5d55dc64ccb07cf$export$800b28255aa678d9);
/**
* @vue/runtime-dom v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow(el);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow(el);
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $8POXm.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(?:^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$a5d55dc64ccb07cf$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $8POXm.isString)(prev) && prev ? prev[key] : void 0, value)) $a5d55dc64ccb07cf$var$setStyle(style, key, value);
            } else $a5d55dc64ccb07cf$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $a5d55dc64ccb07cf$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $8POXm.isString)(next) && prev === next;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $a5d55dc64ccb07cf$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)) && !$a5d55dc64ccb07cf$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $8POXm.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $TusQn.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $TusQn.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue)))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
function $a5d55dc64ccb07cf$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $8POXm.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $8POXm.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $8POXm.camelize)(prop) === camelKey);
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) Comp = (0, $8POXm.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $8POXm.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = this._def.configureApp;
                resolve(this._def = def, true);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$a5d55dc64ccb07cf$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, $a5d55dc64ccb07cf$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, $a5d55dc64ccb07cf$var$getPosition(c.el));
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = /* @__PURE__ */ Symbol("_assign");
const $a5d55dc64ccb07cf$var$initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function $a5d55dc64ccb07cf$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $8POXm.looseToNumber)(value);
    return value;
}
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$a5d55dc64ccb07cf$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$a5d55dc64ccb07cf$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = $a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$a5d55dc64ccb07cf$var$initialValueKey];
        delete el[$a5d55dc64ccb07cf$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? (0, $8POXm.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$export$cd4aa0842d13df8b
}, $a5d55dc64ccb07cf$export$de4fb7f5030605d3);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $TusQn);

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithErrorHandling", () => $0a6cc4ba868319ae$export$b22fcaf88446e9bf);
$parcel$export(module.exports, "assertNumber", () => $0a6cc4ba868319ae$export$dfbcecb440255e4a);
$parcel$export(module.exports, "ErrorCodes", () => $0a6cc4ba868319ae$export$10e8e1cf990558d7);
$parcel$export(module.exports, "handleError", () => $0a6cc4ba868319ae$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $0a6cc4ba868319ae$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "pushScopeId", () => $0a6cc4ba868319ae$export$ac020265ca2cc4cd);
$parcel$export(module.exports, "popScopeId", () => $0a6cc4ba868319ae$export$f2dc6805dc11834e);
$parcel$export(module.exports, "withScopeId", () => $0a6cc4ba868319ae$export$15ba313e13f3dd04);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "setBlockTracking", () => $0a6cc4ba868319ae$export$c20bee82f26f1e27);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "hasInjectionContext", () => $0a6cc4ba868319ae$export$caf6761f24fc571a);
$parcel$export(module.exports, "ssrContextKey", () => $0a6cc4ba868319ae$export$f2549a27e18acf2d);
$parcel$export(module.exports, "useSSRContext", () => $0a6cc4ba868319ae$export$6b1c54dc4befcda);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watchSyncEffect", () => $0a6cc4ba868319ae$export$2035654f31b0e555);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "cloneVNode", () => $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "useId", () => $0a6cc4ba868319ae$export$f680877a34711e37);
$parcel$export(module.exports, "useTemplateRef", () => $0a6cc4ba868319ae$export$83a5dbc1f35517ca);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "hydrateOnIdle", () => $0a6cc4ba868319ae$export$8bfca283fd254627);
$parcel$export(module.exports, "hydrateOnVisible", () => $0a6cc4ba868319ae$export$2b04cd335e660930);
$parcel$export(module.exports, "hydrateOnMediaQuery", () => $0a6cc4ba868319ae$export$804dbb6002787b74);
$parcel$export(module.exports, "hydrateOnInteraction", () => $0a6cc4ba868319ae$export$288f5a9b4248e114);
$parcel$export(module.exports, "defineAsyncComponent", () => $0a6cc4ba868319ae$export$d75d499b4c16cf21);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "isVNode", () => $0a6cc4ba868319ae$export$3868d13f8734ae81);
$parcel$export(module.exports, "KeepAlive", () => $0a6cc4ba868319ae$export$70eb8a58709972df);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "onServerPrefetch", () => $0a6cc4ba868319ae$export$ebf0c601f267bceb);
$parcel$export(module.exports, "onRenderTriggered", () => $0a6cc4ba868319ae$export$898295a813d662eb);
$parcel$export(module.exports, "onRenderTracked", () => $0a6cc4ba868319ae$export$2b41f4235363e921);
$parcel$export(module.exports, "onErrorCaptured", () => $0a6cc4ba868319ae$export$6a3a15856e50ad19);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "resolveDirective", () => $0a6cc4ba868319ae$export$a1989e995cd481be);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $0a6cc4ba868319ae$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $0a6cc4ba868319ae$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "defineProps", () => $0a6cc4ba868319ae$export$80b33eababae110e);
$parcel$export(module.exports, "defineEmits", () => $0a6cc4ba868319ae$export$51ecece22fc17ddc);
$parcel$export(module.exports, "defineExpose", () => $0a6cc4ba868319ae$export$da25b65ca24b518a);
$parcel$export(module.exports, "defineOptions", () => $0a6cc4ba868319ae$export$77e79129327f3d0d);
$parcel$export(module.exports, "defineSlots", () => $0a6cc4ba868319ae$export$1b3acd4bb805b712);
$parcel$export(module.exports, "defineModel", () => $0a6cc4ba868319ae$export$acd55aa037e791bb);
$parcel$export(module.exports, "withDefaults", () => $0a6cc4ba868319ae$export$4df9c0969a9e0160);
$parcel$export(module.exports, "useSlots", () => $0a6cc4ba868319ae$export$9203a8e84125433c);
$parcel$export(module.exports, "useAttrs", () => $0a6cc4ba868319ae$export$75e29435042cd2ea);
$parcel$export(module.exports, "mergeDefaults", () => $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f);
$parcel$export(module.exports, "mergeModels", () => $0a6cc4ba868319ae$export$ad4f724f587e6828);
$parcel$export(module.exports, "createPropsRestProxy", () => $0a6cc4ba868319ae$export$7c343e855c563faa);
$parcel$export(module.exports, "withAsyncContext", () => $0a6cc4ba868319ae$export$d6d6f7369f1fb104);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "version", () => $0a6cc4ba868319ae$export$83d89fbfd8236492);
$parcel$export(module.exports, "useModel", () => $0a6cc4ba868319ae$export$fb78bd113157f1a1);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "Suspense", () => $0a6cc4ba868319ae$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "transformVNodeArgs", () => $0a6cc4ba868319ae$export$83beccd3afeeb809);
$parcel$export(module.exports, "guardReactiveProps", () => $0a6cc4ba868319ae$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $0a6cc4ba868319ae$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "withMemo", () => $0a6cc4ba868319ae$export$2a6d714a4d738ae);
$parcel$export(module.exports, "isMemoSame", () => $0a6cc4ba868319ae$export$bf525184d622787c);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "ErrorTypeStrings", () => $0a6cc4ba868319ae$export$795e0ad4a0e2ed30);
$parcel$export(module.exports, "devtools", () => $0a6cc4ba868319ae$export$6922d3b3a607469e);
$parcel$export(module.exports, "setDevtoolsHook", () => $0a6cc4ba868319ae$export$b0c258b32c26c785);
$parcel$export(module.exports, "ssrUtils", () => $0a6cc4ba868319ae$export$a9679033567b336d);
$parcel$export(module.exports, "resolveFilter", () => $0a6cc4ba868319ae$export$83cf26e06ea620e1);
$parcel$export(module.exports, "compatUtils", () => $0a6cc4ba868319ae$export$dc678eddf276286e);
$parcel$export(module.exports, "DeprecationTypes", () => $0a6cc4ba868319ae$export$22072a82865312f6);
$parcel$export(module.exports, "EffectScope", () => (parcelRequire("01W3b")).EffectScope);
$parcel$export(module.exports, "ReactiveEffect", () => (parcelRequire("01W3b")).ReactiveEffect);
$parcel$export(module.exports, "TrackOpTypes", () => (parcelRequire("01W3b")).TrackOpTypes);
$parcel$export(module.exports, "TriggerOpTypes", () => (parcelRequire("01W3b")).TriggerOpTypes);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "effect", () => (parcelRequire("01W3b")).effect);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "getCurrentWatcher", () => (parcelRequire("01W3b")).getCurrentWatcher);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("01W3b")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isShallow", () => (parcelRequire("01W3b")).isShallow);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "onWatcherCleanup", () => (parcelRequire("01W3b")).onWatcherCleanup);
$parcel$export(module.exports, "proxyRefs", () => (parcelRequire("01W3b")).proxyRefs);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "stop", () => (parcelRequire("01W3b")).stop);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("01W3b")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("8POXm")).capitalize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8POXm")).normalizeProps);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("8POXm")).toHandlerKey);
/**
* @vue/runtime-core v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else for(let i = 0; i < cb.length; i++)$0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb[i]);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            for(let i = 0; i < deduped.length; i++)$0a6cc4ba868319ae$var$activePostFlushCbs.push(deduped[i]);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$setHmrUpdating = (v1)=>{
    try {
        return $0a6cc4ba868319ae$var$isHmrUpdating;
    } finally{
        $0a6cc4ba868319ae$var$isHmrUpdating = v1;
    }
};
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $0a6cc4ba868319ae$var$isHmrUpdating = true;
                instance.parent.update();
                $0a6cc4ba868319ae$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $0a6cc4ba868319ae$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $0a6cc4ba868319ae$var$blockStack.length; i > prevStackSize; i--)$0a6cc4ba868319ae$var$closeBlock();
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if ($0a6cc4ba868319ae$var$currentInstance) {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        let provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$export$f13e630aa3915748() || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $0a6cc4ba868319ae$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $0a6cc4ba868319ae$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($0a6cc4ba868319ae$var$pendingMounts.get(vnode) !== mountJob) return;
                $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
                if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $0a6cc4ba868319ae$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $0a6cc4ba868319ae$var$pendingMounts.set(vnode, mountJob);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $0a6cc4ba868319ae$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $0a6cc4ba868319ae$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $0a6cc4ba868319ae$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$0a6cc4ba868319ae$var$pendingMounts.has(vnode) && (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $0a6cc4ba868319ae$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $0a6cc4ba868319ae$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(oldInnerChild, innerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$0a6cc4ba868319ae$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            const done = el[$0a6cc4ba868319ae$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        const subTree = vnode.component.subTree;
        $0a6cc4ba868319ae$export$7770a22486565649($0a6cc4ba868319ae$var$isTeleport(subTree.type) ? $0a6cc4ba868319ae$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $0a6cc4ba868319ae$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? (0, $8POXm.NO) : (key)=>{
        if ($0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $0a6cc4ba868319ae$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $0a6cc4ba868319ae$var$pendingSetRefMap.set(rawRef, job);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $0a6cc4ba868319ae$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(node, "__vnode", vnode, true);
            (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $8POXm.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($0a6cc4ba868319ae$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $0a6cc4ba868319ae$var$resourceProps = /* @__PURE__ */ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $0a6cc4ba868319ae$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$0a6cc4ba868319ae$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if (key === "hidden") {
            actual = $0a6cc4ba868319ae$var$normalizeHiddenValue(el.getAttribute(key));
            expected = $0a6cc4ba868319ae$var$normalizeHiddenValue(clientValue);
        } else if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$normalizeHiddenValue(value) {
    if (!(0, $8POXm.isRenderableAttrValue)(value)) return false;
    if ((0, $8POXm.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $8POXm.includeBooleanAttr)(value) ? "" : false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $8POXm.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    return $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr), allowedType);
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
function $0a6cc4ba868319ae$var$isNodeMismatchAllowed(node, vnode) {
    return $0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $0a6cc4ba868319ae$var$isMismatchAllowedByNode(node) || $0a6cc4ba868319ae$var$isMismatchAllowedByVNode(vnode);
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(node.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $0a6cc4ba868319ae$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$0a6cc4ba868319ae$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $0a6cc4ba868319ae$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            isReadonlySource = (0, $01W3b.isReadonly)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $01W3b.toReadonly)((0, $01W3b.toReactive)(source[i])) : (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $8POXm.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $0a6cc4ba868319ae$var$blockStack.length;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $0a6cc4ba868319ae$var$blockStack.length; i > prevStackSize; i--)$0a6cc4ba868319ae$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $8POXm.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && key[0] !== "$" && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (0, $8POXm.hasOwn)(props, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext("useSlots").slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext("useAttrs").attrs;
}
function $0a6cc4ba868319ae$var$getContext(calledFunctionName) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const inSSRSetup = $0a6cc4ba868319ae$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    const restore = ()=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($0a6cc4ba868319ae$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
        if (inSSRSetup) $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    };
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, prevSetValue) && ((0, $8POXm.hasChanged)(value, emittedValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $8POXm.EMPTY_OBJ) && !(0, $8POXm.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $0a6cc4ba868319ae$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $0a6cc4ba868319ae$var$isTeleport(root.type) ? $0a6cc4ba868319ae$var$getInnerChild$1(root) || root : root;
        $0a6cc4ba868319ae$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $8POXm.isObject)(nextProp) && (0, $8POXm.isObject)(prevProp)) return !(0, $8POXm.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8POXm.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && $0a6cc4ba868319ae$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if ((0, $8POXm.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0a6cc4ba868319ae$var$isInternalKey(key)) slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(measureName, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMeasures(measureName);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $0a6cc4ba868319ae$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(el, "__vnode", vnode, true);
            (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$0a6cc4ba868319ae$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$0a6cc4ba868319ae$var$leaveCbKey];
                    if (el._isLeaving) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $01W3b.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $0a6cc4ba868319ae$var$unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$var$hasContentChildren(children) {
    if ((0, $8POXm.isString)(children)) return children !== "";
    if ((0, $8POXm.isArray)(children)) return children.length > 0;
    return false;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        if (shapeFlag & 65) {
            $0a6cc4ba868319ae$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $8POXm.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$setInSSRSetupState(true);
                try {
                    $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $0a6cc4ba868319ae$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])\w/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
                if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.41";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "effect", () => $005d1fb7704e278c$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "stop", () => $005d1fb7704e278c$export$fa6813432f753b0d);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $005d1fb7704e278c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "triggerRef", () => $005d1fb7704e278c$export$f402f86588575ccc);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $005d1fb7704e278c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "TrackOpTypes", () => $005d1fb7704e278c$export$2ac2bd0a56e04551);
$parcel$export(module.exports, "TriggerOpTypes", () => $005d1fb7704e278c$export$1e8941c92696a26);
$parcel$export(module.exports, "getCurrentWatcher", () => $005d1fb7704e278c$export$2532f7acfca7c82d);
$parcel$export(module.exports, "onWatcherCleanup", () => $005d1fb7704e278c$export$8ddeeb083684a9d0);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) {
            if ($005d1fb7704e278c$var$activeEffectScope.active) {
                this.parent = $005d1fb7704e278c$var$activeEffectScope;
                this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $005d1fb7704e278c$var$activeEffectScope;
            $005d1fb7704e278c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($005d1fb7704e278c$var$activeEffectScope === this) $005d1fb7704e278c$var$activeEffectScope = this.prevScope;
            else {
                let current = $005d1fb7704e278c$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope) {
            if ($005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$005d1fb7704e278c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
function $005d1fb7704e278c$var$toWrapped(target, item) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return $005d1fb7704e278c$export$352205f445242f02(target) ? $005d1fb7704e278c$export$4a78e7a2a4fb689f($005d1fb7704e278c$export$45c769cf449a508c(item)) : $005d1fb7704e278c$export$4a78e7a2a4fb689f(item);
    return $005d1fb7704e278c$export$45c769cf449a508c(item);
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$005d1fb7704e278c$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $005d1fb7704e278c$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $005d1fb7704e278c$var$toWrapped(self, result) : result;
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return (0, $8POXm.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const rawValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $8POXm.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $8POXm.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(value)) return /* @__PURE__ */ $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $8POXm.isSymbol)(key) ? key : String(key);
        this._raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $8POXm.isArray)(_object) || (0, $8POXm.isSymbol)(this._key) || !(0, $8POXm.isIntegerKey)(this._key)) do shallow = !$005d1fb7704e278c$export$5f3ca29d057519b3(obj) || $005d1fb7704e278c$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $005d1fb7704e278c$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive(this._raw, this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    return new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            const res = _cb(...args);
            watchHandle();
            return res;
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $66ea9d0aaa418c4d$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.41
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-\w/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});





parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84d1df06ca739753$export$2e2bcd8739ae039);

var $gt0ky = parcelRequire("gt0ky");
var $84d1df06ca739753$export$2e2bcd8739ae039 = {
    name: 'app',
    components: {
        Banner: $gt0ky.default
    },
    data () {
        return {
            bundler: 'Parcel'
        };
    },
    methods: {
        getWidth () {
            let width = '70%';
            switch(this.$vuetify.display.name){
                case 'md':
                    width = '80%';
                    break;
                case 'sm':
                    width = '90%';
                    break;
                case 'xs':
                    width = '95%';
                    break;
            }
            return width;
        }
    }
};

});
parcelRegister("gt0ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfcf9c653dd4281d$export$2e2bcd8739ae039);
let $bfcf9c653dd4281d$var$script;




let $bfcf9c653dd4281d$var$initialize = ()=>{
    $bfcf9c653dd4281d$var$script = (parcelRequire("kztWU"));
    if ($bfcf9c653dd4281d$var$script.__esModule) $bfcf9c653dd4281d$var$script = $bfcf9c653dd4281d$var$script.default;
    $bfcf9c653dd4281d$var$script.render = (parcelRequire("4LqGM")).render;
    $bfcf9c653dd4281d$var$script.__cssModules = {};
    (parcelRequire("aFpwf")).default($bfcf9c653dd4281d$var$script);
    $bfcf9c653dd4281d$var$script.__scopeId = 'data-v-b223e5';
    $bfcf9c653dd4281d$var$script.__file = "Banner.vue";
};
$bfcf9c653dd4281d$var$initialize();
var $bfcf9c653dd4281d$export$2e2bcd8739ae039 = $bfcf9c653dd4281d$var$script;

});
parcelRegister("kztWU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ef9e4eca3ceff5c6$export$2e2bcd8739ae039);
var $ef9e4eca3ceff5c6$export$2e2bcd8739ae039 = {
    name: 'Banner',
    data () {
        const router = this.$router;
        return {
            hidden: true,
            routes: router.getRoutes()
        };
    },
    mounted () {
        this.hidden = this.isMobile();
    },
    methods: {
        toggleOverlay () {
            this.hidden = !this.hidden;
        },
        isMobile () {
            return this.$vuetify.display.mobile;
        },
        handleOverlayInputEvent (isShown) {
            this.hidden = !isShown;
        }
    }
};

});

parcelRegister("4LqGM", function(module, exports) {

$parcel$export(module.exports, "render", () => $3780411268961a67$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $3780411268961a67$var$_hoisted_1 = {
    id: "banner"
};
function $3780411268961a67$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_app_bar_nav_icon = (0, $TusQn.resolveComponent)("v-app-bar-nav-icon");
    const _component_v_app_bar = (0, $TusQn.resolveComponent)("v-app-bar");
    const _component_v_list_item_title = (0, $TusQn.resolveComponent)("v-list-item-title");
    const _component_v_list_item = (0, $TusQn.resolveComponent)("v-list-item");
    const _component_v_list = (0, $TusQn.resolveComponent)("v-list");
    const _component_v_navigation_drawer = (0, $TusQn.resolveComponent)("v-navigation-drawer");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3780411268961a67$var$_hoisted_1, [
        $options.isMobile() ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_app_bar, {
            key: 0,
            density: "compact",
            flat: "",
            fixed: ""
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_v_app_bar_nav_icon, {
                        onClick: _cache[0] || (_cache[0] = ($event)=>$options.toggleOverlay())
                    })
                ]),
            _: 1
        })) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createVNode)(_component_v_navigation_drawer, {
            rail: "",
            "expand-on-hover": "",
            permanent: !$options.isMobile(),
            "model-value": !$data.hidden,
            "onUpdate:modelValue": $options.handleOverlayInputEvent
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_v_list, null, {
                        default: (0, $TusQn.withCtx)(()=>[
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.routes, (route)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_list_item, {
                                        key: route.meta.title,
                                        to: route.path,
                                        link: "",
                                        "prepend-icon": route.meta.icon
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createVNode)(_component_v_list_item_title, null, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(route.meta.title), 1)
                                                        ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to",
                                        "prepend-icon"
                                    ]);
                                }), 128))
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }, 8, [
            "permanent",
            "model-value",
            "onUpdate:modelValue"
        ])
    ]);
}

});

parcelRegister("aFpwf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c41874db0bd1f93$export$2e2bcd8739ae039);
let $7c41874db0bd1f93$var$NOOP = ()=>{};
var $7c41874db0bd1f93$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Banner = (0, $TusQn.resolveComponent)("Banner");
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    const _component_v_main = (0, $TusQn.resolveComponent)("v-main");
    const _component_v_app = (0, $TusQn.resolveComponent)("v-app");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_app, null, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_Banner),
                (0, $TusQn.createVNode)(_component_v_main, {
                    id: "main",
                    style: (0, $8POXm.normalizeStyle)({
                        width: $options.getWidth()
                    })
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_router_view, null, {
                                default: (0, $TusQn.withCtx)(({ Component: Component })=>[
                                        (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                                            name: "fade",
                                            mode: "out-in"
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(Component)))
                                                ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "style"
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("6xlhX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4c2656a54813eeaf$export$2e2bcd8739ae039);

var $lWzCO = parcelRequire("lWzCO");

var $c4tyj = parcelRequire("c4tyj");

const $4c2656a54813eeaf$var$Mugshot = new URL((parcelRequire("bgTZZ"))).href;
var $4c2656a54813eeaf$export$2e2bcd8739ae039 = {
    name: 'About',
    components: {
        DescriptionSection: $lWzCO.default
    },
    data () {
        return {
            imagePath: $4c2656a54813eeaf$var$Mugshot,
            descriptionItems: (0, $c4tyj.default)
        };
    }
};

});
parcelRegister("lWzCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9aa6272487c115$export$2e2bcd8739ae039);
let $ff9aa6272487c115$var$script;




let $ff9aa6272487c115$var$initialize = ()=>{
    $ff9aa6272487c115$var$script = (parcelRequire("9luct"));
    if ($ff9aa6272487c115$var$script.__esModule) $ff9aa6272487c115$var$script = $ff9aa6272487c115$var$script.default;
    $ff9aa6272487c115$var$script.render = (parcelRequire("6zemt")).render;
    $ff9aa6272487c115$var$script.__cssModules = {};
    (parcelRequire("lDwe6")).default($ff9aa6272487c115$var$script);
    $ff9aa6272487c115$var$script.__scopeId = 'data-v-7ba7ba';
    $ff9aa6272487c115$var$script.__file = "DescriptionSection.vue";
};
$ff9aa6272487c115$var$initialize();
var $ff9aa6272487c115$export$2e2bcd8739ae039 = $ff9aa6272487c115$var$script;

});
parcelRegister("9luct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6cdd805ba8f763d4$export$2e2bcd8739ae039);
var $6cdd805ba8f763d4$export$2e2bcd8739ae039 = {
    name: 'DescriptionSection',
    props: {
        items: Array
    },
    methods: {
        parseText (text) {
            return text.split(/\n/g);
        }
    }
};

});

parcelRegister("6zemt", function(module, exports) {

$parcel$export(module.exports, "render", () => $4c8126daa8ac23a4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $4c8126daa8ac23a4$var$_hoisted_1 = {
    class: "sectionHeader"
};
const $4c8126daa8ac23a4$var$_hoisted_2 = {
    class: "text"
};
const $4c8126daa8ac23a4$var$_hoisted_3 = [
    "innerHTML"
];
function $4c8126daa8ac23a4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_col = (0, $TusQn.resolveComponent)("v-col");
    const _component_v_row = (0, $TusQn.resolveComponent)("v-row");
    const _component_v_container = (0, $TusQn.resolveComponent)("v-container");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_container, null, {
        default: (0, $TusQn.withCtx)(()=>[
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.items, (item)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_row, {
                        class: "section"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_v_col, null, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("p", $4c8126daa8ac23a4$var$_hoisted_1, (0, $8POXm.toDisplayString)(item.header), 1),
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.parseText(item.text), (paragraph)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4c8126daa8ac23a4$var$_hoisted_2, [
                                                    (0, $TusQn.createElementVNode)("p", {
                                                        innerHTML: paragraph
                                                    }, null, 8, $4c8126daa8ac23a4$var$_hoisted_3)
                                                ]);
                                            }), 256))
                                        ]),
                                    _: 2
                                }, 1024)
                            ]),
                        _: 2
                    }, 1024);
                }), 256))
            ]),
        _: 1
    });
}

});

parcelRegister("lDwe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc063cfc61c0714b$export$2e2bcd8739ae039);
let $fc063cfc61c0714b$var$NOOP = ()=>{};
var $fc063cfc61c0714b$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("c4tyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c9cc83e7b59e5d3$export$2e2bcd8739ae039);
var $8c9cc83e7b59e5d3$export$2e2bcd8739ae039 = [
    {
        header: 'Who is Matt',
        text: `Matt is a senior software developer.

        Matt has ${new Date(Date.now() - new Date(2011, 6, 1).getTime()).getFullYear() - 1970} years of software programming experience.

        Matt has extensive knowledge of backend systems and working with cloud architecture.`
    },
    {
        header: 'What has Matt done',
        text: `Matt is currently working on many side projects.

        Matt likes to experiment with different frameworks to gain a better understanding of the current tools in the industry.
        
        Matt is also currently working on this website! Updates and additional features may be in store in the future.`
    },
    {
        header: 'Where can Matt be found',
        text: `Currently Matt can be found on <a href="https://github.com/matthewswar">GitHub</a> and <a href="https://www.linkedin.com/in/matthew-swartzendruber-5a982175/">LinkedIn</a>.`
    }
];

});

parcelRegister("bgTZZ", function(module, exports) {
module.exports = import.meta.resolve("l5lQ5");

});


parcelRegister("cPp6y", function(module, exports) {

$parcel$export(module.exports, "render", () => $956db8bed2382e5a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $956db8bed2382e5a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_img = (0, $TusQn.resolveComponent)("v-img");
    const _component_DescriptionSection = (0, $TusQn.resolveComponent)("DescriptionSection");
    const _component_v_col = (0, $TusQn.resolveComponent)("v-col");
    const _component_v_row = (0, $TusQn.resolveComponent)("v-row");
    const _component_v_container = (0, $TusQn.resolveComponent)("v-container");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_container, null, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_v_row, null, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_v_col, null, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_v_img, {
                                            id: "mugshot",
                                            src: $data.imagePath,
                                            "aspect-ratio": 2000 / 2997
                                        }, null, 8, [
                                            "src"
                                        ]),
                                        (0, $TusQn.createVNode)(_component_DescriptionSection, {
                                            id: "descriptions",
                                            items: $data.descriptionItems
                                        }, null, 8, [
                                            "items"
                                        ])
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                })
            ]),
        _: 1
    });
}

});

parcelRegister("1fW17", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea432232390f9d3$export$2e2bcd8739ae039);
let $0ea432232390f9d3$var$NOOP = ()=>{};
var $0ea432232390f9d3$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("eIvmH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ab6d8136b8b6faec$export$2e2bcd8739ae039);

var $aNBsW = parcelRequire("aNBsW");

var $iJwNG = parcelRequire("iJwNG");

var $l5Z8f = parcelRequire("l5Z8f");

var $8NwGS = parcelRequire("8NwGS");

var $85KJO = parcelRequire("85KJO");

var $LLcw9 = parcelRequire("LLcw9");
var $ab6d8136b8b6faec$export$2e2bcd8739ae039 = {
    name: 'Resume',
    components: {
        ProfessionalExperience: $iJwNG.default,
        Skills: $aNBsW.default
    },
    data () {
        return {
            showPasscodeDialog: false,
            passcodeValue: '',
            passcodeErrorMessage: '',
            tooltipWidth: '150px',
            skills: (0, $l5Z8f.default),
            experiences: (0, $8NwGS.default),
            education: (0, $85KJO.default)
        };
    },
    computed: {
        skillsLayout () {
            return {
                gutter: {
                    default: '15px',
                    [this.$vuetify.display.thresholds.xs]: '8px'
                },
                cols: {
                    default: 4,
                    [this.$vuetify.display.thresholds.lg]: 4,
                    [this.$vuetify.display.thresholds.md]: 3,
                    [this.$vuetify.display.thresholds.sm]: 2,
                    [this.$vuetify.display.thresholds.xs]: 1
                },
                columnClass: 'skillBox'
            };
        }
    },
    methods: {
        setPasscodeDialog (visible) {
            this.showPasscodeDialog = visible;
            this.passcodeValue = '';
            this.passcodeErrorMessage = '';
        },
        redirectToResume (withPasscode) {
            new Promise((resolve, reject)=>{
                let info = {
                    address: 'Please contact via LinkedIn for additional contact info.',
                    phoneNumber: '',
                    email: ''
                };
                if (!withPasscode) {
                    resolve(info);
                    return;
                }
                fetch(`${window.location.protocol}//${window.location.hostname}/contact`, {
                    headers: {
                        'x-pass-key': this.passcodeValue
                    }
                }).then((response)=>{
                    if (response.status == 200) {
                        response.json().then(resolve);
                        this.setPasscodeDialog(false);
                    } else reject(new Error(`Passphrase is invalid.`));
                }, ()=>reject(new Error('Something failed. Somehow let Matt know!')));
            }).then((info)=>{
                (0, $LLcw9.createPDF)((0, $l5Z8f.default), (0, $8NwGS.default), (0, $85KJO.default), info).then((pdfURL)=>{
                    const aTag = document.createElement('a');
                    document.body.appendChild(aTag);
                    aTag.href = pdfURL;
                    aTag.download = `matthew_swartzendruber_resume_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.pdf`;
                    aTag.click();
                    document.body.removeChild(aTag);
                });
            }, (err)=>{
                if (withPasscode) this.passcodeErrorMessage = err;
            });
        }
    }
};

});
parcelRegister("aNBsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dcb8ae35d1089ae$export$2e2bcd8739ae039);
let $7dcb8ae35d1089ae$var$script;




let $7dcb8ae35d1089ae$var$initialize = ()=>{
    $7dcb8ae35d1089ae$var$script = (parcelRequire("3yA7M"));
    if ($7dcb8ae35d1089ae$var$script.__esModule) $7dcb8ae35d1089ae$var$script = $7dcb8ae35d1089ae$var$script.default;
    $7dcb8ae35d1089ae$var$script.render = (parcelRequire("fhynw")).render;
    $7dcb8ae35d1089ae$var$script.__cssModules = {};
    (parcelRequire("gC0hW")).default($7dcb8ae35d1089ae$var$script);
    $7dcb8ae35d1089ae$var$script.__scopeId = 'data-v-49f2c3';
    $7dcb8ae35d1089ae$var$script.__file = "Skills.vue";
};
$7dcb8ae35d1089ae$var$initialize();
var $7dcb8ae35d1089ae$export$2e2bcd8739ae039 = $7dcb8ae35d1089ae$var$script;

});
parcelRegister("3yA7M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2970919f63a61f07$export$2e2bcd8739ae039);

var $cgcox = parcelRequire("cgcox");
var $2970919f63a61f07$export$2e2bcd8739ae039 = {
    name: 'Skills',
    components: {
        ExpandableBox: $cgcox.default
    },
    props: {
        layoutOptions: Object,
        skills: Array
    },
    data () {
        return {
            windowWidth: window.innerWidth
        };
    },
    computed: {
        displayColumns () {
            return Math.max(1, Number(this.breakpointValue(this.layoutOptions.cols, this.windowWidth)) || 1);
        },
        displayGutter () {
            return this.breakpointValue(this.layoutOptions.gutter, this.windowWidth);
        },
        gutterSizeWithUnit () {
            const gutter = String(this.displayGutter);
            return /^\d+(\.\d+)?$/.test(gutter) ? `${gutter}px` : gutter;
        },
        containerStyle () {
            return {
                display: 'flex',
                marginLeft: `-${this.gutterSizeWithUnit}`
            };
        },
        columnStyle () {
            return {
                boxSizing: 'border-box',
                backgroundClip: 'padding-box',
                width: `${100 / this.displayColumns}%`,
                border: '0 solid transparent',
                borderLeftWidth: this.gutterSizeWithUnit
            };
        },
        columns () {
            const cols = [];
            this.skills.forEach((skill, index)=>{
                const columnIndex = index % this.displayColumns;
                if (!cols[columnIndex]) cols[columnIndex] = [];
                cols[columnIndex].push(skill);
            });
            return cols;
        }
    },
    methods: {
        breakpointValue (mixed, windowWidth) {
            const valueAsNum = parseInt(String(mixed));
            if (valueAsNum > -1) return mixed;
            if (typeof mixed !== 'object') return 0;
            let matchedBreakpoint = Infinity;
            let matchedValue = mixed.default || 0;
            for(const key in mixed){
                const breakpoint = parseInt(key);
                const breakpointValRaw = mixed[breakpoint];
                const breakpointVal = parseInt(String(breakpointValRaw));
                if (isNaN(breakpoint) || isNaN(breakpointVal)) continue;
                if (windowWidth <= breakpoint && breakpoint < matchedBreakpoint) {
                    matchedBreakpoint = breakpoint;
                    matchedValue = breakpointValRaw;
                }
            }
            return matchedValue;
        },
        reCalculate () {
            this.windowWidth = window.innerWidth || Infinity;
        }
    },
    mounted () {
        this.reCalculate();
        window.addEventListener('resize', this.reCalculate);
    },
    beforeUnmount () {
        window.removeEventListener('resize', this.reCalculate);
    }
};

});
parcelRegister("cgcox", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed098032873ac57$export$2e2bcd8739ae039);
let $8ed098032873ac57$var$script;




let $8ed098032873ac57$var$initialize = ()=>{
    $8ed098032873ac57$var$script = (parcelRequire("fFY85"));
    if ($8ed098032873ac57$var$script.__esModule) $8ed098032873ac57$var$script = $8ed098032873ac57$var$script.default;
    $8ed098032873ac57$var$script.render = (parcelRequire("aBmDL")).render;
    $8ed098032873ac57$var$script.__cssModules = {};
    (parcelRequire("lL5iu")).default($8ed098032873ac57$var$script);
    $8ed098032873ac57$var$script.__scopeId = 'data-v-a77b14';
    $8ed098032873ac57$var$script.__file = "ExpandableBox.vue";
};
$8ed098032873ac57$var$initialize();
var $8ed098032873ac57$export$2e2bcd8739ae039 = $8ed098032873ac57$var$script;

});
parcelRegister("fFY85", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b69953cfe980306f$export$2e2bcd8739ae039);
var $b69953cfe980306f$export$2e2bcd8739ae039 = {
    name: 'ExpandableBox',
    props: {
        item: Object
    },
    data () {
        return {
            expanded: false
        };
    },
    methods: {
        toggle () {
            this.expanded = !this.expanded;
        }
    }
};

});

parcelRegister("aBmDL", function(module, exports) {

$parcel$export(module.exports, "render", () => $7b7eebf767ccbe1c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7b7eebf767ccbe1c$var$_hoisted_1 = {
    class: "text-headline-medium mt-0 mb-2"
};
const $7b7eebf767ccbe1c$var$_hoisted_2 = {
    class: "box-desc"
};
function $7b7eebf767ccbe1c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_expand_transition = (0, $TusQn.resolveComponent)("v-expand-transition");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: "box",
        onClick: _cache[0] || (_cache[0] = (...args)=>$options.toggle && $options.toggle(...args))
    }, [
        (0, $TusQn.createElementVNode)("h3", $7b7eebf767ccbe1c$var$_hoisted_1, (0, $8POXm.toDisplayString)($props.item.name), 1),
        (0, $TusQn.createVNode)(_component_v_expand_transition, null, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("p", null, [
                        (0, $TusQn.createElementVNode)("span", $7b7eebf767ccbe1c$var$_hoisted_2, (0, $8POXm.toDisplayString)($props.item.description), 1)
                    ], 512), [
                        [
                            (0, $eeJ70.vShow),
                            $data.expanded
                        ]
                    ])
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("lL5iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $04167c44cec6831b$export$2e2bcd8739ae039);
let $04167c44cec6831b$var$NOOP = ()=>{};
var $04167c44cec6831b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("fhynw", function(module, exports) {

$parcel$export(module.exports, "render", () => $b2031c5b7ca9fbeb$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $b2031c5b7ca9fbeb$var$_hoisted_1 = {
    id: "skills"
};
function $b2031c5b7ca9fbeb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ExpandableBox = (0, $TusQn.resolveComponent)("ExpandableBox");
    const _component_v_container = (0, $TusQn.resolveComponent)("v-container");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b2031c5b7ca9fbeb$var$_hoisted_1, [
        (0, $TusQn.createVNode)(_component_v_container, null, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("div", {
                        style: (0, $8POXm.normalizeStyle)($options.containerStyle)
                    }, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.columns, (column, columnIndex)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                key: columnIndex,
                                class: (0, $8POXm.normalizeClass)($props.layoutOptions.columnClass),
                                style: (0, $8POXm.normalizeStyle)($options.columnStyle)
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(column, (skill, skillIndex)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ExpandableBox, {
                                        key: skillIndex,
                                        item: skill
                                    }, null, 8, [
                                        "item"
                                    ]);
                                }), 128))
                            ], 6);
                        }), 128))
                    ], 4)
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("gC0hW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1806b34557b8e58$export$2e2bcd8739ae039);
let $c1806b34557b8e58$var$NOOP = ()=>{};
var $c1806b34557b8e58$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iJwNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $da35df71e743348c$export$2e2bcd8739ae039);
let $da35df71e743348c$var$script;




let $da35df71e743348c$var$initialize = ()=>{
    $da35df71e743348c$var$script = (parcelRequire("1AiGg"));
    if ($da35df71e743348c$var$script.__esModule) $da35df71e743348c$var$script = $da35df71e743348c$var$script.default;
    $da35df71e743348c$var$script.render = (parcelRequire("cUEsk")).render;
    $da35df71e743348c$var$script.__cssModules = {};
    (parcelRequire("f2xkK")).default($da35df71e743348c$var$script);
    $da35df71e743348c$var$script.__scopeId = 'data-v-3ce765';
    $da35df71e743348c$var$script.__file = "ProfessionalExperience.vue";
};
$da35df71e743348c$var$initialize();
var $da35df71e743348c$export$2e2bcd8739ae039 = $da35df71e743348c$var$script;

});
parcelRegister("1AiGg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1277a4d96d1c77ab$export$2e2bcd8739ae039);
var $1277a4d96d1c77ab$export$2e2bcd8739ae039 = {
    name: 'ProfessionalExperience',
    props: {
        experiences: Array
    },
    data () {
        return {};
    }
};

});

parcelRegister("cUEsk", function(module, exports) {

$parcel$export(module.exports, "render", () => $966a18b75973de75$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $966a18b75973de75$var$_hoisted_1 = {
    class: "text-left font-weight-bold text-title-large"
};
const $966a18b75973de75$var$_hoisted_2 = {
    class: "text-center"
};
const $966a18b75973de75$var$_hoisted_3 = {
    class: "text-right"
};
const $966a18b75973de75$var$_hoisted_4 = {
    class: "text-left"
};
const $966a18b75973de75$var$_hoisted_5 = {
    class: "text-left font-italic"
};
const $966a18b75973de75$var$_hoisted_6 = {
    class: "text-right font-italic"
};
const $966a18b75973de75$var$_hoisted_7 = {
    class: "text-left"
};
function $966a18b75973de75$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_col = (0, $TusQn.resolveComponent)("v-col");
    const _component_v_row = (0, $TusQn.resolveComponent)("v-row");
    const _component_v_container = (0, $TusQn.resolveComponent)("v-container");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_container, null, {
        default: (0, $TusQn.withCtx)(()=>[
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.experiences, (experience)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_container, null, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_v_row, {
                                    class: "experienceHeader",
                                    "no-gutters": ""
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createVNode)(_component_v_col, null, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createElementVNode)("h5", $966a18b75973de75$var$_hoisted_1, (0, $8POXm.toDisplayString)(experience.companyName), 1)
                                                    ]),
                                                _: 2
                                            }, 1024),
                                            (0, $TusQn.createVNode)(_component_v_col, {
                                                md: "auto"
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createElementVNode)("p", $966a18b75973de75$var$_hoisted_2, (0, $8POXm.toDisplayString)(experience.location), 1)
                                                    ]),
                                                _: 2
                                            }, 1024),
                                            (0, $TusQn.createVNode)(_component_v_col, null, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createElementVNode)("p", $966a18b75973de75$var$_hoisted_3, (0, $8POXm.toDisplayString)(experience.employmentDate), 1)
                                                    ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                    _: 2
                                }, 1024),
                                (0, $TusQn.createVNode)(_component_v_row, null, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createVNode)(_component_v_col, null, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createElementVNode)("p", $966a18b75973de75$var$_hoisted_4, (0, $8POXm.toDisplayString)(experience.description), 1)
                                                    ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                    _: 2
                                }, 1024),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(experience.employmentTitles, (title)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_row, null, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createVNode)(_component_v_container, null, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createVNode)(_component_v_row, null, {
                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                        (0, $TusQn.createVNode)(_component_v_col, null, {
                                                                            default: (0, $TusQn.withCtx)(()=>[
                                                                                    (0, $TusQn.createElementVNode)("p", $966a18b75973de75$var$_hoisted_5, (0, $8POXm.toDisplayString)(title.title), 1)
                                                                                ]),
                                                                            _: 2
                                                                        }, 1024),
                                                                        (0, $TusQn.createVNode)(_component_v_col, null, {
                                                                            default: (0, $TusQn.withCtx)(()=>[
                                                                                    (0, $TusQn.createElementVNode)("p", $966a18b75973de75$var$_hoisted_6, (0, $8POXm.toDisplayString)(title.titleDate), 1)
                                                                                ]),
                                                                            _: 2
                                                                        }, 1024)
                                                                    ]),
                                                                _: 2
                                                            }, 1024),
                                                            (0, $TusQn.createVNode)(_component_v_row, null, {
                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                        (0, $TusQn.createVNode)(_component_v_col, null, {
                                                                            default: (0, $TusQn.withCtx)(()=>[
                                                                                    (0, $TusQn.createElementVNode)("ul", null, [
                                                                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(title.summaryPoints, (point)=>{
                                                                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $966a18b75973de75$var$_hoisted_7, (0, $8POXm.toDisplayString)(point), 1);
                                                                                        }), 256))
                                                                                    ])
                                                                                ]),
                                                                            _: 2
                                                                        }, 1024)
                                                                    ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                        _: 2
                                    }, 1024);
                                }), 256))
                            ]),
                        _: 2
                    }, 1024);
                }), 256))
            ]),
        _: 1
    });
}

});

parcelRegister("f2xkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $af30e649ca09a71c$export$2e2bcd8739ae039);
let $af30e649ca09a71c$var$NOOP = ()=>{};
var $af30e649ca09a71c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("l5Z8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b97c2a799aa8bf$export$2e2bcd8739ae039);
var $f5b97c2a799aa8bf$export$103a0e2a426ae314;
(function(SkillType) {
    SkillType["Languages"] = "Languages";
    SkillType["ToolsAndTechnologies"] = "Tools and Technologies";
    SkillType["Concepts"] = "Concepts";
})($f5b97c2a799aa8bf$export$103a0e2a426ae314 || ($f5b97c2a799aa8bf$export$103a0e2a426ae314 = {}));
const $f5b97c2a799aa8bf$var$data = [
    {
        name: 'Kubernetes',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "I was tasked with standing up one of the first Kubernetes clusters at iStreamPlanet \u2014 before EKS existed, building it from scratch with kops. Learning the system's architecture from the ground up is why I'm comfortable developing services against its full feature set."
    },
    {
        name: 'Docker and Containers',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "Containers have been the default way I build and ship software since 2016 \u2014 writing and maintaining Docker images for everything from Python microservices on Kubernetes to Go services I migrated from AWS Lambda onto ECS."
    },
    {
        name: 'Metric Collection',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "I co-wrote an early metrics library that shipped fixed-size payloads to an InfluxDB server that also hosted Grafana for visualization. We later replaced it with a Datadog StatsD integration \u2014 a staple of my monitoring and alerting at most positions since."
    },
    {
        name: 'Kafka',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "Kafka served as the message bus for a suite of services that aggregate and schedule event-driven data. Every microservice communicated asynchronously through Kafka, so an outage in any one service didn't stall the pipeline \u2014 work simply resumed where it left off."
    },
    {
        name: 'Uber Cadence',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "Cadence was one of my first experiences with a workflow engine outside a managed service. It changed how I design long-running processes and drilled into the importance of writing idempotent steps \u2014 experience that carries straight over to its successor, Temporal, a direct fork with the same workflow model."
    },
    {
        name: 'Apache Airflow',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: 'We used Airflow for operational tasks such as rolling kernel upgrades across our on-premises fleet. By breaking work into small, re-entrant steps that resume where they left off, we avoided many potential incidents.'
    },
    {
        name: 'Asynchronous Architecture',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "I've built asynchronous designs around SQS, Kafka, and other queues: microservices listen for commands to execute, so producers can enqueue work even while a consumer is down, and it runs once the service recovers. Routing internal tooling through the same message bus made the pattern a default in my service design."
    },
    {
        name: 'Amazon Web Services',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "I've worked extensively with AWS since 2016, proficient across EC2, VPC networking, and Lambda, and comfortable incorporating SNS topics and SQS queues into service designs."
    },
    {
        name: 'Google Cloud Platform',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "Not as extensive as my AWS experience, but I've worked with GCP-specific technologies in past architectures \u2014 automating Datadog integration with Pub/Sub, replicating S3 buckets to Cloud Storage, and configuring Cloud CDN."
    },
    {
        name: 'PostgreSQL',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "PostgreSQL is my database of choice. Most recently I've used it for standard relational work, but I've also leaned hard on JSONB for rapidly evolving data: anything query-essential gets promoted to its own column, while the rest stays flexible in the document."
    },
    {
        name: 'CI/CD',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "I've set up, configured, and maintained pipelines across GitHub Actions, TeamCity, Jenkins, CodeFresh, and CircleCI \u2014 including integrations with AWS CodeDeploy, Kubernetes, and AWS Fargate."
    },
    {
        name: 'Linux Stack',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "My development has been Linux-based from 2016 to the present, with most services I've written optimized for containerized environments."
    },
    {
        name: 'Microsoft Stack',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "From 2011 to 2016, my development was heavily Microsoft-stack. I spent a lot of time diagnosing the errors our all-Microsoft CI/CD toolchain, built around Visual Studio, produced, and at my first job I owned the PowerShell setup script \u2014 checking dependencies, deploying the software, configuring IIS and SQL Server, and handling upgrades from prior versions."
    },
    {
        name: 'REST Web Services',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "I've built many web services to a proper RESTful standard \u2014 resource-oriented design, appropriate status codes, and OpenAPI documentation."
    },
    {
        name: 'Multi-Region Services',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "I've helped design and implement services spanning multiple regions \u2014 data replication, request routing across domains and zones, and region-specific resource allocation."
    },
    {
        name: 'Infrastructure as Code',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Concepts,
        description: "I use Pulumi to automate all the infrastructure for this website \u2014 and the same tooling to spin up and tear down personal services on demand, including Jitsi, virtual tabletops, and various game servers."
    },
    {
        name: 'C#',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Languages,
        description: "I added features to and maintained an Excel add-in with heavy COM interop \u2014 including the timeless fun of figuring out when a VBA array is zero- or one-based. I later took over our setup script, tracking issues from mismatched DLLs down to the root cause with a disassembler."
    },
    {
        name: 'Java',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Languages,
        description: "I've used Java extensively for web services. On the DRM team at iStreamPlanet, our services were built for high throughput \u2014 sustaining hundreds of requests per second."
    },
    {
        name: 'Python',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Languages,
        description: 'I built a suite of five Python microservices that communicated over queues, with pyenv and Pipenv managing the environments in Docker containers deployed on Kubernetes.'
    },
    {
        name: 'Go',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Languages,
        description: "I've used Go heavily since 2017 and am typically the go-to person on my teams for the language's finer details. I've built everything from web services to long-running data-processing pipelines."
    },
    {
        name: 'TypeScript',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.Languages,
        description: "My main TypeScript experience is in AWS serverless architecture \u2014 chaining Lambdas together and orchestrating workflows with Step Functions \u2014 and in building and maintaining this site, which is TypeScript and Vue."
    },
    {
        name: 'AI Tooling',
        type: $f5b97c2a799aa8bf$export$103a0e2a426ae314.ToolsAndTechnologies,
        description: "I've worked AI tooling into my day-to-day development. At Tanium I leveraged Claude Code for code verification and a variety of development workflows \u2014 using it to accelerate the work without outsourcing the engineering judgment."
    }
];
var $f5b97c2a799aa8bf$export$2e2bcd8739ae039 = $f5b97c2a799aa8bf$var$data;

});

parcelRegister("8NwGS", function(module, exports) {

$parcel$export(module.exports, "default", () => $667c41f9eeaf10bc$export$2e2bcd8739ae039);
const $667c41f9eeaf10bc$var$data = [
    {
        companyName: 'Tanium',
        location: 'Bellevue, WA',
        employmentDate: 'April 2023 - September 2026',
        description: 'Tanium empowers users to query complete and accurate data about their workstations, servers, and other endpoints at scale in real time. As a senior software engineer, my responsibilities included the maintenance, feature work, and refinement of backend services across the Tanium ecosystem.',
        employmentTitles: [
            {
                title: 'Senior Software Engineer',
                titleDate: 'April 2023 - September 2026',
                summaryPoints: [
                    'Architected and implemented backend services for the external attack surface management module from concept to production, collaborating with the graph database team to integrate data sources.',
                    'Designed extensible report generation framework supporting multiple report types and risk assessment exports, working with Security to ensure metrics met compliance requirements.',
                    'Designed industry designation resolution for Benchmark with graceful fallback from customer configuration, through Tanium-managed settings, to the license, plus a Postgres-backed change log with cache invalidation to trigger reprocessing of peer-benchmark metrics on change.',
                    'Designed and implemented a generic, durable asynchronous job processing pipeline to support Tanium Risk Assessment report generation against a large custom data store.',
                    'Developed test harness for Comply API routes, reducing code duplication and test complexity through a configurable data-driven approach.',
                    'As the recognized Go expert for the Benchmark and External Attack Surface teams, conducted backend code reviews that taught idiomatic Go and codebase structure, caught potential bugs, and simplified implementations into more composable, generic designs.'
                ]
            }
        ]
    },
    {
        companyName: 'Twitter',
        location: 'Seattle, WA',
        employmentDate: 'February 2021 - November 2022',
        description: "I worked as a Senior Site Reliability Engineer on Twitter's messaging team. We use Kafka as a backbone for internal communication and processing between internal services. My responsibilities include developing automation to facilitate fleet safety and scalable infrastructure.",
        employmentTitles: [
            {
                title: 'Senior Site Reliability Engineer',
                titleDate: 'February 2021 - November 2022',
                summaryPoints: [
                    'Co-designed and developed a fleet safety service called the Constraint Manager which checks the health and various constraints against on-premises machines and their clusters before beginning maintenance operations.',
                    'Automated the detection and remediation of hosts with various hardware failures within Kafka clusters.',
                    'Wrote internal Apache Airflow DAGs to perform kernel upgrades of on-premises machines and roll the deployment of encryption at rest across the fleet.',
                    'Co-designed and developed the Network Alert Console in a cross team effort which is responsible for identifying and correlating alarms, incident creation, and auto-mitigation of various network device failures.',
                    'Investigated the design for and assisted in the deployment of running Kafka at a large scale on Kubernetes in the Twitter data centers.'
                ]
            }
        ]
    },
    {
        companyName: 'Discovery',
        location: 'Bellevue, WA',
        employmentDate: 'September 2019 - January 2021',
        description: "I worked as a Senior Software Development Engineer at Discovery's Bellevue office. I have worked on various systems involving ingesting different video sources and metadata that is propagated to various regions around the world. The last team I was on was the transcoding team that converts raw video files into different packaging formats such as HLS and DASH.",
        employmentTitles: [
            {
                title: 'Senior Software Development Engineer',
                titleDate: 'September 2019 - January 2021',
                summaryPoints: [
                    'Worked on the implementation of our transcoding workflow using the Uber Cadence workflow engine.',
                    'Frequently mentored coworkers on the Go language and the best practices.',
                    'Assisted in the design and implementation of various serverless components such as AWS Lambdas to validate, store, and replicate video metadata.'
                ]
            }
        ]
    },
    {
        companyName: 'iStreamPlanet',
        location: 'Seattle, WA',
        employmentDate: 'January 2016 - September 2019',
        description: "iStreamPlanet offers the backend streaming solution that has been used for well-known live events such as the Olympics, BlizzCon, and March Madness. I have been involved with many teams of talented individuals usually centered around the company's flagship product and transcoding pipeline, Aventus. In addition, I was involved in the overall design and implementation of Orbis, a direct-to-consumer platform for user, billing, and content management from the initial concept to its full release.",
        employmentTitles: [
            {
                title: 'Senior Software Engineer',
                titleDate: 'January 2016 - September 2019',
                summaryPoints: [
                    'Automated NBA schedule aggregation, storage, and Aventus channel management by integrating various cloud services such as AWS RDS and Kafka.',
                    'Security focused development to stay within PCI and PII compliance for our commerce and user management platform.',
                    'One of the key players in the design, architecture, and implementation of the Orbis platform from initial concept to release.',
                    'Spearheaded the implementation for Microsoft PlayReady into the Atlas DRM product.',
                    'Increased the overall transactions per second capability by the DRM service machines by offloading the responsibilities of processing logs to a separate instance with a custom solution written in Go.',
                    'Responsible for increasing the rate of detection and reaction of problematic ingest and output streams allowing for faster response times.'
                ]
            }
        ]
    },
    {
        companyName: 'Predixion Software',
        location: 'Redmond, WA',
        employmentDate: 'June 2011 - November 2015',
        description: 'Predixion was a small startup company where I worked with a highly intelligent and motivated team developing the latest in predictive analytics technology. Our product empowered even the most novice of users to see the full benefits of their data. Joining in the summer of 2011 as an intern focusing on quality assurance, I continued with the company after my internship to become a Software Development Engineer in Test. Later I switched my focus towards development and changed my title to Software Development Engineer after making a suite of tools and features. In both roles my responsibilities included working on the Predixion Insight Server and the Predixion Solutions Accelerator.',
        employmentTitles: [
            {
                title: 'Software Development Engineer',
                titleDate: 'June 2014 - November 2015',
                summaryPoints: [
                    'Expanded Predixion Insight application by adding features to the proprietary Excel-like Predictive Analytic Expression language.',
                    'Took over feature development on Predixion Insight setup projects, using various technologies such as PowerShell, Visual Studio Deployment, and Inno Setup.',
                    'Maintained the Predixion Insight custom SQL Server Integration Services (SSIS) components, empowering users to benefit from predictive queries and transformations in the SSIS environment.',
                    'Created Windows Presentation Foundation and Windows Forms controls for modeling and data extraction wizards.'
                ]
            },
            {
                title: 'Software Development Engineer in Test',
                titleDate: 'June 2013 - June 2014',
                summaryPoints: [
                    'Developed a command line tool for the Predixion Solutions Accelerator application, a product that allows users to rapidly prototype a predictive solution for their data. The tool itself eased the process in setting up the database and refreshing the data without having the user interact with stored procedures, SQL statements, or scripts themselves.',
                    'Created the framework and process for testing the existing Predixion Insight REST API endpoints.',
                    'Created a configurable web application to report the overall status and test automation of the project.'
                ]
            },
            {
                title: 'Software Development Test Intern',
                titleDate: 'June 2011 - June 2013',
                summaryPoints: [
                    'Created a PowerShell script to automatically connect, install, and snapshot different base states of Hyper-V Virtual Machines using built-in Windows Management Instrumentation.',
                    'Worked in collaboration with others to create an automated testing framework and maintained various tools to assist in the software development lifecycle.'
                ]
            }
        ]
    }
];
var $667c41f9eeaf10bc$export$2e2bcd8739ae039 = $667c41f9eeaf10bc$var$data;

});

parcelRegister("85KJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e430b8cf361606f$export$2e2bcd8739ae039);
const $5e430b8cf361606f$var$data = [
    {
        establishmentName: 'University of Washington',
        location: 'Tacoma, WA',
        attendedDate: 'September 2010 - June 2013',
        accomplishment: 'Bachelor of Science in Computer Science and Systems'
    }
];
var $5e430b8cf361606f$export$2e2bcd8739ae039 = $5e430b8cf361606f$var$data;

});

parcelRegister("LLcw9", function(module, exports) {

$parcel$export(module.exports, "createPDF", () => $08f9010409c657f2$export$4b3f79ddda86d10c);

var $g5MIj = parcelRequire("g5MIj");

var $5C4Fs = parcelRequire("5C4Fs");

var $eTEAQ = parcelRequire("eTEAQ");
var $08f9010409c657f2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $08f9010409c657f2$var$sectionOffsetY = 10;
const $08f9010409c657f2$var$experienceIndent = 5;
const $08f9010409c657f2$var$marginLength = 36;
const $08f9010409c657f2$var$footerMargin = 10;
const $08f9010409c657f2$var$fonts = {
    nameTitle: {
        name: 'NameTitle',
        size: 20
    },
    main: {
        name: 'Main',
        size: 12
    },
    mainBold: {
        name: 'MainBold',
        size: 12
    },
    mainItalic: {
        name: 'MainItalic',
        size: 12
    },
    section: {
        name: 'Section',
        size: 14
    },
    footer: {
        name: 'MainItalic',
        size: 8
    }
};
const $08f9010409c657f2$var$colors = {
    sectionBreaks: '#000000',
    employmentBreaks: '#000000'
};
class $08f9010409c657f2$var$ResumeCreator {
    constructor(doc){
        this._doc = doc;
        this._currentFontName = '';
        this._currentFontSize = 0;
        this._previousFontName = '';
        this._previousFontSize = 0;
        this._nextSectionStartY = 0;
    }
    writeContent(skills, employment, education, info) {
        this._doc.on('pageAdded', ()=>{
            this._doc.page.margins = {
                top: $08f9010409c657f2$var$marginLength,
                bottom: $08f9010409c657f2$var$marginLength,
                left: $08f9010409c657f2$var$marginLength,
                right: $08f9010409c657f2$var$marginLength
            };
        });
        this._doc.addPage({
            margin: $08f9010409c657f2$var$marginLength
        });
        this.setFont($08f9010409c657f2$var$fonts.main.name, $08f9010409c657f2$var$fonts.main.size);
        this.writeHeader(info);
        this.writeSkills(skills);
        this.writeEmployment(employment);
        this.writeEducation(education);
        this.writeFooter();
    }
    writeFooter() {
        const range = this._doc.bufferedPageRange();
        for(let i = 0; i < range.count; i++){
            this._doc.switchToPage(i);
            this._doc.page.margins.bottom = 0;
            this._doc.page.margins.right = $08f9010409c657f2$var$footerMargin;
            this.setFont($08f9010409c657f2$var$fonts.footer.name, $08f9010409c657f2$var$fonts.footer.size);
            const originalPosition = {
                x: this._doc.x,
                y: this._doc.y
            };
            const footerMessage = `Generated from ${window.location.protocol}//${window.location.hostname}/#/resume`;
            const footerDimensions = {
                w: this._doc.widthOfString(footerMessage),
                h: this._doc.heightOfString(footerMessage)
            };
            this._doc.text(footerMessage, originalPosition.x, this._doc.page.height - footerDimensions.h - $08f9010409c657f2$var$footerMargin, {
                align: 'right'
            });
            this._doc.text('', originalPosition.x, originalPosition.y);
            this.setFont(this._previousFontName || $08f9010409c657f2$var$fonts.main.name, this._previousFontSize || $08f9010409c657f2$var$fonts.main.size);
            this._doc.page.margins.bottom = $08f9010409c657f2$var$marginLength;
            this._doc.page.margins.right = $08f9010409c657f2$var$marginLength;
        }
    }
    writeHeader(info) {
        const myName = 'Matthew Swartzendruber';
        this.setFont($08f9010409c657f2$var$fonts.nameTitle.name, $08f9010409c657f2$var$fonts.nameTitle.size);
        this._doc.text(myName);
        const nameDimensions = {
            width: this._doc.widthOfString(myName),
            height: this._doc.heightOfString(myName)
        };
        const myTitle = 'Senior Software Engineer';
        this.setFont($08f9010409c657f2$var$fonts.mainItalic.name, $08f9010409c657f2$var$fonts.mainItalic.size);
        this._doc.text(myTitle, {
            align: 'right',
            width: nameDimensions.width
        });
        const titleDimensions = {
            width: this._doc.widthOfString(myTitle),
            height: this._doc.heightOfString(myTitle)
        };
        const lineOffset = 10;
        const startX = nameDimensions.width + this._doc.page.margins.left + lineOffset;
        const startY = this._doc.page.margins.top;
        const lineEndY = startY + nameDimensions.height + titleDimensions.height;
        this._doc.moveTo(startX, startY).lineTo(startX, lineEndY).stroke();
        this._nextSectionStartY = lineEndY + $08f9010409c657f2$var$sectionOffsetY;
        this.setFont($08f9010409c657f2$var$fonts.main.name, $08f9010409c657f2$var$fonts.main.size);
        const contactInfoStartX = startX + lineOffset;
        const contactInfoHeight = this._doc.heightOfString(info.address);
        const contactInfoStartY = this._doc.page.margins.top + nameDimensions.height / 4;
        const headerWidth = this._doc.page.width - nameDimensions.width - lineOffset * 2 - this._doc.page.margins.right - this._doc.page.margins.left;
        this._doc.text(info.address, contactInfoStartX, contactInfoStartY, {
            width: headerWidth,
            align: 'justify'
        });
        this._doc.text(info.phoneNumber, contactInfoStartX, contactInfoStartY + contactInfoHeight, {
            width: headerWidth,
            align: 'left'
        });
        this._doc.text(info.email, contactInfoStartX, contactInfoStartY + contactInfoHeight, {
            width: headerWidth - 10,
            align: 'right'
        });
    }
    writeSectionName(text) {
        const paddingOffset = 5 + $08f9010409c657f2$var$fonts.section.size * 0.1;
        this._doc.moveTo(this._doc.x, this._doc.y - paddingOffset).lineTo(this._doc.page.width - this._doc.page.margins.right, this._doc.y - paddingOffset).strokeColor($08f9010409c657f2$var$colors.sectionBreaks).lineWidth(2).stroke();
        this.setFont($08f9010409c657f2$var$fonts.section.name, $08f9010409c657f2$var$fonts.section.size);
        this._doc.text(` ${text}`);
        this._doc.moveTo(this._doc.x, this._doc.y).lineTo(this._doc.page.width - this._doc.page.margins.right, this._doc.y).strokeColor($08f9010409c657f2$var$colors.sectionBreaks).lineWidth(2).stroke();
        this.setFont(this._previousFontName, this._previousFontSize);
        this._doc.moveDown(1);
    }
    writeSkills(skills) {
        this._doc.text('', this._doc.page.margins.left, this._nextSectionStartY);
        this.writeSectionName('Summary of Skills');
        const skillSections = skills.reduce((sections, skill)=>{
            if (!skill.type) return sections;
            if (!sections[skill.type]) sections[skill.type] = [];
            sections[skill.type].push(skill);
            return sections;
        }, {});
        Object.entries(skillSections).forEach(([section, skills])=>{
            this.setFont($08f9010409c657f2$var$fonts.mainBold.name, $08f9010409c657f2$var$fonts.mainBold.size);
            this._doc.text(`${section}: `, {
                continued: true
            });
            this.setFont($08f9010409c657f2$var$fonts.main.name, $08f9010409c657f2$var$fonts.main.size);
            skills.forEach((skill, index)=>{
                const lastEntry = index == skills.length - 1;
                let output = `${skill.name}, `;
                if (lastEntry) output = output.slice(0, -2);
                this._doc.text(output, {
                    continued: !lastEntry,
                    lineGap: 5
                });
            });
            this._nextSectionStartY = this._doc.y + $08f9010409c657f2$var$sectionOffsetY;
        });
    }
    writeEmployment(employments) {
        this._doc.text('', this._doc.page.margins.left, this._nextSectionStartY);
        this.writeSectionName('Professional Experience');
        const startX = this._doc.x;
        employments.forEach((employment)=>{
            this.setFont($08f9010409c657f2$var$fonts.mainBold.name, $08f9010409c657f2$var$fonts.mainBold.size);
            this._doc.text(employment.companyName, startX, this._doc.y, {
                continued: true,
                align: 'left'
            });
            this.setFont($08f9010409c657f2$var$fonts.main.name, $08f9010409c657f2$var$fonts.main.size);
            this._doc.text(employment.location, {
                continued: true,
                align: 'center'
            });
            this._doc.text(employment.employmentDate, {
                continued: false,
                align: 'right'
            });
            this._doc.moveTo(this._doc.x, this._doc.y).lineTo(this._doc.page.width - this._doc.page.margins.right, this._doc.y).strokeColor($08f9010409c657f2$var$colors.employmentBreaks).lineWidth(1).stroke();
            this._doc.moveDown(0.5);
            this._doc.text(employment.description, this._doc.x + $08f9010409c657f2$var$experienceIndent, this._doc.y, {
                align: 'justify',
                width: this._doc.page.width - this._doc.page.margins.left - this._doc.page.margins.right - $08f9010409c657f2$var$experienceIndent * 2
            });
            this._doc.moveDown(0.5);
            const titleStartX = this._doc.x;
            employment.employmentTitles.forEach((title)=>{
                this.setFont($08f9010409c657f2$var$fonts.mainItalic.name, $08f9010409c657f2$var$fonts.mainItalic.size);
                this._doc.moveDown(0.5);
                this._doc.text(title.title, titleStartX + $08f9010409c657f2$var$experienceIndent * 2, this._doc.y, {
                    align: 'left',
                    continued: true,
                    width: this._doc.page.width - this._doc.page.margins.left - this._doc.page.margins.right - $08f9010409c657f2$var$experienceIndent * 4
                });
                this._doc.text(title.titleDate, {
                    align: 'right',
                    continued: false
                });
                this.setFont($08f9010409c657f2$var$fonts.main.name, $08f9010409c657f2$var$fonts.main.size);
                this._doc.moveDown(1);
                this._doc.list(title.summaryPoints, {
                    lineGap: 2,
                    width: this._doc.page.width - this._doc.page.margins.left - this._doc.page.margins.right - $08f9010409c657f2$var$experienceIndent * 4
                });
                this._doc.moveDown(0.5);
            });
            this._doc.moveDown(1);
        });
        this._nextSectionStartY = this._doc.y + $08f9010409c657f2$var$sectionOffsetY;
    }
    writeEducation(education) {
        this._doc.text('', this._doc.page.margins.left, this._nextSectionStartY);
        this.writeSectionName('Education');
        const startX = this._doc.x;
        education.forEach((item)=>{
            this.setFont($08f9010409c657f2$var$fonts.mainBold.name, $08f9010409c657f2$var$fonts.mainBold.size);
            this._doc.text(item.establishmentName, startX, this._doc.y, {
                continued: true,
                align: 'left'
            });
            this.setFont($08f9010409c657f2$var$fonts.main.name, $08f9010409c657f2$var$fonts.main.size);
            this._doc.text(item.location, {
                continued: true,
                align: 'center'
            });
            this._doc.text(item.attendedDate, {
                continued: false,
                align: 'right'
            });
            this._doc.moveTo(this._doc.x, this._doc.y).lineTo(this._doc.page.width - this._doc.page.margins.right, this._doc.y).strokeColor($08f9010409c657f2$var$colors.employmentBreaks).lineWidth(1).stroke();
            this._doc.moveDown(0.5);
            this._doc.text(item.accomplishment, this._doc.x + $08f9010409c657f2$var$experienceIndent, this._doc.y, {
                align: 'justify',
                width: this._doc.page.width - this._doc.page.margins.left - this._doc.page.margins.right - $08f9010409c657f2$var$experienceIndent * 2
            });
            this._doc.moveDown(1);
        });
    }
    setFont(fontName, fontSize) {
        this._previousFontName = this._currentFontName;
        this._previousFontSize = this._currentFontSize;
        this._doc.font(fontName).fontSize(fontSize);
        this._currentFontName = fontName;
        this._currentFontSize = fontSize;
    }
}
const $08f9010409c657f2$var$registerFonts = (doc)=>$08f9010409c657f2$var$__awaiter(void 0, void 0, void 0, function*() {
        const getBlob = (fontPath)=>$08f9010409c657f2$var$__awaiter(void 0, void 0, void 0, function*() {
                return yield (yield fetch(fontPath)).arrayBuffer();
            });
        doc.registerFont($08f9010409c657f2$var$fonts.nameTitle.name, (yield getBlob((0, (/*@__PURE__*/$parcel$interopDefault($eTEAQ))))));
        doc.registerFont($08f9010409c657f2$var$fonts.main.name, 'Times-Roman');
        doc.registerFont($08f9010409c657f2$var$fonts.mainBold.name, 'Times-Bold');
        doc.registerFont($08f9010409c657f2$var$fonts.mainItalic.name, 'Times-Italic');
        doc.registerFont($08f9010409c657f2$var$fonts.section.name, 'Times-BoldItalic');
    });
const $08f9010409c657f2$export$4b3f79ddda86d10c = (skills, employment, education, contactInfo)=>$08f9010409c657f2$var$__awaiter(void 0, void 0, void 0, function*() {
        const doc = new (0, $g5MIj.default)({
            autoFirstPage: false,
            bufferPages: true
        });
        const pdfStream = doc.pipe((0, (/*@__PURE__*/$parcel$interopDefault($5C4Fs)))());
        yield $08f9010409c657f2$var$registerFonts(doc);
        const creator = new $08f9010409c657f2$var$ResumeCreator(doc);
        creator.writeContent(skills, employment, education, contactInfo);
        doc.end();
        return yield new Promise((resolve)=>{
            pdfStream.on('finish', ()=>{
                const url = pdfStream.toBlobURL('application/pdf');
                resolve(url);
            });
        });
    });

});
parcelRegister("g5MIj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb72e68028dbdf4a$export$2e2bcd8739ae039);

var $ioRHp = parcelRequire("ioRHp");

var $gxZpm = parcelRequire("gxZpm");

var $3Bcdj = parcelRequire("3Bcdj");

var $hqt0D = parcelRequire("hqt0D");

var $htQ8Z = parcelRequire("htQ8Z");

var $3RPiR = parcelRequire("3RPiR");

var $kjyEk = parcelRequire("kjyEk");

var $izQkD = parcelRequire("izQkD");

var $31QE8 = parcelRequire("31QE8");

var $ijE9O = parcelRequire("ijE9O");

var $6ZWSX = parcelRequire("6ZWSX");
var $bb72e68028dbdf4a$require$Buffer = $6ZWSX.Buffer;
var $bb72e68028dbdf4a$var$__dirname = "node_modules/pdfkit/js";
class $bb72e68028dbdf4a$var$PDFAbstractReference {
    toString() {
        throw new Error('Must be implemented by subclasses');
    }
}
class $bb72e68028dbdf4a$var$PDFTree {
    constructor(options = {}){
        this._items = {};
        this.limits = typeof options.limits === 'boolean' ? options.limits : true;
    }
    add(key, val) {
        return this._items[key] = val;
    }
    get(key) {
        return this._items[key];
    }
    toString() {
        const sortedKeys = Object.keys(this._items).sort((a, b)=>this._compareKeys(a, b));
        const out = [
            '<<'
        ];
        if (this.limits && sortedKeys.length > 1) {
            const first = sortedKeys[0], last = sortedKeys[sortedKeys.length - 1];
            out.push(`  /Limits ${$bb72e68028dbdf4a$var$PDFObject.convert([
                this._dataForKey(first),
                this._dataForKey(last)
            ])}`);
        }
        out.push(`  /${this._keysName()} [`);
        for (let key of sortedKeys)out.push(`    ${$bb72e68028dbdf4a$var$PDFObject.convert(this._dataForKey(key))} ${$bb72e68028dbdf4a$var$PDFObject.convert(this._items[key])}`);
        out.push(']');
        out.push('>>');
        return out.join('\n');
    }
    _compareKeys() {
        throw new Error('Must be implemented by subclasses');
    }
    _keysName() {
        throw new Error('Must be implemented by subclasses');
    }
    _dataForKey() {
        throw new Error('Must be implemented by subclasses');
    }
}
class $bb72e68028dbdf4a$var$SpotColor {
    constructor(doc, name, C, M, Y, K){
        this.id = 'CS' + Object.keys(doc.spotColors).length;
        this.name = name;
        this.values = [
            C,
            M,
            Y,
            K
        ];
        this.ref = doc.ref([
            'Separation',
            $bb72e68028dbdf4a$var$escapeName(this.name),
            'DeviceCMYK',
            {
                Range: [
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1
                ],
                C0: [
                    0,
                    0,
                    0,
                    0
                ],
                C1: this.values.map((value)=>value / 100),
                FunctionType: 2,
                Domain: [
                    0,
                    1
                ],
                N: 1
            }
        ]);
        this.ref.end();
    }
    toString() {
        return `${this.ref.id} 0 R`;
    }
}
const $bb72e68028dbdf4a$var$pad = (str, length)=>(Array(length + 1).join('0') + str).slice(-length);
const $bb72e68028dbdf4a$var$isSafeCharCode = (code)=>{
    if (code > 0x7f) return true;
    return code > 0x20 && code !== 0x7f && code !== 0x23 && code !== 0x25 && code !== 0x28 && code !== 0x29 && code !== 0x2f && code !== 0x3c && code !== 0x3e && code !== 0x5b && code !== 0x5d && code !== 0x7b && code !== 0x7d;
};
const $bb72e68028dbdf4a$var$escapableRe = /[\n\r\t\b\f()\\]/g;
const $bb72e68028dbdf4a$var$escapable = {
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t',
    '\b': '\\b',
    '\f': '\\f',
    '\\': '\\\\',
    '(': '\\(',
    ')': '\\)'
};
const $bb72e68028dbdf4a$var$escapeName = function(name) {
    let escapedName = '';
    for (const char of name){
        const code = char.charCodeAt(0);
        if ($bb72e68028dbdf4a$var$isSafeCharCode(code)) escapedName += char;
        else escapedName += `#${code.toString(16).toUpperCase().padStart(2, '0')}`;
    }
    return escapedName;
};
const $bb72e68028dbdf4a$var$swapBytes = function(buff) {
    const l = buff.length;
    if (l & 0x01) throw new Error('Buffer length must be even');
    else for(let i = 0, end = l - 1; i < end; i += 2){
        const a = buff[i];
        buff[i] = buff[i + 1];
        buff[i + 1] = a;
    }
    return buff;
};
class $bb72e68028dbdf4a$var$PDFObject {
    static convert(object, encryptFn = null) {
        if (typeof object === 'string') return `/${object}`;
        else if (object instanceof String) {
            let string = object;
            let isUnicode = false;
            for(let i = 0, end = string.length; i < end; i++)if (string.charCodeAt(i) > 0x7f) {
                isUnicode = true;
                break;
            }
            let stringBuffer;
            if (isUnicode) stringBuffer = $bb72e68028dbdf4a$var$swapBytes($bb72e68028dbdf4a$require$Buffer.from(`\ufeff${string}`, 'utf16le'));
            else stringBuffer = $bb72e68028dbdf4a$require$Buffer.from(string.valueOf(), 'ascii');
            if (encryptFn) string = encryptFn(stringBuffer).toString('binary');
            else string = stringBuffer.toString('binary');
            string = string.replace($bb72e68028dbdf4a$var$escapableRe, (c)=>$bb72e68028dbdf4a$var$escapable[c]);
            return `(${string})`;
        } else if ($bb72e68028dbdf4a$require$Buffer.isBuffer(object)) return `<${object.toString('hex')}>`;
        else if (object instanceof $bb72e68028dbdf4a$var$PDFAbstractReference || object instanceof $bb72e68028dbdf4a$var$PDFTree || object instanceof $bb72e68028dbdf4a$var$SpotColor) return object.toString();
        else if (object instanceof Date) {
            let string = `D:${$bb72e68028dbdf4a$var$pad(object.getUTCFullYear(), 4)}` + $bb72e68028dbdf4a$var$pad(object.getUTCMonth() + 1, 2) + $bb72e68028dbdf4a$var$pad(object.getUTCDate(), 2) + $bb72e68028dbdf4a$var$pad(object.getUTCHours(), 2) + $bb72e68028dbdf4a$var$pad(object.getUTCMinutes(), 2) + $bb72e68028dbdf4a$var$pad(object.getUTCSeconds(), 2) + 'Z';
            if (encryptFn) {
                string = encryptFn($bb72e68028dbdf4a$require$Buffer.from(string, 'ascii')).toString('binary');
                string = string.replace($bb72e68028dbdf4a$var$escapableRe, (c)=>$bb72e68028dbdf4a$var$escapable[c]);
            }
            return `(${string})`;
        } else if (Array.isArray(object)) {
            const items = object.map((e)=>$bb72e68028dbdf4a$var$PDFObject.convert(e, encryptFn)).join(' ');
            return `[${items}]`;
        } else if (({}).toString.call(object) === '[object Object]') {
            const out = [
                '<<'
            ];
            for(let key in object){
                const val = object[key];
                out.push(`/${key} ${$bb72e68028dbdf4a$var$PDFObject.convert(val, encryptFn)}`);
            }
            out.push('>>');
            return out.join('\n');
        } else if (typeof object === 'number') return $bb72e68028dbdf4a$var$PDFObject.number(object);
        else return `${object}`;
    }
    static number(n) {
        if (n > -1000000000000000000000 && n < 1e21) return Math.round(n * 1e6) / 1e6;
        throw new Error(`unsupported number: ${n}`);
    }
}
class $bb72e68028dbdf4a$var$PDFReference extends $bb72e68028dbdf4a$var$PDFAbstractReference {
    constructor(document, id, data = {}){
        super();
        this.document = document;
        this.id = id;
        this.data = data;
        this.gen = 0;
        this.compress = this.document.compress && !this.data.Filter;
        this.uncompressedLength = 0;
        this.buffer = [];
    }
    write(chunk) {
        if (!(chunk instanceof Uint8Array)) chunk = $bb72e68028dbdf4a$require$Buffer.from(chunk + '\n', 'binary');
        this.uncompressedLength += chunk.length;
        if (this.data.Length == null) this.data.Length = 0;
        this.buffer.push(chunk);
        this.data.Length += chunk.length;
        if (this.compress) this.data.Filter = 'FlateDecode';
    }
    end(chunk) {
        if (chunk) this.write(chunk);
        this.finalize();
    }
    finalize() {
        this.offset = this.document._offset;
        const encryptFn = this.document._security ? this.document._security.getEncryptFn(this.id, this.gen) : null;
        if (this.buffer.length) {
            this.buffer = $bb72e68028dbdf4a$require$Buffer.concat(this.buffer);
            if (this.compress) this.buffer = (0, (/*@__PURE__*/$parcel$interopDefault($gxZpm))).deflateSync(this.buffer);
            if (encryptFn) this.buffer = encryptFn(this.buffer);
            this.data.Length = this.buffer.length;
        }
        this.document._write(`${this.id} ${this.gen} obj`);
        this.document._write($bb72e68028dbdf4a$var$PDFObject.convert(this.data, encryptFn));
        if (this.buffer.length) {
            this.document._write('stream');
            this.document._write(this.buffer);
            this.buffer = [];
            this.document._write('\nendstream');
        }
        this.document._write('endobj');
        this.document._refEnd(this);
    }
    toString() {
        return `${this.id} ${this.gen} R`;
    }
}
const $bb72e68028dbdf4a$var$fArray = new Float32Array(1);
const $bb72e68028dbdf4a$var$uArray = new Uint32Array($bb72e68028dbdf4a$var$fArray.buffer);
function $bb72e68028dbdf4a$var$PDFNumber(n) {
    const rounded = Math.fround(n);
    if (rounded <= n) return rounded;
    $bb72e68028dbdf4a$var$fArray[0] = n;
    if (n <= 0) $bb72e68028dbdf4a$var$uArray[0] += 1;
    else $bb72e68028dbdf4a$var$uArray[0] -= 1;
    return $bb72e68028dbdf4a$var$fArray[0];
}
function $bb72e68028dbdf4a$var$normalizeSides(sides, defaultDefinition, transformer = (v)=>v) {
    if (sides == null || typeof sides === 'object' && Object.keys(sides).length === 0) sides = defaultDefinition;
    if (sides == null || typeof sides !== 'object') sides = {
        top: sides,
        right: sides,
        bottom: sides,
        left: sides
    };
    else if (Array.isArray(sides)) {
        if (sides.length === 2) sides = {
            vertical: sides[0],
            horizontal: sides[1]
        };
        else sides = {
            top: sides[0],
            right: sides[1],
            bottom: sides[2],
            left: sides[3]
        };
    }
    if ('vertical' in sides || 'horizontal' in sides) sides = {
        top: sides.vertical,
        right: sides.horizontal,
        bottom: sides.vertical,
        left: sides.horizontal
    };
    return {
        top: transformer(sides.top),
        right: transformer(sides.right),
        bottom: transformer(sides.bottom),
        left: transformer(sides.left)
    };
}
const $bb72e68028dbdf4a$var$MM_TO_CM = 0.1;
const $bb72e68028dbdf4a$var$CM_TO_IN = 1 / 2.54;
const $bb72e68028dbdf4a$var$PX_TO_IN = 1 / 96;
const $bb72e68028dbdf4a$var$IN_TO_PT = 72;
const $bb72e68028dbdf4a$var$PC_TO_PT = 12;
function $bb72e68028dbdf4a$var$cosine(a) {
    if (a === 0) return 1;
    if (a === 90) return 0;
    if (a === 180) return -1;
    if (a === 270) return 0;
    return Math.cos(a * Math.PI / 180);
}
function $bb72e68028dbdf4a$var$sine(a) {
    if (a === 0) return 0;
    if (a === 90) return 1;
    if (a === 180) return 0;
    if (a === 270) return -1;
    return Math.sin(a * Math.PI / 180);
}
const $bb72e68028dbdf4a$var$DEFAULT_MARGINS = {
    top: 72,
    left: 72,
    bottom: 72,
    right: 72
};
const $bb72e68028dbdf4a$var$SIZES = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ]
};
class $bb72e68028dbdf4a$var$PDFPage {
    constructor(document, options = {}){
        this.document = document;
        this._options = options;
        this.size = options.size || 'letter';
        this.layout = options.layout || 'portrait';
        this.userUnit = options.userUnit || 1.0;
        const dimensions = Array.isArray(this.size) ? this.size : $bb72e68028dbdf4a$var$SIZES[this.size.toUpperCase()];
        this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
        this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
        this.content = this.document.ref();
        if (options.font) document.font(options.font, options.fontFamily);
        if (options.fontSize) document.fontSize(options.fontSize);
        this.margins = $bb72e68028dbdf4a$var$normalizeSides(options.margin ?? options.margins, $bb72e68028dbdf4a$var$DEFAULT_MARGINS, (x)=>document.sizeToPoint(x, 0, this));
        this.resources = this.document.ref({
            ProcSet: [
                'PDF',
                'Text',
                'ImageB',
                'ImageC',
                'ImageI'
            ]
        });
        this.dictionary = this.document.ref({
            Type: 'Page',
            Parent: this.document._root.data.Pages,
            MediaBox: [
                0,
                0,
                this.width,
                this.height
            ],
            Contents: this.content,
            Resources: this.resources,
            UserUnit: this.userUnit
        });
        this.markings = [];
    }
    get fonts() {
        const data = this.resources.data;
        return data.Font != null ? data.Font : data.Font = {};
    }
    get xobjects() {
        const data = this.resources.data;
        return data.XObject != null ? data.XObject : data.XObject = {};
    }
    get ext_gstates() {
        const data = this.resources.data;
        return data.ExtGState != null ? data.ExtGState : data.ExtGState = {};
    }
    get patterns() {
        const data = this.resources.data;
        return data.Pattern != null ? data.Pattern : data.Pattern = {};
    }
    get colorSpaces() {
        const data = this.resources.data;
        return data.ColorSpace || (data.ColorSpace = {});
    }
    get annotations() {
        const data = this.dictionary.data;
        return data.Annots != null ? data.Annots : data.Annots = [];
    }
    get structParentTreeKey() {
        const data = this.dictionary.data;
        return data.StructParents != null ? data.StructParents : data.StructParents = this.document.createStructParentTreeNextKey();
    }
    get contentWidth() {
        return this.width - this.margins.left - this.margins.right;
    }
    get contentHeight() {
        return this.height - this.margins.top - this.margins.bottom;
    }
    maxY() {
        return this.height - this.margins.bottom;
    }
    write(chunk) {
        return this.content.write(chunk);
    }
    _setTabOrder() {
        if (!this.dictionary.Tabs && this.document.hasMarkInfoDictionary()) this.dictionary.data.Tabs = 'S';
    }
    end() {
        this._setTabOrder();
        this.dictionary.end();
        this.resources.data.ColorSpace = this.resources.data.ColorSpace || {};
        for (let color of Object.values(this.document.spotColors))this.resources.data.ColorSpace[color.id] = color;
        this.resources.end();
        return this.content.end();
    }
}
class $bb72e68028dbdf4a$var$PDFNameTree extends $bb72e68028dbdf4a$var$PDFTree {
    _compareKeys(a, b) {
        return a.localeCompare(b);
    }
    _keysName() {
        return 'Names';
    }
    _dataForKey(k) {
        return new String(k);
    }
}
function $bb72e68028dbdf4a$var$md5Hash(data) {
    return new Uint8Array((0, (/*@__PURE__*/$parcel$interopDefault($hqt0D))).arrayBuffer(data));
}
function $bb72e68028dbdf4a$var$md5Hex(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hqt0D)))(data);
}
function $bb72e68028dbdf4a$var$sha256Hash(data) {
    return (0, $htQ8Z.sha256)(data);
}
function $bb72e68028dbdf4a$var$aesCbcEncrypt(data, key, iv, padding = true) {
    return (0, $3RPiR.cbc)(key, iv, {
        disablePadding: !padding
    }).encrypt(data);
}
function $bb72e68028dbdf4a$var$aesEcbEncrypt(data, key) {
    return (0, $3RPiR.ecb)(key, {
        disablePadding: true
    }).encrypt(data);
}
function $bb72e68028dbdf4a$var$rc4(data, key) {
    const s = new Uint8Array(256);
    for(let i = 0; i < 256; i++)s[i] = i;
    let j = 0;
    for(let i = 0; i < 256; i++){
        j = j + s[i] + key[i % key.length] & 0xff;
        [s[i], s[j]] = [
            s[j],
            s[i]
        ];
    }
    const output = new Uint8Array(data.length);
    for(let i = 0, j = 0, k = 0; k < data.length; k++){
        i = i + 1 & 0xff;
        j = j + s[i] & 0xff;
        [s[i], s[j]] = [
            s[j],
            s[i]
        ];
        output[k] = data[k] ^ s[s[i] + s[j] & 0xff];
    }
    return output;
}
function $bb72e68028dbdf4a$var$randomBytes(length) {
    const bytes = new Uint8Array(length);
    globalThis.crypto.getRandomValues(bytes);
    return bytes;
}
function $bb72e68028dbdf4a$var$inRange(value, rangeGroup) {
    if (value < rangeGroup[0]) return false;
    let startRange = 0;
    let endRange = rangeGroup.length / 2;
    while(startRange <= endRange){
        const middleRange = Math.floor((startRange + endRange) / 2);
        const arrayIndex = middleRange * 2;
        if (value >= rangeGroup[arrayIndex] && value <= rangeGroup[arrayIndex + 1]) return true;
        if (value > rangeGroup[arrayIndex + 1]) startRange = middleRange + 1;
        else endRange = middleRange - 1;
    }
    return false;
}
const $bb72e68028dbdf4a$var$unassigned_code_points = [
    0x0221,
    0x0221,
    0x0234,
    0x024f,
    0x02ae,
    0x02af,
    0x02ef,
    0x02ff,
    0x0350,
    0x035f,
    0x0370,
    0x0373,
    0x0376,
    0x0379,
    0x037b,
    0x037d,
    0x037f,
    0x0383,
    0x038b,
    0x038b,
    0x038d,
    0x038d,
    0x03a2,
    0x03a2,
    0x03cf,
    0x03cf,
    0x03f7,
    0x03ff,
    0x0487,
    0x0487,
    0x04cf,
    0x04cf,
    0x04f6,
    0x04f7,
    0x04fa,
    0x04ff,
    0x0510,
    0x0530,
    0x0557,
    0x0558,
    0x0560,
    0x0560,
    0x0588,
    0x0588,
    0x058b,
    0x0590,
    0x05a2,
    0x05a2,
    0x05ba,
    0x05ba,
    0x05c5,
    0x05cf,
    0x05eb,
    0x05ef,
    0x05f5,
    0x060b,
    0x060d,
    0x061a,
    0x061c,
    0x061e,
    0x0620,
    0x0620,
    0x063b,
    0x063f,
    0x0656,
    0x065f,
    0x06ee,
    0x06ef,
    0x06ff,
    0x06ff,
    0x070e,
    0x070e,
    0x072d,
    0x072f,
    0x074b,
    0x077f,
    0x07b2,
    0x0900,
    0x0904,
    0x0904,
    0x093a,
    0x093b,
    0x094e,
    0x094f,
    0x0955,
    0x0957,
    0x0971,
    0x0980,
    0x0984,
    0x0984,
    0x098d,
    0x098e,
    0x0991,
    0x0992,
    0x09a9,
    0x09a9,
    0x09b1,
    0x09b1,
    0x09b3,
    0x09b5,
    0x09ba,
    0x09bb,
    0x09bd,
    0x09bd,
    0x09c5,
    0x09c6,
    0x09c9,
    0x09ca,
    0x09ce,
    0x09d6,
    0x09d8,
    0x09db,
    0x09de,
    0x09de,
    0x09e4,
    0x09e5,
    0x09fb,
    0x0a01,
    0x0a03,
    0x0a04,
    0x0a0b,
    0x0a0e,
    0x0a11,
    0x0a12,
    0x0a29,
    0x0a29,
    0x0a31,
    0x0a31,
    0x0a34,
    0x0a34,
    0x0a37,
    0x0a37,
    0x0a3a,
    0x0a3b,
    0x0a3d,
    0x0a3d,
    0x0a43,
    0x0a46,
    0x0a49,
    0x0a4a,
    0x0a4e,
    0x0a58,
    0x0a5d,
    0x0a5d,
    0x0a5f,
    0x0a65,
    0x0a75,
    0x0a80,
    0x0a84,
    0x0a84,
    0x0a8c,
    0x0a8c,
    0x0a8e,
    0x0a8e,
    0x0a92,
    0x0a92,
    0x0aa9,
    0x0aa9,
    0x0ab1,
    0x0ab1,
    0x0ab4,
    0x0ab4,
    0x0aba,
    0x0abb,
    0x0ac6,
    0x0ac6,
    0x0aca,
    0x0aca,
    0x0ace,
    0x0acf,
    0x0ad1,
    0x0adf,
    0x0ae1,
    0x0ae5,
    0x0af0,
    0x0b00,
    0x0b04,
    0x0b04,
    0x0b0d,
    0x0b0e,
    0x0b11,
    0x0b12,
    0x0b29,
    0x0b29,
    0x0b31,
    0x0b31,
    0x0b34,
    0x0b35,
    0x0b3a,
    0x0b3b,
    0x0b44,
    0x0b46,
    0x0b49,
    0x0b4a,
    0x0b4e,
    0x0b55,
    0x0b58,
    0x0b5b,
    0x0b5e,
    0x0b5e,
    0x0b62,
    0x0b65,
    0x0b71,
    0x0b81,
    0x0b84,
    0x0b84,
    0x0b8b,
    0x0b8d,
    0x0b91,
    0x0b91,
    0x0b96,
    0x0b98,
    0x0b9b,
    0x0b9b,
    0x0b9d,
    0x0b9d,
    0x0ba0,
    0x0ba2,
    0x0ba5,
    0x0ba7,
    0x0bab,
    0x0bad,
    0x0bb6,
    0x0bb6,
    0x0bba,
    0x0bbd,
    0x0bc3,
    0x0bc5,
    0x0bc9,
    0x0bc9,
    0x0bce,
    0x0bd6,
    0x0bd8,
    0x0be6,
    0x0bf3,
    0x0c00,
    0x0c04,
    0x0c04,
    0x0c0d,
    0x0c0d,
    0x0c11,
    0x0c11,
    0x0c29,
    0x0c29,
    0x0c34,
    0x0c34,
    0x0c3a,
    0x0c3d,
    0x0c45,
    0x0c45,
    0x0c49,
    0x0c49,
    0x0c4e,
    0x0c54,
    0x0c57,
    0x0c5f,
    0x0c62,
    0x0c65,
    0x0c70,
    0x0c81,
    0x0c84,
    0x0c84,
    0x0c8d,
    0x0c8d,
    0x0c91,
    0x0c91,
    0x0ca9,
    0x0ca9,
    0x0cb4,
    0x0cb4,
    0x0cba,
    0x0cbd,
    0x0cc5,
    0x0cc5,
    0x0cc9,
    0x0cc9,
    0x0cce,
    0x0cd4,
    0x0cd7,
    0x0cdd,
    0x0cdf,
    0x0cdf,
    0x0ce2,
    0x0ce5,
    0x0cf0,
    0x0d01,
    0x0d04,
    0x0d04,
    0x0d0d,
    0x0d0d,
    0x0d11,
    0x0d11,
    0x0d29,
    0x0d29,
    0x0d3a,
    0x0d3d,
    0x0d44,
    0x0d45,
    0x0d49,
    0x0d49,
    0x0d4e,
    0x0d56,
    0x0d58,
    0x0d5f,
    0x0d62,
    0x0d65,
    0x0d70,
    0x0d81,
    0x0d84,
    0x0d84,
    0x0d97,
    0x0d99,
    0x0db2,
    0x0db2,
    0x0dbc,
    0x0dbc,
    0x0dbe,
    0x0dbf,
    0x0dc7,
    0x0dc9,
    0x0dcb,
    0x0dce,
    0x0dd5,
    0x0dd5,
    0x0dd7,
    0x0dd7,
    0x0de0,
    0x0df1,
    0x0df5,
    0x0e00,
    0x0e3b,
    0x0e3e,
    0x0e5c,
    0x0e80,
    0x0e83,
    0x0e83,
    0x0e85,
    0x0e86,
    0x0e89,
    0x0e89,
    0x0e8b,
    0x0e8c,
    0x0e8e,
    0x0e93,
    0x0e98,
    0x0e98,
    0x0ea0,
    0x0ea0,
    0x0ea4,
    0x0ea4,
    0x0ea6,
    0x0ea6,
    0x0ea8,
    0x0ea9,
    0x0eac,
    0x0eac,
    0x0eba,
    0x0eba,
    0x0ebe,
    0x0ebf,
    0x0ec5,
    0x0ec5,
    0x0ec7,
    0x0ec7,
    0x0ece,
    0x0ecf,
    0x0eda,
    0x0edb,
    0x0ede,
    0x0eff,
    0x0f48,
    0x0f48,
    0x0f6b,
    0x0f70,
    0x0f8c,
    0x0f8f,
    0x0f98,
    0x0f98,
    0x0fbd,
    0x0fbd,
    0x0fcd,
    0x0fce,
    0x0fd0,
    0x0fff,
    0x1022,
    0x1022,
    0x1028,
    0x1028,
    0x102b,
    0x102b,
    0x1033,
    0x1035,
    0x103a,
    0x103f,
    0x105a,
    0x109f,
    0x10c6,
    0x10cf,
    0x10f9,
    0x10fa,
    0x10fc,
    0x10ff,
    0x115a,
    0x115e,
    0x11a3,
    0x11a7,
    0x11fa,
    0x11ff,
    0x1207,
    0x1207,
    0x1247,
    0x1247,
    0x1249,
    0x1249,
    0x124e,
    0x124f,
    0x1257,
    0x1257,
    0x1259,
    0x1259,
    0x125e,
    0x125f,
    0x1287,
    0x1287,
    0x1289,
    0x1289,
    0x128e,
    0x128f,
    0x12af,
    0x12af,
    0x12b1,
    0x12b1,
    0x12b6,
    0x12b7,
    0x12bf,
    0x12bf,
    0x12c1,
    0x12c1,
    0x12c6,
    0x12c7,
    0x12cf,
    0x12cf,
    0x12d7,
    0x12d7,
    0x12ef,
    0x12ef,
    0x130f,
    0x130f,
    0x1311,
    0x1311,
    0x1316,
    0x1317,
    0x131f,
    0x131f,
    0x1347,
    0x1347,
    0x135b,
    0x1360,
    0x137d,
    0x139f,
    0x13f5,
    0x1400,
    0x1677,
    0x167f,
    0x169d,
    0x169f,
    0x16f1,
    0x16ff,
    0x170d,
    0x170d,
    0x1715,
    0x171f,
    0x1737,
    0x173f,
    0x1754,
    0x175f,
    0x176d,
    0x176d,
    0x1771,
    0x1771,
    0x1774,
    0x177f,
    0x17dd,
    0x17df,
    0x17ea,
    0x17ff,
    0x180f,
    0x180f,
    0x181a,
    0x181f,
    0x1878,
    0x187f,
    0x18aa,
    0x1dff,
    0x1e9c,
    0x1e9f,
    0x1efa,
    0x1eff,
    0x1f16,
    0x1f17,
    0x1f1e,
    0x1f1f,
    0x1f46,
    0x1f47,
    0x1f4e,
    0x1f4f,
    0x1f58,
    0x1f58,
    0x1f5a,
    0x1f5a,
    0x1f5c,
    0x1f5c,
    0x1f5e,
    0x1f5e,
    0x1f7e,
    0x1f7f,
    0x1fb5,
    0x1fb5,
    0x1fc5,
    0x1fc5,
    0x1fd4,
    0x1fd5,
    0x1fdc,
    0x1fdc,
    0x1ff0,
    0x1ff1,
    0x1ff5,
    0x1ff5,
    0x1fff,
    0x1fff,
    0x2053,
    0x2056,
    0x2058,
    0x205e,
    0x2064,
    0x2069,
    0x2072,
    0x2073,
    0x208f,
    0x209f,
    0x20b2,
    0x20cf,
    0x20eb,
    0x20ff,
    0x213b,
    0x213c,
    0x214c,
    0x2152,
    0x2184,
    0x218f,
    0x23cf,
    0x23ff,
    0x2427,
    0x243f,
    0x244b,
    0x245f,
    0x24ff,
    0x24ff,
    0x2614,
    0x2615,
    0x2618,
    0x2618,
    0x267e,
    0x267f,
    0x268a,
    0x2700,
    0x2705,
    0x2705,
    0x270a,
    0x270b,
    0x2728,
    0x2728,
    0x274c,
    0x274c,
    0x274e,
    0x274e,
    0x2753,
    0x2755,
    0x2757,
    0x2757,
    0x275f,
    0x2760,
    0x2795,
    0x2797,
    0x27b0,
    0x27b0,
    0x27bf,
    0x27cf,
    0x27ec,
    0x27ef,
    0x2b00,
    0x2e7f,
    0x2e9a,
    0x2e9a,
    0x2ef4,
    0x2eff,
    0x2fd6,
    0x2fef,
    0x2ffc,
    0x2fff,
    0x3040,
    0x3040,
    0x3097,
    0x3098,
    0x3100,
    0x3104,
    0x312d,
    0x3130,
    0x318f,
    0x318f,
    0x31b8,
    0x31ef,
    0x321d,
    0x321f,
    0x3244,
    0x3250,
    0x327c,
    0x327e,
    0x32cc,
    0x32cf,
    0x32ff,
    0x32ff,
    0x3377,
    0x337a,
    0x33de,
    0x33df,
    0x33ff,
    0x33ff,
    0x4db6,
    0x4dff,
    0x9fa6,
    0x9fff,
    0xa48d,
    0xa48f,
    0xa4c7,
    0xabff,
    0xd7a4,
    0xd7ff,
    0xfa2e,
    0xfa2f,
    0xfa6b,
    0xfaff,
    0xfb07,
    0xfb12,
    0xfb18,
    0xfb1c,
    0xfb37,
    0xfb37,
    0xfb3d,
    0xfb3d,
    0xfb3f,
    0xfb3f,
    0xfb42,
    0xfb42,
    0xfb45,
    0xfb45,
    0xfbb2,
    0xfbd2,
    0xfd40,
    0xfd4f,
    0xfd90,
    0xfd91,
    0xfdc8,
    0xfdcf,
    0xfdfd,
    0xfdff,
    0xfe10,
    0xfe1f,
    0xfe24,
    0xfe2f,
    0xfe47,
    0xfe48,
    0xfe53,
    0xfe53,
    0xfe67,
    0xfe67,
    0xfe6c,
    0xfe6f,
    0xfe75,
    0xfe75,
    0xfefd,
    0xfefe,
    0xff00,
    0xff00,
    0xffbf,
    0xffc1,
    0xffc8,
    0xffc9,
    0xffd0,
    0xffd1,
    0xffd8,
    0xffd9,
    0xffdd,
    0xffdf,
    0xffe7,
    0xffe7,
    0xffef,
    0xfff8,
    0x10000,
    0x102ff,
    0x1031f,
    0x1031f,
    0x10324,
    0x1032f,
    0x1034b,
    0x103ff,
    0x10426,
    0x10427,
    0x1044e,
    0x1cfff,
    0x1d0f6,
    0x1d0ff,
    0x1d127,
    0x1d129,
    0x1d1de,
    0x1d3ff,
    0x1d455,
    0x1d455,
    0x1d49d,
    0x1d49d,
    0x1d4a0,
    0x1d4a1,
    0x1d4a3,
    0x1d4a4,
    0x1d4a7,
    0x1d4a8,
    0x1d4ad,
    0x1d4ad,
    0x1d4ba,
    0x1d4ba,
    0x1d4bc,
    0x1d4bc,
    0x1d4c1,
    0x1d4c1,
    0x1d4c4,
    0x1d4c4,
    0x1d506,
    0x1d506,
    0x1d50b,
    0x1d50c,
    0x1d515,
    0x1d515,
    0x1d51d,
    0x1d51d,
    0x1d53a,
    0x1d53a,
    0x1d53f,
    0x1d53f,
    0x1d545,
    0x1d545,
    0x1d547,
    0x1d549,
    0x1d551,
    0x1d551,
    0x1d6a4,
    0x1d6a7,
    0x1d7ca,
    0x1d7cd,
    0x1d800,
    0x1fffd,
    0x2a6d7,
    0x2f7ff,
    0x2fa1e,
    0x2fffd,
    0x30000,
    0x3fffd,
    0x40000,
    0x4fffd,
    0x50000,
    0x5fffd,
    0x60000,
    0x6fffd,
    0x70000,
    0x7fffd,
    0x80000,
    0x8fffd,
    0x90000,
    0x9fffd,
    0xa0000,
    0xafffd,
    0xb0000,
    0xbfffd,
    0xc0000,
    0xcfffd,
    0xd0000,
    0xdfffd,
    0xe0000,
    0xe0000,
    0xe0002,
    0xe001f,
    0xe0080,
    0xefffd
];
const $bb72e68028dbdf4a$var$isUnassignedCodePoint = (character)=>$bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$unassigned_code_points);
const $bb72e68028dbdf4a$var$commonly_mapped_to_nothing = [
    0x00ad,
    0x00ad,
    0x034f,
    0x034f,
    0x1806,
    0x1806,
    0x180b,
    0x180b,
    0x180c,
    0x180c,
    0x180d,
    0x180d,
    0x200b,
    0x200b,
    0x200c,
    0x200c,
    0x200d,
    0x200d,
    0x2060,
    0x2060,
    0xfe00,
    0xfe00,
    0xfe01,
    0xfe01,
    0xfe02,
    0xfe02,
    0xfe03,
    0xfe03,
    0xfe04,
    0xfe04,
    0xfe05,
    0xfe05,
    0xfe06,
    0xfe06,
    0xfe07,
    0xfe07,
    0xfe08,
    0xfe08,
    0xfe09,
    0xfe09,
    0xfe0a,
    0xfe0a,
    0xfe0b,
    0xfe0b,
    0xfe0c,
    0xfe0c,
    0xfe0d,
    0xfe0d,
    0xfe0e,
    0xfe0e,
    0xfe0f,
    0xfe0f,
    0xfeff,
    0xfeff
];
const $bb72e68028dbdf4a$var$isCommonlyMappedToNothing = (character)=>$bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$commonly_mapped_to_nothing);
const $bb72e68028dbdf4a$var$non_ASCII_space_characters = [
    0x00a0,
    0x00a0,
    0x1680,
    0x1680,
    0x2000,
    0x2000,
    0x2001,
    0x2001,
    0x2002,
    0x2002,
    0x2003,
    0x2003,
    0x2004,
    0x2004,
    0x2005,
    0x2005,
    0x2006,
    0x2006,
    0x2007,
    0x2007,
    0x2008,
    0x2008,
    0x2009,
    0x2009,
    0x200a,
    0x200a,
    0x200b,
    0x200b,
    0x202f,
    0x202f,
    0x205f,
    0x205f,
    0x3000,
    0x3000
];
const $bb72e68028dbdf4a$var$isNonASCIISpaceCharacter = (character)=>$bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$non_ASCII_space_characters);
const $bb72e68028dbdf4a$var$non_ASCII_controls_characters = [
    0x0080,
    0x009f,
    0x06dd,
    0x06dd,
    0x070f,
    0x070f,
    0x180e,
    0x180e,
    0x200c,
    0x200c,
    0x200d,
    0x200d,
    0x2028,
    0x2028,
    0x2029,
    0x2029,
    0x2060,
    0x2060,
    0x2061,
    0x2061,
    0x2062,
    0x2062,
    0x2063,
    0x2063,
    0x206a,
    0x206f,
    0xfeff,
    0xfeff,
    0xfff9,
    0xfffc,
    0x1d173,
    0x1d17a
];
const $bb72e68028dbdf4a$var$non_character_codepoints = [
    0xfdd0,
    0xfdef,
    0xfffe,
    0xffff,
    0x1fffe,
    0x1ffff,
    0x2fffe,
    0x2ffff,
    0x3fffe,
    0x3ffff,
    0x4fffe,
    0x4ffff,
    0x5fffe,
    0x5ffff,
    0x6fffe,
    0x6ffff,
    0x7fffe,
    0x7ffff,
    0x8fffe,
    0x8ffff,
    0x9fffe,
    0x9ffff,
    0xafffe,
    0xaffff,
    0xbfffe,
    0xbffff,
    0xcfffe,
    0xcffff,
    0xdfffe,
    0xdffff,
    0xefffe,
    0xeffff,
    0x10fffe,
    0x10ffff
];
const $bb72e68028dbdf4a$var$prohibited_characters = [
    0,
    0x001f,
    0x007f,
    0x007f,
    0x0340,
    0x0340,
    0x0341,
    0x0341,
    0x200e,
    0x200e,
    0x200f,
    0x200f,
    0x202a,
    0x202a,
    0x202b,
    0x202b,
    0x202c,
    0x202c,
    0x202d,
    0x202d,
    0x202e,
    0x202e,
    0x206a,
    0x206a,
    0x206b,
    0x206b,
    0x206c,
    0x206c,
    0x206d,
    0x206d,
    0x206e,
    0x206e,
    0x206f,
    0x206f,
    0x2ff0,
    0x2ffb,
    0xd800,
    0xdfff,
    0xe000,
    0xf8ff,
    0xfff9,
    0xfff9,
    0xfffa,
    0xfffa,
    0xfffb,
    0xfffb,
    0xfffc,
    0xfffc,
    0xfffd,
    0xfffd,
    0xe0001,
    0xe0001,
    0xe0020,
    0xe007f,
    0xf0000,
    0xffffd,
    0x100000,
    0x10fffd
];
const $bb72e68028dbdf4a$var$isProhibitedCharacter = (character)=>$bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$non_ASCII_space_characters) || $bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$prohibited_characters) || $bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$non_ASCII_controls_characters) || $bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$non_character_codepoints);
const $bb72e68028dbdf4a$var$bidirectional_r_al = [
    0x05be,
    0x05be,
    0x05c0,
    0x05c0,
    0x05c3,
    0x05c3,
    0x05d0,
    0x05ea,
    0x05f0,
    0x05f4,
    0x061b,
    0x061b,
    0x061f,
    0x061f,
    0x0621,
    0x063a,
    0x0640,
    0x064a,
    0x066d,
    0x066f,
    0x0671,
    0x06d5,
    0x06dd,
    0x06dd,
    0x06e5,
    0x06e6,
    0x06fa,
    0x06fe,
    0x0700,
    0x070d,
    0x0710,
    0x0710,
    0x0712,
    0x072c,
    0x0780,
    0x07a5,
    0x07b1,
    0x07b1,
    0x200f,
    0x200f,
    0xfb1d,
    0xfb1d,
    0xfb1f,
    0xfb28,
    0xfb2a,
    0xfb36,
    0xfb38,
    0xfb3c,
    0xfb3e,
    0xfb3e,
    0xfb40,
    0xfb41,
    0xfb43,
    0xfb44,
    0xfb46,
    0xfbb1,
    0xfbd3,
    0xfd3d,
    0xfd50,
    0xfd8f,
    0xfd92,
    0xfdc7,
    0xfdf0,
    0xfdfc,
    0xfe70,
    0xfe74,
    0xfe76,
    0xfefc
];
const $bb72e68028dbdf4a$var$isBidirectionalRAL = (character)=>$bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$bidirectional_r_al);
const $bb72e68028dbdf4a$var$bidirectional_l = [
    0x0041,
    0x005a,
    0x0061,
    0x007a,
    0x00aa,
    0x00aa,
    0x00b5,
    0x00b5,
    0x00ba,
    0x00ba,
    0x00c0,
    0x00d6,
    0x00d8,
    0x00f6,
    0x00f8,
    0x0220,
    0x0222,
    0x0233,
    0x0250,
    0x02ad,
    0x02b0,
    0x02b8,
    0x02bb,
    0x02c1,
    0x02d0,
    0x02d1,
    0x02e0,
    0x02e4,
    0x02ee,
    0x02ee,
    0x037a,
    0x037a,
    0x0386,
    0x0386,
    0x0388,
    0x038a,
    0x038c,
    0x038c,
    0x038e,
    0x03a1,
    0x03a3,
    0x03ce,
    0x03d0,
    0x03f5,
    0x0400,
    0x0482,
    0x048a,
    0x04ce,
    0x04d0,
    0x04f5,
    0x04f8,
    0x04f9,
    0x0500,
    0x050f,
    0x0531,
    0x0556,
    0x0559,
    0x055f,
    0x0561,
    0x0587,
    0x0589,
    0x0589,
    0x0903,
    0x0903,
    0x0905,
    0x0939,
    0x093d,
    0x0940,
    0x0949,
    0x094c,
    0x0950,
    0x0950,
    0x0958,
    0x0961,
    0x0964,
    0x0970,
    0x0982,
    0x0983,
    0x0985,
    0x098c,
    0x098f,
    0x0990,
    0x0993,
    0x09a8,
    0x09aa,
    0x09b0,
    0x09b2,
    0x09b2,
    0x09b6,
    0x09b9,
    0x09be,
    0x09c0,
    0x09c7,
    0x09c8,
    0x09cb,
    0x09cc,
    0x09d7,
    0x09d7,
    0x09dc,
    0x09dd,
    0x09df,
    0x09e1,
    0x09e6,
    0x09f1,
    0x09f4,
    0x09fa,
    0x0a05,
    0x0a0a,
    0x0a0f,
    0x0a10,
    0x0a13,
    0x0a28,
    0x0a2a,
    0x0a30,
    0x0a32,
    0x0a33,
    0x0a35,
    0x0a36,
    0x0a38,
    0x0a39,
    0x0a3e,
    0x0a40,
    0x0a59,
    0x0a5c,
    0x0a5e,
    0x0a5e,
    0x0a66,
    0x0a6f,
    0x0a72,
    0x0a74,
    0x0a83,
    0x0a83,
    0x0a85,
    0x0a8b,
    0x0a8d,
    0x0a8d,
    0x0a8f,
    0x0a91,
    0x0a93,
    0x0aa8,
    0x0aaa,
    0x0ab0,
    0x0ab2,
    0x0ab3,
    0x0ab5,
    0x0ab9,
    0x0abd,
    0x0ac0,
    0x0ac9,
    0x0ac9,
    0x0acb,
    0x0acc,
    0x0ad0,
    0x0ad0,
    0x0ae0,
    0x0ae0,
    0x0ae6,
    0x0aef,
    0x0b02,
    0x0b03,
    0x0b05,
    0x0b0c,
    0x0b0f,
    0x0b10,
    0x0b13,
    0x0b28,
    0x0b2a,
    0x0b30,
    0x0b32,
    0x0b33,
    0x0b36,
    0x0b39,
    0x0b3d,
    0x0b3e,
    0x0b40,
    0x0b40,
    0x0b47,
    0x0b48,
    0x0b4b,
    0x0b4c,
    0x0b57,
    0x0b57,
    0x0b5c,
    0x0b5d,
    0x0b5f,
    0x0b61,
    0x0b66,
    0x0b70,
    0x0b83,
    0x0b83,
    0x0b85,
    0x0b8a,
    0x0b8e,
    0x0b90,
    0x0b92,
    0x0b95,
    0x0b99,
    0x0b9a,
    0x0b9c,
    0x0b9c,
    0x0b9e,
    0x0b9f,
    0x0ba3,
    0x0ba4,
    0x0ba8,
    0x0baa,
    0x0bae,
    0x0bb5,
    0x0bb7,
    0x0bb9,
    0x0bbe,
    0x0bbf,
    0x0bc1,
    0x0bc2,
    0x0bc6,
    0x0bc8,
    0x0bca,
    0x0bcc,
    0x0bd7,
    0x0bd7,
    0x0be7,
    0x0bf2,
    0x0c01,
    0x0c03,
    0x0c05,
    0x0c0c,
    0x0c0e,
    0x0c10,
    0x0c12,
    0x0c28,
    0x0c2a,
    0x0c33,
    0x0c35,
    0x0c39,
    0x0c41,
    0x0c44,
    0x0c60,
    0x0c61,
    0x0c66,
    0x0c6f,
    0x0c82,
    0x0c83,
    0x0c85,
    0x0c8c,
    0x0c8e,
    0x0c90,
    0x0c92,
    0x0ca8,
    0x0caa,
    0x0cb3,
    0x0cb5,
    0x0cb9,
    0x0cbe,
    0x0cbe,
    0x0cc0,
    0x0cc4,
    0x0cc7,
    0x0cc8,
    0x0cca,
    0x0ccb,
    0x0cd5,
    0x0cd6,
    0x0cde,
    0x0cde,
    0x0ce0,
    0x0ce1,
    0x0ce6,
    0x0cef,
    0x0d02,
    0x0d03,
    0x0d05,
    0x0d0c,
    0x0d0e,
    0x0d10,
    0x0d12,
    0x0d28,
    0x0d2a,
    0x0d39,
    0x0d3e,
    0x0d40,
    0x0d46,
    0x0d48,
    0x0d4a,
    0x0d4c,
    0x0d57,
    0x0d57,
    0x0d60,
    0x0d61,
    0x0d66,
    0x0d6f,
    0x0d82,
    0x0d83,
    0x0d85,
    0x0d96,
    0x0d9a,
    0x0db1,
    0x0db3,
    0x0dbb,
    0x0dbd,
    0x0dbd,
    0x0dc0,
    0x0dc6,
    0x0dcf,
    0x0dd1,
    0x0dd8,
    0x0ddf,
    0x0df2,
    0x0df4,
    0x0e01,
    0x0e30,
    0x0e32,
    0x0e33,
    0x0e40,
    0x0e46,
    0x0e4f,
    0x0e5b,
    0x0e81,
    0x0e82,
    0x0e84,
    0x0e84,
    0x0e87,
    0x0e88,
    0x0e8a,
    0x0e8a,
    0x0e8d,
    0x0e8d,
    0x0e94,
    0x0e97,
    0x0e99,
    0x0e9f,
    0x0ea1,
    0x0ea3,
    0x0ea5,
    0x0ea5,
    0x0ea7,
    0x0ea7,
    0x0eaa,
    0x0eab,
    0x0ead,
    0x0eb0,
    0x0eb2,
    0x0eb3,
    0x0ebd,
    0x0ebd,
    0x0ec0,
    0x0ec4,
    0x0ec6,
    0x0ec6,
    0x0ed0,
    0x0ed9,
    0x0edc,
    0x0edd,
    0x0f00,
    0x0f17,
    0x0f1a,
    0x0f34,
    0x0f36,
    0x0f36,
    0x0f38,
    0x0f38,
    0x0f3e,
    0x0f47,
    0x0f49,
    0x0f6a,
    0x0f7f,
    0x0f7f,
    0x0f85,
    0x0f85,
    0x0f88,
    0x0f8b,
    0x0fbe,
    0x0fc5,
    0x0fc7,
    0x0fcc,
    0x0fcf,
    0x0fcf,
    0x1000,
    0x1021,
    0x1023,
    0x1027,
    0x1029,
    0x102a,
    0x102c,
    0x102c,
    0x1031,
    0x1031,
    0x1038,
    0x1038,
    0x1040,
    0x1057,
    0x10a0,
    0x10c5,
    0x10d0,
    0x10f8,
    0x10fb,
    0x10fb,
    0x1100,
    0x1159,
    0x115f,
    0x11a2,
    0x11a8,
    0x11f9,
    0x1200,
    0x1206,
    0x1208,
    0x1246,
    0x1248,
    0x1248,
    0x124a,
    0x124d,
    0x1250,
    0x1256,
    0x1258,
    0x1258,
    0x125a,
    0x125d,
    0x1260,
    0x1286,
    0x1288,
    0x1288,
    0x128a,
    0x128d,
    0x1290,
    0x12ae,
    0x12b0,
    0x12b0,
    0x12b2,
    0x12b5,
    0x12b8,
    0x12be,
    0x12c0,
    0x12c0,
    0x12c2,
    0x12c5,
    0x12c8,
    0x12ce,
    0x12d0,
    0x12d6,
    0x12d8,
    0x12ee,
    0x12f0,
    0x130e,
    0x1310,
    0x1310,
    0x1312,
    0x1315,
    0x1318,
    0x131e,
    0x1320,
    0x1346,
    0x1348,
    0x135a,
    0x1361,
    0x137c,
    0x13a0,
    0x13f4,
    0x1401,
    0x1676,
    0x1681,
    0x169a,
    0x16a0,
    0x16f0,
    0x1700,
    0x170c,
    0x170e,
    0x1711,
    0x1720,
    0x1731,
    0x1735,
    0x1736,
    0x1740,
    0x1751,
    0x1760,
    0x176c,
    0x176e,
    0x1770,
    0x1780,
    0x17b6,
    0x17be,
    0x17c5,
    0x17c7,
    0x17c8,
    0x17d4,
    0x17da,
    0x17dc,
    0x17dc,
    0x17e0,
    0x17e9,
    0x1810,
    0x1819,
    0x1820,
    0x1877,
    0x1880,
    0x18a8,
    0x1e00,
    0x1e9b,
    0x1ea0,
    0x1ef9,
    0x1f00,
    0x1f15,
    0x1f18,
    0x1f1d,
    0x1f20,
    0x1f45,
    0x1f48,
    0x1f4d,
    0x1f50,
    0x1f57,
    0x1f59,
    0x1f59,
    0x1f5b,
    0x1f5b,
    0x1f5d,
    0x1f5d,
    0x1f5f,
    0x1f7d,
    0x1f80,
    0x1fb4,
    0x1fb6,
    0x1fbc,
    0x1fbe,
    0x1fbe,
    0x1fc2,
    0x1fc4,
    0x1fc6,
    0x1fcc,
    0x1fd0,
    0x1fd3,
    0x1fd6,
    0x1fdb,
    0x1fe0,
    0x1fec,
    0x1ff2,
    0x1ff4,
    0x1ff6,
    0x1ffc,
    0x200e,
    0x200e,
    0x2071,
    0x2071,
    0x207f,
    0x207f,
    0x2102,
    0x2102,
    0x2107,
    0x2107,
    0x210a,
    0x2113,
    0x2115,
    0x2115,
    0x2119,
    0x211d,
    0x2124,
    0x2124,
    0x2126,
    0x2126,
    0x2128,
    0x2128,
    0x212a,
    0x212d,
    0x212f,
    0x2131,
    0x2133,
    0x2139,
    0x213d,
    0x213f,
    0x2145,
    0x2149,
    0x2160,
    0x2183,
    0x2336,
    0x237a,
    0x2395,
    0x2395,
    0x249c,
    0x24e9,
    0x3005,
    0x3007,
    0x3021,
    0x3029,
    0x3031,
    0x3035,
    0x3038,
    0x303c,
    0x3041,
    0x3096,
    0x309d,
    0x309f,
    0x30a1,
    0x30fa,
    0x30fc,
    0x30ff,
    0x3105,
    0x312c,
    0x3131,
    0x318e,
    0x3190,
    0x31b7,
    0x31f0,
    0x321c,
    0x3220,
    0x3243,
    0x3260,
    0x327b,
    0x327f,
    0x32b0,
    0x32c0,
    0x32cb,
    0x32d0,
    0x32fe,
    0x3300,
    0x3376,
    0x337b,
    0x33dd,
    0x33e0,
    0x33fe,
    0x3400,
    0x4db5,
    0x4e00,
    0x9fa5,
    0xa000,
    0xa48c,
    0xac00,
    0xd7a3,
    0xd800,
    0xfa2d,
    0xfa30,
    0xfa6a,
    0xfb00,
    0xfb06,
    0xfb13,
    0xfb17,
    0xff21,
    0xff3a,
    0xff41,
    0xff5a,
    0xff66,
    0xffbe,
    0xffc2,
    0xffc7,
    0xffca,
    0xffcf,
    0xffd2,
    0xffd7,
    0xffda,
    0xffdc,
    0x10300,
    0x1031e,
    0x10320,
    0x10323,
    0x10330,
    0x1034a,
    0x10400,
    0x10425,
    0x10428,
    0x1044d,
    0x1d000,
    0x1d0f5,
    0x1d100,
    0x1d126,
    0x1d12a,
    0x1d166,
    0x1d16a,
    0x1d172,
    0x1d183,
    0x1d184,
    0x1d18c,
    0x1d1a9,
    0x1d1ae,
    0x1d1dd,
    0x1d400,
    0x1d454,
    0x1d456,
    0x1d49c,
    0x1d49e,
    0x1d49f,
    0x1d4a2,
    0x1d4a2,
    0x1d4a5,
    0x1d4a6,
    0x1d4a9,
    0x1d4ac,
    0x1d4ae,
    0x1d4b9,
    0x1d4bb,
    0x1d4bb,
    0x1d4bd,
    0x1d4c0,
    0x1d4c2,
    0x1d4c3,
    0x1d4c5,
    0x1d505,
    0x1d507,
    0x1d50a,
    0x1d50d,
    0x1d514,
    0x1d516,
    0x1d51c,
    0x1d51e,
    0x1d539,
    0x1d53b,
    0x1d53e,
    0x1d540,
    0x1d544,
    0x1d546,
    0x1d546,
    0x1d54a,
    0x1d550,
    0x1d552,
    0x1d6a3,
    0x1d6a8,
    0x1d7c9,
    0x20000,
    0x2a6d6,
    0x2f800,
    0x2fa1d,
    0xf0000,
    0xffffd,
    0x100000,
    0x10fffd
];
const $bb72e68028dbdf4a$var$isBidirectionalL = (character)=>$bb72e68028dbdf4a$var$inRange(character, $bb72e68028dbdf4a$var$bidirectional_l);
const $bb72e68028dbdf4a$var$mapping2space = $bb72e68028dbdf4a$var$isNonASCIISpaceCharacter;
const $bb72e68028dbdf4a$var$mapping2nothing = $bb72e68028dbdf4a$var$isCommonlyMappedToNothing;
const $bb72e68028dbdf4a$var$getCodePoint = (character)=>character.codePointAt(0);
const $bb72e68028dbdf4a$var$first = (x)=>x[0];
const $bb72e68028dbdf4a$var$last = (x)=>x[x.length - 1];
function $bb72e68028dbdf4a$var$toCodePoints(input) {
    const codepoints = [];
    const size = input.length;
    for(let i = 0; i < size; i += 1){
        const before = input.charCodeAt(i);
        if (before >= 0xd800 && before <= 0xdbff && size > i + 1) {
            const next = input.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                codepoints.push((before - 0xd800) * 0x400 + next - 0xdc00 + 0x10000);
                i += 1;
                continue;
            }
        }
        codepoints.push(before);
    }
    return codepoints;
}
function $bb72e68028dbdf4a$var$saslprep(input, opts = {}) {
    if (typeof input !== 'string') throw new TypeError('Expected string.');
    if (input.length === 0) return '';
    const mapped_input = $bb72e68028dbdf4a$var$toCodePoints(input).map((character)=>$bb72e68028dbdf4a$var$mapping2space(character) ? 0x20 : character).filter((character)=>!$bb72e68028dbdf4a$var$mapping2nothing(character));
    const normalized_input = String.fromCodePoint.apply(null, mapped_input).normalize('NFKC');
    const normalized_map = $bb72e68028dbdf4a$var$toCodePoints(normalized_input);
    const hasProhibited = normalized_map.some($bb72e68028dbdf4a$var$isProhibitedCharacter);
    if (hasProhibited) throw new Error('Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3');
    if (opts.allowUnassigned !== true) {
        const hasUnassigned = normalized_map.some($bb72e68028dbdf4a$var$isUnassignedCodePoint);
        if (hasUnassigned) throw new Error('Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5');
    }
    const hasBidiRAL = normalized_map.some($bb72e68028dbdf4a$var$isBidirectionalRAL);
    const hasBidiL = normalized_map.some($bb72e68028dbdf4a$var$isBidirectionalL);
    if (hasBidiRAL && hasBidiL) throw new Error("String must not contain RandALCat and LCat at the same time, see https://tools.ietf.org/html/rfc3454#section-6");
    const isFirstBidiRAL = $bb72e68028dbdf4a$var$isBidirectionalRAL($bb72e68028dbdf4a$var$getCodePoint($bb72e68028dbdf4a$var$first(normalized_input)));
    const isLastBidiRAL = $bb72e68028dbdf4a$var$isBidirectionalRAL($bb72e68028dbdf4a$var$getCodePoint($bb72e68028dbdf4a$var$last(normalized_input)));
    if (hasBidiRAL && !(isFirstBidiRAL && isLastBidiRAL)) throw new Error("Bidirectional RandALCat character must be the first and the last character of the string, see https://tools.ietf.org/html/rfc3454#section-6");
    return normalized_input;
}
class $bb72e68028dbdf4a$var$PDFSecurity {
    static generateFileID(info = {}) {
        let infoStr = `${info.CreationDate.getTime()}\n`;
        for(let key in info){
            if (!info.hasOwnProperty(key)) continue;
            infoStr += `${key}: ${info[key].valueOf()}\n`;
        }
        return $bb72e68028dbdf4a$require$Buffer.from($bb72e68028dbdf4a$var$md5Hash(infoStr));
    }
    static generateRandomWordArray(bytes) {
        return $bb72e68028dbdf4a$var$randomBytes(bytes);
    }
    static create(document, options = {}) {
        if (!options.ownerPassword && !options.userPassword) return null;
        return new $bb72e68028dbdf4a$var$PDFSecurity(document, options);
    }
    constructor(document, options = {}){
        if (!options.ownerPassword && !options.userPassword) throw new Error('None of owner password and user password is defined.');
        this.document = document;
        this._setupEncryption(options);
    }
    _setupEncryption(options) {
        switch(options.pdfVersion){
            case '1.4':
            case '1.5':
                this.version = 2;
                break;
            case '1.6':
            case '1.7':
                this.version = 4;
                break;
            case '1.7ext3':
                this.version = 5;
                break;
            default:
                this.version = 1;
                break;
        }
        const encDict = {
            Filter: 'Standard'
        };
        switch(this.version){
            case 1:
            case 2:
            case 4:
                this._setupEncryptionV1V2V4(this.version, encDict, options);
                break;
            case 5:
                this._setupEncryptionV5(encDict, options);
                break;
        }
        this.dictionary = this.document.ref(encDict);
    }
    _setupEncryptionV1V2V4(v, encDict, options) {
        let r, permissions;
        switch(v){
            case 1:
                r = 2;
                this.keyBits = 40;
                permissions = $bb72e68028dbdf4a$var$getPermissionsR2(options.permissions);
                break;
            case 2:
                r = 3;
                this.keyBits = 128;
                permissions = $bb72e68028dbdf4a$var$getPermissionsR3(options.permissions);
                break;
            case 4:
                r = 4;
                this.keyBits = 128;
                permissions = $bb72e68028dbdf4a$var$getPermissionsR3(options.permissions);
                break;
        }
        const paddedUserPassword = $bb72e68028dbdf4a$var$processPasswordR2R3R4(options.userPassword);
        const paddedOwnerPassword = options.ownerPassword ? $bb72e68028dbdf4a$var$processPasswordR2R3R4(options.ownerPassword) : paddedUserPassword;
        const ownerPasswordEntry = $bb72e68028dbdf4a$var$getOwnerPasswordR2R3R4(r, this.keyBits, paddedUserPassword, paddedOwnerPassword);
        this.encryptionKey = $bb72e68028dbdf4a$var$getEncryptionKeyR2R3R4(r, this.keyBits, this.document._id, paddedUserPassword, ownerPasswordEntry, permissions);
        let userPasswordEntry;
        if (r === 2) userPasswordEntry = $bb72e68028dbdf4a$var$getUserPasswordR2(this.encryptionKey);
        else userPasswordEntry = $bb72e68028dbdf4a$var$getUserPasswordR3R4(this.document._id, this.encryptionKey);
        encDict.V = v;
        if (v >= 2) encDict.Length = this.keyBits;
        if (v === 4) {
            encDict.CF = {
                StdCF: {
                    AuthEvent: 'DocOpen',
                    CFM: 'AESV2',
                    Length: this.keyBits / 8
                }
            };
            encDict.StmF = 'StdCF';
            encDict.StrF = 'StdCF';
        }
        encDict.R = r;
        encDict.O = $bb72e68028dbdf4a$require$Buffer.from(ownerPasswordEntry);
        encDict.U = $bb72e68028dbdf4a$require$Buffer.from(userPasswordEntry);
        encDict.P = permissions;
    }
    _setupEncryptionV5(encDict, options) {
        this.keyBits = 256;
        const permissions = $bb72e68028dbdf4a$var$getPermissionsR3(options.permissions);
        const processedUserPassword = $bb72e68028dbdf4a$var$processPasswordR5(options.userPassword);
        const processedOwnerPassword = options.ownerPassword ? $bb72e68028dbdf4a$var$processPasswordR5(options.ownerPassword) : processedUserPassword;
        this.encryptionKey = $bb72e68028dbdf4a$var$getEncryptionKeyR5($bb72e68028dbdf4a$var$PDFSecurity.generateRandomWordArray);
        const userPasswordEntry = $bb72e68028dbdf4a$var$getUserPasswordR5(processedUserPassword, $bb72e68028dbdf4a$var$PDFSecurity.generateRandomWordArray);
        const userKeySalt = userPasswordEntry.slice(40, 48);
        const userEncryptionKeyEntry = $bb72e68028dbdf4a$var$getUserEncryptionKeyR5(processedUserPassword, userKeySalt, this.encryptionKey);
        const ownerPasswordEntry = $bb72e68028dbdf4a$var$getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, $bb72e68028dbdf4a$var$PDFSecurity.generateRandomWordArray);
        const ownerKeySalt = ownerPasswordEntry.slice(40, 48);
        const ownerEncryptionKeyEntry = $bb72e68028dbdf4a$var$getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, this.encryptionKey);
        const permsEntry = $bb72e68028dbdf4a$var$getEncryptedPermissionsR5(permissions, this.encryptionKey, $bb72e68028dbdf4a$var$PDFSecurity.generateRandomWordArray);
        encDict.V = 5;
        encDict.Length = this.keyBits;
        encDict.CF = {
            StdCF: {
                AuthEvent: 'DocOpen',
                CFM: 'AESV3',
                Length: this.keyBits / 8
            }
        };
        encDict.StmF = 'StdCF';
        encDict.StrF = 'StdCF';
        encDict.R = 5;
        encDict.O = $bb72e68028dbdf4a$require$Buffer.from(ownerPasswordEntry);
        encDict.OE = $bb72e68028dbdf4a$require$Buffer.from(ownerEncryptionKeyEntry);
        encDict.U = $bb72e68028dbdf4a$require$Buffer.from(userPasswordEntry);
        encDict.UE = $bb72e68028dbdf4a$require$Buffer.from(userEncryptionKeyEntry);
        encDict.P = permissions;
        encDict.Perms = $bb72e68028dbdf4a$require$Buffer.from(permsEntry);
    }
    getEncryptFn(obj, gen) {
        let digest;
        if (this.version < 5) {
            const suffix = new Uint8Array([
                obj & 0xff,
                obj >> 8 & 0xff,
                obj >> 16 & 0xff,
                gen & 0xff,
                gen >> 8 & 0xff
            ]);
            digest = (0, $3Bcdj.concatBytes)(this.encryptionKey, suffix);
        }
        if (this.version === 1 || this.version === 2) {
            let key = $bb72e68028dbdf4a$var$md5Hash(digest);
            const keyLen = Math.min(16, this.keyBits / 8 + 5);
            key = key.slice(0, keyLen);
            return (buffer)=>$bb72e68028dbdf4a$require$Buffer.from($bb72e68028dbdf4a$var$rc4(new Uint8Array(buffer), key));
        }
        let key;
        if (this.version === 4) {
            const saltMarker = new Uint8Array([
                0x73,
                0x41,
                0x6c,
                0x54
            ]);
            key = $bb72e68028dbdf4a$var$md5Hash((0, $3Bcdj.concatBytes)(digest, saltMarker));
        } else key = this.encryptionKey;
        const iv = $bb72e68028dbdf4a$var$PDFSecurity.generateRandomWordArray(16);
        return (buffer)=>{
            const encrypted = $bb72e68028dbdf4a$var$aesCbcEncrypt(new Uint8Array(buffer), key, iv, true);
            return $bb72e68028dbdf4a$require$Buffer.from((0, $3Bcdj.concatBytes)(iv, encrypted));
        };
    }
    end() {
        this.dictionary.end();
    }
}
function $bb72e68028dbdf4a$var$getPermissionsR2(permissionObject = {}) {
    let permissions = -64;
    if (permissionObject.printing) permissions |= 4;
    if (permissionObject.modifying) permissions |= 8;
    if (permissionObject.copying) permissions |= 16;
    if (permissionObject.annotating) permissions |= 32;
    return permissions;
}
function $bb72e68028dbdf4a$var$getPermissionsR3(permissionObject = {}) {
    let permissions = -3904;
    if (permissionObject.printing === 'lowResolution') permissions |= 4;
    if (permissionObject.printing === 'highResolution') permissions |= 2052;
    if (permissionObject.modifying) permissions |= 8;
    if (permissionObject.copying) permissions |= 16;
    if (permissionObject.annotating) permissions |= 32;
    if (permissionObject.fillingForms) permissions |= 256;
    if (permissionObject.contentAccessibility) permissions |= 512;
    if (permissionObject.documentAssembly) permissions |= 1024;
    return permissions;
}
function $bb72e68028dbdf4a$var$getUserPasswordR2(encryptionKey) {
    return $bb72e68028dbdf4a$var$rc4($bb72e68028dbdf4a$var$processPasswordR2R3R4(), encryptionKey);
}
function $bb72e68028dbdf4a$var$getUserPasswordR3R4(documentId, encryptionKey) {
    const key = encryptionKey.slice();
    let cipher = $bb72e68028dbdf4a$var$md5Hash((0, $3Bcdj.concatBytes)($bb72e68028dbdf4a$var$processPasswordR2R3R4(), new Uint8Array(documentId)));
    for(let i = 0; i < 20; i++){
        const xorKey = new Uint8Array(key.length);
        for(let j = 0; j < key.length; j++)xorKey[j] = encryptionKey[j] ^ i;
        cipher = $bb72e68028dbdf4a$var$rc4(cipher, xorKey);
    }
    const result = new Uint8Array(32);
    result.set(cipher);
    return result;
}
function $bb72e68028dbdf4a$var$getOwnerPasswordR2R3R4(r, keyBits, paddedUserPassword, paddedOwnerPassword) {
    let digest = paddedOwnerPassword;
    let round = r >= 3 ? 51 : 1;
    for(let i = 0; i < round; i++)digest = $bb72e68028dbdf4a$var$md5Hash(digest);
    const keyLen = keyBits / 8;
    let key = digest.slice(0, keyLen);
    let cipher = paddedUserPassword;
    round = r >= 3 ? 20 : 1;
    for(let i = 0; i < round; i++){
        const xorKey = new Uint8Array(keyLen);
        for(let j = 0; j < keyLen; j++)xorKey[j] = key[j] ^ i;
        cipher = $bb72e68028dbdf4a$var$rc4(cipher, xorKey);
    }
    return cipher;
}
function $bb72e68028dbdf4a$var$getEncryptionKeyR2R3R4(r, keyBits, documentId, paddedUserPassword, ownerPasswordEntry, permissions) {
    const permBytes = new Uint8Array([
        permissions & 0xff,
        permissions >> 8 & 0xff,
        permissions >> 16 & 0xff,
        permissions >> 24 & 0xff
    ]);
    let key = (0, $3Bcdj.concatBytes)(paddedUserPassword, ownerPasswordEntry, permBytes, new Uint8Array(documentId));
    const round = r >= 3 ? 51 : 1;
    const keyLen = keyBits / 8;
    for(let i = 0; i < round; i++){
        key = $bb72e68028dbdf4a$var$md5Hash(key);
        key = key.slice(0, keyLen);
    }
    return key;
}
function $bb72e68028dbdf4a$var$getUserPasswordR5(processedUserPassword, generateRandomWordArray) {
    const validationSalt = generateRandomWordArray(8);
    const keySalt = generateRandomWordArray(8);
    const hash = $bb72e68028dbdf4a$var$sha256Hash((0, $3Bcdj.concatBytes)(processedUserPassword, validationSalt));
    return (0, $3Bcdj.concatBytes)(hash, validationSalt, keySalt);
}
function $bb72e68028dbdf4a$var$getUserEncryptionKeyR5(processedUserPassword, userKeySalt, encryptionKey) {
    const key = $bb72e68028dbdf4a$var$sha256Hash((0, $3Bcdj.concatBytes)(processedUserPassword, userKeySalt));
    const iv = new Uint8Array(16);
    return $bb72e68028dbdf4a$var$aesCbcEncrypt(encryptionKey, key, iv, false);
}
function $bb72e68028dbdf4a$var$getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, generateRandomWordArray) {
    const validationSalt = generateRandomWordArray(8);
    const keySalt = generateRandomWordArray(8);
    const hash = $bb72e68028dbdf4a$var$sha256Hash((0, $3Bcdj.concatBytes)(processedOwnerPassword, validationSalt, userPasswordEntry));
    return (0, $3Bcdj.concatBytes)(hash, validationSalt, keySalt);
}
function $bb72e68028dbdf4a$var$getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, encryptionKey) {
    const key = $bb72e68028dbdf4a$var$sha256Hash((0, $3Bcdj.concatBytes)(processedOwnerPassword, ownerKeySalt, userPasswordEntry));
    const iv = new Uint8Array(16);
    return $bb72e68028dbdf4a$var$aesCbcEncrypt(encryptionKey, key, iv, false);
}
function $bb72e68028dbdf4a$var$getEncryptionKeyR5(generateRandomWordArray) {
    return generateRandomWordArray(32);
}
function $bb72e68028dbdf4a$var$getEncryptedPermissionsR5(permissions, encryptionKey, generateRandomWordArray) {
    const data = new Uint8Array(16);
    data[0] = permissions & 0xff;
    data[1] = permissions >> 8 & 0xff;
    data[2] = permissions >> 16 & 0xff;
    data[3] = permissions >> 24 & 0xff;
    data[4] = 0xff;
    data[5] = 0xff;
    data[6] = 0xff;
    data[7] = 0xff;
    data[8] = 0x54;
    data[9] = 0x61;
    data[10] = 0x64;
    data[11] = 0x62;
    const randomPart = generateRandomWordArray(4);
    data.set(randomPart, 12);
    return $bb72e68028dbdf4a$var$aesEcbEncrypt(data, encryptionKey);
}
function $bb72e68028dbdf4a$var$processPasswordR2R3R4(password = '') {
    const out = new Uint8Array(32);
    const length = password.length;
    let index = 0;
    while(index < length && index < 32){
        const code = password.charCodeAt(index);
        if (code > 0xff) throw new Error('Password contains one or more invalid characters.');
        out[index] = code;
        index++;
    }
    while(index < 32){
        out[index] = $bb72e68028dbdf4a$var$PASSWORD_PADDING[index - length];
        index++;
    }
    return out;
}
function $bb72e68028dbdf4a$var$processPasswordR5(password = '') {
    password = unescape(encodeURIComponent($bb72e68028dbdf4a$var$saslprep(password)));
    const length = Math.min(127, password.length);
    const out = new Uint8Array(length);
    for(let i = 0; i < length; i++)out[i] = password.charCodeAt(i);
    return out;
}
const $bb72e68028dbdf4a$var$PASSWORD_PADDING = [
    0x28,
    0xbf,
    0x4e,
    0x5e,
    0x4e,
    0x75,
    0x8a,
    0x41,
    0x64,
    0x00,
    0x4e,
    0x56,
    0xff,
    0xfa,
    0x01,
    0x08,
    0x2e,
    0x2e,
    0x00,
    0xb6,
    0xd0,
    0x68,
    0x3e,
    0x80,
    0x2f,
    0x0c,
    0xa9,
    0xfe,
    0x64,
    0x53,
    0x69,
    0x7a
];
const { number: $bb72e68028dbdf4a$var$number$2 } = $bb72e68028dbdf4a$var$PDFObject;
let $bb72e68028dbdf4a$var$PDFGradient$1 = class PDFGradient {
    constructor(doc){
        this.doc = doc;
        this.stops = [];
        this.embedded = false;
        this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    stop(pos, color, opacity) {
        if (opacity == null) opacity = 1;
        color = this.doc._normalizeColor(color);
        if (this.stops.length === 0) {
            if (color.length === 3) this._colorSpace = 'DeviceRGB';
            else if (color.length === 4) this._colorSpace = 'DeviceCMYK';
            else if (color.length === 1) this._colorSpace = 'DeviceGray';
            else throw new Error('Unknown color space');
        } else if (this._colorSpace === 'DeviceRGB' && color.length !== 3 || this._colorSpace === 'DeviceCMYK' && color.length !== 4 || this._colorSpace === 'DeviceGray' && color.length !== 1) throw new Error('All gradient stops must use the same color space');
        opacity = Math.max(0, Math.min(1, opacity));
        this.stops.push([
            pos,
            color,
            opacity
        ]);
        return this;
    }
    setTransform(m11, m12, m21, m22, dx, dy) {
        this.transform = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ];
        return this;
    }
    embed(m) {
        let fn;
        const stopsLength = this.stops.length;
        if (stopsLength === 0) return;
        this.embedded = true;
        this.matrix = m;
        const last = this.stops[stopsLength - 1];
        if (last[0] < 1) this.stops.push([
            1,
            last[1],
            last[2]
        ]);
        const bounds = [];
        const encode = [];
        const stops = [];
        for(let i = 0; i < stopsLength - 1; i++){
            encode.push(0, 1);
            if (i + 2 !== stopsLength) bounds.push(this.stops[i + 1][0]);
            fn = this.doc.ref({
                FunctionType: 2,
                Domain: [
                    0,
                    1
                ],
                C0: this.stops[i + 0][1],
                C1: this.stops[i + 1][1],
                N: 1
            });
            stops.push(fn);
            fn.end();
        }
        if (stopsLength === 1) fn = stops[0];
        else {
            fn = this.doc.ref({
                FunctionType: 3,
                Domain: [
                    0,
                    1
                ],
                Functions: stops,
                Bounds: bounds,
                Encode: encode
            });
            fn.end();
        }
        this.id = `Sh${++this.doc._gradCount}`;
        const shader = this.shader(fn);
        shader.end();
        const pattern = this.doc.ref({
            Type: 'Pattern',
            PatternType: 2,
            Shading: shader,
            Matrix: this.matrix.map($bb72e68028dbdf4a$var$number$2)
        });
        pattern.end();
        if (this.stops.some((stop)=>stop[2] < 1)) {
            let grad = this.opacityGradient();
            grad._colorSpace = 'DeviceGray';
            for (let stop of this.stops)grad.stop(stop[0], [
                stop[2]
            ]);
            grad = grad.embed(this.matrix);
            const pageBBox = [
                0,
                0,
                this.doc.page.width,
                this.doc.page.height
            ];
            const form = this.doc.ref({
                Type: 'XObject',
                Subtype: 'Form',
                FormType: 1,
                BBox: pageBBox,
                Group: {
                    Type: 'Group',
                    S: 'Transparency',
                    CS: 'DeviceGray'
                },
                Resources: {
                    ProcSet: [
                        'PDF',
                        'Text',
                        'ImageB',
                        'ImageC',
                        'ImageI'
                    ],
                    Pattern: {
                        Sh1: grad
                    }
                }
            });
            form.write('/Pattern cs /Sh1 scn');
            form.end(`${pageBBox.join(' ')} re f`);
            const gstate = this.doc.ref({
                Type: 'ExtGState',
                SMask: {
                    Type: 'Mask',
                    S: 'Luminosity',
                    G: form
                }
            });
            gstate.end();
            const opacityPattern = this.doc.ref({
                Type: 'Pattern',
                PatternType: 1,
                PaintType: 1,
                TilingType: 2,
                BBox: pageBBox,
                XStep: pageBBox[2],
                YStep: pageBBox[3],
                Resources: {
                    ProcSet: [
                        'PDF',
                        'Text',
                        'ImageB',
                        'ImageC',
                        'ImageI'
                    ],
                    Pattern: {
                        Sh1: pattern
                    },
                    ExtGState: {
                        Gs1: gstate
                    }
                }
            });
            opacityPattern.write('/Gs1 gs /Pattern cs /Sh1 scn');
            opacityPattern.end(`${pageBBox.join(' ')} re f`);
            this.doc.page.patterns[this.id] = opacityPattern;
        } else this.doc.page.patterns[this.id] = pattern;
        return pattern;
    }
    apply(stroke) {
        const [m0, m1, m2, m3, m4, m5] = this.doc._ctm;
        const [m11, m12, m21, m22, dx, dy] = this.transform;
        const m = [
            m0 * m11 + m2 * m12,
            m1 * m11 + m3 * m12,
            m0 * m21 + m2 * m22,
            m1 * m21 + m3 * m22,
            m0 * dx + m2 * dy + m4,
            m1 * dx + m3 * dy + m5
        ];
        if (!this.embedded || m.join(' ') !== this.matrix.join(' ')) this.embed(m);
        this.doc._setColorSpace('Pattern', stroke);
        const op = stroke ? 'SCN' : 'scn';
        return this.doc.addContent(`/${this.id} ${op}`);
    }
};
let $bb72e68028dbdf4a$var$PDFLinearGradient$1 = class PDFLinearGradient extends $bb72e68028dbdf4a$var$PDFGradient$1 {
    constructor(doc, x1, y1, x2, y2){
        super(doc);
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    shader(fn) {
        return this.doc.ref({
            ShadingType: 2,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.x2,
                this.y2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    }
    opacityGradient() {
        return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
    }
};
let $bb72e68028dbdf4a$var$PDFRadialGradient$1 = class PDFRadialGradient extends $bb72e68028dbdf4a$var$PDFGradient$1 {
    constructor(doc, x1, y1, r1, x2, y2, r2){
        super(doc);
        this.doc = doc;
        this.x1 = x1;
        this.y1 = y1;
        this.r1 = r1;
        this.x2 = x2;
        this.y2 = y2;
        this.r2 = r2;
    }
    shader(fn) {
        return this.doc.ref({
            ShadingType: 3,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.r1,
                this.x2,
                this.y2,
                this.r2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    }
    opacityGradient() {
        return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
    }
};
var $bb72e68028dbdf4a$var$Gradient = {
    PDFGradient: $bb72e68028dbdf4a$var$PDFGradient$1,
    PDFLinearGradient: $bb72e68028dbdf4a$var$PDFLinearGradient$1,
    PDFRadialGradient: $bb72e68028dbdf4a$var$PDFRadialGradient$1
};
const $bb72e68028dbdf4a$var$underlyingColorSpaces = [
    'DeviceCMYK',
    'DeviceRGB'
];
let $bb72e68028dbdf4a$var$PDFTilingPattern$1 = class PDFTilingPattern {
    constructor(doc, bBox, xStep, yStep, stream){
        this.doc = doc;
        this.bBox = bBox;
        this.xStep = xStep;
        this.yStep = yStep;
        this.stream = stream;
    }
    createPattern() {
        const resources = this.doc.ref();
        resources.end();
        const [m0, m1, m2, m3, m4, m5] = this.doc._ctm;
        const [m11, m12, m21, m22, dx, dy] = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        const m = [
            m0 * m11 + m2 * m12,
            m1 * m11 + m3 * m12,
            m0 * m21 + m2 * m22,
            m1 * m21 + m3 * m22,
            m0 * dx + m2 * dy + m4,
            m1 * dx + m3 * dy + m5
        ];
        const pattern = this.doc.ref({
            Type: 'Pattern',
            PatternType: 1,
            PaintType: 2,
            TilingType: 2,
            BBox: this.bBox,
            XStep: this.xStep,
            YStep: this.yStep,
            Matrix: m.map((v)=>+v.toFixed(5)),
            Resources: resources
        });
        pattern.end(this.stream);
        return pattern;
    }
    embedPatternColorSpaces() {
        $bb72e68028dbdf4a$var$underlyingColorSpaces.forEach((csName)=>{
            const csId = this.getPatternColorSpaceId(csName);
            if (this.doc.page.colorSpaces[csId]) return;
            const cs = this.doc.ref([
                'Pattern',
                csName
            ]);
            cs.end();
            this.doc.page.colorSpaces[csId] = cs;
        });
    }
    getPatternColorSpaceId(underlyingColorspace) {
        return `CsP${underlyingColorspace}`;
    }
    embed() {
        if (!this.id) {
            this.doc._patternCount = this.doc._patternCount + 1;
            this.id = 'P' + this.doc._patternCount;
            this.pattern = this.createPattern();
        }
        if (!this.doc.page.patterns[this.id]) this.doc.page.patterns[this.id] = this.pattern;
    }
    apply(stroke, patternColor) {
        this.embedPatternColorSpaces();
        this.embed();
        const normalizedColor = this.doc._normalizeColor(patternColor);
        if (!normalizedColor) throw Error(`invalid pattern color. (value: ${patternColor})`);
        const csId = this.getPatternColorSpaceId(this.doc._getColorSpace(normalizedColor));
        this.doc._setColorSpace(csId, stroke);
        const op = stroke ? 'SCN' : 'scn';
        return this.doc.addContent(`${normalizedColor.join(' ')} /${this.id} ${op}`);
    }
};
var $bb72e68028dbdf4a$var$pattern = {
    PDFTilingPattern: $bb72e68028dbdf4a$var$PDFTilingPattern$1
};
const { PDFGradient: $bb72e68028dbdf4a$var$PDFGradient, PDFLinearGradient: $bb72e68028dbdf4a$var$PDFLinearGradient, PDFRadialGradient: $bb72e68028dbdf4a$var$PDFRadialGradient } = $bb72e68028dbdf4a$var$Gradient;
const { PDFTilingPattern: $bb72e68028dbdf4a$var$PDFTilingPattern } = $bb72e68028dbdf4a$var$pattern;
var $bb72e68028dbdf4a$var$ColorMixin = {
    initColor () {
        this.spotColors = {};
        this._opacityRegistry = {};
        this._opacityCount = 0;
        this._patternCount = 0;
        this._gradCount = 0;
    },
    _normalizeColor (color) {
        if (typeof color === 'string') {
            if (color.charAt(0) === '#') {
                if (color.length === 4) color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, '#$1$1$2$2$3$3');
                const hex = parseInt(color.slice(1), 16);
                color = [
                    hex >> 16,
                    hex >> 8 & 0xff,
                    hex & 0xff
                ];
            } else if ($bb72e68028dbdf4a$var$namedColors[color]) color = $bb72e68028dbdf4a$var$namedColors[color];
            else if (this.spotColors[color]) return this.spotColors[color];
        }
        if (Array.isArray(color)) {
            if (color.length === 3) color = color.map((part)=>part / 255);
            else if (color.length === 4) color = color.map((part)=>part / 100);
            return color;
        }
        return null;
    },
    _setColor (color, stroke) {
        if (color instanceof $bb72e68028dbdf4a$var$PDFGradient) {
            color.apply(stroke);
            return true;
        } else if (Array.isArray(color) && color[0] instanceof $bb72e68028dbdf4a$var$PDFTilingPattern) {
            color[0].apply(stroke, color[1]);
            return true;
        }
        return this._setColorCore(color, stroke);
    },
    _setColorCore (color, stroke) {
        color = this._normalizeColor(color);
        if (!color) return false;
        const op = stroke ? 'SCN' : 'scn';
        const space = this._getColorSpace(color);
        this._setColorSpace(space, stroke);
        if (color instanceof $bb72e68028dbdf4a$var$SpotColor) {
            this.page.colorSpaces[color.id] = color.ref;
            this.addContent(`1 ${op}`);
        } else this.addContent(`${color.join(' ')} ${op}`);
        return true;
    },
    _setColorSpace (space, stroke) {
        const op = stroke ? 'CS' : 'cs';
        return this.addContent(`/${space} ${op}`);
    },
    _getColorSpace (color) {
        if (color instanceof $bb72e68028dbdf4a$var$SpotColor) return color.id;
        return color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
    },
    fillColor (color, opacity) {
        const set = this._setColor(color, false);
        if (set) this.fillOpacity(opacity);
        this._fillColor = [
            color,
            opacity
        ];
        return this;
    },
    strokeColor (color, opacity) {
        const set = this._setColor(color, true);
        if (set) this.strokeOpacity(opacity);
        return this;
    },
    opacity (opacity) {
        this._doOpacity(opacity, opacity);
        return this;
    },
    fillOpacity (opacity) {
        this._doOpacity(opacity, null);
        return this;
    },
    strokeOpacity (opacity) {
        this._doOpacity(null, opacity);
        return this;
    },
    _doOpacity (fillOpacity, strokeOpacity) {
        let dictionary, name;
        if (fillOpacity == null && strokeOpacity == null) return;
        if (fillOpacity != null) fillOpacity = Math.max(0, Math.min(1, fillOpacity));
        if (strokeOpacity != null) strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
        const key = `${fillOpacity}_${strokeOpacity}`;
        if (this._opacityRegistry[key]) [dictionary, name] = this._opacityRegistry[key];
        else {
            dictionary = {
                Type: 'ExtGState'
            };
            if (fillOpacity != null) dictionary.ca = fillOpacity;
            if (strokeOpacity != null) dictionary.CA = strokeOpacity;
            dictionary = this.ref(dictionary);
            dictionary.end();
            const id = ++this._opacityCount;
            name = `Gs${id}`;
            this._opacityRegistry[key] = [
                dictionary,
                name
            ];
        }
        this.page.ext_gstates[name] = dictionary;
        return this.addContent(`/${name} gs`);
    },
    linearGradient (x1, y1, x2, y2) {
        return new $bb72e68028dbdf4a$var$PDFLinearGradient(this, x1, y1, x2, y2);
    },
    radialGradient (x1, y1, r1, x2, y2, r2) {
        return new $bb72e68028dbdf4a$var$PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
    },
    pattern (bbox, xStep, yStep, stream) {
        return new $bb72e68028dbdf4a$var$PDFTilingPattern(this, bbox, xStep, yStep, stream);
    },
    addSpotColor (name, C, M, Y, K) {
        const color = new $bb72e68028dbdf4a$var$SpotColor(this, name, C, M, Y, K);
        this.spotColors[name] = color;
        return this;
    }
};
var $bb72e68028dbdf4a$var$namedColors = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
let $bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy, $bb72e68028dbdf4a$var$px, $bb72e68028dbdf4a$var$py, $bb72e68028dbdf4a$var$sx, $bb72e68028dbdf4a$var$sy;
$bb72e68028dbdf4a$var$cx = $bb72e68028dbdf4a$var$cy = $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$sx = $bb72e68028dbdf4a$var$sy = 0;
const $bb72e68028dbdf4a$var$parameters = {
    A: 7,
    a: 7,
    C: 6,
    c: 6,
    H: 1,
    h: 1,
    L: 2,
    l: 2,
    M: 2,
    m: 2,
    Q: 4,
    q: 4,
    S: 4,
    s: 4,
    T: 2,
    t: 2,
    V: 1,
    v: 1,
    Z: 0,
    z: 0
};
const $bb72e68028dbdf4a$var$isCommand = function(c) {
    return c in $bb72e68028dbdf4a$var$parameters;
};
const $bb72e68028dbdf4a$var$isWsp = function(c) {
    const codePoint = c.codePointAt(0);
    return codePoint === 0x20 || codePoint === 0x9 || codePoint === 0xd || codePoint === 0xa;
};
const $bb72e68028dbdf4a$var$isDigit = function(c) {
    const codePoint = c.codePointAt(0);
    if (codePoint == null) return false;
    return 48 <= codePoint && codePoint <= 57;
};
const $bb72e68028dbdf4a$var$readNumber = function(string, cursor) {
    let i = cursor;
    let value = '';
    let state = 'none';
    for(; i < string.length; i += 1){
        const c = string[i];
        if (c === '+' || c === '-') {
            if (state === 'none') {
                state = 'sign';
                value += c;
                continue;
            }
            if (state === 'e') {
                state = 'exponent_sign';
                value += c;
                continue;
            }
        }
        if ($bb72e68028dbdf4a$var$isDigit(c)) {
            if (state === 'none' || state === 'sign' || state === 'whole') {
                state = 'whole';
                value += c;
                continue;
            }
            if (state === 'decimal_point' || state === 'decimal') {
                state = 'decimal';
                value += c;
                continue;
            }
            if (state === 'e' || state === 'exponent_sign' || state === 'exponent') {
                state = 'exponent';
                value += c;
                continue;
            }
        }
        if (c === '.') {
            if (state === 'none' || state === 'sign' || state === 'whole') {
                state = 'decimal_point';
                value += c;
                continue;
            }
        }
        if (c === 'E' || c === 'e') {
            if (state === 'whole' || state === 'decimal_point' || state === 'decimal') {
                state = 'e';
                value += c;
                continue;
            }
        }
        break;
    }
    const number = Number.parseFloat(value);
    if (Number.isNaN(number)) return [
        cursor,
        null
    ];
    return [
        i - 1,
        number
    ];
};
const $bb72e68028dbdf4a$var$parse = function(path) {
    const pathData = [];
    let command = null;
    let args = [];
    let argsCount = 0;
    let canHaveComma = false;
    let hadComma = false;
    for(let i = 0; i < path.length; i += 1){
        const c = path.charAt(i);
        if ($bb72e68028dbdf4a$var$isWsp(c)) continue;
        if (canHaveComma && c === ',') {
            if (hadComma) break;
            hadComma = true;
            continue;
        }
        if ($bb72e68028dbdf4a$var$isCommand(c)) {
            if (hadComma) return pathData;
            if (command == null) {
                if (c !== 'M' && c !== 'm') return pathData;
            } else {
                if (args.length !== 0) return pathData;
            }
            command = c;
            args = [];
            argsCount = $bb72e68028dbdf4a$var$parameters[command];
            canHaveComma = false;
            if (argsCount === 0) pathData.push({
                command: command,
                args: args
            });
            continue;
        }
        if (command == null) return pathData;
        let newCursor = i;
        let number = null;
        if (command === 'A' || command === 'a') {
            const position = args.length;
            if (position === 0 || position === 1) {
                if (c !== '+' && c !== '-') [newCursor, number] = $bb72e68028dbdf4a$var$readNumber(path, i);
            }
            if (position === 2 || position === 5 || position === 6) [newCursor, number] = $bb72e68028dbdf4a$var$readNumber(path, i);
            if (position === 3 || position === 4) {
                if (c === '0') number = 0;
                if (c === '1') number = 1;
            }
        } else [newCursor, number] = $bb72e68028dbdf4a$var$readNumber(path, i);
        if (number == null) return pathData;
        args.push(number);
        canHaveComma = true;
        hadComma = false;
        i = newCursor;
        if (args.length === argsCount) {
            pathData.push({
                command: command,
                args: args
            });
            if (command === 'M') command = 'L';
            if (command === 'm') command = 'l';
            args = [];
        }
    }
    return pathData;
};
const $bb72e68028dbdf4a$var$apply = function(commands, doc) {
    $bb72e68028dbdf4a$var$cx = $bb72e68028dbdf4a$var$cy = $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$sx = $bb72e68028dbdf4a$var$sy = 0;
    for(let i = 0; i < commands.length; i++){
        const c = commands[i];
        if (typeof $bb72e68028dbdf4a$var$runners[c.command] === 'function') $bb72e68028dbdf4a$var$runners[c.command](doc, c.args);
    }
};
const $bb72e68028dbdf4a$var$runners = {
    M (doc, a) {
        $bb72e68028dbdf4a$var$cx = a[0];
        $bb72e68028dbdf4a$var$cy = a[1];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        $bb72e68028dbdf4a$var$sx = $bb72e68028dbdf4a$var$cx;
        $bb72e68028dbdf4a$var$sy = $bb72e68028dbdf4a$var$cy;
        return doc.moveTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    m (doc, a) {
        $bb72e68028dbdf4a$var$cx += a[0];
        $bb72e68028dbdf4a$var$cy += a[1];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        $bb72e68028dbdf4a$var$sx = $bb72e68028dbdf4a$var$cx;
        $bb72e68028dbdf4a$var$sy = $bb72e68028dbdf4a$var$cy;
        return doc.moveTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    C (doc, a) {
        $bb72e68028dbdf4a$var$cx = a[4];
        $bb72e68028dbdf4a$var$cy = a[5];
        $bb72e68028dbdf4a$var$px = a[2];
        $bb72e68028dbdf4a$var$py = a[3];
        return doc.bezierCurveTo(...a);
    },
    c (doc, a) {
        doc.bezierCurveTo(a[0] + $bb72e68028dbdf4a$var$cx, a[1] + $bb72e68028dbdf4a$var$cy, a[2] + $bb72e68028dbdf4a$var$cx, a[3] + $bb72e68028dbdf4a$var$cy, a[4] + $bb72e68028dbdf4a$var$cx, a[5] + $bb72e68028dbdf4a$var$cy);
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx + a[2];
        $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy + a[3];
        $bb72e68028dbdf4a$var$cx += a[4];
        return $bb72e68028dbdf4a$var$cy += a[5];
    },
    S (doc, a) {
        if ($bb72e68028dbdf4a$var$px === null) {
            $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx;
            $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy;
        }
        doc.bezierCurveTo($bb72e68028dbdf4a$var$cx - ($bb72e68028dbdf4a$var$px - $bb72e68028dbdf4a$var$cx), $bb72e68028dbdf4a$var$cy - ($bb72e68028dbdf4a$var$py - $bb72e68028dbdf4a$var$cy), a[0], a[1], a[2], a[3]);
        $bb72e68028dbdf4a$var$px = a[0];
        $bb72e68028dbdf4a$var$py = a[1];
        $bb72e68028dbdf4a$var$cx = a[2];
        return $bb72e68028dbdf4a$var$cy = a[3];
    },
    s (doc, a) {
        if ($bb72e68028dbdf4a$var$px === null) {
            $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx;
            $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy;
        }
        doc.bezierCurveTo($bb72e68028dbdf4a$var$cx - ($bb72e68028dbdf4a$var$px - $bb72e68028dbdf4a$var$cx), $bb72e68028dbdf4a$var$cy - ($bb72e68028dbdf4a$var$py - $bb72e68028dbdf4a$var$cy), $bb72e68028dbdf4a$var$cx + a[0], $bb72e68028dbdf4a$var$cy + a[1], $bb72e68028dbdf4a$var$cx + a[2], $bb72e68028dbdf4a$var$cy + a[3]);
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx + a[0];
        $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy + a[1];
        $bb72e68028dbdf4a$var$cx += a[2];
        return $bb72e68028dbdf4a$var$cy += a[3];
    },
    Q (doc, a) {
        $bb72e68028dbdf4a$var$px = a[0];
        $bb72e68028dbdf4a$var$py = a[1];
        $bb72e68028dbdf4a$var$cx = a[2];
        $bb72e68028dbdf4a$var$cy = a[3];
        return doc.quadraticCurveTo(a[0], a[1], $bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    q (doc, a) {
        doc.quadraticCurveTo(a[0] + $bb72e68028dbdf4a$var$cx, a[1] + $bb72e68028dbdf4a$var$cy, a[2] + $bb72e68028dbdf4a$var$cx, a[3] + $bb72e68028dbdf4a$var$cy);
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx + a[0];
        $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy + a[1];
        $bb72e68028dbdf4a$var$cx += a[2];
        return $bb72e68028dbdf4a$var$cy += a[3];
    },
    T (doc, a) {
        if ($bb72e68028dbdf4a$var$px === null) {
            $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx;
            $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy;
        } else {
            $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx - ($bb72e68028dbdf4a$var$px - $bb72e68028dbdf4a$var$cx);
            $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy - ($bb72e68028dbdf4a$var$py - $bb72e68028dbdf4a$var$cy);
        }
        doc.quadraticCurveTo($bb72e68028dbdf4a$var$px, $bb72e68028dbdf4a$var$py, a[0], a[1]);
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx - ($bb72e68028dbdf4a$var$px - $bb72e68028dbdf4a$var$cx);
        $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy - ($bb72e68028dbdf4a$var$py - $bb72e68028dbdf4a$var$cy);
        $bb72e68028dbdf4a$var$cx = a[0];
        return $bb72e68028dbdf4a$var$cy = a[1];
    },
    t (doc, a) {
        if ($bb72e68028dbdf4a$var$px === null) {
            $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx;
            $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy;
        } else {
            $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$cx - ($bb72e68028dbdf4a$var$px - $bb72e68028dbdf4a$var$cx);
            $bb72e68028dbdf4a$var$py = $bb72e68028dbdf4a$var$cy - ($bb72e68028dbdf4a$var$py - $bb72e68028dbdf4a$var$cy);
        }
        doc.quadraticCurveTo($bb72e68028dbdf4a$var$px, $bb72e68028dbdf4a$var$py, $bb72e68028dbdf4a$var$cx + a[0], $bb72e68028dbdf4a$var$cy + a[1]);
        $bb72e68028dbdf4a$var$cx += a[0];
        return $bb72e68028dbdf4a$var$cy += a[1];
    },
    A (doc, a) {
        $bb72e68028dbdf4a$var$solveArc(doc, $bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy, a);
        $bb72e68028dbdf4a$var$cx = a[5];
        return $bb72e68028dbdf4a$var$cy = a[6];
    },
    a (doc, a) {
        a[5] += $bb72e68028dbdf4a$var$cx;
        a[6] += $bb72e68028dbdf4a$var$cy;
        $bb72e68028dbdf4a$var$solveArc(doc, $bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy, a);
        $bb72e68028dbdf4a$var$cx = a[5];
        return $bb72e68028dbdf4a$var$cy = a[6];
    },
    L (doc, a) {
        $bb72e68028dbdf4a$var$cx = a[0];
        $bb72e68028dbdf4a$var$cy = a[1];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        return doc.lineTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    l (doc, a) {
        $bb72e68028dbdf4a$var$cx += a[0];
        $bb72e68028dbdf4a$var$cy += a[1];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        return doc.lineTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    H (doc, a) {
        $bb72e68028dbdf4a$var$cx = a[0];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        return doc.lineTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    h (doc, a) {
        $bb72e68028dbdf4a$var$cx += a[0];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        return doc.lineTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    V (doc, a) {
        $bb72e68028dbdf4a$var$cy = a[0];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        return doc.lineTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    v (doc, a) {
        $bb72e68028dbdf4a$var$cy += a[0];
        $bb72e68028dbdf4a$var$px = $bb72e68028dbdf4a$var$py = null;
        return doc.lineTo($bb72e68028dbdf4a$var$cx, $bb72e68028dbdf4a$var$cy);
    },
    Z (doc) {
        doc.closePath();
        $bb72e68028dbdf4a$var$cx = $bb72e68028dbdf4a$var$sx;
        return $bb72e68028dbdf4a$var$cy = $bb72e68028dbdf4a$var$sy;
    },
    z (doc) {
        doc.closePath();
        $bb72e68028dbdf4a$var$cx = $bb72e68028dbdf4a$var$sx;
        return $bb72e68028dbdf4a$var$cy = $bb72e68028dbdf4a$var$sy;
    }
};
const $bb72e68028dbdf4a$var$solveArc = function(doc, x, y, coords) {
    const [rx, ry, rot, large, sweep, ex, ey] = coords;
    const segs = $bb72e68028dbdf4a$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    for (let seg of segs){
        const bez = $bb72e68028dbdf4a$var$segmentToBezier(...seg);
        doc.bezierCurveTo(...bez);
    }
};
const $bb72e68028dbdf4a$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    const th = rotateX * (Math.PI / 180);
    const sin_th = Math.sin(th);
    const cos_th = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $bb72e68028dbdf4a$var$px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
    $bb72e68028dbdf4a$var$py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
    let pl = $bb72e68028dbdf4a$var$px * $bb72e68028dbdf4a$var$px / (rx * rx) + $bb72e68028dbdf4a$var$py * $bb72e68028dbdf4a$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    const a00 = cos_th / rx;
    const a01 = sin_th / rx;
    const a10 = -sin_th / ry;
    const a11 = cos_th / ry;
    const x0 = a00 * ox + a01 * oy;
    const y0 = a10 * ox + a11 * oy;
    const x1 = a00 * x + a01 * y;
    const y1 = a10 * x + a11 * y;
    const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    let sfactor_sq = 1 / d - 0.25;
    if (sfactor_sq < 0) sfactor_sq = 0;
    let sfactor = Math.sqrt(sfactor_sq);
    if (sweep === large) sfactor = -sfactor;
    const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    const th0 = Math.atan2(y0 - yc, x0 - xc);
    const th1 = Math.atan2(y1 - yc, x1 - xc);
    let th_arc = th1 - th0;
    if (th_arc < 0 && sweep === 1) th_arc += 2 * Math.PI;
    else if (th_arc > 0 && sweep === 0) th_arc -= 2 * Math.PI;
    const segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
    const result = [];
    for(let i = 0; i < segments; i++){
        const th2 = th0 + i * th_arc / segments;
        const th3 = th0 + (i + 1) * th_arc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sin_th,
            cos_th
        ];
    }
    return result;
};
const $bb72e68028dbdf4a$var$segmentToBezier = function(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
    const a00 = cos_th * rx;
    const a01 = -sin_th * ry;
    const a10 = sin_th * rx;
    const a11 = cos_th * ry;
    const th_half = 0.5 * (th1 - th0);
    const t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
    const x1 = cx + Math.cos(th0) - t * Math.sin(th0);
    const y1 = cy + Math.sin(th0) + t * Math.cos(th0);
    const x3 = cx + Math.cos(th1);
    const y3 = cy + Math.sin(th1);
    const x2 = x3 + t * Math.sin(th1);
    const y2 = y3 - t * Math.cos(th1);
    return [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
};
class $bb72e68028dbdf4a$var$SVGPath {
    static apply(doc, path) {
        const commands = $bb72e68028dbdf4a$var$parse(path);
        $bb72e68028dbdf4a$var$apply(commands, doc);
    }
}
const { number: $bb72e68028dbdf4a$var$number$1 } = $bb72e68028dbdf4a$var$PDFObject;
const $bb72e68028dbdf4a$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $bb72e68028dbdf4a$var$VectorMixin = {
    initVector () {
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        this._ctmStack = [];
    },
    save () {
        this._ctmStack.push(this._ctm.slice());
        return this.addContent('q');
    },
    restore () {
        this._ctm = this._ctmStack.pop() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        return this.addContent('Q');
    },
    closePath () {
        return this.addContent('h');
    },
    lineWidth (w) {
        return this.addContent(`${$bb72e68028dbdf4a$var$number$1(w)} w`);
    },
    _CAP_STYLES: {
        BUTT: 0,
        ROUND: 1,
        SQUARE: 2
    },
    lineCap (c) {
        if (typeof c === 'string') c = this._CAP_STYLES[c.toUpperCase()];
        return this.addContent(`${c} J`);
    },
    _JOIN_STYLES: {
        MITER: 0,
        ROUND: 1,
        BEVEL: 2
    },
    lineJoin (j) {
        if (typeof j === 'string') j = this._JOIN_STYLES[j.toUpperCase()];
        return this.addContent(`${j} j`);
    },
    miterLimit (m) {
        return this.addContent(`${$bb72e68028dbdf4a$var$number$1(m)} M`);
    },
    dash (length, options = {}) {
        const originalLength = length;
        if (!Array.isArray(length)) length = [
            length,
            options.space || length
        ];
        const valid = length.every((x)=>Number.isFinite(x) && x > 0);
        if (!valid) throw new Error(`dash(${JSON.stringify(originalLength)}, ${JSON.stringify(options)}) invalid, lengths must be numeric and greater than zero`);
        length = length.map($bb72e68028dbdf4a$var$number$1).join(' ');
        return this.addContent(`[${length}] ${$bb72e68028dbdf4a$var$number$1(options.phase || 0)} d`);
    },
    undash () {
        return this.addContent('[] 0 d');
    },
    moveTo (x, y) {
        return this.addContent(`${$bb72e68028dbdf4a$var$number$1(x)} ${$bb72e68028dbdf4a$var$number$1(y)} m`);
    },
    lineTo (x, y) {
        return this.addContent(`${$bb72e68028dbdf4a$var$number$1(x)} ${$bb72e68028dbdf4a$var$number$1(y)} l`);
    },
    bezierCurveTo (cp1x, cp1y, cp2x, cp2y, x, y) {
        return this.addContent(`${$bb72e68028dbdf4a$var$number$1(cp1x)} ${$bb72e68028dbdf4a$var$number$1(cp1y)} ${$bb72e68028dbdf4a$var$number$1(cp2x)} ${$bb72e68028dbdf4a$var$number$1(cp2y)} ${$bb72e68028dbdf4a$var$number$1(x)} ${$bb72e68028dbdf4a$var$number$1(y)} c`);
    },
    quadraticCurveTo (cpx, cpy, x, y) {
        return this.addContent(`${$bb72e68028dbdf4a$var$number$1(cpx)} ${$bb72e68028dbdf4a$var$number$1(cpy)} ${$bb72e68028dbdf4a$var$number$1(x)} ${$bb72e68028dbdf4a$var$number$1(y)} v`);
    },
    rect (x, y, w, h) {
        return this.addContent(`${$bb72e68028dbdf4a$var$number$1(x)} ${$bb72e68028dbdf4a$var$number$1(y)} ${$bb72e68028dbdf4a$var$number$1(w)} ${$bb72e68028dbdf4a$var$number$1(h)} re`);
    },
    roundedRect (x, y, w, h, borderRadius) {
        if (borderRadius == null) borderRadius = 0;
        let radii;
        if (Array.isArray(borderRadius)) radii = borderRadius.slice(0, 4);
        else radii = [
            borderRadius,
            borderRadius,
            borderRadius,
            borderRadius
        ];
        const limit = Math.min(0.5 * w, 0.5 * h);
        const rTL = Math.max(0, Math.min(radii[0] || 0, limit));
        const rTR = Math.max(0, Math.min(radii[1] || 0, limit));
        const rBR = Math.max(0, Math.min(radii[2] || 0, limit));
        const rBL = Math.max(0, Math.min(radii[3] || 0, limit));
        const cpTR = rTR * (1.0 - $bb72e68028dbdf4a$var$KAPPA);
        const cpBR = rBR * (1.0 - $bb72e68028dbdf4a$var$KAPPA);
        const cpBL = rBL * (1.0 - $bb72e68028dbdf4a$var$KAPPA);
        const cpTL = rTL * (1.0 - $bb72e68028dbdf4a$var$KAPPA);
        this.moveTo(x + rTL, y);
        this.lineTo(x + w - rTR, y);
        if (rTR > 0) this.bezierCurveTo(x + w - cpTR, y, x + w, y + cpTR, x + w, y + rTR);
        this.lineTo(x + w, y + h - rBR);
        if (rBR > 0) this.bezierCurveTo(x + w, y + h - cpBR, x + w - cpBR, y + h, x + w - rBR, y + h);
        this.lineTo(x + rBL, y + h);
        if (rBL > 0) this.bezierCurveTo(x + cpBL, y + h, x, y + h - cpBL, x, y + h - rBL);
        this.lineTo(x, y + rTL);
        if (rTL > 0) this.bezierCurveTo(x, y + cpTL, x + cpTL, y, x + rTL, y);
        return this.closePath();
    },
    ellipse (x, y, r1, r2) {
        if (r2 == null) r2 = r1;
        x -= r1;
        y -= r2;
        const ox = r1 * $bb72e68028dbdf4a$var$KAPPA;
        const oy = r2 * $bb72e68028dbdf4a$var$KAPPA;
        const xe = x + r1 * 2;
        const ye = y + r2 * 2;
        const xm = x + r1;
        const ym = y + r2;
        this.moveTo(x, ym);
        this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        return this.closePath();
    },
    circle (x, y, radius) {
        return this.ellipse(x, y, radius);
    },
    arc (x, y, radius, startAngle, endAngle, anticlockwise) {
        if (anticlockwise == null) anticlockwise = false;
        const TWO_PI = 2.0 * Math.PI;
        const HALF_PI = 0.5 * Math.PI;
        let deltaAng = endAngle - startAngle;
        if (Math.abs(deltaAng) > TWO_PI) deltaAng = TWO_PI;
        else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
            const dir = anticlockwise ? -1 : 1;
            deltaAng = dir * TWO_PI + deltaAng;
        }
        const numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
        const segAng = deltaAng / numSegs;
        const handleLen = segAng / HALF_PI * $bb72e68028dbdf4a$var$KAPPA * radius;
        let curAng = startAngle;
        let deltaCx = -Math.sin(curAng) * handleLen;
        let deltaCy = Math.cos(curAng) * handleLen;
        let ax = x + Math.cos(curAng) * radius;
        let ay = y + Math.sin(curAng) * radius;
        this.moveTo(ax, ay);
        for(let segIdx = 0; segIdx < numSegs; segIdx++){
            const cp1x = ax + deltaCx;
            const cp1y = ay + deltaCy;
            curAng += segAng;
            ax = x + Math.cos(curAng) * radius;
            ay = y + Math.sin(curAng) * radius;
            deltaCx = -Math.sin(curAng) * handleLen;
            deltaCy = Math.cos(curAng) * handleLen;
            const cp2x = ax - deltaCx;
            const cp2y = ay - deltaCy;
            this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
        }
        return this;
    },
    polygon (...points) {
        this.moveTo(...points.shift() || []);
        for (let point of points)this.lineTo(...point || []);
        return this.closePath();
    },
    path (path) {
        $bb72e68028dbdf4a$var$SVGPath.apply(this, path);
        return this;
    },
    _windingRule (rule) {
        if (/even-?odd/.test(rule)) return '*';
        return '';
    },
    fill (color, rule) {
        if (/(even-?odd)|(non-?zero)/.test(color)) {
            rule = color;
            color = null;
        }
        if (color) this.fillColor(color);
        return this.addContent(`f${this._windingRule(rule)}`);
    },
    stroke (color) {
        if (color) this.strokeColor(color);
        return this.addContent('S');
    },
    fillAndStroke (fillColor, strokeColor, rule) {
        if (strokeColor == null) strokeColor = fillColor;
        const isFillRule = /(even-?odd)|(non-?zero)/;
        if (isFillRule.test(fillColor)) {
            rule = fillColor;
            fillColor = null;
        }
        if (isFillRule.test(strokeColor)) {
            rule = strokeColor;
            strokeColor = fillColor;
        }
        if (fillColor) {
            this.fillColor(fillColor);
            this.strokeColor(strokeColor);
        }
        return this.addContent(`B${this._windingRule(rule)}`);
    },
    clip (rule) {
        return this.addContent(`W${this._windingRule(rule)} n`);
    },
    transform (m11, m12, m21, m22, dx, dy) {
        if (m11 === 1 && m12 === 0 && m21 === 0 && m22 === 1 && dx === 0 && dy === 0) return this;
        const m = this._ctm;
        const [m0, m1, m2, m3, m4, m5] = m;
        m[0] = m0 * m11 + m2 * m12;
        m[1] = m1 * m11 + m3 * m12;
        m[2] = m0 * m21 + m2 * m22;
        m[3] = m1 * m21 + m3 * m22;
        m[4] = m0 * dx + m2 * dy + m4;
        m[5] = m1 * dx + m3 * dy + m5;
        const values = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ].map((v)=>$bb72e68028dbdf4a$var$number$1(v)).join(' ');
        return this.addContent(`${values} cm`);
    },
    translate (x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    },
    rotate (angle, options = {}) {
        let y;
        const rad = angle * Math.PI / 180;
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        let x = y = 0;
        if (options.origin != null) {
            [x, y] = options.origin;
            const x1 = x * cos - y * sin;
            const y1 = x * sin + y * cos;
            x -= x1;
            y -= y1;
        }
        return this.transform(cos, sin, -sin, cos, x, y);
    },
    scale (xFactor, yFactor, options = {}) {
        let y;
        if (yFactor == null) yFactor = xFactor;
        if (typeof yFactor === 'object') {
            options = yFactor;
            yFactor = xFactor;
        }
        let x = y = 0;
        if (options.origin != null) {
            [x, y] = options.origin;
            x -= xFactor * x;
            y -= yFactor * y;
        }
        return this.transform(xFactor, 0, 0, yFactor, x, y);
    }
};
const $bb72e68028dbdf4a$var$WIN_ANSI_MAP = {
    402: 131,
    8211: 150,
    8212: 151,
    8216: 145,
    8217: 146,
    8218: 130,
    8220: 147,
    8221: 148,
    8222: 132,
    8224: 134,
    8225: 135,
    8226: 149,
    8230: 133,
    8364: 128,
    8240: 137,
    8249: 139,
    8250: 155,
    710: 136,
    8482: 153,
    338: 140,
    339: 156,
    732: 152,
    352: 138,
    353: 154,
    376: 159,
    381: 142,
    382: 158
};
const $bb72e68028dbdf4a$var$characters = `\
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
  
space         exclam         quotedbl       numbersign
dollar        percent        ampersand      quotesingle
parenleft     parenright     asterisk       plus
comma         hyphen         period         slash
zero          one            two            three
four          five           six            seven
eight         nine           colon          semicolon
less          equal          greater        question
  
at            A              B              C
D             E              F              G
H             I              J              K
L             M              N              O
P             Q              R              S
T             U              V              W
X             Y              Z              bracketleft
backslash     bracketright   asciicircum    underscore
  
grave         a              b              c
d             e              f              g
h             i              j              k
l             m              n              o
p             q              r              s
t             u              v              w
x             y              z              braceleft
bar           braceright     asciitilde     .notdef
  
Euro          .notdef        quotesinglbase florin
quotedblbase  ellipsis       dagger         daggerdbl
circumflex    perthousand    Scaron         guilsinglleft
OE            .notdef        Zcaron         .notdef
.notdef       quoteleft      quoteright     quotedblleft
quotedblright bullet         endash         emdash
tilde         trademark      scaron         guilsinglright
oe            .notdef        zcaron         ydieresis
  
space         exclamdown     cent           sterling
currency      yen            brokenbar      section
dieresis      copyright      ordfeminine    guillemotleft
logicalnot    hyphen         registered     macron
degree        plusminus      twosuperior    threesuperior
acute         mu             paragraph      periodcentered
cedilla       onesuperior    ordmasculine   guillemotright
onequarter    onehalf        threequarters  questiondown
  
Agrave        Aacute         Acircumflex    Atilde
Adieresis     Aring          AE             Ccedilla
Egrave        Eacute         Ecircumflex    Edieresis
Igrave        Iacute         Icircumflex    Idieresis
Eth           Ntilde         Ograve         Oacute
Ocircumflex   Otilde         Odieresis      multiply
Oslash        Ugrave         Uacute         Ucircumflex
Udieresis     Yacute         Thorn          germandbls
  
agrave        aacute         acircumflex    atilde
adieresis     aring          ae             ccedilla
egrave        eacute         ecircumflex    edieresis
igrave        iacute         icircumflex    idieresis
eth           ntilde         ograve         oacute
ocircumflex   otilde         odieresis      divide
oslash        ugrave         uacute         ucircumflex
udieresis     yacute         thorn          ydieresis\
`.split(/\s+/);
class $bb72e68028dbdf4a$var$AFMFont {
    constructor(contents){
        this.attributes = {};
        this.glyphWidths = {};
        this.boundingBoxes = {};
        this.kernPairs = {};
        this.parse(contents);
        this.bbox = this.attributes['FontBBox'].split(/\s+/).map((e)=>+e);
        this.ascender = +(this.attributes['Ascender'] || 0);
        this.descender = +(this.attributes['Descender'] || 0);
        this.xHeight = +(this.attributes['XHeight'] || 0);
        this.capHeight = +(this.attributes['CapHeight'] || 0);
        this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
    }
    parse(contents) {
        let section = '';
        for (let line of contents.split('\n')){
            var match;
            var a;
            if (match = line.match(/^Start(\w+)/)) {
                section = match[1];
                continue;
            } else if (line.match(/^End(\w+)/)) {
                section = '';
                continue;
            }
            switch(section){
                case 'FontMetrics':
                    match = line.match(/(^\w+)\s+(.*)/);
                    var key = match[1];
                    var value = match[2];
                    if (a = this.attributes[key]) {
                        if (!Array.isArray(a)) a = this.attributes[key] = [
                            a
                        ];
                        a.push(value);
                    } else this.attributes[key] = value;
                    break;
                case 'CharMetrics':
                    if (!/^CH?\s/.test(line)) continue;
                    var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                    this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
                    break;
                case 'KernPairs':
                    match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
                    if (match) this.kernPairs[match[1] + '\0' + match[2]] = parseInt(match[3]);
                    break;
            }
        }
    }
    encodeText(text) {
        const res = [];
        for(let i = 0, len = text.length; i < len; i++){
            let char = text.charCodeAt(i);
            char = $bb72e68028dbdf4a$var$WIN_ANSI_MAP[char] || char;
            res.push(char.toString(16));
        }
        return res;
    }
    glyphsForString(string) {
        const glyphs = [];
        for(let i = 0, len = string.length; i < len; i++){
            const charCode = string.charCodeAt(i);
            glyphs.push(this.characterToGlyph(charCode));
        }
        return glyphs;
    }
    characterToGlyph(character) {
        return $bb72e68028dbdf4a$var$characters[$bb72e68028dbdf4a$var$WIN_ANSI_MAP[character] || character] || '.notdef';
    }
    widthOfGlyph(glyph) {
        return this.glyphWidths[glyph] || 0;
    }
    getKernPair(left, right) {
        return this.kernPairs[left + '\0' + right] || 0;
    }
    advancesForGlyphs(glyphs) {
        const advances = [];
        for(let index = 0; index < glyphs.length; index++){
            const left = glyphs[index];
            const right = glyphs[index + 1];
            advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
        }
        return advances;
    }
}
class $bb72e68028dbdf4a$var$PDFFont {
    constructor(){}
    encode() {
        throw new Error('Must be implemented by subclasses');
    }
    widthOfString() {
        throw new Error('Must be implemented by subclasses');
    }
    ref() {
        return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
    }
    finalize() {
        if (this.embedded || this.dictionary == null) return;
        this.embed();
        this.embedded = true;
    }
    embed() {
        throw new Error('Must be implemented by subclasses');
    }
    lineHeight(size, includeGap = false) {
        const gap = includeGap ? this.lineGap : 0;
        return (this.ascender + gap - this.descender) / 1000 * size;
    }
}
const $bb72e68028dbdf4a$var$STANDARD_FONTS = {
    Courier () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 17:27:09 1997\nComment UniqueID 43050\nComment VMusage 39754 50779\nFontName Courier\nFullName Courier\nFamilyName Courier\nWeight Medium\nItalicAngle 0\nIsFixedPitch true\nCharacterSet ExtendedRoman\nFontBBox -23 -250 715 805 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 003.000\nNotice Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nEncodingScheme AdobeStandardEncoding\nCapHeight 562\nXHeight 426\nAscender 629\nDescender -157\nStdHW 51\nStdVW 51\nStartCharMetrics 315\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 600 ; N exclam ; B 236 -15 364 572 ;\nC 34 ; WX 600 ; N quotedbl ; B 187 328 413 562 ;\nC 35 ; WX 600 ; N numbersign ; B 93 -32 507 639 ;\nC 36 ; WX 600 ; N dollar ; B 105 -126 496 662 ;\nC 37 ; WX 600 ; N percent ; B 81 -15 518 622 ;\nC 38 ; WX 600 ; N ampersand ; B 63 -15 538 543 ;\nC 39 ; WX 600 ; N quoteright ; B 213 328 376 562 ;\nC 40 ; WX 600 ; N parenleft ; B 269 -108 440 622 ;\nC 41 ; WX 600 ; N parenright ; B 160 -108 331 622 ;\nC 42 ; WX 600 ; N asterisk ; B 116 257 484 607 ;\nC 43 ; WX 600 ; N plus ; B 80 44 520 470 ;\nC 44 ; WX 600 ; N comma ; B 181 -112 344 122 ;\nC 45 ; WX 600 ; N hyphen ; B 103 231 497 285 ;\nC 46 ; WX 600 ; N period ; B 229 -15 371 109 ;\nC 47 ; WX 600 ; N slash ; B 125 -80 475 629 ;\nC 48 ; WX 600 ; N zero ; B 106 -15 494 622 ;\nC 49 ; WX 600 ; N one ; B 96 0 505 622 ;\nC 50 ; WX 600 ; N two ; B 70 0 471 622 ;\nC 51 ; WX 600 ; N three ; B 75 -15 466 622 ;\nC 52 ; WX 600 ; N four ; B 78 0 500 622 ;\nC 53 ; WX 600 ; N five ; B 92 -15 497 607 ;\nC 54 ; WX 600 ; N six ; B 111 -15 497 622 ;\nC 55 ; WX 600 ; N seven ; B 82 0 483 607 ;\nC 56 ; WX 600 ; N eight ; B 102 -15 498 622 ;\nC 57 ; WX 600 ; N nine ; B 96 -15 489 622 ;\nC 58 ; WX 600 ; N colon ; B 229 -15 371 385 ;\nC 59 ; WX 600 ; N semicolon ; B 181 -112 371 385 ;\nC 60 ; WX 600 ; N less ; B 41 42 519 472 ;\nC 61 ; WX 600 ; N equal ; B 80 138 520 376 ;\nC 62 ; WX 600 ; N greater ; B 66 42 544 472 ;\nC 63 ; WX 600 ; N question ; B 129 -15 492 572 ;\nC 64 ; WX 600 ; N at ; B 77 -15 533 622 ;\nC 65 ; WX 600 ; N A ; B 3 0 597 562 ;\nC 66 ; WX 600 ; N B ; B 43 0 559 562 ;\nC 67 ; WX 600 ; N C ; B 41 -18 540 580 ;\nC 68 ; WX 600 ; N D ; B 43 0 574 562 ;\nC 69 ; WX 600 ; N E ; B 53 0 550 562 ;\nC 70 ; WX 600 ; N F ; B 53 0 545 562 ;\nC 71 ; WX 600 ; N G ; B 31 -18 575 580 ;\nC 72 ; WX 600 ; N H ; B 32 0 568 562 ;\nC 73 ; WX 600 ; N I ; B 96 0 504 562 ;\nC 74 ; WX 600 ; N J ; B 34 -18 566 562 ;\nC 75 ; WX 600 ; N K ; B 38 0 582 562 ;\nC 76 ; WX 600 ; N L ; B 47 0 554 562 ;\nC 77 ; WX 600 ; N M ; B 4 0 596 562 ;\nC 78 ; WX 600 ; N N ; B 7 -13 593 562 ;\nC 79 ; WX 600 ; N O ; B 43 -18 557 580 ;\nC 80 ; WX 600 ; N P ; B 79 0 558 562 ;\nC 81 ; WX 600 ; N Q ; B 43 -138 557 580 ;\nC 82 ; WX 600 ; N R ; B 38 0 588 562 ;\nC 83 ; WX 600 ; N S ; B 72 -20 529 580 ;\nC 84 ; WX 600 ; N T ; B 38 0 563 562 ;\nC 85 ; WX 600 ; N U ; B 17 -18 583 562 ;\nC 86 ; WX 600 ; N V ; B -4 -13 604 562 ;\nC 87 ; WX 600 ; N W ; B -3 -13 603 562 ;\nC 88 ; WX 600 ; N X ; B 23 0 577 562 ;\nC 89 ; WX 600 ; N Y ; B 24 0 576 562 ;\nC 90 ; WX 600 ; N Z ; B 86 0 514 562 ;\nC 91 ; WX 600 ; N bracketleft ; B 269 -108 442 622 ;\nC 92 ; WX 600 ; N backslash ; B 118 -80 482 629 ;\nC 93 ; WX 600 ; N bracketright ; B 158 -108 331 622 ;\nC 94 ; WX 600 ; N asciicircum ; B 94 354 506 622 ;\nC 95 ; WX 600 ; N underscore ; B 0 -125 600 -75 ;\nC 96 ; WX 600 ; N quoteleft ; B 224 328 387 562 ;\nC 97 ; WX 600 ; N a ; B 53 -15 559 441 ;\nC 98 ; WX 600 ; N b ; B 14 -15 575 629 ;\nC 99 ; WX 600 ; N c ; B 66 -15 529 441 ;\nC 100 ; WX 600 ; N d ; B 45 -15 591 629 ;\nC 101 ; WX 600 ; N e ; B 66 -15 548 441 ;\nC 102 ; WX 600 ; N f ; B 114 0 531 629 ; L i fi ; L l fl ;\nC 103 ; WX 600 ; N g ; B 45 -157 566 441 ;\nC 104 ; WX 600 ; N h ; B 18 0 582 629 ;\nC 105 ; WX 600 ; N i ; B 95 0 505 657 ;\nC 106 ; WX 600 ; N j ; B 82 -157 410 657 ;\nC 107 ; WX 600 ; N k ; B 43 0 580 629 ;\nC 108 ; WX 600 ; N l ; B 95 0 505 629 ;\nC 109 ; WX 600 ; N m ; B -5 0 605 441 ;\nC 110 ; WX 600 ; N n ; B 26 0 575 441 ;\nC 111 ; WX 600 ; N o ; B 62 -15 538 441 ;\nC 112 ; WX 600 ; N p ; B 9 -157 555 441 ;\nC 113 ; WX 600 ; N q ; B 45 -157 591 441 ;\nC 114 ; WX 600 ; N r ; B 60 0 559 441 ;\nC 115 ; WX 600 ; N s ; B 80 -15 513 441 ;\nC 116 ; WX 600 ; N t ; B 87 -15 530 561 ;\nC 117 ; WX 600 ; N u ; B 21 -15 562 426 ;\nC 118 ; WX 600 ; N v ; B 10 -10 590 426 ;\nC 119 ; WX 600 ; N w ; B -4 -10 604 426 ;\nC 120 ; WX 600 ; N x ; B 20 0 580 426 ;\nC 121 ; WX 600 ; N y ; B 7 -157 592 426 ;\nC 122 ; WX 600 ; N z ; B 99 0 502 426 ;\nC 123 ; WX 600 ; N braceleft ; B 182 -108 437 622 ;\nC 124 ; WX 600 ; N bar ; B 275 -250 326 750 ;\nC 125 ; WX 600 ; N braceright ; B 163 -108 418 622 ;\nC 126 ; WX 600 ; N asciitilde ; B 63 197 540 320 ;\nC 161 ; WX 600 ; N exclamdown ; B 236 -157 364 430 ;\nC 162 ; WX 600 ; N cent ; B 96 -49 500 614 ;\nC 163 ; WX 600 ; N sterling ; B 84 -21 521 611 ;\nC 164 ; WX 600 ; N fraction ; B 92 -57 509 665 ;\nC 165 ; WX 600 ; N yen ; B 26 0 574 562 ;\nC 166 ; WX 600 ; N florin ; B 4 -143 539 622 ;\nC 167 ; WX 600 ; N section ; B 113 -78 488 580 ;\nC 168 ; WX 600 ; N currency ; B 73 58 527 506 ;\nC 169 ; WX 600 ; N quotesingle ; B 259 328 341 562 ;\nC 170 ; WX 600 ; N quotedblleft ; B 143 328 471 562 ;\nC 171 ; WX 600 ; N guillemotleft ; B 37 70 563 446 ;\nC 172 ; WX 600 ; N guilsinglleft ; B 149 70 451 446 ;\nC 173 ; WX 600 ; N guilsinglright ; B 149 70 451 446 ;\nC 174 ; WX 600 ; N fi ; B 3 0 597 629 ;\nC 175 ; WX 600 ; N fl ; B 3 0 597 629 ;\nC 177 ; WX 600 ; N endash ; B 75 231 525 285 ;\nC 178 ; WX 600 ; N dagger ; B 141 -78 459 580 ;\nC 179 ; WX 600 ; N daggerdbl ; B 141 -78 459 580 ;\nC 180 ; WX 600 ; N periodcentered ; B 222 189 378 327 ;\nC 182 ; WX 600 ; N paragraph ; B 50 -78 511 562 ;\nC 183 ; WX 600 ; N bullet ; B 172 130 428 383 ;\nC 184 ; WX 600 ; N quotesinglbase ; B 213 -134 376 100 ;\nC 185 ; WX 600 ; N quotedblbase ; B 143 -134 457 100 ;\nC 186 ; WX 600 ; N quotedblright ; B 143 328 457 562 ;\nC 187 ; WX 600 ; N guillemotright ; B 37 70 563 446 ;\nC 188 ; WX 600 ; N ellipsis ; B 37 -15 563 111 ;\nC 189 ; WX 600 ; N perthousand ; B 3 -15 600 622 ;\nC 191 ; WX 600 ; N questiondown ; B 108 -157 471 430 ;\nC 193 ; WX 600 ; N grave ; B 151 497 378 672 ;\nC 194 ; WX 600 ; N acute ; B 242 497 469 672 ;\nC 195 ; WX 600 ; N circumflex ; B 124 477 476 654 ;\nC 196 ; WX 600 ; N tilde ; B 105 489 503 606 ;\nC 197 ; WX 600 ; N macron ; B 120 525 480 565 ;\nC 198 ; WX 600 ; N breve ; B 153 501 447 609 ;\nC 199 ; WX 600 ; N dotaccent ; B 249 537 352 640 ;\nC 200 ; WX 600 ; N dieresis ; B 148 537 453 640 ;\nC 202 ; WX 600 ; N ring ; B 218 463 382 627 ;\nC 203 ; WX 600 ; N cedilla ; B 224 -151 362 10 ;\nC 205 ; WX 600 ; N hungarumlaut ; B 133 497 540 672 ;\nC 206 ; WX 600 ; N ogonek ; B 211 -172 407 4 ;\nC 207 ; WX 600 ; N caron ; B 124 492 476 669 ;\nC 208 ; WX 600 ; N emdash ; B 0 231 600 285 ;\nC 225 ; WX 600 ; N AE ; B 3 0 550 562 ;\nC 227 ; WX 600 ; N ordfeminine ; B 156 249 442 580 ;\nC 232 ; WX 600 ; N Lslash ; B 47 0 554 562 ;\nC 233 ; WX 600 ; N Oslash ; B 43 -80 557 629 ;\nC 234 ; WX 600 ; N OE ; B 7 0 567 562 ;\nC 235 ; WX 600 ; N ordmasculine ; B 157 249 443 580 ;\nC 241 ; WX 600 ; N ae ; B 19 -15 570 441 ;\nC 245 ; WX 600 ; N dotlessi ; B 95 0 505 426 ;\nC 248 ; WX 600 ; N lslash ; B 95 0 505 629 ;\nC 249 ; WX 600 ; N oslash ; B 62 -80 538 506 ;\nC 250 ; WX 600 ; N oe ; B 19 -15 559 441 ;\nC 251 ; WX 600 ; N germandbls ; B 48 -15 588 629 ;\nC -1 ; WX 600 ; N Idieresis ; B 96 0 504 753 ;\nC -1 ; WX 600 ; N eacute ; B 66 -15 548 672 ;\nC -1 ; WX 600 ; N abreve ; B 53 -15 559 609 ;\nC -1 ; WX 600 ; N uhungarumlaut ; B 21 -15 580 672 ;\nC -1 ; WX 600 ; N ecaron ; B 66 -15 548 669 ;\nC -1 ; WX 600 ; N Ydieresis ; B 24 0 576 753 ;\nC -1 ; WX 600 ; N divide ; B 87 48 513 467 ;\nC -1 ; WX 600 ; N Yacute ; B 24 0 576 805 ;\nC -1 ; WX 600 ; N Acircumflex ; B 3 0 597 787 ;\nC -1 ; WX 600 ; N aacute ; B 53 -15 559 672 ;\nC -1 ; WX 600 ; N Ucircumflex ; B 17 -18 583 787 ;\nC -1 ; WX 600 ; N yacute ; B 7 -157 592 672 ;\nC -1 ; WX 600 ; N scommaaccent ; B 80 -250 513 441 ;\nC -1 ; WX 600 ; N ecircumflex ; B 66 -15 548 654 ;\nC -1 ; WX 600 ; N Uring ; B 17 -18 583 760 ;\nC -1 ; WX 600 ; N Udieresis ; B 17 -18 583 753 ;\nC -1 ; WX 600 ; N aogonek ; B 53 -172 587 441 ;\nC -1 ; WX 600 ; N Uacute ; B 17 -18 583 805 ;\nC -1 ; WX 600 ; N uogonek ; B 21 -172 590 426 ;\nC -1 ; WX 600 ; N Edieresis ; B 53 0 550 753 ;\nC -1 ; WX 600 ; N Dcroat ; B 30 0 574 562 ;\nC -1 ; WX 600 ; N commaaccent ; B 198 -250 335 -58 ;\nC -1 ; WX 600 ; N copyright ; B 0 -18 600 580 ;\nC -1 ; WX 600 ; N Emacron ; B 53 0 550 698 ;\nC -1 ; WX 600 ; N ccaron ; B 66 -15 529 669 ;\nC -1 ; WX 600 ; N aring ; B 53 -15 559 627 ;\nC -1 ; WX 600 ; N Ncommaaccent ; B 7 -250 593 562 ;\nC -1 ; WX 600 ; N lacute ; B 95 0 505 805 ;\nC -1 ; WX 600 ; N agrave ; B 53 -15 559 672 ;\nC -1 ; WX 600 ; N Tcommaaccent ; B 38 -250 563 562 ;\nC -1 ; WX 600 ; N Cacute ; B 41 -18 540 805 ;\nC -1 ; WX 600 ; N atilde ; B 53 -15 559 606 ;\nC -1 ; WX 600 ; N Edotaccent ; B 53 0 550 753 ;\nC -1 ; WX 600 ; N scaron ; B 80 -15 513 669 ;\nC -1 ; WX 600 ; N scedilla ; B 80 -151 513 441 ;\nC -1 ; WX 600 ; N iacute ; B 95 0 505 672 ;\nC -1 ; WX 600 ; N lozenge ; B 18 0 443 706 ;\nC -1 ; WX 600 ; N Rcaron ; B 38 0 588 802 ;\nC -1 ; WX 600 ; N Gcommaaccent ; B 31 -250 575 580 ;\nC -1 ; WX 600 ; N ucircumflex ; B 21 -15 562 654 ;\nC -1 ; WX 600 ; N acircumflex ; B 53 -15 559 654 ;\nC -1 ; WX 600 ; N Amacron ; B 3 0 597 698 ;\nC -1 ; WX 600 ; N rcaron ; B 60 0 559 669 ;\nC -1 ; WX 600 ; N ccedilla ; B 66 -151 529 441 ;\nC -1 ; WX 600 ; N Zdotaccent ; B 86 0 514 753 ;\nC -1 ; WX 600 ; N Thorn ; B 79 0 538 562 ;\nC -1 ; WX 600 ; N Omacron ; B 43 -18 557 698 ;\nC -1 ; WX 600 ; N Racute ; B 38 0 588 805 ;\nC -1 ; WX 600 ; N Sacute ; B 72 -20 529 805 ;\nC -1 ; WX 600 ; N dcaron ; B 45 -15 715 629 ;\nC -1 ; WX 600 ; N Umacron ; B 17 -18 583 698 ;\nC -1 ; WX 600 ; N uring ; B 21 -15 562 627 ;\nC -1 ; WX 600 ; N threesuperior ; B 155 240 406 622 ;\nC -1 ; WX 600 ; N Ograve ; B 43 -18 557 805 ;\nC -1 ; WX 600 ; N Agrave ; B 3 0 597 805 ;\nC -1 ; WX 600 ; N Abreve ; B 3 0 597 732 ;\nC -1 ; WX 600 ; N multiply ; B 87 43 515 470 ;\nC -1 ; WX 600 ; N uacute ; B 21 -15 562 672 ;\nC -1 ; WX 600 ; N Tcaron ; B 38 0 563 802 ;\nC -1 ; WX 600 ; N partialdiff ; B 17 -38 459 710 ;\nC -1 ; WX 600 ; N ydieresis ; B 7 -157 592 620 ;\nC -1 ; WX 600 ; N Nacute ; B 7 -13 593 805 ;\nC -1 ; WX 600 ; N icircumflex ; B 94 0 505 654 ;\nC -1 ; WX 600 ; N Ecircumflex ; B 53 0 550 787 ;\nC -1 ; WX 600 ; N adieresis ; B 53 -15 559 620 ;\nC -1 ; WX 600 ; N edieresis ; B 66 -15 548 620 ;\nC -1 ; WX 600 ; N cacute ; B 66 -15 529 672 ;\nC -1 ; WX 600 ; N nacute ; B 26 0 575 672 ;\nC -1 ; WX 600 ; N umacron ; B 21 -15 562 565 ;\nC -1 ; WX 600 ; N Ncaron ; B 7 -13 593 802 ;\nC -1 ; WX 600 ; N Iacute ; B 96 0 504 805 ;\nC -1 ; WX 600 ; N plusminus ; B 87 44 513 558 ;\nC -1 ; WX 600 ; N brokenbar ; B 275 -175 326 675 ;\nC -1 ; WX 600 ; N registered ; B 0 -18 600 580 ;\nC -1 ; WX 600 ; N Gbreve ; B 31 -18 575 732 ;\nC -1 ; WX 600 ; N Idotaccent ; B 96 0 504 753 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 585 706 ;\nC -1 ; WX 600 ; N Egrave ; B 53 0 550 805 ;\nC -1 ; WX 600 ; N racute ; B 60 0 559 672 ;\nC -1 ; WX 600 ; N omacron ; B 62 -15 538 565 ;\nC -1 ; WX 600 ; N Zacute ; B 86 0 514 805 ;\nC -1 ; WX 600 ; N Zcaron ; B 86 0 514 802 ;\nC -1 ; WX 600 ; N greaterequal ; B 98 0 502 710 ;\nC -1 ; WX 600 ; N Eth ; B 30 0 574 562 ;\nC -1 ; WX 600 ; N Ccedilla ; B 41 -151 540 580 ;\nC -1 ; WX 600 ; N lcommaaccent ; B 95 -250 505 629 ;\nC -1 ; WX 600 ; N tcaron ; B 87 -15 530 717 ;\nC -1 ; WX 600 ; N eogonek ; B 66 -172 548 441 ;\nC -1 ; WX 600 ; N Uogonek ; B 17 -172 583 562 ;\nC -1 ; WX 600 ; N Aacute ; B 3 0 597 805 ;\nC -1 ; WX 600 ; N Adieresis ; B 3 0 597 753 ;\nC -1 ; WX 600 ; N egrave ; B 66 -15 548 672 ;\nC -1 ; WX 600 ; N zacute ; B 99 0 502 672 ;\nC -1 ; WX 600 ; N iogonek ; B 95 -172 505 657 ;\nC -1 ; WX 600 ; N Oacute ; B 43 -18 557 805 ;\nC -1 ; WX 600 ; N oacute ; B 62 -15 538 672 ;\nC -1 ; WX 600 ; N amacron ; B 53 -15 559 565 ;\nC -1 ; WX 600 ; N sacute ; B 80 -15 513 672 ;\nC -1 ; WX 600 ; N idieresis ; B 95 0 505 620 ;\nC -1 ; WX 600 ; N Ocircumflex ; B 43 -18 557 787 ;\nC -1 ; WX 600 ; N Ugrave ; B 17 -18 583 805 ;\nC -1 ; WX 600 ; N Delta ; B 6 0 598 688 ;\nC -1 ; WX 600 ; N thorn ; B -6 -157 555 629 ;\nC -1 ; WX 600 ; N twosuperior ; B 177 249 424 622 ;\nC -1 ; WX 600 ; N Odieresis ; B 43 -18 557 753 ;\nC -1 ; WX 600 ; N mu ; B 21 -157 562 426 ;\nC -1 ; WX 600 ; N igrave ; B 95 0 505 672 ;\nC -1 ; WX 600 ; N ohungarumlaut ; B 62 -15 580 672 ;\nC -1 ; WX 600 ; N Eogonek ; B 53 -172 561 562 ;\nC -1 ; WX 600 ; N dcroat ; B 45 -15 591 629 ;\nC -1 ; WX 600 ; N threequarters ; B 8 -56 593 666 ;\nC -1 ; WX 600 ; N Scedilla ; B 72 -151 529 580 ;\nC -1 ; WX 600 ; N lcaron ; B 95 0 533 629 ;\nC -1 ; WX 600 ; N Kcommaaccent ; B 38 -250 582 562 ;\nC -1 ; WX 600 ; N Lacute ; B 47 0 554 805 ;\nC -1 ; WX 600 ; N trademark ; B -23 263 623 562 ;\nC -1 ; WX 600 ; N edotaccent ; B 66 -15 548 620 ;\nC -1 ; WX 600 ; N Igrave ; B 96 0 504 805 ;\nC -1 ; WX 600 ; N Imacron ; B 96 0 504 698 ;\nC -1 ; WX 600 ; N Lcaron ; B 47 0 554 562 ;\nC -1 ; WX 600 ; N onehalf ; B 0 -57 611 665 ;\nC -1 ; WX 600 ; N lessequal ; B 98 0 502 710 ;\nC -1 ; WX 600 ; N ocircumflex ; B 62 -15 538 654 ;\nC -1 ; WX 600 ; N ntilde ; B 26 0 575 606 ;\nC -1 ; WX 600 ; N Uhungarumlaut ; B 17 -18 590 805 ;\nC -1 ; WX 600 ; N Eacute ; B 53 0 550 805 ;\nC -1 ; WX 600 ; N emacron ; B 66 -15 548 565 ;\nC -1 ; WX 600 ; N gbreve ; B 45 -157 566 609 ;\nC -1 ; WX 600 ; N onequarter ; B 0 -57 600 665 ;\nC -1 ; WX 600 ; N Scaron ; B 72 -20 529 802 ;\nC -1 ; WX 600 ; N Scommaaccent ; B 72 -250 529 580 ;\nC -1 ; WX 600 ; N Ohungarumlaut ; B 43 -18 580 805 ;\nC -1 ; WX 600 ; N degree ; B 123 269 477 622 ;\nC -1 ; WX 600 ; N ograve ; B 62 -15 538 672 ;\nC -1 ; WX 600 ; N Ccaron ; B 41 -18 540 802 ;\nC -1 ; WX 600 ; N ugrave ; B 21 -15 562 672 ;\nC -1 ; WX 600 ; N radical ; B 3 -15 597 792 ;\nC -1 ; WX 600 ; N Dcaron ; B 43 0 574 802 ;\nC -1 ; WX 600 ; N rcommaaccent ; B 60 -250 559 441 ;\nC -1 ; WX 600 ; N Ntilde ; B 7 -13 593 729 ;\nC -1 ; WX 600 ; N otilde ; B 62 -15 538 606 ;\nC -1 ; WX 600 ; N Rcommaaccent ; B 38 -250 588 562 ;\nC -1 ; WX 600 ; N Lcommaaccent ; B 47 -250 554 562 ;\nC -1 ; WX 600 ; N Atilde ; B 3 0 597 729 ;\nC -1 ; WX 600 ; N Aogonek ; B 3 -172 608 562 ;\nC -1 ; WX 600 ; N Aring ; B 3 0 597 750 ;\nC -1 ; WX 600 ; N Otilde ; B 43 -18 557 729 ;\nC -1 ; WX 600 ; N zdotaccent ; B 99 0 502 620 ;\nC -1 ; WX 600 ; N Ecaron ; B 53 0 550 802 ;\nC -1 ; WX 600 ; N Iogonek ; B 96 -172 504 562 ;\nC -1 ; WX 600 ; N kcommaaccent ; B 43 -250 580 629 ;\nC -1 ; WX 600 ; N minus ; B 80 232 520 283 ;\nC -1 ; WX 600 ; N Icircumflex ; B 96 0 504 787 ;\nC -1 ; WX 600 ; N ncaron ; B 26 0 575 669 ;\nC -1 ; WX 600 ; N tcommaaccent ; B 87 -250 530 561 ;\nC -1 ; WX 600 ; N logicalnot ; B 87 108 513 369 ;\nC -1 ; WX 600 ; N odieresis ; B 62 -15 538 620 ;\nC -1 ; WX 600 ; N udieresis ; B 21 -15 562 620 ;\nC -1 ; WX 600 ; N notequal ; B 15 -16 540 529 ;\nC -1 ; WX 600 ; N gcommaaccent ; B 45 -157 566 708 ;\nC -1 ; WX 600 ; N eth ; B 62 -15 538 629 ;\nC -1 ; WX 600 ; N zcaron ; B 99 0 502 669 ;\nC -1 ; WX 600 ; N ncommaaccent ; B 26 -250 575 441 ;\nC -1 ; WX 600 ; N onesuperior ; B 172 249 428 622 ;\nC -1 ; WX 600 ; N imacron ; B 95 0 505 565 ;\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nEndFontMetrics\n";
    },
    'Courier-Bold' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Mon Jun 23 16:28:00 1997\nComment UniqueID 43048\nComment VMusage 41139 52164\nFontName Courier-Bold\nFullName Courier Bold\nFamilyName Courier\nWeight Bold\nItalicAngle 0\nIsFixedPitch true\nCharacterSet ExtendedRoman\nFontBBox -113 -250 749 801 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 003.000\nNotice Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nEncodingScheme AdobeStandardEncoding\nCapHeight 562\nXHeight 439\nAscender 629\nDescender -157\nStdHW 84\nStdVW 106\nStartCharMetrics 315\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 600 ; N exclam ; B 202 -15 398 572 ;\nC 34 ; WX 600 ; N quotedbl ; B 135 277 465 562 ;\nC 35 ; WX 600 ; N numbersign ; B 56 -45 544 651 ;\nC 36 ; WX 600 ; N dollar ; B 82 -126 519 666 ;\nC 37 ; WX 600 ; N percent ; B 5 -15 595 616 ;\nC 38 ; WX 600 ; N ampersand ; B 36 -15 546 543 ;\nC 39 ; WX 600 ; N quoteright ; B 171 277 423 562 ;\nC 40 ; WX 600 ; N parenleft ; B 219 -102 461 616 ;\nC 41 ; WX 600 ; N parenright ; B 139 -102 381 616 ;\nC 42 ; WX 600 ; N asterisk ; B 91 219 509 601 ;\nC 43 ; WX 600 ; N plus ; B 71 39 529 478 ;\nC 44 ; WX 600 ; N comma ; B 123 -111 393 174 ;\nC 45 ; WX 600 ; N hyphen ; B 100 203 500 313 ;\nC 46 ; WX 600 ; N period ; B 192 -15 408 171 ;\nC 47 ; WX 600 ; N slash ; B 98 -77 502 626 ;\nC 48 ; WX 600 ; N zero ; B 87 -15 513 616 ;\nC 49 ; WX 600 ; N one ; B 81 0 539 616 ;\nC 50 ; WX 600 ; N two ; B 61 0 499 616 ;\nC 51 ; WX 600 ; N three ; B 63 -15 501 616 ;\nC 52 ; WX 600 ; N four ; B 53 0 507 616 ;\nC 53 ; WX 600 ; N five ; B 70 -15 521 601 ;\nC 54 ; WX 600 ; N six ; B 90 -15 521 616 ;\nC 55 ; WX 600 ; N seven ; B 55 0 494 601 ;\nC 56 ; WX 600 ; N eight ; B 83 -15 517 616 ;\nC 57 ; WX 600 ; N nine ; B 79 -15 510 616 ;\nC 58 ; WX 600 ; N colon ; B 191 -15 407 425 ;\nC 59 ; WX 600 ; N semicolon ; B 123 -111 408 425 ;\nC 60 ; WX 600 ; N less ; B 66 15 523 501 ;\nC 61 ; WX 600 ; N equal ; B 71 118 529 398 ;\nC 62 ; WX 600 ; N greater ; B 77 15 534 501 ;\nC 63 ; WX 600 ; N question ; B 98 -14 501 580 ;\nC 64 ; WX 600 ; N at ; B 16 -15 584 616 ;\nC 65 ; WX 600 ; N A ; B -9 0 609 562 ;\nC 66 ; WX 600 ; N B ; B 30 0 573 562 ;\nC 67 ; WX 600 ; N C ; B 22 -18 560 580 ;\nC 68 ; WX 600 ; N D ; B 30 0 594 562 ;\nC 69 ; WX 600 ; N E ; B 25 0 560 562 ;\nC 70 ; WX 600 ; N F ; B 39 0 570 562 ;\nC 71 ; WX 600 ; N G ; B 22 -18 594 580 ;\nC 72 ; WX 600 ; N H ; B 20 0 580 562 ;\nC 73 ; WX 600 ; N I ; B 77 0 523 562 ;\nC 74 ; WX 600 ; N J ; B 37 -18 601 562 ;\nC 75 ; WX 600 ; N K ; B 21 0 599 562 ;\nC 76 ; WX 600 ; N L ; B 39 0 578 562 ;\nC 77 ; WX 600 ; N M ; B -2 0 602 562 ;\nC 78 ; WX 600 ; N N ; B 8 -12 610 562 ;\nC 79 ; WX 600 ; N O ; B 22 -18 578 580 ;\nC 80 ; WX 600 ; N P ; B 48 0 559 562 ;\nC 81 ; WX 600 ; N Q ; B 32 -138 578 580 ;\nC 82 ; WX 600 ; N R ; B 24 0 599 562 ;\nC 83 ; WX 600 ; N S ; B 47 -22 553 582 ;\nC 84 ; WX 600 ; N T ; B 21 0 579 562 ;\nC 85 ; WX 600 ; N U ; B 4 -18 596 562 ;\nC 86 ; WX 600 ; N V ; B -13 0 613 562 ;\nC 87 ; WX 600 ; N W ; B -18 0 618 562 ;\nC 88 ; WX 600 ; N X ; B 12 0 588 562 ;\nC 89 ; WX 600 ; N Y ; B 12 0 589 562 ;\nC 90 ; WX 600 ; N Z ; B 62 0 539 562 ;\nC 91 ; WX 600 ; N bracketleft ; B 245 -102 475 616 ;\nC 92 ; WX 600 ; N backslash ; B 99 -77 503 626 ;\nC 93 ; WX 600 ; N bracketright ; B 125 -102 355 616 ;\nC 94 ; WX 600 ; N asciicircum ; B 108 250 492 616 ;\nC 95 ; WX 600 ; N underscore ; B 0 -125 600 -75 ;\nC 96 ; WX 600 ; N quoteleft ; B 178 277 428 562 ;\nC 97 ; WX 600 ; N a ; B 35 -15 570 454 ;\nC 98 ; WX 600 ; N b ; B 0 -15 584 626 ;\nC 99 ; WX 600 ; N c ; B 40 -15 545 459 ;\nC 100 ; WX 600 ; N d ; B 20 -15 591 626 ;\nC 101 ; WX 600 ; N e ; B 40 -15 563 454 ;\nC 102 ; WX 600 ; N f ; B 83 0 547 626 ; L i fi ; L l fl ;\nC 103 ; WX 600 ; N g ; B 30 -146 580 454 ;\nC 104 ; WX 600 ; N h ; B 5 0 592 626 ;\nC 105 ; WX 600 ; N i ; B 77 0 523 658 ;\nC 106 ; WX 600 ; N j ; B 63 -146 440 658 ;\nC 107 ; WX 600 ; N k ; B 20 0 585 626 ;\nC 108 ; WX 600 ; N l ; B 77 0 523 626 ;\nC 109 ; WX 600 ; N m ; B -22 0 626 454 ;\nC 110 ; WX 600 ; N n ; B 18 0 592 454 ;\nC 111 ; WX 600 ; N o ; B 30 -15 570 454 ;\nC 112 ; WX 600 ; N p ; B -1 -142 570 454 ;\nC 113 ; WX 600 ; N q ; B 20 -142 591 454 ;\nC 114 ; WX 600 ; N r ; B 47 0 580 454 ;\nC 115 ; WX 600 ; N s ; B 68 -17 535 459 ;\nC 116 ; WX 600 ; N t ; B 47 -15 532 562 ;\nC 117 ; WX 600 ; N u ; B -1 -15 569 439 ;\nC 118 ; WX 600 ; N v ; B -1 0 601 439 ;\nC 119 ; WX 600 ; N w ; B -18 0 618 439 ;\nC 120 ; WX 600 ; N x ; B 6 0 594 439 ;\nC 121 ; WX 600 ; N y ; B -4 -142 601 439 ;\nC 122 ; WX 600 ; N z ; B 81 0 520 439 ;\nC 123 ; WX 600 ; N braceleft ; B 160 -102 464 616 ;\nC 124 ; WX 600 ; N bar ; B 255 -250 345 750 ;\nC 125 ; WX 600 ; N braceright ; B 136 -102 440 616 ;\nC 126 ; WX 600 ; N asciitilde ; B 71 153 530 356 ;\nC 161 ; WX 600 ; N exclamdown ; B 202 -146 398 449 ;\nC 162 ; WX 600 ; N cent ; B 66 -49 518 614 ;\nC 163 ; WX 600 ; N sterling ; B 72 -28 558 611 ;\nC 164 ; WX 600 ; N fraction ; B 25 -60 576 661 ;\nC 165 ; WX 600 ; N yen ; B 10 0 590 562 ;\nC 166 ; WX 600 ; N florin ; B -30 -131 572 616 ;\nC 167 ; WX 600 ; N section ; B 83 -70 517 580 ;\nC 168 ; WX 600 ; N currency ; B 54 49 546 517 ;\nC 169 ; WX 600 ; N quotesingle ; B 227 277 373 562 ;\nC 170 ; WX 600 ; N quotedblleft ; B 71 277 535 562 ;\nC 171 ; WX 600 ; N guillemotleft ; B 8 70 553 446 ;\nC 172 ; WX 600 ; N guilsinglleft ; B 141 70 459 446 ;\nC 173 ; WX 600 ; N guilsinglright ; B 141 70 459 446 ;\nC 174 ; WX 600 ; N fi ; B 12 0 593 626 ;\nC 175 ; WX 600 ; N fl ; B 12 0 593 626 ;\nC 177 ; WX 600 ; N endash ; B 65 203 535 313 ;\nC 178 ; WX 600 ; N dagger ; B 106 -70 494 580 ;\nC 179 ; WX 600 ; N daggerdbl ; B 106 -70 494 580 ;\nC 180 ; WX 600 ; N periodcentered ; B 196 165 404 351 ;\nC 182 ; WX 600 ; N paragraph ; B 6 -70 576 580 ;\nC 183 ; WX 600 ; N bullet ; B 140 132 460 430 ;\nC 184 ; WX 600 ; N quotesinglbase ; B 175 -142 427 143 ;\nC 185 ; WX 600 ; N quotedblbase ; B 65 -142 529 143 ;\nC 186 ; WX 600 ; N quotedblright ; B 61 277 525 562 ;\nC 187 ; WX 600 ; N guillemotright ; B 47 70 592 446 ;\nC 188 ; WX 600 ; N ellipsis ; B 26 -15 574 116 ;\nC 189 ; WX 600 ; N perthousand ; B -113 -15 713 616 ;\nC 191 ; WX 600 ; N questiondown ; B 99 -146 502 449 ;\nC 193 ; WX 600 ; N grave ; B 132 508 395 661 ;\nC 194 ; WX 600 ; N acute ; B 205 508 468 661 ;\nC 195 ; WX 600 ; N circumflex ; B 103 483 497 657 ;\nC 196 ; WX 600 ; N tilde ; B 89 493 512 636 ;\nC 197 ; WX 600 ; N macron ; B 88 505 512 585 ;\nC 198 ; WX 600 ; N breve ; B 83 468 517 631 ;\nC 199 ; WX 600 ; N dotaccent ; B 230 498 370 638 ;\nC 200 ; WX 600 ; N dieresis ; B 128 498 472 638 ;\nC 202 ; WX 600 ; N ring ; B 198 481 402 678 ;\nC 203 ; WX 600 ; N cedilla ; B 205 -206 387 0 ;\nC 205 ; WX 600 ; N hungarumlaut ; B 68 488 588 661 ;\nC 206 ; WX 600 ; N ogonek ; B 169 -199 400 0 ;\nC 207 ; WX 600 ; N caron ; B 103 493 497 667 ;\nC 208 ; WX 600 ; N emdash ; B -10 203 610 313 ;\nC 225 ; WX 600 ; N AE ; B -29 0 602 562 ;\nC 227 ; WX 600 ; N ordfeminine ; B 147 196 453 580 ;\nC 232 ; WX 600 ; N Lslash ; B 39 0 578 562 ;\nC 233 ; WX 600 ; N Oslash ; B 22 -22 578 584 ;\nC 234 ; WX 600 ; N OE ; B -25 0 595 562 ;\nC 235 ; WX 600 ; N ordmasculine ; B 147 196 453 580 ;\nC 241 ; WX 600 ; N ae ; B -4 -15 601 454 ;\nC 245 ; WX 600 ; N dotlessi ; B 77 0 523 439 ;\nC 248 ; WX 600 ; N lslash ; B 77 0 523 626 ;\nC 249 ; WX 600 ; N oslash ; B 30 -24 570 463 ;\nC 250 ; WX 600 ; N oe ; B -18 -15 611 454 ;\nC 251 ; WX 600 ; N germandbls ; B 22 -15 596 626 ;\nC -1 ; WX 600 ; N Idieresis ; B 77 0 523 761 ;\nC -1 ; WX 600 ; N eacute ; B 40 -15 563 661 ;\nC -1 ; WX 600 ; N abreve ; B 35 -15 570 661 ;\nC -1 ; WX 600 ; N uhungarumlaut ; B -1 -15 628 661 ;\nC -1 ; WX 600 ; N ecaron ; B 40 -15 563 667 ;\nC -1 ; WX 600 ; N Ydieresis ; B 12 0 589 761 ;\nC -1 ; WX 600 ; N divide ; B 71 16 529 500 ;\nC -1 ; WX 600 ; N Yacute ; B 12 0 589 784 ;\nC -1 ; WX 600 ; N Acircumflex ; B -9 0 609 780 ;\nC -1 ; WX 600 ; N aacute ; B 35 -15 570 661 ;\nC -1 ; WX 600 ; N Ucircumflex ; B 4 -18 596 780 ;\nC -1 ; WX 600 ; N yacute ; B -4 -142 601 661 ;\nC -1 ; WX 600 ; N scommaaccent ; B 68 -250 535 459 ;\nC -1 ; WX 600 ; N ecircumflex ; B 40 -15 563 657 ;\nC -1 ; WX 600 ; N Uring ; B 4 -18 596 801 ;\nC -1 ; WX 600 ; N Udieresis ; B 4 -18 596 761 ;\nC -1 ; WX 600 ; N aogonek ; B 35 -199 586 454 ;\nC -1 ; WX 600 ; N Uacute ; B 4 -18 596 784 ;\nC -1 ; WX 600 ; N uogonek ; B -1 -199 585 439 ;\nC -1 ; WX 600 ; N Edieresis ; B 25 0 560 761 ;\nC -1 ; WX 600 ; N Dcroat ; B 30 0 594 562 ;\nC -1 ; WX 600 ; N commaaccent ; B 205 -250 397 -57 ;\nC -1 ; WX 600 ; N copyright ; B 0 -18 600 580 ;\nC -1 ; WX 600 ; N Emacron ; B 25 0 560 708 ;\nC -1 ; WX 600 ; N ccaron ; B 40 -15 545 667 ;\nC -1 ; WX 600 ; N aring ; B 35 -15 570 678 ;\nC -1 ; WX 600 ; N Ncommaaccent ; B 8 -250 610 562 ;\nC -1 ; WX 600 ; N lacute ; B 77 0 523 801 ;\nC -1 ; WX 600 ; N agrave ; B 35 -15 570 661 ;\nC -1 ; WX 600 ; N Tcommaaccent ; B 21 -250 579 562 ;\nC -1 ; WX 600 ; N Cacute ; B 22 -18 560 784 ;\nC -1 ; WX 600 ; N atilde ; B 35 -15 570 636 ;\nC -1 ; WX 600 ; N Edotaccent ; B 25 0 560 761 ;\nC -1 ; WX 600 ; N scaron ; B 68 -17 535 667 ;\nC -1 ; WX 600 ; N scedilla ; B 68 -206 535 459 ;\nC -1 ; WX 600 ; N iacute ; B 77 0 523 661 ;\nC -1 ; WX 600 ; N lozenge ; B 66 0 534 740 ;\nC -1 ; WX 600 ; N Rcaron ; B 24 0 599 790 ;\nC -1 ; WX 600 ; N Gcommaaccent ; B 22 -250 594 580 ;\nC -1 ; WX 600 ; N ucircumflex ; B -1 -15 569 657 ;\nC -1 ; WX 600 ; N acircumflex ; B 35 -15 570 657 ;\nC -1 ; WX 600 ; N Amacron ; B -9 0 609 708 ;\nC -1 ; WX 600 ; N rcaron ; B 47 0 580 667 ;\nC -1 ; WX 600 ; N ccedilla ; B 40 -206 545 459 ;\nC -1 ; WX 600 ; N Zdotaccent ; B 62 0 539 761 ;\nC -1 ; WX 600 ; N Thorn ; B 48 0 557 562 ;\nC -1 ; WX 600 ; N Omacron ; B 22 -18 578 708 ;\nC -1 ; WX 600 ; N Racute ; B 24 0 599 784 ;\nC -1 ; WX 600 ; N Sacute ; B 47 -22 553 784 ;\nC -1 ; WX 600 ; N dcaron ; B 20 -15 727 626 ;\nC -1 ; WX 600 ; N Umacron ; B 4 -18 596 708 ;\nC -1 ; WX 600 ; N uring ; B -1 -15 569 678 ;\nC -1 ; WX 600 ; N threesuperior ; B 138 222 433 616 ;\nC -1 ; WX 600 ; N Ograve ; B 22 -18 578 784 ;\nC -1 ; WX 600 ; N Agrave ; B -9 0 609 784 ;\nC -1 ; WX 600 ; N Abreve ; B -9 0 609 784 ;\nC -1 ; WX 600 ; N multiply ; B 81 39 520 478 ;\nC -1 ; WX 600 ; N uacute ; B -1 -15 569 661 ;\nC -1 ; WX 600 ; N Tcaron ; B 21 0 579 790 ;\nC -1 ; WX 600 ; N partialdiff ; B 63 -38 537 728 ;\nC -1 ; WX 600 ; N ydieresis ; B -4 -142 601 638 ;\nC -1 ; WX 600 ; N Nacute ; B 8 -12 610 784 ;\nC -1 ; WX 600 ; N icircumflex ; B 73 0 523 657 ;\nC -1 ; WX 600 ; N Ecircumflex ; B 25 0 560 780 ;\nC -1 ; WX 600 ; N adieresis ; B 35 -15 570 638 ;\nC -1 ; WX 600 ; N edieresis ; B 40 -15 563 638 ;\nC -1 ; WX 600 ; N cacute ; B 40 -15 545 661 ;\nC -1 ; WX 600 ; N nacute ; B 18 0 592 661 ;\nC -1 ; WX 600 ; N umacron ; B -1 -15 569 585 ;\nC -1 ; WX 600 ; N Ncaron ; B 8 -12 610 790 ;\nC -1 ; WX 600 ; N Iacute ; B 77 0 523 784 ;\nC -1 ; WX 600 ; N plusminus ; B 71 24 529 515 ;\nC -1 ; WX 600 ; N brokenbar ; B 255 -175 345 675 ;\nC -1 ; WX 600 ; N registered ; B 0 -18 600 580 ;\nC -1 ; WX 600 ; N Gbreve ; B 22 -18 594 784 ;\nC -1 ; WX 600 ; N Idotaccent ; B 77 0 523 761 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 586 706 ;\nC -1 ; WX 600 ; N Egrave ; B 25 0 560 784 ;\nC -1 ; WX 600 ; N racute ; B 47 0 580 661 ;\nC -1 ; WX 600 ; N omacron ; B 30 -15 570 585 ;\nC -1 ; WX 600 ; N Zacute ; B 62 0 539 784 ;\nC -1 ; WX 600 ; N Zcaron ; B 62 0 539 790 ;\nC -1 ; WX 600 ; N greaterequal ; B 26 0 523 696 ;\nC -1 ; WX 600 ; N Eth ; B 30 0 594 562 ;\nC -1 ; WX 600 ; N Ccedilla ; B 22 -206 560 580 ;\nC -1 ; WX 600 ; N lcommaaccent ; B 77 -250 523 626 ;\nC -1 ; WX 600 ; N tcaron ; B 47 -15 532 703 ;\nC -1 ; WX 600 ; N eogonek ; B 40 -199 563 454 ;\nC -1 ; WX 600 ; N Uogonek ; B 4 -199 596 562 ;\nC -1 ; WX 600 ; N Aacute ; B -9 0 609 784 ;\nC -1 ; WX 600 ; N Adieresis ; B -9 0 609 761 ;\nC -1 ; WX 600 ; N egrave ; B 40 -15 563 661 ;\nC -1 ; WX 600 ; N zacute ; B 81 0 520 661 ;\nC -1 ; WX 600 ; N iogonek ; B 77 -199 523 658 ;\nC -1 ; WX 600 ; N Oacute ; B 22 -18 578 784 ;\nC -1 ; WX 600 ; N oacute ; B 30 -15 570 661 ;\nC -1 ; WX 600 ; N amacron ; B 35 -15 570 585 ;\nC -1 ; WX 600 ; N sacute ; B 68 -17 535 661 ;\nC -1 ; WX 600 ; N idieresis ; B 77 0 523 618 ;\nC -1 ; WX 600 ; N Ocircumflex ; B 22 -18 578 780 ;\nC -1 ; WX 600 ; N Ugrave ; B 4 -18 596 784 ;\nC -1 ; WX 600 ; N Delta ; B 6 0 594 688 ;\nC -1 ; WX 600 ; N thorn ; B -14 -142 570 626 ;\nC -1 ; WX 600 ; N twosuperior ; B 143 230 436 616 ;\nC -1 ; WX 600 ; N Odieresis ; B 22 -18 578 761 ;\nC -1 ; WX 600 ; N mu ; B -1 -142 569 439 ;\nC -1 ; WX 600 ; N igrave ; B 77 0 523 661 ;\nC -1 ; WX 600 ; N ohungarumlaut ; B 30 -15 668 661 ;\nC -1 ; WX 600 ; N Eogonek ; B 25 -199 576 562 ;\nC -1 ; WX 600 ; N dcroat ; B 20 -15 591 626 ;\nC -1 ; WX 600 ; N threequarters ; B -47 -60 648 661 ;\nC -1 ; WX 600 ; N Scedilla ; B 47 -206 553 582 ;\nC -1 ; WX 600 ; N lcaron ; B 77 0 597 626 ;\nC -1 ; WX 600 ; N Kcommaaccent ; B 21 -250 599 562 ;\nC -1 ; WX 600 ; N Lacute ; B 39 0 578 784 ;\nC -1 ; WX 600 ; N trademark ; B -9 230 749 562 ;\nC -1 ; WX 600 ; N edotaccent ; B 40 -15 563 638 ;\nC -1 ; WX 600 ; N Igrave ; B 77 0 523 784 ;\nC -1 ; WX 600 ; N Imacron ; B 77 0 523 708 ;\nC -1 ; WX 600 ; N Lcaron ; B 39 0 637 562 ;\nC -1 ; WX 600 ; N onehalf ; B -47 -60 648 661 ;\nC -1 ; WX 600 ; N lessequal ; B 26 0 523 696 ;\nC -1 ; WX 600 ; N ocircumflex ; B 30 -15 570 657 ;\nC -1 ; WX 600 ; N ntilde ; B 18 0 592 636 ;\nC -1 ; WX 600 ; N Uhungarumlaut ; B 4 -18 638 784 ;\nC -1 ; WX 600 ; N Eacute ; B 25 0 560 784 ;\nC -1 ; WX 600 ; N emacron ; B 40 -15 563 585 ;\nC -1 ; WX 600 ; N gbreve ; B 30 -146 580 661 ;\nC -1 ; WX 600 ; N onequarter ; B -56 -60 656 661 ;\nC -1 ; WX 600 ; N Scaron ; B 47 -22 553 790 ;\nC -1 ; WX 600 ; N Scommaaccent ; B 47 -250 553 582 ;\nC -1 ; WX 600 ; N Ohungarumlaut ; B 22 -18 628 784 ;\nC -1 ; WX 600 ; N degree ; B 86 243 474 616 ;\nC -1 ; WX 600 ; N ograve ; B 30 -15 570 661 ;\nC -1 ; WX 600 ; N Ccaron ; B 22 -18 560 790 ;\nC -1 ; WX 600 ; N ugrave ; B -1 -15 569 661 ;\nC -1 ; WX 600 ; N radical ; B -19 -104 473 778 ;\nC -1 ; WX 600 ; N Dcaron ; B 30 0 594 790 ;\nC -1 ; WX 600 ; N rcommaaccent ; B 47 -250 580 454 ;\nC -1 ; WX 600 ; N Ntilde ; B 8 -12 610 759 ;\nC -1 ; WX 600 ; N otilde ; B 30 -15 570 636 ;\nC -1 ; WX 600 ; N Rcommaaccent ; B 24 -250 599 562 ;\nC -1 ; WX 600 ; N Lcommaaccent ; B 39 -250 578 562 ;\nC -1 ; WX 600 ; N Atilde ; B -9 0 609 759 ;\nC -1 ; WX 600 ; N Aogonek ; B -9 -199 625 562 ;\nC -1 ; WX 600 ; N Aring ; B -9 0 609 801 ;\nC -1 ; WX 600 ; N Otilde ; B 22 -18 578 759 ;\nC -1 ; WX 600 ; N zdotaccent ; B 81 0 520 638 ;\nC -1 ; WX 600 ; N Ecaron ; B 25 0 560 790 ;\nC -1 ; WX 600 ; N Iogonek ; B 77 -199 523 562 ;\nC -1 ; WX 600 ; N kcommaaccent ; B 20 -250 585 626 ;\nC -1 ; WX 600 ; N minus ; B 71 203 529 313 ;\nC -1 ; WX 600 ; N Icircumflex ; B 77 0 523 780 ;\nC -1 ; WX 600 ; N ncaron ; B 18 0 592 667 ;\nC -1 ; WX 600 ; N tcommaaccent ; B 47 -250 532 562 ;\nC -1 ; WX 600 ; N logicalnot ; B 71 103 529 413 ;\nC -1 ; WX 600 ; N odieresis ; B 30 -15 570 638 ;\nC -1 ; WX 600 ; N udieresis ; B -1 -15 569 638 ;\nC -1 ; WX 600 ; N notequal ; B 12 -47 537 563 ;\nC -1 ; WX 600 ; N gcommaaccent ; B 30 -146 580 714 ;\nC -1 ; WX 600 ; N eth ; B 58 -27 543 626 ;\nC -1 ; WX 600 ; N zcaron ; B 81 0 520 667 ;\nC -1 ; WX 600 ; N ncommaaccent ; B 18 -250 592 454 ;\nC -1 ; WX 600 ; N onesuperior ; B 153 230 447 616 ;\nC -1 ; WX 600 ; N imacron ; B 77 0 523 585 ;\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nEndFontMetrics\n";
    },
    'Courier-Oblique' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 17:37:52 1997\nComment UniqueID 43051\nComment VMusage 16248 75829\nFontName Courier-Oblique\nFullName Courier Oblique\nFamilyName Courier\nWeight Medium\nItalicAngle -12\nIsFixedPitch true\nCharacterSet ExtendedRoman\nFontBBox -27 -250 849 805 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 003.000\nNotice Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nEncodingScheme AdobeStandardEncoding\nCapHeight 562\nXHeight 426\nAscender 629\nDescender -157\nStdHW 51\nStdVW 51\nStartCharMetrics 315\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 600 ; N exclam ; B 243 -15 464 572 ;\nC 34 ; WX 600 ; N quotedbl ; B 273 328 532 562 ;\nC 35 ; WX 600 ; N numbersign ; B 133 -32 596 639 ;\nC 36 ; WX 600 ; N dollar ; B 108 -126 596 662 ;\nC 37 ; WX 600 ; N percent ; B 134 -15 599 622 ;\nC 38 ; WX 600 ; N ampersand ; B 87 -15 580 543 ;\nC 39 ; WX 600 ; N quoteright ; B 283 328 495 562 ;\nC 40 ; WX 600 ; N parenleft ; B 313 -108 572 622 ;\nC 41 ; WX 600 ; N parenright ; B 137 -108 396 622 ;\nC 42 ; WX 600 ; N asterisk ; B 212 257 580 607 ;\nC 43 ; WX 600 ; N plus ; B 129 44 580 470 ;\nC 44 ; WX 600 ; N comma ; B 157 -112 370 122 ;\nC 45 ; WX 600 ; N hyphen ; B 152 231 558 285 ;\nC 46 ; WX 600 ; N period ; B 238 -15 382 109 ;\nC 47 ; WX 600 ; N slash ; B 112 -80 604 629 ;\nC 48 ; WX 600 ; N zero ; B 154 -15 575 622 ;\nC 49 ; WX 600 ; N one ; B 98 0 515 622 ;\nC 50 ; WX 600 ; N two ; B 70 0 568 622 ;\nC 51 ; WX 600 ; N three ; B 82 -15 538 622 ;\nC 52 ; WX 600 ; N four ; B 108 0 541 622 ;\nC 53 ; WX 600 ; N five ; B 99 -15 589 607 ;\nC 54 ; WX 600 ; N six ; B 155 -15 629 622 ;\nC 55 ; WX 600 ; N seven ; B 182 0 612 607 ;\nC 56 ; WX 600 ; N eight ; B 132 -15 588 622 ;\nC 57 ; WX 600 ; N nine ; B 93 -15 574 622 ;\nC 58 ; WX 600 ; N colon ; B 238 -15 441 385 ;\nC 59 ; WX 600 ; N semicolon ; B 157 -112 441 385 ;\nC 60 ; WX 600 ; N less ; B 96 42 610 472 ;\nC 61 ; WX 600 ; N equal ; B 109 138 600 376 ;\nC 62 ; WX 600 ; N greater ; B 85 42 599 472 ;\nC 63 ; WX 600 ; N question ; B 222 -15 583 572 ;\nC 64 ; WX 600 ; N at ; B 127 -15 582 622 ;\nC 65 ; WX 600 ; N A ; B 3 0 607 562 ;\nC 66 ; WX 600 ; N B ; B 43 0 616 562 ;\nC 67 ; WX 600 ; N C ; B 93 -18 655 580 ;\nC 68 ; WX 600 ; N D ; B 43 0 645 562 ;\nC 69 ; WX 600 ; N E ; B 53 0 660 562 ;\nC 70 ; WX 600 ; N F ; B 53 0 660 562 ;\nC 71 ; WX 600 ; N G ; B 83 -18 645 580 ;\nC 72 ; WX 600 ; N H ; B 32 0 687 562 ;\nC 73 ; WX 600 ; N I ; B 96 0 623 562 ;\nC 74 ; WX 600 ; N J ; B 52 -18 685 562 ;\nC 75 ; WX 600 ; N K ; B 38 0 671 562 ;\nC 76 ; WX 600 ; N L ; B 47 0 607 562 ;\nC 77 ; WX 600 ; N M ; B 4 0 715 562 ;\nC 78 ; WX 600 ; N N ; B 7 -13 712 562 ;\nC 79 ; WX 600 ; N O ; B 94 -18 625 580 ;\nC 80 ; WX 600 ; N P ; B 79 0 644 562 ;\nC 81 ; WX 600 ; N Q ; B 95 -138 625 580 ;\nC 82 ; WX 600 ; N R ; B 38 0 598 562 ;\nC 83 ; WX 600 ; N S ; B 76 -20 650 580 ;\nC 84 ; WX 600 ; N T ; B 108 0 665 562 ;\nC 85 ; WX 600 ; N U ; B 125 -18 702 562 ;\nC 86 ; WX 600 ; N V ; B 105 -13 723 562 ;\nC 87 ; WX 600 ; N W ; B 106 -13 722 562 ;\nC 88 ; WX 600 ; N X ; B 23 0 675 562 ;\nC 89 ; WX 600 ; N Y ; B 133 0 695 562 ;\nC 90 ; WX 600 ; N Z ; B 86 0 610 562 ;\nC 91 ; WX 600 ; N bracketleft ; B 246 -108 574 622 ;\nC 92 ; WX 600 ; N backslash ; B 249 -80 468 629 ;\nC 93 ; WX 600 ; N bracketright ; B 135 -108 463 622 ;\nC 94 ; WX 600 ; N asciicircum ; B 175 354 587 622 ;\nC 95 ; WX 600 ; N underscore ; B -27 -125 584 -75 ;\nC 96 ; WX 600 ; N quoteleft ; B 343 328 457 562 ;\nC 97 ; WX 600 ; N a ; B 76 -15 569 441 ;\nC 98 ; WX 600 ; N b ; B 29 -15 625 629 ;\nC 99 ; WX 600 ; N c ; B 106 -15 608 441 ;\nC 100 ; WX 600 ; N d ; B 85 -15 640 629 ;\nC 101 ; WX 600 ; N e ; B 106 -15 598 441 ;\nC 102 ; WX 600 ; N f ; B 114 0 662 629 ; L i fi ; L l fl ;\nC 103 ; WX 600 ; N g ; B 61 -157 657 441 ;\nC 104 ; WX 600 ; N h ; B 33 0 592 629 ;\nC 105 ; WX 600 ; N i ; B 95 0 515 657 ;\nC 106 ; WX 600 ; N j ; B 52 -157 550 657 ;\nC 107 ; WX 600 ; N k ; B 58 0 633 629 ;\nC 108 ; WX 600 ; N l ; B 95 0 515 629 ;\nC 109 ; WX 600 ; N m ; B -5 0 615 441 ;\nC 110 ; WX 600 ; N n ; B 26 0 585 441 ;\nC 111 ; WX 600 ; N o ; B 102 -15 588 441 ;\nC 112 ; WX 600 ; N p ; B -24 -157 605 441 ;\nC 113 ; WX 600 ; N q ; B 85 -157 682 441 ;\nC 114 ; WX 600 ; N r ; B 60 0 636 441 ;\nC 115 ; WX 600 ; N s ; B 78 -15 584 441 ;\nC 116 ; WX 600 ; N t ; B 167 -15 561 561 ;\nC 117 ; WX 600 ; N u ; B 101 -15 572 426 ;\nC 118 ; WX 600 ; N v ; B 90 -10 681 426 ;\nC 119 ; WX 600 ; N w ; B 76 -10 695 426 ;\nC 120 ; WX 600 ; N x ; B 20 0 655 426 ;\nC 121 ; WX 600 ; N y ; B -4 -157 683 426 ;\nC 122 ; WX 600 ; N z ; B 99 0 593 426 ;\nC 123 ; WX 600 ; N braceleft ; B 233 -108 569 622 ;\nC 124 ; WX 600 ; N bar ; B 222 -250 485 750 ;\nC 125 ; WX 600 ; N braceright ; B 140 -108 477 622 ;\nC 126 ; WX 600 ; N asciitilde ; B 116 197 600 320 ;\nC 161 ; WX 600 ; N exclamdown ; B 225 -157 445 430 ;\nC 162 ; WX 600 ; N cent ; B 151 -49 588 614 ;\nC 163 ; WX 600 ; N sterling ; B 124 -21 621 611 ;\nC 164 ; WX 600 ; N fraction ; B 84 -57 646 665 ;\nC 165 ; WX 600 ; N yen ; B 120 0 693 562 ;\nC 166 ; WX 600 ; N florin ; B -26 -143 671 622 ;\nC 167 ; WX 600 ; N section ; B 104 -78 590 580 ;\nC 168 ; WX 600 ; N currency ; B 94 58 628 506 ;\nC 169 ; WX 600 ; N quotesingle ; B 345 328 460 562 ;\nC 170 ; WX 600 ; N quotedblleft ; B 262 328 541 562 ;\nC 171 ; WX 600 ; N guillemotleft ; B 92 70 652 446 ;\nC 172 ; WX 600 ; N guilsinglleft ; B 204 70 540 446 ;\nC 173 ; WX 600 ; N guilsinglright ; B 170 70 506 446 ;\nC 174 ; WX 600 ; N fi ; B 3 0 619 629 ;\nC 175 ; WX 600 ; N fl ; B 3 0 619 629 ;\nC 177 ; WX 600 ; N endash ; B 124 231 586 285 ;\nC 178 ; WX 600 ; N dagger ; B 217 -78 546 580 ;\nC 179 ; WX 600 ; N daggerdbl ; B 163 -78 546 580 ;\nC 180 ; WX 600 ; N periodcentered ; B 275 189 434 327 ;\nC 182 ; WX 600 ; N paragraph ; B 100 -78 630 562 ;\nC 183 ; WX 600 ; N bullet ; B 224 130 485 383 ;\nC 184 ; WX 600 ; N quotesinglbase ; B 185 -134 397 100 ;\nC 185 ; WX 600 ; N quotedblbase ; B 115 -134 478 100 ;\nC 186 ; WX 600 ; N quotedblright ; B 213 328 576 562 ;\nC 187 ; WX 600 ; N guillemotright ; B 58 70 618 446 ;\nC 188 ; WX 600 ; N ellipsis ; B 46 -15 575 111 ;\nC 189 ; WX 600 ; N perthousand ; B 59 -15 627 622 ;\nC 191 ; WX 600 ; N questiondown ; B 105 -157 466 430 ;\nC 193 ; WX 600 ; N grave ; B 294 497 484 672 ;\nC 194 ; WX 600 ; N acute ; B 348 497 612 672 ;\nC 195 ; WX 600 ; N circumflex ; B 229 477 581 654 ;\nC 196 ; WX 600 ; N tilde ; B 212 489 629 606 ;\nC 197 ; WX 600 ; N macron ; B 232 525 600 565 ;\nC 198 ; WX 600 ; N breve ; B 279 501 576 609 ;\nC 199 ; WX 600 ; N dotaccent ; B 373 537 478 640 ;\nC 200 ; WX 600 ; N dieresis ; B 272 537 579 640 ;\nC 202 ; WX 600 ; N ring ; B 332 463 500 627 ;\nC 203 ; WX 600 ; N cedilla ; B 197 -151 344 10 ;\nC 205 ; WX 600 ; N hungarumlaut ; B 239 497 683 672 ;\nC 206 ; WX 600 ; N ogonek ; B 189 -172 377 4 ;\nC 207 ; WX 600 ; N caron ; B 262 492 614 669 ;\nC 208 ; WX 600 ; N emdash ; B 49 231 661 285 ;\nC 225 ; WX 600 ; N AE ; B 3 0 655 562 ;\nC 227 ; WX 600 ; N ordfeminine ; B 209 249 512 580 ;\nC 232 ; WX 600 ; N Lslash ; B 47 0 607 562 ;\nC 233 ; WX 600 ; N Oslash ; B 94 -80 625 629 ;\nC 234 ; WX 600 ; N OE ; B 59 0 672 562 ;\nC 235 ; WX 600 ; N ordmasculine ; B 210 249 535 580 ;\nC 241 ; WX 600 ; N ae ; B 41 -15 626 441 ;\nC 245 ; WX 600 ; N dotlessi ; B 95 0 515 426 ;\nC 248 ; WX 600 ; N lslash ; B 95 0 587 629 ;\nC 249 ; WX 600 ; N oslash ; B 102 -80 588 506 ;\nC 250 ; WX 600 ; N oe ; B 54 -15 615 441 ;\nC 251 ; WX 600 ; N germandbls ; B 48 -15 617 629 ;\nC -1 ; WX 600 ; N Idieresis ; B 96 0 623 753 ;\nC -1 ; WX 600 ; N eacute ; B 106 -15 612 672 ;\nC -1 ; WX 600 ; N abreve ; B 76 -15 576 609 ;\nC -1 ; WX 600 ; N uhungarumlaut ; B 101 -15 723 672 ;\nC -1 ; WX 600 ; N ecaron ; B 106 -15 614 669 ;\nC -1 ; WX 600 ; N Ydieresis ; B 133 0 695 753 ;\nC -1 ; WX 600 ; N divide ; B 136 48 573 467 ;\nC -1 ; WX 600 ; N Yacute ; B 133 0 695 805 ;\nC -1 ; WX 600 ; N Acircumflex ; B 3 0 607 787 ;\nC -1 ; WX 600 ; N aacute ; B 76 -15 612 672 ;\nC -1 ; WX 600 ; N Ucircumflex ; B 125 -18 702 787 ;\nC -1 ; WX 600 ; N yacute ; B -4 -157 683 672 ;\nC -1 ; WX 600 ; N scommaaccent ; B 78 -250 584 441 ;\nC -1 ; WX 600 ; N ecircumflex ; B 106 -15 598 654 ;\nC -1 ; WX 600 ; N Uring ; B 125 -18 702 760 ;\nC -1 ; WX 600 ; N Udieresis ; B 125 -18 702 753 ;\nC -1 ; WX 600 ; N aogonek ; B 76 -172 569 441 ;\nC -1 ; WX 600 ; N Uacute ; B 125 -18 702 805 ;\nC -1 ; WX 600 ; N uogonek ; B 101 -172 572 426 ;\nC -1 ; WX 600 ; N Edieresis ; B 53 0 660 753 ;\nC -1 ; WX 600 ; N Dcroat ; B 43 0 645 562 ;\nC -1 ; WX 600 ; N commaaccent ; B 145 -250 323 -58 ;\nC -1 ; WX 600 ; N copyright ; B 53 -18 667 580 ;\nC -1 ; WX 600 ; N Emacron ; B 53 0 660 698 ;\nC -1 ; WX 600 ; N ccaron ; B 106 -15 614 669 ;\nC -1 ; WX 600 ; N aring ; B 76 -15 569 627 ;\nC -1 ; WX 600 ; N Ncommaaccent ; B 7 -250 712 562 ;\nC -1 ; WX 600 ; N lacute ; B 95 0 640 805 ;\nC -1 ; WX 600 ; N agrave ; B 76 -15 569 672 ;\nC -1 ; WX 600 ; N Tcommaaccent ; B 108 -250 665 562 ;\nC -1 ; WX 600 ; N Cacute ; B 93 -18 655 805 ;\nC -1 ; WX 600 ; N atilde ; B 76 -15 629 606 ;\nC -1 ; WX 600 ; N Edotaccent ; B 53 0 660 753 ;\nC -1 ; WX 600 ; N scaron ; B 78 -15 614 669 ;\nC -1 ; WX 600 ; N scedilla ; B 78 -151 584 441 ;\nC -1 ; WX 600 ; N iacute ; B 95 0 612 672 ;\nC -1 ; WX 600 ; N lozenge ; B 94 0 519 706 ;\nC -1 ; WX 600 ; N Rcaron ; B 38 0 642 802 ;\nC -1 ; WX 600 ; N Gcommaaccent ; B 83 -250 645 580 ;\nC -1 ; WX 600 ; N ucircumflex ; B 101 -15 572 654 ;\nC -1 ; WX 600 ; N acircumflex ; B 76 -15 581 654 ;\nC -1 ; WX 600 ; N Amacron ; B 3 0 607 698 ;\nC -1 ; WX 600 ; N rcaron ; B 60 0 636 669 ;\nC -1 ; WX 600 ; N ccedilla ; B 106 -151 614 441 ;\nC -1 ; WX 600 ; N Zdotaccent ; B 86 0 610 753 ;\nC -1 ; WX 600 ; N Thorn ; B 79 0 606 562 ;\nC -1 ; WX 600 ; N Omacron ; B 94 -18 628 698 ;\nC -1 ; WX 600 ; N Racute ; B 38 0 670 805 ;\nC -1 ; WX 600 ; N Sacute ; B 76 -20 650 805 ;\nC -1 ; WX 600 ; N dcaron ; B 85 -15 849 629 ;\nC -1 ; WX 600 ; N Umacron ; B 125 -18 702 698 ;\nC -1 ; WX 600 ; N uring ; B 101 -15 572 627 ;\nC -1 ; WX 600 ; N threesuperior ; B 213 240 501 622 ;\nC -1 ; WX 600 ; N Ograve ; B 94 -18 625 805 ;\nC -1 ; WX 600 ; N Agrave ; B 3 0 607 805 ;\nC -1 ; WX 600 ; N Abreve ; B 3 0 607 732 ;\nC -1 ; WX 600 ; N multiply ; B 103 43 607 470 ;\nC -1 ; WX 600 ; N uacute ; B 101 -15 602 672 ;\nC -1 ; WX 600 ; N Tcaron ; B 108 0 665 802 ;\nC -1 ; WX 600 ; N partialdiff ; B 45 -38 546 710 ;\nC -1 ; WX 600 ; N ydieresis ; B -4 -157 683 620 ;\nC -1 ; WX 600 ; N Nacute ; B 7 -13 712 805 ;\nC -1 ; WX 600 ; N icircumflex ; B 95 0 551 654 ;\nC -1 ; WX 600 ; N Ecircumflex ; B 53 0 660 787 ;\nC -1 ; WX 600 ; N adieresis ; B 76 -15 575 620 ;\nC -1 ; WX 600 ; N edieresis ; B 106 -15 598 620 ;\nC -1 ; WX 600 ; N cacute ; B 106 -15 612 672 ;\nC -1 ; WX 600 ; N nacute ; B 26 0 602 672 ;\nC -1 ; WX 600 ; N umacron ; B 101 -15 600 565 ;\nC -1 ; WX 600 ; N Ncaron ; B 7 -13 712 802 ;\nC -1 ; WX 600 ; N Iacute ; B 96 0 640 805 ;\nC -1 ; WX 600 ; N plusminus ; B 96 44 594 558 ;\nC -1 ; WX 600 ; N brokenbar ; B 238 -175 469 675 ;\nC -1 ; WX 600 ; N registered ; B 53 -18 667 580 ;\nC -1 ; WX 600 ; N Gbreve ; B 83 -18 645 732 ;\nC -1 ; WX 600 ; N Idotaccent ; B 96 0 623 753 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 670 706 ;\nC -1 ; WX 600 ; N Egrave ; B 53 0 660 805 ;\nC -1 ; WX 600 ; N racute ; B 60 0 636 672 ;\nC -1 ; WX 600 ; N omacron ; B 102 -15 600 565 ;\nC -1 ; WX 600 ; N Zacute ; B 86 0 670 805 ;\nC -1 ; WX 600 ; N Zcaron ; B 86 0 642 802 ;\nC -1 ; WX 600 ; N greaterequal ; B 98 0 594 710 ;\nC -1 ; WX 600 ; N Eth ; B 43 0 645 562 ;\nC -1 ; WX 600 ; N Ccedilla ; B 93 -151 658 580 ;\nC -1 ; WX 600 ; N lcommaaccent ; B 95 -250 515 629 ;\nC -1 ; WX 600 ; N tcaron ; B 167 -15 587 717 ;\nC -1 ; WX 600 ; N eogonek ; B 106 -172 598 441 ;\nC -1 ; WX 600 ; N Uogonek ; B 124 -172 702 562 ;\nC -1 ; WX 600 ; N Aacute ; B 3 0 660 805 ;\nC -1 ; WX 600 ; N Adieresis ; B 3 0 607 753 ;\nC -1 ; WX 600 ; N egrave ; B 106 -15 598 672 ;\nC -1 ; WX 600 ; N zacute ; B 99 0 612 672 ;\nC -1 ; WX 600 ; N iogonek ; B 95 -172 515 657 ;\nC -1 ; WX 600 ; N Oacute ; B 94 -18 640 805 ;\nC -1 ; WX 600 ; N oacute ; B 102 -15 612 672 ;\nC -1 ; WX 600 ; N amacron ; B 76 -15 600 565 ;\nC -1 ; WX 600 ; N sacute ; B 78 -15 612 672 ;\nC -1 ; WX 600 ; N idieresis ; B 95 0 545 620 ;\nC -1 ; WX 600 ; N Ocircumflex ; B 94 -18 625 787 ;\nC -1 ; WX 600 ; N Ugrave ; B 125 -18 702 805 ;\nC -1 ; WX 600 ; N Delta ; B 6 0 598 688 ;\nC -1 ; WX 600 ; N thorn ; B -24 -157 605 629 ;\nC -1 ; WX 600 ; N twosuperior ; B 230 249 535 622 ;\nC -1 ; WX 600 ; N Odieresis ; B 94 -18 625 753 ;\nC -1 ; WX 600 ; N mu ; B 72 -157 572 426 ;\nC -1 ; WX 600 ; N igrave ; B 95 0 515 672 ;\nC -1 ; WX 600 ; N ohungarumlaut ; B 102 -15 723 672 ;\nC -1 ; WX 600 ; N Eogonek ; B 53 -172 660 562 ;\nC -1 ; WX 600 ; N dcroat ; B 85 -15 704 629 ;\nC -1 ; WX 600 ; N threequarters ; B 73 -56 659 666 ;\nC -1 ; WX 600 ; N Scedilla ; B 76 -151 650 580 ;\nC -1 ; WX 600 ; N lcaron ; B 95 0 667 629 ;\nC -1 ; WX 600 ; N Kcommaaccent ; B 38 -250 671 562 ;\nC -1 ; WX 600 ; N Lacute ; B 47 0 607 805 ;\nC -1 ; WX 600 ; N trademark ; B 75 263 742 562 ;\nC -1 ; WX 600 ; N edotaccent ; B 106 -15 598 620 ;\nC -1 ; WX 600 ; N Igrave ; B 96 0 623 805 ;\nC -1 ; WX 600 ; N Imacron ; B 96 0 628 698 ;\nC -1 ; WX 600 ; N Lcaron ; B 47 0 632 562 ;\nC -1 ; WX 600 ; N onehalf ; B 65 -57 669 665 ;\nC -1 ; WX 600 ; N lessequal ; B 98 0 645 710 ;\nC -1 ; WX 600 ; N ocircumflex ; B 102 -15 588 654 ;\nC -1 ; WX 600 ; N ntilde ; B 26 0 629 606 ;\nC -1 ; WX 600 ; N Uhungarumlaut ; B 125 -18 761 805 ;\nC -1 ; WX 600 ; N Eacute ; B 53 0 670 805 ;\nC -1 ; WX 600 ; N emacron ; B 106 -15 600 565 ;\nC -1 ; WX 600 ; N gbreve ; B 61 -157 657 609 ;\nC -1 ; WX 600 ; N onequarter ; B 65 -57 674 665 ;\nC -1 ; WX 600 ; N Scaron ; B 76 -20 672 802 ;\nC -1 ; WX 600 ; N Scommaaccent ; B 76 -250 650 580 ;\nC -1 ; WX 600 ; N Ohungarumlaut ; B 94 -18 751 805 ;\nC -1 ; WX 600 ; N degree ; B 214 269 576 622 ;\nC -1 ; WX 600 ; N ograve ; B 102 -15 588 672 ;\nC -1 ; WX 600 ; N Ccaron ; B 93 -18 672 802 ;\nC -1 ; WX 600 ; N ugrave ; B 101 -15 572 672 ;\nC -1 ; WX 600 ; N radical ; B 85 -15 765 792 ;\nC -1 ; WX 600 ; N Dcaron ; B 43 0 645 802 ;\nC -1 ; WX 600 ; N rcommaaccent ; B 60 -250 636 441 ;\nC -1 ; WX 600 ; N Ntilde ; B 7 -13 712 729 ;\nC -1 ; WX 600 ; N otilde ; B 102 -15 629 606 ;\nC -1 ; WX 600 ; N Rcommaaccent ; B 38 -250 598 562 ;\nC -1 ; WX 600 ; N Lcommaaccent ; B 47 -250 607 562 ;\nC -1 ; WX 600 ; N Atilde ; B 3 0 655 729 ;\nC -1 ; WX 600 ; N Aogonek ; B 3 -172 607 562 ;\nC -1 ; WX 600 ; N Aring ; B 3 0 607 750 ;\nC -1 ; WX 600 ; N Otilde ; B 94 -18 655 729 ;\nC -1 ; WX 600 ; N zdotaccent ; B 99 0 593 620 ;\nC -1 ; WX 600 ; N Ecaron ; B 53 0 660 802 ;\nC -1 ; WX 600 ; N Iogonek ; B 96 -172 623 562 ;\nC -1 ; WX 600 ; N kcommaaccent ; B 58 -250 633 629 ;\nC -1 ; WX 600 ; N minus ; B 129 232 580 283 ;\nC -1 ; WX 600 ; N Icircumflex ; B 96 0 623 787 ;\nC -1 ; WX 600 ; N ncaron ; B 26 0 614 669 ;\nC -1 ; WX 600 ; N tcommaaccent ; B 165 -250 561 561 ;\nC -1 ; WX 600 ; N logicalnot ; B 155 108 591 369 ;\nC -1 ; WX 600 ; N odieresis ; B 102 -15 588 620 ;\nC -1 ; WX 600 ; N udieresis ; B 101 -15 575 620 ;\nC -1 ; WX 600 ; N notequal ; B 43 -16 621 529 ;\nC -1 ; WX 600 ; N gcommaaccent ; B 61 -157 657 708 ;\nC -1 ; WX 600 ; N eth ; B 102 -15 639 629 ;\nC -1 ; WX 600 ; N zcaron ; B 99 0 624 669 ;\nC -1 ; WX 600 ; N ncommaaccent ; B 26 -250 585 441 ;\nC -1 ; WX 600 ; N onesuperior ; B 231 249 491 622 ;\nC -1 ; WX 600 ; N imacron ; B 95 0 543 565 ;\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nEndFontMetrics\n";
    },
    'Courier-BoldOblique' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Mon Jun 23 16:28:46 1997\nComment UniqueID 43049\nComment VMusage 17529 79244\nFontName Courier-BoldOblique\nFullName Courier Bold Oblique\nFamilyName Courier\nWeight Bold\nItalicAngle -12\nIsFixedPitch true\nCharacterSet ExtendedRoman\nFontBBox -57 -250 869 801 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 003.000\nNotice Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nEncodingScheme AdobeStandardEncoding\nCapHeight 562\nXHeight 439\nAscender 629\nDescender -157\nStdHW 84\nStdVW 106\nStartCharMetrics 315\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 600 ; N exclam ; B 215 -15 495 572 ;\nC 34 ; WX 600 ; N quotedbl ; B 211 277 585 562 ;\nC 35 ; WX 600 ; N numbersign ; B 88 -45 641 651 ;\nC 36 ; WX 600 ; N dollar ; B 87 -126 630 666 ;\nC 37 ; WX 600 ; N percent ; B 101 -15 625 616 ;\nC 38 ; WX 600 ; N ampersand ; B 61 -15 595 543 ;\nC 39 ; WX 600 ; N quoteright ; B 229 277 543 562 ;\nC 40 ; WX 600 ; N parenleft ; B 265 -102 592 616 ;\nC 41 ; WX 600 ; N parenright ; B 117 -102 444 616 ;\nC 42 ; WX 600 ; N asterisk ; B 179 219 598 601 ;\nC 43 ; WX 600 ; N plus ; B 114 39 596 478 ;\nC 44 ; WX 600 ; N comma ; B 99 -111 430 174 ;\nC 45 ; WX 600 ; N hyphen ; B 143 203 567 313 ;\nC 46 ; WX 600 ; N period ; B 206 -15 427 171 ;\nC 47 ; WX 600 ; N slash ; B 90 -77 626 626 ;\nC 48 ; WX 600 ; N zero ; B 135 -15 593 616 ;\nC 49 ; WX 600 ; N one ; B 93 0 562 616 ;\nC 50 ; WX 600 ; N two ; B 61 0 594 616 ;\nC 51 ; WX 600 ; N three ; B 71 -15 571 616 ;\nC 52 ; WX 600 ; N four ; B 81 0 559 616 ;\nC 53 ; WX 600 ; N five ; B 77 -15 621 601 ;\nC 54 ; WX 600 ; N six ; B 135 -15 652 616 ;\nC 55 ; WX 600 ; N seven ; B 147 0 622 601 ;\nC 56 ; WX 600 ; N eight ; B 115 -15 604 616 ;\nC 57 ; WX 600 ; N nine ; B 75 -15 592 616 ;\nC 58 ; WX 600 ; N colon ; B 205 -15 480 425 ;\nC 59 ; WX 600 ; N semicolon ; B 99 -111 481 425 ;\nC 60 ; WX 600 ; N less ; B 120 15 613 501 ;\nC 61 ; WX 600 ; N equal ; B 96 118 614 398 ;\nC 62 ; WX 600 ; N greater ; B 97 15 589 501 ;\nC 63 ; WX 600 ; N question ; B 183 -14 592 580 ;\nC 64 ; WX 600 ; N at ; B 65 -15 642 616 ;\nC 65 ; WX 600 ; N A ; B -9 0 632 562 ;\nC 66 ; WX 600 ; N B ; B 30 0 630 562 ;\nC 67 ; WX 600 ; N C ; B 74 -18 675 580 ;\nC 68 ; WX 600 ; N D ; B 30 0 664 562 ;\nC 69 ; WX 600 ; N E ; B 25 0 670 562 ;\nC 70 ; WX 600 ; N F ; B 39 0 684 562 ;\nC 71 ; WX 600 ; N G ; B 74 -18 675 580 ;\nC 72 ; WX 600 ; N H ; B 20 0 700 562 ;\nC 73 ; WX 600 ; N I ; B 77 0 643 562 ;\nC 74 ; WX 600 ; N J ; B 58 -18 721 562 ;\nC 75 ; WX 600 ; N K ; B 21 0 692 562 ;\nC 76 ; WX 600 ; N L ; B 39 0 636 562 ;\nC 77 ; WX 600 ; N M ; B -2 0 722 562 ;\nC 78 ; WX 600 ; N N ; B 8 -12 730 562 ;\nC 79 ; WX 600 ; N O ; B 74 -18 645 580 ;\nC 80 ; WX 600 ; N P ; B 48 0 643 562 ;\nC 81 ; WX 600 ; N Q ; B 83 -138 636 580 ;\nC 82 ; WX 600 ; N R ; B 24 0 617 562 ;\nC 83 ; WX 600 ; N S ; B 54 -22 673 582 ;\nC 84 ; WX 600 ; N T ; B 86 0 679 562 ;\nC 85 ; WX 600 ; N U ; B 101 -18 716 562 ;\nC 86 ; WX 600 ; N V ; B 84 0 733 562 ;\nC 87 ; WX 600 ; N W ; B 79 0 738 562 ;\nC 88 ; WX 600 ; N X ; B 12 0 690 562 ;\nC 89 ; WX 600 ; N Y ; B 109 0 709 562 ;\nC 90 ; WX 600 ; N Z ; B 62 0 637 562 ;\nC 91 ; WX 600 ; N bracketleft ; B 223 -102 606 616 ;\nC 92 ; WX 600 ; N backslash ; B 222 -77 496 626 ;\nC 93 ; WX 600 ; N bracketright ; B 103 -102 486 616 ;\nC 94 ; WX 600 ; N asciicircum ; B 171 250 556 616 ;\nC 95 ; WX 600 ; N underscore ; B -27 -125 585 -75 ;\nC 96 ; WX 600 ; N quoteleft ; B 297 277 487 562 ;\nC 97 ; WX 600 ; N a ; B 61 -15 593 454 ;\nC 98 ; WX 600 ; N b ; B 13 -15 636 626 ;\nC 99 ; WX 600 ; N c ; B 81 -15 631 459 ;\nC 100 ; WX 600 ; N d ; B 60 -15 645 626 ;\nC 101 ; WX 600 ; N e ; B 81 -15 605 454 ;\nC 102 ; WX 600 ; N f ; B 83 0 677 626 ; L i fi ; L l fl ;\nC 103 ; WX 600 ; N g ; B 40 -146 674 454 ;\nC 104 ; WX 600 ; N h ; B 18 0 615 626 ;\nC 105 ; WX 600 ; N i ; B 77 0 546 658 ;\nC 106 ; WX 600 ; N j ; B 36 -146 580 658 ;\nC 107 ; WX 600 ; N k ; B 33 0 643 626 ;\nC 108 ; WX 600 ; N l ; B 77 0 546 626 ;\nC 109 ; WX 600 ; N m ; B -22 0 649 454 ;\nC 110 ; WX 600 ; N n ; B 18 0 615 454 ;\nC 111 ; WX 600 ; N o ; B 71 -15 622 454 ;\nC 112 ; WX 600 ; N p ; B -32 -142 622 454 ;\nC 113 ; WX 600 ; N q ; B 60 -142 685 454 ;\nC 114 ; WX 600 ; N r ; B 47 0 655 454 ;\nC 115 ; WX 600 ; N s ; B 66 -17 608 459 ;\nC 116 ; WX 600 ; N t ; B 118 -15 567 562 ;\nC 117 ; WX 600 ; N u ; B 70 -15 592 439 ;\nC 118 ; WX 600 ; N v ; B 70 0 695 439 ;\nC 119 ; WX 600 ; N w ; B 53 0 712 439 ;\nC 120 ; WX 600 ; N x ; B 6 0 671 439 ;\nC 121 ; WX 600 ; N y ; B -21 -142 695 439 ;\nC 122 ; WX 600 ; N z ; B 81 0 614 439 ;\nC 123 ; WX 600 ; N braceleft ; B 203 -102 595 616 ;\nC 124 ; WX 600 ; N bar ; B 201 -250 505 750 ;\nC 125 ; WX 600 ; N braceright ; B 114 -102 506 616 ;\nC 126 ; WX 600 ; N asciitilde ; B 120 153 590 356 ;\nC 161 ; WX 600 ; N exclamdown ; B 196 -146 477 449 ;\nC 162 ; WX 600 ; N cent ; B 121 -49 605 614 ;\nC 163 ; WX 600 ; N sterling ; B 106 -28 650 611 ;\nC 164 ; WX 600 ; N fraction ; B 22 -60 708 661 ;\nC 165 ; WX 600 ; N yen ; B 98 0 710 562 ;\nC 166 ; WX 600 ; N florin ; B -57 -131 702 616 ;\nC 167 ; WX 600 ; N section ; B 74 -70 620 580 ;\nC 168 ; WX 600 ; N currency ; B 77 49 644 517 ;\nC 169 ; WX 600 ; N quotesingle ; B 303 277 493 562 ;\nC 170 ; WX 600 ; N quotedblleft ; B 190 277 594 562 ;\nC 171 ; WX 600 ; N guillemotleft ; B 62 70 639 446 ;\nC 172 ; WX 600 ; N guilsinglleft ; B 195 70 545 446 ;\nC 173 ; WX 600 ; N guilsinglright ; B 165 70 514 446 ;\nC 174 ; WX 600 ; N fi ; B 12 0 644 626 ;\nC 175 ; WX 600 ; N fl ; B 12 0 644 626 ;\nC 177 ; WX 600 ; N endash ; B 108 203 602 313 ;\nC 178 ; WX 600 ; N dagger ; B 175 -70 586 580 ;\nC 179 ; WX 600 ; N daggerdbl ; B 121 -70 587 580 ;\nC 180 ; WX 600 ; N periodcentered ; B 248 165 461 351 ;\nC 182 ; WX 600 ; N paragraph ; B 61 -70 700 580 ;\nC 183 ; WX 600 ; N bullet ; B 196 132 523 430 ;\nC 184 ; WX 600 ; N quotesinglbase ; B 144 -142 458 143 ;\nC 185 ; WX 600 ; N quotedblbase ; B 34 -142 560 143 ;\nC 186 ; WX 600 ; N quotedblright ; B 119 277 645 562 ;\nC 187 ; WX 600 ; N guillemotright ; B 71 70 647 446 ;\nC 188 ; WX 600 ; N ellipsis ; B 35 -15 587 116 ;\nC 189 ; WX 600 ; N perthousand ; B -45 -15 743 616 ;\nC 191 ; WX 600 ; N questiondown ; B 100 -146 509 449 ;\nC 193 ; WX 600 ; N grave ; B 272 508 503 661 ;\nC 194 ; WX 600 ; N acute ; B 312 508 609 661 ;\nC 195 ; WX 600 ; N circumflex ; B 212 483 607 657 ;\nC 196 ; WX 600 ; N tilde ; B 199 493 643 636 ;\nC 197 ; WX 600 ; N macron ; B 195 505 637 585 ;\nC 198 ; WX 600 ; N breve ; B 217 468 652 631 ;\nC 199 ; WX 600 ; N dotaccent ; B 348 498 493 638 ;\nC 200 ; WX 600 ; N dieresis ; B 246 498 595 638 ;\nC 202 ; WX 600 ; N ring ; B 319 481 528 678 ;\nC 203 ; WX 600 ; N cedilla ; B 168 -206 368 0 ;\nC 205 ; WX 600 ; N hungarumlaut ; B 171 488 729 661 ;\nC 206 ; WX 600 ; N ogonek ; B 143 -199 367 0 ;\nC 207 ; WX 600 ; N caron ; B 238 493 633 667 ;\nC 208 ; WX 600 ; N emdash ; B 33 203 677 313 ;\nC 225 ; WX 600 ; N AE ; B -29 0 708 562 ;\nC 227 ; WX 600 ; N ordfeminine ; B 188 196 526 580 ;\nC 232 ; WX 600 ; N Lslash ; B 39 0 636 562 ;\nC 233 ; WX 600 ; N Oslash ; B 48 -22 673 584 ;\nC 234 ; WX 600 ; N OE ; B 26 0 701 562 ;\nC 235 ; WX 600 ; N ordmasculine ; B 188 196 543 580 ;\nC 241 ; WX 600 ; N ae ; B 21 -15 652 454 ;\nC 245 ; WX 600 ; N dotlessi ; B 77 0 546 439 ;\nC 248 ; WX 600 ; N lslash ; B 77 0 587 626 ;\nC 249 ; WX 600 ; N oslash ; B 54 -24 638 463 ;\nC 250 ; WX 600 ; N oe ; B 18 -15 662 454 ;\nC 251 ; WX 600 ; N germandbls ; B 22 -15 629 626 ;\nC -1 ; WX 600 ; N Idieresis ; B 77 0 643 761 ;\nC -1 ; WX 600 ; N eacute ; B 81 -15 609 661 ;\nC -1 ; WX 600 ; N abreve ; B 61 -15 658 661 ;\nC -1 ; WX 600 ; N uhungarumlaut ; B 70 -15 769 661 ;\nC -1 ; WX 600 ; N ecaron ; B 81 -15 633 667 ;\nC -1 ; WX 600 ; N Ydieresis ; B 109 0 709 761 ;\nC -1 ; WX 600 ; N divide ; B 114 16 596 500 ;\nC -1 ; WX 600 ; N Yacute ; B 109 0 709 784 ;\nC -1 ; WX 600 ; N Acircumflex ; B -9 0 632 780 ;\nC -1 ; WX 600 ; N aacute ; B 61 -15 609 661 ;\nC -1 ; WX 600 ; N Ucircumflex ; B 101 -18 716 780 ;\nC -1 ; WX 600 ; N yacute ; B -21 -142 695 661 ;\nC -1 ; WX 600 ; N scommaaccent ; B 66 -250 608 459 ;\nC -1 ; WX 600 ; N ecircumflex ; B 81 -15 607 657 ;\nC -1 ; WX 600 ; N Uring ; B 101 -18 716 801 ;\nC -1 ; WX 600 ; N Udieresis ; B 101 -18 716 761 ;\nC -1 ; WX 600 ; N aogonek ; B 61 -199 593 454 ;\nC -1 ; WX 600 ; N Uacute ; B 101 -18 716 784 ;\nC -1 ; WX 600 ; N uogonek ; B 70 -199 592 439 ;\nC -1 ; WX 600 ; N Edieresis ; B 25 0 670 761 ;\nC -1 ; WX 600 ; N Dcroat ; B 30 0 664 562 ;\nC -1 ; WX 600 ; N commaaccent ; B 151 -250 385 -57 ;\nC -1 ; WX 600 ; N copyright ; B 53 -18 667 580 ;\nC -1 ; WX 600 ; N Emacron ; B 25 0 670 708 ;\nC -1 ; WX 600 ; N ccaron ; B 81 -15 633 667 ;\nC -1 ; WX 600 ; N aring ; B 61 -15 593 678 ;\nC -1 ; WX 600 ; N Ncommaaccent ; B 8 -250 730 562 ;\nC -1 ; WX 600 ; N lacute ; B 77 0 639 801 ;\nC -1 ; WX 600 ; N agrave ; B 61 -15 593 661 ;\nC -1 ; WX 600 ; N Tcommaaccent ; B 86 -250 679 562 ;\nC -1 ; WX 600 ; N Cacute ; B 74 -18 675 784 ;\nC -1 ; WX 600 ; N atilde ; B 61 -15 643 636 ;\nC -1 ; WX 600 ; N Edotaccent ; B 25 0 670 761 ;\nC -1 ; WX 600 ; N scaron ; B 66 -17 633 667 ;\nC -1 ; WX 600 ; N scedilla ; B 66 -206 608 459 ;\nC -1 ; WX 600 ; N iacute ; B 77 0 609 661 ;\nC -1 ; WX 600 ; N lozenge ; B 145 0 614 740 ;\nC -1 ; WX 600 ; N Rcaron ; B 24 0 659 790 ;\nC -1 ; WX 600 ; N Gcommaaccent ; B 74 -250 675 580 ;\nC -1 ; WX 600 ; N ucircumflex ; B 70 -15 597 657 ;\nC -1 ; WX 600 ; N acircumflex ; B 61 -15 607 657 ;\nC -1 ; WX 600 ; N Amacron ; B -9 0 633 708 ;\nC -1 ; WX 600 ; N rcaron ; B 47 0 655 667 ;\nC -1 ; WX 600 ; N ccedilla ; B 81 -206 631 459 ;\nC -1 ; WX 600 ; N Zdotaccent ; B 62 0 637 761 ;\nC -1 ; WX 600 ; N Thorn ; B 48 0 620 562 ;\nC -1 ; WX 600 ; N Omacron ; B 74 -18 663 708 ;\nC -1 ; WX 600 ; N Racute ; B 24 0 665 784 ;\nC -1 ; WX 600 ; N Sacute ; B 54 -22 673 784 ;\nC -1 ; WX 600 ; N dcaron ; B 60 -15 861 626 ;\nC -1 ; WX 600 ; N Umacron ; B 101 -18 716 708 ;\nC -1 ; WX 600 ; N uring ; B 70 -15 592 678 ;\nC -1 ; WX 600 ; N threesuperior ; B 193 222 526 616 ;\nC -1 ; WX 600 ; N Ograve ; B 74 -18 645 784 ;\nC -1 ; WX 600 ; N Agrave ; B -9 0 632 784 ;\nC -1 ; WX 600 ; N Abreve ; B -9 0 684 784 ;\nC -1 ; WX 600 ; N multiply ; B 104 39 606 478 ;\nC -1 ; WX 600 ; N uacute ; B 70 -15 599 661 ;\nC -1 ; WX 600 ; N Tcaron ; B 86 0 679 790 ;\nC -1 ; WX 600 ; N partialdiff ; B 91 -38 627 728 ;\nC -1 ; WX 600 ; N ydieresis ; B -21 -142 695 638 ;\nC -1 ; WX 600 ; N Nacute ; B 8 -12 730 784 ;\nC -1 ; WX 600 ; N icircumflex ; B 77 0 577 657 ;\nC -1 ; WX 600 ; N Ecircumflex ; B 25 0 670 780 ;\nC -1 ; WX 600 ; N adieresis ; B 61 -15 595 638 ;\nC -1 ; WX 600 ; N edieresis ; B 81 -15 605 638 ;\nC -1 ; WX 600 ; N cacute ; B 81 -15 649 661 ;\nC -1 ; WX 600 ; N nacute ; B 18 0 639 661 ;\nC -1 ; WX 600 ; N umacron ; B 70 -15 637 585 ;\nC -1 ; WX 600 ; N Ncaron ; B 8 -12 730 790 ;\nC -1 ; WX 600 ; N Iacute ; B 77 0 643 784 ;\nC -1 ; WX 600 ; N plusminus ; B 76 24 614 515 ;\nC -1 ; WX 600 ; N brokenbar ; B 217 -175 489 675 ;\nC -1 ; WX 600 ; N registered ; B 53 -18 667 580 ;\nC -1 ; WX 600 ; N Gbreve ; B 74 -18 684 784 ;\nC -1 ; WX 600 ; N Idotaccent ; B 77 0 643 761 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 672 706 ;\nC -1 ; WX 600 ; N Egrave ; B 25 0 670 784 ;\nC -1 ; WX 600 ; N racute ; B 47 0 655 661 ;\nC -1 ; WX 600 ; N omacron ; B 71 -15 637 585 ;\nC -1 ; WX 600 ; N Zacute ; B 62 0 665 784 ;\nC -1 ; WX 600 ; N Zcaron ; B 62 0 659 790 ;\nC -1 ; WX 600 ; N greaterequal ; B 26 0 627 696 ;\nC -1 ; WX 600 ; N Eth ; B 30 0 664 562 ;\nC -1 ; WX 600 ; N Ccedilla ; B 74 -206 675 580 ;\nC -1 ; WX 600 ; N lcommaaccent ; B 77 -250 546 626 ;\nC -1 ; WX 600 ; N tcaron ; B 118 -15 627 703 ;\nC -1 ; WX 600 ; N eogonek ; B 81 -199 605 454 ;\nC -1 ; WX 600 ; N Uogonek ; B 101 -199 716 562 ;\nC -1 ; WX 600 ; N Aacute ; B -9 0 655 784 ;\nC -1 ; WX 600 ; N Adieresis ; B -9 0 632 761 ;\nC -1 ; WX 600 ; N egrave ; B 81 -15 605 661 ;\nC -1 ; WX 600 ; N zacute ; B 81 0 614 661 ;\nC -1 ; WX 600 ; N iogonek ; B 77 -199 546 658 ;\nC -1 ; WX 600 ; N Oacute ; B 74 -18 645 784 ;\nC -1 ; WX 600 ; N oacute ; B 71 -15 649 661 ;\nC -1 ; WX 600 ; N amacron ; B 61 -15 637 585 ;\nC -1 ; WX 600 ; N sacute ; B 66 -17 609 661 ;\nC -1 ; WX 600 ; N idieresis ; B 77 0 561 618 ;\nC -1 ; WX 600 ; N Ocircumflex ; B 74 -18 645 780 ;\nC -1 ; WX 600 ; N Ugrave ; B 101 -18 716 784 ;\nC -1 ; WX 600 ; N Delta ; B 6 0 594 688 ;\nC -1 ; WX 600 ; N thorn ; B -32 -142 622 626 ;\nC -1 ; WX 600 ; N twosuperior ; B 191 230 542 616 ;\nC -1 ; WX 600 ; N Odieresis ; B 74 -18 645 761 ;\nC -1 ; WX 600 ; N mu ; B 49 -142 592 439 ;\nC -1 ; WX 600 ; N igrave ; B 77 0 546 661 ;\nC -1 ; WX 600 ; N ohungarumlaut ; B 71 -15 809 661 ;\nC -1 ; WX 600 ; N Eogonek ; B 25 -199 670 562 ;\nC -1 ; WX 600 ; N dcroat ; B 60 -15 712 626 ;\nC -1 ; WX 600 ; N threequarters ; B 8 -60 699 661 ;\nC -1 ; WX 600 ; N Scedilla ; B 54 -206 673 582 ;\nC -1 ; WX 600 ; N lcaron ; B 77 0 731 626 ;\nC -1 ; WX 600 ; N Kcommaaccent ; B 21 -250 692 562 ;\nC -1 ; WX 600 ; N Lacute ; B 39 0 636 784 ;\nC -1 ; WX 600 ; N trademark ; B 86 230 869 562 ;\nC -1 ; WX 600 ; N edotaccent ; B 81 -15 605 638 ;\nC -1 ; WX 600 ; N Igrave ; B 77 0 643 784 ;\nC -1 ; WX 600 ; N Imacron ; B 77 0 663 708 ;\nC -1 ; WX 600 ; N Lcaron ; B 39 0 757 562 ;\nC -1 ; WX 600 ; N onehalf ; B 22 -60 716 661 ;\nC -1 ; WX 600 ; N lessequal ; B 26 0 671 696 ;\nC -1 ; WX 600 ; N ocircumflex ; B 71 -15 622 657 ;\nC -1 ; WX 600 ; N ntilde ; B 18 0 643 636 ;\nC -1 ; WX 600 ; N Uhungarumlaut ; B 101 -18 805 784 ;\nC -1 ; WX 600 ; N Eacute ; B 25 0 670 784 ;\nC -1 ; WX 600 ; N emacron ; B 81 -15 637 585 ;\nC -1 ; WX 600 ; N gbreve ; B 40 -146 674 661 ;\nC -1 ; WX 600 ; N onequarter ; B 13 -60 707 661 ;\nC -1 ; WX 600 ; N Scaron ; B 54 -22 689 790 ;\nC -1 ; WX 600 ; N Scommaaccent ; B 54 -250 673 582 ;\nC -1 ; WX 600 ; N Ohungarumlaut ; B 74 -18 795 784 ;\nC -1 ; WX 600 ; N degree ; B 173 243 570 616 ;\nC -1 ; WX 600 ; N ograve ; B 71 -15 622 661 ;\nC -1 ; WX 600 ; N Ccaron ; B 74 -18 689 790 ;\nC -1 ; WX 600 ; N ugrave ; B 70 -15 592 661 ;\nC -1 ; WX 600 ; N radical ; B 67 -104 635 778 ;\nC -1 ; WX 600 ; N Dcaron ; B 30 0 664 790 ;\nC -1 ; WX 600 ; N rcommaaccent ; B 47 -250 655 454 ;\nC -1 ; WX 600 ; N Ntilde ; B 8 -12 730 759 ;\nC -1 ; WX 600 ; N otilde ; B 71 -15 643 636 ;\nC -1 ; WX 600 ; N Rcommaaccent ; B 24 -250 617 562 ;\nC -1 ; WX 600 ; N Lcommaaccent ; B 39 -250 636 562 ;\nC -1 ; WX 600 ; N Atilde ; B -9 0 669 759 ;\nC -1 ; WX 600 ; N Aogonek ; B -9 -199 632 562 ;\nC -1 ; WX 600 ; N Aring ; B -9 0 632 801 ;\nC -1 ; WX 600 ; N Otilde ; B 74 -18 669 759 ;\nC -1 ; WX 600 ; N zdotaccent ; B 81 0 614 638 ;\nC -1 ; WX 600 ; N Ecaron ; B 25 0 670 790 ;\nC -1 ; WX 600 ; N Iogonek ; B 77 -199 643 562 ;\nC -1 ; WX 600 ; N kcommaaccent ; B 33 -250 643 626 ;\nC -1 ; WX 600 ; N minus ; B 114 203 596 313 ;\nC -1 ; WX 600 ; N Icircumflex ; B 77 0 643 780 ;\nC -1 ; WX 600 ; N ncaron ; B 18 0 633 667 ;\nC -1 ; WX 600 ; N tcommaaccent ; B 118 -250 567 562 ;\nC -1 ; WX 600 ; N logicalnot ; B 135 103 617 413 ;\nC -1 ; WX 600 ; N odieresis ; B 71 -15 622 638 ;\nC -1 ; WX 600 ; N udieresis ; B 70 -15 595 638 ;\nC -1 ; WX 600 ; N notequal ; B 30 -47 626 563 ;\nC -1 ; WX 600 ; N gcommaaccent ; B 40 -146 674 714 ;\nC -1 ; WX 600 ; N eth ; B 93 -27 661 626 ;\nC -1 ; WX 600 ; N zcaron ; B 81 0 643 667 ;\nC -1 ; WX 600 ; N ncommaaccent ; B 18 -250 615 454 ;\nC -1 ; WX 600 ; N onesuperior ; B 212 230 514 616 ;\nC -1 ; WX 600 ; N imacron ; B 77 0 575 585 ;\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nEndFontMetrics\n";
    },
    Helvetica () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 12:38:23 1997\nComment UniqueID 43054\nComment VMusage 37069 48094\nFontName Helvetica\nFullName Helvetica\nFamilyName Helvetica\nWeight Medium\nItalicAngle 0\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -166 -225 1000 931 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 718\nXHeight 523\nAscender 718\nDescender -207\nStdHW 76\nStdVW 88\nStartCharMetrics 315\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 278 ; N exclam ; B 90 0 187 718 ;\nC 34 ; WX 355 ; N quotedbl ; B 70 463 285 718 ;\nC 35 ; WX 556 ; N numbersign ; B 28 0 529 688 ;\nC 36 ; WX 556 ; N dollar ; B 32 -115 520 775 ;\nC 37 ; WX 889 ; N percent ; B 39 -19 850 703 ;\nC 38 ; WX 667 ; N ampersand ; B 44 -15 645 718 ;\nC 39 ; WX 222 ; N quoteright ; B 53 463 157 718 ;\nC 40 ; WX 333 ; N parenleft ; B 68 -207 299 733 ;\nC 41 ; WX 333 ; N parenright ; B 34 -207 265 733 ;\nC 42 ; WX 389 ; N asterisk ; B 39 431 349 718 ;\nC 43 ; WX 584 ; N plus ; B 39 0 545 505 ;\nC 44 ; WX 278 ; N comma ; B 87 -147 191 106 ;\nC 45 ; WX 333 ; N hyphen ; B 44 232 289 322 ;\nC 46 ; WX 278 ; N period ; B 87 0 191 106 ;\nC 47 ; WX 278 ; N slash ; B -17 -19 295 737 ;\nC 48 ; WX 556 ; N zero ; B 37 -19 519 703 ;\nC 49 ; WX 556 ; N one ; B 101 0 359 703 ;\nC 50 ; WX 556 ; N two ; B 26 0 507 703 ;\nC 51 ; WX 556 ; N three ; B 34 -19 522 703 ;\nC 52 ; WX 556 ; N four ; B 25 0 523 703 ;\nC 53 ; WX 556 ; N five ; B 32 -19 514 688 ;\nC 54 ; WX 556 ; N six ; B 38 -19 518 703 ;\nC 55 ; WX 556 ; N seven ; B 37 0 523 688 ;\nC 56 ; WX 556 ; N eight ; B 38 -19 517 703 ;\nC 57 ; WX 556 ; N nine ; B 42 -19 514 703 ;\nC 58 ; WX 278 ; N colon ; B 87 0 191 516 ;\nC 59 ; WX 278 ; N semicolon ; B 87 -147 191 516 ;\nC 60 ; WX 584 ; N less ; B 48 11 536 495 ;\nC 61 ; WX 584 ; N equal ; B 39 115 545 390 ;\nC 62 ; WX 584 ; N greater ; B 48 11 536 495 ;\nC 63 ; WX 556 ; N question ; B 56 0 492 727 ;\nC 64 ; WX 1015 ; N at ; B 147 -19 868 737 ;\nC 65 ; WX 667 ; N A ; B 14 0 654 718 ;\nC 66 ; WX 667 ; N B ; B 74 0 627 718 ;\nC 67 ; WX 722 ; N C ; B 44 -19 681 737 ;\nC 68 ; WX 722 ; N D ; B 81 0 674 718 ;\nC 69 ; WX 667 ; N E ; B 86 0 616 718 ;\nC 70 ; WX 611 ; N F ; B 86 0 583 718 ;\nC 71 ; WX 778 ; N G ; B 48 -19 704 737 ;\nC 72 ; WX 722 ; N H ; B 77 0 646 718 ;\nC 73 ; WX 278 ; N I ; B 91 0 188 718 ;\nC 74 ; WX 500 ; N J ; B 17 -19 428 718 ;\nC 75 ; WX 667 ; N K ; B 76 0 663 718 ;\nC 76 ; WX 556 ; N L ; B 76 0 537 718 ;\nC 77 ; WX 833 ; N M ; B 73 0 761 718 ;\nC 78 ; WX 722 ; N N ; B 76 0 646 718 ;\nC 79 ; WX 778 ; N O ; B 39 -19 739 737 ;\nC 80 ; WX 667 ; N P ; B 86 0 622 718 ;\nC 81 ; WX 778 ; N Q ; B 39 -56 739 737 ;\nC 82 ; WX 722 ; N R ; B 88 0 684 718 ;\nC 83 ; WX 667 ; N S ; B 49 -19 620 737 ;\nC 84 ; WX 611 ; N T ; B 14 0 597 718 ;\nC 85 ; WX 722 ; N U ; B 79 -19 644 718 ;\nC 86 ; WX 667 ; N V ; B 20 0 647 718 ;\nC 87 ; WX 944 ; N W ; B 16 0 928 718 ;\nC 88 ; WX 667 ; N X ; B 19 0 648 718 ;\nC 89 ; WX 667 ; N Y ; B 14 0 653 718 ;\nC 90 ; WX 611 ; N Z ; B 23 0 588 718 ;\nC 91 ; WX 278 ; N bracketleft ; B 63 -196 250 722 ;\nC 92 ; WX 278 ; N backslash ; B -17 -19 295 737 ;\nC 93 ; WX 278 ; N bracketright ; B 28 -196 215 722 ;\nC 94 ; WX 469 ; N asciicircum ; B -14 264 483 688 ;\nC 95 ; WX 556 ; N underscore ; B 0 -125 556 -75 ;\nC 96 ; WX 222 ; N quoteleft ; B 65 470 169 725 ;\nC 97 ; WX 556 ; N a ; B 36 -15 530 538 ;\nC 98 ; WX 556 ; N b ; B 58 -15 517 718 ;\nC 99 ; WX 500 ; N c ; B 30 -15 477 538 ;\nC 100 ; WX 556 ; N d ; B 35 -15 499 718 ;\nC 101 ; WX 556 ; N e ; B 40 -15 516 538 ;\nC 102 ; WX 278 ; N f ; B 14 0 262 728 ; L i fi ; L l fl ;\nC 103 ; WX 556 ; N g ; B 40 -220 499 538 ;\nC 104 ; WX 556 ; N h ; B 65 0 491 718 ;\nC 105 ; WX 222 ; N i ; B 67 0 155 718 ;\nC 106 ; WX 222 ; N j ; B -16 -210 155 718 ;\nC 107 ; WX 500 ; N k ; B 67 0 501 718 ;\nC 108 ; WX 222 ; N l ; B 67 0 155 718 ;\nC 109 ; WX 833 ; N m ; B 65 0 769 538 ;\nC 110 ; WX 556 ; N n ; B 65 0 491 538 ;\nC 111 ; WX 556 ; N o ; B 35 -14 521 538 ;\nC 112 ; WX 556 ; N p ; B 58 -207 517 538 ;\nC 113 ; WX 556 ; N q ; B 35 -207 494 538 ;\nC 114 ; WX 333 ; N r ; B 77 0 332 538 ;\nC 115 ; WX 500 ; N s ; B 32 -15 464 538 ;\nC 116 ; WX 278 ; N t ; B 14 -7 257 669 ;\nC 117 ; WX 556 ; N u ; B 68 -15 489 523 ;\nC 118 ; WX 500 ; N v ; B 8 0 492 523 ;\nC 119 ; WX 722 ; N w ; B 14 0 709 523 ;\nC 120 ; WX 500 ; N x ; B 11 0 490 523 ;\nC 121 ; WX 500 ; N y ; B 11 -214 489 523 ;\nC 122 ; WX 500 ; N z ; B 31 0 469 523 ;\nC 123 ; WX 334 ; N braceleft ; B 42 -196 292 722 ;\nC 124 ; WX 260 ; N bar ; B 94 -225 167 775 ;\nC 125 ; WX 334 ; N braceright ; B 42 -196 292 722 ;\nC 126 ; WX 584 ; N asciitilde ; B 61 180 523 326 ;\nC 161 ; WX 333 ; N exclamdown ; B 118 -195 215 523 ;\nC 162 ; WX 556 ; N cent ; B 51 -115 513 623 ;\nC 163 ; WX 556 ; N sterling ; B 33 -16 539 718 ;\nC 164 ; WX 167 ; N fraction ; B -166 -19 333 703 ;\nC 165 ; WX 556 ; N yen ; B 3 0 553 688 ;\nC 166 ; WX 556 ; N florin ; B -11 -207 501 737 ;\nC 167 ; WX 556 ; N section ; B 43 -191 512 737 ;\nC 168 ; WX 556 ; N currency ; B 28 99 528 603 ;\nC 169 ; WX 191 ; N quotesingle ; B 59 463 132 718 ;\nC 170 ; WX 333 ; N quotedblleft ; B 38 470 307 725 ;\nC 171 ; WX 556 ; N guillemotleft ; B 97 108 459 446 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 88 108 245 446 ;\nC 173 ; WX 333 ; N guilsinglright ; B 88 108 245 446 ;\nC 174 ; WX 500 ; N fi ; B 14 0 434 728 ;\nC 175 ; WX 500 ; N fl ; B 14 0 432 728 ;\nC 177 ; WX 556 ; N endash ; B 0 240 556 313 ;\nC 178 ; WX 556 ; N dagger ; B 43 -159 514 718 ;\nC 179 ; WX 556 ; N daggerdbl ; B 43 -159 514 718 ;\nC 180 ; WX 278 ; N periodcentered ; B 77 190 202 315 ;\nC 182 ; WX 537 ; N paragraph ; B 18 -173 497 718 ;\nC 183 ; WX 350 ; N bullet ; B 18 202 333 517 ;\nC 184 ; WX 222 ; N quotesinglbase ; B 53 -149 157 106 ;\nC 185 ; WX 333 ; N quotedblbase ; B 26 -149 295 106 ;\nC 186 ; WX 333 ; N quotedblright ; B 26 463 295 718 ;\nC 187 ; WX 556 ; N guillemotright ; B 97 108 459 446 ;\nC 188 ; WX 1000 ; N ellipsis ; B 115 0 885 106 ;\nC 189 ; WX 1000 ; N perthousand ; B 7 -19 994 703 ;\nC 191 ; WX 611 ; N questiondown ; B 91 -201 527 525 ;\nC 193 ; WX 333 ; N grave ; B 14 593 211 734 ;\nC 194 ; WX 333 ; N acute ; B 122 593 319 734 ;\nC 195 ; WX 333 ; N circumflex ; B 21 593 312 734 ;\nC 196 ; WX 333 ; N tilde ; B -4 606 337 722 ;\nC 197 ; WX 333 ; N macron ; B 10 627 323 684 ;\nC 198 ; WX 333 ; N breve ; B 13 595 321 731 ;\nC 199 ; WX 333 ; N dotaccent ; B 121 604 212 706 ;\nC 200 ; WX 333 ; N dieresis ; B 40 604 293 706 ;\nC 202 ; WX 333 ; N ring ; B 75 572 259 756 ;\nC 203 ; WX 333 ; N cedilla ; B 45 -225 259 0 ;\nC 205 ; WX 333 ; N hungarumlaut ; B 31 593 409 734 ;\nC 206 ; WX 333 ; N ogonek ; B 73 -225 287 0 ;\nC 207 ; WX 333 ; N caron ; B 21 593 312 734 ;\nC 208 ; WX 1000 ; N emdash ; B 0 240 1000 313 ;\nC 225 ; WX 1000 ; N AE ; B 8 0 951 718 ;\nC 227 ; WX 370 ; N ordfeminine ; B 24 405 346 737 ;\nC 232 ; WX 556 ; N Lslash ; B -20 0 537 718 ;\nC 233 ; WX 778 ; N Oslash ; B 39 -19 740 737 ;\nC 234 ; WX 1000 ; N OE ; B 36 -19 965 737 ;\nC 235 ; WX 365 ; N ordmasculine ; B 25 405 341 737 ;\nC 241 ; WX 889 ; N ae ; B 36 -15 847 538 ;\nC 245 ; WX 278 ; N dotlessi ; B 95 0 183 523 ;\nC 248 ; WX 222 ; N lslash ; B -20 0 242 718 ;\nC 249 ; WX 611 ; N oslash ; B 28 -22 537 545 ;\nC 250 ; WX 944 ; N oe ; B 35 -15 902 538 ;\nC 251 ; WX 611 ; N germandbls ; B 67 -15 571 728 ;\nC -1 ; WX 278 ; N Idieresis ; B 13 0 266 901 ;\nC -1 ; WX 556 ; N eacute ; B 40 -15 516 734 ;\nC -1 ; WX 556 ; N abreve ; B 36 -15 530 731 ;\nC -1 ; WX 556 ; N uhungarumlaut ; B 68 -15 521 734 ;\nC -1 ; WX 556 ; N ecaron ; B 40 -15 516 734 ;\nC -1 ; WX 667 ; N Ydieresis ; B 14 0 653 901 ;\nC -1 ; WX 584 ; N divide ; B 39 -19 545 524 ;\nC -1 ; WX 667 ; N Yacute ; B 14 0 653 929 ;\nC -1 ; WX 667 ; N Acircumflex ; B 14 0 654 929 ;\nC -1 ; WX 556 ; N aacute ; B 36 -15 530 734 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 79 -19 644 929 ;\nC -1 ; WX 500 ; N yacute ; B 11 -214 489 734 ;\nC -1 ; WX 500 ; N scommaaccent ; B 32 -225 464 538 ;\nC -1 ; WX 556 ; N ecircumflex ; B 40 -15 516 734 ;\nC -1 ; WX 722 ; N Uring ; B 79 -19 644 931 ;\nC -1 ; WX 722 ; N Udieresis ; B 79 -19 644 901 ;\nC -1 ; WX 556 ; N aogonek ; B 36 -220 547 538 ;\nC -1 ; WX 722 ; N Uacute ; B 79 -19 644 929 ;\nC -1 ; WX 556 ; N uogonek ; B 68 -225 519 523 ;\nC -1 ; WX 667 ; N Edieresis ; B 86 0 616 901 ;\nC -1 ; WX 722 ; N Dcroat ; B 0 0 674 718 ;\nC -1 ; WX 250 ; N commaaccent ; B 87 -225 181 -40 ;\nC -1 ; WX 737 ; N copyright ; B -14 -19 752 737 ;\nC -1 ; WX 667 ; N Emacron ; B 86 0 616 879 ;\nC -1 ; WX 500 ; N ccaron ; B 30 -15 477 734 ;\nC -1 ; WX 556 ; N aring ; B 36 -15 530 756 ;\nC -1 ; WX 722 ; N Ncommaaccent ; B 76 -225 646 718 ;\nC -1 ; WX 222 ; N lacute ; B 67 0 264 929 ;\nC -1 ; WX 556 ; N agrave ; B 36 -15 530 734 ;\nC -1 ; WX 611 ; N Tcommaaccent ; B 14 -225 597 718 ;\nC -1 ; WX 722 ; N Cacute ; B 44 -19 681 929 ;\nC -1 ; WX 556 ; N atilde ; B 36 -15 530 722 ;\nC -1 ; WX 667 ; N Edotaccent ; B 86 0 616 901 ;\nC -1 ; WX 500 ; N scaron ; B 32 -15 464 734 ;\nC -1 ; WX 500 ; N scedilla ; B 32 -225 464 538 ;\nC -1 ; WX 278 ; N iacute ; B 95 0 292 734 ;\nC -1 ; WX 471 ; N lozenge ; B 10 0 462 728 ;\nC -1 ; WX 722 ; N Rcaron ; B 88 0 684 929 ;\nC -1 ; WX 778 ; N Gcommaaccent ; B 48 -225 704 737 ;\nC -1 ; WX 556 ; N ucircumflex ; B 68 -15 489 734 ;\nC -1 ; WX 556 ; N acircumflex ; B 36 -15 530 734 ;\nC -1 ; WX 667 ; N Amacron ; B 14 0 654 879 ;\nC -1 ; WX 333 ; N rcaron ; B 61 0 352 734 ;\nC -1 ; WX 500 ; N ccedilla ; B 30 -225 477 538 ;\nC -1 ; WX 611 ; N Zdotaccent ; B 23 0 588 901 ;\nC -1 ; WX 667 ; N Thorn ; B 86 0 622 718 ;\nC -1 ; WX 778 ; N Omacron ; B 39 -19 739 879 ;\nC -1 ; WX 722 ; N Racute ; B 88 0 684 929 ;\nC -1 ; WX 667 ; N Sacute ; B 49 -19 620 929 ;\nC -1 ; WX 643 ; N dcaron ; B 35 -15 655 718 ;\nC -1 ; WX 722 ; N Umacron ; B 79 -19 644 879 ;\nC -1 ; WX 556 ; N uring ; B 68 -15 489 756 ;\nC -1 ; WX 333 ; N threesuperior ; B 5 270 325 703 ;\nC -1 ; WX 778 ; N Ograve ; B 39 -19 739 929 ;\nC -1 ; WX 667 ; N Agrave ; B 14 0 654 929 ;\nC -1 ; WX 667 ; N Abreve ; B 14 0 654 926 ;\nC -1 ; WX 584 ; N multiply ; B 39 0 545 506 ;\nC -1 ; WX 556 ; N uacute ; B 68 -15 489 734 ;\nC -1 ; WX 611 ; N Tcaron ; B 14 0 597 929 ;\nC -1 ; WX 476 ; N partialdiff ; B 13 -38 463 714 ;\nC -1 ; WX 500 ; N ydieresis ; B 11 -214 489 706 ;\nC -1 ; WX 722 ; N Nacute ; B 76 0 646 929 ;\nC -1 ; WX 278 ; N icircumflex ; B -6 0 285 734 ;\nC -1 ; WX 667 ; N Ecircumflex ; B 86 0 616 929 ;\nC -1 ; WX 556 ; N adieresis ; B 36 -15 530 706 ;\nC -1 ; WX 556 ; N edieresis ; B 40 -15 516 706 ;\nC -1 ; WX 500 ; N cacute ; B 30 -15 477 734 ;\nC -1 ; WX 556 ; N nacute ; B 65 0 491 734 ;\nC -1 ; WX 556 ; N umacron ; B 68 -15 489 684 ;\nC -1 ; WX 722 ; N Ncaron ; B 76 0 646 929 ;\nC -1 ; WX 278 ; N Iacute ; B 91 0 292 929 ;\nC -1 ; WX 584 ; N plusminus ; B 39 0 545 506 ;\nC -1 ; WX 260 ; N brokenbar ; B 94 -150 167 700 ;\nC -1 ; WX 737 ; N registered ; B -14 -19 752 737 ;\nC -1 ; WX 778 ; N Gbreve ; B 48 -19 704 926 ;\nC -1 ; WX 278 ; N Idotaccent ; B 91 0 188 901 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 586 706 ;\nC -1 ; WX 667 ; N Egrave ; B 86 0 616 929 ;\nC -1 ; WX 333 ; N racute ; B 77 0 332 734 ;\nC -1 ; WX 556 ; N omacron ; B 35 -14 521 684 ;\nC -1 ; WX 611 ; N Zacute ; B 23 0 588 929 ;\nC -1 ; WX 611 ; N Zcaron ; B 23 0 588 929 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 674 ;\nC -1 ; WX 722 ; N Eth ; B 0 0 674 718 ;\nC -1 ; WX 722 ; N Ccedilla ; B 44 -225 681 737 ;\nC -1 ; WX 222 ; N lcommaaccent ; B 67 -225 167 718 ;\nC -1 ; WX 317 ; N tcaron ; B 14 -7 329 808 ;\nC -1 ; WX 556 ; N eogonek ; B 40 -225 516 538 ;\nC -1 ; WX 722 ; N Uogonek ; B 79 -225 644 718 ;\nC -1 ; WX 667 ; N Aacute ; B 14 0 654 929 ;\nC -1 ; WX 667 ; N Adieresis ; B 14 0 654 901 ;\nC -1 ; WX 556 ; N egrave ; B 40 -15 516 734 ;\nC -1 ; WX 500 ; N zacute ; B 31 0 469 734 ;\nC -1 ; WX 222 ; N iogonek ; B -31 -225 183 718 ;\nC -1 ; WX 778 ; N Oacute ; B 39 -19 739 929 ;\nC -1 ; WX 556 ; N oacute ; B 35 -14 521 734 ;\nC -1 ; WX 556 ; N amacron ; B 36 -15 530 684 ;\nC -1 ; WX 500 ; N sacute ; B 32 -15 464 734 ;\nC -1 ; WX 278 ; N idieresis ; B 13 0 266 706 ;\nC -1 ; WX 778 ; N Ocircumflex ; B 39 -19 739 929 ;\nC -1 ; WX 722 ; N Ugrave ; B 79 -19 644 929 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 556 ; N thorn ; B 58 -207 517 718 ;\nC -1 ; WX 333 ; N twosuperior ; B 4 281 323 703 ;\nC -1 ; WX 778 ; N Odieresis ; B 39 -19 739 901 ;\nC -1 ; WX 556 ; N mu ; B 68 -207 489 523 ;\nC -1 ; WX 278 ; N igrave ; B -13 0 184 734 ;\nC -1 ; WX 556 ; N ohungarumlaut ; B 35 -14 521 734 ;\nC -1 ; WX 667 ; N Eogonek ; B 86 -220 633 718 ;\nC -1 ; WX 556 ; N dcroat ; B 35 -15 550 718 ;\nC -1 ; WX 834 ; N threequarters ; B 45 -19 810 703 ;\nC -1 ; WX 667 ; N Scedilla ; B 49 -225 620 737 ;\nC -1 ; WX 299 ; N lcaron ; B 67 0 311 718 ;\nC -1 ; WX 667 ; N Kcommaaccent ; B 76 -225 663 718 ;\nC -1 ; WX 556 ; N Lacute ; B 76 0 537 929 ;\nC -1 ; WX 1000 ; N trademark ; B 46 306 903 718 ;\nC -1 ; WX 556 ; N edotaccent ; B 40 -15 516 706 ;\nC -1 ; WX 278 ; N Igrave ; B -13 0 188 929 ;\nC -1 ; WX 278 ; N Imacron ; B -17 0 296 879 ;\nC -1 ; WX 556 ; N Lcaron ; B 76 0 537 718 ;\nC -1 ; WX 834 ; N onehalf ; B 43 -19 773 703 ;\nC -1 ; WX 549 ; N lessequal ; B 26 0 523 674 ;\nC -1 ; WX 556 ; N ocircumflex ; B 35 -14 521 734 ;\nC -1 ; WX 556 ; N ntilde ; B 65 0 491 722 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 79 -19 644 929 ;\nC -1 ; WX 667 ; N Eacute ; B 86 0 616 929 ;\nC -1 ; WX 556 ; N emacron ; B 40 -15 516 684 ;\nC -1 ; WX 556 ; N gbreve ; B 40 -220 499 731 ;\nC -1 ; WX 834 ; N onequarter ; B 73 -19 756 703 ;\nC -1 ; WX 667 ; N Scaron ; B 49 -19 620 929 ;\nC -1 ; WX 667 ; N Scommaaccent ; B 49 -225 620 737 ;\nC -1 ; WX 778 ; N Ohungarumlaut ; B 39 -19 739 929 ;\nC -1 ; WX 400 ; N degree ; B 54 411 346 703 ;\nC -1 ; WX 556 ; N ograve ; B 35 -14 521 734 ;\nC -1 ; WX 722 ; N Ccaron ; B 44 -19 681 929 ;\nC -1 ; WX 556 ; N ugrave ; B 68 -15 489 734 ;\nC -1 ; WX 453 ; N radical ; B -4 -80 458 762 ;\nC -1 ; WX 722 ; N Dcaron ; B 81 0 674 929 ;\nC -1 ; WX 333 ; N rcommaaccent ; B 77 -225 332 538 ;\nC -1 ; WX 722 ; N Ntilde ; B 76 0 646 917 ;\nC -1 ; WX 556 ; N otilde ; B 35 -14 521 722 ;\nC -1 ; WX 722 ; N Rcommaaccent ; B 88 -225 684 718 ;\nC -1 ; WX 556 ; N Lcommaaccent ; B 76 -225 537 718 ;\nC -1 ; WX 667 ; N Atilde ; B 14 0 654 917 ;\nC -1 ; WX 667 ; N Aogonek ; B 14 -225 654 718 ;\nC -1 ; WX 667 ; N Aring ; B 14 0 654 931 ;\nC -1 ; WX 778 ; N Otilde ; B 39 -19 739 917 ;\nC -1 ; WX 500 ; N zdotaccent ; B 31 0 469 706 ;\nC -1 ; WX 667 ; N Ecaron ; B 86 0 616 929 ;\nC -1 ; WX 278 ; N Iogonek ; B -3 -225 211 718 ;\nC -1 ; WX 500 ; N kcommaaccent ; B 67 -225 501 718 ;\nC -1 ; WX 584 ; N minus ; B 39 216 545 289 ;\nC -1 ; WX 278 ; N Icircumflex ; B -6 0 285 929 ;\nC -1 ; WX 556 ; N ncaron ; B 65 0 491 734 ;\nC -1 ; WX 278 ; N tcommaaccent ; B 14 -225 257 669 ;\nC -1 ; WX 584 ; N logicalnot ; B 39 108 545 390 ;\nC -1 ; WX 556 ; N odieresis ; B 35 -14 521 706 ;\nC -1 ; WX 556 ; N udieresis ; B 68 -15 489 706 ;\nC -1 ; WX 549 ; N notequal ; B 12 -35 537 551 ;\nC -1 ; WX 556 ; N gcommaaccent ; B 40 -220 499 822 ;\nC -1 ; WX 556 ; N eth ; B 35 -15 522 737 ;\nC -1 ; WX 500 ; N zcaron ; B 31 0 469 734 ;\nC -1 ; WX 556 ; N ncommaaccent ; B 65 -225 491 538 ;\nC -1 ; WX 333 ; N onesuperior ; B 43 281 222 703 ;\nC -1 ; WX 278 ; N imacron ; B 5 0 272 684 ;\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2705\nKPX A C -30\nKPX A Cacute -30\nKPX A Ccaron -30\nKPX A Ccedilla -30\nKPX A G -30\nKPX A Gbreve -30\nKPX A Gcommaaccent -30\nKPX A O -30\nKPX A Oacute -30\nKPX A Ocircumflex -30\nKPX A Odieresis -30\nKPX A Ograve -30\nKPX A Ohungarumlaut -30\nKPX A Omacron -30\nKPX A Oslash -30\nKPX A Otilde -30\nKPX A Q -30\nKPX A T -120\nKPX A Tcaron -120\nKPX A Tcommaaccent -120\nKPX A U -50\nKPX A Uacute -50\nKPX A Ucircumflex -50\nKPX A Udieresis -50\nKPX A Ugrave -50\nKPX A Uhungarumlaut -50\nKPX A Umacron -50\nKPX A Uogonek -50\nKPX A Uring -50\nKPX A V -70\nKPX A W -50\nKPX A Y -100\nKPX A Yacute -100\nKPX A Ydieresis -100\nKPX A u -30\nKPX A uacute -30\nKPX A ucircumflex -30\nKPX A udieresis -30\nKPX A ugrave -30\nKPX A uhungarumlaut -30\nKPX A umacron -30\nKPX A uogonek -30\nKPX A uring -30\nKPX A v -40\nKPX A w -40\nKPX A y -40\nKPX A yacute -40\nKPX A ydieresis -40\nKPX Aacute C -30\nKPX Aacute Cacute -30\nKPX Aacute Ccaron -30\nKPX Aacute Ccedilla -30\nKPX Aacute G -30\nKPX Aacute Gbreve -30\nKPX Aacute Gcommaaccent -30\nKPX Aacute O -30\nKPX Aacute Oacute -30\nKPX Aacute Ocircumflex -30\nKPX Aacute Odieresis -30\nKPX Aacute Ograve -30\nKPX Aacute Ohungarumlaut -30\nKPX Aacute Omacron -30\nKPX Aacute Oslash -30\nKPX Aacute Otilde -30\nKPX Aacute Q -30\nKPX Aacute T -120\nKPX Aacute Tcaron -120\nKPX Aacute Tcommaaccent -120\nKPX Aacute U -50\nKPX Aacute Uacute -50\nKPX Aacute Ucircumflex -50\nKPX Aacute Udieresis -50\nKPX Aacute Ugrave -50\nKPX Aacute Uhungarumlaut -50\nKPX Aacute Umacron -50\nKPX Aacute Uogonek -50\nKPX Aacute Uring -50\nKPX Aacute V -70\nKPX Aacute W -50\nKPX Aacute Y -100\nKPX Aacute Yacute -100\nKPX Aacute Ydieresis -100\nKPX Aacute u -30\nKPX Aacute uacute -30\nKPX Aacute ucircumflex -30\nKPX Aacute udieresis -30\nKPX Aacute ugrave -30\nKPX Aacute uhungarumlaut -30\nKPX Aacute umacron -30\nKPX Aacute uogonek -30\nKPX Aacute uring -30\nKPX Aacute v -40\nKPX Aacute w -40\nKPX Aacute y -40\nKPX Aacute yacute -40\nKPX Aacute ydieresis -40\nKPX Abreve C -30\nKPX Abreve Cacute -30\nKPX Abreve Ccaron -30\nKPX Abreve Ccedilla -30\nKPX Abreve G -30\nKPX Abreve Gbreve -30\nKPX Abreve Gcommaaccent -30\nKPX Abreve O -30\nKPX Abreve Oacute -30\nKPX Abreve Ocircumflex -30\nKPX Abreve Odieresis -30\nKPX Abreve Ograve -30\nKPX Abreve Ohungarumlaut -30\nKPX Abreve Omacron -30\nKPX Abreve Oslash -30\nKPX Abreve Otilde -30\nKPX Abreve Q -30\nKPX Abreve T -120\nKPX Abreve Tcaron -120\nKPX Abreve Tcommaaccent -120\nKPX Abreve U -50\nKPX Abreve Uacute -50\nKPX Abreve Ucircumflex -50\nKPX Abreve Udieresis -50\nKPX Abreve Ugrave -50\nKPX Abreve Uhungarumlaut -50\nKPX Abreve Umacron -50\nKPX Abreve Uogonek -50\nKPX Abreve Uring -50\nKPX Abreve V -70\nKPX Abreve W -50\nKPX Abreve Y -100\nKPX Abreve Yacute -100\nKPX Abreve Ydieresis -100\nKPX Abreve u -30\nKPX Abreve uacute -30\nKPX Abreve ucircumflex -30\nKPX Abreve udieresis -30\nKPX Abreve ugrave -30\nKPX Abreve uhungarumlaut -30\nKPX Abreve umacron -30\nKPX Abreve uogonek -30\nKPX Abreve uring -30\nKPX Abreve v -40\nKPX Abreve w -40\nKPX Abreve y -40\nKPX Abreve yacute -40\nKPX Abreve ydieresis -40\nKPX Acircumflex C -30\nKPX Acircumflex Cacute -30\nKPX Acircumflex Ccaron -30\nKPX Acircumflex Ccedilla -30\nKPX Acircumflex G -30\nKPX Acircumflex Gbreve -30\nKPX Acircumflex Gcommaaccent -30\nKPX Acircumflex O -30\nKPX Acircumflex Oacute -30\nKPX Acircumflex Ocircumflex -30\nKPX Acircumflex Odieresis -30\nKPX Acircumflex Ograve -30\nKPX Acircumflex Ohungarumlaut -30\nKPX Acircumflex Omacron -30\nKPX Acircumflex Oslash -30\nKPX Acircumflex Otilde -30\nKPX Acircumflex Q -30\nKPX Acircumflex T -120\nKPX Acircumflex Tcaron -120\nKPX Acircumflex Tcommaaccent -120\nKPX Acircumflex U -50\nKPX Acircumflex Uacute -50\nKPX Acircumflex Ucircumflex -50\nKPX Acircumflex Udieresis -50\nKPX Acircumflex Ugrave -50\nKPX Acircumflex Uhungarumlaut -50\nKPX Acircumflex Umacron -50\nKPX Acircumflex Uogonek -50\nKPX Acircumflex Uring -50\nKPX Acircumflex V -70\nKPX Acircumflex W -50\nKPX Acircumflex Y -100\nKPX Acircumflex Yacute -100\nKPX Acircumflex Ydieresis -100\nKPX Acircumflex u -30\nKPX Acircumflex uacute -30\nKPX Acircumflex ucircumflex -30\nKPX Acircumflex udieresis -30\nKPX Acircumflex ugrave -30\nKPX Acircumflex uhungarumlaut -30\nKPX Acircumflex umacron -30\nKPX Acircumflex uogonek -30\nKPX Acircumflex uring -30\nKPX Acircumflex v -40\nKPX Acircumflex w -40\nKPX Acircumflex y -40\nKPX Acircumflex yacute -40\nKPX Acircumflex ydieresis -40\nKPX Adieresis C -30\nKPX Adieresis Cacute -30\nKPX Adieresis Ccaron -30\nKPX Adieresis Ccedilla -30\nKPX Adieresis G -30\nKPX Adieresis Gbreve -30\nKPX Adieresis Gcommaaccent -30\nKPX Adieresis O -30\nKPX Adieresis Oacute -30\nKPX Adieresis Ocircumflex -30\nKPX Adieresis Odieresis -30\nKPX Adieresis Ograve -30\nKPX Adieresis Ohungarumlaut -30\nKPX Adieresis Omacron -30\nKPX Adieresis Oslash -30\nKPX Adieresis Otilde -30\nKPX Adieresis Q -30\nKPX Adieresis T -120\nKPX Adieresis Tcaron -120\nKPX Adieresis Tcommaaccent -120\nKPX Adieresis U -50\nKPX Adieresis Uacute -50\nKPX Adieresis Ucircumflex -50\nKPX Adieresis Udieresis -50\nKPX Adieresis Ugrave -50\nKPX Adieresis Uhungarumlaut -50\nKPX Adieresis Umacron -50\nKPX Adieresis Uogonek -50\nKPX Adieresis Uring -50\nKPX Adieresis V -70\nKPX Adieresis W -50\nKPX Adieresis Y -100\nKPX Adieresis Yacute -100\nKPX Adieresis Ydieresis -100\nKPX Adieresis u -30\nKPX Adieresis uacute -30\nKPX Adieresis ucircumflex -30\nKPX Adieresis udieresis -30\nKPX Adieresis ugrave -30\nKPX Adieresis uhungarumlaut -30\nKPX Adieresis umacron -30\nKPX Adieresis uogonek -30\nKPX Adieresis uring -30\nKPX Adieresis v -40\nKPX Adieresis w -40\nKPX Adieresis y -40\nKPX Adieresis yacute -40\nKPX Adieresis ydieresis -40\nKPX Agrave C -30\nKPX Agrave Cacute -30\nKPX Agrave Ccaron -30\nKPX Agrave Ccedilla -30\nKPX Agrave G -30\nKPX Agrave Gbreve -30\nKPX Agrave Gcommaaccent -30\nKPX Agrave O -30\nKPX Agrave Oacute -30\nKPX Agrave Ocircumflex -30\nKPX Agrave Odieresis -30\nKPX Agrave Ograve -30\nKPX Agrave Ohungarumlaut -30\nKPX Agrave Omacron -30\nKPX Agrave Oslash -30\nKPX Agrave Otilde -30\nKPX Agrave Q -30\nKPX Agrave T -120\nKPX Agrave Tcaron -120\nKPX Agrave Tcommaaccent -120\nKPX Agrave U -50\nKPX Agrave Uacute -50\nKPX Agrave Ucircumflex -50\nKPX Agrave Udieresis -50\nKPX Agrave Ugrave -50\nKPX Agrave Uhungarumlaut -50\nKPX Agrave Umacron -50\nKPX Agrave Uogonek -50\nKPX Agrave Uring -50\nKPX Agrave V -70\nKPX Agrave W -50\nKPX Agrave Y -100\nKPX Agrave Yacute -100\nKPX Agrave Ydieresis -100\nKPX Agrave u -30\nKPX Agrave uacute -30\nKPX Agrave ucircumflex -30\nKPX Agrave udieresis -30\nKPX Agrave ugrave -30\nKPX Agrave uhungarumlaut -30\nKPX Agrave umacron -30\nKPX Agrave uogonek -30\nKPX Agrave uring -30\nKPX Agrave v -40\nKPX Agrave w -40\nKPX Agrave y -40\nKPX Agrave yacute -40\nKPX Agrave ydieresis -40\nKPX Amacron C -30\nKPX Amacron Cacute -30\nKPX Amacron Ccaron -30\nKPX Amacron Ccedilla -30\nKPX Amacron G -30\nKPX Amacron Gbreve -30\nKPX Amacron Gcommaaccent -30\nKPX Amacron O -30\nKPX Amacron Oacute -30\nKPX Amacron Ocircumflex -30\nKPX Amacron Odieresis -30\nKPX Amacron Ograve -30\nKPX Amacron Ohungarumlaut -30\nKPX Amacron Omacron -30\nKPX Amacron Oslash -30\nKPX Amacron Otilde -30\nKPX Amacron Q -30\nKPX Amacron T -120\nKPX Amacron Tcaron -120\nKPX Amacron Tcommaaccent -120\nKPX Amacron U -50\nKPX Amacron Uacute -50\nKPX Amacron Ucircumflex -50\nKPX Amacron Udieresis -50\nKPX Amacron Ugrave -50\nKPX Amacron Uhungarumlaut -50\nKPX Amacron Umacron -50\nKPX Amacron Uogonek -50\nKPX Amacron Uring -50\nKPX Amacron V -70\nKPX Amacron W -50\nKPX Amacron Y -100\nKPX Amacron Yacute -100\nKPX Amacron Ydieresis -100\nKPX Amacron u -30\nKPX Amacron uacute -30\nKPX Amacron ucircumflex -30\nKPX Amacron udieresis -30\nKPX Amacron ugrave -30\nKPX Amacron uhungarumlaut -30\nKPX Amacron umacron -30\nKPX Amacron uogonek -30\nKPX Amacron uring -30\nKPX Amacron v -40\nKPX Amacron w -40\nKPX Amacron y -40\nKPX Amacron yacute -40\nKPX Amacron ydieresis -40\nKPX Aogonek C -30\nKPX Aogonek Cacute -30\nKPX Aogonek Ccaron -30\nKPX Aogonek Ccedilla -30\nKPX Aogonek G -30\nKPX Aogonek Gbreve -30\nKPX Aogonek Gcommaaccent -30\nKPX Aogonek O -30\nKPX Aogonek Oacute -30\nKPX Aogonek Ocircumflex -30\nKPX Aogonek Odieresis -30\nKPX Aogonek Ograve -30\nKPX Aogonek Ohungarumlaut -30\nKPX Aogonek Omacron -30\nKPX Aogonek Oslash -30\nKPX Aogonek Otilde -30\nKPX Aogonek Q -30\nKPX Aogonek T -120\nKPX Aogonek Tcaron -120\nKPX Aogonek Tcommaaccent -120\nKPX Aogonek U -50\nKPX Aogonek Uacute -50\nKPX Aogonek Ucircumflex -50\nKPX Aogonek Udieresis -50\nKPX Aogonek Ugrave -50\nKPX Aogonek Uhungarumlaut -50\nKPX Aogonek Umacron -50\nKPX Aogonek Uogonek -50\nKPX Aogonek Uring -50\nKPX Aogonek V -70\nKPX Aogonek W -50\nKPX Aogonek Y -100\nKPX Aogonek Yacute -100\nKPX Aogonek Ydieresis -100\nKPX Aogonek u -30\nKPX Aogonek uacute -30\nKPX Aogonek ucircumflex -30\nKPX Aogonek udieresis -30\nKPX Aogonek ugrave -30\nKPX Aogonek uhungarumlaut -30\nKPX Aogonek umacron -30\nKPX Aogonek uogonek -30\nKPX Aogonek uring -30\nKPX Aogonek v -40\nKPX Aogonek w -40\nKPX Aogonek y -40\nKPX Aogonek yacute -40\nKPX Aogonek ydieresis -40\nKPX Aring C -30\nKPX Aring Cacute -30\nKPX Aring Ccaron -30\nKPX Aring Ccedilla -30\nKPX Aring G -30\nKPX Aring Gbreve -30\nKPX Aring Gcommaaccent -30\nKPX Aring O -30\nKPX Aring Oacute -30\nKPX Aring Ocircumflex -30\nKPX Aring Odieresis -30\nKPX Aring Ograve -30\nKPX Aring Ohungarumlaut -30\nKPX Aring Omacron -30\nKPX Aring Oslash -30\nKPX Aring Otilde -30\nKPX Aring Q -30\nKPX Aring T -120\nKPX Aring Tcaron -120\nKPX Aring Tcommaaccent -120\nKPX Aring U -50\nKPX Aring Uacute -50\nKPX Aring Ucircumflex -50\nKPX Aring Udieresis -50\nKPX Aring Ugrave -50\nKPX Aring Uhungarumlaut -50\nKPX Aring Umacron -50\nKPX Aring Uogonek -50\nKPX Aring Uring -50\nKPX Aring V -70\nKPX Aring W -50\nKPX Aring Y -100\nKPX Aring Yacute -100\nKPX Aring Ydieresis -100\nKPX Aring u -30\nKPX Aring uacute -30\nKPX Aring ucircumflex -30\nKPX Aring udieresis -30\nKPX Aring ugrave -30\nKPX Aring uhungarumlaut -30\nKPX Aring umacron -30\nKPX Aring uogonek -30\nKPX Aring uring -30\nKPX Aring v -40\nKPX Aring w -40\nKPX Aring y -40\nKPX Aring yacute -40\nKPX Aring ydieresis -40\nKPX Atilde C -30\nKPX Atilde Cacute -30\nKPX Atilde Ccaron -30\nKPX Atilde Ccedilla -30\nKPX Atilde G -30\nKPX Atilde Gbreve -30\nKPX Atilde Gcommaaccent -30\nKPX Atilde O -30\nKPX Atilde Oacute -30\nKPX Atilde Ocircumflex -30\nKPX Atilde Odieresis -30\nKPX Atilde Ograve -30\nKPX Atilde Ohungarumlaut -30\nKPX Atilde Omacron -30\nKPX Atilde Oslash -30\nKPX Atilde Otilde -30\nKPX Atilde Q -30\nKPX Atilde T -120\nKPX Atilde Tcaron -120\nKPX Atilde Tcommaaccent -120\nKPX Atilde U -50\nKPX Atilde Uacute -50\nKPX Atilde Ucircumflex -50\nKPX Atilde Udieresis -50\nKPX Atilde Ugrave -50\nKPX Atilde Uhungarumlaut -50\nKPX Atilde Umacron -50\nKPX Atilde Uogonek -50\nKPX Atilde Uring -50\nKPX Atilde V -70\nKPX Atilde W -50\nKPX Atilde Y -100\nKPX Atilde Yacute -100\nKPX Atilde Ydieresis -100\nKPX Atilde u -30\nKPX Atilde uacute -30\nKPX Atilde ucircumflex -30\nKPX Atilde udieresis -30\nKPX Atilde ugrave -30\nKPX Atilde uhungarumlaut -30\nKPX Atilde umacron -30\nKPX Atilde uogonek -30\nKPX Atilde uring -30\nKPX Atilde v -40\nKPX Atilde w -40\nKPX Atilde y -40\nKPX Atilde yacute -40\nKPX Atilde ydieresis -40\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX B comma -20\nKPX B period -20\nKPX C comma -30\nKPX C period -30\nKPX Cacute comma -30\nKPX Cacute period -30\nKPX Ccaron comma -30\nKPX Ccaron period -30\nKPX Ccedilla comma -30\nKPX Ccedilla period -30\nKPX D A -40\nKPX D Aacute -40\nKPX D Abreve -40\nKPX D Acircumflex -40\nKPX D Adieresis -40\nKPX D Agrave -40\nKPX D Amacron -40\nKPX D Aogonek -40\nKPX D Aring -40\nKPX D Atilde -40\nKPX D V -70\nKPX D W -40\nKPX D Y -90\nKPX D Yacute -90\nKPX D Ydieresis -90\nKPX D comma -70\nKPX D period -70\nKPX Dcaron A -40\nKPX Dcaron Aacute -40\nKPX Dcaron Abreve -40\nKPX Dcaron Acircumflex -40\nKPX Dcaron Adieresis -40\nKPX Dcaron Agrave -40\nKPX Dcaron Amacron -40\nKPX Dcaron Aogonek -40\nKPX Dcaron Aring -40\nKPX Dcaron Atilde -40\nKPX Dcaron V -70\nKPX Dcaron W -40\nKPX Dcaron Y -90\nKPX Dcaron Yacute -90\nKPX Dcaron Ydieresis -90\nKPX Dcaron comma -70\nKPX Dcaron period -70\nKPX Dcroat A -40\nKPX Dcroat Aacute -40\nKPX Dcroat Abreve -40\nKPX Dcroat Acircumflex -40\nKPX Dcroat Adieresis -40\nKPX Dcroat Agrave -40\nKPX Dcroat Amacron -40\nKPX Dcroat Aogonek -40\nKPX Dcroat Aring -40\nKPX Dcroat Atilde -40\nKPX Dcroat V -70\nKPX Dcroat W -40\nKPX Dcroat Y -90\nKPX Dcroat Yacute -90\nKPX Dcroat Ydieresis -90\nKPX Dcroat comma -70\nKPX Dcroat period -70\nKPX F A -80\nKPX F Aacute -80\nKPX F Abreve -80\nKPX F Acircumflex -80\nKPX F Adieresis -80\nKPX F Agrave -80\nKPX F Amacron -80\nKPX F Aogonek -80\nKPX F Aring -80\nKPX F Atilde -80\nKPX F a -50\nKPX F aacute -50\nKPX F abreve -50\nKPX F acircumflex -50\nKPX F adieresis -50\nKPX F agrave -50\nKPX F amacron -50\nKPX F aogonek -50\nKPX F aring -50\nKPX F atilde -50\nKPX F comma -150\nKPX F e -30\nKPX F eacute -30\nKPX F ecaron -30\nKPX F ecircumflex -30\nKPX F edieresis -30\nKPX F edotaccent -30\nKPX F egrave -30\nKPX F emacron -30\nKPX F eogonek -30\nKPX F o -30\nKPX F oacute -30\nKPX F ocircumflex -30\nKPX F odieresis -30\nKPX F ograve -30\nKPX F ohungarumlaut -30\nKPX F omacron -30\nKPX F oslash -30\nKPX F otilde -30\nKPX F period -150\nKPX F r -45\nKPX F racute -45\nKPX F rcaron -45\nKPX F rcommaaccent -45\nKPX J A -20\nKPX J Aacute -20\nKPX J Abreve -20\nKPX J Acircumflex -20\nKPX J Adieresis -20\nKPX J Agrave -20\nKPX J Amacron -20\nKPX J Aogonek -20\nKPX J Aring -20\nKPX J Atilde -20\nKPX J a -20\nKPX J aacute -20\nKPX J abreve -20\nKPX J acircumflex -20\nKPX J adieresis -20\nKPX J agrave -20\nKPX J amacron -20\nKPX J aogonek -20\nKPX J aring -20\nKPX J atilde -20\nKPX J comma -30\nKPX J period -30\nKPX J u -20\nKPX J uacute -20\nKPX J ucircumflex -20\nKPX J udieresis -20\nKPX J ugrave -20\nKPX J uhungarumlaut -20\nKPX J umacron -20\nKPX J uogonek -20\nKPX J uring -20\nKPX K O -50\nKPX K Oacute -50\nKPX K Ocircumflex -50\nKPX K Odieresis -50\nKPX K Ograve -50\nKPX K Ohungarumlaut -50\nKPX K Omacron -50\nKPX K Oslash -50\nKPX K Otilde -50\nKPX K e -40\nKPX K eacute -40\nKPX K ecaron -40\nKPX K ecircumflex -40\nKPX K edieresis -40\nKPX K edotaccent -40\nKPX K egrave -40\nKPX K emacron -40\nKPX K eogonek -40\nKPX K o -40\nKPX K oacute -40\nKPX K ocircumflex -40\nKPX K odieresis -40\nKPX K ograve -40\nKPX K ohungarumlaut -40\nKPX K omacron -40\nKPX K oslash -40\nKPX K otilde -40\nKPX K u -30\nKPX K uacute -30\nKPX K ucircumflex -30\nKPX K udieresis -30\nKPX K ugrave -30\nKPX K uhungarumlaut -30\nKPX K umacron -30\nKPX K uogonek -30\nKPX K uring -30\nKPX K y -50\nKPX K yacute -50\nKPX K ydieresis -50\nKPX Kcommaaccent O -50\nKPX Kcommaaccent Oacute -50\nKPX Kcommaaccent Ocircumflex -50\nKPX Kcommaaccent Odieresis -50\nKPX Kcommaaccent Ograve -50\nKPX Kcommaaccent Ohungarumlaut -50\nKPX Kcommaaccent Omacron -50\nKPX Kcommaaccent Oslash -50\nKPX Kcommaaccent Otilde -50\nKPX Kcommaaccent e -40\nKPX Kcommaaccent eacute -40\nKPX Kcommaaccent ecaron -40\nKPX Kcommaaccent ecircumflex -40\nKPX Kcommaaccent edieresis -40\nKPX Kcommaaccent edotaccent -40\nKPX Kcommaaccent egrave -40\nKPX Kcommaaccent emacron -40\nKPX Kcommaaccent eogonek -40\nKPX Kcommaaccent o -40\nKPX Kcommaaccent oacute -40\nKPX Kcommaaccent ocircumflex -40\nKPX Kcommaaccent odieresis -40\nKPX Kcommaaccent ograve -40\nKPX Kcommaaccent ohungarumlaut -40\nKPX Kcommaaccent omacron -40\nKPX Kcommaaccent oslash -40\nKPX Kcommaaccent otilde -40\nKPX Kcommaaccent u -30\nKPX Kcommaaccent uacute -30\nKPX Kcommaaccent ucircumflex -30\nKPX Kcommaaccent udieresis -30\nKPX Kcommaaccent ugrave -30\nKPX Kcommaaccent uhungarumlaut -30\nKPX Kcommaaccent umacron -30\nKPX Kcommaaccent uogonek -30\nKPX Kcommaaccent uring -30\nKPX Kcommaaccent y -50\nKPX Kcommaaccent yacute -50\nKPX Kcommaaccent ydieresis -50\nKPX L T -110\nKPX L Tcaron -110\nKPX L Tcommaaccent -110\nKPX L V -110\nKPX L W -70\nKPX L Y -140\nKPX L Yacute -140\nKPX L Ydieresis -140\nKPX L quotedblright -140\nKPX L quoteright -160\nKPX L y -30\nKPX L yacute -30\nKPX L ydieresis -30\nKPX Lacute T -110\nKPX Lacute Tcaron -110\nKPX Lacute Tcommaaccent -110\nKPX Lacute V -110\nKPX Lacute W -70\nKPX Lacute Y -140\nKPX Lacute Yacute -140\nKPX Lacute Ydieresis -140\nKPX Lacute quotedblright -140\nKPX Lacute quoteright -160\nKPX Lacute y -30\nKPX Lacute yacute -30\nKPX Lacute ydieresis -30\nKPX Lcaron T -110\nKPX Lcaron Tcaron -110\nKPX Lcaron Tcommaaccent -110\nKPX Lcaron V -110\nKPX Lcaron W -70\nKPX Lcaron Y -140\nKPX Lcaron Yacute -140\nKPX Lcaron Ydieresis -140\nKPX Lcaron quotedblright -140\nKPX Lcaron quoteright -160\nKPX Lcaron y -30\nKPX Lcaron yacute -30\nKPX Lcaron ydieresis -30\nKPX Lcommaaccent T -110\nKPX Lcommaaccent Tcaron -110\nKPX Lcommaaccent Tcommaaccent -110\nKPX Lcommaaccent V -110\nKPX Lcommaaccent W -70\nKPX Lcommaaccent Y -140\nKPX Lcommaaccent Yacute -140\nKPX Lcommaaccent Ydieresis -140\nKPX Lcommaaccent quotedblright -140\nKPX Lcommaaccent quoteright -160\nKPX Lcommaaccent y -30\nKPX Lcommaaccent yacute -30\nKPX Lcommaaccent ydieresis -30\nKPX Lslash T -110\nKPX Lslash Tcaron -110\nKPX Lslash Tcommaaccent -110\nKPX Lslash V -110\nKPX Lslash W -70\nKPX Lslash Y -140\nKPX Lslash Yacute -140\nKPX Lslash Ydieresis -140\nKPX Lslash quotedblright -140\nKPX Lslash quoteright -160\nKPX Lslash y -30\nKPX Lslash yacute -30\nKPX Lslash ydieresis -30\nKPX O A -20\nKPX O Aacute -20\nKPX O Abreve -20\nKPX O Acircumflex -20\nKPX O Adieresis -20\nKPX O Agrave -20\nKPX O Amacron -20\nKPX O Aogonek -20\nKPX O Aring -20\nKPX O Atilde -20\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -30\nKPX O X -60\nKPX O Y -70\nKPX O Yacute -70\nKPX O Ydieresis -70\nKPX O comma -40\nKPX O period -40\nKPX Oacute A -20\nKPX Oacute Aacute -20\nKPX Oacute Abreve -20\nKPX Oacute Acircumflex -20\nKPX Oacute Adieresis -20\nKPX Oacute Agrave -20\nKPX Oacute Amacron -20\nKPX Oacute Aogonek -20\nKPX Oacute Aring -20\nKPX Oacute Atilde -20\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -30\nKPX Oacute X -60\nKPX Oacute Y -70\nKPX Oacute Yacute -70\nKPX Oacute Ydieresis -70\nKPX Oacute comma -40\nKPX Oacute period -40\nKPX Ocircumflex A -20\nKPX Ocircumflex Aacute -20\nKPX Ocircumflex Abreve -20\nKPX Ocircumflex Acircumflex -20\nKPX Ocircumflex Adieresis -20\nKPX Ocircumflex Agrave -20\nKPX Ocircumflex Amacron -20\nKPX Ocircumflex Aogonek -20\nKPX Ocircumflex Aring -20\nKPX Ocircumflex Atilde -20\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -30\nKPX Ocircumflex X -60\nKPX Ocircumflex Y -70\nKPX Ocircumflex Yacute -70\nKPX Ocircumflex Ydieresis -70\nKPX Ocircumflex comma -40\nKPX Ocircumflex period -40\nKPX Odieresis A -20\nKPX Odieresis Aacute -20\nKPX Odieresis Abreve -20\nKPX Odieresis Acircumflex -20\nKPX Odieresis Adieresis -20\nKPX Odieresis Agrave -20\nKPX Odieresis Amacron -20\nKPX Odieresis Aogonek -20\nKPX Odieresis Aring -20\nKPX Odieresis Atilde -20\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -30\nKPX Odieresis X -60\nKPX Odieresis Y -70\nKPX Odieresis Yacute -70\nKPX Odieresis Ydieresis -70\nKPX Odieresis comma -40\nKPX Odieresis period -40\nKPX Ograve A -20\nKPX Ograve Aacute -20\nKPX Ograve Abreve -20\nKPX Ograve Acircumflex -20\nKPX Ograve Adieresis -20\nKPX Ograve Agrave -20\nKPX Ograve Amacron -20\nKPX Ograve Aogonek -20\nKPX Ograve Aring -20\nKPX Ograve Atilde -20\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -30\nKPX Ograve X -60\nKPX Ograve Y -70\nKPX Ograve Yacute -70\nKPX Ograve Ydieresis -70\nKPX Ograve comma -40\nKPX Ograve period -40\nKPX Ohungarumlaut A -20\nKPX Ohungarumlaut Aacute -20\nKPX Ohungarumlaut Abreve -20\nKPX Ohungarumlaut Acircumflex -20\nKPX Ohungarumlaut Adieresis -20\nKPX Ohungarumlaut Agrave -20\nKPX Ohungarumlaut Amacron -20\nKPX Ohungarumlaut Aogonek -20\nKPX Ohungarumlaut Aring -20\nKPX Ohungarumlaut Atilde -20\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -30\nKPX Ohungarumlaut X -60\nKPX Ohungarumlaut Y -70\nKPX Ohungarumlaut Yacute -70\nKPX Ohungarumlaut Ydieresis -70\nKPX Ohungarumlaut comma -40\nKPX Ohungarumlaut period -40\nKPX Omacron A -20\nKPX Omacron Aacute -20\nKPX Omacron Abreve -20\nKPX Omacron Acircumflex -20\nKPX Omacron Adieresis -20\nKPX Omacron Agrave -20\nKPX Omacron Amacron -20\nKPX Omacron Aogonek -20\nKPX Omacron Aring -20\nKPX Omacron Atilde -20\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -30\nKPX Omacron X -60\nKPX Omacron Y -70\nKPX Omacron Yacute -70\nKPX Omacron Ydieresis -70\nKPX Omacron comma -40\nKPX Omacron period -40\nKPX Oslash A -20\nKPX Oslash Aacute -20\nKPX Oslash Abreve -20\nKPX Oslash Acircumflex -20\nKPX Oslash Adieresis -20\nKPX Oslash Agrave -20\nKPX Oslash Amacron -20\nKPX Oslash Aogonek -20\nKPX Oslash Aring -20\nKPX Oslash Atilde -20\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -30\nKPX Oslash X -60\nKPX Oslash Y -70\nKPX Oslash Yacute -70\nKPX Oslash Ydieresis -70\nKPX Oslash comma -40\nKPX Oslash period -40\nKPX Otilde A -20\nKPX Otilde Aacute -20\nKPX Otilde Abreve -20\nKPX Otilde Acircumflex -20\nKPX Otilde Adieresis -20\nKPX Otilde Agrave -20\nKPX Otilde Amacron -20\nKPX Otilde Aogonek -20\nKPX Otilde Aring -20\nKPX Otilde Atilde -20\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -30\nKPX Otilde X -60\nKPX Otilde Y -70\nKPX Otilde Yacute -70\nKPX Otilde Ydieresis -70\nKPX Otilde comma -40\nKPX Otilde period -40\nKPX P A -120\nKPX P Aacute -120\nKPX P Abreve -120\nKPX P Acircumflex -120\nKPX P Adieresis -120\nKPX P Agrave -120\nKPX P Amacron -120\nKPX P Aogonek -120\nKPX P Aring -120\nKPX P Atilde -120\nKPX P a -40\nKPX P aacute -40\nKPX P abreve -40\nKPX P acircumflex -40\nKPX P adieresis -40\nKPX P agrave -40\nKPX P amacron -40\nKPX P aogonek -40\nKPX P aring -40\nKPX P atilde -40\nKPX P comma -180\nKPX P e -50\nKPX P eacute -50\nKPX P ecaron -50\nKPX P ecircumflex -50\nKPX P edieresis -50\nKPX P edotaccent -50\nKPX P egrave -50\nKPX P emacron -50\nKPX P eogonek -50\nKPX P o -50\nKPX P oacute -50\nKPX P ocircumflex -50\nKPX P odieresis -50\nKPX P ograve -50\nKPX P ohungarumlaut -50\nKPX P omacron -50\nKPX P oslash -50\nKPX P otilde -50\nKPX P period -180\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX R O -20\nKPX R Oacute -20\nKPX R Ocircumflex -20\nKPX R Odieresis -20\nKPX R Ograve -20\nKPX R Ohungarumlaut -20\nKPX R Omacron -20\nKPX R Oslash -20\nKPX R Otilde -20\nKPX R T -30\nKPX R Tcaron -30\nKPX R Tcommaaccent -30\nKPX R U -40\nKPX R Uacute -40\nKPX R Ucircumflex -40\nKPX R Udieresis -40\nKPX R Ugrave -40\nKPX R Uhungarumlaut -40\nKPX R Umacron -40\nKPX R Uogonek -40\nKPX R Uring -40\nKPX R V -50\nKPX R W -30\nKPX R Y -50\nKPX R Yacute -50\nKPX R Ydieresis -50\nKPX Racute O -20\nKPX Racute Oacute -20\nKPX Racute Ocircumflex -20\nKPX Racute Odieresis -20\nKPX Racute Ograve -20\nKPX Racute Ohungarumlaut -20\nKPX Racute Omacron -20\nKPX Racute Oslash -20\nKPX Racute Otilde -20\nKPX Racute T -30\nKPX Racute Tcaron -30\nKPX Racute Tcommaaccent -30\nKPX Racute U -40\nKPX Racute Uacute -40\nKPX Racute Ucircumflex -40\nKPX Racute Udieresis -40\nKPX Racute Ugrave -40\nKPX Racute Uhungarumlaut -40\nKPX Racute Umacron -40\nKPX Racute Uogonek -40\nKPX Racute Uring -40\nKPX Racute V -50\nKPX Racute W -30\nKPX Racute Y -50\nKPX Racute Yacute -50\nKPX Racute Ydieresis -50\nKPX Rcaron O -20\nKPX Rcaron Oacute -20\nKPX Rcaron Ocircumflex -20\nKPX Rcaron Odieresis -20\nKPX Rcaron Ograve -20\nKPX Rcaron Ohungarumlaut -20\nKPX Rcaron Omacron -20\nKPX Rcaron Oslash -20\nKPX Rcaron Otilde -20\nKPX Rcaron T -30\nKPX Rcaron Tcaron -30\nKPX Rcaron Tcommaaccent -30\nKPX Rcaron U -40\nKPX Rcaron Uacute -40\nKPX Rcaron Ucircumflex -40\nKPX Rcaron Udieresis -40\nKPX Rcaron Ugrave -40\nKPX Rcaron Uhungarumlaut -40\nKPX Rcaron Umacron -40\nKPX Rcaron Uogonek -40\nKPX Rcaron Uring -40\nKPX Rcaron V -50\nKPX Rcaron W -30\nKPX Rcaron Y -50\nKPX Rcaron Yacute -50\nKPX Rcaron Ydieresis -50\nKPX Rcommaaccent O -20\nKPX Rcommaaccent Oacute -20\nKPX Rcommaaccent Ocircumflex -20\nKPX Rcommaaccent Odieresis -20\nKPX Rcommaaccent Ograve -20\nKPX Rcommaaccent Ohungarumlaut -20\nKPX Rcommaaccent Omacron -20\nKPX Rcommaaccent Oslash -20\nKPX Rcommaaccent Otilde -20\nKPX Rcommaaccent T -30\nKPX Rcommaaccent Tcaron -30\nKPX Rcommaaccent Tcommaaccent -30\nKPX Rcommaaccent U -40\nKPX Rcommaaccent Uacute -40\nKPX Rcommaaccent Ucircumflex -40\nKPX Rcommaaccent Udieresis -40\nKPX Rcommaaccent Ugrave -40\nKPX Rcommaaccent Uhungarumlaut -40\nKPX Rcommaaccent Umacron -40\nKPX Rcommaaccent Uogonek -40\nKPX Rcommaaccent Uring -40\nKPX Rcommaaccent V -50\nKPX Rcommaaccent W -30\nKPX Rcommaaccent Y -50\nKPX Rcommaaccent Yacute -50\nKPX Rcommaaccent Ydieresis -50\nKPX S comma -20\nKPX S period -20\nKPX Sacute comma -20\nKPX Sacute period -20\nKPX Scaron comma -20\nKPX Scaron period -20\nKPX Scedilla comma -20\nKPX Scedilla period -20\nKPX Scommaaccent comma -20\nKPX Scommaaccent period -20\nKPX T A -120\nKPX T Aacute -120\nKPX T Abreve -120\nKPX T Acircumflex -120\nKPX T Adieresis -120\nKPX T Agrave -120\nKPX T Amacron -120\nKPX T Aogonek -120\nKPX T Aring -120\nKPX T Atilde -120\nKPX T O -40\nKPX T Oacute -40\nKPX T Ocircumflex -40\nKPX T Odieresis -40\nKPX T Ograve -40\nKPX T Ohungarumlaut -40\nKPX T Omacron -40\nKPX T Oslash -40\nKPX T Otilde -40\nKPX T a -120\nKPX T aacute -120\nKPX T abreve -60\nKPX T acircumflex -120\nKPX T adieresis -120\nKPX T agrave -120\nKPX T amacron -60\nKPX T aogonek -120\nKPX T aring -120\nKPX T atilde -60\nKPX T colon -20\nKPX T comma -120\nKPX T e -120\nKPX T eacute -120\nKPX T ecaron -120\nKPX T ecircumflex -120\nKPX T edieresis -120\nKPX T edotaccent -120\nKPX T egrave -60\nKPX T emacron -60\nKPX T eogonek -120\nKPX T hyphen -140\nKPX T o -120\nKPX T oacute -120\nKPX T ocircumflex -120\nKPX T odieresis -120\nKPX T ograve -120\nKPX T ohungarumlaut -120\nKPX T omacron -60\nKPX T oslash -120\nKPX T otilde -60\nKPX T period -120\nKPX T r -120\nKPX T racute -120\nKPX T rcaron -120\nKPX T rcommaaccent -120\nKPX T semicolon -20\nKPX T u -120\nKPX T uacute -120\nKPX T ucircumflex -120\nKPX T udieresis -120\nKPX T ugrave -120\nKPX T uhungarumlaut -120\nKPX T umacron -60\nKPX T uogonek -120\nKPX T uring -120\nKPX T w -120\nKPX T y -120\nKPX T yacute -120\nKPX T ydieresis -60\nKPX Tcaron A -120\nKPX Tcaron Aacute -120\nKPX Tcaron Abreve -120\nKPX Tcaron Acircumflex -120\nKPX Tcaron Adieresis -120\nKPX Tcaron Agrave -120\nKPX Tcaron Amacron -120\nKPX Tcaron Aogonek -120\nKPX Tcaron Aring -120\nKPX Tcaron Atilde -120\nKPX Tcaron O -40\nKPX Tcaron Oacute -40\nKPX Tcaron Ocircumflex -40\nKPX Tcaron Odieresis -40\nKPX Tcaron Ograve -40\nKPX Tcaron Ohungarumlaut -40\nKPX Tcaron Omacron -40\nKPX Tcaron Oslash -40\nKPX Tcaron Otilde -40\nKPX Tcaron a -120\nKPX Tcaron aacute -120\nKPX Tcaron abreve -60\nKPX Tcaron acircumflex -120\nKPX Tcaron adieresis -120\nKPX Tcaron agrave -120\nKPX Tcaron amacron -60\nKPX Tcaron aogonek -120\nKPX Tcaron aring -120\nKPX Tcaron atilde -60\nKPX Tcaron colon -20\nKPX Tcaron comma -120\nKPX Tcaron e -120\nKPX Tcaron eacute -120\nKPX Tcaron ecaron -120\nKPX Tcaron ecircumflex -120\nKPX Tcaron edieresis -120\nKPX Tcaron edotaccent -120\nKPX Tcaron egrave -60\nKPX Tcaron emacron -60\nKPX Tcaron eogonek -120\nKPX Tcaron hyphen -140\nKPX Tcaron o -120\nKPX Tcaron oacute -120\nKPX Tcaron ocircumflex -120\nKPX Tcaron odieresis -120\nKPX Tcaron ograve -120\nKPX Tcaron ohungarumlaut -120\nKPX Tcaron omacron -60\nKPX Tcaron oslash -120\nKPX Tcaron otilde -60\nKPX Tcaron period -120\nKPX Tcaron r -120\nKPX Tcaron racute -120\nKPX Tcaron rcaron -120\nKPX Tcaron rcommaaccent -120\nKPX Tcaron semicolon -20\nKPX Tcaron u -120\nKPX Tcaron uacute -120\nKPX Tcaron ucircumflex -120\nKPX Tcaron udieresis -120\nKPX Tcaron ugrave -120\nKPX Tcaron uhungarumlaut -120\nKPX Tcaron umacron -60\nKPX Tcaron uogonek -120\nKPX Tcaron uring -120\nKPX Tcaron w -120\nKPX Tcaron y -120\nKPX Tcaron yacute -120\nKPX Tcaron ydieresis -60\nKPX Tcommaaccent A -120\nKPX Tcommaaccent Aacute -120\nKPX Tcommaaccent Abreve -120\nKPX Tcommaaccent Acircumflex -120\nKPX Tcommaaccent Adieresis -120\nKPX Tcommaaccent Agrave -120\nKPX Tcommaaccent Amacron -120\nKPX Tcommaaccent Aogonek -120\nKPX Tcommaaccent Aring -120\nKPX Tcommaaccent Atilde -120\nKPX Tcommaaccent O -40\nKPX Tcommaaccent Oacute -40\nKPX Tcommaaccent Ocircumflex -40\nKPX Tcommaaccent Odieresis -40\nKPX Tcommaaccent Ograve -40\nKPX Tcommaaccent Ohungarumlaut -40\nKPX Tcommaaccent Omacron -40\nKPX Tcommaaccent Oslash -40\nKPX Tcommaaccent Otilde -40\nKPX Tcommaaccent a -120\nKPX Tcommaaccent aacute -120\nKPX Tcommaaccent abreve -60\nKPX Tcommaaccent acircumflex -120\nKPX Tcommaaccent adieresis -120\nKPX Tcommaaccent agrave -120\nKPX Tcommaaccent amacron -60\nKPX Tcommaaccent aogonek -120\nKPX Tcommaaccent aring -120\nKPX Tcommaaccent atilde -60\nKPX Tcommaaccent colon -20\nKPX Tcommaaccent comma -120\nKPX Tcommaaccent e -120\nKPX Tcommaaccent eacute -120\nKPX Tcommaaccent ecaron -120\nKPX Tcommaaccent ecircumflex -120\nKPX Tcommaaccent edieresis -120\nKPX Tcommaaccent edotaccent -120\nKPX Tcommaaccent egrave -60\nKPX Tcommaaccent emacron -60\nKPX Tcommaaccent eogonek -120\nKPX Tcommaaccent hyphen -140\nKPX Tcommaaccent o -120\nKPX Tcommaaccent oacute -120\nKPX Tcommaaccent ocircumflex -120\nKPX Tcommaaccent odieresis -120\nKPX Tcommaaccent ograve -120\nKPX Tcommaaccent ohungarumlaut -120\nKPX Tcommaaccent omacron -60\nKPX Tcommaaccent oslash -120\nKPX Tcommaaccent otilde -60\nKPX Tcommaaccent period -120\nKPX Tcommaaccent r -120\nKPX Tcommaaccent racute -120\nKPX Tcommaaccent rcaron -120\nKPX Tcommaaccent rcommaaccent -120\nKPX Tcommaaccent semicolon -20\nKPX Tcommaaccent u -120\nKPX Tcommaaccent uacute -120\nKPX Tcommaaccent ucircumflex -120\nKPX Tcommaaccent udieresis -120\nKPX Tcommaaccent ugrave -120\nKPX Tcommaaccent uhungarumlaut -120\nKPX Tcommaaccent umacron -60\nKPX Tcommaaccent uogonek -120\nKPX Tcommaaccent uring -120\nKPX Tcommaaccent w -120\nKPX Tcommaaccent y -120\nKPX Tcommaaccent yacute -120\nKPX Tcommaaccent ydieresis -60\nKPX U A -40\nKPX U Aacute -40\nKPX U Abreve -40\nKPX U Acircumflex -40\nKPX U Adieresis -40\nKPX U Agrave -40\nKPX U Amacron -40\nKPX U Aogonek -40\nKPX U Aring -40\nKPX U Atilde -40\nKPX U comma -40\nKPX U period -40\nKPX Uacute A -40\nKPX Uacute Aacute -40\nKPX Uacute Abreve -40\nKPX Uacute Acircumflex -40\nKPX Uacute Adieresis -40\nKPX Uacute Agrave -40\nKPX Uacute Amacron -40\nKPX Uacute Aogonek -40\nKPX Uacute Aring -40\nKPX Uacute Atilde -40\nKPX Uacute comma -40\nKPX Uacute period -40\nKPX Ucircumflex A -40\nKPX Ucircumflex Aacute -40\nKPX Ucircumflex Abreve -40\nKPX Ucircumflex Acircumflex -40\nKPX Ucircumflex Adieresis -40\nKPX Ucircumflex Agrave -40\nKPX Ucircumflex Amacron -40\nKPX Ucircumflex Aogonek -40\nKPX Ucircumflex Aring -40\nKPX Ucircumflex Atilde -40\nKPX Ucircumflex comma -40\nKPX Ucircumflex period -40\nKPX Udieresis A -40\nKPX Udieresis Aacute -40\nKPX Udieresis Abreve -40\nKPX Udieresis Acircumflex -40\nKPX Udieresis Adieresis -40\nKPX Udieresis Agrave -40\nKPX Udieresis Amacron -40\nKPX Udieresis Aogonek -40\nKPX Udieresis Aring -40\nKPX Udieresis Atilde -40\nKPX Udieresis comma -40\nKPX Udieresis period -40\nKPX Ugrave A -40\nKPX Ugrave Aacute -40\nKPX Ugrave Abreve -40\nKPX Ugrave Acircumflex -40\nKPX Ugrave Adieresis -40\nKPX Ugrave Agrave -40\nKPX Ugrave Amacron -40\nKPX Ugrave Aogonek -40\nKPX Ugrave Aring -40\nKPX Ugrave Atilde -40\nKPX Ugrave comma -40\nKPX Ugrave period -40\nKPX Uhungarumlaut A -40\nKPX Uhungarumlaut Aacute -40\nKPX Uhungarumlaut Abreve -40\nKPX Uhungarumlaut Acircumflex -40\nKPX Uhungarumlaut Adieresis -40\nKPX Uhungarumlaut Agrave -40\nKPX Uhungarumlaut Amacron -40\nKPX Uhungarumlaut Aogonek -40\nKPX Uhungarumlaut Aring -40\nKPX Uhungarumlaut Atilde -40\nKPX Uhungarumlaut comma -40\nKPX Uhungarumlaut period -40\nKPX Umacron A -40\nKPX Umacron Aacute -40\nKPX Umacron Abreve -40\nKPX Umacron Acircumflex -40\nKPX Umacron Adieresis -40\nKPX Umacron Agrave -40\nKPX Umacron Amacron -40\nKPX Umacron Aogonek -40\nKPX Umacron Aring -40\nKPX Umacron Atilde -40\nKPX Umacron comma -40\nKPX Umacron period -40\nKPX Uogonek A -40\nKPX Uogonek Aacute -40\nKPX Uogonek Abreve -40\nKPX Uogonek Acircumflex -40\nKPX Uogonek Adieresis -40\nKPX Uogonek Agrave -40\nKPX Uogonek Amacron -40\nKPX Uogonek Aogonek -40\nKPX Uogonek Aring -40\nKPX Uogonek Atilde -40\nKPX Uogonek comma -40\nKPX Uogonek period -40\nKPX Uring A -40\nKPX Uring Aacute -40\nKPX Uring Abreve -40\nKPX Uring Acircumflex -40\nKPX Uring Adieresis -40\nKPX Uring Agrave -40\nKPX Uring Amacron -40\nKPX Uring Aogonek -40\nKPX Uring Aring -40\nKPX Uring Atilde -40\nKPX Uring comma -40\nKPX Uring period -40\nKPX V A -80\nKPX V Aacute -80\nKPX V Abreve -80\nKPX V Acircumflex -80\nKPX V Adieresis -80\nKPX V Agrave -80\nKPX V Amacron -80\nKPX V Aogonek -80\nKPX V Aring -80\nKPX V Atilde -80\nKPX V G -40\nKPX V Gbreve -40\nKPX V Gcommaaccent -40\nKPX V O -40\nKPX V Oacute -40\nKPX V Ocircumflex -40\nKPX V Odieresis -40\nKPX V Ograve -40\nKPX V Ohungarumlaut -40\nKPX V Omacron -40\nKPX V Oslash -40\nKPX V Otilde -40\nKPX V a -70\nKPX V aacute -70\nKPX V abreve -70\nKPX V acircumflex -70\nKPX V adieresis -70\nKPX V agrave -70\nKPX V amacron -70\nKPX V aogonek -70\nKPX V aring -70\nKPX V atilde -70\nKPX V colon -40\nKPX V comma -125\nKPX V e -80\nKPX V eacute -80\nKPX V ecaron -80\nKPX V ecircumflex -80\nKPX V edieresis -80\nKPX V edotaccent -80\nKPX V egrave -80\nKPX V emacron -80\nKPX V eogonek -80\nKPX V hyphen -80\nKPX V o -80\nKPX V oacute -80\nKPX V ocircumflex -80\nKPX V odieresis -80\nKPX V ograve -80\nKPX V ohungarumlaut -80\nKPX V omacron -80\nKPX V oslash -80\nKPX V otilde -80\nKPX V period -125\nKPX V semicolon -40\nKPX V u -70\nKPX V uacute -70\nKPX V ucircumflex -70\nKPX V udieresis -70\nKPX V ugrave -70\nKPX V uhungarumlaut -70\nKPX V umacron -70\nKPX V uogonek -70\nKPX V uring -70\nKPX W A -50\nKPX W Aacute -50\nKPX W Abreve -50\nKPX W Acircumflex -50\nKPX W Adieresis -50\nKPX W Agrave -50\nKPX W Amacron -50\nKPX W Aogonek -50\nKPX W Aring -50\nKPX W Atilde -50\nKPX W O -20\nKPX W Oacute -20\nKPX W Ocircumflex -20\nKPX W Odieresis -20\nKPX W Ograve -20\nKPX W Ohungarumlaut -20\nKPX W Omacron -20\nKPX W Oslash -20\nKPX W Otilde -20\nKPX W a -40\nKPX W aacute -40\nKPX W abreve -40\nKPX W acircumflex -40\nKPX W adieresis -40\nKPX W agrave -40\nKPX W amacron -40\nKPX W aogonek -40\nKPX W aring -40\nKPX W atilde -40\nKPX W comma -80\nKPX W e -30\nKPX W eacute -30\nKPX W ecaron -30\nKPX W ecircumflex -30\nKPX W edieresis -30\nKPX W edotaccent -30\nKPX W egrave -30\nKPX W emacron -30\nKPX W eogonek -30\nKPX W hyphen -40\nKPX W o -30\nKPX W oacute -30\nKPX W ocircumflex -30\nKPX W odieresis -30\nKPX W ograve -30\nKPX W ohungarumlaut -30\nKPX W omacron -30\nKPX W oslash -30\nKPX W otilde -30\nKPX W period -80\nKPX W u -30\nKPX W uacute -30\nKPX W ucircumflex -30\nKPX W udieresis -30\nKPX W ugrave -30\nKPX W uhungarumlaut -30\nKPX W umacron -30\nKPX W uogonek -30\nKPX W uring -30\nKPX W y -20\nKPX W yacute -20\nKPX W ydieresis -20\nKPX Y A -110\nKPX Y Aacute -110\nKPX Y Abreve -110\nKPX Y Acircumflex -110\nKPX Y Adieresis -110\nKPX Y Agrave -110\nKPX Y Amacron -110\nKPX Y Aogonek -110\nKPX Y Aring -110\nKPX Y Atilde -110\nKPX Y O -85\nKPX Y Oacute -85\nKPX Y Ocircumflex -85\nKPX Y Odieresis -85\nKPX Y Ograve -85\nKPX Y Ohungarumlaut -85\nKPX Y Omacron -85\nKPX Y Oslash -85\nKPX Y Otilde -85\nKPX Y a -140\nKPX Y aacute -140\nKPX Y abreve -70\nKPX Y acircumflex -140\nKPX Y adieresis -140\nKPX Y agrave -140\nKPX Y amacron -70\nKPX Y aogonek -140\nKPX Y aring -140\nKPX Y atilde -140\nKPX Y colon -60\nKPX Y comma -140\nKPX Y e -140\nKPX Y eacute -140\nKPX Y ecaron -140\nKPX Y ecircumflex -140\nKPX Y edieresis -140\nKPX Y edotaccent -140\nKPX Y egrave -140\nKPX Y emacron -70\nKPX Y eogonek -140\nKPX Y hyphen -140\nKPX Y i -20\nKPX Y iacute -20\nKPX Y iogonek -20\nKPX Y o -140\nKPX Y oacute -140\nKPX Y ocircumflex -140\nKPX Y odieresis -140\nKPX Y ograve -140\nKPX Y ohungarumlaut -140\nKPX Y omacron -140\nKPX Y oslash -140\nKPX Y otilde -140\nKPX Y period -140\nKPX Y semicolon -60\nKPX Y u -110\nKPX Y uacute -110\nKPX Y ucircumflex -110\nKPX Y udieresis -110\nKPX Y ugrave -110\nKPX Y uhungarumlaut -110\nKPX Y umacron -110\nKPX Y uogonek -110\nKPX Y uring -110\nKPX Yacute A -110\nKPX Yacute Aacute -110\nKPX Yacute Abreve -110\nKPX Yacute Acircumflex -110\nKPX Yacute Adieresis -110\nKPX Yacute Agrave -110\nKPX Yacute Amacron -110\nKPX Yacute Aogonek -110\nKPX Yacute Aring -110\nKPX Yacute Atilde -110\nKPX Yacute O -85\nKPX Yacute Oacute -85\nKPX Yacute Ocircumflex -85\nKPX Yacute Odieresis -85\nKPX Yacute Ograve -85\nKPX Yacute Ohungarumlaut -85\nKPX Yacute Omacron -85\nKPX Yacute Oslash -85\nKPX Yacute Otilde -85\nKPX Yacute a -140\nKPX Yacute aacute -140\nKPX Yacute abreve -70\nKPX Yacute acircumflex -140\nKPX Yacute adieresis -140\nKPX Yacute agrave -140\nKPX Yacute amacron -70\nKPX Yacute aogonek -140\nKPX Yacute aring -140\nKPX Yacute atilde -70\nKPX Yacute colon -60\nKPX Yacute comma -140\nKPX Yacute e -140\nKPX Yacute eacute -140\nKPX Yacute ecaron -140\nKPX Yacute ecircumflex -140\nKPX Yacute edieresis -140\nKPX Yacute edotaccent -140\nKPX Yacute egrave -140\nKPX Yacute emacron -70\nKPX Yacute eogonek -140\nKPX Yacute hyphen -140\nKPX Yacute i -20\nKPX Yacute iacute -20\nKPX Yacute iogonek -20\nKPX Yacute o -140\nKPX Yacute oacute -140\nKPX Yacute ocircumflex -140\nKPX Yacute odieresis -140\nKPX Yacute ograve -140\nKPX Yacute ohungarumlaut -140\nKPX Yacute omacron -70\nKPX Yacute oslash -140\nKPX Yacute otilde -140\nKPX Yacute period -140\nKPX Yacute semicolon -60\nKPX Yacute u -110\nKPX Yacute uacute -110\nKPX Yacute ucircumflex -110\nKPX Yacute udieresis -110\nKPX Yacute ugrave -110\nKPX Yacute uhungarumlaut -110\nKPX Yacute umacron -110\nKPX Yacute uogonek -110\nKPX Yacute uring -110\nKPX Ydieresis A -110\nKPX Ydieresis Aacute -110\nKPX Ydieresis Abreve -110\nKPX Ydieresis Acircumflex -110\nKPX Ydieresis Adieresis -110\nKPX Ydieresis Agrave -110\nKPX Ydieresis Amacron -110\nKPX Ydieresis Aogonek -110\nKPX Ydieresis Aring -110\nKPX Ydieresis Atilde -110\nKPX Ydieresis O -85\nKPX Ydieresis Oacute -85\nKPX Ydieresis Ocircumflex -85\nKPX Ydieresis Odieresis -85\nKPX Ydieresis Ograve -85\nKPX Ydieresis Ohungarumlaut -85\nKPX Ydieresis Omacron -85\nKPX Ydieresis Oslash -85\nKPX Ydieresis Otilde -85\nKPX Ydieresis a -140\nKPX Ydieresis aacute -140\nKPX Ydieresis abreve -70\nKPX Ydieresis acircumflex -140\nKPX Ydieresis adieresis -140\nKPX Ydieresis agrave -140\nKPX Ydieresis amacron -70\nKPX Ydieresis aogonek -140\nKPX Ydieresis aring -140\nKPX Ydieresis atilde -70\nKPX Ydieresis colon -60\nKPX Ydieresis comma -140\nKPX Ydieresis e -140\nKPX Ydieresis eacute -140\nKPX Ydieresis ecaron -140\nKPX Ydieresis ecircumflex -140\nKPX Ydieresis edieresis -140\nKPX Ydieresis edotaccent -140\nKPX Ydieresis egrave -140\nKPX Ydieresis emacron -70\nKPX Ydieresis eogonek -140\nKPX Ydieresis hyphen -140\nKPX Ydieresis i -20\nKPX Ydieresis iacute -20\nKPX Ydieresis iogonek -20\nKPX Ydieresis o -140\nKPX Ydieresis oacute -140\nKPX Ydieresis ocircumflex -140\nKPX Ydieresis odieresis -140\nKPX Ydieresis ograve -140\nKPX Ydieresis ohungarumlaut -140\nKPX Ydieresis omacron -140\nKPX Ydieresis oslash -140\nKPX Ydieresis otilde -140\nKPX Ydieresis period -140\nKPX Ydieresis semicolon -60\nKPX Ydieresis u -110\nKPX Ydieresis uacute -110\nKPX Ydieresis ucircumflex -110\nKPX Ydieresis udieresis -110\nKPX Ydieresis ugrave -110\nKPX Ydieresis uhungarumlaut -110\nKPX Ydieresis umacron -110\nKPX Ydieresis uogonek -110\nKPX Ydieresis uring -110\nKPX a v -20\nKPX a w -20\nKPX a y -30\nKPX a yacute -30\nKPX a ydieresis -30\nKPX aacute v -20\nKPX aacute w -20\nKPX aacute y -30\nKPX aacute yacute -30\nKPX aacute ydieresis -30\nKPX abreve v -20\nKPX abreve w -20\nKPX abreve y -30\nKPX abreve yacute -30\nKPX abreve ydieresis -30\nKPX acircumflex v -20\nKPX acircumflex w -20\nKPX acircumflex y -30\nKPX acircumflex yacute -30\nKPX acircumflex ydieresis -30\nKPX adieresis v -20\nKPX adieresis w -20\nKPX adieresis y -30\nKPX adieresis yacute -30\nKPX adieresis ydieresis -30\nKPX agrave v -20\nKPX agrave w -20\nKPX agrave y -30\nKPX agrave yacute -30\nKPX agrave ydieresis -30\nKPX amacron v -20\nKPX amacron w -20\nKPX amacron y -30\nKPX amacron yacute -30\nKPX amacron ydieresis -30\nKPX aogonek v -20\nKPX aogonek w -20\nKPX aogonek y -30\nKPX aogonek yacute -30\nKPX aogonek ydieresis -30\nKPX aring v -20\nKPX aring w -20\nKPX aring y -30\nKPX aring yacute -30\nKPX aring ydieresis -30\nKPX atilde v -20\nKPX atilde w -20\nKPX atilde y -30\nKPX atilde yacute -30\nKPX atilde ydieresis -30\nKPX b b -10\nKPX b comma -40\nKPX b l -20\nKPX b lacute -20\nKPX b lcommaaccent -20\nKPX b lslash -20\nKPX b period -40\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX b v -20\nKPX b y -20\nKPX b yacute -20\nKPX b ydieresis -20\nKPX c comma -15\nKPX c k -20\nKPX c kcommaaccent -20\nKPX cacute comma -15\nKPX cacute k -20\nKPX cacute kcommaaccent -20\nKPX ccaron comma -15\nKPX ccaron k -20\nKPX ccaron kcommaaccent -20\nKPX ccedilla comma -15\nKPX ccedilla k -20\nKPX ccedilla kcommaaccent -20\nKPX colon space -50\nKPX comma quotedblright -100\nKPX comma quoteright -100\nKPX e comma -15\nKPX e period -15\nKPX e v -30\nKPX e w -20\nKPX e x -30\nKPX e y -20\nKPX e yacute -20\nKPX e ydieresis -20\nKPX eacute comma -15\nKPX eacute period -15\nKPX eacute v -30\nKPX eacute w -20\nKPX eacute x -30\nKPX eacute y -20\nKPX eacute yacute -20\nKPX eacute ydieresis -20\nKPX ecaron comma -15\nKPX ecaron period -15\nKPX ecaron v -30\nKPX ecaron w -20\nKPX ecaron x -30\nKPX ecaron y -20\nKPX ecaron yacute -20\nKPX ecaron ydieresis -20\nKPX ecircumflex comma -15\nKPX ecircumflex period -15\nKPX ecircumflex v -30\nKPX ecircumflex w -20\nKPX ecircumflex x -30\nKPX ecircumflex y -20\nKPX ecircumflex yacute -20\nKPX ecircumflex ydieresis -20\nKPX edieresis comma -15\nKPX edieresis period -15\nKPX edieresis v -30\nKPX edieresis w -20\nKPX edieresis x -30\nKPX edieresis y -20\nKPX edieresis yacute -20\nKPX edieresis ydieresis -20\nKPX edotaccent comma -15\nKPX edotaccent period -15\nKPX edotaccent v -30\nKPX edotaccent w -20\nKPX edotaccent x -30\nKPX edotaccent y -20\nKPX edotaccent yacute -20\nKPX edotaccent ydieresis -20\nKPX egrave comma -15\nKPX egrave period -15\nKPX egrave v -30\nKPX egrave w -20\nKPX egrave x -30\nKPX egrave y -20\nKPX egrave yacute -20\nKPX egrave ydieresis -20\nKPX emacron comma -15\nKPX emacron period -15\nKPX emacron v -30\nKPX emacron w -20\nKPX emacron x -30\nKPX emacron y -20\nKPX emacron yacute -20\nKPX emacron ydieresis -20\nKPX eogonek comma -15\nKPX eogonek period -15\nKPX eogonek v -30\nKPX eogonek w -20\nKPX eogonek x -30\nKPX eogonek y -20\nKPX eogonek yacute -20\nKPX eogonek ydieresis -20\nKPX f a -30\nKPX f aacute -30\nKPX f abreve -30\nKPX f acircumflex -30\nKPX f adieresis -30\nKPX f agrave -30\nKPX f amacron -30\nKPX f aogonek -30\nKPX f aring -30\nKPX f atilde -30\nKPX f comma -30\nKPX f dotlessi -28\nKPX f e -30\nKPX f eacute -30\nKPX f ecaron -30\nKPX f ecircumflex -30\nKPX f edieresis -30\nKPX f edotaccent -30\nKPX f egrave -30\nKPX f emacron -30\nKPX f eogonek -30\nKPX f o -30\nKPX f oacute -30\nKPX f ocircumflex -30\nKPX f odieresis -30\nKPX f ograve -30\nKPX f ohungarumlaut -30\nKPX f omacron -30\nKPX f oslash -30\nKPX f otilde -30\nKPX f period -30\nKPX f quotedblright 60\nKPX f quoteright 50\nKPX g r -10\nKPX g racute -10\nKPX g rcaron -10\nKPX g rcommaaccent -10\nKPX gbreve r -10\nKPX gbreve racute -10\nKPX gbreve rcaron -10\nKPX gbreve rcommaaccent -10\nKPX gcommaaccent r -10\nKPX gcommaaccent racute -10\nKPX gcommaaccent rcaron -10\nKPX gcommaaccent rcommaaccent -10\nKPX h y -30\nKPX h yacute -30\nKPX h ydieresis -30\nKPX k e -20\nKPX k eacute -20\nKPX k ecaron -20\nKPX k ecircumflex -20\nKPX k edieresis -20\nKPX k edotaccent -20\nKPX k egrave -20\nKPX k emacron -20\nKPX k eogonek -20\nKPX k o -20\nKPX k oacute -20\nKPX k ocircumflex -20\nKPX k odieresis -20\nKPX k ograve -20\nKPX k ohungarumlaut -20\nKPX k omacron -20\nKPX k oslash -20\nKPX k otilde -20\nKPX kcommaaccent e -20\nKPX kcommaaccent eacute -20\nKPX kcommaaccent ecaron -20\nKPX kcommaaccent ecircumflex -20\nKPX kcommaaccent edieresis -20\nKPX kcommaaccent edotaccent -20\nKPX kcommaaccent egrave -20\nKPX kcommaaccent emacron -20\nKPX kcommaaccent eogonek -20\nKPX kcommaaccent o -20\nKPX kcommaaccent oacute -20\nKPX kcommaaccent ocircumflex -20\nKPX kcommaaccent odieresis -20\nKPX kcommaaccent ograve -20\nKPX kcommaaccent ohungarumlaut -20\nKPX kcommaaccent omacron -20\nKPX kcommaaccent oslash -20\nKPX kcommaaccent otilde -20\nKPX m u -10\nKPX m uacute -10\nKPX m ucircumflex -10\nKPX m udieresis -10\nKPX m ugrave -10\nKPX m uhungarumlaut -10\nKPX m umacron -10\nKPX m uogonek -10\nKPX m uring -10\nKPX m y -15\nKPX m yacute -15\nKPX m ydieresis -15\nKPX n u -10\nKPX n uacute -10\nKPX n ucircumflex -10\nKPX n udieresis -10\nKPX n ugrave -10\nKPX n uhungarumlaut -10\nKPX n umacron -10\nKPX n uogonek -10\nKPX n uring -10\nKPX n v -20\nKPX n y -15\nKPX n yacute -15\nKPX n ydieresis -15\nKPX nacute u -10\nKPX nacute uacute -10\nKPX nacute ucircumflex -10\nKPX nacute udieresis -10\nKPX nacute ugrave -10\nKPX nacute uhungarumlaut -10\nKPX nacute umacron -10\nKPX nacute uogonek -10\nKPX nacute uring -10\nKPX nacute v -20\nKPX nacute y -15\nKPX nacute yacute -15\nKPX nacute ydieresis -15\nKPX ncaron u -10\nKPX ncaron uacute -10\nKPX ncaron ucircumflex -10\nKPX ncaron udieresis -10\nKPX ncaron ugrave -10\nKPX ncaron uhungarumlaut -10\nKPX ncaron umacron -10\nKPX ncaron uogonek -10\nKPX ncaron uring -10\nKPX ncaron v -20\nKPX ncaron y -15\nKPX ncaron yacute -15\nKPX ncaron ydieresis -15\nKPX ncommaaccent u -10\nKPX ncommaaccent uacute -10\nKPX ncommaaccent ucircumflex -10\nKPX ncommaaccent udieresis -10\nKPX ncommaaccent ugrave -10\nKPX ncommaaccent uhungarumlaut -10\nKPX ncommaaccent umacron -10\nKPX ncommaaccent uogonek -10\nKPX ncommaaccent uring -10\nKPX ncommaaccent v -20\nKPX ncommaaccent y -15\nKPX ncommaaccent yacute -15\nKPX ncommaaccent ydieresis -15\nKPX ntilde u -10\nKPX ntilde uacute -10\nKPX ntilde ucircumflex -10\nKPX ntilde udieresis -10\nKPX ntilde ugrave -10\nKPX ntilde uhungarumlaut -10\nKPX ntilde umacron -10\nKPX ntilde uogonek -10\nKPX ntilde uring -10\nKPX ntilde v -20\nKPX ntilde y -15\nKPX ntilde yacute -15\nKPX ntilde ydieresis -15\nKPX o comma -40\nKPX o period -40\nKPX o v -15\nKPX o w -15\nKPX o x -30\nKPX o y -30\nKPX o yacute -30\nKPX o ydieresis -30\nKPX oacute comma -40\nKPX oacute period -40\nKPX oacute v -15\nKPX oacute w -15\nKPX oacute x -30\nKPX oacute y -30\nKPX oacute yacute -30\nKPX oacute ydieresis -30\nKPX ocircumflex comma -40\nKPX ocircumflex period -40\nKPX ocircumflex v -15\nKPX ocircumflex w -15\nKPX ocircumflex x -30\nKPX ocircumflex y -30\nKPX ocircumflex yacute -30\nKPX ocircumflex ydieresis -30\nKPX odieresis comma -40\nKPX odieresis period -40\nKPX odieresis v -15\nKPX odieresis w -15\nKPX odieresis x -30\nKPX odieresis y -30\nKPX odieresis yacute -30\nKPX odieresis ydieresis -30\nKPX ograve comma -40\nKPX ograve period -40\nKPX ograve v -15\nKPX ograve w -15\nKPX ograve x -30\nKPX ograve y -30\nKPX ograve yacute -30\nKPX ograve ydieresis -30\nKPX ohungarumlaut comma -40\nKPX ohungarumlaut period -40\nKPX ohungarumlaut v -15\nKPX ohungarumlaut w -15\nKPX ohungarumlaut x -30\nKPX ohungarumlaut y -30\nKPX ohungarumlaut yacute -30\nKPX ohungarumlaut ydieresis -30\nKPX omacron comma -40\nKPX omacron period -40\nKPX omacron v -15\nKPX omacron w -15\nKPX omacron x -30\nKPX omacron y -30\nKPX omacron yacute -30\nKPX omacron ydieresis -30\nKPX oslash a -55\nKPX oslash aacute -55\nKPX oslash abreve -55\nKPX oslash acircumflex -55\nKPX oslash adieresis -55\nKPX oslash agrave -55\nKPX oslash amacron -55\nKPX oslash aogonek -55\nKPX oslash aring -55\nKPX oslash atilde -55\nKPX oslash b -55\nKPX oslash c -55\nKPX oslash cacute -55\nKPX oslash ccaron -55\nKPX oslash ccedilla -55\nKPX oslash comma -95\nKPX oslash d -55\nKPX oslash dcroat -55\nKPX oslash e -55\nKPX oslash eacute -55\nKPX oslash ecaron -55\nKPX oslash ecircumflex -55\nKPX oslash edieresis -55\nKPX oslash edotaccent -55\nKPX oslash egrave -55\nKPX oslash emacron -55\nKPX oslash eogonek -55\nKPX oslash f -55\nKPX oslash g -55\nKPX oslash gbreve -55\nKPX oslash gcommaaccent -55\nKPX oslash h -55\nKPX oslash i -55\nKPX oslash iacute -55\nKPX oslash icircumflex -55\nKPX oslash idieresis -55\nKPX oslash igrave -55\nKPX oslash imacron -55\nKPX oslash iogonek -55\nKPX oslash j -55\nKPX oslash k -55\nKPX oslash kcommaaccent -55\nKPX oslash l -55\nKPX oslash lacute -55\nKPX oslash lcommaaccent -55\nKPX oslash lslash -55\nKPX oslash m -55\nKPX oslash n -55\nKPX oslash nacute -55\nKPX oslash ncaron -55\nKPX oslash ncommaaccent -55\nKPX oslash ntilde -55\nKPX oslash o -55\nKPX oslash oacute -55\nKPX oslash ocircumflex -55\nKPX oslash odieresis -55\nKPX oslash ograve -55\nKPX oslash ohungarumlaut -55\nKPX oslash omacron -55\nKPX oslash oslash -55\nKPX oslash otilde -55\nKPX oslash p -55\nKPX oslash period -95\nKPX oslash q -55\nKPX oslash r -55\nKPX oslash racute -55\nKPX oslash rcaron -55\nKPX oslash rcommaaccent -55\nKPX oslash s -55\nKPX oslash sacute -55\nKPX oslash scaron -55\nKPX oslash scedilla -55\nKPX oslash scommaaccent -55\nKPX oslash t -55\nKPX oslash tcommaaccent -55\nKPX oslash u -55\nKPX oslash uacute -55\nKPX oslash ucircumflex -55\nKPX oslash udieresis -55\nKPX oslash ugrave -55\nKPX oslash uhungarumlaut -55\nKPX oslash umacron -55\nKPX oslash uogonek -55\nKPX oslash uring -55\nKPX oslash v -70\nKPX oslash w -70\nKPX oslash x -85\nKPX oslash y -70\nKPX oslash yacute -70\nKPX oslash ydieresis -70\nKPX oslash z -55\nKPX oslash zacute -55\nKPX oslash zcaron -55\nKPX oslash zdotaccent -55\nKPX otilde comma -40\nKPX otilde period -40\nKPX otilde v -15\nKPX otilde w -15\nKPX otilde x -30\nKPX otilde y -30\nKPX otilde yacute -30\nKPX otilde ydieresis -30\nKPX p comma -35\nKPX p period -35\nKPX p y -30\nKPX p yacute -30\nKPX p ydieresis -30\nKPX period quotedblright -100\nKPX period quoteright -100\nKPX period space -60\nKPX quotedblright space -40\nKPX quoteleft quoteleft -57\nKPX quoteright d -50\nKPX quoteright dcroat -50\nKPX quoteright quoteright -57\nKPX quoteright r -50\nKPX quoteright racute -50\nKPX quoteright rcaron -50\nKPX quoteright rcommaaccent -50\nKPX quoteright s -50\nKPX quoteright sacute -50\nKPX quoteright scaron -50\nKPX quoteright scedilla -50\nKPX quoteright scommaaccent -50\nKPX quoteright space -70\nKPX r a -10\nKPX r aacute -10\nKPX r abreve -10\nKPX r acircumflex -10\nKPX r adieresis -10\nKPX r agrave -10\nKPX r amacron -10\nKPX r aogonek -10\nKPX r aring -10\nKPX r atilde -10\nKPX r colon 30\nKPX r comma -50\nKPX r i 15\nKPX r iacute 15\nKPX r icircumflex 15\nKPX r idieresis 15\nKPX r igrave 15\nKPX r imacron 15\nKPX r iogonek 15\nKPX r k 15\nKPX r kcommaaccent 15\nKPX r l 15\nKPX r lacute 15\nKPX r lcommaaccent 15\nKPX r lslash 15\nKPX r m 25\nKPX r n 25\nKPX r nacute 25\nKPX r ncaron 25\nKPX r ncommaaccent 25\nKPX r ntilde 25\nKPX r p 30\nKPX r period -50\nKPX r semicolon 30\nKPX r t 40\nKPX r tcommaaccent 40\nKPX r u 15\nKPX r uacute 15\nKPX r ucircumflex 15\nKPX r udieresis 15\nKPX r ugrave 15\nKPX r uhungarumlaut 15\nKPX r umacron 15\nKPX r uogonek 15\nKPX r uring 15\nKPX r v 30\nKPX r y 30\nKPX r yacute 30\nKPX r ydieresis 30\nKPX racute a -10\nKPX racute aacute -10\nKPX racute abreve -10\nKPX racute acircumflex -10\nKPX racute adieresis -10\nKPX racute agrave -10\nKPX racute amacron -10\nKPX racute aogonek -10\nKPX racute aring -10\nKPX racute atilde -10\nKPX racute colon 30\nKPX racute comma -50\nKPX racute i 15\nKPX racute iacute 15\nKPX racute icircumflex 15\nKPX racute idieresis 15\nKPX racute igrave 15\nKPX racute imacron 15\nKPX racute iogonek 15\nKPX racute k 15\nKPX racute kcommaaccent 15\nKPX racute l 15\nKPX racute lacute 15\nKPX racute lcommaaccent 15\nKPX racute lslash 15\nKPX racute m 25\nKPX racute n 25\nKPX racute nacute 25\nKPX racute ncaron 25\nKPX racute ncommaaccent 25\nKPX racute ntilde 25\nKPX racute p 30\nKPX racute period -50\nKPX racute semicolon 30\nKPX racute t 40\nKPX racute tcommaaccent 40\nKPX racute u 15\nKPX racute uacute 15\nKPX racute ucircumflex 15\nKPX racute udieresis 15\nKPX racute ugrave 15\nKPX racute uhungarumlaut 15\nKPX racute umacron 15\nKPX racute uogonek 15\nKPX racute uring 15\nKPX racute v 30\nKPX racute y 30\nKPX racute yacute 30\nKPX racute ydieresis 30\nKPX rcaron a -10\nKPX rcaron aacute -10\nKPX rcaron abreve -10\nKPX rcaron acircumflex -10\nKPX rcaron adieresis -10\nKPX rcaron agrave -10\nKPX rcaron amacron -10\nKPX rcaron aogonek -10\nKPX rcaron aring -10\nKPX rcaron atilde -10\nKPX rcaron colon 30\nKPX rcaron comma -50\nKPX rcaron i 15\nKPX rcaron iacute 15\nKPX rcaron icircumflex 15\nKPX rcaron idieresis 15\nKPX rcaron igrave 15\nKPX rcaron imacron 15\nKPX rcaron iogonek 15\nKPX rcaron k 15\nKPX rcaron kcommaaccent 15\nKPX rcaron l 15\nKPX rcaron lacute 15\nKPX rcaron lcommaaccent 15\nKPX rcaron lslash 15\nKPX rcaron m 25\nKPX rcaron n 25\nKPX rcaron nacute 25\nKPX rcaron ncaron 25\nKPX rcaron ncommaaccent 25\nKPX rcaron ntilde 25\nKPX rcaron p 30\nKPX rcaron period -50\nKPX rcaron semicolon 30\nKPX rcaron t 40\nKPX rcaron tcommaaccent 40\nKPX rcaron u 15\nKPX rcaron uacute 15\nKPX rcaron ucircumflex 15\nKPX rcaron udieresis 15\nKPX rcaron ugrave 15\nKPX rcaron uhungarumlaut 15\nKPX rcaron umacron 15\nKPX rcaron uogonek 15\nKPX rcaron uring 15\nKPX rcaron v 30\nKPX rcaron y 30\nKPX rcaron yacute 30\nKPX rcaron ydieresis 30\nKPX rcommaaccent a -10\nKPX rcommaaccent aacute -10\nKPX rcommaaccent abreve -10\nKPX rcommaaccent acircumflex -10\nKPX rcommaaccent adieresis -10\nKPX rcommaaccent agrave -10\nKPX rcommaaccent amacron -10\nKPX rcommaaccent aogonek -10\nKPX rcommaaccent aring -10\nKPX rcommaaccent atilde -10\nKPX rcommaaccent colon 30\nKPX rcommaaccent comma -50\nKPX rcommaaccent i 15\nKPX rcommaaccent iacute 15\nKPX rcommaaccent icircumflex 15\nKPX rcommaaccent idieresis 15\nKPX rcommaaccent igrave 15\nKPX rcommaaccent imacron 15\nKPX rcommaaccent iogonek 15\nKPX rcommaaccent k 15\nKPX rcommaaccent kcommaaccent 15\nKPX rcommaaccent l 15\nKPX rcommaaccent lacute 15\nKPX rcommaaccent lcommaaccent 15\nKPX rcommaaccent lslash 15\nKPX rcommaaccent m 25\nKPX rcommaaccent n 25\nKPX rcommaaccent nacute 25\nKPX rcommaaccent ncaron 25\nKPX rcommaaccent ncommaaccent 25\nKPX rcommaaccent ntilde 25\nKPX rcommaaccent p 30\nKPX rcommaaccent period -50\nKPX rcommaaccent semicolon 30\nKPX rcommaaccent t 40\nKPX rcommaaccent tcommaaccent 40\nKPX rcommaaccent u 15\nKPX rcommaaccent uacute 15\nKPX rcommaaccent ucircumflex 15\nKPX rcommaaccent udieresis 15\nKPX rcommaaccent ugrave 15\nKPX rcommaaccent uhungarumlaut 15\nKPX rcommaaccent umacron 15\nKPX rcommaaccent uogonek 15\nKPX rcommaaccent uring 15\nKPX rcommaaccent v 30\nKPX rcommaaccent y 30\nKPX rcommaaccent yacute 30\nKPX rcommaaccent ydieresis 30\nKPX s comma -15\nKPX s period -15\nKPX s w -30\nKPX sacute comma -15\nKPX sacute period -15\nKPX sacute w -30\nKPX scaron comma -15\nKPX scaron period -15\nKPX scaron w -30\nKPX scedilla comma -15\nKPX scedilla period -15\nKPX scedilla w -30\nKPX scommaaccent comma -15\nKPX scommaaccent period -15\nKPX scommaaccent w -30\nKPX semicolon space -50\nKPX space T -50\nKPX space Tcaron -50\nKPX space Tcommaaccent -50\nKPX space V -50\nKPX space W -40\nKPX space Y -90\nKPX space Yacute -90\nKPX space Ydieresis -90\nKPX space quotedblleft -30\nKPX space quoteleft -60\nKPX v a -25\nKPX v aacute -25\nKPX v abreve -25\nKPX v acircumflex -25\nKPX v adieresis -25\nKPX v agrave -25\nKPX v amacron -25\nKPX v aogonek -25\nKPX v aring -25\nKPX v atilde -25\nKPX v comma -80\nKPX v e -25\nKPX v eacute -25\nKPX v ecaron -25\nKPX v ecircumflex -25\nKPX v edieresis -25\nKPX v edotaccent -25\nKPX v egrave -25\nKPX v emacron -25\nKPX v eogonek -25\nKPX v o -25\nKPX v oacute -25\nKPX v ocircumflex -25\nKPX v odieresis -25\nKPX v ograve -25\nKPX v ohungarumlaut -25\nKPX v omacron -25\nKPX v oslash -25\nKPX v otilde -25\nKPX v period -80\nKPX w a -15\nKPX w aacute -15\nKPX w abreve -15\nKPX w acircumflex -15\nKPX w adieresis -15\nKPX w agrave -15\nKPX w amacron -15\nKPX w aogonek -15\nKPX w aring -15\nKPX w atilde -15\nKPX w comma -60\nKPX w e -10\nKPX w eacute -10\nKPX w ecaron -10\nKPX w ecircumflex -10\nKPX w edieresis -10\nKPX w edotaccent -10\nKPX w egrave -10\nKPX w emacron -10\nKPX w eogonek -10\nKPX w o -10\nKPX w oacute -10\nKPX w ocircumflex -10\nKPX w odieresis -10\nKPX w ograve -10\nKPX w ohungarumlaut -10\nKPX w omacron -10\nKPX w oslash -10\nKPX w otilde -10\nKPX w period -60\nKPX x e -30\nKPX x eacute -30\nKPX x ecaron -30\nKPX x ecircumflex -30\nKPX x edieresis -30\nKPX x edotaccent -30\nKPX x egrave -30\nKPX x emacron -30\nKPX x eogonek -30\nKPX y a -20\nKPX y aacute -20\nKPX y abreve -20\nKPX y acircumflex -20\nKPX y adieresis -20\nKPX y agrave -20\nKPX y amacron -20\nKPX y aogonek -20\nKPX y aring -20\nKPX y atilde -20\nKPX y comma -100\nKPX y e -20\nKPX y eacute -20\nKPX y ecaron -20\nKPX y ecircumflex -20\nKPX y edieresis -20\nKPX y edotaccent -20\nKPX y egrave -20\nKPX y emacron -20\nKPX y eogonek -20\nKPX y o -20\nKPX y oacute -20\nKPX y ocircumflex -20\nKPX y odieresis -20\nKPX y ograve -20\nKPX y ohungarumlaut -20\nKPX y omacron -20\nKPX y oslash -20\nKPX y otilde -20\nKPX y period -100\nKPX yacute a -20\nKPX yacute aacute -20\nKPX yacute abreve -20\nKPX yacute acircumflex -20\nKPX yacute adieresis -20\nKPX yacute agrave -20\nKPX yacute amacron -20\nKPX yacute aogonek -20\nKPX yacute aring -20\nKPX yacute atilde -20\nKPX yacute comma -100\nKPX yacute e -20\nKPX yacute eacute -20\nKPX yacute ecaron -20\nKPX yacute ecircumflex -20\nKPX yacute edieresis -20\nKPX yacute edotaccent -20\nKPX yacute egrave -20\nKPX yacute emacron -20\nKPX yacute eogonek -20\nKPX yacute o -20\nKPX yacute oacute -20\nKPX yacute ocircumflex -20\nKPX yacute odieresis -20\nKPX yacute ograve -20\nKPX yacute ohungarumlaut -20\nKPX yacute omacron -20\nKPX yacute oslash -20\nKPX yacute otilde -20\nKPX yacute period -100\nKPX ydieresis a -20\nKPX ydieresis aacute -20\nKPX ydieresis abreve -20\nKPX ydieresis acircumflex -20\nKPX ydieresis adieresis -20\nKPX ydieresis agrave -20\nKPX ydieresis amacron -20\nKPX ydieresis aogonek -20\nKPX ydieresis aring -20\nKPX ydieresis atilde -20\nKPX ydieresis comma -100\nKPX ydieresis e -20\nKPX ydieresis eacute -20\nKPX ydieresis ecaron -20\nKPX ydieresis ecircumflex -20\nKPX ydieresis edieresis -20\nKPX ydieresis edotaccent -20\nKPX ydieresis egrave -20\nKPX ydieresis emacron -20\nKPX ydieresis eogonek -20\nKPX ydieresis o -20\nKPX ydieresis oacute -20\nKPX ydieresis ocircumflex -20\nKPX ydieresis odieresis -20\nKPX ydieresis ograve -20\nKPX ydieresis ohungarumlaut -20\nKPX ydieresis omacron -20\nKPX ydieresis oslash -20\nKPX ydieresis otilde -20\nKPX ydieresis period -100\nKPX z e -15\nKPX z eacute -15\nKPX z ecaron -15\nKPX z ecircumflex -15\nKPX z edieresis -15\nKPX z edotaccent -15\nKPX z egrave -15\nKPX z emacron -15\nKPX z eogonek -15\nKPX z o -15\nKPX z oacute -15\nKPX z ocircumflex -15\nKPX z odieresis -15\nKPX z ograve -15\nKPX z ohungarumlaut -15\nKPX z omacron -15\nKPX z oslash -15\nKPX z otilde -15\nKPX zacute e -15\nKPX zacute eacute -15\nKPX zacute ecaron -15\nKPX zacute ecircumflex -15\nKPX zacute edieresis -15\nKPX zacute edotaccent -15\nKPX zacute egrave -15\nKPX zacute emacron -15\nKPX zacute eogonek -15\nKPX zacute o -15\nKPX zacute oacute -15\nKPX zacute ocircumflex -15\nKPX zacute odieresis -15\nKPX zacute ograve -15\nKPX zacute ohungarumlaut -15\nKPX zacute omacron -15\nKPX zacute oslash -15\nKPX zacute otilde -15\nKPX zcaron e -15\nKPX zcaron eacute -15\nKPX zcaron ecaron -15\nKPX zcaron ecircumflex -15\nKPX zcaron edieresis -15\nKPX zcaron edotaccent -15\nKPX zcaron egrave -15\nKPX zcaron emacron -15\nKPX zcaron eogonek -15\nKPX zcaron o -15\nKPX zcaron oacute -15\nKPX zcaron ocircumflex -15\nKPX zcaron odieresis -15\nKPX zcaron ograve -15\nKPX zcaron ohungarumlaut -15\nKPX zcaron omacron -15\nKPX zcaron oslash -15\nKPX zcaron otilde -15\nKPX zdotaccent e -15\nKPX zdotaccent eacute -15\nKPX zdotaccent ecaron -15\nKPX zdotaccent ecircumflex -15\nKPX zdotaccent edieresis -15\nKPX zdotaccent edotaccent -15\nKPX zdotaccent egrave -15\nKPX zdotaccent emacron -15\nKPX zdotaccent eogonek -15\nKPX zdotaccent o -15\nKPX zdotaccent oacute -15\nKPX zdotaccent ocircumflex -15\nKPX zdotaccent odieresis -15\nKPX zdotaccent ograve -15\nKPX zdotaccent ohungarumlaut -15\nKPX zdotaccent omacron -15\nKPX zdotaccent oslash -15\nKPX zdotaccent otilde -15\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    'Helvetica-Bold' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 12:43:52 1997\nComment UniqueID 43052\nComment VMusage 37169 48194\nFontName Helvetica-Bold\nFullName Helvetica Bold\nFamilyName Helvetica\nWeight Bold\nItalicAngle 0\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -170 -228 1003 962 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 718\nXHeight 532\nAscender 718\nDescender -207\nStdHW 118\nStdVW 140\nStartCharMetrics 315\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 333 ; N exclam ; B 90 0 244 718 ;\nC 34 ; WX 474 ; N quotedbl ; B 98 447 376 718 ;\nC 35 ; WX 556 ; N numbersign ; B 18 0 538 698 ;\nC 36 ; WX 556 ; N dollar ; B 30 -115 523 775 ;\nC 37 ; WX 889 ; N percent ; B 28 -19 861 710 ;\nC 38 ; WX 722 ; N ampersand ; B 54 -19 701 718 ;\nC 39 ; WX 278 ; N quoteright ; B 69 445 209 718 ;\nC 40 ; WX 333 ; N parenleft ; B 35 -208 314 734 ;\nC 41 ; WX 333 ; N parenright ; B 19 -208 298 734 ;\nC 42 ; WX 389 ; N asterisk ; B 27 387 362 718 ;\nC 43 ; WX 584 ; N plus ; B 40 0 544 506 ;\nC 44 ; WX 278 ; N comma ; B 64 -168 214 146 ;\nC 45 ; WX 333 ; N hyphen ; B 27 215 306 345 ;\nC 46 ; WX 278 ; N period ; B 64 0 214 146 ;\nC 47 ; WX 278 ; N slash ; B -33 -19 311 737 ;\nC 48 ; WX 556 ; N zero ; B 32 -19 524 710 ;\nC 49 ; WX 556 ; N one ; B 69 0 378 710 ;\nC 50 ; WX 556 ; N two ; B 26 0 511 710 ;\nC 51 ; WX 556 ; N three ; B 27 -19 516 710 ;\nC 52 ; WX 556 ; N four ; B 27 0 526 710 ;\nC 53 ; WX 556 ; N five ; B 27 -19 516 698 ;\nC 54 ; WX 556 ; N six ; B 31 -19 520 710 ;\nC 55 ; WX 556 ; N seven ; B 25 0 528 698 ;\nC 56 ; WX 556 ; N eight ; B 32 -19 524 710 ;\nC 57 ; WX 556 ; N nine ; B 30 -19 522 710 ;\nC 58 ; WX 333 ; N colon ; B 92 0 242 512 ;\nC 59 ; WX 333 ; N semicolon ; B 92 -168 242 512 ;\nC 60 ; WX 584 ; N less ; B 38 -8 546 514 ;\nC 61 ; WX 584 ; N equal ; B 40 87 544 419 ;\nC 62 ; WX 584 ; N greater ; B 38 -8 546 514 ;\nC 63 ; WX 611 ; N question ; B 60 0 556 727 ;\nC 64 ; WX 975 ; N at ; B 118 -19 856 737 ;\nC 65 ; WX 722 ; N A ; B 20 0 702 718 ;\nC 66 ; WX 722 ; N B ; B 76 0 669 718 ;\nC 67 ; WX 722 ; N C ; B 44 -19 684 737 ;\nC 68 ; WX 722 ; N D ; B 76 0 685 718 ;\nC 69 ; WX 667 ; N E ; B 76 0 621 718 ;\nC 70 ; WX 611 ; N F ; B 76 0 587 718 ;\nC 71 ; WX 778 ; N G ; B 44 -19 713 737 ;\nC 72 ; WX 722 ; N H ; B 71 0 651 718 ;\nC 73 ; WX 278 ; N I ; B 64 0 214 718 ;\nC 74 ; WX 556 ; N J ; B 22 -18 484 718 ;\nC 75 ; WX 722 ; N K ; B 87 0 722 718 ;\nC 76 ; WX 611 ; N L ; B 76 0 583 718 ;\nC 77 ; WX 833 ; N M ; B 69 0 765 718 ;\nC 78 ; WX 722 ; N N ; B 69 0 654 718 ;\nC 79 ; WX 778 ; N O ; B 44 -19 734 737 ;\nC 80 ; WX 667 ; N P ; B 76 0 627 718 ;\nC 81 ; WX 778 ; N Q ; B 44 -52 737 737 ;\nC 82 ; WX 722 ; N R ; B 76 0 677 718 ;\nC 83 ; WX 667 ; N S ; B 39 -19 629 737 ;\nC 84 ; WX 611 ; N T ; B 14 0 598 718 ;\nC 85 ; WX 722 ; N U ; B 72 -19 651 718 ;\nC 86 ; WX 667 ; N V ; B 19 0 648 718 ;\nC 87 ; WX 944 ; N W ; B 16 0 929 718 ;\nC 88 ; WX 667 ; N X ; B 14 0 653 718 ;\nC 89 ; WX 667 ; N Y ; B 15 0 653 718 ;\nC 90 ; WX 611 ; N Z ; B 25 0 586 718 ;\nC 91 ; WX 333 ; N bracketleft ; B 63 -196 309 722 ;\nC 92 ; WX 278 ; N backslash ; B -33 -19 311 737 ;\nC 93 ; WX 333 ; N bracketright ; B 24 -196 270 722 ;\nC 94 ; WX 584 ; N asciicircum ; B 62 323 522 698 ;\nC 95 ; WX 556 ; N underscore ; B 0 -125 556 -75 ;\nC 96 ; WX 278 ; N quoteleft ; B 69 454 209 727 ;\nC 97 ; WX 556 ; N a ; B 29 -14 527 546 ;\nC 98 ; WX 611 ; N b ; B 61 -14 578 718 ;\nC 99 ; WX 556 ; N c ; B 34 -14 524 546 ;\nC 100 ; WX 611 ; N d ; B 34 -14 551 718 ;\nC 101 ; WX 556 ; N e ; B 23 -14 528 546 ;\nC 102 ; WX 333 ; N f ; B 10 0 318 727 ; L i fi ; L l fl ;\nC 103 ; WX 611 ; N g ; B 40 -217 553 546 ;\nC 104 ; WX 611 ; N h ; B 65 0 546 718 ;\nC 105 ; WX 278 ; N i ; B 69 0 209 725 ;\nC 106 ; WX 278 ; N j ; B 3 -214 209 725 ;\nC 107 ; WX 556 ; N k ; B 69 0 562 718 ;\nC 108 ; WX 278 ; N l ; B 69 0 209 718 ;\nC 109 ; WX 889 ; N m ; B 64 0 826 546 ;\nC 110 ; WX 611 ; N n ; B 65 0 546 546 ;\nC 111 ; WX 611 ; N o ; B 34 -14 578 546 ;\nC 112 ; WX 611 ; N p ; B 62 -207 578 546 ;\nC 113 ; WX 611 ; N q ; B 34 -207 552 546 ;\nC 114 ; WX 389 ; N r ; B 64 0 373 546 ;\nC 115 ; WX 556 ; N s ; B 30 -14 519 546 ;\nC 116 ; WX 333 ; N t ; B 10 -6 309 676 ;\nC 117 ; WX 611 ; N u ; B 66 -14 545 532 ;\nC 118 ; WX 556 ; N v ; B 13 0 543 532 ;\nC 119 ; WX 778 ; N w ; B 10 0 769 532 ;\nC 120 ; WX 556 ; N x ; B 15 0 541 532 ;\nC 121 ; WX 556 ; N y ; B 10 -214 539 532 ;\nC 122 ; WX 500 ; N z ; B 20 0 480 532 ;\nC 123 ; WX 389 ; N braceleft ; B 48 -196 365 722 ;\nC 124 ; WX 280 ; N bar ; B 84 -225 196 775 ;\nC 125 ; WX 389 ; N braceright ; B 24 -196 341 722 ;\nC 126 ; WX 584 ; N asciitilde ; B 61 163 523 343 ;\nC 161 ; WX 333 ; N exclamdown ; B 90 -186 244 532 ;\nC 162 ; WX 556 ; N cent ; B 34 -118 524 628 ;\nC 163 ; WX 556 ; N sterling ; B 28 -16 541 718 ;\nC 164 ; WX 167 ; N fraction ; B -170 -19 336 710 ;\nC 165 ; WX 556 ; N yen ; B -9 0 565 698 ;\nC 166 ; WX 556 ; N florin ; B -10 -210 516 737 ;\nC 167 ; WX 556 ; N section ; B 34 -184 522 727 ;\nC 168 ; WX 556 ; N currency ; B -3 76 559 636 ;\nC 169 ; WX 238 ; N quotesingle ; B 70 447 168 718 ;\nC 170 ; WX 500 ; N quotedblleft ; B 64 454 436 727 ;\nC 171 ; WX 556 ; N guillemotleft ; B 88 76 468 484 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 83 76 250 484 ;\nC 173 ; WX 333 ; N guilsinglright ; B 83 76 250 484 ;\nC 174 ; WX 611 ; N fi ; B 10 0 542 727 ;\nC 175 ; WX 611 ; N fl ; B 10 0 542 727 ;\nC 177 ; WX 556 ; N endash ; B 0 227 556 333 ;\nC 178 ; WX 556 ; N dagger ; B 36 -171 520 718 ;\nC 179 ; WX 556 ; N daggerdbl ; B 36 -171 520 718 ;\nC 180 ; WX 278 ; N periodcentered ; B 58 172 220 334 ;\nC 182 ; WX 556 ; N paragraph ; B -8 -191 539 700 ;\nC 183 ; WX 350 ; N bullet ; B 10 194 340 524 ;\nC 184 ; WX 278 ; N quotesinglbase ; B 69 -146 209 127 ;\nC 185 ; WX 500 ; N quotedblbase ; B 64 -146 436 127 ;\nC 186 ; WX 500 ; N quotedblright ; B 64 445 436 718 ;\nC 187 ; WX 556 ; N guillemotright ; B 88 76 468 484 ;\nC 188 ; WX 1000 ; N ellipsis ; B 92 0 908 146 ;\nC 189 ; WX 1000 ; N perthousand ; B -3 -19 1003 710 ;\nC 191 ; WX 611 ; N questiondown ; B 55 -195 551 532 ;\nC 193 ; WX 333 ; N grave ; B -23 604 225 750 ;\nC 194 ; WX 333 ; N acute ; B 108 604 356 750 ;\nC 195 ; WX 333 ; N circumflex ; B -10 604 343 750 ;\nC 196 ; WX 333 ; N tilde ; B -17 610 350 737 ;\nC 197 ; WX 333 ; N macron ; B -6 604 339 678 ;\nC 198 ; WX 333 ; N breve ; B -2 604 335 750 ;\nC 199 ; WX 333 ; N dotaccent ; B 104 614 230 729 ;\nC 200 ; WX 333 ; N dieresis ; B 6 614 327 729 ;\nC 202 ; WX 333 ; N ring ; B 59 568 275 776 ;\nC 203 ; WX 333 ; N cedilla ; B 6 -228 245 0 ;\nC 205 ; WX 333 ; N hungarumlaut ; B 9 604 486 750 ;\nC 206 ; WX 333 ; N ogonek ; B 71 -228 304 0 ;\nC 207 ; WX 333 ; N caron ; B -10 604 343 750 ;\nC 208 ; WX 1000 ; N emdash ; B 0 227 1000 333 ;\nC 225 ; WX 1000 ; N AE ; B 5 0 954 718 ;\nC 227 ; WX 370 ; N ordfeminine ; B 22 401 347 737 ;\nC 232 ; WX 611 ; N Lslash ; B -20 0 583 718 ;\nC 233 ; WX 778 ; N Oslash ; B 33 -27 744 745 ;\nC 234 ; WX 1000 ; N OE ; B 37 -19 961 737 ;\nC 235 ; WX 365 ; N ordmasculine ; B 6 401 360 737 ;\nC 241 ; WX 889 ; N ae ; B 29 -14 858 546 ;\nC 245 ; WX 278 ; N dotlessi ; B 69 0 209 532 ;\nC 248 ; WX 278 ; N lslash ; B -18 0 296 718 ;\nC 249 ; WX 611 ; N oslash ; B 22 -29 589 560 ;\nC 250 ; WX 944 ; N oe ; B 34 -14 912 546 ;\nC 251 ; WX 611 ; N germandbls ; B 69 -14 579 731 ;\nC -1 ; WX 278 ; N Idieresis ; B -21 0 300 915 ;\nC -1 ; WX 556 ; N eacute ; B 23 -14 528 750 ;\nC -1 ; WX 556 ; N abreve ; B 29 -14 527 750 ;\nC -1 ; WX 611 ; N uhungarumlaut ; B 66 -14 625 750 ;\nC -1 ; WX 556 ; N ecaron ; B 23 -14 528 750 ;\nC -1 ; WX 667 ; N Ydieresis ; B 15 0 653 915 ;\nC -1 ; WX 584 ; N divide ; B 40 -42 544 548 ;\nC -1 ; WX 667 ; N Yacute ; B 15 0 653 936 ;\nC -1 ; WX 722 ; N Acircumflex ; B 20 0 702 936 ;\nC -1 ; WX 556 ; N aacute ; B 29 -14 527 750 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 72 -19 651 936 ;\nC -1 ; WX 556 ; N yacute ; B 10 -214 539 750 ;\nC -1 ; WX 556 ; N scommaaccent ; B 30 -228 519 546 ;\nC -1 ; WX 556 ; N ecircumflex ; B 23 -14 528 750 ;\nC -1 ; WX 722 ; N Uring ; B 72 -19 651 962 ;\nC -1 ; WX 722 ; N Udieresis ; B 72 -19 651 915 ;\nC -1 ; WX 556 ; N aogonek ; B 29 -224 545 546 ;\nC -1 ; WX 722 ; N Uacute ; B 72 -19 651 936 ;\nC -1 ; WX 611 ; N uogonek ; B 66 -228 545 532 ;\nC -1 ; WX 667 ; N Edieresis ; B 76 0 621 915 ;\nC -1 ; WX 722 ; N Dcroat ; B -5 0 685 718 ;\nC -1 ; WX 250 ; N commaaccent ; B 64 -228 199 -50 ;\nC -1 ; WX 737 ; N copyright ; B -11 -19 749 737 ;\nC -1 ; WX 667 ; N Emacron ; B 76 0 621 864 ;\nC -1 ; WX 556 ; N ccaron ; B 34 -14 524 750 ;\nC -1 ; WX 556 ; N aring ; B 29 -14 527 776 ;\nC -1 ; WX 722 ; N Ncommaaccent ; B 69 -228 654 718 ;\nC -1 ; WX 278 ; N lacute ; B 69 0 329 936 ;\nC -1 ; WX 556 ; N agrave ; B 29 -14 527 750 ;\nC -1 ; WX 611 ; N Tcommaaccent ; B 14 -228 598 718 ;\nC -1 ; WX 722 ; N Cacute ; B 44 -19 684 936 ;\nC -1 ; WX 556 ; N atilde ; B 29 -14 527 737 ;\nC -1 ; WX 667 ; N Edotaccent ; B 76 0 621 915 ;\nC -1 ; WX 556 ; N scaron ; B 30 -14 519 750 ;\nC -1 ; WX 556 ; N scedilla ; B 30 -228 519 546 ;\nC -1 ; WX 278 ; N iacute ; B 69 0 329 750 ;\nC -1 ; WX 494 ; N lozenge ; B 10 0 484 745 ;\nC -1 ; WX 722 ; N Rcaron ; B 76 0 677 936 ;\nC -1 ; WX 778 ; N Gcommaaccent ; B 44 -228 713 737 ;\nC -1 ; WX 611 ; N ucircumflex ; B 66 -14 545 750 ;\nC -1 ; WX 556 ; N acircumflex ; B 29 -14 527 750 ;\nC -1 ; WX 722 ; N Amacron ; B 20 0 702 864 ;\nC -1 ; WX 389 ; N rcaron ; B 18 0 373 750 ;\nC -1 ; WX 556 ; N ccedilla ; B 34 -228 524 546 ;\nC -1 ; WX 611 ; N Zdotaccent ; B 25 0 586 915 ;\nC -1 ; WX 667 ; N Thorn ; B 76 0 627 718 ;\nC -1 ; WX 778 ; N Omacron ; B 44 -19 734 864 ;\nC -1 ; WX 722 ; N Racute ; B 76 0 677 936 ;\nC -1 ; WX 667 ; N Sacute ; B 39 -19 629 936 ;\nC -1 ; WX 743 ; N dcaron ; B 34 -14 750 718 ;\nC -1 ; WX 722 ; N Umacron ; B 72 -19 651 864 ;\nC -1 ; WX 611 ; N uring ; B 66 -14 545 776 ;\nC -1 ; WX 333 ; N threesuperior ; B 8 271 326 710 ;\nC -1 ; WX 778 ; N Ograve ; B 44 -19 734 936 ;\nC -1 ; WX 722 ; N Agrave ; B 20 0 702 936 ;\nC -1 ; WX 722 ; N Abreve ; B 20 0 702 936 ;\nC -1 ; WX 584 ; N multiply ; B 40 1 545 505 ;\nC -1 ; WX 611 ; N uacute ; B 66 -14 545 750 ;\nC -1 ; WX 611 ; N Tcaron ; B 14 0 598 936 ;\nC -1 ; WX 494 ; N partialdiff ; B 11 -21 494 750 ;\nC -1 ; WX 556 ; N ydieresis ; B 10 -214 539 729 ;\nC -1 ; WX 722 ; N Nacute ; B 69 0 654 936 ;\nC -1 ; WX 278 ; N icircumflex ; B -37 0 316 750 ;\nC -1 ; WX 667 ; N Ecircumflex ; B 76 0 621 936 ;\nC -1 ; WX 556 ; N adieresis ; B 29 -14 527 729 ;\nC -1 ; WX 556 ; N edieresis ; B 23 -14 528 729 ;\nC -1 ; WX 556 ; N cacute ; B 34 -14 524 750 ;\nC -1 ; WX 611 ; N nacute ; B 65 0 546 750 ;\nC -1 ; WX 611 ; N umacron ; B 66 -14 545 678 ;\nC -1 ; WX 722 ; N Ncaron ; B 69 0 654 936 ;\nC -1 ; WX 278 ; N Iacute ; B 64 0 329 936 ;\nC -1 ; WX 584 ; N plusminus ; B 40 0 544 506 ;\nC -1 ; WX 280 ; N brokenbar ; B 84 -150 196 700 ;\nC -1 ; WX 737 ; N registered ; B -11 -19 748 737 ;\nC -1 ; WX 778 ; N Gbreve ; B 44 -19 713 936 ;\nC -1 ; WX 278 ; N Idotaccent ; B 64 0 214 915 ;\nC -1 ; WX 600 ; N summation ; B 14 -10 585 706 ;\nC -1 ; WX 667 ; N Egrave ; B 76 0 621 936 ;\nC -1 ; WX 389 ; N racute ; B 64 0 384 750 ;\nC -1 ; WX 611 ; N omacron ; B 34 -14 578 678 ;\nC -1 ; WX 611 ; N Zacute ; B 25 0 586 936 ;\nC -1 ; WX 611 ; N Zcaron ; B 25 0 586 936 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 704 ;\nC -1 ; WX 722 ; N Eth ; B -5 0 685 718 ;\nC -1 ; WX 722 ; N Ccedilla ; B 44 -228 684 737 ;\nC -1 ; WX 278 ; N lcommaaccent ; B 69 -228 213 718 ;\nC -1 ; WX 389 ; N tcaron ; B 10 -6 421 878 ;\nC -1 ; WX 556 ; N eogonek ; B 23 -228 528 546 ;\nC -1 ; WX 722 ; N Uogonek ; B 72 -228 651 718 ;\nC -1 ; WX 722 ; N Aacute ; B 20 0 702 936 ;\nC -1 ; WX 722 ; N Adieresis ; B 20 0 702 915 ;\nC -1 ; WX 556 ; N egrave ; B 23 -14 528 750 ;\nC -1 ; WX 500 ; N zacute ; B 20 0 480 750 ;\nC -1 ; WX 278 ; N iogonek ; B 16 -224 249 725 ;\nC -1 ; WX 778 ; N Oacute ; B 44 -19 734 936 ;\nC -1 ; WX 611 ; N oacute ; B 34 -14 578 750 ;\nC -1 ; WX 556 ; N amacron ; B 29 -14 527 678 ;\nC -1 ; WX 556 ; N sacute ; B 30 -14 519 750 ;\nC -1 ; WX 278 ; N idieresis ; B -21 0 300 729 ;\nC -1 ; WX 778 ; N Ocircumflex ; B 44 -19 734 936 ;\nC -1 ; WX 722 ; N Ugrave ; B 72 -19 651 936 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 611 ; N thorn ; B 62 -208 578 718 ;\nC -1 ; WX 333 ; N twosuperior ; B 9 283 324 710 ;\nC -1 ; WX 778 ; N Odieresis ; B 44 -19 734 915 ;\nC -1 ; WX 611 ; N mu ; B 66 -207 545 532 ;\nC -1 ; WX 278 ; N igrave ; B -50 0 209 750 ;\nC -1 ; WX 611 ; N ohungarumlaut ; B 34 -14 625 750 ;\nC -1 ; WX 667 ; N Eogonek ; B 76 -224 639 718 ;\nC -1 ; WX 611 ; N dcroat ; B 34 -14 650 718 ;\nC -1 ; WX 834 ; N threequarters ; B 16 -19 799 710 ;\nC -1 ; WX 667 ; N Scedilla ; B 39 -228 629 737 ;\nC -1 ; WX 400 ; N lcaron ; B 69 0 408 718 ;\nC -1 ; WX 722 ; N Kcommaaccent ; B 87 -228 722 718 ;\nC -1 ; WX 611 ; N Lacute ; B 76 0 583 936 ;\nC -1 ; WX 1000 ; N trademark ; B 44 306 956 718 ;\nC -1 ; WX 556 ; N edotaccent ; B 23 -14 528 729 ;\nC -1 ; WX 278 ; N Igrave ; B -50 0 214 936 ;\nC -1 ; WX 278 ; N Imacron ; B -33 0 312 864 ;\nC -1 ; WX 611 ; N Lcaron ; B 76 0 583 718 ;\nC -1 ; WX 834 ; N onehalf ; B 26 -19 794 710 ;\nC -1 ; WX 549 ; N lessequal ; B 29 0 526 704 ;\nC -1 ; WX 611 ; N ocircumflex ; B 34 -14 578 750 ;\nC -1 ; WX 611 ; N ntilde ; B 65 0 546 737 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 72 -19 681 936 ;\nC -1 ; WX 667 ; N Eacute ; B 76 0 621 936 ;\nC -1 ; WX 556 ; N emacron ; B 23 -14 528 678 ;\nC -1 ; WX 611 ; N gbreve ; B 40 -217 553 750 ;\nC -1 ; WX 834 ; N onequarter ; B 26 -19 766 710 ;\nC -1 ; WX 667 ; N Scaron ; B 39 -19 629 936 ;\nC -1 ; WX 667 ; N Scommaaccent ; B 39 -228 629 737 ;\nC -1 ; WX 778 ; N Ohungarumlaut ; B 44 -19 734 936 ;\nC -1 ; WX 400 ; N degree ; B 57 426 343 712 ;\nC -1 ; WX 611 ; N ograve ; B 34 -14 578 750 ;\nC -1 ; WX 722 ; N Ccaron ; B 44 -19 684 936 ;\nC -1 ; WX 611 ; N ugrave ; B 66 -14 545 750 ;\nC -1 ; WX 549 ; N radical ; B 10 -46 512 850 ;\nC -1 ; WX 722 ; N Dcaron ; B 76 0 685 936 ;\nC -1 ; WX 389 ; N rcommaaccent ; B 64 -228 373 546 ;\nC -1 ; WX 722 ; N Ntilde ; B 69 0 654 923 ;\nC -1 ; WX 611 ; N otilde ; B 34 -14 578 737 ;\nC -1 ; WX 722 ; N Rcommaaccent ; B 76 -228 677 718 ;\nC -1 ; WX 611 ; N Lcommaaccent ; B 76 -228 583 718 ;\nC -1 ; WX 722 ; N Atilde ; B 20 0 702 923 ;\nC -1 ; WX 722 ; N Aogonek ; B 20 -224 742 718 ;\nC -1 ; WX 722 ; N Aring ; B 20 0 702 962 ;\nC -1 ; WX 778 ; N Otilde ; B 44 -19 734 923 ;\nC -1 ; WX 500 ; N zdotaccent ; B 20 0 480 729 ;\nC -1 ; WX 667 ; N Ecaron ; B 76 0 621 936 ;\nC -1 ; WX 278 ; N Iogonek ; B -11 -228 222 718 ;\nC -1 ; WX 556 ; N kcommaaccent ; B 69 -228 562 718 ;\nC -1 ; WX 584 ; N minus ; B 40 197 544 309 ;\nC -1 ; WX 278 ; N Icircumflex ; B -37 0 316 936 ;\nC -1 ; WX 611 ; N ncaron ; B 65 0 546 750 ;\nC -1 ; WX 333 ; N tcommaaccent ; B 10 -228 309 676 ;\nC -1 ; WX 584 ; N logicalnot ; B 40 108 544 419 ;\nC -1 ; WX 611 ; N odieresis ; B 34 -14 578 729 ;\nC -1 ; WX 611 ; N udieresis ; B 66 -14 545 729 ;\nC -1 ; WX 549 ; N notequal ; B 15 -49 540 570 ;\nC -1 ; WX 611 ; N gcommaaccent ; B 40 -217 553 850 ;\nC -1 ; WX 611 ; N eth ; B 34 -14 578 737 ;\nC -1 ; WX 500 ; N zcaron ; B 20 0 480 750 ;\nC -1 ; WX 611 ; N ncommaaccent ; B 65 -228 546 546 ;\nC -1 ; WX 333 ; N onesuperior ; B 26 283 237 710 ;\nC -1 ; WX 278 ; N imacron ; B -8 0 285 678 ;\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2481\nKPX A C -40\nKPX A Cacute -40\nKPX A Ccaron -40\nKPX A Ccedilla -40\nKPX A G -50\nKPX A Gbreve -50\nKPX A Gcommaaccent -50\nKPX A O -40\nKPX A Oacute -40\nKPX A Ocircumflex -40\nKPX A Odieresis -40\nKPX A Ograve -40\nKPX A Ohungarumlaut -40\nKPX A Omacron -40\nKPX A Oslash -40\nKPX A Otilde -40\nKPX A Q -40\nKPX A T -90\nKPX A Tcaron -90\nKPX A Tcommaaccent -90\nKPX A U -50\nKPX A Uacute -50\nKPX A Ucircumflex -50\nKPX A Udieresis -50\nKPX A Ugrave -50\nKPX A Uhungarumlaut -50\nKPX A Umacron -50\nKPX A Uogonek -50\nKPX A Uring -50\nKPX A V -80\nKPX A W -60\nKPX A Y -110\nKPX A Yacute -110\nKPX A Ydieresis -110\nKPX A u -30\nKPX A uacute -30\nKPX A ucircumflex -30\nKPX A udieresis -30\nKPX A ugrave -30\nKPX A uhungarumlaut -30\nKPX A umacron -30\nKPX A uogonek -30\nKPX A uring -30\nKPX A v -40\nKPX A w -30\nKPX A y -30\nKPX A yacute -30\nKPX A ydieresis -30\nKPX Aacute C -40\nKPX Aacute Cacute -40\nKPX Aacute Ccaron -40\nKPX Aacute Ccedilla -40\nKPX Aacute G -50\nKPX Aacute Gbreve -50\nKPX Aacute Gcommaaccent -50\nKPX Aacute O -40\nKPX Aacute Oacute -40\nKPX Aacute Ocircumflex -40\nKPX Aacute Odieresis -40\nKPX Aacute Ograve -40\nKPX Aacute Ohungarumlaut -40\nKPX Aacute Omacron -40\nKPX Aacute Oslash -40\nKPX Aacute Otilde -40\nKPX Aacute Q -40\nKPX Aacute T -90\nKPX Aacute Tcaron -90\nKPX Aacute Tcommaaccent -90\nKPX Aacute U -50\nKPX Aacute Uacute -50\nKPX Aacute Ucircumflex -50\nKPX Aacute Udieresis -50\nKPX Aacute Ugrave -50\nKPX Aacute Uhungarumlaut -50\nKPX Aacute Umacron -50\nKPX Aacute Uogonek -50\nKPX Aacute Uring -50\nKPX Aacute V -80\nKPX Aacute W -60\nKPX Aacute Y -110\nKPX Aacute Yacute -110\nKPX Aacute Ydieresis -110\nKPX Aacute u -30\nKPX Aacute uacute -30\nKPX Aacute ucircumflex -30\nKPX Aacute udieresis -30\nKPX Aacute ugrave -30\nKPX Aacute uhungarumlaut -30\nKPX Aacute umacron -30\nKPX Aacute uogonek -30\nKPX Aacute uring -30\nKPX Aacute v -40\nKPX Aacute w -30\nKPX Aacute y -30\nKPX Aacute yacute -30\nKPX Aacute ydieresis -30\nKPX Abreve C -40\nKPX Abreve Cacute -40\nKPX Abreve Ccaron -40\nKPX Abreve Ccedilla -40\nKPX Abreve G -50\nKPX Abreve Gbreve -50\nKPX Abreve Gcommaaccent -50\nKPX Abreve O -40\nKPX Abreve Oacute -40\nKPX Abreve Ocircumflex -40\nKPX Abreve Odieresis -40\nKPX Abreve Ograve -40\nKPX Abreve Ohungarumlaut -40\nKPX Abreve Omacron -40\nKPX Abreve Oslash -40\nKPX Abreve Otilde -40\nKPX Abreve Q -40\nKPX Abreve T -90\nKPX Abreve Tcaron -90\nKPX Abreve Tcommaaccent -90\nKPX Abreve U -50\nKPX Abreve Uacute -50\nKPX Abreve Ucircumflex -50\nKPX Abreve Udieresis -50\nKPX Abreve Ugrave -50\nKPX Abreve Uhungarumlaut -50\nKPX Abreve Umacron -50\nKPX Abreve Uogonek -50\nKPX Abreve Uring -50\nKPX Abreve V -80\nKPX Abreve W -60\nKPX Abreve Y -110\nKPX Abreve Yacute -110\nKPX Abreve Ydieresis -110\nKPX Abreve u -30\nKPX Abreve uacute -30\nKPX Abreve ucircumflex -30\nKPX Abreve udieresis -30\nKPX Abreve ugrave -30\nKPX Abreve uhungarumlaut -30\nKPX Abreve umacron -30\nKPX Abreve uogonek -30\nKPX Abreve uring -30\nKPX Abreve v -40\nKPX Abreve w -30\nKPX Abreve y -30\nKPX Abreve yacute -30\nKPX Abreve ydieresis -30\nKPX Acircumflex C -40\nKPX Acircumflex Cacute -40\nKPX Acircumflex Ccaron -40\nKPX Acircumflex Ccedilla -40\nKPX Acircumflex G -50\nKPX Acircumflex Gbreve -50\nKPX Acircumflex Gcommaaccent -50\nKPX Acircumflex O -40\nKPX Acircumflex Oacute -40\nKPX Acircumflex Ocircumflex -40\nKPX Acircumflex Odieresis -40\nKPX Acircumflex Ograve -40\nKPX Acircumflex Ohungarumlaut -40\nKPX Acircumflex Omacron -40\nKPX Acircumflex Oslash -40\nKPX Acircumflex Otilde -40\nKPX Acircumflex Q -40\nKPX Acircumflex T -90\nKPX Acircumflex Tcaron -90\nKPX Acircumflex Tcommaaccent -90\nKPX Acircumflex U -50\nKPX Acircumflex Uacute -50\nKPX Acircumflex Ucircumflex -50\nKPX Acircumflex Udieresis -50\nKPX Acircumflex Ugrave -50\nKPX Acircumflex Uhungarumlaut -50\nKPX Acircumflex Umacron -50\nKPX Acircumflex Uogonek -50\nKPX Acircumflex Uring -50\nKPX Acircumflex V -80\nKPX Acircumflex W -60\nKPX Acircumflex Y -110\nKPX Acircumflex Yacute -110\nKPX Acircumflex Ydieresis -110\nKPX Acircumflex u -30\nKPX Acircumflex uacute -30\nKPX Acircumflex ucircumflex -30\nKPX Acircumflex udieresis -30\nKPX Acircumflex ugrave -30\nKPX Acircumflex uhungarumlaut -30\nKPX Acircumflex umacron -30\nKPX Acircumflex uogonek -30\nKPX Acircumflex uring -30\nKPX Acircumflex v -40\nKPX Acircumflex w -30\nKPX Acircumflex y -30\nKPX Acircumflex yacute -30\nKPX Acircumflex ydieresis -30\nKPX Adieresis C -40\nKPX Adieresis Cacute -40\nKPX Adieresis Ccaron -40\nKPX Adieresis Ccedilla -40\nKPX Adieresis G -50\nKPX Adieresis Gbreve -50\nKPX Adieresis Gcommaaccent -50\nKPX Adieresis O -40\nKPX Adieresis Oacute -40\nKPX Adieresis Ocircumflex -40\nKPX Adieresis Odieresis -40\nKPX Adieresis Ograve -40\nKPX Adieresis Ohungarumlaut -40\nKPX Adieresis Omacron -40\nKPX Adieresis Oslash -40\nKPX Adieresis Otilde -40\nKPX Adieresis Q -40\nKPX Adieresis T -90\nKPX Adieresis Tcaron -90\nKPX Adieresis Tcommaaccent -90\nKPX Adieresis U -50\nKPX Adieresis Uacute -50\nKPX Adieresis Ucircumflex -50\nKPX Adieresis Udieresis -50\nKPX Adieresis Ugrave -50\nKPX Adieresis Uhungarumlaut -50\nKPX Adieresis Umacron -50\nKPX Adieresis Uogonek -50\nKPX Adieresis Uring -50\nKPX Adieresis V -80\nKPX Adieresis W -60\nKPX Adieresis Y -110\nKPX Adieresis Yacute -110\nKPX Adieresis Ydieresis -110\nKPX Adieresis u -30\nKPX Adieresis uacute -30\nKPX Adieresis ucircumflex -30\nKPX Adieresis udieresis -30\nKPX Adieresis ugrave -30\nKPX Adieresis uhungarumlaut -30\nKPX Adieresis umacron -30\nKPX Adieresis uogonek -30\nKPX Adieresis uring -30\nKPX Adieresis v -40\nKPX Adieresis w -30\nKPX Adieresis y -30\nKPX Adieresis yacute -30\nKPX Adieresis ydieresis -30\nKPX Agrave C -40\nKPX Agrave Cacute -40\nKPX Agrave Ccaron -40\nKPX Agrave Ccedilla -40\nKPX Agrave G -50\nKPX Agrave Gbreve -50\nKPX Agrave Gcommaaccent -50\nKPX Agrave O -40\nKPX Agrave Oacute -40\nKPX Agrave Ocircumflex -40\nKPX Agrave Odieresis -40\nKPX Agrave Ograve -40\nKPX Agrave Ohungarumlaut -40\nKPX Agrave Omacron -40\nKPX Agrave Oslash -40\nKPX Agrave Otilde -40\nKPX Agrave Q -40\nKPX Agrave T -90\nKPX Agrave Tcaron -90\nKPX Agrave Tcommaaccent -90\nKPX Agrave U -50\nKPX Agrave Uacute -50\nKPX Agrave Ucircumflex -50\nKPX Agrave Udieresis -50\nKPX Agrave Ugrave -50\nKPX Agrave Uhungarumlaut -50\nKPX Agrave Umacron -50\nKPX Agrave Uogonek -50\nKPX Agrave Uring -50\nKPX Agrave V -80\nKPX Agrave W -60\nKPX Agrave Y -110\nKPX Agrave Yacute -110\nKPX Agrave Ydieresis -110\nKPX Agrave u -30\nKPX Agrave uacute -30\nKPX Agrave ucircumflex -30\nKPX Agrave udieresis -30\nKPX Agrave ugrave -30\nKPX Agrave uhungarumlaut -30\nKPX Agrave umacron -30\nKPX Agrave uogonek -30\nKPX Agrave uring -30\nKPX Agrave v -40\nKPX Agrave w -30\nKPX Agrave y -30\nKPX Agrave yacute -30\nKPX Agrave ydieresis -30\nKPX Amacron C -40\nKPX Amacron Cacute -40\nKPX Amacron Ccaron -40\nKPX Amacron Ccedilla -40\nKPX Amacron G -50\nKPX Amacron Gbreve -50\nKPX Amacron Gcommaaccent -50\nKPX Amacron O -40\nKPX Amacron Oacute -40\nKPX Amacron Ocircumflex -40\nKPX Amacron Odieresis -40\nKPX Amacron Ograve -40\nKPX Amacron Ohungarumlaut -40\nKPX Amacron Omacron -40\nKPX Amacron Oslash -40\nKPX Amacron Otilde -40\nKPX Amacron Q -40\nKPX Amacron T -90\nKPX Amacron Tcaron -90\nKPX Amacron Tcommaaccent -90\nKPX Amacron U -50\nKPX Amacron Uacute -50\nKPX Amacron Ucircumflex -50\nKPX Amacron Udieresis -50\nKPX Amacron Ugrave -50\nKPX Amacron Uhungarumlaut -50\nKPX Amacron Umacron -50\nKPX Amacron Uogonek -50\nKPX Amacron Uring -50\nKPX Amacron V -80\nKPX Amacron W -60\nKPX Amacron Y -110\nKPX Amacron Yacute -110\nKPX Amacron Ydieresis -110\nKPX Amacron u -30\nKPX Amacron uacute -30\nKPX Amacron ucircumflex -30\nKPX Amacron udieresis -30\nKPX Amacron ugrave -30\nKPX Amacron uhungarumlaut -30\nKPX Amacron umacron -30\nKPX Amacron uogonek -30\nKPX Amacron uring -30\nKPX Amacron v -40\nKPX Amacron w -30\nKPX Amacron y -30\nKPX Amacron yacute -30\nKPX Amacron ydieresis -30\nKPX Aogonek C -40\nKPX Aogonek Cacute -40\nKPX Aogonek Ccaron -40\nKPX Aogonek Ccedilla -40\nKPX Aogonek G -50\nKPX Aogonek Gbreve -50\nKPX Aogonek Gcommaaccent -50\nKPX Aogonek O -40\nKPX Aogonek Oacute -40\nKPX Aogonek Ocircumflex -40\nKPX Aogonek Odieresis -40\nKPX Aogonek Ograve -40\nKPX Aogonek Ohungarumlaut -40\nKPX Aogonek Omacron -40\nKPX Aogonek Oslash -40\nKPX Aogonek Otilde -40\nKPX Aogonek Q -40\nKPX Aogonek T -90\nKPX Aogonek Tcaron -90\nKPX Aogonek Tcommaaccent -90\nKPX Aogonek U -50\nKPX Aogonek Uacute -50\nKPX Aogonek Ucircumflex -50\nKPX Aogonek Udieresis -50\nKPX Aogonek Ugrave -50\nKPX Aogonek Uhungarumlaut -50\nKPX Aogonek Umacron -50\nKPX Aogonek Uogonek -50\nKPX Aogonek Uring -50\nKPX Aogonek V -80\nKPX Aogonek W -60\nKPX Aogonek Y -110\nKPX Aogonek Yacute -110\nKPX Aogonek Ydieresis -110\nKPX Aogonek u -30\nKPX Aogonek uacute -30\nKPX Aogonek ucircumflex -30\nKPX Aogonek udieresis -30\nKPX Aogonek ugrave -30\nKPX Aogonek uhungarumlaut -30\nKPX Aogonek umacron -30\nKPX Aogonek uogonek -30\nKPX Aogonek uring -30\nKPX Aogonek v -40\nKPX Aogonek w -30\nKPX Aogonek y -30\nKPX Aogonek yacute -30\nKPX Aogonek ydieresis -30\nKPX Aring C -40\nKPX Aring Cacute -40\nKPX Aring Ccaron -40\nKPX Aring Ccedilla -40\nKPX Aring G -50\nKPX Aring Gbreve -50\nKPX Aring Gcommaaccent -50\nKPX Aring O -40\nKPX Aring Oacute -40\nKPX Aring Ocircumflex -40\nKPX Aring Odieresis -40\nKPX Aring Ograve -40\nKPX Aring Ohungarumlaut -40\nKPX Aring Omacron -40\nKPX Aring Oslash -40\nKPX Aring Otilde -40\nKPX Aring Q -40\nKPX Aring T -90\nKPX Aring Tcaron -90\nKPX Aring Tcommaaccent -90\nKPX Aring U -50\nKPX Aring Uacute -50\nKPX Aring Ucircumflex -50\nKPX Aring Udieresis -50\nKPX Aring Ugrave -50\nKPX Aring Uhungarumlaut -50\nKPX Aring Umacron -50\nKPX Aring Uogonek -50\nKPX Aring Uring -50\nKPX Aring V -80\nKPX Aring W -60\nKPX Aring Y -110\nKPX Aring Yacute -110\nKPX Aring Ydieresis -110\nKPX Aring u -30\nKPX Aring uacute -30\nKPX Aring ucircumflex -30\nKPX Aring udieresis -30\nKPX Aring ugrave -30\nKPX Aring uhungarumlaut -30\nKPX Aring umacron -30\nKPX Aring uogonek -30\nKPX Aring uring -30\nKPX Aring v -40\nKPX Aring w -30\nKPX Aring y -30\nKPX Aring yacute -30\nKPX Aring ydieresis -30\nKPX Atilde C -40\nKPX Atilde Cacute -40\nKPX Atilde Ccaron -40\nKPX Atilde Ccedilla -40\nKPX Atilde G -50\nKPX Atilde Gbreve -50\nKPX Atilde Gcommaaccent -50\nKPX Atilde O -40\nKPX Atilde Oacute -40\nKPX Atilde Ocircumflex -40\nKPX Atilde Odieresis -40\nKPX Atilde Ograve -40\nKPX Atilde Ohungarumlaut -40\nKPX Atilde Omacron -40\nKPX Atilde Oslash -40\nKPX Atilde Otilde -40\nKPX Atilde Q -40\nKPX Atilde T -90\nKPX Atilde Tcaron -90\nKPX Atilde Tcommaaccent -90\nKPX Atilde U -50\nKPX Atilde Uacute -50\nKPX Atilde Ucircumflex -50\nKPX Atilde Udieresis -50\nKPX Atilde Ugrave -50\nKPX Atilde Uhungarumlaut -50\nKPX Atilde Umacron -50\nKPX Atilde Uogonek -50\nKPX Atilde Uring -50\nKPX Atilde V -80\nKPX Atilde W -60\nKPX Atilde Y -110\nKPX Atilde Yacute -110\nKPX Atilde Ydieresis -110\nKPX Atilde u -30\nKPX Atilde uacute -30\nKPX Atilde ucircumflex -30\nKPX Atilde udieresis -30\nKPX Atilde ugrave -30\nKPX Atilde uhungarumlaut -30\nKPX Atilde umacron -30\nKPX Atilde uogonek -30\nKPX Atilde uring -30\nKPX Atilde v -40\nKPX Atilde w -30\nKPX Atilde y -30\nKPX Atilde yacute -30\nKPX Atilde ydieresis -30\nKPX B A -30\nKPX B Aacute -30\nKPX B Abreve -30\nKPX B Acircumflex -30\nKPX B Adieresis -30\nKPX B Agrave -30\nKPX B Amacron -30\nKPX B Aogonek -30\nKPX B Aring -30\nKPX B Atilde -30\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX D A -40\nKPX D Aacute -40\nKPX D Abreve -40\nKPX D Acircumflex -40\nKPX D Adieresis -40\nKPX D Agrave -40\nKPX D Amacron -40\nKPX D Aogonek -40\nKPX D Aring -40\nKPX D Atilde -40\nKPX D V -40\nKPX D W -40\nKPX D Y -70\nKPX D Yacute -70\nKPX D Ydieresis -70\nKPX D comma -30\nKPX D period -30\nKPX Dcaron A -40\nKPX Dcaron Aacute -40\nKPX Dcaron Abreve -40\nKPX Dcaron Acircumflex -40\nKPX Dcaron Adieresis -40\nKPX Dcaron Agrave -40\nKPX Dcaron Amacron -40\nKPX Dcaron Aogonek -40\nKPX Dcaron Aring -40\nKPX Dcaron Atilde -40\nKPX Dcaron V -40\nKPX Dcaron W -40\nKPX Dcaron Y -70\nKPX Dcaron Yacute -70\nKPX Dcaron Ydieresis -70\nKPX Dcaron comma -30\nKPX Dcaron period -30\nKPX Dcroat A -40\nKPX Dcroat Aacute -40\nKPX Dcroat Abreve -40\nKPX Dcroat Acircumflex -40\nKPX Dcroat Adieresis -40\nKPX Dcroat Agrave -40\nKPX Dcroat Amacron -40\nKPX Dcroat Aogonek -40\nKPX Dcroat Aring -40\nKPX Dcroat Atilde -40\nKPX Dcroat V -40\nKPX Dcroat W -40\nKPX Dcroat Y -70\nKPX Dcroat Yacute -70\nKPX Dcroat Ydieresis -70\nKPX Dcroat comma -30\nKPX Dcroat period -30\nKPX F A -80\nKPX F Aacute -80\nKPX F Abreve -80\nKPX F Acircumflex -80\nKPX F Adieresis -80\nKPX F Agrave -80\nKPX F Amacron -80\nKPX F Aogonek -80\nKPX F Aring -80\nKPX F Atilde -80\nKPX F a -20\nKPX F aacute -20\nKPX F abreve -20\nKPX F acircumflex -20\nKPX F adieresis -20\nKPX F agrave -20\nKPX F amacron -20\nKPX F aogonek -20\nKPX F aring -20\nKPX F atilde -20\nKPX F comma -100\nKPX F period -100\nKPX J A -20\nKPX J Aacute -20\nKPX J Abreve -20\nKPX J Acircumflex -20\nKPX J Adieresis -20\nKPX J Agrave -20\nKPX J Amacron -20\nKPX J Aogonek -20\nKPX J Aring -20\nKPX J Atilde -20\nKPX J comma -20\nKPX J period -20\nKPX J u -20\nKPX J uacute -20\nKPX J ucircumflex -20\nKPX J udieresis -20\nKPX J ugrave -20\nKPX J uhungarumlaut -20\nKPX J umacron -20\nKPX J uogonek -20\nKPX J uring -20\nKPX K O -30\nKPX K Oacute -30\nKPX K Ocircumflex -30\nKPX K Odieresis -30\nKPX K Ograve -30\nKPX K Ohungarumlaut -30\nKPX K Omacron -30\nKPX K Oslash -30\nKPX K Otilde -30\nKPX K e -15\nKPX K eacute -15\nKPX K ecaron -15\nKPX K ecircumflex -15\nKPX K edieresis -15\nKPX K edotaccent -15\nKPX K egrave -15\nKPX K emacron -15\nKPX K eogonek -15\nKPX K o -35\nKPX K oacute -35\nKPX K ocircumflex -35\nKPX K odieresis -35\nKPX K ograve -35\nKPX K ohungarumlaut -35\nKPX K omacron -35\nKPX K oslash -35\nKPX K otilde -35\nKPX K u -30\nKPX K uacute -30\nKPX K ucircumflex -30\nKPX K udieresis -30\nKPX K ugrave -30\nKPX K uhungarumlaut -30\nKPX K umacron -30\nKPX K uogonek -30\nKPX K uring -30\nKPX K y -40\nKPX K yacute -40\nKPX K ydieresis -40\nKPX Kcommaaccent O -30\nKPX Kcommaaccent Oacute -30\nKPX Kcommaaccent Ocircumflex -30\nKPX Kcommaaccent Odieresis -30\nKPX Kcommaaccent Ograve -30\nKPX Kcommaaccent Ohungarumlaut -30\nKPX Kcommaaccent Omacron -30\nKPX Kcommaaccent Oslash -30\nKPX Kcommaaccent Otilde -30\nKPX Kcommaaccent e -15\nKPX Kcommaaccent eacute -15\nKPX Kcommaaccent ecaron -15\nKPX Kcommaaccent ecircumflex -15\nKPX Kcommaaccent edieresis -15\nKPX Kcommaaccent edotaccent -15\nKPX Kcommaaccent egrave -15\nKPX Kcommaaccent emacron -15\nKPX Kcommaaccent eogonek -15\nKPX Kcommaaccent o -35\nKPX Kcommaaccent oacute -35\nKPX Kcommaaccent ocircumflex -35\nKPX Kcommaaccent odieresis -35\nKPX Kcommaaccent ograve -35\nKPX Kcommaaccent ohungarumlaut -35\nKPX Kcommaaccent omacron -35\nKPX Kcommaaccent oslash -35\nKPX Kcommaaccent otilde -35\nKPX Kcommaaccent u -30\nKPX Kcommaaccent uacute -30\nKPX Kcommaaccent ucircumflex -30\nKPX Kcommaaccent udieresis -30\nKPX Kcommaaccent ugrave -30\nKPX Kcommaaccent uhungarumlaut -30\nKPX Kcommaaccent umacron -30\nKPX Kcommaaccent uogonek -30\nKPX Kcommaaccent uring -30\nKPX Kcommaaccent y -40\nKPX Kcommaaccent yacute -40\nKPX Kcommaaccent ydieresis -40\nKPX L T -90\nKPX L Tcaron -90\nKPX L Tcommaaccent -90\nKPX L V -110\nKPX L W -80\nKPX L Y -120\nKPX L Yacute -120\nKPX L Ydieresis -120\nKPX L quotedblright -140\nKPX L quoteright -140\nKPX L y -30\nKPX L yacute -30\nKPX L ydieresis -30\nKPX Lacute T -90\nKPX Lacute Tcaron -90\nKPX Lacute Tcommaaccent -90\nKPX Lacute V -110\nKPX Lacute W -80\nKPX Lacute Y -120\nKPX Lacute Yacute -120\nKPX Lacute Ydieresis -120\nKPX Lacute quotedblright -140\nKPX Lacute quoteright -140\nKPX Lacute y -30\nKPX Lacute yacute -30\nKPX Lacute ydieresis -30\nKPX Lcommaaccent T -90\nKPX Lcommaaccent Tcaron -90\nKPX Lcommaaccent Tcommaaccent -90\nKPX Lcommaaccent V -110\nKPX Lcommaaccent W -80\nKPX Lcommaaccent Y -120\nKPX Lcommaaccent Yacute -120\nKPX Lcommaaccent Ydieresis -120\nKPX Lcommaaccent quotedblright -140\nKPX Lcommaaccent quoteright -140\nKPX Lcommaaccent y -30\nKPX Lcommaaccent yacute -30\nKPX Lcommaaccent ydieresis -30\nKPX Lslash T -90\nKPX Lslash Tcaron -90\nKPX Lslash Tcommaaccent -90\nKPX Lslash V -110\nKPX Lslash W -80\nKPX Lslash Y -120\nKPX Lslash Yacute -120\nKPX Lslash Ydieresis -120\nKPX Lslash quotedblright -140\nKPX Lslash quoteright -140\nKPX Lslash y -30\nKPX Lslash yacute -30\nKPX Lslash ydieresis -30\nKPX O A -50\nKPX O Aacute -50\nKPX O Abreve -50\nKPX O Acircumflex -50\nKPX O Adieresis -50\nKPX O Agrave -50\nKPX O Amacron -50\nKPX O Aogonek -50\nKPX O Aring -50\nKPX O Atilde -50\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -50\nKPX O X -50\nKPX O Y -70\nKPX O Yacute -70\nKPX O Ydieresis -70\nKPX O comma -40\nKPX O period -40\nKPX Oacute A -50\nKPX Oacute Aacute -50\nKPX Oacute Abreve -50\nKPX Oacute Acircumflex -50\nKPX Oacute Adieresis -50\nKPX Oacute Agrave -50\nKPX Oacute Amacron -50\nKPX Oacute Aogonek -50\nKPX Oacute Aring -50\nKPX Oacute Atilde -50\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -50\nKPX Oacute X -50\nKPX Oacute Y -70\nKPX Oacute Yacute -70\nKPX Oacute Ydieresis -70\nKPX Oacute comma -40\nKPX Oacute period -40\nKPX Ocircumflex A -50\nKPX Ocircumflex Aacute -50\nKPX Ocircumflex Abreve -50\nKPX Ocircumflex Acircumflex -50\nKPX Ocircumflex Adieresis -50\nKPX Ocircumflex Agrave -50\nKPX Ocircumflex Amacron -50\nKPX Ocircumflex Aogonek -50\nKPX Ocircumflex Aring -50\nKPX Ocircumflex Atilde -50\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -50\nKPX Ocircumflex X -50\nKPX Ocircumflex Y -70\nKPX Ocircumflex Yacute -70\nKPX Ocircumflex Ydieresis -70\nKPX Ocircumflex comma -40\nKPX Ocircumflex period -40\nKPX Odieresis A -50\nKPX Odieresis Aacute -50\nKPX Odieresis Abreve -50\nKPX Odieresis Acircumflex -50\nKPX Odieresis Adieresis -50\nKPX Odieresis Agrave -50\nKPX Odieresis Amacron -50\nKPX Odieresis Aogonek -50\nKPX Odieresis Aring -50\nKPX Odieresis Atilde -50\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -50\nKPX Odieresis X -50\nKPX Odieresis Y -70\nKPX Odieresis Yacute -70\nKPX Odieresis Ydieresis -70\nKPX Odieresis comma -40\nKPX Odieresis period -40\nKPX Ograve A -50\nKPX Ograve Aacute -50\nKPX Ograve Abreve -50\nKPX Ograve Acircumflex -50\nKPX Ograve Adieresis -50\nKPX Ograve Agrave -50\nKPX Ograve Amacron -50\nKPX Ograve Aogonek -50\nKPX Ograve Aring -50\nKPX Ograve Atilde -50\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -50\nKPX Ograve X -50\nKPX Ograve Y -70\nKPX Ograve Yacute -70\nKPX Ograve Ydieresis -70\nKPX Ograve comma -40\nKPX Ograve period -40\nKPX Ohungarumlaut A -50\nKPX Ohungarumlaut Aacute -50\nKPX Ohungarumlaut Abreve -50\nKPX Ohungarumlaut Acircumflex -50\nKPX Ohungarumlaut Adieresis -50\nKPX Ohungarumlaut Agrave -50\nKPX Ohungarumlaut Amacron -50\nKPX Ohungarumlaut Aogonek -50\nKPX Ohungarumlaut Aring -50\nKPX Ohungarumlaut Atilde -50\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -50\nKPX Ohungarumlaut X -50\nKPX Ohungarumlaut Y -70\nKPX Ohungarumlaut Yacute -70\nKPX Ohungarumlaut Ydieresis -70\nKPX Ohungarumlaut comma -40\nKPX Ohungarumlaut period -40\nKPX Omacron A -50\nKPX Omacron Aacute -50\nKPX Omacron Abreve -50\nKPX Omacron Acircumflex -50\nKPX Omacron Adieresis -50\nKPX Omacron Agrave -50\nKPX Omacron Amacron -50\nKPX Omacron Aogonek -50\nKPX Omacron Aring -50\nKPX Omacron Atilde -50\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -50\nKPX Omacron X -50\nKPX Omacron Y -70\nKPX Omacron Yacute -70\nKPX Omacron Ydieresis -70\nKPX Omacron comma -40\nKPX Omacron period -40\nKPX Oslash A -50\nKPX Oslash Aacute -50\nKPX Oslash Abreve -50\nKPX Oslash Acircumflex -50\nKPX Oslash Adieresis -50\nKPX Oslash Agrave -50\nKPX Oslash Amacron -50\nKPX Oslash Aogonek -50\nKPX Oslash Aring -50\nKPX Oslash Atilde -50\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -50\nKPX Oslash X -50\nKPX Oslash Y -70\nKPX Oslash Yacute -70\nKPX Oslash Ydieresis -70\nKPX Oslash comma -40\nKPX Oslash period -40\nKPX Otilde A -50\nKPX Otilde Aacute -50\nKPX Otilde Abreve -50\nKPX Otilde Acircumflex -50\nKPX Otilde Adieresis -50\nKPX Otilde Agrave -50\nKPX Otilde Amacron -50\nKPX Otilde Aogonek -50\nKPX Otilde Aring -50\nKPX Otilde Atilde -50\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -50\nKPX Otilde X -50\nKPX Otilde Y -70\nKPX Otilde Yacute -70\nKPX Otilde Ydieresis -70\nKPX Otilde comma -40\nKPX Otilde period -40\nKPX P A -100\nKPX P Aacute -100\nKPX P Abreve -100\nKPX P Acircumflex -100\nKPX P Adieresis -100\nKPX P Agrave -100\nKPX P Amacron -100\nKPX P Aogonek -100\nKPX P Aring -100\nKPX P Atilde -100\nKPX P a -30\nKPX P aacute -30\nKPX P abreve -30\nKPX P acircumflex -30\nKPX P adieresis -30\nKPX P agrave -30\nKPX P amacron -30\nKPX P aogonek -30\nKPX P aring -30\nKPX P atilde -30\nKPX P comma -120\nKPX P e -30\nKPX P eacute -30\nKPX P ecaron -30\nKPX P ecircumflex -30\nKPX P edieresis -30\nKPX P edotaccent -30\nKPX P egrave -30\nKPX P emacron -30\nKPX P eogonek -30\nKPX P o -40\nKPX P oacute -40\nKPX P ocircumflex -40\nKPX P odieresis -40\nKPX P ograve -40\nKPX P ohungarumlaut -40\nKPX P omacron -40\nKPX P oslash -40\nKPX P otilde -40\nKPX P period -120\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX Q comma 20\nKPX Q period 20\nKPX R O -20\nKPX R Oacute -20\nKPX R Ocircumflex -20\nKPX R Odieresis -20\nKPX R Ograve -20\nKPX R Ohungarumlaut -20\nKPX R Omacron -20\nKPX R Oslash -20\nKPX R Otilde -20\nKPX R T -20\nKPX R Tcaron -20\nKPX R Tcommaaccent -20\nKPX R U -20\nKPX R Uacute -20\nKPX R Ucircumflex -20\nKPX R Udieresis -20\nKPX R Ugrave -20\nKPX R Uhungarumlaut -20\nKPX R Umacron -20\nKPX R Uogonek -20\nKPX R Uring -20\nKPX R V -50\nKPX R W -40\nKPX R Y -50\nKPX R Yacute -50\nKPX R Ydieresis -50\nKPX Racute O -20\nKPX Racute Oacute -20\nKPX Racute Ocircumflex -20\nKPX Racute Odieresis -20\nKPX Racute Ograve -20\nKPX Racute Ohungarumlaut -20\nKPX Racute Omacron -20\nKPX Racute Oslash -20\nKPX Racute Otilde -20\nKPX Racute T -20\nKPX Racute Tcaron -20\nKPX Racute Tcommaaccent -20\nKPX Racute U -20\nKPX Racute Uacute -20\nKPX Racute Ucircumflex -20\nKPX Racute Udieresis -20\nKPX Racute Ugrave -20\nKPX Racute Uhungarumlaut -20\nKPX Racute Umacron -20\nKPX Racute Uogonek -20\nKPX Racute Uring -20\nKPX Racute V -50\nKPX Racute W -40\nKPX Racute Y -50\nKPX Racute Yacute -50\nKPX Racute Ydieresis -50\nKPX Rcaron O -20\nKPX Rcaron Oacute -20\nKPX Rcaron Ocircumflex -20\nKPX Rcaron Odieresis -20\nKPX Rcaron Ograve -20\nKPX Rcaron Ohungarumlaut -20\nKPX Rcaron Omacron -20\nKPX Rcaron Oslash -20\nKPX Rcaron Otilde -20\nKPX Rcaron T -20\nKPX Rcaron Tcaron -20\nKPX Rcaron Tcommaaccent -20\nKPX Rcaron U -20\nKPX Rcaron Uacute -20\nKPX Rcaron Ucircumflex -20\nKPX Rcaron Udieresis -20\nKPX Rcaron Ugrave -20\nKPX Rcaron Uhungarumlaut -20\nKPX Rcaron Umacron -20\nKPX Rcaron Uogonek -20\nKPX Rcaron Uring -20\nKPX Rcaron V -50\nKPX Rcaron W -40\nKPX Rcaron Y -50\nKPX Rcaron Yacute -50\nKPX Rcaron Ydieresis -50\nKPX Rcommaaccent O -20\nKPX Rcommaaccent Oacute -20\nKPX Rcommaaccent Ocircumflex -20\nKPX Rcommaaccent Odieresis -20\nKPX Rcommaaccent Ograve -20\nKPX Rcommaaccent Ohungarumlaut -20\nKPX Rcommaaccent Omacron -20\nKPX Rcommaaccent Oslash -20\nKPX Rcommaaccent Otilde -20\nKPX Rcommaaccent T -20\nKPX Rcommaaccent Tcaron -20\nKPX Rcommaaccent Tcommaaccent -20\nKPX Rcommaaccent U -20\nKPX Rcommaaccent Uacute -20\nKPX Rcommaaccent Ucircumflex -20\nKPX Rcommaaccent Udieresis -20\nKPX Rcommaaccent Ugrave -20\nKPX Rcommaaccent Uhungarumlaut -20\nKPX Rcommaaccent Umacron -20\nKPX Rcommaaccent Uogonek -20\nKPX Rcommaaccent Uring -20\nKPX Rcommaaccent V -50\nKPX Rcommaaccent W -40\nKPX Rcommaaccent Y -50\nKPX Rcommaaccent Yacute -50\nKPX Rcommaaccent Ydieresis -50\nKPX T A -90\nKPX T Aacute -90\nKPX T Abreve -90\nKPX T Acircumflex -90\nKPX T Adieresis -90\nKPX T Agrave -90\nKPX T Amacron -90\nKPX T Aogonek -90\nKPX T Aring -90\nKPX T Atilde -90\nKPX T O -40\nKPX T Oacute -40\nKPX T Ocircumflex -40\nKPX T Odieresis -40\nKPX T Ograve -40\nKPX T Ohungarumlaut -40\nKPX T Omacron -40\nKPX T Oslash -40\nKPX T Otilde -40\nKPX T a -80\nKPX T aacute -80\nKPX T abreve -80\nKPX T acircumflex -80\nKPX T adieresis -80\nKPX T agrave -80\nKPX T amacron -80\nKPX T aogonek -80\nKPX T aring -80\nKPX T atilde -80\nKPX T colon -40\nKPX T comma -80\nKPX T e -60\nKPX T eacute -60\nKPX T ecaron -60\nKPX T ecircumflex -60\nKPX T edieresis -60\nKPX T edotaccent -60\nKPX T egrave -60\nKPX T emacron -60\nKPX T eogonek -60\nKPX T hyphen -120\nKPX T o -80\nKPX T oacute -80\nKPX T ocircumflex -80\nKPX T odieresis -80\nKPX T ograve -80\nKPX T ohungarumlaut -80\nKPX T omacron -80\nKPX T oslash -80\nKPX T otilde -80\nKPX T period -80\nKPX T r -80\nKPX T racute -80\nKPX T rcommaaccent -80\nKPX T semicolon -40\nKPX T u -90\nKPX T uacute -90\nKPX T ucircumflex -90\nKPX T udieresis -90\nKPX T ugrave -90\nKPX T uhungarumlaut -90\nKPX T umacron -90\nKPX T uogonek -90\nKPX T uring -90\nKPX T w -60\nKPX T y -60\nKPX T yacute -60\nKPX T ydieresis -60\nKPX Tcaron A -90\nKPX Tcaron Aacute -90\nKPX Tcaron Abreve -90\nKPX Tcaron Acircumflex -90\nKPX Tcaron Adieresis -90\nKPX Tcaron Agrave -90\nKPX Tcaron Amacron -90\nKPX Tcaron Aogonek -90\nKPX Tcaron Aring -90\nKPX Tcaron Atilde -90\nKPX Tcaron O -40\nKPX Tcaron Oacute -40\nKPX Tcaron Ocircumflex -40\nKPX Tcaron Odieresis -40\nKPX Tcaron Ograve -40\nKPX Tcaron Ohungarumlaut -40\nKPX Tcaron Omacron -40\nKPX Tcaron Oslash -40\nKPX Tcaron Otilde -40\nKPX Tcaron a -80\nKPX Tcaron aacute -80\nKPX Tcaron abreve -80\nKPX Tcaron acircumflex -80\nKPX Tcaron adieresis -80\nKPX Tcaron agrave -80\nKPX Tcaron amacron -80\nKPX Tcaron aogonek -80\nKPX Tcaron aring -80\nKPX Tcaron atilde -80\nKPX Tcaron colon -40\nKPX Tcaron comma -80\nKPX Tcaron e -60\nKPX Tcaron eacute -60\nKPX Tcaron ecaron -60\nKPX Tcaron ecircumflex -60\nKPX Tcaron edieresis -60\nKPX Tcaron edotaccent -60\nKPX Tcaron egrave -60\nKPX Tcaron emacron -60\nKPX Tcaron eogonek -60\nKPX Tcaron hyphen -120\nKPX Tcaron o -80\nKPX Tcaron oacute -80\nKPX Tcaron ocircumflex -80\nKPX Tcaron odieresis -80\nKPX Tcaron ograve -80\nKPX Tcaron ohungarumlaut -80\nKPX Tcaron omacron -80\nKPX Tcaron oslash -80\nKPX Tcaron otilde -80\nKPX Tcaron period -80\nKPX Tcaron r -80\nKPX Tcaron racute -80\nKPX Tcaron rcommaaccent -80\nKPX Tcaron semicolon -40\nKPX Tcaron u -90\nKPX Tcaron uacute -90\nKPX Tcaron ucircumflex -90\nKPX Tcaron udieresis -90\nKPX Tcaron ugrave -90\nKPX Tcaron uhungarumlaut -90\nKPX Tcaron umacron -90\nKPX Tcaron uogonek -90\nKPX Tcaron uring -90\nKPX Tcaron w -60\nKPX Tcaron y -60\nKPX Tcaron yacute -60\nKPX Tcaron ydieresis -60\nKPX Tcommaaccent A -90\nKPX Tcommaaccent Aacute -90\nKPX Tcommaaccent Abreve -90\nKPX Tcommaaccent Acircumflex -90\nKPX Tcommaaccent Adieresis -90\nKPX Tcommaaccent Agrave -90\nKPX Tcommaaccent Amacron -90\nKPX Tcommaaccent Aogonek -90\nKPX Tcommaaccent Aring -90\nKPX Tcommaaccent Atilde -90\nKPX Tcommaaccent O -40\nKPX Tcommaaccent Oacute -40\nKPX Tcommaaccent Ocircumflex -40\nKPX Tcommaaccent Odieresis -40\nKPX Tcommaaccent Ograve -40\nKPX Tcommaaccent Ohungarumlaut -40\nKPX Tcommaaccent Omacron -40\nKPX Tcommaaccent Oslash -40\nKPX Tcommaaccent Otilde -40\nKPX Tcommaaccent a -80\nKPX Tcommaaccent aacute -80\nKPX Tcommaaccent abreve -80\nKPX Tcommaaccent acircumflex -80\nKPX Tcommaaccent adieresis -80\nKPX Tcommaaccent agrave -80\nKPX Tcommaaccent amacron -80\nKPX Tcommaaccent aogonek -80\nKPX Tcommaaccent aring -80\nKPX Tcommaaccent atilde -80\nKPX Tcommaaccent colon -40\nKPX Tcommaaccent comma -80\nKPX Tcommaaccent e -60\nKPX Tcommaaccent eacute -60\nKPX Tcommaaccent ecaron -60\nKPX Tcommaaccent ecircumflex -60\nKPX Tcommaaccent edieresis -60\nKPX Tcommaaccent edotaccent -60\nKPX Tcommaaccent egrave -60\nKPX Tcommaaccent emacron -60\nKPX Tcommaaccent eogonek -60\nKPX Tcommaaccent hyphen -120\nKPX Tcommaaccent o -80\nKPX Tcommaaccent oacute -80\nKPX Tcommaaccent ocircumflex -80\nKPX Tcommaaccent odieresis -80\nKPX Tcommaaccent ograve -80\nKPX Tcommaaccent ohungarumlaut -80\nKPX Tcommaaccent omacron -80\nKPX Tcommaaccent oslash -80\nKPX Tcommaaccent otilde -80\nKPX Tcommaaccent period -80\nKPX Tcommaaccent r -80\nKPX Tcommaaccent racute -80\nKPX Tcommaaccent rcommaaccent -80\nKPX Tcommaaccent semicolon -40\nKPX Tcommaaccent u -90\nKPX Tcommaaccent uacute -90\nKPX Tcommaaccent ucircumflex -90\nKPX Tcommaaccent udieresis -90\nKPX Tcommaaccent ugrave -90\nKPX Tcommaaccent uhungarumlaut -90\nKPX Tcommaaccent umacron -90\nKPX Tcommaaccent uogonek -90\nKPX Tcommaaccent uring -90\nKPX Tcommaaccent w -60\nKPX Tcommaaccent y -60\nKPX Tcommaaccent yacute -60\nKPX Tcommaaccent ydieresis -60\nKPX U A -50\nKPX U Aacute -50\nKPX U Abreve -50\nKPX U Acircumflex -50\nKPX U Adieresis -50\nKPX U Agrave -50\nKPX U Amacron -50\nKPX U Aogonek -50\nKPX U Aring -50\nKPX U Atilde -50\nKPX U comma -30\nKPX U period -30\nKPX Uacute A -50\nKPX Uacute Aacute -50\nKPX Uacute Abreve -50\nKPX Uacute Acircumflex -50\nKPX Uacute Adieresis -50\nKPX Uacute Agrave -50\nKPX Uacute Amacron -50\nKPX Uacute Aogonek -50\nKPX Uacute Aring -50\nKPX Uacute Atilde -50\nKPX Uacute comma -30\nKPX Uacute period -30\nKPX Ucircumflex A -50\nKPX Ucircumflex Aacute -50\nKPX Ucircumflex Abreve -50\nKPX Ucircumflex Acircumflex -50\nKPX Ucircumflex Adieresis -50\nKPX Ucircumflex Agrave -50\nKPX Ucircumflex Amacron -50\nKPX Ucircumflex Aogonek -50\nKPX Ucircumflex Aring -50\nKPX Ucircumflex Atilde -50\nKPX Ucircumflex comma -30\nKPX Ucircumflex period -30\nKPX Udieresis A -50\nKPX Udieresis Aacute -50\nKPX Udieresis Abreve -50\nKPX Udieresis Acircumflex -50\nKPX Udieresis Adieresis -50\nKPX Udieresis Agrave -50\nKPX Udieresis Amacron -50\nKPX Udieresis Aogonek -50\nKPX Udieresis Aring -50\nKPX Udieresis Atilde -50\nKPX Udieresis comma -30\nKPX Udieresis period -30\nKPX Ugrave A -50\nKPX Ugrave Aacute -50\nKPX Ugrave Abreve -50\nKPX Ugrave Acircumflex -50\nKPX Ugrave Adieresis -50\nKPX Ugrave Agrave -50\nKPX Ugrave Amacron -50\nKPX Ugrave Aogonek -50\nKPX Ugrave Aring -50\nKPX Ugrave Atilde -50\nKPX Ugrave comma -30\nKPX Ugrave period -30\nKPX Uhungarumlaut A -50\nKPX Uhungarumlaut Aacute -50\nKPX Uhungarumlaut Abreve -50\nKPX Uhungarumlaut Acircumflex -50\nKPX Uhungarumlaut Adieresis -50\nKPX Uhungarumlaut Agrave -50\nKPX Uhungarumlaut Amacron -50\nKPX Uhungarumlaut Aogonek -50\nKPX Uhungarumlaut Aring -50\nKPX Uhungarumlaut Atilde -50\nKPX Uhungarumlaut comma -30\nKPX Uhungarumlaut period -30\nKPX Umacron A -50\nKPX Umacron Aacute -50\nKPX Umacron Abreve -50\nKPX Umacron Acircumflex -50\nKPX Umacron Adieresis -50\nKPX Umacron Agrave -50\nKPX Umacron Amacron -50\nKPX Umacron Aogonek -50\nKPX Umacron Aring -50\nKPX Umacron Atilde -50\nKPX Umacron comma -30\nKPX Umacron period -30\nKPX Uogonek A -50\nKPX Uogonek Aacute -50\nKPX Uogonek Abreve -50\nKPX Uogonek Acircumflex -50\nKPX Uogonek Adieresis -50\nKPX Uogonek Agrave -50\nKPX Uogonek Amacron -50\nKPX Uogonek Aogonek -50\nKPX Uogonek Aring -50\nKPX Uogonek Atilde -50\nKPX Uogonek comma -30\nKPX Uogonek period -30\nKPX Uring A -50\nKPX Uring Aacute -50\nKPX Uring Abreve -50\nKPX Uring Acircumflex -50\nKPX Uring Adieresis -50\nKPX Uring Agrave -50\nKPX Uring Amacron -50\nKPX Uring Aogonek -50\nKPX Uring Aring -50\nKPX Uring Atilde -50\nKPX Uring comma -30\nKPX Uring period -30\nKPX V A -80\nKPX V Aacute -80\nKPX V Abreve -80\nKPX V Acircumflex -80\nKPX V Adieresis -80\nKPX V Agrave -80\nKPX V Amacron -80\nKPX V Aogonek -80\nKPX V Aring -80\nKPX V Atilde -80\nKPX V G -50\nKPX V Gbreve -50\nKPX V Gcommaaccent -50\nKPX V O -50\nKPX V Oacute -50\nKPX V Ocircumflex -50\nKPX V Odieresis -50\nKPX V Ograve -50\nKPX V Ohungarumlaut -50\nKPX V Omacron -50\nKPX V Oslash -50\nKPX V Otilde -50\nKPX V a -60\nKPX V aacute -60\nKPX V abreve -60\nKPX V acircumflex -60\nKPX V adieresis -60\nKPX V agrave -60\nKPX V amacron -60\nKPX V aogonek -60\nKPX V aring -60\nKPX V atilde -60\nKPX V colon -40\nKPX V comma -120\nKPX V e -50\nKPX V eacute -50\nKPX V ecaron -50\nKPX V ecircumflex -50\nKPX V edieresis -50\nKPX V edotaccent -50\nKPX V egrave -50\nKPX V emacron -50\nKPX V eogonek -50\nKPX V hyphen -80\nKPX V o -90\nKPX V oacute -90\nKPX V ocircumflex -90\nKPX V odieresis -90\nKPX V ograve -90\nKPX V ohungarumlaut -90\nKPX V omacron -90\nKPX V oslash -90\nKPX V otilde -90\nKPX V period -120\nKPX V semicolon -40\nKPX V u -60\nKPX V uacute -60\nKPX V ucircumflex -60\nKPX V udieresis -60\nKPX V ugrave -60\nKPX V uhungarumlaut -60\nKPX V umacron -60\nKPX V uogonek -60\nKPX V uring -60\nKPX W A -60\nKPX W Aacute -60\nKPX W Abreve -60\nKPX W Acircumflex -60\nKPX W Adieresis -60\nKPX W Agrave -60\nKPX W Amacron -60\nKPX W Aogonek -60\nKPX W Aring -60\nKPX W Atilde -60\nKPX W O -20\nKPX W Oacute -20\nKPX W Ocircumflex -20\nKPX W Odieresis -20\nKPX W Ograve -20\nKPX W Ohungarumlaut -20\nKPX W Omacron -20\nKPX W Oslash -20\nKPX W Otilde -20\nKPX W a -40\nKPX W aacute -40\nKPX W abreve -40\nKPX W acircumflex -40\nKPX W adieresis -40\nKPX W agrave -40\nKPX W amacron -40\nKPX W aogonek -40\nKPX W aring -40\nKPX W atilde -40\nKPX W colon -10\nKPX W comma -80\nKPX W e -35\nKPX W eacute -35\nKPX W ecaron -35\nKPX W ecircumflex -35\nKPX W edieresis -35\nKPX W edotaccent -35\nKPX W egrave -35\nKPX W emacron -35\nKPX W eogonek -35\nKPX W hyphen -40\nKPX W o -60\nKPX W oacute -60\nKPX W ocircumflex -60\nKPX W odieresis -60\nKPX W ograve -60\nKPX W ohungarumlaut -60\nKPX W omacron -60\nKPX W oslash -60\nKPX W otilde -60\nKPX W period -80\nKPX W semicolon -10\nKPX W u -45\nKPX W uacute -45\nKPX W ucircumflex -45\nKPX W udieresis -45\nKPX W ugrave -45\nKPX W uhungarumlaut -45\nKPX W umacron -45\nKPX W uogonek -45\nKPX W uring -45\nKPX W y -20\nKPX W yacute -20\nKPX W ydieresis -20\nKPX Y A -110\nKPX Y Aacute -110\nKPX Y Abreve -110\nKPX Y Acircumflex -110\nKPX Y Adieresis -110\nKPX Y Agrave -110\nKPX Y Amacron -110\nKPX Y Aogonek -110\nKPX Y Aring -110\nKPX Y Atilde -110\nKPX Y O -70\nKPX Y Oacute -70\nKPX Y Ocircumflex -70\nKPX Y Odieresis -70\nKPX Y Ograve -70\nKPX Y Ohungarumlaut -70\nKPX Y Omacron -70\nKPX Y Oslash -70\nKPX Y Otilde -70\nKPX Y a -90\nKPX Y aacute -90\nKPX Y abreve -90\nKPX Y acircumflex -90\nKPX Y adieresis -90\nKPX Y agrave -90\nKPX Y amacron -90\nKPX Y aogonek -90\nKPX Y aring -90\nKPX Y atilde -90\nKPX Y colon -50\nKPX Y comma -100\nKPX Y e -80\nKPX Y eacute -80\nKPX Y ecaron -80\nKPX Y ecircumflex -80\nKPX Y edieresis -80\nKPX Y edotaccent -80\nKPX Y egrave -80\nKPX Y emacron -80\nKPX Y eogonek -80\nKPX Y o -100\nKPX Y oacute -100\nKPX Y ocircumflex -100\nKPX Y odieresis -100\nKPX Y ograve -100\nKPX Y ohungarumlaut -100\nKPX Y omacron -100\nKPX Y oslash -100\nKPX Y otilde -100\nKPX Y period -100\nKPX Y semicolon -50\nKPX Y u -100\nKPX Y uacute -100\nKPX Y ucircumflex -100\nKPX Y udieresis -100\nKPX Y ugrave -100\nKPX Y uhungarumlaut -100\nKPX Y umacron -100\nKPX Y uogonek -100\nKPX Y uring -100\nKPX Yacute A -110\nKPX Yacute Aacute -110\nKPX Yacute Abreve -110\nKPX Yacute Acircumflex -110\nKPX Yacute Adieresis -110\nKPX Yacute Agrave -110\nKPX Yacute Amacron -110\nKPX Yacute Aogonek -110\nKPX Yacute Aring -110\nKPX Yacute Atilde -110\nKPX Yacute O -70\nKPX Yacute Oacute -70\nKPX Yacute Ocircumflex -70\nKPX Yacute Odieresis -70\nKPX Yacute Ograve -70\nKPX Yacute Ohungarumlaut -70\nKPX Yacute Omacron -70\nKPX Yacute Oslash -70\nKPX Yacute Otilde -70\nKPX Yacute a -90\nKPX Yacute aacute -90\nKPX Yacute abreve -90\nKPX Yacute acircumflex -90\nKPX Yacute adieresis -90\nKPX Yacute agrave -90\nKPX Yacute amacron -90\nKPX Yacute aogonek -90\nKPX Yacute aring -90\nKPX Yacute atilde -90\nKPX Yacute colon -50\nKPX Yacute comma -100\nKPX Yacute e -80\nKPX Yacute eacute -80\nKPX Yacute ecaron -80\nKPX Yacute ecircumflex -80\nKPX Yacute edieresis -80\nKPX Yacute edotaccent -80\nKPX Yacute egrave -80\nKPX Yacute emacron -80\nKPX Yacute eogonek -80\nKPX Yacute o -100\nKPX Yacute oacute -100\nKPX Yacute ocircumflex -100\nKPX Yacute odieresis -100\nKPX Yacute ograve -100\nKPX Yacute ohungarumlaut -100\nKPX Yacute omacron -100\nKPX Yacute oslash -100\nKPX Yacute otilde -100\nKPX Yacute period -100\nKPX Yacute semicolon -50\nKPX Yacute u -100\nKPX Yacute uacute -100\nKPX Yacute ucircumflex -100\nKPX Yacute udieresis -100\nKPX Yacute ugrave -100\nKPX Yacute uhungarumlaut -100\nKPX Yacute umacron -100\nKPX Yacute uogonek -100\nKPX Yacute uring -100\nKPX Ydieresis A -110\nKPX Ydieresis Aacute -110\nKPX Ydieresis Abreve -110\nKPX Ydieresis Acircumflex -110\nKPX Ydieresis Adieresis -110\nKPX Ydieresis Agrave -110\nKPX Ydieresis Amacron -110\nKPX Ydieresis Aogonek -110\nKPX Ydieresis Aring -110\nKPX Ydieresis Atilde -110\nKPX Ydieresis O -70\nKPX Ydieresis Oacute -70\nKPX Ydieresis Ocircumflex -70\nKPX Ydieresis Odieresis -70\nKPX Ydieresis Ograve -70\nKPX Ydieresis Ohungarumlaut -70\nKPX Ydieresis Omacron -70\nKPX Ydieresis Oslash -70\nKPX Ydieresis Otilde -70\nKPX Ydieresis a -90\nKPX Ydieresis aacute -90\nKPX Ydieresis abreve -90\nKPX Ydieresis acircumflex -90\nKPX Ydieresis adieresis -90\nKPX Ydieresis agrave -90\nKPX Ydieresis amacron -90\nKPX Ydieresis aogonek -90\nKPX Ydieresis aring -90\nKPX Ydieresis atilde -90\nKPX Ydieresis colon -50\nKPX Ydieresis comma -100\nKPX Ydieresis e -80\nKPX Ydieresis eacute -80\nKPX Ydieresis ecaron -80\nKPX Ydieresis ecircumflex -80\nKPX Ydieresis edieresis -80\nKPX Ydieresis edotaccent -80\nKPX Ydieresis egrave -80\nKPX Ydieresis emacron -80\nKPX Ydieresis eogonek -80\nKPX Ydieresis o -100\nKPX Ydieresis oacute -100\nKPX Ydieresis ocircumflex -100\nKPX Ydieresis odieresis -100\nKPX Ydieresis ograve -100\nKPX Ydieresis ohungarumlaut -100\nKPX Ydieresis omacron -100\nKPX Ydieresis oslash -100\nKPX Ydieresis otilde -100\nKPX Ydieresis period -100\nKPX Ydieresis semicolon -50\nKPX Ydieresis u -100\nKPX Ydieresis uacute -100\nKPX Ydieresis ucircumflex -100\nKPX Ydieresis udieresis -100\nKPX Ydieresis ugrave -100\nKPX Ydieresis uhungarumlaut -100\nKPX Ydieresis umacron -100\nKPX Ydieresis uogonek -100\nKPX Ydieresis uring -100\nKPX a g -10\nKPX a gbreve -10\nKPX a gcommaaccent -10\nKPX a v -15\nKPX a w -15\nKPX a y -20\nKPX a yacute -20\nKPX a ydieresis -20\nKPX aacute g -10\nKPX aacute gbreve -10\nKPX aacute gcommaaccent -10\nKPX aacute v -15\nKPX aacute w -15\nKPX aacute y -20\nKPX aacute yacute -20\nKPX aacute ydieresis -20\nKPX abreve g -10\nKPX abreve gbreve -10\nKPX abreve gcommaaccent -10\nKPX abreve v -15\nKPX abreve w -15\nKPX abreve y -20\nKPX abreve yacute -20\nKPX abreve ydieresis -20\nKPX acircumflex g -10\nKPX acircumflex gbreve -10\nKPX acircumflex gcommaaccent -10\nKPX acircumflex v -15\nKPX acircumflex w -15\nKPX acircumflex y -20\nKPX acircumflex yacute -20\nKPX acircumflex ydieresis -20\nKPX adieresis g -10\nKPX adieresis gbreve -10\nKPX adieresis gcommaaccent -10\nKPX adieresis v -15\nKPX adieresis w -15\nKPX adieresis y -20\nKPX adieresis yacute -20\nKPX adieresis ydieresis -20\nKPX agrave g -10\nKPX agrave gbreve -10\nKPX agrave gcommaaccent -10\nKPX agrave v -15\nKPX agrave w -15\nKPX agrave y -20\nKPX agrave yacute -20\nKPX agrave ydieresis -20\nKPX amacron g -10\nKPX amacron gbreve -10\nKPX amacron gcommaaccent -10\nKPX amacron v -15\nKPX amacron w -15\nKPX amacron y -20\nKPX amacron yacute -20\nKPX amacron ydieresis -20\nKPX aogonek g -10\nKPX aogonek gbreve -10\nKPX aogonek gcommaaccent -10\nKPX aogonek v -15\nKPX aogonek w -15\nKPX aogonek y -20\nKPX aogonek yacute -20\nKPX aogonek ydieresis -20\nKPX aring g -10\nKPX aring gbreve -10\nKPX aring gcommaaccent -10\nKPX aring v -15\nKPX aring w -15\nKPX aring y -20\nKPX aring yacute -20\nKPX aring ydieresis -20\nKPX atilde g -10\nKPX atilde gbreve -10\nKPX atilde gcommaaccent -10\nKPX atilde v -15\nKPX atilde w -15\nKPX atilde y -20\nKPX atilde yacute -20\nKPX atilde ydieresis -20\nKPX b l -10\nKPX b lacute -10\nKPX b lcommaaccent -10\nKPX b lslash -10\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX b v -20\nKPX b y -20\nKPX b yacute -20\nKPX b ydieresis -20\nKPX c h -10\nKPX c k -20\nKPX c kcommaaccent -20\nKPX c l -20\nKPX c lacute -20\nKPX c lcommaaccent -20\nKPX c lslash -20\nKPX c y -10\nKPX c yacute -10\nKPX c ydieresis -10\nKPX cacute h -10\nKPX cacute k -20\nKPX cacute kcommaaccent -20\nKPX cacute l -20\nKPX cacute lacute -20\nKPX cacute lcommaaccent -20\nKPX cacute lslash -20\nKPX cacute y -10\nKPX cacute yacute -10\nKPX cacute ydieresis -10\nKPX ccaron h -10\nKPX ccaron k -20\nKPX ccaron kcommaaccent -20\nKPX ccaron l -20\nKPX ccaron lacute -20\nKPX ccaron lcommaaccent -20\nKPX ccaron lslash -20\nKPX ccaron y -10\nKPX ccaron yacute -10\nKPX ccaron ydieresis -10\nKPX ccedilla h -10\nKPX ccedilla k -20\nKPX ccedilla kcommaaccent -20\nKPX ccedilla l -20\nKPX ccedilla lacute -20\nKPX ccedilla lcommaaccent -20\nKPX ccedilla lslash -20\nKPX ccedilla y -10\nKPX ccedilla yacute -10\nKPX ccedilla ydieresis -10\nKPX colon space -40\nKPX comma quotedblright -120\nKPX comma quoteright -120\nKPX comma space -40\nKPX d d -10\nKPX d dcroat -10\nKPX d v -15\nKPX d w -15\nKPX d y -15\nKPX d yacute -15\nKPX d ydieresis -15\nKPX dcroat d -10\nKPX dcroat dcroat -10\nKPX dcroat v -15\nKPX dcroat w -15\nKPX dcroat y -15\nKPX dcroat yacute -15\nKPX dcroat ydieresis -15\nKPX e comma 10\nKPX e period 20\nKPX e v -15\nKPX e w -15\nKPX e x -15\nKPX e y -15\nKPX e yacute -15\nKPX e ydieresis -15\nKPX eacute comma 10\nKPX eacute period 20\nKPX eacute v -15\nKPX eacute w -15\nKPX eacute x -15\nKPX eacute y -15\nKPX eacute yacute -15\nKPX eacute ydieresis -15\nKPX ecaron comma 10\nKPX ecaron period 20\nKPX ecaron v -15\nKPX ecaron w -15\nKPX ecaron x -15\nKPX ecaron y -15\nKPX ecaron yacute -15\nKPX ecaron ydieresis -15\nKPX ecircumflex comma 10\nKPX ecircumflex period 20\nKPX ecircumflex v -15\nKPX ecircumflex w -15\nKPX ecircumflex x -15\nKPX ecircumflex y -15\nKPX ecircumflex yacute -15\nKPX ecircumflex ydieresis -15\nKPX edieresis comma 10\nKPX edieresis period 20\nKPX edieresis v -15\nKPX edieresis w -15\nKPX edieresis x -15\nKPX edieresis y -15\nKPX edieresis yacute -15\nKPX edieresis ydieresis -15\nKPX edotaccent comma 10\nKPX edotaccent period 20\nKPX edotaccent v -15\nKPX edotaccent w -15\nKPX edotaccent x -15\nKPX edotaccent y -15\nKPX edotaccent yacute -15\nKPX edotaccent ydieresis -15\nKPX egrave comma 10\nKPX egrave period 20\nKPX egrave v -15\nKPX egrave w -15\nKPX egrave x -15\nKPX egrave y -15\nKPX egrave yacute -15\nKPX egrave ydieresis -15\nKPX emacron comma 10\nKPX emacron period 20\nKPX emacron v -15\nKPX emacron w -15\nKPX emacron x -15\nKPX emacron y -15\nKPX emacron yacute -15\nKPX emacron ydieresis -15\nKPX eogonek comma 10\nKPX eogonek period 20\nKPX eogonek v -15\nKPX eogonek w -15\nKPX eogonek x -15\nKPX eogonek y -15\nKPX eogonek yacute -15\nKPX eogonek ydieresis -15\nKPX f comma -10\nKPX f e -10\nKPX f eacute -10\nKPX f ecaron -10\nKPX f ecircumflex -10\nKPX f edieresis -10\nKPX f edotaccent -10\nKPX f egrave -10\nKPX f emacron -10\nKPX f eogonek -10\nKPX f o -20\nKPX f oacute -20\nKPX f ocircumflex -20\nKPX f odieresis -20\nKPX f ograve -20\nKPX f ohungarumlaut -20\nKPX f omacron -20\nKPX f oslash -20\nKPX f otilde -20\nKPX f period -10\nKPX f quotedblright 30\nKPX f quoteright 30\nKPX g e 10\nKPX g eacute 10\nKPX g ecaron 10\nKPX g ecircumflex 10\nKPX g edieresis 10\nKPX g edotaccent 10\nKPX g egrave 10\nKPX g emacron 10\nKPX g eogonek 10\nKPX g g -10\nKPX g gbreve -10\nKPX g gcommaaccent -10\nKPX gbreve e 10\nKPX gbreve eacute 10\nKPX gbreve ecaron 10\nKPX gbreve ecircumflex 10\nKPX gbreve edieresis 10\nKPX gbreve edotaccent 10\nKPX gbreve egrave 10\nKPX gbreve emacron 10\nKPX gbreve eogonek 10\nKPX gbreve g -10\nKPX gbreve gbreve -10\nKPX gbreve gcommaaccent -10\nKPX gcommaaccent e 10\nKPX gcommaaccent eacute 10\nKPX gcommaaccent ecaron 10\nKPX gcommaaccent ecircumflex 10\nKPX gcommaaccent edieresis 10\nKPX gcommaaccent edotaccent 10\nKPX gcommaaccent egrave 10\nKPX gcommaaccent emacron 10\nKPX gcommaaccent eogonek 10\nKPX gcommaaccent g -10\nKPX gcommaaccent gbreve -10\nKPX gcommaaccent gcommaaccent -10\nKPX h y -20\nKPX h yacute -20\nKPX h ydieresis -20\nKPX k o -15\nKPX k oacute -15\nKPX k ocircumflex -15\nKPX k odieresis -15\nKPX k ograve -15\nKPX k ohungarumlaut -15\nKPX k omacron -15\nKPX k oslash -15\nKPX k otilde -15\nKPX kcommaaccent o -15\nKPX kcommaaccent oacute -15\nKPX kcommaaccent ocircumflex -15\nKPX kcommaaccent odieresis -15\nKPX kcommaaccent ograve -15\nKPX kcommaaccent ohungarumlaut -15\nKPX kcommaaccent omacron -15\nKPX kcommaaccent oslash -15\nKPX kcommaaccent otilde -15\nKPX l w -15\nKPX l y -15\nKPX l yacute -15\nKPX l ydieresis -15\nKPX lacute w -15\nKPX lacute y -15\nKPX lacute yacute -15\nKPX lacute ydieresis -15\nKPX lcommaaccent w -15\nKPX lcommaaccent y -15\nKPX lcommaaccent yacute -15\nKPX lcommaaccent ydieresis -15\nKPX lslash w -15\nKPX lslash y -15\nKPX lslash yacute -15\nKPX lslash ydieresis -15\nKPX m u -20\nKPX m uacute -20\nKPX m ucircumflex -20\nKPX m udieresis -20\nKPX m ugrave -20\nKPX m uhungarumlaut -20\nKPX m umacron -20\nKPX m uogonek -20\nKPX m uring -20\nKPX m y -30\nKPX m yacute -30\nKPX m ydieresis -30\nKPX n u -10\nKPX n uacute -10\nKPX n ucircumflex -10\nKPX n udieresis -10\nKPX n ugrave -10\nKPX n uhungarumlaut -10\nKPX n umacron -10\nKPX n uogonek -10\nKPX n uring -10\nKPX n v -40\nKPX n y -20\nKPX n yacute -20\nKPX n ydieresis -20\nKPX nacute u -10\nKPX nacute uacute -10\nKPX nacute ucircumflex -10\nKPX nacute udieresis -10\nKPX nacute ugrave -10\nKPX nacute uhungarumlaut -10\nKPX nacute umacron -10\nKPX nacute uogonek -10\nKPX nacute uring -10\nKPX nacute v -40\nKPX nacute y -20\nKPX nacute yacute -20\nKPX nacute ydieresis -20\nKPX ncaron u -10\nKPX ncaron uacute -10\nKPX ncaron ucircumflex -10\nKPX ncaron udieresis -10\nKPX ncaron ugrave -10\nKPX ncaron uhungarumlaut -10\nKPX ncaron umacron -10\nKPX ncaron uogonek -10\nKPX ncaron uring -10\nKPX ncaron v -40\nKPX ncaron y -20\nKPX ncaron yacute -20\nKPX ncaron ydieresis -20\nKPX ncommaaccent u -10\nKPX ncommaaccent uacute -10\nKPX ncommaaccent ucircumflex -10\nKPX ncommaaccent udieresis -10\nKPX ncommaaccent ugrave -10\nKPX ncommaaccent uhungarumlaut -10\nKPX ncommaaccent umacron -10\nKPX ncommaaccent uogonek -10\nKPX ncommaaccent uring -10\nKPX ncommaaccent v -40\nKPX ncommaaccent y -20\nKPX ncommaaccent yacute -20\nKPX ncommaaccent ydieresis -20\nKPX ntilde u -10\nKPX ntilde uacute -10\nKPX ntilde ucircumflex -10\nKPX ntilde udieresis -10\nKPX ntilde ugrave -10\nKPX ntilde uhungarumlaut -10\nKPX ntilde umacron -10\nKPX ntilde uogonek -10\nKPX ntilde uring -10\nKPX ntilde v -40\nKPX ntilde y -20\nKPX ntilde yacute -20\nKPX ntilde ydieresis -20\nKPX o v -20\nKPX o w -15\nKPX o x -30\nKPX o y -20\nKPX o yacute -20\nKPX o ydieresis -20\nKPX oacute v -20\nKPX oacute w -15\nKPX oacute x -30\nKPX oacute y -20\nKPX oacute yacute -20\nKPX oacute ydieresis -20\nKPX ocircumflex v -20\nKPX ocircumflex w -15\nKPX ocircumflex x -30\nKPX ocircumflex y -20\nKPX ocircumflex yacute -20\nKPX ocircumflex ydieresis -20\nKPX odieresis v -20\nKPX odieresis w -15\nKPX odieresis x -30\nKPX odieresis y -20\nKPX odieresis yacute -20\nKPX odieresis ydieresis -20\nKPX ograve v -20\nKPX ograve w -15\nKPX ograve x -30\nKPX ograve y -20\nKPX ograve yacute -20\nKPX ograve ydieresis -20\nKPX ohungarumlaut v -20\nKPX ohungarumlaut w -15\nKPX ohungarumlaut x -30\nKPX ohungarumlaut y -20\nKPX ohungarumlaut yacute -20\nKPX ohungarumlaut ydieresis -20\nKPX omacron v -20\nKPX omacron w -15\nKPX omacron x -30\nKPX omacron y -20\nKPX omacron yacute -20\nKPX omacron ydieresis -20\nKPX oslash v -20\nKPX oslash w -15\nKPX oslash x -30\nKPX oslash y -20\nKPX oslash yacute -20\nKPX oslash ydieresis -20\nKPX otilde v -20\nKPX otilde w -15\nKPX otilde x -30\nKPX otilde y -20\nKPX otilde yacute -20\nKPX otilde ydieresis -20\nKPX p y -15\nKPX p yacute -15\nKPX p ydieresis -15\nKPX period quotedblright -120\nKPX period quoteright -120\nKPX period space -40\nKPX quotedblright space -80\nKPX quoteleft quoteleft -46\nKPX quoteright d -80\nKPX quoteright dcroat -80\nKPX quoteright l -20\nKPX quoteright lacute -20\nKPX quoteright lcommaaccent -20\nKPX quoteright lslash -20\nKPX quoteright quoteright -46\nKPX quoteright r -40\nKPX quoteright racute -40\nKPX quoteright rcaron -40\nKPX quoteright rcommaaccent -40\nKPX quoteright s -60\nKPX quoteright sacute -60\nKPX quoteright scaron -60\nKPX quoteright scedilla -60\nKPX quoteright scommaaccent -60\nKPX quoteright space -80\nKPX quoteright v -20\nKPX r c -20\nKPX r cacute -20\nKPX r ccaron -20\nKPX r ccedilla -20\nKPX r comma -60\nKPX r d -20\nKPX r dcroat -20\nKPX r g -15\nKPX r gbreve -15\nKPX r gcommaaccent -15\nKPX r hyphen -20\nKPX r o -20\nKPX r oacute -20\nKPX r ocircumflex -20\nKPX r odieresis -20\nKPX r ograve -20\nKPX r ohungarumlaut -20\nKPX r omacron -20\nKPX r oslash -20\nKPX r otilde -20\nKPX r period -60\nKPX r q -20\nKPX r s -15\nKPX r sacute -15\nKPX r scaron -15\nKPX r scedilla -15\nKPX r scommaaccent -15\nKPX r t 20\nKPX r tcommaaccent 20\nKPX r v 10\nKPX r y 10\nKPX r yacute 10\nKPX r ydieresis 10\nKPX racute c -20\nKPX racute cacute -20\nKPX racute ccaron -20\nKPX racute ccedilla -20\nKPX racute comma -60\nKPX racute d -20\nKPX racute dcroat -20\nKPX racute g -15\nKPX racute gbreve -15\nKPX racute gcommaaccent -15\nKPX racute hyphen -20\nKPX racute o -20\nKPX racute oacute -20\nKPX racute ocircumflex -20\nKPX racute odieresis -20\nKPX racute ograve -20\nKPX racute ohungarumlaut -20\nKPX racute omacron -20\nKPX racute oslash -20\nKPX racute otilde -20\nKPX racute period -60\nKPX racute q -20\nKPX racute s -15\nKPX racute sacute -15\nKPX racute scaron -15\nKPX racute scedilla -15\nKPX racute scommaaccent -15\nKPX racute t 20\nKPX racute tcommaaccent 20\nKPX racute v 10\nKPX racute y 10\nKPX racute yacute 10\nKPX racute ydieresis 10\nKPX rcaron c -20\nKPX rcaron cacute -20\nKPX rcaron ccaron -20\nKPX rcaron ccedilla -20\nKPX rcaron comma -60\nKPX rcaron d -20\nKPX rcaron dcroat -20\nKPX rcaron g -15\nKPX rcaron gbreve -15\nKPX rcaron gcommaaccent -15\nKPX rcaron hyphen -20\nKPX rcaron o -20\nKPX rcaron oacute -20\nKPX rcaron ocircumflex -20\nKPX rcaron odieresis -20\nKPX rcaron ograve -20\nKPX rcaron ohungarumlaut -20\nKPX rcaron omacron -20\nKPX rcaron oslash -20\nKPX rcaron otilde -20\nKPX rcaron period -60\nKPX rcaron q -20\nKPX rcaron s -15\nKPX rcaron sacute -15\nKPX rcaron scaron -15\nKPX rcaron scedilla -15\nKPX rcaron scommaaccent -15\nKPX rcaron t 20\nKPX rcaron tcommaaccent 20\nKPX rcaron v 10\nKPX rcaron y 10\nKPX rcaron yacute 10\nKPX rcaron ydieresis 10\nKPX rcommaaccent c -20\nKPX rcommaaccent cacute -20\nKPX rcommaaccent ccaron -20\nKPX rcommaaccent ccedilla -20\nKPX rcommaaccent comma -60\nKPX rcommaaccent d -20\nKPX rcommaaccent dcroat -20\nKPX rcommaaccent g -15\nKPX rcommaaccent gbreve -15\nKPX rcommaaccent gcommaaccent -15\nKPX rcommaaccent hyphen -20\nKPX rcommaaccent o -20\nKPX rcommaaccent oacute -20\nKPX rcommaaccent ocircumflex -20\nKPX rcommaaccent odieresis -20\nKPX rcommaaccent ograve -20\nKPX rcommaaccent ohungarumlaut -20\nKPX rcommaaccent omacron -20\nKPX rcommaaccent oslash -20\nKPX rcommaaccent otilde -20\nKPX rcommaaccent period -60\nKPX rcommaaccent q -20\nKPX rcommaaccent s -15\nKPX rcommaaccent sacute -15\nKPX rcommaaccent scaron -15\nKPX rcommaaccent scedilla -15\nKPX rcommaaccent scommaaccent -15\nKPX rcommaaccent t 20\nKPX rcommaaccent tcommaaccent 20\nKPX rcommaaccent v 10\nKPX rcommaaccent y 10\nKPX rcommaaccent yacute 10\nKPX rcommaaccent ydieresis 10\nKPX s w -15\nKPX sacute w -15\nKPX scaron w -15\nKPX scedilla w -15\nKPX scommaaccent w -15\nKPX semicolon space -40\nKPX space T -100\nKPX space Tcaron -100\nKPX space Tcommaaccent -100\nKPX space V -80\nKPX space W -80\nKPX space Y -120\nKPX space Yacute -120\nKPX space Ydieresis -120\nKPX space quotedblleft -80\nKPX space quoteleft -60\nKPX v a -20\nKPX v aacute -20\nKPX v abreve -20\nKPX v acircumflex -20\nKPX v adieresis -20\nKPX v agrave -20\nKPX v amacron -20\nKPX v aogonek -20\nKPX v aring -20\nKPX v atilde -20\nKPX v comma -80\nKPX v o -30\nKPX v oacute -30\nKPX v ocircumflex -30\nKPX v odieresis -30\nKPX v ograve -30\nKPX v ohungarumlaut -30\nKPX v omacron -30\nKPX v oslash -30\nKPX v otilde -30\nKPX v period -80\nKPX w comma -40\nKPX w o -20\nKPX w oacute -20\nKPX w ocircumflex -20\nKPX w odieresis -20\nKPX w ograve -20\nKPX w ohungarumlaut -20\nKPX w omacron -20\nKPX w oslash -20\nKPX w otilde -20\nKPX w period -40\nKPX x e -10\nKPX x eacute -10\nKPX x ecaron -10\nKPX x ecircumflex -10\nKPX x edieresis -10\nKPX x edotaccent -10\nKPX x egrave -10\nKPX x emacron -10\nKPX x eogonek -10\nKPX y a -30\nKPX y aacute -30\nKPX y abreve -30\nKPX y acircumflex -30\nKPX y adieresis -30\nKPX y agrave -30\nKPX y amacron -30\nKPX y aogonek -30\nKPX y aring -30\nKPX y atilde -30\nKPX y comma -80\nKPX y e -10\nKPX y eacute -10\nKPX y ecaron -10\nKPX y ecircumflex -10\nKPX y edieresis -10\nKPX y edotaccent -10\nKPX y egrave -10\nKPX y emacron -10\nKPX y eogonek -10\nKPX y o -25\nKPX y oacute -25\nKPX y ocircumflex -25\nKPX y odieresis -25\nKPX y ograve -25\nKPX y ohungarumlaut -25\nKPX y omacron -25\nKPX y oslash -25\nKPX y otilde -25\nKPX y period -80\nKPX yacute a -30\nKPX yacute aacute -30\nKPX yacute abreve -30\nKPX yacute acircumflex -30\nKPX yacute adieresis -30\nKPX yacute agrave -30\nKPX yacute amacron -30\nKPX yacute aogonek -30\nKPX yacute aring -30\nKPX yacute atilde -30\nKPX yacute comma -80\nKPX yacute e -10\nKPX yacute eacute -10\nKPX yacute ecaron -10\nKPX yacute ecircumflex -10\nKPX yacute edieresis -10\nKPX yacute edotaccent -10\nKPX yacute egrave -10\nKPX yacute emacron -10\nKPX yacute eogonek -10\nKPX yacute o -25\nKPX yacute oacute -25\nKPX yacute ocircumflex -25\nKPX yacute odieresis -25\nKPX yacute ograve -25\nKPX yacute ohungarumlaut -25\nKPX yacute omacron -25\nKPX yacute oslash -25\nKPX yacute otilde -25\nKPX yacute period -80\nKPX ydieresis a -30\nKPX ydieresis aacute -30\nKPX ydieresis abreve -30\nKPX ydieresis acircumflex -30\nKPX ydieresis adieresis -30\nKPX ydieresis agrave -30\nKPX ydieresis amacron -30\nKPX ydieresis aogonek -30\nKPX ydieresis aring -30\nKPX ydieresis atilde -30\nKPX ydieresis comma -80\nKPX ydieresis e -10\nKPX ydieresis eacute -10\nKPX ydieresis ecaron -10\nKPX ydieresis ecircumflex -10\nKPX ydieresis edieresis -10\nKPX ydieresis edotaccent -10\nKPX ydieresis egrave -10\nKPX ydieresis emacron -10\nKPX ydieresis eogonek -10\nKPX ydieresis o -25\nKPX ydieresis oacute -25\nKPX ydieresis ocircumflex -25\nKPX ydieresis odieresis -25\nKPX ydieresis ograve -25\nKPX ydieresis ohungarumlaut -25\nKPX ydieresis omacron -25\nKPX ydieresis oslash -25\nKPX ydieresis otilde -25\nKPX ydieresis period -80\nKPX z e 10\nKPX z eacute 10\nKPX z ecaron 10\nKPX z ecircumflex 10\nKPX z edieresis 10\nKPX z edotaccent 10\nKPX z egrave 10\nKPX z emacron 10\nKPX z eogonek 10\nKPX zacute e 10\nKPX zacute eacute 10\nKPX zacute ecaron 10\nKPX zacute ecircumflex 10\nKPX zacute edieresis 10\nKPX zacute edotaccent 10\nKPX zacute egrave 10\nKPX zacute emacron 10\nKPX zacute eogonek 10\nKPX zcaron e 10\nKPX zcaron eacute 10\nKPX zcaron ecaron 10\nKPX zcaron ecircumflex 10\nKPX zcaron edieresis 10\nKPX zcaron edotaccent 10\nKPX zcaron egrave 10\nKPX zcaron emacron 10\nKPX zcaron eogonek 10\nKPX zdotaccent e 10\nKPX zdotaccent eacute 10\nKPX zdotaccent ecaron 10\nKPX zdotaccent ecircumflex 10\nKPX zdotaccent edieresis 10\nKPX zdotaccent edotaccent 10\nKPX zdotaccent egrave 10\nKPX zdotaccent emacron 10\nKPX zdotaccent eogonek 10\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    'Helvetica-Oblique' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 12:44:31 1997\nComment UniqueID 43055\nComment VMusage 14960 69346\nFontName Helvetica-Oblique\nFullName Helvetica Oblique\nFamilyName Helvetica\nWeight Medium\nItalicAngle -12\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -170 -225 1116 931 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 718\nXHeight 523\nAscender 718\nDescender -207\nStdHW 76\nStdVW 88\nStartCharMetrics 315\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 278 ; N exclam ; B 90 0 340 718 ;\nC 34 ; WX 355 ; N quotedbl ; B 168 463 438 718 ;\nC 35 ; WX 556 ; N numbersign ; B 73 0 631 688 ;\nC 36 ; WX 556 ; N dollar ; B 69 -115 617 775 ;\nC 37 ; WX 889 ; N percent ; B 147 -19 889 703 ;\nC 38 ; WX 667 ; N ampersand ; B 77 -15 647 718 ;\nC 39 ; WX 222 ; N quoteright ; B 151 463 310 718 ;\nC 40 ; WX 333 ; N parenleft ; B 108 -207 454 733 ;\nC 41 ; WX 333 ; N parenright ; B -9 -207 337 733 ;\nC 42 ; WX 389 ; N asterisk ; B 165 431 475 718 ;\nC 43 ; WX 584 ; N plus ; B 85 0 606 505 ;\nC 44 ; WX 278 ; N comma ; B 56 -147 214 106 ;\nC 45 ; WX 333 ; N hyphen ; B 93 232 357 322 ;\nC 46 ; WX 278 ; N period ; B 87 0 214 106 ;\nC 47 ; WX 278 ; N slash ; B -21 -19 452 737 ;\nC 48 ; WX 556 ; N zero ; B 93 -19 608 703 ;\nC 49 ; WX 556 ; N one ; B 207 0 508 703 ;\nC 50 ; WX 556 ; N two ; B 26 0 617 703 ;\nC 51 ; WX 556 ; N three ; B 75 -19 610 703 ;\nC 52 ; WX 556 ; N four ; B 61 0 576 703 ;\nC 53 ; WX 556 ; N five ; B 68 -19 621 688 ;\nC 54 ; WX 556 ; N six ; B 91 -19 615 703 ;\nC 55 ; WX 556 ; N seven ; B 137 0 669 688 ;\nC 56 ; WX 556 ; N eight ; B 74 -19 607 703 ;\nC 57 ; WX 556 ; N nine ; B 82 -19 609 703 ;\nC 58 ; WX 278 ; N colon ; B 87 0 301 516 ;\nC 59 ; WX 278 ; N semicolon ; B 56 -147 301 516 ;\nC 60 ; WX 584 ; N less ; B 94 11 641 495 ;\nC 61 ; WX 584 ; N equal ; B 63 115 628 390 ;\nC 62 ; WX 584 ; N greater ; B 50 11 597 495 ;\nC 63 ; WX 556 ; N question ; B 161 0 610 727 ;\nC 64 ; WX 1015 ; N at ; B 215 -19 965 737 ;\nC 65 ; WX 667 ; N A ; B 14 0 654 718 ;\nC 66 ; WX 667 ; N B ; B 74 0 712 718 ;\nC 67 ; WX 722 ; N C ; B 108 -19 782 737 ;\nC 68 ; WX 722 ; N D ; B 81 0 764 718 ;\nC 69 ; WX 667 ; N E ; B 86 0 762 718 ;\nC 70 ; WX 611 ; N F ; B 86 0 736 718 ;\nC 71 ; WX 778 ; N G ; B 111 -19 799 737 ;\nC 72 ; WX 722 ; N H ; B 77 0 799 718 ;\nC 73 ; WX 278 ; N I ; B 91 0 341 718 ;\nC 74 ; WX 500 ; N J ; B 47 -19 581 718 ;\nC 75 ; WX 667 ; N K ; B 76 0 808 718 ;\nC 76 ; WX 556 ; N L ; B 76 0 555 718 ;\nC 77 ; WX 833 ; N M ; B 73 0 914 718 ;\nC 78 ; WX 722 ; N N ; B 76 0 799 718 ;\nC 79 ; WX 778 ; N O ; B 105 -19 826 737 ;\nC 80 ; WX 667 ; N P ; B 86 0 737 718 ;\nC 81 ; WX 778 ; N Q ; B 105 -56 826 737 ;\nC 82 ; WX 722 ; N R ; B 88 0 773 718 ;\nC 83 ; WX 667 ; N S ; B 90 -19 713 737 ;\nC 84 ; WX 611 ; N T ; B 148 0 750 718 ;\nC 85 ; WX 722 ; N U ; B 123 -19 797 718 ;\nC 86 ; WX 667 ; N V ; B 173 0 800 718 ;\nC 87 ; WX 944 ; N W ; B 169 0 1081 718 ;\nC 88 ; WX 667 ; N X ; B 19 0 790 718 ;\nC 89 ; WX 667 ; N Y ; B 167 0 806 718 ;\nC 90 ; WX 611 ; N Z ; B 23 0 741 718 ;\nC 91 ; WX 278 ; N bracketleft ; B 21 -196 403 722 ;\nC 92 ; WX 278 ; N backslash ; B 140 -19 291 737 ;\nC 93 ; WX 278 ; N bracketright ; B -14 -196 368 722 ;\nC 94 ; WX 469 ; N asciicircum ; B 42 264 539 688 ;\nC 95 ; WX 556 ; N underscore ; B -27 -125 540 -75 ;\nC 96 ; WX 222 ; N quoteleft ; B 165 470 323 725 ;\nC 97 ; WX 556 ; N a ; B 61 -15 559 538 ;\nC 98 ; WX 556 ; N b ; B 58 -15 584 718 ;\nC 99 ; WX 500 ; N c ; B 74 -15 553 538 ;\nC 100 ; WX 556 ; N d ; B 84 -15 652 718 ;\nC 101 ; WX 556 ; N e ; B 84 -15 578 538 ;\nC 102 ; WX 278 ; N f ; B 86 0 416 728 ; L i fi ; L l fl ;\nC 103 ; WX 556 ; N g ; B 42 -220 610 538 ;\nC 104 ; WX 556 ; N h ; B 65 0 573 718 ;\nC 105 ; WX 222 ; N i ; B 67 0 308 718 ;\nC 106 ; WX 222 ; N j ; B -60 -210 308 718 ;\nC 107 ; WX 500 ; N k ; B 67 0 600 718 ;\nC 108 ; WX 222 ; N l ; B 67 0 308 718 ;\nC 109 ; WX 833 ; N m ; B 65 0 852 538 ;\nC 110 ; WX 556 ; N n ; B 65 0 573 538 ;\nC 111 ; WX 556 ; N o ; B 83 -14 585 538 ;\nC 112 ; WX 556 ; N p ; B 14 -207 584 538 ;\nC 113 ; WX 556 ; N q ; B 84 -207 605 538 ;\nC 114 ; WX 333 ; N r ; B 77 0 446 538 ;\nC 115 ; WX 500 ; N s ; B 63 -15 529 538 ;\nC 116 ; WX 278 ; N t ; B 102 -7 368 669 ;\nC 117 ; WX 556 ; N u ; B 94 -15 600 523 ;\nC 118 ; WX 500 ; N v ; B 119 0 603 523 ;\nC 119 ; WX 722 ; N w ; B 125 0 820 523 ;\nC 120 ; WX 500 ; N x ; B 11 0 594 523 ;\nC 121 ; WX 500 ; N y ; B 15 -214 600 523 ;\nC 122 ; WX 500 ; N z ; B 31 0 571 523 ;\nC 123 ; WX 334 ; N braceleft ; B 92 -196 445 722 ;\nC 124 ; WX 260 ; N bar ; B 46 -225 332 775 ;\nC 125 ; WX 334 ; N braceright ; B 0 -196 354 722 ;\nC 126 ; WX 584 ; N asciitilde ; B 111 180 580 326 ;\nC 161 ; WX 333 ; N exclamdown ; B 77 -195 326 523 ;\nC 162 ; WX 556 ; N cent ; B 95 -115 584 623 ;\nC 163 ; WX 556 ; N sterling ; B 49 -16 634 718 ;\nC 164 ; WX 167 ; N fraction ; B -170 -19 482 703 ;\nC 165 ; WX 556 ; N yen ; B 81 0 699 688 ;\nC 166 ; WX 556 ; N florin ; B -52 -207 654 737 ;\nC 167 ; WX 556 ; N section ; B 76 -191 584 737 ;\nC 168 ; WX 556 ; N currency ; B 60 99 646 603 ;\nC 169 ; WX 191 ; N quotesingle ; B 157 463 285 718 ;\nC 170 ; WX 333 ; N quotedblleft ; B 138 470 461 725 ;\nC 171 ; WX 556 ; N guillemotleft ; B 146 108 554 446 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 137 108 340 446 ;\nC 173 ; WX 333 ; N guilsinglright ; B 111 108 314 446 ;\nC 174 ; WX 500 ; N fi ; B 86 0 587 728 ;\nC 175 ; WX 500 ; N fl ; B 86 0 585 728 ;\nC 177 ; WX 556 ; N endash ; B 51 240 623 313 ;\nC 178 ; WX 556 ; N dagger ; B 135 -159 622 718 ;\nC 179 ; WX 556 ; N daggerdbl ; B 52 -159 623 718 ;\nC 180 ; WX 278 ; N periodcentered ; B 129 190 257 315 ;\nC 182 ; WX 537 ; N paragraph ; B 126 -173 650 718 ;\nC 183 ; WX 350 ; N bullet ; B 91 202 413 517 ;\nC 184 ; WX 222 ; N quotesinglbase ; B 21 -149 180 106 ;\nC 185 ; WX 333 ; N quotedblbase ; B -6 -149 318 106 ;\nC 186 ; WX 333 ; N quotedblright ; B 124 463 448 718 ;\nC 187 ; WX 556 ; N guillemotright ; B 120 108 528 446 ;\nC 188 ; WX 1000 ; N ellipsis ; B 115 0 908 106 ;\nC 189 ; WX 1000 ; N perthousand ; B 88 -19 1029 703 ;\nC 191 ; WX 611 ; N questiondown ; B 85 -201 534 525 ;\nC 193 ; WX 333 ; N grave ; B 170 593 337 734 ;\nC 194 ; WX 333 ; N acute ; B 248 593 475 734 ;\nC 195 ; WX 333 ; N circumflex ; B 147 593 438 734 ;\nC 196 ; WX 333 ; N tilde ; B 125 606 490 722 ;\nC 197 ; WX 333 ; N macron ; B 143 627 468 684 ;\nC 198 ; WX 333 ; N breve ; B 167 595 476 731 ;\nC 199 ; WX 333 ; N dotaccent ; B 249 604 362 706 ;\nC 200 ; WX 333 ; N dieresis ; B 168 604 443 706 ;\nC 202 ; WX 333 ; N ring ; B 214 572 402 756 ;\nC 203 ; WX 333 ; N cedilla ; B 2 -225 232 0 ;\nC 205 ; WX 333 ; N hungarumlaut ; B 157 593 565 734 ;\nC 206 ; WX 333 ; N ogonek ; B 43 -225 249 0 ;\nC 207 ; WX 333 ; N caron ; B 177 593 468 734 ;\nC 208 ; WX 1000 ; N emdash ; B 51 240 1067 313 ;\nC 225 ; WX 1000 ; N AE ; B 8 0 1097 718 ;\nC 227 ; WX 370 ; N ordfeminine ; B 127 405 449 737 ;\nC 232 ; WX 556 ; N Lslash ; B 41 0 555 718 ;\nC 233 ; WX 778 ; N Oslash ; B 43 -19 890 737 ;\nC 234 ; WX 1000 ; N OE ; B 98 -19 1116 737 ;\nC 235 ; WX 365 ; N ordmasculine ; B 141 405 468 737 ;\nC 241 ; WX 889 ; N ae ; B 61 -15 909 538 ;\nC 245 ; WX 278 ; N dotlessi ; B 95 0 294 523 ;\nC 248 ; WX 222 ; N lslash ; B 41 0 347 718 ;\nC 249 ; WX 611 ; N oslash ; B 29 -22 647 545 ;\nC 250 ; WX 944 ; N oe ; B 83 -15 964 538 ;\nC 251 ; WX 611 ; N germandbls ; B 67 -15 658 728 ;\nC -1 ; WX 278 ; N Idieresis ; B 91 0 458 901 ;\nC -1 ; WX 556 ; N eacute ; B 84 -15 587 734 ;\nC -1 ; WX 556 ; N abreve ; B 61 -15 578 731 ;\nC -1 ; WX 556 ; N uhungarumlaut ; B 94 -15 677 734 ;\nC -1 ; WX 556 ; N ecaron ; B 84 -15 580 734 ;\nC -1 ; WX 667 ; N Ydieresis ; B 167 0 806 901 ;\nC -1 ; WX 584 ; N divide ; B 85 -19 606 524 ;\nC -1 ; WX 667 ; N Yacute ; B 167 0 806 929 ;\nC -1 ; WX 667 ; N Acircumflex ; B 14 0 654 929 ;\nC -1 ; WX 556 ; N aacute ; B 61 -15 587 734 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 123 -19 797 929 ;\nC -1 ; WX 500 ; N yacute ; B 15 -214 600 734 ;\nC -1 ; WX 500 ; N scommaaccent ; B 63 -225 529 538 ;\nC -1 ; WX 556 ; N ecircumflex ; B 84 -15 578 734 ;\nC -1 ; WX 722 ; N Uring ; B 123 -19 797 931 ;\nC -1 ; WX 722 ; N Udieresis ; B 123 -19 797 901 ;\nC -1 ; WX 556 ; N aogonek ; B 61 -220 559 538 ;\nC -1 ; WX 722 ; N Uacute ; B 123 -19 797 929 ;\nC -1 ; WX 556 ; N uogonek ; B 94 -225 600 523 ;\nC -1 ; WX 667 ; N Edieresis ; B 86 0 762 901 ;\nC -1 ; WX 722 ; N Dcroat ; B 69 0 764 718 ;\nC -1 ; WX 250 ; N commaaccent ; B 39 -225 172 -40 ;\nC -1 ; WX 737 ; N copyright ; B 54 -19 837 737 ;\nC -1 ; WX 667 ; N Emacron ; B 86 0 762 879 ;\nC -1 ; WX 500 ; N ccaron ; B 74 -15 553 734 ;\nC -1 ; WX 556 ; N aring ; B 61 -15 559 756 ;\nC -1 ; WX 722 ; N Ncommaaccent ; B 76 -225 799 718 ;\nC -1 ; WX 222 ; N lacute ; B 67 0 461 929 ;\nC -1 ; WX 556 ; N agrave ; B 61 -15 559 734 ;\nC -1 ; WX 611 ; N Tcommaaccent ; B 148 -225 750 718 ;\nC -1 ; WX 722 ; N Cacute ; B 108 -19 782 929 ;\nC -1 ; WX 556 ; N atilde ; B 61 -15 592 722 ;\nC -1 ; WX 667 ; N Edotaccent ; B 86 0 762 901 ;\nC -1 ; WX 500 ; N scaron ; B 63 -15 552 734 ;\nC -1 ; WX 500 ; N scedilla ; B 63 -225 529 538 ;\nC -1 ; WX 278 ; N iacute ; B 95 0 448 734 ;\nC -1 ; WX 471 ; N lozenge ; B 88 0 540 728 ;\nC -1 ; WX 722 ; N Rcaron ; B 88 0 773 929 ;\nC -1 ; WX 778 ; N Gcommaaccent ; B 111 -225 799 737 ;\nC -1 ; WX 556 ; N ucircumflex ; B 94 -15 600 734 ;\nC -1 ; WX 556 ; N acircumflex ; B 61 -15 559 734 ;\nC -1 ; WX 667 ; N Amacron ; B 14 0 677 879 ;\nC -1 ; WX 333 ; N rcaron ; B 77 0 508 734 ;\nC -1 ; WX 500 ; N ccedilla ; B 74 -225 553 538 ;\nC -1 ; WX 611 ; N Zdotaccent ; B 23 0 741 901 ;\nC -1 ; WX 667 ; N Thorn ; B 86 0 712 718 ;\nC -1 ; WX 778 ; N Omacron ; B 105 -19 826 879 ;\nC -1 ; WX 722 ; N Racute ; B 88 0 773 929 ;\nC -1 ; WX 667 ; N Sacute ; B 90 -19 713 929 ;\nC -1 ; WX 643 ; N dcaron ; B 84 -15 808 718 ;\nC -1 ; WX 722 ; N Umacron ; B 123 -19 797 879 ;\nC -1 ; WX 556 ; N uring ; B 94 -15 600 756 ;\nC -1 ; WX 333 ; N threesuperior ; B 90 270 436 703 ;\nC -1 ; WX 778 ; N Ograve ; B 105 -19 826 929 ;\nC -1 ; WX 667 ; N Agrave ; B 14 0 654 929 ;\nC -1 ; WX 667 ; N Abreve ; B 14 0 685 926 ;\nC -1 ; WX 584 ; N multiply ; B 50 0 642 506 ;\nC -1 ; WX 556 ; N uacute ; B 94 -15 600 734 ;\nC -1 ; WX 611 ; N Tcaron ; B 148 0 750 929 ;\nC -1 ; WX 476 ; N partialdiff ; B 41 -38 550 714 ;\nC -1 ; WX 500 ; N ydieresis ; B 15 -214 600 706 ;\nC -1 ; WX 722 ; N Nacute ; B 76 0 799 929 ;\nC -1 ; WX 278 ; N icircumflex ; B 95 0 411 734 ;\nC -1 ; WX 667 ; N Ecircumflex ; B 86 0 762 929 ;\nC -1 ; WX 556 ; N adieresis ; B 61 -15 559 706 ;\nC -1 ; WX 556 ; N edieresis ; B 84 -15 578 706 ;\nC -1 ; WX 500 ; N cacute ; B 74 -15 559 734 ;\nC -1 ; WX 556 ; N nacute ; B 65 0 587 734 ;\nC -1 ; WX 556 ; N umacron ; B 94 -15 600 684 ;\nC -1 ; WX 722 ; N Ncaron ; B 76 0 799 929 ;\nC -1 ; WX 278 ; N Iacute ; B 91 0 489 929 ;\nC -1 ; WX 584 ; N plusminus ; B 39 0 618 506 ;\nC -1 ; WX 260 ; N brokenbar ; B 62 -150 316 700 ;\nC -1 ; WX 737 ; N registered ; B 54 -19 837 737 ;\nC -1 ; WX 778 ; N Gbreve ; B 111 -19 799 926 ;\nC -1 ; WX 278 ; N Idotaccent ; B 91 0 377 901 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 671 706 ;\nC -1 ; WX 667 ; N Egrave ; B 86 0 762 929 ;\nC -1 ; WX 333 ; N racute ; B 77 0 475 734 ;\nC -1 ; WX 556 ; N omacron ; B 83 -14 585 684 ;\nC -1 ; WX 611 ; N Zacute ; B 23 0 741 929 ;\nC -1 ; WX 611 ; N Zcaron ; B 23 0 741 929 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 620 674 ;\nC -1 ; WX 722 ; N Eth ; B 69 0 764 718 ;\nC -1 ; WX 722 ; N Ccedilla ; B 108 -225 782 737 ;\nC -1 ; WX 222 ; N lcommaaccent ; B 25 -225 308 718 ;\nC -1 ; WX 317 ; N tcaron ; B 102 -7 501 808 ;\nC -1 ; WX 556 ; N eogonek ; B 84 -225 578 538 ;\nC -1 ; WX 722 ; N Uogonek ; B 123 -225 797 718 ;\nC -1 ; WX 667 ; N Aacute ; B 14 0 683 929 ;\nC -1 ; WX 667 ; N Adieresis ; B 14 0 654 901 ;\nC -1 ; WX 556 ; N egrave ; B 84 -15 578 734 ;\nC -1 ; WX 500 ; N zacute ; B 31 0 571 734 ;\nC -1 ; WX 222 ; N iogonek ; B -61 -225 308 718 ;\nC -1 ; WX 778 ; N Oacute ; B 105 -19 826 929 ;\nC -1 ; WX 556 ; N oacute ; B 83 -14 587 734 ;\nC -1 ; WX 556 ; N amacron ; B 61 -15 580 684 ;\nC -1 ; WX 500 ; N sacute ; B 63 -15 559 734 ;\nC -1 ; WX 278 ; N idieresis ; B 95 0 416 706 ;\nC -1 ; WX 778 ; N Ocircumflex ; B 105 -19 826 929 ;\nC -1 ; WX 722 ; N Ugrave ; B 123 -19 797 929 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 556 ; N thorn ; B 14 -207 584 718 ;\nC -1 ; WX 333 ; N twosuperior ; B 64 281 449 703 ;\nC -1 ; WX 778 ; N Odieresis ; B 105 -19 826 901 ;\nC -1 ; WX 556 ; N mu ; B 24 -207 600 523 ;\nC -1 ; WX 278 ; N igrave ; B 95 0 310 734 ;\nC -1 ; WX 556 ; N ohungarumlaut ; B 83 -14 677 734 ;\nC -1 ; WX 667 ; N Eogonek ; B 86 -220 762 718 ;\nC -1 ; WX 556 ; N dcroat ; B 84 -15 689 718 ;\nC -1 ; WX 834 ; N threequarters ; B 130 -19 861 703 ;\nC -1 ; WX 667 ; N Scedilla ; B 90 -225 713 737 ;\nC -1 ; WX 299 ; N lcaron ; B 67 0 464 718 ;\nC -1 ; WX 667 ; N Kcommaaccent ; B 76 -225 808 718 ;\nC -1 ; WX 556 ; N Lacute ; B 76 0 555 929 ;\nC -1 ; WX 1000 ; N trademark ; B 186 306 1056 718 ;\nC -1 ; WX 556 ; N edotaccent ; B 84 -15 578 706 ;\nC -1 ; WX 278 ; N Igrave ; B 91 0 351 929 ;\nC -1 ; WX 278 ; N Imacron ; B 91 0 483 879 ;\nC -1 ; WX 556 ; N Lcaron ; B 76 0 570 718 ;\nC -1 ; WX 834 ; N onehalf ; B 114 -19 839 703 ;\nC -1 ; WX 549 ; N lessequal ; B 26 0 666 674 ;\nC -1 ; WX 556 ; N ocircumflex ; B 83 -14 585 734 ;\nC -1 ; WX 556 ; N ntilde ; B 65 0 592 722 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 123 -19 801 929 ;\nC -1 ; WX 667 ; N Eacute ; B 86 0 762 929 ;\nC -1 ; WX 556 ; N emacron ; B 84 -15 580 684 ;\nC -1 ; WX 556 ; N gbreve ; B 42 -220 610 731 ;\nC -1 ; WX 834 ; N onequarter ; B 150 -19 802 703 ;\nC -1 ; WX 667 ; N Scaron ; B 90 -19 713 929 ;\nC -1 ; WX 667 ; N Scommaaccent ; B 90 -225 713 737 ;\nC -1 ; WX 778 ; N Ohungarumlaut ; B 105 -19 829 929 ;\nC -1 ; WX 400 ; N degree ; B 169 411 468 703 ;\nC -1 ; WX 556 ; N ograve ; B 83 -14 585 734 ;\nC -1 ; WX 722 ; N Ccaron ; B 108 -19 782 929 ;\nC -1 ; WX 556 ; N ugrave ; B 94 -15 600 734 ;\nC -1 ; WX 453 ; N radical ; B 79 -80 617 762 ;\nC -1 ; WX 722 ; N Dcaron ; B 81 0 764 929 ;\nC -1 ; WX 333 ; N rcommaaccent ; B 30 -225 446 538 ;\nC -1 ; WX 722 ; N Ntilde ; B 76 0 799 917 ;\nC -1 ; WX 556 ; N otilde ; B 83 -14 602 722 ;\nC -1 ; WX 722 ; N Rcommaaccent ; B 88 -225 773 718 ;\nC -1 ; WX 556 ; N Lcommaaccent ; B 76 -225 555 718 ;\nC -1 ; WX 667 ; N Atilde ; B 14 0 699 917 ;\nC -1 ; WX 667 ; N Aogonek ; B 14 -225 654 718 ;\nC -1 ; WX 667 ; N Aring ; B 14 0 654 931 ;\nC -1 ; WX 778 ; N Otilde ; B 105 -19 826 917 ;\nC -1 ; WX 500 ; N zdotaccent ; B 31 0 571 706 ;\nC -1 ; WX 667 ; N Ecaron ; B 86 0 762 929 ;\nC -1 ; WX 278 ; N Iogonek ; B -33 -225 341 718 ;\nC -1 ; WX 500 ; N kcommaaccent ; B 67 -225 600 718 ;\nC -1 ; WX 584 ; N minus ; B 85 216 606 289 ;\nC -1 ; WX 278 ; N Icircumflex ; B 91 0 452 929 ;\nC -1 ; WX 556 ; N ncaron ; B 65 0 580 734 ;\nC -1 ; WX 278 ; N tcommaaccent ; B 63 -225 368 669 ;\nC -1 ; WX 584 ; N logicalnot ; B 106 108 628 390 ;\nC -1 ; WX 556 ; N odieresis ; B 83 -14 585 706 ;\nC -1 ; WX 556 ; N udieresis ; B 94 -15 600 706 ;\nC -1 ; WX 549 ; N notequal ; B 34 -35 623 551 ;\nC -1 ; WX 556 ; N gcommaaccent ; B 42 -220 610 822 ;\nC -1 ; WX 556 ; N eth ; B 81 -15 617 737 ;\nC -1 ; WX 500 ; N zcaron ; B 31 0 571 734 ;\nC -1 ; WX 556 ; N ncommaaccent ; B 65 -225 573 538 ;\nC -1 ; WX 333 ; N onesuperior ; B 166 281 371 703 ;\nC -1 ; WX 278 ; N imacron ; B 95 0 417 684 ;\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2705\nKPX A C -30\nKPX A Cacute -30\nKPX A Ccaron -30\nKPX A Ccedilla -30\nKPX A G -30\nKPX A Gbreve -30\nKPX A Gcommaaccent -30\nKPX A O -30\nKPX A Oacute -30\nKPX A Ocircumflex -30\nKPX A Odieresis -30\nKPX A Ograve -30\nKPX A Ohungarumlaut -30\nKPX A Omacron -30\nKPX A Oslash -30\nKPX A Otilde -30\nKPX A Q -30\nKPX A T -120\nKPX A Tcaron -120\nKPX A Tcommaaccent -120\nKPX A U -50\nKPX A Uacute -50\nKPX A Ucircumflex -50\nKPX A Udieresis -50\nKPX A Ugrave -50\nKPX A Uhungarumlaut -50\nKPX A Umacron -50\nKPX A Uogonek -50\nKPX A Uring -50\nKPX A V -70\nKPX A W -50\nKPX A Y -100\nKPX A Yacute -100\nKPX A Ydieresis -100\nKPX A u -30\nKPX A uacute -30\nKPX A ucircumflex -30\nKPX A udieresis -30\nKPX A ugrave -30\nKPX A uhungarumlaut -30\nKPX A umacron -30\nKPX A uogonek -30\nKPX A uring -30\nKPX A v -40\nKPX A w -40\nKPX A y -40\nKPX A yacute -40\nKPX A ydieresis -40\nKPX Aacute C -30\nKPX Aacute Cacute -30\nKPX Aacute Ccaron -30\nKPX Aacute Ccedilla -30\nKPX Aacute G -30\nKPX Aacute Gbreve -30\nKPX Aacute Gcommaaccent -30\nKPX Aacute O -30\nKPX Aacute Oacute -30\nKPX Aacute Ocircumflex -30\nKPX Aacute Odieresis -30\nKPX Aacute Ograve -30\nKPX Aacute Ohungarumlaut -30\nKPX Aacute Omacron -30\nKPX Aacute Oslash -30\nKPX Aacute Otilde -30\nKPX Aacute Q -30\nKPX Aacute T -120\nKPX Aacute Tcaron -120\nKPX Aacute Tcommaaccent -120\nKPX Aacute U -50\nKPX Aacute Uacute -50\nKPX Aacute Ucircumflex -50\nKPX Aacute Udieresis -50\nKPX Aacute Ugrave -50\nKPX Aacute Uhungarumlaut -50\nKPX Aacute Umacron -50\nKPX Aacute Uogonek -50\nKPX Aacute Uring -50\nKPX Aacute V -70\nKPX Aacute W -50\nKPX Aacute Y -100\nKPX Aacute Yacute -100\nKPX Aacute Ydieresis -100\nKPX Aacute u -30\nKPX Aacute uacute -30\nKPX Aacute ucircumflex -30\nKPX Aacute udieresis -30\nKPX Aacute ugrave -30\nKPX Aacute uhungarumlaut -30\nKPX Aacute umacron -30\nKPX Aacute uogonek -30\nKPX Aacute uring -30\nKPX Aacute v -40\nKPX Aacute w -40\nKPX Aacute y -40\nKPX Aacute yacute -40\nKPX Aacute ydieresis -40\nKPX Abreve C -30\nKPX Abreve Cacute -30\nKPX Abreve Ccaron -30\nKPX Abreve Ccedilla -30\nKPX Abreve G -30\nKPX Abreve Gbreve -30\nKPX Abreve Gcommaaccent -30\nKPX Abreve O -30\nKPX Abreve Oacute -30\nKPX Abreve Ocircumflex -30\nKPX Abreve Odieresis -30\nKPX Abreve Ograve -30\nKPX Abreve Ohungarumlaut -30\nKPX Abreve Omacron -30\nKPX Abreve Oslash -30\nKPX Abreve Otilde -30\nKPX Abreve Q -30\nKPX Abreve T -120\nKPX Abreve Tcaron -120\nKPX Abreve Tcommaaccent -120\nKPX Abreve U -50\nKPX Abreve Uacute -50\nKPX Abreve Ucircumflex -50\nKPX Abreve Udieresis -50\nKPX Abreve Ugrave -50\nKPX Abreve Uhungarumlaut -50\nKPX Abreve Umacron -50\nKPX Abreve Uogonek -50\nKPX Abreve Uring -50\nKPX Abreve V -70\nKPX Abreve W -50\nKPX Abreve Y -100\nKPX Abreve Yacute -100\nKPX Abreve Ydieresis -100\nKPX Abreve u -30\nKPX Abreve uacute -30\nKPX Abreve ucircumflex -30\nKPX Abreve udieresis -30\nKPX Abreve ugrave -30\nKPX Abreve uhungarumlaut -30\nKPX Abreve umacron -30\nKPX Abreve uogonek -30\nKPX Abreve uring -30\nKPX Abreve v -40\nKPX Abreve w -40\nKPX Abreve y -40\nKPX Abreve yacute -40\nKPX Abreve ydieresis -40\nKPX Acircumflex C -30\nKPX Acircumflex Cacute -30\nKPX Acircumflex Ccaron -30\nKPX Acircumflex Ccedilla -30\nKPX Acircumflex G -30\nKPX Acircumflex Gbreve -30\nKPX Acircumflex Gcommaaccent -30\nKPX Acircumflex O -30\nKPX Acircumflex Oacute -30\nKPX Acircumflex Ocircumflex -30\nKPX Acircumflex Odieresis -30\nKPX Acircumflex Ograve -30\nKPX Acircumflex Ohungarumlaut -30\nKPX Acircumflex Omacron -30\nKPX Acircumflex Oslash -30\nKPX Acircumflex Otilde -30\nKPX Acircumflex Q -30\nKPX Acircumflex T -120\nKPX Acircumflex Tcaron -120\nKPX Acircumflex Tcommaaccent -120\nKPX Acircumflex U -50\nKPX Acircumflex Uacute -50\nKPX Acircumflex Ucircumflex -50\nKPX Acircumflex Udieresis -50\nKPX Acircumflex Ugrave -50\nKPX Acircumflex Uhungarumlaut -50\nKPX Acircumflex Umacron -50\nKPX Acircumflex Uogonek -50\nKPX Acircumflex Uring -50\nKPX Acircumflex V -70\nKPX Acircumflex W -50\nKPX Acircumflex Y -100\nKPX Acircumflex Yacute -100\nKPX Acircumflex Ydieresis -100\nKPX Acircumflex u -30\nKPX Acircumflex uacute -30\nKPX Acircumflex ucircumflex -30\nKPX Acircumflex udieresis -30\nKPX Acircumflex ugrave -30\nKPX Acircumflex uhungarumlaut -30\nKPX Acircumflex umacron -30\nKPX Acircumflex uogonek -30\nKPX Acircumflex uring -30\nKPX Acircumflex v -40\nKPX Acircumflex w -40\nKPX Acircumflex y -40\nKPX Acircumflex yacute -40\nKPX Acircumflex ydieresis -40\nKPX Adieresis C -30\nKPX Adieresis Cacute -30\nKPX Adieresis Ccaron -30\nKPX Adieresis Ccedilla -30\nKPX Adieresis G -30\nKPX Adieresis Gbreve -30\nKPX Adieresis Gcommaaccent -30\nKPX Adieresis O -30\nKPX Adieresis Oacute -30\nKPX Adieresis Ocircumflex -30\nKPX Adieresis Odieresis -30\nKPX Adieresis Ograve -30\nKPX Adieresis Ohungarumlaut -30\nKPX Adieresis Omacron -30\nKPX Adieresis Oslash -30\nKPX Adieresis Otilde -30\nKPX Adieresis Q -30\nKPX Adieresis T -120\nKPX Adieresis Tcaron -120\nKPX Adieresis Tcommaaccent -120\nKPX Adieresis U -50\nKPX Adieresis Uacute -50\nKPX Adieresis Ucircumflex -50\nKPX Adieresis Udieresis -50\nKPX Adieresis Ugrave -50\nKPX Adieresis Uhungarumlaut -50\nKPX Adieresis Umacron -50\nKPX Adieresis Uogonek -50\nKPX Adieresis Uring -50\nKPX Adieresis V -70\nKPX Adieresis W -50\nKPX Adieresis Y -100\nKPX Adieresis Yacute -100\nKPX Adieresis Ydieresis -100\nKPX Adieresis u -30\nKPX Adieresis uacute -30\nKPX Adieresis ucircumflex -30\nKPX Adieresis udieresis -30\nKPX Adieresis ugrave -30\nKPX Adieresis uhungarumlaut -30\nKPX Adieresis umacron -30\nKPX Adieresis uogonek -30\nKPX Adieresis uring -30\nKPX Adieresis v -40\nKPX Adieresis w -40\nKPX Adieresis y -40\nKPX Adieresis yacute -40\nKPX Adieresis ydieresis -40\nKPX Agrave C -30\nKPX Agrave Cacute -30\nKPX Agrave Ccaron -30\nKPX Agrave Ccedilla -30\nKPX Agrave G -30\nKPX Agrave Gbreve -30\nKPX Agrave Gcommaaccent -30\nKPX Agrave O -30\nKPX Agrave Oacute -30\nKPX Agrave Ocircumflex -30\nKPX Agrave Odieresis -30\nKPX Agrave Ograve -30\nKPX Agrave Ohungarumlaut -30\nKPX Agrave Omacron -30\nKPX Agrave Oslash -30\nKPX Agrave Otilde -30\nKPX Agrave Q -30\nKPX Agrave T -120\nKPX Agrave Tcaron -120\nKPX Agrave Tcommaaccent -120\nKPX Agrave U -50\nKPX Agrave Uacute -50\nKPX Agrave Ucircumflex -50\nKPX Agrave Udieresis -50\nKPX Agrave Ugrave -50\nKPX Agrave Uhungarumlaut -50\nKPX Agrave Umacron -50\nKPX Agrave Uogonek -50\nKPX Agrave Uring -50\nKPX Agrave V -70\nKPX Agrave W -50\nKPX Agrave Y -100\nKPX Agrave Yacute -100\nKPX Agrave Ydieresis -100\nKPX Agrave u -30\nKPX Agrave uacute -30\nKPX Agrave ucircumflex -30\nKPX Agrave udieresis -30\nKPX Agrave ugrave -30\nKPX Agrave uhungarumlaut -30\nKPX Agrave umacron -30\nKPX Agrave uogonek -30\nKPX Agrave uring -30\nKPX Agrave v -40\nKPX Agrave w -40\nKPX Agrave y -40\nKPX Agrave yacute -40\nKPX Agrave ydieresis -40\nKPX Amacron C -30\nKPX Amacron Cacute -30\nKPX Amacron Ccaron -30\nKPX Amacron Ccedilla -30\nKPX Amacron G -30\nKPX Amacron Gbreve -30\nKPX Amacron Gcommaaccent -30\nKPX Amacron O -30\nKPX Amacron Oacute -30\nKPX Amacron Ocircumflex -30\nKPX Amacron Odieresis -30\nKPX Amacron Ograve -30\nKPX Amacron Ohungarumlaut -30\nKPX Amacron Omacron -30\nKPX Amacron Oslash -30\nKPX Amacron Otilde -30\nKPX Amacron Q -30\nKPX Amacron T -120\nKPX Amacron Tcaron -120\nKPX Amacron Tcommaaccent -120\nKPX Amacron U -50\nKPX Amacron Uacute -50\nKPX Amacron Ucircumflex -50\nKPX Amacron Udieresis -50\nKPX Amacron Ugrave -50\nKPX Amacron Uhungarumlaut -50\nKPX Amacron Umacron -50\nKPX Amacron Uogonek -50\nKPX Amacron Uring -50\nKPX Amacron V -70\nKPX Amacron W -50\nKPX Amacron Y -100\nKPX Amacron Yacute -100\nKPX Amacron Ydieresis -100\nKPX Amacron u -30\nKPX Amacron uacute -30\nKPX Amacron ucircumflex -30\nKPX Amacron udieresis -30\nKPX Amacron ugrave -30\nKPX Amacron uhungarumlaut -30\nKPX Amacron umacron -30\nKPX Amacron uogonek -30\nKPX Amacron uring -30\nKPX Amacron v -40\nKPX Amacron w -40\nKPX Amacron y -40\nKPX Amacron yacute -40\nKPX Amacron ydieresis -40\nKPX Aogonek C -30\nKPX Aogonek Cacute -30\nKPX Aogonek Ccaron -30\nKPX Aogonek Ccedilla -30\nKPX Aogonek G -30\nKPX Aogonek Gbreve -30\nKPX Aogonek Gcommaaccent -30\nKPX Aogonek O -30\nKPX Aogonek Oacute -30\nKPX Aogonek Ocircumflex -30\nKPX Aogonek Odieresis -30\nKPX Aogonek Ograve -30\nKPX Aogonek Ohungarumlaut -30\nKPX Aogonek Omacron -30\nKPX Aogonek Oslash -30\nKPX Aogonek Otilde -30\nKPX Aogonek Q -30\nKPX Aogonek T -120\nKPX Aogonek Tcaron -120\nKPX Aogonek Tcommaaccent -120\nKPX Aogonek U -50\nKPX Aogonek Uacute -50\nKPX Aogonek Ucircumflex -50\nKPX Aogonek Udieresis -50\nKPX Aogonek Ugrave -50\nKPX Aogonek Uhungarumlaut -50\nKPX Aogonek Umacron -50\nKPX Aogonek Uogonek -50\nKPX Aogonek Uring -50\nKPX Aogonek V -70\nKPX Aogonek W -50\nKPX Aogonek Y -100\nKPX Aogonek Yacute -100\nKPX Aogonek Ydieresis -100\nKPX Aogonek u -30\nKPX Aogonek uacute -30\nKPX Aogonek ucircumflex -30\nKPX Aogonek udieresis -30\nKPX Aogonek ugrave -30\nKPX Aogonek uhungarumlaut -30\nKPX Aogonek umacron -30\nKPX Aogonek uogonek -30\nKPX Aogonek uring -30\nKPX Aogonek v -40\nKPX Aogonek w -40\nKPX Aogonek y -40\nKPX Aogonek yacute -40\nKPX Aogonek ydieresis -40\nKPX Aring C -30\nKPX Aring Cacute -30\nKPX Aring Ccaron -30\nKPX Aring Ccedilla -30\nKPX Aring G -30\nKPX Aring Gbreve -30\nKPX Aring Gcommaaccent -30\nKPX Aring O -30\nKPX Aring Oacute -30\nKPX Aring Ocircumflex -30\nKPX Aring Odieresis -30\nKPX Aring Ograve -30\nKPX Aring Ohungarumlaut -30\nKPX Aring Omacron -30\nKPX Aring Oslash -30\nKPX Aring Otilde -30\nKPX Aring Q -30\nKPX Aring T -120\nKPX Aring Tcaron -120\nKPX Aring Tcommaaccent -120\nKPX Aring U -50\nKPX Aring Uacute -50\nKPX Aring Ucircumflex -50\nKPX Aring Udieresis -50\nKPX Aring Ugrave -50\nKPX Aring Uhungarumlaut -50\nKPX Aring Umacron -50\nKPX Aring Uogonek -50\nKPX Aring Uring -50\nKPX Aring V -70\nKPX Aring W -50\nKPX Aring Y -100\nKPX Aring Yacute -100\nKPX Aring Ydieresis -100\nKPX Aring u -30\nKPX Aring uacute -30\nKPX Aring ucircumflex -30\nKPX Aring udieresis -30\nKPX Aring ugrave -30\nKPX Aring uhungarumlaut -30\nKPX Aring umacron -30\nKPX Aring uogonek -30\nKPX Aring uring -30\nKPX Aring v -40\nKPX Aring w -40\nKPX Aring y -40\nKPX Aring yacute -40\nKPX Aring ydieresis -40\nKPX Atilde C -30\nKPX Atilde Cacute -30\nKPX Atilde Ccaron -30\nKPX Atilde Ccedilla -30\nKPX Atilde G -30\nKPX Atilde Gbreve -30\nKPX Atilde Gcommaaccent -30\nKPX Atilde O -30\nKPX Atilde Oacute -30\nKPX Atilde Ocircumflex -30\nKPX Atilde Odieresis -30\nKPX Atilde Ograve -30\nKPX Atilde Ohungarumlaut -30\nKPX Atilde Omacron -30\nKPX Atilde Oslash -30\nKPX Atilde Otilde -30\nKPX Atilde Q -30\nKPX Atilde T -120\nKPX Atilde Tcaron -120\nKPX Atilde Tcommaaccent -120\nKPX Atilde U -50\nKPX Atilde Uacute -50\nKPX Atilde Ucircumflex -50\nKPX Atilde Udieresis -50\nKPX Atilde Ugrave -50\nKPX Atilde Uhungarumlaut -50\nKPX Atilde Umacron -50\nKPX Atilde Uogonek -50\nKPX Atilde Uring -50\nKPX Atilde V -70\nKPX Atilde W -50\nKPX Atilde Y -100\nKPX Atilde Yacute -100\nKPX Atilde Ydieresis -100\nKPX Atilde u -30\nKPX Atilde uacute -30\nKPX Atilde ucircumflex -30\nKPX Atilde udieresis -30\nKPX Atilde ugrave -30\nKPX Atilde uhungarumlaut -30\nKPX Atilde umacron -30\nKPX Atilde uogonek -30\nKPX Atilde uring -30\nKPX Atilde v -40\nKPX Atilde w -40\nKPX Atilde y -40\nKPX Atilde yacute -40\nKPX Atilde ydieresis -40\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX B comma -20\nKPX B period -20\nKPX C comma -30\nKPX C period -30\nKPX Cacute comma -30\nKPX Cacute period -30\nKPX Ccaron comma -30\nKPX Ccaron period -30\nKPX Ccedilla comma -30\nKPX Ccedilla period -30\nKPX D A -40\nKPX D Aacute -40\nKPX D Abreve -40\nKPX D Acircumflex -40\nKPX D Adieresis -40\nKPX D Agrave -40\nKPX D Amacron -40\nKPX D Aogonek -40\nKPX D Aring -40\nKPX D Atilde -40\nKPX D V -70\nKPX D W -40\nKPX D Y -90\nKPX D Yacute -90\nKPX D Ydieresis -90\nKPX D comma -70\nKPX D period -70\nKPX Dcaron A -40\nKPX Dcaron Aacute -40\nKPX Dcaron Abreve -40\nKPX Dcaron Acircumflex -40\nKPX Dcaron Adieresis -40\nKPX Dcaron Agrave -40\nKPX Dcaron Amacron -40\nKPX Dcaron Aogonek -40\nKPX Dcaron Aring -40\nKPX Dcaron Atilde -40\nKPX Dcaron V -70\nKPX Dcaron W -40\nKPX Dcaron Y -90\nKPX Dcaron Yacute -90\nKPX Dcaron Ydieresis -90\nKPX Dcaron comma -70\nKPX Dcaron period -70\nKPX Dcroat A -40\nKPX Dcroat Aacute -40\nKPX Dcroat Abreve -40\nKPX Dcroat Acircumflex -40\nKPX Dcroat Adieresis -40\nKPX Dcroat Agrave -40\nKPX Dcroat Amacron -40\nKPX Dcroat Aogonek -40\nKPX Dcroat Aring -40\nKPX Dcroat Atilde -40\nKPX Dcroat V -70\nKPX Dcroat W -40\nKPX Dcroat Y -90\nKPX Dcroat Yacute -90\nKPX Dcroat Ydieresis -90\nKPX Dcroat comma -70\nKPX Dcroat period -70\nKPX F A -80\nKPX F Aacute -80\nKPX F Abreve -80\nKPX F Acircumflex -80\nKPX F Adieresis -80\nKPX F Agrave -80\nKPX F Amacron -80\nKPX F Aogonek -80\nKPX F Aring -80\nKPX F Atilde -80\nKPX F a -50\nKPX F aacute -50\nKPX F abreve -50\nKPX F acircumflex -50\nKPX F adieresis -50\nKPX F agrave -50\nKPX F amacron -50\nKPX F aogonek -50\nKPX F aring -50\nKPX F atilde -50\nKPX F comma -150\nKPX F e -30\nKPX F eacute -30\nKPX F ecaron -30\nKPX F ecircumflex -30\nKPX F edieresis -30\nKPX F edotaccent -30\nKPX F egrave -30\nKPX F emacron -30\nKPX F eogonek -30\nKPX F o -30\nKPX F oacute -30\nKPX F ocircumflex -30\nKPX F odieresis -30\nKPX F ograve -30\nKPX F ohungarumlaut -30\nKPX F omacron -30\nKPX F oslash -30\nKPX F otilde -30\nKPX F period -150\nKPX F r -45\nKPX F racute -45\nKPX F rcaron -45\nKPX F rcommaaccent -45\nKPX J A -20\nKPX J Aacute -20\nKPX J Abreve -20\nKPX J Acircumflex -20\nKPX J Adieresis -20\nKPX J Agrave -20\nKPX J Amacron -20\nKPX J Aogonek -20\nKPX J Aring -20\nKPX J Atilde -20\nKPX J a -20\nKPX J aacute -20\nKPX J abreve -20\nKPX J acircumflex -20\nKPX J adieresis -20\nKPX J agrave -20\nKPX J amacron -20\nKPX J aogonek -20\nKPX J aring -20\nKPX J atilde -20\nKPX J comma -30\nKPX J period -30\nKPX J u -20\nKPX J uacute -20\nKPX J ucircumflex -20\nKPX J udieresis -20\nKPX J ugrave -20\nKPX J uhungarumlaut -20\nKPX J umacron -20\nKPX J uogonek -20\nKPX J uring -20\nKPX K O -50\nKPX K Oacute -50\nKPX K Ocircumflex -50\nKPX K Odieresis -50\nKPX K Ograve -50\nKPX K Ohungarumlaut -50\nKPX K Omacron -50\nKPX K Oslash -50\nKPX K Otilde -50\nKPX K e -40\nKPX K eacute -40\nKPX K ecaron -40\nKPX K ecircumflex -40\nKPX K edieresis -40\nKPX K edotaccent -40\nKPX K egrave -40\nKPX K emacron -40\nKPX K eogonek -40\nKPX K o -40\nKPX K oacute -40\nKPX K ocircumflex -40\nKPX K odieresis -40\nKPX K ograve -40\nKPX K ohungarumlaut -40\nKPX K omacron -40\nKPX K oslash -40\nKPX K otilde -40\nKPX K u -30\nKPX K uacute -30\nKPX K ucircumflex -30\nKPX K udieresis -30\nKPX K ugrave -30\nKPX K uhungarumlaut -30\nKPX K umacron -30\nKPX K uogonek -30\nKPX K uring -30\nKPX K y -50\nKPX K yacute -50\nKPX K ydieresis -50\nKPX Kcommaaccent O -50\nKPX Kcommaaccent Oacute -50\nKPX Kcommaaccent Ocircumflex -50\nKPX Kcommaaccent Odieresis -50\nKPX Kcommaaccent Ograve -50\nKPX Kcommaaccent Ohungarumlaut -50\nKPX Kcommaaccent Omacron -50\nKPX Kcommaaccent Oslash -50\nKPX Kcommaaccent Otilde -50\nKPX Kcommaaccent e -40\nKPX Kcommaaccent eacute -40\nKPX Kcommaaccent ecaron -40\nKPX Kcommaaccent ecircumflex -40\nKPX Kcommaaccent edieresis -40\nKPX Kcommaaccent edotaccent -40\nKPX Kcommaaccent egrave -40\nKPX Kcommaaccent emacron -40\nKPX Kcommaaccent eogonek -40\nKPX Kcommaaccent o -40\nKPX Kcommaaccent oacute -40\nKPX Kcommaaccent ocircumflex -40\nKPX Kcommaaccent odieresis -40\nKPX Kcommaaccent ograve -40\nKPX Kcommaaccent ohungarumlaut -40\nKPX Kcommaaccent omacron -40\nKPX Kcommaaccent oslash -40\nKPX Kcommaaccent otilde -40\nKPX Kcommaaccent u -30\nKPX Kcommaaccent uacute -30\nKPX Kcommaaccent ucircumflex -30\nKPX Kcommaaccent udieresis -30\nKPX Kcommaaccent ugrave -30\nKPX Kcommaaccent uhungarumlaut -30\nKPX Kcommaaccent umacron -30\nKPX Kcommaaccent uogonek -30\nKPX Kcommaaccent uring -30\nKPX Kcommaaccent y -50\nKPX Kcommaaccent yacute -50\nKPX Kcommaaccent ydieresis -50\nKPX L T -110\nKPX L Tcaron -110\nKPX L Tcommaaccent -110\nKPX L V -110\nKPX L W -70\nKPX L Y -140\nKPX L Yacute -140\nKPX L Ydieresis -140\nKPX L quotedblright -140\nKPX L quoteright -160\nKPX L y -30\nKPX L yacute -30\nKPX L ydieresis -30\nKPX Lacute T -110\nKPX Lacute Tcaron -110\nKPX Lacute Tcommaaccent -110\nKPX Lacute V -110\nKPX Lacute W -70\nKPX Lacute Y -140\nKPX Lacute Yacute -140\nKPX Lacute Ydieresis -140\nKPX Lacute quotedblright -140\nKPX Lacute quoteright -160\nKPX Lacute y -30\nKPX Lacute yacute -30\nKPX Lacute ydieresis -30\nKPX Lcaron T -110\nKPX Lcaron Tcaron -110\nKPX Lcaron Tcommaaccent -110\nKPX Lcaron V -110\nKPX Lcaron W -70\nKPX Lcaron Y -140\nKPX Lcaron Yacute -140\nKPX Lcaron Ydieresis -140\nKPX Lcaron quotedblright -140\nKPX Lcaron quoteright -160\nKPX Lcaron y -30\nKPX Lcaron yacute -30\nKPX Lcaron ydieresis -30\nKPX Lcommaaccent T -110\nKPX Lcommaaccent Tcaron -110\nKPX Lcommaaccent Tcommaaccent -110\nKPX Lcommaaccent V -110\nKPX Lcommaaccent W -70\nKPX Lcommaaccent Y -140\nKPX Lcommaaccent Yacute -140\nKPX Lcommaaccent Ydieresis -140\nKPX Lcommaaccent quotedblright -140\nKPX Lcommaaccent quoteright -160\nKPX Lcommaaccent y -30\nKPX Lcommaaccent yacute -30\nKPX Lcommaaccent ydieresis -30\nKPX Lslash T -110\nKPX Lslash Tcaron -110\nKPX Lslash Tcommaaccent -110\nKPX Lslash V -110\nKPX Lslash W -70\nKPX Lslash Y -140\nKPX Lslash Yacute -140\nKPX Lslash Ydieresis -140\nKPX Lslash quotedblright -140\nKPX Lslash quoteright -160\nKPX Lslash y -30\nKPX Lslash yacute -30\nKPX Lslash ydieresis -30\nKPX O A -20\nKPX O Aacute -20\nKPX O Abreve -20\nKPX O Acircumflex -20\nKPX O Adieresis -20\nKPX O Agrave -20\nKPX O Amacron -20\nKPX O Aogonek -20\nKPX O Aring -20\nKPX O Atilde -20\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -30\nKPX O X -60\nKPX O Y -70\nKPX O Yacute -70\nKPX O Ydieresis -70\nKPX O comma -40\nKPX O period -40\nKPX Oacute A -20\nKPX Oacute Aacute -20\nKPX Oacute Abreve -20\nKPX Oacute Acircumflex -20\nKPX Oacute Adieresis -20\nKPX Oacute Agrave -20\nKPX Oacute Amacron -20\nKPX Oacute Aogonek -20\nKPX Oacute Aring -20\nKPX Oacute Atilde -20\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -30\nKPX Oacute X -60\nKPX Oacute Y -70\nKPX Oacute Yacute -70\nKPX Oacute Ydieresis -70\nKPX Oacute comma -40\nKPX Oacute period -40\nKPX Ocircumflex A -20\nKPX Ocircumflex Aacute -20\nKPX Ocircumflex Abreve -20\nKPX Ocircumflex Acircumflex -20\nKPX Ocircumflex Adieresis -20\nKPX Ocircumflex Agrave -20\nKPX Ocircumflex Amacron -20\nKPX Ocircumflex Aogonek -20\nKPX Ocircumflex Aring -20\nKPX Ocircumflex Atilde -20\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -30\nKPX Ocircumflex X -60\nKPX Ocircumflex Y -70\nKPX Ocircumflex Yacute -70\nKPX Ocircumflex Ydieresis -70\nKPX Ocircumflex comma -40\nKPX Ocircumflex period -40\nKPX Odieresis A -20\nKPX Odieresis Aacute -20\nKPX Odieresis Abreve -20\nKPX Odieresis Acircumflex -20\nKPX Odieresis Adieresis -20\nKPX Odieresis Agrave -20\nKPX Odieresis Amacron -20\nKPX Odieresis Aogonek -20\nKPX Odieresis Aring -20\nKPX Odieresis Atilde -20\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -30\nKPX Odieresis X -60\nKPX Odieresis Y -70\nKPX Odieresis Yacute -70\nKPX Odieresis Ydieresis -70\nKPX Odieresis comma -40\nKPX Odieresis period -40\nKPX Ograve A -20\nKPX Ograve Aacute -20\nKPX Ograve Abreve -20\nKPX Ograve Acircumflex -20\nKPX Ograve Adieresis -20\nKPX Ograve Agrave -20\nKPX Ograve Amacron -20\nKPX Ograve Aogonek -20\nKPX Ograve Aring -20\nKPX Ograve Atilde -20\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -30\nKPX Ograve X -60\nKPX Ograve Y -70\nKPX Ograve Yacute -70\nKPX Ograve Ydieresis -70\nKPX Ograve comma -40\nKPX Ograve period -40\nKPX Ohungarumlaut A -20\nKPX Ohungarumlaut Aacute -20\nKPX Ohungarumlaut Abreve -20\nKPX Ohungarumlaut Acircumflex -20\nKPX Ohungarumlaut Adieresis -20\nKPX Ohungarumlaut Agrave -20\nKPX Ohungarumlaut Amacron -20\nKPX Ohungarumlaut Aogonek -20\nKPX Ohungarumlaut Aring -20\nKPX Ohungarumlaut Atilde -20\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -30\nKPX Ohungarumlaut X -60\nKPX Ohungarumlaut Y -70\nKPX Ohungarumlaut Yacute -70\nKPX Ohungarumlaut Ydieresis -70\nKPX Ohungarumlaut comma -40\nKPX Ohungarumlaut period -40\nKPX Omacron A -20\nKPX Omacron Aacute -20\nKPX Omacron Abreve -20\nKPX Omacron Acircumflex -20\nKPX Omacron Adieresis -20\nKPX Omacron Agrave -20\nKPX Omacron Amacron -20\nKPX Omacron Aogonek -20\nKPX Omacron Aring -20\nKPX Omacron Atilde -20\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -30\nKPX Omacron X -60\nKPX Omacron Y -70\nKPX Omacron Yacute -70\nKPX Omacron Ydieresis -70\nKPX Omacron comma -40\nKPX Omacron period -40\nKPX Oslash A -20\nKPX Oslash Aacute -20\nKPX Oslash Abreve -20\nKPX Oslash Acircumflex -20\nKPX Oslash Adieresis -20\nKPX Oslash Agrave -20\nKPX Oslash Amacron -20\nKPX Oslash Aogonek -20\nKPX Oslash Aring -20\nKPX Oslash Atilde -20\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -30\nKPX Oslash X -60\nKPX Oslash Y -70\nKPX Oslash Yacute -70\nKPX Oslash Ydieresis -70\nKPX Oslash comma -40\nKPX Oslash period -40\nKPX Otilde A -20\nKPX Otilde Aacute -20\nKPX Otilde Abreve -20\nKPX Otilde Acircumflex -20\nKPX Otilde Adieresis -20\nKPX Otilde Agrave -20\nKPX Otilde Amacron -20\nKPX Otilde Aogonek -20\nKPX Otilde Aring -20\nKPX Otilde Atilde -20\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -30\nKPX Otilde X -60\nKPX Otilde Y -70\nKPX Otilde Yacute -70\nKPX Otilde Ydieresis -70\nKPX Otilde comma -40\nKPX Otilde period -40\nKPX P A -120\nKPX P Aacute -120\nKPX P Abreve -120\nKPX P Acircumflex -120\nKPX P Adieresis -120\nKPX P Agrave -120\nKPX P Amacron -120\nKPX P Aogonek -120\nKPX P Aring -120\nKPX P Atilde -120\nKPX P a -40\nKPX P aacute -40\nKPX P abreve -40\nKPX P acircumflex -40\nKPX P adieresis -40\nKPX P agrave -40\nKPX P amacron -40\nKPX P aogonek -40\nKPX P aring -40\nKPX P atilde -40\nKPX P comma -180\nKPX P e -50\nKPX P eacute -50\nKPX P ecaron -50\nKPX P ecircumflex -50\nKPX P edieresis -50\nKPX P edotaccent -50\nKPX P egrave -50\nKPX P emacron -50\nKPX P eogonek -50\nKPX P o -50\nKPX P oacute -50\nKPX P ocircumflex -50\nKPX P odieresis -50\nKPX P ograve -50\nKPX P ohungarumlaut -50\nKPX P omacron -50\nKPX P oslash -50\nKPX P otilde -50\nKPX P period -180\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX R O -20\nKPX R Oacute -20\nKPX R Ocircumflex -20\nKPX R Odieresis -20\nKPX R Ograve -20\nKPX R Ohungarumlaut -20\nKPX R Omacron -20\nKPX R Oslash -20\nKPX R Otilde -20\nKPX R T -30\nKPX R Tcaron -30\nKPX R Tcommaaccent -30\nKPX R U -40\nKPX R Uacute -40\nKPX R Ucircumflex -40\nKPX R Udieresis -40\nKPX R Ugrave -40\nKPX R Uhungarumlaut -40\nKPX R Umacron -40\nKPX R Uogonek -40\nKPX R Uring -40\nKPX R V -50\nKPX R W -30\nKPX R Y -50\nKPX R Yacute -50\nKPX R Ydieresis -50\nKPX Racute O -20\nKPX Racute Oacute -20\nKPX Racute Ocircumflex -20\nKPX Racute Odieresis -20\nKPX Racute Ograve -20\nKPX Racute Ohungarumlaut -20\nKPX Racute Omacron -20\nKPX Racute Oslash -20\nKPX Racute Otilde -20\nKPX Racute T -30\nKPX Racute Tcaron -30\nKPX Racute Tcommaaccent -30\nKPX Racute U -40\nKPX Racute Uacute -40\nKPX Racute Ucircumflex -40\nKPX Racute Udieresis -40\nKPX Racute Ugrave -40\nKPX Racute Uhungarumlaut -40\nKPX Racute Umacron -40\nKPX Racute Uogonek -40\nKPX Racute Uring -40\nKPX Racute V -50\nKPX Racute W -30\nKPX Racute Y -50\nKPX Racute Yacute -50\nKPX Racute Ydieresis -50\nKPX Rcaron O -20\nKPX Rcaron Oacute -20\nKPX Rcaron Ocircumflex -20\nKPX Rcaron Odieresis -20\nKPX Rcaron Ograve -20\nKPX Rcaron Ohungarumlaut -20\nKPX Rcaron Omacron -20\nKPX Rcaron Oslash -20\nKPX Rcaron Otilde -20\nKPX Rcaron T -30\nKPX Rcaron Tcaron -30\nKPX Rcaron Tcommaaccent -30\nKPX Rcaron U -40\nKPX Rcaron Uacute -40\nKPX Rcaron Ucircumflex -40\nKPX Rcaron Udieresis -40\nKPX Rcaron Ugrave -40\nKPX Rcaron Uhungarumlaut -40\nKPX Rcaron Umacron -40\nKPX Rcaron Uogonek -40\nKPX Rcaron Uring -40\nKPX Rcaron V -50\nKPX Rcaron W -30\nKPX Rcaron Y -50\nKPX Rcaron Yacute -50\nKPX Rcaron Ydieresis -50\nKPX Rcommaaccent O -20\nKPX Rcommaaccent Oacute -20\nKPX Rcommaaccent Ocircumflex -20\nKPX Rcommaaccent Odieresis -20\nKPX Rcommaaccent Ograve -20\nKPX Rcommaaccent Ohungarumlaut -20\nKPX Rcommaaccent Omacron -20\nKPX Rcommaaccent Oslash -20\nKPX Rcommaaccent Otilde -20\nKPX Rcommaaccent T -30\nKPX Rcommaaccent Tcaron -30\nKPX Rcommaaccent Tcommaaccent -30\nKPX Rcommaaccent U -40\nKPX Rcommaaccent Uacute -40\nKPX Rcommaaccent Ucircumflex -40\nKPX Rcommaaccent Udieresis -40\nKPX Rcommaaccent Ugrave -40\nKPX Rcommaaccent Uhungarumlaut -40\nKPX Rcommaaccent Umacron -40\nKPX Rcommaaccent Uogonek -40\nKPX Rcommaaccent Uring -40\nKPX Rcommaaccent V -50\nKPX Rcommaaccent W -30\nKPX Rcommaaccent Y -50\nKPX Rcommaaccent Yacute -50\nKPX Rcommaaccent Ydieresis -50\nKPX S comma -20\nKPX S period -20\nKPX Sacute comma -20\nKPX Sacute period -20\nKPX Scaron comma -20\nKPX Scaron period -20\nKPX Scedilla comma -20\nKPX Scedilla period -20\nKPX Scommaaccent comma -20\nKPX Scommaaccent period -20\nKPX T A -120\nKPX T Aacute -120\nKPX T Abreve -120\nKPX T Acircumflex -120\nKPX T Adieresis -120\nKPX T Agrave -120\nKPX T Amacron -120\nKPX T Aogonek -120\nKPX T Aring -120\nKPX T Atilde -120\nKPX T O -40\nKPX T Oacute -40\nKPX T Ocircumflex -40\nKPX T Odieresis -40\nKPX T Ograve -40\nKPX T Ohungarumlaut -40\nKPX T Omacron -40\nKPX T Oslash -40\nKPX T Otilde -40\nKPX T a -120\nKPX T aacute -120\nKPX T abreve -60\nKPX T acircumflex -120\nKPX T adieresis -120\nKPX T agrave -120\nKPX T amacron -60\nKPX T aogonek -120\nKPX T aring -120\nKPX T atilde -60\nKPX T colon -20\nKPX T comma -120\nKPX T e -120\nKPX T eacute -120\nKPX T ecaron -120\nKPX T ecircumflex -120\nKPX T edieresis -120\nKPX T edotaccent -120\nKPX T egrave -60\nKPX T emacron -60\nKPX T eogonek -120\nKPX T hyphen -140\nKPX T o -120\nKPX T oacute -120\nKPX T ocircumflex -120\nKPX T odieresis -120\nKPX T ograve -120\nKPX T ohungarumlaut -120\nKPX T omacron -60\nKPX T oslash -120\nKPX T otilde -60\nKPX T period -120\nKPX T r -120\nKPX T racute -120\nKPX T rcaron -120\nKPX T rcommaaccent -120\nKPX T semicolon -20\nKPX T u -120\nKPX T uacute -120\nKPX T ucircumflex -120\nKPX T udieresis -120\nKPX T ugrave -120\nKPX T uhungarumlaut -120\nKPX T umacron -60\nKPX T uogonek -120\nKPX T uring -120\nKPX T w -120\nKPX T y -120\nKPX T yacute -120\nKPX T ydieresis -60\nKPX Tcaron A -120\nKPX Tcaron Aacute -120\nKPX Tcaron Abreve -120\nKPX Tcaron Acircumflex -120\nKPX Tcaron Adieresis -120\nKPX Tcaron Agrave -120\nKPX Tcaron Amacron -120\nKPX Tcaron Aogonek -120\nKPX Tcaron Aring -120\nKPX Tcaron Atilde -120\nKPX Tcaron O -40\nKPX Tcaron Oacute -40\nKPX Tcaron Ocircumflex -40\nKPX Tcaron Odieresis -40\nKPX Tcaron Ograve -40\nKPX Tcaron Ohungarumlaut -40\nKPX Tcaron Omacron -40\nKPX Tcaron Oslash -40\nKPX Tcaron Otilde -40\nKPX Tcaron a -120\nKPX Tcaron aacute -120\nKPX Tcaron abreve -60\nKPX Tcaron acircumflex -120\nKPX Tcaron adieresis -120\nKPX Tcaron agrave -120\nKPX Tcaron amacron -60\nKPX Tcaron aogonek -120\nKPX Tcaron aring -120\nKPX Tcaron atilde -60\nKPX Tcaron colon -20\nKPX Tcaron comma -120\nKPX Tcaron e -120\nKPX Tcaron eacute -120\nKPX Tcaron ecaron -120\nKPX Tcaron ecircumflex -120\nKPX Tcaron edieresis -120\nKPX Tcaron edotaccent -120\nKPX Tcaron egrave -60\nKPX Tcaron emacron -60\nKPX Tcaron eogonek -120\nKPX Tcaron hyphen -140\nKPX Tcaron o -120\nKPX Tcaron oacute -120\nKPX Tcaron ocircumflex -120\nKPX Tcaron odieresis -120\nKPX Tcaron ograve -120\nKPX Tcaron ohungarumlaut -120\nKPX Tcaron omacron -60\nKPX Tcaron oslash -120\nKPX Tcaron otilde -60\nKPX Tcaron period -120\nKPX Tcaron r -120\nKPX Tcaron racute -120\nKPX Tcaron rcaron -120\nKPX Tcaron rcommaaccent -120\nKPX Tcaron semicolon -20\nKPX Tcaron u -120\nKPX Tcaron uacute -120\nKPX Tcaron ucircumflex -120\nKPX Tcaron udieresis -120\nKPX Tcaron ugrave -120\nKPX Tcaron uhungarumlaut -120\nKPX Tcaron umacron -60\nKPX Tcaron uogonek -120\nKPX Tcaron uring -120\nKPX Tcaron w -120\nKPX Tcaron y -120\nKPX Tcaron yacute -120\nKPX Tcaron ydieresis -60\nKPX Tcommaaccent A -120\nKPX Tcommaaccent Aacute -120\nKPX Tcommaaccent Abreve -120\nKPX Tcommaaccent Acircumflex -120\nKPX Tcommaaccent Adieresis -120\nKPX Tcommaaccent Agrave -120\nKPX Tcommaaccent Amacron -120\nKPX Tcommaaccent Aogonek -120\nKPX Tcommaaccent Aring -120\nKPX Tcommaaccent Atilde -120\nKPX Tcommaaccent O -40\nKPX Tcommaaccent Oacute -40\nKPX Tcommaaccent Ocircumflex -40\nKPX Tcommaaccent Odieresis -40\nKPX Tcommaaccent Ograve -40\nKPX Tcommaaccent Ohungarumlaut -40\nKPX Tcommaaccent Omacron -40\nKPX Tcommaaccent Oslash -40\nKPX Tcommaaccent Otilde -40\nKPX Tcommaaccent a -120\nKPX Tcommaaccent aacute -120\nKPX Tcommaaccent abreve -60\nKPX Tcommaaccent acircumflex -120\nKPX Tcommaaccent adieresis -120\nKPX Tcommaaccent agrave -120\nKPX Tcommaaccent amacron -60\nKPX Tcommaaccent aogonek -120\nKPX Tcommaaccent aring -120\nKPX Tcommaaccent atilde -60\nKPX Tcommaaccent colon -20\nKPX Tcommaaccent comma -120\nKPX Tcommaaccent e -120\nKPX Tcommaaccent eacute -120\nKPX Tcommaaccent ecaron -120\nKPX Tcommaaccent ecircumflex -120\nKPX Tcommaaccent edieresis -120\nKPX Tcommaaccent edotaccent -120\nKPX Tcommaaccent egrave -60\nKPX Tcommaaccent emacron -60\nKPX Tcommaaccent eogonek -120\nKPX Tcommaaccent hyphen -140\nKPX Tcommaaccent o -120\nKPX Tcommaaccent oacute -120\nKPX Tcommaaccent ocircumflex -120\nKPX Tcommaaccent odieresis -120\nKPX Tcommaaccent ograve -120\nKPX Tcommaaccent ohungarumlaut -120\nKPX Tcommaaccent omacron -60\nKPX Tcommaaccent oslash -120\nKPX Tcommaaccent otilde -60\nKPX Tcommaaccent period -120\nKPX Tcommaaccent r -120\nKPX Tcommaaccent racute -120\nKPX Tcommaaccent rcaron -120\nKPX Tcommaaccent rcommaaccent -120\nKPX Tcommaaccent semicolon -20\nKPX Tcommaaccent u -120\nKPX Tcommaaccent uacute -120\nKPX Tcommaaccent ucircumflex -120\nKPX Tcommaaccent udieresis -120\nKPX Tcommaaccent ugrave -120\nKPX Tcommaaccent uhungarumlaut -120\nKPX Tcommaaccent umacron -60\nKPX Tcommaaccent uogonek -120\nKPX Tcommaaccent uring -120\nKPX Tcommaaccent w -120\nKPX Tcommaaccent y -120\nKPX Tcommaaccent yacute -120\nKPX Tcommaaccent ydieresis -60\nKPX U A -40\nKPX U Aacute -40\nKPX U Abreve -40\nKPX U Acircumflex -40\nKPX U Adieresis -40\nKPX U Agrave -40\nKPX U Amacron -40\nKPX U Aogonek -40\nKPX U Aring -40\nKPX U Atilde -40\nKPX U comma -40\nKPX U period -40\nKPX Uacute A -40\nKPX Uacute Aacute -40\nKPX Uacute Abreve -40\nKPX Uacute Acircumflex -40\nKPX Uacute Adieresis -40\nKPX Uacute Agrave -40\nKPX Uacute Amacron -40\nKPX Uacute Aogonek -40\nKPX Uacute Aring -40\nKPX Uacute Atilde -40\nKPX Uacute comma -40\nKPX Uacute period -40\nKPX Ucircumflex A -40\nKPX Ucircumflex Aacute -40\nKPX Ucircumflex Abreve -40\nKPX Ucircumflex Acircumflex -40\nKPX Ucircumflex Adieresis -40\nKPX Ucircumflex Agrave -40\nKPX Ucircumflex Amacron -40\nKPX Ucircumflex Aogonek -40\nKPX Ucircumflex Aring -40\nKPX Ucircumflex Atilde -40\nKPX Ucircumflex comma -40\nKPX Ucircumflex period -40\nKPX Udieresis A -40\nKPX Udieresis Aacute -40\nKPX Udieresis Abreve -40\nKPX Udieresis Acircumflex -40\nKPX Udieresis Adieresis -40\nKPX Udieresis Agrave -40\nKPX Udieresis Amacron -40\nKPX Udieresis Aogonek -40\nKPX Udieresis Aring -40\nKPX Udieresis Atilde -40\nKPX Udieresis comma -40\nKPX Udieresis period -40\nKPX Ugrave A -40\nKPX Ugrave Aacute -40\nKPX Ugrave Abreve -40\nKPX Ugrave Acircumflex -40\nKPX Ugrave Adieresis -40\nKPX Ugrave Agrave -40\nKPX Ugrave Amacron -40\nKPX Ugrave Aogonek -40\nKPX Ugrave Aring -40\nKPX Ugrave Atilde -40\nKPX Ugrave comma -40\nKPX Ugrave period -40\nKPX Uhungarumlaut A -40\nKPX Uhungarumlaut Aacute -40\nKPX Uhungarumlaut Abreve -40\nKPX Uhungarumlaut Acircumflex -40\nKPX Uhungarumlaut Adieresis -40\nKPX Uhungarumlaut Agrave -40\nKPX Uhungarumlaut Amacron -40\nKPX Uhungarumlaut Aogonek -40\nKPX Uhungarumlaut Aring -40\nKPX Uhungarumlaut Atilde -40\nKPX Uhungarumlaut comma -40\nKPX Uhungarumlaut period -40\nKPX Umacron A -40\nKPX Umacron Aacute -40\nKPX Umacron Abreve -40\nKPX Umacron Acircumflex -40\nKPX Umacron Adieresis -40\nKPX Umacron Agrave -40\nKPX Umacron Amacron -40\nKPX Umacron Aogonek -40\nKPX Umacron Aring -40\nKPX Umacron Atilde -40\nKPX Umacron comma -40\nKPX Umacron period -40\nKPX Uogonek A -40\nKPX Uogonek Aacute -40\nKPX Uogonek Abreve -40\nKPX Uogonek Acircumflex -40\nKPX Uogonek Adieresis -40\nKPX Uogonek Agrave -40\nKPX Uogonek Amacron -40\nKPX Uogonek Aogonek -40\nKPX Uogonek Aring -40\nKPX Uogonek Atilde -40\nKPX Uogonek comma -40\nKPX Uogonek period -40\nKPX Uring A -40\nKPX Uring Aacute -40\nKPX Uring Abreve -40\nKPX Uring Acircumflex -40\nKPX Uring Adieresis -40\nKPX Uring Agrave -40\nKPX Uring Amacron -40\nKPX Uring Aogonek -40\nKPX Uring Aring -40\nKPX Uring Atilde -40\nKPX Uring comma -40\nKPX Uring period -40\nKPX V A -80\nKPX V Aacute -80\nKPX V Abreve -80\nKPX V Acircumflex -80\nKPX V Adieresis -80\nKPX V Agrave -80\nKPX V Amacron -80\nKPX V Aogonek -80\nKPX V Aring -80\nKPX V Atilde -80\nKPX V G -40\nKPX V Gbreve -40\nKPX V Gcommaaccent -40\nKPX V O -40\nKPX V Oacute -40\nKPX V Ocircumflex -40\nKPX V Odieresis -40\nKPX V Ograve -40\nKPX V Ohungarumlaut -40\nKPX V Omacron -40\nKPX V Oslash -40\nKPX V Otilde -40\nKPX V a -70\nKPX V aacute -70\nKPX V abreve -70\nKPX V acircumflex -70\nKPX V adieresis -70\nKPX V agrave -70\nKPX V amacron -70\nKPX V aogonek -70\nKPX V aring -70\nKPX V atilde -70\nKPX V colon -40\nKPX V comma -125\nKPX V e -80\nKPX V eacute -80\nKPX V ecaron -80\nKPX V ecircumflex -80\nKPX V edieresis -80\nKPX V edotaccent -80\nKPX V egrave -80\nKPX V emacron -80\nKPX V eogonek -80\nKPX V hyphen -80\nKPX V o -80\nKPX V oacute -80\nKPX V ocircumflex -80\nKPX V odieresis -80\nKPX V ograve -80\nKPX V ohungarumlaut -80\nKPX V omacron -80\nKPX V oslash -80\nKPX V otilde -80\nKPX V period -125\nKPX V semicolon -40\nKPX V u -70\nKPX V uacute -70\nKPX V ucircumflex -70\nKPX V udieresis -70\nKPX V ugrave -70\nKPX V uhungarumlaut -70\nKPX V umacron -70\nKPX V uogonek -70\nKPX V uring -70\nKPX W A -50\nKPX W Aacute -50\nKPX W Abreve -50\nKPX W Acircumflex -50\nKPX W Adieresis -50\nKPX W Agrave -50\nKPX W Amacron -50\nKPX W Aogonek -50\nKPX W Aring -50\nKPX W Atilde -50\nKPX W O -20\nKPX W Oacute -20\nKPX W Ocircumflex -20\nKPX W Odieresis -20\nKPX W Ograve -20\nKPX W Ohungarumlaut -20\nKPX W Omacron -20\nKPX W Oslash -20\nKPX W Otilde -20\nKPX W a -40\nKPX W aacute -40\nKPX W abreve -40\nKPX W acircumflex -40\nKPX W adieresis -40\nKPX W agrave -40\nKPX W amacron -40\nKPX W aogonek -40\nKPX W aring -40\nKPX W atilde -40\nKPX W comma -80\nKPX W e -30\nKPX W eacute -30\nKPX W ecaron -30\nKPX W ecircumflex -30\nKPX W edieresis -30\nKPX W edotaccent -30\nKPX W egrave -30\nKPX W emacron -30\nKPX W eogonek -30\nKPX W hyphen -40\nKPX W o -30\nKPX W oacute -30\nKPX W ocircumflex -30\nKPX W odieresis -30\nKPX W ograve -30\nKPX W ohungarumlaut -30\nKPX W omacron -30\nKPX W oslash -30\nKPX W otilde -30\nKPX W period -80\nKPX W u -30\nKPX W uacute -30\nKPX W ucircumflex -30\nKPX W udieresis -30\nKPX W ugrave -30\nKPX W uhungarumlaut -30\nKPX W umacron -30\nKPX W uogonek -30\nKPX W uring -30\nKPX W y -20\nKPX W yacute -20\nKPX W ydieresis -20\nKPX Y A -110\nKPX Y Aacute -110\nKPX Y Abreve -110\nKPX Y Acircumflex -110\nKPX Y Adieresis -110\nKPX Y Agrave -110\nKPX Y Amacron -110\nKPX Y Aogonek -110\nKPX Y Aring -110\nKPX Y Atilde -110\nKPX Y O -85\nKPX Y Oacute -85\nKPX Y Ocircumflex -85\nKPX Y Odieresis -85\nKPX Y Ograve -85\nKPX Y Ohungarumlaut -85\nKPX Y Omacron -85\nKPX Y Oslash -85\nKPX Y Otilde -85\nKPX Y a -140\nKPX Y aacute -140\nKPX Y abreve -70\nKPX Y acircumflex -140\nKPX Y adieresis -140\nKPX Y agrave -140\nKPX Y amacron -70\nKPX Y aogonek -140\nKPX Y aring -140\nKPX Y atilde -140\nKPX Y colon -60\nKPX Y comma -140\nKPX Y e -140\nKPX Y eacute -140\nKPX Y ecaron -140\nKPX Y ecircumflex -140\nKPX Y edieresis -140\nKPX Y edotaccent -140\nKPX Y egrave -140\nKPX Y emacron -70\nKPX Y eogonek -140\nKPX Y hyphen -140\nKPX Y i -20\nKPX Y iacute -20\nKPX Y iogonek -20\nKPX Y o -140\nKPX Y oacute -140\nKPX Y ocircumflex -140\nKPX Y odieresis -140\nKPX Y ograve -140\nKPX Y ohungarumlaut -140\nKPX Y omacron -140\nKPX Y oslash -140\nKPX Y otilde -140\nKPX Y period -140\nKPX Y semicolon -60\nKPX Y u -110\nKPX Y uacute -110\nKPX Y ucircumflex -110\nKPX Y udieresis -110\nKPX Y ugrave -110\nKPX Y uhungarumlaut -110\nKPX Y umacron -110\nKPX Y uogonek -110\nKPX Y uring -110\nKPX Yacute A -110\nKPX Yacute Aacute -110\nKPX Yacute Abreve -110\nKPX Yacute Acircumflex -110\nKPX Yacute Adieresis -110\nKPX Yacute Agrave -110\nKPX Yacute Amacron -110\nKPX Yacute Aogonek -110\nKPX Yacute Aring -110\nKPX Yacute Atilde -110\nKPX Yacute O -85\nKPX Yacute Oacute -85\nKPX Yacute Ocircumflex -85\nKPX Yacute Odieresis -85\nKPX Yacute Ograve -85\nKPX Yacute Ohungarumlaut -85\nKPX Yacute Omacron -85\nKPX Yacute Oslash -85\nKPX Yacute Otilde -85\nKPX Yacute a -140\nKPX Yacute aacute -140\nKPX Yacute abreve -70\nKPX Yacute acircumflex -140\nKPX Yacute adieresis -140\nKPX Yacute agrave -140\nKPX Yacute amacron -70\nKPX Yacute aogonek -140\nKPX Yacute aring -140\nKPX Yacute atilde -70\nKPX Yacute colon -60\nKPX Yacute comma -140\nKPX Yacute e -140\nKPX Yacute eacute -140\nKPX Yacute ecaron -140\nKPX Yacute ecircumflex -140\nKPX Yacute edieresis -140\nKPX Yacute edotaccent -140\nKPX Yacute egrave -140\nKPX Yacute emacron -70\nKPX Yacute eogonek -140\nKPX Yacute hyphen -140\nKPX Yacute i -20\nKPX Yacute iacute -20\nKPX Yacute iogonek -20\nKPX Yacute o -140\nKPX Yacute oacute -140\nKPX Yacute ocircumflex -140\nKPX Yacute odieresis -140\nKPX Yacute ograve -140\nKPX Yacute ohungarumlaut -140\nKPX Yacute omacron -70\nKPX Yacute oslash -140\nKPX Yacute otilde -140\nKPX Yacute period -140\nKPX Yacute semicolon -60\nKPX Yacute u -110\nKPX Yacute uacute -110\nKPX Yacute ucircumflex -110\nKPX Yacute udieresis -110\nKPX Yacute ugrave -110\nKPX Yacute uhungarumlaut -110\nKPX Yacute umacron -110\nKPX Yacute uogonek -110\nKPX Yacute uring -110\nKPX Ydieresis A -110\nKPX Ydieresis Aacute -110\nKPX Ydieresis Abreve -110\nKPX Ydieresis Acircumflex -110\nKPX Ydieresis Adieresis -110\nKPX Ydieresis Agrave -110\nKPX Ydieresis Amacron -110\nKPX Ydieresis Aogonek -110\nKPX Ydieresis Aring -110\nKPX Ydieresis Atilde -110\nKPX Ydieresis O -85\nKPX Ydieresis Oacute -85\nKPX Ydieresis Ocircumflex -85\nKPX Ydieresis Odieresis -85\nKPX Ydieresis Ograve -85\nKPX Ydieresis Ohungarumlaut -85\nKPX Ydieresis Omacron -85\nKPX Ydieresis Oslash -85\nKPX Ydieresis Otilde -85\nKPX Ydieresis a -140\nKPX Ydieresis aacute -140\nKPX Ydieresis abreve -70\nKPX Ydieresis acircumflex -140\nKPX Ydieresis adieresis -140\nKPX Ydieresis agrave -140\nKPX Ydieresis amacron -70\nKPX Ydieresis aogonek -140\nKPX Ydieresis aring -140\nKPX Ydieresis atilde -70\nKPX Ydieresis colon -60\nKPX Ydieresis comma -140\nKPX Ydieresis e -140\nKPX Ydieresis eacute -140\nKPX Ydieresis ecaron -140\nKPX Ydieresis ecircumflex -140\nKPX Ydieresis edieresis -140\nKPX Ydieresis edotaccent -140\nKPX Ydieresis egrave -140\nKPX Ydieresis emacron -70\nKPX Ydieresis eogonek -140\nKPX Ydieresis hyphen -140\nKPX Ydieresis i -20\nKPX Ydieresis iacute -20\nKPX Ydieresis iogonek -20\nKPX Ydieresis o -140\nKPX Ydieresis oacute -140\nKPX Ydieresis ocircumflex -140\nKPX Ydieresis odieresis -140\nKPX Ydieresis ograve -140\nKPX Ydieresis ohungarumlaut -140\nKPX Ydieresis omacron -140\nKPX Ydieresis oslash -140\nKPX Ydieresis otilde -140\nKPX Ydieresis period -140\nKPX Ydieresis semicolon -60\nKPX Ydieresis u -110\nKPX Ydieresis uacute -110\nKPX Ydieresis ucircumflex -110\nKPX Ydieresis udieresis -110\nKPX Ydieresis ugrave -110\nKPX Ydieresis uhungarumlaut -110\nKPX Ydieresis umacron -110\nKPX Ydieresis uogonek -110\nKPX Ydieresis uring -110\nKPX a v -20\nKPX a w -20\nKPX a y -30\nKPX a yacute -30\nKPX a ydieresis -30\nKPX aacute v -20\nKPX aacute w -20\nKPX aacute y -30\nKPX aacute yacute -30\nKPX aacute ydieresis -30\nKPX abreve v -20\nKPX abreve w -20\nKPX abreve y -30\nKPX abreve yacute -30\nKPX abreve ydieresis -30\nKPX acircumflex v -20\nKPX acircumflex w -20\nKPX acircumflex y -30\nKPX acircumflex yacute -30\nKPX acircumflex ydieresis -30\nKPX adieresis v -20\nKPX adieresis w -20\nKPX adieresis y -30\nKPX adieresis yacute -30\nKPX adieresis ydieresis -30\nKPX agrave v -20\nKPX agrave w -20\nKPX agrave y -30\nKPX agrave yacute -30\nKPX agrave ydieresis -30\nKPX amacron v -20\nKPX amacron w -20\nKPX amacron y -30\nKPX amacron yacute -30\nKPX amacron ydieresis -30\nKPX aogonek v -20\nKPX aogonek w -20\nKPX aogonek y -30\nKPX aogonek yacute -30\nKPX aogonek ydieresis -30\nKPX aring v -20\nKPX aring w -20\nKPX aring y -30\nKPX aring yacute -30\nKPX aring ydieresis -30\nKPX atilde v -20\nKPX atilde w -20\nKPX atilde y -30\nKPX atilde yacute -30\nKPX atilde ydieresis -30\nKPX b b -10\nKPX b comma -40\nKPX b l -20\nKPX b lacute -20\nKPX b lcommaaccent -20\nKPX b lslash -20\nKPX b period -40\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX b v -20\nKPX b y -20\nKPX b yacute -20\nKPX b ydieresis -20\nKPX c comma -15\nKPX c k -20\nKPX c kcommaaccent -20\nKPX cacute comma -15\nKPX cacute k -20\nKPX cacute kcommaaccent -20\nKPX ccaron comma -15\nKPX ccaron k -20\nKPX ccaron kcommaaccent -20\nKPX ccedilla comma -15\nKPX ccedilla k -20\nKPX ccedilla kcommaaccent -20\nKPX colon space -50\nKPX comma quotedblright -100\nKPX comma quoteright -100\nKPX e comma -15\nKPX e period -15\nKPX e v -30\nKPX e w -20\nKPX e x -30\nKPX e y -20\nKPX e yacute -20\nKPX e ydieresis -20\nKPX eacute comma -15\nKPX eacute period -15\nKPX eacute v -30\nKPX eacute w -20\nKPX eacute x -30\nKPX eacute y -20\nKPX eacute yacute -20\nKPX eacute ydieresis -20\nKPX ecaron comma -15\nKPX ecaron period -15\nKPX ecaron v -30\nKPX ecaron w -20\nKPX ecaron x -30\nKPX ecaron y -20\nKPX ecaron yacute -20\nKPX ecaron ydieresis -20\nKPX ecircumflex comma -15\nKPX ecircumflex period -15\nKPX ecircumflex v -30\nKPX ecircumflex w -20\nKPX ecircumflex x -30\nKPX ecircumflex y -20\nKPX ecircumflex yacute -20\nKPX ecircumflex ydieresis -20\nKPX edieresis comma -15\nKPX edieresis period -15\nKPX edieresis v -30\nKPX edieresis w -20\nKPX edieresis x -30\nKPX edieresis y -20\nKPX edieresis yacute -20\nKPX edieresis ydieresis -20\nKPX edotaccent comma -15\nKPX edotaccent period -15\nKPX edotaccent v -30\nKPX edotaccent w -20\nKPX edotaccent x -30\nKPX edotaccent y -20\nKPX edotaccent yacute -20\nKPX edotaccent ydieresis -20\nKPX egrave comma -15\nKPX egrave period -15\nKPX egrave v -30\nKPX egrave w -20\nKPX egrave x -30\nKPX egrave y -20\nKPX egrave yacute -20\nKPX egrave ydieresis -20\nKPX emacron comma -15\nKPX emacron period -15\nKPX emacron v -30\nKPX emacron w -20\nKPX emacron x -30\nKPX emacron y -20\nKPX emacron yacute -20\nKPX emacron ydieresis -20\nKPX eogonek comma -15\nKPX eogonek period -15\nKPX eogonek v -30\nKPX eogonek w -20\nKPX eogonek x -30\nKPX eogonek y -20\nKPX eogonek yacute -20\nKPX eogonek ydieresis -20\nKPX f a -30\nKPX f aacute -30\nKPX f abreve -30\nKPX f acircumflex -30\nKPX f adieresis -30\nKPX f agrave -30\nKPX f amacron -30\nKPX f aogonek -30\nKPX f aring -30\nKPX f atilde -30\nKPX f comma -30\nKPX f dotlessi -28\nKPX f e -30\nKPX f eacute -30\nKPX f ecaron -30\nKPX f ecircumflex -30\nKPX f edieresis -30\nKPX f edotaccent -30\nKPX f egrave -30\nKPX f emacron -30\nKPX f eogonek -30\nKPX f o -30\nKPX f oacute -30\nKPX f ocircumflex -30\nKPX f odieresis -30\nKPX f ograve -30\nKPX f ohungarumlaut -30\nKPX f omacron -30\nKPX f oslash -30\nKPX f otilde -30\nKPX f period -30\nKPX f quotedblright 60\nKPX f quoteright 50\nKPX g r -10\nKPX g racute -10\nKPX g rcaron -10\nKPX g rcommaaccent -10\nKPX gbreve r -10\nKPX gbreve racute -10\nKPX gbreve rcaron -10\nKPX gbreve rcommaaccent -10\nKPX gcommaaccent r -10\nKPX gcommaaccent racute -10\nKPX gcommaaccent rcaron -10\nKPX gcommaaccent rcommaaccent -10\nKPX h y -30\nKPX h yacute -30\nKPX h ydieresis -30\nKPX k e -20\nKPX k eacute -20\nKPX k ecaron -20\nKPX k ecircumflex -20\nKPX k edieresis -20\nKPX k edotaccent -20\nKPX k egrave -20\nKPX k emacron -20\nKPX k eogonek -20\nKPX k o -20\nKPX k oacute -20\nKPX k ocircumflex -20\nKPX k odieresis -20\nKPX k ograve -20\nKPX k ohungarumlaut -20\nKPX k omacron -20\nKPX k oslash -20\nKPX k otilde -20\nKPX kcommaaccent e -20\nKPX kcommaaccent eacute -20\nKPX kcommaaccent ecaron -20\nKPX kcommaaccent ecircumflex -20\nKPX kcommaaccent edieresis -20\nKPX kcommaaccent edotaccent -20\nKPX kcommaaccent egrave -20\nKPX kcommaaccent emacron -20\nKPX kcommaaccent eogonek -20\nKPX kcommaaccent o -20\nKPX kcommaaccent oacute -20\nKPX kcommaaccent ocircumflex -20\nKPX kcommaaccent odieresis -20\nKPX kcommaaccent ograve -20\nKPX kcommaaccent ohungarumlaut -20\nKPX kcommaaccent omacron -20\nKPX kcommaaccent oslash -20\nKPX kcommaaccent otilde -20\nKPX m u -10\nKPX m uacute -10\nKPX m ucircumflex -10\nKPX m udieresis -10\nKPX m ugrave -10\nKPX m uhungarumlaut -10\nKPX m umacron -10\nKPX m uogonek -10\nKPX m uring -10\nKPX m y -15\nKPX m yacute -15\nKPX m ydieresis -15\nKPX n u -10\nKPX n uacute -10\nKPX n ucircumflex -10\nKPX n udieresis -10\nKPX n ugrave -10\nKPX n uhungarumlaut -10\nKPX n umacron -10\nKPX n uogonek -10\nKPX n uring -10\nKPX n v -20\nKPX n y -15\nKPX n yacute -15\nKPX n ydieresis -15\nKPX nacute u -10\nKPX nacute uacute -10\nKPX nacute ucircumflex -10\nKPX nacute udieresis -10\nKPX nacute ugrave -10\nKPX nacute uhungarumlaut -10\nKPX nacute umacron -10\nKPX nacute uogonek -10\nKPX nacute uring -10\nKPX nacute v -20\nKPX nacute y -15\nKPX nacute yacute -15\nKPX nacute ydieresis -15\nKPX ncaron u -10\nKPX ncaron uacute -10\nKPX ncaron ucircumflex -10\nKPX ncaron udieresis -10\nKPX ncaron ugrave -10\nKPX ncaron uhungarumlaut -10\nKPX ncaron umacron -10\nKPX ncaron uogonek -10\nKPX ncaron uring -10\nKPX ncaron v -20\nKPX ncaron y -15\nKPX ncaron yacute -15\nKPX ncaron ydieresis -15\nKPX ncommaaccent u -10\nKPX ncommaaccent uacute -10\nKPX ncommaaccent ucircumflex -10\nKPX ncommaaccent udieresis -10\nKPX ncommaaccent ugrave -10\nKPX ncommaaccent uhungarumlaut -10\nKPX ncommaaccent umacron -10\nKPX ncommaaccent uogonek -10\nKPX ncommaaccent uring -10\nKPX ncommaaccent v -20\nKPX ncommaaccent y -15\nKPX ncommaaccent yacute -15\nKPX ncommaaccent ydieresis -15\nKPX ntilde u -10\nKPX ntilde uacute -10\nKPX ntilde ucircumflex -10\nKPX ntilde udieresis -10\nKPX ntilde ugrave -10\nKPX ntilde uhungarumlaut -10\nKPX ntilde umacron -10\nKPX ntilde uogonek -10\nKPX ntilde uring -10\nKPX ntilde v -20\nKPX ntilde y -15\nKPX ntilde yacute -15\nKPX ntilde ydieresis -15\nKPX o comma -40\nKPX o period -40\nKPX o v -15\nKPX o w -15\nKPX o x -30\nKPX o y -30\nKPX o yacute -30\nKPX o ydieresis -30\nKPX oacute comma -40\nKPX oacute period -40\nKPX oacute v -15\nKPX oacute w -15\nKPX oacute x -30\nKPX oacute y -30\nKPX oacute yacute -30\nKPX oacute ydieresis -30\nKPX ocircumflex comma -40\nKPX ocircumflex period -40\nKPX ocircumflex v -15\nKPX ocircumflex w -15\nKPX ocircumflex x -30\nKPX ocircumflex y -30\nKPX ocircumflex yacute -30\nKPX ocircumflex ydieresis -30\nKPX odieresis comma -40\nKPX odieresis period -40\nKPX odieresis v -15\nKPX odieresis w -15\nKPX odieresis x -30\nKPX odieresis y -30\nKPX odieresis yacute -30\nKPX odieresis ydieresis -30\nKPX ograve comma -40\nKPX ograve period -40\nKPX ograve v -15\nKPX ograve w -15\nKPX ograve x -30\nKPX ograve y -30\nKPX ograve yacute -30\nKPX ograve ydieresis -30\nKPX ohungarumlaut comma -40\nKPX ohungarumlaut period -40\nKPX ohungarumlaut v -15\nKPX ohungarumlaut w -15\nKPX ohungarumlaut x -30\nKPX ohungarumlaut y -30\nKPX ohungarumlaut yacute -30\nKPX ohungarumlaut ydieresis -30\nKPX omacron comma -40\nKPX omacron period -40\nKPX omacron v -15\nKPX omacron w -15\nKPX omacron x -30\nKPX omacron y -30\nKPX omacron yacute -30\nKPX omacron ydieresis -30\nKPX oslash a -55\nKPX oslash aacute -55\nKPX oslash abreve -55\nKPX oslash acircumflex -55\nKPX oslash adieresis -55\nKPX oslash agrave -55\nKPX oslash amacron -55\nKPX oslash aogonek -55\nKPX oslash aring -55\nKPX oslash atilde -55\nKPX oslash b -55\nKPX oslash c -55\nKPX oslash cacute -55\nKPX oslash ccaron -55\nKPX oslash ccedilla -55\nKPX oslash comma -95\nKPX oslash d -55\nKPX oslash dcroat -55\nKPX oslash e -55\nKPX oslash eacute -55\nKPX oslash ecaron -55\nKPX oslash ecircumflex -55\nKPX oslash edieresis -55\nKPX oslash edotaccent -55\nKPX oslash egrave -55\nKPX oslash emacron -55\nKPX oslash eogonek -55\nKPX oslash f -55\nKPX oslash g -55\nKPX oslash gbreve -55\nKPX oslash gcommaaccent -55\nKPX oslash h -55\nKPX oslash i -55\nKPX oslash iacute -55\nKPX oslash icircumflex -55\nKPX oslash idieresis -55\nKPX oslash igrave -55\nKPX oslash imacron -55\nKPX oslash iogonek -55\nKPX oslash j -55\nKPX oslash k -55\nKPX oslash kcommaaccent -55\nKPX oslash l -55\nKPX oslash lacute -55\nKPX oslash lcommaaccent -55\nKPX oslash lslash -55\nKPX oslash m -55\nKPX oslash n -55\nKPX oslash nacute -55\nKPX oslash ncaron -55\nKPX oslash ncommaaccent -55\nKPX oslash ntilde -55\nKPX oslash o -55\nKPX oslash oacute -55\nKPX oslash ocircumflex -55\nKPX oslash odieresis -55\nKPX oslash ograve -55\nKPX oslash ohungarumlaut -55\nKPX oslash omacron -55\nKPX oslash oslash -55\nKPX oslash otilde -55\nKPX oslash p -55\nKPX oslash period -95\nKPX oslash q -55\nKPX oslash r -55\nKPX oslash racute -55\nKPX oslash rcaron -55\nKPX oslash rcommaaccent -55\nKPX oslash s -55\nKPX oslash sacute -55\nKPX oslash scaron -55\nKPX oslash scedilla -55\nKPX oslash scommaaccent -55\nKPX oslash t -55\nKPX oslash tcommaaccent -55\nKPX oslash u -55\nKPX oslash uacute -55\nKPX oslash ucircumflex -55\nKPX oslash udieresis -55\nKPX oslash ugrave -55\nKPX oslash uhungarumlaut -55\nKPX oslash umacron -55\nKPX oslash uogonek -55\nKPX oslash uring -55\nKPX oslash v -70\nKPX oslash w -70\nKPX oslash x -85\nKPX oslash y -70\nKPX oslash yacute -70\nKPX oslash ydieresis -70\nKPX oslash z -55\nKPX oslash zacute -55\nKPX oslash zcaron -55\nKPX oslash zdotaccent -55\nKPX otilde comma -40\nKPX otilde period -40\nKPX otilde v -15\nKPX otilde w -15\nKPX otilde x -30\nKPX otilde y -30\nKPX otilde yacute -30\nKPX otilde ydieresis -30\nKPX p comma -35\nKPX p period -35\nKPX p y -30\nKPX p yacute -30\nKPX p ydieresis -30\nKPX period quotedblright -100\nKPX period quoteright -100\nKPX period space -60\nKPX quotedblright space -40\nKPX quoteleft quoteleft -57\nKPX quoteright d -50\nKPX quoteright dcroat -50\nKPX quoteright quoteright -57\nKPX quoteright r -50\nKPX quoteright racute -50\nKPX quoteright rcaron -50\nKPX quoteright rcommaaccent -50\nKPX quoteright s -50\nKPX quoteright sacute -50\nKPX quoteright scaron -50\nKPX quoteright scedilla -50\nKPX quoteright scommaaccent -50\nKPX quoteright space -70\nKPX r a -10\nKPX r aacute -10\nKPX r abreve -10\nKPX r acircumflex -10\nKPX r adieresis -10\nKPX r agrave -10\nKPX r amacron -10\nKPX r aogonek -10\nKPX r aring -10\nKPX r atilde -10\nKPX r colon 30\nKPX r comma -50\nKPX r i 15\nKPX r iacute 15\nKPX r icircumflex 15\nKPX r idieresis 15\nKPX r igrave 15\nKPX r imacron 15\nKPX r iogonek 15\nKPX r k 15\nKPX r kcommaaccent 15\nKPX r l 15\nKPX r lacute 15\nKPX r lcommaaccent 15\nKPX r lslash 15\nKPX r m 25\nKPX r n 25\nKPX r nacute 25\nKPX r ncaron 25\nKPX r ncommaaccent 25\nKPX r ntilde 25\nKPX r p 30\nKPX r period -50\nKPX r semicolon 30\nKPX r t 40\nKPX r tcommaaccent 40\nKPX r u 15\nKPX r uacute 15\nKPX r ucircumflex 15\nKPX r udieresis 15\nKPX r ugrave 15\nKPX r uhungarumlaut 15\nKPX r umacron 15\nKPX r uogonek 15\nKPX r uring 15\nKPX r v 30\nKPX r y 30\nKPX r yacute 30\nKPX r ydieresis 30\nKPX racute a -10\nKPX racute aacute -10\nKPX racute abreve -10\nKPX racute acircumflex -10\nKPX racute adieresis -10\nKPX racute agrave -10\nKPX racute amacron -10\nKPX racute aogonek -10\nKPX racute aring -10\nKPX racute atilde -10\nKPX racute colon 30\nKPX racute comma -50\nKPX racute i 15\nKPX racute iacute 15\nKPX racute icircumflex 15\nKPX racute idieresis 15\nKPX racute igrave 15\nKPX racute imacron 15\nKPX racute iogonek 15\nKPX racute k 15\nKPX racute kcommaaccent 15\nKPX racute l 15\nKPX racute lacute 15\nKPX racute lcommaaccent 15\nKPX racute lslash 15\nKPX racute m 25\nKPX racute n 25\nKPX racute nacute 25\nKPX racute ncaron 25\nKPX racute ncommaaccent 25\nKPX racute ntilde 25\nKPX racute p 30\nKPX racute period -50\nKPX racute semicolon 30\nKPX racute t 40\nKPX racute tcommaaccent 40\nKPX racute u 15\nKPX racute uacute 15\nKPX racute ucircumflex 15\nKPX racute udieresis 15\nKPX racute ugrave 15\nKPX racute uhungarumlaut 15\nKPX racute umacron 15\nKPX racute uogonek 15\nKPX racute uring 15\nKPX racute v 30\nKPX racute y 30\nKPX racute yacute 30\nKPX racute ydieresis 30\nKPX rcaron a -10\nKPX rcaron aacute -10\nKPX rcaron abreve -10\nKPX rcaron acircumflex -10\nKPX rcaron adieresis -10\nKPX rcaron agrave -10\nKPX rcaron amacron -10\nKPX rcaron aogonek -10\nKPX rcaron aring -10\nKPX rcaron atilde -10\nKPX rcaron colon 30\nKPX rcaron comma -50\nKPX rcaron i 15\nKPX rcaron iacute 15\nKPX rcaron icircumflex 15\nKPX rcaron idieresis 15\nKPX rcaron igrave 15\nKPX rcaron imacron 15\nKPX rcaron iogonek 15\nKPX rcaron k 15\nKPX rcaron kcommaaccent 15\nKPX rcaron l 15\nKPX rcaron lacute 15\nKPX rcaron lcommaaccent 15\nKPX rcaron lslash 15\nKPX rcaron m 25\nKPX rcaron n 25\nKPX rcaron nacute 25\nKPX rcaron ncaron 25\nKPX rcaron ncommaaccent 25\nKPX rcaron ntilde 25\nKPX rcaron p 30\nKPX rcaron period -50\nKPX rcaron semicolon 30\nKPX rcaron t 40\nKPX rcaron tcommaaccent 40\nKPX rcaron u 15\nKPX rcaron uacute 15\nKPX rcaron ucircumflex 15\nKPX rcaron udieresis 15\nKPX rcaron ugrave 15\nKPX rcaron uhungarumlaut 15\nKPX rcaron umacron 15\nKPX rcaron uogonek 15\nKPX rcaron uring 15\nKPX rcaron v 30\nKPX rcaron y 30\nKPX rcaron yacute 30\nKPX rcaron ydieresis 30\nKPX rcommaaccent a -10\nKPX rcommaaccent aacute -10\nKPX rcommaaccent abreve -10\nKPX rcommaaccent acircumflex -10\nKPX rcommaaccent adieresis -10\nKPX rcommaaccent agrave -10\nKPX rcommaaccent amacron -10\nKPX rcommaaccent aogonek -10\nKPX rcommaaccent aring -10\nKPX rcommaaccent atilde -10\nKPX rcommaaccent colon 30\nKPX rcommaaccent comma -50\nKPX rcommaaccent i 15\nKPX rcommaaccent iacute 15\nKPX rcommaaccent icircumflex 15\nKPX rcommaaccent idieresis 15\nKPX rcommaaccent igrave 15\nKPX rcommaaccent imacron 15\nKPX rcommaaccent iogonek 15\nKPX rcommaaccent k 15\nKPX rcommaaccent kcommaaccent 15\nKPX rcommaaccent l 15\nKPX rcommaaccent lacute 15\nKPX rcommaaccent lcommaaccent 15\nKPX rcommaaccent lslash 15\nKPX rcommaaccent m 25\nKPX rcommaaccent n 25\nKPX rcommaaccent nacute 25\nKPX rcommaaccent ncaron 25\nKPX rcommaaccent ncommaaccent 25\nKPX rcommaaccent ntilde 25\nKPX rcommaaccent p 30\nKPX rcommaaccent period -50\nKPX rcommaaccent semicolon 30\nKPX rcommaaccent t 40\nKPX rcommaaccent tcommaaccent 40\nKPX rcommaaccent u 15\nKPX rcommaaccent uacute 15\nKPX rcommaaccent ucircumflex 15\nKPX rcommaaccent udieresis 15\nKPX rcommaaccent ugrave 15\nKPX rcommaaccent uhungarumlaut 15\nKPX rcommaaccent umacron 15\nKPX rcommaaccent uogonek 15\nKPX rcommaaccent uring 15\nKPX rcommaaccent v 30\nKPX rcommaaccent y 30\nKPX rcommaaccent yacute 30\nKPX rcommaaccent ydieresis 30\nKPX s comma -15\nKPX s period -15\nKPX s w -30\nKPX sacute comma -15\nKPX sacute period -15\nKPX sacute w -30\nKPX scaron comma -15\nKPX scaron period -15\nKPX scaron w -30\nKPX scedilla comma -15\nKPX scedilla period -15\nKPX scedilla w -30\nKPX scommaaccent comma -15\nKPX scommaaccent period -15\nKPX scommaaccent w -30\nKPX semicolon space -50\nKPX space T -50\nKPX space Tcaron -50\nKPX space Tcommaaccent -50\nKPX space V -50\nKPX space W -40\nKPX space Y -90\nKPX space Yacute -90\nKPX space Ydieresis -90\nKPX space quotedblleft -30\nKPX space quoteleft -60\nKPX v a -25\nKPX v aacute -25\nKPX v abreve -25\nKPX v acircumflex -25\nKPX v adieresis -25\nKPX v agrave -25\nKPX v amacron -25\nKPX v aogonek -25\nKPX v aring -25\nKPX v atilde -25\nKPX v comma -80\nKPX v e -25\nKPX v eacute -25\nKPX v ecaron -25\nKPX v ecircumflex -25\nKPX v edieresis -25\nKPX v edotaccent -25\nKPX v egrave -25\nKPX v emacron -25\nKPX v eogonek -25\nKPX v o -25\nKPX v oacute -25\nKPX v ocircumflex -25\nKPX v odieresis -25\nKPX v ograve -25\nKPX v ohungarumlaut -25\nKPX v omacron -25\nKPX v oslash -25\nKPX v otilde -25\nKPX v period -80\nKPX w a -15\nKPX w aacute -15\nKPX w abreve -15\nKPX w acircumflex -15\nKPX w adieresis -15\nKPX w agrave -15\nKPX w amacron -15\nKPX w aogonek -15\nKPX w aring -15\nKPX w atilde -15\nKPX w comma -60\nKPX w e -10\nKPX w eacute -10\nKPX w ecaron -10\nKPX w ecircumflex -10\nKPX w edieresis -10\nKPX w edotaccent -10\nKPX w egrave -10\nKPX w emacron -10\nKPX w eogonek -10\nKPX w o -10\nKPX w oacute -10\nKPX w ocircumflex -10\nKPX w odieresis -10\nKPX w ograve -10\nKPX w ohungarumlaut -10\nKPX w omacron -10\nKPX w oslash -10\nKPX w otilde -10\nKPX w period -60\nKPX x e -30\nKPX x eacute -30\nKPX x ecaron -30\nKPX x ecircumflex -30\nKPX x edieresis -30\nKPX x edotaccent -30\nKPX x egrave -30\nKPX x emacron -30\nKPX x eogonek -30\nKPX y a -20\nKPX y aacute -20\nKPX y abreve -20\nKPX y acircumflex -20\nKPX y adieresis -20\nKPX y agrave -20\nKPX y amacron -20\nKPX y aogonek -20\nKPX y aring -20\nKPX y atilde -20\nKPX y comma -100\nKPX y e -20\nKPX y eacute -20\nKPX y ecaron -20\nKPX y ecircumflex -20\nKPX y edieresis -20\nKPX y edotaccent -20\nKPX y egrave -20\nKPX y emacron -20\nKPX y eogonek -20\nKPX y o -20\nKPX y oacute -20\nKPX y ocircumflex -20\nKPX y odieresis -20\nKPX y ograve -20\nKPX y ohungarumlaut -20\nKPX y omacron -20\nKPX y oslash -20\nKPX y otilde -20\nKPX y period -100\nKPX yacute a -20\nKPX yacute aacute -20\nKPX yacute abreve -20\nKPX yacute acircumflex -20\nKPX yacute adieresis -20\nKPX yacute agrave -20\nKPX yacute amacron -20\nKPX yacute aogonek -20\nKPX yacute aring -20\nKPX yacute atilde -20\nKPX yacute comma -100\nKPX yacute e -20\nKPX yacute eacute -20\nKPX yacute ecaron -20\nKPX yacute ecircumflex -20\nKPX yacute edieresis -20\nKPX yacute edotaccent -20\nKPX yacute egrave -20\nKPX yacute emacron -20\nKPX yacute eogonek -20\nKPX yacute o -20\nKPX yacute oacute -20\nKPX yacute ocircumflex -20\nKPX yacute odieresis -20\nKPX yacute ograve -20\nKPX yacute ohungarumlaut -20\nKPX yacute omacron -20\nKPX yacute oslash -20\nKPX yacute otilde -20\nKPX yacute period -100\nKPX ydieresis a -20\nKPX ydieresis aacute -20\nKPX ydieresis abreve -20\nKPX ydieresis acircumflex -20\nKPX ydieresis adieresis -20\nKPX ydieresis agrave -20\nKPX ydieresis amacron -20\nKPX ydieresis aogonek -20\nKPX ydieresis aring -20\nKPX ydieresis atilde -20\nKPX ydieresis comma -100\nKPX ydieresis e -20\nKPX ydieresis eacute -20\nKPX ydieresis ecaron -20\nKPX ydieresis ecircumflex -20\nKPX ydieresis edieresis -20\nKPX ydieresis edotaccent -20\nKPX ydieresis egrave -20\nKPX ydieresis emacron -20\nKPX ydieresis eogonek -20\nKPX ydieresis o -20\nKPX ydieresis oacute -20\nKPX ydieresis ocircumflex -20\nKPX ydieresis odieresis -20\nKPX ydieresis ograve -20\nKPX ydieresis ohungarumlaut -20\nKPX ydieresis omacron -20\nKPX ydieresis oslash -20\nKPX ydieresis otilde -20\nKPX ydieresis period -100\nKPX z e -15\nKPX z eacute -15\nKPX z ecaron -15\nKPX z ecircumflex -15\nKPX z edieresis -15\nKPX z edotaccent -15\nKPX z egrave -15\nKPX z emacron -15\nKPX z eogonek -15\nKPX z o -15\nKPX z oacute -15\nKPX z ocircumflex -15\nKPX z odieresis -15\nKPX z ograve -15\nKPX z ohungarumlaut -15\nKPX z omacron -15\nKPX z oslash -15\nKPX z otilde -15\nKPX zacute e -15\nKPX zacute eacute -15\nKPX zacute ecaron -15\nKPX zacute ecircumflex -15\nKPX zacute edieresis -15\nKPX zacute edotaccent -15\nKPX zacute egrave -15\nKPX zacute emacron -15\nKPX zacute eogonek -15\nKPX zacute o -15\nKPX zacute oacute -15\nKPX zacute ocircumflex -15\nKPX zacute odieresis -15\nKPX zacute ograve -15\nKPX zacute ohungarumlaut -15\nKPX zacute omacron -15\nKPX zacute oslash -15\nKPX zacute otilde -15\nKPX zcaron e -15\nKPX zcaron eacute -15\nKPX zcaron ecaron -15\nKPX zcaron ecircumflex -15\nKPX zcaron edieresis -15\nKPX zcaron edotaccent -15\nKPX zcaron egrave -15\nKPX zcaron emacron -15\nKPX zcaron eogonek -15\nKPX zcaron o -15\nKPX zcaron oacute -15\nKPX zcaron ocircumflex -15\nKPX zcaron odieresis -15\nKPX zcaron ograve -15\nKPX zcaron ohungarumlaut -15\nKPX zcaron omacron -15\nKPX zcaron oslash -15\nKPX zcaron otilde -15\nKPX zdotaccent e -15\nKPX zdotaccent eacute -15\nKPX zdotaccent ecaron -15\nKPX zdotaccent ecircumflex -15\nKPX zdotaccent edieresis -15\nKPX zdotaccent edotaccent -15\nKPX zdotaccent egrave -15\nKPX zdotaccent emacron -15\nKPX zdotaccent eogonek -15\nKPX zdotaccent o -15\nKPX zdotaccent oacute -15\nKPX zdotaccent ocircumflex -15\nKPX zdotaccent odieresis -15\nKPX zdotaccent ograve -15\nKPX zdotaccent ohungarumlaut -15\nKPX zdotaccent omacron -15\nKPX zdotaccent oslash -15\nKPX zdotaccent otilde -15\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    'Helvetica-BoldOblique' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 12:45:12 1997\nComment UniqueID 43053\nComment VMusage 14482 68586\nFontName Helvetica-BoldOblique\nFullName Helvetica Bold Oblique\nFamilyName Helvetica\nWeight Bold\nItalicAngle -12\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -174 -228 1114 962 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 718\nXHeight 532\nAscender 718\nDescender -207\nStdHW 118\nStdVW 140\nStartCharMetrics 315\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 333 ; N exclam ; B 94 0 397 718 ;\nC 34 ; WX 474 ; N quotedbl ; B 193 447 529 718 ;\nC 35 ; WX 556 ; N numbersign ; B 60 0 644 698 ;\nC 36 ; WX 556 ; N dollar ; B 67 -115 622 775 ;\nC 37 ; WX 889 ; N percent ; B 136 -19 901 710 ;\nC 38 ; WX 722 ; N ampersand ; B 89 -19 732 718 ;\nC 39 ; WX 278 ; N quoteright ; B 167 445 362 718 ;\nC 40 ; WX 333 ; N parenleft ; B 76 -208 470 734 ;\nC 41 ; WX 333 ; N parenright ; B -25 -208 369 734 ;\nC 42 ; WX 389 ; N asterisk ; B 146 387 481 718 ;\nC 43 ; WX 584 ; N plus ; B 82 0 610 506 ;\nC 44 ; WX 278 ; N comma ; B 28 -168 245 146 ;\nC 45 ; WX 333 ; N hyphen ; B 73 215 379 345 ;\nC 46 ; WX 278 ; N period ; B 64 0 245 146 ;\nC 47 ; WX 278 ; N slash ; B -37 -19 468 737 ;\nC 48 ; WX 556 ; N zero ; B 86 -19 617 710 ;\nC 49 ; WX 556 ; N one ; B 173 0 529 710 ;\nC 50 ; WX 556 ; N two ; B 26 0 619 710 ;\nC 51 ; WX 556 ; N three ; B 65 -19 608 710 ;\nC 52 ; WX 556 ; N four ; B 60 0 598 710 ;\nC 53 ; WX 556 ; N five ; B 64 -19 636 698 ;\nC 54 ; WX 556 ; N six ; B 85 -19 619 710 ;\nC 55 ; WX 556 ; N seven ; B 125 0 676 698 ;\nC 56 ; WX 556 ; N eight ; B 69 -19 616 710 ;\nC 57 ; WX 556 ; N nine ; B 78 -19 615 710 ;\nC 58 ; WX 333 ; N colon ; B 92 0 351 512 ;\nC 59 ; WX 333 ; N semicolon ; B 56 -168 351 512 ;\nC 60 ; WX 584 ; N less ; B 82 -8 655 514 ;\nC 61 ; WX 584 ; N equal ; B 58 87 633 419 ;\nC 62 ; WX 584 ; N greater ; B 36 -8 609 514 ;\nC 63 ; WX 611 ; N question ; B 165 0 671 727 ;\nC 64 ; WX 975 ; N at ; B 186 -19 954 737 ;\nC 65 ; WX 722 ; N A ; B 20 0 702 718 ;\nC 66 ; WX 722 ; N B ; B 76 0 764 718 ;\nC 67 ; WX 722 ; N C ; B 107 -19 789 737 ;\nC 68 ; WX 722 ; N D ; B 76 0 777 718 ;\nC 69 ; WX 667 ; N E ; B 76 0 757 718 ;\nC 70 ; WX 611 ; N F ; B 76 0 740 718 ;\nC 71 ; WX 778 ; N G ; B 108 -19 817 737 ;\nC 72 ; WX 722 ; N H ; B 71 0 804 718 ;\nC 73 ; WX 278 ; N I ; B 64 0 367 718 ;\nC 74 ; WX 556 ; N J ; B 60 -18 637 718 ;\nC 75 ; WX 722 ; N K ; B 87 0 858 718 ;\nC 76 ; WX 611 ; N L ; B 76 0 611 718 ;\nC 77 ; WX 833 ; N M ; B 69 0 918 718 ;\nC 78 ; WX 722 ; N N ; B 69 0 807 718 ;\nC 79 ; WX 778 ; N O ; B 107 -19 823 737 ;\nC 80 ; WX 667 ; N P ; B 76 0 738 718 ;\nC 81 ; WX 778 ; N Q ; B 107 -52 823 737 ;\nC 82 ; WX 722 ; N R ; B 76 0 778 718 ;\nC 83 ; WX 667 ; N S ; B 81 -19 718 737 ;\nC 84 ; WX 611 ; N T ; B 140 0 751 718 ;\nC 85 ; WX 722 ; N U ; B 116 -19 804 718 ;\nC 86 ; WX 667 ; N V ; B 172 0 801 718 ;\nC 87 ; WX 944 ; N W ; B 169 0 1082 718 ;\nC 88 ; WX 667 ; N X ; B 14 0 791 718 ;\nC 89 ; WX 667 ; N Y ; B 168 0 806 718 ;\nC 90 ; WX 611 ; N Z ; B 25 0 737 718 ;\nC 91 ; WX 333 ; N bracketleft ; B 21 -196 462 722 ;\nC 92 ; WX 278 ; N backslash ; B 124 -19 307 737 ;\nC 93 ; WX 333 ; N bracketright ; B -18 -196 423 722 ;\nC 94 ; WX 584 ; N asciicircum ; B 131 323 591 698 ;\nC 95 ; WX 556 ; N underscore ; B -27 -125 540 -75 ;\nC 96 ; WX 278 ; N quoteleft ; B 165 454 361 727 ;\nC 97 ; WX 556 ; N a ; B 55 -14 583 546 ;\nC 98 ; WX 611 ; N b ; B 61 -14 645 718 ;\nC 99 ; WX 556 ; N c ; B 79 -14 599 546 ;\nC 100 ; WX 611 ; N d ; B 82 -14 704 718 ;\nC 101 ; WX 556 ; N e ; B 70 -14 593 546 ;\nC 102 ; WX 333 ; N f ; B 87 0 469 727 ; L i fi ; L l fl ;\nC 103 ; WX 611 ; N g ; B 38 -217 666 546 ;\nC 104 ; WX 611 ; N h ; B 65 0 629 718 ;\nC 105 ; WX 278 ; N i ; B 69 0 363 725 ;\nC 106 ; WX 278 ; N j ; B -42 -214 363 725 ;\nC 107 ; WX 556 ; N k ; B 69 0 670 718 ;\nC 108 ; WX 278 ; N l ; B 69 0 362 718 ;\nC 109 ; WX 889 ; N m ; B 64 0 909 546 ;\nC 110 ; WX 611 ; N n ; B 65 0 629 546 ;\nC 111 ; WX 611 ; N o ; B 82 -14 643 546 ;\nC 112 ; WX 611 ; N p ; B 18 -207 645 546 ;\nC 113 ; WX 611 ; N q ; B 80 -207 665 546 ;\nC 114 ; WX 389 ; N r ; B 64 0 489 546 ;\nC 115 ; WX 556 ; N s ; B 63 -14 584 546 ;\nC 116 ; WX 333 ; N t ; B 100 -6 422 676 ;\nC 117 ; WX 611 ; N u ; B 98 -14 658 532 ;\nC 118 ; WX 556 ; N v ; B 126 0 656 532 ;\nC 119 ; WX 778 ; N w ; B 123 0 882 532 ;\nC 120 ; WX 556 ; N x ; B 15 0 648 532 ;\nC 121 ; WX 556 ; N y ; B 42 -214 652 532 ;\nC 122 ; WX 500 ; N z ; B 20 0 583 532 ;\nC 123 ; WX 389 ; N braceleft ; B 94 -196 518 722 ;\nC 124 ; WX 280 ; N bar ; B 36 -225 361 775 ;\nC 125 ; WX 389 ; N braceright ; B -18 -196 407 722 ;\nC 126 ; WX 584 ; N asciitilde ; B 115 163 577 343 ;\nC 161 ; WX 333 ; N exclamdown ; B 50 -186 353 532 ;\nC 162 ; WX 556 ; N cent ; B 79 -118 599 628 ;\nC 163 ; WX 556 ; N sterling ; B 50 -16 635 718 ;\nC 164 ; WX 167 ; N fraction ; B -174 -19 487 710 ;\nC 165 ; WX 556 ; N yen ; B 60 0 713 698 ;\nC 166 ; WX 556 ; N florin ; B -50 -210 669 737 ;\nC 167 ; WX 556 ; N section ; B 61 -184 598 727 ;\nC 168 ; WX 556 ; N currency ; B 27 76 680 636 ;\nC 169 ; WX 238 ; N quotesingle ; B 165 447 321 718 ;\nC 170 ; WX 500 ; N quotedblleft ; B 160 454 588 727 ;\nC 171 ; WX 556 ; N guillemotleft ; B 135 76 571 484 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 130 76 353 484 ;\nC 173 ; WX 333 ; N guilsinglright ; B 99 76 322 484 ;\nC 174 ; WX 611 ; N fi ; B 87 0 696 727 ;\nC 175 ; WX 611 ; N fl ; B 87 0 695 727 ;\nC 177 ; WX 556 ; N endash ; B 48 227 627 333 ;\nC 178 ; WX 556 ; N dagger ; B 118 -171 626 718 ;\nC 179 ; WX 556 ; N daggerdbl ; B 46 -171 628 718 ;\nC 180 ; WX 278 ; N periodcentered ; B 110 172 276 334 ;\nC 182 ; WX 556 ; N paragraph ; B 98 -191 688 700 ;\nC 183 ; WX 350 ; N bullet ; B 83 194 420 524 ;\nC 184 ; WX 278 ; N quotesinglbase ; B 41 -146 236 127 ;\nC 185 ; WX 500 ; N quotedblbase ; B 36 -146 463 127 ;\nC 186 ; WX 500 ; N quotedblright ; B 162 445 589 718 ;\nC 187 ; WX 556 ; N guillemotright ; B 104 76 540 484 ;\nC 188 ; WX 1000 ; N ellipsis ; B 92 0 939 146 ;\nC 189 ; WX 1000 ; N perthousand ; B 76 -19 1038 710 ;\nC 191 ; WX 611 ; N questiondown ; B 53 -195 559 532 ;\nC 193 ; WX 333 ; N grave ; B 136 604 353 750 ;\nC 194 ; WX 333 ; N acute ; B 236 604 515 750 ;\nC 195 ; WX 333 ; N circumflex ; B 118 604 471 750 ;\nC 196 ; WX 333 ; N tilde ; B 113 610 507 737 ;\nC 197 ; WX 333 ; N macron ; B 122 604 483 678 ;\nC 198 ; WX 333 ; N breve ; B 156 604 494 750 ;\nC 199 ; WX 333 ; N dotaccent ; B 235 614 385 729 ;\nC 200 ; WX 333 ; N dieresis ; B 137 614 482 729 ;\nC 202 ; WX 333 ; N ring ; B 200 568 420 776 ;\nC 203 ; WX 333 ; N cedilla ; B -37 -228 220 0 ;\nC 205 ; WX 333 ; N hungarumlaut ; B 137 604 645 750 ;\nC 206 ; WX 333 ; N ogonek ; B 41 -228 264 0 ;\nC 207 ; WX 333 ; N caron ; B 149 604 502 750 ;\nC 208 ; WX 1000 ; N emdash ; B 48 227 1071 333 ;\nC 225 ; WX 1000 ; N AE ; B 5 0 1100 718 ;\nC 227 ; WX 370 ; N ordfeminine ; B 125 401 465 737 ;\nC 232 ; WX 611 ; N Lslash ; B 34 0 611 718 ;\nC 233 ; WX 778 ; N Oslash ; B 35 -27 894 745 ;\nC 234 ; WX 1000 ; N OE ; B 99 -19 1114 737 ;\nC 235 ; WX 365 ; N ordmasculine ; B 123 401 485 737 ;\nC 241 ; WX 889 ; N ae ; B 56 -14 923 546 ;\nC 245 ; WX 278 ; N dotlessi ; B 69 0 322 532 ;\nC 248 ; WX 278 ; N lslash ; B 40 0 407 718 ;\nC 249 ; WX 611 ; N oslash ; B 22 -29 701 560 ;\nC 250 ; WX 944 ; N oe ; B 82 -14 977 546 ;\nC 251 ; WX 611 ; N germandbls ; B 69 -14 657 731 ;\nC -1 ; WX 278 ; N Idieresis ; B 64 0 494 915 ;\nC -1 ; WX 556 ; N eacute ; B 70 -14 627 750 ;\nC -1 ; WX 556 ; N abreve ; B 55 -14 606 750 ;\nC -1 ; WX 611 ; N uhungarumlaut ; B 98 -14 784 750 ;\nC -1 ; WX 556 ; N ecaron ; B 70 -14 614 750 ;\nC -1 ; WX 667 ; N Ydieresis ; B 168 0 806 915 ;\nC -1 ; WX 584 ; N divide ; B 82 -42 610 548 ;\nC -1 ; WX 667 ; N Yacute ; B 168 0 806 936 ;\nC -1 ; WX 722 ; N Acircumflex ; B 20 0 706 936 ;\nC -1 ; WX 556 ; N aacute ; B 55 -14 627 750 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 116 -19 804 936 ;\nC -1 ; WX 556 ; N yacute ; B 42 -214 652 750 ;\nC -1 ; WX 556 ; N scommaaccent ; B 63 -228 584 546 ;\nC -1 ; WX 556 ; N ecircumflex ; B 70 -14 593 750 ;\nC -1 ; WX 722 ; N Uring ; B 116 -19 804 962 ;\nC -1 ; WX 722 ; N Udieresis ; B 116 -19 804 915 ;\nC -1 ; WX 556 ; N aogonek ; B 55 -224 583 546 ;\nC -1 ; WX 722 ; N Uacute ; B 116 -19 804 936 ;\nC -1 ; WX 611 ; N uogonek ; B 98 -228 658 532 ;\nC -1 ; WX 667 ; N Edieresis ; B 76 0 757 915 ;\nC -1 ; WX 722 ; N Dcroat ; B 62 0 777 718 ;\nC -1 ; WX 250 ; N commaaccent ; B 16 -228 188 -50 ;\nC -1 ; WX 737 ; N copyright ; B 56 -19 835 737 ;\nC -1 ; WX 667 ; N Emacron ; B 76 0 757 864 ;\nC -1 ; WX 556 ; N ccaron ; B 79 -14 614 750 ;\nC -1 ; WX 556 ; N aring ; B 55 -14 583 776 ;\nC -1 ; WX 722 ; N Ncommaaccent ; B 69 -228 807 718 ;\nC -1 ; WX 278 ; N lacute ; B 69 0 528 936 ;\nC -1 ; WX 556 ; N agrave ; B 55 -14 583 750 ;\nC -1 ; WX 611 ; N Tcommaaccent ; B 140 -228 751 718 ;\nC -1 ; WX 722 ; N Cacute ; B 107 -19 789 936 ;\nC -1 ; WX 556 ; N atilde ; B 55 -14 619 737 ;\nC -1 ; WX 667 ; N Edotaccent ; B 76 0 757 915 ;\nC -1 ; WX 556 ; N scaron ; B 63 -14 614 750 ;\nC -1 ; WX 556 ; N scedilla ; B 63 -228 584 546 ;\nC -1 ; WX 278 ; N iacute ; B 69 0 488 750 ;\nC -1 ; WX 494 ; N lozenge ; B 90 0 564 745 ;\nC -1 ; WX 722 ; N Rcaron ; B 76 0 778 936 ;\nC -1 ; WX 778 ; N Gcommaaccent ; B 108 -228 817 737 ;\nC -1 ; WX 611 ; N ucircumflex ; B 98 -14 658 750 ;\nC -1 ; WX 556 ; N acircumflex ; B 55 -14 583 750 ;\nC -1 ; WX 722 ; N Amacron ; B 20 0 718 864 ;\nC -1 ; WX 389 ; N rcaron ; B 64 0 530 750 ;\nC -1 ; WX 556 ; N ccedilla ; B 79 -228 599 546 ;\nC -1 ; WX 611 ; N Zdotaccent ; B 25 0 737 915 ;\nC -1 ; WX 667 ; N Thorn ; B 76 0 716 718 ;\nC -1 ; WX 778 ; N Omacron ; B 107 -19 823 864 ;\nC -1 ; WX 722 ; N Racute ; B 76 0 778 936 ;\nC -1 ; WX 667 ; N Sacute ; B 81 -19 722 936 ;\nC -1 ; WX 743 ; N dcaron ; B 82 -14 903 718 ;\nC -1 ; WX 722 ; N Umacron ; B 116 -19 804 864 ;\nC -1 ; WX 611 ; N uring ; B 98 -14 658 776 ;\nC -1 ; WX 333 ; N threesuperior ; B 91 271 441 710 ;\nC -1 ; WX 778 ; N Ograve ; B 107 -19 823 936 ;\nC -1 ; WX 722 ; N Agrave ; B 20 0 702 936 ;\nC -1 ; WX 722 ; N Abreve ; B 20 0 729 936 ;\nC -1 ; WX 584 ; N multiply ; B 57 1 635 505 ;\nC -1 ; WX 611 ; N uacute ; B 98 -14 658 750 ;\nC -1 ; WX 611 ; N Tcaron ; B 140 0 751 936 ;\nC -1 ; WX 494 ; N partialdiff ; B 43 -21 585 750 ;\nC -1 ; WX 556 ; N ydieresis ; B 42 -214 652 729 ;\nC -1 ; WX 722 ; N Nacute ; B 69 0 807 936 ;\nC -1 ; WX 278 ; N icircumflex ; B 69 0 444 750 ;\nC -1 ; WX 667 ; N Ecircumflex ; B 76 0 757 936 ;\nC -1 ; WX 556 ; N adieresis ; B 55 -14 594 729 ;\nC -1 ; WX 556 ; N edieresis ; B 70 -14 594 729 ;\nC -1 ; WX 556 ; N cacute ; B 79 -14 627 750 ;\nC -1 ; WX 611 ; N nacute ; B 65 0 654 750 ;\nC -1 ; WX 611 ; N umacron ; B 98 -14 658 678 ;\nC -1 ; WX 722 ; N Ncaron ; B 69 0 807 936 ;\nC -1 ; WX 278 ; N Iacute ; B 64 0 528 936 ;\nC -1 ; WX 584 ; N plusminus ; B 40 0 625 506 ;\nC -1 ; WX 280 ; N brokenbar ; B 52 -150 345 700 ;\nC -1 ; WX 737 ; N registered ; B 55 -19 834 737 ;\nC -1 ; WX 778 ; N Gbreve ; B 108 -19 817 936 ;\nC -1 ; WX 278 ; N Idotaccent ; B 64 0 397 915 ;\nC -1 ; WX 600 ; N summation ; B 14 -10 670 706 ;\nC -1 ; WX 667 ; N Egrave ; B 76 0 757 936 ;\nC -1 ; WX 389 ; N racute ; B 64 0 543 750 ;\nC -1 ; WX 611 ; N omacron ; B 82 -14 643 678 ;\nC -1 ; WX 611 ; N Zacute ; B 25 0 737 936 ;\nC -1 ; WX 611 ; N Zcaron ; B 25 0 737 936 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 629 704 ;\nC -1 ; WX 722 ; N Eth ; B 62 0 777 718 ;\nC -1 ; WX 722 ; N Ccedilla ; B 107 -228 789 737 ;\nC -1 ; WX 278 ; N lcommaaccent ; B 30 -228 362 718 ;\nC -1 ; WX 389 ; N tcaron ; B 100 -6 608 878 ;\nC -1 ; WX 556 ; N eogonek ; B 70 -228 593 546 ;\nC -1 ; WX 722 ; N Uogonek ; B 116 -228 804 718 ;\nC -1 ; WX 722 ; N Aacute ; B 20 0 750 936 ;\nC -1 ; WX 722 ; N Adieresis ; B 20 0 716 915 ;\nC -1 ; WX 556 ; N egrave ; B 70 -14 593 750 ;\nC -1 ; WX 500 ; N zacute ; B 20 0 599 750 ;\nC -1 ; WX 278 ; N iogonek ; B -14 -224 363 725 ;\nC -1 ; WX 778 ; N Oacute ; B 107 -19 823 936 ;\nC -1 ; WX 611 ; N oacute ; B 82 -14 654 750 ;\nC -1 ; WX 556 ; N amacron ; B 55 -14 595 678 ;\nC -1 ; WX 556 ; N sacute ; B 63 -14 627 750 ;\nC -1 ; WX 278 ; N idieresis ; B 69 0 455 729 ;\nC -1 ; WX 778 ; N Ocircumflex ; B 107 -19 823 936 ;\nC -1 ; WX 722 ; N Ugrave ; B 116 -19 804 936 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 611 ; N thorn ; B 18 -208 645 718 ;\nC -1 ; WX 333 ; N twosuperior ; B 69 283 449 710 ;\nC -1 ; WX 778 ; N Odieresis ; B 107 -19 823 915 ;\nC -1 ; WX 611 ; N mu ; B 22 -207 658 532 ;\nC -1 ; WX 278 ; N igrave ; B 69 0 326 750 ;\nC -1 ; WX 611 ; N ohungarumlaut ; B 82 -14 784 750 ;\nC -1 ; WX 667 ; N Eogonek ; B 76 -224 757 718 ;\nC -1 ; WX 611 ; N dcroat ; B 82 -14 789 718 ;\nC -1 ; WX 834 ; N threequarters ; B 99 -19 839 710 ;\nC -1 ; WX 667 ; N Scedilla ; B 81 -228 718 737 ;\nC -1 ; WX 400 ; N lcaron ; B 69 0 561 718 ;\nC -1 ; WX 722 ; N Kcommaaccent ; B 87 -228 858 718 ;\nC -1 ; WX 611 ; N Lacute ; B 76 0 611 936 ;\nC -1 ; WX 1000 ; N trademark ; B 179 306 1109 718 ;\nC -1 ; WX 556 ; N edotaccent ; B 70 -14 593 729 ;\nC -1 ; WX 278 ; N Igrave ; B 64 0 367 936 ;\nC -1 ; WX 278 ; N Imacron ; B 64 0 496 864 ;\nC -1 ; WX 611 ; N Lcaron ; B 76 0 643 718 ;\nC -1 ; WX 834 ; N onehalf ; B 132 -19 858 710 ;\nC -1 ; WX 549 ; N lessequal ; B 29 0 676 704 ;\nC -1 ; WX 611 ; N ocircumflex ; B 82 -14 643 750 ;\nC -1 ; WX 611 ; N ntilde ; B 65 0 646 737 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 116 -19 880 936 ;\nC -1 ; WX 667 ; N Eacute ; B 76 0 757 936 ;\nC -1 ; WX 556 ; N emacron ; B 70 -14 595 678 ;\nC -1 ; WX 611 ; N gbreve ; B 38 -217 666 750 ;\nC -1 ; WX 834 ; N onequarter ; B 132 -19 806 710 ;\nC -1 ; WX 667 ; N Scaron ; B 81 -19 718 936 ;\nC -1 ; WX 667 ; N Scommaaccent ; B 81 -228 718 737 ;\nC -1 ; WX 778 ; N Ohungarumlaut ; B 107 -19 908 936 ;\nC -1 ; WX 400 ; N degree ; B 175 426 467 712 ;\nC -1 ; WX 611 ; N ograve ; B 82 -14 643 750 ;\nC -1 ; WX 722 ; N Ccaron ; B 107 -19 789 936 ;\nC -1 ; WX 611 ; N ugrave ; B 98 -14 658 750 ;\nC -1 ; WX 549 ; N radical ; B 112 -46 689 850 ;\nC -1 ; WX 722 ; N Dcaron ; B 76 0 777 936 ;\nC -1 ; WX 389 ; N rcommaaccent ; B 26 -228 489 546 ;\nC -1 ; WX 722 ; N Ntilde ; B 69 0 807 923 ;\nC -1 ; WX 611 ; N otilde ; B 82 -14 646 737 ;\nC -1 ; WX 722 ; N Rcommaaccent ; B 76 -228 778 718 ;\nC -1 ; WX 611 ; N Lcommaaccent ; B 76 -228 611 718 ;\nC -1 ; WX 722 ; N Atilde ; B 20 0 741 923 ;\nC -1 ; WX 722 ; N Aogonek ; B 20 -224 702 718 ;\nC -1 ; WX 722 ; N Aring ; B 20 0 702 962 ;\nC -1 ; WX 778 ; N Otilde ; B 107 -19 823 923 ;\nC -1 ; WX 500 ; N zdotaccent ; B 20 0 583 729 ;\nC -1 ; WX 667 ; N Ecaron ; B 76 0 757 936 ;\nC -1 ; WX 278 ; N Iogonek ; B -41 -228 367 718 ;\nC -1 ; WX 556 ; N kcommaaccent ; B 69 -228 670 718 ;\nC -1 ; WX 584 ; N minus ; B 82 197 610 309 ;\nC -1 ; WX 278 ; N Icircumflex ; B 64 0 484 936 ;\nC -1 ; WX 611 ; N ncaron ; B 65 0 641 750 ;\nC -1 ; WX 333 ; N tcommaaccent ; B 58 -228 422 676 ;\nC -1 ; WX 584 ; N logicalnot ; B 105 108 633 419 ;\nC -1 ; WX 611 ; N odieresis ; B 82 -14 643 729 ;\nC -1 ; WX 611 ; N udieresis ; B 98 -14 658 729 ;\nC -1 ; WX 549 ; N notequal ; B 32 -49 630 570 ;\nC -1 ; WX 611 ; N gcommaaccent ; B 38 -217 666 850 ;\nC -1 ; WX 611 ; N eth ; B 82 -14 670 737 ;\nC -1 ; WX 500 ; N zcaron ; B 20 0 586 750 ;\nC -1 ; WX 611 ; N ncommaaccent ; B 65 -228 629 546 ;\nC -1 ; WX 333 ; N onesuperior ; B 148 283 388 710 ;\nC -1 ; WX 278 ; N imacron ; B 69 0 429 678 ;\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2481\nKPX A C -40\nKPX A Cacute -40\nKPX A Ccaron -40\nKPX A Ccedilla -40\nKPX A G -50\nKPX A Gbreve -50\nKPX A Gcommaaccent -50\nKPX A O -40\nKPX A Oacute -40\nKPX A Ocircumflex -40\nKPX A Odieresis -40\nKPX A Ograve -40\nKPX A Ohungarumlaut -40\nKPX A Omacron -40\nKPX A Oslash -40\nKPX A Otilde -40\nKPX A Q -40\nKPX A T -90\nKPX A Tcaron -90\nKPX A Tcommaaccent -90\nKPX A U -50\nKPX A Uacute -50\nKPX A Ucircumflex -50\nKPX A Udieresis -50\nKPX A Ugrave -50\nKPX A Uhungarumlaut -50\nKPX A Umacron -50\nKPX A Uogonek -50\nKPX A Uring -50\nKPX A V -80\nKPX A W -60\nKPX A Y -110\nKPX A Yacute -110\nKPX A Ydieresis -110\nKPX A u -30\nKPX A uacute -30\nKPX A ucircumflex -30\nKPX A udieresis -30\nKPX A ugrave -30\nKPX A uhungarumlaut -30\nKPX A umacron -30\nKPX A uogonek -30\nKPX A uring -30\nKPX A v -40\nKPX A w -30\nKPX A y -30\nKPX A yacute -30\nKPX A ydieresis -30\nKPX Aacute C -40\nKPX Aacute Cacute -40\nKPX Aacute Ccaron -40\nKPX Aacute Ccedilla -40\nKPX Aacute G -50\nKPX Aacute Gbreve -50\nKPX Aacute Gcommaaccent -50\nKPX Aacute O -40\nKPX Aacute Oacute -40\nKPX Aacute Ocircumflex -40\nKPX Aacute Odieresis -40\nKPX Aacute Ograve -40\nKPX Aacute Ohungarumlaut -40\nKPX Aacute Omacron -40\nKPX Aacute Oslash -40\nKPX Aacute Otilde -40\nKPX Aacute Q -40\nKPX Aacute T -90\nKPX Aacute Tcaron -90\nKPX Aacute Tcommaaccent -90\nKPX Aacute U -50\nKPX Aacute Uacute -50\nKPX Aacute Ucircumflex -50\nKPX Aacute Udieresis -50\nKPX Aacute Ugrave -50\nKPX Aacute Uhungarumlaut -50\nKPX Aacute Umacron -50\nKPX Aacute Uogonek -50\nKPX Aacute Uring -50\nKPX Aacute V -80\nKPX Aacute W -60\nKPX Aacute Y -110\nKPX Aacute Yacute -110\nKPX Aacute Ydieresis -110\nKPX Aacute u -30\nKPX Aacute uacute -30\nKPX Aacute ucircumflex -30\nKPX Aacute udieresis -30\nKPX Aacute ugrave -30\nKPX Aacute uhungarumlaut -30\nKPX Aacute umacron -30\nKPX Aacute uogonek -30\nKPX Aacute uring -30\nKPX Aacute v -40\nKPX Aacute w -30\nKPX Aacute y -30\nKPX Aacute yacute -30\nKPX Aacute ydieresis -30\nKPX Abreve C -40\nKPX Abreve Cacute -40\nKPX Abreve Ccaron -40\nKPX Abreve Ccedilla -40\nKPX Abreve G -50\nKPX Abreve Gbreve -50\nKPX Abreve Gcommaaccent -50\nKPX Abreve O -40\nKPX Abreve Oacute -40\nKPX Abreve Ocircumflex -40\nKPX Abreve Odieresis -40\nKPX Abreve Ograve -40\nKPX Abreve Ohungarumlaut -40\nKPX Abreve Omacron -40\nKPX Abreve Oslash -40\nKPX Abreve Otilde -40\nKPX Abreve Q -40\nKPX Abreve T -90\nKPX Abreve Tcaron -90\nKPX Abreve Tcommaaccent -90\nKPX Abreve U -50\nKPX Abreve Uacute -50\nKPX Abreve Ucircumflex -50\nKPX Abreve Udieresis -50\nKPX Abreve Ugrave -50\nKPX Abreve Uhungarumlaut -50\nKPX Abreve Umacron -50\nKPX Abreve Uogonek -50\nKPX Abreve Uring -50\nKPX Abreve V -80\nKPX Abreve W -60\nKPX Abreve Y -110\nKPX Abreve Yacute -110\nKPX Abreve Ydieresis -110\nKPX Abreve u -30\nKPX Abreve uacute -30\nKPX Abreve ucircumflex -30\nKPX Abreve udieresis -30\nKPX Abreve ugrave -30\nKPX Abreve uhungarumlaut -30\nKPX Abreve umacron -30\nKPX Abreve uogonek -30\nKPX Abreve uring -30\nKPX Abreve v -40\nKPX Abreve w -30\nKPX Abreve y -30\nKPX Abreve yacute -30\nKPX Abreve ydieresis -30\nKPX Acircumflex C -40\nKPX Acircumflex Cacute -40\nKPX Acircumflex Ccaron -40\nKPX Acircumflex Ccedilla -40\nKPX Acircumflex G -50\nKPX Acircumflex Gbreve -50\nKPX Acircumflex Gcommaaccent -50\nKPX Acircumflex O -40\nKPX Acircumflex Oacute -40\nKPX Acircumflex Ocircumflex -40\nKPX Acircumflex Odieresis -40\nKPX Acircumflex Ograve -40\nKPX Acircumflex Ohungarumlaut -40\nKPX Acircumflex Omacron -40\nKPX Acircumflex Oslash -40\nKPX Acircumflex Otilde -40\nKPX Acircumflex Q -40\nKPX Acircumflex T -90\nKPX Acircumflex Tcaron -90\nKPX Acircumflex Tcommaaccent -90\nKPX Acircumflex U -50\nKPX Acircumflex Uacute -50\nKPX Acircumflex Ucircumflex -50\nKPX Acircumflex Udieresis -50\nKPX Acircumflex Ugrave -50\nKPX Acircumflex Uhungarumlaut -50\nKPX Acircumflex Umacron -50\nKPX Acircumflex Uogonek -50\nKPX Acircumflex Uring -50\nKPX Acircumflex V -80\nKPX Acircumflex W -60\nKPX Acircumflex Y -110\nKPX Acircumflex Yacute -110\nKPX Acircumflex Ydieresis -110\nKPX Acircumflex u -30\nKPX Acircumflex uacute -30\nKPX Acircumflex ucircumflex -30\nKPX Acircumflex udieresis -30\nKPX Acircumflex ugrave -30\nKPX Acircumflex uhungarumlaut -30\nKPX Acircumflex umacron -30\nKPX Acircumflex uogonek -30\nKPX Acircumflex uring -30\nKPX Acircumflex v -40\nKPX Acircumflex w -30\nKPX Acircumflex y -30\nKPX Acircumflex yacute -30\nKPX Acircumflex ydieresis -30\nKPX Adieresis C -40\nKPX Adieresis Cacute -40\nKPX Adieresis Ccaron -40\nKPX Adieresis Ccedilla -40\nKPX Adieresis G -50\nKPX Adieresis Gbreve -50\nKPX Adieresis Gcommaaccent -50\nKPX Adieresis O -40\nKPX Adieresis Oacute -40\nKPX Adieresis Ocircumflex -40\nKPX Adieresis Odieresis -40\nKPX Adieresis Ograve -40\nKPX Adieresis Ohungarumlaut -40\nKPX Adieresis Omacron -40\nKPX Adieresis Oslash -40\nKPX Adieresis Otilde -40\nKPX Adieresis Q -40\nKPX Adieresis T -90\nKPX Adieresis Tcaron -90\nKPX Adieresis Tcommaaccent -90\nKPX Adieresis U -50\nKPX Adieresis Uacute -50\nKPX Adieresis Ucircumflex -50\nKPX Adieresis Udieresis -50\nKPX Adieresis Ugrave -50\nKPX Adieresis Uhungarumlaut -50\nKPX Adieresis Umacron -50\nKPX Adieresis Uogonek -50\nKPX Adieresis Uring -50\nKPX Adieresis V -80\nKPX Adieresis W -60\nKPX Adieresis Y -110\nKPX Adieresis Yacute -110\nKPX Adieresis Ydieresis -110\nKPX Adieresis u -30\nKPX Adieresis uacute -30\nKPX Adieresis ucircumflex -30\nKPX Adieresis udieresis -30\nKPX Adieresis ugrave -30\nKPX Adieresis uhungarumlaut -30\nKPX Adieresis umacron -30\nKPX Adieresis uogonek -30\nKPX Adieresis uring -30\nKPX Adieresis v -40\nKPX Adieresis w -30\nKPX Adieresis y -30\nKPX Adieresis yacute -30\nKPX Adieresis ydieresis -30\nKPX Agrave C -40\nKPX Agrave Cacute -40\nKPX Agrave Ccaron -40\nKPX Agrave Ccedilla -40\nKPX Agrave G -50\nKPX Agrave Gbreve -50\nKPX Agrave Gcommaaccent -50\nKPX Agrave O -40\nKPX Agrave Oacute -40\nKPX Agrave Ocircumflex -40\nKPX Agrave Odieresis -40\nKPX Agrave Ograve -40\nKPX Agrave Ohungarumlaut -40\nKPX Agrave Omacron -40\nKPX Agrave Oslash -40\nKPX Agrave Otilde -40\nKPX Agrave Q -40\nKPX Agrave T -90\nKPX Agrave Tcaron -90\nKPX Agrave Tcommaaccent -90\nKPX Agrave U -50\nKPX Agrave Uacute -50\nKPX Agrave Ucircumflex -50\nKPX Agrave Udieresis -50\nKPX Agrave Ugrave -50\nKPX Agrave Uhungarumlaut -50\nKPX Agrave Umacron -50\nKPX Agrave Uogonek -50\nKPX Agrave Uring -50\nKPX Agrave V -80\nKPX Agrave W -60\nKPX Agrave Y -110\nKPX Agrave Yacute -110\nKPX Agrave Ydieresis -110\nKPX Agrave u -30\nKPX Agrave uacute -30\nKPX Agrave ucircumflex -30\nKPX Agrave udieresis -30\nKPX Agrave ugrave -30\nKPX Agrave uhungarumlaut -30\nKPX Agrave umacron -30\nKPX Agrave uogonek -30\nKPX Agrave uring -30\nKPX Agrave v -40\nKPX Agrave w -30\nKPX Agrave y -30\nKPX Agrave yacute -30\nKPX Agrave ydieresis -30\nKPX Amacron C -40\nKPX Amacron Cacute -40\nKPX Amacron Ccaron -40\nKPX Amacron Ccedilla -40\nKPX Amacron G -50\nKPX Amacron Gbreve -50\nKPX Amacron Gcommaaccent -50\nKPX Amacron O -40\nKPX Amacron Oacute -40\nKPX Amacron Ocircumflex -40\nKPX Amacron Odieresis -40\nKPX Amacron Ograve -40\nKPX Amacron Ohungarumlaut -40\nKPX Amacron Omacron -40\nKPX Amacron Oslash -40\nKPX Amacron Otilde -40\nKPX Amacron Q -40\nKPX Amacron T -90\nKPX Amacron Tcaron -90\nKPX Amacron Tcommaaccent -90\nKPX Amacron U -50\nKPX Amacron Uacute -50\nKPX Amacron Ucircumflex -50\nKPX Amacron Udieresis -50\nKPX Amacron Ugrave -50\nKPX Amacron Uhungarumlaut -50\nKPX Amacron Umacron -50\nKPX Amacron Uogonek -50\nKPX Amacron Uring -50\nKPX Amacron V -80\nKPX Amacron W -60\nKPX Amacron Y -110\nKPX Amacron Yacute -110\nKPX Amacron Ydieresis -110\nKPX Amacron u -30\nKPX Amacron uacute -30\nKPX Amacron ucircumflex -30\nKPX Amacron udieresis -30\nKPX Amacron ugrave -30\nKPX Amacron uhungarumlaut -30\nKPX Amacron umacron -30\nKPX Amacron uogonek -30\nKPX Amacron uring -30\nKPX Amacron v -40\nKPX Amacron w -30\nKPX Amacron y -30\nKPX Amacron yacute -30\nKPX Amacron ydieresis -30\nKPX Aogonek C -40\nKPX Aogonek Cacute -40\nKPX Aogonek Ccaron -40\nKPX Aogonek Ccedilla -40\nKPX Aogonek G -50\nKPX Aogonek Gbreve -50\nKPX Aogonek Gcommaaccent -50\nKPX Aogonek O -40\nKPX Aogonek Oacute -40\nKPX Aogonek Ocircumflex -40\nKPX Aogonek Odieresis -40\nKPX Aogonek Ograve -40\nKPX Aogonek Ohungarumlaut -40\nKPX Aogonek Omacron -40\nKPX Aogonek Oslash -40\nKPX Aogonek Otilde -40\nKPX Aogonek Q -40\nKPX Aogonek T -90\nKPX Aogonek Tcaron -90\nKPX Aogonek Tcommaaccent -90\nKPX Aogonek U -50\nKPX Aogonek Uacute -50\nKPX Aogonek Ucircumflex -50\nKPX Aogonek Udieresis -50\nKPX Aogonek Ugrave -50\nKPX Aogonek Uhungarumlaut -50\nKPX Aogonek Umacron -50\nKPX Aogonek Uogonek -50\nKPX Aogonek Uring -50\nKPX Aogonek V -80\nKPX Aogonek W -60\nKPX Aogonek Y -110\nKPX Aogonek Yacute -110\nKPX Aogonek Ydieresis -110\nKPX Aogonek u -30\nKPX Aogonek uacute -30\nKPX Aogonek ucircumflex -30\nKPX Aogonek udieresis -30\nKPX Aogonek ugrave -30\nKPX Aogonek uhungarumlaut -30\nKPX Aogonek umacron -30\nKPX Aogonek uogonek -30\nKPX Aogonek uring -30\nKPX Aogonek v -40\nKPX Aogonek w -30\nKPX Aogonek y -30\nKPX Aogonek yacute -30\nKPX Aogonek ydieresis -30\nKPX Aring C -40\nKPX Aring Cacute -40\nKPX Aring Ccaron -40\nKPX Aring Ccedilla -40\nKPX Aring G -50\nKPX Aring Gbreve -50\nKPX Aring Gcommaaccent -50\nKPX Aring O -40\nKPX Aring Oacute -40\nKPX Aring Ocircumflex -40\nKPX Aring Odieresis -40\nKPX Aring Ograve -40\nKPX Aring Ohungarumlaut -40\nKPX Aring Omacron -40\nKPX Aring Oslash -40\nKPX Aring Otilde -40\nKPX Aring Q -40\nKPX Aring T -90\nKPX Aring Tcaron -90\nKPX Aring Tcommaaccent -90\nKPX Aring U -50\nKPX Aring Uacute -50\nKPX Aring Ucircumflex -50\nKPX Aring Udieresis -50\nKPX Aring Ugrave -50\nKPX Aring Uhungarumlaut -50\nKPX Aring Umacron -50\nKPX Aring Uogonek -50\nKPX Aring Uring -50\nKPX Aring V -80\nKPX Aring W -60\nKPX Aring Y -110\nKPX Aring Yacute -110\nKPX Aring Ydieresis -110\nKPX Aring u -30\nKPX Aring uacute -30\nKPX Aring ucircumflex -30\nKPX Aring udieresis -30\nKPX Aring ugrave -30\nKPX Aring uhungarumlaut -30\nKPX Aring umacron -30\nKPX Aring uogonek -30\nKPX Aring uring -30\nKPX Aring v -40\nKPX Aring w -30\nKPX Aring y -30\nKPX Aring yacute -30\nKPX Aring ydieresis -30\nKPX Atilde C -40\nKPX Atilde Cacute -40\nKPX Atilde Ccaron -40\nKPX Atilde Ccedilla -40\nKPX Atilde G -50\nKPX Atilde Gbreve -50\nKPX Atilde Gcommaaccent -50\nKPX Atilde O -40\nKPX Atilde Oacute -40\nKPX Atilde Ocircumflex -40\nKPX Atilde Odieresis -40\nKPX Atilde Ograve -40\nKPX Atilde Ohungarumlaut -40\nKPX Atilde Omacron -40\nKPX Atilde Oslash -40\nKPX Atilde Otilde -40\nKPX Atilde Q -40\nKPX Atilde T -90\nKPX Atilde Tcaron -90\nKPX Atilde Tcommaaccent -90\nKPX Atilde U -50\nKPX Atilde Uacute -50\nKPX Atilde Ucircumflex -50\nKPX Atilde Udieresis -50\nKPX Atilde Ugrave -50\nKPX Atilde Uhungarumlaut -50\nKPX Atilde Umacron -50\nKPX Atilde Uogonek -50\nKPX Atilde Uring -50\nKPX Atilde V -80\nKPX Atilde W -60\nKPX Atilde Y -110\nKPX Atilde Yacute -110\nKPX Atilde Ydieresis -110\nKPX Atilde u -30\nKPX Atilde uacute -30\nKPX Atilde ucircumflex -30\nKPX Atilde udieresis -30\nKPX Atilde ugrave -30\nKPX Atilde uhungarumlaut -30\nKPX Atilde umacron -30\nKPX Atilde uogonek -30\nKPX Atilde uring -30\nKPX Atilde v -40\nKPX Atilde w -30\nKPX Atilde y -30\nKPX Atilde yacute -30\nKPX Atilde ydieresis -30\nKPX B A -30\nKPX B Aacute -30\nKPX B Abreve -30\nKPX B Acircumflex -30\nKPX B Adieresis -30\nKPX B Agrave -30\nKPX B Amacron -30\nKPX B Aogonek -30\nKPX B Aring -30\nKPX B Atilde -30\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX D A -40\nKPX D Aacute -40\nKPX D Abreve -40\nKPX D Acircumflex -40\nKPX D Adieresis -40\nKPX D Agrave -40\nKPX D Amacron -40\nKPX D Aogonek -40\nKPX D Aring -40\nKPX D Atilde -40\nKPX D V -40\nKPX D W -40\nKPX D Y -70\nKPX D Yacute -70\nKPX D Ydieresis -70\nKPX D comma -30\nKPX D period -30\nKPX Dcaron A -40\nKPX Dcaron Aacute -40\nKPX Dcaron Abreve -40\nKPX Dcaron Acircumflex -40\nKPX Dcaron Adieresis -40\nKPX Dcaron Agrave -40\nKPX Dcaron Amacron -40\nKPX Dcaron Aogonek -40\nKPX Dcaron Aring -40\nKPX Dcaron Atilde -40\nKPX Dcaron V -40\nKPX Dcaron W -40\nKPX Dcaron Y -70\nKPX Dcaron Yacute -70\nKPX Dcaron Ydieresis -70\nKPX Dcaron comma -30\nKPX Dcaron period -30\nKPX Dcroat A -40\nKPX Dcroat Aacute -40\nKPX Dcroat Abreve -40\nKPX Dcroat Acircumflex -40\nKPX Dcroat Adieresis -40\nKPX Dcroat Agrave -40\nKPX Dcroat Amacron -40\nKPX Dcroat Aogonek -40\nKPX Dcroat Aring -40\nKPX Dcroat Atilde -40\nKPX Dcroat V -40\nKPX Dcroat W -40\nKPX Dcroat Y -70\nKPX Dcroat Yacute -70\nKPX Dcroat Ydieresis -70\nKPX Dcroat comma -30\nKPX Dcroat period -30\nKPX F A -80\nKPX F Aacute -80\nKPX F Abreve -80\nKPX F Acircumflex -80\nKPX F Adieresis -80\nKPX F Agrave -80\nKPX F Amacron -80\nKPX F Aogonek -80\nKPX F Aring -80\nKPX F Atilde -80\nKPX F a -20\nKPX F aacute -20\nKPX F abreve -20\nKPX F acircumflex -20\nKPX F adieresis -20\nKPX F agrave -20\nKPX F amacron -20\nKPX F aogonek -20\nKPX F aring -20\nKPX F atilde -20\nKPX F comma -100\nKPX F period -100\nKPX J A -20\nKPX J Aacute -20\nKPX J Abreve -20\nKPX J Acircumflex -20\nKPX J Adieresis -20\nKPX J Agrave -20\nKPX J Amacron -20\nKPX J Aogonek -20\nKPX J Aring -20\nKPX J Atilde -20\nKPX J comma -20\nKPX J period -20\nKPX J u -20\nKPX J uacute -20\nKPX J ucircumflex -20\nKPX J udieresis -20\nKPX J ugrave -20\nKPX J uhungarumlaut -20\nKPX J umacron -20\nKPX J uogonek -20\nKPX J uring -20\nKPX K O -30\nKPX K Oacute -30\nKPX K Ocircumflex -30\nKPX K Odieresis -30\nKPX K Ograve -30\nKPX K Ohungarumlaut -30\nKPX K Omacron -30\nKPX K Oslash -30\nKPX K Otilde -30\nKPX K e -15\nKPX K eacute -15\nKPX K ecaron -15\nKPX K ecircumflex -15\nKPX K edieresis -15\nKPX K edotaccent -15\nKPX K egrave -15\nKPX K emacron -15\nKPX K eogonek -15\nKPX K o -35\nKPX K oacute -35\nKPX K ocircumflex -35\nKPX K odieresis -35\nKPX K ograve -35\nKPX K ohungarumlaut -35\nKPX K omacron -35\nKPX K oslash -35\nKPX K otilde -35\nKPX K u -30\nKPX K uacute -30\nKPX K ucircumflex -30\nKPX K udieresis -30\nKPX K ugrave -30\nKPX K uhungarumlaut -30\nKPX K umacron -30\nKPX K uogonek -30\nKPX K uring -30\nKPX K y -40\nKPX K yacute -40\nKPX K ydieresis -40\nKPX Kcommaaccent O -30\nKPX Kcommaaccent Oacute -30\nKPX Kcommaaccent Ocircumflex -30\nKPX Kcommaaccent Odieresis -30\nKPX Kcommaaccent Ograve -30\nKPX Kcommaaccent Ohungarumlaut -30\nKPX Kcommaaccent Omacron -30\nKPX Kcommaaccent Oslash -30\nKPX Kcommaaccent Otilde -30\nKPX Kcommaaccent e -15\nKPX Kcommaaccent eacute -15\nKPX Kcommaaccent ecaron -15\nKPX Kcommaaccent ecircumflex -15\nKPX Kcommaaccent edieresis -15\nKPX Kcommaaccent edotaccent -15\nKPX Kcommaaccent egrave -15\nKPX Kcommaaccent emacron -15\nKPX Kcommaaccent eogonek -15\nKPX Kcommaaccent o -35\nKPX Kcommaaccent oacute -35\nKPX Kcommaaccent ocircumflex -35\nKPX Kcommaaccent odieresis -35\nKPX Kcommaaccent ograve -35\nKPX Kcommaaccent ohungarumlaut -35\nKPX Kcommaaccent omacron -35\nKPX Kcommaaccent oslash -35\nKPX Kcommaaccent otilde -35\nKPX Kcommaaccent u -30\nKPX Kcommaaccent uacute -30\nKPX Kcommaaccent ucircumflex -30\nKPX Kcommaaccent udieresis -30\nKPX Kcommaaccent ugrave -30\nKPX Kcommaaccent uhungarumlaut -30\nKPX Kcommaaccent umacron -30\nKPX Kcommaaccent uogonek -30\nKPX Kcommaaccent uring -30\nKPX Kcommaaccent y -40\nKPX Kcommaaccent yacute -40\nKPX Kcommaaccent ydieresis -40\nKPX L T -90\nKPX L Tcaron -90\nKPX L Tcommaaccent -90\nKPX L V -110\nKPX L W -80\nKPX L Y -120\nKPX L Yacute -120\nKPX L Ydieresis -120\nKPX L quotedblright -140\nKPX L quoteright -140\nKPX L y -30\nKPX L yacute -30\nKPX L ydieresis -30\nKPX Lacute T -90\nKPX Lacute Tcaron -90\nKPX Lacute Tcommaaccent -90\nKPX Lacute V -110\nKPX Lacute W -80\nKPX Lacute Y -120\nKPX Lacute Yacute -120\nKPX Lacute Ydieresis -120\nKPX Lacute quotedblright -140\nKPX Lacute quoteright -140\nKPX Lacute y -30\nKPX Lacute yacute -30\nKPX Lacute ydieresis -30\nKPX Lcommaaccent T -90\nKPX Lcommaaccent Tcaron -90\nKPX Lcommaaccent Tcommaaccent -90\nKPX Lcommaaccent V -110\nKPX Lcommaaccent W -80\nKPX Lcommaaccent Y -120\nKPX Lcommaaccent Yacute -120\nKPX Lcommaaccent Ydieresis -120\nKPX Lcommaaccent quotedblright -140\nKPX Lcommaaccent quoteright -140\nKPX Lcommaaccent y -30\nKPX Lcommaaccent yacute -30\nKPX Lcommaaccent ydieresis -30\nKPX Lslash T -90\nKPX Lslash Tcaron -90\nKPX Lslash Tcommaaccent -90\nKPX Lslash V -110\nKPX Lslash W -80\nKPX Lslash Y -120\nKPX Lslash Yacute -120\nKPX Lslash Ydieresis -120\nKPX Lslash quotedblright -140\nKPX Lslash quoteright -140\nKPX Lslash y -30\nKPX Lslash yacute -30\nKPX Lslash ydieresis -30\nKPX O A -50\nKPX O Aacute -50\nKPX O Abreve -50\nKPX O Acircumflex -50\nKPX O Adieresis -50\nKPX O Agrave -50\nKPX O Amacron -50\nKPX O Aogonek -50\nKPX O Aring -50\nKPX O Atilde -50\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -50\nKPX O X -50\nKPX O Y -70\nKPX O Yacute -70\nKPX O Ydieresis -70\nKPX O comma -40\nKPX O period -40\nKPX Oacute A -50\nKPX Oacute Aacute -50\nKPX Oacute Abreve -50\nKPX Oacute Acircumflex -50\nKPX Oacute Adieresis -50\nKPX Oacute Agrave -50\nKPX Oacute Amacron -50\nKPX Oacute Aogonek -50\nKPX Oacute Aring -50\nKPX Oacute Atilde -50\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -50\nKPX Oacute X -50\nKPX Oacute Y -70\nKPX Oacute Yacute -70\nKPX Oacute Ydieresis -70\nKPX Oacute comma -40\nKPX Oacute period -40\nKPX Ocircumflex A -50\nKPX Ocircumflex Aacute -50\nKPX Ocircumflex Abreve -50\nKPX Ocircumflex Acircumflex -50\nKPX Ocircumflex Adieresis -50\nKPX Ocircumflex Agrave -50\nKPX Ocircumflex Amacron -50\nKPX Ocircumflex Aogonek -50\nKPX Ocircumflex Aring -50\nKPX Ocircumflex Atilde -50\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -50\nKPX Ocircumflex X -50\nKPX Ocircumflex Y -70\nKPX Ocircumflex Yacute -70\nKPX Ocircumflex Ydieresis -70\nKPX Ocircumflex comma -40\nKPX Ocircumflex period -40\nKPX Odieresis A -50\nKPX Odieresis Aacute -50\nKPX Odieresis Abreve -50\nKPX Odieresis Acircumflex -50\nKPX Odieresis Adieresis -50\nKPX Odieresis Agrave -50\nKPX Odieresis Amacron -50\nKPX Odieresis Aogonek -50\nKPX Odieresis Aring -50\nKPX Odieresis Atilde -50\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -50\nKPX Odieresis X -50\nKPX Odieresis Y -70\nKPX Odieresis Yacute -70\nKPX Odieresis Ydieresis -70\nKPX Odieresis comma -40\nKPX Odieresis period -40\nKPX Ograve A -50\nKPX Ograve Aacute -50\nKPX Ograve Abreve -50\nKPX Ograve Acircumflex -50\nKPX Ograve Adieresis -50\nKPX Ograve Agrave -50\nKPX Ograve Amacron -50\nKPX Ograve Aogonek -50\nKPX Ograve Aring -50\nKPX Ograve Atilde -50\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -50\nKPX Ograve X -50\nKPX Ograve Y -70\nKPX Ograve Yacute -70\nKPX Ograve Ydieresis -70\nKPX Ograve comma -40\nKPX Ograve period -40\nKPX Ohungarumlaut A -50\nKPX Ohungarumlaut Aacute -50\nKPX Ohungarumlaut Abreve -50\nKPX Ohungarumlaut Acircumflex -50\nKPX Ohungarumlaut Adieresis -50\nKPX Ohungarumlaut Agrave -50\nKPX Ohungarumlaut Amacron -50\nKPX Ohungarumlaut Aogonek -50\nKPX Ohungarumlaut Aring -50\nKPX Ohungarumlaut Atilde -50\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -50\nKPX Ohungarumlaut X -50\nKPX Ohungarumlaut Y -70\nKPX Ohungarumlaut Yacute -70\nKPX Ohungarumlaut Ydieresis -70\nKPX Ohungarumlaut comma -40\nKPX Ohungarumlaut period -40\nKPX Omacron A -50\nKPX Omacron Aacute -50\nKPX Omacron Abreve -50\nKPX Omacron Acircumflex -50\nKPX Omacron Adieresis -50\nKPX Omacron Agrave -50\nKPX Omacron Amacron -50\nKPX Omacron Aogonek -50\nKPX Omacron Aring -50\nKPX Omacron Atilde -50\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -50\nKPX Omacron X -50\nKPX Omacron Y -70\nKPX Omacron Yacute -70\nKPX Omacron Ydieresis -70\nKPX Omacron comma -40\nKPX Omacron period -40\nKPX Oslash A -50\nKPX Oslash Aacute -50\nKPX Oslash Abreve -50\nKPX Oslash Acircumflex -50\nKPX Oslash Adieresis -50\nKPX Oslash Agrave -50\nKPX Oslash Amacron -50\nKPX Oslash Aogonek -50\nKPX Oslash Aring -50\nKPX Oslash Atilde -50\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -50\nKPX Oslash X -50\nKPX Oslash Y -70\nKPX Oslash Yacute -70\nKPX Oslash Ydieresis -70\nKPX Oslash comma -40\nKPX Oslash period -40\nKPX Otilde A -50\nKPX Otilde Aacute -50\nKPX Otilde Abreve -50\nKPX Otilde Acircumflex -50\nKPX Otilde Adieresis -50\nKPX Otilde Agrave -50\nKPX Otilde Amacron -50\nKPX Otilde Aogonek -50\nKPX Otilde Aring -50\nKPX Otilde Atilde -50\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -50\nKPX Otilde X -50\nKPX Otilde Y -70\nKPX Otilde Yacute -70\nKPX Otilde Ydieresis -70\nKPX Otilde comma -40\nKPX Otilde period -40\nKPX P A -100\nKPX P Aacute -100\nKPX P Abreve -100\nKPX P Acircumflex -100\nKPX P Adieresis -100\nKPX P Agrave -100\nKPX P Amacron -100\nKPX P Aogonek -100\nKPX P Aring -100\nKPX P Atilde -100\nKPX P a -30\nKPX P aacute -30\nKPX P abreve -30\nKPX P acircumflex -30\nKPX P adieresis -30\nKPX P agrave -30\nKPX P amacron -30\nKPX P aogonek -30\nKPX P aring -30\nKPX P atilde -30\nKPX P comma -120\nKPX P e -30\nKPX P eacute -30\nKPX P ecaron -30\nKPX P ecircumflex -30\nKPX P edieresis -30\nKPX P edotaccent -30\nKPX P egrave -30\nKPX P emacron -30\nKPX P eogonek -30\nKPX P o -40\nKPX P oacute -40\nKPX P ocircumflex -40\nKPX P odieresis -40\nKPX P ograve -40\nKPX P ohungarumlaut -40\nKPX P omacron -40\nKPX P oslash -40\nKPX P otilde -40\nKPX P period -120\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX Q comma 20\nKPX Q period 20\nKPX R O -20\nKPX R Oacute -20\nKPX R Ocircumflex -20\nKPX R Odieresis -20\nKPX R Ograve -20\nKPX R Ohungarumlaut -20\nKPX R Omacron -20\nKPX R Oslash -20\nKPX R Otilde -20\nKPX R T -20\nKPX R Tcaron -20\nKPX R Tcommaaccent -20\nKPX R U -20\nKPX R Uacute -20\nKPX R Ucircumflex -20\nKPX R Udieresis -20\nKPX R Ugrave -20\nKPX R Uhungarumlaut -20\nKPX R Umacron -20\nKPX R Uogonek -20\nKPX R Uring -20\nKPX R V -50\nKPX R W -40\nKPX R Y -50\nKPX R Yacute -50\nKPX R Ydieresis -50\nKPX Racute O -20\nKPX Racute Oacute -20\nKPX Racute Ocircumflex -20\nKPX Racute Odieresis -20\nKPX Racute Ograve -20\nKPX Racute Ohungarumlaut -20\nKPX Racute Omacron -20\nKPX Racute Oslash -20\nKPX Racute Otilde -20\nKPX Racute T -20\nKPX Racute Tcaron -20\nKPX Racute Tcommaaccent -20\nKPX Racute U -20\nKPX Racute Uacute -20\nKPX Racute Ucircumflex -20\nKPX Racute Udieresis -20\nKPX Racute Ugrave -20\nKPX Racute Uhungarumlaut -20\nKPX Racute Umacron -20\nKPX Racute Uogonek -20\nKPX Racute Uring -20\nKPX Racute V -50\nKPX Racute W -40\nKPX Racute Y -50\nKPX Racute Yacute -50\nKPX Racute Ydieresis -50\nKPX Rcaron O -20\nKPX Rcaron Oacute -20\nKPX Rcaron Ocircumflex -20\nKPX Rcaron Odieresis -20\nKPX Rcaron Ograve -20\nKPX Rcaron Ohungarumlaut -20\nKPX Rcaron Omacron -20\nKPX Rcaron Oslash -20\nKPX Rcaron Otilde -20\nKPX Rcaron T -20\nKPX Rcaron Tcaron -20\nKPX Rcaron Tcommaaccent -20\nKPX Rcaron U -20\nKPX Rcaron Uacute -20\nKPX Rcaron Ucircumflex -20\nKPX Rcaron Udieresis -20\nKPX Rcaron Ugrave -20\nKPX Rcaron Uhungarumlaut -20\nKPX Rcaron Umacron -20\nKPX Rcaron Uogonek -20\nKPX Rcaron Uring -20\nKPX Rcaron V -50\nKPX Rcaron W -40\nKPX Rcaron Y -50\nKPX Rcaron Yacute -50\nKPX Rcaron Ydieresis -50\nKPX Rcommaaccent O -20\nKPX Rcommaaccent Oacute -20\nKPX Rcommaaccent Ocircumflex -20\nKPX Rcommaaccent Odieresis -20\nKPX Rcommaaccent Ograve -20\nKPX Rcommaaccent Ohungarumlaut -20\nKPX Rcommaaccent Omacron -20\nKPX Rcommaaccent Oslash -20\nKPX Rcommaaccent Otilde -20\nKPX Rcommaaccent T -20\nKPX Rcommaaccent Tcaron -20\nKPX Rcommaaccent Tcommaaccent -20\nKPX Rcommaaccent U -20\nKPX Rcommaaccent Uacute -20\nKPX Rcommaaccent Ucircumflex -20\nKPX Rcommaaccent Udieresis -20\nKPX Rcommaaccent Ugrave -20\nKPX Rcommaaccent Uhungarumlaut -20\nKPX Rcommaaccent Umacron -20\nKPX Rcommaaccent Uogonek -20\nKPX Rcommaaccent Uring -20\nKPX Rcommaaccent V -50\nKPX Rcommaaccent W -40\nKPX Rcommaaccent Y -50\nKPX Rcommaaccent Yacute -50\nKPX Rcommaaccent Ydieresis -50\nKPX T A -90\nKPX T Aacute -90\nKPX T Abreve -90\nKPX T Acircumflex -90\nKPX T Adieresis -90\nKPX T Agrave -90\nKPX T Amacron -90\nKPX T Aogonek -90\nKPX T Aring -90\nKPX T Atilde -90\nKPX T O -40\nKPX T Oacute -40\nKPX T Ocircumflex -40\nKPX T Odieresis -40\nKPX T Ograve -40\nKPX T Ohungarumlaut -40\nKPX T Omacron -40\nKPX T Oslash -40\nKPX T Otilde -40\nKPX T a -80\nKPX T aacute -80\nKPX T abreve -80\nKPX T acircumflex -80\nKPX T adieresis -80\nKPX T agrave -80\nKPX T amacron -80\nKPX T aogonek -80\nKPX T aring -80\nKPX T atilde -80\nKPX T colon -40\nKPX T comma -80\nKPX T e -60\nKPX T eacute -60\nKPX T ecaron -60\nKPX T ecircumflex -60\nKPX T edieresis -60\nKPX T edotaccent -60\nKPX T egrave -60\nKPX T emacron -60\nKPX T eogonek -60\nKPX T hyphen -120\nKPX T o -80\nKPX T oacute -80\nKPX T ocircumflex -80\nKPX T odieresis -80\nKPX T ograve -80\nKPX T ohungarumlaut -80\nKPX T omacron -80\nKPX T oslash -80\nKPX T otilde -80\nKPX T period -80\nKPX T r -80\nKPX T racute -80\nKPX T rcommaaccent -80\nKPX T semicolon -40\nKPX T u -90\nKPX T uacute -90\nKPX T ucircumflex -90\nKPX T udieresis -90\nKPX T ugrave -90\nKPX T uhungarumlaut -90\nKPX T umacron -90\nKPX T uogonek -90\nKPX T uring -90\nKPX T w -60\nKPX T y -60\nKPX T yacute -60\nKPX T ydieresis -60\nKPX Tcaron A -90\nKPX Tcaron Aacute -90\nKPX Tcaron Abreve -90\nKPX Tcaron Acircumflex -90\nKPX Tcaron Adieresis -90\nKPX Tcaron Agrave -90\nKPX Tcaron Amacron -90\nKPX Tcaron Aogonek -90\nKPX Tcaron Aring -90\nKPX Tcaron Atilde -90\nKPX Tcaron O -40\nKPX Tcaron Oacute -40\nKPX Tcaron Ocircumflex -40\nKPX Tcaron Odieresis -40\nKPX Tcaron Ograve -40\nKPX Tcaron Ohungarumlaut -40\nKPX Tcaron Omacron -40\nKPX Tcaron Oslash -40\nKPX Tcaron Otilde -40\nKPX Tcaron a -80\nKPX Tcaron aacute -80\nKPX Tcaron abreve -80\nKPX Tcaron acircumflex -80\nKPX Tcaron adieresis -80\nKPX Tcaron agrave -80\nKPX Tcaron amacron -80\nKPX Tcaron aogonek -80\nKPX Tcaron aring -80\nKPX Tcaron atilde -80\nKPX Tcaron colon -40\nKPX Tcaron comma -80\nKPX Tcaron e -60\nKPX Tcaron eacute -60\nKPX Tcaron ecaron -60\nKPX Tcaron ecircumflex -60\nKPX Tcaron edieresis -60\nKPX Tcaron edotaccent -60\nKPX Tcaron egrave -60\nKPX Tcaron emacron -60\nKPX Tcaron eogonek -60\nKPX Tcaron hyphen -120\nKPX Tcaron o -80\nKPX Tcaron oacute -80\nKPX Tcaron ocircumflex -80\nKPX Tcaron odieresis -80\nKPX Tcaron ograve -80\nKPX Tcaron ohungarumlaut -80\nKPX Tcaron omacron -80\nKPX Tcaron oslash -80\nKPX Tcaron otilde -80\nKPX Tcaron period -80\nKPX Tcaron r -80\nKPX Tcaron racute -80\nKPX Tcaron rcommaaccent -80\nKPX Tcaron semicolon -40\nKPX Tcaron u -90\nKPX Tcaron uacute -90\nKPX Tcaron ucircumflex -90\nKPX Tcaron udieresis -90\nKPX Tcaron ugrave -90\nKPX Tcaron uhungarumlaut -90\nKPX Tcaron umacron -90\nKPX Tcaron uogonek -90\nKPX Tcaron uring -90\nKPX Tcaron w -60\nKPX Tcaron y -60\nKPX Tcaron yacute -60\nKPX Tcaron ydieresis -60\nKPX Tcommaaccent A -90\nKPX Tcommaaccent Aacute -90\nKPX Tcommaaccent Abreve -90\nKPX Tcommaaccent Acircumflex -90\nKPX Tcommaaccent Adieresis -90\nKPX Tcommaaccent Agrave -90\nKPX Tcommaaccent Amacron -90\nKPX Tcommaaccent Aogonek -90\nKPX Tcommaaccent Aring -90\nKPX Tcommaaccent Atilde -90\nKPX Tcommaaccent O -40\nKPX Tcommaaccent Oacute -40\nKPX Tcommaaccent Ocircumflex -40\nKPX Tcommaaccent Odieresis -40\nKPX Tcommaaccent Ograve -40\nKPX Tcommaaccent Ohungarumlaut -40\nKPX Tcommaaccent Omacron -40\nKPX Tcommaaccent Oslash -40\nKPX Tcommaaccent Otilde -40\nKPX Tcommaaccent a -80\nKPX Tcommaaccent aacute -80\nKPX Tcommaaccent abreve -80\nKPX Tcommaaccent acircumflex -80\nKPX Tcommaaccent adieresis -80\nKPX Tcommaaccent agrave -80\nKPX Tcommaaccent amacron -80\nKPX Tcommaaccent aogonek -80\nKPX Tcommaaccent aring -80\nKPX Tcommaaccent atilde -80\nKPX Tcommaaccent colon -40\nKPX Tcommaaccent comma -80\nKPX Tcommaaccent e -60\nKPX Tcommaaccent eacute -60\nKPX Tcommaaccent ecaron -60\nKPX Tcommaaccent ecircumflex -60\nKPX Tcommaaccent edieresis -60\nKPX Tcommaaccent edotaccent -60\nKPX Tcommaaccent egrave -60\nKPX Tcommaaccent emacron -60\nKPX Tcommaaccent eogonek -60\nKPX Tcommaaccent hyphen -120\nKPX Tcommaaccent o -80\nKPX Tcommaaccent oacute -80\nKPX Tcommaaccent ocircumflex -80\nKPX Tcommaaccent odieresis -80\nKPX Tcommaaccent ograve -80\nKPX Tcommaaccent ohungarumlaut -80\nKPX Tcommaaccent omacron -80\nKPX Tcommaaccent oslash -80\nKPX Tcommaaccent otilde -80\nKPX Tcommaaccent period -80\nKPX Tcommaaccent r -80\nKPX Tcommaaccent racute -80\nKPX Tcommaaccent rcommaaccent -80\nKPX Tcommaaccent semicolon -40\nKPX Tcommaaccent u -90\nKPX Tcommaaccent uacute -90\nKPX Tcommaaccent ucircumflex -90\nKPX Tcommaaccent udieresis -90\nKPX Tcommaaccent ugrave -90\nKPX Tcommaaccent uhungarumlaut -90\nKPX Tcommaaccent umacron -90\nKPX Tcommaaccent uogonek -90\nKPX Tcommaaccent uring -90\nKPX Tcommaaccent w -60\nKPX Tcommaaccent y -60\nKPX Tcommaaccent yacute -60\nKPX Tcommaaccent ydieresis -60\nKPX U A -50\nKPX U Aacute -50\nKPX U Abreve -50\nKPX U Acircumflex -50\nKPX U Adieresis -50\nKPX U Agrave -50\nKPX U Amacron -50\nKPX U Aogonek -50\nKPX U Aring -50\nKPX U Atilde -50\nKPX U comma -30\nKPX U period -30\nKPX Uacute A -50\nKPX Uacute Aacute -50\nKPX Uacute Abreve -50\nKPX Uacute Acircumflex -50\nKPX Uacute Adieresis -50\nKPX Uacute Agrave -50\nKPX Uacute Amacron -50\nKPX Uacute Aogonek -50\nKPX Uacute Aring -50\nKPX Uacute Atilde -50\nKPX Uacute comma -30\nKPX Uacute period -30\nKPX Ucircumflex A -50\nKPX Ucircumflex Aacute -50\nKPX Ucircumflex Abreve -50\nKPX Ucircumflex Acircumflex -50\nKPX Ucircumflex Adieresis -50\nKPX Ucircumflex Agrave -50\nKPX Ucircumflex Amacron -50\nKPX Ucircumflex Aogonek -50\nKPX Ucircumflex Aring -50\nKPX Ucircumflex Atilde -50\nKPX Ucircumflex comma -30\nKPX Ucircumflex period -30\nKPX Udieresis A -50\nKPX Udieresis Aacute -50\nKPX Udieresis Abreve -50\nKPX Udieresis Acircumflex -50\nKPX Udieresis Adieresis -50\nKPX Udieresis Agrave -50\nKPX Udieresis Amacron -50\nKPX Udieresis Aogonek -50\nKPX Udieresis Aring -50\nKPX Udieresis Atilde -50\nKPX Udieresis comma -30\nKPX Udieresis period -30\nKPX Ugrave A -50\nKPX Ugrave Aacute -50\nKPX Ugrave Abreve -50\nKPX Ugrave Acircumflex -50\nKPX Ugrave Adieresis -50\nKPX Ugrave Agrave -50\nKPX Ugrave Amacron -50\nKPX Ugrave Aogonek -50\nKPX Ugrave Aring -50\nKPX Ugrave Atilde -50\nKPX Ugrave comma -30\nKPX Ugrave period -30\nKPX Uhungarumlaut A -50\nKPX Uhungarumlaut Aacute -50\nKPX Uhungarumlaut Abreve -50\nKPX Uhungarumlaut Acircumflex -50\nKPX Uhungarumlaut Adieresis -50\nKPX Uhungarumlaut Agrave -50\nKPX Uhungarumlaut Amacron -50\nKPX Uhungarumlaut Aogonek -50\nKPX Uhungarumlaut Aring -50\nKPX Uhungarumlaut Atilde -50\nKPX Uhungarumlaut comma -30\nKPX Uhungarumlaut period -30\nKPX Umacron A -50\nKPX Umacron Aacute -50\nKPX Umacron Abreve -50\nKPX Umacron Acircumflex -50\nKPX Umacron Adieresis -50\nKPX Umacron Agrave -50\nKPX Umacron Amacron -50\nKPX Umacron Aogonek -50\nKPX Umacron Aring -50\nKPX Umacron Atilde -50\nKPX Umacron comma -30\nKPX Umacron period -30\nKPX Uogonek A -50\nKPX Uogonek Aacute -50\nKPX Uogonek Abreve -50\nKPX Uogonek Acircumflex -50\nKPX Uogonek Adieresis -50\nKPX Uogonek Agrave -50\nKPX Uogonek Amacron -50\nKPX Uogonek Aogonek -50\nKPX Uogonek Aring -50\nKPX Uogonek Atilde -50\nKPX Uogonek comma -30\nKPX Uogonek period -30\nKPX Uring A -50\nKPX Uring Aacute -50\nKPX Uring Abreve -50\nKPX Uring Acircumflex -50\nKPX Uring Adieresis -50\nKPX Uring Agrave -50\nKPX Uring Amacron -50\nKPX Uring Aogonek -50\nKPX Uring Aring -50\nKPX Uring Atilde -50\nKPX Uring comma -30\nKPX Uring period -30\nKPX V A -80\nKPX V Aacute -80\nKPX V Abreve -80\nKPX V Acircumflex -80\nKPX V Adieresis -80\nKPX V Agrave -80\nKPX V Amacron -80\nKPX V Aogonek -80\nKPX V Aring -80\nKPX V Atilde -80\nKPX V G -50\nKPX V Gbreve -50\nKPX V Gcommaaccent -50\nKPX V O -50\nKPX V Oacute -50\nKPX V Ocircumflex -50\nKPX V Odieresis -50\nKPX V Ograve -50\nKPX V Ohungarumlaut -50\nKPX V Omacron -50\nKPX V Oslash -50\nKPX V Otilde -50\nKPX V a -60\nKPX V aacute -60\nKPX V abreve -60\nKPX V acircumflex -60\nKPX V adieresis -60\nKPX V agrave -60\nKPX V amacron -60\nKPX V aogonek -60\nKPX V aring -60\nKPX V atilde -60\nKPX V colon -40\nKPX V comma -120\nKPX V e -50\nKPX V eacute -50\nKPX V ecaron -50\nKPX V ecircumflex -50\nKPX V edieresis -50\nKPX V edotaccent -50\nKPX V egrave -50\nKPX V emacron -50\nKPX V eogonek -50\nKPX V hyphen -80\nKPX V o -90\nKPX V oacute -90\nKPX V ocircumflex -90\nKPX V odieresis -90\nKPX V ograve -90\nKPX V ohungarumlaut -90\nKPX V omacron -90\nKPX V oslash -90\nKPX V otilde -90\nKPX V period -120\nKPX V semicolon -40\nKPX V u -60\nKPX V uacute -60\nKPX V ucircumflex -60\nKPX V udieresis -60\nKPX V ugrave -60\nKPX V uhungarumlaut -60\nKPX V umacron -60\nKPX V uogonek -60\nKPX V uring -60\nKPX W A -60\nKPX W Aacute -60\nKPX W Abreve -60\nKPX W Acircumflex -60\nKPX W Adieresis -60\nKPX W Agrave -60\nKPX W Amacron -60\nKPX W Aogonek -60\nKPX W Aring -60\nKPX W Atilde -60\nKPX W O -20\nKPX W Oacute -20\nKPX W Ocircumflex -20\nKPX W Odieresis -20\nKPX W Ograve -20\nKPX W Ohungarumlaut -20\nKPX W Omacron -20\nKPX W Oslash -20\nKPX W Otilde -20\nKPX W a -40\nKPX W aacute -40\nKPX W abreve -40\nKPX W acircumflex -40\nKPX W adieresis -40\nKPX W agrave -40\nKPX W amacron -40\nKPX W aogonek -40\nKPX W aring -40\nKPX W atilde -40\nKPX W colon -10\nKPX W comma -80\nKPX W e -35\nKPX W eacute -35\nKPX W ecaron -35\nKPX W ecircumflex -35\nKPX W edieresis -35\nKPX W edotaccent -35\nKPX W egrave -35\nKPX W emacron -35\nKPX W eogonek -35\nKPX W hyphen -40\nKPX W o -60\nKPX W oacute -60\nKPX W ocircumflex -60\nKPX W odieresis -60\nKPX W ograve -60\nKPX W ohungarumlaut -60\nKPX W omacron -60\nKPX W oslash -60\nKPX W otilde -60\nKPX W period -80\nKPX W semicolon -10\nKPX W u -45\nKPX W uacute -45\nKPX W ucircumflex -45\nKPX W udieresis -45\nKPX W ugrave -45\nKPX W uhungarumlaut -45\nKPX W umacron -45\nKPX W uogonek -45\nKPX W uring -45\nKPX W y -20\nKPX W yacute -20\nKPX W ydieresis -20\nKPX Y A -110\nKPX Y Aacute -110\nKPX Y Abreve -110\nKPX Y Acircumflex -110\nKPX Y Adieresis -110\nKPX Y Agrave -110\nKPX Y Amacron -110\nKPX Y Aogonek -110\nKPX Y Aring -110\nKPX Y Atilde -110\nKPX Y O -70\nKPX Y Oacute -70\nKPX Y Ocircumflex -70\nKPX Y Odieresis -70\nKPX Y Ograve -70\nKPX Y Ohungarumlaut -70\nKPX Y Omacron -70\nKPX Y Oslash -70\nKPX Y Otilde -70\nKPX Y a -90\nKPX Y aacute -90\nKPX Y abreve -90\nKPX Y acircumflex -90\nKPX Y adieresis -90\nKPX Y agrave -90\nKPX Y amacron -90\nKPX Y aogonek -90\nKPX Y aring -90\nKPX Y atilde -90\nKPX Y colon -50\nKPX Y comma -100\nKPX Y e -80\nKPX Y eacute -80\nKPX Y ecaron -80\nKPX Y ecircumflex -80\nKPX Y edieresis -80\nKPX Y edotaccent -80\nKPX Y egrave -80\nKPX Y emacron -80\nKPX Y eogonek -80\nKPX Y o -100\nKPX Y oacute -100\nKPX Y ocircumflex -100\nKPX Y odieresis -100\nKPX Y ograve -100\nKPX Y ohungarumlaut -100\nKPX Y omacron -100\nKPX Y oslash -100\nKPX Y otilde -100\nKPX Y period -100\nKPX Y semicolon -50\nKPX Y u -100\nKPX Y uacute -100\nKPX Y ucircumflex -100\nKPX Y udieresis -100\nKPX Y ugrave -100\nKPX Y uhungarumlaut -100\nKPX Y umacron -100\nKPX Y uogonek -100\nKPX Y uring -100\nKPX Yacute A -110\nKPX Yacute Aacute -110\nKPX Yacute Abreve -110\nKPX Yacute Acircumflex -110\nKPX Yacute Adieresis -110\nKPX Yacute Agrave -110\nKPX Yacute Amacron -110\nKPX Yacute Aogonek -110\nKPX Yacute Aring -110\nKPX Yacute Atilde -110\nKPX Yacute O -70\nKPX Yacute Oacute -70\nKPX Yacute Ocircumflex -70\nKPX Yacute Odieresis -70\nKPX Yacute Ograve -70\nKPX Yacute Ohungarumlaut -70\nKPX Yacute Omacron -70\nKPX Yacute Oslash -70\nKPX Yacute Otilde -70\nKPX Yacute a -90\nKPX Yacute aacute -90\nKPX Yacute abreve -90\nKPX Yacute acircumflex -90\nKPX Yacute adieresis -90\nKPX Yacute agrave -90\nKPX Yacute amacron -90\nKPX Yacute aogonek -90\nKPX Yacute aring -90\nKPX Yacute atilde -90\nKPX Yacute colon -50\nKPX Yacute comma -100\nKPX Yacute e -80\nKPX Yacute eacute -80\nKPX Yacute ecaron -80\nKPX Yacute ecircumflex -80\nKPX Yacute edieresis -80\nKPX Yacute edotaccent -80\nKPX Yacute egrave -80\nKPX Yacute emacron -80\nKPX Yacute eogonek -80\nKPX Yacute o -100\nKPX Yacute oacute -100\nKPX Yacute ocircumflex -100\nKPX Yacute odieresis -100\nKPX Yacute ograve -100\nKPX Yacute ohungarumlaut -100\nKPX Yacute omacron -100\nKPX Yacute oslash -100\nKPX Yacute otilde -100\nKPX Yacute period -100\nKPX Yacute semicolon -50\nKPX Yacute u -100\nKPX Yacute uacute -100\nKPX Yacute ucircumflex -100\nKPX Yacute udieresis -100\nKPX Yacute ugrave -100\nKPX Yacute uhungarumlaut -100\nKPX Yacute umacron -100\nKPX Yacute uogonek -100\nKPX Yacute uring -100\nKPX Ydieresis A -110\nKPX Ydieresis Aacute -110\nKPX Ydieresis Abreve -110\nKPX Ydieresis Acircumflex -110\nKPX Ydieresis Adieresis -110\nKPX Ydieresis Agrave -110\nKPX Ydieresis Amacron -110\nKPX Ydieresis Aogonek -110\nKPX Ydieresis Aring -110\nKPX Ydieresis Atilde -110\nKPX Ydieresis O -70\nKPX Ydieresis Oacute -70\nKPX Ydieresis Ocircumflex -70\nKPX Ydieresis Odieresis -70\nKPX Ydieresis Ograve -70\nKPX Ydieresis Ohungarumlaut -70\nKPX Ydieresis Omacron -70\nKPX Ydieresis Oslash -70\nKPX Ydieresis Otilde -70\nKPX Ydieresis a -90\nKPX Ydieresis aacute -90\nKPX Ydieresis abreve -90\nKPX Ydieresis acircumflex -90\nKPX Ydieresis adieresis -90\nKPX Ydieresis agrave -90\nKPX Ydieresis amacron -90\nKPX Ydieresis aogonek -90\nKPX Ydieresis aring -90\nKPX Ydieresis atilde -90\nKPX Ydieresis colon -50\nKPX Ydieresis comma -100\nKPX Ydieresis e -80\nKPX Ydieresis eacute -80\nKPX Ydieresis ecaron -80\nKPX Ydieresis ecircumflex -80\nKPX Ydieresis edieresis -80\nKPX Ydieresis edotaccent -80\nKPX Ydieresis egrave -80\nKPX Ydieresis emacron -80\nKPX Ydieresis eogonek -80\nKPX Ydieresis o -100\nKPX Ydieresis oacute -100\nKPX Ydieresis ocircumflex -100\nKPX Ydieresis odieresis -100\nKPX Ydieresis ograve -100\nKPX Ydieresis ohungarumlaut -100\nKPX Ydieresis omacron -100\nKPX Ydieresis oslash -100\nKPX Ydieresis otilde -100\nKPX Ydieresis period -100\nKPX Ydieresis semicolon -50\nKPX Ydieresis u -100\nKPX Ydieresis uacute -100\nKPX Ydieresis ucircumflex -100\nKPX Ydieresis udieresis -100\nKPX Ydieresis ugrave -100\nKPX Ydieresis uhungarumlaut -100\nKPX Ydieresis umacron -100\nKPX Ydieresis uogonek -100\nKPX Ydieresis uring -100\nKPX a g -10\nKPX a gbreve -10\nKPX a gcommaaccent -10\nKPX a v -15\nKPX a w -15\nKPX a y -20\nKPX a yacute -20\nKPX a ydieresis -20\nKPX aacute g -10\nKPX aacute gbreve -10\nKPX aacute gcommaaccent -10\nKPX aacute v -15\nKPX aacute w -15\nKPX aacute y -20\nKPX aacute yacute -20\nKPX aacute ydieresis -20\nKPX abreve g -10\nKPX abreve gbreve -10\nKPX abreve gcommaaccent -10\nKPX abreve v -15\nKPX abreve w -15\nKPX abreve y -20\nKPX abreve yacute -20\nKPX abreve ydieresis -20\nKPX acircumflex g -10\nKPX acircumflex gbreve -10\nKPX acircumflex gcommaaccent -10\nKPX acircumflex v -15\nKPX acircumflex w -15\nKPX acircumflex y -20\nKPX acircumflex yacute -20\nKPX acircumflex ydieresis -20\nKPX adieresis g -10\nKPX adieresis gbreve -10\nKPX adieresis gcommaaccent -10\nKPX adieresis v -15\nKPX adieresis w -15\nKPX adieresis y -20\nKPX adieresis yacute -20\nKPX adieresis ydieresis -20\nKPX agrave g -10\nKPX agrave gbreve -10\nKPX agrave gcommaaccent -10\nKPX agrave v -15\nKPX agrave w -15\nKPX agrave y -20\nKPX agrave yacute -20\nKPX agrave ydieresis -20\nKPX amacron g -10\nKPX amacron gbreve -10\nKPX amacron gcommaaccent -10\nKPX amacron v -15\nKPX amacron w -15\nKPX amacron y -20\nKPX amacron yacute -20\nKPX amacron ydieresis -20\nKPX aogonek g -10\nKPX aogonek gbreve -10\nKPX aogonek gcommaaccent -10\nKPX aogonek v -15\nKPX aogonek w -15\nKPX aogonek y -20\nKPX aogonek yacute -20\nKPX aogonek ydieresis -20\nKPX aring g -10\nKPX aring gbreve -10\nKPX aring gcommaaccent -10\nKPX aring v -15\nKPX aring w -15\nKPX aring y -20\nKPX aring yacute -20\nKPX aring ydieresis -20\nKPX atilde g -10\nKPX atilde gbreve -10\nKPX atilde gcommaaccent -10\nKPX atilde v -15\nKPX atilde w -15\nKPX atilde y -20\nKPX atilde yacute -20\nKPX atilde ydieresis -20\nKPX b l -10\nKPX b lacute -10\nKPX b lcommaaccent -10\nKPX b lslash -10\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX b v -20\nKPX b y -20\nKPX b yacute -20\nKPX b ydieresis -20\nKPX c h -10\nKPX c k -20\nKPX c kcommaaccent -20\nKPX c l -20\nKPX c lacute -20\nKPX c lcommaaccent -20\nKPX c lslash -20\nKPX c y -10\nKPX c yacute -10\nKPX c ydieresis -10\nKPX cacute h -10\nKPX cacute k -20\nKPX cacute kcommaaccent -20\nKPX cacute l -20\nKPX cacute lacute -20\nKPX cacute lcommaaccent -20\nKPX cacute lslash -20\nKPX cacute y -10\nKPX cacute yacute -10\nKPX cacute ydieresis -10\nKPX ccaron h -10\nKPX ccaron k -20\nKPX ccaron kcommaaccent -20\nKPX ccaron l -20\nKPX ccaron lacute -20\nKPX ccaron lcommaaccent -20\nKPX ccaron lslash -20\nKPX ccaron y -10\nKPX ccaron yacute -10\nKPX ccaron ydieresis -10\nKPX ccedilla h -10\nKPX ccedilla k -20\nKPX ccedilla kcommaaccent -20\nKPX ccedilla l -20\nKPX ccedilla lacute -20\nKPX ccedilla lcommaaccent -20\nKPX ccedilla lslash -20\nKPX ccedilla y -10\nKPX ccedilla yacute -10\nKPX ccedilla ydieresis -10\nKPX colon space -40\nKPX comma quotedblright -120\nKPX comma quoteright -120\nKPX comma space -40\nKPX d d -10\nKPX d dcroat -10\nKPX d v -15\nKPX d w -15\nKPX d y -15\nKPX d yacute -15\nKPX d ydieresis -15\nKPX dcroat d -10\nKPX dcroat dcroat -10\nKPX dcroat v -15\nKPX dcroat w -15\nKPX dcroat y -15\nKPX dcroat yacute -15\nKPX dcroat ydieresis -15\nKPX e comma 10\nKPX e period 20\nKPX e v -15\nKPX e w -15\nKPX e x -15\nKPX e y -15\nKPX e yacute -15\nKPX e ydieresis -15\nKPX eacute comma 10\nKPX eacute period 20\nKPX eacute v -15\nKPX eacute w -15\nKPX eacute x -15\nKPX eacute y -15\nKPX eacute yacute -15\nKPX eacute ydieresis -15\nKPX ecaron comma 10\nKPX ecaron period 20\nKPX ecaron v -15\nKPX ecaron w -15\nKPX ecaron x -15\nKPX ecaron y -15\nKPX ecaron yacute -15\nKPX ecaron ydieresis -15\nKPX ecircumflex comma 10\nKPX ecircumflex period 20\nKPX ecircumflex v -15\nKPX ecircumflex w -15\nKPX ecircumflex x -15\nKPX ecircumflex y -15\nKPX ecircumflex yacute -15\nKPX ecircumflex ydieresis -15\nKPX edieresis comma 10\nKPX edieresis period 20\nKPX edieresis v -15\nKPX edieresis w -15\nKPX edieresis x -15\nKPX edieresis y -15\nKPX edieresis yacute -15\nKPX edieresis ydieresis -15\nKPX edotaccent comma 10\nKPX edotaccent period 20\nKPX edotaccent v -15\nKPX edotaccent w -15\nKPX edotaccent x -15\nKPX edotaccent y -15\nKPX edotaccent yacute -15\nKPX edotaccent ydieresis -15\nKPX egrave comma 10\nKPX egrave period 20\nKPX egrave v -15\nKPX egrave w -15\nKPX egrave x -15\nKPX egrave y -15\nKPX egrave yacute -15\nKPX egrave ydieresis -15\nKPX emacron comma 10\nKPX emacron period 20\nKPX emacron v -15\nKPX emacron w -15\nKPX emacron x -15\nKPX emacron y -15\nKPX emacron yacute -15\nKPX emacron ydieresis -15\nKPX eogonek comma 10\nKPX eogonek period 20\nKPX eogonek v -15\nKPX eogonek w -15\nKPX eogonek x -15\nKPX eogonek y -15\nKPX eogonek yacute -15\nKPX eogonek ydieresis -15\nKPX f comma -10\nKPX f e -10\nKPX f eacute -10\nKPX f ecaron -10\nKPX f ecircumflex -10\nKPX f edieresis -10\nKPX f edotaccent -10\nKPX f egrave -10\nKPX f emacron -10\nKPX f eogonek -10\nKPX f o -20\nKPX f oacute -20\nKPX f ocircumflex -20\nKPX f odieresis -20\nKPX f ograve -20\nKPX f ohungarumlaut -20\nKPX f omacron -20\nKPX f oslash -20\nKPX f otilde -20\nKPX f period -10\nKPX f quotedblright 30\nKPX f quoteright 30\nKPX g e 10\nKPX g eacute 10\nKPX g ecaron 10\nKPX g ecircumflex 10\nKPX g edieresis 10\nKPX g edotaccent 10\nKPX g egrave 10\nKPX g emacron 10\nKPX g eogonek 10\nKPX g g -10\nKPX g gbreve -10\nKPX g gcommaaccent -10\nKPX gbreve e 10\nKPX gbreve eacute 10\nKPX gbreve ecaron 10\nKPX gbreve ecircumflex 10\nKPX gbreve edieresis 10\nKPX gbreve edotaccent 10\nKPX gbreve egrave 10\nKPX gbreve emacron 10\nKPX gbreve eogonek 10\nKPX gbreve g -10\nKPX gbreve gbreve -10\nKPX gbreve gcommaaccent -10\nKPX gcommaaccent e 10\nKPX gcommaaccent eacute 10\nKPX gcommaaccent ecaron 10\nKPX gcommaaccent ecircumflex 10\nKPX gcommaaccent edieresis 10\nKPX gcommaaccent edotaccent 10\nKPX gcommaaccent egrave 10\nKPX gcommaaccent emacron 10\nKPX gcommaaccent eogonek 10\nKPX gcommaaccent g -10\nKPX gcommaaccent gbreve -10\nKPX gcommaaccent gcommaaccent -10\nKPX h y -20\nKPX h yacute -20\nKPX h ydieresis -20\nKPX k o -15\nKPX k oacute -15\nKPX k ocircumflex -15\nKPX k odieresis -15\nKPX k ograve -15\nKPX k ohungarumlaut -15\nKPX k omacron -15\nKPX k oslash -15\nKPX k otilde -15\nKPX kcommaaccent o -15\nKPX kcommaaccent oacute -15\nKPX kcommaaccent ocircumflex -15\nKPX kcommaaccent odieresis -15\nKPX kcommaaccent ograve -15\nKPX kcommaaccent ohungarumlaut -15\nKPX kcommaaccent omacron -15\nKPX kcommaaccent oslash -15\nKPX kcommaaccent otilde -15\nKPX l w -15\nKPX l y -15\nKPX l yacute -15\nKPX l ydieresis -15\nKPX lacute w -15\nKPX lacute y -15\nKPX lacute yacute -15\nKPX lacute ydieresis -15\nKPX lcommaaccent w -15\nKPX lcommaaccent y -15\nKPX lcommaaccent yacute -15\nKPX lcommaaccent ydieresis -15\nKPX lslash w -15\nKPX lslash y -15\nKPX lslash yacute -15\nKPX lslash ydieresis -15\nKPX m u -20\nKPX m uacute -20\nKPX m ucircumflex -20\nKPX m udieresis -20\nKPX m ugrave -20\nKPX m uhungarumlaut -20\nKPX m umacron -20\nKPX m uogonek -20\nKPX m uring -20\nKPX m y -30\nKPX m yacute -30\nKPX m ydieresis -30\nKPX n u -10\nKPX n uacute -10\nKPX n ucircumflex -10\nKPX n udieresis -10\nKPX n ugrave -10\nKPX n uhungarumlaut -10\nKPX n umacron -10\nKPX n uogonek -10\nKPX n uring -10\nKPX n v -40\nKPX n y -20\nKPX n yacute -20\nKPX n ydieresis -20\nKPX nacute u -10\nKPX nacute uacute -10\nKPX nacute ucircumflex -10\nKPX nacute udieresis -10\nKPX nacute ugrave -10\nKPX nacute uhungarumlaut -10\nKPX nacute umacron -10\nKPX nacute uogonek -10\nKPX nacute uring -10\nKPX nacute v -40\nKPX nacute y -20\nKPX nacute yacute -20\nKPX nacute ydieresis -20\nKPX ncaron u -10\nKPX ncaron uacute -10\nKPX ncaron ucircumflex -10\nKPX ncaron udieresis -10\nKPX ncaron ugrave -10\nKPX ncaron uhungarumlaut -10\nKPX ncaron umacron -10\nKPX ncaron uogonek -10\nKPX ncaron uring -10\nKPX ncaron v -40\nKPX ncaron y -20\nKPX ncaron yacute -20\nKPX ncaron ydieresis -20\nKPX ncommaaccent u -10\nKPX ncommaaccent uacute -10\nKPX ncommaaccent ucircumflex -10\nKPX ncommaaccent udieresis -10\nKPX ncommaaccent ugrave -10\nKPX ncommaaccent uhungarumlaut -10\nKPX ncommaaccent umacron -10\nKPX ncommaaccent uogonek -10\nKPX ncommaaccent uring -10\nKPX ncommaaccent v -40\nKPX ncommaaccent y -20\nKPX ncommaaccent yacute -20\nKPX ncommaaccent ydieresis -20\nKPX ntilde u -10\nKPX ntilde uacute -10\nKPX ntilde ucircumflex -10\nKPX ntilde udieresis -10\nKPX ntilde ugrave -10\nKPX ntilde uhungarumlaut -10\nKPX ntilde umacron -10\nKPX ntilde uogonek -10\nKPX ntilde uring -10\nKPX ntilde v -40\nKPX ntilde y -20\nKPX ntilde yacute -20\nKPX ntilde ydieresis -20\nKPX o v -20\nKPX o w -15\nKPX o x -30\nKPX o y -20\nKPX o yacute -20\nKPX o ydieresis -20\nKPX oacute v -20\nKPX oacute w -15\nKPX oacute x -30\nKPX oacute y -20\nKPX oacute yacute -20\nKPX oacute ydieresis -20\nKPX ocircumflex v -20\nKPX ocircumflex w -15\nKPX ocircumflex x -30\nKPX ocircumflex y -20\nKPX ocircumflex yacute -20\nKPX ocircumflex ydieresis -20\nKPX odieresis v -20\nKPX odieresis w -15\nKPX odieresis x -30\nKPX odieresis y -20\nKPX odieresis yacute -20\nKPX odieresis ydieresis -20\nKPX ograve v -20\nKPX ograve w -15\nKPX ograve x -30\nKPX ograve y -20\nKPX ograve yacute -20\nKPX ograve ydieresis -20\nKPX ohungarumlaut v -20\nKPX ohungarumlaut w -15\nKPX ohungarumlaut x -30\nKPX ohungarumlaut y -20\nKPX ohungarumlaut yacute -20\nKPX ohungarumlaut ydieresis -20\nKPX omacron v -20\nKPX omacron w -15\nKPX omacron x -30\nKPX omacron y -20\nKPX omacron yacute -20\nKPX omacron ydieresis -20\nKPX oslash v -20\nKPX oslash w -15\nKPX oslash x -30\nKPX oslash y -20\nKPX oslash yacute -20\nKPX oslash ydieresis -20\nKPX otilde v -20\nKPX otilde w -15\nKPX otilde x -30\nKPX otilde y -20\nKPX otilde yacute -20\nKPX otilde ydieresis -20\nKPX p y -15\nKPX p yacute -15\nKPX p ydieresis -15\nKPX period quotedblright -120\nKPX period quoteright -120\nKPX period space -40\nKPX quotedblright space -80\nKPX quoteleft quoteleft -46\nKPX quoteright d -80\nKPX quoteright dcroat -80\nKPX quoteright l -20\nKPX quoteright lacute -20\nKPX quoteright lcommaaccent -20\nKPX quoteright lslash -20\nKPX quoteright quoteright -46\nKPX quoteright r -40\nKPX quoteright racute -40\nKPX quoteright rcaron -40\nKPX quoteright rcommaaccent -40\nKPX quoteright s -60\nKPX quoteright sacute -60\nKPX quoteright scaron -60\nKPX quoteright scedilla -60\nKPX quoteright scommaaccent -60\nKPX quoteright space -80\nKPX quoteright v -20\nKPX r c -20\nKPX r cacute -20\nKPX r ccaron -20\nKPX r ccedilla -20\nKPX r comma -60\nKPX r d -20\nKPX r dcroat -20\nKPX r g -15\nKPX r gbreve -15\nKPX r gcommaaccent -15\nKPX r hyphen -20\nKPX r o -20\nKPX r oacute -20\nKPX r ocircumflex -20\nKPX r odieresis -20\nKPX r ograve -20\nKPX r ohungarumlaut -20\nKPX r omacron -20\nKPX r oslash -20\nKPX r otilde -20\nKPX r period -60\nKPX r q -20\nKPX r s -15\nKPX r sacute -15\nKPX r scaron -15\nKPX r scedilla -15\nKPX r scommaaccent -15\nKPX r t 20\nKPX r tcommaaccent 20\nKPX r v 10\nKPX r y 10\nKPX r yacute 10\nKPX r ydieresis 10\nKPX racute c -20\nKPX racute cacute -20\nKPX racute ccaron -20\nKPX racute ccedilla -20\nKPX racute comma -60\nKPX racute d -20\nKPX racute dcroat -20\nKPX racute g -15\nKPX racute gbreve -15\nKPX racute gcommaaccent -15\nKPX racute hyphen -20\nKPX racute o -20\nKPX racute oacute -20\nKPX racute ocircumflex -20\nKPX racute odieresis -20\nKPX racute ograve -20\nKPX racute ohungarumlaut -20\nKPX racute omacron -20\nKPX racute oslash -20\nKPX racute otilde -20\nKPX racute period -60\nKPX racute q -20\nKPX racute s -15\nKPX racute sacute -15\nKPX racute scaron -15\nKPX racute scedilla -15\nKPX racute scommaaccent -15\nKPX racute t 20\nKPX racute tcommaaccent 20\nKPX racute v 10\nKPX racute y 10\nKPX racute yacute 10\nKPX racute ydieresis 10\nKPX rcaron c -20\nKPX rcaron cacute -20\nKPX rcaron ccaron -20\nKPX rcaron ccedilla -20\nKPX rcaron comma -60\nKPX rcaron d -20\nKPX rcaron dcroat -20\nKPX rcaron g -15\nKPX rcaron gbreve -15\nKPX rcaron gcommaaccent -15\nKPX rcaron hyphen -20\nKPX rcaron o -20\nKPX rcaron oacute -20\nKPX rcaron ocircumflex -20\nKPX rcaron odieresis -20\nKPX rcaron ograve -20\nKPX rcaron ohungarumlaut -20\nKPX rcaron omacron -20\nKPX rcaron oslash -20\nKPX rcaron otilde -20\nKPX rcaron period -60\nKPX rcaron q -20\nKPX rcaron s -15\nKPX rcaron sacute -15\nKPX rcaron scaron -15\nKPX rcaron scedilla -15\nKPX rcaron scommaaccent -15\nKPX rcaron t 20\nKPX rcaron tcommaaccent 20\nKPX rcaron v 10\nKPX rcaron y 10\nKPX rcaron yacute 10\nKPX rcaron ydieresis 10\nKPX rcommaaccent c -20\nKPX rcommaaccent cacute -20\nKPX rcommaaccent ccaron -20\nKPX rcommaaccent ccedilla -20\nKPX rcommaaccent comma -60\nKPX rcommaaccent d -20\nKPX rcommaaccent dcroat -20\nKPX rcommaaccent g -15\nKPX rcommaaccent gbreve -15\nKPX rcommaaccent gcommaaccent -15\nKPX rcommaaccent hyphen -20\nKPX rcommaaccent o -20\nKPX rcommaaccent oacute -20\nKPX rcommaaccent ocircumflex -20\nKPX rcommaaccent odieresis -20\nKPX rcommaaccent ograve -20\nKPX rcommaaccent ohungarumlaut -20\nKPX rcommaaccent omacron -20\nKPX rcommaaccent oslash -20\nKPX rcommaaccent otilde -20\nKPX rcommaaccent period -60\nKPX rcommaaccent q -20\nKPX rcommaaccent s -15\nKPX rcommaaccent sacute -15\nKPX rcommaaccent scaron -15\nKPX rcommaaccent scedilla -15\nKPX rcommaaccent scommaaccent -15\nKPX rcommaaccent t 20\nKPX rcommaaccent tcommaaccent 20\nKPX rcommaaccent v 10\nKPX rcommaaccent y 10\nKPX rcommaaccent yacute 10\nKPX rcommaaccent ydieresis 10\nKPX s w -15\nKPX sacute w -15\nKPX scaron w -15\nKPX scedilla w -15\nKPX scommaaccent w -15\nKPX semicolon space -40\nKPX space T -100\nKPX space Tcaron -100\nKPX space Tcommaaccent -100\nKPX space V -80\nKPX space W -80\nKPX space Y -120\nKPX space Yacute -120\nKPX space Ydieresis -120\nKPX space quotedblleft -80\nKPX space quoteleft -60\nKPX v a -20\nKPX v aacute -20\nKPX v abreve -20\nKPX v acircumflex -20\nKPX v adieresis -20\nKPX v agrave -20\nKPX v amacron -20\nKPX v aogonek -20\nKPX v aring -20\nKPX v atilde -20\nKPX v comma -80\nKPX v o -30\nKPX v oacute -30\nKPX v ocircumflex -30\nKPX v odieresis -30\nKPX v ograve -30\nKPX v ohungarumlaut -30\nKPX v omacron -30\nKPX v oslash -30\nKPX v otilde -30\nKPX v period -80\nKPX w comma -40\nKPX w o -20\nKPX w oacute -20\nKPX w ocircumflex -20\nKPX w odieresis -20\nKPX w ograve -20\nKPX w ohungarumlaut -20\nKPX w omacron -20\nKPX w oslash -20\nKPX w otilde -20\nKPX w period -40\nKPX x e -10\nKPX x eacute -10\nKPX x ecaron -10\nKPX x ecircumflex -10\nKPX x edieresis -10\nKPX x edotaccent -10\nKPX x egrave -10\nKPX x emacron -10\nKPX x eogonek -10\nKPX y a -30\nKPX y aacute -30\nKPX y abreve -30\nKPX y acircumflex -30\nKPX y adieresis -30\nKPX y agrave -30\nKPX y amacron -30\nKPX y aogonek -30\nKPX y aring -30\nKPX y atilde -30\nKPX y comma -80\nKPX y e -10\nKPX y eacute -10\nKPX y ecaron -10\nKPX y ecircumflex -10\nKPX y edieresis -10\nKPX y edotaccent -10\nKPX y egrave -10\nKPX y emacron -10\nKPX y eogonek -10\nKPX y o -25\nKPX y oacute -25\nKPX y ocircumflex -25\nKPX y odieresis -25\nKPX y ograve -25\nKPX y ohungarumlaut -25\nKPX y omacron -25\nKPX y oslash -25\nKPX y otilde -25\nKPX y period -80\nKPX yacute a -30\nKPX yacute aacute -30\nKPX yacute abreve -30\nKPX yacute acircumflex -30\nKPX yacute adieresis -30\nKPX yacute agrave -30\nKPX yacute amacron -30\nKPX yacute aogonek -30\nKPX yacute aring -30\nKPX yacute atilde -30\nKPX yacute comma -80\nKPX yacute e -10\nKPX yacute eacute -10\nKPX yacute ecaron -10\nKPX yacute ecircumflex -10\nKPX yacute edieresis -10\nKPX yacute edotaccent -10\nKPX yacute egrave -10\nKPX yacute emacron -10\nKPX yacute eogonek -10\nKPX yacute o -25\nKPX yacute oacute -25\nKPX yacute ocircumflex -25\nKPX yacute odieresis -25\nKPX yacute ograve -25\nKPX yacute ohungarumlaut -25\nKPX yacute omacron -25\nKPX yacute oslash -25\nKPX yacute otilde -25\nKPX yacute period -80\nKPX ydieresis a -30\nKPX ydieresis aacute -30\nKPX ydieresis abreve -30\nKPX ydieresis acircumflex -30\nKPX ydieresis adieresis -30\nKPX ydieresis agrave -30\nKPX ydieresis amacron -30\nKPX ydieresis aogonek -30\nKPX ydieresis aring -30\nKPX ydieresis atilde -30\nKPX ydieresis comma -80\nKPX ydieresis e -10\nKPX ydieresis eacute -10\nKPX ydieresis ecaron -10\nKPX ydieresis ecircumflex -10\nKPX ydieresis edieresis -10\nKPX ydieresis edotaccent -10\nKPX ydieresis egrave -10\nKPX ydieresis emacron -10\nKPX ydieresis eogonek -10\nKPX ydieresis o -25\nKPX ydieresis oacute -25\nKPX ydieresis ocircumflex -25\nKPX ydieresis odieresis -25\nKPX ydieresis ograve -25\nKPX ydieresis ohungarumlaut -25\nKPX ydieresis omacron -25\nKPX ydieresis oslash -25\nKPX ydieresis otilde -25\nKPX ydieresis period -80\nKPX z e 10\nKPX z eacute 10\nKPX z ecaron 10\nKPX z ecircumflex 10\nKPX z edieresis 10\nKPX z edotaccent 10\nKPX z egrave 10\nKPX z emacron 10\nKPX z eogonek 10\nKPX zacute e 10\nKPX zacute eacute 10\nKPX zacute ecaron 10\nKPX zacute ecircumflex 10\nKPX zacute edieresis 10\nKPX zacute edotaccent 10\nKPX zacute egrave 10\nKPX zacute emacron 10\nKPX zacute eogonek 10\nKPX zcaron e 10\nKPX zcaron eacute 10\nKPX zcaron ecaron 10\nKPX zcaron ecircumflex 10\nKPX zcaron edieresis 10\nKPX zcaron edotaccent 10\nKPX zcaron egrave 10\nKPX zcaron emacron 10\nKPX zcaron eogonek 10\nKPX zdotaccent e 10\nKPX zdotaccent eacute 10\nKPX zdotaccent ecaron 10\nKPX zdotaccent ecircumflex 10\nKPX zdotaccent edieresis 10\nKPX zdotaccent edotaccent 10\nKPX zdotaccent egrave 10\nKPX zdotaccent emacron 10\nKPX zdotaccent eogonek 10\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    'Times-Roman' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 12:49:17 1997\nComment UniqueID 43068\nComment VMusage 43909 54934\nFontName Times-Roman\nFullName Times Roman\nFamilyName Times\nWeight Roman\nItalicAngle 0\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -168 -218 1000 898 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 662\nXHeight 450\nAscender 683\nDescender -217\nStdHW 28\nStdVW 84\nStartCharMetrics 315\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 333 ; N exclam ; B 130 -9 238 676 ;\nC 34 ; WX 408 ; N quotedbl ; B 77 431 331 676 ;\nC 35 ; WX 500 ; N numbersign ; B 5 0 496 662 ;\nC 36 ; WX 500 ; N dollar ; B 44 -87 457 727 ;\nC 37 ; WX 833 ; N percent ; B 61 -13 772 676 ;\nC 38 ; WX 778 ; N ampersand ; B 42 -13 750 676 ;\nC 39 ; WX 333 ; N quoteright ; B 79 433 218 676 ;\nC 40 ; WX 333 ; N parenleft ; B 48 -177 304 676 ;\nC 41 ; WX 333 ; N parenright ; B 29 -177 285 676 ;\nC 42 ; WX 500 ; N asterisk ; B 69 265 432 676 ;\nC 43 ; WX 564 ; N plus ; B 30 0 534 506 ;\nC 44 ; WX 250 ; N comma ; B 56 -141 195 102 ;\nC 45 ; WX 333 ; N hyphen ; B 39 194 285 257 ;\nC 46 ; WX 250 ; N period ; B 70 -11 181 100 ;\nC 47 ; WX 278 ; N slash ; B -9 -14 287 676 ;\nC 48 ; WX 500 ; N zero ; B 24 -14 476 676 ;\nC 49 ; WX 500 ; N one ; B 111 0 394 676 ;\nC 50 ; WX 500 ; N two ; B 30 0 475 676 ;\nC 51 ; WX 500 ; N three ; B 43 -14 431 676 ;\nC 52 ; WX 500 ; N four ; B 12 0 472 676 ;\nC 53 ; WX 500 ; N five ; B 32 -14 438 688 ;\nC 54 ; WX 500 ; N six ; B 34 -14 468 684 ;\nC 55 ; WX 500 ; N seven ; B 20 -8 449 662 ;\nC 56 ; WX 500 ; N eight ; B 56 -14 445 676 ;\nC 57 ; WX 500 ; N nine ; B 30 -22 459 676 ;\nC 58 ; WX 278 ; N colon ; B 81 -11 192 459 ;\nC 59 ; WX 278 ; N semicolon ; B 80 -141 219 459 ;\nC 60 ; WX 564 ; N less ; B 28 -8 536 514 ;\nC 61 ; WX 564 ; N equal ; B 30 120 534 386 ;\nC 62 ; WX 564 ; N greater ; B 28 -8 536 514 ;\nC 63 ; WX 444 ; N question ; B 68 -8 414 676 ;\nC 64 ; WX 921 ; N at ; B 116 -14 809 676 ;\nC 65 ; WX 722 ; N A ; B 15 0 706 674 ;\nC 66 ; WX 667 ; N B ; B 17 0 593 662 ;\nC 67 ; WX 667 ; N C ; B 28 -14 633 676 ;\nC 68 ; WX 722 ; N D ; B 16 0 685 662 ;\nC 69 ; WX 611 ; N E ; B 12 0 597 662 ;\nC 70 ; WX 556 ; N F ; B 12 0 546 662 ;\nC 71 ; WX 722 ; N G ; B 32 -14 709 676 ;\nC 72 ; WX 722 ; N H ; B 19 0 702 662 ;\nC 73 ; WX 333 ; N I ; B 18 0 315 662 ;\nC 74 ; WX 389 ; N J ; B 10 -14 370 662 ;\nC 75 ; WX 722 ; N K ; B 34 0 723 662 ;\nC 76 ; WX 611 ; N L ; B 12 0 598 662 ;\nC 77 ; WX 889 ; N M ; B 12 0 863 662 ;\nC 78 ; WX 722 ; N N ; B 12 -11 707 662 ;\nC 79 ; WX 722 ; N O ; B 34 -14 688 676 ;\nC 80 ; WX 556 ; N P ; B 16 0 542 662 ;\nC 81 ; WX 722 ; N Q ; B 34 -178 701 676 ;\nC 82 ; WX 667 ; N R ; B 17 0 659 662 ;\nC 83 ; WX 556 ; N S ; B 42 -14 491 676 ;\nC 84 ; WX 611 ; N T ; B 17 0 593 662 ;\nC 85 ; WX 722 ; N U ; B 14 -14 705 662 ;\nC 86 ; WX 722 ; N V ; B 16 -11 697 662 ;\nC 87 ; WX 944 ; N W ; B 5 -11 932 662 ;\nC 88 ; WX 722 ; N X ; B 10 0 704 662 ;\nC 89 ; WX 722 ; N Y ; B 22 0 703 662 ;\nC 90 ; WX 611 ; N Z ; B 9 0 597 662 ;\nC 91 ; WX 333 ; N bracketleft ; B 88 -156 299 662 ;\nC 92 ; WX 278 ; N backslash ; B -9 -14 287 676 ;\nC 93 ; WX 333 ; N bracketright ; B 34 -156 245 662 ;\nC 94 ; WX 469 ; N asciicircum ; B 24 297 446 662 ;\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\nC 96 ; WX 333 ; N quoteleft ; B 115 433 254 676 ;\nC 97 ; WX 444 ; N a ; B 37 -10 442 460 ;\nC 98 ; WX 500 ; N b ; B 3 -10 468 683 ;\nC 99 ; WX 444 ; N c ; B 25 -10 412 460 ;\nC 100 ; WX 500 ; N d ; B 27 -10 491 683 ;\nC 101 ; WX 444 ; N e ; B 25 -10 424 460 ;\nC 102 ; WX 333 ; N f ; B 20 0 383 683 ; L i fi ; L l fl ;\nC 103 ; WX 500 ; N g ; B 28 -218 470 460 ;\nC 104 ; WX 500 ; N h ; B 9 0 487 683 ;\nC 105 ; WX 278 ; N i ; B 16 0 253 683 ;\nC 106 ; WX 278 ; N j ; B -70 -218 194 683 ;\nC 107 ; WX 500 ; N k ; B 7 0 505 683 ;\nC 108 ; WX 278 ; N l ; B 19 0 257 683 ;\nC 109 ; WX 778 ; N m ; B 16 0 775 460 ;\nC 110 ; WX 500 ; N n ; B 16 0 485 460 ;\nC 111 ; WX 500 ; N o ; B 29 -10 470 460 ;\nC 112 ; WX 500 ; N p ; B 5 -217 470 460 ;\nC 113 ; WX 500 ; N q ; B 24 -217 488 460 ;\nC 114 ; WX 333 ; N r ; B 5 0 335 460 ;\nC 115 ; WX 389 ; N s ; B 51 -10 348 460 ;\nC 116 ; WX 278 ; N t ; B 13 -10 279 579 ;\nC 117 ; WX 500 ; N u ; B 9 -10 479 450 ;\nC 118 ; WX 500 ; N v ; B 19 -14 477 450 ;\nC 119 ; WX 722 ; N w ; B 21 -14 694 450 ;\nC 120 ; WX 500 ; N x ; B 17 0 479 450 ;\nC 121 ; WX 500 ; N y ; B 14 -218 475 450 ;\nC 122 ; WX 444 ; N z ; B 27 0 418 450 ;\nC 123 ; WX 480 ; N braceleft ; B 100 -181 350 680 ;\nC 124 ; WX 200 ; N bar ; B 67 -218 133 782 ;\nC 125 ; WX 480 ; N braceright ; B 130 -181 380 680 ;\nC 126 ; WX 541 ; N asciitilde ; B 40 183 502 323 ;\nC 161 ; WX 333 ; N exclamdown ; B 97 -218 205 467 ;\nC 162 ; WX 500 ; N cent ; B 53 -138 448 579 ;\nC 163 ; WX 500 ; N sterling ; B 12 -8 490 676 ;\nC 164 ; WX 167 ; N fraction ; B -168 -14 331 676 ;\nC 165 ; WX 500 ; N yen ; B -53 0 512 662 ;\nC 166 ; WX 500 ; N florin ; B 7 -189 490 676 ;\nC 167 ; WX 500 ; N section ; B 70 -148 426 676 ;\nC 168 ; WX 500 ; N currency ; B -22 58 522 602 ;\nC 169 ; WX 180 ; N quotesingle ; B 48 431 133 676 ;\nC 170 ; WX 444 ; N quotedblleft ; B 43 433 414 676 ;\nC 171 ; WX 500 ; N guillemotleft ; B 42 33 456 416 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 63 33 285 416 ;\nC 173 ; WX 333 ; N guilsinglright ; B 48 33 270 416 ;\nC 174 ; WX 556 ; N fi ; B 31 0 521 683 ;\nC 175 ; WX 556 ; N fl ; B 32 0 521 683 ;\nC 177 ; WX 500 ; N endash ; B 0 201 500 250 ;\nC 178 ; WX 500 ; N dagger ; B 59 -149 442 676 ;\nC 179 ; WX 500 ; N daggerdbl ; B 58 -153 442 676 ;\nC 180 ; WX 250 ; N periodcentered ; B 70 199 181 310 ;\nC 182 ; WX 453 ; N paragraph ; B -22 -154 450 662 ;\nC 183 ; WX 350 ; N bullet ; B 40 196 310 466 ;\nC 184 ; WX 333 ; N quotesinglbase ; B 79 -141 218 102 ;\nC 185 ; WX 444 ; N quotedblbase ; B 45 -141 416 102 ;\nC 186 ; WX 444 ; N quotedblright ; B 30 433 401 676 ;\nC 187 ; WX 500 ; N guillemotright ; B 44 33 458 416 ;\nC 188 ; WX 1000 ; N ellipsis ; B 111 -11 888 100 ;\nC 189 ; WX 1000 ; N perthousand ; B 7 -19 994 706 ;\nC 191 ; WX 444 ; N questiondown ; B 30 -218 376 466 ;\nC 193 ; WX 333 ; N grave ; B 19 507 242 678 ;\nC 194 ; WX 333 ; N acute ; B 93 507 317 678 ;\nC 195 ; WX 333 ; N circumflex ; B 11 507 322 674 ;\nC 196 ; WX 333 ; N tilde ; B 1 532 331 638 ;\nC 197 ; WX 333 ; N macron ; B 11 547 322 601 ;\nC 198 ; WX 333 ; N breve ; B 26 507 307 664 ;\nC 199 ; WX 333 ; N dotaccent ; B 118 581 216 681 ;\nC 200 ; WX 333 ; N dieresis ; B 18 581 315 681 ;\nC 202 ; WX 333 ; N ring ; B 67 512 266 711 ;\nC 203 ; WX 333 ; N cedilla ; B 52 -215 261 0 ;\nC 205 ; WX 333 ; N hungarumlaut ; B -3 507 377 678 ;\nC 206 ; WX 333 ; N ogonek ; B 62 -165 243 0 ;\nC 207 ; WX 333 ; N caron ; B 11 507 322 674 ;\nC 208 ; WX 1000 ; N emdash ; B 0 201 1000 250 ;\nC 225 ; WX 889 ; N AE ; B 0 0 863 662 ;\nC 227 ; WX 276 ; N ordfeminine ; B 4 394 270 676 ;\nC 232 ; WX 611 ; N Lslash ; B 12 0 598 662 ;\nC 233 ; WX 722 ; N Oslash ; B 34 -80 688 734 ;\nC 234 ; WX 889 ; N OE ; B 30 -6 885 668 ;\nC 235 ; WX 310 ; N ordmasculine ; B 6 394 304 676 ;\nC 241 ; WX 667 ; N ae ; B 38 -10 632 460 ;\nC 245 ; WX 278 ; N dotlessi ; B 16 0 253 460 ;\nC 248 ; WX 278 ; N lslash ; B 19 0 259 683 ;\nC 249 ; WX 500 ; N oslash ; B 29 -112 470 551 ;\nC 250 ; WX 722 ; N oe ; B 30 -10 690 460 ;\nC 251 ; WX 500 ; N germandbls ; B 12 -9 468 683 ;\nC -1 ; WX 333 ; N Idieresis ; B 18 0 315 835 ;\nC -1 ; WX 444 ; N eacute ; B 25 -10 424 678 ;\nC -1 ; WX 444 ; N abreve ; B 37 -10 442 664 ;\nC -1 ; WX 500 ; N uhungarumlaut ; B 9 -10 501 678 ;\nC -1 ; WX 444 ; N ecaron ; B 25 -10 424 674 ;\nC -1 ; WX 722 ; N Ydieresis ; B 22 0 703 835 ;\nC -1 ; WX 564 ; N divide ; B 30 -10 534 516 ;\nC -1 ; WX 722 ; N Yacute ; B 22 0 703 890 ;\nC -1 ; WX 722 ; N Acircumflex ; B 15 0 706 886 ;\nC -1 ; WX 444 ; N aacute ; B 37 -10 442 678 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 14 -14 705 886 ;\nC -1 ; WX 500 ; N yacute ; B 14 -218 475 678 ;\nC -1 ; WX 389 ; N scommaaccent ; B 51 -218 348 460 ;\nC -1 ; WX 444 ; N ecircumflex ; B 25 -10 424 674 ;\nC -1 ; WX 722 ; N Uring ; B 14 -14 705 898 ;\nC -1 ; WX 722 ; N Udieresis ; B 14 -14 705 835 ;\nC -1 ; WX 444 ; N aogonek ; B 37 -165 469 460 ;\nC -1 ; WX 722 ; N Uacute ; B 14 -14 705 890 ;\nC -1 ; WX 500 ; N uogonek ; B 9 -155 487 450 ;\nC -1 ; WX 611 ; N Edieresis ; B 12 0 597 835 ;\nC -1 ; WX 722 ; N Dcroat ; B 16 0 685 662 ;\nC -1 ; WX 250 ; N commaaccent ; B 59 -218 184 -50 ;\nC -1 ; WX 760 ; N copyright ; B 38 -14 722 676 ;\nC -1 ; WX 611 ; N Emacron ; B 12 0 597 813 ;\nC -1 ; WX 444 ; N ccaron ; B 25 -10 412 674 ;\nC -1 ; WX 444 ; N aring ; B 37 -10 442 711 ;\nC -1 ; WX 722 ; N Ncommaaccent ; B 12 -198 707 662 ;\nC -1 ; WX 278 ; N lacute ; B 19 0 290 890 ;\nC -1 ; WX 444 ; N agrave ; B 37 -10 442 678 ;\nC -1 ; WX 611 ; N Tcommaaccent ; B 17 -218 593 662 ;\nC -1 ; WX 667 ; N Cacute ; B 28 -14 633 890 ;\nC -1 ; WX 444 ; N atilde ; B 37 -10 442 638 ;\nC -1 ; WX 611 ; N Edotaccent ; B 12 0 597 835 ;\nC -1 ; WX 389 ; N scaron ; B 39 -10 350 674 ;\nC -1 ; WX 389 ; N scedilla ; B 51 -215 348 460 ;\nC -1 ; WX 278 ; N iacute ; B 16 0 290 678 ;\nC -1 ; WX 471 ; N lozenge ; B 13 0 459 724 ;\nC -1 ; WX 667 ; N Rcaron ; B 17 0 659 886 ;\nC -1 ; WX 722 ; N Gcommaaccent ; B 32 -218 709 676 ;\nC -1 ; WX 500 ; N ucircumflex ; B 9 -10 479 674 ;\nC -1 ; WX 444 ; N acircumflex ; B 37 -10 442 674 ;\nC -1 ; WX 722 ; N Amacron ; B 15 0 706 813 ;\nC -1 ; WX 333 ; N rcaron ; B 5 0 335 674 ;\nC -1 ; WX 444 ; N ccedilla ; B 25 -215 412 460 ;\nC -1 ; WX 611 ; N Zdotaccent ; B 9 0 597 835 ;\nC -1 ; WX 556 ; N Thorn ; B 16 0 542 662 ;\nC -1 ; WX 722 ; N Omacron ; B 34 -14 688 813 ;\nC -1 ; WX 667 ; N Racute ; B 17 0 659 890 ;\nC -1 ; WX 556 ; N Sacute ; B 42 -14 491 890 ;\nC -1 ; WX 588 ; N dcaron ; B 27 -10 589 695 ;\nC -1 ; WX 722 ; N Umacron ; B 14 -14 705 813 ;\nC -1 ; WX 500 ; N uring ; B 9 -10 479 711 ;\nC -1 ; WX 300 ; N threesuperior ; B 15 262 291 676 ;\nC -1 ; WX 722 ; N Ograve ; B 34 -14 688 890 ;\nC -1 ; WX 722 ; N Agrave ; B 15 0 706 890 ;\nC -1 ; WX 722 ; N Abreve ; B 15 0 706 876 ;\nC -1 ; WX 564 ; N multiply ; B 38 8 527 497 ;\nC -1 ; WX 500 ; N uacute ; B 9 -10 479 678 ;\nC -1 ; WX 611 ; N Tcaron ; B 17 0 593 886 ;\nC -1 ; WX 476 ; N partialdiff ; B 17 -38 459 710 ;\nC -1 ; WX 500 ; N ydieresis ; B 14 -218 475 623 ;\nC -1 ; WX 722 ; N Nacute ; B 12 -11 707 890 ;\nC -1 ; WX 278 ; N icircumflex ; B -16 0 295 674 ;\nC -1 ; WX 611 ; N Ecircumflex ; B 12 0 597 886 ;\nC -1 ; WX 444 ; N adieresis ; B 37 -10 442 623 ;\nC -1 ; WX 444 ; N edieresis ; B 25 -10 424 623 ;\nC -1 ; WX 444 ; N cacute ; B 25 -10 413 678 ;\nC -1 ; WX 500 ; N nacute ; B 16 0 485 678 ;\nC -1 ; WX 500 ; N umacron ; B 9 -10 479 601 ;\nC -1 ; WX 722 ; N Ncaron ; B 12 -11 707 886 ;\nC -1 ; WX 333 ; N Iacute ; B 18 0 317 890 ;\nC -1 ; WX 564 ; N plusminus ; B 30 0 534 506 ;\nC -1 ; WX 200 ; N brokenbar ; B 67 -143 133 707 ;\nC -1 ; WX 760 ; N registered ; B 38 -14 722 676 ;\nC -1 ; WX 722 ; N Gbreve ; B 32 -14 709 876 ;\nC -1 ; WX 333 ; N Idotaccent ; B 18 0 315 835 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 585 706 ;\nC -1 ; WX 611 ; N Egrave ; B 12 0 597 890 ;\nC -1 ; WX 333 ; N racute ; B 5 0 335 678 ;\nC -1 ; WX 500 ; N omacron ; B 29 -10 470 601 ;\nC -1 ; WX 611 ; N Zacute ; B 9 0 597 890 ;\nC -1 ; WX 611 ; N Zcaron ; B 9 0 597 886 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 666 ;\nC -1 ; WX 722 ; N Eth ; B 16 0 685 662 ;\nC -1 ; WX 667 ; N Ccedilla ; B 28 -215 633 676 ;\nC -1 ; WX 278 ; N lcommaaccent ; B 19 -218 257 683 ;\nC -1 ; WX 326 ; N tcaron ; B 13 -10 318 722 ;\nC -1 ; WX 444 ; N eogonek ; B 25 -165 424 460 ;\nC -1 ; WX 722 ; N Uogonek ; B 14 -165 705 662 ;\nC -1 ; WX 722 ; N Aacute ; B 15 0 706 890 ;\nC -1 ; WX 722 ; N Adieresis ; B 15 0 706 835 ;\nC -1 ; WX 444 ; N egrave ; B 25 -10 424 678 ;\nC -1 ; WX 444 ; N zacute ; B 27 0 418 678 ;\nC -1 ; WX 278 ; N iogonek ; B 16 -165 265 683 ;\nC -1 ; WX 722 ; N Oacute ; B 34 -14 688 890 ;\nC -1 ; WX 500 ; N oacute ; B 29 -10 470 678 ;\nC -1 ; WX 444 ; N amacron ; B 37 -10 442 601 ;\nC -1 ; WX 389 ; N sacute ; B 51 -10 348 678 ;\nC -1 ; WX 278 ; N idieresis ; B -9 0 288 623 ;\nC -1 ; WX 722 ; N Ocircumflex ; B 34 -14 688 886 ;\nC -1 ; WX 722 ; N Ugrave ; B 14 -14 705 890 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 500 ; N thorn ; B 5 -217 470 683 ;\nC -1 ; WX 300 ; N twosuperior ; B 1 270 296 676 ;\nC -1 ; WX 722 ; N Odieresis ; B 34 -14 688 835 ;\nC -1 ; WX 500 ; N mu ; B 36 -218 512 450 ;\nC -1 ; WX 278 ; N igrave ; B -8 0 253 678 ;\nC -1 ; WX 500 ; N ohungarumlaut ; B 29 -10 491 678 ;\nC -1 ; WX 611 ; N Eogonek ; B 12 -165 597 662 ;\nC -1 ; WX 500 ; N dcroat ; B 27 -10 500 683 ;\nC -1 ; WX 750 ; N threequarters ; B 15 -14 718 676 ;\nC -1 ; WX 556 ; N Scedilla ; B 42 -215 491 676 ;\nC -1 ; WX 344 ; N lcaron ; B 19 0 347 695 ;\nC -1 ; WX 722 ; N Kcommaaccent ; B 34 -198 723 662 ;\nC -1 ; WX 611 ; N Lacute ; B 12 0 598 890 ;\nC -1 ; WX 980 ; N trademark ; B 30 256 957 662 ;\nC -1 ; WX 444 ; N edotaccent ; B 25 -10 424 623 ;\nC -1 ; WX 333 ; N Igrave ; B 18 0 315 890 ;\nC -1 ; WX 333 ; N Imacron ; B 11 0 322 813 ;\nC -1 ; WX 611 ; N Lcaron ; B 12 0 598 676 ;\nC -1 ; WX 750 ; N onehalf ; B 31 -14 746 676 ;\nC -1 ; WX 549 ; N lessequal ; B 26 0 523 666 ;\nC -1 ; WX 500 ; N ocircumflex ; B 29 -10 470 674 ;\nC -1 ; WX 500 ; N ntilde ; B 16 0 485 638 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 14 -14 705 890 ;\nC -1 ; WX 611 ; N Eacute ; B 12 0 597 890 ;\nC -1 ; WX 444 ; N emacron ; B 25 -10 424 601 ;\nC -1 ; WX 500 ; N gbreve ; B 28 -218 470 664 ;\nC -1 ; WX 750 ; N onequarter ; B 37 -14 718 676 ;\nC -1 ; WX 556 ; N Scaron ; B 42 -14 491 886 ;\nC -1 ; WX 556 ; N Scommaaccent ; B 42 -218 491 676 ;\nC -1 ; WX 722 ; N Ohungarumlaut ; B 34 -14 688 890 ;\nC -1 ; WX 400 ; N degree ; B 57 390 343 676 ;\nC -1 ; WX 500 ; N ograve ; B 29 -10 470 678 ;\nC -1 ; WX 667 ; N Ccaron ; B 28 -14 633 886 ;\nC -1 ; WX 500 ; N ugrave ; B 9 -10 479 678 ;\nC -1 ; WX 453 ; N radical ; B 2 -60 452 768 ;\nC -1 ; WX 722 ; N Dcaron ; B 16 0 685 886 ;\nC -1 ; WX 333 ; N rcommaaccent ; B 5 -218 335 460 ;\nC -1 ; WX 722 ; N Ntilde ; B 12 -11 707 850 ;\nC -1 ; WX 500 ; N otilde ; B 29 -10 470 638 ;\nC -1 ; WX 667 ; N Rcommaaccent ; B 17 -198 659 662 ;\nC -1 ; WX 611 ; N Lcommaaccent ; B 12 -218 598 662 ;\nC -1 ; WX 722 ; N Atilde ; B 15 0 706 850 ;\nC -1 ; WX 722 ; N Aogonek ; B 15 -165 738 674 ;\nC -1 ; WX 722 ; N Aring ; B 15 0 706 898 ;\nC -1 ; WX 722 ; N Otilde ; B 34 -14 688 850 ;\nC -1 ; WX 444 ; N zdotaccent ; B 27 0 418 623 ;\nC -1 ; WX 611 ; N Ecaron ; B 12 0 597 886 ;\nC -1 ; WX 333 ; N Iogonek ; B 18 -165 315 662 ;\nC -1 ; WX 500 ; N kcommaaccent ; B 7 -218 505 683 ;\nC -1 ; WX 564 ; N minus ; B 30 220 534 286 ;\nC -1 ; WX 333 ; N Icircumflex ; B 11 0 322 886 ;\nC -1 ; WX 500 ; N ncaron ; B 16 0 485 674 ;\nC -1 ; WX 278 ; N tcommaaccent ; B 13 -218 279 579 ;\nC -1 ; WX 564 ; N logicalnot ; B 30 108 534 386 ;\nC -1 ; WX 500 ; N odieresis ; B 29 -10 470 623 ;\nC -1 ; WX 500 ; N udieresis ; B 9 -10 479 623 ;\nC -1 ; WX 549 ; N notequal ; B 12 -31 537 547 ;\nC -1 ; WX 500 ; N gcommaaccent ; B 28 -218 470 749 ;\nC -1 ; WX 500 ; N eth ; B 29 -10 471 686 ;\nC -1 ; WX 444 ; N zcaron ; B 27 0 418 674 ;\nC -1 ; WX 500 ; N ncommaaccent ; B 16 -218 485 460 ;\nC -1 ; WX 300 ; N onesuperior ; B 57 270 248 676 ;\nC -1 ; WX 278 ; N imacron ; B 6 0 271 601 ;\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2073\nKPX A C -40\nKPX A Cacute -40\nKPX A Ccaron -40\nKPX A Ccedilla -40\nKPX A G -40\nKPX A Gbreve -40\nKPX A Gcommaaccent -40\nKPX A O -55\nKPX A Oacute -55\nKPX A Ocircumflex -55\nKPX A Odieresis -55\nKPX A Ograve -55\nKPX A Ohungarumlaut -55\nKPX A Omacron -55\nKPX A Oslash -55\nKPX A Otilde -55\nKPX A Q -55\nKPX A T -111\nKPX A Tcaron -111\nKPX A Tcommaaccent -111\nKPX A U -55\nKPX A Uacute -55\nKPX A Ucircumflex -55\nKPX A Udieresis -55\nKPX A Ugrave -55\nKPX A Uhungarumlaut -55\nKPX A Umacron -55\nKPX A Uogonek -55\nKPX A Uring -55\nKPX A V -135\nKPX A W -90\nKPX A Y -105\nKPX A Yacute -105\nKPX A Ydieresis -105\nKPX A quoteright -111\nKPX A v -74\nKPX A w -92\nKPX A y -92\nKPX A yacute -92\nKPX A ydieresis -92\nKPX Aacute C -40\nKPX Aacute Cacute -40\nKPX Aacute Ccaron -40\nKPX Aacute Ccedilla -40\nKPX Aacute G -40\nKPX Aacute Gbreve -40\nKPX Aacute Gcommaaccent -40\nKPX Aacute O -55\nKPX Aacute Oacute -55\nKPX Aacute Ocircumflex -55\nKPX Aacute Odieresis -55\nKPX Aacute Ograve -55\nKPX Aacute Ohungarumlaut -55\nKPX Aacute Omacron -55\nKPX Aacute Oslash -55\nKPX Aacute Otilde -55\nKPX Aacute Q -55\nKPX Aacute T -111\nKPX Aacute Tcaron -111\nKPX Aacute Tcommaaccent -111\nKPX Aacute U -55\nKPX Aacute Uacute -55\nKPX Aacute Ucircumflex -55\nKPX Aacute Udieresis -55\nKPX Aacute Ugrave -55\nKPX Aacute Uhungarumlaut -55\nKPX Aacute Umacron -55\nKPX Aacute Uogonek -55\nKPX Aacute Uring -55\nKPX Aacute V -135\nKPX Aacute W -90\nKPX Aacute Y -105\nKPX Aacute Yacute -105\nKPX Aacute Ydieresis -105\nKPX Aacute quoteright -111\nKPX Aacute v -74\nKPX Aacute w -92\nKPX Aacute y -92\nKPX Aacute yacute -92\nKPX Aacute ydieresis -92\nKPX Abreve C -40\nKPX Abreve Cacute -40\nKPX Abreve Ccaron -40\nKPX Abreve Ccedilla -40\nKPX Abreve G -40\nKPX Abreve Gbreve -40\nKPX Abreve Gcommaaccent -40\nKPX Abreve O -55\nKPX Abreve Oacute -55\nKPX Abreve Ocircumflex -55\nKPX Abreve Odieresis -55\nKPX Abreve Ograve -55\nKPX Abreve Ohungarumlaut -55\nKPX Abreve Omacron -55\nKPX Abreve Oslash -55\nKPX Abreve Otilde -55\nKPX Abreve Q -55\nKPX Abreve T -111\nKPX Abreve Tcaron -111\nKPX Abreve Tcommaaccent -111\nKPX Abreve U -55\nKPX Abreve Uacute -55\nKPX Abreve Ucircumflex -55\nKPX Abreve Udieresis -55\nKPX Abreve Ugrave -55\nKPX Abreve Uhungarumlaut -55\nKPX Abreve Umacron -55\nKPX Abreve Uogonek -55\nKPX Abreve Uring -55\nKPX Abreve V -135\nKPX Abreve W -90\nKPX Abreve Y -105\nKPX Abreve Yacute -105\nKPX Abreve Ydieresis -105\nKPX Abreve quoteright -111\nKPX Abreve v -74\nKPX Abreve w -92\nKPX Abreve y -92\nKPX Abreve yacute -92\nKPX Abreve ydieresis -92\nKPX Acircumflex C -40\nKPX Acircumflex Cacute -40\nKPX Acircumflex Ccaron -40\nKPX Acircumflex Ccedilla -40\nKPX Acircumflex G -40\nKPX Acircumflex Gbreve -40\nKPX Acircumflex Gcommaaccent -40\nKPX Acircumflex O -55\nKPX Acircumflex Oacute -55\nKPX Acircumflex Ocircumflex -55\nKPX Acircumflex Odieresis -55\nKPX Acircumflex Ograve -55\nKPX Acircumflex Ohungarumlaut -55\nKPX Acircumflex Omacron -55\nKPX Acircumflex Oslash -55\nKPX Acircumflex Otilde -55\nKPX Acircumflex Q -55\nKPX Acircumflex T -111\nKPX Acircumflex Tcaron -111\nKPX Acircumflex Tcommaaccent -111\nKPX Acircumflex U -55\nKPX Acircumflex Uacute -55\nKPX Acircumflex Ucircumflex -55\nKPX Acircumflex Udieresis -55\nKPX Acircumflex Ugrave -55\nKPX Acircumflex Uhungarumlaut -55\nKPX Acircumflex Umacron -55\nKPX Acircumflex Uogonek -55\nKPX Acircumflex Uring -55\nKPX Acircumflex V -135\nKPX Acircumflex W -90\nKPX Acircumflex Y -105\nKPX Acircumflex Yacute -105\nKPX Acircumflex Ydieresis -105\nKPX Acircumflex quoteright -111\nKPX Acircumflex v -74\nKPX Acircumflex w -92\nKPX Acircumflex y -92\nKPX Acircumflex yacute -92\nKPX Acircumflex ydieresis -92\nKPX Adieresis C -40\nKPX Adieresis Cacute -40\nKPX Adieresis Ccaron -40\nKPX Adieresis Ccedilla -40\nKPX Adieresis G -40\nKPX Adieresis Gbreve -40\nKPX Adieresis Gcommaaccent -40\nKPX Adieresis O -55\nKPX Adieresis Oacute -55\nKPX Adieresis Ocircumflex -55\nKPX Adieresis Odieresis -55\nKPX Adieresis Ograve -55\nKPX Adieresis Ohungarumlaut -55\nKPX Adieresis Omacron -55\nKPX Adieresis Oslash -55\nKPX Adieresis Otilde -55\nKPX Adieresis Q -55\nKPX Adieresis T -111\nKPX Adieresis Tcaron -111\nKPX Adieresis Tcommaaccent -111\nKPX Adieresis U -55\nKPX Adieresis Uacute -55\nKPX Adieresis Ucircumflex -55\nKPX Adieresis Udieresis -55\nKPX Adieresis Ugrave -55\nKPX Adieresis Uhungarumlaut -55\nKPX Adieresis Umacron -55\nKPX Adieresis Uogonek -55\nKPX Adieresis Uring -55\nKPX Adieresis V -135\nKPX Adieresis W -90\nKPX Adieresis Y -105\nKPX Adieresis Yacute -105\nKPX Adieresis Ydieresis -105\nKPX Adieresis quoteright -111\nKPX Adieresis v -74\nKPX Adieresis w -92\nKPX Adieresis y -92\nKPX Adieresis yacute -92\nKPX Adieresis ydieresis -92\nKPX Agrave C -40\nKPX Agrave Cacute -40\nKPX Agrave Ccaron -40\nKPX Agrave Ccedilla -40\nKPX Agrave G -40\nKPX Agrave Gbreve -40\nKPX Agrave Gcommaaccent -40\nKPX Agrave O -55\nKPX Agrave Oacute -55\nKPX Agrave Ocircumflex -55\nKPX Agrave Odieresis -55\nKPX Agrave Ograve -55\nKPX Agrave Ohungarumlaut -55\nKPX Agrave Omacron -55\nKPX Agrave Oslash -55\nKPX Agrave Otilde -55\nKPX Agrave Q -55\nKPX Agrave T -111\nKPX Agrave Tcaron -111\nKPX Agrave Tcommaaccent -111\nKPX Agrave U -55\nKPX Agrave Uacute -55\nKPX Agrave Ucircumflex -55\nKPX Agrave Udieresis -55\nKPX Agrave Ugrave -55\nKPX Agrave Uhungarumlaut -55\nKPX Agrave Umacron -55\nKPX Agrave Uogonek -55\nKPX Agrave Uring -55\nKPX Agrave V -135\nKPX Agrave W -90\nKPX Agrave Y -105\nKPX Agrave Yacute -105\nKPX Agrave Ydieresis -105\nKPX Agrave quoteright -111\nKPX Agrave v -74\nKPX Agrave w -92\nKPX Agrave y -92\nKPX Agrave yacute -92\nKPX Agrave ydieresis -92\nKPX Amacron C -40\nKPX Amacron Cacute -40\nKPX Amacron Ccaron -40\nKPX Amacron Ccedilla -40\nKPX Amacron G -40\nKPX Amacron Gbreve -40\nKPX Amacron Gcommaaccent -40\nKPX Amacron O -55\nKPX Amacron Oacute -55\nKPX Amacron Ocircumflex -55\nKPX Amacron Odieresis -55\nKPX Amacron Ograve -55\nKPX Amacron Ohungarumlaut -55\nKPX Amacron Omacron -55\nKPX Amacron Oslash -55\nKPX Amacron Otilde -55\nKPX Amacron Q -55\nKPX Amacron T -111\nKPX Amacron Tcaron -111\nKPX Amacron Tcommaaccent -111\nKPX Amacron U -55\nKPX Amacron Uacute -55\nKPX Amacron Ucircumflex -55\nKPX Amacron Udieresis -55\nKPX Amacron Ugrave -55\nKPX Amacron Uhungarumlaut -55\nKPX Amacron Umacron -55\nKPX Amacron Uogonek -55\nKPX Amacron Uring -55\nKPX Amacron V -135\nKPX Amacron W -90\nKPX Amacron Y -105\nKPX Amacron Yacute -105\nKPX Amacron Ydieresis -105\nKPX Amacron quoteright -111\nKPX Amacron v -74\nKPX Amacron w -92\nKPX Amacron y -92\nKPX Amacron yacute -92\nKPX Amacron ydieresis -92\nKPX Aogonek C -40\nKPX Aogonek Cacute -40\nKPX Aogonek Ccaron -40\nKPX Aogonek Ccedilla -40\nKPX Aogonek G -40\nKPX Aogonek Gbreve -40\nKPX Aogonek Gcommaaccent -40\nKPX Aogonek O -55\nKPX Aogonek Oacute -55\nKPX Aogonek Ocircumflex -55\nKPX Aogonek Odieresis -55\nKPX Aogonek Ograve -55\nKPX Aogonek Ohungarumlaut -55\nKPX Aogonek Omacron -55\nKPX Aogonek Oslash -55\nKPX Aogonek Otilde -55\nKPX Aogonek Q -55\nKPX Aogonek T -111\nKPX Aogonek Tcaron -111\nKPX Aogonek Tcommaaccent -111\nKPX Aogonek U -55\nKPX Aogonek Uacute -55\nKPX Aogonek Ucircumflex -55\nKPX Aogonek Udieresis -55\nKPX Aogonek Ugrave -55\nKPX Aogonek Uhungarumlaut -55\nKPX Aogonek Umacron -55\nKPX Aogonek Uogonek -55\nKPX Aogonek Uring -55\nKPX Aogonek V -135\nKPX Aogonek W -90\nKPX Aogonek Y -105\nKPX Aogonek Yacute -105\nKPX Aogonek Ydieresis -105\nKPX Aogonek quoteright -111\nKPX Aogonek v -74\nKPX Aogonek w -52\nKPX Aogonek y -52\nKPX Aogonek yacute -52\nKPX Aogonek ydieresis -52\nKPX Aring C -40\nKPX Aring Cacute -40\nKPX Aring Ccaron -40\nKPX Aring Ccedilla -40\nKPX Aring G -40\nKPX Aring Gbreve -40\nKPX Aring Gcommaaccent -40\nKPX Aring O -55\nKPX Aring Oacute -55\nKPX Aring Ocircumflex -55\nKPX Aring Odieresis -55\nKPX Aring Ograve -55\nKPX Aring Ohungarumlaut -55\nKPX Aring Omacron -55\nKPX Aring Oslash -55\nKPX Aring Otilde -55\nKPX Aring Q -55\nKPX Aring T -111\nKPX Aring Tcaron -111\nKPX Aring Tcommaaccent -111\nKPX Aring U -55\nKPX Aring Uacute -55\nKPX Aring Ucircumflex -55\nKPX Aring Udieresis -55\nKPX Aring Ugrave -55\nKPX Aring Uhungarumlaut -55\nKPX Aring Umacron -55\nKPX Aring Uogonek -55\nKPX Aring Uring -55\nKPX Aring V -135\nKPX Aring W -90\nKPX Aring Y -105\nKPX Aring Yacute -105\nKPX Aring Ydieresis -105\nKPX Aring quoteright -111\nKPX Aring v -74\nKPX Aring w -92\nKPX Aring y -92\nKPX Aring yacute -92\nKPX Aring ydieresis -92\nKPX Atilde C -40\nKPX Atilde Cacute -40\nKPX Atilde Ccaron -40\nKPX Atilde Ccedilla -40\nKPX Atilde G -40\nKPX Atilde Gbreve -40\nKPX Atilde Gcommaaccent -40\nKPX Atilde O -55\nKPX Atilde Oacute -55\nKPX Atilde Ocircumflex -55\nKPX Atilde Odieresis -55\nKPX Atilde Ograve -55\nKPX Atilde Ohungarumlaut -55\nKPX Atilde Omacron -55\nKPX Atilde Oslash -55\nKPX Atilde Otilde -55\nKPX Atilde Q -55\nKPX Atilde T -111\nKPX Atilde Tcaron -111\nKPX Atilde Tcommaaccent -111\nKPX Atilde U -55\nKPX Atilde Uacute -55\nKPX Atilde Ucircumflex -55\nKPX Atilde Udieresis -55\nKPX Atilde Ugrave -55\nKPX Atilde Uhungarumlaut -55\nKPX Atilde Umacron -55\nKPX Atilde Uogonek -55\nKPX Atilde Uring -55\nKPX Atilde V -135\nKPX Atilde W -90\nKPX Atilde Y -105\nKPX Atilde Yacute -105\nKPX Atilde Ydieresis -105\nKPX Atilde quoteright -111\nKPX Atilde v -74\nKPX Atilde w -92\nKPX Atilde y -92\nKPX Atilde yacute -92\nKPX Atilde ydieresis -92\nKPX B A -35\nKPX B Aacute -35\nKPX B Abreve -35\nKPX B Acircumflex -35\nKPX B Adieresis -35\nKPX B Agrave -35\nKPX B Amacron -35\nKPX B Aogonek -35\nKPX B Aring -35\nKPX B Atilde -35\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX D A -40\nKPX D Aacute -40\nKPX D Abreve -40\nKPX D Acircumflex -40\nKPX D Adieresis -40\nKPX D Agrave -40\nKPX D Amacron -40\nKPX D Aogonek -40\nKPX D Aring -40\nKPX D Atilde -40\nKPX D V -40\nKPX D W -30\nKPX D Y -55\nKPX D Yacute -55\nKPX D Ydieresis -55\nKPX Dcaron A -40\nKPX Dcaron Aacute -40\nKPX Dcaron Abreve -40\nKPX Dcaron Acircumflex -40\nKPX Dcaron Adieresis -40\nKPX Dcaron Agrave -40\nKPX Dcaron Amacron -40\nKPX Dcaron Aogonek -40\nKPX Dcaron Aring -40\nKPX Dcaron Atilde -40\nKPX Dcaron V -40\nKPX Dcaron W -30\nKPX Dcaron Y -55\nKPX Dcaron Yacute -55\nKPX Dcaron Ydieresis -55\nKPX Dcroat A -40\nKPX Dcroat Aacute -40\nKPX Dcroat Abreve -40\nKPX Dcroat Acircumflex -40\nKPX Dcroat Adieresis -40\nKPX Dcroat Agrave -40\nKPX Dcroat Amacron -40\nKPX Dcroat Aogonek -40\nKPX Dcroat Aring -40\nKPX Dcroat Atilde -40\nKPX Dcroat V -40\nKPX Dcroat W -30\nKPX Dcroat Y -55\nKPX Dcroat Yacute -55\nKPX Dcroat Ydieresis -55\nKPX F A -74\nKPX F Aacute -74\nKPX F Abreve -74\nKPX F Acircumflex -74\nKPX F Adieresis -74\nKPX F Agrave -74\nKPX F Amacron -74\nKPX F Aogonek -74\nKPX F Aring -74\nKPX F Atilde -74\nKPX F a -15\nKPX F aacute -15\nKPX F abreve -15\nKPX F acircumflex -15\nKPX F adieresis -15\nKPX F agrave -15\nKPX F amacron -15\nKPX F aogonek -15\nKPX F aring -15\nKPX F atilde -15\nKPX F comma -80\nKPX F o -15\nKPX F oacute -15\nKPX F ocircumflex -15\nKPX F odieresis -15\nKPX F ograve -15\nKPX F ohungarumlaut -15\nKPX F omacron -15\nKPX F oslash -15\nKPX F otilde -15\nKPX F period -80\nKPX J A -60\nKPX J Aacute -60\nKPX J Abreve -60\nKPX J Acircumflex -60\nKPX J Adieresis -60\nKPX J Agrave -60\nKPX J Amacron -60\nKPX J Aogonek -60\nKPX J Aring -60\nKPX J Atilde -60\nKPX K O -30\nKPX K Oacute -30\nKPX K Ocircumflex -30\nKPX K Odieresis -30\nKPX K Ograve -30\nKPX K Ohungarumlaut -30\nKPX K Omacron -30\nKPX K Oslash -30\nKPX K Otilde -30\nKPX K e -25\nKPX K eacute -25\nKPX K ecaron -25\nKPX K ecircumflex -25\nKPX K edieresis -25\nKPX K edotaccent -25\nKPX K egrave -25\nKPX K emacron -25\nKPX K eogonek -25\nKPX K o -35\nKPX K oacute -35\nKPX K ocircumflex -35\nKPX K odieresis -35\nKPX K ograve -35\nKPX K ohungarumlaut -35\nKPX K omacron -35\nKPX K oslash -35\nKPX K otilde -35\nKPX K u -15\nKPX K uacute -15\nKPX K ucircumflex -15\nKPX K udieresis -15\nKPX K ugrave -15\nKPX K uhungarumlaut -15\nKPX K umacron -15\nKPX K uogonek -15\nKPX K uring -15\nKPX K y -25\nKPX K yacute -25\nKPX K ydieresis -25\nKPX Kcommaaccent O -30\nKPX Kcommaaccent Oacute -30\nKPX Kcommaaccent Ocircumflex -30\nKPX Kcommaaccent Odieresis -30\nKPX Kcommaaccent Ograve -30\nKPX Kcommaaccent Ohungarumlaut -30\nKPX Kcommaaccent Omacron -30\nKPX Kcommaaccent Oslash -30\nKPX Kcommaaccent Otilde -30\nKPX Kcommaaccent e -25\nKPX Kcommaaccent eacute -25\nKPX Kcommaaccent ecaron -25\nKPX Kcommaaccent ecircumflex -25\nKPX Kcommaaccent edieresis -25\nKPX Kcommaaccent edotaccent -25\nKPX Kcommaaccent egrave -25\nKPX Kcommaaccent emacron -25\nKPX Kcommaaccent eogonek -25\nKPX Kcommaaccent o -35\nKPX Kcommaaccent oacute -35\nKPX Kcommaaccent ocircumflex -35\nKPX Kcommaaccent odieresis -35\nKPX Kcommaaccent ograve -35\nKPX Kcommaaccent ohungarumlaut -35\nKPX Kcommaaccent omacron -35\nKPX Kcommaaccent oslash -35\nKPX Kcommaaccent otilde -35\nKPX Kcommaaccent u -15\nKPX Kcommaaccent uacute -15\nKPX Kcommaaccent ucircumflex -15\nKPX Kcommaaccent udieresis -15\nKPX Kcommaaccent ugrave -15\nKPX Kcommaaccent uhungarumlaut -15\nKPX Kcommaaccent umacron -15\nKPX Kcommaaccent uogonek -15\nKPX Kcommaaccent uring -15\nKPX Kcommaaccent y -25\nKPX Kcommaaccent yacute -25\nKPX Kcommaaccent ydieresis -25\nKPX L T -92\nKPX L Tcaron -92\nKPX L Tcommaaccent -92\nKPX L V -100\nKPX L W -74\nKPX L Y -100\nKPX L Yacute -100\nKPX L Ydieresis -100\nKPX L quoteright -92\nKPX L y -55\nKPX L yacute -55\nKPX L ydieresis -55\nKPX Lacute T -92\nKPX Lacute Tcaron -92\nKPX Lacute Tcommaaccent -92\nKPX Lacute V -100\nKPX Lacute W -74\nKPX Lacute Y -100\nKPX Lacute Yacute -100\nKPX Lacute Ydieresis -100\nKPX Lacute quoteright -92\nKPX Lacute y -55\nKPX Lacute yacute -55\nKPX Lacute ydieresis -55\nKPX Lcaron quoteright -92\nKPX Lcaron y -55\nKPX Lcaron yacute -55\nKPX Lcaron ydieresis -55\nKPX Lcommaaccent T -92\nKPX Lcommaaccent Tcaron -92\nKPX Lcommaaccent Tcommaaccent -92\nKPX Lcommaaccent V -100\nKPX Lcommaaccent W -74\nKPX Lcommaaccent Y -100\nKPX Lcommaaccent Yacute -100\nKPX Lcommaaccent Ydieresis -100\nKPX Lcommaaccent quoteright -92\nKPX Lcommaaccent y -55\nKPX Lcommaaccent yacute -55\nKPX Lcommaaccent ydieresis -55\nKPX Lslash T -92\nKPX Lslash Tcaron -92\nKPX Lslash Tcommaaccent -92\nKPX Lslash V -100\nKPX Lslash W -74\nKPX Lslash Y -100\nKPX Lslash Yacute -100\nKPX Lslash Ydieresis -100\nKPX Lslash quoteright -92\nKPX Lslash y -55\nKPX Lslash yacute -55\nKPX Lslash ydieresis -55\nKPX N A -35\nKPX N Aacute -35\nKPX N Abreve -35\nKPX N Acircumflex -35\nKPX N Adieresis -35\nKPX N Agrave -35\nKPX N Amacron -35\nKPX N Aogonek -35\nKPX N Aring -35\nKPX N Atilde -35\nKPX Nacute A -35\nKPX Nacute Aacute -35\nKPX Nacute Abreve -35\nKPX Nacute Acircumflex -35\nKPX Nacute Adieresis -35\nKPX Nacute Agrave -35\nKPX Nacute Amacron -35\nKPX Nacute Aogonek -35\nKPX Nacute Aring -35\nKPX Nacute Atilde -35\nKPX Ncaron A -35\nKPX Ncaron Aacute -35\nKPX Ncaron Abreve -35\nKPX Ncaron Acircumflex -35\nKPX Ncaron Adieresis -35\nKPX Ncaron Agrave -35\nKPX Ncaron Amacron -35\nKPX Ncaron Aogonek -35\nKPX Ncaron Aring -35\nKPX Ncaron Atilde -35\nKPX Ncommaaccent A -35\nKPX Ncommaaccent Aacute -35\nKPX Ncommaaccent Abreve -35\nKPX Ncommaaccent Acircumflex -35\nKPX Ncommaaccent Adieresis -35\nKPX Ncommaaccent Agrave -35\nKPX Ncommaaccent Amacron -35\nKPX Ncommaaccent Aogonek -35\nKPX Ncommaaccent Aring -35\nKPX Ncommaaccent Atilde -35\nKPX Ntilde A -35\nKPX Ntilde Aacute -35\nKPX Ntilde Abreve -35\nKPX Ntilde Acircumflex -35\nKPX Ntilde Adieresis -35\nKPX Ntilde Agrave -35\nKPX Ntilde Amacron -35\nKPX Ntilde Aogonek -35\nKPX Ntilde Aring -35\nKPX Ntilde Atilde -35\nKPX O A -35\nKPX O Aacute -35\nKPX O Abreve -35\nKPX O Acircumflex -35\nKPX O Adieresis -35\nKPX O Agrave -35\nKPX O Amacron -35\nKPX O Aogonek -35\nKPX O Aring -35\nKPX O Atilde -35\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -35\nKPX O X -40\nKPX O Y -50\nKPX O Yacute -50\nKPX O Ydieresis -50\nKPX Oacute A -35\nKPX Oacute Aacute -35\nKPX Oacute Abreve -35\nKPX Oacute Acircumflex -35\nKPX Oacute Adieresis -35\nKPX Oacute Agrave -35\nKPX Oacute Amacron -35\nKPX Oacute Aogonek -35\nKPX Oacute Aring -35\nKPX Oacute Atilde -35\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -35\nKPX Oacute X -40\nKPX Oacute Y -50\nKPX Oacute Yacute -50\nKPX Oacute Ydieresis -50\nKPX Ocircumflex A -35\nKPX Ocircumflex Aacute -35\nKPX Ocircumflex Abreve -35\nKPX Ocircumflex Acircumflex -35\nKPX Ocircumflex Adieresis -35\nKPX Ocircumflex Agrave -35\nKPX Ocircumflex Amacron -35\nKPX Ocircumflex Aogonek -35\nKPX Ocircumflex Aring -35\nKPX Ocircumflex Atilde -35\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -35\nKPX Ocircumflex X -40\nKPX Ocircumflex Y -50\nKPX Ocircumflex Yacute -50\nKPX Ocircumflex Ydieresis -50\nKPX Odieresis A -35\nKPX Odieresis Aacute -35\nKPX Odieresis Abreve -35\nKPX Odieresis Acircumflex -35\nKPX Odieresis Adieresis -35\nKPX Odieresis Agrave -35\nKPX Odieresis Amacron -35\nKPX Odieresis Aogonek -35\nKPX Odieresis Aring -35\nKPX Odieresis Atilde -35\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -35\nKPX Odieresis X -40\nKPX Odieresis Y -50\nKPX Odieresis Yacute -50\nKPX Odieresis Ydieresis -50\nKPX Ograve A -35\nKPX Ograve Aacute -35\nKPX Ograve Abreve -35\nKPX Ograve Acircumflex -35\nKPX Ograve Adieresis -35\nKPX Ograve Agrave -35\nKPX Ograve Amacron -35\nKPX Ograve Aogonek -35\nKPX Ograve Aring -35\nKPX Ograve Atilde -35\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -35\nKPX Ograve X -40\nKPX Ograve Y -50\nKPX Ograve Yacute -50\nKPX Ograve Ydieresis -50\nKPX Ohungarumlaut A -35\nKPX Ohungarumlaut Aacute -35\nKPX Ohungarumlaut Abreve -35\nKPX Ohungarumlaut Acircumflex -35\nKPX Ohungarumlaut Adieresis -35\nKPX Ohungarumlaut Agrave -35\nKPX Ohungarumlaut Amacron -35\nKPX Ohungarumlaut Aogonek -35\nKPX Ohungarumlaut Aring -35\nKPX Ohungarumlaut Atilde -35\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -35\nKPX Ohungarumlaut X -40\nKPX Ohungarumlaut Y -50\nKPX Ohungarumlaut Yacute -50\nKPX Ohungarumlaut Ydieresis -50\nKPX Omacron A -35\nKPX Omacron Aacute -35\nKPX Omacron Abreve -35\nKPX Omacron Acircumflex -35\nKPX Omacron Adieresis -35\nKPX Omacron Agrave -35\nKPX Omacron Amacron -35\nKPX Omacron Aogonek -35\nKPX Omacron Aring -35\nKPX Omacron Atilde -35\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -35\nKPX Omacron X -40\nKPX Omacron Y -50\nKPX Omacron Yacute -50\nKPX Omacron Ydieresis -50\nKPX Oslash A -35\nKPX Oslash Aacute -35\nKPX Oslash Abreve -35\nKPX Oslash Acircumflex -35\nKPX Oslash Adieresis -35\nKPX Oslash Agrave -35\nKPX Oslash Amacron -35\nKPX Oslash Aogonek -35\nKPX Oslash Aring -35\nKPX Oslash Atilde -35\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -35\nKPX Oslash X -40\nKPX Oslash Y -50\nKPX Oslash Yacute -50\nKPX Oslash Ydieresis -50\nKPX Otilde A -35\nKPX Otilde Aacute -35\nKPX Otilde Abreve -35\nKPX Otilde Acircumflex -35\nKPX Otilde Adieresis -35\nKPX Otilde Agrave -35\nKPX Otilde Amacron -35\nKPX Otilde Aogonek -35\nKPX Otilde Aring -35\nKPX Otilde Atilde -35\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -35\nKPX Otilde X -40\nKPX Otilde Y -50\nKPX Otilde Yacute -50\nKPX Otilde Ydieresis -50\nKPX P A -92\nKPX P Aacute -92\nKPX P Abreve -92\nKPX P Acircumflex -92\nKPX P Adieresis -92\nKPX P Agrave -92\nKPX P Amacron -92\nKPX P Aogonek -92\nKPX P Aring -92\nKPX P Atilde -92\nKPX P a -15\nKPX P aacute -15\nKPX P abreve -15\nKPX P acircumflex -15\nKPX P adieresis -15\nKPX P agrave -15\nKPX P amacron -15\nKPX P aogonek -15\nKPX P aring -15\nKPX P atilde -15\nKPX P comma -111\nKPX P period -111\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX R O -40\nKPX R Oacute -40\nKPX R Ocircumflex -40\nKPX R Odieresis -40\nKPX R Ograve -40\nKPX R Ohungarumlaut -40\nKPX R Omacron -40\nKPX R Oslash -40\nKPX R Otilde -40\nKPX R T -60\nKPX R Tcaron -60\nKPX R Tcommaaccent -60\nKPX R U -40\nKPX R Uacute -40\nKPX R Ucircumflex -40\nKPX R Udieresis -40\nKPX R Ugrave -40\nKPX R Uhungarumlaut -40\nKPX R Umacron -40\nKPX R Uogonek -40\nKPX R Uring -40\nKPX R V -80\nKPX R W -55\nKPX R Y -65\nKPX R Yacute -65\nKPX R Ydieresis -65\nKPX Racute O -40\nKPX Racute Oacute -40\nKPX Racute Ocircumflex -40\nKPX Racute Odieresis -40\nKPX Racute Ograve -40\nKPX Racute Ohungarumlaut -40\nKPX Racute Omacron -40\nKPX Racute Oslash -40\nKPX Racute Otilde -40\nKPX Racute T -60\nKPX Racute Tcaron -60\nKPX Racute Tcommaaccent -60\nKPX Racute U -40\nKPX Racute Uacute -40\nKPX Racute Ucircumflex -40\nKPX Racute Udieresis -40\nKPX Racute Ugrave -40\nKPX Racute Uhungarumlaut -40\nKPX Racute Umacron -40\nKPX Racute Uogonek -40\nKPX Racute Uring -40\nKPX Racute V -80\nKPX Racute W -55\nKPX Racute Y -65\nKPX Racute Yacute -65\nKPX Racute Ydieresis -65\nKPX Rcaron O -40\nKPX Rcaron Oacute -40\nKPX Rcaron Ocircumflex -40\nKPX Rcaron Odieresis -40\nKPX Rcaron Ograve -40\nKPX Rcaron Ohungarumlaut -40\nKPX Rcaron Omacron -40\nKPX Rcaron Oslash -40\nKPX Rcaron Otilde -40\nKPX Rcaron T -60\nKPX Rcaron Tcaron -60\nKPX Rcaron Tcommaaccent -60\nKPX Rcaron U -40\nKPX Rcaron Uacute -40\nKPX Rcaron Ucircumflex -40\nKPX Rcaron Udieresis -40\nKPX Rcaron Ugrave -40\nKPX Rcaron Uhungarumlaut -40\nKPX Rcaron Umacron -40\nKPX Rcaron Uogonek -40\nKPX Rcaron Uring -40\nKPX Rcaron V -80\nKPX Rcaron W -55\nKPX Rcaron Y -65\nKPX Rcaron Yacute -65\nKPX Rcaron Ydieresis -65\nKPX Rcommaaccent O -40\nKPX Rcommaaccent Oacute -40\nKPX Rcommaaccent Ocircumflex -40\nKPX Rcommaaccent Odieresis -40\nKPX Rcommaaccent Ograve -40\nKPX Rcommaaccent Ohungarumlaut -40\nKPX Rcommaaccent Omacron -40\nKPX Rcommaaccent Oslash -40\nKPX Rcommaaccent Otilde -40\nKPX Rcommaaccent T -60\nKPX Rcommaaccent Tcaron -60\nKPX Rcommaaccent Tcommaaccent -60\nKPX Rcommaaccent U -40\nKPX Rcommaaccent Uacute -40\nKPX Rcommaaccent Ucircumflex -40\nKPX Rcommaaccent Udieresis -40\nKPX Rcommaaccent Ugrave -40\nKPX Rcommaaccent Uhungarumlaut -40\nKPX Rcommaaccent Umacron -40\nKPX Rcommaaccent Uogonek -40\nKPX Rcommaaccent Uring -40\nKPX Rcommaaccent V -80\nKPX Rcommaaccent W -55\nKPX Rcommaaccent Y -65\nKPX Rcommaaccent Yacute -65\nKPX Rcommaaccent Ydieresis -65\nKPX T A -93\nKPX T Aacute -93\nKPX T Abreve -93\nKPX T Acircumflex -93\nKPX T Adieresis -93\nKPX T Agrave -93\nKPX T Amacron -93\nKPX T Aogonek -93\nKPX T Aring -93\nKPX T Atilde -93\nKPX T O -18\nKPX T Oacute -18\nKPX T Ocircumflex -18\nKPX T Odieresis -18\nKPX T Ograve -18\nKPX T Ohungarumlaut -18\nKPX T Omacron -18\nKPX T Oslash -18\nKPX T Otilde -18\nKPX T a -80\nKPX T aacute -80\nKPX T abreve -80\nKPX T acircumflex -80\nKPX T adieresis -40\nKPX T agrave -40\nKPX T amacron -40\nKPX T aogonek -80\nKPX T aring -80\nKPX T atilde -40\nKPX T colon -50\nKPX T comma -74\nKPX T e -70\nKPX T eacute -70\nKPX T ecaron -70\nKPX T ecircumflex -70\nKPX T edieresis -30\nKPX T edotaccent -70\nKPX T egrave -70\nKPX T emacron -30\nKPX T eogonek -70\nKPX T hyphen -92\nKPX T i -35\nKPX T iacute -35\nKPX T iogonek -35\nKPX T o -80\nKPX T oacute -80\nKPX T ocircumflex -80\nKPX T odieresis -80\nKPX T ograve -80\nKPX T ohungarumlaut -80\nKPX T omacron -80\nKPX T oslash -80\nKPX T otilde -80\nKPX T period -74\nKPX T r -35\nKPX T racute -35\nKPX T rcaron -35\nKPX T rcommaaccent -35\nKPX T semicolon -55\nKPX T u -45\nKPX T uacute -45\nKPX T ucircumflex -45\nKPX T udieresis -45\nKPX T ugrave -45\nKPX T uhungarumlaut -45\nKPX T umacron -45\nKPX T uogonek -45\nKPX T uring -45\nKPX T w -80\nKPX T y -80\nKPX T yacute -80\nKPX T ydieresis -80\nKPX Tcaron A -93\nKPX Tcaron Aacute -93\nKPX Tcaron Abreve -93\nKPX Tcaron Acircumflex -93\nKPX Tcaron Adieresis -93\nKPX Tcaron Agrave -93\nKPX Tcaron Amacron -93\nKPX Tcaron Aogonek -93\nKPX Tcaron Aring -93\nKPX Tcaron Atilde -93\nKPX Tcaron O -18\nKPX Tcaron Oacute -18\nKPX Tcaron Ocircumflex -18\nKPX Tcaron Odieresis -18\nKPX Tcaron Ograve -18\nKPX Tcaron Ohungarumlaut -18\nKPX Tcaron Omacron -18\nKPX Tcaron Oslash -18\nKPX Tcaron Otilde -18\nKPX Tcaron a -80\nKPX Tcaron aacute -80\nKPX Tcaron abreve -80\nKPX Tcaron acircumflex -80\nKPX Tcaron adieresis -40\nKPX Tcaron agrave -40\nKPX Tcaron amacron -40\nKPX Tcaron aogonek -80\nKPX Tcaron aring -80\nKPX Tcaron atilde -40\nKPX Tcaron colon -50\nKPX Tcaron comma -74\nKPX Tcaron e -70\nKPX Tcaron eacute -70\nKPX Tcaron ecaron -70\nKPX Tcaron ecircumflex -30\nKPX Tcaron edieresis -30\nKPX Tcaron edotaccent -70\nKPX Tcaron egrave -70\nKPX Tcaron emacron -30\nKPX Tcaron eogonek -70\nKPX Tcaron hyphen -92\nKPX Tcaron i -35\nKPX Tcaron iacute -35\nKPX Tcaron iogonek -35\nKPX Tcaron o -80\nKPX Tcaron oacute -80\nKPX Tcaron ocircumflex -80\nKPX Tcaron odieresis -80\nKPX Tcaron ograve -80\nKPX Tcaron ohungarumlaut -80\nKPX Tcaron omacron -80\nKPX Tcaron oslash -80\nKPX Tcaron otilde -80\nKPX Tcaron period -74\nKPX Tcaron r -35\nKPX Tcaron racute -35\nKPX Tcaron rcaron -35\nKPX Tcaron rcommaaccent -35\nKPX Tcaron semicolon -55\nKPX Tcaron u -45\nKPX Tcaron uacute -45\nKPX Tcaron ucircumflex -45\nKPX Tcaron udieresis -45\nKPX Tcaron ugrave -45\nKPX Tcaron uhungarumlaut -45\nKPX Tcaron umacron -45\nKPX Tcaron uogonek -45\nKPX Tcaron uring -45\nKPX Tcaron w -80\nKPX Tcaron y -80\nKPX Tcaron yacute -80\nKPX Tcaron ydieresis -80\nKPX Tcommaaccent A -93\nKPX Tcommaaccent Aacute -93\nKPX Tcommaaccent Abreve -93\nKPX Tcommaaccent Acircumflex -93\nKPX Tcommaaccent Adieresis -93\nKPX Tcommaaccent Agrave -93\nKPX Tcommaaccent Amacron -93\nKPX Tcommaaccent Aogonek -93\nKPX Tcommaaccent Aring -93\nKPX Tcommaaccent Atilde -93\nKPX Tcommaaccent O -18\nKPX Tcommaaccent Oacute -18\nKPX Tcommaaccent Ocircumflex -18\nKPX Tcommaaccent Odieresis -18\nKPX Tcommaaccent Ograve -18\nKPX Tcommaaccent Ohungarumlaut -18\nKPX Tcommaaccent Omacron -18\nKPX Tcommaaccent Oslash -18\nKPX Tcommaaccent Otilde -18\nKPX Tcommaaccent a -80\nKPX Tcommaaccent aacute -80\nKPX Tcommaaccent abreve -80\nKPX Tcommaaccent acircumflex -80\nKPX Tcommaaccent adieresis -40\nKPX Tcommaaccent agrave -40\nKPX Tcommaaccent amacron -40\nKPX Tcommaaccent aogonek -80\nKPX Tcommaaccent aring -80\nKPX Tcommaaccent atilde -40\nKPX Tcommaaccent colon -50\nKPX Tcommaaccent comma -74\nKPX Tcommaaccent e -70\nKPX Tcommaaccent eacute -70\nKPX Tcommaaccent ecaron -70\nKPX Tcommaaccent ecircumflex -30\nKPX Tcommaaccent edieresis -30\nKPX Tcommaaccent edotaccent -70\nKPX Tcommaaccent egrave -30\nKPX Tcommaaccent emacron -70\nKPX Tcommaaccent eogonek -70\nKPX Tcommaaccent hyphen -92\nKPX Tcommaaccent i -35\nKPX Tcommaaccent iacute -35\nKPX Tcommaaccent iogonek -35\nKPX Tcommaaccent o -80\nKPX Tcommaaccent oacute -80\nKPX Tcommaaccent ocircumflex -80\nKPX Tcommaaccent odieresis -80\nKPX Tcommaaccent ograve -80\nKPX Tcommaaccent ohungarumlaut -80\nKPX Tcommaaccent omacron -80\nKPX Tcommaaccent oslash -80\nKPX Tcommaaccent otilde -80\nKPX Tcommaaccent period -74\nKPX Tcommaaccent r -35\nKPX Tcommaaccent racute -35\nKPX Tcommaaccent rcaron -35\nKPX Tcommaaccent rcommaaccent -35\nKPX Tcommaaccent semicolon -55\nKPX Tcommaaccent u -45\nKPX Tcommaaccent uacute -45\nKPX Tcommaaccent ucircumflex -45\nKPX Tcommaaccent udieresis -45\nKPX Tcommaaccent ugrave -45\nKPX Tcommaaccent uhungarumlaut -45\nKPX Tcommaaccent umacron -45\nKPX Tcommaaccent uogonek -45\nKPX Tcommaaccent uring -45\nKPX Tcommaaccent w -80\nKPX Tcommaaccent y -80\nKPX Tcommaaccent yacute -80\nKPX Tcommaaccent ydieresis -80\nKPX U A -40\nKPX U Aacute -40\nKPX U Abreve -40\nKPX U Acircumflex -40\nKPX U Adieresis -40\nKPX U Agrave -40\nKPX U Amacron -40\nKPX U Aogonek -40\nKPX U Aring -40\nKPX U Atilde -40\nKPX Uacute A -40\nKPX Uacute Aacute -40\nKPX Uacute Abreve -40\nKPX Uacute Acircumflex -40\nKPX Uacute Adieresis -40\nKPX Uacute Agrave -40\nKPX Uacute Amacron -40\nKPX Uacute Aogonek -40\nKPX Uacute Aring -40\nKPX Uacute Atilde -40\nKPX Ucircumflex A -40\nKPX Ucircumflex Aacute -40\nKPX Ucircumflex Abreve -40\nKPX Ucircumflex Acircumflex -40\nKPX Ucircumflex Adieresis -40\nKPX Ucircumflex Agrave -40\nKPX Ucircumflex Amacron -40\nKPX Ucircumflex Aogonek -40\nKPX Ucircumflex Aring -40\nKPX Ucircumflex Atilde -40\nKPX Udieresis A -40\nKPX Udieresis Aacute -40\nKPX Udieresis Abreve -40\nKPX Udieresis Acircumflex -40\nKPX Udieresis Adieresis -40\nKPX Udieresis Agrave -40\nKPX Udieresis Amacron -40\nKPX Udieresis Aogonek -40\nKPX Udieresis Aring -40\nKPX Udieresis Atilde -40\nKPX Ugrave A -40\nKPX Ugrave Aacute -40\nKPX Ugrave Abreve -40\nKPX Ugrave Acircumflex -40\nKPX Ugrave Adieresis -40\nKPX Ugrave Agrave -40\nKPX Ugrave Amacron -40\nKPX Ugrave Aogonek -40\nKPX Ugrave Aring -40\nKPX Ugrave Atilde -40\nKPX Uhungarumlaut A -40\nKPX Uhungarumlaut Aacute -40\nKPX Uhungarumlaut Abreve -40\nKPX Uhungarumlaut Acircumflex -40\nKPX Uhungarumlaut Adieresis -40\nKPX Uhungarumlaut Agrave -40\nKPX Uhungarumlaut Amacron -40\nKPX Uhungarumlaut Aogonek -40\nKPX Uhungarumlaut Aring -40\nKPX Uhungarumlaut Atilde -40\nKPX Umacron A -40\nKPX Umacron Aacute -40\nKPX Umacron Abreve -40\nKPX Umacron Acircumflex -40\nKPX Umacron Adieresis -40\nKPX Umacron Agrave -40\nKPX Umacron Amacron -40\nKPX Umacron Aogonek -40\nKPX Umacron Aring -40\nKPX Umacron Atilde -40\nKPX Uogonek A -40\nKPX Uogonek Aacute -40\nKPX Uogonek Abreve -40\nKPX Uogonek Acircumflex -40\nKPX Uogonek Adieresis -40\nKPX Uogonek Agrave -40\nKPX Uogonek Amacron -40\nKPX Uogonek Aogonek -40\nKPX Uogonek Aring -40\nKPX Uogonek Atilde -40\nKPX Uring A -40\nKPX Uring Aacute -40\nKPX Uring Abreve -40\nKPX Uring Acircumflex -40\nKPX Uring Adieresis -40\nKPX Uring Agrave -40\nKPX Uring Amacron -40\nKPX Uring Aogonek -40\nKPX Uring Aring -40\nKPX Uring Atilde -40\nKPX V A -135\nKPX V Aacute -135\nKPX V Abreve -135\nKPX V Acircumflex -135\nKPX V Adieresis -135\nKPX V Agrave -135\nKPX V Amacron -135\nKPX V Aogonek -135\nKPX V Aring -135\nKPX V Atilde -135\nKPX V G -15\nKPX V Gbreve -15\nKPX V Gcommaaccent -15\nKPX V O -40\nKPX V Oacute -40\nKPX V Ocircumflex -40\nKPX V Odieresis -40\nKPX V Ograve -40\nKPX V Ohungarumlaut -40\nKPX V Omacron -40\nKPX V Oslash -40\nKPX V Otilde -40\nKPX V a -111\nKPX V aacute -111\nKPX V abreve -111\nKPX V acircumflex -71\nKPX V adieresis -71\nKPX V agrave -71\nKPX V amacron -71\nKPX V aogonek -111\nKPX V aring -111\nKPX V atilde -71\nKPX V colon -74\nKPX V comma -129\nKPX V e -111\nKPX V eacute -111\nKPX V ecaron -71\nKPX V ecircumflex -71\nKPX V edieresis -71\nKPX V edotaccent -111\nKPX V egrave -71\nKPX V emacron -71\nKPX V eogonek -111\nKPX V hyphen -100\nKPX V i -60\nKPX V iacute -60\nKPX V icircumflex -20\nKPX V idieresis -20\nKPX V igrave -20\nKPX V imacron -20\nKPX V iogonek -60\nKPX V o -129\nKPX V oacute -129\nKPX V ocircumflex -129\nKPX V odieresis -89\nKPX V ograve -89\nKPX V ohungarumlaut -129\nKPX V omacron -89\nKPX V oslash -129\nKPX V otilde -89\nKPX V period -129\nKPX V semicolon -74\nKPX V u -75\nKPX V uacute -75\nKPX V ucircumflex -75\nKPX V udieresis -75\nKPX V ugrave -75\nKPX V uhungarumlaut -75\nKPX V umacron -75\nKPX V uogonek -75\nKPX V uring -75\nKPX W A -120\nKPX W Aacute -120\nKPX W Abreve -120\nKPX W Acircumflex -120\nKPX W Adieresis -120\nKPX W Agrave -120\nKPX W Amacron -120\nKPX W Aogonek -120\nKPX W Aring -120\nKPX W Atilde -120\nKPX W O -10\nKPX W Oacute -10\nKPX W Ocircumflex -10\nKPX W Odieresis -10\nKPX W Ograve -10\nKPX W Ohungarumlaut -10\nKPX W Omacron -10\nKPX W Oslash -10\nKPX W Otilde -10\nKPX W a -80\nKPX W aacute -80\nKPX W abreve -80\nKPX W acircumflex -80\nKPX W adieresis -80\nKPX W agrave -80\nKPX W amacron -80\nKPX W aogonek -80\nKPX W aring -80\nKPX W atilde -80\nKPX W colon -37\nKPX W comma -92\nKPX W e -80\nKPX W eacute -80\nKPX W ecaron -80\nKPX W ecircumflex -80\nKPX W edieresis -40\nKPX W edotaccent -80\nKPX W egrave -40\nKPX W emacron -40\nKPX W eogonek -80\nKPX W hyphen -65\nKPX W i -40\nKPX W iacute -40\nKPX W iogonek -40\nKPX W o -80\nKPX W oacute -80\nKPX W ocircumflex -80\nKPX W odieresis -80\nKPX W ograve -80\nKPX W ohungarumlaut -80\nKPX W omacron -80\nKPX W oslash -80\nKPX W otilde -80\nKPX W period -92\nKPX W semicolon -37\nKPX W u -50\nKPX W uacute -50\nKPX W ucircumflex -50\nKPX W udieresis -50\nKPX W ugrave -50\nKPX W uhungarumlaut -50\nKPX W umacron -50\nKPX W uogonek -50\nKPX W uring -50\nKPX W y -73\nKPX W yacute -73\nKPX W ydieresis -73\nKPX Y A -120\nKPX Y Aacute -120\nKPX Y Abreve -120\nKPX Y Acircumflex -120\nKPX Y Adieresis -120\nKPX Y Agrave -120\nKPX Y Amacron -120\nKPX Y Aogonek -120\nKPX Y Aring -120\nKPX Y Atilde -120\nKPX Y O -30\nKPX Y Oacute -30\nKPX Y Ocircumflex -30\nKPX Y Odieresis -30\nKPX Y Ograve -30\nKPX Y Ohungarumlaut -30\nKPX Y Omacron -30\nKPX Y Oslash -30\nKPX Y Otilde -30\nKPX Y a -100\nKPX Y aacute -100\nKPX Y abreve -100\nKPX Y acircumflex -100\nKPX Y adieresis -60\nKPX Y agrave -60\nKPX Y amacron -60\nKPX Y aogonek -100\nKPX Y aring -100\nKPX Y atilde -60\nKPX Y colon -92\nKPX Y comma -129\nKPX Y e -100\nKPX Y eacute -100\nKPX Y ecaron -100\nKPX Y ecircumflex -100\nKPX Y edieresis -60\nKPX Y edotaccent -100\nKPX Y egrave -60\nKPX Y emacron -60\nKPX Y eogonek -100\nKPX Y hyphen -111\nKPX Y i -55\nKPX Y iacute -55\nKPX Y iogonek -55\nKPX Y o -110\nKPX Y oacute -110\nKPX Y ocircumflex -110\nKPX Y odieresis -70\nKPX Y ograve -70\nKPX Y ohungarumlaut -110\nKPX Y omacron -70\nKPX Y oslash -110\nKPX Y otilde -70\nKPX Y period -129\nKPX Y semicolon -92\nKPX Y u -111\nKPX Y uacute -111\nKPX Y ucircumflex -111\nKPX Y udieresis -71\nKPX Y ugrave -71\nKPX Y uhungarumlaut -111\nKPX Y umacron -71\nKPX Y uogonek -111\nKPX Y uring -111\nKPX Yacute A -120\nKPX Yacute Aacute -120\nKPX Yacute Abreve -120\nKPX Yacute Acircumflex -120\nKPX Yacute Adieresis -120\nKPX Yacute Agrave -120\nKPX Yacute Amacron -120\nKPX Yacute Aogonek -120\nKPX Yacute Aring -120\nKPX Yacute Atilde -120\nKPX Yacute O -30\nKPX Yacute Oacute -30\nKPX Yacute Ocircumflex -30\nKPX Yacute Odieresis -30\nKPX Yacute Ograve -30\nKPX Yacute Ohungarumlaut -30\nKPX Yacute Omacron -30\nKPX Yacute Oslash -30\nKPX Yacute Otilde -30\nKPX Yacute a -100\nKPX Yacute aacute -100\nKPX Yacute abreve -100\nKPX Yacute acircumflex -100\nKPX Yacute adieresis -60\nKPX Yacute agrave -60\nKPX Yacute amacron -60\nKPX Yacute aogonek -100\nKPX Yacute aring -100\nKPX Yacute atilde -60\nKPX Yacute colon -92\nKPX Yacute comma -129\nKPX Yacute e -100\nKPX Yacute eacute -100\nKPX Yacute ecaron -100\nKPX Yacute ecircumflex -100\nKPX Yacute edieresis -60\nKPX Yacute edotaccent -100\nKPX Yacute egrave -60\nKPX Yacute emacron -60\nKPX Yacute eogonek -100\nKPX Yacute hyphen -111\nKPX Yacute i -55\nKPX Yacute iacute -55\nKPX Yacute iogonek -55\nKPX Yacute o -110\nKPX Yacute oacute -110\nKPX Yacute ocircumflex -110\nKPX Yacute odieresis -70\nKPX Yacute ograve -70\nKPX Yacute ohungarumlaut -110\nKPX Yacute omacron -70\nKPX Yacute oslash -110\nKPX Yacute otilde -70\nKPX Yacute period -129\nKPX Yacute semicolon -92\nKPX Yacute u -111\nKPX Yacute uacute -111\nKPX Yacute ucircumflex -111\nKPX Yacute udieresis -71\nKPX Yacute ugrave -71\nKPX Yacute uhungarumlaut -111\nKPX Yacute umacron -71\nKPX Yacute uogonek -111\nKPX Yacute uring -111\nKPX Ydieresis A -120\nKPX Ydieresis Aacute -120\nKPX Ydieresis Abreve -120\nKPX Ydieresis Acircumflex -120\nKPX Ydieresis Adieresis -120\nKPX Ydieresis Agrave -120\nKPX Ydieresis Amacron -120\nKPX Ydieresis Aogonek -120\nKPX Ydieresis Aring -120\nKPX Ydieresis Atilde -120\nKPX Ydieresis O -30\nKPX Ydieresis Oacute -30\nKPX Ydieresis Ocircumflex -30\nKPX Ydieresis Odieresis -30\nKPX Ydieresis Ograve -30\nKPX Ydieresis Ohungarumlaut -30\nKPX Ydieresis Omacron -30\nKPX Ydieresis Oslash -30\nKPX Ydieresis Otilde -30\nKPX Ydieresis a -100\nKPX Ydieresis aacute -100\nKPX Ydieresis abreve -100\nKPX Ydieresis acircumflex -100\nKPX Ydieresis adieresis -60\nKPX Ydieresis agrave -60\nKPX Ydieresis amacron -60\nKPX Ydieresis aogonek -100\nKPX Ydieresis aring -100\nKPX Ydieresis atilde -100\nKPX Ydieresis colon -92\nKPX Ydieresis comma -129\nKPX Ydieresis e -100\nKPX Ydieresis eacute -100\nKPX Ydieresis ecaron -100\nKPX Ydieresis ecircumflex -100\nKPX Ydieresis edieresis -60\nKPX Ydieresis edotaccent -100\nKPX Ydieresis egrave -60\nKPX Ydieresis emacron -60\nKPX Ydieresis eogonek -100\nKPX Ydieresis hyphen -111\nKPX Ydieresis i -55\nKPX Ydieresis iacute -55\nKPX Ydieresis iogonek -55\nKPX Ydieresis o -110\nKPX Ydieresis oacute -110\nKPX Ydieresis ocircumflex -110\nKPX Ydieresis odieresis -70\nKPX Ydieresis ograve -70\nKPX Ydieresis ohungarumlaut -110\nKPX Ydieresis omacron -70\nKPX Ydieresis oslash -110\nKPX Ydieresis otilde -70\nKPX Ydieresis period -129\nKPX Ydieresis semicolon -92\nKPX Ydieresis u -111\nKPX Ydieresis uacute -111\nKPX Ydieresis ucircumflex -111\nKPX Ydieresis udieresis -71\nKPX Ydieresis ugrave -71\nKPX Ydieresis uhungarumlaut -111\nKPX Ydieresis umacron -71\nKPX Ydieresis uogonek -111\nKPX Ydieresis uring -111\nKPX a v -20\nKPX a w -15\nKPX aacute v -20\nKPX aacute w -15\nKPX abreve v -20\nKPX abreve w -15\nKPX acircumflex v -20\nKPX acircumflex w -15\nKPX adieresis v -20\nKPX adieresis w -15\nKPX agrave v -20\nKPX agrave w -15\nKPX amacron v -20\nKPX amacron w -15\nKPX aogonek v -20\nKPX aogonek w -15\nKPX aring v -20\nKPX aring w -15\nKPX atilde v -20\nKPX atilde w -15\nKPX b period -40\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX b v -15\nKPX c y -15\nKPX c yacute -15\nKPX c ydieresis -15\nKPX cacute y -15\nKPX cacute yacute -15\nKPX cacute ydieresis -15\nKPX ccaron y -15\nKPX ccaron yacute -15\nKPX ccaron ydieresis -15\nKPX ccedilla y -15\nKPX ccedilla yacute -15\nKPX ccedilla ydieresis -15\nKPX comma quotedblright -70\nKPX comma quoteright -70\nKPX e g -15\nKPX e gbreve -15\nKPX e gcommaaccent -15\nKPX e v -25\nKPX e w -25\nKPX e x -15\nKPX e y -15\nKPX e yacute -15\nKPX e ydieresis -15\nKPX eacute g -15\nKPX eacute gbreve -15\nKPX eacute gcommaaccent -15\nKPX eacute v -25\nKPX eacute w -25\nKPX eacute x -15\nKPX eacute y -15\nKPX eacute yacute -15\nKPX eacute ydieresis -15\nKPX ecaron g -15\nKPX ecaron gbreve -15\nKPX ecaron gcommaaccent -15\nKPX ecaron v -25\nKPX ecaron w -25\nKPX ecaron x -15\nKPX ecaron y -15\nKPX ecaron yacute -15\nKPX ecaron ydieresis -15\nKPX ecircumflex g -15\nKPX ecircumflex gbreve -15\nKPX ecircumflex gcommaaccent -15\nKPX ecircumflex v -25\nKPX ecircumflex w -25\nKPX ecircumflex x -15\nKPX ecircumflex y -15\nKPX ecircumflex yacute -15\nKPX ecircumflex ydieresis -15\nKPX edieresis g -15\nKPX edieresis gbreve -15\nKPX edieresis gcommaaccent -15\nKPX edieresis v -25\nKPX edieresis w -25\nKPX edieresis x -15\nKPX edieresis y -15\nKPX edieresis yacute -15\nKPX edieresis ydieresis -15\nKPX edotaccent g -15\nKPX edotaccent gbreve -15\nKPX edotaccent gcommaaccent -15\nKPX edotaccent v -25\nKPX edotaccent w -25\nKPX edotaccent x -15\nKPX edotaccent y -15\nKPX edotaccent yacute -15\nKPX edotaccent ydieresis -15\nKPX egrave g -15\nKPX egrave gbreve -15\nKPX egrave gcommaaccent -15\nKPX egrave v -25\nKPX egrave w -25\nKPX egrave x -15\nKPX egrave y -15\nKPX egrave yacute -15\nKPX egrave ydieresis -15\nKPX emacron g -15\nKPX emacron gbreve -15\nKPX emacron gcommaaccent -15\nKPX emacron v -25\nKPX emacron w -25\nKPX emacron x -15\nKPX emacron y -15\nKPX emacron yacute -15\nKPX emacron ydieresis -15\nKPX eogonek g -15\nKPX eogonek gbreve -15\nKPX eogonek gcommaaccent -15\nKPX eogonek v -25\nKPX eogonek w -25\nKPX eogonek x -15\nKPX eogonek y -15\nKPX eogonek yacute -15\nKPX eogonek ydieresis -15\nKPX f a -10\nKPX f aacute -10\nKPX f abreve -10\nKPX f acircumflex -10\nKPX f adieresis -10\nKPX f agrave -10\nKPX f amacron -10\nKPX f aogonek -10\nKPX f aring -10\nKPX f atilde -10\nKPX f dotlessi -50\nKPX f f -25\nKPX f i -20\nKPX f iacute -20\nKPX f quoteright 55\nKPX g a -5\nKPX g aacute -5\nKPX g abreve -5\nKPX g acircumflex -5\nKPX g adieresis -5\nKPX g agrave -5\nKPX g amacron -5\nKPX g aogonek -5\nKPX g aring -5\nKPX g atilde -5\nKPX gbreve a -5\nKPX gbreve aacute -5\nKPX gbreve abreve -5\nKPX gbreve acircumflex -5\nKPX gbreve adieresis -5\nKPX gbreve agrave -5\nKPX gbreve amacron -5\nKPX gbreve aogonek -5\nKPX gbreve aring -5\nKPX gbreve atilde -5\nKPX gcommaaccent a -5\nKPX gcommaaccent aacute -5\nKPX gcommaaccent abreve -5\nKPX gcommaaccent acircumflex -5\nKPX gcommaaccent adieresis -5\nKPX gcommaaccent agrave -5\nKPX gcommaaccent amacron -5\nKPX gcommaaccent aogonek -5\nKPX gcommaaccent aring -5\nKPX gcommaaccent atilde -5\nKPX h y -5\nKPX h yacute -5\nKPX h ydieresis -5\nKPX i v -25\nKPX iacute v -25\nKPX icircumflex v -25\nKPX idieresis v -25\nKPX igrave v -25\nKPX imacron v -25\nKPX iogonek v -25\nKPX k e -10\nKPX k eacute -10\nKPX k ecaron -10\nKPX k ecircumflex -10\nKPX k edieresis -10\nKPX k edotaccent -10\nKPX k egrave -10\nKPX k emacron -10\nKPX k eogonek -10\nKPX k o -10\nKPX k oacute -10\nKPX k ocircumflex -10\nKPX k odieresis -10\nKPX k ograve -10\nKPX k ohungarumlaut -10\nKPX k omacron -10\nKPX k oslash -10\nKPX k otilde -10\nKPX k y -15\nKPX k yacute -15\nKPX k ydieresis -15\nKPX kcommaaccent e -10\nKPX kcommaaccent eacute -10\nKPX kcommaaccent ecaron -10\nKPX kcommaaccent ecircumflex -10\nKPX kcommaaccent edieresis -10\nKPX kcommaaccent edotaccent -10\nKPX kcommaaccent egrave -10\nKPX kcommaaccent emacron -10\nKPX kcommaaccent eogonek -10\nKPX kcommaaccent o -10\nKPX kcommaaccent oacute -10\nKPX kcommaaccent ocircumflex -10\nKPX kcommaaccent odieresis -10\nKPX kcommaaccent ograve -10\nKPX kcommaaccent ohungarumlaut -10\nKPX kcommaaccent omacron -10\nKPX kcommaaccent oslash -10\nKPX kcommaaccent otilde -10\nKPX kcommaaccent y -15\nKPX kcommaaccent yacute -15\nKPX kcommaaccent ydieresis -15\nKPX l w -10\nKPX lacute w -10\nKPX lcommaaccent w -10\nKPX lslash w -10\nKPX n v -40\nKPX n y -15\nKPX n yacute -15\nKPX n ydieresis -15\nKPX nacute v -40\nKPX nacute y -15\nKPX nacute yacute -15\nKPX nacute ydieresis -15\nKPX ncaron v -40\nKPX ncaron y -15\nKPX ncaron yacute -15\nKPX ncaron ydieresis -15\nKPX ncommaaccent v -40\nKPX ncommaaccent y -15\nKPX ncommaaccent yacute -15\nKPX ncommaaccent ydieresis -15\nKPX ntilde v -40\nKPX ntilde y -15\nKPX ntilde yacute -15\nKPX ntilde ydieresis -15\nKPX o v -15\nKPX o w -25\nKPX o y -10\nKPX o yacute -10\nKPX o ydieresis -10\nKPX oacute v -15\nKPX oacute w -25\nKPX oacute y -10\nKPX oacute yacute -10\nKPX oacute ydieresis -10\nKPX ocircumflex v -15\nKPX ocircumflex w -25\nKPX ocircumflex y -10\nKPX ocircumflex yacute -10\nKPX ocircumflex ydieresis -10\nKPX odieresis v -15\nKPX odieresis w -25\nKPX odieresis y -10\nKPX odieresis yacute -10\nKPX odieresis ydieresis -10\nKPX ograve v -15\nKPX ograve w -25\nKPX ograve y -10\nKPX ograve yacute -10\nKPX ograve ydieresis -10\nKPX ohungarumlaut v -15\nKPX ohungarumlaut w -25\nKPX ohungarumlaut y -10\nKPX ohungarumlaut yacute -10\nKPX ohungarumlaut ydieresis -10\nKPX omacron v -15\nKPX omacron w -25\nKPX omacron y -10\nKPX omacron yacute -10\nKPX omacron ydieresis -10\nKPX oslash v -15\nKPX oslash w -25\nKPX oslash y -10\nKPX oslash yacute -10\nKPX oslash ydieresis -10\nKPX otilde v -15\nKPX otilde w -25\nKPX otilde y -10\nKPX otilde yacute -10\nKPX otilde ydieresis -10\nKPX p y -10\nKPX p yacute -10\nKPX p ydieresis -10\nKPX period quotedblright -70\nKPX period quoteright -70\nKPX quotedblleft A -80\nKPX quotedblleft Aacute -80\nKPX quotedblleft Abreve -80\nKPX quotedblleft Acircumflex -80\nKPX quotedblleft Adieresis -80\nKPX quotedblleft Agrave -80\nKPX quotedblleft Amacron -80\nKPX quotedblleft Aogonek -80\nKPX quotedblleft Aring -80\nKPX quotedblleft Atilde -80\nKPX quoteleft A -80\nKPX quoteleft Aacute -80\nKPX quoteleft Abreve -80\nKPX quoteleft Acircumflex -80\nKPX quoteleft Adieresis -80\nKPX quoteleft Agrave -80\nKPX quoteleft Amacron -80\nKPX quoteleft Aogonek -80\nKPX quoteleft Aring -80\nKPX quoteleft Atilde -80\nKPX quoteleft quoteleft -74\nKPX quoteright d -50\nKPX quoteright dcroat -50\nKPX quoteright l -10\nKPX quoteright lacute -10\nKPX quoteright lcommaaccent -10\nKPX quoteright lslash -10\nKPX quoteright quoteright -74\nKPX quoteright r -50\nKPX quoteright racute -50\nKPX quoteright rcaron -50\nKPX quoteright rcommaaccent -50\nKPX quoteright s -55\nKPX quoteright sacute -55\nKPX quoteright scaron -55\nKPX quoteright scedilla -55\nKPX quoteright scommaaccent -55\nKPX quoteright space -74\nKPX quoteright t -18\nKPX quoteright tcommaaccent -18\nKPX quoteright v -50\nKPX r comma -40\nKPX r g -18\nKPX r gbreve -18\nKPX r gcommaaccent -18\nKPX r hyphen -20\nKPX r period -55\nKPX racute comma -40\nKPX racute g -18\nKPX racute gbreve -18\nKPX racute gcommaaccent -18\nKPX racute hyphen -20\nKPX racute period -55\nKPX rcaron comma -40\nKPX rcaron g -18\nKPX rcaron gbreve -18\nKPX rcaron gcommaaccent -18\nKPX rcaron hyphen -20\nKPX rcaron period -55\nKPX rcommaaccent comma -40\nKPX rcommaaccent g -18\nKPX rcommaaccent gbreve -18\nKPX rcommaaccent gcommaaccent -18\nKPX rcommaaccent hyphen -20\nKPX rcommaaccent period -55\nKPX space A -55\nKPX space Aacute -55\nKPX space Abreve -55\nKPX space Acircumflex -55\nKPX space Adieresis -55\nKPX space Agrave -55\nKPX space Amacron -55\nKPX space Aogonek -55\nKPX space Aring -55\nKPX space Atilde -55\nKPX space T -18\nKPX space Tcaron -18\nKPX space Tcommaaccent -18\nKPX space V -50\nKPX space W -30\nKPX space Y -90\nKPX space Yacute -90\nKPX space Ydieresis -90\nKPX v a -25\nKPX v aacute -25\nKPX v abreve -25\nKPX v acircumflex -25\nKPX v adieresis -25\nKPX v agrave -25\nKPX v amacron -25\nKPX v aogonek -25\nKPX v aring -25\nKPX v atilde -25\nKPX v comma -65\nKPX v e -15\nKPX v eacute -15\nKPX v ecaron -15\nKPX v ecircumflex -15\nKPX v edieresis -15\nKPX v edotaccent -15\nKPX v egrave -15\nKPX v emacron -15\nKPX v eogonek -15\nKPX v o -20\nKPX v oacute -20\nKPX v ocircumflex -20\nKPX v odieresis -20\nKPX v ograve -20\nKPX v ohungarumlaut -20\nKPX v omacron -20\nKPX v oslash -20\nKPX v otilde -20\nKPX v period -65\nKPX w a -10\nKPX w aacute -10\nKPX w abreve -10\nKPX w acircumflex -10\nKPX w adieresis -10\nKPX w agrave -10\nKPX w amacron -10\nKPX w aogonek -10\nKPX w aring -10\nKPX w atilde -10\nKPX w comma -65\nKPX w o -10\nKPX w oacute -10\nKPX w ocircumflex -10\nKPX w odieresis -10\nKPX w ograve -10\nKPX w ohungarumlaut -10\nKPX w omacron -10\nKPX w oslash -10\nKPX w otilde -10\nKPX w period -65\nKPX x e -15\nKPX x eacute -15\nKPX x ecaron -15\nKPX x ecircumflex -15\nKPX x edieresis -15\nKPX x edotaccent -15\nKPX x egrave -15\nKPX x emacron -15\nKPX x eogonek -15\nKPX y comma -65\nKPX y period -65\nKPX yacute comma -65\nKPX yacute period -65\nKPX ydieresis comma -65\nKPX ydieresis period -65\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    'Times-Bold' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 12:52:56 1997\nComment UniqueID 43065\nComment VMusage 41636 52661\nFontName Times-Bold\nFullName Times Bold\nFamilyName Times\nWeight Bold\nItalicAngle 0\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -168 -218 1000 935 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 676\nXHeight 461\nAscender 683\nDescender -217\nStdHW 44\nStdVW 139\nStartCharMetrics 315\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 333 ; N exclam ; B 81 -13 251 691 ;\nC 34 ; WX 555 ; N quotedbl ; B 83 404 472 691 ;\nC 35 ; WX 500 ; N numbersign ; B 4 0 496 700 ;\nC 36 ; WX 500 ; N dollar ; B 29 -99 472 750 ;\nC 37 ; WX 1000 ; N percent ; B 124 -14 877 692 ;\nC 38 ; WX 833 ; N ampersand ; B 62 -16 787 691 ;\nC 39 ; WX 333 ; N quoteright ; B 79 356 263 691 ;\nC 40 ; WX 333 ; N parenleft ; B 46 -168 306 694 ;\nC 41 ; WX 333 ; N parenright ; B 27 -168 287 694 ;\nC 42 ; WX 500 ; N asterisk ; B 56 255 447 691 ;\nC 43 ; WX 570 ; N plus ; B 33 0 537 506 ;\nC 44 ; WX 250 ; N comma ; B 39 -180 223 155 ;\nC 45 ; WX 333 ; N hyphen ; B 44 171 287 287 ;\nC 46 ; WX 250 ; N period ; B 41 -13 210 156 ;\nC 47 ; WX 278 ; N slash ; B -24 -19 302 691 ;\nC 48 ; WX 500 ; N zero ; B 24 -13 476 688 ;\nC 49 ; WX 500 ; N one ; B 65 0 442 688 ;\nC 50 ; WX 500 ; N two ; B 17 0 478 688 ;\nC 51 ; WX 500 ; N three ; B 16 -14 468 688 ;\nC 52 ; WX 500 ; N four ; B 19 0 475 688 ;\nC 53 ; WX 500 ; N five ; B 22 -8 470 676 ;\nC 54 ; WX 500 ; N six ; B 28 -13 475 688 ;\nC 55 ; WX 500 ; N seven ; B 17 0 477 676 ;\nC 56 ; WX 500 ; N eight ; B 28 -13 472 688 ;\nC 57 ; WX 500 ; N nine ; B 26 -13 473 688 ;\nC 58 ; WX 333 ; N colon ; B 82 -13 251 472 ;\nC 59 ; WX 333 ; N semicolon ; B 82 -180 266 472 ;\nC 60 ; WX 570 ; N less ; B 31 -8 539 514 ;\nC 61 ; WX 570 ; N equal ; B 33 107 537 399 ;\nC 62 ; WX 570 ; N greater ; B 31 -8 539 514 ;\nC 63 ; WX 500 ; N question ; B 57 -13 445 689 ;\nC 64 ; WX 930 ; N at ; B 108 -19 822 691 ;\nC 65 ; WX 722 ; N A ; B 9 0 689 690 ;\nC 66 ; WX 667 ; N B ; B 16 0 619 676 ;\nC 67 ; WX 722 ; N C ; B 49 -19 687 691 ;\nC 68 ; WX 722 ; N D ; B 14 0 690 676 ;\nC 69 ; WX 667 ; N E ; B 16 0 641 676 ;\nC 70 ; WX 611 ; N F ; B 16 0 583 676 ;\nC 71 ; WX 778 ; N G ; B 37 -19 755 691 ;\nC 72 ; WX 778 ; N H ; B 21 0 759 676 ;\nC 73 ; WX 389 ; N I ; B 20 0 370 676 ;\nC 74 ; WX 500 ; N J ; B 3 -96 479 676 ;\nC 75 ; WX 778 ; N K ; B 30 0 769 676 ;\nC 76 ; WX 667 ; N L ; B 19 0 638 676 ;\nC 77 ; WX 944 ; N M ; B 14 0 921 676 ;\nC 78 ; WX 722 ; N N ; B 16 -18 701 676 ;\nC 79 ; WX 778 ; N O ; B 35 -19 743 691 ;\nC 80 ; WX 611 ; N P ; B 16 0 600 676 ;\nC 81 ; WX 778 ; N Q ; B 35 -176 743 691 ;\nC 82 ; WX 722 ; N R ; B 26 0 715 676 ;\nC 83 ; WX 556 ; N S ; B 35 -19 513 692 ;\nC 84 ; WX 667 ; N T ; B 31 0 636 676 ;\nC 85 ; WX 722 ; N U ; B 16 -19 701 676 ;\nC 86 ; WX 722 ; N V ; B 16 -18 701 676 ;\nC 87 ; WX 1000 ; N W ; B 19 -15 981 676 ;\nC 88 ; WX 722 ; N X ; B 16 0 699 676 ;\nC 89 ; WX 722 ; N Y ; B 15 0 699 676 ;\nC 90 ; WX 667 ; N Z ; B 28 0 634 676 ;\nC 91 ; WX 333 ; N bracketleft ; B 67 -149 301 678 ;\nC 92 ; WX 278 ; N backslash ; B -25 -19 303 691 ;\nC 93 ; WX 333 ; N bracketright ; B 32 -149 266 678 ;\nC 94 ; WX 581 ; N asciicircum ; B 73 311 509 676 ;\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\nC 96 ; WX 333 ; N quoteleft ; B 70 356 254 691 ;\nC 97 ; WX 500 ; N a ; B 25 -14 488 473 ;\nC 98 ; WX 556 ; N b ; B 17 -14 521 676 ;\nC 99 ; WX 444 ; N c ; B 25 -14 430 473 ;\nC 100 ; WX 556 ; N d ; B 25 -14 534 676 ;\nC 101 ; WX 444 ; N e ; B 25 -14 426 473 ;\nC 102 ; WX 333 ; N f ; B 14 0 389 691 ; L i fi ; L l fl ;\nC 103 ; WX 500 ; N g ; B 28 -206 483 473 ;\nC 104 ; WX 556 ; N h ; B 16 0 534 676 ;\nC 105 ; WX 278 ; N i ; B 16 0 255 691 ;\nC 106 ; WX 333 ; N j ; B -57 -203 263 691 ;\nC 107 ; WX 556 ; N k ; B 22 0 543 676 ;\nC 108 ; WX 278 ; N l ; B 16 0 255 676 ;\nC 109 ; WX 833 ; N m ; B 16 0 814 473 ;\nC 110 ; WX 556 ; N n ; B 21 0 539 473 ;\nC 111 ; WX 500 ; N o ; B 25 -14 476 473 ;\nC 112 ; WX 556 ; N p ; B 19 -205 524 473 ;\nC 113 ; WX 556 ; N q ; B 34 -205 536 473 ;\nC 114 ; WX 444 ; N r ; B 29 0 434 473 ;\nC 115 ; WX 389 ; N s ; B 25 -14 361 473 ;\nC 116 ; WX 333 ; N t ; B 20 -12 332 630 ;\nC 117 ; WX 556 ; N u ; B 16 -14 537 461 ;\nC 118 ; WX 500 ; N v ; B 21 -14 485 461 ;\nC 119 ; WX 722 ; N w ; B 23 -14 707 461 ;\nC 120 ; WX 500 ; N x ; B 12 0 484 461 ;\nC 121 ; WX 500 ; N y ; B 16 -205 480 461 ;\nC 122 ; WX 444 ; N z ; B 21 0 420 461 ;\nC 123 ; WX 394 ; N braceleft ; B 22 -175 340 698 ;\nC 124 ; WX 220 ; N bar ; B 66 -218 154 782 ;\nC 125 ; WX 394 ; N braceright ; B 54 -175 372 698 ;\nC 126 ; WX 520 ; N asciitilde ; B 29 173 491 333 ;\nC 161 ; WX 333 ; N exclamdown ; B 82 -203 252 501 ;\nC 162 ; WX 500 ; N cent ; B 53 -140 458 588 ;\nC 163 ; WX 500 ; N sterling ; B 21 -14 477 684 ;\nC 164 ; WX 167 ; N fraction ; B -168 -12 329 688 ;\nC 165 ; WX 500 ; N yen ; B -64 0 547 676 ;\nC 166 ; WX 500 ; N florin ; B 0 -155 498 706 ;\nC 167 ; WX 500 ; N section ; B 57 -132 443 691 ;\nC 168 ; WX 500 ; N currency ; B -26 61 526 613 ;\nC 169 ; WX 278 ; N quotesingle ; B 75 404 204 691 ;\nC 170 ; WX 500 ; N quotedblleft ; B 32 356 486 691 ;\nC 171 ; WX 500 ; N guillemotleft ; B 23 36 473 415 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 51 36 305 415 ;\nC 173 ; WX 333 ; N guilsinglright ; B 28 36 282 415 ;\nC 174 ; WX 556 ; N fi ; B 14 0 536 691 ;\nC 175 ; WX 556 ; N fl ; B 14 0 536 691 ;\nC 177 ; WX 500 ; N endash ; B 0 181 500 271 ;\nC 178 ; WX 500 ; N dagger ; B 47 -134 453 691 ;\nC 179 ; WX 500 ; N daggerdbl ; B 45 -132 456 691 ;\nC 180 ; WX 250 ; N periodcentered ; B 41 248 210 417 ;\nC 182 ; WX 540 ; N paragraph ; B 0 -186 519 676 ;\nC 183 ; WX 350 ; N bullet ; B 35 198 315 478 ;\nC 184 ; WX 333 ; N quotesinglbase ; B 79 -180 263 155 ;\nC 185 ; WX 500 ; N quotedblbase ; B 14 -180 468 155 ;\nC 186 ; WX 500 ; N quotedblright ; B 14 356 468 691 ;\nC 187 ; WX 500 ; N guillemotright ; B 27 36 477 415 ;\nC 188 ; WX 1000 ; N ellipsis ; B 82 -13 917 156 ;\nC 189 ; WX 1000 ; N perthousand ; B 7 -29 995 706 ;\nC 191 ; WX 500 ; N questiondown ; B 55 -201 443 501 ;\nC 193 ; WX 333 ; N grave ; B 8 528 246 713 ;\nC 194 ; WX 333 ; N acute ; B 86 528 324 713 ;\nC 195 ; WX 333 ; N circumflex ; B -2 528 335 704 ;\nC 196 ; WX 333 ; N tilde ; B -16 547 349 674 ;\nC 197 ; WX 333 ; N macron ; B 1 565 331 637 ;\nC 198 ; WX 333 ; N breve ; B 15 528 318 691 ;\nC 199 ; WX 333 ; N dotaccent ; B 103 536 258 691 ;\nC 200 ; WX 333 ; N dieresis ; B -2 537 335 667 ;\nC 202 ; WX 333 ; N ring ; B 60 527 273 740 ;\nC 203 ; WX 333 ; N cedilla ; B 68 -218 294 0 ;\nC 205 ; WX 333 ; N hungarumlaut ; B -13 528 425 713 ;\nC 206 ; WX 333 ; N ogonek ; B 90 -193 319 24 ;\nC 207 ; WX 333 ; N caron ; B -2 528 335 704 ;\nC 208 ; WX 1000 ; N emdash ; B 0 181 1000 271 ;\nC 225 ; WX 1000 ; N AE ; B 4 0 951 676 ;\nC 227 ; WX 300 ; N ordfeminine ; B -1 397 301 688 ;\nC 232 ; WX 667 ; N Lslash ; B 19 0 638 676 ;\nC 233 ; WX 778 ; N Oslash ; B 35 -74 743 737 ;\nC 234 ; WX 1000 ; N OE ; B 22 -5 981 684 ;\nC 235 ; WX 330 ; N ordmasculine ; B 18 397 312 688 ;\nC 241 ; WX 722 ; N ae ; B 33 -14 693 473 ;\nC 245 ; WX 278 ; N dotlessi ; B 16 0 255 461 ;\nC 248 ; WX 278 ; N lslash ; B -22 0 303 676 ;\nC 249 ; WX 500 ; N oslash ; B 25 -92 476 549 ;\nC 250 ; WX 722 ; N oe ; B 22 -14 696 473 ;\nC 251 ; WX 556 ; N germandbls ; B 19 -12 517 691 ;\nC -1 ; WX 389 ; N Idieresis ; B 20 0 370 877 ;\nC -1 ; WX 444 ; N eacute ; B 25 -14 426 713 ;\nC -1 ; WX 500 ; N abreve ; B 25 -14 488 691 ;\nC -1 ; WX 556 ; N uhungarumlaut ; B 16 -14 557 713 ;\nC -1 ; WX 444 ; N ecaron ; B 25 -14 426 704 ;\nC -1 ; WX 722 ; N Ydieresis ; B 15 0 699 877 ;\nC -1 ; WX 570 ; N divide ; B 33 -31 537 537 ;\nC -1 ; WX 722 ; N Yacute ; B 15 0 699 923 ;\nC -1 ; WX 722 ; N Acircumflex ; B 9 0 689 914 ;\nC -1 ; WX 500 ; N aacute ; B 25 -14 488 713 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 16 -19 701 914 ;\nC -1 ; WX 500 ; N yacute ; B 16 -205 480 713 ;\nC -1 ; WX 389 ; N scommaaccent ; B 25 -218 361 473 ;\nC -1 ; WX 444 ; N ecircumflex ; B 25 -14 426 704 ;\nC -1 ; WX 722 ; N Uring ; B 16 -19 701 935 ;\nC -1 ; WX 722 ; N Udieresis ; B 16 -19 701 877 ;\nC -1 ; WX 500 ; N aogonek ; B 25 -193 504 473 ;\nC -1 ; WX 722 ; N Uacute ; B 16 -19 701 923 ;\nC -1 ; WX 556 ; N uogonek ; B 16 -193 539 461 ;\nC -1 ; WX 667 ; N Edieresis ; B 16 0 641 877 ;\nC -1 ; WX 722 ; N Dcroat ; B 6 0 690 676 ;\nC -1 ; WX 250 ; N commaaccent ; B 47 -218 203 -50 ;\nC -1 ; WX 747 ; N copyright ; B 26 -19 721 691 ;\nC -1 ; WX 667 ; N Emacron ; B 16 0 641 847 ;\nC -1 ; WX 444 ; N ccaron ; B 25 -14 430 704 ;\nC -1 ; WX 500 ; N aring ; B 25 -14 488 740 ;\nC -1 ; WX 722 ; N Ncommaaccent ; B 16 -188 701 676 ;\nC -1 ; WX 278 ; N lacute ; B 16 0 297 923 ;\nC -1 ; WX 500 ; N agrave ; B 25 -14 488 713 ;\nC -1 ; WX 667 ; N Tcommaaccent ; B 31 -218 636 676 ;\nC -1 ; WX 722 ; N Cacute ; B 49 -19 687 923 ;\nC -1 ; WX 500 ; N atilde ; B 25 -14 488 674 ;\nC -1 ; WX 667 ; N Edotaccent ; B 16 0 641 901 ;\nC -1 ; WX 389 ; N scaron ; B 25 -14 363 704 ;\nC -1 ; WX 389 ; N scedilla ; B 25 -218 361 473 ;\nC -1 ; WX 278 ; N iacute ; B 16 0 289 713 ;\nC -1 ; WX 494 ; N lozenge ; B 10 0 484 745 ;\nC -1 ; WX 722 ; N Rcaron ; B 26 0 715 914 ;\nC -1 ; WX 778 ; N Gcommaaccent ; B 37 -218 755 691 ;\nC -1 ; WX 556 ; N ucircumflex ; B 16 -14 537 704 ;\nC -1 ; WX 500 ; N acircumflex ; B 25 -14 488 704 ;\nC -1 ; WX 722 ; N Amacron ; B 9 0 689 847 ;\nC -1 ; WX 444 ; N rcaron ; B 29 0 434 704 ;\nC -1 ; WX 444 ; N ccedilla ; B 25 -218 430 473 ;\nC -1 ; WX 667 ; N Zdotaccent ; B 28 0 634 901 ;\nC -1 ; WX 611 ; N Thorn ; B 16 0 600 676 ;\nC -1 ; WX 778 ; N Omacron ; B 35 -19 743 847 ;\nC -1 ; WX 722 ; N Racute ; B 26 0 715 923 ;\nC -1 ; WX 556 ; N Sacute ; B 35 -19 513 923 ;\nC -1 ; WX 672 ; N dcaron ; B 25 -14 681 682 ;\nC -1 ; WX 722 ; N Umacron ; B 16 -19 701 847 ;\nC -1 ; WX 556 ; N uring ; B 16 -14 537 740 ;\nC -1 ; WX 300 ; N threesuperior ; B 3 268 297 688 ;\nC -1 ; WX 778 ; N Ograve ; B 35 -19 743 923 ;\nC -1 ; WX 722 ; N Agrave ; B 9 0 689 923 ;\nC -1 ; WX 722 ; N Abreve ; B 9 0 689 901 ;\nC -1 ; WX 570 ; N multiply ; B 48 16 522 490 ;\nC -1 ; WX 556 ; N uacute ; B 16 -14 537 713 ;\nC -1 ; WX 667 ; N Tcaron ; B 31 0 636 914 ;\nC -1 ; WX 494 ; N partialdiff ; B 11 -21 494 750 ;\nC -1 ; WX 500 ; N ydieresis ; B 16 -205 480 667 ;\nC -1 ; WX 722 ; N Nacute ; B 16 -18 701 923 ;\nC -1 ; WX 278 ; N icircumflex ; B -37 0 300 704 ;\nC -1 ; WX 667 ; N Ecircumflex ; B 16 0 641 914 ;\nC -1 ; WX 500 ; N adieresis ; B 25 -14 488 667 ;\nC -1 ; WX 444 ; N edieresis ; B 25 -14 426 667 ;\nC -1 ; WX 444 ; N cacute ; B 25 -14 430 713 ;\nC -1 ; WX 556 ; N nacute ; B 21 0 539 713 ;\nC -1 ; WX 556 ; N umacron ; B 16 -14 537 637 ;\nC -1 ; WX 722 ; N Ncaron ; B 16 -18 701 914 ;\nC -1 ; WX 389 ; N Iacute ; B 20 0 370 923 ;\nC -1 ; WX 570 ; N plusminus ; B 33 0 537 506 ;\nC -1 ; WX 220 ; N brokenbar ; B 66 -143 154 707 ;\nC -1 ; WX 747 ; N registered ; B 26 -19 721 691 ;\nC -1 ; WX 778 ; N Gbreve ; B 37 -19 755 901 ;\nC -1 ; WX 389 ; N Idotaccent ; B 20 0 370 901 ;\nC -1 ; WX 600 ; N summation ; B 14 -10 585 706 ;\nC -1 ; WX 667 ; N Egrave ; B 16 0 641 923 ;\nC -1 ; WX 444 ; N racute ; B 29 0 434 713 ;\nC -1 ; WX 500 ; N omacron ; B 25 -14 476 637 ;\nC -1 ; WX 667 ; N Zacute ; B 28 0 634 923 ;\nC -1 ; WX 667 ; N Zcaron ; B 28 0 634 914 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 704 ;\nC -1 ; WX 722 ; N Eth ; B 6 0 690 676 ;\nC -1 ; WX 722 ; N Ccedilla ; B 49 -218 687 691 ;\nC -1 ; WX 278 ; N lcommaaccent ; B 16 -218 255 676 ;\nC -1 ; WX 416 ; N tcaron ; B 20 -12 425 815 ;\nC -1 ; WX 444 ; N eogonek ; B 25 -193 426 473 ;\nC -1 ; WX 722 ; N Uogonek ; B 16 -193 701 676 ;\nC -1 ; WX 722 ; N Aacute ; B 9 0 689 923 ;\nC -1 ; WX 722 ; N Adieresis ; B 9 0 689 877 ;\nC -1 ; WX 444 ; N egrave ; B 25 -14 426 713 ;\nC -1 ; WX 444 ; N zacute ; B 21 0 420 713 ;\nC -1 ; WX 278 ; N iogonek ; B 16 -193 274 691 ;\nC -1 ; WX 778 ; N Oacute ; B 35 -19 743 923 ;\nC -1 ; WX 500 ; N oacute ; B 25 -14 476 713 ;\nC -1 ; WX 500 ; N amacron ; B 25 -14 488 637 ;\nC -1 ; WX 389 ; N sacute ; B 25 -14 361 713 ;\nC -1 ; WX 278 ; N idieresis ; B -37 0 300 667 ;\nC -1 ; WX 778 ; N Ocircumflex ; B 35 -19 743 914 ;\nC -1 ; WX 722 ; N Ugrave ; B 16 -19 701 923 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 556 ; N thorn ; B 19 -205 524 676 ;\nC -1 ; WX 300 ; N twosuperior ; B 0 275 300 688 ;\nC -1 ; WX 778 ; N Odieresis ; B 35 -19 743 877 ;\nC -1 ; WX 556 ; N mu ; B 33 -206 536 461 ;\nC -1 ; WX 278 ; N igrave ; B -27 0 255 713 ;\nC -1 ; WX 500 ; N ohungarumlaut ; B 25 -14 529 713 ;\nC -1 ; WX 667 ; N Eogonek ; B 16 -193 644 676 ;\nC -1 ; WX 556 ; N dcroat ; B 25 -14 534 676 ;\nC -1 ; WX 750 ; N threequarters ; B 23 -12 733 688 ;\nC -1 ; WX 556 ; N Scedilla ; B 35 -218 513 692 ;\nC -1 ; WX 394 ; N lcaron ; B 16 0 412 682 ;\nC -1 ; WX 778 ; N Kcommaaccent ; B 30 -218 769 676 ;\nC -1 ; WX 667 ; N Lacute ; B 19 0 638 923 ;\nC -1 ; WX 1000 ; N trademark ; B 24 271 977 676 ;\nC -1 ; WX 444 ; N edotaccent ; B 25 -14 426 691 ;\nC -1 ; WX 389 ; N Igrave ; B 20 0 370 923 ;\nC -1 ; WX 389 ; N Imacron ; B 20 0 370 847 ;\nC -1 ; WX 667 ; N Lcaron ; B 19 0 652 682 ;\nC -1 ; WX 750 ; N onehalf ; B -7 -12 775 688 ;\nC -1 ; WX 549 ; N lessequal ; B 29 0 526 704 ;\nC -1 ; WX 500 ; N ocircumflex ; B 25 -14 476 704 ;\nC -1 ; WX 556 ; N ntilde ; B 21 0 539 674 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 16 -19 701 923 ;\nC -1 ; WX 667 ; N Eacute ; B 16 0 641 923 ;\nC -1 ; WX 444 ; N emacron ; B 25 -14 426 637 ;\nC -1 ; WX 500 ; N gbreve ; B 28 -206 483 691 ;\nC -1 ; WX 750 ; N onequarter ; B 28 -12 743 688 ;\nC -1 ; WX 556 ; N Scaron ; B 35 -19 513 914 ;\nC -1 ; WX 556 ; N Scommaaccent ; B 35 -218 513 692 ;\nC -1 ; WX 778 ; N Ohungarumlaut ; B 35 -19 743 923 ;\nC -1 ; WX 400 ; N degree ; B 57 402 343 688 ;\nC -1 ; WX 500 ; N ograve ; B 25 -14 476 713 ;\nC -1 ; WX 722 ; N Ccaron ; B 49 -19 687 914 ;\nC -1 ; WX 556 ; N ugrave ; B 16 -14 537 713 ;\nC -1 ; WX 549 ; N radical ; B 10 -46 512 850 ;\nC -1 ; WX 722 ; N Dcaron ; B 14 0 690 914 ;\nC -1 ; WX 444 ; N rcommaaccent ; B 29 -218 434 473 ;\nC -1 ; WX 722 ; N Ntilde ; B 16 -18 701 884 ;\nC -1 ; WX 500 ; N otilde ; B 25 -14 476 674 ;\nC -1 ; WX 722 ; N Rcommaaccent ; B 26 -218 715 676 ;\nC -1 ; WX 667 ; N Lcommaaccent ; B 19 -218 638 676 ;\nC -1 ; WX 722 ; N Atilde ; B 9 0 689 884 ;\nC -1 ; WX 722 ; N Aogonek ; B 9 -193 699 690 ;\nC -1 ; WX 722 ; N Aring ; B 9 0 689 935 ;\nC -1 ; WX 778 ; N Otilde ; B 35 -19 743 884 ;\nC -1 ; WX 444 ; N zdotaccent ; B 21 0 420 691 ;\nC -1 ; WX 667 ; N Ecaron ; B 16 0 641 914 ;\nC -1 ; WX 389 ; N Iogonek ; B 20 -193 370 676 ;\nC -1 ; WX 556 ; N kcommaaccent ; B 22 -218 543 676 ;\nC -1 ; WX 570 ; N minus ; B 33 209 537 297 ;\nC -1 ; WX 389 ; N Icircumflex ; B 20 0 370 914 ;\nC -1 ; WX 556 ; N ncaron ; B 21 0 539 704 ;\nC -1 ; WX 333 ; N tcommaaccent ; B 20 -218 332 630 ;\nC -1 ; WX 570 ; N logicalnot ; B 33 108 537 399 ;\nC -1 ; WX 500 ; N odieresis ; B 25 -14 476 667 ;\nC -1 ; WX 556 ; N udieresis ; B 16 -14 537 667 ;\nC -1 ; WX 549 ; N notequal ; B 15 -49 540 570 ;\nC -1 ; WX 500 ; N gcommaaccent ; B 28 -206 483 829 ;\nC -1 ; WX 500 ; N eth ; B 25 -14 476 691 ;\nC -1 ; WX 444 ; N zcaron ; B 21 0 420 704 ;\nC -1 ; WX 556 ; N ncommaaccent ; B 21 -218 539 473 ;\nC -1 ; WX 300 ; N onesuperior ; B 28 275 273 688 ;\nC -1 ; WX 278 ; N imacron ; B -8 0 272 637 ;\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2242\nKPX A C -55\nKPX A Cacute -55\nKPX A Ccaron -55\nKPX A Ccedilla -55\nKPX A G -55\nKPX A Gbreve -55\nKPX A Gcommaaccent -55\nKPX A O -45\nKPX A Oacute -45\nKPX A Ocircumflex -45\nKPX A Odieresis -45\nKPX A Ograve -45\nKPX A Ohungarumlaut -45\nKPX A Omacron -45\nKPX A Oslash -45\nKPX A Otilde -45\nKPX A Q -45\nKPX A T -95\nKPX A Tcaron -95\nKPX A Tcommaaccent -95\nKPX A U -50\nKPX A Uacute -50\nKPX A Ucircumflex -50\nKPX A Udieresis -50\nKPX A Ugrave -50\nKPX A Uhungarumlaut -50\nKPX A Umacron -50\nKPX A Uogonek -50\nKPX A Uring -50\nKPX A V -145\nKPX A W -130\nKPX A Y -100\nKPX A Yacute -100\nKPX A Ydieresis -100\nKPX A p -25\nKPX A quoteright -74\nKPX A u -50\nKPX A uacute -50\nKPX A ucircumflex -50\nKPX A udieresis -50\nKPX A ugrave -50\nKPX A uhungarumlaut -50\nKPX A umacron -50\nKPX A uogonek -50\nKPX A uring -50\nKPX A v -100\nKPX A w -90\nKPX A y -74\nKPX A yacute -74\nKPX A ydieresis -74\nKPX Aacute C -55\nKPX Aacute Cacute -55\nKPX Aacute Ccaron -55\nKPX Aacute Ccedilla -55\nKPX Aacute G -55\nKPX Aacute Gbreve -55\nKPX Aacute Gcommaaccent -55\nKPX Aacute O -45\nKPX Aacute Oacute -45\nKPX Aacute Ocircumflex -45\nKPX Aacute Odieresis -45\nKPX Aacute Ograve -45\nKPX Aacute Ohungarumlaut -45\nKPX Aacute Omacron -45\nKPX Aacute Oslash -45\nKPX Aacute Otilde -45\nKPX Aacute Q -45\nKPX Aacute T -95\nKPX Aacute Tcaron -95\nKPX Aacute Tcommaaccent -95\nKPX Aacute U -50\nKPX Aacute Uacute -50\nKPX Aacute Ucircumflex -50\nKPX Aacute Udieresis -50\nKPX Aacute Ugrave -50\nKPX Aacute Uhungarumlaut -50\nKPX Aacute Umacron -50\nKPX Aacute Uogonek -50\nKPX Aacute Uring -50\nKPX Aacute V -145\nKPX Aacute W -130\nKPX Aacute Y -100\nKPX Aacute Yacute -100\nKPX Aacute Ydieresis -100\nKPX Aacute p -25\nKPX Aacute quoteright -74\nKPX Aacute u -50\nKPX Aacute uacute -50\nKPX Aacute ucircumflex -50\nKPX Aacute udieresis -50\nKPX Aacute ugrave -50\nKPX Aacute uhungarumlaut -50\nKPX Aacute umacron -50\nKPX Aacute uogonek -50\nKPX Aacute uring -50\nKPX Aacute v -100\nKPX Aacute w -90\nKPX Aacute y -74\nKPX Aacute yacute -74\nKPX Aacute ydieresis -74\nKPX Abreve C -55\nKPX Abreve Cacute -55\nKPX Abreve Ccaron -55\nKPX Abreve Ccedilla -55\nKPX Abreve G -55\nKPX Abreve Gbreve -55\nKPX Abreve Gcommaaccent -55\nKPX Abreve O -45\nKPX Abreve Oacute -45\nKPX Abreve Ocircumflex -45\nKPX Abreve Odieresis -45\nKPX Abreve Ograve -45\nKPX Abreve Ohungarumlaut -45\nKPX Abreve Omacron -45\nKPX Abreve Oslash -45\nKPX Abreve Otilde -45\nKPX Abreve Q -45\nKPX Abreve T -95\nKPX Abreve Tcaron -95\nKPX Abreve Tcommaaccent -95\nKPX Abreve U -50\nKPX Abreve Uacute -50\nKPX Abreve Ucircumflex -50\nKPX Abreve Udieresis -50\nKPX Abreve Ugrave -50\nKPX Abreve Uhungarumlaut -50\nKPX Abreve Umacron -50\nKPX Abreve Uogonek -50\nKPX Abreve Uring -50\nKPX Abreve V -145\nKPX Abreve W -130\nKPX Abreve Y -100\nKPX Abreve Yacute -100\nKPX Abreve Ydieresis -100\nKPX Abreve p -25\nKPX Abreve quoteright -74\nKPX Abreve u -50\nKPX Abreve uacute -50\nKPX Abreve ucircumflex -50\nKPX Abreve udieresis -50\nKPX Abreve ugrave -50\nKPX Abreve uhungarumlaut -50\nKPX Abreve umacron -50\nKPX Abreve uogonek -50\nKPX Abreve uring -50\nKPX Abreve v -100\nKPX Abreve w -90\nKPX Abreve y -74\nKPX Abreve yacute -74\nKPX Abreve ydieresis -74\nKPX Acircumflex C -55\nKPX Acircumflex Cacute -55\nKPX Acircumflex Ccaron -55\nKPX Acircumflex Ccedilla -55\nKPX Acircumflex G -55\nKPX Acircumflex Gbreve -55\nKPX Acircumflex Gcommaaccent -55\nKPX Acircumflex O -45\nKPX Acircumflex Oacute -45\nKPX Acircumflex Ocircumflex -45\nKPX Acircumflex Odieresis -45\nKPX Acircumflex Ograve -45\nKPX Acircumflex Ohungarumlaut -45\nKPX Acircumflex Omacron -45\nKPX Acircumflex Oslash -45\nKPX Acircumflex Otilde -45\nKPX Acircumflex Q -45\nKPX Acircumflex T -95\nKPX Acircumflex Tcaron -95\nKPX Acircumflex Tcommaaccent -95\nKPX Acircumflex U -50\nKPX Acircumflex Uacute -50\nKPX Acircumflex Ucircumflex -50\nKPX Acircumflex Udieresis -50\nKPX Acircumflex Ugrave -50\nKPX Acircumflex Uhungarumlaut -50\nKPX Acircumflex Umacron -50\nKPX Acircumflex Uogonek -50\nKPX Acircumflex Uring -50\nKPX Acircumflex V -145\nKPX Acircumflex W -130\nKPX Acircumflex Y -100\nKPX Acircumflex Yacute -100\nKPX Acircumflex Ydieresis -100\nKPX Acircumflex p -25\nKPX Acircumflex quoteright -74\nKPX Acircumflex u -50\nKPX Acircumflex uacute -50\nKPX Acircumflex ucircumflex -50\nKPX Acircumflex udieresis -50\nKPX Acircumflex ugrave -50\nKPX Acircumflex uhungarumlaut -50\nKPX Acircumflex umacron -50\nKPX Acircumflex uogonek -50\nKPX Acircumflex uring -50\nKPX Acircumflex v -100\nKPX Acircumflex w -90\nKPX Acircumflex y -74\nKPX Acircumflex yacute -74\nKPX Acircumflex ydieresis -74\nKPX Adieresis C -55\nKPX Adieresis Cacute -55\nKPX Adieresis Ccaron -55\nKPX Adieresis Ccedilla -55\nKPX Adieresis G -55\nKPX Adieresis Gbreve -55\nKPX Adieresis Gcommaaccent -55\nKPX Adieresis O -45\nKPX Adieresis Oacute -45\nKPX Adieresis Ocircumflex -45\nKPX Adieresis Odieresis -45\nKPX Adieresis Ograve -45\nKPX Adieresis Ohungarumlaut -45\nKPX Adieresis Omacron -45\nKPX Adieresis Oslash -45\nKPX Adieresis Otilde -45\nKPX Adieresis Q -45\nKPX Adieresis T -95\nKPX Adieresis Tcaron -95\nKPX Adieresis Tcommaaccent -95\nKPX Adieresis U -50\nKPX Adieresis Uacute -50\nKPX Adieresis Ucircumflex -50\nKPX Adieresis Udieresis -50\nKPX Adieresis Ugrave -50\nKPX Adieresis Uhungarumlaut -50\nKPX Adieresis Umacron -50\nKPX Adieresis Uogonek -50\nKPX Adieresis Uring -50\nKPX Adieresis V -145\nKPX Adieresis W -130\nKPX Adieresis Y -100\nKPX Adieresis Yacute -100\nKPX Adieresis Ydieresis -100\nKPX Adieresis p -25\nKPX Adieresis quoteright -74\nKPX Adieresis u -50\nKPX Adieresis uacute -50\nKPX Adieresis ucircumflex -50\nKPX Adieresis udieresis -50\nKPX Adieresis ugrave -50\nKPX Adieresis uhungarumlaut -50\nKPX Adieresis umacron -50\nKPX Adieresis uogonek -50\nKPX Adieresis uring -50\nKPX Adieresis v -100\nKPX Adieresis w -90\nKPX Adieresis y -74\nKPX Adieresis yacute -74\nKPX Adieresis ydieresis -74\nKPX Agrave C -55\nKPX Agrave Cacute -55\nKPX Agrave Ccaron -55\nKPX Agrave Ccedilla -55\nKPX Agrave G -55\nKPX Agrave Gbreve -55\nKPX Agrave Gcommaaccent -55\nKPX Agrave O -45\nKPX Agrave Oacute -45\nKPX Agrave Ocircumflex -45\nKPX Agrave Odieresis -45\nKPX Agrave Ograve -45\nKPX Agrave Ohungarumlaut -45\nKPX Agrave Omacron -45\nKPX Agrave Oslash -45\nKPX Agrave Otilde -45\nKPX Agrave Q -45\nKPX Agrave T -95\nKPX Agrave Tcaron -95\nKPX Agrave Tcommaaccent -95\nKPX Agrave U -50\nKPX Agrave Uacute -50\nKPX Agrave Ucircumflex -50\nKPX Agrave Udieresis -50\nKPX Agrave Ugrave -50\nKPX Agrave Uhungarumlaut -50\nKPX Agrave Umacron -50\nKPX Agrave Uogonek -50\nKPX Agrave Uring -50\nKPX Agrave V -145\nKPX Agrave W -130\nKPX Agrave Y -100\nKPX Agrave Yacute -100\nKPX Agrave Ydieresis -100\nKPX Agrave p -25\nKPX Agrave quoteright -74\nKPX Agrave u -50\nKPX Agrave uacute -50\nKPX Agrave ucircumflex -50\nKPX Agrave udieresis -50\nKPX Agrave ugrave -50\nKPX Agrave uhungarumlaut -50\nKPX Agrave umacron -50\nKPX Agrave uogonek -50\nKPX Agrave uring -50\nKPX Agrave v -100\nKPX Agrave w -90\nKPX Agrave y -74\nKPX Agrave yacute -74\nKPX Agrave ydieresis -74\nKPX Amacron C -55\nKPX Amacron Cacute -55\nKPX Amacron Ccaron -55\nKPX Amacron Ccedilla -55\nKPX Amacron G -55\nKPX Amacron Gbreve -55\nKPX Amacron Gcommaaccent -55\nKPX Amacron O -45\nKPX Amacron Oacute -45\nKPX Amacron Ocircumflex -45\nKPX Amacron Odieresis -45\nKPX Amacron Ograve -45\nKPX Amacron Ohungarumlaut -45\nKPX Amacron Omacron -45\nKPX Amacron Oslash -45\nKPX Amacron Otilde -45\nKPX Amacron Q -45\nKPX Amacron T -95\nKPX Amacron Tcaron -95\nKPX Amacron Tcommaaccent -95\nKPX Amacron U -50\nKPX Amacron Uacute -50\nKPX Amacron Ucircumflex -50\nKPX Amacron Udieresis -50\nKPX Amacron Ugrave -50\nKPX Amacron Uhungarumlaut -50\nKPX Amacron Umacron -50\nKPX Amacron Uogonek -50\nKPX Amacron Uring -50\nKPX Amacron V -145\nKPX Amacron W -130\nKPX Amacron Y -100\nKPX Amacron Yacute -100\nKPX Amacron Ydieresis -100\nKPX Amacron p -25\nKPX Amacron quoteright -74\nKPX Amacron u -50\nKPX Amacron uacute -50\nKPX Amacron ucircumflex -50\nKPX Amacron udieresis -50\nKPX Amacron ugrave -50\nKPX Amacron uhungarumlaut -50\nKPX Amacron umacron -50\nKPX Amacron uogonek -50\nKPX Amacron uring -50\nKPX Amacron v -100\nKPX Amacron w -90\nKPX Amacron y -74\nKPX Amacron yacute -74\nKPX Amacron ydieresis -74\nKPX Aogonek C -55\nKPX Aogonek Cacute -55\nKPX Aogonek Ccaron -55\nKPX Aogonek Ccedilla -55\nKPX Aogonek G -55\nKPX Aogonek Gbreve -55\nKPX Aogonek Gcommaaccent -55\nKPX Aogonek O -45\nKPX Aogonek Oacute -45\nKPX Aogonek Ocircumflex -45\nKPX Aogonek Odieresis -45\nKPX Aogonek Ograve -45\nKPX Aogonek Ohungarumlaut -45\nKPX Aogonek Omacron -45\nKPX Aogonek Oslash -45\nKPX Aogonek Otilde -45\nKPX Aogonek Q -45\nKPX Aogonek T -95\nKPX Aogonek Tcaron -95\nKPX Aogonek Tcommaaccent -95\nKPX Aogonek U -50\nKPX Aogonek Uacute -50\nKPX Aogonek Ucircumflex -50\nKPX Aogonek Udieresis -50\nKPX Aogonek Ugrave -50\nKPX Aogonek Uhungarumlaut -50\nKPX Aogonek Umacron -50\nKPX Aogonek Uogonek -50\nKPX Aogonek Uring -50\nKPX Aogonek V -145\nKPX Aogonek W -130\nKPX Aogonek Y -100\nKPX Aogonek Yacute -100\nKPX Aogonek Ydieresis -100\nKPX Aogonek p -25\nKPX Aogonek quoteright -74\nKPX Aogonek u -50\nKPX Aogonek uacute -50\nKPX Aogonek ucircumflex -50\nKPX Aogonek udieresis -50\nKPX Aogonek ugrave -50\nKPX Aogonek uhungarumlaut -50\nKPX Aogonek umacron -50\nKPX Aogonek uogonek -50\nKPX Aogonek uring -50\nKPX Aogonek v -100\nKPX Aogonek w -90\nKPX Aogonek y -34\nKPX Aogonek yacute -34\nKPX Aogonek ydieresis -34\nKPX Aring C -55\nKPX Aring Cacute -55\nKPX Aring Ccaron -55\nKPX Aring Ccedilla -55\nKPX Aring G -55\nKPX Aring Gbreve -55\nKPX Aring Gcommaaccent -55\nKPX Aring O -45\nKPX Aring Oacute -45\nKPX Aring Ocircumflex -45\nKPX Aring Odieresis -45\nKPX Aring Ograve -45\nKPX Aring Ohungarumlaut -45\nKPX Aring Omacron -45\nKPX Aring Oslash -45\nKPX Aring Otilde -45\nKPX Aring Q -45\nKPX Aring T -95\nKPX Aring Tcaron -95\nKPX Aring Tcommaaccent -95\nKPX Aring U -50\nKPX Aring Uacute -50\nKPX Aring Ucircumflex -50\nKPX Aring Udieresis -50\nKPX Aring Ugrave -50\nKPX Aring Uhungarumlaut -50\nKPX Aring Umacron -50\nKPX Aring Uogonek -50\nKPX Aring Uring -50\nKPX Aring V -145\nKPX Aring W -130\nKPX Aring Y -100\nKPX Aring Yacute -100\nKPX Aring Ydieresis -100\nKPX Aring p -25\nKPX Aring quoteright -74\nKPX Aring u -50\nKPX Aring uacute -50\nKPX Aring ucircumflex -50\nKPX Aring udieresis -50\nKPX Aring ugrave -50\nKPX Aring uhungarumlaut -50\nKPX Aring umacron -50\nKPX Aring uogonek -50\nKPX Aring uring -50\nKPX Aring v -100\nKPX Aring w -90\nKPX Aring y -74\nKPX Aring yacute -74\nKPX Aring ydieresis -74\nKPX Atilde C -55\nKPX Atilde Cacute -55\nKPX Atilde Ccaron -55\nKPX Atilde Ccedilla -55\nKPX Atilde G -55\nKPX Atilde Gbreve -55\nKPX Atilde Gcommaaccent -55\nKPX Atilde O -45\nKPX Atilde Oacute -45\nKPX Atilde Ocircumflex -45\nKPX Atilde Odieresis -45\nKPX Atilde Ograve -45\nKPX Atilde Ohungarumlaut -45\nKPX Atilde Omacron -45\nKPX Atilde Oslash -45\nKPX Atilde Otilde -45\nKPX Atilde Q -45\nKPX Atilde T -95\nKPX Atilde Tcaron -95\nKPX Atilde Tcommaaccent -95\nKPX Atilde U -50\nKPX Atilde Uacute -50\nKPX Atilde Ucircumflex -50\nKPX Atilde Udieresis -50\nKPX Atilde Ugrave -50\nKPX Atilde Uhungarumlaut -50\nKPX Atilde Umacron -50\nKPX Atilde Uogonek -50\nKPX Atilde Uring -50\nKPX Atilde V -145\nKPX Atilde W -130\nKPX Atilde Y -100\nKPX Atilde Yacute -100\nKPX Atilde Ydieresis -100\nKPX Atilde p -25\nKPX Atilde quoteright -74\nKPX Atilde u -50\nKPX Atilde uacute -50\nKPX Atilde ucircumflex -50\nKPX Atilde udieresis -50\nKPX Atilde ugrave -50\nKPX Atilde uhungarumlaut -50\nKPX Atilde umacron -50\nKPX Atilde uogonek -50\nKPX Atilde uring -50\nKPX Atilde v -100\nKPX Atilde w -90\nKPX Atilde y -74\nKPX Atilde yacute -74\nKPX Atilde ydieresis -74\nKPX B A -30\nKPX B Aacute -30\nKPX B Abreve -30\nKPX B Acircumflex -30\nKPX B Adieresis -30\nKPX B Agrave -30\nKPX B Amacron -30\nKPX B Aogonek -30\nKPX B Aring -30\nKPX B Atilde -30\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX D A -35\nKPX D Aacute -35\nKPX D Abreve -35\nKPX D Acircumflex -35\nKPX D Adieresis -35\nKPX D Agrave -35\nKPX D Amacron -35\nKPX D Aogonek -35\nKPX D Aring -35\nKPX D Atilde -35\nKPX D V -40\nKPX D W -40\nKPX D Y -40\nKPX D Yacute -40\nKPX D Ydieresis -40\nKPX D period -20\nKPX Dcaron A -35\nKPX Dcaron Aacute -35\nKPX Dcaron Abreve -35\nKPX Dcaron Acircumflex -35\nKPX Dcaron Adieresis -35\nKPX Dcaron Agrave -35\nKPX Dcaron Amacron -35\nKPX Dcaron Aogonek -35\nKPX Dcaron Aring -35\nKPX Dcaron Atilde -35\nKPX Dcaron V -40\nKPX Dcaron W -40\nKPX Dcaron Y -40\nKPX Dcaron Yacute -40\nKPX Dcaron Ydieresis -40\nKPX Dcaron period -20\nKPX Dcroat A -35\nKPX Dcroat Aacute -35\nKPX Dcroat Abreve -35\nKPX Dcroat Acircumflex -35\nKPX Dcroat Adieresis -35\nKPX Dcroat Agrave -35\nKPX Dcroat Amacron -35\nKPX Dcroat Aogonek -35\nKPX Dcroat Aring -35\nKPX Dcroat Atilde -35\nKPX Dcroat V -40\nKPX Dcroat W -40\nKPX Dcroat Y -40\nKPX Dcroat Yacute -40\nKPX Dcroat Ydieresis -40\nKPX Dcroat period -20\nKPX F A -90\nKPX F Aacute -90\nKPX F Abreve -90\nKPX F Acircumflex -90\nKPX F Adieresis -90\nKPX F Agrave -90\nKPX F Amacron -90\nKPX F Aogonek -90\nKPX F Aring -90\nKPX F Atilde -90\nKPX F a -25\nKPX F aacute -25\nKPX F abreve -25\nKPX F acircumflex -25\nKPX F adieresis -25\nKPX F agrave -25\nKPX F amacron -25\nKPX F aogonek -25\nKPX F aring -25\nKPX F atilde -25\nKPX F comma -92\nKPX F e -25\nKPX F eacute -25\nKPX F ecaron -25\nKPX F ecircumflex -25\nKPX F edieresis -25\nKPX F edotaccent -25\nKPX F egrave -25\nKPX F emacron -25\nKPX F eogonek -25\nKPX F o -25\nKPX F oacute -25\nKPX F ocircumflex -25\nKPX F odieresis -25\nKPX F ograve -25\nKPX F ohungarumlaut -25\nKPX F omacron -25\nKPX F oslash -25\nKPX F otilde -25\nKPX F period -110\nKPX J A -30\nKPX J Aacute -30\nKPX J Abreve -30\nKPX J Acircumflex -30\nKPX J Adieresis -30\nKPX J Agrave -30\nKPX J Amacron -30\nKPX J Aogonek -30\nKPX J Aring -30\nKPX J Atilde -30\nKPX J a -15\nKPX J aacute -15\nKPX J abreve -15\nKPX J acircumflex -15\nKPX J adieresis -15\nKPX J agrave -15\nKPX J amacron -15\nKPX J aogonek -15\nKPX J aring -15\nKPX J atilde -15\nKPX J e -15\nKPX J eacute -15\nKPX J ecaron -15\nKPX J ecircumflex -15\nKPX J edieresis -15\nKPX J edotaccent -15\nKPX J egrave -15\nKPX J emacron -15\nKPX J eogonek -15\nKPX J o -15\nKPX J oacute -15\nKPX J ocircumflex -15\nKPX J odieresis -15\nKPX J ograve -15\nKPX J ohungarumlaut -15\nKPX J omacron -15\nKPX J oslash -15\nKPX J otilde -15\nKPX J period -20\nKPX J u -15\nKPX J uacute -15\nKPX J ucircumflex -15\nKPX J udieresis -15\nKPX J ugrave -15\nKPX J uhungarumlaut -15\nKPX J umacron -15\nKPX J uogonek -15\nKPX J uring -15\nKPX K O -30\nKPX K Oacute -30\nKPX K Ocircumflex -30\nKPX K Odieresis -30\nKPX K Ograve -30\nKPX K Ohungarumlaut -30\nKPX K Omacron -30\nKPX K Oslash -30\nKPX K Otilde -30\nKPX K e -25\nKPX K eacute -25\nKPX K ecaron -25\nKPX K ecircumflex -25\nKPX K edieresis -25\nKPX K edotaccent -25\nKPX K egrave -25\nKPX K emacron -25\nKPX K eogonek -25\nKPX K o -25\nKPX K oacute -25\nKPX K ocircumflex -25\nKPX K odieresis -25\nKPX K ograve -25\nKPX K ohungarumlaut -25\nKPX K omacron -25\nKPX K oslash -25\nKPX K otilde -25\nKPX K u -15\nKPX K uacute -15\nKPX K ucircumflex -15\nKPX K udieresis -15\nKPX K ugrave -15\nKPX K uhungarumlaut -15\nKPX K umacron -15\nKPX K uogonek -15\nKPX K uring -15\nKPX K y -45\nKPX K yacute -45\nKPX K ydieresis -45\nKPX Kcommaaccent O -30\nKPX Kcommaaccent Oacute -30\nKPX Kcommaaccent Ocircumflex -30\nKPX Kcommaaccent Odieresis -30\nKPX Kcommaaccent Ograve -30\nKPX Kcommaaccent Ohungarumlaut -30\nKPX Kcommaaccent Omacron -30\nKPX Kcommaaccent Oslash -30\nKPX Kcommaaccent Otilde -30\nKPX Kcommaaccent e -25\nKPX Kcommaaccent eacute -25\nKPX Kcommaaccent ecaron -25\nKPX Kcommaaccent ecircumflex -25\nKPX Kcommaaccent edieresis -25\nKPX Kcommaaccent edotaccent -25\nKPX Kcommaaccent egrave -25\nKPX Kcommaaccent emacron -25\nKPX Kcommaaccent eogonek -25\nKPX Kcommaaccent o -25\nKPX Kcommaaccent oacute -25\nKPX Kcommaaccent ocircumflex -25\nKPX Kcommaaccent odieresis -25\nKPX Kcommaaccent ograve -25\nKPX Kcommaaccent ohungarumlaut -25\nKPX Kcommaaccent omacron -25\nKPX Kcommaaccent oslash -25\nKPX Kcommaaccent otilde -25\nKPX Kcommaaccent u -15\nKPX Kcommaaccent uacute -15\nKPX Kcommaaccent ucircumflex -15\nKPX Kcommaaccent udieresis -15\nKPX Kcommaaccent ugrave -15\nKPX Kcommaaccent uhungarumlaut -15\nKPX Kcommaaccent umacron -15\nKPX Kcommaaccent uogonek -15\nKPX Kcommaaccent uring -15\nKPX Kcommaaccent y -45\nKPX Kcommaaccent yacute -45\nKPX Kcommaaccent ydieresis -45\nKPX L T -92\nKPX L Tcaron -92\nKPX L Tcommaaccent -92\nKPX L V -92\nKPX L W -92\nKPX L Y -92\nKPX L Yacute -92\nKPX L Ydieresis -92\nKPX L quotedblright -20\nKPX L quoteright -110\nKPX L y -55\nKPX L yacute -55\nKPX L ydieresis -55\nKPX Lacute T -92\nKPX Lacute Tcaron -92\nKPX Lacute Tcommaaccent -92\nKPX Lacute V -92\nKPX Lacute W -92\nKPX Lacute Y -92\nKPX Lacute Yacute -92\nKPX Lacute Ydieresis -92\nKPX Lacute quotedblright -20\nKPX Lacute quoteright -110\nKPX Lacute y -55\nKPX Lacute yacute -55\nKPX Lacute ydieresis -55\nKPX Lcommaaccent T -92\nKPX Lcommaaccent Tcaron -92\nKPX Lcommaaccent Tcommaaccent -92\nKPX Lcommaaccent V -92\nKPX Lcommaaccent W -92\nKPX Lcommaaccent Y -92\nKPX Lcommaaccent Yacute -92\nKPX Lcommaaccent Ydieresis -92\nKPX Lcommaaccent quotedblright -20\nKPX Lcommaaccent quoteright -110\nKPX Lcommaaccent y -55\nKPX Lcommaaccent yacute -55\nKPX Lcommaaccent ydieresis -55\nKPX Lslash T -92\nKPX Lslash Tcaron -92\nKPX Lslash Tcommaaccent -92\nKPX Lslash V -92\nKPX Lslash W -92\nKPX Lslash Y -92\nKPX Lslash Yacute -92\nKPX Lslash Ydieresis -92\nKPX Lslash quotedblright -20\nKPX Lslash quoteright -110\nKPX Lslash y -55\nKPX Lslash yacute -55\nKPX Lslash ydieresis -55\nKPX N A -20\nKPX N Aacute -20\nKPX N Abreve -20\nKPX N Acircumflex -20\nKPX N Adieresis -20\nKPX N Agrave -20\nKPX N Amacron -20\nKPX N Aogonek -20\nKPX N Aring -20\nKPX N Atilde -20\nKPX Nacute A -20\nKPX Nacute Aacute -20\nKPX Nacute Abreve -20\nKPX Nacute Acircumflex -20\nKPX Nacute Adieresis -20\nKPX Nacute Agrave -20\nKPX Nacute Amacron -20\nKPX Nacute Aogonek -20\nKPX Nacute Aring -20\nKPX Nacute Atilde -20\nKPX Ncaron A -20\nKPX Ncaron Aacute -20\nKPX Ncaron Abreve -20\nKPX Ncaron Acircumflex -20\nKPX Ncaron Adieresis -20\nKPX Ncaron Agrave -20\nKPX Ncaron Amacron -20\nKPX Ncaron Aogonek -20\nKPX Ncaron Aring -20\nKPX Ncaron Atilde -20\nKPX Ncommaaccent A -20\nKPX Ncommaaccent Aacute -20\nKPX Ncommaaccent Abreve -20\nKPX Ncommaaccent Acircumflex -20\nKPX Ncommaaccent Adieresis -20\nKPX Ncommaaccent Agrave -20\nKPX Ncommaaccent Amacron -20\nKPX Ncommaaccent Aogonek -20\nKPX Ncommaaccent Aring -20\nKPX Ncommaaccent Atilde -20\nKPX Ntilde A -20\nKPX Ntilde Aacute -20\nKPX Ntilde Abreve -20\nKPX Ntilde Acircumflex -20\nKPX Ntilde Adieresis -20\nKPX Ntilde Agrave -20\nKPX Ntilde Amacron -20\nKPX Ntilde Aogonek -20\nKPX Ntilde Aring -20\nKPX Ntilde Atilde -20\nKPX O A -40\nKPX O Aacute -40\nKPX O Abreve -40\nKPX O Acircumflex -40\nKPX O Adieresis -40\nKPX O Agrave -40\nKPX O Amacron -40\nKPX O Aogonek -40\nKPX O Aring -40\nKPX O Atilde -40\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -50\nKPX O X -40\nKPX O Y -50\nKPX O Yacute -50\nKPX O Ydieresis -50\nKPX Oacute A -40\nKPX Oacute Aacute -40\nKPX Oacute Abreve -40\nKPX Oacute Acircumflex -40\nKPX Oacute Adieresis -40\nKPX Oacute Agrave -40\nKPX Oacute Amacron -40\nKPX Oacute Aogonek -40\nKPX Oacute Aring -40\nKPX Oacute Atilde -40\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -50\nKPX Oacute X -40\nKPX Oacute Y -50\nKPX Oacute Yacute -50\nKPX Oacute Ydieresis -50\nKPX Ocircumflex A -40\nKPX Ocircumflex Aacute -40\nKPX Ocircumflex Abreve -40\nKPX Ocircumflex Acircumflex -40\nKPX Ocircumflex Adieresis -40\nKPX Ocircumflex Agrave -40\nKPX Ocircumflex Amacron -40\nKPX Ocircumflex Aogonek -40\nKPX Ocircumflex Aring -40\nKPX Ocircumflex Atilde -40\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -50\nKPX Ocircumflex X -40\nKPX Ocircumflex Y -50\nKPX Ocircumflex Yacute -50\nKPX Ocircumflex Ydieresis -50\nKPX Odieresis A -40\nKPX Odieresis Aacute -40\nKPX Odieresis Abreve -40\nKPX Odieresis Acircumflex -40\nKPX Odieresis Adieresis -40\nKPX Odieresis Agrave -40\nKPX Odieresis Amacron -40\nKPX Odieresis Aogonek -40\nKPX Odieresis Aring -40\nKPX Odieresis Atilde -40\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -50\nKPX Odieresis X -40\nKPX Odieresis Y -50\nKPX Odieresis Yacute -50\nKPX Odieresis Ydieresis -50\nKPX Ograve A -40\nKPX Ograve Aacute -40\nKPX Ograve Abreve -40\nKPX Ograve Acircumflex -40\nKPX Ograve Adieresis -40\nKPX Ograve Agrave -40\nKPX Ograve Amacron -40\nKPX Ograve Aogonek -40\nKPX Ograve Aring -40\nKPX Ograve Atilde -40\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -50\nKPX Ograve X -40\nKPX Ograve Y -50\nKPX Ograve Yacute -50\nKPX Ograve Ydieresis -50\nKPX Ohungarumlaut A -40\nKPX Ohungarumlaut Aacute -40\nKPX Ohungarumlaut Abreve -40\nKPX Ohungarumlaut Acircumflex -40\nKPX Ohungarumlaut Adieresis -40\nKPX Ohungarumlaut Agrave -40\nKPX Ohungarumlaut Amacron -40\nKPX Ohungarumlaut Aogonek -40\nKPX Ohungarumlaut Aring -40\nKPX Ohungarumlaut Atilde -40\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -50\nKPX Ohungarumlaut X -40\nKPX Ohungarumlaut Y -50\nKPX Ohungarumlaut Yacute -50\nKPX Ohungarumlaut Ydieresis -50\nKPX Omacron A -40\nKPX Omacron Aacute -40\nKPX Omacron Abreve -40\nKPX Omacron Acircumflex -40\nKPX Omacron Adieresis -40\nKPX Omacron Agrave -40\nKPX Omacron Amacron -40\nKPX Omacron Aogonek -40\nKPX Omacron Aring -40\nKPX Omacron Atilde -40\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -50\nKPX Omacron X -40\nKPX Omacron Y -50\nKPX Omacron Yacute -50\nKPX Omacron Ydieresis -50\nKPX Oslash A -40\nKPX Oslash Aacute -40\nKPX Oslash Abreve -40\nKPX Oslash Acircumflex -40\nKPX Oslash Adieresis -40\nKPX Oslash Agrave -40\nKPX Oslash Amacron -40\nKPX Oslash Aogonek -40\nKPX Oslash Aring -40\nKPX Oslash Atilde -40\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -50\nKPX Oslash X -40\nKPX Oslash Y -50\nKPX Oslash Yacute -50\nKPX Oslash Ydieresis -50\nKPX Otilde A -40\nKPX Otilde Aacute -40\nKPX Otilde Abreve -40\nKPX Otilde Acircumflex -40\nKPX Otilde Adieresis -40\nKPX Otilde Agrave -40\nKPX Otilde Amacron -40\nKPX Otilde Aogonek -40\nKPX Otilde Aring -40\nKPX Otilde Atilde -40\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -50\nKPX Otilde X -40\nKPX Otilde Y -50\nKPX Otilde Yacute -50\nKPX Otilde Ydieresis -50\nKPX P A -74\nKPX P Aacute -74\nKPX P Abreve -74\nKPX P Acircumflex -74\nKPX P Adieresis -74\nKPX P Agrave -74\nKPX P Amacron -74\nKPX P Aogonek -74\nKPX P Aring -74\nKPX P Atilde -74\nKPX P a -10\nKPX P aacute -10\nKPX P abreve -10\nKPX P acircumflex -10\nKPX P adieresis -10\nKPX P agrave -10\nKPX P amacron -10\nKPX P aogonek -10\nKPX P aring -10\nKPX P atilde -10\nKPX P comma -92\nKPX P e -20\nKPX P eacute -20\nKPX P ecaron -20\nKPX P ecircumflex -20\nKPX P edieresis -20\nKPX P edotaccent -20\nKPX P egrave -20\nKPX P emacron -20\nKPX P eogonek -20\nKPX P o -20\nKPX P oacute -20\nKPX P ocircumflex -20\nKPX P odieresis -20\nKPX P ograve -20\nKPX P ohungarumlaut -20\nKPX P omacron -20\nKPX P oslash -20\nKPX P otilde -20\nKPX P period -110\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX Q period -20\nKPX R O -30\nKPX R Oacute -30\nKPX R Ocircumflex -30\nKPX R Odieresis -30\nKPX R Ograve -30\nKPX R Ohungarumlaut -30\nKPX R Omacron -30\nKPX R Oslash -30\nKPX R Otilde -30\nKPX R T -40\nKPX R Tcaron -40\nKPX R Tcommaaccent -40\nKPX R U -30\nKPX R Uacute -30\nKPX R Ucircumflex -30\nKPX R Udieresis -30\nKPX R Ugrave -30\nKPX R Uhungarumlaut -30\nKPX R Umacron -30\nKPX R Uogonek -30\nKPX R Uring -30\nKPX R V -55\nKPX R W -35\nKPX R Y -35\nKPX R Yacute -35\nKPX R Ydieresis -35\nKPX Racute O -30\nKPX Racute Oacute -30\nKPX Racute Ocircumflex -30\nKPX Racute Odieresis -30\nKPX Racute Ograve -30\nKPX Racute Ohungarumlaut -30\nKPX Racute Omacron -30\nKPX Racute Oslash -30\nKPX Racute Otilde -30\nKPX Racute T -40\nKPX Racute Tcaron -40\nKPX Racute Tcommaaccent -40\nKPX Racute U -30\nKPX Racute Uacute -30\nKPX Racute Ucircumflex -30\nKPX Racute Udieresis -30\nKPX Racute Ugrave -30\nKPX Racute Uhungarumlaut -30\nKPX Racute Umacron -30\nKPX Racute Uogonek -30\nKPX Racute Uring -30\nKPX Racute V -55\nKPX Racute W -35\nKPX Racute Y -35\nKPX Racute Yacute -35\nKPX Racute Ydieresis -35\nKPX Rcaron O -30\nKPX Rcaron Oacute -30\nKPX Rcaron Ocircumflex -30\nKPX Rcaron Odieresis -30\nKPX Rcaron Ograve -30\nKPX Rcaron Ohungarumlaut -30\nKPX Rcaron Omacron -30\nKPX Rcaron Oslash -30\nKPX Rcaron Otilde -30\nKPX Rcaron T -40\nKPX Rcaron Tcaron -40\nKPX Rcaron Tcommaaccent -40\nKPX Rcaron U -30\nKPX Rcaron Uacute -30\nKPX Rcaron Ucircumflex -30\nKPX Rcaron Udieresis -30\nKPX Rcaron Ugrave -30\nKPX Rcaron Uhungarumlaut -30\nKPX Rcaron Umacron -30\nKPX Rcaron Uogonek -30\nKPX Rcaron Uring -30\nKPX Rcaron V -55\nKPX Rcaron W -35\nKPX Rcaron Y -35\nKPX Rcaron Yacute -35\nKPX Rcaron Ydieresis -35\nKPX Rcommaaccent O -30\nKPX Rcommaaccent Oacute -30\nKPX Rcommaaccent Ocircumflex -30\nKPX Rcommaaccent Odieresis -30\nKPX Rcommaaccent Ograve -30\nKPX Rcommaaccent Ohungarumlaut -30\nKPX Rcommaaccent Omacron -30\nKPX Rcommaaccent Oslash -30\nKPX Rcommaaccent Otilde -30\nKPX Rcommaaccent T -40\nKPX Rcommaaccent Tcaron -40\nKPX Rcommaaccent Tcommaaccent -40\nKPX Rcommaaccent U -30\nKPX Rcommaaccent Uacute -30\nKPX Rcommaaccent Ucircumflex -30\nKPX Rcommaaccent Udieresis -30\nKPX Rcommaaccent Ugrave -30\nKPX Rcommaaccent Uhungarumlaut -30\nKPX Rcommaaccent Umacron -30\nKPX Rcommaaccent Uogonek -30\nKPX Rcommaaccent Uring -30\nKPX Rcommaaccent V -55\nKPX Rcommaaccent W -35\nKPX Rcommaaccent Y -35\nKPX Rcommaaccent Yacute -35\nKPX Rcommaaccent Ydieresis -35\nKPX T A -90\nKPX T Aacute -90\nKPX T Abreve -90\nKPX T Acircumflex -90\nKPX T Adieresis -90\nKPX T Agrave -90\nKPX T Amacron -90\nKPX T Aogonek -90\nKPX T Aring -90\nKPX T Atilde -90\nKPX T O -18\nKPX T Oacute -18\nKPX T Ocircumflex -18\nKPX T Odieresis -18\nKPX T Ograve -18\nKPX T Ohungarumlaut -18\nKPX T Omacron -18\nKPX T Oslash -18\nKPX T Otilde -18\nKPX T a -92\nKPX T aacute -92\nKPX T abreve -52\nKPX T acircumflex -52\nKPX T adieresis -52\nKPX T agrave -52\nKPX T amacron -52\nKPX T aogonek -92\nKPX T aring -92\nKPX T atilde -52\nKPX T colon -74\nKPX T comma -74\nKPX T e -92\nKPX T eacute -92\nKPX T ecaron -92\nKPX T ecircumflex -92\nKPX T edieresis -52\nKPX T edotaccent -92\nKPX T egrave -52\nKPX T emacron -52\nKPX T eogonek -92\nKPX T hyphen -92\nKPX T i -18\nKPX T iacute -18\nKPX T iogonek -18\nKPX T o -92\nKPX T oacute -92\nKPX T ocircumflex -92\nKPX T odieresis -92\nKPX T ograve -92\nKPX T ohungarumlaut -92\nKPX T omacron -92\nKPX T oslash -92\nKPX T otilde -92\nKPX T period -90\nKPX T r -74\nKPX T racute -74\nKPX T rcaron -74\nKPX T rcommaaccent -74\nKPX T semicolon -74\nKPX T u -92\nKPX T uacute -92\nKPX T ucircumflex -92\nKPX T udieresis -92\nKPX T ugrave -92\nKPX T uhungarumlaut -92\nKPX T umacron -92\nKPX T uogonek -92\nKPX T uring -92\nKPX T w -74\nKPX T y -34\nKPX T yacute -34\nKPX T ydieresis -34\nKPX Tcaron A -90\nKPX Tcaron Aacute -90\nKPX Tcaron Abreve -90\nKPX Tcaron Acircumflex -90\nKPX Tcaron Adieresis -90\nKPX Tcaron Agrave -90\nKPX Tcaron Amacron -90\nKPX Tcaron Aogonek -90\nKPX Tcaron Aring -90\nKPX Tcaron Atilde -90\nKPX Tcaron O -18\nKPX Tcaron Oacute -18\nKPX Tcaron Ocircumflex -18\nKPX Tcaron Odieresis -18\nKPX Tcaron Ograve -18\nKPX Tcaron Ohungarumlaut -18\nKPX Tcaron Omacron -18\nKPX Tcaron Oslash -18\nKPX Tcaron Otilde -18\nKPX Tcaron a -92\nKPX Tcaron aacute -92\nKPX Tcaron abreve -52\nKPX Tcaron acircumflex -52\nKPX Tcaron adieresis -52\nKPX Tcaron agrave -52\nKPX Tcaron amacron -52\nKPX Tcaron aogonek -92\nKPX Tcaron aring -92\nKPX Tcaron atilde -52\nKPX Tcaron colon -74\nKPX Tcaron comma -74\nKPX Tcaron e -92\nKPX Tcaron eacute -92\nKPX Tcaron ecaron -92\nKPX Tcaron ecircumflex -92\nKPX Tcaron edieresis -52\nKPX Tcaron edotaccent -92\nKPX Tcaron egrave -52\nKPX Tcaron emacron -52\nKPX Tcaron eogonek -92\nKPX Tcaron hyphen -92\nKPX Tcaron i -18\nKPX Tcaron iacute -18\nKPX Tcaron iogonek -18\nKPX Tcaron o -92\nKPX Tcaron oacute -92\nKPX Tcaron ocircumflex -92\nKPX Tcaron odieresis -92\nKPX Tcaron ograve -92\nKPX Tcaron ohungarumlaut -92\nKPX Tcaron omacron -92\nKPX Tcaron oslash -92\nKPX Tcaron otilde -92\nKPX Tcaron period -90\nKPX Tcaron r -74\nKPX Tcaron racute -74\nKPX Tcaron rcaron -74\nKPX Tcaron rcommaaccent -74\nKPX Tcaron semicolon -74\nKPX Tcaron u -92\nKPX Tcaron uacute -92\nKPX Tcaron ucircumflex -92\nKPX Tcaron udieresis -92\nKPX Tcaron ugrave -92\nKPX Tcaron uhungarumlaut -92\nKPX Tcaron umacron -92\nKPX Tcaron uogonek -92\nKPX Tcaron uring -92\nKPX Tcaron w -74\nKPX Tcaron y -34\nKPX Tcaron yacute -34\nKPX Tcaron ydieresis -34\nKPX Tcommaaccent A -90\nKPX Tcommaaccent Aacute -90\nKPX Tcommaaccent Abreve -90\nKPX Tcommaaccent Acircumflex -90\nKPX Tcommaaccent Adieresis -90\nKPX Tcommaaccent Agrave -90\nKPX Tcommaaccent Amacron -90\nKPX Tcommaaccent Aogonek -90\nKPX Tcommaaccent Aring -90\nKPX Tcommaaccent Atilde -90\nKPX Tcommaaccent O -18\nKPX Tcommaaccent Oacute -18\nKPX Tcommaaccent Ocircumflex -18\nKPX Tcommaaccent Odieresis -18\nKPX Tcommaaccent Ograve -18\nKPX Tcommaaccent Ohungarumlaut -18\nKPX Tcommaaccent Omacron -18\nKPX Tcommaaccent Oslash -18\nKPX Tcommaaccent Otilde -18\nKPX Tcommaaccent a -92\nKPX Tcommaaccent aacute -92\nKPX Tcommaaccent abreve -52\nKPX Tcommaaccent acircumflex -52\nKPX Tcommaaccent adieresis -52\nKPX Tcommaaccent agrave -52\nKPX Tcommaaccent amacron -52\nKPX Tcommaaccent aogonek -92\nKPX Tcommaaccent aring -92\nKPX Tcommaaccent atilde -52\nKPX Tcommaaccent colon -74\nKPX Tcommaaccent comma -74\nKPX Tcommaaccent e -92\nKPX Tcommaaccent eacute -92\nKPX Tcommaaccent ecaron -92\nKPX Tcommaaccent ecircumflex -92\nKPX Tcommaaccent edieresis -52\nKPX Tcommaaccent edotaccent -92\nKPX Tcommaaccent egrave -52\nKPX Tcommaaccent emacron -52\nKPX Tcommaaccent eogonek -92\nKPX Tcommaaccent hyphen -92\nKPX Tcommaaccent i -18\nKPX Tcommaaccent iacute -18\nKPX Tcommaaccent iogonek -18\nKPX Tcommaaccent o -92\nKPX Tcommaaccent oacute -92\nKPX Tcommaaccent ocircumflex -92\nKPX Tcommaaccent odieresis -92\nKPX Tcommaaccent ograve -92\nKPX Tcommaaccent ohungarumlaut -92\nKPX Tcommaaccent omacron -92\nKPX Tcommaaccent oslash -92\nKPX Tcommaaccent otilde -92\nKPX Tcommaaccent period -90\nKPX Tcommaaccent r -74\nKPX Tcommaaccent racute -74\nKPX Tcommaaccent rcaron -74\nKPX Tcommaaccent rcommaaccent -74\nKPX Tcommaaccent semicolon -74\nKPX Tcommaaccent u -92\nKPX Tcommaaccent uacute -92\nKPX Tcommaaccent ucircumflex -92\nKPX Tcommaaccent udieresis -92\nKPX Tcommaaccent ugrave -92\nKPX Tcommaaccent uhungarumlaut -92\nKPX Tcommaaccent umacron -92\nKPX Tcommaaccent uogonek -92\nKPX Tcommaaccent uring -92\nKPX Tcommaaccent w -74\nKPX Tcommaaccent y -34\nKPX Tcommaaccent yacute -34\nKPX Tcommaaccent ydieresis -34\nKPX U A -60\nKPX U Aacute -60\nKPX U Abreve -60\nKPX U Acircumflex -60\nKPX U Adieresis -60\nKPX U Agrave -60\nKPX U Amacron -60\nKPX U Aogonek -60\nKPX U Aring -60\nKPX U Atilde -60\nKPX U comma -50\nKPX U period -50\nKPX Uacute A -60\nKPX Uacute Aacute -60\nKPX Uacute Abreve -60\nKPX Uacute Acircumflex -60\nKPX Uacute Adieresis -60\nKPX Uacute Agrave -60\nKPX Uacute Amacron -60\nKPX Uacute Aogonek -60\nKPX Uacute Aring -60\nKPX Uacute Atilde -60\nKPX Uacute comma -50\nKPX Uacute period -50\nKPX Ucircumflex A -60\nKPX Ucircumflex Aacute -60\nKPX Ucircumflex Abreve -60\nKPX Ucircumflex Acircumflex -60\nKPX Ucircumflex Adieresis -60\nKPX Ucircumflex Agrave -60\nKPX Ucircumflex Amacron -60\nKPX Ucircumflex Aogonek -60\nKPX Ucircumflex Aring -60\nKPX Ucircumflex Atilde -60\nKPX Ucircumflex comma -50\nKPX Ucircumflex period -50\nKPX Udieresis A -60\nKPX Udieresis Aacute -60\nKPX Udieresis Abreve -60\nKPX Udieresis Acircumflex -60\nKPX Udieresis Adieresis -60\nKPX Udieresis Agrave -60\nKPX Udieresis Amacron -60\nKPX Udieresis Aogonek -60\nKPX Udieresis Aring -60\nKPX Udieresis Atilde -60\nKPX Udieresis comma -50\nKPX Udieresis period -50\nKPX Ugrave A -60\nKPX Ugrave Aacute -60\nKPX Ugrave Abreve -60\nKPX Ugrave Acircumflex -60\nKPX Ugrave Adieresis -60\nKPX Ugrave Agrave -60\nKPX Ugrave Amacron -60\nKPX Ugrave Aogonek -60\nKPX Ugrave Aring -60\nKPX Ugrave Atilde -60\nKPX Ugrave comma -50\nKPX Ugrave period -50\nKPX Uhungarumlaut A -60\nKPX Uhungarumlaut Aacute -60\nKPX Uhungarumlaut Abreve -60\nKPX Uhungarumlaut Acircumflex -60\nKPX Uhungarumlaut Adieresis -60\nKPX Uhungarumlaut Agrave -60\nKPX Uhungarumlaut Amacron -60\nKPX Uhungarumlaut Aogonek -60\nKPX Uhungarumlaut Aring -60\nKPX Uhungarumlaut Atilde -60\nKPX Uhungarumlaut comma -50\nKPX Uhungarumlaut period -50\nKPX Umacron A -60\nKPX Umacron Aacute -60\nKPX Umacron Abreve -60\nKPX Umacron Acircumflex -60\nKPX Umacron Adieresis -60\nKPX Umacron Agrave -60\nKPX Umacron Amacron -60\nKPX Umacron Aogonek -60\nKPX Umacron Aring -60\nKPX Umacron Atilde -60\nKPX Umacron comma -50\nKPX Umacron period -50\nKPX Uogonek A -60\nKPX Uogonek Aacute -60\nKPX Uogonek Abreve -60\nKPX Uogonek Acircumflex -60\nKPX Uogonek Adieresis -60\nKPX Uogonek Agrave -60\nKPX Uogonek Amacron -60\nKPX Uogonek Aogonek -60\nKPX Uogonek Aring -60\nKPX Uogonek Atilde -60\nKPX Uogonek comma -50\nKPX Uogonek period -50\nKPX Uring A -60\nKPX Uring Aacute -60\nKPX Uring Abreve -60\nKPX Uring Acircumflex -60\nKPX Uring Adieresis -60\nKPX Uring Agrave -60\nKPX Uring Amacron -60\nKPX Uring Aogonek -60\nKPX Uring Aring -60\nKPX Uring Atilde -60\nKPX Uring comma -50\nKPX Uring period -50\nKPX V A -135\nKPX V Aacute -135\nKPX V Abreve -135\nKPX V Acircumflex -135\nKPX V Adieresis -135\nKPX V Agrave -135\nKPX V Amacron -135\nKPX V Aogonek -135\nKPX V Aring -135\nKPX V Atilde -135\nKPX V G -30\nKPX V Gbreve -30\nKPX V Gcommaaccent -30\nKPX V O -45\nKPX V Oacute -45\nKPX V Ocircumflex -45\nKPX V Odieresis -45\nKPX V Ograve -45\nKPX V Ohungarumlaut -45\nKPX V Omacron -45\nKPX V Oslash -45\nKPX V Otilde -45\nKPX V a -92\nKPX V aacute -92\nKPX V abreve -92\nKPX V acircumflex -92\nKPX V adieresis -92\nKPX V agrave -92\nKPX V amacron -92\nKPX V aogonek -92\nKPX V aring -92\nKPX V atilde -92\nKPX V colon -92\nKPX V comma -129\nKPX V e -100\nKPX V eacute -100\nKPX V ecaron -100\nKPX V ecircumflex -100\nKPX V edieresis -100\nKPX V edotaccent -100\nKPX V egrave -100\nKPX V emacron -100\nKPX V eogonek -100\nKPX V hyphen -74\nKPX V i -37\nKPX V iacute -37\nKPX V icircumflex -37\nKPX V idieresis -37\nKPX V igrave -37\nKPX V imacron -37\nKPX V iogonek -37\nKPX V o -100\nKPX V oacute -100\nKPX V ocircumflex -100\nKPX V odieresis -100\nKPX V ograve -100\nKPX V ohungarumlaut -100\nKPX V omacron -100\nKPX V oslash -100\nKPX V otilde -100\nKPX V period -145\nKPX V semicolon -92\nKPX V u -92\nKPX V uacute -92\nKPX V ucircumflex -92\nKPX V udieresis -92\nKPX V ugrave -92\nKPX V uhungarumlaut -92\nKPX V umacron -92\nKPX V uogonek -92\nKPX V uring -92\nKPX W A -120\nKPX W Aacute -120\nKPX W Abreve -120\nKPX W Acircumflex -120\nKPX W Adieresis -120\nKPX W Agrave -120\nKPX W Amacron -120\nKPX W Aogonek -120\nKPX W Aring -120\nKPX W Atilde -120\nKPX W O -10\nKPX W Oacute -10\nKPX W Ocircumflex -10\nKPX W Odieresis -10\nKPX W Ograve -10\nKPX W Ohungarumlaut -10\nKPX W Omacron -10\nKPX W Oslash -10\nKPX W Otilde -10\nKPX W a -65\nKPX W aacute -65\nKPX W abreve -65\nKPX W acircumflex -65\nKPX W adieresis -65\nKPX W agrave -65\nKPX W amacron -65\nKPX W aogonek -65\nKPX W aring -65\nKPX W atilde -65\nKPX W colon -55\nKPX W comma -92\nKPX W e -65\nKPX W eacute -65\nKPX W ecaron -65\nKPX W ecircumflex -65\nKPX W edieresis -65\nKPX W edotaccent -65\nKPX W egrave -65\nKPX W emacron -65\nKPX W eogonek -65\nKPX W hyphen -37\nKPX W i -18\nKPX W iacute -18\nKPX W iogonek -18\nKPX W o -75\nKPX W oacute -75\nKPX W ocircumflex -75\nKPX W odieresis -75\nKPX W ograve -75\nKPX W ohungarumlaut -75\nKPX W omacron -75\nKPX W oslash -75\nKPX W otilde -75\nKPX W period -92\nKPX W semicolon -55\nKPX W u -50\nKPX W uacute -50\nKPX W ucircumflex -50\nKPX W udieresis -50\nKPX W ugrave -50\nKPX W uhungarumlaut -50\nKPX W umacron -50\nKPX W uogonek -50\nKPX W uring -50\nKPX W y -60\nKPX W yacute -60\nKPX W ydieresis -60\nKPX Y A -110\nKPX Y Aacute -110\nKPX Y Abreve -110\nKPX Y Acircumflex -110\nKPX Y Adieresis -110\nKPX Y Agrave -110\nKPX Y Amacron -110\nKPX Y Aogonek -110\nKPX Y Aring -110\nKPX Y Atilde -110\nKPX Y O -35\nKPX Y Oacute -35\nKPX Y Ocircumflex -35\nKPX Y Odieresis -35\nKPX Y Ograve -35\nKPX Y Ohungarumlaut -35\nKPX Y Omacron -35\nKPX Y Oslash -35\nKPX Y Otilde -35\nKPX Y a -85\nKPX Y aacute -85\nKPX Y abreve -85\nKPX Y acircumflex -85\nKPX Y adieresis -85\nKPX Y agrave -85\nKPX Y amacron -85\nKPX Y aogonek -85\nKPX Y aring -85\nKPX Y atilde -85\nKPX Y colon -92\nKPX Y comma -92\nKPX Y e -111\nKPX Y eacute -111\nKPX Y ecaron -111\nKPX Y ecircumflex -111\nKPX Y edieresis -71\nKPX Y edotaccent -111\nKPX Y egrave -71\nKPX Y emacron -71\nKPX Y eogonek -111\nKPX Y hyphen -92\nKPX Y i -37\nKPX Y iacute -37\nKPX Y iogonek -37\nKPX Y o -111\nKPX Y oacute -111\nKPX Y ocircumflex -111\nKPX Y odieresis -111\nKPX Y ograve -111\nKPX Y ohungarumlaut -111\nKPX Y omacron -111\nKPX Y oslash -111\nKPX Y otilde -111\nKPX Y period -92\nKPX Y semicolon -92\nKPX Y u -92\nKPX Y uacute -92\nKPX Y ucircumflex -92\nKPX Y udieresis -92\nKPX Y ugrave -92\nKPX Y uhungarumlaut -92\nKPX Y umacron -92\nKPX Y uogonek -92\nKPX Y uring -92\nKPX Yacute A -110\nKPX Yacute Aacute -110\nKPX Yacute Abreve -110\nKPX Yacute Acircumflex -110\nKPX Yacute Adieresis -110\nKPX Yacute Agrave -110\nKPX Yacute Amacron -110\nKPX Yacute Aogonek -110\nKPX Yacute Aring -110\nKPX Yacute Atilde -110\nKPX Yacute O -35\nKPX Yacute Oacute -35\nKPX Yacute Ocircumflex -35\nKPX Yacute Odieresis -35\nKPX Yacute Ograve -35\nKPX Yacute Ohungarumlaut -35\nKPX Yacute Omacron -35\nKPX Yacute Oslash -35\nKPX Yacute Otilde -35\nKPX Yacute a -85\nKPX Yacute aacute -85\nKPX Yacute abreve -85\nKPX Yacute acircumflex -85\nKPX Yacute adieresis -85\nKPX Yacute agrave -85\nKPX Yacute amacron -85\nKPX Yacute aogonek -85\nKPX Yacute aring -85\nKPX Yacute atilde -85\nKPX Yacute colon -92\nKPX Yacute comma -92\nKPX Yacute e -111\nKPX Yacute eacute -111\nKPX Yacute ecaron -111\nKPX Yacute ecircumflex -111\nKPX Yacute edieresis -71\nKPX Yacute edotaccent -111\nKPX Yacute egrave -71\nKPX Yacute emacron -71\nKPX Yacute eogonek -111\nKPX Yacute hyphen -92\nKPX Yacute i -37\nKPX Yacute iacute -37\nKPX Yacute iogonek -37\nKPX Yacute o -111\nKPX Yacute oacute -111\nKPX Yacute ocircumflex -111\nKPX Yacute odieresis -111\nKPX Yacute ograve -111\nKPX Yacute ohungarumlaut -111\nKPX Yacute omacron -111\nKPX Yacute oslash -111\nKPX Yacute otilde -111\nKPX Yacute period -92\nKPX Yacute semicolon -92\nKPX Yacute u -92\nKPX Yacute uacute -92\nKPX Yacute ucircumflex -92\nKPX Yacute udieresis -92\nKPX Yacute ugrave -92\nKPX Yacute uhungarumlaut -92\nKPX Yacute umacron -92\nKPX Yacute uogonek -92\nKPX Yacute uring -92\nKPX Ydieresis A -110\nKPX Ydieresis Aacute -110\nKPX Ydieresis Abreve -110\nKPX Ydieresis Acircumflex -110\nKPX Ydieresis Adieresis -110\nKPX Ydieresis Agrave -110\nKPX Ydieresis Amacron -110\nKPX Ydieresis Aogonek -110\nKPX Ydieresis Aring -110\nKPX Ydieresis Atilde -110\nKPX Ydieresis O -35\nKPX Ydieresis Oacute -35\nKPX Ydieresis Ocircumflex -35\nKPX Ydieresis Odieresis -35\nKPX Ydieresis Ograve -35\nKPX Ydieresis Ohungarumlaut -35\nKPX Ydieresis Omacron -35\nKPX Ydieresis Oslash -35\nKPX Ydieresis Otilde -35\nKPX Ydieresis a -85\nKPX Ydieresis aacute -85\nKPX Ydieresis abreve -85\nKPX Ydieresis acircumflex -85\nKPX Ydieresis adieresis -85\nKPX Ydieresis agrave -85\nKPX Ydieresis amacron -85\nKPX Ydieresis aogonek -85\nKPX Ydieresis aring -85\nKPX Ydieresis atilde -85\nKPX Ydieresis colon -92\nKPX Ydieresis comma -92\nKPX Ydieresis e -111\nKPX Ydieresis eacute -111\nKPX Ydieresis ecaron -111\nKPX Ydieresis ecircumflex -111\nKPX Ydieresis edieresis -71\nKPX Ydieresis edotaccent -111\nKPX Ydieresis egrave -71\nKPX Ydieresis emacron -71\nKPX Ydieresis eogonek -111\nKPX Ydieresis hyphen -92\nKPX Ydieresis i -37\nKPX Ydieresis iacute -37\nKPX Ydieresis iogonek -37\nKPX Ydieresis o -111\nKPX Ydieresis oacute -111\nKPX Ydieresis ocircumflex -111\nKPX Ydieresis odieresis -111\nKPX Ydieresis ograve -111\nKPX Ydieresis ohungarumlaut -111\nKPX Ydieresis omacron -111\nKPX Ydieresis oslash -111\nKPX Ydieresis otilde -111\nKPX Ydieresis period -92\nKPX Ydieresis semicolon -92\nKPX Ydieresis u -92\nKPX Ydieresis uacute -92\nKPX Ydieresis ucircumflex -92\nKPX Ydieresis udieresis -92\nKPX Ydieresis ugrave -92\nKPX Ydieresis uhungarumlaut -92\nKPX Ydieresis umacron -92\nKPX Ydieresis uogonek -92\nKPX Ydieresis uring -92\nKPX a v -25\nKPX aacute v -25\nKPX abreve v -25\nKPX acircumflex v -25\nKPX adieresis v -25\nKPX agrave v -25\nKPX amacron v -25\nKPX aogonek v -25\nKPX aring v -25\nKPX atilde v -25\nKPX b b -10\nKPX b period -40\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX b v -15\nKPX comma quotedblright -45\nKPX comma quoteright -55\nKPX d w -15\nKPX dcroat w -15\nKPX e v -15\nKPX eacute v -15\nKPX ecaron v -15\nKPX ecircumflex v -15\nKPX edieresis v -15\nKPX edotaccent v -15\nKPX egrave v -15\nKPX emacron v -15\nKPX eogonek v -15\nKPX f comma -15\nKPX f dotlessi -35\nKPX f i -25\nKPX f o -25\nKPX f oacute -25\nKPX f ocircumflex -25\nKPX f odieresis -25\nKPX f ograve -25\nKPX f ohungarumlaut -25\nKPX f omacron -25\nKPX f oslash -25\nKPX f otilde -25\nKPX f period -15\nKPX f quotedblright 50\nKPX f quoteright 55\nKPX g period -15\nKPX gbreve period -15\nKPX gcommaaccent period -15\nKPX h y -15\nKPX h yacute -15\nKPX h ydieresis -15\nKPX i v -10\nKPX iacute v -10\nKPX icircumflex v -10\nKPX idieresis v -10\nKPX igrave v -10\nKPX imacron v -10\nKPX iogonek v -10\nKPX k e -10\nKPX k eacute -10\nKPX k ecaron -10\nKPX k ecircumflex -10\nKPX k edieresis -10\nKPX k edotaccent -10\nKPX k egrave -10\nKPX k emacron -10\nKPX k eogonek -10\nKPX k o -15\nKPX k oacute -15\nKPX k ocircumflex -15\nKPX k odieresis -15\nKPX k ograve -15\nKPX k ohungarumlaut -15\nKPX k omacron -15\nKPX k oslash -15\nKPX k otilde -15\nKPX k y -15\nKPX k yacute -15\nKPX k ydieresis -15\nKPX kcommaaccent e -10\nKPX kcommaaccent eacute -10\nKPX kcommaaccent ecaron -10\nKPX kcommaaccent ecircumflex -10\nKPX kcommaaccent edieresis -10\nKPX kcommaaccent edotaccent -10\nKPX kcommaaccent egrave -10\nKPX kcommaaccent emacron -10\nKPX kcommaaccent eogonek -10\nKPX kcommaaccent o -15\nKPX kcommaaccent oacute -15\nKPX kcommaaccent ocircumflex -15\nKPX kcommaaccent odieresis -15\nKPX kcommaaccent ograve -15\nKPX kcommaaccent ohungarumlaut -15\nKPX kcommaaccent omacron -15\nKPX kcommaaccent oslash -15\nKPX kcommaaccent otilde -15\nKPX kcommaaccent y -15\nKPX kcommaaccent yacute -15\nKPX kcommaaccent ydieresis -15\nKPX n v -40\nKPX nacute v -40\nKPX ncaron v -40\nKPX ncommaaccent v -40\nKPX ntilde v -40\nKPX o v -10\nKPX o w -10\nKPX oacute v -10\nKPX oacute w -10\nKPX ocircumflex v -10\nKPX ocircumflex w -10\nKPX odieresis v -10\nKPX odieresis w -10\nKPX ograve v -10\nKPX ograve w -10\nKPX ohungarumlaut v -10\nKPX ohungarumlaut w -10\nKPX omacron v -10\nKPX omacron w -10\nKPX oslash v -10\nKPX oslash w -10\nKPX otilde v -10\nKPX otilde w -10\nKPX period quotedblright -55\nKPX period quoteright -55\nKPX quotedblleft A -10\nKPX quotedblleft Aacute -10\nKPX quotedblleft Abreve -10\nKPX quotedblleft Acircumflex -10\nKPX quotedblleft Adieresis -10\nKPX quotedblleft Agrave -10\nKPX quotedblleft Amacron -10\nKPX quotedblleft Aogonek -10\nKPX quotedblleft Aring -10\nKPX quotedblleft Atilde -10\nKPX quoteleft A -10\nKPX quoteleft Aacute -10\nKPX quoteleft Abreve -10\nKPX quoteleft Acircumflex -10\nKPX quoteleft Adieresis -10\nKPX quoteleft Agrave -10\nKPX quoteleft Amacron -10\nKPX quoteleft Aogonek -10\nKPX quoteleft Aring -10\nKPX quoteleft Atilde -10\nKPX quoteleft quoteleft -63\nKPX quoteright d -20\nKPX quoteright dcroat -20\nKPX quoteright quoteright -63\nKPX quoteright r -20\nKPX quoteright racute -20\nKPX quoteright rcaron -20\nKPX quoteright rcommaaccent -20\nKPX quoteright s -37\nKPX quoteright sacute -37\nKPX quoteright scaron -37\nKPX quoteright scedilla -37\nKPX quoteright scommaaccent -37\nKPX quoteright space -74\nKPX quoteright v -20\nKPX r c -18\nKPX r cacute -18\nKPX r ccaron -18\nKPX r ccedilla -18\nKPX r comma -92\nKPX r e -18\nKPX r eacute -18\nKPX r ecaron -18\nKPX r ecircumflex -18\nKPX r edieresis -18\nKPX r edotaccent -18\nKPX r egrave -18\nKPX r emacron -18\nKPX r eogonek -18\nKPX r g -10\nKPX r gbreve -10\nKPX r gcommaaccent -10\nKPX r hyphen -37\nKPX r n -15\nKPX r nacute -15\nKPX r ncaron -15\nKPX r ncommaaccent -15\nKPX r ntilde -15\nKPX r o -18\nKPX r oacute -18\nKPX r ocircumflex -18\nKPX r odieresis -18\nKPX r ograve -18\nKPX r ohungarumlaut -18\nKPX r omacron -18\nKPX r oslash -18\nKPX r otilde -18\nKPX r p -10\nKPX r period -100\nKPX r q -18\nKPX r v -10\nKPX racute c -18\nKPX racute cacute -18\nKPX racute ccaron -18\nKPX racute ccedilla -18\nKPX racute comma -92\nKPX racute e -18\nKPX racute eacute -18\nKPX racute ecaron -18\nKPX racute ecircumflex -18\nKPX racute edieresis -18\nKPX racute edotaccent -18\nKPX racute egrave -18\nKPX racute emacron -18\nKPX racute eogonek -18\nKPX racute g -10\nKPX racute gbreve -10\nKPX racute gcommaaccent -10\nKPX racute hyphen -37\nKPX racute n -15\nKPX racute nacute -15\nKPX racute ncaron -15\nKPX racute ncommaaccent -15\nKPX racute ntilde -15\nKPX racute o -18\nKPX racute oacute -18\nKPX racute ocircumflex -18\nKPX racute odieresis -18\nKPX racute ograve -18\nKPX racute ohungarumlaut -18\nKPX racute omacron -18\nKPX racute oslash -18\nKPX racute otilde -18\nKPX racute p -10\nKPX racute period -100\nKPX racute q -18\nKPX racute v -10\nKPX rcaron c -18\nKPX rcaron cacute -18\nKPX rcaron ccaron -18\nKPX rcaron ccedilla -18\nKPX rcaron comma -92\nKPX rcaron e -18\nKPX rcaron eacute -18\nKPX rcaron ecaron -18\nKPX rcaron ecircumflex -18\nKPX rcaron edieresis -18\nKPX rcaron edotaccent -18\nKPX rcaron egrave -18\nKPX rcaron emacron -18\nKPX rcaron eogonek -18\nKPX rcaron g -10\nKPX rcaron gbreve -10\nKPX rcaron gcommaaccent -10\nKPX rcaron hyphen -37\nKPX rcaron n -15\nKPX rcaron nacute -15\nKPX rcaron ncaron -15\nKPX rcaron ncommaaccent -15\nKPX rcaron ntilde -15\nKPX rcaron o -18\nKPX rcaron oacute -18\nKPX rcaron ocircumflex -18\nKPX rcaron odieresis -18\nKPX rcaron ograve -18\nKPX rcaron ohungarumlaut -18\nKPX rcaron omacron -18\nKPX rcaron oslash -18\nKPX rcaron otilde -18\nKPX rcaron p -10\nKPX rcaron period -100\nKPX rcaron q -18\nKPX rcaron v -10\nKPX rcommaaccent c -18\nKPX rcommaaccent cacute -18\nKPX rcommaaccent ccaron -18\nKPX rcommaaccent ccedilla -18\nKPX rcommaaccent comma -92\nKPX rcommaaccent e -18\nKPX rcommaaccent eacute -18\nKPX rcommaaccent ecaron -18\nKPX rcommaaccent ecircumflex -18\nKPX rcommaaccent edieresis -18\nKPX rcommaaccent edotaccent -18\nKPX rcommaaccent egrave -18\nKPX rcommaaccent emacron -18\nKPX rcommaaccent eogonek -18\nKPX rcommaaccent g -10\nKPX rcommaaccent gbreve -10\nKPX rcommaaccent gcommaaccent -10\nKPX rcommaaccent hyphen -37\nKPX rcommaaccent n -15\nKPX rcommaaccent nacute -15\nKPX rcommaaccent ncaron -15\nKPX rcommaaccent ncommaaccent -15\nKPX rcommaaccent ntilde -15\nKPX rcommaaccent o -18\nKPX rcommaaccent oacute -18\nKPX rcommaaccent ocircumflex -18\nKPX rcommaaccent odieresis -18\nKPX rcommaaccent ograve -18\nKPX rcommaaccent ohungarumlaut -18\nKPX rcommaaccent omacron -18\nKPX rcommaaccent oslash -18\nKPX rcommaaccent otilde -18\nKPX rcommaaccent p -10\nKPX rcommaaccent period -100\nKPX rcommaaccent q -18\nKPX rcommaaccent v -10\nKPX space A -55\nKPX space Aacute -55\nKPX space Abreve -55\nKPX space Acircumflex -55\nKPX space Adieresis -55\nKPX space Agrave -55\nKPX space Amacron -55\nKPX space Aogonek -55\nKPX space Aring -55\nKPX space Atilde -55\nKPX space T -30\nKPX space Tcaron -30\nKPX space Tcommaaccent -30\nKPX space V -45\nKPX space W -30\nKPX space Y -55\nKPX space Yacute -55\nKPX space Ydieresis -55\nKPX v a -10\nKPX v aacute -10\nKPX v abreve -10\nKPX v acircumflex -10\nKPX v adieresis -10\nKPX v agrave -10\nKPX v amacron -10\nKPX v aogonek -10\nKPX v aring -10\nKPX v atilde -10\nKPX v comma -55\nKPX v e -10\nKPX v eacute -10\nKPX v ecaron -10\nKPX v ecircumflex -10\nKPX v edieresis -10\nKPX v edotaccent -10\nKPX v egrave -10\nKPX v emacron -10\nKPX v eogonek -10\nKPX v o -10\nKPX v oacute -10\nKPX v ocircumflex -10\nKPX v odieresis -10\nKPX v ograve -10\nKPX v ohungarumlaut -10\nKPX v omacron -10\nKPX v oslash -10\nKPX v otilde -10\nKPX v period -70\nKPX w comma -55\nKPX w o -10\nKPX w oacute -10\nKPX w ocircumflex -10\nKPX w odieresis -10\nKPX w ograve -10\nKPX w ohungarumlaut -10\nKPX w omacron -10\nKPX w oslash -10\nKPX w otilde -10\nKPX w period -70\nKPX y comma -55\nKPX y e -10\nKPX y eacute -10\nKPX y ecaron -10\nKPX y ecircumflex -10\nKPX y edieresis -10\nKPX y edotaccent -10\nKPX y egrave -10\nKPX y emacron -10\nKPX y eogonek -10\nKPX y o -25\nKPX y oacute -25\nKPX y ocircumflex -25\nKPX y odieresis -25\nKPX y ograve -25\nKPX y ohungarumlaut -25\nKPX y omacron -25\nKPX y oslash -25\nKPX y otilde -25\nKPX y period -70\nKPX yacute comma -55\nKPX yacute e -10\nKPX yacute eacute -10\nKPX yacute ecaron -10\nKPX yacute ecircumflex -10\nKPX yacute edieresis -10\nKPX yacute edotaccent -10\nKPX yacute egrave -10\nKPX yacute emacron -10\nKPX yacute eogonek -10\nKPX yacute o -25\nKPX yacute oacute -25\nKPX yacute ocircumflex -25\nKPX yacute odieresis -25\nKPX yacute ograve -25\nKPX yacute ohungarumlaut -25\nKPX yacute omacron -25\nKPX yacute oslash -25\nKPX yacute otilde -25\nKPX yacute period -70\nKPX ydieresis comma -55\nKPX ydieresis e -10\nKPX ydieresis eacute -10\nKPX ydieresis ecaron -10\nKPX ydieresis ecircumflex -10\nKPX ydieresis edieresis -10\nKPX ydieresis edotaccent -10\nKPX ydieresis egrave -10\nKPX ydieresis emacron -10\nKPX ydieresis eogonek -10\nKPX ydieresis o -25\nKPX ydieresis oacute -25\nKPX ydieresis ocircumflex -25\nKPX ydieresis odieresis -25\nKPX ydieresis ograve -25\nKPX ydieresis ohungarumlaut -25\nKPX ydieresis omacron -25\nKPX ydieresis oslash -25\nKPX ydieresis otilde -25\nKPX ydieresis period -70\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    'Times-Italic' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 12:56:55 1997\nComment UniqueID 43067\nComment VMusage 47727 58752\nFontName Times-Italic\nFullName Times Italic\nFamilyName Times\nWeight Medium\nItalicAngle -15.5\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -169 -217 1010 883 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 653\nXHeight 441\nAscender 683\nDescender -217\nStdHW 32\nStdVW 76\nStartCharMetrics 315\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 333 ; N exclam ; B 39 -11 302 667 ;\nC 34 ; WX 420 ; N quotedbl ; B 144 421 432 666 ;\nC 35 ; WX 500 ; N numbersign ; B 2 0 540 676 ;\nC 36 ; WX 500 ; N dollar ; B 31 -89 497 731 ;\nC 37 ; WX 833 ; N percent ; B 79 -13 790 676 ;\nC 38 ; WX 778 ; N ampersand ; B 76 -18 723 666 ;\nC 39 ; WX 333 ; N quoteright ; B 151 436 290 666 ;\nC 40 ; WX 333 ; N parenleft ; B 42 -181 315 669 ;\nC 41 ; WX 333 ; N parenright ; B 16 -180 289 669 ;\nC 42 ; WX 500 ; N asterisk ; B 128 255 492 666 ;\nC 43 ; WX 675 ; N plus ; B 86 0 590 506 ;\nC 44 ; WX 250 ; N comma ; B -4 -129 135 101 ;\nC 45 ; WX 333 ; N hyphen ; B 49 192 282 255 ;\nC 46 ; WX 250 ; N period ; B 27 -11 138 100 ;\nC 47 ; WX 278 ; N slash ; B -65 -18 386 666 ;\nC 48 ; WX 500 ; N zero ; B 32 -7 497 676 ;\nC 49 ; WX 500 ; N one ; B 49 0 409 676 ;\nC 50 ; WX 500 ; N two ; B 12 0 452 676 ;\nC 51 ; WX 500 ; N three ; B 15 -7 465 676 ;\nC 52 ; WX 500 ; N four ; B 1 0 479 676 ;\nC 53 ; WX 500 ; N five ; B 15 -7 491 666 ;\nC 54 ; WX 500 ; N six ; B 30 -7 521 686 ;\nC 55 ; WX 500 ; N seven ; B 75 -8 537 666 ;\nC 56 ; WX 500 ; N eight ; B 30 -7 493 676 ;\nC 57 ; WX 500 ; N nine ; B 23 -17 492 676 ;\nC 58 ; WX 333 ; N colon ; B 50 -11 261 441 ;\nC 59 ; WX 333 ; N semicolon ; B 27 -129 261 441 ;\nC 60 ; WX 675 ; N less ; B 84 -8 592 514 ;\nC 61 ; WX 675 ; N equal ; B 86 120 590 386 ;\nC 62 ; WX 675 ; N greater ; B 84 -8 592 514 ;\nC 63 ; WX 500 ; N question ; B 132 -12 472 664 ;\nC 64 ; WX 920 ; N at ; B 118 -18 806 666 ;\nC 65 ; WX 611 ; N A ; B -51 0 564 668 ;\nC 66 ; WX 611 ; N B ; B -8 0 588 653 ;\nC 67 ; WX 667 ; N C ; B 66 -18 689 666 ;\nC 68 ; WX 722 ; N D ; B -8 0 700 653 ;\nC 69 ; WX 611 ; N E ; B -1 0 634 653 ;\nC 70 ; WX 611 ; N F ; B 8 0 645 653 ;\nC 71 ; WX 722 ; N G ; B 52 -18 722 666 ;\nC 72 ; WX 722 ; N H ; B -8 0 767 653 ;\nC 73 ; WX 333 ; N I ; B -8 0 384 653 ;\nC 74 ; WX 444 ; N J ; B -6 -18 491 653 ;\nC 75 ; WX 667 ; N K ; B 7 0 722 653 ;\nC 76 ; WX 556 ; N L ; B -8 0 559 653 ;\nC 77 ; WX 833 ; N M ; B -18 0 873 653 ;\nC 78 ; WX 667 ; N N ; B -20 -15 727 653 ;\nC 79 ; WX 722 ; N O ; B 60 -18 699 666 ;\nC 80 ; WX 611 ; N P ; B 0 0 605 653 ;\nC 81 ; WX 722 ; N Q ; B 59 -182 699 666 ;\nC 82 ; WX 611 ; N R ; B -13 0 588 653 ;\nC 83 ; WX 500 ; N S ; B 17 -18 508 667 ;\nC 84 ; WX 556 ; N T ; B 59 0 633 653 ;\nC 85 ; WX 722 ; N U ; B 102 -18 765 653 ;\nC 86 ; WX 611 ; N V ; B 76 -18 688 653 ;\nC 87 ; WX 833 ; N W ; B 71 -18 906 653 ;\nC 88 ; WX 611 ; N X ; B -29 0 655 653 ;\nC 89 ; WX 556 ; N Y ; B 78 0 633 653 ;\nC 90 ; WX 556 ; N Z ; B -6 0 606 653 ;\nC 91 ; WX 389 ; N bracketleft ; B 21 -153 391 663 ;\nC 92 ; WX 278 ; N backslash ; B -41 -18 319 666 ;\nC 93 ; WX 389 ; N bracketright ; B 12 -153 382 663 ;\nC 94 ; WX 422 ; N asciicircum ; B 0 301 422 666 ;\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\nC 96 ; WX 333 ; N quoteleft ; B 171 436 310 666 ;\nC 97 ; WX 500 ; N a ; B 17 -11 476 441 ;\nC 98 ; WX 500 ; N b ; B 23 -11 473 683 ;\nC 99 ; WX 444 ; N c ; B 30 -11 425 441 ;\nC 100 ; WX 500 ; N d ; B 15 -13 527 683 ;\nC 101 ; WX 444 ; N e ; B 31 -11 412 441 ;\nC 102 ; WX 278 ; N f ; B -147 -207 424 678 ; L i fi ; L l fl ;\nC 103 ; WX 500 ; N g ; B 8 -206 472 441 ;\nC 104 ; WX 500 ; N h ; B 19 -9 478 683 ;\nC 105 ; WX 278 ; N i ; B 49 -11 264 654 ;\nC 106 ; WX 278 ; N j ; B -124 -207 276 654 ;\nC 107 ; WX 444 ; N k ; B 14 -11 461 683 ;\nC 108 ; WX 278 ; N l ; B 41 -11 279 683 ;\nC 109 ; WX 722 ; N m ; B 12 -9 704 441 ;\nC 110 ; WX 500 ; N n ; B 14 -9 474 441 ;\nC 111 ; WX 500 ; N o ; B 27 -11 468 441 ;\nC 112 ; WX 500 ; N p ; B -75 -205 469 441 ;\nC 113 ; WX 500 ; N q ; B 25 -209 483 441 ;\nC 114 ; WX 389 ; N r ; B 45 0 412 441 ;\nC 115 ; WX 389 ; N s ; B 16 -13 366 442 ;\nC 116 ; WX 278 ; N t ; B 37 -11 296 546 ;\nC 117 ; WX 500 ; N u ; B 42 -11 475 441 ;\nC 118 ; WX 444 ; N v ; B 21 -18 426 441 ;\nC 119 ; WX 667 ; N w ; B 16 -18 648 441 ;\nC 120 ; WX 444 ; N x ; B -27 -11 447 441 ;\nC 121 ; WX 444 ; N y ; B -24 -206 426 441 ;\nC 122 ; WX 389 ; N z ; B -2 -81 380 428 ;\nC 123 ; WX 400 ; N braceleft ; B 51 -177 407 687 ;\nC 124 ; WX 275 ; N bar ; B 105 -217 171 783 ;\nC 125 ; WX 400 ; N braceright ; B -7 -177 349 687 ;\nC 126 ; WX 541 ; N asciitilde ; B 40 183 502 323 ;\nC 161 ; WX 389 ; N exclamdown ; B 59 -205 322 473 ;\nC 162 ; WX 500 ; N cent ; B 77 -143 472 560 ;\nC 163 ; WX 500 ; N sterling ; B 10 -6 517 670 ;\nC 164 ; WX 167 ; N fraction ; B -169 -10 337 676 ;\nC 165 ; WX 500 ; N yen ; B 27 0 603 653 ;\nC 166 ; WX 500 ; N florin ; B 25 -182 507 682 ;\nC 167 ; WX 500 ; N section ; B 53 -162 461 666 ;\nC 168 ; WX 500 ; N currency ; B -22 53 522 597 ;\nC 169 ; WX 214 ; N quotesingle ; B 132 421 241 666 ;\nC 170 ; WX 556 ; N quotedblleft ; B 166 436 514 666 ;\nC 171 ; WX 500 ; N guillemotleft ; B 53 37 445 403 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 51 37 281 403 ;\nC 173 ; WX 333 ; N guilsinglright ; B 52 37 282 403 ;\nC 174 ; WX 500 ; N fi ; B -141 -207 481 681 ;\nC 175 ; WX 500 ; N fl ; B -141 -204 518 682 ;\nC 177 ; WX 500 ; N endash ; B -6 197 505 243 ;\nC 178 ; WX 500 ; N dagger ; B 101 -159 488 666 ;\nC 179 ; WX 500 ; N daggerdbl ; B 22 -143 491 666 ;\nC 180 ; WX 250 ; N periodcentered ; B 70 199 181 310 ;\nC 182 ; WX 523 ; N paragraph ; B 55 -123 616 653 ;\nC 183 ; WX 350 ; N bullet ; B 40 191 310 461 ;\nC 184 ; WX 333 ; N quotesinglbase ; B 44 -129 183 101 ;\nC 185 ; WX 556 ; N quotedblbase ; B 57 -129 405 101 ;\nC 186 ; WX 556 ; N quotedblright ; B 151 436 499 666 ;\nC 187 ; WX 500 ; N guillemotright ; B 55 37 447 403 ;\nC 188 ; WX 889 ; N ellipsis ; B 57 -11 762 100 ;\nC 189 ; WX 1000 ; N perthousand ; B 25 -19 1010 706 ;\nC 191 ; WX 500 ; N questiondown ; B 28 -205 368 471 ;\nC 193 ; WX 333 ; N grave ; B 121 492 311 664 ;\nC 194 ; WX 333 ; N acute ; B 180 494 403 664 ;\nC 195 ; WX 333 ; N circumflex ; B 91 492 385 661 ;\nC 196 ; WX 333 ; N tilde ; B 100 517 427 624 ;\nC 197 ; WX 333 ; N macron ; B 99 532 411 583 ;\nC 198 ; WX 333 ; N breve ; B 117 492 418 650 ;\nC 199 ; WX 333 ; N dotaccent ; B 207 548 305 646 ;\nC 200 ; WX 333 ; N dieresis ; B 107 548 405 646 ;\nC 202 ; WX 333 ; N ring ; B 155 492 355 691 ;\nC 203 ; WX 333 ; N cedilla ; B -30 -217 182 0 ;\nC 205 ; WX 333 ; N hungarumlaut ; B 93 494 486 664 ;\nC 206 ; WX 333 ; N ogonek ; B 20 -169 203 40 ;\nC 207 ; WX 333 ; N caron ; B 121 492 426 661 ;\nC 208 ; WX 889 ; N emdash ; B -6 197 894 243 ;\nC 225 ; WX 889 ; N AE ; B -27 0 911 653 ;\nC 227 ; WX 276 ; N ordfeminine ; B 42 406 352 676 ;\nC 232 ; WX 556 ; N Lslash ; B -8 0 559 653 ;\nC 233 ; WX 722 ; N Oslash ; B 60 -105 699 722 ;\nC 234 ; WX 944 ; N OE ; B 49 -8 964 666 ;\nC 235 ; WX 310 ; N ordmasculine ; B 67 406 362 676 ;\nC 241 ; WX 667 ; N ae ; B 23 -11 640 441 ;\nC 245 ; WX 278 ; N dotlessi ; B 49 -11 235 441 ;\nC 248 ; WX 278 ; N lslash ; B 41 -11 312 683 ;\nC 249 ; WX 500 ; N oslash ; B 28 -135 469 554 ;\nC 250 ; WX 667 ; N oe ; B 20 -12 646 441 ;\nC 251 ; WX 500 ; N germandbls ; B -168 -207 493 679 ;\nC -1 ; WX 333 ; N Idieresis ; B -8 0 435 818 ;\nC -1 ; WX 444 ; N eacute ; B 31 -11 459 664 ;\nC -1 ; WX 500 ; N abreve ; B 17 -11 502 650 ;\nC -1 ; WX 500 ; N uhungarumlaut ; B 42 -11 580 664 ;\nC -1 ; WX 444 ; N ecaron ; B 31 -11 482 661 ;\nC -1 ; WX 556 ; N Ydieresis ; B 78 0 633 818 ;\nC -1 ; WX 675 ; N divide ; B 86 -11 590 517 ;\nC -1 ; WX 556 ; N Yacute ; B 78 0 633 876 ;\nC -1 ; WX 611 ; N Acircumflex ; B -51 0 564 873 ;\nC -1 ; WX 500 ; N aacute ; B 17 -11 487 664 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 102 -18 765 873 ;\nC -1 ; WX 444 ; N yacute ; B -24 -206 459 664 ;\nC -1 ; WX 389 ; N scommaaccent ; B 16 -217 366 442 ;\nC -1 ; WX 444 ; N ecircumflex ; B 31 -11 441 661 ;\nC -1 ; WX 722 ; N Uring ; B 102 -18 765 883 ;\nC -1 ; WX 722 ; N Udieresis ; B 102 -18 765 818 ;\nC -1 ; WX 500 ; N aogonek ; B 17 -169 476 441 ;\nC -1 ; WX 722 ; N Uacute ; B 102 -18 765 876 ;\nC -1 ; WX 500 ; N uogonek ; B 42 -169 477 441 ;\nC -1 ; WX 611 ; N Edieresis ; B -1 0 634 818 ;\nC -1 ; WX 722 ; N Dcroat ; B -8 0 700 653 ;\nC -1 ; WX 250 ; N commaaccent ; B 8 -217 133 -50 ;\nC -1 ; WX 760 ; N copyright ; B 41 -18 719 666 ;\nC -1 ; WX 611 ; N Emacron ; B -1 0 634 795 ;\nC -1 ; WX 444 ; N ccaron ; B 30 -11 482 661 ;\nC -1 ; WX 500 ; N aring ; B 17 -11 476 691 ;\nC -1 ; WX 667 ; N Ncommaaccent ; B -20 -187 727 653 ;\nC -1 ; WX 278 ; N lacute ; B 41 -11 395 876 ;\nC -1 ; WX 500 ; N agrave ; B 17 -11 476 664 ;\nC -1 ; WX 556 ; N Tcommaaccent ; B 59 -217 633 653 ;\nC -1 ; WX 667 ; N Cacute ; B 66 -18 690 876 ;\nC -1 ; WX 500 ; N atilde ; B 17 -11 511 624 ;\nC -1 ; WX 611 ; N Edotaccent ; B -1 0 634 818 ;\nC -1 ; WX 389 ; N scaron ; B 16 -13 454 661 ;\nC -1 ; WX 389 ; N scedilla ; B 16 -217 366 442 ;\nC -1 ; WX 278 ; N iacute ; B 49 -11 355 664 ;\nC -1 ; WX 471 ; N lozenge ; B 13 0 459 724 ;\nC -1 ; WX 611 ; N Rcaron ; B -13 0 588 873 ;\nC -1 ; WX 722 ; N Gcommaaccent ; B 52 -217 722 666 ;\nC -1 ; WX 500 ; N ucircumflex ; B 42 -11 475 661 ;\nC -1 ; WX 500 ; N acircumflex ; B 17 -11 476 661 ;\nC -1 ; WX 611 ; N Amacron ; B -51 0 564 795 ;\nC -1 ; WX 389 ; N rcaron ; B 45 0 434 661 ;\nC -1 ; WX 444 ; N ccedilla ; B 30 -217 425 441 ;\nC -1 ; WX 556 ; N Zdotaccent ; B -6 0 606 818 ;\nC -1 ; WX 611 ; N Thorn ; B 0 0 569 653 ;\nC -1 ; WX 722 ; N Omacron ; B 60 -18 699 795 ;\nC -1 ; WX 611 ; N Racute ; B -13 0 588 876 ;\nC -1 ; WX 500 ; N Sacute ; B 17 -18 508 876 ;\nC -1 ; WX 544 ; N dcaron ; B 15 -13 658 683 ;\nC -1 ; WX 722 ; N Umacron ; B 102 -18 765 795 ;\nC -1 ; WX 500 ; N uring ; B 42 -11 475 691 ;\nC -1 ; WX 300 ; N threesuperior ; B 43 268 339 676 ;\nC -1 ; WX 722 ; N Ograve ; B 60 -18 699 876 ;\nC -1 ; WX 611 ; N Agrave ; B -51 0 564 876 ;\nC -1 ; WX 611 ; N Abreve ; B -51 0 564 862 ;\nC -1 ; WX 675 ; N multiply ; B 93 8 582 497 ;\nC -1 ; WX 500 ; N uacute ; B 42 -11 477 664 ;\nC -1 ; WX 556 ; N Tcaron ; B 59 0 633 873 ;\nC -1 ; WX 476 ; N partialdiff ; B 17 -38 459 710 ;\nC -1 ; WX 444 ; N ydieresis ; B -24 -206 441 606 ;\nC -1 ; WX 667 ; N Nacute ; B -20 -15 727 876 ;\nC -1 ; WX 278 ; N icircumflex ; B 33 -11 327 661 ;\nC -1 ; WX 611 ; N Ecircumflex ; B -1 0 634 873 ;\nC -1 ; WX 500 ; N adieresis ; B 17 -11 489 606 ;\nC -1 ; WX 444 ; N edieresis ; B 31 -11 451 606 ;\nC -1 ; WX 444 ; N cacute ; B 30 -11 459 664 ;\nC -1 ; WX 500 ; N nacute ; B 14 -9 477 664 ;\nC -1 ; WX 500 ; N umacron ; B 42 -11 485 583 ;\nC -1 ; WX 667 ; N Ncaron ; B -20 -15 727 873 ;\nC -1 ; WX 333 ; N Iacute ; B -8 0 433 876 ;\nC -1 ; WX 675 ; N plusminus ; B 86 0 590 506 ;\nC -1 ; WX 275 ; N brokenbar ; B 105 -142 171 708 ;\nC -1 ; WX 760 ; N registered ; B 41 -18 719 666 ;\nC -1 ; WX 722 ; N Gbreve ; B 52 -18 722 862 ;\nC -1 ; WX 333 ; N Idotaccent ; B -8 0 384 818 ;\nC -1 ; WX 600 ; N summation ; B 15 -10 585 706 ;\nC -1 ; WX 611 ; N Egrave ; B -1 0 634 876 ;\nC -1 ; WX 389 ; N racute ; B 45 0 431 664 ;\nC -1 ; WX 500 ; N omacron ; B 27 -11 495 583 ;\nC -1 ; WX 556 ; N Zacute ; B -6 0 606 876 ;\nC -1 ; WX 556 ; N Zcaron ; B -6 0 606 873 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 658 ;\nC -1 ; WX 722 ; N Eth ; B -8 0 700 653 ;\nC -1 ; WX 667 ; N Ccedilla ; B 66 -217 689 666 ;\nC -1 ; WX 278 ; N lcommaaccent ; B 22 -217 279 683 ;\nC -1 ; WX 300 ; N tcaron ; B 37 -11 407 681 ;\nC -1 ; WX 444 ; N eogonek ; B 31 -169 412 441 ;\nC -1 ; WX 722 ; N Uogonek ; B 102 -184 765 653 ;\nC -1 ; WX 611 ; N Aacute ; B -51 0 564 876 ;\nC -1 ; WX 611 ; N Adieresis ; B -51 0 564 818 ;\nC -1 ; WX 444 ; N egrave ; B 31 -11 412 664 ;\nC -1 ; WX 389 ; N zacute ; B -2 -81 431 664 ;\nC -1 ; WX 278 ; N iogonek ; B 49 -169 264 654 ;\nC -1 ; WX 722 ; N Oacute ; B 60 -18 699 876 ;\nC -1 ; WX 500 ; N oacute ; B 27 -11 487 664 ;\nC -1 ; WX 500 ; N amacron ; B 17 -11 495 583 ;\nC -1 ; WX 389 ; N sacute ; B 16 -13 431 664 ;\nC -1 ; WX 278 ; N idieresis ; B 49 -11 352 606 ;\nC -1 ; WX 722 ; N Ocircumflex ; B 60 -18 699 873 ;\nC -1 ; WX 722 ; N Ugrave ; B 102 -18 765 876 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 500 ; N thorn ; B -75 -205 469 683 ;\nC -1 ; WX 300 ; N twosuperior ; B 33 271 324 676 ;\nC -1 ; WX 722 ; N Odieresis ; B 60 -18 699 818 ;\nC -1 ; WX 500 ; N mu ; B -30 -209 497 428 ;\nC -1 ; WX 278 ; N igrave ; B 49 -11 284 664 ;\nC -1 ; WX 500 ; N ohungarumlaut ; B 27 -11 590 664 ;\nC -1 ; WX 611 ; N Eogonek ; B -1 -169 634 653 ;\nC -1 ; WX 500 ; N dcroat ; B 15 -13 572 683 ;\nC -1 ; WX 750 ; N threequarters ; B 23 -10 736 676 ;\nC -1 ; WX 500 ; N Scedilla ; B 17 -217 508 667 ;\nC -1 ; WX 300 ; N lcaron ; B 41 -11 407 683 ;\nC -1 ; WX 667 ; N Kcommaaccent ; B 7 -217 722 653 ;\nC -1 ; WX 556 ; N Lacute ; B -8 0 559 876 ;\nC -1 ; WX 980 ; N trademark ; B 30 247 957 653 ;\nC -1 ; WX 444 ; N edotaccent ; B 31 -11 412 606 ;\nC -1 ; WX 333 ; N Igrave ; B -8 0 384 876 ;\nC -1 ; WX 333 ; N Imacron ; B -8 0 441 795 ;\nC -1 ; WX 611 ; N Lcaron ; B -8 0 586 653 ;\nC -1 ; WX 750 ; N onehalf ; B 34 -10 749 676 ;\nC -1 ; WX 549 ; N lessequal ; B 26 0 523 658 ;\nC -1 ; WX 500 ; N ocircumflex ; B 27 -11 468 661 ;\nC -1 ; WX 500 ; N ntilde ; B 14 -9 476 624 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 102 -18 765 876 ;\nC -1 ; WX 611 ; N Eacute ; B -1 0 634 876 ;\nC -1 ; WX 444 ; N emacron ; B 31 -11 457 583 ;\nC -1 ; WX 500 ; N gbreve ; B 8 -206 487 650 ;\nC -1 ; WX 750 ; N onequarter ; B 33 -10 736 676 ;\nC -1 ; WX 500 ; N Scaron ; B 17 -18 520 873 ;\nC -1 ; WX 500 ; N Scommaaccent ; B 17 -217 508 667 ;\nC -1 ; WX 722 ; N Ohungarumlaut ; B 60 -18 699 876 ;\nC -1 ; WX 400 ; N degree ; B 101 390 387 676 ;\nC -1 ; WX 500 ; N ograve ; B 27 -11 468 664 ;\nC -1 ; WX 667 ; N Ccaron ; B 66 -18 689 873 ;\nC -1 ; WX 500 ; N ugrave ; B 42 -11 475 664 ;\nC -1 ; WX 453 ; N radical ; B 2 -60 452 768 ;\nC -1 ; WX 722 ; N Dcaron ; B -8 0 700 873 ;\nC -1 ; WX 389 ; N rcommaaccent ; B -3 -217 412 441 ;\nC -1 ; WX 667 ; N Ntilde ; B -20 -15 727 836 ;\nC -1 ; WX 500 ; N otilde ; B 27 -11 496 624 ;\nC -1 ; WX 611 ; N Rcommaaccent ; B -13 -187 588 653 ;\nC -1 ; WX 556 ; N Lcommaaccent ; B -8 -217 559 653 ;\nC -1 ; WX 611 ; N Atilde ; B -51 0 566 836 ;\nC -1 ; WX 611 ; N Aogonek ; B -51 -169 566 668 ;\nC -1 ; WX 611 ; N Aring ; B -51 0 564 883 ;\nC -1 ; WX 722 ; N Otilde ; B 60 -18 699 836 ;\nC -1 ; WX 389 ; N zdotaccent ; B -2 -81 380 606 ;\nC -1 ; WX 611 ; N Ecaron ; B -1 0 634 873 ;\nC -1 ; WX 333 ; N Iogonek ; B -8 -169 384 653 ;\nC -1 ; WX 444 ; N kcommaaccent ; B 14 -187 461 683 ;\nC -1 ; WX 675 ; N minus ; B 86 220 590 286 ;\nC -1 ; WX 333 ; N Icircumflex ; B -8 0 425 873 ;\nC -1 ; WX 500 ; N ncaron ; B 14 -9 510 661 ;\nC -1 ; WX 278 ; N tcommaaccent ; B 2 -217 296 546 ;\nC -1 ; WX 675 ; N logicalnot ; B 86 108 590 386 ;\nC -1 ; WX 500 ; N odieresis ; B 27 -11 489 606 ;\nC -1 ; WX 500 ; N udieresis ; B 42 -11 479 606 ;\nC -1 ; WX 549 ; N notequal ; B 12 -29 537 541 ;\nC -1 ; WX 500 ; N gcommaaccent ; B 8 -206 472 706 ;\nC -1 ; WX 500 ; N eth ; B 27 -11 482 683 ;\nC -1 ; WX 389 ; N zcaron ; B -2 -81 434 661 ;\nC -1 ; WX 500 ; N ncommaaccent ; B 14 -187 474 441 ;\nC -1 ; WX 300 ; N onesuperior ; B 43 271 284 676 ;\nC -1 ; WX 278 ; N imacron ; B 46 -11 311 583 ;\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2321\nKPX A C -30\nKPX A Cacute -30\nKPX A Ccaron -30\nKPX A Ccedilla -30\nKPX A G -35\nKPX A Gbreve -35\nKPX A Gcommaaccent -35\nKPX A O -40\nKPX A Oacute -40\nKPX A Ocircumflex -40\nKPX A Odieresis -40\nKPX A Ograve -40\nKPX A Ohungarumlaut -40\nKPX A Omacron -40\nKPX A Oslash -40\nKPX A Otilde -40\nKPX A Q -40\nKPX A T -37\nKPX A Tcaron -37\nKPX A Tcommaaccent -37\nKPX A U -50\nKPX A Uacute -50\nKPX A Ucircumflex -50\nKPX A Udieresis -50\nKPX A Ugrave -50\nKPX A Uhungarumlaut -50\nKPX A Umacron -50\nKPX A Uogonek -50\nKPX A Uring -50\nKPX A V -105\nKPX A W -95\nKPX A Y -55\nKPX A Yacute -55\nKPX A Ydieresis -55\nKPX A quoteright -37\nKPX A u -20\nKPX A uacute -20\nKPX A ucircumflex -20\nKPX A udieresis -20\nKPX A ugrave -20\nKPX A uhungarumlaut -20\nKPX A umacron -20\nKPX A uogonek -20\nKPX A uring -20\nKPX A v -55\nKPX A w -55\nKPX A y -55\nKPX A yacute -55\nKPX A ydieresis -55\nKPX Aacute C -30\nKPX Aacute Cacute -30\nKPX Aacute Ccaron -30\nKPX Aacute Ccedilla -30\nKPX Aacute G -35\nKPX Aacute Gbreve -35\nKPX Aacute Gcommaaccent -35\nKPX Aacute O -40\nKPX Aacute Oacute -40\nKPX Aacute Ocircumflex -40\nKPX Aacute Odieresis -40\nKPX Aacute Ograve -40\nKPX Aacute Ohungarumlaut -40\nKPX Aacute Omacron -40\nKPX Aacute Oslash -40\nKPX Aacute Otilde -40\nKPX Aacute Q -40\nKPX Aacute T -37\nKPX Aacute Tcaron -37\nKPX Aacute Tcommaaccent -37\nKPX Aacute U -50\nKPX Aacute Uacute -50\nKPX Aacute Ucircumflex -50\nKPX Aacute Udieresis -50\nKPX Aacute Ugrave -50\nKPX Aacute Uhungarumlaut -50\nKPX Aacute Umacron -50\nKPX Aacute Uogonek -50\nKPX Aacute Uring -50\nKPX Aacute V -105\nKPX Aacute W -95\nKPX Aacute Y -55\nKPX Aacute Yacute -55\nKPX Aacute Ydieresis -55\nKPX Aacute quoteright -37\nKPX Aacute u -20\nKPX Aacute uacute -20\nKPX Aacute ucircumflex -20\nKPX Aacute udieresis -20\nKPX Aacute ugrave -20\nKPX Aacute uhungarumlaut -20\nKPX Aacute umacron -20\nKPX Aacute uogonek -20\nKPX Aacute uring -20\nKPX Aacute v -55\nKPX Aacute w -55\nKPX Aacute y -55\nKPX Aacute yacute -55\nKPX Aacute ydieresis -55\nKPX Abreve C -30\nKPX Abreve Cacute -30\nKPX Abreve Ccaron -30\nKPX Abreve Ccedilla -30\nKPX Abreve G -35\nKPX Abreve Gbreve -35\nKPX Abreve Gcommaaccent -35\nKPX Abreve O -40\nKPX Abreve Oacute -40\nKPX Abreve Ocircumflex -40\nKPX Abreve Odieresis -40\nKPX Abreve Ograve -40\nKPX Abreve Ohungarumlaut -40\nKPX Abreve Omacron -40\nKPX Abreve Oslash -40\nKPX Abreve Otilde -40\nKPX Abreve Q -40\nKPX Abreve T -37\nKPX Abreve Tcaron -37\nKPX Abreve Tcommaaccent -37\nKPX Abreve U -50\nKPX Abreve Uacute -50\nKPX Abreve Ucircumflex -50\nKPX Abreve Udieresis -50\nKPX Abreve Ugrave -50\nKPX Abreve Uhungarumlaut -50\nKPX Abreve Umacron -50\nKPX Abreve Uogonek -50\nKPX Abreve Uring -50\nKPX Abreve V -105\nKPX Abreve W -95\nKPX Abreve Y -55\nKPX Abreve Yacute -55\nKPX Abreve Ydieresis -55\nKPX Abreve quoteright -37\nKPX Abreve u -20\nKPX Abreve uacute -20\nKPX Abreve ucircumflex -20\nKPX Abreve udieresis -20\nKPX Abreve ugrave -20\nKPX Abreve uhungarumlaut -20\nKPX Abreve umacron -20\nKPX Abreve uogonek -20\nKPX Abreve uring -20\nKPX Abreve v -55\nKPX Abreve w -55\nKPX Abreve y -55\nKPX Abreve yacute -55\nKPX Abreve ydieresis -55\nKPX Acircumflex C -30\nKPX Acircumflex Cacute -30\nKPX Acircumflex Ccaron -30\nKPX Acircumflex Ccedilla -30\nKPX Acircumflex G -35\nKPX Acircumflex Gbreve -35\nKPX Acircumflex Gcommaaccent -35\nKPX Acircumflex O -40\nKPX Acircumflex Oacute -40\nKPX Acircumflex Ocircumflex -40\nKPX Acircumflex Odieresis -40\nKPX Acircumflex Ograve -40\nKPX Acircumflex Ohungarumlaut -40\nKPX Acircumflex Omacron -40\nKPX Acircumflex Oslash -40\nKPX Acircumflex Otilde -40\nKPX Acircumflex Q -40\nKPX Acircumflex T -37\nKPX Acircumflex Tcaron -37\nKPX Acircumflex Tcommaaccent -37\nKPX Acircumflex U -50\nKPX Acircumflex Uacute -50\nKPX Acircumflex Ucircumflex -50\nKPX Acircumflex Udieresis -50\nKPX Acircumflex Ugrave -50\nKPX Acircumflex Uhungarumlaut -50\nKPX Acircumflex Umacron -50\nKPX Acircumflex Uogonek -50\nKPX Acircumflex Uring -50\nKPX Acircumflex V -105\nKPX Acircumflex W -95\nKPX Acircumflex Y -55\nKPX Acircumflex Yacute -55\nKPX Acircumflex Ydieresis -55\nKPX Acircumflex quoteright -37\nKPX Acircumflex u -20\nKPX Acircumflex uacute -20\nKPX Acircumflex ucircumflex -20\nKPX Acircumflex udieresis -20\nKPX Acircumflex ugrave -20\nKPX Acircumflex uhungarumlaut -20\nKPX Acircumflex umacron -20\nKPX Acircumflex uogonek -20\nKPX Acircumflex uring -20\nKPX Acircumflex v -55\nKPX Acircumflex w -55\nKPX Acircumflex y -55\nKPX Acircumflex yacute -55\nKPX Acircumflex ydieresis -55\nKPX Adieresis C -30\nKPX Adieresis Cacute -30\nKPX Adieresis Ccaron -30\nKPX Adieresis Ccedilla -30\nKPX Adieresis G -35\nKPX Adieresis Gbreve -35\nKPX Adieresis Gcommaaccent -35\nKPX Adieresis O -40\nKPX Adieresis Oacute -40\nKPX Adieresis Ocircumflex -40\nKPX Adieresis Odieresis -40\nKPX Adieresis Ograve -40\nKPX Adieresis Ohungarumlaut -40\nKPX Adieresis Omacron -40\nKPX Adieresis Oslash -40\nKPX Adieresis Otilde -40\nKPX Adieresis Q -40\nKPX Adieresis T -37\nKPX Adieresis Tcaron -37\nKPX Adieresis Tcommaaccent -37\nKPX Adieresis U -50\nKPX Adieresis Uacute -50\nKPX Adieresis Ucircumflex -50\nKPX Adieresis Udieresis -50\nKPX Adieresis Ugrave -50\nKPX Adieresis Uhungarumlaut -50\nKPX Adieresis Umacron -50\nKPX Adieresis Uogonek -50\nKPX Adieresis Uring -50\nKPX Adieresis V -105\nKPX Adieresis W -95\nKPX Adieresis Y -55\nKPX Adieresis Yacute -55\nKPX Adieresis Ydieresis -55\nKPX Adieresis quoteright -37\nKPX Adieresis u -20\nKPX Adieresis uacute -20\nKPX Adieresis ucircumflex -20\nKPX Adieresis udieresis -20\nKPX Adieresis ugrave -20\nKPX Adieresis uhungarumlaut -20\nKPX Adieresis umacron -20\nKPX Adieresis uogonek -20\nKPX Adieresis uring -20\nKPX Adieresis v -55\nKPX Adieresis w -55\nKPX Adieresis y -55\nKPX Adieresis yacute -55\nKPX Adieresis ydieresis -55\nKPX Agrave C -30\nKPX Agrave Cacute -30\nKPX Agrave Ccaron -30\nKPX Agrave Ccedilla -30\nKPX Agrave G -35\nKPX Agrave Gbreve -35\nKPX Agrave Gcommaaccent -35\nKPX Agrave O -40\nKPX Agrave Oacute -40\nKPX Agrave Ocircumflex -40\nKPX Agrave Odieresis -40\nKPX Agrave Ograve -40\nKPX Agrave Ohungarumlaut -40\nKPX Agrave Omacron -40\nKPX Agrave Oslash -40\nKPX Agrave Otilde -40\nKPX Agrave Q -40\nKPX Agrave T -37\nKPX Agrave Tcaron -37\nKPX Agrave Tcommaaccent -37\nKPX Agrave U -50\nKPX Agrave Uacute -50\nKPX Agrave Ucircumflex -50\nKPX Agrave Udieresis -50\nKPX Agrave Ugrave -50\nKPX Agrave Uhungarumlaut -50\nKPX Agrave Umacron -50\nKPX Agrave Uogonek -50\nKPX Agrave Uring -50\nKPX Agrave V -105\nKPX Agrave W -95\nKPX Agrave Y -55\nKPX Agrave Yacute -55\nKPX Agrave Ydieresis -55\nKPX Agrave quoteright -37\nKPX Agrave u -20\nKPX Agrave uacute -20\nKPX Agrave ucircumflex -20\nKPX Agrave udieresis -20\nKPX Agrave ugrave -20\nKPX Agrave uhungarumlaut -20\nKPX Agrave umacron -20\nKPX Agrave uogonek -20\nKPX Agrave uring -20\nKPX Agrave v -55\nKPX Agrave w -55\nKPX Agrave y -55\nKPX Agrave yacute -55\nKPX Agrave ydieresis -55\nKPX Amacron C -30\nKPX Amacron Cacute -30\nKPX Amacron Ccaron -30\nKPX Amacron Ccedilla -30\nKPX Amacron G -35\nKPX Amacron Gbreve -35\nKPX Amacron Gcommaaccent -35\nKPX Amacron O -40\nKPX Amacron Oacute -40\nKPX Amacron Ocircumflex -40\nKPX Amacron Odieresis -40\nKPX Amacron Ograve -40\nKPX Amacron Ohungarumlaut -40\nKPX Amacron Omacron -40\nKPX Amacron Oslash -40\nKPX Amacron Otilde -40\nKPX Amacron Q -40\nKPX Amacron T -37\nKPX Amacron Tcaron -37\nKPX Amacron Tcommaaccent -37\nKPX Amacron U -50\nKPX Amacron Uacute -50\nKPX Amacron Ucircumflex -50\nKPX Amacron Udieresis -50\nKPX Amacron Ugrave -50\nKPX Amacron Uhungarumlaut -50\nKPX Amacron Umacron -50\nKPX Amacron Uogonek -50\nKPX Amacron Uring -50\nKPX Amacron V -105\nKPX Amacron W -95\nKPX Amacron Y -55\nKPX Amacron Yacute -55\nKPX Amacron Ydieresis -55\nKPX Amacron quoteright -37\nKPX Amacron u -20\nKPX Amacron uacute -20\nKPX Amacron ucircumflex -20\nKPX Amacron udieresis -20\nKPX Amacron ugrave -20\nKPX Amacron uhungarumlaut -20\nKPX Amacron umacron -20\nKPX Amacron uogonek -20\nKPX Amacron uring -20\nKPX Amacron v -55\nKPX Amacron w -55\nKPX Amacron y -55\nKPX Amacron yacute -55\nKPX Amacron ydieresis -55\nKPX Aogonek C -30\nKPX Aogonek Cacute -30\nKPX Aogonek Ccaron -30\nKPX Aogonek Ccedilla -30\nKPX Aogonek G -35\nKPX Aogonek Gbreve -35\nKPX Aogonek Gcommaaccent -35\nKPX Aogonek O -40\nKPX Aogonek Oacute -40\nKPX Aogonek Ocircumflex -40\nKPX Aogonek Odieresis -40\nKPX Aogonek Ograve -40\nKPX Aogonek Ohungarumlaut -40\nKPX Aogonek Omacron -40\nKPX Aogonek Oslash -40\nKPX Aogonek Otilde -40\nKPX Aogonek Q -40\nKPX Aogonek T -37\nKPX Aogonek Tcaron -37\nKPX Aogonek Tcommaaccent -37\nKPX Aogonek U -50\nKPX Aogonek Uacute -50\nKPX Aogonek Ucircumflex -50\nKPX Aogonek Udieresis -50\nKPX Aogonek Ugrave -50\nKPX Aogonek Uhungarumlaut -50\nKPX Aogonek Umacron -50\nKPX Aogonek Uogonek -50\nKPX Aogonek Uring -50\nKPX Aogonek V -105\nKPX Aogonek W -95\nKPX Aogonek Y -55\nKPX Aogonek Yacute -55\nKPX Aogonek Ydieresis -55\nKPX Aogonek quoteright -37\nKPX Aogonek u -20\nKPX Aogonek uacute -20\nKPX Aogonek ucircumflex -20\nKPX Aogonek udieresis -20\nKPX Aogonek ugrave -20\nKPX Aogonek uhungarumlaut -20\nKPX Aogonek umacron -20\nKPX Aogonek uogonek -20\nKPX Aogonek uring -20\nKPX Aogonek v -55\nKPX Aogonek w -55\nKPX Aogonek y -55\nKPX Aogonek yacute -55\nKPX Aogonek ydieresis -55\nKPX Aring C -30\nKPX Aring Cacute -30\nKPX Aring Ccaron -30\nKPX Aring Ccedilla -30\nKPX Aring G -35\nKPX Aring Gbreve -35\nKPX Aring Gcommaaccent -35\nKPX Aring O -40\nKPX Aring Oacute -40\nKPX Aring Ocircumflex -40\nKPX Aring Odieresis -40\nKPX Aring Ograve -40\nKPX Aring Ohungarumlaut -40\nKPX Aring Omacron -40\nKPX Aring Oslash -40\nKPX Aring Otilde -40\nKPX Aring Q -40\nKPX Aring T -37\nKPX Aring Tcaron -37\nKPX Aring Tcommaaccent -37\nKPX Aring U -50\nKPX Aring Uacute -50\nKPX Aring Ucircumflex -50\nKPX Aring Udieresis -50\nKPX Aring Ugrave -50\nKPX Aring Uhungarumlaut -50\nKPX Aring Umacron -50\nKPX Aring Uogonek -50\nKPX Aring Uring -50\nKPX Aring V -105\nKPX Aring W -95\nKPX Aring Y -55\nKPX Aring Yacute -55\nKPX Aring Ydieresis -55\nKPX Aring quoteright -37\nKPX Aring u -20\nKPX Aring uacute -20\nKPX Aring ucircumflex -20\nKPX Aring udieresis -20\nKPX Aring ugrave -20\nKPX Aring uhungarumlaut -20\nKPX Aring umacron -20\nKPX Aring uogonek -20\nKPX Aring uring -20\nKPX Aring v -55\nKPX Aring w -55\nKPX Aring y -55\nKPX Aring yacute -55\nKPX Aring ydieresis -55\nKPX Atilde C -30\nKPX Atilde Cacute -30\nKPX Atilde Ccaron -30\nKPX Atilde Ccedilla -30\nKPX Atilde G -35\nKPX Atilde Gbreve -35\nKPX Atilde Gcommaaccent -35\nKPX Atilde O -40\nKPX Atilde Oacute -40\nKPX Atilde Ocircumflex -40\nKPX Atilde Odieresis -40\nKPX Atilde Ograve -40\nKPX Atilde Ohungarumlaut -40\nKPX Atilde Omacron -40\nKPX Atilde Oslash -40\nKPX Atilde Otilde -40\nKPX Atilde Q -40\nKPX Atilde T -37\nKPX Atilde Tcaron -37\nKPX Atilde Tcommaaccent -37\nKPX Atilde U -50\nKPX Atilde Uacute -50\nKPX Atilde Ucircumflex -50\nKPX Atilde Udieresis -50\nKPX Atilde Ugrave -50\nKPX Atilde Uhungarumlaut -50\nKPX Atilde Umacron -50\nKPX Atilde Uogonek -50\nKPX Atilde Uring -50\nKPX Atilde V -105\nKPX Atilde W -95\nKPX Atilde Y -55\nKPX Atilde Yacute -55\nKPX Atilde Ydieresis -55\nKPX Atilde quoteright -37\nKPX Atilde u -20\nKPX Atilde uacute -20\nKPX Atilde ucircumflex -20\nKPX Atilde udieresis -20\nKPX Atilde ugrave -20\nKPX Atilde uhungarumlaut -20\nKPX Atilde umacron -20\nKPX Atilde uogonek -20\nKPX Atilde uring -20\nKPX Atilde v -55\nKPX Atilde w -55\nKPX Atilde y -55\nKPX Atilde yacute -55\nKPX Atilde ydieresis -55\nKPX B A -25\nKPX B Aacute -25\nKPX B Abreve -25\nKPX B Acircumflex -25\nKPX B Adieresis -25\nKPX B Agrave -25\nKPX B Amacron -25\nKPX B Aogonek -25\nKPX B Aring -25\nKPX B Atilde -25\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX D A -35\nKPX D Aacute -35\nKPX D Abreve -35\nKPX D Acircumflex -35\nKPX D Adieresis -35\nKPX D Agrave -35\nKPX D Amacron -35\nKPX D Aogonek -35\nKPX D Aring -35\nKPX D Atilde -35\nKPX D V -40\nKPX D W -40\nKPX D Y -40\nKPX D Yacute -40\nKPX D Ydieresis -40\nKPX Dcaron A -35\nKPX Dcaron Aacute -35\nKPX Dcaron Abreve -35\nKPX Dcaron Acircumflex -35\nKPX Dcaron Adieresis -35\nKPX Dcaron Agrave -35\nKPX Dcaron Amacron -35\nKPX Dcaron Aogonek -35\nKPX Dcaron Aring -35\nKPX Dcaron Atilde -35\nKPX Dcaron V -40\nKPX Dcaron W -40\nKPX Dcaron Y -40\nKPX Dcaron Yacute -40\nKPX Dcaron Ydieresis -40\nKPX Dcroat A -35\nKPX Dcroat Aacute -35\nKPX Dcroat Abreve -35\nKPX Dcroat Acircumflex -35\nKPX Dcroat Adieresis -35\nKPX Dcroat Agrave -35\nKPX Dcroat Amacron -35\nKPX Dcroat Aogonek -35\nKPX Dcroat Aring -35\nKPX Dcroat Atilde -35\nKPX Dcroat V -40\nKPX Dcroat W -40\nKPX Dcroat Y -40\nKPX Dcroat Yacute -40\nKPX Dcroat Ydieresis -40\nKPX F A -115\nKPX F Aacute -115\nKPX F Abreve -115\nKPX F Acircumflex -115\nKPX F Adieresis -115\nKPX F Agrave -115\nKPX F Amacron -115\nKPX F Aogonek -115\nKPX F Aring -115\nKPX F Atilde -115\nKPX F a -75\nKPX F aacute -75\nKPX F abreve -75\nKPX F acircumflex -75\nKPX F adieresis -75\nKPX F agrave -75\nKPX F amacron -75\nKPX F aogonek -75\nKPX F aring -75\nKPX F atilde -75\nKPX F comma -135\nKPX F e -75\nKPX F eacute -75\nKPX F ecaron -75\nKPX F ecircumflex -75\nKPX F edieresis -75\nKPX F edotaccent -75\nKPX F egrave -75\nKPX F emacron -75\nKPX F eogonek -75\nKPX F i -45\nKPX F iacute -45\nKPX F icircumflex -45\nKPX F idieresis -45\nKPX F igrave -45\nKPX F imacron -45\nKPX F iogonek -45\nKPX F o -105\nKPX F oacute -105\nKPX F ocircumflex -105\nKPX F odieresis -105\nKPX F ograve -105\nKPX F ohungarumlaut -105\nKPX F omacron -105\nKPX F oslash -105\nKPX F otilde -105\nKPX F period -135\nKPX F r -55\nKPX F racute -55\nKPX F rcaron -55\nKPX F rcommaaccent -55\nKPX J A -40\nKPX J Aacute -40\nKPX J Abreve -40\nKPX J Acircumflex -40\nKPX J Adieresis -40\nKPX J Agrave -40\nKPX J Amacron -40\nKPX J Aogonek -40\nKPX J Aring -40\nKPX J Atilde -40\nKPX J a -35\nKPX J aacute -35\nKPX J abreve -35\nKPX J acircumflex -35\nKPX J adieresis -35\nKPX J agrave -35\nKPX J amacron -35\nKPX J aogonek -35\nKPX J aring -35\nKPX J atilde -35\nKPX J comma -25\nKPX J e -25\nKPX J eacute -25\nKPX J ecaron -25\nKPX J ecircumflex -25\nKPX J edieresis -25\nKPX J edotaccent -25\nKPX J egrave -25\nKPX J emacron -25\nKPX J eogonek -25\nKPX J o -25\nKPX J oacute -25\nKPX J ocircumflex -25\nKPX J odieresis -25\nKPX J ograve -25\nKPX J ohungarumlaut -25\nKPX J omacron -25\nKPX J oslash -25\nKPX J otilde -25\nKPX J period -25\nKPX J u -35\nKPX J uacute -35\nKPX J ucircumflex -35\nKPX J udieresis -35\nKPX J ugrave -35\nKPX J uhungarumlaut -35\nKPX J umacron -35\nKPX J uogonek -35\nKPX J uring -35\nKPX K O -50\nKPX K Oacute -50\nKPX K Ocircumflex -50\nKPX K Odieresis -50\nKPX K Ograve -50\nKPX K Ohungarumlaut -50\nKPX K Omacron -50\nKPX K Oslash -50\nKPX K Otilde -50\nKPX K e -35\nKPX K eacute -35\nKPX K ecaron -35\nKPX K ecircumflex -35\nKPX K edieresis -35\nKPX K edotaccent -35\nKPX K egrave -35\nKPX K emacron -35\nKPX K eogonek -35\nKPX K o -40\nKPX K oacute -40\nKPX K ocircumflex -40\nKPX K odieresis -40\nKPX K ograve -40\nKPX K ohungarumlaut -40\nKPX K omacron -40\nKPX K oslash -40\nKPX K otilde -40\nKPX K u -40\nKPX K uacute -40\nKPX K ucircumflex -40\nKPX K udieresis -40\nKPX K ugrave -40\nKPX K uhungarumlaut -40\nKPX K umacron -40\nKPX K uogonek -40\nKPX K uring -40\nKPX K y -40\nKPX K yacute -40\nKPX K ydieresis -40\nKPX Kcommaaccent O -50\nKPX Kcommaaccent Oacute -50\nKPX Kcommaaccent Ocircumflex -50\nKPX Kcommaaccent Odieresis -50\nKPX Kcommaaccent Ograve -50\nKPX Kcommaaccent Ohungarumlaut -50\nKPX Kcommaaccent Omacron -50\nKPX Kcommaaccent Oslash -50\nKPX Kcommaaccent Otilde -50\nKPX Kcommaaccent e -35\nKPX Kcommaaccent eacute -35\nKPX Kcommaaccent ecaron -35\nKPX Kcommaaccent ecircumflex -35\nKPX Kcommaaccent edieresis -35\nKPX Kcommaaccent edotaccent -35\nKPX Kcommaaccent egrave -35\nKPX Kcommaaccent emacron -35\nKPX Kcommaaccent eogonek -35\nKPX Kcommaaccent o -40\nKPX Kcommaaccent oacute -40\nKPX Kcommaaccent ocircumflex -40\nKPX Kcommaaccent odieresis -40\nKPX Kcommaaccent ograve -40\nKPX Kcommaaccent ohungarumlaut -40\nKPX Kcommaaccent omacron -40\nKPX Kcommaaccent oslash -40\nKPX Kcommaaccent otilde -40\nKPX Kcommaaccent u -40\nKPX Kcommaaccent uacute -40\nKPX Kcommaaccent ucircumflex -40\nKPX Kcommaaccent udieresis -40\nKPX Kcommaaccent ugrave -40\nKPX Kcommaaccent uhungarumlaut -40\nKPX Kcommaaccent umacron -40\nKPX Kcommaaccent uogonek -40\nKPX Kcommaaccent uring -40\nKPX Kcommaaccent y -40\nKPX Kcommaaccent yacute -40\nKPX Kcommaaccent ydieresis -40\nKPX L T -20\nKPX L Tcaron -20\nKPX L Tcommaaccent -20\nKPX L V -55\nKPX L W -55\nKPX L Y -20\nKPX L Yacute -20\nKPX L Ydieresis -20\nKPX L quoteright -37\nKPX L y -30\nKPX L yacute -30\nKPX L ydieresis -30\nKPX Lacute T -20\nKPX Lacute Tcaron -20\nKPX Lacute Tcommaaccent -20\nKPX Lacute V -55\nKPX Lacute W -55\nKPX Lacute Y -20\nKPX Lacute Yacute -20\nKPX Lacute Ydieresis -20\nKPX Lacute quoteright -37\nKPX Lacute y -30\nKPX Lacute yacute -30\nKPX Lacute ydieresis -30\nKPX Lcommaaccent T -20\nKPX Lcommaaccent Tcaron -20\nKPX Lcommaaccent Tcommaaccent -20\nKPX Lcommaaccent V -55\nKPX Lcommaaccent W -55\nKPX Lcommaaccent Y -20\nKPX Lcommaaccent Yacute -20\nKPX Lcommaaccent Ydieresis -20\nKPX Lcommaaccent quoteright -37\nKPX Lcommaaccent y -30\nKPX Lcommaaccent yacute -30\nKPX Lcommaaccent ydieresis -30\nKPX Lslash T -20\nKPX Lslash Tcaron -20\nKPX Lslash Tcommaaccent -20\nKPX Lslash V -55\nKPX Lslash W -55\nKPX Lslash Y -20\nKPX Lslash Yacute -20\nKPX Lslash Ydieresis -20\nKPX Lslash quoteright -37\nKPX Lslash y -30\nKPX Lslash yacute -30\nKPX Lslash ydieresis -30\nKPX N A -27\nKPX N Aacute -27\nKPX N Abreve -27\nKPX N Acircumflex -27\nKPX N Adieresis -27\nKPX N Agrave -27\nKPX N Amacron -27\nKPX N Aogonek -27\nKPX N Aring -27\nKPX N Atilde -27\nKPX Nacute A -27\nKPX Nacute Aacute -27\nKPX Nacute Abreve -27\nKPX Nacute Acircumflex -27\nKPX Nacute Adieresis -27\nKPX Nacute Agrave -27\nKPX Nacute Amacron -27\nKPX Nacute Aogonek -27\nKPX Nacute Aring -27\nKPX Nacute Atilde -27\nKPX Ncaron A -27\nKPX Ncaron Aacute -27\nKPX Ncaron Abreve -27\nKPX Ncaron Acircumflex -27\nKPX Ncaron Adieresis -27\nKPX Ncaron Agrave -27\nKPX Ncaron Amacron -27\nKPX Ncaron Aogonek -27\nKPX Ncaron Aring -27\nKPX Ncaron Atilde -27\nKPX Ncommaaccent A -27\nKPX Ncommaaccent Aacute -27\nKPX Ncommaaccent Abreve -27\nKPX Ncommaaccent Acircumflex -27\nKPX Ncommaaccent Adieresis -27\nKPX Ncommaaccent Agrave -27\nKPX Ncommaaccent Amacron -27\nKPX Ncommaaccent Aogonek -27\nKPX Ncommaaccent Aring -27\nKPX Ncommaaccent Atilde -27\nKPX Ntilde A -27\nKPX Ntilde Aacute -27\nKPX Ntilde Abreve -27\nKPX Ntilde Acircumflex -27\nKPX Ntilde Adieresis -27\nKPX Ntilde Agrave -27\nKPX Ntilde Amacron -27\nKPX Ntilde Aogonek -27\nKPX Ntilde Aring -27\nKPX Ntilde Atilde -27\nKPX O A -55\nKPX O Aacute -55\nKPX O Abreve -55\nKPX O Acircumflex -55\nKPX O Adieresis -55\nKPX O Agrave -55\nKPX O Amacron -55\nKPX O Aogonek -55\nKPX O Aring -55\nKPX O Atilde -55\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -50\nKPX O X -40\nKPX O Y -50\nKPX O Yacute -50\nKPX O Ydieresis -50\nKPX Oacute A -55\nKPX Oacute Aacute -55\nKPX Oacute Abreve -55\nKPX Oacute Acircumflex -55\nKPX Oacute Adieresis -55\nKPX Oacute Agrave -55\nKPX Oacute Amacron -55\nKPX Oacute Aogonek -55\nKPX Oacute Aring -55\nKPX Oacute Atilde -55\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -50\nKPX Oacute X -40\nKPX Oacute Y -50\nKPX Oacute Yacute -50\nKPX Oacute Ydieresis -50\nKPX Ocircumflex A -55\nKPX Ocircumflex Aacute -55\nKPX Ocircumflex Abreve -55\nKPX Ocircumflex Acircumflex -55\nKPX Ocircumflex Adieresis -55\nKPX Ocircumflex Agrave -55\nKPX Ocircumflex Amacron -55\nKPX Ocircumflex Aogonek -55\nKPX Ocircumflex Aring -55\nKPX Ocircumflex Atilde -55\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -50\nKPX Ocircumflex X -40\nKPX Ocircumflex Y -50\nKPX Ocircumflex Yacute -50\nKPX Ocircumflex Ydieresis -50\nKPX Odieresis A -55\nKPX Odieresis Aacute -55\nKPX Odieresis Abreve -55\nKPX Odieresis Acircumflex -55\nKPX Odieresis Adieresis -55\nKPX Odieresis Agrave -55\nKPX Odieresis Amacron -55\nKPX Odieresis Aogonek -55\nKPX Odieresis Aring -55\nKPX Odieresis Atilde -55\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -50\nKPX Odieresis X -40\nKPX Odieresis Y -50\nKPX Odieresis Yacute -50\nKPX Odieresis Ydieresis -50\nKPX Ograve A -55\nKPX Ograve Aacute -55\nKPX Ograve Abreve -55\nKPX Ograve Acircumflex -55\nKPX Ograve Adieresis -55\nKPX Ograve Agrave -55\nKPX Ograve Amacron -55\nKPX Ograve Aogonek -55\nKPX Ograve Aring -55\nKPX Ograve Atilde -55\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -50\nKPX Ograve X -40\nKPX Ograve Y -50\nKPX Ograve Yacute -50\nKPX Ograve Ydieresis -50\nKPX Ohungarumlaut A -55\nKPX Ohungarumlaut Aacute -55\nKPX Ohungarumlaut Abreve -55\nKPX Ohungarumlaut Acircumflex -55\nKPX Ohungarumlaut Adieresis -55\nKPX Ohungarumlaut Agrave -55\nKPX Ohungarumlaut Amacron -55\nKPX Ohungarumlaut Aogonek -55\nKPX Ohungarumlaut Aring -55\nKPX Ohungarumlaut Atilde -55\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -50\nKPX Ohungarumlaut X -40\nKPX Ohungarumlaut Y -50\nKPX Ohungarumlaut Yacute -50\nKPX Ohungarumlaut Ydieresis -50\nKPX Omacron A -55\nKPX Omacron Aacute -55\nKPX Omacron Abreve -55\nKPX Omacron Acircumflex -55\nKPX Omacron Adieresis -55\nKPX Omacron Agrave -55\nKPX Omacron Amacron -55\nKPX Omacron Aogonek -55\nKPX Omacron Aring -55\nKPX Omacron Atilde -55\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -50\nKPX Omacron X -40\nKPX Omacron Y -50\nKPX Omacron Yacute -50\nKPX Omacron Ydieresis -50\nKPX Oslash A -55\nKPX Oslash Aacute -55\nKPX Oslash Abreve -55\nKPX Oslash Acircumflex -55\nKPX Oslash Adieresis -55\nKPX Oslash Agrave -55\nKPX Oslash Amacron -55\nKPX Oslash Aogonek -55\nKPX Oslash Aring -55\nKPX Oslash Atilde -55\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -50\nKPX Oslash X -40\nKPX Oslash Y -50\nKPX Oslash Yacute -50\nKPX Oslash Ydieresis -50\nKPX Otilde A -55\nKPX Otilde Aacute -55\nKPX Otilde Abreve -55\nKPX Otilde Acircumflex -55\nKPX Otilde Adieresis -55\nKPX Otilde Agrave -55\nKPX Otilde Amacron -55\nKPX Otilde Aogonek -55\nKPX Otilde Aring -55\nKPX Otilde Atilde -55\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -50\nKPX Otilde X -40\nKPX Otilde Y -50\nKPX Otilde Yacute -50\nKPX Otilde Ydieresis -50\nKPX P A -90\nKPX P Aacute -90\nKPX P Abreve -90\nKPX P Acircumflex -90\nKPX P Adieresis -90\nKPX P Agrave -90\nKPX P Amacron -90\nKPX P Aogonek -90\nKPX P Aring -90\nKPX P Atilde -90\nKPX P a -80\nKPX P aacute -80\nKPX P abreve -80\nKPX P acircumflex -80\nKPX P adieresis -80\nKPX P agrave -80\nKPX P amacron -80\nKPX P aogonek -80\nKPX P aring -80\nKPX P atilde -80\nKPX P comma -135\nKPX P e -80\nKPX P eacute -80\nKPX P ecaron -80\nKPX P ecircumflex -80\nKPX P edieresis -80\nKPX P edotaccent -80\nKPX P egrave -80\nKPX P emacron -80\nKPX P eogonek -80\nKPX P o -80\nKPX P oacute -80\nKPX P ocircumflex -80\nKPX P odieresis -80\nKPX P ograve -80\nKPX P ohungarumlaut -80\nKPX P omacron -80\nKPX P oslash -80\nKPX P otilde -80\nKPX P period -135\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX R O -40\nKPX R Oacute -40\nKPX R Ocircumflex -40\nKPX R Odieresis -40\nKPX R Ograve -40\nKPX R Ohungarumlaut -40\nKPX R Omacron -40\nKPX R Oslash -40\nKPX R Otilde -40\nKPX R U -40\nKPX R Uacute -40\nKPX R Ucircumflex -40\nKPX R Udieresis -40\nKPX R Ugrave -40\nKPX R Uhungarumlaut -40\nKPX R Umacron -40\nKPX R Uogonek -40\nKPX R Uring -40\nKPX R V -18\nKPX R W -18\nKPX R Y -18\nKPX R Yacute -18\nKPX R Ydieresis -18\nKPX Racute O -40\nKPX Racute Oacute -40\nKPX Racute Ocircumflex -40\nKPX Racute Odieresis -40\nKPX Racute Ograve -40\nKPX Racute Ohungarumlaut -40\nKPX Racute Omacron -40\nKPX Racute Oslash -40\nKPX Racute Otilde -40\nKPX Racute U -40\nKPX Racute Uacute -40\nKPX Racute Ucircumflex -40\nKPX Racute Udieresis -40\nKPX Racute Ugrave -40\nKPX Racute Uhungarumlaut -40\nKPX Racute Umacron -40\nKPX Racute Uogonek -40\nKPX Racute Uring -40\nKPX Racute V -18\nKPX Racute W -18\nKPX Racute Y -18\nKPX Racute Yacute -18\nKPX Racute Ydieresis -18\nKPX Rcaron O -40\nKPX Rcaron Oacute -40\nKPX Rcaron Ocircumflex -40\nKPX Rcaron Odieresis -40\nKPX Rcaron Ograve -40\nKPX Rcaron Ohungarumlaut -40\nKPX Rcaron Omacron -40\nKPX Rcaron Oslash -40\nKPX Rcaron Otilde -40\nKPX Rcaron U -40\nKPX Rcaron Uacute -40\nKPX Rcaron Ucircumflex -40\nKPX Rcaron Udieresis -40\nKPX Rcaron Ugrave -40\nKPX Rcaron Uhungarumlaut -40\nKPX Rcaron Umacron -40\nKPX Rcaron Uogonek -40\nKPX Rcaron Uring -40\nKPX Rcaron V -18\nKPX Rcaron W -18\nKPX Rcaron Y -18\nKPX Rcaron Yacute -18\nKPX Rcaron Ydieresis -18\nKPX Rcommaaccent O -40\nKPX Rcommaaccent Oacute -40\nKPX Rcommaaccent Ocircumflex -40\nKPX Rcommaaccent Odieresis -40\nKPX Rcommaaccent Ograve -40\nKPX Rcommaaccent Ohungarumlaut -40\nKPX Rcommaaccent Omacron -40\nKPX Rcommaaccent Oslash -40\nKPX Rcommaaccent Otilde -40\nKPX Rcommaaccent U -40\nKPX Rcommaaccent Uacute -40\nKPX Rcommaaccent Ucircumflex -40\nKPX Rcommaaccent Udieresis -40\nKPX Rcommaaccent Ugrave -40\nKPX Rcommaaccent Uhungarumlaut -40\nKPX Rcommaaccent Umacron -40\nKPX Rcommaaccent Uogonek -40\nKPX Rcommaaccent Uring -40\nKPX Rcommaaccent V -18\nKPX Rcommaaccent W -18\nKPX Rcommaaccent Y -18\nKPX Rcommaaccent Yacute -18\nKPX Rcommaaccent Ydieresis -18\nKPX T A -50\nKPX T Aacute -50\nKPX T Abreve -50\nKPX T Acircumflex -50\nKPX T Adieresis -50\nKPX T Agrave -50\nKPX T Amacron -50\nKPX T Aogonek -50\nKPX T Aring -50\nKPX T Atilde -50\nKPX T O -18\nKPX T Oacute -18\nKPX T Ocircumflex -18\nKPX T Odieresis -18\nKPX T Ograve -18\nKPX T Ohungarumlaut -18\nKPX T Omacron -18\nKPX T Oslash -18\nKPX T Otilde -18\nKPX T a -92\nKPX T aacute -92\nKPX T abreve -92\nKPX T acircumflex -92\nKPX T adieresis -92\nKPX T agrave -92\nKPX T amacron -92\nKPX T aogonek -92\nKPX T aring -92\nKPX T atilde -92\nKPX T colon -55\nKPX T comma -74\nKPX T e -92\nKPX T eacute -92\nKPX T ecaron -92\nKPX T ecircumflex -52\nKPX T edieresis -52\nKPX T edotaccent -92\nKPX T egrave -52\nKPX T emacron -52\nKPX T eogonek -92\nKPX T hyphen -74\nKPX T i -55\nKPX T iacute -55\nKPX T iogonek -55\nKPX T o -92\nKPX T oacute -92\nKPX T ocircumflex -92\nKPX T odieresis -92\nKPX T ograve -92\nKPX T ohungarumlaut -92\nKPX T omacron -92\nKPX T oslash -92\nKPX T otilde -92\nKPX T period -74\nKPX T r -55\nKPX T racute -55\nKPX T rcaron -55\nKPX T rcommaaccent -55\nKPX T semicolon -65\nKPX T u -55\nKPX T uacute -55\nKPX T ucircumflex -55\nKPX T udieresis -55\nKPX T ugrave -55\nKPX T uhungarumlaut -55\nKPX T umacron -55\nKPX T uogonek -55\nKPX T uring -55\nKPX T w -74\nKPX T y -74\nKPX T yacute -74\nKPX T ydieresis -34\nKPX Tcaron A -50\nKPX Tcaron Aacute -50\nKPX Tcaron Abreve -50\nKPX Tcaron Acircumflex -50\nKPX Tcaron Adieresis -50\nKPX Tcaron Agrave -50\nKPX Tcaron Amacron -50\nKPX Tcaron Aogonek -50\nKPX Tcaron Aring -50\nKPX Tcaron Atilde -50\nKPX Tcaron O -18\nKPX Tcaron Oacute -18\nKPX Tcaron Ocircumflex -18\nKPX Tcaron Odieresis -18\nKPX Tcaron Ograve -18\nKPX Tcaron Ohungarumlaut -18\nKPX Tcaron Omacron -18\nKPX Tcaron Oslash -18\nKPX Tcaron Otilde -18\nKPX Tcaron a -92\nKPX Tcaron aacute -92\nKPX Tcaron abreve -92\nKPX Tcaron acircumflex -92\nKPX Tcaron adieresis -92\nKPX Tcaron agrave -92\nKPX Tcaron amacron -92\nKPX Tcaron aogonek -92\nKPX Tcaron aring -92\nKPX Tcaron atilde -92\nKPX Tcaron colon -55\nKPX Tcaron comma -74\nKPX Tcaron e -92\nKPX Tcaron eacute -92\nKPX Tcaron ecaron -92\nKPX Tcaron ecircumflex -52\nKPX Tcaron edieresis -52\nKPX Tcaron edotaccent -92\nKPX Tcaron egrave -52\nKPX Tcaron emacron -52\nKPX Tcaron eogonek -92\nKPX Tcaron hyphen -74\nKPX Tcaron i -55\nKPX Tcaron iacute -55\nKPX Tcaron iogonek -55\nKPX Tcaron o -92\nKPX Tcaron oacute -92\nKPX Tcaron ocircumflex -92\nKPX Tcaron odieresis -92\nKPX Tcaron ograve -92\nKPX Tcaron ohungarumlaut -92\nKPX Tcaron omacron -92\nKPX Tcaron oslash -92\nKPX Tcaron otilde -92\nKPX Tcaron period -74\nKPX Tcaron r -55\nKPX Tcaron racute -55\nKPX Tcaron rcaron -55\nKPX Tcaron rcommaaccent -55\nKPX Tcaron semicolon -65\nKPX Tcaron u -55\nKPX Tcaron uacute -55\nKPX Tcaron ucircumflex -55\nKPX Tcaron udieresis -55\nKPX Tcaron ugrave -55\nKPX Tcaron uhungarumlaut -55\nKPX Tcaron umacron -55\nKPX Tcaron uogonek -55\nKPX Tcaron uring -55\nKPX Tcaron w -74\nKPX Tcaron y -74\nKPX Tcaron yacute -74\nKPX Tcaron ydieresis -34\nKPX Tcommaaccent A -50\nKPX Tcommaaccent Aacute -50\nKPX Tcommaaccent Abreve -50\nKPX Tcommaaccent Acircumflex -50\nKPX Tcommaaccent Adieresis -50\nKPX Tcommaaccent Agrave -50\nKPX Tcommaaccent Amacron -50\nKPX Tcommaaccent Aogonek -50\nKPX Tcommaaccent Aring -50\nKPX Tcommaaccent Atilde -50\nKPX Tcommaaccent O -18\nKPX Tcommaaccent Oacute -18\nKPX Tcommaaccent Ocircumflex -18\nKPX Tcommaaccent Odieresis -18\nKPX Tcommaaccent Ograve -18\nKPX Tcommaaccent Ohungarumlaut -18\nKPX Tcommaaccent Omacron -18\nKPX Tcommaaccent Oslash -18\nKPX Tcommaaccent Otilde -18\nKPX Tcommaaccent a -92\nKPX Tcommaaccent aacute -92\nKPX Tcommaaccent abreve -92\nKPX Tcommaaccent acircumflex -92\nKPX Tcommaaccent adieresis -92\nKPX Tcommaaccent agrave -92\nKPX Tcommaaccent amacron -92\nKPX Tcommaaccent aogonek -92\nKPX Tcommaaccent aring -92\nKPX Tcommaaccent atilde -92\nKPX Tcommaaccent colon -55\nKPX Tcommaaccent comma -74\nKPX Tcommaaccent e -92\nKPX Tcommaaccent eacute -92\nKPX Tcommaaccent ecaron -92\nKPX Tcommaaccent ecircumflex -52\nKPX Tcommaaccent edieresis -52\nKPX Tcommaaccent edotaccent -92\nKPX Tcommaaccent egrave -52\nKPX Tcommaaccent emacron -52\nKPX Tcommaaccent eogonek -92\nKPX Tcommaaccent hyphen -74\nKPX Tcommaaccent i -55\nKPX Tcommaaccent iacute -55\nKPX Tcommaaccent iogonek -55\nKPX Tcommaaccent o -92\nKPX Tcommaaccent oacute -92\nKPX Tcommaaccent ocircumflex -92\nKPX Tcommaaccent odieresis -92\nKPX Tcommaaccent ograve -92\nKPX Tcommaaccent ohungarumlaut -92\nKPX Tcommaaccent omacron -92\nKPX Tcommaaccent oslash -92\nKPX Tcommaaccent otilde -92\nKPX Tcommaaccent period -74\nKPX Tcommaaccent r -55\nKPX Tcommaaccent racute -55\nKPX Tcommaaccent rcaron -55\nKPX Tcommaaccent rcommaaccent -55\nKPX Tcommaaccent semicolon -65\nKPX Tcommaaccent u -55\nKPX Tcommaaccent uacute -55\nKPX Tcommaaccent ucircumflex -55\nKPX Tcommaaccent udieresis -55\nKPX Tcommaaccent ugrave -55\nKPX Tcommaaccent uhungarumlaut -55\nKPX Tcommaaccent umacron -55\nKPX Tcommaaccent uogonek -55\nKPX Tcommaaccent uring -55\nKPX Tcommaaccent w -74\nKPX Tcommaaccent y -74\nKPX Tcommaaccent yacute -74\nKPX Tcommaaccent ydieresis -34\nKPX U A -40\nKPX U Aacute -40\nKPX U Abreve -40\nKPX U Acircumflex -40\nKPX U Adieresis -40\nKPX U Agrave -40\nKPX U Amacron -40\nKPX U Aogonek -40\nKPX U Aring -40\nKPX U Atilde -40\nKPX U comma -25\nKPX U period -25\nKPX Uacute A -40\nKPX Uacute Aacute -40\nKPX Uacute Abreve -40\nKPX Uacute Acircumflex -40\nKPX Uacute Adieresis -40\nKPX Uacute Agrave -40\nKPX Uacute Amacron -40\nKPX Uacute Aogonek -40\nKPX Uacute Aring -40\nKPX Uacute Atilde -40\nKPX Uacute comma -25\nKPX Uacute period -25\nKPX Ucircumflex A -40\nKPX Ucircumflex Aacute -40\nKPX Ucircumflex Abreve -40\nKPX Ucircumflex Acircumflex -40\nKPX Ucircumflex Adieresis -40\nKPX Ucircumflex Agrave -40\nKPX Ucircumflex Amacron -40\nKPX Ucircumflex Aogonek -40\nKPX Ucircumflex Aring -40\nKPX Ucircumflex Atilde -40\nKPX Ucircumflex comma -25\nKPX Ucircumflex period -25\nKPX Udieresis A -40\nKPX Udieresis Aacute -40\nKPX Udieresis Abreve -40\nKPX Udieresis Acircumflex -40\nKPX Udieresis Adieresis -40\nKPX Udieresis Agrave -40\nKPX Udieresis Amacron -40\nKPX Udieresis Aogonek -40\nKPX Udieresis Aring -40\nKPX Udieresis Atilde -40\nKPX Udieresis comma -25\nKPX Udieresis period -25\nKPX Ugrave A -40\nKPX Ugrave Aacute -40\nKPX Ugrave Abreve -40\nKPX Ugrave Acircumflex -40\nKPX Ugrave Adieresis -40\nKPX Ugrave Agrave -40\nKPX Ugrave Amacron -40\nKPX Ugrave Aogonek -40\nKPX Ugrave Aring -40\nKPX Ugrave Atilde -40\nKPX Ugrave comma -25\nKPX Ugrave period -25\nKPX Uhungarumlaut A -40\nKPX Uhungarumlaut Aacute -40\nKPX Uhungarumlaut Abreve -40\nKPX Uhungarumlaut Acircumflex -40\nKPX Uhungarumlaut Adieresis -40\nKPX Uhungarumlaut Agrave -40\nKPX Uhungarumlaut Amacron -40\nKPX Uhungarumlaut Aogonek -40\nKPX Uhungarumlaut Aring -40\nKPX Uhungarumlaut Atilde -40\nKPX Uhungarumlaut comma -25\nKPX Uhungarumlaut period -25\nKPX Umacron A -40\nKPX Umacron Aacute -40\nKPX Umacron Abreve -40\nKPX Umacron Acircumflex -40\nKPX Umacron Adieresis -40\nKPX Umacron Agrave -40\nKPX Umacron Amacron -40\nKPX Umacron Aogonek -40\nKPX Umacron Aring -40\nKPX Umacron Atilde -40\nKPX Umacron comma -25\nKPX Umacron period -25\nKPX Uogonek A -40\nKPX Uogonek Aacute -40\nKPX Uogonek Abreve -40\nKPX Uogonek Acircumflex -40\nKPX Uogonek Adieresis -40\nKPX Uogonek Agrave -40\nKPX Uogonek Amacron -40\nKPX Uogonek Aogonek -40\nKPX Uogonek Aring -40\nKPX Uogonek Atilde -40\nKPX Uogonek comma -25\nKPX Uogonek period -25\nKPX Uring A -40\nKPX Uring Aacute -40\nKPX Uring Abreve -40\nKPX Uring Acircumflex -40\nKPX Uring Adieresis -40\nKPX Uring Agrave -40\nKPX Uring Amacron -40\nKPX Uring Aogonek -40\nKPX Uring Aring -40\nKPX Uring Atilde -40\nKPX Uring comma -25\nKPX Uring period -25\nKPX V A -60\nKPX V Aacute -60\nKPX V Abreve -60\nKPX V Acircumflex -60\nKPX V Adieresis -60\nKPX V Agrave -60\nKPX V Amacron -60\nKPX V Aogonek -60\nKPX V Aring -60\nKPX V Atilde -60\nKPX V O -30\nKPX V Oacute -30\nKPX V Ocircumflex -30\nKPX V Odieresis -30\nKPX V Ograve -30\nKPX V Ohungarumlaut -30\nKPX V Omacron -30\nKPX V Oslash -30\nKPX V Otilde -30\nKPX V a -111\nKPX V aacute -111\nKPX V abreve -111\nKPX V acircumflex -111\nKPX V adieresis -111\nKPX V agrave -111\nKPX V amacron -111\nKPX V aogonek -111\nKPX V aring -111\nKPX V atilde -111\nKPX V colon -65\nKPX V comma -129\nKPX V e -111\nKPX V eacute -111\nKPX V ecaron -111\nKPX V ecircumflex -111\nKPX V edieresis -71\nKPX V edotaccent -111\nKPX V egrave -71\nKPX V emacron -71\nKPX V eogonek -111\nKPX V hyphen -55\nKPX V i -74\nKPX V iacute -74\nKPX V icircumflex -34\nKPX V idieresis -34\nKPX V igrave -34\nKPX V imacron -34\nKPX V iogonek -74\nKPX V o -111\nKPX V oacute -111\nKPX V ocircumflex -111\nKPX V odieresis -111\nKPX V ograve -111\nKPX V ohungarumlaut -111\nKPX V omacron -111\nKPX V oslash -111\nKPX V otilde -111\nKPX V period -129\nKPX V semicolon -74\nKPX V u -74\nKPX V uacute -74\nKPX V ucircumflex -74\nKPX V udieresis -74\nKPX V ugrave -74\nKPX V uhungarumlaut -74\nKPX V umacron -74\nKPX V uogonek -74\nKPX V uring -74\nKPX W A -60\nKPX W Aacute -60\nKPX W Abreve -60\nKPX W Acircumflex -60\nKPX W Adieresis -60\nKPX W Agrave -60\nKPX W Amacron -60\nKPX W Aogonek -60\nKPX W Aring -60\nKPX W Atilde -60\nKPX W O -25\nKPX W Oacute -25\nKPX W Ocircumflex -25\nKPX W Odieresis -25\nKPX W Ograve -25\nKPX W Ohungarumlaut -25\nKPX W Omacron -25\nKPX W Oslash -25\nKPX W Otilde -25\nKPX W a -92\nKPX W aacute -92\nKPX W abreve -92\nKPX W acircumflex -92\nKPX W adieresis -92\nKPX W agrave -92\nKPX W amacron -92\nKPX W aogonek -92\nKPX W aring -92\nKPX W atilde -92\nKPX W colon -65\nKPX W comma -92\nKPX W e -92\nKPX W eacute -92\nKPX W ecaron -92\nKPX W ecircumflex -92\nKPX W edieresis -52\nKPX W edotaccent -92\nKPX W egrave -52\nKPX W emacron -52\nKPX W eogonek -92\nKPX W hyphen -37\nKPX W i -55\nKPX W iacute -55\nKPX W iogonek -55\nKPX W o -92\nKPX W oacute -92\nKPX W ocircumflex -92\nKPX W odieresis -92\nKPX W ograve -92\nKPX W ohungarumlaut -92\nKPX W omacron -92\nKPX W oslash -92\nKPX W otilde -92\nKPX W period -92\nKPX W semicolon -65\nKPX W u -55\nKPX W uacute -55\nKPX W ucircumflex -55\nKPX W udieresis -55\nKPX W ugrave -55\nKPX W uhungarumlaut -55\nKPX W umacron -55\nKPX W uogonek -55\nKPX W uring -55\nKPX W y -70\nKPX W yacute -70\nKPX W ydieresis -70\nKPX Y A -50\nKPX Y Aacute -50\nKPX Y Abreve -50\nKPX Y Acircumflex -50\nKPX Y Adieresis -50\nKPX Y Agrave -50\nKPX Y Amacron -50\nKPX Y Aogonek -50\nKPX Y Aring -50\nKPX Y Atilde -50\nKPX Y O -15\nKPX Y Oacute -15\nKPX Y Ocircumflex -15\nKPX Y Odieresis -15\nKPX Y Ograve -15\nKPX Y Ohungarumlaut -15\nKPX Y Omacron -15\nKPX Y Oslash -15\nKPX Y Otilde -15\nKPX Y a -92\nKPX Y aacute -92\nKPX Y abreve -92\nKPX Y acircumflex -92\nKPX Y adieresis -92\nKPX Y agrave -92\nKPX Y amacron -92\nKPX Y aogonek -92\nKPX Y aring -92\nKPX Y atilde -92\nKPX Y colon -65\nKPX Y comma -92\nKPX Y e -92\nKPX Y eacute -92\nKPX Y ecaron -92\nKPX Y ecircumflex -92\nKPX Y edieresis -52\nKPX Y edotaccent -92\nKPX Y egrave -52\nKPX Y emacron -52\nKPX Y eogonek -92\nKPX Y hyphen -74\nKPX Y i -74\nKPX Y iacute -74\nKPX Y icircumflex -34\nKPX Y idieresis -34\nKPX Y igrave -34\nKPX Y imacron -34\nKPX Y iogonek -74\nKPX Y o -92\nKPX Y oacute -92\nKPX Y ocircumflex -92\nKPX Y odieresis -92\nKPX Y ograve -92\nKPX Y ohungarumlaut -92\nKPX Y omacron -92\nKPX Y oslash -92\nKPX Y otilde -92\nKPX Y period -92\nKPX Y semicolon -65\nKPX Y u -92\nKPX Y uacute -92\nKPX Y ucircumflex -92\nKPX Y udieresis -92\nKPX Y ugrave -92\nKPX Y uhungarumlaut -92\nKPX Y umacron -92\nKPX Y uogonek -92\nKPX Y uring -92\nKPX Yacute A -50\nKPX Yacute Aacute -50\nKPX Yacute Abreve -50\nKPX Yacute Acircumflex -50\nKPX Yacute Adieresis -50\nKPX Yacute Agrave -50\nKPX Yacute Amacron -50\nKPX Yacute Aogonek -50\nKPX Yacute Aring -50\nKPX Yacute Atilde -50\nKPX Yacute O -15\nKPX Yacute Oacute -15\nKPX Yacute Ocircumflex -15\nKPX Yacute Odieresis -15\nKPX Yacute Ograve -15\nKPX Yacute Ohungarumlaut -15\nKPX Yacute Omacron -15\nKPX Yacute Oslash -15\nKPX Yacute Otilde -15\nKPX Yacute a -92\nKPX Yacute aacute -92\nKPX Yacute abreve -92\nKPX Yacute acircumflex -92\nKPX Yacute adieresis -92\nKPX Yacute agrave -92\nKPX Yacute amacron -92\nKPX Yacute aogonek -92\nKPX Yacute aring -92\nKPX Yacute atilde -92\nKPX Yacute colon -65\nKPX Yacute comma -92\nKPX Yacute e -92\nKPX Yacute eacute -92\nKPX Yacute ecaron -92\nKPX Yacute ecircumflex -92\nKPX Yacute edieresis -52\nKPX Yacute edotaccent -92\nKPX Yacute egrave -52\nKPX Yacute emacron -52\nKPX Yacute eogonek -92\nKPX Yacute hyphen -74\nKPX Yacute i -74\nKPX Yacute iacute -74\nKPX Yacute icircumflex -34\nKPX Yacute idieresis -34\nKPX Yacute igrave -34\nKPX Yacute imacron -34\nKPX Yacute iogonek -74\nKPX Yacute o -92\nKPX Yacute oacute -92\nKPX Yacute ocircumflex -92\nKPX Yacute odieresis -92\nKPX Yacute ograve -92\nKPX Yacute ohungarumlaut -92\nKPX Yacute omacron -92\nKPX Yacute oslash -92\nKPX Yacute otilde -92\nKPX Yacute period -92\nKPX Yacute semicolon -65\nKPX Yacute u -92\nKPX Yacute uacute -92\nKPX Yacute ucircumflex -92\nKPX Yacute udieresis -92\nKPX Yacute ugrave -92\nKPX Yacute uhungarumlaut -92\nKPX Yacute umacron -92\nKPX Yacute uogonek -92\nKPX Yacute uring -92\nKPX Ydieresis A -50\nKPX Ydieresis Aacute -50\nKPX Ydieresis Abreve -50\nKPX Ydieresis Acircumflex -50\nKPX Ydieresis Adieresis -50\nKPX Ydieresis Agrave -50\nKPX Ydieresis Amacron -50\nKPX Ydieresis Aogonek -50\nKPX Ydieresis Aring -50\nKPX Ydieresis Atilde -50\nKPX Ydieresis O -15\nKPX Ydieresis Oacute -15\nKPX Ydieresis Ocircumflex -15\nKPX Ydieresis Odieresis -15\nKPX Ydieresis Ograve -15\nKPX Ydieresis Ohungarumlaut -15\nKPX Ydieresis Omacron -15\nKPX Ydieresis Oslash -15\nKPX Ydieresis Otilde -15\nKPX Ydieresis a -92\nKPX Ydieresis aacute -92\nKPX Ydieresis abreve -92\nKPX Ydieresis acircumflex -92\nKPX Ydieresis adieresis -92\nKPX Ydieresis agrave -92\nKPX Ydieresis amacron -92\nKPX Ydieresis aogonek -92\nKPX Ydieresis aring -92\nKPX Ydieresis atilde -92\nKPX Ydieresis colon -65\nKPX Ydieresis comma -92\nKPX Ydieresis e -92\nKPX Ydieresis eacute -92\nKPX Ydieresis ecaron -92\nKPX Ydieresis ecircumflex -92\nKPX Ydieresis edieresis -52\nKPX Ydieresis edotaccent -92\nKPX Ydieresis egrave -52\nKPX Ydieresis emacron -52\nKPX Ydieresis eogonek -92\nKPX Ydieresis hyphen -74\nKPX Ydieresis i -74\nKPX Ydieresis iacute -74\nKPX Ydieresis icircumflex -34\nKPX Ydieresis idieresis -34\nKPX Ydieresis igrave -34\nKPX Ydieresis imacron -34\nKPX Ydieresis iogonek -74\nKPX Ydieresis o -92\nKPX Ydieresis oacute -92\nKPX Ydieresis ocircumflex -92\nKPX Ydieresis odieresis -92\nKPX Ydieresis ograve -92\nKPX Ydieresis ohungarumlaut -92\nKPX Ydieresis omacron -92\nKPX Ydieresis oslash -92\nKPX Ydieresis otilde -92\nKPX Ydieresis period -92\nKPX Ydieresis semicolon -65\nKPX Ydieresis u -92\nKPX Ydieresis uacute -92\nKPX Ydieresis ucircumflex -92\nKPX Ydieresis udieresis -92\nKPX Ydieresis ugrave -92\nKPX Ydieresis uhungarumlaut -92\nKPX Ydieresis umacron -92\nKPX Ydieresis uogonek -92\nKPX Ydieresis uring -92\nKPX a g -10\nKPX a gbreve -10\nKPX a gcommaaccent -10\nKPX aacute g -10\nKPX aacute gbreve -10\nKPX aacute gcommaaccent -10\nKPX abreve g -10\nKPX abreve gbreve -10\nKPX abreve gcommaaccent -10\nKPX acircumflex g -10\nKPX acircumflex gbreve -10\nKPX acircumflex gcommaaccent -10\nKPX adieresis g -10\nKPX adieresis gbreve -10\nKPX adieresis gcommaaccent -10\nKPX agrave g -10\nKPX agrave gbreve -10\nKPX agrave gcommaaccent -10\nKPX amacron g -10\nKPX amacron gbreve -10\nKPX amacron gcommaaccent -10\nKPX aogonek g -10\nKPX aogonek gbreve -10\nKPX aogonek gcommaaccent -10\nKPX aring g -10\nKPX aring gbreve -10\nKPX aring gcommaaccent -10\nKPX atilde g -10\nKPX atilde gbreve -10\nKPX atilde gcommaaccent -10\nKPX b period -40\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX c h -15\nKPX c k -20\nKPX c kcommaaccent -20\nKPX cacute h -15\nKPX cacute k -20\nKPX cacute kcommaaccent -20\nKPX ccaron h -15\nKPX ccaron k -20\nKPX ccaron kcommaaccent -20\nKPX ccedilla h -15\nKPX ccedilla k -20\nKPX ccedilla kcommaaccent -20\nKPX comma quotedblright -140\nKPX comma quoteright -140\nKPX e comma -10\nKPX e g -40\nKPX e gbreve -40\nKPX e gcommaaccent -40\nKPX e period -15\nKPX e v -15\nKPX e w -15\nKPX e x -20\nKPX e y -30\nKPX e yacute -30\nKPX e ydieresis -30\nKPX eacute comma -10\nKPX eacute g -40\nKPX eacute gbreve -40\nKPX eacute gcommaaccent -40\nKPX eacute period -15\nKPX eacute v -15\nKPX eacute w -15\nKPX eacute x -20\nKPX eacute y -30\nKPX eacute yacute -30\nKPX eacute ydieresis -30\nKPX ecaron comma -10\nKPX ecaron g -40\nKPX ecaron gbreve -40\nKPX ecaron gcommaaccent -40\nKPX ecaron period -15\nKPX ecaron v -15\nKPX ecaron w -15\nKPX ecaron x -20\nKPX ecaron y -30\nKPX ecaron yacute -30\nKPX ecaron ydieresis -30\nKPX ecircumflex comma -10\nKPX ecircumflex g -40\nKPX ecircumflex gbreve -40\nKPX ecircumflex gcommaaccent -40\nKPX ecircumflex period -15\nKPX ecircumflex v -15\nKPX ecircumflex w -15\nKPX ecircumflex x -20\nKPX ecircumflex y -30\nKPX ecircumflex yacute -30\nKPX ecircumflex ydieresis -30\nKPX edieresis comma -10\nKPX edieresis g -40\nKPX edieresis gbreve -40\nKPX edieresis gcommaaccent -40\nKPX edieresis period -15\nKPX edieresis v -15\nKPX edieresis w -15\nKPX edieresis x -20\nKPX edieresis y -30\nKPX edieresis yacute -30\nKPX edieresis ydieresis -30\nKPX edotaccent comma -10\nKPX edotaccent g -40\nKPX edotaccent gbreve -40\nKPX edotaccent gcommaaccent -40\nKPX edotaccent period -15\nKPX edotaccent v -15\nKPX edotaccent w -15\nKPX edotaccent x -20\nKPX edotaccent y -30\nKPX edotaccent yacute -30\nKPX edotaccent ydieresis -30\nKPX egrave comma -10\nKPX egrave g -40\nKPX egrave gbreve -40\nKPX egrave gcommaaccent -40\nKPX egrave period -15\nKPX egrave v -15\nKPX egrave w -15\nKPX egrave x -20\nKPX egrave y -30\nKPX egrave yacute -30\nKPX egrave ydieresis -30\nKPX emacron comma -10\nKPX emacron g -40\nKPX emacron gbreve -40\nKPX emacron gcommaaccent -40\nKPX emacron period -15\nKPX emacron v -15\nKPX emacron w -15\nKPX emacron x -20\nKPX emacron y -30\nKPX emacron yacute -30\nKPX emacron ydieresis -30\nKPX eogonek comma -10\nKPX eogonek g -40\nKPX eogonek gbreve -40\nKPX eogonek gcommaaccent -40\nKPX eogonek period -15\nKPX eogonek v -15\nKPX eogonek w -15\nKPX eogonek x -20\nKPX eogonek y -30\nKPX eogonek yacute -30\nKPX eogonek ydieresis -30\nKPX f comma -10\nKPX f dotlessi -60\nKPX f f -18\nKPX f i -20\nKPX f iogonek -20\nKPX f period -15\nKPX f quoteright 92\nKPX g comma -10\nKPX g e -10\nKPX g eacute -10\nKPX g ecaron -10\nKPX g ecircumflex -10\nKPX g edieresis -10\nKPX g edotaccent -10\nKPX g egrave -10\nKPX g emacron -10\nKPX g eogonek -10\nKPX g g -10\nKPX g gbreve -10\nKPX g gcommaaccent -10\nKPX g period -15\nKPX gbreve comma -10\nKPX gbreve e -10\nKPX gbreve eacute -10\nKPX gbreve ecaron -10\nKPX gbreve ecircumflex -10\nKPX gbreve edieresis -10\nKPX gbreve edotaccent -10\nKPX gbreve egrave -10\nKPX gbreve emacron -10\nKPX gbreve eogonek -10\nKPX gbreve g -10\nKPX gbreve gbreve -10\nKPX gbreve gcommaaccent -10\nKPX gbreve period -15\nKPX gcommaaccent comma -10\nKPX gcommaaccent e -10\nKPX gcommaaccent eacute -10\nKPX gcommaaccent ecaron -10\nKPX gcommaaccent ecircumflex -10\nKPX gcommaaccent edieresis -10\nKPX gcommaaccent edotaccent -10\nKPX gcommaaccent egrave -10\nKPX gcommaaccent emacron -10\nKPX gcommaaccent eogonek -10\nKPX gcommaaccent g -10\nKPX gcommaaccent gbreve -10\nKPX gcommaaccent gcommaaccent -10\nKPX gcommaaccent period -15\nKPX k e -10\nKPX k eacute -10\nKPX k ecaron -10\nKPX k ecircumflex -10\nKPX k edieresis -10\nKPX k edotaccent -10\nKPX k egrave -10\nKPX k emacron -10\nKPX k eogonek -10\nKPX k o -10\nKPX k oacute -10\nKPX k ocircumflex -10\nKPX k odieresis -10\nKPX k ograve -10\nKPX k ohungarumlaut -10\nKPX k omacron -10\nKPX k oslash -10\nKPX k otilde -10\nKPX k y -10\nKPX k yacute -10\nKPX k ydieresis -10\nKPX kcommaaccent e -10\nKPX kcommaaccent eacute -10\nKPX kcommaaccent ecaron -10\nKPX kcommaaccent ecircumflex -10\nKPX kcommaaccent edieresis -10\nKPX kcommaaccent edotaccent -10\nKPX kcommaaccent egrave -10\nKPX kcommaaccent emacron -10\nKPX kcommaaccent eogonek -10\nKPX kcommaaccent o -10\nKPX kcommaaccent oacute -10\nKPX kcommaaccent ocircumflex -10\nKPX kcommaaccent odieresis -10\nKPX kcommaaccent ograve -10\nKPX kcommaaccent ohungarumlaut -10\nKPX kcommaaccent omacron -10\nKPX kcommaaccent oslash -10\nKPX kcommaaccent otilde -10\nKPX kcommaaccent y -10\nKPX kcommaaccent yacute -10\nKPX kcommaaccent ydieresis -10\nKPX n v -40\nKPX nacute v -40\nKPX ncaron v -40\nKPX ncommaaccent v -40\nKPX ntilde v -40\nKPX o g -10\nKPX o gbreve -10\nKPX o gcommaaccent -10\nKPX o v -10\nKPX oacute g -10\nKPX oacute gbreve -10\nKPX oacute gcommaaccent -10\nKPX oacute v -10\nKPX ocircumflex g -10\nKPX ocircumflex gbreve -10\nKPX ocircumflex gcommaaccent -10\nKPX ocircumflex v -10\nKPX odieresis g -10\nKPX odieresis gbreve -10\nKPX odieresis gcommaaccent -10\nKPX odieresis v -10\nKPX ograve g -10\nKPX ograve gbreve -10\nKPX ograve gcommaaccent -10\nKPX ograve v -10\nKPX ohungarumlaut g -10\nKPX ohungarumlaut gbreve -10\nKPX ohungarumlaut gcommaaccent -10\nKPX ohungarumlaut v -10\nKPX omacron g -10\nKPX omacron gbreve -10\nKPX omacron gcommaaccent -10\nKPX omacron v -10\nKPX oslash g -10\nKPX oslash gbreve -10\nKPX oslash gcommaaccent -10\nKPX oslash v -10\nKPX otilde g -10\nKPX otilde gbreve -10\nKPX otilde gcommaaccent -10\nKPX otilde v -10\nKPX period quotedblright -140\nKPX period quoteright -140\nKPX quoteleft quoteleft -111\nKPX quoteright d -25\nKPX quoteright dcroat -25\nKPX quoteright quoteright -111\nKPX quoteright r -25\nKPX quoteright racute -25\nKPX quoteright rcaron -25\nKPX quoteright rcommaaccent -25\nKPX quoteright s -40\nKPX quoteright sacute -40\nKPX quoteright scaron -40\nKPX quoteright scedilla -40\nKPX quoteright scommaaccent -40\nKPX quoteright space -111\nKPX quoteright t -30\nKPX quoteright tcommaaccent -30\nKPX quoteright v -10\nKPX r a -15\nKPX r aacute -15\nKPX r abreve -15\nKPX r acircumflex -15\nKPX r adieresis -15\nKPX r agrave -15\nKPX r amacron -15\nKPX r aogonek -15\nKPX r aring -15\nKPX r atilde -15\nKPX r c -37\nKPX r cacute -37\nKPX r ccaron -37\nKPX r ccedilla -37\nKPX r comma -111\nKPX r d -37\nKPX r dcroat -37\nKPX r e -37\nKPX r eacute -37\nKPX r ecaron -37\nKPX r ecircumflex -37\nKPX r edieresis -37\nKPX r edotaccent -37\nKPX r egrave -37\nKPX r emacron -37\nKPX r eogonek -37\nKPX r g -37\nKPX r gbreve -37\nKPX r gcommaaccent -37\nKPX r hyphen -20\nKPX r o -45\nKPX r oacute -45\nKPX r ocircumflex -45\nKPX r odieresis -45\nKPX r ograve -45\nKPX r ohungarumlaut -45\nKPX r omacron -45\nKPX r oslash -45\nKPX r otilde -45\nKPX r period -111\nKPX r q -37\nKPX r s -10\nKPX r sacute -10\nKPX r scaron -10\nKPX r scedilla -10\nKPX r scommaaccent -10\nKPX racute a -15\nKPX racute aacute -15\nKPX racute abreve -15\nKPX racute acircumflex -15\nKPX racute adieresis -15\nKPX racute agrave -15\nKPX racute amacron -15\nKPX racute aogonek -15\nKPX racute aring -15\nKPX racute atilde -15\nKPX racute c -37\nKPX racute cacute -37\nKPX racute ccaron -37\nKPX racute ccedilla -37\nKPX racute comma -111\nKPX racute d -37\nKPX racute dcroat -37\nKPX racute e -37\nKPX racute eacute -37\nKPX racute ecaron -37\nKPX racute ecircumflex -37\nKPX racute edieresis -37\nKPX racute edotaccent -37\nKPX racute egrave -37\nKPX racute emacron -37\nKPX racute eogonek -37\nKPX racute g -37\nKPX racute gbreve -37\nKPX racute gcommaaccent -37\nKPX racute hyphen -20\nKPX racute o -45\nKPX racute oacute -45\nKPX racute ocircumflex -45\nKPX racute odieresis -45\nKPX racute ograve -45\nKPX racute ohungarumlaut -45\nKPX racute omacron -45\nKPX racute oslash -45\nKPX racute otilde -45\nKPX racute period -111\nKPX racute q -37\nKPX racute s -10\nKPX racute sacute -10\nKPX racute scaron -10\nKPX racute scedilla -10\nKPX racute scommaaccent -10\nKPX rcaron a -15\nKPX rcaron aacute -15\nKPX rcaron abreve -15\nKPX rcaron acircumflex -15\nKPX rcaron adieresis -15\nKPX rcaron agrave -15\nKPX rcaron amacron -15\nKPX rcaron aogonek -15\nKPX rcaron aring -15\nKPX rcaron atilde -15\nKPX rcaron c -37\nKPX rcaron cacute -37\nKPX rcaron ccaron -37\nKPX rcaron ccedilla -37\nKPX rcaron comma -111\nKPX rcaron d -37\nKPX rcaron dcroat -37\nKPX rcaron e -37\nKPX rcaron eacute -37\nKPX rcaron ecaron -37\nKPX rcaron ecircumflex -37\nKPX rcaron edieresis -37\nKPX rcaron edotaccent -37\nKPX rcaron egrave -37\nKPX rcaron emacron -37\nKPX rcaron eogonek -37\nKPX rcaron g -37\nKPX rcaron gbreve -37\nKPX rcaron gcommaaccent -37\nKPX rcaron hyphen -20\nKPX rcaron o -45\nKPX rcaron oacute -45\nKPX rcaron ocircumflex -45\nKPX rcaron odieresis -45\nKPX rcaron ograve -45\nKPX rcaron ohungarumlaut -45\nKPX rcaron omacron -45\nKPX rcaron oslash -45\nKPX rcaron otilde -45\nKPX rcaron period -111\nKPX rcaron q -37\nKPX rcaron s -10\nKPX rcaron sacute -10\nKPX rcaron scaron -10\nKPX rcaron scedilla -10\nKPX rcaron scommaaccent -10\nKPX rcommaaccent a -15\nKPX rcommaaccent aacute -15\nKPX rcommaaccent abreve -15\nKPX rcommaaccent acircumflex -15\nKPX rcommaaccent adieresis -15\nKPX rcommaaccent agrave -15\nKPX rcommaaccent amacron -15\nKPX rcommaaccent aogonek -15\nKPX rcommaaccent aring -15\nKPX rcommaaccent atilde -15\nKPX rcommaaccent c -37\nKPX rcommaaccent cacute -37\nKPX rcommaaccent ccaron -37\nKPX rcommaaccent ccedilla -37\nKPX rcommaaccent comma -111\nKPX rcommaaccent d -37\nKPX rcommaaccent dcroat -37\nKPX rcommaaccent e -37\nKPX rcommaaccent eacute -37\nKPX rcommaaccent ecaron -37\nKPX rcommaaccent ecircumflex -37\nKPX rcommaaccent edieresis -37\nKPX rcommaaccent edotaccent -37\nKPX rcommaaccent egrave -37\nKPX rcommaaccent emacron -37\nKPX rcommaaccent eogonek -37\nKPX rcommaaccent g -37\nKPX rcommaaccent gbreve -37\nKPX rcommaaccent gcommaaccent -37\nKPX rcommaaccent hyphen -20\nKPX rcommaaccent o -45\nKPX rcommaaccent oacute -45\nKPX rcommaaccent ocircumflex -45\nKPX rcommaaccent odieresis -45\nKPX rcommaaccent ograve -45\nKPX rcommaaccent ohungarumlaut -45\nKPX rcommaaccent omacron -45\nKPX rcommaaccent oslash -45\nKPX rcommaaccent otilde -45\nKPX rcommaaccent period -111\nKPX rcommaaccent q -37\nKPX rcommaaccent s -10\nKPX rcommaaccent sacute -10\nKPX rcommaaccent scaron -10\nKPX rcommaaccent scedilla -10\nKPX rcommaaccent scommaaccent -10\nKPX space A -18\nKPX space Aacute -18\nKPX space Abreve -18\nKPX space Acircumflex -18\nKPX space Adieresis -18\nKPX space Agrave -18\nKPX space Amacron -18\nKPX space Aogonek -18\nKPX space Aring -18\nKPX space Atilde -18\nKPX space T -18\nKPX space Tcaron -18\nKPX space Tcommaaccent -18\nKPX space V -35\nKPX space W -40\nKPX space Y -75\nKPX space Yacute -75\nKPX space Ydieresis -75\nKPX v comma -74\nKPX v period -74\nKPX w comma -74\nKPX w period -74\nKPX y comma -55\nKPX y period -55\nKPX yacute comma -55\nKPX yacute period -55\nKPX ydieresis comma -55\nKPX ydieresis period -55\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    'Times-BoldItalic' () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\nComment Creation Date: Thu May  1 13:04:06 1997\nComment UniqueID 43066\nComment VMusage 45874 56899\nFontName Times-BoldItalic\nFullName Times Bold Italic\nFamilyName Times\nWeight Bold\nItalicAngle -15\nIsFixedPitch false\nCharacterSet ExtendedRoman\nFontBBox -200 -218 996 921 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\nEncodingScheme AdobeStandardEncoding\nCapHeight 669\nXHeight 462\nAscender 683\nDescender -217\nStdHW 42\nStdVW 121\nStartCharMetrics 315\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 389 ; N exclam ; B 67 -13 370 684 ;\nC 34 ; WX 555 ; N quotedbl ; B 136 398 536 685 ;\nC 35 ; WX 500 ; N numbersign ; B -33 0 533 700 ;\nC 36 ; WX 500 ; N dollar ; B -20 -100 497 733 ;\nC 37 ; WX 833 ; N percent ; B 39 -10 793 692 ;\nC 38 ; WX 778 ; N ampersand ; B 5 -19 699 682 ;\nC 39 ; WX 333 ; N quoteright ; B 98 369 302 685 ;\nC 40 ; WX 333 ; N parenleft ; B 28 -179 344 685 ;\nC 41 ; WX 333 ; N parenright ; B -44 -179 271 685 ;\nC 42 ; WX 500 ; N asterisk ; B 65 249 456 685 ;\nC 43 ; WX 570 ; N plus ; B 33 0 537 506 ;\nC 44 ; WX 250 ; N comma ; B -60 -182 144 134 ;\nC 45 ; WX 333 ; N hyphen ; B 2 166 271 282 ;\nC 46 ; WX 250 ; N period ; B -9 -13 139 135 ;\nC 47 ; WX 278 ; N slash ; B -64 -18 342 685 ;\nC 48 ; WX 500 ; N zero ; B 17 -14 477 683 ;\nC 49 ; WX 500 ; N one ; B 5 0 419 683 ;\nC 50 ; WX 500 ; N two ; B -27 0 446 683 ;\nC 51 ; WX 500 ; N three ; B -15 -13 450 683 ;\nC 52 ; WX 500 ; N four ; B -15 0 503 683 ;\nC 53 ; WX 500 ; N five ; B -11 -13 487 669 ;\nC 54 ; WX 500 ; N six ; B 23 -15 509 679 ;\nC 55 ; WX 500 ; N seven ; B 52 0 525 669 ;\nC 56 ; WX 500 ; N eight ; B 3 -13 476 683 ;\nC 57 ; WX 500 ; N nine ; B -12 -10 475 683 ;\nC 58 ; WX 333 ; N colon ; B 23 -13 264 459 ;\nC 59 ; WX 333 ; N semicolon ; B -25 -183 264 459 ;\nC 60 ; WX 570 ; N less ; B 31 -8 539 514 ;\nC 61 ; WX 570 ; N equal ; B 33 107 537 399 ;\nC 62 ; WX 570 ; N greater ; B 31 -8 539 514 ;\nC 63 ; WX 500 ; N question ; B 79 -13 470 684 ;\nC 64 ; WX 832 ; N at ; B 63 -18 770 685 ;\nC 65 ; WX 667 ; N A ; B -67 0 593 683 ;\nC 66 ; WX 667 ; N B ; B -24 0 624 669 ;\nC 67 ; WX 667 ; N C ; B 32 -18 677 685 ;\nC 68 ; WX 722 ; N D ; B -46 0 685 669 ;\nC 69 ; WX 667 ; N E ; B -27 0 653 669 ;\nC 70 ; WX 667 ; N F ; B -13 0 660 669 ;\nC 71 ; WX 722 ; N G ; B 21 -18 706 685 ;\nC 72 ; WX 778 ; N H ; B -24 0 799 669 ;\nC 73 ; WX 389 ; N I ; B -32 0 406 669 ;\nC 74 ; WX 500 ; N J ; B -46 -99 524 669 ;\nC 75 ; WX 667 ; N K ; B -21 0 702 669 ;\nC 76 ; WX 611 ; N L ; B -22 0 590 669 ;\nC 77 ; WX 889 ; N M ; B -29 -12 917 669 ;\nC 78 ; WX 722 ; N N ; B -27 -15 748 669 ;\nC 79 ; WX 722 ; N O ; B 27 -18 691 685 ;\nC 80 ; WX 611 ; N P ; B -27 0 613 669 ;\nC 81 ; WX 722 ; N Q ; B 27 -208 691 685 ;\nC 82 ; WX 667 ; N R ; B -29 0 623 669 ;\nC 83 ; WX 556 ; N S ; B 2 -18 526 685 ;\nC 84 ; WX 611 ; N T ; B 50 0 650 669 ;\nC 85 ; WX 722 ; N U ; B 67 -18 744 669 ;\nC 86 ; WX 667 ; N V ; B 65 -18 715 669 ;\nC 87 ; WX 889 ; N W ; B 65 -18 940 669 ;\nC 88 ; WX 667 ; N X ; B -24 0 694 669 ;\nC 89 ; WX 611 ; N Y ; B 73 0 659 669 ;\nC 90 ; WX 611 ; N Z ; B -11 0 590 669 ;\nC 91 ; WX 333 ; N bracketleft ; B -37 -159 362 674 ;\nC 92 ; WX 278 ; N backslash ; B -1 -18 279 685 ;\nC 93 ; WX 333 ; N bracketright ; B -56 -157 343 674 ;\nC 94 ; WX 570 ; N asciicircum ; B 67 304 503 669 ;\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\nC 96 ; WX 333 ; N quoteleft ; B 128 369 332 685 ;\nC 97 ; WX 500 ; N a ; B -21 -14 455 462 ;\nC 98 ; WX 500 ; N b ; B -14 -13 444 699 ;\nC 99 ; WX 444 ; N c ; B -5 -13 392 462 ;\nC 100 ; WX 500 ; N d ; B -21 -13 517 699 ;\nC 101 ; WX 444 ; N e ; B 5 -13 398 462 ;\nC 102 ; WX 333 ; N f ; B -169 -205 446 698 ; L i fi ; L l fl ;\nC 103 ; WX 500 ; N g ; B -52 -203 478 462 ;\nC 104 ; WX 556 ; N h ; B -13 -9 498 699 ;\nC 105 ; WX 278 ; N i ; B 2 -9 263 684 ;\nC 106 ; WX 278 ; N j ; B -189 -207 279 684 ;\nC 107 ; WX 500 ; N k ; B -23 -8 483 699 ;\nC 108 ; WX 278 ; N l ; B 2 -9 290 699 ;\nC 109 ; WX 778 ; N m ; B -14 -9 722 462 ;\nC 110 ; WX 556 ; N n ; B -6 -9 493 462 ;\nC 111 ; WX 500 ; N o ; B -3 -13 441 462 ;\nC 112 ; WX 500 ; N p ; B -120 -205 446 462 ;\nC 113 ; WX 500 ; N q ; B 1 -205 471 462 ;\nC 114 ; WX 389 ; N r ; B -21 0 389 462 ;\nC 115 ; WX 389 ; N s ; B -19 -13 333 462 ;\nC 116 ; WX 278 ; N t ; B -11 -9 281 594 ;\nC 117 ; WX 556 ; N u ; B 15 -9 492 462 ;\nC 118 ; WX 444 ; N v ; B 16 -13 401 462 ;\nC 119 ; WX 667 ; N w ; B 16 -13 614 462 ;\nC 120 ; WX 500 ; N x ; B -46 -13 469 462 ;\nC 121 ; WX 444 ; N y ; B -94 -205 392 462 ;\nC 122 ; WX 389 ; N z ; B -43 -78 368 449 ;\nC 123 ; WX 348 ; N braceleft ; B 5 -187 436 686 ;\nC 124 ; WX 220 ; N bar ; B 66 -218 154 782 ;\nC 125 ; WX 348 ; N braceright ; B -129 -187 302 686 ;\nC 126 ; WX 570 ; N asciitilde ; B 54 173 516 333 ;\nC 161 ; WX 389 ; N exclamdown ; B 19 -205 322 492 ;\nC 162 ; WX 500 ; N cent ; B 42 -143 439 576 ;\nC 163 ; WX 500 ; N sterling ; B -32 -12 510 683 ;\nC 164 ; WX 167 ; N fraction ; B -169 -14 324 683 ;\nC 165 ; WX 500 ; N yen ; B 33 0 628 669 ;\nC 166 ; WX 500 ; N florin ; B -87 -156 537 707 ;\nC 167 ; WX 500 ; N section ; B 36 -143 459 685 ;\nC 168 ; WX 500 ; N currency ; B -26 34 526 586 ;\nC 169 ; WX 278 ; N quotesingle ; B 128 398 268 685 ;\nC 170 ; WX 500 ; N quotedblleft ; B 53 369 513 685 ;\nC 171 ; WX 500 ; N guillemotleft ; B 12 32 468 415 ;\nC 172 ; WX 333 ; N guilsinglleft ; B 32 32 303 415 ;\nC 173 ; WX 333 ; N guilsinglright ; B 10 32 281 415 ;\nC 174 ; WX 556 ; N fi ; B -188 -205 514 703 ;\nC 175 ; WX 556 ; N fl ; B -186 -205 553 704 ;\nC 177 ; WX 500 ; N endash ; B -40 178 477 269 ;\nC 178 ; WX 500 ; N dagger ; B 91 -145 494 685 ;\nC 179 ; WX 500 ; N daggerdbl ; B 10 -139 493 685 ;\nC 180 ; WX 250 ; N periodcentered ; B 51 257 199 405 ;\nC 182 ; WX 500 ; N paragraph ; B -57 -193 562 669 ;\nC 183 ; WX 350 ; N bullet ; B 0 175 350 525 ;\nC 184 ; WX 333 ; N quotesinglbase ; B -5 -182 199 134 ;\nC 185 ; WX 500 ; N quotedblbase ; B -57 -182 403 134 ;\nC 186 ; WX 500 ; N quotedblright ; B 53 369 513 685 ;\nC 187 ; WX 500 ; N guillemotright ; B 12 32 468 415 ;\nC 188 ; WX 1000 ; N ellipsis ; B 40 -13 852 135 ;\nC 189 ; WX 1000 ; N perthousand ; B 7 -29 996 706 ;\nC 191 ; WX 500 ; N questiondown ; B 30 -205 421 492 ;\nC 193 ; WX 333 ; N grave ; B 85 516 297 697 ;\nC 194 ; WX 333 ; N acute ; B 139 516 379 697 ;\nC 195 ; WX 333 ; N circumflex ; B 40 516 367 690 ;\nC 196 ; WX 333 ; N tilde ; B 48 536 407 655 ;\nC 197 ; WX 333 ; N macron ; B 51 553 393 623 ;\nC 198 ; WX 333 ; N breve ; B 71 516 387 678 ;\nC 199 ; WX 333 ; N dotaccent ; B 163 550 298 684 ;\nC 200 ; WX 333 ; N dieresis ; B 55 550 402 684 ;\nC 202 ; WX 333 ; N ring ; B 127 516 340 729 ;\nC 203 ; WX 333 ; N cedilla ; B -80 -218 156 5 ;\nC 205 ; WX 333 ; N hungarumlaut ; B 69 516 498 697 ;\nC 206 ; WX 333 ; N ogonek ; B 15 -183 244 34 ;\nC 207 ; WX 333 ; N caron ; B 79 516 411 690 ;\nC 208 ; WX 1000 ; N emdash ; B -40 178 977 269 ;\nC 225 ; WX 944 ; N AE ; B -64 0 918 669 ;\nC 227 ; WX 266 ; N ordfeminine ; B 16 399 330 685 ;\nC 232 ; WX 611 ; N Lslash ; B -22 0 590 669 ;\nC 233 ; WX 722 ; N Oslash ; B 27 -125 691 764 ;\nC 234 ; WX 944 ; N OE ; B 23 -8 946 677 ;\nC 235 ; WX 300 ; N ordmasculine ; B 56 400 347 685 ;\nC 241 ; WX 722 ; N ae ; B -5 -13 673 462 ;\nC 245 ; WX 278 ; N dotlessi ; B 2 -9 238 462 ;\nC 248 ; WX 278 ; N lslash ; B -7 -9 307 699 ;\nC 249 ; WX 500 ; N oslash ; B -3 -119 441 560 ;\nC 250 ; WX 722 ; N oe ; B 6 -13 674 462 ;\nC 251 ; WX 500 ; N germandbls ; B -200 -200 473 705 ;\nC -1 ; WX 389 ; N Idieresis ; B -32 0 450 862 ;\nC -1 ; WX 444 ; N eacute ; B 5 -13 435 697 ;\nC -1 ; WX 500 ; N abreve ; B -21 -14 471 678 ;\nC -1 ; WX 556 ; N uhungarumlaut ; B 15 -9 610 697 ;\nC -1 ; WX 444 ; N ecaron ; B 5 -13 467 690 ;\nC -1 ; WX 611 ; N Ydieresis ; B 73 0 659 862 ;\nC -1 ; WX 570 ; N divide ; B 33 -29 537 535 ;\nC -1 ; WX 611 ; N Yacute ; B 73 0 659 904 ;\nC -1 ; WX 667 ; N Acircumflex ; B -67 0 593 897 ;\nC -1 ; WX 500 ; N aacute ; B -21 -14 463 697 ;\nC -1 ; WX 722 ; N Ucircumflex ; B 67 -18 744 897 ;\nC -1 ; WX 444 ; N yacute ; B -94 -205 435 697 ;\nC -1 ; WX 389 ; N scommaaccent ; B -19 -218 333 462 ;\nC -1 ; WX 444 ; N ecircumflex ; B 5 -13 423 690 ;\nC -1 ; WX 722 ; N Uring ; B 67 -18 744 921 ;\nC -1 ; WX 722 ; N Udieresis ; B 67 -18 744 862 ;\nC -1 ; WX 500 ; N aogonek ; B -21 -183 455 462 ;\nC -1 ; WX 722 ; N Uacute ; B 67 -18 744 904 ;\nC -1 ; WX 556 ; N uogonek ; B 15 -183 492 462 ;\nC -1 ; WX 667 ; N Edieresis ; B -27 0 653 862 ;\nC -1 ; WX 722 ; N Dcroat ; B -31 0 700 669 ;\nC -1 ; WX 250 ; N commaaccent ; B -36 -218 131 -50 ;\nC -1 ; WX 747 ; N copyright ; B 30 -18 718 685 ;\nC -1 ; WX 667 ; N Emacron ; B -27 0 653 830 ;\nC -1 ; WX 444 ; N ccaron ; B -5 -13 467 690 ;\nC -1 ; WX 500 ; N aring ; B -21 -14 455 729 ;\nC -1 ; WX 722 ; N Ncommaaccent ; B -27 -218 748 669 ;\nC -1 ; WX 278 ; N lacute ; B 2 -9 392 904 ;\nC -1 ; WX 500 ; N agrave ; B -21 -14 455 697 ;\nC -1 ; WX 611 ; N Tcommaaccent ; B 50 -218 650 669 ;\nC -1 ; WX 667 ; N Cacute ; B 32 -18 677 904 ;\nC -1 ; WX 500 ; N atilde ; B -21 -14 491 655 ;\nC -1 ; WX 667 ; N Edotaccent ; B -27 0 653 862 ;\nC -1 ; WX 389 ; N scaron ; B -19 -13 424 690 ;\nC -1 ; WX 389 ; N scedilla ; B -19 -218 333 462 ;\nC -1 ; WX 278 ; N iacute ; B 2 -9 352 697 ;\nC -1 ; WX 494 ; N lozenge ; B 10 0 484 745 ;\nC -1 ; WX 667 ; N Rcaron ; B -29 0 623 897 ;\nC -1 ; WX 722 ; N Gcommaaccent ; B 21 -218 706 685 ;\nC -1 ; WX 556 ; N ucircumflex ; B 15 -9 492 690 ;\nC -1 ; WX 500 ; N acircumflex ; B -21 -14 455 690 ;\nC -1 ; WX 667 ; N Amacron ; B -67 0 593 830 ;\nC -1 ; WX 389 ; N rcaron ; B -21 0 424 690 ;\nC -1 ; WX 444 ; N ccedilla ; B -5 -218 392 462 ;\nC -1 ; WX 611 ; N Zdotaccent ; B -11 0 590 862 ;\nC -1 ; WX 611 ; N Thorn ; B -27 0 573 669 ;\nC -1 ; WX 722 ; N Omacron ; B 27 -18 691 830 ;\nC -1 ; WX 667 ; N Racute ; B -29 0 623 904 ;\nC -1 ; WX 556 ; N Sacute ; B 2 -18 531 904 ;\nC -1 ; WX 608 ; N dcaron ; B -21 -13 675 708 ;\nC -1 ; WX 722 ; N Umacron ; B 67 -18 744 830 ;\nC -1 ; WX 556 ; N uring ; B 15 -9 492 729 ;\nC -1 ; WX 300 ; N threesuperior ; B 17 265 321 683 ;\nC -1 ; WX 722 ; N Ograve ; B 27 -18 691 904 ;\nC -1 ; WX 667 ; N Agrave ; B -67 0 593 904 ;\nC -1 ; WX 667 ; N Abreve ; B -67 0 593 885 ;\nC -1 ; WX 570 ; N multiply ; B 48 16 522 490 ;\nC -1 ; WX 556 ; N uacute ; B 15 -9 492 697 ;\nC -1 ; WX 611 ; N Tcaron ; B 50 0 650 897 ;\nC -1 ; WX 494 ; N partialdiff ; B 11 -21 494 750 ;\nC -1 ; WX 444 ; N ydieresis ; B -94 -205 443 655 ;\nC -1 ; WX 722 ; N Nacute ; B -27 -15 748 904 ;\nC -1 ; WX 278 ; N icircumflex ; B -3 -9 324 690 ;\nC -1 ; WX 667 ; N Ecircumflex ; B -27 0 653 897 ;\nC -1 ; WX 500 ; N adieresis ; B -21 -14 476 655 ;\nC -1 ; WX 444 ; N edieresis ; B 5 -13 448 655 ;\nC -1 ; WX 444 ; N cacute ; B -5 -13 435 697 ;\nC -1 ; WX 556 ; N nacute ; B -6 -9 493 697 ;\nC -1 ; WX 556 ; N umacron ; B 15 -9 492 623 ;\nC -1 ; WX 722 ; N Ncaron ; B -27 -15 748 897 ;\nC -1 ; WX 389 ; N Iacute ; B -32 0 432 904 ;\nC -1 ; WX 570 ; N plusminus ; B 33 0 537 506 ;\nC -1 ; WX 220 ; N brokenbar ; B 66 -143 154 707 ;\nC -1 ; WX 747 ; N registered ; B 30 -18 718 685 ;\nC -1 ; WX 722 ; N Gbreve ; B 21 -18 706 885 ;\nC -1 ; WX 389 ; N Idotaccent ; B -32 0 406 862 ;\nC -1 ; WX 600 ; N summation ; B 14 -10 585 706 ;\nC -1 ; WX 667 ; N Egrave ; B -27 0 653 904 ;\nC -1 ; WX 389 ; N racute ; B -21 0 407 697 ;\nC -1 ; WX 500 ; N omacron ; B -3 -13 462 623 ;\nC -1 ; WX 611 ; N Zacute ; B -11 0 590 904 ;\nC -1 ; WX 611 ; N Zcaron ; B -11 0 590 897 ;\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 704 ;\nC -1 ; WX 722 ; N Eth ; B -31 0 700 669 ;\nC -1 ; WX 667 ; N Ccedilla ; B 32 -218 677 685 ;\nC -1 ; WX 278 ; N lcommaaccent ; B -42 -218 290 699 ;\nC -1 ; WX 366 ; N tcaron ; B -11 -9 434 754 ;\nC -1 ; WX 444 ; N eogonek ; B 5 -183 398 462 ;\nC -1 ; WX 722 ; N Uogonek ; B 67 -183 744 669 ;\nC -1 ; WX 667 ; N Aacute ; B -67 0 593 904 ;\nC -1 ; WX 667 ; N Adieresis ; B -67 0 593 862 ;\nC -1 ; WX 444 ; N egrave ; B 5 -13 398 697 ;\nC -1 ; WX 389 ; N zacute ; B -43 -78 407 697 ;\nC -1 ; WX 278 ; N iogonek ; B -20 -183 263 684 ;\nC -1 ; WX 722 ; N Oacute ; B 27 -18 691 904 ;\nC -1 ; WX 500 ; N oacute ; B -3 -13 463 697 ;\nC -1 ; WX 500 ; N amacron ; B -21 -14 467 623 ;\nC -1 ; WX 389 ; N sacute ; B -19 -13 407 697 ;\nC -1 ; WX 278 ; N idieresis ; B 2 -9 364 655 ;\nC -1 ; WX 722 ; N Ocircumflex ; B 27 -18 691 897 ;\nC -1 ; WX 722 ; N Ugrave ; B 67 -18 744 904 ;\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC -1 ; WX 500 ; N thorn ; B -120 -205 446 699 ;\nC -1 ; WX 300 ; N twosuperior ; B 2 274 313 683 ;\nC -1 ; WX 722 ; N Odieresis ; B 27 -18 691 862 ;\nC -1 ; WX 576 ; N mu ; B -60 -207 516 449 ;\nC -1 ; WX 278 ; N igrave ; B 2 -9 259 697 ;\nC -1 ; WX 500 ; N ohungarumlaut ; B -3 -13 582 697 ;\nC -1 ; WX 667 ; N Eogonek ; B -27 -183 653 669 ;\nC -1 ; WX 500 ; N dcroat ; B -21 -13 552 699 ;\nC -1 ; WX 750 ; N threequarters ; B 7 -14 726 683 ;\nC -1 ; WX 556 ; N Scedilla ; B 2 -218 526 685 ;\nC -1 ; WX 382 ; N lcaron ; B 2 -9 448 708 ;\nC -1 ; WX 667 ; N Kcommaaccent ; B -21 -218 702 669 ;\nC -1 ; WX 611 ; N Lacute ; B -22 0 590 904 ;\nC -1 ; WX 1000 ; N trademark ; B 32 263 968 669 ;\nC -1 ; WX 444 ; N edotaccent ; B 5 -13 398 655 ;\nC -1 ; WX 389 ; N Igrave ; B -32 0 406 904 ;\nC -1 ; WX 389 ; N Imacron ; B -32 0 461 830 ;\nC -1 ; WX 611 ; N Lcaron ; B -22 0 671 718 ;\nC -1 ; WX 750 ; N onehalf ; B -9 -14 723 683 ;\nC -1 ; WX 549 ; N lessequal ; B 29 0 526 704 ;\nC -1 ; WX 500 ; N ocircumflex ; B -3 -13 451 690 ;\nC -1 ; WX 556 ; N ntilde ; B -6 -9 504 655 ;\nC -1 ; WX 722 ; N Uhungarumlaut ; B 67 -18 744 904 ;\nC -1 ; WX 667 ; N Eacute ; B -27 0 653 904 ;\nC -1 ; WX 444 ; N emacron ; B 5 -13 439 623 ;\nC -1 ; WX 500 ; N gbreve ; B -52 -203 478 678 ;\nC -1 ; WX 750 ; N onequarter ; B 7 -14 721 683 ;\nC -1 ; WX 556 ; N Scaron ; B 2 -18 553 897 ;\nC -1 ; WX 556 ; N Scommaaccent ; B 2 -218 526 685 ;\nC -1 ; WX 722 ; N Ohungarumlaut ; B 27 -18 723 904 ;\nC -1 ; WX 400 ; N degree ; B 83 397 369 683 ;\nC -1 ; WX 500 ; N ograve ; B -3 -13 441 697 ;\nC -1 ; WX 667 ; N Ccaron ; B 32 -18 677 897 ;\nC -1 ; WX 556 ; N ugrave ; B 15 -9 492 697 ;\nC -1 ; WX 549 ; N radical ; B 10 -46 512 850 ;\nC -1 ; WX 722 ; N Dcaron ; B -46 0 685 897 ;\nC -1 ; WX 389 ; N rcommaaccent ; B -67 -218 389 462 ;\nC -1 ; WX 722 ; N Ntilde ; B -27 -15 748 862 ;\nC -1 ; WX 500 ; N otilde ; B -3 -13 491 655 ;\nC -1 ; WX 667 ; N Rcommaaccent ; B -29 -218 623 669 ;\nC -1 ; WX 611 ; N Lcommaaccent ; B -22 -218 590 669 ;\nC -1 ; WX 667 ; N Atilde ; B -67 0 593 862 ;\nC -1 ; WX 667 ; N Aogonek ; B -67 -183 604 683 ;\nC -1 ; WX 667 ; N Aring ; B -67 0 593 921 ;\nC -1 ; WX 722 ; N Otilde ; B 27 -18 691 862 ;\nC -1 ; WX 389 ; N zdotaccent ; B -43 -78 368 655 ;\nC -1 ; WX 667 ; N Ecaron ; B -27 0 653 897 ;\nC -1 ; WX 389 ; N Iogonek ; B -32 -183 406 669 ;\nC -1 ; WX 500 ; N kcommaaccent ; B -23 -218 483 699 ;\nC -1 ; WX 606 ; N minus ; B 51 209 555 297 ;\nC -1 ; WX 389 ; N Icircumflex ; B -32 0 450 897 ;\nC -1 ; WX 556 ; N ncaron ; B -6 -9 523 690 ;\nC -1 ; WX 278 ; N tcommaaccent ; B -62 -218 281 594 ;\nC -1 ; WX 606 ; N logicalnot ; B 51 108 555 399 ;\nC -1 ; WX 500 ; N odieresis ; B -3 -13 471 655 ;\nC -1 ; WX 556 ; N udieresis ; B 15 -9 499 655 ;\nC -1 ; WX 549 ; N notequal ; B 15 -49 540 570 ;\nC -1 ; WX 500 ; N gcommaaccent ; B -52 -203 478 767 ;\nC -1 ; WX 500 ; N eth ; B -3 -13 454 699 ;\nC -1 ; WX 389 ; N zcaron ; B -43 -78 424 690 ;\nC -1 ; WX 556 ; N ncommaaccent ; B -6 -218 493 462 ;\nC -1 ; WX 300 ; N onesuperior ; B 30 274 301 683 ;\nC -1 ; WX 278 ; N imacron ; B 2 -9 294 623 ;\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\nEndCharMetrics\nStartKernData\nStartKernPairs 2038\nKPX A C -65\nKPX A Cacute -65\nKPX A Ccaron -65\nKPX A Ccedilla -65\nKPX A G -60\nKPX A Gbreve -60\nKPX A Gcommaaccent -60\nKPX A O -50\nKPX A Oacute -50\nKPX A Ocircumflex -50\nKPX A Odieresis -50\nKPX A Ograve -50\nKPX A Ohungarumlaut -50\nKPX A Omacron -50\nKPX A Oslash -50\nKPX A Otilde -50\nKPX A Q -55\nKPX A T -55\nKPX A Tcaron -55\nKPX A Tcommaaccent -55\nKPX A U -50\nKPX A Uacute -50\nKPX A Ucircumflex -50\nKPX A Udieresis -50\nKPX A Ugrave -50\nKPX A Uhungarumlaut -50\nKPX A Umacron -50\nKPX A Uogonek -50\nKPX A Uring -50\nKPX A V -95\nKPX A W -100\nKPX A Y -70\nKPX A Yacute -70\nKPX A Ydieresis -70\nKPX A quoteright -74\nKPX A u -30\nKPX A uacute -30\nKPX A ucircumflex -30\nKPX A udieresis -30\nKPX A ugrave -30\nKPX A uhungarumlaut -30\nKPX A umacron -30\nKPX A uogonek -30\nKPX A uring -30\nKPX A v -74\nKPX A w -74\nKPX A y -74\nKPX A yacute -74\nKPX A ydieresis -74\nKPX Aacute C -65\nKPX Aacute Cacute -65\nKPX Aacute Ccaron -65\nKPX Aacute Ccedilla -65\nKPX Aacute G -60\nKPX Aacute Gbreve -60\nKPX Aacute Gcommaaccent -60\nKPX Aacute O -50\nKPX Aacute Oacute -50\nKPX Aacute Ocircumflex -50\nKPX Aacute Odieresis -50\nKPX Aacute Ograve -50\nKPX Aacute Ohungarumlaut -50\nKPX Aacute Omacron -50\nKPX Aacute Oslash -50\nKPX Aacute Otilde -50\nKPX Aacute Q -55\nKPX Aacute T -55\nKPX Aacute Tcaron -55\nKPX Aacute Tcommaaccent -55\nKPX Aacute U -50\nKPX Aacute Uacute -50\nKPX Aacute Ucircumflex -50\nKPX Aacute Udieresis -50\nKPX Aacute Ugrave -50\nKPX Aacute Uhungarumlaut -50\nKPX Aacute Umacron -50\nKPX Aacute Uogonek -50\nKPX Aacute Uring -50\nKPX Aacute V -95\nKPX Aacute W -100\nKPX Aacute Y -70\nKPX Aacute Yacute -70\nKPX Aacute Ydieresis -70\nKPX Aacute quoteright -74\nKPX Aacute u -30\nKPX Aacute uacute -30\nKPX Aacute ucircumflex -30\nKPX Aacute udieresis -30\nKPX Aacute ugrave -30\nKPX Aacute uhungarumlaut -30\nKPX Aacute umacron -30\nKPX Aacute uogonek -30\nKPX Aacute uring -30\nKPX Aacute v -74\nKPX Aacute w -74\nKPX Aacute y -74\nKPX Aacute yacute -74\nKPX Aacute ydieresis -74\nKPX Abreve C -65\nKPX Abreve Cacute -65\nKPX Abreve Ccaron -65\nKPX Abreve Ccedilla -65\nKPX Abreve G -60\nKPX Abreve Gbreve -60\nKPX Abreve Gcommaaccent -60\nKPX Abreve O -50\nKPX Abreve Oacute -50\nKPX Abreve Ocircumflex -50\nKPX Abreve Odieresis -50\nKPX Abreve Ograve -50\nKPX Abreve Ohungarumlaut -50\nKPX Abreve Omacron -50\nKPX Abreve Oslash -50\nKPX Abreve Otilde -50\nKPX Abreve Q -55\nKPX Abreve T -55\nKPX Abreve Tcaron -55\nKPX Abreve Tcommaaccent -55\nKPX Abreve U -50\nKPX Abreve Uacute -50\nKPX Abreve Ucircumflex -50\nKPX Abreve Udieresis -50\nKPX Abreve Ugrave -50\nKPX Abreve Uhungarumlaut -50\nKPX Abreve Umacron -50\nKPX Abreve Uogonek -50\nKPX Abreve Uring -50\nKPX Abreve V -95\nKPX Abreve W -100\nKPX Abreve Y -70\nKPX Abreve Yacute -70\nKPX Abreve Ydieresis -70\nKPX Abreve quoteright -74\nKPX Abreve u -30\nKPX Abreve uacute -30\nKPX Abreve ucircumflex -30\nKPX Abreve udieresis -30\nKPX Abreve ugrave -30\nKPX Abreve uhungarumlaut -30\nKPX Abreve umacron -30\nKPX Abreve uogonek -30\nKPX Abreve uring -30\nKPX Abreve v -74\nKPX Abreve w -74\nKPX Abreve y -74\nKPX Abreve yacute -74\nKPX Abreve ydieresis -74\nKPX Acircumflex C -65\nKPX Acircumflex Cacute -65\nKPX Acircumflex Ccaron -65\nKPX Acircumflex Ccedilla -65\nKPX Acircumflex G -60\nKPX Acircumflex Gbreve -60\nKPX Acircumflex Gcommaaccent -60\nKPX Acircumflex O -50\nKPX Acircumflex Oacute -50\nKPX Acircumflex Ocircumflex -50\nKPX Acircumflex Odieresis -50\nKPX Acircumflex Ograve -50\nKPX Acircumflex Ohungarumlaut -50\nKPX Acircumflex Omacron -50\nKPX Acircumflex Oslash -50\nKPX Acircumflex Otilde -50\nKPX Acircumflex Q -55\nKPX Acircumflex T -55\nKPX Acircumflex Tcaron -55\nKPX Acircumflex Tcommaaccent -55\nKPX Acircumflex U -50\nKPX Acircumflex Uacute -50\nKPX Acircumflex Ucircumflex -50\nKPX Acircumflex Udieresis -50\nKPX Acircumflex Ugrave -50\nKPX Acircumflex Uhungarumlaut -50\nKPX Acircumflex Umacron -50\nKPX Acircumflex Uogonek -50\nKPX Acircumflex Uring -50\nKPX Acircumflex V -95\nKPX Acircumflex W -100\nKPX Acircumflex Y -70\nKPX Acircumflex Yacute -70\nKPX Acircumflex Ydieresis -70\nKPX Acircumflex quoteright -74\nKPX Acircumflex u -30\nKPX Acircumflex uacute -30\nKPX Acircumflex ucircumflex -30\nKPX Acircumflex udieresis -30\nKPX Acircumflex ugrave -30\nKPX Acircumflex uhungarumlaut -30\nKPX Acircumflex umacron -30\nKPX Acircumflex uogonek -30\nKPX Acircumflex uring -30\nKPX Acircumflex v -74\nKPX Acircumflex w -74\nKPX Acircumflex y -74\nKPX Acircumflex yacute -74\nKPX Acircumflex ydieresis -74\nKPX Adieresis C -65\nKPX Adieresis Cacute -65\nKPX Adieresis Ccaron -65\nKPX Adieresis Ccedilla -65\nKPX Adieresis G -60\nKPX Adieresis Gbreve -60\nKPX Adieresis Gcommaaccent -60\nKPX Adieresis O -50\nKPX Adieresis Oacute -50\nKPX Adieresis Ocircumflex -50\nKPX Adieresis Odieresis -50\nKPX Adieresis Ograve -50\nKPX Adieresis Ohungarumlaut -50\nKPX Adieresis Omacron -50\nKPX Adieresis Oslash -50\nKPX Adieresis Otilde -50\nKPX Adieresis Q -55\nKPX Adieresis T -55\nKPX Adieresis Tcaron -55\nKPX Adieresis Tcommaaccent -55\nKPX Adieresis U -50\nKPX Adieresis Uacute -50\nKPX Adieresis Ucircumflex -50\nKPX Adieresis Udieresis -50\nKPX Adieresis Ugrave -50\nKPX Adieresis Uhungarumlaut -50\nKPX Adieresis Umacron -50\nKPX Adieresis Uogonek -50\nKPX Adieresis Uring -50\nKPX Adieresis V -95\nKPX Adieresis W -100\nKPX Adieresis Y -70\nKPX Adieresis Yacute -70\nKPX Adieresis Ydieresis -70\nKPX Adieresis quoteright -74\nKPX Adieresis u -30\nKPX Adieresis uacute -30\nKPX Adieresis ucircumflex -30\nKPX Adieresis udieresis -30\nKPX Adieresis ugrave -30\nKPX Adieresis uhungarumlaut -30\nKPX Adieresis umacron -30\nKPX Adieresis uogonek -30\nKPX Adieresis uring -30\nKPX Adieresis v -74\nKPX Adieresis w -74\nKPX Adieresis y -74\nKPX Adieresis yacute -74\nKPX Adieresis ydieresis -74\nKPX Agrave C -65\nKPX Agrave Cacute -65\nKPX Agrave Ccaron -65\nKPX Agrave Ccedilla -65\nKPX Agrave G -60\nKPX Agrave Gbreve -60\nKPX Agrave Gcommaaccent -60\nKPX Agrave O -50\nKPX Agrave Oacute -50\nKPX Agrave Ocircumflex -50\nKPX Agrave Odieresis -50\nKPX Agrave Ograve -50\nKPX Agrave Ohungarumlaut -50\nKPX Agrave Omacron -50\nKPX Agrave Oslash -50\nKPX Agrave Otilde -50\nKPX Agrave Q -55\nKPX Agrave T -55\nKPX Agrave Tcaron -55\nKPX Agrave Tcommaaccent -55\nKPX Agrave U -50\nKPX Agrave Uacute -50\nKPX Agrave Ucircumflex -50\nKPX Agrave Udieresis -50\nKPX Agrave Ugrave -50\nKPX Agrave Uhungarumlaut -50\nKPX Agrave Umacron -50\nKPX Agrave Uogonek -50\nKPX Agrave Uring -50\nKPX Agrave V -95\nKPX Agrave W -100\nKPX Agrave Y -70\nKPX Agrave Yacute -70\nKPX Agrave Ydieresis -70\nKPX Agrave quoteright -74\nKPX Agrave u -30\nKPX Agrave uacute -30\nKPX Agrave ucircumflex -30\nKPX Agrave udieresis -30\nKPX Agrave ugrave -30\nKPX Agrave uhungarumlaut -30\nKPX Agrave umacron -30\nKPX Agrave uogonek -30\nKPX Agrave uring -30\nKPX Agrave v -74\nKPX Agrave w -74\nKPX Agrave y -74\nKPX Agrave yacute -74\nKPX Agrave ydieresis -74\nKPX Amacron C -65\nKPX Amacron Cacute -65\nKPX Amacron Ccaron -65\nKPX Amacron Ccedilla -65\nKPX Amacron G -60\nKPX Amacron Gbreve -60\nKPX Amacron Gcommaaccent -60\nKPX Amacron O -50\nKPX Amacron Oacute -50\nKPX Amacron Ocircumflex -50\nKPX Amacron Odieresis -50\nKPX Amacron Ograve -50\nKPX Amacron Ohungarumlaut -50\nKPX Amacron Omacron -50\nKPX Amacron Oslash -50\nKPX Amacron Otilde -50\nKPX Amacron Q -55\nKPX Amacron T -55\nKPX Amacron Tcaron -55\nKPX Amacron Tcommaaccent -55\nKPX Amacron U -50\nKPX Amacron Uacute -50\nKPX Amacron Ucircumflex -50\nKPX Amacron Udieresis -50\nKPX Amacron Ugrave -50\nKPX Amacron Uhungarumlaut -50\nKPX Amacron Umacron -50\nKPX Amacron Uogonek -50\nKPX Amacron Uring -50\nKPX Amacron V -95\nKPX Amacron W -100\nKPX Amacron Y -70\nKPX Amacron Yacute -70\nKPX Amacron Ydieresis -70\nKPX Amacron quoteright -74\nKPX Amacron u -30\nKPX Amacron uacute -30\nKPX Amacron ucircumflex -30\nKPX Amacron udieresis -30\nKPX Amacron ugrave -30\nKPX Amacron uhungarumlaut -30\nKPX Amacron umacron -30\nKPX Amacron uogonek -30\nKPX Amacron uring -30\nKPX Amacron v -74\nKPX Amacron w -74\nKPX Amacron y -74\nKPX Amacron yacute -74\nKPX Amacron ydieresis -74\nKPX Aogonek C -65\nKPX Aogonek Cacute -65\nKPX Aogonek Ccaron -65\nKPX Aogonek Ccedilla -65\nKPX Aogonek G -60\nKPX Aogonek Gbreve -60\nKPX Aogonek Gcommaaccent -60\nKPX Aogonek O -50\nKPX Aogonek Oacute -50\nKPX Aogonek Ocircumflex -50\nKPX Aogonek Odieresis -50\nKPX Aogonek Ograve -50\nKPX Aogonek Ohungarumlaut -50\nKPX Aogonek Omacron -50\nKPX Aogonek Oslash -50\nKPX Aogonek Otilde -50\nKPX Aogonek Q -55\nKPX Aogonek T -55\nKPX Aogonek Tcaron -55\nKPX Aogonek Tcommaaccent -55\nKPX Aogonek U -50\nKPX Aogonek Uacute -50\nKPX Aogonek Ucircumflex -50\nKPX Aogonek Udieresis -50\nKPX Aogonek Ugrave -50\nKPX Aogonek Uhungarumlaut -50\nKPX Aogonek Umacron -50\nKPX Aogonek Uogonek -50\nKPX Aogonek Uring -50\nKPX Aogonek V -95\nKPX Aogonek W -100\nKPX Aogonek Y -70\nKPX Aogonek Yacute -70\nKPX Aogonek Ydieresis -70\nKPX Aogonek quoteright -74\nKPX Aogonek u -30\nKPX Aogonek uacute -30\nKPX Aogonek ucircumflex -30\nKPX Aogonek udieresis -30\nKPX Aogonek ugrave -30\nKPX Aogonek uhungarumlaut -30\nKPX Aogonek umacron -30\nKPX Aogonek uogonek -30\nKPX Aogonek uring -30\nKPX Aogonek v -74\nKPX Aogonek w -74\nKPX Aogonek y -34\nKPX Aogonek yacute -34\nKPX Aogonek ydieresis -34\nKPX Aring C -65\nKPX Aring Cacute -65\nKPX Aring Ccaron -65\nKPX Aring Ccedilla -65\nKPX Aring G -60\nKPX Aring Gbreve -60\nKPX Aring Gcommaaccent -60\nKPX Aring O -50\nKPX Aring Oacute -50\nKPX Aring Ocircumflex -50\nKPX Aring Odieresis -50\nKPX Aring Ograve -50\nKPX Aring Ohungarumlaut -50\nKPX Aring Omacron -50\nKPX Aring Oslash -50\nKPX Aring Otilde -50\nKPX Aring Q -55\nKPX Aring T -55\nKPX Aring Tcaron -55\nKPX Aring Tcommaaccent -55\nKPX Aring U -50\nKPX Aring Uacute -50\nKPX Aring Ucircumflex -50\nKPX Aring Udieresis -50\nKPX Aring Ugrave -50\nKPX Aring Uhungarumlaut -50\nKPX Aring Umacron -50\nKPX Aring Uogonek -50\nKPX Aring Uring -50\nKPX Aring V -95\nKPX Aring W -100\nKPX Aring Y -70\nKPX Aring Yacute -70\nKPX Aring Ydieresis -70\nKPX Aring quoteright -74\nKPX Aring u -30\nKPX Aring uacute -30\nKPX Aring ucircumflex -30\nKPX Aring udieresis -30\nKPX Aring ugrave -30\nKPX Aring uhungarumlaut -30\nKPX Aring umacron -30\nKPX Aring uogonek -30\nKPX Aring uring -30\nKPX Aring v -74\nKPX Aring w -74\nKPX Aring y -74\nKPX Aring yacute -74\nKPX Aring ydieresis -74\nKPX Atilde C -65\nKPX Atilde Cacute -65\nKPX Atilde Ccaron -65\nKPX Atilde Ccedilla -65\nKPX Atilde G -60\nKPX Atilde Gbreve -60\nKPX Atilde Gcommaaccent -60\nKPX Atilde O -50\nKPX Atilde Oacute -50\nKPX Atilde Ocircumflex -50\nKPX Atilde Odieresis -50\nKPX Atilde Ograve -50\nKPX Atilde Ohungarumlaut -50\nKPX Atilde Omacron -50\nKPX Atilde Oslash -50\nKPX Atilde Otilde -50\nKPX Atilde Q -55\nKPX Atilde T -55\nKPX Atilde Tcaron -55\nKPX Atilde Tcommaaccent -55\nKPX Atilde U -50\nKPX Atilde Uacute -50\nKPX Atilde Ucircumflex -50\nKPX Atilde Udieresis -50\nKPX Atilde Ugrave -50\nKPX Atilde Uhungarumlaut -50\nKPX Atilde Umacron -50\nKPX Atilde Uogonek -50\nKPX Atilde Uring -50\nKPX Atilde V -95\nKPX Atilde W -100\nKPX Atilde Y -70\nKPX Atilde Yacute -70\nKPX Atilde Ydieresis -70\nKPX Atilde quoteright -74\nKPX Atilde u -30\nKPX Atilde uacute -30\nKPX Atilde ucircumflex -30\nKPX Atilde udieresis -30\nKPX Atilde ugrave -30\nKPX Atilde uhungarumlaut -30\nKPX Atilde umacron -30\nKPX Atilde uogonek -30\nKPX Atilde uring -30\nKPX Atilde v -74\nKPX Atilde w -74\nKPX Atilde y -74\nKPX Atilde yacute -74\nKPX Atilde ydieresis -74\nKPX B A -25\nKPX B Aacute -25\nKPX B Abreve -25\nKPX B Acircumflex -25\nKPX B Adieresis -25\nKPX B Agrave -25\nKPX B Amacron -25\nKPX B Aogonek -25\nKPX B Aring -25\nKPX B Atilde -25\nKPX B U -10\nKPX B Uacute -10\nKPX B Ucircumflex -10\nKPX B Udieresis -10\nKPX B Ugrave -10\nKPX B Uhungarumlaut -10\nKPX B Umacron -10\nKPX B Uogonek -10\nKPX B Uring -10\nKPX D A -25\nKPX D Aacute -25\nKPX D Abreve -25\nKPX D Acircumflex -25\nKPX D Adieresis -25\nKPX D Agrave -25\nKPX D Amacron -25\nKPX D Aogonek -25\nKPX D Aring -25\nKPX D Atilde -25\nKPX D V -50\nKPX D W -40\nKPX D Y -50\nKPX D Yacute -50\nKPX D Ydieresis -50\nKPX Dcaron A -25\nKPX Dcaron Aacute -25\nKPX Dcaron Abreve -25\nKPX Dcaron Acircumflex -25\nKPX Dcaron Adieresis -25\nKPX Dcaron Agrave -25\nKPX Dcaron Amacron -25\nKPX Dcaron Aogonek -25\nKPX Dcaron Aring -25\nKPX Dcaron Atilde -25\nKPX Dcaron V -50\nKPX Dcaron W -40\nKPX Dcaron Y -50\nKPX Dcaron Yacute -50\nKPX Dcaron Ydieresis -50\nKPX Dcroat A -25\nKPX Dcroat Aacute -25\nKPX Dcroat Abreve -25\nKPX Dcroat Acircumflex -25\nKPX Dcroat Adieresis -25\nKPX Dcroat Agrave -25\nKPX Dcroat Amacron -25\nKPX Dcroat Aogonek -25\nKPX Dcroat Aring -25\nKPX Dcroat Atilde -25\nKPX Dcroat V -50\nKPX Dcroat W -40\nKPX Dcroat Y -50\nKPX Dcroat Yacute -50\nKPX Dcroat Ydieresis -50\nKPX F A -100\nKPX F Aacute -100\nKPX F Abreve -100\nKPX F Acircumflex -100\nKPX F Adieresis -100\nKPX F Agrave -100\nKPX F Amacron -100\nKPX F Aogonek -100\nKPX F Aring -100\nKPX F Atilde -100\nKPX F a -95\nKPX F aacute -95\nKPX F abreve -95\nKPX F acircumflex -95\nKPX F adieresis -95\nKPX F agrave -95\nKPX F amacron -95\nKPX F aogonek -95\nKPX F aring -95\nKPX F atilde -95\nKPX F comma -129\nKPX F e -100\nKPX F eacute -100\nKPX F ecaron -100\nKPX F ecircumflex -100\nKPX F edieresis -100\nKPX F edotaccent -100\nKPX F egrave -100\nKPX F emacron -100\nKPX F eogonek -100\nKPX F i -40\nKPX F iacute -40\nKPX F icircumflex -40\nKPX F idieresis -40\nKPX F igrave -40\nKPX F imacron -40\nKPX F iogonek -40\nKPX F o -70\nKPX F oacute -70\nKPX F ocircumflex -70\nKPX F odieresis -70\nKPX F ograve -70\nKPX F ohungarumlaut -70\nKPX F omacron -70\nKPX F oslash -70\nKPX F otilde -70\nKPX F period -129\nKPX F r -50\nKPX F racute -50\nKPX F rcaron -50\nKPX F rcommaaccent -50\nKPX J A -25\nKPX J Aacute -25\nKPX J Abreve -25\nKPX J Acircumflex -25\nKPX J Adieresis -25\nKPX J Agrave -25\nKPX J Amacron -25\nKPX J Aogonek -25\nKPX J Aring -25\nKPX J Atilde -25\nKPX J a -40\nKPX J aacute -40\nKPX J abreve -40\nKPX J acircumflex -40\nKPX J adieresis -40\nKPX J agrave -40\nKPX J amacron -40\nKPX J aogonek -40\nKPX J aring -40\nKPX J atilde -40\nKPX J comma -10\nKPX J e -40\nKPX J eacute -40\nKPX J ecaron -40\nKPX J ecircumflex -40\nKPX J edieresis -40\nKPX J edotaccent -40\nKPX J egrave -40\nKPX J emacron -40\nKPX J eogonek -40\nKPX J o -40\nKPX J oacute -40\nKPX J ocircumflex -40\nKPX J odieresis -40\nKPX J ograve -40\nKPX J ohungarumlaut -40\nKPX J omacron -40\nKPX J oslash -40\nKPX J otilde -40\nKPX J period -10\nKPX J u -40\nKPX J uacute -40\nKPX J ucircumflex -40\nKPX J udieresis -40\nKPX J ugrave -40\nKPX J uhungarumlaut -40\nKPX J umacron -40\nKPX J uogonek -40\nKPX J uring -40\nKPX K O -30\nKPX K Oacute -30\nKPX K Ocircumflex -30\nKPX K Odieresis -30\nKPX K Ograve -30\nKPX K Ohungarumlaut -30\nKPX K Omacron -30\nKPX K Oslash -30\nKPX K Otilde -30\nKPX K e -25\nKPX K eacute -25\nKPX K ecaron -25\nKPX K ecircumflex -25\nKPX K edieresis -25\nKPX K edotaccent -25\nKPX K egrave -25\nKPX K emacron -25\nKPX K eogonek -25\nKPX K o -25\nKPX K oacute -25\nKPX K ocircumflex -25\nKPX K odieresis -25\nKPX K ograve -25\nKPX K ohungarumlaut -25\nKPX K omacron -25\nKPX K oslash -25\nKPX K otilde -25\nKPX K u -20\nKPX K uacute -20\nKPX K ucircumflex -20\nKPX K udieresis -20\nKPX K ugrave -20\nKPX K uhungarumlaut -20\nKPX K umacron -20\nKPX K uogonek -20\nKPX K uring -20\nKPX K y -20\nKPX K yacute -20\nKPX K ydieresis -20\nKPX Kcommaaccent O -30\nKPX Kcommaaccent Oacute -30\nKPX Kcommaaccent Ocircumflex -30\nKPX Kcommaaccent Odieresis -30\nKPX Kcommaaccent Ograve -30\nKPX Kcommaaccent Ohungarumlaut -30\nKPX Kcommaaccent Omacron -30\nKPX Kcommaaccent Oslash -30\nKPX Kcommaaccent Otilde -30\nKPX Kcommaaccent e -25\nKPX Kcommaaccent eacute -25\nKPX Kcommaaccent ecaron -25\nKPX Kcommaaccent ecircumflex -25\nKPX Kcommaaccent edieresis -25\nKPX Kcommaaccent edotaccent -25\nKPX Kcommaaccent egrave -25\nKPX Kcommaaccent emacron -25\nKPX Kcommaaccent eogonek -25\nKPX Kcommaaccent o -25\nKPX Kcommaaccent oacute -25\nKPX Kcommaaccent ocircumflex -25\nKPX Kcommaaccent odieresis -25\nKPX Kcommaaccent ograve -25\nKPX Kcommaaccent ohungarumlaut -25\nKPX Kcommaaccent omacron -25\nKPX Kcommaaccent oslash -25\nKPX Kcommaaccent otilde -25\nKPX Kcommaaccent u -20\nKPX Kcommaaccent uacute -20\nKPX Kcommaaccent ucircumflex -20\nKPX Kcommaaccent udieresis -20\nKPX Kcommaaccent ugrave -20\nKPX Kcommaaccent uhungarumlaut -20\nKPX Kcommaaccent umacron -20\nKPX Kcommaaccent uogonek -20\nKPX Kcommaaccent uring -20\nKPX Kcommaaccent y -20\nKPX Kcommaaccent yacute -20\nKPX Kcommaaccent ydieresis -20\nKPX L T -18\nKPX L Tcaron -18\nKPX L Tcommaaccent -18\nKPX L V -37\nKPX L W -37\nKPX L Y -37\nKPX L Yacute -37\nKPX L Ydieresis -37\nKPX L quoteright -55\nKPX L y -37\nKPX L yacute -37\nKPX L ydieresis -37\nKPX Lacute T -18\nKPX Lacute Tcaron -18\nKPX Lacute Tcommaaccent -18\nKPX Lacute V -37\nKPX Lacute W -37\nKPX Lacute Y -37\nKPX Lacute Yacute -37\nKPX Lacute Ydieresis -37\nKPX Lacute quoteright -55\nKPX Lacute y -37\nKPX Lacute yacute -37\nKPX Lacute ydieresis -37\nKPX Lcommaaccent T -18\nKPX Lcommaaccent Tcaron -18\nKPX Lcommaaccent Tcommaaccent -18\nKPX Lcommaaccent V -37\nKPX Lcommaaccent W -37\nKPX Lcommaaccent Y -37\nKPX Lcommaaccent Yacute -37\nKPX Lcommaaccent Ydieresis -37\nKPX Lcommaaccent quoteright -55\nKPX Lcommaaccent y -37\nKPX Lcommaaccent yacute -37\nKPX Lcommaaccent ydieresis -37\nKPX Lslash T -18\nKPX Lslash Tcaron -18\nKPX Lslash Tcommaaccent -18\nKPX Lslash V -37\nKPX Lslash W -37\nKPX Lslash Y -37\nKPX Lslash Yacute -37\nKPX Lslash Ydieresis -37\nKPX Lslash quoteright -55\nKPX Lslash y -37\nKPX Lslash yacute -37\nKPX Lslash ydieresis -37\nKPX N A -30\nKPX N Aacute -30\nKPX N Abreve -30\nKPX N Acircumflex -30\nKPX N Adieresis -30\nKPX N Agrave -30\nKPX N Amacron -30\nKPX N Aogonek -30\nKPX N Aring -30\nKPX N Atilde -30\nKPX Nacute A -30\nKPX Nacute Aacute -30\nKPX Nacute Abreve -30\nKPX Nacute Acircumflex -30\nKPX Nacute Adieresis -30\nKPX Nacute Agrave -30\nKPX Nacute Amacron -30\nKPX Nacute Aogonek -30\nKPX Nacute Aring -30\nKPX Nacute Atilde -30\nKPX Ncaron A -30\nKPX Ncaron Aacute -30\nKPX Ncaron Abreve -30\nKPX Ncaron Acircumflex -30\nKPX Ncaron Adieresis -30\nKPX Ncaron Agrave -30\nKPX Ncaron Amacron -30\nKPX Ncaron Aogonek -30\nKPX Ncaron Aring -30\nKPX Ncaron Atilde -30\nKPX Ncommaaccent A -30\nKPX Ncommaaccent Aacute -30\nKPX Ncommaaccent Abreve -30\nKPX Ncommaaccent Acircumflex -30\nKPX Ncommaaccent Adieresis -30\nKPX Ncommaaccent Agrave -30\nKPX Ncommaaccent Amacron -30\nKPX Ncommaaccent Aogonek -30\nKPX Ncommaaccent Aring -30\nKPX Ncommaaccent Atilde -30\nKPX Ntilde A -30\nKPX Ntilde Aacute -30\nKPX Ntilde Abreve -30\nKPX Ntilde Acircumflex -30\nKPX Ntilde Adieresis -30\nKPX Ntilde Agrave -30\nKPX Ntilde Amacron -30\nKPX Ntilde Aogonek -30\nKPX Ntilde Aring -30\nKPX Ntilde Atilde -30\nKPX O A -40\nKPX O Aacute -40\nKPX O Abreve -40\nKPX O Acircumflex -40\nKPX O Adieresis -40\nKPX O Agrave -40\nKPX O Amacron -40\nKPX O Aogonek -40\nKPX O Aring -40\nKPX O Atilde -40\nKPX O T -40\nKPX O Tcaron -40\nKPX O Tcommaaccent -40\nKPX O V -50\nKPX O W -50\nKPX O X -40\nKPX O Y -50\nKPX O Yacute -50\nKPX O Ydieresis -50\nKPX Oacute A -40\nKPX Oacute Aacute -40\nKPX Oacute Abreve -40\nKPX Oacute Acircumflex -40\nKPX Oacute Adieresis -40\nKPX Oacute Agrave -40\nKPX Oacute Amacron -40\nKPX Oacute Aogonek -40\nKPX Oacute Aring -40\nKPX Oacute Atilde -40\nKPX Oacute T -40\nKPX Oacute Tcaron -40\nKPX Oacute Tcommaaccent -40\nKPX Oacute V -50\nKPX Oacute W -50\nKPX Oacute X -40\nKPX Oacute Y -50\nKPX Oacute Yacute -50\nKPX Oacute Ydieresis -50\nKPX Ocircumflex A -40\nKPX Ocircumflex Aacute -40\nKPX Ocircumflex Abreve -40\nKPX Ocircumflex Acircumflex -40\nKPX Ocircumflex Adieresis -40\nKPX Ocircumflex Agrave -40\nKPX Ocircumflex Amacron -40\nKPX Ocircumflex Aogonek -40\nKPX Ocircumflex Aring -40\nKPX Ocircumflex Atilde -40\nKPX Ocircumflex T -40\nKPX Ocircumflex Tcaron -40\nKPX Ocircumflex Tcommaaccent -40\nKPX Ocircumflex V -50\nKPX Ocircumflex W -50\nKPX Ocircumflex X -40\nKPX Ocircumflex Y -50\nKPX Ocircumflex Yacute -50\nKPX Ocircumflex Ydieresis -50\nKPX Odieresis A -40\nKPX Odieresis Aacute -40\nKPX Odieresis Abreve -40\nKPX Odieresis Acircumflex -40\nKPX Odieresis Adieresis -40\nKPX Odieresis Agrave -40\nKPX Odieresis Amacron -40\nKPX Odieresis Aogonek -40\nKPX Odieresis Aring -40\nKPX Odieresis Atilde -40\nKPX Odieresis T -40\nKPX Odieresis Tcaron -40\nKPX Odieresis Tcommaaccent -40\nKPX Odieresis V -50\nKPX Odieresis W -50\nKPX Odieresis X -40\nKPX Odieresis Y -50\nKPX Odieresis Yacute -50\nKPX Odieresis Ydieresis -50\nKPX Ograve A -40\nKPX Ograve Aacute -40\nKPX Ograve Abreve -40\nKPX Ograve Acircumflex -40\nKPX Ograve Adieresis -40\nKPX Ograve Agrave -40\nKPX Ograve Amacron -40\nKPX Ograve Aogonek -40\nKPX Ograve Aring -40\nKPX Ograve Atilde -40\nKPX Ograve T -40\nKPX Ograve Tcaron -40\nKPX Ograve Tcommaaccent -40\nKPX Ograve V -50\nKPX Ograve W -50\nKPX Ograve X -40\nKPX Ograve Y -50\nKPX Ograve Yacute -50\nKPX Ograve Ydieresis -50\nKPX Ohungarumlaut A -40\nKPX Ohungarumlaut Aacute -40\nKPX Ohungarumlaut Abreve -40\nKPX Ohungarumlaut Acircumflex -40\nKPX Ohungarumlaut Adieresis -40\nKPX Ohungarumlaut Agrave -40\nKPX Ohungarumlaut Amacron -40\nKPX Ohungarumlaut Aogonek -40\nKPX Ohungarumlaut Aring -40\nKPX Ohungarumlaut Atilde -40\nKPX Ohungarumlaut T -40\nKPX Ohungarumlaut Tcaron -40\nKPX Ohungarumlaut Tcommaaccent -40\nKPX Ohungarumlaut V -50\nKPX Ohungarumlaut W -50\nKPX Ohungarumlaut X -40\nKPX Ohungarumlaut Y -50\nKPX Ohungarumlaut Yacute -50\nKPX Ohungarumlaut Ydieresis -50\nKPX Omacron A -40\nKPX Omacron Aacute -40\nKPX Omacron Abreve -40\nKPX Omacron Acircumflex -40\nKPX Omacron Adieresis -40\nKPX Omacron Agrave -40\nKPX Omacron Amacron -40\nKPX Omacron Aogonek -40\nKPX Omacron Aring -40\nKPX Omacron Atilde -40\nKPX Omacron T -40\nKPX Omacron Tcaron -40\nKPX Omacron Tcommaaccent -40\nKPX Omacron V -50\nKPX Omacron W -50\nKPX Omacron X -40\nKPX Omacron Y -50\nKPX Omacron Yacute -50\nKPX Omacron Ydieresis -50\nKPX Oslash A -40\nKPX Oslash Aacute -40\nKPX Oslash Abreve -40\nKPX Oslash Acircumflex -40\nKPX Oslash Adieresis -40\nKPX Oslash Agrave -40\nKPX Oslash Amacron -40\nKPX Oslash Aogonek -40\nKPX Oslash Aring -40\nKPX Oslash Atilde -40\nKPX Oslash T -40\nKPX Oslash Tcaron -40\nKPX Oslash Tcommaaccent -40\nKPX Oslash V -50\nKPX Oslash W -50\nKPX Oslash X -40\nKPX Oslash Y -50\nKPX Oslash Yacute -50\nKPX Oslash Ydieresis -50\nKPX Otilde A -40\nKPX Otilde Aacute -40\nKPX Otilde Abreve -40\nKPX Otilde Acircumflex -40\nKPX Otilde Adieresis -40\nKPX Otilde Agrave -40\nKPX Otilde Amacron -40\nKPX Otilde Aogonek -40\nKPX Otilde Aring -40\nKPX Otilde Atilde -40\nKPX Otilde T -40\nKPX Otilde Tcaron -40\nKPX Otilde Tcommaaccent -40\nKPX Otilde V -50\nKPX Otilde W -50\nKPX Otilde X -40\nKPX Otilde Y -50\nKPX Otilde Yacute -50\nKPX Otilde Ydieresis -50\nKPX P A -85\nKPX P Aacute -85\nKPX P Abreve -85\nKPX P Acircumflex -85\nKPX P Adieresis -85\nKPX P Agrave -85\nKPX P Amacron -85\nKPX P Aogonek -85\nKPX P Aring -85\nKPX P Atilde -85\nKPX P a -40\nKPX P aacute -40\nKPX P abreve -40\nKPX P acircumflex -40\nKPX P adieresis -40\nKPX P agrave -40\nKPX P amacron -40\nKPX P aogonek -40\nKPX P aring -40\nKPX P atilde -40\nKPX P comma -129\nKPX P e -50\nKPX P eacute -50\nKPX P ecaron -50\nKPX P ecircumflex -50\nKPX P edieresis -50\nKPX P edotaccent -50\nKPX P egrave -50\nKPX P emacron -50\nKPX P eogonek -50\nKPX P o -55\nKPX P oacute -55\nKPX P ocircumflex -55\nKPX P odieresis -55\nKPX P ograve -55\nKPX P ohungarumlaut -55\nKPX P omacron -55\nKPX P oslash -55\nKPX P otilde -55\nKPX P period -129\nKPX Q U -10\nKPX Q Uacute -10\nKPX Q Ucircumflex -10\nKPX Q Udieresis -10\nKPX Q Ugrave -10\nKPX Q Uhungarumlaut -10\nKPX Q Umacron -10\nKPX Q Uogonek -10\nKPX Q Uring -10\nKPX R O -40\nKPX R Oacute -40\nKPX R Ocircumflex -40\nKPX R Odieresis -40\nKPX R Ograve -40\nKPX R Ohungarumlaut -40\nKPX R Omacron -40\nKPX R Oslash -40\nKPX R Otilde -40\nKPX R T -30\nKPX R Tcaron -30\nKPX R Tcommaaccent -30\nKPX R U -40\nKPX R Uacute -40\nKPX R Ucircumflex -40\nKPX R Udieresis -40\nKPX R Ugrave -40\nKPX R Uhungarumlaut -40\nKPX R Umacron -40\nKPX R Uogonek -40\nKPX R Uring -40\nKPX R V -18\nKPX R W -18\nKPX R Y -18\nKPX R Yacute -18\nKPX R Ydieresis -18\nKPX Racute O -40\nKPX Racute Oacute -40\nKPX Racute Ocircumflex -40\nKPX Racute Odieresis -40\nKPX Racute Ograve -40\nKPX Racute Ohungarumlaut -40\nKPX Racute Omacron -40\nKPX Racute Oslash -40\nKPX Racute Otilde -40\nKPX Racute T -30\nKPX Racute Tcaron -30\nKPX Racute Tcommaaccent -30\nKPX Racute U -40\nKPX Racute Uacute -40\nKPX Racute Ucircumflex -40\nKPX Racute Udieresis -40\nKPX Racute Ugrave -40\nKPX Racute Uhungarumlaut -40\nKPX Racute Umacron -40\nKPX Racute Uogonek -40\nKPX Racute Uring -40\nKPX Racute V -18\nKPX Racute W -18\nKPX Racute Y -18\nKPX Racute Yacute -18\nKPX Racute Ydieresis -18\nKPX Rcaron O -40\nKPX Rcaron Oacute -40\nKPX Rcaron Ocircumflex -40\nKPX Rcaron Odieresis -40\nKPX Rcaron Ograve -40\nKPX Rcaron Ohungarumlaut -40\nKPX Rcaron Omacron -40\nKPX Rcaron Oslash -40\nKPX Rcaron Otilde -40\nKPX Rcaron T -30\nKPX Rcaron Tcaron -30\nKPX Rcaron Tcommaaccent -30\nKPX Rcaron U -40\nKPX Rcaron Uacute -40\nKPX Rcaron Ucircumflex -40\nKPX Rcaron Udieresis -40\nKPX Rcaron Ugrave -40\nKPX Rcaron Uhungarumlaut -40\nKPX Rcaron Umacron -40\nKPX Rcaron Uogonek -40\nKPX Rcaron Uring -40\nKPX Rcaron V -18\nKPX Rcaron W -18\nKPX Rcaron Y -18\nKPX Rcaron Yacute -18\nKPX Rcaron Ydieresis -18\nKPX Rcommaaccent O -40\nKPX Rcommaaccent Oacute -40\nKPX Rcommaaccent Ocircumflex -40\nKPX Rcommaaccent Odieresis -40\nKPX Rcommaaccent Ograve -40\nKPX Rcommaaccent Ohungarumlaut -40\nKPX Rcommaaccent Omacron -40\nKPX Rcommaaccent Oslash -40\nKPX Rcommaaccent Otilde -40\nKPX Rcommaaccent T -30\nKPX Rcommaaccent Tcaron -30\nKPX Rcommaaccent Tcommaaccent -30\nKPX Rcommaaccent U -40\nKPX Rcommaaccent Uacute -40\nKPX Rcommaaccent Ucircumflex -40\nKPX Rcommaaccent Udieresis -40\nKPX Rcommaaccent Ugrave -40\nKPX Rcommaaccent Uhungarumlaut -40\nKPX Rcommaaccent Umacron -40\nKPX Rcommaaccent Uogonek -40\nKPX Rcommaaccent Uring -40\nKPX Rcommaaccent V -18\nKPX Rcommaaccent W -18\nKPX Rcommaaccent Y -18\nKPX Rcommaaccent Yacute -18\nKPX Rcommaaccent Ydieresis -18\nKPX T A -55\nKPX T Aacute -55\nKPX T Abreve -55\nKPX T Acircumflex -55\nKPX T Adieresis -55\nKPX T Agrave -55\nKPX T Amacron -55\nKPX T Aogonek -55\nKPX T Aring -55\nKPX T Atilde -55\nKPX T O -18\nKPX T Oacute -18\nKPX T Ocircumflex -18\nKPX T Odieresis -18\nKPX T Ograve -18\nKPX T Ohungarumlaut -18\nKPX T Omacron -18\nKPX T Oslash -18\nKPX T Otilde -18\nKPX T a -92\nKPX T aacute -92\nKPX T abreve -92\nKPX T acircumflex -92\nKPX T adieresis -92\nKPX T agrave -92\nKPX T amacron -92\nKPX T aogonek -92\nKPX T aring -92\nKPX T atilde -92\nKPX T colon -74\nKPX T comma -92\nKPX T e -92\nKPX T eacute -92\nKPX T ecaron -92\nKPX T ecircumflex -92\nKPX T edieresis -52\nKPX T edotaccent -92\nKPX T egrave -52\nKPX T emacron -52\nKPX T eogonek -92\nKPX T hyphen -92\nKPX T i -37\nKPX T iacute -37\nKPX T iogonek -37\nKPX T o -95\nKPX T oacute -95\nKPX T ocircumflex -95\nKPX T odieresis -95\nKPX T ograve -95\nKPX T ohungarumlaut -95\nKPX T omacron -95\nKPX T oslash -95\nKPX T otilde -95\nKPX T period -92\nKPX T r -37\nKPX T racute -37\nKPX T rcaron -37\nKPX T rcommaaccent -37\nKPX T semicolon -74\nKPX T u -37\nKPX T uacute -37\nKPX T ucircumflex -37\nKPX T udieresis -37\nKPX T ugrave -37\nKPX T uhungarumlaut -37\nKPX T umacron -37\nKPX T uogonek -37\nKPX T uring -37\nKPX T w -37\nKPX T y -37\nKPX T yacute -37\nKPX T ydieresis -37\nKPX Tcaron A -55\nKPX Tcaron Aacute -55\nKPX Tcaron Abreve -55\nKPX Tcaron Acircumflex -55\nKPX Tcaron Adieresis -55\nKPX Tcaron Agrave -55\nKPX Tcaron Amacron -55\nKPX Tcaron Aogonek -55\nKPX Tcaron Aring -55\nKPX Tcaron Atilde -55\nKPX Tcaron O -18\nKPX Tcaron Oacute -18\nKPX Tcaron Ocircumflex -18\nKPX Tcaron Odieresis -18\nKPX Tcaron Ograve -18\nKPX Tcaron Ohungarumlaut -18\nKPX Tcaron Omacron -18\nKPX Tcaron Oslash -18\nKPX Tcaron Otilde -18\nKPX Tcaron a -92\nKPX Tcaron aacute -92\nKPX Tcaron abreve -92\nKPX Tcaron acircumflex -92\nKPX Tcaron adieresis -92\nKPX Tcaron agrave -92\nKPX Tcaron amacron -92\nKPX Tcaron aogonek -92\nKPX Tcaron aring -92\nKPX Tcaron atilde -92\nKPX Tcaron colon -74\nKPX Tcaron comma -92\nKPX Tcaron e -92\nKPX Tcaron eacute -92\nKPX Tcaron ecaron -92\nKPX Tcaron ecircumflex -92\nKPX Tcaron edieresis -52\nKPX Tcaron edotaccent -92\nKPX Tcaron egrave -52\nKPX Tcaron emacron -52\nKPX Tcaron eogonek -92\nKPX Tcaron hyphen -92\nKPX Tcaron i -37\nKPX Tcaron iacute -37\nKPX Tcaron iogonek -37\nKPX Tcaron o -95\nKPX Tcaron oacute -95\nKPX Tcaron ocircumflex -95\nKPX Tcaron odieresis -95\nKPX Tcaron ograve -95\nKPX Tcaron ohungarumlaut -95\nKPX Tcaron omacron -95\nKPX Tcaron oslash -95\nKPX Tcaron otilde -95\nKPX Tcaron period -92\nKPX Tcaron r -37\nKPX Tcaron racute -37\nKPX Tcaron rcaron -37\nKPX Tcaron rcommaaccent -37\nKPX Tcaron semicolon -74\nKPX Tcaron u -37\nKPX Tcaron uacute -37\nKPX Tcaron ucircumflex -37\nKPX Tcaron udieresis -37\nKPX Tcaron ugrave -37\nKPX Tcaron uhungarumlaut -37\nKPX Tcaron umacron -37\nKPX Tcaron uogonek -37\nKPX Tcaron uring -37\nKPX Tcaron w -37\nKPX Tcaron y -37\nKPX Tcaron yacute -37\nKPX Tcaron ydieresis -37\nKPX Tcommaaccent A -55\nKPX Tcommaaccent Aacute -55\nKPX Tcommaaccent Abreve -55\nKPX Tcommaaccent Acircumflex -55\nKPX Tcommaaccent Adieresis -55\nKPX Tcommaaccent Agrave -55\nKPX Tcommaaccent Amacron -55\nKPX Tcommaaccent Aogonek -55\nKPX Tcommaaccent Aring -55\nKPX Tcommaaccent Atilde -55\nKPX Tcommaaccent O -18\nKPX Tcommaaccent Oacute -18\nKPX Tcommaaccent Ocircumflex -18\nKPX Tcommaaccent Odieresis -18\nKPX Tcommaaccent Ograve -18\nKPX Tcommaaccent Ohungarumlaut -18\nKPX Tcommaaccent Omacron -18\nKPX Tcommaaccent Oslash -18\nKPX Tcommaaccent Otilde -18\nKPX Tcommaaccent a -92\nKPX Tcommaaccent aacute -92\nKPX Tcommaaccent abreve -92\nKPX Tcommaaccent acircumflex -92\nKPX Tcommaaccent adieresis -92\nKPX Tcommaaccent agrave -92\nKPX Tcommaaccent amacron -92\nKPX Tcommaaccent aogonek -92\nKPX Tcommaaccent aring -92\nKPX Tcommaaccent atilde -92\nKPX Tcommaaccent colon -74\nKPX Tcommaaccent comma -92\nKPX Tcommaaccent e -92\nKPX Tcommaaccent eacute -92\nKPX Tcommaaccent ecaron -92\nKPX Tcommaaccent ecircumflex -92\nKPX Tcommaaccent edieresis -52\nKPX Tcommaaccent edotaccent -92\nKPX Tcommaaccent egrave -52\nKPX Tcommaaccent emacron -52\nKPX Tcommaaccent eogonek -92\nKPX Tcommaaccent hyphen -92\nKPX Tcommaaccent i -37\nKPX Tcommaaccent iacute -37\nKPX Tcommaaccent iogonek -37\nKPX Tcommaaccent o -95\nKPX Tcommaaccent oacute -95\nKPX Tcommaaccent ocircumflex -95\nKPX Tcommaaccent odieresis -95\nKPX Tcommaaccent ograve -95\nKPX Tcommaaccent ohungarumlaut -95\nKPX Tcommaaccent omacron -95\nKPX Tcommaaccent oslash -95\nKPX Tcommaaccent otilde -95\nKPX Tcommaaccent period -92\nKPX Tcommaaccent r -37\nKPX Tcommaaccent racute -37\nKPX Tcommaaccent rcaron -37\nKPX Tcommaaccent rcommaaccent -37\nKPX Tcommaaccent semicolon -74\nKPX Tcommaaccent u -37\nKPX Tcommaaccent uacute -37\nKPX Tcommaaccent ucircumflex -37\nKPX Tcommaaccent udieresis -37\nKPX Tcommaaccent ugrave -37\nKPX Tcommaaccent uhungarumlaut -37\nKPX Tcommaaccent umacron -37\nKPX Tcommaaccent uogonek -37\nKPX Tcommaaccent uring -37\nKPX Tcommaaccent w -37\nKPX Tcommaaccent y -37\nKPX Tcommaaccent yacute -37\nKPX Tcommaaccent ydieresis -37\nKPX U A -45\nKPX U Aacute -45\nKPX U Abreve -45\nKPX U Acircumflex -45\nKPX U Adieresis -45\nKPX U Agrave -45\nKPX U Amacron -45\nKPX U Aogonek -45\nKPX U Aring -45\nKPX U Atilde -45\nKPX Uacute A -45\nKPX Uacute Aacute -45\nKPX Uacute Abreve -45\nKPX Uacute Acircumflex -45\nKPX Uacute Adieresis -45\nKPX Uacute Agrave -45\nKPX Uacute Amacron -45\nKPX Uacute Aogonek -45\nKPX Uacute Aring -45\nKPX Uacute Atilde -45\nKPX Ucircumflex A -45\nKPX Ucircumflex Aacute -45\nKPX Ucircumflex Abreve -45\nKPX Ucircumflex Acircumflex -45\nKPX Ucircumflex Adieresis -45\nKPX Ucircumflex Agrave -45\nKPX Ucircumflex Amacron -45\nKPX Ucircumflex Aogonek -45\nKPX Ucircumflex Aring -45\nKPX Ucircumflex Atilde -45\nKPX Udieresis A -45\nKPX Udieresis Aacute -45\nKPX Udieresis Abreve -45\nKPX Udieresis Acircumflex -45\nKPX Udieresis Adieresis -45\nKPX Udieresis Agrave -45\nKPX Udieresis Amacron -45\nKPX Udieresis Aogonek -45\nKPX Udieresis Aring -45\nKPX Udieresis Atilde -45\nKPX Ugrave A -45\nKPX Ugrave Aacute -45\nKPX Ugrave Abreve -45\nKPX Ugrave Acircumflex -45\nKPX Ugrave Adieresis -45\nKPX Ugrave Agrave -45\nKPX Ugrave Amacron -45\nKPX Ugrave Aogonek -45\nKPX Ugrave Aring -45\nKPX Ugrave Atilde -45\nKPX Uhungarumlaut A -45\nKPX Uhungarumlaut Aacute -45\nKPX Uhungarumlaut Abreve -45\nKPX Uhungarumlaut Acircumflex -45\nKPX Uhungarumlaut Adieresis -45\nKPX Uhungarumlaut Agrave -45\nKPX Uhungarumlaut Amacron -45\nKPX Uhungarumlaut Aogonek -45\nKPX Uhungarumlaut Aring -45\nKPX Uhungarumlaut Atilde -45\nKPX Umacron A -45\nKPX Umacron Aacute -45\nKPX Umacron Abreve -45\nKPX Umacron Acircumflex -45\nKPX Umacron Adieresis -45\nKPX Umacron Agrave -45\nKPX Umacron Amacron -45\nKPX Umacron Aogonek -45\nKPX Umacron Aring -45\nKPX Umacron Atilde -45\nKPX Uogonek A -45\nKPX Uogonek Aacute -45\nKPX Uogonek Abreve -45\nKPX Uogonek Acircumflex -45\nKPX Uogonek Adieresis -45\nKPX Uogonek Agrave -45\nKPX Uogonek Amacron -45\nKPX Uogonek Aogonek -45\nKPX Uogonek Aring -45\nKPX Uogonek Atilde -45\nKPX Uring A -45\nKPX Uring Aacute -45\nKPX Uring Abreve -45\nKPX Uring Acircumflex -45\nKPX Uring Adieresis -45\nKPX Uring Agrave -45\nKPX Uring Amacron -45\nKPX Uring Aogonek -45\nKPX Uring Aring -45\nKPX Uring Atilde -45\nKPX V A -85\nKPX V Aacute -85\nKPX V Abreve -85\nKPX V Acircumflex -85\nKPX V Adieresis -85\nKPX V Agrave -85\nKPX V Amacron -85\nKPX V Aogonek -85\nKPX V Aring -85\nKPX V Atilde -85\nKPX V G -10\nKPX V Gbreve -10\nKPX V Gcommaaccent -10\nKPX V O -30\nKPX V Oacute -30\nKPX V Ocircumflex -30\nKPX V Odieresis -30\nKPX V Ograve -30\nKPX V Ohungarumlaut -30\nKPX V Omacron -30\nKPX V Oslash -30\nKPX V Otilde -30\nKPX V a -111\nKPX V aacute -111\nKPX V abreve -111\nKPX V acircumflex -111\nKPX V adieresis -111\nKPX V agrave -111\nKPX V amacron -111\nKPX V aogonek -111\nKPX V aring -111\nKPX V atilde -111\nKPX V colon -74\nKPX V comma -129\nKPX V e -111\nKPX V eacute -111\nKPX V ecaron -111\nKPX V ecircumflex -111\nKPX V edieresis -71\nKPX V edotaccent -111\nKPX V egrave -71\nKPX V emacron -71\nKPX V eogonek -111\nKPX V hyphen -70\nKPX V i -55\nKPX V iacute -55\nKPX V iogonek -55\nKPX V o -111\nKPX V oacute -111\nKPX V ocircumflex -111\nKPX V odieresis -111\nKPX V ograve -111\nKPX V ohungarumlaut -111\nKPX V omacron -111\nKPX V oslash -111\nKPX V otilde -111\nKPX V period -129\nKPX V semicolon -74\nKPX V u -55\nKPX V uacute -55\nKPX V ucircumflex -55\nKPX V udieresis -55\nKPX V ugrave -55\nKPX V uhungarumlaut -55\nKPX V umacron -55\nKPX V uogonek -55\nKPX V uring -55\nKPX W A -74\nKPX W Aacute -74\nKPX W Abreve -74\nKPX W Acircumflex -74\nKPX W Adieresis -74\nKPX W Agrave -74\nKPX W Amacron -74\nKPX W Aogonek -74\nKPX W Aring -74\nKPX W Atilde -74\nKPX W O -15\nKPX W Oacute -15\nKPX W Ocircumflex -15\nKPX W Odieresis -15\nKPX W Ograve -15\nKPX W Ohungarumlaut -15\nKPX W Omacron -15\nKPX W Oslash -15\nKPX W Otilde -15\nKPX W a -85\nKPX W aacute -85\nKPX W abreve -85\nKPX W acircumflex -85\nKPX W adieresis -85\nKPX W agrave -85\nKPX W amacron -85\nKPX W aogonek -85\nKPX W aring -85\nKPX W atilde -85\nKPX W colon -55\nKPX W comma -74\nKPX W e -90\nKPX W eacute -90\nKPX W ecaron -90\nKPX W ecircumflex -90\nKPX W edieresis -50\nKPX W edotaccent -90\nKPX W egrave -50\nKPX W emacron -50\nKPX W eogonek -90\nKPX W hyphen -50\nKPX W i -37\nKPX W iacute -37\nKPX W iogonek -37\nKPX W o -80\nKPX W oacute -80\nKPX W ocircumflex -80\nKPX W odieresis -80\nKPX W ograve -80\nKPX W ohungarumlaut -80\nKPX W omacron -80\nKPX W oslash -80\nKPX W otilde -80\nKPX W period -74\nKPX W semicolon -55\nKPX W u -55\nKPX W uacute -55\nKPX W ucircumflex -55\nKPX W udieresis -55\nKPX W ugrave -55\nKPX W uhungarumlaut -55\nKPX W umacron -55\nKPX W uogonek -55\nKPX W uring -55\nKPX W y -55\nKPX W yacute -55\nKPX W ydieresis -55\nKPX Y A -74\nKPX Y Aacute -74\nKPX Y Abreve -74\nKPX Y Acircumflex -74\nKPX Y Adieresis -74\nKPX Y Agrave -74\nKPX Y Amacron -74\nKPX Y Aogonek -74\nKPX Y Aring -74\nKPX Y Atilde -74\nKPX Y O -25\nKPX Y Oacute -25\nKPX Y Ocircumflex -25\nKPX Y Odieresis -25\nKPX Y Ograve -25\nKPX Y Ohungarumlaut -25\nKPX Y Omacron -25\nKPX Y Oslash -25\nKPX Y Otilde -25\nKPX Y a -92\nKPX Y aacute -92\nKPX Y abreve -92\nKPX Y acircumflex -92\nKPX Y adieresis -92\nKPX Y agrave -92\nKPX Y amacron -92\nKPX Y aogonek -92\nKPX Y aring -92\nKPX Y atilde -92\nKPX Y colon -92\nKPX Y comma -92\nKPX Y e -111\nKPX Y eacute -111\nKPX Y ecaron -111\nKPX Y ecircumflex -71\nKPX Y edieresis -71\nKPX Y edotaccent -111\nKPX Y egrave -71\nKPX Y emacron -71\nKPX Y eogonek -111\nKPX Y hyphen -92\nKPX Y i -55\nKPX Y iacute -55\nKPX Y iogonek -55\nKPX Y o -111\nKPX Y oacute -111\nKPX Y ocircumflex -111\nKPX Y odieresis -111\nKPX Y ograve -111\nKPX Y ohungarumlaut -111\nKPX Y omacron -111\nKPX Y oslash -111\nKPX Y otilde -111\nKPX Y period -74\nKPX Y semicolon -92\nKPX Y u -92\nKPX Y uacute -92\nKPX Y ucircumflex -92\nKPX Y udieresis -92\nKPX Y ugrave -92\nKPX Y uhungarumlaut -92\nKPX Y umacron -92\nKPX Y uogonek -92\nKPX Y uring -92\nKPX Yacute A -74\nKPX Yacute Aacute -74\nKPX Yacute Abreve -74\nKPX Yacute Acircumflex -74\nKPX Yacute Adieresis -74\nKPX Yacute Agrave -74\nKPX Yacute Amacron -74\nKPX Yacute Aogonek -74\nKPX Yacute Aring -74\nKPX Yacute Atilde -74\nKPX Yacute O -25\nKPX Yacute Oacute -25\nKPX Yacute Ocircumflex -25\nKPX Yacute Odieresis -25\nKPX Yacute Ograve -25\nKPX Yacute Ohungarumlaut -25\nKPX Yacute Omacron -25\nKPX Yacute Oslash -25\nKPX Yacute Otilde -25\nKPX Yacute a -92\nKPX Yacute aacute -92\nKPX Yacute abreve -92\nKPX Yacute acircumflex -92\nKPX Yacute adieresis -92\nKPX Yacute agrave -92\nKPX Yacute amacron -92\nKPX Yacute aogonek -92\nKPX Yacute aring -92\nKPX Yacute atilde -92\nKPX Yacute colon -92\nKPX Yacute comma -92\nKPX Yacute e -111\nKPX Yacute eacute -111\nKPX Yacute ecaron -111\nKPX Yacute ecircumflex -71\nKPX Yacute edieresis -71\nKPX Yacute edotaccent -111\nKPX Yacute egrave -71\nKPX Yacute emacron -71\nKPX Yacute eogonek -111\nKPX Yacute hyphen -92\nKPX Yacute i -55\nKPX Yacute iacute -55\nKPX Yacute iogonek -55\nKPX Yacute o -111\nKPX Yacute oacute -111\nKPX Yacute ocircumflex -111\nKPX Yacute odieresis -111\nKPX Yacute ograve -111\nKPX Yacute ohungarumlaut -111\nKPX Yacute omacron -111\nKPX Yacute oslash -111\nKPX Yacute otilde -111\nKPX Yacute period -74\nKPX Yacute semicolon -92\nKPX Yacute u -92\nKPX Yacute uacute -92\nKPX Yacute ucircumflex -92\nKPX Yacute udieresis -92\nKPX Yacute ugrave -92\nKPX Yacute uhungarumlaut -92\nKPX Yacute umacron -92\nKPX Yacute uogonek -92\nKPX Yacute uring -92\nKPX Ydieresis A -74\nKPX Ydieresis Aacute -74\nKPX Ydieresis Abreve -74\nKPX Ydieresis Acircumflex -74\nKPX Ydieresis Adieresis -74\nKPX Ydieresis Agrave -74\nKPX Ydieresis Amacron -74\nKPX Ydieresis Aogonek -74\nKPX Ydieresis Aring -74\nKPX Ydieresis Atilde -74\nKPX Ydieresis O -25\nKPX Ydieresis Oacute -25\nKPX Ydieresis Ocircumflex -25\nKPX Ydieresis Odieresis -25\nKPX Ydieresis Ograve -25\nKPX Ydieresis Ohungarumlaut -25\nKPX Ydieresis Omacron -25\nKPX Ydieresis Oslash -25\nKPX Ydieresis Otilde -25\nKPX Ydieresis a -92\nKPX Ydieresis aacute -92\nKPX Ydieresis abreve -92\nKPX Ydieresis acircumflex -92\nKPX Ydieresis adieresis -92\nKPX Ydieresis agrave -92\nKPX Ydieresis amacron -92\nKPX Ydieresis aogonek -92\nKPX Ydieresis aring -92\nKPX Ydieresis atilde -92\nKPX Ydieresis colon -92\nKPX Ydieresis comma -92\nKPX Ydieresis e -111\nKPX Ydieresis eacute -111\nKPX Ydieresis ecaron -111\nKPX Ydieresis ecircumflex -71\nKPX Ydieresis edieresis -71\nKPX Ydieresis edotaccent -111\nKPX Ydieresis egrave -71\nKPX Ydieresis emacron -71\nKPX Ydieresis eogonek -111\nKPX Ydieresis hyphen -92\nKPX Ydieresis i -55\nKPX Ydieresis iacute -55\nKPX Ydieresis iogonek -55\nKPX Ydieresis o -111\nKPX Ydieresis oacute -111\nKPX Ydieresis ocircumflex -111\nKPX Ydieresis odieresis -111\nKPX Ydieresis ograve -111\nKPX Ydieresis ohungarumlaut -111\nKPX Ydieresis omacron -111\nKPX Ydieresis oslash -111\nKPX Ydieresis otilde -111\nKPX Ydieresis period -74\nKPX Ydieresis semicolon -92\nKPX Ydieresis u -92\nKPX Ydieresis uacute -92\nKPX Ydieresis ucircumflex -92\nKPX Ydieresis udieresis -92\nKPX Ydieresis ugrave -92\nKPX Ydieresis uhungarumlaut -92\nKPX Ydieresis umacron -92\nKPX Ydieresis uogonek -92\nKPX Ydieresis uring -92\nKPX b b -10\nKPX b period -40\nKPX b u -20\nKPX b uacute -20\nKPX b ucircumflex -20\nKPX b udieresis -20\nKPX b ugrave -20\nKPX b uhungarumlaut -20\nKPX b umacron -20\nKPX b uogonek -20\nKPX b uring -20\nKPX c h -10\nKPX c k -10\nKPX c kcommaaccent -10\nKPX cacute h -10\nKPX cacute k -10\nKPX cacute kcommaaccent -10\nKPX ccaron h -10\nKPX ccaron k -10\nKPX ccaron kcommaaccent -10\nKPX ccedilla h -10\nKPX ccedilla k -10\nKPX ccedilla kcommaaccent -10\nKPX comma quotedblright -95\nKPX comma quoteright -95\nKPX e b -10\nKPX eacute b -10\nKPX ecaron b -10\nKPX ecircumflex b -10\nKPX edieresis b -10\nKPX edotaccent b -10\nKPX egrave b -10\nKPX emacron b -10\nKPX eogonek b -10\nKPX f comma -10\nKPX f dotlessi -30\nKPX f e -10\nKPX f eacute -10\nKPX f edotaccent -10\nKPX f eogonek -10\nKPX f f -18\nKPX f o -10\nKPX f oacute -10\nKPX f ocircumflex -10\nKPX f ograve -10\nKPX f ohungarumlaut -10\nKPX f oslash -10\nKPX f otilde -10\nKPX f period -10\nKPX f quoteright 55\nKPX k e -30\nKPX k eacute -30\nKPX k ecaron -30\nKPX k ecircumflex -30\nKPX k edieresis -30\nKPX k edotaccent -30\nKPX k egrave -30\nKPX k emacron -30\nKPX k eogonek -30\nKPX k o -10\nKPX k oacute -10\nKPX k ocircumflex -10\nKPX k odieresis -10\nKPX k ograve -10\nKPX k ohungarumlaut -10\nKPX k omacron -10\nKPX k oslash -10\nKPX k otilde -10\nKPX kcommaaccent e -30\nKPX kcommaaccent eacute -30\nKPX kcommaaccent ecaron -30\nKPX kcommaaccent ecircumflex -30\nKPX kcommaaccent edieresis -30\nKPX kcommaaccent edotaccent -30\nKPX kcommaaccent egrave -30\nKPX kcommaaccent emacron -30\nKPX kcommaaccent eogonek -30\nKPX kcommaaccent o -10\nKPX kcommaaccent oacute -10\nKPX kcommaaccent ocircumflex -10\nKPX kcommaaccent odieresis -10\nKPX kcommaaccent ograve -10\nKPX kcommaaccent ohungarumlaut -10\nKPX kcommaaccent omacron -10\nKPX kcommaaccent oslash -10\nKPX kcommaaccent otilde -10\nKPX n v -40\nKPX nacute v -40\nKPX ncaron v -40\nKPX ncommaaccent v -40\nKPX ntilde v -40\nKPX o v -15\nKPX o w -25\nKPX o x -10\nKPX o y -10\nKPX o yacute -10\nKPX o ydieresis -10\nKPX oacute v -15\nKPX oacute w -25\nKPX oacute x -10\nKPX oacute y -10\nKPX oacute yacute -10\nKPX oacute ydieresis -10\nKPX ocircumflex v -15\nKPX ocircumflex w -25\nKPX ocircumflex x -10\nKPX ocircumflex y -10\nKPX ocircumflex yacute -10\nKPX ocircumflex ydieresis -10\nKPX odieresis v -15\nKPX odieresis w -25\nKPX odieresis x -10\nKPX odieresis y -10\nKPX odieresis yacute -10\nKPX odieresis ydieresis -10\nKPX ograve v -15\nKPX ograve w -25\nKPX ograve x -10\nKPX ograve y -10\nKPX ograve yacute -10\nKPX ograve ydieresis -10\nKPX ohungarumlaut v -15\nKPX ohungarumlaut w -25\nKPX ohungarumlaut x -10\nKPX ohungarumlaut y -10\nKPX ohungarumlaut yacute -10\nKPX ohungarumlaut ydieresis -10\nKPX omacron v -15\nKPX omacron w -25\nKPX omacron x -10\nKPX omacron y -10\nKPX omacron yacute -10\nKPX omacron ydieresis -10\nKPX oslash v -15\nKPX oslash w -25\nKPX oslash x -10\nKPX oslash y -10\nKPX oslash yacute -10\nKPX oslash ydieresis -10\nKPX otilde v -15\nKPX otilde w -25\nKPX otilde x -10\nKPX otilde y -10\nKPX otilde yacute -10\nKPX otilde ydieresis -10\nKPX period quotedblright -95\nKPX period quoteright -95\nKPX quoteleft quoteleft -74\nKPX quoteright d -15\nKPX quoteright dcroat -15\nKPX quoteright quoteright -74\nKPX quoteright r -15\nKPX quoteright racute -15\nKPX quoteright rcaron -15\nKPX quoteright rcommaaccent -15\nKPX quoteright s -74\nKPX quoteright sacute -74\nKPX quoteright scaron -74\nKPX quoteright scedilla -74\nKPX quoteright scommaaccent -74\nKPX quoteright space -74\nKPX quoteright t -37\nKPX quoteright tcommaaccent -37\nKPX quoteright v -15\nKPX r comma -65\nKPX r period -65\nKPX racute comma -65\nKPX racute period -65\nKPX rcaron comma -65\nKPX rcaron period -65\nKPX rcommaaccent comma -65\nKPX rcommaaccent period -65\nKPX space A -37\nKPX space Aacute -37\nKPX space Abreve -37\nKPX space Acircumflex -37\nKPX space Adieresis -37\nKPX space Agrave -37\nKPX space Amacron -37\nKPX space Aogonek -37\nKPX space Aring -37\nKPX space Atilde -37\nKPX space V -70\nKPX space W -70\nKPX space Y -70\nKPX space Yacute -70\nKPX space Ydieresis -70\nKPX v comma -37\nKPX v e -15\nKPX v eacute -15\nKPX v ecaron -15\nKPX v ecircumflex -15\nKPX v edieresis -15\nKPX v edotaccent -15\nKPX v egrave -15\nKPX v emacron -15\nKPX v eogonek -15\nKPX v o -15\nKPX v oacute -15\nKPX v ocircumflex -15\nKPX v odieresis -15\nKPX v ograve -15\nKPX v ohungarumlaut -15\nKPX v omacron -15\nKPX v oslash -15\nKPX v otilde -15\nKPX v period -37\nKPX w a -10\nKPX w aacute -10\nKPX w abreve -10\nKPX w acircumflex -10\nKPX w adieresis -10\nKPX w agrave -10\nKPX w amacron -10\nKPX w aogonek -10\nKPX w aring -10\nKPX w atilde -10\nKPX w comma -37\nKPX w e -10\nKPX w eacute -10\nKPX w ecaron -10\nKPX w ecircumflex -10\nKPX w edieresis -10\nKPX w edotaccent -10\nKPX w egrave -10\nKPX w emacron -10\nKPX w eogonek -10\nKPX w o -15\nKPX w oacute -15\nKPX w ocircumflex -15\nKPX w odieresis -15\nKPX w ograve -15\nKPX w ohungarumlaut -15\nKPX w omacron -15\nKPX w oslash -15\nKPX w otilde -15\nKPX w period -37\nKPX x e -10\nKPX x eacute -10\nKPX x ecaron -10\nKPX x ecircumflex -10\nKPX x edieresis -10\nKPX x edotaccent -10\nKPX x egrave -10\nKPX x emacron -10\nKPX x eogonek -10\nKPX y comma -37\nKPX y period -37\nKPX yacute comma -37\nKPX yacute period -37\nKPX ydieresis comma -37\nKPX ydieresis period -37\nEndKernPairs\nEndKernData\nEndFontMetrics\n";
    },
    Symbol () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated. All rights reserved.\nComment Creation Date: Thu May  1 15:12:25 1997\nComment UniqueID 43064\nComment VMusage 30820 39997\nFontName Symbol\nFullName Symbol\nFamilyName Symbol\nWeight Medium\nItalicAngle 0\nIsFixedPitch false\nCharacterSet Special\nFontBBox -180 -293 1090 1010 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 001.008\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated. All rights reserved.\nEncodingScheme FontSpecific\nStdHW 92\nStdVW 85\nStartCharMetrics 190\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 333 ; N exclam ; B 128 -17 240 672 ;\nC 34 ; WX 713 ; N universal ; B 31 0 681 705 ;\nC 35 ; WX 500 ; N numbersign ; B 20 -16 481 673 ;\nC 36 ; WX 549 ; N existential ; B 25 0 478 707 ;\nC 37 ; WX 833 ; N percent ; B 63 -36 771 655 ;\nC 38 ; WX 778 ; N ampersand ; B 41 -18 750 661 ;\nC 39 ; WX 439 ; N suchthat ; B 48 -17 414 500 ;\nC 40 ; WX 333 ; N parenleft ; B 53 -191 300 673 ;\nC 41 ; WX 333 ; N parenright ; B 30 -191 277 673 ;\nC 42 ; WX 500 ; N asteriskmath ; B 65 134 427 551 ;\nC 43 ; WX 549 ; N plus ; B 10 0 539 533 ;\nC 44 ; WX 250 ; N comma ; B 56 -152 194 104 ;\nC 45 ; WX 549 ; N minus ; B 11 233 535 288 ;\nC 46 ; WX 250 ; N period ; B 69 -17 181 95 ;\nC 47 ; WX 278 ; N slash ; B 0 -18 254 646 ;\nC 48 ; WX 500 ; N zero ; B 24 -14 476 685 ;\nC 49 ; WX 500 ; N one ; B 117 0 390 673 ;\nC 50 ; WX 500 ; N two ; B 25 0 475 685 ;\nC 51 ; WX 500 ; N three ; B 43 -14 435 685 ;\nC 52 ; WX 500 ; N four ; B 15 0 469 685 ;\nC 53 ; WX 500 ; N five ; B 32 -14 445 690 ;\nC 54 ; WX 500 ; N six ; B 34 -14 468 685 ;\nC 55 ; WX 500 ; N seven ; B 24 -16 448 673 ;\nC 56 ; WX 500 ; N eight ; B 56 -14 445 685 ;\nC 57 ; WX 500 ; N nine ; B 30 -18 459 685 ;\nC 58 ; WX 278 ; N colon ; B 81 -17 193 460 ;\nC 59 ; WX 278 ; N semicolon ; B 83 -152 221 460 ;\nC 60 ; WX 549 ; N less ; B 26 0 523 522 ;\nC 61 ; WX 549 ; N equal ; B 11 141 537 390 ;\nC 62 ; WX 549 ; N greater ; B 26 0 523 522 ;\nC 63 ; WX 444 ; N question ; B 70 -17 412 686 ;\nC 64 ; WX 549 ; N congruent ; B 11 0 537 475 ;\nC 65 ; WX 722 ; N Alpha ; B 4 0 684 673 ;\nC 66 ; WX 667 ; N Beta ; B 29 0 592 673 ;\nC 67 ; WX 722 ; N Chi ; B -9 0 704 673 ;\nC 68 ; WX 612 ; N Delta ; B 6 0 608 688 ;\nC 69 ; WX 611 ; N Epsilon ; B 32 0 617 673 ;\nC 70 ; WX 763 ; N Phi ; B 26 0 741 673 ;\nC 71 ; WX 603 ; N Gamma ; B 24 0 609 673 ;\nC 72 ; WX 722 ; N Eta ; B 39 0 729 673 ;\nC 73 ; WX 333 ; N Iota ; B 32 0 316 673 ;\nC 74 ; WX 631 ; N theta1 ; B 18 -18 623 689 ;\nC 75 ; WX 722 ; N Kappa ; B 35 0 722 673 ;\nC 76 ; WX 686 ; N Lambda ; B 6 0 680 688 ;\nC 77 ; WX 889 ; N Mu ; B 28 0 887 673 ;\nC 78 ; WX 722 ; N Nu ; B 29 -8 720 673 ;\nC 79 ; WX 722 ; N Omicron ; B 41 -17 715 685 ;\nC 80 ; WX 768 ; N Pi ; B 25 0 745 673 ;\nC 81 ; WX 741 ; N Theta ; B 41 -17 715 685 ;\nC 82 ; WX 556 ; N Rho ; B 28 0 563 673 ;\nC 83 ; WX 592 ; N Sigma ; B 5 0 589 673 ;\nC 84 ; WX 611 ; N Tau ; B 33 0 607 673 ;\nC 85 ; WX 690 ; N Upsilon ; B -8 0 694 673 ;\nC 86 ; WX 439 ; N sigma1 ; B 40 -233 436 500 ;\nC 87 ; WX 768 ; N Omega ; B 34 0 736 688 ;\nC 88 ; WX 645 ; N Xi ; B 40 0 599 673 ;\nC 89 ; WX 795 ; N Psi ; B 15 0 781 684 ;\nC 90 ; WX 611 ; N Zeta ; B 44 0 636 673 ;\nC 91 ; WX 333 ; N bracketleft ; B 86 -155 299 674 ;\nC 92 ; WX 863 ; N therefore ; B 163 0 701 487 ;\nC 93 ; WX 333 ; N bracketright ; B 33 -155 246 674 ;\nC 94 ; WX 658 ; N perpendicular ; B 15 0 652 674 ;\nC 95 ; WX 500 ; N underscore ; B -2 -125 502 -75 ;\nC 96 ; WX 500 ; N radicalex ; B 480 881 1090 917 ;\nC 97 ; WX 631 ; N alpha ; B 41 -18 622 500 ;\nC 98 ; WX 549 ; N beta ; B 61 -223 515 741 ;\nC 99 ; WX 549 ; N chi ; B 12 -231 522 499 ;\nC 100 ; WX 494 ; N delta ; B 40 -19 481 740 ;\nC 101 ; WX 439 ; N epsilon ; B 22 -19 427 502 ;\nC 102 ; WX 521 ; N phi ; B 28 -224 492 673 ;\nC 103 ; WX 411 ; N gamma ; B 5 -225 484 499 ;\nC 104 ; WX 603 ; N eta ; B 0 -202 527 514 ;\nC 105 ; WX 329 ; N iota ; B 0 -17 301 503 ;\nC 106 ; WX 603 ; N phi1 ; B 36 -224 587 499 ;\nC 107 ; WX 549 ; N kappa ; B 33 0 558 501 ;\nC 108 ; WX 549 ; N lambda ; B 24 -17 548 739 ;\nC 109 ; WX 576 ; N mu ; B 33 -223 567 500 ;\nC 110 ; WX 521 ; N nu ; B -9 -16 475 507 ;\nC 111 ; WX 549 ; N omicron ; B 35 -19 501 499 ;\nC 112 ; WX 549 ; N pi ; B 10 -19 530 487 ;\nC 113 ; WX 521 ; N theta ; B 43 -17 485 690 ;\nC 114 ; WX 549 ; N rho ; B 50 -230 490 499 ;\nC 115 ; WX 603 ; N sigma ; B 30 -21 588 500 ;\nC 116 ; WX 439 ; N tau ; B 10 -19 418 500 ;\nC 117 ; WX 576 ; N upsilon ; B 7 -18 535 507 ;\nC 118 ; WX 713 ; N omega1 ; B 12 -18 671 583 ;\nC 119 ; WX 686 ; N omega ; B 42 -17 684 500 ;\nC 120 ; WX 493 ; N xi ; B 27 -224 469 766 ;\nC 121 ; WX 686 ; N psi ; B 12 -228 701 500 ;\nC 122 ; WX 494 ; N zeta ; B 60 -225 467 756 ;\nC 123 ; WX 480 ; N braceleft ; B 58 -183 397 673 ;\nC 124 ; WX 200 ; N bar ; B 65 -293 135 707 ;\nC 125 ; WX 480 ; N braceright ; B 79 -183 418 673 ;\nC 126 ; WX 549 ; N similar ; B 17 203 529 307 ;\nC 160 ; WX 750 ; N Euro ; B 20 -12 714 685 ;\nC 161 ; WX 620 ; N Upsilon1 ; B -2 0 610 685 ;\nC 162 ; WX 247 ; N minute ; B 27 459 228 735 ;\nC 163 ; WX 549 ; N lessequal ; B 29 0 526 639 ;\nC 164 ; WX 167 ; N fraction ; B -180 -12 340 677 ;\nC 165 ; WX 713 ; N infinity ; B 26 124 688 404 ;\nC 166 ; WX 500 ; N florin ; B 2 -193 494 686 ;\nC 167 ; WX 753 ; N club ; B 86 -26 660 533 ;\nC 168 ; WX 753 ; N diamond ; B 142 -36 600 550 ;\nC 169 ; WX 753 ; N heart ; B 117 -33 631 532 ;\nC 170 ; WX 753 ; N spade ; B 113 -36 629 548 ;\nC 171 ; WX 1042 ; N arrowboth ; B 24 -15 1024 511 ;\nC 172 ; WX 987 ; N arrowleft ; B 32 -15 942 511 ;\nC 173 ; WX 603 ; N arrowup ; B 45 0 571 910 ;\nC 174 ; WX 987 ; N arrowright ; B 49 -15 959 511 ;\nC 175 ; WX 603 ; N arrowdown ; B 45 -22 571 888 ;\nC 176 ; WX 400 ; N degree ; B 50 385 350 685 ;\nC 177 ; WX 549 ; N plusminus ; B 10 0 539 645 ;\nC 178 ; WX 411 ; N second ; B 20 459 413 737 ;\nC 179 ; WX 549 ; N greaterequal ; B 29 0 526 639 ;\nC 180 ; WX 549 ; N multiply ; B 17 8 533 524 ;\nC 181 ; WX 713 ; N proportional ; B 27 123 639 404 ;\nC 182 ; WX 494 ; N partialdiff ; B 26 -20 462 746 ;\nC 183 ; WX 460 ; N bullet ; B 50 113 410 473 ;\nC 184 ; WX 549 ; N divide ; B 10 71 536 456 ;\nC 185 ; WX 549 ; N notequal ; B 15 -25 540 549 ;\nC 186 ; WX 549 ; N equivalence ; B 14 82 538 443 ;\nC 187 ; WX 549 ; N approxequal ; B 14 135 527 394 ;\nC 188 ; WX 1000 ; N ellipsis ; B 111 -17 889 95 ;\nC 189 ; WX 603 ; N arrowvertex ; B 280 -120 336 1010 ;\nC 190 ; WX 1000 ; N arrowhorizex ; B -60 220 1050 276 ;\nC 191 ; WX 658 ; N carriagereturn ; B 15 -16 602 629 ;\nC 192 ; WX 823 ; N aleph ; B 175 -18 661 658 ;\nC 193 ; WX 686 ; N Ifraktur ; B 10 -53 578 740 ;\nC 194 ; WX 795 ; N Rfraktur ; B 26 -15 759 734 ;\nC 195 ; WX 987 ; N weierstrass ; B 159 -211 870 573 ;\nC 196 ; WX 768 ; N circlemultiply ; B 43 -17 733 673 ;\nC 197 ; WX 768 ; N circleplus ; B 43 -15 733 675 ;\nC 198 ; WX 823 ; N emptyset ; B 39 -24 781 719 ;\nC 199 ; WX 768 ; N intersection ; B 40 0 732 509 ;\nC 200 ; WX 768 ; N union ; B 40 -17 732 492 ;\nC 201 ; WX 713 ; N propersuperset ; B 20 0 673 470 ;\nC 202 ; WX 713 ; N reflexsuperset ; B 20 -125 673 470 ;\nC 203 ; WX 713 ; N notsubset ; B 36 -70 690 540 ;\nC 204 ; WX 713 ; N propersubset ; B 37 0 690 470 ;\nC 205 ; WX 713 ; N reflexsubset ; B 37 -125 690 470 ;\nC 206 ; WX 713 ; N element ; B 45 0 505 468 ;\nC 207 ; WX 713 ; N notelement ; B 45 -58 505 555 ;\nC 208 ; WX 768 ; N angle ; B 26 0 738 673 ;\nC 209 ; WX 713 ; N gradient ; B 36 -19 681 718 ;\nC 210 ; WX 790 ; N registerserif ; B 50 -17 740 673 ;\nC 211 ; WX 790 ; N copyrightserif ; B 51 -15 741 675 ;\nC 212 ; WX 890 ; N trademarkserif ; B 18 293 855 673 ;\nC 213 ; WX 823 ; N product ; B 25 -101 803 751 ;\nC 214 ; WX 549 ; N radical ; B 10 -38 515 917 ;\nC 215 ; WX 250 ; N dotmath ; B 69 210 169 310 ;\nC 216 ; WX 713 ; N logicalnot ; B 15 0 680 288 ;\nC 217 ; WX 603 ; N logicaland ; B 23 0 583 454 ;\nC 218 ; WX 603 ; N logicalor ; B 30 0 578 477 ;\nC 219 ; WX 1042 ; N arrowdblboth ; B 27 -20 1023 510 ;\nC 220 ; WX 987 ; N arrowdblleft ; B 30 -15 939 513 ;\nC 221 ; WX 603 ; N arrowdblup ; B 39 2 567 911 ;\nC 222 ; WX 987 ; N arrowdblright ; B 45 -20 954 508 ;\nC 223 ; WX 603 ; N arrowdbldown ; B 44 -19 572 890 ;\nC 224 ; WX 494 ; N lozenge ; B 18 0 466 745 ;\nC 225 ; WX 329 ; N angleleft ; B 25 -198 306 746 ;\nC 226 ; WX 790 ; N registersans ; B 50 -20 740 670 ;\nC 227 ; WX 790 ; N copyrightsans ; B 49 -15 739 675 ;\nC 228 ; WX 786 ; N trademarksans ; B 5 293 725 673 ;\nC 229 ; WX 713 ; N summation ; B 14 -108 695 752 ;\nC 230 ; WX 384 ; N parenlefttp ; B 24 -293 436 926 ;\nC 231 ; WX 384 ; N parenleftex ; B 24 -85 108 925 ;\nC 232 ; WX 384 ; N parenleftbt ; B 24 -293 436 926 ;\nC 233 ; WX 384 ; N bracketlefttp ; B 0 -80 349 926 ;\nC 234 ; WX 384 ; N bracketleftex ; B 0 -79 77 925 ;\nC 235 ; WX 384 ; N bracketleftbt ; B 0 -80 349 926 ;\nC 236 ; WX 494 ; N bracelefttp ; B 209 -85 445 925 ;\nC 237 ; WX 494 ; N braceleftmid ; B 20 -85 284 935 ;\nC 238 ; WX 494 ; N braceleftbt ; B 209 -75 445 935 ;\nC 239 ; WX 494 ; N braceex ; B 209 -85 284 935 ;\nC 241 ; WX 329 ; N angleright ; B 21 -198 302 746 ;\nC 242 ; WX 274 ; N integral ; B 2 -107 291 916 ;\nC 243 ; WX 686 ; N integraltp ; B 308 -88 675 920 ;\nC 244 ; WX 686 ; N integralex ; B 308 -88 378 975 ;\nC 245 ; WX 686 ; N integralbt ; B 11 -87 378 921 ;\nC 246 ; WX 384 ; N parenrighttp ; B 54 -293 466 926 ;\nC 247 ; WX 384 ; N parenrightex ; B 382 -85 466 925 ;\nC 248 ; WX 384 ; N parenrightbt ; B 54 -293 466 926 ;\nC 249 ; WX 384 ; N bracketrighttp ; B 22 -80 371 926 ;\nC 250 ; WX 384 ; N bracketrightex ; B 294 -79 371 925 ;\nC 251 ; WX 384 ; N bracketrightbt ; B 22 -80 371 926 ;\nC 252 ; WX 494 ; N bracerighttp ; B 48 -85 284 925 ;\nC 253 ; WX 494 ; N bracerightmid ; B 209 -85 473 935 ;\nC 254 ; WX 494 ; N bracerightbt ; B 48 -75 284 935 ;\nC -1 ; WX 790 ; N apple ; B 56 -3 733 808 ;\nEndCharMetrics\nEndFontMetrics\n";
    },
    ZapfDingbats () {
        return "StartFontMetrics 4.1\nComment Copyright (c) 1985, 1987, 1988, 1989, 1997 Adobe Systems Incorporated. All Rights Reserved.\nComment Creation Date: Thu May  1 15:14:13 1997\nComment UniqueID 43082\nComment VMusage 45775 55535\nFontName ZapfDingbats\nFullName ITC Zapf Dingbats\nFamilyName ZapfDingbats\nWeight Medium\nItalicAngle 0\nIsFixedPitch false\nCharacterSet Special\nFontBBox -1 -143 981 820 \nUnderlinePosition -100\nUnderlineThickness 50\nVersion 002.000\nNotice Copyright (c) 1985, 1987, 1988, 1989, 1997 Adobe Systems Incorporated. All Rights Reserved.ITC Zapf Dingbats is a registered trademark of International Typeface Corporation.\nEncodingScheme FontSpecific\nStdHW 28\nStdVW 90\nStartCharMetrics 202\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\nC 33 ; WX 974 ; N a1 ; B 35 72 939 621 ;\nC 34 ; WX 961 ; N a2 ; B 35 81 927 611 ;\nC 35 ; WX 974 ; N a202 ; B 35 72 939 621 ;\nC 36 ; WX 980 ; N a3 ; B 35 0 945 692 ;\nC 37 ; WX 719 ; N a4 ; B 34 139 685 566 ;\nC 38 ; WX 789 ; N a5 ; B 35 -14 755 705 ;\nC 39 ; WX 790 ; N a119 ; B 35 -14 755 705 ;\nC 40 ; WX 791 ; N a118 ; B 35 -13 761 705 ;\nC 41 ; WX 690 ; N a117 ; B 34 138 655 553 ;\nC 42 ; WX 960 ; N a11 ; B 35 123 925 568 ;\nC 43 ; WX 939 ; N a12 ; B 35 134 904 559 ;\nC 44 ; WX 549 ; N a13 ; B 29 -11 516 705 ;\nC 45 ; WX 855 ; N a14 ; B 34 59 820 632 ;\nC 46 ; WX 911 ; N a15 ; B 35 50 876 642 ;\nC 47 ; WX 933 ; N a16 ; B 35 139 899 550 ;\nC 48 ; WX 911 ; N a105 ; B 35 50 876 642 ;\nC 49 ; WX 945 ; N a17 ; B 35 139 909 553 ;\nC 50 ; WX 974 ; N a18 ; B 35 104 938 587 ;\nC 51 ; WX 755 ; N a19 ; B 34 -13 721 705 ;\nC 52 ; WX 846 ; N a20 ; B 36 -14 811 705 ;\nC 53 ; WX 762 ; N a21 ; B 35 0 727 692 ;\nC 54 ; WX 761 ; N a22 ; B 35 0 727 692 ;\nC 55 ; WX 571 ; N a23 ; B -1 -68 571 661 ;\nC 56 ; WX 677 ; N a24 ; B 36 -13 642 705 ;\nC 57 ; WX 763 ; N a25 ; B 35 0 728 692 ;\nC 58 ; WX 760 ; N a26 ; B 35 0 726 692 ;\nC 59 ; WX 759 ; N a27 ; B 35 0 725 692 ;\nC 60 ; WX 754 ; N a28 ; B 35 0 720 692 ;\nC 61 ; WX 494 ; N a6 ; B 35 0 460 692 ;\nC 62 ; WX 552 ; N a7 ; B 35 0 517 692 ;\nC 63 ; WX 537 ; N a8 ; B 35 0 503 692 ;\nC 64 ; WX 577 ; N a9 ; B 35 96 542 596 ;\nC 65 ; WX 692 ; N a10 ; B 35 -14 657 705 ;\nC 66 ; WX 786 ; N a29 ; B 35 -14 751 705 ;\nC 67 ; WX 788 ; N a30 ; B 35 -14 752 705 ;\nC 68 ; WX 788 ; N a31 ; B 35 -14 753 705 ;\nC 69 ; WX 790 ; N a32 ; B 35 -14 756 705 ;\nC 70 ; WX 793 ; N a33 ; B 35 -13 759 705 ;\nC 71 ; WX 794 ; N a34 ; B 35 -13 759 705 ;\nC 72 ; WX 816 ; N a35 ; B 35 -14 782 705 ;\nC 73 ; WX 823 ; N a36 ; B 35 -14 787 705 ;\nC 74 ; WX 789 ; N a37 ; B 35 -14 754 705 ;\nC 75 ; WX 841 ; N a38 ; B 35 -14 807 705 ;\nC 76 ; WX 823 ; N a39 ; B 35 -14 789 705 ;\nC 77 ; WX 833 ; N a40 ; B 35 -14 798 705 ;\nC 78 ; WX 816 ; N a41 ; B 35 -13 782 705 ;\nC 79 ; WX 831 ; N a42 ; B 35 -14 796 705 ;\nC 80 ; WX 923 ; N a43 ; B 35 -14 888 705 ;\nC 81 ; WX 744 ; N a44 ; B 35 0 710 692 ;\nC 82 ; WX 723 ; N a45 ; B 35 0 688 692 ;\nC 83 ; WX 749 ; N a46 ; B 35 0 714 692 ;\nC 84 ; WX 790 ; N a47 ; B 34 -14 756 705 ;\nC 85 ; WX 792 ; N a48 ; B 35 -14 758 705 ;\nC 86 ; WX 695 ; N a49 ; B 35 -14 661 706 ;\nC 87 ; WX 776 ; N a50 ; B 35 -6 741 699 ;\nC 88 ; WX 768 ; N a51 ; B 35 -7 734 699 ;\nC 89 ; WX 792 ; N a52 ; B 35 -14 757 705 ;\nC 90 ; WX 759 ; N a53 ; B 35 0 725 692 ;\nC 91 ; WX 707 ; N a54 ; B 35 -13 672 704 ;\nC 92 ; WX 708 ; N a55 ; B 35 -14 672 705 ;\nC 93 ; WX 682 ; N a56 ; B 35 -14 647 705 ;\nC 94 ; WX 701 ; N a57 ; B 35 -14 666 705 ;\nC 95 ; WX 826 ; N a58 ; B 35 -14 791 705 ;\nC 96 ; WX 815 ; N a59 ; B 35 -14 780 705 ;\nC 97 ; WX 789 ; N a60 ; B 35 -14 754 705 ;\nC 98 ; WX 789 ; N a61 ; B 35 -14 754 705 ;\nC 99 ; WX 707 ; N a62 ; B 34 -14 673 705 ;\nC 100 ; WX 687 ; N a63 ; B 36 0 651 692 ;\nC 101 ; WX 696 ; N a64 ; B 35 0 661 691 ;\nC 102 ; WX 689 ; N a65 ; B 35 0 655 692 ;\nC 103 ; WX 786 ; N a66 ; B 34 -14 751 705 ;\nC 104 ; WX 787 ; N a67 ; B 35 -14 752 705 ;\nC 105 ; WX 713 ; N a68 ; B 35 -14 678 705 ;\nC 106 ; WX 791 ; N a69 ; B 35 -14 756 705 ;\nC 107 ; WX 785 ; N a70 ; B 36 -14 751 705 ;\nC 108 ; WX 791 ; N a71 ; B 35 -14 757 705 ;\nC 109 ; WX 873 ; N a72 ; B 35 -14 838 705 ;\nC 110 ; WX 761 ; N a73 ; B 35 0 726 692 ;\nC 111 ; WX 762 ; N a74 ; B 35 0 727 692 ;\nC 112 ; WX 762 ; N a203 ; B 35 0 727 692 ;\nC 113 ; WX 759 ; N a75 ; B 35 0 725 692 ;\nC 114 ; WX 759 ; N a204 ; B 35 0 725 692 ;\nC 115 ; WX 892 ; N a76 ; B 35 0 858 705 ;\nC 116 ; WX 892 ; N a77 ; B 35 -14 858 692 ;\nC 117 ; WX 788 ; N a78 ; B 35 -14 754 705 ;\nC 118 ; WX 784 ; N a79 ; B 35 -14 749 705 ;\nC 119 ; WX 438 ; N a81 ; B 35 -14 403 705 ;\nC 120 ; WX 138 ; N a82 ; B 35 0 104 692 ;\nC 121 ; WX 277 ; N a83 ; B 35 0 242 692 ;\nC 122 ; WX 415 ; N a84 ; B 35 0 380 692 ;\nC 123 ; WX 392 ; N a97 ; B 35 263 357 705 ;\nC 124 ; WX 392 ; N a98 ; B 34 263 357 705 ;\nC 125 ; WX 668 ; N a99 ; B 35 263 633 705 ;\nC 126 ; WX 668 ; N a100 ; B 36 263 634 705 ;\nC 128 ; WX 390 ; N a89 ; B 35 -14 356 705 ;\nC 129 ; WX 390 ; N a90 ; B 35 -14 355 705 ;\nC 130 ; WX 317 ; N a93 ; B 35 0 283 692 ;\nC 131 ; WX 317 ; N a94 ; B 35 0 283 692 ;\nC 132 ; WX 276 ; N a91 ; B 35 0 242 692 ;\nC 133 ; WX 276 ; N a92 ; B 35 0 242 692 ;\nC 134 ; WX 509 ; N a205 ; B 35 0 475 692 ;\nC 135 ; WX 509 ; N a85 ; B 35 0 475 692 ;\nC 136 ; WX 410 ; N a206 ; B 35 0 375 692 ;\nC 137 ; WX 410 ; N a86 ; B 35 0 375 692 ;\nC 138 ; WX 234 ; N a87 ; B 35 -14 199 705 ;\nC 139 ; WX 234 ; N a88 ; B 35 -14 199 705 ;\nC 140 ; WX 334 ; N a95 ; B 35 0 299 692 ;\nC 141 ; WX 334 ; N a96 ; B 35 0 299 692 ;\nC 161 ; WX 732 ; N a101 ; B 35 -143 697 806 ;\nC 162 ; WX 544 ; N a102 ; B 56 -14 488 706 ;\nC 163 ; WX 544 ; N a103 ; B 34 -14 508 705 ;\nC 164 ; WX 910 ; N a104 ; B 35 40 875 651 ;\nC 165 ; WX 667 ; N a106 ; B 35 -14 633 705 ;\nC 166 ; WX 760 ; N a107 ; B 35 -14 726 705 ;\nC 167 ; WX 760 ; N a108 ; B 0 121 758 569 ;\nC 168 ; WX 776 ; N a112 ; B 35 0 741 705 ;\nC 169 ; WX 595 ; N a111 ; B 34 -14 560 705 ;\nC 170 ; WX 694 ; N a110 ; B 35 -14 659 705 ;\nC 171 ; WX 626 ; N a109 ; B 34 0 591 705 ;\nC 172 ; WX 788 ; N a120 ; B 35 -14 754 705 ;\nC 173 ; WX 788 ; N a121 ; B 35 -14 754 705 ;\nC 174 ; WX 788 ; N a122 ; B 35 -14 754 705 ;\nC 175 ; WX 788 ; N a123 ; B 35 -14 754 705 ;\nC 176 ; WX 788 ; N a124 ; B 35 -14 754 705 ;\nC 177 ; WX 788 ; N a125 ; B 35 -14 754 705 ;\nC 178 ; WX 788 ; N a126 ; B 35 -14 754 705 ;\nC 179 ; WX 788 ; N a127 ; B 35 -14 754 705 ;\nC 180 ; WX 788 ; N a128 ; B 35 -14 754 705 ;\nC 181 ; WX 788 ; N a129 ; B 35 -14 754 705 ;\nC 182 ; WX 788 ; N a130 ; B 35 -14 754 705 ;\nC 183 ; WX 788 ; N a131 ; B 35 -14 754 705 ;\nC 184 ; WX 788 ; N a132 ; B 35 -14 754 705 ;\nC 185 ; WX 788 ; N a133 ; B 35 -14 754 705 ;\nC 186 ; WX 788 ; N a134 ; B 35 -14 754 705 ;\nC 187 ; WX 788 ; N a135 ; B 35 -14 754 705 ;\nC 188 ; WX 788 ; N a136 ; B 35 -14 754 705 ;\nC 189 ; WX 788 ; N a137 ; B 35 -14 754 705 ;\nC 190 ; WX 788 ; N a138 ; B 35 -14 754 705 ;\nC 191 ; WX 788 ; N a139 ; B 35 -14 754 705 ;\nC 192 ; WX 788 ; N a140 ; B 35 -14 754 705 ;\nC 193 ; WX 788 ; N a141 ; B 35 -14 754 705 ;\nC 194 ; WX 788 ; N a142 ; B 35 -14 754 705 ;\nC 195 ; WX 788 ; N a143 ; B 35 -14 754 705 ;\nC 196 ; WX 788 ; N a144 ; B 35 -14 754 705 ;\nC 197 ; WX 788 ; N a145 ; B 35 -14 754 705 ;\nC 198 ; WX 788 ; N a146 ; B 35 -14 754 705 ;\nC 199 ; WX 788 ; N a147 ; B 35 -14 754 705 ;\nC 200 ; WX 788 ; N a148 ; B 35 -14 754 705 ;\nC 201 ; WX 788 ; N a149 ; B 35 -14 754 705 ;\nC 202 ; WX 788 ; N a150 ; B 35 -14 754 705 ;\nC 203 ; WX 788 ; N a151 ; B 35 -14 754 705 ;\nC 204 ; WX 788 ; N a152 ; B 35 -14 754 705 ;\nC 205 ; WX 788 ; N a153 ; B 35 -14 754 705 ;\nC 206 ; WX 788 ; N a154 ; B 35 -14 754 705 ;\nC 207 ; WX 788 ; N a155 ; B 35 -14 754 705 ;\nC 208 ; WX 788 ; N a156 ; B 35 -14 754 705 ;\nC 209 ; WX 788 ; N a157 ; B 35 -14 754 705 ;\nC 210 ; WX 788 ; N a158 ; B 35 -14 754 705 ;\nC 211 ; WX 788 ; N a159 ; B 35 -14 754 705 ;\nC 212 ; WX 894 ; N a160 ; B 35 58 860 634 ;\nC 213 ; WX 838 ; N a161 ; B 35 152 803 540 ;\nC 214 ; WX 1016 ; N a163 ; B 34 152 981 540 ;\nC 215 ; WX 458 ; N a164 ; B 35 -127 422 820 ;\nC 216 ; WX 748 ; N a196 ; B 35 94 698 597 ;\nC 217 ; WX 924 ; N a165 ; B 35 140 890 552 ;\nC 218 ; WX 748 ; N a192 ; B 35 94 698 597 ;\nC 219 ; WX 918 ; N a166 ; B 35 166 884 526 ;\nC 220 ; WX 927 ; N a167 ; B 35 32 892 660 ;\nC 221 ; WX 928 ; N a168 ; B 35 129 891 562 ;\nC 222 ; WX 928 ; N a169 ; B 35 128 893 563 ;\nC 223 ; WX 834 ; N a170 ; B 35 155 799 537 ;\nC 224 ; WX 873 ; N a171 ; B 35 93 838 599 ;\nC 225 ; WX 828 ; N a172 ; B 35 104 791 588 ;\nC 226 ; WX 924 ; N a173 ; B 35 98 889 594 ;\nC 227 ; WX 924 ; N a162 ; B 35 98 889 594 ;\nC 228 ; WX 917 ; N a174 ; B 35 0 882 692 ;\nC 229 ; WX 930 ; N a175 ; B 35 84 896 608 ;\nC 230 ; WX 931 ; N a176 ; B 35 84 896 608 ;\nC 231 ; WX 463 ; N a177 ; B 35 -99 429 791 ;\nC 232 ; WX 883 ; N a178 ; B 35 71 848 623 ;\nC 233 ; WX 836 ; N a179 ; B 35 44 802 648 ;\nC 234 ; WX 836 ; N a193 ; B 35 44 802 648 ;\nC 235 ; WX 867 ; N a180 ; B 35 101 832 591 ;\nC 236 ; WX 867 ; N a199 ; B 35 101 832 591 ;\nC 237 ; WX 696 ; N a181 ; B 35 44 661 648 ;\nC 238 ; WX 696 ; N a200 ; B 35 44 661 648 ;\nC 239 ; WX 874 ; N a182 ; B 35 77 840 619 ;\nC 241 ; WX 874 ; N a201 ; B 35 73 840 615 ;\nC 242 ; WX 760 ; N a183 ; B 35 0 725 692 ;\nC 243 ; WX 946 ; N a184 ; B 35 160 911 533 ;\nC 244 ; WX 771 ; N a197 ; B 34 37 736 655 ;\nC 245 ; WX 865 ; N a185 ; B 35 207 830 481 ;\nC 246 ; WX 771 ; N a194 ; B 34 37 736 655 ;\nC 247 ; WX 888 ; N a198 ; B 34 -19 853 712 ;\nC 248 ; WX 967 ; N a186 ; B 35 124 932 568 ;\nC 249 ; WX 888 ; N a195 ; B 34 -19 853 712 ;\nC 250 ; WX 831 ; N a187 ; B 35 113 796 579 ;\nC 251 ; WX 873 ; N a188 ; B 36 118 838 578 ;\nC 252 ; WX 927 ; N a189 ; B 35 150 891 542 ;\nC 253 ; WX 970 ; N a190 ; B 35 76 931 616 ;\nC 254 ; WX 918 ; N a191 ; B 34 99 884 593 ;\nEndCharMetrics\nEndFontMetrics\n";
    }
};
class $bb72e68028dbdf4a$var$StandardFont extends $bb72e68028dbdf4a$var$PDFFont {
    constructor(document, name, id){
        super();
        this.document = document;
        this.name = name;
        this.id = id;
        this.font = new $bb72e68028dbdf4a$var$AFMFont($bb72e68028dbdf4a$var$STANDARD_FONTS[this.name]());
        ({ ascender: this.ascender, descender: this.descender, bbox: this.bbox, lineGap: this.lineGap, xHeight: this.xHeight, capHeight: this.capHeight } = this.font);
    }
    embed() {
        this.dictionary.data = {
            Type: 'Font',
            BaseFont: this.name,
            Subtype: 'Type1',
            Encoding: 'WinAnsiEncoding'
        };
        return this.dictionary.end();
    }
    encode(text) {
        const encoded = this.font.encodeText(text);
        const glyphs = this.font.glyphsForString(`${text}`);
        const advances = this.font.advancesForGlyphs(glyphs);
        const positions = [];
        for(let i = 0; i < glyphs.length; i++){
            const glyph = glyphs[i];
            positions.push({
                xAdvance: advances[i],
                yAdvance: 0,
                xOffset: 0,
                yOffset: 0,
                advanceWidth: this.font.widthOfGlyph(glyph)
            });
        }
        return [
            encoded,
            positions
        ];
    }
    widthOfString(string, size) {
        const glyphs = this.font.glyphsForString(`${string}`);
        const advances = this.font.advancesForGlyphs(glyphs);
        let width = 0;
        for (let advance of advances)width += advance;
        const scale = size / 1000;
        return width * scale;
    }
    static isStandardFont(name) {
        return name in $bb72e68028dbdf4a$var$STANDARD_FONTS;
    }
}
const $bb72e68028dbdf4a$var$toHex = function(num) {
    return `0000${num.toString(16)}`.slice(-4);
};
class $bb72e68028dbdf4a$var$EmbeddedFont extends $bb72e68028dbdf4a$var$PDFFont {
    constructor(document, font, id){
        super();
        this.document = document;
        this.font = font;
        this.id = id;
        this.subset = this.font.createSubset();
        this.unicode = [
            [
                0
            ]
        ];
        this.widths = [
            this.font.getGlyph(0).advanceWidth
        ];
        this.name = this.font.postscriptName;
        this.scale = 1000 / this.font.unitsPerEm;
        this.ascender = this.font.ascent * this.scale;
        this.descender = this.font.descent * this.scale;
        this.xHeight = this.font.xHeight * this.scale;
        this.capHeight = this.font.capHeight * this.scale;
        this.lineGap = this.font.lineGap * this.scale;
        this.bbox = this.font.bbox;
        if (document.options.fontLayoutCache !== false) this.layoutCache = Object.create(null);
    }
    layoutRun(text, features) {
        const run = this.font.layout(text, features);
        for(let i = 0; i < run.positions.length; i++){
            const position = run.positions[i];
            for(let key in position)position[key] *= this.scale;
            position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
        }
        return run;
    }
    layoutCached(text) {
        if (!this.layoutCache) return this.layoutRun(text);
        let cached;
        if (cached = this.layoutCache[text]) return cached;
        const run = this.layoutRun(text);
        this.layoutCache[text] = run;
        return run;
    }
    layout(text, features, onlyWidth) {
        if (features) return this.layoutRun(text, features);
        let glyphs = onlyWidth ? null : [];
        let positions = onlyWidth ? null : [];
        let advanceWidth = 0;
        let last = 0;
        let index = 0;
        while(index <= text.length){
            var needle;
            if (index === text.length && last < index || (needle = text.charAt(index), [
                ' ',
                '\t'
            ].includes(needle))) {
                const run = this.layoutCached(text.slice(last, ++index));
                if (!onlyWidth) {
                    glyphs = glyphs.concat(run.glyphs);
                    positions = positions.concat(run.positions);
                }
                advanceWidth += run.advanceWidth;
                last = index;
            } else index++;
        }
        return {
            glyphs: glyphs,
            positions: positions,
            advanceWidth: advanceWidth
        };
    }
    encode(text, features) {
        const { glyphs: glyphs, positions: positions } = this.layout(text, features);
        const res = [];
        for(let i = 0; i < glyphs.length; i++){
            const glyph = glyphs[i];
            const gid = this.subset.includeGlyph(glyph.id);
            res.push(`0000${gid.toString(16)}`.slice(-4));
            if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
            if (this.unicode[gid] == null) this.unicode[gid] = glyph.codePoints;
        }
        return [
            res,
            positions
        ];
    }
    widthOfString(string, size, features) {
        const width = this.layout(string, features, true).advanceWidth;
        const scale = size / 1000;
        return width * scale;
    }
    embed() {
        const isCFF = this.subset.cff != null;
        const fontFile = this.document.ref();
        if (isCFF) fontFile.data.Subtype = 'CIDFontType0C';
        fontFile.end(this.subset.encode());
        const familyClass = ((this.font['OS/2'] != null ? this.font['OS/2'].sFamilyClass : undefined) || 0) >> 8;
        let flags = 0;
        if (this.font.post.isFixedPitch) flags |= 1;
        if (1 <= familyClass && familyClass <= 7) flags |= 2;
        flags |= 4;
        if (familyClass === 10) flags |= 8;
        if (this.font.head.macStyle.italic) flags |= 64;
        const tag = [
            1,
            2,
            3,
            4,
            5,
            6
        ].map((i)=>String.fromCharCode((this.id.charCodeAt(i) || 73) + 17)).join('');
        const name = tag + '+' + this.font.postscriptName?.replaceAll(' ', '_');
        const { bbox: bbox } = this.font;
        const descriptor = this.document.ref({
            Type: 'FontDescriptor',
            FontName: name,
            Flags: flags,
            FontBBox: [
                bbox.minX * this.scale,
                bbox.minY * this.scale,
                bbox.maxX * this.scale,
                bbox.maxY * this.scale
            ],
            ItalicAngle: this.font.italicAngle,
            Ascent: this.ascender,
            Descent: this.descender,
            CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
            XHeight: (this.font.xHeight || 0) * this.scale,
            StemV: 0
        });
        if (isCFF) descriptor.data.FontFile3 = fontFile;
        else descriptor.data.FontFile2 = fontFile;
        if (this.document.subset && this.document.subset === 1) {
            const maxCID = this.widths.length - 1;
            const cidSetBuffer = $bb72e68028dbdf4a$require$Buffer.alloc(Math.ceil((maxCID + 1) / 8), 0);
            for(let cid = 0; cid <= maxCID; cid++)if (this.widths[cid] != null) cidSetBuffer[Math.floor(cid / 8)] |= 0x80 >> cid % 8;
            const CIDSetRef = this.document.ref();
            CIDSetRef.write(cidSetBuffer);
            CIDSetRef.end();
            descriptor.data.CIDSet = CIDSetRef;
        }
        descriptor.end();
        const descendantFontData = {
            Type: 'Font',
            Subtype: 'CIDFontType0',
            BaseFont: name,
            CIDSystemInfo: {
                Registry: new String('Adobe'),
                Ordering: new String('Identity'),
                Supplement: 0
            },
            FontDescriptor: descriptor,
            W: [
                0,
                this.widths
            ]
        };
        if (!isCFF) {
            descendantFontData.Subtype = 'CIDFontType2';
            descendantFontData.CIDToGIDMap = 'Identity';
        }
        const descendantFont = this.document.ref(descendantFontData);
        descendantFont.end();
        this.dictionary.data = {
            Type: 'Font',
            Subtype: 'Type0',
            BaseFont: name,
            Encoding: 'Identity-H',
            DescendantFonts: [
                descendantFont
            ],
            ToUnicode: this.toUnicodeCmap()
        };
        return this.dictionary.end();
    }
    toUnicodeCmap() {
        const cmap = this.document.ref();
        const entries = [];
        for (let codePoints of this.unicode){
            const encoded = [];
            for (let value of codePoints){
                if (value > 0xffff) {
                    value -= 0x10000;
                    encoded.push($bb72e68028dbdf4a$var$toHex(value >>> 10 & 0x3ff | 0xd800));
                    value = 0xdc00 | value & 0x3ff;
                }
                encoded.push($bb72e68028dbdf4a$var$toHex(value));
            }
            entries.push(`<${encoded.join(' ')}>`);
        }
        const chunkSize = 256;
        const chunks = Math.ceil(entries.length / chunkSize);
        const ranges = [];
        for(let i = 0; i < chunks; i++){
            const start = i * chunkSize;
            const end = Math.min((i + 1) * chunkSize, entries.length);
            ranges.push(`<${$bb72e68028dbdf4a$var$toHex(start)}> <${$bb72e68028dbdf4a$var$toHex(end - 1)}> [${entries.slice(start, end).join(' ')}]`);
        }
        cmap.end(`\
/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange
${ranges.length} beginbfrange
${ranges.join('\n')}
endbfrange
endcmap
CMapName currentdict /CMap defineresource pop
end
end\
`);
        return cmap;
    }
}
class $bb72e68028dbdf4a$var$PDFFontFactory {
    static open(document, src, family, id) {
        let font;
        if (typeof src === 'string') {
            if ($bb72e68028dbdf4a$var$StandardFont.isStandardFont(src)) return new $bb72e68028dbdf4a$var$StandardFont(document, src, id);
            src = (0, (/*@__PURE__*/$parcel$interopDefault($kjyEk))).readFileSync(src);
        }
        if (src instanceof Uint8Array) font = (0, $izQkD.create)(src, family);
        else if (src instanceof ArrayBuffer) font = (0, $izQkD.create)(new Uint8Array(src), family);
        if (font == null) throw new Error('Not a supported font format or standard PDF font.');
        return new $bb72e68028dbdf4a$var$EmbeddedFont(document, font, id);
    }
}
const $bb72e68028dbdf4a$var$isEqualFont = (font1, font2)=>{
    if (font1.font._tables?.head?.checkSumAdjustment !== font2.font._tables?.head?.checkSumAdjustment) return false;
    if (JSON.stringify(font1.font._tables?.name?.records) !== JSON.stringify(font2.font._tables?.name?.records)) return false;
    return true;
};
var $bb72e68028dbdf4a$var$FontsMixin = {
    initFonts (defaultFont = 'Helvetica', defaultFontFamily = null, defaultFontSize = 12) {
        this._fontFamilies = {};
        this._fontCount = 0;
        this._fontSource = defaultFont;
        this._fontFamily = defaultFontFamily;
        this._fontSize = defaultFontSize;
        this._font = null;
        this._remSize = defaultFontSize;
        this._registeredFonts = {};
        if (defaultFont) this.font(defaultFont, defaultFontFamily);
    },
    font (src, family, size) {
        let cacheKey, font;
        if (typeof family === 'number') {
            size = family;
            family = null;
        }
        if (typeof src === 'string' && this._registeredFonts[src]) {
            cacheKey = src;
            ({ src: src, family: family } = this._registeredFonts[src]);
        } else {
            cacheKey = family || src;
            if (typeof cacheKey !== 'string') cacheKey = null;
        }
        this._fontSource = src;
        this._fontFamily = family;
        if (size != null) this.fontSize(size);
        if (font = this._fontFamilies[cacheKey]) {
            this._font = font;
            return this;
        }
        const id = `F${++this._fontCount}`;
        this._font = $bb72e68028dbdf4a$var$PDFFontFactory.open(this, src, family, id);
        if ((font = this._fontFamilies[this._font.name]) && $bb72e68028dbdf4a$var$isEqualFont(this._font, font)) {
            this._font = font;
            return this;
        }
        if (cacheKey) this._fontFamilies[cacheKey] = this._font;
        if (this._font.name && !this._fontFamilies[this._font.name]) this._fontFamilies[this._font.name] = this._font;
        if (!cacheKey && (!this._font.name || this._fontFamilies[this._font.name] !== this._font)) this._fontFamilies[this._font.id] = this._font;
        return this;
    },
    fontSize (_fontSize) {
        this._fontSize = this.sizeToPoint(_fontSize);
        return this;
    },
    currentLineHeight (includeGap) {
        return this._font.lineHeight(this._fontSize, includeGap);
    },
    registerFont (name, src, family) {
        this._registeredFonts[name] = {
            src: src,
            family: family
        };
        return this;
    },
    sizeToPoint (size, defaultValue = 0, page = this.page, percentageWidth) {
        if (!percentageWidth) percentageWidth = this._fontSize;
        if (typeof defaultValue !== 'number') defaultValue = this.sizeToPoint(defaultValue);
        if (size === undefined) return defaultValue;
        if (typeof size === 'number') return size;
        if (typeof size === 'boolean') return Number(size);
        const match = String(size).match(/((\d+)?(\.\d+)?)(em|in|px|cm|mm|pc|ex|ch|rem|vw|vh|vmin|vmax|%|pt)?/);
        if (!match) throw new Error(`Unsupported size '${size}'`);
        let multiplier;
        switch(match[4]){
            case 'em':
                multiplier = this._fontSize;
                break;
            case 'in':
                multiplier = $bb72e68028dbdf4a$var$IN_TO_PT;
                break;
            case 'px':
                multiplier = $bb72e68028dbdf4a$var$PX_TO_IN * $bb72e68028dbdf4a$var$IN_TO_PT;
                break;
            case 'cm':
                multiplier = $bb72e68028dbdf4a$var$CM_TO_IN * $bb72e68028dbdf4a$var$IN_TO_PT;
                break;
            case 'mm':
                multiplier = $bb72e68028dbdf4a$var$MM_TO_CM * $bb72e68028dbdf4a$var$CM_TO_IN * $bb72e68028dbdf4a$var$IN_TO_PT;
                break;
            case 'pc':
                multiplier = $bb72e68028dbdf4a$var$PC_TO_PT;
                break;
            case 'ex':
                multiplier = this.currentLineHeight();
                break;
            case 'ch':
                multiplier = this.widthOfString('0');
                break;
            case 'rem':
                multiplier = this._remSize;
                break;
            case 'vw':
                multiplier = page.width / 100;
                break;
            case 'vh':
                multiplier = page.height / 100;
                break;
            case 'vmin':
                multiplier = Math.min(page.width, page.height) / 100;
                break;
            case 'vmax':
                multiplier = Math.max(page.width, page.height) / 100;
                break;
            case '%':
                multiplier = percentageWidth / 100;
                break;
            case 'pt':
            default:
                multiplier = 1;
        }
        return multiplier * Number(match[1]);
    }
};
const $bb72e68028dbdf4a$var$SOFT_HYPHEN = '\u00AD';
const $bb72e68028dbdf4a$var$HYPHEN = '-';
class $bb72e68028dbdf4a$var$LineWrapper {
    constructor(document, options){
        this._listeners = Object.create(null);
        this.document = document;
        this.horizontalScaling = options.horizontalScaling || 100;
        this.indent = (options.indent || 0) * this.horizontalScaling / 100;
        this.indentAllLines = options.indentAllLines || false;
        this.characterSpacing = (options.characterSpacing || 0) * this.horizontalScaling / 100;
        this.wordSpacing = (options.wordSpacing === 0) * this.horizontalScaling / 100;
        this.columns = options.columns || 1;
        this.columnGap = (options.columnGap != null ? options.columnGap : 18) * this.horizontalScaling / 100;
        this.lineWidth = (options.width * this.horizontalScaling / 100 - this.columnGap * (this.columns - 1)) / this.columns;
        this.spaceLeft = this.lineWidth;
        this.startX = this.document.x;
        this.startY = this.document.y;
        this.column = 1;
        this.ellipsis = options.ellipsis;
        this.continuedX = 0;
        this.features = options.features;
        if (options.height != null) {
            this.height = options.height;
            this.maxY = $bb72e68028dbdf4a$var$PDFNumber(this.startY + options.height);
        } else this.maxY = $bb72e68028dbdf4a$var$PDFNumber(this.document.page.maxY());
        this.on('firstLine', (options)=>{
            const indent = this.continuedX || this.indent;
            this.document.x += indent;
            this.lineWidth -= indent;
            if (options.indentAllLines) return;
            this.once('line', ()=>{
                this.document.x -= indent;
                this.lineWidth += indent;
                if (options.continued && !this.continuedX) this.continuedX = this.indent;
                if (!options.continued) this.continuedX = 0;
            });
        });
        this.on('lastLine', (options)=>{
            const { align: align } = options;
            if (align === 'justify') options.align = 'left';
            this.lastLine = true;
            this.once('line', ()=>{
                this.document.y += options.paragraphGap || 0;
                options.align = align;
                return this.lastLine = false;
            });
        });
    }
    on(event, listener) {
        (this._listeners[event] || (this._listeners[event] = [])).push(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            const listeners = this._listeners[event];
            listeners.splice(listeners.indexOf(wrapper), 1);
            listener(...args);
        };
        this.on(event, wrapper);
    }
    emit(event, ...args) {
        const listeners = this._listeners[event];
        if (!listeners) return;
        for (const listener of listeners.slice())listener(...args);
    }
    wordWidth(word) {
        return $bb72e68028dbdf4a$var$PDFNumber(this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing);
    }
    canFit(word, w) {
        if (word[word.length - 1] != $bb72e68028dbdf4a$var$SOFT_HYPHEN) return w <= this.spaceLeft;
        return w + this.wordWidth($bb72e68028dbdf4a$var$HYPHEN) <= this.spaceLeft;
    }
    eachWord(text, fn) {
        let bk;
        const breaker = new (0, $31QE8.default)(text);
        let last = null;
        const wordWidths = Object.create(null);
        while(bk = breaker.nextBreak()){
            var shouldContinue;
            let word = text.slice((last != null ? last.position : undefined) || 0, bk.position);
            let w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word);
            if (w > this.lineWidth + this.continuedX) {
                let lbk = last;
                const fbk = {};
                while(word.length){
                    var l, mightGrow;
                    if (w > this.spaceLeft) {
                        l = Math.ceil(this.spaceLeft / (w / word.length));
                        w = this.wordWidth(word.slice(0, l));
                        mightGrow = w <= this.spaceLeft && l < word.length;
                    } else l = word.length;
                    let mustShrink = w > this.spaceLeft && l > 0;
                    while(mustShrink || mightGrow)if (mustShrink) {
                        w = this.wordWidth(word.slice(0, --l));
                        mustShrink = w > this.spaceLeft && l > 0;
                    } else {
                        w = this.wordWidth(word.slice(0, ++l));
                        mustShrink = w > this.spaceLeft && l > 0;
                        mightGrow = w <= this.spaceLeft && l < word.length;
                    }
                    if (l === 0 && this.spaceLeft === this.lineWidth) l = 1;
                    fbk.required = bk.required || l < word.length;
                    shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
                    lbk = {
                        required: false
                    };
                    word = word.slice(l);
                    w = this.wordWidth(word);
                    if (shouldContinue === false) break;
                }
            } else shouldContinue = fn(word, w, bk, last);
            if (shouldContinue === false) break;
            last = bk;
        }
    }
    wrap(text, options) {
        const { document: document } = this;
        this.horizontalScaling = options.horizontalScaling || 100;
        if (options.indent != null) this.indent = options.indent * this.horizontalScaling / 100;
        if (options.characterSpacing != null) this.characterSpacing = options.characterSpacing * this.horizontalScaling / 100;
        if (options.wordSpacing != null) this.wordSpacing = options.wordSpacing * this.horizontalScaling / 100;
        if (options.ellipsis != null) this.ellipsis = options.ellipsis;
        const nextY = document.y + document.currentLineHeight(true);
        if (document.y > this.maxY || nextY > this.maxY) this.nextSection();
        let buffer = '';
        let textWidth = 0;
        let wc = 0;
        let lc = 0;
        let continueY = document.y;
        const emitLine = ()=>{
            options.textWidth = textWidth + this.wordSpacing * (wc - 1);
            options.wordCount = wc;
            options.lineWidth = this.lineWidth;
            continueY = document.y;
            this.emit('line', buffer, options, this);
            return lc++;
        };
        this.emit('sectionStart', options, this);
        this.eachWord(text, (word, w, bk, last)=>{
            if (last == null || last.required) {
                this.emit('firstLine', options, this);
                this.spaceLeft = this.lineWidth;
            }
            if (this.canFit(word, w)) {
                buffer += word;
                textWidth += w;
                wc++;
            }
            if (bk.required || !this.canFit(word, w)) {
                const lh = document.currentLineHeight(true);
                if (this.height != null && this.ellipsis && $bb72e68028dbdf4a$var$PDFNumber(document.y + lh * 2) > this.maxY && this.column >= this.columns) {
                    if (this.ellipsis === true) this.ellipsis = "\u2026";
                    buffer = buffer.replace(/\s+$/, '');
                    textWidth = this.wordWidth(buffer + this.ellipsis);
                    while(buffer && textWidth > this.lineWidth){
                        buffer = buffer.slice(0, -1).replace(/\s+$/, '');
                        textWidth = this.wordWidth(buffer + this.ellipsis);
                    }
                    if (textWidth <= this.lineWidth) buffer = buffer + this.ellipsis;
                    textWidth = this.wordWidth(buffer);
                }
                if (bk.required) {
                    if (w > this.spaceLeft) {
                        emitLine();
                        buffer = word;
                        textWidth = w;
                        wc = 1;
                    }
                    this.emit('lastLine', options, this);
                }
                if (buffer[buffer.length - 1] == $bb72e68028dbdf4a$var$SOFT_HYPHEN) {
                    buffer = buffer.slice(0, -1) + $bb72e68028dbdf4a$var$HYPHEN;
                    this.spaceLeft -= this.wordWidth($bb72e68028dbdf4a$var$HYPHEN);
                }
                emitLine();
                if ($bb72e68028dbdf4a$var$PDFNumber(document.y + lh) > this.maxY) {
                    this.emit('sectionEnd', options, this);
                    const shouldContinue = this.nextSection();
                    if (!shouldContinue) {
                        wc = 0;
                        buffer = '';
                        return false;
                    }
                    this.emit('sectionStart', options, this);
                }
                if (bk.required) {
                    this.spaceLeft = this.lineWidth;
                    buffer = '';
                    textWidth = 0;
                    return wc = 0;
                } else {
                    this.spaceLeft = this.lineWidth - w;
                    buffer = word;
                    textWidth = w;
                    return wc = 1;
                }
            } else return this.spaceLeft -= w;
        });
        if (wc > 0) {
            this.emit('lastLine', options, this);
            emitLine();
        }
        this.emit('sectionEnd', options, this);
        if (options.continued === true) {
            if (lc > 1) this.continuedX = 0;
            this.continuedX += options.textWidth || 0;
            document.y = continueY;
        } else document.x = this.startX;
    }
    nextSection(options) {
        if (++this.column > this.columns) {
            if (this.height != null) return false;
            this.document.continueOnNewPage();
            this.column = 1;
            this.startY = this.document.page.margins.top;
            this.maxY = this.document.page.maxY();
            if (this.indentAllLines) {
                const indent = this.continuedX || this.indent;
                this.document.x += indent;
                this.lineWidth -= indent;
            } else this.document.x = this.startX;
            if (this.document._fillColor) this.document.fillColor(...this.document._fillColor);
            this.emit('pageBreak', options, this);
        } else {
            this.document.x += this.lineWidth + this.columnGap;
            this.document.y = this.startY;
            this.emit('columnBreak', options, this);
        }
        return true;
    }
}
const { number: $bb72e68028dbdf4a$var$number } = $bb72e68028dbdf4a$var$PDFObject;
function $bb72e68028dbdf4a$var$formatListLabel(n, listType) {
    if (listType === 'numbered') return `${n}.`;
    var letter = String.fromCharCode((n - 1) % 26 + 65);
    var times = Math.floor((n - 1) / 26 + 1);
    var text = Array(times + 1).join(letter);
    return `${text}.`;
}
var $bb72e68028dbdf4a$var$TextMixin = {
    initText () {
        this._line = this._line.bind(this);
        this.x = 0;
        this.y = 0;
        this._lineGap = 0;
    },
    lineGap (_lineGap) {
        this._lineGap = _lineGap;
        return this;
    },
    moveDown (lines) {
        if (lines == null) lines = 1;
        this.y += this.currentLineHeight(true) * lines + this._lineGap;
        return this;
    },
    moveUp (lines) {
        if (lines == null) lines = 1;
        this.y -= this.currentLineHeight(true) * lines + this._lineGap;
        return this;
    },
    _text (text, x, y, options, lineCallback) {
        options = this._initOptions(x, y, options);
        text = text == null ? '' : `${text}`;
        if (options.wordSpacing) text = text.replace(/\s{2,}/g, ' ');
        const addStructure = ()=>{
            if (options.structParent) options.structParent.add(this.struct(options.structType || 'P', [
                this.markStructureContent(options.structType || 'P')
            ]));
        };
        if (options.rotation !== 0) {
            this.save();
            this.rotate(-options.rotation, {
                origin: [
                    this.x,
                    this.y
                ]
            });
        }
        if (options.width) {
            let wrapper = this._wrapper;
            if (!wrapper) {
                wrapper = new $bb72e68028dbdf4a$var$LineWrapper(this, options);
                wrapper.on('line', lineCallback);
                wrapper.on('firstLine', addStructure);
            }
            this._wrapper = options.continued ? wrapper : null;
            this._textOptions = options.continued ? options : null;
            wrapper.wrap(text, options);
        } else for (let line of text.split('\n')){
            addStructure();
            lineCallback(line, options);
        }
        if (options.rotation !== 0) this.restore();
        return this;
    },
    text (text, x, y, options) {
        return this._text(text, x, y, options, this._line);
    },
    widthOfString (string, options = {}) {
        const horizontalScaling = options.horizontalScaling || 100;
        return (this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1)) * horizontalScaling / 100;
    },
    boundsOfString (string, x, y, options) {
        options = this._initOptions(x, y, options);
        ({ x: x, y: y } = this);
        const lineGap = options.lineGap ?? this._lineGap ?? 0;
        const lineHeight = this.currentLineHeight(true) + lineGap;
        let contentWidth = 0;
        string = String(string ?? '');
        if (options.wordSpacing) string = string.replace(/\s{2,}/g, ' ');
        if (options.width) {
            let wrapper = new $bb72e68028dbdf4a$var$LineWrapper(this, options);
            wrapper.on('line', (text, options)=>{
                this.y += lineHeight;
                text = text.replace(/\n/g, '');
                if (text.length) {
                    let wordSpacing = options.wordSpacing ?? 0;
                    const characterSpacing = options.characterSpacing ?? 0;
                    if (options.width && options.align === 'justify') {
                        const words = text.trim().split(/\s+/);
                        const textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
                        const spaceWidth = this.widthOfString(' ') + characterSpacing;
                        wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
                    }
                    contentWidth = Math.max(contentWidth, options.textWidth + wordSpacing * (options.wordCount - 1) + characterSpacing * (text.length - 1));
                }
            });
            wrapper.wrap(string, options);
        } else for (let line of string.split('\n')){
            const lineWidth = this.widthOfString(line, options);
            this.y += lineHeight;
            contentWidth = Math.max(contentWidth, lineWidth);
        }
        let contentHeight = this.y - y;
        if (options.height) contentHeight = Math.min(contentHeight, options.height);
        this.x = x;
        this.y = y;
        if (options.rotation === 0) return {
            x: x,
            y: y,
            width: contentWidth,
            height: contentHeight
        };
        else if (options.rotation === 90) return {
            x: x,
            y: y - contentWidth,
            width: contentHeight,
            height: contentWidth
        };
        else if (options.rotation === 180) return {
            x: x - contentWidth,
            y: y - contentHeight,
            width: contentWidth,
            height: contentHeight
        };
        else if (options.rotation === 270) return {
            x: x - contentHeight,
            y: y,
            width: contentHeight,
            height: contentWidth
        };
        const cos = $bb72e68028dbdf4a$var$cosine(options.rotation);
        const sin = $bb72e68028dbdf4a$var$sine(options.rotation);
        const x1 = x;
        const y1 = y;
        const x2 = x + contentWidth * cos;
        const y2 = y - contentWidth * sin;
        const x3 = x + contentWidth * cos + contentHeight * sin;
        const y3 = y - contentWidth * sin + contentHeight * cos;
        const x4 = x + contentHeight * sin;
        const y4 = y + contentHeight * cos;
        const xMin = Math.min(x1, x2, x3, x4);
        const xMax = Math.max(x1, x2, x3, x4);
        const yMin = Math.min(y1, y2, y3, y4);
        const yMax = Math.max(y1, y2, y3, y4);
        return {
            x: xMin,
            y: yMin,
            width: xMax - xMin,
            height: yMax - yMin
        };
    },
    heightOfString (text, options) {
        const { x: x, y: y } = this;
        options = this._initOptions(options);
        options.height = Infinity;
        const lineGap = options.lineGap || this._lineGap || 0;
        this._text(text, this.x, this.y, options, ()=>{
            this.y += this.currentLineHeight(true) + lineGap;
        });
        const height = this.y - y;
        this.x = x;
        this.y = y;
        return height;
    },
    list (list, x, y, options) {
        options = this._initOptions(x, y, options);
        const listType = options.listType || 'bullet';
        const unit = Math.round(this._font.ascender / 1000 * this._fontSize);
        const midLine = unit / 2;
        const r = options.bulletRadius || unit / 3;
        const indent = options.textIndent || (listType === 'bullet' ? r * 5 : unit * 2);
        const itemIndent = options.bulletIndent || (listType === 'bullet' ? r * 8 : unit * 2);
        let level = 1;
        const items = [];
        const levels = [];
        const numbers = [];
        var flatten = function(list) {
            let n = 1;
            for(let i = 0; i < list.length; i++){
                const item = list[i];
                if (Array.isArray(item)) {
                    level++;
                    flatten(item);
                    level--;
                } else {
                    items.push(item);
                    levels.push(level);
                    if (listType !== 'bullet') numbers.push(n++);
                }
            }
        };
        flatten(list);
        const drawListItem = function(listItem, i) {
            const wrapper = new $bb72e68028dbdf4a$var$LineWrapper(this, options);
            wrapper.on('line', this._line);
            level = 1;
            wrapper.once('firstLine', ()=>{
                let item, itemType, labelType, bodyType;
                if (options.structParent) {
                    if (options.structTypes) [itemType, labelType, bodyType] = options.structTypes;
                    else [itemType, labelType, bodyType] = [
                        'LI',
                        'Lbl',
                        'LBody'
                    ];
                }
                if (itemType) {
                    item = this.struct(itemType);
                    options.structParent.add(item);
                } else if (options.structParent) item = options.structParent;
                let l;
                if ((l = levels[i++]) !== level) {
                    const diff = itemIndent * (l - level);
                    this.x += diff;
                    wrapper.lineWidth -= diff;
                    level = l;
                }
                if (item && (labelType || bodyType)) item.add(this.struct(labelType || bodyType, [
                    this.markStructureContent(labelType || bodyType)
                ]));
                switch(listType){
                    case 'bullet':
                        this.circle(this.x - indent + r, this.y + midLine, r);
                        this.fill();
                        break;
                    case 'numbered':
                    case 'lettered':
                        var text = $bb72e68028dbdf4a$var$formatListLabel(numbers[i - 1], listType);
                        this._fragment(text, this.x - indent, this.y, options);
                        break;
                }
                if (item && labelType && bodyType) item.add(this.struct(bodyType, [
                    this.markStructureContent(bodyType)
                ]));
                if (item && item !== options.structParent) item.end();
            });
            wrapper.on('sectionStart', ()=>{
                const pos = indent + itemIndent * (level - 1);
                this.x += pos;
                wrapper.lineWidth -= pos;
            });
            wrapper.on('sectionEnd', ()=>{
                const pos = indent + itemIndent * (level - 1);
                this.x -= pos;
                wrapper.lineWidth += pos;
            });
            wrapper.wrap(listItem, options);
        };
        for(let i = 0; i < items.length; i++)drawListItem.call(this, items[i], i);
        return this;
    },
    _initOptions (x = {}, y, options = {}) {
        if (x && typeof x === 'object') {
            options = x;
            x = null;
        }
        const result = Object.assign({}, options);
        if (this._textOptions) for(let key in this._textOptions){
            const val = this._textOptions[key];
            if (key !== 'continued') {
                if (result[key] === undefined) result[key] = val;
            }
        }
        if (x != null) this.x = x;
        if (y != null) this.y = y;
        if (result.lineBreak !== false) {
            if (result.width == null) result.width = this.page.width - this.x - this.page.margins.right;
            result.width = Math.max(result.width, 0);
        }
        if (!result.columns) result.columns = 0;
        if (result.columnGap == null) result.columnGap = 18;
        result.rotation = Number(result.rotation ?? 0) % 360;
        if (result.rotation < 0) result.rotation += 360;
        return result;
    },
    _line (text, options = {}, wrapper) {
        this._fragment(text, this.x, this.y, options);
        if (wrapper) {
            const lineGap = options.lineGap || this._lineGap || 0;
            this.y += this.currentLineHeight(true) + lineGap;
        } else this.x += this.widthOfString(text, options);
    },
    _fragment (text, x, y, options) {
        let dy, encoded, i, positions, textWidth, words;
        text = `${text}`.replace(/\n/g, '');
        if (text.length === 0) return;
        const align = options.align || 'left';
        let wordSpacing = options.wordSpacing || 0;
        const characterSpacing = options.characterSpacing || 0;
        const horizontalScaling = options.horizontalScaling || 100;
        if (options.width) switch(align){
            case 'right':
                textWidth = this.widthOfString(text.replace(/\s+$/, ''), options);
                x += options.lineWidth - textWidth;
                break;
            case 'center':
                x += options.lineWidth / 2 - options.textWidth / 2;
                break;
            case 'justify':
                words = text.trim().split(/\s+/);
                textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
                var spaceWidth = this.widthOfString(' ') + characterSpacing;
                wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
                break;
        }
        if (typeof options.baseline === 'number') dy = -options.baseline;
        else {
            switch(options.baseline){
                case 'svg-middle':
                    dy = 0.5 * this._font.xHeight;
                    break;
                case 'middle':
                case 'svg-central':
                    dy = 0.5 * (this._font.descender + this._font.ascender);
                    break;
                case 'bottom':
                case 'ideographic':
                    dy = this._font.descender;
                    break;
                case 'alphabetic':
                    dy = 0;
                    break;
                case 'mathematical':
                    dy = 0.5 * this._font.ascender;
                    break;
                case 'hanging':
                    dy = 0.8 * this._font.ascender;
                    break;
                case 'top':
                    dy = this._font.ascender;
                    break;
                default:
                    dy = this._font.ascender;
            }
            dy = dy / 1000 * this._fontSize;
        }
        const renderedWidth = options.textWidth + wordSpacing * (options.wordCount - 1) + characterSpacing * (text.length - 1);
        if (options.link != null) {
            const linkOptions = {};
            if (this._currentStructureElement && this._currentStructureElement.dictionary.data.S === 'Link') linkOptions.structParent = this._currentStructureElement;
            this.link(x, y, renderedWidth, this.currentLineHeight(), options.link, linkOptions);
        }
        if (options.goTo != null) this.goTo(x, y, renderedWidth, this.currentLineHeight(), options.goTo);
        if (options.destination != null) this.addNamedDestination(options.destination, 'XYZ', x, y, null);
        if (options.underline) {
            this.save();
            if (!options.stroke) this.strokeColor(...this._fillColor || []);
            const lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
            this.lineWidth(lineWidth);
            let lineY = y + this.currentLineHeight() - lineWidth;
            this.moveTo(x, lineY);
            this.lineTo(x + renderedWidth, lineY);
            this.stroke();
            this.restore();
        }
        if (options.strike) {
            this.save();
            if (!options.stroke) this.strokeColor(...this._fillColor || []);
            const lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
            this.lineWidth(lineWidth);
            let lineY = y + this.currentLineHeight() / 2;
            this.moveTo(x, lineY);
            this.lineTo(x + renderedWidth, lineY);
            this.stroke();
            this.restore();
        }
        this.save();
        if (options.oblique) {
            let skew;
            if (typeof options.oblique === 'number') skew = -Math.tan(options.oblique * Math.PI / 180);
            else skew = -0.25;
            this.transform(1, 0, 0, 1, x, y);
            this.transform(1, 0, skew, 1, -skew * dy, 0);
            this.transform(1, 0, 0, 1, -x, -y);
        }
        this.transform(1, 0, 0, -1, 0, this.page.height);
        y = this.page.height - y - dy;
        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
        this.addContent('BT');
        this.addContent(`1 0 0 1 ${$bb72e68028dbdf4a$var$number(x)} ${$bb72e68028dbdf4a$var$number(y)} Tm`);
        this.addContent(`/${this._font.id} ${$bb72e68028dbdf4a$var$number(this._fontSize)} Tf`);
        const mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
        if (mode) this.addContent(`${mode} Tr`);
        if (characterSpacing) this.addContent(`${$bb72e68028dbdf4a$var$number(characterSpacing)} Tc`);
        if (horizontalScaling !== 100) this.addContent(`${horizontalScaling} Tz`);
        if (wordSpacing) {
            words = text.trim().split(/\s+/);
            wordSpacing += this.widthOfString(' ') + characterSpacing;
            wordSpacing *= 1000 / this._fontSize;
            encoded = [];
            positions = [];
            for (let word of words){
                const [encodedWord, positionsWord] = this._font.encode(word, options.features);
                encoded = encoded.concat(encodedWord);
                positions = positions.concat(positionsWord);
                const space = {};
                const object = positions[positions.length - 1];
                for(let key in object){
                    const val = object[key];
                    space[key] = val;
                }
                space.xAdvance += wordSpacing;
                positions[positions.length - 1] = space;
            }
        } else [encoded, positions] = this._font.encode(text, options.features);
        const scale = this._fontSize / 1000;
        const commands = [];
        let last = 0;
        let hadOffset = false;
        const addSegment = (cur)=>{
            if (last < cur) {
                const hex = encoded.slice(last, cur).join('');
                const advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                commands.push(`<${hex}> ${$bb72e68028dbdf4a$var$number(-advance)}`);
            }
            last = cur;
        };
        const flush = (i)=>{
            addSegment(i);
            if (commands.length > 0) {
                this.addContent(`[${commands.join(' ')}] TJ`);
                commands.length = 0;
            }
        };
        for(i = 0; i < positions.length; i++){
            const pos = positions[i];
            if (pos.xOffset || pos.yOffset) {
                flush(i);
                this.addContent(`1 0 0 1 ${$bb72e68028dbdf4a$var$number(x + pos.xOffset * scale)} ${$bb72e68028dbdf4a$var$number(y + pos.yOffset * scale)} Tm`);
                flush(i + 1);
                hadOffset = true;
            } else {
                if (hadOffset) {
                    this.addContent(`1 0 0 1 ${$bb72e68028dbdf4a$var$number(x)} ${$bb72e68028dbdf4a$var$number(y)} Tm`);
                    hadOffset = false;
                }
                if (pos.xAdvance - pos.advanceWidth !== 0) addSegment(i + 1);
            }
            x += pos.xAdvance * scale;
        }
        flush(i);
        this.addContent('ET');
        this.restore();
    }
};
const $bb72e68028dbdf4a$var$toBinaryString = (bytes)=>{
    const chunkSize = 0x8000;
    let out = '';
    for(let i = 0; i < bytes.length; i += chunkSize){
        const end = Math.min(i + chunkSize, bytes.length);
        out += String.fromCharCode.apply(null, bytes.subarray(i, end));
    }
    return out;
};
const $bb72e68028dbdf4a$var$readUInt16BE = (bytes, offset = 0)=>(bytes[offset] << 8 | bytes[offset + 1]) >>> 0;
const $bb72e68028dbdf4a$var$readUInt16LE = (bytes, offset = 0)=>(bytes[offset + 1] << 8 | bytes[offset]) >>> 0;
const $bb72e68028dbdf4a$var$readUInt32BE = (bytes, offset = 0)=>bytes[offset] * 0x1000000 + (bytes[offset + 1] << 16 | bytes[offset + 2] << 8 | bytes[offset + 3]) >>> 0;
const $bb72e68028dbdf4a$var$readUInt32LE = (bytes, offset = 0)=>(bytes[offset] | bytes[offset + 1] << 8 | bytes[offset + 2] << 16) + bytes[offset + 3] * 0x1000000 >>> 0;
const $bb72e68028dbdf4a$var$parseExifOrientation = (data)=>{
    if (!data || data.length < 20) return null;
    let pos = 2;
    while(pos < data.length - 4){
        while(pos < data.length && data[pos] !== 0xff)pos++;
        if (pos >= data.length - 4) return null;
        const marker = $bb72e68028dbdf4a$var$readUInt16BE(data, pos);
        pos += 2;
        if (marker === 0xffda) return null;
        if (marker >= 0xffd0 && marker <= 0xffd9 || marker === 0xff01) continue;
        if (pos + 2 > data.length) return null;
        const segmentLength = $bb72e68028dbdf4a$var$readUInt16BE(data, pos);
        if (marker === 0xffe1 && pos + 8 <= data.length) {
            const exifHeader = $bb72e68028dbdf4a$var$toBinaryString(data.subarray(pos + 2, pos + 8));
            if (exifHeader === 'Exif\x00\x00') {
                const tiffStart = pos + 8;
                if (tiffStart + 8 > data.length) return null;
                const byteOrder = $bb72e68028dbdf4a$var$toBinaryString(data.subarray(tiffStart, tiffStart + 2));
                const isLittleEndian = byteOrder === 'II';
                if (!isLittleEndian && byteOrder !== 'MM') return null;
                const read16 = isLittleEndian ? (o)=>$bb72e68028dbdf4a$var$readUInt16LE(data, o) : (o)=>$bb72e68028dbdf4a$var$readUInt16BE(data, o);
                const read32 = isLittleEndian ? (o)=>$bb72e68028dbdf4a$var$readUInt32LE(data, o) : (o)=>$bb72e68028dbdf4a$var$readUInt32BE(data, o);
                if (read16(tiffStart + 2) !== 42) return null;
                const ifdPos = tiffStart + read32(tiffStart + 4);
                if (ifdPos + 2 > data.length) return null;
                const entryCount = read16(ifdPos);
                for(let i = 0; i < entryCount; i++){
                    const entryPos = ifdPos + 2 + i * 12;
                    if (entryPos + 12 > data.length) return null;
                    if (read16(entryPos) === 0x0112) {
                        const value = read16(entryPos + 8);
                        return value >= 1 && value <= 8 ? value : null;
                    }
                }
                return null;
            }
        }
        pos += segmentLength;
    }
    return null;
};
const $bb72e68028dbdf4a$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
const $bb72e68028dbdf4a$var$COLOR_SPACE_MAP = {
    1: 'DeviceGray',
    3: 'DeviceRGB',
    4: 'DeviceCMYK'
};
class $bb72e68028dbdf4a$var$JPEG {
    constructor(data, label){
        let marker;
        this.data = data;
        this.label = label;
        if (this.data.readUInt16BE(0) !== 0xffd8) throw 'SOI not found in JPEG';
        this.orientation = $bb72e68028dbdf4a$var$parseExifOrientation(this.data) || 1;
        let pos = 2;
        while(pos < this.data.length){
            while(pos < this.data.length && this.data[pos] !== 0xff)pos++;
            if (pos >= this.data.length) break;
            marker = this.data.readUInt16BE(pos);
            pos += 2;
            if ($bb72e68028dbdf4a$var$MARKERS.includes(marker)) break;
            pos += this.data.readUInt16BE(pos);
        }
        if (!$bb72e68028dbdf4a$var$MARKERS.includes(marker)) throw 'Invalid JPEG.';
        pos += 2;
        this.bits = this.data[pos++];
        this.height = this.data.readUInt16BE(pos);
        pos += 2;
        this.width = this.data.readUInt16BE(pos);
        pos += 2;
        const channels = this.data[pos];
        this.colorSpace = $bb72e68028dbdf4a$var$COLOR_SPACE_MAP[channels];
        this.obj = null;
    }
    embed(document) {
        if (this.obj) return;
        this.obj = document.ref({
            Type: 'XObject',
            Subtype: 'Image',
            BitsPerComponent: this.bits,
            Width: this.width,
            Height: this.height,
            ColorSpace: this.colorSpace,
            Filter: 'DCTDecode'
        });
        if (this.colorSpace === 'DeviceCMYK') this.obj.data['Decode'] = [
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ];
        this.obj.end(this.data);
        return this.data = null;
    }
}
class $bb72e68028dbdf4a$var$PNGImage {
    constructor(data, label){
        this.label = label;
        this.image = new (0, $ijE9O.default)(data);
        this.width = this.image.width;
        this.height = this.image.height;
        this.imgData = this.image.imgData;
        this.obj = null;
    }
    embed(document) {
        this.document = document;
        if (this.obj) return;
        const { image: image, height: height, width: width } = this;
        const hasAlphaChannel = image.hasAlphaChannel;
        const isInterlaced = image.interlaceMethod === 1;
        const obj = this.obj = document.ref({
            Type: 'XObject',
            Subtype: 'Image',
            BitsPerComponent: hasAlphaChannel ? 8 : image.bits,
            Width: width,
            Height: height,
            Filter: 'FlateDecode'
        });
        if (!hasAlphaChannel) {
            const params = document.ref({
                Predictor: isInterlaced ? 1 : 15,
                Colors: image.colors,
                BitsPerComponent: image.bits,
                Columns: width
            });
            obj.data['DecodeParms'] = params;
            params.end();
        }
        if (image.palette.length === 0) obj.data['ColorSpace'] = image.colorSpace;
        else {
            const palette = document.ref();
            palette.end($bb72e68028dbdf4a$require$Buffer.from(image.palette));
            obj.data['ColorSpace'] = [
                'Indexed',
                'DeviceRGB',
                image.palette.length / 3 - 1,
                palette
            ];
        }
        if (image.transparency.grayscale != null) {
            const val = image.transparency.grayscale;
            obj.data['Mask'] = [
                val,
                val
            ];
        } else if (image.transparency.rgb) {
            const { rgb: rgb } = image.transparency;
            const mask = [];
            for (let x of rgb)mask.push(x, x);
            obj.data['Mask'] = mask;
        } else if (image.transparency.indexed) return this.loadIndexedAlphaChannel();
        else if (hasAlphaChannel) return this.splitAlphaChannel();
        if (isInterlaced && true) return this.decodeData();
        this.finalize();
    }
    finalize() {
        if (this.alphaChannel) {
            const sMask = this.document.ref({
                Type: 'XObject',
                Subtype: 'Image',
                Height: this.height,
                Width: this.width,
                BitsPerComponent: 8,
                Filter: 'FlateDecode',
                ColorSpace: 'DeviceGray',
                Decode: [
                    0,
                    1
                ]
            });
            sMask.end(this.alphaChannel);
            this.obj.data['SMask'] = sMask;
        }
        this.obj.end(this.imgData);
        this.image = null;
        return this.imgData = null;
    }
    splitAlphaChannel() {
        return this.image.decodePixels((pixels)=>{
            let a, p;
            const colorCount = this.image.colors;
            const pixelCount = this.width * this.height;
            const imgData = $bb72e68028dbdf4a$require$Buffer.alloc(pixelCount * colorCount);
            const alphaChannel = $bb72e68028dbdf4a$require$Buffer.alloc(pixelCount);
            let i = p = a = 0;
            const len = pixels.length;
            const skipByteCount = this.image.bits === 16 ? 1 : 0;
            while(i < len){
                for(let colorIndex = 0; colorIndex < colorCount; colorIndex++){
                    imgData[p++] = pixels[i++];
                    i += skipByteCount;
                }
                alphaChannel[a++] = pixels[i++];
                i += skipByteCount;
            }
            this.imgData = (0, (/*@__PURE__*/$parcel$interopDefault($gxZpm))).deflateSync(imgData);
            this.alphaChannel = (0, (/*@__PURE__*/$parcel$interopDefault($gxZpm))).deflateSync(alphaChannel);
            return this.finalize();
        });
    }
    loadIndexedAlphaChannel() {
        const transparency = this.image.transparency.indexed;
        const isInterlaced = this.image.interlaceMethod === 1;
        return this.image.decodePixels((pixels)=>{
            const alphaChannel = $bb72e68028dbdf4a$require$Buffer.alloc(this.width * this.height);
            let i = 0;
            for(let j = 0, end = pixels.length; j < end; j++)alphaChannel[i++] = transparency[pixels[j]];
            if (isInterlaced) this.imgData = (0, (/*@__PURE__*/$parcel$interopDefault($gxZpm))).deflateSync($bb72e68028dbdf4a$require$Buffer.from(pixels));
            this.alphaChannel = (0, (/*@__PURE__*/$parcel$interopDefault($gxZpm))).deflateSync(alphaChannel);
            return this.finalize();
        });
    }
    decodeData() {
        this.image.decodePixels((pixels)=>{
            this.imgData = (0, (/*@__PURE__*/$parcel$interopDefault($gxZpm))).deflateSync(pixels);
            this.finalize();
        });
    }
}
class $bb72e68028dbdf4a$var$PDFImage {
    static open(src, label) {
        let data;
        if ($bb72e68028dbdf4a$require$Buffer.isBuffer(src)) data = src;
        else if (src instanceof ArrayBuffer) data = $bb72e68028dbdf4a$require$Buffer.from(new Uint8Array(src));
        else {
            const match = /^data:.+?;base64,(.*)$/.exec(src);
            if (match) data = $bb72e68028dbdf4a$require$Buffer.from(match[1], 'base64');
            else {
                data = (0, (/*@__PURE__*/$parcel$interopDefault($kjyEk))).readFileSync(src);
                if (!data) return;
            }
        }
        if (data[0] === 0xff && data[1] === 0xd8) return new $bb72e68028dbdf4a$var$JPEG(data, label);
        else if (data[0] === 0x89 && data[1] === 0x50 && data[2] === 0x4e && data[3] === 0x47) return new $bb72e68028dbdf4a$var$PNGImage(data, label);
        else throw new Error('Unknown image format.');
    }
}
var $bb72e68028dbdf4a$var$ImagesMixin = {
    initImages () {
        this._imageRegistry = {};
        this._imageCount = 0;
    },
    image (src, x, y, options = {}) {
        let bh, bp, bw, image, ip, left, left1, originX, originY;
        if (typeof x === 'object') {
            options = x;
            x = null;
        }
        const ignoreOrientation = options.ignoreOrientation || options.ignoreOrientation !== false && this.options.ignoreOrientation;
        const inDocumentFlow = typeof y !== 'number';
        x = (left = x != null ? x : options.x) != null ? left : this.x;
        y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;
        if (typeof src === 'string') image = this._imageRegistry[src];
        if (!image) {
            if (src.width && src.height) image = src;
            else image = this.openImage(src);
        }
        if (!image.obj) image.embed(this);
        if (this.page.xobjects[image.label] == null) this.page.xobjects[image.label] = image.obj;
        let { width: width, height: height } = image;
        if (!ignoreOrientation && image.orientation > 4) [width, height] = [
            height,
            width
        ];
        let w = options.width || width;
        let h = options.height || height;
        if (options.width && !options.height) {
            const wp = w / width;
            w = width * wp;
            h = height * wp;
        } else if (options.height && !options.width) {
            const hp = h / height;
            w = width * hp;
            h = height * hp;
        } else if (options.scale) {
            w = width * options.scale;
            h = height * options.scale;
        } else if (options.fit) {
            [bw, bh] = options.fit;
            bp = bw / bh;
            ip = width / height;
            if (ip > bp) {
                w = bw;
                h = bw / ip;
            } else {
                h = bh;
                w = bh * ip;
            }
        } else if (options.cover) {
            [bw, bh] = options.cover;
            bp = bw / bh;
            ip = width / height;
            if (ip > bp) {
                h = bh;
                w = bh * ip;
            } else {
                w = bw;
                h = bw / ip;
            }
        }
        if (options.fit || options.cover) {
            if (options.align === 'center') x = x + bw / 2 - w / 2;
            else if (options.align === 'right') x = x + bw - w;
            if (options.valign === 'center') y = y + bh / 2 - h / 2;
            else if (options.valign === 'bottom') y = y + bh - h;
        }
        let rotateAngle = 0;
        let xTransform = x;
        let yTransform = y;
        let hTransform = h;
        let wTransform = w;
        if (!ignoreOrientation) switch(image.orientation){
            default:
            case 1:
                hTransform = -h;
                yTransform += h;
                break;
            case 2:
                wTransform = -w;
                hTransform = -h;
                xTransform += w;
                yTransform += h;
                break;
            case 3:
                originX = x;
                originY = y;
                hTransform = -h;
                xTransform -= w;
                rotateAngle = 180;
                break;
            case 4:
                break;
            case 5:
                originX = x;
                originY = y;
                wTransform = h;
                hTransform = w;
                yTransform -= hTransform;
                rotateAngle = 90;
                break;
            case 6:
                originX = x;
                originY = y;
                wTransform = h;
                hTransform = -w;
                rotateAngle = 90;
                break;
            case 7:
                originX = x;
                originY = y;
                hTransform = -w;
                wTransform = -h;
                xTransform += h;
                rotateAngle = 90;
                break;
            case 8:
                originX = x;
                originY = y;
                wTransform = h;
                hTransform = -w;
                xTransform -= h;
                yTransform += w;
                rotateAngle = -90;
                break;
        }
        else {
            hTransform = -h;
            yTransform += h;
        }
        if (options.link != null) this.link(x, y, w, h, options.link);
        if (options.goTo != null) this.goTo(x, y, w, h, options.goTo);
        if (options.destination != null) this.addNamedDestination(options.destination, 'XYZ', x, y, null);
        if (inDocumentFlow) this.y += h;
        this.save();
        if (options.opacity != null) this._doOpacity(options.opacity, null);
        if (rotateAngle) this.rotate(rotateAngle, {
            origin: [
                originX,
                originY
            ]
        });
        this.transform(wTransform, 0, 0, hTransform, xTransform, yTransform);
        this.addContent(`/${image.label} Do`);
        this.restore();
        return this;
    },
    openImage (src) {
        let image;
        if (typeof src === 'string') image = this._imageRegistry[src];
        if (!image) {
            image = $bb72e68028dbdf4a$var$PDFImage.open(src, `I${++this._imageCount}`);
            if (typeof src === 'string') this._imageRegistry[src] = image;
        }
        return image;
    }
};
class $bb72e68028dbdf4a$var$PDFAnnotationReference {
    constructor(annotationRef){
        this.annotationRef = annotationRef;
    }
}
var $bb72e68028dbdf4a$var$AnnotationsMixin = {
    annotate (x, y, w, h, options) {
        options.Type = 'Annot';
        options.Rect = this._convertRect(x, y, w, h);
        options.Border = [
            0,
            0,
            0
        ];
        if (options.Subtype === 'Link' && typeof options.F === 'undefined') options.F = 4;
        if (options.Subtype !== 'Link') {
            if (options.C == null) options.C = this._normalizeColor(options.color || [
                0,
                0,
                0
            ]);
        }
        delete options.color;
        if (typeof options.Dest === 'string') options.Dest = new String(options.Dest);
        const structParent = options.structParent;
        delete options.structParent;
        for(let key in options){
            const val = options[key];
            options[key[0].toUpperCase() + key.slice(1)] = val;
        }
        const ref = this.ref(options);
        this.page.annotations.push(ref);
        if (structParent && typeof structParent.add === 'function') {
            const annotRef = new $bb72e68028dbdf4a$var$PDFAnnotationReference(ref);
            structParent.add(annotRef);
        }
        ref.end();
        return this;
    },
    note (x, y, w, h, contents, options = {}) {
        options.Subtype = 'Text';
        options.Contents = new String(contents);
        if (options.Name == null) options.Name = 'Comment';
        if (options.color == null) options.color = [
            243,
            223,
            92
        ];
        return this.annotate(x, y, w, h, options);
    },
    goTo (x, y, w, h, name, options = {}) {
        options.Subtype = 'Link';
        options.A = this.ref({
            S: 'GoTo',
            D: new String(name)
        });
        options.A.end();
        return this.annotate(x, y, w, h, options);
    },
    link (x, y, w, h, url, options = {}) {
        options.Subtype = 'Link';
        if (typeof url === 'number') {
            const pages = this._root.data.Pages.data;
            if (url >= 0 && url < pages.Kids.length) {
                options.A = this.ref({
                    S: 'GoTo',
                    D: [
                        pages.Kids[url],
                        'XYZ',
                        null,
                        null,
                        null
                    ]
                });
                options.A.end();
            } else throw new Error(`The document has no page ${url}`);
        } else {
            options.A = this.ref({
                S: 'URI',
                URI: new String(url)
            });
            options.A.end();
        }
        if (options.structParent && !options.Contents) options.Contents = new String('');
        return this.annotate(x, y, w, h, options);
    },
    _markup (x, y, w, h, options = {}) {
        const [x1, y1, x2, y2] = this._convertRect(x, y, w, h);
        options.QuadPoints = [
            x1,
            y2,
            x2,
            y2,
            x1,
            y1,
            x2,
            y1
        ];
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    highlight (x, y, w, h, options = {}) {
        options.Subtype = 'Highlight';
        if (options.color == null) options.color = [
            241,
            238,
            148
        ];
        return this._markup(x, y, w, h, options);
    },
    underline (x, y, w, h, options = {}) {
        options.Subtype = 'Underline';
        return this._markup(x, y, w, h, options);
    },
    strike (x, y, w, h, options = {}) {
        options.Subtype = 'StrikeOut';
        return this._markup(x, y, w, h, options);
    },
    lineAnnotation (x1, y1, x2, y2, options = {}) {
        options.Subtype = 'Line';
        options.Contents = new String();
        options.L = [
            x1,
            this.page.height - y1,
            x2,
            this.page.height - y2
        ];
        return this.annotate(x1, y1, x2, y2, options);
    },
    rectAnnotation (x, y, w, h, options = {}) {
        options.Subtype = 'Square';
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    ellipseAnnotation (x, y, w, h, options = {}) {
        options.Subtype = 'Circle';
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    textAnnotation (x, y, w, h, text, options = {}) {
        options.Subtype = 'FreeText';
        options.Contents = new String(text);
        options.DA = new String();
        return this.annotate(x, y, w, h, options);
    },
    fileAnnotation (x, y, w, h, file = {}, options = {}) {
        const filespec = this.file(file.src, Object.assign({
            hidden: true
        }, file));
        options.Subtype = 'FileAttachment';
        options.FS = filespec;
        if (options.Contents) options.Contents = new String(options.Contents);
        else if (filespec.data.Desc) options.Contents = filespec.data.Desc;
        return this.annotate(x, y, w, h, options);
    },
    _convertRect (x1, y1, w, h) {
        let y2 = y1;
        y1 += h;
        let x2 = x1 + w;
        const [m0, m1, m2, m3, m4, m5] = this._ctm;
        x1 = m0 * x1 + m2 * y1 + m4;
        y1 = m1 * x1 + m3 * y1 + m5;
        x2 = m0 * x2 + m2 * y2 + m4;
        y2 = m1 * x2 + m3 * y2 + m5;
        return [
            x1,
            y1,
            x2,
            y2
        ];
    }
};
const $bb72e68028dbdf4a$var$DEFAULT_OPTIONS = {
    top: 0,
    left: 0,
    zoom: 0,
    fit: true,
    pageNumber: null,
    expanded: false
};
class $bb72e68028dbdf4a$var$PDFOutline {
    constructor(document, parent, title, dest, options = $bb72e68028dbdf4a$var$DEFAULT_OPTIONS){
        this.document = document;
        this.options = options;
        this.outlineData = {};
        if (dest !== null) {
            const destWidth = dest.data.MediaBox[2];
            const destHeight = dest.data.MediaBox[3];
            const top = destHeight - (options.top || 0);
            const left = destWidth - (options.left || 0);
            const zoom = options.zoom || 0;
            this.outlineData['Dest'] = options.fit ? [
                dest,
                'Fit'
            ] : [
                dest,
                'XYZ',
                left,
                top,
                zoom
            ];
        }
        if (parent !== null) this.outlineData['Parent'] = parent;
        if (title !== null) this.outlineData['Title'] = new String(title);
        this.dictionary = this.document.ref(this.outlineData);
        this.children = [];
    }
    addItem(title, options = $bb72e68028dbdf4a$var$DEFAULT_OPTIONS) {
        const pages = this.document._root.data.Pages.data.Kids;
        const dest = options.pageNumber != null ? pages[options.pageNumber] : this.document.page.dictionary;
        const result = new $bb72e68028dbdf4a$var$PDFOutline(this.document, this.dictionary, title, dest, options);
        this.children.push(result);
        return result;
    }
    endOutline() {
        if (this.children.length > 0) {
            if (this.options.expanded) this.outlineData.Count = this.children.length;
            const first = this.children[0], last = this.children[this.children.length - 1];
            this.outlineData.First = first.dictionary;
            this.outlineData.Last = last.dictionary;
            for(let i = 0, len = this.children.length; i < len; i++){
                const child = this.children[i];
                if (i > 0) child.outlineData.Prev = this.children[i - 1].dictionary;
                if (i < this.children.length - 1) child.outlineData.Next = this.children[i + 1].dictionary;
                child.endOutline();
            }
        }
        return this.dictionary.end();
    }
}
var $bb72e68028dbdf4a$var$OutlineMixin = {
    initOutline () {
        this.outline = new $bb72e68028dbdf4a$var$PDFOutline(this, null, null, null);
    },
    endOutline () {
        this.outline.endOutline();
        if (this.outline.children.length > 0) {
            this._root.data.Outlines = this.outline.dictionary;
            return this._root.data.PageMode = this._root.data.PageMode || 'UseOutlines';
        }
    }
};
class $bb72e68028dbdf4a$var$PDFStructureContent {
    constructor(pageRef, mcid){
        this.refs = [
            {
                pageRef: pageRef,
                mcid: mcid
            }
        ];
    }
    push(structContent) {
        structContent.refs.forEach((ref)=>this.refs.push(ref));
    }
}
class $bb72e68028dbdf4a$var$PDFStructureElement {
    constructor(document, type, options = {}, children = null){
        this.document = document;
        this._attached = false;
        this._ended = false;
        this._flushed = false;
        this.dictionary = document.ref({
            S: type
        });
        const data = this.dictionary.data;
        if (Array.isArray(options) || this._isValidChild(options)) {
            children = options;
            options = {};
        }
        if (options.title) data.T = new String(options.title);
        if (options.lang) data.Lang = new String(options.lang);
        if (options.alt) data.Alt = new String(options.alt);
        if (options.expanded) data.E = new String(options.expanded);
        if (options.actual) data.ActualText = new String(options.actual);
        const hasBbox = Array.isArray(options.bbox) && options.bbox.length === 4;
        const hasPlacement = typeof options.placement === 'string';
        if (hasBbox || hasPlacement) {
            const attrs = {
                O: 'Layout'
            };
            attrs.Placement = hasPlacement ? options.placement : 'Block';
            if (hasBbox) {
                const height = document.page.height;
                attrs.BBox = [
                    options.bbox[0],
                    height - options.bbox[3],
                    options.bbox[2],
                    height - options.bbox[1]
                ];
            }
            data.A = attrs;
        }
        if (options.scope) data.A = {
            ...data.A || {},
            O: 'Table',
            Scope: options.scope
        };
        this._children = [];
        if (children) {
            if (!Array.isArray(children)) children = [
                children
            ];
            children.forEach((child)=>this.add(child));
            this.end();
        }
    }
    add(child) {
        if (this._ended) throw new Error(`Cannot add child to already-ended structure element`);
        if (!this._isValidChild(child)) throw new Error(`Invalid structure element child`);
        if (child instanceof $bb72e68028dbdf4a$var$PDFStructureElement) {
            child.setParent(this.dictionary);
            if (this._attached) child.setAttached();
        }
        if (child instanceof $bb72e68028dbdf4a$var$PDFStructureContent) this._addContentToParentTree(child);
        if (child instanceof $bb72e68028dbdf4a$var$PDFAnnotationReference) this._addAnnotationToParentTree(child.annotationRef);
        if (typeof child === 'function' && this._attached) child = this._contentForClosure(child);
        this._children.push(child);
        return this;
    }
    _addContentToParentTree(content) {
        content.refs.forEach(({ pageRef: pageRef, mcid: mcid })=>{
            const pageStructParents = this.document.getStructParentTree().get(pageRef.data.StructParents);
            pageStructParents[mcid] = this.dictionary;
        });
    }
    _addAnnotationToParentTree(annotRef) {
        const parentTreeKey = this.document.createStructParentTreeNextKey();
        annotRef.data.StructParent = parentTreeKey;
        const parentTree = this.document.getStructParentTree();
        parentTree.add(parentTreeKey, this.dictionary);
    }
    setParent(parentRef) {
        if (this.dictionary.data.P) throw new Error(`Structure element added to more than one parent`);
        this.dictionary.data.P = parentRef;
        this._flush();
    }
    setAttached() {
        if (this._attached) return;
        this._children.forEach((child, index)=>{
            if (child instanceof $bb72e68028dbdf4a$var$PDFStructureElement) child.setAttached();
            if (typeof child === 'function') this._children[index] = this._contentForClosure(child);
        });
        this._attached = true;
        this._flush();
    }
    end() {
        if (this._ended) return;
        this._children.filter((child)=>child instanceof $bb72e68028dbdf4a$var$PDFStructureElement).forEach((child)=>child.end());
        this._ended = true;
        this._flush();
    }
    _isValidChild(child) {
        return child instanceof $bb72e68028dbdf4a$var$PDFStructureElement || child instanceof $bb72e68028dbdf4a$var$PDFStructureContent || child instanceof $bb72e68028dbdf4a$var$PDFAnnotationReference || typeof child === 'function';
    }
    _contentForClosure(closure) {
        const content = this.document.markStructureContent(this.dictionary.data.S);
        const prevStructElement = this.document._currentStructureElement;
        this.document._currentStructureElement = this;
        const wasEnded = this._ended;
        this._ended = false;
        closure();
        this._ended = wasEnded;
        this.document._currentStructureElement = prevStructElement;
        this.document.endMarkedContent();
        this._addContentToParentTree(content);
        return content;
    }
    _isFlushable() {
        if (!this.dictionary.data.P || !this._ended) return false;
        return this._children.every((child)=>{
            if (typeof child === 'function') return false;
            if (child instanceof $bb72e68028dbdf4a$var$PDFStructureElement) return child._isFlushable();
            return true;
        });
    }
    _flush() {
        if (this._flushed || !this._isFlushable()) return;
        this.dictionary.data.K = [];
        this._children.forEach((child)=>this._flushChild(child));
        this.dictionary.end();
        this._children = [];
        this.dictionary.data.K = null;
        this._flushed = true;
    }
    _flushChild(child) {
        if (child instanceof $bb72e68028dbdf4a$var$PDFStructureElement) this.dictionary.data.K.push(child.dictionary);
        if (child instanceof $bb72e68028dbdf4a$var$PDFStructureContent) child.refs.forEach(({ pageRef: pageRef, mcid: mcid })=>{
            if (!this.dictionary.data.Pg) this.dictionary.data.Pg = pageRef;
            if (this.dictionary.data.Pg === pageRef) this.dictionary.data.K.push(mcid);
            else this.dictionary.data.K.push({
                Type: 'MCR',
                Pg: pageRef,
                MCID: mcid
            });
        });
        if (child instanceof $bb72e68028dbdf4a$var$PDFAnnotationReference) {
            const pageRef = this.document.page.dictionary;
            const objr = {
                Type: 'OBJR',
                Obj: child.annotationRef,
                Pg: pageRef
            };
            this.dictionary.data.K.push(objr);
        }
    }
}
class $bb72e68028dbdf4a$var$PDFNumberTree extends $bb72e68028dbdf4a$var$PDFTree {
    _compareKeys(a, b) {
        return parseInt(a) - parseInt(b);
    }
    _keysName() {
        return 'Nums';
    }
    _dataForKey(k) {
        return parseInt(k);
    }
}
var $bb72e68028dbdf4a$var$MarkingsMixin = {
    initMarkings (options) {
        this.structChildren = [];
        if (options.tagged) {
            this.getMarkInfoDictionary().data.Marked = true;
            this.getStructTreeRoot();
        }
    },
    markContent (tag, options = null) {
        if (tag === 'Artifact' || options && options.mcid) {
            let toClose = 0;
            this.page.markings.forEach((marking)=>{
                if (toClose || marking.structContent || marking.tag === 'Artifact') toClose++;
            });
            while(toClose--)this.endMarkedContent();
        }
        if (!options) {
            this.page.markings.push({
                tag: tag
            });
            this.addContent(`/${tag} BMC`);
            return this;
        }
        this.page.markings.push({
            tag: tag,
            options: options
        });
        const dictionary = {};
        if (typeof options.mcid !== 'undefined') dictionary.MCID = options.mcid;
        if (tag === 'Artifact') {
            if (typeof options.type === 'string') dictionary.Type = options.type;
            if (Array.isArray(options.bbox)) dictionary.BBox = [
                options.bbox[0],
                this.page.height - options.bbox[3],
                options.bbox[2],
                this.page.height - options.bbox[1]
            ];
            if (Array.isArray(options.attached) && options.attached.every((val)=>typeof val === 'string')) dictionary.Attached = options.attached;
        }
        if (tag === 'Span') {
            if (options.lang) dictionary.Lang = new String(options.lang);
            if (options.alt) dictionary.Alt = new String(options.alt);
            if (options.expanded) dictionary.E = new String(options.expanded);
            if (options.actual) dictionary.ActualText = new String(options.actual);
        }
        this.addContent(`/${tag} ${$bb72e68028dbdf4a$var$PDFObject.convert(dictionary)} BDC`);
        return this;
    },
    markStructureContent (tag, options = {}) {
        const pageStructParents = this.getStructParentTree().get(this.page.structParentTreeKey);
        const mcid = pageStructParents.length;
        pageStructParents.push(null);
        this.markContent(tag, {
            ...options,
            mcid: mcid
        });
        const structContent = new $bb72e68028dbdf4a$var$PDFStructureContent(this.page.dictionary, mcid);
        this.page.markings.slice(-1)[0].structContent = structContent;
        return structContent;
    },
    endMarkedContent () {
        this.page.markings.pop();
        this.addContent('EMC');
        if (this._textOptions) {
            delete this._textOptions.link;
            delete this._textOptions.goTo;
            delete this._textOptions.destination;
            delete this._textOptions.underline;
            delete this._textOptions.strike;
        }
        return this;
    },
    struct (type, options = {}, children = null) {
        return new $bb72e68028dbdf4a$var$PDFStructureElement(this, type, options, children);
    },
    addStructure (structElem) {
        const structTreeRoot = this.getStructTreeRoot();
        structElem.setParent(structTreeRoot);
        structElem.setAttached();
        this.structChildren.push(structElem);
        if (!structTreeRoot.data.K) structTreeRoot.data.K = [];
        structTreeRoot.data.K.push(structElem.dictionary);
        return this;
    },
    initPageMarkings (pageMarkings) {
        pageMarkings.forEach((marking)=>{
            if (marking.structContent) {
                const structContent = marking.structContent;
                const newStructContent = this.markStructureContent(marking.tag, marking.options);
                structContent.push(newStructContent);
                this.page.markings.slice(-1)[0].structContent = structContent;
            } else this.markContent(marking.tag, marking.options);
        });
    },
    endPageMarkings (page) {
        const pageMarkings = page.markings;
        pageMarkings.forEach(()=>page.write('EMC'));
        page.markings = [];
        return pageMarkings;
    },
    getMarkInfoDictionary () {
        if (!this._root.data.MarkInfo) this._root.data.MarkInfo = this.ref({});
        return this._root.data.MarkInfo;
    },
    hasMarkInfoDictionary () {
        return !!this._root.data.MarkInfo;
    },
    getStructTreeRoot () {
        if (!this._root.data.StructTreeRoot) this._root.data.StructTreeRoot = this.ref({
            Type: 'StructTreeRoot',
            ParentTree: new $bb72e68028dbdf4a$var$PDFNumberTree(),
            ParentTreeNextKey: 0
        });
        return this._root.data.StructTreeRoot;
    },
    getStructParentTree () {
        return this.getStructTreeRoot().data.ParentTree;
    },
    createStructParentTreeNextKey () {
        this.getMarkInfoDictionary();
        const structTreeRoot = this.getStructTreeRoot();
        const key = structTreeRoot.data.ParentTreeNextKey++;
        structTreeRoot.data.ParentTree.add(key, []);
        return key;
    },
    endMarkings () {
        const structTreeRoot = this._root.data.StructTreeRoot;
        if (structTreeRoot) {
            structTreeRoot.end();
            this.structChildren.forEach((structElem)=>structElem.end());
        }
        if (this._root.data.MarkInfo) this._root.data.MarkInfo.end();
    }
};
const $bb72e68028dbdf4a$var$FIELD_FLAGS = {
    readOnly: 1,
    required: 2,
    noExport: 4,
    multiline: 0x1000,
    password: 0x2000,
    toggleToOffButton: 0x4000,
    radioButton: 0x8000,
    pushButton: 0x10000,
    combo: 0x20000,
    edit: 0x40000,
    sort: 0x80000,
    multiSelect: 0x200000,
    noSpell: 0x400000
};
const $bb72e68028dbdf4a$var$FIELD_JUSTIFY = {
    left: 0,
    center: 1,
    right: 2
};
const $bb72e68028dbdf4a$var$VALUE_MAP = {
    value: 'V',
    defaultValue: 'DV'
};
const $bb72e68028dbdf4a$var$FORMAT_SPECIAL = {
    zip: '0',
    zipPlus4: '1',
    zip4: '1',
    phone: '2',
    ssn: '3'
};
const $bb72e68028dbdf4a$var$FORMAT_DEFAULT = {
    number: {
        nDec: 0,
        sepComma: false,
        negStyle: 'MinusBlack',
        currency: '',
        currencyPrepend: true
    },
    percent: {
        nDec: 0,
        sepComma: false
    }
};
var $bb72e68028dbdf4a$var$AcroFormMixin = {
    initForm () {
        if (!this._font) throw new Error('Must set a font before calling initForm method');
        this._acroform = {
            fonts: {},
            defaultFont: this._font.name
        };
        this._acroform.fonts[this._font.id] = this._font.ref();
        let data = {
            Fields: [],
            NeedAppearances: true,
            DA: new String(`/${this._font.id} 0 Tf 0 g`),
            DR: {
                Font: {}
            }
        };
        data.DR.Font[this._font.id] = this._font.ref();
        const AcroForm = this.ref(data);
        this._root.data.AcroForm = AcroForm;
        return this;
    },
    endAcroForm () {
        if (this._root.data.AcroForm) {
            if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) throw new Error('No fonts specified for PDF form');
            let fontDict = this._root.data.AcroForm.data.DR.Font;
            Object.keys(this._acroform.fonts).forEach((name)=>{
                fontDict[name] = this._acroform.fonts[name];
            });
            this._root.data.AcroForm.data.Fields.forEach((fieldRef)=>{
                this._endChild(fieldRef);
            });
            this._root.data.AcroForm.end();
        }
        return this;
    },
    _endChild (ref) {
        if (Array.isArray(ref.data.Kids)) {
            ref.data.Kids.forEach((childRef)=>{
                this._endChild(childRef);
            });
            ref.end();
        }
        return this;
    },
    formField (name, options = {}) {
        let fieldDict = this._fieldDict(name, null, options);
        let fieldRef = this.ref(fieldDict);
        this._addToParent(fieldRef);
        return fieldRef;
    },
    formAnnotation (name, type, x, y, w, h, options = {}) {
        let fieldDict = this._fieldDict(name, type, options);
        fieldDict.Subtype = 'Widget';
        if (fieldDict.F === undefined) fieldDict.F = 4;
        this.annotate(x, y, w, h, fieldDict);
        let annotRef = this.page.annotations[this.page.annotations.length - 1];
        return this._addToParent(annotRef);
    },
    formText (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'text', x, y, w, h, options);
    },
    formPushButton (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'pushButton', x, y, w, h, options);
    },
    formCombo (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'combo', x, y, w, h, options);
    },
    formList (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'list', x, y, w, h, options);
    },
    formRadioButton (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'radioButton', x, y, w, h, options);
    },
    formCheckbox (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'checkbox', x, y, w, h, options);
    },
    _addToParent (fieldRef) {
        let parent = fieldRef.data.Parent;
        if (parent) {
            if (!parent.data.Kids) parent.data.Kids = [];
            parent.data.Kids.push(fieldRef);
        } else this._root.data.AcroForm.data.Fields.push(fieldRef);
        return this;
    },
    _fieldDict (name, type, options = {}) {
        if (!this._acroform) throw new Error('Call document.initForm() method before adding form elements to document');
        let opts = Object.assign({}, options);
        if (type !== null) opts = this._resolveType(type, options);
        opts = this._resolveFlags(opts);
        opts = this._resolveJustify(opts);
        opts = this._resolveFont(opts);
        opts = this._resolveStrings(opts);
        opts = this._resolveColors(opts);
        opts = this._resolveFormat(opts);
        opts.T = new String(name);
        if (opts.parent) {
            opts.Parent = opts.parent;
            delete opts.parent;
        }
        return opts;
    },
    _resolveType (type, opts) {
        if (type === 'text') opts.FT = 'Tx';
        else if (type === 'pushButton') {
            opts.FT = 'Btn';
            opts.pushButton = true;
        } else if (type === 'radioButton') {
            opts.FT = 'Btn';
            opts.radioButton = true;
        } else if (type === 'checkbox') opts.FT = 'Btn';
        else if (type === 'combo') {
            opts.FT = 'Ch';
            opts.combo = true;
        } else if (type === 'list') opts.FT = 'Ch';
        else throw new Error(`Invalid form annotation type '${type}'`);
        return opts;
    },
    _resolveFormat (opts) {
        const f = opts.format;
        if (f && f.type) {
            let fnKeystroke;
            let fnFormat;
            let params = '';
            if ($bb72e68028dbdf4a$var$FORMAT_SPECIAL[f.type] !== undefined) {
                fnKeystroke = `AFSpecial_Keystroke`;
                fnFormat = `AFSpecial_Format`;
                params = $bb72e68028dbdf4a$var$FORMAT_SPECIAL[f.type];
            } else {
                let format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
                fnKeystroke = `AF${format}_Keystroke`;
                fnFormat = `AF${format}_Format`;
                if (f.type === 'date') {
                    fnKeystroke += 'Ex';
                    params = String(f.param);
                } else if (f.type === 'time') params = String(f.param);
                else if (f.type === 'number') {
                    let p = Object.assign({}, $bb72e68028dbdf4a$var$FORMAT_DEFAULT.number, f);
                    params = String([
                        String(p.nDec),
                        p.sepComma ? '0' : '1',
                        '"' + p.negStyle + '"',
                        'null',
                        '"' + p.currency + '"',
                        String(p.currencyPrepend)
                    ].join(','));
                } else if (f.type === 'percent') {
                    let p = Object.assign({}, $bb72e68028dbdf4a$var$FORMAT_DEFAULT.percent, f);
                    params = String([
                        String(p.nDec),
                        p.sepComma ? '0' : '1'
                    ].join(','));
                }
            }
            opts.AA = opts.AA ? opts.AA : {};
            opts.AA.K = {
                S: 'JavaScript',
                JS: new String(`${fnKeystroke}(${params});`)
            };
            opts.AA.F = {
                S: 'JavaScript',
                JS: new String(`${fnFormat}(${params});`)
            };
        }
        delete opts.format;
        return opts;
    },
    _resolveColors (opts) {
        let color = this._normalizeColor(opts.backgroundColor);
        if (color) {
            if (!opts.MK) opts.MK = {};
            opts.MK.BG = color;
        }
        color = this._normalizeColor(opts.borderColor);
        if (color) {
            if (!opts.MK) opts.MK = {};
            opts.MK.BC = color;
        }
        delete opts.backgroundColor;
        delete opts.borderColor;
        return opts;
    },
    _resolveFlags (options) {
        let result = 0;
        Object.keys(options).forEach((key)=>{
            if ($bb72e68028dbdf4a$var$FIELD_FLAGS[key]) {
                if (options[key]) result |= $bb72e68028dbdf4a$var$FIELD_FLAGS[key];
                delete options[key];
            }
        });
        if (result !== 0) {
            options.Ff = options.Ff ? options.Ff : 0;
            options.Ff |= result;
        }
        return options;
    },
    _resolveJustify (options) {
        let result = 0;
        if (options.align !== undefined) {
            if (typeof $bb72e68028dbdf4a$var$FIELD_JUSTIFY[options.align] === 'number') result = $bb72e68028dbdf4a$var$FIELD_JUSTIFY[options.align];
            delete options.align;
        }
        if (result !== 0) options.Q = result;
        return options;
    },
    _resolveFont (options) {
        if (this._acroform.fonts[this._font.id] == null) this._acroform.fonts[this._font.id] = this._font.ref();
        if (this._acroform.defaultFont !== this._font.name) {
            options.DR = {
                Font: {}
            };
            const fontSize = options.fontSize || 0;
            options.DR.Font[this._font.id] = this._font.ref();
            options.DA = new String(`/${this._font.id} ${fontSize} Tf 0 g`);
        }
        return options;
    },
    _resolveStrings (options) {
        let select = [];
        function appendChoices(a) {
            if (Array.isArray(a)) {
                for(let idx = 0; idx < a.length; idx++)if (typeof a[idx] === 'string') select.push(new String(a[idx]));
                else select.push(a[idx]);
            }
        }
        appendChoices(options.Opt);
        if (options.select) {
            appendChoices(options.select);
            delete options.select;
        }
        if (select.length) options.Opt = select;
        Object.keys($bb72e68028dbdf4a$var$VALUE_MAP).forEach((key)=>{
            if (options[key] !== undefined) {
                options[$bb72e68028dbdf4a$var$VALUE_MAP[key]] = options[key];
                delete options[key];
            }
        });
        [
            'V',
            'DV'
        ].forEach((key)=>{
            if (typeof options[key] === 'string') options[key] = new String(options[key]);
        });
        if (options.MK && options.MK.CA) options.MK.CA = new String(options.MK.CA);
        if (options.label) {
            options.MK = options.MK ? options.MK : {};
            options.MK.CA = new String(options.label);
            delete options.label;
        }
        return options;
    }
};
var $bb72e68028dbdf4a$var$AttachmentsMixin = {
    file (src, options = {}) {
        options.name = options.name || src;
        options.relationship = options.relationship || 'Unspecified';
        const refBody = {
            Type: 'EmbeddedFile',
            Params: {}
        };
        let data;
        if (!src) throw new Error('No src specified');
        if ($bb72e68028dbdf4a$require$Buffer.isBuffer(src)) data = src;
        else if (src instanceof ArrayBuffer) data = $bb72e68028dbdf4a$require$Buffer.from(new Uint8Array(src));
        else {
            const match = /^data:(.*?);base64,(.*)$/.exec(src);
            if (match) {
                if (match[1]) refBody.Subtype = $bb72e68028dbdf4a$var$escapeName(match[1]);
                data = $bb72e68028dbdf4a$require$Buffer.from(match[2], 'base64');
            } else {
                data = (0, (/*@__PURE__*/$parcel$interopDefault($kjyEk))).readFileSync(src);
                if (!data) throw new Error(`Could not read contents of file at filepath ${src}`);
                const { birthtime: birthtime, ctime: ctime } = (0, (/*@__PURE__*/$parcel$interopDefault($kjyEk))).statSync(src);
                refBody.Params.CreationDate = birthtime;
                refBody.Params.ModDate = ctime;
            }
        }
        if (options.creationDate instanceof Date) refBody.Params.CreationDate = options.creationDate;
        if (options.modifiedDate instanceof Date) refBody.Params.ModDate = options.modifiedDate;
        if (options.type) refBody.Subtype = $bb72e68028dbdf4a$var$escapeName(options.type);
        const checksum = $bb72e68028dbdf4a$var$md5Hex(new Uint8Array(data));
        refBody.Params.CheckSum = new String(checksum);
        refBody.Params.Size = data.byteLength;
        let ref;
        if (!this._fileRegistry) this._fileRegistry = {};
        let file = this._fileRegistry[options.name];
        if (file && $bb72e68028dbdf4a$var$isEqual(refBody, file)) ref = file.ref;
        else {
            ref = this.ref(refBody);
            ref.end(data);
            this._fileRegistry[options.name] = {
                ...refBody,
                ref: ref
            };
        }
        const fileSpecBody = {
            Type: 'Filespec',
            AFRelationship: options.relationship,
            F: new String(options.name),
            EF: {
                F: ref
            },
            UF: new String(options.name)
        };
        if (options.description) fileSpecBody.Desc = new String(options.description);
        const filespec = this.ref(fileSpecBody);
        filespec.end();
        if (!options.hidden) this.addNamedEmbeddedFile(options.name, filespec);
        if (this._root.data.AF) this._root.data.AF.push(filespec);
        else this._root.data.AF = [
            filespec
        ];
        return filespec;
    }
};
function $bb72e68028dbdf4a$var$isEqual(a, b) {
    return a.Subtype === b.Subtype && a.Params.CheckSum.toString() === b.Params.CheckSum.toString() && a.Params.Size === b.Params.Size && a.Params.CreationDate.getTime() === b.Params.CreationDate.getTime() && (a.Params.ModDate === undefined && b.Params.ModDate === undefined || a.Params.ModDate.getTime() === b.Params.ModDate.getTime());
}
var $bb72e68028dbdf4a$var$PDFA = {
    initPDFA (pSubset) {
        if (pSubset.charAt(pSubset.length - 3) === '-') {
            this.subset_conformance = pSubset.charAt(pSubset.length - 1).toUpperCase();
            this.subset = parseInt(pSubset.charAt(pSubset.length - 2));
        } else {
            this.subset_conformance = 'B';
            this.subset = parseInt(pSubset.charAt(pSubset.length - 1));
        }
    },
    endSubset () {
        this._addPdfaMetadata();
        this._addColorOutputIntent();
    },
    _addColorOutputIntent () {
        const iccProfile = (0, (/*@__PURE__*/$parcel$interopDefault($kjyEk))).readFileSync(`${$bb72e68028dbdf4a$var$__dirname}/data/sRGB_IEC61966_2_1.icc`);
        const colorProfileRef = this.ref({
            Length: iccProfile.length,
            N: 3
        });
        colorProfileRef.write(iccProfile);
        colorProfileRef.end();
        const intentRef = this.ref({
            Type: 'OutputIntent',
            S: 'GTS_PDFA1',
            Info: new String('sRGB IEC61966-2.1'),
            OutputConditionIdentifier: new String('sRGB IEC61966-2.1'),
            DestOutputProfile: colorProfileRef
        });
        intentRef.end();
        this._root.data.OutputIntents = [
            intentRef
        ];
    },
    _getPdfaid () {
        return `
        <rdf:Description xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/" rdf:about="">
            <pdfaid:part>${this.subset}</pdfaid:part>
            <pdfaid:conformance>${this.subset_conformance}</pdfaid:conformance>
        </rdf:Description>
        `;
    },
    _addPdfaMetadata () {
        this.appendXML(this._getPdfaid());
    }
};
var $bb72e68028dbdf4a$var$PDFUA = {
    initPDFUA () {
        this.subset = 1;
    },
    endSubset () {
        this._addPdfuaMetadata();
    },
    _addPdfuaMetadata () {
        this.appendXML(this._getPdfuaid());
    },
    _getPdfuaid () {
        return `
        <rdf:Description xmlns:pdfuaid="http://www.aiim.org/pdfua/ns/id/" rdf:about="">
            <pdfuaid:part>${this.subset}</pdfuaid:part>
        </rdf:Description>
        `;
    }
};
var $bb72e68028dbdf4a$var$SubsetMixin = {
    _importSubset (subset) {
        Object.assign(this, subset);
    },
    initSubset (options) {
        switch(options.subset){
            case 'PDF/A-1':
            case 'PDF/A-1a':
            case 'PDF/A-1b':
            case 'PDF/A-2':
            case 'PDF/A-2a':
            case 'PDF/A-2b':
            case 'PDF/A-3':
            case 'PDF/A-3a':
            case 'PDF/A-3b':
                this._importSubset($bb72e68028dbdf4a$var$PDFA);
                this.initPDFA(options.subset);
                break;
            case 'PDF/UA':
                this._importSubset($bb72e68028dbdf4a$var$PDFUA);
                this.initPDFUA();
                break;
        }
    }
};
const $bb72e68028dbdf4a$var$ROW_FIELDS = [
    'height',
    'minHeight',
    'maxHeight'
];
const $bb72e68028dbdf4a$var$COLUMN_FIELDS = [
    'width',
    'minWidth',
    'maxWidth'
];
function $bb72e68028dbdf4a$var$memoize(fn, maxSize) {
    const cache = new Map();
    return function(...args) {
        const key = args[0];
        if (!cache.has(key)) {
            cache.set(key, fn(...args));
            if (cache.size > maxSize) cache.delete(cache.keys().next());
        }
        return cache.get(key);
    };
}
function $bb72e68028dbdf4a$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $bb72e68028dbdf4a$var$deepMerge(target, ...sources) {
    if (!$bb72e68028dbdf4a$var$isObject(target)) return target;
    target = $bb72e68028dbdf4a$var$deepClone(target);
    for (const source of sources){
        if ($bb72e68028dbdf4a$var$isObject(source)) for(const key in source){
            if ($bb72e68028dbdf4a$var$isObject(source[key])) {
                if (!(key in target)) target[key] = {};
                target[key] = $bb72e68028dbdf4a$var$deepMerge(target[key], source[key]);
            } else if (source[key] !== undefined) target[key] = $bb72e68028dbdf4a$var$deepClone(source[key]);
        }
    }
    return target;
}
function $bb72e68028dbdf4a$var$deepClone(obj) {
    let result = obj;
    if (obj && typeof obj == 'object') {
        result = Array.isArray(obj) ? [] : {};
        for(const key in obj)result[key] = $bb72e68028dbdf4a$var$deepClone(obj[key]);
    }
    return result;
}
function $bb72e68028dbdf4a$var$normalizedDefaultStyle(defaultStyleInternal) {
    let defaultStyle = defaultStyleInternal;
    if (typeof defaultStyle !== 'object') defaultStyle = {
        text: defaultStyle
    };
    const defaultRowStyle = Object.fromEntries(Object.entries(defaultStyle).filter(([k])=>$bb72e68028dbdf4a$var$ROW_FIELDS.includes(k)));
    const defaultColStyle = Object.fromEntries(Object.entries(defaultStyle).filter(([k])=>$bb72e68028dbdf4a$var$COLUMN_FIELDS.includes(k)));
    defaultStyle.padding = $bb72e68028dbdf4a$var$normalizeSides(defaultStyle.padding);
    defaultStyle.border = $bb72e68028dbdf4a$var$normalizeSides(defaultStyle.border);
    defaultStyle.borderColor = $bb72e68028dbdf4a$var$normalizeSides(defaultStyle.borderColor);
    defaultStyle.align = $bb72e68028dbdf4a$var$normalizeAlignment(defaultStyle.align);
    return {
        defaultStyle: defaultStyle,
        defaultRowStyle: defaultRowStyle,
        defaultColStyle: defaultColStyle
    };
}
function $bb72e68028dbdf4a$var$normalizedRowStyle(defaultRowStyle, rowStyleInternal, i) {
    let rowStyle = rowStyleInternal(i);
    if (rowStyle == null || typeof rowStyle !== 'object') rowStyle = {
        height: rowStyle
    };
    rowStyle.padding = $bb72e68028dbdf4a$var$normalizeSides(rowStyle.padding);
    rowStyle.border = $bb72e68028dbdf4a$var$normalizeSides(rowStyle.border);
    rowStyle.borderColor = $bb72e68028dbdf4a$var$normalizeSides(rowStyle.borderColor);
    rowStyle.align = $bb72e68028dbdf4a$var$normalizeAlignment(rowStyle.align);
    rowStyle = $bb72e68028dbdf4a$var$deepMerge(defaultRowStyle, rowStyle);
    const document = this.document;
    const page = document.page;
    const contentHeight = page.contentHeight;
    if (rowStyle.height == null || rowStyle.height === 'auto') rowStyle.height = 'auto';
    else rowStyle.height = document.sizeToPoint(rowStyle.height, 0, page, contentHeight);
    rowStyle.minHeight = document.sizeToPoint(rowStyle.minHeight, 0, page, contentHeight);
    rowStyle.maxHeight = document.sizeToPoint(rowStyle.maxHeight, 0, page, contentHeight);
    return rowStyle;
}
function $bb72e68028dbdf4a$var$normalizedColumnStyle(defaultColStyle, colStyleInternal, i) {
    let colStyle = colStyleInternal(i);
    if (colStyle == null || typeof colStyle !== 'object') colStyle = {
        width: colStyle
    };
    colStyle.padding = $bb72e68028dbdf4a$var$normalizeSides(colStyle.padding);
    colStyle.border = $bb72e68028dbdf4a$var$normalizeSides(colStyle.border);
    colStyle.borderColor = $bb72e68028dbdf4a$var$normalizeSides(colStyle.borderColor);
    colStyle.align = $bb72e68028dbdf4a$var$normalizeAlignment(colStyle.align);
    colStyle = $bb72e68028dbdf4a$var$deepMerge(defaultColStyle, colStyle);
    if (colStyle.width == null || colStyle.width === '*') colStyle.width = '*';
    else colStyle.width = this.document.sizeToPoint(colStyle.width, 0, this.document.page, this._maxWidth);
    colStyle.minWidth = this.document.sizeToPoint(colStyle.minWidth, 0, this.document.page, this._maxWidth);
    colStyle.maxWidth = this.document.sizeToPoint(colStyle.maxWidth, 0, this.document.page, this._maxWidth);
    return colStyle;
}
function $bb72e68028dbdf4a$var$normalizeAlignment(align) {
    return align == null || typeof align === 'string' ? {
        x: align,
        y: align
    } : align;
}
function $bb72e68028dbdf4a$var$normalizeTable() {
    const doc = this.document;
    const opts = this.opts;
    let index = doc._tableIndex++;
    this._id = new String(opts.id ?? `table-${index}`);
    this._position = {
        x: doc.sizeToPoint(opts.position?.x, doc.x),
        y: doc.sizeToPoint(opts.position?.y, doc.y)
    };
    this._maxWidth = doc.sizeToPoint(opts.maxWidth, doc.page.width - doc.page.margins.right - this._position.x);
    const { defaultStyle: defaultStyle, defaultColStyle: defaultColStyle, defaultRowStyle: defaultRowStyle } = $bb72e68028dbdf4a$var$normalizedDefaultStyle(opts.defaultStyle);
    this._defaultStyle = defaultStyle;
    let colStyle;
    if (opts.columnStyles) {
        if (Array.isArray(opts.columnStyles)) colStyle = (i)=>opts.columnStyles[i];
        else if (typeof opts.columnStyles === 'function') colStyle = $bb72e68028dbdf4a$var$memoize((i)=>opts.columnStyles(i), Infinity);
        else if (typeof opts.columnStyles === 'object') colStyle = ()=>opts.columnStyles;
    }
    if (!colStyle) colStyle = ()=>({});
    this._colStyle = $bb72e68028dbdf4a$var$normalizedColumnStyle.bind(this, defaultColStyle, colStyle);
    let rowStyle;
    if (opts.rowStyles) {
        if (Array.isArray(opts.rowStyles)) rowStyle = (i)=>opts.rowStyles[i];
        else if (typeof opts.rowStyles === 'function') rowStyle = $bb72e68028dbdf4a$var$memoize((i)=>opts.rowStyles(i), 10);
        else if (typeof opts.rowStyles === 'object') rowStyle = ()=>opts.rowStyles;
    }
    if (!rowStyle) rowStyle = ()=>({});
    this._rowStyle = $bb72e68028dbdf4a$var$normalizedRowStyle.bind(this, defaultRowStyle, rowStyle);
}
function $bb72e68028dbdf4a$var$normalizeText(text) {
    if (text != null) text = `${text}`;
    return text;
}
function $bb72e68028dbdf4a$var$normalizeCell(cell, rowIndex, colIndex) {
    const colStyle = this._colStyle(colIndex);
    let rowStyle = this._rowStyle(rowIndex);
    const font = $bb72e68028dbdf4a$var$deepMerge({}, colStyle.font, rowStyle.font, cell.font);
    const customFont = Object.values(font).filter((v)=>v != null).length > 0;
    const doc = this.document;
    const rollbackFont = doc._fontSource;
    const rollbackFontSize = doc._fontSize;
    const rollbackFontFamily = doc._fontFamily;
    if (customFont) {
        if (font.src) doc.font(font.src, font.family);
        if (font.size) doc.fontSize(font.size);
        rowStyle = this._rowStyle(rowIndex);
    }
    cell.padding = $bb72e68028dbdf4a$var$normalizeSides(cell.padding);
    cell.border = $bb72e68028dbdf4a$var$normalizeSides(cell.border);
    cell.borderColor = $bb72e68028dbdf4a$var$normalizeSides(cell.borderColor);
    const config = $bb72e68028dbdf4a$var$deepMerge(this._defaultStyle, colStyle, rowStyle, cell);
    config.rowIndex = rowIndex;
    config.colIndex = colIndex;
    config.font = font ?? {};
    config.customFont = customFont;
    config.text = $bb72e68028dbdf4a$var$normalizeText(config.text);
    config.rowSpan = config.rowSpan ?? 1;
    config.colSpan = config.colSpan ?? 1;
    config.padding = $bb72e68028dbdf4a$var$normalizeSides(config.padding, '0.25em', (x)=>doc.sizeToPoint(x, '0.25em'));
    config.border = $bb72e68028dbdf4a$var$normalizeSides(config.border, 1, (x)=>doc.sizeToPoint(x, 1));
    config.borderColor = $bb72e68028dbdf4a$var$normalizeSides(config.borderColor, 'black', (x)=>x ?? 'black');
    config.align = $bb72e68028dbdf4a$var$normalizeAlignment(config.align);
    config.align.x = config.align.x ?? 'left';
    config.align.y = config.align.y ?? 'top';
    config.textStroke = doc.sizeToPoint(config.textStroke, 0);
    config.textStrokeColor = config.textStrokeColor ?? 'black';
    config.textColor = config.textColor ?? 'black';
    config.textOptions = config.textOptions ?? {};
    config.id = new String(config.id ?? `${this._id}-${rowIndex}-${colIndex}`);
    config.type = config.type?.toUpperCase() === 'TH' ? 'TH' : 'TD';
    if (config.scope) {
        config.scope = config.scope.toLowerCase();
        if (config.scope === 'row') config.scope = 'Row';
        else if (config.scope === 'both') config.scope = 'Both';
        else if (config.scope === 'column') config.scope = 'Column';
    }
    if (typeof this.opts.debug === 'boolean') config.debug = this.opts.debug;
    if (customFont) doc.font(rollbackFont, rollbackFontFamily, rollbackFontSize);
    return config;
}
function $bb72e68028dbdf4a$var$normalizeRow(row, rowIndex) {
    if (!this._cellClaim) this._cellClaim = new Set();
    let colIndex = 0;
    return row.map((cell)=>{
        if (cell == null || typeof cell !== 'object') cell = {
            text: cell
        };
        while(this._cellClaim.has(`${rowIndex},${colIndex}`))colIndex++;
        cell = $bb72e68028dbdf4a$var$normalizeCell.call(this, cell, rowIndex, colIndex);
        for(let i = 0; i < cell.rowSpan; i++)for(let j = 0; j < cell.colSpan; j++)this._cellClaim.add(`${rowIndex + i},${colIndex + j}`);
        colIndex += cell.colSpan;
        return cell;
    });
}
function $bb72e68028dbdf4a$var$ensure(row) {
    this._columnWidths = [];
    $bb72e68028dbdf4a$var$ensureColumnWidths.call(this, row.reduce((a, cell)=>a + cell.colSpan, 0));
    this._rowHeights = [];
    this._rowYPos = [
        this._position.y
    ];
    this._rowBuffer = new Set();
}
function $bb72e68028dbdf4a$var$ensureColumnWidths(numCols) {
    let starColumnIndexes = [];
    let starMinAcc = 0;
    let unclaimedWidth = this._maxWidth;
    for(let i = 0; i < numCols; i++){
        let col = this._colStyle(i);
        if (col.width === '*') {
            starColumnIndexes[i] = col;
            starMinAcc += col.minWidth;
        } else {
            unclaimedWidth -= col.width;
            this._columnWidths[i] = col.width;
        }
    }
    let starColCount = starColumnIndexes.reduce((x)=>x + 1, 0);
    if (starMinAcc >= unclaimedWidth) starColumnIndexes.forEach((cell, i)=>{
        this._columnWidths[i] = cell.minWidth;
    });
    else if (starColCount > 0) starColumnIndexes.forEach((col, i)=>{
        let starSize = unclaimedWidth / starColCount;
        this._columnWidths[i] = Math.max(starSize, col.minWidth);
        if (col.maxWidth > 0) this._columnWidths[i] = Math.min(this._columnWidths[i], col.maxWidth);
        unclaimedWidth -= this._columnWidths[i];
        starColCount--;
    });
    let tempX = this._position.x;
    this._columnXPos = Array.from(this._columnWidths, (v)=>{
        const t = tempX;
        tempX += v;
        return t;
    });
}
function $bb72e68028dbdf4a$var$measure(row, rowIndex) {
    row.forEach((cell)=>this._rowBuffer.add(cell));
    if (rowIndex > 0) this._rowYPos[rowIndex] = this._rowYPos[rowIndex - 1] + this._rowHeights[rowIndex - 1];
    const rowStyle = this._rowStyle(rowIndex);
    let toRender = [];
    this._rowBuffer.forEach((cell)=>{
        if (cell.rowIndex + cell.rowSpan - 1 === rowIndex) {
            toRender.push($bb72e68028dbdf4a$var$measureCell.call(this, cell, rowStyle.height));
            this._rowBuffer.delete(cell);
        }
    });
    let rowHeight = rowStyle.height;
    if (rowHeight === 'auto') rowHeight = toRender.reduce((acc, cell)=>{
        let minHeight = cell.textBounds.height + cell.padding.top + cell.padding.bottom;
        for(let i = 0; i < cell.rowSpan - 1; i++)minHeight -= this._rowHeights[cell.rowIndex + i];
        return Math.max(acc, minHeight);
    }, 0);
    rowHeight = Math.max(rowHeight, rowStyle.minHeight);
    if (rowStyle.maxHeight > 0) rowHeight = Math.min(rowHeight, rowStyle.maxHeight);
    this._rowHeights[rowIndex] = rowHeight;
    let newPage = false;
    if (rowHeight > this.document.page.contentHeight) {
        console.warn(new Error(`Row ${rowIndex} requested more than the safe page height, row has been clamped`).stack.slice(7));
        this._rowHeights[rowIndex] = this.document.page.maxY() - this._rowYPos[rowIndex];
    } else if (this._rowYPos[rowIndex] + rowHeight >= this.document.page.maxY()) {
        this._rowYPos[rowIndex] = this.document.page.margins.top;
        newPage = true;
    }
    return {
        newPage: newPage,
        toRender: toRender.map((cell)=>$bb72e68028dbdf4a$var$measureCell.call(this, cell, rowHeight))
    };
}
function $bb72e68028dbdf4a$var$measureCell(cell, rowHeight) {
    let cellWidth = 0;
    for(let i = 0; i < cell.colSpan; i++)cellWidth += this._columnWidths[cell.colIndex + i];
    let cellHeight = rowHeight;
    if (cellHeight === 'auto') cellHeight = this.document.page.contentHeight;
    else for(let i = 0; i < cell.rowSpan - 1; i++)cellHeight += this._rowHeights[cell.rowIndex + i];
    const textAllocatedWidth = cellWidth - cell.padding.left - cell.padding.right;
    const textAllocatedHeight = cellHeight - cell.padding.top - cell.padding.bottom;
    const rotation = cell.textOptions.rotation ?? 0;
    const { width: textMaxWidth, height: textMaxHeight } = $bb72e68028dbdf4a$var$computeBounds(rotation, textAllocatedWidth, textAllocatedHeight);
    const textOptions = {
        align: cell.align.x,
        ellipsis: true,
        stroke: cell.textStroke > 0,
        fill: true,
        width: textMaxWidth,
        height: textMaxHeight,
        rotation: rotation,
        ...cell.textOptions
    };
    let textBounds = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    if (cell.text) {
        const rollbackFont = this.document._fontSource;
        const rollbackFontSize = this.document._fontSize;
        const rollbackFontFamily = this.document._fontFamily;
        if (cell.font?.src) this.document.font(cell.font.src, cell.font?.family);
        if (cell.font?.size) this.document.fontSize(cell.font.size);
        const unRotatedTextBounds = this.document.boundsOfString(cell.text, 0, 0, {
            ...textOptions,
            rotation: 0
        });
        textOptions.width = unRotatedTextBounds.width;
        textOptions.height = unRotatedTextBounds.height;
        textBounds = this.document.boundsOfString(cell.text, 0, 0, textOptions);
        this.document.font(rollbackFont, rollbackFontFamily, rollbackFontSize);
    }
    return {
        ...cell,
        textOptions: textOptions,
        x: this._columnXPos[cell.colIndex],
        y: this._rowYPos[cell.rowIndex],
        textX: this._columnXPos[cell.colIndex] + cell.padding.left,
        textY: this._rowYPos[cell.rowIndex] + cell.padding.top,
        width: cellWidth,
        height: cellHeight,
        textAllocatedHeight: textAllocatedHeight,
        textAllocatedWidth: textAllocatedWidth,
        textBounds: textBounds
    };
}
function $bb72e68028dbdf4a$var$computeBounds(rotation, allocWidth, allocHeight) {
    let textMaxWidth, textMaxHeight;
    const cos = $bb72e68028dbdf4a$var$cosine(rotation);
    const sin = $bb72e68028dbdf4a$var$sine(rotation);
    if (rotation === 0 || rotation === 180) {
        textMaxWidth = allocWidth;
        textMaxHeight = allocHeight;
    } else if (rotation === 90 || rotation === 270) {
        textMaxWidth = allocHeight;
        textMaxHeight = allocWidth;
    } else if (rotation < 90 || rotation > 180 && rotation < 270) {
        textMaxWidth = allocWidth / (2 * cos);
        textMaxHeight = allocWidth / (2 * sin);
    } else {
        textMaxHeight = allocWidth / (2 * cos);
        textMaxWidth = allocWidth / (2 * sin);
    }
    const EF = sin * textMaxWidth;
    const FG = cos * textMaxHeight;
    if (EF + FG > allocHeight) {
        const denominator = cos * cos - sin * sin;
        if (rotation === 0 || rotation === 180) {
            textMaxWidth = allocWidth;
            textMaxHeight = allocHeight;
        } else if (rotation === 90 || rotation === 270) {
            textMaxWidth = allocHeight;
            textMaxHeight = allocWidth;
        } else if (rotation < 90 || rotation > 180 && rotation < 270) {
            textMaxWidth = (allocWidth * cos - allocHeight * sin) / denominator;
            textMaxHeight = (allocHeight * cos - allocWidth * sin) / denominator;
        } else {
            textMaxHeight = (allocWidth * cos - allocHeight * sin) / denominator;
            textMaxWidth = (allocHeight * cos - allocWidth * sin) / denominator;
        }
    }
    return {
        width: Math.abs(textMaxWidth),
        height: Math.abs(textMaxHeight)
    };
}
function $bb72e68028dbdf4a$var$accommodateTable() {
    const structParent = this.opts.structParent;
    if (structParent) {
        this._tableStruct = this.document.struct('Table');
        this._tableStruct.dictionary.data.ID = this._id;
        if (structParent instanceof $bb72e68028dbdf4a$var$PDFStructureElement) structParent.add(this._tableStruct);
        else if (structParent instanceof $bb72e68028dbdf4a$export$2e2bcd8739ae039) structParent.addStructure(this._tableStruct);
        this._headerRowLookup = {};
        this._headerColumnLookup = {};
    }
}
function $bb72e68028dbdf4a$var$accommodateCleanup() {
    if (this._tableStruct) this._tableStruct.end();
}
function $bb72e68028dbdf4a$var$accessibleRow(row, rowIndex, renderCell) {
    const rowStruct = this.document.struct('TR');
    rowStruct.dictionary.data.ID = new String(`${this._id}-${rowIndex}`);
    this._tableStruct.add(rowStruct);
    row.forEach((cell)=>renderCell(cell, rowStruct));
    rowStruct.end();
}
function $bb72e68028dbdf4a$var$accessibleCell(cell, rowStruct, callback) {
    const doc = this.document;
    const cellStruct = doc.struct(cell.type, {
        title: cell.title
    });
    cellStruct.dictionary.data.ID = cell.id;
    rowStruct.add(cellStruct);
    const padding = cell.padding;
    const border = cell.border;
    const attributes = {
        O: 'Table',
        Width: cell.width,
        Height: cell.height,
        Padding: [
            padding.top,
            padding.bottom,
            padding.left,
            padding.right
        ],
        RowSpan: cell.rowSpan > 1 ? cell.rowSpan : undefined,
        ColSpan: cell.colSpan > 1 ? cell.colSpan : undefined,
        BorderThickness: [
            border.top,
            border.bottom,
            border.left,
            border.right
        ]
    };
    if (cell.type === 'TH') {
        if (cell.scope === 'Row' || cell.scope === 'Both') {
            for(let i = 0; i < cell.rowSpan; i++){
                if (!this._headerRowLookup[cell.rowIndex + i]) this._headerRowLookup[cell.rowIndex + i] = [];
                this._headerRowLookup[cell.rowIndex + i].push(cell.id);
            }
            attributes.Scope = cell.scope;
        }
        if (cell.scope === 'Column' || cell.scope === 'Both') {
            for(let i = 0; i < cell.colSpan; i++){
                if (!this._headerColumnLookup[cell.colIndex + i]) this._headerColumnLookup[cell.colIndex + i] = [];
                this._headerColumnLookup[cell.colIndex + i].push(cell.id);
            }
            attributes.Scope = cell.scope;
        }
    }
    const Headers = new Set([
        ...Array.from({
            length: cell.colSpan
        }, (_, i)=>this._headerColumnLookup[cell.colIndex + i]).flat(),
        ...Array.from({
            length: cell.rowSpan
        }, (_, i)=>this._headerRowLookup[cell.rowIndex + i]).flat()
    ].filter(Boolean));
    if (Headers.size) attributes.Headers = Array.from(Headers);
    const normalizeColor = doc._normalizeColor;
    if (cell.backgroundColor != null) attributes.BackgroundColor = normalizeColor(cell.backgroundColor);
    const hasBorder = [
        border.top,
        border.bottom,
        border.left,
        border.right
    ];
    if (hasBorder.some((x)=>x)) {
        const borderColor = cell.borderColor;
        attributes.BorderColor = [
            hasBorder[0] ? normalizeColor(borderColor.top) : null,
            hasBorder[1] ? normalizeColor(borderColor.bottom) : null,
            hasBorder[2] ? normalizeColor(borderColor.left) : null,
            hasBorder[3] ? normalizeColor(borderColor.right) : null
        ];
    }
    Object.keys(attributes).forEach((key)=>attributes[key] === undefined && delete attributes[key]);
    cellStruct.dictionary.data.A = doc.ref(attributes);
    cellStruct.add(callback);
    cellStruct.end();
    cellStruct.dictionary.data.A.end();
}
function $bb72e68028dbdf4a$var$renderRow(row, rowIndex) {
    if (this._tableStruct) $bb72e68028dbdf4a$var$accessibleRow.call(this, row, rowIndex, $bb72e68028dbdf4a$var$renderCell.bind(this));
    else row.forEach((cell)=>$bb72e68028dbdf4a$var$renderCell.call(this, cell));
    return this._rowYPos[rowIndex] + this._rowHeights[rowIndex];
}
function $bb72e68028dbdf4a$var$renderCell(cell, rowStruct) {
    const cellRenderer = ()=>{
        if (cell.backgroundColor != null) this.document.save().fillColor(cell.backgroundColor).rect(cell.x, cell.y, cell.width, cell.height).fill().restore();
        $bb72e68028dbdf4a$var$renderBorder.call(this, cell.border, cell.borderColor, cell.x, cell.y, cell.width, cell.height);
        if (cell.debug) {
            this.document.save();
            this.document.dash(1, {
                space: 1
            }).lineWidth(1).strokeOpacity(0.3);
            this.document.rect(cell.x, cell.y, cell.width, cell.height).stroke('green');
            this.document.restore();
        }
        if (cell.text) $bb72e68028dbdf4a$var$renderCellText.call(this, cell);
    };
    if (rowStruct) $bb72e68028dbdf4a$var$accessibleCell.call(this, cell, rowStruct, cellRenderer);
    else cellRenderer();
}
function $bb72e68028dbdf4a$var$renderCellText(cell) {
    const doc = this.document;
    const rollbackFont = doc._fontSource;
    const rollbackFontSize = doc._fontSize;
    const rollbackFontFamily = doc._fontFamily;
    if (cell.customFont) {
        if (cell.font.src) doc.font(cell.font.src, cell.font.family);
        if (cell.font.size) doc.fontSize(cell.font.size);
    }
    const x = cell.textX;
    const y = cell.textY;
    const Ah = cell.textAllocatedHeight;
    const Aw = cell.textAllocatedWidth;
    const Cw = cell.textBounds.width;
    const Ch = cell.textBounds.height;
    const Ox = -cell.textBounds.x;
    const Oy = -cell.textBounds.y;
    const PxScale = cell.align.x === 'right' ? 1 : cell.align.x === 'center' ? 0.5 : 0;
    const Px = (Aw - Cw) * PxScale;
    const PyScale = cell.align.y === 'bottom' ? 1 : cell.align.y === 'center' ? 0.5 : 0;
    const Py = (Ah - Ch) * PyScale;
    const dx = Px + Ox;
    const dy = Py + Oy;
    if (cell.debug) {
        doc.save();
        doc.dash(1, {
            space: 1
        }).lineWidth(1).strokeOpacity(0.3);
        if (cell.text) doc.moveTo(x + Px, y).lineTo(x + Px, y + Ah).moveTo(x + Px + Cw, y).lineTo(x + Px + Cw, y + Ah).stroke('blue').moveTo(x, y + Py).lineTo(x + Aw, y + Py).moveTo(x, y + Py + Ch).lineTo(x + Aw, y + Py + Ch).stroke('green');
        doc.rect(x, y, Aw, Ah).stroke('orange');
        doc.restore();
    }
    doc.save().rect(x, y, Aw, Ah).clip();
    doc.fillColor(cell.textColor).strokeColor(cell.textStrokeColor);
    if (cell.textStroke > 0) doc.lineWidth(cell.textStroke);
    doc.text(cell.text, x + dx, y + dy, cell.textOptions);
    doc.restore();
    if (cell.font) doc.font(rollbackFont, rollbackFontFamily, rollbackFontSize);
}
function $bb72e68028dbdf4a$var$renderBorder(border, borderColor, x, y, width, height, mask) {
    border = Object.fromEntries(Object.entries(border).map(([k, v])=>[
            k,
            mask && !mask[k] ? 0 : v
        ]));
    const doc = this.document;
    if ([
        border.right,
        border.bottom,
        border.left
    ].every((val)=>val === border.top)) {
        if (border.top > 0) doc.save().lineWidth(border.top).strokeColor(borderColor.top).rect(x, y, width, height).stroke().restore();
    } else {
        if (border.top > 0) doc.save().lineWidth(border.top).moveTo(x, y).strokeColor(borderColor.top).lineTo(x + width, y).stroke().restore();
        if (border.right > 0) doc.save().lineWidth(border.right).moveTo(x + width, y).strokeColor(borderColor.right).lineTo(x + width, y + height).stroke().restore();
        if (border.bottom > 0) doc.save().lineWidth(border.bottom).moveTo(x + width, y + height).strokeColor(borderColor.bottom).lineTo(x, y + height).stroke().restore();
        if (border.left > 0) doc.save().lineWidth(border.left).moveTo(x, y + height).strokeColor(borderColor.left).lineTo(x, y).stroke().restore();
    }
}
class $bb72e68028dbdf4a$var$PDFTable {
    constructor(document, opts = {}){
        this.document = document;
        this.opts = Object.freeze(opts);
        $bb72e68028dbdf4a$var$normalizeTable.call(this);
        $bb72e68028dbdf4a$var$accommodateTable.call(this);
        this._currRowIndex = 0;
        this._ended = false;
        if (opts.data) {
            for (const row of opts.data)this.row(row);
            return this.end();
        }
    }
    row(row, lastRow = false) {
        if (this._ended) throw new Error(`Table was marked as ended on row ${this._currRowIndex}`);
        row = Array.from(row);
        row = $bb72e68028dbdf4a$var$normalizeRow.call(this, row, this._currRowIndex);
        if (this._currRowIndex === 0) $bb72e68028dbdf4a$var$ensure.call(this, row);
        const { newPage: newPage, toRender: toRender } = $bb72e68028dbdf4a$var$measure.call(this, row, this._currRowIndex);
        if (newPage) this.document.continueOnNewPage();
        const yPos = $bb72e68028dbdf4a$var$renderRow.call(this, toRender, this._currRowIndex);
        this.document.x = this._position.x;
        this.document.y = yPos;
        if (lastRow) return this.end();
        this._currRowIndex++;
        return this;
    }
    end() {
        while(this._rowBuffer?.size)this.row([]);
        this._ended = true;
        $bb72e68028dbdf4a$var$accommodateCleanup.call(this);
        return this.document;
    }
}
var $bb72e68028dbdf4a$var$TableMixin = {
    initTables () {
        this._tableIndex = 0;
    },
    table (opts) {
        return new $bb72e68028dbdf4a$var$PDFTable(this, opts);
    }
};
class $bb72e68028dbdf4a$var$PDFMetadata {
    constructor(){
        this._metadata = `
        <?xpacket begin="\ufeff" id="W5M0MpCehiHzreSzNTczkc9d"?>
            <x:xmpmeta xmlns:x="adobe:ns:meta/">
                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
        `;
    }
    _closeTags() {
        this._metadata = this._metadata.concat(`
                </rdf:RDF>
            </x:xmpmeta>
        <?xpacket end="w"?>
        `);
    }
    append(xml, newline = true) {
        this._metadata = this._metadata.concat(xml);
        if (newline) this._metadata = this._metadata.concat('\n');
    }
    getXML() {
        return this._metadata;
    }
    getLength() {
        return this._metadata.length;
    }
    end() {
        this._closeTags();
        this._metadata = this._metadata.trim();
    }
}
var $bb72e68028dbdf4a$var$MetadataMixin = {
    initMetadata () {
        this.metadata = new $bb72e68028dbdf4a$var$PDFMetadata();
    },
    appendXML (xml, newline = true) {
        this.metadata.append(xml, newline);
    },
    _addInfo () {
        this.appendXML(`
        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreateDate>${this.info.CreationDate.toISOString().split('.')[0] + 'Z'}</xmp:CreateDate>
            <xmp:CreatorTool>${this.info.Creator}</xmp:CreatorTool>
        </rdf:Description>
        `);
        if (this.info.Title || this.info.Author || this.info.Subject) {
            this.appendXML(`
            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">
            `);
            if (this.info.Title) this.appendXML(`
                <dc:title>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Title}</rdf:li>
                    </rdf:Alt>
                </dc:title>
                `);
            if (this.info.Author) this.appendXML(`
                <dc:creator>
                    <rdf:Seq>
                        <rdf:li>${this.info.Author}</rdf:li>
                    </rdf:Seq>
                </dc:creator>
                `);
            if (this.info.Subject) this.appendXML(`
                <dc:description>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Subject}</rdf:li>
                    </rdf:Alt>
                </dc:description>
                `);
            this.appendXML(`
            </rdf:Description>
            `);
        }
        this.appendXML(`
        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>${this.info.Producer}</pdf:Producer>`, false);
        if (this.info.Keywords) this.appendXML(`
            <pdf:Keywords>${this.info.Keywords}</pdf:Keywords>`, false);
        this.appendXML(`
        </rdf:Description>
        `);
    },
    endMetadata () {
        this._addInfo();
        this.metadata.end();
        if (this.version != 1.3) {
            this.metadataRef = this.ref({
                length: this.metadata.getLength(),
                Type: 'Metadata',
                Subtype: 'XML'
            });
            this.metadataRef.compress = false;
            this.metadataRef.write($bb72e68028dbdf4a$require$Buffer.from(this.metadata.getXML(), 'utf-8'));
            this.metadataRef.end();
            this._root.data.Metadata = this.metadataRef;
        }
    }
};
class $bb72e68028dbdf4a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($ioRHp))).Readable {
    constructor(options = {}){
        super(options);
        this.options = options;
        switch(options.pdfVersion){
            case '1.4':
                this.version = 1.4;
                break;
            case '1.5':
                this.version = 1.5;
                break;
            case '1.6':
                this.version = 1.6;
                break;
            case '1.7':
            case '1.7ext3':
                this.version = 1.7;
                break;
            default:
                this.version = 1.3;
                break;
        }
        this.compress = this.options.compress != null ? this.options.compress : true;
        this._pageBuffer = [];
        this._pageBufferStart = 0;
        this._offsets = [];
        this._waiting = 0;
        this._ended = false;
        this._offset = 0;
        const Pages = this.ref({
            Type: 'Pages',
            Count: 0,
            Kids: []
        });
        const Names = this.ref({
            Dests: new $bb72e68028dbdf4a$var$PDFNameTree()
        });
        this._root = this.ref({
            Type: 'Catalog',
            Pages: Pages,
            Names: Names
        });
        if (this.options.lang) this._root.data.Lang = new String(this.options.lang);
        if (this.options.pageLayout) {
            const layout = this.options.pageLayout;
            this._root.data.PageLayout = layout.charAt(0).toUpperCase() + layout.slice(1);
        }
        this.page = null;
        this.initMetadata();
        this.initColor();
        this.initVector();
        this.initFonts(options.font);
        this.initText();
        this.initImages();
        this.initOutline();
        this.initMarkings(options);
        this.initTables();
        this.initSubset(options);
        this.info = {
            Producer: 'PDFKit',
            Creator: 'PDFKit',
            CreationDate: new Date()
        };
        if (this.options.info) for(let key in this.options.info){
            const val = this.options.info[key];
            this.info[key] = val;
        }
        if (this.options.displayTitle) this._root.data.ViewerPreferences = this.ref({
            DisplayDocTitle: true
        });
        this._id = $bb72e68028dbdf4a$var$PDFSecurity.generateFileID(this.info);
        this._security = $bb72e68028dbdf4a$var$PDFSecurity.create(this, options);
        this._write(`%PDF-${this.version}`);
        this._write('%\xFF\xFF\xFF\xFF');
        if (this.options.autoFirstPage !== false) this.addPage();
    }
    addPage(options) {
        if (options == null) ({ options: options } = this);
        if (!this.options.bufferPages) this.flushPages();
        this.page = new $bb72e68028dbdf4a$var$PDFPage(this, options);
        this._pageBuffer.push(this.page);
        const pages = this._root.data.Pages.data;
        pages.Kids.push(this.page.dictionary);
        pages.Count++;
        this.x = this.page.margins.left;
        this.y = this.page.margins.top;
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        this.transform(1, 0, 0, -1, 0, this.page.height);
        this.emit('pageAdded');
        return this;
    }
    continueOnNewPage(options) {
        const pageMarkings = this.endPageMarkings(this.page);
        this.addPage(options ?? this.page._options);
        this.initPageMarkings(pageMarkings);
        return this;
    }
    bufferedPageRange() {
        return {
            start: this._pageBufferStart,
            count: this._pageBuffer.length
        };
    }
    switchToPage(n) {
        let page;
        if (!(page = this._pageBuffer[n - this._pageBufferStart])) throw new Error(`switchToPage(${n}) out of bounds, current buffer covers pages ${this._pageBufferStart} to ${this._pageBufferStart + this._pageBuffer.length - 1}`);
        return this.page = page;
    }
    flushPages() {
        const pages = this._pageBuffer;
        this._pageBuffer = [];
        this._pageBufferStart += pages.length;
        for (let page of pages){
            this.endPageMarkings(page);
            page.end();
        }
    }
    addNamedDestination(name, ...args) {
        if (args.length === 0) args = [
            'XYZ',
            null,
            null,
            null
        ];
        if (args[0] === 'XYZ' && args[2] !== null) args[2] = this.page.height - args[2];
        args.unshift(this.page.dictionary);
        this._root.data.Names.data.Dests.add(name, args);
    }
    addNamedEmbeddedFile(name, ref) {
        if (!this._root.data.Names.data.EmbeddedFiles) this._root.data.Names.data.EmbeddedFiles = new $bb72e68028dbdf4a$var$PDFNameTree({
            limits: false
        });
        this._root.data.Names.data.EmbeddedFiles.add(name, ref);
    }
    addNamedJavaScript(name, js) {
        if (!this._root.data.Names.data.JavaScript) this._root.data.Names.data.JavaScript = new $bb72e68028dbdf4a$var$PDFNameTree();
        let data = {
            JS: new String(js),
            S: 'JavaScript'
        };
        this._root.data.Names.data.JavaScript.add(name, data);
    }
    ref(data) {
        const ref = new $bb72e68028dbdf4a$var$PDFReference(this, this._offsets.length + 1, data);
        this._offsets.push(null);
        this._waiting++;
        return ref;
    }
    _read() {}
    _write(data) {
        if (!$bb72e68028dbdf4a$require$Buffer.isBuffer(data)) data = $bb72e68028dbdf4a$require$Buffer.from(data + '\n', 'binary');
        this.push(data);
        this._offset += data.length;
    }
    addContent(data) {
        this.page.write(data);
        return this;
    }
    _refEnd(ref) {
        this._offsets[ref.id - 1] = ref.offset;
        if (--this._waiting === 0 && this._ended) {
            this._finalize();
            this._ended = false;
        }
    }
    end() {
        this.flushPages();
        this._info = this.ref();
        for(let key in this.info){
            let val = this.info[key];
            if (typeof val === 'string') val = new String(val);
            let entry = this.ref(val);
            entry.end();
            this._info.data[key] = entry;
        }
        this._info.end();
        for(let name in this._fontFamilies){
            const font = this._fontFamilies[name];
            font.finalize();
        }
        this.endOutline();
        this.endMarkings();
        if (this.subset) this.endSubset();
        this.endMetadata();
        this._root.end();
        this._root.data.Pages.end();
        this._root.data.Names.end();
        this.endAcroForm();
        if (this._root.data.ViewerPreferences) this._root.data.ViewerPreferences.end();
        if (this._security) this._security.end();
        if (this._waiting === 0) this._finalize();
        else this._ended = true;
    }
    _finalize() {
        const xRefOffset = this._offset;
        this._write('xref');
        this._write(`0 ${this._offsets.length + 1}`);
        this._write('0000000000 65535 f ');
        for (let offset of this._offsets){
            offset = `0000000000${offset}`.slice(-10);
            this._write(offset + ' 00000 n ');
        }
        const trailer = {
            Size: this._offsets.length + 1,
            Root: this._root,
            Info: this._info,
            ID: [
                this._id,
                this._id
            ]
        };
        if (this._security) trailer.Encrypt = this._security.dictionary;
        this._write('trailer');
        this._write($bb72e68028dbdf4a$var$PDFObject.convert(trailer));
        this._write('startxref');
        this._write(`${xRefOffset}`);
        this._write('%%EOF');
        this.push(null);
    }
    toString() {
        return '[object PDFDocument]';
    }
}
const $bb72e68028dbdf4a$var$mixin = (methods)=>{
    Object.assign($bb72e68028dbdf4a$export$2e2bcd8739ae039.prototype, methods);
};
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$MetadataMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$ColorMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$VectorMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$FontsMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$TextMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$ImagesMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$AnnotationsMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$OutlineMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$MarkingsMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$AcroFormMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$AttachmentsMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$SubsetMixin);
$bb72e68028dbdf4a$var$mixin($bb72e68028dbdf4a$var$TableMixin);
$bb72e68028dbdf4a$export$2e2bcd8739ae039.LineWrapper = $bb72e68028dbdf4a$var$LineWrapper;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog('stream');
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug('ondata');
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, 'error') === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug('on readable', state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9845726cca5dc7eb$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9845726cca5dc7eb$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "byteLength", () => $eeb0961446aae8e3$export$a48f0734ac7c2329, (v) => $eeb0961446aae8e3$export$a48f0734ac7c2329 = v);
$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("bF5dL", function(module, exports) {
'use strict';
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || 'inspect';
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
'use strict';

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
'use strict';
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $4e720097bc0bc9d8$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, 'type'));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$4e720097bc0bc9d8$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$4e720097bc0bc9d8$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, 'buffer', {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol('lastResolve');
var $21db958e3a099d7d$var$kLastReject = Symbol('lastReject');
var $21db958e3a099d7d$var$kError = Symbol('error');
var $21db958e3a099d7d$var$kEnded = Symbol('ended');
var $21db958e3a099d7d$var$kLastPromise = Symbol('lastPromise');
var $21db958e3a099d7d$var$kHandlePromise = Symbol('handlePromise');
var $21db958e3a099d7d$var$kStream = Symbol('stream');
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on('readable', $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});


parcelRegister("gxZpm", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $c0bf5cc3997d5bb7$require$Buffer = $6ZWSX.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $c0bf5cc3997d5bb7$require$Transform = $ioRHp.Transform;

var $gymho = parcelRequire("gymho");

var $N7Lcz = parcelRequire("N7Lcz");

var $aLUwE = parcelRequire("aLUwE");
var $c0bf5cc3997d5bb7$require$assert = $aLUwE.ok;

var $6ZWSX = parcelRequire("6ZWSX");
var $c0bf5cc3997d5bb7$require$kMaxLength = $6ZWSX.kMaxLength;
var $c0bf5cc3997d5bb7$var$kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + $c0bf5cc3997d5bb7$require$kMaxLength.toString(16) + ' bytes';
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
$gymho.Z_MIN_WINDOWBITS = 8;
$gymho.Z_MAX_WINDOWBITS = 15;
$gymho.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
$gymho.Z_MIN_CHUNK = 64;
$gymho.Z_MAX_CHUNK = Infinity;
$gymho.Z_DEFAULT_CHUNK = 16384;
$gymho.Z_MIN_MEMLEVEL = 1;
$gymho.Z_MAX_MEMLEVEL = 9;
$gymho.Z_DEFAULT_MEMLEVEL = 8;
$gymho.Z_MIN_LEVEL = -1;
$gymho.Z_MAX_LEVEL = 9;
$gymho.Z_DEFAULT_LEVEL = $gymho.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var $c0bf5cc3997d5bb7$var$bkeys = Object.keys($gymho);
for(var $c0bf5cc3997d5bb7$var$bk = 0; $c0bf5cc3997d5bb7$var$bk < $c0bf5cc3997d5bb7$var$bkeys.length; $c0bf5cc3997d5bb7$var$bk++){
    var $c0bf5cc3997d5bb7$var$bkey = $c0bf5cc3997d5bb7$var$bkeys[$c0bf5cc3997d5bb7$var$bk];
    if ($c0bf5cc3997d5bb7$var$bkey.match(/^Z/)) Object.defineProperty(module.exports, $c0bf5cc3997d5bb7$var$bkey, {
        enumerable: true,
        value: $gymho[$c0bf5cc3997d5bb7$var$bkey],
        writable: false
    });
}
// translation table for return codes.
var $c0bf5cc3997d5bb7$var$codes = {
    Z_OK: $gymho.Z_OK,
    Z_STREAM_END: $gymho.Z_STREAM_END,
    Z_NEED_DICT: $gymho.Z_NEED_DICT,
    Z_ERRNO: $gymho.Z_ERRNO,
    Z_STREAM_ERROR: $gymho.Z_STREAM_ERROR,
    Z_DATA_ERROR: $gymho.Z_DATA_ERROR,
    Z_MEM_ERROR: $gymho.Z_MEM_ERROR,
    Z_BUF_ERROR: $gymho.Z_BUF_ERROR,
    Z_VERSION_ERROR: $gymho.Z_VERSION_ERROR
};
var $c0bf5cc3997d5bb7$var$ckeys = Object.keys($c0bf5cc3997d5bb7$var$codes);
for(var $c0bf5cc3997d5bb7$var$ck = 0; $c0bf5cc3997d5bb7$var$ck < $c0bf5cc3997d5bb7$var$ckeys.length; $c0bf5cc3997d5bb7$var$ck++){
    var $c0bf5cc3997d5bb7$var$ckey = $c0bf5cc3997d5bb7$var$ckeys[$c0bf5cc3997d5bb7$var$ck];
    $c0bf5cc3997d5bb7$var$codes[$c0bf5cc3997d5bb7$var$codes[$c0bf5cc3997d5bb7$var$ckey]] = $c0bf5cc3997d5bb7$var$ckey;
}
Object.defineProperty(module.exports, 'codes', {
    enumerable: true,
    value: Object.freeze($c0bf5cc3997d5bb7$var$codes),
    writable: false
});
module.exports.Deflate = $c0bf5cc3997d5bb7$var$Deflate;
module.exports.Inflate = $c0bf5cc3997d5bb7$var$Inflate;
module.exports.Gzip = $c0bf5cc3997d5bb7$var$Gzip;
module.exports.Gunzip = $c0bf5cc3997d5bb7$var$Gunzip;
module.exports.DeflateRaw = $c0bf5cc3997d5bb7$var$DeflateRaw;
module.exports.InflateRaw = $c0bf5cc3997d5bb7$var$InflateRaw;
module.exports.Unzip = $c0bf5cc3997d5bb7$var$Unzip;
module.exports.createDeflate = function(o) {
    return new $c0bf5cc3997d5bb7$var$Deflate(o);
};
module.exports.createInflate = function(o) {
    return new $c0bf5cc3997d5bb7$var$Inflate(o);
};
module.exports.createDeflateRaw = function(o) {
    return new $c0bf5cc3997d5bb7$var$DeflateRaw(o);
};
module.exports.createInflateRaw = function(o) {
    return new $c0bf5cc3997d5bb7$var$InflateRaw(o);
};
module.exports.createGzip = function(o) {
    return new $c0bf5cc3997d5bb7$var$Gzip(o);
};
module.exports.createGunzip = function(o) {
    return new $c0bf5cc3997d5bb7$var$Gunzip(o);
};
module.exports.createUnzip = function(o) {
    return new $c0bf5cc3997d5bb7$var$Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
module.exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Deflate(opts), buffer, callback);
};
module.exports.deflateSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Deflate(opts), buffer);
};
module.exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Gzip(opts), buffer, callback);
};
module.exports.gzipSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Gzip(opts), buffer);
};
module.exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$DeflateRaw(opts), buffer, callback);
};
module.exports.deflateRawSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$DeflateRaw(opts), buffer);
};
module.exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Unzip(opts), buffer, callback);
};
module.exports.unzipSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Unzip(opts), buffer);
};
module.exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Inflate(opts), buffer, callback);
};
module.exports.inflateSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Inflate(opts), buffer);
};
module.exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Gunzip(opts), buffer, callback);
};
module.exports.gunzipSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Gunzip(opts), buffer);
};
module.exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$InflateRaw(opts), buffer, callback);
};
module.exports.inflateRawSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$InflateRaw(opts), buffer);
};
function $c0bf5cc3997d5bb7$var$zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on('error', onError);
    engine.on('end', onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once('readable', flow);
    }
    function onError(err) {
        engine.removeListener('end', onEnd);
        engine.removeListener('readable', flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= $c0bf5cc3997d5bb7$require$kMaxLength) err = new RangeError($c0bf5cc3997d5bb7$var$kRangeErrorMessage);
        else buf = $c0bf5cc3997d5bb7$require$Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function $c0bf5cc3997d5bb7$var$zlibBufferSync(engine, buffer) {
    if (typeof buffer === 'string') buffer = $c0bf5cc3997d5bb7$require$Buffer.from(buffer);
    if (!$c0bf5cc3997d5bb7$require$Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function $c0bf5cc3997d5bb7$var$Deflate(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Deflate)) return new $c0bf5cc3997d5bb7$var$Deflate(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.DEFLATE);
}
function $c0bf5cc3997d5bb7$var$Inflate(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Inflate)) return new $c0bf5cc3997d5bb7$var$Inflate(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.INFLATE);
}
// gzip - bigger header, same deflate compression
function $c0bf5cc3997d5bb7$var$Gzip(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Gzip)) return new $c0bf5cc3997d5bb7$var$Gzip(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.GZIP);
}
function $c0bf5cc3997d5bb7$var$Gunzip(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Gunzip)) return new $c0bf5cc3997d5bb7$var$Gunzip(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.GUNZIP);
}
// raw - no header
function $c0bf5cc3997d5bb7$var$DeflateRaw(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$DeflateRaw)) return new $c0bf5cc3997d5bb7$var$DeflateRaw(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.DEFLATERAW);
}
function $c0bf5cc3997d5bb7$var$InflateRaw(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$InflateRaw)) return new $c0bf5cc3997d5bb7$var$InflateRaw(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.INFLATERAW);
}
// auto-detect header.
function $c0bf5cc3997d5bb7$var$Unzip(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Unzip)) return new $c0bf5cc3997d5bb7$var$Unzip(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.UNZIP);
}
function $c0bf5cc3997d5bb7$var$isValidFlushFlag(flag) {
    return flag === $gymho.Z_NO_FLUSH || flag === $gymho.Z_PARTIAL_FLUSH || flag === $gymho.Z_SYNC_FLUSH || flag === $gymho.Z_FULL_FLUSH || flag === $gymho.Z_FINISH || flag === $gymho.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function $c0bf5cc3997d5bb7$var$Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || module.exports.Z_DEFAULT_CHUNK;
    $c0bf5cc3997d5bb7$require$Transform.call(this, opts);
    if (opts.flush && !$c0bf5cc3997d5bb7$var$isValidFlushFlag(opts.flush)) throw new Error('Invalid flush flag: ' + opts.flush);
    if (opts.finishFlush && !$c0bf5cc3997d5bb7$var$isValidFlushFlag(opts.finishFlush)) throw new Error('Invalid flush flag: ' + opts.finishFlush);
    this._flushFlag = opts.flush || $gymho.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : $gymho.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < module.exports.Z_MIN_CHUNK || opts.chunkSize > module.exports.Z_MAX_CHUNK) throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < module.exports.Z_MIN_WINDOWBITS || opts.windowBits > module.exports.Z_MAX_WINDOWBITS) throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < module.exports.Z_MIN_LEVEL || opts.level > module.exports.Z_MAX_LEVEL) throw new Error('Invalid compression level: ' + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < module.exports.Z_MIN_MEMLEVEL || opts.memLevel > module.exports.Z_MAX_MEMLEVEL) throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != module.exports.Z_FILTERED && opts.strategy != module.exports.Z_HUFFMAN_ONLY && opts.strategy != module.exports.Z_RLE && opts.strategy != module.exports.Z_FIXED && opts.strategy != module.exports.Z_DEFAULT_STRATEGY) throw new Error('Invalid strategy: ' + opts.strategy);
    }
    if (opts.dictionary) {
        if (!$c0bf5cc3997d5bb7$require$Buffer.isBuffer(opts.dictionary)) throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
    this._handle = new $gymho.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        $c0bf5cc3997d5bb7$var$_close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = module.exports.codes[errno];
        self.emit('error', error);
    };
    var level = module.exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === 'number') level = opts.level;
    var strategy = module.exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === 'number') strategy = opts.strategy;
    this._handle.init(opts.windowBits || module.exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || module.exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = $c0bf5cc3997d5bb7$require$Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once('end', this.close);
    Object.defineProperty(this, '_closed', {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Zlib, $c0bf5cc3997d5bb7$require$Transform);
$c0bf5cc3997d5bb7$var$Zlib.prototype.params = function(level, strategy, callback) {
    if (level < module.exports.Z_MIN_LEVEL || level > module.exports.Z_MAX_LEVEL) throw new RangeError('Invalid compression level: ' + level);
    if (strategy != module.exports.Z_FILTERED && strategy != module.exports.Z_HUFFMAN_ONLY && strategy != module.exports.Z_RLE && strategy != module.exports.Z_FIXED && strategy != module.exports.Z_DEFAULT_STRATEGY) throw new TypeError('Invalid strategy: ' + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush($gymho.Z_SYNC_FLUSH, function() {
            $c0bf5cc3997d5bb7$require$assert(self._handle, 'zlib binding closed');
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else $hPtJY.nextTick(callback);
};
$c0bf5cc3997d5bb7$var$Zlib.prototype.reset = function() {
    $c0bf5cc3997d5bb7$require$assert(this._handle, 'zlib binding closed');
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
$c0bf5cc3997d5bb7$var$Zlib.prototype._flush = function(callback) {
    this._transform($c0bf5cc3997d5bb7$require$Buffer.alloc(0), '', callback);
};
$c0bf5cc3997d5bb7$var$Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === 'function' || kind === undefined && !callback) {
        callback = kind;
        kind = $gymho.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) $hPtJY.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once('end', callback);
    } else if (ws.needDrain) {
        if (callback) this.once('drain', function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write($c0bf5cc3997d5bb7$require$Buffer.alloc(0), '', callback);
    }
};
$c0bf5cc3997d5bb7$var$Zlib.prototype.close = function(callback) {
    $c0bf5cc3997d5bb7$var$_close(this, callback);
    $hPtJY.nextTick($c0bf5cc3997d5bb7$var$emitCloseNT, this);
};
function $c0bf5cc3997d5bb7$var$_close(engine, callback) {
    if (callback) $hPtJY.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function $c0bf5cc3997d5bb7$var$emitCloseNT(self) {
    self.emit('close');
}
$c0bf5cc3997d5bb7$var$Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !$c0bf5cc3997d5bb7$require$Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
    if (!this._handle) return cb(new Error('zlib binding closed'));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || $gymho.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
$c0bf5cc3997d5bb7$var$Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === 'function';
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on('error', function(er) {
            error = er;
        });
        $c0bf5cc3997d5bb7$require$assert(this._handle, 'zlib binding closed');
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= $c0bf5cc3997d5bb7$require$kMaxLength) {
            $c0bf5cc3997d5bb7$var$_close(this);
            throw new RangeError($c0bf5cc3997d5bb7$var$kRangeErrorMessage);
        }
        var buf = $c0bf5cc3997d5bb7$require$Buffer.concat(buffers, nread);
        $c0bf5cc3997d5bb7$var$_close(this);
        return buf;
    }
    $c0bf5cc3997d5bb7$require$assert(this._handle, 'zlib binding closed');
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        $c0bf5cc3997d5bb7$require$assert(have >= 0, 'have should not go down');
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = $c0bf5cc3997d5bb7$require$Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Deflate, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Inflate, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Gzip, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Gunzip, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$DeflateRaw, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$InflateRaw, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Unzip, $c0bf5cc3997d5bb7$var$Zlib);

});
parcelRegister("gymho", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c0d11a8fc746efbd$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $aLUwE = parcelRequire("aLUwE");

var $9WDto = parcelRequire("9WDto");

var $lGf86 = parcelRequire("lGf86");

var $fzvBq = parcelRequire("fzvBq");

var $hf4Xu = parcelRequire("hf4Xu");
for(var $c0d11a8fc746efbd$var$key in $hf4Xu)module.exports[$c0d11a8fc746efbd$var$key] = $hf4Xu[$c0d11a8fc746efbd$var$key];
// zlib modes
module.exports.NONE = 0;
module.exports.DEFLATE = 1;
module.exports.INFLATE = 2;
module.exports.GZIP = 3;
module.exports.GUNZIP = 4;
module.exports.DEFLATERAW = 5;
module.exports.INFLATERAW = 6;
module.exports.UNZIP = 7;
var $c0d11a8fc746efbd$var$GZIP_HEADER_ID1 = 0x1f;
var $c0d11a8fc746efbd$var$GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function $c0d11a8fc746efbd$var$Zlib(mode) {
    if (typeof mode !== 'number' || mode < module.exports.DEFLATE || mode > module.exports.UNZIP) throw new TypeError('Bad argument');
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
$c0d11a8fc746efbd$var$Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    $aLUwE(this.init_done, 'close before init');
    $aLUwE(this.mode <= module.exports.UNZIP);
    if (this.mode === module.exports.DEFLATE || this.mode === module.exports.GZIP || this.mode === module.exports.DEFLATERAW) $lGf86.deflateEnd(this.strm);
    else if (this.mode === module.exports.INFLATE || this.mode === module.exports.GUNZIP || this.mode === module.exports.INFLATERAW || this.mode === module.exports.UNZIP) $fzvBq.inflateEnd(this.strm);
    this.mode = module.exports.NONE;
    this.dictionary = null;
};
$c0d11a8fc746efbd$var$Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
$c0d11a8fc746efbd$var$Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
$c0d11a8fc746efbd$var$Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    $aLUwE.equal(arguments.length, 8);
    $aLUwE(this.init_done, 'write before init');
    $aLUwE(this.mode !== module.exports.NONE, 'already finalized');
    $aLUwE.equal(false, this.write_in_progress, 'write already in progress');
    $aLUwE.equal(false, this.pending_close, 'close is pending');
    this.write_in_progress = true;
    $aLUwE.equal(false, flush === undefined, 'must provide flush value');
    this.write_in_progress = true;
    if (flush !== module.exports.Z_NO_FLUSH && flush !== module.exports.Z_PARTIAL_FLUSH && flush !== module.exports.Z_SYNC_FLUSH && flush !== module.exports.Z_FULL_FLUSH && flush !== module.exports.Z_FINISH && flush !== module.exports.Z_BLOCK) throw new Error('Invalid flush value');
    if (input == null) {
        input = $c0d11a8fc746efbd$require$Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    $hPtJY.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
$c0d11a8fc746efbd$var$Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
$c0d11a8fc746efbd$var$Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $lGf86.deflate(this.strm, this.flush);
            break;
        case module.exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $c0d11a8fc746efbd$var$GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = module.exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $c0d11a8fc746efbd$var$GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = module.exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = module.exports.INFLATE;
                    break;
                default:
                    throw new Error('invalid number of gzip magic number bytes read');
            }
        // fallthrough
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
            this.err = $fzvBq.inflate(this.strm, this.flush);
            if (this.err === module.exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = $fzvBq.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === module.exports.Z_OK) // And try to decode again
                this.err = $fzvBq.inflate(this.strm, this.flush);
                else if (this.err === module.exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = module.exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === module.exports.GUNZIP && this.err === module.exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = $fzvBq.inflate(this.strm, this.flush);
            }
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
};
$c0d11a8fc746efbd$var$Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case module.exports.Z_OK:
        case module.exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === module.exports.Z_FINISH) {
                this._error('unexpected end of file');
                return false;
            }
            break;
        case module.exports.Z_STREAM_END:
            break;
        case module.exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error('Missing dictionary');
            else this._error('Bad dictionary');
            return false;
        default:
            // something else.
            this._error('Zlib error');
            return false;
    }
    return true;
};
$c0d11a8fc746efbd$var$Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
$c0d11a8fc746efbd$var$Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
$c0d11a8fc746efbd$var$Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    $aLUwE(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
    $aLUwE(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
    $aLUwE(level >= -1 && level <= 9, 'invalid compression level');
    $aLUwE(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
    $aLUwE(strategy === module.exports.Z_FILTERED || strategy === module.exports.Z_HUFFMAN_ONLY || strategy === module.exports.Z_RLE || strategy === module.exports.Z_FIXED || strategy === module.exports.Z_DEFAULT_STRATEGY, 'invalid strategy');
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
$c0d11a8fc746efbd$var$Zlib.prototype.params = function() {
    throw new Error('deflateParams Not supported');
};
$c0d11a8fc746efbd$var$Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
$c0d11a8fc746efbd$var$Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = module.exports.Z_NO_FLUSH;
    this.err = module.exports.Z_OK;
    if (this.mode === module.exports.GZIP || this.mode === module.exports.GUNZIP) this.windowBits += 16;
    if (this.mode === module.exports.UNZIP) this.windowBits += 32;
    if (this.mode === module.exports.DEFLATERAW || this.mode === module.exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new $9WDto();
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $lGf86.deflateInit2(this.strm, this.level, module.exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
        case module.exports.UNZIP:
            this.err = $fzvBq.inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
    if (this.err !== module.exports.Z_OK) this._error('Init error');
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
$c0d11a8fc746efbd$var$Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
            this.err = $lGf86.deflateSetDictionary(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error('Failed to set dictionary');
};
$c0d11a8fc746efbd$var$Zlib.prototype._reset = function() {
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
        case module.exports.GZIP:
            this.err = $lGf86.deflateReset(this.strm);
            break;
        case module.exports.INFLATE:
        case module.exports.INFLATERAW:
        case module.exports.GUNZIP:
            this.err = $fzvBq.inflateReset(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error('Failed to reset stream');
};
module.exports.Zlib = $c0d11a8fc746efbd$var$Zlib;

});
parcelRegister("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $7d7a23f7babfddb7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d7a23f7babfddb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d7a23f7babfddb7$var$_typeof(o);
}
function $7d7a23f7babfddb7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d7a23f7babfddb7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d7a23f7babfddb7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d7a23f7babfddb7$var$_toPropertyKey(arg) {
    var key = $7d7a23f7babfddb7$var$_toPrimitive(arg, "string");
    return $7d7a23f7babfddb7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7d7a23f7babfddb7$var$_toPrimitive(input, hint) {
    if ($7d7a23f7babfddb7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7d7a23f7babfddb7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = (parcelRequire("boX8x"))();

var $7d7a23f7babfddb7$var$objectIs = (parcelRequire("5SxoI"))();

var $7d7a23f7babfddb7$var$RegExpPrototypeTest = (parcelRequire("hXu6F"))('RegExp.prototype.test');
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail;
// The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = /*#__PURE__*/ $7d7a23f7babfddb7$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($7d7a23f7babfddb7$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$7d7a23f7babfddb7$var$isRegExp(regexp)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $7d7a23f7babfddb7$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($7d7a23f7babfddb7$var$_typeof(string), " (").concat($7d7a23f7babfddb7$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($7d7a23f7babfddb7$var$inspect(regexp), ". Input:\n\n").concat($7d7a23f7babfddb7$var$inspect(string), "\n"));
        var err = new $8pS6q({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$7d7a23f7babfddb7$var$assert.match = function match(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, match, 'match');
};
$7d7a23f7babfddb7$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRegister("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $92f737b1c63f6b54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $92f737b1c63f6b54$var$_typeof(o);
}
function $92f737b1c63f6b54$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $92f737b1c63f6b54$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $92f737b1c63f6b54$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $92f737b1c63f6b54$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $92f737b1c63f6b54$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $92f737b1c63f6b54$var$_toPropertyKey(arg) {
    var key = $92f737b1c63f6b54$var$_toPrimitive(arg, "string");
    return $92f737b1c63f6b54$var$_typeof(key) === "symbol" ? key : String(key);
}
function $92f737b1c63f6b54$var$_toPrimitive(input, hint) {
    if ($92f737b1c63f6b54$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($92f737b1c63f6b54$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
function $92f737b1c63f6b54$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $92f737b1c63f6b54$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $92f737b1c63f6b54$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $92f737b1c63f6b54$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $92f737b1c63f6b54$var$_possibleConstructorReturn(this, result);
    };
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
var $92f737b1c63f6b54$var$codes = {};
// Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        var _super = $92f737b1c63f6b54$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $92f737b1c63f6b54$var$_createClass(NodeError);
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $92f737b1c63f6b54$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, 'type'));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});
parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = ' ' + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === 'Uint8Array';
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === 'Uint16Array';
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === 'Uint32Array';
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === 'Int8Array';
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === 'Int16Array';
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === 'Int32Array';
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === 'Float32Array';
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === 'Float64Array';
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map]';
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== 'undefined' && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set]';
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== 'undefined' && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakMap]';
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakSet]';
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object DataView]';
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === 'undefined') $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
'use strict';

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $eW390 = parcelRequire("eW390");
var $af991f1d6c80f097$var$$toString = $eW390('Object.prototype.toString');
/** @type {import('.')} */ var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== '[object Array]' && 'callee' in value && $af991f1d6c80f097$var$$toString(value.callee) === '[object Function]';
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
'use strict';

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});

parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});




parcelRegister("5WnCa", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $2xf7f = parcelRequire("2xf7f");
var $4534afe844d627e4$var$isFnRegex = $2xf7f(/^\s*(?:function)?\*/);

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $3ERI6 = parcelRequire("3ERI6");
var $4534afe844d627e4$var$toStr = $eW390('Object.prototype.toString');
var $4534afe844d627e4$var$fnToStr = $eW390('Function.prototype.toString');

var $1xINW = parcelRequire("1xINW");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($4534afe844d627e4$var$isFnRegex($4534afe844d627e4$var$fnToStr(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$3ERI6) return false;
    var GeneratorFunction = $1xINW();
    return GeneratorFunction && $3ERI6(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("2xf7f", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $l37Ky = parcelRequire("l37Ky");
var $1d8a638ce4bfc95c$var$$exec = $eW390('RegExp.prototype.exec');

var $eEkyn = parcelRequire("eEkyn");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$l37Ky(regex)) throw new $eEkyn('`regex` must be a RegExp');
    return function test(s) {
        return $1d8a638ce4bfc95c$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("l37Ky", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $f52fe3bd41a86f17$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $4c4Ky = parcelRequire("4c4Ky");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ var $f52fe3bd41a86f17$var$fn;
if ($f52fe3bd41a86f17$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $f52fe3bd41a86f17$var$$exec = $eW390('RegExp.prototype.exec');
    /** @type {object} */ var $f52fe3bd41a86f17$var$isRegexMarker = {};
    var $f52fe3bd41a86f17$var$throwRegexMarker = function() {
        throw $f52fe3bd41a86f17$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $f52fe3bd41a86f17$var$badStringifier = {
        toString: $f52fe3bd41a86f17$var$throwRegexMarker,
        valueOf: $f52fe3bd41a86f17$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $f52fe3bd41a86f17$var$badStringifier[Symbol.toPrimitive] = $f52fe3bd41a86f17$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $dYOee(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $4c4Ky(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $f52fe3bd41a86f17$var$$exec(value, /** @type {unknown} */ $f52fe3bd41a86f17$var$badStringifier);
        } catch (e) {
            return e === $f52fe3bd41a86f17$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $f52fe3bd41a86f17$var$$toString = $eW390('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $f52fe3bd41a86f17$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $f52fe3bd41a86f17$var$$toString(value) === $f52fe3bd41a86f17$var$regexClass;
    };
}
module.exports = $f52fe3bd41a86f17$var$fn;

});


parcelRegister("1xINW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8c988d2af4ba1e07$export$2e2bcd8739ae039);

var $aN8bA = parcelRequire("aN8bA");
var /** @type {import('./index.d.mts').default} */ $8c988d2af4ba1e07$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aN8bA)));

});
parcelRegister("aN8bA", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $7db4d48993eb4086$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$7db4d48993eb4086$var$cached;

});



parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $eW390 = parcelRequire("eW390");

var $dYOee = parcelRequire("dYOee");

var $3ERI6 = parcelRequire("3ERI6");
var $c2e61c703a2c9ae0$var$$toString = $eW390('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $eW390('String.prototype.slice');
/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */ /** @import { TypedArrayName } from '.' */ /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $eW390('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @type {Cache} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $3ERI6) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3ERI6) {
        var proto = $3ERI6(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3ERI6(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $cOB0F(descriptor.get);
            $c2e61c703a2c9ae0$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {BoundSlice | BoundSet} */ // @ts-expect-error TODO FIXME
        $cOB0F(fn);
        $c2e61c703a2c9ae0$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | TypedArrayName} */ function $c2e61c703a2c9ae0$var$tryTypedArrays(value) {
    /** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
    $gFhA7(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(value: object) => false | TypedArrayName} */ function $c2e61c703a2c9ae0$var$trySlices(value) {
    /** @type {ReturnType<typeof trySlices>} */ var found = false;
    $gFhA7(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */ function $c2e61c703a2c9ae0$var$isTATag(tag) {
    return $c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1;
}
/**
 * @type {import('.')}
 * @param {unknown} value
 */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$isTATag(tag)) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
'use strict';

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c21e1d005400ef2a$var$isArray(x) {
    return $c21e1d005400ef2a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$isArray(list)) $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("63RD0", function(module, exports) {
'use strict';
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = '[object Object]';
var $469c9f4bd3a650de$var$fnClass = '[object Function]';
var $469c9f4bd3a650de$var$genClass = '[object GeneratorFunction]';
var $469c9f4bd3a650de$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = '[object HTML document.all class]';
var $469c9f4bd3a650de$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
'use strict';

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === 'function') // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $BPe9e = parcelRequire("BPe9e");

var $jAy3M = parcelRequire("jAy3M");

var $jyxCz = parcelRequire("jyxCz");

var $1uOip = parcelRequire("1uOip");
module.exports = function callBind(originalFunction) {
    var func = $jyxCz(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $BPe9e(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($jAy3M) $jAy3M(module.exports, 'apply', {
    value: $1uOip
});
else module.exports.apply = $1uOip;

});
parcelRegister("BPe9e", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eEkyn('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $dYOee) {
        var desc = $dYOee(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eEkyn('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eEkyn('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eEkyn('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eEkyn('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eEkyn('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eEkyn('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRegister("1uOip", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $3YvJT = parcelRequire("3YvJT");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $3YvJT($gvair, $xMvSJ, arguments);
};

});



parcelRegister("hN833", function(module, exports) {
'use strict';

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $620aa032cca82da4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $620aa032cca82da4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $620aa032cca82da4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $620aa032cca82da4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $620aa032cca82da4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    key = $620aa032cca82da4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $620aa032cca82da4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $620aa032cca82da4$var$_toPropertyKey(arg) {
    var key = $620aa032cca82da4$var$_toPrimitive(arg, "string");
    return $620aa032cca82da4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $620aa032cca82da4$var$_toPrimitive(input, hint) {
    if ($620aa032cca82da4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($620aa032cca82da4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $620aa032cca82da4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $620aa032cca82da4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $620aa032cca82da4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $620aa032cca82da4$var$_possibleConstructorReturn(this, result);
    };
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$_isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct.bind();
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $620aa032cca82da4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $620aa032cca82da4$var$_typeof(o);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = '';
var $620aa032cca82da4$var$green = '';
var $620aa032cca82da4$var$red = '';
var $620aa032cca82da4$var$white = '';
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $620aa032cca82da4$var$_typeof(actual) === 'object' && $620aa032cca82da4$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== 'object' || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    var _super = $620aa032cca82da4$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== 'object' || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1B[34m";
                    $620aa032cca82da4$var$green = "\x1B[32m";
                    $620aa032cca82da4$var$white = "\x1B[39m";
                    $620aa032cca82da4$var$red = "\x1B[31m";
                } else {
                    $620aa032cca82da4$var$blue = '';
                    $620aa032cca82da4$var$green = '';
                    $620aa032cca82da4$var$white = '';
                    $620aa032cca82da4$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === 'object' && actual !== null && $620aa032cca82da4$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $620aa032cca82da4$var$_typeof(actual) === 'object' && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = '';
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread($620aa032cca82da4$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $620aa032cca82da4$var$_wrapNativeSuper(Error), $620aa032cca82da4$var$inspect.custom);
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRegister("boX8x", function(module, exports) {
'use strict';

var $aHVV7 = parcelRequire("aHVV7");
var $84cfceeae7d9941c$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $84cfceeae7d9941c$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $aHVV7;
    if ($84cfceeae7d9941c$var$lacksProperEnumerationOrder()) return $aHVV7;
    if ($84cfceeae7d9941c$var$assignHasPendingExceptions()) return $aHVV7;
    return Object.assign;
};

});
parcelRegister("aHVV7", function(module, exports) {
'use strict';

var $81enX = parcelRequire("81enX");

var $7cbad94b4017a2be$var$hasSymbols = (parcelRequire("7YWkK"))();

var $eW390 = parcelRequire("eW390");

var $90JBs = parcelRequire("90JBs");
var $7cbad94b4017a2be$var$$push = $eW390('Array.prototype.push');
var $7cbad94b4017a2be$var$$propIsEnumerable = $eW390('Object.prototype.propertyIsEnumerable');
var $7cbad94b4017a2be$var$originalGetSymbols = $7cbad94b4017a2be$var$hasSymbols ? $90JBs.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $90JBs(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $90JBs(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $81enX(from);
        var getSymbols = $7cbad94b4017a2be$var$hasSymbols && ($90JBs.getOwnPropertySymbols || $7cbad94b4017a2be$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7cbad94b4017a2be$var$$propIsEnumerable(from, key)) $7cbad94b4017a2be$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7cbad94b4017a2be$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("81enX", function(module, exports) {
'use strict';
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRegister("z1gio", function(module, exports) {
'use strict';
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
'use strict';
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, 'prototype');
    var $330998a67e44345d$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys['$' + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $330998a67e44345d$var$toStr.call(object) === '[object Function]';
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === 'constructor') && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});




parcelRegister("5SxoI", function(module, exports) {
'use strict';

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $6wuPW;
};

});
parcelRegister("6wuPW", function(module, exports) {
'use strict';
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("hXu6F", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $d12f4cdcd6b10506$var$$indexOf(name, '.prototype.') > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});

parcelRegister("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_unsupportedIterableToArray(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2be9aa30bff457b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
}
function $2be9aa30bff457b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2be9aa30bff457b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2be9aa30bff457b9$var$_typeof(o);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3;
// Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== 'object') {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRegister("eT9RM", function(module, exports) {
'use strict';

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRegister("1UbTr", function(module, exports) {
'use strict';

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;

var $5FEEt = parcelRequire("5FEEt");
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === 'function' && $16343f2546a69e4c$var$toStr.call(fn) === '[object Function]';
};

var $16343f2546a69e4c$var$supportsDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $5FEEt(object, name, value, true);
    else $5FEEt(object, name, value);
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});

parcelRegister("bNbuK", function(module, exports) {
'use strict';

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("c8Cyq", function(module, exports) {
'use strict';

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRegister("8sYH2", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("91M8b", function(module, exports) {
'use strict';

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $8sYH2;
};

});

parcelRegister("hCf9I", function(module, exports) {
'use strict';

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("9WDto", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});

parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateReset", () => $fc8941aa2060205a$export$8f99f0e30bc7dd53, (v) => $fc8941aa2060205a$export$8f99f0e30bc7dd53 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $hx6dX = parcelRequire("hx6dX");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $7gAmB[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $9CLQF.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $hx6dX._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $9CLQF.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $9CLQF.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $hx6dX._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $9CLQF.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $9CLQF.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $hx6dX._tr_init(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $9CLQF.Buf8(s.w_size * 2);
    s.head = new $9CLQF.Buf16(s.hash_size);
    s.prev = new $9CLQF.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $9CLQF.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $hx6dX._tr_align(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $hx6dX._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $9CLQF.Buf8(s.w_size);
        $9CLQF.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("9CLQF", function(module, exports) {
'use strict';
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnUntyped);
    }
};
module.exports.setTyped($701cc75d47025217$var$TYPED_OK);

});

parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $9CLQF.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateReset", () => $b562a383a327bea1$export$42de45683a92ba94, (v) => $b562a383a327bea1$export$42de45683a92ba94 = v);
$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $9CLQF.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $9CLQF.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $9CLQF.Buf32(512);
        $b562a383a327bea1$var$distfix = new $9CLQF.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $9CLQF.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $9CLQF.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $9CLQF.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $9CLQF.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $9CLQF.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $9CLQF.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $9CLQF.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("hf4Xu", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});



parcelRegister("3Bcdj", function(module, exports) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.Hash = module.exports.nextTick = module.exports.swap32IfBE = module.exports.byteSwapIfBE = module.exports.swap8IfBE = module.exports.isLE = void 0;
module.exports.isBytes = $29ee4d3171d9809b$var$isBytes;
module.exports.anumber = $29ee4d3171d9809b$var$anumber;
module.exports.abytes = $29ee4d3171d9809b$var$abytes;
module.exports.ahash = $29ee4d3171d9809b$var$ahash;
module.exports.aexists = $29ee4d3171d9809b$var$aexists;
module.exports.aoutput = $29ee4d3171d9809b$var$aoutput;
module.exports.u8 = $29ee4d3171d9809b$var$u8;
module.exports.u32 = $29ee4d3171d9809b$var$u32;
module.exports.clean = $29ee4d3171d9809b$var$clean;
module.exports.createView = $29ee4d3171d9809b$var$createView;
module.exports.rotr = $29ee4d3171d9809b$var$rotr;
module.exports.rotl = $29ee4d3171d9809b$var$rotl;
module.exports.byteSwap = $29ee4d3171d9809b$var$byteSwap;
module.exports.byteSwap32 = $29ee4d3171d9809b$var$byteSwap32;
module.exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
module.exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
module.exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
module.exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
module.exports.bytesToUtf8 = $29ee4d3171d9809b$var$bytesToUtf8;
module.exports.toBytes = $29ee4d3171d9809b$var$toBytes;
module.exports.kdfInputToBytes = $29ee4d3171d9809b$var$kdfInputToBytes;
module.exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
module.exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
module.exports.createHasher = $29ee4d3171d9809b$var$createHasher;
module.exports.createOptHasher = $29ee4d3171d9809b$var$createOptHasher;
module.exports.createXOFer = $29ee4d3171d9809b$var$createXOFer;
module.exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;

var $dUxV2 = parcelRequire("dUxV2");
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is positive integer. */ function $29ee4d3171d9809b$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */ function $29ee4d3171d9809b$var$abytes(b, ...lengths) {
    if (!$29ee4d3171d9809b$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function $29ee4d3171d9809b$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $29ee4d3171d9809b$var$anumber(h.outputLen);
    $29ee4d3171d9809b$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $29ee4d3171d9809b$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function $29ee4d3171d9809b$var$aoutput(out, instance) {
    $29ee4d3171d9809b$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
/** Cast u8 / u16 / u32 to u8. */ function $29ee4d3171d9809b$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */ function $29ee4d3171d9809b$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */ function $29ee4d3171d9809b$var$clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
/** Create DataView of an array for easy byte-level manipulation. */ function $29ee4d3171d9809b$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ module.exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */ function $29ee4d3171d9809b$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ module.exports.swap8IfBE = module.exports.isLE ? (n)=>n : (n)=>$29ee4d3171d9809b$var$byteSwap(n);
/** @deprecated */ module.exports.byteSwapIfBE = module.exports.swap8IfBE;
/** In place byte swap for Uint32Array */ function $29ee4d3171d9809b$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $29ee4d3171d9809b$var$byteSwap(arr[i]);
    return arr;
}
module.exports.swap32IfBE = module.exports.isLE ? (u)=>u : $29ee4d3171d9809b$var$byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $29ee4d3171d9809b$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    $29ee4d3171d9809b$var$abytes(bytes);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(ch) {
    if (ch >= $29ee4d3171d9809b$var$asciis._0 && ch <= $29ee4d3171d9809b$var$asciis._9) return ch - $29ee4d3171d9809b$var$asciis._0; // '2' => 50-48
    if (ch >= $29ee4d3171d9809b$var$asciis.A && ch <= $29ee4d3171d9809b$var$asciis.F) return ch - ($29ee4d3171d9809b$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $29ee4d3171d9809b$var$asciis.a && ch <= $29ee4d3171d9809b$var$asciis.f) return ch - ($29ee4d3171d9809b$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $29ee4d3171d9809b$var$nextTick = async ()=>{};
module.exports.nextTick = $29ee4d3171d9809b$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ function $29ee4d3171d9809b$var$bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === 'string') data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    $29ee4d3171d9809b$var$abytes(data);
    return data;
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */ function $29ee4d3171d9809b$var$kdfInputToBytes(data) {
    if (typeof data === 'string') data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    $29ee4d3171d9809b$var$abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $29ee4d3171d9809b$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** For runtime check if class implements interface */ class $29ee4d3171d9809b$var$Hash {
}
module.exports.Hash = $29ee4d3171d9809b$var$Hash;
/** Wraps hash function, creating an interface on top of it */ function $29ee4d3171d9809b$var$createHasher(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $29ee4d3171d9809b$var$createOptHasher(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $29ee4d3171d9809b$var$createXOFer(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructor = $29ee4d3171d9809b$var$createHasher;
module.exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$createOptHasher;
module.exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$createXOFer;
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($dUxV2.crypto && typeof $dUxV2.crypto.getRandomValues === 'function') return $dUxV2.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($dUxV2.crypto && typeof $dUxV2.crypto.randomBytes === 'function') return Uint8Array.from($dUxV2.crypto.randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("dUxV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});


parcelRegister("hqt0D", function(module, exports) {


/**
 * [js-md5]{@link https://github.com/emn178/js-md5}
 *
 * @namespace md5
 * @version 0.8.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ (function() {
    'use strict';
    var INPUT_ERROR = 'input is invalid type';
    var FINALIZE_ERROR = 'finalize already called';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_MD5_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_MD5_NO_NODE_JS && false;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        128,
        32768,
        8388608,
        -2147483648
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'buffer',
        'arrayBuffer',
        'base64'
    ];
    var BASE64_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
    var blocks = [], buffer8;
    if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        buffer8 = new Uint8Array(buffer);
        blocks = new Uint32Array(buffer);
    }
    var isArray = Array.isArray;
    if (root.JS_MD5_NO_NODE_JS || !isArray) isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    var isView = ArrayBuffer.isView;
    if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !isView)) isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    // [message: string, isString: bool]
    var formatMessage = function(message) {
        var type = typeof message;
        if (type === 'string') return [
            message,
            true
        ];
        if (type !== 'object' || message === null) throw new Error(INPUT_ERROR);
        if (ARRAY_BUFFER && message.constructor === ArrayBuffer) return [
            new Uint8Array(message),
            false
        ];
        if (!isArray(message) && !isView(message)) throw new Error(INPUT_ERROR);
        return [
            message,
            false
        ];
    };
    /**
   * @method hex
   * @memberof md5
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hex('The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method digest
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.digest('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method array
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.array('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method arrayBuffer
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.buffer('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method base64
   * @memberof md5
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.base64('The quick brown fox jumps over the lazy dog');
   */ var createOutputMethod = function(outputType) {
        return function(message) {
            return new Md5(true).update(message)[outputType]();
        };
    };
    /**
   * @method create
   * @memberof md5
   * @description Create Md5 object
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.create();
   */ /**
   * @method update
   * @memberof md5
   * @description Create and update Md5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.update('The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.create();
   * hash.update('The quick brown fox jumps over the lazy dog');
   */ var createMethod = function() {
        var method = createOutputMethod('hex');
        if (NODE_JS) method = nodeWrap(method);
        method.create = function() {
            return new Md5();
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type);
        }
        return method;
    };
    var nodeWrap = function(method) {
        var crypto = (parcelRequire("kjyEk"));
        var Buffer = (parcelRequire("kjyEk")).Buffer;
        var bufferFrom;
        if (Buffer.from && !root.JS_MD5_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash('md5').update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(INPUT_ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (isArray(message) || isView(message) || message.constructor === Buffer) return crypto.createHash('md5').update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    /**
   * @namespace md5.hmac
   */ /**
   * @method hex
   * @memberof md5.hmac
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hmac.hex('key', 'The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5.hmac('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method digest
   * @memberof md5.hmac
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.hmac.digest('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method array
   * @memberof md5.hmac
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.hmac.array('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method arrayBuffer
   * @memberof md5.hmac
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.hmac.arrayBuffer('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5.hmac
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.hmac.buffer('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method base64
   * @memberof md5.hmac
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.hmac.base64('key', 'The quick brown fox jumps over the lazy dog');
   */ var createHmacOutputMethod = function(outputType) {
        return function(key, message) {
            return new HmacMd5(key, true).update(message)[outputType]();
        };
    };
    /**
   * @method create
   * @memberof md5.hmac
   * @description Create HmacMd5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @returns {HmacMd5} HmacMd5 object.
   * @example
   * var hash = md5.hmac.create('key');
   */ /**
   * @method update
   * @memberof md5.hmac
   * @description Create and update HmacMd5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {HmacMd5} HmacMd5 object.
   * @example
   * var hash = md5.hmac.update('key', 'The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.hmac.create('key');
   * hash.update('The quick brown fox jumps over the lazy dog');
   */ var createHmacMethod = function() {
        var method = createHmacOutputMethod('hex');
        method.create = function(key) {
            return new HmacMd5(key);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type);
        }
        return method;
    };
    /**
   * Md5 class
   * @class Md5
   * @description This is internal class.
   * @see {@link md5.create}
   */ function Md5(sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
            this.buffer8 = buffer8;
        } else if (ARRAY_BUFFER) {
            var buffer = new ArrayBuffer(68);
            this.buffer8 = new Uint8Array(buffer);
            this.blocks = new Uint32Array(buffer);
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
    }
    /**
   * @method update
   * @memberof Md5
   * @instance
   * @description Update hash
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @see {@link md5.update}
   */ Md5.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var result = formatMessage(message);
        message = result[0];
        var isString = result[1];
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        var buffer8 = this.buffer8;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = blocks[16];
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (isString) {
                if (ARRAY_BUFFER) for(i = this.start; index < length && i < 64; ++index){
                    code = message.charCodeAt(index);
                    if (code < 0x80) buffer8[i++] = code;
                    else if (code < 0x800) {
                        buffer8[i++] = 0xc0 | code >>> 6;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    } else if (code < 0xd800 || code >= 0xe000) {
                        buffer8[i++] = 0xe0 | code >>> 12;
                        buffer8[i++] = 0x80 | code >>> 6 & 0x3f;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                        buffer8[i++] = 0xf0 | code >>> 18;
                        buffer8[i++] = 0x80 | code >>> 12 & 0x3f;
                        buffer8[i++] = 0x80 | code >>> 6 & 0x3f;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    }
                }
                else for(i = this.start; index < length && i < 64; ++index){
                    code = message.charCodeAt(index);
                    if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                    else if (code < 0x800) {
                        blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else if (code < 0xd800 || code >= 0xe000) {
                        blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                        blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    }
                }
            } else {
                if (ARRAY_BUFFER) for(i = this.start; index < length && i < 64; ++index)buffer8[i++] = message[index];
                else for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Md5.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[i >>> 2] |= EXTRA[i & 3];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = blocks[16];
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.bytes << 3;
        blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
        this.hash();
    };
    Md5.prototype.hash = function() {
        var a, b, c, d, bc, da, blocks = this.blocks;
        if (this.first) {
            a = blocks[0] - 680876937;
            a = (a << 7 | a >>> 25) - 271733879 << 0;
            d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
            d = (d << 12 | d >>> 20) + a << 0;
            c = (-271733879 ^ d & (a ^ -271733879)) + blocks[2] - 1126478375;
            c = (c << 17 | c >>> 15) + d << 0;
            b = (a ^ c & (d ^ a)) + blocks[3] - 1316259209;
            b = (b << 22 | b >>> 10) + c << 0;
        } else {
            a = this.h0;
            b = this.h1;
            c = this.h2;
            d = this.h3;
            a += (d ^ b & (c ^ d)) + blocks[0] - 680876936;
            a = (a << 7 | a >>> 25) + b << 0;
            d += (c ^ a & (b ^ c)) + blocks[1] - 389564586;
            d = (d << 12 | d >>> 20) + a << 0;
            c += (b ^ d & (a ^ b)) + blocks[2] + 606105819;
            c = (c << 17 | c >>> 15) + d << 0;
            b += (a ^ c & (d ^ a)) + blocks[3] - 1044525330;
            b = (b << 22 | b >>> 10) + c << 0;
        }
        a += (d ^ b & (c ^ d)) + blocks[4] - 176418897;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[5] + 1200080426;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[6] - 1473231341;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[7] - 45705983;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[8] + 1770035416;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[9] - 1958414417;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[10] - 42063;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[11] - 1990404162;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[12] + 1804603682;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[13] - 40341101;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[14] - 1502002290;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[15] + 1236535329;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[1] - 165796510;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[6] - 1069501632;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[11] + 643717713;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[0] - 373897302;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[5] - 701558691;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[10] + 38016083;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[15] - 660478335;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[4] - 405537848;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[9] + 568446438;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[14] - 1019803690;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[3] - 187363961;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[8] + 1163531501;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[13] - 1444681467;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[2] - 51403784;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[7] + 1735328473;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[12] - 1926607734;
        b = (b << 20 | b >>> 12) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[5] - 378558;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[8] - 2022574463;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[11] + 1839030562;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[14] - 35309556;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[1] - 1530992060;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[4] + 1272893353;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[7] - 155497632;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[10] - 1094730640;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[13] + 681279174;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[0] - 358537222;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[3] - 722521979;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[6] + 76029189;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[9] - 640364487;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[12] - 421815835;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[15] + 530742520;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[2] - 995338651;
        b = (b << 23 | b >>> 9) + c << 0;
        a += (c ^ (b | ~d)) + blocks[0] - 198630844;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[5] - 57434055;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[10] - 1051523;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[15] - 30611744;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[4] - 145523070;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[2] + 718787259;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[9] - 343485551;
        b = (b << 21 | b >>> 11) + c << 0;
        if (this.first) {
            this.h0 = a + 1732584193 << 0;
            this.h1 = b - 271733879 << 0;
            this.h2 = c - 1732584194 << 0;
            this.h3 = d + 271733878 << 0;
            this.first = false;
        } else {
            this.h0 = this.h0 + a << 0;
            this.h1 = this.h1 + b << 0;
            this.h2 = this.h2 + c << 0;
            this.h3 = this.h3 + d << 0;
        }
    };
    /**
   * @method hex
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.hex();
   */ Md5.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
        return HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F];
    };
    /**
   * @method toString
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.toString();
   */ Md5.prototype.toString = Md5.prototype.hex;
    /**
   * @method digest
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.digest}
   * @example
   * hash.digest();
   */ Md5.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
        return [
            h0 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 24 & 0xFF,
            h1 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 24 & 0xFF,
            h2 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 24 & 0xFF,
            h3 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 24 & 0xFF
        ];
    };
    /**
   * @method array
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.array}
   * @example
   * hash.array();
   */ Md5.prototype.array = Md5.prototype.digest;
    /**
   * @method arrayBuffer
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.arrayBuffer}
   * @example
   * hash.arrayBuffer();
   */ Md5.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(16);
        var blocks = new Uint32Array(buffer);
        blocks[0] = this.h0;
        blocks[1] = this.h1;
        blocks[2] = this.h2;
        blocks[3] = this.h3;
        return buffer;
    };
    /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.buffer}
   * @example
   * hash.buffer();
   */ Md5.prototype.buffer = Md5.prototype.arrayBuffer;
    /**
   * @method base64
   * @memberof Md5
   * @instance
   * @description Output hash as base64 string
   * @returns {String} base64 string
   * @see {@link md5.base64}
   * @example
   * hash.base64();
   */ Md5.prototype.base64 = function() {
        var v1, v2, v3, base64Str = '', bytes = this.array();
        for(var i = 0; i < 15;){
            v1 = bytes[i++];
            v2 = bytes[i++];
            v3 = bytes[i++];
            base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] + BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] + BASE64_ENCODE_CHAR[v3 & 63];
        }
        v1 = bytes[i];
        base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[v1 << 4 & 63] + '==';
        return base64Str;
    };
    /**
   * HmacMd5 class
   * @class HmacMd5
   * @extends Md5
   * @description This is internal class.
   * @see {@link md5.hmac.create}
   */ function HmacMd5(key, sharedMemory) {
        var i, result = formatMessage(key);
        key = result[0];
        if (result[1]) {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        }
        if (key.length > 64) key = new Md5(true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Md5.call(this, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacMd5.prototype = new Md5();
    HmacMd5.prototype.finalize = function() {
        Md5.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Md5.call(this, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Md5.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.md5 = exports;
    exports.md5.hmac = createHmacMethod();
    if (COMMON_JS) module.exports = exports;
    else {
        /**
     * @method md5
     * @description Md5 hash function, export to global in browsers.
     * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
     * @returns {String} md5 hashes
     * @example
     * md5(''); // d41d8cd98f00b204e9800998ecf8427e
     * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
     * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
     *
     * // It also supports UTF-8 encoding
     * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
     *
     * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
     * md5([]); // d41d8cd98f00b204e9800998ecf8427e
     * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
     */ root.md5 = exports;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});

parcelRegister("htQ8Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512_224 = module.exports.sha512_256 = module.exports.sha384 = module.exports.sha512 = module.exports.sha224 = module.exports.sha256 = module.exports.SHA512_256 = module.exports.SHA512_224 = module.exports.SHA384 = module.exports.SHA512 = module.exports.SHA224 = module.exports.SHA256 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $eDgKs = parcelRequire("eDgKs");

var $3Bcdj = parcelRequire("3Bcdj");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $cb9d97d4d61a5a71$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $cb9d97d4d61a5a71$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $cb9d97d4d61a5a71$var$SHA256 extends $iYRTw.HashMD {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $iYRTw.SHA256_IV[0] | 0;
        this.B = $iYRTw.SHA256_IV[1] | 0;
        this.C = $iYRTw.SHA256_IV[2] | 0;
        this.D = $iYRTw.SHA256_IV[3] | 0;
        this.E = $iYRTw.SHA256_IV[4] | 0;
        this.F = $iYRTw.SHA256_IV[5] | 0;
        this.G = $iYRTw.SHA256_IV[6] | 0;
        this.H = $iYRTw.SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$cb9d97d4d61a5a71$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $cb9d97d4d61a5a71$var$SHA256_W[i - 15];
            const W2 = $cb9d97d4d61a5a71$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $cb9d97d4d61a5a71$var$SHA256_W[i] = s1 + $cb9d97d4d61a5a71$var$SHA256_W[i - 7] + s0 + $cb9d97d4d61a5a71$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $iYRTw.Chi)(E, F, G) + $cb9d97d4d61a5a71$var$SHA256_K[i] + $cb9d97d4d61a5a71$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + (0, $iYRTw.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $3Bcdj.clean)($cb9d97d4d61a5a71$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $3Bcdj.clean)(this.buffer);
    }
}
module.exports.SHA256 = $cb9d97d4d61a5a71$var$SHA256;
class $cb9d97d4d61a5a71$var$SHA224 extends $cb9d97d4d61a5a71$var$SHA256 {
    constructor(){
        super(28);
        this.A = $iYRTw.SHA224_IV[0] | 0;
        this.B = $iYRTw.SHA224_IV[1] | 0;
        this.C = $iYRTw.SHA224_IV[2] | 0;
        this.D = $iYRTw.SHA224_IV[3] | 0;
        this.E = $iYRTw.SHA224_IV[4] | 0;
        this.F = $iYRTw.SHA224_IV[5] | 0;
        this.G = $iYRTw.SHA224_IV[6] | 0;
        this.H = $iYRTw.SHA224_IV[7] | 0;
    }
}
module.exports.SHA224 = $cb9d97d4d61a5a71$var$SHA224;
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $cb9d97d4d61a5a71$var$K512 = /* @__PURE__ */ (()=>$eDgKs.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $cb9d97d4d61a5a71$var$SHA512_Kh = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[0])();
const $cb9d97d4d61a5a71$var$SHA512_Kl = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[1])();
// Reusable temporary buffers
const $cb9d97d4d61a5a71$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $cb9d97d4d61a5a71$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $cb9d97d4d61a5a71$var$SHA512 extends $iYRTw.HashMD {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = $iYRTw.SHA512_IV[0] | 0;
        this.Al = $iYRTw.SHA512_IV[1] | 0;
        this.Bh = $iYRTw.SHA512_IV[2] | 0;
        this.Bl = $iYRTw.SHA512_IV[3] | 0;
        this.Ch = $iYRTw.SHA512_IV[4] | 0;
        this.Cl = $iYRTw.SHA512_IV[5] | 0;
        this.Dh = $iYRTw.SHA512_IV[6] | 0;
        this.Dl = $iYRTw.SHA512_IV[7] | 0;
        this.Eh = $iYRTw.SHA512_IV[8] | 0;
        this.El = $iYRTw.SHA512_IV[9] | 0;
        this.Fh = $iYRTw.SHA512_IV[10] | 0;
        this.Fl = $iYRTw.SHA512_IV[11] | 0;
        this.Gh = $iYRTw.SHA512_IV[12] | 0;
        this.Gl = $iYRTw.SHA512_IV[13] | 0;
        this.Hh = $iYRTw.SHA512_IV[14] | 0;
        this.Hl = $iYRTw.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = view.getUint32(offset);
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 15] | 0;
            const W15l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 15] | 0;
            const s0h = $eDgKs.rotrSH(W15h, W15l, 1) ^ $eDgKs.rotrSH(W15h, W15l, 8) ^ $eDgKs.shrSH(W15h, W15l, 7);
            const s0l = $eDgKs.rotrSL(W15h, W15l, 1) ^ $eDgKs.rotrSL(W15h, W15l, 8) ^ $eDgKs.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 2] | 0;
            const W2l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 2] | 0;
            const s1h = $eDgKs.rotrSH(W2h, W2l, 19) ^ $eDgKs.rotrBH(W2h, W2l, 61) ^ $eDgKs.shrSH(W2h, W2l, 6);
            const s1l = $eDgKs.rotrSL(W2h, W2l, 19) ^ $eDgKs.rotrBL(W2h, W2l, 61) ^ $eDgKs.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $eDgKs.add4L(s0l, s1l, $cb9d97d4d61a5a71$var$SHA512_W_L[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_L[i - 16]);
            const SUMh = $eDgKs.add4H(SUMl, s0h, s1h, $cb9d97d4d61a5a71$var$SHA512_W_H[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_H[i - 16]);
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = SUMh | 0;
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $eDgKs.rotrSH(Eh, El, 14) ^ $eDgKs.rotrSH(Eh, El, 18) ^ $eDgKs.rotrBH(Eh, El, 41);
            const sigma1l = $eDgKs.rotrSL(Eh, El, 14) ^ $eDgKs.rotrSL(Eh, El, 18) ^ $eDgKs.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $eDgKs.add5L(Hl, sigma1l, CHIl, $cb9d97d4d61a5a71$var$SHA512_Kl[i], $cb9d97d4d61a5a71$var$SHA512_W_L[i]);
            const T1h = $eDgKs.add5H(T1ll, Hh, sigma1h, CHIh, $cb9d97d4d61a5a71$var$SHA512_Kh[i], $cb9d97d4d61a5a71$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $eDgKs.rotrSH(Ah, Al, 28) ^ $eDgKs.rotrBH(Ah, Al, 34) ^ $eDgKs.rotrBH(Ah, Al, 39);
            const sigma0l = $eDgKs.rotrSL(Ah, Al, 28) ^ $eDgKs.rotrBL(Ah, Al, 34) ^ $eDgKs.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $eDgKs.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $eDgKs.add3L(T1l, sigma0l, MAJl);
            Ah = $eDgKs.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $eDgKs.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $eDgKs.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $eDgKs.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $eDgKs.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $eDgKs.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $eDgKs.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $eDgKs.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $eDgKs.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $3Bcdj.clean)($cb9d97d4d61a5a71$var$SHA512_W_H, $cb9d97d4d61a5a71$var$SHA512_W_L);
    }
    destroy() {
        (0, $3Bcdj.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $cb9d97d4d61a5a71$var$SHA512;
class $cb9d97d4d61a5a71$var$SHA384 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(48);
        this.Ah = $iYRTw.SHA384_IV[0] | 0;
        this.Al = $iYRTw.SHA384_IV[1] | 0;
        this.Bh = $iYRTw.SHA384_IV[2] | 0;
        this.Bl = $iYRTw.SHA384_IV[3] | 0;
        this.Ch = $iYRTw.SHA384_IV[4] | 0;
        this.Cl = $iYRTw.SHA384_IV[5] | 0;
        this.Dh = $iYRTw.SHA384_IV[6] | 0;
        this.Dl = $iYRTw.SHA384_IV[7] | 0;
        this.Eh = $iYRTw.SHA384_IV[8] | 0;
        this.El = $iYRTw.SHA384_IV[9] | 0;
        this.Fh = $iYRTw.SHA384_IV[10] | 0;
        this.Fl = $iYRTw.SHA384_IV[11] | 0;
        this.Gh = $iYRTw.SHA384_IV[12] | 0;
        this.Gl = $iYRTw.SHA384_IV[13] | 0;
        this.Hh = $iYRTw.SHA384_IV[14] | 0;
        this.Hl = $iYRTw.SHA384_IV[15] | 0;
    }
}
module.exports.SHA384 = $cb9d97d4d61a5a71$var$SHA384;
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $cb9d97d4d61a5a71$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $cb9d97d4d61a5a71$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $cb9d97d4d61a5a71$var$SHA512_224 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(28);
        this.Ah = $cb9d97d4d61a5a71$var$T224_IV[0] | 0;
        this.Al = $cb9d97d4d61a5a71$var$T224_IV[1] | 0;
        this.Bh = $cb9d97d4d61a5a71$var$T224_IV[2] | 0;
        this.Bl = $cb9d97d4d61a5a71$var$T224_IV[3] | 0;
        this.Ch = $cb9d97d4d61a5a71$var$T224_IV[4] | 0;
        this.Cl = $cb9d97d4d61a5a71$var$T224_IV[5] | 0;
        this.Dh = $cb9d97d4d61a5a71$var$T224_IV[6] | 0;
        this.Dl = $cb9d97d4d61a5a71$var$T224_IV[7] | 0;
        this.Eh = $cb9d97d4d61a5a71$var$T224_IV[8] | 0;
        this.El = $cb9d97d4d61a5a71$var$T224_IV[9] | 0;
        this.Fh = $cb9d97d4d61a5a71$var$T224_IV[10] | 0;
        this.Fl = $cb9d97d4d61a5a71$var$T224_IV[11] | 0;
        this.Gh = $cb9d97d4d61a5a71$var$T224_IV[12] | 0;
        this.Gl = $cb9d97d4d61a5a71$var$T224_IV[13] | 0;
        this.Hh = $cb9d97d4d61a5a71$var$T224_IV[14] | 0;
        this.Hl = $cb9d97d4d61a5a71$var$T224_IV[15] | 0;
    }
}
module.exports.SHA512_224 = $cb9d97d4d61a5a71$var$SHA512_224;
class $cb9d97d4d61a5a71$var$SHA512_256 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(32);
        this.Ah = $cb9d97d4d61a5a71$var$T256_IV[0] | 0;
        this.Al = $cb9d97d4d61a5a71$var$T256_IV[1] | 0;
        this.Bh = $cb9d97d4d61a5a71$var$T256_IV[2] | 0;
        this.Bl = $cb9d97d4d61a5a71$var$T256_IV[3] | 0;
        this.Ch = $cb9d97d4d61a5a71$var$T256_IV[4] | 0;
        this.Cl = $cb9d97d4d61a5a71$var$T256_IV[5] | 0;
        this.Dh = $cb9d97d4d61a5a71$var$T256_IV[6] | 0;
        this.Dl = $cb9d97d4d61a5a71$var$T256_IV[7] | 0;
        this.Eh = $cb9d97d4d61a5a71$var$T256_IV[8] | 0;
        this.El = $cb9d97d4d61a5a71$var$T256_IV[9] | 0;
        this.Fh = $cb9d97d4d61a5a71$var$T256_IV[10] | 0;
        this.Fl = $cb9d97d4d61a5a71$var$T256_IV[11] | 0;
        this.Gh = $cb9d97d4d61a5a71$var$T256_IV[12] | 0;
        this.Gl = $cb9d97d4d61a5a71$var$T256_IV[13] | 0;
        this.Hh = $cb9d97d4d61a5a71$var$T256_IV[14] | 0;
        this.Hl = $cb9d97d4d61a5a71$var$T256_IV[15] | 0;
    }
}
module.exports.SHA512_256 = $cb9d97d4d61a5a71$var$SHA512_256;
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */ module.exports.sha256 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA256());
/** SHA2-224 hash function from RFC 4634 */ module.exports.sha224 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA224());
/** SHA2-512 hash function from RFC 4634. */ module.exports.sha512 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512());
/** SHA2-384 hash function from RFC 4634. */ module.exports.sha384 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA384());
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ module.exports.sha512_256 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512_256());
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ module.exports.sha512_224 = (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512_224());

});
parcelRegister("iYRTw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA512_IV = module.exports.SHA384_IV = module.exports.SHA224_IV = module.exports.SHA256_IV = module.exports.HashMD = void 0;
module.exports.setBigUint64 = $dd17a2ee919821c7$var$setBigUint64;
module.exports.Chi = $dd17a2ee919821c7$var$Chi;
module.exports.Maj = $dd17a2ee919821c7$var$Maj;

var $3Bcdj = parcelRequire("3Bcdj");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $dd17a2ee919821c7$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $dd17a2ee919821c7$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $dd17a2ee919821c7$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $dd17a2ee919821c7$var$HashMD extends $3Bcdj.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $3Bcdj.aexists)(this);
        data = (0, $3Bcdj.toBytes)(data);
        (0, $3Bcdj.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3Bcdj.aexists)(this);
        (0, $3Bcdj.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $3Bcdj.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dd17a2ee919821c7$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
module.exports.HashMD = $dd17a2ee919821c7$var$HashMD;
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */ /** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */ module.exports.SHA256_IV = Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */ module.exports.SHA224_IV = Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */ module.exports.SHA384_IV = Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */ module.exports.SHA512_IV = Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

});

parcelRegister("eDgKs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toBig = module.exports.shrSL = module.exports.shrSH = module.exports.rotrSL = module.exports.rotrSH = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotlBL = module.exports.rotlBH = module.exports.add5L = module.exports.add5H = module.exports.add4L = module.exports.add4H = module.exports.add3L = module.exports.add3H = void 0;
module.exports.add = $aa71b30d36adb919$var$add;
module.exports.fromBig = $aa71b30d36adb919$var$fromBig;
module.exports.split = $aa71b30d36adb919$var$split;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
function $aa71b30d36adb919$var$split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
module.exports.default = $aa71b30d36adb919$var$u64;

});


parcelRegister("3RPiR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unsafe = module.exports.aeskwp = module.exports.aeskw = module.exports.siv = module.exports.gcmsiv = module.exports.gcm = module.exports.cfb = module.exports.cbc = module.exports.ecb = module.exports.ctr = void 0;

var $8wowT = parcelRequire("8wowT");

var $38xio = parcelRequire("38xio");
const $2d0e1e19edfeea80$var$BLOCK_SIZE = 16;
const $2d0e1e19edfeea80$var$BLOCK_SIZE32 = 4;
const $2d0e1e19edfeea80$var$EMPTY_BLOCK = /* @__PURE__ */ new Uint8Array($2d0e1e19edfeea80$var$BLOCK_SIZE);
const $2d0e1e19edfeea80$var$POLY = 0x11b; // 1 + x + x**3 + x**4 + x**8
// TODO: remove multiplication, binary ops only
function $2d0e1e19edfeea80$var$mul2(n) {
    return n << 1 ^ $2d0e1e19edfeea80$var$POLY & -(n >> 7);
}
function $2d0e1e19edfeea80$var$mul(a, b) {
    let res = 0;
    for(; b > 0; b >>= 1){
        // Montgomery ladder
        res ^= a & -(b & 1); // if (b&1) res ^=a (but const-time).
        a = $2d0e1e19edfeea80$var$mul2(a); // a = 2*a
    }
    return res;
}
// AES S-box is generated using finite field inversion,
// an affine transform, and xor of a constant 0x63.
const $2d0e1e19edfeea80$var$sbox = /* @__PURE__ */ (()=>{
    const t = new Uint8Array(256);
    for(let i = 0, x = 1; i < 256; i++, x ^= $2d0e1e19edfeea80$var$mul2(x))t[i] = x;
    const box = new Uint8Array(256);
    box[0] = 0x63; // first elm
    for(let i = 0; i < 255; i++){
        let x = t[255 - i];
        x |= x << 8;
        box[t[i]] = (x ^ x >> 4 ^ x >> 5 ^ x >> 6 ^ x >> 7 ^ 0x63) & 0xff;
    }
    (0, $38xio.clean)(t);
    return box;
})();
// Inverted S-box
const $2d0e1e19edfeea80$var$invSbox = /* @__PURE__ */ $2d0e1e19edfeea80$var$sbox.map((_, j)=>$2d0e1e19edfeea80$var$sbox.indexOf(j));
// Rotate u32 by 8
const $2d0e1e19edfeea80$var$rotr32_8 = (n)=>n << 24 | n >>> 8;
const $2d0e1e19edfeea80$var$rotl32_8 = (n)=>n << 8 | n >>> 24;
// The byte swap operation for uint32 (LE<->BE)
const $2d0e1e19edfeea80$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
// T-table is optimization suggested in 5.2 of original proposal (missed from FIPS-197). Changes:
// - LE instead of BE
// - bigger tables: T0 and T1 are merged into T01 table and T2 & T3 into T23;
//   so index is u16, instead of u8. This speeds up things, unexpectedly
function $2d0e1e19edfeea80$var$genTtable(sbox, fn) {
    if (sbox.length !== 256) throw new Error('Wrong sbox length');
    const T0 = new Uint32Array(256).map((_, j)=>fn(sbox[j]));
    const T1 = T0.map($2d0e1e19edfeea80$var$rotl32_8);
    const T2 = T1.map($2d0e1e19edfeea80$var$rotl32_8);
    const T3 = T2.map($2d0e1e19edfeea80$var$rotl32_8);
    const T01 = new Uint32Array(65536);
    const T23 = new Uint32Array(65536);
    const sbox2 = new Uint16Array(65536);
    for(let i = 0; i < 256; i++)for(let j = 0; j < 256; j++){
        const idx = i * 256 + j;
        T01[idx] = T0[i] ^ T1[j];
        T23[idx] = T2[i] ^ T3[j];
        sbox2[idx] = sbox[i] << 8 | sbox[j];
    }
    return {
        sbox: sbox,
        sbox2: sbox2,
        T0: T0,
        T1: T1,
        T2: T2,
        T3: T3,
        T01: T01,
        T23: T23
    };
}
const $2d0e1e19edfeea80$var$tableEncoding = /* @__PURE__ */ $2d0e1e19edfeea80$var$genTtable($2d0e1e19edfeea80$var$sbox, (s)=>$2d0e1e19edfeea80$var$mul(s, 3) << 24 | s << 16 | s << 8 | $2d0e1e19edfeea80$var$mul(s, 2));
const $2d0e1e19edfeea80$var$tableDecoding = /* @__PURE__ */ $2d0e1e19edfeea80$var$genTtable($2d0e1e19edfeea80$var$invSbox, (s)=>$2d0e1e19edfeea80$var$mul(s, 11) << 24 | $2d0e1e19edfeea80$var$mul(s, 13) << 16 | $2d0e1e19edfeea80$var$mul(s, 9) << 8 | $2d0e1e19edfeea80$var$mul(s, 14));
const $2d0e1e19edfeea80$var$xPowers = /* @__PURE__ */ (()=>{
    const p = new Uint8Array(16);
    for(let i = 0, x = 1; i < 16; i++, x = $2d0e1e19edfeea80$var$mul2(x))p[i] = x;
    return p;
})();
/** Key expansion used in CTR. */ function $2d0e1e19edfeea80$var$expandKeyLE(key) {
    (0, $38xio.abytes)(key);
    const len = key.length;
    if (![
        16,
        24,
        32
    ].includes(len)) throw new Error('aes: invalid key size, should be 16, 24 or 32, got ' + len);
    const { sbox2: sbox2 } = $2d0e1e19edfeea80$var$tableEncoding;
    const toClean = [];
    if (!(0, $38xio.isAligned32)(key)) toClean.push(key = (0, $38xio.copyBytes)(key));
    const k32 = (0, $38xio.u32)(key);
    const Nk = k32.length;
    const subByte = (n)=>$2d0e1e19edfeea80$var$applySbox(sbox2, n, n, n, n);
    const xk = new Uint32Array(len + 28); // expanded key
    xk.set(k32);
    // 4.3.1 Key expansion
    for(let i = Nk; i < xk.length; i++){
        let t = xk[i - 1];
        if (i % Nk === 0) t = subByte($2d0e1e19edfeea80$var$rotr32_8(t)) ^ $2d0e1e19edfeea80$var$xPowers[i / Nk - 1];
        else if (Nk > 6 && i % Nk === 4) t = subByte(t);
        xk[i] = xk[i - Nk] ^ t;
    }
    (0, $38xio.clean)(...toClean);
    return xk;
}
function $2d0e1e19edfeea80$var$expandKeyDecLE(key) {
    const encKey = $2d0e1e19edfeea80$var$expandKeyLE(key);
    const xk = encKey.slice();
    const Nk = encKey.length;
    const { sbox2: sbox2 } = $2d0e1e19edfeea80$var$tableEncoding;
    const { T0: T0, T1: T1, T2: T2, T3: T3 } = $2d0e1e19edfeea80$var$tableDecoding;
    // Inverse key by chunks of 4 (rounds)
    for(let i = 0; i < Nk; i += 4)for(let j = 0; j < 4; j++)xk[i + j] = encKey[Nk - i - 4 + j];
    (0, $38xio.clean)(encKey);
    // apply InvMixColumn except first & last round
    for(let i = 4; i < Nk - 4; i++){
        const x = xk[i];
        const w = $2d0e1e19edfeea80$var$applySbox(sbox2, x, x, x, x);
        xk[i] = T0[w & 0xff] ^ T1[w >>> 8 & 0xff] ^ T2[w >>> 16 & 0xff] ^ T3[w >>> 24];
    }
    return xk;
}
// Apply tables
function $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s1, s2, s3) {
    return T01[s0 << 8 & 0xff00 | s1 >>> 8 & 0xff] ^ T23[s2 >>> 8 & 0xff00 | s3 >>> 24 & 0xff];
}
function $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s1, s2, s3) {
    return sbox2[s0 & 0xff | s1 & 0xff00] | sbox2[s2 >>> 16 & 0xff | s3 >>> 16 & 0xff00] << 16;
}
function $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2d0e1e19edfeea80$var$tableEncoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s1, s2, s3);
        const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s1, s2, s3, s0);
        const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s2, s3, s0, s1);
        const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s3, s0, s1, s2);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // last round (without mixcolumns, so using SBOX2 table)
    const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s1, s2, s3);
    const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s1, s2, s3, s0);
    const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s2, s3, s0, s1);
    const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s3, s0, s1, s2);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// Can't be merged with encrypt: arg positions for apply0123 / applySbox are different
function $2d0e1e19edfeea80$var$decrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2d0e1e19edfeea80$var$tableDecoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s3, s2, s1);
        const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s1, s0, s3, s2);
        const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s2, s1, s0, s3);
        const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s3, s2, s1, s0);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // Last round
    const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s3, s2, s1);
    const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s1, s0, s3, s2);
    const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s2, s1, s0, s3);
    const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s3, s2, s1, s0);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// TODO: investigate merging with ctr32
function $2d0e1e19edfeea80$var$ctrCounter(xk, nonce, src, dst) {
    (0, $38xio.abytes)(nonce, $2d0e1e19edfeea80$var$BLOCK_SIZE);
    (0, $38xio.abytes)(src);
    const srcLen = src.length;
    dst = (0, $38xio.getOutput)(srcLen, dst);
    (0, $38xio.complexOverlapBytes)(src, dst);
    const ctr = nonce;
    const c32 = (0, $38xio.u32)(ctr);
    // Fill block (empty, ctr=0)
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    const src32 = (0, $38xio.u32)(src);
    const dst32 = (0, $38xio.u32)(dst);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        // Full 128 bit counter with wrap around
        let carry = 1;
        for(let i = ctr.length - 1; i >= 0; i--){
            carry = carry + (ctr[i] & 0xff) | 0;
            ctr[i] = carry & 0xff;
            carry >>>= 8;
        }
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than block)
    // It's possible to handle > u32 fast, but is it worth it?
    const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $38xio.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $38xio.clean)(b32);
    }
    return dst;
}
// AES CTR with overflowing 32 bit counter
// It's possible to do 32le significantly simpler (and probably faster) by using u32.
// But, we need both, and perf bottleneck is in ghash anyway.
function $2d0e1e19edfeea80$var$ctr32(xk, isLE, nonce, src, dst) {
    (0, $38xio.abytes)(nonce, $2d0e1e19edfeea80$var$BLOCK_SIZE);
    (0, $38xio.abytes)(src);
    dst = (0, $38xio.getOutput)(src.length, dst);
    const ctr = nonce; // write new value to nonce, so it can be re-used
    const c32 = (0, $38xio.u32)(ctr);
    const view = (0, $38xio.createView)(ctr);
    const src32 = (0, $38xio.u32)(src);
    const dst32 = (0, $38xio.u32)(dst);
    const ctrPos = isLE ? 0 : 12;
    const srcLen = src.length;
    // Fill block (empty, ctr=0)
    let ctrNum = view.getUint32(ctrPos, isLE); // read current counter value
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        ctrNum = ctrNum + 1 >>> 0; // u32 wrap
        view.setUint32(ctrPos, ctrNum, isLE);
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than a block)
    const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $38xio.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $38xio.clean)(b32);
    }
    return dst;
}
/**
 * CTR: counter mode. Creates stream cipher.
 * Requires good IV. Parallelizable. OK, but no MAC.
 */ module.exports.ctr = (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aesctr(key, nonce) {
    function processCtr(buf, dst) {
        (0, $38xio.abytes)(buf);
        if (dst !== undefined) {
            (0, $38xio.abytes)(dst);
            if (!(0, $38xio.isAligned32)(dst)) throw new Error('unaligned destination');
        }
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const n = (0, $38xio.copyBytes)(nonce); // align + avoid changing
        const toClean = [
            xk,
            n
        ];
        if (!(0, $38xio.isAligned32)(buf)) toClean.push(buf = (0, $38xio.copyBytes)(buf));
        const out = $2d0e1e19edfeea80$var$ctrCounter(xk, n, buf, dst);
        (0, $38xio.clean)(...toClean);
        return out;
    }
    return {
        encrypt: (plaintext, dst)=>processCtr(plaintext, dst),
        decrypt: (ciphertext, dst)=>processCtr(ciphertext, dst)
    };
});
function $2d0e1e19edfeea80$var$validateBlockDecrypt(data) {
    (0, $38xio.abytes)(data);
    if (data.length % $2d0e1e19edfeea80$var$BLOCK_SIZE !== 0) throw new Error('aes-(cbc/ecb).decrypt ciphertext should consist of blocks with size ' + $2d0e1e19edfeea80$var$BLOCK_SIZE);
}
function $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst) {
    (0, $38xio.abytes)(plaintext);
    let outLen = plaintext.length;
    const remaining = outLen % $2d0e1e19edfeea80$var$BLOCK_SIZE;
    if (!pcks5 && remaining !== 0) throw new Error('aec/(cbc-ecb): unpadded plaintext with disabled padding');
    if (!(0, $38xio.isAligned32)(plaintext)) plaintext = (0, $38xio.copyBytes)(plaintext);
    const b = (0, $38xio.u32)(plaintext);
    if (pcks5) {
        let left = $2d0e1e19edfeea80$var$BLOCK_SIZE - remaining;
        if (!left) left = $2d0e1e19edfeea80$var$BLOCK_SIZE; // if no bytes left, create empty padding block
        outLen = outLen + left;
    }
    dst = (0, $38xio.getOutput)(outLen, dst);
    (0, $38xio.complexOverlapBytes)(plaintext, dst);
    const o = (0, $38xio.u32)(dst);
    return {
        b: b,
        o: o,
        out: dst
    };
}
function $2d0e1e19edfeea80$var$validatePCKS(data, pcks5) {
    if (!pcks5) return data;
    const len = data.length;
    if (!len) throw new Error('aes/pcks5: empty ciphertext not allowed');
    const lastByte = data[len - 1];
    if (lastByte <= 0 || lastByte > 16) throw new Error('aes/pcks5: wrong padding');
    const out = data.subarray(0, -lastByte);
    for(let i = 0; i < lastByte; i++)if (data[len - i - 1] !== lastByte) throw new Error('aes/pcks5: wrong padding');
    return out;
}
function $2d0e1e19edfeea80$var$padPCKS(left) {
    const tmp = new Uint8Array(16);
    const tmp32 = (0, $38xio.u32)(tmp);
    tmp.set(left);
    const paddingByte = $2d0e1e19edfeea80$var$BLOCK_SIZE - left.length;
    for(let i = $2d0e1e19edfeea80$var$BLOCK_SIZE - paddingByte; i < $2d0e1e19edfeea80$var$BLOCK_SIZE; i++)tmp[i] = paddingByte;
    return tmp32;
}
/**
 * ECB: Electronic CodeBook. Simple deterministic replacement.
 * Dangerous: always map x to y. See [AES Penguin](https://words.filippo.io/the-ecb-penguin/).
 */ module.exports.ecb = (0, $38xio.wrapCipher)({
    blockSize: 16
}, function aesecb(key, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const { b: b, o: o, out: _out } = $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst);
            const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
            let i = 0;
            for(; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2d0e1e19edfeea80$var$padPCKS(plaintext.subarray(i * 4));
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, tmp32[0], tmp32[1], tmp32[2], tmp32[3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $38xio.clean)(xk);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $2d0e1e19edfeea80$var$validateBlockDecrypt(ciphertext);
            const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(key);
            dst = (0, $38xio.getOutput)(ciphertext.length, dst);
            const toClean = [
                xk
            ];
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            (0, $38xio.complexOverlapBytes)(ciphertext, dst);
            const b = (0, $38xio.u32)(ciphertext);
            const o = (0, $38xio.u32)(dst);
            for(let i = 0; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $38xio.clean)(...toClean);
            return $2d0e1e19edfeea80$var$validatePCKS(dst, pcks5);
        }
    };
});
/**
 * CBC: Cipher-Block-Chaining. Key is previous round’s block.
 * Fragile: needs proper padding. Unauthenticated: needs MAC.
 */ module.exports.cbc = (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aescbc(key, iv, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
            const { b: b, o: o, out: _out } = $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $38xio.isAligned32)(_iv)) toClean.push(_iv = (0, $38xio.copyBytes)(_iv));
            const n32 = (0, $38xio.u32)(_iv);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            let i = 0;
            for(; i + 4 <= b.length;){
                s0 ^= b[i + 0], s1 ^= b[i + 1], s2 ^= b[i + 2], s3 ^= b[i + 3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2d0e1e19edfeea80$var$padPCKS(plaintext.subarray(i * 4));
                s0 ^= tmp32[0], s1 ^= tmp32[1], s2 ^= tmp32[2], s3 ^= tmp32[3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $38xio.clean)(...toClean);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $2d0e1e19edfeea80$var$validateBlockDecrypt(ciphertext);
            const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(key);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $38xio.isAligned32)(_iv)) toClean.push(_iv = (0, $38xio.copyBytes)(_iv));
            const n32 = (0, $38xio.u32)(_iv);
            dst = (0, $38xio.getOutput)(ciphertext.length, dst);
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            (0, $38xio.complexOverlapBytes)(ciphertext, dst);
            const b = (0, $38xio.u32)(ciphertext);
            const o = (0, $38xio.u32)(dst);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            for(let i = 0; i + 4 <= b.length;){
                // prettier-ignore
                const ps0 = s0, ps1 = s1, ps2 = s2, ps3 = s3;
                s0 = b[i + 0], s1 = b[i + 1], s2 = b[i + 2], s3 = b[i + 3];
                const { s0: o0, s1: o1, s2: o2, s3: o3 } = $2d0e1e19edfeea80$var$decrypt(xk, s0, s1, s2, s3);
                o[i++] = o0 ^ ps0, o[i++] = o1 ^ ps1, o[i++] = o2 ^ ps2, o[i++] = o3 ^ ps3;
            }
            (0, $38xio.clean)(...toClean);
            return $2d0e1e19edfeea80$var$validatePCKS(dst, pcks5);
        }
    };
});
/**
 * CFB: Cipher Feedback Mode. The input for the block cipher is the previous cipher output.
 * Unauthenticated: needs MAC.
 */ module.exports.cfb = (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aescfb(key, iv) {
    function processCfb(src, isEncrypt, dst) {
        (0, $38xio.abytes)(src);
        const srcLen = src.length;
        dst = (0, $38xio.getOutput)(srcLen, dst);
        if ((0, $38xio.overlapBytes)(src, dst)) throw new Error('overlapping src and dst not supported.');
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        let _iv = iv;
        const toClean = [
            xk
        ];
        if (!(0, $38xio.isAligned32)(_iv)) toClean.push(_iv = (0, $38xio.copyBytes)(_iv));
        if (!(0, $38xio.isAligned32)(src)) toClean.push(src = (0, $38xio.copyBytes)(src));
        const src32 = (0, $38xio.u32)(src);
        const dst32 = (0, $38xio.u32)(dst);
        const next32 = isEncrypt ? dst32 : src32;
        const n32 = (0, $38xio.u32)(_iv);
        // prettier-ignore
        let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
        for(let i = 0; i + 4 <= src32.length;){
            const { s0: e0, s1: e1, s2: e2, s3: e3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3);
            dst32[i + 0] = src32[i + 0] ^ e0;
            dst32[i + 1] = src32[i + 1] ^ e1;
            dst32[i + 2] = src32[i + 2] ^ e2;
            dst32[i + 3] = src32[i + 3] ^ e3;
            s0 = next32[i++], s1 = next32[i++], s2 = next32[i++], s3 = next32[i++];
        }
        // leftovers (less than block)
        const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
        if (start < srcLen) {
            ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
            const buf = (0, $38xio.u8)(new Uint32Array([
                s0,
                s1,
                s2,
                s3
            ]));
            for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
            (0, $38xio.clean)(buf);
        }
        (0, $38xio.clean)(...toClean);
        return dst;
    }
    return {
        encrypt: (plaintext, dst)=>processCfb(plaintext, true, dst),
        decrypt: (ciphertext, dst)=>processCfb(ciphertext, false, dst)
    };
});
// TODO: merge with chacha, however gcm has bitLen while chacha has byteLen
function $2d0e1e19edfeea80$var$computeTag(fn, isLE, key, data, AAD) {
    const aadLength = AAD ? AAD.length : 0;
    const h = fn.create(key, data.length + aadLength);
    if (AAD) h.update(AAD);
    const num = (0, $38xio.u64Lengths)(8 * data.length, 8 * aadLength, isLE);
    h.update(data);
    h.update(num);
    const res = h.digest();
    (0, $38xio.clean)(num);
    return res;
}
/**
 * GCM: Galois/Counter Mode.
 * Modern, parallel version of CTR, with MAC.
 * Be careful: MACs can be forged.
 * Unsafe to use random nonces under the same key, due to collision chance.
 * As for nonce size, prefer 12-byte, instead of 8-byte.
 */ module.exports.gcm = (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aesgcm(key, nonce, AAD) {
    // NIST 800-38d doesn't enforce minimum nonce length.
    // We enforce 8 bytes for compat with openssl.
    // 12 bytes are recommended. More than 12 bytes would be converted into 12.
    if (nonce.length < 8) throw new Error('aes/gcm: invalid nonce length');
    const tagLength = 16;
    function _computeTag(authKey, tagMask, data) {
        const tag = $2d0e1e19edfeea80$var$computeTag($8wowT.ghash, false, authKey, data, AAD);
        for(let i = 0; i < tagMask.length; i++)tag[i] ^= tagMask[i];
        return tag;
    }
    function deriveKeys() {
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const authKey = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
        const counter = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
        $2d0e1e19edfeea80$var$ctr32(xk, false, counter, counter, authKey);
        // NIST 800-38d, page 15: different behavior for 96-bit and non-96-bit nonces
        if (nonce.length === 12) counter.set(nonce);
        else {
            const nonceLen = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
            const view = (0, $38xio.createView)(nonceLen);
            (0, $38xio.setBigUint64)(view, 8, BigInt(nonce.length * 8), false);
            // ghash(nonce || u64be(0) || u64be(nonceLen*8))
            const g = $8wowT.ghash.create(authKey).update(nonce).update(nonceLen);
            g.digestInto(counter); // digestInto doesn't trigger '.destroy'
            g.destroy();
        }
        const tagMask = $2d0e1e19edfeea80$var$ctr32(xk, false, counter, $2d0e1e19edfeea80$var$EMPTY_BLOCK);
        return {
            xk: xk,
            authKey: authKey,
            counter: counter,
            tagMask: tagMask
        };
    }
    return {
        encrypt (plaintext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const out = new Uint8Array(plaintext.length + tagLength);
            const toClean = [
                xk,
                authKey,
                counter,
                tagMask
            ];
            if (!(0, $38xio.isAligned32)(plaintext)) toClean.push(plaintext = (0, $38xio.copyBytes)(plaintext));
            $2d0e1e19edfeea80$var$ctr32(xk, false, counter, plaintext, out.subarray(0, plaintext.length));
            const tag = _computeTag(authKey, tagMask, out.subarray(0, out.length - tagLength));
            toClean.push(tag);
            out.set(tag, plaintext.length);
            (0, $38xio.clean)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const toClean = [
                xk,
                authKey,
                tagMask,
                counter
            ];
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            const data = ciphertext.subarray(0, -tagLength);
            const passedTag = ciphertext.subarray(-tagLength);
            const tag = _computeTag(authKey, tagMask, data);
            toClean.push(tag);
            if (!(0, $38xio.equalBytes)(tag, passedTag)) throw new Error('aes/gcm: invalid ghash tag');
            const out = $2d0e1e19edfeea80$var$ctr32(xk, false, counter, data);
            (0, $38xio.clean)(...toClean);
            return out;
        }
    };
});
const $2d0e1e19edfeea80$var$limit = (name, min, max)=>(value)=>{
        if (!Number.isSafeInteger(value) || min > value || value > max) {
            const minmax = '[' + min + '..' + max + ']';
            throw new Error('' + name + ': expected value in range ' + minmax + ', got ' + value);
        }
    };
/**
 * AES-GCM-SIV: classic AES-GCM with nonce-misuse resistance.
 * Guarantees that, when a nonce is repeated, the only security loss is that identical
 * plaintexts will produce identical ciphertexts.
 * RFC 8452, https://datatracker.ietf.org/doc/html/rfc8452
 */ module.exports.gcmsiv = (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aessiv(key, nonce, AAD) {
    const tagLength = 16;
    // From RFC 8452: Section 6
    const AAD_LIMIT = $2d0e1e19edfeea80$var$limit('AAD', 0, 2 ** 36);
    const PLAIN_LIMIT = $2d0e1e19edfeea80$var$limit('plaintext', 0, 2 ** 36);
    const NONCE_LIMIT = $2d0e1e19edfeea80$var$limit('nonce', 12, 12);
    const CIPHER_LIMIT = $2d0e1e19edfeea80$var$limit('ciphertext', 16, 2 ** 36 + 16);
    (0, $38xio.abytes)(key, 16, 24, 32);
    NONCE_LIMIT(nonce.length);
    if (AAD !== undefined) AAD_LIMIT(AAD.length);
    function deriveKeys() {
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const encKey = new Uint8Array(key.length);
        const authKey = new Uint8Array(16);
        const toClean = [
            xk,
            encKey
        ];
        let _nonce = nonce;
        if (!(0, $38xio.isAligned32)(_nonce)) toClean.push(_nonce = (0, $38xio.copyBytes)(_nonce));
        const n32 = (0, $38xio.u32)(_nonce);
        // prettier-ignore
        let s0 = 0, s1 = n32[0], s2 = n32[1], s3 = n32[2];
        let counter = 0;
        for (const derivedKey of [
            authKey,
            encKey
        ].map($38xio.u32)){
            const d32 = (0, $38xio.u32)(derivedKey);
            for(let i = 0; i < d32.length; i += 2){
                // aes(u32le(0) || nonce)[:8] || aes(u32le(1) || nonce)[:8] ...
                const { s0: o0, s1: o1 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3);
                d32[i + 0] = o0;
                d32[i + 1] = o1;
                s0 = ++counter; // increment counter inside state
            }
        }
        const res = {
            authKey: authKey,
            encKey: $2d0e1e19edfeea80$var$expandKeyLE(encKey)
        };
        // Cleanup
        (0, $38xio.clean)(...toClean);
        return res;
    }
    function _computeTag(encKey, authKey, data) {
        const tag = $2d0e1e19edfeea80$var$computeTag($8wowT.polyval, true, authKey, data, AAD);
        // Compute the expected tag by XORing S_s and the nonce, clearing the
        // most significant bit of the last byte and encrypting with the
        // message-encryption key.
        for(let i = 0; i < 12; i++)tag[i] ^= nonce[i];
        tag[15] &= 0x7f; // Clear the highest bit
        // encrypt tag as block
        const t32 = (0, $38xio.u32)(tag);
        // prettier-ignore
        let s0 = t32[0], s1 = t32[1], s2 = t32[2], s3 = t32[3];
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(encKey, s0, s1, s2, s3));
        t32[0] = s0, t32[1] = s1, t32[2] = s2, t32[3] = s3;
        return tag;
    }
    // actual decrypt/encrypt of message.
    function processSiv(encKey, tag, input) {
        let block = (0, $38xio.copyBytes)(tag);
        block[15] |= 0x80; // Force highest bit
        const res = $2d0e1e19edfeea80$var$ctr32(encKey, true, block, input);
        // Cleanup
        (0, $38xio.clean)(block);
        return res;
    }
    return {
        encrypt (plaintext) {
            PLAIN_LIMIT(plaintext.length);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const tag = _computeTag(encKey, authKey, plaintext);
            const toClean = [
                encKey,
                authKey,
                tag
            ];
            if (!(0, $38xio.isAligned32)(plaintext)) toClean.push(plaintext = (0, $38xio.copyBytes)(plaintext));
            const out = new Uint8Array(plaintext.length + tagLength);
            out.set(tag, plaintext.length);
            out.set(processSiv(encKey, tag, plaintext));
            // Cleanup
            (0, $38xio.clean)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            CIPHER_LIMIT(ciphertext.length);
            const tag = ciphertext.subarray(-tagLength);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const toClean = [
                encKey,
                authKey
            ];
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            const plaintext = processSiv(encKey, tag, ciphertext.subarray(0, -tagLength));
            const expectedTag = _computeTag(encKey, authKey, plaintext);
            toClean.push(expectedTag);
            if (!(0, $38xio.equalBytes)(tag, expectedTag)) {
                (0, $38xio.clean)(...toClean);
                throw new Error('invalid polyval tag');
            }
            // Cleanup
            (0, $38xio.clean)(...toClean);
            return plaintext;
        }
    };
});
/**
 * AES-GCM-SIV, not AES-SIV.
 * This is legace name, use `gcmsiv` export instead.
 * @deprecated
 */ module.exports.siv = module.exports.gcmsiv;
function $2d0e1e19edfeea80$var$isBytes32(a) {
    return a instanceof Uint32Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint32Array';
}
function $2d0e1e19edfeea80$var$encryptBlock(xk, block) {
    (0, $38xio.abytes)(block, 16);
    if (!$2d0e1e19edfeea80$var$isBytes32(xk)) throw new Error('_encryptBlock accepts result of expandKeyLE');
    const b32 = (0, $38xio.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
function $2d0e1e19edfeea80$var$decryptBlock(xk, block) {
    (0, $38xio.abytes)(block, 16);
    if (!$2d0e1e19edfeea80$var$isBytes32(xk)) throw new Error('_decryptBlock accepts result of expandKeyLE');
    const b32 = (0, $38xio.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
/**
 * AES-W (base for AESKW/AESKWP).
 * Specs: [SP800-38F](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-38F.pdf),
 * [RFC 3394](https://datatracker.ietf.org/doc/rfc3394/),
 * [RFC 5649](https://datatracker.ietf.org/doc/rfc5649/).
 */ const $2d0e1e19edfeea80$var$AESW = {
    /*
    High-level pseudocode:
    ```
    A: u64 = IV
    out = []
    for (let i=0, ctr = 0; i<6; i++) {
      for (const chunk of chunks(plaintext, 8)) {
        A ^= swapEndianess(ctr++)
        [A, res] = chunks(encrypt(A || chunk), 8);
        out ||= res
      }
    }
    out = A || out
    ```
    Decrypt is the same, but reversed.
    */ encrypt (kek, out) {
        // Size is limited to 4GB, otherwise ctr will overflow and we'll need to switch to bigints.
        // If you need it larger, open an issue.
        if (out.length >= 2 ** 32) throw new Error('plaintext should be less than 4gb');
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(kek);
        if (out.length === 16) $2d0e1e19edfeea80$var$encryptBlock(xk, out);
        else {
            const o32 = (0, $38xio.u32)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = 1; j < 6; j++)for(let pos = 2; pos < o32.length; pos += 2, ctr++){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                // A = MSB(64, B) ^ t where t = (n*j)+i
                a0 = s0, a1 = s1 ^ $2d0e1e19edfeea80$var$byteSwap(ctr), o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1; // out = A || out
        }
        xk.fill(0);
    },
    decrypt (kek, out) {
        if (out.length - 8 >= 2 ** 32) throw new Error('ciphertext should be less than 4gb');
        const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(kek);
        const chunks = out.length / 8 - 1; // first chunk is IV
        if (chunks === 1) $2d0e1e19edfeea80$var$decryptBlock(xk, out);
        else {
            const o32 = (0, $38xio.u32)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = chunks * 6; j < 6; j++)for(let pos = chunks * 2; pos >= 1; pos -= 2, ctr--){
                a1 ^= $2d0e1e19edfeea80$var$byteSwap(ctr);
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                a0 = s0, a1 = s1, o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1;
        }
        xk.fill(0);
    }
};
const $2d0e1e19edfeea80$var$AESKW_IV = /* @__PURE__ */ new Uint8Array(8).fill(0xa6); // A6A6A6A6A6A6A6A6
/**
 * AES-KW (key-wrap). Injects static IV into plaintext, adds counter, encrypts 6 times.
 * Reduces block size from 16 to 8 bytes.
 * For padded version, use aeskwp.
 * [RFC 3394](https://datatracker.ietf.org/doc/rfc3394/),
 * [NIST.SP.800-38F](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-38F.pdf).
 */ module.exports.aeskw = (0, $38xio.wrapCipher)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length || plaintext.length % 8 !== 0) throw new Error('invalid plaintext length');
            if (plaintext.length === 8) throw new Error('8-byte keys not allowed in AESKW, use AESKWP instead');
            const out = (0, $38xio.concatBytes)($2d0e1e19edfeea80$var$AESKW_IV, plaintext);
            $2d0e1e19edfeea80$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // ciphertext must be at least 24 bytes and a multiple of 8 bytes
            // 24 because should have at least two block (1 iv + 2).
            // Replace with 16 to enable '8-byte keys'
            if (ciphertext.length % 8 !== 0 || ciphertext.length < 24) throw new Error('invalid ciphertext length');
            const out = (0, $38xio.copyBytes)(ciphertext);
            $2d0e1e19edfeea80$var$AESW.decrypt(kek, out);
            if (!(0, $38xio.equalBytes)(out.subarray(0, 8), $2d0e1e19edfeea80$var$AESKW_IV)) throw new Error('integrity check failed');
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8);
        }
    }));
/*
We don't support 8-byte keys. The rabbit hole:

- Wycheproof says: "NIST SP 800-38F does not define the wrapping of 8 byte keys.
  RFC 3394 Section 2  on the other hand specifies that 8 byte keys are wrapped
  by directly encrypting one block with AES."
    - https://github.com/C2SP/wycheproof/blob/master/doc/key_wrap.md
    - "RFC 3394 specifies in Section 2, that the input for the key wrap
      algorithm must be at least two blocks and otherwise the constant
      field and key are simply encrypted with ECB as a single block"
- What RFC 3394 actually says (in Section 2):
    - "Before being wrapped, the key data is parsed into n blocks of 64 bits.
      The only restriction the key wrap algorithm places on n is that n be
      at least two"
    - "For key data with length less than or equal to 64 bits, the constant
      field used in this specification and the key data form a single
      128-bit codebook input making this key wrap unnecessary."
- Which means "assert(n >= 2)" and "use something else for 8 byte keys"
- NIST SP800-38F actually prohibits 8-byte in "5.3.1 Mandatory Limits".
  It states that plaintext for KW should be "2 to 2^54 -1 semiblocks".
- So, where does "directly encrypt single block with AES" come from?
    - Not RFC 3394. Pseudocode of key wrap in 2.2 explicitly uses
      loop of 6 for any code path
    - There is a weird W3C spec:
      https://www.w3.org/TR/2002/REC-xmlenc-core-20021210/Overview.html#kw-aes128
    - This spec is outdated, as admitted by Wycheproof authors
    - There is RFC 5649 for padded key wrap, which is padding construction on
      top of AESKW. In '4.1.2' it says: "If the padded plaintext contains exactly
      eight octets, then prepend the AIV as defined in Section 3 above to P[1] and
      encrypt the resulting 128-bit block using AES in ECB mode [Modes] with key
      K (the KEK).  In this case, the output is two 64-bit blocks C[0] and C[1]:"
    - Browser subtle crypto is actually crashes on wrapping keys less than 16 bytes:
      `Error: error:1C8000E6:Provider routines::invalid input length] { opensslErrorStack: [ 'error:030000BD:digital envelope routines::update error' ]`

In the end, seems like a bug in Wycheproof.
The 8-byte check can be easily disabled inside of AES_W.
*/ const $2d0e1e19edfeea80$var$AESKWP_IV = 0xa65959a6; // single u32le value
/**
 * AES-KW, but with padding and allows random keys.
 * Second u32 of IV is used as counter for length.
 * [RFC 5649](https://www.rfc-editor.org/rfc/rfc5649)
 */ module.exports.aeskwp = (0, $38xio.wrapCipher)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length) throw new Error('invalid plaintext length');
            const padded = Math.ceil(plaintext.length / 8) * 8;
            const out = new Uint8Array(8 + padded);
            out.set(plaintext, 8);
            const out32 = (0, $38xio.u32)(out);
            out32[0] = $2d0e1e19edfeea80$var$AESKWP_IV;
            out32[1] = $2d0e1e19edfeea80$var$byteSwap(plaintext.length);
            $2d0e1e19edfeea80$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // 16 because should have at least one block
            if (ciphertext.length < 16) throw new Error('invalid ciphertext length');
            const out = (0, $38xio.copyBytes)(ciphertext);
            const o32 = (0, $38xio.u32)(out);
            $2d0e1e19edfeea80$var$AESW.decrypt(kek, out);
            const len = $2d0e1e19edfeea80$var$byteSwap(o32[1]) >>> 0;
            const padded = Math.ceil(len / 8) * 8;
            if (o32[0] !== $2d0e1e19edfeea80$var$AESKWP_IV || out.length - 8 !== padded) throw new Error('integrity check failed');
            for(let i = len; i < padded; i++)if (out[8 + i] !== 0) throw new Error('integrity check failed');
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8, 8 + len);
        }
    }));
/** Unsafe low-level internal methods. May change at any time. */ module.exports.unsafe = {
    expandKeyLE: $2d0e1e19edfeea80$var$expandKeyLE,
    expandKeyDecLE: $2d0e1e19edfeea80$var$expandKeyDecLE,
    encrypt: $2d0e1e19edfeea80$var$encrypt,
    decrypt: $2d0e1e19edfeea80$var$decrypt,
    encryptBlock: $2d0e1e19edfeea80$var$encryptBlock,
    decryptBlock: $2d0e1e19edfeea80$var$decryptBlock,
    ctrCounter: $2d0e1e19edfeea80$var$ctrCounter,
    ctr32: $2d0e1e19edfeea80$var$ctr32
};

});
parcelRegister("8wowT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.polyval = module.exports.ghash = void 0;
module.exports._toGHASHKey = $634456ee3058786c$var$_toGHASHKey;

var $38xio = parcelRequire("38xio");
const $634456ee3058786c$var$BLOCK_SIZE = 16;
// TODO: rewrite
// temporary padding buffer
const $634456ee3058786c$var$ZEROS16 = /* @__PURE__ */ new Uint8Array(16);
const $634456ee3058786c$var$ZEROS32 = (0, $38xio.u32)($634456ee3058786c$var$ZEROS16);
const $634456ee3058786c$var$POLY = 0xe1; // v = 2*v % POLY
// v = 2*v % POLY
// NOTE: because x + x = 0 (add/sub is same), mul2(x) != x+x
// We can multiply any number using montgomery ladder and this function (works as double, add is simple xor)
const $634456ee3058786c$var$mul2 = (s0, s1, s2, s3)=>{
    const hiBit = s3 & 1;
    return {
        s3: s2 << 31 | s3 >>> 1,
        s2: s1 << 31 | s2 >>> 1,
        s1: s0 << 31 | s1 >>> 1,
        s0: s0 >>> 1 ^ $634456ee3058786c$var$POLY << 24 & -(hiBit & 1)
    };
};
const $634456ee3058786c$var$swapLE = (n)=>(n >>> 0 & 0xff) << 24 | (n >>> 8 & 0xff) << 16 | (n >>> 16 & 0xff) << 8 | n >>> 24 & 0xff | 0;
/**
 * `mulX_POLYVAL(ByteReverse(H))` from spec
 * @param k mutated in place
 */ function $634456ee3058786c$var$_toGHASHKey(k) {
    k.reverse();
    const hiBit = k[15] & 1;
    // k >>= 1
    let carry = 0;
    for(let i = 0; i < k.length; i++){
        const t = k[i];
        k[i] = t >>> 1 | carry;
        carry = (t & 1) << 7;
    }
    k[0] ^= -hiBit & 0xe1; // if (hiBit) n ^= 0xe1000000000000000000000000000000;
    return k;
}
const $634456ee3058786c$var$estimateWindow = (bytes)=>{
    if (bytes > 65536) return 8;
    if (bytes > 1024) return 4;
    return 2;
};
class $634456ee3058786c$var$GHASH {
    // We select bits per window adaptively based on expectedLength
    constructor(key, expectedLength){
        this.blockLen = $634456ee3058786c$var$BLOCK_SIZE;
        this.outputLen = $634456ee3058786c$var$BLOCK_SIZE;
        this.s0 = 0;
        this.s1 = 0;
        this.s2 = 0;
        this.s3 = 0;
        this.finished = false;
        key = (0, $38xio.toBytes)(key);
        (0, $38xio.abytes)(key, 16);
        const kView = (0, $38xio.createView)(key);
        let k0 = kView.getUint32(0, false);
        let k1 = kView.getUint32(4, false);
        let k2 = kView.getUint32(8, false);
        let k3 = kView.getUint32(12, false);
        // generate table of doubled keys (half of montgomery ladder)
        const doubles = [];
        for(let i = 0; i < 128; i++){
            doubles.push({
                s0: $634456ee3058786c$var$swapLE(k0),
                s1: $634456ee3058786c$var$swapLE(k1),
                s2: $634456ee3058786c$var$swapLE(k2),
                s3: $634456ee3058786c$var$swapLE(k3)
            });
            ({ s0: k0, s1: k1, s2: k2, s3: k3 } = $634456ee3058786c$var$mul2(k0, k1, k2, k3));
        }
        const W = $634456ee3058786c$var$estimateWindow(expectedLength || 1024);
        if (![
            1,
            2,
            4,
            8
        ].includes(W)) throw new Error('ghash: invalid window size, expected 2, 4 or 8');
        this.W = W;
        const bits = 128; // always 128 bits;
        const windows = bits / W;
        const windowSize = this.windowSize = 2 ** W;
        const items = [];
        // Create precompute table for window of W bits
        for(let w = 0; w < windows; w++)// truth table: 00, 01, 10, 11
        for(let byte = 0; byte < windowSize; byte++){
            // prettier-ignore
            let s0 = 0, s1 = 0, s2 = 0, s3 = 0;
            for(let j = 0; j < W; j++){
                const bit = byte >>> W - j - 1 & 1;
                if (!bit) continue;
                const { s0: d0, s1: d1, s2: d2, s3: d3 } = doubles[W * w + j];
                s0 ^= d0, s1 ^= d1, s2 ^= d2, s3 ^= d3;
            }
            items.push({
                s0: s0,
                s1: s1,
                s2: s2,
                s3: s3
            });
        }
        this.t = items;
    }
    _updateBlock(s0, s1, s2, s3) {
        s0 ^= this.s0, s1 ^= this.s1, s2 ^= this.s2, s3 ^= this.s3;
        const { W: W, t: t, windowSize: windowSize } = this;
        // prettier-ignore
        let o0 = 0, o1 = 0, o2 = 0, o3 = 0;
        const mask = (1 << W) - 1; // 2**W will kill performance.
        let w = 0;
        for (const num of [
            s0,
            s1,
            s2,
            s3
        ])for(let bytePos = 0; bytePos < 4; bytePos++){
            const byte = num >>> 8 * bytePos & 0xff;
            for(let bitPos = 8 / W - 1; bitPos >= 0; bitPos--){
                const bit = byte >>> W * bitPos & mask;
                const { s0: e0, s1: e1, s2: e2, s3: e3 } = t[w * windowSize + bit];
                o0 ^= e0, o1 ^= e1, o2 ^= e2, o3 ^= e3;
                w += 1;
            }
        }
        this.s0 = o0;
        this.s1 = o1;
        this.s2 = o2;
        this.s3 = o3;
    }
    update(data) {
        (0, $38xio.aexists)(this);
        data = (0, $38xio.toBytes)(data);
        (0, $38xio.abytes)(data);
        const b32 = (0, $38xio.u32)(data);
        const blocks = Math.floor(data.length / $634456ee3058786c$var$BLOCK_SIZE);
        const left = data.length % $634456ee3058786c$var$BLOCK_SIZE;
        for(let i = 0; i < blocks; i++)this._updateBlock(b32[i * 4 + 0], b32[i * 4 + 1], b32[i * 4 + 2], b32[i * 4 + 3]);
        if (left) {
            $634456ee3058786c$var$ZEROS16.set(data.subarray(blocks * $634456ee3058786c$var$BLOCK_SIZE));
            this._updateBlock($634456ee3058786c$var$ZEROS32[0], $634456ee3058786c$var$ZEROS32[1], $634456ee3058786c$var$ZEROS32[2], $634456ee3058786c$var$ZEROS32[3]);
            (0, $38xio.clean)($634456ee3058786c$var$ZEROS32); // clean tmp buffer
        }
        return this;
    }
    destroy() {
        const { t: t } = this;
        // clean precompute table
        for (const elm of t)elm.s0 = 0, elm.s1 = 0, elm.s2 = 0, elm.s3 = 0;
    }
    digestInto(out) {
        (0, $38xio.aexists)(this);
        (0, $38xio.aoutput)(out, this);
        this.finished = true;
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $38xio.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out;
    }
    digest() {
        const res = new Uint8Array($634456ee3058786c$var$BLOCK_SIZE);
        this.digestInto(res);
        this.destroy();
        return res;
    }
}
class $634456ee3058786c$var$Polyval extends $634456ee3058786c$var$GHASH {
    constructor(key, expectedLength){
        key = (0, $38xio.toBytes)(key);
        (0, $38xio.abytes)(key);
        const ghKey = $634456ee3058786c$var$_toGHASHKey((0, $38xio.copyBytes)(key));
        super(ghKey, expectedLength);
        (0, $38xio.clean)(ghKey);
    }
    update(data) {
        data = (0, $38xio.toBytes)(data);
        (0, $38xio.aexists)(this);
        const b32 = (0, $38xio.u32)(data);
        const left = data.length % $634456ee3058786c$var$BLOCK_SIZE;
        const blocks = Math.floor(data.length / $634456ee3058786c$var$BLOCK_SIZE);
        for(let i = 0; i < blocks; i++)this._updateBlock($634456ee3058786c$var$swapLE(b32[i * 4 + 3]), $634456ee3058786c$var$swapLE(b32[i * 4 + 2]), $634456ee3058786c$var$swapLE(b32[i * 4 + 1]), $634456ee3058786c$var$swapLE(b32[i * 4 + 0]));
        if (left) {
            $634456ee3058786c$var$ZEROS16.set(data.subarray(blocks * $634456ee3058786c$var$BLOCK_SIZE));
            this._updateBlock($634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[3]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[2]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[1]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[0]));
            (0, $38xio.clean)($634456ee3058786c$var$ZEROS32);
        }
        return this;
    }
    digestInto(out) {
        (0, $38xio.aexists)(this);
        (0, $38xio.aoutput)(out, this);
        this.finished = true;
        // tmp ugly hack
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $38xio.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out.reverse();
    }
}
function $634456ee3058786c$var$wrapConstructorWithKey(hashCons) {
    const hashC = (msg, key)=>hashCons(key, msg.length).update((0, $38xio.toBytes)(msg)).digest();
    const tmp = hashCons(new Uint8Array(16), 0);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (key, expectedLength)=>hashCons(key, expectedLength);
    return hashC;
}
/** GHash MAC for AES-GCM. */ module.exports.ghash = $634456ee3058786c$var$wrapConstructorWithKey((key, expectedLength)=>new $634456ee3058786c$var$GHASH(key, expectedLength));
/** Polyval MAC for AES-SIV. */ module.exports.polyval = $634456ee3058786c$var$wrapConstructorWithKey((key, expectedLength)=>new $634456ee3058786c$var$Polyval(key, expectedLength));

});
parcelRegister("38xio", function(module, exports) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapCipher = module.exports.Hash = module.exports.nextTick = module.exports.isLE = void 0;
module.exports.isBytes = $248bf24903c02b9f$var$isBytes;
module.exports.abool = $248bf24903c02b9f$var$abool;
module.exports.anumber = $248bf24903c02b9f$var$anumber;
module.exports.abytes = $248bf24903c02b9f$var$abytes;
module.exports.ahash = $248bf24903c02b9f$var$ahash;
module.exports.aexists = $248bf24903c02b9f$var$aexists;
module.exports.aoutput = $248bf24903c02b9f$var$aoutput;
module.exports.u8 = $248bf24903c02b9f$var$u8;
module.exports.u32 = $248bf24903c02b9f$var$u32;
module.exports.clean = $248bf24903c02b9f$var$clean;
module.exports.createView = $248bf24903c02b9f$var$createView;
module.exports.bytesToHex = $248bf24903c02b9f$var$bytesToHex;
module.exports.hexToBytes = $248bf24903c02b9f$var$hexToBytes;
module.exports.hexToNumber = $248bf24903c02b9f$var$hexToNumber;
module.exports.bytesToNumberBE = $248bf24903c02b9f$var$bytesToNumberBE;
module.exports.numberToBytesBE = $248bf24903c02b9f$var$numberToBytesBE;
module.exports.utf8ToBytes = $248bf24903c02b9f$var$utf8ToBytes;
module.exports.bytesToUtf8 = $248bf24903c02b9f$var$bytesToUtf8;
module.exports.toBytes = $248bf24903c02b9f$var$toBytes;
module.exports.overlapBytes = $248bf24903c02b9f$var$overlapBytes;
module.exports.complexOverlapBytes = $248bf24903c02b9f$var$complexOverlapBytes;
module.exports.concatBytes = $248bf24903c02b9f$var$concatBytes;
module.exports.checkOpts = $248bf24903c02b9f$var$checkOpts;
module.exports.equalBytes = $248bf24903c02b9f$var$equalBytes;
module.exports.getOutput = $248bf24903c02b9f$var$getOutput;
module.exports.setBigUint64 = $248bf24903c02b9f$var$setBigUint64;
module.exports.u64Lengths = $248bf24903c02b9f$var$u64Lengths;
module.exports.isAligned32 = $248bf24903c02b9f$var$isAligned32;
module.exports.copyBytes = $248bf24903c02b9f$var$copyBytes;
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $248bf24903c02b9f$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is boolean. */ function $248bf24903c02b9f$var$abool(b) {
    if (typeof b !== 'boolean') throw new Error(`boolean expected, not ${b}`);
}
/** Asserts something is positive integer. */ function $248bf24903c02b9f$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */ function $248bf24903c02b9f$var$abytes(b, ...lengths) {
    if (!$248bf24903c02b9f$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/**
 * Asserts something is hash
 * TODO: remove
 * @deprecated
 */ function $248bf24903c02b9f$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $248bf24903c02b9f$var$anumber(h.outputLen);
    $248bf24903c02b9f$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $248bf24903c02b9f$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function $248bf24903c02b9f$var$aoutput(out, instance) {
    $248bf24903c02b9f$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
/** Cast u8 / u16 / u32 to u8. */ function $248bf24903c02b9f$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */ function $248bf24903c02b9f$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */ function $248bf24903c02b9f$var$clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
/** Create DataView of an array for easy byte-level manipulation. */ function $248bf24903c02b9f$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ module.exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $248bf24903c02b9f$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $248bf24903c02b9f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $248bf24903c02b9f$var$bytesToHex(bytes) {
    $248bf24903c02b9f$var$abytes(bytes);
    // @ts-ignore
    if ($248bf24903c02b9f$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $248bf24903c02b9f$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $248bf24903c02b9f$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $248bf24903c02b9f$var$asciiToBase16(ch) {
    if (ch >= $248bf24903c02b9f$var$asciis._0 && ch <= $248bf24903c02b9f$var$asciis._9) return ch - $248bf24903c02b9f$var$asciis._0; // '2' => 50-48
    if (ch >= $248bf24903c02b9f$var$asciis.A && ch <= $248bf24903c02b9f$var$asciis.F) return ch - ($248bf24903c02b9f$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $248bf24903c02b9f$var$asciis.a && ch <= $248bf24903c02b9f$var$asciis.f) return ch - ($248bf24903c02b9f$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $248bf24903c02b9f$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($248bf24903c02b9f$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $248bf24903c02b9f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $248bf24903c02b9f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// Used in micro
function $248bf24903c02b9f$var$hexToNumber(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return BigInt(hex === '' ? '0' : '0x' + hex); // Big Endian
}
// Used in ff1
// BE: Big Endian, LE: Little Endian
function $248bf24903c02b9f$var$bytesToNumberBE(bytes) {
    return $248bf24903c02b9f$var$hexToNumber($248bf24903c02b9f$var$bytesToHex(bytes));
}
// Used in micro, ff1
function $248bf24903c02b9f$var$numberToBytesBE(n, len) {
    return $248bf24903c02b9f$var$hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
// TODO: remove
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $248bf24903c02b9f$var$nextTick = async ()=>{};
module.exports.nextTick = $248bf24903c02b9f$var$nextTick;
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $248bf24903c02b9f$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(new Uint8Array([97, 98, 99])) // 'abc'
 */ function $248bf24903c02b9f$var$bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $248bf24903c02b9f$var$toBytes(data) {
    if (typeof data === 'string') data = $248bf24903c02b9f$var$utf8ToBytes(data);
    else if ($248bf24903c02b9f$var$isBytes(data)) data = $248bf24903c02b9f$var$copyBytes(data);
    else throw new Error('Uint8Array expected, got ' + typeof data);
    return data;
}
/**
 * Checks if two U8A use same underlying buffer and overlaps.
 * This is invalid and can corrupt data.
 */ function $248bf24903c02b9f$var$overlapBytes(a, b) {
    return a.buffer === b.buffer && // best we can do, may fail with an obscure Proxy
    a.byteOffset < b.byteOffset + b.byteLength && // a starts before b end
    b.byteOffset < a.byteOffset + a.byteLength // b starts before a end
    ;
}
/**
 * If input and output overlap and input starts before output, we will overwrite end of input before
 * we start processing it, so this is not supported for most ciphers (except chacha/salse, which designed with this)
 */ function $248bf24903c02b9f$var$complexOverlapBytes(input, output) {
    // This is very cursed. It works somehow, but I'm completely unsure,
    // reasoning about overlapping aligned windows is very hard.
    if ($248bf24903c02b9f$var$overlapBytes(input, output) && input.byteOffset < output.byteOffset) throw new Error('complex overlap of input and output is not supported');
}
/**
 * Copies several Uint8Arrays into one.
 */ function $248bf24903c02b9f$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $248bf24903c02b9f$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $248bf24903c02b9f$var$checkOpts(defaults, opts) {
    if (opts == null || typeof opts !== 'object') throw new Error('options must be defined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** Compares 2 uint8array-s in kinda constant time. */ function $248bf24903c02b9f$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
// TODO: remove
/** For runtime check if class implements interface. */ class $248bf24903c02b9f$var$Hash {
}
module.exports.Hash = $248bf24903c02b9f$var$Hash;
/**
 * Wraps a cipher: validates args, ensures encrypt() can only be called once.
 * @__NO_SIDE_EFFECTS__
 */ const $248bf24903c02b9f$var$wrapCipher = (params, constructor)=>{
    function wrappedCipher(key, ...args) {
        // Validate key
        $248bf24903c02b9f$var$abytes(key);
        // Big-Endian hardware is rare. Just in case someone still decides to run ciphers:
        if (!module.exports.isLE) throw new Error('Non little-endian hardware is not yet supported');
        // Validate nonce if nonceLength is present
        if (params.nonceLength !== undefined) {
            const nonce = args[0];
            if (!nonce) throw new Error('nonce / iv required');
            if (params.varSizeNonce) $248bf24903c02b9f$var$abytes(nonce);
            else $248bf24903c02b9f$var$abytes(nonce, params.nonceLength);
        }
        // Validate AAD if tagLength present
        const tagl = params.tagLength;
        if (tagl && args[1] !== undefined) $248bf24903c02b9f$var$abytes(args[1]);
        const cipher = constructor(key, ...args);
        const checkOutput = (fnLength, output)=>{
            if (output !== undefined) {
                if (fnLength !== 2) throw new Error('cipher output not supported');
                $248bf24903c02b9f$var$abytes(output);
            }
        };
        // Create wrapped cipher with validation and single-use encryption
        let called = false;
        const wrCipher = {
            encrypt (data, output) {
                if (called) throw new Error('cannot encrypt() twice with same key + nonce');
                called = true;
                $248bf24903c02b9f$var$abytes(data);
                checkOutput(cipher.encrypt.length, output);
                return cipher.encrypt(data, output);
            },
            decrypt (data, output) {
                $248bf24903c02b9f$var$abytes(data);
                if (tagl && data.length < tagl) throw new Error('invalid ciphertext length: smaller than tagLength=' + tagl);
                checkOutput(cipher.decrypt.length, output);
                return cipher.decrypt(data, output);
            }
        };
        return wrCipher;
    }
    Object.assign(wrappedCipher, params);
    return wrappedCipher;
};
module.exports.wrapCipher = $248bf24903c02b9f$var$wrapCipher;
/**
 * By default, returns u8a of length.
 * When out is available, it checks it for validity and uses it.
 */ function $248bf24903c02b9f$var$getOutput(expectedLength, out, onlyAligned = true) {
    if (out === undefined) return new Uint8Array(expectedLength);
    if (out.length !== expectedLength) throw new Error('invalid output length, expected ' + expectedLength + ', got: ' + out.length);
    if (onlyAligned && !$248bf24903c02b9f$var$isAligned32(out)) throw new Error('invalid output, must be aligned');
    return out;
}
/** Polyfill for Safari 14. */ function $248bf24903c02b9f$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $248bf24903c02b9f$var$u64Lengths(dataLength, aadLength, isLE) {
    $248bf24903c02b9f$var$abool(isLE);
    const num = new Uint8Array(16);
    const view = $248bf24903c02b9f$var$createView(num);
    $248bf24903c02b9f$var$setBigUint64(view, 0, BigInt(aadLength), isLE);
    $248bf24903c02b9f$var$setBigUint64(view, 8, BigInt(dataLength), isLE);
    return num;
}
// Is byte array aligned to 4 byte offset (u32)?
function $248bf24903c02b9f$var$isAligned32(bytes) {
    return bytes.byteOffset % 4 === 0;
}
// copy bytes to new u8a (aligned). Because Buffer.slice is broken.
function $248bf24903c02b9f$var$copyBytes(bytes) {
    return Uint8Array.from(bytes);
}

});



parcelRegister("izQkD", function(module, exports) {
parcelRequire("dgZXH");
var $gI9iY = parcelRequire("gI9iY");
var $5J5hB = parcelRequire("5J5hB");
var $hH3hY = parcelRequire("hH3hY");
var $i4JPn = parcelRequire("i4JPn");
var $gEOXZ = parcelRequire("gEOXZ");
var $bjBBc = parcelRequire("bjBBc");
var $1Oxaj = parcelRequire("1Oxaj");
var $jvb6m = parcelRequire("jvb6m");
var $erngl = parcelRequire("erngl");
var $d0Ff6 = parcelRequire("d0Ff6");
var $4cbQT = parcelRequire("4cbQT");
var $1X3I0 = parcelRequire("1X3I0");
var $XqKmt = parcelRequire("XqKmt");
var $gqRil = parcelRequire("gqRil");

var $4Bw9T = parcelRequire("4Bw9T");

var $NqsVD = parcelRequire("NqsVD");

var $7hFx0 = parcelRequire("7hFx0");

var $k9oO0 = parcelRequire("k9oO0");

var $9daMG = parcelRequire("9daMG");

var $fLo3N = parcelRequire("fLo3N");

var $8kDCz = parcelRequire("8kDCz");

var $dHvIi = parcelRequire("dHvIi");

var $j8d6B = parcelRequire("j8d6B");
function $f7a6899246d76dab$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $f7a6899246d76dab$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $f7a6899246d76dab$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $f7a6899246d76dab$var$$59aa4ed98453e1d4$exports = {};
$f7a6899246d76dab$var$$parcel$export($f7a6899246d76dab$var$$59aa4ed98453e1d4$exports, "logErrors", ()=>$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$bd5c5d8b8dcafd78);
$f7a6899246d76dab$var$$parcel$export($f7a6899246d76dab$var$$59aa4ed98453e1d4$exports, "registerFormat", ()=>$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$36b2f24e97d43be);
$f7a6899246d76dab$var$$parcel$export($f7a6899246d76dab$var$$59aa4ed98453e1d4$exports, "create", ()=>$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$185802fd694ee1f5);
$f7a6899246d76dab$var$$parcel$export($f7a6899246d76dab$var$$59aa4ed98453e1d4$exports, "defaultLanguage", ()=>$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$42940898df819940);
$f7a6899246d76dab$var$$parcel$export($f7a6899246d76dab$var$$59aa4ed98453e1d4$exports, "setDefaultLanguage", ()=>$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$5157e7780d44cc36);
let $f7a6899246d76dab$var$$59aa4ed98453e1d4$export$bd5c5d8b8dcafd78 = false;
let $f7a6899246d76dab$var$$59aa4ed98453e1d4$var$formats = [];
function $f7a6899246d76dab$var$$59aa4ed98453e1d4$export$36b2f24e97d43be(format) {
    $f7a6899246d76dab$var$$59aa4ed98453e1d4$var$formats.push(format);
}
function $f7a6899246d76dab$var$$59aa4ed98453e1d4$export$185802fd694ee1f5(buffer, postscriptName) {
    for(let i = 0; i < $f7a6899246d76dab$var$$59aa4ed98453e1d4$var$formats.length; i++){
        let format = $f7a6899246d76dab$var$$59aa4ed98453e1d4$var$formats[i];
        if (format.probe(buffer)) {
            let font = new format(new $i4JPn.DecodeStream(buffer));
            if (postscriptName) return font.getFont(postscriptName);
            return font;
        }
    }
    throw new Error('Unknown font format');
}
let $f7a6899246d76dab$var$$59aa4ed98453e1d4$export$42940898df819940 = 'en';
function $f7a6899246d76dab$var$$59aa4ed98453e1d4$export$5157e7780d44cc36(lang = 'en') {
    $f7a6899246d76dab$var$$59aa4ed98453e1d4$export$42940898df819940 = lang;
}
/**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */ function $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d(target, key, descriptor) {
    if (descriptor.get) {
        let get = descriptor.get;
        descriptor.get = function() {
            let value = get.call(this);
            Object.defineProperty(this, key, {
                value: value
            });
            return value;
        };
    } else if (typeof descriptor.value === 'function') {
        let fn = descriptor.value;
        return {
            get () {
                let cache = new Map;
                function memoized(...args) {
                    let key = args.length > 0 ? args[0] : 'value';
                    if (cache.has(key)) return cache.get(key);
                    let result = fn.apply(this, args);
                    cache.set(key, result);
                    return result;
                }
                Object.defineProperty(this, key, {
                    value: memoized
                });
                return memoized;
            }
        };
    }
}
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$SubHeader = new $XqKmt.Struct({
    firstCode: $bjBBc.uint16,
    entryCount: $bjBBc.uint16,
    idDelta: $bjBBc.int16,
    idRangeOffset: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapGroup = new $XqKmt.Struct({
    startCharCode: $bjBBc.uint32,
    endCharCode: $bjBBc.uint32,
    glyphID: $bjBBc.uint32
});
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$UnicodeValueRange = new $XqKmt.Struct({
    startUnicodeValue: $bjBBc.uint24,
    additionalCount: $bjBBc.uint8
});
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$UVSMapping = new $XqKmt.Struct({
    unicodeValue: $bjBBc.uint24,
    glyphID: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$DefaultUVS = new $gI9iY.Array($f7a6899246d76dab$var$$e4ae0436c91af89f$var$UnicodeValueRange, $bjBBc.uint32);
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$NonDefaultUVS = new $gI9iY.Array($f7a6899246d76dab$var$$e4ae0436c91af89f$var$UVSMapping, $bjBBc.uint32);
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$VarSelectorRecord = new $XqKmt.Struct({
    varSelector: $bjBBc.uint24,
    defaultUVS: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$e4ae0436c91af89f$var$DefaultUVS, {
        type: 'parent'
    }),
    nonDefaultUVS: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$e4ae0436c91af89f$var$NonDefaultUVS, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapSubtable = new $gqRil.VersionedStruct($bjBBc.uint16, {
    0: {
        length: $bjBBc.uint16,
        language: $bjBBc.uint16,
        codeMap: new $1Oxaj.LazyArray($bjBBc.uint8, 256)
    },
    2: {
        length: $bjBBc.uint16,
        language: $bjBBc.uint16,
        subHeaderKeys: new $gI9iY.Array($bjBBc.uint16, 256),
        subHeaderCount: (t)=>Math.max.apply(Math, t.subHeaderKeys),
        subHeaders: new $1Oxaj.LazyArray($f7a6899246d76dab$var$$e4ae0436c91af89f$var$SubHeader, 'subHeaderCount'),
        glyphIndexArray: new $1Oxaj.LazyArray($bjBBc.uint16, 'subHeaderCount')
    },
    4: {
        length: $bjBBc.uint16,
        language: $bjBBc.uint16,
        segCountX2: $bjBBc.uint16,
        segCount: (t)=>t.segCountX2 >> 1,
        searchRange: $bjBBc.uint16,
        entrySelector: $bjBBc.uint16,
        rangeShift: $bjBBc.uint16,
        endCode: new $1Oxaj.LazyArray($bjBBc.uint16, 'segCount'),
        reservedPad: new $4cbQT.Reserved($bjBBc.uint16),
        startCode: new $1Oxaj.LazyArray($bjBBc.uint16, 'segCount'),
        idDelta: new $1Oxaj.LazyArray($bjBBc.int16, 'segCount'),
        idRangeOffset: new $1Oxaj.LazyArray($bjBBc.uint16, 'segCount'),
        glyphIndexArray: new $1Oxaj.LazyArray($bjBBc.uint16, (t)=>(t.length - t._currentOffset) / 2)
    },
    6: {
        length: $bjBBc.uint16,
        language: $bjBBc.uint16,
        firstCode: $bjBBc.uint16,
        entryCount: $bjBBc.uint16,
        glyphIndices: new $1Oxaj.LazyArray($bjBBc.uint16, 'entryCount')
    },
    8: {
        reserved: new $4cbQT.Reserved($bjBBc.uint16),
        length: $bjBBc.uint32,
        language: $bjBBc.uint16,
        is32: new $1Oxaj.LazyArray($bjBBc.uint8, 8192),
        nGroups: $bjBBc.uint32,
        groups: new $1Oxaj.LazyArray($f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapGroup, 'nGroups')
    },
    10: {
        reserved: new $4cbQT.Reserved($bjBBc.uint16),
        length: $bjBBc.uint32,
        language: $bjBBc.uint32,
        firstCode: $bjBBc.uint32,
        entryCount: $bjBBc.uint32,
        glyphIndices: new $1Oxaj.LazyArray($bjBBc.uint16, 'numChars')
    },
    12: {
        reserved: new $4cbQT.Reserved($bjBBc.uint16),
        length: $bjBBc.uint32,
        language: $bjBBc.uint32,
        nGroups: $bjBBc.uint32,
        groups: new $1Oxaj.LazyArray($f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapGroup, 'nGroups')
    },
    13: {
        reserved: new $4cbQT.Reserved($bjBBc.uint16),
        length: $bjBBc.uint32,
        language: $bjBBc.uint32,
        nGroups: $bjBBc.uint32,
        groups: new $1Oxaj.LazyArray($f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapGroup, 'nGroups')
    },
    14: {
        length: $bjBBc.uint32,
        numRecords: $bjBBc.uint32,
        varSelectors: new $1Oxaj.LazyArray($f7a6899246d76dab$var$$e4ae0436c91af89f$var$VarSelectorRecord, 'numRecords')
    }
});
let $f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapEntry = new $XqKmt.Struct({
    platformID: $bjBBc.uint16,
    encodingID: $bjBBc.uint16,
    table: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapSubtable, {
        type: 'parent',
        lazy: true
    })
});
var $f7a6899246d76dab$var$$e4ae0436c91af89f$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    numSubtables: $bjBBc.uint16,
    tables: new $gI9iY.Array($f7a6899246d76dab$var$$e4ae0436c91af89f$var$CmapEntry, 'numSubtables')
});
var $f7a6899246d76dab$var$$55a60976afb7c261$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.int32,
    revision: $bjBBc.int32,
    checkSumAdjustment: $bjBBc.uint32,
    magicNumber: $bjBBc.uint32,
    flags: $bjBBc.uint16,
    unitsPerEm: $bjBBc.uint16,
    created: new $gI9iY.Array($bjBBc.int32, 2),
    modified: new $gI9iY.Array($bjBBc.int32, 2),
    xMin: $bjBBc.int16,
    yMin: $bjBBc.int16,
    xMax: $bjBBc.int16,
    yMax: $bjBBc.int16,
    macStyle: new $5J5hB.Bitfield($bjBBc.uint16, [
        'bold',
        'italic',
        'underline',
        'outline',
        'shadow',
        'condensed',
        'extended'
    ]),
    lowestRecPPEM: $bjBBc.uint16,
    fontDirectionHint: $bjBBc.int16,
    indexToLocFormat: $bjBBc.int16,
    glyphDataFormat: $bjBBc.int16 // 0 for current format
});
var $f7a6899246d76dab$var$$dde72b7b5b650596$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.int32,
    ascent: $bjBBc.int16,
    descent: $bjBBc.int16,
    lineGap: $bjBBc.int16,
    advanceWidthMax: $bjBBc.uint16,
    minLeftSideBearing: $bjBBc.int16,
    minRightSideBearing: $bjBBc.int16,
    xMaxExtent: $bjBBc.int16,
    caretSlopeRise: $bjBBc.int16,
    caretSlopeRun: $bjBBc.int16,
    caretOffset: $bjBBc.int16,
    reserved: new $4cbQT.Reserved($bjBBc.int16, 4),
    metricDataFormat: $bjBBc.int16,
    numberOfMetrics: $bjBBc.uint16 // Number of advance widths in 'hmtx' table
});
let $f7a6899246d76dab$var$$a7c40184072c9a5b$var$HmtxEntry = new $XqKmt.Struct({
    advance: $bjBBc.uint16,
    bearing: $bjBBc.int16
});
var $f7a6899246d76dab$var$$a7c40184072c9a5b$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    metrics: new $1Oxaj.LazyArray($f7a6899246d76dab$var$$a7c40184072c9a5b$var$HmtxEntry, (t)=>t.parent.hhea.numberOfMetrics),
    bearings: new $1Oxaj.LazyArray($bjBBc.int16, (t)=>t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics)
});
var $f7a6899246d76dab$var$$521197722369f691$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.int32,
    numGlyphs: $bjBBc.uint16,
    maxPoints: $bjBBc.uint16,
    maxContours: $bjBBc.uint16,
    maxComponentPoints: $bjBBc.uint16,
    maxComponentContours: $bjBBc.uint16,
    maxZones: $bjBBc.uint16,
    maxTwilightPoints: $bjBBc.uint16,
    maxStorage: $bjBBc.uint16,
    maxFunctionDefs: $bjBBc.uint16,
    maxInstructionDefs: $bjBBc.uint16,
    maxStackElements: $bjBBc.uint16,
    maxSizeOfInstructions: $bjBBc.uint16,
    maxComponentElements: $bjBBc.uint16,
    maxComponentDepth: $bjBBc.uint16 // Maximum levels of recursion; 1 for simple components
});
/**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */ function $f7a6899246d76dab$var$$e2613b812f052cbe$export$badc544e0651b6b1(platformID, encodingID, languageID = 0) {
    if (platformID === 1 && $f7a6899246d76dab$var$$e2613b812f052cbe$export$479e671907f486d1[languageID]) return $f7a6899246d76dab$var$$e2613b812f052cbe$export$479e671907f486d1[languageID];
    return $f7a6899246d76dab$var$$e2613b812f052cbe$export$6fef87b7618bdf0b[platformID][encodingID];
}
const $f7a6899246d76dab$var$$e2613b812f052cbe$var$SINGLE_BYTE_ENCODINGS = new Set([
    'x-mac-roman',
    'x-mac-cyrillic',
    'iso-8859-6',
    'iso-8859-8'
]);
const $f7a6899246d76dab$var$$e2613b812f052cbe$var$MAC_ENCODINGS = {
    'x-mac-croatian': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u03A9\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026 \xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uF8FF\xa9\u2044\u20AC\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7",
    'x-mac-gaelic': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u1E02\xb1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xe6\xf8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xff\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xb7\u1EF2\u1EF3\u204A\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\u2663\xd2\xda\xdb\xd9\u0131\xdd\xfd\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
    'x-mac-greek': "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\u20AC\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\xb7\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026 \u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xad",
    'x-mac-icelandic': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    'x-mac-inuit': "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xb0\u14A1\u14A5\u14A6\u2022\xb6\u14A7\xae\xa9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026 \u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
    'x-mac-ce': "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026 \u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7",
    'x-mac-romanian': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u0218\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\u0103\u0219\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    'x-mac-turkish': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\uF8A0\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
};
const $f7a6899246d76dab$var$$e2613b812f052cbe$var$encodingCache = new Map();
function $f7a6899246d76dab$var$$e2613b812f052cbe$export$1dceb3c14ed68bee(encoding) {
    let cached = $f7a6899246d76dab$var$$e2613b812f052cbe$var$encodingCache.get(encoding);
    if (cached) return cached;
    // These encodings aren't supported by TextDecoder.
    let mapping = $f7a6899246d76dab$var$$e2613b812f052cbe$var$MAC_ENCODINGS[encoding];
    if (mapping) {
        let res = new Map();
        for(let i = 0; i < mapping.length; i++)res.set(mapping.charCodeAt(i), 0x80 + i);
        $f7a6899246d76dab$var$$e2613b812f052cbe$var$encodingCache.set(encoding, res);
        return res;
    }
    // Only single byte encodings can be mapped 1:1.
    if ($f7a6899246d76dab$var$$e2613b812f052cbe$var$SINGLE_BYTE_ENCODINGS.has(encoding)) {
        // TextEncoder only supports utf8, whereas TextDecoder supports legacy encodings.
        // Use this to create a mapping of code points.
        let decoder = new TextDecoder(encoding);
        let mapping = new Uint8Array(0x80);
        for(let i = 0; i < 0x80; i++)mapping[i] = 0x80 + i;
        let res = new Map();
        let s = decoder.decode(mapping);
        for(let i = 0; i < 0x80; i++)res.set(s.charCodeAt(i), 0x80 + i);
        $f7a6899246d76dab$var$$e2613b812f052cbe$var$encodingCache.set(encoding, res);
        return res;
    }
}
const $f7a6899246d76dab$var$$e2613b812f052cbe$export$6fef87b7618bdf0b = [
    // unicode
    [
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be'
    ],
    // macintosh
    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
    // 0	Roman                 17	Malayalam
    // 1	Japanese	            18	Sinhalese
    // 2	Traditional Chinese	  19	Burmese
    // 3	Korean	              20	Khmer
    // 4	Arabic	              21	Thai
    // 5	Hebrew	              22	Laotian
    // 6	Greek	                23	Georgian
    // 7	Russian	              24	Armenian
    // 8	RSymbol	              25	Simplified Chinese
    // 9	Devanagari	          26	Tibetan
    // 10	Gurmukhi	            27	Mongolian
    // 11	Gujarati	            28	Geez
    // 12	Oriya	                29	Slavic
    // 13	Bengali	              30	Vietnamese
    // 14	Tamil	                31	Sindhi
    // 15	Telugu	              32	(Uninterpreted)
    // 16	Kannada
    [
        'x-mac-roman',
        'shift-jis',
        'big5',
        'euc-kr',
        'iso-8859-6',
        'iso-8859-8',
        'x-mac-greek',
        'x-mac-cyrillic',
        'x-mac-symbol',
        'x-mac-devanagari',
        'x-mac-gurmukhi',
        'x-mac-gujarati',
        'Oriya',
        'Bengali',
        'Tamil',
        'Telugu',
        'Kannada',
        'Malayalam',
        'Sinhalese',
        'Burmese',
        'Khmer',
        'iso-8859-11',
        'Laotian',
        'Georgian',
        'Armenian',
        'gbk',
        'Tibetan',
        'Mongolian',
        'Geez',
        'x-mac-ce',
        'Vietnamese',
        'Sindhi'
    ],
    // ISO (deprecated)
    [
        'ascii',
        null,
        'iso-8859-1'
    ],
    // windows
    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
    [
        'symbol',
        'utf-16be',
        'shift-jis',
        'gb18030',
        'big5',
        'euc-kr',
        'johab',
        null,
        null,
        null,
        'utf-16be'
    ]
];
const $f7a6899246d76dab$var$$e2613b812f052cbe$export$479e671907f486d1 = {
    15: 'x-mac-icelandic',
    17: 'x-mac-turkish',
    18: 'x-mac-croatian',
    24: 'x-mac-ce',
    25: 'x-mac-ce',
    26: 'x-mac-ce',
    27: 'x-mac-ce',
    28: 'x-mac-ce',
    30: 'x-mac-icelandic',
    37: 'x-mac-romanian',
    38: 'x-mac-ce',
    39: 'x-mac-ce',
    40: 'x-mac-ce',
    143: 'x-mac-inuit',
    146: 'x-mac-gaelic'
};
const $f7a6899246d76dab$var$$e2613b812f052cbe$export$2092376fd002e13 = [
    // unicode
    [],
    {
        0: 'en',
        30: 'fo',
        60: 'ks',
        90: 'rw',
        1: 'fr',
        31: 'fa',
        61: 'ku',
        91: 'rn',
        2: 'de',
        32: 'ru',
        62: 'sd',
        92: 'ny',
        3: 'it',
        33: 'zh',
        63: 'bo',
        93: 'mg',
        4: 'nl',
        34: 'nl-BE',
        64: 'ne',
        94: 'eo',
        5: 'sv',
        35: 'ga',
        65: 'sa',
        128: 'cy',
        6: 'es',
        36: 'sq',
        66: 'mr',
        129: 'eu',
        7: 'da',
        37: 'ro',
        67: 'bn',
        130: 'ca',
        8: 'pt',
        38: 'cz',
        68: 'as',
        131: 'la',
        9: 'no',
        39: 'sk',
        69: 'gu',
        132: 'qu',
        10: 'he',
        40: 'si',
        70: 'pa',
        133: 'gn',
        11: 'ja',
        41: 'yi',
        71: 'or',
        134: 'ay',
        12: 'ar',
        42: 'sr',
        72: 'ml',
        135: 'tt',
        13: 'fi',
        43: 'mk',
        73: 'kn',
        136: 'ug',
        14: 'el',
        44: 'bg',
        74: 'ta',
        137: 'dz',
        15: 'is',
        45: 'uk',
        75: 'te',
        138: 'jv',
        16: 'mt',
        46: 'be',
        76: 'si',
        139: 'su',
        17: 'tr',
        47: 'uz',
        77: 'my',
        140: 'gl',
        18: 'hr',
        48: 'kk',
        78: 'km',
        141: 'af',
        19: 'zh-Hant',
        49: 'az-Cyrl',
        79: 'lo',
        142: 'br',
        20: 'ur',
        50: 'az-Arab',
        80: 'vi',
        143: 'iu',
        21: 'hi',
        51: 'hy',
        81: 'id',
        144: 'gd',
        22: 'th',
        52: 'ka',
        82: 'tl',
        145: 'gv',
        23: 'ko',
        53: 'mo',
        83: 'ms',
        146: 'ga',
        24: 'lt',
        54: 'ky',
        84: 'ms-Arab',
        147: 'to',
        25: 'pl',
        55: 'tg',
        85: 'am',
        148: 'el-polyton',
        26: 'hu',
        56: 'tk',
        86: 'ti',
        149: 'kl',
        27: 'es',
        57: 'mn-CN',
        87: 'om',
        150: 'az',
        28: 'lv',
        58: 'mn',
        88: 'so',
        151: 'nn',
        29: 'se',
        59: 'ps',
        89: 'sw'
    },
    // ISO (deprecated)
    [],
    {
        0x0436: 'af',
        0x4009: 'en-IN',
        0x0487: 'rw',
        0x0432: 'tn',
        0x041C: 'sq',
        0x1809: 'en-IE',
        0x0441: 'sw',
        0x045B: 'si',
        0x0484: 'gsw',
        0x2009: 'en-JM',
        0x0457: 'kok',
        0x041B: 'sk',
        0x045E: 'am',
        0x4409: 'en-MY',
        0x0412: 'ko',
        0x0424: 'sl',
        0x1401: 'ar-DZ',
        0x1409: 'en-NZ',
        0x0440: 'ky',
        0x2C0A: 'es-AR',
        0x3C01: 'ar-BH',
        0x3409: 'en-PH',
        0x0454: 'lo',
        0x400A: 'es-BO',
        0x0C01: 'ar',
        0x4809: 'en-SG',
        0x0426: 'lv',
        0x340A: 'es-CL',
        0x0801: 'ar-IQ',
        0x1C09: 'en-ZA',
        0x0427: 'lt',
        0x240A: 'es-CO',
        0x2C01: 'ar-JO',
        0x2C09: 'en-TT',
        0x082E: 'dsb',
        0x140A: 'es-CR',
        0x3401: 'ar-KW',
        0x0809: 'en-GB',
        0x046E: 'lb',
        0x1C0A: 'es-DO',
        0x3001: 'ar-LB',
        0x0409: 'en',
        0x042F: 'mk',
        0x300A: 'es-EC',
        0x1001: 'ar-LY',
        0x3009: 'en-ZW',
        0x083E: 'ms-BN',
        0x440A: 'es-SV',
        0x1801: 'ary',
        0x0425: 'et',
        0x043E: 'ms',
        0x100A: 'es-GT',
        0x2001: 'ar-OM',
        0x0438: 'fo',
        0x044C: 'ml',
        0x480A: 'es-HN',
        0x4001: 'ar-QA',
        0x0464: 'fil',
        0x043A: 'mt',
        0x080A: 'es-MX',
        0x0401: 'ar-SA',
        0x040B: 'fi',
        0x0481: 'mi',
        0x4C0A: 'es-NI',
        0x2801: 'ar-SY',
        0x080C: 'fr-BE',
        0x047A: 'arn',
        0x180A: 'es-PA',
        0x1C01: 'aeb',
        0x0C0C: 'fr-CA',
        0x044E: 'mr',
        0x3C0A: 'es-PY',
        0x3801: 'ar-AE',
        0x040C: 'fr',
        0x047C: 'moh',
        0x280A: 'es-PE',
        0x2401: 'ar-YE',
        0x140C: 'fr-LU',
        0x0450: 'mn',
        0x500A: 'es-PR',
        0x042B: 'hy',
        0x180C: 'fr-MC',
        0x0850: 'mn-CN',
        0x0C0A: 'es',
        0x044D: 'as',
        0x100C: 'fr-CH',
        0x0461: 'ne',
        0x040A: 'es',
        0x082C: 'az-Cyrl',
        0x0462: 'fy',
        0x0414: 'nb',
        0x540A: 'es-US',
        0x042C: 'az',
        0x0456: 'gl',
        0x0814: 'nn',
        0x380A: 'es-UY',
        0x046D: 'ba',
        0x0437: 'ka',
        0x0482: 'oc',
        0x200A: 'es-VE',
        0x042D: 'eu',
        0x0C07: 'de-AT',
        0x0448: 'or',
        0x081D: 'sv-FI',
        0x0423: 'be',
        0x0407: 'de',
        0x0463: 'ps',
        0x041D: 'sv',
        0x0845: 'bn',
        0x1407: 'de-LI',
        0x0415: 'pl',
        0x045A: 'syr',
        0x0445: 'bn-IN',
        0x1007: 'de-LU',
        0x0416: 'pt',
        0x0428: 'tg',
        0x201A: 'bs-Cyrl',
        0x0807: 'de-CH',
        0x0816: 'pt-PT',
        0x085F: 'tzm',
        0x141A: 'bs',
        0x0408: 'el',
        0x0446: 'pa',
        0x0449: 'ta',
        0x047E: 'br',
        0x046F: 'kl',
        0x046B: 'qu-BO',
        0x0444: 'tt',
        0x0402: 'bg',
        0x0447: 'gu',
        0x086B: 'qu-EC',
        0x044A: 'te',
        0x0403: 'ca',
        0x0468: 'ha',
        0x0C6B: 'qu',
        0x041E: 'th',
        0x0C04: 'zh-HK',
        0x040D: 'he',
        0x0418: 'ro',
        0x0451: 'bo',
        0x1404: 'zh-MO',
        0x0439: 'hi',
        0x0417: 'rm',
        0x041F: 'tr',
        0x0804: 'zh',
        0x040E: 'hu',
        0x0419: 'ru',
        0x0442: 'tk',
        0x1004: 'zh-SG',
        0x040F: 'is',
        0x243B: 'smn',
        0x0480: 'ug',
        0x0404: 'zh-TW',
        0x0470: 'ig',
        0x103B: 'smj-NO',
        0x0422: 'uk',
        0x0483: 'co',
        0x0421: 'id',
        0x143B: 'smj',
        0x042E: 'hsb',
        0x041A: 'hr',
        0x045D: 'iu',
        0x0C3B: 'se-FI',
        0x0420: 'ur',
        0x101A: 'hr-BA',
        0x085D: 'iu-Latn',
        0x043B: 'se',
        0x0843: 'uz-Cyrl',
        0x0405: 'cs',
        0x083C: 'ga',
        0x083B: 'se-SE',
        0x0443: 'uz',
        0x0406: 'da',
        0x0434: 'xh',
        0x203B: 'sms',
        0x042A: 'vi',
        0x048C: 'prs',
        0x0435: 'zu',
        0x183B: 'sma-NO',
        0x0452: 'cy',
        0x0465: 'dv',
        0x0410: 'it',
        0x1C3B: 'sms',
        0x0488: 'wo',
        0x0813: 'nl-BE',
        0x0810: 'it-CH',
        0x044F: 'sa',
        0x0485: 'sah',
        0x0413: 'nl',
        0x0411: 'ja',
        0x1C1A: 'sr-Cyrl-BA',
        0x0478: 'ii',
        0x0C09: 'en-AU',
        0x044B: 'kn',
        0x0C1A: 'sr',
        0x046A: 'yo',
        0x2809: 'en-BZ',
        0x043F: 'kk',
        0x181A: 'sr-Latn-BA',
        0x1009: 'en-CA',
        0x0453: 'km',
        0x081A: 'sr-Latn',
        0x2409: 'en-029',
        0x0486: 'quc',
        0x046C: 'nso'
    }
];
let $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameRecord = new $XqKmt.Struct({
    platformID: $bjBBc.uint16,
    encodingID: $bjBBc.uint16,
    languageID: $bjBBc.uint16,
    nameID: $bjBBc.uint16,
    length: $bjBBc.uint16,
    string: new $erngl.Pointer($bjBBc.uint16, new $1X3I0.String('length', (t)=>$f7a6899246d76dab$var$$e2613b812f052cbe$export$badc544e0651b6b1(t.platformID, t.encodingID, t.languageID)), {
        type: 'parent',
        relativeTo: (ctx)=>ctx.parent.stringOffset,
        allowNull: false
    })
});
let $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$LangTagRecord = new $XqKmt.Struct({
    length: $bjBBc.uint16,
    tag: new $erngl.Pointer($bjBBc.uint16, new $1X3I0.String('length', 'utf16be'), {
        type: 'parent',
        relativeTo: (ctx)=>ctx.stringOffset
    })
});
var $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameTable = new $gqRil.VersionedStruct($bjBBc.uint16, {
    0: {
        count: $bjBBc.uint16,
        stringOffset: $bjBBc.uint16,
        records: new $gI9iY.Array($f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameRecord, 'count')
    },
    1: {
        count: $bjBBc.uint16,
        stringOffset: $bjBBc.uint16,
        records: new $gI9iY.Array($f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameRecord, 'count'),
        langTagCount: $bjBBc.uint16,
        langTags: new $gI9iY.Array($f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$LangTagRecord, 'langTagCount')
    }
});
var $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameTable;
const $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NAMES = [
    'copyright',
    'fontFamily',
    'fontSubfamily',
    'uniqueSubfamily',
    'fullName',
    'version',
    'postscriptName',
    'trademark',
    'manufacturer',
    'designer',
    'description',
    'vendorURL',
    'designerURL',
    'license',
    'licenseURL',
    null,
    'preferredFamily',
    'preferredSubfamily',
    'compatibleFull',
    'sampleText',
    'postscriptCIDFontName',
    'wwsFamilyName',
    'wwsSubfamilyName'
];
$f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameTable.process = function(stream) {
    var records = {};
    for (let record of this.records){
        // find out what language this is for
        let language = $f7a6899246d76dab$var$$e2613b812f052cbe$export$2092376fd002e13[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
        if (language == null) language = record.platformID + '-' + record.languageID;
        // if the nameID is >= 256, it is a font feature record (AAT)
        let key = record.nameID >= 256 ? 'fontFeatures' : $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NAMES[record.nameID] || record.nameID;
        if (records[key] == null) records[key] = {};
        let obj = records[key];
        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
        if (typeof record.string === 'string' || typeof obj[language] !== 'string') obj[language] = record.string;
    }
    this.records = records;
};
$f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameTable.preEncode = function() {
    if (Array.isArray(this.records)) return;
    this.version = 0;
    let records = [];
    for(let key in this.records){
        let val = this.records[key];
        if (key === 'fontFeatures') continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 0x409,
            nameID: $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NAMES.indexOf(key),
            length: val.en.length * 2,
            string: val.en
        });
        if (key === 'postscriptName') records.push({
            platformID: 1,
            encodingID: 0,
            languageID: 0,
            nameID: $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NAMES.indexOf(key),
            length: val.en.length,
            string: val.en
        });
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$var$NameTable.size(this, null, false);
};
var $f7a6899246d76dab$var$$114ea85db469b435$var$OS2 = new $gqRil.VersionedStruct($bjBBc.uint16, {
    header: {
        xAvgCharWidth: $bjBBc.int16,
        usWeightClass: $bjBBc.uint16,
        usWidthClass: $bjBBc.uint16,
        fsType: new $5J5hB.Bitfield($bjBBc.uint16, [
            null,
            'noEmbedding',
            'viewOnly',
            'editable',
            null,
            null,
            null,
            null,
            'noSubsetting',
            'bitmapOnly'
        ]),
        ySubscriptXSize: $bjBBc.int16,
        ySubscriptYSize: $bjBBc.int16,
        ySubscriptXOffset: $bjBBc.int16,
        ySubscriptYOffset: $bjBBc.int16,
        ySuperscriptXSize: $bjBBc.int16,
        ySuperscriptYSize: $bjBBc.int16,
        ySuperscriptXOffset: $bjBBc.int16,
        ySuperscriptYOffset: $bjBBc.int16,
        yStrikeoutSize: $bjBBc.int16,
        yStrikeoutPosition: $bjBBc.int16,
        sFamilyClass: $bjBBc.int16,
        panose: new $gI9iY.Array($bjBBc.uint8, 10),
        ulCharRange: new $gI9iY.Array($bjBBc.uint32, 4),
        vendorID: new $1X3I0.String(4),
        fsSelection: new $5J5hB.Bitfield($bjBBc.uint16, [
            'italic',
            'underscore',
            'negative',
            'outlined',
            'strikeout',
            'bold',
            'regular',
            'useTypoMetrics',
            'wws',
            'oblique'
        ]),
        usFirstCharIndex: $bjBBc.uint16,
        usLastCharIndex: $bjBBc.uint16 // The maximum Unicode index in this font
    },
    // The Apple version of this table ends here, but the Microsoft one continues on...
    0: {},
    1: {
        typoAscender: $bjBBc.int16,
        typoDescender: $bjBBc.int16,
        typoLineGap: $bjBBc.int16,
        winAscent: $bjBBc.uint16,
        winDescent: $bjBBc.uint16,
        codePageRange: new $gI9iY.Array($bjBBc.uint32, 2)
    },
    2: {
        // these should be common with version 1 somehow
        typoAscender: $bjBBc.int16,
        typoDescender: $bjBBc.int16,
        typoLineGap: $bjBBc.int16,
        winAscent: $bjBBc.uint16,
        winDescent: $bjBBc.uint16,
        codePageRange: new $gI9iY.Array($bjBBc.uint32, 2),
        xHeight: $bjBBc.int16,
        capHeight: $bjBBc.int16,
        defaultChar: $bjBBc.uint16,
        breakChar: $bjBBc.uint16,
        maxContent: $bjBBc.uint16
    },
    5: {
        typoAscender: $bjBBc.int16,
        typoDescender: $bjBBc.int16,
        typoLineGap: $bjBBc.int16,
        winAscent: $bjBBc.uint16,
        winDescent: $bjBBc.uint16,
        codePageRange: new $gI9iY.Array($bjBBc.uint32, 2),
        xHeight: $bjBBc.int16,
        capHeight: $bjBBc.int16,
        defaultChar: $bjBBc.uint16,
        breakChar: $bjBBc.uint16,
        maxContent: $bjBBc.uint16,
        usLowerOpticalPointSize: $bjBBc.uint16,
        usUpperOpticalPointSize: $bjBBc.uint16
    }
});
let $f7a6899246d76dab$var$$114ea85db469b435$var$versions = $f7a6899246d76dab$var$$114ea85db469b435$var$OS2.versions;
$f7a6899246d76dab$var$$114ea85db469b435$var$versions[3] = $f7a6899246d76dab$var$$114ea85db469b435$var$versions[4] = $f7a6899246d76dab$var$$114ea85db469b435$var$versions[2];
var $f7a6899246d76dab$var$$114ea85db469b435$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$114ea85db469b435$var$OS2;
var $f7a6899246d76dab$var$$f93b30299e1ea0f5$export$2e2bcd8739ae039 = new $gqRil.VersionedStruct($bjBBc.fixed32, {
    header: {
        italicAngle: $bjBBc.fixed32,
        underlinePosition: $bjBBc.int16,
        underlineThickness: $bjBBc.int16,
        isFixedPitch: $bjBBc.uint32,
        minMemType42: $bjBBc.uint32,
        maxMemType42: $bjBBc.uint32,
        minMemType1: $bjBBc.uint32,
        maxMemType1: $bjBBc.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
    },
    1: {},
    2: {
        numberOfGlyphs: $bjBBc.uint16,
        glyphNameIndex: new $gI9iY.Array($bjBBc.uint16, 'numberOfGlyphs'),
        names: new $gI9iY.Array(new $1X3I0.String($bjBBc.uint8))
    },
    2.5: {
        numberOfGlyphs: $bjBBc.uint16,
        offsets: new $gI9iY.Array($bjBBc.uint8, 'numberOfGlyphs')
    },
    3: {},
    4: {
        map: new $gI9iY.Array($bjBBc.uint32, (t)=>t.parent.maxp.numGlyphs)
    }
});
var $f7a6899246d76dab$var$$8fb09b0f473d61a0$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    controlValues: new $gI9iY.Array($bjBBc.int16)
});
var // These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
$f7a6899246d76dab$var$$873d79fea57d3161$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    instructions: new $gI9iY.Array($bjBBc.uint8)
});
let $f7a6899246d76dab$var$$83c4155666d50c37$var$loca = new $gqRil.VersionedStruct('head.indexToLocFormat', {
    0: {
        offsets: new $gI9iY.Array($bjBBc.uint16)
    },
    1: {
        offsets: new $gI9iY.Array($bjBBc.uint32)
    }
});
$f7a6899246d76dab$var$$83c4155666d50c37$var$loca.process = function() {
    if (this.version === 0 && !this._processed) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
        this._processed = true;
    }
};
$f7a6899246d76dab$var$$83c4155666d50c37$var$loca.preEncode = function() {
    if (this.version === 0 && this._processed !== false) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
        this._processed = false;
    }
};
var $f7a6899246d76dab$var$$83c4155666d50c37$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$83c4155666d50c37$var$loca;
var $f7a6899246d76dab$var$$b12598db7cdf7042$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    controlValueProgram: new $gI9iY.Array($bjBBc.uint8)
});
var $f7a6899246d76dab$var$$7707bdf21a3d89cc$export$2e2bcd8739ae039 = new $gI9iY.Array(new $hH3hY.Buffer);
class $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039 {
    getCFFVersion(ctx) {
        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
        return ctx ? ctx.version : -1;
    }
    decode(stream, parent) {
        let version = this.getCFFVersion(parent);
        let count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
        if (count === 0) return [];
        let offSize = stream.readUInt8();
        let offsetType;
        if (offSize === 1) offsetType = $bjBBc.uint8;
        else if (offSize === 2) offsetType = $bjBBc.uint16;
        else if (offSize === 3) offsetType = $bjBBc.uint24;
        else if (offSize === 4) offsetType = $bjBBc.uint32;
        else throw new Error(`Bad offset size in CFFIndex: ${offSize} ${stream.pos}`);
        let ret = [];
        let startPos = stream.pos + (count + 1) * offSize - 1;
        let start = offsetType.decode(stream);
        for(let i = 0; i < count; i++){
            let end = offsetType.decode(stream);
            if (this.type != null) {
                let pos = stream.pos;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
            } else ret.push({
                offset: startPos + start,
                length: end - start
            });
            start = end;
        }
        stream.pos = startPos + start;
        return ret;
    }
    size(arr, parent) {
        let size = 2;
        if (arr.length === 0) return size;
        let type = this.type || new $hH3hY.Buffer;
        // find maximum offset to detminine offset type
        let offset = 1;
        for(let i = 0; i < arr.length; i++){
            let item = arr[i];
            offset += type.size(item, parent);
        }
        let offsetType;
        if (offset <= 0xff) offsetType = $bjBBc.uint8;
        else if (offset <= 0xffff) offsetType = $bjBBc.uint16;
        else if (offset <= 0xffffff) offsetType = $bjBBc.uint24;
        else if (offset <= 0xffffffff) offsetType = $bjBBc.uint32;
        else throw new Error("Bad offset in CFFIndex");
        size += 1 + offsetType.size() * (arr.length + 1);
        size += offset - 1;
        return size;
    }
    encode(stream, arr, parent) {
        stream.writeUInt16BE(arr.length);
        if (arr.length === 0) return;
        let type = this.type || new $hH3hY.Buffer;
        // find maximum offset to detminine offset type
        let sizes = [];
        let offset = 1;
        for (let item of arr){
            let s = type.size(item, parent);
            sizes.push(s);
            offset += s;
        }
        let offsetType;
        if (offset <= 0xff) offsetType = $bjBBc.uint8;
        else if (offset <= 0xffff) offsetType = $bjBBc.uint16;
        else if (offset <= 0xffffff) offsetType = $bjBBc.uint24;
        else if (offset <= 0xffffffff) offsetType = $bjBBc.uint32;
        else throw new Error("Bad offset in CFFIndex");
        // write offset size
        stream.writeUInt8(offsetType.size());
        // write elements
        offset = 1;
        offsetType.encode(stream, offset);
        for (let size of sizes){
            offset += size;
            offsetType.encode(stream, offset);
        }
        for (let item of arr)type.encode(stream, item, parent);
        return;
    }
    constructor(type){
        this.type = type;
    }
}
const $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_EOF = 0xf;
const $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_LOOKUP = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    'E',
    'E-',
    null,
    '-'
];
const $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP = {
    '.': 10,
    'E': 11,
    'E-': 12,
    '-': 14
};
class $f7a6899246d76dab$var$$f77b592c17132d70$export$2e2bcd8739ae039 {
    static decode(stream, value) {
        if (32 <= value && value <= 246) return value - 139;
        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
        if (value === 28) return stream.readInt16BE();
        if (value === 29) return stream.readInt32BE();
        if (value === 30) {
            let str = '';
            while(true){
                let b = stream.readUInt8();
                let n1 = b >> 4;
                if (n1 === $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_EOF) break;
                str += $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_LOOKUP[n1];
                let n2 = b & 15;
                if (n2 === $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_EOF) break;
                str += $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_LOOKUP[n2];
            }
            return parseFloat(str);
        }
        return null;
    }
    static size(value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, set to 32768
        if (value.forceLarge) value = 32768;
        if ((value | 0) !== value) {
            let str = '' + value;
            return 1 + Math.ceil((str.length + 1) / 2);
        } else if (-107 <= value && value <= 107) return 1;
        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
        else if (-32768 <= value && value <= 32767) return 3;
        else return 5;
    }
    static encode(stream, value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, save the old value and set to 32768
        let val = Number(value);
        if (value.forceLarge) {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        } else if ((val | 0) !== val) {
            stream.writeUInt8(30);
            let str = '' + val;
            for(let i = 0; i < str.length; i += 2){
                let c1 = str[i];
                let n1 = $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP[c1] || +c1;
                if (i === str.length - 1) var n2 = $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_EOF;
                else {
                    let c2 = str[i + 1];
                    var n2 = $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }
                stream.writeUInt8(n1 << 4 | n2 & 15);
            }
            if (n2 !== $f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_EOF) return stream.writeUInt8($f7a6899246d76dab$var$$f77b592c17132d70$var$FLOAT_EOF << 4);
        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
        else if (108 <= val && val <= 1131) {
            val -= 108;
            stream.writeUInt8((val >> 8) + 247);
            return stream.writeUInt8(val & 0xff);
        } else if (-1131 <= val && val <= -108) {
            val = -val - 108;
            stream.writeUInt8((val >> 8) + 251);
            return stream.writeUInt8(val & 0xff);
        } else if (-32768 <= val && val <= 32767) {
            stream.writeUInt8(28);
            return stream.writeInt16BE(val);
        } else {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        }
    }
}
class $f7a6899246d76dab$var$$efe622f40a9c35bd$export$2e2bcd8739ae039 {
    decodeOperands(type, stream, ret, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.decodeOperands(type[i], stream, ret, [
                op
            ]));
        else if (type.decode != null) return type.decode(stream, ret, operands);
        else switch(type){
            case 'number':
            case 'offset':
            case 'sid':
                return operands[0];
            case 'boolean':
                return !!operands[0];
            default:
                return operands;
        }
    }
    encodeOperands(type, stream, ctx, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.encodeOperands(type[i], stream, ctx, op)[0]);
        else if (type.encode != null) return type.encode(stream, operands, ctx);
        else if (typeof operands === 'number') return [
            operands
        ];
        else if (typeof operands === 'boolean') return [
            +operands
        ];
        else if (Array.isArray(operands)) return operands;
        else return [
            operands
        ];
    }
    decode(stream, parent) {
        let end = stream.pos + parent.length;
        let ret = {};
        let operands = [];
        // define hidden properties
        Object.defineProperties(ret, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            }
        });
        // fill in defaults
        for(let key in this.fields){
            let field = this.fields[key];
            ret[field[1]] = field[3];
        }
        while(stream.pos < end){
            let b = stream.readUInt8();
            if (b < 28) {
                if (b === 12) b = b << 8 | stream.readUInt8();
                let field = this.fields[b];
                if (!field) throw new Error(`Unknown operator ${b}`);
                let val = this.decodeOperands(field[2], stream, ret, operands);
                if (val != null) {
                    if (val instanceof $d0Ff6.PropertyDescriptor) Object.defineProperty(ret, field[1], val);
                    else ret[field[1]] = val;
                }
                operands = [];
            } else operands.push($f7a6899246d76dab$var$$f77b592c17132d70$export$2e2bcd8739ae039.decode(stream, b));
        }
        return ret;
    }
    size(dict, parent, includePointers = true) {
        let ctx = {
            parent: parent,
            val: dict,
            pointerSize: 0,
            startOffset: parent.startOffset || 0
        };
        let len = 0;
        for(let k in this.fields){
            let field = this.fields[k];
            let val = dict[field[1]];
            if (val == null || $f7a6899246d76dab$var$$parcel$interopDefault($7hFx0)(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], null, ctx, val);
            for (let op of operands)len += $f7a6899246d76dab$var$$f77b592c17132d70$export$2e2bcd8739ae039.size(op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            len += key.length;
        }
        if (includePointers) len += ctx.pointerSize;
        return len;
    }
    encode(stream, dict, parent) {
        let ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: dict,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
        for (let field of this.ops){
            let val = dict[field[1]];
            if (val == null || $f7a6899246d76dab$var$$parcel$interopDefault($7hFx0)(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], stream, ctx, val);
            for (let op of operands)$f7a6899246d76dab$var$$f77b592c17132d70$export$2e2bcd8739ae039.encode(stream, op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            for (let op of key)stream.writeUInt8(op);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            let ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
        return;
    }
    constructor(ops = []){
        this.ops = ops;
        this.fields = {};
        for (let field of ops){
            let key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
            this.fields[key] = field;
        }
    }
}
class $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039 extends $erngl.Pointer {
    decode(stream, parent, operands) {
        this.offsetType = {
            decode: ()=>operands[0]
        };
        return super.decode(stream, parent, operands);
    }
    encode(stream, value, ctx) {
        if (!stream) {
            // compute the size (so ctx.pointerSize is correct)
            this.offsetType = {
                size: ()=>0
            };
            this.size(value, ctx);
            return [
                new $f7a6899246d76dab$var$$4aa1b0749c2770f8$var$Ptr(0)
            ];
        }
        let ptr = null;
        this.offsetType = {
            encode: (stream, val)=>ptr = val
        };
        super.encode(stream, value, ctx);
        return [
            new $f7a6899246d76dab$var$$4aa1b0749c2770f8$var$Ptr(ptr)
        ];
    }
    constructor(type, options = {}){
        if (options.type == null) options.type = 'global';
        super(null, type, options);
    }
}
class $f7a6899246d76dab$var$$4aa1b0749c2770f8$var$Ptr {
    valueOf() {
        return this.val;
    }
    constructor(val){
        this.val = val;
        this.forceLarge = true;
    }
}
class $f7a6899246d76dab$var$$15a0cbb3d09cf7ee$var$CFFBlendOp {
    static decode(stream, parent, operands) {
        let numBlends = operands.pop();
        // TODO: actually blend. For now just consume the deltas
        // since we don't use any of the values anyway.
        while(operands.length > numBlends)operands.pop();
    }
}
var $f7a6899246d76dab$var$$15a0cbb3d09cf7ee$export$2e2bcd8739ae039 = new $f7a6899246d76dab$var$$efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                    type                                          default
    [
        6,
        'BlueValues',
        'delta',
        null
    ],
    [
        7,
        'OtherBlues',
        'delta',
        null
    ],
    [
        8,
        'FamilyBlues',
        'delta',
        null
    ],
    [
        9,
        'FamilyOtherBlues',
        'delta',
        null
    ],
    [
        [
            12,
            9
        ],
        'BlueScale',
        'number',
        0.039625
    ],
    [
        [
            12,
            10
        ],
        'BlueShift',
        'number',
        7
    ],
    [
        [
            12,
            11
        ],
        'BlueFuzz',
        'number',
        1
    ],
    [
        10,
        'StdHW',
        'number',
        null
    ],
    [
        11,
        'StdVW',
        'number',
        null
    ],
    [
        [
            12,
            12
        ],
        'StemSnapH',
        'delta',
        null
    ],
    [
        [
            12,
            13
        ],
        'StemSnapV',
        'delta',
        null
    ],
    [
        [
            12,
            14
        ],
        'ForceBold',
        'boolean',
        false
    ],
    [
        [
            12,
            17
        ],
        'LanguageGroup',
        'number',
        0
    ],
    [
        [
            12,
            18
        ],
        'ExpansionFactor',
        'number',
        0.06
    ],
    [
        [
            12,
            19
        ],
        'initialRandomSeed',
        'number',
        0
    ],
    [
        20,
        'defaultWidthX',
        'number',
        0
    ],
    [
        21,
        'nominalWidthX',
        'number',
        0
    ],
    [
        22,
        'vsindex',
        'number',
        0
    ],
    [
        23,
        'blend',
        $f7a6899246d76dab$var$$15a0cbb3d09cf7ee$var$CFFBlendOp,
        null
    ],
    [
        19,
        'Subrs',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039(new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039, {
            type: 'local'
        }),
        null
    ]
]);
// Automatically generated from Appendix A of the CFF specification; do
// not edit. Length should be 391.
var $f7a6899246d76dab$var$$860d3574d7fa3a51$export$2e2bcd8739ae039 = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall",
    "001.000",
    "001.001",
    "001.002",
    "001.003",
    "Black",
    "Bold",
    "Book",
    "Light",
    "Medium",
    "Regular",
    "Roman",
    "Semibold"
];
let $f7a6899246d76dab$var$$c4ffe47cba1d7f36$export$dee0027060fa13bd = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    '',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    '',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    '',
    'questiondown',
    '',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    '',
    'ring',
    'cedilla',
    '',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'AE',
    '',
    'ordfeminine',
    '',
    '',
    '',
    '',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    '',
    '',
    '',
    '',
    '',
    'ae',
    '',
    '',
    '',
    'dotlessi',
    '',
    '',
    'lslash',
    'oslash',
    'oe',
    'germandbls'
];
let $f7a6899246d76dab$var$$c4ffe47cba1d7f36$export$4f58f497e14a53c3 = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    '',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    '',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    '',
    '',
    'isuperior',
    '',
    '',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    '',
    '',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    '',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    '',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    '',
    '',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    '',
    'Dotaccentsmall',
    '',
    '',
    'Macronsmall',
    '',
    '',
    'figuredash',
    'hypheninferior',
    '',
    '',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    '',
    '',
    '',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    '',
    '',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
let $f7a6899246d76dab$var$$1e7c7c16984e4427$export$c33b50336c234f16 = [
    '.notdef',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    'questiondown',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    'AE',
    'ordfeminine',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    'ae',
    'dotlessi',
    'lslash',
    'oslash',
    'oe',
    'germandbls',
    'onesuperior',
    'logicalnot',
    'mu',
    'trademark',
    'Eth',
    'onehalf',
    'plusminus',
    'Thorn',
    'onequarter',
    'divide',
    'brokenbar',
    'degree',
    'thorn',
    'threequarters',
    'twosuperior',
    'registered',
    'minus',
    'eth',
    'multiply',
    'threesuperior',
    'copyright',
    'Aacute',
    'Acircumflex',
    'Adieresis',
    'Agrave',
    'Aring',
    'Atilde',
    'Ccedilla',
    'Eacute',
    'Ecircumflex',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Ntilde',
    'Oacute',
    'Ocircumflex',
    'Odieresis',
    'Ograve',
    'Otilde',
    'Scaron',
    'Uacute',
    'Ucircumflex',
    'Udieresis',
    'Ugrave',
    'Yacute',
    'Ydieresis',
    'Zcaron',
    'aacute',
    'acircumflex',
    'adieresis',
    'agrave',
    'aring',
    'atilde',
    'ccedilla',
    'eacute',
    'ecircumflex',
    'edieresis',
    'egrave',
    'iacute',
    'icircumflex',
    'idieresis',
    'igrave',
    'ntilde',
    'oacute',
    'ocircumflex',
    'odieresis',
    'ograve',
    'otilde',
    'scaron',
    'uacute',
    'ucircumflex',
    'udieresis',
    'ugrave',
    'yacute',
    'ydieresis',
    'zcaron'
];
let $f7a6899246d76dab$var$$1e7c7c16984e4427$export$3ed0f9e1fee8d489 = [
    '.notdef',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    'Dotaccentsmall',
    'Macronsmall',
    'figuredash',
    'hypheninferior',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
let $f7a6899246d76dab$var$$1e7c7c16984e4427$export$dc28be11139d4120 = [
    '.notdef',
    'space',
    'dollaroldstyle',
    'dollarsuperior',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'hyphensuperior',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'centoldstyle',
    'figuredash',
    'hypheninferior',
    'onequarter',
    'onehalf',
    'threequarters',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior'
];
//########################
// Scripts and Languages #
//########################
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$LangSysTable = new $XqKmt.Struct({
    reserved: new $4cbQT.Reserved($bjBBc.uint16),
    reqFeatureIndex: $bjBBc.uint16,
    featureCount: $bjBBc.uint16,
    featureIndexes: new $gI9iY.Array($bjBBc.uint16, 'featureCount')
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$LangSysRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    langSys: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$LangSysTable, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$Script = new $XqKmt.Struct({
    defaultLangSys: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$LangSysTable),
    count: $bjBBc.uint16,
    langSysRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$LangSysRecord, 'count')
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$ScriptRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    script: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$Script, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$3e15fc05ce864229 = new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$ScriptRecord, $bjBBc.uint16);
//#######################
// Features and Lookups #
//#######################
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$FeatureParams = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    nameID: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$6e91cf7616333d5 = new $XqKmt.Struct({
    featureParams: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$FeatureParams),
    lookupCount: $bjBBc.uint16,
    lookupListIndexes: new $gI9iY.Array($bjBBc.uint16, 'lookupCount')
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$FeatureRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    feature: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$6e91cf7616333d5, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$aa18130def4b6cb4 = new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$FeatureRecord, $bjBBc.uint16);
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupFlags = new $XqKmt.Struct({
    markAttachmentType: $bjBBc.uint8,
    flags: new $5J5hB.Bitfield($bjBBc.uint8, [
        'rightToLeft',
        'ignoreBaseGlyphs',
        'ignoreLigatures',
        'ignoreMarks',
        'useMarkFilteringSet'
    ])
});
function $f7a6899246d76dab$var$$b6dd765146ad212a$export$df0008c6ff2da22a(SubTable) {
    let Lookup = new $XqKmt.Struct({
        lookupType: $bjBBc.uint16,
        flags: $f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupFlags,
        subTableCount: $bjBBc.uint16,
        subTables: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, SubTable), 'subTableCount'),
        markFilteringSet: new $jvb6m.Optional($bjBBc.uint16, (t)=>t.flags.flags.useMarkFilteringSet)
    });
    return new $1Oxaj.LazyArray(new $erngl.Pointer($bjBBc.uint16, Lookup), $bjBBc.uint16);
}
//#################
// Coverage Table #
//#################
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$RangeRecord = new $XqKmt.Struct({
    start: $bjBBc.uint16,
    end: $bjBBc.uint16,
    startCoverageIndex: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111 = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        glyphCount: $bjBBc.uint16,
        glyphs: new $gI9iY.Array($bjBBc.uint16, 'glyphCount')
    },
    2: {
        rangeCount: $bjBBc.uint16,
        rangeRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$RangeRecord, 'rangeCount')
    }
});
//#########################
// Class Definition Table #
//#########################
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$ClassRangeRecord = new $XqKmt.Struct({
    start: $bjBBc.uint16,
    end: $bjBBc.uint16,
    class: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71 = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        startGlyph: $bjBBc.uint16,
        glyphCount: $bjBBc.uint16,
        classValueArray: new $gI9iY.Array($bjBBc.uint16, 'glyphCount')
    },
    2: {
        classRangeCount: $bjBBc.uint16,
        classRangeRecord: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$ClassRangeRecord, 'classRangeCount')
    }
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10 = new $XqKmt.Struct({
    a: $bjBBc.uint16,
    b: $bjBBc.uint16,
    deltaFormat: $bjBBc.uint16
});
//#############################################
// Contextual Substitution/Positioning Tables #
//#############################################
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupRecord = new $XqKmt.Struct({
    sequenceIndex: $bjBBc.uint16,
    lookupListIndex: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$Rule = new $XqKmt.Struct({
    glyphCount: $bjBBc.uint16,
    lookupCount: $bjBBc.uint16,
    input: new $gI9iY.Array($bjBBc.uint16, (t)=>t.glyphCount - 1),
    lookupRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupRecord, 'lookupCount')
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$RuleSet = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$Rule), $bjBBc.uint16);
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$ClassRule = new $XqKmt.Struct({
    glyphCount: $bjBBc.uint16,
    lookupCount: $bjBBc.uint16,
    classes: new $gI9iY.Array($bjBBc.uint16, (t)=>t.glyphCount - 1),
    lookupRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupRecord, 'lookupCount')
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$ClassSet = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$ClassRule), $bjBBc.uint16);
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$841858b892ce1f4c = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        ruleSetCount: $bjBBc.uint16,
        ruleSets: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$RuleSet), 'ruleSetCount')
    },
    2: {
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        classDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71),
        classSetCnt: $bjBBc.uint16,
        classSet: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$ClassSet), 'classSetCnt')
    },
    3: {
        glyphCount: $bjBBc.uint16,
        lookupCount: $bjBBc.uint16,
        coverages: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111), 'glyphCount'),
        lookupRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupRecord, 'lookupCount')
    }
});
//######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$ChainRule = new $XqKmt.Struct({
    backtrackGlyphCount: $bjBBc.uint16,
    backtrack: new $gI9iY.Array($bjBBc.uint16, 'backtrackGlyphCount'),
    inputGlyphCount: $bjBBc.uint16,
    input: new $gI9iY.Array($bjBBc.uint16, (t)=>t.inputGlyphCount - 1),
    lookaheadGlyphCount: $bjBBc.uint16,
    lookahead: new $gI9iY.Array($bjBBc.uint16, 'lookaheadGlyphCount'),
    lookupCount: $bjBBc.uint16,
    lookupRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupRecord, 'lookupCount')
});
let $f7a6899246d76dab$var$$b6dd765146ad212a$var$ChainRuleSet = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$ChainRule), $bjBBc.uint16);
let $f7a6899246d76dab$var$$b6dd765146ad212a$export$5e6d09e6861162f6 = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        chainCount: $bjBBc.uint16,
        chainRuleSets: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$ChainRuleSet), 'chainCount')
    },
    2: {
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        backtrackClassDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71),
        inputClassDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71),
        lookaheadClassDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71),
        chainCount: $bjBBc.uint16,
        chainClassSet: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$var$ChainRuleSet), 'chainCount')
    },
    3: {
        backtrackGlyphCount: $bjBBc.uint16,
        backtrackCoverage: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111), 'backtrackGlyphCount'),
        inputGlyphCount: $bjBBc.uint16,
        inputCoverage: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111), 'inputGlyphCount'),
        lookaheadGlyphCount: $bjBBc.uint16,
        lookaheadCoverage: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111), 'lookaheadGlyphCount'),
        lookupCount: $bjBBc.uint16,
        lookupRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b6dd765146ad212a$var$LookupRecord, 'lookupCount')
    }
});
/*******************
 * Variation Store *
 *******************/ let $f7a6899246d76dab$var$$2e4adcda047b3383$var$F2DOT14 = new $bjBBc.Fixed(16, 'BE', 14);
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$RegionAxisCoordinates = new $XqKmt.Struct({
    startCoord: $f7a6899246d76dab$var$$2e4adcda047b3383$var$F2DOT14,
    peakCoord: $f7a6899246d76dab$var$$2e4adcda047b3383$var$F2DOT14,
    endCoord: $f7a6899246d76dab$var$$2e4adcda047b3383$var$F2DOT14
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$VariationRegionList = new $XqKmt.Struct({
    axisCount: $bjBBc.uint16,
    regionCount: $bjBBc.uint16,
    variationRegions: new $gI9iY.Array(new $gI9iY.Array($f7a6899246d76dab$var$$2e4adcda047b3383$var$RegionAxisCoordinates, 'axisCount'), 'regionCount')
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$DeltaSet = new $XqKmt.Struct({
    shortDeltas: new $gI9iY.Array($bjBBc.int16, (t)=>t.parent.shortDeltaCount),
    regionDeltas: new $gI9iY.Array($bjBBc.int8, (t)=>t.parent.regionIndexCount - t.parent.shortDeltaCount),
    deltas: (t)=>t.shortDeltas.concat(t.regionDeltas)
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$ItemVariationData = new $XqKmt.Struct({
    itemCount: $bjBBc.uint16,
    shortDeltaCount: $bjBBc.uint16,
    regionIndexCount: $bjBBc.uint16,
    regionIndexes: new $gI9iY.Array($bjBBc.uint16, 'regionIndexCount'),
    deltaSets: new $gI9iY.Array($f7a6899246d76dab$var$$2e4adcda047b3383$var$DeltaSet, 'itemCount')
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$export$fe1b122a2710f241 = new $XqKmt.Struct({
    format: $bjBBc.uint16,
    variationRegionList: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$var$VariationRegionList),
    variationDataCount: $bjBBc.uint16,
    itemVariationData: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$var$ItemVariationData), 'variationDataCount')
});
/**********************
 * Feature Variations *
 **********************/ let $f7a6899246d76dab$var$$2e4adcda047b3383$var$ConditionTable = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        axisIndex: $bjBBc.uint16,
        axisIndex: $bjBBc.uint16,
        filterRangeMinValue: $f7a6899246d76dab$var$$2e4adcda047b3383$var$F2DOT14,
        filterRangeMaxValue: $f7a6899246d76dab$var$$2e4adcda047b3383$var$F2DOT14
    }
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$ConditionSet = new $XqKmt.Struct({
    conditionCount: $bjBBc.uint16,
    conditionTable: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$var$ConditionTable), 'conditionCount')
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$FeatureTableSubstitutionRecord = new $XqKmt.Struct({
    featureIndex: $bjBBc.uint16,
    alternateFeatureTable: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$b6dd765146ad212a$export$6e91cf7616333d5, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$FeatureTableSubstitution = new $XqKmt.Struct({
    version: $bjBBc.fixed32,
    substitutionCount: $bjBBc.uint16,
    substitutions: new $gI9iY.Array($f7a6899246d76dab$var$$2e4adcda047b3383$var$FeatureTableSubstitutionRecord, 'substitutionCount')
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$var$FeatureVariationRecord = new $XqKmt.Struct({
    conditionSet: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$var$ConditionSet, {
        type: 'parent'
    }),
    featureTableSubstitution: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$var$FeatureTableSubstitution, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$2e4adcda047b3383$export$441b70b7971dd419 = new $XqKmt.Struct({
    majorVersion: $bjBBc.uint16,
    minorVersion: $bjBBc.uint16,
    featureVariationRecordCount: $bjBBc.uint32,
    featureVariationRecords: new $gI9iY.Array($f7a6899246d76dab$var$$2e4adcda047b3383$var$FeatureVariationRecord, 'featureVariationRecordCount')
});
// Checks if an operand is an index of a predefined value,
// otherwise delegates to the provided type.
class $f7a6899246d76dab$var$$5b547cf9e5da519b$var$PredefinedOp {
    decode(stream, parent, operands) {
        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
        return this.type.decode(stream, parent, operands);
    }
    size(value, ctx) {
        return this.type.size(value, ctx);
    }
    encode(stream, value, ctx) {
        let index = this.predefinedOps.indexOf(value);
        if (index !== -1) return index;
        return this.type.encode(stream, value, ctx);
    }
    constructor(predefinedOps, type){
        this.predefinedOps = predefinedOps;
        this.type = type;
    }
}
class $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFEncodingVersion extends $bjBBc.Number {
    decode(stream) {
        return $bjBBc.uint8.decode(stream) & 0x7f;
    }
    constructor(){
        super('UInt8');
    }
}
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$Range1 = new $XqKmt.Struct({
    first: $bjBBc.uint16,
    nLeft: $bjBBc.uint8
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$Range2 = new $XqKmt.Struct({
    first: $bjBBc.uint16,
    nLeft: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFCustomEncoding = new $gqRil.VersionedStruct(new $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFEncodingVersion(), {
    0: {
        nCodes: $bjBBc.uint8,
        codes: new $gI9iY.Array($bjBBc.uint8, 'nCodes')
    },
    1: {
        nRanges: $bjBBc.uint8,
        ranges: new $gI9iY.Array($f7a6899246d76dab$var$$5b547cf9e5da519b$var$Range1, 'nRanges')
    }
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFEncoding = new $f7a6899246d76dab$var$$5b547cf9e5da519b$var$PredefinedOp([
    $f7a6899246d76dab$var$$c4ffe47cba1d7f36$export$dee0027060fa13bd,
    $f7a6899246d76dab$var$$c4ffe47cba1d7f36$export$4f58f497e14a53c3
], new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFCustomEncoding, {
    lazy: true
}));
// Decodes an array of ranges until the total
// length is equal to the provided length.
class $f7a6899246d76dab$var$$5b547cf9e5da519b$var$RangeArray extends $gI9iY.Array {
    decode(stream, parent) {
        let length = (0, $d0Ff6.resolveLength)(this.length, stream, parent);
        let count = 0;
        let res = [];
        while(count < length){
            let range = this.type.decode(stream, parent);
            range.offset = count;
            count += range.nLeft + 1;
            res.push(range);
        }
        return res;
    }
}
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFCustomCharset = new $gqRil.VersionedStruct($bjBBc.uint8, {
    0: {
        glyphs: new $gI9iY.Array($bjBBc.uint16, (t)=>t.parent.CharStrings.length - 1)
    },
    1: {
        ranges: new $f7a6899246d76dab$var$$5b547cf9e5da519b$var$RangeArray($f7a6899246d76dab$var$$5b547cf9e5da519b$var$Range1, (t)=>t.parent.CharStrings.length - 1)
    },
    2: {
        ranges: new $f7a6899246d76dab$var$$5b547cf9e5da519b$var$RangeArray($f7a6899246d76dab$var$$5b547cf9e5da519b$var$Range2, (t)=>t.parent.CharStrings.length - 1)
    }
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFCharset = new $f7a6899246d76dab$var$$5b547cf9e5da519b$var$PredefinedOp([
    $f7a6899246d76dab$var$$1e7c7c16984e4427$export$c33b50336c234f16,
    $f7a6899246d76dab$var$$1e7c7c16984e4427$export$3ed0f9e1fee8d489,
    $f7a6899246d76dab$var$$1e7c7c16984e4427$export$dc28be11139d4120
], new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFCustomCharset, {
    lazy: true
}));
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$FDRange3 = new $XqKmt.Struct({
    first: $bjBBc.uint16,
    fd: $bjBBc.uint8
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$FDRange4 = new $XqKmt.Struct({
    first: $bjBBc.uint32,
    fd: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$FDSelect = new $gqRil.VersionedStruct($bjBBc.uint8, {
    0: {
        fds: new $gI9iY.Array($bjBBc.uint8, (t)=>t.parent.CharStrings.length)
    },
    3: {
        nRanges: $bjBBc.uint16,
        ranges: new $gI9iY.Array($f7a6899246d76dab$var$$5b547cf9e5da519b$var$FDRange3, 'nRanges'),
        sentinel: $bjBBc.uint16
    },
    4: {
        nRanges: $bjBBc.uint32,
        ranges: new $gI9iY.Array($f7a6899246d76dab$var$$5b547cf9e5da519b$var$FDRange4, 'nRanges'),
        sentinel: $bjBBc.uint32
    }
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$ptr = new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039($f7a6899246d76dab$var$$15a0cbb3d09cf7ee$export$2e2bcd8739ae039);
class $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFPrivateOp {
    decode(stream, parent, operands) {
        parent.length = operands[0];
        return $f7a6899246d76dab$var$$5b547cf9e5da519b$var$ptr.decode(stream, parent, [
            operands[1]
        ]);
    }
    size(dict, ctx) {
        return [
            $f7a6899246d76dab$var$$15a0cbb3d09cf7ee$export$2e2bcd8739ae039.size(dict, ctx, false),
            $f7a6899246d76dab$var$$5b547cf9e5da519b$var$ptr.size(dict, ctx)[0]
        ];
    }
    encode(stream, dict, ctx) {
        return [
            $f7a6899246d76dab$var$$15a0cbb3d09cf7ee$export$2e2bcd8739ae039.size(dict, ctx, false),
            $f7a6899246d76dab$var$$5b547cf9e5da519b$var$ptr.encode(stream, dict, ctx)[0]
        ];
    }
}
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$FontDict = new $f7a6899246d76dab$var$$efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        18,
        'Private',
        new $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ],
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        [
            12,
            5
        ],
        'PaintType',
        'number',
        0
    ]
]);
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFTopDict = new $f7a6899246d76dab$var$$efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        [
            12,
            30
        ],
        'ROS',
        [
            'sid',
            'sid',
            'number'
        ],
        null
    ],
    [
        0,
        'version',
        'sid',
        null
    ],
    [
        1,
        'Notice',
        'sid',
        null
    ],
    [
        [
            12,
            0
        ],
        'Copyright',
        'sid',
        null
    ],
    [
        2,
        'FullName',
        'sid',
        null
    ],
    [
        3,
        'FamilyName',
        'sid',
        null
    ],
    [
        4,
        'Weight',
        'sid',
        null
    ],
    [
        [
            12,
            1
        ],
        'isFixedPitch',
        'boolean',
        false
    ],
    [
        [
            12,
            2
        ],
        'ItalicAngle',
        'number',
        0
    ],
    [
        [
            12,
            3
        ],
        'UnderlinePosition',
        'number',
        -100
    ],
    [
        [
            12,
            4
        ],
        'UnderlineThickness',
        'number',
        50
    ],
    [
        [
            12,
            5
        ],
        'PaintType',
        'number',
        0
    ],
    [
        [
            12,
            6
        ],
        'CharstringType',
        'number',
        2
    ],
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        13,
        'UniqueID',
        'number',
        null
    ],
    [
        5,
        'FontBBox',
        'array',
        [
            0,
            0,
            0,
            0
        ]
    ],
    [
        [
            12,
            8
        ],
        'StrokeWidth',
        'number',
        0
    ],
    [
        14,
        'XUID',
        'array',
        null
    ],
    [
        15,
        'charset',
        $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFCharset,
        $f7a6899246d76dab$var$$1e7c7c16984e4427$export$c33b50336c234f16
    ],
    [
        16,
        'Encoding',
        $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFEncoding,
        $f7a6899246d76dab$var$$c4ffe47cba1d7f36$export$dee0027060fa13bd
    ],
    [
        17,
        'CharStrings',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039(new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039),
        null
    ],
    [
        18,
        'Private',
        new $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            20
        ],
        'SyntheticBase',
        'number',
        null
    ],
    [
        [
            12,
            21
        ],
        'PostScript',
        'sid',
        null
    ],
    [
        [
            12,
            22
        ],
        'BaseFontName',
        'sid',
        null
    ],
    [
        [
            12,
            23
        ],
        'BaseFontBlend',
        'delta',
        null
    ],
    // CID font specific
    [
        [
            12,
            31
        ],
        'CIDFontVersion',
        'number',
        0
    ],
    [
        [
            12,
            32
        ],
        'CIDFontRevision',
        'number',
        0
    ],
    [
        [
            12,
            33
        ],
        'CIDFontType',
        'number',
        0
    ],
    [
        [
            12,
            34
        ],
        'CIDCount',
        'number',
        8720
    ],
    [
        [
            12,
            35
        ],
        'UIDBase',
        'number',
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039(new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$FontDict)),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$VariationStore = new $XqKmt.Struct({
    length: $bjBBc.uint16,
    itemVariationStore: $f7a6899246d76dab$var$$2e4adcda047b3383$export$fe1b122a2710f241
});
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFF2TopDict = new $f7a6899246d76dab$var$$efe622f40a9c35bd$export$2e2bcd8739ae039([
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        17,
        'CharStrings',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039(new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039),
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039(new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$FontDict)),
        null
    ],
    [
        24,
        'vstore',
        new $f7a6899246d76dab$var$$4aa1b0749c2770f8$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$VariationStore),
        null
    ],
    [
        25,
        'maxstack',
        'number',
        193
    ]
]);
let $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFTop = new $gqRil.VersionedStruct($bjBBc.fixed16, {
    1: {
        hdrSize: $bjBBc.uint8,
        offSize: $bjBBc.uint8,
        nameIndex: new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039(new $1X3I0.String('length')),
        topDictIndex: new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039($f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFTopDict),
        stringIndex: new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039(new $1X3I0.String('length')),
        globalSubrIndex: new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039
    },
    2: {
        hdrSize: $bjBBc.uint8,
        length: $bjBBc.uint16,
        topDict: $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFF2TopDict,
        globalSubrIndex: new $f7a6899246d76dab$var$$9eaea3754914a290$export$2e2bcd8739ae039
    }
});
var $f7a6899246d76dab$var$$5b547cf9e5da519b$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$5b547cf9e5da519b$var$CFFTop;
class $f7a6899246d76dab$var$$f717432b360040c7$var$CFFFont {
    static decode(stream) {
        return new $f7a6899246d76dab$var$$f717432b360040c7$var$CFFFont(stream);
    }
    decode() {
        let start = this.stream.pos;
        let top = $f7a6899246d76dab$var$$5b547cf9e5da519b$export$2e2bcd8739ae039.decode(this.stream);
        for(let key in top){
            let val = top[key];
            this[key] = val;
        }
        if (this.version < 2) {
            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
            this.topDict = this.topDictIndex[0];
        }
        this.isCIDFont = this.topDict.ROS != null;
        return this;
    }
    string(sid) {
        if (this.version >= 2) return null;
        if (sid < $f7a6899246d76dab$var$$860d3574d7fa3a51$export$2e2bcd8739ae039.length) return $f7a6899246d76dab$var$$860d3574d7fa3a51$export$2e2bcd8739ae039[sid];
        return this.stringIndex[sid - $f7a6899246d76dab$var$$860d3574d7fa3a51$export$2e2bcd8739ae039.length];
    }
    get postscriptName() {
        if (this.version < 2) return this.nameIndex[0];
        return null;
    }
    get fullName() {
        return this.string(this.topDict.FullName);
    }
    get familyName() {
        return this.string(this.topDict.FamilyName);
    }
    getCharString(glyph) {
        this.stream.pos = this.topDict.CharStrings[glyph].offset;
        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
    }
    getGlyphName(gid) {
        // CFF2 glyph names are in the post table.
        if (this.version >= 2) return null;
        // CID-keyed fonts don't have glyph names
        if (this.isCIDFont) return null;
        let { charset: charset } = this.topDict;
        if (Array.isArray(charset)) return charset[gid];
        if (gid === 0) return '.notdef';
        gid -= 1;
        switch(charset.version){
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for(let i = 0; i < charset.ranges.length; i++){
                    let range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                }
                break;
        }
        return null;
    }
    fdForGlyph(gid) {
        if (!this.topDict.FDSelect) return null;
        switch(this.topDict.FDSelect.version){
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                let { ranges: ranges } = this.topDict.FDSelect;
                let low = 0;
                let high = ranges.length - 1;
                while(low <= high){
                    let mid = low + high >> 1;
                    if (gid < ranges[mid].first) high = mid - 1;
                    else if (mid < high && gid >= ranges[mid + 1].first) low = mid + 1;
                    else return ranges[mid].fd;
                }
            default:
                throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
        }
    }
    privateDictForGlyph(gid) {
        if (this.topDict.FDSelect) {
            let fd = this.fdForGlyph(gid);
            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
            return null;
        }
        if (this.version < 2) return this.topDict.Private;
        return this.topDict.FDArray[0].Private;
    }
    constructor(stream){
        this.stream = stream;
        this.decode();
    }
}
var $f7a6899246d76dab$var$$f717432b360040c7$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$f717432b360040c7$var$CFFFont;
let $f7a6899246d76dab$var$$8cb7ae73ed7aa7d8$var$VerticalOrigin = new $XqKmt.Struct({
    glyphIndex: $bjBBc.uint16,
    vertOriginY: $bjBBc.int16
});
var $f7a6899246d76dab$var$$8cb7ae73ed7aa7d8$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    majorVersion: $bjBBc.uint16,
    minorVersion: $bjBBc.uint16,
    defaultVertOriginY: $bjBBc.int16,
    numVertOriginYMetrics: $bjBBc.uint16,
    metrics: new $gI9iY.Array($f7a6899246d76dab$var$$8cb7ae73ed7aa7d8$var$VerticalOrigin, 'numVertOriginYMetrics')
});
let $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$16b227cb15d716a0 = new $XqKmt.Struct({
    height: $bjBBc.uint8,
    width: $bjBBc.uint8,
    horiBearingX: $bjBBc.int8,
    horiBearingY: $bjBBc.int8,
    horiAdvance: $bjBBc.uint8,
    vertBearingX: $bjBBc.int8,
    vertBearingY: $bjBBc.int8,
    vertAdvance: $bjBBc.uint8
});
let $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$62c53e75f69bfe12 = new $XqKmt.Struct({
    height: $bjBBc.uint8,
    width: $bjBBc.uint8,
    bearingX: $bjBBc.int8,
    bearingY: $bjBBc.int8,
    advance: $bjBBc.uint8
});
let $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$EBDTComponent = new $XqKmt.Struct({
    glyph: $bjBBc.uint16,
    xOffset: $bjBBc.int8,
    yOffset: $bjBBc.int8
});
class $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$ByteAligned {
}
class $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$BitAligned {
}
let $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$f1f5ddeb20d14f = new $gqRil.VersionedStruct('version', {
    1: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$62c53e75f69bfe12,
        data: $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$ByteAligned
    },
    2: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$62c53e75f69bfe12,
        data: $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$BitAligned
    },
    // format 3 is deprecated
    // format 4 is not supported by Microsoft
    5: {
        data: $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$BitAligned
    },
    6: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$16b227cb15d716a0,
        data: $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$ByteAligned
    },
    7: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$16b227cb15d716a0,
        data: $f7a6899246d76dab$var$$20e0c7bbecb76d75$var$BitAligned
    },
    8: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$62c53e75f69bfe12,
        pad: new $4cbQT.Reserved($bjBBc.uint8),
        numComponents: $bjBBc.uint16,
        components: new $gI9iY.Array($f7a6899246d76dab$var$$20e0c7bbecb76d75$var$EBDTComponent, 'numComponents')
    },
    9: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$16b227cb15d716a0,
        pad: new $4cbQT.Reserved($bjBBc.uint8),
        numComponents: $bjBBc.uint16,
        components: new $gI9iY.Array($f7a6899246d76dab$var$$20e0c7bbecb76d75$var$EBDTComponent, 'numComponents')
    },
    17: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$62c53e75f69bfe12,
        dataLen: $bjBBc.uint32,
        data: new $hH3hY.Buffer('dataLen')
    },
    18: {
        metrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$16b227cb15d716a0,
        dataLen: $bjBBc.uint32,
        data: new $hH3hY.Buffer('dataLen')
    },
    19: {
        dataLen: $bjBBc.uint32,
        data: new $hH3hY.Buffer('dataLen')
    }
});
let $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$SBitLineMetrics = new $XqKmt.Struct({
    ascender: $bjBBc.int8,
    descender: $bjBBc.int8,
    widthMax: $bjBBc.uint8,
    caretSlopeNumerator: $bjBBc.int8,
    caretSlopeDenominator: $bjBBc.int8,
    caretOffset: $bjBBc.int8,
    minOriginSB: $bjBBc.int8,
    minAdvanceSB: $bjBBc.int8,
    maxBeforeBL: $bjBBc.int8,
    minAfterBL: $bjBBc.int8,
    pad: new $4cbQT.Reserved($bjBBc.int8, 2)
});
let $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$CodeOffsetPair = new $XqKmt.Struct({
    glyphCode: $bjBBc.uint16,
    offset: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$IndexSubtable = new $gqRil.VersionedStruct($bjBBc.uint16, {
    header: {
        imageFormat: $bjBBc.uint16,
        imageDataOffset: $bjBBc.uint32
    },
    1: {
        offsetArray: new $gI9iY.Array($bjBBc.uint32, (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    2: {
        imageSize: $bjBBc.uint32,
        bigMetrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$16b227cb15d716a0
    },
    3: {
        offsetArray: new $gI9iY.Array($bjBBc.uint16, (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    4: {
        numGlyphs: $bjBBc.uint32,
        glyphArray: new $gI9iY.Array($f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$CodeOffsetPair, (t)=>t.numGlyphs + 1)
    },
    5: {
        imageSize: $bjBBc.uint32,
        bigMetrics: $f7a6899246d76dab$var$$20e0c7bbecb76d75$export$16b227cb15d716a0,
        numGlyphs: $bjBBc.uint32,
        glyphCodeArray: new $gI9iY.Array($bjBBc.uint16, 'numGlyphs')
    }
});
let $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$IndexSubtableArray = new $XqKmt.Struct({
    firstGlyphIndex: $bjBBc.uint16,
    lastGlyphIndex: $bjBBc.uint16,
    subtable: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$IndexSubtable)
});
let $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$BitmapSizeTable = new $XqKmt.Struct({
    indexSubTableArray: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$IndexSubtableArray, 1), {
        type: 'parent'
    }),
    indexTablesSize: $bjBBc.uint32,
    numberOfIndexSubTables: $bjBBc.uint32,
    colorRef: $bjBBc.uint32,
    hori: $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$SBitLineMetrics,
    vert: $f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$SBitLineMetrics,
    startGlyphIndex: $bjBBc.uint16,
    endGlyphIndex: $bjBBc.uint16,
    ppemX: $bjBBc.uint8,
    ppemY: $bjBBc.uint8,
    bitDepth: $bjBBc.uint8,
    flags: new $5J5hB.Bitfield($bjBBc.uint8, [
        'horizontal',
        'vertical'
    ])
});
var $f7a6899246d76dab$var$$035bb95c0cdb1f6d$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint32,
    numSizes: $bjBBc.uint32,
    sizes: new $gI9iY.Array($f7a6899246d76dab$var$$035bb95c0cdb1f6d$var$BitmapSizeTable, 'numSizes')
});
let $f7a6899246d76dab$var$$73d13900b55a3c0c$var$ImageTable = new $XqKmt.Struct({
    ppem: $bjBBc.uint16,
    resolution: $bjBBc.uint16,
    imageOffsets: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint32, 'void'), (t)=>t.parent.parent.maxp.numGlyphs + 1)
});
var // It includes several image tables with images for each bitmap glyph
// of several different sizes.
$f7a6899246d76dab$var$$73d13900b55a3c0c$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    flags: new $5J5hB.Bitfield($bjBBc.uint16, [
        'renderOutlines'
    ]),
    numImgTables: $bjBBc.uint32,
    imageTables: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$73d13900b55a3c0c$var$ImageTable), 'numImgTables')
});
let $f7a6899246d76dab$var$$97f6b8be3a347a8f$var$LayerRecord = new $XqKmt.Struct({
    gid: $bjBBc.uint16,
    paletteIndex: $bjBBc.uint16 // Index value to use in the appropriate palette. This value must
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.
let $f7a6899246d76dab$var$$97f6b8be3a347a8f$var$BaseGlyphRecord = new $XqKmt.Struct({
    gid: $bjBBc.uint16,
    // and is not rendered for color.
    firstLayerIndex: $bjBBc.uint16,
    // There will be numLayers consecutive entries for this base glyph.
    numLayers: $bjBBc.uint16
});
var $f7a6899246d76dab$var$$97f6b8be3a347a8f$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    numBaseGlyphRecords: $bjBBc.uint16,
    baseGlyphRecord: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($f7a6899246d76dab$var$$97f6b8be3a347a8f$var$BaseGlyphRecord, 'numBaseGlyphRecords')),
    layerRecords: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($f7a6899246d76dab$var$$97f6b8be3a347a8f$var$LayerRecord, 'numLayerRecords'), {
        lazy: true
    }),
    numLayerRecords: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$16ca60ecbdee30ea$var$ColorRecord = new $XqKmt.Struct({
    blue: $bjBBc.uint8,
    green: $bjBBc.uint8,
    red: $bjBBc.uint8,
    alpha: $bjBBc.uint8
});
var $f7a6899246d76dab$var$$16ca60ecbdee30ea$export$2e2bcd8739ae039 = new $gqRil.VersionedStruct($bjBBc.uint16, {
    header: {
        numPaletteEntries: $bjBBc.uint16,
        numPalettes: $bjBBc.uint16,
        numColorRecords: $bjBBc.uint16,
        colorRecords: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($f7a6899246d76dab$var$$16ca60ecbdee30ea$var$ColorRecord, 'numColorRecords')),
        colorRecordIndices: new $gI9iY.Array($bjBBc.uint16, 'numPalettes')
    },
    0: {},
    1: {
        offsetPaletteTypeArray: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($bjBBc.uint32, 'numPalettes')),
        offsetPaletteLabelArray: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($bjBBc.uint16, 'numPalettes')),
        offsetPaletteEntryLabelArray: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($bjBBc.uint16, 'numPaletteEntries'))
    }
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseCoord = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        coordinate: $bjBBc.int16 // X or Y value, in design units
    },
    2: {
        coordinate: $bjBBc.int16,
        referenceGlyph: $bjBBc.uint16,
        baseCoordPoint: $bjBBc.uint16 // Index of contour point on the referenceGlyph
    },
    3: {
        coordinate: $bjBBc.int16,
        deviceTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10) // Device table for X or Y value
    }
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseValues = new $XqKmt.Struct({
    defaultIndex: $bjBBc.uint16,
    baseCoordCount: $bjBBc.uint16,
    baseCoords: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseCoord), 'baseCoordCount')
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$FeatMinMaxRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    minCoord: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseCoord, {
        type: 'parent'
    }),
    maxCoord: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseCoord, {
        type: 'parent'
    }) // May be NULL
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$MinMax = new $XqKmt.Struct({
    minCoord: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseCoord),
    maxCoord: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseCoord),
    featMinMaxCount: $bjBBc.uint16,
    featMinMaxRecords: new $gI9iY.Array($f7a6899246d76dab$var$$7327e41706f9d5c7$var$FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseLangSysRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    minMax: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$MinMax, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseScript = new $XqKmt.Struct({
    baseValues: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseValues),
    defaultMinMax: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$MinMax),
    baseLangSysCount: $bjBBc.uint16,
    baseLangSysRecords: new $gI9iY.Array($f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseScriptRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    script: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseScript, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseScriptList = new $gI9iY.Array($f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseScriptRecord, $bjBBc.uint16);
// Array of 4-byte baseline identification tags-must be in alphabetical order
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseTagList = new $gI9iY.Array(new $1X3I0.String(4), $bjBBc.uint16);
let $f7a6899246d76dab$var$$7327e41706f9d5c7$var$Axis = new $XqKmt.Struct({
    baseTagList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseTagList),
    baseScriptList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$BaseScriptList)
});
var $f7a6899246d76dab$var$$7327e41706f9d5c7$export$2e2bcd8739ae039 = new $gqRil.VersionedStruct($bjBBc.uint32, {
    header: {
        horizAxis: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$Axis),
        vertAxis: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7327e41706f9d5c7$var$Axis) // May be NULL
    },
    0x00010000: {},
    0x00010001: {
        itemVariationStore: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$export$fe1b122a2710f241)
    }
});
let $f7a6899246d76dab$var$$7e48bbe9e5345664$var$AttachPoint = new $gI9iY.Array($bjBBc.uint16, $bjBBc.uint16);
let $f7a6899246d76dab$var$$7e48bbe9e5345664$var$AttachList = new $XqKmt.Struct({
    coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
    glyphCount: $bjBBc.uint16,
    attachPoints: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7e48bbe9e5345664$var$AttachPoint), 'glyphCount')
});
let $f7a6899246d76dab$var$$7e48bbe9e5345664$var$CaretValue = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        coordinate: $bjBBc.int16
    },
    2: {
        caretValuePoint: $bjBBc.uint16
    },
    3: {
        coordinate: $bjBBc.int16,
        deviceTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10)
    }
});
let $f7a6899246d76dab$var$$7e48bbe9e5345664$var$LigGlyph = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7e48bbe9e5345664$var$CaretValue), $bjBBc.uint16);
let $f7a6899246d76dab$var$$7e48bbe9e5345664$var$LigCaretList = new $XqKmt.Struct({
    coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
    ligGlyphCount: $bjBBc.uint16,
    ligGlyphs: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7e48bbe9e5345664$var$LigGlyph), 'ligGlyphCount')
});
let $f7a6899246d76dab$var$$7e48bbe9e5345664$var$MarkGlyphSetsDef = new $XqKmt.Struct({
    markSetTableFormat: $bjBBc.uint16,
    markSetCount: $bjBBc.uint16,
    coverage: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111), 'markSetCount')
});
var $f7a6899246d76dab$var$$7e48bbe9e5345664$export$2e2bcd8739ae039 = new $gqRil.VersionedStruct($bjBBc.uint32, {
    header: {
        glyphClassDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71),
        attachList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7e48bbe9e5345664$var$AttachList),
        ligCaretList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7e48bbe9e5345664$var$LigCaretList),
        markAttachClassDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71)
    },
    0x00010000: {},
    0x00010002: {
        markGlyphSetsDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7e48bbe9e5345664$var$MarkGlyphSetsDef)
    },
    0x00010003: {
        markGlyphSetsDef: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$7e48bbe9e5345664$var$MarkGlyphSetsDef),
        itemVariationStore: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$export$fe1b122a2710f241)
    }
});
let $f7a6899246d76dab$var$$b687332511a4da75$var$ValueFormat = new $5J5hB.Bitfield($bjBBc.uint16, [
    'xPlacement',
    'yPlacement',
    'xAdvance',
    'yAdvance',
    'xPlaDevice',
    'yPlaDevice',
    'xAdvDevice',
    'yAdvDevice'
]);
let $f7a6899246d76dab$var$$b687332511a4da75$var$types = {
    xPlacement: $bjBBc.int16,
    yPlacement: $bjBBc.int16,
    xAdvance: $bjBBc.int16,
    yAdvance: $bjBBc.int16,
    xPlaDevice: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    }),
    yPlaDevice: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    }),
    xAdvDevice: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    }),
    yAdvDevice: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    })
};
class $f7a6899246d76dab$var$$b687332511a4da75$var$ValueRecord {
    buildStruct(parent) {
        let struct = parent;
        while(!struct[this.key] && struct.parent)struct = struct.parent;
        if (!struct[this.key]) return;
        let fields = {};
        fields.rel = ()=>struct._startOffset;
        let format = struct[this.key];
        for(let key in format)if (format[key]) fields[key] = $f7a6899246d76dab$var$$b687332511a4da75$var$types[key];
        return new $XqKmt.Struct(fields);
    }
    size(val, ctx) {
        return this.buildStruct(ctx).size(val, ctx);
    }
    decode(stream, parent) {
        let res = this.buildStruct(parent).decode(stream, parent);
        delete res.rel;
        return res;
    }
    constructor(key = 'valueFormat'){
        this.key = key;
    }
}
let $f7a6899246d76dab$var$$b687332511a4da75$var$PairValueRecord = new $XqKmt.Struct({
    secondGlyph: $bjBBc.uint16,
    value1: new $f7a6899246d76dab$var$$b687332511a4da75$var$ValueRecord('valueFormat1'),
    value2: new $f7a6899246d76dab$var$$b687332511a4da75$var$ValueRecord('valueFormat2')
});
let $f7a6899246d76dab$var$$b687332511a4da75$var$PairSet = new $gI9iY.Array($f7a6899246d76dab$var$$b687332511a4da75$var$PairValueRecord, $bjBBc.uint16);
let $f7a6899246d76dab$var$$b687332511a4da75$var$Class2Record = new $XqKmt.Struct({
    value1: new $f7a6899246d76dab$var$$b687332511a4da75$var$ValueRecord('valueFormat1'),
    value2: new $f7a6899246d76dab$var$$b687332511a4da75$var$ValueRecord('valueFormat2')
});
let $f7a6899246d76dab$var$$b687332511a4da75$var$Anchor = new $gqRil.VersionedStruct($bjBBc.uint16, {
    1: {
        xCoordinate: $bjBBc.int16,
        yCoordinate: $bjBBc.int16
    },
    2: {
        xCoordinate: $bjBBc.int16,
        yCoordinate: $bjBBc.int16,
        anchorPoint: $bjBBc.uint16
    },
    3: {
        xCoordinate: $bjBBc.int16,
        yCoordinate: $bjBBc.int16,
        xDeviceTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10),
        yDeviceTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$8215d14a63d9fb10)
    }
});
let $f7a6899246d76dab$var$$b687332511a4da75$var$EntryExitRecord = new $XqKmt.Struct({
    entryAnchor: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$Anchor, {
        type: 'parent'
    }),
    exitAnchor: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$Anchor, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$b687332511a4da75$var$MarkRecord = new $XqKmt.Struct({
    class: $bjBBc.uint16,
    markAnchor: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$Anchor, {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$b687332511a4da75$var$MarkArray = new $gI9iY.Array($f7a6899246d76dab$var$$b687332511a4da75$var$MarkRecord, $bjBBc.uint16);
let $f7a6899246d76dab$var$$b687332511a4da75$var$BaseRecord = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$Anchor), (t)=>t.parent.classCount);
let $f7a6899246d76dab$var$$b687332511a4da75$var$BaseArray = new $gI9iY.Array($f7a6899246d76dab$var$$b687332511a4da75$var$BaseRecord, $bjBBc.uint16);
let $f7a6899246d76dab$var$$b687332511a4da75$var$ComponentRecord = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$Anchor), (t)=>t.parent.parent.classCount);
let $f7a6899246d76dab$var$$b687332511a4da75$var$LigatureAttach = new $gI9iY.Array($f7a6899246d76dab$var$$b687332511a4da75$var$ComponentRecord, $bjBBc.uint16);
let $f7a6899246d76dab$var$$b687332511a4da75$var$LigatureArray = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$LigatureAttach), $bjBBc.uint16);
let $f7a6899246d76dab$var$$b687332511a4da75$export$73a8cfb19cd43a0f = new $gqRil.VersionedStruct('lookupType', {
    1: new $gqRil.VersionedStruct($bjBBc.uint16, {
        1: {
            coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat: $f7a6899246d76dab$var$$b687332511a4da75$var$ValueFormat,
            value: new $f7a6899246d76dab$var$$b687332511a4da75$var$ValueRecord()
        },
        2: {
            coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat: $f7a6899246d76dab$var$$b687332511a4da75$var$ValueFormat,
            valueCount: $bjBBc.uint16,
            values: new $1Oxaj.LazyArray(new $f7a6899246d76dab$var$$b687332511a4da75$var$ValueRecord(), 'valueCount')
        }
    }),
    2: new $gqRil.VersionedStruct($bjBBc.uint16, {
        1: {
            coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat1: $f7a6899246d76dab$var$$b687332511a4da75$var$ValueFormat,
            valueFormat2: $f7a6899246d76dab$var$$b687332511a4da75$var$ValueFormat,
            pairSetCount: $bjBBc.uint16,
            pairSets: new $1Oxaj.LazyArray(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$PairSet), 'pairSetCount')
        },
        2: {
            coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat1: $f7a6899246d76dab$var$$b687332511a4da75$var$ValueFormat,
            valueFormat2: $f7a6899246d76dab$var$$b687332511a4da75$var$ValueFormat,
            classDef1: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71),
            classDef2: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$843d551fbbafef71),
            class1Count: $bjBBc.uint16,
            class2Count: $bjBBc.uint16,
            classRecords: new $1Oxaj.LazyArray(new $1Oxaj.LazyArray($f7a6899246d76dab$var$$b687332511a4da75$var$Class2Record, 'class2Count'), 'class1Count')
        }
    }),
    3: {
        format: $bjBBc.uint16,
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        entryExitCount: $bjBBc.uint16,
        entryExitRecords: new $gI9iY.Array($f7a6899246d76dab$var$$b687332511a4da75$var$EntryExitRecord, 'entryExitCount')
    },
    4: {
        format: $bjBBc.uint16,
        markCoverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        baseCoverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $bjBBc.uint16,
        markArray: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$MarkArray),
        baseArray: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$BaseArray)
    },
    5: {
        format: $bjBBc.uint16,
        markCoverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        ligatureCoverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $bjBBc.uint16,
        markArray: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$MarkArray),
        ligatureArray: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$LigatureArray)
    },
    6: {
        format: $bjBBc.uint16,
        mark1Coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        mark2Coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $bjBBc.uint16,
        mark1Array: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$MarkArray),
        mark2Array: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b687332511a4da75$var$BaseArray)
    },
    7: $f7a6899246d76dab$var$$b6dd765146ad212a$export$841858b892ce1f4c,
    8: $f7a6899246d76dab$var$$b6dd765146ad212a$export$5e6d09e6861162f6,
    9: {
        posFormat: $bjBBc.uint16,
        lookupType: $bjBBc.uint16,
        extension: new $erngl.Pointer($bjBBc.uint32, null)
    }
});
// Fix circular reference
$f7a6899246d76dab$var$$b687332511a4da75$export$73a8cfb19cd43a0f.versions[9].extension.type = $f7a6899246d76dab$var$$b687332511a4da75$export$73a8cfb19cd43a0f;
var $f7a6899246d76dab$var$$b687332511a4da75$export$2e2bcd8739ae039 = new $gqRil.VersionedStruct($bjBBc.uint32, {
    header: {
        scriptList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$3e15fc05ce864229),
        featureList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$aa18130def4b6cb4),
        lookupList: new $erngl.Pointer($bjBBc.uint16, new $f7a6899246d76dab$var$$b6dd765146ad212a$export$df0008c6ff2da22a($f7a6899246d76dab$var$$b687332511a4da75$export$73a8cfb19cd43a0f))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$export$441b70b7971dd419)
    }
});
let $f7a6899246d76dab$var$$99ccad60b96f92fb$var$Sequence = new $gI9iY.Array($bjBBc.uint16, $bjBBc.uint16);
let $f7a6899246d76dab$var$$99ccad60b96f92fb$var$AlternateSet = $f7a6899246d76dab$var$$99ccad60b96f92fb$var$Sequence;
let $f7a6899246d76dab$var$$99ccad60b96f92fb$var$Ligature = new $XqKmt.Struct({
    glyph: $bjBBc.uint16,
    compCount: $bjBBc.uint16,
    components: new $gI9iY.Array($bjBBc.uint16, (t)=>t.compCount - 1)
});
let $f7a6899246d76dab$var$$99ccad60b96f92fb$var$LigatureSet = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$99ccad60b96f92fb$var$Ligature), $bjBBc.uint16);
let $f7a6899246d76dab$var$$99ccad60b96f92fb$var$GSUBLookup = new $gqRil.VersionedStruct('lookupType', {
    1: new $gqRil.VersionedStruct($bjBBc.uint16, {
        1: {
            coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
            deltaGlyphID: $bjBBc.int16
        },
        2: {
            coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
            glyphCount: $bjBBc.uint16,
            substitute: new $1Oxaj.LazyArray($bjBBc.uint16, 'glyphCount')
        }
    }),
    2: {
        substFormat: $bjBBc.uint16,
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        count: $bjBBc.uint16,
        sequences: new $1Oxaj.LazyArray(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$99ccad60b96f92fb$var$Sequence), 'count')
    },
    3: {
        substFormat: $bjBBc.uint16,
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        count: $bjBBc.uint16,
        alternateSet: new $1Oxaj.LazyArray(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$99ccad60b96f92fb$var$AlternateSet), 'count')
    },
    4: {
        substFormat: $bjBBc.uint16,
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        count: $bjBBc.uint16,
        ligatureSets: new $1Oxaj.LazyArray(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$99ccad60b96f92fb$var$LigatureSet), 'count')
    },
    5: $f7a6899246d76dab$var$$b6dd765146ad212a$export$841858b892ce1f4c,
    6: $f7a6899246d76dab$var$$b6dd765146ad212a$export$5e6d09e6861162f6,
    7: {
        substFormat: $bjBBc.uint16,
        lookupType: $bjBBc.uint16,
        extension: new $erngl.Pointer($bjBBc.uint32, null)
    },
    8: {
        substFormat: $bjBBc.uint16,
        coverage: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111),
        backtrackCoverage: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111), 'backtrackGlyphCount'),
        lookaheadGlyphCount: $bjBBc.uint16,
        lookaheadCoverage: new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$17608c3f81a6111), 'lookaheadGlyphCount'),
        glyphCount: $bjBBc.uint16,
        substitutes: new $gI9iY.Array($bjBBc.uint16, 'glyphCount')
    }
});
// Fix circular reference
$f7a6899246d76dab$var$$99ccad60b96f92fb$var$GSUBLookup.versions[7].extension.type = $f7a6899246d76dab$var$$99ccad60b96f92fb$var$GSUBLookup;
var $f7a6899246d76dab$var$$99ccad60b96f92fb$export$2e2bcd8739ae039 = new $gqRil.VersionedStruct($bjBBc.uint32, {
    header: {
        scriptList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$3e15fc05ce864229),
        featureList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$b6dd765146ad212a$export$aa18130def4b6cb4),
        lookupList: new $erngl.Pointer($bjBBc.uint16, new $f7a6899246d76dab$var$$b6dd765146ad212a$export$df0008c6ff2da22a($f7a6899246d76dab$var$$99ccad60b96f92fb$var$GSUBLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$export$441b70b7971dd419)
    }
});
let $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList = new $gI9iY.Array($bjBBc.uint16, $bjBBc.uint16);
let $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfPriority = new $XqKmt.Struct({
    shrinkageEnableGSUB: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    shrinkageDisableGSUB: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    shrinkageEnableGPOS: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    shrinkageDisableGPOS: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    shrinkageJstfMax: new $erngl.Pointer($bjBBc.uint16, new $f7a6899246d76dab$var$$b6dd765146ad212a$export$df0008c6ff2da22a($f7a6899246d76dab$var$$b687332511a4da75$export$73a8cfb19cd43a0f)),
    extensionEnableGSUB: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    extensionDisableGSUB: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    extensionEnableGPOS: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    extensionDisableGPOS: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfGSUBModList),
    extensionJstfMax: new $erngl.Pointer($bjBBc.uint16, new $f7a6899246d76dab$var$$b6dd765146ad212a$export$df0008c6ff2da22a($f7a6899246d76dab$var$$b687332511a4da75$export$73a8cfb19cd43a0f))
});
let $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfLangSys = new $gI9iY.Array(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfPriority), $bjBBc.uint16);
let $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfLangSysRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    jstfLangSys: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfLangSys)
});
let $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfScript = new $XqKmt.Struct({
    extenderGlyphs: new $erngl.Pointer($bjBBc.uint16, new $gI9iY.Array($bjBBc.uint16, $bjBBc.uint16)),
    defaultLangSys: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfLangSys),
    langSysCount: $bjBBc.uint16,
    langSysRecords: new $gI9iY.Array($f7a6899246d76dab$var$$573d5042c76c4940$var$JstfLangSysRecord, 'langSysCount')
});
let $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfScriptRecord = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    script: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$573d5042c76c4940$var$JstfScript, {
        type: 'parent'
    })
});
var $f7a6899246d76dab$var$$573d5042c76c4940$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint32,
    scriptCount: $bjBBc.uint16,
    scriptList: new $gI9iY.Array($f7a6899246d76dab$var$$573d5042c76c4940$var$JstfScriptRecord, 'scriptCount')
});
// TODO: add this to restructure
class $f7a6899246d76dab$var$$a5875b80d6087f61$var$VariableSizeNumber {
    decode(stream, parent) {
        switch(this.size(0, parent)){
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
        }
    }
    size(val, parent) {
        return (0, $d0Ff6.resolveLength)(this._size, null, parent);
    }
    constructor(size){
        this._size = size;
    }
}
let $f7a6899246d76dab$var$$a5875b80d6087f61$var$MapDataEntry = new $XqKmt.Struct({
    entry: new $f7a6899246d76dab$var$$a5875b80d6087f61$var$VariableSizeNumber((t)=>((t.parent.entryFormat & 0x0030) >> 4) + 1),
    outerIndex: (t)=>t.entry >> (t.parent.entryFormat & 0x000F) + 1,
    innerIndex: (t)=>t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1
});
let $f7a6899246d76dab$var$$a5875b80d6087f61$var$DeltaSetIndexMap = new $XqKmt.Struct({
    entryFormat: $bjBBc.uint16,
    mapCount: $bjBBc.uint16,
    mapData: new $gI9iY.Array($f7a6899246d76dab$var$$a5875b80d6087f61$var$MapDataEntry, 'mapCount')
});
var $f7a6899246d76dab$var$$a5875b80d6087f61$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    majorVersion: $bjBBc.uint16,
    minorVersion: $bjBBc.uint16,
    itemVariationStore: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$2e4adcda047b3383$export$fe1b122a2710f241),
    advanceWidthMapping: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$a5875b80d6087f61$var$DeltaSetIndexMap),
    LSBMapping: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$a5875b80d6087f61$var$DeltaSetIndexMap),
    RSBMapping: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$a5875b80d6087f61$var$DeltaSetIndexMap)
});
let $f7a6899246d76dab$var$$4423bc1ac09bbbd1$var$Signature = new $XqKmt.Struct({
    format: $bjBBc.uint32,
    length: $bjBBc.uint32,
    offset: $bjBBc.uint32
});
let $f7a6899246d76dab$var$$4423bc1ac09bbbd1$var$SignatureBlock = new $XqKmt.Struct({
    reserved: new $4cbQT.Reserved($bjBBc.uint16, 2),
    cbSignature: $bjBBc.uint32,
    signature: new $hH3hY.Buffer('cbSignature')
});
var $f7a6899246d76dab$var$$4423bc1ac09bbbd1$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    ulVersion: $bjBBc.uint32,
    usNumSigs: $bjBBc.uint16,
    usFlag: $bjBBc.uint16,
    signatures: new $gI9iY.Array($f7a6899246d76dab$var$$4423bc1ac09bbbd1$var$Signature, 'usNumSigs'),
    signatureBlocks: new $gI9iY.Array($f7a6899246d76dab$var$$4423bc1ac09bbbd1$var$SignatureBlock, 'usNumSigs')
});
let $f7a6899246d76dab$var$$7b50e3f8d83263de$var$GaspRange = new $XqKmt.Struct({
    rangeMaxPPEM: $bjBBc.uint16,
    rangeGaspBehavior: new $5J5hB.Bitfield($bjBBc.uint16, [
        'grayscale',
        'gridfit',
        'symmetricSmoothing',
        'symmetricGridfit' // only in version 1, for ClearType
    ])
});
var $f7a6899246d76dab$var$$7b50e3f8d83263de$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    numRanges: $bjBBc.uint16,
    gaspRanges: new $gI9iY.Array($f7a6899246d76dab$var$$7b50e3f8d83263de$var$GaspRange, 'numRanges') // Sorted by ppem
});
let $f7a6899246d76dab$var$$7bf92ec372cd2307$var$DeviceRecord = new $XqKmt.Struct({
    pixelSize: $bjBBc.uint8,
    maximumWidth: $bjBBc.uint8,
    widths: new $gI9iY.Array($bjBBc.uint8, (t)=>t.parent.parent.maxp.numGlyphs)
});
var $f7a6899246d76dab$var$$7bf92ec372cd2307$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    numRecords: $bjBBc.int16,
    sizeDeviceRecord: $bjBBc.int32,
    records: new $gI9iY.Array($f7a6899246d76dab$var$$7bf92ec372cd2307$var$DeviceRecord, 'numRecords')
});
let $f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernPair = new $XqKmt.Struct({
    left: $bjBBc.uint16,
    right: $bjBBc.uint16,
    value: $bjBBc.int16
});
let $f7a6899246d76dab$var$$a3f544bcf76542d1$var$ClassTable = new $XqKmt.Struct({
    firstGlyph: $bjBBc.uint16,
    nGlyphs: $bjBBc.uint16,
    offsets: new $gI9iY.Array($bjBBc.uint16, 'nGlyphs'),
    max: (t)=>t.offsets.length && Math.max.apply(Math, t.offsets)
});
let $f7a6899246d76dab$var$$a3f544bcf76542d1$var$Kern2Array = new $XqKmt.Struct({
    off: (t)=>t._startOffset - t.parent.parent._startOffset,
    len: (t)=>((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2),
    values: new $1Oxaj.LazyArray($bjBBc.int16, 'len')
});
let $f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernSubtable = new $gqRil.VersionedStruct('format', {
    0: {
        nPairs: $bjBBc.uint16,
        searchRange: $bjBBc.uint16,
        entrySelector: $bjBBc.uint16,
        rangeShift: $bjBBc.uint16,
        pairs: new $gI9iY.Array($f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernPair, 'nPairs')
    },
    2: {
        rowWidth: $bjBBc.uint16,
        leftTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$a3f544bcf76542d1$var$ClassTable, {
            type: 'parent'
        }),
        rightTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$a3f544bcf76542d1$var$ClassTable, {
            type: 'parent'
        }),
        array: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$a3f544bcf76542d1$var$Kern2Array, {
            type: 'parent'
        })
    },
    3: {
        glyphCount: $bjBBc.uint16,
        kernValueCount: $bjBBc.uint8,
        leftClassCount: $bjBBc.uint8,
        rightClassCount: $bjBBc.uint8,
        flags: $bjBBc.uint8,
        kernValue: new $gI9iY.Array($bjBBc.int16, 'kernValueCount'),
        leftClass: new $gI9iY.Array($bjBBc.uint8, 'glyphCount'),
        rightClass: new $gI9iY.Array($bjBBc.uint8, 'glyphCount'),
        kernIndex: new $gI9iY.Array($bjBBc.uint8, (t)=>t.leftClassCount * t.rightClassCount)
    }
});
let $f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernTable = new $gqRil.VersionedStruct('version', {
    0: {
        subVersion: $bjBBc.uint16,
        length: $bjBBc.uint16,
        format: $bjBBc.uint8,
        coverage: new $5J5hB.Bitfield($bjBBc.uint8, [
            'horizontal',
            'minimum',
            'crossStream',
            'override' // If set to 1 the value in this table replaces the accumulated value
        ]),
        subtable: $f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernSubtable,
        padding: new $4cbQT.Reserved($bjBBc.uint8, (t)=>t.length - t._currentOffset)
    },
    1: {
        length: $bjBBc.uint32,
        coverage: new $5J5hB.Bitfield($bjBBc.uint8, [
            null,
            null,
            null,
            null,
            null,
            'variation',
            'crossStream',
            'vertical' // Set if table has vertical kerning values
        ]),
        format: $bjBBc.uint8,
        tupleIndex: $bjBBc.uint16,
        subtable: $f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernSubtable,
        padding: new $4cbQT.Reserved($bjBBc.uint8, (t)=>t.length - t._currentOffset)
    }
});
var $f7a6899246d76dab$var$$a3f544bcf76542d1$export$2e2bcd8739ae039 = new $gqRil.VersionedStruct($bjBBc.uint16, {
    0: {
        nTables: $bjBBc.uint16,
        tables: new $gI9iY.Array($f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernTable, 'nTables')
    },
    1: {
        reserved: new $4cbQT.Reserved($bjBBc.uint16),
        nTables: $bjBBc.uint32,
        tables: new $gI9iY.Array($f7a6899246d76dab$var$$a3f544bcf76542d1$var$KernTable, 'nTables')
    }
});
var // Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
$f7a6899246d76dab$var$$86687befb45925d0$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    numGlyphs: $bjBBc.uint16,
    yPels: new $gI9iY.Array($bjBBc.uint8, 'numGlyphs')
});
var // NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
$f7a6899246d76dab$var$$91429006e51e0fe8$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    fontNumber: $bjBBc.uint32,
    pitch: $bjBBc.uint16,
    xHeight: $bjBBc.uint16,
    style: $bjBBc.uint16,
    typeFamily: $bjBBc.uint16,
    capHeight: $bjBBc.uint16,
    symbolSet: $bjBBc.uint16,
    typeface: new $1X3I0.String(16),
    characterComplement: new $1X3I0.String(8),
    fileName: new $1X3I0.String(6),
    strokeWeight: new $1X3I0.String(1),
    widthType: new $1X3I0.String(1),
    serifStyle: $bjBBc.uint8,
    reserved: new $4cbQT.Reserved($bjBBc.uint8)
});
// VDMX tables contain ascender/descender overrides for certain (usually small)
// sizes. This is needed in order to match font metrics on Windows.
let $f7a6899246d76dab$var$$627850fc9deed59a$var$Ratio = new $XqKmt.Struct({
    bCharSet: $bjBBc.uint8,
    xRatio: $bjBBc.uint8,
    yStartRatio: $bjBBc.uint8,
    yEndRatio: $bjBBc.uint8 // Ending y-Ratio value
});
let $f7a6899246d76dab$var$$627850fc9deed59a$var$vTable = new $XqKmt.Struct({
    yPelHeight: $bjBBc.uint16,
    yMax: $bjBBc.int16,
    yMin: $bjBBc.int16 // Minimum value (in pels) for this yPelHeight
});
let $f7a6899246d76dab$var$$627850fc9deed59a$var$VdmxGroup = new $XqKmt.Struct({
    recs: $bjBBc.uint16,
    startsz: $bjBBc.uint8,
    endsz: $bjBBc.uint8,
    entries: new $gI9iY.Array($f7a6899246d76dab$var$$627850fc9deed59a$var$vTable, 'recs') // The VDMX records
});
var $f7a6899246d76dab$var$$627850fc9deed59a$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    numRecs: $bjBBc.uint16,
    numRatios: $bjBBc.uint16,
    ratioRanges: new $gI9iY.Array($f7a6899246d76dab$var$$627850fc9deed59a$var$Ratio, 'numRatios'),
    offsets: new $gI9iY.Array($bjBBc.uint16, 'numRatios'),
    groups: new $gI9iY.Array($f7a6899246d76dab$var$$627850fc9deed59a$var$VdmxGroup, 'numRecs') // The actual VDMX groupings
});
var $f7a6899246d76dab$var$$65c33f5f068fc77f$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    ascent: $bjBBc.int16,
    descent: $bjBBc.int16,
    lineGap: $bjBBc.int16,
    advanceHeightMax: $bjBBc.int16,
    minTopSideBearing: $bjBBc.int16,
    minBottomSideBearing: $bjBBc.int16,
    yMaxExtent: $bjBBc.int16,
    caretSlopeRise: $bjBBc.int16,
    caretSlopeRun: $bjBBc.int16,
    caretOffset: $bjBBc.int16,
    reserved: new $4cbQT.Reserved($bjBBc.int16, 4),
    metricDataFormat: $bjBBc.int16,
    numberOfMetrics: $bjBBc.uint16 // Number of advance heights in the Vertical Metrics table
});
let $f7a6899246d76dab$var$$597d739523b65bb3$var$VmtxEntry = new $XqKmt.Struct({
    advance: $bjBBc.uint16,
    bearing: $bjBBc.int16 // The top sidebearing of the glyph
});
var $f7a6899246d76dab$var$$597d739523b65bb3$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    metrics: new $1Oxaj.LazyArray($f7a6899246d76dab$var$$597d739523b65bb3$var$VmtxEntry, (t)=>t.parent.vhea.numberOfMetrics),
    bearings: new $1Oxaj.LazyArray($bjBBc.int16, (t)=>t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics)
});
let $f7a6899246d76dab$var$$35aa0c87d9c3d3a0$var$shortFrac = new $bjBBc.Fixed(16, 'BE', 14);
let $f7a6899246d76dab$var$$35aa0c87d9c3d3a0$var$Correspondence = new $XqKmt.Struct({
    fromCoord: $f7a6899246d76dab$var$$35aa0c87d9c3d3a0$var$shortFrac,
    toCoord: $f7a6899246d76dab$var$$35aa0c87d9c3d3a0$var$shortFrac
});
let $f7a6899246d76dab$var$$35aa0c87d9c3d3a0$var$Segment = new $XqKmt.Struct({
    pairCount: $bjBBc.uint16,
    correspondence: new $gI9iY.Array($f7a6899246d76dab$var$$35aa0c87d9c3d3a0$var$Correspondence, 'pairCount')
});
var $f7a6899246d76dab$var$$35aa0c87d9c3d3a0$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.fixed32,
    axisCount: $bjBBc.uint32,
    segment: new $gI9iY.Array($f7a6899246d76dab$var$$35aa0c87d9c3d3a0$var$Segment, 'axisCount')
});
class $f7a6899246d76dab$var$$22801616bd931ca3$var$UnboundedArrayAccessor {
    getItem(index) {
        if (this._items[index] == null) {
            let pos = this.stream.pos;
            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
            this._items[index] = this.type.decode(this.stream, this.parent);
            this.stream.pos = pos;
        }
        return this._items[index];
    }
    inspect() {
        return `[UnboundedArray ${this.type.constructor.name}]`;
    }
    constructor(type, stream, parent){
        this.type = type;
        this.stream = stream;
        this.parent = parent;
        this.base = this.stream.pos;
        this._items = [];
    }
}
class $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a extends $gI9iY.Array {
    decode(stream, parent) {
        return new $f7a6899246d76dab$var$$22801616bd931ca3$var$UnboundedArrayAccessor(this.type, stream, parent);
    }
    constructor(type){
        super(type, 0);
    }
}
let $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c = function(ValueType = $bjBBc.uint16) {
    // Helper class that makes internal structures invisible to pointers
    class Shadow {
        decode(stream, ctx) {
            ctx = ctx.parent.parent;
            return this.type.decode(stream, ctx);
        }
        size(val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.size(val, ctx);
        }
        encode(stream, val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.encode(stream, val, ctx);
        }
        constructor(type){
            this.type = type;
        }
    }
    ValueType = new Shadow(ValueType);
    let BinarySearchHeader = new $XqKmt.Struct({
        unitSize: $bjBBc.uint16,
        nUnits: $bjBBc.uint16,
        searchRange: $bjBBc.uint16,
        entrySelector: $bjBBc.uint16,
        rangeShift: $bjBBc.uint16
    });
    let LookupSegmentSingle = new $XqKmt.Struct({
        lastGlyph: $bjBBc.uint16,
        firstGlyph: $bjBBc.uint16,
        value: ValueType
    });
    let LookupSegmentArray = new $XqKmt.Struct({
        lastGlyph: $bjBBc.uint16,
        firstGlyph: $bjBBc.uint16,
        values: new $erngl.Pointer($bjBBc.uint16, new $gI9iY.Array(ValueType, (t)=>t.lastGlyph - t.firstGlyph + 1), {
            type: 'parent'
        })
    });
    let LookupSingle = new $XqKmt.Struct({
        glyph: $bjBBc.uint16,
        value: ValueType
    });
    return new $gqRil.VersionedStruct($bjBBc.uint16, {
        0: {
            values: new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a(ValueType) // length == number of glyphs maybe?
        },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gI9iY.Array(LookupSegmentSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gI9iY.Array(LookupSegmentArray, (t)=>t.binarySearchHeader.nUnits)
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gI9iY.Array(LookupSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        8: {
            firstGlyph: $bjBBc.uint16,
            count: $bjBBc.uint16,
            values: new $gI9iY.Array(ValueType, 'count')
        }
    });
};
function $f7a6899246d76dab$var$$22801616bd931ca3$export$79f7d93d790934ba(entryData = {}, lookupType = $bjBBc.uint16) {
    let entry = Object.assign({
        newState: $bjBBc.uint16,
        flags: $bjBBc.uint16
    }, entryData);
    let Entry = new $XqKmt.Struct(entry);
    let StateArray = new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a(new $gI9iY.Array($bjBBc.uint16, (t)=>t.nClasses));
    let StateHeader = new $XqKmt.Struct({
        nClasses: $bjBBc.uint32,
        classTable: new $erngl.Pointer($bjBBc.uint32, new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c(lookupType)),
        stateArray: new $erngl.Pointer($bjBBc.uint32, StateArray),
        entryTable: new $erngl.Pointer($bjBBc.uint32, new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader;
}
function $f7a6899246d76dab$var$$22801616bd931ca3$export$105027425199cc51(entryData = {}, lookupType = $bjBBc.uint16) {
    let ClassLookupTable = new $XqKmt.Struct({
        version () {
            return 8;
        },
        firstGlyph: $bjBBc.uint16,
        values: new $gI9iY.Array($bjBBc.uint8, $bjBBc.uint16)
    });
    let entry = Object.assign({
        newStateOffset: $bjBBc.uint16,
        // convert offset to stateArray index
        newState: (t)=>(t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses,
        flags: $bjBBc.uint16
    }, entryData);
    let Entry = new $XqKmt.Struct(entry);
    let StateArray = new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a(new $gI9iY.Array($bjBBc.uint8, (t)=>t.nClasses));
    let StateHeader1 = new $XqKmt.Struct({
        nClasses: $bjBBc.uint16,
        classTable: new $erngl.Pointer($bjBBc.uint16, ClassLookupTable),
        stateArray: new $erngl.Pointer($bjBBc.uint16, StateArray),
        entryTable: new $erngl.Pointer($bjBBc.uint16, new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader1;
}
let $f7a6899246d76dab$var$$3a5ca96d3e3aaf20$var$BslnSubtable = new $gqRil.VersionedStruct('format', {
    0: {
        deltas: new $gI9iY.Array($bjBBc.int16, 32)
    },
    1: {
        deltas: new $gI9iY.Array($bjBBc.int16, 32),
        mappingData: new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c($bjBBc.uint16)
    },
    2: {
        standardGlyph: $bjBBc.uint16,
        controlPoints: new $gI9iY.Array($bjBBc.uint16, 32)
    },
    3: {
        standardGlyph: $bjBBc.uint16,
        controlPoints: new $gI9iY.Array($bjBBc.uint16, 32),
        mappingData: new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c($bjBBc.uint16)
    }
});
var $f7a6899246d76dab$var$$3a5ca96d3e3aaf20$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.fixed32,
    format: $bjBBc.uint16,
    defaultBaseline: $bjBBc.uint16,
    subtable: $f7a6899246d76dab$var$$3a5ca96d3e3aaf20$var$BslnSubtable
});
let $f7a6899246d76dab$var$$8d4241d96b2b0589$var$Setting = new $XqKmt.Struct({
    setting: $bjBBc.uint16,
    nameIndex: $bjBBc.int16,
    name: (t)=>t.parent.parent.parent.name.records.fontFeatures[t.nameIndex]
});
let $f7a6899246d76dab$var$$8d4241d96b2b0589$var$FeatureName = new $XqKmt.Struct({
    feature: $bjBBc.uint16,
    nSettings: $bjBBc.uint16,
    settingTable: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array($f7a6899246d76dab$var$$8d4241d96b2b0589$var$Setting, 'nSettings'), {
        type: 'parent'
    }),
    featureFlags: new $5J5hB.Bitfield($bjBBc.uint8, [
        null,
        null,
        null,
        null,
        null,
        null,
        'hasDefault',
        'exclusive'
    ]),
    defaultSetting: $bjBBc.uint8,
    nameIndex: $bjBBc.int16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameIndex]
});
var $f7a6899246d76dab$var$$8d4241d96b2b0589$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.fixed32,
    featureNameCount: $bjBBc.uint16,
    reserved1: new $4cbQT.Reserved($bjBBc.uint16),
    reserved2: new $4cbQT.Reserved($bjBBc.uint32),
    featureNames: new $gI9iY.Array($f7a6899246d76dab$var$$8d4241d96b2b0589$var$FeatureName, 'featureNameCount')
});
let $f7a6899246d76dab$var$$a79cd5132b1cf476$var$Axis = new $XqKmt.Struct({
    axisTag: new $1X3I0.String(4),
    minValue: $bjBBc.fixed32,
    defaultValue: $bjBBc.fixed32,
    maxValue: $bjBBc.fixed32,
    flags: $bjBBc.uint16,
    nameID: $bjBBc.uint16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID]
});
let $f7a6899246d76dab$var$$a79cd5132b1cf476$var$Instance = new $XqKmt.Struct({
    nameID: $bjBBc.uint16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID],
    flags: $bjBBc.uint16,
    coord: new $gI9iY.Array($bjBBc.fixed32, (t)=>t.parent.axisCount),
    postscriptNameID: new $jvb6m.Optional($bjBBc.uint16, (t)=>t.parent.instanceSize - t._currentOffset > 0)
});
var $f7a6899246d76dab$var$$a79cd5132b1cf476$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.fixed32,
    offsetToData: $bjBBc.uint16,
    countSizePairs: $bjBBc.uint16,
    axisCount: $bjBBc.uint16,
    axisSize: $bjBBc.uint16,
    instanceCount: $bjBBc.uint16,
    instanceSize: $bjBBc.uint16,
    axis: new $gI9iY.Array($f7a6899246d76dab$var$$a79cd5132b1cf476$var$Axis, 'axisCount'),
    instance: new $gI9iY.Array($f7a6899246d76dab$var$$a79cd5132b1cf476$var$Instance, 'instanceCount')
});
let $f7a6899246d76dab$var$$3f36f1a5e6989457$var$shortFrac = new $bjBBc.Fixed(16, 'BE', 14);
class $f7a6899246d76dab$var$$3f36f1a5e6989457$var$Offset {
    static decode(stream, parent) {
        // In short format, offsets are multiplied by 2.
        // This doesn't seem to be documented by Apple, but it
        // is implemented this way in Freetype.
        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
    }
}
let $f7a6899246d76dab$var$$3f36f1a5e6989457$var$gvar = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    reserved: new $4cbQT.Reserved($bjBBc.uint16),
    axisCount: $bjBBc.uint16,
    globalCoordCount: $bjBBc.uint16,
    globalCoords: new $erngl.Pointer($bjBBc.uint32, new $gI9iY.Array(new $gI9iY.Array($f7a6899246d76dab$var$$3f36f1a5e6989457$var$shortFrac, 'axisCount'), 'globalCoordCount')),
    glyphCount: $bjBBc.uint16,
    flags: $bjBBc.uint16,
    offsetToData: $bjBBc.uint32,
    offsets: new $gI9iY.Array(new $erngl.Pointer($f7a6899246d76dab$var$$3f36f1a5e6989457$var$Offset, 'void', {
        relativeTo: (ctx)=>ctx.offsetToData,
        allowNull: false
    }), (t)=>t.glyphCount + 1)
});
var $f7a6899246d76dab$var$$3f36f1a5e6989457$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$3f36f1a5e6989457$var$gvar;
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$ClassTable = new $XqKmt.Struct({
    length: $bjBBc.uint16,
    coverage: $bjBBc.uint16,
    subFeatureFlags: $bjBBc.uint32,
    stateTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$105027425199cc51
});
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$WidthDeltaRecord = new $XqKmt.Struct({
    justClass: $bjBBc.uint32,
    beforeGrowLimit: $bjBBc.fixed32,
    beforeShrinkLimit: $bjBBc.fixed32,
    afterGrowLimit: $bjBBc.fixed32,
    afterShrinkLimit: $bjBBc.fixed32,
    growFlags: $bjBBc.uint16,
    shrinkFlags: $bjBBc.uint16
});
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$WidthDeltaCluster = new $gI9iY.Array($f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$WidthDeltaRecord, $bjBBc.uint32);
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$ActionData = new $gqRil.VersionedStruct('actionType', {
    0: {
        lowerLimit: $bjBBc.fixed32,
        upperLimit: $bjBBc.fixed32,
        order: $bjBBc.uint16,
        glyphs: new $gI9iY.Array($bjBBc.uint16, $bjBBc.uint16)
    },
    1: {
        addGlyph: $bjBBc.uint16
    },
    2: {
        substThreshold: $bjBBc.fixed32,
        addGlyph: $bjBBc.uint16,
        substGlyph: $bjBBc.uint16
    },
    3: {},
    4: {
        variationAxis: $bjBBc.uint32,
        minimumLimit: $bjBBc.fixed32,
        noStretchValue: $bjBBc.fixed32,
        maximumLimit: $bjBBc.fixed32
    },
    5: {
        flags: $bjBBc.uint16,
        glyph: $bjBBc.uint16
    }
});
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$Action = new $XqKmt.Struct({
    actionClass: $bjBBc.uint16,
    actionType: $bjBBc.uint16,
    actionLength: $bjBBc.uint32,
    actionData: $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$ActionData,
    padding: new $4cbQT.Reserved($bjBBc.uint8, (t)=>t.actionLength - t._currentOffset)
});
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$PostcompensationAction = new $gI9iY.Array($f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$Action, $bjBBc.uint32);
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$PostCompensationTable = new $XqKmt.Struct({
    lookupTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$PostcompensationAction))
});
let $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$JustificationTable = new $XqKmt.Struct({
    classTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$ClassTable, {
        type: 'parent'
    }),
    wdcOffset: $bjBBc.uint16,
    postCompensationTable: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$PostCompensationTable, {
        type: 'parent'
    }),
    widthDeltaClusters: new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c(new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$WidthDeltaCluster, {
        type: 'parent',
        relativeTo: (ctx)=>ctx.wdcOffset
    }))
});
var $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint32,
    format: $bjBBc.uint16,
    horizontal: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$JustificationTable),
    vertical: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$var$JustificationTable)
});
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$LigatureData = {
    action: $bjBBc.uint16
};
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$ContextualData = {
    markIndex: $bjBBc.uint16,
    currentIndex: $bjBBc.uint16
};
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$InsertionData = {
    currentInsertIndex: $bjBBc.uint16,
    markedInsertIndex: $bjBBc.uint16
};
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$SubstitutionTable = new $XqKmt.Struct({
    items: new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a(new $erngl.Pointer($bjBBc.uint32, new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c))
});
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$SubtableData = new $gqRil.VersionedStruct('type', {
    0: {
        stateTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$79f7d93d790934ba
    },
    1: {
        stateTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$79f7d93d790934ba($f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$ContextualData),
        substitutionTable: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$SubstitutionTable)
    },
    2: {
        stateTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$79f7d93d790934ba($f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$LigatureData),
        ligatureActions: new $erngl.Pointer($bjBBc.uint32, new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a($bjBBc.uint32)),
        components: new $erngl.Pointer($bjBBc.uint32, new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a($bjBBc.uint16)),
        ligatureList: new $erngl.Pointer($bjBBc.uint32, new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a($bjBBc.uint16))
    },
    4: {
        lookupTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c
    },
    5: {
        stateTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$79f7d93d790934ba($f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$InsertionData),
        insertionActions: new $erngl.Pointer($bjBBc.uint32, new $f7a6899246d76dab$var$$22801616bd931ca3$export$c5af1eebc882e39a($bjBBc.uint16))
    }
});
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$Subtable = new $XqKmt.Struct({
    length: $bjBBc.uint32,
    coverage: $bjBBc.uint24,
    type: $bjBBc.uint8,
    subFeatureFlags: $bjBBc.uint32,
    table: $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$SubtableData,
    padding: new $4cbQT.Reserved($bjBBc.uint8, (t)=>t.length - t._currentOffset)
});
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$FeatureEntry = new $XqKmt.Struct({
    featureType: $bjBBc.uint16,
    featureSetting: $bjBBc.uint16,
    enableFlags: $bjBBc.uint32,
    disableFlags: $bjBBc.uint32
});
let $f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$MorxChain = new $XqKmt.Struct({
    defaultFlags: $bjBBc.uint32,
    chainLength: $bjBBc.uint32,
    nFeatureEntries: $bjBBc.uint32,
    nSubtables: $bjBBc.uint32,
    features: new $gI9iY.Array($f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$FeatureEntry, 'nFeatureEntries'),
    subtables: new $gI9iY.Array($f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$Subtable, 'nSubtables')
});
var $f7a6899246d76dab$var$$ef40c6dc80fd50a2$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.uint16,
    unused: new $4cbQT.Reserved($bjBBc.uint16),
    nChains: $bjBBc.uint32,
    chains: new $gI9iY.Array($f7a6899246d76dab$var$$ef40c6dc80fd50a2$var$MorxChain, 'nChains')
});
let $f7a6899246d76dab$var$$ab24dea08b58a7cc$var$OpticalBounds = new $XqKmt.Struct({
    left: $bjBBc.int16,
    top: $bjBBc.int16,
    right: $bjBBc.int16,
    bottom: $bjBBc.int16
});
var $f7a6899246d76dab$var$$ab24dea08b58a7cc$export$2e2bcd8739ae039 = new $XqKmt.Struct({
    version: $bjBBc.fixed32,
    format: $bjBBc.uint16,
    lookupTable: new $f7a6899246d76dab$var$$22801616bd931ca3$export$8351f8c2ae2f103c($f7a6899246d76dab$var$$ab24dea08b58a7cc$var$OpticalBounds)
});
let $f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables = {};
var $f7a6899246d76dab$var$$5825c04ce8f7102d$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.cmap = $f7a6899246d76dab$var$$e4ae0436c91af89f$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.head = $f7a6899246d76dab$var$$55a60976afb7c261$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.hhea = $f7a6899246d76dab$var$$dde72b7b5b650596$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.hmtx = $f7a6899246d76dab$var$$a7c40184072c9a5b$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.maxp = $f7a6899246d76dab$var$$521197722369f691$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.name = $f7a6899246d76dab$var$$51a9f4feb3a3b2b1$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables['OS/2'] = $f7a6899246d76dab$var$$114ea85db469b435$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.post = $f7a6899246d76dab$var$$f93b30299e1ea0f5$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.fpgm = $f7a6899246d76dab$var$$873d79fea57d3161$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.loca = $f7a6899246d76dab$var$$83c4155666d50c37$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.prep = $f7a6899246d76dab$var$$b12598db7cdf7042$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables['cvt '] = $f7a6899246d76dab$var$$8fb09b0f473d61a0$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.glyf = $f7a6899246d76dab$var$$7707bdf21a3d89cc$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables['CFF '] = $f7a6899246d76dab$var$$f717432b360040c7$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables['CFF2'] = $f7a6899246d76dab$var$$f717432b360040c7$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.VORG = $f7a6899246d76dab$var$$8cb7ae73ed7aa7d8$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.EBLC = $f7a6899246d76dab$var$$035bb95c0cdb1f6d$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.CBLC = $f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.EBLC;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.sbix = $f7a6899246d76dab$var$$73d13900b55a3c0c$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.COLR = $f7a6899246d76dab$var$$97f6b8be3a347a8f$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.CPAL = $f7a6899246d76dab$var$$16ca60ecbdee30ea$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.BASE = $f7a6899246d76dab$var$$7327e41706f9d5c7$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.GDEF = $f7a6899246d76dab$var$$7e48bbe9e5345664$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.GPOS = $f7a6899246d76dab$var$$b687332511a4da75$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.GSUB = $f7a6899246d76dab$var$$99ccad60b96f92fb$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.JSTF = $f7a6899246d76dab$var$$573d5042c76c4940$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.HVAR = $f7a6899246d76dab$var$$a5875b80d6087f61$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.DSIG = $f7a6899246d76dab$var$$4423bc1ac09bbbd1$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.gasp = $f7a6899246d76dab$var$$7b50e3f8d83263de$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.hdmx = $f7a6899246d76dab$var$$7bf92ec372cd2307$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.kern = $f7a6899246d76dab$var$$a3f544bcf76542d1$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.LTSH = $f7a6899246d76dab$var$$86687befb45925d0$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.PCLT = $f7a6899246d76dab$var$$91429006e51e0fe8$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.VDMX = $f7a6899246d76dab$var$$627850fc9deed59a$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.vhea = $f7a6899246d76dab$var$$65c33f5f068fc77f$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.vmtx = $f7a6899246d76dab$var$$597d739523b65bb3$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.avar = $f7a6899246d76dab$var$$35aa0c87d9c3d3a0$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.bsln = $f7a6899246d76dab$var$$3a5ca96d3e3aaf20$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.feat = $f7a6899246d76dab$var$$8d4241d96b2b0589$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.fvar = $f7a6899246d76dab$var$$a79cd5132b1cf476$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.gvar = $f7a6899246d76dab$var$$3f36f1a5e6989457$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.just = $f7a6899246d76dab$var$$0bd8fe7a6d1d9fb4$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.morx = $f7a6899246d76dab$var$$ef40c6dc80fd50a2$export$2e2bcd8739ae039;
$f7a6899246d76dab$var$$5825c04ce8f7102d$var$tables.opbd = $f7a6899246d76dab$var$$ab24dea08b58a7cc$export$2e2bcd8739ae039;
let $f7a6899246d76dab$var$$df50e1efe10a1247$var$TableEntry = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    checkSum: $bjBBc.uint32,
    offset: new $erngl.Pointer($bjBBc.uint32, 'void', {
        type: 'global'
    }),
    length: $bjBBc.uint32
});
let $f7a6899246d76dab$var$$df50e1efe10a1247$var$Directory = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    numTables: $bjBBc.uint16,
    searchRange: $bjBBc.uint16,
    entrySelector: $bjBBc.uint16,
    rangeShift: $bjBBc.uint16,
    tables: new $gI9iY.Array($f7a6899246d76dab$var$$df50e1efe10a1247$var$TableEntry, 'numTables')
});
$f7a6899246d76dab$var$$df50e1efe10a1247$var$Directory.process = function() {
    let tables = {};
    for (let table of this.tables)tables[table.tag] = table;
    this.tables = tables;
};
$f7a6899246d76dab$var$$df50e1efe10a1247$var$Directory.preEncode = function() {
    if (!Array.isArray(this.tables)) {
        let tables = [];
        for(let tag in this.tables){
            let table = this.tables[tag];
            if (table) tables.push({
                tag: tag,
                checkSum: 0,
                offset: new $erngl.VoidPointer($f7a6899246d76dab$var$$5825c04ce8f7102d$export$2e2bcd8739ae039[tag], table),
                length: $f7a6899246d76dab$var$$5825c04ce8f7102d$export$2e2bcd8739ae039[tag].size(table)
            });
        }
        this.tables = tables;
    }
    this.tag = 'true';
    this.numTables = this.tables.length;
    let maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
    let maxPowerOf2 = Math.pow(2, maxExponentFor2);
    this.searchRange = maxPowerOf2 * 16;
    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
var $f7a6899246d76dab$var$$df50e1efe10a1247$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$df50e1efe10a1247$var$Directory;
function $f7a6899246d76dab$var$$66a5b9fb5318558a$export$2e0ae67339d5f1ac(arr, cmp) {
    let min = 0;
    let max = arr.length - 1;
    while(min <= max){
        let mid = min + max >> 1;
        let res = cmp(arr[mid]);
        if (res < 0) max = mid - 1;
        else if (res > 0) min = mid + 1;
        else return mid;
    }
    return -1;
}
function $f7a6899246d76dab$var$$66a5b9fb5318558a$export$d02631cccf789723(index, end) {
    let range = [];
    while(index < end)range.push(index++);
    return range;
}
const $f7a6899246d76dab$var$$66a5b9fb5318558a$export$3d28c1996ced1f14 = new TextDecoder('ascii');
// Based on https://github.com/niklasvh/base64-arraybuffer. MIT license.
const $f7a6899246d76dab$var$$66a5b9fb5318558a$var$CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
const $f7a6899246d76dab$var$$66a5b9fb5318558a$var$LOOKUP = new Uint8Array(256);
for(let i = 0; i < $f7a6899246d76dab$var$$66a5b9fb5318558a$var$CHARS.length; i++)$f7a6899246d76dab$var$$66a5b9fb5318558a$var$LOOKUP[$f7a6899246d76dab$var$$66a5b9fb5318558a$var$CHARS.charCodeAt(i)] = i;
function $f7a6899246d76dab$var$$66a5b9fb5318558a$export$94fdf11bafc8de6b(base64) {
    let bufferLength = base64.length * 0.75;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    let bytes = new Uint8Array(bufferLength);
    let p = 0;
    for(let i = 0, len = base64.length; i < len; i += 4){
        let encoded1 = $f7a6899246d76dab$var$$66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i)];
        let encoded2 = $f7a6899246d76dab$var$$66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i + 1)];
        let encoded3 = $f7a6899246d76dab$var$$66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i + 2)];
        let encoded4 = $f7a6899246d76dab$var$$66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
}
class $f7a6899246d76dab$var$$0d6e160064c86e50$export$2e2bcd8739ae039 {
    findSubtable(cmapTable, pairs) {
        for (let [platformID, encodingID] of pairs)for (let cmap of cmapTable.tables){
            if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
        }
        return null;
    }
    lookup(codepoint, variationSelector) {
        // If there is no Unicode cmap in this font, we need to re-encode
        // the codepoint in the encoding that the cmap supports.
        if (this.encoding) codepoint = this.encoding.get(codepoint) || codepoint;
        else if (variationSelector) {
            let gid = this.getVariationSelector(codepoint, variationSelector);
            if (gid) return gid;
        }
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4:
                {
                    let min = 0;
                    let max = cmap.segCount - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                        else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                        else {
                            let rangeOffset = cmap.idRangeOffset.get(mid);
                            let gid;
                            if (rangeOffset === 0) gid = codepoint + cmap.idDelta.get(mid);
                            else {
                                let index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                                gid = cmap.glyphIndexArray.get(index) || 0;
                                if (gid !== 0) gid += cmap.idDelta.get(mid);
                            }
                            return gid & 0xffff;
                        }
                    }
                    return 0;
                }
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13:
                {
                    let min = 0;
                    let max = cmap.nGroups - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        let group = cmap.groups.get(mid);
                        if (codepoint < group.startCharCode) max = mid - 1;
                        else if (codepoint > group.endCharCode) min = mid + 1;
                        else {
                            if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                            else return group.glyphID;
                        }
                    }
                    return 0;
                }
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    getVariationSelector(codepoint, variationSelector) {
        if (!this.uvs) return 0;
        let selectors = this.uvs.varSelectors.toArray();
        let i = $f7a6899246d76dab$var$$66a5b9fb5318558a$export$2e0ae67339d5f1ac(selectors, (x)=>variationSelector - x.varSelector);
        let sel = selectors[i];
        if (i !== -1 && sel.defaultUVS) i = $f7a6899246d76dab$var$$66a5b9fb5318558a$export$2e0ae67339d5f1ac(sel.defaultUVS, (x)=>codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0);
        if (i !== -1 && sel.nonDefaultUVS) {
            i = $f7a6899246d76dab$var$$66a5b9fb5318558a$export$2e0ae67339d5f1ac(sel.nonDefaultUVS, (x)=>codepoint - x.unicodeValue);
            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
        }
        return 0;
    }
    getCharacterSet() {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return $f7a6899246d76dab$var$$66a5b9fb5318558a$export$d02631cccf789723(0, cmap.codeMap.length);
            case 4:
                {
                    let res = [];
                    let endCodes = cmap.endCode.toArray();
                    for(let i = 0; i < endCodes.length; i++){
                        let tail = endCodes[i] + 1;
                        let start = cmap.startCode.get(i);
                        res.push(...$f7a6899246d76dab$var$$66a5b9fb5318558a$export$d02631cccf789723(start, tail));
                    }
                    return res;
                }
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return $f7a6899246d76dab$var$$66a5b9fb5318558a$export$d02631cccf789723(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())res.push(...$f7a6899246d76dab$var$$66a5b9fb5318558a$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    codePointsForGlyph(gid) {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                {
                    let res = [];
                    for(let i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                    return res;
                }
            case 4:
                {
                    let res = [];
                    for(let i = 0; i < cmap.segCount; i++){
                        let end = cmap.endCode.get(i);
                        let start = cmap.startCode.get(i);
                        let rangeOffset = cmap.idRangeOffset.get(i);
                        let delta = cmap.idDelta.get(i);
                        for(var c = start; c <= end; c++){
                            let g = 0;
                            if (rangeOffset === 0) g = c + delta;
                            else {
                                let index = rangeOffset / 2 + (c - start) - (cmap.segCount - i);
                                g = cmap.glyphIndexArray.get(index) || 0;
                                if (g !== 0) g += delta;
                            }
                            if (g === gid) res.push(c);
                        }
                    }
                    return res;
                }
            case 12:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) res.push(group.startCharCode + (gid - group.glyphID));
                    return res;
                }
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid === group.glyphID) res.push(...$f7a6899246d76dab$var$$66a5b9fb5318558a$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    constructor(cmapTable){
        // Attempt to find a Unicode cmap first
        this.encoding = null;
        this.cmap = this.findSubtable(cmapTable, [
            // 32-bit subtables
            [
                3,
                10
            ],
            [
                0,
                6
            ],
            [
                0,
                4
            ],
            // 16-bit subtables
            [
                3,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                2
            ],
            [
                0,
                1
            ],
            [
                0,
                0
            ]
        ]);
        // If not unicode cmap was found, take the first table with a supported encoding.
        if (!this.cmap) for (let cmap of cmapTable.tables){
            let encoding = $f7a6899246d76dab$var$$e2613b812f052cbe$export$badc544e0651b6b1(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
            let mapping = $f7a6899246d76dab$var$$e2613b812f052cbe$export$1dceb3c14ed68bee(encoding);
            if (mapping) {
                this.cmap = cmap.table;
                this.encoding = mapping;
            }
        }
        if (!this.cmap) throw new Error("Could not find a supported cmap table");
        this.uvs = this.findSubtable(cmapTable, [
            [
                0,
                5
            ]
        ]);
        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
    }
}
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0d6e160064c86e50$export$2e2bcd8739ae039.prototype, "getCharacterSet", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0d6e160064c86e50$export$2e2bcd8739ae039.prototype, "codePointsForGlyph", null);
class $f7a6899246d76dab$var$$4646d52c2a559cdb$export$2e2bcd8739ae039 {
    process(glyphs, positions) {
        for(let glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
            let left = glyphs[glyphIndex].id;
            let right = glyphs[glyphIndex + 1].id;
            positions[glyphIndex].xAdvance += this.getKerning(left, right);
        }
    }
    getKerning(left, right) {
        let res = 0;
        for (let table of this.kern.tables){
            if (table.coverage.crossStream) continue;
            switch(table.version){
                case 0:
                    if (!table.coverage.horizontal) continue;
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) continue;
                    break;
                default:
                    throw new Error(`Unsupported kerning table version ${table.version}`);
            }
            let val = 0;
            let s = table.subtable;
            switch(table.format){
                case 0:
                    let pairIdx = $f7a6899246d76dab$var$$66a5b9fb5318558a$export$2e0ae67339d5f1ac(s.pairs, function(pair) {
                        return left - pair.left || right - pair.right;
                    });
                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                    break;
                case 2:
                    let leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    else leftOffset = s.array.off;
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    let index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error(`Unsupported kerning sub-table format ${table.format}`);
            }
            // Microsoft supports the override flag, which resets the result
            // Otherwise, the sum of the results from all subtables is returned
            if (table.coverage.override) res = val;
            else res += val;
        }
        return res;
    }
    constructor(font){
        this.kern = font.kern;
    }
}
class $f7a6899246d76dab$var$$a57a26817cd35108$export$2e2bcd8739ae039 {
    positionGlyphs(glyphs, positions) {
        // find each base + mark cluster, and position the marks relative to the base
        let clusterStart = 0;
        let clusterEnd = 0;
        for(let index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.isMark) clusterEnd = index;
            else {
                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                clusterStart = clusterEnd = index;
            }
        }
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        return positions;
    }
    positionCluster(glyphs, positions, clusterStart, clusterEnd) {
        let base = glyphs[clusterStart];
        let baseBox = base.cbox.copy();
        // adjust bounding box for ligature glyphs
        if (base.codePoints.length > 1) baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
        let xOffset = -positions[clusterStart].xAdvance;
        let yOffset = 0;
        let yGap = this.font.unitsPerEm / 16;
        // position each of the mark glyphs relative to the base glyph
        for(let index = clusterStart + 1; index <= clusterEnd; index++){
            let mark = glyphs[index];
            let markBox = mark.cbox;
            let position = positions[index];
            let combiningClass = this.getCombiningClass(mark.codePoints[0]);
            if (combiningClass !== 'Not_Reordered') {
                position.xOffset = position.yOffset = 0;
                // x positioning
                switch(combiningClass){
                    case 'Double_Above':
                    case 'Double_Below':
                        // LTR. TODO: RTL support.
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case 'Attached_Below_Left':
                    case 'Below_Left':
                    case 'Above_Left':
                        // left align
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case 'Attached_Above_Right':
                    case 'Below_Right':
                    case 'Above_Right':
                        // right align
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        // center align
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                }
                // y positioning
                switch(combiningClass){
                    case 'Double_Below':
                    case 'Below_Left':
                    case 'Below':
                    case 'Below_Right':
                    case 'Attached_Below_Left':
                    case 'Attached_Below':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') baseBox.minY += yGap;
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case 'Double_Above':
                    case 'Above_Left':
                    case 'Above':
                    case 'Above_Right':
                    case 'Attached_Above':
                    case 'Attached_Above_Right':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') baseBox.maxY += yGap;
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                }
                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
            } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
            }
        }
        return;
    }
    getCombiningClass(codePoint) {
        let combiningClass = (0, $k9oO0.getCombiningClass)(codePoint);
        // Thai / Lao need some per-character work
        if ((codePoint & -256) === 0x0e00) {
            if (combiningClass === 'Not_Reordered') switch(codePoint){
                case 0x0e31:
                case 0x0e34:
                case 0x0e35:
                case 0x0e36:
                case 0x0e37:
                case 0x0e47:
                case 0x0e4c:
                case 0x0e3d:
                case 0x0e4e:
                    return 'Above_Right';
                case 0x0eb1:
                case 0x0eb4:
                case 0x0eb5:
                case 0x0eb6:
                case 0x0eb7:
                case 0x0ebb:
                case 0x0ecc:
                case 0x0ecd:
                    return 'Above';
                case 0x0ebc:
                    return 'Below';
            }
            else if (codePoint === 0x0e3a) return 'Below_Right';
        }
        switch(combiningClass){
            // Hebrew
            case 'CCC10':
            case 'CCC11':
            case 'CCC12':
            case 'CCC13':
            case 'CCC14':
            case 'CCC15':
            case 'CCC16':
            case 'CCC17':
            case 'CCC18':
            case 'CCC20':
            case 'CCC22':
                return 'Below';
            case 'CCC23':
                return 'Attached_Above';
            case 'CCC24':
                return 'Above_Right';
            case 'CCC25':
            case 'CCC19':
                return 'Above_Left';
            case 'CCC26':
                return 'Above';
            case 'CCC21':
                break;
            // Arabic and Syriac
            case 'CCC27':
            case 'CCC28':
            case 'CCC30':
            case 'CCC31':
            case 'CCC33':
            case 'CCC34':
            case 'CCC35':
            case 'CCC36':
                return 'Above';
            case 'CCC29':
            case 'CCC32':
                return 'Below';
            // Thai
            case 'CCC103':
                return 'Below_Right';
            case 'CCC107':
                return 'Above_Right';
            // Lao
            case 'CCC118':
                return 'Below';
            case 'CCC122':
                return 'Above';
            // Tibetan
            case 'CCC129':
            case 'CCC132':
                return 'Below';
            case 'CCC130':
                return 'Above';
        }
        return combiningClass;
    }
    constructor(font){
        this.font = font;
    }
}
/**
 * Represents a glyph bounding box
 */ class $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039 {
    /**
   * The width of the bounding box
   * @type {number}
   */ get width() {
        return this.maxX - this.minX;
    }
    /**
   * The height of the bounding box
   * @type {number}
   */ get height() {
        return this.maxY - this.minY;
    }
    addPoint(x, y) {
        if (Math.abs(x) !== Infinity) {
            if (x < this.minX) this.minX = x;
            if (x > this.maxX) this.maxX = x;
        }
        if (Math.abs(y) !== Infinity) {
            if (y < this.minY) this.minY = y;
            if (y > this.maxY) this.maxY = y;
        }
    }
    copy() {
        return new $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039(this.minX, this.minY, this.maxX, this.maxY);
    }
    constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
    }
}
// This maps the Unicode Script property to an OpenType script tag
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
const $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS = {
    Caucasian_Albanian: 'aghb',
    Arabic: 'arab',
    Imperial_Aramaic: 'armi',
    Armenian: 'armn',
    Avestan: 'avst',
    Balinese: 'bali',
    Bamum: 'bamu',
    Bassa_Vah: 'bass',
    Batak: 'batk',
    Bengali: [
        'bng2',
        'beng'
    ],
    Bopomofo: 'bopo',
    Brahmi: 'brah',
    Braille: 'brai',
    Buginese: 'bugi',
    Buhid: 'buhd',
    Chakma: 'cakm',
    Canadian_Aboriginal: 'cans',
    Carian: 'cari',
    Cham: 'cham',
    Cherokee: 'cher',
    Coptic: 'copt',
    Cypriot: 'cprt',
    Cyrillic: 'cyrl',
    Devanagari: [
        'dev2',
        'deva'
    ],
    Deseret: 'dsrt',
    Duployan: 'dupl',
    Egyptian_Hieroglyphs: 'egyp',
    Elbasan: 'elba',
    Ethiopic: 'ethi',
    Georgian: 'geor',
    Glagolitic: 'glag',
    Gothic: 'goth',
    Grantha: 'gran',
    Greek: 'grek',
    Gujarati: [
        'gjr2',
        'gujr'
    ],
    Gurmukhi: [
        'gur2',
        'guru'
    ],
    Hangul: 'hang',
    Han: 'hani',
    Hanunoo: 'hano',
    Hebrew: 'hebr',
    Hiragana: 'hira',
    Pahawh_Hmong: 'hmng',
    Katakana_Or_Hiragana: 'hrkt',
    Old_Italic: 'ital',
    Javanese: 'java',
    Kayah_Li: 'kali',
    Katakana: 'kana',
    Kharoshthi: 'khar',
    Khmer: 'khmr',
    Khojki: 'khoj',
    Kannada: [
        'knd2',
        'knda'
    ],
    Kaithi: 'kthi',
    Tai_Tham: 'lana',
    Lao: 'lao ',
    Latin: 'latn',
    Lepcha: 'lepc',
    Limbu: 'limb',
    Linear_A: 'lina',
    Linear_B: 'linb',
    Lisu: 'lisu',
    Lycian: 'lyci',
    Lydian: 'lydi',
    Mahajani: 'mahj',
    Mandaic: 'mand',
    Manichaean: 'mani',
    Mende_Kikakui: 'mend',
    Meroitic_Cursive: 'merc',
    Meroitic_Hieroglyphs: 'mero',
    Malayalam: [
        'mlm2',
        'mlym'
    ],
    Modi: 'modi',
    Mongolian: 'mong',
    Mro: 'mroo',
    Meetei_Mayek: 'mtei',
    Myanmar: [
        'mym2',
        'mymr'
    ],
    Old_North_Arabian: 'narb',
    Nabataean: 'nbat',
    Nko: 'nko ',
    Ogham: 'ogam',
    Ol_Chiki: 'olck',
    Old_Turkic: 'orkh',
    Oriya: [
        'ory2',
        'orya'
    ],
    Osmanya: 'osma',
    Palmyrene: 'palm',
    Pau_Cin_Hau: 'pauc',
    Old_Permic: 'perm',
    Phags_Pa: 'phag',
    Inscriptional_Pahlavi: 'phli',
    Psalter_Pahlavi: 'phlp',
    Phoenician: 'phnx',
    Miao: 'plrd',
    Inscriptional_Parthian: 'prti',
    Rejang: 'rjng',
    Runic: 'runr',
    Samaritan: 'samr',
    Old_South_Arabian: 'sarb',
    Saurashtra: 'saur',
    Shavian: 'shaw',
    Sharada: 'shrd',
    Siddham: 'sidd',
    Khudawadi: 'sind',
    Sinhala: 'sinh',
    Sora_Sompeng: 'sora',
    Sundanese: 'sund',
    Syloti_Nagri: 'sylo',
    Syriac: 'syrc',
    Tagbanwa: 'tagb',
    Takri: 'takr',
    Tai_Le: 'tale',
    New_Tai_Lue: 'talu',
    Tamil: [
        'tml2',
        'taml'
    ],
    Tai_Viet: 'tavt',
    Telugu: [
        'tel2',
        'telu'
    ],
    Tifinagh: 'tfng',
    Tagalog: 'tglg',
    Thaana: 'thaa',
    Thai: 'thai',
    Tibetan: 'tibt',
    Tirhuta: 'tirh',
    Ugaritic: 'ugar',
    Vai: 'vai ',
    Warang_Citi: 'wara',
    Old_Persian: 'xpeo',
    Cuneiform: 'xsux',
    Yi: 'yi  ',
    Inherited: 'zinh',
    Common: 'zyyy',
    Unknown: 'zzzz'
};
const $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS = {};
for(let script in $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS){
    let tag = $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script];
    if (Array.isArray(tag)) for (let t of tag)$f7a6899246d76dab$var$$e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[t] = script;
    else $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[tag] = script;
}
function $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$b32f0b5f69d65e51(script) {
    return $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script];
}
function $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$ce50e82f12a827a4(tag) {
    return $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[tag];
}
function $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$e5cb25e204fb8450(string) {
    let len = string.length;
    let idx = 0;
    while(idx < len){
        let code = string.charCodeAt(idx++);
        // Check if this is a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
            let next = string.charCodeAt(idx);
            // Check if this is a low surrogate
            if (0xdc00 <= next && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
            }
        }
        let script = (0, $k9oO0.getScript)(code);
        if (script !== 'Common' && script !== 'Inherited' && script !== 'Unknown') return $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script];
    }
    return $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS.Unknown;
}
function $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$16fab0757cfc223d(codePoints) {
    for(let i = 0; i < codePoints.length; i++){
        let codePoint = codePoints[i];
        let script = (0, $k9oO0.getScript)(codePoint);
        if (script !== 'Common' && script !== 'Inherited' && script !== 'Unknown') return $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script];
    }
    return $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$UNICODE_SCRIPTS.Unknown;
}
// The scripts in this map are written from right to left
const $f7a6899246d76dab$var$$e38a1a895f6aeb54$var$RTL = {
    arab: true,
    hebr: true,
    syrc: true,
    thaa: true,
    cprt: true,
    khar: true,
    phnx: true,
    'nko ': true,
    lydi: true,
    avst: true,
    armi: true,
    phli: true,
    prti: true,
    sarb: true,
    orkh: true,
    samr: true,
    mand: true,
    merc: true,
    mero: true,
    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
    mani: true,
    mend: true,
    nbat: true,
    narb: true,
    palm: true,
    phlp: true // Psalter Pahlavi
};
function $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script) {
    if ($f7a6899246d76dab$var$$e38a1a895f6aeb54$var$RTL[script]) return 'rtl';
    return 'ltr';
}
class $f7a6899246d76dab$var$$b19c79ec7a94fa39$export$2e2bcd8739ae039 {
    /**
   * The total advance width of the run.
   * @type {number}
   */ get advanceWidth() {
        let width = 0;
        for (let position of this.positions)width += position.xAdvance;
        return width;
    }
    /**
  * The total advance height of the run.
  * @type {number}
  */ get advanceHeight() {
        let height = 0;
        for (let position of this.positions)height += position.yAdvance;
        return height;
    }
    /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */ get bbox() {
        let bbox = new $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        let x = 0;
        let y = 0;
        for(let index = 0; index < this.glyphs.length; index++){
            let glyph = this.glyphs[index];
            let p = this.positions[index];
            let b = glyph.bbox;
            bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
            bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
            x += p.xAdvance;
            y += p.yAdvance;
        }
        return bbox;
    }
    constructor(glyphs, features, script, language, direction){
        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction || $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script);
        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {};
        // Convert features to an object
        if (Array.isArray(features)) for (let tag of features)this.features[tag] = true;
        else if (typeof features === 'object') this.features = features;
    }
}
/**
 * Represents positioning information for a glyph in a GlyphRun.
 */ class $f7a6899246d76dab$var$$9195cf1266c12ea5$export$2e2bcd8739ae039 {
    constructor(xAdvance = 0, yAdvance = 0, xOffset = 0, yOffset = 0){
        /**
     * The amount to move the virtual pen in the X direction after rendering this glyph.
     * @type {number}
     */ this.xAdvance = xAdvance;
        /**
     * The amount to move the virtual pen in the Y direction after rendering this glyph.
     * @type {number}
     */ this.yAdvance = yAdvance;
        /**
     * The offset from the pen position in the X direction at which to render this glyph.
     * @type {number}
     */ this.xOffset = xOffset;
        /**
     * The offset from the pen position in the Y direction at which to render this glyph.
     * @type {number}
     */ this.yOffset = yOffset;
    }
}
// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
const $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features = {
    allTypographicFeatures: {
        code: 0,
        exclusive: false,
        allTypeFeatures: 0
    },
    ligatures: {
        code: 1,
        exclusive: false,
        requiredLigatures: 0,
        commonLigatures: 2,
        rareLigatures: 4,
        // logos: 6
        rebusPictures: 8,
        diphthongLigatures: 10,
        squaredLigatures: 12,
        abbrevSquaredLigatures: 14,
        symbolLigatures: 16,
        contextualLigatures: 18,
        historicalLigatures: 20
    },
    cursiveConnection: {
        code: 2,
        exclusive: true,
        unconnected: 0,
        partiallyConnected: 1,
        cursive: 2
    },
    letterCase: {
        code: 3,
        exclusive: true
    },
    // upperAndLowerCase: 0          # deprecated
    // allCaps: 1                    # deprecated
    // allLowerCase: 2               # deprecated
    // smallCaps: 3                  # deprecated
    // initialCaps: 4                # deprecated
    // initialCapsAndSmallCaps: 5    # deprecated
    verticalSubstitution: {
        code: 4,
        exclusive: false,
        substituteVerticalForms: 0
    },
    linguisticRearrangement: {
        code: 5,
        exclusive: false,
        linguisticRearrangement: 0
    },
    numberSpacing: {
        code: 6,
        exclusive: true,
        monospacedNumbers: 0,
        proportionalNumbers: 1,
        thirdWidthNumbers: 2,
        quarterWidthNumbers: 3
    },
    smartSwash: {
        code: 8,
        exclusive: false,
        wordInitialSwashes: 0,
        wordFinalSwashes: 2,
        // lineInitialSwashes: 4
        // lineFinalSwashes: 6
        nonFinalSwashes: 8
    },
    diacritics: {
        code: 9,
        exclusive: true,
        showDiacritics: 0,
        hideDiacritics: 1,
        decomposeDiacritics: 2
    },
    verticalPosition: {
        code: 10,
        exclusive: true,
        normalPosition: 0,
        superiors: 1,
        inferiors: 2,
        ordinals: 3,
        scientificInferiors: 4
    },
    fractions: {
        code: 11,
        exclusive: true,
        noFractions: 0,
        verticalFractions: 1,
        diagonalFractions: 2
    },
    overlappingCharacters: {
        code: 13,
        exclusive: false,
        preventOverlap: 0
    },
    typographicExtras: {
        code: 14,
        exclusive: false,
        // hyphensToEmDash: 0
        // hyphenToEnDash: 2
        slashedZero: 4
    },
    // formInterrobang: 6
    // smartQuotes: 8
    // periodsToEllipsis: 10
    mathematicalExtras: {
        code: 15,
        exclusive: false,
        // hyphenToMinus: 0
        // asteristoMultiply: 2
        // slashToDivide: 4
        // inequalityLigatures: 6
        // exponents: 8
        mathematicalGreek: 10
    },
    ornamentSets: {
        code: 16,
        exclusive: true,
        noOrnaments: 0,
        dingbats: 1,
        piCharacters: 2,
        fleurons: 3,
        decorativeBorders: 4,
        internationalSymbols: 5,
        mathSymbols: 6
    },
    characterAlternatives: {
        code: 17,
        exclusive: true,
        noAlternates: 0
    },
    // user defined options
    designComplexity: {
        code: 18,
        exclusive: true,
        designLevel1: 0,
        designLevel2: 1,
        designLevel3: 2,
        designLevel4: 3,
        designLevel5: 4
    },
    styleOptions: {
        code: 19,
        exclusive: true,
        noStyleOptions: 0,
        displayText: 1,
        engravedText: 2,
        illuminatedCaps: 3,
        titlingCaps: 4,
        tallCaps: 5
    },
    characterShape: {
        code: 20,
        exclusive: true,
        traditionalCharacters: 0,
        simplifiedCharacters: 1,
        JIS1978Characters: 2,
        JIS1983Characters: 3,
        JIS1990Characters: 4,
        traditionalAltOne: 5,
        traditionalAltTwo: 6,
        traditionalAltThree: 7,
        traditionalAltFour: 8,
        traditionalAltFive: 9,
        expertCharacters: 10,
        JIS2004Characters: 11,
        hojoCharacters: 12,
        NLCCharacters: 13,
        traditionalNamesCharacters: 14
    },
    numberCase: {
        code: 21,
        exclusive: true,
        lowerCaseNumbers: 0,
        upperCaseNumbers: 1
    },
    textSpacing: {
        code: 22,
        exclusive: true,
        proportionalText: 0,
        monospacedText: 1,
        halfWidthText: 2,
        thirdWidthText: 3,
        quarterWidthText: 4,
        altProportionalText: 5,
        altHalfWidthText: 6
    },
    transliteration: {
        code: 23,
        exclusive: true,
        noTransliteration: 0
    },
    // hanjaToHangul: 1
    // hiraganaToKatakana: 2
    // katakanaToHiragana: 3
    // kanaToRomanization: 4
    // romanizationToHiragana: 5
    // romanizationToKatakana: 6
    // hanjaToHangulAltOne: 7
    // hanjaToHangulAltTwo: 8
    // hanjaToHangulAltThree: 9
    annotation: {
        code: 24,
        exclusive: true,
        noAnnotation: 0,
        boxAnnotation: 1,
        roundedBoxAnnotation: 2,
        circleAnnotation: 3,
        invertedCircleAnnotation: 4,
        parenthesisAnnotation: 5,
        periodAnnotation: 6,
        romanNumeralAnnotation: 7,
        diamondAnnotation: 8,
        invertedBoxAnnotation: 9,
        invertedRoundedBoxAnnotation: 10
    },
    kanaSpacing: {
        code: 25,
        exclusive: true,
        fullWidthKana: 0,
        proportionalKana: 1
    },
    ideographicSpacing: {
        code: 26,
        exclusive: true,
        fullWidthIdeographs: 0,
        proportionalIdeographs: 1,
        halfWidthIdeographs: 2
    },
    unicodeDecomposition: {
        code: 27,
        exclusive: false,
        canonicalComposition: 0,
        compatibilityComposition: 2,
        transcodingComposition: 4
    },
    rubyKana: {
        code: 28,
        exclusive: false,
        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
        // rubyKana: 1     # deprecated - use rubyKanaOn instead
        rubyKana: 2
    },
    CJKSymbolAlternatives: {
        code: 29,
        exclusive: true,
        noCJKSymbolAlternatives: 0,
        CJKSymbolAltOne: 1,
        CJKSymbolAltTwo: 2,
        CJKSymbolAltThree: 3,
        CJKSymbolAltFour: 4,
        CJKSymbolAltFive: 5
    },
    ideographicAlternatives: {
        code: 30,
        exclusive: true,
        noIdeographicAlternatives: 0,
        ideographicAltOne: 1,
        ideographicAltTwo: 2,
        ideographicAltThree: 3,
        ideographicAltFour: 4,
        ideographicAltFive: 5
    },
    CJKVerticalRomanPlacement: {
        code: 31,
        exclusive: true,
        CJKVerticalRomanCentered: 0,
        CJKVerticalRomanHBaseline: 1
    },
    italicCJKRoman: {
        code: 32,
        exclusive: false,
        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
        CJKItalicRoman: 2
    },
    caseSensitiveLayout: {
        code: 33,
        exclusive: false,
        caseSensitiveLayout: 0,
        caseSensitiveSpacing: 2
    },
    alternateKana: {
        code: 34,
        exclusive: false,
        alternateHorizKana: 0,
        alternateVertKana: 2
    },
    stylisticAlternatives: {
        code: 35,
        exclusive: false,
        noStylisticAlternates: 0,
        stylisticAltOne: 2,
        stylisticAltTwo: 4,
        stylisticAltThree: 6,
        stylisticAltFour: 8,
        stylisticAltFive: 10,
        stylisticAltSix: 12,
        stylisticAltSeven: 14,
        stylisticAltEight: 16,
        stylisticAltNine: 18,
        stylisticAltTen: 20,
        stylisticAltEleven: 22,
        stylisticAltTwelve: 24,
        stylisticAltThirteen: 26,
        stylisticAltFourteen: 28,
        stylisticAltFifteen: 30,
        stylisticAltSixteen: 32,
        stylisticAltSeventeen: 34,
        stylisticAltEighteen: 36,
        stylisticAltNineteen: 38,
        stylisticAltTwenty: 40
    },
    contextualAlternates: {
        code: 36,
        exclusive: false,
        contextualAlternates: 0,
        swashAlternates: 2,
        contextualSwashAlternates: 4
    },
    lowerCase: {
        code: 37,
        exclusive: true,
        defaultLowerCase: 0,
        lowerCaseSmallCaps: 1,
        lowerCasePetiteCaps: 2
    },
    upperCase: {
        code: 38,
        exclusive: true,
        defaultUpperCase: 0,
        upperCaseSmallCaps: 1,
        upperCasePetiteCaps: 2
    },
    languageTag: {
        code: 39,
        exclusive: true
    },
    CJKRomanSpacing: {
        code: 103,
        exclusive: true,
        halfWidthCJKRoman: 0,
        proportionalCJKRoman: 1,
        defaultCJKRoman: 2,
        fullWidthCJKRoman: 3
    }
};
const $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature = (name, selector)=>[
        $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features[name].code,
        $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features[name][selector]
    ];
const $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$OTMapping = {
    rlig: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('ligatures', 'requiredLigatures'),
    clig: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('ligatures', 'contextualLigatures'),
    dlig: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('ligatures', 'rareLigatures'),
    hlig: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('ligatures', 'historicalLigatures'),
    liga: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('ligatures', 'commonLigatures'),
    hist: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('ligatures', 'historicalLigatures'),
    smcp: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('lowerCase', 'lowerCaseSmallCaps'),
    pcap: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('lowerCase', 'lowerCasePetiteCaps'),
    frac: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('fractions', 'diagonalFractions'),
    dnom: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('fractions', 'diagonalFractions'),
    numr: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('fractions', 'diagonalFractions'),
    afrc: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('fractions', 'verticalFractions'),
    // aalt
    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
    // unic, vatu, vhal, vjmo, vpal, vrt2
    // dist -> trak table?
    // kern, vkrn -> kern table
    // lfbd + opbd + rtbd -> opbd table?
    // mark, mkmk -> acnt table?
    // locl -> languageTag + ltag table
    case: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('caseSensitiveLayout', 'caseSensitiveLayout'),
    ccmp: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('unicodeDecomposition', 'canonicalComposition'),
    cpct: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    valt: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    swsh: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('contextualAlternates', 'swashAlternates'),
    cswh: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('contextualAlternates', 'contextualSwashAlternates'),
    curs: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('cursiveConnection', 'cursive'),
    c2pc: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('upperCase', 'upperCasePetiteCaps'),
    c2sc: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('upperCase', 'upperCaseSmallCaps'),
    init: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('smartSwash', 'wordInitialSwashes'),
    fin2: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('smartSwash', 'wordFinalSwashes'),
    medi: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('smartSwash', 'nonFinalSwashes'),
    med2: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('smartSwash', 'nonFinalSwashes'),
    fin3: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('smartSwash', 'wordFinalSwashes'),
    fina: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('smartSwash', 'wordFinalSwashes'),
    pkna: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('kanaSpacing', 'proportionalKana'),
    half: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'halfWidthText'),
    halt: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'altHalfWidthText'),
    hkna: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('alternateKana', 'alternateHorizKana'),
    vkna: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('alternateKana', 'alternateVertKana'),
    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
    ital: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('italicCJKRoman', 'CJKItalicRoman'),
    lnum: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('numberCase', 'upperCaseNumbers'),
    onum: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('numberCase', 'lowerCaseNumbers'),
    mgrk: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('mathematicalExtras', 'mathematicalGreek'),
    // nalt: not enough info. what type of annotation?
    // ornm: ditto, which ornament style?
    calt: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('contextualAlternates', 'contextualAlternates'),
    vrt2: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    vert: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    tnum: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('numberSpacing', 'monospacedNumbers'),
    pnum: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('numberSpacing', 'proportionalNumbers'),
    sups: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('verticalPosition', 'superiors'),
    subs: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('verticalPosition', 'inferiors'),
    ordn: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('verticalPosition', 'ordinals'),
    pwid: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'proportionalText'),
    hwid: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'halfWidthText'),
    qwid: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'quarterWidthText'),
    twid: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'thirdWidthText'),
    fwid: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'proportionalText'),
    palt: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('textSpacing', 'altProportionalText'),
    trad: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'traditionalCharacters'),
    smpl: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'simplifiedCharacters'),
    jp78: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'JIS1978Characters'),
    jp83: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'JIS1983Characters'),
    jp90: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'JIS1990Characters'),
    jp04: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'JIS2004Characters'),
    expt: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'expertCharacters'),
    hojo: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'hojoCharacters'),
    nlck: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'NLCCharacters'),
    tnam: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('characterShape', 'traditionalNamesCharacters'),
    ruby: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('rubyKana', 'rubyKana'),
    titl: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('styleOptions', 'titlingCaps'),
    zero: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('typographicExtras', 'slashedZero'),
    ss01: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltOne'),
    ss02: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltTwo'),
    ss03: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltThree'),
    ss04: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltFour'),
    ss05: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltFive'),
    ss06: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltSix'),
    ss07: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltSeven'),
    ss08: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltEight'),
    ss09: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltNine'),
    ss10: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltTen'),
    ss11: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltEleven'),
    ss12: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltTwelve'),
    ss13: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltThirteen'),
    ss14: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltFourteen'),
    ss15: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltFifteen'),
    ss16: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltSixteen'),
    ss17: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltSeventeen'),
    ss18: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltEighteen'),
    ss19: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltNineteen'),
    ss20: $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$feature('stylisticAlternatives', 'stylisticAltTwenty')
};
// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
// Add cv01-cv99 features
for(let i = 1; i <= 99; i++)$f7a6899246d76dab$var$$2b7f887ebcb5888a$var$OTMapping[`cv${`00${i}`.slice(-2)}`] = [
    $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features.characterAlternatives.code,
    i
];
// create inverse mapping
let $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping = {};
for(let ot in $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$OTMapping){
    let aat = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$OTMapping[ot];
    if ($f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping[aat[0]] == null) $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping[aat[0]] = {};
    $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping[aat[0]][aat[1]] = ot;
}
function $f7a6899246d76dab$var$$2b7f887ebcb5888a$export$b813f7d2a1677c16(features) {
    let res = {};
    for(let k in features){
        let r;
        if (r = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$OTMapping[k]) {
            if (res[r[0]] == null) res[r[0]] = {};
            res[r[0]][r[1]] = features[k];
        }
    }
    return res;
}
// Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$mapFeatureStrings(f) {
    let [type, setting] = f;
    if (isNaN(type)) var typeCode = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features[type] && $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features[type].code;
    else var typeCode = type;
    if (isNaN(setting)) var settingCode = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features[type] && $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$features[type][setting];
    else var settingCode = setting;
    return [
        typeCode,
        settingCode
    ];
}
function $f7a6899246d76dab$var$$2b7f887ebcb5888a$export$bd6df347a4f391c4(features) {
    let res = {};
    if (Array.isArray(features)) for(let k = 0; k < features.length; k++){
        let r;
        let f = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$mapFeatureStrings(features[k]);
        if (r = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping[f[0]] && $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping[f[0]][f[1]]) res[r] = true;
    }
    else if (typeof features === 'object') for(let type in features){
        let feature = features[type];
        for(let setting in feature){
            let r;
            let f = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$mapFeatureStrings([
                type,
                setting
            ]);
            if (feature[setting] && (r = $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping[f[0]] && $f7a6899246d76dab$var$$2b7f887ebcb5888a$var$AATMapping[f[0]][f[1]])) res[r] = true;
        }
    }
    return Object.keys(res);
}
class $f7a6899246d76dab$var$$f3d63ae925545400$export$2e2bcd8739ae039 {
    lookup(glyph) {
        switch(this.table.version){
            case 0:
                return this.table.values.getItem(glyph);
            case 2:
            case 4:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.firstGlyph === 0xffff) return null;
                        if (glyph < seg.firstGlyph) max = mid - 1;
                        else if (glyph > seg.lastGlyph) min = mid + 1;
                        else {
                            if (this.table.version === 2) return seg.value;
                            else return seg.values[glyph - seg.firstGlyph];
                        }
                    }
                    return null;
                }
            case 6:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.glyph === 0xffff) return null;
                        if (glyph < seg.glyph) max = mid - 1;
                        else if (glyph > seg.glyph) min = mid + 1;
                        else return seg.value;
                    }
                    return null;
                }
            case 8:
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
    }
    glyphsForValue(classValue) {
        let res = [];
        switch(this.table.version){
            case 2:
            case 4:
                for (let segment of this.table.segments)if (this.table.version === 2 && segment.value === classValue) res.push(...$f7a6899246d76dab$var$$66a5b9fb5318558a$export$d02631cccf789723(segment.firstGlyph, segment.lastGlyph + 1));
                else {
                    for(let index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                }
                break;
            case 6:
                for (let segment of this.table.segments)if (segment.value === classValue) res.push(segment.glyph);
                break;
            case 8:
                for(let i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                break;
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
        return res;
    }
    constructor(table){
        this.table = table;
    }
}
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$f3d63ae925545400$export$2e2bcd8739ae039.prototype, "glyphsForValue", null);
const $f7a6899246d76dab$var$$860c6347bb941b91$var$START_OF_TEXT_STATE = 0;
const $f7a6899246d76dab$var$$860c6347bb941b91$var$START_OF_LINE_STATE = 1;
const $f7a6899246d76dab$var$$860c6347bb941b91$var$END_OF_TEXT_CLASS = 0;
const $f7a6899246d76dab$var$$860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS = 1;
const $f7a6899246d76dab$var$$860c6347bb941b91$var$DELETED_GLYPH_CLASS = 2;
const $f7a6899246d76dab$var$$860c6347bb941b91$var$END_OF_LINE_CLASS = 3;
const $f7a6899246d76dab$var$$860c6347bb941b91$var$DONT_ADVANCE = 0x4000;
class $f7a6899246d76dab$var$$860c6347bb941b91$export$2e2bcd8739ae039 {
    process(glyphs, reverse, processEntry) {
        let currentState = $f7a6899246d76dab$var$$860c6347bb941b91$var$START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
        let index = reverse ? glyphs.length - 1 : 0;
        let dir = reverse ? -1 : 1;
        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
            let glyph = null;
            let classCode = $f7a6899246d76dab$var$$860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS;
            let shouldAdvance = true;
            if (index === glyphs.length || index === -1) classCode = $f7a6899246d76dab$var$$860c6347bb941b91$var$END_OF_TEXT_CLASS;
            else {
                glyph = glyphs[index];
                if (glyph.id === 0xffff) classCode = $f7a6899246d76dab$var$$860c6347bb941b91$var$DELETED_GLYPH_CLASS;
                else {
                    classCode = this.lookupTable.lookup(glyph.id);
                    if (classCode == null) classCode = $f7a6899246d76dab$var$$860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS;
                }
            }
            let row = this.stateTable.stateArray.getItem(currentState);
            let entryIndex = row[classCode];
            let entry = this.stateTable.entryTable.getItem(entryIndex);
            if (classCode !== $f7a6899246d76dab$var$$860c6347bb941b91$var$END_OF_TEXT_CLASS && classCode !== $f7a6899246d76dab$var$$860c6347bb941b91$var$DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & $f7a6899246d76dab$var$$860c6347bb941b91$var$DONT_ADVANCE);
            }
            currentState = entry.newState;
            if (shouldAdvance) index += dir;
        }
        return glyphs;
    }
    /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */ traverse(opts, state = 0, visited = new Set) {
        if (visited.has(state)) return;
        visited.add(state);
        let { nClasses: nClasses, stateArray: stateArray, entryTable: entryTable } = this.stateTable;
        let row = stateArray.getItem(state);
        // Skip predefined classes
        for(let classCode = 4; classCode < nClasses; classCode++){
            let entryIndex = row[classCode];
            let entry = entryTable.getItem(entryIndex);
            // Try all glyphs in the class
            for (let glyph of this.lookupTable.glyphsForValue(classCode)){
                if (opts.enter) opts.enter(glyph, entry);
                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                if (opts.exit) opts.exit(glyph, entry);
            }
        }
    }
    constructor(stateTable){
        this.stateTable = stateTable;
        this.lookupTable = new $f7a6899246d76dab$var$$f3d63ae925545400$export$2e2bcd8739ae039(stateTable.classTable);
    }
}
// indic replacement flags
const $f7a6899246d76dab$var$$99be642f82069918$var$MARK_FIRST = 0x8000;
const $f7a6899246d76dab$var$$99be642f82069918$var$MARK_LAST = 0x2000;
const $f7a6899246d76dab$var$$99be642f82069918$var$VERB = 0x000F;
// contextual substitution and glyph insertion flag
const $f7a6899246d76dab$var$$99be642f82069918$var$SET_MARK = 0x8000;
// ligature entry flags
const $f7a6899246d76dab$var$$99be642f82069918$var$SET_COMPONENT = 0x8000;
const $f7a6899246d76dab$var$$99be642f82069918$var$PERFORM_ACTION = 0x2000;
// ligature action masks
const $f7a6899246d76dab$var$$99be642f82069918$var$LAST_MASK = 0x80000000;
const $f7a6899246d76dab$var$$99be642f82069918$var$STORE_MASK = 0x40000000;
const $f7a6899246d76dab$var$$99be642f82069918$var$OFFSET_MASK = 0x3FFFFFFF;
const $f7a6899246d76dab$var$$99be642f82069918$var$VERTICAL_ONLY = 0x800000;
const $f7a6899246d76dab$var$$99be642f82069918$var$REVERSE_DIRECTION = 0x400000;
const $f7a6899246d76dab$var$$99be642f82069918$var$HORIZONTAL_AND_VERTICAL = 0x200000;
// glyph insertion flags
const $f7a6899246d76dab$var$$99be642f82069918$var$CURRENT_IS_KASHIDA_LIKE = 0x2000;
const $f7a6899246d76dab$var$$99be642f82069918$var$MARKED_IS_KASHIDA_LIKE = 0x1000;
const $f7a6899246d76dab$var$$99be642f82069918$var$CURRENT_INSERT_BEFORE = 0x0800;
const $f7a6899246d76dab$var$$99be642f82069918$var$MARKED_INSERT_BEFORE = 0x0400;
const $f7a6899246d76dab$var$$99be642f82069918$var$CURRENT_INSERT_COUNT = 0x03E0;
const $f7a6899246d76dab$var$$99be642f82069918$var$MARKED_INSERT_COUNT = 0x001F;
class $f7a6899246d76dab$var$$99be642f82069918$export$2e2bcd8739ae039 {
    // Processes an array of glyphs and applies the specified features
    // Features should be in the form of {featureType:{featureSetting:boolean}}
    process(glyphs, features = {}) {
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            // enable/disable the requested features
            for (let feature of chain.features){
                let f;
                if (f = features[feature.featureType]) {
                    if (f[feature.featureSetting]) {
                        flags &= feature.disableFlags;
                        flags |= feature.enableFlags;
                    } else if (f[feature.featureSetting] === false) {
                        flags |= ~feature.disableFlags;
                        flags &= ~feature.enableFlags;
                    }
                }
            }
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
        }
        // remove deleted glyphs
        let index = glyphs.length - 1;
        while(index >= 0){
            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
            index--;
        }
        return glyphs;
    }
    processSubtable(subtable, glyphs) {
        this.subtable = subtable;
        this.glyphs = glyphs;
        if (this.subtable.type === 4) {
            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
            return;
        }
        this.ligatureStack = [];
        this.markedGlyph = null;
        this.firstGlyph = null;
        this.lastGlyph = null;
        this.markedIndex = null;
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let reverse = !!(this.subtable.coverage & $f7a6899246d76dab$var$$99be642f82069918$var$REVERSE_DIRECTION);
        return stateMachine.process(this.glyphs, reverse, process);
    }
    getStateMachine(subtable) {
        return new $f7a6899246d76dab$var$$860c6347bb941b91$export$2e2bcd8739ae039(subtable.table.stateTable);
    }
    getProcessor() {
        switch(this.subtable.type){
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
        }
    }
    processIndicRearragement(glyph, entry, index) {
        if (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$MARK_FIRST) this.firstGlyph = index;
        if (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$MARK_LAST) this.lastGlyph = index;
        $f7a6899246d76dab$var$$99be642f82069918$var$reorderGlyphs(this.glyphs, entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$VERB, this.firstGlyph, this.lastGlyph);
    }
    processContextualSubstitution(glyph, entry, index) {
        let subsitutions = this.subtable.table.substitutionTable.items;
        if (entry.markIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.markIndex);
            let lookupTable = new $f7a6899246d76dab$var$$f3d63ae925545400$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[this.markedGlyph];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.currentIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.currentIndex);
            let lookupTable = new $f7a6899246d76dab$var$$f3d63ae925545400$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[index];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$SET_MARK) this.markedGlyph = index;
    }
    processLigature(glyph, entry, index) {
        if (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$SET_COMPONENT) this.ligatureStack.push(index);
        if (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$PERFORM_ACTION) {
            let actions = this.subtable.table.ligatureActions;
            let components = this.subtable.table.components;
            let ligatureList = this.subtable.table.ligatureList;
            let actionIndex = entry.action;
            let last = false;
            let ligatureIndex = 0;
            let codePoints = [];
            let ligatureGlyphs = [];
            while(!last){
                let componentGlyph = this.ligatureStack.pop();
                codePoints.unshift(...this.glyphs[componentGlyph].codePoints);
                let action = actions.getItem(actionIndex++);
                last = !!(action & $f7a6899246d76dab$var$$99be642f82069918$var$LAST_MASK);
                let store = !!(action & $f7a6899246d76dab$var$$99be642f82069918$var$STORE_MASK);
                let offset = (action & $f7a6899246d76dab$var$$99be642f82069918$var$OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                offset += this.glyphs[componentGlyph].id;
                let component = components.getItem(offset);
                ligatureIndex += component;
                if (last || store) {
                    let ligatureEntry = ligatureList.getItem(ligatureIndex);
                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                    ligatureGlyphs.push(componentGlyph);
                    ligatureIndex = 0;
                    codePoints = [];
                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
            }
            // Put ligature glyph indexes back on the stack
            this.ligatureStack.push(...ligatureGlyphs);
        }
    }
    processNoncontextualSubstitutions(subtable, glyphs, index) {
        let lookupTable = new $f7a6899246d76dab$var$$f3d63ae925545400$export$2e2bcd8739ae039(subtable.table.lookupTable);
        for(index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.id !== 0xffff) {
                let gid = lookupTable.lookup(glyph.id);
                if (gid) glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
            }
        }
    }
    _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
        let insertions = [];
        while(count--){
            let gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
            insertions.push(this.font.getGlyph(gid));
        }
        if (!isBefore) glyphIndex++;
        this.glyphs.splice(glyphIndex, 0, ...insertions);
    }
    processGlyphInsertion(glyph, entry, index) {
        if (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$SET_MARK) this.markedIndex = index;
        if (entry.markedInsertIndex !== 0xffff) {
            let count = (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$MARKED_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$MARKED_INSERT_BEFORE);
            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
        }
        if (entry.currentInsertIndex !== 0xffff) {
            let count = (entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$CURRENT_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $f7a6899246d76dab$var$$99be642f82069918$var$CURRENT_INSERT_BEFORE);
            this._insertGlyphs(index, entry.currentInsertIndex, count, isBefore);
        }
    }
    getSupportedFeatures() {
        let features = [];
        for (let chain of this.morx.chains)for (let feature of chain.features)features.push([
            feature.featureType,
            feature.featureSetting
        ]);
        return features;
    }
    generateInputs(gid) {
        if (!this.inputCache) this.generateInputCache();
        return this.inputCache[gid] || [];
    }
    generateInputCache() {
        this.inputCache = {};
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
        }
    }
    generateInputsForSubtable(subtable) {
        // Currently, only supporting ligature subtables.
        if (subtable.type !== 2) return;
        let reverse = !!(subtable.coverage & $f7a6899246d76dab$var$$99be642f82069918$var$REVERSE_DIRECTION);
        if (reverse) throw new Error('Reverse subtable, not supported.');
        this.subtable = subtable;
        this.ligatureStack = [];
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let input = [];
        let stack = [];
        this.glyphs = [];
        stateMachine.traverse({
            enter: (glyph, entry)=>{
                let glyphs = this.glyphs;
                stack.push({
                    glyphs: glyphs.slice(),
                    ligatureStack: this.ligatureStack.slice()
                });
                // Add glyph to input and glyphs to process.
                let g = this.font.getGlyph(glyph);
                input.push(g);
                glyphs.push(input[input.length - 1]);
                // Process ligature substitution
                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
                // Add input to result if only one matching (non-deleted) glyph remains.
                let count = 0;
                let found = 0;
                for(let i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                }
                if (count === 1) {
                    let result = input.map((g)=>g.id);
                    let cache = this.inputCache[found];
                    if (cache) cache.push(result);
                    else this.inputCache[found] = [
                        result
                    ];
                }
            },
            exit: ()=>{
                ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = stack.pop());
                input.pop();
            }
        });
    }
    constructor(font){
        this.processIndicRearragement = this.processIndicRearragement.bind(this);
        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
        this.processLigature = this.processLigature.bind(this);
        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
        this.font = font;
        this.morx = font.morx;
        this.inputCache = null;
    }
}
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$99be642f82069918$export$2e2bcd8739ae039.prototype, "getStateMachine", null);
// swaps the glyphs in rangeA with those in rangeB
// reverse the glyphs inside those ranges if specified
// ranges are in [offset, length] format
function $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, rangeA, rangeB, reverseA = false, reverseB = false) {
    let end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) end.reverse();
    let start = glyphs.splice(rangeA[0], rangeA[1], ...end);
    if (reverseA) start.reverse();
    glyphs.splice(rangeB[0] - (rangeA[1] - 1), 0, ...start);
    return glyphs;
}
function $f7a6899246d76dab$var$$99be642f82069918$var$reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    let length = lastGlyph - firstGlyph + 1;
    switch(verb){
        case 0:
            return glyphs;
        case 1:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                0
            ]);
        case 2:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                1
            ]);
        case 3:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                1
            ]);
        case 4:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ]);
        case 5:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ], true, false);
        case 6:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ]);
        case 7:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ], false, true);
        case 8:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ]);
        case 9:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ], false, true);
        case 10:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ]);
        case 11:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ], true, false);
        case 12:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ]);
        case 13:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, false);
        case 14:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], false, true);
        case 15:
            return $f7a6899246d76dab$var$$99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, true);
        default:
            throw new Error(`Unknown verb: ${verb}`);
    }
}
class $f7a6899246d76dab$var$$860fcbd64bc12fbc$export$2e2bcd8739ae039 {
    substitute(glyphRun) {
        // AAT expects the glyphs to be in visual order prior to morx processing,
        // so reverse the glyphs if the script is right-to-left.
        if (glyphRun.direction === 'rtl') glyphRun.glyphs.reverse();
        this.morxProcessor.process(glyphRun.glyphs, $f7a6899246d76dab$var$$2b7f887ebcb5888a$export$b813f7d2a1677c16(glyphRun.features));
    }
    getAvailableFeatures(script, language) {
        return $f7a6899246d76dab$var$$2b7f887ebcb5888a$export$bd6df347a4f391c4(this.morxProcessor.getSupportedFeatures());
    }
    stringsForGlyph(gid) {
        let glyphStrings = this.morxProcessor.generateInputs(gid);
        let result = new Set;
        for (let glyphs of glyphStrings)this._addStrings(glyphs, 0, result, '');
        return result;
    }
    _addStrings(glyphs, index, strings, string) {
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
        for (let codePoint of codePoints){
            let s = string + String.fromCodePoint(codePoint);
            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
            else strings.add(s);
        }
    }
    constructor(font){
        this.font = font;
        this.morxProcessor = new $f7a6899246d76dab$var$$99be642f82069918$export$2e2bcd8739ae039(font);
        this.fallbackPosition = false;
    }
}
class $f7a6899246d76dab$var$$d7e93cca3cf8ce8a$export$2e2bcd8739ae039 {
    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ _addFeatures(features, global) {
        let stageIndex = this.stages.length - 1;
        let stage = this.stages[stageIndex];
        for (let feature of features)if (this.allFeatures[feature] == null) {
            stage.push(feature);
            this.allFeatures[feature] = stageIndex;
            if (global) this.globalFeatures[feature] = true;
        }
    }
    /**
   * Add features to the last stage
   */ add(arg, global = true) {
        if (this.stages.length === 0) this.stages.push([]);
        if (typeof arg === 'string') arg = [
            arg
        ];
        if (Array.isArray(arg)) this._addFeatures(arg, global);
        else if (typeof arg === 'object') {
            this._addFeatures(arg.global || [], true);
            this._addFeatures(arg.local || [], false);
        } else throw new Error("Unsupported argument to ShapingPlan#add");
    }
    /**
   * Add a new stage
   */ addStage(arg, global) {
        if (typeof arg === 'function') this.stages.push(arg, []);
        else {
            this.stages.push([]);
            this.add(arg, global);
        }
    }
    setFeatureOverrides(features) {
        if (Array.isArray(features)) this.add(features);
        else if (typeof features === 'object') for(let tag in features){
            if (features[tag]) this.add(tag);
            else if (this.allFeatures[tag] != null) {
                let stage = this.stages[this.allFeatures[tag]];
                stage.splice(stage.indexOf(tag), 1);
                delete this.allFeatures[tag];
                delete this.globalFeatures[tag];
            }
        }
    }
    /**
   * Assigns the global features to the given glyphs
   */ assignGlobalFeatures(glyphs) {
        for (let glyph of glyphs)for(let feature in this.globalFeatures)glyph.features[feature] = true;
    }
    /**
   * Executes the planned stages using the given OTProcessor
   */ process(processor, glyphs, positions) {
        for (let stage of this.stages){
            if (typeof stage === 'function') {
                if (!positions) stage(this.font, glyphs, this);
            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
        }
    }
    constructor(font, script, direction){
        this.font = font;
        this.script = script;
        this.direction = direction;
        this.stages = [];
        this.globalFeatures = {};
        this.allFeatures = {};
    }
}
const $f7a6899246d76dab$var$$d28fb665ee343afc$var$VARIATION_FEATURES = [
    'rvrn'
];
const $f7a6899246d76dab$var$$d28fb665ee343afc$var$COMMON_FEATURES = [
    'ccmp',
    'locl',
    'rlig',
    'mark',
    'mkmk'
];
const $f7a6899246d76dab$var$$d28fb665ee343afc$var$FRACTIONAL_FEATURES = [
    'frac',
    'numr',
    'dnom'
];
const $f7a6899246d76dab$var$$d28fb665ee343afc$var$HORIZONTAL_FEATURES = [
    'calt',
    'clig',
    'liga',
    'rclt',
    'curs',
    'kern'
];
const $f7a6899246d76dab$var$$d28fb665ee343afc$var$VERTICAL_FEATURES = [
    'vert'
];
const $f7a6899246d76dab$var$$d28fb665ee343afc$var$DIRECTIONAL_FEATURES = {
    ltr: [
        'ltra',
        'ltrm'
    ],
    rtl: [
        'rtla',
        'rtlm'
    ]
};
class $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039 {
    static plan(plan, glyphs, features) {
        // Plan the features we want to apply
        this.planPreprocessing(plan);
        this.planFeatures(plan);
        this.planPostprocessing(plan, features);
        // Assign the global features to all the glyphs
        plan.assignGlobalFeatures(glyphs);
        // Assign local features to glyphs
        this.assignFeatures(plan, glyphs);
    }
    static planPreprocessing(plan) {
        plan.add({
            global: [
                ...$f7a6899246d76dab$var$$d28fb665ee343afc$var$VARIATION_FEATURES,
                ...$f7a6899246d76dab$var$$d28fb665ee343afc$var$DIRECTIONAL_FEATURES[plan.direction]
            ],
            local: $f7a6899246d76dab$var$$d28fb665ee343afc$var$FRACTIONAL_FEATURES
        });
    }
    static planFeatures(plan) {
    // Do nothing by default. Let subclasses override this.
    }
    static planPostprocessing(plan, userFeatures) {
        plan.add([
            ...$f7a6899246d76dab$var$$d28fb665ee343afc$var$COMMON_FEATURES,
            ...$f7a6899246d76dab$var$$d28fb665ee343afc$var$HORIZONTAL_FEATURES
        ]);
        plan.setFeatureOverrides(userFeatures);
    }
    static assignFeatures(plan, glyphs) {
        // Enable contextual fractions
        for(let i = 0; i < glyphs.length; i++){
            let glyph = glyphs[i];
            if (glyph.codePoints[0] === 0x2044) {
                let start = i;
                let end = i + 1;
                // Apply numerator
                while(start > 0 && (0, $k9oO0.isDigit)(glyphs[start - 1].codePoints[0])){
                    glyphs[start - 1].features.numr = true;
                    glyphs[start - 1].features.frac = true;
                    start--;
                }
                // Apply denominator
                while(end < glyphs.length && (0, $k9oO0.isDigit)(glyphs[end].codePoints[0])){
                    glyphs[end].features.dnom = true;
                    glyphs[end].features.frac = true;
                    end++;
                }
                // Apply fraction slash
                glyph.features.frac = true;
                i = end - 1;
            }
        }
    }
}
(0, $4Bw9T._)($f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039, "zeroMarkWidths", 'AFTER_GPOS');
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$trie = new ($f7a6899246d76dab$var$$parcel$interopDefault($9daMG))($f7a6899246d76dab$var$$66a5b9fb5318558a$export$94fdf11bafc8de6b("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ=="));
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FEATURES = [
    'isol',
    'fina',
    'fin2',
    'fin3',
    'medi',
    'med2',
    'init'
];
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ShapingClasses = {
    Non_Joining: 0,
    Left_Joining: 1,
    Right_Joining: 2,
    Dual_Joining: 3,
    Join_Causing: 3,
    ALAPH: 4,
    'DALATH RISH': 5,
    Transparent: 6
};
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL = 'isol';
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA = 'fina';
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FIN2 = 'fin2';
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FIN3 = 'fin3';
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MEDI = 'medi';
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MED2 = 'med2';
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$INIT = 'init';
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE = null;
// Each entry is [prevAction, curAction, nextState]
const $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$STATE_TABLE = [
    //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
    // State 0: prev was U,  not willing to join.
    [
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 1: prev was R or ISOL/ALAPH,  not willing to join.
    [
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 2: prev was D/L in ISOL form,  willing to join.
    [
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$INIT,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$INIT,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            3
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$INIT,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            4
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$INIT,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            6
        ]
    ],
    // State 3: prev was D in FINA form,  willing to join.
    [
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MEDI,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MEDI,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            3
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MEDI,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            4
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MEDI,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FINA,
            6
        ]
    ],
    // State 4: prev was FINA ALAPH,  not willing to join.
    [
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MED2,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MED2,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MED2,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$MED2,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
    [
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 6: prev was DALATH/RISH,  not willing to join.
    [
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FIN3,
            5
        ],
        [
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE,
            $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ]
];
class $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            'ccmp',
            'locl'
        ]);
        for(let i = 0; i < $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FEATURES.length; i++){
            let feature = $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$FEATURES[i];
            plan.addStage(feature, false);
        }
        plan.addStage('mset');
    }
    static assignFeatures(plan, glyphs) {
        super.assignFeatures(plan, glyphs);
        let prev = -1;
        let state = 0;
        let actions = [];
        // Apply the state machine to map glyphs to features
        for(let i = 0; i < glyphs.length; i++){
            let curAction, prevAction;
            var glyph = glyphs[i];
            let type = $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$getShapingClass(glyph.codePoints[0]);
            if (type === $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ShapingClasses.Transparent) {
                actions[i] = $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE;
                continue;
            }
            [prevAction, curAction, state] = $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$STATE_TABLE[state][type];
            if (prevAction !== $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$NONE && prev !== -1) actions[prev] = prevAction;
            actions[i] = curAction;
            prev = i;
        }
        // Apply the chosen features to their respective glyphs
        for(let index = 0; index < glyphs.length; index++){
            let feature;
            var glyph = glyphs[index];
            if (feature = actions[index]) glyph.features[feature] = true;
        }
    }
}
function $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$getShapingClass(codePoint) {
    let res = $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$trie.get(codePoint);
    if (res) return res - 1;
    let category = (0, $k9oO0.getCategory)(codePoint);
    if (category === 'Mn' || category === 'Me' || category === 'Cf') return $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ShapingClasses.Transparent;
    return $f7a6899246d76dab$var$$17ba6019f27bfcf9$var$ShapingClasses.Non_Joining;
}
class $f7a6899246d76dab$var$$d6368085223f631e$export$2e2bcd8739ae039 {
    reset(options = {}, index = 0) {
        this.options = options;
        this.flags = options.flags || {};
        this.markAttachmentType = options.markAttachmentType || 0;
        this.index = index;
    }
    get cur() {
        return this.glyphs[this.index] || null;
    }
    shouldIgnore(glyph) {
        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
    }
    move(dir) {
        this.index += dir;
        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
        if (0 > this.index || this.index >= this.glyphs.length) return null;
        return this.glyphs[this.index];
    }
    next() {
        return this.move(1);
    }
    prev() {
        return this.move(-1);
    }
    peek(count = 1) {
        let idx = this.index;
        let res = this.increment(count);
        this.index = idx;
        return res;
    }
    peekIndex(count = 1) {
        let idx = this.index;
        this.increment(count);
        let res = this.index;
        this.index = idx;
        return res;
    }
    increment(count = 1) {
        let dir = count < 0 ? -1 : 1;
        count = Math.abs(count);
        while(count--)this.move(dir);
        return this.glyphs[this.index];
    }
    constructor(glyphs, options){
        this.glyphs = glyphs;
        this.reset(options);
    }
}
const $f7a6899246d76dab$var$$7b226e6bbeadedeb$var$DEFAULT_SCRIPTS = [
    'DFLT',
    'dflt',
    'latn'
];
class $f7a6899246d76dab$var$$7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    findScript(script) {
        if (this.table.scriptList == null) return null;
        if (!Array.isArray(script)) script = [
            script
        ];
        for (let s of script)for (let entry of this.table.scriptList){
            if (entry.tag === s) return entry;
        }
        return null;
    }
    selectScript(script, language, direction) {
        let changed = false;
        let entry;
        if (!this.script || script !== this.scriptTag) {
            entry = this.findScript(script);
            if (!entry) entry = this.findScript($f7a6899246d76dab$var$$7b226e6bbeadedeb$var$DEFAULT_SCRIPTS);
            if (!entry) return this.scriptTag;
            this.scriptTag = entry.tag;
            this.script = entry.script;
            this.language = null;
            this.languageTag = null;
            changed = true;
        }
        if (!direction || direction !== this.direction) this.direction = direction || $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script);
        if (language && language.length < 4) language += ' '.repeat(4 - language.length);
        if (!language || language !== this.languageTag) {
            this.language = null;
            for (let lang of this.script.langSysRecords)if (lang.tag === language) {
                this.language = lang.langSys;
                this.languageTag = lang.tag;
                break;
            }
            if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
            }
            changed = true;
        }
        // Build a feature lookup table
        if (changed) {
            this.features = {};
            if (this.language) for (let featureIndex of this.language.featureIndexes){
                let record = this.table.featureList[featureIndex];
                let substituteFeature = this.substituteFeatureForVariations(featureIndex);
                this.features[record.tag] = substituteFeature || record.feature;
            }
        }
        return this.scriptTag;
    }
    lookupsForFeatures(userFeatures = [], exclude) {
        let lookups = [];
        for (let tag of userFeatures){
            let feature = this.features[tag];
            if (!feature) continue;
            for (let lookupIndex of feature.lookupListIndexes){
                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                lookups.push({
                    feature: tag,
                    index: lookupIndex,
                    lookup: this.table.lookupList.get(lookupIndex)
                });
            }
        }
        lookups.sort((a, b)=>a.index - b.index);
        return lookups;
    }
    substituteFeatureForVariations(featureIndex) {
        if (this.variationsIndex === -1) return null;
        let record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
        let substitutions = record.featureTableSubstitution.substitutions;
        for (let substitution of substitutions){
            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
        }
        return null;
    }
    findVariationsIndex(coords) {
        let variations = this.table.featureVariations;
        if (!variations) return -1;
        let records = variations.featureVariationRecords;
        for(let i = 0; i < records.length; i++){
            let conditions = records[i].conditionSet.conditionTable;
            if (this.variationConditionsMatch(conditions, coords)) return i;
        }
        return -1;
    }
    variationConditionsMatch(conditions, coords) {
        return conditions.every((condition)=>{
            let coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
        });
    }
    applyFeatures(userFeatures, glyphs, advances) {
        let lookups = this.lookupsForFeatures(userFeatures);
        this.applyLookups(lookups, glyphs, advances);
    }
    applyLookups(lookups, glyphs, positions) {
        this.glyphs = glyphs;
        this.positions = positions;
        this.glyphIterator = new $f7a6899246d76dab$var$$d6368085223f631e$export$2e2bcd8739ae039(glyphs);
        for (let { feature: feature, lookup: lookup } of lookups){
            this.currentFeature = feature;
            this.glyphIterator.reset(lookup.flags);
            while(this.glyphIterator.index < glyphs.length){
                if (!(feature in this.glyphIterator.cur.features)) {
                    this.glyphIterator.next();
                    continue;
                }
                for (let table of lookup.subTables){
                    let res = this.applyLookup(lookup.lookupType, table);
                    if (res) break;
                }
                this.glyphIterator.next();
            }
        }
    }
    applyLookup(lookup, table) {
        throw new Error("applyLookup must be implemented by subclasses");
    }
    applyLookupList(lookupRecords) {
        let options = this.glyphIterator.options;
        let glyphIndex = this.glyphIterator.index;
        for (let lookupRecord of lookupRecords){
            // Reset flags and find glyph index for this lookup record
            this.glyphIterator.reset(options, glyphIndex);
            this.glyphIterator.increment(lookupRecord.sequenceIndex);
            // Get the lookup and setup flags for subtables
            let lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
            // Apply lookup subtables until one matches
            for (let table of lookup.subTables){
                if (this.applyLookup(lookup.lookupType, table)) break;
            }
        }
        this.glyphIterator.reset(options, glyphIndex);
        return true;
    }
    coverageIndex(coverage, glyph) {
        if (glyph == null) glyph = this.glyphIterator.cur.id;
        switch(coverage.version){
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for (let range of coverage.rangeRecords){
                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                }
                break;
        }
        return -1;
    }
    match(sequenceIndex, sequence, fn, matched) {
        let pos = this.glyphIterator.index;
        let glyph = this.glyphIterator.increment(sequenceIndex);
        let idx = 0;
        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
            if (matched) matched.push(this.glyphIterator.index);
            idx++;
            glyph = this.glyphIterator.next();
        }
        this.glyphIterator.index = pos;
        if (idx < sequence.length) return false;
        return matched || true;
    }
    sequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>component === glyph.id);
    }
    sequenceMatchIndices(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>{
            // If the current feature doesn't apply to this glyph,
            if (!(this.currentFeature in glyph.features)) return false;
            return component === glyph.id;
        }, []);
    }
    coverageSequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (coverage, glyph)=>this.coverageIndex(coverage, glyph.id) >= 0);
    }
    getClassID(glyph, classDef) {
        switch(classDef.version){
            case 1:
                let i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                break;
            case 2:
                for (let range of classDef.classRangeRecord){
                    if (range.start <= glyph && glyph <= range.end) return range.class;
                }
                break;
        }
        return 0;
    }
    classSequenceMatches(sequenceIndex, sequence, classDef) {
        return this.match(sequenceIndex, sequence, (classID, glyph)=>classID === this.getClassID(glyph.id, classDef));
    }
    applyContext(table) {
        let index, set;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                set = table.ruleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) return false;
                set = table.classSet[index];
                for (let rule of set){
                    if (this.classSequenceMatches(1, rule.classes, table.classDef)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    applyChainingContext(table) {
        let index;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                let set = table.chainRuleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                let rules = table.chainClassSet[index];
                if (!rules) return false;
                for (let rule of rules){
                    if (this.classSequenceMatches(-rule.backtrack.length, rule.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, rule.input, table.inputClassDef) && this.classSequenceMatches(1 + rule.input.length, rule.lookahead, table.lookaheadClassDef)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    constructor(font, table){
        this.font = font;
        this.table = table;
        this.script = null;
        this.scriptTag = null;
        this.language = null;
        this.languageTag = null;
        this.features = {};
        this.lookups = {};
        // Setup variation substitutions
        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
        // initialize to default script + language
        this.selectScript();
        // current context (set by applyFeatures)
        this.glyphs = [];
        this.positions = []; // only used by GPOS
        this.ligatureID = 1;
        this.currentFeature = null;
    }
}
class $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039 {
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
        this.substituted = true;
        let GDEF = this._font.GDEF;
        if (GDEF && GDEF.glyphClassDef) {
            // TODO: clean this up
            let classID = $f7a6899246d76dab$var$$7b226e6bbeadedeb$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.glyphClassDef);
            this.isBase = classID === 1;
            this.isLigature = classID === 2;
            this.isMark = classID === 3;
            this.markAttachmentType = GDEF.markAttachClassDef ? $f7a6899246d76dab$var$$7b226e6bbeadedeb$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
        } else {
            this.isMark = this.codePoints.length > 0 && this.codePoints.every($k9oO0.isMark);
            this.isBase = !this.isMark;
            this.isLigature = this.codePoints.length > 1;
            this.markAttachmentType = 0;
        }
    }
    copy() {
        return new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(this._font, this.id, this.codePoints, this.features);
    }
    constructor(font, id, codePoints = [], features){
        this._font = font;
        this.codePoints = codePoints;
        this.id = id;
        this.features = {};
        if (Array.isArray(features)) for(let i = 0; i < features.length; i++){
            let feature = features[i];
            this.features[feature] = true;
        }
        else if (typeof features === 'object') Object.assign(this.features, features);
        this.ligatureID = null;
        this.ligatureComponent = null;
        this.isLigated = false;
        this.cursiveAttachment = null;
        this.markAttachment = null;
        this.shaperInfo = null;
        this.substituted = false;
        this.isMultiplied = false;
    }
}
class $f7a6899246d76dab$var$$fa1d9fd80dd7279e$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            'ljmo',
            'vjmo',
            'tjmo'
        ], false);
    }
    static assignFeatures(plan, glyphs) {
        let state = 0;
        let i = 0;
        while(i < glyphs.length){
            let action;
            let glyph = glyphs[i];
            let code = glyph.codePoints[0];
            let type = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getType(code);
            [action, state] = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$STATE_TABLE[state][type];
            switch(action){
                case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE:
                    // Decompose the composed syllable if it is not supported by the font.
                    if (!plan.font.hasGlyphForCodePoint(code)) i = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$decompose(glyphs, i, plan.font);
                    break;
                case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$COMPOSE:
                    // Found a decomposed syllable. Try to compose if supported by the font.
                    i = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$compose(glyphs, i, plan.font);
                    break;
                case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$TONE_MARK:
                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                    $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$reorderToneMark(glyphs, i, plan.font);
                    break;
                case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$INVALID:
                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                    i = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$insertDottedCircle(glyphs, i, plan.font);
                    break;
            }
            i++;
        }
    }
}
(0, $4Bw9T._)($f7a6899246d76dab$var$$fa1d9fd80dd7279e$export$2e2bcd8739ae039, "zeroMarkWidths", 'NONE');
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_BASE = 0xac00;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_END = 0xd7a4;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_COUNT = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_END - $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_BASE + 1;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_BASE = 0x1100; // lead
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_BASE = 0x1161; // vowel
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE = 0x11a7; // trail
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_COUNT = 19;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_COUNT = 21;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_COUNT = 28;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_END = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_BASE + $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_COUNT - 1;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_END = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_BASE + $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_COUNT - 1;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_END = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE + $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_COUNT - 1;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DOTTED_CIRCLE = 0x25cc;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isL = (code)=>0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isV = (code)=>0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isT = (code)=>0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isTone = (code)=>0x302e <= code && code <= 0x302f;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isLVT = (code)=>$f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_BASE <= code && code <= $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_END;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isLV = (code)=>code - $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_BASE < $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_COUNT && (code - $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_BASE) % $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_COUNT === 0;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isCombiningL = (code)=>$f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_BASE <= code && code <= $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_END;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isCombiningV = (code)=>$f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_BASE <= code && code <= $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_END;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isCombiningT = (code)=>$f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE + 1 && 1 <= code && code <= $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_END;
// Character categories
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$X = 0; // Other character
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L = 1; // Leading consonant
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V = 2; // Medial vowel
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T = 3; // Trailing consonant
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LV = 4; // Composed <LV> syllable
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LVT = 5; // Composed <LVT> syllable
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$M = 6; // Tone mark
// This function classifies a character using the above categories.
function $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getType(code) {
    if ($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isL(code)) return $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L;
    if ($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isV(code)) return $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V;
    if ($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isT(code)) return $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T;
    if ($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isLV(code)) return $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LV;
    if ($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isLVT(code)) return $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LVT;
    if ($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isTone(code)) return $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$M;
    return $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$X;
}
// State machine actions
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION = 0;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE = 1;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$COMPOSE = 2;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$TONE_MARK = 4;
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$INVALID = 5;
// Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
const $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$STATE_TABLE = [
    //       X                 L                 V                T                  LV                LVT               M
    // State 0: start state
    [
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$INVALID,
            0
        ]
    ],
    // State 1: <L>
    [
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$COMPOSE,
            2
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$INVALID,
            0
        ]
    ],
    // State 2: <L,V> or <LV>
    [
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$COMPOSE,
            3
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$TONE_MARK,
            0
        ]
    ],
    // State 3: <L,V,T> or <LVT>
    [
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$TONE_MARK,
            0
        ]
    ]
];
function $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getGlyph(font, code, features) {
    return new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(font, font.glyphForCodePoint(code).id, [
        code
    ], features);
}
function $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$decompose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyph.codePoints[0];
    let s = code - $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_BASE;
    let t = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE + s % $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_COUNT;
    s = s / $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_COUNT | 0;
    let l = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_BASE + s / $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_COUNT | 0;
    let v = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_BASE + s % $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_COUNT;
    // Don't decompose if all of the components are not available
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE && !font.hasGlyphForCodePoint(t)) return i;
    // Replace the current glyph with decomposed L, V, and T glyphs,
    // and apply the proper OpenType features to each component.
    let ljmo = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    let vjmo = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    let insert = [
        ljmo,
        vjmo
    ];
    if (t > $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE) {
        let tjmo = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice(i, 1, ...insert);
    return i + insert.length - 1;
}
function $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$compose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    let type = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getType(code);
    let prev = glyphs[i - 1].codePoints[0];
    let prevType = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getType(prev);
    // Figure out what type of syllable we're dealing with
    let lv, ljmo, vjmo, tjmo;
    if (prevType === $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LV && type === $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T) {
        // <LV,T>
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V) {
            // <L,V>
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            // <L,V,T>
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        let l = ljmo.codePoints[0];
        let v = vjmo.codePoints[0];
        // Make sure L and V are combining characters
        if ($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isCombiningL(l) && $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isCombiningV(v)) lv = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$HANGUL_BASE + ((l - $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$L_BASE) * $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_COUNT + (v - $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V_BASE)) * $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_COUNT;
    }
    let t = tjmo && tjmo.codePoints[0] || $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE;
    if (lv != null && (t === $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE || $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$isCombiningT(t))) {
        let s = lv + (t - $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T_BASE);
        // Replace with a composed glyph if supported by the font,
        // otherwise apply the proper OpenType features to each component.
        if (font.hasGlyphForCodePoint(s)) {
            let del = prevType === $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V ? 3 : 2;
            glyphs.splice(i - del + 1, del, $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    }
    // Didn't compose (either a non-combining component or unsupported by font).
    if (ljmo) ljmo.features.ljmo = true;
    if (vjmo) vjmo.features.vjmo = true;
    if (tjmo) tjmo.features.tjmo = true;
    if (prevType === $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LV) {
        // Sequence was originally <L,V>, which got combined earlier.
        // Either the T was non-combining, or the LVT glyph wasn't supported.
        // Decompose the glyph again and apply OT features.
        $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getLength(code) {
    switch($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getType(code)){
        case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LV:
        case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$LVT:
            return 1;
        case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$V:
            return 2;
        case $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$T:
            return 3;
    }
}
function $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$reorderToneMark(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    // Move tone mark to the beginning of the previous syllable, unless it is zero width
    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
    let prev = glyphs[i - 1].codePoints[0];
    let len = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$insertDottedCircle(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint($f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DOTTED_CIRCLE)) {
        let dottedCircle = $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$getGlyph(font, $f7a6899246d76dab$var$$fa1d9fd80dd7279e$var$DOTTED_CIRCLE, glyph.features);
        // If the tone mark is zero width, insert the dotted circle before, otherwise after
        let idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
var $f7a6899246d76dab$var$$d22b56f2cf15e5ba$exports = {};
$f7a6899246d76dab$var$$d22b56f2cf15e5ba$exports = JSON.parse("{\"stateTable\":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],\"accepting\":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],\"tags\":[[],[\"broken_cluster\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"symbol_cluster\"],[],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"standalone_cluster\"]]}");
var $f7a6899246d76dab$var$$79781f8c452881c2$exports = {};
$f7a6899246d76dab$var$$79781f8c452881c2$exports = JSON.parse("{\"categories\":[\"O\",\"IND\",\"S\",\"GB\",\"B\",\"FM\",\"CGJ\",\"VMAbv\",\"VMPst\",\"VAbv\",\"VPst\",\"CMBlw\",\"VPre\",\"VBlw\",\"H\",\"VMBlw\",\"CMAbv\",\"MBlw\",\"CS\",\"R\",\"SUB\",\"MPst\",\"MPre\",\"FAbv\",\"FPst\",\"FBlw\",\"null\",\"SMAbv\",\"SMBlw\",\"VMPre\",\"ZWNJ\",\"ZWJ\",\"WJ\",\"M\",\"VS\",\"N\",\"HN\",\"MAbv\"],\"decompositions\":{\"2507\":[2503,2494],\"2508\":[2503,2519],\"2888\":[2887,2902],\"2891\":[2887,2878],\"2892\":[2887,2903],\"3018\":[3014,3006],\"3019\":[3015,3006],\"3020\":[3014,3031],\"3144\":[3142,3158],\"3264\":[3263,3285],\"3271\":[3270,3285],\"3272\":[3270,3286],\"3274\":[3270,3266],\"3275\":[3270,3266,3285],\"3402\":[3398,3390],\"3403\":[3399,3390],\"3404\":[3398,3415],\"3546\":[3545,3530],\"3548\":[3545,3535],\"3549\":[3545,3535,3530],\"3550\":[3545,3551],\"3635\":[3661,3634],\"3763\":[3789,3762],\"3955\":[3953,3954],\"3957\":[3953,3956],\"3958\":[4018,3968],\"3959\":[4018,3953,3968],\"3960\":[4019,3968],\"3961\":[4019,3953,3968],\"3969\":[3953,3968],\"6971\":[6970,6965],\"6973\":[6972,6965],\"6976\":[6974,6965],\"6977\":[6975,6965],\"6979\":[6978,6965],\"69934\":[69937,69927],\"69935\":[69938,69927],\"70475\":[70471,70462],\"70476\":[70471,70487],\"70843\":[70841,70842],\"70844\":[70841,70832],\"70846\":[70841,70845],\"71098\":[71096,71087],\"71099\":[71097,71087]},\"stateTable\":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],\"accepting\":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],\"tags\":[[],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"virama_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"number_joiner_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"numeral_cluster\"]]}");
// Cateories used in the OpenType spec:
// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
const $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c = {
    X: 1,
    C: 2,
    V: 4,
    N: 8,
    H: 16,
    ZWNJ: 32,
    ZWJ: 64,
    M: 128,
    SM: 256,
    VD: 512,
    A: 1024,
    Placeholder: 2048,
    Dotted_Circle: 4096,
    RS: 8192,
    Coeng: 16384,
    Repha: 32768,
    Ra: 65536,
    CM: 131072,
    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
};
const $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0 = {
    Start: 1,
    Ra_To_Become_Reph: 2,
    Pre_M: 4,
    Pre_C: 8,
    Base_C: 16,
    After_Main: 32,
    Above_C: 64,
    Before_Sub: 128,
    Below_C: 256,
    After_Sub: 512,
    Before_Post: 1024,
    Post_C: 2048,
    After_Post: 4096,
    Final_C: 8192,
    SMVD: 16384,
    End: 32768
};
const $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$8519deaa7de2b07 = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.C | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Ra | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.CM | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.V | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Placeholder | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Dotted_Circle;
const $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$bbcd928767338e0d = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWNJ;
const $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$ca9599b2a300afc = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.H | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Coeng;
const $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$e99d119da76a0fc5 = {
    Default: {
        hasOldSpec: false,
        virama: 0,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Devanagari: {
        hasOldSpec: true,
        virama: 0x094D,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Bengali: {
        hasOldSpec: true,
        virama: 0x09CD,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gurmukhi: {
        hasOldSpec: true,
        virama: 0x0A4D,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gujarati: {
        hasOldSpec: true,
        virama: 0x0ACD,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Oriya: {
        hasOldSpec: true,
        virama: 0x0B4D,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Tamil: {
        hasOldSpec: true,
        virama: 0x0BCD,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Telugu: {
        hasOldSpec: true,
        virama: 0x0C4D,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: 'Explicit',
        blwfMode: 'Post_Only'
    },
    Kannada: {
        hasOldSpec: true,
        virama: 0x0CCD,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Post_Only'
    },
    Malayalam: {
        hasOldSpec: true,
        virama: 0x0D4D,
        basePos: 'Last',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: 'Log_Repha',
        blwfMode: 'Pre_And_Post'
    },
    // Handled by UniversalShaper
    // Sinhala: {
    //   hasOldSpec: false,
    //   virama: 0x0DCA,
    //   basePos: 'Last_Sinhala',
    //   rephPos: POSITIONS.After_Main,
    //   rephMode: 'Explicit',
    //   blwfMode: 'Pre_And_Post'
    // },
    Khmer: {
        hasOldSpec: false,
        virama: 0x17D2,
        basePos: 'First',
        rephPos: $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph,
        rephMode: 'Vis_Repha',
        blwfMode: 'Pre_And_Post'
    }
};
const $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$f647c9cfdd77d95a = {
    // Khmer
    0x17BE: [
        0x17C1,
        0x17BE
    ],
    0x17BF: [
        0x17C1,
        0x17BF
    ],
    0x17C0: [
        0x17C1,
        0x17C0
    ],
    0x17C4: [
        0x17C1,
        0x17C4
    ],
    0x17C5: [
        0x17C1,
        0x17C5
    ]
};
const { decompositions: $f7a6899246d76dab$var$$d203e6b9523d0071$var$decompositions } = /*@__PURE__*/ $f7a6899246d76dab$var$$parcel$interopDefault($f7a6899246d76dab$var$$79781f8c452881c2$exports);
const $f7a6899246d76dab$var$$d203e6b9523d0071$var$trie = new ($f7a6899246d76dab$var$$parcel$interopDefault($9daMG))($f7a6899246d76dab$var$$66a5b9fb5318558a$export$94fdf11bafc8de6b("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"));
const $f7a6899246d76dab$var$$d203e6b9523d0071$var$stateMachine = new ($f7a6899246d76dab$var$$parcel$interopDefault($fLo3N))(/*@__PURE__*/ $f7a6899246d76dab$var$$parcel$interopDefault($f7a6899246d76dab$var$$d22b56f2cf15e5ba$exports));
class $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($f7a6899246d76dab$var$$d203e6b9523d0071$var$setupSyllables);
        plan.addStage([
            'locl',
            'ccmp'
        ]);
        plan.addStage($f7a6899246d76dab$var$$d203e6b9523d0071$var$initialReordering);
        plan.addStage('nukt');
        plan.addStage('akhn');
        plan.addStage('rphf', false);
        plan.addStage('rkrf');
        plan.addStage('pref', false);
        plan.addStage('blwf', false);
        plan.addStage('abvf', false);
        plan.addStage('half', false);
        plan.addStage('pstf', false);
        plan.addStage('vatu');
        plan.addStage('cjct');
        plan.addStage('cfar', false);
        plan.addStage($f7a6899246d76dab$var$$d203e6b9523d0071$var$finalReordering);
        plan.addStage({
            local: [
                'init'
            ],
            global: [
                'pres',
                'abvs',
                'blws',
                'psts',
                'haln',
                'dist',
                'abvm',
                'blwm',
                'calt',
                'clig'
            ]
        });
        // Setup the indic config for the selected script
        plan.unicodeScript = $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$ce50e82f12a827a4(plan.script);
        plan.indicConfig = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$e99d119da76a0fc5[plan.unicodeScript] || $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$e99d119da76a0fc5.Default;
        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2';
    // TODO: turn off kern (Khmer) and liga features.
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split matras
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            let d = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$f647c9cfdd77d95a[codepoint] || $f7a6899246d76dab$var$$d203e6b9523d0071$var$decompositions[codepoint];
            if (d) {
                let decomposed = d.map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
(0, $4Bw9T._)($f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039, "zeroMarkWidths", 'NONE');
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$indicCategory(glyph) {
    return $f7a6899246d76dab$var$$d203e6b9523d0071$var$trie.get(glyph.codePoints[0]) >> 8;
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$indicPosition(glyph) {
    return 1 << ($f7a6899246d76dab$var$$d203e6b9523d0071$var$trie.get(glyph.codePoints[0]) & 0xff);
}
class $f7a6899246d76dab$var$$d203e6b9523d0071$var$IndicInfo {
    constructor(category, position, syllableType, syllable){
        this.category = category;
        this.position = position;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    let last = 0;
    for (let [start, end, tags] of $f7a6899246d76dab$var$$d203e6b9523d0071$var$stateMachine.match(glyphs.map($f7a6899246d76dab$var$$d203e6b9523d0071$var$indicCategory))){
        if (start > last) {
            ++syllable;
            for(let i = last; i < start; i++)glyphs[i].shaperInfo = new $f7a6899246d76dab$var$$d203e6b9523d0071$var$IndicInfo($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.X, $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.End, 'non_indic_cluster', syllable);
        }
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $f7a6899246d76dab$var$$d203e6b9523d0071$var$IndicInfo(1 << $f7a6899246d76dab$var$$d203e6b9523d0071$var$indicCategory(glyphs[i]), $f7a6899246d76dab$var$$d203e6b9523d0071$var$indicPosition(glyphs[i]), tags[0], syllable);
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for(let i = last; i < glyphs.length; i++)glyphs[i].shaperInfo = new $f7a6899246d76dab$var$$d203e6b9523d0071$var$IndicInfo($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.X, $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.End, 'non_indic_cluster', syllable);
    }
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyph) {
    return glyph.shaperInfo.category & $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$8519deaa7de2b07;
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyph) {
    return glyph.shaperInfo.category & $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$bbcd928767338e0d;
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$ca9599b2a300afc;
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(glyphs, feature) {
    for (let glyph of glyphs)glyph.features = {
        [feature]: true
    };
    let GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([
        feature
    ], glyphs);
    return glyphs.length === 1;
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$consonantPosition(font, consonant, virama) {
    let glyphs = [
        virama,
        consonant,
        virama
    ];
    if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), 'blwf') || $f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), 'blwf')) return $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C;
    else if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), 'pstf') || $f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), 'pstf')) return $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C;
    else if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), 'pref') || $f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), 'pref')) return $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C;
    return $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$initialReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    let virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        let info = new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(font, virama, [
            indicConfig.virama
        ]);
        for(let i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) glyphs[i].shaperInfo.position = $f7a6899246d76dab$var$$d203e6b9523d0071$var$consonantPosition(font, glyphs[i].copy(), info);
    }
    for(let start = 0, end = $f7a6899246d76dab$var$$d203e6b9523d0071$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $f7a6899246d76dab$var$$d203e6b9523d0071$var$nextSyllable(glyphs, start)){
        let { category: category, syllableType: syllableType } = glyphs[start].shaperInfo;
        if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') continue;
        if (syllableType === 'broken_cluster' && dottedCircle) {
            let g = new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = new $f7a6899246d76dab$var$$d203e6b9523d0071$var$IndicInfo(1 << $f7a6899246d76dab$var$$d203e6b9523d0071$var$indicCategory(g), $f7a6899246d76dab$var$$d203e6b9523d0071$var$indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
            // Insert after possible Repha.
            let i = start;
            while(i < end && glyphs[i].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha)i++;
            glyphs.splice(i++, 0, g);
            end++;
        }
        // 1. Find base consonant:
        //
        // The shaping engine finds the base consonant of the syllable, using the
        // following algorithm: starting from the end of the syllable, move backwards
        // until a consonant is found that does not have a below-base or post-base
        // form (post-base forms have to follow below-base forms), or that is not a
        // pre-base reordering Ra, or arrive at the first consonant. The consonant
        // stopped at will be the base.
        let base = end;
        let limit = start;
        let hasReph = false;
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        if (indicConfig.rephPos !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !$f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ)) {
            // See if it matches the 'rphf' feature.
            let g = [
                glyphs[start].copy(),
                glyphs[start + 1].copy(),
                glyphs[start + 2].copy()
            ];
            if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && $f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(g, 'rphf')) {
                limit += 2;
                while(limit < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[limit]))limit++;
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha) {
            limit++;
            while(limit < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[limit]))limit++;
            base = start;
            hasReph = true;
        }
        switch(indicConfig.basePos){
            case 'Last':
                {
                    // starting from the end of the syllable, move backwards
                    let i = end;
                    let seenBelow = false;
                    do {
                        let info = glyphs[--i].shaperInfo;
                        // until a consonant is found
                        if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyphs[i])) {
                            // that does not have a below-base or post-base form
                            // (post-base forms have to follow below-base forms),
                            if (info.position !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C && (info.position !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C || seenBelow)) {
                                base = i;
                                break;
                            }
                            // or that is not a pre-base reordering Ra,
                            //
                            // IMPLEMENTATION NOTES:
                            //
                            // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                            // by the logic above already.
                            //
                            // or arrive at the first consonant. The consonant stopped at will
                            // be the base.
                            if (info.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C) seenBelow = true;
                            base = i;
                        } else if (start < i && info.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ && glyphs[i - 1].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) break;
                    }while (i > limit);
                    break;
                }
            case 'First':
                // The first consonant is always the base.
                base = start;
                // Mark all subsequent consonants as below.
                for(let i = base + 1; i < end; i++)if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyphs[i])) glyphs[i].shaperInfo.position = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C;
        }
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        //
        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
        if (hasReph && base === start && limit - base <= 2) hasReph = false;
        // 2. Decompose and reorder Matras:
        //
        // Each matra and any syllable modifier sign in the cluster are moved to the
        // appropriate position relative to the consonant(s) in the cluster. The
        // shaping engine decomposes two- or three-part matras into their constituent
        // parts before any repositioning. Matra characters are classified by which
        // consonant in a conjunct they have affinity for and are reordered to the
        // following positions:
        //
        //   o Before first half form in the syllable
        //   o After subjoined consonants
        //   o After post-form consonant
        //   o After main consonant (for above marks)
        //
        // IMPLEMENTATION NOTES:
        //
        // The normalize() routine has already decomposed matras for us, so we don't
        // need to worry about that.
        // 3.  Reorder marks to canonical order:
        //
        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
        // if necessary, so that the nukta is first.
        //
        // IMPLEMENTATION NOTES:
        //
        // We don't need to do this: the normalize() routine already did this for us.
        // Reorder characters
        for(let i = start; i < base; i++){
            let info = glyphs[i].shaperInfo;
            info.position = Math.min($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_C, info.position);
        }
        if (base < end) glyphs[base].shaperInfo.position = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
        // Mark final consonants.  A final consonant is one appearing after a matra,
        // like in Khmer.
        for(let i = base + 1; i < end; i++)if (glyphs[i].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
            for(let j = i + 1; j < end; j++)if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyphs[j])) {
                glyphs[j].shaperInfo.position = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Final_C;
                break;
            }
            break;
        }
        // Handle beginning Ra
        if (hasReph) glyphs[start].shaperInfo.position = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph;
        // For old-style Indic script tags, move the first post-base Halant after
        // last consonant.
        //
        // Reports suggest that in some scripts Uniscribe does this only if there
        // is *not* a Halant after last consonant already (eg. Kannada), while it
        // does it unconditionally in other scripts (eg. Malayalam).  We don't
        // currently know about other scripts, so we single out Malayalam for now.
        //
        // Kannada test case:
        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
        // With some versions of Lohit Kannada.
        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
        //
        // Malayalam test case:
        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
        if (plan.isOldSpec) {
            let disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
            for(let i = base + 1; i < end; i++)if (glyphs[i].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) {
                let j;
                for(j = end - 1; j > i; j--){
                    if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyphs[j]) || disallowDoubleHalants && glyphs[j].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) break;
                }
                if (glyphs[j].shaperInfo.category !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && j > i) {
                    // Move Halant to after last consonant.
                    let t = glyphs[i];
                    glyphs.splice(i, 0, ...glyphs.splice(i + 1, j - i));
                    glyphs[j] = t;
                }
                break;
            }
        }
        // Attach misc marks to previous char to move with them.
        let lastPos = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Start;
        for(let i = start; i < end; i++){
            let info = glyphs[i].shaperInfo;
            if (info.category & ($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$bbcd928767338e0d | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.N | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.RS | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.CM | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$ca9599b2a300afc & info.category)) {
                info.position = lastPos;
                if (info.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && info.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    // Uniscribe doesn't move the Halant with Left Matra.
                    // TEST: U+092B,U+093F,U+094DE
                    // We follow.  This is important for the Sinhala
                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                    // We don't want to move the virama with the left matra.
                    // TEST: U+0D9A,U+0DDA
                    for(let j = i; j > start; j--)if (glyphs[j - 1].shaperInfo.position !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                        info.position = glyphs[j - 1].shaperInfo.position;
                        break;
                    }
                }
            } else if (info.position !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD) lastPos = info.position;
        }
        // For post-base consonants let them own anything before them
        // since the last consonant or matra.
        let last = base;
        for(let i = base + 1; i < end; i++){
            if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyphs[i])) {
                for(let j = last + 1; j < i; j++)if (glyphs[j].shaperInfo.position < $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD) glyphs[j].shaperInfo.position = glyphs[i].shaperInfo.position;
                last = i;
            } else if (glyphs[i].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) last = i;
        }
        let arr = glyphs.slice(start, end);
        arr.sort((a, b)=>a.shaperInfo.position - b.shaperInfo.position);
        glyphs.splice(start, arr.length, ...arr);
        // Find base again
        for(let i = start; i < end; i++)if (glyphs[i].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) {
            base = i;
            break;
        }
        // Setup features now
        // Reph
        for(let i = start; i < end && glyphs[i].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph; i++)glyphs[i].features.rphf = true;
        // Pre-base
        let blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
        for(let i = start; i < base; i++){
            glyphs[i].features.half = true;
            if (blwf) glyphs[i].features.blwf = true;
        }
        // Post-base
        for(let i = base + 1; i < end; i++){
            glyphs[i].features.abvf = true;
            glyphs[i].features.pstf = true;
            glyphs[i].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
            // Old-spec eye-lash Ra needs special handling.  From the
            // spec:
            //
            // "The feature 'below-base form' is applied to consonants
            // having below-base forms and following the base consonant.
            // The exception is vattu, which may appear below half forms
            // as well as below the base glyph. The feature 'below-base
            // form' will be applied to all such occurrences of Ra as well."
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
            // with Sanskrit 2003 font.
            //
            // However, note that Ra,Halant,ZWJ is the correct way to
            // request eyelash form of Ra, so we wouldbn't inhibit it
            // in that sequence.
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
            for(let i = start; i + 1 < base; i++)if (glyphs[i].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Ra && glyphs[i + 1].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && (i + 1 === base || glyphs[i + 2].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ)) {
                glyphs[i].features.blwf = true;
                glyphs[i + 1].features.blwf = true;
            }
        }
        let prefLen = 2;
        if (features.pref && base + prefLen < end) for(let i = base + 1; i + prefLen - 1 < end; i++){
            let g = [
                glyphs[i].copy(),
                glyphs[i + 1].copy()
            ];
            if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$wouldSubstitute(g, 'pref')) {
                for(let j = 0; j < prefLen; j++)glyphs[i++].features.pref = true;
                // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                // Read the feature spec.
                // This allows distinguishing the following cases with MS Khmer fonts:
                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                if (features.cfar) for(; i < end; i++)glyphs[i].features.cfar = true;
                break;
            }
        }
        // Apply ZWJ/ZWNJ effects
        for(let i = start + 1; i < end; i++)if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[i])) {
            let nonJoiner = glyphs[i].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWNJ;
            let j = i;
            do {
                j--;
                // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                // being there, since we don't skip them for the CJCT
                // feature (ie. F_MANUAL_ZWJ)
                // A ZWNJ disables HALF.
                if (nonJoiner) delete glyphs[j].features.half;
            }while (j > start && !$f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyphs[j]));
        }
    }
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$finalReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    for(let start = 0, end = $f7a6899246d76dab$var$$d203e6b9523d0071$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $f7a6899246d76dab$var$$d203e6b9523d0071$var$nextSyllable(glyphs, start)){
        // 4. Final reordering:
        //
        // After the localized forms and basic shaping forms GSUB features have been
        // applied (see below), the shaping engine performs some final glyph
        // reordering before applying all the remaining font features to the entire
        // cluster.
        let tryPref = !!features.pref;
        // Find base again
        let base = start;
        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) {
            if (tryPref && base + 1 < end) {
                for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;
                        while(base < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[base]))base++;
                        glyphs[base].shaperInfo.position = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.BASE_C;
                        tryPref = false;
                    }
                    break;
                }
            }
            // For Malayalam, skip over unformed below- (but NOT post-) forms.
            if (plan.unicodeScript === 'Malayalam') for(let i = base + 1; i < end; i++){
                while(i < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[i]))i++;
                if (i === end || !$f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[i])) break;
                i++; // Skip halant.
                while(i < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[i]))i++;
                if (i < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isConsonant(glyphs[i]) && glyphs[i].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C) {
                    base = i;
                    glyphs[base].shaperInfo.position = $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
                }
            }
            if (start < base && glyphs[base].shaperInfo.position > $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) base--;
            break;
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ) base--;
        if (base < end) while(start < base && glyphs[base].shaperInfo.category & ($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.N | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$ca9599b2a300afc))base--;
        // o Reorder matras:
        //
        // If a pre-base matra character had been reordered before applying basic
        // features, the glyph can be moved closer to the main consonant based on
        // whether half-forms had been formed. Actual position for the matra is
        // defined as “after last standalone halant glyph, after initial matra
        // position and before the main consonant”. If ZWJ or ZWNJ follow this
        // halant, position is moved after it.
        //
        if (start + 1 < end && start < base) {
            // If we lost track of base, alas, position before last thingy.
            let newPos = base === end ? base - 2 : base - 1;
            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                while(newPos > start && !(glyphs[newPos].shaperInfo.category & ($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.M | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$ca9599b2a300afc)))newPos--;
                // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!
                if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    if (newPos + 1 < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[newPos + 1])) newPos++;
                } else newPos = start; // No move.
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                // Now go see if there's actually any matras...
                for(let i = newPos; i > start; i--)if (glyphs[i - 1].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    let oldPos = i - 1;
                    if (oldPos < base && base <= newPos) base--;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(oldPos, 0, ...glyphs.splice(oldPos + 1, newPos - oldPos));
                    glyphs[newPos] = tmp;
                    newPos--;
                }
            }
        }
        // o Reorder reph:
        //
        // Reph’s original position is always at the beginning of the syllable,
        // (i.e. it is not reordered at the character reordering stage). However,
        // it will be reordered according to the basic-forms shaping results.
        // Possible positions for reph, depending on the script, are; after main,
        // before post-base consonant forms, and after post-base consonant forms.
        // Two cases:
        //
        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
        //   we should only move it if the sequence ligated to the repha form.
        //
        // - If repha is encoded separately and in the logical position, we should only
        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
        //   to make it work without the reordering.
        if (start + 1 < end && glyphs[start].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            let newRephPos;
            let rephPos = indicConfig.rephPos;
            let found = false;
            // 1. If reph should be positioned after post-base consonant forms,
            //    proceed to step 5.
            if (rephPos !== $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;
                while(newRephPos < base && !$f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
                // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.
                if (!found && rephPos === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main)newRephPos++;
                    found = newRephPos < end;
                }
                // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).
                if (!found && rephPos === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Sub) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & ($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD)))newRephPos++;
                    found = newRephPos < end;
                }
            }
            //  5. If no consonant is found in steps 3 or 4, move reph to a position
            //     immediately before the first post-base matra, syllable modifier
            //     sign or vedic sign that has a reordering class after the intended
            //     reph position. For example, if the reordering position for reph
            //     is post-main, it will skip above-base matras that also have a
            //     post-main position.
            if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;
                while(newRephPos < base && !$f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
            }
            // 6. Otherwise, reorder reph to the end of the syllable.
            if (!found) {
                newRephPos = end - 1;
                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD)newRephPos--;
                // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                if ($f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    for(let i = base + 1; i < newRephPos; i++)if (glyphs[i].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) newRephPos--;
                }
            }
            let reph = glyphs[start];
            glyphs.splice(start, 0, ...glyphs.splice(start + 1, newRephPos - start));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) base--;
        }
        // o Reorder pre-base reordering consonants:
        //
        // If a pre-base reordering consonant is found, reorder it according to
        // the following rules:
        if (tryPref && base + 1 < end) {
            for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                // 1. Only reorder a glyph produced by substitution during application
                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                //    the feature generally but block it in certain contexts.)
                // Note: We just check that something got substituted.  We don't check that
                // the <pref> feature actually did it...
                //
                // Reorder pref only if it ligated.
                if (glyphs[i].isLigated && !glyphs[i].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    let newPos = base;
                    // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.
                    if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                        while(newPos > start && !(glyphs[newPos - 1].shaperInfo.category & ($f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.M | $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$ca9599b2a300afc)))newPos--;
                        // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                        // split matra, it should be reordered to *before* the left part of such matra.
                        if (newPos > start && glyphs[newPos - 1].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
                            let oldPos = i;
                            for(let j = base + 1; j < oldPos; j++)if (glyphs[j].shaperInfo.category === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
                                newPos--;
                                break;
                            }
                        }
                    }
                    if (newPos > start && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newPos - 1])) {
                        if (newPos < end && $f7a6899246d76dab$var$$d203e6b9523d0071$var$isJoiner(glyphs[newPos])) newPos++;
                    }
                    let oldPos = i;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(newPos + 1, 0, ...glyphs.splice(newPos, oldPos - newPos));
                    glyphs[newPos] = tmp;
                    if (newPos <= base && base < oldPos) base++;
                }
                break;
            }
        }
        // Apply 'init' to the Left Matra if it's a word start.
        if (glyphs[start].shaperInfo.position === $f7a6899246d76dab$var$$79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M && (!start || !/Cf|Mn/.test((0, $k9oO0.getCategory)(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
    }
}
function $f7a6899246d76dab$var$$d203e6b9523d0071$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
const { categories: $f7a6899246d76dab$var$$9b772791ccede8a5$var$categories, decompositions: $f7a6899246d76dab$var$$9b772791ccede8a5$var$decompositions } = /*@__PURE__*/ $f7a6899246d76dab$var$$parcel$interopDefault($f7a6899246d76dab$var$$79781f8c452881c2$exports);
const $f7a6899246d76dab$var$$9b772791ccede8a5$var$trie = new ($f7a6899246d76dab$var$$parcel$interopDefault($9daMG))($f7a6899246d76dab$var$$66a5b9fb5318558a$export$94fdf11bafc8de6b("AAACAAAAAAAQugAAAQUO+vHtnHuMX0UVx2d3u/t7bXe7FlqgvB+mpQhFmhikMRAg0ZQmakMU+cPWBzZisEGNjUpoiIYCEgmGUGOEGqOVNPUZUGNA+QNIBU2KREEFFSMBUYRISMXE+B3vnPzOzp553tcWfif5ZO5jnufMzJ2ZO/eumlDqFLAWnAMuBBvBZnC5uXZeBe4WsA1sBzs8/naCXcL1G8GtYDfYA74NvgfuAfcZHmT+fwEeBb8DTwvxPQWeAavACyZvq8z9VYxXwCGglijVBcvACnA8eCM4E6wHG8BF4BLwbvA+8AHwUbAd7AA7wS5wC9gN7gR7wX5wN7gXPAAeBr8Gvwd/Ac+CF8EhoCaV6oBZsBKcAE4FZ0wWeV8P9zxwoTnfCHczuBxsAdvAx8Gnzf1r4X4B3AxuA1+bHJb9m5PzdVGW/Yjv+xXHyfmxFfd9OH8Q/Ar8Bjw1WZT3GfACeAX8N5CfqSmlZsAKsGqqCH8K3DXgbHCuuXYB3HeAd4HLpgrdarbi+EPgY+CT4HPg8ybMTcb9MtyvghtYut/A+b4pf95+ELgfw08Qx/3gADgInjDl0veehPtX8A/wsrn2KtzxDuogWNoJx38k/BzXKeI8Ee5qcBZYD9aZtDbg+AwT19uMX83F7JizCdcvBZdZ97c6/BMfMWmfzfTm88/95aLj+DDSvApcDXZ04uPfaen3TMHPLvi5BezuFPVtD4t/qUcfe3FvP7gb3Ouwo9T+H+gMy/UIjh8DfwBPm7T08d/M8WMBe1Sh3xEjXo+M2s+IESNGjBgxYsSI1wLrOsM1gRsi/P+TzV3/Zc1jvxgR/j8IM9Et1mEGcJeDFeA4cJq5/ia467uF/w1wzwdvB+80998LdwvYZs63w90Bdnbd6Wp/uzz3R4wYMWJEvZzTMm2Xf8SIEfVQd/v+EsaPt3eL90J3wP2WMJ78Trd4t6+P77Hu37cIxp9/ny6YXqrUJeCR6TA74e/nll81MzxejeMtYA94HBwy91bPYow+O/S3A8d7oIM/gRN7CAP29Iqx/B1ThfuwOecM+vA3NmRjf6Gfm3BtH7v+PI7XDpS6EuwDz4O10+0/f9om1F4ehO4OmHp6EO7jxl56nvhsN/15ut+4Z0b657yYkZ7UJ0jhX0bcr3bn+6P87vekN4762QNzvWHZtL+jcH5srzg/uTf0f3pvfj5i+6tYW7rK9+aefO+tuL4BXAQ2gs3gPeBJc//9OL4CXAWuNvc/A64DN4Jbwe0s7jtxvBfsAz8EPwX3gwPgoJAHPQ9/Atf/bO7p/TTP4fglwS/5/zfujfWH5z0cz4Gj+8X5Sf1ib4m+vwbHZ/fdOtP+z+3LOnPp/QL4vxhsApeCy8BWk/a2ftFmYu22Hf4/Ba4B14Hrwc0sP7fh+Cvg6+Au8F1WthA/8pT7UeTxZ/12njkuXT8UyM9i6iur1EEb6f+yPz/eg0b3v4X7x365fMaW42lPu7PTv6vi8i/G+lWF/cvUk7bLl1r+5/rN5tu3j2qvWTd/qV+4h+AqjDGnBsX59GDo94iBXDa6v6Yjl6vu+h8itJcsZq/ZykHhHg/3tMHhUe9s/Yfuny7YNxTvQ8LYdrER2+/c0GBezhrMv3ZNRv7PmYirh7oOv4W1Y72/cwPOzx8U7X8d2295sfE3MPnbBPfSQbHv9nK4HxTqiK/trI7Yy5mLzvuVg/nX+N7V51A3r+gMy/4J434W7l2dYf5PZWGuNX6uh3uzEPetuLY7sZ20zTETY2oxyBhj3DrnfsidYPeXRGLHpxzX6pbFofGRkFBdGhcgW40L4cYtd9JAElO36q4LEzXHX7VMtZ2BEhJjy9dT25fazOtJxhwsBrHzwfu8w12kMYN9fLhIbp2RxlI59rX1dzjpsKl2Fxt3iu6rbofc9q5+KcRrXVzzDn6/Crvk6p/y1GFgGhs9/6maHjBLgv8/18fTxl1q0bPoW8ywsFTGWaazHosrNn/kP2eeqEroZYLZphsZl7L82eephMIqNT8dyT9JjH1Jpg32ubZvTB/SF665ymSnnaqjUHum+1Qn+NyOtz9f2r6y5OQ51b6hYy0D40r2tYXar30+Y/mbVX6JqY+hMC60XZapoh3S/HdOpT3DYu3rs0lKnquyb277JZvyPlqp+f1zVVK2/dJYNpQGf04uYyh1+PTPqfalZ2tO/xwSu+3bOrDzmWvfcTW/fLmibRx6lkvlcOlc8qsE/y5/rnSk67F1iAu1VT6+4jKt5tufn8e2b+n57JKcckhrsKG1Cd6Wu+Y8tf2l5DenPafqQZ/7xstKLeyr+XnInjSelvRgS9n27JPQM5n6Am7jmLG8VK6m7OvyS2L313XYV2r/tth5LWPfNxhyhI+1Up7HVbe/HMgeZE8brtNQ/7tcyX0cn//H2LTO9kpir5VI6yYp9szJW9W2jI1Tqfl5ic2v1GZ5XaG6RDZbyvxMO/DVh1SdUj5y1vraaHs+2/TYNXvtSRoXk4wrf9w6fEctnFt0zL2y+xFsfSrLza2zOTqMiZv8xOpbn8+xsL5ykdj6VsxNKb/Lvxb7nX8u48y1x6yuMW3V9tNxTlouzXslibVxndjC14xda8g2NIbg5x01XAP2lfeIBFSi/zrQEporTXru8fCueiy1CUnqrhspSM9SzbSS64tep9R1ZsZcOxKsUEUfNZeYtr0vjY5DeXW915hT8/PRV8MxlR1HV4DHZZc9R7dzajgWoXikdLtGr0uEfPigsGS/NvYjSHW87XejoXZehZ74XrcqpQ4d5T5f7Gu8f6g7fQmefoqOqk4/VarQv2o4/VDetPDnhjR2dc3BCBp/9NVw7KGfwStVMf6aZNAajj6224j9HCZbpZa/LvH1gU30i/q5WnUdSNEprxv2eIOwx2pcjjLMsmObo008k0J4u69P3d9QdbspW/dy080Nb8PXqcrmj0vsc7tu6qwD1A5oLYr3U3XWSxqj6/a10nCMkudJMyxvrvbK55jUrqU+Xlr/Iai98jY7mVAml5QNHxq31j2m5TrSdmp6z5p+9kpzQntdQbI1Pafr6I9C60gxrALHGtdF6tyhLTtxeBuW+hhqyzPMX931xl6rJ5f6n5h3blpsW7vKbvdBfL1gpYfjDLrvob1drrRT+mcuMf1OrJSdW/P+RfufdUB+pOtdTzhpL5t0jfKr46P3obQfQdPGt1jS+DEkx4MT2PmEg1j72OthqfZNWX+JuZ4at/2sTAmn5cSIMqZIjk0pnD0+aUI6YS9ekdaspWsp8cWEC62dS66UTkq+ypajyvXSlPz4xhQhm/ns6wpXBVI560jHN9aKkdT46spvWT916rONdHNsGSNtl6Hp8oakTVukpF9n3U3Jx0TNefbp3R4jltVfFfpvQkJpNaH/puyco++qbZPz7sE1L3DFGVovc4XPLUPO3ELyrzLiSpmPhaTJfqeJ+t60PiTh9snNW2656upDQ+Wtyg6ueJquB7HSVPspW9a28lDWJouhb6iyv7XjTfVL67j2vjDpvUfMt1Vl4GvctMaeq/vYcFWXIfV5Ku3XaxK951H6dsWFrhcxa3pU/pz3C1xc71tTcaXjGjtJbYIj7UHm7wxSyx+D/d7SfpfJ3wPpfSQp32tS2dt8V2tD7+Bce3rpPa3eC6Dr8Ulq+K+J3HFvbn312Zv2RdStr9g0pP0P/B04XbP3Q8cIT2dlRF6orkrhY/Rv27FqHfL1DP480ffo/V6V7aTHXLKDbTdXOOrnyG1ScvSv6xqve30lPzdpj36M8Pilb+L5vr0xE3dd30nWIfZ45uSSxK4x+CRmTUK6F/LrSsfnj+aOdYyvpXyMK7/OpHWjlDTsa0rJum5K7Ppnj7F9c+0q0qtr7pQji2X9oMwcVrJfmblwU2V2SV3rEk3YuO46XXf8MfrQz077G2zftyDkj/ZqhcZr9nldkOg5ykAt3GunJbR3NGYsUfWafd3ts853C4dLHppOM6WcfM5C+xSbaC/2HMa1H9v1vXdoXm/LKSVpYh5wqmr/X67SfwHtPc9a97p/k8bt0hpbW0j1Svr2m+7Rd98qIQ1pvSF273dKOjHYNmk6fd8/JX3tWIddblBqoU5p7zrZKnd9TppjVq0DSitWqkwz12b2exb7vwjaRvS/TFd/S+8AYvIo+Suri5TwvvZRdV1IQevQ1/8SA+UeH5eto7n/X1Oe86ptaafl8kPjcF7P7W93eD9d5n+oSvn7fFe7I/G9q1IBfylSR71N6fft94ZU18hOXKR+JqUO8f4+5dvLsmWlMQb/Vov+CUDlpTGUndeQlG3fdZWdRPoPgl3mmDlsLnaey/4X3tVuU+o6L3/Pym+qlLV/jk6rlBRd8394hZ6JdnuqIv2ykOh3pfq96Wkq/E8qu2xl88/tOJ4R3tfmpbGi3c5T859bzqr7MbsN03iI5itUNj5eaEKWqIX/KJCQ/iFWNZMmHXs8ovWk53JzFq5vPul6zDjLV36pX7bzvNzB0YlQOZephWtRS5T7eeSq8030R77/HvC1d7tN83Zt9yltrDdwSR0XxsZd5l+MvvvU1/M9jSnj+Nh6FPJbBld/w6XHXH5MZeXrOfS/65g9RTl1JCa8chzX2RZ9/3lXSh4/VqWfEBNq4b82Ytp6m+9Qqxir1jX+rfPdT1vvsWhM6bPbmON6E1LnPCZW7L0qqXswmtqf0MQelZj4myrzYtzvIYmURlvtqapyx+gzRfd0XPfahVSOquMoG+dibBdl46iyfdbV1qvUW9m8+KTudMvkzZe/pqTJ+pWTflX5zw1fVfox6ZTVc8hvHflOSb+OuG1JsZ0kufXAJf8D"));
const $f7a6899246d76dab$var$$9b772791ccede8a5$var$stateMachine = new ($f7a6899246d76dab$var$$parcel$interopDefault($fLo3N))(/*@__PURE__*/ $f7a6899246d76dab$var$$parcel$interopDefault($f7a6899246d76dab$var$$79781f8c452881c2$exports));
class $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($f7a6899246d76dab$var$$9b772791ccede8a5$var$setupSyllables);
        // Default glyph pre-processing group
        plan.addStage([
            'locl',
            'ccmp',
            'nukt',
            'akhn'
        ]);
        // Reordering group
        plan.addStage($f7a6899246d76dab$var$$9b772791ccede8a5$var$clearSubstitutionFlags);
        plan.addStage([
            'rphf'
        ], false);
        plan.addStage($f7a6899246d76dab$var$$9b772791ccede8a5$var$recordRphf);
        plan.addStage($f7a6899246d76dab$var$$9b772791ccede8a5$var$clearSubstitutionFlags);
        plan.addStage([
            'pref'
        ]);
        plan.addStage($f7a6899246d76dab$var$$9b772791ccede8a5$var$recordPref);
        // Orthographic unit shaping group
        plan.addStage([
            'rkrf',
            'abvf',
            'blwf',
            'half',
            'pstf',
            'vatu',
            'cjct'
        ]);
        plan.addStage($f7a6899246d76dab$var$$9b772791ccede8a5$var$reorder);
        // Topographical features
        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
        // Standard topographic presentation and positional feature application
        plan.addStage([
            'abvs',
            'blws',
            'pres',
            'psts',
            'dist',
            'abvm',
            'blwm'
        ]);
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split vowels
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            if ($f7a6899246d76dab$var$$9b772791ccede8a5$var$decompositions[codepoint]) {
                let decomposed = $f7a6899246d76dab$var$$9b772791ccede8a5$var$decompositions[codepoint].map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
(0, $4Bw9T._)($f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039, "zeroMarkWidths", 'BEFORE_GPOS');
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$useCategory(glyph) {
    return $f7a6899246d76dab$var$$9b772791ccede8a5$var$trie.get(glyph.codePoints[0]);
}
class $f7a6899246d76dab$var$$9b772791ccede8a5$var$USEInfo {
    constructor(category, syllableType, syllable){
        this.category = category;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    for (let [start, end, tags] of $f7a6899246d76dab$var$$9b772791ccede8a5$var$stateMachine.match(glyphs.map($f7a6899246d76dab$var$$9b772791ccede8a5$var$useCategory))){
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $f7a6899246d76dab$var$$9b772791ccede8a5$var$USEInfo($f7a6899246d76dab$var$$9b772791ccede8a5$var$categories[$f7a6899246d76dab$var$$9b772791ccede8a5$var$useCategory(glyphs[i])], tags[0], syllable);
        // Assign rphf feature
        let limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
        for(let i = start; i < start + limit; i++)glyphs[i].features.rphf = true;
    }
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$clearSubstitutionFlags(font, glyphs) {
    for (let glyph of glyphs)glyph.substituted = false;
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$recordRphf(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted && glyph.features.rphf) glyph.shaperInfo.category = 'R';
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$recordPref(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted) glyph.shaperInfo.category = 'VPre';
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$reorder(font, glyphs) {
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    for(let start = 0, end = $f7a6899246d76dab$var$$9b772791ccede8a5$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $f7a6899246d76dab$var$$9b772791ccede8a5$var$nextSyllable(glyphs, start)){
        let i, j;
        let info = glyphs[start].shaperInfo;
        let type = info.syllableType;
        // Only a few syllable types need reordering.
        if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') continue;
        // Insert a dotted circle glyph in broken clusters.
        if (type === 'broken_cluster' && dottedCircle) {
            let g = new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = info;
            // Insert after possible Repha.
            for(i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++);
            glyphs.splice(++i, 0, g);
            end++;
        }
        // Move things forward.
        if (info.category === 'R' && end - start > 1) for(i = start + 1; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($f7a6899246d76dab$var$$9b772791ccede8a5$var$isBase(info) || $f7a6899246d76dab$var$$9b772791ccede8a5$var$isHalant(glyphs[i])) {
                // If we hit a halant, move before it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                if ($f7a6899246d76dab$var$$9b772791ccede8a5$var$isHalant(glyphs[i])) i--;
                glyphs.splice(start, 0, ...glyphs.splice(start + 1, i - start), glyphs[i]);
                break;
            }
        }
        // Move things back.
        for(i = start, j = end; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($f7a6899246d76dab$var$$9b772791ccede8a5$var$isBase(info) || $f7a6899246d76dab$var$$9b772791ccede8a5$var$isHalant(glyphs[i])) // place, and shift things in between backward.
            j = $f7a6899246d76dab$var$$9b772791ccede8a5$var$isHalant(glyphs[i]) ? i + 1 : i;
            else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) glyphs.splice(j, 1, glyphs[i], ...glyphs.splice(j, i - j));
        }
    }
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$isHalant(glyph) {
    return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
}
function $f7a6899246d76dab$var$$9b772791ccede8a5$var$isBase(info) {
    return info.category === 'B' || info.category === 'GB';
}
const $f7a6899246d76dab$var$$fdb4471fc82bc2c2$var$SHAPERS = {
    arab: $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mong: $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    syrc: $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    'nko ': $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    phag: $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mand: $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mani: $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    phlp: $f7a6899246d76dab$var$$17ba6019f27bfcf9$export$2e2bcd8739ae039,
    hang: $f7a6899246d76dab$var$$fa1d9fd80dd7279e$export$2e2bcd8739ae039,
    bng2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    beng: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    dev2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    deva: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    gjr2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    gujr: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    guru: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    gur2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    knda: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    knd2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    mlm2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    mlym: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    ory2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    orya: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    taml: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    tml2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    telu: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    tel2: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    khmr: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    bali: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    batk: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    brah: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    bugi: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    buhd: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    cakm: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    cham: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    dupl: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    egyp: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    gran: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    hano: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    java: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    kthi: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    kali: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    khar: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    khoj: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    sind: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    lepc: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    limb: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    mahj: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    // mand: UniversalShaper, // Mandaic
    // mani: UniversalShaper, // Manichaean
    mtei: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    modi: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    // mong: UniversalShaper, // Mongolian
    // 'nko ': UniversalShaper, // N’Ko
    hmng: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    // phag: UniversalShaper, // Phags-pa
    // phlp: UniversalShaper, // Psalter Pahlavi
    rjng: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    saur: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    shrd: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    sidd: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    sinh: $f7a6899246d76dab$var$$d203e6b9523d0071$export$2e2bcd8739ae039,
    sund: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    sylo: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    tglg: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    tagb: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    tale: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    lana: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    tavt: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    takr: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    tibt: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    tfng: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    tirh: $f7a6899246d76dab$var$$9b772791ccede8a5$export$2e2bcd8739ae039,
    latn: $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039,
    DFLT: $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039 // Default
};
function $f7a6899246d76dab$var$$fdb4471fc82bc2c2$export$7877a478dd30fd3d(script) {
    if (!Array.isArray(script)) script = [
        script
    ];
    for (let s of script){
        let shaper = $f7a6899246d76dab$var$$fdb4471fc82bc2c2$var$SHAPERS[s];
        if (shaper) return shaper;
    }
    return $f7a6899246d76dab$var$$d28fb665ee343afc$export$2e2bcd8739ae039;
}
class $f7a6899246d76dab$var$$86bc1883359e094a$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    let glyph = this.glyphIterator.cur;
                    switch(table.version){
                        case 1:
                            glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                            break;
                        case 2:
                            glyph.id = table.substitute.get(index);
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let sequence = table.sequences.get(index);
                        if (sequence.length === 0) {
                            // If the sequence length is zero, delete the glyph.
                            // The OpenType spec disallows this, but seems like Harfbuzz and Uniscribe allow it.
                            this.glyphs.splice(this.glyphIterator.index, 1);
                            return true;
                        }
                        this.glyphIterator.cur.id = sequence[0];
                        this.glyphIterator.cur.ligatureComponent = 0;
                        let features = this.glyphIterator.cur.features;
                        let curGlyph = this.glyphIterator.cur;
                        let replacement = sequence.slice(1).map((gid, i)=>{
                            let glyph = new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, gid, undefined, features);
                            glyph.shaperInfo = curGlyph.shaperInfo;
                            glyph.isLigated = curGlyph.isLigated;
                            glyph.ligatureComponent = i + 1;
                            glyph.substituted = true;
                            glyph.isMultiplied = true;
                            return glyph;
                        });
                        this.glyphs.splice(this.glyphIterator.index + 1, 0, ...replacement);
                        return true;
                    }
                    return false;
                }
            case 3:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let USER_INDEX = 0; // TODO
                        this.glyphIterator.cur.id = table.alternateSet.get(index)[USER_INDEX];
                        return true;
                    }
                    return false;
                }
            case 4:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    for (let ligature of table.ligatureSets.get(index)){
                        let matched = this.sequenceMatchIndices(1, ligature.components);
                        if (!matched) continue;
                        let curGlyph = this.glyphIterator.cur;
                        // Concatenate all of the characters the new ligature will represent
                        let characters = curGlyph.codePoints.slice();
                        for (let index of matched)characters.push(...this.glyphs[index].codePoints);
                        // Create the replacement ligature glyph
                        let ligatureGlyph = new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, ligature.glyph, characters, curGlyph.features);
                        ligatureGlyph.shaperInfo = curGlyph.shaperInfo;
                        ligatureGlyph.isLigated = true;
                        ligatureGlyph.substituted = true;
                        // From Harfbuzz:
                        // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                        //   the ligature to keep its old ligature id.  This will allow it to attach to
                        //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                        //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                        //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                        //   later, we don't want them to lose their ligature id/component, otherwise
                        //   GPOS will fail to correctly position the mark ligature on top of the
                        //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                        //
                        // - If a ligature is formed of components that some of which are also ligatures
                        //   themselves, and those ligature components had marks attached to *their*
                        //   components, we have to attach the marks to the new ligature component
                        //   positions!  Now *that*'s tricky!  And these marks may be following the
                        //   last component of the whole sequence, so we should loop forward looking
                        //   for them and update them.
                        //
                        //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                        //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                        //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                        //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                        //   the new ligature with a component value of 2.
                        //
                        //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                        let isMarkLigature = curGlyph.isMark;
                        for(let i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                        ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                        let lastLigID = curGlyph.ligatureID;
                        let lastNumComps = curGlyph.codePoints.length;
                        let curComps = lastNumComps;
                        let idx = this.glyphIterator.index + 1;
                        // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                        // This allows GPOS to attach marks to the correct ligature components.
                        for (let matchIndex of matched){
                            // Don't assign new ligature components for mark ligatures (see above)
                            if (isMarkLigature) idx = matchIndex;
                            else while(idx < matchIndex){
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                                this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                                this.glyphs[idx].ligatureComponent = ligatureComponent;
                                idx++;
                            }
                            lastLigID = this.glyphs[idx].ligatureID;
                            lastNumComps = this.glyphs[idx].codePoints.length;
                            curComps += lastNumComps;
                            idx++; // skip base glyph
                        }
                        // Adjust ligature components for any marks following
                        if (lastLigID && !isMarkLigature) for(let i = idx; i < this.glyphs.length; i++){
                            if (this.glyphs[i].ligatureID === lastLigID) {
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[i].ligatureComponent || 1, lastNumComps);
                                this.glyphs[i].ligatureComponent = ligatureComponent;
                            } else break;
                        }
                        // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                        for(let i = matched.length - 1; i >= 0; i--)this.glyphs.splice(matched[i], 1);
                        this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                        return true;
                    }
                    return false;
                }
            case 5:
                return this.applyContext(table);
            case 6:
                return this.applyChainingContext(table);
            case 7:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`GSUB lookupType ${lookupType} is not supported`);
        }
    }
}
class $f7a6899246d76dab$var$$79ea6270f0a90256$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    applyPositionValue(sequenceIndex, value) {
        let position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
        if (value.xPlacement != null) position.xOffset += value.xPlacement;
        if (value.yPlacement != null) position.yOffset += value.yPlacement;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
        }
    // TODO: device tables
    }
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            this.applyPositionValue(0, table.value);
                            break;
                        case 2:
                            this.applyPositionValue(0, table.values.get(index));
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let nextGlyph = this.glyphIterator.peek();
                    if (!nextGlyph) return false;
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            let set = table.pairSets.get(index);
                            for (let pair of set)if (pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, pair.value1);
                                this.applyPositionValue(1, pair.value2);
                                return true;
                            }
                            return false;
                        case 2:
                            let class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                            let class2 = this.getClassID(nextGlyph.id, table.classDef2);
                            if (class1 === -1 || class2 === -1) return false;
                            var pair = table.classRecords.get(class1).get(class2);
                            this.applyPositionValue(0, pair.value1);
                            this.applyPositionValue(1, pair.value2);
                            return true;
                    }
                }
            case 3:
                {
                    let nextIndex = this.glyphIterator.peekIndex();
                    let nextGlyph = this.glyphs[nextIndex];
                    if (!nextGlyph) return false;
                    let curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                    if (!curRecord || !curRecord.exitAnchor) return false;
                    let nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, nextGlyph.id)];
                    if (!nextRecord || !nextRecord.entryAnchor) return false;
                    let entry = this.getAnchor(nextRecord.entryAnchor);
                    let exit = this.getAnchor(curRecord.exitAnchor);
                    let cur = this.positions[this.glyphIterator.index];
                    let next = this.positions[nextIndex];
                    let d;
                    switch(this.direction){
                        case 'ltr':
                            cur.xAdvance = exit.x + cur.xOffset;
                            d = entry.x + next.xOffset;
                            next.xAdvance -= d;
                            next.xOffset -= d;
                            break;
                        case 'rtl':
                            d = exit.x + cur.xOffset;
                            cur.xAdvance -= d;
                            cur.xOffset -= d;
                            next.xAdvance = entry.x + next.xOffset;
                            break;
                    }
                    if (this.glyphIterator.flags.rightToLeft) {
                        this.glyphIterator.cur.cursiveAttachment = nextIndex;
                        cur.yOffset = entry.y - exit.y;
                    } else {
                        nextGlyph.cursiveAttachment = this.glyphIterator.index;
                        cur.yOffset = exit.y - entry.y;
                    }
                    return true;
                }
            case 4:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                    if (baseGlyphIndex < 0) return false;
                    let baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                    if (baseIndex === -1) return false;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = table.baseArray[baseIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 5:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && this.glyphs[baseGlyphIndex].isMark);
                    if (baseGlyphIndex < 0) return false;
                    let ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[baseGlyphIndex].id);
                    if (ligIndex === -1) return false;
                    let ligAttach = table.ligatureArray[ligIndex];
                    let markGlyph = this.glyphIterator.cur;
                    let ligGlyph = this.glyphs[baseGlyphIndex];
                    let compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = ligAttach[compIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 6:
                {
                    let mark1Index = this.coverageIndex(table.mark1Coverage);
                    if (mark1Index === -1) return false;
                    // get the previous mark to attach to
                    let prevIndex = this.glyphIterator.peekIndex(-1);
                    let prev = this.glyphs[prevIndex];
                    if (!prev || !prev.isMark) return false;
                    let cur = this.glyphIterator.cur;
                    // The following logic was borrowed from Harfbuzz
                    let good = false;
                    if (cur.ligatureID === prev.ligatureID) {
                        if (!cur.ligatureID) good = true;
                        else if (cur.ligatureComponent === prev.ligatureComponent) good = true;
                    } else // itself is a ligature, in which case match.
                    if (cur.ligatureID && !cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                    if (!good) return false;
                    let mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                    if (mark2Index === -1) return false;
                    let markRecord = table.mark1Array[mark1Index];
                    let baseAnchor = table.mark2Array[mark2Index][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, prevIndex);
                    return true;
                }
            case 7:
                return this.applyContext(table);
            case 8:
                return this.applyChainingContext(table);
            case 9:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`Unsupported GPOS table: ${lookupType}`);
        }
    }
    applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
        let baseCoords = this.getAnchor(baseAnchor);
        let markCoords = this.getAnchor(markRecord.markAnchor);
        let basePos = this.positions[baseGlyphIndex];
        let markPos = this.positions[this.glyphIterator.index];
        markPos.xOffset = baseCoords.x - markCoords.x;
        markPos.yOffset = baseCoords.y - markCoords.y;
        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
    }
    getAnchor(anchor) {
        // TODO: contour point, device tables
        let x = anchor.xCoordinate;
        let y = anchor.yCoordinate;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
        }
        return {
            x: x,
            y: y
        };
    }
    applyFeatures(userFeatures, glyphs, advances) {
        super.applyFeatures(userFeatures, glyphs, advances);
        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
        this.fixMarkAttachment();
    }
    fixCursiveAttachment(i) {
        let glyph = this.glyphs[i];
        if (glyph.cursiveAttachment != null) {
            let j = glyph.cursiveAttachment;
            glyph.cursiveAttachment = null;
            this.fixCursiveAttachment(j);
            this.positions[i].yOffset += this.positions[j].yOffset;
        }
    }
    fixMarkAttachment() {
        for(let i = 0; i < this.glyphs.length; i++){
            let glyph = this.glyphs[i];
            if (glyph.markAttachment != null) {
                let j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;
                if (this.direction === 'ltr') for(let k = j; k < i; k++){
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                }
                else for(let k = j + 1; k < i + 1; k++){
                    this.positions[i].xOffset += this.positions[k].xAdvance;
                    this.positions[i].yOffset += this.positions[k].yAdvance;
                }
            }
        }
    }
}
class $f7a6899246d76dab$var$$b2f26a32cb9ab2fa$export$2e2bcd8739ae039 {
    setup(glyphRun) {
        // Map glyphs to GlyphInfo objects so data can be passed between
        // GSUB and GPOS without mutating the real (shared) Glyph objects.
        this.glyphInfos = glyphRun.glyphs.map((glyph)=>new $f7a6899246d76dab$var$$f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, glyph.id, [
                ...glyph.codePoints
            ]));
        // Select a script based on what is available in GSUB/GPOS.
        let script = null;
        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        // Choose a shaper based on the script, and setup a shaping plan.
        // This determines which features to apply to which glyphs.
        this.shaper = $f7a6899246d76dab$var$$fdb4471fc82bc2c2$export$7877a478dd30fd3d(script);
        this.plan = new $f7a6899246d76dab$var$$d7e93cca3cf8ce8a$export$2e2bcd8739ae039(this.font, script, glyphRun.direction);
        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);
        // Assign chosen features to output glyph run
        for(let key in this.plan.allFeatures)glyphRun.features[key] = true;
    }
    substitute(glyphRun) {
        if (this.GSUBProcessor) {
            this.plan.process(this.GSUBProcessor, this.glyphInfos);
            // Map glyph infos back to normal Glyph objects
            glyphRun.glyphs = this.glyphInfos.map((glyphInfo)=>this.font.getGlyph(glyphInfo.id, glyphInfo.codePoints));
        }
    }
    position(glyphRun) {
        if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') this.zeroMarkAdvances(glyphRun.positions);
        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
        if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') this.zeroMarkAdvances(glyphRun.positions);
        // Reverse the glyphs and positions if the script is right-to-left
        if (glyphRun.direction === 'rtl') {
            glyphRun.glyphs.reverse();
            glyphRun.positions.reverse();
        }
        return this.GPOSProcessor && this.GPOSProcessor.features;
    }
    zeroMarkAdvances(positions) {
        for(let i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    cleanup() {
        this.glyphInfos = null;
        this.plan = null;
        this.shaper = null;
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.GSUBProcessor) {
            this.GSUBProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GSUBProcessor.features));
        }
        if (this.GPOSProcessor) {
            this.GPOSProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GPOSProcessor.features));
        }
        return features;
    }
    constructor(font){
        this.font = font;
        this.glyphInfos = null;
        this.plan = null;
        this.GSUBProcessor = null;
        this.GPOSProcessor = null;
        this.fallbackPosition = true;
        if (font.GSUB) this.GSUBProcessor = new $f7a6899246d76dab$var$$86bc1883359e094a$export$2e2bcd8739ae039(font, font.GSUB);
        if (font.GPOS) this.GPOSProcessor = new $f7a6899246d76dab$var$$79ea6270f0a90256$export$2e2bcd8739ae039(font, font.GPOS);
    }
}
class $f7a6899246d76dab$var$$9d641258c9d7180d$export$2e2bcd8739ae039 {
    layout(string, features, script, language, direction) {
        // Make the features parameter optional
        if (typeof features === 'string') {
            direction = language;
            language = script;
            script = features;
            features = [];
        }
        // Map string to glyphs if needed
        if (typeof string === 'string') {
            // Attempt to detect the script from the string if not provided.
            if (script == null) script = $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$e5cb25e204fb8450(string);
            var glyphs = this.font.glyphsForString(string);
        } else {
            // Attempt to detect the script from the glyph code points if not provided.
            if (script == null) {
                let codePoints = [];
                for (let glyph of string)codePoints.push(...glyph.codePoints);
                script = $f7a6899246d76dab$var$$e38a1a895f6aeb54$export$16fab0757cfc223d(codePoints);
            }
            var glyphs = string;
        }
        let glyphRun = new $f7a6899246d76dab$var$$b19c79ec7a94fa39$export$2e2bcd8739ae039(glyphs, features, script, language, direction);
        // Return early if there are no glyphs
        if (glyphs.length === 0) {
            glyphRun.positions = [];
            return glyphRun;
        }
        // Setup the advanced layout engine
        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
        // Substitute and position the glyphs
        this.substitute(glyphRun);
        this.position(glyphRun);
        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
        // Let the layout engine clean up any state it might have
        if (this.engine && this.engine.cleanup) this.engine.cleanup();
        return glyphRun;
    }
    substitute(glyphRun) {
        // Call the advanced layout engine to make substitutions
        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
    }
    position(glyphRun) {
        // Get initial glyph positions
        glyphRun.positions = glyphRun.glyphs.map((glyph)=>new $f7a6899246d76dab$var$$9195cf1266c12ea5$export$2e2bcd8739ae039(glyph.advanceWidth));
        let positioned = null;
        // Call the advanced layout engine. Returns the features applied.
        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
        // if there is no GPOS table, use unicode properties to position marks.
        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new $f7a6899246d76dab$var$$a57a26817cd35108$export$2e2bcd8739ae039(this.font);
            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
        }
        // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
            if (!this.kernProcessor) this.kernProcessor = new $f7a6899246d76dab$var$$4646d52c2a559cdb$export$2e2bcd8739ae039(this.font);
            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
            glyphRun.features.kern = true;
        }
    }
    hideDefaultIgnorables(glyphs, positions) {
        let space = this.font.glyphForCodePoint(0x20);
        for(let i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
            glyphs[i] = space;
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    isDefaultIgnorable(ch) {
        // From DerivedCoreProperties.txt in the Unicode database,
        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
        // Harfbuzz and Uniscribe do.
        let plane = ch >> 16;
        if (plane === 0) switch(ch >> 8){
            case 0x00:
                return ch === 0x00AD;
            case 0x03:
                return ch === 0x034F;
            case 0x06:
                return ch === 0x061C;
            case 0x17:
                return 0x17B4 <= ch && ch <= 0x17B5;
            case 0x18:
                return 0x180B <= ch && ch <= 0x180E;
            case 0x20:
                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
            case 0xFE:
                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
            case 0xFF:
                return 0xFFF0 <= ch && ch <= 0xFFF8;
            default:
                return false;
        }
        else switch(plane){
            case 0x01:
                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
            case 0x0E:
                return 0xE0000 <= ch && ch <= 0xE0FFF;
            default:
                return false;
        }
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.engine) features.push(...this.engine.getAvailableFeatures(script, language));
        if (this.font.kern && features.indexOf('kern') === -1) features.push('kern');
        return features;
    }
    stringsForGlyph(gid) {
        let result = new Set;
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
        for (let codePoint of codePoints)result.add(String.fromCodePoint(codePoint));
        if (this.engine && this.engine.stringsForGlyph) for (let string of this.engine.stringsForGlyph(gid))result.add(string);
        return Array.from(result);
    }
    constructor(font){
        this.font = font;
        this.unicodeLayoutEngine = null;
        this.kernProcessor = null;
        // Choose an advanced layout engine. We try the AAT morx table first since more
        // scripts are currently supported because the shaping logic is built into the font.
        if (this.font.morx) this.engine = new $f7a6899246d76dab$var$$860fcbd64bc12fbc$export$2e2bcd8739ae039(this.font);
        else if (this.font.GSUB || this.font.GPOS) this.engine = new $f7a6899246d76dab$var$$b2f26a32cb9ab2fa$export$2e2bcd8739ae039(this.font);
    }
}
const $f7a6899246d76dab$var$$67ee4828d81adb28$var$SVG_COMMANDS = {
    moveTo: 'M',
    lineTo: 'L',
    quadraticCurveTo: 'Q',
    bezierCurveTo: 'C',
    closePath: 'Z'
};
class $f7a6899246d76dab$var$$67ee4828d81adb28$export$2e2bcd8739ae039 {
    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ toFunction() {
        return (ctx)=>{
            this.commands.forEach((c)=>{
                return ctx[c.command].apply(ctx, c.args);
            });
        };
    }
    /**
   * Converts the path to an SVG path data string
   * @return {string}
   */ toSVG() {
        let cmds = this.commands.map((c)=>{
            let args = c.args.map((arg)=>Math.round(arg * 100) / 100);
            return `${$f7a6899246d76dab$var$$67ee4828d81adb28$var$SVG_COMMANDS[c.command]}${args.join(' ')}`;
        });
        return cmds.join('');
    }
    /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */ get cbox() {
        if (!this._cbox) {
            let cbox = new $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
            for (let command of this.commands)for(let i = 0; i < command.args.length; i += 2)cbox.addPoint(command.args[i], command.args[i + 1]);
            this._cbox = Object.freeze(cbox);
        }
        return this._cbox;
    }
    /**
   * Gets the exact bounding box of the path by evaluating curve segments.
   * Slower to compute than the control box, but more accurate.
   * @type {BBox}
   */ get bbox() {
        if (this._bbox) return this._bbox;
        let bbox = new $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        let cx = 0, cy = 0;
        let f = (t)=>Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
        for (let c of this.commands)switch(c.command){
            case 'moveTo':
            case 'lineTo':
                let [x, y] = c.args;
                bbox.addPoint(x, y);
                cx = x;
                cy = y;
                break;
            case 'quadraticCurveTo':
            case 'bezierCurveTo':
                if (c.command === 'quadraticCurveTo') {
                    // http://fontforge.org/bezier.html
                    var [qp1x, qp1y, p3x, p3y] = c.args;
                    var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                    var cp1y = cy + 2 / 3 * (qp1y - cy);
                    var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                    var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                } else var [cp1x, cp1y, cp2x, cp2y, p3x, p3y] = c.args;
                // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                bbox.addPoint(p3x, p3y);
                var p0 = [
                    cx,
                    cy
                ];
                var p1 = [
                    cp1x,
                    cp1y
                ];
                var p2 = [
                    cp2x,
                    cp2y
                ];
                var p3 = [
                    p3x,
                    p3y
                ];
                for(var i = 0; i <= 1; i++){
                    let b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                    let a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                    c = 3 * p1[i] - 3 * p0[i];
                    if (a === 0) {
                        if (b === 0) continue;
                        let t = -c / b;
                        if (0 < t && t < 1) {
                            if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                            else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                        }
                        continue;
                    }
                    let b2ac = Math.pow(b, 2) - 4 * c * a;
                    if (b2ac < 0) continue;
                    let t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t1 && t1 < 1) {
                        if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                    }
                    let t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t2 && t2 < 1) {
                        if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                    }
                }
                cx = p3x;
                cy = p3y;
                break;
        }
        return this._bbox = Object.freeze(bbox);
    }
    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ mapPoints(fn) {
        let path = new $f7a6899246d76dab$var$$67ee4828d81adb28$export$2e2bcd8739ae039;
        for (let c of this.commands){
            let args = [];
            for(let i = 0; i < c.args.length; i += 2){
                let [x, y] = fn(c.args[i], c.args[i + 1]);
                args.push(x, y);
            }
            path[c.command](...args);
        }
        return path;
    }
    /**
   * Transforms the path by the given matrix.
   */ transform(m0, m1, m2, m3, m4, m5) {
        return this.mapPoints((x, y)=>{
            const tx = m0 * x + m2 * y + m4;
            const ty = m1 * x + m3 * y + m5;
            return [
                tx,
                ty
            ];
        });
    }
    /**
   * Translates the path by the given offset.
   */ translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    }
    /**
   * Rotates the path by the given angle (in radians).
   */ rotate(angle) {
        let cos = Math.cos(angle);
        let sin = Math.sin(angle);
        return this.transform(cos, sin, -sin, cos, 0, 0);
    }
    /**
   * Scales the path.
   */ scale(scaleX, scaleY = scaleX) {
        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
    }
    constructor(){
        this.commands = [];
        this._bbox = null;
        this._cbox = null;
    }
}
for (let command of [
    'moveTo',
    'lineTo',
    'quadraticCurveTo',
    'bezierCurveTo',
    'closePath'
])$f7a6899246d76dab$var$$67ee4828d81adb28$export$2e2bcd8739ae039.prototype[command] = function(...args) {
    this._bbox = this._cbox = null;
    this.commands.push({
        command: command,
        args: args
    });
    return this;
};
var $f7a6899246d76dab$var$$85e16e40023cfb0f$export$2e2bcd8739ae039 = [
    '.notdef',
    '.null',
    'nonmarkingreturn',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quotesingle',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'grave',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'Adieresis',
    'Aring',
    'Ccedilla',
    'Eacute',
    'Ntilde',
    'Odieresis',
    'Udieresis',
    'aacute',
    'agrave',
    'acircumflex',
    'adieresis',
    'atilde',
    'aring',
    'ccedilla',
    'eacute',
    'egrave',
    'ecircumflex',
    'edieresis',
    'iacute',
    'igrave',
    'icircumflex',
    'idieresis',
    'ntilde',
    'oacute',
    'ograve',
    'ocircumflex',
    'odieresis',
    'otilde',
    'uacute',
    'ugrave',
    'ucircumflex',
    'udieresis',
    'dagger',
    'degree',
    'cent',
    'sterling',
    'section',
    'bullet',
    'paragraph',
    'germandbls',
    'registered',
    'copyright',
    'trademark',
    'acute',
    'dieresis',
    'notequal',
    'AE',
    'Oslash',
    'infinity',
    'plusminus',
    'lessequal',
    'greaterequal',
    'yen',
    'mu',
    'partialdiff',
    'summation',
    'product',
    'pi',
    'integral',
    'ordfeminine',
    'ordmasculine',
    'Omega',
    'ae',
    'oslash',
    'questiondown',
    'exclamdown',
    'logicalnot',
    'radical',
    'florin',
    'approxequal',
    'Delta',
    'guillemotleft',
    'guillemotright',
    'ellipsis',
    'nonbreakingspace',
    'Agrave',
    'Atilde',
    'Otilde',
    'OE',
    'oe',
    'endash',
    'emdash',
    'quotedblleft',
    'quotedblright',
    'quoteleft',
    'quoteright',
    'divide',
    'lozenge',
    'ydieresis',
    'Ydieresis',
    'fraction',
    'currency',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'daggerdbl',
    'periodcentered',
    'quotesinglbase',
    'quotedblbase',
    'perthousand',
    'Acircumflex',
    'Ecircumflex',
    'Aacute',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Oacute',
    'Ocircumflex',
    'apple',
    'Ograve',
    'Uacute',
    'Ucircumflex',
    'Ugrave',
    'dotlessi',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'Lslash',
    'lslash',
    'Scaron',
    'scaron',
    'Zcaron',
    'zcaron',
    'brokenbar',
    'Eth',
    'eth',
    'Yacute',
    'yacute',
    'Thorn',
    'thorn',
    'minus',
    'multiply',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'onehalf',
    'onequarter',
    'threequarters',
    'franc',
    'Gbreve',
    'gbreve',
    'Idotaccent',
    'Scedilla',
    'scedilla',
    'Cacute',
    'cacute',
    'Ccaron',
    'ccaron',
    'dcroat'
];
class $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getPath() {
        return new $f7a6899246d76dab$var$$67ee4828d81adb28$export$2e2bcd8739ae039();
    }
    _getCBox() {
        return this.path.cbox;
    }
    _getBBox() {
        return this.path.bbox;
    }
    _getTableMetrics(table) {
        if (this.id < table.metrics.length) return table.metrics.get(this.id);
        let metric = table.metrics.get(table.metrics.length - 1);
        let res = {
            advance: metric ? metric.advance : 0,
            bearing: table.bearings.get(this.id - table.metrics.length) || 0
        };
        return res;
    }
    _getMetrics(cbox) {
        if (this._metrics) return this._metrics;
        let { advance: advanceWidth, bearing: leftBearing } = this._getTableMetrics(this._font.hmtx);
        // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
        if (this._font.vmtx) var { advance: advanceHeight, bearing: topBearing } = this._getTableMetrics(this._font.vmtx);
        else {
            let os2;
            if (typeof cbox === 'undefined' || cbox === null) ({ cbox: cbox } = this);
            if ((os2 = this._font['OS/2']) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
            } else {
                let { hhea: hhea } = this._font;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
            }
        }
        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
        return this._metrics = {
            advanceWidth: advanceWidth,
            advanceHeight: advanceHeight,
            leftBearing: leftBearing,
            topBearing: topBearing
        };
    }
    /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */ get cbox() {
        return this._getCBox();
    }
    /**
   * The glyph’s bounding box, i.e. the rectangle that encloses the
   * glyph outline as tightly as possible.
   * @type {BBox}
   */ get bbox() {
        return this._getBBox();
    }
    /**
   * A vector Path object representing the glyph outline.
   * @type {Path}
   */ get path() {
        // Cache the path so we only decode it once
        // Decoding is actually performed by subclasses
        return this._getPath();
    }
    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ getScaledPath(size) {
        let scale = 1 / this._font.unitsPerEm * size;
        return this.path.scale(scale);
    }
    /**
   * The glyph's advance width.
   * @type {number}
   */ get advanceWidth() {
        return this._getMetrics().advanceWidth;
    }
    /**
   * The glyph's advance height.
   * @type {number}
   */ get advanceHeight() {
        return this._getMetrics().advanceHeight;
    }
    get ligatureCaretPositions() {}
    _getName() {
        let { post: post } = this._font;
        if (!post) return null;
        switch(post.version){
            case 1:
                return $f7a6899246d76dab$var$$85e16e40023cfb0f$export$2e2bcd8739ae039[this.id];
            case 2:
                let id = post.glyphNameIndex[this.id];
                if (id < $f7a6899246d76dab$var$$85e16e40023cfb0f$export$2e2bcd8739ae039.length) return $f7a6899246d76dab$var$$85e16e40023cfb0f$export$2e2bcd8739ae039[id];
                return post.names[id - $f7a6899246d76dab$var$$85e16e40023cfb0f$export$2e2bcd8739ae039.length];
            case 2.5:
                return $f7a6899246d76dab$var$$85e16e40023cfb0f$export$2e2bcd8739ae039[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
        }
    }
    /**
   * The glyph's name
   * @type {string}
   */ get name() {
        return this._getName();
    }
    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ render(ctx, size) {
        ctx.save();
        let scale = 1 / this._font.head.unitsPerEm * size;
        ctx.scale(scale, scale);
        let fn = this.path.toFunction();
        fn(ctx);
        ctx.fill();
        ctx.restore();
    }
    constructor(id, codePoints, font){
        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
        this._font = font;
        // TODO: get this info from GDEF if available
        this.isMark = this.codePoints.length > 0 && this.codePoints.every($k9oO0.isMark);
        this.isLigature = this.codePoints.length > 1;
    }
}
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "cbox", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "bbox", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "path", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "advanceWidth", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "advanceHeight", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "name", null);
// The header for both simple and composite glyphs
let $f7a6899246d76dab$var$$f680320fa07ef53d$var$GlyfHeader = new $XqKmt.Struct({
    numberOfContours: $bjBBc.int16,
    xMin: $bjBBc.int16,
    yMin: $bjBBc.int16,
    xMax: $bjBBc.int16,
    yMax: $bjBBc.int16
});
// Flags for simple glyphs
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$ON_CURVE = 1;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$X_SHORT_VECTOR = 2;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$Y_SHORT_VECTOR = 4;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$REPEAT = 8;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$SAME_X = 16;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$SAME_Y = 32;
// Flags for composite glyphs
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$ARG_1_AND_2_ARE_WORDS = 1;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$ARGS_ARE_XY_VALUES = 2;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$ROUND_XY_TO_GRID = 4;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_A_SCALE = 8;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$MORE_COMPONENTS = 32;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_AN_X_AND_Y_SCALE = 64;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_A_TWO_BY_TWO = 128;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_INSTRUCTIONS = 256;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$USE_MY_METRICS = 512;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$OVERLAP_COMPOUND = 1024;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$SCALED_COMPONENT_OFFSET = 2048;
const $f7a6899246d76dab$var$$f680320fa07ef53d$var$UNSCALED_COMPONENT_OFFSET = 4096;
class $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a {
    copy() {
        return new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(this.onCurve, this.endContour, this.x, this.y);
    }
    constructor(onCurve, endContour, x = 0, y = 0){
        this.onCurve = onCurve;
        this.endContour = endContour;
        this.x = x;
        this.y = y;
    }
}
// Represents a component in a composite glyph
class $f7a6899246d76dab$var$$f680320fa07ef53d$var$Component {
    constructor(glyphID, dx, dy){
        this.glyphID = glyphID;
        this.dx = dx;
        this.dy = dy;
        this.pos = 0;
        this.scaleX = this.scaleY = 1;
        this.scale01 = this.scale10 = 0;
    }
}
class $f7a6899246d76dab$var$$f680320fa07ef53d$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039 {
    // Parses just the glyph header and returns the bounding box
    _getCBox(internal) {
        // We need to decode the glyph if variation processing is requested,
        // so it's easier just to recompute the path's cbox after decoding.
        if (this._font._variationProcessor && !internal) return this.path.cbox;
        let stream = this._font._getTableStream('glyf');
        stream.pos += this._font.loca.offsets[this.id];
        let glyph = $f7a6899246d76dab$var$$f680320fa07ef53d$var$GlyfHeader.decode(stream);
        let cbox = new $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
        return Object.freeze(cbox);
    }
    // Parses a single glyph coordinate
    _parseGlyphCoord(stream, prev, short, same) {
        if (short) {
            var val = stream.readUInt8();
            if (!same) val = -val;
            val += prev;
        } else if (same) var val = prev;
        else var val = prev + stream.readInt16BE();
        return val;
    }
    // Decodes the glyph data into points for simple glyphs,
    // or components for composite glyphs
    _decode() {
        let glyfPos = this._font.loca.offsets[this.id];
        let nextPos = this._font.loca.offsets[this.id + 1];
        // Nothing to do if there is no data for this glyph
        if (glyfPos === nextPos) return null;
        let stream = this._font._getTableStream('glyf');
        stream.pos += glyfPos;
        let startPos = stream.pos;
        let glyph = $f7a6899246d76dab$var$$f680320fa07ef53d$var$GlyfHeader.decode(stream);
        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
        return glyph;
    }
    _decodeSimple(glyph, stream) {
        // this is a simple glyph
        glyph.points = [];
        let endPtsOfContours = new $gI9iY.Array($bjBBc.uint16, glyph.numberOfContours).decode(stream);
        glyph.instructions = new $gI9iY.Array($bjBBc.uint8, $bjBBc.uint16).decode(stream);
        let flags = [];
        let numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
        while(flags.length < numCoords){
            var flag = stream.readUInt8();
            flags.push(flag);
            // check for repeat flag
            if (flag & $f7a6899246d76dab$var$$f680320fa07ef53d$var$REPEAT) {
                let count = stream.readUInt8();
                for(let j = 0; j < count; j++)flags.push(flag);
            }
        }
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            let point = new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(!!(flag & $f7a6899246d76dab$var$$f680320fa07ef53d$var$ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
            glyph.points.push(point);
        }
        let px = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & $f7a6899246d76dab$var$$f680320fa07ef53d$var$X_SHORT_VECTOR, flag & $f7a6899246d76dab$var$$f680320fa07ef53d$var$SAME_X);
        }
        let py = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & $f7a6899246d76dab$var$$f680320fa07ef53d$var$Y_SHORT_VECTOR, flag & $f7a6899246d76dab$var$$f680320fa07ef53d$var$SAME_Y);
        }
        if (this._font._variationProcessor) {
            let points = glyph.points.slice();
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.slice(-4);
        }
        return;
    }
    _decodeComposite(glyph, stream, offset = 0) {
        // this is a composite glyph
        glyph.components = [];
        let haveInstructions = false;
        let flags = $f7a6899246d76dab$var$$f680320fa07ef53d$var$MORE_COMPONENTS;
        while(flags & $f7a6899246d76dab$var$$f680320fa07ef53d$var$MORE_COMPONENTS){
            flags = stream.readUInt16BE();
            let gPos = stream.pos - offset;
            let glyphID = stream.readUInt16BE();
            if (!haveInstructions) haveInstructions = (flags & $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_INSTRUCTIONS) !== 0;
            if (flags & $f7a6899246d76dab$var$$f680320fa07ef53d$var$ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
            } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
            }
            var component = new $f7a6899246d76dab$var$$f680320fa07ef53d$var$Component(glyphID, dx, dy);
            component.pos = gPos;
            if (flags & $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_A_SCALE) component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            else if (flags & $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            } else if (flags & $f7a6899246d76dab$var$$f680320fa07ef53d$var$WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            }
            glyph.components.push(component);
        }
        if (this._font._variationProcessor) {
            let points = [];
            for(let j = 0; j < glyph.components.length; j++){
                var component = glyph.components[j];
                points.push(new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(true, true, component.dx, component.dy));
            }
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.splice(-4, 4);
            for(let i = 0; i < points.length; i++){
                let point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
            }
        }
        return haveInstructions;
    }
    _getPhantomPoints(glyph) {
        let cbox = this._getCBox(true);
        if (this._metrics == null) this._metrics = $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039.prototype._getMetrics.call(this, cbox);
        let { advanceWidth: advanceWidth, advanceHeight: advanceHeight, leftBearing: leftBearing, topBearing: topBearing } = this._metrics;
        return [
            new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing, 0),
            new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
            new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing),
            new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing + advanceHeight)
        ];
    }
    // Decodes font data, resolves composite glyphs, and returns an array of contours
    _getContours() {
        let glyph = this._decode();
        if (!glyph) return [];
        let points = [];
        if (glyph.numberOfContours < 0) for (let component of glyph.components){
            let contours = this._font.getGlyph(component.glyphID)._getContours();
            for(let i = 0; i < contours.length; i++){
                let contour = contours[i];
                for(let j = 0; j < contour.length; j++){
                    let point = contour[j];
                    let x = point.x * component.scaleX + point.y * component.scale01 + component.dx;
                    let y = point.y * component.scaleY + point.x * component.scale10 + component.dy;
                    points.push(new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(point.onCurve, point.endContour, x, y));
                }
            }
        }
        else points = glyph.points || [];
        // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
        }
        let contours = [];
        let cur = [];
        for(let k = 0; k < points.length; k++){
            var point = points[k];
            cur.push(point);
            if (point.endContour) {
                contours.push(cur);
                cur = [];
            }
        }
        return contours;
    }
    _getMetrics() {
        if (this._metrics) return this._metrics;
        let cbox = this._getCBox(true);
        super._getMetrics(cbox);
        if (this._font._variationProcessor && !this._font.HVAR) this.path;
        return this._metrics;
    }
    // Converts contours to a Path object that can be rendered
    _getPath() {
        let contours = this._getContours();
        let path = new $f7a6899246d76dab$var$$67ee4828d81adb28$export$2e2bcd8739ae039;
        for(let i = 0; i < contours.length; i++){
            let contour = contours[i];
            let firstPt = contour[0];
            let lastPt = contour[contour.length - 1];
            let start = 0;
            if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
            } else {
                if (lastPt.onCurve) firstPt = lastPt;
                else firstPt = new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                var curvePt = firstPt;
            }
            path.moveTo(firstPt.x, firstPt.y);
            for(let j = start; j < contour.length; j++){
                let pt = contour[j];
                let prevPt = j === 0 ? firstPt : contour[j - 1];
                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                else if (!prevPt.onCurve && !pt.onCurve) {
                    let midX = (prevPt.x + pt.x) / 2;
                    let midY = (prevPt.y + pt.y) / 2;
                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                    var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                    var curvePt = null;
                } else throw new Error("Unknown TTF path state");
            }
            // Connect the first and last points
            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            path.closePath();
        }
        return path;
    }
    constructor(...args){
        super(...args);
        (0, $4Bw9T._)(this, "type", 'TTF');
    }
}
class $f7a6899246d76dab$var$$7ee0705195f3b047$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getName() {
        if (this._font.CFF2) return super._getName();
        return this._font['CFF '].getGlyphName(this.id);
    }
    bias(s) {
        if (s.length < 1240) return 107;
        else if (s.length < 33900) return 1131;
        else return 32768;
    }
    _getPath() {
        let cff = this._font.CFF2 || this._font['CFF '];
        let { stream: stream } = cff;
        let str = cff.topDict.CharStrings[this.id];
        let end = str.offset + str.length;
        stream.pos = str.offset;
        let path = new $f7a6899246d76dab$var$$67ee4828d81adb28$export$2e2bcd8739ae039;
        let stack = [];
        let trans = [];
        let width = null;
        let nStems = 0;
        let x = 0, y = 0;
        let usedGsubrs;
        let usedSubrs;
        let open = false;
        this._usedGsubrs = usedGsubrs = {};
        this._usedSubrs = usedSubrs = {};
        let gsubrs = cff.globalSubrIndex || [];
        let gsubrsBias = this.bias(gsubrs);
        let privateDict = cff.privateDictForGlyph(this.id) || {};
        let subrs = privateDict.Subrs || [];
        let subrsBias = this.bias(subrs);
        let vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
        let vsindex = privateDict.vsindex;
        let variationProcessor = this._font._variationProcessor;
        function checkWidth() {
            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
        }
        function parseStems() {
            if (stack.length % 2 !== 0) checkWidth();
            nStems += stack.length >> 1;
            return stack.length = 0;
        }
        function moveTo(x, y) {
            if (open) path.closePath();
            path.moveTo(x, y);
            open = true;
        }
        let parse = function() {
            while(stream.pos < end){
                let op = stream.readUInt8();
                if (op < 32) {
                    let index, subr, phase;
                    let c1x, c1y, c2x, c2y, c3x, c3y;
                    let c4x, c4y, c5x, c5y, c6x, c6y;
                    let pts;
                    switch(op){
                        case 1:
                        case 3:
                        case 18:
                        case 23:
                            parseStems();
                            break;
                        case 4:
                            if (stack.length > 1) checkWidth();
                            y += stack.shift();
                            moveTo(x, y);
                            break;
                        case 5:
                            while(stack.length >= 2){
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                            }
                            break;
                        case 6:
                        case 7:
                            phase = op === 6;
                            while(stack.length >= 1){
                                if (phase) x += stack.shift();
                                else y += stack.shift();
                                path.lineTo(x, y);
                                phase = !phase;
                            }
                            break;
                        case 8:
                            while(stack.length > 0){
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 10:
                            index = stack.pop() + subrsBias;
                            subr = subrs[index];
                            if (subr) {
                                usedSubrs[index] = true;
                                let p = stream.pos;
                                let e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 11:
                            if (cff.version >= 2) break;
                            return;
                        case 14:
                            if (cff.version >= 2) break;
                            if (stack.length > 0) checkWidth();
                            if (open) {
                                path.closePath();
                                open = false;
                            }
                            break;
                        case 15:
                            if (cff.version < 2) throw new Error('vsindex operator not supported in CFF v1');
                            vsindex = stack.pop();
                            break;
                        case 16:
                            {
                                if (cff.version < 2) throw new Error('blend operator not supported in CFF v1');
                                if (!variationProcessor) throw new Error('blend operator in non-variation font');
                                let blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                                let numBlends = stack.pop();
                                let numOperands = numBlends * blendVector.length;
                                let delta = stack.length - numOperands;
                                let base = delta - numBlends;
                                for(let i = 0; i < numBlends; i++){
                                    let sum = stack[base + i];
                                    for(let j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                                    stack[base + i] = sum;
                                }
                                while(numOperands--)stack.pop();
                                break;
                            }
                        case 19:
                        case 20:
                            parseStems();
                            stream.pos += nStems + 7 >> 3;
                            break;
                        case 21:
                            if (stack.length > 2) checkWidth();
                            x += stack.shift();
                            y += stack.shift();
                            moveTo(x, y);
                            break;
                        case 22:
                            if (stack.length > 1) checkWidth();
                            x += stack.shift();
                            moveTo(x, y);
                            break;
                        case 24:
                            while(stack.length >= 8){
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                            break;
                        case 25:
                            while(stack.length >= 8){
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                            }
                            c1x = x + stack.shift();
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            break;
                        case 26:
                            if (stack.length % 2) x += stack.shift();
                            while(stack.length >= 4){
                                c1x = x;
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x;
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 27:
                            if (stack.length % 2) y += stack.shift();
                            while(stack.length >= 4){
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 28:
                            stack.push(stream.readInt16BE());
                            break;
                        case 29:
                            index = stack.pop() + gsubrsBias;
                            subr = gsubrs[index];
                            if (subr) {
                                usedGsubrs[index] = true;
                                let p = stream.pos;
                                let e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 30:
                        case 31:
                            phase = op === 31;
                            while(stack.length >= 4){
                                if (phase) {
                                    c1x = x + stack.shift();
                                    c1y = y;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    y = c2y + stack.shift();
                                    x = c2x + (stack.length === 1 ? stack.shift() : 0);
                                } else {
                                    c1x = x;
                                    c1y = y + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    x = c2x + stack.shift();
                                    y = c2y + (stack.length === 1 ? stack.shift() : 0);
                                }
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                phase = !phase;
                            }
                            break;
                        case 12:
                            op = stream.readUInt8();
                            switch(op){
                                case 3:
                                    let a = stack.pop();
                                    let b = stack.pop();
                                    stack.push(a && b ? 1 : 0);
                                    break;
                                case 4:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a || b ? 1 : 0);
                                    break;
                                case 5:
                                    a = stack.pop();
                                    stack.push(a ? 0 : 1);
                                    break;
                                case 9:
                                    a = stack.pop();
                                    stack.push(Math.abs(a));
                                    break;
                                case 10:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a + b);
                                    break;
                                case 11:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a - b);
                                    break;
                                case 12:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a / b);
                                    break;
                                case 14:
                                    a = stack.pop();
                                    stack.push(-a);
                                    break;
                                case 15:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a === b ? 1 : 0);
                                    break;
                                case 18:
                                    stack.pop();
                                    break;
                                case 20:
                                    let val = stack.pop();
                                    let idx = stack.pop();
                                    trans[idx] = val;
                                    break;
                                case 21:
                                    idx = stack.pop();
                                    stack.push(trans[idx] || 0);
                                    break;
                                case 22:
                                    let s1 = stack.pop();
                                    let s2 = stack.pop();
                                    let v1 = stack.pop();
                                    let v2 = stack.pop();
                                    stack.push(v1 <= v2 ? s1 : s2);
                                    break;
                                case 23:
                                    stack.push(Math.random());
                                    break;
                                case 24:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a * b);
                                    break;
                                case 26:
                                    a = stack.pop();
                                    stack.push(Math.sqrt(a));
                                    break;
                                case 27:
                                    a = stack.pop();
                                    stack.push(a, a);
                                    break;
                                case 28:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(b, a);
                                    break;
                                case 29:
                                    idx = stack.pop();
                                    if (idx < 0) idx = 0;
                                    else if (idx > stack.length - 1) idx = stack.length - 1;
                                    stack.push(stack[idx]);
                                    break;
                                case 30:
                                    let n = stack.pop();
                                    let j = stack.pop();
                                    if (j >= 0) while(j > 0){
                                        var t = stack[n - 1];
                                        for(let i = n - 2; i >= 0; i--)stack[i + 1] = stack[i];
                                        stack[0] = t;
                                        j--;
                                    }
                                    else while(j < 0){
                                        var t = stack[0];
                                        for(let i = 0; i <= n; i++)stack[i] = stack[i + 1];
                                        stack[n - 1] = t;
                                        j++;
                                    }
                                    break;
                                case 34:
                                    c1x = x + stack.shift();
                                    c1y = y;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    c3x = c2x + stack.shift();
                                    c3y = c2y;
                                    c4x = c3x + stack.shift();
                                    c4y = c3y;
                                    c5x = c4x + stack.shift();
                                    c5y = c4y;
                                    c6x = c5x + stack.shift();
                                    c6y = c5y;
                                    x = c6x;
                                    y = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 35:
                                    pts = [];
                                    for(let i = 0; i <= 5; i++){
                                        x += stack.shift();
                                        y += stack.shift();
                                        pts.push(x, y);
                                    }
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    stack.shift(); // fd
                                    break;
                                case 36:
                                    c1x = x + stack.shift();
                                    c1y = y + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    c3x = c2x + stack.shift();
                                    c3y = c2y;
                                    c4x = c3x + stack.shift();
                                    c4y = c3y;
                                    c5x = c4x + stack.shift();
                                    c5y = c4y + stack.shift();
                                    c6x = c5x + stack.shift();
                                    c6y = c5y;
                                    x = c6x;
                                    y = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 37:
                                    let startx = x;
                                    let starty = y;
                                    pts = [];
                                    for(let i = 0; i <= 4; i++){
                                        x += stack.shift();
                                        y += stack.shift();
                                        pts.push(x, y);
                                    }
                                    if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                        x += stack.shift();
                                        y = starty;
                                    } else {
                                        x = startx;
                                        y += stack.shift();
                                    }
                                    pts.push(x, y);
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    break;
                                default:
                                    throw new Error(`Unknown op: 12 ${op}`);
                            }
                            break;
                        default:
                            throw new Error(`Unknown op: ${op}`);
                    }
                } else if (op < 247) stack.push(op - 139);
                else if (op < 251) {
                    var b1 = stream.readUInt8();
                    stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                    var b1 = stream.readUInt8();
                    stack.push(-(op - 251) * 256 - b1 - 108);
                } else stack.push(stream.readInt32BE() / 65536);
            }
        };
        parse();
        if (open) path.closePath();
        return path;
    }
    constructor(...args){
        super(...args);
        (0, $4Bw9T._)(this, "type", 'CFF');
    }
}
let $f7a6899246d76dab$var$$55855d6d316b015e$var$SBIXImage = new $XqKmt.Struct({
    originX: $bjBBc.uint16,
    originY: $bjBBc.uint16,
    type: new $1X3I0.String(4),
    data: new $hH3hY.Buffer((t)=>t.parent.buflen - t._currentOffset)
});
class $f7a6899246d76dab$var$$55855d6d316b015e$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$f680320fa07ef53d$export$2e2bcd8739ae039 {
    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ getImageForSize(size) {
        for(let i = 0; i < this._font.sbix.imageTables.length; i++){
            var table = this._font.sbix.imageTables[i];
            if (table.ppem >= size) break;
        }
        let offsets = table.imageOffsets;
        let start = offsets[this.id];
        let end = offsets[this.id + 1];
        if (start === end) return null;
        this._font.stream.pos = start;
        return $f7a6899246d76dab$var$$55855d6d316b015e$var$SBIXImage.decode(this._font.stream, {
            buflen: end - start
        });
    }
    render(ctx, size) {
        let img = this.getImageForSize(size);
        if (img != null) {
            let scale = size / this._font.unitsPerEm;
            ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale
            });
        }
        if (this._font.sbix.flags.renderOutlines) super.render(ctx, size);
    }
    constructor(...args){
        super(...args);
        (0, $4Bw9T._)(this, "type", 'SBIX');
    }
}
class $f7a6899246d76dab$var$$42d9dbd2de9ee2d8$var$COLRLayer {
    constructor(glyph, color){
        this.glyph = glyph;
        this.color = color;
    }
}
class $f7a6899246d76dab$var$$42d9dbd2de9ee2d8$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getBBox() {
        let bbox = new $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        for(let i = 0; i < this.layers.length; i++){
            let layer = this.layers[i];
            let b = layer.glyph.bbox;
            bbox.addPoint(b.minX, b.minY);
            bbox.addPoint(b.maxX, b.maxY);
        }
        return bbox;
    }
    /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */ get layers() {
        let cpal = this._font.CPAL;
        let colr = this._font.COLR;
        let low = 0;
        let high = colr.baseGlyphRecord.length - 1;
        while(low <= high){
            let mid = low + high >> 1;
            var rec = colr.baseGlyphRecord[mid];
            if (this.id < rec.gid) high = mid - 1;
            else if (this.id > rec.gid) low = mid + 1;
            else {
                var baseLayer = rec;
                break;
            }
        }
        // if base glyph not found in COLR table,
        // default to normal glyph from glyf or CFF
        if (baseLayer == null) {
            var g = this._font._getBaseGlyph(this.id);
            var color = {
                red: 0,
                green: 0,
                blue: 0,
                alpha: 255
            };
            return [
                new $f7a6899246d76dab$var$$42d9dbd2de9ee2d8$var$COLRLayer(g, color)
            ];
        }
        // otherwise, return an array of all the layers
        let layers = [];
        for(let i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
            var rec = colr.layerRecords[i];
            var color = cpal.colorRecords[rec.paletteIndex];
            var g = this._font._getBaseGlyph(rec.gid);
            layers.push(new $f7a6899246d76dab$var$$42d9dbd2de9ee2d8$var$COLRLayer(g, color));
        }
        return layers;
    }
    render(ctx, size) {
        for (let { glyph: glyph, color: color } of this.layers){
            ctx.fillColor([
                color.red,
                color.green,
                color.blue
            ], color.alpha / 255 * 100);
            glyph.render(ctx, size);
        }
        return;
    }
    constructor(...args){
        super(...args);
        (0, $4Bw9T._)(this, "type", 'COLR');
    }
}
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$TUPLES_SHARE_POINT_NUMBERS = 0x8000;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$TUPLE_COUNT_MASK = 0x0fff;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$EMBEDDED_TUPLE_COORD = 0x8000;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE = 0x4000;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$PRIVATE_POINT_NUMBERS = 0x2000;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$TUPLE_INDEX_MASK = 0x0fff;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$POINTS_ARE_WORDS = 0x80;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK = 0x7f;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$DELTAS_ARE_ZERO = 0x80;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$DELTAS_ARE_WORDS = 0x40;
const $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$DELTA_RUN_COUNT_MASK = 0x3f;
class $f7a6899246d76dab$var$$7586bb9ea67c41d8$export$2e2bcd8739ae039 {
    normalizeCoords(coords) {
        // the default mapping is linear along each axis, in two segments:
        // from the minValue to defaultValue, and from defaultValue to maxValue.
        let normalized = [];
        for(var i = 0; i < this.font.fvar.axis.length; i++){
            let axis = this.font.fvar.axis[i];
            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
        }
        // if there is an avar table, the normalized value is calculated
        // by interpolating between the two nearest mapped values.
        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
            let segment = this.font.avar.segment[i];
            for(let j = 0; j < segment.correspondence.length; j++){
                let pair = segment.correspondence[j];
                if (j >= 1 && normalized[i] < pair.fromCoord) {
                    let prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                }
            }
        }
        return normalized;
    }
    transformPoints(gid, glyphPoints) {
        if (!this.font.fvar || !this.font.gvar) return;
        let { gvar: gvar } = this.font;
        if (gid >= gvar.glyphCount) return;
        let offset = gvar.offsets[gid];
        if (offset === gvar.offsets[gid + 1]) return;
        // Read the gvar data for this glyph
        let { stream: stream } = this.font;
        stream.pos = offset;
        if (stream.pos >= stream.length) return;
        let tupleCount = stream.readUInt16BE();
        let offsetToData = offset + stream.readUInt16BE();
        if (tupleCount & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$TUPLES_SHARE_POINT_NUMBERS) {
            var here = stream.pos;
            stream.pos = offsetToData;
            var sharedPoints = this.decodePoints();
            offsetToData = stream.pos;
            stream.pos = here;
        }
        let origPoints = glyphPoints.map((pt)=>pt.copy());
        tupleCount &= $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$TUPLE_COUNT_MASK;
        for(let i = 0; i < tupleCount; i++){
            let tupleDataSize = stream.readUInt16BE();
            let tupleIndex = stream.readUInt16BE();
            if (tupleIndex & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
            } else {
                if ((tupleIndex & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error('Invalid gvar table');
                var tupleCoords = gvar.globalCoords[tupleIndex & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$TUPLE_INDEX_MASK];
            }
            if (tupleIndex & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE) {
                var startCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)startCoords.push(stream.readInt16BE() / 16384);
                var endCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)endCoords.push(stream.readInt16BE() / 16384);
            }
            // Get the factor at which to apply this tuple
            let factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
            if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
            }
            var here = stream.pos;
            stream.pos = offsetToData;
            if (tupleIndex & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
            else var points = sharedPoints;
            // points.length = 0 means there are deltas for all points
            let nPoints = points.length === 0 ? glyphPoints.length : points.length;
            let xDeltas = this.decodeDeltas(nPoints);
            let yDeltas = this.decodeDeltas(nPoints);
            if (points.length === 0) for(let i = 0; i < glyphPoints.length; i++){
                var point = glyphPoints[i];
                point.x += Math.round(xDeltas[i] * factor);
                point.y += Math.round(yDeltas[i] * factor);
            }
            else {
                let outPoints = origPoints.map((pt)=>pt.copy());
                let hasDelta = glyphPoints.map(()=>false);
                for(let i = 0; i < points.length; i++){
                    let idx = points[i];
                    if (idx < glyphPoints.length) {
                        let point = outPoints[idx];
                        hasDelta[idx] = true;
                        point.x += xDeltas[i] * factor;
                        point.y += yDeltas[i] * factor;
                    }
                }
                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                for(let i = 0; i < glyphPoints.length; i++){
                    let deltaX = outPoints[i].x - origPoints[i].x;
                    let deltaY = outPoints[i].y - origPoints[i].y;
                    glyphPoints[i].x = Math.round(glyphPoints[i].x + deltaX);
                    glyphPoints[i].y = Math.round(glyphPoints[i].y + deltaY);
                }
            }
            offsetToData += tupleDataSize;
            stream.pos = here;
        }
    }
    decodePoints() {
        let stream = this.font.stream;
        let count = stream.readUInt8();
        if (count & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$POINTS_ARE_WORDS) count = (count & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
        let points = new Uint16Array(count);
        let i = 0;
        let point = 0;
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK) + 1;
            let fn = run & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
            for(let j = 0; j < runCount && i < count; j++){
                point += fn.call(stream);
                points[i++] = point;
            }
        }
        return points;
    }
    decodeDeltas(count) {
        let stream = this.font.stream;
        let i = 0;
        let deltas = new Int16Array(count);
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$DELTA_RUN_COUNT_MASK) + 1;
            if (run & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$DELTAS_ARE_ZERO) i += runCount;
            else {
                let fn = run & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                for(let j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
            }
        }
        return deltas;
    }
    tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
        let normalized = this.normalizedCoords;
        let { gvar: gvar } = this.font;
        let factor = 1;
        for(let i = 0; i < gvar.axisCount; i++){
            if (tupleCoords[i] === 0) continue;
            if (normalized[i] === 0) return 0;
            if ((tupleIndex & $f7a6899246d76dab$var$$7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
            } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
            }
        }
        return factor;
    }
    // Interpolates points without delta values.
    // Needed for the Ø and Q glyphs in Skia.
    // Algorithm from Freetype.
    interpolateMissingDeltas(points, inPoints, hasDelta) {
        if (points.length === 0) return;
        let point = 0;
        while(point < points.length){
            let firstPoint = point;
            // find the end point of the contour
            let endPoint = point;
            let pt = points[endPoint];
            while(!pt.endContour)pt = points[++endPoint];
            // find the first point that has a delta
            while(point <= endPoint && !hasDelta[point])point++;
            if (point > endPoint) continue;
            let firstDelta = point;
            let curDelta = point;
            point++;
            while(point <= endPoint){
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                    curDelta = point;
                }
                point++;
            }
            // shift contour if we only have a single delta
            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
            else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
            }
            point = endPoint + 1;
        }
    }
    deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
        if (p1 > p2) return;
        let iterable = [
            'x',
            'y'
        ];
        for(let i = 0; i < iterable.length; i++){
            let k = iterable[i];
            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                var p = ref1;
                ref1 = ref2;
                ref2 = p;
            }
            let in1 = inPoints[ref1][k];
            let in2 = inPoints[ref2][k];
            let out1 = outPoints[ref1][k];
            let out2 = outPoints[ref2][k];
            // If the reference points have the same coordinate but different
            // delta, inferred delta is zero.  Otherwise interpolate.
            if (in1 !== in2 || out1 === out2) {
                let scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                for(let p = p1; p <= p2; p++){
                    let out = inPoints[p][k];
                    if (out <= in1) out += out1 - in1;
                    else if (out >= in2) out += out2 - in2;
                    else out = out1 + (out - in1) * scale;
                    outPoints[p][k] = out;
                }
            }
        }
    }
    deltaShift(p1, p2, ref, inPoints, outPoints) {
        let deltaX = outPoints[ref].x - inPoints[ref].x;
        let deltaY = outPoints[ref].y - inPoints[ref].y;
        if (deltaX === 0 && deltaY === 0) return;
        for(let p = p1; p <= p2; p++)if (p !== ref) {
            outPoints[p].x += deltaX;
            outPoints[p].y += deltaY;
        }
    }
    getAdvanceAdjustment(gid, table) {
        let outerIndex, innerIndex;
        if (table.advanceWidthMapping) {
            let idx = gid;
            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
            let entryFormat = table.advanceWidthMapping.entryFormat;
            ({ outerIndex: outerIndex, innerIndex: innerIndex } = table.advanceWidthMapping.mapData[idx]);
        } else {
            outerIndex = 0;
            innerIndex = gid;
        }
        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
    }
    // See pseudo code from `Font Variations Overview'
    // in the OpenType specification.
    getDelta(itemStore, outerIndex, innerIndex) {
        if (outerIndex >= itemStore.itemVariationData.length) return 0;
        let varData = itemStore.itemVariationData[outerIndex];
        if (innerIndex >= varData.deltaSets.length) return 0;
        let deltaSet = varData.deltaSets[innerIndex];
        let blendVector = this.getBlendVector(itemStore, outerIndex);
        let netAdjustment = 0;
        for(let master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
        return netAdjustment;
    }
    getBlendVector(itemStore, outerIndex) {
        let varData = itemStore.itemVariationData[outerIndex];
        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
        let normalizedCoords = this.normalizedCoords;
        let blendVector = [];
        // outer loop steps through master designs to be blended
        for(let master = 0; master < varData.regionIndexCount; master++){
            let scalar = 1;
            let regionIndex = varData.regionIndexes[master];
            let axes = itemStore.variationRegionList.variationRegions[regionIndex];
            // inner loop steps through axes in this region
            for(let j = 0; j < axes.length; j++){
                let axis = axes[j];
                let axisScalar;
                // compute the scalar contribution of this axis
                // ignore invalid ranges
                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1;
                else if (axis.peakCoord === 0) axisScalar = 1;
                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0;
                else {
                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                }
                // take product of all the axis scalars
                scalar *= axisScalar;
            }
            blendVector[master] = scalar;
        }
        this.blendVectors.set(varData, blendVector);
        return blendVector;
    }
    constructor(font, coords){
        this.font = font;
        this.normalizedCoords = this.normalizeCoords(coords);
        this.blendVectors = new Map;
    }
}
const $f7a6899246d76dab$var$$a8ac370803cb82cf$var$resolved = Promise.resolve();
class $f7a6899246d76dab$var$$a8ac370803cb82cf$export$2e2bcd8739ae039 {
    includeGlyph(glyph) {
        if (typeof glyph === 'object') glyph = glyph.id;
        if (this.mapping[glyph] == null) {
            this.glyphs.push(glyph);
            this.mapping[glyph] = this.glyphs.length - 1;
        }
        return this.mapping[glyph];
    }
    constructor(font){
        this.font = font;
        this.glyphs = [];
        this.mapping = {};
        // always include the missing glyph
        this.includeGlyph(0);
    }
}
// Flags for simple glyphs
const $f7a6899246d76dab$var$$2784eedf0b35a048$var$ON_CURVE = 1;
const $f7a6899246d76dab$var$$2784eedf0b35a048$var$X_SHORT_VECTOR = 2;
const $f7a6899246d76dab$var$$2784eedf0b35a048$var$Y_SHORT_VECTOR = 4;
const $f7a6899246d76dab$var$$2784eedf0b35a048$var$REPEAT = 8;
const $f7a6899246d76dab$var$$2784eedf0b35a048$var$SAME_X = 16;
const $f7a6899246d76dab$var$$2784eedf0b35a048$var$SAME_Y = 32;
class $f7a6899246d76dab$var$$2784eedf0b35a048$var$Point {
    static size(val) {
        return val >= 0 && val <= 255 ? 1 : 2;
    }
    static encode(stream, value) {
        if (value >= 0 && value <= 255) stream.writeUInt8(value);
        else stream.writeInt16BE(value);
    }
}
let $f7a6899246d76dab$var$$2784eedf0b35a048$var$Glyf = new $XqKmt.Struct({
    numberOfContours: $bjBBc.int16,
    xMin: $bjBBc.int16,
    yMin: $bjBBc.int16,
    xMax: $bjBBc.int16,
    yMax: $bjBBc.int16,
    endPtsOfContours: new $gI9iY.Array($bjBBc.uint16, 'numberOfContours'),
    instructions: new $gI9iY.Array($bjBBc.uint8, $bjBBc.uint16),
    flags: new $gI9iY.Array($bjBBc.uint8, 0),
    xPoints: new $gI9iY.Array($f7a6899246d76dab$var$$2784eedf0b35a048$var$Point, 0),
    yPoints: new $gI9iY.Array($f7a6899246d76dab$var$$2784eedf0b35a048$var$Point, 0)
});
class $f7a6899246d76dab$var$$2784eedf0b35a048$export$2e2bcd8739ae039 {
    encodeSimple(path, instructions = []) {
        let endPtsOfContours = [];
        let xPoints = [];
        let yPoints = [];
        let flags = [];
        let same = 0;
        let lastX = 0, lastY = 0, lastFlag = 0;
        let pointCount = 0;
        for(let i = 0; i < path.commands.length; i++){
            let c = path.commands[i];
            for(let j = 0; j < c.args.length; j += 2){
                let x = c.args[j];
                let y = c.args[j + 1];
                let flag = 0;
                // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.
                if (c.command === 'quadraticCurveTo' && j === 2) {
                    let next = path.commands[i + 1];
                    if (next && next.command === 'quadraticCurveTo') {
                        let midX = (lastX + next.args[0]) / 2;
                        let midY = (lastY + next.args[1]) / 2;
                        if (x === midX && y === midY) continue;
                    }
                }
                // All points except control points are on curve.
                if (!(c.command === 'quadraticCurveTo' && j === 0)) flag |= $f7a6899246d76dab$var$$2784eedf0b35a048$var$ON_CURVE;
                flag = this._encodePoint(x, lastX, xPoints, flag, $f7a6899246d76dab$var$$2784eedf0b35a048$var$X_SHORT_VECTOR, $f7a6899246d76dab$var$$2784eedf0b35a048$var$SAME_X);
                flag = this._encodePoint(y, lastY, yPoints, flag, $f7a6899246d76dab$var$$2784eedf0b35a048$var$Y_SHORT_VECTOR, $f7a6899246d76dab$var$$2784eedf0b35a048$var$SAME_Y);
                if (flag === lastFlag && same < 255) {
                    flags[flags.length - 1] |= $f7a6899246d76dab$var$$2784eedf0b35a048$var$REPEAT;
                    same++;
                } else {
                    if (same > 0) {
                        flags.push(same);
                        same = 0;
                    }
                    flags.push(flag);
                    lastFlag = flag;
                }
                lastX = x;
                lastY = y;
                pointCount++;
            }
            if (c.command === 'closePath') endPtsOfContours.push(pointCount - 1);
        }
        // Close the path if the last command didn't already
        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') endPtsOfContours.push(pointCount - 1);
        let bbox = path.bbox;
        let glyf = {
            numberOfContours: endPtsOfContours.length,
            xMin: bbox.minX,
            yMin: bbox.minY,
            xMax: bbox.maxX,
            yMax: bbox.maxY,
            endPtsOfContours: endPtsOfContours,
            instructions: instructions,
            flags: flags,
            xPoints: xPoints,
            yPoints: yPoints
        };
        let size = $f7a6899246d76dab$var$$2784eedf0b35a048$var$Glyf.size(glyf);
        let tail = 4 - size % 4;
        let stream = new $gEOXZ.EncodeStream(size + tail);
        $f7a6899246d76dab$var$$2784eedf0b35a048$var$Glyf.encode(stream, glyf);
        // Align to 4-byte length
        if (tail !== 0) stream.fill(0, tail);
        return stream.buffer;
    }
    _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
        let diff = value - last;
        if (value === last) flag |= sameFlag;
        else {
            if (-255 <= diff && diff <= 255) {
                flag |= shortFlag;
                if (diff < 0) diff = -diff;
                else flag |= sameFlag;
            }
            points.push(diff);
        }
        return flag;
    }
}
class $f7a6899246d76dab$var$$fe042f4b88f46896$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$a8ac370803cb82cf$export$2e2bcd8739ae039 {
    _addGlyph(gid) {
        let glyph = this.font.getGlyph(gid);
        let glyf = glyph._decode();
        // get the offset to the glyph from the loca table
        let curOffset = this.font.loca.offsets[gid];
        let nextOffset = this.font.loca.offsets[gid + 1];
        let stream = this.font._getTableStream('glyf');
        stream.pos += curOffset;
        let buffer = stream.readBuffer(nextOffset - curOffset);
        // if it is a compound glyph, include its components
        if (glyf && glyf.numberOfContours < 0) {
            buffer = new Uint8Array(buffer);
            let view = new DataView(buffer.buffer);
            for (let component of glyf.components){
                gid = this.includeGlyph(component.glyphID);
                view.setUint16(component.pos, gid);
            }
        } else if (glyf && this.font._variationProcessor) buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
        this.glyf.push(buffer);
        this.loca.offsets.push(this.offset);
        this.hmtx.metrics.push({
            advance: glyph.advanceWidth,
            bearing: glyph._getMetrics().leftBearing
        });
        this.offset += buffer.length;
        return this.glyf.length - 1;
    }
    encode() {
        // tables required by PDF spec:
        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
        //
        // additional tables required for standalone fonts:
        //   name, cmap, OS/2, post
        this.glyf = [];
        this.offset = 0;
        this.loca = {
            offsets: [],
            version: this.font.loca.version
        };
        this.hmtx = {
            metrics: [],
            bearings: []
        };
        // include all the glyphs
        // not using a for loop because we need to support adding more
        // glyphs to the array as we go, and CoffeeScript caches the length.
        let i = 0;
        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
        let maxp = $f7a6899246d76dab$var$$parcel$interopDefault($8kDCz)(this.font.maxp);
        maxp.numGlyphs = this.glyf.length;
        this.loca.offsets.push(this.offset);
        let head = $f7a6899246d76dab$var$$parcel$interopDefault($8kDCz)(this.font.head);
        head.indexToLocFormat = this.loca.version;
        let hhea = $f7a6899246d76dab$var$$parcel$interopDefault($8kDCz)(this.font.hhea);
        hhea.numberOfMetrics = this.hmtx.metrics.length;
        // map = []
        // for index in [0...256]
        //     if index < @numGlyphs
        //         map[index] = index
        //     else
        //         map[index] = 0
        //
        // cmapTable =
        //     version: 0
        //     length: 262
        //     language: 0
        //     codeMap: map
        //
        // cmap =
        //     version: 0
        //     numSubtables: 1
        //     tables: [
        //         platformID: 1
        //         encodingID: 0
        //         table: cmapTable
        //     ]
        // TODO: subset prep, cvt, fpgm?
        return $f7a6899246d76dab$var$$df50e1efe10a1247$export$2e2bcd8739ae039.toBuffer({
            tables: {
                head: head,
                hhea: hhea,
                loca: this.loca,
                maxp: maxp,
                'cvt ': this.font['cvt '],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm
            }
        });
    }
    constructor(font){
        super(font);
        this.glyphEncoder = new $f7a6899246d76dab$var$$2784eedf0b35a048$export$2e2bcd8739ae039;
    }
}
class $f7a6899246d76dab$var$$ec40f80c07a4e08a$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$a8ac370803cb82cf$export$2e2bcd8739ae039 {
    subsetCharstrings() {
        this.charstrings = [];
        let gsubrs = {};
        for (let gid of this.glyphs){
            this.charstrings.push(this.cff.getCharString(gid));
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedGsubrs)gsubrs[subr] = true;
        }
        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
    }
    subsetSubrs(subrs, used) {
        let res = [];
        for(let i = 0; i < subrs.length; i++){
            let subr = subrs[i];
            if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
            } else res.push(new Uint8Array([
                11
            ])); // return
        }
        return res;
    }
    subsetFontdict(topDict) {
        topDict.FDArray = [];
        topDict.FDSelect = {
            version: 0,
            fds: []
        };
        let used_fds = {};
        let used_subrs = [];
        let fd_select = {};
        for (let gid of this.glyphs){
            let fd = this.cff.fdForGlyph(gid);
            if (fd == null) continue;
            if (!used_fds[fd]) {
                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                used_subrs.push({});
                fd_select[fd] = topDict.FDArray.length - 1;
            }
            used_fds[fd] = true;
            topDict.FDSelect.fds.push(fd_select[fd]);
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[fd_select[fd]][subr] = true;
        }
        for(let i = 0; i < topDict.FDArray.length; i++){
            let dict = topDict.FDArray[i];
            delete dict.FontName;
            if (dict.Private && dict.Private.Subrs) {
                dict.Private = Object.assign({}, dict.Private);
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
            }
        }
        return;
    }
    createCIDFontdict(topDict) {
        let used_subrs = {};
        for (let gid of this.glyphs){
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[subr] = true;
        }
        let privateDict = Object.assign({}, this.cff.topDict.Private);
        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
        topDict.FDArray = [
            {
                Private: privateDict
            }
        ];
        return topDict.FDSelect = {
            version: 3,
            nRanges: 1,
            ranges: [
                {
                    first: 0,
                    fd: 0
                }
            ],
            sentinel: this.charstrings.length
        };
    }
    addString(string) {
        if (!string) return null;
        if (!this.strings) this.strings = [];
        this.strings.push(string);
        return $f7a6899246d76dab$var$$860d3574d7fa3a51$export$2e2bcd8739ae039.length + this.strings.length - 1;
    }
    encode() {
        this.subsetCharstrings();
        let charset = {
            version: this.charstrings.length > 255 ? 2 : 1,
            ranges: [
                {
                    first: 1,
                    nLeft: this.charstrings.length - 2
                }
            ]
        };
        let topDict = Object.assign({}, this.cff.topDict);
        topDict.Private = null;
        topDict.charset = charset;
        topDict.Encoding = null;
        topDict.CharStrings = this.charstrings;
        for (let key of [
            'version',
            'Notice',
            'Copyright',
            'FullName',
            'FamilyName',
            'Weight',
            'PostScript',
            'BaseFontName',
            'FontName'
        ])topDict[key] = this.addString(this.cff.string(topDict[key]));
        topDict.ROS = [
            this.addString('Adobe'),
            this.addString('Identity'),
            0
        ];
        topDict.CIDCount = this.charstrings.length;
        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
        else this.createCIDFontdict(topDict);
        let top = {
            version: 1,
            hdrSize: this.cff.hdrSize,
            offSize: 4,
            header: this.cff.header,
            nameIndex: [
                this.cff.postscriptName
            ],
            topDictIndex: [
                topDict
            ],
            stringIndex: this.strings,
            globalSubrIndex: this.gsubrs
        };
        return $f7a6899246d76dab$var$$5b547cf9e5da519b$export$2e2bcd8739ae039.toBuffer(top);
    }
    constructor(font){
        super(font);
        this.cff = this.font['CFF '];
        if (!this.cff) throw new Error('Not a CFF Font');
    }
}
class $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let format = $f7a6899246d76dab$var$$66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4));
        return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
    }
    setDefaultLanguage(lang = null) {
        this.defaultLanguage = lang;
    }
    _getTable(table) {
        if (!(table.tag in this._tables)) try {
            this._tables[table.tag] = this._decodeTable(table);
        } catch (e) {
            if ($f7a6899246d76dab$var$$59aa4ed98453e1d4$export$bd5c5d8b8dcafd78) {
                console.error(`Error decoding table ${table.tag}`);
                console.error(e.stack);
            }
        }
        return this._tables[table.tag];
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            return this.stream;
        }
        return null;
    }
    _decodeDirectory() {
        return this.directory = $f7a6899246d76dab$var$$df50e1efe10a1247$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _decodeTable(table) {
        let pos = this.stream.pos;
        let stream = this._getTableStream(table.tag);
        let result = $f7a6899246d76dab$var$$5825c04ce8f7102d$export$2e2bcd8739ae039[table.tag].decode(stream, this, table.length);
        this.stream.pos = pos;
        return result;
    }
    /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ getName(key, lang = this.defaultLanguage || $f7a6899246d76dab$var$$59aa4ed98453e1d4$export$42940898df819940) {
        let record = this.name && this.name.records[key];
        if (record) return record[lang] || record[this.defaultLanguage] || record[$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$42940898df819940] || record['en'] || record[Object.keys(record)[0]] // Seriously, ANY language would be fine
         || null;
        return null;
    }
    /**
   * The unique PostScript name for this font, e.g. "Helvetica-Bold"
   * @type {string}
   */ get postscriptName() {
        return this.getName('postscriptName');
    }
    /**
   * The font's full name, e.g. "Helvetica Bold"
   * @type {string}
   */ get fullName() {
        return this.getName('fullName');
    }
    /**
   * The font's family name, e.g. "Helvetica"
   * @type {string}
   */ get familyName() {
        return this.getName('fontFamily');
    }
    /**
   * The font's sub-family, e.g. "Bold".
   * @type {string}
   */ get subfamilyName() {
        return this.getName('fontSubfamily');
    }
    /**
   * The font's copyright information
   * @type {string}
   */ get copyright() {
        return this.getName('copyright');
    }
    /**
   * The font's version number
   * @type {string}
   */ get version() {
        return this.getName('version');
    }
    /**
   * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
   * @type {number}
   */ get ascent() {
        return this.hhea.ascent;
    }
    /**
   * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
   * @type {number}
   */ get descent() {
        return this.hhea.descent;
    }
    /**
   * The amount of space that should be included between lines
   * @type {number}
   */ get lineGap() {
        return this.hhea.lineGap;
    }
    /**
   * The offset from the normal underline position that should be used
   * @type {number}
   */ get underlinePosition() {
        return this.post.underlinePosition;
    }
    /**
   * The weight of the underline that should be used
   * @type {number}
   */ get underlineThickness() {
        return this.post.underlineThickness;
    }
    /**
   * If this is an italic font, the angle the cursor should be drawn at to match the font design
   * @type {number}
   */ get italicAngle() {
        return this.post.italicAngle;
    }
    /**
   * The height of capital letters above the baseline.
   * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
   * @type {number}
   */ get capHeight() {
        let os2 = this['OS/2'];
        return os2 ? os2.capHeight : this.ascent;
    }
    /**
   * The height of lower case letters in the font.
   * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
   * @type {number}
   */ get xHeight() {
        let os2 = this['OS/2'];
        return os2 ? os2.xHeight : 0;
    }
    /**
   * The number of glyphs in the font.
   * @type {number}
   */ get numGlyphs() {
        return this.maxp.numGlyphs;
    }
    /**
   * The size of the font’s internal coordinate grid
   * @type {number}
   */ get unitsPerEm() {
        return this.head.unitsPerEm;
    }
    /**
   * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
   * @type {BBox}
   */ get bbox() {
        return Object.freeze(new $f7a6899246d76dab$var$$0e2da1c4ce69e8ad$export$2e2bcd8739ae039(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
    }
    get _cmapProcessor() {
        return new $f7a6899246d76dab$var$$0d6e160064c86e50$export$2e2bcd8739ae039(this.cmap);
    }
    /**
   * An array of all of the unicode code points supported by the font.
   * @type {number[]}
   */ get characterSet() {
        return this._cmapProcessor.getCharacterSet();
    }
    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ hasGlyphForCodePoint(codePoint) {
        return !!this._cmapProcessor.lookup(codePoint);
    }
    /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */ glyphForCodePoint(codePoint) {
        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
            codePoint
        ]);
    }
    /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */ glyphsForString(string) {
        let glyphs = [];
        let len = string.length;
        let idx = 0;
        let last = -1;
        let state = -1;
        while(idx <= len){
            let code = 0;
            let nextState = 0;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    let next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                }
                // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                last,
                code
            ]));
            else if (state === 0 && nextState === 0) glyphs.push(this.glyphForCodePoint(last));
            last = code;
            state = nextState;
        }
        return glyphs;
    }
    get _layoutEngine() {
        return new $f7a6899246d76dab$var$$9d641258c9d7180d$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ layout(string, userFeatures, script, language, direction) {
        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
    }
    /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */ stringsForGlyph(gid) {
        return this._layoutEngine.stringsForGlyph(gid);
    }
    /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */ get availableFeatures() {
        return this._layoutEngine.getAvailableFeatures();
    }
    getAvailableFeatures(script, language) {
        return this._layoutEngine.getAvailableFeatures(script, language);
    }
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf) this._glyphs[glyph] = new $f7a6899246d76dab$var$$f680320fa07ef53d$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) this._glyphs[glyph] = new $f7a6899246d76dab$var$$7ee0705195f3b047$export$2e2bcd8739ae039(glyph, characters, this);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */ getGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.sbix) this._glyphs[glyph] = new $f7a6899246d76dab$var$$55855d6d316b015e$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new $f7a6899246d76dab$var$$42d9dbd2de9ee2d8$export$2e2bcd8739ae039(glyph, characters, this);
            else this._getBaseGlyph(glyph, characters);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a Subset for this font.
   * @return {Subset}
   */ createSubset() {
        if (this.directory.tables['CFF ']) return new $f7a6899246d76dab$var$$ec40f80c07a4e08a$export$2e2bcd8739ae039(this);
        return new $f7a6899246d76dab$var$$fe042f4b88f46896$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */ get variationAxes() {
        let res = {};
        if (!this.fvar) return res;
        for (let axis of this.fvar.axis)res[axis.axisTag.trim()] = {
            name: axis.name.en,
            min: axis.minValue,
            default: axis.defaultValue,
            max: axis.maxValue
        };
        return res;
    }
    /**
   * Returns an object describing the named variation instances
   * that the font designer has specified. Keys are variation names
   * and values are the variation settings for this instance.
   *
   * @type {object}
   */ get namedVariations() {
        let res = {};
        if (!this.fvar) return res;
        for (let instance of this.fvar.instance){
            let settings = {};
            for(let i = 0; i < this.fvar.axis.length; i++){
                let axis = this.fvar.axis[i];
                settings[axis.axisTag.trim()] = instance.coord[i];
            }
            res[instance.name.en] = settings;
        }
        return res;
    }
    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ getVariation(settings) {
        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
        if (typeof settings === 'string') settings = this.namedVariations[settings];
        if (typeof settings !== 'object') throw new Error('Variation settings must be either a variation name or settings object.');
        // normalize the coordinates
        let coords = this.fvar.axis.map((axis, i)=>{
            let axisTag = axis.axisTag.trim();
            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
            else return axis.defaultValue;
        });
        let stream = new $i4JPn.DecodeStream(this.stream.buffer);
        stream.pos = this._directoryPos;
        let font = new $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream, coords);
        font._tables = this._tables;
        return font;
    }
    get _variationProcessor() {
        if (!this.fvar) return null;
        let variationCoords = this.variationCoords;
        // Ignore if no variation coords and not CFF2
        if (!variationCoords && !this.CFF2) return null;
        if (!variationCoords) variationCoords = this.fvar.axis.map((axis)=>axis.defaultValue);
        return new $f7a6899246d76dab$var$$7586bb9ea67c41d8$export$2e2bcd8739ae039(this, variationCoords);
    }
    // Standardized format plugin API
    getFont(name) {
        return this.getVariation(name);
    }
    constructor(stream, variationCoords = null){
        (0, $4Bw9T._)(this, "type", 'TTF');
        this.defaultLanguage = null;
        this.stream = stream;
        this.variationCoords = variationCoords;
        this._directoryPos = this.stream.pos;
        this._tables = {};
        this._glyphs = {};
        this._decodeDirectory();
        // define properties for each table to lazily parse
        for(let tag in this.directory.tables){
            let table = this.directory.tables[tag];
            if ($f7a6899246d76dab$var$$5825c04ce8f7102d$export$2e2bcd8739ae039[tag] && table.length > 0) Object.defineProperty(this, tag, {
                get: this._getTable.bind(this, table)
            });
        }
    }
}
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "bbox", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_cmapProcessor", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "characterSet", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_layoutEngine", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "variationAxes", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "namedVariations", null);
(0, $NqsVD._)([
    $f7a6899246d76dab$var$$3bda6911913b43f0$export$69a3209f1a06c04d
], $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_variationProcessor", null);
let $f7a6899246d76dab$var$$89f72d2d7c9afc0d$var$WOFFDirectoryEntry = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    offset: new $erngl.Pointer($bjBBc.uint32, 'void', {
        type: 'global'
    }),
    compLength: $bjBBc.uint32,
    length: $bjBBc.uint32,
    origChecksum: $bjBBc.uint32
});
let $f7a6899246d76dab$var$$89f72d2d7c9afc0d$var$WOFFDirectory = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    flavor: $bjBBc.uint32,
    length: $bjBBc.uint32,
    numTables: $bjBBc.uint16,
    reserved: new $4cbQT.Reserved($bjBBc.uint16),
    totalSfntSize: $bjBBc.uint32,
    majorVersion: $bjBBc.uint16,
    minorVersion: $bjBBc.uint16,
    metaOffset: $bjBBc.uint32,
    metaLength: $bjBBc.uint32,
    metaOrigLength: $bjBBc.uint32,
    privOffset: $bjBBc.uint32,
    privLength: $bjBBc.uint32,
    tables: new $gI9iY.Array($f7a6899246d76dab$var$$89f72d2d7c9afc0d$var$WOFFDirectoryEntry, 'numTables')
});
$f7a6899246d76dab$var$$89f72d2d7c9afc0d$var$WOFFDirectory.process = function() {
    let tables = {};
    for (let table of this.tables)tables[table.tag] = table;
    this.tables = tables;
};
var $f7a6899246d76dab$var$$89f72d2d7c9afc0d$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$89f72d2d7c9afc0d$var$WOFFDirectory;
class $f7a6899246d76dab$var$$8a0a49baaf5d834d$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $f7a6899246d76dab$var$$66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === 'wOFF';
    }
    _decodeDirectory() {
        this.directory = $f7a6899246d76dab$var$$89f72d2d7c9afc0d$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header
                let outBuffer = new Uint8Array(table.length);
                let buf = $f7a6899246d76dab$var$$parcel$interopDefault($dHvIi)(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new $i4JPn.DecodeStream(buf);
            } else return this.stream;
        }
        return null;
    }
    constructor(...args){
        super(...args);
        (0, $4Bw9T._)(this, "type", 'WOFF');
    }
}
class $f7a6899246d76dab$var$$44b9edca0e403d6d$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$f680320fa07ef53d$export$2e2bcd8739ae039 {
    _decode() {
        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
        return this._font._transformedGlyphs[this.id];
    }
    _getCBox() {
        return this.path.bbox;
    }
    constructor(...args){
        super(...args);
        (0, $4Bw9T._)(this, "type", 'WOFF2');
    }
}
const $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$Base128 = {
    decode (stream) {
        let result = 0;
        let iterable = [
            0,
            1,
            2,
            3,
            4
        ];
        for(let j = 0; j < iterable.length; j++){
            let i = iterable[j];
            let code = stream.readUInt8();
            // If any of the top seven bits are set then we're about to overflow.
            if (result & 0xe0000000) throw new Error('Overflow');
            result = result << 7 | code & 0x7f;
            if ((code & 0x80) === 0) return result;
        }
        throw new Error('Bad base 128 number');
    }
};
let $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$knownTags = [
    'cmap',
    'head',
    'hhea',
    'hmtx',
    'maxp',
    'name',
    'OS/2',
    'post',
    'cvt ',
    'fpgm',
    'glyf',
    'loca',
    'prep',
    'CFF ',
    'VORG',
    'EBDT',
    'EBLC',
    'gasp',
    'hdmx',
    'kern',
    'LTSH',
    'PCLT',
    'VDMX',
    'vhea',
    'vmtx',
    'BASE',
    'GDEF',
    'GPOS',
    'GSUB',
    'EBSC',
    'JSTF',
    'MATH',
    'CBDT',
    'CBLC',
    'COLR',
    'CPAL',
    'SVG ',
    'sbix',
    'acnt',
    'avar',
    'bdat',
    'bloc',
    'bsln',
    'cvar',
    'fdsc',
    'feat',
    'fmtx',
    'fvar',
    'gvar',
    'hsty',
    'just',
    'lcar',
    'mort',
    'morx',
    'opbd',
    'prop',
    'trak',
    'Zapf',
    'Silf',
    'Glat',
    'Gloc',
    'Feat',
    'Sill'
];
let $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$WOFF2DirectoryEntry = new $XqKmt.Struct({
    flags: $bjBBc.uint8,
    customTag: new $jvb6m.Optional(new $1X3I0.String(4), (t)=>(t.flags & 0x3f) === 0x3f),
    tag: (t)=>t.customTag || $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$knownTags[t.flags & 0x3f],
    length: $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$Base128,
    transformVersion: (t)=>t.flags >>> 6 & 0x03,
    transformed: (t)=>t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0,
    transformLength: new $jvb6m.Optional($f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$Base128, (t)=>t.transformed)
});
let $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$WOFF2Directory = new $XqKmt.Struct({
    tag: new $1X3I0.String(4),
    flavor: $bjBBc.uint32,
    length: $bjBBc.uint32,
    numTables: $bjBBc.uint16,
    reserved: new $4cbQT.Reserved($bjBBc.uint16),
    totalSfntSize: $bjBBc.uint32,
    totalCompressedSize: $bjBBc.uint32,
    majorVersion: $bjBBc.uint16,
    minorVersion: $bjBBc.uint16,
    metaOffset: $bjBBc.uint32,
    metaLength: $bjBBc.uint32,
    metaOrigLength: $bjBBc.uint32,
    privOffset: $bjBBc.uint32,
    privLength: $bjBBc.uint32,
    tables: new $gI9iY.Array($f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$WOFF2DirectoryEntry, 'numTables')
});
$f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$WOFF2Directory.process = function() {
    let tables = {};
    for(let i = 0; i < this.tables.length; i++){
        let table = this.tables[i];
        tables[table.tag] = table;
    }
    return this.tables = tables;
};
var $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$export$2e2bcd8739ae039 = $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$var$WOFF2Directory;
class $f7a6899246d76dab$var$$333fb94547d9fb5c$export$2e2bcd8739ae039 extends $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $f7a6899246d76dab$var$$66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === 'wOF2';
    }
    _decodeDirectory() {
        this.directory = $f7a6899246d76dab$var$$2f0bfd9a5c1d7b58$export$2e2bcd8739ae039.decode(this.stream);
        this._dataPos = this.stream.pos;
    }
    _decompress() {
        // decompress data and setup table offsets if we haven't already
        if (!this._decompressed) {
            this.stream.pos = this._dataPos;
            let buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
            let decompressedSize = 0;
            for(let tag in this.directory.tables){
                let entry = this.directory.tables[tag];
                entry.offset = decompressedSize;
                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
            }
            let decompressed = $f7a6899246d76dab$var$$parcel$interopDefault($j8d6B)(buffer, decompressedSize);
            if (!decompressed) throw new Error('Error decoding compressed data in WOFF2');
            this.stream = new $i4JPn.DecodeStream(decompressed);
            this._decompressed = true;
        }
    }
    _decodeTable(table) {
        this._decompress();
        return super._decodeTable(table);
    }
    // Override this method to get a glyph and return our
    // custom subclass if there is a glyf table.
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                if (!this._transformedGlyphs) this._transformGlyfTable();
                return this._glyphs[glyph] = new $f7a6899246d76dab$var$$44b9edca0e403d6d$export$2e2bcd8739ae039(glyph, characters, this);
            } else return super._getBaseGlyph(glyph, characters);
        }
    }
    _transformGlyfTable() {
        this._decompress();
        this.stream.pos = this.directory.tables.glyf.offset;
        let table = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$GlyfTable.decode(this.stream);
        let glyphs = [];
        for(let index = 0; index < table.numGlyphs; index++){
            let glyph = {};
            let nContours = table.nContours.readInt16BE();
            glyph.numberOfContours = nContours;
            if (nContours > 0) {
                let nPoints = [];
                let totalPoints = 0;
                for(let i = 0; i < nContours; i++){
                    let r = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$read255UInt16(table.nPoints);
                    totalPoints += r;
                    nPoints.push(totalPoints);
                }
                glyph.points = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$decodeTriplet(table.flags, table.glyphs, totalPoints);
                for(let i = 0; i < nContours; i++)glyph.points[nPoints[i] - 1].endContour = true;
                var instructionSize = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$read255UInt16(table.glyphs);
            } else if (nContours < 0) {
                let haveInstructions = $f7a6899246d76dab$var$$f680320fa07ef53d$export$2e2bcd8739ae039.prototype._decodeComposite.call({
                    _font: this
                }, glyph, table.composites);
                if (haveInstructions) var instructionSize = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$read255UInt16(table.glyphs);
            }
            glyphs.push(glyph);
        }
        this._transformedGlyphs = glyphs;
    }
    constructor(...args){
        super(...args);
        (0, $4Bw9T._)(this, "type", 'WOFF2');
    }
}
// Special class that accepts a length and returns a sub-stream for that data
class $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream {
    decode(stream, parent) {
        return new $i4JPn.DecodeStream(this._buf.decode(stream, parent));
    }
    constructor(length){
        this.length = length;
        this._buf = new $hH3hY.Buffer(length);
    }
}
// This struct represents the entire glyf table
let $f7a6899246d76dab$var$$333fb94547d9fb5c$var$GlyfTable = new $XqKmt.Struct({
    version: $bjBBc.uint32,
    numGlyphs: $bjBBc.uint16,
    indexFormat: $bjBBc.uint16,
    nContourStreamSize: $bjBBc.uint32,
    nPointsStreamSize: $bjBBc.uint32,
    flagStreamSize: $bjBBc.uint32,
    glyphStreamSize: $bjBBc.uint32,
    compositeStreamSize: $bjBBc.uint32,
    bboxStreamSize: $bjBBc.uint32,
    instructionStreamSize: $bjBBc.uint32,
    nContours: new $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream('nContourStreamSize'),
    nPoints: new $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream('nPointsStreamSize'),
    flags: new $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream('flagStreamSize'),
    glyphs: new $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream('glyphStreamSize'),
    composites: new $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream('compositeStreamSize'),
    bboxes: new $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream('bboxStreamSize'),
    instructions: new $f7a6899246d76dab$var$$333fb94547d9fb5c$var$Substream('instructionStreamSize')
});
const $f7a6899246d76dab$var$$333fb94547d9fb5c$var$WORD_CODE = 253;
const $f7a6899246d76dab$var$$333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE2 = 254;
const $f7a6899246d76dab$var$$333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE1 = 255;
const $f7a6899246d76dab$var$$333fb94547d9fb5c$var$LOWEST_U_CODE = 253;
function $f7a6899246d76dab$var$$333fb94547d9fb5c$var$read255UInt16(stream) {
    let code = stream.readUInt8();
    if (code === $f7a6899246d76dab$var$$333fb94547d9fb5c$var$WORD_CODE) return stream.readUInt16BE();
    if (code === $f7a6899246d76dab$var$$333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE1) return stream.readUInt8() + $f7a6899246d76dab$var$$333fb94547d9fb5c$var$LOWEST_U_CODE;
    if (code === $f7a6899246d76dab$var$$333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE2) return stream.readUInt8() + $f7a6899246d76dab$var$$333fb94547d9fb5c$var$LOWEST_U_CODE * 2;
    return code;
}
function $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag, baseval) {
    return flag & 1 ? baseval : -baseval;
}
function $f7a6899246d76dab$var$$333fb94547d9fb5c$var$decodeTriplet(flags, glyphs, nPoints) {
    let y;
    let x = y = 0;
    let res = [];
    for(let i = 0; i < nPoints; i++){
        let dx = 0, dy = 0;
        let flag = flags.readUInt8();
        let onCurve = !(flag >> 7);
        flag &= 0x7f;
        if (flag < 10) {
            dx = 0;
            dy = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
        } else if (flag < 20) {
            dx = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
            dy = 0;
        } else if (flag < 84) {
            var b0 = flag - 20;
            var b1 = glyphs.readUInt8();
            dx = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
            dy = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
        } else if (flag < 120) {
            var b0 = flag - 84;
            dx = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
            dy = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
        } else if (flag < 124) {
            var b1 = glyphs.readUInt8();
            let b2 = glyphs.readUInt8();
            dx = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag, (b1 << 4) + (b2 >> 4));
            dy = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
        } else {
            dx = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag, glyphs.readUInt16BE());
            dy = $f7a6899246d76dab$var$$333fb94547d9fb5c$var$withSign(flag >> 1, glyphs.readUInt16BE());
        }
        x += dx;
        y += dy;
        res.push(new $f7a6899246d76dab$var$$f680320fa07ef53d$export$baf26146a414f24a(onCurve, false, x, y));
    }
    return res;
}
let $f7a6899246d76dab$var$$e0b2de9958441c02$var$TTCHeader = new $gqRil.VersionedStruct($bjBBc.uint32, {
    0x00010000: {
        numFonts: $bjBBc.uint32,
        offsets: new $gI9iY.Array($bjBBc.uint32, 'numFonts')
    },
    0x00020000: {
        numFonts: $bjBBc.uint32,
        offsets: new $gI9iY.Array($bjBBc.uint32, 'numFonts'),
        dsigTag: $bjBBc.uint32,
        dsigLength: $bjBBc.uint32,
        dsigOffset: $bjBBc.uint32
    }
});
class $f7a6899246d76dab$var$$e0b2de9958441c02$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $f7a6899246d76dab$var$$66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === 'ttcf';
    }
    getFont(name) {
        for (let offset of this.header.offsets){
            let stream = new $i4JPn.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            let font = new $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let offset of this.header.offsets){
            let stream = new $i4JPn.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            fonts.push(new $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        (0, $4Bw9T._)(this, "type", 'TTC');
        this.stream = stream;
        if (stream.readString(4) !== 'ttcf') throw new Error('Not a TrueType collection');
        this.header = $f7a6899246d76dab$var$$e0b2de9958441c02$var$TTCHeader.decode(stream);
    }
}
let $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontName = new $1X3I0.String($bjBBc.uint8);
let $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontData = new $XqKmt.Struct({
    len: $bjBBc.uint32,
    buf: new $hH3hY.Buffer('len')
});
let $f7a6899246d76dab$var$$d0fe640dc6c78783$var$Ref = new $XqKmt.Struct({
    id: $bjBBc.uint16,
    nameOffset: $bjBBc.int16,
    attr: $bjBBc.uint8,
    dataOffset: $bjBBc.uint24,
    handle: $bjBBc.uint32
});
let $f7a6899246d76dab$var$$d0fe640dc6c78783$var$Type = new $XqKmt.Struct({
    name: new $1X3I0.String(4),
    maxTypeIndex: $bjBBc.uint16,
    refList: new $erngl.Pointer($bjBBc.uint16, new $gI9iY.Array($f7a6899246d76dab$var$$d0fe640dc6c78783$var$Ref, (t)=>t.maxTypeIndex + 1), {
        type: 'parent'
    })
});
let $f7a6899246d76dab$var$$d0fe640dc6c78783$var$TypeList = new $XqKmt.Struct({
    length: $bjBBc.uint16,
    types: new $gI9iY.Array($f7a6899246d76dab$var$$d0fe640dc6c78783$var$Type, (t)=>t.length + 1)
});
let $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontMap = new $XqKmt.Struct({
    reserved: new $4cbQT.Reserved($bjBBc.uint8, 24),
    typeList: new $erngl.Pointer($bjBBc.uint16, $f7a6899246d76dab$var$$d0fe640dc6c78783$var$TypeList),
    nameListOffset: new $erngl.Pointer($bjBBc.uint16, 'void')
});
let $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontHeader = new $XqKmt.Struct({
    dataOffset: $bjBBc.uint32,
    map: new $erngl.Pointer($bjBBc.uint32, $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontMap),
    dataLength: $bjBBc.uint32,
    mapLength: $bjBBc.uint32
});
class $f7a6899246d76dab$var$$d0fe640dc6c78783$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let stream = new $i4JPn.DecodeStream(buffer);
        try {
            var header = $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontHeader.decode(stream);
        } catch (e) {
            return false;
        }
        for (let type of header.map.typeList.types){
            if (type.name === 'sfnt') return true;
        }
        return false;
    }
    getFont(name) {
        if (!this.sfnt) return null;
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new $i4JPn.DecodeStream(this.stream.buffer.slice(pos));
            let font = new $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new $i4JPn.DecodeStream(this.stream.buffer.slice(pos));
            fonts.push(new $f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        (0, $4Bw9T._)(this, "type", 'DFont');
        this.stream = stream;
        this.header = $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontHeader.decode(this.stream);
        for (let type of this.header.map.typeList.types){
            for (let ref of type.refList)if (ref.nameOffset >= 0) {
                this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                ref.name = $f7a6899246d76dab$var$$d0fe640dc6c78783$var$DFontName.decode(this.stream);
            } else ref.name = null;
            if (type.name === 'sfnt') this.sfnt = type;
        }
    }
}
$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$36b2f24e97d43be($f7a6899246d76dab$var$$0a8ef2660a6ce4b6$export$2e2bcd8739ae039);
$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$36b2f24e97d43be($f7a6899246d76dab$var$$8a0a49baaf5d834d$export$2e2bcd8739ae039);
$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$36b2f24e97d43be($f7a6899246d76dab$var$$333fb94547d9fb5c$export$2e2bcd8739ae039);
$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$36b2f24e97d43be($f7a6899246d76dab$var$$e0b2de9958441c02$export$2e2bcd8739ae039);
$f7a6899246d76dab$var$$59aa4ed98453e1d4$export$36b2f24e97d43be($f7a6899246d76dab$var$$d0fe640dc6c78783$export$2e2bcd8739ae039);
$f7a6899246d76dab$var$$parcel$exportWildcard(module.exports, $f7a6899246d76dab$var$$59aa4ed98453e1d4$exports); //# sourceMappingURL=browser.cjs.map

});
parcelRegister("dgZXH", function(module, exports) {
$parcel$export(module.exports, "PropertyDescriptor", () => (parcelRequire("d0Ff6")).PropertyDescriptor);
$parcel$export(module.exports, "resolveLength", () => (parcelRequire("d0Ff6")).resolveLength);
$parcel$export(module.exports, "Fixed", () => (parcelRequire("bjBBc")).Fixed);
$parcel$export(module.exports, "fixed16", () => (parcelRequire("bjBBc")).fixed16);
$parcel$export(module.exports, "fixed32", () => (parcelRequire("bjBBc")).fixed32);
$parcel$export(module.exports, "int16", () => (parcelRequire("bjBBc")).int16);
$parcel$export(module.exports, "int32", () => (parcelRequire("bjBBc")).int32);
$parcel$export(module.exports, "int8", () => (parcelRequire("bjBBc")).int8);
$parcel$export(module.exports, "Number", () => (parcelRequire("bjBBc")).Number);
$parcel$export(module.exports, "uint16", () => (parcelRequire("bjBBc")).uint16);
$parcel$export(module.exports, "uint24", () => (parcelRequire("bjBBc")).uint24);
$parcel$export(module.exports, "uint32", () => (parcelRequire("bjBBc")).uint32);
$parcel$export(module.exports, "uint8", () => (parcelRequire("bjBBc")).uint8);
$parcel$export(module.exports, "Pointer", () => (parcelRequire("erngl")).Pointer);
$parcel$export(module.exports, "VoidPointer", () => (parcelRequire("erngl")).VoidPointer);

$parcel$export(module.exports, "EncodeStream", () => (parcelRequire("gEOXZ")).EncodeStream);
$parcel$export(module.exports, "DecodeStream", () => (parcelRequire("i4JPn")).DecodeStream);
$parcel$export(module.exports, "Array", () => (parcelRequire("gI9iY")).Array);
$parcel$export(module.exports, "LazyArray", () => (parcelRequire("1Oxaj")).LazyArray);
$parcel$export(module.exports, "Bitfield", () => (parcelRequire("5J5hB")).Bitfield);
$parcel$export(module.exports, "Buffer", () => (parcelRequire("hH3hY")).Buffer);
$parcel$export(module.exports, "Optional", () => (parcelRequire("jvb6m")).Optional);
$parcel$export(module.exports, "Reserved", () => (parcelRequire("4cbQT")).Reserved);
$parcel$export(module.exports, "String", () => (parcelRequire("1X3I0")).String);
$parcel$export(module.exports, "Struct", () => (parcelRequire("XqKmt")).Struct);
$parcel$export(module.exports, "VersionedStruct", () => (parcelRequire("gqRil")).VersionedStruct);

var $gEOXZ = parcelRequire("gEOXZ");

var $i4JPn = parcelRequire("i4JPn");

var $gI9iY = parcelRequire("gI9iY");

var $1Oxaj = parcelRequire("1Oxaj");

var $5J5hB = parcelRequire("5J5hB");

var $dMNvd = parcelRequire("dMNvd");

var $hH3hY = parcelRequire("hH3hY");

var $hqub0 = parcelRequire("hqub0");

var $jvb6m = parcelRequire("jvb6m");

var $4cbQT = parcelRequire("4cbQT");

var $1X3I0 = parcelRequire("1X3I0");

var $XqKmt = parcelRequire("XqKmt");

var $gqRil = parcelRequire("gqRil");
parcelRequire("d0Ff6");
parcelRequire("bjBBc");
parcelRequire("erngl");

});
parcelRegister("gEOXZ", function(module, exports) {

$parcel$export(module.exports, "EncodeStream", () => $c207eaab05273912$export$9b4f661deaa36c3e);

var $i4JPn = parcelRequire("i4JPn");
const $c207eaab05273912$var$textEncoder = new TextEncoder();
const $c207eaab05273912$var$isBigEndian = new Uint8Array(new Uint16Array([
    0x1234
]).buffer)[0] == 0x12;
class $c207eaab05273912$export$9b4f661deaa36c3e {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        this.pos = 0;
    }
    writeBuffer(buffer) {
        this.buffer.set(buffer, this.pos);
        this.pos += buffer.length;
    }
    writeString(string, encoding = 'ascii') {
        let buf;
        switch(encoding){
            case 'utf16le':
            case 'utf16-le':
            case 'ucs2':
                buf = $c207eaab05273912$var$stringToUtf16(string, $c207eaab05273912$var$isBigEndian);
                break;
            case 'utf16be':
            case 'utf16-be':
                buf = $c207eaab05273912$var$stringToUtf16(string, !$c207eaab05273912$var$isBigEndian);
                break;
            case 'utf8':
                buf = $c207eaab05273912$var$textEncoder.encode(string);
                break;
            case 'ascii':
                buf = $c207eaab05273912$var$stringToAscii(string);
                break;
            default:
                throw new Error(`Unsupported encoding: ${encoding}`);
        }
        this.writeBuffer(buf);
    }
    writeUInt24BE(val) {
        this.buffer[this.pos++] = val >>> 16 & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val & 0xff;
    }
    writeUInt24LE(val) {
        this.buffer[this.pos++] = val & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val >>> 16 & 0xff;
    }
    writeInt24BE(val) {
        if (val >= 0) this.writeUInt24BE(val);
        else this.writeUInt24BE(val + 0xffffff + 1);
    }
    writeInt24LE(val) {
        if (val >= 0) this.writeUInt24LE(val);
        else this.writeUInt24LE(val + 0xffffff + 1);
    }
    fill(val, length) {
        if (length < this.buffer.length) {
            this.buffer.fill(val, this.pos, this.pos + length);
            this.pos += length;
        } else {
            const buf = new Uint8Array(length);
            buf.fill(val);
            this.writeBuffer(buf);
        }
    }
}
function $c207eaab05273912$var$stringToUtf16(string, swap) {
    let buf = new Uint16Array(string.length);
    for(let i = 0; i < string.length; i++){
        let code = string.charCodeAt(i);
        if (swap) code = code >> 8 | (code & 0xff) << 8;
        buf[i] = code;
    }
    return new Uint8Array(buf.buffer);
}
function $c207eaab05273912$var$stringToAscii(string) {
    let buf = new Uint8Array(string.length);
    for(let i = 0; i < string.length; i++)// Match node.js behavior - encoding allows 8-bit rather than 7-bit.
    buf[i] = string.charCodeAt(i);
    return buf;
}
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === 'set') {
    let type = key.slice(3).replace('Ui', 'UI');
    if (type === 'Float32') type = 'Float';
    else if (type === 'Float64') type = 'Double';
    let bytes = (0, $i4JPn.DecodeStream).TYPES[type];
    $c207eaab05273912$export$9b4f661deaa36c3e.prototype['write' + type + (bytes === 1 ? '' : 'BE')] = function(value) {
        this.view[key](this.pos, value, false);
        this.pos += bytes;
    };
    if (bytes !== 1) $c207eaab05273912$export$9b4f661deaa36c3e.prototype['write' + type + 'LE'] = function(value) {
        this.view[key](this.pos, value, true);
        this.pos += bytes;
    };
}

});
parcelRegister("i4JPn", function(module, exports) {

$parcel$export(module.exports, "DecodeStream", () => $d28c261f9dc3f39e$export$c18b354bac7948e9);
// Node back-compat.
const $d28c261f9dc3f39e$var$ENCODING_MAPPING = {
    utf16le: 'utf-16le',
    ucs2: 'utf-16le',
    utf16be: 'utf-16be'
};
class $d28c261f9dc3f39e$export$c18b354bac7948e9 {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
        this.pos = 0;
        this.length = this.buffer.length;
    }
    readString(length, encoding = 'ascii') {
        encoding = $d28c261f9dc3f39e$var$ENCODING_MAPPING[encoding] || encoding;
        let buf = this.readBuffer(length);
        try {
            let decoder = new TextDecoder(encoding);
            return decoder.decode(buf);
        } catch (err) {
            return buf;
        }
    }
    readBuffer(length) {
        return this.buffer.slice(this.pos, this.pos += length);
    }
    readUInt24BE() {
        return (this.readUInt16BE() << 8) + this.readUInt8();
    }
    readUInt24LE() {
        return this.readUInt16LE() + (this.readUInt8() << 16);
    }
    readInt24BE() {
        return (this.readInt16BE() << 8) + this.readUInt8();
    }
    readInt24LE() {
        return this.readUInt16LE() + (this.readInt8() << 16);
    }
}
$d28c261f9dc3f39e$export$c18b354bac7948e9.TYPES = {
    UInt8: 1,
    UInt16: 2,
    UInt24: 3,
    UInt32: 4,
    Int8: 1,
    Int16: 2,
    Int24: 3,
    Int32: 4,
    Float: 4,
    Double: 8
};
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === 'get') {
    let type = key.slice(3).replace('Ui', 'UI');
    if (type === 'Float32') type = 'Float';
    else if (type === 'Float64') type = 'Double';
    let bytes = $d28c261f9dc3f39e$export$c18b354bac7948e9.TYPES[type];
    $d28c261f9dc3f39e$export$c18b354bac7948e9.prototype['read' + type + (bytes === 1 ? '' : 'BE')] = function() {
        const ret = this.view[key](this.pos, false);
        this.pos += bytes;
        return ret;
    };
    if (bytes !== 1) $d28c261f9dc3f39e$export$c18b354bac7948e9.prototype['read' + type + 'LE'] = function() {
        const ret = this.view[key](this.pos, true);
        this.pos += bytes;
        return ret;
    };
}

});


parcelRegister("gI9iY", function(module, exports) {

$parcel$export(module.exports, "Array", () => $c2a7f92f159a8c91$export$c4be6576ca6fe4aa);

var $6wP74 = parcelRequire("6wP74");

var $bjBBc = parcelRequire("bjBBc");

var $d0Ff6 = parcelRequire("d0Ff6");
class $c2a7f92f159a8c91$export$c4be6576ca6fe4aa extends (0, $6wP74.Base) {
    constructor(type, length, lengthType = 'count'){
        super();
        this.type = type;
        this.length = length;
        this.lengthType = lengthType;
    }
    decode(stream, parent) {
        let length;
        const { pos: pos } = stream;
        const res = [];
        let ctx = parent;
        if (this.length != null) length = $d0Ff6.resolveLength(this.length, stream, parent);
        if (this.length instanceof (0, $bjBBc.Number)) {
            // define hidden properties
            Object.defineProperties(res, {
                parent: {
                    value: parent
                },
                _startOffset: {
                    value: pos
                },
                _currentOffset: {
                    value: 0,
                    writable: true
                },
                _length: {
                    value: length
                }
            });
            ctx = res;
        }
        if (length == null || this.lengthType === 'bytes') {
            const target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;
            while(stream.pos < target)res.push(this.type.decode(stream, ctx));
        } else for(let i = 0, end = length; i < end; i++)res.push(this.type.decode(stream, ctx));
        return res;
    }
    size(array, ctx, includePointers = true) {
        if (!array) return this.type.size(null, ctx) * $d0Ff6.resolveLength(this.length, null, ctx);
        let size = 0;
        if (this.length instanceof (0, $bjBBc.Number)) {
            size += this.length.size();
            ctx = {
                parent: ctx,
                pointerSize: 0
            };
        }
        for (let item of array)size += this.type.size(item, ctx);
        if (ctx && includePointers && this.length instanceof (0, $bjBBc.Number)) size += ctx.pointerSize;
        return size;
    }
    encode(stream, array, parent) {
        let ctx = parent;
        if (this.length instanceof (0, $bjBBc.Number)) {
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent: parent
            };
            ctx.pointerOffset = stream.pos + this.size(array, ctx, false);
            this.length.encode(stream, array.length);
        }
        for (let item of array)this.type.encode(stream, item, ctx);
        if (this.length instanceof (0, $bjBBc.Number)) {
            let i = 0;
            while(i < ctx.pointers.length){
                const ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        }
    }
}

});
parcelRegister("6wP74", function(module, exports) {

$parcel$export(module.exports, "Base", () => $4c0d613e95890d04$export$ef88aa0d34c34520);

var $i4JPn = parcelRequire("i4JPn");

var $gEOXZ = parcelRequire("gEOXZ");
class $4c0d613e95890d04$export$ef88aa0d34c34520 {
    fromBuffer(buffer) {
        let stream = new (0, $i4JPn.DecodeStream)(buffer);
        return this.decode(stream);
    }
    toBuffer(value) {
        let size = this.size(value);
        let buffer = new Uint8Array(size);
        let stream = new (0, $gEOXZ.EncodeStream)(buffer);
        this.encode(stream, value);
        return buffer;
    }
}

});

parcelRegister("bjBBc", function(module, exports) {

$parcel$export(module.exports, "Number", () => $83cea26e2678b6a9$export$fffa67e515d04022);
$parcel$export(module.exports, "uint8", () => $83cea26e2678b6a9$export$52e103c63c4e68cf);
$parcel$export(module.exports, "uint16", () => $83cea26e2678b6a9$export$56bd24b5a3ee8456);
$parcel$export(module.exports, "uint24", () => $83cea26e2678b6a9$export$1925298fbd719b21);
$parcel$export(module.exports, "uint32", () => $83cea26e2678b6a9$export$de9ffb9418dd7d0d);
$parcel$export(module.exports, "int8", () => $83cea26e2678b6a9$export$5984f25eab09961f);
$parcel$export(module.exports, "int16", () => $83cea26e2678b6a9$export$c35c15c7caeff2b6);
$parcel$export(module.exports, "int32", () => $83cea26e2678b6a9$export$1d95835383bb05a);
$parcel$export(module.exports, "Fixed", () => $83cea26e2678b6a9$export$13475bbd2a37a9b4);
$parcel$export(module.exports, "fixed16", () => $83cea26e2678b6a9$export$a3abada75ef55921);
$parcel$export(module.exports, "fixed32", () => $83cea26e2678b6a9$export$e913265d48471f2d);

var $i4JPn = parcelRequire("i4JPn");

var $6wP74 = parcelRequire("6wP74");
class $83cea26e2678b6a9$export$fffa67e515d04022 extends (0, $6wP74.Base) {
    constructor(type, endian = 'BE'){
        super();
        this.type = type;
        this.endian = endian;
        this.fn = this.type;
        if (this.type[this.type.length - 1] !== '8') this.fn += this.endian;
    }
    size() {
        return (0, $i4JPn.DecodeStream).TYPES[this.type];
    }
    decode(stream) {
        return stream[`read${this.fn}`]();
    }
    encode(stream, val) {
        return stream[`write${this.fn}`](val);
    }
}
const $83cea26e2678b6a9$export$52e103c63c4e68cf = new $83cea26e2678b6a9$export$fffa67e515d04022('UInt8');
const $83cea26e2678b6a9$export$60dfe43c8297a8f8 = new $83cea26e2678b6a9$export$fffa67e515d04022('UInt16', 'BE');
const $83cea26e2678b6a9$export$56bd24b5a3ee8456 = $83cea26e2678b6a9$export$60dfe43c8297a8f8;
const $83cea26e2678b6a9$export$b92d76f0ca6d1789 = new $83cea26e2678b6a9$export$fffa67e515d04022('UInt16', 'LE');
const $83cea26e2678b6a9$export$255f45171f96b50c = new $83cea26e2678b6a9$export$fffa67e515d04022('UInt24', 'BE');
const $83cea26e2678b6a9$export$1925298fbd719b21 = $83cea26e2678b6a9$export$255f45171f96b50c;
const $83cea26e2678b6a9$export$758e1dafc8dc7271 = new $83cea26e2678b6a9$export$fffa67e515d04022('UInt24', 'LE');
const $83cea26e2678b6a9$export$74c16dba6c885532 = new $83cea26e2678b6a9$export$fffa67e515d04022('UInt32', 'BE');
const $83cea26e2678b6a9$export$de9ffb9418dd7d0d = $83cea26e2678b6a9$export$74c16dba6c885532;
const $83cea26e2678b6a9$export$5f744bb30a534bc9 = new $83cea26e2678b6a9$export$fffa67e515d04022('UInt32', 'LE');
const $83cea26e2678b6a9$export$5984f25eab09961f = new $83cea26e2678b6a9$export$fffa67e515d04022('Int8');
const $83cea26e2678b6a9$export$198ae7d10d26a900 = new $83cea26e2678b6a9$export$fffa67e515d04022('Int16', 'BE');
const $83cea26e2678b6a9$export$c35c15c7caeff2b6 = $83cea26e2678b6a9$export$198ae7d10d26a900;
const $83cea26e2678b6a9$export$399cc4b7169e5aed = new $83cea26e2678b6a9$export$fffa67e515d04022('Int16', 'LE');
const $83cea26e2678b6a9$export$3676d1f71eca2ec0 = new $83cea26e2678b6a9$export$fffa67e515d04022('Int24', 'BE');
const $83cea26e2678b6a9$export$73f695d681ac61f9 = $83cea26e2678b6a9$export$3676d1f71eca2ec0;
const $83cea26e2678b6a9$export$671f8672dbd40a4 = new $83cea26e2678b6a9$export$fffa67e515d04022('Int24', 'LE');
const $83cea26e2678b6a9$export$78a2ac3d09dd42d5 = new $83cea26e2678b6a9$export$fffa67e515d04022('Int32', 'BE');
const $83cea26e2678b6a9$export$1d95835383bb05a = $83cea26e2678b6a9$export$78a2ac3d09dd42d5;
const $83cea26e2678b6a9$export$5ec1f146e759329a = new $83cea26e2678b6a9$export$fffa67e515d04022('Int32', 'LE');
const $83cea26e2678b6a9$export$92b5c14c6abb5c97 = new $83cea26e2678b6a9$export$fffa67e515d04022('Float', 'BE');
const $83cea26e2678b6a9$export$6b5cd3983e3ee5ab = $83cea26e2678b6a9$export$92b5c14c6abb5c97;
const $83cea26e2678b6a9$export$6d20592bc4cb19d9 = new $83cea26e2678b6a9$export$fffa67e515d04022('Float', 'LE');
const $83cea26e2678b6a9$export$e50b9e97e4d43631 = new $83cea26e2678b6a9$export$fffa67e515d04022('Double', 'BE');
const $83cea26e2678b6a9$export$7b3cbda67be88f5f = $83cea26e2678b6a9$export$e50b9e97e4d43631;
const $83cea26e2678b6a9$export$6f53315aa512b751 = new $83cea26e2678b6a9$export$fffa67e515d04022('Double', 'LE');
class $83cea26e2678b6a9$export$13475bbd2a37a9b4 extends $83cea26e2678b6a9$export$fffa67e515d04022 {
    constructor(size, endian, fracBits = size >> 1){
        super(`Int${size}`, endian);
        this._point = 1 << fracBits;
    }
    decode(stream) {
        return super.decode(stream) / this._point;
    }
    encode(stream, val) {
        return super.encode(stream, val * this._point | 0);
    }
}
const $83cea26e2678b6a9$export$f87b441e6bd90278 = new $83cea26e2678b6a9$export$13475bbd2a37a9b4(16, 'BE');
const $83cea26e2678b6a9$export$a3abada75ef55921 = $83cea26e2678b6a9$export$f87b441e6bd90278;
const $83cea26e2678b6a9$export$3752a2886837dc22 = new $83cea26e2678b6a9$export$13475bbd2a37a9b4(16, 'LE');
const $83cea26e2678b6a9$export$dd71d8d9bc792632 = new $83cea26e2678b6a9$export$13475bbd2a37a9b4(32, 'BE');
const $83cea26e2678b6a9$export$e913265d48471f2d = $83cea26e2678b6a9$export$dd71d8d9bc792632;
const $83cea26e2678b6a9$export$7fc47db6a5fc8223 = new $83cea26e2678b6a9$export$13475bbd2a37a9b4(32, 'LE');

});

parcelRegister("d0Ff6", function(module, exports) {

$parcel$export(module.exports, "resolveLength", () => $978b446018acf522$export$83b6dc3503c1fda6);
$parcel$export(module.exports, "PropertyDescriptor", () => $978b446018acf522$export$41705b1d644e0f14);

var $bjBBc = parcelRequire("bjBBc");
function $978b446018acf522$export$83b6dc3503c1fda6(length, stream, parent) {
    let res;
    if (typeof length === 'number') res = length;
    else if (typeof length === 'function') res = length.call(parent, parent);
    else if (parent && typeof length === 'string') res = parent[length];
    else if (stream && length instanceof (0, $bjBBc.Number)) res = length.decode(stream);
    if (isNaN(res)) throw new Error('Not a fixed size');
    return res;
}
class $978b446018acf522$export$41705b1d644e0f14 {
    constructor(opts = {}){
        this.enumerable = true;
        this.configurable = true;
        for(let key in opts){
            const val = opts[key];
            this[key] = val;
        }
    }
}

});


parcelRegister("1Oxaj", function(module, exports) {

$parcel$export(module.exports, "LazyArray", () => $15242fe892221bcd$export$5576c026028d4983);

var $gI9iY = parcelRequire("gI9iY");

var $bjBBc = parcelRequire("bjBBc");

var $d0Ff6 = parcelRequire("d0Ff6");
class $15242fe892221bcd$export$5576c026028d4983 extends (0, $gI9iY.Array) {
    decode(stream, parent) {
        const { pos: pos } = stream;
        const length = $d0Ff6.resolveLength(this.length, stream, parent);
        if (this.length instanceof (0, $bjBBc.Number)) parent = {
            parent: parent,
            _startOffset: pos,
            _currentOffset: 0,
            _length: length
        };
        const res = new $15242fe892221bcd$var$LazyArrayValue(this.type, length, stream, parent);
        stream.pos += length * this.type.size(null, parent);
        return res;
    }
    size(val, ctx) {
        if (val instanceof $15242fe892221bcd$var$LazyArrayValue) val = val.toArray();
        return super.size(val, ctx);
    }
    encode(stream, val, ctx) {
        if (val instanceof $15242fe892221bcd$var$LazyArrayValue) val = val.toArray();
        return super.encode(stream, val, ctx);
    }
}
class $15242fe892221bcd$var$LazyArrayValue {
    constructor(type, length, stream, ctx){
        this.type = type;
        this.length = length;
        this.stream = stream;
        this.ctx = ctx;
        this.base = this.stream.pos;
        this.items = [];
    }
    get(index) {
        if (index < 0 || index >= this.length) return undefined;
        if (this.items[index] == null) {
            const { pos: pos } = this.stream;
            this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
            this.items[index] = this.type.decode(this.stream, this.ctx);
            this.stream.pos = pos;
        }
        return this.items[index];
    }
    toArray() {
        const result = [];
        for(let i = 0, end = this.length; i < end; i++)result.push(this.get(i));
        return result;
    }
}

});

parcelRegister("5J5hB", function(module, exports) {

$parcel$export(module.exports, "Bitfield", () => $42b540cf7adee3c9$export$96b43b8a49f688ea);

var $6wP74 = parcelRequire("6wP74");
class $42b540cf7adee3c9$export$96b43b8a49f688ea extends (0, $6wP74.Base) {
    constructor(type, flags = []){
        super();
        this.type = type;
        this.flags = flags;
    }
    decode(stream) {
        const val = this.type.decode(stream);
        const res = {};
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) res[flag] = !!(val & 1 << i);
        }
        return res;
    }
    size() {
        return this.type.size();
    }
    encode(stream, keys) {
        let val = 0;
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) {
                if (keys[flag]) val |= 1 << i;
            }
        }
        return this.type.encode(stream, val);
    }
}

});

parcelRegister("dMNvd", function(module, exports) {

var $6wP74 = parcelRequire("6wP74");
class $a0962835272634bf$export$ff887cefee4d61ec extends (0, $6wP74.Base) {
    constructor(type){
        super();
        this.type = type;
    }
    decode(stream, parent) {
        return !!this.type.decode(stream, parent);
    }
    size(val, parent) {
        return this.type.size(val, parent);
    }
    encode(stream, val, parent) {
        return this.type.encode(stream, +val, parent);
    }
}

});

parcelRegister("hH3hY", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $ce1900e78ba28923$export$7d22a0eea6656474);

var $6wP74 = parcelRequire("6wP74");

var $bjBBc = parcelRequire("bjBBc");

var $d0Ff6 = parcelRequire("d0Ff6");
class $ce1900e78ba28923$export$7d22a0eea6656474 extends (0, $6wP74.Base) {
    constructor(length){
        super();
        this.length = length;
    }
    decode(stream, parent) {
        const length = $d0Ff6.resolveLength(this.length, stream, parent);
        return stream.readBuffer(length);
    }
    size(val, parent) {
        if (!val) return $d0Ff6.resolveLength(this.length, null, parent);
        let len = val.length;
        if (this.length instanceof (0, $bjBBc.Number)) len += this.length.size();
        return len;
    }
    encode(stream, buf, parent) {
        if (this.length instanceof (0, $bjBBc.Number)) this.length.encode(stream, buf.length);
        return stream.writeBuffer(buf);
    }
}

});

parcelRegister("hqub0", function(module, exports) {

var $6wP74 = parcelRequire("6wP74");
class $cafc45cc672d5f91$export$deb82508dd66d288 extends (0, $6wP74.Base) {
    constructor(type, options = []){
        super();
        this.type = type;
        this.options = options;
    }
    decode(stream) {
        const index = this.type.decode(stream);
        return this.options[index] || index;
    }
    size() {
        return this.type.size();
    }
    encode(stream, val) {
        const index = this.options.indexOf(val);
        if (index === -1) throw new Error(`Unknown option in enum: ${val}`);
        return this.type.encode(stream, index);
    }
}

});

parcelRegister("jvb6m", function(module, exports) {

$parcel$export(module.exports, "Optional", () => $e3298619df00705e$export$7acb7b24c478f9c6);

var $6wP74 = parcelRequire("6wP74");
class $e3298619df00705e$export$7acb7b24c478f9c6 extends (0, $6wP74.Base) {
    constructor(type, condition = true){
        super();
        this.type = type;
        this.condition = condition;
    }
    decode(stream, parent) {
        let { condition: condition } = this;
        if (typeof condition === 'function') condition = condition.call(parent, parent);
        if (condition) return this.type.decode(stream, parent);
    }
    size(val, parent) {
        let { condition: condition } = this;
        if (typeof condition === 'function') condition = condition.call(parent, parent);
        if (condition) return this.type.size(val, parent);
        else return 0;
    }
    encode(stream, val, parent) {
        let { condition: condition } = this;
        if (typeof condition === 'function') condition = condition.call(parent, parent);
        if (condition) return this.type.encode(stream, val, parent);
    }
}

});

parcelRegister("4cbQT", function(module, exports) {

$parcel$export(module.exports, "Reserved", () => $30e179fcc799e217$export$da9b5fe187a9aa1);

var $6wP74 = parcelRequire("6wP74");

var $d0Ff6 = parcelRequire("d0Ff6");
class $30e179fcc799e217$export$da9b5fe187a9aa1 extends (0, $6wP74.Base) {
    constructor(type, count = 1){
        super();
        this.type = type;
        this.count = count;
    }
    decode(stream, parent) {
        stream.pos += this.size(null, parent);
        return undefined;
    }
    size(data, parent) {
        const count = $d0Ff6.resolveLength(this.count, null, parent);
        return this.type.size() * count;
    }
    encode(stream, val, parent) {
        return stream.fill(0, this.size(val, parent));
    }
}

});

parcelRegister("1X3I0", function(module, exports) {

$parcel$export(module.exports, "String", () => $16be2d98cb6bced0$export$89b8e0fa65f6a914);

var $6wP74 = parcelRequire("6wP74");

var $bjBBc = parcelRequire("bjBBc");

var $d0Ff6 = parcelRequire("d0Ff6");
class $16be2d98cb6bced0$export$89b8e0fa65f6a914 extends (0, $6wP74.Base) {
    constructor(length, encoding = 'ascii'){
        super();
        this.length = length;
        this.encoding = encoding;
    }
    decode(stream, parent) {
        let length, pos;
        let { encoding: encoding } = this;
        if (typeof encoding === 'function') encoding = encoding.call(parent, parent) || 'ascii';
        let width = $16be2d98cb6bced0$var$encodingWidth(encoding);
        if (this.length != null) length = $d0Ff6.resolveLength(this.length, stream, parent);
        else {
            let buffer;
            ({ buffer: buffer, length: length, pos: pos } = stream);
            while(pos < length - width + 1 && (buffer[pos] !== 0x00 || width === 2 && buffer[pos + 1] !== 0x00))pos += width;
            length = pos - stream.pos;
        }
        const string = stream.readString(length, encoding);
        if (this.length == null && stream.pos < stream.length) stream.pos += width;
        return string;
    }
    size(val, parent) {
        // Use the defined value if no value was given
        if (val === undefined || val === null) return $d0Ff6.resolveLength(this.length, null, parent);
        let { encoding: encoding } = this;
        if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
        if (encoding === 'utf16be') encoding = 'utf16le';
        let size = $16be2d98cb6bced0$var$byteLength(val, encoding);
        if (this.length instanceof (0, $bjBBc.Number)) size += this.length.size();
        if (this.length == null) size += $16be2d98cb6bced0$var$encodingWidth(encoding);
        return size;
    }
    encode(stream, val, parent) {
        let { encoding: encoding } = this;
        if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
        if (this.length instanceof (0, $bjBBc.Number)) this.length.encode(stream, $16be2d98cb6bced0$var$byteLength(val, encoding));
        stream.writeString(val, encoding);
        if (this.length == null) return $16be2d98cb6bced0$var$encodingWidth(encoding) == 2 ? stream.writeUInt16LE(0x0000) : stream.writeUInt8(0x00);
    }
}
function $16be2d98cb6bced0$var$encodingWidth(encoding) {
    switch(encoding){
        case 'ascii':
        case 'utf8':
            return 1;
        case 'utf16le':
        case 'utf16-le':
        case 'utf-16be':
        case 'utf-16le':
        case 'utf16be':
        case 'utf16-be':
        case 'ucs2':
            return 2;
        default:
            //TODO: assume all other encodings are 1-byters
            //throw new Error('Unknown encoding ' + encoding);
            return 1;
    }
}
function $16be2d98cb6bced0$var$byteLength(string, encoding) {
    switch(encoding){
        case 'ascii':
            return string.length;
        case 'utf8':
            let len = 0;
            for(let i = 0; i < string.length; i++){
                let c = string.charCodeAt(i);
                if (c >= 0xd800 && c <= 0xdbff && i < string.length - 1) {
                    let c2 = string.charCodeAt(++i);
                    if ((c2 & 0xfc00) === 0xdc00) c = ((c & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
                    else // unmatched surrogate.
                    i--;
                }
                if ((c & 0xffffff80) === 0) len++;
                else if ((c & 0xfffff800) === 0) len += 2;
                else if ((c & 0xffff0000) === 0) len += 3;
                else if ((c & 0xffe00000) === 0) len += 4;
            }
            return len;
        case 'utf16le':
        case 'utf16-le':
        case 'utf16be':
        case 'utf16-be':
        case 'ucs2':
            return string.length * 2;
        default:
            throw new Error('Unknown encoding ' + encoding);
    }
}

});

parcelRegister("XqKmt", function(module, exports) {

$parcel$export(module.exports, "Struct", () => $0b2a422743092498$export$eabc71f011df675a);

var $6wP74 = parcelRequire("6wP74");

var $d0Ff6 = parcelRequire("d0Ff6");
class $0b2a422743092498$export$eabc71f011df675a extends (0, $6wP74.Base) {
    constructor(fields = {}){
        super();
        this.fields = fields;
    }
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        this._parseFields(stream, res, this.fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    _setup(stream, parent, length) {
        const res = {};
        // define hidden properties
        Object.defineProperties(res, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            },
            _currentOffset: {
                value: 0,
                writable: true
            },
            _length: {
                value: length
            }
        });
        return res;
    }
    _parseFields(stream, res, fields) {
        for(let key in fields){
            var val;
            const type = fields[key];
            if (typeof type === 'function') val = type.call(res, res);
            else val = type.decode(stream, res);
            if (val !== undefined) {
                if (val instanceof $d0Ff6.PropertyDescriptor) Object.defineProperty(res, key, val);
                else res[key] = val;
            }
            res._currentOffset = stream.pos - res._startOffset;
        }
    }
    size(val, parent, includePointers = true) {
        if (val == null) val = {};
        const ctx = {
            parent: parent,
            val: val,
            pointerSize: 0
        };
        if (this.preEncode != null) this.preEncode.call(val);
        let size = 0;
        for(let key in this.fields){
            const type = this.fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        for(let key in this.fields){
            type = this.fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
}

});

parcelRegister("gqRil", function(module, exports) {

$parcel$export(module.exports, "VersionedStruct", () => $bf686a5101131396$export$95a8b60f4da7dec8);

var $XqKmt = parcelRequire("XqKmt");
const $bf686a5101131396$var$getPath = (object, pathArray)=>{
    return pathArray.reduce((prevObj, key)=>prevObj && prevObj[key], object);
};
class $bf686a5101131396$export$95a8b60f4da7dec8 extends (0, $XqKmt.Struct) {
    constructor(type, versions = {}){
        super();
        this.type = type;
        this.versions = versions;
        if (typeof type === 'string') this.versionPath = type.split('.');
    }
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        if (typeof this.type === 'string') res.version = $bf686a5101131396$var$getPath(parent, this.versionPath);
        else res.version = this.type.decode(stream);
        if (this.versions.header) this._parseFields(stream, res, this.versions.header);
        const fields = this.versions[res.version];
        if (fields == null) throw new Error(`Unknown version ${res.version}`);
        if (fields instanceof $bf686a5101131396$export$95a8b60f4da7dec8) return fields.decode(stream, parent);
        this._parseFields(stream, res, fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    size(val, parent, includePointers = true) {
        let key, type;
        if (!val) throw new Error('Not a fixed size');
        if (this.preEncode != null) this.preEncode.call(val);
        const ctx = {
            parent: parent,
            val: val,
            pointerSize: 0
        };
        let size = 0;
        if (typeof this.type !== 'string') size += this.type.size(val.version, ctx);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        const fields = this.versions[val.version];
        if (fields == null) throw new Error(`Unknown version ${val.version}`);
        for(key in fields){
            type = fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let key, type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        if (typeof this.type !== 'string') this.type.encode(stream, val.version);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        const fields = this.versions[val.version];
        for(key in fields){
            type = fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
}

});

parcelRegister("erngl", function(module, exports) {

$parcel$export(module.exports, "Pointer", () => $a835a1cb0586c20c$export$b56007f12edf0c17);
$parcel$export(module.exports, "VoidPointer", () => $a835a1cb0586c20c$export$df5cb1f3d04f5a0f);

var $d0Ff6 = parcelRequire("d0Ff6");

var $6wP74 = parcelRequire("6wP74");
class $a835a1cb0586c20c$export$b56007f12edf0c17 extends (0, $6wP74.Base) {
    constructor(offsetType, type, options = {}){
        super();
        this.offsetType = offsetType;
        this.type = type;
        this.options = options;
        if (this.type === 'void') this.type = null;
        if (this.options.type == null) this.options.type = 'local';
        if (this.options.allowNull == null) this.options.allowNull = true;
        if (this.options.nullValue == null) this.options.nullValue = 0;
        if (this.options.lazy == null) this.options.lazy = false;
        if (this.options.relativeTo) {
            if (typeof this.options.relativeTo !== 'function') throw new Error('relativeTo option must be a function');
            this.relativeToGetter = options.relativeTo;
        }
    }
    decode(stream, ctx) {
        const offset = this.offsetType.decode(stream, ctx);
        // handle NULL pointers
        if (offset === this.options.nullValue && this.options.allowNull) return null;
        let relative;
        switch(this.options.type){
            case 'local':
                relative = ctx._startOffset;
                break;
            case 'immediate':
                relative = stream.pos - this.offsetType.size();
                break;
            case 'parent':
                relative = ctx.parent._startOffset;
                break;
            default:
                var c = ctx;
                while(c.parent)c = c.parent;
                relative = c._startOffset || 0;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
        const ptr = offset + relative;
        if (this.type != null) {
            let val = null;
            const decodeValue = ()=>{
                if (val != null) return val;
                const { pos: pos } = stream;
                stream.pos = ptr;
                val = this.type.decode(stream, ctx);
                stream.pos = pos;
                return val;
            };
            // If this is a lazy pointer, define a getter to decode only when needed.
            // This obviously only works when the pointer is contained by a Struct.
            if (this.options.lazy) return new $d0Ff6.PropertyDescriptor({
                get: decodeValue
            });
            return decodeValue();
        } else return ptr;
    }
    size(val, ctx) {
        const parent = ctx;
        switch(this.options.type){
            case 'local':
            case 'immediate':
                break;
            case 'parent':
                ctx = ctx.parent;
                break;
            default:
                while(ctx.parent)ctx = ctx.parent;
        }
        let { type: type } = this;
        if (type == null) {
            if (!(val instanceof $a835a1cb0586c20c$export$df5cb1f3d04f5a0f)) throw new Error("Must be a VoidPointer");
            ({ type: type } = val);
            val = val.value;
        }
        if (val && ctx) {
            // Must be written as two separate lines rather than += in case `type.size` mutates ctx.pointerSize.
            let size = type.size(val, parent);
            ctx.pointerSize += size;
        }
        return this.offsetType.size();
    }
    encode(stream, val, ctx) {
        let relative;
        const parent = ctx;
        if (val == null) {
            this.offsetType.encode(stream, this.options.nullValue);
            return;
        }
        switch(this.options.type){
            case 'local':
                relative = ctx.startOffset;
                break;
            case 'immediate':
                relative = stream.pos + this.offsetType.size(val, parent);
                break;
            case 'parent':
                ctx = ctx.parent;
                relative = ctx.startOffset;
                break;
            default:
                relative = 0;
                while(ctx.parent)ctx = ctx.parent;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
        this.offsetType.encode(stream, ctx.pointerOffset - relative);
        let { type: type } = this;
        if (type == null) {
            if (!(val instanceof $a835a1cb0586c20c$export$df5cb1f3d04f5a0f)) throw new Error("Must be a VoidPointer");
            ({ type: type } = val);
            val = val.value;
        }
        ctx.pointers.push({
            type: type,
            val: val,
            parent: parent
        });
        return ctx.pointerOffset += type.size(val, parent);
    }
}
class $a835a1cb0586c20c$export$df5cb1f3d04f5a0f {
    constructor(type, value){
        this.type = type;
        this.value = value;
    }
}

});


parcelRegister("4Bw9T", function(module, exports) {

$parcel$export(module.exports, "_", () => $97da4707ce14d34f$export$71511d61b312f219, (v) => $97da4707ce14d34f$export$71511d61b312f219 = v);
var $97da4707ce14d34f$export$71511d61b312f219;
"use strict";
function $97da4707ce14d34f$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$97da4707ce14d34f$export$71511d61b312f219 = $97da4707ce14d34f$var$_define_property;

});

parcelRegister("NqsVD", function(module, exports) {

$parcel$export(module.exports, "_", () => $f9fe8e9f0bb2d1a8$export$71511d61b312f219, (v) => $f9fe8e9f0bb2d1a8$export$71511d61b312f219 = v);
var $f9fe8e9f0bb2d1a8$export$71511d61b312f219;
"use strict";

$f9fe8e9f0bb2d1a8$export$71511d61b312f219 = (parcelRequire("7WQrb")).__decorate;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__decorate", () => $5c96a02c592fcff1$export$29e00dfd3077644b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});


parcelRegister("7hFx0", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("k9oO0", function(module, exports) {

$parcel$export(module.exports, "getCategory", () => $38e929d1b08c92d4$export$410364bbb673ddbc);
$parcel$export(module.exports, "getCombiningClass", () => $38e929d1b08c92d4$export$c03b919c6651ed55);
$parcel$export(module.exports, "getScript", () => $38e929d1b08c92d4$export$941569448d136665);
$parcel$export(module.exports, "isDigit", () => $38e929d1b08c92d4$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isMark", () => $38e929d1b08c92d4$export$e33ad6871e762338);

var $kuxul = parcelRequire("kuxul");

var $9daMG = parcelRequire("9daMG");
function $38e929d1b08c92d4$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $38e929d1b08c92d4$var$$f4087201da764553$exports = {};
$38e929d1b08c92d4$var$$f4087201da764553$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const $38e929d1b08c92d4$var$$747425b437e121da$var$trie = new (0, (/*@__PURE__*/$parcel$interopDefault($9daMG)))((0, (/*@__PURE__*/$parcel$interopDefault($kuxul))).toByteArray("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"));
const $38e929d1b08c92d4$var$$747425b437e121da$var$log2 = Math.log2 || ((n)=>Math.log(n) / Math.LN2);
const $38e929d1b08c92d4$var$$747425b437e121da$var$bits = (n)=>$38e929d1b08c92d4$var$$747425b437e121da$var$log2(n) + 1 | 0;
// compute the number of bits stored for each field
const $38e929d1b08c92d4$var$$747425b437e121da$var$CATEGORY_BITS = $38e929d1b08c92d4$var$$747425b437e121da$var$bits(/*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).categories.length - 1);
const $38e929d1b08c92d4$var$$747425b437e121da$var$COMBINING_BITS = $38e929d1b08c92d4$var$$747425b437e121da$var$bits(/*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).combiningClasses.length - 1);
const $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_BITS = $38e929d1b08c92d4$var$$747425b437e121da$var$bits(/*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).scripts.length - 1);
const $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_BITS = $38e929d1b08c92d4$var$$747425b437e121da$var$bits(/*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).eaw.length - 1);
const $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_BITS = 10;
// compute shift and mask values for each field
const $38e929d1b08c92d4$var$$747425b437e121da$var$CATEGORY_SHIFT = $38e929d1b08c92d4$var$$747425b437e121da$var$COMBINING_BITS + $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_BITS + $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_BITS + $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_BITS;
const $38e929d1b08c92d4$var$$747425b437e121da$var$COMBINING_SHIFT = $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_BITS + $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_BITS + $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_BITS;
const $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_SHIFT = $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_BITS + $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_BITS;
const $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_SHIFT = $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_BITS;
const $38e929d1b08c92d4$var$$747425b437e121da$var$CATEGORY_MASK = (1 << $38e929d1b08c92d4$var$$747425b437e121da$var$CATEGORY_BITS) - 1;
const $38e929d1b08c92d4$var$$747425b437e121da$var$COMBINING_MASK = (1 << $38e929d1b08c92d4$var$$747425b437e121da$var$COMBINING_BITS) - 1;
const $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_MASK = (1 << $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_BITS) - 1;
const $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_MASK = (1 << $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_BITS) - 1;
const $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_MASK = (1 << $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_BITS) - 1;
function $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint) {
    const val = $38e929d1b08c92d4$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).categories[val >> $38e929d1b08c92d4$var$$747425b437e121da$var$CATEGORY_SHIFT & $38e929d1b08c92d4$var$$747425b437e121da$var$CATEGORY_MASK];
}
function $38e929d1b08c92d4$export$c03b919c6651ed55(codePoint) {
    const val = $38e929d1b08c92d4$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).combiningClasses[val >> $38e929d1b08c92d4$var$$747425b437e121da$var$COMBINING_SHIFT & $38e929d1b08c92d4$var$$747425b437e121da$var$COMBINING_MASK];
}
function $38e929d1b08c92d4$export$941569448d136665(codePoint) {
    const val = $38e929d1b08c92d4$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).scripts[val >> $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_SHIFT & $38e929d1b08c92d4$var$$747425b437e121da$var$SCRIPT_MASK];
}
function $38e929d1b08c92d4$export$92f6187db8ca6d26(codePoint) {
    const val = $38e929d1b08c92d4$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $38e929d1b08c92d4$var$$parcel$interopDefault($38e929d1b08c92d4$var$$f4087201da764553$exports).eaw[val >> $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_SHIFT & $38e929d1b08c92d4$var$$747425b437e121da$var$EAW_MASK];
}
function $38e929d1b08c92d4$export$7d1258ebb7625a0d(codePoint) {
    let val = $38e929d1b08c92d4$var$$747425b437e121da$var$trie.get(codePoint);
    let num = val & $38e929d1b08c92d4$var$$747425b437e121da$var$NUMBER_MASK;
    if (num === 0) return null;
    else if (num <= 50) return num - 1;
    else if (num < 0x1e0) {
        const numerator = (num >> 4) - 12;
        const denominator = (num & 0xf) + 1;
        return numerator / denominator;
    } else if (num < 0x300) {
        val = (num >> 5) - 14;
        let exp = (num & 0x1f) + 2;
        while(exp > 0){
            val *= 10;
            exp--;
        }
        return val;
    } else {
        val = (num >> 2) - 0xbf;
        let exp = (num & 3) + 1;
        while(exp > 0){
            val *= 60;
            exp--;
        }
        return val;
    }
}
function $38e929d1b08c92d4$export$52c8ea63abd07594(codePoint) {
    const category = $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint);
    return category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Nl";
}
function $38e929d1b08c92d4$export$727d9dbc4fbb948f(codePoint) {
    return $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint) === "Nd";
}
function $38e929d1b08c92d4$export$a5b49f4dc6a07d2c(codePoint) {
    const category = $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint);
    return category === "Pc" || category === "Pd" || category === "Pe" || category === "Pf" || category === "Pi" || category === "Po" || category === "Ps";
}
function $38e929d1b08c92d4$export$7b6804e8df61fcf5(codePoint) {
    return $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint) === "Ll";
}
function $38e929d1b08c92d4$export$aebd617640818cda(codePoint) {
    return $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint) === "Lu";
}
function $38e929d1b08c92d4$export$de8b4ee23b2cf823(codePoint) {
    return $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint) === "Lt";
}
function $38e929d1b08c92d4$export$3c52dd84024ae72c(codePoint) {
    const category = $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint);
    return category === "Zs" || category === "Zl" || category === "Zp";
}
function $38e929d1b08c92d4$export$a11bdcffe109e74b(codePoint) {
    const category = $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint);
    return category === "Nd" || category === "No" || category === "Nl" || category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Me" || category === "Mc";
}
function $38e929d1b08c92d4$export$e33ad6871e762338(codePoint) {
    const category = $38e929d1b08c92d4$export$410364bbb673ddbc(codePoint);
    return category === "Mn" || category === "Me" || category === "Mc";
}
var $38e929d1b08c92d4$export$2e2bcd8739ae039 = {
    getCategory: $38e929d1b08c92d4$export$410364bbb673ddbc,
    getCombiningClass: $38e929d1b08c92d4$export$c03b919c6651ed55,
    getScript: $38e929d1b08c92d4$export$941569448d136665,
    getEastAsianWidth: $38e929d1b08c92d4$export$92f6187db8ca6d26,
    getNumericValue: $38e929d1b08c92d4$export$7d1258ebb7625a0d,
    isAlphabetic: $38e929d1b08c92d4$export$52c8ea63abd07594,
    isDigit: $38e929d1b08c92d4$export$727d9dbc4fbb948f,
    isPunctuation: $38e929d1b08c92d4$export$a5b49f4dc6a07d2c,
    isLowerCase: $38e929d1b08c92d4$export$7b6804e8df61fcf5,
    isUpperCase: $38e929d1b08c92d4$export$aebd617640818cda,
    isTitleCase: $38e929d1b08c92d4$export$de8b4ee23b2cf823,
    isWhiteSpace: $38e929d1b08c92d4$export$3c52dd84024ae72c,
    isBaseForm: $38e929d1b08c92d4$export$a11bdcffe109e74b,
    isMark: $38e929d1b08c92d4$export$e33ad6871e762338
};

});
parcelRegister("9daMG", function(module, exports) {

var $dHvIi = parcelRequire("dHvIi");

var $k8qkk = parcelRequire("k8qkk");
var $6b4db174c89ebdc9$require$swap32LE = $k8qkk.swap32LE;
// Shift size for getting the index-1 table offset.
const $6b4db174c89ebdc9$var$SHIFT_1 = 11;
// Shift size for getting the index-2 table offset.
const $6b4db174c89ebdc9$var$SHIFT_2 = 5;
// Difference between the two shift sizes,
// for getting an index-1 offset from an index-2 offset. 6=11-5
const $6b4db174c89ebdc9$var$SHIFT_1_2 = $6b4db174c89ebdc9$var$SHIFT_1 - $6b4db174c89ebdc9$var$SHIFT_2;
// Number of index-1 entries for the BMP. 32=0x20
// This part of the index-1 table is omitted from the serialized form.
const $6b4db174c89ebdc9$var$OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> $6b4db174c89ebdc9$var$SHIFT_1;
// Number of entries in an index-2 block. 64=0x40
const $6b4db174c89ebdc9$var$INDEX_2_BLOCK_LENGTH = 1 << $6b4db174c89ebdc9$var$SHIFT_1_2;
// Mask for getting the lower bits for the in-index-2-block offset. */
const $6b4db174c89ebdc9$var$INDEX_2_MASK = $6b4db174c89ebdc9$var$INDEX_2_BLOCK_LENGTH - 1;
// Shift size for shifting left the index array values.
// Increases possible data size with 16-bit index values at the cost
// of compactability.
// This requires data blocks to be aligned by DATA_GRANULARITY.
const $6b4db174c89ebdc9$var$INDEX_SHIFT = 2;
// Number of entries in a data block. 32=0x20
const $6b4db174c89ebdc9$var$DATA_BLOCK_LENGTH = 1 << $6b4db174c89ebdc9$var$SHIFT_2;
// Mask for getting the lower bits for the in-data-block offset.
const $6b4db174c89ebdc9$var$DATA_MASK = $6b4db174c89ebdc9$var$DATA_BLOCK_LENGTH - 1;
// The part of the index-2 table for U+D800..U+DBFF stores values for
// lead surrogate code _units_ not code _points_.
// Values for lead surrogate code _points_ are indexed with this portion of the table.
// Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
const $6b4db174c89ebdc9$var$LSCP_INDEX_2_OFFSET = 0x10000 >> $6b4db174c89ebdc9$var$SHIFT_2;
const $6b4db174c89ebdc9$var$LSCP_INDEX_2_LENGTH = 0x400 >> $6b4db174c89ebdc9$var$SHIFT_2;
// Count the lengths of both BMP pieces. 2080=0x820
const $6b4db174c89ebdc9$var$INDEX_2_BMP_LENGTH = $6b4db174c89ebdc9$var$LSCP_INDEX_2_OFFSET + $6b4db174c89ebdc9$var$LSCP_INDEX_2_LENGTH;
// The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
// Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
const $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_OFFSET = $6b4db174c89ebdc9$var$INDEX_2_BMP_LENGTH;
const $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_LENGTH = 32; // U+0800 is the first code point after 2-byte UTF-8
// The index-1 table, only used for supplementary code points, at offset 2112=0x840.
// Variable length, for code points up to highStart, where the last single-value range starts.
// Maximum length 512=0x200=0x100000>>SHIFT_1.
// (For 0x100000 supplementary code points U+10000..U+10ffff.)
//
// The part of the index-2 table for supplementary code points starts
// after this index-1 table.
//
// Both the index-1 table and the following part of the index-2 table
// are omitted completely if there is only BMP data.
const $6b4db174c89ebdc9$var$INDEX_1_OFFSET = $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_OFFSET + $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_LENGTH;
// The alignment size of a data block. Also the granularity for compaction.
const $6b4db174c89ebdc9$var$DATA_GRANULARITY = 1 << $6b4db174c89ebdc9$var$INDEX_SHIFT;
class $6b4db174c89ebdc9$var$UnicodeTrie {
    constructor(data){
        const isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
        if (isBuffer || data instanceof Uint8Array) {
            // read binary format
            let uncompressedLength;
            if (isBuffer) {
                this.highStart = data.readUInt32LE(0);
                this.errorValue = data.readUInt32LE(4);
                uncompressedLength = data.readUInt32LE(8);
                data = data.slice(12);
            } else {
                const view = new DataView(data.buffer);
                this.highStart = view.getUint32(0, true);
                this.errorValue = view.getUint32(4, true);
                uncompressedLength = view.getUint32(8, true);
                data = data.subarray(12);
            }
            // double inflate the actual trie data
            data = $dHvIi(data, new Uint8Array(uncompressedLength));
            data = $dHvIi(data, new Uint8Array(uncompressedLength));
            // swap bytes from little-endian
            $6b4db174c89ebdc9$require$swap32LE(data);
            this.data = new Uint32Array(data.buffer);
        } else // pre-parsed data
        ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data);
    }
    get(codePoint) {
        let index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            // Ordinary BMP code point, excluding leading surrogates.
            // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
            // data is stored in the index array itself.
            index = (this.data[codePoint >> $6b4db174c89ebdc9$var$SHIFT_2] << $6b4db174c89ebdc9$var$INDEX_SHIFT) + (codePoint & $6b4db174c89ebdc9$var$DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            // Lead Surrogate Code Point.  A Separate index section is stored for
            // lead surrogate code units and code points.
            //   The main index has the code unit data.
            //   For this function, we need the code point data.
            index = (this.data[$6b4db174c89ebdc9$var$LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> $6b4db174c89ebdc9$var$SHIFT_2)] << $6b4db174c89ebdc9$var$INDEX_SHIFT) + (codePoint & $6b4db174c89ebdc9$var$DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            // Supplemental code point, use two-level lookup.
            index = this.data[$6b4db174c89ebdc9$var$INDEX_1_OFFSET - $6b4db174c89ebdc9$var$OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> $6b4db174c89ebdc9$var$SHIFT_1)];
            index = this.data[index + (codePoint >> $6b4db174c89ebdc9$var$SHIFT_2 & $6b4db174c89ebdc9$var$INDEX_2_MASK)];
            index = (index << $6b4db174c89ebdc9$var$INDEX_SHIFT) + (codePoint & $6b4db174c89ebdc9$var$DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - $6b4db174c89ebdc9$var$DATA_GRANULARITY];
    }
}
module.exports = $6b4db174c89ebdc9$var$UnicodeTrie;

});
parcelRegister("dHvIi", function(module, exports) {
var $9f97e41f2448bce6$var$TINF_OK = 0;
var $9f97e41f2448bce6$var$TINF_DATA_ERROR = -3;
function $9f97e41f2448bce6$var$Tree() {
    this.table = new Uint16Array(16); /* table of code length counts */ 
    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
}
function $9f97e41f2448bce6$var$Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new $9f97e41f2448bce6$var$Tree(); /* dynamic length/symbol tree */ 
    this.dtree = new $9f97e41f2448bce6$var$Tree(); /* dynamic distance tree */ 
}
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var $9f97e41f2448bce6$var$sltree = new $9f97e41f2448bce6$var$Tree();
var $9f97e41f2448bce6$var$sdtree = new $9f97e41f2448bce6$var$Tree();
/* extra bits and base tables for length codes */ var $9f97e41f2448bce6$var$length_bits = new Uint8Array(30);
var $9f97e41f2448bce6$var$length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var $9f97e41f2448bce6$var$dist_bits = new Uint8Array(30);
var $9f97e41f2448bce6$var$dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var $9f97e41f2448bce6$var$clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var $9f97e41f2448bce6$var$code_tree = new $9f97e41f2448bce6$var$Tree();
var $9f97e41f2448bce6$var$lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function $9f97e41f2448bce6$var$tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function $9f97e41f2448bce6$var$tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var $9f97e41f2448bce6$var$offs = new Uint16Array(16);
function $9f97e41f2448bce6$var$tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        $9f97e41f2448bce6$var$offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[$9f97e41f2448bce6$var$offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function $9f97e41f2448bce6$var$tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function $9f97e41f2448bce6$var$tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function $9f97e41f2448bce6$var$tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function $9f97e41f2448bce6$var$tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = $9f97e41f2448bce6$var$tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = $9f97e41f2448bce6$var$tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = $9f97e41f2448bce6$var$tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)$9f97e41f2448bce6$var$lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = $9f97e41f2448bce6$var$tinf_read_bits(d, 3, 0);
        $9f97e41f2448bce6$var$lengths[$9f97e41f2448bce6$var$clcidx[i]] = clen;
    }
    /* build code length tree */ $9f97e41f2448bce6$var$tinf_build_tree($9f97e41f2448bce6$var$code_tree, $9f97e41f2448bce6$var$lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = $9f97e41f2448bce6$var$tinf_decode_symbol(d, $9f97e41f2448bce6$var$code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = $9f97e41f2448bce6$var$lengths[num - 1];
                for(length = $9f97e41f2448bce6$var$tinf_read_bits(d, 2, 3); length; --length)$9f97e41f2448bce6$var$lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = $9f97e41f2448bce6$var$tinf_read_bits(d, 3, 3); length; --length)$9f97e41f2448bce6$var$lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = $9f97e41f2448bce6$var$tinf_read_bits(d, 7, 11); length; --length)$9f97e41f2448bce6$var$lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ $9f97e41f2448bce6$var$lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ $9f97e41f2448bce6$var$tinf_build_tree(lt, $9f97e41f2448bce6$var$lengths, 0, hlit);
    $9f97e41f2448bce6$var$tinf_build_tree(dt, $9f97e41f2448bce6$var$lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function $9f97e41f2448bce6$var$tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = $9f97e41f2448bce6$var$tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return $9f97e41f2448bce6$var$TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = $9f97e41f2448bce6$var$tinf_read_bits(d, $9f97e41f2448bce6$var$length_bits[sym], $9f97e41f2448bce6$var$length_base[sym]);
            dist = $9f97e41f2448bce6$var$tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - $9f97e41f2448bce6$var$tinf_read_bits(d, $9f97e41f2448bce6$var$dist_bits[dist], $9f97e41f2448bce6$var$dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function $9f97e41f2448bce6$var$tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return $9f97e41f2448bce6$var$TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return $9f97e41f2448bce6$var$TINF_OK;
}
/* inflate stream from source to dest */ function $9f97e41f2448bce6$var$tinf_uncompress(source, dest) {
    var d = new $9f97e41f2448bce6$var$Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = $9f97e41f2448bce6$var$tinf_getbit(d);
        /* read block type (2 bits) */ btype = $9f97e41f2448bce6$var$tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = $9f97e41f2448bce6$var$tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = $9f97e41f2448bce6$var$tinf_inflate_block_data(d, $9f97e41f2448bce6$var$sltree, $9f97e41f2448bce6$var$sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ $9f97e41f2448bce6$var$tinf_decode_trees(d, d.ltree, d.dtree);
                res = $9f97e41f2448bce6$var$tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = $9f97e41f2448bce6$var$TINF_DATA_ERROR;
        }
        if (res !== $9f97e41f2448bce6$var$TINF_OK) throw new Error('Data error');
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ $9f97e41f2448bce6$var$tinf_build_fixed_trees($9f97e41f2448bce6$var$sltree, $9f97e41f2448bce6$var$sdtree);
/* build extra bits and base tables */ $9f97e41f2448bce6$var$tinf_build_bits_base($9f97e41f2448bce6$var$length_bits, $9f97e41f2448bce6$var$length_base, 4, 3);
$9f97e41f2448bce6$var$tinf_build_bits_base($9f97e41f2448bce6$var$dist_bits, $9f97e41f2448bce6$var$dist_base, 2, 1);
/* fix a special case */ $9f97e41f2448bce6$var$length_bits[28] = 0;
$9f97e41f2448bce6$var$length_base[28] = 258;
module.exports = $9f97e41f2448bce6$var$tinf_uncompress;

});

parcelRegister("k8qkk", function(module, exports) {
const $03c86720e418ebc3$var$isBigEndian = new Uint8Array(new Uint32Array([
    0x12345678
]).buffer)[0] === 0x12;
const $03c86720e418ebc3$var$swap = (b, n, m)=>{
    let i = b[n];
    b[n] = b[m];
    b[m] = i;
};
const $03c86720e418ebc3$var$swap32 = (array)=>{
    const len = array.length;
    for(let i = 0; i < len; i += 4){
        $03c86720e418ebc3$var$swap(array, i, i + 3);
        $03c86720e418ebc3$var$swap(array, i + 1, i + 2);
    }
};
const $03c86720e418ebc3$var$swap32LE = (array)=>{
    if ($03c86720e418ebc3$var$isBigEndian) $03c86720e418ebc3$var$swap32(array);
};
module.exports = {
    swap32LE: $03c86720e418ebc3$var$swap32LE
};

});



parcelRegister("fLo3N", function(module, exports) {
'use strict';
var $b79de8adb8c1e088$var$INITIAL_STATE = 1;
var $b79de8adb8c1e088$var$FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ class $b79de8adb8c1e088$var$StateMachine {
    constructor(dfa){
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
    }
    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ match(str) {
        var self = this;
        return {
            *[Symbol.iterator] () {
                var state = $b79de8adb8c1e088$var$INITIAL_STATE;
                var startRun = null;
                var lastAccepting = null;
                var lastState = null;
                for(var p = 0; p < str.length; p++){
                    var c = str[p];
                    lastState = state;
                    state = self.stateTable[state][c];
                    if (state === $b79de8adb8c1e088$var$FAIL_STATE) {
                        // yield the last match if any
                        if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                            startRun,
                            lastAccepting,
                            self.tags[lastState]
                        ];
                         // reset the state as if we started over from the initial state
                        state = self.stateTable[$b79de8adb8c1e088$var$INITIAL_STATE][c];
                        startRun = null;
                    } // start a run if not in the failure state
                    if (state !== $b79de8adb8c1e088$var$FAIL_STATE && startRun == null) startRun = p;
                     // if accepting, mark the potential match end
                    if (self.accepting[state]) lastAccepting = p;
                     // reset the state to the initial state if we get into the failure state
                    if (state === $b79de8adb8c1e088$var$FAIL_STATE) state = $b79de8adb8c1e088$var$INITIAL_STATE;
                } // yield the last match if any
                if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                    startRun,
                    lastAccepting,
                    self.tags[state]
                ];
            }
        };
    }
    /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */ apply(str, actions) {
        for (var [start, end, tags] of this.match(str)){
            for (var tag of tags)if (typeof actions[tag] === 'function') actions[tag](start, end, str.slice(start, end + 1));
        }
    }
}
module.exports = $b79de8adb8c1e088$var$StateMachine;

});

parcelRegister("8kDCz", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $610eece7e795b354$require$Buffer = $6ZWSX.Buffer;
var $610eece7e795b354$var$clone = function() {
    'use strict';
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof $610eece7e795b354$require$Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && $610eece7e795b354$require$Buffer.isBuffer(parent)) {
                if ($610eece7e795b354$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = $610eece7e795b354$require$Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new $610eece7e795b354$require$Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (module.exports) module.exports = $610eece7e795b354$var$clone;

});

parcelRegister("j8d6B", function(module, exports) {

module.exports = (parcelRequire("ktvS8")).BrotliDecompressBuffer;

});
parcelRegister("ktvS8", function(module, exports) {

$parcel$export(module.exports, "BrotliDecompressBuffer", () => $ee7f3d40128f729f$export$9840689580eff2f0, (v) => $ee7f3d40128f729f$export$9840689580eff2f0 = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var $ee7f3d40128f729f$export$fa64f32e2d0558a1;
var $ee7f3d40128f729f$export$9840689580eff2f0;
var $ee7f3d40128f729f$export$59cbf0b8eef2df1e;

var $j5sEj = parcelRequire("j5sEj");
var $ee7f3d40128f729f$require$BrotliInput = $j5sEj.BrotliInput;

var $j5sEj = parcelRequire("j5sEj");
var $ee7f3d40128f729f$require$BrotliOutput = $j5sEj.BrotliOutput;

var $8JSYM = parcelRequire("8JSYM");

var $fo1rr = parcelRequire("fo1rr");

var $kls9x = parcelRequire("kls9x");
var $ee7f3d40128f729f$require$HuffmanCode = $kls9x.HuffmanCode;

var $kls9x = parcelRequire("kls9x");
var $ee7f3d40128f729f$require$BrotliBuildHuffmanTable = $kls9x.BrotliBuildHuffmanTable;

var $hX8C6 = parcelRequire("hX8C6");

var $7aaiK = parcelRequire("7aaiK");

var $4zIc9 = parcelRequire("4zIc9");
var $ee7f3d40128f729f$var$kDefaultCodeLength = 8;
var $ee7f3d40128f729f$var$kCodeLengthRepeatCode = 16;
var $ee7f3d40128f729f$var$kNumLiteralCodes = 256;
var $ee7f3d40128f729f$var$kNumInsertAndCopyCodes = 704;
var $ee7f3d40128f729f$var$kNumBlockLengthCodes = 26;
var $ee7f3d40128f729f$var$kLiteralContextBits = 6;
var $ee7f3d40128f729f$var$kDistanceContextBits = 2;
var $ee7f3d40128f729f$var$HUFFMAN_TABLE_BITS = 8;
var $ee7f3d40128f729f$var$HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE = 1080;
var $ee7f3d40128f729f$var$CODE_LENGTH_CODES = 18;
var $ee7f3d40128f729f$var$kCodeLengthCodeOrder = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
]);
var $ee7f3d40128f729f$var$NUM_DISTANCE_SHORT_CODES = 16;
var $ee7f3d40128f729f$var$kDistanceShortCodeIndexOffset = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
]);
var $ee7f3d40128f729f$var$kDistanceShortCodeValueOffset = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
]);
var $ee7f3d40128f729f$var$kMaxHuffmanTableSize = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
]);
function $ee7f3d40128f729f$var$DecodeWindowBits(br) {
    var n;
    if (br.readBits(1) === 0) return 16;
    n = br.readBits(3);
    if (n > 0) return 17 + n;
    n = br.readBits(3);
    if (n > 0) return 8 + n;
    return 17;
}
/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function $ee7f3d40128f729f$var$DecodeVarLenUint8(br) {
    if (br.readBits(1)) {
        var nbits = br.readBits(3);
        if (nbits === 0) return 1;
        else return br.readBits(nbits) + (1 << nbits);
    }
    return 0;
}
function $ee7f3d40128f729f$var$MetaBlockLength() {
    this.meta_block_length = 0;
    this.input_end = 0;
    this.is_uncompressed = 0;
    this.is_metadata = false;
}
function $ee7f3d40128f729f$var$DecodeMetaBlockLength(br) {
    var out = new $ee7f3d40128f729f$var$MetaBlockLength;
    var size_nibbles;
    var size_bytes;
    var i;
    out.input_end = br.readBits(1);
    if (out.input_end && br.readBits(1)) return out;
    size_nibbles = br.readBits(2) + 4;
    if (size_nibbles === 7) {
        out.is_metadata = true;
        if (br.readBits(1) !== 0) throw new Error('Invalid reserved bit');
        size_bytes = br.readBits(2);
        if (size_bytes === 0) return out;
        for(i = 0; i < size_bytes; i++){
            var next_byte = br.readBits(8);
            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error('Invalid size byte');
            out.meta_block_length |= next_byte << i * 8;
        }
    } else for(i = 0; i < size_nibbles; ++i){
        var next_nibble = br.readBits(4);
        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error('Invalid size nibble');
        out.meta_block_length |= next_nibble << i * 4;
    }
    ++out.meta_block_length;
    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
    return out;
}
/* Decodes the next Huffman code from bit-stream. */ function $ee7f3d40128f729f$var$ReadSymbol(table, index, br) {
    var start_index = index;
    var nbits;
    br.fillBitWindow();
    index += br.val_ >>> br.bit_pos_ & $ee7f3d40128f729f$var$HUFFMAN_TABLE_MASK;
    nbits = table[index].bits - $ee7f3d40128f729f$var$HUFFMAN_TABLE_BITS;
    if (nbits > 0) {
        br.bit_pos_ += $ee7f3d40128f729f$var$HUFFMAN_TABLE_BITS;
        index += table[index].value;
        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
    }
    br.bit_pos_ += table[index].bits;
    return table[index].value;
}
function $ee7f3d40128f729f$var$ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
    var symbol = 0;
    var prev_code_len = $ee7f3d40128f729f$var$kDefaultCodeLength;
    var repeat = 0;
    var repeat_code_len = 0;
    var space = 32768;
    var table = [];
    for(var i = 0; i < 32; i++)table.push(new $ee7f3d40128f729f$require$HuffmanCode(0, 0));
    $ee7f3d40128f729f$require$BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, $ee7f3d40128f729f$var$CODE_LENGTH_CODES);
    while(symbol < num_symbols && space > 0){
        var p = 0;
        var code_len;
        br.readMoreInput();
        br.fillBitWindow();
        p += br.val_ >>> br.bit_pos_ & 31;
        br.bit_pos_ += table[p].bits;
        code_len = table[p].value & 0xff;
        if (code_len < $ee7f3d40128f729f$var$kCodeLengthRepeatCode) {
            repeat = 0;
            code_lengths[symbol++] = code_len;
            if (code_len !== 0) {
                prev_code_len = code_len;
                space -= 32768 >> code_len;
            }
        } else {
            var extra_bits = code_len - 14;
            var old_repeat;
            var repeat_delta;
            var new_len = 0;
            if (code_len === $ee7f3d40128f729f$var$kCodeLengthRepeatCode) new_len = prev_code_len;
            if (repeat_code_len !== new_len) {
                repeat = 0;
                repeat_code_len = new_len;
            }
            old_repeat = repeat;
            if (repeat > 0) {
                repeat -= 2;
                repeat <<= extra_bits;
            }
            repeat += br.readBits(extra_bits) + 3;
            repeat_delta = repeat - old_repeat;
            if (symbol + repeat_delta > num_symbols) throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
            symbol += repeat_delta;
            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
        }
    }
    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
}
function $ee7f3d40128f729f$var$ReadHuffmanCode(alphabet_size, tables, table, br) {
    var table_size = 0;
    var simple_code_or_skip;
    var code_lengths = new Uint8Array(alphabet_size);
    br.readMoreInput();
    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
    if (simple_code_or_skip === 1) {
        /* Read symbols, codes & code lengths directly. */ var i;
        var max_bits_counter = alphabet_size - 1;
        var max_bits = 0;
        var symbols = new Int32Array(4);
        var num_symbols = br.readBits(2) + 1;
        while(max_bits_counter){
            max_bits_counter >>= 1;
            ++max_bits;
        }
        for(i = 0; i < num_symbols; ++i){
            symbols[i] = br.readBits(max_bits) % alphabet_size;
            code_lengths[symbols[i]] = 2;
        }
        code_lengths[symbols[0]] = 1;
        switch(num_symbols){
            case 1:
                break;
            case 3:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error('[ReadHuffmanCode] invalid symbols');
                break;
            case 2:
                if (symbols[0] === symbols[1]) throw new Error('[ReadHuffmanCode] invalid symbols');
                code_lengths[symbols[1]] = 1;
                break;
            case 4:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error('[ReadHuffmanCode] invalid symbols');
                if (br.readBits(1)) {
                    code_lengths[symbols[2]] = 3;
                    code_lengths[symbols[3]] = 3;
                } else code_lengths[symbols[0]] = 2;
                break;
        }
    } else {
        var i;
        var code_length_code_lengths = new Uint8Array($ee7f3d40128f729f$var$CODE_LENGTH_CODES);
        var space = 32;
        var num_codes = 0;
        /* Static Huffman code for the code length code lengths */ var huff = [
            new $ee7f3d40128f729f$require$HuffmanCode(2, 0),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 4),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 3),
            new $ee7f3d40128f729f$require$HuffmanCode(3, 2),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 0),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 4),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 3),
            new $ee7f3d40128f729f$require$HuffmanCode(4, 1),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 0),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 4),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 3),
            new $ee7f3d40128f729f$require$HuffmanCode(3, 2),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 0),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 4),
            new $ee7f3d40128f729f$require$HuffmanCode(2, 3),
            new $ee7f3d40128f729f$require$HuffmanCode(4, 5)
        ];
        for(i = simple_code_or_skip; i < $ee7f3d40128f729f$var$CODE_LENGTH_CODES && space > 0; ++i){
            var code_len_idx = $ee7f3d40128f729f$var$kCodeLengthCodeOrder[i];
            var p = 0;
            var v;
            br.fillBitWindow();
            p += br.val_ >>> br.bit_pos_ & 15;
            br.bit_pos_ += huff[p].bits;
            v = huff[p].value;
            code_length_code_lengths[code_len_idx] = v;
            if (v !== 0) {
                space -= 32 >> v;
                ++num_codes;
            }
        }
        if (!(num_codes === 1 || space === 0)) throw new Error('[ReadHuffmanCode] invalid num_codes or space');
        $ee7f3d40128f729f$var$ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
    }
    table_size = $ee7f3d40128f729f$require$BrotliBuildHuffmanTable(tables, table, $ee7f3d40128f729f$var$HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return table_size;
}
function $ee7f3d40128f729f$var$ReadBlockLength(table, index, br) {
    var code;
    var nbits;
    code = $ee7f3d40128f729f$var$ReadSymbol(table, index, br);
    nbits = $7aaiK.kBlockLengthPrefixCode[code].nbits;
    return $7aaiK.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}
function $ee7f3d40128f729f$var$TranslateShortCodes(code, ringbuffer, index) {
    var val;
    if (code < $ee7f3d40128f729f$var$NUM_DISTANCE_SHORT_CODES) {
        index += $ee7f3d40128f729f$var$kDistanceShortCodeIndexOffset[code];
        index &= 3;
        val = ringbuffer[index] + $ee7f3d40128f729f$var$kDistanceShortCodeValueOffset[code];
    } else val = code - $ee7f3d40128f729f$var$NUM_DISTANCE_SHORT_CODES + 1;
    return val;
}
function $ee7f3d40128f729f$var$MoveToFront(v, index) {
    var value = v[index];
    var i = index;
    for(; i; --i)v[i] = v[i - 1];
    v[0] = value;
}
function $ee7f3d40128f729f$var$InverseMoveToFrontTransform(v, v_len) {
    var mtf = new Uint8Array(256);
    var i;
    for(i = 0; i < 256; ++i)mtf[i] = i;
    for(i = 0; i < v_len; ++i){
        var index = v[i];
        v[i] = mtf[index];
        if (index) $ee7f3d40128f729f$var$MoveToFront(mtf, index);
    }
}
/* Contains a collection of huffman trees with the same alphabet size. */ function $ee7f3d40128f729f$var$HuffmanTreeGroup(alphabet_size, num_htrees) {
    this.alphabet_size = alphabet_size;
    this.num_htrees = num_htrees;
    this.codes = new Array(num_htrees + num_htrees * $ee7f3d40128f729f$var$kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
    this.htrees = new Uint32Array(num_htrees);
}
$ee7f3d40128f729f$var$HuffmanTreeGroup.prototype.decode = function(br) {
    var i;
    var table_size;
    var next = 0;
    for(i = 0; i < this.num_htrees; ++i){
        this.htrees[i] = next;
        table_size = $ee7f3d40128f729f$var$ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
        next += table_size;
    }
};
function $ee7f3d40128f729f$var$DecodeContextMap(context_map_size, br) {
    var out = {
        num_htrees: null,
        context_map: null
    };
    var use_rle_for_zeros;
    var max_run_length_prefix = 0;
    var table;
    var i;
    br.readMoreInput();
    var num_htrees = out.num_htrees = $ee7f3d40128f729f$var$DecodeVarLenUint8(br) + 1;
    var context_map = out.context_map = new Uint8Array(context_map_size);
    if (num_htrees <= 1) return out;
    use_rle_for_zeros = br.readBits(1);
    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
    table = [];
    for(i = 0; i < $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new $ee7f3d40128f729f$require$HuffmanCode(0, 0);
    $ee7f3d40128f729f$var$ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
    for(i = 0; i < context_map_size;){
        var code;
        br.readMoreInput();
        code = $ee7f3d40128f729f$var$ReadSymbol(table, 0, br);
        if (code === 0) {
            context_map[i] = 0;
            ++i;
        } else if (code <= max_run_length_prefix) {
            var reps = 1 + (1 << code) + br.readBits(code);
            while(--reps){
                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                context_map[i] = 0;
                ++i;
            }
        } else {
            context_map[i] = code - max_run_length_prefix;
            ++i;
        }
    }
    if (br.readBits(1)) $ee7f3d40128f729f$var$InverseMoveToFrontTransform(context_map, context_map_size);
    return out;
}
function $ee7f3d40128f729f$var$DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
    var ringbuffer = tree_type * 2;
    var index = tree_type;
    var type_code = $ee7f3d40128f729f$var$ReadSymbol(trees, tree_type * $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE, br);
    var block_type;
    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
    else block_type = type_code - 2;
    if (block_type >= max_block_type) block_type -= max_block_type;
    block_types[tree_type] = block_type;
    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
    ++indexes[index];
}
function $ee7f3d40128f729f$var$CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
    var rb_size = ringbuffer_mask + 1;
    var rb_pos = pos & ringbuffer_mask;
    var br_pos = br.pos_ & $8JSYM.IBUF_MASK;
    var nbytes;
    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
        while(len-- > 0){
            br.readMoreInput();
            ringbuffer[rb_pos++] = br.readBits(8);
            if (rb_pos === rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos = 0;
            }
        }
        return;
    }
    if (br.bit_end_pos_ < 32) throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
        br.bit_pos_ += 8;
        ++rb_pos;
        --len;
    }
    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
    if (br_pos + nbytes > $8JSYM.IBUF_MASK) {
        var tail = $8JSYM.IBUF_MASK + 1 - br_pos;
        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
        nbytes -= tail;
        rb_pos += tail;
        len -= tail;
        br_pos = 0;
    }
    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    rb_pos += nbytes;
    len -= nbytes;
    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos -= rb_size;
        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
    }
    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
        nbytes = rb_size - rb_pos;
        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
        output.write(ringbuffer, rb_size);
        len -= nbytes;
        rb_pos = 0;
    }
    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
    /* Restore the state of the bit reader. */ br.reset();
}
/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function $ee7f3d40128f729f$var$JumpToByteBoundary(br) {
    var new_bit_pos = br.bit_pos_ + 7 & -8;
    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
    return pad_bits == 0;
}
function $ee7f3d40128f729f$var$BrotliDecompressedSize(buffer) {
    var input = new $ee7f3d40128f729f$require$BrotliInput(buffer);
    var br = new $8JSYM(input);
    $ee7f3d40128f729f$var$DecodeWindowBits(br);
    var out = $ee7f3d40128f729f$var$DecodeMetaBlockLength(br);
    return out.meta_block_length;
}
$ee7f3d40128f729f$export$fa64f32e2d0558a1 = $ee7f3d40128f729f$var$BrotliDecompressedSize;
function $ee7f3d40128f729f$var$BrotliDecompressBuffer(buffer, output_size) {
    var input = new $ee7f3d40128f729f$require$BrotliInput(buffer);
    if (output_size == null) output_size = $ee7f3d40128f729f$var$BrotliDecompressedSize(buffer);
    var output_buffer = new Uint8Array(output_size);
    var output = new $ee7f3d40128f729f$require$BrotliOutput(output_buffer);
    $ee7f3d40128f729f$var$BrotliDecompress(input, output);
    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
    return output.buffer;
}
$ee7f3d40128f729f$export$9840689580eff2f0 = $ee7f3d40128f729f$var$BrotliDecompressBuffer;
function $ee7f3d40128f729f$var$BrotliDecompress(input, output) {
    var i;
    var pos = 0;
    var input_end = 0;
    var window_bits = 0;
    var max_backward_distance;
    var max_distance = 0;
    var ringbuffer_size;
    var ringbuffer_mask;
    var ringbuffer;
    var ringbuffer_end;
    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
        16,
        15,
        11,
        4
    ];
    var dist_rb_idx = 0;
    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
    var prev_byte2 = 0;
    var hgroup = [
        new $ee7f3d40128f729f$var$HuffmanTreeGroup(0, 0),
        new $ee7f3d40128f729f$var$HuffmanTreeGroup(0, 0),
        new $ee7f3d40128f729f$var$HuffmanTreeGroup(0, 0)
    ];
    var block_type_trees;
    var block_len_trees;
    var br;
    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + $8JSYM.READ_SIZE;
    br = new $8JSYM(input);
    /* Decode window size. */ window_bits = $ee7f3d40128f729f$var$DecodeWindowBits(br);
    max_backward_distance = (1 << window_bits) - 16;
    ringbuffer_size = 1 << window_bits;
    ringbuffer_mask = ringbuffer_size - 1;
    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + $fo1rr.maxDictionaryWordLength);
    ringbuffer_end = ringbuffer_size;
    block_type_trees = [];
    block_len_trees = [];
    for(var x = 0; x < 3 * $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE; x++){
        block_type_trees[x] = new $ee7f3d40128f729f$require$HuffmanCode(0, 0);
        block_len_trees[x] = new $ee7f3d40128f729f$require$HuffmanCode(0, 0);
    }
    while(!input_end){
        var meta_block_remaining_len = 0;
        var is_uncompressed;
        var block_length = [
            268435456,
            268435456,
            268435456
        ];
        var block_type = [
            0
        ];
        var num_block_types = [
            1,
            1,
            1
        ];
        var block_type_rb = [
            0,
            1,
            0,
            1,
            0,
            1
        ];
        var block_type_rb_index = [
            0
        ];
        var distance_postfix_bits;
        var num_direct_distance_codes;
        var distance_postfix_mask;
        var num_distance_codes;
        var context_map = null;
        var context_modes = null;
        var num_literal_htrees;
        var dist_context_map = null;
        var num_dist_htrees;
        var context_offset = 0;
        var context_map_slice = null;
        var literal_htree_index = 0;
        var dist_context_offset = 0;
        var dist_context_map_slice = null;
        var dist_htree_index = 0;
        var context_lookup_offset1 = 0;
        var context_lookup_offset2 = 0;
        var context_mode;
        var htree_command;
        for(i = 0; i < 3; ++i){
            hgroup[i].codes = null;
            hgroup[i].htrees = null;
        }
        br.readMoreInput();
        var _out = $ee7f3d40128f729f$var$DecodeMetaBlockLength(br);
        meta_block_remaining_len = _out.meta_block_length;
        if (pos + meta_block_remaining_len > output.buffer.length) {
            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
            tmp.set(output.buffer);
            output.buffer = tmp;
        }
        input_end = _out.input_end;
        is_uncompressed = _out.is_uncompressed;
        if (_out.is_metadata) {
            $ee7f3d40128f729f$var$JumpToByteBoundary(br);
            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                br.readMoreInput();
                /* Read one byte and ignore it. */ br.readBits(8);
            }
            continue;
        }
        if (meta_block_remaining_len === 0) continue;
        if (is_uncompressed) {
            br.bit_pos_ = br.bit_pos_ + 7 & -8;
            $ee7f3d40128f729f$var$CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
            pos += meta_block_remaining_len;
            continue;
        }
        for(i = 0; i < 3; ++i){
            num_block_types[i] = $ee7f3d40128f729f$var$DecodeVarLenUint8(br) + 1;
            if (num_block_types[i] >= 2) {
                $ee7f3d40128f729f$var$ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE, br);
                $ee7f3d40128f729f$var$ReadHuffmanCode($ee7f3d40128f729f$var$kNumBlockLengthCodes, block_len_trees, i * $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_length[i] = $ee7f3d40128f729f$var$ReadBlockLength(block_len_trees, i * $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_type_rb_index[i] = 1;
            }
        }
        br.readMoreInput();
        distance_postfix_bits = br.readBits(2);
        num_direct_distance_codes = $ee7f3d40128f729f$var$NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
        context_modes = new Uint8Array(num_block_types[0]);
        for(i = 0; i < num_block_types[0]; ++i){
            br.readMoreInput();
            context_modes[i] = br.readBits(2) << 1;
        }
        var _o1 = $ee7f3d40128f729f$var$DecodeContextMap(num_block_types[0] << $ee7f3d40128f729f$var$kLiteralContextBits, br);
        num_literal_htrees = _o1.num_htrees;
        context_map = _o1.context_map;
        var _o2 = $ee7f3d40128f729f$var$DecodeContextMap(num_block_types[2] << $ee7f3d40128f729f$var$kDistanceContextBits, br);
        num_dist_htrees = _o2.num_htrees;
        dist_context_map = _o2.context_map;
        hgroup[0] = new $ee7f3d40128f729f$var$HuffmanTreeGroup($ee7f3d40128f729f$var$kNumLiteralCodes, num_literal_htrees);
        hgroup[1] = new $ee7f3d40128f729f$var$HuffmanTreeGroup($ee7f3d40128f729f$var$kNumInsertAndCopyCodes, num_block_types[1]);
        hgroup[2] = new $ee7f3d40128f729f$var$HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
        context_map_slice = 0;
        dist_context_map_slice = 0;
        context_mode = context_modes[block_type[0]];
        context_lookup_offset1 = $hX8C6.lookupOffsets[context_mode];
        context_lookup_offset2 = $hX8C6.lookupOffsets[context_mode + 1];
        htree_command = hgroup[1].htrees[0];
        while(meta_block_remaining_len > 0){
            var cmd_code;
            var range_idx;
            var insert_code;
            var copy_code;
            var insert_length;
            var copy_length;
            var distance_code;
            var distance;
            var context;
            var j;
            var copy_dst;
            br.readMoreInput();
            if (block_length[1] === 0) {
                $ee7f3d40128f729f$var$DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                block_length[1] = $ee7f3d40128f729f$var$ReadBlockLength(block_len_trees, $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE, br);
                htree_command = hgroup[1].htrees[block_type[1]];
            }
            --block_length[1];
            cmd_code = $ee7f3d40128f729f$var$ReadSymbol(hgroup[1].codes, htree_command, br);
            range_idx = cmd_code >> 6;
            if (range_idx >= 2) {
                range_idx -= 2;
                distance_code = -1;
            } else distance_code = 0;
            insert_code = $7aaiK.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
            copy_code = $7aaiK.kCopyRangeLut[range_idx] + (cmd_code & 7);
            insert_length = $7aaiK.kInsertLengthPrefixCode[insert_code].offset + br.readBits($7aaiK.kInsertLengthPrefixCode[insert_code].nbits);
            copy_length = $7aaiK.kCopyLengthPrefixCode[copy_code].offset + br.readBits($7aaiK.kCopyLengthPrefixCode[copy_code].nbits);
            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
            for(j = 0; j < insert_length; ++j){
                br.readMoreInput();
                if (block_length[0] === 0) {
                    $ee7f3d40128f729f$var$DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[0] = $ee7f3d40128f729f$var$ReadBlockLength(block_len_trees, 0, br);
                    context_offset = block_type[0] << $ee7f3d40128f729f$var$kLiteralContextBits;
                    context_map_slice = context_offset;
                    context_mode = context_modes[block_type[0]];
                    context_lookup_offset1 = $hX8C6.lookupOffsets[context_mode];
                    context_lookup_offset2 = $hX8C6.lookupOffsets[context_mode + 1];
                }
                context = $hX8C6.lookup[context_lookup_offset1 + prev_byte1] | $hX8C6.lookup[context_lookup_offset2 + prev_byte2];
                literal_htree_index = context_map[context_map_slice + context];
                --block_length[0];
                prev_byte2 = prev_byte1;
                prev_byte1 = $ee7f3d40128f729f$var$ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                ++pos;
            }
            meta_block_remaining_len -= insert_length;
            if (meta_block_remaining_len <= 0) break;
            if (distance_code < 0) {
                var context;
                br.readMoreInput();
                if (block_length[2] === 0) {
                    $ee7f3d40128f729f$var$DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[2] = $ee7f3d40128f729f$var$ReadBlockLength(block_len_trees, 2 * $ee7f3d40128f729f$var$HUFFMAN_MAX_TABLE_SIZE, br);
                    dist_context_offset = block_type[2] << $ee7f3d40128f729f$var$kDistanceContextBits;
                    dist_context_map_slice = dist_context_offset;
                }
                --block_length[2];
                context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                dist_htree_index = dist_context_map[dist_context_map_slice + context];
                distance_code = $ee7f3d40128f729f$var$ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                if (distance_code >= num_direct_distance_codes) {
                    var nbits;
                    var postfix;
                    var offset;
                    distance_code -= num_direct_distance_codes;
                    postfix = distance_code & distance_postfix_mask;
                    distance_code >>= distance_postfix_bits;
                    nbits = (distance_code >> 1) + 1;
                    offset = (2 + (distance_code & 1) << nbits) - 4;
                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                }
            }
            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = $ee7f3d40128f729f$var$TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
            if (distance < 0) throw new Error('[BrotliDecompress] invalid distance');
            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
            else max_distance = max_backward_distance;
            copy_dst = pos & ringbuffer_mask;
            if (distance > max_distance) {
                if (copy_length >= $fo1rr.minDictionaryWordLength && copy_length <= $fo1rr.maxDictionaryWordLength) {
                    var offset = $fo1rr.offsetsByLength[copy_length];
                    var word_id = distance - max_distance - 1;
                    var shift = $fo1rr.sizeBitsByLength[copy_length];
                    var mask = (1 << shift) - 1;
                    var word_idx = word_id & mask;
                    var transform_idx = word_id >> shift;
                    offset += word_idx * copy_length;
                    if (transform_idx < $4zIc9.kNumTransforms) {
                        var len = $4zIc9.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                        copy_dst += len;
                        pos += len;
                        meta_block_remaining_len -= len;
                        if (copy_dst >= ringbuffer_end) {
                            output.write(ringbuffer, ringbuffer_size);
                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                        }
                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            } else {
                if (distance_code > 0) {
                    dist_rb[dist_rb_idx & 3] = distance;
                    ++dist_rb_idx;
                }
                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                for(j = 0; j < copy_length; ++j){
                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                    ++pos;
                    --meta_block_remaining_len;
                }
            }
            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
        }
        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
    }
    output.write(ringbuffer, pos & ringbuffer_mask);
}
$ee7f3d40128f729f$export$59cbf0b8eef2df1e = $ee7f3d40128f729f$var$BrotliDecompress;
$fo1rr.init();

});
parcelRegister("j5sEj", function(module, exports) {

$parcel$export(module.exports, "BrotliInput", () => $de54b50f360309a7$export$a450e20310cb640a, (v) => $de54b50f360309a7$export$a450e20310cb640a = v);
$parcel$export(module.exports, "BrotliOutput", () => $de54b50f360309a7$export$29d67bcb1d627ed0, (v) => $de54b50f360309a7$export$29d67bcb1d627ed0 = v);
var $de54b50f360309a7$export$a450e20310cb640a;
var $de54b50f360309a7$export$29d67bcb1d627ed0;
function $de54b50f360309a7$var$BrotliInput(buffer) {
    this.buffer = buffer;
    this.pos = 0;
}
$de54b50f360309a7$var$BrotliInput.prototype.read = function(buf, i, count) {
    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
    this.pos += count;
    return count;
};
$de54b50f360309a7$export$a450e20310cb640a = $de54b50f360309a7$var$BrotliInput;
function $de54b50f360309a7$var$BrotliOutput(buf) {
    this.buffer = buf;
    this.pos = 0;
}
$de54b50f360309a7$var$BrotliOutput.prototype.write = function(buf, count) {
    if (this.pos + count > this.buffer.length) throw new Error('Output buffer is not large enough');
    this.buffer.set(buf.subarray(0, count), this.pos);
    this.pos += count;
    return count;
};
$de54b50f360309a7$export$29d67bcb1d627ed0 = $de54b50f360309a7$var$BrotliOutput;

});

parcelRegister("8JSYM", function(module, exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var $65cd2c782f23ca03$var$BROTLI_READ_SIZE = 4096;
var $65cd2c782f23ca03$var$BROTLI_IBUF_SIZE = 2 * $65cd2c782f23ca03$var$BROTLI_READ_SIZE + 32;
var $65cd2c782f23ca03$var$BROTLI_IBUF_MASK = 2 * $65cd2c782f23ca03$var$BROTLI_READ_SIZE - 1;
var $65cd2c782f23ca03$var$kBitMask = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
]);
/* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function $65cd2c782f23ca03$var$BrotliBitReader(input) {
    this.buf_ = new Uint8Array($65cd2c782f23ca03$var$BROTLI_IBUF_SIZE);
    this.input_ = input; /* input callback */ 
    this.reset();
}
$65cd2c782f23ca03$var$BrotliBitReader.READ_SIZE = $65cd2c782f23ca03$var$BROTLI_READ_SIZE;
$65cd2c782f23ca03$var$BrotliBitReader.IBUF_MASK = $65cd2c782f23ca03$var$BROTLI_IBUF_MASK;
$65cd2c782f23ca03$var$BrotliBitReader.prototype.reset = function() {
    this.buf_ptr_ = 0; /* next input will write here */ 
    this.val_ = 0; /* pre-fetched bits */ 
    this.pos_ = 0; /* byte position in stream */ 
    this.bit_pos_ = 0; /* current bit-reading position in val_ */ 
    this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */ 
    this.eos_ = 0; /* input stream is finished */ 
    this.readMoreInput();
    for(var i = 0; i < 4; i++){
        this.val_ |= this.buf_[this.pos_] << 8 * i;
        ++this.pos_;
    }
    return this.bit_end_pos_ > 0;
};
/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ $65cd2c782f23ca03$var$BrotliBitReader.prototype.readMoreInput = function() {
    if (this.bit_end_pos_ > 256) return;
    else if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_) throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
    } else {
        var dst = this.buf_ptr_;
        var bytes_read = this.input_.read(this.buf_, dst, $65cd2c782f23ca03$var$BROTLI_READ_SIZE);
        if (bytes_read < 0) throw new Error('Unexpected end of input');
        if (bytes_read < $65cd2c782f23ca03$var$BROTLI_READ_SIZE) {
            this.eos_ = 1;
            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
        }
        if (dst === 0) {
            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[($65cd2c782f23ca03$var$BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
            this.buf_ptr_ = $65cd2c782f23ca03$var$BROTLI_READ_SIZE;
        } else this.buf_ptr_ = 0;
        this.bit_end_pos_ += bytes_read << 3;
    }
};
/* Guarantees that there are at least 24 bits in the buffer. */ $65cd2c782f23ca03$var$BrotliBitReader.prototype.fillBitWindow = function() {
    while(this.bit_pos_ >= 8){
        this.val_ >>>= 8;
        this.val_ |= this.buf_[this.pos_ & $65cd2c782f23ca03$var$BROTLI_IBUF_MASK] << 24;
        ++this.pos_;
        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
    }
};
/* Reads the specified number of bits from Read Buffer. */ $65cd2c782f23ca03$var$BrotliBitReader.prototype.readBits = function(n_bits) {
    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
    var val = this.val_ >>> this.bit_pos_ & $65cd2c782f23ca03$var$kBitMask[n_bits];
    this.bit_pos_ += n_bits;
    return val;
};
module.exports = $65cd2c782f23ca03$var$BrotliBitReader;

});

parcelRegister("fo1rr", function(module, exports) {

$parcel$export(module.exports, "init", () => $b33a37285e850206$export$2cd8252107eb640b, (v) => $b33a37285e850206$export$2cd8252107eb640b = v);
$parcel$export(module.exports, "dictionary", () => $b33a37285e850206$export$d3757880ed390b62, (v) => $b33a37285e850206$export$d3757880ed390b62 = v);
$parcel$export(module.exports, "offsetsByLength", () => $b33a37285e850206$export$a94670ba663785a0, (v) => $b33a37285e850206$export$a94670ba663785a0 = v);
$parcel$export(module.exports, "sizeBitsByLength", () => $b33a37285e850206$export$149ef025c336056f, (v) => $b33a37285e850206$export$149ef025c336056f = v);
$parcel$export(module.exports, "minDictionaryWordLength", () => $b33a37285e850206$export$66b25e7ba93e8824, (v) => $b33a37285e850206$export$66b25e7ba93e8824 = v);
$parcel$export(module.exports, "maxDictionaryWordLength", () => $b33a37285e850206$export$2ce04c23045f1c32, (v) => $b33a37285e850206$export$2ce04c23045f1c32 = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/ var $b33a37285e850206$export$2cd8252107eb640b;
var $b33a37285e850206$export$d3757880ed390b62;
var $b33a37285e850206$export$a94670ba663785a0;
var $b33a37285e850206$export$149ef025c336056f;
var $b33a37285e850206$export$66b25e7ba93e8824;
var $b33a37285e850206$export$2ce04c23045f1c32;

var $uI49e = parcelRequire("uI49e");
$b33a37285e850206$export$2cd8252107eb640b = function() {
    $b33a37285e850206$export$d3757880ed390b62 = $uI49e.init();
};
$b33a37285e850206$export$a94670ba663785a0 = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
]);
$b33a37285e850206$export$149ef025c336056f = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
]);
$b33a37285e850206$export$66b25e7ba93e8824 = 4;
$b33a37285e850206$export$2ce04c23045f1c32 = 24;

});
parcelRegister("uI49e", function(module, exports) {

$parcel$export(module.exports, "init", () => $05c4fc06ecec7c4f$export$2cd8252107eb640b, (v) => $05c4fc06ecec7c4f$export$2cd8252107eb640b = v);
/**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */ var $05c4fc06ecec7c4f$export$2cd8252107eb640b;

var $kuxul = parcelRequire("kuxul");


$05c4fc06ecec7c4f$export$2cd8252107eb640b = function() {
    var BrotliDecompressBuffer = (parcelRequire("ktvS8")).BrotliDecompressBuffer;
    var compressed = $kuxul.toByteArray((parcelRequire("3Cq5K")));
    return BrotliDecompressBuffer(compressed);
};

});
parcelRegister("3Cq5K", function(module, exports) {
module.exports = "W5/fcQLn5gKf2XUbAiQ1XULX+TZz6ADToDsgqk6qVfeC0e4m6OO2wcQ1J76ZBVRV1fRkEsdu//62zQsFEZWSTCnMhcsQKlS2qOhuVYYMGCkV0fXWEoMFbESXrKEZ9wdUEsyw9g4bJlEt1Y6oVMxMRTEVbCIwZzJzboK5j8m4YH02qgXYhv1V+PM435sLVxyHJihaJREEhZGqL03txGFQLm76caGO/ovxKvzCby/3vMTtX/459f0igi7WutnKiMQ6wODSoRh/8Lx1V3Q99MvKtwB6bHdERYRY0hStJoMjNeTsNX7bn+Y7e4EQ3bf8xBc7L0BsyfFPK43dGSXpL6clYC/I328h54/VYrQ5i0648FgbGtl837svJ35L3Mot/+nPlNpWgKx1gGXQYqX6n+bbZ7wuyCHKcUok12Xjqub7NXZGzqBx0SD+uziNf87t7ve42jxSKQoW3nyxVrWIGlFShhCKxjpZZ5MeGna0+lBkk+kaN8F9qFBAFgEogyMBdcX/T1W/WnMOi/7ycWUQloEBKGeC48MkiwqJkJO+12eQiOFHMmck6q/IjWW3RZlany23TBm+cNr/84/oi5GGmGBZWrZ6j+zykVozz5fT/QH/Da6WTbZYYPynVNO7kxzuNN2kxKKWche5WveitPKAecB8YcAHz/+zXLjcLzkdDSktNIDwZE9J9X+tto43oJy65wApM3mDzYtCwX9lM+N5VR3kXYo0Z3t0TtXfgBFg7gU8oN0Dgl7fZlUbhNll+0uuohRVKjrEd8egrSndy5/Tgd2gqjA4CAVuC7ESUmL3DZoGnfhQV8uwnpi8EGvAVVsowNRxPudck7+oqAUDkwZopWqFnW1riss0t1z6iCISVKreYGNvQcXv+1L9+jbP8cd/dPUiqBso2q+7ZyFBvENCkkVr44iyPbtOoOoCecWsiuqMSML5lv+vN5MzUr+Dnh73G7Q1YnRYJVYXHRJaNAOByiaK6CusgFdBPE40r0rvqXV7tksKO2DrHYXBTv8P5ysqxEx8VDXUDDqkPH6NNOV/a2WH8zlkXRELSa8P+heNyJBBP7PgsG1EtWtNef6/i+lcayzQwQCsduidpbKfhWUDgAEmyhGu/zVTacI6RS0zTABrOYueemnVa19u9fT23N/Ta6RvTpof5DWygqreCqrDAgM4LID1+1T/taU6yTFVLqXOv+/MuQOFnaF8vLMKD7tKWDoBdALgxF33zQccCcdHx8fKIVdW69O7qHtXpeGr9jbbpFA+qRMWr5hp0s67FPc7HAiLV0g0/peZlW7hJPYEhZyhpSwahnf93/tZgfqZWXFdmdXBzqxGHLrQKxoAY6fRoBhgCRPmmGueYZ5JexTVDKUIXzkG/fqp/0U3hAgQdJ9zumutK6nqWbaqvm1pgu03IYR+G+8s0jDBBz8cApZFSBeuWasyqo2OMDKAZCozS+GWSvL/HsE9rHxooe17U3s/lTE+VZAk4j3dp6uIGaC0JMiqR5CUsabPyM0dOYDR7Ea7ip4USZlya38YfPtvrX/tBlhHilj55nZ1nfN24AOAi9BVtz/Mbn8AEDJCqJgsVUa6nQnSxv2Fs7l/NlCzpfYEjmPrNyib/+t0ei2eEMjvNhLkHCZlci4WhBe7ePZTmzYqlY9+1pxtS4GB+5lM1BHT9tS270EWUDYFq1I0yY/fNiAk4bk9yBgmef/f2k6AlYQZHsNFnW8wBQxCd68iWv7/35bXfz3JZmfGligWAKRjIs3IpzxQ27vAglHSiOzCYzJ9L9A1CdiyFvyR66ucA4jKifu5ehwER26yV7HjKqn5Mfozo7Coxxt8LWWPT47BeMxX8p0Pjb7hZn+6bw7z3Lw+7653j5sI8CLu5kThpMlj1m4c2ch3jGcP1FsT13vuK3qjecKTZk2kHcOZY40UX+qdaxstZqsqQqgXz+QGF99ZJLqr3VYu4aecl1Ab5GmqS8k/GV5b95zxQ5d4EfXUJ6kTS/CXF/aiqKDOT1T7Jz5z0PwDUcwr9clLN1OJGCiKfqvah+h3XzrBOiLOW8wvn8gW6qE8vPxi+Efv+UH55T7PQFVMh6cZ1pZQlzJpKZ7P7uWvwPGJ6DTlR6wbyj3Iv2HyefnRo/dv7dNx+qaa0N38iBsR++Uil7Wd4afwDNsrzDAK4fXZwvEY/jdKuIKXlfrQd2C39dW7ntnRbIp9OtGy9pPBn/V2ASoi/2UJZfS+xuGLH8bnLuPlzdTNS6zdyk8Dt/h6sfOW5myxh1f+zf3zZ3MX/mO9cQPp5pOx967ZA6/pqHvclNfnUFF+rq+Vd7alKr6KWPcIDhpn6v2K6NlUu6LrKo8b/pYpU/Gazfvtwhn7tEOUuXht5rUJdSf6sLjYf0VTYDgwJ81yaqKTUYej/tbHckSRb/HZicwGJqh1mAHB/IuNs9dc9yuvF3D5Xocm3elWFdq5oEy70dYFit79yaLiNjPj5UUcVmZUVhQEhW5V2Z6Cm4HVH/R8qlamRYwBileuh07CbEce3TXa2JmXWBf+ozt319psboobeZhVnwhMZzOeQJzhpTDbP71Tv8HuZxxUI/+ma3XW6DFDDs4+qmpERwHGBd2edxwUKlODRdUWZ/g0GOezrbzOZauFMai4QU6GVHV6aPNBiBndHSsV4IzpvUiiYyg6OyyrL4Dj5q/Lw3N5kAwftEVl9rNd7Jk5PDij2hTH6wIXnsyXkKePxbmHYgC8A6an5Fob/KH5GtC0l4eFso+VpxedtJHdHpNm+Bvy4C79yVOkrZsLrQ3OHCeB0Ra+kBIRldUGlDCEmq2RwXnfyh6Dz+alk6eftI2n6sastRrGwbwszBeDRS/Fa/KwRJkCzTsLr/JCs5hOPE/MPLYdZ1F1fv7D+VmysX6NpOC8aU9F4Qs6HvDyUy9PvFGDKZ/P5101TYHFl8pjj6wm/qyS75etZhhfg0UEL4OYmHk6m6dO192AzoIyPSV9QedDA4Ml23rRbqxMPMxf7FJnDc5FTElVS/PyqgePzmwVZ26NWhRDQ+oaT7ly7ell4s3DypS1s0g+tOr7XHrrkZj9+x/mJBttrLx98lFIaRZzHz4aC7r52/JQ4VjHahY2/YVXZn/QC2ztQb/sY3uRlyc5vQS8nLPGT/n27495i8HPA152z7Fh5aFpyn1GPJKHuPL8Iw94DuW3KjkURAWZXn4EQy89xiKEHN1mk/tkM4gYDBxwNoYvRfE6LFqsxWJtPrDGbsnLMap3Ka3MUoytW0cvieozOmdERmhcqzG+3HmZv2yZeiIeQTKGdRT4HHNxekm1tY+/n06rGmFleqLscSERzctTKM6G9P0Pc1RmVvrascIxaO1CQCiYPE15bD7c3xSeW7gXxYjgxcrUlcbIvO0r+Yplhx0kTt3qafDOmFyMjgGxXu73rddMHpV1wMubyAGcf/v5dLr5P72Ta9lBF+fzMJrMycwv+9vnU3ANIl1cH9tfW7af8u0/HG0vV47jNFXzFTtaha1xvze/s8KMtCYucXc1nzfd/MQydUXn/b72RBt5wO/3jRcMH9BdhC/yctKBIveRYPrNpDWqBsO8VMmP+WvRaOcA4zRMR1PvSoO92rS7pYEv+fZfEfTMzEdM+6X5tLlyxExhqLRkms5EuLovLfx66de5fL2/yX02H52FPVwahrPqmN/E0oVXnsCKhbi/yRxX83nRbUKWhzYceXOntfuXn51NszJ6MO73pQf5Pl4in3ec4JU8hF7ppV34+mm9r1LY0ee/i1O1wpd8+zfLztE0cqBxggiBi5Bu95v9l3r9r/U5hweLn+TbfxowrWDqdJauKd8+q/dH8sbPkc9ttuyO94f7/XK/nHX46MPFLEb5qQlNPvhJ50/59t9ft3LXu7uVaWaO2bDrDCnRSzZyWvFKxO1+vT8MwwunR3bX0CkfPjqb4K9O19tn5X50PvmYpEwHtiW9WtzuV/s76B1zvLLNkViNd8ySxIl/3orfqP90TyTGaf7/rx8jQzeHJXdmh/N6YDvbvmTBwCdxfEQ1NcL6wNMdSIXNq7b1EUzRy1/Axsyk5p22GMG1b+GxFgbHErZh92wuvco0AuOLXct9hvw2nw/LqIcDRRmJmmZzcgUa7JpM/WV/S9IUfbF56TL2orzqwebdRD8nIYNJ41D/hz37Fo11p2Y21wzPcn713qVGhqtevStYfGH4n69OEJtPvbbLYWvscDqc3Hgnu166+tAyLnxrX0Y5zoYjV++1sI7t5kMr02KT/+uwtkc+rZLOf/qn/s3nYCf13Dg8/sB2diJgjGqjQ+TLhxbzyue2Ob7X6/9lUwW7a+lbznHzOYy8LKW1C/uRPbQY3KW/0gO9LXunHLvPL97afba9bFtc9hmz7GAttjVYlCvQAiOwAk/gC5+hkLEs6tr3AZKxLJtOEwk2dLxTYWsIB/j/ToWtIWzo906FrSG8iaqqqqqqiIiIiAgzMzMzNz+AyK+01/zi8n8S+Y1MjoRaQ80WU/G8MBlO+53VPXANrWm4wzGUVZUjjBJZVdhpcfkjsmcWaO+UEldXi1e+zq+HOsCpknYshuh8pOLISJun7TN0EIGW2xTnlOImeecnoGW4raxe2G1T3HEvfYUYMhG+gAFOAwh5nK8mZhwJMmN7r224QVsNFvZ87Z0qatvknklyPDK3Hy45PgVKXji52Wen4d4PlFVVYGnNap+fSpFbK90rYnhUc6n91Q3AY9E0tJOFrcfZtm/491XbcG/jsViUPPX76qmeuiz+qY1Hk7/1VPM405zWVuoheLUimpWYdVzCmUdKHebMdzgrYrb8mL2eeLSnRWHdonfZa8RsOU9F37w+591l5FLYHiOqWeHtE/lWrBHcRKp3uhtr8yXm8LU/5ms+NM6ZKsqu90cFZ4o58+k4rdrtB97NADFbwmEG7lXqvirhOTOqU14xuUF2myIjURcPHrPOQ4lmM3PeMg7bUuk0nnZi67bXsU6H8lhqIo8TaOrEafCO1ARK9PjC0QOoq2BxmMdgYB9G/lIb9++fqNJ2s7BHGFyBNmZAR8J3KCo012ikaSP8BCrf6VI0X5xdnbhHIO+B5rbOyB54zXkzfObyJ4ecwxfqBJMLFc7m59rNcw7hoHnFZ0b00zee+gTqvjm61Pb4xn0kcDX4jvHM0rBXZypG3DCKnD/Waa/ZtHmtFPgO5eETx+k7RrVg3aSwm2YoNXnCs3XPQDhNn+Fia6IlOOuIG6VJH7TP6ava26ehKHQa2T4N0tcZ9dPCGo3ZdnNltsHQbeYt5vPnJezV/cAeNypdml1vCHI8M81nSRP5Qi2+mI8v/sxiZru9187nRtp3f/42NemcONa+4eVC3PCZzc88aZh851CqSsshe70uPxeN/dmYwlwb3trwMrN1Gq8jbnApcVDx/yDPeYs5/7r62tsQ6lLg+DiFXTEhzR9dHqv0iT4tgj825W+H3XiRUNUZT2kR9Ri0+lp+UM3iQtS8uOE23Ly4KYtvqH13jghUntJRAewuzNLDXp8RxdcaA3cMY6TO2IeSFRXezeWIjCqyhsUdMYuCgYTZSKpBype1zRfq8FshvfBPc6BAQWl7/QxIDp3VGo1J3vn42OEs3qznws+YLRXbymyB19a9XBx6n/owcyxlEYyFWCi+kG9F+EyD/4yn80+agaZ9P7ay2Dny99aK2o91FkfEOY8hBwyfi5uwx2y5SaHmG+oq/zl1FX/8irOf8Y3vAcX/6uLP6A6nvMO24edSGPjQc827Rw2atX+z2bKq0CmW9mOtYnr5/AfDa1ZfPaXnKtlWborup7QYx+Or2uWb+N3N//2+yDcXMqIJdf55xl7/vsj4WoPPlxLxtVrkJ4w/tTe3mLdATOOYwxcq52w5Wxz5MbPdVs5O8/lhfE7dPj0bIiPQ3QV0iqm4m3YX8hRfc6jQ3fWepevMqUDJd86Z4vwM40CWHnn+WphsGHfieF02D3tmZvpWD+kBpNCFcLnZhcmmrhpGzzbdA+sQ1ar18OJD87IOKOFoRNznaHPNHUfUNhvY1iU+uhvEvpKHaUn3qK3exVVyX4joipp3um7FmYJWmA+WbIDshRpbVRx5/nqstCgy87FGbfVB8yDGCqS+2qCsnRwnSAN6zgzxfdB2nBT/vZ4/6uxb6oH8b4VBRxiIB93wLa47hG3w2SL/2Z27yOXJFwZpSJaBYyvajA7vRRYNKqljXKpt/CFD/tSMr18DKKbwB0xggBePatl1nki0yvqW5zchlyZmJ0OTxJ3D+fsYJs/mxYN5+Le5oagtcl+YsVvy8kSjI2YGvGjvmpkRS9W2dtXqWnVuxUhURm1lKtou/hdEq19VBp9OjGvHEQSmrpuf2R24mXGheil8KeiANY8fW1VERUfBImb64j12caBZmRViZHbeVMjCrPDg9A90IXrtnsYCuZtRQ0PyrKDjBNOsPfKsg1pA02gHlVr0OXiFhtp6nJqXVzcbfM0KnzC3ggOENPE9VBdmHKN6LYaijb4wXxJn5A0FSDF5j+h1ooZx885Jt3ZKzO5n7Z5WfNEOtyyPqQEnn7WLv5Fis3PdgMshjF1FRydbNyeBbyKI1oN1TRVrVK7kgsb/zjX4NDPIRMctVeaxVB38Vh1x5KbeJbU138AM5KzmZu3uny0ErygxiJF7GVXUrPzFxrlx1uFdAaZFDN9cvIb74qD9tzBMo7L7WIEYK+sla1DVMHpF0F7b3+Y6S+zjvLeDMCpapmJo1weBWuxKF3rOocih1gun4BoJh1kWnV/Jmiq6uOhK3VfKxEHEkafjLgK3oujaPzY6SXg8phhL4TNR1xvJd1Wa0aYFfPUMLrNBDCh4AuGRTbtKMc6Z1Udj8evY/ZpCuMAUefdo69DZUngoqE1P9A3PJfOf7WixCEj+Y6t7fYeHbbxUAoFV3M89cCKfma3fc1+jKRe7MFWEbQqEfyzO2x/wrO2VYH7iYdQ9BkPyI8/3kXBpLaCpU7eC0Yv/am/tEDu7HZpqg0EvHo0nf/R/gRzUWy33/HXMJQeu1GylKmOkXzlCfGFruAcPPhaGqZOtu19zsJ1SO2Jz4Ztth5cBX6mRQwWmDwryG9FUMlZzNckMdK+IoMJv1rOWnBamS2w2KHiaPMPLC15hCZm4KTpoZyj4E2TqC/P6r7/EhnDMhKicZZ1ZwxuC7DPzDGs53q8gXaI9kFTK+2LTq7bhwsTbrMV8Rsfua5lMS0FwbTitUVnVa1yTb5IX51mmYnUcP9wPr8Ji1tiYJeJV9GZTrQhF7vvdU2OTU42ogJ9FDwhmycI2LIg++03C6scYhUyUuMV5tkw6kGUoL+mjNC38+wMdWNljn6tGPpRES7veqrSn5TRuv+dh6JVL/iDHU1db4c9WK3++OrH3PqziF916UMUKn8G67nN60GfWiHrXYhUG3yVWmyYak59NHj8t1smG4UDiWz2rPHNrKnN4Zo1LBbr2/eF9YZ0n0blx2nG4X+EKFxvS3W28JESD+FWk61VCD3z/URGHiJl++7TdBwkCj6tGOH3qDb0QqcOF9Kzpj0HUb/KyFW3Yhj2VMKJqGZleFBH7vqvf7WqLC3XMuHV8q8a4sTFuxUtkD/6JIBvKaVjv96ndgruKZ1k/BHzqf2K9fLk7HGXANyLDd1vxkK/i055pnzl+zw6zLnwXlVYVtfmacJgEpRP1hbGgrYPVN6v2lG+idQNGmwcKXu/8xEj/P6qe/sB2WmwNp6pp8jaISMkwdleFXYK55NHWLTTbutSUqjBfDGWo/Yg918qQ+8BRZSAHZbfuNZz2O0sov1Ue4CWlVg3rFhM3Kljj9ksGd/NUhk4nH+a5UN2+1i8+NM3vRNp7uQ6sqexSCukEVlVZriHNqFi5rLm9TMWa4qm3idJqppQACol2l4VSuvWLfta4JcXy3bROPNbXOgdOhG47LC0CwW/dMlSx4Jf17aEU3yA1x9p+Yc0jupXgcMuYNku64iYOkGToVDuJvlbEKlJqsmiHbvNrIVZEH+yFdF8DbleZ6iNiWwMqvtMp/mSpwx5KxRrT9p3MAPTHGtMbfvdFhyj9vhaKcn3At8Lc16Ai+vBcSp1ztXi7rCJZx/ql7TXcclq6Q76UeKWDy9boS0WHIjUuWhPG8LBmW5y2rhuTpM5vsLt+HOLh1Yf0DqXa9tsfC+kaKt2htA0ai/L2i7RKoNjEwztkmRU0GfgW1TxUvPFhg0V7DdfWJk5gfrccpYv+MA9M0dkGTLECeYwUixRzjRFdmjG7zdZIl3XKB9YliNKI31lfa7i2JG5C8Ss+rHe0D7Z696/V3DEAOWHnQ9yNahMUl5kENWS6pHKKp2D1BaSrrHdE1w2qNxIztpXgUIrF0bm15YML4b6V1k+GpNysTahKMVrrS85lTVo9OGJ96I47eAy5rYWpRf/mIzeoYU1DKaQCTUVwrhHeyNoDqHel+lLxr9WKzhSYw7vrR6+V5q0pfi2k3L1zqkubY6rrd9ZLvSuWNf0uqnkY+FpTvFzSW9Fp0b9l8JA7THV9eCi/PY/SCZIUYx3BU2alj7Cm3VV6eYpios4b6WuNOJdYXUK3zTqj5CVG2FqYM4Z7CuIU0qO05XR0d71FHM0YhZmJmTRfLlXEumN82BGtzdX0S19t1e+bUieK8zRmqpa4Qc5TSjifmaQsY2ETLjhI36gMR1+7qpjdXXHiceUekfBaucHShAOiFXmv3sNmGQyU5iVgnoocuonQXEPTFwslHtS8R+A47StI9wj0iSrtbi5rMysczFiImsQ+bdFClnFjjpXXwMy6O7qfjOr8Fb0a7ODItisjnn3EQO16+ypd1cwyaAW5Yzxz5QknfMO7643fXW/I9y3U2xH27Oapqr56Z/tEzglj6IbT6HEHjopiXqeRbe5mQQvxtcbDOVverN0ZgMdzqRYRjaXtMRd56Q4cZSmdPvZJdSrhJ1D9zNXPqAEqPIavPdfubt5oke2kmv0dztIszSv2VYuoyf1UuopbsYb+uX9h6WpwjpgtZ6fNNawNJ4q8O3CFoSbioAaOSZMx2GYaPYB+rEb6qjQiNRFQ76TvwNFVKD+BhH9VhcKGsXzmMI7BptU/CNWolM7YzROvpFAntsiWJp6eR2d3GarcYShVYSUqhmYOWj5E96NK2WvmYNTeY7Zs4RUEdv9h9QT4EseKt6LzLrqEOs3hxAY1MaNWpSa6zZx8F3YOVeCYMS88W+CYHDuWe4yoc6YK+djDuEOrBR5lvh0r+Q9uM88lrjx9x9AtgpQVNE8r+3O6Gvw59D+kBF/UMXyhliYUtPjmvXGY6Dk3x+kEOW+GtdMVC4EZTqoS/jmR0P0LS75DOc/w2vnri97M4SdbZ8qeU7gg8DVbERkU5geaMQO3mYrSYyAngeUQqrN0C0/vsFmcgWNXNeidsTAj7/4MncJR0caaBUpbLK1yBCBNRjEv6KvuVSdpPnEMJdsRRtqJ+U8tN1gXA4ePHc6ZT0eviI73UOJF0fEZ8YaneAQqQdGphNvwM4nIqPnXxV0xA0fnCT+oAhJuyw/q8jO0y8CjSteZExwBpIN6SvNp6A5G/abi6egeND/1GTguhuNjaUbbnSbGd4L8937Ezm34Eyi6n1maeOBxh3PI0jzJDf5mh/BsLD7F2GOKvlA/5gtvxI3/eV4sLfKW5Wy+oio+es/u6T8UU+nsofy57Icb/JlZHPFtCgd/x+bwt3ZT+xXTtTtTrGAb4QehC6X9G+8YT+ozcLxDsdCjsuOqwPFnrdLYaFc92Ui0m4fr39lYmlCaqTit7G6O/3kWDkgtXjNH4BiEm/+jegQnihOtfffn33WxsFjhfMd48HT+f6o6X65j7XR8WLSHMFkxbvOYsrRsF1bowDuSQ18Mkxk4qz2zoGPL5fu9h2Hqmt1asl3Q3Yu3szOc+spiCmX4AETBM3pLoTYSp3sVxahyhL8eC4mPN9k2x3o0xkiixIzM3CZFzf5oR4mecQ5+ax2wCah3/crmnHoqR0+KMaOPxRif1oEFRFOO/kTPPmtww+NfMXxEK6gn6iU32U6fFruIz8Q4WgljtnaCVTBgWx7diUdshC9ZEa5yKpRBBeW12r/iNc/+EgNqmhswNB8SBoihHXeDF7rrWDLcmt3V8GYYN7pXRy4DZjj4DJuUBL5iC3DQAaoo4vkftqVTYRGLS3mHZ7gdmdTTqbgNN/PTdTCOTgXolc88MhXAEUMdX0iy1JMuk5wLsgeu0QUYlz2S4skTWwJz6pOm/8ihrmgGfFgri+ZWUK2gAPHgbWa8jaocdSuM4FJYoKicYX/ZSENkg9Q1ZzJfwScfVnR2DegOGwCvmogaWJCLQepv9WNlU6QgsmOwICquU28Mlk3d9W5E81lU/5Ez0LcX6lwKMWDNluNKfBDUy/phJgBcMnfkh9iRxrdOzgs08JdPB85Lwo+GUSb4t3nC+0byqMZtO2fQJ4U2zGIr49t/28qmmGv2RanDD7a3FEcdtutkW8twwwlUSpb8QalodddbBfNHKDQ828BdE7OBgFdiKYohLawFYqpybQoxATZrheLhdI7+0Zlu9Q1myRcd15r9UIm8K2LGJxqTegntqNVMKnf1a8zQiyUR1rxoqjiFxeHxqFcYUTHfDu7rhbWng6qOxOsI+5A1p9mRyEPdVkTlE24vY54W7bWc6jMgZvNXdfC9/9q7408KDsbdL7Utz7QFSDetz2picArzrdpL8OaCHC9V26RroemtDZ5yNM/KGkWMyTmfnInEvwtSD23UcFcjhaE3VKzkoaEMKGBft4XbIO6forTY1lmGQwVmKicBCiArDzE+1oIxE08fWeviIOD5TznqH+OoHadvoOP20drMPe5Irg3XBQziW2XDuHYzjqQQ4wySssjXUs5H+t3FWYMHppUnBHMx/nYIT5d7OmjDbgD9F6na3m4l7KdkeSO3kTEPXafiWinogag7b52taiZhL1TSvBFmEZafFq2H8khQaZXuitCewT5FBgVtPK0j4xUHPfUz3Q28eac1Z139DAP23dgki94EC8vbDPTQC97HPPSWjUNG5tWKMsaxAEMKC0665Xvo1Ntd07wCLNf8Q56mrEPVpCxlIMVlQlWRxM3oAfpgIc+8KC3rEXUog5g06vt7zgXY8grH7hhwVSaeuvC06YYRAwpbyk/Unzj9hLEZNs2oxPQB9yc+GnL6zTgq7rI++KDJwX2SP8Sd6YzTuw5lV/kU6eQxRD12omfQAW6caTR4LikYkBB1CMOrvgRr/VY75+NSB40Cni6bADAtaK+vyxVWpf9NeKJxN2KYQ8Q2xPB3K1s7fuhvWbr2XpgW044VD6DRs0qXoqKf1NFsaGvKJc47leUV3pppP/5VTKFhaGuol4Esfjf5zyCyUHmHthChcYh4hYLQF+AFWsuq4t0wJyWgdwQVOZiV0efRHPoK5+E1vjz9wTJmVkITC9oEstAsyZSgE/dbicwKr89YUxKZI+owD205Tm5lnnmDRuP/JnzxX3gMtlrcX0UesZdxyQqYQuEW4R51vmQ5xOZteUd8SJruMlTUzhtVw/Nq7eUBcqN2/HVotgfngif60yKEtoUx3WYOZlVJuJOh8u59fzSDPFYtQgqDUAGyGhQOAvKroXMcOYY0qjnStJR/G3aP+Jt1sLVlGV8POwr/6OGsqetnyF3TmTqZjENfnXh51oxe9qVUw2M78EzAJ+IM8lZ1MBPQ9ZWSVc4J3mWSrLKrMHReA5qdGoz0ODRsaA+vwxXA2cAM4qlfzBJA6581m4hzxItQw5dxrrBL3Y6kCbUcFxo1S8jyV44q//+7ASNNudZ6xeaNOSIUffqMn4A9lIjFctYn2gpEPAb3f7p3iIBN8H14FUGQ9ct2hPsL+cEsTgUrR47uJVN4n4wt/wgfwwHuOnLd4yobkofy8JvxSQTA7rMpDIc608SlZFJfZYcmbT0tAHpPE8MrtQ42siTUNWxqvWZOmvu9f0JPoQmg+6l7sZWwyfi6PXkxJnwBraUG0MYG4zYHQz3igy/XsFkx5tNQxw43qvI9dU3f0DdhOUlHKjmi1VAr2Kiy0HZwD8VeEbhh0OiDdMYspolQsYdSwjCcjeowIXNZVUPmL2wwIkYhmXKhGozdCJ4lRKbsf4NBh/XnQoS92NJEWOVOFs2YhN8c5QZFeK0pRdAG40hqvLbmoSA8xQmzOOEc7wLcme9JOsjPCEgpCwUs9E2DohMHRhUeyGIN6TFvrbny8nDuilsDpzrH5mS76APoIEJmItS67sQJ+nfwddzmjPxcBEBBCw0kWDwd0EZCkNeOD7NNQhtBm7KHL9mRxj6U1yWU2puzlIDtpYxdH4ZPeXBJkTGAJfUr/oTCz/iypY6uXaR2V1doPxJYlrw2ghH0D5gbrhFcIxzYwi4a/4hqVdf2DdxBp6vGYDjavxMAAoy+1+3aiO6S3W/QAKNVXagDtvsNtx7Ks+HKgo6U21B+QSZgIogV5Bt+BnXisdVfy9VyXV+2P5fMuvdpAjM1o/K9Z+XnE4EOCrue+kcdYHqAQ0/Y/OmNlQ6OI33jH/uD1RalPaHpJAm2av0/xtpqdXVKNDrc9F2izo23Wu7firgbURFDNX9eGGeYBhiypyXZft2j3hTvzE6PMWKsod//rEILDkzBXfi7xh0eFkfb3/1zzPK/PI5Nk3FbZyTl4mq5BfBoVoqiPHO4Q4QKZAlrQ3MdNfi3oxIjvsM3kAFv3fdufurqYR3PSwX/mpGy/GFI/B2MNPiNdOppWVbs/gjF3YH+QA9jMhlAbhvasAHstB0IJew09iAkmXHl1/TEj+jvHOpOGrPRQXbPADM+Ig2/OEcUcpgPTItMtW4DdqgfYVI/+4hAFWYjUGpOP/UwNuB7+BbKOcALbjobdgzeBQfjgNSp2GOpxzGLj70Vvq5cw2AoYENwKLUtJUX8sGRox4dVa/TN4xKwaKcl9XawQR/uNus700Hf17pyNnezrUgaY9e4MADhEDBpsJT6y1gDJs1q6wlwGhuUzGR7C8kgpjPyHWwsvrf3yn1zJEIRa5eSxoLAZOCR9xbuztxFRJW9ZmMYfCFJ0evm9F2fVnuje92Rc4Pl6A8bluN8MZyyJGZ0+sNSb//DvAFxC2BqlEsFwccWeAl6CyBcQV1bx4mQMBP1Jxqk1EUADNLeieS2dUFbQ/c/kvwItbZ7tx0st16viqd53WsRmPTKv2AD8CUnhtPWg5aUegNpsYgasaw2+EVooeNKmrW3MFtj76bYHJm5K9gpAXZXsE5U8DM8XmVOSJ1F1WnLy6nQup+jx52bAb+rCq6y9WXl2B2oZDhfDkW7H3oYfT/4xx5VncBuxMXP2lNfhUVQjSSzSRbuZFE4vFawlzveXxaYKVs8LpvAb8IRYF3ZHiRnm0ADeNPWocwxSzNseG7NrSEVZoHdKWqaGEBz1N8Pt7kFbqh3LYmAbm9i1IChIpLpM5AS6mr6OAPHMwwznVy61YpBYX8xZDN/a+lt7n+x5j4bNOVteZ8lj3hpAHSx1VR8vZHec4AHO9XFCdjZ9eRkSV65ljMmZVzaej2qFn/qt1lvWzNZEfHxK3qOJrHL6crr0CRzMox5f2e8ALBB4UGFZKA3tN6F6IXd32GTJXGQ7DTi9j/dNcLF9jCbDcWGKxoKTYblIwbLDReL00LRcDPMcQuXLMh5YzgtfjkFK1DP1iDzzYYVZz5M/kWYRlRpig1htVRjVCknm+h1M5LiEDXOyHREhvzCGpFZjHS0RsK27o2avgdilrJkalWqPW3D9gmwV37HKmfM3F8YZj2ar+vHFvf3B8CRoH4kDHIK9mrAg+owiEwNjjd9V+FsQKYR8czJrUkf7Qoi2YaW6EVDZp5zYlqiYtuXOTHk4fAcZ7qBbdLDiJq0WNV1l2+Hntk1mMWvxrYmc8kIx8G3rW36J6Ra4lLrTOCgiOihmow+YnzUT19jbV2B3RWqSHyxkhmgsBqMYWvOcUom1jDQ436+fcbu3xf2bbeqU/ca+C4DOKE+e3qvmeMqW3AxejfzBRFVcwVYPq4L0APSWWoJu+5UYX4qg5U6YTioqQGPG9XrnuZ/BkxuYpe6Li87+18EskyQW/uA+uk2rpHpr6hut2TlVbKgWkFpx+AZffweiw2+VittkEyf/ifinS/0ItRL2Jq3tQOcxPaWO2xrG68GdFoUpZgFXaP2wYVtRc6xYCfI1CaBqyWpg4bx8OHBQwsV4XWMibZZ0LYjWEy2IxQ1mZrf1/UNbYCJplWu3nZ4WpodIGVA05d+RWSS+ET9tH3RfGGmNI1cIY7evZZq7o+a0bjjygpmR3mVfalkT/SZGT27Q8QGalwGlDOS9VHCyFAIL0a1Q7JiW3saz9gqY8lqKynFrPCzxkU4SIfLc9VfCI5edgRhDXs0edO992nhTKHriREP1NJC6SROMgQ0xO5kNNZOhMOIT99AUElbxqeZF8A3xrfDJsWtDnUenAHdYWSwAbYjFqQZ+D5gi3hNK8CSxU9i6f6ClL9IGlj1OPMQAsr84YG6ijsJpCaGWj75c3yOZKBB9mNpQNPUKkK0D6wgLH8MGoyRxTX6Y05Q4AnYNXMZwXM4eij/9WpsM/9CoRnFQXGR6MEaY+FXvXEO3RO0JaStk6OXuHVATHJE+1W+TU3bSZ2ksMtqjO0zfSJCdBv7y2d8DMx6TfVme3q0ZpTKMMu4YL/t7ciTNtdDkwPogh3Cnjx7qk08SHwf+dksZ7M2vCOlfsF0hQ6J4ehPCaHTNrM/zBSOqD83dBEBCW/F/LEmeh0nOHd7oVl3/Qo/9GUDkkbj7yz+9cvvu+dDAtx8NzCDTP4iKdZvk9MWiizvtILLepysflSvTLFBZ37RLwiriqyRxYv/zrgFd/9XVHh/OmzBvDX4mitMR/lUavs2Vx6cR94lzAkplm3IRNy4TFfu47tuYs9EQPIPVta4P64tV+sZ7n3ued3cgEx2YK+QL5+xms6osk8qQbTyuKVGdaX9FQqk6qfDnT5ykxk0VK7KZ62b6DNDUfQlqGHxSMKv1P0XN5BqMeKG1P4Wp5QfZDUCEldppoX0U6ss2jIko2XpURKCIhfaOqLPfShdtS37ZrT+jFRSH2xYVV1rmT/MBtRQhxiO4MQ3iAGlaZi+9PWBEIXOVnu9jN1f921lWLZky9bqbM3J2MAAI9jmuAx3gyoEUa6P2ivs0EeNv/OR+AX6q5SW6l5HaoFuS6jr6yg9limu+P0KYKzfMXWcQSfTXzpOzKEKpwI3YGXZpSSy2LTlMgfmFA3CF6R5c9xWEtRuCg2ZPUQ2Nb6dRFTNd4TfGHrnEWSKHPuRyiJSDAZ+KX0VxmSHjGPbQTLVpqixia2uyhQ394gBMt7C3ZAmxn/DJS+l1fBsAo2Eir/C0jG9csd4+/tp12pPc/BVJGaK9mfvr7M/CeztrmCO5qY06Edi4xAGtiEhnWAbzLy2VEyazE1J5nPmgU4RpW4Sa0TnOT6w5lgt3/tMpROigHHmexBGAMY0mdcDbDxWIz41NgdD6oxgHsJRgr5RnT6wZAkTOcStU4NMOQNemSO7gxGahdEsC+NRVGxMUhQmmM0llWRbbmFGHzEqLM4Iw0H7577Kyo+Zf+2cUFIOw93gEY171vQaM0HLwpjpdRR6Jz7V0ckE7XzYJ0TmY9znLdzkva0vNrAGGT5SUZ5uaHDkcGvI0ySpwkasEgZPMseYcu85w8HPdSNi+4T6A83iAwDbxgeFcB1ZM2iGXzFcEOUlYVrEckaOyodfvaYSQ7GuB4ISE0nYJc15X/1ciDTPbPCgYJK55VkEor4LvzL9S2WDy4xj+6FOqVyTAC2ZNowheeeSI5hA/02l8UYkv4nk9iaVn+kCVEUstgk5Hyq+gJm6R9vG3rhuM904he/hFmNQaUIATB1y3vw+OmxP4X5Yi6A5I5jJufHCjF9+AGNwnEllZjUco6XhsO5T5+R3yxz5yLVOnAn0zuS+6zdj0nTJbEZCbXJdtpfYZfCeCOqJHoE2vPPFS6eRLjIJlG69X93nfR0mxSFXzp1Zc0lt/VafDaImhUMtbnqWVb9M4nGNQLN68BHP7AR8Il9dkcxzmBv8PCZlw9guY0lurbBsmNYlwJZsA/B15/HfkbjbwPddaVecls/elmDHNW2r4crAx43feNkfRwsaNq/yyJ0d/p5hZ6AZajz7DBfUok0ZU62gCzz7x8eVfJTKA8IWn45vINLSM1q+HF9CV9qF3zP6Ml21kPPL3CXzkuYUlnSqT+Ij4tI/od5KwIs+tDajDs64owN7tOAd6eucGz+KfO26iNcBFpbWA5732bBNWO4kHNpr9D955L61bvHCF/mwSrz6eQaDjfDEANqGMkFc+NGxpKZzCD2sj/JrHd+zlPQ8Iz7Q+2JVIiVCuCKoK/hlAEHzvk/Piq3mRL1rT/fEh9hoT5GJmeYswg1otiKydizJ/fS2SeKHVu6Z3JEHjiW8NaTQgP5xdBli8nC57XiN9hrquBu99hn9zqwo92+PM2JXtpeVZS0PdqR5mDyDreMMtEws+CpwaRyyzoYtfcvt9PJIW0fJVNNi/FFyRsea7peLvJrL+5b4GOXJ8tAr+ATk9f8KmiIsRhqRy0vFzwRV3Z5dZ3QqIU8JQ/uQpkJbjMUMFj2F9sCFeaBjI4+fL/oN3+LQgjI4zuAfQ+3IPIPFQBccf0clJpsfpnBxD84atwtupkGqKvrH7cGNl/QcWcSi6wcVDML6ljOgYbo+2BOAWNNjlUBPiyitUAwbnhFvLbnqw42kR3Yp2kv2dMeDdcGOX5kT4S6M44KHEB/SpCfl7xgsUvs+JNY9G3O2X/6FEt9FyAn57lrbiu+tl83sCymSvq9eZbe9mchL7MTf/Ta78e80zSf0hYY5eUU7+ff14jv7Xy8qjzfzzzvaJnrIdvFb5BLWKcWGy5/w7+vV2cvIfwHqdTB+RuJK5oj9mbt0Hy94AmjMjjwYNZlNS6uiyxNnwNyt3gdreLb64p/3+08nXkb92LTkkRgFOwk1oGEVllcOj5lv1hfAZywDows0944U8vUFw+A/nuVq/UCygsrmWIBnHyU01d0XJPwriEOvx/ISK6Pk4y2w0gmojZs7lU8TtakBAdne4v/aNxmMpK4VcGMp7si0yqsiolXRuOi1Z1P7SqD3Zmp0CWcyK4Ubmp2SXiXuI5nGLCieFHKHNRIlcY3Pys2dwMTYCaqlyWSITwr2oGXvyU3h1Pf8eQ3w1bnD7ilocVjYDkcXR3Oo1BXgMLTUjNw2xMVwjtp99NhSVc5aIWrDQT5DHPKtCtheBP4zHcw4dz2eRdTMamhlHhtfgqJJHI7NGDUw1XL8vsSeSHyKqDtqoAmrQqsYwvwi7HW3ojWyhIa5oz5xJTaq14NAzFLjVLR12rRNUQ6xohDnrWFb5bG9yf8aCD8d5phoackcNJp+Dw3Due3RM+5Rid7EuIgsnwgpX0rUWh/nqPtByMhMZZ69NpgvRTKZ62ViZ+Q7Dp5r4K0d7EfJuiy06KuIYauRh5Ecrhdt2QpTS1k1AscEHvapNbU3HL1F2TFyR33Wxb5MvH5iZsrn3SDcsxlnnshO8PLwmdGN+paWnQuORtZGX37uhFT64SeuPsx8UOokY6ON85WdQ1dki5zErsJGazcBOddWJEKqNPiJpsMD1GrVLrVY+AOdPWQneTyyP1hRX/lMM4ZogGGOhYuAdr7F/DOiAoc++cn5vlf0zkMUJ40Z1rlgv9BelPqVOpxKeOpzKdF8maK+1Vv23MO9k/8+qpLoxrIGH2EDQlnGmH8CD31G8QqlyQIcpmR5bwmSVw9/Ns6IHgulCRehvZ/+VrM60Cu/r3AontFfrljew74skYe2uyn7JKQtFQBQRJ9ryGic/zQOsbS4scUBctA8cPToQ3x6ZBQu6DPu5m1bnCtP8TllLYA0UTQNVqza5nfew3Mopy1GPUwG5jsl0OVXniPmAcmLqO5HG8Hv3nSLecE9oOjPDXcsTxoCBxYyzBdj4wmnyEV4kvFDunipS8SSkvdaMnTBN9brHUR8xdmmEAp/Pdqk9uextp1t+JrtXwpN/MG2w/qhRMpSNxQ1uhg/kKO30eQ/FyHUDkWHT8V6gGRU4DhDMxZu7xXij9Ui6jlpWmQCqJg3FkOTq3WKneCRYZxBXMNAVLQgHXSCGSqNdjebY94oyIpVjMYehAiFx/tqzBXFHZaL5PeeD74rW5OysFoUXY8sebUZleFTUa/+zBKVTFDopTReXNuZq47QjkWnxjirCommO4L/GrFtVV21EpMyw8wyThL5Y59d88xtlx1g1ttSICDwnof6lt/6zliPzgVUL8jWBjC0o2D6Kg+jNuThkAlaDJsq/AG2aKA//A76avw2KNqtv223P+Wq3StRDDNKFFgtsFukYt1GFDWooFVXitaNhb3RCyJi4cMeNjROiPEDb4k+G3+hD8tsg+5hhmSc/8t2JTSwYoCzAI75doq8QTHe+E/Tw0RQSUDlU+6uBeNN3h6jJGX/mH8oj0i3caCNsjvTnoh73BtyZpsflHLq6AfwJNCDX4S98h4+pCOhGKDhV3rtkKHMa3EG4J9y8zFWI4UsfNzC/Rl5midNn7gwoN9j23HGCQQ+OAZpTTPMdiVow740gIyuEtd0qVxMyNXhHcnuXRKdw5wDUSL358ktjMXmAkvIB73BLa1vfF9BAUZInPYJiwxqFWQQBVk7gQH4ojfUQ/KEjn+A/WR6EEe4CtbpoLe1mzHkajgTIoE0SLDHVauKhrq12zrAXBGbPPWKCt4DGedq3JyGRbmPFW32bE7T20+73BatV/qQhhBWfWBFHfhYWXjALts38FemnoT+9bn1jDBMcUMmYgSc0e7GQjv2MUBwLU8ionCpgV+Qrhg7iUIfUY6JFxR0Y+ZTCPM+rVuq0GNLyJXX6nrUTt8HzFBRY1E/FIm2EeVA9NcXrj7S6YYIChVQCWr/m2fYUjC4j0XLkzZ8GCSLfmkW3PB/xq+nlXsKVBOj7vTvqKCOMq7Ztqr3cQ+N8gBnPaAps+oGwWOkbuxnRYj/x/WjiDclVrs22xMK4qArE1Ztk1456kiJriw6abkNeRHogaPRBgbgF9Z8i/tbzWELN4CvbqtrqV9TtGSnmPS2F9kqOIBaazHYaJ9bi3AoDBvlZasMluxt0BDXfhp02Jn411aVt6S4TUB8ZgFDkI6TP6gwPY85w+oUQSsjIeXVminrwIdK2ZAawb8Se6XOJbOaliQxHSrnAeONDLuCnFejIbp4YDtBcQCwMsYiRZfHefuEJqJcwKTTJ8sx5hjHmJI1sPFHOr6W9AhZ2NAod38mnLQk1gOz2LCAohoQbgMbUK9RMEA3LkiF7Sr9tLZp6lkciIGhE2V546w3Mam53VtVkGbB9w0Yk2XiRnCmbpxmHr2k4eSC0RuNbjNsUfDIfc8DZvRvgUDe1IlKdZTzcT4ZGEb53dp8VtsoZlyXzLHOdAbsp1LPTVaHvLA0GYDFMbAW/WUBfUAdHwqLFAV+3uHvYWrCfhUOR2i89qvCBoOb48usAGdcF2M4aKn79k/43WzBZ+xR1L0uZfia70XP9soQReeuhZiUnXFDG1T8/OXNmssTSnYO+3kVLAgeiY719uDwL9FQycgLPessNihMZbAKG7qwPZyG11G1+ZA3jAX2yddpYfmaKBlmfcK/V0mwIRUDC0nJSOPUl2KB8h13F4dlVZiRhdGY5farwN+f9hEb1cRi41ZcGDn6Xe9MMSTOY81ULJyXIHSWFIQHstVYLiJEiUjktlHiGjntN5/btB8Fu+vp28zl2fZXN+dJDyN6EXhS+0yzqpl/LSJNEUVxmu7BsNdjAY0jVsAhkNuuY0E1G48ej25mSt+00yPbQ4SRCVkIwb6ISvYtmJRPz9Zt5dk76blf+lJwAPH5KDF+vHAmACLoCdG2Adii6dOHnNJnTmZtoOGO8Q1jy1veMw6gbLFToQmfJa7nT7Al89mRbRkZZQxJTKgK5Kc9INzmTJFp0tpAPzNmyL/F08bX3nhCumM/cR/2RPn9emZ3VljokttZD1zVWXlUIqEU7SLk5I0lFRU0AcENXBYazNaVzsVHA/sD3o9hm42wbHIRb/BBQTKzAi8s3+bMtpOOZgLdQzCYPfX3UUxKd1WYVkGH7lh/RBBgMZZwXzU9+GYxdBqlGs0LP+DZ5g2BWNh6FAcR944B+K/JTWI3t9YyVyRhlP4CCoUk/mmF7+r2pilVBjxXBHFaBfBtr9hbVn2zDuI0kEOG3kBx8CGdPOjX1ph1POOZJUO1JEGG0jzUy2tK4X0CgVNYhmkqqQysRNtKuPdCJqK3WW57kaV17vXgiyPrl4KEEWgiGF1euI4QkSFHFf0TDroQiLNKJiLbdhH0YBhriRNCHPxSqJmNNoketaioohqMglh6wLtEGWSM1EZbQg72h0UJAIPVFCAJOThpQGGdKfFovcwEeiBuZHN2Ob4uVM7+gwZLz1D9E7ta4RmMZ24OBBAg7Eh6dLXGofZ4U2TFOCQMKjwhVckjrydRS+YaqCw1kYt6UexuzbNEDyYLTZnrY1PzsHZJT4U+awO2xlqTSYu6n/U29O2wPXgGOEKDMSq+zTUtyc8+6iLp0ivav4FKx+xxVy4FxhIF/pucVDqpsVe2jFOfdZhTzLz2QjtzvsTCvDPU7bzDH2eXVKUV9TZ+qFtaSSxnYgYdXKwVreIgvWhT9eGDB2OvnWyPLfIIIfNnfIxU8nW7MbcH05nhlsYtaW9EZRsxWcKdEqInq1DiZPKCz7iGmAU9/ccnnQud2pNgIGFYOTAWjhIrd63aPDgfj8/sdlD4l+UTlcxTI9jbaMqqN0gQxSHs60IAcW3cH4p3V1aSciTKB29L1tz2eUQhRiTgTvmqc+sGtBNh4ky0mQJGsdycBREP+fAaSs1EREDVo5gvgi5+aCN7NECw30owbCc1mSpjiahyNVwJd1jiGgzSwfTpzf2c5XJvG/g1n0fH88KHNnf+u7ZiRMlXueSIsloJBUtW9ezvsx9grfsX/FNxnbxU1Lvg0hLxixypHKGFAaPu0xCD8oDTeFSyfRT6s8109GMUZL8m2xXp8X2dpPCWWdX84iga4BrTlOfqox4shqEgh/Ht4qRst52cA1xOIUuOxgfUivp6v5f8IVyaryEdpVk72ERAwdT4aoY1usBgmP+0m06Q216H/nubtNYxHaOIYjcach3A8Ez/zc0KcShhel0HCYjFsA0FjYqyJ5ZUH1aZw3+zWC0hLpM6GDfcAdn9fq2orPmZbW6XXrf+Krc9RtvII5jeD3dFoT1KwZJwxfUMvc5KLfn8rROW23Jw89sJ2a5dpB3qWDUBWF2iX8OCuKprHosJ2mflBR+Wqs86VvgI/XMnsqb97+VlKdPVysczPj8Jhzf+WCvGBHijAqYlavbF60soMWlHbvKT+ScvhprgeTln51xX0sF+Eadc/l2s2a5BgkVbHYyz0E85p0LstqH+gEGiR84nBRRFIn8hLSZrGwqjZ3E29cuGi+5Z5bp7EM8MWFa9ssS/vy4VrDfECSv7DSU84DaP0sXI3Ap4lWznQ65nQoTKRWU30gd7Nn8ZowUvGIx4aqyXGwmA/PB4qN8msJUODezUHEl0VP9uo+cZ8vPFodSIB4C7lQYjEFj8yu49C2KIV3qxMFYTevG8KqAr0TPlkbzHHnTpDpvpzziAiNFh8xiT7C/TiyH0EguUw4vxAgpnE27WIypV+uFN2zW7xniF/n75trs9IJ5amB1zXXZ1LFkJ6GbS/dFokzl4cc2mamVwhL4XU0Av5gDWAl+aEWhAP7t2VIwU+EpvfOPDcLASX7H7lZpXA2XQfbSlD4qU18NffNPoAKMNSccBfO9YVVgmlW4RydBqfHAV7+hrZ84WJGho6bNT0YMhxxLdOx/dwGj0oyak9aAkNJ8lRJzUuA8sR+fPyiyTgUHio5+Pp+YaKlHrhR41jY5NESPS3x+zTMe0S2HnLOKCOQPpdxKyviBvdHrCDRqO+l96HhhNBLXWv4yEMuEUYo8kXnYJM8oIgVM4XJ+xXOev4YbWeqsvgq0lmw4/PiYr9sYLt+W5EAuYSFnJEan8CwJwbtASBfLBBpJZiRPor/aCJBZsM+MhvS7ZepyHvU8m5WSmaZnxuLts8ojl6KkS8oSAHkq5GWlCB/NgJ5W3rO2Cj1MK7ahxsCrbTT3a0V/QQH+sErxV4XUWDHx0kkFy25bPmBMBQ6BU3HoHhhYcJB9JhP6NXUWKxnE0raXHB6U9KHpWdQCQI72qevp5fMzcm+AvC85rsynVQhruDA9fp9COe7N56cg1UKGSas89vrN+WlGLYTwi5W+0xYdKEGtGCeNJwXKDU0XqU5uQYnWsMwTENLGtbQMvoGjIFIEMzCRal4rnBAg7D/CSn8MsCvS+FDJJAzoiioJEhZJgAp9n2+1Yznr7H+6eT4YkJ9Mpj60ImcW4i4iHDLn9RydB8dx3QYm3rsX6n4VRrZDsYK6DCGwkwd5n3/INFEpk16fYpP6JtMQpqEMzcOfQGAHXBTEGzuLJ03GYQL9bmV2/7ExDlRf+Uvf1sM2frRtCWmal12pMgtonvSCtR4n1CLUZRdTHDHP1Otwqd+rcdlavnKjUB/OYXQHUJzpNyFoKpQK+2OgrEKpGyIgIBgn2y9QHnTJihZOpEvOKIoHAMGAXHmj21Lym39Mbiow4IF+77xNuewziNVBxr6KD5e+9HzZSBIlUa/AmsDFJFXeyrQakR3FwowTGcADJHcEfhGkXYNGSYo4dh4bxwLM+28xjiqkdn0/3R4UEkvcBrBfn/SzBc1XhKM2VPlJgKSorjDac96V2UnQYXl1/yZPT4DVelgO+soMjexXwYO58VLl5xInQUZI8jc3H2CPnCNb9X05nOxIy4MlecasTqGK6s2az4RjpF2cQP2G28R+7wDPsZDZC/kWtjdoHC7SpdPmqQrUAhMwKVuxCmYTiD9q/O7GHtZvPSN0CAUQN/rymXZNniYLlJDE70bsk6Xxsh4kDOdxe7A2wo7P9F5YvqqRDI6brf79yPCSp4I0jVoO4YnLYtX5nzspR5WB4AKOYtR1ujXbOQpPyYDvfRE3FN5zw0i7reehdi7yV0YDRKRllGCGRk5Yz+Uv1fYl2ZwrnGsqsjgAVo0xEUba8ohjaNMJNwTwZA/wBDWFSCpg1eUH8MYL2zdioxRTqgGQrDZxQyNzyBJPXZF0+oxITJAbj7oNC5JwgDMUJaM5GqlGCWc//KCIrI+aclEe4IA0uzv7cuj6GCdaJONpi13O544vbtIHBF+A+JeDFUQNy61Gki3rtyQ4aUywn6ru314/dkGiP8Iwjo0J/2Txs49ZkwEl4mx+iYUUO55I6pJzU4P+7RRs+DXZkyKUYZqVWrPF4I94m4Wx1tXeE74o9GuX977yvJ/jkdak8+AmoHVjI15V+WwBdARFV2IPirJgVMdsg1Pez2VNHqa7EHWdTkl3XTcyjG9BiueWFvQfXI8aWSkuuRmqi/HUuzqyvLJfNfs0txMqldYYflWB1BS31WkuPJGGwXUCpjiQSktkuBMWwHjSkQxeehqw1Kgz0Trzm7QbtgxiEPDVmWCNCAeCfROTphd1ZNOhzLy6XfJyG6Xgd5MCAZw4xie0Sj5AnY1/akDgNS9YFl3Y06vd6FAsg2gVQJtzG7LVq1OH2frbXNHWH/NY89NNZ4QUSJqL2yEcGADbT38X0bGdukqYlSoliKOcsSTuqhcaemUeYLLoI8+MZor2RxXTRThF1LrHfqf/5LcLAjdl4EERgUysYS2geE+yFdasU91UgUDsc2cSQ1ZoT9+uLOwdgAmifwQqF028INc2IQEDfTmUw3eZxvz7Ud1z3xc1PQfeCvfKsB9jOhRj7rFyb9XcDWLcYj0bByosychMezMLVkFiYcdBBQtvI6K0KRuOZQH2kBsYHJaXTkup8F0eIhO1/GcIwWKpr2mouB7g5TUDJNvORXPXa/mU8bh27TAZYBe2sKx4NSv5OjnHIWD2RuysCzBlUfeNXhDd2jxnHoUlheJ3jBApzURy0fwm2FwwsSU0caQGl0Kv8hopRQE211NnvtLRsmCNrhhpEDoNiZEzD2QdJWKbRRWnaFedXHAELSN0t0bfsCsMf0ktfBoXBoNA+nZN9+pSlmuzspFevmsqqcMllzzvkyXrzoA+Ryo1ePXpdGOoJvhyru+EBRsmOp7MXZ0vNUMUqHLUoKglg1p73sWeZmPc+KAw0pE2zIsFFE5H4192KwDvDxdxEYoDBDNZjbg2bmADTeUKK57IPD4fTYF4c6EnXx/teYMORBDtIhPJneiZny7Nv/zG+YmekIKCoxr6kauE2bZtBLufetNG0BtBY7f+/ImUypMBvdWu/Q7vTMRzw5aQGZWuc1V0HEsItFYMIBnoKGZ0xcarba/TYZq50kCaflFysYjA4EDKHqGdpYWdKYmm+a7TADmW35yfnOYpZYrkpVEtiqF0EujI00aeplNs2k+qyFZNeE3CDPL9P6b4PQ/kataHkVpLSEVGK7EX6rAa7IVNrvZtFvOA6okKvBgMtFDAGZOx88MeBcJ8AR3AgUUeIznAN6tjCUipGDZONm1FjWJp4A3QIzSaIOmZ7DvF/ysYYbM/fFDOV0jntAjRdapxJxL0eThpEhKOjCDDq2ks+3GrwxqIFKLe1WdOzII8XIOPGnwy6LKXVfpSDOTEfaRsGujhpS4hBIsMOqHbl16PJxc4EkaVu9wpEYlF/84NSv5Zum4drMfp9yXbzzAOJqqS4YkI4cBrFrC7bMPiCfgI3nNZAqkk3QOZqR+yyqx+nDQKBBBZ7QKrfGMCL+XpqFaBJU0wpkBdAhbR4hJsmT5aynlvkouoxm/NjD5oe6BzVIO9uktM+/5dEC5P7vZvarmuO/lKXz4sBabVPIATuKTrwbJP8XUkdM6uEctHKXICUJGjaZIWRbZp8czquQYfY6ynBUCfIU+gG6wqSIBmYIm9pZpXdaL121V7q0VjDjmQnXvMe7ysoEZnZL15B0SpxS1jjd83uNIOKZwu5MPzg2NhOx3xMOPYwEn2CUzbSrwAs5OAtrz3GAaUkJOU74XwjaYUmGJdZBS1NJVkGYrToINLKDjxcuIlyfVsKQSG/G4DyiO2SlQvJ0d0Ot1uOG5IFSAkq+PRVMgVMDvOIJMdqjeCFKUGRWBW9wigYvcbU7CQL/7meF2KZAaWl+4y9uhowAX7elogAvItAAxo2+SFxGRsHGEW9BnhlTuWigYxRcnVUBRQHV41LV+Fr5CJYV7sHfeywswx4XMtUx6EkBhR+q8AXXUA8uPJ73Pb49i9KG9fOljvXeyFj9ixgbo6CcbAJ7WHWqKHy/h+YjBwp6VcN7M89FGzQ04qbrQtgrOFybg3gQRTYG5xn73ArkfQWjCJROwy3J38Dx/D7jOa6BBNsitEw1wGq780EEioOeD+ZGp2J66ADiVGMayiHYucMk8nTK2zzT9CnEraAk95kQjy4k0GRElLL5YAKLQErJ5rp1eay9O4Fb6yJGm9U4FaMwPGxtKD6odIIHKoWnhKo1U8KIpFC+MVn59ZXmc7ZTBZfsg6FQ8W10YfTr4u0nYrpHZbZ1jXiLmooF0cOm0+mPnJBXQtepc7n0BqOipNCqI6yyloTeRShNKH04FIo0gcMk0H/xThyN4pPAWjDDkEp3lNNPRNVfpMI44CWRlRgViP64eK0JSRp0WUvCWYumlW/c58Vcz/yMwVcW5oYb9+26TEhwvbxiNg48hl1VI1UXTU//Eta+BMKnGUivctfL5wINDD0giQL1ipt6U7C9cd4+lgqY2lMUZ02Uv6Prs+ZEZer7ZfWBXVghlfOOrClwsoOFKzWEfz6RZu1eCs+K8fLvkts5+BX0gyrFYve0C3qHrn5U/Oh6D/CihmWIrY7HUZRhJaxde+tldu6adYJ+LeXupQw0XExC36RETdNFxcq9glMu4cNQSX9cqR/GQYp+IxUkIcNGWVU7ZtGa6P3XAyodRt0XeS3Tp01AnCh0ZbUh4VrSZeV9RWfSoWyxnY3hzcZ30G/InDq4wxRrEejreBxnhIQbkxenxkaxl+k7eLUQkUR6vKJ2iDFNGX3WmVA1yaOH+mvhBd+sE6vacQzFobwY5BqEAFmejwW5ne7HtVNolOUgJc8CsUxmc/LBi8N5mu9VsIA5HyErnS6zeCz7VLI9+n/hbT6hTokMXTVyXJRKSG2hd2labXTbtmK4fNH3IZBPreSA4FMeVouVN3zG5x9CiGpLw/3pceo4qGqp+rVp+z+7yQ98oEf+nyH4F3+J9IheDBa94Wi63zJbLBCIZm7P0asHGpIJt3PzE3m0S4YIWyXBCVXGikj8MudDPB/6Nm2v4IxJ5gU0ii0guy5SUHqGUYzTP0jIJU5E82RHUXtX4lDdrihBLdP1YaG1AGUC12rQKuIaGvCpMjZC9bWSCYnjDlvpWbkdXMTNeBHLKiuoozMGIvkczmP0aRJSJ8PYnLCVNhKHXBNckH79e8Z8Kc2wUej4sQZoH8qDRGkg86maW/ZQWGNnLcXmq3FlXM6ssR/3P6E/bHMvm6HLrv1yRixit25JsH3/IOr2UV4BWJhxXW5BJ6Xdr07n9kF3ZNAk6/Xpc5MSFmYJ2R7bdL8Kk7q1OU9Elg/tCxJ8giT27wSTySF0GOxg4PbYJdi/Nyia9Nn89CGDulfJemm1aiEr/eleGSN+5MRrVJ4K6lgyTTIW3i9cQ0dAi6FHt0YMbH3wDSAtGLSAccezzxHitt1QdhW36CQgPcA8vIIBh3/JNjf/Obmc2yzpk8edSlS4lVdwgW5vzbYEyFoF4GCBBby1keVNueHAH+evi+H7oOVfS3XuPQSNTXOONAbzJeSb5stwdQHl1ZjrGoE49I8+A9j3t+ahhQj74FCSWpZrj7wRSFJJnnwi1T9HL5qrCFW/JZq6P62XkMWTb+u4lGpKfmmwiJWx178GOG7KbrZGqyWwmuyKWPkNswkZ1q8uptUlviIi+AXh2bOOTOLsrtNkfqbQJeh24reebkINLkjut5r4d9GR/r8CBa9SU0UQhsnZp5cP+RqWCixRm7i4YRFbtZ4EAkhtNa6jHb6gPYQv7MKqkPLRmX3dFsK8XsRLVZ6IEVrCbmNDc8o5mqsogjAQfoC9Bc7R6gfw03m+lQpv6kTfhxscDIX6s0w+fBxtkhjXAXr10UouWCx3C/p/FYwJRS/AXRKkjOb5CLmK4XRe0+xeDDwVkJPZau52bzLEDHCqV0f44pPgKOkYKgTZJ33fmk3Tu8SdxJ02SHM8Fem5SMsWqRyi2F1ynfRJszcFKykdWlNqgDA/L9lKYBmc7Zu/q9ii1FPF47VJkqhirUob53zoiJtVVRVwMR34gV9iqcBaHbRu9kkvqk3yMpfRFG49pKKjIiq7h/VpRwPGTHoY4cg05X5028iHsLvUW/uz+kjPyIEhhcKUwCkJAwbR9pIEGOn8z6svAO8i89sJ3dL5qDWFYbS+HGPRMxYwJItFQN86YESeJQhn2urGiLRffQeLptDl8dAgb+Tp47UQPxWOw17OeChLN1WnzlkPL1T5O+O3Menpn4C3IY5LEepHpnPeZHbvuWfeVtPlkH4LZjPbBrkJT3NoRJzBt86CO0Xq59oQ+8dsm0ymRcmQyn8w71mhmcuEI5byuF+C88VPYly2sEzjlzAQ3vdn/1+Hzguw6qFNNbqenhZGbdiG6RwZaTG7jTA2X9RdXjDN9yj1uQpyO4Lx8KRAcZcbZMafp4wPOd5MdXoFY52V1A8M9hi3sso93+uprE0qYNMjkE22CvK4HuUxqN7oIz5pWuETq1lQAjqlSlqdD2Rnr/ggp/TVkQYjn9lMfYelk2sH5HPdopYo7MHwlV1or9Bxf+QCyLzm92vzG2wjiIjC/ZHEJzeroJl6bdFPTpZho5MV2U86fLQqxNlGIMqCGy+9WYhJ8ob1r0+Whxde9L2PdysETv97O+xVw+VNN1TZSQN5I6l9m5Ip6pLIqLm4a1B1ffH6gHyqT9p82NOjntRWGIofO3bJz5GhkvSWbsXueTAMaJDou99kGLqDlhwBZNEQ4mKPuDvVwSK4WmLluHyhA97pZiVe8g+JxmnJF8IkV/tCs4Jq/HgOoAEGR9tCDsDbDmi3OviUQpG5D8XmKcSAUaFLRXb2lmJTNYdhtYyfjBYZQmN5qT5CNuaD3BVnlkCk7bsMW3AtXkNMMTuW4HjUERSJnVQ0vsBGa1wo3Qh7115XGeTF3NTz8w0440AgU7c3bSXO/KMINaIWXd0oLpoq/0/QJxCQSJ9XnYy1W7TYLBJpHsVWD1ahsA7FjNvRd6mxCiHsm8g6Z0pnzqIpF1dHUtP2ITU5Z1hZHbu+L3BEEStBbL9XYvGfEakv1bmf+bOZGnoiuHEdlBnaChxYKNzB23b8sw8YyT7Ajxfk49eJIAvdbVkdFCe2J0gMefhQ0bIZxhx3fzMIysQNiN8PgOUKxOMur10LduigREDRMZyP4oGWrP1GFY4t6groASsZ421os48wAdnrbovNhLt7ScNULkwZ5AIZJTrbaKYTLjA1oJ3sIuN/aYocm/9uoQHEIlacF1s/TM1fLcPTL38O9fOsjMEIwoPKfvt7opuI9G2Hf/PR4aCLDQ7wNmIdEuXJ/QNL72k5q4NejAldPfe3UVVqzkys8YZ/jYOGOp6c+YzRCrCuq0M11y7TiN6qk7YXRMn/gukxrEimbMQjr3jwRM6dKVZ4RUfWQr8noPXLJq6yh5R3EH1IVOHESst/LItbG2D2vRsZRkAObzvQAAD3mb3/G4NzopI0FAiHfbpq0X72adg6SRj+8OHMShtFxxLZlf/nLgRLbClwl5WmaYSs+yEjkq48tY7Z2bE0N91mJwt+ua0NlRJIDh0HikF4UvSVorFj2YVu9YeS5tfvlVjPSoNu/Zu6dEUfBOT555hahBdN3Sa5Xuj2Rvau1lQNIaC944y0RWj9UiNDskAK1WoL+EfXcC6IbBXFRyVfX/WKXxPAwUyIAGW8ggZ08hcijKTt1YKnUO6QPvcrmDVAb0FCLIXn5id4fD/Jx4tw/gbXs7WF9b2RgXtPhLBG9vF5FEkdHAKrQHZAJC/HWvk7nvzzDzIXZlfFTJoC3JpGgLPBY7SQTjGlUvG577yNutZ1hTfs9/1nkSXK9zzKLRZ3VODeKUovJe0WCq1zVMYxCJMenmNzPIU2S8TA4E7wWmbNkxq9rI2dd6v0VpcAPVMxnDsvWTWFayyqvKZO7Z08a62i/oH2/jxf8rpmfO64in3FLiL1GX8IGtVE9M23yGsIqJbxDTy+LtaMWDaPqkymb5VrQdzOvqldeU0SUi6IirG8UZ3jcpRbwHa1C0Dww9G/SFX3gPvTJQE+kyz+g1BeMILKKO+olcHzctOWgzxYHnOD7dpCRtuZEXACjgqesZMasoPgnuDC4nUviAAxDc5pngjoAITIkvhKwg5d608pdrZcA+qn5TMT6Uo/QzBaOxBCLTJX3Mgk85rMfsnWx86oLxf7p2PX5ONqieTa/qM3tPw4ZXvlAp83NSD8F7+ZgctK1TpoYwtiU2h02HCGioH5tkVCqNVTMH5p00sRy2JU1qyDBP2CII/Dg4WDsIl+zgeX7589srx6YORRQMBfKbodbB743Tl4WLKOEnwWUVBsm94SOlCracU72MSyj068wdpYjyz1FwC2bjQnxnB6Mp/pZ+yyZXtguEaYB+kqhjQ6UUmwSFazOb+rhYjLaoiM+aN9/8KKn0zaCTFpN9eKwWy7/u4EHzO46TdFSNjMfn2iPSJwDPCFHc0I1+vjdAZw5ZjqR/uzi9Zn20oAa5JnLEk/EA3VRWE7J/XrupfFJPtCUuqHPpnlL7ISJtRpSVcB8qsZCm2QEkWoROtCKKxUh3yEcMbWYJwk6DlEBG0bZP6eg06FL3v6RPb7odGuwm7FN8fG4woqtB8e7M5klPpo97GoObNwt+ludTAmxyC5hmcFx+dIvEZKI6igFKHqLH01iY1o7903VzG9QGetyVx5RNmBYUU+zIuSva/yIcECUi4pRmE3VkF2avqulQEUY4yZ/wmNboBzPmAPey3+dSYtBZUjeWWT0pPwCz4Vozxp9xeClIU60qvEFMQCaPvPaA70WlOP9f/ey39macvpGCVa+zfa8gO44wbxpJUlC8GN/pRMTQtzY8Z8/hiNrU+Zq64ZfFGIkdj7m7abcK1EBtws1X4J/hnqvasPvvDSDYWN+QcQVGMqXalkDtTad5rYY0TIR1Eqox3czwPMjKPvF5sFv17Thujr1IZ1Ytl4VX1J0vjXKmLY4lmXipRAro0qVGEcXxEVMMEl54jQMd4J7RjgomU0j1ptjyxY+cLiSyXPfiEcIS2lWDK3ISAy6UZ3Hb5vnPncA94411jcy75ay6B6DSTzK6UTCZR9uDANtPBrvIDgjsfarMiwoax2OlLxaSoYn4iRgkpEGqEkwox5tyI8aKkLlfZ12lO11TxsqRMY89j5JaO55XfPJPDL1LGSnC88Re9Ai+Nu5bZjtwRrvFITUFHPR4ZmxGslQMecgbZO7nHk32qHxYkdvWpup07ojcMCaVrpFAyFZJJbNvBpZfdf39Hdo2kPtT7v0/f8R/B5Nz4f1t9/3zNM/7n6SUHfcWk5dfQFJvcJMgPolGCpOFb/WC0FGWU2asuQyT+rm88ZKZ78Cei/CAh939CH0JYbpZIPtxc2ufXqjS3pHH9lnWK4iJ7OjR/EESpCo2R3MYKyE7rHfhTvWho4cL1QdN4jFTyR6syMwFm124TVDDRXMNveI1Dp/ntwdz8k8kxw7iFSx6+Yx6O+1LzMVrN0BBzziZi9kneZSzgollBnVwBh6oSOPHXrglrOj+QmR/AESrhDpKrWT+8/AiMDxS/5wwRNuGQPLlJ9ovomhJWn8sMLVItQ8N/7IXvtD8kdOoHaw+vBSbFImQsv/OCAIui99E+YSIOMlMvBXkAt+NAZK8wB9Jf8CPtB+TOUOR+z71d/AFXpPBT6+A5FLjxMjLIEoJzrQfquvxEIi+WoUzGR1IzQFNvbYOnxb2PyQ0kGdyXKzW2axQL8lNAXPk6NEjqrRD1oZtKLlFoofrXw0dCNWASHzy+7PSzOUJ3XtaPZsxLDjr+o41fKuKWNmjiZtfkOzItvlV2MDGSheGF0ma04qE3TUEfqJMrXFm7DpK+27DSvCUVf7rbNoljPhha5W7KBqVq0ShUSTbRmuqPtQreVWH4JET5yMhuqMoSd4r/N8sDmeQiQQvi1tcZv7Moc7dT5X5AtCD6kNEGZOzVcNYlpX4AbTsLgSYYliiPyVoniuYYySxsBy5cgb3pD+EK0Gpb0wJg031dPgaL8JZt6sIvzNPEHfVPOjXmaXj4bd4voXzpZ5GApMhILgMbCEWZ2zwgdeQgjNHLbPIt+KqxRwWPLTN6HwZ0Ouijj4UF+Sg0Au8XuIKW0WxlexdrFrDcZJ8Shauat3X0XmHygqgL1nAu2hrJFb4wZXkcS+i36KMyU1yFvYv23bQUJi/3yQpqr/naUOoiEWOxckyq/gq43dFou1DVDaYMZK9tho7+IXXokBCs5GRfOcBK7g3A+jXQ39K4YA8PBRW4m5+yR0ZAxWJncjRVbITvIAPHYRt1EJ3YLiUbqIvoKHtzHKtUy1ddRUQ0AUO41vonZDUOW+mrszw+SW/6Q/IUgNpcXFjkM7F4CSSQ2ExZg85otsMs7kqsQD4OxYeBNDcSpifjMoLb7GEbGWTwasVObmB/bfPcUlq0wYhXCYEDWRW02TP5bBrYsKTGWjnWDDJ1F7zWai0zW/2XsCuvBQjPFcTYaQX3tSXRSm8hsAoDdjArK/OFp6vcWYOE7lizP0Yc+8p16i7/NiXIiiQTp7c7Xus925VEtlKAjUdFhyaiLT7VxDagprMFwix4wZ05u0qj7cDWFd0W9OYHIu3JbJKMXRJ1aYNovugg+QqRN7fNHSi26VSgBpn+JfMuPo3aeqPWik/wI5Rz3BWarPQX4i5+dM0npwVOsX+KsOhC7vDg+OJsz4Q5zlnIeflUWL6QYMbf9WDfLmosLF4Qev3mJiOuHjoor/dMeBpA9iKDkMjYBNbRo414HCxjsHrB4EXNbHzNMDHCLuNBG6Sf+J4MZ/ElVsDSLxjIiGsTPhw8BPjxbfQtskj+dyNMKOOcUYIRBEIqbazz3lmjlRQhplxq673VklMMY6597vu+d89ec/zq7Mi4gQvh87ehYbpOuZEXj5g/Q7S7BFDAAB9DzG35SC853xtWVcnZQoH54jeOqYLR9NDuwxsVthTV7V99n/B7HSbAytbEyVTz/5NhJ8gGIjG0E5j3griULUd5Rg7tQR+90hJgNQKQH2btbSfPcaTOfIexc1db1BxUOhM1vWCpLaYuKr3FdNTt/T3PWCpEUWDKEtzYrjpzlL/wri3MITKsFvtF8QVV/NhVo97aKIBgdliNc10dWdXVDpVtsNn+2UIolrgqdWA4EY8so0YvB4a+aLzMXiMAuOHQrXY0tr+CL10JbvZzgjJJuB1cRkdT7DUqTvnswVUp5kkUSFVtIIFYK05+tQxT6992HHNWVhWxUsD1PkceIrlXuUVRogwmfdhyrf6zzaL8+c0L7GXMZOteAhAVQVwdJh+7nrX7x4LaIIfz2F2v7Dg/uDfz2Fa+4gFm2zHAor8UqimJG3VTJtZEoFXhnDYXvxMJFc6ku2bhbCxzij2z5UNuK0jmp1mnvkVNUfR+SEmj1Lr94Lym75PO7Fs0MIr3GdsWXRXSfgLTVY0FLqba97u1In8NAcY7IC6TjWLigwKEIm43NxTdaVTv9mcKkzuzBkKd8x/xt1p/9BbP7Wyb4bpo1K1gnOpbLvKz58pWl3B55RJ/Z5mRDLPtNQg14jdOEs9+h/V5UVpwrAI8kGbX8KPVPDIMfIqKDjJD9UyDOPhjZ3vFAyecwyq4akUE9mDOtJEK1hpDyi6Ae87sWAClXGTiwPwN7PXWwjxaR79ArHRIPeYKTunVW24sPr/3HPz2IwH8oKH4OlWEmt4BLM6W5g4kMcYbLwj2usodD1088stZA7VOsUSpEVl4w7NMb1EUHMRxAxLF0CIV+0L3iZb+ekB1vSDSFjAZ3hfLJf7gFaXrOKn+mhR+rWw/eTXIcAgl4HvFuBg1LOmOAwJH3eoVEjjwheKA4icbrQCmvAtpQ0mXG0agYp5mj4Rb6mdQ+RV4QBPbxMqh9C7o8nP0Wko2ocnCHeRGhN1XVyT2b9ACsL+6ylUy+yC3QEnaKRIJK91YtaoSrcWZMMwxuM0E9J68Z+YyjA0g8p1PfHAAIROy6Sa04VXOuT6A351FOWhKfTGsFJ3RTJGWYPoLk5FVK4OaYR9hkJvezwF9vQN1126r6isMGXWTqFW+3HL3I/jurlIdDWIVvYY+s6yq7lrFSPAGRdnU7PVwY/SvWbZGpXzy3BQ2LmAJlrONUsZs4oGkly0V267xbD5KMY8woNNsmWG1VVgLCra8aQBBcI4DP2BlNwxhiCtHlaz6OWFoCW0vMR3ErrG7JyMjTSCnvRcsEHgmPnwA6iNpJ2DrFb4gLlhKJyZGaWkA97H6FFdwEcLT6DRQQL++fOkVC4cYGW1TG/3iK5dShRSuiBulmihqgjR45Vi03o2RbQbP3sxt90VxQ6vzdlGfkXmmKmjOi080JSHkLntjvsBJnv7gKscOaTOkEaRQqAnCA4HWtB4XnMtOhpRmH2FH8tTXrIjAGNWEmudQLCkcVlGTQ965Kh0H6ixXbgImQP6b42B49sO5C8pc7iRlgyvSYvcnH9FgQ3azLbQG2cUW96SDojTQStxkOJyOuDGTHAnnWkz29aEwN9FT8EJ4yhXOg+jLTrCPKeEoJ9a7lDXOjEr8AgX4BmnMQ668oW0zYPyQiVMPxKRHtpfnEEyaKhdzNVThlxxDQNdrHeZiUFb6NoY2KwvSb7BnRcpJy+/g/zAYx3fYSN5QEaVD2Y1VsNWxB0BSO12MRsRY8JLfAezRMz5lURuLUnG1ToKk6Q30FughqWN6gBNcFxP/nY/iv+iaUQOa+2Nuym46wtI/DvSfzSp1jEi4SdYBE7YhTiVV5cX9gwboVDMVgZp5YBQlHOQvaDNfcCoCJuYhf5kz5kwiIKPjzgpcRJHPbOhJajeoeRL53cuMahhV8Z7IRr6M4hW0JzT7mzaMUzQpm866zwM7Cs07fJYXuWvjAMkbe5O6V4bu71sOG6JQ4oL8zIeXHheFVavzxmlIyBkgc9IZlEDplMPr8xlcyss4pVUdwK1e7CK2kTsSdq7g5SHRAl3pYUB9Ko4fsh4qleOyJv1z3KFSTSvwEcRO/Ew8ozEDYZSqpfoVW9uhJfYrNAXR0Z3VmeoAD+rVWtwP/13sE/3ICX3HhDG3CMc476dEEC0K3umSAD4j+ZQLVdFOsWL2C1TH5+4KiSWH+lMibo+B55hR3Gq40G1n25sGcN0mEcoU2wN9FCVyQLBhYOu9aHVLWjEKx2JIUZi5ySoHUAI9b8hGzaLMxCZDMLhv8MkcpTqEwz9KFDpCpqQhVmsGQN8m24wyB82FAKNmjgfKRsXRmsSESovAwXjBIoMKSG51p6Um8b3i7GISs7kjTq/PZoioCfJzfKdJTN0Q45kQEQuh9H88M3yEs3DbtRTKALraM0YC8laiMiOOe6ADmTcCiREeAWZelBaEXRaSuj2lx0xHaRYqF65O0Lo5OCFU18A8cMDE4MLYm9w2QSr9NgQAIcRxZsNpA7UJR0e71JL+VU+ISWFk5I97lra8uGg7GlQYhGd4Gc6rxsLFRiIeGO4abP4S4ekQ1fiqDCy87GZHd52fn5aaDGuvOmIofrzpVwMvtbreZ/855OaXTRcNiNE0wzGZSxbjg26v8ko8L537v/XCCWP2MFaArJpvnkep0pA+O86MWjRAZPQRfznZiSIaTppy6m3p6HrNSsY7fDtz7Cl4V/DJAjQDoyiL2uwf1UHVd2AIrzBUSlJaTj4k6NL97a/GqhWKU9RUmjnYKpm2r+JYUcrkCuZKvcYvrg8pDoUKQywY9GDWg03DUFSirlUXBS5SWn/KAntnf0IdHGL/7mwXqDG+LZYjbEdQmqUqq4y54TNmWUP7IgcAw5816YBzwiNIJiE9M4lPCzeI/FGBeYy3p6IAmH4AjXXmvQ4Iy0Y82NTobcAggT2Cdqz6Mx4TdGoq9fn2etrWKUNFyatAHydQTVUQ2S5OWVUlugcNvoUrlA8cJJz9MqOa/W3iVno4zDHfE7zhoY5f5lRTVZDhrQbR8LS4eRLz8iPMyBL6o4PiLlp89FjdokQLaSBmKHUwWp0na5fE3v9zny2YcDXG/jfI9sctulHRbdkI5a4GOPJx4oAJQzVZ/yYAado8KNZUdEFs9ZPiBsausotXMNebEgr0dyopuqfScFJ3ODNPHgclACPdccwv0YJGQdsN2lhoV4HVGBxcEUeUX/alr4nqpcc1CCR3vR7g40zteQg/JvWmFlUE4mAiTpHlYGrB7w+U2KdSwQz2QJKBe/5eiixWipmfP15AFWrK8Sh1GBBYLgzki1wTMhGQmagXqJ2+FuqJ8f0XzXCVJFHQdMAw8xco11HhM347alrAu+wmX3pDFABOvkC+WPX0Uhg1Z5MVHKNROxaR84YV3s12UcM+70cJ460SzEaKLyh472vOMD3XnaK7zxZcXlWqenEvcjmgGNR2OKbI1s8U+iwiW+HotHalp3e1MGDy6BMVIvajnAzkFHbeVsgjmJUkrP9OAwnEHYXVBqYx3q7LvXjoVR0mY8h+ZaOnh053pdsGkmbqhyryN01eVHySr+CkDYkSMeZ1xjPNVM+gVLTDKu2VGsMUJqWO4TwPDP0VOg2/8ITbAUaMGb4LjL7L+Pi11lEVMXTYIlAZ/QHmTENjyx3kDkBdfcvvQt6tKk6jYFM4EG5UXDTaF5+1ZjRz6W7MdJPC+wTkbDUim4p5QQH3b9kGk2Bkilyeur8Bc20wm5uJSBO95GfYDI1EZipoRaH7uVveneqz43tlTZGRQ4a7CNmMHgXyOQQOL6WQkgMUTQDT8vh21aSdz7ERiZT1jK9F+v6wgFvuEmGngSvIUR2CJkc5tx1QygfZnAruONobB1idCLB1FCfO7N1ZdRocT8/Wye+EnDiO9pzqIpnLDl4bkaRKW+ekBVwHn46Shw1X0tclt/0ROijuUB4kIInrVJU4buWf4YITJtjOJ6iKdr1u+flgQeFH70GxKjhdgt/MrwfB4K/sXczQ+9zYcrD4dhY6qZhZ010rrxggWA8JaZyg2pYij8ieYEg1aZJkZK9O1Re7sB0iouf60rK0Gd+AYlp7soqCBCDGwfKeUQhCBn0E0o0GS6PdmjLi0TtCYZeqazqwN+yNINIA8Lk3iPDnWUiIPLGNcHmZDxfeK0iAdxm/T7LnN+gemRL61hHIc0NCAZaiYJR+OHnLWSe8sLrK905B5eEJHNlWq4RmEXIaFTmo49f8w61+NwfEUyuJAwVqZCLFcyHBKAcIVj3sNzfEOXzVKIndxHw+AR93owhbCxUZf6Gs8cz6/1VdrFEPrv330+9s6BtMVPJ3zl/Uf9rUi0Z/opexfdL3ykF76e999GPfVv8fJv/Y/+/5hEMon1tqNFyVRevV9y9/uIvsG3dbB8GRRrgaEXfhx+2xeOFt+cEn3RZanNxdEe2+B6MHpNbrRE53PlDifPvFcp4kO78ILR0T4xyW/WGPyBsqGdoA7zJJCu1TKbGfhnqgnRbxbB2B3UZoeQ2bz2sTVnUwokTcTU21RxN1PYPS3Sar7T0eRIsyCNowr9amwoMU/od9s2APtiKNL6ENOlyKADstAEWKA+sdKDhrJ6BOhRJmZ+QJbAaZ3/5Fq0/lumCgEzGEbu3yi0Y4I4EgVAjqxh4HbuQn0GrRhOWyAfsglQJAVL1y/6yezS2k8RE2MstJLh92NOB3GCYgFXznF4d25qiP4ZCyI4RYGesut6FXK6GwPpKK8WHEkhYui0AyEmr5Ml3uBFtPFdnioI8RiCooa7Z1G1WuyIi3nSNglutc+xY8BkeW3JJXPK6jd2VIMpaSxpVtFq+R+ySK9J6WG5Qvt+C+QH1hyYUOVK7857nFmyDBYgZ/o+AnibzNVqyYCJQvyDXDTK+iXdkA71bY7TL3bvuLxLBQ8kbTvTEY9aqkQ3+MiLWbEgjLzOH+lXgco1ERgzd80rDCymlpaRQbOYnKG/ODoFl46lzT0cjM5FYVvv0qLUbD5lyJtMUaC1pFlTkNONx6lliaX9o0i/1vws5bNKn5OuENQEKmLlcP4o2ZmJjD4zzd3Fk32uQ4uRWkPSUqb4LBe3EXHdORNB2BWsws5daRnMfNVX7isPSb1hMQdAJi1/qmDMfRUlCU74pmnzjbXfL8PVG8NsW6IQM2Ne23iCPIpryJjYbVnm5hCvKpMa7HLViNiNc+xTfDIaKm3jctViD8A1M9YPJNk003VVr4Zo2MuGW8vil8SLaGpPXqG7I4DLdtl8a4Rbx1Lt4w5Huqaa1XzZBtj208EJVGcmKYEuaeN27zT9EE6a09JerXdEbpaNgNqYJdhP1NdqiPKsbDRUi86XvvNC7rME5mrSQtrzAZVndtSjCMqd8BmaeGR4l4YFULGRBeXIV9Y4yxLFdyoUNpiy2IhePSWzBofYPP0eIa2q5JP4j9G8at/AqoSsLAUuRXtvgsqX/zYwsE+of6oSDbUOo4RMJw+DOUTJq+hnqwKim9Yy/napyZNTc2rCq6V9jHtJbxGPDwlzWj/Sk3zF/BHOlT/fSjSq7FqlPI1q6J+ru8Aku008SFINXZfOfnZNOvGPMtEmn2gLPt+H4QLA+/SYe4j398auzhKIp2Pok3mPC5q1IN1HgR+mnEfc4NeeHYwd2/kpszR3cBn7ni9NbIqhtSWFW8xbUJuUPVOeeXu3j0IGZmFNiwaNZ6rH4/zQ2ODz6tFxRLsUYZu1bfd1uIvfQDt4YD/efKYv8VF8bHGDgK22w2Wqwpi43vNCOXFJZCGMqWiPbL8mil6tsmOTXAWCyMCw73e2rADZj2IK6rqksM3EXF2cbLb4vjB14wa/yXK5vwU+05MzERJ5nXsXsW21o7M+gO0js2OyKciP5uF2iXyb2DiptwQeHeqygkrNsqVCSlldxBMpwHi1vfc8RKpP/4L3Lmpq6DZcvhDDfxTCE3splacTcOtXdK2g303dIWBVe2wD/Gvja1cClFQ67gw0t1ZUttsUgQ1Veky8oOpS6ksYEc4bqseCbZy766SvL3FodmnahlWJRgVCNjPxhL/fk2wyvlKhITH/VQCipOI0dNcRa5B1M5HmOBjTLeZQJy237e2mobwmDyJNHePhdDmiknvLKaDbShL+Is1XTCJuLQd2wmdJL7+mKvs294whXQD+vtd88KKk0DXP8B1Xu9J+xo69VOuFgexgTrcvI6SyltuLix9OPuE6/iRJYoBMEXxU4shQMf4Fjqwf1PtnJ/wWSZd29rhZjRmTGgiGTAUQqRz+nCdjeMfYhsBD5Lv60KILWEvNEHfmsDs2L0A252351eUoYxAysVaCJVLdH9QFWAmqJDCODUcdoo12+gd6bW2boY0pBVHWL6LQDK5bYWh1V8vFvi0cRpfwv7cJiMX3AZNJuTddHehTIdU0YQ/sQ1dLoF2xQPcCuHKiuCWOY30DHe1OwcClLAhqAKyqlnIbH/8u9ScJpcS4kgp6HKDUdiOgRaRGSiUCRBjzI5gSksMZKqy7Sd51aeg0tgJ+x0TH9YH2Mgsap9N7ENZdEB0bey2DMTrBA1hn56SErNHf3tKtqyL9b6yXEP97/rc+jgD2N1LNUH6RM9AzP3kSipr06RkKOolR7HO768jjWiH1X92jA7dkg7gcNcjqsZCgfqWw0tPXdLg20cF6vnQypg7gLtkazrHAodyYfENPQZsdfnjMZiNu4nJO97D1/sQE+3vNFzrSDOKw+keLECYf7RJwVHeP/j79833oZ0egonYB2FlFE5qj02B/LVOMJQlsB8uNg3Leg4qtZwntsOSNidR0abbZmAK4sCzvt8Yiuz2yrNCJoH5O8XvX/vLeR/BBYTWj0sOPYM/jyxRd5+/JziKAABaPcw/34UA3aj/gLZxZgRCWN6m4m3demanNgsx0P237/Q+Ew5VYnJPkyCY0cIVHoFn2Ay/e7U4P19APbPFXEHX94N6KhEMPG7iwB3+I+O1jd5n6VSgHegxgaSawO6iQCYFgDsPSMsNOcUj4q3sF6KzGaH/0u5PQoAj/8zq6Uc9MoNrGqhYeb2jQo0WlGlXjxtanZLS24/OIN5Gx/2g684BPDQpwlqnkFcxpmP/osnOXrFuu4PqifouQH0eF5qCkvITQbJw/Zvy5mAHWC9oU+cTiYhJmSfKsCyt1cGVxisKu+NymEQIAyaCgud/V09qT3nk/9s/SWsYtha7yNpzBIMM40rCSGaJ9u6lEkl00vXBiEt7p9P5IBCiavynEOv7FgLqPdeqxRiCwuFVMolSIUBcoyfUC2e2FJSAUgYdVGFf0b0Kn2EZlK97yyxrT2MVgvtRikfdaAW8RwEEfN+B7/eK8bBdp7URpbqn1xcrC6d2UjdsKbzCjBFqkKkoZt7Mrhg6YagE7spkqj0jOrWM+UGQ0MUlG2evP1uE1p2xSv4dMK0dna6ENcNUF+xkaJ7B764NdxLCpuvhblltVRAf7vK5qPttJ/9RYFUUSGcLdibnz6mf7WkPO3MkUUhR2mAOuGv8IWw5XG1ZvoVMnjSAZe6T7WYA99GENxoHkMiKxHlCuK5Gd0INrISImHQrQmv6F4mqU/TTQ8nHMDzCRivKySQ8dqkpQgnUMnwIkaAuc6/FGq1hw3b2Sba398BhUwUZSAIO8XZvnuLdY2n6hOXws+gq9BHUKcKFA6kz6FDnpxLPICa3qGhnc97bo1FT/XJk48LrkHJ2CAtBv0RtN97N21plfpXHvZ8gMJb7Zc4cfI6MbPwsW7AilCSXMFIEUEmir8XLEklA0ztYbGpTTGqttp5hpFTTIqUyaAIqvMT9A/x+Ji5ejA4Bhxb/cl1pUdOD6epd3yilIdO6j297xInoiBPuEDW2/UfslDyhGkQs7Wy253bVnlT+SWg89zYIK/9KXFl5fe+jow2rd5FXv8zDPrmfMXiUPt9QBO/iK4QGbX5j/7Rx1c1vzsY8ONbP3lVIaPrhL4+1QrECTN3nyKavGG0gBBtHvTKhGoBHgMXHStFowN+HKrPriYu+OZ05Frn8okQrPaaxoKP1ULCS/cmKFN3gcH7HQlVjraCeQmtjg1pSQxeuqXiSKgLpxc/1OiZsU4+n4lz4hpahGyWBURLi4642n1gn9qz9bIsaCeEPJ0uJmenMWp2tJmIwLQ6VSgDYErOeBCfSj9P4G/vI7oIF+l/n5fp956QgxGvur77ynawAu3G9MdFbJbu49NZnWnnFcQHjxRuhUYvg1U/e84N4JTecciDAKb/KYIFXzloyuE1eYXf54MmhjTq7B/yBToDzzpx3tJCTo3HCmVPYfmtBRe3mPYEE/6RlTIxbf4fSOcaKFGk4gbaUWe44hVk9SZzhW80yfW5QWBHxmtUzvMhfVQli4gZTktIOZd9mjJ5hsbmzttaHQB29Am3dZkmx3g/qvYocyhZ2PXAWsNQiIaf+Q8W/MWPIK7/TjvCx5q2XRp4lVWydMc2wIQkhadDB0xsnw/kSEyGjLKjI4coVIwtubTF3E7MJ6LS6UOsJKj82XVAVPJJcepfewbzE91ivXZvOvYfsmMevwtPpfMzGmC7WJlyW2j0jh7AF1JLmwEJSKYwIvu6DHc3YnyLH9ZdIBnQ+nOVDRiP+REpqv++typYHIvoJyICGA40d8bR7HR2k7do6UQTHF4oriYeIQbxKe4Th6+/l1BjUtS9hqORh3MbgvYrStXTfSwaBOmAVQZzpYNqsAmQyjY56MUqty3c/xH6GuhNvNaG9vGbG6cPtBM8UA3e8r51D0AR9kozKuGGSMgLz3nAHxDNnc7GTwpLj7/6HeWp1iksDeTjwCLpxejuMtpMnGJgsiku1sOACwQ9ukzESiDRN77YNESxR5LphOlcASXA5uIts1LnBIcn1J7BLWs49DMALSnuz95gdOrTZr0u1SeYHinno/pE58xYoXbVO/S+FEMMs5qyWkMnp8Q3ClyTlZP52Y9nq7b8fITPuVXUk9ohG5EFHw4gAEcjFxfKb3xuAsEjx2z1wxNbSZMcgS9GKyW3R6KwJONgtA64LTyxWm8Bvudp0M1FdJPEGopM4Fvg7G/hsptkhCfHFegv4ENwxPeXmYhxwZy7js+BeM27t9ODBMynVCLJ7RWcBMteZJtvjOYHb5lOnCLYWNEMKC59BA7covu1cANa2PXL05iGdufOzkgFqqHBOrgQVUmLEc+Mkz4Rq8O6WkNr7atNkH4M8d+SD1t/tSzt3oFql+neVs+AwEI5JaBJaxARtY2Z4mKoUqxds4UpZ0sv3zIbNoo0J4fihldQTX3XNcuNcZmcrB5LTWMdzeRuAtBk3cZHYQF6gTi3PNuDJ0nmR+4LPLoHvxQIxRgJ9iNNXqf2SYJhcvCtJiVWo85TsyFOuq7EyBPJrAdhEgE0cTq16FQXhYPJFqSfiVn0IQnPOy0LbU4BeG94QjdYNB0CiQ3QaxQqD2ebSMiNjaVaw8WaM4Z5WnzcVDsr4eGweSLa2DE3BWViaxhZFIcSTjgxNCAfelg+hznVOYoe5VqTYs1g7WtfTm3e4/WduC6p+qqAM8H4ZyrJCGpewThTDPe6H7CzX/zQ8Tm+r65HeZn+MsmxUciEWPlAVaK/VBaQBWfoG/aRL/jSZIQfep/89GjasWmbaWzeEZ2R1FOjvyJT37O9B8046SRSKVEnXWlBqbkb5XCS3qFeuE9xb9+frEknxWB5h1D/hruz2iVDEAS7+qkEz5Ot5agHJc7WCdY94Ws61sURcX5nG8UELGBAHZ3i+3VulAyT0nKNNz4K2LBHBWJcTBX1wzf+//u/j/9+//v87+9/l9Lbh/L/uyNYiTsWV2LwsjaA6MxTuzFMqmxW8Jw/+IppdX8t/Clgi1rI1SN0UC/r6tX/4lUc2VV1OQReSeCsjUpKZchw4XUcjHfw6ryCV3R8s6VXm67vp4n+lcPV9gJwmbKQEsmrJi9c2vkwrm8HFbVYNTaRGq8D91t9n5+U+aD/hNtN3HjC/nC/vUoGFSCkXP+NlRcmLUqLbiUBl4LYf1U/CCvwtd3ryCH8gUmGITAxiH1O5rnGTz7y1LuFjmnFGQ1UWuM7HwfXtWl2fPFKklYwNUpF2IL/TmaRETjQiM5SJacI+3Gv5MBU8lP5Io6gWkawpyzNEVGqOdx4YlO1dCvjbWFZWbCmeiFKPSlMKtKcMFLs/KQxtgAHi7NZNCQ32bBAW2mbHflVZ8wXKi1JKVHkW20bnYnl3dKWJeWJOiX3oKPBD6Zbi0ZvSIuWktUHB8qDR8DMMh1ZfkBL9FS9x5r0hBGLJ8pUCJv3NYH+Ae8p40mZWd5m5fhobFjQeQvqTT4VKWIYfRL0tfaXKiVl75hHReuTJEcqVlug+eOIIc4bdIydtn2K0iNZPsYWQvQio2qbO3OqAlPHDDOB7DfjGEfVF51FqqNacd6QmgFKJpMfLp5DHTv4wXlONKVXF9zTJpDV4m1sYZqJPhotcsliZM8yksKkCkzpiXt+EcRQvSQqmBS9WdWkxMTJXPSw94jqI3varCjQxTazjlMH8jTS8ilaW8014/vwA/LNa+YiFoyyx3s/KswP3O8QW1jtq45yTM/DX9a8M4voTVaO2ebvw1EooDw/yg6Y1faY+WwrdVs5Yt0hQ5EwRfYXSFxray1YvSM+kYmlpLG2/9mm1MfmbKHXr44Ih8nVKb1M537ZANUkCtdsPZ80JVKVKabVHCadaLXg+IV8i5GSwpZti0h6diTaKs9sdpUKEpd7jDUpYmHtiX33SKiO3tuydkaxA7pEc9XIQEOfWJlszj5YpL5bKeQyT7aZSBOamvSHl8xsWvgo26IP/bqk+0EJUz+gkkcvlUlyPp2kdKFtt7y5aCdks9ZJJcFp5ZWeaWKgtnXMN3ORwGLBE0PtkEIek5FY2aVssUZHtsWIvnljMVJtuVIjpZup/5VL1yPOHWWHkOMc6YySWMckczD5jUj2mlLVquFaMU8leGVaqeXis+aRRL8zm4WuBk6cyWfGMxgtr8useQEx7k/PvRoZyd9nde1GUCV84gMX8Ogu/BWezYPSR27llzQnA97oo0pYyxobYUJfsj+ysTm9zJ+S4pk0TGo9VTG0KjqYhTmALfoDZVKla2b5yhv241PxFaLJs3i05K0AAIdcGxCJZmT3ZdT7CliR7q+kur7WdQjygYtOWRL9B8E4s4LI8KpAj7bE0dg7DLOaX+MGeAi0hMMSSWZEz+RudXbZCsGYS0QqiXjH9XQbd8sCB+nIVTq7/T/FDS+zWY9q7Z2fdq1tdLb6v3hKKVDAw5gjj6o9r1wHFROdHc18MJp4SJ2Ucvu+iQ9EgkekW8VCM+psM6y+/2SBy8tNN4a3L1MzP+OLsyvESo5gS7IQOnIqMmviJBVc6zbVG1n8eXiA3j46kmvvtJlewwNDrxk4SbJOtP/TV/lIVK9ueShNbbMHfwnLTLLhbZuO79ec5XvfgRwLFK+w1r5ZWW15rVFZrE+wKqNRv5KqsLNfpGgnoUU6Y71NxEmN7MyqwqAQqoIULOw/LbuUB2+uE75gJt+kq1qY4LoxV+qR/zalupea3D5+WMeaRIn0sAI6DDWDh158fqUb4YhAxhREbUN0qyyJYkBU4V2KARXDT65gW3gRsiv7xSPYEKLwzgriWcWgPr0sbZnv7m1XHNFW6xPdGNZUdxFiUYlmXNjDVWuu7LCkX/nVkrXaJhiYktBISC2xgBXQnNEP+cptWl1eG62a7CPXrnrkTQ5BQASbEqUZWMDiZUisKyHDeLFOaJILUo5f6iDt4ZO8MlqaKLto0AmTHVVbkGuyPa1R/ywZsWRoRDoRdNMMHwYTsklMVnlAd2S0282bgMI8fiJpDh69OSL6K3qbo20KfpNMurnYGQSr/stFqZ7hYsxKlLnKAKhsmB8AIpEQ4bd/NrTLTXefsE6ChRmKWjXKVgpGoPs8GAicgKVw4K0qgDgy1A6hFq1WRat3fHF+FkU+b6H4NWpOU3KXTxrIb2qSHAb+qhm8hiSROi/9ofapjxhyKxxntPpge6KL5Z4+WBMYkAcE6+0Hd3Yh2zBsK2MV3iW0Y6cvOCroXlRb2MMJtdWx+3dkFzGh2Pe3DZ9QpSqpaR/rE1ImOrHqYYyccpiLC22amJIjRWVAherTfpQLmo6/K2pna85GrDuQPlH1Tsar8isAJbXLafSwOof4gg9RkAGm/oYpBQQiPUoyDk2BCQ1k+KILq48ErFo4WSRhHLq/y7mgw3+L85PpP6xWr6cgp9sOjYjKagOrxF148uhuaWtjet953fh1IQiEzgC+d2IgBCcUZqgTAICm2bR8oCjDLBsmg+ThyhfD+zBalsKBY1Ce54Y/t9cwfbLu9SFwEgphfopNA3yNxgyDafUM3mYTovZNgPGdd4ZFFOj1vtfFW3u7N+iHEN1HkeesDMXKPyoCDCGVMo4GCCD6PBhQ3dRZIHy0Y/3MaE5zU9mTCrwwnZojtE+qNpMSkJSpmGe0EzLyFelMJqhfFQ7a50uXxZ8pCc2wxtAKWgHoeamR2O7R+bq7IbPYItO0esdRgoTaY38hZLJ5y02oIVwoPokGIzxAMDuanQ1vn2WDQ00Rh6o5QOaCRu99fwDbQcN0XAuqkFpxT/cfz3slGRVokrNU0iqiMAJFEbKScZdmSkTUznC0U+MfwFOGdLgsewRyPKwBZYSmy6U325iUhBQNxbAC3FLKDV9VSOuQpOOukJ/GAmu/tyEbX9DgEp6dv1zoU0IqzpG6gssSjIYRVPGgU1QAQYRgIT8gEV0EXr1sqeh2I6rXjtmoCYyEDCe/PkFEi/Q48FuT29p557iN+LCwk5CK/CZ2WdAdfQZh2Z9QGrzPLSNRj5igUWzl9Vi0rCqH8G1Kp4QMLkuwMCAypdviDXyOIk0AHTM8HBYKh3b0/F+DxoNj4ZdoZfCpQVdnZarqoMaHWnMLNVcyevytGsrXQEoIbubqWYNo7NRHzdc0zvT21fWVirj7g36iy6pxogfvgHp1xH1Turbz8QyyHnXeBJicpYUctbzApwzZ1HT+FPEXMAgUZetgeGMwt4G+DHiDT2Lu+PT21fjJCAfV16a/Wu1PqOkUHSTKYhWW6PhhHUlNtWzFnA7MbY+r64vkwdpfNB2JfWgWXAvkzd42K4lN9x7Wrg4kIKgXCb4mcW595MCPJ/cTfPAMQMFWwnqwde4w8HZYJFpQwcSMhjVz4B8p6ncSCN1X4klxoIH4BN2J6taBMj6lHkAOs8JJAmXq5xsQtrPIPIIp/HG6i21xMGcFgqDXSRF0xQg14d2uy6HgKE13LSvQe52oShF5Jx1R6avyL4thhXQZHfC94oZzuPUBKFYf1VvDaxIrtV6dNGSx7DO0i1p6CzBkuAmEqyWceQY7F9+U0ObYDzoa1iKao/cOD/v6Q9gHrrr1uCeOk8fST9MG23Ul0KmM3r+Wn6Hi6WAcL7gEeaykicvgjzkjSwFsAXIR81Zx4QJ6oosVyJkCcT+4xAldCcihqvTf94HHUPXYp3REIaR4dhpQF6+FK1H0i9i7Pvh8owu3lO4PT1iuqu+DkL2Bj9+kdfGAg2TXw03iNHyobxofLE2ibjsYDPgeEQlRMR7afXbSGQcnPjI2D+sdtmuQ771dbASUsDndU7t58jrrNGRzISvwioAlHs5FA+cBE5Ccznkd8NMV6BR6ksnKLPZnMUawRDU1MZ/ib3xCdkTblHKu4blNiylH5n213yM0zubEie0o4JhzcfAy3H5qh2l17uLooBNLaO+gzonTH2uF8PQu9EyH+pjGsACTMy4cHzsPdymUSXYJOMP3yTkXqvO/lpvt0cX5ekDEu9PUfBeZODkFuAjXCaGdi6ew4qxJ8PmFfwmPpkgQjQlWqomFY6UkjmcnAtJG75EVR+NpzGpP1Ef5qUUbfowrC3zcSLX3BxgWEgEx/v9cP8H8u1Mvt9/rMDYf6sjwU1xSOPBgzFEeJLMRVFtKo5QHsUYT8ZRLCah27599EuqoC9PYjYO6aoAMHB8X1OHwEAYouHfHB3nyb2B+SnZxM/vw/bCtORjLMSy5aZoEpvgdGvlJfNPFUu/p7Z4VVK1hiI0/UTuB3ZPq4ohEbm7Mntgc1evEtknaosgZSwnDC2BdMmibpeg48X8Ixl+/8+xXdbshQXUPPvx8jT3fkELivHSmqbhblfNFShWAyQnJ3WBU6SMYSIpTDmHjdLVAdlADdz9gCplZw6mTiHqDwIsxbm9ErGusiVpg2w8Q3khKV/R9Oj8PFeF43hmW/nSd99nZzhyjCX3QOZkkB6BsH4H866WGyv9E0hVAzPYah2tkRfQZMmP2rinfOeQalge0ovhduBjJs9a1GBwReerceify49ctOh5/65ATYuMsAkVltmvTLBk4oHpdl6i+p8DoNj4Fb2vhdFYer2JSEilEwPd5n5zNoGBXEjreg/wh2NFnNRaIUHSOXa4eJRwygZoX6vnWnqVdCRT1ARxeFrNBJ+tsdooMwqnYhE7zIxnD8pZH+P0Nu1wWxCPTADfNWmqx626IBJJq6NeapcGeOmbtXvl0TeWG0Y7OGGV4+EHTtNBIT5Wd0Bujl7inXgZgfXTM5efD3qDTJ54O9v3Bkv+tdIRlq1kXcVD0BEMirmFxglNPt5pedb1AnxuCYMChUykwsTIWqT23XDpvTiKEru1cTcEMeniB+HQDehxPXNmkotFdwUPnilB/u4Nx5Xc6l8J9jH1EgKZUUt8t8cyoZleDBEt8oibDmJRAoMKJ5Oe9CSWS5ZMEJvacsGVdXDWjp/Ype5x0p9PXB2PAwt2LRD3d+ftNgpuyvxlP8pB84oB1i73vAVpwyrmXW72hfW6Dzn9Jkj4++0VQ4d0KSx1AsDA4OtXXDo63/w+GD+zC7w5SJaxsmnlYRQ4dgdjA7tTl2KNLnpJ+mvkoDxtt1a4oPaX3EVqj96o9sRKBQqU7ZOiupeAIyLMD+Y3YwHx30XWHB5CQiw7q3mj1EDlP2eBsZbz79ayUMbyHQ7s8gu4Lgip1LiGJj7NQj905/+rgUYKAA5qdrlHKIknWmqfuR+PB8RdBkDg/NgnlT89G72h2NvySnj7UyBwD+mi/IWs1xWbxuVwUIVXun5cMqBtFbrccI+DILjsVQg6eeq0itiRfedn89CvyFtpkxaauEvSANuZmB1p8FGPbU94J9medwsZ9HkUYjmI7OH5HuxendLbxTaYrPuIfE2ffXFKhoNBUp33HsFAXmCV/Vxpq5AYgFoRr5Ay93ZLRlgaIPjhZjXZZChT+aE5iWAXMX0oSFQEtwjiuhQQItTQX5IYrKfKB+queTNplR1Hoflo5/I6aPPmACwQCE2jTOYo5Dz1cs7Sod0KTG/3kEDGk3kUaUCON19xSJCab3kNpWZhSWkO8l+SpW70Wn3g0ciOIJO5JXma6dbos6jyisuxXwUUhj2+1uGhcvuliKtWwsUTw4gi1c/diEEpZHoKoxTBeMDmhPhKTx7TXWRakV8imJR355DcIHkR9IREHxohP4TbyR5LtFU24umRPRmEYHbpe1LghyxPx7YgUHjNbbQFRQhh4KeU1EabXx8FS3JAxp2rwRDoeWkJgWRUSKw6gGP5U2PuO9V4ZuiKXGGzFQuRuf+tkSSsbBtRJKhCi3ENuLlXhPbjTKD4djXVnfXFds6Zb+1XiUrRfyayGxJq1+SYBEfbKlgjiSmk0orgTqzSS+DZ5rTqsJbttiNtp+KMqGE2AHGFw6jQqM5vD6vMptmXV9OAjq49Uf/Lx9Opam+Hn5O9p8qoBBAQixzQZ4eNVkO9sPzJAMyR1y4/RCQQ1s0pV5KAU5sKLw3tkcFbI/JqrjCsK4Mw+W8aod4lioYuawUiCyVWBE/qPaFi5bnkgpfu/ae47174rI1fqQoTbW0HrU6FAejq7ByM0V4zkZTg02/YJK2N7hUQRCeZ4BIgSEqgD8XsjzG6LIsSbuHoIdz/LhFzbNn1clci1NHWJ0/6/O8HJMdIpEZbqi1RrrFfoo/rI/7ufm2MPG5lUI0IYJ4MAiHRTSOFJ2oTverFHYXThkYFIoyFx6rMYFgaOKM4xNWdlOnIcKb/suptptgTOTdVIf4YgdaAjJnIAm4qNNHNQqqAzvi53GkyRCEoseUBrHohZsjUbkR8gfKtc/+Oa72lwxJ8Mq6HDfDATbfbJhzeIuFQJSiw1uZprHlzUf90WgqG76zO0eCB1WdPv1IT6sNxxh91GEL2YpgC97ikFHyoaH92ndwduqZ6IYjkg20DX33MWdoZk7QkcKUCgisIYslOaaLyvIIqRKWQj16jE1DlQWJJaPopWTJjXfixEjRJJo8g4++wuQjbq+WVYjsqCuNIQW3YjnxKe2M5ZKEqq+cX7ZVgnkbsU3RWIyXA1rxv4kGersYJjD//auldXGmcEbcfTeF16Y1708FB1HIfmWv6dSFi6oD4E+RIjCsEZ+kY7dKnwReJJw3xCjKvi3kGN42rvyhUlIz0Bp+fNSV5xwFiuBzG296e5s/oHoFtUyUplmPulIPl+e1CQIQVtjlzLzzzbV+D/OVQtYzo5ixtMi5BmHuG4N/uKfJk5UIREp7+12oZlKtPBomXSzAY0KgtbPzzZoHQxujnREUgBU+O/jKKhgxVhRPtbqyHiUaRwRpHv7pgRPyUrnE7fYkVblGmfTY28tFCvlILC04Tz3ivkNWVazA+OsYrxvRM/hiNn8Fc4bQBeUZABGx5S/xFf9Lbbmk298X7iFg2yeimvsQqqJ+hYbt6uq+Zf9jC+Jcwiccd61NKQtFvGWrgJiHB5lwi6fR8KzYS7EaEHf/ka9EC7H8D+WEa3TEACHBkNSj/cXxFeq4RllC+fUFm2xtstYLL2nos1DfzsC9vqDDdRVcPA3Ho95aEQHvExVThXPqym65llkKlfRXbPTRiDepdylHjmV9YTWAEjlD9DdQnCem7Aj/ml58On366392214B5zrmQz/9ySG2mFqEwjq5sFl5tYJPw5hNz8lyZPUTsr5E0F2C9VMPnZckWP7+mbwp/BiN7f4kf7vtGnZF2JGvjK/sDX1RtcFY5oPQnE4lIAYV49U3C9SP0LCY/9i/WIFK9ORjzM9kG/KGrAuwFmgdEpdLaiqQNpCTGZVuAO65afkY1h33hrqyLjZy92JK3/twdj9pafFcwfXONmPQWldPlMe7jlP24Js0v9m8bIJ9TgS2IuRvE9ZVRaCwSJYOtAfL5H/YS4FfzKWKbek+GFulheyKtDNlBtrdmr+KU+ibHTdalzFUmMfxw3f36x+3cQbJLItSilW9cuvZEMjKw987jykZRlsH/UI+HlKfo2tLwemBEeBFtmxF2xmItA/dAIfQ+rXnm88dqvXa+GapOYVt/2waFimXFx3TC2MUiOi5/Ml+3rj/YU6Ihx2hXgiDXFsUeQkRAD6wF3SCPi2flk7XwKAA4zboqynuELD312EJ88lmDEVOMa1W/K/a8tGylZRMrMoILyoMQzzbDJHNZrhH77L9qSC42HVmKiZ5S0016UTp83gOhCwz9XItK9fgXfK3F5d7nZCBUekoLxrutQaPHa16Rjsa0gTrzyjqTnmcIcrxg6X6dkKiucudc0DD5W4pJPf0vuDW8r5/uw24YfMuxFRpD2ovT2mFX79xH6Jf+MVdv2TYqR6/955QgVPe3JCD/WjAYcLA9tpXgFiEjge2J5ljeI/iUzg91KQuHkII4mmHZxC3XQORLAC6G7uFn5LOmlnXkjFdoO976moNTxElS8HdxWoPAkjjocDR136m2l+f5t6xaaNgdodOvTu0rievnhNAB79WNrVs6EsPgkgfahF9gSFzzAd+rJSraw5Mllit7vUP5YxA843lUpu6/5jAR0RvH4rRXkSg3nE+O5GFyfe+L0s5r3k05FyghSFnKo4TTgs07qj4nTLqOYj6qaW9knJTDkF5OFMYbmCP+8H16Ty482OjvERV6OFyw043L9w3hoJi408sR+SGo1WviXUu8d7qS+ehKjpKwxeCthsm2LBFSFeetx0x4AaKPxtp3CxdWqCsLrB1s/j5TAhc1jNZsXWl6tjo/WDoewxzg8T8NnhZ1niUwL/nhfygLanCnRwaFGDyLw+sfZhyZ1UtYTp8TYB6dE7R3VsKKH95CUxJ8u8N+9u2/9HUNKHW3x3w5GQrfOPafk2w5qZq8MaHT0ebeY3wIsp3rN9lrpIsW9c1ws3VNV+JwNz0Lo9+V7zZr6GD56We6gWVIvtmam5GPPkVAbr74r6SwhuL+TRXtW/0pgyX16VNl4/EAD50TnUPuwrW6OcUO2VlWXS0inq872kk7GUlW6o/ozFKq+Sip6LcTtSDfDrPTcCHhx75H8BeRon+KG2wRwzfDgWhALmiWOMO6h3pm1UCZEPEjScyk7tdLx6WrdA2N1QTPENvNnhCQjW6kl057/qv7IwRryHrZBCwVSbLLnFRiHdTwk8mlYixFt1slEcPD7FVht13HyqVeyD55HOXrh2ElAxJyinGeoFzwKA91zfrdLvDxJSjzmImfvTisreI25EDcVfGsmxLVbfU8PGe/7NmWWKjXcdTJ11jAlVIY/Bv/mcxg/Q10vCHwKG1GW/XbJq5nxDhyLqiorn7Wd7VEVL8UgVzpHMjQ+Z8DUgSukiVwWAKkeTlVVeZ7t1DGnCgJVIdBPZAEK5f8CDyDNo7tK4/5DBjdD5MPV86TaEhGsLVFPQSI68KlBYy84FievdU9gWh6XZrugvtCZmi9vfd6db6V7FmoEcRHnG36VZH8N4aZaldq9zZawt1uBFgxYYx+Gs/qW1jwANeFy+LCoymyM6zgG7j8bGzUyLhvrbJkTYAEdICEb4kMKusKT9V3eIwMLsjdUdgijMc+7iKrr+TxrVWG0U+W95SGrxnxGrE4eaJFfgvAjUM4SAy8UaRwE9j6ZQH5qYAWGtXByvDiLSDfOD0yFA3UCMKSyQ30fyy1mIRg4ZcgZHLNHWl+c9SeijOvbOJxoQy7lTN2r3Y8p6ovxvUY74aOYbuVezryqXA6U+fcp6wSV9X5/OZKP18tB56Ua0gMyxJI7XyNT7IrqN8GsB9rL/kP5KMrjXxgqKLDa+V5OCH6a5hmOWemMUsea9vQl9t5Oce76PrTyTv50ExOqngE3PHPfSL//AItPdB7kGnyTRhVUUFNdJJ2z7RtktZwgmQzhBG/G7QsjZmJfCE7k75EmdIKH7xlnmDrNM/XbTT6FzldcH/rcRGxlPrv4qDScqE7JSmQABJWqRT/TUcJSwoQM+1jvDigvrjjH8oeK2in1S+/yO1j8xAws/T5u0VnIvAPqaE1atNuN0cuRliLcH2j0nTL4JpcR7w9Qya0JoaHgsOiALLCCzRkl1UUESz+ze/gIXHGtDwgYrK6pCFKJ1webSDog4zTlPkgXZqxlQDiYMjhDpwTtBW2WxthWbov9dt2X9XFLFmcF+eEc1UaQ74gqZiZsdj63pH1qcv3Vy8JYciogIVKsJ8Yy3J9w/GhjWVSQAmrS0BPOWK+RKV+0lWqXgYMnIFwpcZVD7zPSp547i9HlflB8gVnSTGmmq1ClO081OW/UH11pEQMfkEdDFzjLC1Cdo/BdL3s7cXb8J++Hzz1rhOUVZFIPehRiZ8VYu6+7Er7j5PSZu9g/GBdmNzJmyCD9wiswj9BZw+T3iBrg81re36ihMLjoVLoWc+62a1U/7qVX5CpvTVF7rocSAKwv4cBVqZm7lLDS/qoXs4fMs/VQi6BtVbNA3uSzKpQfjH1o3x4LrvkOn40zhm6hjduDglzJUwA0POabgdXIndp9fzhOo23Pe+Rk9GSLX0d71Poqry8NQDTzNlsa+JTNG9+UrEf+ngxCjGEsDCc0bz+udVRyHQI1jmEO3S+IOQycEq7XwB6z3wfMfa73m8PVRp+iOgtZfeSBl01xn03vMaQJkyj7vnhGCklsCWVRUl4y+5oNUzQ63B2dbjDF3vikd/3RUMifPYnX5Glfuk2FsV/7RqjI9yKTbE8wJY+74p7qXO8+dIYgjtLD/N8TJtRh04N9tXJA4H59IkMmLElgvr0Q5OCeVfdAt+5hkh4pQgfRMHpL74XatLQpPiOyHRs/OdmHtBf8nOZcxVKzdGclIN16lE7kJ+pVMjspOI+5+TqLRO6m0ZpNXJoZRv9MPDRcAfJUtNZHyig/s2wwReakFgPPJwCQmu1I30/tcBbji+Na53i1W1N+BqoY7Zxo+U/M9XyJ4Ok2SSkBtoOrwuhAY3a03Eu6l8wFdIG1cN+e8hopTkiKF093KuH/BcB39rMiGDLn6XVhGKEaaT/vqb/lufuAdpGExevF1+J9itkFhCfymWr9vGb3BTK4j598zRH7+e+MU9maruZqb0pkGxRDRE1CD4Z8LV4vhgPidk5w2Bq816g3nHw1//j3JStz7NR9HIWELO8TMn3QrP/zZp//+Dv9p429/ogv+GATR+n/UdF+ns9xNkXZQJXY4t9jMkJNUFygAtzndXwjss+yWH9HAnLQQfhAskdZS2l01HLWv7L7us5uTH409pqitvfSOQg/c+Zt7k879P3K9+WV68n7+3cZfuRd/dDPP/03rn+d+/nBvWfgDlt8+LzjqJ/vx3CnNOwiXhho778C96iD+1TBvRZYeP+EH81LE0vVwOOrmCLB3iKzI1x+vJEsrPH4uF0UB4TJ4X3uDfOCo3PYpYe0MF4bouh0DQ/l43fxUF7Y+dpWuvTSffB0yO2UQUETI/LwCZE3BvnevJ7c9zUlY3H58xzke6DNFDQG8n0WtDN4LAYN4nogKav1ezOfK/z+t6tsCTp+dhx4ymjWuCJk1dEUifDP+HyS4iP/Vg9B2jTo9L4NbiBuDS4nuuHW6H+JDQn2JtqRKGkEQPEYE7uzazXIkcxIAqUq1esasZBETlEZY7y7Jo+RoV/IsjY9eIMkUvr42Hc0xqtsavZvhz1OLwSxMOTuqzlhb0WbdOwBH9EYiyBjatz40bUxTHbiWxqJ0uma19qhPruvcWJlbiSSH48OLDDpaHPszvyct41ZfTu10+vjox6kOqK6v0K/gEPphEvMl/vwSv+A4Hhm36JSP9IXTyCZDm4kKsqD5ay8b1Sad/vaiyO5N/sDfEV6Z4q95E+yfjxpqBoBETW2C7xl4pIO2bDODDFurUPwE7EWC2Uplq+AHmBHvir2PSgkR12/Ry65O0aZtQPeXi9mTlF/Wj5GQ+vFkYyhXsLTjrBSP9hwk4GPqDP5rBn5/l8b0mLRAvRSzXHc293bs3s8EsdE3m2exxidWVB4joHR+S+dz5/W+v00K3TqN14CDBth8eWcsTbiwXPsygHdGid0PEdy6HHm2v/IUuV5RVapYmzGsX90mpnIdNGcOOq64Dbc5GUbYpD9M7S+6cLY//QmjxFLP5cuTFRm3vA5rkFZroFnO3bjHF35uU3s8mvL7Tp9nyTc4mymTJ5sLIp7umSnGkO23faehtz3mmTS7fbVx5rP7x3HXIjRNeq/A3xCs9JNB08c9S9BF2O3bOur0ItslFxXgRPdaapBIi4dRpKGxVz7ir69t/bc9qTxjvtOyGOfiLGDhR4fYywHv1WdOplxIV87TpLBy3Wc0QP0P9s4G7FBNOdITS/tep3o3h1TEa5XDDii7fWtqRzUEReP2fbxz7bHWWJdbIOxOUJZtItNZpTFRfj6vm9sYjRxQVO+WTdiOhdPeTJ+8YirPvoeL88l5iLYOHd3b/Imkq+1ZN1El3UikhftuteEYxf1Wujof8Pr4ICTu5ezZyZ4tHQMxlzUHLYO2VMOoNMGL/20S5i2o2obfk+8qqdR7xzbRDbgU0lnuIgz4LelQ5XS7xbLuSQtNS95v3ZUOdaUx/Qd8qxCt6xf2E62yb/HukLO6RyorV8KgYl5YNc75y+KvefrxY+lc/64y9kvWP0a0bDz/rojq+RWjO06WeruWqNFU7r3HPIcLWRql8ICZsz2Ls/qOm/CLn6++X+Qf7mGspYCrZod/lpl6Rw4xN/yuq8gqV4B6aHk1hVE1SfILxWu5gvXqbfARYQpspcxKp1F/c8XOPzkZvmoSw+vEqBLdrq1fr3wAPv5NnM9i8F+jdAuxkP5Z71c6uhK3enlnGymr7UsWZKC12qgUiG8XXGQ9mxnqz4GSIlybF9eXmbqj2sHX+a1jf0gRoONHRdRSrIq03Ty89eQ1GbV/Bk+du4+V15zls+vvERvZ4E7ZbnxWTVjDjb4o/k8jlw44pTIrUGxxuJvBeO+heuhOjpFsO6lVJ/aXnJDa/bM0Ql1cLbXE/Pbv3EZ3vj3iVrB5irjupZTzlnv677NrI9UNYNqbPgp/HZXS+lJmk87wec+7YOxTDo2aw2l3NfDr34VNlvqWJBknuK7oSlZ6/T10zuOoPZOeoIk81N+sL843WJ2Q4Z0fZ3scsqC/JV2fuhWi1jGURSKZV637lf53Xnnx16/vKEXY89aVJ0fv91jGdfG+G4+sniwHes4hS+udOr4RfhFhG/F5gUG35QaU+McuLmclb5ZWmR+sG5V6nf+PxYzlrnFGxpZaK8eqqVo0NfmAWoGfXDiT/FnUbWvzGDOTr8aktOZWg4BYvz5YH12ZbfCcGtNk+dDAZNGWvHov+PIOnY9Prjg8h/wLRrT69suaMVZ5bNuK00lSVpnqSX1NON/81FoP92rYndionwgOiA8WMf4vc8l15KqEEG4yAm2+WAN5Brfu1sq9suWYqgoajgOYt/JCk1gC8wPkK+XKCtRX6TAtgvrnuBgNRmn6I8lVDipOVB9kX6Oxkp4ZKyd1M6Gj8/v2U7k+YQBL95Kb9PQENucJb0JlW3b5tObN7m/Z1j1ev388d7o15zgXsI9CikAGAViR6lkJv7nb4Ak40M2G8TJ447kN+pvfHiOFjSUSP6PM+QfbAywKJCBaxSVxpizHseZUyUBhq59vFwrkyGoRiHbo0apweEZeSLuNiQ+HAekOnarFg00dZNXaPeoHPTRR0FmEyqYExOVaaaO8c0uFUh7U4e/UxdBmthlBDgg257Q33j1hA7HTxSeTTSuVnPZbgW1nodwmG16aKBDKxEetv7D9OjO0JhrbJTnoe+kcGoDJazFSO8/fUN9Jy/g4XK5PUkw2dgPDGpJqBfhe7GA+cjzfE/EGsMM+FV9nj9IAhrSfT/J3QE5TEIYyk5UjsI6ZZcCPr6A8FZUF4g9nnpVmjX90MLSQysIPD0nFzqwCcSJmIb5mYv2Cmk+C1MDFkZQyCBq4c/Yai9LJ6xYkGS/x2s5/frIW2vmG2Wrv0APpCdgCA9snFvfpe8uc0OwdRs4G9973PGEBnQB5qKrCQ6m6X/H7NInZ7y/1674/ZXOVp7OeuCRk8JFS516VHrnH1HkIUIlTIljjHaQtEtkJtosYul77cVwjk3gW1Ajaa6zWeyHGLlpk3VHE2VFzT2yI/EvlGUSz2H9zYE1s4nsKMtMqNyKNtL/59CpFJki5Fou6VXGm8vWATEPwrUVOLvoA8jLuwOzVBCgHB2Cr5V6OwEWtJEKokJkfc87h+sNHTvMb0KVTp5284QTPupoWvQVUwUeogZR3kBMESYo0mfukewRVPKh5+rzLQb7HKjFFIgWhj1w3yN/qCNoPI8XFiUgBNT1hCHBsAz8L7Oyt8wQWUFj92ONn/APyJFg8hzueqoJdNj57ROrFbffuS/XxrSXLTRgj5uxZjpgQYceeMc2wJrahReSKpm3QjHfqExTLAB2ipVumE8pqcZv8LYXQiPHHsgb5BMW8zM5pvQit+mQx8XGaVDcfVbLyMTlY8xcfmm/RSAT/H09UQol5gIz7rESDmnrQ4bURIB4iRXMDQwxgex1GgtDxKp2HayIkR+E/aDmCttNm2C6lytWdfOVzD6X2SpDWjQDlMRvAp1symWv4my1bPCD+E1EmGnMGWhNwmycJnDV2WrQNxO45ukEb08AAffizYKVULp15I4vbNK5DzWwCSUADfmKhfGSUqii1L2UsE8rB7mLuHuUJZOx4+WiizHBJ/hwboaBzhpNOVvgFTf5cJsHef7L1HCI9dOUUbb+YxUJWn6dYOLz+THi91kzY5dtO5c+grX7v0jEbsuoOGnoIreDIg/sFMyG+TyCLIcAWd1IZ1UNFxE8Uie13ucm40U2fcxC0u3WLvLOxwu+F7MWUsHsdtFQZ7W+nlfCASiAKyh8rnP3EyDByvtJb6Kax6/HkLzT9SyEyTMVM1zPtM0MJY14DmsWh4MgD15Ea9Hd00AdkTZ0EiG5NAGuIBzQJJ0JR0na+OB7lQA6UKxMfihIQ7GCCnVz694QvykWXTxpS2soDu+smru1UdIxSvAszBFD1c8c6ZOobA8bJiJIvuycgIXBQIXWwhyTgZDQxJTRXgEwRNAawGSXO0a1DKjdihLVNp/taE/xYhsgwe+VpKEEB4LlraQyE84gEihxCnbfoyOuJIEXy2FIYw+JjRusybKlU2g/vhTSGTydvCvXhYBdtAXtS2v7LkHtmXh/8fly1do8FI/D0f8UbzVb5h+KRhMGSAmR2mhi0YG/uj7wgxcfzCrMvdjitUIpXDX8ae2JcF/36qUWIMwN6JsjaRGNj+jEteGDcFyTUb8X/NHSucKMJp7pduxtD6KuxVlyxxwaeiC1FbGBESO84lbyrAugYxdl+2N8/6AgWpo/IeoAOcsG35IA/b3AuSyoa55L7llBLlaWlEWvuCFd8f8NfcTUgzJv6CbB+6ohWwodlk9nGWFpBAOaz5uEW5xBvmjnHFeDsb0mXwayj3mdYq5gxxNf3H3/tnCgHwjSrpSgVxLmiTtuszdRUFIsn6LiMPjL808vL1uQhDbM7aA43mISXReqjSskynIRcHCJ9qeFopJfx9tqyUoGbSwJex/0aDE3plBPGtNBYgWbdLom3+Q/bjdizR2/AS/c/dH/d3G7pyl1qDXgtOFtEqidwLqxPYtrNEveasWq3vPUUtqTeu8gpov4bdOQRI2kneFvRNMrShyVeEupK1PoLDPMSfWMIJcs267mGB8X9CehQCF0gIyhpP10mbyM7lwW1e6TGvHBV1sg/UyTghHPGRqMyaebC6pbB1WKNCQtlai1GGvmq9zUKaUzLaXsXEBYtHxmFbEZ2kJhR164LhWW2Tlp1dhsGE7ZgIWRBOx3Zcu2DxgH+G83WTPceKG0TgQKKiiNNOlWgvqNEbnrk6fVD+AqRam2OguZb0YWSTX88N+i/ELSxbaUUpPx4vJUzYg/WonSeA8xUK6u7DPHgpqWpEe6D4cXg5uK9FIYVba47V/nb+wyOtk+zG8RrS4EA0ouwa04iByRLSvoJA2FzaobbZtXnq8GdbfqEp5I2dpfpj59TCVif6+E75p665faiX8gS213RqBxTZqfHP46nF6NSenOneuT+vgbLUbdTH2/t0REFXZJOEB6DHvx6N6g9956CYrY/AYcm9gELJXYkrSi+0F0geKDZgOCIYkLU/+GOW5aGj8mvLFgtFH5+XC8hvAE3CvHRfl4ofM/Qwk4x2A+R+nyc9gNu/9Tem7XW4XRnyRymf52z09cTOdr+PG6+P/Vb4QiXlwauc5WB1z3o+IJjlbxI8MyWtSzT+k4sKVbhF3xa+vDts3NxXa87iiu+xRH9cAprnOL2h6vV54iQRXuOAj1s8nLFK8gZ70ThIQcWdF19/2xaJmT0efrkNDkWbpAQPdo92Z8+Hn/aLjbOzB9AI/k12fPs9HhUNDJ1u6ax2VxD3R6PywN7BrLJ26z6s3QoMp76qzzwetrDABKSGkfW5PwS1GvYNUbK6uRqxfyVGNyFB0E+OugMM8kKwmJmupuRWO8XkXXXQECyRVw9UyIrtCtcc4oNqXqr7AURBmKn6Khz3eBN96LwIJrAGP9mr/59uTOSx631suyT+QujDd4beUFpZ0kJEEnjlP+X/Kr2kCKhnENTg4BsMTOmMqlj2WMFLRUlVG0fzdCBgUta9odrJfpVdFomTi6ak0tFjXTcdqqvWBAzjY6hVrH9sbt3Z9gn+AVDpTcQImefbB4edirjzrsNievve4ZT4EUZWV3TxEsIW+9MT/RJoKfZZYSRGfC1CwPG/9rdMOM8qR/LUYvw5f/emUSoD7YSFuOoqchdUg2UePd1eCtFSKgxLSZ764oy4lvRCIH6bowPxZWwxNFctksLeil47pfevcBipkkBIc4ngZG+kxGZ71a72KQ7VaZ6MZOZkQJZXM6kb/Ac0/XkJx8dvyfJcWbI3zONEaEPIW8GbkYjsZcwy+eMoKrYjDmvEEixHzkCSCRPRzhOfJZuLdcbx19EL23MA8rnjTZZ787FGMnkqnpuzB5/90w1gtUSRaWcb0eta8198VEeZMUSfIhyuc4/nywFQ9uqn7jdqXh+5wwv+RK9XouNPbYdoEelNGo34KyySwigsrfCe0v/PlWPvQvQg8R0KgHO18mTVThhQrlbEQ0Kp/JxPdjHyR7E1QPw/ut0r+HDDG7BwZFm9IqEUZRpv2WpzlMkOemeLcAt5CsrzskLGaVOAxyySzZV/D2EY7ydNZMf8e8VhHcKGHAWNszf1EOq8fNstijMY4JXyATwTdncFFqcNDfDo+mWFvxJJpc4sEZtjXyBdoFcxbUmniCoKq5jydUHNjYJxMqN1KzYV62MugcELVhS3Bnd+TLLOh7dws/zSXWzxEb4Nj4aFun5x4kDWLK5TUF/yCXB/cZYvI9kPgVsG2jShtXkxfgT+xzjJofXqPEnIXIQ1lnIdmVzBOM90EXvJUW6a0nZ/7XjJGl8ToO3H/fdxnxmTNKBZxnkpXLVgLXCZywGT3YyS75w/PAH5I/jMuRspej8xZObU9kREbRA+kqjmKRFaKGWAmFQspC+QLbKPf0RaK3OXvBSWqo46p70ws/eZpu6jCtZUgQy6r4tHMPUdAgWGGUYNbuv/1a6K+MVFsd3T183+T8capSo6m0+Sh57fEeG/95dykGJBQMj09DSW2bY0mUonDy9a8trLnnL5B5LW3Nl8rJZNysO8Zb+80zXxqUGFpud3Qzwb7bf+8mq6x0TAnJU9pDQR9YQmZhlna2xuxJt0aCO/f1SU8gblOrbIyMsxTlVUW69VJPzYU2HlRXcqE2lLLxnObZuz2tT9CivfTAUYfmzJlt/lOPgsR6VN64/xQd4Jlk/RV7UKVv2Gx/AWsmTAuCWKhdwC+4HmKEKYZh2Xis4KsUR1BeObs1c13wqFRnocdmuheaTV30gvVXZcouzHKK5zwrN52jXJEuX6dGx3BCpV/++4f3hyaW/cQJLFKqasjsMuO3B3WlMq2gyYfdK1e7L2pO/tRye2mwzwZPfdUMrl5wdLqdd2Kv/wVtnpyWYhd49L6rsOV+8HXPrWH2Kup89l2tz6bf80iYSd+V4LROSOHeamvexR524q4r43rTmtFzQvArpvWfLYFZrbFspBsXNUqqenjxNNsFXatZvlIhk7teUPfK+YL32F8McTnjv0BZNppb+vshoCrtLXjIWq3EJXpVXIlG6ZNL0dh6qEm2WMwDjD3LfOfkGh1/czYc/0qhiD2ozNnH4882MVVt3JbVFkbwowNCO3KL5IoYW5wlVeGCViOuv1svZx7FbzxKzA4zGqBlRRaRWCobXaVq4yYCWbZf8eiJwt3OY+MFiSJengcFP2t0JMfzOiJ7cECvpx7neg1Rc5x+7myPJOXt2FohVRyXtD+/rDoTOyGYInJelZMjolecVHUhUNqvdZWg2J2t0jPmiLFeRD/8fOT4o+NGILb+TufCo9ceBBm3JLVn+MO2675n7qiEX/6W+188cYg3Zn5NSTjgOKfWFSAANa6raCxSoVU851oJLY11WIoYK0du0ec5E4tCnAPoKh71riTsjVIp3gKvBbEYQiNYrmH22oLQWA2AdwMnID6PX9b58dR2QKo4qag1D1Z+L/FwEKTR7osOZPWECPJIHQqPUsM5i/CH5YupVPfFA5pHUBcsesh8eO5YhyWnaVRPZn/BmdXVumZWPxMP5e28zm2uqHgFoT9CymHYNNrzrrjlXZM06HnzDxYNlI5b/QosxLmmrqDFqmogQdqk0WLkUceoAvQxHgkIyvWU69BPFr24VB6+lx75Rna6dGtrmOxDnvBojvi1/4dHjVeg8owofPe1cOnxU1ioh016s/Vudv9mhV9f35At+Sh28h1bpp8xhr09+vf47Elx3Ms6hyp6QvB3t0vnLbOhwo660cp7K0vvepabK7YJfxEWWfrC2YzJfYOjygPwfwd/1amTqa0hZ5ueebhWYVMubRTwIjj+0Oq0ohU3zfRfuL8gt59XsHdwKtxTQQ4Y2qz6gisxnm2UdlmpEkgOsZz7iEk6QOt8BuPwr+NR01LTqXmJo1C76o1N274twJvl+I069TiLpenK/miRxhyY8jvYV6W1WuSwhH9q7kuwnJMtm7IWcqs7HsnyHSqWXLSpYtZGaR1V3t0gauninFPZGtWskF65rtti48UV9uV9KM8kfDYs0pgB00S+TlzTXV6P8mxq15b9En8sz3jWSszcifZa/NuufPNnNTb031pptt0+sRSH/7UG8pzbsgtt3OG3ut7B9JzDMt2mTZuyRNIV8D54TuTrpNcHtgmMlYJeiY9XS83NYJicjRjtJSf9BZLsQv629QdDsKQhTK5CnXhpk7vMNkHzPhm0ExW/VCGApHfPyBagtZQTQmPHx7g5IXXsrQDPzIVhv2LB6Ih138iSDww1JNHrDvzUxvp73MsQBVhW8EbrReaVUcLB1R3PUXyaYG4HpJUcLVxMgDxcPkVRQpL7VTAGabDzbKcvg12t5P8TSGQkrj/gOrpnbiDHwluA73xbXts/L7u468cRWSWRtgTwlQnA47EKg0OiZDgFxAKQQUcsbGomITgeXUAAyKe03eA7Mp4gnyKQmm0LXJtEk6ddksMJCuxDmmHzmVhO+XaN2A54MIh3niw5CF7PwiXFZrnA8wOdeHLvvhdoqIDG9PDI7UnWWHq526T8y6ixJPhkuVKZnoUruOpUgOOp3iIKBjk+yi1vHo5cItHXb1PIKzGaZlRS0g5d3MV2pD8FQdGYLZ73aae/eEIUePMc4NFz8pIUfLCrrF4jVWH5gQneN3S8vANBmUXrEcKGn6hIUN95y1vpsvLwbGpzV9L0ZKTan6TDXM05236uLJcIEMKVAxKNT0K8WljuwNny3BNQRfzovA85beI9zr1AGNYnYCVkR1aGngWURUrgqR+gRrQhxW81l3CHevjvGEPzPMTxdsIfB9dfGRbZU0cg/1mcubtECX4tvaedmNAvTxCJtc2QaoUalGfENCGK7IS/O8CRpdOVca8EWCRwv2sSWE8CJPW5PCugjCXPd3h6U60cPD+bdhtXZuYB6stcoveE7Sm5MM2yvfUHXFSW7KzLmi7/EeEWL0wqcOH9MOSKjhCHHmw+JGLcYE/7SBZQCRggox0ZZTAxrlzNNXYXL5fNIjkdT4YMqVUz6p8YDt049v4OXGdg3qTrtLBUXOZf7ahPlZAY/O+7Sp0bvGSHdyQ8B1LOsplqMb9Se8VAE7gIdSZvxbRSrfl+Lk5Qaqi5QJceqjitdErcHXg/3MryljPSIAMaaloFm1cVwBJ8DNmkDqoGROSHFetrgjQ5CahuKkdH5pRPigMrgTtlFI8ufJPJSUlGgTjbBSvpRc0zypiUn6U5KZqcRoyrtzhmJ7/caeZkmVRwJQeLOG8LY6vP5ChpKhc8Js0El+n6FXqbx9ItdtLtYP92kKfaTLtCi8StLZdENJa9Ex1nOoz1kQ7qxoiZFKRyLf4O4CHRT0T/0W9F8epNKVoeyxUXhy3sQMMsJjQJEyMOjmOhMFgOmmlscV4eFi1CldU92yjwleirEKPW3bPAuEhRZV7JsKV3Lr5cETAiFuX5Nw5UlF7d2HZ96Bh0sgFIL5KGaKSoVYVlvdKpZJVP5+NZ7xDEkQhmDgsDKciazJCXJ6ZN2B3FY2f6VZyGl/t4aunGIAk/BHaS+i+SpdRfnB/OktOvyjinWNfM9Ksr6WwtCa1hCmeRI6icpFM4o8quCLsikU0tMoZI/9EqXRMpKGaWzofl4nQuVQm17d5fU5qXCQeCDqVaL9XJ9qJ08n3G3EFZS28SHEb3cdRBdtO0YcTzil3QknNKEe/smQ1fTb0XbpyNB5xAeuIlf+5KWlEY0DqJbsnzJlQxJPOVyHiKMx5Xu9FcEv1Fbg6Fhm4t+Jyy5JC1W3YO8dYLsO0PXPbxodBgttTbH3rt9Cp1lJIk2r3O1Zqu94eRbnIz2f50lWolYzuKsj4PMok4abHLO8NAC884hiXx5Fy5pWKO0bWL7uEGXaJCtznhP67SlQ4xjWIfgq6EpZ28QMtuZK7JC0RGbl9nA4XtFLug/NLMoH1pGt9IonAJqcEDLyH6TDROcbsmGPaGIxMo41IUAnQVPMPGByp4mOmh9ZQMkBAcksUK55LsZj7E5z5XuZoyWCKu6nHmDq22xI/9Z8YdxJy4kWpD16jLVrpwGLWfyOD0Wd+cBzFBxVaGv7S5k9qwh/5t/LQEXsRqI3Q9Rm3QIoaZW9GlsDaKOUyykyWuhNOprSEi0s1G4rgoiX1V743EELti+pJu5og6X0g6oTynUqlhH9k6ezyRi05NGZHz0nvp3HOJr7ebrAUFrDjbkFBObEvdQWkkUbL0pEvMU46X58vF9j9F3j6kpyetNUBItrEubW9ZvMPM4qNqLlsSBJqOH3XbNwv/cXDXNxN8iFLzUhteisYY+RlHYOuP29/Cb+L+xv+35Rv7xudnZ6ohK4cMPfCG8KI7dNmjNk/H4e84pOxn/sZHK9psfvj8ncA8qJz7O8xqbxESDivGJOZzF7o5PJLQ7g34qAWoyuA+x3btU98LT6ZyGyceIXjrqob2CAVql4VOTQPUQYvHV/g4zAuCZGvYQBtf0wmd5lilrvuEn1BXLny01B4h4SMDlYsnNpm9d7m9h578ufpef9Z4WplqWQvqo52fyUA7J24eZD5av6SyGIV9kpmHNqyvdfzcpEMw97BvknV2fq+MFHun9BT3Lsf8pbzvisWiIQvYkng+8Vxk1V+dli1u56kY50LRjaPdotvT5BwqtwyF+emo/z9J3yVUVGfKrxQtJMOAQWoQii/4dp9wgybSa5mkucmRLtEQZ/pz0tL/NVcgWAd95nEQ3Tg6tNbuyn3Iepz65L3huMUUBntllWuu4DbtOFSMSbpILV4fy6wlM0SOvi6CpLh81c1LreIvKd61uEWBcDw1lUBUW1I0Z+m/PaRlX+PQ/oxg0Ye6KUiIiTF4ADNk59Ydpt5/rkxmq9tV5Kcp/eQLUVVmBzQNVuytQCP6Ezd0G8eLxWyHpmZWJ3bAzkWTtg4lZlw42SQezEmiUPaJUuR/qklVA/87S4ArFCpALdY3QRdUw3G3XbWUp6aq9z0zUizcPa7351p9JXOZyfdZBFnqt90VzQndXB/mwf8LC9STj5kenVpNuqOQQP3mIRJj7eV21FxG8VAxKrEn3c+XfmZ800EPb9/5lIlijscUbB6da0RQaMook0zug1G0tKi/JBC4rw7/D3m4ARzAkzMcVrDcT2SyFtUdWAsFlsPDFqV3N+EjyXaoEePwroaZCiLqEzb8MW+PNE9TmTC01EzWli51PzZvUqkmyuROU+V6ik+Le/9qT6nwzUzf9tP68tYei0YaDGx6kAd7jn1cKqOCuYbiELH9zYqcc4MnRJjkeGiqaGwLImhyeKs+xKJMBlOJ05ow9gGCKZ1VpnMKoSCTbMS+X+23y042zOb5MtcY/6oBeAo1Vy89OTyhpavFP78jXCcFH0t7Gx24hMEOm2gsEfGabVpQgvFqbQKMsknFRRmuPHcZu0Su/WMFphZvB2r/EGbG72rpGGho3h+Msz0uGzJ7hNK2uqQiE1qmn0zgacKYYZBCqsxV+sjbpoVdSilW/b94n2xNb648VmNIoizqEWhBnsen+d0kbCPmRItfWqSBeOd9Wne3c6bcd6uvXOJ6WdiSsuXq0ndhqrQ4QoWUjCjYtZ0EAhnSOP1m44xkf0O7jXghrzSJWxP4a/t72jU29Vu2rvu4n7HfHkkmQOMGSS+NPeLGO5I73mC2B7+lMiBQQZRM9/9liLIfowupUFAbPBbR+lxDM6M8Ptgh1paJq5Rvs7yEuLQv/7d1oU2woFSb3FMPWQOKMuCuJ7pDDjpIclus5TeEoMBy2YdVB4fxmesaCeMNsEgTHKS5WDSGyNUOoEpcC2OFWtIRf0w27ck34/DjxRTVIcc9+kqZE6iMSiVDsiKdP/Xz5XfEhm/sBhO50p1rvJDlkyyxuJ9SPgs7YeUJBjXdeAkE+P9OQJm6SZnn1svcduI78dYmbkE2mtziPrcjVisXG78spLvbZaSFx/Rks9zP4LKn0Cdz/3JsetkT06A8f/yCgMO6Mb1Hme0JJ7b2wZz1qleqTuKBGokhPVUZ0dVu+tnQYNEY1fmkZSz6+EGZ5EzL7657mreZGR3jUfaEk458PDniBzsSmBKhDRzfXameryJv9/D5m6HIqZ0R+ouCE54Dzp4IJuuD1e4Dc5i+PpSORJfG23uVgqixAMDvchMR0nZdH5brclYwRoJRWv/rlxGRI5ffD5NPGmIDt7vDE1434pYdVZIFh89Bs94HGGJbTwrN8T6lh1HZFTOB4lWzWj6EVqxSMvC0/ljWBQ3F2kc/mO2b6tWonT2JEqEwFts8rz2h+oWNds9ceR2cb7zZvJTDppHaEhK5avWqsseWa2Dt5BBhabdWSktS80oMQrL4TvAM9b5HMmyDnO+OkkbMXfUJG7eXqTIG6lqSOEbqVR+qYdP7uWb57WEJqzyh411GAVsDinPs7KvUeXItlcMdOUWzXBH6zscymV1LLVCtc8IePojzXHF9m5b5zGwBRdzcyUJkiu938ApmAayRdJrX1PmVguWUvt2ThQ62czItTyWJMW2An/hdDfMK7SiFQlGIdAbltHz3ycoh7j9V7GxNWBpbtcSdqm4XxRwTawc3cbZ+xfSv9qQfEkDKfZTwCkqWGI/ur250ItXlMlh6vUNWEYIg9A3GzbgmbqvTN8js2YMo87CU5y6nZ4dbJLDQJj9fc7yM7tZzJDZFtqOcU8+mZjYlq4VmifI23iHb1ZoT9E+kT2dolnP1AfiOkt7PQCSykBiXy5mv637IegWSKj9IKrYZf4Lu9+I7ub+mkRdlvYzehh/jaJ9n7HUH5b2IbgeNdkY7wx1yVzxS7pbvky6+nmVUtRllEFfweUQ0/nG017WoUYSxs+j2B4FV/F62EtHlMWZXYrjGHpthnNb1x66LKZ0Qe92INWHdfR/vqp02wMS8r1G4dJqHok8KmQ7947G13a4YXbsGgHcBvRuVu1eAi4/A5+ZixmdSXM73LupB/LH7O9yxLTVXJTyBbI1S49TIROrfVCOb/czZ9pM4JsZx8kUz8dQGv7gUWKxXvTH7QM/3J2OuXXgciUhqY+cgtaOliQQVOYthBLV3xpESZT3rmfEYNZxmpBbb24CRao86prn+i9TNOh8VxRJGXJfXHATJHs1T5txgc/opYrY8XjlGQQbRcoxIBcnVsMjmU1ymmIUL4dviJXndMAJ0Yet+c7O52/p98ytlmAsGBaTAmMhimAnvp1TWNGM9BpuitGj+t810CU2UhorrjPKGtThVC8WaXw04WFnT5fTjqmPyrQ0tN3CkLsctVy2xr0ZWgiWVZ1OrlFjjxJYsOiZv2cAoOvE+7sY0I/TwWcZqMoyIKNOftwP7w++Rfg67ljfovKYa50if3fzE/8aPYVey/Nq35+nH2sLPh/fP5TsylSKGOZ4k69d2PnH43+kq++sRXHQqGArWdwhx+hpwQC6JgT2uxehYU4Zbw7oNb6/HLikPyJROGK2ouyr+vzseESp9G50T4AyFrSqOQ0rroCYP4sMDFBrHn342EyZTMlSyk47rHSq89Y9/nI3zG5lX16Z5lxphguLOcZUndL8wNcrkyjH82jqg8Bo8OYkynrxZvbFno5lUS3OPr8Ko3mX9NoRPdYOKKjD07bvgFgpZ/RF+YzkWvJ/Hs/tUbfeGzGWLxNAjfDzHHMVSDwB5SabQLsIZHiBp43FjGkaienYoDd18hu2BGwOK7U3o70K/WY/kuuKdmdrykIBUdG2mvE91L1JtTbh20mOLbk1vCAamu7utlXeGU2ooVikbU/actcgmsC1FKk2qmj3GWeIWbj4tGIxE7BLcBWUvvcnd/lYxsMV4F917fWeFB/XbINN3qGvIyTpCalz1lVewdIGqeAS/gB8Mi+sA+BqDiX3VGD2eUunTRbSY+AuDy4E3Qx3hAhwnSXX+B0zuj3eQ1miS8Vux2z/l6/BkWtjKGU72aJkOCWhGcSf3+kFkkB15vGOsQrSdFr6qTj0gBYiOlnBO41170gOWHSUoBVRU2JjwppYdhIFDfu7tIRHccSNM5KZOFDPz0TGMAjzzEpeLwTWp+kn201kU6NjbiMQJx83+LX1e1tZ10kuChJZ/XBUQ1dwaBHjTDJDqOympEk8X2M3VtVw21JksChA8w1tTefO3RJ1FMbqZ01bHHkudDB/OhLfe7P5GOHaI28ZXKTMuqo0hLWQ4HabBsGG7NbP1RiXtETz074er6w/OerJWEqjmkq2y51q1BVI+JUudnVa3ogBpzdhFE7fC7kybrAt2Z6RqDjATAUEYeYK45WMupBKQRtQlU+uNsjnzj6ZmGrezA+ASrWxQ6LMkHRXqXwNq7ftv28dUx/ZSJciDXP2SWJsWaN0FjPX9Yko6LobZ7aYW/IdUktI9apTLyHS8DyWPyuoZyxN1TK/vtfxk3HwWh6JczZC8Ftn0bIJay2g+n5wd7lm9rEsKO+svqVmi+c1j88hSCxbzrg4+HEP0Nt1/B6YW1XVm09T1CpAKjc9n18hjqsaFGdfyva1ZG0Xu3ip6N6JGpyTSqY5h4BOlpLPaOnyw45PdXTN+DtAKg7DLrLFTnWusoSBHk3s0d7YouJHq85/R09Tfc37ENXZF48eAYLnq9GLioNcwDZrC6FW6godB8JnqYUPvn0pWLfQz0lM0Yy8Mybgn84Ds3Q9bDP10bLyOV+qzxa4Rd9Dhu7cju8mMaONXK3UqmBQ9qIg7etIwEqM/kECk/Dzja4Bs1xR+Q/tCbc8IKrSGsTdJJ0vge7IG20W687uVmK6icWQ6cD3lwFzgNMGtFvO5qyJeKflGLAAcQZOrkxVwy3cWvqlGpvjmf9Qe6Ap20MPbV92DPV0OhFM4kz8Yr0ffC2zLWSQ1kqY6QdQrttR3kh1YLtQd1kCEv5hVoPIRWl5ERcUTttBIrWp6Xs5Ehh5OUUwI5aEBvuiDmUoENmnVw1FohCrbRp1A1E+XSlWVOTi7ADW+5Ohb9z1vK4qx5R5lPdGCPBJZ00mC+Ssp8VUbgpGAvXWMuWQQRbCqI6Rr2jtxZxtfP7W/8onz+yz0Gs76LaT5HX9ecyiZCB/ZR/gFtMxPsDwohoeCRtiuLxE1GM1vUEUgBv86+eehL58/P56QFGQ/MqOe/vC76L63jzmeax4exd/OKTUvkXg+fOJUHych9xt/9goJMrapSgvXrj8+8vk/N80f22Sewj6cyGqt1B6mztoeklVHHraouhvHJaG/OuBz6DHKMpFmQULU1bRWlyYE0RPXYYkUycIemN7TLtgNCJX6BqdyxDKkegO7nJK5xQ7OVYDZTMf9bVHidtk6DQX9Et+V9M7esgbsYBdEeUpsB0Xvw2kd9+rI7V+m47u+O/tq7mw7262HU1WlS9uFzsV6JxIHNmUCy0QS9e077JGRFbG65z3/dOKB/Zk+yDdKpUmdXjn/aS3N5nv4fK7bMHHmPlHd4E2+iTbV5rpzScRnxk6KARuDTJ8Q1LpK2mP8gj1EbuJ9RIyY+EWK4hCiIDBAS1Tm2IEXAFfgKPgdL9O6mAa06wjCcUAL6EsxPQWO9VNegBPm/0GgkZbDxCynxujX/92vmGcjZRMAY45puak2sFLCLSwXpEsyy5fnF0jGJBhm+fNSHKKUUfy+276A7/feLOFxxUuHRNJI2Osenxyvf8DAGObT60pfTTlhEg9u/KKkhJqm5U1/+BEcSkpFDA5XeCqxwXmPac1jcuZ3JWQ+p0NdWzb/5v1ZvF8GtMTFFEdQjpLO0bwPb0BHNWnip3liDXI2fXf05jjvfJ0NpjLCUgfTh9CMFYVFKEd4Z/OG/2C+N435mnK+9t1gvCiVcaaH7rK4+PjCvpVNiz+t2QyqH1O8x3JKZVl6Q+Lp/XK8wMjVMslOq9FdSw5FtUs/CptXH9PW+wbWHgrV17R5jTVOtGtKFu3nb80T+E0tv9QkzW3J2dbaw/8ddAKZ0pxIaEqLjlPrji3VgJ3GvdFvlqD8075woxh4fVt0JZE0KVFsAvqhe0dqN9b35jtSpnYMXkU+vZq+IAHad3IHc2s/LYrnD1anfG46IFiMIr9oNbZDWvwthqYNqOigaKd/XlLU4XHfk/PXIjPsLy/9/kAtQ+/wKH+hI/IROWj5FPvTZAT9f7j4ZXQyG4M0TujMAFXYkKvEHv1xhySekgXGGqNxWeWKlf8dDAlLuB1cb/qOD+rk7cmwt+1yKpk9cudqBanTi6zTbXRtV8qylNtjyOVKy1HTz0GW9rjt6sSjAZcT5R+KdtyYb0zyqG9pSLuCw5WBwAn7fjBjKLLoxLXMI+52L9cLwIR2B6OllJZLHJ8vDxmWdtF+QJnmt1rsHPIWY20lftk8fYePkAIg6Hgn532QoIpegMxiWgAOfe5/U44APR8Ac0NeZrVh3gEhs12W+tVSiWiUQekf/YBECUy5fdYbA08dd7VzPAP9aiVcIB9k6tY7WdJ1wNV+bHeydNtmC6G5ICtFC1ZwmJU/j8hf0I8TRVKSiz5oYIa93EpUI78X8GYIAZabx47/n8LDAAJ0nNtP1rpROprqKMBRecShca6qXuTSI3jZBLOB3Vp381B5rCGhjSvh/NSVkYp2qIdP/Bg=";

});



parcelRegister("kls9x", function(module, exports) {

$parcel$export(module.exports, "HuffmanCode", () => $ecfb9b5b3306a38a$export$209a3d84f3357583, (v) => $ecfb9b5b3306a38a$export$209a3d84f3357583 = v);
$parcel$export(module.exports, "BrotliBuildHuffmanTable", () => $ecfb9b5b3306a38a$export$8a58ff2090e8dcda, (v) => $ecfb9b5b3306a38a$export$8a58ff2090e8dcda = v);
var $ecfb9b5b3306a38a$export$209a3d84f3357583;
var $ecfb9b5b3306a38a$export$8a58ff2090e8dcda;
function $ecfb9b5b3306a38a$var$HuffmanCode(bits, value) {
    this.bits = bits; /* number of bits used for this symbol */ 
    this.value = value; /* symbol value or table offset */ 
}
$ecfb9b5b3306a38a$export$209a3d84f3357583 = $ecfb9b5b3306a38a$var$HuffmanCode;
var $ecfb9b5b3306a38a$var$MAX_LENGTH = 15;
/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function $ecfb9b5b3306a38a$var$GetNextKey(key, len) {
    var step = 1 << len - 1;
    while(key & step)step >>= 1;
    return (key & step - 1) + step;
}
/* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function $ecfb9b5b3306a38a$var$ReplicateValue(table, i, step, end, code) {
    do {
        end -= step;
        table[i + end] = new $ecfb9b5b3306a38a$var$HuffmanCode(code.bits, code.value);
    }while (end > 0);
}
/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function $ecfb9b5b3306a38a$var$NextTableBitSize(count, len, root_bits) {
    var left = 1 << len - root_bits;
    while(len < $ecfb9b5b3306a38a$var$MAX_LENGTH){
        left -= count[len];
        if (left <= 0) break;
        ++len;
        left <<= 1;
    }
    return len - root_bits;
}
$ecfb9b5b3306a38a$export$8a58ff2090e8dcda = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
    var start_table = table;
    var code; /* current table entry */ 
    var len; /* current code length */ 
    var symbol; /* symbol index in original or sorted table */ 
    var key; /* reversed prefix code */ 
    var step; /* step size to replicate values in current table */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low bits */ 
    var table_bits; /* key length of current table */ 
    var table_size; /* size of current table */ 
    var total_size; /* sum of root table size and 2nd level table sizes */ 
    var sorted; /* symbols sorted by code length */ 
    var count = new Int32Array($ecfb9b5b3306a38a$var$MAX_LENGTH + 1); /* number of codes of each length */ 
    var offset = new Int32Array($ecfb9b5b3306a38a$var$MAX_LENGTH + 1); /* offsets in sorted table for each length */ 
    sorted = new Int32Array(code_lengths_size);
    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
    for(len = 1; len < $ecfb9b5b3306a38a$var$MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
    table_bits = root_bits;
    table_size = 1 << table_bits;
    total_size = table_size;
    /* special case code with only one value */ if (offset[$ecfb9b5b3306a38a$var$MAX_LENGTH] === 1) {
        for(key = 0; key < total_size; ++key)root_table[table + key] = new $ecfb9b5b3306a38a$var$HuffmanCode(0, sorted[0] & 0xffff);
        return total_size;
    }
    /* fill in root table */ key = 0;
    symbol = 0;
    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        code = new $ecfb9b5b3306a38a$var$HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
        $ecfb9b5b3306a38a$var$ReplicateValue(root_table, table + key, step, table_size, code);
        key = $ecfb9b5b3306a38a$var$GetNextKey(key, len);
    }
    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
    low = -1;
    for(len = root_bits + 1, step = 2; len <= $ecfb9b5b3306a38a$var$MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        if ((key & mask) !== low) {
            table += table_size;
            table_bits = $ecfb9b5b3306a38a$var$NextTableBitSize(count, len, root_bits);
            table_size = 1 << table_bits;
            total_size += table_size;
            low = key & mask;
            root_table[start_table + low] = new $ecfb9b5b3306a38a$var$HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
        }
        code = new $ecfb9b5b3306a38a$var$HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
        $ecfb9b5b3306a38a$var$ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
        key = $ecfb9b5b3306a38a$var$GetNextKey(key, len);
    }
    return total_size;
};

});

parcelRegister("hX8C6", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $d11ea0ce95d3ac2c$export$dfc7155ac0343b8, (v) => $d11ea0ce95d3ac2c$export$dfc7155ac0343b8 = v);
$parcel$export(module.exports, "lookupOffsets", () => $d11ea0ce95d3ac2c$export$cc8d42455ae4ca5e, (v) => $d11ea0ce95d3ac2c$export$cc8d42455ae4ca5e = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ /* Common context lookup table for all context modes. */ var $d11ea0ce95d3ac2c$export$dfc7155ac0343b8;
var $d11ea0ce95d3ac2c$export$cc8d42455ae4ca5e;
var $d11ea0ce95d3ac2c$var$CONTEXT_LSB6 = 0;
var $d11ea0ce95d3ac2c$var$CONTEXT_MSB6 = 1;
var $d11ea0ce95d3ac2c$var$CONTEXT_UTF8 = 2;
var $d11ea0ce95d3ac2c$var$CONTEXT_SIGNED = 3;
$d11ea0ce95d3ac2c$export$dfc7155ac0343b8 = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */ 0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */ 2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */ 0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */ 0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
$d11ea0ce95d3ac2c$export$cc8d42455ae4ca5e = new Uint16Array([
    /* CONTEXT_LSB6 */ 1024,
    1536,
    /* CONTEXT_MSB6 */ 1280,
    1536,
    /* CONTEXT_UTF8 */ 0,
    256,
    /* CONTEXT_SIGNED */ 768,
    512
]);

});

parcelRegister("7aaiK", function(module, exports) {

$parcel$export(module.exports, "kBlockLengthPrefixCode", () => $5371753d531ab78c$export$6e6a061a64eda771, (v) => $5371753d531ab78c$export$6e6a061a64eda771 = v);
$parcel$export(module.exports, "kInsertLengthPrefixCode", () => $5371753d531ab78c$export$62ffb848600e90dd, (v) => $5371753d531ab78c$export$62ffb848600e90dd = v);
$parcel$export(module.exports, "kCopyLengthPrefixCode", () => $5371753d531ab78c$export$cc7c44d8afc93b69, (v) => $5371753d531ab78c$export$cc7c44d8afc93b69 = v);
$parcel$export(module.exports, "kInsertRangeLut", () => $5371753d531ab78c$export$91c779240ecfdaca, (v) => $5371753d531ab78c$export$91c779240ecfdaca = v);
$parcel$export(module.exports, "kCopyRangeLut", () => $5371753d531ab78c$export$c243b934bf41e980, (v) => $5371753d531ab78c$export$c243b934bf41e980 = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ var $5371753d531ab78c$export$6e6a061a64eda771;
var $5371753d531ab78c$export$62ffb848600e90dd;
var $5371753d531ab78c$export$cc7c44d8afc93b69;
var $5371753d531ab78c$export$91c779240ecfdaca;
var $5371753d531ab78c$export$c243b934bf41e980;
function $5371753d531ab78c$var$PrefixCodeRange(offset, nbits) {
    this.offset = offset;
    this.nbits = nbits;
}
$5371753d531ab78c$export$6e6a061a64eda771 = [
    new $5371753d531ab78c$var$PrefixCodeRange(1, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(5, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(9, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(13, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(17, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(25, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(33, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(41, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(49, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(65, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(81, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(97, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(113, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(145, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(177, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(209, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(241, 6),
    new $5371753d531ab78c$var$PrefixCodeRange(305, 6),
    new $5371753d531ab78c$var$PrefixCodeRange(369, 7),
    new $5371753d531ab78c$var$PrefixCodeRange(497, 8),
    new $5371753d531ab78c$var$PrefixCodeRange(753, 9),
    new $5371753d531ab78c$var$PrefixCodeRange(1265, 10),
    new $5371753d531ab78c$var$PrefixCodeRange(2289, 11),
    new $5371753d531ab78c$var$PrefixCodeRange(4337, 12),
    new $5371753d531ab78c$var$PrefixCodeRange(8433, 13),
    new $5371753d531ab78c$var$PrefixCodeRange(16625, 24)
];
$5371753d531ab78c$export$62ffb848600e90dd = [
    new $5371753d531ab78c$var$PrefixCodeRange(0, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(1, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(2, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(3, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(4, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(5, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(6, 1),
    new $5371753d531ab78c$var$PrefixCodeRange(8, 1),
    new $5371753d531ab78c$var$PrefixCodeRange(10, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(14, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(18, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(26, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(34, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(50, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(66, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(98, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(130, 6),
    new $5371753d531ab78c$var$PrefixCodeRange(194, 7),
    new $5371753d531ab78c$var$PrefixCodeRange(322, 8),
    new $5371753d531ab78c$var$PrefixCodeRange(578, 9),
    new $5371753d531ab78c$var$PrefixCodeRange(1090, 10),
    new $5371753d531ab78c$var$PrefixCodeRange(2114, 12),
    new $5371753d531ab78c$var$PrefixCodeRange(6210, 14),
    new $5371753d531ab78c$var$PrefixCodeRange(22594, 24)
];
$5371753d531ab78c$export$cc7c44d8afc93b69 = [
    new $5371753d531ab78c$var$PrefixCodeRange(2, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(3, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(4, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(5, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(6, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(7, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(8, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(9, 0),
    new $5371753d531ab78c$var$PrefixCodeRange(10, 1),
    new $5371753d531ab78c$var$PrefixCodeRange(12, 1),
    new $5371753d531ab78c$var$PrefixCodeRange(14, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(18, 2),
    new $5371753d531ab78c$var$PrefixCodeRange(22, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(30, 3),
    new $5371753d531ab78c$var$PrefixCodeRange(38, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(54, 4),
    new $5371753d531ab78c$var$PrefixCodeRange(70, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(102, 5),
    new $5371753d531ab78c$var$PrefixCodeRange(134, 6),
    new $5371753d531ab78c$var$PrefixCodeRange(198, 7),
    new $5371753d531ab78c$var$PrefixCodeRange(326, 8),
    new $5371753d531ab78c$var$PrefixCodeRange(582, 9),
    new $5371753d531ab78c$var$PrefixCodeRange(1094, 10),
    new $5371753d531ab78c$var$PrefixCodeRange(2118, 24)
];
$5371753d531ab78c$export$91c779240ecfdaca = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
];
$5371753d531ab78c$export$c243b934bf41e980 = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
];

});

parcelRegister("4zIc9", function(module, exports) {

$parcel$export(module.exports, "kNumTransforms", () => $354cb680e66e788a$export$5d2d653c67838a2, (v) => $354cb680e66e788a$export$5d2d653c67838a2 = v);
$parcel$export(module.exports, "transformDictionaryWord", () => $354cb680e66e788a$export$8cfa5a6f89d017bb, (v) => $354cb680e66e788a$export$8cfa5a6f89d017bb = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var $354cb680e66e788a$export$4898d75d9d9d305c;
var $354cb680e66e788a$export$5d2d653c67838a2;
var $354cb680e66e788a$export$8cfa5a6f89d017bb;

var $fo1rr = parcelRequire("fo1rr");
var $354cb680e66e788a$var$kIdentity = 0;
var $354cb680e66e788a$var$kOmitLast1 = 1;
var $354cb680e66e788a$var$kOmitLast2 = 2;
var $354cb680e66e788a$var$kOmitLast3 = 3;
var $354cb680e66e788a$var$kOmitLast4 = 4;
var $354cb680e66e788a$var$kOmitLast5 = 5;
var $354cb680e66e788a$var$kOmitLast6 = 6;
var $354cb680e66e788a$var$kOmitLast7 = 7;
var $354cb680e66e788a$var$kOmitLast8 = 8;
var $354cb680e66e788a$var$kOmitLast9 = 9;
var $354cb680e66e788a$var$kUppercaseFirst = 10;
var $354cb680e66e788a$var$kUppercaseAll = 11;
var $354cb680e66e788a$var$kOmitFirst1 = 12;
var $354cb680e66e788a$var$kOmitFirst2 = 13;
var $354cb680e66e788a$var$kOmitFirst3 = 14;
var $354cb680e66e788a$var$kOmitFirst4 = 15;
var $354cb680e66e788a$var$kOmitFirst5 = 16;
var $354cb680e66e788a$var$kOmitFirst6 = 17;
var $354cb680e66e788a$var$kOmitFirst7 = 18;
var $354cb680e66e788a$var$kOmitFirst8 = 19;
var $354cb680e66e788a$var$kOmitFirst9 = 20;
function $354cb680e66e788a$var$Transform(prefix, transform, suffix) {
    this.prefix = new Uint8Array(prefix.length);
    this.transform = transform;
    this.suffix = new Uint8Array(suffix.length);
    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
}
var $354cb680e66e788a$var$kTransforms = [
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst1, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " the "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, ""),
    new $354cb680e66e788a$var$Transform("s ", $354cb680e66e788a$var$kIdentity, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " of "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " and "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst2, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast1, ""),
    new $354cb680e66e788a$var$Transform(", ", $354cb680e66e788a$var$kIdentity, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, ", "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " in "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " to "),
    new $354cb680e66e788a$var$Transform("e ", $354cb680e66e788a$var$kIdentity, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "\""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "."),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "\">"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "\n"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast3, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "]"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " for "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst3, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast2, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " a "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " that "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, ". "),
    new $354cb680e66e788a$var$Transform(".", $354cb680e66e788a$var$kIdentity, ""),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, ", "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst4, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " with "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "'"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " from "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " by "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst5, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst6, ""),
    new $354cb680e66e788a$var$Transform(" the ", $354cb680e66e788a$var$kIdentity, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast4, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, ". The "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " on "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " as "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " is "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast7, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast1, "ing "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "\n\t"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, ":"),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, ". "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "ed "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst9, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitFirst7, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast6, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "("),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, ", "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast8, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " at "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "ly "),
    new $354cb680e66e788a$var$Transform(" the ", $354cb680e66e788a$var$kIdentity, " of "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast5, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kOmitLast9, ""),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, ", "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, "\""),
    new $354cb680e66e788a$var$Transform(".", $354cb680e66e788a$var$kIdentity, "("),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, "\">"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "=\""),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, "."),
    new $354cb680e66e788a$var$Transform(".com/", $354cb680e66e788a$var$kIdentity, ""),
    new $354cb680e66e788a$var$Transform(" the ", $354cb680e66e788a$var$kIdentity, " of the "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, "'"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, ". This "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, ","),
    new $354cb680e66e788a$var$Transform(".", $354cb680e66e788a$var$kIdentity, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, "("),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, "."),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, " not "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, "=\""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "er "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseAll, " "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "al "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseAll, ""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "='"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, "\""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, ". "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, "("),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "ful "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, ". "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "ive "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "less "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, "'"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "est "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, "."),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, "\">"),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, "='"),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, ","),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "ize "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, "."),
    new $354cb680e66e788a$var$Transform("\xc2\xa0", $354cb680e66e788a$var$kIdentity, ""),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kIdentity, ","),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, "=\""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, "=\""),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kIdentity, "ous "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, ", "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseFirst, "='"),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, ","),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseAll, "=\""),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseAll, ", "),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, ","),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, "("),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, ". "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseAll, "."),
    new $354cb680e66e788a$var$Transform("", $354cb680e66e788a$var$kUppercaseAll, "='"),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseAll, ". "),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, "=\""),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseAll, "='"),
    new $354cb680e66e788a$var$Transform(" ", $354cb680e66e788a$var$kUppercaseFirst, "='")
];
$354cb680e66e788a$export$4898d75d9d9d305c = $354cb680e66e788a$var$kTransforms;
$354cb680e66e788a$export$5d2d653c67838a2 = $354cb680e66e788a$var$kTransforms.length;
function $354cb680e66e788a$var$ToUpperCase(p, i) {
    if (p[i] < 0xc0) {
        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
        return 1;
    }
    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
        p[i + 1] ^= 32;
        return 2;
    }
    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
    return 3;
}
$354cb680e66e788a$export$8cfa5a6f89d017bb = function(dst, idx, word, len, transform) {
    var prefix = $354cb680e66e788a$var$kTransforms[transform].prefix;
    var suffix = $354cb680e66e788a$var$kTransforms[transform].suffix;
    var t = $354cb680e66e788a$var$kTransforms[transform].transform;
    var skip = t < $354cb680e66e788a$var$kOmitFirst1 ? 0 : t - ($354cb680e66e788a$var$kOmitFirst1 - 1);
    var i = 0;
    var start_idx = idx;
    var uppercase;
    if (skip > len) skip = len;
    var prefix_pos = 0;
    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
    word += skip;
    len -= skip;
    if (t <= $354cb680e66e788a$var$kOmitLast9) len -= t;
    for(i = 0; i < len; i++)dst[idx++] = $fo1rr.dictionary[word + i];
    uppercase = idx - len;
    if (t === $354cb680e66e788a$var$kUppercaseFirst) $354cb680e66e788a$var$ToUpperCase(dst, uppercase);
    else if (t === $354cb680e66e788a$var$kUppercaseAll) while(len > 0){
        var step = $354cb680e66e788a$var$ToUpperCase(dst, uppercase);
        uppercase += step;
        len -= step;
    }
    var suffix_pos = 0;
    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
    return idx - start_idx;
};

});




parcelRegister("31QE8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0373be29a832db$export$2e2bcd8739ae039);

var $9daMG = parcelRequire("9daMG");

var $jI3YX = parcelRequire("jI3YX");
var $8c0373be29a832db$export$2e2bcd8739ae039 = {};
"use strict";
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$af862512e23cb54 = 0; // Opening punctuation
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$9bf3043cb7503aa1 = 1; // Closing punctuation
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$6d0b2a5dd774590a = 2; // Closing parenthesis
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$bf0b2277bd569ea1 = 3; // Ambiguous quotation
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$bad2a840ccda93b6 = 4; // Glue
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$fb4028874a74450 = 5; // Non-starters
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$463bd1ce0149c55e = 6; // Exclamation/Interrogation
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$2e8caadc521d7cbb = 7; // Symbols allowing break after
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$bfe27467c1de9413 = 8; // Infix separator
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$af5f8d68aad3cd3a = 9; // Prefix
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$6b7e017d6825d38f = 10; // Postfix
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$8227ca023eb0daaa = 11; // Numeric
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$1bb1140fe1358b00 = 12; // Alphabetic
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$f3e416a182673355 = 13; // Hebrew Letter
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$8be180ec26319f9f = 14; // Ideographic
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$70824c8942178d60 = 15; // Inseparable characters
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$24aa617c849a894a = 16; // Hyphen
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$a73c4d14459b698d = 17; // Break after
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$921068d8846a1559 = 18; // Break before
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$8b85a4f193482778 = 19; // Break on either side (but not pair)
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$b2fd9c01d360241f = 20; // Zero-width space
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$dcd191669c0a595f = 21; // Combining marks
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$9e5d732f3676a9ba = 22; // Word joiner
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$cb94397127ac9363 = 23; // Hangul LV
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$746be9e3a3dfff1f = 24; // Hangul LVT
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$96e3e682276c47cf = 25; // Hangul L Jamo
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$fc2ff69ee2cb01bf = 26; // Hangul V Jamo
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$8999624a7bae9d04 = 27; // Hangul T Jamo
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$1dff41d5c0caca01 = 28; // Regional Indicator
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$ddb7a6c76d9d93eb = 29; // Emoji Base
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$7e93eb3105e4786d = 30; // Emoji Modifier
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$30a74a373318dec6 = 31; // Zero Width Joiner
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$54caeea5e6dab1f = 32; // Contingent break
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$d710c5f50fc7496a = 33; // Ambiguous (Alphabetic or Ideograph)
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$66498d28055820a9 = 34; // Break (mandatory)
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$eb6c6d0b7c8826f2 = 35; // Conditional Japanese Starter
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$de92be486109a1df = 36; // Carriage return
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$606cfc2a8896c91f = 37; // Line feed
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$e51d3c675bb0140d = 38; // Next line
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$da51c6332ad11d7b = 39; // South-East Asian
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$bea437c40441867d = 40; // Surrogates
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9 = 41; // Space
const $8c0373be29a832db$var$$1627905f8be2ef3f$export$98e1f8a379849661 = 42; // Unknown
const $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745 = 0; // Direct break opportunity
const $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e = 1; // Indirect break opportunity
const $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454 = 2; // Indirect break opportunity for combining marks
const $8c0373be29a832db$var$$32627af916ac1b00$export$8f14048969dcd45e = 3; // Prohibited break for combining marks
const $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4 = 4; // Prohibited break
const $8c0373be29a832db$var$$32627af916ac1b00$export$5bdb8ccbf5c57afc = [
    //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$8f14048969dcd45e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454,
        $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745,
        $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745
    ] // CB
];
const $8c0373be29a832db$var$$557adaaeb0c7885f$var$data = (0, (/*@__PURE__*/$parcel$interopDefault($jI3YX))).toByteArray("AAgOAAAAAAAQ4QAAAQ0P8vDtnQuMXUUZx+eyu7d7797d9m5bHoWltKVUlsjLWE0VJNigQoMVqkStEoNQQUl5GIo1KKmogEgqkKbBRki72lYabZMGKoGAjQRtJJDaCCIRiiigREBQS3z+xzOTnZ3O+3HOhd5NfpkzZx7fN9988zivu2M9hGwB28F94DnwEngd/Asc1EtIs9c/bIPDwCxwLDgezHcodyo4w5C+CCwBS8FnwSXgCnA1uFbI93XwbXAbWAfWgx+CzWAb+An4KfgFeAzsYWWfYuFz4CXwGvgb+Dfo6yNkEEwGh4CZYB44FpwI3g1OY+kfBItZOo2fB84Hy8DF4HJwNbiWpV8PVoO1LH4n2NRXyN+KcAd4kNVP9XsY4aPgcfAbsBfs6SniL4K/sPjfEf6HlanXCRkCw2BGvUh/keWfXS/CY+pFXs7x9XHmM94LTmWIeU2cgbxnS/k/B3kf86jDhU8L9V2E40vAFWAlWFUfb++NOL4F3C7JX4/4GiE+hvgWsF0oS7mXldspnN+F493gyXrh9xTav0cg3EvzgVfBG6wsmVSEkxBOBgdPGpd7JI6PnqRvJ68/xlbHof53gPeA94OzwLngk+ACsAwsByvASrAK3MB0Ws3CtQjvBJvAVrADPMDSHkb4CNijaccTwvnf4fiPEs8Lxy+D18A/QU8/xjgYBjPAbDAKTgYLwOngTHAO+EQ/8wuEF4EvsPiVCFf2+9tsFStzA8LVHuXXBsi6QyqzUYiPMR/7Mc7dAx7oL8bzw/3u/Bw8Bp4Az4AXwCtgHzsmDXP5fiF9iiVvly5d0sHngar16NKlS5cuXbp06fLmYlqHXrcd3ph4P0THUY3iXh49novju4S0tzfs5d+JPKewfAsRntZb3K9ZhOMlrO6lCC8An28U9+OuovcPcPxlVu5rCL/VmHh/iHIrzn3fIPu7SN8Axmg+8AOwEWwCm7tp3bRuWjetm5Y8bSu4B9zbKO6ZVsnORrVU3f4uXTqZ2H3sLoyx3eDXjfDndE9qyj6L838CfwVvgFpzYnof4oNgOhgBc8Fos9DrZIQLmtXPP1MmF6wGj4H+KXoWguvADkXaPil+YpuQy8Am8Ey7ODdtmJDF4HowBp4De6HDTNjhfHAHeBr0DBBy0kDxfPbcgSIusgrcWhtnJ8vL+TPix7UIOQtcBq4C28Cr4KRBnANbwSuDE+s50JgyNNFuXbp06XIgsXjIvPafjvXozKY+fVFz/z0LT1uCtKVSWbrOLWPnztG8e0Xfy7ol8XtZJi7WtG+5od2UFXQ/A12vUeS7jp27yVKHjdsU9lXB869TyNvAzt0lpP2oWbwLdjiO78bx/Sz+EMJHwK9Y/LcIfw+eZ3F67/Hl5vh9xX80J+rwX8SvRDhpgL17iPAQMHNArfPrqHPewLheI+AERV6efwV418B4nOZ/H+IfYHV8GOF5LJ3eAz0fx8sM9S0fUNud39O9CulfGZhY5huI3wzWgNvBelbHZoTbNPVpfYjKQpkHwUNgl0LWblbnk0LbbDxr0OMFpL3iqWdu9nWYPlVAWkXY39LnGdCkDbeqv1YNbfcMQ3t9oe8lzm6NH9N1ZB6Ln4BwfkJZJk7RyFnYKt6b/JDQXx9p5X+eFdqOjzM9P9MB/lUlFzr20aXIdzlY4dmn9F3YqtvoO76/2hp/D/xA5Zue88nNyL8GbFbs075X0tyUig3Qd2MCnf//HjnzpbsR3g9+1kHzzVjdnE71/qVBX9rGPUh/ysNWe1neFzvIDi5zAufV1sT0N0poR22wkFUfTOPfA4N2mbZ5fSrqOHSw+IbkSBbOGSzSRgf91/GTUWYBOB2cIZQ/G8cfBZ8CFwrnL8XxF8FKcA24jqXdiPA7Qr61OF7H4mMItwzuv2/YLth1ISt3Hzu3k4W7EH5JqPdRHD/O4k+z8A8IX5Lq3y7Z4nXE9xn6kX6vQ4bKfy+ok+hH+xf3hq9dnTTHhjKd2GmDuWA242iHMq4cC7A8kJ7i8o1+skSa7Jieo38HCWnoNjKFhdSFBxzpZ7QE6lI8N4S14aASZcryaV/WWHw66f6NHuCoxuQxmvM56GX9QMd8Q4D65ywGP+ZzRJuM+zQvx/MOS2VFeqQ4IXnH26zM9Xe6/E6D+4foAzzuajPZp8Qyw5ayZVDWuH0z0BtYRkeIDqH9KO9VbH1btd/lhNqCzvl8zeLnG0S/hnU6baHfpiuO6yy0rd+DHURo/zYF5H26j03rQsip2ndzz82u1z9N4VjWKWeb68Tedpt95HRVXp7H1R6p+/Wt4FPy/PpWwscOLRJ+PVWF/+W0iVyGzs18TIvXkOJ1Wxm66vSXz+vylenrZcj1ub439W+K8RNCGTJi2p/TJ1K23VaXr35tRpnzmjxequgfcfyk6B/TGBVlyedsNgpdd/h+W1U3P99QyFPNo1X3TwpM/WLTIWYfoBqXrv6iskHZ/RFr79R6hIyHBrH3f1nrUVnjP8SnZZ+rYtzr9Exld5MNbPNErusAPg+77u/eDOPftU9yj39TH7rezxd1LvsZQJlzkWlOirG/79zjMj/mtHUKu7vKy+3/LnXr9okyKedjX5/0He9iP/j63LwOQdarEVlfy8OO/Lqw023j6xcqmwxLiOd6heM2i9cV9LJy8jMJ23yQ+rpbfu7EQ/pXE8KYvUSqvVnb4XzZa6LrHMXHR+zcLvqWbm/Bn0/HzIs6fWPHoat8XfnDKmZGxRxeMbn2UqZ5Q94nmcZRbqqUXbZ8+lcjE+cPX11t814orvvAXNcG8vqj2vvk1MGn3anlj0bIT72v47bvE+Lc98T9b6r7AKn6j+8Duf7D0nnZx/j7Zjn0j9nbpSTndaLr9WNLivP+iN23xF7L+fqv6ZouFyb78jxVXvv5jJ9YUs9/sddO8h7KNg5jrhfaJGztT6G7KF+1d6yCmD5Kdb2fan60rSc552fZr3zeQ9DpnPp+Si5cx5Ktv2QfSzF/mMbWdOm46rFI4XstnU9xeqX4NKb7TKEdcr6pZOK3ID1k/LvFHkVczEuZLEDr499YqvqBym1aEHWgcvoYOtv0M91qQl5TfpO/in6rWx8OVpT1Wedkv3f5xom3T/xeR/6Gx6V86PWAOB4bBpqWdN+yTcVxjIyGRz/FrDGu6w/3d7kPm8StX8RyPu+uuvpNju/vTLJV37GpvoM0oZPnW87VLnL/5pDno1NoW1R6yedU6TyUv3u19a3KFnIbTLYz+ZCLP4T0tU1uivFgso0pnsJ/UtXvarNY28Xq5cvkBDrQP/E5ZaiuQwwfmTlsOiQRU1fMuqrDd/3ISSuwjOwXOfTyGUMpZIXq4GpLn3pUcdfzch2x7XO1u2uZHOPb1G6b3Xg9PH1IIWeEpJlPQtqos2EKW8b0u8rnuP1UeVLoXJb9be0uG9nnbchjU+XTszT5VeNBThPHnc5OKj1U9aj0GTHIVaGy1YhEWT4ixns00DT+XEzWn/7VAsIc63Cov3OdyhwjrnaqQqZvWKXdypRdlq+k8msZ031U+Rm4fA+3TtyeR9hwfW9G9yxDN0fZMN33F+9TE6md4hwoxumfaUzI9fN3PFT3xVV2msrQ3UsnChm6Nulk8TndpS28D3zX9tTIPsF/z7Am5OkTjm1tI1JZW74+4VgsZ0N3L1yXV3WeP5uR7TGHHdvC3JQlxybfpd22tDlk/2eofRK8TzrN/qnar/K/OUTth6I/+jAnEptNbPvFHP2gs40N3+dfMWtwqvVct7/wfd8gtQ7imifial9ZJ9/3IHLYU6eDj3+4PhsNhX+vwvcWLnu6kGfEMe8DuciPfUfGZB8X/7HJy/Gefe5n+VRGFd/wyP2ta7/LO4yh/sbLV/k9lev6kfO9Dt/5U67b1/6u/epqB1U9Me23jfHY9sscAg4tkbLl+e4/U36rJ9ddxfd6sg5vq5ice42Wpk/pb9FOJ36/W9tpv4kbC79nUbZceX8Zu6/qJ+P3WvhvA8v3reh7Jbn2d6rrNC7XNZTLma4Ba0JI9efX2uLzF5scG/w9UNU1ZxW+ymUfzELeTllXlQ1rUuhzjS5fp9c964iFBOqeSz63bU065nZKdU+mDEz3qHIjjifquw0pnb/raRtvrnsYcb46ihT3taoYz6brdNW9l6rWRnE/navdPn1XlR1km7hcz1WlH/elKuSOSvLLuE8U6m8uzwRdfcGl73VyTHuyMvzJ1Sa2cWDTP/Z63Kc94n2B1PYr24dz1JlyHLlcP+S4B6vD1c9EW4q2LWstCvUjeVy63k/LMYdUNd5D1xQfvVTzX1VjkMsUv88N8VH5fReVn/Fjn++/h6X6Q8a6b1/q3g/i/ewi0/Scs8zxXeV6mWIOUPlPzBgdFerW+bZrm2P18dnjuK6HunEp+rHvPMXbr+sHVb/lnL+pTP57jPw9Cvk3PW178JD9qChfzuvTf7Htl38L1QUf/VKu9SFjwWbTWPvFEvu7Uq76y7+31g6QlYPc669pbsm9Xur2LWI9Pu8ypfDXqm3A2z8s1FWGn4ntL9NfQu2oSlftX9uetvTtv7J8Ql4zxfXGZ3zk8PeQ9w59x2uMfqI8/q5eKh/l9cb2rwsu9rSNl06ZP2Pmxtz+rNMx93yno0n2/82rVH7rQ+y9P15H6FyRun9ViH81ATmffI7nJ5r8uXXW6enbP6b/B8/l5OifVHYLnb9S39s2zcc+Ph+rh8+eQgVPS72elzGWY/tUtbbabBpDiI7yN1q6/4th2y+ErAc5+9BVvu/7KamJbWNZeuqI/R4tRf+YyD1HmOZM1bMV3/14Sn10c0Xu+Sj1nOXb5jL73ncdy02uvlXZNde65dOHYl7Vs4KYuS6FzWLn2zJlpZqPXPVPOa5yzKOyn1VhT9lmMfdbfH7D11Wf2PXN5h9y+dD287+qxgSnaYmnIrRtIb8pJe6/Uv9OVer6Whn0zfGO/BEloZI9ojmfAlUflClDd178bTmVHVTpZXOkAlk/lb42UujmI89HH5V+cl7XtowY6vTxLVWok6UrGzoGTHN+bB+6ri05687VNpvfuvRfaP2uMlNQth1D5JjGelm/8yn+9p3p/7qk9gnfeddXZmq/Sm333PJT659Kv1zjNbZ9uv2Oi//67CV8/N1nj1DmviyXDNVeJkaeaX8UsyesYg8cu2+NvdaPfb+lLDu5tvt/");
const $8c0373be29a832db$var$$557adaaeb0c7885f$var$classTrie = new (0, (/*@__PURE__*/$parcel$interopDefault($9daMG)))($8c0373be29a832db$var$$557adaaeb0c7885f$var$data);
const $8c0373be29a832db$var$$557adaaeb0c7885f$var$mapClass = function(c) {
    switch(c){
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$d710c5f50fc7496a:
            return $8c0373be29a832db$var$$1627905f8be2ef3f$export$1bb1140fe1358b00;
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$da51c6332ad11d7b:
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$bea437c40441867d:
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$98e1f8a379849661:
            return $8c0373be29a832db$var$$1627905f8be2ef3f$export$1bb1140fe1358b00;
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$eb6c6d0b7c8826f2:
            return $8c0373be29a832db$var$$1627905f8be2ef3f$export$fb4028874a74450;
        default:
            return c;
    }
};
const $8c0373be29a832db$var$$557adaaeb0c7885f$var$mapFirst = function(c) {
    switch(c){
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$606cfc2a8896c91f:
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$e51d3c675bb0140d:
            return $8c0373be29a832db$var$$1627905f8be2ef3f$export$66498d28055820a9;
        case $8c0373be29a832db$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9:
            return $8c0373be29a832db$var$$1627905f8be2ef3f$export$9e5d732f3676a9ba;
        default:
            return c;
    }
};
class $8c0373be29a832db$var$$557adaaeb0c7885f$var$Break {
    constructor(position, required = false){
        this.position = position;
        this.required = required;
    }
}
class $8c0373be29a832db$var$$557adaaeb0c7885f$var$LineBreaker {
    nextCodePoint() {
        const code = this.string.charCodeAt(this.pos++);
        const next = this.string.charCodeAt(this.pos);
        // If a surrogate pair
        if (0xd800 <= code && code <= 0xdbff && 0xdc00 <= next && next <= 0xdfff) {
            this.pos++;
            return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000;
        }
        return code;
    }
    nextCharClass() {
        return $8c0373be29a832db$var$$557adaaeb0c7885f$var$mapClass($8c0373be29a832db$var$$557adaaeb0c7885f$var$classTrie.get(this.nextCodePoint()));
    }
    getSimpleBreak() {
        // handle classes not handled by the pair table
        switch(this.nextClass){
            case $8c0373be29a832db$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9:
                return false;
            case $8c0373be29a832db$var$$1627905f8be2ef3f$export$66498d28055820a9:
            case $8c0373be29a832db$var$$1627905f8be2ef3f$export$606cfc2a8896c91f:
            case $8c0373be29a832db$var$$1627905f8be2ef3f$export$e51d3c675bb0140d:
                this.curClass = $8c0373be29a832db$var$$1627905f8be2ef3f$export$66498d28055820a9;
                return false;
            case $8c0373be29a832db$var$$1627905f8be2ef3f$export$de92be486109a1df:
                this.curClass = $8c0373be29a832db$var$$1627905f8be2ef3f$export$de92be486109a1df;
                return false;
        }
        return null;
    }
    getPairTableBreak(lastClass) {
        // if not handled already, use the pair table
        let shouldBreak = false;
        switch($8c0373be29a832db$var$$32627af916ac1b00$export$5bdb8ccbf5c57afc[this.curClass][this.nextClass]){
            case $8c0373be29a832db$var$$32627af916ac1b00$export$98f50d781a474745:
                shouldBreak = true;
                break;
            case $8c0373be29a832db$var$$32627af916ac1b00$export$12ee1f8f5315ca7e:
                shouldBreak = lastClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9;
                break;
            case $8c0373be29a832db$var$$32627af916ac1b00$export$e4965ce242860454:
                shouldBreak = lastClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9;
                if (!shouldBreak) {
                    shouldBreak = false;
                    return shouldBreak;
                }
                break;
            case $8c0373be29a832db$var$$32627af916ac1b00$export$8f14048969dcd45e:
                if (lastClass !== $8c0373be29a832db$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9) return shouldBreak;
                break;
            case $8c0373be29a832db$var$$32627af916ac1b00$export$133eb141bf58aff4:
                break;
        }
        if (this.LB8a) shouldBreak = false;
        // Rule LB21a
        if (this.LB21a && (this.curClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$24aa617c849a894a || this.curClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$a73c4d14459b698d)) {
            shouldBreak = false;
            this.LB21a = false;
        } else this.LB21a = this.curClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$f3e416a182673355;
        // Rule LB30a
        if (this.curClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$1dff41d5c0caca01) {
            this.LB30a++;
            if (this.LB30a == 2 && this.nextClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$1dff41d5c0caca01) {
                shouldBreak = true;
                this.LB30a = 0;
            }
        } else this.LB30a = 0;
        this.curClass = this.nextClass;
        return shouldBreak;
    }
    nextBreak() {
        // get the first char if we're at the beginning of the string
        if (this.curClass == null) {
            let firstClass = this.nextCharClass();
            this.curClass = $8c0373be29a832db$var$$557adaaeb0c7885f$var$mapFirst(firstClass);
            this.nextClass = firstClass;
            this.LB8a = firstClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$30a74a373318dec6;
            this.LB30a = 0;
        }
        while(this.pos < this.string.length){
            this.lastPos = this.pos;
            const lastClass = this.nextClass;
            this.nextClass = this.nextCharClass();
            // explicit newline
            if (this.curClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$66498d28055820a9 || this.curClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$de92be486109a1df && this.nextClass !== $8c0373be29a832db$var$$1627905f8be2ef3f$export$606cfc2a8896c91f) {
                this.curClass = $8c0373be29a832db$var$$557adaaeb0c7885f$var$mapFirst($8c0373be29a832db$var$$557adaaeb0c7885f$var$mapClass(this.nextClass));
                return new $8c0373be29a832db$var$$557adaaeb0c7885f$var$Break(this.lastPos, true);
            }
            let shouldBreak = this.getSimpleBreak();
            if (shouldBreak === null) shouldBreak = this.getPairTableBreak(lastClass);
            // Rule LB8a
            this.LB8a = this.nextClass === $8c0373be29a832db$var$$1627905f8be2ef3f$export$30a74a373318dec6;
            if (shouldBreak) return new $8c0373be29a832db$var$$557adaaeb0c7885f$var$Break(this.lastPos);
        }
        if (this.lastPos < this.string.length) {
            this.lastPos = this.string.length;
            return new $8c0373be29a832db$var$$557adaaeb0c7885f$var$Break(this.string.length);
        }
        return null;
    }
    constructor(string){
        this.string = string;
        this.pos = 0;
        this.lastPos = 0;
        this.curClass = null;
        this.nextClass = null;
        this.LB8a = false;
        this.LB21a = false;
        this.LB30a = 0;
    }
}
$8c0373be29a832db$export$2e2bcd8739ae039 = $8c0373be29a832db$var$$557adaaeb0c7885f$var$LineBreaker;

});
parcelRegister("jI3YX", function(module, exports) {
var $e59537245c58aa5f$var$lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
(function(exports1) {
    'use strict';
    var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    var PLUS = '+'.charCodeAt(0);
    var SLASH = '/'.charCodeAt(0);
    var NUMBER = '0'.charCodeAt(0);
    var LOWER = 'a'.charCodeAt(0);
    var UPPER = 'A'.charCodeAt(0);
    var PLUS_URL_SAFE = '-'.charCodeAt(0);
    var SLASH_URL_SAFE = '_'.charCodeAt(0);
    function decode(elt) {
        var code = elt.charCodeAt(0);
        if (code === PLUS || code === PLUS_URL_SAFE) return 62 // '+'
        ;
        if (code === SLASH || code === SLASH_URL_SAFE) return 63 // '/'
        ;
        if (code < NUMBER) return -1 //no match
        ;
        if (code < NUMBER + 10) return code - NUMBER + 26 + 26;
        if (code < UPPER + 26) return code - UPPER;
        if (code < LOWER + 26) return code - LOWER + 26;
    }
    function b64ToByteArray(b64) {
        var i, j, l, tmp, placeHolders, arr;
        if (b64.length % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
        // the number of equal signs (place holders)
        // if there are two placeholders, than the two characters before it
        // represent one byte
        // if there is only one, then the three characters before it represent 2 bytes
        // this is just a cheap hack to not do indexOf twice
        var len = b64.length;
        placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0;
        // base64 is 4/3 + up to two characters of the original data
        arr = new Arr(b64.length * 3 / 4 - placeHolders);
        // if there are placeholders, only get up to the last complete 4 chars
        l = placeHolders > 0 ? b64.length - 4 : b64.length;
        var L = 0;
        function push(v) {
            arr[L++] = v;
        }
        for(i = 0, j = 0; i < l; i += 4, j += 3){
            tmp = decode(b64.charAt(i)) << 18 | decode(b64.charAt(i + 1)) << 12 | decode(b64.charAt(i + 2)) << 6 | decode(b64.charAt(i + 3));
            push((tmp & 0xFF0000) >> 16);
            push((tmp & 0xFF00) >> 8);
            push(tmp & 0xFF);
        }
        if (placeHolders === 2) {
            tmp = decode(b64.charAt(i)) << 2 | decode(b64.charAt(i + 1)) >> 4;
            push(tmp & 0xFF);
        } else if (placeHolders === 1) {
            tmp = decode(b64.charAt(i)) << 10 | decode(b64.charAt(i + 1)) << 4 | decode(b64.charAt(i + 2)) >> 2;
            push(tmp >> 8 & 0xFF);
            push(tmp & 0xFF);
        }
        return arr;
    }
    function uint8ToBase64(uint8) {
        var i, extraBytes = uint8.length % 3, output = "", temp, length;
        function encode(num) {
            return $e59537245c58aa5f$var$lookup.charAt(num);
        }
        function tripletToBase64(num) {
            return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F);
        }
        // go through the array every three bytes, we'll deal with trailing stuff later
        for(i = 0, length = uint8.length - extraBytes; i < length; i += 3){
            temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
            output += tripletToBase64(temp);
        }
        // pad the end with zeros, but make sure to not forget the extra bytes
        switch(extraBytes){
            case 1:
                temp = uint8[uint8.length - 1];
                output += encode(temp >> 2);
                output += encode(temp << 4 & 0x3F);
                output += '==';
                break;
            case 2:
                temp = (uint8[uint8.length - 2] << 8) + uint8[uint8.length - 1];
                output += encode(temp >> 10);
                output += encode(temp >> 4 & 0x3F);
                output += encode(temp << 2 & 0x3F);
                output += '=';
                break;
        }
        return output;
    }
    exports1.toByteArray = b64ToByteArray;
    exports1.fromByteArray = uint8ToBase64;
})(module.exports);

});


parcelRegister("ijE9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55926bc0f5b8b23$export$2e2bcd8739ae039);

var $gxZpm = parcelRequire("gxZpm");

var $6ZWSX = parcelRequire("6ZWSX");
var $d55926bc0f5b8b23$require$Buffer = $6ZWSX.Buffer;
class $d55926bc0f5b8b23$export$2e2bcd8739ae039 {
    static decode(path, fn) {
        throw new Error('PNG.decode not available in browser build');
    }
    static load(path) {
        throw new Error('PNG.load not available in browser build');
    }
    constructor(data){
        let i;
        this.data = data;
        this.pos = 8; // Skip the default header
        this.palette = [];
        this.imgData = [];
        this.transparency = {};
        this.text = {};
        while(true){
            const chunkSize = this.readUInt32();
            let section = '';
            for(i = 0; i < 4; i++)section += String.fromCharCode(this.data[this.pos++]);
            switch(section){
                case 'IHDR':
                    // we can grab  interesting values from here (like width, height, etc)
                    this.width = this.readUInt32();
                    this.height = this.readUInt32();
                    this.bits = this.data[this.pos++];
                    this.colorType = this.data[this.pos++];
                    this.compressionMethod = this.data[this.pos++];
                    this.filterMethod = this.data[this.pos++];
                    this.interlaceMethod = this.data[this.pos++];
                    break;
                case 'PLTE':
                    this.palette = this.read(chunkSize);
                    break;
                case 'IDAT':
                    for(i = 0; i < chunkSize; i++)this.imgData.push(this.data[this.pos++]);
                    break;
                case 'tRNS':
                    // This chunk can only occur once and it must occur after the
                    // PLTE chunk and before the IDAT chunk.
                    this.transparency = {};
                    switch(this.colorType){
                        case 3:
                            // Indexed color, RGB. Each byte in this chunk is an alpha for
                            // the palette index in the PLTE ("palette") chunk up until the
                            // last non-opaque entry. Set up an array, stretching over all
                            // palette entries which will be 0 (opaque) or 1 (transparent).
                            this.transparency.indexed = this.read(chunkSize);
                            var short = 255 - this.transparency.indexed.length;
                            if (short > 0) for(i = 0; i < short; i++)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            // Greyscale. Corresponding to entries in the PLTE chunk.
                            // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                            this.transparency.grayscale = this.read(chunkSize)[0];
                            break;
                        case 2:
                            // True color with proper alpha channel.
                            this.transparency.rgb = this.read(chunkSize);
                            break;
                    }
                    break;
                case 'tEXt':
                    var text = this.read(chunkSize);
                    var index = text.indexOf(0);
                    var key = String.fromCharCode.apply(String, text.slice(0, index));
                    this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
                    break;
                case 'IEND':
                    // we've got everything we need!
                    switch(this.colorType){
                        case 0:
                        case 3:
                        case 4:
                            this.colors = 1;
                            break;
                        case 2:
                        case 6:
                            this.colors = 3;
                            break;
                    }
                    this.hasAlphaChannel = [
                        4,
                        6
                    ].includes(this.colorType);
                    var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                    this.pixelBitlength = this.bits * colors;
                    switch(this.colors){
                        case 1:
                            this.colorSpace = 'DeviceGray';
                            break;
                        case 3:
                            this.colorSpace = 'DeviceRGB';
                            break;
                    }
                    this.imgData = $d55926bc0f5b8b23$require$Buffer.from(this.imgData);
                    return;
                default:
                    // unknown (or unimportant) section, skip it
                    this.pos += chunkSize;
            }
            this.pos += 4; // Skip the CRC
            if (this.pos > this.data.length) throw new Error('Incomplete or corrupt PNG file');
        }
    }
    read(bytes) {
        const result = new Array(bytes);
        for(let i = 0; i < bytes; i++)result[i] = this.data[this.pos++];
        return result;
    }
    readUInt32() {
        const b1 = this.data[this.pos++] << 24;
        const b2 = this.data[this.pos++] << 16;
        const b3 = this.data[this.pos++] << 8;
        const b4 = this.data[this.pos++];
        return b1 | b2 | b3 | b4;
    }
    readUInt16() {
        const b1 = this.data[this.pos++] << 8;
        const b2 = this.data[this.pos++];
        return b1 | b2;
    }
    decodePixels(fn) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gxZpm))).inflate(this.imgData, (err, data)=>{
            if (err) throw err;
            const { width: width, height: height } = this;
            const pixelBytes = this.pixelBitlength / 8;
            const pixels = $d55926bc0f5b8b23$require$Buffer.alloc(width * height * pixelBytes);
            const { length: length } = data;
            let pos = 0;
            function pass(x0, y0, dx, dy, singlePass = false) {
                const w = Math.ceil((width - x0) / dx);
                const h = Math.ceil((height - y0) / dy);
                const scanlineLength = pixelBytes * w;
                const buffer = singlePass ? pixels : $d55926bc0f5b8b23$require$Buffer.alloc(scanlineLength * h);
                let row = 0;
                let c = 0;
                while(row < h && pos < length){
                    var byte, col, i, left, upper;
                    switch(data[pos++]){
                        case 0:
                            for(i = 0; i < scanlineLength; i++)buffer[c++] = data[pos++];
                            break;
                        case 1:
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                buffer[c++] = (byte + left) % 256;
                            }
                            break;
                        case 2:
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (upper + byte) % 256;
                            }
                            break;
                        case 3:
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                            }
                            break;
                        case 4:
                            for(i = 0; i < scanlineLength; i++){
                                var paeth, upperLeft;
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                if (row === 0) upper = upperLeft = 0;
                                else {
                                    upper = buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                    upperLeft = col && buffer[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                                }
                                const p = left + upper - upperLeft;
                                const pa = Math.abs(p - left);
                                const pb = Math.abs(p - upper);
                                const pc = Math.abs(p - upperLeft);
                                if (pa <= pb && pa <= pc) paeth = left;
                                else if (pb <= pc) paeth = upper;
                                else paeth = upperLeft;
                                buffer[c++] = (byte + paeth) % 256;
                            }
                            break;
                        default:
                            throw new Error(`Invalid filter algorithm: ${data[pos - 1]}`);
                    }
                    if (!singlePass) {
                        let pixelsPos = ((y0 + row * dy) * width + x0) * pixelBytes;
                        let bufferPos = row * scanlineLength;
                        for(i = 0; i < w; i++){
                            for(let j = 0; j < pixelBytes; j++)pixels[pixelsPos++] = buffer[bufferPos++];
                            pixelsPos += (dx - 1) * pixelBytes;
                        }
                    }
                    row++;
                }
            }
            if (this.interlaceMethod === 1) {
                /*
          1 6 4 6 2 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
          3 6 4 6 3 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
        */ pass(0, 0, 8, 8); // 1
                pass(4, 0, 8, 8); // 2
                pass(0, 4, 4, 8); // 3
                pass(2, 0, 4, 4); // 4
                pass(0, 2, 2, 4); // 5
                pass(1, 0, 2, 2); // 6
                pass(0, 1, 1, 2); // 7
            } else pass(0, 0, 1, 1, true);
            return fn(pixels);
        });
    }
    decodePalette() {
        const { palette: palette } = this;
        const { length: length } = palette;
        const transparency = this.transparency.indexed || [];
        const ret = $d55926bc0f5b8b23$require$Buffer.alloc(transparency.length + length);
        let pos = 0;
        let c = 0;
        for(let i = 0; i < length; i += 3){
            var left;
            ret[pos++] = palette[i];
            ret[pos++] = palette[i + 1];
            ret[pos++] = palette[i + 2];
            ret[pos++] = (left = transparency[c++]) != null ? left : 255;
        }
        return ret;
    }
    copyToImageData(imageData, pixels) {
        let j, k;
        let { colors: colors } = this;
        let palette = null;
        let alpha = this.hasAlphaChannel;
        if (this.palette.length) {
            palette = this._decodedPalette || (this._decodedPalette = this.decodePalette());
            colors = 4;
            alpha = true;
        }
        const data = imageData.data || imageData;
        const { length: length } = data;
        const input = palette || pixels;
        let i = j = 0;
        if (colors === 1) while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            const v = input[k++];
            data[i++] = v;
            data[i++] = v;
            data[i++] = v;
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
        else while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
    }
    decode(fn) {
        const ret = $d55926bc0f5b8b23$require$Buffer.alloc(this.width * this.height * 4);
        return this.decodePixels((pixels)=>{
            this.copyToImageData(ret, pixels);
            return fn(ret);
        });
    }
}

});


parcelRegister("5C4Fs", function(module, exports) {

var $ioRHp = parcelRequire("ioRHp");
var $41641f46ef85f4d3$require$WritableStream = $ioRHp.Writable;

var $N7Lcz = parcelRequire("N7Lcz");

var $kjZ7o = parcelRequire("kjZ7o");
var $41641f46ef85f4d3$var$URL = $parcel$global.URL || $parcel$global.webkitURL || $parcel$global.mozURL;
function $41641f46ef85f4d3$var$BlobStream() {
    if (!(this instanceof $41641f46ef85f4d3$var$BlobStream)) return new $41641f46ef85f4d3$var$BlobStream;
    $41641f46ef85f4d3$require$WritableStream.call(this);
    this._chunks = [];
    this._blob = null;
    this.length = 0;
}
$N7Lcz.inherits($41641f46ef85f4d3$var$BlobStream, $41641f46ef85f4d3$require$WritableStream);
$41641f46ef85f4d3$var$BlobStream.prototype._write = function(chunk, encoding, callback) {
    // convert chunks to Uint8Arrays (e.g. Buffer when array fallback is being used)
    if (!(chunk instanceof Uint8Array)) chunk = new Uint8Array(chunk);
    this.length += chunk.length;
    this._chunks.push(chunk);
    callback();
};
$41641f46ef85f4d3$var$BlobStream.prototype.toBlob = function(type) {
    type = type || 'application/octet-stream';
    // cache the blob if needed
    if (!this._blob) {
        this._blob = new $kjZ7o(this._chunks, {
            type: type
        });
        this._chunks = []; // free memory
    }
    // if the cached blob's type doesn't match the requested type, make a new blob
    if (this._blob.type !== type) this._blob = new $kjZ7o([
        this._blob
    ], {
        type: type
    });
    return this._blob;
};
$41641f46ef85f4d3$var$BlobStream.prototype.toBlobURL = function(type) {
    return $41641f46ef85f4d3$var$URL.createObjectURL(this.toBlob(type));
};
module.exports = $41641f46ef85f4d3$var$BlobStream;

});
parcelRegister("kjZ7o", function(module, exports) {
/**
 * Create a blob builder even when vendor prefixes exist
 */ var $ecb4fdd3be6ba171$var$BlobBuilder = $parcel$global.BlobBuilder || $parcel$global.WebKitBlobBuilder || $parcel$global.MSBlobBuilder || $parcel$global.MozBlobBuilder;
/**
 * Check if Blob constructor is supported
 */ var $ecb4fdd3be6ba171$var$blobSupported = function() {
    try {
        var a = new Blob([
            'hi'
        ]);
        return a.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */ var $ecb4fdd3be6ba171$var$blobSupportsArrayBufferView = $ecb4fdd3be6ba171$var$blobSupported && function() {
    try {
        var b = new Blob([
            new Uint8Array([
                1,
                2
            ])
        ]);
        return b.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if BlobBuilder is supported
 */ var $ecb4fdd3be6ba171$var$blobBuilderSupported = $ecb4fdd3be6ba171$var$BlobBuilder && $ecb4fdd3be6ba171$var$BlobBuilder.prototype.append && $ecb4fdd3be6ba171$var$BlobBuilder.prototype.getBlob;
/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */ function $ecb4fdd3be6ba171$var$mapArrayBufferViews(ary) {
    for(var i = 0; i < ary.length; i++){
        var chunk = ary[i];
        if (chunk.buffer instanceof ArrayBuffer) {
            var buf = chunk.buffer;
            // if this is a subarray, make a copy so we only
            // include the subarray region from the underlying buffer
            if (chunk.byteLength !== buf.byteLength) {
                var copy = new Uint8Array(chunk.byteLength);
                copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
                buf = copy.buffer;
            }
            ary[i] = buf;
        }
    }
}
function $ecb4fdd3be6ba171$var$BlobBuilderConstructor(ary, options) {
    options = options || {};
    var bb = new $ecb4fdd3be6ba171$var$BlobBuilder();
    $ecb4fdd3be6ba171$var$mapArrayBufferViews(ary);
    for(var i = 0; i < ary.length; i++)bb.append(ary[i]);
    return options.type ? bb.getBlob(options.type) : bb.getBlob();
}
function $ecb4fdd3be6ba171$var$BlobConstructor(ary, options) {
    $ecb4fdd3be6ba171$var$mapArrayBufferViews(ary);
    return new Blob(ary, options || {});
}
module.exports = function() {
    if ($ecb4fdd3be6ba171$var$blobSupported) return $ecb4fdd3be6ba171$var$blobSupportsArrayBufferView ? $parcel$global.Blob : $ecb4fdd3be6ba171$var$BlobConstructor;
    else if ($ecb4fdd3be6ba171$var$blobBuilderSupported) return $ecb4fdd3be6ba171$var$BlobBuilderConstructor;
    else return undefined;
}();

});


parcelRegister("eTEAQ", function(module, exports) {
module.exports = import.meta.resolve("3cuyC");

});



parcelRegister("igJGC", function(module, exports) {

$parcel$export(module.exports, "render", () => $d4cd28f9c5c838f6$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $d4cd28f9c5c838f6$var$_hoisted_1 = {
    id: "resume"
};
const $d4cd28f9c5c838f6$var$_hoisted_2 = {
    class: "text-left"
};
const $d4cd28f9c5c838f6$var$_hoisted_3 = {
    class: "font-weight-bold"
};
const $d4cd28f9c5c838f6$var$_hoisted_4 = {
    class: "text-center"
};
const $d4cd28f9c5c838f6$var$_hoisted_5 = {
    class: "text-right"
};
const $d4cd28f9c5c838f6$var$_hoisted_6 = {
    class: "text-left font-italic"
};
const $d4cd28f9c5c838f6$var$_hoisted_7 = {
    class: "dial-anchor"
};
const $d4cd28f9c5c838f6$var$_hoisted_8 = {
    key: "download"
};
const $d4cd28f9c5c838f6$var$_hoisted_9 = {
    key: "download-passcode"
};
const $d4cd28f9c5c838f6$var$_hoisted_10 = {
    key: 0,
    class: "text-left error-message"
};
function $d4cd28f9c5c838f6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Skills = (0, $TusQn.resolveComponent)("Skills");
    const _component_v_col = (0, $TusQn.resolveComponent)("v-col");
    const _component_v_row = (0, $TusQn.resolveComponent)("v-row");
    const _component_ProfessionalExperience = (0, $TusQn.resolveComponent)("ProfessionalExperience");
    const _component_v_container = (0, $TusQn.resolveComponent)("v-container");
    const _component_v_icon = (0, $TusQn.resolveComponent)("v-icon");
    const _component_v_btn = (0, $TusQn.resolveComponent)("v-btn");
    const _component_v_tooltip = (0, $TusQn.resolveComponent)("v-tooltip");
    const _component_v_speed_dial = (0, $TusQn.resolveComponent)("v-speed-dial");
    const _component_v_card_title = (0, $TusQn.resolveComponent)("v-card-title");
    const _component_v_card_text = (0, $TusQn.resolveComponent)("v-card-text");
    const _component_v_text_field = (0, $TusQn.resolveComponent)("v-text-field");
    const _component_v_card_actions = (0, $TusQn.resolveComponent)("v-card-actions");
    const _component_v_card = (0, $TusQn.resolveComponent)("v-card");
    const _component_v_dialog = (0, $TusQn.resolveComponent)("v-dialog");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d4cd28f9c5c838f6$var$_hoisted_1, [
        _cache[18] || (_cache[18] = (0, $TusQn.createElementVNode)("h1", {
            class: "text-display-small font-weight-500 mt-0 mb-2"
        }, "Resume", -1)),
        (0, $TusQn.createVNode)(_component_v_row, null, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_v_col, null, {
                        default: (0, $TusQn.withCtx)(()=>[
                                _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("p", {
                                    class: "section sectionHeader"
                                }, "Summary of Skills", -1)),
                                (0, $TusQn.createVNode)(_component_Skills, {
                                    skills: $data.skills,
                                    layoutOptions: $options.skillsLayout
                                }, null, 8, [
                                    "skills",
                                    "layoutOptions"
                                ])
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }),
        (0, $TusQn.createVNode)(_component_v_row, null, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_v_col, null, {
                        default: (0, $TusQn.withCtx)(()=>[
                                _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("p", {
                                    class: "section sectionHeader"
                                }, "Professional Experience", -1)),
                                (0, $TusQn.createVNode)(_component_ProfessionalExperience, {
                                    experiences: $data.experiences
                                }, null, 8, [
                                    "experiences"
                                ])
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }),
        (0, $TusQn.createVNode)(_component_v_row, null, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_v_col, null, {
                        default: (0, $TusQn.withCtx)(()=>[
                                _cache[8] || (_cache[8] = (0, $TusQn.createElementVNode)("p", {
                                    class: "section sectionHeader"
                                }, "Education", -1)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.education, (item)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_container, null, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createVNode)(_component_v_row, null, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createVNode)(_component_v_col, null, {
                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                        (0, $TusQn.createElementVNode)("div", $d4cd28f9c5c838f6$var$_hoisted_2, [
                                                                            (0, $TusQn.createElementVNode)("p", $d4cd28f9c5c838f6$var$_hoisted_3, (0, $8POXm.toDisplayString)(item.establishmentName), 1)
                                                                        ])
                                                                    ]),
                                                                _: 2
                                                            }, 1024),
                                                            (0, $TusQn.createVNode)(_component_v_col, {
                                                                md: "auto"
                                                            }, {
                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                        (0, $TusQn.createElementVNode)("p", $d4cd28f9c5c838f6$var$_hoisted_4, (0, $8POXm.toDisplayString)(item.location), 1)
                                                                    ]),
                                                                _: 2
                                                            }, 1024),
                                                            (0, $TusQn.createVNode)(_component_v_col, null, {
                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                        (0, $TusQn.createElementVNode)("p", $d4cd28f9c5c838f6$var$_hoisted_5, (0, $8POXm.toDisplayString)(item.attendedDate), 1)
                                                                    ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                    _: 2
                                                }, 1024),
                                                (0, $TusQn.createVNode)(_component_v_row, null, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createVNode)(_component_v_col, null, {
                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                        (0, $TusQn.createElementVNode)("p", $d4cd28f9c5c838f6$var$_hoisted_6, (0, $8POXm.toDisplayString)(item.accomplishment), 1)
                                                                    ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                        _: 2
                                    }, 1024);
                                }), 256))
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }),
        (0, $TusQn.createElementVNode)("div", $d4cd28f9c5c838f6$var$_hoisted_7, [
            (0, $TusQn.createVNode)(_component_v_speed_dial, {
                transition: "slide-y-reverse-transition"
            }, {
                activator: (0, $TusQn.withCtx)(({ props: props })=>[
                        (0, $TusQn.createVNode)(_component_v_btn, (0, $TusQn.mergeProps)({
                            elevation: "2",
                            fab: ""
                        }, props), {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createVNode)(_component_v_icon, null, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                ..._cache[9] || (_cache[9] = [
                                                    (0, $TusQn.createTextVNode)("mdi-export", -1)
                                                ])
                                            ]),
                                        _: 1
                                    })
                                ]),
                            _: 1
                        }, 16)
                    ]),
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("span", $d4cd28f9c5c838f6$var$_hoisted_8, [
                            (0, $TusQn.createVNode)(_component_v_tooltip, {
                                location: "left",
                                "max-width": $data.tooltipWidth
                            }, {
                                activator: (0, $TusQn.withCtx)(({ props: props })=>[
                                        (0, $TusQn.createVNode)(_component_v_btn, (0, $TusQn.mergeProps)({
                                            size: "small",
                                            fab: ""
                                        }, props, {
                                            onClick: _cache[0] || (_cache[0] = ($event)=>$options.redirectToResume(false))
                                        }), {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_v_icon, null, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[10] || (_cache[10] = [
                                                                    (0, $TusQn.createTextVNode)("mdi-download", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    })
                                                ]),
                                            _: 1
                                        }, 16)
                                    ]),
                                default: (0, $TusQn.withCtx)(()=>[
                                        _cache[11] || (_cache[11] = (0, $TusQn.createElementVNode)("span", null, "Download to PDF", -1))
                                    ]),
                                _: 1
                            }, 8, [
                                "max-width"
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("span", $d4cd28f9c5c838f6$var$_hoisted_9, [
                            (0, $TusQn.createVNode)(_component_v_tooltip, {
                                location: "left",
                                "max-width": $data.tooltipWidth
                            }, {
                                activator: (0, $TusQn.withCtx)(({ props: props })=>[
                                        (0, $TusQn.createVNode)(_component_v_btn, (0, $TusQn.mergeProps)({
                                            size: "small",
                                            fab: ""
                                        }, props, {
                                            onClick: _cache[1] || (_cache[1] = (0, $eeJ70.withModifiers)(($event)=>$options.setPasscodeDialog(true), [
                                                "stop"
                                            ]))
                                        }), {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_v_icon, null, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[12] || (_cache[12] = [
                                                                    (0, $TusQn.createTextVNode)("mdi-download-lock", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    })
                                                ]),
                                            _: 1
                                        }, 16)
                                    ]),
                                default: (0, $TusQn.withCtx)(()=>[
                                        _cache[13] || (_cache[13] = (0, $TusQn.createElementVNode)("span", null, "Download to PDF with Passcode", -1))
                                    ]),
                                _: 1
                            }, 8, [
                                "max-width"
                            ])
                        ])
                    ]),
                _: 1
            })
        ]),
        (0, $TusQn.createVNode)(_component_v_dialog, {
            modelValue: $data.showPasscodeDialog,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.showPasscodeDialog = $event),
            "max-width": "300px"
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_v_card, null, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_v_card_title, null, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            ..._cache[14] || (_cache[14] = [
                                                (0, $TusQn.createElementVNode)("span", null, "Rich Download", -1)
                                            ])
                                        ]),
                                    _: 1
                                }),
                                (0, $TusQn.createVNode)(_component_v_card_text, null, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            ..._cache[15] || (_cache[15] = [
                                                (0, $TusQn.createElementVNode)("p", {
                                                    class: "text-left"
                                                }, "Downloading via this button adds additional contact information to the resume as long as you enter the correct passcode.", -1)
                                            ])
                                        ]),
                                    _: 1
                                }),
                                (0, $TusQn.createVNode)(_component_v_text_field, {
                                    class: "input-field",
                                    modelValue: $data.passcodeValue,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.passcodeValue = $event),
                                    label: "Passcode",
                                    type: "password",
                                    autofocus: ""
                                }, null, 8, [
                                    "modelValue"
                                ]),
                                (0, $TusQn.createVNode)(_component_v_card_text, null, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            $data.passcodeErrorMessage != '' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $d4cd28f9c5c838f6$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.passcodeErrorMessage), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                        ]),
                                    _: 1
                                }),
                                (0, $TusQn.createVNode)(_component_v_card_actions, null, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createVNode)(_component_v_btn, {
                                                variant: "text",
                                                onClick: _cache[3] || (_cache[3] = (0, $eeJ70.withModifiers)(($event)=>$options.setPasscodeDialog(false), [
                                                    "stop"
                                                ]))
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        ..._cache[16] || (_cache[16] = [
                                                            (0, $TusQn.createTextVNode)("Cancel", -1)
                                                        ])
                                                    ]),
                                                _: 1
                                            }),
                                            (0, $TusQn.createVNode)(_component_v_btn, {
                                                variant: "text",
                                                onClick: _cache[4] || (_cache[4] = (0, $eeJ70.withModifiers)(($event)=>$options.redirectToResume(true), [
                                                    "stop"
                                                ]))
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        ..._cache[17] || (_cache[17] = [
                                                            (0, $TusQn.createTextVNode)("Download", -1)
                                                        ])
                                                    ]),
                                                _: 1
                                            })
                                        ]),
                                    _: 1
                                })
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }, 8, [
            "modelValue"
        ])
    ]);
}

});

parcelRegister("f9gbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0744159e05d32f4$export$2e2bcd8739ae039);
let $b0744159e05d32f4$var$NOOP = ()=>{};
var $b0744159e05d32f4$export$2e2bcd8739ae039 = (script)=>{};

});

"use strict";
globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;


parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");
var $a0b080bdc0c7df32$exports = {};

/*!
* Vuetify v4.1.11
* Forged by John Leider
* Released under the MIT License.
*/ (function(global, factory) {
    factory($a0b080bdc0c7df32$exports, (parcelRequire("ecd4d")));
})($a0b080bdc0c7df32$exports, function(exports1, vue) {
    'use strict';
    /* eslint-disable no-console */ function consoleWarn(message) {
        vue.warn(`Vuetify: ${message}`);
    }
    function consoleError(message) {
        vue.warn(`Vuetify error: ${message}`);
    }
    function deprecate(original, replacement) {
        replacement = Array.isArray(replacement) ? replacement.slice(0, -1).map((s)=>`'${s}'`).join(', ') + ` or '${replacement.at(-1)}'` : `'${replacement}'`;
        vue.warn(`[Vuetify UPGRADE] '${original}' is deprecated, use ${replacement} instead.`);
    }
    const IN_BROWSER = typeof window !== 'undefined';
    const SUPPORTS_INTERSECTION = IN_BROWSER && 'IntersectionObserver' in window;
    const SUPPORTS_TOUCH = IN_BROWSER && ('ontouchstart' in window || window.navigator.maxTouchPoints > 0);
    const SUPPORTS_EYE_DROPPER = IN_BROWSER && 'EyeDropper' in window;
    const SUPPORTS_MATCH_MEDIA = IN_BROWSER && 'matchMedia' in window && typeof window.matchMedia === 'function';
    const PREFERS_REDUCED_MOTION = ()=>SUPPORTS_MATCH_MEDIA && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const IS_WEBKIT = IN_BROWSER && CSS?.supports?.('-webkit-backdrop-filter', 'none');
    // Utilities
    // Types
    function getNestedValue(obj, path, fallback) {
        const last = path.length - 1;
        if (last < 0) return obj === undefined ? fallback : obj;
        for(let i = 0; i < last; i++){
            if (obj == null) return fallback;
            obj = obj[path[i]];
        }
        if (obj == null) return fallback;
        return obj[path[last]] === undefined ? fallback : obj[path[last]];
    }
    function getObjectValueByPath(obj, path, fallback) {
        // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
        if (obj == null || !path || typeof path !== 'string') return fallback;
        if (obj[path] !== undefined) return obj[path];
        path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        path = path.replace(/^\./, ''); // strip a leading dot
        return getNestedValue(obj, path.split('.'), fallback);
    }
    function getPropertyFromItem(item, property, fallback) {
        if (property === true) return item === undefined ? fallback : item;
        if (property == null || typeof property === 'boolean') return fallback;
        if (item !== Object(item)) {
            if (typeof property !== 'function') return fallback;
            const value = property(item, fallback);
            return typeof value === 'undefined' ? fallback : value;
        }
        if (typeof property === 'string') return getObjectValueByPath(item, property, fallback);
        if (Array.isArray(property)) return getNestedValue(item, property, fallback);
        if (typeof property !== 'function') return fallback;
        const value = property(item, fallback);
        return typeof value === 'undefined' ? fallback : value;
    }
    function createRange(length, start = 0) {
        return Array.from({
            length: length
        }, (v, k)=>start + k);
    }
    function convertToUnit(str, unit = 'px') {
        if (str == null || str === '') return undefined;
        const num = Number(str);
        if (isNaN(num)) return String(str);
        else if (!isFinite(num)) return undefined;
        else return `${num}${unit}`;
    }
    function isObject(obj) {
        return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
    }
    function isPlainObject(obj) {
        let proto;
        return obj !== null && typeof obj === 'object' && ((proto = Object.getPrototypeOf(obj)) === Object.prototype || proto === null);
    }
    function refElement(obj) {
        if (obj && '$el' in obj) {
            const el = obj.$el;
            if (el?.nodeType === Node.TEXT_NODE) // Multi-root component, use the first element
            return el.nextElementSibling;
            return el;
        }
        return obj;
    }
    const keyValues = Object.freeze({
        enter: 'Enter',
        tab: 'Tab',
        delete: 'Delete',
        esc: 'Escape',
        space: 'Space',
        up: 'ArrowUp',
        down: 'ArrowDown',
        left: 'ArrowLeft',
        right: 'ArrowRight',
        end: 'End',
        home: 'Home',
        del: 'Delete',
        backspace: 'Backspace',
        insert: 'Insert',
        pageup: 'PageUp',
        pagedown: 'PageDown',
        shift: 'Shift'
    });
    function keys(o) {
        return Object.keys(o);
    }
    function has(obj, key) {
        return key.every((k)=>obj.hasOwnProperty(k));
    }
    // Array of keys
    function pick(obj, paths) {
        const found = {};
        for (const key of paths)if (Object.prototype.hasOwnProperty.call(obj, key)) found[key] = obj[key];
        return found;
    }
    // Array of keys
    // Array of keys or RegExp to test keys against
    function pickWithRest(obj, paths, exclude) {
        const found = Object.create(null);
        const rest = Object.create(null);
        for(const key in obj)if (paths.some((path)=>path instanceof RegExp ? path.test(key) : path === key) && true) found[key] = obj[key];
        else rest[key] = obj[key];
        return [
            found,
            rest
        ];
    }
    function omit(obj, exclude) {
        const clone = {
            ...obj
        };
        exclude.forEach((prop)=>delete clone[prop]);
        return clone;
    }
    const onRE = /^on[^a-z]/;
    const isOn = (key)=>onRE.test(key);
    const bubblingEvents = [
        'onAfterscriptexecute',
        'onAnimationcancel',
        'onAnimationend',
        'onAnimationiteration',
        'onAnimationstart',
        'onAuxclick',
        'onBeforeinput',
        'onBeforescriptexecute',
        'onChange',
        'onClick',
        'onCompositionend',
        'onCompositionstart',
        'onCompositionupdate',
        'onContextmenu',
        'onCopy',
        'onCut',
        'onDblclick',
        'onFocusin',
        'onFocusout',
        'onFullscreenchange',
        'onFullscreenerror',
        'onGesturechange',
        'onGestureend',
        'onGesturestart',
        'onGotpointercapture',
        'onInput',
        'onKeydown',
        'onKeypress',
        'onKeyup',
        'onLostpointercapture',
        'onMousedown',
        'onMousemove',
        'onMouseout',
        'onMouseover',
        'onMouseup',
        'onMousewheel',
        'onPaste',
        'onPointercancel',
        'onPointerdown',
        'onPointerenter',
        'onPointerleave',
        'onPointermove',
        'onPointerout',
        'onPointerover',
        'onPointerup',
        'onReset',
        'onSelect',
        'onSubmit',
        'onTouchcancel',
        'onTouchend',
        'onTouchmove',
        'onTouchstart',
        'onTransitioncancel',
        'onTransitionend',
        'onTransitionrun',
        'onTransitionstart',
        'onWheel'
    ];
    const compositionIgnoreKeys = [
        'ArrowUp',
        'ArrowDown',
        'ArrowRight',
        'ArrowLeft',
        'Enter',
        'Escape',
        'Tab',
        ' '
    ];
    function isComposingIgnoreKey(e) {
        return e.isComposing && compositionIgnoreKeys.includes(e.key);
    }
    /**
   * Filter attributes that should be applied to
   * the root element of an input component. Remaining
   * attributes should be passed to the <input> element inside.
   */ function filterInputAttrs(attrs) {
        const [events, props] = pickWithRest(attrs, [
            onRE
        ]);
        const inputEvents = omit(events, bubblingEvents);
        const [rootAttrs, inputAttrs] = pickWithRest(props, [
            'class',
            'style',
            'id',
            'inert',
            /^data-/
        ]);
        Object.assign(rootAttrs, events);
        Object.assign(inputAttrs, inputEvents);
        return [
            rootAttrs,
            inputAttrs
        ];
    }
    function wrapInArray(v) {
        return v == null ? [] : Array.isArray(v) ? v : [
            v
        ];
    }
    function debounce(fn, delay) {
        let timeoutId = 0;
        const wrap = (...args)=>{
            clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>fn(...args), vue.unref(delay));
        };
        wrap.clear = ()=>{
            clearTimeout(timeoutId);
        };
        wrap.immediate = fn;
        return wrap;
    }
    function clamp(value, min = 0, max = 1) {
        return Math.max(min, Math.min(max, value));
    }
    function getDecimals(value) {
        const trimmedStr = value.toString().trim();
        return trimmedStr.includes('.') ? trimmedStr.length - trimmedStr.indexOf('.') - 1 : 0;
    }
    function padEnd(str, length, char = '0') {
        return str + char.repeat(Math.max(0, length - str.length));
    }
    function padStart(str, length, char = '0') {
        return char.repeat(Math.max(0, length - str.length)) + str;
    }
    function chunk(str, size = 1) {
        const chunked = [];
        let index = 0;
        while(index < str.length){
            chunked.push(str.substr(index, size));
            index += size;
        }
        return chunked;
    }
    function chunkArray(array, size = 1) {
        return Array.from({
            length: Math.ceil(array.length / size)
        }, (v, i)=>array.slice(i * size, i * size + size));
    }
    function humanReadableFileSize(bytes, base = 1000) {
        if (bytes < base) return `${bytes} B`;
        const prefix = base === 1024 ? [
            'Ki',
            'Mi',
            'Gi'
        ] : [
            'k',
            'M',
            'G'
        ];
        let unit = -1;
        while(Math.abs(bytes) >= base && unit < prefix.length - 1){
            bytes /= base;
            ++unit;
        }
        return `${bytes.toFixed(1)} ${prefix[unit]}B`;
    }
    function mergeDeep(source = {}, target = {}, arrayFn, targetCondition) {
        const out = {};
        for(const key in source)out[key] = source[key];
        for(const key in target){
            const targetProperty = target[key];
            if (targetCondition && !targetCondition(key, targetProperty)) continue;
            const sourceProperty = source[key];
            // Only continue deep merging if
            // both properties are plain objects
            if (isPlainObject(sourceProperty) && isPlainObject(targetProperty)) {
                out[key] = mergeDeep(sourceProperty, targetProperty, arrayFn, targetCondition);
                continue;
            }
            out[key] = targetProperty;
        }
        return out;
    }
    function flattenFragments(nodes) {
        return nodes.map((node)=>{
            if (node.type === vue.Fragment) return flattenFragments(node.children);
            else return node;
        }).flat();
    }
    function toKebabCase(str = '') {
        if (toKebabCase.cache.has(str)) return toKebabCase.cache.get(str);
        const kebab = str.replace(/[^a-z]/gi, '-').replace(/\B([A-Z])/g, '-$1').toLowerCase();
        toKebabCase.cache.set(str, kebab);
        return kebab;
    }
    toKebabCase.cache = new Map();
    function findChildrenWithProvide(key, vnode) {
        if (!vnode || typeof vnode !== 'object') return [];
        if (Array.isArray(vnode)) return vnode.map((child)=>findChildrenWithProvide(key, child)).flat(1);
        else if (vnode.suspense) return findChildrenWithProvide(key, vnode.ssContent);
        else if (Array.isArray(vnode.children)) return vnode.children.map((child)=>findChildrenWithProvide(key, child)).flat(1);
        else if (vnode.component) {
            if (Object.getOwnPropertyDescriptor(vnode.component.provides, key)) return [
                vnode.component
            ];
            else if (vnode.component.subTree) return findChildrenWithProvide(key, vnode.component.subTree).flat(1);
        }
        return [];
    }
    class CircularBuffer {
        #arr = [];
        #pointer = 0;
        constructor(size){
            this.size = size;
        }
        get isFull() {
            return this.#arr.length === this.size;
        }
        push(val) {
            this.#arr[this.#pointer] = val;
            this.#pointer = (this.#pointer + 1) % this.size;
        }
        values() {
            return this.#arr.slice(this.#pointer).concat(this.#arr.slice(0, this.#pointer));
        }
        clear() {
            this.#arr.length = 0;
            this.#pointer = 0;
        }
    }
    function getEventCoordinates(e) {
        if ('touches' in e) return {
            clientX: e.touches[0].clientX,
            clientY: e.touches[0].clientY
        };
        return {
            clientX: e.clientX,
            clientY: e.clientY
        };
    }
    // Only allow a single return type
    /**
   * Convert a computed ref to a record of refs.
   * The getter function must always return an object with the same keys.
   */ function destructComputed(getter) {
        const refs = vue.reactive({});
        vue.watchEffect(()=>{
            const base = getter();
            for(const key in base)refs[key] = base[key];
        }, {
            flush: 'sync'
        });
        const obj = {};
        for(const key in refs)obj[key] = vue.toRef(()=>refs[key]);
        return obj;
    }
    /** Array.includes but value can be any type */ function includes(arr, val) {
        return arr.includes(val);
    }
    function eventName(propName) {
        return propName[2].toLowerCase() + propName.slice(3);
    }
    // TODO: this should be an array but vue's types don't accept arrays: vuejs/core#8025
    const EventProp = ()=>[
            Function,
            Array
        ];
    function hasEvent(props, name) {
        name = 'on' + vue.capitalize(name);
        return !!(props[name] || props[`${name}Once`] || props[`${name}Capture`] || props[`${name}OnceCapture`] || props[`${name}CaptureOnce`]);
    }
    function callEvent(handler, ...args) {
        if (Array.isArray(handler)) for (const h of handler)h(...args);
        else if (typeof handler === 'function') handler(...args);
    }
    function focusableChildren(el, filterByTabIndex = true) {
        const targets = [
            'button',
            '[href]',
            'input:not([type="hidden"])',
            'select',
            'textarea',
            'details:not(:has(> summary))',
            'details > summary',
            '[tabindex]',
            '[contenteditable]:not([contenteditable="false"])',
            'audio[controls]',
            'video[controls]'
        ].map((s)=>`${s}${filterByTabIndex ? ':not([tabindex="-1"])' : ''}:not([disabled], [inert])`).join(', ');
        let elements;
        try {
            elements = [
                ...el.querySelectorAll(targets)
            ];
        } catch (err) {
            consoleError(String(err));
            return [];
        }
        return elements.filter((x)=>!x.closest('[inert]')) // does not have inert parent
        .filter((x)=>!!x.offsetParent || x.getClientRects().length > 0) // is rendered
        .filter((x)=>!x.parentElement?.closest('details:not([open])') || x.tagName === 'SUMMARY' && x.parentElement?.tagName === 'DETAILS');
    }
    function getActiveElement() {
        let active = document.activeElement;
        while(active?.shadowRoot?.activeElement)active = active.shadowRoot.activeElement;
        return active;
    }
    function getNextElement(elements, location, condition) {
        let _el;
        let idx = elements.indexOf(getActiveElement());
        if (idx < 0) idx = elements.findIndex((el)=>el.getAttribute('aria-selected') === 'true');
        const inc = location === 'next' ? 1 : -1;
        do {
            idx += inc;
            _el = elements[idx];
        }while ((!_el || _el.offsetParent == null || !(condition?.(_el) ?? true)) && idx < elements.length && idx >= 0);
        return _el;
    }
    function focusChild(el, location, options) {
        const focusable = focusableChildren(el);
        if (location == null) {
            const active = getActiveElement();
            if (el === active || !el.contains(active)) focusable[0]?.focus(options);
        } else if (location === 'first') focusable[0]?.focus(options);
        else if (location === 'last') focusable.at(-1)?.focus(options);
        else if (typeof location === 'number') focusable[location]?.focus(options);
        else {
            const _el = getNextElement(focusable, location);
            if (_el) _el.focus();
            else focusChild(el, location === 'next' ? 'first' : 'last', options);
        }
    }
    function isEmpty(val) {
        return val === null || val === undefined || typeof val === 'string' && val.trim() === '';
    }
    function noop() {}
    /** Returns null if the selector is not supported or we can't check */ function matchesSelector(el, selector) {
        const supportsSelector = IN_BROWSER && typeof CSS !== 'undefined' && typeof CSS.supports !== 'undefined' && CSS.supports(`selector(${selector})`);
        if (!supportsSelector) return null;
        try {
            return !!el && el.matches(selector);
        } catch (err) {
            return null;
        }
    }
    function ensureValidVNode(vnodes) {
        return vnodes.some((child)=>{
            if (!vue.isVNode(child)) return true;
            if (child.type === vue.Comment) return false;
            return child.type !== vue.Fragment || ensureValidVNode(child.children);
        }) ? vnodes : null;
    }
    function renderSlot(slot, props, fallback) {
        // TODO: check if slot returns elements: #18308
        return slot?.(props) ?? fallback?.(props);
    }
    function defer(timeout, cb) {
        if (!IN_BROWSER || timeout === 0) {
            cb();
            return ()=>{};
        }
        const timeoutId = window.setTimeout(cb, timeout);
        return ()=>window.clearTimeout(timeoutId);
    }
    function templateRef() {
        const el = vue.shallowRef();
        const fn = (target)=>{
            el.value = target;
        };
        Object.defineProperty(fn, 'value', {
            enumerable: true,
            get: ()=>el.value,
            set: (val)=>el.value = val
        });
        Object.defineProperty(fn, 'el', {
            enumerable: true,
            get: ()=>refElement(el.value)
        });
        return fn;
    }
    function checkPrintable(e) {
        const isPrintableChar = e.key.length === 1;
        const noModifier = !e.ctrlKey && !e.metaKey && !e.altKey;
        return isPrintableChar && noModifier;
    }
    function isPrimitive(value) {
        return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint';
    }
    function escapeForRegex(sign) {
        return '\\^$*+?.()|{}[]'.includes(sign) ? `\\${sign}` : sign;
    }
    function normalizeMinusSign(text) {
        return text.replace(/−/g, '-');
    }
    function extractNumber(text, decimalDigitsLimit, decimalSeparator) {
        const onlyValidCharacters = new RegExp(`[\\d\\-${escapeForRegex(decimalSeparator)}]`);
        const cleanText = normalizeMinusSign(text).split('').filter((x)=>onlyValidCharacters.test(x)).filter((x, i, all)=>i === 0 && /[-]/.test(x) || // sign allowed at the start
            x === decimalSeparator && i === all.indexOf(x) || // decimal separator allowed only once
            /\d/.test(x)).join('');
        if (decimalDigitsLimit === 0) return cleanText.split(decimalSeparator)[0];
        const decimalPart = new RegExp(`${escapeForRegex(decimalSeparator)}\\d`);
        if (decimalDigitsLimit !== null && decimalPart.test(cleanText)) {
            const parts = cleanText.split(decimalSeparator);
            return [
                parts[0],
                parts[1].substring(0, decimalDigitsLimit)
            ].join(decimalSeparator);
        }
        return cleanText;
    }
    function camelizeProps(props) {
        const out = {};
        for(const prop in props)out[vue.camelize(prop)] = props[prop];
        return out;
    }
    function onlyDefinedProps(props) {
        const booleanAttributes = [
            'checked',
            'disabled'
        ];
        return Object.fromEntries(Object.entries(props).filter(([key, v])=>booleanAttributes.includes(key) ? !!v : v !== undefined));
    }
    function deepToRaw(value) {
        const objectIterator = (input)=>{
            if (Array.isArray(input)) return input.map((item)=>objectIterator(item));
            if (vue.isRef(input) || vue.isReactive(input) || vue.isProxy(input)) return objectIterator(vue.toRaw(input));
            if (isPlainObject(input)) return Object.keys(input).reduce((acc, key)=>{
                acc[key] = objectIterator(input[key]);
                return acc;
            }, {});
            return input;
        };
        return objectIterator(value);
    }
    // Utilities
    const block = [
        'top',
        'bottom'
    ];
    const inline = [
        'start',
        'end',
        'left',
        'right'
    ];
    /** Parse a raw anchor string into an object */ function parseAnchor(anchor, isRtl) {
        let [side, align] = anchor.split(' ');
        if (!align) align = includes(block, side) ? 'start' : includes(inline, side) ? 'top' : 'center';
        return {
            side: toPhysical(side, isRtl),
            align: toPhysical(align, isRtl)
        };
    }
    function toPhysical(str, isRtl) {
        if (str === 'start') return isRtl ? 'right' : 'left';
        if (str === 'end') return isRtl ? 'left' : 'right';
        return str;
    }
    function flipSide(anchor) {
        return {
            side: ({
                center: 'center',
                top: 'bottom',
                bottom: 'top',
                left: 'right',
                right: 'left'
            })[anchor.side],
            align: anchor.align
        };
    }
    function flipAlign(anchor) {
        return {
            side: anchor.side,
            align: ({
                center: 'center',
                top: 'bottom',
                bottom: 'top',
                left: 'right',
                right: 'left'
            })[anchor.align]
        };
    }
    function flipCorner(anchor) {
        return {
            side: anchor.align,
            align: anchor.side
        };
    }
    function getAxis(anchor) {
        return includes(block, anchor.side) ? 'y' : 'x';
    }
    class Box {
        constructor(args){
            const pageScale = document.body.currentCSSZoom ?? 1;
            const isElement = args instanceof Element;
            const factor = isElement ? 1 + (1 - pageScale) / pageScale : 1;
            const { x: x, y: y, width: width, height: height } = isElement ? args.getBoundingClientRect() : args;
            this.x = x * factor;
            this.y = y * factor;
            this.width = width * factor;
            this.height = height * factor;
        }
        get top() {
            return this.y;
        }
        get bottom() {
            return this.y + this.height;
        }
        get left() {
            return this.x;
        }
        get right() {
            return this.x + this.width;
        }
    }
    function getOverflow(a, b) {
        return {
            x: {
                before: Math.max(0, b.left - a.left),
                after: Math.max(0, a.right - b.right)
            },
            y: {
                before: Math.max(0, b.top - a.top),
                after: Math.max(0, a.bottom - b.bottom)
            }
        };
    }
    function getTargetBox(target) {
        if (Array.isArray(target)) {
            const pageScale = document.body.currentCSSZoom ?? 1;
            const factor = 1 + (1 - pageScale) / pageScale;
            return new Box({
                x: target[0] * factor,
                y: target[1] * factor,
                width: 0 * factor,
                height: 0 * factor
            });
        } else return new Box(target);
    }
    function getElementBox(el) {
        if (el === document.documentElement) {
            if (!visualViewport) return new Box({
                x: 0,
                y: 0,
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            });
            else return new Box({
                x: visualViewport.scale > 1 || IS_WEBKIT ? 0 : visualViewport.offsetLeft,
                y: visualViewport.scale > 1 || IS_WEBKIT ? 0 : visualViewport.offsetTop,
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            });
        } else return new Box(el);
    }
    // Utilities
    /** @see https://stackoverflow.com/a/57876601/2074736 */ function nullifyTransforms(el) {
        const rect = new Box(el);
        const style = getComputedStyle(el);
        const tx = style.transform;
        if (tx) {
            let ta, sx, sy, dx, dy;
            if (tx.startsWith('matrix3d(')) {
                ta = tx.slice(9, -1).split(/, /);
                sx = Number(ta[0]);
                sy = Number(ta[5]);
                dx = Number(ta[12]);
                dy = Number(ta[13]);
            } else if (tx.startsWith('matrix(')) {
                ta = tx.slice(7, -1).split(/, /);
                sx = Number(ta[0]);
                sy = Number(ta[3]);
                dx = Number(ta[4]);
                dy = Number(ta[5]);
            } else return new Box(rect);
            const to = style.transformOrigin;
            const x = rect.x - dx - (1 - sx) * parseFloat(to);
            const y = rect.y - dy - (1 - sy) * parseFloat(to.slice(to.indexOf(' ') + 1));
            const w = sx ? rect.width / sx : el.offsetWidth + 1;
            const h = sy ? rect.height / sy : el.offsetHeight + 1;
            return new Box({
                x: x,
                y: y,
                width: w,
                height: h
            });
        } else return new Box(rect);
    }
    function animate(el, keyframes, options) {
        if (typeof el.animate === 'undefined') return {
            finished: Promise.resolve()
        };
        let animation;
        try {
            animation = el.animate(keyframes, options);
        } catch (err) {
            return {
                finished: Promise.resolve()
            };
        }
        if (typeof animation.finished === 'undefined') animation.finished = new Promise((resolve)=>{
            animation.onfinish = ()=>{
                resolve(animation);
            };
        });
        return animation;
    }
    // Utilities
    const handlers = new WeakMap();
    function bindProps(el, props) {
        Object.keys(props).forEach((k)=>{
            if (isOn(k)) {
                const name = eventName(k);
                const handler = handlers.get(el);
                if (props[k] == null) handler?.forEach((v)=>{
                    const [n, fn] = v;
                    if (n === name) {
                        el.removeEventListener(name, fn);
                        handler.delete(v);
                    }
                });
                else if (!handler || ![
                    ...handler
                ]?.some((v)=>v[0] === name && v[1] === props[k])) {
                    el.addEventListener(name, props[k]);
                    const _handler = handler || new Set();
                    _handler.add([
                        name,
                        props[k]
                    ]);
                    if (!handlers.has(el)) handlers.set(el, _handler);
                }
            } else if (props[k] == null) el.removeAttribute(k);
            else el.setAttribute(k, props[k]);
        });
    }
    function unbindProps(el, props) {
        Object.keys(props).forEach((k)=>{
            if (isOn(k)) {
                const name = eventName(k);
                const handler = handlers.get(el);
                handler?.forEach((v)=>{
                    const [n, fn] = v;
                    if (n === name) {
                        el.removeEventListener(name, fn);
                        handler.delete(v);
                    }
                });
            } else el.removeAttribute(k);
        });
    }
    /**
   * WCAG 3.0 APCA perceptual contrast algorithm from https://github.com/Myndex/SAPC-APCA
   * @licence https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
   * @see https://www.w3.org/WAI/GL/task-forces/silver/wiki/Visual_Contrast_of_Text_Subgroup
   */ // Types
    // MAGICAL NUMBERS
    // sRGB Conversion to Relative Luminance (Y)
    // Transfer Curve (aka "Gamma") for sRGB linearization
    // Simple power curve vs piecewise described in docs
    // Essentially, 2.4 best models actual display
    // characteristics in combination with the total method
    const mainTRC = 2.4;
    const Rco = 0.2126729; // sRGB Red Coefficient (from matrix)
    const Gco = 0.7151522; // sRGB Green Coefficient (from matrix)
    const Bco = 0.0721750; // sRGB Blue Coefficient (from matrix)
    // For Finding Raw SAPC Contrast from Relative Luminance (Y)
    // Constants for SAPC Power Curve Exponents
    // One pair for normal text, and one for reverse
    // These are the "beating heart" of SAPC
    const normBG = 0.55;
    const normTXT = 0.58;
    const revTXT = 0.57;
    const revBG = 0.62;
    // For Clamping and Scaling Values
    const blkThrs = 0.03; // Level that triggers the soft black clamp
    const blkClmp = 1.45; // Exponent for the soft black clamp curve
    const deltaYmin = 0.0005; // Lint trap
    const scaleBoW = 1.25; // Scaling for dark text on light
    const scaleWoB = 1.25; // Scaling for light text on dark
    const loConThresh = 0.078; // Threshold for new simple offset scale
    const loConFactor = 12.82051282051282; // = 1/0.078,
    const loConOffset = 0.06; // The simple offset
    const loClip = 0.001; // Output clip (lint trap #2)
    function APCAcontrast(text, background) {
        // Linearize sRGB
        const Rtxt = (text.r / 255) ** mainTRC;
        const Gtxt = (text.g / 255) ** mainTRC;
        const Btxt = (text.b / 255) ** mainTRC;
        const Rbg = (background.r / 255) ** mainTRC;
        const Gbg = (background.g / 255) ** mainTRC;
        const Bbg = (background.b / 255) ** mainTRC;
        // Apply the standard coefficients and sum to Y
        let Ytxt = Rtxt * Rco + Gtxt * Gco + Btxt * Bco;
        let Ybg = Rbg * Rco + Gbg * Gco + Bbg * Bco;
        // Soft clamp Y when near black.
        // Now clamping all colors to prevent crossover errors
        if (Ytxt <= blkThrs) Ytxt += (blkThrs - Ytxt) ** blkClmp;
        if (Ybg <= blkThrs) Ybg += (blkThrs - Ybg) ** blkClmp;
        // Return 0 Early for extremely low ∆Y (lint trap #1)
        if (Math.abs(Ybg - Ytxt) < deltaYmin) return 0.0;
        // SAPC CONTRAST
        let outputContrast; // For weighted final values
        if (Ybg > Ytxt) {
            // For normal polarity, black text on white
            // Calculate the SAPC contrast value and scale
            const SAPC = (Ybg ** normBG - Ytxt ** normTXT) * scaleBoW;
            // NEW! SAPC SmoothScale™
            // Low Contrast Smooth Scale Rollout to prevent polarity reversal
            // and also a low clip for very low contrasts (lint trap #2)
            // much of this is for very low contrasts, less than 10
            // therefore for most reversing needs, only loConOffset is important
            outputContrast = SAPC < loClip ? 0.0 : SAPC < loConThresh ? SAPC - SAPC * loConFactor * loConOffset : SAPC - loConOffset;
        } else {
            // For reverse polarity, light text on dark
            // WoB should always return negative value.
            const SAPC = (Ybg ** revBG - Ytxt ** revTXT) * scaleWoB;
            outputContrast = SAPC > -loClip ? 0.0 : SAPC > -loConThresh ? SAPC - SAPC * loConFactor * loConOffset : SAPC + loConOffset;
        }
        return outputContrast * 100;
    }
    // Types
    const delta = 0.20689655172413793; // 6÷29
    const cielabForwardTransform = (t)=>t > delta ** 3 ? Math.cbrt(t) : t / (3 * delta ** 2) + 4 / 29;
    const cielabReverseTransform = (t)=>t > delta ? t ** 3 : 3 * delta ** 2 * (t - 4 / 29);
    function fromXYZ$1(xyz) {
        const transform = cielabForwardTransform;
        const transformedY = transform(xyz[1]);
        return [
            116 * transformedY - 16,
            500 * (transform(xyz[0] / 0.95047) - transformedY),
            200 * (transformedY - transform(xyz[2] / 1.08883))
        ];
    }
    function toXYZ$1(lab) {
        const transform = cielabReverseTransform;
        const Ln = (lab[0] + 16) / 116;
        return [
            transform(Ln + lab[1] / 500) * 0.95047,
            transform(Ln),
            transform(Ln - lab[2] / 200) * 1.08883
        ];
    }
    // Utilities
    // Types
    // For converting XYZ to sRGB
    const srgbForwardMatrix = [
        [
            3.2406,
            -1.5372,
            -0.4986
        ],
        [
            -0.9689,
            1.8758,
            0.0415
        ],
        [
            0.0557,
            -0.204,
            1.0570
        ]
    ];
    // Forward gamma adjust
    const srgbForwardTransform = (C)=>C <= 0.0031308 ? C * 12.92 : 1.055 * C ** (1 / 2.4) - 0.055;
    // For converting sRGB to XYZ
    const srgbReverseMatrix = [
        [
            0.4124,
            0.3576,
            0.1805
        ],
        [
            0.2126,
            0.7152,
            0.0722
        ],
        [
            0.0193,
            0.1192,
            0.9505
        ]
    ];
    // Reverse gamma adjust
    const srgbReverseTransform = (C)=>C <= 0.04045 ? C / 12.92 : ((C + 0.055) / 1.055) ** 2.4;
    function fromXYZ(xyz) {
        const rgb = Array(3);
        const transform = srgbForwardTransform;
        const matrix = srgbForwardMatrix;
        // Matrix transform, then gamma adjustment
        for(let i = 0; i < 3; ++i)// Rescale back to [0, 255]
        rgb[i] = Math.round(clamp(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
        return {
            r: rgb[0],
            g: rgb[1],
            b: rgb[2]
        };
    }
    function toXYZ({ r: r, g: g, b: b }) {
        const xyz = [
            0,
            0,
            0
        ];
        const transform = srgbReverseTransform;
        const matrix = srgbReverseMatrix;
        // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
        r = transform(r / 255);
        g = transform(g / 255);
        b = transform(b / 255);
        // Matrix color space transform
        for(let i = 0; i < 3; ++i)xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
        return xyz;
    }
    // Utilities
    // Types
    function isCssColor(color) {
        return !!color && /^(#|var\(--|(rgb|hsl)a?\()/.test(color);
    }
    function isParsableColor(color) {
        return isCssColor(color) && !/^((rgb|hsl)a?\()?var\(--/.test(color);
    }
    const cssColorRe = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/;
    const mappers = {
        rgb: (r, g, b, a)=>({
                r: r,
                g: g,
                b: b,
                a: a
            }),
        rgba: (r, g, b, a)=>({
                r: r,
                g: g,
                b: b,
                a: a
            }),
        hsl: (h, s, l, a)=>HSLtoRGB({
                h: h,
                s: s,
                l: l,
                a: a
            }),
        hsla: (h, s, l, a)=>HSLtoRGB({
                h: h,
                s: s,
                l: l,
                a: a
            }),
        hsv: (h, s, v, a)=>HSVtoRGB({
                h: h,
                s: s,
                v: v,
                a: a
            }),
        hsva: (h, s, v, a)=>HSVtoRGB({
                h: h,
                s: s,
                v: v,
                a: a
            })
    };
    function parseColor(color) {
        if (typeof color === 'number') {
            if (isNaN(color) || color < 0 || color > 0xFFFFFF) // int can't have opacity
            consoleWarn(`'${color}' is not a valid hex color`);
            return {
                r: (color & 0xFF0000) >> 16,
                g: (color & 0xFF00) >> 8,
                b: color & 0xFF
            };
        } else if (typeof color === 'string' && cssColorRe.test(color)) {
            const { groups: groups } = color.match(cssColorRe);
            const { fn: fn, values: values } = groups;
            const realValues = values.split(/,\s*|\s*\/\s*|\s+/).map((v, i)=>{
                if (v.endsWith('%') || // unitless slv are %
                i > 0 && i < 3 && [
                    'hsl',
                    'hsla',
                    'hsv',
                    'hsva'
                ].includes(fn)) return parseFloat(v) / 100;
                else return parseFloat(v);
            });
            return mappers[fn](...realValues);
        } else if (typeof color === 'string') {
            let hex = color.startsWith('#') ? color.slice(1) : color;
            if ([
                3,
                4
            ].includes(hex.length)) hex = hex.split('').map((char)=>char + char).join('');
            else if (![
                6,
                8
            ].includes(hex.length)) consoleWarn(`'${color}' is not a valid hex(a) color`);
            const int = parseInt(hex, 16);
            if (isNaN(int) || int < 0 || int > 0xFFFFFFFF) consoleWarn(`'${color}' is not a valid hex(a) color`);
            return HexToRGB(hex);
        } else if (typeof color === 'object') {
            if (has(color, [
                'r',
                'g',
                'b'
            ])) return color;
            else if (has(color, [
                'h',
                's',
                'l'
            ])) return HSVtoRGB(HSLtoHSV(color));
            else if (has(color, [
                'h',
                's',
                'v'
            ])) return HSVtoRGB(color);
        }
        throw new TypeError(`Invalid color: ${color == null ? color : String(color) || color.constructor.name}\nExpected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
    }
    /** Converts HSVA to RGBA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV */ function HSVtoRGB(hsva) {
        const { h: h, s: s, v: v, a: a } = hsva;
        const f = (n)=>{
            const k = (n + h / 60) % 6;
            return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
        };
        const rgb = [
            f(5),
            f(3),
            f(1)
        ].map((v)=>Math.round(v * 255));
        return {
            r: rgb[0],
            g: rgb[1],
            b: rgb[2],
            a: a
        };
    }
    function HSLtoRGB(hsla) {
        return HSVtoRGB(HSLtoHSV(hsla));
    }
    /** Converts RGBA to HSVA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV */ function RGBtoHSV(rgba) {
        if (!rgba) return {
            h: 0,
            s: 1,
            v: 1,
            a: 1
        };
        const r = rgba.r / 255;
        const g = rgba.g / 255;
        const b = rgba.b / 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h = 0;
        if (max !== min) {
            if (max === r) h = 60 * (0 + (g - b) / (max - min));
            else if (max === g) h = 60 * (2 + (b - r) / (max - min));
            else if (max === b) h = 60 * (4 + (r - g) / (max - min));
        }
        if (h < 0) h = h + 360;
        const s = max === 0 ? 0 : (max - min) / max;
        const hsv = [
            h,
            s,
            max
        ];
        return {
            h: hsv[0],
            s: hsv[1],
            v: hsv[2],
            a: rgba.a
        };
    }
    function HSVtoHSL(hsva) {
        const { h: h, s: s, v: v, a: a } = hsva;
        const l = v - v * s / 2;
        const sprime = l === 1 || l === 0 ? 0 : (v - l) / Math.min(l, 1 - l);
        return {
            h: h,
            s: sprime,
            l: l,
            a: a
        };
    }
    function HSLtoHSV(hsl) {
        const { h: h, s: s, l: l, a: a } = hsl;
        const v = l + s * Math.min(l, 1 - l);
        const sprime = v === 0 ? 0 : 2 - 2 * l / v;
        return {
            h: h,
            s: sprime,
            v: v,
            a: a
        };
    }
    function RGBtoCSS({ r: r, g: g, b: b, a: a }) {
        return a === undefined ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${a})`;
    }
    function HSVtoCSS(hsva) {
        return RGBtoCSS(HSVtoRGB(hsva));
    }
    function toHex(v) {
        const h = Math.round(v).toString(16);
        return ('00'.substr(0, 2 - h.length) + h).toUpperCase();
    }
    function RGBtoHex({ r: r, g: g, b: b, a: a }) {
        return `#${[
            toHex(r),
            toHex(g),
            toHex(b),
            a !== undefined ? toHex(Math.round(a * 255)) : ''
        ].join('')}`;
    }
    function HexToRGB(hex) {
        hex = parseHex(hex);
        let [r, g, b, a] = chunk(hex, 2).map((c)=>parseInt(c, 16));
        a = a === undefined ? a : a / 255;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    function HexToHSV(hex) {
        const rgb = HexToRGB(hex);
        return RGBtoHSV(rgb);
    }
    function HSVtoHex(hsva) {
        return RGBtoHex(HSVtoRGB(hsva));
    }
    function parseHex(hex) {
        if (hex.startsWith('#')) hex = hex.slice(1);
        hex = hex.replace(/([^0-9a-f])/gi, 'F');
        if (hex.length === 3 || hex.length === 4) hex = hex.split('').map((x)=>x + x).join('');
        if (hex.length !== 6) hex = padEnd(padEnd(hex, 6), 8, 'F');
        return hex;
    }
    function lighten(value, amount) {
        const lab = fromXYZ$1(toXYZ(value));
        lab[0] = lab[0] + amount * 10;
        return fromXYZ(toXYZ$1(lab));
    }
    function darken(value, amount) {
        const lab = fromXYZ$1(toXYZ(value));
        lab[0] = lab[0] - amount * 10;
        return fromXYZ(toXYZ$1(lab));
    }
    /**
   * Calculate the relative luminance of a given color
   * @see https://www.w3.org/TR/WCAG20/#relativeluminancedef
   */ function getLuma(color) {
        const rgb = parseColor(color);
        return toXYZ(rgb)[1];
    }
    /**
   * Returns the contrast ratio (1-21) between two colors.
   * @see https://www.w3.org/TR/WCAG20/#contrast-ratiodef
   */ function getContrast(first, second) {
        const l1 = getLuma(first);
        const l2 = getLuma(second);
        const light = Math.max(l1, l2);
        const dark = Math.min(l1, l2);
        return (light + 0.05) / (dark + 0.05);
    }
    function hasLightForeground(color) {
        const blackContrast = Math.abs(APCAcontrast(parseColor(0), parseColor(color)));
        const whiteContrast = Math.abs(APCAcontrast(parseColor(0xffffff), parseColor(color)));
        // TODO: warn about poor color selections
        // const contrastAsText = Math.abs(APCAcontrast(colorVal, colorToInt(theme.colors.background)))
        // const minContrast = Math.max(blackContrast, whiteContrast)
        // if (minContrast < 60) {
        //   consoleInfo(`${key} theme color ${color} has poor contrast (${minContrast.toFixed()}%)`)
        // } else if (contrastAsText < 60 && !['background', 'surface'].includes(color)) {
        //   consoleInfo(`${key} theme color ${color} has poor contrast as text (${contrastAsText.toFixed()}%)`)
        // }
        // Prefer white text if both have an acceptable contrast ratio
        return whiteContrast > Math.min(blackContrast, 50);
    }
    // Types
    // eslint-disable-line vue/prefer-import-from-vue
    /**
   * Creates a factory function for props definitions.
   * This is used to define props in a composable then override
   * default values in an implementing component.
   *
   * @example Simplified signature
   * (props: Props) => (defaults?: Record<keyof props, any>) => Props
   *
   * @example Usage
   * const makeProps = propsFactory({
   *   foo: String,
   * })
   *
   * defineComponent({
   *   props: {
   *     ...makeProps({
   *       foo: 'a',
   *     }),
   *   },
   *   setup (props) {
   *     // would be "string | undefined", now "string" because a default has been provided
   *     props.foo
   *   },
   * }
   */ function propsFactory(props, source) {
        return (defaults)=>{
            return Object.keys(props).reduce((obj, prop)=>{
                const isObjectDefinition = typeof props[prop] === 'object' && props[prop] != null && !Array.isArray(props[prop]);
                const definition = isObjectDefinition ? props[prop] : {
                    type: props[prop]
                };
                if (defaults && prop in defaults) obj[prop] = {
                    ...definition,
                    default: defaults[prop]
                };
                else obj[prop] = definition;
                if (source && !obj[prop].source) obj[prop].source = source;
                return obj;
            }, {});
        };
    }
    /**
   * Like `Partial<T>` but doesn't care what the value is
   */ // Copied from Vue
    // Utilities
    // Types
    // TODO: import from vue once upstream PR is merged
    // https://github.com/vuejs/core/pull/14441
    // Composables
    const makeComponentProps = propsFactory({
        class: [
            String,
            Array,
            Object
        ],
        style: {
            type: [
                String,
                Array,
                Object
            ],
            default: null
        }
    }, 'component');
    // Utilities
    function getCurrentInstance(name, message) {
        const vm = vue.getCurrentInstance();
        if (!vm) throw new Error(`[Vuetify] ${name} ${'must be called from inside a setup function'}`);
        return vm;
    }
    function getCurrentInstanceName(name = 'composables') {
        const vm = getCurrentInstance(name).type;
        return toKebabCase(vm?.aliasName || vm?.name);
    }
    // Utilities
    // Types
    function injectSelf(key, vm = getCurrentInstance('injectSelf')) {
        const { provides: provides } = vm;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        return undefined;
    }
    // Utilities
    // Types
    const DefaultsSymbol = Symbol.for('vuetify:defaults');
    function createDefaults(options) {
        return vue.ref(options);
    }
    function injectDefaults() {
        const defaults = vue.inject(DefaultsSymbol);
        if (!defaults) throw new Error('[Vuetify] Could not find defaults instance');
        return defaults;
    }
    function provideDefaults(defaults, options) {
        const injectedDefaults = injectDefaults();
        const providedDefaults = vue.ref(defaults);
        const newDefaults = vue.computed(()=>{
            const disabled = vue.unref(options?.disabled);
            if (disabled) return injectedDefaults.value;
            const scoped = vue.unref(options?.scoped);
            const reset = vue.unref(options?.reset);
            const root = vue.unref(options?.root);
            if (providedDefaults.value == null && !(scoped || reset || root)) return injectedDefaults.value;
            let properties = mergeDeep(providedDefaults.value, {
                prev: injectedDefaults.value
            });
            if (scoped) return properties;
            if (reset || root) {
                const len = Number(reset || Infinity);
                const rootDefaults = typeof root === 'string' ? properties.prev?.[root] : undefined;
                for(let i = 0; i <= len; i++){
                    if (!properties || !('prev' in properties)) break;
                    properties = properties.prev;
                }
                if (properties && rootDefaults) properties = mergeDeep(mergeDeep(properties, {
                    prev: properties
                }), rootDefaults);
                return properties;
            }
            return properties.prev ? mergeDeep(properties.prev, properties, undefined, (_, v)=>v !== undefined) : properties;
        });
        vue.provide(DefaultsSymbol, newDefaults);
        return newDefaults;
    }
    function propIsDefined(vnode, prop) {
        return vnode.props && (typeof vnode.props[prop] !== 'undefined' || typeof vnode.props[toKebabCase(prop)] !== 'undefined');
    }
    function internalUseDefaults(props = {}, name, defaults = injectDefaults()) {
        const vm = getCurrentInstance('useDefaults');
        name = name ?? vm.type.name ?? vm.type.__name;
        if (!name) throw new Error('[Vuetify] Could not determine component name');
        const componentDefaults = vue.computed(()=>defaults.value?.[props._as ?? name]);
        const _props = new Proxy(props, {
            get (target, prop) {
                const propValue = Reflect.get(target, prop);
                if (prop === 'class' || prop === 'style') return [
                    componentDefaults.value?.[prop],
                    propValue
                ].filter((v)=>v != null);
                if (propIsDefined(vm.vnode, prop)) return propValue;
                const _componentDefault = componentDefaults.value?.[prop];
                if (_componentDefault !== undefined) return _componentDefault;
                const _globalDefault = defaults.value?.global?.[prop];
                if (_globalDefault !== undefined) return _globalDefault;
                return propValue;
            }
        });
        const _subcomponentDefaults = vue.shallowRef();
        vue.watchEffect(()=>{
            if (componentDefaults.value) {
                const subComponents = Object.entries(componentDefaults.value).filter(([key])=>key.startsWith(key[0].toUpperCase()));
                _subcomponentDefaults.value = subComponents.length ? Object.fromEntries(subComponents) : undefined;
            } else _subcomponentDefaults.value = undefined;
        });
        function provideSubDefaults() {
            const injected = injectSelf(DefaultsSymbol, vm);
            vue.provide(DefaultsSymbol, vue.computed(()=>{
                return _subcomponentDefaults.value ? mergeDeep(injected?.value ?? {}, _subcomponentDefaults.value) : injected?.value;
            }));
        }
        return {
            props: _props,
            provideSubDefaults: provideSubDefaults
        };
    }
    function useDefaults(props = {}, name) {
        const { props: _props, provideSubDefaults: provideSubDefaults } = internalUseDefaults(props, name);
        provideSubDefaults();
        return _props;
    }
    // Composables
    // Types
    // No props
    // Object Props
    // Implementation
    function defineComponent(options) {
        options._setup = options._setup ?? options.setup;
        if (!options.name) {
            consoleWarn('The component is missing an explicit name, unable to generate default prop value');
            return options;
        }
        if (options._setup) {
            options.props = propsFactory(options.props ?? {}, options.name)();
            const propKeys = Object.keys(options.props).filter((key)=>key !== 'class' && key !== 'style');
            options.filterProps = function filterProps(props) {
                return pick(props, propKeys);
            };
            options.props._as = String;
            options.setup = function setup(props, ctx) {
                const defaults = injectDefaults();
                // Skip props proxy if defaults are not provided
                if (!defaults.value) return options._setup(props, ctx);
                const { props: _props, provideSubDefaults: provideSubDefaults } = internalUseDefaults(props, props._as ?? options.name, defaults);
                const setupBindings = options._setup(_props, ctx);
                provideSubDefaults();
                return setupBindings;
            };
        }
        return options;
    }
    // No argument - simple default slot
    // Generic constructor argument - generic props and slots
    // Slots argument - simple slots
    // Implementation
    function genericComponent(exposeDefaults = true) {
        return (options)=>(exposeDefaults ? defineComponent : vue.defineComponent)(options);
    }
    function defineFunctionalComponent(props, render) {
        render.props = props;
        return render;
    }
    // Adds a filterProps method to the component options
    // https://github.com/vuejs/core/pull/10557
    // not a vue Component
    // Composables
    function createSimpleFunctional(klass, tag = 'div', name) {
        return genericComponent()({
            name: name ?? vue.capitalize(vue.camelize(klass.replace(/__/g, '-'))),
            props: {
                tag: {
                    type: String,
                    default: tag
                },
                ...makeComponentProps()
            },
            setup (props, { slots: slots }) {
                return ()=>{
                    return vue.h(props.tag, {
                        class: [
                            klass,
                            props.class
                        ],
                        style: props.style
                    }, slots.default?.());
                };
            }
        });
    }
    function updateRecursionCache(a, b, cache, result) {
        if (!cache || isPrimitive(a) || isPrimitive(b)) return;
        const visitedObject = cache.get(a);
        if (visitedObject) visitedObject.set(b, result);
        else {
            const newCacheItem = new WeakMap();
            newCacheItem.set(b, result);
            cache.set(a, newCacheItem);
        }
    }
    function findCachedComparison(a, b, cache) {
        if (!cache || isPrimitive(a) || isPrimitive(b)) return null;
        const r1 = cache.get(a)?.get(b);
        if (typeof r1 === 'boolean') return r1;
        const r2 = cache.get(b)?.get(a);
        if (typeof r2 === 'boolean') return r2;
        return null;
    }
    function deepEqual(a, b, recursionCache = new WeakMap()) {
        if (a === b) return true;
        if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) // If the values are Date, compare them as timestamps
        return false;
        if (a !== Object(a) || b !== Object(b)) // If the values aren't objects, they were already checked for equality
        return false;
        const props = Object.keys(a);
        if (props.length !== Object.keys(b).length) // Different number of props, don't bother to check
        return false;
        const cachedComparisonResult = findCachedComparison(a, b, recursionCache);
        if (cachedComparisonResult) return cachedComparisonResult;
        updateRecursionCache(a, b, recursionCache, true);
        return props.every((p)=>deepEqual(a[p], b[p], recursionCache));
    }
    /**
   * Returns:
   *  - 'null' if the node is not attached to the DOM
   *  - the root node (HTMLDocument | ShadowRoot) otherwise
   */ function attachedRoot(node) {
        /* istanbul ignore next */ if (typeof node.getRootNode !== 'function') {
            // Shadow DOM not supported (IE11), lets find the root of this node
            while(node.parentNode)node = node.parentNode;
            // The root parent is the document if the node is attached to the DOM
            if (node !== document) return null;
            return document;
        }
        const root = node.getRootNode();
        // The composed root node is the document if the node is attached to the DOM
        if (root !== document && root.getRootNode({
            composed: true
        }) !== document) return null;
        return root;
    }
    // Utilities
    // Types
    const standardEasing = 'cubic-bezier(0.4, 0, 0.2, 1)';
    const deceleratedEasing = 'cubic-bezier(0.0, 0, 0.2, 1)'; // Entering
    const acceleratedEasing = 'cubic-bezier(0.4, 0, 1, 1)'; // Leaving
    const easingPatterns = {
        linear: (t)=>t,
        easeInQuad: (t)=>t ** 2,
        easeOutQuad: (t)=>t * (2 - t),
        easeInOutQuad: (t)=>t < 0.5 ? 2 * t ** 2 : -1 + (4 - 2 * t) * t,
        easeInCubic: (t)=>t ** 3,
        easeOutCubic: (t)=>--t ** 3 + 1,
        easeInOutCubic: (t)=>t < 0.5 ? 4 * t ** 3 : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
        easeInQuart: (t)=>t ** 4,
        easeOutQuart: (t)=>1 - --t ** 4,
        easeInOutQuart: (t)=>t < 0.5 ? 8 * t ** 4 : 1 - 8 * --t ** 4,
        easeInQuint: (t)=>t ** 5,
        easeOutQuint: (t)=>1 + --t ** 5,
        easeInOutQuint: (t)=>t < 0.5 ? 16 * t ** 5 : 1 + 16 * --t ** 5,
        instant: (t)=>1
    };
    function useTransition(source, options) {
        const defaultTransition = {
            duration: 300,
            transition: easingPatterns.easeInOutCubic
        };
        let raf = -1;
        const outputRef = vue.shallowRef(vue.toValue(source));
        vue.watch(()=>vue.toValue(source), async (to)=>{
            cancelAnimationFrame(raf);
            const easing = {
                ...defaultTransition,
                ...vue.toValue(options)
            };
            await executeTransition(outputRef, outputRef.value, to, easing);
        });
        function executeTransition(out, from, to, options) {
            const startTime = performance.now();
            const ease = PREFERS_REDUCED_MOTION() ? easingPatterns.instant : options.transition ?? easingPatterns.easeInOutCubic;
            return new Promise((resolve)=>{
                raf = requestAnimationFrame(function step(currentTime) {
                    const timeElapsed = currentTime - startTime;
                    const progress = timeElapsed / options.duration;
                    out.value = from + (to - from) * ease(clamp(progress, 0, 1));
                    if (progress < 1) raf = requestAnimationFrame(step);
                    else {
                        out.value = to;
                        resolve();
                    }
                });
            });
        }
        return vue.computed(()=>outputRef.value);
    }
    // Utilities
    function getPrefixedEventHandlers(attrs, suffix, getData) {
        return Object.keys(attrs).filter((key)=>isOn(key) && key.endsWith(suffix)).reduce((acc, key)=>{
            acc[key.slice(0, -suffix.length)] = (event)=>callEvent(attrs[key], event, getData(event));
            return acc;
        }, {});
    }
    function getScrollParent(el, includeHidden = false) {
        while(el){
            if (includeHidden ? isPotentiallyScrollable(el) : hasScrollbar(el)) return el;
            el = el.parentElement;
        }
        return document.scrollingElement;
    }
    function getScrollParents(el, stopAt) {
        const elements = [];
        if (stopAt && el && !stopAt.contains(el)) return elements;
        while(el){
            if (hasScrollbar(el)) elements.push(el);
            if (el === stopAt) break;
            el = el.parentElement;
        }
        return elements;
    }
    function hasScrollbar(el) {
        if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
        const style = window.getComputedStyle(el);
        const hasVerticalScrollbar = style.overflowY === 'scroll' || style.overflowY === 'auto' && el.scrollHeight > el.clientHeight;
        const hasHorizontalScrollbar = style.overflowX === 'scroll' || style.overflowX === 'auto' && el.scrollWidth > el.clientWidth;
        return hasVerticalScrollbar || hasHorizontalScrollbar;
    }
    function isPotentiallyScrollable(el) {
        if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
        const style = window.getComputedStyle(el);
        return [
            'scroll',
            'auto'
        ].includes(style.overflowY);
    }
    // Types
    function getIndentLines({ depth: depth, isLast: isLast, isLastGroup: isLastGroup, leafLinks: leafLinks, separateRoots: separateRoots, parentIndentLines: parentIndentLines, variant: variant }) {
        const isLastLeaf = isLast && (!isLastGroup || separateRoots || depth > 1);
        if (!parentIndentLines || !depth) return {
            leaf: undefined,
            node: undefined,
            children: parentIndentLines,
            footer: parentIndentLines && (!isLastLeaf || variant === 'simple') ? [
                ...parentIndentLines,
                separateRoots ? 'none' : 'line'
            ] : [
                'none'
            ]
        };
        if (variant === 'simple') return {
            leaf: [
                ...parentIndentLines,
                'line'
            ],
            node: [
                ...parentIndentLines,
                'line'
            ],
            children: [
                ...parentIndentLines,
                'line'
            ],
            footer: [
                ...parentIndentLines,
                'line',
                'line'
            ]
        };
        return {
            leaf: [
                ...parentIndentLines,
                isLastLeaf ? 'last-leaf' : 'leaf',
                ...leafLinks ? [
                    'leaf-link'
                ] : []
            ],
            node: [
                ...parentIndentLines,
                isLastLeaf ? 'last-leaf' : 'leaf'
            ],
            children: [
                ...parentIndentLines,
                isLastLeaf ? 'none' : 'line'
            ],
            footer: [
                ...parentIndentLines,
                isLastLeaf ? 'none' : 'line'
            ]
        };
    }
    function isFixedPosition(el) {
        while(el){
            if (window.getComputedStyle(el).position === 'fixed') return true;
            el = el.offsetParent;
        }
        return false;
    }
    // Utilities
    // Types
    function useRender(render) {
        const vm = getCurrentInstance('useRender');
        vm.render = render;
    }
    function throttle(fn, delay, options = {
        leading: true,
        trailing: true
    }) {
        let timeoutId = 0;
        let lastExec = 0;
        let throttling = false;
        let start = 0;
        function clear() {
            clearTimeout(timeoutId);
            throttling = false;
            start = 0;
        }
        const wrap = (...args)=>{
            clearTimeout(timeoutId);
            const now = Date.now();
            if (!start) start = now;
            const elapsed = now - Math.max(start, lastExec);
            function invoke() {
                lastExec = Date.now();
                timeoutId = setTimeout(clear, delay);
                fn(...args);
            }
            if (!throttling) {
                throttling = true;
                if (options.leading) invoke();
            } else if (elapsed >= delay) invoke();
            else if (options.trailing) timeoutId = setTimeout(invoke, delay - elapsed);
        };
        wrap.clear = clear;
        wrap.immediate = fn;
        return wrap;
    }
    // Utilities
    // Types
    const IconValue = [
        String,
        Function,
        Object,
        Array
    ];
    const IconSymbol = Symbol.for('vuetify:icons');
    const makeIconProps = propsFactory({
        icon: {
            type: IconValue
        },
        // Could not remove this and use makeTagProps, types complained because it is not required
        tag: {
            type: [
                String,
                Object,
                Function
            ],
            required: true
        }
    }, 'icon');
    const VComponentIcon = genericComponent()({
        name: 'VComponentIcon',
        props: makeIconProps(),
        setup (props, { slots: slots }) {
            return ()=>{
                const Icon = props.icon;
                return vue.createVNode(props.tag, null, {
                    default: ()=>[
                            props.icon ? vue.createVNode(Icon, null, null) : slots.default?.()
                        ]
                });
            };
        }
    });
    const VSvgIcon = defineComponent({
        name: 'VSvgIcon',
        inheritAttrs: false,
        props: makeIconProps(),
        setup (props, { attrs: attrs }) {
            return ()=>{
                return vue.createVNode(props.tag, vue.mergeProps(attrs, {
                    "style": null
                }), {
                    default: ()=>[
                            vue.createElementVNode("svg", {
                                "class": "v-icon__svg",
                                "xmlns": "http://www.w3.org/2000/svg",
                                "viewBox": "0 0 24 24",
                                "role": "img",
                                "aria-hidden": "true"
                            }, [
                                Array.isArray(props.icon) ? props.icon.map((path)=>Array.isArray(path) ? vue.createElementVNode("path", {
                                        "d": path[0],
                                        "fill-opacity": path[1]
                                    }, null) : vue.createElementVNode("path", {
                                        "d": path
                                    }, null)) : vue.createElementVNode("path", {
                                    "d": props.icon
                                }, null)
                            ])
                        ]
                });
            };
        }
    });
    const VLigatureIcon = defineComponent({
        name: 'VLigatureIcon',
        props: makeIconProps(),
        setup (props) {
            return ()=>{
                return vue.createVNode(props.tag, null, {
                    default: ()=>[
                            props.icon
                        ]
                });
            };
        }
    });
    const VClassIcon = defineComponent({
        name: 'VClassIcon',
        props: makeIconProps(),
        setup (props) {
            return ()=>{
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass(props.icon)
                }, null);
            };
        }
    });
    const useIcon = (props)=>{
        const icons = vue.inject(IconSymbol);
        if (!icons) throw new Error('Missing Vuetify Icons provide!');
        const iconData = vue.computed(()=>{
            const iconAlias = vue.toValue(props);
            if (!iconAlias) return {
                component: VComponentIcon
            };
            let icon = iconAlias;
            if (typeof icon === 'string') {
                icon = icon.trim();
                if (icon.startsWith('$')) icon = icons.aliases?.[icon.slice(1)];
            }
            if (!icon) consoleWarn(`Could not find aliased icon "${iconAlias}"`);
            if (Array.isArray(icon)) return {
                component: VSvgIcon,
                icon: icon
            };
            else if (typeof icon !== 'string') return {
                component: VComponentIcon,
                icon: icon
            };
            const iconSetName = Object.keys(icons.sets).find((setName)=>typeof icon === 'string' && icon.startsWith(`${setName}:`));
            const iconName = iconSetName ? icon.slice(iconSetName.length + 1) : icon;
            const iconSet = icons.sets[iconSetName ?? icons.defaultSet];
            return {
                component: iconSet.component,
                icon: iconName
            };
        });
        return {
            iconData: iconData
        };
    };
    // Composables
    // Types
    const aliases = {
        collapse: 'mdi-chevron-up',
        complete: 'mdi-check',
        cancel: 'mdi-close-circle',
        close: 'mdi-close',
        delete: 'mdi-close-circle',
        // delete (e.g. v-chip close)
        clear: 'mdi-close-circle',
        success: 'mdi-check-circle',
        info: 'mdi-information',
        warning: 'mdi-alert-circle',
        error: 'mdi-close-circle',
        prev: 'mdi-chevron-left',
        next: 'mdi-chevron-right',
        checkboxOn: 'mdi-checkbox-marked',
        checkboxOff: 'mdi-checkbox-blank-outline',
        checkboxIndeterminate: 'mdi-minus-box',
        delimiter: 'mdi-circle',
        // for carousel
        sortAsc: 'mdi-arrow-up',
        sortDesc: 'mdi-arrow-down',
        expand: 'mdi-chevron-down',
        menu: 'mdi-menu',
        subgroup: 'mdi-menu-down',
        dropdown: 'mdi-menu-down',
        radioOn: 'mdi-radiobox-marked',
        radioOff: 'mdi-radiobox-blank',
        edit: 'mdi-pencil',
        ratingEmpty: 'mdi-star-outline',
        ratingFull: 'mdi-star',
        ratingHalf: 'mdi-star-half-full',
        loading: 'mdi-cached',
        first: 'mdi-page-first',
        last: 'mdi-page-last',
        unfold: 'mdi-unfold-more-horizontal',
        file: 'mdi-paperclip',
        plus: 'mdi-plus',
        minus: 'mdi-minus',
        calendar: 'mdi-calendar',
        treeviewCollapse: 'mdi-menu-down',
        treeviewExpand: 'mdi-menu-right',
        tableGroupCollapse: 'mdi-chevron-down',
        tableGroupExpand: 'mdi-chevron-right',
        eyeDropper: 'mdi-eyedropper',
        upload: 'mdi-cloud-upload',
        color: 'mdi-palette',
        command: 'mdi-apple-keyboard-command',
        ctrl: 'mdi-apple-keyboard-control',
        space: 'mdi-keyboard-space',
        shift: 'mdi-apple-keyboard-shift',
        alt: 'mdi-apple-keyboard-option',
        enter: 'mdi-keyboard-return',
        arrowup: 'mdi-arrow-up',
        arrowdown: 'mdi-arrow-down',
        arrowleft: 'mdi-arrow-left',
        arrowright: 'mdi-arrow-right',
        backspace: 'mdi-backspace',
        play: 'mdi-play',
        pause: 'mdi-pause',
        fullscreen: 'mdi-fullscreen',
        fullscreenExit: 'mdi-fullscreen-exit',
        volumeHigh: 'mdi-volume-high',
        volumeMedium: 'mdi-volume-medium',
        volumeLow: 'mdi-volume-low',
        volumeOff: 'mdi-volume-variant-off',
        search: 'mdi-magnify'
    };
    const mdi = {
        // Not using mergeProps here, functional components merge props by default (?)
        component: (props)=>vue.h(VClassIcon, {
                ...props,
                class: 'mdi'
            })
    };
    // Icons
    // Types
    const md1 = {
        defaults: {
            global: {
                rounded: 'sm'
            },
            VAvatar: {
                rounded: 'circle'
            },
            VAutocomplete: {
                variant: 'underlined'
            },
            VBanner: {
                color: 'primary'
            },
            VBtn: {
                class: 'text-uppercase',
                color: 'primary',
                rounded: 0
            },
            VCheckbox: {
                color: 'secondary',
                indentDetails: false
            },
            VCombobox: {
                variant: 'underlined'
            },
            VDatePicker: {
                color: 'primary',
                controlHeight: 44,
                elevation: 1,
                rounded: 0,
                controlVariant: 'modal',
                VBtn: {
                    color: 'high-emphasis',
                    rounded: 'circle'
                }
            },
            VSelect: {
                variant: 'underlined'
            },
            VSlider: {
                color: 'primary',
                indentDetails: false
            },
            VSwitch: {
                indentDetails: false
            },
            VRadioGroup: {
                indentDetails: false
            },
            VRangeSlider: {
                indentDetails: false
            },
            VTabs: {
                color: 'primary'
            },
            VTextarea: {
                variant: 'underlined'
            },
            VTextField: {
                variant: 'underlined'
            },
            VToolbar: {
                VBtn: {
                    color: null
                }
            }
        },
        icons: {
            defaultSet: 'mdi',
            sets: {
                mdi: mdi
            }
        },
        theme: {
            themes: {
                light: {
                    colors: {
                        primary: '#3F51B5',
                        'primary-darken-1': '#303F9F',
                        'primary-lighten-1': '#C5CAE9',
                        secondary: '#FF4081',
                        'secondary-darken-1': '#F50057',
                        'secondary-lighten-1': '#FF80AB',
                        accent: '#009688'
                    }
                }
            }
        }
    };
    // Icons
    // Types
    const md2 = {
        defaults: {
            VAvatar: {
                rounded: 'circle'
            },
            VAutocomplete: {
                variant: 'filled'
            },
            VBanner: {
                color: 'primary'
            },
            VBtn: {
                class: 'text-uppercase',
                color: 'primary'
            },
            VCheckbox: {
                color: 'secondary',
                indentDetails: true
            },
            VCombobox: {
                variant: 'filled'
            },
            VDatePicker: {
                color: 'primary',
                controlHeight: 56,
                elevation: 2,
                rounded: 'md',
                controlVariant: 'modal',
                VBtn: {
                    color: 'high-emphasis',
                    rounded: 'circle'
                }
            },
            VRadioGroup: {
                indentDetails: true
            },
            VSelect: {
                variant: 'filled'
            },
            VSlider: {
                color: 'primary',
                indentDetails: true
            },
            VRangeSlider: {
                indentDetails: true
            },
            VSwitch: {
                indentDetails: true
            },
            VTabs: {
                color: 'primary'
            },
            VTextarea: {
                variant: 'filled'
            },
            VTextField: {
                variant: 'filled'
            },
            VToolbar: {
                VBtn: {
                    color: null
                }
            }
        },
        icons: {
            defaultSet: 'mdi',
            sets: {
                mdi: mdi
            }
        },
        theme: {
            themes: {
                light: {
                    colors: {
                        primary: '#6200EE',
                        'primary-darken-1': '#3700B3',
                        secondary: '#03DAC6',
                        'secondary-darken-1': '#018786',
                        error: '#B00020'
                    }
                }
            }
        }
    };
    // Icons
    // Types
    const md3 = {
        defaults: {
            VAppBar: {
                flat: true
            },
            VAutocomplete: {
                variant: 'outlined'
            },
            VBanner: {
                color: 'primary'
            },
            VBottomSheet: {
                contentClass: 'rounded-t-xl overflow-hidden'
            },
            VBtn: {
                color: 'primary',
                rounded: 'xl'
            },
            VBtnGroup: {
                rounded: 'xl',
                VBtn: {
                    rounded: null
                }
            },
            VCard: {
                rounded: 'lg'
            },
            VCheckbox: {
                color: 'secondary',
                inset: true,
                indentDetails: true
            },
            VChip: {
                rounded: 'sm'
            },
            VCombobox: {
                variant: 'outlined'
            },
            VDateInput: {
                variant: 'outlined'
            },
            VDatePicker: {
                controlHeight: 48,
                color: 'primary',
                divided: true,
                headerColor: '',
                elevation: 1,
                rounded: 'xl',
                VBtn: {
                    color: 'high-emphasis',
                    rounded: 'circle'
                }
            },
            VFileInput: {
                variant: 'outlined'
            },
            VList: {
                prependGap: 16
            },
            VNavigationDrawer: {
            },
            VNumberInput: {
                variant: 'outlined',
                VBtn: {
                    color: undefined,
                    rounded: undefined
                }
            },
            VRadioGroup: {
                indentDetails: true
            },
            VSelect: {
                variant: 'outlined'
            },
            VSlider: {
                color: 'primary',
                indentDetails: true
            },
            VRangeSlider: {
                indentDetails: true
            },
            VSwitch: {
                indentDetails: true
            },
            VTabs: {
                color: 'primary'
            },
            VTextarea: {
                variant: 'outlined'
            },
            VTextField: {
                variant: 'outlined'
            },
            VToolbar: {
                VBtn: {
                    color: null
                }
            }
        },
        icons: {
            defaultSet: 'mdi',
            sets: {
                mdi: mdi
            }
        },
        theme: {
            themes: {
                light: {
                    colors: {
                        primary: '#6750a4',
                        secondary: '#b4b0bb',
                        tertiary: '#7d5260',
                        error: '#b3261e',
                        surface: '#fffbfe'
                    }
                }
            }
        }
    };
    var index = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        md1: md1,
        md2: md2,
        md3: md3
    });
    // Utilities
    // Types
    function useResizeObserver(callback, box = 'content') {
        const resizeRef = templateRef();
        const contentRect = vue.ref();
        if (IN_BROWSER) {
            const observer = new ResizeObserver((entries)=>{
                callback?.(entries, observer);
                if (!entries.length) return;
                if (box === 'content') contentRect.value = entries[0].contentRect;
                else {
                    // borderBoxSize ignores CSS transforms (e.g. VDialogTransition scale-in)
                    const border = entries[0].borderBoxSize?.[0];
                    const el = entries[0].target;
                    contentRect.value = new Box({
                        x: 0,
                        y: 0,
                        width: border?.inlineSize ?? el.offsetWidth,
                        height: border?.blockSize ?? el.offsetHeight
                    });
                }
            });
            vue.onBeforeUnmount(()=>{
                observer.disconnect();
            });
            vue.watch(()=>resizeRef.el, (newValue, oldValue)=>{
                if (oldValue) {
                    observer.unobserve(oldValue);
                    contentRect.value = undefined;
                }
                if (newValue) observer.observe(newValue);
            }, {
                flush: 'post'
            });
        }
        return {
            resizeRef: resizeRef,
            contentRect: vue.readonly(contentRect)
        };
    }
    // Composables
    // Types
    const VuetifyLayoutKey = Symbol.for('vuetify:layout');
    const VuetifyLayoutItemKey = Symbol.for('vuetify:layout-item');
    const ROOT_ZINDEX = 1000;
    const makeLayoutProps = propsFactory({
        overlaps: {
            type: Array,
            default: ()=>[]
        },
        fullHeight: Boolean
    }, 'layout');
    // Composables
    const makeLayoutItemProps = propsFactory({
        name: {
            type: String
        },
        order: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        absolute: Boolean
    }, 'layout-item');
    function useLayout() {
        const layout = vue.inject(VuetifyLayoutKey);
        if (!layout) throw new Error('[Vuetify] Could not find injected layout');
        return {
            getLayoutItem: layout.getLayoutItem,
            mainRect: layout.mainRect,
            mainStyles: layout.mainStyles
        };
    }
    function useLayoutItem(options) {
        const layout = vue.inject(VuetifyLayoutKey);
        if (!layout) throw new Error('[Vuetify] Could not find injected layout');
        const id = options.id ?? `layout-item-${vue.useId()}`;
        const vm = getCurrentInstance('useLayoutItem');
        vue.provide(VuetifyLayoutItemKey, {
            id: id
        });
        const isKeptAlive = vue.shallowRef(false);
        vue.onDeactivated(()=>isKeptAlive.value = true);
        vue.onActivated(()=>isKeptAlive.value = false);
        const { layoutItemStyles: layoutItemStyles, layoutItemScrimStyles: layoutItemScrimStyles } = layout.register(vm, {
            ...options,
            active: vue.computed(()=>isKeptAlive.value ? false : options.active.value),
            id: id
        });
        vue.onBeforeUnmount(()=>layout.unregister(id));
        return {
            layoutItemStyles: layoutItemStyles,
            layoutRect: layout.layoutRect,
            layoutItemScrimStyles: layoutItemScrimStyles
        };
    }
    const generateLayers = (layout, positions, layoutSizes, activeItems)=>{
        let previousLayer = {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        };
        const layers = [
            {
                id: '',
                layer: {
                    ...previousLayer
                }
            }
        ];
        for (const id of layout){
            const position = positions.get(id);
            const amount = layoutSizes.get(id);
            const active = activeItems.get(id);
            if (!position || !amount || !active) continue;
            const layer = {
                ...previousLayer,
                [position.value]: parseInt(previousLayer[position.value], 10) + (active.value ? parseInt(amount.value, 10) : 0)
            };
            layers.push({
                id: id,
                layer: layer
            });
            previousLayer = layer;
        }
        return layers;
    };
    function createLayout(props) {
        const parentLayout = vue.inject(VuetifyLayoutKey, null);
        const rootZIndex = vue.computed(()=>parentLayout ? parentLayout.rootZIndex.value - 100 : ROOT_ZINDEX);
        const registered = vue.ref([]);
        const positions = vue.reactive(new Map());
        const layoutSizes = vue.reactive(new Map());
        const priorities = vue.reactive(new Map());
        const activeItems = vue.reactive(new Map());
        const disabledTransitions = vue.reactive(new Map());
        const { resizeRef: resizeRef, contentRect: layoutRect } = useResizeObserver();
        const computedOverlaps = vue.computed(()=>{
            const map = new Map();
            const overlaps = props.overlaps ?? [];
            for (const overlap of overlaps.filter((item)=>item.includes(':'))){
                const [top, bottom] = overlap.split(':');
                if (!registered.value.includes(top) || !registered.value.includes(bottom)) continue;
                const topPosition = positions.get(top);
                const bottomPosition = positions.get(bottom);
                const topAmount = layoutSizes.get(top);
                const bottomAmount = layoutSizes.get(bottom);
                if (!topPosition || !bottomPosition || !topAmount || !bottomAmount) continue;
                map.set(bottom, {
                    position: topPosition.value,
                    amount: parseInt(topAmount.value, 10)
                });
                map.set(top, {
                    position: bottomPosition.value,
                    amount: -parseInt(bottomAmount.value, 10)
                });
            }
            return map;
        });
        const layers = vue.computed(()=>{
            const uniquePriorities = [
                ...new Set([
                    ...priorities.values()
                ].map((p)=>p.value))
            ].sort((a, b)=>a - b);
            const layout = [];
            for (const p of uniquePriorities){
                const items = registered.value.filter((id)=>priorities.get(id)?.value === p);
                layout.push(...items);
            }
            return generateLayers(layout, positions, layoutSizes, activeItems);
        });
        const transitionsEnabled = vue.computed(()=>{
            return !Array.from(disabledTransitions.values()).some((ref)=>ref.value);
        });
        const mainRect = vue.computed(()=>{
            return layers.value[layers.value.length - 1].layer;
        });
        const mainStyles = vue.toRef(()=>{
            return {
                '--v-layout-left': convertToUnit(mainRect.value.left),
                '--v-layout-right': convertToUnit(mainRect.value.right),
                '--v-layout-top': convertToUnit(mainRect.value.top),
                '--v-layout-bottom': convertToUnit(mainRect.value.bottom),
                ...transitionsEnabled.value ? undefined : {
                    transition: 'none'
                }
            };
        });
        const items = vue.computed(()=>{
            return layers.value.slice(1).map(({ id: id }, index)=>{
                const { layer: layer } = layers.value[index];
                const size = layoutSizes.get(id);
                const position = positions.get(id);
                return {
                    id: id,
                    ...layer,
                    size: Number(size.value),
                    position: position.value
                };
            });
        });
        const getLayoutItem = (id)=>{
            return items.value.find((item)=>item.id === id);
        };
        const rootVm = getCurrentInstance('createLayout');
        const isMounted = vue.shallowRef(false);
        vue.onMounted(()=>{
            isMounted.value = true;
        });
        vue.provide(VuetifyLayoutKey, {
            register: (vm, { id: id, order: order, position: position, layoutSize: layoutSize, elementSize: elementSize, active: active, disableTransitions: disableTransitions, absolute: absolute })=>{
                priorities.set(id, order);
                positions.set(id, position);
                layoutSizes.set(id, layoutSize);
                activeItems.set(id, active);
                disableTransitions && disabledTransitions.set(id, disableTransitions);
                const instances = findChildrenWithProvide(VuetifyLayoutItemKey, rootVm?.vnode);
                const instanceIndex = instances.indexOf(vm);
                if (instanceIndex > -1) registered.value.splice(instanceIndex, 0, id);
                else registered.value.push(id);
                const index = vue.computed(()=>items.value.findIndex((i)=>i.id === id));
                const zIndex = vue.computed(()=>rootZIndex.value + layers.value.length * 2 - index.value * 2);
                const layoutItemStyles = vue.computed(()=>{
                    const isHorizontal = position.value === 'left' || position.value === 'right';
                    const isOppositeHorizontal = position.value === 'right';
                    const isOppositeVertical = position.value === 'bottom';
                    const size = Number(elementSize.value ?? layoutSize.value);
                    const transformFunction = `translate${isHorizontal ? 'X' : 'Y'}`;
                    const transformValue = active.value ? 0 : (size === 0 ? 100 : size + 1) * (isOppositeHorizontal || isOppositeVertical ? 1 : -1);
                    const unit = size === 0 ? '%' : 'px';
                    const styles = {
                        [position.value]: 0,
                        zIndex: zIndex.value,
                        transform: `${transformFunction}(${transformValue}${unit})`,
                        position: absolute.value || rootZIndex.value !== ROOT_ZINDEX ? 'absolute' : 'fixed',
                        ...transitionsEnabled.value ? undefined : {
                            transition: 'none'
                        }
                    };
                    if (!isMounted.value) return styles;
                    const item = items.value[index.value];
                    if (!item) consoleWarn(`[Vuetify] Could not find layout item "${id}"`);
                    const overlap = computedOverlaps.value.get(id);
                    if (overlap) item[overlap.position] += overlap.amount;
                    return {
                        ...styles,
                        height: isHorizontal ? `calc(100% - ${item.top}px - ${item.bottom}px)` : elementSize.value ? `${elementSize.value}px` : undefined,
                        left: isOppositeHorizontal ? undefined : `${item.left}px`,
                        right: isOppositeHorizontal ? `${item.right}px` : undefined,
                        top: position.value !== 'bottom' ? `${item.top}px` : undefined,
                        bottom: position.value !== 'top' ? `${item.bottom}px` : undefined,
                        width: !isHorizontal ? `calc(100% - ${item.left}px - ${item.right}px)` : elementSize.value ? `${elementSize.value}px` : undefined
                    };
                });
                const layoutItemScrimStyles = vue.computed(()=>({
                        zIndex: zIndex.value - 1
                    }));
                return {
                    layoutItemStyles: layoutItemStyles,
                    layoutItemScrimStyles: layoutItemScrimStyles,
                    zIndex: zIndex
                };
            },
            unregister: (id)=>{
                priorities.delete(id);
                positions.delete(id);
                layoutSizes.delete(id);
                activeItems.delete(id);
                disabledTransitions.delete(id);
                registered.value = registered.value.filter((v)=>v !== id);
            },
            mainRect: mainRect,
            mainStyles: mainStyles,
            getLayoutItem: getLayoutItem,
            items: items,
            layoutRect: layoutRect,
            rootZIndex: rootZIndex
        });
        const layoutClasses = vue.toRef(()=>[
                'v-layout',
                {
                    'v-layout--full-height': props.fullHeight
                }
            ]);
        const layoutStyles = vue.toRef(()=>({
                zIndex: parentLayout ? rootZIndex.value : undefined,
                position: parentLayout ? 'relative' : undefined,
                overflow: parentLayout ? 'hidden' : undefined
            }));
        return {
            layoutClasses: layoutClasses,
            layoutStyles: layoutStyles,
            getLayoutItem: getLayoutItem,
            items: items,
            layoutRect: layoutRect,
            layoutRef: resizeRef
        };
    }
    // Utilities
    // Types
    function useToggleScope(source, fn) {
        let scope;
        function start() {
            scope = vue.effectScope();
            scope.run(()=>fn.length ? fn(()=>{
                    scope?.stop();
                    start();
                }) : fn());
        }
        vue.watch(source, (active)=>{
            if (active && !scope) start();
            else if (!active) {
                scope?.stop();
                scope = undefined;
            }
        }, {
            immediate: true
        });
        vue.onScopeDispose(()=>{
            scope?.stop();
        });
    }
    // Composables
    // Types
    // Composables
    function useProxiedModel(props, prop, defaultValue, transformIn = (v)=>v, transformOut = (v)=>v) {
        const vm = getCurrentInstance('useProxiedModel');
        const internal = vue.ref(props[prop] !== undefined ? props[prop] : defaultValue);
        const kebabProp = toKebabCase(prop);
        const checkKebab = kebabProp !== prop;
        const isControlled = checkKebab ? vue.computed(()=>{
            props[prop];
            return !!((vm.vnode.props?.hasOwnProperty(prop) || vm.vnode.props?.hasOwnProperty(kebabProp)) && (vm.vnode.props?.hasOwnProperty(`onUpdate:${prop}`) || vm.vnode.props?.hasOwnProperty(`onUpdate:${kebabProp}`)));
        }) : vue.computed(()=>{
            props[prop];
            return !!(vm.vnode.props?.hasOwnProperty(prop) && vm.vnode.props?.hasOwnProperty(`onUpdate:${prop}`));
        });
        useToggleScope(()=>!isControlled.value, ()=>{
            vue.watch(()=>props[prop], (val)=>{
                internal.value = val;
            });
        });
        const model = vue.computed({
            get () {
                const externalValue = props[prop];
                return transformIn(isControlled.value ? externalValue : internal.value);
            },
            set (internalValue) {
                const newValue = transformOut(internalValue);
                const value = vue.toRaw(isControlled.value ? props[prop] : internal.value);
                if (value === newValue || transformIn(value) === internalValue) return;
                internal.value = newValue;
                vm?.emit(`update:${prop}`, newValue);
            }
        });
        Object.defineProperty(model, 'externalValue', {
            get: ()=>isControlled.value ? props[prop] : internal.value
        });
        return model;
    }
    var en = {
        badge: 'Badge',
        open: 'Open',
        close: 'Close',
        dismiss: 'Dismiss',
        confirmEdit: {
            ok: 'OK',
            cancel: 'Cancel'
        },
        dataIterator: {
            noResultsText: 'No matching records found',
            loadingText: 'Loading items...'
        },
        dataTable: {
            itemsPerPageText: 'Rows per page:',
            ariaLabel: {
                sortDescending: 'Sorted descending.',
                sortAscending: 'Sorted ascending.',
                sortNone: 'Not sorted.',
                activateNone: 'Activate to remove sorting.',
                activateDescending: 'Activate to sort descending.',
                activateAscending: 'Activate to sort ascending.',
                selectRow: 'Select row',
                selectAll: 'Select all',
                selectGroup: 'Select group'
            },
            sortBy: 'Sort by'
        },
        dataFooter: {
            itemsPerPageText: 'Items per page:',
            itemsPerPageAll: 'All',
            nextPage: 'Next page',
            prevPage: 'Previous page',
            firstPage: 'First page',
            lastPage: 'Last page',
            pageText: '{0}-{1} of {2}'
        },
        dateRangeInput: {
            divider: 'to'
        },
        monthPicker: {
            title: 'Select month',
            itemsSelected: '{0} selected',
            header: 'Enter month',
            range: {
                title: 'Enter months'
            },
            ariaLabel: {
                previousYear: 'Previous year',
                nextYear: 'Next year',
                selectYear: 'Select year',
                currentMonth: 'Current month, {0}'
            }
        },
        datePicker: {
            itemsSelected: '{0} selected',
            range: {
                title: 'Select dates',
                header: 'Enter dates'
            },
            title: 'Select date',
            header: 'Enter date',
            input: {
                placeholder: 'Enter date'
            },
            ariaLabel: {
                previousMonth: 'Previous month',
                nextMonth: 'Next month',
                selectYear: 'Select year',
                previousYear: 'Previous year',
                nextYear: 'Next year',
                selectMonth: 'Select month',
                selectDate: '{0}',
                // Full date format
                currentDate: 'Today, {0}'
            }
        },
        noDataText: 'No data available',
        carousel: {
            prev: 'Previous visual',
            next: 'Next visual',
            ariaLabel: {
                delimiter: 'Carousel slide {0} of {1}'
            }
        },
        calendar: {
            moreEvents: '{0} more',
            today: 'Today'
        },
        heatmap: {
            less: 'Less',
            more: 'More'
        },
        input: {
            clear: 'Clear {0}',
            prependAction: '{0} prepended action',
            appendAction: '{0} appended action',
            otp: 'Enter verification code'
        },
        fileInput: {
            counter: '{0} files',
            counterSize: '{0} files ({1} in total)'
        },
        fileUpload: {
            title: 'Drag and drop files here',
            divider: 'or',
            browse: 'Browse Files'
        },
        timePicker: {
            am: 'AM',
            pm: 'PM',
            title: 'Select Time',
            hour: 'Hour',
            minute: 'Minute',
            second: 'Second',
            notAllowed: 'Value is not allowed'
        },
        pagination: {
            ariaLabel: {
                root: 'Pagination Navigation',
                next: 'Next page',
                previous: 'Previous page',
                page: 'Go to page {0}',
                currentPage: 'Page {0}, Current page',
                first: 'First page',
                last: 'Last page'
            }
        },
        stepper: {
            next: 'Next',
            prev: 'Previous'
        },
        rating: {
            ariaLabel: {
                item: 'Rating {0} of {1}'
            }
        },
        loading: 'Loading...',
        infiniteScroll: {
            loadMore: 'Load more',
            empty: 'No more'
        },
        rules: {
            required: 'This field is required',
            email: 'Please enter a valid email',
            number: 'This field can only contain numbers',
            integer: 'This field can only contain integer values',
            capital: 'This field can only contain uppercase letters',
            maxLength: 'You must enter a maximum of {0} characters',
            minLength: 'You must enter a minimum of {0} characters',
            strictLength: 'The length of the entered field is invalid',
            exclude: 'The {0} character is not allowed',
            notEmpty: 'Please choose at least one value',
            pattern: 'Invalid format'
        },
        command: {
            search: 'Type a command or search...'
        },
        hotkey: {
            then: 'then',
            ctrl: 'Ctrl',
            command: 'Command',
            space: 'Space',
            shift: 'Shift',
            alt: 'Alt',
            enter: 'Enter',
            escape: 'Escape',
            upArrow: 'Up Arrow',
            downArrow: 'Down Arrow',
            leftArrow: 'Left Arrow',
            rightArrow: 'Right Arrow',
            backspace: 'Backspace',
            option: 'Option',
            plus: 'plus',
            shortcut: 'Keyboard shortcut: {0}',
            or: 'or'
        },
        video: {
            play: 'Play',
            pause: 'Pause',
            seek: 'Seek',
            volume: 'Volume',
            showVolume: 'Show volume control',
            mute: 'Mute',
            unmute: 'Unmute',
            enterFullscreen: 'Full screen',
            exitFullscreen: 'Exit full screen'
        },
        colorPicker: {
            ariaLabel: {
                eyedropper: 'Select color with eyedropper',
                hueSlider: 'Hue',
                alphaSlider: 'Alpha',
                redInput: 'Red value',
                greenInput: 'Green value',
                blueInput: 'Blue value',
                alphaInput: 'Alpha value',
                hueInput: 'Hue value',
                saturationInput: 'Saturation value',
                lightnessInput: 'Lightness value',
                hexInput: 'HEX value',
                hexaInput: 'HEX with alpha value',
                changeFormat: 'Change color format'
            }
        }
    };
    // Composables
    // Types
    const LANG_PREFIX = '$vuetify.';
    const replace = (str, params)=>{
        return str.replace(/\{(\d+)\}/g, (match, index)=>{
            return String(params[Number(index)]);
        });
    };
    const createTranslateFunction = (current, fallback, messages)=>{
        return (key, ...params)=>{
            if (!key.startsWith(LANG_PREFIX)) return replace(key, params);
            const shortKey = key.replace(LANG_PREFIX, '');
            const currentLocale = current.value && messages.value[current.value];
            const fallbackLocale = fallback.value && messages.value[fallback.value];
            let str = getObjectValueByPath(currentLocale, shortKey, null);
            if (!str) {
                consoleWarn(`Translation key "${key}" not found in "${current.value}", trying fallback locale`);
                str = getObjectValueByPath(fallbackLocale, shortKey, null);
            }
            if (!str) {
                consoleError(`Translation key "${key}" not found in fallback`);
                str = key;
            }
            if (typeof str !== 'string') {
                consoleError(`Translation key "${key}" has a non-string value`);
                str = key;
            }
            return replace(str, params);
        };
    };
    function createNumberFunction(current, fallback) {
        return (value, options)=>{
            const numberFormat = new Intl.NumberFormat([
                current.value,
                fallback.value
            ], options);
            return numberFormat.format(value);
        };
    }
    function inferDecimalSeparator(current, fallback) {
        const format = createNumberFunction(current, fallback);
        return format(0.1).includes(',') ? ',' : '.';
    }
    function inferNumericGroupSeparator(current, fallback) {
        return new Intl.NumberFormat([
            current.value,
            fallback.value
        ], {
            useGrouping: true
        }).formatToParts(10000).find((p)=>p.type === 'group')?.value ?? "\xa0";
    }
    function useProvided(props, prop, provided) {
        const internal = useProxiedModel(props, prop, props[prop] ?? provided.value);
        // TODO: Remove when defaultValue works
        internal.value = props[prop] ?? provided.value;
        vue.watch(provided, (v)=>{
            if (props[prop] == null) internal.value = provided.value;
        });
        return internal;
    }
    function createProvideFunction(state) {
        return (props)=>{
            const current = useProvided(props, 'locale', state.current);
            const fallback = useProvided(props, 'fallback', state.fallback);
            const messages = useProvided(props, 'messages', state.messages);
            return {
                name: 'vuetify',
                current: current,
                fallback: fallback,
                messages: messages,
                decimalSeparator: vue.toRef(()=>inferDecimalSeparator(current, fallback)),
                numericGroupSeparator: vue.toRef(()=>inferNumericGroupSeparator(current, fallback)),
                t: createTranslateFunction(current, fallback, messages),
                n: createNumberFunction(current, fallback),
                provide: createProvideFunction({
                    current: current,
                    fallback: fallback,
                    messages: messages
                })
            };
        };
    }
    function createVuetifyAdapter(options) {
        const current = vue.shallowRef(options?.locale ?? 'en');
        const fallback = vue.shallowRef(options?.fallback ?? 'en');
        const messages = vue.ref({
            en: en,
            ...options?.messages
        });
        return {
            name: 'vuetify',
            current: current,
            fallback: fallback,
            messages: messages,
            decimalSeparator: vue.toRef(()=>options?.decimalSeparator ?? inferDecimalSeparator(current, fallback)),
            numericGroupSeparator: vue.toRef(()=>options?.numericGroupSeparator ?? inferNumericGroupSeparator(current, fallback)),
            t: createTranslateFunction(current, fallback, messages),
            n: createNumberFunction(current, fallback),
            provide: createProvideFunction({
                current: current,
                fallback: fallback,
                messages: messages
            })
        };
    }
    // Utilities
    // Types
    const LocaleSymbol = Symbol.for('vuetify:locale');
    function isLocaleInstance(obj) {
        return obj.name != null;
    }
    function createLocale(options) {
        const i18n = options?.adapter && isLocaleInstance(options?.adapter) ? options?.adapter : createVuetifyAdapter(options);
        const rtl = createRtl(i18n, options);
        return {
            ...i18n,
            ...rtl
        };
    }
    function useLocale() {
        const locale = vue.inject(LocaleSymbol);
        if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
        return locale;
    }
    function provideLocale(props) {
        const locale = vue.inject(LocaleSymbol);
        if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
        const i18n = locale.provide(props);
        const rtl = provideRtl(i18n, locale.rtl, props);
        const data = {
            ...i18n,
            ...rtl
        };
        vue.provide(LocaleSymbol, data);
        return data;
    }
    function genDefaults$3() {
        return {
            af: false,
            ar: true,
            bg: false,
            ca: false,
            ckb: true,
            cs: false,
            de: false,
            el: false,
            en: false,
            es: false,
            et: false,
            fa: true,
            fi: false,
            fr: false,
            hr: false,
            hu: false,
            he: true,
            id: false,
            it: false,
            ja: false,
            km: false,
            ko: false,
            lv: false,
            lt: false,
            nl: false,
            no: false,
            pl: false,
            pt: false,
            ro: false,
            ru: false,
            sk: false,
            sl: false,
            srCyrl: false,
            srLatn: false,
            sv: false,
            th: false,
            tr: false,
            az: false,
            uk: false,
            vi: false,
            zhHans: false,
            zhHant: false
        };
    }
    function createRtl(i18n, options) {
        const rtl = vue.ref(options?.rtl ?? genDefaults$3());
        const isRtl = vue.computed(()=>rtl.value[i18n.current.value] ?? false);
        return {
            isRtl: isRtl,
            rtl: rtl,
            rtlClasses: vue.toRef(()=>`v-locale--is-${isRtl.value ? 'rtl' : 'ltr'}`)
        };
    }
    function provideRtl(locale, rtl, props) {
        const isRtl = vue.computed(()=>props.rtl ?? rtl.value[locale.current.value] ?? false);
        return {
            isRtl: isRtl,
            rtl: rtl,
            rtlClasses: vue.toRef(()=>`v-locale--is-${isRtl.value ? 'rtl' : 'ltr'}`)
        };
    }
    function useRtl() {
        const locale = vue.inject(LocaleSymbol);
        if (!locale) throw new Error('[Vuetify] Could not find injected rtl instance');
        return {
            isRtl: locale.isRtl,
            rtlClasses: locale.rtlClasses
        };
    }
    // Utilities
    // Types
    const ThemeSymbol = Symbol.for('vuetify:theme');
    const makeThemeProps = propsFactory({
        theme: String
    }, 'theme');
    function genDefaults$2() {
        return {
            defaultTheme: 'system',
            prefix: 'v-',
            variations: {
                colors: [],
                lighten: 0,
                darken: 0
            },
            themes: {
                light: {
                    dark: false,
                    colors: {
                        background: '#FFFFFF',
                        surface: '#FFFFFF',
                        'surface-bright': '#FFFFFF',
                        'surface-light': '#EEEEEE',
                        'surface-variant': '#424242',
                        'on-surface-variant': '#EEEEEE',
                        primary: '#1867C0',
                        'primary-darken-1': '#1F5592',
                        secondary: '#48A9A6',
                        'secondary-darken-1': '#018786',
                        error: '#B00020',
                        info: '#2196F3',
                        success: '#4CAF50',
                        warning: '#FB8C00'
                    },
                    variables: {
                        'border-color': '#000000',
                        'border-opacity': 0.12,
                        'shadow-color': '#000000',
                        'high-emphasis-opacity': 0.87,
                        'medium-emphasis-opacity': 0.60,
                        'disabled-opacity': 0.38,
                        'idle-opacity': 0.04,
                        'hover-opacity': 0.04,
                        'focus-opacity': 0.12,
                        'selected-opacity': 0.08,
                        'activated-opacity': 0.12,
                        'pressed-opacity': 0.12,
                        'dragged-opacity': 0.08,
                        'theme-kbd': '#EEEEEE',
                        'theme-on-kbd': '#000000',
                        'theme-code': '#F5F5F5',
                        'theme-on-code': '#000000',
                        'theme-on-dark': '#FFF',
                        'theme-on-light': '#000',
                        'elevation-overlay-color': 'black',
                        'elevation-overlay-opacity-step': '2%',
                        'highlight-opacity': '8%'
                    }
                },
                dark: {
                    dark: true,
                    colors: {
                        background: '#121212',
                        surface: '#212121',
                        'surface-bright': '#ccbfd6',
                        'surface-light': '#424242',
                        'surface-variant': '#c8c8c8',
                        'on-surface-variant': '#000000',
                        primary: '#2196F3',
                        'primary-darken-1': '#277CC1',
                        secondary: '#54B6B2',
                        'secondary-darken-1': '#48A9A6',
                        error: '#CF6679',
                        info: '#2196F3',
                        success: '#4CAF50',
                        warning: '#FB8C00'
                    },
                    variables: {
                        'border-color': '#FFFFFF',
                        'border-opacity': 0.12,
                        'shadow-color': '#000000',
                        'high-emphasis-opacity': 1,
                        'medium-emphasis-opacity': 0.70,
                        'disabled-opacity': 0.50,
                        'idle-opacity': 0.10,
                        'hover-opacity': 0.04,
                        'focus-opacity': 0.12,
                        'selected-opacity': 0.08,
                        'activated-opacity': 0.12,
                        'pressed-opacity': 0.16,
                        'dragged-opacity': 0.08,
                        'theme-kbd': '#424242',
                        'theme-on-kbd': '#FFFFFF',
                        'theme-code': '#343434',
                        'theme-on-code': '#CCCCCC',
                        'theme-on-dark': '#FFF',
                        'theme-on-light': '#000',
                        'elevation-overlay-color': 'white',
                        'elevation-overlay-opacity-step': '2%',
                        'highlight-opacity': '20%'
                    }
                }
            },
            stylesheetId: 'vuetify-theme-stylesheet',
            scoped: false,
            utilities: true,
            transition: false
        };
    }
    function parseThemeOptions(options = genDefaults$2()) {
        const defaults = genDefaults$2();
        if (!options) return {
            ...defaults,
            isDisabled: true
        };
        return mergeDeep(defaults, options);
    }
    function createCssClass(lines, selector, content, scope) {
        lines.push(`${getScopedSelector(selector, scope)} {\n`, ...content.map((line)=>`  ${line};\n`), '}\n');
    }
    function genCssVariables(theme, prefix) {
        const lightOverlay = theme.dark ? 2 : 1;
        const darkOverlay = theme.dark ? 1 : 2;
        const variables = [];
        for (const [key, value] of Object.entries(theme.colors)){
            const rgb = parseColor(value);
            variables.push(`--${prefix}theme-${key}: ${rgb.r},${rgb.g},${rgb.b}` + (rgb.a == null ? '' : `,${rgb.a}`));
            if (!key.startsWith('on-')) variables.push(`--${prefix}theme-${key}-overlay-multiplier: ${getLuma(value) > 0.18 ? lightOverlay : darkOverlay}`);
        }
        for (const [key, value] of Object.entries(theme.variables)){
            const color = typeof value === 'string' && value.startsWith('#') ? parseColor(value) : undefined;
            const rgb = color ? `${color.r}, ${color.g}, ${color.b}` + (color.a == null ? '' : `, ${color.a}`) : undefined;
            variables.push(`--${prefix}${key}: ${rgb ?? value}`);
        }
        return variables;
    }
    function genVariation(name, color, variations) {
        const object = {};
        if (variations) for (const variation of [
            'lighten',
            'darken'
        ]){
            const fn = variation === 'lighten' ? lighten : darken;
            for (const amount of createRange(variations[variation], 1))object[`${name}-${variation}-${amount}`] = RGBtoHex(fn(parseColor(color), amount));
        }
        return object;
    }
    function genVariations(colors, variations) {
        if (!variations) return {};
        let variationColors = {};
        for (const name of variations.colors){
            const color = colors[name];
            if (!color) continue;
            variationColors = {
                ...variationColors,
                ...genVariation(name, color, variations)
            };
        }
        return variationColors;
    }
    function genOnColors(colors, variables) {
        const onColors = {};
        for (const color of Object.keys(colors)){
            if (color.startsWith('on-') || colors[`on-${color}`]) continue;
            const onColor = `on-${color}`;
            const colorVal = parseColor(colors[color]);
            onColors[onColor] = hasLightForeground(colorVal) ? variables['theme-on-dark'] : variables['theme-on-light'];
        }
        return onColors;
    }
    function getScopedSelector(selector, scope) {
        if (!scope) return selector;
        const scopeSelector = `:where(${scope})`;
        return selector === ':root' ? scopeSelector : `${scopeSelector} ${selector}`;
    }
    function upsertStyles(id, cspNonce, styles) {
        const styleEl = getOrCreateStyleElement(id, cspNonce);
        if (!styleEl) return;
        styleEl.innerHTML = styles;
    }
    function getOrCreateStyleElement(id, cspNonce) {
        if (!IN_BROWSER) return null;
        let style = document.getElementById(id);
        if (!style) {
            style = document.createElement('style');
            style.id = id;
            style.type = 'text/css';
            if (cspNonce) style.setAttribute('nonce', cspNonce);
            document.head.appendChild(style);
        }
        return style;
    }
    // Composables
    function createTheme(options) {
        const parsedOptions = parseThemeOptions(options);
        const _name = vue.shallowRef(parsedOptions.defaultTheme);
        const themes = vue.ref(parsedOptions.themes);
        const systemName = vue.shallowRef('light');
        const name = vue.computed({
            get () {
                return _name.value === 'system' ? systemName.value : _name.value;
            },
            set (val) {
                _name.value = val;
            }
        });
        const computedThemes = vue.computed(()=>{
            const acc = {};
            for (const [name, original] of Object.entries(themes.value)){
                const defaultTheme = original.dark || name === 'dark' ? themes.value.dark : themes.value.light;
                const merged = mergeDeep(defaultTheme, original);
                const colors = {
                    ...merged.colors,
                    ...genVariations(merged.colors, parsedOptions.variations)
                };
                acc[name] = {
                    ...merged,
                    colors: {
                        ...colors,
                        ...genOnColors(colors, merged.variables)
                    }
                };
            }
            return acc;
        });
        const current = vue.toRef(()=>computedThemes.value[name.value]);
        const isSystem = vue.toRef(()=>_name.value === 'system');
        const styles = vue.computed(()=>{
            const lines = [];
            const scoped = parsedOptions.scoped ? parsedOptions.prefix : '';
            lines.push('@layer theme-base {\n');
            createCssClass(lines, ':root', [
                `color-scheme: ${current.value?.dark ? 'dark' : 'light'}`
            ], parsedOptions.scope);
            createCssClass(lines, ':root', genCssVariables(current.value, parsedOptions.prefix), parsedOptions.scope);
            for (const [themeName, theme] of Object.entries(computedThemes.value))createCssClass(lines, `.${parsedOptions.prefix}theme--${themeName}`, [
                `color-scheme: ${theme.dark ? 'dark' : 'light'}`,
                ...genCssVariables(theme, parsedOptions.prefix)
            ], parsedOptions.scope);
            lines.push('}\n');
            if (parsedOptions.utilities) {
                const bgLines = [];
                const fgLines = [];
                const colors = new Set(Object.values(computedThemes.value).flatMap((theme)=>Object.keys(theme.colors)));
                for (const key of colors)if (key.startsWith('on-')) createCssClass(fgLines, `.${key}`, [
                    `color: rgb(var(--${parsedOptions.prefix}theme-${key}))`
                ], parsedOptions.scope);
                else {
                    createCssClass(bgLines, `.${scoped}bg-${key}`, [
                        `--${parsedOptions.prefix}theme-overlay-multiplier: var(--${parsedOptions.prefix}theme-${key}-overlay-multiplier)`,
                        `background-color: rgb(var(--${parsedOptions.prefix}theme-${key}))`,
                        `color: rgb(var(--${parsedOptions.prefix}theme-on-${key}))`
                    ], parsedOptions.scope);
                    createCssClass(fgLines, `.${scoped}text-${key}`, [
                        `color: rgb(var(--${parsedOptions.prefix}theme-${key}))`
                    ], parsedOptions.scope);
                    createCssClass(fgLines, `.${scoped}border-${key}`, [
                        `--${parsedOptions.prefix}border-color: var(--${parsedOptions.prefix}theme-${key})`
                    ], parsedOptions.scope);
                }
                lines.push('@layer theme-background {\n', ...bgLines.map((v)=>`  ${v}`), '}\n', '@layer theme-foreground {\n', ...fgLines.map((v)=>`  ${v}`), '}\n');
            }
            return '@layer vuetify-utilities {\n' + lines.map((v)=>`  ${v}`).join('') + '\n}';
        });
        const themeClasses = vue.toRef(()=>parsedOptions.isDisabled ? undefined : `${parsedOptions.prefix}theme--${name.value}`);
        const themeNames = vue.toRef(()=>Object.keys(computedThemes.value));
        if (SUPPORTS_MATCH_MEDIA) {
            const media = window.matchMedia('(prefers-color-scheme: dark)');
            function updateSystemName() {
                systemName.value = media.matches ? 'dark' : 'light';
            }
            updateSystemName();
            media.addEventListener('change', updateSystemName, {
                passive: true
            });
            if (vue.getCurrentScope()) vue.onScopeDispose(()=>{
                media.removeEventListener('change', updateSystemName);
            });
        }
        function install(app) {
            if (parsedOptions.isDisabled) return;
            const head = app._context.provides.usehead;
            if (head) {
                function getHead() {
                    return {
                        style: [
                            {
                                textContent: styles.value,
                                id: parsedOptions.stylesheetId,
                                nonce: parsedOptions.cspNonce || false,
                                tagPosition: 'bodyOpen'
                            }
                        ]
                    };
                }
                if (head.push) {
                    const entry = head.push(getHead);
                    if (IN_BROWSER) vue.watch(styles, ()=>{
                        entry.patch(getHead);
                    });
                } else if (IN_BROWSER) {
                    head.addHeadObjs(vue.toRef(getHead));
                    vue.watchEffect(()=>head.updateDOM());
                } else head.addHeadObjs(getHead());
            } else {
                if (IN_BROWSER) vue.watch(styles, updateStyles, {
                    immediate: true
                });
                else updateStyles();
                function updateStyles() {
                    upsertStyles(parsedOptions.stylesheetId, parsedOptions.cspNonce, styles.value);
                }
            }
        }
        let _transitionOrigin;
        function setTransitionOrigin(e) {
            if (!e) {
                _transitionOrigin = null;
                return;
            }
            let x;
            let y;
            if (e instanceof Element) {
                const box = new Box(e);
                x = box.left + box.width / 2;
                y = box.top + box.height / 2;
            } else {
                x = e.clientX;
                y = e.clientY;
            }
            const originX = Math.min(98.9, 100 * x / window.innerWidth); // clip to avoid glitches
            const originY = 100 * y / window.innerHeight;
            _transitionOrigin = `${originX.toFixed(2)}% ${originY.toFixed(2)}%`;
        }
        function resolveTransitionOptions(transition) {
            const opt = transition ?? parsedOptions.transition;
            if (!opt && !_transitionOrigin) return false;
            const global = typeof parsedOptions.transition === 'object' ? parsedOptions.transition : {};
            const local = typeof transition === 'object' ? transition : {};
            return {
                origin: local.origin ?? _transitionOrigin ?? global.origin,
                duration: local.duration ?? global.duration
            };
        }
        function withPageTransition(callback, options) {
            if (!IN_BROWSER || !document.startViewTransition || PREFERS_REDUCED_MOTION()) {
                callback();
                return Promise.resolve();
            }
            const origin = options.origin ?? '50% 0%';
            const duration = options.duration ?? '500ms';
            const style = document.createElement('style');
            style.textContent = `html:active-view-transition-type(vuetify-theme)::view-transition-old(root) { animation: none; }` + `html:active-view-transition-type(vuetify-theme)::view-transition-new(root) { animation: v-circle-in ${duration} ease-in-out; }` + `@keyframes v-circle-in {` + `  from { clip-path: circle(0% at ${origin}); }` + `  to { clip-path: circle(150% at ${origin}); }` + `}`;
            document.head.appendChild(style);
            const transition = document.startViewTransition({
                update: ()=>callback(),
                types: [
                    'vuetify-theme'
                ]
            });
            transition.finished.then(()=>{
                _transitionOrigin = null;
                style.remove();
            });
            return transition.updateCallbackDone;
        }
        function change(themeName, transition) {
            if (themeName !== 'system' && !themeNames.value.includes(themeName)) {
                consoleWarn(`Theme "${themeName}" not found on the Vuetify theme instance`);
                return Promise.resolve();
            }
            const apply = ()=>{
                name.value = themeName;
            };
            const transitionOptions = resolveTransitionOptions(transition);
            if (transitionOptions) return withPageTransition(apply, transitionOptions);
            apply();
            return Promise.resolve();
        }
        function cycle(themeArray = themeNames.value, transition) {
            const currentIndex = themeArray.indexOf(name.value);
            const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % themeArray.length;
            return change(themeArray[nextIndex], transition);
        }
        function toggle(themeArray = [
            'light',
            'dark'
        ], transition) {
            return cycle(themeArray, transition);
        }
        const globalName = new Proxy(name, {
            get (target, prop) {
                return Reflect.get(target, prop);
            },
            set (target, prop, val) {
                if (prop === 'value') deprecate(`theme.global.name.value = ${val}`, `theme.change('${val}')`);
                return Reflect.set(target, prop, val);
            }
        });
        return {
            install: install,
            change: change,
            cycle: cycle,
            toggle: toggle,
            setTransitionOrigin: setTransitionOrigin,
            isDisabled: parsedOptions.isDisabled,
            isSystem: isSystem,
            name: name,
            themes: themes,
            current: current,
            computedThemes: computedThemes,
            prefix: parsedOptions.prefix,
            themeClasses: themeClasses,
            styles: styles,
            global: {
                name: globalName,
                current: current
            }
        };
    }
    function provideTheme(props) {
        getCurrentInstance('provideTheme');
        const theme = vue.inject(ThemeSymbol, null);
        if (!theme) throw new Error('Could not find Vuetify theme injection');
        const name = vue.toRef(()=>props.theme ?? theme.name.value);
        const current = vue.toRef(()=>theme.computedThemes.value[name.value]);
        const themeClasses = vue.toRef(()=>theme.isDisabled ? undefined : `${theme.prefix}theme--${name.value}`);
        const newTheme = {
            ...theme,
            name: name,
            current: current,
            themeClasses: themeClasses
        };
        vue.provide(ThemeSymbol, newTheme);
        return newTheme;
    }
    function useTheme() {
        getCurrentInstance('useTheme');
        const theme = vue.inject(ThemeSymbol, null);
        if (!theme) throw new Error('Could not find Vuetify theme injection');
        return theme;
    }
    const makeVAppProps = propsFactory({
        ...makeComponentProps(),
        ...omit(makeLayoutProps(), [
            'fullHeight'
        ]),
        ...makeThemeProps()
    }, 'VApp');
    const VApp = genericComponent()({
        name: 'VApp',
        props: makeVAppProps(),
        setup (props, { slots: slots }) {
            const theme = provideTheme(props);
            const { layoutClasses: layoutClasses, getLayoutItem: getLayoutItem, items: items, layoutRef: layoutRef } = createLayout({
                ...props,
                fullHeight: true
            });
            const { rtlClasses: rtlClasses } = useRtl();
            useRender(()=>vue.createElementVNode("div", {
                    "ref": layoutRef,
                    "class": vue.normalizeClass([
                        'v-application',
                        theme.themeClasses.value,
                        layoutClasses.value,
                        rtlClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        props.style
                    ])
                }, [
                    vue.createElementVNode("div", {
                        "class": "v-application__wrap"
                    }, [
                        slots.default?.()
                    ])
                ]));
            return {
                getLayoutItem: getLayoutItem,
                items: items,
                theme: theme
            };
        }
    });
    // Utilities
    // Types
    // Types
    // Composables
    const makeTagProps = propsFactory({
        tag: {
            type: [
                String,
                Object,
                Function
            ],
            default: 'div'
        }
    }, 'tag');
    const makeVToolbarTitleProps = propsFactory({
        text: String,
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VToolbarTitle');
    const VToolbarTitle = genericComponent()({
        name: 'VToolbarTitle',
        props: makeVToolbarTitleProps(),
        setup (props, { slots: slots }) {
            useRender(()=>{
                const hasText = !!(slots.default || slots.text || props.text);
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-toolbar-title',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, {
                    default: ()=>[
                            hasText && vue.createElementVNode("div", {
                                "class": "v-toolbar-title__placeholder"
                            }, [
                                slots.text ? slots.text() : props.text,
                                slots.default?.()
                            ])
                        ]
                });
            });
            return {};
        }
    });
    // Utilities
    // Types
    const makeTransitionProps$1 = propsFactory({
        disabled: Boolean,
        group: Boolean,
        hideOnLeave: Boolean,
        leaveAbsolute: Boolean,
        mode: String,
        origin: String
    }, 'transition');
    function createCssTransition(name, origin, mode) {
        return genericComponent()({
            name: name,
            props: makeTransitionProps$1({
                mode: mode,
                origin: origin
            }),
            setup (props, { slots: slots }) {
                const functions = {
                    onBeforeEnter (el) {
                        if (props.origin) el.style.transformOrigin = props.origin;
                    },
                    onLeave (el) {
                        if (props.leaveAbsolute) {
                            const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = el;
                            el._transitionInitialStyles = {
                                position: el.style.position,
                                top: el.style.top,
                                left: el.style.left,
                                width: el.style.width,
                                height: el.style.height
                            };
                            el.style.position = 'absolute';
                            el.style.top = `${offsetTop}px`;
                            el.style.left = `${offsetLeft}px`;
                            el.style.width = `${offsetWidth}px`;
                            el.style.height = `${offsetHeight}px`;
                        }
                        if (props.hideOnLeave) el.style.setProperty('display', 'none', 'important');
                    },
                    onAfterLeave (el) {
                        if (props.leaveAbsolute && el?._transitionInitialStyles) {
                            const { position: position, top: top, left: left, width: width, height: height } = el._transitionInitialStyles;
                            delete el._transitionInitialStyles;
                            el.style.position = position || '';
                            el.style.top = top || '';
                            el.style.left = left || '';
                            el.style.width = width || '';
                            el.style.height = height || '';
                        }
                    }
                };
                return ()=>{
                    const tag = props.group ? vue.TransitionGroup : vue.Transition;
                    return vue.h(tag, {
                        name: props.disabled ? '' : name,
                        css: !props.disabled,
                        ...props.group ? undefined : {
                            mode: props.mode
                        },
                        ...props.disabled ? {} : functions
                    }, slots.default);
                };
            }
        });
    }
    function createJavascriptTransition(name, functions, mode = 'in-out') {
        return genericComponent()({
            name: name,
            props: {
                mode: {
                    type: String,
                    default: mode
                },
                disabled: {
                    type: Boolean,
                    default: PREFERS_REDUCED_MOTION()
                },
                group: Boolean,
                hideOnLeave: Boolean
            },
            setup (props, { slots: slots }) {
                const tag = props.group ? vue.TransitionGroup : vue.Transition;
                return ()=>{
                    return vue.h(tag, {
                        name: props.disabled ? '' : name,
                        css: !props.disabled,
                        // mode: props.mode, // TODO: vuejs/vue-next#3104
                        ...props.disabled ? {} : {
                            ...functions,
                            onLeave: (el)=>{
                                if (props.hideOnLeave) el.style.setProperty('display', 'none', 'important');
                                else functions.onLeave?.(el);
                            }
                        }
                    }, slots.default);
                };
            }
        });
    }
    function ExpandTransitionGenerator(expandedParentClass = '', type = 'y') {
        return {
            onBeforeEnter (el) {
                el._parent = el.parentNode;
                el._initialStyle = {
                    transition: el.style.transition,
                    overflow: el.style.overflow,
                    width: el.style.width,
                    height: el.style.height
                };
            },
            onEnter (el) {
                const initialStyle = el._initialStyle;
                if (!initialStyle) return;
                el.style.setProperty('transition', 'none', 'important');
                // Hide overflow to account for collapsed margins in the calculated height
                el.style.overflow = 'hidden';
                const offsetWidth = `${el.offsetWidth}px`;
                const offsetHeight = `${el.offsetHeight}px`;
                if ([
                    'x',
                    'both'
                ].includes(type)) el.style.width = '0';
                if ([
                    'y',
                    'both'
                ].includes(type)) el.style.height = '0';
                el.offsetHeight; // force reflow
                el.style.transition = initialStyle.transition;
                if (expandedParentClass && el._parent) el._parent.classList.add(expandedParentClass);
                requestAnimationFrame(()=>{
                    if ([
                        'x',
                        'both'
                    ].includes(type)) el.style.width = offsetWidth;
                    if ([
                        'y',
                        'both'
                    ].includes(type)) el.style.height = offsetHeight;
                });
            },
            onAfterEnter: resetStyles,
            onEnterCancelled: resetStyles,
            onLeave (el) {
                el._initialStyle = {
                    transition: '',
                    overflow: el.style.overflow,
                    width: el.style.width,
                    height: el.style.height
                };
                el.style.overflow = 'hidden';
                if ([
                    'x',
                    'both'
                ].includes(type)) el.style.width = `${el.offsetWidth}px`;
                if ([
                    'y',
                    'both'
                ].includes(type)) el.style.height = `${el.offsetHeight}px`;
                el.offsetHeight; // force reflow
                requestAnimationFrame(()=>{
                    if ([
                        'x',
                        'both'
                    ].includes(type)) el.style.width = '0';
                    if ([
                        'y',
                        'both'
                    ].includes(type)) el.style.height = '0';
                });
            },
            onAfterLeave: onAfterLeave,
            onLeaveCancelled: onAfterLeave
        };
        function onAfterLeave(el) {
            if (expandedParentClass && el._parent) el._parent.classList.remove(expandedParentClass);
            resetStyles(el);
        }
        function resetStyles(el) {
            if (!el._initialStyle) return;
            const { width: w, height: h } = el._initialStyle;
            el.style.overflow = el._initialStyle.overflow;
            if (w != null && [
                'x',
                'both'
            ].includes(type)) el.style.width = w;
            if (h != null && [
                'y',
                'both'
            ].includes(type)) el.style.height = h;
            delete el._initialStyle;
        }
    }
    // Utilities
    // Types
    const makeVDialogTransitionProps = propsFactory({
        target: [
            Object,
            Array
        ]
    }, 'v-dialog-transition');
    const saved = new WeakMap();
    const VDialogTransition = genericComponent()({
        name: 'VDialogTransition',
        props: makeVDialogTransitionProps(),
        setup (props, { slots: slots }) {
            const functions = {
                onBeforeEnter (el) {
                    el.style.pointerEvents = 'none';
                    el.style.visibility = 'hidden';
                },
                async onEnter (el, done) {
                    await new Promise((resolve)=>requestAnimationFrame(resolve));
                    await new Promise((resolve)=>requestAnimationFrame(resolve));
                    el.style.visibility = '';
                    const dimensions = getDimensions(props.target, el);
                    const { x: x, y: y, sx: sx, sy: sy, speed: speed } = dimensions;
                    saved.set(el, dimensions);
                    if (PREFERS_REDUCED_MOTION()) animate(el, [
                        {
                            opacity: 0
                        },
                        {}
                    ], {
                        duration: 125 * speed,
                        easing: deceleratedEasing
                    }).finished.then(()=>done());
                    else {
                        const animation = animate(el, [
                            {
                                transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
                                opacity: 0
                            },
                            {}
                        ], {
                            duration: 225 * speed,
                            easing: deceleratedEasing
                        });
                        getChildren(el)?.forEach((el)=>{
                            animate(el, [
                                {
                                    opacity: 0
                                },
                                {
                                    opacity: 0,
                                    offset: 0.33
                                },
                                {}
                            ], {
                                duration: 225 * 2 * speed,
                                easing: standardEasing
                            });
                        });
                        animation.finished.then(()=>done());
                    }
                },
                onAfterEnter (el) {
                    el.style.removeProperty('pointer-events');
                },
                onBeforeLeave (el) {
                    el.style.pointerEvents = 'none';
                },
                async onLeave (el, done) {
                    await new Promise((resolve)=>requestAnimationFrame(resolve));
                    let dimensions;
                    if (!saved.has(el) || Array.isArray(props.target) || props.target.offsetParent || props.target.getClientRects().length) dimensions = getDimensions(props.target, el);
                    else dimensions = saved.get(el);
                    const { x: x, y: y, sx: sx, sy: sy, speed: speed } = dimensions;
                    if (PREFERS_REDUCED_MOTION()) animate(el, [
                        {},
                        {
                            opacity: 0
                        }
                    ], {
                        duration: 85 * speed,
                        easing: acceleratedEasing
                    }).finished.then(()=>done());
                    else {
                        const animation = animate(el, [
                            {},
                            {
                                transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
                                opacity: 0
                            }
                        ], {
                            duration: 125 * speed,
                            easing: acceleratedEasing
                        });
                        animation.finished.then(()=>done());
                        getChildren(el)?.forEach((el)=>{
                            animate(el, [
                                {},
                                {
                                    opacity: 0,
                                    offset: 0.2
                                },
                                {
                                    opacity: 0
                                }
                            ], {
                                duration: 125 * 2 * speed,
                                easing: standardEasing
                            });
                        });
                    }
                },
                onAfterLeave (el) {
                    el.style.removeProperty('pointer-events');
                }
            };
            return ()=>{
                return props.target ? vue.createVNode(vue.Transition, vue.mergeProps({
                    "name": "dialog-transition"
                }, functions, {
                    "css": false
                }), slots) : vue.createVNode(vue.Transition, {
                    "name": "dialog-transition"
                }, slots);
            };
        }
    });
    /** Animatable children (card, sheet, list) */ function getChildren(el) {
        const els = el.querySelector(':scope > .v-card, :scope > .v-sheet, :scope > .v-list')?.children;
        return els && [
            ...els
        ];
    }
    function getDimensions(target, el) {
        const targetBox = getTargetBox(target);
        const elBox = nullifyTransforms(el);
        const [originX, originY] = getComputedStyle(el).transformOrigin.split(' ').map((v)=>parseFloat(v));
        const [anchorSide, anchorOffset] = getComputedStyle(el).getPropertyValue('--v-overlay-anchor-origin').split(' ');
        let offsetX = targetBox.left + targetBox.width / 2;
        if (anchorSide === 'left' || anchorOffset === 'left') offsetX -= targetBox.width / 2;
        else if (anchorSide === 'right' || anchorOffset === 'right') offsetX += targetBox.width / 2;
        let offsetY = targetBox.top + targetBox.height / 2;
        if (anchorSide === 'top' || anchorOffset === 'top') offsetY -= targetBox.height / 2;
        else if (anchorSide === 'bottom' || anchorOffset === 'bottom') offsetY += targetBox.height / 2;
        const tsx = targetBox.width / elBox.width;
        const tsy = targetBox.height / elBox.height;
        const maxs = Math.max(1, tsx, tsy);
        const sx = tsx / maxs || 0;
        const sy = tsy / maxs || 0;
        // Animate elements larger than 12% of the screen area up to 1.5x slower
        const asa = elBox.width * elBox.height / (window.innerWidth * window.innerHeight);
        const speed = asa > 0.12 ? Math.min(1.5, (asa - 0.12) * 10 + 1) : 1;
        return {
            x: offsetX - (originX + elBox.left),
            y: offsetY - (originY + elBox.top),
            sx: sx,
            sy: sy,
            speed: speed
        };
    }
    // Component specific transitions
    const VFabTransition = createCssTransition('fab-transition', 'center center', 'out-in');
    // Generic transitions
    const VDialogBottomTransition = createCssTransition('dialog-bottom-transition');
    const VDialogTopTransition = createCssTransition('dialog-top-transition');
    const VFadeTransition = createCssTransition('fade-transition');
    const VScaleTransition = createCssTransition('scale-transition');
    const VScrollXTransition = createCssTransition('scroll-x-transition');
    const VScrollXReverseTransition = createCssTransition('scroll-x-reverse-transition');
    const VScrollYTransition = createCssTransition('scroll-y-transition');
    const VScrollYReverseTransition = createCssTransition('scroll-y-reverse-transition');
    const VSlideXTransition = createCssTransition('slide-x-transition');
    const VSlideXReverseTransition = createCssTransition('slide-x-reverse-transition');
    const VSlideYTransition = createCssTransition('slide-y-transition');
    const VSlideYReverseTransition = createCssTransition('slide-y-reverse-transition');
    // Javascript transitions
    const VExpandTransition = createJavascriptTransition('expand-transition', ExpandTransitionGenerator());
    const VExpandXTransition = createJavascriptTransition('expand-x-transition', ExpandTransitionGenerator('', 'x'));
    const VExpandBothTransition = createJavascriptTransition('expand-both-transition', ExpandTransitionGenerator('', 'both'));
    // Composables
    // Types
    const makeVDefaultsProviderProps = propsFactory({
        defaults: Object,
        disabled: Boolean,
        reset: [
            Number,
            String
        ],
        root: [
            Boolean,
            String
        ],
        scoped: Boolean
    }, 'VDefaultsProvider');
    const VDefaultsProvider = genericComponent(false)({
        name: 'VDefaultsProvider',
        props: makeVDefaultsProviderProps(),
        setup (props, { slots: slots }) {
            const { defaults: defaults, disabled: disabled, reset: reset, root: root, scoped: scoped } = vue.toRefs(props);
            provideDefaults(defaults, {
                reset: reset,
                root: root,
                scoped: scoped,
                disabled: disabled
            });
            return ()=>slots.default?.();
        }
    });
    // Utilities
    // Types
    // Composables
    const makeDimensionProps = propsFactory({
        height: [
            Number,
            String
        ],
        maxHeight: [
            Number,
            String
        ],
        maxWidth: [
            Number,
            String
        ],
        minHeight: [
            Number,
            String
        ],
        minWidth: [
            Number,
            String
        ],
        width: [
            Number,
            String
        ]
    }, 'dimension');
    function useDimension(props) {
        const dimensionStyles = vue.computed(()=>{
            const styles = {};
            const height = convertToUnit(props.height);
            const maxHeight = convertToUnit(props.maxHeight);
            const maxWidth = convertToUnit(props.maxWidth);
            const minHeight = convertToUnit(props.minHeight);
            const minWidth = convertToUnit(props.minWidth);
            const width = convertToUnit(props.width);
            if (height != null) styles.height = height;
            if (maxHeight != null) styles.maxHeight = maxHeight;
            if (maxWidth != null) styles.maxWidth = maxWidth;
            if (minHeight != null) styles.minHeight = minHeight;
            if (minWidth != null) styles.minWidth = minWidth;
            if (width != null) styles.width = width;
            return styles;
        });
        return {
            dimensionStyles: dimensionStyles
        };
    }
    function useAspectStyles(props) {
        return {
            aspectStyles: vue.computed(()=>{
                const ratio = Number(props.aspectRatio);
                return ratio ? {
                    paddingBottom: String(1 / ratio * 100) + '%'
                } : undefined;
            })
        };
    }
    const makeVResponsiveProps = propsFactory({
        aspectRatio: [
            String,
            Number
        ],
        contentClass: null,
        inline: Boolean,
        ...makeComponentProps(),
        ...makeDimensionProps()
    }, 'VResponsive');
    const VResponsive = genericComponent()({
        name: 'VResponsive',
        props: makeVResponsiveProps(),
        setup (props, { slots: slots }) {
            const { aspectStyles: aspectStyles } = useAspectStyles(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-responsive',
                        {
                            'v-responsive--inline': props.inline
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        dimensionStyles.value,
                        props.style
                    ])
                }, [
                    vue.createElementVNode("div", {
                        "class": "v-responsive__sizer",
                        "style": vue.normalizeStyle(aspectStyles.value)
                    }, null),
                    slots.additional?.(),
                    slots.default && vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-responsive__content',
                            props.contentClass
                        ])
                    }, [
                        slots.default()
                    ])
                ]));
            return {};
        }
    });
    // Utilities
    // Types
    // Composables
    function useColor(colors) {
        return destructComputed(()=>{
            const { class: colorClasses, style: colorStyles } = computeColor(colors);
            return {
                colorClasses: colorClasses,
                colorStyles: colorStyles
            };
        });
    }
    function useTextColor(color) {
        const { colorClasses: textColorClasses, colorStyles: textColorStyles } = useColor(()=>({
                text: vue.toValue(color)
            }));
        return {
            textColorClasses: textColorClasses,
            textColorStyles: textColorStyles
        };
    }
    function useBackgroundColor(color) {
        const { colorClasses: backgroundColorClasses, colorStyles: backgroundColorStyles } = useColor(()=>({
                background: vue.toValue(color)
            }));
        return {
            backgroundColorClasses: backgroundColorClasses,
            backgroundColorStyles: backgroundColorStyles
        };
    }
    function normalizeColors(colors) {
        return {
            text: typeof colors.text === 'string' ? colors.text.replace(/^text-/, '') : colors.text,
            background: typeof colors.background === 'string' ? colors.background.replace(/^bg-/, '') : colors.background
        };
    }
    function computeColor(colors) {
        const _colors = normalizeColors(vue.toValue(colors));
        const classes = [];
        const styles = {};
        if (_colors.background) {
            if (isCssColor(_colors.background)) {
                styles.backgroundColor = _colors.background;
                if (!_colors.text && isParsableColor(_colors.background)) {
                    const backgroundColor = parseColor(_colors.background);
                    if (backgroundColor.a == null || backgroundColor.a === 1) classes.push(hasLightForeground(backgroundColor) ? 'v-theme-on-dark' : 'v-theme-on-light');
                }
            } else classes.push(`bg-${_colors.background}`);
        }
        if (_colors.text) {
            if (isCssColor(_colors.text)) {
                styles.color = _colors.text;
                styles.caretColor = _colors.text;
            } else classes.push(`text-${_colors.text}`);
        }
        return {
            class: classes,
            style: styles
        };
    }
    // Utilities
    // Types
    const CSS_LENGTH = /^-?\d*\.?\d+([a-z%]{0,4})$/i;
    function splitTokens(v) {
        return String(v).trim().split(/\s+/);
    }
    function isCssLength(token) {
        return token.toLowerCase().match(CSS_LENGTH)?.at(1)?.startsWith('x') === false;
    }
    function isCssValue(v) {
        return typeof v === 'string' && !!v && (v.includes('(') || splitTokens(v).every(isCssLength));
    }
    // Composables
    const makeRoundedProps = propsFactory({
        rounded: {
            type: [
                Boolean,
                Number,
                String
            ],
            default: undefined
        },
        tile: Boolean
    }, 'rounded');
    function useRounded(props, name = getCurrentInstanceName()) {
        const roundedClasses = vue.computed(()=>{
            const rounded = vue.isRef(props) ? props.value : props.rounded;
            const tile = vue.isRef(props) ? false : props.tile;
            const classes = [];
            if (tile || rounded === false || String(rounded) === '0') classes.push('rounded-0');
            else if (rounded === true || rounded === '') classes.push(`${name}--rounded`);
            else if (typeof rounded === 'string' && !isCssValue(rounded)) for (const value of splitTokens(rounded))classes.push(`rounded-${value}`);
            return classes;
        });
        const roundedStyles = vue.computed(()=>{
            const rounded = vue.isRef(props) ? props.value : props.rounded;
            if ((!isCssValue(rounded) || String(rounded) === '0') && !(typeof rounded === 'number' && rounded !== 0)) return {};
            return {
                borderRadius: convertToUnit(rounded)
            };
        });
        return {
            roundedClasses: roundedClasses,
            roundedStyles: roundedStyles
        };
    }
    // Utilities
    // Types
    const makeTransitionProps = propsFactory({
        transition: {
            type: null,
            default: 'fade-transition',
            validator: (val)=>val !== true
        }
    }, 'transition');
    const MaybeTransition = (props, { slots: slots })=>{
        const { transition: transition, disabled: disabled, group: group, target: target, ...rest } = props;
        const { component: component = group ? vue.TransitionGroup : vue.Transition, ...customProps } = isObject(transition) ? transition : {};
        let transitionProps;
        if (isObject(transition)) transitionProps = vue.mergeProps(customProps, onlyDefinedProps({
            disabled: disabled,
            group: group,
            target: target
        }), rest);
        else transitionProps = vue.mergeProps({
            name: disabled || !transition ? '' : transition
        }, rest);
        return vue.h(component, transitionProps, slots);
    };
    // Utilities
    // Types
    function mounted$5(el, binding) {
        if (!SUPPORTS_INTERSECTION) return;
        const modifiers = binding.modifiers || {};
        const value = binding.value;
        const { handler: handler, options: options } = typeof value === 'object' ? value : {
            handler: value,
            options: {}
        };
        const observer = new IntersectionObserver((entries = [], observer)=>{
            const _observe = el._observe?.[binding.instance.$.uid];
            if (!_observe) return; // Just in case, should never fire
            const isIntersecting = entries.some((entry)=>entry.isIntersecting);
            // If is not quiet or has already been
            // initted, invoke the user callback
            if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) handler(isIntersecting, entries, observer);
            if (isIntersecting && modifiers.once) unmounted$5(el, binding);
            else _observe.init = true;
        }, options);
        el._observe = Object(el._observe);
        el._observe[binding.instance.$.uid] = {
            init: false,
            observer: observer
        };
        observer.observe(el);
    }
    function unmounted$5(el, binding) {
        const observe = el._observe?.[binding.instance.$.uid];
        if (!observe) return;
        observe.observer.unobserve(el);
        delete el._observe[binding.instance.$.uid];
    }
    const Intersect = {
        mounted: mounted$5,
        unmounted: unmounted$5,
        updated: (el, binding)=>{
            if (el._observe?.[binding.instance.$.uid]) {
                unmounted$5(el, binding);
                mounted$5(el, binding);
            }
        }
    };
    // Types
    // not intended for public use, this is passed in by vuetify-loader
    const makeVImgProps = propsFactory({
        absolute: Boolean,
        alt: String,
        cover: Boolean,
        color: String,
        draggable: {
            type: [
                Boolean,
                String
            ],
            default: undefined
        },
        eager: Boolean,
        gradient: String,
        imageClass: null,
        lazySrc: String,
        options: {
            type: Object,
            // For more information on types, navigate to:
            // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
            default: ()=>({
                    root: undefined,
                    rootMargin: undefined,
                    threshold: undefined
                })
        },
        sizes: String,
        src: {
            type: [
                String,
                Object
            ],
            default: ''
        },
        crossorigin: String,
        referrerpolicy: String,
        srcset: String,
        position: String,
        ...makeVResponsiveProps(),
        ...makeComponentProps(),
        ...makeRoundedProps(),
        ...makeTransitionProps()
    }, 'VImg');
    const VImg = genericComponent()({
        name: 'VImg',
        directives: {
            vIntersect: Intersect
        },
        inheritAttrs: false,
        props: makeVImgProps(),
        emits: {
            loadstart: (value)=>true,
            load: (value)=>true,
            error: (value)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const vm = getCurrentInstance('VImg');
            const currentSrc = vue.shallowRef(''); // Set from srcset
            const image = vue.ref();
            const state = vue.shallowRef(props.eager ? 'loading' : 'idle');
            const naturalWidth = vue.shallowRef();
            const naturalHeight = vue.shallowRef();
            let deferredLoadEmit = false;
            const normalisedSrc = vue.computed(()=>{
                return props.src && typeof props.src === 'object' ? {
                    src: props.src.src,
                    srcset: props.srcset || props.src.srcset,
                    lazySrc: props.lazySrc || props.src.lazySrc,
                    aspect: Number(props.aspectRatio || props.src.aspect || 0)
                } : {
                    src: props.src,
                    srcset: props.srcset,
                    lazySrc: props.lazySrc,
                    aspect: Number(props.aspectRatio || 0)
                };
            });
            const aspectRatio = vue.computed(()=>{
                return normalisedSrc.value.aspect || naturalWidth.value / naturalHeight.value || 0;
            });
            vue.watch(()=>props.src, ()=>{
                init(state.value !== 'idle');
            });
            vue.watch(aspectRatio, (val, oldVal)=>{
                if (!val && oldVal && image.value) pollForSize(image.value);
            });
            vue.watch(image, (img)=>{
                if (!img || state.value === 'idle') return;
                if (!aspectRatio.value) pollForSize(img);
                getSrc(img);
                if (deferredLoadEmit) {
                    deferredLoadEmit = false;
                    emit('load', img.currentSrc || normalisedSrc.value.src);
                }
            });
            // TODO: getSrc when window width changes
            vue.onBeforeMount(()=>init());
            function init(isIntersecting) {
                if (props.eager && isIntersecting) return;
                if (SUPPORTS_INTERSECTION && !isIntersecting && !props.eager) return;
                state.value = 'loading';
                if (normalisedSrc.value.lazySrc) {
                    const lazyImg = new Image();
                    lazyImg.src = normalisedSrc.value.lazySrc;
                    pollForSize(lazyImg, null);
                }
                if (!normalisedSrc.value.src) return;
                vue.nextTick(()=>{
                    emit('loadstart', image.value?.currentSrc || normalisedSrc.value.src);
                    setTimeout(()=>{
                        if (vm.isUnmounted) return;
                        if (image.value?.complete) {
                            if (!image.value.naturalWidth) onError();
                            if (state.value === 'error') return;
                            if (!aspectRatio.value) pollForSize(image.value, null);
                            if (state.value === 'loading') onLoad();
                        } else if (image.value) {
                            if (!aspectRatio.value) pollForSize(image.value);
                            getSrc(image.value);
                        }
                    });
                });
            }
            function onLoad() {
                if (vm.isUnmounted) return;
                if (image.value) {
                    getSrc(image.value);
                    pollForSize(image.value);
                    emit('load', image.value.currentSrc || normalisedSrc.value.src);
                } else deferredLoadEmit = true;
                state.value = 'loaded';
            }
            function onError() {
                if (vm.isUnmounted) return;
                state.value = 'error';
                emit('error', image.value?.currentSrc || normalisedSrc.value.src);
            }
            function getSrc(img) {
                currentSrc.value = img.currentSrc || img.src;
            }
            let timer = -1;
            vue.onBeforeUnmount(()=>{
                clearTimeout(timer);
            });
            function pollForSize(img, timeout = 100) {
                const poll = ()=>{
                    clearTimeout(timer);
                    if (vm.isUnmounted) return;
                    const { naturalHeight: imgHeight, naturalWidth: imgWidth } = img;
                    if (imgHeight || imgWidth) {
                        naturalWidth.value = imgWidth;
                        naturalHeight.value = imgHeight;
                    } else if (!img.complete && state.value === 'loading' && timeout != null) timer = window.setTimeout(poll, timeout);
                    else if (img.currentSrc.endsWith('.svg') || img.currentSrc.startsWith('data:image/svg+xml')) {
                        naturalWidth.value = 1;
                        naturalHeight.value = 1;
                    }
                };
                poll();
            }
            const containClasses = vue.toRef(()=>({
                    'v-img__img--cover': props.cover,
                    'v-img__img--contain': !props.cover
                }));
            const __image = ()=>{
                if (!normalisedSrc.value.src || state.value === 'idle') return null;
                const img = vue.createElementVNode("img", {
                    "class": vue.normalizeClass([
                        'v-img__img',
                        containClasses.value,
                        props.imageClass
                    ]),
                    "style": {
                        objectPosition: props.position
                    },
                    "crossorigin": props.crossorigin,
                    "src": normalisedSrc.value.src,
                    "srcset": normalisedSrc.value.srcset,
                    "alt": props.alt,
                    "referrerpolicy": props.referrerpolicy,
                    "draggable": props.draggable,
                    "sizes": props.sizes,
                    "ref": image,
                    "onLoad": onLoad,
                    "onError": onError
                }, null);
                const sources = slots.sources?.();
                return vue.createVNode(MaybeTransition, {
                    "transition": props.transition,
                    "appear": true
                }, {
                    default: ()=>[
                            vue.withDirectives(sources ? vue.createElementVNode("picture", {
                                "class": "v-img__picture"
                            }, [
                                sources,
                                img
                            ]) : img, [
                                [
                                    vue.vShow,
                                    state.value === 'loaded'
                                ]
                            ])
                        ]
                });
            };
            const __preloadImage = ()=>vue.createVNode(MaybeTransition, {
                    "transition": props.transition
                }, {
                    default: ()=>[
                            normalisedSrc.value.lazySrc && state.value !== 'loaded' && vue.createElementVNode("img", {
                                "class": vue.normalizeClass([
                                    'v-img__img',
                                    'v-img__img--preload',
                                    containClasses.value
                                ]),
                                "style": {
                                    objectPosition: props.position
                                },
                                "crossorigin": props.crossorigin,
                                "src": normalisedSrc.value.lazySrc,
                                "alt": props.alt,
                                "referrerpolicy": props.referrerpolicy,
                                "draggable": props.draggable
                            }, null)
                        ]
                });
            const __placeholder = ()=>{
                if (!slots.placeholder) return null;
                return vue.createVNode(MaybeTransition, {
                    "transition": props.transition,
                    "appear": true
                }, {
                    default: ()=>[
                            (state.value === 'loading' || state.value === 'error' && !slots.error) && vue.createElementVNode("div", {
                                "class": "v-img__placeholder"
                            }, [
                                slots.placeholder()
                            ])
                        ]
                });
            };
            const __error = ()=>{
                if (!slots.error) return null;
                return vue.createVNode(MaybeTransition, {
                    "transition": props.transition,
                    "appear": true
                }, {
                    default: ()=>[
                            state.value === 'error' && vue.createElementVNode("div", {
                                "class": "v-img__error"
                            }, [
                                slots.error()
                            ])
                        ]
                });
            };
            const __gradient = ()=>{
                if (!props.gradient) return null;
                return vue.createElementVNode("div", {
                    "class": "v-img__gradient",
                    "style": {
                        backgroundImage: `linear-gradient(${props.gradient})`
                    }
                }, null);
            };
            const isBooted = vue.shallowRef(false);
            {
                const stop = vue.watch(aspectRatio, (val)=>{
                    if (val) {
                        // Doesn't work with nextTick, idk why
                        requestAnimationFrame(()=>{
                            requestAnimationFrame(()=>{
                                isBooted.value = true;
                            });
                        });
                        stop();
                    }
                });
            }
            useRender(()=>{
                const responsiveProps = VResponsive.filterProps(props);
                const [rootAttrs, imageAttrs] = filterInputAttrs(attrs);
                return vue.withDirectives(vue.createVNode(VResponsive, vue.mergeProps({
                    "class": [
                        'v-img',
                        {
                            'v-img--absolute': props.absolute,
                            'v-img--booting': !isBooted.value,
                            'v-img--fit-content': props.width === 'fit-content'
                        },
                        backgroundColorClasses.value,
                        roundedClasses.value,
                        props.class
                    ],
                    "style": [
                        {
                            width: convertToUnit(props.width === 'auto' ? naturalWidth.value : props.width)
                        },
                        backgroundColorStyles.value,
                        roundedStyles.value,
                        props.style
                    ]
                }, responsiveProps, rootAttrs, {
                    "aspectRatio": aspectRatio.value,
                    "aria-label": props.alt || undefined,
                    "role": props.alt ? 'img' : undefined
                }), {
                    additional: ()=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(__image, imageAttrs, null),
                            vue.createVNode(__preloadImage, null, null),
                            vue.createVNode(__gradient, null, null),
                            vue.createVNode(__placeholder, null, null),
                            vue.createVNode(__error, null, null)
                        ]),
                    default: slots.default
                }), [
                    [
                        Intersect,
                        {
                            handler: init,
                            options: props.options
                        },
                        null,
                        {
                            once: true
                        }
                    ]
                ]);
            });
            return {
                currentSrc: currentSrc,
                image: image,
                state: state,
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            };
        }
    });
    // Utilities
    // Types
    // Composables
    const makeBorderProps = propsFactory({
        border: [
            Boolean,
            Number,
            String
        ]
    }, 'border');
    function useBorder(props, name = getCurrentInstanceName()) {
        const borderClasses = vue.computed(()=>{
            const border = props.border;
            if (border === true || border === '') return `${name}--border`;
            else if (typeof border === 'string' || border === 0) return String(border).split(' ').map((v)=>`border-${v}`);
            return [];
        });
        return {
            borderClasses: borderClasses
        };
    }
    // Utilities
    // Types
    // Composables
    const makeElevationProps = propsFactory({
        elevation: {
            type: [
                Number,
                String
            ],
            // no limit to allow both 0-6 (MD3) and legacy 0-24 (MD2)
            validator: (value)=>parseInt(value) >= 0
        },
        hoverElevation: {
            type: [
                Number,
                String
            ],
            validator: (value)=>parseInt(value) >= 0
        }
    }, 'elevation');
    function useElevation(props) {
        const elevationClasses = vue.toRef(()=>{
            const elevation = vue.isRef(props) ? props.value : props.elevation;
            const hoverElevation = vue.isRef(props) ? null : props.hoverElevation;
            return [
                ...elevation == null ? [] : [
                    `elevation-${parseInt(elevation)}`
                ],
                ...hoverElevation == null ? [] : [
                    `hover-elevation-${parseInt(hoverElevation)}`
                ]
            ];
        });
        return {
            elevationClasses: elevationClasses
        };
    }
    // Composables
    // Types
    const oppositeMap = {
        center: 'center',
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
    };
    const makeLocationProps = propsFactory({
        location: String
    }, 'location');
    function useLocation(props, opposite = false, offset) {
        const { isRtl: isRtl } = useRtl();
        const locationStyles = vue.computed(()=>{
            if (!props.location) return {};
            const { side: side, align: align } = parseAnchor(props.location.split(' ').length > 1 ? props.location : `${props.location} center`, isRtl.value);
            function getOffset(side) {
                return offset ? offset(side) : 0;
            }
            const styles = {};
            if (side !== 'center') {
                if (opposite) styles[oppositeMap[side]] = `calc(100% - ${getOffset(side)}px)`;
                else styles[side] = 0;
            }
            if (align !== 'center') {
                if (opposite) styles[oppositeMap[align]] = `calc(100% - ${getOffset(align)}px)`;
                else styles[align] = 0;
            } else {
                if (side === 'center') styles.top = styles.left = '50%';
                else styles[({
                    top: 'left',
                    bottom: 'left',
                    left: 'top',
                    right: 'top'
                })[side]] = '50%';
                styles.transform = ({
                    top: 'translateX(-50%)',
                    bottom: 'translateX(-50%)',
                    left: 'translateY(-50%)',
                    right: 'translateY(-50%)',
                    center: 'translate(-50%, -50%)'
                })[side];
            }
            return styles;
        });
        return {
            locationStyles: locationStyles
        };
    }
    // Types
    const allowedDensities$1 = [
        null,
        'prominent',
        'default',
        'comfortable',
        'compact'
    ];
    const makeVToolbarProps = propsFactory({
        absolute: Boolean,
        collapse: Boolean,
        collapsePosition: {
            type: String,
            default: 'start'
        },
        color: String,
        density: {
            type: String,
            default: 'default',
            validator: (v)=>allowedDensities$1.includes(v)
        },
        extended: {
            type: Boolean,
            default: null
        },
        extensionHeight: {
            type: [
                Number,
                String
            ],
            default: 48
        },
        flat: Boolean,
        floating: Boolean,
        height: {
            type: [
                Number,
                String
            ],
            default: 64
        },
        image: String,
        title: String,
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeElevationProps(),
        ...makeLocationProps(),
        ...makeRoundedProps(),
        ...makeTagProps({
            tag: 'header'
        }),
        ...makeThemeProps()
    }, 'VToolbar');
    const VToolbar = genericComponent()({
        name: 'VToolbar',
        props: makeVToolbarProps(),
        setup (props, { slots: slots }) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { borderClasses: borderClasses } = useBorder(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { locationStyles: locationStyles } = useLocation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { themeClasses: themeClasses } = provideTheme(props);
            const { rtlClasses: rtlClasses } = useRtl();
            const isExtended = vue.shallowRef(props.extended === null ? !!slots.extension?.() : props.extended);
            const contentHeight = vue.computed(()=>parseInt(Number(props.height) + (props.density === 'prominent' ? Number(props.height) : 0) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0), 10));
            const extensionHeight = vue.computed(()=>isExtended.value ? parseInt(Number(props.extensionHeight) + (props.density === 'prominent' ? Number(props.extensionHeight) : 0) - (props.density === 'comfortable' ? 4 : 0) - (props.density === 'compact' ? 8 : 0), 10) : 0);
            provideDefaults({
                VBtn: {
                    variant: 'text'
                }
            });
            useRender(()=>{
                const hasTitle = !!(props.title || slots.title);
                const hasImage = !!(slots.image || props.image);
                const extension = slots.extension?.();
                isExtended.value = props.extended === null ? !!extension : props.extended;
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-toolbar',
                        `v-toolbar--collapse-${props.collapsePosition}`,
                        {
                            'v-toolbar--absolute': props.absolute,
                            'v-toolbar--collapse': props.collapse,
                            'v-toolbar--flat': props.flat,
                            'v-toolbar--floating': props.floating,
                            [`v-toolbar--density-${props.density}`]: true
                        },
                        backgroundColorClasses.value,
                        borderClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        themeClasses.value,
                        rtlClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        locationStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            hasImage && vue.createElementVNode("div", {
                                "key": "image",
                                "class": "v-toolbar__image"
                            }, [
                                !slots.image ? vue.createVNode(VImg, {
                                    "key": "image-img",
                                    "cover": true,
                                    "src": props.image
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "image-defaults",
                                    "disabled": !props.image,
                                    "defaults": {
                                        VImg: {
                                            cover: true,
                                            src: props.image
                                        }
                                    }
                                }, slots.image)
                            ]),
                            vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VTabs: {
                                        height: convertToUnit(contentHeight.value)
                                    }
                                }
                            }, {
                                default: ()=>[
                                        vue.createElementVNode("div", {
                                            "class": "v-toolbar__content",
                                            "style": {
                                                height: convertToUnit(contentHeight.value)
                                            }
                                        }, [
                                            slots.prepend && vue.createElementVNode("div", {
                                                "class": "v-toolbar__prepend"
                                            }, [
                                                slots.prepend?.()
                                            ]),
                                            hasTitle && vue.createVNode(VToolbarTitle, {
                                                "key": "title",
                                                "text": props.title
                                            }, {
                                                text: slots.title
                                            }),
                                            slots.default?.(),
                                            slots.append && vue.createElementVNode("div", {
                                                "class": "v-toolbar__append"
                                            }, [
                                                slots.append?.()
                                            ])
                                        ])
                                    ]
                            }),
                            vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VTabs: {
                                        height: convertToUnit(extensionHeight.value)
                                    }
                                }
                            }, {
                                default: ()=>[
                                        vue.createVNode(VExpandTransition, null, {
                                            default: ()=>[
                                                    isExtended.value && vue.createElementVNode("div", {
                                                        "class": "v-toolbar__extension",
                                                        "style": {
                                                            height: convertToUnit(extensionHeight.value)
                                                        }
                                                    }, [
                                                        extension
                                                    ])
                                                ]
                                        })
                                    ]
                            })
                        ]
                });
            });
            return {
                contentHeight: contentHeight,
                extensionHeight: extensionHeight
            };
        }
    });
    // Utilities
    // Types
    // Composables
    const makeScrollProps = propsFactory({
        scrollTarget: {
            type: String
        },
        scrollThreshold: {
            type: [
                String,
                Number
            ],
            default: 300
        }
    }, 'scroll');
    function useScroll(props, args = {}) {
        const { canScroll: canScroll, layoutSize: layoutSize } = args;
        let previousScroll = 0;
        let previousScrollHeight = 0;
        const target = vue.ref(null);
        const currentScroll = vue.shallowRef(0);
        const savedScroll = vue.shallowRef(0);
        const currentThreshold = vue.shallowRef(0);
        const isScrollActive = vue.shallowRef(false);
        const isScrollingUp = vue.shallowRef(false);
        const isAtBottom = vue.shallowRef(false);
        const reachedBottomWhileScrollingDown = vue.shallowRef(false);
        const hasEnoughScrollableSpace = vue.shallowRef(true);
        const scrollThreshold = vue.computed(()=>{
            return Number(props.scrollThreshold);
        });
        /**
     * 1: at top
     * 0: at threshold
     */ const scrollRatio = vue.computed(()=>{
            return clamp((scrollThreshold.value - currentScroll.value) / scrollThreshold.value || 0);
        });
        function getScrollMetrics(targetEl) {
            const clientHeight = 'window' in targetEl ? window.innerHeight : targetEl.clientHeight;
            const scrollHeight = 'window' in targetEl ? document.documentElement.scrollHeight : targetEl.scrollHeight;
            return {
                clientHeight: clientHeight,
                scrollHeight: scrollHeight
            };
        }
        function checkScrollableSpace() {
            const targetEl = target.value;
            if (!targetEl) return;
            const { clientHeight: clientHeight, scrollHeight: scrollHeight } = getScrollMetrics(targetEl);
            const maxScrollableDistance = scrollHeight - clientHeight;
            // When the scroll-hide element (like AppBar) hides, it causes the page to grow
            // We need extra scrollable space beyond the threshold to prevent bouncing
            // Add the element's height to the required minimum distance
            const elementHeight = layoutSize?.value || 0;
            const minRequiredDistance = scrollThreshold.value + elementHeight;
            // Only enable scroll-hide if there's enough scrollable space
            hasEnoughScrollableSpace.value = maxScrollableDistance > minRequiredDistance;
        }
        function onResize() {
            checkScrollableSpace();
        }
        function onScroll() {
            const targetEl = target.value;
            if (!targetEl || canScroll && !canScroll.value) return;
            previousScroll = currentScroll.value;
            currentScroll.value = 'window' in targetEl ? targetEl.pageYOffset : targetEl.scrollTop;
            const currentScrollHeight = targetEl instanceof Window ? document.documentElement.scrollHeight : targetEl.scrollHeight;
            if (previousScrollHeight !== currentScrollHeight) {
                // If page is growing (content loading), recalculate scrollable space
                // If page is shrinking (likely due to navbar animation), don't recalculate
                if (currentScrollHeight > previousScrollHeight) checkScrollableSpace();
                previousScrollHeight = currentScrollHeight;
            }
            isScrollingUp.value = currentScroll.value < previousScroll;
            currentThreshold.value = Math.abs(currentScroll.value - scrollThreshold.value);
            // Detect if at bottom of page
            const { clientHeight: clientHeight, scrollHeight: scrollHeight } = getScrollMetrics(targetEl);
            const atBottom = currentScroll.value + clientHeight >= scrollHeight - 5;
            // Track when bottom is reached during downward scroll
            // Only set flag if ALL conditions are met:
            // 1. Scrolled past threshold (navbar is hiding)
            // 2. Page has enough scrollable space for scroll-hide
            // This prevents activation on short pages or edge cases
            if (!isScrollingUp.value && atBottom && currentScroll.value >= scrollThreshold.value && hasEnoughScrollableSpace.value) reachedBottomWhileScrollingDown.value = true;
            // Reset the flag when:
            // 1. Scrolling up away from bottom (with small tolerance for touchpad/momentum scrolling)
            // 2. Scroll position jumped significantly (e.g., navigation, scroll restoration)
            // 3. Scroll is at the very top (page navigation resets to top)
            const scrollJumped = Math.abs(currentScroll.value - previousScroll) > 100;
            const atTop = currentScroll.value <= 5;
            const scrolledUpSignificantly = isScrollingUp.value && previousScroll - currentScroll.value > 1;
            if (scrolledUpSignificantly && !atBottom || scrollJumped && currentScroll.value < scrollThreshold.value || atTop) reachedBottomWhileScrollingDown.value = false;
            // Update state
            isAtBottom.value = atBottom;
        }
        vue.watch(isScrollingUp, ()=>{
            savedScroll.value = savedScroll.value || currentScroll.value;
        });
        vue.watch(isScrollActive, ()=>{
            savedScroll.value = 0;
        });
        vue.onMounted(()=>{
            vue.watch(()=>props.scrollTarget, (scrollTarget)=>{
                const newTarget = scrollTarget ? document.querySelector(scrollTarget) : window;
                if (!newTarget) {
                    consoleWarn(`Unable to locate element with identifier ${scrollTarget}`);
                    return;
                }
                if (newTarget === target.value) return;
                target.value?.removeEventListener('scroll', onScroll);
                target.value = newTarget;
                target.value.addEventListener('scroll', onScroll, {
                    passive: true
                });
                // Check scrollable space when target is set
                Promise.resolve().then(()=>{
                    checkScrollableSpace();
                });
            }, {
                immediate: true
            });
            // Listen to window resize to recalculate scrollable space
            window.addEventListener('resize', onResize, {
                passive: true
            });
        });
        vue.onBeforeUnmount(()=>{
            target.value?.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
        });
        // Do we need this? If yes - seems that
        // there's no need to expose onScroll
        canScroll && vue.watch(canScroll, onScroll, {
            immediate: true
        });
        return {
            scrollThreshold: scrollThreshold,
            currentScroll: currentScroll,
            currentThreshold: currentThreshold,
            isScrollActive: isScrollActive,
            scrollRatio: scrollRatio,
            isScrollingUp: // required only for testing
            // probably can be removed
            // later (2 chars chlng)
            isScrollingUp,
            savedScroll: savedScroll,
            isAtBottom: isAtBottom,
            reachedBottomWhileScrollingDown: reachedBottomWhileScrollingDown,
            hasEnoughScrollableSpace: hasEnoughScrollableSpace
        };
    }
    // Utilities
    // Composables
    function useSsrBoot() {
        const isBooted = vue.shallowRef(false);
        vue.onMounted(()=>{
            window.requestAnimationFrame(()=>{
                isBooted.value = true;
            });
        });
        const ssrBootStyles = vue.toRef(()=>!isBooted.value ? {
                transition: 'none !important'
            } : undefined);
        return {
            ssrBootStyles: ssrBootStyles,
            isBooted: vue.readonly(isBooted)
        };
    }
    // Types
    const makeVAppBarProps = propsFactory({
        scrollBehavior: String,
        modelValue: {
            type: Boolean,
            default: true
        },
        location: {
            type: String,
            default: 'top',
            validator: (value)=>[
                    'top',
                    'bottom'
                ].includes(value)
        },
        ...omit(makeVToolbarProps(), [
            'location'
        ]),
        ...makeLayoutItemProps(),
        ...makeScrollProps(),
        height: {
            type: [
                Number,
                String
            ],
            default: 64
        }
    }, 'VAppBar');
    const VAppBar = genericComponent()({
        name: 'VAppBar',
        props: makeVAppBarProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const vToolbarRef = vue.ref();
            const isActive = useProxiedModel(props, 'modelValue');
            const scrollBehavior = vue.computed(()=>{
                const behavior = new Set(props.scrollBehavior?.split(' ') ?? []);
                return {
                    hide: behavior.has('hide'),
                    fullyHide: behavior.has('fully-hide'),
                    inverted: behavior.has('inverted'),
                    collapse: behavior.has('collapse'),
                    elevate: behavior.has('elevate'),
                    fadeImage: behavior.has('fade-image')
                };
            });
            const canScroll = vue.computed(()=>{
                const behavior = scrollBehavior.value;
                return behavior.hide || behavior.fullyHide || behavior.inverted || behavior.collapse || behavior.elevate || behavior.fadeImage || // behavior.shrink ||
                !isActive.value;
            });
            const appBarHeight = vue.computed(()=>{
                const height = vToolbarRef.value?.contentHeight ?? 0;
                const extensionHeight = vToolbarRef.value?.extensionHeight ?? 0;
                return height + extensionHeight;
            });
            const { currentScroll: currentScroll, scrollThreshold: scrollThreshold, isScrollingUp: isScrollingUp, scrollRatio: scrollRatio, isAtBottom: isAtBottom, reachedBottomWhileScrollingDown: reachedBottomWhileScrollingDown, hasEnoughScrollableSpace: hasEnoughScrollableSpace } = useScroll(props, {
                canScroll: canScroll,
                layoutSize: appBarHeight
            });
            const canHide = vue.toRef(()=>scrollBehavior.value.hide || scrollBehavior.value.fullyHide);
            const isCollapsed = vue.computed(()=>props.collapse || scrollBehavior.value.collapse && (scrollBehavior.value.inverted ? scrollRatio.value > 0 : scrollRatio.value === 0));
            const isFlat = vue.computed(()=>props.flat || scrollBehavior.value.fullyHide && !isActive.value || scrollBehavior.value.elevate && (scrollBehavior.value.inverted ? currentScroll.value > 0 : currentScroll.value === 0));
            const opacity = vue.computed(()=>scrollBehavior.value.fadeImage ? scrollBehavior.value.inverted ? 1 - scrollRatio.value : scrollRatio.value : undefined);
            const height = vue.computed(()=>{
                if (scrollBehavior.value.hide && scrollBehavior.value.inverted) return 0;
                const height = vToolbarRef.value?.contentHeight ?? 0;
                const extensionHeight = vToolbarRef.value?.extensionHeight ?? 0;
                if (!canHide.value) return height + extensionHeight;
                return currentScroll.value < scrollThreshold.value || scrollBehavior.value.fullyHide ? height + extensionHeight : height;
            });
            useToggleScope(()=>!!props.scrollBehavior, ()=>{
                vue.watchEffect(()=>{
                    if (!canHide.value) {
                        isActive.value = true;
                        return;
                    }
                    if (scrollBehavior.value.inverted) {
                        isActive.value = currentScroll.value > scrollThreshold.value;
                        return;
                    }
                    // If there's not enough scrollable space, don't apply scroll-hide behavior at all
                    // This prevents flickering/bouncing animations on short pages
                    if (!hasEnoughScrollableSpace.value) {
                        isActive.value = true;
                        return;
                    }
                    // Prevent navbar from showing when we reached bottom while scrolling down
                    // This handles the case where scroll momentum causes to hit bottom during hide transition
                    if (reachedBottomWhileScrollingDown.value) {
                        isActive.value = false;
                        return;
                    }
                    // Normal behavior: show when scrolling up (and not at bottom) or above threshold
                    isActive.value = isScrollingUp.value && !isAtBottom.value || currentScroll.value < scrollThreshold.value;
                });
            });
            const { ssrBootStyles: ssrBootStyles } = useSsrBoot();
            const { layoutItemStyles: layoutItemStyles } = useLayoutItem({
                id: props.name,
                order: vue.computed(()=>parseInt(props.order, 10)),
                position: vue.toRef(()=>props.location),
                layoutSize: height,
                elementSize: vue.shallowRef(undefined),
                active: isActive,
                absolute: vue.toRef(()=>props.absolute)
            });
            useRender(()=>{
                const toolbarProps = omit(VToolbar.filterProps(props), [
                    'location'
                ]);
                return vue.createVNode(VToolbar, vue.mergeProps({
                    "ref": vToolbarRef,
                    "class": [
                        'v-app-bar',
                        {
                            'v-app-bar--bottom': props.location === 'bottom'
                        },
                        props.class
                    ],
                    "style": [
                        {
                            ...layoutItemStyles.value,
                            '--v-toolbar-image-opacity': opacity.value,
                            height: undefined,
                            ...ssrBootStyles.value
                        },
                        props.style
                    ]
                }, toolbarProps, {
                    "collapse": isCollapsed.value,
                    "flat": isFlat.value
                }), slots);
            });
            return {};
        }
    });
    // Utilities
    // Types
    const allowedDensities = [
        null,
        'default',
        'comfortable',
        'compact'
    ];
    // typeof allowedDensities[number] evaluates to any
    // when generating api types for whatever reason.
    // Composables
    const makeDensityProps = propsFactory({
        density: {
            type: String,
            default: 'default',
            validator: (v)=>allowedDensities.includes(v)
        }
    }, 'density');
    function useDensity(props, name = getCurrentInstanceName()) {
        const densityClasses = vue.toRef(()=>{
            return `${name}--density-${props.density}`;
        });
        return {
            densityClasses: densityClasses
        };
    }
    // Types
    const allowedVariants$3 = [
        'elevated',
        'flat',
        'tonal',
        'outlined',
        'text',
        'plain'
    ];
    function genOverlays(isClickable, name) {
        return vue.createElementVNode(vue.Fragment, null, [
            isClickable && vue.createElementVNode("span", {
                "key": "overlay",
                "class": vue.normalizeClass(`${name}__overlay`)
            }, null),
            vue.createElementVNode("span", {
                "key": "underlay",
                "class": vue.normalizeClass(`${name}__underlay`)
            }, null)
        ]);
    }
    const makeVariantProps = propsFactory({
        color: String,
        variant: {
            type: String,
            default: 'elevated',
            validator: (v)=>allowedVariants$3.includes(v)
        }
    }, 'variant');
    function useVariant(props, name = getCurrentInstanceName()) {
        const variantClasses = vue.toRef(()=>{
            const { variant: variant } = vue.toValue(props);
            return `${name}--variant-${variant}`;
        });
        const { colorClasses: colorClasses, colorStyles: colorStyles } = useColor(()=>{
            const { variant: variant, color: color } = vue.toValue(props);
            return {
                [[
                    'elevated',
                    'flat'
                ].includes(variant) ? 'background' : 'text']: color
            };
        });
        return {
            colorClasses: colorClasses,
            colorStyles: colorStyles,
            variantClasses: variantClasses
        };
    }
    // Types
    const makeVBtnGroupProps = propsFactory({
        baseColor: String,
        divided: Boolean,
        direction: {
            type: String,
            default: 'horizontal'
        },
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeElevationProps(),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeVariantProps()
    }, 'VBtnGroup');
    const VBtnGroup = genericComponent()({
        name: 'VBtnGroup',
        props: makeVBtnGroupProps(),
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            provideDefaults({
                VBtn: {
                    height: vue.toRef(()=>props.direction === 'horizontal' ? 'auto' : null),
                    baseColor: vue.toRef(()=>props.baseColor),
                    color: vue.toRef(()=>props.color),
                    density: vue.toRef(()=>props.density),
                    flat: true,
                    variant: vue.toRef(()=>props.variant)
                }
            });
            useRender(()=>{
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-btn-group',
                        `v-btn-group--${props.direction}`,
                        {
                            'v-btn-group--divided': props.divided
                        },
                        themeClasses.value,
                        borderClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        roundedStyles.value,
                        props.style
                    ])
                }, slots);
            });
        }
    });
    // Composables
    // Types
    const makeGroupProps = propsFactory({
        modelValue: {
            type: null,
            default: undefined
        },
        multiple: Boolean,
        mandatory: [
            Boolean,
            String
        ],
        max: Number,
        selectedClass: String,
        disabled: Boolean
    }, 'group');
    const makeGroupItemProps = propsFactory({
        value: null,
        disabled: Boolean,
        selectedClass: String
    }, 'group-item');
    // Composables
    function useGroupItem(props, injectKey, required = true) {
        const vm = getCurrentInstance('useGroupItem');
        if (!vm) throw new Error('[Vuetify] useGroupItem composable must be used inside a component setup function');
        const id = vue.useId();
        vue.provide(Symbol.for(`${injectKey.description}:id`), id);
        const group = vue.inject(injectKey, null);
        if (!group) {
            if (!required) return group;
            throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${injectKey.description}`);
        }
        const value = vue.toRef(()=>props.value);
        const disabled = vue.computed(()=>!!(group.disabled.value || props.disabled));
        function register() {
            group?.register({
                id: id,
                value: value,
                disabled: disabled
            }, vm);
        }
        function unregister() {
            group?.unregister(id);
        }
        register();
        vue.onBeforeUnmount(()=>unregister());
        const isSelected = vue.computed(()=>{
            return group.isSelected(id);
        });
        const isFirst = vue.computed(()=>{
            return group.items.value[0].id === id;
        });
        const isLast = vue.computed(()=>{
            return group.items.value[group.items.value.length - 1].id === id;
        });
        const selectedClass = vue.computed(()=>isSelected.value && [
                group.selectedClass.value,
                props.selectedClass
            ]);
        vue.watch(isSelected, (value)=>{
            vm.emit('group:selected', {
                value: value
            });
        }, {
            flush: 'sync'
        });
        return {
            id: id,
            isSelected: isSelected,
            isFirst: isFirst,
            isLast: isLast,
            toggle: ()=>group.select(id, !isSelected.value),
            select: (value)=>group.select(id, value),
            selectedClass: selectedClass,
            value: value,
            disabled: disabled,
            group: group,
            register: register,
            unregister: unregister
        };
    }
    function useGroup(props, injectKey) {
        let isUnmounted = false;
        const items = vue.reactive([]);
        const selected = useProxiedModel(props, 'modelValue', [], (v)=>{
            if (v === undefined) return [];
            return getIds(items, v === null ? [
                null
            ] : wrapInArray(v));
        }, (v)=>{
            const arr = getValues(items, v);
            return props.multiple ? arr : arr[0];
        });
        const groupVm = getCurrentInstance('useGroup');
        function register(item, vm) {
            // Is there a better way to fix this typing?
            const unwrapped = item;
            const key = Symbol.for(`${injectKey.description}:id`);
            const children = findChildrenWithProvide(key, groupVm?.vnode);
            const index = children.indexOf(vm);
            if (vue.unref(unwrapped.value) === undefined) {
                unwrapped.value = index;
                unwrapped.useIndexAsValue = true;
            }
            if (index > -1) items.splice(index, 0, unwrapped);
            else items.push(unwrapped);
        }
        function unregister(id) {
            if (isUnmounted) return;
            // TODO: re-evaluate this line's importance in the future
            // should we only modify the model if mandatory is set.
            // selected.value = selected.value.filter(v => v !== id)
            forceMandatoryValue();
            const index = items.findIndex((item)=>item.id === id);
            items.splice(index, 1);
        }
        // If mandatory and nothing is selected, then select first non-disabled item
        function forceMandatoryValue() {
            const item = items.find((item)=>!item.disabled);
            if (item && props.mandatory === 'force' && !selected.value.length) selected.value = [
                item.id
            ];
        }
        vue.onMounted(()=>{
            forceMandatoryValue();
        });
        vue.onBeforeUnmount(()=>{
            isUnmounted = true;
        });
        vue.onUpdated(()=>{
            // #19655 update the items that use the index as the value.
            for(let i = 0; i < items.length; i++)if (items[i].useIndexAsValue) items[i].value = i;
        });
        function select(id, value) {
            const item = items.find((item)=>item.id === id);
            if (value && item?.disabled) return;
            if (props.multiple) {
                const internalValue = selected.value.slice();
                const index = internalValue.findIndex((v)=>v === id);
                const isSelected = ~index;
                value = value ?? !isSelected;
                // We can't remove value if group is
                // mandatory, value already exists,
                // and it is the only value
                if (isSelected && props.mandatory && internalValue.length <= 1) return;
                // We can't add value if it would
                // cause max limit to be exceeded
                if (!isSelected && props.max != null && internalValue.length + 1 > props.max) return;
                if (index < 0 && value) internalValue.push(id);
                else if (index >= 0 && !value) internalValue.splice(index, 1);
                selected.value = internalValue;
            } else {
                const isSelected = selected.value.includes(id);
                if (props.mandatory && isSelected) return;
                if (!isSelected && !value) return;
                selected.value = value ?? !isSelected ? [
                    id
                ] : [];
            }
        }
        function step(offset) {
            // getting an offset from selected value obviously won't work with multiple values
            if (props.multiple) consoleWarn('This method is not supported when using "multiple" prop');
            if (!selected.value.length) {
                const item = items.find((item)=>!item.disabled);
                item && (selected.value = [
                    item.id
                ]);
            } else {
                const currentId = selected.value[0];
                const currentIndex = items.findIndex((i)=>i.id === currentId);
                let newIndex = (currentIndex + offset) % items.length;
                let newItem = items[newIndex];
                while(newItem.disabled && newIndex !== currentIndex){
                    newIndex = (newIndex + offset) % items.length;
                    newItem = items[newIndex];
                }
                if (newItem.disabled) return;
                selected.value = [
                    items[newIndex].id
                ];
            }
        }
        const state = {
            register: register,
            unregister: unregister,
            selected: selected,
            select: select,
            disabled: vue.toRef(()=>props.disabled),
            prev: ()=>step(items.length - 1),
            next: ()=>step(1),
            isSelected: (id)=>selected.value.includes(id),
            selectedClass: vue.toRef(()=>props.selectedClass),
            items: vue.toRef(()=>items),
            getItemIndex: (value)=>getItemIndex(items, value)
        };
        vue.provide(injectKey, state);
        return state;
    }
    function getItemIndex(items, value) {
        const ids = getIds(items, [
            value
        ]);
        if (!ids.length) return -1;
        return items.findIndex((item)=>item.id === ids[0]);
    }
    function getIds(items, modelValue) {
        const ids = [];
        modelValue.forEach((value)=>{
            const item = items.find((item)=>deepEqual(value, item.value));
            const itemByIndex = items[value];
            if (item?.value !== undefined) ids.push(item.id);
            else if (itemByIndex?.useIndexAsValue) ids.push(itemByIndex.id);
        });
        return ids;
    }
    function getValues(items, ids) {
        const values = [];
        ids.forEach((id)=>{
            const itemIndex = items.findIndex((item)=>item.id === id);
            if (~itemIndex) {
                const item = items[itemIndex];
                values.push(item.value !== undefined ? item.value : itemIndex);
            }
        });
        return values;
    }
    // Types
    const VBtnToggleSymbol = Symbol.for('vuetify:v-btn-toggle');
    const makeVBtnToggleProps = propsFactory({
        ...makeVBtnGroupProps(),
        ...makeGroupProps()
    }, 'VBtnToggle');
    const VBtnToggle = genericComponent()({
        name: 'VBtnToggle',
        props: makeVBtnToggleProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { isSelected: isSelected, next: next, prev: prev, select: select, selected: selected } = useGroup(props, VBtnToggleSymbol);
            useRender(()=>{
                const btnGroupProps = VBtnGroup.filterProps(props);
                return vue.createVNode(VBtnGroup, vue.mergeProps({
                    "class": [
                        'v-btn-toggle',
                        {
                            'v-btn-toggle--has-color': !!props.color
                        },
                        props.class
                    ]
                }, btnGroupProps, {
                    "style": props.style
                }), {
                    default: ()=>[
                            slots.default?.({
                                isSelected: isSelected,
                                next: next,
                                prev: prev,
                                select: select,
                                selected: selected
                            })
                        ]
                });
            });
            return {
                next: next,
                prev: prev,
                select: select
            };
        }
    });
    // Utilities
    // Types
    const predefinedSizes$1 = [
        'x-small',
        'small',
        'default',
        'large',
        'x-large'
    ];
    // Composables
    const makeSizeProps = propsFactory({
        size: {
            type: [
                String,
                Number
            ],
            default: 'default'
        }
    }, 'size');
    function useSize(props, name = getCurrentInstanceName()) {
        return destructComputed(()=>{
            const size = props.size;
            let sizeClasses;
            let sizeStyles;
            if (includes(predefinedSizes$1, size)) sizeClasses = `${name}--size-${size}`;
            else if (size) sizeStyles = {
                width: convertToUnit(size),
                height: convertToUnit(size)
            };
            return {
                sizeClasses: sizeClasses,
                sizeStyles: sizeStyles
            };
        });
    }
    const makeVIconProps = propsFactory({
        color: String,
        disabled: Boolean,
        start: Boolean,
        end: Boolean,
        icon: IconValue,
        opacity: [
            String,
            Number
        ],
        ...makeComponentProps(),
        ...makeSizeProps(),
        ...makeTagProps({
            tag: 'i'
        }),
        ...makeThemeProps()
    }, 'VIcon');
    const VIcon = genericComponent()({
        name: 'VIcon',
        props: makeVIconProps(),
        setup (props, { attrs: attrs, slots: slots }) {
            const slotIcon = vue.shallowRef();
            const { themeClasses: themeClasses } = useTheme();
            const { iconData: iconData } = useIcon(()=>slotIcon.value || props.icon);
            const { sizeClasses: sizeClasses } = useSize(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            useRender(()=>{
                const slotValue = slots.default?.();
                if (slotValue) slotIcon.value = flattenFragments(slotValue).filter((node)=>node.type === vue.Text && node.children && typeof node.children === 'string')[0]?.children;
                const hasClick = !!(attrs.onClick || attrs.onClickOnce);
                return vue.createVNode(iconData.value.component, {
                    "tag": props.tag,
                    "icon": iconData.value.icon,
                    "class": vue.normalizeClass([
                        'v-icon',
                        'notranslate',
                        themeClasses.value,
                        sizeClasses.value,
                        textColorClasses.value,
                        {
                            'v-icon--clickable': hasClick,
                            'v-icon--disabled': props.disabled,
                            'v-icon--start': props.start,
                            'v-icon--end': props.end
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-icon-opacity': props.opacity
                        },
                        !sizeClasses.value ? {
                            fontSize: convertToUnit(props.size),
                            height: convertToUnit(props.size),
                            width: convertToUnit(props.size)
                        } : undefined,
                        textColorStyles.value,
                        props.style
                    ]),
                    "role": hasClick ? 'button' : undefined,
                    "aria-hidden": !hasClick,
                    "tabindex": hasClick ? props.disabled ? -1 : 0 : undefined
                }, {
                    default: ()=>[
                            slotValue
                        ]
                });
            });
            return {};
        }
    });
    // Utilities
    function useIntersectionObserver(callback, options) {
        const intersectionRef = vue.ref();
        const isIntersecting = vue.shallowRef(false);
        if (SUPPORTS_INTERSECTION) {
            const observer = new IntersectionObserver((entries)=>{
                isIntersecting.value = !!entries.find((entry)=>entry.isIntersecting);
            }, options);
            vue.onScopeDispose(()=>{
                observer.disconnect();
            });
            vue.watch(intersectionRef, (newValue, oldValue)=>{
                if (oldValue) {
                    observer.unobserve(oldValue);
                    isIntersecting.value = false;
                }
                if (newValue) observer.observe(newValue);
            }, {
                flush: 'post'
            });
        }
        return {
            intersectionRef: intersectionRef,
            isIntersecting: isIntersecting
        };
    }
    // Utilities
    // Types
    // Types
    // Composables
    const makeRevealProps = propsFactory({
        reveal: {
            type: [
                Boolean,
                Object
            ],
            default: false
        }
    }, 'reveal');
    function useReveal(props) {
        const defaultDuration = 900;
        const duration = vue.toRef(()=>typeof props.reveal === 'object' ? Math.max(0, Number(props.reveal.duration ?? defaultDuration)) : defaultDuration);
        const state = vue.shallowRef(props.reveal ? 'initial' : 'disabled');
        vue.onMounted(async ()=>{
            if (props.reveal) {
                state.value = 'initial';
                await new Promise((resolve)=>requestAnimationFrame(resolve));
                state.value = 'pending';
                await new Promise((resolve)=>setTimeout(resolve, duration.value));
                state.value = 'done';
            }
        });
        return {
            duration: duration,
            state: state
        };
    }
    // Types
    const makeVProgressCircularProps = propsFactory({
        bgColor: String,
        color: String,
        indeterminate: [
            Boolean,
            String
        ],
        rounded: Boolean,
        modelValue: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        rotate: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        width: {
            type: [
                Number,
                String
            ],
            default: 4
        },
        ...makeComponentProps(),
        ...makeRevealProps(),
        ...makeSizeProps(),
        ...makeTagProps({
            tag: 'div'
        }),
        ...makeThemeProps()
    }, 'VProgressCircular');
    const VProgressCircular = genericComponent()({
        name: 'VProgressCircular',
        props: makeVProgressCircularProps(),
        setup (props, { slots: slots }) {
            const MAGIC_RADIUS_CONSTANT = 20;
            const CIRCUMFERENCE = 2 * Math.PI * MAGIC_RADIUS_CONSTANT;
            const root = vue.ref();
            const { themeClasses: themeClasses } = provideTheme(props);
            const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = useSize(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            const { textColorClasses: underlayColorClasses, textColorStyles: underlayColorStyles } = useTextColor(()=>props.bgColor);
            const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = useIntersectionObserver();
            const { resizeRef: resizeRef, contentRect: contentRect } = useResizeObserver();
            const { state: revealState, duration: revealDuration } = useReveal(props);
            const normalizedValue = vue.toRef(()=>revealState.value === 'initial' ? 0 : clamp(parseFloat(props.modelValue), 0, 100));
            const width = vue.toRef(()=>Number(props.width));
            const size = vue.toRef(()=>{
                // Get size from element if size prop value is small, large etc
                return sizeStyles.value ? Number(props.size) : contentRect.value ? contentRect.value.width : Math.max(width.value, 32);
            });
            const diameter = vue.toRef(()=>MAGIC_RADIUS_CONSTANT / (1 - width.value / size.value) * 2);
            const strokeWidth = vue.toRef(()=>width.value / size.value * diameter.value);
            const strokeDashOffset = vue.toRef(()=>{
                const baseLength = (100 - normalizedValue.value) / 100 * CIRCUMFERENCE;
                return props.rounded && normalizedValue.value > 0 && normalizedValue.value < 100 ? convertToUnit(Math.min(CIRCUMFERENCE - 0.01, baseLength + strokeWidth.value)) : convertToUnit(baseLength);
            });
            const startAngle = vue.computed(()=>{
                const baseAngle = Number(props.rotate);
                return props.rounded ? baseAngle + strokeWidth.value / 2 / CIRCUMFERENCE * 360 : baseAngle;
            });
            vue.watchEffect(()=>{
                intersectionRef.value = root.value;
                resizeRef.value = root.value;
            });
            useRender(()=>vue.createVNode(props.tag, {
                    "ref": root,
                    "class": vue.normalizeClass([
                        'v-progress-circular',
                        {
                            'v-progress-circular--indeterminate': !!props.indeterminate,
                            'v-progress-circular--visible': isIntersecting.value,
                            'v-progress-circular--disable-shrink': props.indeterminate && (props.indeterminate === 'disable-shrink' || PREFERS_REDUCED_MOTION()),
                            'v-progress-circular--revealing': [
                                'initial',
                                'pending'
                            ].includes(revealState.value)
                        },
                        themeClasses.value,
                        sizeClasses.value,
                        textColorClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        sizeStyles.value,
                        textColorStyles.value,
                        {
                            '--progress-reveal-duration': `${revealDuration.value}ms`
                        },
                        props.style
                    ]),
                    "role": "progressbar",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    "aria-valuenow": props.indeterminate ? undefined : normalizedValue.value
                }, {
                    default: ()=>[
                            vue.createElementVNode("svg", {
                                "style": {
                                    transform: `rotate(calc(-90deg + ${startAngle.value}deg))`
                                },
                                "xmlns": "http://www.w3.org/2000/svg",
                                "viewBox": `0 0 ${diameter.value} ${diameter.value}`
                            }, [
                                vue.createElementVNode("circle", {
                                    "class": vue.normalizeClass([
                                        'v-progress-circular__underlay',
                                        underlayColorClasses.value
                                    ]),
                                    "style": vue.normalizeStyle(underlayColorStyles.value),
                                    "fill": "transparent",
                                    "cx": "50%",
                                    "cy": "50%",
                                    "r": MAGIC_RADIUS_CONSTANT,
                                    "stroke-width": strokeWidth.value,
                                    "stroke-dasharray": CIRCUMFERENCE,
                                    "stroke-dashoffset": 0
                                }, null),
                                vue.createElementVNode("circle", {
                                    "class": "v-progress-circular__overlay",
                                    "fill": "transparent",
                                    "cx": "50%",
                                    "cy": "50%",
                                    "r": MAGIC_RADIUS_CONSTANT,
                                    "stroke-width": strokeWidth.value,
                                    "stroke-dasharray": CIRCUMFERENCE,
                                    "stroke-dashoffset": strokeDashOffset.value,
                                    "stroke-linecap": props.rounded ? 'round' : undefined
                                }, null)
                            ]),
                            slots.default && vue.createElementVNode("div", {
                                "class": "v-progress-circular__content"
                            }, [
                                slots.default({
                                    value: normalizedValue.value
                                })
                            ])
                        ]
                }));
            return {};
        }
    });
    // Utilities
    // Types
    // Composables
    const makeChunksProps = propsFactory({
        chunkCount: {
            type: [
                Number,
                String
            ],
            default: null
        },
        chunkWidth: {
            type: [
                Number,
                String
            ],
            default: null
        },
        chunkGap: {
            type: [
                Number,
                String
            ],
            default: 4
        },
        variant: {
            type: String,
            default: undefined,
            validator: (v)=>[
                    'split'
                ].includes(v)
        }
    }, 'chunks');
    function useChunks(props, containerWidth, value, bufferValue, reversed) {
        const isSplit = vue.toRef(()=>props.variant === 'split');
        const chunkCount = vue.toRef(()=>isSplit.value ? 2 : Number(props.chunkCount) || 0);
        const hasChunks = vue.toRef(()=>!isSplit.value && (!!chunkCount.value || !!props.chunkWidth));
        const chunkWidth = vue.computed(()=>{
            const containerSize = vue.toValue(containerWidth);
            if (!containerSize) return 0;
            if (chunkCount.value) {
                const availableWidth = containerSize - Number(props.chunkGap) * (chunkCount.value - 1);
                return availableWidth / chunkCount.value;
            }
            return Number(props.chunkWidth);
        });
        const chunkGap = vue.toRef(()=>Number(props.chunkGap));
        const chunksMaskStyles = vue.computed(()=>{
            if (!hasChunks.value) return {};
            const chunkGapPx = convertToUnit(chunkGap.value);
            const chunkWidthPx = convertToUnit(chunkWidth.value);
            return {
                maskRepeat: 'repeat-x',
                maskImage: `linear-gradient(90deg, #000, #000 ${chunkWidthPx}, transparent ${chunkWidthPx}, transparent)`,
                maskSize: `calc(${chunkWidthPx} + ${chunkGapPx}) 100%`
            };
        });
        const splitStyles = vue.computed(()=>{
            if (!isSplit.value) return undefined;
            const halfGap = convertToUnit(chunkGap.value / 2);
            const position = vue.toValue(reversed) ? 'right' : 'left';
            const val = vue.toValue(value);
            if (val <= 0 || val >= 100) return undefined;
            const buffer = vue.toValue(bufferValue);
            const split = convertToUnit(val, '%');
            const hasBuffer = buffer > val && buffer < 100;
            const bufferSplit = convertToUnit(buffer, '%');
            return {
                bar: {
                    width: `calc(${split} - ${halfGap})`
                },
                buffer: hasBuffer ? {
                    [position]: `calc(${split} + ${halfGap})`,
                    width: `calc(${bufferSplit} - ${split} - ${convertToUnit(chunkGap.value)})`
                } : undefined,
                background: {
                    [position]: `calc(${hasBuffer ? bufferSplit : split} + ${halfGap})`,
                    width: `calc(100% - ${hasBuffer ? bufferSplit : split} - ${halfGap})`
                }
            };
        });
        function snapValueToChunk(val) {
            if (isSplit.value) return val;
            const containerSize = vue.toValue(containerWidth);
            if (!containerSize) return val;
            const gapRelativeSize = 100 * chunkGap.value / containerSize;
            const chunkRelativeSize = 100 * (chunkWidth.value + chunkGap.value) / containerSize;
            // low-effort workaround to floating-point rounding in the division
            const filledChunks = Math.floor((val + gapRelativeSize) / chunkRelativeSize + 1e-9);
            return clamp(filledChunks * chunkRelativeSize - gapRelativeSize / 2, 0, 100);
        }
        return {
            hasChunks: vue.toRef(()=>hasChunks.value || isSplit.value),
            isSplit: isSplit,
            chunkCount: chunkCount,
            chunksMaskStyles: chunksMaskStyles,
            splitStyles: splitStyles,
            snapValueToChunk: snapValueToChunk
        };
    }
    const makeVProgressLinearProps = propsFactory({
        absolute: Boolean,
        active: {
            type: Boolean,
            default: true
        },
        bgColor: String,
        bgOpacity: [
            Number,
            String
        ],
        bufferValue: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        bufferColor: String,
        bufferOpacity: [
            Number,
            String
        ],
        clickable: Boolean,
        color: String,
        height: {
            type: [
                Number,
                String
            ],
            default: 4
        },
        indeterminate: Boolean,
        max: {
            type: [
                Number,
                String
            ],
            default: 100
        },
        modelValue: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        opacity: [
            Number,
            String
        ],
        reverse: Boolean,
        stream: Boolean,
        striped: Boolean,
        roundedBar: Boolean,
        ...makeChunksProps(),
        ...makeComponentProps(),
        ...makeLocationProps({
            location: 'top'
        }),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VProgressLinear');
    const VProgressLinear = genericComponent()({
        name: 'VProgressLinear',
        props: makeVProgressLinearProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const root = vue.ref();
            const progress = useProxiedModel(props, 'modelValue');
            const { isRtl: isRtl, rtlClasses: rtlClasses } = useRtl();
            const { themeClasses: themeClasses } = provideTheme(props);
            const { locationStyles: locationStyles } = useLocation(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor || props.color);
            const { backgroundColorClasses: bufferColorClasses, backgroundColorStyles: bufferColorStyles } = useBackgroundColor(()=>props.bufferColor || props.bgColor || props.color);
            const { backgroundColorClasses: barColorClasses, backgroundColorStyles: barColorStyles } = useBackgroundColor(()=>props.color);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = useIntersectionObserver();
            const max = vue.computed(()=>parseFloat(props.max));
            const height = vue.computed(()=>parseFloat(props.height));
            const normalizedBuffer = vue.computed(()=>clamp(parseFloat(props.bufferValue) / max.value * 100, 0, 100));
            const normalizedValue = vue.computed(()=>clamp(parseFloat(progress.value) / max.value * 100, 0, 100));
            const isReversed = vue.computed(()=>isRtl.value !== props.reverse);
            const transition = vue.computed(()=>props.indeterminate ? 'fade-transition' : 'slide-x-transition');
            const containerWidth = vue.shallowRef(0);
            const { hasChunks: hasChunks, splitStyles: splitStyles, chunksMaskStyles: chunksMaskStyles, snapValueToChunk: snapValueToChunk } = useChunks(props, containerWidth, normalizedValue, normalizedBuffer, isReversed);
            useToggleScope(hasChunks, ()=>{
                const { resizeRef: resizeRef } = useResizeObserver((entries)=>containerWidth.value = entries[0].contentRect.width);
                vue.watchEffect(()=>resizeRef.value = root.value);
            });
            const bufferWidth = vue.computed(()=>{
                return hasChunks.value ? snapValueToChunk(normalizedBuffer.value) : normalizedBuffer.value;
            });
            const barWidth = vue.computed(()=>{
                return hasChunks.value ? snapValueToChunk(normalizedValue.value) : normalizedValue.value;
            });
            function handleClick(e) {
                if (!intersectionRef.value) return;
                const { left: left, right: right, width: width } = intersectionRef.value.getBoundingClientRect();
                const value = isReversed.value ? width - e.clientX + (right - width) : e.clientX - left;
                progress.value = Math.round(value / width * max.value);
            }
            vue.watchEffect(()=>{
                intersectionRef.value = root.value;
            });
            function renderBackgroundBar() {
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-progress-linear__background',
                        backgroundColorClasses.value
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        {
                            opacity: props.bgOpacity != null ? parseFloat(props.bgOpacity) : undefined,
                            width: props.stream ? 0 : undefined
                        },
                        props.indeterminate ? {} : splitStyles.value?.background
                    ])
                }, null);
            }
            useRender(()=>vue.createVNode(props.tag, {
                    "ref": root,
                    "class": vue.normalizeClass([
                        'v-progress-linear',
                        {
                            'v-progress-linear--absolute': props.absolute,
                            'v-progress-linear--active': props.active && isIntersecting.value,
                            'v-progress-linear--reverse': isReversed.value,
                            'v-progress-linear--rounded': props.rounded,
                            'v-progress-linear--rounded-bar': props.roundedBar,
                            'v-progress-linear--striped': props.striped,
                            'v-progress-linear--clickable': props.clickable,
                            'v-progress-linear--variant-split': props.variant === 'split'
                        },
                        roundedClasses.value,
                        themeClasses.value,
                        rtlClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            bottom: props.location === 'bottom' ? 0 : undefined,
                            top: props.location === 'top' ? 0 : undefined,
                            height: props.active ? convertToUnit(height.value) : 0,
                            '--v-progress-linear-height': convertToUnit(height.value),
                            '--v-progress-chunk-gap': convertToUnit(props.chunkGap),
                            ...props.absolute ? locationStyles.value : {}
                        },
                        chunksMaskStyles.value,
                        roundedStyles.value,
                        props.style
                    ]),
                    "role": "progressbar",
                    "aria-hidden": props.active ? 'false' : 'true',
                    "aria-valuemin": "0",
                    "aria-valuemax": props.max,
                    "aria-valuenow": props.indeterminate ? undefined : Math.min(parseFloat(progress.value), max.value),
                    "onClick": props.clickable && handleClick
                }, {
                    default: ()=>[
                            props.stream && vue.createElementVNode("div", {
                                "key": "stream",
                                "class": vue.normalizeClass([
                                    'v-progress-linear__stream',
                                    textColorClasses.value
                                ]),
                                "style": {
                                    ...textColorStyles.value,
                                    [isReversed.value ? 'left' : 'right']: convertToUnit(-height.value),
                                    borderTop: `${convertToUnit(height.value / 2)} dotted`,
                                    opacity: props.bufferOpacity != null ? parseFloat(props.bufferOpacity) : undefined,
                                    top: `calc(50% - ${convertToUnit(height.value / 4)})`,
                                    width: convertToUnit(100 - normalizedBuffer.value, '%'),
                                    '--v-progress-linear-stream-to': convertToUnit(height.value * (isReversed.value ? 1 : -1))
                                }
                            }, null),
                            (props.variant !== 'split' || !props.indeterminate) && renderBackgroundBar(),
                            vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    'v-progress-linear__buffer',
                                    bufferColorClasses.value
                                ]),
                                "style": vue.normalizeStyle([
                                    bufferColorStyles.value,
                                    {
                                        opacity: props.bufferOpacity != null ? parseFloat(props.bufferOpacity) : undefined,
                                        width: convertToUnit(bufferWidth.value, '%')
                                    },
                                    splitStyles.value?.buffer
                                ])
                            }, null),
                            vue.createVNode(vue.Transition, {
                                "name": transition.value
                            }, {
                                default: ()=>[
                                        !props.indeterminate ? vue.createElementVNode("div", {
                                            "class": vue.normalizeClass([
                                                'v-progress-linear__determinate',
                                                barColorClasses.value
                                            ]),
                                            "style": vue.normalizeStyle([
                                                barColorStyles.value,
                                                {
                                                    width: convertToUnit(barWidth.value, '%')
                                                },
                                                splitStyles.value?.bar
                                            ])
                                        }, null) : vue.createElementVNode("div", {
                                            "class": "v-progress-linear__indeterminate"
                                        }, [
                                            props.variant === 'split' && vue.createElementVNode(vue.Fragment, null, [
                                                renderBackgroundBar(),
                                                renderBackgroundBar(),
                                                renderBackgroundBar()
                                            ]),
                                            [
                                                'long',
                                                'short'
                                            ].map((bar)=>vue.createElementVNode("div", {
                                                    "key": bar,
                                                    "class": vue.normalizeClass([
                                                        'v-progress-linear__indeterminate',
                                                        bar,
                                                        barColorClasses.value
                                                    ]),
                                                    "style": vue.normalizeStyle(barColorStyles.value)
                                                }, null))
                                        ])
                                    ]
                            }),
                            slots.default && vue.createElementVNode("div", {
                                "class": "v-progress-linear__content"
                            }, [
                                slots.default({
                                    value: normalizedValue.value,
                                    buffer: normalizedBuffer.value
                                })
                            ])
                        ]
                }));
            return {};
        }
    });
    // Types
    // Composables
    const makeLoaderProps = propsFactory({
        loading: [
            Boolean,
            String
        ]
    }, 'loader');
    function useLoader(props, name = getCurrentInstanceName()) {
        const loaderClasses = vue.toRef(()=>({
                [`${name}--loading`]: props.loading
            }));
        return {
            loaderClasses: loaderClasses
        };
    }
    function LoaderSlot(props, { slots: slots }) {
        return vue.createElementVNode("div", {
            "class": vue.normalizeClass(`${props.name}__loader`)
        }, [
            slots.default?.({
                color: props.color,
                isActive: props.active
            }) || vue.createVNode(VProgressLinear, {
                "absolute": props.absolute,
                "active": props.active,
                "color": props.color,
                "height": "2",
                "indeterminate": true
            }, null)
        ]);
    }
    // Utilities
    // Types
    const positionValues = [
        'static',
        'relative',
        'fixed',
        'absolute',
        'sticky'
    ];
    // Composables
    const makePositionProps = propsFactory({
        position: {
            type: String,
            validator: /* istanbul ignore next */ (v)=>positionValues.includes(v)
        }
    }, 'position');
    function usePosition(props, name = getCurrentInstanceName()) {
        const positionClasses = vue.toRef(()=>{
            return props.position ? `${name}--${props.position}` : undefined;
        });
        return {
            positionClasses: positionClasses
        };
    }
    // Utilities
    // Types
    function useRoute() {
        const vm = getCurrentInstance('useRoute');
        return vue.computed(()=>vm?.proxy?.$route);
    }
    function useRouter() {
        return getCurrentInstance('useRouter')?.proxy?.$router;
    }
    function useLink(props, attrs) {
        const RouterLink = vue.resolveDynamicComponent('RouterLink');
        const isLink = vue.toRef(()=>!!(props.href || props.to));
        const isClickable = vue.computed(()=>{
            return isLink?.value || hasEvent(attrs, 'click') || hasEvent(props, 'click');
        });
        if (typeof RouterLink === 'string' || !('useLink' in RouterLink)) {
            const href = vue.toRef(()=>props.href);
            return {
                isLink: isLink,
                isRouterLink: vue.toRef(()=>false),
                isClickable: isClickable,
                href: href,
                linkProps: vue.reactive({
                    href: href
                }),
                route: vue.toRef(()=>undefined),
                navigate: vue.toRef(()=>undefined)
            };
        }
        // vue-router useLink `to` prop needs to be reactive and useLink will crash if undefined
        const routerLink = RouterLink.useLink({
            to: vue.toRef(()=>props.to || ''),
            replace: vue.toRef(()=>props.replace)
        });
        // Actual link needs to be undefined when to prop is not used
        const link = vue.computed(()=>props.to ? routerLink : undefined);
        const route = useRoute();
        const isActive = vue.computed(()=>{
            if (!link.value) return false;
            // router still resolving initial navigation, according to posva:
            // - START_LOCATION has an empty matched array and its name is undefined (unlike 404 Not Page Found)
            // - if the router is still resolving the initial boot, we bypass the active check and returns
            //   isExactActive ?? false to prevent the flashing overlay on page refresh
            if (route.value && route.value.matched.length === 0 && route.value.name == null) return link.value.isExactActive?.value ?? false;
            if (!props.exact) return link.value.isActive?.value ?? false;
            if (!route.value) return link.value.isExactActive?.value ?? false;
            return link.value.isExactActive?.value && deepEqual(link.value.route.value.query, route.value.query);
        });
        const href = vue.computed(()=>props.to ? link.value?.route.value.href : props.href);
        const isRouterLink = vue.toRef(()=>!!props.to);
        return {
            isLink: isLink,
            isRouterLink: isRouterLink,
            isClickable: isClickable,
            isActive: isActive,
            route: vue.toRef(()=>link.value?.route.value),
            navigate: vue.toRef(()=>link.value?.navigate),
            href: href,
            linkProps: vue.reactive({
                href: href,
                'aria-current': vue.toRef(()=>isActive.value ? 'page' : undefined),
                'aria-disabled': vue.toRef(()=>props.disabled && isLink.value ? 'true' : undefined),
                tabindex: vue.toRef(()=>props.disabled && isLink.value ? '-1' : undefined)
            })
        };
    }
    const makeRouterProps = propsFactory({
        href: String,
        replace: Boolean,
        to: [
            String,
            Object
        ],
        exact: Boolean
    }, 'router');
    let inTransition = false;
    function useBackButton(router, cb) {
        let popped = false;
        let removeBefore;
        let removeAfter;
        if (IN_BROWSER && router?.beforeEach) {
            vue.nextTick(()=>{
                window.addEventListener('popstate', onPopstate);
                removeBefore = router.beforeEach(()=>{
                    if (!inTransition) {
                        inTransition = true;
                        return new Promise((resolve)=>{
                            setTimeout(()=>resolve(popped ? cb() : undefined));
                        });
                    }
                    return popped ? cb() : undefined;
                });
                removeAfter = router?.afterEach(()=>{
                    inTransition = false;
                });
            });
            vue.onScopeDispose(()=>{
                window.removeEventListener('popstate', onPopstate);
                removeBefore?.();
                removeAfter?.();
            });
        }
        function onPopstate(e) {
            if (e.state?.replaced) return;
            popped = true;
            setTimeout(()=>popped = false);
        }
    }
    // Utilities
    // Types
    function useSelectLink(link, select) {
        vue.watch(()=>link.isActive?.value, (isActive)=>{
            if (link.isLink.value && isActive != null && select) vue.nextTick(()=>{
                select(isActive);
            });
        }, {
            immediate: true
        });
    }
    // Styles
    // Types
    const stopSymbol = Symbol('rippleStop');
    const DELAY_RIPPLE = 80;
    function transform(el, value) {
        el.style.transform = value;
        el.style.webkitTransform = value;
    }
    function isTouchEvent(e) {
        return e.constructor.name === 'TouchEvent';
    }
    function isKeyboardEvent(e) {
        return e.constructor.name === 'KeyboardEvent';
    }
    const calculate = (e, el, value = {})=>{
        let localX = 0;
        let localY = 0;
        if (!isKeyboardEvent(e)) {
            const offset = new Box(el);
            const target = isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
            const point = getTargetBox([
                target.clientX,
                target.clientY
            ]);
            localX = point.x - offset.left;
            localY = point.y - offset.top;
        }
        let radius = 0;
        let scale = 0.3;
        if (el._ripple?.circle) {
            scale = 0.15;
            radius = el.clientWidth / 2;
            radius = value.center ? radius : radius + Math.sqrt((localX - radius) ** 2 + (localY - radius) ** 2) / 4;
        } else radius = Math.sqrt(el.clientWidth ** 2 + el.clientHeight ** 2) / 2;
        const centerX = `${(el.clientWidth - radius * 2) / 2}px`;
        const centerY = `${(el.clientHeight - radius * 2) / 2}px`;
        const x = value.center ? centerX : `${localX - radius}px`;
        const y = value.center ? centerY : `${localY - radius}px`;
        return {
            radius: radius,
            scale: scale,
            x: x,
            y: y,
            centerX: centerX,
            centerY: centerY
        };
    };
    const ripples = {
        /* eslint-disable max-statements */ show (e, el, value = {}) {
            if (!el?._ripple?.enabled) return;
            const container = document.createElement('span');
            const animation = document.createElement('span');
            container.appendChild(animation);
            container.className = 'v-ripple__container';
            if (value.class) container.className += ` ${value.class}`;
            const { radius: radius, scale: scale, x: x, y: y, centerX: centerX, centerY: centerY } = calculate(e, el, value);
            const size = `${radius * 2}px`;
            animation.className = 'v-ripple__animation';
            animation.style.width = size;
            animation.style.height = size;
            el.appendChild(container);
            const computed = window.getComputedStyle(el);
            if (computed && computed.position === 'static') {
                el.style.position = 'relative';
                el.dataset.previousPosition = 'static';
            }
            animation.classList.add('v-ripple__animation--enter');
            animation.classList.add('v-ripple__animation--visible');
            transform(animation, `translate(${x}, ${y}) scale3d(${scale},${scale},${scale})`);
            animation.dataset.activated = String(performance.now());
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    animation.classList.remove('v-ripple__animation--enter');
                    animation.classList.add('v-ripple__animation--in');
                    transform(animation, `translate(${centerX}, ${centerY}) scale3d(1,1,1)`);
                });
            });
        },
        hide (el) {
            if (!el?._ripple?.enabled) return;
            const ripples = el.getElementsByClassName('v-ripple__animation');
            if (ripples.length === 0) return;
            const animation = Array.from(ripples).findLast((ripple)=>!ripple.dataset.isHiding);
            if (!animation) return;
            else animation.dataset.isHiding = 'true';
            const diff = performance.now() - Number(animation.dataset.activated);
            const delay = Math.max(250 - diff, 0);
            setTimeout(()=>{
                animation.classList.remove('v-ripple__animation--in');
                animation.classList.add('v-ripple__animation--out');
                setTimeout(()=>{
                    const ripples = el.getElementsByClassName('v-ripple__animation');
                    if (ripples.length === 1 && el.dataset.previousPosition) {
                        el.style.position = el.dataset.previousPosition;
                        delete el.dataset.previousPosition;
                    }
                    if (animation.parentNode?.parentNode === el) el.removeChild(animation.parentNode);
                }, 300);
            }, delay);
        }
    };
    function isRippleEnabled(value) {
        return typeof value === 'undefined' || !!value;
    }
    function rippleShow(e) {
        const value = {};
        const element = e.currentTarget;
        if (!element?._ripple || element._ripple.touched || e[stopSymbol]) return;
        // Don't allow the event to trigger ripples on any other elements
        e[stopSymbol] = true;
        if (isTouchEvent(e)) {
            element._ripple.touched = true;
            element._ripple.isTouch = true;
        } else {
            // It's possible for touch events to fire
            // as mouse events on Android/iOS, this
            // will skip the event call if it has
            // already been registered as touch
            if (element._ripple.isTouch) return;
        }
        value.center = element._ripple.centered || isKeyboardEvent(e);
        if (element._ripple.class) value.class = element._ripple.class;
        if (isTouchEvent(e)) {
            // already queued that shows or hides the ripple
            if (element._ripple.showTimerCommit) return;
            element._ripple.showTimerCommit = ()=>{
                ripples.show(e, element, value);
            };
            element._ripple.showTimer = window.setTimeout(()=>{
                if (element?._ripple?.showTimerCommit) {
                    element._ripple.showTimerCommit();
                    element._ripple.showTimerCommit = null;
                }
            }, DELAY_RIPPLE);
        } else ripples.show(e, element, value);
    }
    function rippleStop(e) {
        e[stopSymbol] = true;
    }
    function rippleHide(e) {
        const element = e.currentTarget;
        if (!element?._ripple) return;
        window.clearTimeout(element._ripple.showTimer);
        // The touch interaction occurs before the show timer is triggered.
        // We still want to show ripple effect.
        if (e.type === 'touchend' && element._ripple.showTimerCommit) {
            element._ripple.showTimerCommit();
            element._ripple.showTimerCommit = null;
            // re-queue ripple hiding
            element._ripple.showTimer = window.setTimeout(()=>{
                rippleHide(e);
            });
            return;
        }
        window.setTimeout(()=>{
            if (element._ripple) element._ripple.touched = false;
        });
        ripples.hide(element);
    }
    function rippleCancelShow(e) {
        const element = e.currentTarget;
        if (!element?._ripple) return;
        if (element._ripple.showTimerCommit) element._ripple.showTimerCommit = null;
        window.clearTimeout(element._ripple.showTimer);
    }
    let keyboardRipple = false;
    function keyboardRippleShow(e, keys) {
        if (!keyboardRipple && keys.includes(e.key)) {
            keyboardRipple = true;
            rippleShow(e);
        }
    }
    function keyboardRippleHide(e) {
        keyboardRipple = false;
        rippleHide(e);
    }
    function focusRippleHide(e) {
        if (keyboardRipple) {
            keyboardRipple = false;
            rippleHide(e);
        }
    }
    function updateRipple(el, binding, wasEnabled) {
        const { value: value, modifiers: modifiers } = binding;
        const enabled = isRippleEnabled(value);
        if (!enabled) ripples.hide(el);
        el._ripple = el._ripple ?? {};
        el._ripple.enabled = enabled;
        el._ripple.centered = modifiers.center;
        el._ripple.circle = modifiers.circle;
        const bindingValue = isObject(value) ? value : {};
        if (bindingValue.class) el._ripple.class = bindingValue.class;
        const allowedKeys = bindingValue.keys ?? [
            'Enter',
            'Space'
        ];
        el._ripple.keyDownHandler = (e)=>keyboardRippleShow(e, allowedKeys);
        if (enabled && !wasEnabled) {
            if (modifiers.stop) {
                el.addEventListener('touchstart', rippleStop, {
                    passive: true
                });
                el.addEventListener('mousedown', rippleStop);
                return;
            }
            el.addEventListener('touchstart', rippleShow, {
                passive: true
            });
            el.addEventListener('touchend', rippleHide, {
                passive: true
            });
            el.addEventListener('touchmove', rippleCancelShow, {
                passive: true
            });
            el.addEventListener('touchcancel', rippleHide);
            el.addEventListener('mousedown', rippleShow);
            el.addEventListener('mouseup', rippleHide);
            el.addEventListener('mouseleave', rippleHide);
            el.addEventListener('keydown', el._ripple.keyDownHandler);
            el.addEventListener('keyup', keyboardRippleHide);
            el.addEventListener('blur', focusRippleHide);
            // Anchor tags can be dragged, causes other hides to fail - #1537
            el.addEventListener('dragstart', rippleHide, {
                passive: true
            });
        } else if (!enabled && wasEnabled) removeListeners(el);
    }
    function removeListeners(el) {
        el.removeEventListener('touchstart', rippleStop);
        el.removeEventListener('mousedown', rippleStop);
        el.removeEventListener('touchstart', rippleShow);
        el.removeEventListener('touchend', rippleHide);
        el.removeEventListener('touchmove', rippleCancelShow);
        el.removeEventListener('touchcancel', rippleHide);
        el.removeEventListener('mousedown', rippleShow);
        el.removeEventListener('mouseup', rippleHide);
        el.removeEventListener('mouseleave', rippleHide);
        if (el._ripple?.keyDownHandler) el.removeEventListener('keydown', el._ripple.keyDownHandler);
        el.removeEventListener('keyup', keyboardRippleHide);
        el.removeEventListener('blur', focusRippleHide);
        el.removeEventListener('dragstart', rippleHide);
    }
    function mounted$4(el, binding) {
        updateRipple(el, binding, false);
    }
    function unmounted$4(el) {
        removeListeners(el);
        delete el._ripple;
    }
    function updated$1(el, binding) {
        if (binding.value === binding.oldValue) return;
        const wasEnabled = isRippleEnabled(binding.oldValue);
        updateRipple(el, binding, wasEnabled);
    }
    const Ripple = {
        mounted: mounted$4,
        unmounted: unmounted$4,
        updated: updated$1
    };
    // Types
    const makeVBtnProps = propsFactory({
        active: {
            type: Boolean,
            default: undefined
        },
        activeColor: String,
        baseColor: String,
        symbol: {
            type: null,
            default: VBtnToggleSymbol
        },
        flat: Boolean,
        icon: [
            Boolean,
            String,
            Function,
            Object
        ],
        prependIcon: IconValue,
        appendIcon: IconValue,
        block: Boolean,
        readonly: Boolean,
        slim: Boolean,
        stacked: Boolean,
        spaced: String,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        },
        text: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeGroupItemProps(),
        ...makeLoaderProps(),
        ...makeLocationProps(),
        ...makePositionProps(),
        ...makeRoundedProps(),
        ...makeRouterProps(),
        ...makeSizeProps(),
        ...makeTagProps({
            tag: 'button'
        }),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'elevated'
        })
    }, 'VBtn');
    const VBtn = genericComponent()({
        name: 'VBtn',
        props: makeVBtnProps(),
        emits: {
            'group:selected': (val)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { loaderClasses: loaderClasses } = useLoader(props);
            const { locationStyles: locationStyles } = useLocation(props);
            const { positionClasses: positionClasses } = usePosition(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = useSize(props);
            const group = useGroupItem(props, props.symbol, false);
            const link = useLink(props, attrs);
            const isActive = vue.computed(()=>{
                if (props.active !== undefined) return props.active;
                if (link.isRouterLink.value) return link.isActive?.value;
                return group?.isSelected.value;
            });
            const color = vue.toRef(()=>isActive.value ? props.activeColor ?? props.color : props.color);
            const variantProps = vue.computed(()=>{
                const showColor = group?.isSelected.value && (!link.isLink.value || link.isActive?.value) || !group || link.isActive?.value;
                return {
                    color: showColor ? color.value ?? props.baseColor : props.baseColor,
                    variant: props.variant
                };
            });
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(variantProps);
            const isDisabled = vue.computed(()=>group?.disabled.value || props.disabled);
            const isElevated = vue.toRef(()=>{
                return props.variant === 'elevated' && !(props.disabled || props.flat || props.border);
            });
            const valueAttr = vue.computed(()=>{
                if (props.value === undefined || typeof props.value === 'symbol') return undefined;
                return Object(props.value) === props.value ? JSON.stringify(props.value, null, 0) : props.value;
            });
            function onClick(e) {
                if (isDisabled.value || link.isLink.value && (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || attrs.target === '_blank')) return;
                if (link.isRouterLink.value) link.navigate.value?.(e);
                else // Group active state for links is handled by useSelectLink
                group?.toggle();
            }
            useSelectLink(link, group?.select);
            useRender(()=>{
                const Tag = link.isLink.value ? 'a' : props.tag;
                const hasPrepend = !!(props.prependIcon || slots.prepend);
                const hasAppend = !!(props.appendIcon || slots.append);
                const hasIcon = !!(props.icon && props.icon !== true);
                return vue.withDirectives(vue.createVNode(Tag, vue.mergeProps(link.linkProps, {
                    "type": Tag === 'a' ? undefined : 'button',
                    "class": [
                        'v-btn',
                        group?.selectedClass.value,
                        {
                            'v-btn--active': isActive.value,
                            'v-btn--block': props.block,
                            'v-btn--disabled': isDisabled.value,
                            'v-btn--elevated': isElevated.value,
                            'v-btn--flat': props.flat,
                            'v-btn--icon': !!props.icon,
                            'v-btn--loading': props.loading,
                            'v-btn--readonly': props.readonly,
                            'v-btn--slim': props.slim,
                            'v-btn--stacked': props.stacked
                        },
                        props.spaced ? [
                            'v-btn--spaced',
                            `v-btn--spaced-${props.spaced}`
                        ] : [],
                        themeClasses.value,
                        borderClasses.value,
                        colorClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        loaderClasses.value,
                        positionClasses.value,
                        roundedClasses.value,
                        sizeClasses.value,
                        variantClasses.value,
                        props.class
                    ],
                    "style": [
                        colorStyles.value,
                        dimensionStyles.value,
                        locationStyles.value,
                        sizeStyles.value,
                        roundedStyles.value,
                        props.style
                    ],
                    "aria-busy": props.loading ? true : undefined,
                    "disabled": isDisabled.value && Tag !== 'a' || undefined,
                    "tabindex": props.loading || props.readonly ? -1 : undefined,
                    "onClick": onClick,
                    "value": Tag !== 'a' ? valueAttr.value : undefined
                }), {
                    default: ()=>[
                            genOverlays(true, 'v-btn'),
                            !props.icon && hasPrepend && vue.createElementVNode("span", {
                                "key": "prepend",
                                "class": "v-btn__prepend"
                            }, [
                                !slots.prepend ? vue.createVNode(VIcon, {
                                    "key": "prepend-icon",
                                    "icon": props.prependIcon
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "prepend-defaults",
                                    "disabled": !props.prependIcon,
                                    "defaults": {
                                        VIcon: {
                                            icon: props.prependIcon
                                        }
                                    }
                                }, slots.prepend)
                            ]),
                            vue.createElementVNode("span", {
                                "class": "v-btn__content",
                                "data-no-activator": ""
                            }, [
                                !slots.default && hasIcon ? vue.createVNode(VIcon, {
                                    "key": "content-icon",
                                    "icon": props.icon
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "content-defaults",
                                    "disabled": !hasIcon,
                                    "defaults": {
                                        VIcon: {
                                            icon: props.icon
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.default?.() ?? vue.toDisplayString(props.text)
                                        ]
                                })
                            ]),
                            !props.icon && hasAppend && vue.createElementVNode("span", {
                                "key": "append",
                                "class": "v-btn__append"
                            }, [
                                !slots.append ? vue.createVNode(VIcon, {
                                    "key": "append-icon",
                                    "icon": props.appendIcon
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "append-defaults",
                                    "disabled": !props.appendIcon,
                                    "defaults": {
                                        VIcon: {
                                            icon: props.appendIcon
                                        }
                                    }
                                }, slots.append)
                            ]),
                            !!props.loading && vue.createElementVNode("span", {
                                "key": "loader",
                                "class": "v-btn__loader"
                            }, [
                                slots.loader?.() ?? vue.createVNode(VProgressCircular, {
                                    "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                    "indeterminate": true,
                                    "width": "2"
                                }, null)
                            ])
                        ]
                }), [
                    [
                        Ripple,
                        !isDisabled.value && props.ripple,
                        '',
                        {
                            center: !!props.icon
                        }
                    ]
                ]);
            });
            return {
                group: group
            };
        }
    });
    // Types
    const makeVAppBarNavIconProps = propsFactory({
        ...omit(makeVBtnProps({
            icon: '$menu',
            variant: 'text'
        }), [
            'spaced'
        ])
    }, 'VAppBarNavIcon');
    const VAppBarNavIcon = genericComponent()({
        name: 'VAppBarNavIcon',
        props: makeVAppBarNavIconProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createVNode(VBtn, vue.mergeProps(props, {
                    "class": [
                        'v-app-bar-nav-icon'
                    ]
                }), slots));
            return {};
        }
    });
    // Types
    const VAppBarTitle = genericComponent()({
        name: 'VAppBarTitle',
        props: makeVToolbarTitleProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createVNode(VToolbarTitle, vue.mergeProps(props, {
                    "class": "v-app-bar-title"
                }), slots));
            return {};
        }
    });
    // Utilities
    const VAlertTitle = createSimpleFunctional('v-alert-title');
    // Utilities
    // Types
    // Types
    // Composables
    const makeIconSizeProps = propsFactory({
        iconSize: [
            Number,
            String
        ],
        iconSizes: {
            type: Array,
            default: ()=>[
                    [
                        'x-small',
                        10
                    ],
                    [
                        'small',
                        16
                    ],
                    [
                        'default',
                        24
                    ],
                    [
                        'large',
                        28
                    ],
                    [
                        'x-large',
                        32
                    ]
                ]
        }
    }, 'iconSize');
    function useIconSizes(props, fallback) {
        const iconSize = vue.computed(()=>{
            const iconSizeMap = new Map(props.iconSizes);
            const _iconSize = props.iconSize ?? fallback() ?? 'default';
            return iconSizeMap.has(_iconSize) ? iconSizeMap.get(_iconSize) : _iconSize;
        });
        return {
            iconSize: iconSize
        };
    }
    // Types
    const allowedTypes = [
        'success',
        'info',
        'warning',
        'error'
    ];
    const makeVAlertProps = propsFactory({
        border: {
            type: [
                Boolean,
                String
            ],
            validator: (val)=>{
                return typeof val === 'boolean' || [
                    'top',
                    'end',
                    'bottom',
                    'start'
                ].includes(val);
            }
        },
        borderColor: String,
        closable: Boolean,
        closeIcon: {
            type: IconValue,
            default: '$close'
        },
        closeLabel: {
            type: String,
            default: '$vuetify.close'
        },
        icon: {
            type: [
                Boolean,
                String,
                Function,
                Object
            ],
            default: null
        },
        modelValue: {
            type: Boolean,
            default: true
        },
        prominent: Boolean,
        title: String,
        text: String,
        type: {
            type: String,
            validator: (val)=>allowedTypes.includes(val)
        },
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeIconSizeProps(),
        ...makeLocationProps(),
        ...makePositionProps(),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'flat'
        })
    }, 'VAlert');
    const VAlert = genericComponent()({
        name: 'VAlert',
        props: makeVAlertProps(),
        emits: {
            'click:close': (e)=>true,
            'update:modelValue': (value)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const isActive = useProxiedModel(props, 'modelValue');
            const icon = vue.toRef(()=>{
                if (props.icon === false) return undefined;
                if (!props.type) return props.icon;
                return props.icon ?? `$${props.type}`;
            });
            const { iconSize: iconSize } = useIconSizes(props, ()=>props.prominent ? 44 : undefined);
            const { themeClasses: themeClasses } = provideTheme(props);
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(()=>({
                    color: props.color ?? props.type,
                    variant: props.variant
                }));
            const { densityClasses: densityClasses } = useDensity(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { locationStyles: locationStyles } = useLocation(props);
            const { positionClasses: positionClasses } = usePosition(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.borderColor);
            const { t: t } = useLocale();
            const closeProps = vue.toRef(()=>({
                    'aria-label': t(props.closeLabel),
                    onClick (e) {
                        isActive.value = false;
                        emit('click:close', e);
                    }
                }));
            return ()=>{
                const hasPrepend = !!(slots.prepend || icon.value);
                const hasTitle = !!(slots.title || props.title);
                const hasClose = !!(slots.close || props.closable);
                const iconProps = {
                    density: props.density,
                    icon: icon.value,
                    size: props.iconSize || props.prominent ? iconSize.value : undefined
                };
                return isActive.value && vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-alert',
                        props.border && {
                            'v-alert--border': !!props.border,
                            [`v-alert--border-${props.border === true ? 'start' : props.border}`]: true
                        },
                        {
                            'v-alert--prominent': props.prominent
                        },
                        themeClasses.value,
                        colorClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        positionClasses.value,
                        roundedClasses.value,
                        variantClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        colorStyles.value,
                        dimensionStyles.value,
                        locationStyles.value,
                        roundedStyles.value,
                        props.style
                    ]),
                    "role": "alert"
                }, {
                    default: ()=>[
                            genOverlays(false, 'v-alert'),
                            props.border && vue.createElementVNode("div", {
                                "key": "border",
                                "class": vue.normalizeClass([
                                    'v-alert__border',
                                    textColorClasses.value
                                ]),
                                "style": vue.normalizeStyle(textColorStyles.value)
                            }, null),
                            hasPrepend && vue.createElementVNode("div", {
                                "key": "prepend",
                                "class": "v-alert__prepend"
                            }, [
                                !slots.prepend ? vue.createVNode(VIcon, vue.mergeProps({
                                    "key": "prepend-icon"
                                }, iconProps), null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "prepend-defaults",
                                    "disabled": !icon.value,
                                    "defaults": {
                                        VIcon: {
                                            ...iconProps
                                        }
                                    }
                                }, slots.prepend)
                            ]),
                            vue.createElementVNode("div", {
                                "class": "v-alert__content"
                            }, [
                                hasTitle && vue.createVNode(VAlertTitle, {
                                    "key": "title"
                                }, {
                                    default: ()=>[
                                            slots.title?.() ?? props.title
                                        ]
                                }),
                                slots.text?.() ?? props.text,
                                slots.default?.()
                            ]),
                            slots.append && vue.createElementVNode("div", {
                                "key": "append",
                                "class": "v-alert__append"
                            }, [
                                slots.append()
                            ]),
                            hasClose && vue.createElementVNode("div", {
                                "key": "close",
                                "class": "v-alert__close"
                            }, [
                                !slots.close ? vue.createVNode(VBtn, vue.mergeProps({
                                    "key": "close-btn",
                                    "icon": props.closeIcon,
                                    "size": "x-small",
                                    "variant": "text"
                                }, closeProps.value), null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "close-defaults",
                                    "defaults": {
                                        VBtn: {
                                            icon: props.closeIcon,
                                            size: 'x-small',
                                            variant: 'text'
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.close?.({
                                                props: closeProps.value
                                            })
                                        ]
                                })
                            ])
                        ]
                });
            };
        }
    });
    const makeVBadgeProps = propsFactory({
        bordered: Boolean,
        color: String,
        content: [
            Number,
            String
        ],
        dot: Boolean,
        dotSize: [
            Number,
            String
        ],
        floating: Boolean,
        icon: IconValue,
        inline: Boolean,
        label: {
            type: String,
            default: '$vuetify.badge'
        },
        max: [
            Number,
            String
        ],
        modelValue: {
            type: Boolean,
            default: true
        },
        offsetX: [
            Number,
            String
        ],
        offsetY: [
            Number,
            String
        ],
        textColor: String,
        ...makeComponentProps(),
        ...makeLocationProps({
            location: 'top end'
        }),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeTransitionProps({
            transition: 'scale-rotate-transition'
        }),
        ...makeDimensionProps()
    }, 'VBadge');
    const VBadge = genericComponent()({
        name: 'VBadge',
        inheritAttrs: false,
        props: makeVBadgeProps(),
        setup (props, ctx) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { t: t } = useLocale();
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.textColor);
            const { themeClasses: themeClasses } = useTheme();
            const { locationStyles: locationStyles } = useLocation(props, true, (side)=>{
                const base = props.floating ? props.dot ? 2 : 4 : props.dot ? Number(props.dotSize ?? 8) : 12;
                return base + ([
                    'top',
                    'bottom'
                ].includes(side) ? Number(props.offsetY ?? 0) : [
                    'left',
                    'right'
                ].includes(side) ? Number(props.offsetX ?? 0) : 0);
            });
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            useRender(()=>{
                const value = Number(props.content);
                const content = !props.max || isNaN(value) ? props.content : value <= Number(props.max) ? value : `${props.max}+`;
                const [badgeAttrs, attrs] = pickWithRest(ctx.attrs, [
                    'aria-atomic',
                    'aria-label',
                    'aria-live',
                    'role',
                    'title'
                ]);
                return vue.createVNode(props.tag, vue.mergeProps({
                    "class": [
                        'v-badge',
                        {
                            'v-badge--bordered': props.bordered,
                            'v-badge--dot': props.dot,
                            'v-badge--floating': props.floating,
                            'v-badge--inline': props.inline
                        },
                        props.class
                    ]
                }, attrs, {
                    "style": props.style
                }), {
                    default: ()=>[
                            vue.createElementVNode("div", {
                                "class": "v-badge__wrapper"
                            }, [
                                ctx.slots.default?.(),
                                vue.createVNode(MaybeTransition, {
                                    "transition": props.transition
                                }, {
                                    default: ()=>[
                                            vue.withDirectives(vue.createElementVNode("span", vue.mergeProps({
                                                "class": [
                                                    'v-badge__badge',
                                                    themeClasses.value,
                                                    backgroundColorClasses.value,
                                                    roundedClasses.value,
                                                    textColorClasses.value
                                                ],
                                                "style": [
                                                    backgroundColorStyles.value,
                                                    textColorStyles.value,
                                                    dimensionStyles.value,
                                                    props.inline ? {} : locationStyles.value,
                                                    props.dot && props.dotSize ? {
                                                        width: convertToUnit(props.dotSize),
                                                        height: convertToUnit(props.dotSize)
                                                    } : {},
                                                    roundedStyles.value
                                                ],
                                                "aria-atomic": "true",
                                                "aria-label": t(props.label, value),
                                                "aria-live": "polite",
                                                "role": "status"
                                            }, badgeAttrs), [
                                                props.dot ? undefined : ctx.slots.badge ? ctx.slots.badge?.() : props.icon ? vue.createVNode(VIcon, {
                                                    "icon": props.icon
                                                }, null) : content
                                            ]), [
                                                [
                                                    vue.vShow,
                                                    props.modelValue
                                                ]
                                            ])
                                        ]
                                })
                            ])
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVAvatarProps = propsFactory({
        badge: {
            type: [
                Boolean,
                Object
            ],
            default: false
        },
        start: Boolean,
        end: Boolean,
        icon: IconValue,
        image: String,
        text: String,
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeRoundedProps(),
        ...makeSizeProps(),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'flat'
        })
    }, 'VAvatar');
    const VAvatar = genericComponent()({
        name: 'VAvatar',
        props: makeVAvatarProps(),
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = useSize(props);
            const badgeDotSize = vue.computed(()=>{
                switch(props.size){
                    case 'x-small':
                        return 8;
                    case 'small':
                        return 10;
                    case 'large':
                        return 14;
                    case 'x-large':
                        return 16;
                    default:
                        return 12;
                }
            });
            const badgeOffset = vue.computed(()=>{
                const { floating: floating } = isObject(props.badge) ? props.badge : {};
                return (floating ? badgeDotSize.value / 2 : 0) - 1.5;
            });
            const badgeProps = vue.computed(()=>{
                return {
                    bordered: true,
                    dot: !slots.badge,
                    dotSize: badgeDotSize.value,
                    offsetX: badgeOffset.value,
                    offsetY: badgeOffset.value,
                    color: typeof props.badge === 'string' ? props.badge : 'primary',
                    ...isObject(props.badge) ? props.badge : {}
                };
            });
            useRender(()=>{
                const avatar = vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-avatar',
                        {
                            'v-avatar--start': props.start,
                            'v-avatar--end': props.end
                        },
                        themeClasses.value,
                        borderClasses.value,
                        colorClasses.value,
                        densityClasses.value,
                        roundedClasses.value,
                        sizeClasses.value,
                        variantClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        colorStyles.value,
                        sizeStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            !slots.default ? props.image ? vue.createVNode(VImg, {
                                "key": "image",
                                "src": props.image,
                                "alt": "",
                                "cover": true
                            }, null) : props.icon ? vue.createVNode(VIcon, {
                                "key": "icon",
                                "icon": props.icon
                            }, null) : props.text : vue.createVNode(VDefaultsProvider, {
                                "key": "content-defaults",
                                "defaults": {
                                    VImg: {
                                        cover: true,
                                        src: props.image
                                    },
                                    VIcon: {
                                        icon: props.icon
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.default()
                                    ]
                            }),
                            genOverlays(false, 'v-avatar')
                        ]
                });
                return props.badge ? vue.createVNode(VBadge, badgeProps.value, {
                    default: ()=>avatar,
                    badge: slots.badge
                }) : avatar;
            });
            return {};
        }
    });
    const makeVLabelProps = propsFactory({
        text: String,
        onClick: EventProp(),
        ...makeComponentProps(),
        ...makeThemeProps()
    }, 'VLabel');
    const VLabel = genericComponent()({
        name: 'VLabel',
        props: makeVLabelProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createElementVNode("label", {
                    "class": vue.normalizeClass([
                        'v-label',
                        {
                            'v-label--clickable': !!props.onClick
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "onClick": props.onClick
                }, [
                    props.text,
                    slots.default?.()
                ]));
            return {};
        }
    });
    // Types
    const VSelectionControlGroupSymbol = Symbol.for('vuetify:selection-control-group');
    const makeSelectionControlGroupProps = propsFactory({
        color: String,
        disabled: {
            type: Boolean,
            default: null
        },
        defaultsTarget: String,
        error: Boolean,
        id: String,
        inline: Boolean,
        falseIcon: IconValue,
        trueIcon: IconValue,
        indeterminateIcon: IconValue,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        },
        multiple: {
            type: Boolean,
            default: null
        },
        name: String,
        readonly: {
            type: Boolean,
            default: null
        },
        modelValue: null,
        type: String,
        valueComparator: {
            type: Function,
            default: deepEqual
        },
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeThemeProps()
    }, 'SelectionControlGroup');
    const makeVSelectionControlGroupProps = propsFactory({
        ...makeSelectionControlGroupProps({
            defaultsTarget: 'VSelectionControl'
        })
    }, 'VSelectionControlGroup');
    const VSelectionControlGroup = genericComponent()({
        name: 'VSelectionControlGroup',
        props: makeVSelectionControlGroupProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const modelValue = useProxiedModel(props, 'modelValue');
            const uid = vue.useId();
            const id = vue.toRef(()=>props.id || `v-selection-control-group-${uid}`);
            const name = vue.toRef(()=>props.name || id.value);
            const updateHandlers = new Set();
            vue.provide(VSelectionControlGroupSymbol, {
                modelValue: modelValue,
                forceUpdate: ()=>{
                    updateHandlers.forEach((fn)=>fn());
                },
                onForceUpdate: (cb)=>{
                    updateHandlers.add(cb);
                    vue.onScopeDispose(()=>{
                        updateHandlers.delete(cb);
                    });
                }
            });
            provideDefaults({
                [props.defaultsTarget]: {
                    color: vue.toRef(()=>props.color),
                    disabled: vue.toRef(()=>props.disabled),
                    density: vue.toRef(()=>props.density),
                    error: vue.toRef(()=>props.error),
                    inline: vue.toRef(()=>props.inline),
                    modelValue: modelValue,
                    multiple: vue.toRef(()=>!!props.multiple || props.multiple == null && Array.isArray(modelValue.value)),
                    name: name,
                    falseIcon: vue.toRef(()=>props.falseIcon),
                    trueIcon: vue.toRef(()=>props.trueIcon),
                    readonly: vue.toRef(()=>props.readonly),
                    ripple: vue.toRef(()=>props.ripple),
                    type: vue.toRef(()=>props.type),
                    valueComparator: vue.toRef(()=>props.valueComparator)
                }
            });
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-selection-control-group',
                        {
                            'v-selection-control-group--inline': props.inline
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "role": props.type === 'radio' ? 'radiogroup' : undefined
                }, [
                    slots.default?.()
                ]));
            return {};
        }
    });
    // Types
    const makeVSelectionControlProps = propsFactory({
        indeterminate: Boolean,
        label: String,
        baseColor: String,
        trueValue: null,
        falseValue: null,
        value: null,
        ...makeComponentProps(),
        ...makeSelectionControlGroupProps()
    }, 'VSelectionControl');
    function useSelectionControl(props) {
        const group = vue.inject(VSelectionControlGroupSymbol, undefined);
        const { densityClasses: densityClasses } = useDensity(props);
        const modelValue = useProxiedModel(props, 'modelValue');
        const trueValue = vue.computed(()=>props.trueValue !== undefined ? props.trueValue : props.value !== undefined ? props.value : true);
        const falseValue = vue.computed(()=>props.falseValue !== undefined ? props.falseValue : false);
        const isMultiple = vue.computed(()=>!!props.multiple || props.multiple == null && Array.isArray(modelValue.value));
        const model = vue.computed({
            get () {
                const val = group ? group.modelValue.value : modelValue.value;
                return isMultiple.value ? wrapInArray(val).some((v)=>props.valueComparator(v, trueValue.value)) : props.valueComparator(val, trueValue.value);
            },
            set (val) {
                if (props.readonly) return;
                const currentValue = val ? trueValue.value : falseValue.value;
                let newVal = currentValue;
                if (isMultiple.value) newVal = val ? [
                    ...wrapInArray(modelValue.value),
                    currentValue
                ] : wrapInArray(modelValue.value).filter((item)=>!props.valueComparator(item, trueValue.value));
                if (group) group.modelValue.value = newVal;
                else modelValue.value = newVal;
            }
        });
        const isActive = vue.computed(()=>model.value || props.indeterminate);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>{
            if (props.error || props.disabled) return undefined;
            return isActive.value ? props.color : props.baseColor;
        });
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>{
            return isActive.value && !props.error && !props.disabled ? props.color : props.baseColor;
        });
        const icon = vue.computed(()=>props.indeterminate ? props.indeterminateIcon : model.value ? props.trueIcon : props.falseIcon);
        return {
            group: group,
            densityClasses: densityClasses,
            trueValue: trueValue,
            falseValue: falseValue,
            model: model,
            textColorClasses: textColorClasses,
            textColorStyles: textColorStyles,
            backgroundColorClasses: backgroundColorClasses,
            backgroundColorStyles: backgroundColorStyles,
            icon: icon
        };
    }
    const VSelectionControl = genericComponent()({
        name: 'VSelectionControl',
        directives: {
            vRipple: Ripple
        },
        inheritAttrs: false,
        props: makeVSelectionControlProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const { group: group, densityClasses: densityClasses, icon: icon, model: model, textColorClasses: textColorClasses, textColorStyles: textColorStyles, backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles, trueValue: trueValue } = useSelectionControl(props);
            const uid = vue.useId();
            const isFocused = vue.shallowRef(false);
            const isFocusVisible = vue.shallowRef(false);
            const input = vue.ref();
            const id = vue.toRef(()=>props.id || `input-${uid}`);
            const isInteractive = vue.toRef(()=>!props.disabled && !props.readonly);
            group?.onForceUpdate(()=>{
                if (input.value) input.value.checked = model.value;
            });
            function onFocus(e) {
                if (props.disabled) return;
                isFocused.value = true;
                if (matchesSelector(e.target, ':focus-visible') !== false) isFocusVisible.value = true;
            }
            function onBlur() {
                isFocused.value = false;
                isFocusVisible.value = false;
            }
            function onClickLabel(e) {
                e.stopPropagation();
            }
            function onInput(e) {
                if (!isInteractive.value) {
                    if (input.value) // model value is not updated when input is not interactive
                    // but the internal checked state of the input is still updated,
                    // so here its value is restored
                    input.value.checked = model.value;
                    return;
                }
                if (props.readonly && group) vue.nextTick(()=>group.forceUpdate());
                model.value = e.target.checked;
            }
            useRender(()=>{
                const label = slots.label ? slots.label({
                    label: props.label,
                    props: {
                        for: id.value
                    }
                }) : props.label;
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                const inputNode = vue.createElementVNode("input", vue.mergeProps({
                    "ref": input,
                    "checked": model.value,
                    "disabled": !!props.disabled,
                    "id": id.value,
                    "onBlur": onBlur,
                    "onFocus": onFocus,
                    "onInput": onInput,
                    "aria-disabled": !!props.disabled,
                    "aria-label": props.label,
                    "type": props.type,
                    "value": trueValue.value,
                    "name": props.name,
                    "aria-checked": props.type === 'checkbox' ? model.value : undefined
                }, inputAttrs), null);
                return vue.createElementVNode("div", vue.mergeProps({
                    "class": [
                        'v-selection-control',
                        {
                            'v-selection-control--dirty': model.value,
                            'v-selection-control--indeterminate': props.indeterminate,
                            'v-selection-control--disabled': props.disabled,
                            'v-selection-control--error': props.error,
                            'v-selection-control--focused': isFocused.value,
                            'v-selection-control--focus-visible': isFocusVisible.value,
                            'v-selection-control--inline': props.inline
                        },
                        densityClasses.value,
                        props.class
                    ]
                }, rootAttrs, {
                    "style": props.style
                }), [
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-selection-control__wrapper',
                            textColorClasses.value
                        ]),
                        "style": vue.normalizeStyle(textColorStyles.value)
                    }, [
                        slots.default?.({
                            backgroundColorClasses: backgroundColorClasses,
                            backgroundColorStyles: backgroundColorStyles
                        }),
                        vue.withDirectives(vue.createElementVNode("div", {
                            "class": vue.normalizeClass([
                                'v-selection-control__input'
                            ])
                        }, [
                            slots.input?.({
                                model: model,
                                textColorClasses: textColorClasses,
                                textColorStyles: textColorStyles,
                                backgroundColorClasses: backgroundColorClasses,
                                backgroundColorStyles: backgroundColorStyles,
                                inputNode: inputNode,
                                icon: icon.value,
                                props: {
                                    onFocus: onFocus,
                                    onBlur: onBlur,
                                    id: id.value
                                }
                            }) ?? vue.createElementVNode(vue.Fragment, null, [
                                icon.value && vue.createVNode(VIcon, {
                                    "key": "icon",
                                    "icon": icon.value
                                }, null),
                                inputNode
                            ])
                        ]), [
                            [
                                Ripple,
                                !props.disabled && !props.readonly && props.ripple,
                                null,
                                {
                                    center: true,
                                    circle: true
                                }
                            ]
                        ])
                    ]),
                    label && vue.createVNode(VLabel, {
                        "for": id.value,
                        "onClick": onClickLabel
                    }, {
                        default: ()=>[
                                label
                            ]
                    })
                ]);
            });
            return {
                isFocused: isFocused,
                input: input
            };
        }
    });
    // Types
    const makeVCheckboxBtnProps = propsFactory({
        ...makeVSelectionControlProps({
            falseIcon: '$checkboxOff',
            trueIcon: '$checkboxOn',
            indeterminateIcon: '$checkboxIndeterminate'
        })
    }, 'VCheckboxBtn');
    const VCheckboxBtn = genericComponent()({
        name: 'VCheckboxBtn',
        props: makeVCheckboxBtnProps(),
        emits: {
            'update:modelValue': (value)=>true,
            'update:indeterminate': (value)=>true
        },
        setup (props, { slots: slots }) {
            const indeterminate = useProxiedModel(props, 'indeterminate');
            const model = useProxiedModel(props, 'modelValue');
            function onChange(v) {
                if (indeterminate.value) indeterminate.value = false;
            }
            useRender(()=>{
                const controlProps = omit(VSelectionControl.filterProps(props), [
                    'modelValue'
                ]);
                return vue.createVNode(VSelectionControl, vue.mergeProps(controlProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": [
                        ($event)=>model.value = $event,
                        onChange
                    ],
                    "class": [
                        'v-checkbox-btn',
                        props.class
                    ],
                    "style": props.style,
                    "type": "checkbox",
                    "aria-checked": indeterminate.value ? 'mixed' : undefined
                }), slots);
            });
            return {};
        }
    });
    // Types
    function useInputIcon(props) {
        const { t: t } = useLocale();
        function InputIcon({ name: name, color: color, ...attrs }) {
            const localeKey = {
                prepend: 'prependAction',
                prependInner: 'prependAction',
                append: 'appendAction',
                appendInner: 'appendAction',
                clear: 'clear'
            }[name];
            const listener = props[`onClick:${name}`];
            function onKeydown(e) {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                e.stopPropagation();
                callEvent(listener, new PointerEvent('click', e));
            }
            const label = listener && localeKey ? t(`$vuetify.input.${localeKey}`, props.label ?? '') : undefined;
            return vue.createVNode(VIcon, vue.mergeProps({
                "icon": props[`${name}Icon`],
                "aria-label": label,
                "onClick": listener,
                "onKeydown": onKeydown,
                "color": color
            }, attrs), null);
        }
        return {
            InputIcon: InputIcon
        };
    }
    // Types
    const makeVMessagesProps = propsFactory({
        active: Boolean,
        color: String,
        messages: {
            type: [
                Array,
                String
            ],
            default: ()=>[]
        },
        ...makeComponentProps(),
        ...makeTransitionProps({
            transition: {
                component: VSlideYTransition,
                leaveAbsolute: true,
                group: true
            }
        })
    }, 'VMessages');
    const VMessages = genericComponent()({
        name: 'VMessages',
        props: makeVMessagesProps(),
        setup (props, { slots: slots }) {
            const messages = vue.computed(()=>wrapInArray(props.messages));
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            useRender(()=>vue.createVNode(MaybeTransition, {
                    "transition": props.transition,
                    "tag": "div",
                    "class": vue.normalizeClass([
                        'v-messages',
                        textColorClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        textColorStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            props.active && messages.value.map((message, i)=>vue.createElementVNode("div", {
                                    "class": "v-messages__message",
                                    "key": `${i}-${messages.value}`
                                }, [
                                    slots.message ? slots.message({
                                        message: message
                                    }) : message
                                ]))
                        ]
                }));
            return {};
        }
    });
    // Composables
    // Types
    // Composables
    const makeFocusProps = propsFactory({
        focused: Boolean,
        'onUpdate:focused': EventProp()
    }, 'focus');
    function useFocus(props, name = getCurrentInstanceName()) {
        const isFocused = useProxiedModel(props, 'focused');
        const focusClasses = vue.toRef(()=>{
            return {
                [`${name}--focused`]: isFocused.value
            };
        });
        function focus() {
            isFocused.value = true;
        }
        function blur() {
            isFocused.value = false;
        }
        return {
            focusClasses: focusClasses,
            isFocused: isFocused,
            focus: focus,
            blur: blur
        };
    }
    // Composables
    // Types
    const FormKey = Symbol.for('vuetify:form');
    const makeFormProps = propsFactory({
        disabled: Boolean,
        fastFail: Boolean,
        readonly: Boolean,
        modelValue: {
            type: Boolean,
            default: null
        },
        validateOn: {
            type: String,
            default: 'input'
        }
    }, 'form');
    function createForm(props) {
        const model = useProxiedModel(props, 'modelValue');
        const isDisabled = vue.toRef(()=>props.disabled);
        const isReadonly = vue.toRef(()=>props.readonly);
        const isValidating = vue.shallowRef(false);
        const items = vue.ref([]);
        const errors = vue.ref([]);
        async function validate() {
            const results = [];
            let valid = true;
            errors.value = [];
            isValidating.value = true;
            for (const item of items.value){
                const itemErrorMessages = await item.validate();
                if (itemErrorMessages.length > 0) {
                    valid = false;
                    results.push({
                        id: item.id,
                        errorMessages: itemErrorMessages
                    });
                }
                if (!valid && props.fastFail) break;
            }
            errors.value = results;
            isValidating.value = false;
            return {
                valid: valid,
                errors: errors.value
            };
        }
        function reset() {
            items.value.forEach((item)=>item.reset());
        }
        function resetValidation() {
            items.value.forEach((item)=>item.resetValidation());
        }
        vue.watch(items, ()=>{
            let valid = 0;
            let invalid = 0;
            const results = [];
            for (const item of items.value){
                if (item.isValid === false) {
                    invalid++;
                    results.push({
                        id: item.id,
                        errorMessages: item.errorMessages
                    });
                } else if (item.isValid === true) valid++;
            }
            errors.value = results;
            model.value = invalid > 0 ? false : valid === items.value.length ? true : null;
        }, {
            deep: true,
            flush: 'post'
        });
        vue.provide(FormKey, {
            register: ({ id: id, vm: vm, validate: validate, reset: reset, resetValidation: resetValidation })=>{
                if (items.value.some((item)=>item.id === id)) consoleWarn(`Duplicate input name "${id}"`);
                items.value.push({
                    id: id,
                    validate: validate,
                    reset: reset,
                    resetValidation: resetValidation,
                    vm: vue.markRaw(vm),
                    isValid: null,
                    errorMessages: []
                });
            },
            unregister: (id)=>{
                items.value = items.value.filter((item)=>{
                    return item.id !== id;
                });
            },
            update: (id, isValid, errorMessages)=>{
                const found = items.value.find((item)=>item.id === id);
                if (!found) return;
                found.isValid = isValid;
                found.errorMessages = errorMessages;
            },
            isDisabled: isDisabled,
            isReadonly: isReadonly,
            isValidating: isValidating,
            isValid: model,
            items: items,
            validateOn: vue.toRef(()=>props.validateOn)
        });
        return {
            errors: errors,
            isDisabled: isDisabled,
            isReadonly: isReadonly,
            isValidating: isValidating,
            isValid: model,
            items: items,
            validate: validate,
            reset: reset,
            resetValidation: resetValidation
        };
    }
    function useForm(props) {
        const form = vue.inject(FormKey, null);
        return {
            ...form,
            isReadonly: vue.computed(()=>!!(props?.readonly ?? form?.isReadonly.value)),
            isDisabled: vue.computed(()=>!!(props?.disabled ?? form?.isDisabled.value))
        };
    }
    // Utilities
    const RulesSymbol = Symbol.for('vuetify:rules');
    function useRules(fn) {
        const rules = vue.inject(RulesSymbol, null);
        if (!fn) {
            if (!rules) throw new Error('Could not find Vuetify rules injection');
            return rules.aliases;
        }
        return rules?.resolve(fn) ?? vue.toRef(fn);
    }
    // Composables
    // Types
    const makeValidationProps = propsFactory({
        disabled: {
            type: Boolean,
            default: null
        },
        error: Boolean,
        errorMessages: {
            type: [
                Array,
                String
            ],
            default: ()=>[]
        },
        maxErrors: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        name: String,
        label: String,
        readonly: {
            type: Boolean,
            default: null
        },
        rules: {
            type: Array,
            default: ()=>[]
        },
        modelValue: null,
        validateOn: String,
        validationValue: null,
        ...makeFocusProps()
    }, 'validation');
    function useValidation(props, name = getCurrentInstanceName(), id = vue.useId()) {
        const model = useProxiedModel(props, 'modelValue');
        const validationModel = vue.computed(()=>props.validationValue === undefined ? model.value : props.validationValue);
        const form = useForm(props);
        const rules = useRules(()=>props.rules);
        const internalErrorMessages = vue.ref([]);
        const isPristine = vue.shallowRef(true);
        const isDirty = vue.computed(()=>!!(wrapInArray(model.value === '' ? null : model.value).length || wrapInArray(validationModel.value === '' ? null : validationModel.value).length));
        const errorMessages = vue.computed(()=>{
            return props.errorMessages?.length ? wrapInArray(props.errorMessages).concat(internalErrorMessages.value).slice(0, Math.max(0, Number(props.maxErrors))) : internalErrorMessages.value;
        });
        const validateOn = vue.computed(()=>{
            let value = (props.validateOn ?? form.validateOn?.value) || 'input';
            if (value === 'lazy') value = 'input lazy';
            if (value === 'eager') value = 'input eager';
            const set = new Set(value?.split(' ') ?? []);
            return {
                input: set.has('input'),
                blur: set.has('blur') || set.has('input') || set.has('invalid-input'),
                invalidInput: set.has('invalid-input'),
                lazy: set.has('lazy'),
                eager: set.has('eager')
            };
        });
        const isValid = vue.computed(()=>{
            if (props.error || props.errorMessages?.length) return false;
            if (!props.rules.length) return true;
            if (isPristine.value) return internalErrorMessages.value.length || validateOn.value.lazy ? null : true;
            else return !internalErrorMessages.value.length;
        });
        const isValidating = vue.shallowRef(false);
        let isResetting = false;
        const validationClasses = vue.computed(()=>{
            return {
                [`${name}--error`]: isValid.value === false,
                [`${name}--dirty`]: isDirty.value,
                [`${name}--disabled`]: form.isDisabled.value,
                [`${name}--readonly`]: form.isReadonly.value
            };
        });
        const vm = getCurrentInstance('validation');
        const uid = vue.computed(()=>props.name ?? vue.unref(id));
        vue.onBeforeMount(()=>{
            form.register?.({
                id: uid.value,
                vm: vm,
                validate: validate,
                reset: reset,
                resetValidation: resetValidation
            });
        });
        vue.onBeforeUnmount(()=>{
            form.unregister?.(uid.value);
        });
        vue.onMounted(async ()=>{
            if (!validateOn.value.lazy) await validate(!validateOn.value.eager);
            form.update?.(uid.value, isValid.value, errorMessages.value);
        });
        useToggleScope(()=>validateOn.value.input || validateOn.value.invalidInput && isValid.value === false, ()=>{
            vue.watch(validationModel, ()=>{
                if (!isResetting) validate();
            });
        });
        useToggleScope(()=>validateOn.value.blur, ()=>{
            vue.watch(()=>props.focused, (val)=>{
                if (!val) validate();
            });
        });
        vue.watch([
            isValid,
            errorMessages
        ], ()=>{
            form.update?.(uid.value, isValid.value, errorMessages.value);
        });
        async function reset() {
            isResetting = true;
            model.value = null;
            await vue.nextTick();
            isResetting = false;
            await resetValidation();
        }
        async function resetValidation() {
            isPristine.value = true;
            if (!validateOn.value.lazy) await validate(!validateOn.value.eager);
            else internalErrorMessages.value = [];
        }
        async function validate(silent = false) {
            const results = [];
            isValidating.value = true;
            for (const rule of rules.value){
                if (results.length >= Number(props.maxErrors ?? 1)) break;
                const handler = typeof rule === 'function' ? rule : ()=>rule;
                const result = await handler(validationModel.value);
                if (result === true) continue;
                if (result !== false && typeof result !== 'string') {
                    // eslint-disable-next-line no-console
                    console.warn(`${result} is not a valid value. Rule functions must return boolean true or a string.`);
                    continue;
                }
                results.push(result || '');
            }
            internalErrorMessages.value = results;
            isValidating.value = false;
            isPristine.value = silent;
            return internalErrorMessages.value;
        }
        return {
            errorMessages: errorMessages,
            isDirty: isDirty,
            isDisabled: form.isDisabled,
            isReadonly: form.isReadonly,
            isPristine: isPristine,
            isValid: isValid,
            isValidating: isValidating,
            reset: reset,
            resetValidation: resetValidation,
            validate: validate,
            validationClasses: validationClasses
        };
    }
    // Types
    const makeVInputProps = propsFactory({
        id: String,
        appendIcon: IconValue,
        baseColor: String,
        centerAffix: {
            type: Boolean,
            default: true
        },
        color: String,
        glow: Boolean,
        iconColor: [
            Boolean,
            String
        ],
        prependIcon: IconValue,
        hideDetails: [
            Boolean,
            String
        ],
        hideSpinButtons: Boolean,
        hint: String,
        indentDetails: {
            type: Boolean,
            default: null
        },
        persistentHint: Boolean,
        messages: {
            type: [
                Array,
                String
            ],
            default: ()=>[]
        },
        direction: {
            type: String,
            default: 'horizontal',
            validator: (v)=>[
                    'horizontal',
                    'vertical'
                ].includes(v)
        },
        'onClick:prepend': EventProp(),
        'onClick:append': EventProp(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...pick(makeDimensionProps(), [
            'maxWidth',
            'minWidth',
            'width'
        ]),
        ...makeThemeProps(),
        ...makeValidationProps()
    }, 'VInput');
    const VInput = genericComponent()({
        name: 'VInput',
        props: {
            ...makeVInputProps()
        },
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots, emit: emit }) {
            const { densityClasses: densityClasses } = useDensity(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { themeClasses: themeClasses } = provideTheme(props);
            const { rtlClasses: rtlClasses } = useRtl();
            const { InputIcon: InputIcon } = useInputIcon(props);
            const uid = vue.useId();
            const id = vue.computed(()=>props.id || `input-${uid}`);
            const { errorMessages: errorMessages, isDirty: isDirty, isDisabled: isDisabled, isReadonly: isReadonly, isPristine: isPristine, isValid: isValid, isValidating: isValidating, reset: reset, resetValidation: resetValidation, validate: validate, validationClasses: validationClasses } = useValidation(props, 'v-input', id);
            const messages = vue.computed(()=>{
                if (props.errorMessages?.length || !isPristine.value && errorMessages.value.length) return errorMessages.value;
                else if (props.hint && (props.persistentHint || props.focused)) return props.hint;
                else return props.messages;
            });
            const hasMessages = vue.toRef(()=>messages.value.length > 0);
            const hasDetails = vue.toRef(()=>!props.hideDetails || props.hideDetails === 'auto' && (hasMessages.value || !!slots.details));
            const messagesId = vue.computed(()=>hasDetails.value ? `${id.value}-messages` : undefined);
            const slotProps = vue.computed(()=>({
                    id: id,
                    messagesId: messagesId,
                    isDirty: isDirty,
                    isDisabled: isDisabled,
                    isReadonly: isReadonly,
                    isPristine: isPristine,
                    isValid: isValid,
                    isValidating: isValidating,
                    hasDetails: hasDetails,
                    reset: reset,
                    resetValidation: resetValidation,
                    validate: validate
                }));
            const color = vue.toRef(()=>{
                return props.error || props.disabled ? undefined : props.focused ? props.color : props.baseColor;
            });
            const iconColor = vue.toRef(()=>{
                if (!props.iconColor) return undefined;
                return props.iconColor === true ? color.value : props.iconColor;
            });
            useRender(()=>{
                const hasPrepend = !!(slots.prepend || props.prependIcon);
                const hasAppend = !!(slots.append || props.appendIcon);
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-input',
                        `v-input--${props.direction}`,
                        {
                            'v-input--center-affix': props.centerAffix,
                            'v-input--focused': props.focused,
                            'v-input--glow': props.glow,
                            'v-input--hide-spin-buttons': props.hideSpinButtons,
                            'v-input--indent-details': props.indentDetails
                        },
                        densityClasses.value,
                        themeClasses.value,
                        rtlClasses.value,
                        validationClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        dimensionStyles.value,
                        props.style
                    ])
                }, [
                    hasPrepend && vue.createElementVNode("div", {
                        "key": "prepend",
                        "class": "v-input__prepend"
                    }, [
                        slots.prepend ? slots.prepend(slotProps.value) : props.prependIcon && vue.createVNode(InputIcon, {
                            "key": "prepend-icon",
                            "name": "prepend",
                            "color": iconColor.value
                        }, null)
                    ]),
                    slots.default && vue.createElementVNode("div", {
                        "class": "v-input__control"
                    }, [
                        slots.default?.(slotProps.value)
                    ]),
                    hasAppend && vue.createElementVNode("div", {
                        "key": "append",
                        "class": "v-input__append"
                    }, [
                        slots.append ? slots.append(slotProps.value) : props.appendIcon && vue.createVNode(InputIcon, {
                            "key": "append-icon",
                            "name": "append",
                            "color": iconColor.value
                        }, null)
                    ]),
                    hasDetails.value && vue.createElementVNode("div", {
                        "id": messagesId.value,
                        "class": "v-input__details",
                        "role": "alert",
                        "aria-live": "polite"
                    }, [
                        vue.createVNode(VMessages, {
                            "active": hasMessages.value,
                            "messages": messages.value
                        }, {
                            message: slots.message
                        }),
                        slots.details?.(slotProps.value)
                    ])
                ]);
            });
            return {
                reset: reset,
                resetValidation: resetValidation,
                validate: validate,
                isValid: isValid,
                errorMessages: errorMessages
            };
        }
    });
    // Types
    const Refs = Symbol('Forwarded refs');
    /** Omit properties starting with P */ /** Omit keyof $props from T */ function getDescriptor(obj, key) {
        let currentObj = obj;
        while(currentObj){
            const descriptor = Reflect.getOwnPropertyDescriptor(currentObj, key);
            if (descriptor) return descriptor;
            currentObj = Object.getPrototypeOf(currentObj);
        }
        return undefined;
    }
    function forwardRefs(target, ...refs) {
        target[Refs] = refs;
        return new Proxy(target, {
            get (target, key) {
                if (Reflect.has(target, key)) return Reflect.get(target, key);
                // Skip internal properties
                if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
                for (const ref of refs)if (ref.value && Reflect.has(ref.value, key)) {
                    const val = Reflect.get(ref.value, key);
                    return typeof val === 'function' ? val.bind(ref.value) : val;
                }
            },
            has (target, key) {
                if (Reflect.has(target, key)) return true;
                // Skip internal properties
                if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
                for (const ref of refs){
                    if (ref.value && Reflect.has(ref.value, key)) return true;
                }
                return false;
            },
            set (target, key, value) {
                if (Reflect.has(target, key)) return Reflect.set(target, key, value);
                // Skip internal properties
                if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
                for (const ref of refs){
                    if (ref.value && Reflect.has(ref.value, key)) return Reflect.set(ref.value, key, value);
                }
                return false;
            },
            getOwnPropertyDescriptor (target, key) {
                const descriptor = Reflect.getOwnPropertyDescriptor(target, key);
                if (descriptor) return descriptor;
                // Skip internal properties
                if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
                // Check each ref's own properties
                for (const ref of refs){
                    if (!ref.value) continue;
                    const descriptor = getDescriptor(ref.value, key) ?? ('_' in ref.value ? getDescriptor(ref.value._?.setupState, key) : undefined);
                    if (descriptor) return descriptor;
                }
                // Recursive search up each ref's prototype
                for (const ref of refs){
                    const childRefs = ref.value && ref.value[Refs];
                    if (!childRefs) continue;
                    const queue = childRefs.slice();
                    while(queue.length){
                        const ref = queue.shift();
                        const descriptor = getDescriptor(ref.value, key);
                        if (descriptor) return descriptor;
                        const childRefs = ref.value && ref.value[Refs];
                        if (childRefs) queue.push(...childRefs);
                    }
                }
                return undefined;
            }
        });
    }
    // Types
    const makeVCheckboxProps = propsFactory({
        ...omit(makeVInputProps(), [
            'direction',
            'glow'
        ]),
        ...omit(makeVCheckboxBtnProps(), [
            'inline'
        ])
    }, 'VCheckbox');
    const VCheckbox = genericComponent()({
        name: 'VCheckbox',
        inheritAttrs: false,
        props: makeVCheckboxProps(),
        emits: {
            'update:modelValue': (value)=>true,
            'update:focused': (focused)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const { isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const inputRef = vue.ref();
            const uid = vue.useId();
            useRender(()=>{
                const [rootAttrs, controlAttrs] = filterInputAttrs(attrs);
                const inputProps = VInput.filterProps(props);
                const checkboxProps = VCheckboxBtn.filterProps(props);
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": inputRef,
                    "class": [
                        'v-checkbox',
                        props.class
                    ]
                }, rootAttrs, inputProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "id": props.id || `checkbox-${uid}`,
                    "focused": isFocused.value,
                    "style": props.style
                }), {
                    ...slots,
                    default: ({ id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly, isValid: isValid })=>vue.createVNode(VCheckboxBtn, vue.mergeProps(checkboxProps, {
                            "id": id.value,
                            "aria-describedby": messagesId.value,
                            "disabled": isDisabled.value,
                            "readonly": isReadonly.value
                        }, controlAttrs, {
                            "error": isValid.value === false,
                            "modelValue": model.value,
                            "onUpdate:modelValue": ($event)=>model.value = $event,
                            "onFocus": focus,
                            "onBlur": blur
                        }), slots)
                });
            });
            return forwardRefs({}, inputRef);
        }
    });
    // Utilities
    // Types
    const breakpoints = [
        'sm',
        'md',
        'lg',
        'xl',
        'xxl'
    ]; // no xs
    const DisplaySymbol = Symbol.for('vuetify:display');
    const defaultDisplayOptions = {
        mobileBreakpoint: 'lg',
        thresholds: {
            xs: 0,
            sm: 600,
            md: 840,
            lg: 1145,
            xl: 1545,
            xxl: 2138
        }
    };
    const parseDisplayOptions = (options = defaultDisplayOptions)=>{
        return mergeDeep(defaultDisplayOptions, options);
    };
    function getClientWidth(ssr) {
        return IN_BROWSER && !ssr ? window.innerWidth : typeof ssr === 'object' && ssr.clientWidth || 0;
    }
    function getClientHeight(ssr) {
        return IN_BROWSER && !ssr ? window.innerHeight : typeof ssr === 'object' && ssr.clientHeight || 0;
    }
    function getPlatform(ssr) {
        const userAgent = IN_BROWSER && !ssr ? window.navigator.userAgent : 'ssr';
        function match(regexp) {
            return Boolean(userAgent.match(regexp));
        }
        const android = match(/android/i);
        const ios = match(/iphone|ipad|ipod/i);
        const cordova = match(/cordova/i);
        const electron = match(/electron/i);
        const chrome = match(/chrome/i);
        const edge = match(/edge/i);
        const firefox = match(/firefox/i);
        const opera = match(/opera/i);
        const win = match(/win/i);
        const mac = match(/mac/i);
        const linux = match(/linux/i);
        return {
            android: android,
            ios: ios,
            cordova: cordova,
            electron: electron,
            chrome: chrome,
            edge: edge,
            firefox: firefox,
            opera: opera,
            win: win,
            mac: mac,
            linux: linux,
            touch: SUPPORTS_TOUCH,
            ssr: userAgent === 'ssr'
        };
    }
    function createDisplay(options, ssr) {
        const { thresholds: thresholds, mobileBreakpoint: mobileBreakpoint } = parseDisplayOptions(options);
        const height = vue.shallowRef(getClientHeight(ssr));
        const platform = vue.shallowRef(getPlatform(ssr));
        const state = vue.reactive({});
        const width = vue.shallowRef(getClientWidth(ssr));
        function updateSize() {
            height.value = getClientHeight();
            width.value = getClientWidth();
        }
        function update() {
            updateSize();
            platform.value = getPlatform();
        }
        // eslint-disable-next-line max-statements
        vue.watchEffect(()=>{
            const xs = width.value < thresholds.sm;
            const sm = width.value < thresholds.md && !xs;
            const md = width.value < thresholds.lg && !(sm || xs);
            const lg = width.value < thresholds.xl && !(md || sm || xs);
            const xl = width.value < thresholds.xxl && !(lg || md || sm || xs);
            const xxl = width.value >= thresholds.xxl;
            const name = xs ? 'xs' : sm ? 'sm' : md ? 'md' : lg ? 'lg' : xl ? 'xl' : 'xxl';
            const breakpointValue = typeof mobileBreakpoint === 'number' ? mobileBreakpoint : thresholds[mobileBreakpoint];
            const mobile = width.value < breakpointValue;
            state.xs = xs;
            state.sm = sm;
            state.md = md;
            state.lg = lg;
            state.xl = xl;
            state.xxl = xxl;
            state.smAndUp = !xs;
            state.mdAndUp = !(xs || sm);
            state.lgAndUp = !(xs || sm || md);
            state.xlAndUp = !(xs || sm || md || lg);
            state.smAndDown = !(md || lg || xl || xxl);
            state.mdAndDown = !(lg || xl || xxl);
            state.lgAndDown = !(xl || xxl);
            state.xlAndDown = !xxl;
            state.name = name;
            state.height = height.value;
            state.width = width.value;
            state.mobile = mobile;
            state.mobileBreakpoint = mobileBreakpoint;
            state.platform = platform.value;
            state.thresholds = thresholds;
        });
        if (IN_BROWSER) {
            window.addEventListener('resize', updateSize, {
                passive: true
            });
            vue.onScopeDispose(()=>{
                window.removeEventListener('resize', updateSize);
            }, true);
        }
        return {
            ...vue.toRefs(state),
            update: update,
            ssr: !!ssr
        };
    }
    const makeDisplayProps = propsFactory({
        mobile: {
            type: Boolean,
            default: false
        },
        mobileBreakpoint: [
            Number,
            String
        ]
    }, 'display');
    function useDisplay(props = {
        mobile: null
    }, name = getCurrentInstanceName()) {
        const display = vue.inject(DisplaySymbol);
        if (!display) throw new Error('Could not find Vuetify display injection');
        const mobile = vue.computed(()=>{
            if (props.mobile) return true;
            else if (typeof props.mobileBreakpoint === 'number') return display.width.value < props.mobileBreakpoint;
            else if (props.mobileBreakpoint) return display.width.value < display.thresholds.value[props.mobileBreakpoint];
            else if (props.mobile === null) return display.mobile.value;
            else return false;
        });
        const displayClasses = vue.toRef(()=>{
            if (!name) return {};
            return {
                [`${name}--mobile`]: mobile.value
            };
        });
        return {
            ...display,
            displayClasses: displayClasses,
            mobile: mobile
        };
    }
    // Utilities
    // Types
    const GoToSymbol = Symbol.for('vuetify:goto');
    function genDefaults$1() {
        return {
            container: undefined,
            duration: 300,
            layout: false,
            offset: 0,
            easing: 'easeInOutCubic',
            patterns: easingPatterns
        };
    }
    function getContainer(el) {
        return getTarget$1(el) ?? (document.scrollingElement || document.body);
    }
    function getTarget$1(el) {
        return typeof el === 'string' ? document.querySelector(el) : refElement(el);
    }
    function getOffset$2(target, horizontal, rtl) {
        if (typeof target === 'number') return horizontal && rtl ? -target : target;
        let el = getTarget$1(target);
        let totalOffset = 0;
        while(el){
            totalOffset += horizontal ? el.offsetLeft : el.offsetTop;
            el = el.offsetParent;
        }
        return totalOffset;
    }
    function createGoTo(options, locale) {
        return {
            rtl: locale.isRtl,
            options: mergeDeep(genDefaults$1(), options)
        };
    }
    async function scrollTo(_target, _options, horizontal, goTo) {
        const property = horizontal ? 'scrollLeft' : 'scrollTop';
        const options = mergeDeep(goTo?.options ?? genDefaults$1(), _options);
        const rtl = goTo?.rtl.value;
        const target = (typeof _target === 'number' ? _target : getTarget$1(_target)) ?? 0;
        const container = options.container === 'parent' && target instanceof HTMLElement ? target.parentElement : getContainer(options.container);
        const ease = PREFERS_REDUCED_MOTION() ? options.patterns.instant : typeof options.easing === 'function' ? options.easing : options.patterns[options.easing];
        if (!ease) throw new TypeError(`Easing function "${options.easing}" not found.`);
        let targetLocation;
        if (typeof target === 'number') targetLocation = getOffset$2(target, horizontal, rtl);
        else {
            targetLocation = getOffset$2(target, horizontal, rtl) - getOffset$2(container, horizontal, rtl);
            if (options.layout) {
                const styles = window.getComputedStyle(target);
                const layoutOffset = styles.getPropertyValue('--v-layout-top');
                if (layoutOffset) targetLocation -= parseInt(layoutOffset, 10);
            }
        }
        targetLocation += options.offset;
        targetLocation = clampTarget(container, targetLocation, !!rtl, !!horizontal);
        const startLocation = container[property] ?? 0;
        if (targetLocation === startLocation) return Promise.resolve(targetLocation);
        const startTime = performance.now();
        return new Promise((resolve)=>requestAnimationFrame(function step(currentTime) {
                const timeElapsed = currentTime - startTime;
                const progress = timeElapsed / options.duration;
                const location = Math.floor(startLocation + (targetLocation - startLocation) * ease(clamp(progress, 0, 1)));
                container[property] = location;
                // Allow for some jitter if target time has elapsed
                if (progress >= 1 && Math.abs(location - container[property]) < 10) return resolve(targetLocation);
                else if (progress > 2) {
                    // The target might not be reachable
                    consoleWarn('Scroll target is not reachable');
                    return resolve(container[property]);
                }
                requestAnimationFrame(step);
            }));
    }
    function useGoTo(_options = {}) {
        const goToInstance = vue.inject(GoToSymbol);
        const { isRtl: isRtl } = useRtl();
        if (!goToInstance) throw new Error('[Vuetify] Could not find injected goto instance');
        const goTo = {
            ...goToInstance,
            // can be set via VLocaleProvider
            rtl: vue.toRef(()=>goToInstance.rtl.value || isRtl.value)
        };
        async function go(target, options) {
            return scrollTo(target, mergeDeep(_options, options), false, goTo);
        }
        go.horizontal = async (target, options)=>{
            return scrollTo(target, mergeDeep(_options, options), true, goTo);
        };
        return go;
    }
    /**
   * Clamp target value to achieve a smooth scroll animation
   * when the value goes outside the scroll container size
   */ function clampTarget(container, value, rtl, horizontal) {
        const { scrollWidth: scrollWidth, scrollHeight: scrollHeight } = container;
        const [containerWidth, containerHeight] = container === document.scrollingElement ? [
            window.innerWidth,
            window.innerHeight
        ] : [
            container.offsetWidth,
            container.offsetHeight
        ];
        let min;
        let max;
        if (horizontal) {
            if (rtl) {
                min = -(scrollWidth - containerWidth);
                max = 0;
            } else {
                min = 0;
                max = scrollWidth - containerWidth;
            }
        } else {
            min = 0;
            max = scrollHeight + -containerHeight;
        }
        return clamp(value, min, max);
    }
    function calculateUpdatedTarget({ selectedElement: selectedElement, containerElement: containerElement, isRtl: isRtl, isHorizontal: isHorizontal }) {
        const containerSize = getOffsetSize(isHorizontal, containerElement);
        const scrollPosition = getScrollPosition(isHorizontal, isRtl, containerElement);
        const childrenSize = getOffsetSize(isHorizontal, selectedElement);
        const childrenStartPosition = getOffsetPosition(isHorizontal, selectedElement);
        const additionalOffset = childrenSize * 0.4;
        if (scrollPosition > childrenStartPosition) return childrenStartPosition - additionalOffset;
        else if (scrollPosition + containerSize < childrenStartPosition + childrenSize) return childrenStartPosition - containerSize + childrenSize + additionalOffset;
        return scrollPosition;
    }
    function calculateCenteredTarget({ selectedElement: selectedElement, containerElement: containerElement, isHorizontal: isHorizontal }) {
        const containerOffsetSize = getOffsetSize(isHorizontal, containerElement);
        const childrenOffsetPosition = getOffsetPosition(isHorizontal, selectedElement);
        const childrenOffsetSize = getOffsetSize(isHorizontal, selectedElement);
        return childrenOffsetPosition - containerOffsetSize / 2 + childrenOffsetSize / 2;
    }
    function getScrollSize(isHorizontal, element) {
        const key = isHorizontal ? 'scrollWidth' : 'scrollHeight';
        return element?.[key] || 0;
    }
    function getScrollPosition(isHorizontal, rtl, element) {
        if (!element) return 0;
        const { scrollLeft: scrollLeft, offsetWidth: offsetWidth, scrollWidth: scrollWidth } = element;
        if (isHorizontal) return rtl ? scrollWidth - offsetWidth + scrollLeft : scrollLeft;
        return element.scrollTop;
    }
    function getOffsetSize(isHorizontal, element) {
        const key = isHorizontal ? 'offsetWidth' : 'offsetHeight';
        return element?.[key] || 0;
    }
    function getOffsetPosition(isHorizontal, element) {
        const key = isHorizontal ? 'offsetLeft' : 'offsetTop';
        return element?.[key] || 0;
    }
    // Types
    const VSlideGroupSymbol = Symbol.for('vuetify:v-slide-group');
    const makeVSlideGroupProps = propsFactory({
        centerActive: Boolean,
        scrollToActive: {
            type: Boolean,
            default: true
        },
        contentClass: null,
        direction: {
            type: String,
            default: 'horizontal'
        },
        symbol: {
            type: null,
            default: VSlideGroupSymbol
        },
        nextIcon: {
            type: IconValue,
            default: '$next'
        },
        prevIcon: {
            type: IconValue,
            default: '$prev'
        },
        showArrows: {
            type: [
                Boolean,
                String
            ],
            validator: (v)=>typeof v === 'boolean' || [
                    'always',
                    'desktop',
                    'mobile',
                    'never'
                ].includes(v)
        },
        ...makeComponentProps(),
        ...makeDisplayProps({
            mobile: null
        }),
        ...makeTagProps(),
        ...makeGroupProps({
            selectedClass: 'v-slide-group-item--active'
        })
    }, 'VSlideGroup');
    const VSlideGroup = genericComponent()({
        name: 'VSlideGroup',
        props: makeVSlideGroupProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { isRtl: isRtl } = useRtl();
            const { displayClasses: displayClasses, mobile: mobile } = useDisplay(props);
            const group = useGroup(props, props.symbol);
            const isOverflowing = vue.shallowRef(false);
            const scrollOffset = vue.shallowRef(0);
            const containerSize = vue.shallowRef(0);
            const contentSize = vue.shallowRef(0);
            const isHorizontal = vue.computed(()=>props.direction === 'horizontal');
            const { resizeRef: containerRef, contentRect: containerRect } = useResizeObserver();
            const { resizeRef: contentRef, contentRect: contentRect } = useResizeObserver();
            const goTo = useGoTo();
            const goToOptions = vue.computed(()=>{
                return {
                    container: containerRef.el,
                    duration: 200,
                    easing: 'easeOutQuart'
                };
            });
            const firstSelectedIndex = vue.computed(()=>{
                if (!group.selected.value.length) return -1;
                return group.items.value.findIndex((item)=>item.id === group.selected.value[0]);
            });
            const lastSelectedIndex = vue.computed(()=>{
                if (!group.selected.value.length) return -1;
                return group.items.value.findIndex((item)=>item.id === group.selected.value[group.selected.value.length - 1]);
            });
            if (IN_BROWSER) {
                let frame = -1;
                vue.watch(()=>[
                        group.selected.value,
                        containerRect.value,
                        contentRect.value,
                        isHorizontal.value
                    ], ()=>{
                    cancelAnimationFrame(frame);
                    frame = requestAnimationFrame(()=>{
                        if (containerRect.value && contentRect.value) {
                            const sizeProperty = isHorizontal.value ? 'width' : 'height';
                            containerSize.value = containerRect.value[sizeProperty];
                            contentSize.value = contentRect.value[sizeProperty];
                            isOverflowing.value = containerSize.value + 1 < contentSize.value;
                        }
                        if (props.scrollToActive && firstSelectedIndex.value >= 0 && contentRef.el) {
                            // TODO: Is this too naive? Should we store element references in group composable?
                            const selectedElement = contentRef.el.children[lastSelectedIndex.value];
                            scrollToChildren(selectedElement, props.centerActive);
                        }
                    });
                });
            }
            const isFocused = vue.shallowRef(false);
            function scrollToChildren(children, center) {
                let target = 0;
                if (center) target = calculateCenteredTarget({
                    containerElement: containerRef.el,
                    isHorizontal: isHorizontal.value,
                    selectedElement: children
                });
                else target = calculateUpdatedTarget({
                    containerElement: containerRef.el,
                    isHorizontal: isHorizontal.value,
                    isRtl: isRtl.value,
                    selectedElement: children
                });
                scrollToPosition(target);
            }
            function scrollToPosition(newPosition) {
                if (!IN_BROWSER || !containerRef.el) return;
                const offsetSize = getOffsetSize(isHorizontal.value, containerRef.el);
                const scrollPosition = getScrollPosition(isHorizontal.value, isRtl.value, containerRef.el);
                const scrollSize = getScrollSize(isHorizontal.value, containerRef.el);
                if (scrollSize <= offsetSize || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
                Math.abs(newPosition - scrollPosition) < 16) return;
                if (isHorizontal.value && isRtl.value && containerRef.el) {
                    const { scrollWidth: scrollWidth, offsetWidth: containerWidth } = containerRef.el;
                    newPosition = scrollWidth - containerWidth - newPosition;
                }
                if (isHorizontal.value) goTo.horizontal(newPosition, goToOptions.value);
                else goTo(newPosition, goToOptions.value);
            }
            function onScroll(e) {
                const { scrollTop: scrollTop, scrollLeft: scrollLeft } = e.target;
                scrollOffset.value = isHorizontal.value ? scrollLeft : scrollTop;
            }
            function onFocusin(e) {
                isFocused.value = true;
                if (!isOverflowing.value || !contentRef.el) return;
                // Focused element is likely to be the root of an item, so a
                // breadth-first search will probably find it in the first iteration
                for (const el of e.composedPath()){
                    for (const item of contentRef.el.children)if (item === el) {
                        scrollToChildren(item);
                        return;
                    }
                }
            }
            function onFocusout(e) {
                isFocused.value = false;
            }
            // Affix clicks produce onFocus that we have to ignore to avoid extra scrollToChildren
            let ignoreFocusEvent = false;
            function onFocus(e) {
                if (!ignoreFocusEvent && !isFocused.value && !(e.relatedTarget && contentRef.el?.contains(e.relatedTarget))) focus();
                ignoreFocusEvent = false;
            }
            function onFocusAffixes() {
                ignoreFocusEvent = true;
            }
            function onKeydown(e) {
                if (!contentRef.el) return;
                function toFocus(location) {
                    e.preventDefault();
                    focus(location);
                }
                if (isHorizontal.value) {
                    if (e.key === 'ArrowRight') toFocus(isRtl.value ? 'prev' : 'next');
                    else if (e.key === 'ArrowLeft') toFocus(isRtl.value ? 'next' : 'prev');
                } else {
                    if (e.key === 'ArrowDown') toFocus('next');
                    else if (e.key === 'ArrowUp') toFocus('prev');
                }
                if (e.key === 'Home') toFocus('first');
                else if (e.key === 'End') toFocus('last');
            }
            function getSiblingElement(el, location) {
                if (!el) return undefined;
                let sibling = el;
                do sibling = sibling?.[location === 'next' ? 'nextElementSibling' : 'previousElementSibling'];
                while (sibling?.hasAttribute('disabled'));
                return sibling;
            }
            function focus(location) {
                if (!contentRef.el) return;
                let el;
                if (!location) {
                    const focusable = focusableChildren(contentRef.el);
                    el = focusable[0];
                } else if (location === 'next') {
                    el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                    if (!el) return focus('first');
                } else if (location === 'prev') {
                    el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                    if (!el) return focus('last');
                } else if (location === 'first') {
                    el = contentRef.el.firstElementChild;
                    if (el?.hasAttribute('disabled')) el = getSiblingElement(el, 'next');
                } else if (location === 'last') {
                    el = contentRef.el.lastElementChild;
                    if (el?.hasAttribute('disabled')) el = getSiblingElement(el, 'prev');
                }
                if (el) el.focus({
                    preventScroll: true
                });
            }
            function scrollTo(location) {
                const direction = isHorizontal.value && isRtl.value ? -1 : 1;
                const offsetStep = (location === 'prev' ? -direction : direction) * containerSize.value;
                let newPosition = scrollOffset.value + offsetStep;
                // TODO: improve it
                if (isHorizontal.value && isRtl.value && containerRef.el) {
                    const { scrollWidth: scrollWidth, offsetWidth: containerWidth } = containerRef.el;
                    newPosition += scrollWidth - containerWidth;
                }
                scrollToPosition(newPosition);
            }
            const slotProps = vue.computed(()=>({
                    next: group.next,
                    prev: group.prev,
                    select: group.select,
                    isSelected: group.isSelected
                }));
            const hasOverflowOrScroll = vue.computed(()=>isOverflowing.value || Math.abs(scrollOffset.value) > 0);
            const hasAffixes = vue.computed(()=>{
                switch(props.showArrows){
                    case 'never':
                        return false;
                    // Always show arrows on desktop & mobile
                    case 'always':
                        return true;
                    // Always show arrows on desktop
                    case 'desktop':
                        return !mobile.value;
                    // Show arrows on mobile when overflowing.
                    // This matches the default 2.2 behavior
                    case true:
                        return hasOverflowOrScroll.value;
                    // Always show on mobile
                    case 'mobile':
                        return mobile.value || hasOverflowOrScroll.value;
                    // https://material.io/components/tabs#scrollable-tabs
                    // Always show arrows when
                    // overflowed on desktop
                    default:
                        return !mobile.value && hasOverflowOrScroll.value;
                }
            });
            const hasPrev = vue.computed(()=>{
                // 1 pixel in reserve, may be lost after rounding
                return Math.abs(scrollOffset.value) > 1;
            });
            const hasNext = vue.computed(()=>{
                if (!hasOverflowOrScroll.value) return false;
                const scrollSizeMax = contentSize.value - containerSize.value;
                // 1 pixel in reserve, may be lost after rounding
                return scrollSizeMax - Math.abs(scrollOffset.value) > 1;
            });
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-slide-group',
                        {
                            'v-slide-group--vertical': !isHorizontal.value,
                            'v-slide-group--has-affixes': hasAffixes.value,
                            'v-slide-group--is-overflowing': isOverflowing.value
                        },
                        displayClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "tabindex": isFocused.value || group.selected.value.length ? -1 : 0,
                    "onFocus": onFocus
                }, {
                    default: ()=>[
                            hasAffixes.value && vue.createElementVNode("div", {
                                "key": "prev",
                                "class": vue.normalizeClass([
                                    'v-slide-group__prev',
                                    {
                                        'v-slide-group__prev--disabled': !hasPrev.value
                                    }
                                ]),
                                "onMousedown": onFocusAffixes,
                                "onClick": ()=>hasPrev.value && scrollTo('prev')
                            }, [
                                slots.prev?.(slotProps.value) ?? vue.createVNode(VFadeTransition, null, {
                                    default: ()=>[
                                            vue.createVNode(VIcon, {
                                                "icon": isRtl.value ? props.nextIcon : props.prevIcon
                                            }, null)
                                        ]
                                })
                            ]),
                            vue.createElementVNode("div", {
                                "key": "container",
                                "ref": containerRef,
                                "class": vue.normalizeClass([
                                    'v-slide-group__container',
                                    props.contentClass
                                ]),
                                "onScroll": onScroll
                            }, [
                                vue.createElementVNode("div", {
                                    "ref": contentRef,
                                    "class": "v-slide-group__content",
                                    "onFocusin": onFocusin,
                                    "onFocusout": onFocusout,
                                    "onKeydown": onKeydown
                                }, [
                                    slots.default?.(slotProps.value)
                                ])
                            ]),
                            hasAffixes.value && vue.createElementVNode("div", {
                                "key": "next",
                                "class": vue.normalizeClass([
                                    'v-slide-group__next',
                                    {
                                        'v-slide-group__next--disabled': !hasNext.value
                                    }
                                ]),
                                "onMousedown": onFocusAffixes,
                                "onClick": ()=>hasNext.value && scrollTo('next')
                            }, [
                                slots.next?.(slotProps.value) ?? vue.createVNode(VFadeTransition, null, {
                                    default: ()=>[
                                            vue.createVNode(VIcon, {
                                                "icon": isRtl.value ? props.prevIcon : props.nextIcon
                                            }, null)
                                        ]
                                })
                            ])
                        ]
                }));
            return {
                selected: group.selected,
                scrollTo: scrollTo,
                scrollOffset: scrollOffset,
                focus: focus,
                hasPrev: hasPrev,
                hasNext: hasNext
            };
        }
    });
    // Types
    const VChipGroupSymbol = Symbol.for('vuetify:v-chip-group');
    const makeVChipGroupProps = propsFactory({
        baseColor: String,
        column: Boolean,
        filter: Boolean,
        valueComparator: {
            type: Function,
            default: deepEqual
        },
        ...makeVSlideGroupProps({
            scrollToActive: false
        }),
        ...makeComponentProps(),
        ...makeGroupProps({
            selectedClass: 'v-chip--selected'
        }),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'tonal'
        })
    }, 'VChipGroup');
    const VChipGroup = genericComponent()({
        name: 'VChipGroup',
        props: makeVChipGroupProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { isSelected: isSelected, select: select, next: next, prev: prev, selected: selected } = useGroup(props, VChipGroupSymbol);
            provideDefaults({
                VChip: {
                    baseColor: vue.toRef(()=>props.baseColor),
                    color: vue.toRef(()=>props.color),
                    disabled: vue.toRef(()=>props.disabled),
                    filter: vue.toRef(()=>props.filter),
                    variant: vue.toRef(()=>props.variant)
                }
            });
            useRender(()=>{
                const slideGroupProps = VSlideGroup.filterProps(props);
                return vue.createVNode(VSlideGroup, vue.mergeProps(slideGroupProps, {
                    "class": [
                        'v-chip-group',
                        {
                            'v-chip-group--column': props.column
                        },
                        themeClasses.value,
                        props.class
                    ],
                    "style": props.style
                }), {
                    default: ()=>[
                            slots.default?.({
                                isSelected: isSelected,
                                select: select,
                                next: next,
                                prev: prev,
                                selected: selected.value
                            })
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVChipProps = propsFactory({
        activeClass: String,
        appendAvatar: String,
        appendIcon: IconValue,
        baseColor: String,
        closable: Boolean,
        closeIcon: {
            type: IconValue,
            default: '$delete'
        },
        closeLabel: {
            type: String,
            default: '$vuetify.close'
        },
        draggable: Boolean,
        filter: Boolean,
        filterIcon: {
            type: IconValue,
            default: '$complete'
        },
        label: Boolean,
        link: {
            type: Boolean,
            default: undefined
        },
        pill: Boolean,
        prependAvatar: String,
        prependIcon: IconValue,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        },
        text: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        modelValue: {
            type: Boolean,
            default: true
        },
        onClick: EventProp(),
        onClickOnce: EventProp(),
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeElevationProps(),
        ...makeGroupItemProps(),
        ...makeRoundedProps(),
        ...makeRouterProps(),
        ...makeSizeProps(),
        ...makeTagProps({
            tag: 'span'
        }),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'tonal'
        })
    }, 'VChip');
    const VChip = genericComponent()({
        name: 'VChip',
        directives: {
            vRipple: Ripple
        },
        props: makeVChipProps(),
        emits: {
            'click:close': (e)=>true,
            'update:modelValue': (value)=>true,
            'group:selected': (val)=>true,
            click: (e)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const { borderClasses: borderClasses } = useBorder(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { sizeClasses: sizeClasses } = useSize(props);
            const { themeClasses: themeClasses } = provideTheme(props);
            const isActive = useProxiedModel(props, 'modelValue');
            const group = useGroupItem(props, VChipGroupSymbol, false);
            const slideGroup = useGroupItem(props, VSlideGroupSymbol, false);
            const link = useLink(props, attrs);
            const isLink = vue.toRef(()=>props.link !== false && link.isLink.value);
            const isClickable = vue.computed(()=>!props.disabled && props.link !== false && (!!group || props.link || link.isClickable.value));
            const closeProps = vue.toRef(()=>({
                    'aria-label': t(props.closeLabel),
                    disabled: props.disabled,
                    onClick (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        isActive.value = false;
                        emit('click:close', e);
                    }
                }));
            vue.watch(isActive, (val)=>{
                if (val) {
                    group?.register();
                    slideGroup?.register();
                } else {
                    group?.unregister();
                    slideGroup?.unregister();
                }
            });
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(()=>{
                const showColor = !group || group.isSelected.value;
                return {
                    color: showColor ? props.color ?? props.baseColor : props.baseColor,
                    variant: props.variant
                };
            });
            function onClick(e) {
                emit('click', e);
                if (!isClickable.value) return;
                link.navigate.value?.(e);
                group?.toggle();
            }
            function onKeyDown(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(e);
                }
            }
            return ()=>{
                const Tag = link.isLink.value ? 'a' : props.tag;
                const hasAppendMedia = !!(props.appendIcon || props.appendAvatar);
                const hasAppend = !!(hasAppendMedia || slots.append);
                const hasClose = !!(slots.close || props.closable);
                const hasFilter = !!(slots.filter || props.filter) && group;
                const hasPrependMedia = !!(props.prependIcon || props.prependAvatar);
                const hasPrepend = !!(hasPrependMedia || slots.prepend);
                return isActive.value && vue.withDirectives(vue.createVNode(Tag, vue.mergeProps(link.linkProps, {
                    "class": [
                        'v-chip',
                        {
                            'v-chip--disabled': props.disabled,
                            'v-chip--label': props.label,
                            'v-chip--link': isClickable.value,
                            'v-chip--filter': hasFilter,
                            'v-chip--pill': props.pill,
                            [`${props.activeClass}`]: props.activeClass && link.isActive?.value
                        },
                        themeClasses.value,
                        borderClasses.value,
                        colorClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        sizeClasses.value,
                        variantClasses.value,
                        group?.selectedClass.value,
                        props.class
                    ],
                    "style": [
                        colorStyles.value,
                        roundedStyles.value,
                        props.style
                    ],
                    "disabled": props.disabled || undefined,
                    "draggable": props.draggable,
                    "tabindex": isClickable.value ? 0 : undefined,
                    "onClick": (isClickable.value || props.onClick || props.onClickOnce) && onClick,
                    "onKeydown": isClickable.value && !isLink.value && onKeyDown
                }), {
                    default: ()=>[
                            genOverlays(isClickable.value, 'v-chip'),
                            hasFilter && vue.createVNode(VExpandXTransition, {
                                "key": "filter"
                            }, {
                                default: ()=>[
                                        vue.withDirectives(vue.createElementVNode("div", {
                                            "class": "v-chip__filter"
                                        }, [
                                            !slots.filter ? vue.createVNode(VIcon, {
                                                "key": "filter-icon",
                                                "icon": props.filterIcon
                                            }, null) : vue.createVNode(VDefaultsProvider, {
                                                "key": "filter-defaults",
                                                "disabled": !props.filterIcon,
                                                "defaults": {
                                                    VIcon: {
                                                        icon: props.filterIcon
                                                    }
                                                }
                                            }, slots.filter)
                                        ]), [
                                            [
                                                vue.vShow,
                                                group.isSelected.value
                                            ]
                                        ])
                                    ]
                            }),
                            hasPrepend && vue.createElementVNode("div", {
                                "key": "prepend",
                                "class": "v-chip__prepend"
                            }, [
                                !slots.prepend ? vue.createElementVNode(vue.Fragment, null, [
                                    props.prependIcon && vue.createVNode(VIcon, {
                                        "key": "prepend-icon",
                                        "icon": props.prependIcon,
                                        "start": true
                                    }, null),
                                    props.prependAvatar && vue.createVNode(VAvatar, {
                                        "key": "prepend-avatar",
                                        "image": props.prependAvatar,
                                        "start": true
                                    }, null)
                                ]) : vue.createVNode(VDefaultsProvider, {
                                    "key": "prepend-defaults",
                                    "disabled": !hasPrependMedia,
                                    "defaults": {
                                        VAvatar: {
                                            image: props.prependAvatar,
                                            start: true
                                        },
                                        VIcon: {
                                            icon: props.prependIcon,
                                            start: true
                                        }
                                    }
                                }, slots.prepend)
                            ]),
                            vue.createElementVNode("div", {
                                "class": "v-chip__content",
                                "data-no-activator": ""
                            }, [
                                slots.default?.({
                                    isSelected: group?.isSelected.value,
                                    selectedClass: group?.selectedClass.value,
                                    select: group?.select,
                                    toggle: group?.toggle,
                                    value: group?.value.value,
                                    disabled: props.disabled
                                }) ?? vue.toDisplayString(props.text)
                            ]),
                            hasAppend && vue.createElementVNode("div", {
                                "key": "append",
                                "class": "v-chip__append"
                            }, [
                                !slots.append ? vue.createElementVNode(vue.Fragment, null, [
                                    props.appendIcon && vue.createVNode(VIcon, {
                                        "key": "append-icon",
                                        "end": true,
                                        "icon": props.appendIcon
                                    }, null),
                                    props.appendAvatar && vue.createVNode(VAvatar, {
                                        "key": "append-avatar",
                                        "end": true,
                                        "image": props.appendAvatar
                                    }, null)
                                ]) : vue.createVNode(VDefaultsProvider, {
                                    "key": "append-defaults",
                                    "disabled": !hasAppendMedia,
                                    "defaults": {
                                        VAvatar: {
                                            end: true,
                                            image: props.appendAvatar
                                        },
                                        VIcon: {
                                            end: true,
                                            icon: props.appendIcon
                                        }
                                    }
                                }, slots.append)
                            ]),
                            hasClose && vue.createElementVNode("button", vue.mergeProps({
                                "key": "close",
                                "class": "v-chip__close",
                                "type": "button",
                                "data-testid": "close-chip"
                            }, closeProps.value), [
                                !slots.close ? vue.createVNode(VIcon, {
                                    "key": "close-icon",
                                    "icon": props.closeIcon,
                                    "size": "x-small"
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "close-defaults",
                                    "defaults": {
                                        VIcon: {
                                            icon: props.closeIcon,
                                            size: 'x-small'
                                        }
                                    }
                                }, slots.close)
                            ])
                        ]
                }), [
                    [
                        Ripple,
                        isClickable.value && props.ripple,
                        null
                    ]
                ]);
            };
        }
    });
    // Types
    const allowedVariants$2 = [
        'dotted',
        'dashed',
        'solid',
        'double'
    ];
    const makeVDividerProps = propsFactory({
        color: String,
        contentOffset: [
            Number,
            String,
            Array
        ],
        gradient: Boolean,
        inset: Boolean,
        length: [
            Number,
            String
        ],
        opacity: [
            Number,
            String
        ],
        thickness: [
            Number,
            String
        ],
        vertical: Boolean,
        variant: {
            type: String,
            default: 'solid',
            validator: (v)=>allowedVariants$2.includes(v)
        },
        ...makeComponentProps(),
        ...makeThemeProps()
    }, 'VDivider');
    const VDivider = genericComponent()({
        name: 'VDivider',
        props: makeVDividerProps(),
        setup (props, { attrs: attrs, slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            const dividerStyles = vue.computed(()=>{
                const styles = {};
                if (props.length) styles[props.vertical ? 'height' : 'width'] = convertToUnit(props.length);
                if (props.thickness) styles[props.vertical ? 'borderRightWidth' : 'borderTopWidth'] = convertToUnit(props.thickness);
                return styles;
            });
            const contentStyles = vue.toRef(()=>{
                const margin = Array.isArray(props.contentOffset) ? props.contentOffset[0] : props.contentOffset;
                const shift = Array.isArray(props.contentOffset) ? props.contentOffset[1] : 0;
                return {
                    marginBlock: props.vertical && margin ? convertToUnit(margin) : undefined,
                    marginInline: !props.vertical && margin ? convertToUnit(margin) : undefined,
                    transform: shift ? `translate${props.vertical ? 'X' : 'Y'}(${convertToUnit(shift)})` : undefined
                };
            });
            useRender(()=>{
                const role = attrs.role;
                const hasSlot = !!slots.default;
                const divider = vue.createElementVNode("hr", {
                    "class": vue.normalizeClass([
                        {
                            'v-divider': true,
                            'v-divider--gradient': props.gradient && !slots.default,
                            'v-divider--inset': props.inset,
                            'v-divider--vertical': props.vertical
                        },
                        themeClasses.value,
                        textColorClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        dividerStyles.value,
                        textColorStyles.value,
                        {
                            '--v-border-opacity': props.opacity
                        },
                        {
                            'border-style': props.variant
                        },
                        props.style
                    ]),
                    "aria-orientation": !hasSlot && !role ? props.vertical ? 'vertical' : 'horizontal' : undefined,
                    "role": !hasSlot ? role : undefined
                }, null);
                if (!hasSlot) return divider;
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-divider__wrapper',
                        {
                            'v-divider__wrapper--gradient': props.gradient,
                            'v-divider__wrapper--inset': props.inset,
                            'v-divider__wrapper--vertical': props.vertical
                        }
                    ])
                }, [
                    divider,
                    vue.createElementVNode("div", {
                        "class": "v-divider__content",
                        "style": vue.normalizeStyle(contentStyles.value)
                    }, [
                        slots.default()
                    ]),
                    divider
                ]);
            });
            return {};
        }
    });
    // Utilities
    // List
    const ListKey = Symbol.for('vuetify:list');
    function createList(options = {
        filterable: false
    }) {
        const parent = vue.inject(ListKey, {
            filterable: false,
            hasPrepend: vue.shallowRef(false),
            updateHasPrepend: ()=>null,
            trackingIndex: vue.shallowRef(-1),
            navigationStrategy: vue.shallowRef('focus'),
            uid: ''
        });
        const { filterable: filterable, trackingIndex: trackingIndex = parent.trackingIndex, navigationStrategy: navigationStrategy = parent.navigationStrategy, uid: uid = parent.uid || vue.useId() } = options;
        const data = {
            filterable: parent.filterable || filterable,
            hasPrepend: vue.shallowRef(false),
            updateHasPrepend: (value)=>{
                if (value) data.hasPrepend.value = value;
            },
            trackingIndex: trackingIndex,
            navigationStrategy: navigationStrategy,
            uid: uid
        };
        vue.provide(ListKey, data);
        return parent;
    }
    function useList() {
        return vue.inject(ListKey, null);
    }
    /* eslint-disable sonarjs/no-identical-functions */ // Utilities
    const independentActiveStrategy = (mandatory)=>{
        const strategy = {
            activate: ({ id: id, value: value, activated: activated })=>{
                id = vue.toRaw(id);
                // When mandatory and we're trying to deselect when id
                // is the only currently selected item then do nothing
                if (mandatory && !value && activated.size === 1 && activated.has(id)) return activated;
                if (value) activated.add(id);
                else activated.delete(id);
                return activated;
            },
            in: (v, children, parents)=>{
                let set = new Set();
                if (v != null) for (const id of wrapInArray(v))set = strategy.activate({
                    id: id,
                    value: true,
                    activated: new Set(set),
                    children: children,
                    parents: parents
                });
                return set;
            },
            out: (v)=>{
                return Array.from(v);
            }
        };
        return strategy;
    };
    const independentSingleActiveStrategy = (mandatory)=>{
        const parentStrategy = independentActiveStrategy(mandatory);
        const strategy = {
            activate: ({ activated: activated, id: id, ...rest })=>{
                id = vue.toRaw(id);
                const singleSelected = activated.has(id) ? new Set([
                    id
                ]) : new Set();
                return parentStrategy.activate({
                    ...rest,
                    id: id,
                    activated: singleSelected
                });
            },
            in: (v, children, parents)=>{
                let set = new Set();
                if (v != null) {
                    const arr = wrapInArray(v);
                    if (arr.length) set = parentStrategy.in(arr.slice(0, 1), children, parents);
                }
                return set;
            },
            out: (v, children, parents)=>{
                return parentStrategy.out(v, children, parents);
            }
        };
        return strategy;
    };
    const leafActiveStrategy = (mandatory)=>{
        const parentStrategy = independentActiveStrategy(mandatory);
        const strategy = {
            activate: ({ id: id, activated: activated, children: children, ...rest })=>{
                id = vue.toRaw(id);
                if (children.has(id)) return activated;
                return parentStrategy.activate({
                    id: id,
                    activated: activated,
                    children: children,
                    ...rest
                });
            },
            in: parentStrategy.in,
            out: parentStrategy.out
        };
        return strategy;
    };
    const leafSingleActiveStrategy = (mandatory)=>{
        const parentStrategy = independentSingleActiveStrategy(mandatory);
        const strategy = {
            activate: ({ id: id, activated: activated, children: children, ...rest })=>{
                id = vue.toRaw(id);
                if (children.has(id)) return activated;
                return parentStrategy.activate({
                    id: id,
                    activated: activated,
                    children: children,
                    ...rest
                });
            },
            in: parentStrategy.in,
            out: parentStrategy.out
        };
        return strategy;
    };
    const singleOpenStrategy = {
        open: ({ id: id, value: value, opened: opened, parents: parents })=>{
            if (value) {
                const newOpened = new Set();
                newOpened.add(id);
                let parent = parents.get(id);
                while(parent != null){
                    newOpened.add(parent);
                    parent = parents.get(parent);
                }
                return newOpened;
            } else {
                opened.delete(id);
                return opened;
            }
        },
        select: ()=>null
    };
    const multipleOpenStrategy = {
        open: ({ id: id, value: value, opened: opened, parents: parents })=>{
            if (value) {
                let parent = parents.get(id);
                opened.add(id);
                while(parent != null && parent !== id){
                    opened.add(parent);
                    parent = parents.get(parent);
                }
                return opened;
            } else opened.delete(id);
            return opened;
        },
        select: ()=>null
    };
    const listOpenStrategy = {
        open: multipleOpenStrategy.open,
        select: ({ id: id, value: value, opened: opened, parents: parents })=>{
            if (!value) return opened;
            const path = [];
            let parent = parents.get(id);
            while(parent != null){
                path.push(parent);
                parent = parents.get(parent);
            }
            return new Set(path);
        }
    };
    /* eslint-disable sonarjs/no-identical-functions */ // Utilities
    const independentSelectStrategy = (mandatory)=>{
        const strategy = {
            select: ({ id: id, value: value, selected: selected })=>{
                id = vue.toRaw(id);
                // When mandatory and we're trying to deselect when id
                // is the only currently selected item then do nothing
                if (mandatory && !value) {
                    const on = Array.from(selected.entries()).reduce((arr, [key, value])=>{
                        if (value === 'on') arr.push(key);
                        return arr;
                    }, []);
                    if (on.length === 1 && on[0] === id) return selected;
                }
                selected.set(id, value ? 'on' : 'off');
                return selected;
            },
            in: (v, children, parents, disabled)=>{
                const map = new Map();
                for (const id of v || [])strategy.select({
                    id: id,
                    value: true,
                    selected: map,
                    children: children,
                    parents: parents,
                    disabled: disabled
                });
                return map;
            },
            out: (v)=>{
                const arr = [];
                for (const [key, value] of v.entries())if (value === 'on') arr.push(key);
                return arr;
            }
        };
        return strategy;
    };
    const independentSingleSelectStrategy = (mandatory)=>{
        const parentStrategy = independentSelectStrategy(mandatory);
        const strategy = {
            select: ({ selected: selected, id: id, ...rest })=>{
                id = vue.toRaw(id);
                const singleSelected = selected.has(id) ? new Map([
                    [
                        id,
                        selected.get(id)
                    ]
                ]) : new Map();
                return parentStrategy.select({
                    ...rest,
                    id: id,
                    selected: singleSelected
                });
            },
            in: (v, children, parents, disabled)=>{
                if (v?.length) return parentStrategy.in(v.slice(0, 1), children, parents, disabled);
                return new Map();
            },
            out: (v, children, parents)=>{
                return parentStrategy.out(v, children, parents);
            }
        };
        return strategy;
    };
    const leafSelectStrategy = (mandatory)=>{
        const parentStrategy = independentSelectStrategy(mandatory);
        const strategy = {
            select: ({ id: id, selected: selected, children: children, ...rest })=>{
                id = vue.toRaw(id);
                if (children.has(id)) return selected;
                return parentStrategy.select({
                    id: id,
                    selected: selected,
                    children: children,
                    ...rest
                });
            },
            in: parentStrategy.in,
            out: parentStrategy.out
        };
        return strategy;
    };
    const leafSingleSelectStrategy = (mandatory)=>{
        const parentStrategy = independentSingleSelectStrategy(mandatory);
        const strategy = {
            select: ({ id: id, selected: selected, children: children, ...rest })=>{
                id = vue.toRaw(id);
                if (children.has(id)) return selected;
                return parentStrategy.select({
                    id: id,
                    selected: selected,
                    children: children,
                    ...rest
                });
            },
            in: parentStrategy.in,
            out: parentStrategy.out
        };
        return strategy;
    };
    const classicSelectStrategy = (mandatory)=>{
        const strategy = {
            select: ({ id: id, value: value, selected: selected, children: children, parents: parents, disabled: disabled })=>{
                id = vue.toRaw(id);
                const original = new Map(selected);
                const items = [
                    id
                ];
                while(items.length){
                    const item = items.shift();
                    if (!disabled.has(item)) selected.set(vue.toRaw(item), value ? 'on' : 'off');
                    if (children.has(item)) items.push(...children.get(item));
                }
                let parent = vue.toRaw(parents.get(id));
                while(parent){
                    let everySelected = true;
                    let noneSelected = true;
                    for (const child of children.get(parent)){
                        const cid = vue.toRaw(child);
                        if (disabled.has(cid)) continue;
                        if (selected.get(cid) !== 'on') everySelected = false;
                        if (selected.has(cid) && selected.get(cid) !== 'off') noneSelected = false;
                        if (!everySelected && !noneSelected) break;
                    }
                    selected.set(parent, everySelected ? 'on' : noneSelected ? 'off' : 'indeterminate');
                    parent = vue.toRaw(parents.get(parent));
                }
                // If mandatory and planned deselect results in no selected
                // items then we can't do it, so return original state
                if (mandatory && !value) {
                    const on = Array.from(selected.entries()).reduce((arr, [key, value])=>{
                        if (value === 'on') arr.push(key);
                        return arr;
                    }, []);
                    if (on.length === 0) return original;
                }
                return selected;
            },
            in: (v, children, parents)=>{
                let map = new Map();
                for (const id of v || [])map = strategy.select({
                    id: id,
                    value: true,
                    selected: map,
                    children: children,
                    parents: parents,
                    disabled: new Set()
                });
                return map;
            },
            out: (v, children)=>{
                const arr = [];
                for (const [key, value] of v.entries())if (value === 'on' && !children.has(key)) arr.push(key);
                return arr;
            }
        };
        return strategy;
    };
    const trunkSelectStrategy = (mandatory)=>{
        const parentStrategy = classicSelectStrategy(mandatory);
        const strategy = {
            select: parentStrategy.select,
            in: parentStrategy.in,
            out: (v, children, parents)=>{
                const arr = [];
                for (const [key, value] of v.entries())if (value === 'on') {
                    if (parents.has(key)) {
                        const parent = parents.get(key);
                        if (v.get(parent) === 'on') continue;
                    }
                    arr.push(key);
                }
                return arr;
            }
        };
        return strategy;
    };
    const branchSelectStrategy = (mandatory)=>{
        const parentStrategy = classicSelectStrategy(mandatory);
        const strategy = {
            select: parentStrategy.select,
            in: (v, children, parents, disabled)=>{
                let map = new Map();
                for (const id of v || []){
                    if (children.has(id)) continue;
                    map = strategy.select({
                        id: id,
                        value: true,
                        selected: map,
                        children: children,
                        parents: parents,
                        disabled: disabled
                    });
                }
                return map;
            },
            out: (v)=>{
                const arr = [];
                for (const [key, value] of v.entries())if (value === 'on' || value === 'indeterminate') arr.push(key);
                return arr;
            }
        };
        return strategy;
    };
    // Composables
    // Types
    const VNestedSymbol = Symbol.for('vuetify:nested');
    const emptyNested = {
        id: vue.shallowRef(),
        root: {
            itemsRegistration: vue.ref('render'),
            register: ()=>null,
            unregister: ()=>null,
            updateDisabled: ()=>null,
            children: vue.ref(new Map()),
            parents: vue.ref(new Map()),
            disabled: vue.ref(new Set()),
            open: ()=>null,
            openOnSelect: ()=>null,
            activate: ()=>null,
            select: ()=>null,
            activatable: vue.ref(false),
            scrollToActive: vue.ref(false),
            selectable: vue.ref(false),
            opened: vue.ref(new Set()),
            activated: vue.ref(new Set()),
            selected: vue.ref(new Map()),
            selectedValues: vue.ref([]),
            getPath: ()=>[]
        }
    };
    const makeNestedProps = propsFactory({
        activatable: Boolean,
        selectable: Boolean,
        activeStrategy: [
            String,
            Function,
            Object
        ],
        selectStrategy: [
            String,
            Function,
            Object
        ],
        openStrategy: [
            String,
            Object
        ],
        opened: null,
        activated: null,
        selected: null,
        mandatory: Boolean,
        itemsRegistration: {
            type: String,
            default: 'render'
        }
    }, 'nested');
    const useNested = (props, { items: items, returnObject: returnObject, scrollToActive: scrollToActive, valueComparator: valueComparator })=>{
        let isUnmounted = false;
        const children = vue.shallowRef(new Map());
        const parents = vue.shallowRef(new Map());
        const disabled = vue.shallowRef(new Set());
        const opened = useProxiedModel(props, 'opened', props.opened, (v)=>new Set(Array.isArray(v) ? v.map((i)=>vue.toRaw(i)) : v), (v)=>[
                ...v.values()
            ]);
        const activeStrategy = vue.computed(()=>{
            if (typeof props.activeStrategy === 'object') return props.activeStrategy;
            if (typeof props.activeStrategy === 'function') return props.activeStrategy(props.mandatory);
            switch(props.activeStrategy){
                case 'leaf':
                    return leafActiveStrategy(props.mandatory);
                case 'single-leaf':
                    return leafSingleActiveStrategy(props.mandatory);
                case 'independent':
                    return independentActiveStrategy(props.mandatory);
                case 'single-independent':
                default:
                    return independentSingleActiveStrategy(props.mandatory);
            }
        });
        const selectStrategy = vue.computed(()=>{
            if (typeof props.selectStrategy === 'object') return props.selectStrategy;
            if (typeof props.selectStrategy === 'function') return props.selectStrategy(props.mandatory);
            switch(props.selectStrategy){
                case 'single-leaf':
                    return leafSingleSelectStrategy(props.mandatory);
                case 'leaf':
                    return leafSelectStrategy(props.mandatory);
                case 'independent':
                    return independentSelectStrategy(props.mandatory);
                case 'single-independent':
                    return independentSingleSelectStrategy(props.mandatory);
                case 'trunk':
                    return trunkSelectStrategy(props.mandatory);
                case 'branch':
                    return branchSelectStrategy(props.mandatory);
                case 'classic':
                default:
                    return classicSelectStrategy(props.mandatory);
            }
        });
        const openStrategy = vue.computed(()=>{
            if (typeof props.openStrategy === 'object') return props.openStrategy;
            switch(props.openStrategy){
                case 'list':
                    return listOpenStrategy;
                case 'single':
                    return singleOpenStrategy;
                case 'multiple':
                default:
                    return multipleOpenStrategy;
            }
        });
        const flatItems = vue.computed(()=>{
            const flat = [];
            const stack = [
                ...items.value
            ];
            while(stack.length){
                const item = stack.pop();
                flat.push(item);
                if (item.children) stack.push(...item.children);
            }
            return flat;
        });
        function resolveValue(value) {
            const comparator = vue.toValue(valueComparator);
            if (!comparator) return value;
            const _returnObject = vue.toValue(returnObject);
            for (const item of flatItems.value){
                const itemVal = _returnObject ? vue.toRaw(item.raw) : item.value;
                if (comparator(value, itemVal)) return itemVal;
            }
            return value;
        }
        const activated = useProxiedModel(props, 'activated', props.activated, (v)=>activeStrategy.value.in(Array.isArray(v) ? v.map(resolveValue) : v, children.value, parents.value), (v)=>activeStrategy.value.out(v, children.value, parents.value));
        const selected = useProxiedModel(props, 'selected', props.selected, (v)=>selectStrategy.value.in(Array.isArray(v) ? v.map(resolveValue) : v, children.value, parents.value, disabled.value), (v)=>selectStrategy.value.out(v, children.value, parents.value));
        vue.onBeforeUnmount(()=>{
            isUnmounted = true;
        });
        function getPath(id) {
            const path = [];
            let parent = vue.toRaw(id);
            while(parent !== undefined){
                path.unshift(parent);
                parent = parents.value.get(parent);
            }
            return path;
        }
        const vm = getCurrentInstance('nested');
        const nodeIds = new Set();
        const itemsUpdatePropagation = throttle(()=>{
            vue.nextTick(()=>{
                children.value = new Map(children.value);
                parents.value = new Map(parents.value);
            });
        }, 100);
        vue.watch(()=>[
                items.value,
                vue.toValue(returnObject)
            ], ()=>{
            if (props.itemsRegistration === 'props') updateInternalMaps();
        }, {
            immediate: true
        });
        function updateInternalMaps() {
            const _parents = new Map();
            const _children = new Map();
            const _disabled = new Set();
            const getValue = vue.toValue(returnObject) ? (item)=>vue.toRaw(item.raw) : (item)=>item.value;
            const stack = [
                ...items.value
            ];
            let i = 0;
            while(i < stack.length){
                const item = stack[i++];
                const itemValue = getValue(item);
                if (item.children) {
                    const childValues = [];
                    for (const child of item.children){
                        const childValue = getValue(child);
                        _parents.set(childValue, itemValue);
                        childValues.push(childValue);
                        stack.push(child);
                    }
                    _children.set(itemValue, childValues);
                }
                if (item.props.disabled) _disabled.add(itemValue);
            }
            children.value = _children;
            parents.value = _parents;
            disabled.value = _disabled;
        }
        const nested = {
            id: vue.shallowRef(),
            root: {
                opened: opened,
                activatable: vue.toRef(()=>props.activatable),
                scrollToActive: vue.toRef(()=>vue.toValue(scrollToActive)),
                selectable: vue.toRef(()=>props.selectable),
                activated: activated,
                selected: selected,
                selectedValues: vue.computed(()=>{
                    const arr = [];
                    for (const [key, value] of selected.value.entries())if (value === 'on') arr.push(key);
                    return arr;
                }),
                itemsRegistration: vue.toRef(()=>props.itemsRegistration),
                register: (id, parentId, isDisabled, isGroup)=>{
                    if (nodeIds.has(id)) {
                        const path = getPath(id).map(String).join(' -> ');
                        const newPath = getPath(parentId).concat(id).map(String).join(' -> ');
                        consoleError(`Multiple nodes with the same ID\n\t${path}\n\t${newPath}`);
                        return;
                    } else nodeIds.add(id);
                    parentId && id !== parentId && parents.value.set(id, parentId);
                    isDisabled && disabled.value.add(id);
                    isGroup && children.value.set(id, []);
                    if (parentId != null) children.value.set(parentId, [
                        ...children.value.get(parentId) || [],
                        id
                    ]);
                    itemsUpdatePropagation();
                },
                unregister: (id)=>{
                    if (isUnmounted) return;
                    nodeIds.delete(id);
                    children.value.delete(id);
                    disabled.value.delete(id);
                    const parent = parents.value.get(id);
                    if (parent) {
                        const list = children.value.get(parent) ?? [];
                        children.value.set(parent, list.filter((child)=>child !== id));
                    }
                    parents.value.delete(id);
                    itemsUpdatePropagation();
                },
                updateDisabled: (id, isDisabled)=>{
                    if (isDisabled) disabled.value.add(id);
                    else disabled.value.delete(id);
                // classic selection requires refresh to re-evaluate on/off/indeterminate but
                // currently it is only run for selection interactions, so it will set new disabled
                // to "off" and the visual state becomes out of sync
                // -- selected.value = new Map(selected.value)
                // it is not clear if the framework should un-select when disabled changed to true
                // more discussion is needed
                },
                open: (id, value, event)=>{
                    vm.emit('click:open', {
                        id: id,
                        value: value,
                        path: getPath(id),
                        event: event
                    });
                    const newOpened = openStrategy.value.open({
                        id: id,
                        value: value,
                        opened: new Set(opened.value),
                        children: children.value,
                        parents: parents.value,
                        event: event
                    });
                    newOpened && (opened.value = newOpened);
                },
                openOnSelect: (id, value, event)=>{
                    const newOpened = openStrategy.value.select({
                        id: id,
                        value: value,
                        selected: new Map(selected.value),
                        opened: new Set(opened.value),
                        children: children.value,
                        parents: parents.value,
                        event: event
                    });
                    newOpened && (opened.value = newOpened);
                },
                select: (id, value, event)=>{
                    vm.emit('click:select', {
                        id: id,
                        value: value,
                        path: getPath(id),
                        event: event
                    });
                    const newSelected = selectStrategy.value.select({
                        id: id,
                        value: value,
                        selected: new Map(selected.value),
                        children: children.value,
                        parents: parents.value,
                        disabled: disabled.value,
                        event: event
                    });
                    newSelected && (selected.value = newSelected);
                    nested.root.openOnSelect(id, value, event);
                },
                activate: (id, value, event)=>{
                    if (!props.activatable) return nested.root.select(id, true, event);
                    vm.emit('click:activate', {
                        id: id,
                        value: value,
                        path: getPath(id),
                        event: event
                    });
                    const newActivated = activeStrategy.value.activate({
                        id: id,
                        value: value,
                        activated: new Set(activated.value),
                        children: children.value,
                        parents: parents.value,
                        event: event
                    });
                    if (newActivated.size !== activated.value.size) activated.value = newActivated;
                    else {
                        for (const value of newActivated)if (!activated.value.has(value)) {
                            activated.value = newActivated;
                            return;
                        }
                        for (const value of activated.value)if (!newActivated.has(value)) {
                            activated.value = newActivated;
                            return;
                        }
                    }
                },
                children: children,
                parents: parents,
                disabled: disabled,
                getPath: getPath
            }
        };
        vue.provide(VNestedSymbol, nested);
        return nested.root;
    };
    const useNestedItem = (id, isDisabled, isGroup)=>{
        const parent = vue.inject(VNestedSymbol, emptyNested);
        const uidSymbol = Symbol('nested item');
        const computedId = vue.computed(()=>{
            const idValue = vue.toRaw(vue.toValue(id));
            return idValue !== undefined ? idValue : uidSymbol;
        });
        const item = {
            ...parent,
            id: computedId,
            open: (open, e)=>parent.root.open(computedId.value, open, e),
            openOnSelect: (open, e)=>parent.root.openOnSelect(computedId.value, open, e),
            isOpen: vue.computed(()=>parent.root.opened.value.has(computedId.value)),
            parent: vue.computed(()=>parent.root.parents.value.get(computedId.value)),
            activate: (activated, e)=>parent.root.activate(computedId.value, activated, e),
            isActivated: vue.computed(()=>parent.root.activated.value.has(computedId.value)),
            scrollToActive: parent.root.scrollToActive,
            select: (selected, e)=>parent.root.select(computedId.value, selected, e),
            isSelected: vue.computed(()=>parent.root.selected.value.get(computedId.value) === 'on'),
            isIndeterminate: vue.computed(()=>parent.root.selected.value.get(computedId.value) === 'indeterminate'),
            isLeaf: vue.computed(()=>!parent.root.children.value.get(computedId.value)),
            isGroupActivator: parent.isGroupActivator
        };
        vue.onBeforeMount(()=>{
            if (parent.isGroupActivator || parent.root.itemsRegistration.value === 'props') return;
            vue.nextTick(()=>{
                parent.root.register(computedId.value, parent.id.value, vue.toValue(isDisabled), isGroup);
            });
        });
        vue.onBeforeUnmount(()=>{
            if (parent.isGroupActivator || parent.root.itemsRegistration.value === 'props') return;
            parent.root.unregister(computedId.value);
        });
        vue.watch(computedId, (val, oldVal)=>{
            if (parent.isGroupActivator || parent.root.itemsRegistration.value === 'props') return;
            parent.root.unregister(oldVal);
            vue.nextTick(()=>{
                parent.root.register(val, parent.id.value, vue.toValue(isDisabled), isGroup);
            });
        });
        vue.watch(()=>vue.toValue(isDisabled), (val)=>{
            parent.root.updateDisabled(computedId.value, val);
        });
        isGroup && vue.provide(VNestedSymbol, item);
        return item;
    };
    const useNestedGroupActivator = ()=>{
        const parent = vue.inject(VNestedSymbol, emptyNested);
        vue.provide(VNestedSymbol, {
            ...parent,
            isGroupActivator: true
        });
    };
    const VListGroupActivator = defineComponent({
        name: 'VListGroupActivator',
        setup (_, { slots: slots }) {
            useNestedGroupActivator();
            return ()=>slots.default?.();
        }
    });
    const makeVListGroupProps = propsFactory({
        /* @deprecated */ activeColor: String,
        baseColor: String,
        color: String,
        collapseIcon: {
            type: IconValue,
            default: '$collapse'
        },
        disabled: Boolean,
        expandIcon: {
            type: IconValue,
            default: '$expand'
        },
        rawId: [
            String,
            Number
        ],
        prependIcon: IconValue,
        appendIcon: IconValue,
        fluid: Boolean,
        subgroup: Boolean,
        title: String,
        value: null,
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VListGroup');
    const VListGroup = genericComponent()({
        name: 'VListGroup',
        props: makeVListGroupProps(),
        setup (props, { slots: slots }) {
            const { isOpen: isOpen, open: open, id: _id } = useNestedItem(()=>props.value, ()=>props.disabled, true);
            const id = vue.computed(()=>`v-list-group--id-${String(props.rawId ?? _id.value)}`);
            const list = useList();
            const { isBooted: isBooted } = useSsrBoot();
            const parent = vue.inject(VNestedSymbol);
            const renderWhenClosed = vue.toRef(()=>parent?.root?.itemsRegistration.value === 'render');
            function onClick(e) {
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(e.target?.tagName)) return;
                open(!isOpen.value, e);
            }
            const activatorProps = vue.computed(()=>({
                    onClick: onClick,
                    class: 'v-list-group__header',
                    id: id.value
                }));
            const toggleIcon = vue.computed(()=>isOpen.value ? props.collapseIcon : props.expandIcon);
            const activatorDefaults = vue.computed(()=>({
                    VListItem: {
                        activeColor: props.activeColor,
                        baseColor: props.baseColor,
                        color: props.color,
                        prependIcon: props.prependIcon || props.subgroup && toggleIcon.value,
                        appendIcon: props.appendIcon || !props.subgroup && toggleIcon.value,
                        title: props.title,
                        value: props.value
                    }
                }));
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-list-group',
                        {
                            'v-list-group--prepend': list?.hasPrepend.value,
                            'v-list-group--fluid': props.fluid,
                            'v-list-group--subgroup': props.subgroup,
                            'v-list-group--open': isOpen.value
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, {
                    default: ()=>[
                            slots.activator && vue.createVNode(VDefaultsProvider, {
                                "defaults": activatorDefaults.value
                            }, {
                                default: ()=>[
                                        vue.createVNode(VListGroupActivator, null, {
                                            default: ()=>[
                                                    slots.activator({
                                                        props: activatorProps.value,
                                                        isOpen: isOpen.value
                                                    })
                                                ]
                                        })
                                    ]
                            }),
                            vue.createVNode(MaybeTransition, {
                                "transition": {
                                    component: VExpandTransition
                                },
                                "disabled": !isBooted.value
                            }, {
                                default: ()=>[
                                        renderWhenClosed.value ? vue.withDirectives(vue.createElementVNode("div", {
                                            "class": "v-list-group__items",
                                            "role": "group",
                                            "aria-labelledby": id.value
                                        }, [
                                            slots.default?.()
                                        ]), [
                                            [
                                                vue.vShow,
                                                isOpen.value
                                            ]
                                        ]) : isOpen.value && vue.createElementVNode("div", {
                                            "class": "v-list-group__items",
                                            "role": "group",
                                            "aria-labelledby": id.value
                                        }, [
                                            slots.default?.()
                                        ])
                                    ]
                            })
                        ]
                }));
            return {
                isOpen: isOpen
            };
        }
    });
    const makeVListItemSubtitleProps = propsFactory({
        opacity: [
            Number,
            String
        ],
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VListItemSubtitle');
    const VListItemSubtitle = genericComponent()({
        name: 'VListItemSubtitle',
        props: makeVListItemSubtitleProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-list-item-subtitle',
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-list-item-subtitle-opacity': props.opacity
                        },
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Utilities
    const VListItemTitle = createSimpleFunctional('v-list-item-title');
    // Types
    const makeVListItemProps = propsFactory({
        active: {
            type: Boolean,
            default: undefined
        },
        activeClass: String,
        /* @deprecated */ activeColor: String,
        appendAvatar: String,
        appendIcon: IconValue,
        baseColor: String,
        disabled: Boolean,
        lines: [
            Boolean,
            String
        ],
        link: {
            type: Boolean,
            default: undefined
        },
        nav: Boolean,
        prependAvatar: String,
        prependIcon: IconValue,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        },
        slim: Boolean,
        prependGap: [
            Number,
            String
        ],
        subtitle: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        title: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        value: null,
        index: Number,
        tabindex: [
            Number,
            String
        ],
        onClick: EventProp(),
        onClickOnce: EventProp(),
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeRoundedProps(),
        ...makeRouterProps(),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'text'
        })
    }, 'VListItem');
    const VListItem = genericComponent()({
        name: 'VListItem',
        directives: {
            vRipple: Ripple
        },
        props: makeVListItemProps(),
        emits: {
            click: (e)=>true
        },
        setup (props, { attrs: attrs, slots: slots, emit: emit }) {
            const link = useLink(props, attrs);
            const rootEl = vue.ref();
            const id = vue.computed(()=>props.value === undefined ? link.href.value : props.value);
            const { activate: activate, isActivated: isActivated, select: select, isOpen: isOpen, isSelected: isSelected, isIndeterminate: isIndeterminate, isGroupActivator: isGroupActivator, root: root, parent: parent, openOnSelect: openOnSelect, scrollToActive: scrollToActive, id: uid } = useNestedItem(id, ()=>props.disabled, false);
            const list = useList();
            const isActive = vue.computed(()=>props.active !== false && (props.active || link.isActive?.value || (root.activatable.value ? isActivated.value : isSelected.value)));
            const isLink = vue.toRef(()=>props.link !== false && link.isLink.value);
            const isSelectable = vue.computed(()=>!!list && (root.selectable.value || root.activatable.value || props.value != null));
            const isClickable = vue.computed(()=>!props.disabled && props.link !== false && (props.link || link.isClickable.value || isSelectable.value));
            const isTracked = vue.computed(()=>list && list.navigationStrategy.value === 'track' && props.index !== undefined && list.trackingIndex.value === props.index);
            const role = vue.computed(()=>list ? isLink.value ? 'link' : isSelectable.value ? 'option' : 'listitem' : undefined);
            const ariaSelected = vue.computed(()=>{
                if (!isSelectable.value) return undefined;
                return root.activatable.value ? isActivated.value : root.selectable.value ? isSelected.value : isActive.value;
            });
            const roundedProps = vue.toRef(()=>props.rounded || props.nav);
            const color = vue.toRef(()=>props.color ?? props.activeColor);
            const variantProps = vue.toRef(()=>({
                    color: isActive.value ? color.value ?? props.baseColor : props.baseColor,
                    variant: props.variant
                }));
            // useNestedItem doesn't call register until beforeMount,
            // so this can't be an immediate watcher as we don't know parent yet
            vue.watch(()=>link.isActive?.value, (val)=>{
                if (!val) return;
                handleActiveLink();
            });
            vue.watch(isActivated, (val)=>{
                if (!val || !scrollToActive) return;
                rootEl.value?.scrollIntoView({
                    block: 'nearest',
                    behavior: 'instant'
                });
            });
            vue.watch(isTracked, (val)=>{
                if (!val) return;
                rootEl.value?.scrollIntoView({
                    block: 'nearest',
                    behavior: 'instant'
                });
            });
            vue.onBeforeMount(()=>{
                if (link.isActive?.value) vue.nextTick(()=>handleActiveLink());
            });
            function handleActiveLink() {
                if (parent.value != null) root.open(parent.value, true);
                openOnSelect(true);
            }
            const { themeClasses: themeClasses } = provideTheme(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(variantProps);
            const { densityClasses: densityClasses } = useDensity(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(roundedProps);
            const lineClasses = vue.toRef(()=>props.lines ? `v-list-item--${props.lines}-line` : undefined);
            const rippleOptions = vue.toRef(()=>props.ripple !== undefined && !!props.ripple && list?.filterable ? {
                    keys: [
                        'Enter'
                    ]
                } : props.ripple);
            const slotProps = vue.computed(()=>({
                    isActive: isActive.value,
                    select: select,
                    isOpen: isOpen.value,
                    isSelected: isSelected.value,
                    isIndeterminate: isIndeterminate.value,
                    isDisabled: props.disabled
                }));
            function onClick(e) {
                emit('click', e);
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(e.target?.tagName)) return;
                if (!isClickable.value) return;
                link.navigate.value?.(e);
                if (isGroupActivator) return;
                if (root.activatable.value) activate(!isActivated.value, e);
                else if (root.selectable.value) select(!isSelected.value, e);
                else if (props.value != null && !isLink.value) select(!isSelected.value, e);
            }
            function onKeyDown(e) {
                const target = e.target;
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(target.tagName)) return;
                if (e.key === 'Enter' || e.key === ' ' && !list?.filterable) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.target.dispatchEvent(new MouseEvent('click', e));
                }
            }
            useRender(()=>{
                const Tag = isLink.value ? 'a' : props.tag;
                const hasTitle = slots.title || props.title != null;
                const hasSubtitle = slots.subtitle || props.subtitle != null;
                const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
                const hasAppend = !!(hasAppendMedia || slots.append);
                const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
                const hasPrepend = !!(hasPrependMedia || slots.prepend);
                list?.updateHasPrepend(hasPrepend);
                if (props.activeColor) deprecate('active-color', [
                    'color',
                    'base-color'
                ]);
                return vue.withDirectives(vue.createVNode(Tag, vue.mergeProps(link.linkProps, {
                    "ref": rootEl,
                    "id": props.index !== undefined && list ? `v-list-item-${list.uid}-${props.index}` : undefined,
                    "class": [
                        'v-list-item',
                        {
                            'v-list-item--active': isActive.value,
                            'v-list-item--disabled': props.disabled,
                            'v-list-item--link': isClickable.value,
                            'v-list-item--nav': props.nav,
                            'v-list-item--prepend': !hasPrepend && list?.hasPrepend.value,
                            'v-list-item--slim': props.slim,
                            'v-list-item--focus-visible': isTracked.value,
                            [`${props.activeClass}`]: props.activeClass && isActive.value
                        },
                        themeClasses.value,
                        borderClasses.value,
                        colorClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        lineClasses.value,
                        roundedClasses.value,
                        variantClasses.value,
                        props.class
                    ],
                    "style": [
                        {
                            '--v-list-prepend-gap': convertToUnit(props.prependGap)
                        },
                        colorStyles.value,
                        dimensionStyles.value,
                        roundedStyles.value,
                        props.style
                    ],
                    "tabindex": props.tabindex ?? (isClickable.value ? list ? -2 : 0 : undefined),
                    "aria-selected": ariaSelected.value,
                    "role": role.value,
                    "onClick": (isClickable.value || props.onClick || props.onClickOnce) && onClick,
                    "onKeydown": isClickable.value && !isLink.value && onKeyDown
                }), {
                    default: ()=>[
                            genOverlays(isClickable.value || isActive.value, 'v-list-item'),
                            hasPrepend && vue.createElementVNode("div", {
                                "key": "prepend",
                                "class": "v-list-item__prepend"
                            }, [
                                !slots.prepend ? vue.createElementVNode(vue.Fragment, null, [
                                    props.prependAvatar && vue.createVNode(VAvatar, {
                                        "key": "prepend-avatar",
                                        "density": props.density,
                                        "image": props.prependAvatar
                                    }, null),
                                    props.prependIcon && vue.createVNode(VIcon, {
                                        "key": "prepend-icon",
                                        "density": props.density,
                                        "icon": props.prependIcon
                                    }, null)
                                ]) : vue.createVNode(VDefaultsProvider, {
                                    "key": "prepend-defaults",
                                    "defaults": {
                                        VAvatar: {
                                            density: props.density,
                                            image: props.prependAvatar
                                        },
                                        VIcon: {
                                            density: props.density,
                                            icon: props.prependIcon
                                        },
                                        VListItemAction: {
                                            start: true
                                        },
                                        VCheckboxBtn: {
                                            density: props.density
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.prepend?.(slotProps.value)
                                        ]
                                }),
                                vue.createElementVNode("div", {
                                    "class": "v-list-item__spacer"
                                }, null)
                            ]),
                            vue.createElementVNode("div", {
                                "class": "v-list-item__content",
                                "data-no-activator": ""
                            }, [
                                hasTitle && vue.createVNode(VListItemTitle, {
                                    "key": "title"
                                }, {
                                    default: ()=>[
                                            slots.title?.({
                                                title: props.title
                                            }) ?? vue.toDisplayString(props.title)
                                        ]
                                }),
                                hasSubtitle && vue.createVNode(VListItemSubtitle, {
                                    "key": "subtitle"
                                }, {
                                    default: ()=>[
                                            slots.subtitle?.({
                                                subtitle: props.subtitle
                                            }) ?? vue.toDisplayString(props.subtitle)
                                        ]
                                }),
                                slots.default?.(slotProps.value)
                            ]),
                            hasAppend && vue.createElementVNode("div", {
                                "key": "append",
                                "class": "v-list-item__append"
                            }, [
                                !slots.append ? vue.createElementVNode(vue.Fragment, null, [
                                    props.appendIcon && vue.createVNode(VIcon, {
                                        "key": "append-icon",
                                        "density": props.density,
                                        "icon": props.appendIcon
                                    }, null),
                                    props.appendAvatar && vue.createVNode(VAvatar, {
                                        "key": "append-avatar",
                                        "density": props.density,
                                        "image": props.appendAvatar
                                    }, null)
                                ]) : vue.createVNode(VDefaultsProvider, {
                                    "key": "append-defaults",
                                    "defaults": {
                                        VAvatar: {
                                            density: props.density,
                                            image: props.appendAvatar
                                        },
                                        VIcon: {
                                            density: props.density,
                                            icon: props.appendIcon
                                        },
                                        VListItemAction: {
                                            end: true
                                        },
                                        VCheckboxBtn: {
                                            density: props.density
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.append?.(slotProps.value)
                                        ]
                                }),
                                vue.createElementVNode("div", {
                                    "class": "v-list-item__spacer"
                                }, null)
                            ])
                        ]
                }), [
                    [
                        Ripple,
                        isClickable.value && rippleOptions.value
                    ]
                ]);
            });
            return {
                activate: activate,
                isActivated: isActivated,
                isGroupActivator: isGroupActivator,
                isSelected: isSelected,
                list: list,
                select: select,
                root: root,
                id: uid,
                link: link
            };
        }
    });
    const makeVListSubheaderProps = propsFactory({
        color: String,
        inset: Boolean,
        sticky: Boolean,
        title: String,
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VListSubheader');
    const VListSubheader = genericComponent()({
        name: 'VListSubheader',
        props: makeVListSubheaderProps(),
        setup (props, { slots: slots }) {
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            useRender(()=>{
                const hasText = !!(slots.default || props.title);
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-list-subheader',
                        {
                            'v-list-subheader--inset': props.inset,
                            'v-list-subheader--sticky': props.sticky
                        },
                        textColorClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            textColorStyles: textColorStyles
                        },
                        props.style
                    ])
                }, {
                    default: ()=>[
                            hasText && vue.createElementVNode("div", {
                                "class": "v-list-subheader__text"
                            }, [
                                slots.default?.() ?? props.title
                            ])
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVListChildrenProps = propsFactory({
        items: Array,
        returnObject: Boolean
    }, 'VListChildren');
    const VListChildren = genericComponent()({
        name: 'VListChildren',
        props: makeVListChildrenProps(),
        setup (props, { slots: slots }) {
            createList();
            return ()=>slots.default?.() ?? props.items?.map(({ children: children, props: itemProps, type: type, raw: item }, index)=>{
                    if (type === 'divider') return slots.divider?.({
                        props: itemProps
                    }) ?? vue.createVNode(VDivider, itemProps, null);
                    if (type === 'subheader') return slots.subheader?.({
                        props: itemProps
                    }) ?? vue.createVNode(VListSubheader, itemProps, null);
                    const slotsWithItem = {
                        subtitle: slots.subtitle ? (slotProps)=>slots.subtitle?.({
                                ...slotProps,
                                item: item
                            }) : undefined,
                        prepend: slots.prepend ? (slotProps)=>slots.prepend?.({
                                ...slotProps,
                                item: item
                            }) : undefined,
                        append: slots.append ? (slotProps)=>slots.append?.({
                                ...slotProps,
                                item: item
                            }) : undefined,
                        title: slots.title ? (slotProps)=>slots.title?.({
                                ...slotProps,
                                item: item
                            }) : undefined
                    };
                    const listGroupProps = VListGroup.filterProps(itemProps);
                    return children ? vue.createVNode(VListGroup, vue.mergeProps(listGroupProps, {
                        "value": props.returnObject ? item : itemProps?.value,
                        "rawId": itemProps?.value
                    }), {
                        activator: ({ props: activatorProps })=>{
                            const listItemProps = vue.mergeProps(itemProps, activatorProps, {
                                value: props.returnObject ? item : itemProps.value
                            });
                            return slots.header ? slots.header({
                                props: listItemProps
                            }) : vue.createVNode(VListItem, vue.mergeProps(listItemProps, {
                                "index": index
                            }), slotsWithItem);
                        },
                        default: ()=>vue.createVNode(VListChildren, {
                                "items": children,
                                "returnObject": props.returnObject
                            }, slots)
                    }) : slots.item ? slots.item({
                        props: {
                            ...itemProps,
                            index: index
                        }
                    }) : vue.createVNode(VListItem, vue.mergeProps(itemProps, {
                        "index": index,
                        "value": props.returnObject ? item : itemProps.value
                    }), slotsWithItem);
                });
        }
    });
    // Utilities
    // Types
    // Composables
    const makeItemsProps = propsFactory({
        items: {
            type: Array,
            default: ()=>[]
        },
        itemTitle: {
            type: [
                String,
                Array,
                Function
            ],
            default: 'title'
        },
        itemValue: {
            type: [
                String,
                Array,
                Function
            ],
            default: 'value'
        },
        itemChildren: {
            type: [
                Boolean,
                String,
                Array,
                Function
            ],
            default: 'children'
        },
        itemProps: {
            type: [
                Boolean,
                String,
                Array,
                Function
            ],
            default: 'props'
        },
        itemType: {
            type: [
                Boolean,
                String,
                Array,
                Function
            ],
            default: 'type'
        },
        returnObject: Boolean,
        valueComparator: Function
    }, 'list-items');
    const itemTypes$1 = new Set([
        'item',
        'divider',
        'subheader'
    ]);
    function transformItem$3(props, item) {
        const title = getPropertyFromItem(item, props.itemTitle, item);
        const value = getPropertyFromItem(item, props.itemValue, title);
        const children = getPropertyFromItem(item, props.itemChildren);
        const itemProps = props.itemProps === true ? typeof item === 'object' && item != null && !Array.isArray(item) ? 'children' in item ? omit(item, [
            'children'
        ]) : item : undefined : getPropertyFromItem(item, props.itemProps);
        let type = getPropertyFromItem(item, props.itemType, 'item');
        if (!itemTypes$1.has(type)) type = 'item';
        const _props = {
            title: title,
            value: value,
            ...itemProps
        };
        return {
            type: type,
            title: String(_props.title ?? ''),
            value: _props.value,
            props: _props,
            children: type === 'item' && Array.isArray(children) ? transformItems$3(props, children) : undefined,
            raw: item
        };
    }
    transformItem$3.neededProps = [
        'itemTitle',
        'itemValue',
        'itemChildren',
        'itemProps',
        'itemType'
    ];
    function transformItems$3(props, items) {
        // avoid reactive access in the loop
        const _props = pick(props, transformItem$3.neededProps);
        const array = [];
        for (const item of items)array.push(transformItem$3(_props, item));
        return array;
    }
    function useItems(props) {
        const items = vue.computed(()=>transformItems$3(props, props.items));
        const hasNullItem = vue.computed(()=>items.value.some((item)=>item.value === null));
        const itemsMap = vue.shallowRef(new Map());
        const keylessItems = vue.shallowRef([]);
        vue.watchEffect(()=>{
            const _items = items.value;
            const map = new Map();
            const keyless = [];
            for(let i = 0; i < _items.length; i++){
                const item = _items[i];
                if (isPrimitive(item.value) || item.value === null) {
                    let values = map.get(item.value);
                    if (!values) {
                        values = [];
                        map.set(item.value, values);
                    }
                    values.push(item);
                } else keyless.push(item);
            }
            itemsMap.value = map;
            keylessItems.value = keyless;
        });
        function transformIn(value) {
            // Cache unrefed values outside the loop,
            // proxy getters can be slow when you call them a billion times
            const _items = itemsMap.value;
            const _allItems = items.value;
            const _keylessItems = keylessItems.value;
            const _hasNullItem = hasNullItem.value;
            const _returnObject = props.returnObject;
            const hasValueComparator = !!props.valueComparator;
            const valueComparator = props.valueComparator || deepEqual;
            const _props = pick(props, transformItem$3.neededProps);
            const returnValue = [];
            main: for (const v of value){
                // When the model value is null, return an InternalItem
                // based on null only if null is one of the items
                if (!_hasNullItem && v === null) continue;
                // String model value means value is a custom input value from combobox
                // Don't look up existing items if the model value is a string
                if (_returnObject && typeof v === 'string') {
                    returnValue.push(transformItem$3(_props, v));
                    continue;
                }
                // Fast path, items with primitive values and no
                // custom valueComparator can use a constant-time
                // map lookup instead of searching the items array
                const fastItems = _items.get(v);
                // Slow path, always use valueComparator.
                // This is O(n^2) so we really don't want to
                // do it for more than a couple hundred items.
                if (hasValueComparator || !fastItems) {
                    for (const item of hasValueComparator ? _allItems : _keylessItems)if (valueComparator(v, item.value)) {
                        returnValue.push(item);
                        continue main;
                    }
                    // Not an existing item, construct it from the model (#4000)
                    returnValue.push(transformItem$3(_props, v));
                    continue;
                }
                returnValue.push(...fastItems);
            }
            return returnValue;
        }
        function transformOut(value) {
            return props.returnObject ? value.map(({ raw: raw })=>raw) : value.map(({ value: value })=>value);
        }
        return {
            items: items,
            transformIn: transformIn,
            transformOut: transformOut
        };
    }
    // Types
    const itemTypes = new Set([
        'item',
        'divider',
        'subheader'
    ]);
    function transformItem$2(props, item) {
        const title = isPrimitive(item) ? item : getPropertyFromItem(item, props.itemTitle);
        const value = isPrimitive(item) ? item : getPropertyFromItem(item, props.itemValue, undefined);
        const children = getPropertyFromItem(item, props.itemChildren);
        const itemProps = props.itemProps === true ? omit(item, [
            'children'
        ]) : getPropertyFromItem(item, props.itemProps);
        let type = getPropertyFromItem(item, props.itemType, 'item');
        if (!itemTypes.has(type)) type = 'item';
        const _props = {
            title: title,
            value: value,
            ...itemProps
        };
        return {
            type: type,
            title: _props.title,
            value: _props.value,
            props: _props,
            children: type === 'item' && children ? transformItems$2(props, children) : undefined,
            raw: item
        };
    }
    function transformItems$2(props, items) {
        const array = [];
        for (const item of items)array.push(transformItem$2(props, item));
        return array;
    }
    function useListItems(props) {
        const items = vue.computed(()=>transformItems$2(props, props.items));
        return {
            items: items
        };
    }
    const makeVListProps = propsFactory({
        baseColor: String,
        /* @deprecated */ activeColor: String,
        activeClass: String,
        bgColor: String,
        disabled: Boolean,
        filterable: Boolean,
        expandIcon: IconValue,
        collapseIcon: IconValue,
        lines: {
            type: [
                Boolean,
                String
            ],
            default: 'one'
        },
        slim: Boolean,
        prependGap: [
            Number,
            String
        ],
        indent: [
            Number,
            String
        ],
        nav: Boolean,
        navigationStrategy: {
            type: String,
            default: 'focus'
        },
        navigationIndex: Number,
        'onClick:open': EventProp(),
        'onClick:select': EventProp(),
        'onUpdate:opened': EventProp(),
        ...makeNestedProps({
            selectStrategy: 'single-leaf',
            openStrategy: 'list'
        }),
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeItemsProps(),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'text'
        })
    }, 'VList');
    const VList = genericComponent()({
        name: 'VList',
        props: makeVListProps(),
        emits: {
            'update:selected': (value)=>true,
            'update:activated': (value)=>true,
            'update:opened': (value)=>true,
            'update:navigationIndex': (value)=>true,
            'click:open': (value)=>true,
            'click:activate': (value)=>true,
            'click:select': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots, emit: emit }) {
            const { items: items } = useListItems(props);
            const { themeClasses: themeClasses } = provideTheme(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { borderClasses: borderClasses } = useBorder(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { children: children, open: open, parents: parents, select: select, getPath: getPath } = useNested(props, {
                items: items,
                returnObject: vue.toRef(()=>props.returnObject),
                scrollToActive: vue.toRef(()=>props.navigationStrategy === 'track'),
                valueComparator: vue.toRef(()=>props.valueComparator)
            });
            const lineClasses = vue.toRef(()=>props.lines ? `v-list--${props.lines}-line` : undefined);
            const activeColor = vue.toRef(()=>props.activeColor);
            const baseColor = vue.toRef(()=>props.baseColor);
            const color = vue.toRef(()=>props.color);
            const isSelectable = vue.toRef(()=>props.selectable || props.activatable);
            const navigationIndex = useProxiedModel(props, 'navigationIndex', -1, (v)=>v ?? -1);
            const uid = vue.useId();
            createList({
                filterable: props.filterable,
                trackingIndex: navigationIndex,
                navigationStrategy: vue.toRef(()=>props.navigationStrategy),
                uid: uid
            });
            vue.watch(items, ()=>{
                if (props.navigationStrategy === 'track') navigationIndex.value = -1;
            });
            provideDefaults({
                VListGroup: {
                    activeColor: activeColor,
                    baseColor: baseColor,
                    color: color,
                    expandIcon: vue.toRef(()=>props.expandIcon),
                    collapseIcon: vue.toRef(()=>props.collapseIcon)
                },
                VListItem: {
                    activeClass: vue.toRef(()=>props.activeClass),
                    activeColor: activeColor,
                    baseColor: baseColor,
                    color: color,
                    density: vue.toRef(()=>props.density),
                    disabled: vue.toRef(()=>props.disabled),
                    lines: vue.toRef(()=>props.lines),
                    nav: vue.toRef(()=>props.nav),
                    slim: vue.toRef(()=>props.slim),
                    variant: vue.toRef(()=>props.variant),
                    tabindex: vue.toRef(()=>props.navigationStrategy === 'track' ? -1 : undefined)
                }
            });
            const isFocused = vue.shallowRef(false);
            const contentRef = vue.ref();
            function onFocusin(e) {
                isFocused.value = true;
            }
            function onFocusout(e) {
                isFocused.value = false;
            }
            function onFocus(e) {
                if (props.navigationStrategy === 'track') {
                    if (!~navigationIndex.value) navigationIndex.value = getNextIndex('first');
                } else if (!isFocused.value && !(e.relatedTarget && contentRef.value?.contains(e.relatedTarget))) focus();
            }
            function onBlur() {
                if (props.navigationStrategy === 'track') navigationIndex.value = -1;
            }
            function getNavigationDirection(key) {
                switch(key){
                    case 'ArrowDown':
                        return 'next';
                    case 'ArrowUp':
                        return 'prev';
                    case 'Home':
                        return 'first';
                    case 'End':
                        return 'last';
                    default:
                        return null;
                }
            }
            function getNextIndex(direction) {
                const itemCount = items.value.length;
                if (itemCount === 0) return -1;
                let nextIndex;
                if (direction === 'first') nextIndex = 0;
                else if (direction === 'last') nextIndex = itemCount - 1;
                else {
                    nextIndex = navigationIndex.value + (direction === 'next' ? 1 : -1);
                    if (nextIndex < 0) nextIndex = itemCount - 1;
                    if (nextIndex >= itemCount) nextIndex = 0;
                }
                const startIndex = nextIndex;
                let attempts = 0;
                while(attempts < itemCount){
                    const item = items.value[nextIndex];
                    if (item && item.type !== 'divider' && item.type !== 'subheader') return nextIndex;
                    nextIndex += direction === 'next' || direction === 'first' ? 1 : -1;
                    if (nextIndex < 0) nextIndex = itemCount - 1;
                    if (nextIndex >= itemCount) nextIndex = 0;
                    if (nextIndex === startIndex) return -1;
                    attempts++;
                }
                return -1;
            }
            function onKeydown(e) {
                const target = e.target;
                if (!contentRef.value || target.tagName === 'INPUT' && [
                    'Home',
                    'End'
                ].includes(e.key) || target.tagName === 'TEXTAREA') return;
                const direction = getNavigationDirection(e.key);
                if (direction !== null) {
                    e.preventDefault();
                    if (props.navigationStrategy === 'track') {
                        const nextIndex = getNextIndex(direction);
                        if (nextIndex !== -1) navigationIndex.value = nextIndex;
                    } else focus(direction);
                }
            }
            function onMousedown(e) {
                isFocused.value = true;
            }
            function focus(location, options) {
                if (contentRef.value) return focusChild(contentRef.value, location, options);
            }
            useRender(()=>{
                const indent = props.indent ?? (props.prependGap ? Number(props.prependGap) + 24 : undefined);
                const ariaMultiselectable = isSelectable.value ? attrs.ariaMultiselectable ?? !String(props.selectStrategy).startsWith('single-') : undefined;
                return vue.createVNode(props.tag, {
                    "ref": contentRef,
                    "class": vue.normalizeClass([
                        'v-list',
                        {
                            'v-list--disabled': props.disabled,
                            'v-list--nav': props.nav,
                            'v-list--slim': props.slim
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        lineClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-list-indent': convertToUnit(indent),
                            '--v-list-group-prepend': indent ? '0px' : undefined,
                            '--v-list-prepend-gap': convertToUnit(props.prependGap)
                        },
                        backgroundColorStyles.value,
                        dimensionStyles.value,
                        roundedStyles.value,
                        props.style
                    ]),
                    "tabindex": props.disabled ? -1 : 0,
                    "role": isSelectable.value ? 'listbox' : 'list',
                    "aria-activedescendant": props.navigationStrategy === 'track' && navigationIndex.value >= 0 ? `v-list-item-${uid}-${navigationIndex.value}` : undefined,
                    "aria-multiselectable": ariaMultiselectable,
                    "onFocusin": onFocusin,
                    "onFocusout": onFocusout,
                    "onFocus": onFocus,
                    "onBlur": onBlur,
                    "onKeydown": onKeydown,
                    "onMousedown": onMousedown
                }, {
                    default: ()=>[
                            vue.createVNode(VListChildren, {
                                "items": items.value,
                                "returnObject": props.returnObject
                            }, slots)
                        ]
                });
            });
            return {
                open: open,
                select: select,
                focus: focus,
                children: children,
                parents: parents,
                getPath: getPath,
                navigationIndex: navigationIndex
            };
        }
    });
    // Utilities
    const VListImg = createSimpleFunctional('v-list-img');
    const makeVListItemActionProps = propsFactory({
        start: Boolean,
        end: Boolean,
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VListItemAction');
    const VListItemAction = genericComponent()({
        name: 'VListItemAction',
        props: makeVListItemActionProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-list-item-action',
                        {
                            'v-list-item-action--start': props.start,
                            'v-list-item-action--end': props.end
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, slots));
            return {};
        }
    });
    const makeVListItemMediaProps = propsFactory({
        start: Boolean,
        end: Boolean,
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VListItemMedia');
    const VListItemMedia = genericComponent()({
        name: 'VListItemMedia',
        props: makeVListItemMediaProps(),
        setup (props, { slots: slots }) {
            useRender(()=>{
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-list-item-media',
                        {
                            'v-list-item-media--start': props.start,
                            'v-list-item-media--end': props.end
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, slots);
            });
            return {};
        }
    });
    // Types
    /** Convert a point in local space to viewport space */ function elementToViewport(point, offset) {
        return {
            x: point.x + offset.x,
            y: point.y + offset.y
        };
    }
    /** Get the difference between two points */ function getOffset$1(a, b) {
        return {
            x: a.x - b.x,
            y: a.y - b.y
        };
    }
    /** Convert an anchor object to a point in local space */ function anchorToPoint(anchor, box) {
        if (anchor.side === 'top' || anchor.side === 'bottom') {
            const { side: side, align: align } = anchor;
            const x = align === 'left' ? 0 : align === 'center' ? box.width / 2 : align === 'right' ? box.width : align;
            const y = side === 'top' ? 0 : side === 'bottom' ? box.height : side;
            return elementToViewport({
                x: x,
                y: y
            }, box);
        } else if (anchor.side === 'left' || anchor.side === 'right') {
            const { side: side, align: align } = anchor;
            const x = side === 'left' ? 0 : side === 'right' ? box.width : side;
            const y = align === 'top' ? 0 : align === 'center' ? box.height / 2 : align === 'bottom' ? box.height : align;
            return elementToViewport({
                x: x,
                y: y
            }, box);
        }
        return elementToViewport({
            x: box.width / 2,
            y: box.height / 2
        }, box);
    }
    // Composables
    // Types
    const locationStrategies = {
        static: staticLocationStrategy,
        // specific viewport position, usually centered
        connected: connectedLocationStrategy // connected to a certain element
    };
    const makeLocationStrategyProps = propsFactory({
        locationStrategy: {
            type: [
                String,
                Function
            ],
            default: 'static',
            validator: (val)=>typeof val === 'function' || val in locationStrategies
        },
        location: String,
        origin: {
            type: String,
            default: 'auto'
        },
        offset: [
            Number,
            String,
            Array
        ],
        stickToTarget: Boolean,
        viewportMargin: {
            type: [
                Number,
                String
            ],
            default: 12
        }
    }, 'VOverlay-location-strategies');
    function useLocationStrategies(props, data) {
        const contentStyles = vue.ref({});
        const updateLocation = vue.ref();
        if (IN_BROWSER) useToggleScope(()=>!!(data.isActive.value && props.locationStrategy), (reset)=>{
            vue.watch(()=>props.locationStrategy, reset);
            vue.onScopeDispose(()=>{
                window.removeEventListener('resize', onResize);
                visualViewport?.removeEventListener('resize', onVisualResize);
                visualViewport?.removeEventListener('scroll', onVisualScroll);
                updateLocation.value = undefined;
                if (data.isActive.value) contentStyles.value = {};
            });
            window.addEventListener('resize', onResize, {
                passive: true
            });
            visualViewport?.addEventListener('resize', onVisualResize, {
                passive: true
            });
            visualViewport?.addEventListener('scroll', onVisualScroll, {
                passive: true
            });
            if (typeof props.locationStrategy === 'function') updateLocation.value = props.locationStrategy(data, props, contentStyles)?.updateLocation;
            else updateLocation.value = locationStrategies[props.locationStrategy](data, props, contentStyles)?.updateLocation;
        });
        function onResize(e) {
            updateLocation.value?.(e);
        }
        function onVisualResize(e) {
            updateLocation.value?.(e);
        }
        function onVisualScroll(e) {
            updateLocation.value?.(e);
        }
        return {
            contentStyles: contentStyles,
            updateLocation: updateLocation
        };
    }
    function getStaticLocationClasses(location) {
        if (!location) return undefined;
        const normalized = location.includes(' ') ? location : `${location} center`;
        let justify = 'center';
        let align = 'center';
        const inline = {
            left: 'start',
            start: 'start',
            right: 'end',
            end: 'end'
        };
        const block = {
            top: 'start',
            bottom: 'end'
        };
        for (const token of normalized.split(' ')){
            if (token in inline) justify = inline[token];
            else if (token in block) align = block[token];
        }
        return {
            [`v-overlay--justify-${justify}`]: true,
            [`v-overlay--align-${align}`]: true
        };
    }
    function staticLocationStrategy(data, props, contentStyles) {
        // Positioning is handled by CSS flexbox alignment on the overlay root, keeping
        // the content's insets `auto` so user utility classes (justify-*, align-*) compose.
        // Here we only forward an explicit `origin` to `transform-origin` for the transition.
        function updateStyles() {
            if (props.origin !== 'auto' && props.origin !== 'overlap') {
                const { side: side, align: align } = parseAnchor(props.origin, data.isRtl.value);
                contentStyles.value = {
                    transformOrigin: `${side} ${align}`
                };
            } else contentStyles.value = {};
        }
        vue.watch([
            ()=>props.origin,
            data.isRtl
        ], updateStyles, {
            immediate: true
        });
        return {
            updateLocation: ()=>{}
        };
    }
    /** Resolve a CSS length the browser understands (calc(), min(), vw, …) to pixels */ function resolveCssLength(value, container, isWidth) {
        const probe = document.createElement('div');
        probe.style.position = 'absolute';
        probe.style.visibility = 'hidden';
        probe.style[isWidth ? 'width' : 'height'] = value;
        container.appendChild(probe);
        const size = isWidth ? probe.offsetWidth : probe.offsetHeight;
        container.removeChild(probe);
        return size > 0 ? size : Infinity;
    }
    /** Get size of element ignoring max-width/max-height */ function getIntrinsicSize(el, isRtl) {
        // const scrollables = new Map<Element, [number, number]>()
        // el.querySelectorAll('*').forEach(el => {
        //   const x = el.scrollLeft
        //   const y = el.scrollTop
        //   if (x || y) {
        //     scrollables.set(el, [x, y])
        //   }
        // })
        // const initialMaxWidth = el.style.maxWidth
        // const initialMaxHeight = el.style.maxHeight
        // el.style.removeProperty('max-width')
        // el.style.removeProperty('max-height')
        /* eslint-disable-next-line sonarjs/prefer-immediate-return */ const contentBox = nullifyTransforms(el);
        if (isRtl) contentBox.x += parseFloat(el.style.right || 0);
        else contentBox.x -= parseFloat(el.style.left || 0);
        contentBox.y -= parseFloat(el.style.top || 0);
        // el.style.maxWidth = initialMaxWidth
        // el.style.maxHeight = initialMaxHeight
        // scrollables.forEach((position, el) => {
        //   el.scrollTo(...position)
        // })
        return contentBox;
    }
    function connectedLocationStrategy(data, props, contentStyles) {
        const activatorFixed = Array.isArray(data.target.value) || isFixedPosition(data.target.value);
        if (activatorFixed) Object.assign(contentStyles.value, {
            position: 'fixed',
            top: 0,
            [data.isRtl.value ? 'right' : 'left']: 0
        });
        const { preferredAnchor: preferredAnchor, preferredOrigin: preferredOrigin } = destructComputed(()=>{
            const parsedAnchor = parseAnchor(props.location ?? 'bottom', data.isRtl.value);
            const parsedOrigin = props.origin === 'overlap' ? parsedAnchor : props.origin === 'auto' ? flipSide(parsedAnchor) : parseAnchor(props.origin, data.isRtl.value);
            // Some combinations of props may produce an invalid origin
            if (parsedAnchor.side === parsedOrigin.side && parsedAnchor.align === flipAlign(parsedOrigin).align) return {
                preferredAnchor: flipCorner(parsedAnchor),
                preferredOrigin: flipCorner(parsedOrigin)
            };
            else return {
                preferredAnchor: parsedAnchor,
                preferredOrigin: parsedOrigin
            };
        });
        const [getMinWidth, getMinHeight, getMaxWidth, getMaxHeight] = [
            'minWidth',
            'minHeight',
            'maxWidth',
            'maxHeight'
        ].map((key)=>{
            const isWidth = key.endsWith('Width');
            return ()=>{
                const raw = props[key];
                if (raw == null) return Infinity;
                const container = data.contentEl.value?.parentElement ?? document.documentElement;
                if (typeof raw === 'number' || /^-?[\d.]+(?:px)?$/.test(raw.trim())) return parseFloat(raw);
                if (raw.endsWith('%')) {
                    // resolve against the overlay container, like CSS would
                    const box = getElementBox(container);
                    return parseFloat(raw) * (isWidth ? box.width : box.height) / 100;
                }
                // let the browser resolve viewport units, calc(), min(), max(), clamp(), etc.
                return resolveCssLength(raw, container, isWidth);
            };
        });
        const offset = vue.computed(()=>{
            if (Array.isArray(props.offset)) return props.offset;
            if (typeof props.offset === 'string') {
                const offset = props.offset.split(' ').map(parseFloat);
                if (offset.length < 2) offset.push(0);
                return offset;
            }
            return typeof props.offset === 'number' ? [
                props.offset,
                0
            ] : [
                0,
                0
            ];
        });
        let observe = false;
        let lastFrame = -1;
        const flipped = new CircularBuffer(4);
        const observer = new ResizeObserver(()=>{
            if (!observe) return;
            // Detect consecutive frames
            requestAnimationFrame((newTime)=>{
                if (newTime !== lastFrame) flipped.clear();
                requestAnimationFrame((newNewTime)=>{
                    lastFrame = newNewTime;
                });
            });
            if (flipped.isFull) {
                const values = flipped.values();
                if (deepEqual(values.at(-1), values.at(-3)) && !deepEqual(values.at(-1), values.at(-2))) // Flipping is causing a container resize loop
                return;
            }
            const result = updateLocation();
            if (result) flipped.push(result.flipped);
        });
        let targetBox = new Box({
            x: 0,
            y: 0,
            width: 0,
            height: 0
        });
        vue.watch(data.target, (newTarget, oldTarget)=>{
            if (oldTarget && !Array.isArray(oldTarget)) observer.unobserve(oldTarget);
            if (!Array.isArray(newTarget)) {
                if (newTarget) observer.observe(newTarget);
            } else if (!deepEqual(newTarget, oldTarget)) updateLocation();
        }, {
            immediate: true
        });
        vue.watch(data.contentEl, (newContentEl, oldContentEl)=>{
            if (oldContentEl) observer.unobserve(oldContentEl);
            if (newContentEl) observer.observe(newContentEl);
        }, {
            immediate: true
        });
        vue.onScopeDispose(()=>{
            observer.disconnect();
        });
        // eslint-disable-next-line max-statements
        function updateLocation() {
            observe = false;
            requestAnimationFrame(()=>observe = true);
            if (!data.target.value || !data.contentEl.value) return;
            if (Array.isArray(data.target.value) || data.target.value.offsetParent || data.target.value.getClientRects().length) targetBox = getTargetBox(data.target.value);
             // Otherwise target element is hidden, use last known value
            const contentBox = getIntrinsicSize(data.contentEl.value, data.isRtl.value);
            const scrollParents = getScrollParents(data.contentEl.value);
            const viewportMargin = Number(props.viewportMargin);
            const minWidth = getMinWidth();
            const minHeight = getMinHeight();
            const maxWidth = getMaxWidth();
            const maxHeight = getMaxHeight();
            if (!scrollParents.length) {
                scrollParents.push(document.documentElement);
                if (!(data.contentEl.value.style.top && data.contentEl.value.style.left)) {
                    contentBox.x -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-x') || 0);
                    contentBox.y -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-y') || 0);
                }
            }
            const viewport = scrollParents.reduce((box, el)=>{
                const scrollBox = getElementBox(el);
                if (box) return new Box({
                    x: Math.max(box.left, scrollBox.left),
                    y: Math.max(box.top, scrollBox.top),
                    width: Math.min(box.right, scrollBox.right) - Math.max(box.left, scrollBox.left),
                    height: Math.min(box.bottom, scrollBox.bottom) - Math.max(box.top, scrollBox.top)
                });
                return scrollBox;
            }, undefined);
            if (props.stickToTarget) {
                viewport.x += Math.min(viewportMargin, targetBox.x);
                viewport.y += Math.min(viewportMargin, targetBox.y);
                viewport.width = Math.max(viewport.width - viewportMargin * 2, targetBox.x + targetBox.width - viewportMargin);
                viewport.height = Math.max(viewport.height - viewportMargin * 2, targetBox.y + targetBox.height - viewportMargin);
            } else {
                viewport.x += viewportMargin;
                viewport.y += viewportMargin;
                viewport.width -= viewportMargin * 2;
                viewport.height -= viewportMargin * 2;
            }
            let placement = {
                anchor: preferredAnchor.value,
                origin: preferredOrigin.value
            };
            function checkOverflow(_placement) {
                const box = new Box(contentBox);
                const targetPoint = anchorToPoint(_placement.anchor, targetBox);
                const contentPoint = anchorToPoint(_placement.origin, box);
                let { x: x, y: y } = getOffset$1(targetPoint, contentPoint);
                switch(_placement.anchor.side){
                    case 'top':
                        y -= offset.value[0];
                        break;
                    case 'bottom':
                        y += offset.value[0];
                        break;
                    case 'left':
                        x -= offset.value[0];
                        break;
                    case 'right':
                        x += offset.value[0];
                        break;
                }
                switch(_placement.anchor.align){
                    case 'top':
                        y -= offset.value[1];
                        break;
                    case 'bottom':
                        y += offset.value[1];
                        break;
                    case 'left':
                        x -= offset.value[1];
                        break;
                    case 'right':
                        x += offset.value[1];
                        break;
                }
                box.x += x;
                box.y += y;
                box.width = Math.min(box.width, maxWidth);
                box.height = Math.min(box.height, maxHeight);
                const overflows = getOverflow(box, viewport);
                return {
                    overflows: overflows,
                    x: x,
                    y: y
                };
            }
            let x = 0;
            let y = 0;
            const available = {
                x: 0,
                y: 0
            };
            const flipped = {
                x: false,
                y: false
            };
            let resets = -1;
            while(true){
                if (resets++ > 10) {
                    consoleError('Infinite loop detected in connectedLocationStrategy');
                    break;
                }
                const { x: _x, y: _y, overflows: overflows } = checkOverflow(placement);
                x += _x;
                y += _y;
                contentBox.x += _x;
                contentBox.y += _y;
                // flip
                {
                    const axis = getAxis(placement.anchor);
                    const hasOverflowX = overflows.x.before || overflows.x.after;
                    const hasOverflowY = overflows.y.before || overflows.y.after;
                    let reset = false;
                    [
                        'x',
                        'y'
                    ].forEach((key)=>{
                        if (key === 'x' && hasOverflowX && !flipped.x || key === 'y' && hasOverflowY && !flipped.y) {
                            const newPlacement = {
                                anchor: {
                                    ...placement.anchor
                                },
                                origin: {
                                    ...placement.origin
                                }
                            };
                            const flip = key === 'x' ? axis === 'y' ? flipAlign : flipSide : axis === 'y' ? flipSide : flipAlign;
                            newPlacement.anchor = flip(newPlacement.anchor);
                            newPlacement.origin = flip(newPlacement.origin);
                            const { overflows: newOverflows } = checkOverflow(newPlacement);
                            if (newOverflows[key].before <= overflows[key].before && newOverflows[key].after <= overflows[key].after || newOverflows[key].before + newOverflows[key].after < (overflows[key].before + overflows[key].after) / 2) {
                                placement = newPlacement;
                                reset = flipped[key] = true;
                            }
                        }
                    });
                    if (reset) continue;
                }
                // shift
                if (overflows.x.before) {
                    x += overflows.x.before;
                    contentBox.x += overflows.x.before;
                }
                if (overflows.x.after) {
                    x -= overflows.x.after;
                    contentBox.x -= overflows.x.after;
                }
                if (overflows.y.before) {
                    y += overflows.y.before;
                    contentBox.y += overflows.y.before;
                }
                if (overflows.y.after) {
                    y -= overflows.y.after;
                    contentBox.y -= overflows.y.after;
                }
                // size
                {
                    const overflows = getOverflow(contentBox, viewport);
                    available.x = viewport.width - overflows.x.before - overflows.x.after;
                    available.y = viewport.height - overflows.y.before - overflows.y.after;
                    x += overflows.x.before;
                    contentBox.x += overflows.x.before;
                    y += overflows.y.before;
                    contentBox.y += overflows.y.before;
                }
                break;
            }
            const axis = getAxis(placement.anchor);
            const transformOrigin = props.origin !== 'auto' && props.origin !== 'overlap' ? parseAnchor(props.origin, data.isRtl.value) : placement.origin;
            Object.assign(contentStyles.value, {
                '--v-overlay-anchor-origin': `${placement.anchor.side} ${placement.anchor.align}`,
                transformOrigin: `${transformOrigin.side} ${transformOrigin.align}`,
                // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
                top: convertToUnit(pixelRound(y)),
                left: data.isRtl.value ? undefined : convertToUnit(pixelRound(x)),
                right: data.isRtl.value ? convertToUnit(pixelRound(-x)) : undefined,
                minWidth: convertToUnit(axis === 'y' ? Math.min(minWidth, targetBox.width) : minWidth),
                maxWidth: convertToUnit(pixelCeil(clamp(available.x, minWidth === Infinity ? 0 : minWidth, maxWidth))),
                maxHeight: convertToUnit(pixelCeil(clamp(available.y, minHeight === Infinity ? 0 : minHeight, maxHeight)))
            });
            return {
                available: available,
                contentBox: contentBox,
                flipped: flipped
            };
        }
        vue.watch(()=>[
                preferredAnchor.value,
                preferredOrigin.value,
                props.origin,
                props.offset,
                props.minWidth,
                props.minHeight,
                props.maxWidth,
                props.maxHeight
            ], ()=>updateLocation());
        vue.nextTick(()=>{
            const result = updateLocation();
            // TODO: overflowing content should only require a single updateLocation call
            // Icky hack to make sure the content is positioned consistently
            if (!result) return;
            const { available: available, contentBox: contentBox } = result;
            if (contentBox.height > available.y) requestAnimationFrame(()=>{
                updateLocation();
                requestAnimationFrame(()=>{
                    updateLocation();
                });
            });
        });
        return {
            updateLocation: updateLocation
        };
    }
    function pixelRound(val) {
        return Math.round(val * devicePixelRatio) / devicePixelRatio;
    }
    function pixelCeil(val) {
        return Math.ceil(val * devicePixelRatio) / devicePixelRatio;
    }
    let clean = true;
    const frames = [];
    /**
   * Schedule a task to run in an animation frame on its own
   * This is useful for heavy tasks that may cause jank if all ran together
   */ function requestNewFrame(cb) {
        if (!clean || frames.length) {
            frames.push(cb);
            run();
        } else {
            clean = false;
            cb();
            run();
        }
    }
    let raf = -1;
    function run() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(()=>{
            const frame = frames.shift();
            if (frame) frame();
            if (frames.length) run();
            else clean = true;
        });
    }
    // Utilities
    // Types
    const scrollStrategies = {
        none: null,
        close: closeScrollStrategy,
        block: blockScrollStrategy,
        reposition: repositionScrollStrategy
    };
    const makeScrollStrategyProps = propsFactory({
        scrollStrategy: {
            type: [
                String,
                Function
            ],
            default: 'block',
            validator: (val)=>typeof val === 'function' || val in scrollStrategies
        }
    }, 'VOverlay-scroll-strategies');
    function useScrollStrategies(props, data) {
        if (!IN_BROWSER) return;
        let scope;
        vue.watchEffect(async ()=>{
            scope?.stop();
            if (!(data.isActive.value && props.scrollStrategy)) return;
            scope = vue.effectScope();
            await new Promise((resolve)=>setTimeout(resolve));
            scope.active && scope.run(()=>{
                if (typeof props.scrollStrategy === 'function') props.scrollStrategy(data, props, scope);
                else scrollStrategies[props.scrollStrategy]?.(data, props, scope);
            });
        });
        vue.onScopeDispose(()=>{
            scope?.stop();
        });
    }
    function closeScrollStrategy(data) {
        function onScroll(e) {
            data.isActive.value = false;
        }
        bindScroll(getTargetEl(data.target.value, data.contentEl.value), onScroll);
    }
    function blockScrollStrategy(data, props) {
        const offsetParent = data.root.value?.offsetParent;
        const target = getTargetEl(data.target.value, data.contentEl.value);
        const scrollElements = [
            ...new Set([
                ...getScrollParents(target, props.contained ? offsetParent : undefined),
                ...getScrollParents(data.contentEl.value, props.contained ? offsetParent : undefined)
            ])
        ].filter((el)=>!el.classList.contains('v-overlay-scroll-blocked'));
        const scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;
        const scrollableParent = ((el)=>hasScrollbar(el) && el)(offsetParent || document.documentElement);
        if (scrollableParent) data.root.value.classList.add('v-overlay--scroll-blocked');
        scrollElements.forEach((el, i)=>{
            el.style.setProperty('--v-body-scroll-x', convertToUnit(-el.scrollLeft));
            el.style.setProperty('--v-body-scroll-y', convertToUnit(-el.scrollTop));
            if (el !== document.documentElement || getComputedStyle(el).overflowY !== 'scroll') el.style.setProperty('--v-scrollbar-offset', convertToUnit(scrollbarWidth));
            el.classList.add('v-overlay-scroll-blocked');
        });
        vue.onScopeDispose(()=>{
            scrollElements.forEach((el, i)=>{
                const x = parseFloat(el.style.getPropertyValue('--v-body-scroll-x'));
                const y = parseFloat(el.style.getPropertyValue('--v-body-scroll-y'));
                const scrollBehavior = el.style.scrollBehavior;
                el.style.scrollBehavior = 'auto';
                el.style.removeProperty('--v-body-scroll-x');
                el.style.removeProperty('--v-body-scroll-y');
                el.style.removeProperty('--v-scrollbar-offset');
                el.classList.remove('v-overlay-scroll-blocked');
                el.scrollLeft = -x;
                el.scrollTop = -y;
                el.style.scrollBehavior = scrollBehavior;
            });
            if (scrollableParent) data.root.value.classList.remove('v-overlay--scroll-blocked');
        });
    }
    function repositionScrollStrategy(data, props, scope) {
        let slow = false;
        let raf = -1;
        let ric = -1;
        function update(e) {
            requestNewFrame(()=>{
                const start = performance.now();
                data.updateLocation.value?.(e);
                const time = performance.now() - start;
                slow = time / (1000 / 60) > 2;
            });
        }
        ric = (typeof requestIdleCallback === 'undefined' ? (cb)=>cb() : requestIdleCallback)(()=>{
            scope.run(()=>{
                bindScroll(getTargetEl(data.target.value, data.contentEl.value), (e)=>{
                    if (slow) {
                        // If the position calculation is slow,
                        // defer updates until scrolling is finished.
                        // Browsers usually fire one scroll event per frame so
                        // we just wait until we've got two frames without an event
                        cancelAnimationFrame(raf);
                        raf = requestAnimationFrame(()=>{
                            raf = requestAnimationFrame(()=>{
                                update(e);
                            });
                        });
                    } else update(e);
                });
            });
        });
        vue.onScopeDispose(()=>{
            typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(ric);
            cancelAnimationFrame(raf);
        });
    }
    function getTargetEl(target, contentEl) {
        return Array.isArray(target) ? document.elementsFromPoint(...target).find((el)=>!contentEl?.contains(el)) : target ?? contentEl;
    }
    function bindScroll(el, onScroll) {
        const scrollElements = [
            document,
            ...getScrollParents(el)
        ];
        scrollElements.forEach((el)=>{
            el.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        vue.onScopeDispose(()=>{
            scrollElements.forEach((el)=>{
                el.removeEventListener('scroll', onScroll);
            });
        });
    }
    // Types
    const VMenuSymbol = Symbol.for('vuetify:v-menu');
    // Utilities
    // Types
    // Composables
    const makeDelayProps = propsFactory({
        closeDelay: [
            Number,
            String
        ],
        openDelay: [
            Number,
            String
        ]
    }, 'delay');
    function useDelay(props, cb) {
        let clearDelay = ()=>{};
        function runDelay(isOpening, options) {
            clearDelay?.();
            const delay = isOpening ? props.openDelay : props.closeDelay;
            const normalizedDelay = Math.max(options?.minDelay ?? 0, Number(delay ?? 0));
            return new Promise((resolve)=>{
                clearDelay = defer(normalizedDelay, ()=>{
                    cb?.(isOpening);
                    resolve(isOpening);
                });
            });
        }
        function runOpenDelay() {
            return runDelay(true);
        }
        function runCloseDelay(options) {
            return runDelay(false, options);
        }
        return {
            clearDelay: clearDelay,
            runOpenDelay: runOpenDelay,
            runCloseDelay: runCloseDelay
        };
    }
    // Components
    // Types
    const makeActivatorProps = propsFactory({
        target: [
            String,
            Object
        ],
        activator: [
            String,
            Object
        ],
        activatorProps: {
            type: Object,
            default: ()=>({})
        },
        openOnClick: {
            type: Boolean,
            default: undefined
        },
        openOnHover: Boolean,
        openOnFocus: {
            type: Boolean,
            default: undefined
        },
        closeOnContentClick: Boolean,
        ...makeDelayProps()
    }, 'VOverlay-activator');
    function useActivator(props, { isActive: isActive, isTop: isTop, contentEl: contentEl }) {
        const vm = getCurrentInstance('useActivator');
        const activatorEl = vue.ref();
        let isHovered = false;
        let isFocused = false;
        let firstEnter = true;
        const openOnFocus = vue.computed(()=>props.openOnFocus || props.openOnFocus == null && props.openOnHover);
        const openOnClick = vue.computed(()=>props.openOnClick || props.openOnClick == null && !props.openOnHover && !openOnFocus.value);
        const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = useDelay(props, (value)=>{
            if (value === (props.openOnHover && isHovered || openOnFocus.value && isFocused) && !(props.openOnHover && isActive.value && !isTop.value)) {
                if (isActive.value !== value) firstEnter = true;
                isActive.value = value;
            }
        });
        let reopenLock = false;
        vue.watch(isActive, (v)=>{
            if (v) return;
            reopenLock = true;
            setTimeout(()=>reopenLock = false, 50);
        });
        const cursorTarget = vue.ref();
        const availableEvents = {
            onClick: (e)=>{
                if (reopenLock && !isActive.value) return;
                e.stopPropagation();
                activatorEl.value = e.currentTarget || e.target;
                if (!isActive.value) cursorTarget.value = [
                    e.clientX,
                    e.clientY
                ];
                isActive.value = !isActive.value;
            },
            onMouseenter: (e)=>{
                isHovered = true;
                activatorEl.value = e.currentTarget || e.target;
                if (props.target === 'cursor') cursorTarget.value = [
                    e.clientX,
                    e.clientY
                ];
                runOpenDelay();
            },
            onMousemove: (e)=>{
                cursorTarget.value = [
                    e.clientX,
                    e.clientY
                ];
            },
            onMouseleave: (e)=>{
                isHovered = false;
                if (props.target === 'cursor') isFocused = false;
                runCloseDelay();
            },
            onFocus: (e)=>{
                if (reopenLock) return;
                if (matchesSelector(e.target, ':focus-visible') === false) return;
                isFocused = true;
                e.stopPropagation();
                activatorEl.value = e.currentTarget || e.target;
                runOpenDelay();
            },
            onBlur: (e)=>{
                // Body parks from clicks on empty areas inside content also count as "still focused".
                const next = e.relatedTarget;
                if (!next || contentEl.value?.contains(next)) return;
                isFocused = false;
                e.stopPropagation();
                runCloseDelay({
                    minDelay: 1
                });
            }
        };
        const activatorEvents = vue.computed(()=>{
            const events = {};
            if (openOnClick.value) events.onClick = availableEvents.onClick;
            if (props.openOnHover) {
                events.onMouseenter = availableEvents.onMouseenter;
                events.onMouseleave = availableEvents.onMouseleave;
                if (props.target === 'cursor' && !openOnClick.value) events.onMousemove = availableEvents.onMousemove;
            }
            if (openOnFocus.value) {
                events.onFocus = availableEvents.onFocus;
                events.onBlur = availableEvents.onBlur;
            }
            return events;
        });
        const contentEvents = vue.computed(()=>{
            const events = {};
            if (props.openOnHover) {
                events.onMouseenter = ()=>{
                    isHovered = true;
                    runOpenDelay();
                };
                events.onMouseleave = ()=>{
                    isHovered = false;
                    runCloseDelay();
                };
            }
            if (openOnFocus.value) {
                events.onFocusin = (e)=>{
                    if (!e.target.matches(':focus-visible')) return;
                    isFocused = true;
                    runOpenDelay();
                };
                events.onFocusout = (e)=>{
                    const next = e.relatedTarget;
                    if (!next || contentEl.value?.contains(next)) return;
                    isFocused = false;
                    runCloseDelay({
                        minDelay: 1
                    });
                };
            }
            if (props.closeOnContentClick) {
                const menu = vue.inject(VMenuSymbol, null);
                events.onClick = ()=>{
                    isActive.value = false;
                    menu?.closeParents();
                };
            }
            return events;
        });
        const scrimEvents = vue.computed(()=>{
            const events = {};
            if (props.openOnHover) {
                events.onMouseenter = ()=>{
                    if (firstEnter) {
                        isHovered = true;
                        firstEnter = false;
                        runOpenDelay();
                    }
                };
                events.onMouseleave = ()=>{
                    isHovered = false;
                    runCloseDelay();
                };
            }
            return events;
        });
        vue.watch(isTop, (val)=>{
            if (val && (props.openOnHover && !isHovered && (!openOnFocus.value || !isFocused) || openOnFocus.value && !isFocused && (!props.openOnHover || !isHovered)) && !contentEl.value?.contains(getActiveElement())) runCloseDelay();
        });
        vue.watch(isActive, (val)=>{
            if (!val) setTimeout(()=>{
                cursorTarget.value = undefined;
            });
        }, {
            flush: 'post'
        });
        const activatorRef = templateRef();
        vue.watchEffect(()=>{
            if (!activatorRef.value) return;
            vue.nextTick(()=>{
                activatorEl.value = activatorRef.el;
            });
        });
        const targetRef = templateRef();
        const target = vue.computed(()=>{
            if (props.target === 'cursor' && cursorTarget.value) return cursorTarget.value;
            if (targetRef.value) return targetRef.el;
            return getTarget(props.target, vm) || activatorEl.value;
        });
        const targetEl = vue.computed(()=>{
            return Array.isArray(target.value) ? undefined : target.value;
        });
        let scope;
        vue.watch(()=>!!props.activator, (val)=>{
            if (val && IN_BROWSER) {
                scope = vue.effectScope();
                scope.run(()=>{
                    _useActivator(props, vm, {
                        activatorEl: activatorEl,
                        activatorEvents: activatorEvents
                    });
                });
            } else if (scope) scope.stop();
        }, {
            flush: 'post',
            immediate: true
        });
        vue.onScopeDispose(()=>{
            scope?.stop();
        });
        return {
            activatorEl: activatorEl,
            activatorRef: activatorRef,
            target: target,
            targetEl: targetEl,
            targetRef: targetRef,
            activatorEvents: activatorEvents,
            contentEvents: contentEvents,
            scrimEvents: scrimEvents
        };
    }
    function _useActivator(props, vm, { activatorEl: activatorEl, activatorEvents: activatorEvents }) {
        vue.watch(()=>props.activator, (val, oldVal)=>{
            if (oldVal && val !== oldVal) {
                const activator = getActivator(oldVal);
                activator && unbindActivatorProps(activator);
            }
            if (val) vue.nextTick(()=>bindActivatorProps());
        }, {
            immediate: true
        });
        vue.watch(()=>props.activatorProps, ()=>{
            bindActivatorProps();
        });
        vue.onScopeDispose(()=>{
            unbindActivatorProps();
        });
        function bindActivatorProps(el = getActivator(), _props = props.activatorProps) {
            if (!el) return;
            bindProps(el, vue.mergeProps(activatorEvents.value, _props));
        }
        function unbindActivatorProps(el = getActivator(), _props = props.activatorProps) {
            if (!el) return;
            unbindProps(el, vue.mergeProps(activatorEvents.value, _props));
        }
        function getActivator(selector = props.activator) {
            const activator = getTarget(selector, vm);
            // The activator should only be a valid element (Ignore comments and text nodes)
            activatorEl.value = activator?.nodeType === Node.ELEMENT_NODE ? activator : undefined;
            return activatorEl.value;
        }
    }
    function getTarget(selector, vm) {
        if (!selector) return;
        let target;
        if (selector === 'parent') {
            let el = vm?.proxy?.$el?.parentNode;
            while(el?.hasAttribute('data-no-activator'))el = el.parentNode;
            target = el;
        } else if (typeof selector === 'string') // Selector
        target = document.querySelector(selector);
        else if ('$el' in selector) // Component (ref)
        target = selector.$el;
        else // HTMLElement | Element | [x, y]
        target = selector;
        return target;
    }
    // Utilities
    // Types
    // Types
    // Composables
    const makeFocusTrapProps = propsFactory({
        retainFocus: Boolean,
        captureFocus: Boolean,
        /** @deprecated */ disableInitialFocus: Boolean
    }, 'focusTrap');
    const registry = new Map();
    let subscribers = 0;
    function lastActiveTrap() {
        let el;
        for (const { isActive: isActive, contentEl: contentEl } of registry.values())if (isActive.value && contentEl.value) el = contentEl.value;
        return el;
    }
    function onKeydown(e) {
        const activeElement = getActiveElement();
        if (e.key !== 'Tab' || !activeElement) return;
        const parentTraps = Array.from(registry.values()).filter(({ isActive: isActive, contentEl: contentEl })=>isActive.value && contentEl.value?.contains(activeElement)).map((x)=>x.contentEl.value);
        let closestTrap;
        let currentNode = activeElement;
        while(currentNode){
            if (parentTraps.includes(currentNode)) {
                closestTrap = currentNode;
                break;
            }
            currentNode = currentNode.parentElement;
        }
        if (!closestTrap) {
            const trapEl = lastActiveTrap(); // assuming last registered == topmost panel
            if (!trapEl) return;
            const focusable = focusableChildren(trapEl).filter((x)=>x.tabIndex >= 0);
            e.preventDefault();
            if (!focusable.length) trapEl.focus({
                preventScroll: true
            });
            else if (e.shiftKey) focusable[focusable.length - 1].focus();
            else focusable[0].focus();
            return;
        }
        const focusable = focusableChildren(closestTrap)// excluding VListItems with tabindex="-2"
        .filter((x)=>x.tabIndex >= 0);
        if (!focusable.length) return;
        if (focusable.length === 1 && focusable[0].classList.contains('v-list') && focusable[0].contains(activeElement)) {
            e.preventDefault();
            return;
        }
        const firstElement = focusable[0];
        const lastElement = focusable[focusable.length - 1];
        // contentEl wrapper (tabindex=-1) counts as "before first"
        const atFirst = activeElement === firstElement || activeElement === closestTrap || firstElement.classList.contains('v-list') && firstElement.contains(activeElement);
        const atLast = activeElement === lastElement || lastElement.classList.contains('v-list') && lastElement.contains(activeElement);
        if (e.shiftKey && atFirst) {
            e.preventDefault();
            lastElement.focus();
        }
        if (!e.shiftKey && atLast) {
            e.preventDefault();
            firstElement.focus();
        }
    }
    function useFocusTrap(props, { isActive: isActive, localTop: localTop, contentEl: contentEl }) {
        const trapId = Symbol('trap');
        let focusTrapSuppressed = false;
        let focusTrapSuppressionTimeout = -1;
        async function onPointerdown() {
            focusTrapSuppressed = true;
            focusTrapSuppressionTimeout = window.setTimeout(()=>{
                focusTrapSuppressed = false;
            }, 100);
        }
        async function captureOnFocus(e) {
            const before = e.relatedTarget;
            const after = e.target;
            document.removeEventListener('pointerdown', onPointerdown);
            document.removeEventListener('keydown', captureOnKeydown);
            await new Promise((resolve)=>requestAnimationFrame(resolve));
            if (isActive.value && !focusTrapSuppressed && before !== after && contentEl.value && // We're the menu without open submenus or overlays
            vue.toValue(localTop) && // It isn't the document or the container body
            ![
                document,
                contentEl.value
            ].includes(after) && // It isn't inside the container body
            !contentEl.value.contains(after)) {
                const focusable = focusableChildren(contentEl.value);
                focusable[0]?.focus();
            }
        }
        function captureOnKeydown(e) {
            if (e.key !== 'Tab') return;
            document.removeEventListener('keydown', captureOnKeydown);
            if (isActive.value && contentEl.value && e.target && !contentEl.value.contains(e.target)) {
                const allFocusableElements = focusableChildren(document.documentElement);
                if (e.shiftKey && e.target === allFocusableElements.at(0) || !e.shiftKey && e.target === allFocusableElements.at(-1)) {
                    const focusable = focusableChildren(contentEl.value);
                    if (focusable.length > 0) {
                        e.preventDefault();
                        focusable[0].focus();
                    }
                }
            }
        }
        const shouldCapture = vue.toRef(()=>isActive.value && props.captureFocus && !props.disableInitialFocus);
        if (IN_BROWSER) {
            vue.watch(()=>props.retainFocus, (val)=>{
                if (val) registry.set(trapId, {
                    isActive: isActive,
                    contentEl: contentEl
                });
                else registry.delete(trapId);
            }, {
                immediate: true
            });
            vue.watch(shouldCapture, (val)=>{
                if (val) {
                    document.addEventListener('pointerdown', onPointerdown);
                    document.addEventListener('focusin', captureOnFocus, {
                        once: true
                    });
                    document.addEventListener('keydown', captureOnKeydown);
                } else {
                    document.removeEventListener('pointerdown', onPointerdown);
                    document.removeEventListener('focusin', captureOnFocus);
                    document.removeEventListener('keydown', captureOnKeydown);
                }
            }, {
                immediate: true
            });
            if (subscribers++ < 1) document.addEventListener('keydown', onKeydown);
        }
        vue.onScopeDispose(()=>{
            registry.delete(trapId);
            if (!IN_BROWSER) return;
            clearTimeout(focusTrapSuppressionTimeout);
            document.removeEventListener('pointerdown', onPointerdown);
            document.removeEventListener('focusin', captureOnFocus);
            document.removeEventListener('keydown', captureOnKeydown);
            if (--subscribers < 1) document.removeEventListener('keydown', onKeydown);
        });
    }
    // Composables
    function useHydration() {
        if (!IN_BROWSER) return vue.shallowRef(false);
        const { ssr: ssr } = useDisplay();
        if (ssr) {
            const isMounted = vue.shallowRef(false);
            vue.onMounted(()=>{
                isMounted.value = true;
            });
            return isMounted;
        } else return vue.shallowRef(true);
    }
    // Utilities
    // Types
    const makeLazyProps = propsFactory({
        eager: Boolean
    }, 'lazy');
    function useLazy(props, active) {
        const isBooted = vue.shallowRef(false);
        const hasContent = vue.toRef(()=>isBooted.value || props.eager || active.value);
        vue.watch(active, ()=>isBooted.value = true);
        function onAfterLeave() {
            if (!props.eager) isBooted.value = false;
        }
        return {
            isBooted: isBooted,
            hasContent: hasContent,
            onAfterLeave: onAfterLeave
        };
    }
    // Utilities
    function useScopeId() {
        const vm = getCurrentInstance('useScopeId');
        const scopeId = vm.vnode.scopeId;
        return {
            scopeId: scopeId ? {
                [scopeId]: ''
            } : undefined
        };
    }
    // Composables
    // Types
    const StackSymbol = Symbol.for('vuetify:stack');
    const globalStack = vue.reactive([]);
    function useStack(isActive, zIndex, disableGlobalStack) {
        const vm = getCurrentInstance('useStack');
        const createStackEntry = !disableGlobalStack;
        const parent = vue.inject(StackSymbol, undefined);
        const stack = vue.reactive({
            activeChildren: new Set()
        });
        vue.provide(StackSymbol, stack);
        const _zIndex = vue.shallowRef(Number(vue.toValue(zIndex)));
        useToggleScope(isActive, ()=>{
            const lastZIndex = globalStack.at(-1)?.[1];
            _zIndex.value = lastZIndex ? lastZIndex + 10 : Number(vue.toValue(zIndex));
            if (createStackEntry) globalStack.push([
                vm.uid,
                _zIndex.value
            ]);
            parent?.activeChildren.add(vm.uid);
            vue.onScopeDispose(()=>{
                if (createStackEntry) {
                    const idx = vue.toRaw(globalStack).findIndex((v)=>v[0] === vm.uid);
                    globalStack.splice(idx, 1);
                }
                parent?.activeChildren.delete(vm.uid);
            });
        });
        const globalTop = vue.shallowRef(true);
        if (createStackEntry) vue.watchEffect(()=>{
            const _isTop = globalStack.at(-1)?.[0] === vm.uid;
            setTimeout(()=>globalTop.value = _isTop);
        });
        const localTop = vue.toRef(()=>!stack.activeChildren.size);
        return {
            globalTop: vue.readonly(globalTop),
            localTop: localTop,
            stackStyles: vue.toRef(()=>({
                    zIndex: _zIndex.value
                }))
        };
    }
    // Utilities
    function useTeleport(target) {
        const teleportTarget = vue.computed(()=>{
            const _target = target();
            if (_target === true || !IN_BROWSER) return undefined;
            const targetElement = _target === false ? document.body : typeof _target === 'string' ? document.querySelector(_target) : _target;
            if (targetElement == null) {
                vue.warn(`Unable to locate target ${_target}`);
                return undefined;
            }
            let container = [
                ...targetElement.children
            ].find((el)=>el.matches('.v-overlay-container'));
            if (!container) {
                container = document.createElement('div');
                container.className = 'v-overlay-container';
                targetElement.appendChild(container);
            }
            return container;
        });
        return {
            teleportTarget: teleportTarget
        };
    }
    // Utilities
    // Types
    function defaultConditional() {
        return true;
    }
    function checkEvent(e, el, binding, ignoreActive = false) {
        // The include element callbacks below can be expensive
        // so we should avoid calling them when we're not active.
        // Explicitly check for false to allow fallback compatibility
        // with non-toggleable components
        if (!e || !ignoreActive && checkIsActive(e, binding) === false) return false;
        // If we're clicking inside the shadowroot, then the app root doesn't get the same
        // level of introspection as to _what_ we're clicking. We want to check to see if
        // our target is the shadowroot parent container, and if it is, ignore.
        const root = attachedRoot(el);
        if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot && root.host === e.target) return false;
        // Check if additional elements were passed to be included in check
        // (click must be outside all included elements, if any)
        const elements = (typeof binding.value === 'object' && binding.value.include || (()=>[]))();
        // Add the root element for the component this directive was defined on
        elements.push(el);
        // Check if it's a click outside our elements, and then if our callback returns true.
        // Non-toggleable components should take action in their callback and return falsy.
        // Toggleable can return true if it wants to deactivate.
        // Note that, because we're in the capture phase, this callback will occur before
        // the bubbling click event on any outside elements.
        return !elements.some((el)=>el?.contains(e.target));
    }
    function checkIsActive(e, binding) {
        const isActive = typeof binding.value === 'object' && binding.value.closeConditional || defaultConditional;
        return isActive(e);
    }
    function directive(e, el, binding) {
        const handler = typeof binding.value === 'function' ? binding.value : binding.value.handler;
        // Clicks in the Shadow DOM change their target while using setTimeout, so the original target is saved here
        e.shadowTarget = e.target;
        el._clickOutside.lastMousedownWasOutside && checkEvent(e, el, binding) && setTimeout(()=>{
            checkIsActive(e, binding) && handler && handler(e);
        }, 0);
    }
    function handleShadow(el, callback) {
        const root = attachedRoot(el);
        callback(document);
        if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot) callback(root);
    }
    const ClickOutside = {
        // [data-app] may not be found
        // if using bind, inserted makes
        // sure that the root element is
        // available, iOS does not support
        // clicks on body
        mounted (el, binding) {
            const onClick = (e)=>directive(e, el, binding);
            const onMousedown = (e)=>{
                // Ignore the active check here so ancestors of the top overlay (e.g. a menu
                // with an open submenu, which isn't localTop) still record that the click
                // landed outside, letting the close cascade propagate. #20003
                el._clickOutside.lastMousedownWasOutside = checkEvent(e, el, binding, true);
            };
            handleShadow(el, (app)=>{
                app.addEventListener('click', onClick, true);
                app.addEventListener('mousedown', onMousedown, true);
            });
            if (!el._clickOutside) el._clickOutside = {
                lastMousedownWasOutside: false
            };
            el._clickOutside[binding.instance.$.uid] = {
                onClick: onClick,
                onMousedown: onMousedown
            };
        },
        beforeUnmount (el, binding) {
            if (!el._clickOutside) return;
            handleShadow(el, (app)=>{
                if (!app || !el._clickOutside?.[binding.instance.$.uid]) return;
                const { onClick: onClick, onMousedown: onMousedown } = el._clickOutside[binding.instance.$.uid];
                app.removeEventListener('click', onClick, true);
                app.removeEventListener('mousedown', onMousedown, true);
            });
            delete el._clickOutside[binding.instance.$.uid];
        }
    };
    // Types
    const overlayActivators = new WeakMap();
    function Scrim(props) {
        const { modelValue: modelValue, color: color, ...rest } = props;
        return vue.createVNode(vue.Transition, {
            "name": "fade-transition",
            "appear": true
        }, {
            default: ()=>[
                    props.modelValue && vue.createElementVNode("div", vue.mergeProps({
                        "class": [
                            'v-overlay__scrim',
                            props.color.backgroundColorClasses.value
                        ],
                        "style": props.color.backgroundColorStyles.value
                    }, rest), null)
                ]
        });
    }
    const makeVOverlayProps = propsFactory({
        absolute: Boolean,
        attach: [
            Boolean,
            String,
            Object
        ],
        closeOnBack: {
            type: Boolean,
            default: true
        },
        contained: Boolean,
        contentClass: null,
        contentProps: null,
        disabled: Boolean,
        opacity: [
            Number,
            String
        ],
        noClickAnimation: Boolean,
        modelValue: Boolean,
        persistent: Boolean,
        scrim: {
            type: [
                Boolean,
                String
            ],
            default: true
        },
        zIndex: {
            type: [
                Number,
                String
            ],
            default: 2000
        },
        ...makeActivatorProps(),
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeLazyProps(),
        ...makeLocationStrategyProps(),
        ...makeScrollStrategyProps(),
        ...makeFocusTrapProps(),
        ...makeThemeProps(),
        ...makeTransitionProps()
    }, 'VOverlay');
    const VOverlay = genericComponent()({
        name: 'VOverlay',
        directives: {
            vClickOutside: ClickOutside
        },
        inheritAttrs: false,
        props: {
            _disableGlobalStack: Boolean,
            ...omit(makeVOverlayProps(), [
                'disableInitialFocus'
            ])
        },
        emits: {
            'click:outside': (e)=>true,
            'update:modelValue': (value)=>true,
            keydown: (e)=>true,
            afterEnter: ()=>true,
            afterLeave: ()=>true
        },
        setup (props, { slots: slots, attrs: attrs, emit: emit }) {
            const vm = getCurrentInstance('VOverlay');
            const root = vue.ref();
            const scrimEl = vue.ref();
            const contentEl = vue.ref();
            const model = useProxiedModel(props, 'modelValue');
            const isActive = vue.computed({
                get: ()=>model.value,
                set: (v)=>{
                    if (!(v && props.disabled)) model.value = v;
                }
            });
            const { themeClasses: themeClasses } = provideTheme(props);
            const { rtlClasses: rtlClasses, isRtl: isRtl } = useRtl();
            const { hasContent: hasContent, onAfterLeave: _onAfterLeave } = useLazy(props, isActive);
            const scrimColor = useBackgroundColor(()=>{
                return typeof props.scrim === 'string' ? props.scrim : null;
            });
            const { globalTop: globalTop, localTop: localTop, stackStyles: stackStyles } = useStack(isActive, ()=>props.zIndex, props._disableGlobalStack);
            const { activatorEl: activatorEl, activatorRef: activatorRef, target: target, targetEl: targetEl, targetRef: targetRef, activatorEvents: activatorEvents, contentEvents: contentEvents, scrimEvents: scrimEvents } = useActivator(props, {
                isActive: isActive,
                isTop: localTop,
                contentEl: contentEl
            });
            const { teleportTarget: teleportTarget } = useTeleport(()=>{
                const target = props.attach || props.contained;
                if (target) return target;
                const rootNode = activatorEl?.value?.getRootNode() || vm.proxy?.$el?.getRootNode();
                if (rootNode instanceof ShadowRoot) return rootNode;
                return false;
            });
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const isMounted = useHydration();
            const staticLocationClasses = vue.computed(()=>{
                return props.locationStrategy === 'static' ? getStaticLocationClasses(props.location) : undefined;
            });
            const { scopeId: scopeId } = useScopeId();
            vue.watch(()=>props.disabled, (v)=>{
                if (v) isActive.value = false;
            });
            const { contentStyles: contentStyles, updateLocation: updateLocation } = useLocationStrategies(props, {
                isRtl: isRtl,
                contentEl: contentEl,
                target: target,
                isActive: isActive
            });
            useScrollStrategies(props, {
                root: root,
                contentEl: contentEl,
                targetEl: targetEl,
                target: target,
                isActive: isActive,
                updateLocation: updateLocation
            });
            function onClickOutside(e) {
                emit('click:outside', e);
                if (!props.persistent) isActive.value = false;
                else animateClick();
            }
            function closeConditional(e) {
                return isActive.value && localTop.value && // If using scrim, only close if clicking on it rather than anything opened on top
                (!props.scrim || e.target === scrimEl.value || e instanceof MouseEvent && e.shadowTarget === scrimEl.value);
            }
            useFocusTrap(props, {
                isActive: isActive,
                localTop: localTop,
                contentEl: contentEl
            });
            let openedWithActivatorFocus = false;
            vue.watchEffect(()=>{
                if (!contentEl.value) return;
                if (activatorEl.value) overlayActivators.set(contentEl.value, activatorEl.value);
                else overlayActivators.delete(contentEl.value);
            });
            function ownsFocus(activeElement) {
                let current = activeElement;
                const visited = new Set();
                while(current){
                    const el = current.closest('.v-overlay__content');
                    if (!el || visited.has(el)) return false;
                    if (el === contentEl.value) return true;
                    visited.add(el);
                    current = overlayActivators.get(el) ?? null;
                }
                return false;
            }
            function returnFocusToActivator() {
                const el = activatorEl.value;
                if (!el || !el.isConnected) return;
                // Skip submenus; the outermost close in the cascade will restore focus.
                if (el.closest('.v-overlay__content')) return;
                if (contentEl.value?._clickOutside?.lastMousedownWasOutside) return;
                const activeEl = getActiveElement();
                const focusWasInOverlay = (!activeEl || activeEl === document.body) && openedWithActivatorFocus || activeEl === el || el.contains(activeEl) || ownsFocus(activeEl);
                if (!focusWasInOverlay) return;
                const parent = el.parentElement;
                const focusableInParent = parent ? focusableChildren(parent) : [];
                let target;
                if (focusableInParent.includes(el)) target = el;
                else {
                    const focusableWithin = focusableChildren(el);
                    target = focusableWithin.find((x)=>x.tagName === 'INPUT' || x.tagName === 'TEXTAREA') ?? focusableWithin[0];
                }
                target?.focus({
                    preventScroll: true
                });
            }
            vue.watch(isActive, (val)=>{
                if (val) {
                    const activeEl = getActiveElement();
                    const el = activatorEl.value;
                    openedWithActivatorFocus = !!el && (activeEl === el || el.contains(activeEl));
                    // eager reuses contentEl, so the mousedown that opened us would linger until the next one
                    if (contentEl.value?._clickOutside) contentEl.value._clickOutside.lastMousedownWasOutside = false;
                } else returnFocusToActivator();
            }, {
                flush: 'post'
            });
            IN_BROWSER && vue.watch(isActive, (val)=>{
                if (val) window.addEventListener('keydown', onKeydown);
                else window.removeEventListener('keydown', onKeydown);
            }, {
                immediate: true
            });
            vue.onBeforeUnmount(()=>{
                if (!IN_BROWSER) return;
                window.removeEventListener('keydown', onKeydown);
            });
            function onKeydown(e) {
                if (e.key === 'Escape' && globalTop.value) {
                    if (!contentEl.value?.contains(getActiveElement())) emit('keydown', e);
                    if (!props.persistent) {
                        isActive.value = false;
                        if (contentEl.value?.contains(getActiveElement())) activatorEl.value?.focus();
                    } else animateClick();
                }
            }
            function onKeydownSelf(e) {
                if (e.key === 'Escape' && !globalTop.value) return;
                emit('keydown', e);
            }
            const router = useRouter();
            useToggleScope(()=>props.closeOnBack, ()=>{
                useBackButton(router, ()=>{
                    if (globalTop.value && isActive.value) {
                        if (!props.persistent) isActive.value = false;
                        else animateClick();
                        return false;
                    }
                    return undefined;
                });
            });
            const top = vue.ref();
            vue.watch(()=>isActive.value && (props.absolute || props.contained) && teleportTarget.value == null, (val)=>{
                if (val) {
                    const scrollParent = getScrollParent(root.value);
                    if (scrollParent && scrollParent !== document.scrollingElement) top.value = scrollParent.scrollTop;
                }
            });
            // Add a quick "bounce" animation to the content
            function animateClick() {
                if (props.noClickAnimation) return;
                contentEl.value && animate(contentEl.value, [
                    {
                        transformOrigin: 'center'
                    },
                    {
                        transform: 'scale(1.03)'
                    },
                    {
                        transformOrigin: 'center'
                    }
                ], {
                    duration: 150,
                    easing: standardEasing
                });
            }
            function onAfterEnter() {
                emit('afterEnter');
            }
            function onAfterLeave() {
                _onAfterLeave();
                emit('afterLeave');
            }
            useRender(()=>vue.createElementVNode(vue.Fragment, null, [
                    slots.activator?.({
                        isActive: isActive.value,
                        targetRef: targetRef,
                        props: vue.mergeProps({
                            ref: activatorRef
                        }, activatorEvents.value, props.activatorProps)
                    }),
                    isMounted.value && hasContent.value && vue.createVNode(vue.Teleport, {
                        "disabled": !teleportTarget.value,
                        "to": teleportTarget.value
                    }, {
                        default: ()=>[
                                vue.createElementVNode("div", vue.mergeProps({
                                    "class": [
                                        'v-overlay',
                                        {
                                            'v-overlay--absolute': props.absolute || props.contained,
                                            'v-overlay--active': isActive.value,
                                            'v-overlay--contained': props.contained
                                        },
                                        staticLocationClasses.value,
                                        themeClasses.value,
                                        rtlClasses.value,
                                        props.class
                                    ],
                                    "style": [
                                        stackStyles.value,
                                        {
                                            '--v-overlay-opacity': props.opacity,
                                            top: convertToUnit(top.value)
                                        },
                                        props.style
                                    ],
                                    "ref": root,
                                    "onKeydown": onKeydownSelf
                                }, scopeId, attrs), [
                                    vue.createVNode(Scrim, vue.mergeProps({
                                        "color": scrimColor,
                                        "modelValue": isActive.value && !!props.scrim,
                                        "ref": scrimEl
                                    }, scrimEvents.value), null),
                                    vue.createVNode(MaybeTransition, {
                                        "appear": true,
                                        "persisted": true,
                                        "transition": props.transition,
                                        "target": target.value,
                                        "onAfterEnter": onAfterEnter,
                                        "onAfterLeave": onAfterLeave
                                    }, {
                                        default: ()=>[
                                                vue.withDirectives(vue.createElementVNode("div", vue.mergeProps({
                                                    "ref": contentEl,
                                                    "class": [
                                                        'v-overlay__content',
                                                        props.contentClass
                                                    ],
                                                    "style": [
                                                        dimensionStyles.value,
                                                        contentStyles.value
                                                    ]
                                                }, contentEvents.value, props.contentProps), [
                                                    slots.default?.({
                                                        isActive: isActive
                                                    })
                                                ]), [
                                                    [
                                                        vue.vShow,
                                                        isActive.value
                                                    ],
                                                    [
                                                        ClickOutside,
                                                        {
                                                            handler: onClickOutside,
                                                            closeConditional: closeConditional,
                                                            include: ()=>{
                                                                if (!isActive.value) return [];
                                                                return [
                                                                    activatorEl.value,
                                                                    // Submenu clicks count as "inside"; clicks in ancestor overlays (e.g. a host dialog) don't.
                                                                    ...Array.from(document.querySelectorAll('.v-overlay__content')).filter(ownsFocus)
                                                                ];
                                                            }
                                                        }
                                                    ]
                                                ])
                                            ]
                                    })
                                ])
                            ]
                    })
                ]));
            return {
                activatorEl: activatorEl,
                scrimEl: scrimEl,
                target: target,
                animateClick: animateClick,
                contentEl: contentEl,
                rootEl: root,
                globalTop: globalTop,
                localTop: localTop,
                updateLocation: updateLocation
            };
        }
    });
    // Types
    const makeVMenuProps = propsFactory({
        // TODO
        // disableKeys: Boolean,
        id: String,
        submenu: Boolean,
        ...omit(makeVOverlayProps({
            captureFocus: true,
            closeDelay: 250,
            closeOnContentClick: true,
            locationStrategy: 'connected',
            location: undefined,
            openDelay: 300,
            scrim: false,
            scrollStrategy: 'reposition',
            transition: {
                component: VDialogTransition
            }
        }), [
            'absolute'
        ])
    }, 'VMenu');
    const VMenu = genericComponent()({
        name: 'VMenu',
        props: makeVMenuProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const isActive = useProxiedModel(props, 'modelValue');
            const { scopeId: scopeId } = useScopeId();
            const { isRtl: isRtl } = useRtl();
            const uid = vue.useId();
            const id = vue.toRef(()=>props.id || `v-menu-${uid}`);
            const overlay = vue.ref();
            const parent = vue.inject(VMenuSymbol, null);
            const openChildren = vue.shallowRef(new Set());
            vue.provide(VMenuSymbol, {
                register () {
                    openChildren.value.add(uid);
                },
                unregister () {
                    openChildren.value.delete(uid);
                },
                closeParents (e) {
                    const clickedOutside = !e || overlay.value?.contentEl?._clickOutside?.lastMousedownWasOutside;
                    setTimeout(()=>{
                        if (!openChildren.value.size && !props.persistent && clickedOutside) {
                            isActive.value = false;
                            parent?.closeParents(e);
                        }
                    }, 40);
                }
            });
            vue.onBeforeUnmount(()=>parent?.unregister());
            vue.onDeactivated(()=>isActive.value = false);
            vue.watch(isActive, (val)=>{
                val ? parent?.register() : parent?.unregister();
            }, {
                immediate: true
            });
            function onClickOutside(e) {
                parent?.closeParents(e);
            }
            function onKeydown(e) {
                if (props.disabled) return;
                if (e.key === 'Tab') {
                    const nextElement = getNextElement(focusableChildren(overlay.value?.contentEl, false), e.shiftKey ? 'prev' : 'next', (el)=>el.tabIndex >= 0);
                    if (!nextElement && !props.retainFocus) isActive.value = false;
                } else if (props.submenu && e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) isActive.value = false;
            }
            function onActivatorKeydown(e) {
                if (props.disabled || e.isComposing) return;
                const el = overlay.value?.contentEl;
                if (el && isActive.value) {
                    if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        focusChild(el, 'next');
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        focusChild(el, 'prev');
                    } else if (props.submenu) {
                        if (e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) isActive.value = false;
                        else if (e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight')) {
                            e.preventDefault();
                            focusChild(el, 'first');
                        }
                    }
                } else if (props.submenu ? e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight') : [
                    'ArrowDown',
                    'ArrowUp'
                ].includes(e.key)) {
                    isActive.value = true;
                    e.preventDefault();
                    setTimeout(()=>setTimeout(()=>onActivatorKeydown(e)));
                }
            }
            const activatorProps = vue.computed(()=>vue.mergeProps({
                    'aria-haspopup': 'menu',
                    'aria-expanded': String(isActive.value),
                    'aria-controls': id.value,
                    'aria-owns': id.value,
                    onKeydown: onActivatorKeydown
                }, props.activatorProps));
            useRender(()=>{
                const overlayProps = VOverlay.filterProps(props);
                return vue.createVNode(VOverlay, vue.mergeProps({
                    "ref": overlay,
                    "id": id.value,
                    "class": [
                        'v-menu',
                        props.class
                    ],
                    "style": props.style
                }, overlayProps, {
                    "modelValue": isActive.value,
                    "onUpdate:modelValue": ($event)=>isActive.value = $event,
                    "absolute": true,
                    "activatorProps": activatorProps.value,
                    "location": props.location ?? (props.submenu ? 'end' : 'bottom'),
                    "onClick:outside": onClickOutside,
                    "onKeydown": onKeydown
                }, scopeId), {
                    activator: slots.activator,
                    default: (...args)=>vue.createVNode(VDefaultsProvider, {
                            "root": "VMenu"
                        }, {
                            default: ()=>[
                                    slots.default?.(...args)
                                ]
                        })
                });
            });
            return forwardRefs({
                id: id,
                \u03A8openChildren: openChildren
            }, overlay);
        }
    });
    const makeVSheetProps = propsFactory({
        color: String,
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeLocationProps(),
        ...makePositionProps(),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VSheet');
    const VSheet = genericComponent()({
        name: 'VSheet',
        props: makeVSheetProps(),
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { borderClasses: borderClasses } = useBorder(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { locationStyles: locationStyles } = useLocation(props);
            const { positionClasses: positionClasses } = usePosition(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-sheet',
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        elevationClasses.value,
                        positionClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        dimensionStyles.value,
                        locationStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Types
    const makeVCounterProps = propsFactory({
        active: Boolean,
        disabled: Boolean,
        max: [
            Number,
            String
        ],
        value: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        ...makeComponentProps(),
        ...makeTransitionProps({
            transition: {
                component: VSlideYTransition
            }
        })
    }, 'VCounter');
    const VCounter = genericComponent()({
        name: 'VCounter',
        functional: true,
        props: makeVCounterProps(),
        setup (props, { slots: slots }) {
            const counter = vue.toRef(()=>{
                return props.max ? `${props.value} / ${props.max}` : String(props.value);
            });
            useRender(()=>vue.createVNode(MaybeTransition, {
                    "transition": props.transition
                }, {
                    default: ()=>[
                            vue.withDirectives(vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    'v-counter',
                                    {
                                        'text-error': props.max && !props.disabled && parseFloat(props.value) > parseFloat(props.max)
                                    },
                                    props.class
                                ]),
                                "style": vue.normalizeStyle(props.style)
                            }, [
                                slots.default ? slots.default({
                                    counter: counter.value,
                                    max: props.max,
                                    value: props.value
                                }) : counter.value
                            ]), [
                                [
                                    vue.vShow,
                                    props.active
                                ]
                            ])
                        ]
                }));
            return {};
        }
    });
    const makeVFieldLabelProps = propsFactory({
        floating: Boolean,
        ...makeComponentProps()
    }, 'VFieldLabel');
    const VFieldLabel = genericComponent()({
        name: 'VFieldLabel',
        props: makeVFieldLabelProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createVNode(VLabel, {
                    "class": vue.normalizeClass([
                        'v-field-label',
                        {
                            'v-field-label--floating': props.floating
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, slots));
            return {};
        }
    });
    // Types
    const allowedVariants$1 = [
        'underlined',
        'outlined',
        'filled',
        'solo',
        'solo-inverted',
        'solo-filled',
        'plain'
    ];
    const makeVFieldProps = propsFactory({
        appendInnerIcon: IconValue,
        bgColor: String,
        clearable: Boolean,
        clearIcon: {
            type: IconValue,
            default: '$clear'
        },
        active: Boolean,
        centerAffix: {
            type: Boolean,
            default: undefined
        },
        color: String,
        baseColor: String,
        dirty: Boolean,
        disabled: {
            type: Boolean,
            default: null
        },
        glow: Boolean,
        error: Boolean,
        flat: Boolean,
        iconColor: [
            Boolean,
            String
        ],
        label: String,
        persistentClear: Boolean,
        prependInnerIcon: IconValue,
        reverse: Boolean,
        singleLine: Boolean,
        variant: {
            type: String,
            default: 'filled',
            validator: (v)=>allowedVariants$1.includes(v)
        },
        'onClick:clear': EventProp(),
        'onClick:appendInner': EventProp(),
        'onClick:prependInner': EventProp(),
        ...makeComponentProps(),
        ...makeLoaderProps(),
        ...makeRoundedProps(),
        ...makeThemeProps()
    }, 'VField');
    const VField = genericComponent()({
        name: 'VField',
        inheritAttrs: false,
        props: {
            id: String,
            details: Boolean,
            labelId: String,
            ...makeFocusProps(),
            ...makeVFieldProps()
        },
        emits: {
            'update:focused': (focused)=>true,
            'update:modelValue': (value)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { loaderClasses: loaderClasses } = useLoader(props);
            const { focusClasses: focusClasses, isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const { InputIcon: InputIcon } = useInputIcon(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { rtlClasses: rtlClasses } = useRtl();
            const isActive = vue.toRef(()=>props.dirty || props.active);
            const hasLabel = vue.toRef(()=>!!(props.label || slots.label));
            const hasFloatingLabel = vue.toRef(()=>!props.singleLine && hasLabel.value);
            const uid = vue.useId();
            const id = vue.computed(()=>props.id || `input-${uid}`);
            const messagesId = vue.toRef(()=>!props.details ? undefined : `${id.value}-messages`);
            const labelRef = vue.ref();
            const floatingLabelRef = vue.ref();
            const controlRef = vue.ref();
            const isPlainOrUnderlined = vue.computed(()=>[
                    'plain',
                    'underlined'
                ].includes(props.variant));
            const color = vue.computed(()=>{
                return props.error || props.disabled ? undefined : isActive.value && isFocused.value ? props.color : props.baseColor;
            });
            const iconColor = vue.computed(()=>{
                if (props.iconColor === true || !props.iconColor && props.glow && isFocused.value) return color.value;
                if (!props.iconColor || props.glow && !isFocused.value) return undefined;
                return props.iconColor;
            });
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(color);
            vue.watch(isActive, (val)=>{
                if (hasFloatingLabel.value && !PREFERS_REDUCED_MOTION()) {
                    const el = labelRef.value.$el;
                    const targetEl = floatingLabelRef.value.$el;
                    requestAnimationFrame(()=>{
                        const rect = nullifyTransforms(el);
                        const targetRect = new Box(targetEl);
                        const x = targetRect.x - rect.x;
                        const y = targetRect.y - rect.y - (rect.height / 2 - targetRect.height / 2);
                        const targetWidth = targetRect.width / 0.75;
                        const width = Math.abs(targetWidth - rect.width) > 1 ? {
                            maxWidth: convertToUnit(targetWidth)
                        } : undefined;
                        const style = getComputedStyle(el);
                        const targetStyle = getComputedStyle(targetEl);
                        const duration = parseFloat(style.transitionDuration) * 1000 || 150;
                        const scale = parseFloat(targetStyle.getPropertyValue('--v-field-label-scale'));
                        const color = targetStyle.getPropertyValue('color');
                        el.style.visibility = 'visible';
                        targetEl.style.visibility = 'hidden';
                        animate(el, {
                            transform: `translate(${x}px, ${y}px) scale(${scale})`,
                            color: color,
                            ...width
                        }, {
                            duration: duration,
                            easing: standardEasing,
                            direction: val ? 'normal' : 'reverse'
                        }).finished.then(()=>{
                            el.style.removeProperty('visibility');
                            targetEl.style.removeProperty('visibility');
                        });
                    });
                }
            }, {
                flush: 'post'
            });
            const slotProps = vue.computed(()=>({
                    isActive: isActive,
                    isFocused: isFocused,
                    controlRef: controlRef,
                    iconColor: iconColor,
                    blur: blur,
                    focus: focus
                }));
            const floatingLabelProps = vue.toRef(()=>{
                const ariaHidden = !isActive.value;
                return {
                    'aria-hidden': ariaHidden,
                    for: ariaHidden ? undefined : id.value
                };
            });
            const mainLabelProps = vue.toRef(()=>{
                const ariaHidden = hasFloatingLabel.value && isActive.value;
                return {
                    'aria-hidden': ariaHidden,
                    for: ariaHidden ? undefined : id.value
                };
            });
            function onClick(e) {
                if (e.target !== getActiveElement()) e.preventDefault();
            }
            useRender(()=>{
                const isOutlined = props.variant === 'outlined';
                const hasPrepend = !!(slots['prepend-inner'] || props.prependInnerIcon);
                const hasClear = !!(props.clearable || slots.clear) && !props.disabled;
                const hasAppend = !!(slots['append-inner'] || props.appendInnerIcon || hasClear);
                const label = ()=>slots.label ? slots.label({
                        ...slotProps.value,
                        label: props.label,
                        props: {
                            for: id.value
                        }
                    }) : props.label;
                return vue.createElementVNode("div", vue.mergeProps({
                    "class": [
                        'v-field',
                        {
                            'v-field--active': isActive.value,
                            'v-field--appended': hasAppend,
                            'v-field--center-affix': props.centerAffix ?? !isPlainOrUnderlined.value,
                            'v-field--disabled': props.disabled,
                            'v-field--dirty': props.dirty,
                            'v-field--error': props.error,
                            'v-field--glow': props.glow,
                            'v-field--flat': props.flat,
                            'v-field--has-background': !!props.bgColor,
                            'v-field--persistent-clear': props.persistentClear,
                            'v-field--prepended': hasPrepend,
                            'v-field--reverse': props.reverse,
                            'v-field--single-line': props.singleLine,
                            'v-field--no-label': !label(),
                            [`v-field--variant-${props.variant}`]: true
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        focusClasses.value,
                        loaderClasses.value,
                        roundedClasses.value,
                        rtlClasses.value,
                        props.class
                    ],
                    "style": [
                        backgroundColorStyles.value,
                        roundedStyles.value,
                        props.style
                    ],
                    "onClick": onClick
                }, attrs), [
                    vue.createElementVNode("div", {
                        "class": "v-field__overlay"
                    }, null),
                    vue.createVNode(LoaderSlot, {
                        "name": "v-field",
                        "active": !!props.loading,
                        "color": props.error ? 'error' : typeof props.loading === 'string' ? props.loading : props.color
                    }, {
                        default: slots.loader
                    }),
                    hasPrepend && vue.createElementVNode("div", {
                        "key": "prepend",
                        "class": "v-field__prepend-inner"
                    }, [
                        slots['prepend-inner'] ? slots['prepend-inner'](slotProps.value) : props.prependInnerIcon && vue.createVNode(InputIcon, {
                            "key": "prepend-icon",
                            "name": "prependInner",
                            "color": iconColor.value
                        }, null)
                    ]),
                    vue.createElementVNode("div", {
                        "class": "v-field__field",
                        "data-no-activator": ""
                    }, [
                        [
                            'filled',
                            'solo',
                            'solo-inverted',
                            'solo-filled'
                        ].includes(props.variant) && hasFloatingLabel.value && vue.createVNode(VFieldLabel, vue.mergeProps({
                            "key": "floating-label",
                            "ref": floatingLabelRef,
                            "class": [
                                textColorClasses.value
                            ],
                            "floating": true
                        }, floatingLabelProps.value, {
                            "style": textColorStyles.value
                        }), {
                            default: ()=>[
                                    label()
                                ]
                        }),
                        hasLabel.value && vue.createVNode(VFieldLabel, vue.mergeProps({
                            "key": "label",
                            "ref": labelRef,
                            "id": props.labelId
                        }, mainLabelProps.value), {
                            default: ()=>[
                                    label()
                                ]
                        }),
                        slots.default?.({
                            ...slotProps.value,
                            props: {
                                id: id.value,
                                class: 'v-field__input',
                                'aria-describedby': messagesId.value
                            },
                            focus: focus,
                            blur: blur
                        }) ?? vue.createElementVNode("div", {
                            "id": id.value,
                            "class": "v-field__input",
                            "aria-describedby": messagesId.value
                        }, null)
                    ]),
                    hasClear && vue.createVNode(VExpandXTransition, {
                        "key": "clear"
                    }, {
                        default: ()=>[
                                vue.withDirectives(vue.createElementVNode("div", {
                                    "class": "v-field__clearable",
                                    "onMousedown": (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }, [
                                    vue.createVNode(VDefaultsProvider, {
                                        "defaults": {
                                            VIcon: {
                                                icon: props.clearIcon
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slots.clear ? slots.clear({
                                                    ...slotProps.value,
                                                    props: {
                                                        onFocus: focus,
                                                        onBlur: blur,
                                                        onClick: props['onClick:clear'],
                                                        tabindex: -1
                                                    }
                                                }) : vue.createVNode(InputIcon, {
                                                    "name": "clear",
                                                    "onFocus": focus,
                                                    "onBlur": blur,
                                                    "tabindex": -1
                                                }, null)
                                            ]
                                    })
                                ]), [
                                    [
                                        vue.vShow,
                                        props.dirty
                                    ]
                                ])
                            ]
                    }),
                    hasAppend && vue.createElementVNode("div", {
                        "key": "append",
                        "class": "v-field__append-inner"
                    }, [
                        slots['append-inner'] ? slots['append-inner'](slotProps.value) : props.appendInnerIcon && vue.createVNode(InputIcon, {
                            "key": "append-icon",
                            "name": "appendInner",
                            "color": iconColor.value
                        }, null)
                    ]),
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-field__outline',
                            textColorClasses.value
                        ]),
                        "style": vue.normalizeStyle(textColorStyles.value)
                    }, [
                        isOutlined && vue.createElementVNode(vue.Fragment, null, [
                            vue.createElementVNode("div", {
                                "class": "v-field__outline__start"
                            }, null),
                            hasFloatingLabel.value && vue.createElementVNode("div", {
                                "class": "v-field__outline__notch"
                            }, [
                                vue.createVNode(VFieldLabel, vue.mergeProps({
                                    "ref": floatingLabelRef,
                                    "floating": true
                                }, floatingLabelProps.value), {
                                    default: ()=>[
                                            label()
                                        ]
                                })
                            ]),
                            vue.createElementVNode("div", {
                                "class": "v-field__outline__end"
                            }, null)
                        ]),
                        isPlainOrUnderlined.value && hasFloatingLabel.value && vue.createVNode(VFieldLabel, vue.mergeProps({
                            "ref": floatingLabelRef,
                            "floating": true
                        }, floatingLabelProps.value), {
                            default: ()=>[
                                    label()
                                ]
                        })
                    ])
                ]);
            });
            return {
                controlRef: controlRef,
                fieldIconColor: iconColor
            };
        }
    });
    // Utilities
    // Types
    // Types
    // Composables
    const makeAutocompleteProps = propsFactory({
        autocomplete: String
    }, 'autocomplete');
    function useAutocomplete(props) {
        const uniqueId = vue.useId();
        const reloadTrigger = vue.shallowRef(0);
        const isSuppressing = vue.toRef(()=>props.autocomplete === 'suppress');
        const fieldName = vue.toRef(()=>{
            if (!props.name) return undefined;
            return isSuppressing.value ? `${props.name}-${uniqueId}-${reloadTrigger.value}` : props.name;
        });
        const fieldAutocomplete = vue.toRef(()=>{
            return isSuppressing.value ? 'off' : props.autocomplete;
        });
        return {
            isSuppressing: isSuppressing,
            fieldAutocomplete: fieldAutocomplete,
            fieldName: fieldName,
            update: ()=>reloadTrigger.value = new Date().getTime()
        };
    }
    function useAutofocus(props) {
        function onIntersect(isIntersecting, entries) {
            if (!props.autofocus || !isIntersecting) return;
            const el = entries[0].target;
            const target = el.matches('input,textarea') ? el : el.querySelector('input,textarea');
            // Defer past overlay enter setup (e.g. VDialogTransition visibility:hidden)
            setTimeout(()=>target?.focus(), 50);
        }
        return {
            onIntersect: onIntersect
        };
    }
    // Types
    const activeTypes = [
        'color',
        'file',
        'time',
        'date',
        'datetime-local',
        'week',
        'month'
    ];
    const makeVTextFieldProps = propsFactory({
        autofocus: Boolean,
        counter: [
            Boolean,
            Number,
            String
        ],
        counterValue: [
            Number,
            Function
        ],
        prefix: String,
        placeholder: String,
        persistentPlaceholder: Boolean,
        persistentCounter: Boolean,
        suffix: String,
        role: String,
        type: {
            type: String,
            default: 'text'
        },
        modelModifiers: Object,
        ...makeAutocompleteProps(),
        ...omit(makeVInputProps(), [
            'direction'
        ]),
        ...makeVFieldProps()
    }, 'VTextField');
    const VTextField = genericComponent()({
        name: 'VTextField',
        directives: {
            vIntersect: Intersect
        },
        inheritAttrs: false,
        props: makeVTextFieldProps(),
        emits: {
            'click:control': (e)=>true,
            'mousedown:control': (e)=>true,
            'update:focused': (focused)=>true,
            'update:modelValue': (val)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const model = useProxiedModel(props, 'modelValue', undefined, (v)=>{
                if (Object.is(v, -0)) return '-0';
                return v;
            });
            const { isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const { onIntersect: onIntersect } = useAutofocus(props);
            const counterValue = vue.computed(()=>{
                return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : (model.value ?? '').toString().length;
            });
            const max = vue.computed(()=>{
                if (attrs.maxlength) return attrs.maxlength;
                if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
                return props.counter;
            });
            const isPlainOrUnderlined = vue.computed(()=>[
                    'plain',
                    'underlined'
                ].includes(props.variant));
            const vInputRef = vue.ref();
            const vFieldRef = vue.ref();
            const inputRef = vue.ref();
            const autocomplete = useAutocomplete(props);
            const isActive = vue.computed(()=>activeTypes.includes(props.type) || props.persistentPlaceholder || isFocused.value || props.active);
            function onFocus() {
                if (autocomplete.isSuppressing.value) autocomplete.update();
                if (!isFocused.value) focus();
                vue.nextTick(()=>{
                    if (inputRef.value !== getActiveElement()) inputRef.value?.focus();
                });
            }
            function onControlMousedown(e) {
                emit('mousedown:control', e);
                if (e.target === inputRef.value) return;
                onFocus();
                e.preventDefault();
            }
            function onControlClick(e) {
                emit('click:control', e);
            }
            function onClear(e, reset) {
                e.stopPropagation();
                onFocus();
                vue.nextTick(()=>{
                    reset();
                    callEvent(props['onClick:clear'], e);
                });
            }
            function onInput(e) {
                const el = e.target;
                if (!(props.modelModifiers?.trim && [
                    'text',
                    'search',
                    'password',
                    'tel',
                    'url'
                ].includes(props.type))) {
                    model.value = el.value;
                    return;
                }
                const value = el.value;
                const start = el.selectionStart;
                const end = el.selectionEnd;
                model.value = value;
                vue.nextTick(()=>{
                    let offset = 0;
                    if (value.trimStart().length === el.value.length) // #22307 - Whitespace has been removed from the
                    // start, offset the caret position to compensate
                    offset = value.length - el.value.length;
                    if (start != null) el.selectionStart = start - offset;
                    if (end != null) el.selectionEnd = end - offset;
                });
            }
            useRender(()=>{
                const hasCounter = !!(slots.counter || props.counter !== false && props.counter != null);
                const hasDetails = props.hideDetails !== true && !!(slots.details || hasCounter && (props.persistentCounter || props.hideDetails === false || isFocused.value));
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                const { modelValue: _, ...inputProps } = VInput.filterProps(props);
                const fieldProps = VField.filterProps(props);
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": vInputRef,
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": [
                        'v-text-field',
                        {
                            'v-text-field--prefixed': props.prefix,
                            'v-text-field--suffixed': props.suffix,
                            'v-input--plain-underlined': isPlainOrUnderlined.value
                        },
                        props.class
                    ],
                    "style": props.style
                }, rootAttrs, inputProps, {
                    "centerAffix": !isPlainOrUnderlined.value,
                    "focused": isFocused.value,
                    "indentDetails": props.indentDetails ?? !isPlainOrUnderlined.value
                }), {
                    ...slots,
                    default: ({ id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails, reset: reset })=>vue.createVNode(VField, vue.mergeProps({
                            "ref": vFieldRef,
                            "onMousedown": onControlMousedown,
                            "onClick": onControlClick,
                            "onClick:clear": (e)=>onClear(e, reset),
                            "role": props.role
                        }, omit(fieldProps, [
                            'onClick:clear'
                        ]), {
                            "id": id.value,
                            "labelId": `${id.value}-label`,
                            "active": isActive.value || isDirty.value,
                            "dirty": isDirty.value || props.dirty,
                            "disabled": isDisabled.value,
                            "focused": isFocused.value,
                            "details": hasDetails.value,
                            "error": isValid.value === false
                        }), {
                            ...slots,
                            default: ({ props: { class: fieldClass, ...slotProps }, controlRef: controlRef })=>{
                                const inputNode = vue.createElementVNode("input", vue.mergeProps({
                                    "ref": (val)=>inputRef.value = controlRef.value = val,
                                    "value": model.value,
                                    "onInput": onInput,
                                    "autofocus": props.autofocus,
                                    "readonly": isReadonly.value,
                                    "disabled": isDisabled.value,
                                    "name": autocomplete.fieldName.value,
                                    "autocomplete": autocomplete.fieldAutocomplete.value,
                                    "placeholder": props.placeholder,
                                    "size": 1,
                                    "role": props.role,
                                    "type": props.type,
                                    "onFocus": focus,
                                    "onBlur": blur,
                                    "aria-labelledby": `${id.value}-label`
                                }, slotProps, inputAttrs), null);
                                return vue.createElementVNode(vue.Fragment, null, [
                                    props.prefix && vue.createElementVNode("span", {
                                        "class": "v-text-field__prefix"
                                    }, [
                                        vue.createElementVNode("span", {
                                            "class": "v-text-field__prefix__text"
                                        }, [
                                            props.prefix
                                        ])
                                    ]),
                                    vue.withDirectives(slots.default ? vue.createElementVNode("div", {
                                        "class": vue.normalizeClass(fieldClass),
                                        "data-no-activator": ""
                                    }, [
                                        slots.default({
                                            id: id
                                        }),
                                        inputNode
                                    ]) : vue.cloneVNode(inputNode, {
                                        class: fieldClass
                                    }), [
                                        [
                                            Intersect,
                                            onIntersect,
                                            null,
                                            {
                                                once: true
                                            }
                                        ]
                                    ]),
                                    props.suffix && vue.createElementVNode("span", {
                                        "class": "v-text-field__suffix"
                                    }, [
                                        vue.createElementVNode("span", {
                                            "class": "v-text-field__suffix__text"
                                        }, [
                                            props.suffix
                                        ])
                                    ])
                                ]);
                            }
                        }),
                    details: hasDetails ? (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            slots.details?.(slotProps),
                            hasCounter && vue.createElementVNode(vue.Fragment, null, [
                                vue.createElementVNode("span", null, null),
                                vue.createVNode(VCounter, {
                                    "active": props.persistentCounter || isFocused.value,
                                    "value": counterValue.value,
                                    "max": max.value,
                                    "disabled": props.disabled
                                }, slots.counter)
                            ])
                        ]) : undefined
                });
            });
            return forwardRefs({}, vInputRef, vFieldRef, inputRef);
        }
    });
    // Types
    const makeVVirtualScrollItemProps = propsFactory({
        renderless: Boolean,
        ...makeComponentProps()
    }, 'VVirtualScrollItem');
    const VVirtualScrollItem = genericComponent()({
        name: 'VVirtualScrollItem',
        inheritAttrs: false,
        props: makeVVirtualScrollItemProps(),
        emits: {
            'update:height': (height)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { resizeRef: resizeRef, contentRect: contentRect } = useResizeObserver(undefined, 'border');
            vue.watch(()=>contentRect.value?.height, (height)=>{
                if (height != null) emit('update:height', height);
            });
            useRender(()=>props.renderless ? vue.createElementVNode(vue.Fragment, null, [
                    slots.default?.({
                        itemRef: resizeRef
                    })
                ]) : vue.createElementVNode("div", vue.mergeProps({
                    "ref": resizeRef,
                    "class": [
                        'v-virtual-scroll__item',
                        props.class
                    ],
                    "style": props.style
                }, attrs), [
                    slots.default?.()
                ]));
        }
    });
    // Composables
    // Types
    const UP = -1;
    const DOWN = 1;
    /** Determines how large each batch of items should be */ const BUFFER_PX = 100;
    const makeVirtualProps = propsFactory({
        itemHeight: {
            type: [
                Number,
                String
            ],
            default: null
        },
        itemKey: {
            type: [
                String,
                Array,
                Function
            ],
            default: null
        },
        height: [
            Number,
            String
        ]
    }, 'virtual');
    function useVirtual(props, items) {
        const display = useDisplay();
        const itemHeight = vue.shallowRef(0);
        vue.watchEffect(()=>{
            itemHeight.value = parseFloat(props.itemHeight || 0);
        });
        const first = vue.shallowRef(0);
        const last = vue.shallowRef(Math.ceil(// Assume 16px items filling the entire screen height if
        // not provided. This is probably incorrect but it minimises
        // the chance of ending up with empty space at the bottom.
        // The default value is set here to avoid poisoning getSize()
        (parseInt(props.height) || display.height.value) / (itemHeight.value || 16)) || 1);
        const paddingTop = vue.shallowRef(0);
        const paddingBottom = vue.shallowRef(0);
        /** The scrollable element */ const containerRef = vue.ref();
        /** An element marking the top of the scrollable area,
     * used to add an offset if there's padding or other elements above the virtual list */ const markerRef = vue.ref();
        /** markerRef's offsetTop, lazily evaluated */ let markerOffset = 0;
        const { resizeRef: resizeRef, contentRect: contentRect } = useResizeObserver();
        vue.watchEffect(()=>{
            resizeRef.value = containerRef.value;
        });
        const viewportHeight = vue.computed(()=>{
            return containerRef.value === document.documentElement ? display.height.value : contentRect.value?.height || parseInt(props.height) || 0;
        });
        /** All static elements have been rendered and we have an assumed item height */ const hasInitialRender = vue.computed(()=>{
            return !!(containerRef.value && markerRef.value && viewportHeight.value && itemHeight.value);
        });
        let sizes = Array.from({
            length: items.value.length
        });
        let offsets = Array.from({
            length: items.value.length
        });
        let heights = new Map();
        const updateTime = vue.shallowRef(0);
        let targetScrollIndex = -1;
        let targetScrollHeight = 0;
        function getSize(index) {
            return sizes[index] || itemHeight.value;
        }
        const updateOffsets = debounce(()=>{
            const start = performance.now();
            offsets[0] = 0;
            const length = items.value.length;
            for(let i = 1; i <= length; i++)offsets[i] = (offsets[i - 1] || 0) + getSize(i - 1);
            updateTime.value = Math.max(updateTime.value, performance.now() - start);
            calculateVisibleItems();
        }, updateTime);
        const unwatch = vue.watch(hasInitialRender, (v)=>{
            if (!v) return;
            // First render is complete, update offsets and visible
            // items in case our assumed item height was incorrect
            unwatch();
            markerOffset = markerRef.value.offsetTop;
            updateOffsets.immediate();
            calculateVisibleItems();
            if (!~targetScrollIndex) return;
            vue.nextTick(()=>{
                IN_BROWSER && window.requestAnimationFrame(()=>{
                    if (~targetScrollIndex) scrollToIndex(targetScrollIndex);
                });
            });
        });
        vue.onScopeDispose(()=>{
            updateOffsets.clear();
        });
        function estimateItemHeight() {
            let total = 0;
            for (const count of heights.values())total += count;
            let seen = 0;
            for (const height of [
                ...heights.keys()
            ].sort((a, b)=>a - b)){
                seen += heights.get(height);
                if (seen * 2 >= total) return height;
            }
            return itemHeight.value;
        }
        function handleItemResize(index, height) {
            const prevHeight = sizes[index];
            const prevItemHeight = itemHeight.value;
            if (height > 0) {
                if (prevHeight) {
                    const count = heights.get(prevHeight) - 1;
                    count ? heights.set(prevHeight, count) : heights.delete(prevHeight);
                }
                heights.set(height, (heights.get(height) ?? 0) + 1);
                itemHeight.value = estimateItemHeight();
            }
            if (prevHeight !== height || prevItemHeight !== itemHeight.value) {
                sizes[index] = height;
                updateOffsets();
            }
        }
        function calculateOffset(index) {
            index = clamp(index, 0, items.value.length);
            const whole = Math.floor(index);
            const fraction = index % 1;
            const next = whole + 1;
            const wholeOffset = offsets[whole] || 0;
            const nextOffset = offsets[next] || wholeOffset;
            return wholeOffset + (nextOffset - wholeOffset) * fraction;
        }
        function calculateIndex(scrollTop) {
            return binaryClosest(offsets, scrollTop);
        }
        let lastScrollTop = 0;
        let scrollVelocity = 0;
        let lastScrollTime = 0;
        vue.watch(viewportHeight, (val, oldVal)=>{
            calculateVisibleItems();
            if (val < oldVal) requestAnimationFrame(()=>{
                scrollVelocity = 0;
                calculateVisibleItems();
            });
        });
        let scrollTimeout = -1;
        function handleScroll() {
            if (!containerRef.value || !markerRef.value) return;
            const scrollTop = containerRef.value.scrollTop;
            const scrollTime = performance.now();
            const scrollDeltaT = scrollTime - lastScrollTime;
            if (scrollDeltaT > 500) {
                scrollVelocity = Math.sign(scrollTop - lastScrollTop);
                // Not super important, only update at the
                // start of a scroll sequence to avoid reflows
                markerOffset = markerRef.value.offsetTop;
            } else scrollVelocity = scrollTop - lastScrollTop;
            lastScrollTop = scrollTop;
            lastScrollTime = scrollTime;
            window.clearTimeout(scrollTimeout);
            scrollTimeout = window.setTimeout(handleScrollend, 500);
            calculateVisibleItems();
        }
        function handleScrollend() {
            if (!containerRef.value || !markerRef.value) return;
            scrollVelocity = 0;
            lastScrollTime = 0;
            window.clearTimeout(scrollTimeout);
            calculateVisibleItems();
        }
        let raf = -1;
        function calculateVisibleItems() {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(_calculateVisibleItems);
        }
        function _calculateVisibleItems() {
            if (!containerRef.value || !viewportHeight.value || !itemHeight.value) return;
            const scrollTop = lastScrollTop - markerOffset;
            const direction = Math.sign(scrollVelocity);
            const startPx = Math.max(0, scrollTop - BUFFER_PX);
            const start = clamp(calculateIndex(startPx), 0, items.value.length);
            const endPx = scrollTop + viewportHeight.value + BUFFER_PX;
            const end = clamp(calculateIndex(endPx) + 1, start + 1, items.value.length);
            if (// Only update the side we're scrolling towards,
            // the other side will be updated incidentally
            (direction !== UP || start < first.value) && (direction !== DOWN || end > last.value)) {
                const topOverflow = calculateOffset(first.value) - calculateOffset(start);
                const bottomOverflow = calculateOffset(end) - calculateOffset(last.value);
                const bufferOverflow = Math.max(topOverflow, bottomOverflow);
                if (bufferOverflow > BUFFER_PX) {
                    first.value = start;
                    last.value = end;
                } else {
                    // Only update the side that's reached its limit if there's still buffer left
                    if (start <= 0) first.value = start;
                    if (end >= items.value.length) {
                        last.value = end;
                        first.value = start;
                    }
                }
            }
            paddingTop.value = calculateOffset(first.value);
            paddingBottom.value = calculateOffset(items.value.length) - calculateOffset(last.value);
        }
        function scrollToIndex(index) {
            if (targetScrollIndex !== index) targetScrollHeight = 0;
            const offset = calculateOffset(index);
            if (!containerRef.value || index && !offset) {
                targetScrollIndex = index;
                return;
            }
            // Move the window first so paddingTop/Bottom make scrollHeight large enough
            // before we assign scrollTop (otherwise the browser clamps the scroll).
            const itemSize = itemHeight.value || 16;
            const buffer = Math.ceil(BUFFER_PX / itemSize);
            const viewport = Math.max(1, Math.ceil((viewportHeight.value || 0) / itemSize));
            first.value = clamp(index - buffer, 0, Math.max(0, items.value.length - 1));
            last.value = clamp(index + viewport + buffer, first.value + 1, items.value.length);
            paddingTop.value = calculateOffset(first.value);
            paddingBottom.value = calculateOffset(items.value.length) - calculateOffset(last.value);
            scrollVelocity = 0;
            lastScrollTime = 0;
            targetScrollIndex = index;
            vue.nextTick(()=>{
                const el = containerRef.value;
                // Superseded by a later scrollToIndex
                if (!el || !~targetScrollIndex || targetScrollIndex !== index) return;
                const top = calculateOffset(index);
                el.scrollTop = top;
                // Resize-driven calculateVisibleItems reads lastScrollTop, not the DOM
                lastScrollTop = el.scrollTop;
                if (index && el.scrollTop < top - 1 && el.scrollHeight > targetScrollHeight) {
                    targetScrollHeight = el.scrollHeight;
                    IN_BROWSER && requestAnimationFrame(()=>{
                        if (targetScrollIndex === index) scrollToIndex(index);
                    });
                } else {
                    targetScrollIndex = -1;
                    calculateVisibleItems();
                }
            });
        }
        const computedItems = vue.computed(()=>{
            return items.value.slice(first.value, last.value).map((item, index)=>{
                const _index = index + first.value;
                return {
                    raw: item,
                    index: _index,
                    key: getPropertyFromItem(item, props.itemKey, _index)
                };
            });
        });
        vue.watch(items, ()=>{
            sizes = Array.from({
                length: items.value.length
            });
            offsets = Array.from({
                length: items.value.length
            });
            heights = new Map();
            updateOffsets.immediate();
            calculateVisibleItems();
        }, {
            deep: 1
        });
        return {
            calculateVisibleItems: calculateVisibleItems,
            containerRef: containerRef,
            markerRef: markerRef,
            computedItems: computedItems,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
            scrollToIndex: scrollToIndex,
            handleScroll: handleScroll,
            handleScrollend: handleScrollend,
            handleItemResize: handleItemResize
        };
    }
    // https://gist.github.com/robertleeplummerjr/1cc657191d34ecd0a324
    function binaryClosest(arr, val) {
        let high = arr.length - 1;
        let low = 0;
        let mid = 0;
        let item = null;
        let target = -1;
        if (arr[high] < val) return high;
        while(low <= high){
            mid = low + high >> 1;
            item = arr[mid];
            if (item > val) high = mid - 1;
            else if (item < val) {
                target = mid;
                low = mid + 1;
            } else if (item === val) return mid;
            else return low;
        }
        return target;
    }
    // Types
    const makeVVirtualScrollProps = propsFactory({
        items: {
            type: Array,
            default: ()=>[]
        },
        renderless: Boolean,
        ...makeVirtualProps(),
        ...makeComponentProps(),
        ...makeDimensionProps()
    }, 'VVirtualScroll');
    const VVirtualScroll = genericComponent()({
        name: 'VVirtualScroll',
        props: makeVVirtualScrollProps(),
        setup (props, { slots: slots }) {
            const vm = getCurrentInstance('VVirtualScroll');
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { calculateVisibleItems: calculateVisibleItems, containerRef: containerRef, markerRef: markerRef, handleScroll: handleScroll, handleScrollend: handleScrollend, handleItemResize: handleItemResize, scrollToIndex: scrollToIndex, paddingTop: paddingTop, paddingBottom: paddingBottom, computedItems: computedItems } = useVirtual(props, vue.toRef(()=>props.items));
            useToggleScope(()=>props.renderless, ()=>{
                function handleListeners(add = false) {
                    const method = add ? 'addEventListener' : 'removeEventListener';
                    if (!IN_BROWSER) return;
                    if (containerRef.value === document.documentElement) {
                        document[method]('scroll', handleScroll, {
                            passive: true
                        });
                        document[method]('scrollend', handleScrollend);
                    } else {
                        containerRef.value?.[method]('scroll', handleScroll, {
                            passive: true
                        });
                        containerRef.value?.[method]('scrollend', handleScrollend);
                    }
                }
                vue.onMounted(()=>{
                    containerRef.value = getScrollParent(vm.vnode.el, true);
                    handleListeners(true);
                });
                vue.onScopeDispose(handleListeners);
            });
            useRender(()=>{
                const children = computedItems.value.map((item)=>vue.createVNode(VVirtualScrollItem, {
                        "key": item.key,
                        "renderless": props.renderless,
                        "onUpdate:height": (height)=>handleItemResize(item.index, height)
                    }, {
                        default: (slotProps)=>slots.default?.({
                                item: item.raw,
                                index: item.index,
                                ...slotProps
                            })
                    }));
                return props.renderless ? vue.createElementVNode(vue.Fragment, null, [
                    vue.createElementVNode("div", {
                        "ref": markerRef,
                        "class": "v-virtual-scroll__spacer",
                        "style": {
                            paddingTop: convertToUnit(paddingTop.value)
                        }
                    }, null),
                    children,
                    vue.createElementVNode("div", {
                        "class": "v-virtual-scroll__spacer",
                        "style": {
                            paddingBottom: convertToUnit(paddingBottom.value)
                        }
                    }, null)
                ]) : vue.createElementVNode("div", {
                    "ref": containerRef,
                    "class": vue.normalizeClass([
                        'v-virtual-scroll',
                        props.class
                    ]),
                    "onScrollPassive": handleScroll,
                    "onScrollend": handleScrollend,
                    "style": vue.normalizeStyle([
                        dimensionStyles.value,
                        props.style
                    ])
                }, [
                    vue.createElementVNode("div", {
                        "ref": markerRef,
                        "class": "v-virtual-scroll__container",
                        "style": {
                            paddingTop: convertToUnit(paddingTop.value),
                            paddingBottom: convertToUnit(paddingBottom.value)
                        }
                    }, [
                        children
                    ])
                ]);
            });
            return {
                calculateVisibleItems: calculateVisibleItems,
                scrollToIndex: scrollToIndex
            };
        }
    });
    // Utilities
    // Types
    function mergeRanges(ranges) {
        const sorted = ranges.filter((span)=>span[0] < span[1]).toSorted((a, b)=>a[0] - b[0]);
        const merged = [];
        for (const span of sorted){
            const last = merged.at(-1);
            if (last && span[0] <= last[1]) last[1] = Math.max(last[1], span[1]);
            else merged.push([
                span[0],
                span[1]
            ]);
        }
        return merged;
    }
    function chunkText(text, ranges) {
        const chunks = [];
        let cursor = 0;
        for (const [start, end] of ranges){
            if (cursor < start) chunks.push({
                text: text.slice(cursor, start),
                match: false
            });
            chunks.push({
                text: text.slice(start, end),
                match: true
            });
            cursor = end;
        }
        if (cursor < text.length) chunks.push({
            text: text.slice(cursor),
            match: false
        });
        return chunks;
    }
    function findRanges(text, query, matchAll, ignoreCase) {
        const terms = wrapInArray(query).filter(Boolean);
        const haystack = ignoreCase ? text.toLocaleLowerCase() : text;
        const spans = [];
        for (const term of terms){
            const needle = ignoreCase ? term.toLocaleLowerCase() : term;
            let index = haystack.indexOf(needle);
            if (index !== -1) {
                spans.push([
                    index,
                    index + term.length
                ]);
                if (matchAll) {
                    index = haystack.indexOf(needle, index + term.length);
                    while(index !== -1){
                        spans.push([
                            index,
                            index + term.length
                        ]);
                        index = haystack.indexOf(needle, index + term.length);
                    }
                }
            }
        }
        return mergeRanges(spans);
    }
    // mirror of `toHighlight` from `@vuetify/v0`
    // temporary shim, to be replaced in v5.0
    function toHighlight(text, query, options = {}) {
        const _text = vue.toValue(text);
        const _query = vue.toValue(query);
        const _matches = vue.toValue(options.matches);
        const matchAll = vue.toValue(options.matchAll) ?? false;
        const ignoreCase = vue.toValue(options.ignoreCase) ?? false;
        if (_matches?.length) return chunkText(_text, mergeRanges(_matches));
        if (_query) {
            const ranges = findRanges(_text, _query, matchAll, ignoreCase);
            return ranges.length > 0 ? chunkText(_text, ranges) : [
                {
                    text: _text,
                    match: false
                }
            ];
        }
        return [
            {
                text: _text,
                match: false
            }
        ];
    }
    // Types
    const makeVHighlightProps = propsFactory({
        text: {
            type: String,
            default: ''
        },
        query: [
            String,
            Array
        ],
        matches: Array,
        matchAll: Boolean,
        ignoreCase: Boolean,
        color: String,
        opacity: [
            String,
            Number
        ],
        markClass: String,
        ...makeTagProps({
            tag: 'span'
        })
    }, 'VHighlight');
    const VHighlight = defineComponent({
        name: 'VHighlight',
        props: makeVHighlightProps(),
        setup (props) {
            const chunks = vue.computed(()=>toHighlight(()=>props.text, ()=>props.query, {
                    matches: ()=>props.matches,
                    matchAll: ()=>props.matchAll,
                    ignoreCase: ()=>props.ignoreCase
                }));
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            return ()=>vue.createVNode(props.tag, {
                    "class": "v-highlight"
                }, {
                    default: ()=>[
                            chunks.value.map((chunk, i)=>chunk.match ? vue.createElementVNode("mark", {
                                    "key": i,
                                    "class": vue.normalizeClass([
                                        'v-highlight__mark',
                                        textColorClasses.value,
                                        props.markClass
                                    ]),
                                    "style": vue.normalizeStyle([
                                        textColorStyles.value,
                                        {
                                            '--v-highlight-opacity': props.opacity
                                        }
                                    ])
                                }, [
                                    chunk.text
                                ]) : vue.createElementVNode("span", {
                                    "key": i
                                }, [
                                    chunk.text
                                ]))
                        ]
                });
        }
    });
    // Utilities
    // Types
    function useFocusRepair(active, content, fallback) {
        return function repairOrphanedFocus(e) {
            if (!e.relatedTarget && document.activeElement === document.body && active.value) {
                requestAnimationFrame(()=>{
                    if (!active.value) return;
                    const el = content();
                    const target = (el && focusableChildren(el)[0]) ?? fallback();
                    target?.focus({
                        preventScroll: true
                    });
                });
                return true;
            }
            return false;
        };
    }
    // Utilities
    // Types
    function useScrolling(listRef, textFieldRef) {
        const isScrolling = vue.shallowRef(false);
        let scrollTimeout;
        function onListScroll(e) {
            cancelAnimationFrame(scrollTimeout);
            isScrolling.value = true;
            scrollTimeout = requestAnimationFrame(()=>{
                scrollTimeout = requestAnimationFrame(()=>{
                    isScrolling.value = false;
                });
            });
        }
        async function finishScrolling() {
            await new Promise((resolve)=>requestAnimationFrame(resolve));
            await new Promise((resolve)=>requestAnimationFrame(resolve));
            await new Promise((resolve)=>requestAnimationFrame(resolve));
            await new Promise((resolve)=>{
                if (isScrolling.value) {
                    const stop = vue.watch(isScrolling, ()=>{
                        stop();
                        resolve();
                    });
                } else resolve();
            });
        }
        async function onListKeydown(e) {
            if (e.key === 'Tab') textFieldRef.value?.focus();
            if (![
                'PageDown',
                'PageUp',
                'Home',
                'End'
            ].includes(e.key)) return;
            const el = listRef.value?.$el;
            if (!el) return;
            if (e.key === 'Home' || e.key === 'End') el.scrollTo({
                top: e.key === 'Home' ? 0 : el.scrollHeight,
                behavior: 'smooth'
            });
            await finishScrolling();
            const children = el.querySelectorAll(':scope > :not(.v-virtual-scroll__spacer)');
            if (e.key === 'PageDown' || e.key === 'Home') {
                const top = el.getBoundingClientRect().top;
                for (const child of children)if (child.getBoundingClientRect().top >= top) {
                    child.focus();
                    break;
                }
            } else {
                const bottom = el.getBoundingClientRect().bottom;
                for (const child of [
                    ...children
                ].reverse())if (child.getBoundingClientRect().bottom <= bottom) {
                    child.focus();
                    break;
                }
            }
        }
        return {
            onScrollPassive: onListScroll,
            onKeydown: onListKeydown
        }; // typescript doesn't know about vue's event merging
    }
    // Utilities
    // Types
    function useFocusGroups({ groups: groups, onLeave: onLeave }) {
        function getContentRef(group) {
            return group.type === 'list' ? group.contentRef.value?.$el : group.contentRef.value;
        }
        function getChildren(group) {
            const contentRef = getContentRef(group);
            return contentRef ? focusableChildren(contentRef) : [];
        }
        function onTabKeydown(e) {
            const target = e.target;
            const direction = e.shiftKey ? 'backward' : 'forward';
            const children = groups.map(getChildren);
            const currentGroupIndex = groups.map((g)=>g.type === 'list' ? g.contentRef.value?.$el : g.contentRef.value).findIndex((el)=>el?.contains(target));
            const nextIndex = nextFocusGroup(children, currentGroupIndex, direction, target);
            if (nextIndex === null) {
                const originGroup = groups[currentGroupIndex];
                const origin = children[currentGroupIndex];
                const isListGroup = originGroup.type === 'list';
                const atEdge = isListGroup || (direction === 'forward' ? origin.at(-1) === e.target : origin.at(0) === e.target);
                if (atEdge) onLeave();
            } else {
                e.preventDefault();
                e.stopImmediatePropagation();
                const nextGroup = groups[nextIndex];
                if (nextGroup.type === 'list' && vue.toValue(nextGroup.displayItemsCount) > 0) nextGroup.contentRef.value?.focus(0);
                else {
                    const fromBefore = direction === 'forward';
                    children[nextIndex].at(fromBefore ? 0 : -1).focus();
                }
            }
        }
        function nextFocusGroup(children, currentIndex, direction, target) {
            const originGroup = groups[currentIndex];
            const origin = children[currentIndex];
            // List groups always allow leaving (VList manages internal focus)
            // Element groups require being at the edge focusable child
            if (originGroup.type !== 'list') {
                const isAtEdge = direction === 'forward' ? origin.at(-1) === target : origin.at(0) === target;
                if (!isAtEdge) return null;
            }
            const step = direction === 'forward' ? 1 : -1;
            for(let i = currentIndex + step; i >= 0 && i < groups.length; i += step){
                const group = groups[i];
                if (children[i].length > 0 || group.type === 'list' && vue.toValue(group.displayItemsCount) > 0) return i;
            }
            return null;
        }
        return {
            onTabKeydown: onTabKeydown
        };
    }
    /* eslint-disable max-statements */ /* eslint-disable no-labels */ // Types
    /**
   * - boolean: match without highlight
   * - number: single match (index), length already known
   * - []: single match (start, end)
   * - [][]: multiple matches (start, end), shouldn't overlap
   */ // Composables
    const defaultFilter = (value, query, item)=>{
        if (value == null || query == null) return -1;
        if (!query.length) return 0;
        value = value.toString().toLocaleLowerCase();
        query = query.toString().toLocaleLowerCase();
        const result = [];
        let idx = value.indexOf(query);
        while(~idx){
            result.push([
                idx,
                idx + query.length
            ]);
            idx = value.indexOf(query, idx + query.length);
        }
        return result.length ? result : -1;
    };
    function normaliseMatch(match, query) {
        if (match == null || typeof match === 'boolean' || match === -1) return;
        if (typeof match === 'number') return [
            [
                match,
                match + query.length
            ]
        ];
        if (Array.isArray(match[0])) return match;
        return [
            match
        ];
    }
    const makeFilterProps = propsFactory({
        customFilter: Function,
        customKeyFilter: Object,
        filterKeys: [
            Array,
            String
        ],
        filterMode: {
            type: String,
            default: 'intersection'
        },
        noFilter: Boolean
    }, 'filter');
    // eslint-disable-next-line complexity
    function filterItems(items, query, options) {
        const array = [];
        // always ensure we fall back to a functioning filter
        const filter = options?.default ?? defaultFilter;
        const keys = options?.filterKeys ? wrapInArray(options.filterKeys) : false;
        const customFiltersLength = Object.keys(options?.customKeyFilter ?? {}).length;
        if (!items?.length) return array;
        let lookAheadItems = [];
        loop: for(let i = 0; i < items.length; i++){
            const [item, transformed = item] = wrapInArray(items[i]);
            const customMatches = {};
            const defaultMatches = {};
            let match = -1;
            if ((query || customFiltersLength > 0) && !options?.noFilter) {
                let hasOnlyCustomFilters = false;
                if (typeof item === 'object') {
                    if (item.type === 'divider' || item.type === 'subheader') {
                        if (lookAheadItems.at(-1)?.type !== 'divider' || item.type !== 'subheader') // clear unless, divider appears before subheader
                        lookAheadItems = [];
                        lookAheadItems.push({
                            index: i,
                            matches: {},
                            type: item.type
                        });
                        continue;
                    }
                    const filterKeys = keys || Object.keys(transformed);
                    hasOnlyCustomFilters = filterKeys.length === customFiltersLength;
                    for (const key of filterKeys){
                        const value = getPropertyFromItem(transformed, key);
                        const keyFilter = options?.customKeyFilter?.[key];
                        match = keyFilter ? keyFilter(value, query, item) : filter(value, query, item);
                        if (match !== -1 && match !== false) {
                            if (keyFilter) customMatches[key] = normaliseMatch(match, query);
                            else defaultMatches[key] = normaliseMatch(match, query);
                        } else if (options?.filterMode === 'every') continue loop;
                    }
                } else {
                    match = filter(item, query, item);
                    if (match !== -1 && match !== false) defaultMatches.title = normaliseMatch(match, query);
                }
                const defaultMatchesLength = Object.keys(defaultMatches).length;
                const customMatchesLength = Object.keys(customMatches).length;
                if (!defaultMatchesLength && !customMatchesLength) continue;
                if (options?.filterMode === 'union' && customMatchesLength !== customFiltersLength && !defaultMatchesLength) continue;
                if (options?.filterMode === 'intersection' && (customMatchesLength !== customFiltersLength || !defaultMatchesLength && customFiltersLength > 0 && !hasOnlyCustomFilters)) continue;
            }
            if (lookAheadItems.length) {
                array.push(...lookAheadItems);
                lookAheadItems = [];
            }
            array.push({
                index: i,
                matches: {
                    ...defaultMatches,
                    ...customMatches
                }
            });
        }
        return array;
    }
    function useFilter(props, items, query, options) {
        const filteredItems = vue.shallowRef([]);
        const filteredMatches = vue.shallowRef(new Map());
        const transformedItems = vue.computed(()=>options?.transform ? vue.unref(items).map((item)=>[
                    item,
                    options.transform(item)
                ]) : vue.unref(items));
        vue.watchEffect(()=>{
            const _query = typeof query === 'function' ? query() : vue.unref(query);
            const strQuery = typeof _query !== 'string' && typeof _query !== 'number' ? '' : String(_query);
            const results = filterItems(transformedItems.value, strQuery, {
                customKeyFilter: {
                    ...props.customKeyFilter,
                    ...vue.unref(options?.customKeyFilter)
                },
                default: props.customFilter,
                filterKeys: props.filterKeys,
                filterMode: props.filterMode,
                noFilter: props.noFilter
            });
            const originalItems = vue.unref(items);
            const _filteredItems = [];
            const _filteredMatches = new Map();
            results.forEach(({ index: index, matches: matches })=>{
                const item = originalItems[index];
                _filteredItems.push(item);
                if (item.value !== undefined) _filteredMatches.set(item.value, matches);
            });
            filteredItems.value = _filteredItems;
            filteredMatches.value = _filteredMatches;
        });
        function getMatches(item) {
            return filteredMatches.value.get(item.value);
        }
        return {
            filteredItems: filteredItems,
            filteredMatches: filteredMatches,
            getMatches: getMatches
        };
    }
    // Utilities
    // Types
    // Types
    // Composables
    const makeMenuActivatorProps = propsFactory({
        closeText: {
            type: String,
            default: '$vuetify.close'
        },
        openText: {
            type: String,
            default: '$vuetify.open'
        }
    }, 'autocomplete');
    function useMenuActivator(props, isOpen) {
        const uid = vue.useId();
        const menuId = vue.computed(()=>`menu-${uid}`);
        const ariaExpanded = vue.toRef(()=>vue.toValue(isOpen));
        const ariaControls = vue.toRef(()=>menuId.value);
        return {
            menuId: menuId,
            ariaExpanded: ariaExpanded,
            ariaControls: ariaControls
        };
    }
    // Types
    const makeSelectProps = propsFactory({
        chips: Boolean,
        closableChips: Boolean,
        eager: Boolean,
        hideNoData: Boolean,
        hideSelected: Boolean,
        listProps: {
            type: Object
        },
        menu: Boolean,
        menuElevation: [
            Number,
            String
        ],
        menuIcon: {
            type: IconValue,
            default: '$dropdown'
        },
        menuProps: {
            type: Object
        },
        multiple: Boolean,
        noDataText: {
            type: String,
            default: '$vuetify.noDataText'
        },
        openOnClear: Boolean,
        itemColor: String,
        noAutoScroll: Boolean,
        ...makeMenuActivatorProps(),
        ...makeItemsProps({
            itemChildren: false
        })
    }, 'Select');
    const makeVSelectProps = propsFactory({
        search: String,
        ...makeFilterProps({
            filterKeys: [
                'title'
            ]
        }),
        ...makeSelectProps(),
        ...omit(makeVTextFieldProps({
            modelValue: null,
            role: 'combobox'
        }), [
            'validationValue',
            'dirty'
        ]),
        ...makeTransitionProps({
            transition: {
                component: VDialogTransition
            }
        })
    }, 'VSelect');
    const VSelect = genericComponent()({
        name: 'VSelect',
        props: makeVSelectProps(),
        emits: {
            'update:focused': (focused)=>true,
            'update:modelValue': (value)=>true,
            'update:menu': (ue)=>true,
            'update:search': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { t: t } = useLocale();
            const vTextFieldRef = vue.ref();
            const vMenuRef = vue.ref();
            const headerRef = vue.ref();
            const footerRef = vue.ref();
            const vVirtualScrollRef = vue.ref();
            const { items: items, transformIn: transformIn, transformOut: transformOut } = useItems(props);
            const search = useProxiedModel(props, 'search', '');
            const { filteredItems: filteredItems, getMatches: getMatches } = useFilter(props, items, ()=>search.value);
            const model = useProxiedModel(props, 'modelValue', [], (v)=>transformIn(v === null ? [
                    null
                ] : wrapInArray(v)), (v)=>{
                const transformed = transformOut(v);
                return props.multiple ? transformed : transformed[0] ?? null;
            });
            const counterValue = vue.computed(()=>{
                return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
            });
            const form = useForm(props);
            const autocomplete = useAutocomplete(props);
            const selectedValues = vue.computed(()=>model.value.map((selection)=>selection.value));
            const isFocused = vue.shallowRef(false);
            const closableChips = vue.toRef(()=>props.closableChips && !form.isReadonly.value && !form.isDisabled.value);
            const { InputIcon: InputIcon } = useInputIcon(props);
            let keyboardLookupPrefix = '';
            let keyboardLookupIndex = 0;
            let keyboardLookupLastTime;
            let openedByKeyboard = false;
            let openedByArrow = null;
            const displayItems = vue.computed(()=>{
                const baseItems = search.value ? filteredItems.value : items.value;
                if (props.hideSelected) return baseItems.filter((item)=>!model.value.some((s)=>(props.valueComparator || deepEqual)(s, item)));
                return baseItems;
            });
            const menuDisabled = vue.computed(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
            const _menu = useProxiedModel(props, 'menu');
            const menu = vue.computed({
                get: ()=>_menu.value,
                set: (v)=>{
                    if (_menu.value && !v && vMenuRef.value?.\u03A8openChildren.size) return;
                    if (v && menuDisabled.value) return;
                    _menu.value = v;
                }
            });
            const { menuId: menuId, ariaExpanded: ariaExpanded, ariaControls: ariaControls } = useMenuActivator(props, menu);
            const computedMenuProps = vue.computed(()=>{
                return {
                    ...props.menuProps,
                    activatorProps: {
                        ...props.menuProps?.activatorProps || {},
                        'aria-haspopup': 'listbox' // Set aria-haspopup to 'listbox'
                    }
                };
            });
            const listRef = vue.ref();
            const listEvents = useScrolling(listRef, vTextFieldRef);
            const repairOrphanedFocus = useFocusRepair(menu, ()=>vMenuRef.value?.contentEl, ()=>vTextFieldRef.value?.controlRef);
            const { onTabKeydown: onTabKeydown } = useFocusGroups({
                groups: [
                    {
                        type: 'element',
                        contentRef: headerRef
                    },
                    {
                        type: 'list',
                        contentRef: listRef,
                        displayItemsCount: ()=>displayItems.value.length
                    },
                    {
                        type: 'element',
                        contentRef: footerRef
                    }
                ],
                onLeave: ()=>{
                    menu.value = false;
                    vTextFieldRef.value?.focus();
                }
            });
            function onClear(e) {
                if (props.openOnClear) menu.value = true;
            }
            function onMousedownControl() {
                if (menuDisabled.value) return;
                openedByKeyboard = false;
                openedByArrow = null;
                menu.value = !menu.value;
            }
            function onMenuKeydown(e) {
                if (e.key === 'Tab') onTabKeydown(e);
                if (listRef.value?.$el.contains(e.target) && checkPrintable(e)) onKeydown(e);
            }
            function onKeydown(e) {
                if (!e.key || form.isReadonly.value) return;
                if ([
                    'Enter',
                    ' ',
                    'ArrowDown',
                    'ArrowUp',
                    'Home',
                    'End'
                ].includes(e.key)) e.preventDefault();
                if ([
                    'ArrowDown',
                    'ArrowUp'
                ].includes(e.key)) openedByArrow = e.key === 'ArrowDown' ? 'next' : 'prev';
                else if ([
                    'Enter',
                    ' '
                ].includes(e.key)) openedByArrow = null;
                if ([
                    'Enter',
                    'ArrowDown',
                    ' '
                ].includes(e.key)) {
                    openedByKeyboard = true;
                    menu.value = true;
                }
                if ([
                    'Escape',
                    'Tab'
                ].includes(e.key)) menu.value = false;
                if (props.clearable && e.key === 'Backspace') {
                    e.preventDefault();
                    model.value = [];
                    onClear();
                    return;
                }
                if (e.key === 'Home') listRef.value?.focus('first');
                else if (e.key === 'End') listRef.value?.focus('last');
                // html select hotkeys
                const KEYBOARD_LOOKUP_THRESHOLD = 1000; // milliseconds
                if (!checkPrintable(e)) return;
                const now = performance.now();
                if (now - keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
                    keyboardLookupPrefix = '';
                    keyboardLookupIndex = 0;
                }
                keyboardLookupPrefix += e.key.toLowerCase();
                keyboardLookupLastTime = now;
                const items = displayItems.value;
                function findItem() {
                    let result = findItemBase();
                    if (result) return result;
                    if (keyboardLookupPrefix.at(-1) === keyboardLookupPrefix.at(-2)) {
                        // No matches but we have a repeated letter, try the next item with that prefix
                        keyboardLookupPrefix = keyboardLookupPrefix.slice(0, -1);
                        keyboardLookupIndex++;
                        result = findItemBase();
                        if (result) return result;
                    }
                    // Still nothing, wrap around to the top
                    keyboardLookupIndex = 0;
                    result = findItemBase();
                    if (result) return result;
                    // Still nothing, try just the new letter
                    keyboardLookupPrefix = e.key.toLowerCase();
                    return findItemBase();
                }
                function findItemBase() {
                    for(let i = keyboardLookupIndex; i < items.length; i++){
                        const _item = items[i];
                        if (_item.title.toLowerCase().startsWith(keyboardLookupPrefix)) return [
                            _item,
                            i
                        ];
                    }
                    return undefined;
                }
                const result = findItem();
                if (!result) return;
                const [item, index] = result;
                keyboardLookupIndex = index;
                listRef.value?.focus(index);
                if (!props.multiple) model.value = [
                    item
                ];
            }
            /** @param set - null means toggle */ function select(item, set = true) {
                if (item.props.disabled) return;
                if (props.multiple) {
                    const index = model.value.findIndex((selection)=>(props.valueComparator || deepEqual)(selection.value, item.value));
                    const add = set == null ? !~index : set;
                    if (~index) {
                        const value = add ? [
                            ...model.value,
                            item
                        ] : [
                            ...model.value
                        ];
                        value.splice(index, 1);
                        model.value = value;
                    } else if (add) model.value = [
                        ...model.value,
                        item
                    ];
                } else {
                    const add = set !== false;
                    model.value = add ? [
                        item
                    ] : [];
                    vue.nextTick(()=>{
                        menu.value = false;
                    });
                }
            }
            function onBlur(e) {
                const target = e.target;
                if (!vTextFieldRef.value?.$el.contains(target)) menu.value = false;
            }
            function getSelectedIndex() {
                return displayItems.value.findIndex((item)=>model.value.some((s)=>(props.valueComparator || deepEqual)(s.value, item.value)));
            }
            function focusSelectedItem(options) {
                // Virtual list only mounts a window — numeric index into DOM children is wrong
                const selected = listRef.value?.$el?.querySelector?.('[aria-selected="true"]');
                if (!selected) return false;
                selected.focus(options);
                return true;
            }
            function onAfterEnter() {
                if (props.eager) vVirtualScrollRef.value?.calculateVisibleItems();
                if (!listRef.value || !isFocused.value) return;
                // VMenu re-dispatches ArrowUp/Down after open and already moved focus to next/prev
                if (listRef.value.$el?.contains(getActiveElement())) return;
                const opts = {
                    focusVisible: false,
                    preventScroll: props.noAutoScroll
                };
                // fallback for VMenu's re-dispatch; fires before the virtual list has scrolled
                if (openedByArrow) {
                    listRef.value.focus(openedByArrow, opts);
                    return;
                }
                if (focusSelectedItem(opts)) return;
                if (openedByKeyboard) listRef.value.focus('first', opts);
            }
            function onAfterLeave() {
                search.value = '';
                if (isFocused.value) {
                    if (vMenuRef.value?.contentEl?._clickOutside?.lastMousedownWasOutside) isFocused.value = false;
                    else vTextFieldRef.value?.focus();
                }
            }
            function onFocusin(e) {
                isFocused.value = true;
            }
            function onFocusout(e) {
                if (!vTextFieldRef.value?.$el.contains(e.relatedTarget) && !e.currentTarget.contains(e.relatedTarget)) {
                    if (repairOrphanedFocus(e)) return;
                    isFocused.value = false;
                }
            }
            function onModelUpdate(v) {
                if (v == null) model.value = [];
                else if (matchesSelector(vTextFieldRef.value, ':autofill') || matchesSelector(vTextFieldRef.value, ':-webkit-autofill')) {
                    const item = items.value.find((item)=>item.title === v);
                    if (item) select(item);
                } else if (vTextFieldRef.value) vTextFieldRef.value.value = '';
            }
            vue.watch(menu, (val)=>{
                if (!val) {
                    openedByKeyboard = false;
                    openedByArrow = null;
                }
                if (!props.hideSelected && menu.value && model.value.length) {
                    const index = getSelectedIndex();
                    IN_BROWSER && !props.noAutoScroll && window.requestAnimationFrame(()=>{
                        index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
                    });
                }
            });
            vue.watch(items, (newVal, oldVal)=>{
                if (menu.value) return;
                if (isFocused.value && props.hideNoData && !oldVal.length && newVal.length) menu.value = true;
            });
            useRender(()=>{
                const hasChips = !!(props.chips || slots.chip);
                const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
                const isDirty = model.value.length > 0;
                const textFieldProps = VTextField.filterProps(props);
                const placeholder = isDirty || !isFocused.value && props.label && !props.persistentPlaceholder ? undefined : props.placeholder;
                const menuSlotProps = {
                    search: search,
                    filteredItems: filteredItems.value
                };
                return vue.createVNode(VTextField, vue.mergeProps({
                    "ref": vTextFieldRef
                }, textFieldProps, {
                    "modelValue": model.value.map((v)=>v.props.title).join(', '),
                    "name": undefined,
                    "onUpdate:modelValue": onModelUpdate,
                    "focused": isFocused.value,
                    "onUpdate:focused": ($event)=>isFocused.value = $event,
                    "validationValue": model.externalValue,
                    "counterValue": counterValue.value,
                    "dirty": isDirty,
                    "class": [
                        'v-select',
                        {
                            'v-select--active-menu': menu.value,
                            'v-select--chips': !!props.chips,
                            [`v-select--${props.multiple ? 'multiple' : 'single'}`]: true,
                            'v-select--selected': model.value.length,
                            'v-select--selection-slot': !!slots.selection
                        },
                        props.class
                    ],
                    "style": props.style,
                    "inputmode": "none",
                    "placeholder": placeholder,
                    "onClick:clear": onClear,
                    "onMousedown:control": onMousedownControl,
                    "onBlur": onBlur,
                    "onKeydown": onKeydown,
                    "aria-expanded": ariaExpanded.value,
                    "aria-controls": ariaControls.value
                }), {
                    ...slots,
                    default: ({ id: id })=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createElementVNode("select", {
                                "hidden": true,
                                "multiple": props.multiple,
                                "name": autocomplete.fieldName.value
                            }, [
                                items.value.map((item)=>vue.createElementVNode("option", {
                                        "key": item.value,
                                        "value": item.value,
                                        "selected": selectedValues.value.includes(item.value)
                                    }, null))
                            ]),
                            vue.createVNode(VMenu, vue.mergeProps({
                                "id": menuId.value,
                                "ref": vMenuRef,
                                "modelValue": menu.value,
                                "onUpdate:modelValue": ($event)=>menu.value = $event,
                                "activator": "parent",
                                "captureFocus": false,
                                "disabled": menuDisabled.value,
                                "eager": props.eager,
                                "maxHeight": 310,
                                "openOnClick": false,
                                "closeOnContentClick": false,
                                "transition": props.transition,
                                "onAfterEnter": onAfterEnter,
                                "onAfterLeave": onAfterLeave
                            }, computedMenuProps.value, {
                                "contentClass": [
                                    'v-select__content',
                                    computedMenuProps.value.contentClass
                                ]
                            }), {
                                default: ()=>[
                                        vue.createVNode(VSheet, {
                                            "elevation": props.menuElevation,
                                            "onFocusin": onFocusin,
                                            "onFocusout": onFocusout,
                                            "onKeydown": onMenuKeydown
                                        }, {
                                            default: ()=>[
                                                    slots['menu-header'] && vue.createElementVNode("header", {
                                                        "ref": headerRef
                                                    }, [
                                                        slots['menu-header'](menuSlotProps)
                                                    ]),
                                                    hasList && vue.createVNode(VList, vue.mergeProps({
                                                        "key": "select-list",
                                                        "ref": listRef,
                                                        "selected": selectedValues.value,
                                                        "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                                        "tabindex": "-1",
                                                        "selectable": !!displayItems.value.length,
                                                        "aria-live": "polite",
                                                        "aria-labelledby": `${id.value}-label`,
                                                        "aria-multiselectable": props.multiple,
                                                        "color": props.itemColor ?? props.color
                                                    }, listEvents, props.listProps), {
                                                        default: ()=>[
                                                                slots['prepend-item']?.(),
                                                                !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? vue.createVNode(VListItem, {
                                                                    "key": "no-data",
                                                                    "title": t(props.noDataText)
                                                                }, null)),
                                                                vue.createVNode(VVirtualScroll, {
                                                                    "ref": vVirtualScrollRef,
                                                                    "renderless": true,
                                                                    "items": displayItems.value,
                                                                    "itemKey": "value"
                                                                }, {
                                                                    default: ({ item: item, index: index, itemRef: itemRef })=>{
                                                                        const camelizedProps = camelizeProps(item.props);
                                                                        const itemProps = vue.mergeProps(item.props, {
                                                                            ref: itemRef,
                                                                            key: item.value,
                                                                            onClick: ()=>select(item, null),
                                                                            'aria-posinset': index + 1,
                                                                            'aria-setsize': displayItems.value.length
                                                                        });
                                                                        if (item.type === 'divider') return slots.divider?.({
                                                                            props: item.raw,
                                                                            index: index
                                                                        }) ?? vue.createVNode(VDivider, vue.mergeProps(item.props, {
                                                                            "ref": itemRef,
                                                                            "key": `divider-${index}`
                                                                        }), null);
                                                                        if (item.type === 'subheader') return slots.subheader?.({
                                                                            props: item.raw,
                                                                            index: index
                                                                        }) ?? vue.createVNode(VListSubheader, vue.mergeProps(item.props, {
                                                                            "ref": itemRef,
                                                                            "key": `subheader-${index}`
                                                                        }), null);
                                                                        return slots.item?.({
                                                                            item: item.raw,
                                                                            internalItem: item,
                                                                            index: index,
                                                                            props: itemProps
                                                                        }) ?? vue.createVNode(VListItem, vue.mergeProps(itemProps, {
                                                                            "role": "option"
                                                                        }), {
                                                                            prepend: ({ isSelected: isSelected })=>vue.createElementVNode(vue.Fragment, null, [
                                                                                    props.multiple && !props.hideSelected ? vue.createVNode(VCheckboxBtn, {
                                                                                        "key": item.value,
                                                                                        "modelValue": isSelected,
                                                                                        "ripple": false,
                                                                                        "tabindex": "-1",
                                                                                        "aria-hidden": true,
                                                                                        "onClick": (event)=>event.preventDefault()
                                                                                    }, null) : undefined,
                                                                                    camelizedProps.prependAvatar && vue.createVNode(VAvatar, {
                                                                                        "image": camelizedProps.prependAvatar
                                                                                    }, null),
                                                                                    camelizedProps.prependIcon && vue.createVNode(VIcon, {
                                                                                        "icon": camelizedProps.prependIcon
                                                                                    }, null)
                                                                                ]),
                                                                            title: ()=>{
                                                                                return search.value ? vue.createVNode(VHighlight, {
                                                                                    "text": item.title,
                                                                                    "matches": getMatches(item)?.title,
                                                                                    "markClass": "v-select__mask",
                                                                                    "matchAll": true,
                                                                                    "ignoreCase": true
                                                                                }, null) : item.title;
                                                                            }
                                                                        });
                                                                    }
                                                                }),
                                                                slots['append-item']?.()
                                                            ]
                                                    }),
                                                    slots['menu-footer'] && vue.createElementVNode("footer", {
                                                        "ref": footerRef
                                                    }, [
                                                        slots['menu-footer'](menuSlotProps)
                                                    ])
                                                ]
                                        })
                                    ]
                            }),
                            model.value.map((item, index)=>{
                                function onChipClose(e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    select(item, false);
                                }
                                const slotProps = vue.mergeProps(VChip.filterProps(item.props), {
                                    'onClick:close': onChipClose,
                                    onKeydown (e) {
                                        if (e.key !== 'Enter' && e.key !== ' ') return;
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onChipClose(e);
                                    },
                                    onMousedown (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    },
                                    modelValue: true,
                                    'onUpdate:modelValue': undefined
                                });
                                const hasSlot = hasChips ? !!slots.chip : !!slots.selection;
                                const slotContent = hasSlot ? ensureValidVNode(hasChips ? slots.chip({
                                    item: item.raw,
                                    internalItem: item,
                                    index: index,
                                    props: slotProps
                                }) : slots.selection({
                                    item: item.raw,
                                    internalItem: item,
                                    index: index
                                })) : undefined;
                                if (hasSlot && !slotContent) return undefined;
                                return vue.createElementVNode("div", {
                                    "key": item.value,
                                    "class": "v-select__selection"
                                }, [
                                    hasChips ? !slots.chip ? vue.createVNode(VChip, vue.mergeProps({
                                        "key": "chip",
                                        "closable": closableChips.value,
                                        "size": "small",
                                        "text": item.title,
                                        "disabled": item.props.disabled
                                    }, slotProps), null) : vue.createVNode(VDefaultsProvider, {
                                        "key": "chip-defaults",
                                        "defaults": {
                                            VChip: {
                                                closable: closableChips.value,
                                                size: 'small',
                                                text: item.title
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slotContent
                                            ]
                                    }) : slotContent ?? vue.createElementVNode("span", {
                                        "class": "v-select__selection-text"
                                    }, [
                                        item.title,
                                        props.multiple && index < model.value.length - 1 && vue.createElementVNode("span", {
                                            "class": "v-select__selection-comma"
                                        }, [
                                            vue.createTextVNode(",")
                                        ])
                                    ])
                                ]);
                            })
                        ]),
                    'append-inner': (...args)=>vue.createElementVNode(vue.Fragment, null, [
                            slots['append-inner']?.(...args),
                            props.menuIcon ? vue.createVNode(VIcon, {
                                "class": "v-select__menu-icon",
                                "color": vTextFieldRef.value?.fieldIconColor,
                                "icon": props.menuIcon,
                                "aria-hidden": true
                            }, null) : undefined,
                            props.appendInnerIcon && vue.createVNode(InputIcon, {
                                "key": "append-icon",
                                "name": "appendInner",
                                "color": args[0].iconColor.value
                            }, null)
                        ])
                });
            });
            return forwardRefs({
                isFocused: isFocused,
                menu: menu,
                search: search,
                filteredItems: filteredItems,
                select: select
            }, vTextFieldRef);
        }
    });
    // Types
    const makeVAutocompleteProps = propsFactory({
        autoSelectFirst: {
            type: [
                Boolean,
                String
            ]
        },
        clearOnSelect: Boolean,
        search: String,
        ...makeFilterProps({
            filterKeys: [
                'title'
            ]
        }),
        ...makeSelectProps(),
        ...omit(makeVTextFieldProps({
            modelValue: null,
            role: 'combobox'
        }), [
            'validationValue',
            'dirty'
        ])
    }, 'VAutocomplete');
    const VAutocomplete = genericComponent()({
        name: 'VAutocomplete',
        props: makeVAutocompleteProps(),
        emits: {
            'update:focused': (focused)=>true,
            'update:search': (value)=>true,
            'update:modelValue': (value)=>true,
            'update:menu': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { t: t } = useLocale();
            const vTextFieldRef = vue.ref();
            const isFocused = vue.shallowRef(false);
            const isPristine = vue.shallowRef(true);
            const listHasFocus = vue.shallowRef(false);
            const vMenuRef = vue.ref();
            const vVirtualScrollRef = vue.ref();
            const selectionIndex = vue.shallowRef(-1);
            const _searchLock = vue.shallowRef(null);
            const { items: items, transformIn: transformIn, transformOut: transformOut } = useItems(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>vTextFieldRef.value?.color);
            const { InputIcon: InputIcon } = useInputIcon(props);
            const search = useProxiedModel(props, 'search', '');
            const model = useProxiedModel(props, 'modelValue', [], (v)=>transformIn(v === null ? [
                    null
                ] : wrapInArray(v)), (v)=>{
                const transformed = transformOut(v);
                return props.multiple ? transformed : transformed[0] ?? null;
            });
            const counterValue = vue.computed(()=>{
                return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
            });
            const form = useForm(props);
            const { filteredItems: filteredItems, getMatches: getMatches } = useFilter(props, items, ()=>_searchLock.value ?? (isPristine.value ? '' : search.value));
            const displayItems = vue.computed(()=>{
                if (props.hideSelected && _searchLock.value === null) return filteredItems.value.filter((filteredItem)=>!model.value.some((s)=>s.value === filteredItem.value));
                return filteredItems.value;
            });
            const closableChips = vue.toRef(()=>props.closableChips && !form.isReadonly.value && !form.isDisabled.value);
            const hasChips = vue.computed(()=>!!(props.chips || slots.chip));
            const hasSelectionSlot = vue.computed(()=>hasChips.value || !!slots.selection);
            const selectedValues = vue.computed(()=>model.value.map((selection)=>selection.props.value));
            const firstSelectableItem = vue.computed(()=>displayItems.value.find((x)=>x.type === 'item' && !x.props.disabled));
            const highlightFirst = vue.computed(()=>{
                const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === firstSelectableItem.value?.title;
                return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
            });
            const menuDisabled = vue.computed(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
            const _menu = useProxiedModel(props, 'menu');
            const menu = vue.computed({
                get: ()=>_menu.value,
                set: (v)=>{
                    if (_menu.value && !v && vMenuRef.value?.\u03A8openChildren.size) return;
                    if (v && menuDisabled.value) return;
                    _menu.value = v;
                }
            });
            const { menuId: menuId, ariaExpanded: ariaExpanded, ariaControls: ariaControls } = useMenuActivator(props, menu);
            const listRef = vue.ref();
            const headerRef = vue.ref();
            const footerRef = vue.ref();
            const listEvents = useScrolling(listRef, vTextFieldRef);
            const repairOrphanedFocus = useFocusRepair(menu, ()=>vMenuRef.value?.contentEl, ()=>vTextFieldRef.value?.controlRef);
            const { onTabKeydown: onTabKeydown } = useFocusGroups({
                groups: [
                    {
                        type: 'element',
                        contentRef: headerRef
                    },
                    {
                        type: 'list',
                        contentRef: listRef,
                        displayItemsCount: ()=>displayItems.value.length
                    },
                    {
                        type: 'element',
                        contentRef: footerRef
                    }
                ],
                onLeave: ()=>{
                    menu.value = false;
                    vTextFieldRef.value?.focus();
                }
            });
            function onClear(e) {
                if (props.openOnClear) menu.value = true;
                search.value = '';
            }
            function onMousedownControl() {
                if (menuDisabled.value) return;
                menu.value = true;
            }
            function onMousedownMenuIcon(e) {
                if (menuDisabled.value) return;
                if (isFocused.value) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                menu.value = !menu.value;
            }
            function onMenuKeydown(e) {
                if (e.key === 'Tab') onTabKeydown(e);
                if (listRef.value?.$el.contains(e.target) && (checkPrintable(e) || e.key === 'Backspace')) vTextFieldRef.value?.focus();
            }
            // eslint-disable-next-line complexity
            function onKeydown(e) {
                if (isComposingIgnoreKey(e) || form.isReadonly.value) return;
                const selectionStart = vTextFieldRef.value?.selectionStart;
                const length = model.value.length;
                if ([
                    'Enter',
                    'ArrowDown',
                    'ArrowUp'
                ].includes(e.key)) e.preventDefault();
                if ([
                    'Enter',
                    'ArrowDown'
                ].includes(e.key)) menu.value = true;
                if ([
                    'Escape'
                ].includes(e.key)) menu.value = false;
                if (highlightFirst.value && [
                    'Enter',
                    'Tab'
                ].includes(e.key) && firstSelectableItem.value && !model.value.some(({ value: value })=>value === firstSelectableItem.value.value)) select(firstSelectableItem.value);
                if (e.key === 'ArrowDown' && highlightFirst.value) listRef.value?.focus('next');
                if ([
                    'Backspace',
                    'Delete'
                ].includes(e.key)) {
                    if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                    if (~selectionIndex.value) {
                        e.preventDefault();
                        const originalSelectionIndex = selectionIndex.value;
                        select(model.value[selectionIndex.value], false);
                        selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                    } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                    return;
                }
                if (!props.multiple) return;
                if (e.key === 'ArrowLeft') {
                    if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                    const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                    if (model.value[prev]) selectionIndex.value = prev;
                    else {
                        const searchLength = search.value?.length ?? null;
                        selectionIndex.value = -1;
                        vTextFieldRef.value?.setSelectionRange(searchLength, searchLength);
                    }
                } else if (e.key === 'ArrowRight') {
                    if (selectionIndex.value < 0) return;
                    const next = selectionIndex.value + 1;
                    if (model.value[next]) selectionIndex.value = next;
                    else {
                        selectionIndex.value = -1;
                        vTextFieldRef.value?.setSelectionRange(0, 0);
                    }
                } else if (~selectionIndex.value && checkPrintable(e)) selectionIndex.value = -1;
            }
            function onChange(e) {
                if (matchesSelector(vTextFieldRef.value, ':autofill') || matchesSelector(vTextFieldRef.value, ':-webkit-autofill')) {
                    const item = items.value.find((item)=>item.title === e.target.value);
                    if (item) select(item);
                }
            }
            function onAfterEnter() {
                if (props.eager) vVirtualScrollRef.value?.calculateVisibleItems();
            }
            function onAfterLeave() {
                if (isFocused.value) {
                    if (vMenuRef.value?.contentEl?._clickOutside?.lastMousedownWasOutside) isFocused.value = false;
                    else {
                        isPristine.value = true;
                        vTextFieldRef.value?.focus();
                    }
                }
                _searchLock.value = null;
            }
            function onFocusin(e) {
                isFocused.value = true;
                setTimeout(()=>{
                    listHasFocus.value = true;
                });
            }
            function onFocusout(e) {
                listHasFocus.value = false;
                if (!vTextFieldRef.value?.$el.contains(e.relatedTarget)) {
                    if (repairOrphanedFocus(e)) return;
                    isFocused.value = false;
                }
            }
            function onUpdateModelValue(v) {
                if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
            }
            let mousedownInsideContentAt = 0;
            function onMousedownContent() {
                mousedownInsideContentAt = performance.now();
            }
            function onBlur(e) {
                const next = e.relatedTarget;
                const menuContent = vMenuRef.value?.contentEl;
                if (menuContent?.contains(next) || !next && performance.now() - mousedownInsideContentAt < 10) isFocused.value = true;
            }
            const isSelecting = vue.shallowRef(false);
            /** @param set - null means toggle */ function select(item, set = true) {
                if (!item || item.props.disabled) return;
                if (props.multiple) {
                    const index = model.value.findIndex((selection)=>(props.valueComparator || deepEqual)(selection.value, item.value));
                    const add = set == null ? !~index : set;
                    if (~index) {
                        const value = add ? [
                            ...model.value,
                            item
                        ] : [
                            ...model.value
                        ];
                        value.splice(index, 1);
                        model.value = value;
                    } else if (add) model.value = [
                        ...model.value,
                        item
                    ];
                    if (props.clearOnSelect) search.value = '';
                } else {
                    const add = set !== false;
                    model.value = add ? [
                        item
                    ] : [];
                    _searchLock.value = isPristine.value ? '' : search.value ?? '';
                    search.value = add && !hasSelectionSlot.value ? item.title : '';
                    // watch for search watcher to trigger
                    vue.nextTick(()=>{
                        menu.value = false;
                        isPristine.value = true;
                    });
                }
            }
            vue.watch(isFocused, (val, oldVal)=>{
                if (val === oldVal) return;
                if (val) {
                    isSelecting.value = true;
                    search.value = props.multiple || hasSelectionSlot.value ? '' : String(model.value.at(-1)?.props.title ?? '');
                    isPristine.value = true;
                    vue.nextTick(()=>isSelecting.value = false);
                } else {
                    if (!props.multiple && search.value == null) model.value = [];
                    menu.value = false;
                    if (!isPristine.value && search.value) _searchLock.value = search.value;
                    search.value = '';
                    selectionIndex.value = -1;
                }
            });
            vue.watch(search, (val)=>{
                if (!isFocused.value || isSelecting.value) return;
                if (val) menu.value = true;
                isPristine.value = !val;
            });
            vue.watch(menu, (val)=>{
                if (!props.hideSelected && val && model.value.length && isPristine.value) {
                    const index = displayItems.value.findIndex((item)=>model.value.some((s)=>item.value === s.value));
                    IN_BROWSER && !props.noAutoScroll && window.requestAnimationFrame(()=>{
                        index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
                    });
                }
                if (val) _searchLock.value = null;
            });
            vue.watch(items, (newVal, oldVal)=>{
                if (menu.value) return;
                if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
            });
            useRender(()=>{
                const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
                const isDirty = model.value.length > 0;
                const textFieldProps = VTextField.filterProps(props);
                const menuSlotProps = {
                    search: search,
                    filteredItems: filteredItems.value
                };
                return vue.createVNode(VTextField, vue.mergeProps({
                    "ref": vTextFieldRef
                }, textFieldProps, {
                    "modelValue": search.value,
                    "onUpdate:modelValue": [
                        ($event)=>search.value = $event,
                        onUpdateModelValue
                    ],
                    "focused": isFocused.value,
                    "onUpdate:focused": ($event)=>isFocused.value = $event,
                    "validationValue": model.externalValue,
                    "counterValue": counterValue.value,
                    "dirty": isDirty,
                    "onChange": onChange,
                    "class": [
                        'v-autocomplete',
                        `v-autocomplete--${props.multiple ? 'multiple' : 'single'}`,
                        {
                            'v-autocomplete--active-menu': menu.value,
                            'v-autocomplete--chips': !!props.chips,
                            'v-autocomplete--selection-slot': !!hasSelectionSlot.value,
                            'v-autocomplete--selecting-index': selectionIndex.value > -1
                        },
                        props.class
                    ],
                    "style": props.style,
                    "readonly": form.isReadonly.value,
                    "placeholder": isDirty ? undefined : props.placeholder,
                    "onClick:clear": onClear,
                    "onMousedown:control": onMousedownControl,
                    "onKeydown": onKeydown,
                    "onBlur": onBlur,
                    "aria-expanded": ariaExpanded.value,
                    "aria-controls": ariaControls.value
                }), {
                    ...slots,
                    default: ({ id: id })=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VMenu, vue.mergeProps({
                                "id": menuId.value,
                                "ref": vMenuRef,
                                "modelValue": menu.value,
                                "onUpdate:modelValue": ($event)=>menu.value = $event,
                                "activator": "parent",
                                "disabled": menuDisabled.value,
                                "eager": props.eager,
                                "maxHeight": 310,
                                "openOnClick": false,
                                "closeOnContentClick": false,
                                "onAfterEnter": onAfterEnter,
                                "onAfterLeave": onAfterLeave
                            }, props.menuProps, {
                                "contentClass": [
                                    'v-autocomplete__content',
                                    props.menuProps?.contentClass
                                ]
                            }), {
                                default: ()=>[
                                        vue.createVNode(VSheet, {
                                            "elevation": props.menuElevation,
                                            "onFocusin": onFocusin,
                                            "onKeydown": onMenuKeydown,
                                            "onMousedown": onMousedownContent
                                        }, {
                                            default: ()=>[
                                                    slots['menu-header'] && vue.createElementVNode("header", {
                                                        "ref": headerRef
                                                    }, [
                                                        slots['menu-header'](menuSlotProps)
                                                    ]),
                                                    hasList && vue.createVNode(VList, vue.mergeProps({
                                                        "key": "autocomplete-list",
                                                        "ref": listRef,
                                                        "filterable": true,
                                                        "selected": selectedValues.value,
                                                        "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                                        "onMousedown": (e)=>e.preventDefault(),
                                                        "onFocusout": onFocusout,
                                                        "tabindex": "-1",
                                                        "selectable": !!displayItems.value.length,
                                                        "aria-live": "polite",
                                                        "aria-labelledby": `${id.value}-label`,
                                                        "aria-multiselectable": props.multiple,
                                                        "color": props.itemColor ?? props.color
                                                    }, listEvents, props.listProps), {
                                                        default: ()=>[
                                                                slots['prepend-item']?.(),
                                                                !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? vue.createVNode(VListItem, {
                                                                    "key": "no-data",
                                                                    "title": t(props.noDataText)
                                                                }, null)),
                                                                vue.createVNode(VVirtualScroll, {
                                                                    "ref": vVirtualScrollRef,
                                                                    "renderless": true,
                                                                    "items": displayItems.value,
                                                                    "itemKey": "value"
                                                                }, {
                                                                    default: ({ item: item, index: index, itemRef: itemRef })=>{
                                                                        const camelizedProps = camelizeProps(item.props);
                                                                        const itemProps = vue.mergeProps(item.props, {
                                                                            ref: itemRef,
                                                                            key: item.value,
                                                                            active: highlightFirst.value && item === firstSelectableItem.value ? true : undefined,
                                                                            onClick: ()=>select(item, null),
                                                                            'aria-posinset': index + 1,
                                                                            'aria-setsize': displayItems.value.length
                                                                        });
                                                                        if (item.type === 'divider') return slots.divider?.({
                                                                            props: item.raw,
                                                                            index: index
                                                                        }) ?? vue.createVNode(VDivider, vue.mergeProps(item.props, {
                                                                            "ref": itemRef,
                                                                            "key": `divider-${index}`
                                                                        }), null);
                                                                        if (item.type === 'subheader') return slots.subheader?.({
                                                                            props: item.raw,
                                                                            index: index
                                                                        }) ?? vue.createVNode(VListSubheader, vue.mergeProps(item.props, {
                                                                            "ref": itemRef,
                                                                            "key": `subheader-${index}`
                                                                        }), null);
                                                                        return slots.item?.({
                                                                            item: item.raw,
                                                                            internalItem: item,
                                                                            index: index,
                                                                            props: itemProps
                                                                        }) ?? vue.createVNode(VListItem, vue.mergeProps(itemProps, {
                                                                            "role": "option"
                                                                        }), {
                                                                            prepend: ({ isSelected: isSelected })=>vue.createElementVNode(vue.Fragment, null, [
                                                                                    props.multiple && !props.hideSelected ? vue.createVNode(VCheckboxBtn, {
                                                                                        "key": item.value,
                                                                                        "modelValue": isSelected,
                                                                                        "ripple": false,
                                                                                        "tabindex": "-1",
                                                                                        "aria-hidden": true,
                                                                                        "onClick": (event)=>event.preventDefault()
                                                                                    }, null) : undefined,
                                                                                    camelizedProps.prependAvatar && vue.createVNode(VAvatar, {
                                                                                        "image": camelizedProps.prependAvatar
                                                                                    }, null),
                                                                                    camelizedProps.prependIcon && vue.createVNode(VIcon, {
                                                                                        "icon": camelizedProps.prependIcon
                                                                                    }, null)
                                                                                ]),
                                                                            title: ()=>{
                                                                                return isPristine.value ? item.title : vue.createVNode(VHighlight, {
                                                                                    "text": item.title,
                                                                                    "matches": getMatches(item)?.title,
                                                                                    "markClass": "v-autocomplete__mask",
                                                                                    "matchAll": true,
                                                                                    "ignoreCase": true
                                                                                }, null);
                                                                            }
                                                                        });
                                                                    }
                                                                }),
                                                                slots['append-item']?.()
                                                            ]
                                                    }),
                                                    slots['menu-footer'] && vue.createElementVNode("footer", {
                                                        "ref": footerRef
                                                    }, [
                                                        slots['menu-footer'](menuSlotProps)
                                                    ])
                                                ]
                                        })
                                    ]
                            }),
                            model.value.map((item, index)=>{
                                function onChipClose(e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    select(item, false);
                                }
                                const slotProps = vue.mergeProps(VChip.filterProps(item.props), {
                                    'onClick:close': onChipClose,
                                    onKeydown (e) {
                                        if (e.key !== 'Enter' && e.key !== ' ') return;
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onChipClose(e);
                                    },
                                    onMousedown (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    },
                                    modelValue: true,
                                    'onUpdate:modelValue': undefined
                                });
                                const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                                const slotContent = hasSlot ? ensureValidVNode(hasChips.value ? slots.chip({
                                    item: item.raw,
                                    internalItem: item,
                                    index: index,
                                    props: slotProps
                                }) : slots.selection({
                                    item: item.raw,
                                    internalItem: item,
                                    index: index
                                })) : undefined;
                                if (hasSlot && !slotContent) return undefined;
                                return vue.createElementVNode("div", {
                                    "key": item.value,
                                    "class": vue.normalizeClass([
                                        'v-autocomplete__selection',
                                        index === selectionIndex.value && [
                                            'v-autocomplete__selection--selected',
                                            textColorClasses.value
                                        ]
                                    ]),
                                    "style": vue.normalizeStyle(index === selectionIndex.value ? textColorStyles.value : {})
                                }, [
                                    hasChips.value ? !slots.chip ? vue.createVNode(VChip, vue.mergeProps({
                                        "key": "chip",
                                        "closable": closableChips.value,
                                        "size": "small",
                                        "text": item.title,
                                        "disabled": item.props.disabled
                                    }, slotProps), null) : vue.createVNode(VDefaultsProvider, {
                                        "key": "chip-defaults",
                                        "defaults": {
                                            VChip: {
                                                closable: closableChips.value,
                                                size: 'small',
                                                text: item.title
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slotContent
                                            ]
                                    }) : slotContent ?? vue.createElementVNode("span", {
                                        "class": "v-autocomplete__selection-text"
                                    }, [
                                        item.title,
                                        props.multiple && index < model.value.length - 1 && vue.createElementVNode("span", {
                                            "class": "v-autocomplete__selection-comma"
                                        }, [
                                            vue.createTextVNode(",")
                                        ])
                                    ])
                                ]);
                            })
                        ]),
                    'append-inner': (...args)=>vue.createElementVNode(vue.Fragment, null, [
                            slots['append-inner']?.(...args),
                            props.menuIcon ? vue.createVNode(VIcon, {
                                "class": "v-autocomplete__menu-icon",
                                "color": vTextFieldRef.value?.fieldIconColor,
                                "icon": props.menuIcon,
                                "onMousedown": onMousedownMenuIcon,
                                "onClick": noop,
                                "aria-hidden": true,
                                "tabindex": "-1"
                            }, null) : undefined,
                            props.appendInnerIcon && vue.createVNode(InputIcon, {
                                "key": "append-icon",
                                "name": "appendInner",
                                "color": args[0].iconColor.value
                            }, null)
                        ])
                });
            });
            return forwardRefs({
                isFocused: isFocused,
                isPristine: isPristine,
                menu: menu,
                search: search,
                filteredItems: filteredItems,
                select: select
            }, vTextFieldRef);
        }
    });
    const makeVBannerActionsProps = propsFactory({
        color: String,
        density: String,
        ...makeComponentProps()
    }, 'VBannerActions');
    const VBannerActions = genericComponent()({
        name: 'VBannerActions',
        props: makeVBannerActionsProps(),
        setup (props, { slots: slots }) {
            provideDefaults({
                VBtn: {
                    color: props.color,
                    density: props.density,
                    slim: true,
                    variant: 'text'
                }
            });
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-banner-actions',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, [
                    slots.default?.()
                ]));
            return {};
        }
    });
    // Utilities
    const VBannerText = createSimpleFunctional('v-banner-text');
    // Types
    const makeVBannerProps = propsFactory({
        avatar: String,
        bgColor: String,
        color: String,
        icon: IconValue,
        lines: String,
        stacked: Boolean,
        sticky: Boolean,
        text: String,
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeDimensionProps(),
        ...makeDisplayProps({
            mobile: null
        }),
        ...makeElevationProps(),
        ...makeLocationProps(),
        ...makePositionProps(),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VBanner');
    const VBanner = genericComponent()({
        name: 'VBanner',
        props: makeVBannerProps(),
        setup (props, { slots: slots }) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { borderClasses: borderClasses } = useBorder(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { displayClasses: displayClasses, mobile: mobile } = useDisplay(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { locationStyles: locationStyles } = useLocation(props);
            const { positionClasses: positionClasses } = usePosition(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { themeClasses: themeClasses } = provideTheme(props);
            const color = vue.toRef(()=>props.color);
            const density = vue.toRef(()=>props.density);
            provideDefaults({
                VBannerActions: {
                    color: color,
                    density: density
                }
            });
            useRender(()=>{
                const hasText = !!(props.text || slots.text);
                const hasPrependMedia = !!(props.avatar || props.icon);
                const hasPrepend = !!(hasPrependMedia || slots.prepend);
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-banner',
                        {
                            'v-banner--stacked': props.stacked || mobile.value,
                            'v-banner--sticky': props.sticky,
                            [`v-banner--${props.lines}-line`]: !!props.lines
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        densityClasses.value,
                        displayClasses.value,
                        elevationClasses.value,
                        positionClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        dimensionStyles.value,
                        locationStyles.value,
                        roundedStyles.value,
                        props.style
                    ]),
                    "role": "banner"
                }, {
                    default: ()=>[
                            hasPrepend && vue.createElementVNode("div", {
                                "key": "prepend",
                                "class": "v-banner__prepend"
                            }, [
                                !slots.prepend ? vue.createVNode(VAvatar, {
                                    "key": "prepend-avatar",
                                    "color": color.value,
                                    "density": density.value,
                                    "icon": props.icon,
                                    "image": props.avatar
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "prepend-defaults",
                                    "disabled": !hasPrependMedia,
                                    "defaults": {
                                        VAvatar: {
                                            color: color.value,
                                            density: density.value,
                                            icon: props.icon,
                                            image: props.avatar
                                        }
                                    }
                                }, slots.prepend)
                            ]),
                            vue.createElementVNode("div", {
                                "class": "v-banner__content"
                            }, [
                                hasText && vue.createVNode(VBannerText, {
                                    "key": "text"
                                }, {
                                    default: ()=>[
                                            slots.text?.() ?? props.text
                                        ]
                                }),
                                slots.default?.()
                            ]),
                            slots.actions && vue.createVNode(VBannerActions, {
                                "key": "actions"
                            }, slots.actions)
                        ]
                });
            });
        }
    });
    // Types
    const makeVBottomNavigationProps = propsFactory({
        baseColor: String,
        bgColor: String,
        color: String,
        grow: Boolean,
        mode: {
            type: String,
            validator: (v)=>!v || [
                    'horizontal',
                    'shift'
                ].includes(v)
        },
        height: {
            type: [
                Number,
                String
            ],
            default: 56
        },
        active: {
            type: Boolean,
            default: true
        },
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeElevationProps(),
        ...makeRoundedProps(),
        ...makeLayoutItemProps({
            name: 'bottom-navigation'
        }),
        ...makeTagProps({
            tag: 'header'
        }),
        ...makeGroupProps({
            selectedClass: 'v-btn--selected'
        }),
        ...makeThemeProps()
    }, 'VBottomNavigation');
    const VBottomNavigation = genericComponent()({
        name: 'VBottomNavigation',
        props: makeVBottomNavigationProps(),
        emits: {
            'update:active': (value)=>true,
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = useTheme();
            const { borderClasses: borderClasses } = useBorder(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { densityClasses: densityClasses } = useDensity(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { ssrBootStyles: ssrBootStyles } = useSsrBoot();
            const height = vue.computed(()=>Number(props.height) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0));
            const isActive = useProxiedModel(props, 'active', props.active);
            const { layoutItemStyles: layoutItemStyles } = useLayoutItem({
                id: props.name,
                order: vue.computed(()=>parseInt(props.order, 10)),
                position: vue.toRef(()=>'bottom'),
                layoutSize: vue.toRef(()=>isActive.value ? height.value : 0),
                elementSize: height,
                active: isActive,
                absolute: vue.toRef(()=>props.absolute)
            });
            useGroup(props, VBtnToggleSymbol);
            provideDefaults({
                VBtn: {
                    baseColor: vue.toRef(()=>props.baseColor),
                    color: vue.toRef(()=>props.color),
                    density: vue.toRef(()=>props.density),
                    stacked: vue.toRef(()=>props.mode !== 'horizontal'),
                    variant: 'text'
                }
            }, {
                scoped: true
            });
            useRender(()=>{
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-bottom-navigation',
                        {
                            'v-bottom-navigation--active': isActive.value,
                            'v-bottom-navigation--grow': props.grow,
                            'v-bottom-navigation--shift': props.mode === 'shift'
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        layoutItemStyles.value,
                        {
                            height: convertToUnit(height.value)
                        },
                        ssrBootStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            slots.default && vue.createElementVNode("div", {
                                "class": "v-bottom-navigation__content"
                            }, [
                                slots.default()
                            ])
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVDialogProps = propsFactory({
        fullscreen: Boolean,
        scrollable: Boolean,
        ...omit(makeVOverlayProps({
            captureFocus: true,
            location: 'center center',
            origin: 'center center',
            scrollStrategy: 'block',
            transition: {
                component: VDialogTransition
            },
            zIndex: 2400,
            retainFocus: true
        }), [
            'disableInitialFocus'
        ])
    }, 'VDialog');
    const VDialog = genericComponent()({
        name: 'VDialog',
        props: makeVDialogProps(),
        emits: {
            'update:modelValue': (value)=>true,
            afterEnter: ()=>true,
            afterLeave: ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const isActive = useProxiedModel(props, 'modelValue');
            const { scopeId: scopeId } = useScopeId();
            const overlay = vue.ref();
            function onAfterEnter() {
                emit('afterEnter');
                if ((props.scrim || props.retainFocus) && overlay.value?.contentEl && !overlay.value.contentEl.contains(getActiveElement())) overlay.value.contentEl.focus({
                    preventScroll: true
                });
            }
            function onAfterLeave() {
                emit('afterLeave');
            }
            vue.watch(isActive, async (val)=>{
                if (!val) {
                    await vue.nextTick();
                    overlay.value?.activatorEl?.focus({
                        preventScroll: true
                    });
                }
            });
            useRender(()=>{
                const overlayProps = VOverlay.filterProps(props);
                const activatorProps = vue.mergeProps({
                    'aria-haspopup': 'dialog'
                }, props.activatorProps);
                const contentProps = vue.mergeProps({
                    tabindex: -1
                }, props.contentProps);
                const locationStrategy = props.fullscreen ? noop : props.locationStrategy;
                return vue.createVNode(VOverlay, vue.mergeProps({
                    "ref": overlay,
                    "class": [
                        'v-dialog',
                        {
                            'v-dialog--fullscreen': props.fullscreen,
                            'v-dialog--scrollable': props.scrollable
                        },
                        props.class
                    ],
                    "style": props.style
                }, overlayProps, {
                    "modelValue": isActive.value,
                    "onUpdate:modelValue": ($event)=>isActive.value = $event,
                    "aria-modal": "true",
                    "activatorProps": activatorProps,
                    "contentProps": contentProps,
                    "height": !props.fullscreen ? props.height : undefined,
                    "width": !props.fullscreen ? props.width : undefined,
                    "maxHeight": !props.fullscreen ? props.maxHeight : undefined,
                    "maxWidth": !props.fullscreen ? props.maxWidth : undefined,
                    "locationStrategy": locationStrategy,
                    "role": "dialog",
                    "onAfterEnter": onAfterEnter,
                    "onAfterLeave": onAfterLeave
                }, scopeId), {
                    activator: slots.activator,
                    default: (...args)=>vue.createVNode(VDefaultsProvider, {
                            "root": "VDialog"
                        }, {
                            default: ()=>[
                                    slots.default?.(...args)
                                ]
                        })
                });
            });
            return forwardRefs({}, overlay);
        }
    });
    // Types
    const makeVBottomSheetProps = propsFactory({
        inset: Boolean,
        ...makeVDialogProps({
            transition: 'bottom-sheet-transition',
            location: 'bottom center',
            origin: 'bottom center',
            viewportMargin: 0
        })
    }, 'VBottomSheet');
    const VBottomSheet = genericComponent()({
        name: 'VBottomSheet',
        props: makeVBottomSheetProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const isActive = useProxiedModel(props, 'modelValue');
            useRender(()=>{
                const dialogProps = VDialog.filterProps(props);
                return vue.createVNode(VDialog, vue.mergeProps(dialogProps, {
                    "contentClass": [
                        'v-bottom-sheet__content',
                        props.contentClass
                    ],
                    "modelValue": isActive.value,
                    "onUpdate:modelValue": ($event)=>isActive.value = $event,
                    "class": [
                        'v-bottom-sheet',
                        {
                            'v-bottom-sheet--inset': props.inset
                        },
                        props.class
                    ],
                    "style": props.style
                }), slots);
            });
            return {};
        }
    });
    const makeVBreadcrumbsDividerProps = propsFactory({
        divider: [
            Number,
            String
        ],
        ...makeComponentProps()
    }, 'VBreadcrumbsDivider');
    const VBreadcrumbsDivider = genericComponent()({
        name: 'VBreadcrumbsDivider',
        props: makeVBreadcrumbsDividerProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createElementVNode("li", {
                    "aria-hidden": "true",
                    "class": vue.normalizeClass([
                        'v-breadcrumbs-divider',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, [
                    slots?.default?.() ?? props.divider
                ]));
            return {};
        }
    });
    const makeVBreadcrumbsItemProps = propsFactory({
        active: Boolean,
        activeClass: String,
        activeColor: String,
        color: String,
        disabled: Boolean,
        title: String,
        ...makeComponentProps(),
        ...pick(makeDimensionProps(), [
            'width',
            'maxWidth'
        ]),
        ...makeRouterProps(),
        ...makeTagProps({
            tag: 'li'
        })
    }, 'VBreadcrumbsItem');
    const VBreadcrumbsItem = genericComponent()({
        name: 'VBreadcrumbsItem',
        props: makeVBreadcrumbsItemProps(),
        setup (props, { slots: slots, attrs: attrs }) {
            const link = useLink(props, attrs);
            const isActive = vue.computed(()=>props.active || link.isActive?.value);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>isActive.value ? props.activeColor : props.color);
            useRender(()=>{
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-breadcrumbs-item',
                        {
                            'v-breadcrumbs-item--active': isActive.value,
                            'v-breadcrumbs-item--disabled': props.disabled,
                            [`${props.activeClass}`]: isActive.value && props.activeClass
                        },
                        textColorClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        textColorStyles.value,
                        dimensionStyles.value,
                        props.style
                    ]),
                    "aria-current": isActive.value ? 'page' : undefined
                }, {
                    default: ()=>[
                            !link.isLink.value ? slots.default?.() ?? props.title : vue.createElementVNode("a", vue.mergeProps({
                                "class": "v-breadcrumbs-item--link",
                                "onClick": link.navigate.value
                            }, link.linkProps), [
                                slots.default?.() ?? props.title
                            ])
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVBreadcrumbsProps = propsFactory({
        activeClass: String,
        activeColor: String,
        bgColor: String,
        color: String,
        disabled: Boolean,
        divider: {
            type: String,
            default: '/'
        },
        icon: IconValue,
        items: {
            type: Array,
            default: ()=>[]
        },
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeRoundedProps(),
        ...makeTagProps({
            tag: 'ul'
        })
    }, 'VBreadcrumbs');
    const VBreadcrumbs = genericComponent()({
        name: 'VBreadcrumbs',
        props: makeVBreadcrumbsProps(),
        setup (props, { slots: slots }) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { densityClasses: densityClasses } = useDensity(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            provideDefaults({
                VBreadcrumbsDivider: {
                    divider: vue.toRef(()=>props.divider)
                },
                VBreadcrumbsItem: {
                    activeClass: vue.toRef(()=>props.activeClass),
                    activeColor: vue.toRef(()=>props.activeColor),
                    color: vue.toRef(()=>props.color),
                    disabled: vue.toRef(()=>props.disabled)
                }
            });
            const items = vue.computed(()=>props.items.map((item)=>{
                    return typeof item === 'string' ? {
                        item: {
                            title: item
                        },
                        raw: item
                    } : {
                        item: item,
                        raw: item
                    };
                }));
            useRender(()=>{
                const hasPrepend = !!(slots.prepend || props.icon);
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-breadcrumbs',
                        backgroundColorClasses.value,
                        densityClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            hasPrepend && vue.createElementVNode("li", {
                                "key": "prepend",
                                "class": "v-breadcrumbs__prepend"
                            }, [
                                !slots.prepend ? vue.createVNode(VIcon, {
                                    "key": "prepend-icon",
                                    "start": true,
                                    "icon": props.icon
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "prepend-defaults",
                                    "disabled": !props.icon,
                                    "defaults": {
                                        VIcon: {
                                            icon: props.icon,
                                            start: true
                                        }
                                    }
                                }, slots.prepend)
                            ]),
                            items.value.map(({ item: item, raw: raw }, index, array)=>vue.createElementVNode(vue.Fragment, null, [
                                    slots.item?.({
                                        item: item,
                                        index: index
                                    }) ?? vue.createVNode(VBreadcrumbsItem, vue.mergeProps({
                                        "key": index,
                                        "disabled": index >= array.length - 1
                                    }, typeof item === 'string' ? {
                                        title: item
                                    } : item), {
                                        default: slots.title ? ()=>slots.title?.({
                                                item: item,
                                                index: index
                                            }) : undefined
                                    }),
                                    index < array.length - 1 && vue.createVNode(VBreadcrumbsDivider, null, {
                                        default: slots.divider ? ()=>slots.divider?.({
                                                item: raw,
                                                index: index
                                            }) : undefined
                                    })
                                ])),
                            slots.default?.()
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVIconBtnProps = propsFactory({
        active: {
            type: Boolean,
            default: undefined
        },
        activeColor: String,
        activeIcon: [
            String,
            Function,
            Object
        ],
        activeVariant: String,
        baseVariant: {
            type: String,
            default: 'tonal'
        },
        disabled: Boolean,
        height: [
            Number,
            String
        ],
        width: [
            Number,
            String
        ],
        hideOverlay: Boolean,
        icon: [
            String,
            Function,
            Object
        ],
        iconColor: String,
        loading: Boolean,
        opacity: [
            Number,
            String
        ],
        readonly: Boolean,
        rotate: [
            Number,
            String
        ],
        size: {
            type: [
                Number,
                String
            ],
            default: 'default'
        },
        sizes: {
            type: Array,
            default: ()=>[
                    [
                        'x-small',
                        16
                    ],
                    [
                        'small',
                        24
                    ],
                    [
                        'default',
                        40
                    ],
                    [
                        'large',
                        48
                    ],
                    [
                        'x-large',
                        56
                    ]
                ]
        },
        text: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeElevationProps(),
        ...makeIconSizeProps(),
        ...makeRoundedProps(),
        ...makeTagProps({
            tag: 'button'
        }),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'flat'
        })
    }, 'VIconBtn');
    const VIconBtn = genericComponent()({
        name: 'VIconBtn',
        props: makeVIconBtnProps(),
        emits: {
            'update:active': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const isActive = useProxiedModel(props, 'active');
            const { themeClasses: themeClasses } = provideTheme(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(()=>({
                    color: (()=>{
                        if (props.disabled) return undefined;
                        if (!isActive.value) return props.color;
                        // Use an inline fallback as opposed to setting a default color
                        // because non-toggle buttons are default flat whereas toggle
                        // buttons are default tonal and active flat. The exact use
                        // case for this is a toggle button with no active color.
                        return props.activeColor ?? props.color ?? 'surface-variant';
                    })(),
                    variant: (()=>{
                        if (isActive.value === undefined) return props.variant;
                        if (isActive.value) return props.activeVariant ?? props.variant;
                        return props.baseVariant ?? props.variant;
                    })()
                }));
            const btnSizeMap = new Map(props.sizes);
            function onClick() {
                if (props.disabled || props.readonly || isActive.value === undefined || props.tag === 'a' && attrs.href) return;
                isActive.value = !isActive.value;
            }
            useRender(()=>{
                const icon = isActive.value ? props.activeIcon ?? props.icon : props.icon;
                const _btnSize = props.size;
                const hasNamedSize = btnSizeMap.has(_btnSize);
                const btnSize = hasNamedSize ? btnSizeMap.get(_btnSize) : _btnSize;
                const btnHeight = props.height ?? btnSize;
                const btnWidth = props.width ?? btnSize;
                const { iconSize: iconSize } = useIconSizes(props, ()=>new Map(props.iconSizes).get(_btnSize));
                const iconProps = {
                    icon: icon,
                    size: iconSize.value,
                    color: props.iconColor,
                    opacity: props.opacity
                };
                return vue.createVNode(props.tag, {
                    "type": props.tag === 'button' ? 'button' : undefined,
                    "class": vue.normalizeClass([
                        {
                            'v-icon-btn': true,
                            'v-icon-btn--active': isActive.value,
                            'v-icon-btn--disabled': props.disabled,
                            'v-icon-btn--loading': props.loading,
                            'v-icon-btn--readonly': props.readonly,
                            [`v-icon-btn--${props.size}`]: true
                        },
                        themeClasses.value,
                        colorClasses.value,
                        borderClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        variantClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-icon-btn-rotate': convertToUnit(props.rotate, 'deg'),
                            '--v-icon-btn-height': convertToUnit(btnHeight),
                            '--v-icon-btn-width': convertToUnit(btnWidth)
                        },
                        colorStyles.value,
                        roundedStyles.value,
                        props.style
                    ]),
                    "tabindex": props.disabled || props.readonly ? -1 : 0,
                    "onClick": onClick
                }, {
                    default: ()=>[
                            genOverlays(!props.hideOverlay, 'v-icon-btn'),
                            vue.createElementVNode("div", {
                                "class": "v-icon-btn__content",
                                "data-no-activator": ""
                            }, [
                                !slots.default && icon ? vue.createVNode(VIcon, vue.mergeProps({
                                    "key": "content-icon"
                                }, iconProps), null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "content-defaults",
                                    "disabled": !icon,
                                    "defaults": {
                                        VIcon: {
                                            ...iconProps
                                        }
                                    }
                                }, {
                                    default: ()=>slots.default?.() ?? vue.toDisplayString(props.text)
                                })
                            ]),
                            !!props.loading && vue.createElementVNode("span", {
                                "key": "loader",
                                "class": "v-icon-btn__loader"
                            }, [
                                slots.loader?.() ?? vue.createVNode(VProgressCircular, {
                                    "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                    "indeterminate": "disable-shrink",
                                    "width": "2",
                                    "size": iconSize.value
                                }, null)
                            ])
                        ]
                });
            });
            return {};
        }
    });
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    // Types
    const PARSE_REGEX = /^(\d{4})-(\d{1,2})(-(\d{1,2}))?([^\d]+(\d{1,2}))?(:(\d{1,2}))?(:(\d{1,2}))?$/;
    const PARSE_TIME = /(\d\d?)(:(\d\d?)|)(:(\d\d?)|)/;
    const DAYS_IN_MONTH = [
        0,
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    const DAYS_IN_MONTH_LEAP = [
        0,
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    const DAYS_IN_MONTH_MIN = 28;
    const DAYS_IN_MONTH_MAX = 31;
    const MONTH_MAX = 12;
    const MONTH_MIN = 1;
    const DAY_MIN = 1;
    const DAYS_IN_WEEK = 7;
    const MINUTES_IN_HOUR = 60;
    const MINUTE_MAX = 59;
    const MINUTES_IN_DAY = 1440;
    const HOURS_IN_DAY = 24;
    const HOUR_MAX = 23;
    const FIRST_HOUR = 0;
    const OFFSET_YEAR = 10000;
    const OFFSET_MONTH = 100;
    const OFFSET_HOUR = 100;
    const OFFSET_TIME = 10000;
    function getStartOfWeek(timestamp, weekdays, today) {
        const start = copyTimestamp(timestamp);
        findWeekday(start, weekdays[0], prevDay);
        updateFormatted(start);
        if (today) updateRelative(start, today, start.hasTime);
        return start;
    }
    function getEndOfWeek(timestamp, weekdays, today) {
        const end = copyTimestamp(timestamp);
        findWeekday(end, weekdays[weekdays.length - 1]);
        updateFormatted(end);
        if (today) updateRelative(end, today, end.hasTime);
        return end;
    }
    function getStartOfMonth(timestamp) {
        const start = copyTimestamp(timestamp);
        start.day = DAY_MIN;
        updateWeekday(start);
        updateFormatted(start);
        return start;
    }
    function getEndOfMonth(timestamp) {
        const end = copyTimestamp(timestamp);
        end.day = daysInMonth(end.year, end.month);
        updateWeekday(end);
        updateFormatted(end);
        return end;
    }
    function validateNumber(input) {
        return isFinite(parseInt(input));
    }
    function validateTime(input) {
        return typeof input === 'number' && isFinite(input) || !!PARSE_TIME.exec(input) || typeof input === 'object' && isFinite(input.hour) && isFinite(input.minute);
    }
    function parseTime(input) {
        if (typeof input === 'number') // when a number is given, it's minutes since 12:00am
        return input;
        else if (typeof input === 'string') {
            // when a string is given, it's a hh:mm:ss format where seconds are optional
            const parts = PARSE_TIME.exec(input);
            if (!parts) return false;
            return parseInt(parts[1]) * 60 + parseInt(parts[3] || 0);
        } else if (typeof input === 'object') {
            // when an object is given, it must have hour and minute
            if (typeof input.hour !== 'number' || typeof input.minute !== 'number') return false;
            return input.hour * 60 + input.minute;
        } else // unsupported type
        return false;
    }
    function validateTimestamp(input) {
        return typeof input === 'number' && isFinite(input) || typeof input === 'string' && !!PARSE_REGEX.exec(input) || input instanceof Date;
    }
    function parseTimestamp(input, required = false, now) {
        if (typeof input === 'number' && isFinite(input)) input = new Date(input);
        if (input instanceof Date) {
            const date = parseDate(input);
            return date;
        }
        if (typeof input !== 'string') {
            if (required) throw new Error(`${input} is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.`);
            return null;
        }
        // YYYY-MM-DD hh:mm:ss
        const parts = PARSE_REGEX.exec(input);
        if (!parts) {
            if (required) throw new Error(`${input} is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.`);
            return null;
        }
        const timestamp = {
            date: input,
            time: '',
            year: parseInt(parts[1]),
            month: parseInt(parts[2]),
            day: parseInt(parts[4]) || 1,
            hour: parseInt(parts[6]) || 0,
            minute: parseInt(parts[8]) || 0,
            weekday: 0,
            hasDay: !!parts[4],
            hasTime: !!(parts[6] && parts[8]),
            past: false,
            present: false,
            future: false
        };
        updateWeekday(timestamp);
        updateFormatted(timestamp);
        return timestamp;
    }
    function parseDate(date) {
        return updateFormatted({
            date: '',
            time: '',
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            weekday: date.getDay(),
            hour: date.getHours(),
            minute: date.getMinutes(),
            hasDay: true,
            hasTime: true,
            past: false,
            present: true,
            future: false
        });
    }
    function getDayIdentifier(timestamp) {
        return timestamp.year * OFFSET_YEAR + timestamp.month * OFFSET_MONTH + timestamp.day;
    }
    function getTimeIdentifier(timestamp) {
        return timestamp.hour * OFFSET_HOUR + timestamp.minute;
    }
    function getTimestampIdentifier(timestamp) {
        return getDayIdentifier(timestamp) * OFFSET_TIME + getTimeIdentifier(timestamp);
    }
    function updateRelative(timestamp, now, time = false) {
        let a = getDayIdentifier(now);
        let b = getDayIdentifier(timestamp);
        let present = a === b;
        if (timestamp.hasTime && time && present) {
            a = getTimeIdentifier(now);
            b = getTimeIdentifier(timestamp);
            present = a === b;
        }
        timestamp.past = b < a;
        timestamp.present = present;
        timestamp.future = b > a;
        return timestamp;
    }
    function isTimedless(input) {
        return input instanceof Date || typeof input === 'number' && isFinite(input);
    }
    function updateHasTime(timestamp, hasTime, now) {
        if (timestamp.hasTime !== hasTime) {
            timestamp.hasTime = hasTime;
            if (!hasTime) {
                timestamp.hour = HOUR_MAX;
                timestamp.minute = MINUTE_MAX;
                timestamp.time = getTime(timestamp);
            }
        }
        return timestamp;
    }
    function updateMinutes(timestamp, minutes, now) {
        timestamp.hasTime = true;
        timestamp.hour = 0;
        timestamp.minute = 0;
        nextMinutes(timestamp, minutes);
        updateFormatted(timestamp);
        if (now) updateRelative(timestamp, now, true);
        return timestamp;
    }
    function updateWeekday(timestamp) {
        timestamp.weekday = getWeekday(timestamp);
        return timestamp;
    }
    function updateFormatted(timestamp) {
        timestamp.time = getTime(timestamp);
        timestamp.date = getDate$1(timestamp);
        return timestamp;
    }
    function getWeekday(timestamp) {
        if (timestamp.hasDay) {
            const _ = Math.floor;
            const k = timestamp.day;
            const m = (timestamp.month + 9) % MONTH_MAX + 1;
            const C = _(timestamp.year / 100);
            const Y = timestamp.year % 100 - (timestamp.month <= 2 ? 1 : 0);
            return ((k + _(2.6 * m - 0.2) - 2 * C + Y + _(Y / 4) + _(C / 4)) % 7 + 7) % 7;
        }
        return timestamp.weekday;
    }
    function daysInMonth(year, month) {
        return isLeapYear(year) ? DAYS_IN_MONTH_LEAP[month] : DAYS_IN_MONTH[month];
    }
    function copyTimestamp(timestamp) {
        if (timestamp == null) return null;
        const { date: date, time: time, year: year, month: month, day: day, weekday: weekday, hour: hour, minute: minute, hasDay: hasDay, hasTime: hasTime, past: past, present: present, future: future } = timestamp;
        return {
            date: date,
            time: time,
            year: year,
            month: month,
            day: day,
            weekday: weekday,
            hour: hour,
            minute: minute,
            hasDay: hasDay,
            hasTime: hasTime,
            past: past,
            present: present,
            future: future
        };
    }
    function padNumber(x, length) {
        let padded = String(x);
        while(padded.length < length)padded = '0' + padded;
        return padded;
    }
    function getDate$1(timestamp) {
        let str = `${padNumber(timestamp.year, 4)}-${padNumber(timestamp.month, 2)}`;
        if (timestamp.hasDay) str += `-${padNumber(timestamp.day, 2)}`;
        return str;
    }
    function getTime(timestamp) {
        if (!timestamp.hasTime) return '';
        return `${padNumber(timestamp.hour, 2)}:${padNumber(timestamp.minute, 2)}`;
    }
    function nextMinutes(timestamp, minutes) {
        timestamp.minute += minutes;
        while(timestamp.minute >= MINUTES_IN_HOUR){
            timestamp.minute -= MINUTES_IN_HOUR;
            timestamp.hour++;
            if (timestamp.hour >= HOURS_IN_DAY) {
                nextDay(timestamp);
                timestamp.hour = FIRST_HOUR;
            }
        }
        return timestamp;
    }
    function nextDay(timestamp) {
        timestamp.day++;
        timestamp.weekday = (timestamp.weekday + 1) % DAYS_IN_WEEK;
        if (timestamp.day > DAYS_IN_MONTH_MIN && timestamp.day > daysInMonth(timestamp.year, timestamp.month)) {
            timestamp.day = DAY_MIN;
            timestamp.month++;
            if (timestamp.month > MONTH_MAX) {
                timestamp.month = MONTH_MIN;
                timestamp.year++;
            }
        }
        return timestamp;
    }
    function prevDay(timestamp) {
        timestamp.day--;
        timestamp.weekday = (timestamp.weekday + 6) % DAYS_IN_WEEK;
        if (timestamp.day < DAY_MIN) {
            timestamp.month--;
            if (timestamp.month < MONTH_MIN) {
                timestamp.year--;
                timestamp.month = MONTH_MAX;
            }
            timestamp.day = daysInMonth(timestamp.year, timestamp.month);
        }
        return timestamp;
    }
    function relativeDays(timestamp, mover = nextDay, days = 1) {
        while(--days >= 0)mover(timestamp);
        return timestamp;
    }
    function diffMinutes(min, max) {
        const Y = (max.year - min.year) * 525600;
        const M = (max.month - min.month) * 43800;
        const D = (max.day - min.day) * 1440;
        const h = (max.hour - min.hour) * 60;
        const m = max.minute - min.minute;
        return Y + M + D + h + m;
    }
    function findWeekday(timestamp, weekday, mover = nextDay, maxDays = 6) {
        while(timestamp.weekday !== weekday && --maxDays >= 0)mover(timestamp);
        return timestamp;
    }
    function getWeekdaySkips(weekdays) {
        const skips = [
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ];
        const filled = [
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(let i = 0; i < weekdays.length; i++)filled[weekdays[i]] = 1;
        for(let k = 0; k < DAYS_IN_WEEK; k++){
            let skip = 1;
            for(let j = 1; j < DAYS_IN_WEEK; j++){
                const next = (k + j) % DAYS_IN_WEEK;
                if (filled[next]) break;
                skip++;
            }
            skips[k] = filled[k] * skip;
        }
        return skips;
    }
    function timestampToDate(timestamp) {
        const time = `${padNumber(timestamp.hour, 2)}:${padNumber(timestamp.minute, 2)}`;
        const date = timestamp.date;
        return new Date(`${date}T${time}:00+00:00`);
    }
    function createDayList(start, end, now, weekdaySkips, max = 42, min = 0) {
        const stop = getDayIdentifier(end);
        const days = [];
        let current = copyTimestamp(start);
        let currentIdentifier = 0;
        let stopped = currentIdentifier === stop;
        if (stop < getDayIdentifier(start)) throw new Error('End date is earlier than start date.');
        while((!stopped || days.length < min) && days.length < max){
            currentIdentifier = getDayIdentifier(current);
            stopped = stopped || currentIdentifier === stop;
            if (weekdaySkips[current.weekday] === 0) {
                current = nextDay(current);
                continue;
            }
            const day = copyTimestamp(current);
            updateFormatted(day);
            updateRelative(day, now);
            days.push(day);
            current = relativeDays(current, nextDay, weekdaySkips[current.weekday]);
        }
        if (!days.length) throw new Error('No dates found using specified start date, end date, and weekdays.');
        return days;
    }
    function createIntervalList(timestamp, first, minutes, count, now) {
        const intervals = [];
        for(let i = 0; i < count; i++){
            const mins = first + i * minutes;
            const int = copyTimestamp(timestamp);
            intervals.push(updateMinutes(int, mins, now));
        }
        return intervals;
    }
    function createNativeLocaleFormatter(locale, getOptions) {
        const emptyFormatter = (_t, _s)=>'';
        if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat === 'undefined') return emptyFormatter;
        return (timestamp, short)=>{
            try {
                const intlFormatter = new Intl.DateTimeFormat(locale || undefined, getOptions(timestamp, short));
                return intlFormatter.format(timestampToDate(timestamp));
            } catch (e) {
                return '';
            }
        };
    }
    function validateWeekdays(input) {
        if (typeof input === 'string') input = input.split(',');
        if (Array.isArray(input)) {
            const ints = input.map((x)=>parseInt(x));
            if (ints.length > DAYS_IN_WEEK || ints.length === 0) return false;
            const visited = {};
            let wrapped = false;
            for(let i = 0; i < ints.length; i++){
                const x = ints[i];
                if (!isFinite(x) || x < 0 || x >= DAYS_IN_WEEK) return false;
                if (i > 0) {
                    const d = x - ints[i - 1];
                    if (d < 0) {
                        if (wrapped) return false;
                        wrapped = true;
                    } else if (d === 0) return false;
                }
                if (visited[x]) return false;
                visited[x] = true;
            }
            return true;
        }
        return false;
    }
    // Utilities
    // Types
    function useTimes(props) {
        const times = vue.reactive({
            now: parseTimestamp('0000-00-00 00:00', true),
            today: parseTimestamp('0000-00-00', true)
        });
        const parsedNow = vue.computed(()=>{
            return props.now && validateTimestamp(props.now) ? parseTimestamp(props.now, true) : null;
        });
        function setPresent() {
            times.now.present = times.today.present = true;
            times.now.past = times.today.past = false;
            times.now.future = times.today.future = false;
        }
        function getNow() {
            return parseDate(new Date());
        }
        function updateDay(now, target) {
            if (now.date !== target.date) {
                target.year = now.year;
                target.month = now.month;
                target.day = now.day;
                target.weekday = now.weekday;
                target.date = now.date;
            }
        }
        function updateTime(now, target) {
            if (now.time !== target.time) {
                target.hour = now.hour;
                target.minute = now.minute;
                target.time = now.time;
            }
        }
        function updateTimes() {
            const now = parsedNow.value || getNow();
            updateDay(now, times.now);
            updateTime(now, times.now);
            updateDay(now, times.today);
        }
        vue.watch(parsedNow, updateTimes);
        updateTimes();
        setPresent();
        return {
            times: times,
            parsedNow: parsedNow,
            updateTimes: updateTimes,
            setPresent: setPresent,
            getNow: getNow,
            updateDay: updateDay,
            updateTime: updateTime
        };
    }
    // Utilities
    // Types
    function weekInfo(locale) {
        // https://simplelocalize.io/data/locales/
        // then `new Intl.Locale(...).getWeekInfo()`
        const code = locale.slice(-2).toUpperCase();
        switch(true){
            case locale === 'GB-alt-variant':
                return {
                    firstDay: 0,
                    firstWeekSize: 4
                };
            case locale === '001':
                return {
                    firstDay: 1,
                    firstWeekSize: 1
                };
            case `AG AS BD BR BS BT BW BZ CA CO DM DO ET GT GU HK HN ID IL IN JM JP KE
    KH KR LA MH MM MO MT MX MZ NI NP PA PE PH PK PR PY SA SG SV TH TT TW UM US
    VE VI WS YE ZA ZW`.includes(code):
                return {
                    firstDay: 0,
                    firstWeekSize: 1
                };
            case `AI AL AM AR AU AZ BA BM BN BY CL CM CN CR CY EC GE HR KG KZ LB LK LV
    MD ME MK MN MY NZ RO RS SI TJ TM TR UA UY UZ VN XK`.includes(code):
                return {
                    firstDay: 1,
                    firstWeekSize: 1
                };
            case `AD AN AT AX BE BG CH CZ DE DK EE ES FI FJ FO FR GB GF GP GR HU IE IS
    IT LI LT LU MC MQ NL NO PL RE RU SE SK SM VA`.includes(code):
                return {
                    firstDay: 1,
                    firstWeekSize: 4
                };
            case `AE AF BH DJ DZ EG IQ IR JO KW LY OM QA SD SY`.includes(code):
                return {
                    firstDay: 6,
                    firstWeekSize: 1
                };
            case code === 'MV':
                return {
                    firstDay: 5,
                    firstWeekSize: 1
                };
            case code === 'PT':
                return {
                    firstDay: 0,
                    firstWeekSize: 4
                };
            default:
                return null;
        }
    }
    function getWeekArray(date, locale, firstDayOfWeek) {
        const weeks = [];
        let currentWeek = [];
        const firstDayOfMonth = startOfMonth(date);
        const lastDayOfMonth = endOfMonth(date);
        const first = firstDayOfWeek ?? weekInfo(locale)?.firstDay ?? 0;
        const firstDayWeekIndex = (firstDayOfMonth.getDay() - first + 7) % 7;
        const lastDayWeekIndex = (lastDayOfMonth.getDay() - first + 7) % 7;
        for(let i = 0; i < firstDayWeekIndex; i++){
            const adjacentDay = new Date(firstDayOfMonth);
            adjacentDay.setDate(adjacentDay.getDate() - (firstDayWeekIndex - i));
            currentWeek.push(adjacentDay);
        }
        for(let i = 1; i <= lastDayOfMonth.getDate(); i++){
            const day = new Date(date.getFullYear(), date.getMonth(), i);
            // Add the day to the current week
            currentWeek.push(day);
            // If the current week has 7 days, add it to the weeks array and start a new week
            if (currentWeek.length === 7) {
                weeks.push(currentWeek);
                currentWeek = [];
            }
        }
        for(let i = 1; i < 7 - lastDayWeekIndex; i++){
            const adjacentDay = new Date(lastDayOfMonth);
            adjacentDay.setDate(adjacentDay.getDate() + i);
            currentWeek.push(adjacentDay);
        }
        if (currentWeek.length > 0) weeks.push(currentWeek);
        return weeks;
    }
    function startOfWeek(date, locale, firstDayOfWeek) {
        let day = (firstDayOfWeek ?? weekInfo(locale)?.firstDay ?? 0) % 7;
        // prevent infinite loop
        if (![
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ].includes(day)) {
            consoleWarn('Invalid firstDayOfWeek, expected discrete number in range [0-6]');
            day = 0;
        }
        const d = new Date(date);
        while(d.getDay() !== day)d.setDate(d.getDate() - 1);
        return d;
    }
    function endOfWeek(date, locale) {
        const d = new Date(date);
        const lastDay = ((weekInfo(locale)?.firstDay ?? 0) + 6) % 7;
        while(d.getDay() !== lastDay)d.setDate(d.getDate() + 1);
        return d;
    }
    function startOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }
    function endOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
    function parseLocalDate(value) {
        const parts = value.split('-').map(Number);
        // new Date() uses local time zone when passing individual date component values
        return new Date(parts[0], parts[1] - 1, parts[2]);
    }
    const _YYYMMDD = /^([12]\d{3}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12]\d|3[01]))$/;
    function date(value) {
        if (value == null) return new Date();
        if (value instanceof Date) return value;
        if (typeof value === 'string') {
            let parsed;
            if (_YYYMMDD.test(value)) return parseLocalDate(value);
            else parsed = Date.parse(value);
            if (!isNaN(parsed)) return new Date(parsed);
        }
        return null;
    }
    const sundayJanuarySecond2000 = new Date(2000, 0, 2);
    function getWeekdays(locale, firstDayOfWeek, weekdayFormat) {
        const daysFromSunday = firstDayOfWeek ?? weekInfo(locale)?.firstDay ?? 0;
        return createRange(7).map((i)=>{
            const weekday = new Date(sundayJanuarySecond2000);
            weekday.setDate(sundayJanuarySecond2000.getDate() + daysFromSunday + i);
            return new Intl.DateTimeFormat(locale, {
                weekday: weekdayFormat ?? 'narrow'
            }).format(weekday);
        });
    }
    function format(value, formatString, locale, formats) {
        const newDate = date(value) ?? new Date();
        const customFormat = formats?.[formatString];
        if (typeof customFormat === 'function') return customFormat(newDate, formatString, locale);
        let options = {};
        switch(formatString){
            case 'fullDate':
                options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                };
                break;
            case 'fullDateWithWeekday':
                options = {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                };
                break;
            case 'normalDate':
                const day = newDate.getDate();
                const month = new Intl.DateTimeFormat(locale, {
                    month: 'long'
                }).format(newDate);
                return `${day} ${month}`;
            case 'normalDateWithWeekday':
                options = {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short'
                };
                break;
            case 'shortDate':
                options = {
                    month: 'short',
                    day: 'numeric'
                };
                break;
            case 'year':
                options = {
                    year: 'numeric'
                };
                break;
            case 'month':
                options = {
                    month: 'long'
                };
                break;
            case 'monthShort':
                options = {
                    month: 'short'
                };
                break;
            case 'monthAndYear':
                options = {
                    month: 'long',
                    year: 'numeric'
                };
                break;
            case 'monthAndDate':
                options = {
                    month: 'long',
                    day: 'numeric'
                };
                break;
            case 'weekday':
                options = {
                    weekday: 'long'
                };
                break;
            case 'weekdayShort':
                options = {
                    weekday: 'short'
                };
                break;
            case 'dayOfMonth':
                return new Intl.NumberFormat(locale).format(newDate.getDate());
            case 'hours12h':
                options = {
                    hour: 'numeric',
                    hour12: true
                };
                break;
            case 'hours24h':
                options = {
                    hour: 'numeric',
                    hour12: false
                };
                break;
            case 'minutes':
                options = {
                    minute: 'numeric'
                };
                break;
            case 'seconds':
                options = {
                    second: 'numeric'
                };
                break;
            case 'fullTime':
                options = {
                    hour: 'numeric',
                    minute: 'numeric'
                };
                break;
            case 'fullTime12h':
                options = {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                };
                break;
            case 'fullTime24h':
                options = {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false
                };
                break;
            case 'fullDateTime':
                options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric'
                };
                break;
            case 'fullDateTime12h':
                options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                };
                break;
            case 'fullDateTime24h':
                options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false
                };
                break;
            case 'keyboardDate':
                options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                };
                break;
            case 'keyboardDateTime':
                options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric'
                };
                return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
            case 'keyboardDateTime12h':
                options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                };
                return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
            case 'keyboardDateTime24h':
                options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false
                };
                return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
            default:
                options = customFormat ?? {
                    timeZone: 'UTC',
                    timeZoneName: 'short'
                };
        }
        return new Intl.DateTimeFormat(locale, options).format(newDate);
    }
    function toISO(adapter, value) {
        const date = adapter.toJsDate(value);
        const year = date.getFullYear();
        const month = padStart(String(date.getMonth() + 1), 2, '0');
        const day = padStart(String(date.getDate()), 2, '0');
        return `${year}-${month}-${day}`;
    }
    function parseISO(value) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
    function addMinutes(date, amount) {
        const d = new Date(date);
        d.setMinutes(d.getMinutes() + amount);
        return d;
    }
    function addHours(date, amount) {
        const d = new Date(date);
        d.setHours(d.getHours() + amount);
        return d;
    }
    function addDays(date, amount) {
        const d = new Date(date);
        d.setDate(d.getDate() + amount);
        return d;
    }
    function addWeeks(date, amount) {
        const d = new Date(date);
        d.setDate(d.getDate() + amount * 7);
        return d;
    }
    function addMonths(date, amount) {
        const d = new Date(date);
        d.setDate(1);
        d.setMonth(d.getMonth() + amount);
        return d;
    }
    function getYear(date) {
        return date.getFullYear();
    }
    function getMonth(date) {
        return date.getMonth();
    }
    function getWeek(date, locale, firstDayOfWeek, firstDayOfYear) {
        const weekInfoFromLocale = weekInfo(locale);
        const weekStart = firstDayOfWeek ?? weekInfoFromLocale?.firstDay ?? 0;
        const minWeekSize = weekInfoFromLocale?.firstWeekSize ?? 1;
        return firstDayOfYear !== undefined ? calculateWeekWithFirstDayOfYear(date, locale, weekStart, firstDayOfYear) : calculateWeekWithMinWeekSize(date, locale, weekStart, minWeekSize);
    }
    function calculateWeekWithFirstDayOfYear(date, locale, weekStart, firstDayOfYear) {
        const firstDayOfYearOffset = (7 + firstDayOfYear - weekStart) % 7;
        const currentWeekStart = startOfWeek(date, locale, weekStart);
        const currentWeekEnd = addDays(currentWeekStart, 6);
        function yearStartWeekdayOffset(year) {
            return (7 + new Date(year, 0, 1).getDay() - weekStart) % 7;
        }
        let year = getYear(currentWeekStart);
        if (year < getYear(currentWeekEnd) && yearStartWeekdayOffset(year + 1) <= firstDayOfYearOffset) year++;
        const yearStart = new Date(year, 0, 1);
        const offset = yearStartWeekdayOffset(year);
        const d1w1 = offset <= firstDayOfYearOffset ? addDays(yearStart, -offset) : addDays(yearStart, 7 - offset);
        return 1 + getDiff(endOfDay(currentWeekStart), startOfDay(d1w1), 'weeks');
    }
    function calculateWeekWithMinWeekSize(date, locale, weekStart, minWeekSize) {
        const currentWeekStart = startOfWeek(date, locale, weekStart);
        const currentWeekEnd = addDays(startOfWeek(date, locale, weekStart), 6);
        function firstWeekSize(year) {
            const yearStart = new Date(year, 0, 1);
            return 7 - getDiff(yearStart, startOfWeek(yearStart, locale, weekStart), 'days');
        }
        let year = getYear(currentWeekStart);
        if (year < getYear(currentWeekEnd) && firstWeekSize(year + 1) >= minWeekSize) year++;
        const yearStart = new Date(year, 0, 1);
        const size = firstWeekSize(year);
        const d1w1 = size >= minWeekSize ? addDays(yearStart, size - 7) : addDays(yearStart, size);
        return 1 + getDiff(endOfDay(currentWeekStart), startOfDay(d1w1), 'weeks');
    }
    function getDate(date) {
        return date.getDate();
    }
    function getNextMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    }
    function getPreviousMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    }
    function getHours(date) {
        return date.getHours();
    }
    function getMinutes(date) {
        return date.getMinutes();
    }
    function startOfYear(date) {
        return new Date(date.getFullYear(), 0, 1);
    }
    function endOfYear(date) {
        return new Date(date.getFullYear(), 11, 31);
    }
    function isWithinRange(date, range) {
        return isEqual(date, range[0]) || isEqual(date, range[1]) || isAfter(date, range[0]) && isBefore(date, range[1]);
    }
    function isValid(date) {
        const d = new Date(date);
        return d instanceof Date && !isNaN(d.getTime());
    }
    function isAfter(date, comparing) {
        return date.getTime() > comparing.getTime();
    }
    function isAfterDay(date, comparing) {
        return isAfter(startOfDay(date), startOfDay(comparing));
    }
    function isBefore(date, comparing) {
        return date.getTime() < comparing.getTime();
    }
    function isEqual(date, comparing) {
        return date.getTime() === comparing.getTime();
    }
    function isSameDay(date, comparing) {
        return date.getDate() === comparing.getDate() && date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
    }
    function isSameMonth(date, comparing) {
        return date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
    }
    function isSameYear(date, comparing) {
        return date.getFullYear() === comparing.getFullYear();
    }
    function getDiff(date, comparing, unit) {
        const d = new Date(date);
        const c = new Date(comparing);
        switch(unit){
            case 'years':
                return d.getFullYear() - c.getFullYear();
            case 'quarters':
                return Math.floor((d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12) / 4);
            case 'months':
                return d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12;
            case 'weeks':
                return Math.floor((d.getTime() - c.getTime()) / 604800000);
            case 'days':
                return Math.floor((d.getTime() - c.getTime()) / 86400000);
            case 'hours':
                return Math.floor((d.getTime() - c.getTime()) / 3600000);
            case 'minutes':
                return Math.floor((d.getTime() - c.getTime()) / 60000);
            case 'seconds':
                return Math.floor((d.getTime() - c.getTime()) / 1000);
            default:
                return d.getTime() - c.getTime();
        }
    }
    function setHours(date, count) {
        const d = new Date(date);
        d.setHours(count);
        return d;
    }
    function setMinutes(date, count) {
        const d = new Date(date);
        d.setMinutes(count);
        return d;
    }
    function setMonth(date, count) {
        const d = new Date(date);
        d.setMonth(count);
        return d;
    }
    function setDate(date, day) {
        const d = new Date(date);
        d.setDate(day);
        return d;
    }
    function setYear(date, year) {
        const d = new Date(date);
        d.setFullYear(year);
        return d;
    }
    function startOfDay(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    }
    function endOfDay(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
    }
    class VuetifyDateAdapter {
        constructor(options){
            this.locale = options.locale;
            this.formats = options.formats;
        }
        date(value) {
            return date(value);
        }
        toJsDate(date) {
            return date;
        }
        toISO(date) {
            return toISO(this, date);
        }
        parseISO(date) {
            return parseISO(date);
        }
        addMinutes(date, amount) {
            return addMinutes(date, amount);
        }
        addHours(date, amount) {
            return addHours(date, amount);
        }
        addDays(date, amount) {
            return addDays(date, amount);
        }
        addWeeks(date, amount) {
            return addWeeks(date, amount);
        }
        addMonths(date, amount) {
            return addMonths(date, amount);
        }
        getWeekArray(date, firstDayOfWeek) {
            const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
            return getWeekArray(date, this.locale, firstDay);
        }
        startOfWeek(date, firstDayOfWeek) {
            const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
            return startOfWeek(date, this.locale, firstDay);
        }
        endOfWeek(date) {
            return endOfWeek(date, this.locale);
        }
        startOfMonth(date) {
            return startOfMonth(date);
        }
        endOfMonth(date) {
            return endOfMonth(date);
        }
        format(date, formatString) {
            return format(date, formatString, this.locale, this.formats);
        }
        isEqual(date, comparing) {
            return isEqual(date, comparing);
        }
        isValid(date) {
            return isValid(date);
        }
        isWithinRange(date, range) {
            return isWithinRange(date, range);
        }
        isAfter(date, comparing) {
            return isAfter(date, comparing);
        }
        isAfterDay(date, comparing) {
            return isAfterDay(date, comparing);
        }
        isBefore(date, comparing) {
            return !isAfter(date, comparing) && !isEqual(date, comparing);
        }
        isSameDay(date, comparing) {
            return isSameDay(date, comparing);
        }
        isSameMonth(date, comparing) {
            return isSameMonth(date, comparing);
        }
        isSameYear(date, comparing) {
            return isSameYear(date, comparing);
        }
        setMinutes(date, count) {
            return setMinutes(date, count);
        }
        setHours(date, count) {
            return setHours(date, count);
        }
        setMonth(date, count) {
            return setMonth(date, count);
        }
        setDate(date, day) {
            return setDate(date, day);
        }
        setYear(date, year) {
            return setYear(date, year);
        }
        getDiff(date, comparing, unit) {
            return getDiff(date, comparing, unit);
        }
        getWeekdays(firstDayOfWeek, weekdayFormat) {
            const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
            return getWeekdays(this.locale, firstDay, weekdayFormat);
        }
        getYear(date) {
            return getYear(date);
        }
        getMonth(date) {
            return getMonth(date);
        }
        getWeek(date, firstDayOfWeek, firstDayOfYear) {
            const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
            const firstWeekStart = firstDayOfYear !== undefined ? Number(firstDayOfYear) : undefined;
            return getWeek(date, this.locale, firstDay, firstWeekStart);
        }
        getDate(date) {
            return getDate(date);
        }
        getNextMonth(date) {
            return getNextMonth(date);
        }
        getPreviousMonth(date) {
            return getPreviousMonth(date);
        }
        getHours(date) {
            return getHours(date);
        }
        getMinutes(date) {
            return getMinutes(date);
        }
        startOfDay(date) {
            return startOfDay(date);
        }
        endOfDay(date) {
            return endOfDay(date);
        }
        startOfYear(date) {
            return startOfYear(date);
        }
        endOfYear(date) {
            return endOfYear(date);
        }
    }
    // Composables
    const DateOptionsSymbol = Symbol.for('vuetify:date-options');
    const DateAdapterSymbol = Symbol.for('vuetify:date-adapter');
    function createDate(options, locale) {
        const _options = mergeDeep({
            adapter: VuetifyDateAdapter,
            locale: {
                af: 'af-ZA',
                // ar: '', # not the same value for all variants
                bg: 'bg-BG',
                ca: 'ca-ES',
                ckb: '',
                cs: 'cs-CZ',
                de: 'de-DE',
                el: 'el-GR',
                en: 'en-US',
                // es: '', # not the same value for all variants
                et: 'et-EE',
                fa: 'fa-IR',
                fi: 'fi-FI',
                // fr: '', #not the same value for all variants
                hr: 'hr-HR',
                hu: 'hu-HU',
                he: 'he-IL',
                id: 'id-ID',
                it: 'it-IT',
                ja: 'ja-JP',
                ko: 'ko-KR',
                lv: 'lv-LV',
                lt: 'lt-LT',
                nl: 'nl-NL',
                no: 'no-NO',
                pl: 'pl-PL',
                pt: 'pt-PT',
                ro: 'ro-RO',
                ru: 'ru-RU',
                sk: 'sk-SK',
                sl: 'sl-SI',
                srCyrl: 'sr-SP',
                srLatn: 'sr-SP',
                sv: 'sv-SE',
                th: 'th-TH',
                tr: 'tr-TR',
                az: 'az-AZ',
                uk: 'uk-UA',
                vi: 'vi-VN',
                zhHans: 'zh-CN',
                zhHant: 'zh-TW'
            }
        }, options);
        return {
            options: _options,
            instance: createInstance(_options, locale)
        };
    }
    function daysDiff(adapter, start, stop) {
        const iso = [
            `${adapter.toISO(stop ?? start).split('T')[0]}T00:00:00Z`,
            `${adapter.toISO(start).split('T')[0]}T00:00:00Z`
        ];
        return typeof adapter.date() === 'string' ? adapter.getDiff(iso[0], iso[1], 'days') // for StringDateAdapter
         : adapter.getDiff(adapter.date(iso[0]), adapter.date(iso[1]), 'days');
    }
    function createInstance(options, locale) {
        const instance = vue.reactive(typeof options.adapter === 'function' ? new options.adapter({
            locale: options.locale[locale.current.value] ?? locale.current.value,
            formats: options.formats
        }) : options.adapter);
        vue.watch(locale.current, (value)=>{
            instance.locale = options.locale[value] ?? value ?? instance.locale;
        });
        return instance;
    }
    function useDate() {
        const options = vue.inject(DateOptionsSymbol);
        if (!options) throw new Error('[Vuetify] Could not find injected date options');
        const locale = useLocale();
        return createInstance(options, locale);
    }
    // Composables
    // Types
    const makeCalendarBaseProps = propsFactory({
        start: {
            type: [
                String,
                Number,
                Date
            ],
            validate: validateTimestamp,
            default: ()=>parseDate(new Date()).date
        },
        end: {
            type: [
                String,
                Number,
                Date
            ],
            validate: validateTimestamp
        },
        weekdays: {
            type: [
                Array,
                String
            ],
            default: ()=>[
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ],
            validate: validateWeekdays
        },
        firstDayOfWeek: [
            Number,
            String
        ],
        firstDayOfYear: [
            Number,
            String
        ],
        weekdayFormat: {
            type: Function,
            default: null
        },
        dayFormat: {
            type: Function,
            default: null
        },
        format: String,
        locale: String,
        now: {
            type: String,
            validator: validateTimestamp
        },
        type: {
            type: String,
            default: 'month'
        }
    }, 'VCalendar-base');
    function useCalendarBase(props) {
        const { times: times, updateTimes: updateTimes } = useTimes({
            now: props.now
        });
        const locale = provideLocale(props);
        const adapter = useDate();
        const parsedStart = vue.computed(()=>{
            if (props.type === 'month') return getStartOfMonth(parseTimestamp(props.start, true));
            return parseTimestamp(props.start, true);
        });
        const parsedEnd = vue.computed(()=>{
            const start = parsedStart.value;
            const end = props.end ? parseTimestamp(props.end) || start : start;
            const value = getTimestampIdentifier(end) < getTimestampIdentifier(start) ? start : end;
            if (props.type === 'month') return getEndOfMonth(value);
            return value;
        });
        const parsedValue = vue.computed(()=>{
            return validateTimestamp(props.modelValue) ? parseTimestamp(props.modelValue, true) : parsedStart.value || times.today;
        });
        const parsedWeekdays = vue.computed(()=>{
            const weekdays = Array.isArray(props.weekdays) ? props.weekdays : (props.weekdays || '').split(',').map((x)=>parseInt(x, 10));
            const first = adapter.toJsDate(adapter.startOfWeek(adapter.date(), props.firstDayOfWeek)).getDay();
            return [
                ...weekdays.toSorted().filter((v)=>v >= first),
                ...weekdays.toSorted().filter((v)=>v < first)
            ];
        });
        const effectiveWeekdays = vue.computed(()=>{
            const start = parsedValue.value;
            const days = parseInt(String(props.categoryDays)) || 1;
            switch(props.type){
                case 'day':
                    return [
                        start.weekday
                    ];
                case '4day':
                    return [
                        start.weekday,
                        (start.weekday + 1) % 7,
                        (start.weekday + 2) % 7,
                        (start.weekday + 3) % 7
                    ];
                case 'category':
                    return Array.from({
                        length: days
                    }, (_, i)=>(start.weekday + i) % 7);
                default:
                    return parsedWeekdays.value;
            }
        });
        const weekdaySkips = vue.computed(()=>{
            return getWeekdaySkips(parsedWeekdays.value);
        });
        const days = vue.computed(()=>{
            return createDayList(parsedStart.value, parsedEnd.value, times.today, weekdaySkips.value);
        });
        const dayFormatter = vue.computed(()=>{
            if (props.dayFormat) return props.dayFormat;
            return createNativeLocaleFormatter(locale.current.value, ()=>({
                    timeZone: 'UTC',
                    day: 'numeric'
                }));
        });
        const weekdayFormatter = vue.computed(()=>{
            if (props.weekdayFormat) return props.weekdayFormat;
            return createNativeLocaleFormatter(locale.current.value, (_tms, short)=>({
                    timeZone: 'UTC',
                    weekday: short ? 'short' : 'long'
                }));
        });
        function getColorProps(colors) {
            return computeColor(colors);
        }
        function getRelativeClasses(timestamp, outside = false) {
            return {
                'v-present': timestamp.present,
                'v-past': timestamp.past,
                'v-future': timestamp.future,
                'v-outside': outside
            };
        }
        function getWeekNumber(timestamp) {
            return adapter.getWeek(adapter.date(timestamp.date), props.firstDayOfWeek, props.firstDayOfYear);
        }
        function _getStartOfWeek(timestamp) {
            return getStartOfWeek(timestamp, parsedWeekdays.value, times.today);
        }
        function _getEndOfWeek(timestamp) {
            return getEndOfWeek(timestamp, parsedWeekdays.value, times.today);
        }
        function getFormatter(options) {
            return createNativeLocaleFormatter(locale.current.value, ()=>options);
        }
        return {
            times: times,
            locale: locale,
            parsedValue: parsedValue,
            parsedWeekdays: parsedWeekdays,
            effectiveWeekdays: effectiveWeekdays,
            weekdaySkips: weekdaySkips,
            parsedStart: parsedStart,
            parsedEnd: parsedEnd,
            days: days,
            dayFormatter: dayFormatter,
            weekdayFormatter: weekdayFormatter,
            getColorProps: getColorProps,
            getRelativeClasses: getRelativeClasses,
            getWeekNumber: getWeekNumber,
            getStartOfWeek: _getStartOfWeek,
            getEndOfWeek: _getEndOfWeek,
            getFormatter: getFormatter,
            updateTimes: updateTimes
        };
    }
    // Composables
    // Types
    const makeCalendarWithIntervalsProps = propsFactory({
        maxDays: {
            type: Number,
            default: 7
        },
        intervalHeight: {
            type: [
                Number,
                String
            ],
            default: 48,
            validate: validateNumber
        },
        intervalWidth: {
            type: [
                Number,
                String
            ],
            default: 60,
            validate: validateNumber
        },
        intervalMinutes: {
            type: [
                Number,
                String
            ],
            default: 60,
            validate: validateNumber
        },
        firstInterval: {
            type: [
                Number,
                String
            ],
            default: 0,
            validate: validateNumber
        },
        firstTime: {
            type: [
                Number,
                String,
                Object
            ],
            validate: validateTime
        },
        intervalCount: {
            type: [
                Number,
                String
            ],
            default: 24,
            validate: validateNumber
        },
        intervalFormat: {
            type: Function,
            default: null
        },
        intervalStyle: {
            type: Function,
            default: null
        },
        showIntervalLabel: {
            type: Function,
            default: null
        }
    }, 'VCalendar-intervals');
    function useCalendarWithIntervals(props) {
        const base = useCalendarBase(props);
        const scrollAreaRef = vue.shallowRef();
        const parsedFirstInterval = vue.computed(()=>{
            return parseInt(String(props.firstInterval || 0));
        });
        const parsedIntervalMinutes = vue.computed(()=>{
            return parseInt(String(props.intervalMinutes || 60));
        });
        const parsedIntervalCount = vue.computed(()=>{
            return parseInt(String(props.intervalCount || 24));
        });
        const parsedIntervalHeight = vue.computed(()=>{
            return parseFloat(String(props.intervalHeight || 48));
        });
        const parsedFirstTime = vue.computed(()=>{
            return parseTime(props.firstTime);
        });
        const firstMinute = vue.computed(()=>{
            const time = parsedFirstTime.value;
            return time !== false && time >= 0 && time <= MINUTES_IN_DAY ? time : parsedFirstInterval.value * parsedIntervalMinutes.value;
        });
        const effectiveIntervalCount = vue.computed(()=>{
            const dayLimit = Math.ceil((MINUTES_IN_DAY - firstMinute.value) / parsedIntervalMinutes.value);
            return clamp(parsedIntervalCount.value, 0, dayLimit);
        });
        const bodyHeight = vue.computed(()=>{
            return effectiveIntervalCount.value * parsedIntervalHeight.value;
        });
        const days = vue.computed(()=>{
            return createDayList(base.parsedStart.value, base.parsedEnd.value, base.times.today, base.weekdaySkips.value, props.maxDays);
        });
        const intervals = vue.computed(()=>{
            const daysValue = days.value;
            const first = firstMinute.value;
            const minutes = parsedIntervalMinutes.value;
            const count = effectiveIntervalCount.value;
            const now = base.times.now;
            return daysValue.map((d)=>createIntervalList(d, first, minutes, count, now));
        });
        const intervalFormatter = vue.computed(()=>{
            if (props.intervalFormat) return props.intervalFormat;
            const hour12 = props.format === 'ampm' ? true : props.format === '24hr' ? false : undefined;
            const hourStyle = props.format === '24hr' ? '2-digit' : 'numeric';
            return createNativeLocaleFormatter(base.locale.current.value, (tms, short)=>!short ? {
                    timeZone: 'UTC',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: hour12
                } : tms.minute === 0 ? {
                    timeZone: 'UTC',
                    hour: hourStyle,
                    hour12: hour12
                } : {
                    timeZone: 'UTC',
                    hour: hourStyle,
                    minute: '2-digit',
                    hour12: hour12
                });
        });
        function showIntervalLabelDefault(interval) {
            const first = intervals.value[0][0];
            const isFirst = first.hour === interval.hour && first.minute === interval.minute;
            return !isFirst;
        }
        function intervalStyleDefault(_interval) {
            return undefined;
        }
        function getIntervalAtEvent(e) {
            const bounds = new Box(e.currentTarget);
            const touchEvent = e;
            const mouseEvent = e;
            const touches = touchEvent.changedTouches || touchEvent.touches;
            const target = touches && touches[0] ? touches[0] : mouseEvent;
            const point = getTargetBox([
                target.clientX,
                target.clientY
            ]);
            return (point.y - bounds.top) / parsedIntervalHeight.value;
        }
        function getTimestampAtEvent(e, day) {
            const timestamp = copyTimestamp(day);
            const addMinutes = Math.floor(getIntervalAtEvent(e) * parsedIntervalMinutes.value);
            const minutes = firstMinute.value + addMinutes;
            return updateMinutes(timestamp, minutes, base.times.now);
        }
        function getSlotScope(timestamp) {
            const scope = copyTimestamp(timestamp);
            scope.timeToY = timeToY;
            scope.timeDelta = timeDelta;
            scope.minutesToPixels = minutesToPixels;
            scope.week = days.value;
            scope.intervalRange = [
                firstMinute.value,
                firstMinute.value + effectiveIntervalCount.value * parsedIntervalMinutes.value
            ];
            return scope;
        }
        function scrollToTime(time) {
            const y = timeToY(time);
            const pane = scrollAreaRef.value;
            if (y === false || !pane) return false;
            pane.scrollTop = y;
            return true;
        }
        function minutesToPixels(minutes) {
            return minutes / parsedIntervalMinutes.value * parsedIntervalHeight.value;
        }
        function timeToY(time, targetDateOrClamp = false) {
            const clamp = targetDateOrClamp !== false;
            const targetDate = typeof targetDateOrClamp !== 'boolean' ? targetDateOrClamp : undefined;
            let y = timeDelta(time, targetDate);
            if (y === false) return y;
            y *= bodyHeight.value;
            if (clamp) {
                if (y < 0) y = 0;
                else if (y > bodyHeight.value) y = bodyHeight.value;
            } else {
                if (y < 0) y = y + bodyHeight.value;
                else if (y > bodyHeight.value) y = y - bodyHeight.value;
            }
            return y;
        }
        function timeDelta(time, targetDate) {
            let minutes = parseTime(time);
            if (minutes === false) return false;
            const gap = effectiveIntervalCount.value * parsedIntervalMinutes.value;
            if (targetDate && typeof time === 'object' && 'day' in time) {
                const a = getDayIdentifier(time);
                const b = getDayIdentifier(targetDate);
                minutes += (a - b) * gap;
            }
            const min = firstMinute.value;
            return (minutes - min) / gap;
        }
        return {
            ...base,
            scrollAreaRef: scrollAreaRef,
            parsedFirstInterval: parsedFirstInterval,
            parsedIntervalMinutes: parsedIntervalMinutes,
            parsedIntervalCount: parsedIntervalCount,
            parsedIntervalHeight: parsedIntervalHeight,
            parsedFirstTime: parsedFirstTime,
            firstMinute: firstMinute,
            bodyHeight: bodyHeight,
            days: days,
            intervals: intervals,
            intervalFormatter: intervalFormatter,
            showIntervalLabelDefault: showIntervalLabelDefault,
            intervalStyleDefault: intervalStyleDefault,
            getIntervalAtEvent: getIntervalAtEvent,
            getTimestampAtEvent: getTimestampAtEvent,
            getSlotScope: getSlotScope,
            scrollToTime: scrollToTime,
            minutesToPixels: minutesToPixels,
            timeToY: timeToY,
            timeDelta: timeDelta
        };
    }
    // Types
    const makeIntervalHighlightProps = propsFactory({
        intervalHighlight: {
            type: [
                Boolean,
                String
            ],
            default: false
        }
    }, 'interval-highlight');
    function useIntervalHighlight(props, base) {
        const hoveredTime = vue.shallowRef(null);
        // The underlay paints `background: currentColor`, so we only need a text color.
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>typeof props.intervalHighlight === 'string' && props.intervalHighlight ? props.intervalHighlight : 'surface-variant');
        // Day columns can overlay the intervals, so snap the cursor to an interval row.
        function getHoveredTimeFromEvent(e) {
            const index = Math.floor(base.getIntervalAtEvent(e));
            const intervals = base.intervals.value[0];
            if (!intervals || index < 0 || index >= intervals.length) return null;
            return intervals[index].time;
        }
        function onMousemove(e) {
            if (!props.intervalHighlight) return;
            hoveredTime.value = getHoveredTimeFromEvent(e);
        }
        function onMouseleave() {
            if (!props.intervalHighlight) return;
            hoveredTime.value = null;
        }
        function isHighlighted(interval) {
            return !!props.intervalHighlight && hoveredTime.value === interval.time;
        }
        function genUnderlay() {
            if (!props.intervalHighlight) return undefined;
            return vue.createElementVNode("div", {
                "class": vue.normalizeClass([
                    'v-calendar-daily__day-interval__underlay',
                    textColorClasses.value
                ]),
                "style": vue.normalizeStyle(textColorStyles.value)
            }, null);
        }
        return {
            hoveredTime: hoveredTime,
            onMousemove: onMousemove,
            onMouseleave: onMouseleave,
            isHighlighted: isHighlighted,
            genUnderlay: genUnderlay
        };
    }
    // Types
    function mounted$3(el, binding) {
        const handler = binding.value;
        const options = {
            passive: !binding.modifiers?.active
        };
        window.addEventListener('resize', handler, options);
        el._onResize = Object(el._onResize);
        el._onResize[binding.instance.$.uid] = {
            handler: handler,
            options: options
        };
        if (!binding.modifiers?.quiet) handler();
    }
    function unmounted$3(el, binding) {
        if (!el._onResize?.[binding.instance.$.uid]) return;
        const { handler: handler, options: options } = el._onResize[binding.instance.$.uid];
        window.removeEventListener('resize', handler, options);
        delete el._onResize[binding.instance.$.uid];
    }
    const Resize = {
        mounted: mounted$3,
        unmounted: unmounted$3
    };
    // Types
    const VCalendarDaily = defineComponent({
        name: 'VCalendarDaily',
        directives: {
            vResize: Resize
        },
        props: {
            color: String,
            shortWeekdays: {
                type: Boolean,
                default: true
            },
            shortIntervals: {
                type: Boolean,
                default: true
            },
            hideHeader: Boolean,
            ...makeIntervalHighlightProps(),
            ...makeCalendarBaseProps(),
            ...makeCalendarWithIntervalsProps()
        },
        setup (props, { slots: slots, attrs: attrs }) {
            const scrollPush = vue.ref(0);
            const pane = vue.ref();
            const base = useCalendarWithIntervals(props);
            const highlight = useIntervalHighlight(props, base);
            function init() {
                vue.nextTick(onResize);
            }
            function onResize() {
                scrollPush.value = getScrollPush();
            }
            function getScrollPush() {
                return base.scrollAreaRef.value && pane.value ? base.scrollAreaRef.value.offsetWidth - pane.value.offsetWidth : 0;
            }
            function genHead() {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-daily__head",
                    "style": {
                        marginRight: scrollPush.value + 'px'
                    }
                }, [
                    genHeadIntervals(),
                    genHeadDays()
                ]);
            }
            function genHeadIntervals() {
                const width = convertToUnit(props.intervalWidth);
                return vue.createElementVNode("div", {
                    "class": "v-calendar-daily__intervals-head",
                    "style": {
                        width: width
                    }
                }, [
                    slots['interval-header']?.()
                ]);
            }
            function genHeadDays() {
                return base.days.value.map(genHeadDay);
            }
            function genHeadDay(day, index) {
                const events = getPrefixedEventHandlers(attrs, ':day', (nativeEvent)=>({
                        nativeEvent: nativeEvent,
                        ...base.getSlotScope(day)
                    }));
                return vue.createElementVNode("div", vue.mergeProps({
                    "key": day.date,
                    "class": [
                        'v-calendar-daily_head-day',
                        base.getRelativeClasses(day)
                    ]
                }, events), [
                    genHeadWeekday(day),
                    genHeadDayLabel(day),
                    genDayHeader(day, index)
                ]);
            }
            function genDayHeader(day, index) {
                return slots['day-header']?.({
                    week: base.days.value,
                    ...day,
                    index: index
                }) ?? [];
            }
            function genHeadWeekday(day) {
                const color = day.present ? props.color : undefined;
                return vue.createElementVNode("div", vue.mergeProps(base.getColorProps({
                    text: color
                }), {
                    "class": "v-calendar-daily_head-weekday"
                }), [
                    base.weekdayFormatter.value(day, props.shortWeekdays)
                ]);
            }
            function genHeadDayLabel(day) {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-daily_head-day-label"
                }, [
                    slots['day-label-header']?.(day) ?? genHeadDayButton(day)
                ]);
            }
            function genHeadDayButton(day) {
                const events = getPrefixedEventHandlers(attrs, ':date', (nativeEvent)=>({
                        nativeEvent: nativeEvent,
                        ...day
                    }));
                return vue.createVNode(VIconBtn, vue.mergeProps({
                    "active": day.present,
                    "activeColor": props.color,
                    "variant": "outlined",
                    "baseVariant": "text",
                    "onUpdate:active": noop
                }, events), {
                    default: ()=>[
                            base.dayFormatter.value(day, false)
                        ]
                });
            }
            function genBody() {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-daily__body"
                }, [
                    genScrollArea()
                ]);
            }
            function genScrollArea() {
                return vue.createElementVNode("div", {
                    "ref": base.scrollAreaRef,
                    "class": "v-calendar-daily__scroll-area"
                }, [
                    genPane()
                ]);
            }
            function genPane() {
                return vue.createElementVNode("div", {
                    "ref": pane,
                    "class": "v-calendar-daily__pane",
                    "style": {
                        height: convertToUnit(base.bodyHeight.value)
                    }
                }, [
                    genDayContainer()
                ]);
            }
            function genDayContainer() {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-daily__day-container"
                }, [
                    genBodyIntervals(),
                    slots.days?.() ?? genDays()
                ]);
            }
            function genDays() {
                return base.days.value.map((day, index)=>{
                    const events = getPrefixedEventHandlers(attrs, ':time', (nativeEvent)=>({
                            nativeEvent: nativeEvent,
                            ...base.getSlotScope(base.getTimestampAtEvent(nativeEvent, day))
                        }));
                    return vue.createElementVNode("div", vue.mergeProps({
                        "key": day.date,
                        "class": [
                            'v-calendar-daily__day',
                            base.getRelativeClasses(day)
                        ]
                    }, events, {
                        "onMousemove": highlight.onMousemove,
                        "onMouseleave": highlight.onMouseleave
                    }), [
                        genDayIntervals(index),
                        genDayBody(day)
                    ]);
                });
            }
            function genDayBody(day) {
                return slots['day-body']?.(base.getSlotScope(day)) ?? [];
            }
            function genDayIntervals(index) {
                return base.intervals.value[index].map(genDayInterval);
            }
            function genDayInterval(interval) {
                const height = convertToUnit(props.intervalHeight);
                const styler = props.intervalStyle || base.intervalStyleDefault;
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-calendar-daily__day-interval',
                        {
                            'v-calendar-daily__day-interval--hover': highlight.isHighlighted(interval)
                        }
                    ]),
                    "key": interval.time,
                    "style": vue.normalizeStyle([
                        {
                            height: height
                        },
                        styler(interval)
                    ])
                }, [
                    highlight.genUnderlay(),
                    slots.interval?.(base.getSlotScope(interval))
                ]);
            }
            function genBodyIntervals() {
                const width = convertToUnit(props.intervalWidth);
                const events = getPrefixedEventHandlers(attrs, ':interval', (nativeEvent)=>({
                        nativeEvent: nativeEvent,
                        ...base.getTimestampAtEvent(nativeEvent, base.parsedStart.value)
                    }));
                return vue.createElementVNode("div", vue.mergeProps({
                    "class": "v-calendar-daily__intervals-body",
                    "style": {
                        width: width
                    }
                }, events), [
                    genIntervalLabels()
                ]);
            }
            function genIntervalLabels() {
                if (!base.intervals.value.length) return null;
                return base.intervals.value[0].map(genIntervalLabel);
            }
            function genIntervalLabel(interval) {
                const height = convertToUnit(props.intervalHeight);
                const short = props.shortIntervals;
                const shower = props.showIntervalLabel || base.showIntervalLabelDefault;
                const show = shower(interval);
                const label = show ? base.intervalFormatter.value(interval, short) : undefined;
                return vue.createElementVNode("div", {
                    "key": interval.time,
                    "class": "v-calendar-daily__interval",
                    "style": {
                        height: height
                    }
                }, [
                    vue.createElementVNode("div", {
                        "class": "v-calendar-daily__interval-text"
                    }, [
                        label
                    ])
                ]);
            }
            vue.onMounted(init);
            useRender(()=>vue.withDirectives(vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-calendar-daily',
                        attrs.class
                    ]),
                    "onDragstart": (e)=>e.preventDefault()
                }, [
                    !props.hideHeader ? genHead() : undefined,
                    genBody()
                ]), [
                    [
                        Resize,
                        onResize,
                        void 0,
                        {
                            quiet: true
                        }
                    ]
                ]));
            return {
                ...base,
                scrollPush: scrollPush,
                pane: pane,
                init: init,
                onResize: onResize,
                getScrollPush: getScrollPush
            };
        }
    });
    // Types
    function parsedCategoryText(category, categoryText) {
        return typeof categoryText === 'function' ? categoryText(category) : typeof categoryText === 'string' && typeof category === 'object' && category ? category[categoryText] : typeof category === 'string' ? category : '';
    }
    function getParsedCategories(categories, categoryText) {
        if (typeof categories === 'string') return categories.split(/\s*,\s/);
        if (Array.isArray(categories)) return categories.map((category)=>{
            if (typeof category === 'string') return category;
            const categoryName = typeof category.categoryName === 'string' ? category.categoryName : parsedCategoryText(category, categoryText);
            return {
                ...category,
                categoryName: categoryName
            };
        });
        return [];
    }
    // Types
    const VCalendarCategory = defineComponent({
        name: 'VCalendarCategory',
        props: {
            categories: {
                type: [
                    Array,
                    String
                ],
                default: ''
            },
            categoryText: [
                String,
                Function
            ],
            categoryForInvalid: {
                type: String,
                default: ''
            },
            ...makeIntervalHighlightProps(),
            ...makeCalendarBaseProps(),
            ...makeCalendarWithIntervalsProps()
        },
        setup (props, { slots: slots, attrs: attrs }) {
            const base = useCalendarWithIntervals(props);
            const highlight = useIntervalHighlight(props, base);
            const parsedCategories = vue.computed(()=>{
                return getParsedCategories(props.categories, props.categoryText);
            });
            function getCategoryScope(scope, category) {
                const cat = typeof category === 'object' && category && category.categoryName === props.categoryForInvalid ? null : category;
                return {
                    ...scope,
                    category: cat
                };
            }
            function genDayHeader(scope) {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-category__columns"
                }, [
                    parsedCategories.value.map((category)=>{
                        return genDayHeaderCategory(scope, getCategoryScope(scope, category));
                    })
                ]);
            }
            function genDayHeaderCategory(day, scope) {
                const headerTitle = typeof scope.category === 'object' ? scope.category.categoryName : scope.category;
                const events = getPrefixedEventHandlers(attrs, ':dayCategory', ()=>{
                    return getCategoryScope(base.getSlotScope(day) || day, scope.category);
                });
                return vue.createElementVNode("div", vue.mergeProps({
                    "class": "v-calendar-category__column-header"
                }, events), [
                    slots.category?.(scope) ?? genDayHeaderCategoryTitle(headerTitle),
                    slots['day-header']?.(scope)
                ]);
            }
            function genDayHeaderCategoryTitle(categoryName) {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-category__category"
                }, [
                    categoryName === null ? props.categoryForInvalid : categoryName
                ]);
            }
            function genDays() {
                const days = [];
                base.days.value.forEach((d, j)=>{
                    const day = new Array(parsedCategories.value.length || 1);
                    day.fill(d);
                    days.push(...day.map((v, i)=>genDay(v, j, i)));
                });
                return days;
            }
            function genDay(day, index, categoryIndex) {
                const category = parsedCategories.value[categoryIndex];
                const events = getPrefixedEventHandlers(attrs, ':time', (e)=>{
                    return base.getSlotScope(base.getTimestampAtEvent(e, day));
                });
                return vue.createElementVNode("div", vue.mergeProps({
                    "key": day.date + '-' + categoryIndex,
                    "class": [
                        'v-calendar-daily__day',
                        base.getRelativeClasses(day)
                    ]
                }, events, {
                    "onMousemove": highlight.onMousemove,
                    "onMouseleave": highlight.onMouseleave
                }), [
                    genDayIntervals(index, category),
                    genDayBody(day, category)
                ]);
            }
            function genDayIntervals(index, category) {
                return base.intervals.value[index].map((v)=>genDayInterval(v, category));
            }
            function genDayInterval(interval, category) {
                const height = convertToUnit(props.intervalHeight);
                const styler = props.intervalStyle || base.intervalStyleDefault;
                return vue.createElementVNode("div", {
                    "key": interval.time,
                    "class": vue.normalizeClass([
                        'v-calendar-daily__day-interval',
                        {
                            'v-calendar-daily__day-interval--hover': highlight.isHighlighted(interval)
                        }
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            height: height
                        },
                        styler({
                            ...interval,
                            category: category
                        })
                    ])
                }, [
                    highlight.genUnderlay(),
                    slots.interval?.(getCategoryScope(base.getSlotScope(interval), category))
                ]);
            }
            function genDayBody(day, category) {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-category__columns"
                }, [
                    genDayBodyCategory(day, category)
                ]);
            }
            function genDayBodyCategory(day, category) {
                const events = getPrefixedEventHandlers(attrs, ':timeCategory', (e)=>{
                    return getCategoryScope(base.getSlotScope(base.getTimestampAtEvent(e, day)), category);
                });
                return vue.createElementVNode("div", vue.mergeProps({
                    "class": "v-calendar-category__column"
                }, events), [
                    slots['day-body']?.(getCategoryScope(base.getSlotScope(day), category))
                ]);
            }
            useRender(()=>vue.createVNode(VCalendarDaily, vue.mergeProps({
                    "class": [
                        'v-calendar-daily',
                        'v-calendar-category'
                    ]
                }, props), {
                    ...slots,
                    days: genDays,
                    'day-header': genDayHeader
                }));
            return {
                ...base,
                parsedCategories: parsedCategories
            };
        }
    });
    /**
   * Centralized key alias mapping for consistent key normalization across the hotkey system.
   *
   * This maps various user-friendly aliases to canonical key names that match
   * KeyboardEvent.key values (in lowercase) where possible.
   */ const keyAliasMap = {
        // Modifier aliases (from vue-use, other libraries, and current implementation)
        control: 'ctrl',
        command: 'cmd',
        option: 'alt',
        // Arrow key aliases (common abbreviations)
        up: 'arrowup',
        down: 'arrowdown',
        left: 'arrowleft',
        right: 'arrowright',
        // Other common key aliases
        esc: 'escape',
        spacebar: ' ',
        space: ' ',
        return: 'enter',
        del: 'delete',
        // Symbol aliases (existing from hotkey-parsing.ts)
        plus: '+',
        slash: '/',
        underscore: '_',
        minus: '-',
        hyphen: '-'
    };
    /**
   * Normalizes a key string to its canonical form using the alias map.
   *
   * @param key - The key string to normalize
   * @returns The canonical key name in lowercase
   */ function normalizeKey(key) {
        const lowerKey = key.toLowerCase();
        return keyAliasMap[lowerKey] || lowerKey;
    }
    // Utilities
    // Types
    class ParseError extends Error {
    }
    /**
   * Splits a single combination string into individual key parts.
   * Grammar:
   *
   * sequence   = alternate *('-' alternate)
   * alternate  = combo *('/' combo)
   * combo      = key *(('+' | '_') key)
   * key        = /./ *(/[^-/+_ ]/)
   *
   */ function parseKeyCombination(input) {
        let pos = 0;
        try {
            const result = parseSequence();
            if (!atEnd()) throw new ParseError(`Unexpected character '${peek()}' at position ${pos}`);
            return result;
        } catch (err) {
            if (err instanceof ParseError) {
                consoleWarn(`Invalid hotkey combination: ${err.message}\n  ${input}\n  ${' '.repeat(pos)}^`);
                return '';
            } else throw err;
        }
        function peek(ahead = 0) {
            return pos + ahead < input.length ? input[pos + ahead] : null;
        }
        function consume() {
            if (pos >= input.length) throw new ParseError('Unexpected end of input');
            return input[pos++];
        }
        function atEnd() {
            return pos >= input.length;
        }
        // sequence = alternate *('-' alternate)
        function parseSequence() {
            const parts = [
                parseAlternate()
            ];
            while(peek() === '-'){
                consume();
                parts.push(parseAlternate());
            }
            if (parts.length === 1) return parts[0];
            return {
                type: 'sequence',
                parts: parts
            };
        }
        // alternate = combo *('/' combo)
        function parseAlternate() {
            const parts = [
                parseCombo()
            ];
            while(peek() === '/'){
                consume();
                parts.push(parseCombo());
            }
            if (parts.length === 1) return parts[0];
            return {
                type: 'alternate',
                parts: parts
            };
        }
        // combo = key *(('+' | '_') key)
        function parseCombo() {
            const keys = [
                parseKey()
            ];
            while(includes([
                '+',
                '_'
            ], peek())){
                consume();
                keys.push(parseKey());
            }
            if (keys.length === 1) return keys[0];
            return {
                type: 'combo',
                parts: keys
            };
        }
        // key = /./ *(/[^-/+_ ]/)
        function parseKey() {
            const ch = peek();
            if (ch == null) throw new ParseError('Unexpected end of input');
            const next = peek(1);
            if (isSep(ch) && next != null && !isSep(next)) throw new ParseError(`Unexpected separator '${ch}' at position ${pos}`);
            const first = consume();
            // separator keys are always a single character
            if (isSep(first)) return first;
            const chars = [
                first
            ];
            while(!atEnd() && !isSep(peek()) && peek() !== ' ')chars.push(consume());
            return normalizeKey(chars.join(''));
        }
    }
    function isSep(char) {
        return includes([
            '-',
            '/',
            '+',
            '_'
        ], char);
    }
    // Composables
    // Types
    const MODIFIERS = [
        'ctrl',
        'shift',
        'alt',
        'meta',
        'cmd'
    ];
    const modifiersSet = new Set(MODIFIERS);
    function isModifier(key) {
        return modifiersSet.has(key);
    }
    const emptyModifiers = Object.fromEntries(MODIFIERS.map((m)=>[
            m,
            false
        ]));
    function useHotkey(keys, callback, options = {}) {
        if (!IN_BROWSER) return function() {};
        const { event: event = 'keydown', inputs: inputs = false, preventDefault: preventDefault = true, sequenceTimeout: sequenceTimeout = 1000 } = options;
        const isMac = navigator?.userAgent?.includes('Macintosh') ?? false;
        let timeout = 0;
        let keyGroups;
        let isSequence = false;
        let groupIndex = 0;
        function isInputFocused() {
            if (vue.toValue(inputs)) return false;
            const activeElement = getActiveElement();
            return activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable || activeElement.contentEditable === 'true');
        }
        function resetSequence() {
            groupIndex = 0;
            clearTimeout(timeout);
        }
        function handler(e) {
            const group = keyGroups[groupIndex];
            if (!group || isInputFocused()) return;
            if (!matchesKeyGroup(e, group, isMac)) {
                if (isSequence) resetSequence();
                return;
            }
            if (vue.toValue(preventDefault)) e.preventDefault();
            if (!isSequence) {
                callback(e);
                return;
            }
            clearTimeout(timeout);
            groupIndex++;
            if (groupIndex === keyGroups.length) {
                callback(e);
                resetSequence();
                return;
            }
            timeout = window.setTimeout(resetSequence, vue.toValue(sequenceTimeout));
        }
        function cleanup() {
            window.removeEventListener(vue.toValue(event), handler);
            clearTimeout(timeout);
        }
        vue.watch(()=>vue.toValue(keys), (newKeys)=>{
            cleanup();
            if (newKeys) {
                const parsed = parseKeyCombination(newKeys.toLowerCase());
                if (parsed) {
                    const parts = typeof parsed !== 'string' && parsed.type === 'sequence' ? parsed.parts : [
                        parsed
                    ];
                    isSequence = parts.length > 1;
                    keyGroups = parts;
                    resetSequence();
                    window.addEventListener(vue.toValue(event), handler);
                }
            }
        }, {
            immediate: true
        });
        // Watch for changes in the event type to re-register the listener
        vue.watch(()=>vue.toValue(event), (newEvent, oldEvent)=>{
            if (oldEvent && keyGroups && keyGroups.length > 0) {
                window.removeEventListener(oldEvent, handler);
                window.addEventListener(newEvent, handler);
            }
        });
        vue.onScopeDispose(cleanup, true);
        return cleanup;
    }
    function matchesKeyGroup(e, group, isMac) {
        if (typeof group !== 'string' && group.type === 'alternate') return group.parts.some((part)=>matchesKeyGroup(e, part, isMac));
        const { modifiers: modifiers, actualKey: actualKey } = parseKeyGroup(group);
        const expectCtrl = modifiers.ctrl || !isMac && (modifiers.cmd || modifiers.meta);
        const expectMeta = isMac && (modifiers.cmd || modifiers.meta);
        return e.ctrlKey === expectCtrl && e.metaKey === expectMeta && e.shiftKey === modifiers.shift && e.altKey === modifiers.alt && e.key.toLowerCase() === actualKey?.toLowerCase();
    }
    function parseKeyGroup(group) {
        const parts = typeof group === 'string' ? [
            group
        ] : group.parts;
        const modifiers = {
            ...emptyModifiers
        };
        let actualKey;
        for (const part of parts)if (isModifier(part)) modifiers[part] = true;
        else // TODO: handle multiple keys
        actualKey = part;
        return {
            modifiers: modifiers,
            actualKey: actualKey
        };
    }
    // Utilities
    const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
    const presets = {
        'credit-card': '#### - #### - #### - ####',
        date: '##/##/####',
        'date-time': '##/##/#### ##:##',
        'iso-date': '####-##-##',
        'iso-date-time': '####-##-## ##:##',
        phone: '(###) ### - ####',
        social: '###-##-####',
        time: '##:##',
        'time-with-seconds': '##:##:##'
    };
    const defaultTokens = {
        '#': {
            pattern: /[0-9]/
        },
        A: {
            pattern: /[A-Z]/i,
            convert: (v)=>v.toUpperCase()
        },
        a: {
            pattern: /[a-z]/i,
            convert: (v)=>v.toLowerCase()
        },
        N: {
            pattern: /[0-9A-Z]/i,
            convert: (v)=>v.toUpperCase()
        },
        n: {
            pattern: /[0-9a-z]/i,
            convert: (v)=>v.toLowerCase()
        },
        X: {
            pattern: defaultDelimiters
        }
    };
    function useMask(props) {
        const mask = vue.computed(()=>{
            if (typeof props.mask === 'string') {
                if (props.mask in presets) return presets[props.mask];
                return props.mask;
            }
            return props.mask?.mask ?? '';
        });
        const tokens = vue.computed(()=>{
            return {
                ...defaultTokens,
                ...isObject(props.mask) ? props.mask.tokens : null
            };
        });
        function isMask(char) {
            return char in tokens.value;
        }
        function maskValidates(mask, char) {
            if (char == null || !isMask(mask)) return false;
            const item = tokens.value[mask];
            if (item.pattern) return item.pattern.test(char);
            return item.test(char);
        }
        function convert(mask, char) {
            const item = tokens.value[mask];
            return item.convert ? item.convert(char) : char;
        }
        function maskText(text) {
            const trimmedText = text?.trim().replace(/\s+/g, ' ');
            if (trimmedText == null) return '';
            if (!mask.value.length || !trimmedText.length) return trimmedText;
            let textIndex = 0;
            let maskIndex = 0;
            let newText = '';
            while(maskIndex < mask.value.length){
                const mchar = mask.value[maskIndex];
                const tchar = trimmedText[textIndex];
                // Escaped character in mask, the next mask character is inserted
                if (mchar === '\\') {
                    newText += mask.value[maskIndex + 1];
                    maskIndex += 2;
                    continue;
                }
                if (!isMask(mchar)) {
                    newText += mchar;
                    if (tchar === mchar) textIndex++;
                } else if (maskValidates(mchar, tchar)) {
                    newText += convert(mchar, tchar);
                    textIndex++;
                } else if (textIndex < trimmedText.length) {
                    // No match, try the next input character
                    textIndex++;
                    continue;
                } else break;
                maskIndex++;
            }
            return newText;
        }
        function unmaskText(text) {
            if (text == null) return null;
            if (!mask.value.length || !text.length) return text;
            let result = '';
            const unmaskMap = getUnmaskMap(text);
            for(let i = 0; i < text.length; i++)if (!unmaskMap[i]) result += text[i];
            return result;
        }
        function isDelimiter(text, index) {
            if (!mask.value.length || !text.length) return false;
            return !!getUnmaskMap(text)[index];
        }
        function getUnmaskMap(text) {
            if (text == null || !mask.value.length || !text.length) return [];
            let textIndex = 0;
            let maskIndex = 0;
            const result = Array.from({
                length: text.length
            }, ()=>true);
            while(true){
                const mchar = mask.value[maskIndex];
                const tchar = text[textIndex];
                if (tchar == null) break;
                if (mchar == null) {
                    result[textIndex] = false;
                    textIndex++;
                    continue;
                }
                // Escaped character in mask, skip the next input character
                if (mchar === '\\') {
                    if (tchar === mask.value[maskIndex + 1]) textIndex++;
                    maskIndex += 2;
                    continue;
                }
                if (maskValidates(mchar, tchar)) {
                    // masked char
                    result[textIndex] = false;
                    textIndex++;
                    maskIndex++;
                    continue;
                } else if (mchar !== tchar) {
                    // input doesn't match mask, skip forward until it does
                    while(true){
                        const mchar = mask.value[maskIndex++];
                        if (mchar == null || maskValidates(mchar, tchar)) break;
                    }
                    continue;
                }
                textIndex++;
                maskIndex++;
            }
            return result;
        }
        function isValid(text) {
            if (!text) return false;
            return unmaskText(text) === unmaskText(maskText(text));
        }
        function isComplete(text) {
            if (!text) return false;
            const maskedText = maskText(text);
            return maskedText.length === mask.value.length && isValid(text);
        }
        return {
            isDelimiter: isDelimiter,
            isValid: isValid,
            isComplete: isComplete,
            mask: maskText,
            unmask: unmaskText
        };
    }
    // Types
    const VCalendarWeekly = defineComponent({
        name: 'VCalendarWeekly',
        props: {
            minWeeks: {
                validate: validateNumber,
                default: 1
            },
            monthFormat: Function,
            showWeek: Boolean,
            color: String,
            shortWeekdays: {
                type: Boolean,
                default: true
            },
            showMonthOnFirst: {
                type: Boolean,
                default: true
            },
            shortMonths: {
                type: Boolean,
                default: true
            },
            hideHeader: Boolean,
            ...makeCalendarBaseProps()
        },
        setup (props, { slots: slots, attrs: attrs }) {
            const base = useCalendarBase(props);
            const theme = useTheme();
            const parsedMinWeeks = vue.computed(()=>{
                return parseInt(String(props.minWeeks));
            });
            const days = vue.computed(()=>{
                const minDays = parsedMinWeeks.value * base.parsedWeekdays.value.length;
                const start = base.getStartOfWeek(base.parsedStart.value);
                const end = base.getEndOfWeek(base.parsedEnd.value);
                return createDayList(start, end, base.times.today, base.weekdaySkips.value, Number.MAX_SAFE_INTEGER, minDays);
            });
            const todayWeek = vue.computed(()=>{
                const today = base.times.today;
                const start = base.getStartOfWeek(today);
                const end = base.getEndOfWeek(today);
                return createDayList(start, end, today, base.weekdaySkips.value, base.parsedWeekdays.value.length, base.parsedWeekdays.value.length);
            });
            const monthFormatter = vue.computed(()=>{
                if (props.monthFormat) // TODO: what happens when this is a string?
                return props.monthFormat;
                return createNativeLocaleFormatter(base.locale.current.value, (_tms, short)=>({
                        timeZone: 'UTC',
                        month: short ? 'short' : 'long'
                    }));
            });
            function isOutside(day) {
                const dayIdentifier = getDayIdentifier(day);
                return dayIdentifier < getDayIdentifier(base.parsedStart.value) || dayIdentifier > getDayIdentifier(base.parsedEnd.value);
            }
            function genHead() {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-weekly__head",
                    "role": "row"
                }, [
                    genHeadDays()
                ]);
            }
            function genHeadDays() {
                const header = todayWeek.value.map(genHeadDay);
                if (props.showWeek) header.unshift(vue.createElementVNode("div", {
                    "class": "v-calendar-weekly__head-weeknumber"
                }, null));
                return header;
            }
            function genHeadDay(day, index) {
                const outside = isOutside(days.value[index]);
                const color = day.present ? props.color : undefined;
                return vue.createElementVNode("div", vue.mergeProps(base.getColorProps({
                    text: color
                }), {
                    "key": day.date,
                    "class": [
                        'v-calendar-weekly__head-weekday',
                        base.getRelativeClasses(day, outside)
                    ],
                    "role": "columnheader"
                }), [
                    base.weekdayFormatter.value(day, props.shortWeekdays)
                ]);
            }
            function genWeeks() {
                const daysValue = days.value;
                const weekDays = base.parsedWeekdays.value.length;
                const weeks = [];
                for(let i = 0; i < daysValue.length; i += weekDays)weeks.push(genWeek(daysValue.slice(i, i + weekDays), getWeekNumber(daysValue[i])));
                return weeks;
            }
            function genWeek(week, weekNumber) {
                const weekNodes = week.map((day, index)=>genDay(day, index, week));
                if (props.showWeek) weekNodes.unshift(genWeekNumber(weekNumber));
                return vue.createElementVNode("div", {
                    "key": week[0].date,
                    "class": "v-calendar-weekly__week",
                    "role": "row"
                }, [
                    weekNodes
                ]);
            }
            function getWeekNumber(determineDay) {
                return base.getWeekNumber(determineDay);
            }
            function genWeekNumber(weekNumber) {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-weekly__weeknumber"
                }, [
                    vue.createElementVNode("small", null, [
                        String(weekNumber)
                    ])
                ]);
            }
            function genDay(day, index, week) {
                const outside = isOutside(day);
                const events = getPrefixedEventHandlers(attrs, ':day', (nativeEvent)=>{
                    return {
                        nativeEvent: nativeEvent,
                        ...day
                    };
                });
                return vue.createElementVNode("div", vue.mergeProps({
                    "key": day.date,
                    "class": [
                        'v-calendar-weekly__day',
                        base.getRelativeClasses(day, outside)
                    ],
                    "role": "cell"
                }, events), [
                    genDayLabel(day),
                    slots.day?.({
                        outside: outside,
                        index: index,
                        week: week,
                        ...day
                    })
                ]);
            }
            function genDayLabel(day) {
                return vue.createElementVNode("div", {
                    "class": "v-calendar-weekly__day-label"
                }, [
                    slots['day-label']?.(day) ?? genDayLabelButton(day)
                ]);
            }
            function genDayLabelButton(day) {
                const hasMonth = day.day === 1 && props.showMonthOnFirst;
                const events = getPrefixedEventHandlers(attrs, ':date', (nativeEvent)=>({
                        nativeEvent: nativeEvent,
                        ...day
                    }));
                return vue.createVNode(VIconBtn, vue.mergeProps({
                    "active": day.present,
                    "activeColor": props.color,
                    "variant": "outlined",
                    "baseVariant": "text",
                    "onUpdate:active": noop
                }, events), {
                    default: ()=>[
                            hasMonth ? monthFormatter.value(day, props.shortMonths) + ' ' + base.dayFormatter.value(day, false) : base.dayFormatter.value(day, false)
                        ]
                });
            }
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-calendar-weekly',
                        theme.themeClasses.value
                    ]),
                    "onDragstart": (e)=>e.preventDefault()
                }, [
                    !props.hideHeader ? genHead() : undefined,
                    genWeeks()
                ]));
            return {
                ...base,
                days: days,
                todayWeek: todayWeek,
                monthFormatter: monthFormatter,
                isOutside: isOutside
            };
        }
    });
    // Types
    const MILLIS_IN_DAY = 86400000;
    function getVisuals(events, minStart = 0) {
        const visuals = events.map((event)=>({
                event: event,
                columnCount: 0,
                column: 0,
                left: 0,
                width: 100
            }));
        visuals.sort((a, b)=>{
            return Math.max(minStart, a.event.startTimestampIdentifier) - Math.max(minStart, b.event.startTimestampIdentifier) || b.event.endTimestampIdentifier - a.event.endTimestampIdentifier;
        });
        return visuals;
    }
    function hasOverlap(s0, e0, s1, e1, exclude = true) {
        return exclude ? !(s0 >= e1 || e0 <= s1) : !(s0 > e1 || e0 < s1);
    }
    function setColumnCount(groups) {
        groups.forEach((group)=>{
            group.visuals.forEach((groupVisual)=>{
                groupVisual.columnCount = groups.length;
            });
        });
    }
    function getRange(event) {
        return [
            event.startTimestampIdentifier,
            event.endTimestampIdentifier
        ];
    }
    function getDayRange(event) {
        return [
            event.startIdentifier,
            event.endIdentifier
        ];
    }
    function getNormalizedRange(event, dayStart) {
        return [
            Math.max(dayStart, event.startTimestampIdentifier),
            Math.min(dayStart + MILLIS_IN_DAY, event.endTimestampIdentifier)
        ];
    }
    function getOpenGroup(groups, start, end, timed) {
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            let intersected = false;
            if (hasOverlap(start, end, group.start, group.end, timed)) for(let k = 0; k < group.visuals.length; k++){
                const groupVisual = group.visuals[k];
                const [groupStart, groupEnd] = timed ? getRange(groupVisual.event) : getDayRange(groupVisual.event);
                if (hasOverlap(start, end, groupStart, groupEnd, timed)) {
                    intersected = true;
                    break;
                }
            }
            if (!intersected) return i;
        }
        return -1;
    }
    function getOverlapGroupHandler(firstWeekday) {
        const handler = {
            groups: [],
            min: -1,
            max: -1,
            reset: ()=>{
                handler.groups = [];
                handler.min = handler.max = -1;
            },
            getVisuals: (day, dayEvents, timed, reset = false)=>{
                if (day.weekday === firstWeekday || reset) handler.reset();
                const dayStart = getTimestampIdentifier(day);
                const visuals = getVisuals(dayEvents, dayStart);
                visuals.forEach((visual)=>{
                    const [start, end] = timed ? getRange(visual.event) : getDayRange(visual.event);
                    if (handler.groups.length > 0 && !hasOverlap(start, end, handler.min, handler.max, timed)) {
                        setColumnCount(handler.groups);
                        handler.reset();
                    }
                    let targetGroup = getOpenGroup(handler.groups, start, end, timed);
                    if (targetGroup === -1) {
                        targetGroup = handler.groups.length;
                        handler.groups.push({
                            start: start,
                            end: end,
                            visuals: []
                        });
                    }
                    const target = handler.groups[targetGroup];
                    target.visuals.push(visual);
                    target.start = Math.min(target.start, start);
                    target.end = Math.max(target.end, end);
                    visual.column = targetGroup;
                    if (handler.min === -1) {
                        handler.min = start;
                        handler.max = end;
                    } else {
                        handler.min = Math.min(handler.min, start);
                        handler.max = Math.max(handler.max, end);
                    }
                });
                setColumnCount(handler.groups);
                if (timed) handler.reset();
                return visuals;
            }
        };
        return handler;
    }
    // Types
    const FULL_WIDTH$1 = 100;
    const column = (events, firstWeekday, overlapThreshold)=>{
        const handler = getOverlapGroupHandler(firstWeekday);
        return (day, dayEvents, timed, reset)=>{
            const visuals = handler.getVisuals(day, dayEvents, timed, reset);
            if (timed) visuals.forEach((visual)=>{
                visual.left = visual.column * FULL_WIDTH$1 / visual.columnCount;
                visual.width = FULL_WIDTH$1 / visual.columnCount;
            });
            return visuals;
        };
    };
    // Types
    const FULL_WIDTH = 100;
    const DEFAULT_OFFSET = 5;
    const WIDTH_MULTIPLIER = 1.7;
    /**
   * Variation of column mode where events can be stacked. The priority of this
   * mode is to stack events together taking up the least amount of space while
   * trying to ensure the content of the event is always visible as well as its
   * start and end. A sibling column has intersecting event content and must be
   * placed beside each other. Non-sibling columns are offset by 5% from the
   * previous column. The width is scaled by 1.7 so the events overlap and
   * whitespace is reduced. If there is a hole in columns the event width is
   * scaled up so it intersects with the next column. The columns have equal
   * width in the space they are given. If the event doesn't have any to the
   * right of it that intersect with its content, its right side is extended
   * to the right side.
   */ const stack = (events, firstWeekday, overlapThreshold)=>{
        const handler = getOverlapGroupHandler(firstWeekday);
        // eslint-disable-next-line max-statements
        return (day, dayEvents, timed, reset)=>{
            if (!timed) return handler.getVisuals(day, dayEvents, timed, reset);
            const dayStart = getTimestampIdentifier(day);
            const visuals = getVisuals(dayEvents, dayStart);
            const groups = getGroups(visuals, dayStart);
            for (const group of groups){
                const nodes = [];
                for (const visual of group.visuals){
                    const child = getNode(visual, dayStart);
                    const index = getNextIndex(child, nodes);
                    if (index === false) {
                        const parent = getParent(child, nodes);
                        if (parent) {
                            child.parent = parent;
                            child.sibling = hasOverlap(child.start, child.end, parent.start, addTime(parent.start, overlapThreshold));
                            child.index = parent.index + 1;
                            parent.children.push(child);
                        }
                    } else {
                        const [parent] = getOverlappingRange(child, nodes, index - 1, index - 1);
                        const children = getOverlappingRange(child, nodes, index + 1, index + nodes.length, true);
                        child.children = children;
                        child.index = index;
                        if (parent) {
                            child.parent = parent;
                            child.sibling = hasOverlap(child.start, child.end, parent.start, addTime(parent.start, overlapThreshold));
                            parent.children.push(child);
                        }
                        for (const grand of children){
                            if (grand.parent === parent) grand.parent = child;
                            const grandNext = grand.index - child.index <= 1;
                            if (grandNext && child.sibling && hasOverlap(child.start, addTime(child.start, overlapThreshold), grand.start, grand.end)) grand.sibling = true;
                        }
                    }
                    nodes.push(child);
                }
                calculateBounds(nodes, overlapThreshold);
            }
            visuals.sort((a, b)=>a.left - b.left || a.event.startTimestampIdentifier - b.event.startTimestampIdentifier);
            return visuals;
        };
    };
    function calculateBounds(nodes, overlapThreshold) {
        for (const node of nodes){
            const { visual: visual, parent: parent } = node;
            const columns = getMaxChildIndex(node) + 1;
            const spaceLeft = parent ? parent.visual.left : 0;
            const spaceWidth = FULL_WIDTH - spaceLeft;
            const offset = Math.min(DEFAULT_OFFSET, FULL_WIDTH / columns);
            const columnWidthMultiplier = getColumnWidthMultiplier(node, nodes);
            const columnOffset = spaceWidth / (columns - node.index + 1);
            const columnWidth = spaceWidth / (columns - node.index + (node.sibling ? 1 : 0)) * columnWidthMultiplier;
            if (parent) visual.left = node.sibling ? spaceLeft + columnOffset : spaceLeft + offset;
            visual.width = hasFullWidth(node, nodes, overlapThreshold) ? FULL_WIDTH - visual.left : Math.min(FULL_WIDTH - visual.left, columnWidth * WIDTH_MULTIPLIER);
        }
    }
    function getColumnWidthMultiplier(node, nodes) {
        if (!node.children.length) return 1;
        const maxColumn = node.index + nodes.length;
        const minColumn = node.children.reduce((min, c)=>Math.min(min, c.index), maxColumn);
        return minColumn - node.index;
    }
    function getOverlappingIndices(node, nodes) {
        const indices = [];
        for (const other of nodes)if (hasOverlap(node.start, node.end, other.start, other.end)) indices.push(other.index);
        return indices;
    }
    function getNextIndex(node, nodes) {
        const indices = getOverlappingIndices(node, nodes);
        indices.sort();
        for(let i = 0; i < indices.length; i++){
            if (i < indices[i]) return i;
        }
        return false;
    }
    function getOverlappingRange(node, nodes, indexMin, indexMax, returnFirstColumn = false) {
        const overlapping = [];
        for (const other of nodes)if (other.index >= indexMin && other.index <= indexMax && hasOverlap(node.start, node.end, other.start, other.end)) overlapping.push(other);
        if (returnFirstColumn && overlapping.length > 0) {
            const first = overlapping.reduce((min, n)=>Math.min(min, n.index), overlapping[0].index);
            return overlapping.filter((n)=>n.index === first);
        }
        return overlapping;
    }
    function getParent(node, nodes) {
        let parent = null;
        for (const other of nodes)if (hasOverlap(node.start, node.end, other.start, other.end) && (parent === null || other.index > parent.index)) parent = other;
        return parent;
    }
    function hasFullWidth(node, nodes, overlapThreshold) {
        for (const other of nodes){
            if (other !== node && other.index > node.index && hasOverlap(node.start, addTime(node.start, overlapThreshold), other.start, other.end)) return false;
        }
        return true;
    }
    function getGroups(visuals, dayStart) {
        const groups = [];
        for (const visual of visuals){
            const [start, end] = getNormalizedRange(visual.event, dayStart);
            let added = false;
            for (const group of groups)if (hasOverlap(start, end, group.start, group.end)) {
                group.visuals.push(visual);
                group.end = Math.max(group.end, end);
                added = true;
                break;
            }
            if (!added) groups.push({
                start: start,
                end: end,
                visuals: [
                    visual
                ]
            });
        }
        return groups;
    }
    function getNode(visual, dayStart) {
        const [start, end] = getNormalizedRange(visual.event, dayStart);
        return {
            parent: null,
            sibling: true,
            index: 0,
            visual: visual,
            start: start,
            end: end,
            children: []
        };
    }
    function getMaxChildIndex(node) {
        let max = node.index;
        for (const child of node.children){
            const childMax = getMaxChildIndex(child);
            if (childMax > max) max = childMax;
        }
        return max;
    }
    function addTime(identifier, minutes) {
        const removeMinutes = identifier % 100;
        const totalMinutes = removeMinutes + minutes;
        const addHours = Math.floor(totalMinutes / 60);
        const addMinutes = totalMinutes % 60;
        return identifier - removeMinutes + addHours * 100 + addMinutes;
    }
    // Types
    const CalendarEventOverlapModes = {
        stack: stack,
        column: column
    };
    // Types
    function parseEvent(input, index, startProperty, endProperty, timed = false, category = false) {
        const startInput = input[startProperty];
        const endInput = input[endProperty];
        const startParsed = parseTimestamp(startInput, true);
        const endParsed = endInput ? parseTimestamp(endInput, true) : startParsed;
        const start = isTimedless(startInput) ? updateHasTime(startParsed, timed) : startParsed;
        const end = isTimedless(endInput) ? updateHasTime(endParsed, timed) : endParsed;
        const startIdentifier = getDayIdentifier(start);
        const startTimestampIdentifier = getTimestampIdentifier(start);
        const endIdentifier = getDayIdentifier(end);
        const endOffset = start.hasTime ? 0 : 2359;
        const endTimestampIdentifier = getTimestampIdentifier(end) + endOffset;
        const allDay = !start.hasTime;
        return {
            input: input,
            start: start,
            startIdentifier: startIdentifier,
            startTimestampIdentifier: startTimestampIdentifier,
            end: end,
            endIdentifier: endIdentifier,
            endTimestampIdentifier: endTimestampIdentifier,
            allDay: allDay,
            index: index,
            category: category
        };
    }
    function isEventOn(event, dayIdentifier) {
        return dayIdentifier >= event.startIdentifier && dayIdentifier <= event.endIdentifier;
    }
    function isEventOnDay(event, day, inRange) {
        if (inRange) {
            const dayStart = nextMinutes(copyTimestamp(day), inRange[0]);
            const dayEnd = nextMinutes(copyTimestamp(day), inRange[1]);
            const starts = event.startTimestampIdentifier < getTimestampIdentifier(dayEnd);
            const ends = event.endTimestampIdentifier > getTimestampIdentifier(dayStart);
            return starts && ends;
        }
        return isEventOn(event, getDayIdentifier(day));
    }
    function isEventHiddenOn(event, day) {
        return event.end.time === '00:00' && event.end.date === day.date && event.start.date !== day.date;
    }
    function isEventStart(event, day, dayIdentifier, firstWeekday) {
        return dayIdentifier === event.startIdentifier || firstWeekday === day.weekday && isEventOn(event, dayIdentifier);
    }
    function isEventOverlapping(event, startIdentifier, endIdentifier) {
        return startIdentifier <= event.endIdentifier && endIdentifier >= event.startIdentifier;
    }
    // Types
    // Constants
    const WIDTH_FULL = 100;
    const WIDTH_START = 95;
    const makeCalendarWithEventsProps = propsFactory({
        events: {
            type: Array,
            default: ()=>[]
        },
        eventStart: {
            type: String,
            default: 'start'
        },
        eventEnd: {
            type: String,
            default: 'end'
        },
        eventTimed: {
            type: [
                String,
                Function
            ],
            default: 'timed'
        },
        eventCategory: {
            type: [
                String,
                Function
            ],
            default: 'category'
        },
        eventHeight: {
            type: Number,
            default: 20
        },
        eventColor: {
            type: [
                String,
                Function
            ],
            default: 'primary'
        },
        eventTextColor: {
            type: [
                String,
                Function
            ]
        },
        eventName: {
            type: [
                String,
                Function
            ],
            default: 'name'
        },
        eventOverlapThreshold: {
            type: [
                String,
                Number
            ],
            default: 60
        },
        eventOverlapMode: {
            type: [
                String,
                Function
            ],
            default: 'stack',
            validate: (mode)=>mode in CalendarEventOverlapModes || typeof mode === 'function'
        },
        eventMore: {
            type: Boolean,
            default: true
        },
        eventMoreText: {
            type: String,
            default: '$vuetify.calendar.moreEvents'
        },
        eventRipple: {
            type: [
                Boolean,
                Object
            ],
            default: null
        },
        eventMarginBottom: {
            type: Number,
            default: 1
        }
    }, 'VCalendar-events');
    function useCalendarWithEvents(props, slots, attrs) {
        const base = useCalendarBase(props);
        const noEvents = vue.computed(()=>{
            return !Array.isArray(props.events) || props.events.length === 0;
        });
        const categoryMode = vue.computed(()=>{
            return props.type === 'category';
        });
        const eventTimedFunction = vue.computed(()=>{
            return typeof props.eventTimed === 'function' ? props.eventTimed : (event)=>!!event[props.eventTimed];
        });
        const eventCategoryFunction = vue.computed(()=>{
            return typeof props.eventCategory === 'function' ? props.eventCategory : (event)=>event[props.eventCategory];
        });
        const parsedEvents = vue.computed(()=>{
            if (!props.events) return [];
            return props.events.map((event, index)=>parseEvent(event, index, props.eventStart || '', props.eventEnd || '', eventTimedFunction.value(event), categoryMode.value ? eventCategoryFunction.value(event) : false));
        });
        const parsedEventOverlapThreshold = vue.computed(()=>{
            return parseInt(String(props.eventOverlapThreshold || 0));
        });
        const eventTextColorFunction = vue.computed(()=>{
            return typeof props.eventTextColor === 'function' ? props.eventTextColor : ()=>props.eventTextColor;
        });
        const eventNameFunction = vue.computed(()=>{
            return typeof props.eventName === 'function' ? props.eventName : (event, timedEvent)=>event.input[props.eventName] || '';
        });
        const eventModeFunction = vue.computed(()=>{
            return typeof props.eventOverlapMode === 'function' ? props.eventOverlapMode : CalendarEventOverlapModes[props.eventOverlapMode];
        });
        const eventWeekdays = vue.computed(()=>{
            return base.effectiveWeekdays.value;
        });
        function eventColorFunction(e) {
            return typeof props.eventColor === 'function' ? props.eventColor(e) : e.color || props.eventColor;
        }
        const eventsRef = vue.ref([]);
        function updateEventVisibility() {
            if (noEvents.value || !props.eventMore) return;
            const eventHeight = props.eventHeight || 0;
            const eventsMap = getEventsMap();
            for(const date in eventsMap){
                const { parent: parent, events: events, more: more } = eventsMap[date];
                if (!more) break;
                const parentBounds = parent.getBoundingClientRect();
                const last = events.length - 1;
                const eventsSorted = events.map((event)=>({
                        event: event,
                        bottom: event.getBoundingClientRect().bottom
                    })).sort((a, b)=>a.bottom - b.bottom);
                let hidden = 0;
                for(let i = 0; i <= last; i++){
                    const bottom = eventsSorted[i].bottom;
                    const hide = i === last ? bottom > parentBounds.bottom : bottom + eventHeight > parentBounds.bottom;
                    if (hide) {
                        eventsSorted[i].event.style.display = 'none';
                        hidden++;
                    }
                }
                // TODO: avoid direct DOM manipulation
                if (hidden) {
                    more.style.display = '';
                    more.innerHTML = base.locale.t(props.eventMoreText, hidden);
                } else more.style.display = 'none';
            }
        }
        function getEventsMap() {
            const eventsMap = {};
            const elements = eventsRef.value;
            if (!elements || !elements.length) return eventsMap;
            elements.forEach((el)=>{
                const date = el.getAttribute('data-date');
                if (el.parentElement && date) {
                    if (!(date in eventsMap)) eventsMap[date] = {
                        parent: el.parentElement,
                        more: null,
                        events: []
                    };
                    if (el.getAttribute('data-more')) eventsMap[date].more = el;
                    else {
                        eventsMap[date].events.push(el);
                        el.style.display = '';
                    }
                }
            });
            return eventsMap;
        }
        function genDayEvent({ event: event }, day) {
            const eventHeight = props.eventHeight || 0;
            const eventMarginBottom = props.eventMarginBottom || 0;
            const dayIdentifier = getDayIdentifier(day);
            const week = day.week;
            const start = dayIdentifier === event.startIdentifier;
            let end = dayIdentifier === event.endIdentifier;
            let width = WIDTH_START;
            if (!categoryMode.value) for(let i = day.index + 1; i < week.length; i++){
                const weekdayIdentifier = getDayIdentifier(week[i]);
                if (event.endIdentifier >= weekdayIdentifier) {
                    width += WIDTH_FULL;
                    end = end || weekdayIdentifier === event.endIdentifier;
                } else {
                    end = true;
                    break;
                }
            }
            const scope = {
                eventParsed: event,
                day: day,
                start: start,
                end: end,
                timed: false
            };
            return genEvent(event, scope, false, {
                class: [
                    'v-event',
                    {
                        'v-event-start': start,
                        'v-event-end': end
                    }
                ],
                style: {
                    height: `${eventHeight}px`,
                    width: `${width}%`,
                    marginBottom: `${eventMarginBottom}px`
                },
                'data-date': day.date
            });
        }
        function genTimedEvent({ event: event, left: left, width: width }, day) {
            const startDelta = day.timeDelta(event.start, day);
            const endDelta = day.timeDelta(event.end, day);
            if (endDelta === false || startDelta === false || endDelta < 0 || startDelta >= 1 || isEventHiddenOn(event, day)) return false;
            const dayIdentifier = getDayIdentifier(day);
            const start = event.startIdentifier >= dayIdentifier;
            const end = event.endIdentifier > dayIdentifier;
            const top = day.timeToY(event.start, day);
            const bottom = day.timeToY(event.end, day);
            const height = Math.max(props.eventHeight || 0, bottom - top);
            const scope = {
                eventParsed: event,
                day: day,
                start: start,
                end: end,
                timed: true
            };
            return genEvent(event, scope, true, {
                class: 'v-event-timed',
                style: {
                    top: `${top}px`,
                    height: `${height}px`,
                    left: `${left}%`,
                    width: `${width}%`
                }
            });
        }
        function genEvent(event, scopeInput, timedEvent, data) {
            const slot = slots.event;
            const text = eventTextColorFunction.value(event.input);
            const background = eventColorFunction(event.input);
            const overlapsNoon = event.start.hour < 12 && event.end.hour >= 12;
            const singline = diffMinutes(event.start, event.end) <= parsedEventOverlapThreshold.value;
            const formatTime = (withTime, ampm)=>{
                const hour12 = props.format === 'ampm' ? true : props.format === '24hr' ? false : undefined;
                const formatter = base.getFormatter({
                    timeZone: 'UTC',
                    hour: props.format === '24hr' ? '2-digit' : 'numeric',
                    minute: withTime.minute > 0 ? 'numeric' : undefined,
                    hour12: hour12
                });
                return formatter(withTime, true);
            };
            const timeSummary = ()=>formatTime(event.start) + ' - ' + formatTime(event.end);
            const eventSummary = ()=>{
                const name = eventNameFunction.value(event, timedEvent);
                if (event.start.hasTime) {
                    if (timedEvent) {
                        const time = timeSummary();
                        const delimiter = singline ? ', ' : vue.createElementVNode("br", null, null);
                        return vue.createElementVNode("span", {
                            "class": "v-event-summary"
                        }, [
                            vue.createElementVNode("strong", null, [
                                name
                            ]),
                            delimiter,
                            time
                        ]);
                    } else {
                        const time = formatTime(event.start);
                        return vue.createElementVNode("span", {
                            "class": "v-event-summary"
                        }, [
                            vue.createElementVNode("strong", null, [
                                time
                            ]),
                            vue.createTextVNode(" "),
                            name
                        ]);
                    }
                }
                return vue.createElementVNode("span", {
                    "class": "v-event-summary"
                }, [
                    name
                ]);
            };
            const scope = {
                ...scopeInput,
                event: event.input,
                outside: scopeInput.day.outside,
                singline: singline,
                overlapsNoon: overlapsNoon,
                formatTime: formatTime,
                timeSummary: timeSummary,
                eventSummary: eventSummary
            };
            const events = getPrefixedEventHandlers(attrs, ':event', (nativeEvent)=>({
                    ...scope,
                    nativeEvent: nativeEvent
                }));
            return vue.withDirectives(vue.createElementVNode("div", vue.mergeProps(base.getColorProps({
                text: text,
                background: background
            }), events, data, {
                "ref_for": true,
                "ref": eventsRef
            }), [
                slot?.(scope) ?? genName(eventSummary)
            ]), [
                [
                    Ripple,
                    props.eventRipple ?? true
                ]
            ]);
        }
        function genName(eventSummary) {
            return vue.createElementVNode("div", {
                "class": "pl-1"
            }, [
                eventSummary()
            ]);
        }
        function genPlaceholder(day) {
            const height = (props.eventHeight || 0) + (props.eventMarginBottom || 0);
            return vue.createElementVNode("div", {
                "style": {
                    height: `${height}px`
                },
                "data-date": day.date,
                "ref_for": true,
                "ref": eventsRef
            }, null);
        }
        function genMore(day) {
            const eventHeight = props.eventHeight || 0;
            const eventMarginBottom = props.eventMarginBottom || 0;
            const events = getPrefixedEventHandlers(attrs, ':more', (nativeEvent)=>({
                    nativeEvent: nativeEvent,
                    ...day
                }));
            return vue.withDirectives(vue.createElementVNode("div", vue.mergeProps({
                "class": [
                    'v-event-more pl-1',
                    {
                        'v-outside': day.outside
                    }
                ],
                "data-date": day.date,
                "data-more": "1",
                "style": {
                    display: 'none',
                    height: `${eventHeight}px`,
                    marginBottom: `${eventMarginBottom}px`
                },
                "ref_for": true,
                "ref": eventsRef
            }, events), null), [
                [
                    Ripple,
                    props.eventRipple ?? true
                ]
            ]);
        }
        function getVisibleEvents() {
            const days = base.days.value;
            const start = getDayIdentifier(days[0]);
            const end = getDayIdentifier(days[days.length - 1]);
            return parsedEvents.value.filter((event)=>isEventOverlapping(event, start, end));
        }
        function isEventForCategory(event, category) {
            return !categoryMode.value || typeof category === 'object' && category.categoryName && category.categoryName === event.category || typeof event.category === 'string' && category === event.category || typeof event.category !== 'string' && category === null;
        }
        function getEventsForDay(day) {
            const identifier = getDayIdentifier(day);
            const firstWeekday = eventWeekdays.value[0];
            return parsedEvents.value.filter((event)=>isEventStart(event, day, identifier, firstWeekday));
        }
        function getEventsForDayAll(day) {
            const identifier = getDayIdentifier(day);
            const firstWeekday = eventWeekdays.value[0];
            return parsedEvents.value.filter((event)=>event.allDay && (categoryMode.value ? isEventOn(event, identifier) : isEventStart(event, day, identifier, firstWeekday)) && isEventForCategory(event, day.category));
        }
        function getEventsForDayTimed(day) {
            return parsedEvents.value.filter((event)=>!event.allDay && isEventOnDay(event, day, day.intervalRange) && isEventForCategory(event, day.category));
        }
        function getScopedSlots() {
            if (noEvents.value) return {
                ...slots
            };
            const mode = eventModeFunction.value(parsedEvents.value, eventWeekdays.value[0], parsedEventOverlapThreshold.value);
            const isNode = (input)=>!!input;
            const getSlotChildren = (day, getter, mapper, timed)=>{
                const events = getter(day);
                const visuals = mode(day, events, timed, categoryMode.value);
                if (timed) return visuals.map((visual)=>mapper(visual, day)).filter(isNode);
                const children = [];
                visuals.forEach((visual, index)=>{
                    while(children.length < visual.column)children.push(genPlaceholder(day));
                    const mapped = mapper(visual, day);
                    if (mapped) children.push(mapped);
                });
                return children;
            };
            return {
                ...slots,
                day: (day)=>{
                    let children = getSlotChildren(day, getEventsForDay, genDayEvent, false);
                    if (children && children.length > 0 && props.eventMore) children.push(genMore(day));
                    if (slots.day) {
                        const slot = slots.day(day);
                        if (slot) children = children ? children.concat(slot) : slot;
                    }
                    return children;
                },
                'day-header': (day)=>{
                    let children = getSlotChildren(day, getEventsForDayAll, genDayEvent, false);
                    if (slots['day-header']) {
                        const slot = slots['day-header'](day);
                        if (slot) children = children ? children.concat(slot) : slot;
                    }
                    return children;
                },
                'day-body': (day)=>{
                    const events = getSlotChildren(day, getEventsForDayTimed, genTimedEvent, true);
                    let children = [
                        vue.createElementVNode("div", {
                            "class": "v-event-timed-container"
                        }, [
                            events
                        ])
                    ];
                    if (slots['day-body']) {
                        const slot = slots['day-body'](day);
                        if (slot) children = children.concat(slot);
                    }
                    return children;
                }
            };
        }
        return {
            ...base,
            noEvents: noEvents,
            parsedEvents: parsedEvents,
            parsedEventOverlapThreshold: parsedEventOverlapThreshold,
            eventTimedFunction: eventTimedFunction,
            eventCategoryFunction: eventCategoryFunction,
            eventTextColorFunction: eventTextColorFunction,
            eventNameFunction: eventNameFunction,
            eventModeFunction: eventModeFunction,
            eventWeekdays: eventWeekdays,
            categoryMode: categoryMode,
            eventColorFunction: eventColorFunction,
            eventsRef: eventsRef,
            updateEventVisibility: updateEventVisibility,
            getEventsMap: getEventsMap,
            genDayEvent: genDayEvent,
            genTimedEvent: genTimedEvent,
            genEvent: genEvent,
            genName: genName,
            genPlaceholder: genPlaceholder,
            genMore: genMore,
            getVisibleEvents: getVisibleEvents,
            isEventForCategory: isEventForCategory,
            getEventsForDay: getEventsForDay,
            getEventsForDayAll: getEventsForDayAll,
            getEventsForDayTimed: getEventsForDayTimed,
            getScopedSlots: getScopedSlots
        };
    }
    // Types
    // Types
    const VCalendar = genericComponent()({
        name: 'VCalendar',
        directives: {
            vResize: Resize
        },
        props: {
            modelValue: {
                type: [
                    String,
                    Number,
                    Date
                ],
                validate: validateTimestamp
            },
            categoryDays: {
                type: [
                    Number,
                    String
                ],
                default: 1,
                validate: (x)=>isFinite(parseInt(x)) && parseInt(x) > 0
            },
            categories: {
                type: [
                    Array,
                    String
                ],
                default: ''
            },
            categoryText: {
                type: [
                    String,
                    Function
                ]
            },
            categoryHideDynamic: {
                type: Boolean
            },
            categoryShowAll: {
                type: Boolean
            },
            categoryForInvalid: {
                type: String,
                default: ''
            },
            ...makeIntervalHighlightProps(),
            ...makeCalendarBaseProps(),
            ...makeCalendarWithEventsProps(),
            ...makeCalendarWithIntervalsProps()
        },
        setup (props, { slots: slots, attrs: attrs, emit: emit }) {
            const root = vue.ref();
            const base = useCalendarWithEvents(props, slots, attrs);
            const lastStart = vue.ref(null);
            const lastEnd = vue.ref(null);
            const parsedCategoryDays = vue.computed(()=>{
                return parseInt(String(props.categoryDays)) || 1;
            });
            const parsedCategories = vue.computed(()=>{
                return getParsedCategories(props.categories, props.categoryText);
            });
            const renderProps = vue.computed(()=>{
                const around = base.parsedValue.value;
                let component = null;
                let maxDays = props.maxDays;
                let categories = parsedCategories.value;
                let start = around;
                let end = around;
                switch(props.type){
                    case 'month':
                        component = VCalendarWeekly;
                        start = getStartOfMonth(around);
                        end = getEndOfMonth(around);
                        break;
                    case 'week':
                        component = VCalendarDaily;
                        start = base.getStartOfWeek(around);
                        end = base.getEndOfWeek(around);
                        maxDays = 7;
                        break;
                    case 'day':
                        component = VCalendarDaily;
                        maxDays = 1;
                        break;
                    case '4day':
                        component = VCalendarDaily;
                        end = relativeDays(copyTimestamp(end), nextDay, 3);
                        updateFormatted(end);
                        maxDays = 4;
                        break;
                    case 'custom-weekly':
                        component = VCalendarWeekly;
                        start = base.parsedStart.value || around;
                        end = base.parsedEnd.value;
                        break;
                    case 'custom-daily':
                        component = VCalendarDaily;
                        start = base.parsedStart.value || around;
                        end = base.parsedEnd.value;
                        break;
                    case 'category':
                        const days = parsedCategoryDays.value;
                        component = VCalendarCategory;
                        end = relativeDays(copyTimestamp(end), nextDay, days);
                        updateFormatted(end);
                        maxDays = days;
                        categories = getCategoryList(categories);
                        break;
                    default:
                        const type = props.type;
                        throw new Error(`${type} is not a valid Calendar type`);
                }
                return {
                    component: component,
                    start: start,
                    end: end,
                    maxDays: maxDays,
                    categories: categories
                };
            });
            const eventWeekdays = vue.computed(()=>{
                return base.effectiveWeekdays.value;
            });
            const categoryMode = vue.computed(()=>{
                return props.type === 'category';
            });
            const monthLongFormatter = vue.computed(()=>{
                return base.getFormatter({
                    timeZone: 'UTC',
                    month: 'long'
                });
            });
            const monthShortFormatter = vue.computed(()=>{
                return base.getFormatter({
                    timeZone: 'UTC',
                    month: 'short'
                });
            });
            const title = vue.computed(()=>{
                const { start: start, end: end } = renderProps.value;
                const spanYears = start.year !== end.year;
                const spanMonths = spanYears || start.month !== end.month;
                if (spanYears) return monthShortFormatter.value(start, true) + ' ' + start.year + ' - ' + monthShortFormatter.value(end, true) + ' ' + end.year;
                if (spanMonths) return monthShortFormatter.value(start, true) + ' - ' + monthShortFormatter.value(end, true) + ' ' + end.year;
                else return monthLongFormatter.value(start, false) + ' ' + start.year;
            });
            function checkChange() {
                const { start: start, end: end } = renderProps.value;
                if (!lastStart.value || !lastEnd.value || start.date !== lastStart.value.date || end.date !== lastEnd.value.date) {
                    lastStart.value = start;
                    lastEnd.value = end;
                    emit('change', {
                        start: start,
                        end: end
                    });
                }
            }
            function move(amount = 1) {
                const moved = copyTimestamp(base.parsedValue.value);
                const forward = amount > 0;
                const mover = forward ? nextDay : prevDay;
                const limit = forward ? DAYS_IN_MONTH_MAX : DAY_MIN;
                let times = forward ? amount : -amount;
                while(--times >= 0)switch(props.type){
                    case 'month':
                        moved.day = limit;
                        mover(moved);
                        break;
                    case 'week':
                        relativeDays(moved, mover, DAYS_IN_WEEK);
                        break;
                    case 'day':
                        relativeDays(moved, mover, 1);
                        break;
                    case '4day':
                        relativeDays(moved, mover, 4);
                        break;
                    case 'category':
                        relativeDays(moved, mover, parsedCategoryDays.value);
                        break;
                }
                updateWeekday(moved);
                updateFormatted(moved);
                updateRelative(moved, base.times.now);
                if (props.modelValue instanceof Date) emit('update:modelValue', timestampToDate(moved));
                else if (typeof props.modelValue === 'number') emit('update:modelValue', timestampToDate(moved).getTime());
                else emit('update:modelValue', moved.date);
                emit('moved', moved);
            }
            function next(amount = 1) {
                move(amount);
            }
            function prev(amount = 1) {
                move(-amount);
            }
            function getCategoryList(categories) {
                if (!base.noEvents.value) {
                    const categoryMap = categories.reduce((map, category, index)=>{
                        if (typeof category === 'object' && category.categoryName) map[category.categoryName] = {
                            index: index,
                            count: 0
                        };
                        else if (typeof category === 'string') map[category] = {
                            index: index,
                            count: 0
                        };
                        return map;
                    }, {});
                    if (!props.categoryHideDynamic || !props.categoryShowAll) {
                        let categoryLength = categories.length;
                        base.parsedEvents.value.forEach((ev)=>{
                            let category = ev.category;
                            if (typeof category !== 'string') category = props.categoryForInvalid;
                            if (!category) return;
                            if (category in categoryMap) categoryMap[category].count++;
                            else if (!props.categoryHideDynamic) categoryMap[category] = {
                                index: categoryLength++,
                                count: 1
                            };
                        });
                    }
                    if (!props.categoryShowAll) {
                        for(const category in categoryMap)if (categoryMap[category].count === 0) delete categoryMap[category];
                    }
                    categories = categories.filter((category)=>{
                        if (typeof category === 'object' && category.categoryName) return categoryMap.hasOwnProperty(category.categoryName);
                        else if (typeof category === 'string') return categoryMap.hasOwnProperty(category);
                        return false;
                    });
                }
                return categories;
            }
            vue.watch(renderProps, checkChange);
            vue.onMounted(()=>{
                base.updateEventVisibility();
                checkChange();
            });
            vue.onUpdated(()=>{
                window.requestAnimationFrame(base.updateEventVisibility);
            });
            useRender(()=>{
                const { start: start, end: end, maxDays: maxDays, component: Component, categories: categories } = renderProps.value;
                return vue.withDirectives(vue.createVNode(Component, vue.mergeProps({
                    "ref": root,
                    "class": [
                        'v-calendar',
                        {
                            'v-calendar-events': !base.noEvents.value
                        }
                    ],
                    "role": "grid"
                }, Component.filterProps(props), {
                    "start": start.date,
                    "end": end.date,
                    "maxDays": maxDays,
                    "weekdays": base.effectiveWeekdays.value,
                    "categories": categories,
                    "onClick:date": (e, day)=>{
                        if (attrs['onUpdate:modelValue']) emit('update:modelValue', day.date);
                    }
                }), base.getScopedSlots()), [
                    [
                        Resize,
                        base.updateEventVisibility,
                        void 0,
                        {
                            quiet: true
                        }
                    ]
                ]);
            });
            return forwardRefs({
                ...base,
                lastStart: lastStart,
                lastEnd: lastEnd,
                parsedCategoryDays: parsedCategoryDays,
                renderProps: renderProps,
                eventWeekdays: eventWeekdays,
                categoryMode: categoryMode,
                title: title,
                monthLongFormatter: monthLongFormatter,
                monthShortFormatter: monthShortFormatter,
                parsedCategories: parsedCategories,
                checkChange: checkChange,
                move: move,
                next: next,
                prev: prev,
                getCategoryList: getCategoryList
            }, root);
        }
    });
    const makeVCardActionsProps = propsFactory({
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VCardActions');
    const VCardActions = genericComponent()({
        name: 'VCardActions',
        props: makeVCardActionsProps(),
        setup (props, { slots: slots }) {
            provideDefaults({
                VBtn: {
                    slim: true,
                    variant: 'text'
                }
            });
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-card-actions',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, slots));
            return {};
        }
    });
    const makeVCardSubtitleProps = propsFactory({
        opacity: [
            Number,
            String
        ],
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VCardSubtitle');
    const VCardSubtitle = genericComponent()({
        name: 'VCardSubtitle',
        props: makeVCardSubtitleProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-card-subtitle',
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-card-subtitle-opacity': props.opacity
                        },
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Utilities
    const VCardTitle = createSimpleFunctional('v-card-title');
    const makeCardItemProps = propsFactory({
        appendAvatar: String,
        appendIcon: IconValue,
        prependAvatar: String,
        prependIcon: IconValue,
        subtitle: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        title: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeTagProps()
    }, 'VCardItem');
    const VCardItem = genericComponent()({
        name: 'VCardItem',
        props: makeCardItemProps(),
        setup (props, { slots: slots }) {
            useRender(()=>{
                const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
                const hasPrepend = !!(hasPrependMedia || slots.prepend);
                const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
                const hasAppend = !!(hasAppendMedia || slots.append);
                const hasTitle = !!(props.title != null || slots.title);
                const hasSubtitle = !!(props.subtitle != null || slots.subtitle);
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-card-item',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, {
                    default: ()=>[
                            hasPrepend && vue.createElementVNode("div", {
                                "key": "prepend",
                                "class": "v-card-item__prepend"
                            }, [
                                !slots.prepend ? vue.createElementVNode(vue.Fragment, null, [
                                    props.prependAvatar && vue.createVNode(VAvatar, {
                                        "key": "prepend-avatar",
                                        "density": props.density,
                                        "image": props.prependAvatar
                                    }, null),
                                    props.prependIcon && vue.createVNode(VIcon, {
                                        "key": "prepend-icon",
                                        "density": props.density,
                                        "icon": props.prependIcon
                                    }, null)
                                ]) : vue.createVNode(VDefaultsProvider, {
                                    "key": "prepend-defaults",
                                    "disabled": !hasPrependMedia,
                                    "defaults": {
                                        VAvatar: {
                                            density: props.density,
                                            image: props.prependAvatar
                                        },
                                        VIcon: {
                                            density: props.density,
                                            icon: props.prependIcon
                                        }
                                    }
                                }, slots.prepend)
                            ]),
                            vue.createElementVNode("div", {
                                "class": "v-card-item__content"
                            }, [
                                hasTitle && vue.createVNode(VCardTitle, {
                                    "key": "title"
                                }, {
                                    default: ()=>[
                                            slots.title?.() ?? vue.toDisplayString(props.title)
                                        ]
                                }),
                                hasSubtitle && vue.createVNode(VCardSubtitle, {
                                    "key": "subtitle"
                                }, {
                                    default: ()=>[
                                            slots.subtitle?.() ?? vue.toDisplayString(props.subtitle)
                                        ]
                                }),
                                slots.default?.()
                            ]),
                            hasAppend && vue.createElementVNode("div", {
                                "key": "append",
                                "class": "v-card-item__append"
                            }, [
                                !slots.append ? vue.createElementVNode(vue.Fragment, null, [
                                    props.appendIcon && vue.createVNode(VIcon, {
                                        "key": "append-icon",
                                        "density": props.density,
                                        "icon": props.appendIcon
                                    }, null),
                                    props.appendAvatar && vue.createVNode(VAvatar, {
                                        "key": "append-avatar",
                                        "density": props.density,
                                        "image": props.appendAvatar
                                    }, null)
                                ]) : vue.createVNode(VDefaultsProvider, {
                                    "key": "append-defaults",
                                    "disabled": !hasAppendMedia,
                                    "defaults": {
                                        VAvatar: {
                                            density: props.density,
                                            image: props.appendAvatar
                                        },
                                        VIcon: {
                                            density: props.density,
                                            icon: props.appendIcon
                                        }
                                    }
                                }, slots.append)
                            ])
                        ]
                });
            });
            return {};
        }
    });
    const makeVCardTextProps = propsFactory({
        opacity: [
            Number,
            String
        ],
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VCardText');
    const VCardText = genericComponent()({
        name: 'VCardText',
        props: makeVCardTextProps(),
        setup (props, { slots: slots }) {
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-card-text',
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-card-text-opacity': props.opacity
                        },
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Types
    const makeVCardProps = propsFactory({
        appendAvatar: String,
        appendIcon: IconValue,
        disabled: Boolean,
        flat: Boolean,
        hover: Boolean,
        image: String,
        link: {
            type: Boolean,
            default: undefined
        },
        prependAvatar: String,
        prependIcon: IconValue,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        },
        subtitle: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        text: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        title: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined
        },
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeLoaderProps(),
        ...makeLocationProps(),
        ...makePositionProps(),
        ...makeRoundedProps(),
        ...makeRouterProps(),
        ...makeTagProps(),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'elevated'
        })
    }, 'VCard');
    const VCard = genericComponent()({
        name: 'VCard',
        directives: {
            vRipple: Ripple
        },
        props: makeVCardProps(),
        setup (props, { attrs: attrs, slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { loaderClasses: loaderClasses } = useLoader(props);
            const { locationStyles: locationStyles } = useLocation(props);
            const { positionClasses: positionClasses } = usePosition(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const link = useLink(props, attrs);
            const loadingColor = vue.shallowRef(undefined);
            vue.watch(()=>props.loading, (val, old)=>{
                loadingColor.value = !val && typeof old === 'string' ? old : typeof val === 'boolean' ? undefined : val;
            }, {
                immediate: true
            });
            useRender(()=>{
                const isLink = props.link !== false && link.isLink.value;
                const isClickable = !props.disabled && props.link !== false && (props.link || link.isClickable.value);
                const Tag = isLink ? 'a' : props.tag;
                const hasTitle = !!(slots.title || props.title != null);
                const hasSubtitle = !!(slots.subtitle || props.subtitle != null);
                const hasHeader = hasTitle || hasSubtitle;
                const hasAppend = !!(slots.append || props.appendAvatar || props.appendIcon);
                const hasPrepend = !!(slots.prepend || props.prependAvatar || props.prependIcon);
                const hasImage = !!(slots.image || props.image);
                const hasCardItem = hasHeader || hasPrepend || hasAppend;
                const hasText = !!(slots.text || props.text != null);
                return vue.withDirectives(vue.createVNode(Tag, vue.mergeProps(link.linkProps, {
                    "class": [
                        'v-card',
                        {
                            'v-card--disabled': props.disabled,
                            'v-card--flat': props.flat,
                            'v-card--hover': props.hover && !(props.disabled || props.flat),
                            'v-card--link': isClickable
                        },
                        themeClasses.value,
                        borderClasses.value,
                        colorClasses.value,
                        densityClasses.value,
                        elevationClasses.value,
                        loaderClasses.value,
                        positionClasses.value,
                        roundedClasses.value,
                        variantClasses.value,
                        props.class
                    ],
                    "style": [
                        colorStyles.value,
                        dimensionStyles.value,
                        locationStyles.value,
                        {
                            '--v-card-height': convertToUnit(props.height)
                        },
                        roundedStyles.value,
                        props.style
                    ],
                    "onClick": isClickable && link.navigate.value,
                    "tabindex": props.disabled ? -1 : undefined
                }), {
                    default: ()=>[
                            hasImage && vue.createElementVNode("div", {
                                "key": "image",
                                "class": "v-card__image"
                            }, [
                                !slots.image ? vue.createVNode(VImg, {
                                    "key": "image-img",
                                    "cover": true,
                                    "src": props.image
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "key": "image-defaults",
                                    "disabled": !props.image,
                                    "defaults": {
                                        VImg: {
                                            cover: true,
                                            src: props.image
                                        }
                                    }
                                }, slots.image)
                            ]),
                            vue.createVNode(LoaderSlot, {
                                "name": "v-card",
                                "active": !!props.loading,
                                "color": loadingColor.value
                            }, {
                                default: slots.loader
                            }),
                            hasCardItem && vue.createVNode(VCardItem, {
                                "key": "item",
                                "prependAvatar": props.prependAvatar,
                                "prependIcon": props.prependIcon,
                                "title": props.title,
                                "subtitle": props.subtitle,
                                "appendAvatar": props.appendAvatar,
                                "appendIcon": props.appendIcon
                            }, {
                                default: slots.item,
                                prepend: slots.prepend,
                                title: slots.title,
                                subtitle: slots.subtitle,
                                append: slots.append
                            }),
                            hasText && vue.createVNode(VCardText, {
                                "key": "text"
                            }, {
                                default: ()=>[
                                        slots.text?.() ?? props.text
                                    ]
                            }),
                            slots.default?.(),
                            slots.actions && vue.createVNode(VCardActions, null, {
                                default: slots.actions
                            }),
                            genOverlays(isClickable, 'v-card')
                        ]
                }), [
                    [
                        Ripple,
                        isClickable && props.ripple
                    ]
                ]);
            });
            return {};
        }
    });
    // Utilities
    // Types
    const handleGesture = (wrapper)=>{
        const { touchstartX: touchstartX, touchendX: touchendX, touchstartY: touchstartY, touchendY: touchendY } = wrapper;
        const dirRatio = 0.5;
        const minDistance = 16;
        wrapper.offsetX = touchendX - touchstartX;
        wrapper.offsetY = touchendY - touchstartY;
        if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
            wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
            wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
        }
        if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
            wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
            wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
        }
    };
    function touchstart(event, wrapper) {
        const touch = event.changedTouches[0];
        wrapper.touchstartX = touch.clientX;
        wrapper.touchstartY = touch.clientY;
        wrapper.start?.({
            originalEvent: event,
            ...wrapper
        });
    }
    function touchend(event, wrapper) {
        const touch = event.changedTouches[0];
        wrapper.touchendX = touch.clientX;
        wrapper.touchendY = touch.clientY;
        wrapper.end?.({
            originalEvent: event,
            ...wrapper
        });
        handleGesture(wrapper);
    }
    function touchmove(event, wrapper) {
        const touch = event.changedTouches[0];
        wrapper.touchmoveX = touch.clientX;
        wrapper.touchmoveY = touch.clientY;
        wrapper.move?.({
            originalEvent: event,
            ...wrapper
        });
    }
    function createHandlers(value = {}) {
        const wrapper = {
            touchstartX: 0,
            touchstartY: 0,
            touchendX: 0,
            touchendY: 0,
            touchmoveX: 0,
            touchmoveY: 0,
            offsetX: 0,
            offsetY: 0,
            left: value.left,
            right: value.right,
            up: value.up,
            down: value.down,
            start: value.start,
            move: value.move,
            end: value.end
        };
        return {
            touchstart: (e)=>touchstart(e, wrapper),
            touchend: (e)=>touchend(e, wrapper),
            touchmove: (e)=>touchmove(e, wrapper)
        };
    }
    function mounted$2(el, binding) {
        const value = binding.value;
        const target = value?.parent ? el.parentElement : el;
        const options = value?.options ?? {
            passive: true
        };
        const uid = binding.instance?.$.uid; // TODO: use custom uid generator
        if (!target || uid === undefined) return;
        const handlers = createHandlers(binding.value);
        target._touchHandlers = target._touchHandlers ?? Object.create(null);
        target._touchHandlers[uid] = handlers;
        keys(handlers).forEach((eventName)=>{
            target.addEventListener(eventName, handlers[eventName], options);
        });
    }
    function unmounted$2(el, binding) {
        const target = binding.value?.parent ? el.parentElement : el;
        const uid = binding.instance?.$.uid;
        if (!target?._touchHandlers || uid === undefined) return;
        const handlers = target._touchHandlers[uid];
        // guard against double teardown: e.g. router & suspence racing
        if (!handlers) return;
        keys(handlers).forEach((eventName)=>{
            target.removeEventListener(eventName, handlers[eventName]);
        });
        delete target._touchHandlers[uid];
        if (!keys(target._touchHandlers).length) // only relevant if we keep `parent: boolean`
        delete target._touchHandlers;
    }
    const Touch = {
        mounted: mounted$2,
        unmounted: unmounted$2
    };
    // Types
    const VWindowSymbol = Symbol.for('vuetify:v-window');
    const VWindowGroupSymbol = Symbol.for('vuetify:v-window-group');
    const makeVWindowProps = propsFactory({
        continuous: Boolean,
        nextIcon: {
            type: [
                Boolean,
                String,
                Function,
                Object
            ],
            default: '$next'
        },
        prevIcon: {
            type: [
                Boolean,
                String,
                Function,
                Object
            ],
            default: '$prev'
        },
        reverse: Boolean,
        showArrows: {
            type: [
                Boolean,
                String
            ],
            validator: (v)=>typeof v === 'boolean' || v === 'hover'
        },
        verticalArrows: [
            Boolean,
            String
        ],
        touch: {
            type: [
                Object,
                Boolean
            ],
            default: undefined
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        modelValue: null,
        disabled: Boolean,
        selectedClass: {
            type: String,
            default: 'v-window-item--active'
        },
        // TODO: mandatory should probably not be exposed but do this for now
        mandatory: {
            type: [
                Boolean,
                String
            ],
            default: 'force'
        },
        crossfade: Boolean,
        transitionDuration: Number,
        ...makeComponentProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VWindow');
    const VWindow = genericComponent()({
        name: 'VWindow',
        directives: {
            vTouch: Touch
        },
        props: makeVWindowProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { isRtl: isRtl } = useRtl();
            const { t: t } = useLocale();
            const group = useGroup(props, VWindowGroupSymbol);
            const rootRef = vue.ref();
            const isRtlReverse = vue.computed(()=>isRtl.value ? !props.reverse : props.reverse);
            const isReversed = vue.shallowRef(false);
            const transition = vue.computed(()=>{
                if (props.crossfade) return 'v-window-crossfade-transition';
                const axis = props.direction === 'vertical' ? 'y' : 'x';
                const reverse = isRtlReverse.value ? !isReversed.value : isReversed.value;
                const direction = reverse ? '-reverse' : '';
                return `v-window-${axis}${direction}-transition`;
            });
            const transitionCount = vue.shallowRef(0);
            const transitionHeight = vue.ref(undefined);
            const activeIndex = vue.computed(()=>{
                return group.items.value.findIndex((item)=>group.selected.value.includes(item.id));
            });
            // Fix for https://github.com/vuetifyjs/vuetify/issues/18447
            vue.watch(activeIndex, (newVal, oldVal)=>{
                let scrollableParent;
                const savedScrollPosition = {
                    left: 0,
                    top: 0
                };
                if (IN_BROWSER && oldVal >= 0) {
                    scrollableParent = getScrollParent(rootRef.value);
                    savedScrollPosition.left = scrollableParent?.scrollLeft;
                    savedScrollPosition.top = scrollableParent?.scrollTop;
                }
                const itemsLength = group.items.value.length;
                const lastIndex = itemsLength - 1;
                if (itemsLength <= 2) isReversed.value = newVal < oldVal;
                else if (newVal === lastIndex && oldVal === 0) isReversed.value = false;
                else if (newVal === 0 && oldVal === lastIndex) isReversed.value = true;
                else isReversed.value = newVal < oldVal;
                vue.nextTick(()=>{
                    if (!IN_BROWSER || !scrollableParent) return;
                    const currentScrollY = scrollableParent.scrollTop;
                    if (currentScrollY !== savedScrollPosition.top) scrollableParent.scrollTo({
                        ...savedScrollPosition,
                        behavior: 'instant'
                    });
                    requestAnimationFrame(()=>{
                        if (!scrollableParent) return;
                        const rafScrollY = scrollableParent.scrollTop;
                        if (rafScrollY !== savedScrollPosition.top) scrollableParent.scrollTo({
                            ...savedScrollPosition,
                            behavior: 'instant'
                        });
                    });
                });
            }, {
                flush: 'sync'
            }); // Run synchronously before DOM updates
            vue.provide(VWindowSymbol, {
                transition: transition,
                isReversed: isReversed,
                transitionCount: transitionCount,
                transitionHeight: transitionHeight,
                rootRef: rootRef
            });
            const canMoveBack = vue.toRef(()=>props.continuous || activeIndex.value !== 0);
            const canMoveForward = vue.toRef(()=>props.continuous || activeIndex.value !== group.items.value.length - 1);
            function prev() {
                canMoveBack.value && group.prev();
            }
            function next() {
                canMoveForward.value && group.next();
            }
            const arrows = vue.computed(()=>{
                const arrows = [];
                const prevProps = {
                    icon: isRtl.value ? props.nextIcon : props.prevIcon,
                    class: `v-window__${isRtlReverse.value ? 'right' : 'left'}`,
                    onClick: group.prev,
                    'aria-label': t('$vuetify.carousel.prev')
                };
                arrows.push(canMoveBack.value ? slots.prev ? slots.prev({
                    props: prevProps
                }) : vue.createVNode(VBtn, prevProps, null) : vue.createElementVNode("div", null, null));
                const nextProps = {
                    icon: isRtl.value ? props.prevIcon : props.nextIcon,
                    class: `v-window__${isRtlReverse.value ? 'left' : 'right'}`,
                    onClick: group.next,
                    'aria-label': t('$vuetify.carousel.next')
                };
                arrows.push(canMoveForward.value ? slots.next ? slots.next({
                    props: nextProps
                }) : vue.createVNode(VBtn, nextProps, null) : vue.createElementVNode("div", null, null));
                return arrows;
            });
            const touchOptions = vue.computed(()=>{
                if (props.touch === false) return props.touch;
                const options = {
                    left: ()=>{
                        isRtlReverse.value ? prev() : next();
                    },
                    right: ()=>{
                        isRtlReverse.value ? next() : prev();
                    },
                    start: ({ originalEvent: originalEvent })=>{
                        originalEvent.stopPropagation();
                    }
                };
                return {
                    ...options,
                    ...props.touch === true ? {} : props.touch
                };
            });
            function onKeyDown(e) {
                if (props.direction === 'horizontal' && e.key === 'ArrowLeft' || props.direction === 'vertical' && e.key === 'ArrowUp') {
                    e.preventDefault();
                    prev();
                    vue.nextTick(()=>{
                        canMoveBack.value ? focusArrow(0) : focusArrow(1);
                    });
                }
                if (props.direction === 'horizontal' && e.key === 'ArrowRight' || props.direction === 'vertical' && e.key === 'ArrowDown') {
                    e.preventDefault();
                    next();
                    vue.nextTick(()=>{
                        canMoveForward.value ? focusArrow(1) : focusArrow(0);
                    });
                }
            }
            function focusArrow(index) {
                const arrow = arrows.value[index];
                if (!arrow) return;
                const arrowEl = Array.isArray(arrow) ? arrow[0] : arrow;
                arrowEl.el?.focus();
            }
            useRender(()=>vue.withDirectives(vue.createVNode(props.tag, {
                    "ref": rootRef,
                    "class": vue.normalizeClass([
                        'v-window',
                        {
                            'v-window--show-arrows-on-hover': props.showArrows === 'hover',
                            'v-window--vertical-arrows': !!props.verticalArrows,
                            'v-window--crossfade': !!props.crossfade
                        },
                        themeClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        props.style,
                        {
                            '--v-window-transition-duration': !PREFERS_REDUCED_MOTION() ? convertToUnit(props.transitionDuration, 'ms') : null
                        }
                    ])
                }, {
                    default: ()=>[
                            vue.createElementVNode("div", {
                                "class": "v-window__container",
                                "style": {
                                    height: transitionHeight.value
                                }
                            }, [
                                slots.default?.({
                                    group: group
                                }),
                                props.showArrows !== false && vue.createElementVNode("div", {
                                    "class": vue.normalizeClass([
                                        'v-window__controls',
                                        {
                                            'v-window__controls--left': props.verticalArrows === 'left' || props.verticalArrows === true
                                        },
                                        {
                                            'v-window__controls--right': props.verticalArrows === 'right'
                                        }
                                    ]),
                                    "onKeydown": onKeyDown
                                }, [
                                    arrows.value
                                ])
                            ]),
                            slots.additional?.({
                                group: group
                            })
                        ]
                }), [
                    [
                        Touch,
                        touchOptions.value
                    ]
                ]));
            return {
                group: group
            };
        }
    });
    // Types
    const makeVCarouselProps = propsFactory({
        color: String,
        cycle: Boolean,
        delimiterIcon: {
            type: IconValue,
            default: '$delimiter'
        },
        height: {
            type: [
                Number,
                String
            ],
            default: 500
        },
        hideDelimiters: Boolean,
        hideDelimiterBackground: Boolean,
        interval: {
            type: [
                Number,
                String
            ],
            default: 6000,
            validator: (value)=>Number(value) > 0
        },
        progress: [
            Boolean,
            String
        ],
        verticalDelimiters: [
            Boolean,
            String
        ],
        ...makeVWindowProps({
            continuous: true,
            mandatory: 'force',
            showArrows: true
        })
    }, 'VCarousel');
    const VCarousel = genericComponent()({
        name: 'VCarousel',
        props: makeVCarouselProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const { t: t } = useLocale();
            const windowRef = vue.ref();
            let slideTimeout = -1;
            vue.watch(model, restartTimeout);
            vue.watch(()=>props.interval, restartTimeout);
            vue.watch(()=>props.cycle, (val)=>{
                if (val) restartTimeout();
                else window.clearTimeout(slideTimeout);
            });
            vue.onMounted(startTimeout);
            function startTimeout() {
                if (!props.cycle || !windowRef.value) return;
                slideTimeout = window.setTimeout(windowRef.value.group.next, Number(props.interval) > 0 ? Number(props.interval) : 6000);
            }
            function restartTimeout() {
                window.clearTimeout(slideTimeout);
                window.requestAnimationFrame(startTimeout);
            }
            function onDelimiterKeyDown(e, group) {
                if (props.direction === 'horizontal' && e.key === 'ArrowLeft' || props.direction === 'vertical' && e.key === 'ArrowUp') {
                    e.preventDefault();
                    group.prev();
                    vue.nextTick(()=>windowRef.value?.$el.querySelector('.v-btn--active')?.focus());
                }
                if (props.direction === 'horizontal' && e.key === 'ArrowRight' || props.direction === 'vertical' && e.key === 'ArrowDown') {
                    e.preventDefault();
                    group.next();
                    vue.nextTick(()=>windowRef.value?.$el.querySelector('.v-btn--active')?.focus());
                }
            }
            useRender(()=>{
                const windowProps = VWindow.filterProps(props);
                return vue.createVNode(VWindow, vue.mergeProps({
                    "ref": windowRef
                }, windowProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": [
                        'v-carousel',
                        {
                            'v-carousel--hide-delimiter-background': props.hideDelimiterBackground,
                            'v-carousel--vertical-delimiters': props.verticalDelimiters
                        },
                        props.class
                    ],
                    "style": [
                        {
                            height: convertToUnit(props.height)
                        },
                        props.style
                    ]
                }), {
                    default: slots.default,
                    additional: ({ group: group })=>vue.createElementVNode(vue.Fragment, null, [
                            !props.hideDelimiters && vue.createElementVNode("div", {
                                "class": "v-carousel__controls",
                                "style": {
                                    left: props.verticalDelimiters === 'left' && props.verticalDelimiters ? 0 : 'auto',
                                    right: props.verticalDelimiters === 'right' ? 0 : 'auto'
                                }
                            }, [
                                group.items.value.length > 0 && vue.createVNode(VDefaultsProvider, {
                                    "defaults": {
                                        VBtn: {
                                            color: props.color,
                                            icon: props.delimiterIcon,
                                            size: 'x-small',
                                            variant: 'text'
                                        }
                                    },
                                    "scoped": true
                                }, {
                                    default: ()=>[
                                            group.items.value.map((item, index)=>{
                                                const props = {
                                                    id: `carousel-item-${item.id}`,
                                                    'aria-label': t('$vuetify.carousel.ariaLabel.delimiter', index + 1, group.items.value.length),
                                                    class: [
                                                        'v-carousel__controls__item',
                                                        group.isSelected(item.id) && 'v-btn--active'
                                                    ],
                                                    onClick: ()=>group.select(item.id, true),
                                                    onKeydown: (e)=>onDelimiterKeyDown(e, group)
                                                };
                                                return slots.item ? slots.item({
                                                    props: props,
                                                    item: item
                                                }) : vue.createVNode(VBtn, vue.mergeProps(item, props), null);
                                            })
                                        ]
                                })
                            ]),
                            props.progress && vue.createVNode(VProgressLinear, {
                                "absolute": true,
                                "class": "v-carousel__progress",
                                "color": typeof props.progress === 'string' ? props.progress : undefined,
                                "modelValue": (group.getItemIndex(model.value) + 1) / group.items.value.length * 100
                            }, null)
                        ]),
                    prev: slots.prev,
                    next: slots.next
                });
            });
            return {};
        }
    });
    const makeVWindowItemProps = propsFactory({
        reverseTransition: {
            type: [
                Boolean,
                String
            ],
            default: undefined
        },
        transition: {
            type: [
                Boolean,
                String
            ],
            default: undefined
        },
        ...makeComponentProps(),
        ...makeGroupItemProps(),
        ...makeLazyProps()
    }, 'VWindowItem');
    const VWindowItem = genericComponent()({
        name: 'VWindowItem',
        directives: {
            vTouch: Touch
        },
        props: makeVWindowItemProps(),
        emits: {
            'group:selected': (val)=>true
        },
        setup (props, { slots: slots }) {
            const window1 = vue.inject(VWindowSymbol);
            const groupItem = useGroupItem(props, VWindowGroupSymbol);
            const { isBooted: isBooted } = useSsrBoot();
            if (!window1 || !groupItem) throw new Error('[Vuetify] VWindowItem must be used inside VWindow');
            const isTransitioning = vue.shallowRef(false);
            const hasTransition = vue.computed(()=>isBooted.value && (window1.isReversed.value ? props.reverseTransition !== false : props.transition !== false));
            function onAfterTransition() {
                if (!isTransitioning.value || !window1) return;
                // Finalize transition state.
                isTransitioning.value = false;
                if (window1.transitionCount.value > 0) {
                    window1.transitionCount.value -= 1;
                    // Remove container height if we are out of transition.
                    if (window1.transitionCount.value === 0) window1.transitionHeight.value = undefined;
                }
            }
            function onBeforeTransition() {
                if (isTransitioning.value || !window1) return;
                // Initialize transition state here.
                isTransitioning.value = true;
                if (window1.transitionCount.value === 0) // Set initial height for height transition.
                window1.transitionHeight.value = convertToUnit(window1.rootRef.value?.clientHeight);
                window1.transitionCount.value += 1;
            }
            function onTransitionCancelled() {
                onAfterTransition(); // This should have the same path as normal transition end.
            }
            function onEnterTransition(el) {
                if (!isTransitioning.value) return;
                vue.nextTick(()=>{
                    // Do not set height if no transition or cancelled.
                    if (!hasTransition.value || !isTransitioning.value || !window1) return;
                    // Set transition target height.
                    window1.transitionHeight.value = convertToUnit(el.clientHeight);
                });
            }
            const transition = vue.computed(()=>{
                const name = window1.isReversed.value ? props.reverseTransition : props.transition;
                return !hasTransition.value ? false : {
                    name: typeof name !== 'string' ? window1.transition.value : name,
                    onBeforeEnter: onBeforeTransition,
                    onAfterEnter: onAfterTransition,
                    onEnterCancelled: onTransitionCancelled,
                    onBeforeLeave: onBeforeTransition,
                    onAfterLeave: onAfterTransition,
                    onLeaveCancelled: onTransitionCancelled,
                    onEnter: onEnterTransition
                };
            });
            const { hasContent: hasContent } = useLazy(props, groupItem.isSelected);
            useRender(()=>vue.createVNode(MaybeTransition, {
                    "transition": transition.value,
                    "disabled": !isBooted.value
                }, {
                    default: ()=>[
                            vue.withDirectives(vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    'v-window-item',
                                    groupItem.selectedClass.value,
                                    props.class
                                ]),
                                "style": vue.normalizeStyle(props.style)
                            }, [
                                hasContent.value && slots.default?.()
                            ]), [
                                [
                                    vue.vShow,
                                    groupItem.isSelected.value
                                ]
                            ])
                        ]
                }));
            return {
                groupItem: groupItem
            };
        }
    });
    // Types
    const makeVCarouselItemProps = propsFactory({
        ...makeVImgProps(),
        ...makeVWindowItemProps()
    }, 'VCarouselItem');
    const VCarouselItem = genericComponent()({
        name: 'VCarouselItem',
        inheritAttrs: false,
        props: makeVCarouselItemProps(),
        setup (props, { slots: slots, attrs: attrs }) {
            useRender(()=>{
                const imgProps = VImg.filterProps(props);
                const windowItemProps = VWindowItem.filterProps(props);
                return vue.createVNode(VWindowItem, vue.mergeProps({
                    "class": [
                        'v-carousel-item',
                        props.class
                    ]
                }, windowItemProps), {
                    default: ()=>[
                            vue.createVNode(VImg, vue.mergeProps(attrs, imgProps), slots)
                        ]
                });
            });
        }
    });
    // Styles
    const VCode = createSimpleFunctional('v-code', 'code');
    // Types
    const makeVColorPickerCanvasProps = propsFactory({
        color: {
            type: Object
        },
        disabled: Boolean,
        readonly: Boolean,
        dotSize: {
            type: [
                Number,
                String
            ],
            default: 10
        },
        height: {
            type: [
                Number,
                String
            ],
            default: 150
        },
        width: {
            type: [
                Number,
                String
            ],
            default: 300
        },
        ...makeComponentProps()
    }, 'VColorPickerCanvas');
    const VColorPickerCanvas = defineComponent({
        name: 'VColorPickerCanvas',
        props: makeVColorPickerCanvasProps(),
        emits: {
            'update:color': (color)=>true,
            'update:position': (hue)=>true
        },
        setup (props, { emit: emit }) {
            const isInteracting = vue.shallowRef(false);
            const canvasRef = vue.ref();
            const canvasWidth = vue.shallowRef(parseFloat(props.width));
            const canvasHeight = vue.shallowRef(parseFloat(props.height));
            const _dotPosition = vue.ref({
                x: 0,
                y: 0
            });
            const isInteractive = vue.toRef(()=>!props.disabled && !props.readonly);
            const dotPosition = vue.computed({
                get: ()=>_dotPosition.value,
                set (val) {
                    if (!canvasRef.value) return;
                    const { x: x, y: y } = val;
                    _dotPosition.value = val;
                    emit('update:color', {
                        h: props.color?.h ?? 0,
                        s: clamp(x, 0, canvasWidth.value) / canvasWidth.value,
                        v: 1 - clamp(y, 0, canvasHeight.value) / canvasHeight.value,
                        a: props.color?.a ?? 1
                    });
                }
            });
            const dotStyles = vue.computed(()=>{
                const { x: x, y: y } = dotPosition.value;
                const radius = parseInt(props.dotSize, 10) / 2;
                return {
                    width: convertToUnit(props.dotSize),
                    height: convertToUnit(props.dotSize),
                    transform: `translate(${convertToUnit(x - radius)}, ${convertToUnit(y - radius)})`
                };
            });
            const { resizeRef: resizeRef } = useResizeObserver((entries)=>{
                if (!resizeRef.el?.offsetParent) return;
                const { width: width, height: height } = entries[0].contentRect;
                canvasWidth.value = Math.round(width);
                canvasHeight.value = Math.round(height);
            });
            function updateDotPosition(x, y, rect) {
                const { left: left, top: top, width: width, height: height } = rect;
                dotPosition.value = {
                    x: clamp(x - left, 0, width),
                    y: clamp(y - top, 0, height)
                };
            }
            function handleMouseDown(e) {
                if (e.type === 'mousedown') // Prevent text selection while dragging
                e.preventDefault();
                if (!isInteractive.value) return;
                handleMouseMove(e);
                window.addEventListener('mousemove', handleMouseMove);
                window.addEventListener('mouseup', handleMouseUp);
                window.addEventListener('touchmove', handleMouseMove);
                window.addEventListener('touchend', handleMouseUp);
            }
            function handleMouseMove(e) {
                if (!isInteractive.value || !canvasRef.value) return;
                isInteracting.value = true;
                const coords = getEventCoordinates(e);
                const point = getTargetBox([
                    coords.clientX,
                    coords.clientY
                ]);
                updateDotPosition(point.x, point.y, getTargetBox(canvasRef.value));
            }
            function handleMouseUp() {
                window.removeEventListener('mousemove', handleMouseMove);
                window.removeEventListener('mouseup', handleMouseUp);
                window.removeEventListener('touchmove', handleMouseMove);
                window.removeEventListener('touchend', handleMouseUp);
            }
            function updateCanvas() {
                if (!canvasRef.value) return;
                const canvas = canvasRef.value;
                const ctx = canvas.getContext('2d');
                if (!ctx) return;
                const saturationGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
                saturationGradient.addColorStop(0, 'hsla(0, 0%, 100%, 1)'); // white
                saturationGradient.addColorStop(1, `hsla(${props.color?.h ?? 0}, 100%, 50%, 1)`);
                ctx.fillStyle = saturationGradient;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                const valueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
                valueGradient.addColorStop(0, 'hsla(0, 0%, 0%, 0)'); // transparent
                valueGradient.addColorStop(1, 'hsla(0, 0%, 0%, 1)'); // black
                ctx.fillStyle = valueGradient;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
            vue.watch(()=>props.color?.h, updateCanvas, {
                immediate: true
            });
            vue.watch(()=>[
                    canvasWidth.value,
                    canvasHeight.value
                ], (newVal, oldVal)=>{
                updateCanvas();
                _dotPosition.value = {
                    x: dotPosition.value.x * newVal[0] / oldVal[0],
                    y: dotPosition.value.y * newVal[1] / oldVal[1]
                };
            }, {
                flush: 'post'
            });
            vue.watch(()=>props.color, ()=>{
                if (isInteracting.value) {
                    isInteracting.value = false;
                    return;
                }
                _dotPosition.value = props.color ? {
                    x: props.color.s * canvasWidth.value,
                    y: (1 - props.color.v) * canvasHeight.value
                } : {
                    x: 0,
                    y: 0
                };
            }, {
                deep: true,
                immediate: true
            });
            vue.onMounted(()=>updateCanvas());
            useRender(()=>vue.createElementVNode("div", {
                    "ref": resizeRef,
                    "class": vue.normalizeClass([
                        'v-color-picker-canvas',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "onMousedown": handleMouseDown,
                    "onTouchstartPassive": handleMouseDown
                }, [
                    vue.createElementVNode("canvas", {
                        "ref": canvasRef,
                        "width": canvasWidth.value,
                        "height": canvasHeight.value
                    }, null),
                    props.color && vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-color-picker-canvas__dot',
                            {
                                'v-color-picker-canvas__dot--disabled': props.disabled
                            }
                        ]),
                        "style": vue.normalizeStyle(dotStyles.value)
                    }, null)
                ]));
            return {};
        }
    });
    // Utilities
    // Types
    function stripAlpha(color, stripAlpha) {
        if (stripAlpha) {
            const { a: a, ...rest } = color;
            return rest;
        }
        return color;
    }
    function extractColor(color, input) {
        if (input == null || typeof input === 'string') {
            const hasA = typeof color.a === 'number' && color.a < 1;
            if (input?.startsWith('rgb(')) {
                const { r: r, g: g, b: b, a: a } = HSVtoRGB(color);
                return `rgb(${r} ${g} ${b}` + (hasA ? ` / ${a})` : ')');
            } else if (input?.startsWith('hsl(')) {
                const { h: h, s: s, l: l, a: a } = HSVtoHSL(color);
                return `hsl(${h} ${Math.round(s * 100)} ${Math.round(l * 100)}` + (hasA ? ` / ${a})` : ')');
            }
            const hex = HSVtoHex(color);
            if (color.a === 1) return hex.slice(0, 7);
            else return hex;
        }
        if (typeof input === 'object') {
            let converted;
            if (has(input, [
                'r',
                'g',
                'b'
            ])) converted = HSVtoRGB(color);
            else if (has(input, [
                'h',
                's',
                'l'
            ])) converted = HSVtoHSL(color);
            else if (has(input, [
                'h',
                's',
                'v'
            ])) converted = color;
            return stripAlpha(converted, !has(input, [
                'a'
            ]) && color.a === 1);
        }
        return color;
    }
    const nullColor = {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    const rgba = {
        inputProps: {
            type: 'number',
            min: 0
        },
        inputs: [
            {
                label: 'R',
                max: 255,
                step: 1,
                getValue: (c)=>Math.round(c.r),
                getColor: (c, v)=>({
                        ...c,
                        r: Number(v)
                    }),
                localeKey: 'redInput'
            },
            {
                label: 'G',
                max: 255,
                step: 1,
                getValue: (c)=>Math.round(c.g),
                getColor: (c, v)=>({
                        ...c,
                        g: Number(v)
                    }),
                localeKey: 'greenInput'
            },
            {
                label: 'B',
                max: 255,
                step: 1,
                getValue: (c)=>Math.round(c.b),
                getColor: (c, v)=>({
                        ...c,
                        b: Number(v)
                    }),
                localeKey: 'blueInput'
            },
            {
                label: 'A',
                max: 1,
                step: 0.01,
                getValue: ({ a: a })=>a != null ? Math.round(a * 100) / 100 : 1,
                getColor: (c, v)=>({
                        ...c,
                        a: Number(v)
                    }),
                localeKey: 'alphaInput'
            }
        ],
        to: HSVtoRGB,
        from: RGBtoHSV
    };
    const rgb = {
        ...rgba,
        inputs: rgba.inputs?.slice(0, 3)
    };
    const hsla = {
        inputProps: {
            type: 'number',
            min: 0
        },
        inputs: [
            {
                label: 'H',
                max: 360,
                step: 1,
                getValue: (c)=>Math.round(c.h),
                getColor: (c, v)=>({
                        ...c,
                        h: Number(v)
                    }),
                localeKey: 'hueInput'
            },
            {
                label: 'S',
                max: 1,
                step: 0.01,
                getValue: (c)=>Math.round(c.s * 100) / 100,
                getColor: (c, v)=>({
                        ...c,
                        s: Number(v)
                    }),
                localeKey: 'saturationInput'
            },
            {
                label: 'L',
                max: 1,
                step: 0.01,
                getValue: (c)=>Math.round(c.l * 100) / 100,
                getColor: (c, v)=>({
                        ...c,
                        l: Number(v)
                    }),
                localeKey: 'lightnessInput'
            },
            {
                label: 'A',
                max: 1,
                step: 0.01,
                getValue: ({ a: a })=>a != null ? Math.round(a * 100) / 100 : 1,
                getColor: (c, v)=>({
                        ...c,
                        a: Number(v)
                    }),
                localeKey: 'alphaInput'
            }
        ],
        to: HSVtoHSL,
        from: HSLtoHSV
    };
    const hsl = {
        ...hsla,
        inputs: hsla.inputs.slice(0, 3)
    };
    const hexa = {
        inputProps: {
            type: 'text'
        },
        inputs: [
            {
                label: 'HEXA',
                getValue: (c)=>c,
                getColor: (c, v)=>v,
                localeKey: 'hexaInput'
            }
        ],
        to: HSVtoHex,
        from: HexToHSV
    };
    const hex = {
        ...hexa,
        inputs: [
            {
                label: 'HEX',
                getValue: (c)=>c.slice(0, 7),
                getColor: (c, v)=>v,
                localeKey: 'hexInput'
            }
        ]
    };
    const modes = {
        rgb: rgb,
        rgba: rgba,
        hsl: hsl,
        hsla: hsla,
        hex: hex,
        hexa: hexa
    };
    // Types
    const VColorPickerInput = ({ label: label, ...rest })=>{
        return vue.createElementVNode("div", {
            "class": "v-color-picker-edit__input"
        }, [
            vue.createElementVNode("input", vue.normalizeProps(vue.guardReactiveProps(rest)), null),
            vue.createElementVNode("span", null, [
                label
            ])
        ]);
    };
    const makeVColorPickerEditProps = propsFactory({
        color: Object,
        disabled: Boolean,
        hideInputLabels: Boolean,
        readonly: Boolean,
        mode: {
            type: String,
            default: 'rgba',
            validator: (v)=>Object.keys(modes).includes(v)
        },
        modes: {
            type: Array,
            default: ()=>Object.keys(modes),
            validator: (v)=>Array.isArray(v) && v.every((m)=>Object.keys(modes).includes(m))
        },
        ...makeComponentProps()
    }, 'VColorPickerEdit');
    const VColorPickerEdit = defineComponent({
        name: 'VColorPickerEdit',
        props: makeVColorPickerEditProps(),
        emits: {
            'update:color': (color)=>true,
            'update:mode': (mode)=>true
        },
        setup (props, { emit: emit }) {
            const { t: t } = useLocale();
            const enabledModes = vue.computed(()=>{
                return props.modes.map((key)=>({
                        ...modes[key],
                        name: key
                    }));
            });
            const inputs = vue.computed(()=>{
                const mode = enabledModes.value.find((m)=>m.name === props.mode);
                if (!mode) return [];
                const color = props.color ? mode.to(props.color) : null;
                return mode.inputs?.map(({ getValue: getValue, getColor: getColor, localeKey: localeKey, ...inputProps })=>{
                    return {
                        ...mode.inputProps,
                        ...inputProps,
                        ariaLabel: t(`$vuetify.colorPicker.ariaLabel.${localeKey}`),
                        disabled: props.disabled,
                        readonly: props.readonly,
                        value: color && getValue(color),
                        onChange: (e)=>{
                            const target = e.target;
                            if (!target) return;
                            emit('update:color', mode.from(getColor(color ?? mode.to(nullColor), target.value)));
                        }
                    };
                });
            });
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-color-picker-edit',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, [
                    inputs.value?.map((inputProps)=>vue.createVNode(VColorPickerInput, vue.mergeProps(inputProps, {
                            "label": props.hideInputLabels ? undefined : inputProps.label
                        }), null)),
                    enabledModes.value.length > 1 && vue.createVNode(VBtn, {
                        "icon": "$unfold",
                        "size": "x-small",
                        "variant": "plain",
                        "aria-label": t('$vuetify.colorPicker.ariaLabel.changeFormat'),
                        "onClick": ()=>{
                            const mi = enabledModes.value.findIndex((m)=>m.name === props.mode);
                            emit('update:mode', enabledModes.value[(mi + 1) % enabledModes.value.length].name);
                        }
                    }, null)
                ]));
            return {};
        }
    });
    /* eslint-disable max-statements */ // Composables
    // Types
    const VSliderSymbol = Symbol.for('vuetify:v-slider');
    function getOffset(e, el, direction) {
        const vertical = direction === 'vertical';
        const rect = el.getBoundingClientRect();
        const touch = 'touches' in e ? e.touches[0] : e;
        return vertical ? touch.clientY - (rect.top + rect.height / 2) : touch.clientX - (rect.left + rect.width / 2);
    }
    function getPosition(e, position) {
        if ('touches' in e && e.touches.length) return e.touches[0][position];
        else if ('changedTouches' in e && e.changedTouches.length) return e.changedTouches[0][position];
        else return e[position];
    }
    const makeSliderProps = propsFactory({
        disabled: {
            type: Boolean,
            default: null
        },
        error: Boolean,
        readonly: {
            type: Boolean,
            default: null
        },
        max: {
            type: [
                Number,
                String
            ],
            default: 100
        },
        min: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        step: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        thumbColor: String,
        thumbLabel: {
            type: [
                Boolean,
                String
            ],
            default: undefined,
            validator: (v)=>typeof v === 'boolean' || v === 'always' || v === 'hover'
        },
        thumbSize: {
            type: [
                Number,
                String
            ],
            default: 20
        },
        showTicks: {
            type: [
                Boolean,
                String
            ],
            default: false,
            validator: (v)=>typeof v === 'boolean' || v === 'always'
        },
        ticks: {
            type: [
                Array,
                Object
            ]
        },
        tickSize: {
            type: [
                Number,
                String
            ],
            default: 2
        },
        color: String,
        trackColor: String,
        trackFillColor: String,
        trackSize: {
            type: [
                Number,
                String
            ],
            default: 4
        },
        direction: {
            type: String,
            default: 'horizontal',
            validator: (v)=>[
                    'vertical',
                    'horizontal'
                ].includes(v)
        },
        reverse: Boolean,
        noKeyboard: Boolean,
        ...makeRoundedProps(),
        ...makeElevationProps({
            elevation: 1
        }),
        ripple: {
            type: Boolean,
            default: true
        }
    }, 'Slider');
    const useSteps = (props)=>{
        const min = vue.computed(()=>parseFloat(props.min));
        const max = vue.computed(()=>parseFloat(props.max));
        const step = vue.computed(()=>Number(props.step) > 0 ? parseFloat(props.step) : 0);
        const decimals = vue.computed(()=>Math.max(getDecimals(step.value), getDecimals(min.value)));
        function roundValue(value) {
            value = parseFloat(value);
            if (step.value <= 0) return value;
            const clamped = clamp(value, min.value, max.value);
            const offset = min.value % step.value;
            let newValue = Math.round((clamped - offset) / step.value) * step.value + offset;
            if (clamped > newValue && newValue + step.value > max.value) newValue = max.value;
            return parseFloat(Math.min(newValue, max.value).toFixed(decimals.value));
        }
        return {
            min: min,
            max: max,
            step: step,
            decimals: decimals,
            roundValue: roundValue
        };
    };
    const useSlider = ({ props: props, steps: steps, onSliderStart: onSliderStart, onSliderMove: onSliderMove, onSliderEnd: onSliderEnd, getActiveThumb: getActiveThumb })=>{
        const form = useForm(props);
        const { isRtl: isRtl } = useRtl();
        const isReversed = vue.toRef(()=>props.reverse);
        const vertical = vue.computed(()=>props.direction === 'vertical');
        const indexFromEnd = vue.computed(()=>vertical.value !== isReversed.value);
        const { min: min, max: max, step: step, decimals: decimals, roundValue: roundValue } = steps;
        const thumbSize = vue.computed(()=>parseInt(props.thumbSize, 10));
        const tickSize = vue.computed(()=>parseInt(props.tickSize, 10));
        const trackSize = vue.computed(()=>parseInt(props.trackSize, 10));
        const numTicks = vue.computed(()=>(max.value - min.value) / step.value);
        const thumbColor = vue.computed(()=>props.error || form.isDisabled.value ? undefined : props.thumbColor ?? props.color);
        const thumbLabelColor = vue.computed(()=>props.error || form.isDisabled.value ? undefined : props.thumbColor);
        const trackColor = vue.computed(()=>props.error || form.isDisabled.value ? undefined : props.trackColor ?? props.color);
        const trackFillColor = vue.computed(()=>props.error || form.isDisabled.value ? undefined : props.trackFillColor ?? props.color);
        const mousePressed = vue.shallowRef(false);
        const startOffset = vue.shallowRef(0);
        const trackContainerRef = vue.ref();
        const activeThumbRef = vue.ref();
        function parseMouseMove(e) {
            const el = trackContainerRef.value?.$el;
            if (!el) return;
            const vertical = props.direction === 'vertical';
            const start = vertical ? 'top' : 'left';
            const length = vertical ? 'height' : 'width';
            const position = vertical ? 'clientY' : 'clientX';
            const { [start]: trackStart, [length]: trackLength } = el.getBoundingClientRect();
            const clickOffset = getPosition(e, position);
            // It is possible for left to be NaN, force to number
            let clickPos = clamp((clickOffset - trackStart - startOffset.value) / trackLength) || 0;
            if (vertical ? indexFromEnd.value : indexFromEnd.value !== isRtl.value) clickPos = 1 - clickPos;
            return roundValue(min.value + clickPos * (max.value - min.value));
        }
        const handleStop = (e)=>{
            const value = parseMouseMove(e);
            if (value != null) onSliderEnd({
                value: value
            });
            mousePressed.value = false;
            startOffset.value = 0;
        };
        const handleStart = (e)=>{
            const value = parseMouseMove(e);
            activeThumbRef.value = getActiveThumb(e);
            if (!activeThumbRef.value) return;
            mousePressed.value = true;
            if (activeThumbRef.value.contains(e.target)) startOffset.value = getOffset(e, activeThumbRef.value, props.direction);
            else {
                startOffset.value = 0;
                if (value != null) onSliderMove({
                    value: value
                });
            }
            if (value != null) onSliderStart({
                value: value
            });
            vue.nextTick(()=>activeThumbRef.value?.focus());
        };
        const moveListenerOptions = {
            passive: true,
            capture: true
        };
        function onMouseMove(e) {
            const value = parseMouseMove(e);
            if (value != null) onSliderMove({
                value: value
            });
        }
        function onSliderMouseUp(e) {
            e.stopPropagation();
            e.preventDefault();
            handleStop(e);
            window.removeEventListener('mousemove', onMouseMove, moveListenerOptions);
            window.removeEventListener('mouseup', onSliderMouseUp);
        }
        function onSliderTouchend(e) {
            handleStop(e);
            window.removeEventListener('touchmove', onMouseMove, moveListenerOptions);
            e.target?.removeEventListener('touchend', onSliderTouchend);
        }
        function onSliderTouchstart(e) {
            handleStart(e);
            window.addEventListener('touchmove', onMouseMove, moveListenerOptions);
            e.target?.addEventListener('touchend', onSliderTouchend, {
                passive: false
            });
        }
        function onSliderMousedown(e) {
            if (e.button !== 0) return;
            e.preventDefault();
            handleStart(e);
            window.addEventListener('mousemove', onMouseMove, moveListenerOptions);
            window.addEventListener('mouseup', onSliderMouseUp, {
                passive: false
            });
        }
        vue.onScopeDispose(()=>{
            if (!IN_BROWSER) return;
            window.removeEventListener('touchmove', onMouseMove);
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onSliderMouseUp);
        });
        const position = (val)=>{
            const percentage = (val - min.value) / (max.value - min.value) * 100;
            return clamp(isNaN(percentage) ? 0 : percentage, 0, 100);
        };
        const showTicks = vue.toRef(()=>props.showTicks);
        const parsedTicks = vue.computed(()=>{
            if (!showTicks.value) return [];
            if (!props.ticks) return numTicks.value !== Infinity ? createRange(numTicks.value + 1).map((t)=>{
                const value = min.value + t * step.value;
                return {
                    value: value,
                    position: position(value)
                };
            }) : [];
            if (Array.isArray(props.ticks)) return props.ticks.map((t)=>({
                    value: t,
                    position: position(t),
                    label: t.toString()
                }));
            return Object.keys(props.ticks).map((key)=>({
                    value: parseFloat(key),
                    position: position(parseFloat(key)),
                    label: props.ticks[key]
                }));
        });
        const hasLabels = vue.computed(()=>parsedTicks.value.some(({ label: label })=>!!label));
        const data = {
            activeThumbRef: activeThumbRef,
            color: vue.toRef(()=>props.color),
            decimals: decimals,
            disabled: form.isDisabled,
            direction: vue.toRef(()=>props.direction),
            elevation: vue.toRef(()=>props.elevation),
            hasLabels: hasLabels,
            isReversed: isReversed,
            indexFromEnd: indexFromEnd,
            min: min,
            max: max,
            mousePressed: mousePressed,
            noKeyboard: vue.toRef(()=>props.noKeyboard),
            numTicks: numTicks,
            onSliderMousedown: onSliderMousedown,
            onSliderTouchstart: onSliderTouchstart,
            parsedTicks: parsedTicks,
            parseMouseMove: parseMouseMove,
            position: position,
            readonly: form.isReadonly,
            rounded: vue.toRef(()=>props.rounded),
            roundValue: roundValue,
            showTicks: showTicks,
            startOffset: startOffset,
            step: step,
            thumbSize: thumbSize,
            thumbColor: thumbColor,
            thumbLabelColor: thumbLabelColor,
            thumbLabel: vue.toRef(()=>props.thumbLabel),
            ticks: vue.toRef(()=>props.ticks),
            tickSize: tickSize,
            trackColor: trackColor,
            trackContainerRef: trackContainerRef,
            trackFillColor: trackFillColor,
            trackSize: trackSize,
            vertical: vertical
        };
        vue.provide(VSliderSymbol, data);
        return data;
    };
    // Types
    const makeVSliderThumbProps = propsFactory({
        focused: Boolean,
        max: {
            type: Number,
            required: true
        },
        min: {
            type: Number,
            required: true
        },
        modelValue: {
            type: Number,
            required: true
        },
        position: {
            type: Number,
            required: true
        },
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        },
        name: String,
        noKeyboard: Boolean,
        ...makeComponentProps()
    }, 'VSliderThumb');
    const VSliderThumb = genericComponent()({
        name: 'VSliderThumb',
        directives: {
            vRipple: Ripple
        },
        props: makeVSliderThumbProps(),
        emits: {
            'update:modelValue': (v)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            const slider = vue.inject(VSliderSymbol);
            const { isRtl: isRtl, rtlClasses: rtlClasses } = useRtl();
            if (!slider) throw new Error('[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider');
            const { min: min, max: max, thumbColor: thumbColor, thumbLabelColor: thumbLabelColor, step: step, disabled: disabled, thumbSize: thumbSize, thumbLabel: thumbLabel, direction: direction, isReversed: isReversed, vertical: vertical, readonly: readonly, elevation: elevation, mousePressed: mousePressed, decimals: decimals, indexFromEnd: indexFromEnd } = slider;
            const isHovered = vue.shallowRef(false);
            const isHidden = vue.shallowRef(false);
            const elevationProps = vue.computed(()=>!disabled.value ? elevation.value : undefined);
            const { elevationClasses: elevationClasses } = useElevation(elevationProps);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(thumbColor);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(thumbLabelColor);
            const { pageup: pageup, pagedown: pagedown, end: end, home: home, left: left, right: right, down: down, up: up } = keyValues;
            const relevantKeys = [
                pageup,
                pagedown,
                end,
                home,
                left,
                right,
                down,
                up
            ];
            const multipliers = vue.computed(()=>{
                if (step.value) return [
                    1,
                    2,
                    3
                ];
                else return [
                    1,
                    5,
                    10
                ];
            });
            function parseKeydown(e, value) {
                if (props.noKeyboard || disabled.value) return;
                if (!relevantKeys.includes(e.key)) return;
                e.preventDefault();
                const _step = step.value || 0.1;
                const steps = (max.value - min.value) / _step;
                if ([
                    left,
                    right,
                    down,
                    up
                ].includes(e.key)) {
                    const increase = vertical.value ? [
                        isRtl.value ? left : right,
                        isReversed.value ? down : up
                    ] : indexFromEnd.value !== isRtl.value ? [
                        left,
                        up
                    ] : [
                        right,
                        up
                    ];
                    const direction = increase.includes(e.key) ? 1 : -1;
                    const multiplier = e.shiftKey ? 2 : e.ctrlKey ? 1 : 0;
                    if (direction === -1 && value === max.value && !multiplier && !Number.isInteger(steps)) value = value - steps % 1 * _step;
                    else value = value + direction * _step * multipliers.value[multiplier];
                } else if (e.key === home) value = min.value;
                else if (e.key === end) value = max.value;
                else {
                    const direction = e.key === pagedown ? 1 : -1;
                    value = value - direction * _step * (steps > 100 ? steps / 10 : 10);
                }
                return Math.max(props.min, Math.min(props.max, value));
            }
            function onKeydown(e) {
                const newValue = parseKeydown(e, props.modelValue);
                if (newValue != null) {
                    isHidden.value = false;
                    emit('update:modelValue', newValue);
                }
            }
            vue.watch(()=>props.focused, (val)=>{
                if (val) isHidden.value = false;
            });
            useRender(()=>{
                const positionPercentage = convertToUnit(indexFromEnd.value ? 100 - props.position : props.position, '%');
                const thumbLabelVisible = thumbLabel.value === 'always' || thumbLabel.value === true && props.focused || thumbLabel.value === 'hover' && (isHovered.value || props.focused && !isHidden.value);
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-slider-thumb',
                        {
                            'v-slider-thumb--focused': props.focused,
                            'v-slider-thumb--pressed': props.focused && mousePressed.value
                        },
                        props.class,
                        rtlClasses.value
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-slider-thumb-position': positionPercentage,
                            '--v-slider-thumb-size': convertToUnit(thumbSize.value)
                        },
                        props.style
                    ]),
                    "role": "slider",
                    "tabindex": disabled.value ? -1 : 0,
                    "aria-label": props.name,
                    "aria-valuemin": min.value,
                    "aria-valuemax": max.value,
                    "aria-valuenow": props.modelValue,
                    "aria-readonly": !!readonly.value,
                    "aria-orientation": direction.value,
                    "onKeydown": !readonly.value ? onKeydown : undefined,
                    "onMouseenter": ()=>{
                        isHovered.value = true;
                    },
                    "onMouseleave": ()=>{
                        isHovered.value = false;
                        isHidden.value = true;
                    }
                }, [
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-slider-thumb__surface',
                            textColorClasses.value,
                            elevationClasses.value
                        ]),
                        "style": vue.normalizeStyle(textColorStyles.value)
                    }, null),
                    vue.withDirectives(vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-slider-thumb__ripple',
                            textColorClasses.value
                        ]),
                        "style": vue.normalizeStyle(textColorStyles.value)
                    }, null), [
                        [
                            Ripple,
                            props.ripple,
                            null,
                            {
                                circle: true,
                                center: true
                            }
                        ]
                    ]),
                    vue.createVNode(VScaleTransition, {
                        "origin": "bottom center"
                    }, {
                        default: ()=>[
                                vue.withDirectives(vue.createElementVNode("div", {
                                    "class": "v-slider-thumb__label-container"
                                }, [
                                    vue.createElementVNode("div", {
                                        "class": vue.normalizeClass([
                                            'v-slider-thumb__label',
                                            backgroundColorClasses.value
                                        ]),
                                        "style": vue.normalizeStyle(backgroundColorStyles.value)
                                    }, [
                                        vue.createElementVNode("div", null, [
                                            slots['thumb-label']?.({
                                                modelValue: props.modelValue
                                            }) ?? props.modelValue.toFixed(step.value ? decimals.value : 1)
                                        ]),
                                        vue.createElementVNode("div", {
                                            "class": "v-slider-thumb__label-wedge"
                                        }, null)
                                    ])
                                ]), [
                                    [
                                        vue.vShow,
                                        thumbLabelVisible
                                    ]
                                ])
                            ]
                    })
                ]);
            });
            return {};
        }
    });
    // Types
    const makeVSliderTrackProps = propsFactory({
        start: {
            type: Number,
            required: true
        },
        stop: {
            type: Number,
            required: true
        },
        ...makeComponentProps()
    }, 'VSliderTrack');
    const VSliderTrack = genericComponent()({
        name: 'VSliderTrack',
        props: makeVSliderTrackProps(),
        emits: {},
        setup (props, { slots: slots }) {
            const slider = vue.inject(VSliderSymbol);
            if (!slider) throw new Error('[Vuetify] v-slider-track must be inside v-slider or v-range-slider');
            const { color: color, parsedTicks: parsedTicks, rounded: rounded, showTicks: showTicks, tickSize: tickSize, trackColor: trackColor, trackFillColor: trackFillColor, trackSize: trackSize, vertical: vertical, min: min, max: max, indexFromEnd: indexFromEnd } = slider;
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(rounded);
            const { backgroundColorClasses: trackFillColorClasses, backgroundColorStyles: trackFillColorStyles } = useBackgroundColor(trackFillColor);
            const { backgroundColorClasses: trackColorClasses, backgroundColorStyles: trackColorStyles } = useBackgroundColor(trackColor);
            const startDir = vue.computed(()=>`inset-${vertical.value ? 'block' : 'inline'}-${indexFromEnd.value ? 'end' : 'start'}`);
            const endDir = vue.computed(()=>vertical.value ? 'height' : 'width');
            const backgroundStyles = vue.computed(()=>{
                return {
                    [startDir.value]: '0%',
                    [endDir.value]: '100%'
                };
            });
            const trackFillWidth = vue.computed(()=>props.stop - props.start);
            const trackFillStyles = vue.computed(()=>{
                return {
                    [startDir.value]: convertToUnit(props.start, '%'),
                    [endDir.value]: convertToUnit(trackFillWidth.value, '%')
                };
            });
            const computedTicks = vue.computed(()=>{
                if (!showTicks.value) return [];
                const ticks = vertical.value ? parsedTicks.value.slice().reverse() : parsedTicks.value;
                return ticks.map((tick, index)=>{
                    const directionValue = tick.value !== min.value && tick.value !== max.value ? convertToUnit(tick.position, '%') : undefined;
                    return vue.createElementVNode("div", {
                        "key": tick.value,
                        "class": vue.normalizeClass([
                            'v-slider-track__tick',
                            {
                                'v-slider-track__tick--filled': tick.position >= props.start && tick.position <= props.stop,
                                'v-slider-track__tick--first': tick.value === min.value,
                                'v-slider-track__tick--last': tick.value === max.value
                            }
                        ]),
                        "style": {
                            [startDir.value]: directionValue
                        }
                    }, [
                        (tick.label || slots['tick-label']) && vue.createElementVNode("div", {
                            "class": "v-slider-track__tick-label"
                        }, [
                            slots['tick-label']?.({
                                tick: tick,
                                index: index
                            }) ?? tick.label
                        ])
                    ]);
                });
            });
            useRender(()=>{
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-slider-track',
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-slider-track-size': convertToUnit(trackSize.value),
                            '--v-slider-tick-size': convertToUnit(tickSize.value)
                        },
                        roundedStyles.value,
                        props.style
                    ])
                }, [
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-slider-track__background',
                            trackColorClasses.value,
                            {
                                'v-slider-track__background--opacity': !!color.value || !trackFillColor.value
                            }
                        ]),
                        "style": {
                            ...backgroundStyles.value,
                            ...trackColorStyles.value
                        }
                    }, null),
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-slider-track__fill',
                            trackFillColorClasses.value
                        ]),
                        "style": {
                            ...trackFillStyles.value,
                            ...trackFillColorStyles.value
                        }
                    }, null),
                    showTicks.value && vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-slider-track__ticks',
                            {
                                'v-slider-track__ticks--always-show': showTicks.value === 'always'
                            }
                        ])
                    }, [
                        computedTicks.value
                    ])
                ]);
            });
            return {};
        }
    });
    // Types
    const makeVSliderProps = propsFactory({
        ...makeFocusProps(),
        ...makeSliderProps(),
        ...makeVInputProps(),
        modelValue: {
            type: [
                Number,
                String
            ],
            default: 0
        }
    }, 'VSlider');
    const VSlider = genericComponent()({
        name: 'VSlider',
        inheritAttrs: false,
        props: makeVSliderProps(),
        emits: {
            'update:focused': (value)=>true,
            'update:modelValue': (v)=>true,
            start: (value)=>true,
            end: (value)=>true
        },
        setup (props, { slots: slots, emit: emit, attrs: attrs }) {
            const thumbContainerRef = vue.ref();
            const inputRef = vue.ref();
            const { rtlClasses: rtlClasses } = useRtl();
            const steps = useSteps(props);
            const model = useProxiedModel(props, 'modelValue', undefined, (value)=>{
                return steps.roundValue(value == null ? steps.min.value : value);
            });
            const { min: min, max: max, mousePressed: mousePressed, roundValue: roundValue, onSliderMousedown: onSliderMousedown, onSliderTouchstart: onSliderTouchstart, trackContainerRef: trackContainerRef, position: position, hasLabels: hasLabels, disabled: disabled, readonly: readonly, noKeyboard: noKeyboard } = useSlider({
                props: props,
                steps: steps,
                onSliderStart: ()=>{
                    if (!disabled.value && !readonly.value) emit('start', model.value);
                },
                onSliderEnd: ({ value: value })=>{
                    const roundedValue = roundValue(value);
                    if (!disabled.value && !readonly.value) model.value = roundedValue;
                    emit('end', roundedValue);
                },
                onSliderMove: ({ value: value })=>{
                    if (!disabled.value && !readonly.value) model.value = roundValue(value);
                },
                getActiveThumb: ()=>thumbContainerRef.value?.$el
            });
            const { isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const trackStop = vue.computed(()=>position(model.value));
            useRender(()=>{
                const inputProps = VInput.filterProps(props);
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                const hasPrepend = !!(props.label || slots.label || slots.prepend);
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": inputRef,
                    "class": [
                        'v-slider',
                        {
                            'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                            'v-slider--focused': isFocused.value,
                            'v-slider--pressed': mousePressed.value,
                            'v-slider--disabled': disabled.value
                        },
                        rtlClasses.value,
                        props.class
                    ],
                    "style": props.style
                }, inputProps, rootAttrs, {
                    "focused": isFocused.value
                }), {
                    ...slots,
                    prepend: hasPrepend ? (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            slots.label?.(slotProps) ?? (props.label ? vue.createVNode(VLabel, {
                                "id": slotProps.id.value,
                                "class": "v-slider__label",
                                "text": props.label
                            }, null) : undefined),
                            slots.prepend?.(slotProps)
                        ]) : undefined,
                    default: ({ id: id, messagesId: messagesId })=>vue.createElementVNode("div", {
                            "class": "v-slider__container",
                            "onMousedown": !readonly.value ? onSliderMousedown : undefined,
                            "onTouchstartPassive": !readonly.value ? onSliderTouchstart : undefined
                        }, [
                            vue.createElementVNode("input", {
                                "id": id.value,
                                "name": props.name || id.value,
                                "disabled": disabled.value,
                                "readonly": readonly.value,
                                "tabindex": "-1",
                                "value": model.value
                            }, null),
                            vue.createVNode(VSliderTrack, {
                                "ref": trackContainerRef,
                                "start": 0,
                                "stop": trackStop.value
                            }, {
                                'tick-label': slots['tick-label']
                            }),
                            vue.createVNode(VSliderThumb, vue.mergeProps({
                                "ref": thumbContainerRef,
                                "aria-describedby": messagesId.value,
                                "focused": isFocused.value,
                                "noKeyboard": noKeyboard.value,
                                "min": min.value,
                                "max": max.value,
                                "modelValue": model.value,
                                "onUpdate:modelValue": (v)=>model.value = v,
                                "position": trackStop.value,
                                "elevation": props.elevation,
                                "onFocus": focus,
                                "onBlur": blur,
                                "ripple": props.ripple,
                                "name": props.name
                            }, inputAttrs), {
                                'thumb-label': slots['thumb-label']
                            })
                        ])
                });
            });
            return forwardRefs({
                focus: ()=>thumbContainerRef.value?.$el.focus()
            }, inputRef);
        }
    });
    // Types
    const makeVColorPickerPreviewProps = propsFactory({
        color: {
            type: Object
        },
        disabled: Boolean,
        readonly: Boolean,
        hideAlpha: Boolean,
        hideEyeDropper: Boolean,
        eyeDropperIcon: {
            type: IconValue,
            default: '$eyeDropper'
        },
        ...makeComponentProps()
    }, 'VColorPickerPreview');
    const VColorPickerPreview = defineComponent({
        name: 'VColorPickerPreview',
        props: makeVColorPickerPreviewProps(),
        emits: {
            'update:color': (color)=>true
        },
        setup (props, { emit: emit }) {
            const { t: t } = useLocale();
            const abortController = new AbortController();
            const isInteractive = vue.toRef(()=>!props.disabled && !props.readonly);
            vue.onUnmounted(()=>abortController.abort());
            async function openEyeDropper() {
                if (!SUPPORTS_EYE_DROPPER || !isInteractive.value) return;
                const eyeDropper = new window.EyeDropper();
                try {
                    const result = await eyeDropper.open({
                        signal: abortController.signal
                    });
                    const colorHexValue = RGBtoHSV(parseColor(result.sRGBHex));
                    emit('update:color', {
                        ...props.color ?? nullColor,
                        ...colorHexValue
                    });
                } catch (e) {}
            }
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-color-picker-preview',
                        {
                            'v-color-picker-preview--hide-alpha': props.hideAlpha
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, [
                    SUPPORTS_EYE_DROPPER && !props.hideEyeDropper && vue.createElementVNode("div", {
                        "class": "v-color-picker-preview__eye-dropper",
                        "key": "eyeDropper"
                    }, [
                        vue.createVNode(VBtn, {
                            "aria-label": t('$vuetify.colorPicker.ariaLabel.eyedropper'),
                            "density": "comfortable",
                            "disabled": props.disabled,
                            "readonly": props.readonly,
                            "icon": props.eyeDropperIcon,
                            "variant": "plain",
                            "onClick": openEyeDropper
                        }, null)
                    ]),
                    vue.createElementVNode("div", {
                        "class": "v-color-picker-preview__dot"
                    }, [
                        vue.createElementVNode("div", {
                            "style": {
                                background: HSVtoCSS(props.color ?? nullColor)
                            }
                        }, null)
                    ]),
                    vue.createElementVNode("div", {
                        "class": "v-color-picker-preview__sliders"
                    }, [
                        vue.createVNode(VSlider, {
                            "class": "v-color-picker-preview__track v-color-picker-preview__hue",
                            "aria-label": t('$vuetify.colorPicker.ariaLabel.hueSlider'),
                            "modelValue": props.color?.h,
                            "onUpdate:modelValue": (h)=>emit('update:color', {
                                    ...props.color ?? nullColor,
                                    h: h
                                }),
                            "step": 1,
                            "min": 0,
                            "max": 360,
                            "disabled": props.disabled,
                            "readonly": props.readonly,
                            "thumbSize": 14,
                            "trackSize": 8,
                            "trackFillColor": "white",
                            "hideDetails": true
                        }, null),
                        !props.hideAlpha && vue.createVNode(VSlider, {
                            "class": "v-color-picker-preview__track v-color-picker-preview__alpha",
                            "aria-label": t('$vuetify.colorPicker.ariaLabel.alphaSlider'),
                            "modelValue": props.color?.a ?? 1,
                            "onUpdate:modelValue": (a)=>emit('update:color', {
                                    ...props.color ?? nullColor,
                                    a: a
                                }),
                            "step": 0.01,
                            "min": 0,
                            "max": 1,
                            "disabled": props.disabled,
                            "readonly": props.readonly,
                            "thumbSize": 14,
                            "trackSize": 8,
                            "trackFillColor": "white",
                            "hideDetails": true
                        }, null)
                    ])
                ]));
            return {};
        }
    });
    const red = {
        base: '#f44336',
        lighten5: '#ffebee',
        lighten4: '#ffcdd2',
        lighten3: '#ef9a9a',
        lighten2: '#e57373',
        lighten1: '#ef5350',
        darken1: '#e53935',
        darken2: '#d32f2f',
        darken3: '#c62828',
        darken4: '#b71c1c',
        accent1: '#ff8a80',
        accent2: '#ff5252',
        accent3: '#ff1744',
        accent4: '#d50000'
    };
    const pink = {
        base: '#e91e63',
        lighten5: '#fce4ec',
        lighten4: '#f8bbd0',
        lighten3: '#f48fb1',
        lighten2: '#f06292',
        lighten1: '#ec407a',
        darken1: '#d81b60',
        darken2: '#c2185b',
        darken3: '#ad1457',
        darken4: '#880e4f',
        accent1: '#ff80ab',
        accent2: '#ff4081',
        accent3: '#f50057',
        accent4: '#c51162'
    };
    const purple = {
        base: '#9c27b0',
        lighten5: '#f3e5f5',
        lighten4: '#e1bee7',
        lighten3: '#ce93d8',
        lighten2: '#ba68c8',
        lighten1: '#ab47bc',
        darken1: '#8e24aa',
        darken2: '#7b1fa2',
        darken3: '#6a1b9a',
        darken4: '#4a148c',
        accent1: '#ea80fc',
        accent2: '#e040fb',
        accent3: '#d500f9',
        accent4: '#aa00ff'
    };
    const deepPurple = {
        base: '#673ab7',
        lighten5: '#ede7f6',
        lighten4: '#d1c4e9',
        lighten3: '#b39ddb',
        lighten2: '#9575cd',
        lighten1: '#7e57c2',
        darken1: '#5e35b1',
        darken2: '#512da8',
        darken3: '#4527a0',
        darken4: '#311b92',
        accent1: '#b388ff',
        accent2: '#7c4dff',
        accent3: '#651fff',
        accent4: '#6200ea'
    };
    const indigo = {
        base: '#3f51b5',
        lighten5: '#e8eaf6',
        lighten4: '#c5cae9',
        lighten3: '#9fa8da',
        lighten2: '#7986cb',
        lighten1: '#5c6bc0',
        darken1: '#3949ab',
        darken2: '#303f9f',
        darken3: '#283593',
        darken4: '#1a237e',
        accent1: '#8c9eff',
        accent2: '#536dfe',
        accent3: '#3d5afe',
        accent4: '#304ffe'
    };
    const blue = {
        base: '#2196f3',
        lighten5: '#e3f2fd',
        lighten4: '#bbdefb',
        lighten3: '#90caf9',
        lighten2: '#64b5f6',
        lighten1: '#42a5f5',
        darken1: '#1e88e5',
        darken2: '#1976d2',
        darken3: '#1565c0',
        darken4: '#0d47a1',
        accent1: '#82b1ff',
        accent2: '#448aff',
        accent3: '#2979ff',
        accent4: '#2962ff'
    };
    const lightBlue = {
        base: '#03a9f4',
        lighten5: '#e1f5fe',
        lighten4: '#b3e5fc',
        lighten3: '#81d4fa',
        lighten2: '#4fc3f7',
        lighten1: '#29b6f6',
        darken1: '#039be5',
        darken2: '#0288d1',
        darken3: '#0277bd',
        darken4: '#01579b',
        accent1: '#80d8ff',
        accent2: '#40c4ff',
        accent3: '#00b0ff',
        accent4: '#0091ea'
    };
    const cyan = {
        base: '#00bcd4',
        lighten5: '#e0f7fa',
        lighten4: '#b2ebf2',
        lighten3: '#80deea',
        lighten2: '#4dd0e1',
        lighten1: '#26c6da',
        darken1: '#00acc1',
        darken2: '#0097a7',
        darken3: '#00838f',
        darken4: '#006064',
        accent1: '#84ffff',
        accent2: '#18ffff',
        accent3: '#00e5ff',
        accent4: '#00b8d4'
    };
    const teal = {
        base: '#009688',
        lighten5: '#e0f2f1',
        lighten4: '#b2dfdb',
        lighten3: '#80cbc4',
        lighten2: '#4db6ac',
        lighten1: '#26a69a',
        darken1: '#00897b',
        darken2: '#00796b',
        darken3: '#00695c',
        darken4: '#004d40',
        accent1: '#a7ffeb',
        accent2: '#64ffda',
        accent3: '#1de9b6',
        accent4: '#00bfa5'
    };
    const green = {
        base: '#4caf50',
        lighten5: '#e8f5e9',
        lighten4: '#c8e6c9',
        lighten3: '#a5d6a7',
        lighten2: '#81c784',
        lighten1: '#66bb6a',
        darken1: '#43a047',
        darken2: '#388e3c',
        darken3: '#2e7d32',
        darken4: '#1b5e20',
        accent1: '#b9f6ca',
        accent2: '#69f0ae',
        accent3: '#00e676',
        accent4: '#00c853'
    };
    const lightGreen = {
        base: '#8bc34a',
        lighten5: '#f1f8e9',
        lighten4: '#dcedc8',
        lighten3: '#c5e1a5',
        lighten2: '#aed581',
        lighten1: '#9ccc65',
        darken1: '#7cb342',
        darken2: '#689f38',
        darken3: '#558b2f',
        darken4: '#33691e',
        accent1: '#ccff90',
        accent2: '#b2ff59',
        accent3: '#76ff03',
        accent4: '#64dd17'
    };
    const lime = {
        base: '#cddc39',
        lighten5: '#f9fbe7',
        lighten4: '#f0f4c3',
        lighten3: '#e6ee9c',
        lighten2: '#dce775',
        lighten1: '#d4e157',
        darken1: '#c0ca33',
        darken2: '#afb42b',
        darken3: '#9e9d24',
        darken4: '#827717',
        accent1: '#f4ff81',
        accent2: '#eeff41',
        accent3: '#c6ff00',
        accent4: '#aeea00'
    };
    const yellow = {
        base: '#ffeb3b',
        lighten5: '#fffde7',
        lighten4: '#fff9c4',
        lighten3: '#fff59d',
        lighten2: '#fff176',
        lighten1: '#ffee58',
        darken1: '#fdd835',
        darken2: '#fbc02d',
        darken3: '#f9a825',
        darken4: '#f57f17',
        accent1: '#ffff8d',
        accent2: '#ffff00',
        accent3: '#ffea00',
        accent4: '#ffd600'
    };
    const amber = {
        base: '#ffc107',
        lighten5: '#fff8e1',
        lighten4: '#ffecb3',
        lighten3: '#ffe082',
        lighten2: '#ffd54f',
        lighten1: '#ffca28',
        darken1: '#ffb300',
        darken2: '#ffa000',
        darken3: '#ff8f00',
        darken4: '#ff6f00',
        accent1: '#ffe57f',
        accent2: '#ffd740',
        accent3: '#ffc400',
        accent4: '#ffab00'
    };
    const orange = {
        base: '#ff9800',
        lighten5: '#fff3e0',
        lighten4: '#ffe0b2',
        lighten3: '#ffcc80',
        lighten2: '#ffb74d',
        lighten1: '#ffa726',
        darken1: '#fb8c00',
        darken2: '#f57c00',
        darken3: '#ef6c00',
        darken4: '#e65100',
        accent1: '#ffd180',
        accent2: '#ffab40',
        accent3: '#ff9100',
        accent4: '#ff6d00'
    };
    const deepOrange = {
        base: '#ff5722',
        lighten5: '#fbe9e7',
        lighten4: '#ffccbc',
        lighten3: '#ffab91',
        lighten2: '#ff8a65',
        lighten1: '#ff7043',
        darken1: '#f4511e',
        darken2: '#e64a19',
        darken3: '#d84315',
        darken4: '#bf360c',
        accent1: '#ff9e80',
        accent2: '#ff6e40',
        accent3: '#ff3d00',
        accent4: '#dd2c00'
    };
    const brown = {
        base: '#795548',
        lighten5: '#efebe9',
        lighten4: '#d7ccc8',
        lighten3: '#bcaaa4',
        lighten2: '#a1887f',
        lighten1: '#8d6e63',
        darken1: '#6d4c41',
        darken2: '#5d4037',
        darken3: '#4e342e',
        darken4: '#3e2723'
    };
    const blueGrey = {
        base: '#607d8b',
        lighten5: '#eceff1',
        lighten4: '#cfd8dc',
        lighten3: '#b0bec5',
        lighten2: '#90a4ae',
        lighten1: '#78909c',
        darken1: '#546e7a',
        darken2: '#455a64',
        darken3: '#37474f',
        darken4: '#263238'
    };
    const grey = {
        base: '#9e9e9e',
        lighten5: '#fafafa',
        lighten4: '#f5f5f5',
        lighten3: '#eeeeee',
        lighten2: '#e0e0e0',
        lighten1: '#bdbdbd',
        darken1: '#757575',
        darken2: '#616161',
        darken3: '#424242',
        darken4: '#212121'
    };
    const shades = {
        black: '#000000',
        white: '#ffffff',
        transparent: '#ffffff00'
    };
    var colors = {
        red: red,
        pink: pink,
        purple: purple,
        deepPurple: deepPurple,
        indigo: indigo,
        blue: blue,
        lightBlue: lightBlue,
        cyan: cyan,
        teal: teal,
        green: green,
        lightGreen: lightGreen,
        lime: lime,
        yellow: yellow,
        amber: amber,
        orange: orange,
        deepOrange: deepOrange,
        brown: brown,
        blueGrey: blueGrey,
        grey: grey,
        shades: shades
    };
    // Types
    const makeVColorPickerSwatchesProps = propsFactory({
        swatches: {
            type: Array,
            default: ()=>parseDefaultColors(colors)
        },
        disabled: Boolean,
        readonly: Boolean,
        color: Object,
        maxHeight: [
            Number,
            String
        ],
        ...makeComponentProps()
    }, 'VColorPickerSwatches');
    function parseDefaultColors(colors) {
        return Object.keys(colors).map((key)=>{
            const color = colors[key];
            return color.base ? [
                color.base,
                color.darken4,
                color.darken3,
                color.darken2,
                color.darken1,
                color.lighten1,
                color.lighten2,
                color.lighten3,
                color.lighten4,
                color.lighten5
            ] : [
                color.black,
                color.white,
                color.transparent
            ];
        });
    }
    const VColorPickerSwatches = defineComponent({
        name: 'VColorPickerSwatches',
        props: makeVColorPickerSwatchesProps(),
        emits: {
            'update:color': (color)=>true
        },
        setup (props, { emit: emit }) {
            const isInteractive = vue.toRef(()=>!props.disabled && !props.readonly);
            function onSwatchClick(hsva) {
                if (!isInteractive.value || !hsva) return;
                emit('update:color', hsva);
            }
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-color-picker-swatches',
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            maxHeight: convertToUnit(props.maxHeight)
                        },
                        props.style
                    ])
                }, [
                    vue.createElementVNode("div", null, [
                        props.swatches.map((swatch)=>vue.createElementVNode("div", {
                                "class": "v-color-picker-swatches__swatch"
                            }, [
                                swatch.map((color)=>{
                                    const rgba = parseColor(color);
                                    const hsva = RGBtoHSV(rgba);
                                    const background = RGBtoCSS(rgba);
                                    return vue.createElementVNode("div", {
                                        "class": vue.normalizeClass([
                                            'v-color-picker-swatches__color',
                                            {
                                                'v-color-picker-swatches__color--disabled': props.disabled
                                            }
                                        ]),
                                        "onClick": ()=>onSwatchClick(hsva)
                                    }, [
                                        vue.createElementVNode("div", {
                                            "style": {
                                                background: background
                                            }
                                        }, [
                                            props.color && deepEqual(props.color, hsva) ? vue.createVNode(VIcon, {
                                                "size": "x-small",
                                                "icon": "$success",
                                                "color": getContrast(color, '#FFFFFF') > 2 ? 'white' : 'black'
                                            }, null) : undefined
                                        ])
                                    ]);
                                })
                            ]))
                    ])
                ]));
            return {};
        }
    });
    // Utilities
    const VPickerTitle = createSimpleFunctional('v-picker-title');
    // Types
    const makeVPickerProps = propsFactory({
        bgColor: String,
        divided: Boolean,
        landscape: Boolean,
        title: String,
        hideHeader: Boolean,
        hideTitle: Boolean,
        ...makeVSheetProps()
    }, 'VPicker');
    const VPicker = genericComponent()({
        name: 'VPicker',
        props: makeVPickerProps(),
        setup (props, { slots: slots }) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            useRender(()=>{
                const sheetProps = VSheet.filterProps(props);
                const hasTitle = !props.hideTitle && !!(props.title || slots.title);
                return vue.createVNode(VSheet, vue.mergeProps(sheetProps, {
                    "color": props.bgColor,
                    "class": [
                        'v-picker',
                        {
                            'v-picker--divided': props.divided,
                            'v-picker--landscape': props.landscape,
                            'v-picker--with-actions': !!slots.actions
                        },
                        props.class
                    ],
                    "style": props.style
                }), {
                    default: ()=>[
                            !props.hideHeader && vue.createElementVNode("div", {
                                "key": "header",
                                "class": vue.normalizeClass([
                                    'v-picker__header-wrapper',
                                    backgroundColorClasses.value
                                ]),
                                "style": vue.normalizeStyle([
                                    backgroundColorStyles.value
                                ])
                            }, [
                                hasTitle && vue.createVNode(VPickerTitle, {
                                    "key": "picker-title"
                                }, {
                                    default: ()=>[
                                            slots.title?.() ?? props.title
                                        ]
                                }),
                                slots.header && vue.createElementVNode("div", {
                                    "class": "v-picker__header"
                                }, [
                                    slots.header()
                                ])
                            ]),
                            vue.createElementVNode("div", {
                                "class": "v-picker__body"
                            }, [
                                slots.default?.()
                            ]),
                            slots.actions && vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VBtn: {
                                        slim: true,
                                        variant: 'text'
                                    }
                                }
                            }, {
                                default: ()=>[
                                        vue.createElementVNode("div", {
                                            "class": "v-picker__actions"
                                        }, [
                                            slots.actions()
                                        ])
                                    ]
                            })
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVColorPickerProps = propsFactory({
        canvasHeight: {
            type: [
                String,
                Number
            ],
            default: 150
        },
        disabled: Boolean,
        dotSize: {
            type: [
                Number,
                String
            ],
            default: 10
        },
        hideCanvas: Boolean,
        hideSliders: Boolean,
        hideInputs: Boolean,
        hideInputLabels: Boolean,
        mode: {
            type: String,
            default: 'rgba',
            validator: (v)=>Object.keys(modes).includes(v)
        },
        modes: {
            type: Array,
            default: ()=>Object.keys(modes),
            validator: (v)=>Array.isArray(v) && v.every((m)=>Object.keys(modes).includes(m))
        },
        showSwatches: Boolean,
        readonly: Boolean,
        swatches: Array,
        swatchesMaxHeight: {
            type: [
                Number,
                String
            ],
            default: 150
        },
        modelValue: {
            type: [
                Object,
                String
            ]
        },
        ...makeVPickerProps({
            hideHeader: true
        }),
        ...pick(makeVColorPickerPreviewProps(), [
            'hideEyeDropper',
            'eyeDropperIcon'
        ])
    }, 'VColorPicker');
    const VColorPicker = defineComponent({
        name: 'VColorPicker',
        props: makeVColorPickerProps(),
        emits: {
            'update:modelValue': (color)=>true,
            'update:mode': (mode)=>true
        },
        setup (props, { slots: slots }) {
            const mode = useProxiedModel(props, 'mode');
            const hue = vue.ref(null);
            const model = useProxiedModel(props, 'modelValue', undefined, (v)=>{
                if (v == null || v === '') return null;
                let c;
                try {
                    c = RGBtoHSV(parseColor(v));
                } catch (err) {
                    consoleWarn(err);
                    return null;
                }
                return c;
            }, (v)=>{
                if (!v) return null;
                return extractColor(v, props.modelValue);
            });
            const currentColor = vue.computed(()=>{
                return model.value ? {
                    ...model.value,
                    h: hue.value ?? model.value.h
                } : null;
            });
            const { rtlClasses: rtlClasses } = useRtl();
            let externalChange = true;
            vue.watch(model, (v)=>{
                if (!externalChange) {
                    // prevent hue shift from rgb conversion inaccuracy
                    externalChange = true;
                    return;
                }
                if (!v) return;
                hue.value = v.h;
            }, {
                immediate: true
            });
            const updateColor = (hsva)=>{
                externalChange = false;
                hue.value = hsva.h;
                model.value = hsva;
            };
            vue.onBeforeMount(()=>{
                if (!props.modes.includes(mode.value)) mode.value = props.modes[0];
            });
            provideDefaults({
                VSlider: {
                    color: null,
                    trackColor: null,
                    trackFillColor: null
                }
            });
            useRender(()=>{
                const pickerProps = VPicker.filterProps(props);
                return vue.createVNode(VPicker, vue.mergeProps(pickerProps, {
                    "class": [
                        'v-color-picker',
                        rtlClasses.value,
                        props.class
                    ],
                    "style": [
                        {
                            '--v-color-picker-color-hsv': HSVtoCSS({
                                ...currentColor.value ?? nullColor,
                                a: 1
                            })
                        },
                        props.style
                    ]
                }), {
                    ...slots,
                    default: ()=>vue.createElementVNode(vue.Fragment, null, [
                            !props.hideCanvas && vue.createVNode(VColorPickerCanvas, {
                                "key": "canvas",
                                "color": currentColor.value,
                                "onUpdate:color": updateColor,
                                "disabled": props.disabled,
                                "readonly": props.readonly,
                                "dotSize": props.dotSize,
                                "width": props.width,
                                "height": props.canvasHeight
                            }, null),
                            (!props.hideSliders || !props.hideInputs) && vue.createElementVNode("div", {
                                "key": "controls",
                                "class": "v-color-picker__controls"
                            }, [
                                !props.hideSliders && vue.createVNode(VColorPickerPreview, {
                                    "key": "preview",
                                    "color": currentColor.value,
                                    "onUpdate:color": updateColor,
                                    "hideAlpha": !mode.value.endsWith('a'),
                                    "disabled": props.disabled,
                                    "readonly": props.readonly,
                                    "hideEyeDropper": props.hideEyeDropper,
                                    "eyeDropperIcon": props.eyeDropperIcon
                                }, null),
                                !props.hideInputs && vue.createVNode(VColorPickerEdit, {
                                    "key": "edit",
                                    "modes": props.modes,
                                    "mode": mode.value,
                                    "onUpdate:mode": (m)=>mode.value = m,
                                    "color": currentColor.value,
                                    "onUpdate:color": updateColor,
                                    "disabled": props.disabled,
                                    "readonly": props.readonly,
                                    "hideInputLabels": props.hideInputLabels
                                }, null)
                            ]),
                            props.showSwatches && vue.createVNode(VColorPickerSwatches, {
                                "key": "swatches",
                                "color": currentColor.value,
                                "onUpdate:color": updateColor,
                                "maxHeight": props.swatchesMaxHeight,
                                "swatches": props.swatches,
                                "disabled": props.disabled,
                                "readonly": props.readonly
                            }, null)
                        ])
                });
            });
            return {};
        }
    });
    // Types
    const makeVConfirmEditProps = propsFactory({
        modelValue: null,
        color: String,
        cancelText: {
            type: String,
            default: '$vuetify.confirmEdit.cancel'
        },
        okText: {
            type: String,
            default: '$vuetify.confirmEdit.ok'
        },
        disabled: {
            type: [
                Boolean,
                Array
            ],
            default: undefined
        },
        hideActions: Boolean
    }, 'VConfirmEdit');
    const VConfirmEdit = genericComponent()({
        name: 'VConfirmEdit',
        props: makeVConfirmEditProps(),
        emits: {
            cancel: ()=>true,
            save: (value)=>true,
            'update:modelValue': (value)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const internalModel = vue.ref();
            vue.watchEffect(()=>{
                internalModel.value = structuredClone(deepToRaw(model.value));
            });
            const { t: t } = useLocale();
            const isPristine = vue.computed(()=>{
                return deepEqual(model.value, internalModel.value);
            });
            function isActionDisabled(action) {
                if (typeof props.disabled === 'boolean') return props.disabled;
                if (Array.isArray(props.disabled)) return props.disabled.includes(action);
                return isPristine.value;
            }
            const isSaveDisabled = vue.computed(()=>isActionDisabled('save'));
            const isCancelDisabled = vue.computed(()=>isActionDisabled('cancel'));
            function save() {
                model.value = internalModel.value;
                emit('save', internalModel.value);
            }
            function cancel() {
                internalModel.value = structuredClone(deepToRaw(model.value));
                emit('cancel');
            }
            function actions(actionsProps) {
                return vue.createElementVNode(vue.Fragment, null, [
                    vue.createVNode(VBtn, vue.mergeProps({
                        "disabled": isCancelDisabled.value,
                        "variant": "text",
                        "color": props.color,
                        "onClick": cancel,
                        "text": t(props.cancelText)
                    }, actionsProps), null),
                    vue.createVNode(VBtn, vue.mergeProps({
                        "disabled": isSaveDisabled.value,
                        "variant": "text",
                        "color": props.color,
                        "onClick": save,
                        "text": t(props.okText)
                    }, actionsProps), null)
                ]);
            }
            let actionsUsed = false;
            useRender(()=>{
                return vue.createElementVNode(vue.Fragment, null, [
                    slots.default?.({
                        model: internalModel,
                        save: save,
                        cancel: cancel,
                        isPristine: isPristine.value,
                        get actions () {
                            actionsUsed = true;
                            return actions;
                        }
                    }),
                    !props.hideActions && !actionsUsed && actions()
                ]);
            });
            return {
                save: save,
                cancel: cancel,
                isPristine: isPristine
            };
        }
    });
    // Types
    const availablePipLocations = [
        'prepend',
        'prepend-inner',
        'append',
        'append-inner'
    ];
    const makeVColorInputProps = propsFactory({
        hidePip: Boolean,
        colorPip: Boolean,
        menuProps: Object,
        pipIcon: {
            type: String,
            default: '$color'
        },
        pipLocation: {
            type: String,
            default: 'prepend',
            validator: (v)=>availablePipLocations.includes(v)
        },
        pipVariant: {
            type: String,
            default: 'text'
        },
        pickerProps: Object,
        ...makeFocusProps(),
        ...makeVConfirmEditProps(),
        ...makeVTextFieldProps(),
        ...omit(makeVColorPickerProps(), [
            'location',
            'height',
            'minHeight',
            'maxHeight'
        ])
    }, 'VColorInput');
    const VColorInput = genericComponent()({
        name: 'VColorInput',
        props: makeVColorInputProps(),
        emits: {
            'update:modelValue': (val)=>true
        },
        setup (props, { slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const menu = vue.shallowRef(false);
            const isFocused = vue.shallowRef(props.focused);
            const isInteractive = vue.computed(()=>!props.disabled && !props.readonly);
            const display = vue.computed(()=>model.value || null);
            function onKeydown(e) {
                if (e.key !== 'Enter') return;
                if (!menu.value || !isFocused.value) {
                    menu.value = true;
                    return;
                }
                const target = e.target;
                model.value = target.value;
            }
            function onClick(e) {
                e.preventDefault();
                e.stopPropagation();
                menu.value = true;
            }
            function onSave() {
                menu.value = false;
            }
            function onCancel() {
                menu.value = false;
            }
            useRender(()=>{
                const confirmEditProps = VConfirmEdit.filterProps(props);
                const colorPickerProps = {
                    ...VColorPicker.filterProps(omit(props, [
                        'active',
                        'bgColor',
                        'color',
                        'rounded',
                        'maxWidth',
                        'minWidth',
                        'width'
                    ])),
                    ...props.pickerProps
                };
                const textFieldProps = VTextField.filterProps(props);
                const slotWithPip = props.hidePip ? undefined : {
                    [props.pipLocation]: (arg)=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VAvatar, {
                                "class": "v-color-input__pip",
                                "color": props.colorPip ? model.value : undefined,
                                "variant": props.pipVariant,
                                "icon": props.pipIcon
                            }, null),
                            slots[props.pipLocation]?.(arg)
                        ])
                };
                return vue.createVNode(VTextField, vue.mergeProps(textFieldProps, {
                    "class": [
                        'v-color-input',
                        props.class
                    ],
                    "style": props.style,
                    "modelValue": display.value,
                    "onKeydown": isInteractive.value ? onKeydown : undefined,
                    "focused": menu.value || isFocused.value,
                    "onClick:control": !props.disabled ? onClick : undefined,
                    "onClick:prependInner": !props.disabled ? onClick : undefined,
                    "onUpdate:focused": (event)=>isFocused.value = event,
                    "onClick:appendInner": !props.disabled ? onClick : undefined,
                    "onUpdate:modelValue": (val)=>{
                        model.value = val;
                    }
                }), {
                    ...slots,
                    ...slotWithPip,
                    default: ()=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VMenu, vue.mergeProps({
                                "modelValue": menu.value,
                                "onUpdate:modelValue": ($event)=>menu.value = $event,
                                "activator": "parent",
                                "minWidth": "0",
                                "closeOnContentClick": false,
                                "openOnClick": false
                            }, props.menuProps), {
                                default: ()=>[
                                        vue.createVNode(VConfirmEdit, vue.mergeProps(confirmEditProps, {
                                            "modelValue": model.value,
                                            "onUpdate:modelValue": ($event)=>model.value = $event,
                                            "onSave": onSave,
                                            "onCancel": onCancel
                                        }), {
                                            default: ({ actions: actions, model: proxyModel, save: save, cancel: cancel, isPristine: isPristine })=>{
                                                function onUpdateModel(value) {
                                                    if (!props.hideActions) proxyModel.value = value;
                                                    else model.value = value;
                                                }
                                                return vue.createVNode(VColorPicker, vue.mergeProps(colorPickerProps, {
                                                    "modelValue": props.hideActions ? model.value : proxyModel.value,
                                                    "onUpdate:modelValue": (value)=>onUpdateModel(value)
                                                }), {
                                                    actions: !props.hideActions ? ()=>slots.actions?.({
                                                            save: save,
                                                            cancel: cancel,
                                                            isPristine: isPristine
                                                        }) ?? actions() : undefined
                                                });
                                            }
                                        })
                                    ]
                            }),
                            slots.default?.()
                        ])
                });
            });
        }
    });
    // Types
    const makeVComboboxProps = propsFactory({
        alwaysFilter: Boolean,
        autoSelectFirst: {
            type: [
                Boolean,
                String
            ]
        },
        clearOnSelect: {
            type: Boolean,
            default: true
        },
        delimiters: Array,
        ...makeFilterProps({
            filterKeys: [
                'title'
            ]
        }),
        ...makeSelectProps({
            hideNoData: true,
            returnObject: true
        }),
        ...omit(makeVTextFieldProps({
            modelValue: null,
            role: 'combobox'
        }), [
            'validationValue',
            'dirty'
        ])
    }, 'VCombobox');
    const VCombobox = genericComponent()({
        name: 'VCombobox',
        props: makeVComboboxProps(),
        emits: {
            'update:focused': (focused)=>true,
            'update:modelValue': (value)=>true,
            'update:search': (value)=>true,
            'update:menu': (value)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const vTextFieldRef = vue.ref();
            const isFocused = vue.shallowRef(false);
            const isPristine = vue.shallowRef(true);
            const listHasFocus = vue.shallowRef(false);
            const vMenuRef = vue.ref();
            const vVirtualScrollRef = vue.ref();
            const selectionIndex = vue.shallowRef(-1);
            let cleared = false;
            const { items: items, transformIn: transformIn, transformOut: transformOut } = useItems(props);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>vTextFieldRef.value?.color);
            const { InputIcon: InputIcon } = useInputIcon(props);
            const model = useProxiedModel(props, 'modelValue', [], (v)=>transformIn(wrapInArray(v)), (v)=>{
                const transformed = transformOut(v);
                return props.multiple ? transformed : transformed[0] ?? null;
            });
            const form = useForm(props);
            const closableChips = vue.toRef(()=>props.closableChips && !form.isReadonly.value && !form.isDisabled.value);
            const hasChips = vue.computed(()=>!!(props.chips || slots.chip));
            const hasSelectionSlot = vue.computed(()=>hasChips.value || !!slots.selection);
            const _search = vue.shallowRef(!props.multiple && !hasSelectionSlot.value ? model.value[0]?.title ?? '' : '');
            const _searchLock = vue.shallowRef(null);
            const search = vue.computed({
                get: ()=>{
                    return _search.value;
                },
                set: async (val)=>{
                    _search.value = val ?? '';
                    if (val === null || val === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
                    else if (!props.multiple && !hasSelectionSlot.value) {
                        model.value = [
                            transformItem$3(props, val)
                        ];
                        vue.nextTick(()=>vVirtualScrollRef.value?.scrollToIndex(0));
                    }
                    if (val && props.multiple && props.delimiters?.length) {
                        const values = splitByDelimiters(val);
                        if (values.length > 1) {
                            selectMultiple(values);
                            _search.value = '';
                        }
                    }
                    if (!val) selectionIndex.value = -1;
                    isPristine.value = !val;
                }
            });
            const counterValue = vue.computed(()=>{
                return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : props.multiple ? model.value.length : search.value.length;
            });
            const { filteredItems: filteredItems, getMatches: getMatches } = useFilter(props, items, ()=>_searchLock.value ?? (props.alwaysFilter || !isPristine.value ? search.value : ''));
            const displayItems = vue.computed(()=>{
                if (props.hideSelected && _searchLock.value === null) return filteredItems.value.filter((filteredItem)=>!model.value.some((s)=>s.value === filteredItem.value));
                return filteredItems.value;
            });
            const menuDisabled = vue.computed(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
            const _menu = useProxiedModel(props, 'menu');
            const menu = vue.computed({
                get: ()=>_menu.value,
                set: (v)=>{
                    if (_menu.value && !v && vMenuRef.value?.\u03A8openChildren.size) return;
                    if (v && menuDisabled.value) return;
                    _menu.value = v;
                }
            });
            const { menuId: menuId, ariaExpanded: ariaExpanded, ariaControls: ariaControls } = useMenuActivator(props, menu);
            vue.watch(_search, (value)=>{
                if (cleared) // wait for clear to finish, VTextField sets _search to null
                // then search computed triggers and updates _search to ''
                vue.nextTick(()=>cleared = false);
                else if (isFocused.value && !menu.value) menu.value = true;
                emit('update:search', value);
            });
            vue.watch(model, (value)=>{
                if (!props.multiple && !hasSelectionSlot.value) _search.value = value[0]?.title ?? '';
            });
            const selectedValues = vue.computed(()=>model.value.map((selection)=>selection.value));
            const firstSelectableItem = vue.computed(()=>displayItems.value.find((x)=>x.type === 'item' && !x.props.disabled));
            const highlightFirst = vue.computed(()=>{
                const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === firstSelectableItem.value?.title;
                return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
            });
            const listRef = vue.ref();
            const headerRef = vue.ref();
            const footerRef = vue.ref();
            const listEvents = useScrolling(listRef, vTextFieldRef);
            const repairOrphanedFocus = useFocusRepair(menu, ()=>vMenuRef.value?.contentEl, ()=>vTextFieldRef.value?.controlRef);
            const { onTabKeydown: onTabKeydown } = useFocusGroups({
                groups: [
                    {
                        type: 'element',
                        contentRef: headerRef
                    },
                    {
                        type: 'list',
                        contentRef: listRef,
                        displayItemsCount: ()=>displayItems.value.length
                    },
                    {
                        type: 'element',
                        contentRef: footerRef
                    }
                ],
                onLeave: ()=>{
                    menu.value = false;
                    vTextFieldRef.value?.focus();
                }
            });
            function onClear(e) {
                cleared = true;
                vue.nextTick(()=>cleared = false);
                if (props.openOnClear) menu.value = true;
            }
            function onMousedownControl() {
                if (menuDisabled.value) return;
                menu.value = true;
            }
            function onMousedownMenuIcon(e) {
                if (menuDisabled.value) return;
                if (isFocused.value) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                menu.value = !menu.value;
            }
            function onMenuKeydown(e) {
                if (e.key === 'Tab') onTabKeydown(e);
                if (listRef.value?.$el.contains(e.target) && (checkPrintable(e) || e.key === 'Backspace')) vTextFieldRef.value?.focus();
            }
            // eslint-disable-next-line complexity
            function onKeydown(e) {
                if (isComposingIgnoreKey(e) || form.isReadonly.value) return;
                const selectionStart = vTextFieldRef.value?.selectionStart;
                const length = model.value.length;
                if ([
                    'Enter',
                    'ArrowDown',
                    'ArrowUp'
                ].includes(e.key)) e.preventDefault();
                if ([
                    'Enter',
                    'ArrowDown'
                ].includes(e.key)) menu.value = true;
                if ([
                    'Escape'
                ].includes(e.key)) menu.value = false;
                if (highlightFirst.value && [
                    'Enter',
                    'Tab'
                ].includes(e.key) && firstSelectableItem.value && !model.value.some(({ value: value })=>value === firstSelectableItem.value.value)) select(firstSelectableItem.value);
                if (e.key === 'ArrowDown' && highlightFirst.value) listRef.value?.focus('next');
                if (e.key === 'Enter' && search.value) {
                    select(transformItem$3(props, search.value), true, true);
                    if (hasSelectionSlot.value) _search.value = '';
                }
                if ([
                    'Backspace',
                    'Delete'
                ].includes(e.key)) {
                    if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                    if (~selectionIndex.value) {
                        e.preventDefault();
                        const originalSelectionIndex = selectionIndex.value;
                        select(model.value[selectionIndex.value], false);
                        selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                    } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                    return;
                }
                if (!props.multiple) return;
                if (e.key === 'ArrowLeft') {
                    if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                    const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                    if (model.value[prev]) selectionIndex.value = prev;
                    else {
                        selectionIndex.value = -1;
                        vTextFieldRef.value?.setSelectionRange(search.value.length, search.value.length);
                    }
                } else if (e.key === 'ArrowRight') {
                    if (selectionIndex.value < 0) return;
                    const next = selectionIndex.value + 1;
                    if (model.value[next]) selectionIndex.value = next;
                    else {
                        selectionIndex.value = -1;
                        vTextFieldRef.value?.setSelectionRange(0, 0);
                    }
                } else if (~selectionIndex.value && checkPrintable(e)) selectionIndex.value = -1;
            }
            function onPaste(e) {
                const clipboardText = e?.clipboardData?.getData('Text') ?? '';
                const values = splitByDelimiters(clipboardText);
                if (values.length > 1 && props.multiple) {
                    e.preventDefault();
                    selectMultiple(values);
                }
            }
            function onAfterEnter() {
                if (props.eager) vVirtualScrollRef.value?.calculateVisibleItems();
            }
            function onAfterLeave() {
                if (isFocused.value) {
                    if (vMenuRef.value?.contentEl?._clickOutside?.lastMousedownWasOutside) isFocused.value = false;
                    else vTextFieldRef.value?.focus();
                }
                isPristine.value = true;
                _searchLock.value = null;
            }
            /** @param set - null means toggle */ function select(item, set = true, keepMenu = false) {
                if (!item || item.props.disabled) return;
                if (props.multiple) {
                    const index = model.value.findIndex((selection)=>(props.valueComparator || deepEqual)(selection.value, item.value));
                    const add = set == null ? !~index : set;
                    if (~index) {
                        const value = add ? [
                            ...model.value,
                            item
                        ] : [
                            ...model.value
                        ];
                        value.splice(index, 1);
                        model.value = value;
                    } else if (add) model.value = [
                        ...model.value,
                        item
                    ];
                    if (props.clearOnSelect) search.value = '';
                } else {
                    const add = set !== false;
                    model.value = add ? [
                        item
                    ] : [];
                    if ((!isPristine.value || props.alwaysFilter) && _search.value) _searchLock.value = _search.value;
                    _search.value = add && !hasSelectionSlot.value ? item.title : '';
                    // watch for search watcher to trigger
                    vue.nextTick(()=>{
                        menu.value = keepMenu;
                        isPristine.value = true;
                    });
                }
            }
            function splitByDelimiters(val) {
                const effectiveDelimiters = [
                    '\n',
                    ...props.delimiters ?? []
                ];
                const signsToMatch = effectiveDelimiters.map(escapeForRegex).join('|');
                return val.split(new RegExp(`(?:${signsToMatch})+`));
            }
            async function selectMultiple(values) {
                for (let value of values){
                    value = value.trim();
                    if (value) {
                        select(transformItem$3(props, value));
                        await vue.nextTick();
                    }
                }
            }
            function onFocusin(e) {
                isFocused.value = true;
                setTimeout(()=>{
                    listHasFocus.value = true;
                });
            }
            function onFocusout(e) {
                listHasFocus.value = false;
                if (!vTextFieldRef.value?.$el.contains(e.relatedTarget)) {
                    if (repairOrphanedFocus(e)) return;
                    isFocused.value = false;
                }
            }
            let mousedownInsideContentAt = 0;
            function onMousedownContent() {
                mousedownInsideContentAt = performance.now();
            }
            function onBlur(e) {
                const next = e.relatedTarget;
                const menuContent = vMenuRef.value?.contentEl;
                if (menuContent?.contains(next) || !next && performance.now() - mousedownInsideContentAt < 10) isFocused.value = true;
            }
            vue.watch(isFocused, (val, oldVal)=>{
                if (val || val === oldVal) return;
                selectionIndex.value = -1;
                menu.value = false;
                if (search.value) {
                    if (props.multiple) {
                        select(transformItem$3(props, search.value));
                        return;
                    }
                    if (!hasSelectionSlot.value) return;
                    if (model.value.some(({ title: title })=>title === search.value)) _search.value = '';
                    else select(transformItem$3(props, search.value));
                }
            });
            vue.watch(menu, (val)=>{
                if (!props.hideSelected && val && model.value.length && isPristine.value) {
                    const index = displayItems.value.findIndex((item)=>model.value.some((s)=>(props.valueComparator || deepEqual)(s.value, item.value)));
                    IN_BROWSER && !props.noAutoScroll && window.requestAnimationFrame(()=>{
                        index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
                    });
                }
                if (val) _searchLock.value = null;
            });
            vue.watch(items, (newVal, oldVal)=>{
                if (menu.value) return;
                if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
            });
            useRender(()=>{
                const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
                const isDirty = model.value.length > 0;
                const textFieldProps = VTextField.filterProps(props);
                const menuSlotProps = {
                    search: search,
                    filteredItems: filteredItems.value
                };
                return vue.createVNode(VTextField, vue.mergeProps({
                    "ref": vTextFieldRef
                }, textFieldProps, {
                    "modelValue": search.value,
                    "onUpdate:modelValue": ($event)=>search.value = $event,
                    "focused": isFocused.value,
                    "onUpdate:focused": ($event)=>isFocused.value = $event,
                    "validationValue": model.externalValue,
                    "counterValue": counterValue.value,
                    "dirty": isDirty,
                    "class": [
                        'v-combobox',
                        {
                            'v-combobox--active-menu': menu.value,
                            'v-combobox--chips': !!props.chips,
                            'v-combobox--selection-slot': !!hasSelectionSlot.value,
                            'v-combobox--selecting-index': selectionIndex.value > -1,
                            [`v-combobox--${props.multiple ? 'multiple' : 'single'}`]: true
                        },
                        props.class
                    ],
                    "style": props.style,
                    "readonly": form.isReadonly.value,
                    "placeholder": isDirty ? undefined : props.placeholder,
                    "onClick:clear": onClear,
                    "onMousedown:control": onMousedownControl,
                    "onKeydown": onKeydown,
                    "onPaste": onPaste,
                    "onBlur": onBlur,
                    "aria-expanded": ariaExpanded.value,
                    "aria-controls": ariaControls.value
                }), {
                    ...slots,
                    default: ({ id: id })=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VMenu, vue.mergeProps({
                                "id": menuId.value,
                                "ref": vMenuRef,
                                "modelValue": menu.value,
                                "onUpdate:modelValue": ($event)=>menu.value = $event,
                                "activator": "parent",
                                "disabled": menuDisabled.value,
                                "eager": props.eager,
                                "maxHeight": 310,
                                "openOnClick": false,
                                "closeOnContentClick": false,
                                "onAfterEnter": onAfterEnter,
                                "onAfterLeave": onAfterLeave
                            }, props.menuProps, {
                                "contentClass": [
                                    'v-combobox__content',
                                    props.menuProps?.contentClass
                                ]
                            }), {
                                default: ()=>[
                                        vue.createVNode(VSheet, {
                                            "elevation": props.menuElevation,
                                            "onFocusin": onFocusin,
                                            "onKeydown": onMenuKeydown,
                                            "onMousedown": onMousedownContent
                                        }, {
                                            default: ()=>[
                                                    slots['menu-header'] && vue.createElementVNode("header", {
                                                        "ref": headerRef
                                                    }, [
                                                        slots['menu-header'](menuSlotProps)
                                                    ]),
                                                    hasList && vue.createVNode(VList, vue.mergeProps({
                                                        "key": "combobox-list",
                                                        "ref": listRef,
                                                        "filterable": true,
                                                        "selected": selectedValues.value,
                                                        "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                                        "onMousedown": (e)=>e.preventDefault(),
                                                        "selectable": !!displayItems.value.length,
                                                        "onFocusout": onFocusout,
                                                        "tabindex": "-1",
                                                        "aria-live": "polite",
                                                        "aria-labelledby": `${id.value}-label`,
                                                        "aria-multiselectable": props.multiple,
                                                        "color": props.itemColor ?? props.color
                                                    }, listEvents, props.listProps), {
                                                        default: ()=>[
                                                                slots['prepend-item']?.(),
                                                                !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? vue.createVNode(VListItem, {
                                                                    "key": "no-data",
                                                                    "title": t(props.noDataText)
                                                                }, null)),
                                                                vue.createVNode(VVirtualScroll, {
                                                                    "ref": vVirtualScrollRef,
                                                                    "renderless": true,
                                                                    "items": displayItems.value,
                                                                    "itemKey": "value"
                                                                }, {
                                                                    default: ({ item: item, index: index, itemRef: itemRef })=>{
                                                                        const camelizedProps = camelizeProps(item.props);
                                                                        const itemProps = vue.mergeProps(item.props, {
                                                                            ref: itemRef,
                                                                            key: item.value,
                                                                            active: highlightFirst.value && item === firstSelectableItem.value ? true : undefined,
                                                                            onClick: ()=>select(item, null),
                                                                            'aria-posinset': index + 1,
                                                                            'aria-setsize': displayItems.value.length
                                                                        });
                                                                        if (item.type === 'divider') return slots.divider?.({
                                                                            props: item.raw,
                                                                            index: index
                                                                        }) ?? vue.createVNode(VDivider, vue.mergeProps(item.props, {
                                                                            "ref": itemRef,
                                                                            "key": `divider-${index}`
                                                                        }), null);
                                                                        if (item.type === 'subheader') return slots.subheader?.({
                                                                            props: item.raw,
                                                                            index: index
                                                                        }) ?? vue.createVNode(VListSubheader, vue.mergeProps(item.props, {
                                                                            "ref": itemRef,
                                                                            "key": `subheader-${index}`
                                                                        }), null);
                                                                        return slots.item?.({
                                                                            item: item.raw,
                                                                            internalItem: item,
                                                                            index: index,
                                                                            props: itemProps
                                                                        }) ?? vue.createVNode(VListItem, vue.mergeProps(itemProps, {
                                                                            "role": "option"
                                                                        }), {
                                                                            prepend: ({ isSelected: isSelected })=>vue.createElementVNode(vue.Fragment, null, [
                                                                                    props.multiple && !props.hideSelected ? vue.createVNode(VCheckboxBtn, {
                                                                                        "key": item.value,
                                                                                        "modelValue": isSelected,
                                                                                        "ripple": false,
                                                                                        "tabindex": "-1",
                                                                                        "aria-hidden": true,
                                                                                        "onClick": (event)=>event.preventDefault()
                                                                                    }, null) : undefined,
                                                                                    camelizedProps.prependAvatar && vue.createVNode(VAvatar, {
                                                                                        "image": camelizedProps.prependAvatar
                                                                                    }, null),
                                                                                    camelizedProps.prependIcon && vue.createVNode(VIcon, {
                                                                                        "icon": camelizedProps.prependIcon
                                                                                    }, null)
                                                                                ]),
                                                                            title: ()=>{
                                                                                return isPristine.value ? item.title : vue.createVNode(VHighlight, {
                                                                                    "text": item.title,
                                                                                    "matches": getMatches(item)?.title,
                                                                                    "markClass": "v-combobox__mask",
                                                                                    "matchAll": true,
                                                                                    "ignoreCase": true
                                                                                }, null);
                                                                            }
                                                                        });
                                                                    }
                                                                }),
                                                                slots['append-item']?.()
                                                            ]
                                                    }),
                                                    slots['menu-footer'] && vue.createElementVNode("footer", {
                                                        "ref": footerRef
                                                    }, [
                                                        slots['menu-footer'](menuSlotProps)
                                                    ])
                                                ]
                                        })
                                    ]
                            }),
                            model.value.map((item, index)=>{
                                function onChipClose(e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    select(item, false);
                                }
                                const slotProps = vue.mergeProps(VChip.filterProps(item.props), {
                                    'onClick:close': onChipClose,
                                    onKeydown (e) {
                                        if (e.key !== 'Enter' && e.key !== ' ') return;
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onChipClose(e);
                                    },
                                    onMousedown (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    },
                                    modelValue: true,
                                    'onUpdate:modelValue': undefined
                                });
                                const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                                const slotContent = hasSlot ? ensureValidVNode(hasChips.value ? slots.chip({
                                    item: item.raw,
                                    internalItem: item,
                                    index: index,
                                    props: slotProps
                                }) : slots.selection({
                                    item: item.raw,
                                    internalItem: item,
                                    index: index
                                })) : undefined;
                                if (hasSlot && !slotContent) return undefined;
                                return vue.createElementVNode("div", {
                                    "key": item.value,
                                    "class": vue.normalizeClass([
                                        'v-combobox__selection',
                                        index === selectionIndex.value && [
                                            'v-combobox__selection--selected',
                                            textColorClasses.value
                                        ]
                                    ]),
                                    "style": vue.normalizeStyle(index === selectionIndex.value ? textColorStyles.value : {})
                                }, [
                                    hasChips.value ? !slots.chip ? vue.createVNode(VChip, vue.mergeProps({
                                        "key": "chip",
                                        "closable": closableChips.value,
                                        "size": "small",
                                        "text": item.title,
                                        "disabled": item.props.disabled
                                    }, slotProps), null) : vue.createVNode(VDefaultsProvider, {
                                        "key": "chip-defaults",
                                        "defaults": {
                                            VChip: {
                                                closable: closableChips.value,
                                                size: 'small',
                                                text: item.title
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slotContent
                                            ]
                                    }) : slotContent ?? vue.createElementVNode("span", {
                                        "class": "v-combobox__selection-text"
                                    }, [
                                        item.title,
                                        props.multiple && index < model.value.length - 1 && vue.createElementVNode("span", {
                                            "class": "v-combobox__selection-comma"
                                        }, [
                                            vue.createTextVNode(",")
                                        ])
                                    ])
                                ]);
                            })
                        ]),
                    'append-inner': (...args)=>vue.createElementVNode(vue.Fragment, null, [
                            slots['append-inner']?.(...args),
                            (!props.hideNoData || props.items.length) && props.menuIcon ? vue.createVNode(VIcon, {
                                "class": "v-combobox__menu-icon",
                                "color": vTextFieldRef.value?.fieldIconColor,
                                "icon": props.menuIcon,
                                "onMousedown": onMousedownMenuIcon,
                                "onClick": noop,
                                "aria-hidden": true,
                                "tabindex": "-1"
                            }, null) : undefined,
                            props.appendInnerIcon && vue.createVNode(InputIcon, {
                                "key": "append-icon",
                                "name": "appendInner",
                                "color": args[0].iconColor.value
                            }, null)
                        ])
                });
            });
            return forwardRefs({
                isFocused: isFocused,
                isPristine: isPristine,
                menu: menu,
                search: search,
                selectionIndex: selectionIndex,
                filteredItems: filteredItems,
                select: select
            }, vTextFieldRef);
        }
    });
    // Composables
    // Types
    const makeDataTableExpandProps = propsFactory({
        expandOnClick: Boolean,
        showExpand: Boolean,
        expanded: {
            type: Array,
            default: ()=>[]
        },
        expandStrategy: {
            type: String,
            default: 'multiple'
        }
    }, 'DataTable-expand');
    const VDataTableExpandedKey = Symbol.for('vuetify:datatable:expanded');
    function provideExpanded(props) {
        const expandOnClick = vue.toRef(()=>props.expandOnClick);
        const expanded = useProxiedModel(props, 'expanded', props.expanded, (v)=>{
            return new Set(v);
        }, (v)=>{
            return [
                ...v.values()
            ];
        });
        function expand(item, value) {
            const rawValue = vue.toRaw(item.value);
            const newExpanded = value && props.expandStrategy === 'single' ? new Set() : new Set(expanded.value);
            if (!value) {
                const existing = [
                    ...expanded.value
                ].find((x)=>vue.toRaw(x) === rawValue);
                newExpanded.delete(existing);
            } else newExpanded.add(item.value);
            expanded.value = newExpanded;
        }
        function isExpanded(item) {
            const rawValue = vue.toRaw(item.value);
            return [
                ...expanded.value
            ].some((x)=>vue.toRaw(x) === rawValue);
        }
        function toggleExpand(item) {
            expand(item, !isExpanded(item));
        }
        const data = {
            expand: expand,
            expanded: expanded,
            expandOnClick: expandOnClick,
            isExpanded: isExpanded,
            toggleExpand: toggleExpand
        };
        vue.provide(VDataTableExpandedKey, data);
        return data;
    }
    function useExpanded() {
        const data = vue.inject(VDataTableExpandedKey);
        if (!data) throw new Error('foo');
        return data;
    }
    // Composables
    // Types
    const makeDataTableGroupProps = propsFactory({
        groupBy: {
            type: Array,
            default: ()=>[]
        },
        opened: {
            type: Array,
            default: ()=>[]
        },
        openAll: Boolean,
        groupKey: Function
    }, 'DataTable-group');
    const VDataTableGroupSymbol = Symbol.for('vuetify:data-table-group');
    function createGroupBy(props) {
        const groupBy = useProxiedModel(props, 'groupBy');
        const opened = useProxiedModel(props, 'opened');
        const openAll = vue.toRef(()=>props.openAll);
        const groupKey = vue.toRef(()=>props.groupKey);
        return {
            groupBy: groupBy,
            opened: opened,
            openAll: openAll,
            groupKey: groupKey
        };
    }
    function provideGroupBy(options) {
        const { disableSort: disableSort, groupBy: groupBy, sortBy: sortBy } = options;
        const openedModel = options.opened ?? vue.ref([]);
        // Keep a Set mirror for O(1) lookups; the v-model carries the string[] form.
        const localOpened = vue.shallowRef(new Set(openedModel.value));
        vue.watch(openedModel, (val)=>{
            localOpened.value = new Set(val);
        });
        const opened = vue.computed({
            get: ()=>localOpened.value,
            set: (v)=>{
                localOpened.value = v;
                openedModel.value = [
                    ...v.values()
                ];
            }
        });
        const sortByWithGroups = vue.computed(()=>{
            return groupBy.value.map((val)=>({
                    ...val,
                    order: val.order ?? false
                })).concat(disableSort?.value ? [] : sortBy.value);
        });
        function isGroupOpen(group) {
            return opened.value.has(group.id);
        }
        function toggleGroup(group) {
            const newOpened = new Set(opened.value);
            if (isGroupOpen(group)) newOpened.delete(group.id);
            else newOpened.add(group.id);
            opened.value = newOpened;
        }
        function extractRows(items) {
            function dive(group) {
                const arr = [];
                for (const item of group.items)if ('type' in item && item.type === 'group') arr.push(...dive(item));
                else arr.push(item);
                return [
                    ...new Set(arr)
                ];
            }
            return dive({
                items: items
            });
        }
        const data = {
            sortByWithGroups: sortByWithGroups,
            toggleGroup: toggleGroup,
            opened: opened,
            groupBy: groupBy,
            extractRows: extractRows,
            isGroupOpen: isGroupOpen
        };
        vue.provide(VDataTableGroupSymbol, data);
        return data;
    }
    function useGroupBy() {
        const data = vue.inject(VDataTableGroupSymbol);
        if (!data) throw new Error('Missing group!');
        return data;
    }
    function groupItemsByProperty(items, groupBy) {
        if (!items.length) return [];
        const groups = new Map();
        for (const item of items){
            const value = getObjectValueByPath(item.raw, groupBy);
            if (!groups.has(value)) groups.set(value, []);
            groups.get(value).push(item);
        }
        return groups;
    }
    const defaultGroupId = (key, value, parentKey)=>`${parentKey}_${key}_${value}`;
    function groupItems(items, groupBy, groupKey, depth = 0, parentKey = 'root') {
        if (!groupBy.length) return [];
        const groupedItems = groupItemsByProperty(items, groupBy[0]);
        const groups = [];
        const rest = groupBy.slice(1);
        groupedItems.forEach((items, value)=>{
            const key = groupBy[0];
            const id = groupKey ? groupKey({
                key: key,
                value: value,
                parentKey: depth === 0 ? null : parentKey
            }) : defaultGroupId(key, value, parentKey);
            groups.push({
                depth: depth,
                id: id,
                key: key,
                value: value,
                items: rest.length ? groupItems(items, rest, groupKey, depth + 1, id) : items,
                type: 'group'
            });
        });
        return groups;
    }
    function collectGroupIds(groups) {
        return groups.flatMap((group)=>[
                group.id,
                ...collectGroupIds(group.items.filter((item)=>'type' in item && item.type === 'group'))
            ]);
    }
    function useOpenAllGroups(opened, openAll, items, groupBy, groupKey) {
        const allIds = vue.computed(()=>{
            if (!vue.toValue(openAll) || !groupBy.value.length) return new Set();
            return new Set(collectGroupIds(groupItems(vue.toValue(items), groupBy.value.map((group)=>group.key), vue.toValue(groupKey))));
        });
        vue.watch(allIds, (newIds, oldIds)=>{
            if (!vue.toValue(openAll)) return;
            const current = new Set(opened.value);
            let changed = false;
            for (const id of newIds)if (!oldIds?.has(id) && !current.has(id)) {
                current.add(id);
                changed = true;
            }
            for (const id of oldIds ?? [])if (!newIds.has(id) && current.has(id)) {
                current.delete(id);
                changed = true;
            }
            if (changed) opened.value = current;
        }, {
            immediate: true
        });
    }
    function flattenItems(items, isOpen, hasSummary) {
        const flatItems = [];
        for (const item of items)// TODO: make this better
        if ('type' in item && item.type === 'group') {
            if (item.value != null) flatItems.push(item);
            if (isOpen(item) || item.value == null) {
                flatItems.push(...flattenItems(item.items, isOpen, hasSummary));
                if (hasSummary) flatItems.push({
                    ...item,
                    type: 'group-summary'
                });
            }
        } else flatItems.push(item);
        return flatItems;
    }
    function useGroupedItems(items, groupBy, opened, hasSummary, isGroupOpen, groupKey) {
        const groups = vue.computed(()=>{
            if (!groupBy.value.length) return [];
            return groupItems(vue.toValue(items), groupBy.value.map((item)=>item.key), vue.toValue(groupKey));
        });
        const isOpen = isGroupOpen ?? ((group)=>opened.value.has(group.id));
        const flatItems = vue.computed(()=>{
            if (!groupBy.value.length) return vue.toValue(items);
            return flattenItems(groups.value, isOpen, vue.toValue(hasSummary));
        });
        return {
            groups: groups,
            flatItems: flatItems
        };
    }
    // Utilities
    // Types
    function useOptions({ page: page, itemsPerPage: itemsPerPage, sortBy: sortBy, groupBy: groupBy, search: search }) {
        const vm = getCurrentInstance('VDataTable');
        const options = ()=>({
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                groupBy: groupBy.value,
                search: search.value
            });
        let oldOptions = null;
        vue.watch(options, (value)=>{
            if (deepEqual(oldOptions, value)) return;
            // Reset page when searching
            if (oldOptions && oldOptions.search !== value.search) page.value = 1;
            vm.emit('update:options', value);
            oldOptions = value;
        }, {
            deep: true,
            immediate: true
        });
    }
    // Composables
    // Types
    const makeDataTablePaginateProps = propsFactory({
        page: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        itemsPerPage: {
            type: [
                Number,
                String
            ],
            default: 10
        },
        pageBy: {
            type: String,
            default: 'any'
        }
    }, 'DataTable-paginate');
    const VDataTablePaginationSymbol = Symbol.for('vuetify:data-table-pagination');
    function createPagination(props) {
        const page = useProxiedModel(props, 'page', undefined, (value)=>Number(value ?? 1));
        const itemsPerPage = useProxiedModel(props, 'itemsPerPage', undefined, (value)=>Number(value ?? 10));
        return {
            page: page,
            itemsPerPage: itemsPerPage
        };
    }
    function providePagination(options) {
        const { page: page, itemsPerPage: itemsPerPage, itemsLength: itemsLength } = options;
        const startIndex = vue.computed(()=>{
            if (itemsPerPage.value === -1) return 0;
            return itemsPerPage.value * (page.value - 1);
        });
        const stopIndex = vue.computed(()=>{
            if (itemsPerPage.value === -1) return itemsLength.value;
            return Math.min(itemsLength.value, startIndex.value + itemsPerPage.value);
        });
        const pageCount = vue.computed(()=>{
            if (itemsPerPage.value === -1 || itemsLength.value === 0) return 1;
            return Math.ceil(itemsLength.value / itemsPerPage.value);
        });
        // Don't run immediately, items may not have been loaded yet: #17966
        vue.watch([
            page,
            pageCount
        ], ()=>{
            if (page.value > pageCount.value) page.value = pageCount.value;
        });
        function setItemsPerPage(value) {
            itemsPerPage.value = value;
            page.value = 1;
        }
        function nextPage() {
            page.value = clamp(page.value + 1, 1, pageCount.value);
        }
        function prevPage() {
            page.value = clamp(page.value - 1, 1, pageCount.value);
        }
        function setPage(value) {
            page.value = clamp(value, 1, pageCount.value);
        }
        const data = {
            page: page,
            itemsPerPage: itemsPerPage,
            startIndex: startIndex,
            stopIndex: stopIndex,
            pageCount: pageCount,
            itemsLength: itemsLength,
            nextPage: nextPage,
            prevPage: prevPage,
            setPage: setPage,
            setItemsPerPage: setItemsPerPage
        };
        vue.provide(VDataTablePaginationSymbol, data);
        return data;
    }
    function usePagination() {
        const data = vue.inject(VDataTablePaginationSymbol);
        if (!data) throw new Error('Missing pagination!');
        return data;
    }
    function usePaginatedItems(options) {
        const vm = getCurrentInstance('usePaginatedItems');
        const { items: items, startIndex: startIndex, stopIndex: stopIndex, itemsPerPage: itemsPerPage } = options;
        const paginatedItems = vue.computed(()=>{
            if (itemsPerPage.value <= 0) return vue.toValue(items);
            return vue.toValue(items).slice(startIndex.value, stopIndex.value);
        });
        vue.watch(paginatedItems, (val)=>{
            vm.emit('update:currentItems', val);
        }, {
            immediate: true
        });
        return {
            paginatedItems: paginatedItems
        };
    }
    function usePaginatedGroups(options) {
        const { sortedItems: sortedItems, paginate: paginate, group: group } = options;
        const pageBy = vue.toValue(options.pageBy); // TODO: make reactive
        if (pageBy === 'item') {
            const { paginatedItems: paginatedItems, pageCount: pageCount, setItemsPerPage: setItemsPerPage, prevPage: prevPage, nextPage: nextPage, setPage: setPage } = paginate(sortedItems);
            const { flatItems: paginatedItemsWithGroups } = group(paginatedItems);
            return {
                pageCount: pageCount,
                setItemsPerPage: setItemsPerPage,
                prevPage: prevPage,
                nextPage: nextPage,
                setPage: setPage,
                paginatedItems: paginatedItemsWithGroups
            };
        }
        if (pageBy === 'group') {
            const { flatItems: flatItems, groups: groups } = group(sortedItems);
            const { paginatedItems: paginatedGroups, pageCount: pageCount, setItemsPerPage: setItemsPerPage, prevPage: prevPage, nextPage: nextPage, setPage: setPage } = paginate(groups);
            const paginatedItemsWithGroups = vue.computed(()=>{
                if (!paginatedGroups.value.length) return [];
                const firstGroupId = paginatedGroups.value.at(0).id;
                const lastGroupId = paginatedGroups.value.at(-1).id;
                const start = flatItems.value.findIndex((item)=>item.type === 'group' && item.id === firstGroupId);
                const lastGroupIndex = flatItems.value.findIndex((item)=>item.type === 'group' && item.id === lastGroupId);
                const stop = flatItems.value.findIndex((item, i)=>i > lastGroupIndex && item.type === 'group' && item.depth === 0);
                return flatItems.value.slice(start, stop === -1 ? undefined : stop);
            });
            return {
                pageCount: pageCount,
                setItemsPerPage: setItemsPerPage,
                prevPage: prevPage,
                nextPage: nextPage,
                setPage: setPage,
                paginatedItems: paginatedItemsWithGroups
            };
        }
        if (pageBy === 'any') {
            const { flatItems: flatItems } = group(sortedItems);
            const { paginatedItems: paginatedItemsWithGroups, pageCount: pageCount, setItemsPerPage: setItemsPerPage, prevPage: prevPage, nextPage: nextPage, setPage: setPage } = paginate(flatItems);
            return {
                pageCount: pageCount,
                setItemsPerPage: setItemsPerPage,
                prevPage: prevPage,
                nextPage: nextPage,
                setPage: setPage,
                paginatedItems: paginatedItemsWithGroups
            };
        }
        throw new Error(`Unrecognized pagination target ${pageBy}`);
    }
    // Composables
    // Types
    const singleSelectStrategy = {
        showSelectAll: false,
        allSelected: ()=>[],
        select: ({ items: items, value: value })=>{
            return new Set(value ? [
                items[0]?.value
            ] : []);
        },
        selectAll: ({ selected: selected })=>selected
    };
    const pageSelectStrategy = {
        showSelectAll: true,
        allSelected: ({ currentPage: currentPage })=>currentPage,
        select: ({ items: items, value: value, selected: selected })=>{
            for (const item of items)if (value) selected.add(item.value);
            else selected.delete(item.value);
            return selected;
        },
        selectAll: ({ value: value, currentPage: currentPage, selected: selected })=>pageSelectStrategy.select({
                items: currentPage,
                value: value,
                selected: selected
            })
    };
    const allSelectStrategy = {
        showSelectAll: true,
        allSelected: ({ allItems: allItems })=>allItems,
        select: ({ items: items, value: value, selected: selected })=>{
            for (const item of items)if (value) selected.add(item.value);
            else selected.delete(item.value);
            return selected;
        },
        selectAll: ({ value: value, allItems: allItems })=>{
            return new Set(value ? allItems.map((item)=>item.value) : []);
        }
    };
    const makeDataTableSelectProps = propsFactory({
        showSelect: Boolean,
        selectStrategy: {
            type: [
                String,
                Object
            ],
            default: 'page'
        },
        modelValue: {
            type: Array,
            default: ()=>[]
        },
        valueComparator: Function
    }, 'DataTable-select');
    const VDataTableSelectionSymbol = Symbol.for('vuetify:data-table-selection');
    function provideSelection(props, { allItems: allItems, currentPage: currentPage }) {
        const selected = useProxiedModel(props, 'modelValue', props.modelValue, (v)=>{
            const customComparator = props.valueComparator;
            if (customComparator) return new Set(wrapInArray(v).map((v)=>{
                return allItems.value.find((item)=>customComparator(v, item.value))?.value ?? v;
            }));
            return new Set(wrapInArray(v).map((v)=>{
                return isPrimitive(v) ? allItems.value.find((item)=>v === item.value)?.value ?? v : allItems.value.find((item)=>deepEqual(v, item.value))?.value ?? v;
            }));
        }, (v)=>{
            return [
                ...v.values()
            ];
        });
        const allSelectable = vue.computed(()=>allItems.value.filter((item)=>item.selectable));
        const currentPageSelectable = vue.computed(()=>vue.toValue(currentPage).filter((item)=>item.selectable));
        const selectStrategy = vue.computed(()=>{
            if (typeof props.selectStrategy === 'object') return props.selectStrategy;
            switch(props.selectStrategy){
                case 'single':
                    return singleSelectStrategy;
                case 'all':
                    return allSelectStrategy;
                case 'page':
                default:
                    return pageSelectStrategy;
            }
        });
        const lastSelectedIndex = vue.shallowRef(null);
        function isSelected(items) {
            return wrapInArray(items).every((item)=>selected.value.has(item.value));
        }
        function isSomeSelected(items) {
            return wrapInArray(items).some((item)=>selected.value.has(item.value));
        }
        function select(items, value) {
            const newSelected = selectStrategy.value.select({
                items: items,
                value: value,
                selected: new Set(selected.value)
            });
            selected.value = newSelected;
        }
        function toggleSelect(item, index, event) {
            const items = [];
            const pageItems = vue.toValue(currentPage);
            index = index ?? pageItems.findIndex((i)=>i.value === item.value);
            if (props.selectStrategy !== 'single' && event?.shiftKey && lastSelectedIndex.value !== null) {
                const [start, end] = [
                    lastSelectedIndex.value,
                    index
                ].sort((a, b)=>a - b);
                items.push(...pageItems.slice(start, end + 1).filter((item)=>item.selectable));
            } else {
                items.push(item);
                lastSelectedIndex.value = index;
            }
            select(items, !isSelected([
                item
            ]));
        }
        function selectAll(value) {
            const newSelected = selectStrategy.value.selectAll({
                value: value,
                allItems: allSelectable.value,
                currentPage: currentPageSelectable.value,
                selected: new Set(selected.value)
            });
            selected.value = newSelected;
        }
        const someSelected = vue.computed(()=>selected.value.size > 0);
        const allSelected = vue.computed(()=>{
            const items = selectStrategy.value.allSelected({
                allItems: allSelectable.value,
                currentPage: currentPageSelectable.value
            });
            return !!items.length && isSelected(items);
        });
        const showSelectAll = vue.toRef(()=>selectStrategy.value.showSelectAll);
        const data = {
            toggleSelect: toggleSelect,
            select: select,
            selectAll: selectAll,
            isSelected: isSelected,
            isSomeSelected: isSomeSelected,
            someSelected: someSelected,
            allSelected: allSelected,
            showSelectAll: showSelectAll,
            lastSelectedIndex: lastSelectedIndex,
            selectStrategy: selectStrategy
        };
        vue.provide(VDataTableSelectionSymbol, data);
        return data;
    }
    function useSelection() {
        const data = vue.inject(VDataTableSelectionSymbol);
        if (!data) throw new Error('Missing selection!');
        return data;
    }
    // Composables
    // Types
    const makeDataTableSortProps = propsFactory({
        initialSortOrder: {
            type: String,
            default: 'asc',
            validator: (v)=>!v || [
                    'asc',
                    'desc'
                ].includes(v)
        },
        sortBy: {
            type: Array,
            default: ()=>[]
        },
        customKeySort: Object,
        multiSort: {
            type: [
                Boolean,
                Object
            ],
            default: false
        },
        mustSort: Boolean
    }, 'DataTable-sort');
    const VDataTableSortSymbol = Symbol.for('vuetify:data-table-sort');
    function createSort(props) {
        const initialSortOrder = vue.toRef(()=>props.initialSortOrder);
        const sortBy = useProxiedModel(props, 'sortBy');
        const mustSort = vue.toRef(()=>props.mustSort);
        const multiSort = vue.toRef(()=>props.multiSort);
        return {
            initialSortOrder: initialSortOrder,
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort
        };
    }
    function resolveMultiSort(multiSort, event) {
        if (!isObject(multiSort)) return {
            active: !!multiSort
        };
        const { key: key, mode: mode, modifier: modifier } = multiSort;
        const reverseMode = modifier === 'alt' && event?.altKey || modifier === 'shift' && event?.shiftKey;
        return {
            active: !key || event?.ctrlKey || event?.metaKey || false,
            mode: reverseMode ? mode === 'append' ? 'prepend' : 'append' : mode
        };
    }
    function provideSort(options) {
        const { initialSortOrder: initialSortOrder, sortBy: sortBy, mustSort: mustSort, multiSort: multiSort, page: page } = options;
        const toggleSort = (column, event, mandatory = false)=>{
            if (column.key == null) return;
            let newSortBy = sortBy.value.map((x)=>({
                    ...x
                })) ?? [];
            const item = newSortBy.find((x)=>x.key === column.key);
            const initialOrder = initialSortOrder.value;
            const secondaryOrder = initialSortOrder.value === 'desc' ? 'asc' : 'desc';
            if (!item) {
                const { active: active, mode: mode } = resolveMultiSort(multiSort.value, event);
                if (active) {
                    if (mode === 'prepend') newSortBy.unshift({
                        key: column.key,
                        order: initialOrder
                    });
                    else newSortBy.push({
                        key: column.key,
                        order: initialOrder
                    });
                } else newSortBy = [
                    {
                        key: column.key,
                        order: initialOrder
                    }
                ];
            } else if (item.order === secondaryOrder) {
                if (mandatory || mustSort.value && newSortBy.length === 1) item.order = initialSortOrder.value;
                else newSortBy = newSortBy.filter((x)=>x.key !== column.key);
            } else item.order = secondaryOrder;
            sortBy.value = newSortBy;
            if (page) page.value = 1;
        };
        function isSorted(column) {
            return !!sortBy.value.find((item)=>item.key === column.key);
        }
        const data = {
            sortBy: sortBy,
            toggleSort: toggleSort,
            isSorted: isSorted
        };
        vue.provide(VDataTableSortSymbol, data);
        return data;
    }
    function useSort() {
        const data = vue.inject(VDataTableSortSymbol);
        if (!data) throw new Error('Missing sort!');
        return data;
    }
    // TODO: abstract into project composable
    function useSortedItems(props, items, sortBy, options) {
        const locale = useLocale();
        const sortedItems = vue.computed(()=>{
            if (!sortBy.value.length) return items.value;
            return sortItems(items.value, sortBy.value, locale.current.value, {
                transform: options?.transform,
                sortFunctions: {
                    ...props.customKeySort,
                    ...options?.sortFunctions?.value
                },
                sortRawFunctions: options?.sortRawFunctions?.value
            });
        });
        return {
            sortedItems: sortedItems
        };
    }
    function sortItems(items, sortByItems, locale, options) {
        const stringCollator = new Intl.Collator(locale, {
            sensitivity: 'accent',
            usage: 'sort'
        });
        const transformedItems = items.map((item)=>[
                item,
                options?.transform ? options.transform(item) : item
            ]);
        return transformedItems.sort((a, b)=>{
            for(let i = 0; i < sortByItems.length; i++){
                let hasCustomResult = false;
                const sortKey = sortByItems[i].key;
                const sortOrder = sortByItems[i].order ?? 'asc';
                if (sortOrder === false) continue;
                let sortA = getObjectValueByPath(a[1], sortKey);
                let sortB = getObjectValueByPath(b[1], sortKey);
                let sortARaw = a[0].raw;
                let sortBRaw = b[0].raw;
                if (sortOrder === 'desc') {
                    [sortA, sortB] = [
                        sortB,
                        sortA
                    ];
                    [sortARaw, sortBRaw] = [
                        sortBRaw,
                        sortARaw
                    ];
                }
                if (options?.sortRawFunctions?.[sortKey]) {
                    const customResult = options.sortRawFunctions[sortKey](sortARaw, sortBRaw);
                    if (customResult == null) continue;
                    hasCustomResult = true;
                    if (customResult) return customResult;
                }
                if (options?.sortFunctions?.[sortKey]) {
                    const customResult = options.sortFunctions[sortKey](sortA, sortB);
                    if (customResult == null) continue;
                    hasCustomResult = true;
                    if (customResult) return customResult;
                }
                if (hasCustomResult) continue;
                // Dates should be compared numerically
                if (sortA instanceof Date && sortB instanceof Date) {
                    sortA = sortA.getTime();
                    sortB = sortB.getTime();
                }
                [sortA, sortB] = [
                    sortA,
                    sortB
                ].map((s)=>s != null ? s.toString().toLocaleLowerCase() : s);
                if (sortA !== sortB) {
                    if (isEmpty(sortA) && isEmpty(sortB)) return 0;
                    if (isEmpty(sortA)) return -1;
                    if (isEmpty(sortB)) return 1;
                    if (!isNaN(sortA) && !isNaN(sortB)) return Number(sortA) - Number(sortB);
                    return stringCollator.compare(sortA, sortB);
                }
            }
            return 0;
        }).map(([item])=>item);
    }
    // Utilities
    // Types
    // Composables
    const makeDataIteratorItemsProps = propsFactory({
        items: {
            type: Array,
            default: ()=>[]
        },
        itemValue: {
            type: [
                String,
                Array,
                Function
            ],
            default: 'id'
        },
        itemSelectable: {
            type: [
                String,
                Array,
                Function
            ],
            default: null
        },
        returnObject: Boolean
    }, 'DataIterator-items');
    function transformItem$1(props, item) {
        const value = props.returnObject ? item : getPropertyFromItem(item, props.itemValue);
        const selectable = getPropertyFromItem(item, props.itemSelectable, true);
        return {
            type: 'item',
            value: value,
            selectable: selectable,
            raw: item
        };
    }
    function transformItems$1(props, items) {
        const array = [];
        for (const item of items)array.push(transformItem$1(props, item));
        return array;
    }
    function useDataIteratorItems(props) {
        const items = vue.computed(()=>transformItems$1(props, props.items));
        return {
            items: items
        };
    }
    // Types
    const makeVDataIteratorProps = propsFactory({
        search: String,
        loading: Boolean,
        itemsLength: [
            Number,
            String
        ],
        ...makeComponentProps(),
        ...makeDataIteratorItemsProps(),
        ...makeDataTableSelectProps(),
        ...makeDataTableSortProps(),
        ...makeDataTablePaginateProps({
            itemsPerPage: 5
        }),
        ...makeDataTableExpandProps(),
        ...makeDataTableGroupProps(),
        ...makeFilterProps(),
        ...makeTagProps(),
        ...makeTransitionProps({
            transition: {
                component: VFadeTransition,
                hideOnLeave: true
            }
        })
    }, 'VDataIterator');
    const VDataIterator = genericComponent()({
        name: 'VDataIterator',
        props: makeVDataIteratorProps(),
        emits: {
            'update:modelValue': (value)=>true,
            'update:groupBy': (value)=>true,
            'update:page': (value)=>true,
            'update:itemsPerPage': (value)=>true,
            'update:sortBy': (value)=>true,
            'update:options': (value)=>true,
            'update:expanded': (value)=>true,
            'update:opened': (value)=>true,
            'update:currentItems': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { groupBy: groupBy, opened: opened, openAll: openAll, groupKey: groupKey } = createGroupBy(props);
            const search = vue.toRef(()=>props.search);
            const { items: items } = useDataIteratorItems(props);
            const { filteredItems: filteredItems } = useFilter(props, items, search, {
                transform: (item)=>item.raw
            });
            const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = createSort(props);
            const { page: page, itemsPerPage: itemsPerPage } = createPagination(props);
            const { toggleSort: toggleSort } = provideSort({
                initialSortOrder: initialSortOrder,
                sortBy: sortBy,
                multiSort: multiSort,
                mustSort: mustSort,
                page: page
            });
            const { sortByWithGroups: sortByWithGroups, opened: openedGroups, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = provideGroupBy({
                groupBy: groupBy,
                sortBy: sortBy,
                opened: opened
            });
            const { sortedItems: sortedItems } = useSortedItems(props, filteredItems, sortByWithGroups, {
                transform: (item)=>item.raw
            });
            useOpenAllGroups(openedGroups, openAll, sortedItems, groupBy, groupKey);
            const { flatItems: flatItems } = useGroupedItems(sortedItems, groupBy, openedGroups, false, isGroupOpen, groupKey);
            const manualPagination = vue.toRef(()=>!isEmpty(props.itemsLength));
            const itemsLength = vue.toRef(()=>manualPagination.value ? Number(props.itemsLength) : flatItems.value.length);
            const { startIndex: startIndex, stopIndex: stopIndex, pageCount: pageCount, prevPage: prevPage, nextPage: nextPage, setItemsPerPage: setItemsPerPage, setPage: setPage } = providePagination({
                page: page,
                itemsPerPage: itemsPerPage,
                itemsLength: itemsLength
            });
            const paginatedItems = vue.shallowRef([]);
            const currentItems = vue.computed(()=>manualPagination.value ? flatItems.value : paginatedItems.value);
            useToggleScope(()=>!manualPagination.value, ()=>{
                const { paginatedItems: items } = usePaginatedItems({
                    items: flatItems,
                    startIndex: startIndex,
                    stopIndex: stopIndex,
                    itemsPerPage: itemsPerPage
                });
                vue.watchEffect(()=>{
                    paginatedItems.value = items.value;
                });
            });
            const currentItemsWithoutGroups = vue.computed(()=>extractRows(currentItems.value));
            const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect } = provideSelection(props, {
                allItems: items,
                currentPage: currentItemsWithoutGroups
            });
            const { isExpanded: isExpanded, toggleExpand: toggleExpand } = provideExpanded(props);
            useOptions({
                page: page,
                itemsPerPage: itemsPerPage,
                sortBy: sortBy,
                groupBy: groupBy,
                search: search
            });
            const slotProps = vue.computed(()=>({
                    page: page.value,
                    itemsPerPage: itemsPerPage.value,
                    sortBy: sortBy.value,
                    pageCount: pageCount.value,
                    toggleSort: toggleSort,
                    prevPage: prevPage,
                    nextPage: nextPage,
                    setPage: setPage,
                    setItemsPerPage: setItemsPerPage,
                    isSelected: isSelected,
                    select: select,
                    selectAll: selectAll,
                    toggleSelect: toggleSelect,
                    isExpanded: isExpanded,
                    toggleExpand: toggleExpand,
                    isGroupOpen: isGroupOpen,
                    toggleGroup: toggleGroup,
                    items: currentItemsWithoutGroups.value,
                    itemsCount: filteredItems.value.length,
                    groupedItems: currentItems.value
                }));
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-data-iterator',
                        {
                            'v-data-iterator--loading': props.loading
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, {
                    default: ()=>[
                            slots.header?.(slotProps.value),
                            vue.createVNode(MaybeTransition, {
                                "transition": props.transition
                            }, {
                                default: ()=>[
                                        props.loading ? vue.createVNode(LoaderSlot, {
                                            "key": "loader",
                                            "name": "v-data-iterator",
                                            "active": true
                                        }, {
                                            default: (slotProps)=>slots.loader?.(slotProps)
                                        }) : vue.createElementVNode("div", {
                                            "key": "items"
                                        }, [
                                            !currentItems.value.length ? slots['no-data']?.() : slots.default?.(slotProps.value)
                                        ])
                                    ]
                            }),
                            slots.footer?.(slotProps.value)
                        ]
                }));
            return {};
        }
    });
    // Utilities
    // Types
    function useRefs() {
        const refs = vue.ref([]);
        vue.onBeforeUpdate(()=>refs.value = []);
        function updateRef(e, i) {
            refs.value[i] = e;
        }
        return {
            refs: refs,
            updateRef: updateRef
        };
    }
    // Types
    const makeVPaginationProps = propsFactory({
        activeColor: String,
        start: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        modelValue: {
            type: Number,
            default: (props)=>props.start
        },
        disabled: Boolean,
        length: {
            type: [
                Number,
                String
            ],
            default: 1,
            validator: (val)=>val % 1 === 0
        },
        totalVisible: [
            Number,
            String
        ],
        firstIcon: {
            type: IconValue,
            default: '$first'
        },
        prevIcon: {
            type: IconValue,
            default: '$prev'
        },
        nextIcon: {
            type: IconValue,
            default: '$next'
        },
        lastIcon: {
            type: IconValue,
            default: '$last'
        },
        ariaLabel: {
            type: String,
            default: '$vuetify.pagination.ariaLabel.root'
        },
        pageAriaLabel: {
            type: String,
            default: '$vuetify.pagination.ariaLabel.page'
        },
        currentPageAriaLabel: {
            type: String,
            default: '$vuetify.pagination.ariaLabel.currentPage'
        },
        firstAriaLabel: {
            type: String,
            default: '$vuetify.pagination.ariaLabel.first'
        },
        previousAriaLabel: {
            type: String,
            default: '$vuetify.pagination.ariaLabel.previous'
        },
        nextAriaLabel: {
            type: String,
            default: '$vuetify.pagination.ariaLabel.next'
        },
        lastAriaLabel: {
            type: String,
            default: '$vuetify.pagination.ariaLabel.last'
        },
        ellipsis: {
            type: String,
            default: '...'
        },
        showFirstLastPage: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeElevationProps(),
        ...makeRoundedProps(),
        ...makeSizeProps(),
        ...makeTagProps({
            tag: 'nav'
        }),
        ...makeThemeProps(),
        ...makeVariantProps({
            variant: 'text'
        })
    }, 'VPagination');
    const VPagination = genericComponent()({
        name: 'VPagination',
        props: makeVPaginationProps(),
        emits: {
            'update:modelValue': (value)=>true,
            first: (value)=>true,
            prev: (value)=>true,
            next: (value)=>true,
            last: (value)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            const page = useProxiedModel(props, 'modelValue');
            const { t: t, n: n } = useLocale();
            const { isRtl: isRtl } = useRtl();
            const { themeClasses: themeClasses } = provideTheme(props);
            const { width: width } = useDisplay();
            const maxButtons = vue.shallowRef(-1);
            provideDefaults(undefined, {
                scoped: true
            });
            const { resizeRef: resizeRef } = useResizeObserver((entries)=>{
                if (!entries.length) return;
                const { target: target, contentRect: contentRect } = entries[0];
                const firstItem = target.querySelector('.v-pagination__list > *');
                if (!firstItem) return;
                const totalWidth = contentRect.width;
                const itemWidth = firstItem.offsetWidth + parseFloat(getComputedStyle(firstItem).marginRight) * 2;
                maxButtons.value = getMax(totalWidth, itemWidth);
            });
            const length = vue.computed(()=>parseInt(props.length, 10));
            const start = vue.computed(()=>parseInt(props.start, 10));
            const totalVisible = vue.computed(()=>{
                if (props.totalVisible != null) return parseInt(props.totalVisible, 10);
                else if (maxButtons.value >= 0) return maxButtons.value;
                return getMax(width.value, 58);
            });
            function getMax(totalWidth, itemWidth) {
                const minButtons = props.showFirstLastPage ? 5 : 3;
                return Math.max(0, Math.floor(// Round to two decimal places to avoid floating point errors
                Number(((totalWidth - itemWidth * minButtons) / itemWidth).toFixed(2))));
            }
            const range = vue.computed(()=>{
                if (length.value <= 0 || isNaN(length.value) || length.value > Number.MAX_SAFE_INTEGER) return [];
                if (props.totalVisible == null && length.value < 3) return createRange(length.value, start.value);
                if (totalVisible.value <= 0) return [];
                else if (totalVisible.value === 1) return [
                    page.value
                ];
                if (length.value <= totalVisible.value) return createRange(length.value, start.value);
                const even = totalVisible.value % 2 === 0;
                const middle = even ? totalVisible.value / 2 : Math.floor(totalVisible.value / 2);
                const left = even ? middle : middle + 1;
                const right = length.value - middle;
                if (left - page.value >= 0) return [
                    ...createRange(Math.max(1, totalVisible.value - 1), start.value),
                    props.ellipsis,
                    length.value
                ];
                else if (page.value - right >= (even ? 1 : 0)) {
                    const rangeLength = totalVisible.value - 1;
                    const rangeStart = length.value - rangeLength + start.value;
                    return [
                        start.value,
                        props.ellipsis,
                        ...createRange(rangeLength, rangeStart)
                    ];
                } else {
                    const rangeLength = Math.max(1, totalVisible.value - 2);
                    const rangeStart = rangeLength === 1 ? page.value : page.value - Math.ceil(rangeLength / 2) + start.value;
                    return [
                        start.value,
                        props.ellipsis,
                        ...createRange(rangeLength, rangeStart),
                        props.ellipsis,
                        length.value
                    ];
                }
            });
            // TODO: 'first' | 'prev' | 'next' | 'last' does not work here?
            function setValue(e, value, event) {
                e.preventDefault();
                page.value = value;
                event && emit(event, value);
            }
            const { refs: refs, updateRef: updateRef } = useRefs();
            provideDefaults({
                VPaginationBtn: {
                    color: vue.toRef(()=>props.color),
                    border: vue.toRef(()=>props.border),
                    density: vue.toRef(()=>props.density),
                    size: vue.toRef(()=>props.size),
                    variant: vue.toRef(()=>props.variant),
                    rounded: vue.toRef(()=>props.rounded),
                    elevation: vue.toRef(()=>props.elevation)
                }
            });
            const items = vue.computed(()=>{
                return range.value.map((item, index)=>{
                    const ref = (e)=>updateRef(e, index);
                    if (typeof item === 'string') return {
                        isActive: false,
                        key: `ellipsis-${index}`,
                        page: item,
                        props: {
                            ref: ref,
                            ellipsis: true,
                            icon: true,
                            disabled: true
                        }
                    };
                    else {
                        const isActive = item === page.value;
                        return {
                            isActive: isActive,
                            key: item,
                            page: n(item),
                            props: {
                                ref: ref,
                                ellipsis: false,
                                icon: true,
                                disabled: !!props.disabled || Number(props.length) < 2,
                                color: isActive ? props.activeColor : props.color,
                                'aria-current': isActive,
                                'aria-label': t(isActive ? props.currentPageAriaLabel : props.pageAriaLabel, item),
                                onClick: (e)=>setValue(e, item)
                            }
                        };
                    }
                });
            });
            const controls = vue.computed(()=>{
                const prevDisabled = !!props.disabled || page.value <= start.value;
                const nextDisabled = !!props.disabled || page.value >= start.value + length.value - 1;
                return {
                    first: [
                        true,
                        'only-first'
                    ].includes(props.showFirstLastPage) ? {
                        icon: isRtl.value ? props.lastIcon : props.firstIcon,
                        onClick: (e)=>setValue(e, start.value, 'first'),
                        disabled: prevDisabled,
                        'aria-label': t(props.firstAriaLabel),
                        'aria-disabled': prevDisabled
                    } : undefined,
                    prev: {
                        icon: isRtl.value ? props.nextIcon : props.prevIcon,
                        onClick: (e)=>setValue(e, page.value - 1, 'prev'),
                        disabled: prevDisabled,
                        'aria-label': t(props.previousAriaLabel),
                        'aria-disabled': prevDisabled
                    },
                    next: {
                        icon: isRtl.value ? props.prevIcon : props.nextIcon,
                        onClick: (e)=>setValue(e, page.value + 1, 'next'),
                        disabled: nextDisabled,
                        'aria-label': t(props.nextAriaLabel),
                        'aria-disabled': nextDisabled
                    },
                    last: props.showFirstLastPage === true ? {
                        icon: isRtl.value ? props.firstIcon : props.lastIcon,
                        onClick: (e)=>setValue(e, start.value + length.value - 1, 'last'),
                        disabled: nextDisabled,
                        'aria-label': t(props.lastAriaLabel),
                        'aria-disabled': nextDisabled
                    } : undefined
                };
            });
            function updateFocus() {
                const currentIndex = page.value - start.value;
                refs.value[currentIndex]?.$el.focus();
            }
            function onKeydown(e) {
                if (e.key === keyValues.left && !props.disabled && page.value > Number(props.start)) {
                    page.value = page.value - 1;
                    vue.nextTick(updateFocus);
                } else if (e.key === keyValues.right && !props.disabled && page.value < start.value + length.value - 1) {
                    page.value = page.value + 1;
                    vue.nextTick(updateFocus);
                }
            }
            useRender(()=>vue.createVNode(props.tag, {
                    "ref": resizeRef,
                    "class": vue.normalizeClass([
                        'v-pagination',
                        themeClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "role": "navigation",
                    "aria-label": t(props.ariaLabel),
                    "onKeydown": onKeydown,
                    "data-testid": "v-pagination-root"
                }, {
                    default: ()=>[
                            vue.createElementVNode("ul", {
                                "class": "v-pagination__list"
                            }, [
                                [
                                    true,
                                    'only-first'
                                ].includes(props.showFirstLastPage) && vue.createElementVNode("li", {
                                    "key": "first",
                                    "class": "v-pagination__first",
                                    "data-testid": "v-pagination-first"
                                }, [
                                    slots.first ? slots.first(controls.value.first) : vue.createVNode(VBtn, vue.mergeProps({
                                        "_as": "VPaginationBtn"
                                    }, controls.value.first), null)
                                ]),
                                vue.createElementVNode("li", {
                                    "key": "prev",
                                    "class": "v-pagination__prev",
                                    "data-testid": "v-pagination-prev"
                                }, [
                                    slots.prev ? slots.prev(controls.value.prev) : vue.createVNode(VBtn, vue.mergeProps({
                                        "_as": "VPaginationBtn"
                                    }, controls.value.prev), null)
                                ]),
                                items.value.map((item, index)=>vue.createElementVNode("li", {
                                        "key": item.key,
                                        "class": vue.normalizeClass([
                                            'v-pagination__item',
                                            {
                                                'v-pagination__item--is-active': item.isActive
                                            }
                                        ]),
                                        "data-testid": "v-pagination-item"
                                    }, [
                                        slots.item ? slots.item(item) : vue.createVNode(VBtn, vue.mergeProps({
                                            "_as": "VPaginationBtn"
                                        }, item.props), {
                                            default: ()=>[
                                                    item.page
                                                ]
                                        })
                                    ])),
                                vue.createElementVNode("li", {
                                    "key": "next",
                                    "class": "v-pagination__next",
                                    "data-testid": "v-pagination-next"
                                }, [
                                    slots.next ? slots.next(controls.value.next) : vue.createVNode(VBtn, vue.mergeProps({
                                        "_as": "VPaginationBtn"
                                    }, controls.value.next), null)
                                ]),
                                props.showFirstLastPage === true && vue.createElementVNode("li", {
                                    "key": "last",
                                    "class": "v-pagination__last",
                                    "data-testid": "v-pagination-last"
                                }, [
                                    slots.last ? slots.last(controls.value.last) : vue.createVNode(VBtn, vue.mergeProps({
                                        "_as": "VPaginationBtn"
                                    }, controls.value.last), null)
                                ])
                            ])
                        ]
                }));
            return {};
        }
    });
    const makeVDataTableFooterProps = propsFactory({
        color: String,
        prevIcon: {
            type: IconValue,
            default: '$prev'
        },
        nextIcon: {
            type: IconValue,
            default: '$next'
        },
        firstIcon: {
            type: IconValue,
            default: '$first'
        },
        lastIcon: {
            type: IconValue,
            default: '$last'
        },
        itemsPerPageText: {
            type: String,
            default: '$vuetify.dataFooter.itemsPerPageText'
        },
        pageText: {
            type: String,
            default: '$vuetify.dataFooter.pageText'
        },
        firstPageLabel: {
            type: String,
            default: '$vuetify.dataFooter.firstPage'
        },
        prevPageLabel: {
            type: String,
            default: '$vuetify.dataFooter.prevPage'
        },
        nextPageLabel: {
            type: String,
            default: '$vuetify.dataFooter.nextPage'
        },
        lastPageLabel: {
            type: String,
            default: '$vuetify.dataFooter.lastPage'
        },
        itemsPerPageOptions: {
            type: Array,
            default: ()=>[
                    {
                        value: 10,
                        title: '10'
                    },
                    {
                        value: 25,
                        title: '25'
                    },
                    {
                        value: 50,
                        title: '50'
                    },
                    {
                        value: 100,
                        title: '100'
                    },
                    {
                        value: -1,
                        title: '$vuetify.dataFooter.itemsPerPageAll'
                    }
                ]
        },
        showCurrentPage: Boolean,
        ...pick(makeVPaginationProps({
            showFirstLastPage: true
        }), [
            'showFirstLastPage'
        ])
    }, 'VDataTableFooter');
    const VDataTableFooter = genericComponent()({
        name: 'VDataTableFooter',
        props: makeVDataTableFooterProps(),
        setup (props, { slots: slots }) {
            const { t: t } = useLocale();
            const { page: page, pageCount: pageCount, startIndex: startIndex, stopIndex: stopIndex, itemsLength: itemsLength, itemsPerPage: itemsPerPage, setItemsPerPage: setItemsPerPage } = usePagination();
            const itemsPerPageOptions = vue.computed(()=>props.itemsPerPageOptions.map((option)=>{
                    if (typeof option === 'number') return {
                        value: option,
                        title: option === -1 ? t('$vuetify.dataFooter.itemsPerPageAll') : String(option)
                    };
                    return {
                        ...option,
                        title: !isNaN(Number(option.title)) ? option.title : t(option.title)
                    };
                }));
            useRender(()=>{
                const paginationProps = VPagination.filterProps(props);
                return vue.createElementVNode("div", {
                    "class": "v-data-table-footer"
                }, [
                    slots.prepend?.(),
                    vue.createElementVNode("div", {
                        "class": "v-data-table-footer__items-per-page"
                    }, [
                        vue.createElementVNode("span", null, [
                            t(props.itemsPerPageText)
                        ]),
                        vue.createVNode(VSelect, {
                            "items": itemsPerPageOptions.value,
                            "itemColor": props.color,
                            "modelValue": itemsPerPage.value,
                            "onUpdate:modelValue": (v)=>setItemsPerPage(Number(v)),
                            "density": "compact",
                            "variant": "outlined",
                            "aria-label": t(props.itemsPerPageText),
                            "hideDetails": true
                        }, null)
                    ]),
                    vue.createElementVNode("div", {
                        "class": "v-data-table-footer__info"
                    }, [
                        vue.createElementVNode("div", null, [
                            t(props.pageText, !itemsLength.value ? 0 : startIndex.value + 1, stopIndex.value, itemsLength.value)
                        ])
                    ]),
                    vue.createElementVNode("div", {
                        "class": "v-data-table-footer__pagination"
                    }, [
                        vue.createVNode(VPagination, vue.mergeProps({
                            "modelValue": page.value,
                            "onUpdate:modelValue": ($event)=>page.value = $event,
                            "density": "comfortable",
                            "firstAriaLabel": props.firstPageLabel,
                            "lastAriaLabel": props.lastPageLabel,
                            "length": pageCount.value,
                            "nextAriaLabel": props.nextPageLabel,
                            "previousAriaLabel": props.prevPageLabel,
                            "rounded": true,
                            "showFirstLastPage": true,
                            "totalVisible": props.showCurrentPage ? 1 : 0,
                            "variant": "plain"
                        }, omit(paginationProps, [
                            'color'
                        ])), null)
                    ])
                ]);
            });
            return {};
        }
    });
    // Types
    const VDataTableColumn = defineFunctionalComponent({
        align: {
            type: String,
            default: 'start'
        },
        fixed: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        fixedOffset: [
            Number,
            String
        ],
        fixedEndOffset: [
            Number,
            String
        ],
        height: [
            Number,
            String
        ],
        lastFixed: Boolean,
        firstFixedEnd: Boolean,
        noPadding: Boolean,
        indent: [
            Number,
            String
        ],
        empty: Boolean,
        tag: String,
        width: [
            Number,
            String
        ],
        maxWidth: [
            Number,
            String
        ],
        nowrap: Boolean
    }, (props, { slots: slots })=>{
        const Tag = props.tag ?? 'td';
        const fixedSide = typeof props.fixed === 'string' ? props.fixed : props.fixed ? 'start' : 'none';
        return vue.createVNode(Tag, {
            "class": vue.normalizeClass([
                'v-data-table__td',
                {
                    'v-data-table-column--fixed': fixedSide === 'start',
                    'v-data-table-column--fixed-end': fixedSide === 'end',
                    'v-data-table-column--last-fixed': props.lastFixed,
                    'v-data-table-column--first-fixed-end': props.firstFixedEnd,
                    'v-data-table-column--no-padding': props.noPadding,
                    'v-data-table-column--nowrap': props.nowrap,
                    'v-data-table-column--empty': props.empty
                },
                `v-data-table-column--align-${props.align}`
            ]),
            "style": {
                height: convertToUnit(props.height),
                width: convertToUnit(props.width),
                maxWidth: convertToUnit(props.maxWidth),
                left: fixedSide === 'start' ? convertToUnit(props.fixedOffset || null) : undefined,
                right: fixedSide === 'end' ? convertToUnit(props.fixedEndOffset || null) : undefined,
                paddingInlineStart: props.indent ? convertToUnit(props.indent) : undefined
            }
        }, {
            default: ()=>[
                    slots.default?.()
                ]
        });
    });
    // Utilities
    // Types
    const makeDataTableHeaderProps = propsFactory({
        headers: Array
    }, 'DataTable-header');
    const VDataTableHeadersSymbol = Symbol.for('vuetify:data-table-headers');
    const defaultHeader = {
        title: '',
        sortable: false
    };
    const defaultActionHeader = {
        ...defaultHeader,
        width: 48
    };
    function priorityQueue(arr = []) {
        const queue = arr.map((element)=>({
                element: element,
                priority: 0
            }));
        return {
            enqueue: (element, priority)=>{
                let added = false;
                for(let i = 0; i < queue.length; i++){
                    const item = queue[i];
                    if (item.priority > priority) {
                        queue.splice(i, 0, {
                            element: element,
                            priority: priority
                        });
                        added = true;
                        break;
                    }
                }
                if (!added) queue.push({
                    element: element,
                    priority: priority
                });
            },
            size: ()=>queue.length,
            count: ()=>{
                let count = 0;
                if (!queue.length) return 0;
                const whole = Math.floor(queue[0].priority);
                for(let i = 0; i < queue.length; i++)if (Math.floor(queue[i].priority) === whole) count += 1;
                return count;
            },
            dequeue: ()=>{
                return queue.shift();
            }
        };
    }
    function extractLeaves(item, columns = []) {
        if (!item.children) columns.push(item);
        else for (const child of item.children)extractLeaves(child, columns);
        return columns;
    }
    function extractKeys(headers, keys = new Set()) {
        for (const item of headers){
            if (item.key) keys.add(item.key);
            if (item.children) extractKeys(item.children, keys);
        }
        return keys;
    }
    function getDefaultItem(item) {
        if (!item.key) return undefined;
        if (item.key === 'data-table-group') return defaultHeader;
        if ([
            'data-table-expand',
            'data-table-select'
        ].includes(item.key)) return defaultActionHeader;
        return undefined;
    }
    function getDepth(item, depth = 0) {
        if (!item.children) return depth;
        return Math.max(depth, ...item.children.map((child)=>getDepth(child, depth + 1)));
    }
    function parseFixedColumns(items) {
        let seenFixed = false;
        function setFixed(item, side, parentFixedSide = 'none') {
            if (!item) return;
            if (parentFixedSide !== 'none') item.fixed = parentFixedSide;
            // normalize to simplify logic below
            if (item.fixed === true) item.fixed = 'start';
            if (item.fixed === side) {
                if (item.children) {
                    if (side === 'start') for(let i = item.children.length - 1; i >= 0; i--)setFixed(item.children[i], side, side);
                    else for(let i = 0; i < item.children.length; i++)setFixed(item.children[i], side, side);
                } else {
                    if (!seenFixed && side === 'start') item.lastFixed = true;
                    else if (!seenFixed && side === 'end') item.firstFixedEnd = true;
                    else if (isNaN(Number(item.width))) consoleError(`Multiple fixed columns should have a static width (key: ${item.key})`);
                    else item.minWidth = Math.max(Number(item.width) || 0, Number(item.minWidth) || 0);
                    seenFixed = true;
                }
            } else if (item.children) {
                if (side === 'start') for(let i = item.children.length - 1; i >= 0; i--)setFixed(item.children[i], side);
                else for(let i = 0; i < item.children.length; i++)setFixed(item.children[i], side);
            } else seenFixed = false;
        }
        for(let i = items.length - 1; i >= 0; i--)setFixed(items[i], 'start');
        for(let i = 0; i < items.length; i++)setFixed(items[i], 'end');
        let fixedOffset = 0;
        for(let i = 0; i < items.length; i++)fixedOffset = setFixedOffset(items[i], fixedOffset);
        let fixedEndOffset = 0;
        for(let i = items.length - 1; i >= 0; i--)fixedEndOffset = setFixedEndOffset(items[i], fixedEndOffset);
    }
    function setFixedOffset(item, offset = 0) {
        if (!item) return offset;
        if (item.children) {
            item.fixedOffset = offset;
            for (const child of item.children)offset = setFixedOffset(child, offset);
        } else if (item.fixed && item.fixed !== 'end') {
            item.fixedOffset = offset;
            offset += parseFloat(item.width || '0') || 0;
        }
        return offset;
    }
    function setFixedEndOffset(item, offset = 0) {
        if (!item) return offset;
        if (item.children) {
            item.fixedEndOffset = offset;
            for (const child of item.children)offset = setFixedEndOffset(child, offset);
        } else if (item.fixed === 'end') {
            item.fixedEndOffset = offset;
            offset += parseFloat(item.width || '0') || 0;
        }
        return offset;
    }
    function parse(items, maxDepth) {
        const headers = [];
        let currentDepth = 0;
        const queue = priorityQueue(items);
        while(queue.size() > 0){
            let rowSize = queue.count();
            const row = [];
            let fraction = 1;
            while(rowSize > 0){
                const { element: item, priority: priority } = queue.dequeue();
                const diff = maxDepth - currentDepth - getDepth(item);
                row.push({
                    ...item,
                    rowspan: diff ?? 1,
                    colspan: item.children ? extractLeaves(item).length : 1
                });
                if (item.children) for (const child of item.children){
                    // This internally sorts items that are on the same priority "row"
                    const sort = priority % 1 + fraction / Math.pow(10, currentDepth + 2);
                    queue.enqueue(child, currentDepth + diff + sort);
                }
                fraction += 1;
                rowSize -= 1;
            }
            currentDepth += 1;
            headers.push(row);
        }
        const columns = items.map((item)=>extractLeaves(item)).flat();
        return {
            columns: columns,
            headers: headers
        };
    }
    function convertToInternalHeaders(items) {
        const internalHeaders = [];
        for (const item of items){
            const defaultItem = {
                ...getDefaultItem(item),
                ...item
            };
            const key = defaultItem.key ?? (typeof defaultItem.value === 'string' ? defaultItem.value : null);
            const value = defaultItem.value ?? key ?? null;
            const internalItem = {
                ...defaultItem,
                key: key,
                value: value,
                sortable: defaultItem.sortable ?? (defaultItem.key != null || !!defaultItem.sort),
                children: defaultItem.children ? convertToInternalHeaders(defaultItem.children) : undefined
            };
            internalHeaders.push(internalItem);
        }
        return internalHeaders;
    }
    function createHeaders(props, options) {
        const headers = vue.ref([]);
        const columns = vue.ref([]);
        const sortFunctions = vue.ref({});
        const sortRawFunctions = vue.ref({});
        const filterFunctions = vue.ref({});
        vue.watchEffect(()=>{
            const _headers = props.headers || Object.keys(props.items[0] ?? {}).map((key)=>({
                    key: key,
                    title: vue.capitalize(key)
                }));
            const items = _headers.slice();
            const keys = extractKeys(items);
            if (options?.groupBy?.value.length && !keys.has('data-table-group')) items.unshift({
                key: 'data-table-group',
                title: 'Group'
            });
            if (options?.showSelect?.value && !keys.has('data-table-select')) items.unshift({
                key: 'data-table-select'
            });
            if (options?.showExpand?.value && !keys.has('data-table-expand')) items.push({
                key: 'data-table-expand'
            });
            const internalHeaders = convertToInternalHeaders(items);
            parseFixedColumns(internalHeaders);
            const maxDepth = Math.max(...internalHeaders.map((item)=>getDepth(item))) + 1;
            const parsed = parse(internalHeaders, maxDepth);
            headers.value = parsed.headers;
            columns.value = parsed.columns;
            const flatHeaders = parsed.headers.flat(1);
            sortFunctions.value = {};
            sortRawFunctions.value = {};
            filterFunctions.value = {};
            for (const header of flatHeaders){
                if (!header.key) continue;
                if (header.sortable) {
                    if (header.sort) sortFunctions.value[header.key] = header.sort;
                    if (header.sortRaw) sortRawFunctions.value[header.key] = header.sortRaw;
                }
                if (header.filter) filterFunctions.value[header.key] = header.filter;
            }
        });
        const data = {
            headers: headers,
            columns: columns,
            sortFunctions: sortFunctions,
            sortRawFunctions: sortRawFunctions,
            filterFunctions: filterFunctions
        };
        vue.provide(VDataTableHeadersSymbol, data);
        return data;
    }
    function useHeaders() {
        const data = vue.inject(VDataTableHeadersSymbol);
        if (!data) throw new Error('Missing headers!');
        return data;
    }
    // Utilities
    // Types
    function useLoadingConfig(loading, fallbackColor) {
        const active = vue.computed(()=>{
            const v = loading();
            return v != null && v !== false && v !== 'false';
        });
        const side = vue.computed(()=>{
            const v = loading();
            if (typeof v === 'object' && v !== null && v.side) return v.side;
            return 'start';
        });
        const color = vue.computed(()=>{
            const v = loading();
            if (typeof v === 'object' && v !== null && v.color) return v.color;
            if (typeof v === 'string' && v !== 'true') return v;
            return fallbackColor();
        });
        return {
            active: active,
            side: side,
            color: color
        };
    }
    // Types
    const makeVDataTableHeadersProps = propsFactory({
        color: String,
        disableSort: Boolean,
        fixedHeader: Boolean,
        multiSort: Boolean,
        initialSortOrder: String,
        sortIcon: {
            type: IconValue
        },
        sortAscIcon: {
            type: IconValue,
            default: '$sortAsc'
        },
        sortDescIcon: {
            type: IconValue,
            default: '$sortDesc'
        },
        headerProps: {
            type: Object
        },
        selectAllLabel: {
            type: String,
            default: '$vuetify.dataTable.ariaLabel.selectAll'
        },
        /** @deprecated */ sticky: Boolean,
        ...makeDensityProps(),
        ...makeDisplayProps(),
        ...makeLoaderProps()
    }, 'VDataTableHeaders');
    const VDataTableHeaders = genericComponent()({
        name: 'VDataTableHeaders',
        props: makeVDataTableHeadersProps(),
        setup (props, { slots: slots }) {
            const { t: t } = useLocale();
            const { toggleSort: toggleSort, sortBy: sortBy, isSorted: isSorted } = useSort();
            const { someSelected: someSelected, allSelected: allSelected, selectAll: selectAll, showSelectAll: showSelectAll } = useSelection();
            const { columns: columns, headers: headers } = useHeaders();
            const { loaderClasses: loaderClasses } = useLoader(props);
            function getFixedStyles(column, y) {
                if (!(props.sticky || props.fixedHeader) && !column.fixed) return undefined;
                const fixedSide = typeof column.fixed === 'string' ? column.fixed : column.fixed ? 'start' : 'none';
                return {
                    position: 'sticky',
                    left: fixedSide === 'start' ? convertToUnit(column.fixedOffset) : undefined,
                    right: fixedSide === 'end' ? convertToUnit(column.fixedEndOffset) : undefined,
                    top: props.sticky || props.fixedHeader ? `calc(var(--v-table-header-height) * ${y})` : undefined
                };
            }
            function handleEnterKeyPress(event, column) {
                if (event.key === 'Enter' && !props.disableSort) toggleSort(column, event);
            }
            function getSortIcon(column) {
                const item = sortBy.value.find((item)=>item.key === column.key);
                switch(item?.order){
                    case 'asc':
                        return props.sortAscIcon;
                    case 'desc':
                        return props.sortDescIcon;
                    default:
                        return props.sortIcon || (props.initialSortOrder === 'asc' ? props.sortAscIcon : props.sortDescIcon);
                }
            }
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { displayClasses: displayClasses, mobile: mobile } = useDisplay(props);
            const loadingConfig = useLoadingConfig(()=>props.loading, ()=>props.color);
            const slotProps = vue.computed(()=>({
                    headers: headers.value,
                    columns: columns.value,
                    toggleSort: toggleSort,
                    isSorted: isSorted,
                    sortBy: sortBy.value,
                    someSelected: someSelected.value,
                    allSelected: allSelected.value,
                    selectAll: selectAll,
                    getSortIcon: getSortIcon
                }));
            const headerCellClasses = vue.computed(()=>[
                    'v-data-table__th',
                    {
                        'v-data-table__th--sticky': props.sticky || props.fixedHeader
                    },
                    displayClasses.value,
                    loaderClasses.value
                ]);
            const VDataTableHeaderCell = ({ column: column, x: x, y: y })=>{
                const noPadding = column.key === 'data-table-select' || column.key === 'data-table-expand';
                const isEmpty = column.key === 'data-table-group' && column.width === 0 && !column.title;
                const headerProps = vue.mergeProps(props.headerProps ?? {}, column.headerProps ?? {});
                const isSortable = column.sortable && !props.disableSort;
                const sortItem = isSortable ? sortBy.value.find((item)=>item.key === column.key) : undefined;
                const ariaSort = sortItem?.order === 'asc' ? 'ascending' : sortItem?.order === 'desc' ? 'descending' : undefined;
                return vue.createVNode(VDataTableColumn, vue.mergeProps({
                    "tag": "th",
                    "aria-sort": ariaSort,
                    "align": column.align,
                    "class": [
                        {
                            'v-data-table__th--sortable': isSortable,
                            'v-data-table__th--sorted': isSorted(column),
                            'v-data-table__th--fixed': column.fixed
                        },
                        ...headerCellClasses.value
                    ],
                    "style": {
                        width: convertToUnit(column.width),
                        minWidth: convertToUnit(column.minWidth),
                        maxWidth: convertToUnit(column.maxWidth),
                        ...getFixedStyles(column, y)
                    },
                    "colspan": column.colspan,
                    "rowspan": column.rowspan,
                    "fixed": column.fixed,
                    "nowrap": column.nowrap,
                    "lastFixed": column.lastFixed,
                    "firstFixedEnd": column.firstFixedEnd,
                    "noPadding": noPadding,
                    "empty": isEmpty,
                    "tabindex": isSortable ? 0 : undefined,
                    "onClick": isSortable ? (event)=>toggleSort(column, event) : undefined,
                    "onKeydown": isSortable ? (event)=>handleEnterKeyPress(event, column) : undefined
                }, headerProps), {
                    default: ()=>{
                        const columnSlotName = `header.${column.key}`;
                        const columnSlotProps = {
                            column: column,
                            selectAll: selectAll,
                            isSorted: isSorted,
                            toggleSort: toggleSort,
                            sortBy: sortBy.value,
                            someSelected: someSelected.value,
                            allSelected: allSelected.value,
                            getSortIcon: getSortIcon
                        };
                        if (slots[columnSlotName]) return slots[columnSlotName](columnSlotProps);
                        if (isEmpty) return '';
                        if (column.key === 'data-table-select') return slots['header.data-table-select']?.(columnSlotProps) ?? (showSelectAll.value && vue.createVNode(VCheckboxBtn, {
                            "aria-label": t(props.selectAllLabel),
                            "color": props.color,
                            "density": props.density,
                            "modelValue": allSelected.value,
                            "indeterminate": someSelected.value && !allSelected.value,
                            "onUpdate:modelValue": selectAll
                        }, null));
                        return vue.createElementVNode("div", {
                            "class": "v-data-table-header__content"
                        }, [
                            vue.createElementVNode("span", null, [
                                column.title
                            ]),
                            column.sortable && !props.disableSort && vue.createVNode(VIcon, {
                                "key": "icon",
                                "class": "v-data-table-header__sort-icon",
                                "icon": getSortIcon(column)
                            }, null),
                            props.multiSort && isSorted(column) && vue.createElementVNode("div", {
                                "key": "badge",
                                "class": vue.normalizeClass([
                                    'v-data-table-header__sort-badge',
                                    ...backgroundColorClasses.value
                                ]),
                                "style": vue.normalizeStyle(backgroundColorStyles.value)
                            }, [
                                sortBy.value.findIndex((x)=>x.key === column.key) + 1
                            ])
                        ]);
                    }
                });
            };
            const VDataTableMobileHeaderCell = ()=>{
                const sortableColumns = vue.computed(()=>{
                    return columns.value.filter((column)=>column?.sortable && !props.disableSort);
                });
                const showSelectColumn = columns.value.find((column)=>column.key === 'data-table-select');
                const sortingChips = vue.computed({
                    get: ()=>sortableColumns.value.filter(({ key: key })=>sortBy.value.some((v)=>v.key === key)),
                    set: (val)=>{
                        const sortedColumns = wrapInArray(val);
                        const activeSortKeys = sortBy.value.map((v)=>v.key);
                        const newColumnsToSort = sortedColumns.filter(({ key: key })=>!activeSortKeys.includes(key));
                        newColumnsToSort.forEach((column)=>toggleSort(column));
                        // sortBy is proxied model, needs nextTick after toggleSort
                        vue.nextTick(()=>sortBy.value = sortBy.value.filter(({ key: key })=>sortedColumns.some((c)=>c.key === key)));
                    }
                });
                function renderSortSelect() {
                    return vue.createVNode(VSelect, {
                        "modelValue": sortingChips.value,
                        "onUpdate:modelValue": ($event)=>sortingChips.value = $event,
                        "chips": true,
                        "color": props.color,
                        "class": "v-data-table__td-sort-select",
                        "clearable": true,
                        "density": "default",
                        "items": sortableColumns.value,
                        "label": t('$vuetify.dataTable.sortBy'),
                        "multiple": props.multiSort,
                        "variant": "underlined",
                        "returnObject": true,
                        "onClick:clear": ()=>sortBy.value = []
                    }, {
                        chip: ({ internalItem: internalItem })=>vue.createVNode(VChip, {
                                "onClick": internalItem.raw.sortable ? ()=>toggleSort(internalItem.raw, undefined, true) : undefined,
                                "onMousedown": (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }, {
                                default: ()=>[
                                        internalItem.title,
                                        vue.createVNode(VIcon, {
                                            "class": vue.normalizeClass([
                                                'v-data-table__td-sort-icon',
                                                isSorted(internalItem.raw) && 'v-data-table__td-sort-icon-active'
                                            ]),
                                            "icon": getSortIcon(internalItem.raw),
                                            "size": "small"
                                        }, null)
                                    ]
                            })
                    });
                }
                function renderSelectAll() {
                    return vue.createVNode(VCheckboxBtn, {
                        "aria-label": t(props.selectAllLabel),
                        "class": "v-data-table-header__select-all",
                        "color": props.color,
                        "density": "compact",
                        "modelValue": allSelected.value,
                        "indeterminate": someSelected.value && !allSelected.value,
                        "onUpdate:modelValue": ()=>selectAll(!allSelected.value)
                    }, null);
                }
                return vue.createVNode(VDataTableColumn, vue.mergeProps({
                    "tag": "th",
                    "class": [
                        ...headerCellClasses.value
                    ],
                    "colspan": headers.value.length + 1
                }, props.headerProps), {
                    default: ()=>[
                            vue.createElementVNode("div", {
                                "class": "v-data-table-header__content"
                            }, [
                                slots['mobile.header']?.(slotProps.value) ?? vue.createElementVNode(vue.Fragment, null, [
                                    sortableColumns.value.length > 0 && renderSortSelect(),
                                    showSelectColumn && renderSelectAll()
                                ])
                            ])
                        ]
                });
            };
            const showMobileHeader = vue.computed(()=>{
                if (slots['mobile.header']) return true;
                const hasSortableColumns = columns.value.some((column)=>column?.sortable && !props.disableSort);
                const hasSelectionControl = columns.value.some((column)=>column.key === 'data-table-select');
                return hasSortableColumns || hasSelectionControl;
            });
            useRender(()=>{
                return mobile.value ? vue.createElementVNode(vue.Fragment, null, [
                    showMobileHeader.value && vue.createElementVNode("tr", null, [
                        vue.createVNode(VDataTableMobileHeaderCell, null, null)
                    ])
                ]) : vue.createElementVNode(vue.Fragment, null, [
                    slots.headers ? slots.headers(slotProps.value) : headers.value.map((row, y)=>vue.createElementVNode("tr", null, [
                            row.map((column, x)=>vue.createVNode(VDataTableHeaderCell, {
                                    "key": column.key ?? x,
                                    "column": column,
                                    "x": x,
                                    "y": y
                                }, null))
                        ])),
                    loadingConfig.active.value && [
                        'start',
                        'both'
                    ].includes(loadingConfig.side.value) && vue.createElementVNode("tr", {
                        "class": "v-data-table-progress"
                    }, [
                        vue.createElementVNode("th", {
                            "colspan": columns.value.length
                        }, [
                            vue.createVNode(LoaderSlot, {
                                "name": "v-data-table-progress",
                                "absolute": true,
                                "active": true,
                                "color": loadingConfig.color.value,
                                "indeterminate": true
                            }, {
                                default: slots.loader
                            })
                        ])
                    ])
                ]);
            });
        }
    });
    // Types
    const makeVDataTableGroupHeaderRowProps = propsFactory({
        item: {
            type: Object,
            required: true
        },
        groupCollapseIcon: {
            type: IconValue,
            default: '$tableGroupCollapse'
        },
        groupExpandIcon: {
            type: IconValue,
            default: '$tableGroupExpand'
        },
        selectGroupLabel: {
            type: String,
            default: '$vuetify.dataTable.ariaLabel.selectGroup'
        },
        ...makeDensityProps()
    }, 'VDataTableGroupHeaderRow');
    const VDataTableGroupHeaderRow = genericComponent()({
        name: 'VDataTableGroupHeaderRow',
        props: makeVDataTableGroupHeaderRowProps(),
        setup (props, { slots: slots }) {
            const { t: t } = useLocale();
            const { isGroupOpen: isGroupOpen, toggleGroup: toggleGroup, extractRows: extractRows } = useGroupBy();
            const { isSelected: isSelected, isSomeSelected: isSomeSelected, select: select } = useSelection();
            const { columns: columns } = useHeaders();
            const rows = vue.computed(()=>{
                return extractRows([
                    props.item
                ]);
            });
            const colspan = vue.toRef(()=>columns.value.length - (columns.value.some((c)=>c.key === 'data-table-select') ? 1 : 0));
            return ()=>vue.createElementVNode("tr", {
                    "class": "v-data-table-group-header-row",
                    "style": {
                        '--v-data-table-group-header-row-depth': props.item.depth
                    }
                }, [
                    columns.value.map((column)=>{
                        if (column.key === 'data-table-group') {
                            const icon = isGroupOpen(props.item) ? props.groupCollapseIcon : props.groupExpandIcon;
                            const onClick = ()=>toggleGroup(props.item);
                            return slots['data-table-group']?.({
                                item: props.item,
                                count: rows.value.length,
                                props: {
                                    icon: icon,
                                    onClick: onClick
                                }
                            }) ?? vue.createVNode(VDataTableColumn, {
                                "class": "v-data-table-group-header-row__column",
                                "colspan": colspan.value
                            }, {
                                default: ()=>[
                                        vue.createVNode(VBtn, {
                                            "size": "small",
                                            "variant": "text",
                                            "icon": icon,
                                            "onClick": onClick
                                        }, null),
                                        vue.createElementVNode("span", null, [
                                            props.item.value
                                        ]),
                                        vue.createElementVNode("span", null, [
                                            vue.createTextVNode("("),
                                            rows.value.length,
                                            vue.createTextVNode(")")
                                        ])
                                    ]
                            });
                        } else if (column.key === 'data-table-select') {
                            const selectableRows = rows.value.filter((x)=>x.selectable);
                            const modelValue = selectableRows.length > 0 && isSelected(selectableRows);
                            const indeterminate = isSomeSelected(selectableRows) && !modelValue;
                            const selectGroup = (v)=>select(selectableRows, v);
                            return slots['data-table-select']?.({
                                props: {
                                    modelValue: modelValue,
                                    indeterminate: indeterminate,
                                    'onUpdate:modelValue': selectGroup
                                }
                            }) ?? vue.createVNode(VDataTableColumn, {
                                "class": "v-data-table__td--select-row",
                                "noPadding": true
                            }, {
                                default: ()=>[
                                        vue.createVNode(VCheckboxBtn, {
                                            "aria-label": t(props.selectGroupLabel),
                                            "density": props.density,
                                            "disabled": selectableRows.length === 0,
                                            "modelValue": modelValue,
                                            "indeterminate": indeterminate,
                                            "onUpdate:modelValue": selectGroup
                                        }, null)
                                    ]
                            });
                        }
                        return '';
                    })
                ]);
        }
    });
    // Types
    const makeVDataTableRowProps = propsFactory({
        color: String,
        index: Number,
        item: Object,
        cellProps: [
            Object,
            Function
        ],
        collapseIcon: {
            type: IconValue,
            default: '$collapse'
        },
        expandIcon: {
            type: IconValue,
            default: '$expand'
        },
        selectRowLabel: {
            type: String,
            default: '$vuetify.dataTable.ariaLabel.selectRow'
        },
        getMatches: Function,
        onClick: EventProp(),
        onContextmenu: EventProp(),
        onDblclick: EventProp(),
        ...makeDensityProps(),
        ...makeDisplayProps()
    }, 'VDataTableRow');
    const VDataTableRow = genericComponent()({
        name: 'VDataTableRow',
        props: makeVDataTableRowProps(),
        setup (props, { slots: slots }) {
            const { t: t } = useLocale();
            const { displayClasses: displayClasses, mobile: mobile } = useDisplay(props, 'v-data-table__tr');
            const { isSelected: isSelected, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected, selectAll: selectAll } = useSelection();
            const { isExpanded: isExpanded, toggleExpand: toggleExpand } = useExpanded();
            const { toggleSort: toggleSort, sortBy: sortBy, isSorted: isSorted } = useSort();
            const { columns: columns } = useHeaders();
            useRender(()=>vue.createElementVNode("tr", {
                    "class": vue.normalizeClass([
                        'v-data-table__tr',
                        {
                            'v-data-table__tr--clickable': !!(props.onClick || props.onContextmenu || props.onDblclick)
                        },
                        displayClasses.value
                    ]),
                    "onClick": props.onClick,
                    "onContextmenu": props.onContextmenu,
                    "onDblclick": props.onDblclick
                }, [
                    props.item && columns.value.map((column, i)=>{
                        const item = props.item;
                        const slotName = `item.${column.key}`;
                        const headerSlotName = `header.${column.key}`;
                        const slotProps = {
                            index: props.index,
                            item: item.raw,
                            internalItem: item,
                            value: getObjectValueByPath(item.columns, column.key),
                            column: column,
                            isSelected: isSelected,
                            toggleSelect: toggleSelect,
                            isExpanded: isExpanded,
                            toggleExpand: toggleExpand
                        };
                        const columnSlotProps = {
                            column: column,
                            selectAll: selectAll,
                            isSorted: isSorted,
                            toggleSort: toggleSort,
                            sortBy: sortBy.value,
                            someSelected: someSelected.value,
                            allSelected: allSelected.value,
                            getSortIcon: ()=>''
                        };
                        const cellProps = typeof props.cellProps === 'function' ? props.cellProps({
                            index: slotProps.index,
                            item: slotProps.item,
                            internalItem: slotProps.internalItem,
                            value: slotProps.value,
                            column: column
                        }) : props.cellProps;
                        const columnCellProps = typeof column.cellProps === 'function' ? column.cellProps({
                            index: slotProps.index,
                            item: slotProps.item,
                            internalItem: slotProps.internalItem,
                            value: slotProps.value
                        }) : column.cellProps;
                        const noPadding = column.key === 'data-table-select' || column.key === 'data-table-expand';
                        const isEmpty = column.key === 'data-table-group' && column.width === 0 && !column.title;
                        return vue.createVNode(VDataTableColumn, vue.mergeProps({
                            "key": column.key ?? i,
                            "align": column.align,
                            "indent": column.indent,
                            "class": {
                                'v-data-table__td--expanded-row': column.key === 'data-table-expand',
                                'v-data-table__td--select-row': column.key === 'data-table-select'
                            },
                            "fixed": column.fixed,
                            "fixedOffset": column.fixedOffset,
                            "fixedEndOffset": column.fixedEndOffset,
                            "lastFixed": column.lastFixed,
                            "firstFixedEnd": column.firstFixedEnd,
                            "maxWidth": !mobile.value ? column.maxWidth : undefined,
                            "noPadding": noPadding,
                            "empty": isEmpty,
                            "nowrap": column.nowrap,
                            "width": !mobile.value ? column.width : undefined
                        }, cellProps, columnCellProps), {
                            default: ()=>{
                                if (column.key === 'data-table-select') return slots['item.data-table-select']?.({
                                    ...slotProps,
                                    props: {
                                        color: props.color,
                                        disabled: !item.selectable,
                                        modelValue: isSelected([
                                            item
                                        ]),
                                        onClick: vue.withModifiers(()=>toggleSelect(item), [
                                            'stop'
                                        ])
                                    }
                                }) ?? vue.createVNode(VCheckboxBtn, {
                                    "aria-label": t(props.selectRowLabel),
                                    "color": props.color,
                                    "disabled": !item.selectable,
                                    "density": props.density,
                                    "modelValue": isSelected([
                                        item
                                    ]),
                                    "onClick": vue.withModifiers((event)=>toggleSelect(item, props.index, event), [
                                        'stop'
                                    ])
                                }, null);
                                if (column.key === 'data-table-expand') return slots['item.data-table-expand']?.({
                                    ...slotProps,
                                    props: {
                                        icon: isExpanded(item) ? props.collapseIcon : props.expandIcon,
                                        size: 'small',
                                        variant: 'text',
                                        onClick: vue.withModifiers(()=>toggleExpand(item), [
                                            'stop'
                                        ])
                                    }
                                }) ?? vue.createVNode(VBtn, {
                                    "icon": isExpanded(item) ? props.collapseIcon : props.expandIcon,
                                    "size": "small",
                                    "variant": "text",
                                    "onClick": vue.withModifiers(()=>toggleExpand(item), [
                                        'stop'
                                    ])
                                }, null);
                                if (slots[slotName] && !mobile.value) return slots[slotName](slotProps);
                                const text = vue.toDisplayString(slotProps.value);
                                const matches = props.getMatches?.(item)?.[column.key];
                                const displayValue = matches?.length ? vue.createVNode(VHighlight, {
                                    "text": text,
                                    "matches": matches
                                }, null) : text;
                                return !mobile.value ? displayValue : vue.createElementVNode(vue.Fragment, null, [
                                    vue.createElementVNode("div", {
                                        "class": "v-data-table__td-title"
                                    }, [
                                        slots[headerSlotName]?.(columnSlotProps) ?? column.title
                                    ]),
                                    vue.createElementVNode("div", {
                                        "class": "v-data-table__td-value"
                                    }, [
                                        slots[slotName]?.(slotProps) ?? displayValue
                                    ])
                                ]);
                            }
                        });
                    })
                ]));
        }
    });
    // Types
    const makeVDataTableRowsProps = propsFactory({
        color: String,
        loading: [
            Boolean,
            String,
            Object
        ],
        loadingText: {
            type: String,
            default: '$vuetify.dataIterator.loadingText'
        },
        hideNoData: Boolean,
        items: {
            type: Array,
            default: ()=>[]
        },
        noDataText: {
            type: String,
            default: '$vuetify.noDataText'
        },
        rowProps: [
            Object,
            Function
        ],
        cellProps: [
            Object,
            Function
        ],
        expandTransition: {
            type: null,
            default: ()=>({
                    component: VExpandTransition
                }),
            validator: (val)=>val !== true
        },
        ...pick(makeVDataTableRowProps(), [
            'collapseIcon',
            'expandIcon',
            'density',
            'getMatches'
        ]),
        ...pick(makeVDataTableGroupHeaderRowProps(), [
            'groupCollapseIcon',
            'groupExpandIcon',
            'density'
        ]),
        ...makeDisplayProps()
    }, 'VDataTableRows');
    const VDataTableRows = genericComponent()({
        name: 'VDataTableRows',
        inheritAttrs: false,
        props: makeVDataTableRowsProps(),
        setup (props, { attrs: attrs, slots: slots }) {
            const { columns: columns } = useHeaders();
            const { expandOnClick: expandOnClick, toggleExpand: toggleExpand, isExpanded: isExpanded } = useExpanded();
            const { isSelected: isSelected, toggleSelect: toggleSelect } = useSelection();
            const { toggleGroup: toggleGroup, isGroupOpen: isGroupOpen } = useGroupBy();
            const { t: t } = useLocale();
            const { mobile: mobile } = useDisplay(props);
            useRender(()=>{
                const groupHeaderRowProps = pick(props, [
                    'groupCollapseIcon',
                    'groupExpandIcon',
                    'density'
                ]);
                if (props.loading && (!props.items.length || slots.loading)) return vue.createElementVNode("tr", {
                    "class": "v-data-table-rows-loading",
                    "key": "loading"
                }, [
                    vue.createElementVNode("td", {
                        "colspan": columns.value.length
                    }, [
                        slots.loading?.() ?? t(props.loadingText)
                    ])
                ]);
                if (!props.loading && !props.items.length && !props.hideNoData) return vue.createElementVNode("tr", {
                    "class": "v-data-table-rows-no-data",
                    "key": "no-data"
                }, [
                    vue.createElementVNode("td", {
                        "colspan": columns.value.length
                    }, [
                        slots['no-data']?.() ?? t(props.noDataText)
                    ])
                ]);
                return vue.createElementVNode(vue.Fragment, null, [
                    props.items.map((item, index)=>{
                        if (item.type === 'group') {
                            const slotProps = {
                                index: index,
                                item: item,
                                columns: columns.value,
                                isExpanded: isExpanded,
                                toggleExpand: toggleExpand,
                                isSelected: isSelected,
                                toggleSelect: toggleSelect,
                                toggleGroup: toggleGroup,
                                isGroupOpen: isGroupOpen
                            };
                            return slots['group-header'] ? slots['group-header'](slotProps) : vue.createVNode(VDataTableGroupHeaderRow, vue.mergeProps({
                                "key": `group-header_${item.id}`,
                                "item": item
                            }, getPrefixedEventHandlers(attrs, ':groupHeader', ()=>slotProps), groupHeaderRowProps), slots);
                        }
                        if (item.type === 'group-summary') {
                            const slotProps = {
                                index: index,
                                item: item,
                                columns: columns.value,
                                toggleGroup: toggleGroup
                            };
                            return slots['group-summary']?.(slotProps) ?? '';
                        }
                        const slotProps = {
                            index: item.virtualIndex ?? index,
                            item: item.raw,
                            internalItem: item,
                            columns: columns.value,
                            isExpanded: isExpanded,
                            toggleExpand: toggleExpand,
                            isSelected: isSelected,
                            toggleSelect: toggleSelect
                        };
                        const itemSlotProps = {
                            ...slotProps,
                            props: vue.mergeProps({
                                key: `item_${item.key ?? item.index}`,
                                onClick: expandOnClick.value ? ()=>{
                                    toggleExpand(item);
                                } : undefined,
                                index: index,
                                item: item,
                                color: props.color,
                                cellProps: props.cellProps,
                                collapseIcon: props.collapseIcon,
                                expandIcon: props.expandIcon,
                                density: props.density,
                                mobile: mobile.value,
                                getMatches: props.getMatches
                            }, getPrefixedEventHandlers(attrs, ':row', ()=>slotProps), typeof props.rowProps === 'function' ? props.rowProps({
                                item: slotProps.item,
                                index: slotProps.index,
                                internalItem: slotProps.internalItem
                            }) : props.rowProps)
                        };
                        return vue.createElementVNode(vue.Fragment, {
                            "key": itemSlotProps.props.key
                        }, [
                            slots.item ? slots.item(itemSlotProps) : vue.createVNode(VDataTableRow, itemSlotProps.props, slots),
                            slots['expanded-row'] ? isExpanded(item) && slots['expanded-row'](slotProps) : slots.expanded && vue.createElementVNode("tr", {
                                "class": "v-data-table__tr--expanded"
                            }, [
                                vue.createElementVNode("td", {
                                    "colspan": columns.value.length
                                }, [
                                    props.expandTransition ? vue.createVNode(MaybeTransition, {
                                        "transition": props.expandTransition
                                    }, {
                                        default: ()=>[
                                                isExpanded(item) ? vue.createElementVNode("div", null, [
                                                    slots.expanded(slotProps)
                                                ]) : null
                                            ]
                                    }) // bypass <Transition> to avoid flash when expand-strategy=single
                                     : isExpanded(item) && vue.createElementVNode("div", null, [
                                        slots.expanded(slotProps)
                                    ])
                                ])
                            ])
                        ]);
                    })
                ]);
            });
            return {};
        }
    });
    // Types
    const makeVTableProps = propsFactory({
        gridlines: {
            type: [
                Boolean,
                String
            ],
            default: 'horizontal',
            validator: (v)=>typeof v === 'boolean' || [
                    'horizontal',
                    'vertical',
                    'all'
                ].includes(v)
        },
        fixedHeader: Boolean,
        fixedFooter: Boolean,
        height: [
            Number,
            String
        ],
        hover: Boolean,
        striped: {
            type: String,
            default: null,
            validator: (v)=>[
                    'even',
                    'odd'
                ].includes(v)
        },
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VTable');
    const VTable = genericComponent()({
        name: 'VTable',
        inheritAttrs: false,
        props: makeVTableProps(),
        setup (props, { attrs: attrs, slots: slots, emit: emit }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const gridlinesVariant = vue.computed(()=>{
                if (props.gridlines === false) return 'none';
                if (props.gridlines === true) return 'all';
                return props.gridlines;
            });
            useRender(()=>{
                const [tableAttrs, rootAttrs] = pickWithRest(attrs, [
                    /^aria-label/
                ]);
                return vue.createVNode(props.tag, vue.mergeProps(rootAttrs, {
                    "class": [
                        'v-table',
                        `v-table--gridlines-${gridlinesVariant.value}`,
                        {
                            'v-table--fixed-height': !!props.height,
                            'v-table--fixed-header': props.fixedHeader,
                            'v-table--fixed-footer': props.fixedFooter,
                            'v-table--has-top': !!slots.top,
                            'v-table--has-bottom': !!slots.bottom,
                            'v-table--hover': props.hover,
                            'v-table--striped-even': props.striped === 'even',
                            'v-table--striped-odd': props.striped === 'odd'
                        },
                        themeClasses.value,
                        densityClasses.value,
                        props.class
                    ],
                    "style": props.style
                }), {
                    default: ()=>[
                            slots.top?.(),
                            slots.default ? vue.createElementVNode("div", {
                                "class": "v-table__wrapper",
                                "style": {
                                    height: convertToUnit(props.height)
                                }
                            }, [
                                vue.createElementVNode("table", vue.normalizeProps(vue.guardReactiveProps(tableAttrs)), [
                                    slots.caption?.(),
                                    slots.default()
                                ])
                            ]) : slots.wrapper?.(),
                            slots.bottom?.()
                        ]
                });
            });
            return {};
        }
    });
    // Utilities
    // Types
    // Composables
    const makeDataTableItemsProps = propsFactory({
        items: {
            type: Array,
            default: ()=>[]
        },
        itemValue: {
            type: [
                String,
                Array,
                Function
            ],
            default: 'id'
        },
        itemSelectable: {
            type: [
                String,
                Array,
                Function
            ],
            default: null
        },
        rowProps: [
            Object,
            Function
        ],
        cellProps: [
            Object,
            Function
        ],
        returnObject: Boolean
    }, 'DataTable-items');
    function transformItem(props, item, index, columns) {
        const value = props.returnObject ? item : getPropertyFromItem(item, props.itemValue);
        const selectable = getPropertyFromItem(item, props.itemSelectable, true);
        const itemColumns = columns.reduce((obj, column)=>{
            if (column.key != null) obj[column.key] = getPropertyFromItem(item, column.value);
            return obj;
        }, {});
        return {
            type: 'item',
            key: props.returnObject ? getPropertyFromItem(item, props.itemValue) : value,
            index: index,
            value: value,
            selectable: selectable,
            columns: itemColumns,
            raw: item
        };
    }
    function transformItems(props, items, columns) {
        return items.map((item, index)=>transformItem(props, item, index, columns));
    }
    function useDataTableItems(props, columns) {
        const items = vue.computed(()=>transformItems(props, props.items, columns.value));
        return {
            items: items
        };
    }
    // Types
    const makeDataTableProps = propsFactory({
        ...makeVDataTableRowsProps(),
        hideDefaultBody: Boolean,
        hideDefaultFooter: Boolean,
        hideDefaultHeader: Boolean,
        width: [
            String,
            Number
        ],
        search: String,
        ...makeDataTableExpandProps(),
        ...makeDataTableGroupProps(),
        ...makeDataTableHeaderProps(),
        ...makeDataTableItemsProps(),
        ...makeDataTableSelectProps(),
        ...makeDataTableSortProps(),
        ...omit(makeVDataTableHeadersProps(), [
            'multiSort',
            'initialSortOrder'
        ]),
        ...makeVTableProps()
    }, 'DataTable');
    const makeVDataTableProps = propsFactory({
        ...makeDataTablePaginateProps(),
        ...makeDataTableProps(),
        ...makeFilterProps(),
        ...makeVDataTableFooterProps()
    }, 'VDataTable');
    const VDataTable = genericComponent()({
        name: 'VDataTable',
        props: makeVDataTableProps(),
        emits: {
            'update:modelValue': (value)=>true,
            'update:page': (value)=>true,
            'update:itemsPerPage': (value)=>true,
            'update:sortBy': (value)=>true,
            'update:options': (value)=>true,
            'update:groupBy': (value)=>true,
            'update:expanded': (value)=>true,
            'update:opened': (value)=>true,
            'update:currentItems': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const { groupBy: groupBy, opened: opened, openAll: openAll, groupKey: groupKey } = createGroupBy(props);
            const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = createSort(props);
            const { page: page, itemsPerPage: itemsPerPage } = createPagination(props);
            const { disableSort: disableSort } = vue.toRefs(props);
            const { columns: columns, headers: headers, sortFunctions: sortFunctions, sortRawFunctions: sortRawFunctions, filterFunctions: filterFunctions } = createHeaders(props, {
                groupBy: groupBy,
                showSelect: vue.toRef(()=>props.showSelect),
                showExpand: vue.toRef(()=>props.showExpand)
            });
            const { items: items } = useDataTableItems(props, columns);
            const search = vue.toRef(()=>props.search);
            const { filteredItems: filteredItems, getMatches: getMatches } = useFilter(props, items, search, {
                transform: (item)=>item.columns,
                customKeyFilter: filterFunctions
            });
            const { toggleSort: toggleSort } = provideSort({
                initialSortOrder: initialSortOrder,
                sortBy: sortBy,
                multiSort: multiSort,
                mustSort: mustSort,
                page: page
            });
            const { sortByWithGroups: sortByWithGroups, opened: openedGroups, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = provideGroupBy({
                groupBy: groupBy,
                sortBy: sortBy,
                disableSort: disableSort,
                opened: opened
            });
            const { sortedItems: sortedItems } = useSortedItems(props, filteredItems, sortByWithGroups, {
                transform: (item)=>({
                        ...item.raw,
                        ...item.columns
                    }),
                sortFunctions: sortFunctions,
                sortRawFunctions: sortRawFunctions
            });
            useOpenAllGroups(openedGroups, openAll, sortedItems, groupBy, groupKey);
            const pageBy = vue.computed(()=>{
                if (props.pageBy === 'auto') return props.groupBy.length ? 'group' : 'item';
                return props.pageBy;
            });
            const { pageCount: pageCount, setItemsPerPage: setItemsPerPage, prevPage: prevPage, nextPage: nextPage, setPage: setPage, paginatedItems: paginatedItems } = usePaginatedGroups({
                pageBy: pageBy,
                sortedItems: sortedItems,
                paginate: (items)=>{
                    const itemsLength = vue.computed(()=>vue.toValue(items).length);
                    const { startIndex: startIndex, stopIndex: stopIndex, pageCount: pageCount, setItemsPerPage: setItemsPerPage, prevPage: prevPage, nextPage: nextPage, setPage: setPage } = providePagination({
                        page: page,
                        itemsPerPage: itemsPerPage,
                        itemsLength: itemsLength
                    });
                    const { paginatedItems: paginatedItems } = usePaginatedItems({
                        items: items,
                        startIndex: startIndex,
                        stopIndex: stopIndex,
                        itemsPerPage: itemsPerPage
                    });
                    return {
                        paginatedItems: paginatedItems,
                        pageCount: pageCount,
                        setItemsPerPage: setItemsPerPage,
                        prevPage: prevPage,
                        nextPage: nextPage,
                        setPage: setPage
                    };
                },
                group: (items)=>useGroupedItems(items, groupBy, openedGroups, ()=>!!slots['group-summary'], isGroupOpen, groupKey)
            });
            const paginatedItemsWithoutGroups = vue.computed(()=>extractRows(paginatedItems.value));
            const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = provideSelection(props, {
                allItems: items,
                currentPage: paginatedItemsWithoutGroups
            });
            const { isExpanded: isExpanded, toggleExpand: toggleExpand } = provideExpanded(props);
            const loadingConfig = useLoadingConfig(()=>props.loading, ()=>props.color);
            useOptions({
                page: page,
                itemsPerPage: itemsPerPage,
                sortBy: sortBy,
                groupBy: groupBy,
                search: search
            });
            provideDefaults({
                VDataTableRows: {
                    hideNoData: vue.toRef(()=>props.hideNoData),
                    noDataText: vue.toRef(()=>props.noDataText),
                    loading: vue.toRef(()=>props.loading),
                    loadingText: vue.toRef(()=>props.loadingText)
                }
            });
            const slotProps = vue.computed(()=>({
                    page: page.value,
                    itemsPerPage: itemsPerPage.value,
                    itemsLength: filteredItems.value.length,
                    sortBy: sortBy.value,
                    pageCount: pageCount.value,
                    toggleSort: toggleSort,
                    setItemsPerPage: setItemsPerPage,
                    prevPage: prevPage,
                    nextPage: nextPage,
                    setPage: setPage,
                    someSelected: someSelected.value,
                    allSelected: allSelected.value,
                    isSelected: isSelected,
                    select: select,
                    selectAll: selectAll,
                    toggleSelect: toggleSelect,
                    isExpanded: isExpanded,
                    toggleExpand: toggleExpand,
                    isGroupOpen: isGroupOpen,
                    toggleGroup: toggleGroup,
                    items: paginatedItemsWithoutGroups.value.map((item)=>item.raw),
                    internalItems: paginatedItemsWithoutGroups.value,
                    groupedItems: paginatedItems.value,
                    columns: columns.value,
                    headers: headers.value
                }));
            useRender(()=>{
                const dataTableFooterProps = VDataTableFooter.filterProps(props);
                const dataTableHeadersProps = VDataTableHeaders.filterProps(omit(props, [
                    'multiSort'
                ]));
                const dataTableRowsProps = VDataTableRows.filterProps(props);
                const tableProps = VTable.filterProps(props);
                return vue.createVNode(VTable, vue.mergeProps({
                    "class": [
                        'v-data-table',
                        {
                            'v-data-table--show-select': props.showSelect,
                            'v-data-table--loading': props.loading
                        },
                        props.class
                    ],
                    "style": props.style
                }, tableProps, {
                    "fixedHeader": props.fixedHeader || props.sticky
                }), {
                    top: ()=>slots.top?.(slotProps.value),
                    caption: slots.caption,
                    default: ()=>slots.default ? slots.default(slotProps.value) : vue.createElementVNode(vue.Fragment, null, [
                            slots.colgroup?.(slotProps.value),
                            !props.hideDefaultHeader && vue.createElementVNode("thead", {
                                "key": "thead"
                            }, [
                                vue.createVNode(VDataTableHeaders, vue.mergeProps(dataTableHeadersProps, {
                                    "multiSort": !!props.multiSort
                                }), slots)
                            ]),
                            slots.thead?.(slotProps.value),
                            !props.hideDefaultBody && vue.createElementVNode("tbody", null, [
                                slots['body.prepend']?.(slotProps.value),
                                slots.body ? slots.body(slotProps.value) : vue.createVNode(VDataTableRows, vue.mergeProps(attrs, dataTableRowsProps, {
                                    "items": paginatedItems.value,
                                    "getMatches": getMatches
                                }), slots),
                                slots['body.append']?.(slotProps.value),
                                loadingConfig.active.value && [
                                    'end',
                                    'both'
                                ].includes(loadingConfig.side.value) && vue.createElementVNode("tr", {
                                    "class": "v-data-table-progress v-data-table-progress--bottom"
                                }, [
                                    vue.createElementVNode("th", {
                                        "colspan": columns.value.length
                                    }, [
                                        vue.createVNode(LoaderSlot, {
                                            "name": "v-data-table-progress",
                                            "absolute": true,
                                            "active": true,
                                            "color": loadingConfig.color.value,
                                            "indeterminate": true
                                        }, {
                                            default: slots.loader
                                        })
                                    ])
                                ])
                            ]),
                            slots.tbody?.(slotProps.value),
                            slots.tfoot?.(slotProps.value)
                        ]),
                    bottom: ()=>slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VDivider, null, null),
                            vue.createVNode(VDataTableFooter, dataTableFooterProps, {
                                prepend: slots['footer.prepend']
                            })
                        ])
                });
            });
            return {};
        }
    });
    // Types
    const makeVDataTableVirtualProps = propsFactory({
        ...omit(makeDataTableProps(), [
            'hideDefaultFooter'
        ]),
        ...makeDataTableGroupProps(),
        ...makeVirtualProps(),
        ...makeFilterProps()
    }, 'VDataTableVirtual');
    function elementNodes(nodes) {
        return (nodes ?? []).flatMap((node)=>Array.isArray(node) ? elementNodes(node) : !vue.isVNode(node) ? [] : node.type === vue.Fragment ? elementNodes(node.children) : typeof node.type === 'symbol' ? [] : [
                node
            ]);
    }
    const VDataTableVirtual = genericComponent()({
        name: 'VDataTableVirtual',
        props: makeVDataTableVirtualProps(),
        emits: {
            'update:modelValue': (value)=>true,
            'update:sortBy': (value)=>true,
            'update:options': (value)=>true,
            'update:groupBy': (value)=>true,
            'update:expanded': (value)=>true,
            'update:opened': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const { groupBy: groupBy, opened: opened, openAll: openAll, groupKey: groupKey } = createGroupBy(props);
            const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = createSort(props);
            const { disableSort: disableSort } = vue.toRefs(props);
            const { columns: columns, headers: headers, filterFunctions: filterFunctions, sortFunctions: sortFunctions, sortRawFunctions: sortRawFunctions } = createHeaders(props, {
                groupBy: groupBy,
                showSelect: vue.toRef(()=>props.showSelect),
                showExpand: vue.toRef(()=>props.showExpand)
            });
            const { items: items } = useDataTableItems(props, columns);
            const search = vue.toRef(()=>props.search);
            const { filteredItems: filteredItems, getMatches: getMatches } = useFilter(props, items, search, {
                transform: (item)=>item.columns,
                customKeyFilter: filterFunctions
            });
            const { toggleSort: toggleSort } = provideSort({
                initialSortOrder: initialSortOrder,
                sortBy: sortBy,
                multiSort: multiSort,
                mustSort: mustSort
            });
            const { sortByWithGroups: sortByWithGroups, opened: openedGroups, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = provideGroupBy({
                groupBy: groupBy,
                sortBy: sortBy,
                disableSort: disableSort,
                opened: opened
            });
            const { sortedItems: sortedItems } = useSortedItems(props, filteredItems, sortByWithGroups, {
                transform: (item)=>({
                        ...item.raw,
                        ...item.columns
                    }),
                sortFunctions: sortFunctions,
                sortRawFunctions: sortRawFunctions
            });
            useOpenAllGroups(openedGroups, openAll, sortedItems, groupBy, groupKey);
            const { flatItems: flatItems } = useGroupedItems(sortedItems, groupBy, openedGroups, ()=>!!slots['group-summary'], isGroupOpen, groupKey);
            const allItems = vue.computed(()=>extractRows(flatItems.value));
            const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = provideSelection(props, {
                allItems: allItems,
                currentPage: allItems
            });
            const { expanded: expanded, isExpanded: isExpanded, toggleExpand: toggleExpand } = provideExpanded(props);
            const { containerRef: containerRef, markerRef: markerRef, paddingTop: paddingTop, paddingBottom: paddingBottom, computedItems: computedItems, handleItemResize: handleItemResize, handleScroll: handleScroll, handleScrollend: handleScrollend, calculateVisibleItems: calculateVisibleItems, scrollToIndex: scrollToIndex } = useVirtual(props, flatItems);
            const displayItems = vue.computed(()=>computedItems.value.map((item)=>({
                        ...item.raw,
                        virtualIndex: item.index
                    })));
            // one virtual size per index = item row + optional expanded rows
            const rowHeights = new Map();
            const expandedHeights = new Map();
            function updateSize(index) {
                const expanded = expandedHeights.get(index)?.reduce((sum, height)=>sum + (height || 0), 0) ?? 0;
                handleItemResize(index, (rowHeights.get(index) ?? 0) + expanded);
            }
            function setRowHeight(index, height) {
                rowHeights.set(index, height);
                updateSize(index);
            }
            function setExpandedHeight(index, row, height) {
                const heights = expandedHeights.get(index) ?? [];
                heights[row] = height;
                expandedHeights.set(index, heights);
                updateSize(index);
            }
            function trimExpandedHeights(index, count) {
                const heights = expandedHeights.get(index);
                if (!heights || heights.length <= count) return;
                heights.length = count;
                updateSize(index);
            }
            vue.watch(expanded, ()=>{
                if (!slots['expanded-row']) return;
                for (const index of [
                    ...expandedHeights.keys()
                ]){
                    const item = flatItems.value[index];
                    if (item?.type === 'item' && isExpanded(item)) continue;
                    expandedHeights.delete(index);
                    updateSize(index);
                }
            });
            vue.watch(flatItems, ()=>{
                rowHeights.clear();
                expandedHeights.clear();
            });
            useOptions({
                sortBy: sortBy,
                page: vue.shallowRef(1),
                itemsPerPage: vue.shallowRef(-1),
                groupBy: groupBy,
                search: search
            });
            provideDefaults({
                VDataTableRows: {
                    hideNoData: vue.toRef(()=>props.hideNoData),
                    noDataText: vue.toRef(()=>props.noDataText),
                    loading: vue.toRef(()=>props.loading),
                    loadingText: vue.toRef(()=>props.loadingText)
                }
            });
            const slotProps = vue.computed(()=>({
                    itemsLength: allItems.value.length,
                    sortBy: sortBy.value,
                    toggleSort: toggleSort,
                    someSelected: someSelected.value,
                    allSelected: allSelected.value,
                    isSelected: isSelected,
                    select: select,
                    selectAll: selectAll,
                    toggleSelect: toggleSelect,
                    isExpanded: isExpanded,
                    toggleExpand: toggleExpand,
                    isGroupOpen: isGroupOpen,
                    toggleGroup: toggleGroup,
                    items: allItems.value.map((item)=>item.raw),
                    internalItems: allItems.value,
                    groupedItems: flatItems.value,
                    columns: columns.value,
                    headers: headers.value
                }));
            useRender(()=>{
                const dataTableHeadersProps = VDataTableHeaders.filterProps(omit(props, [
                    'multiSort'
                ]));
                const dataTableRowsProps = VDataTableRows.filterProps(props);
                const tableProps = VTable.filterProps(props);
                const [tableAttrs] = pickWithRest(attrs, [
                    /^aria-label/
                ]);
                return vue.createVNode(VTable, vue.mergeProps({
                    "class": [
                        'v-data-table',
                        {
                            'v-data-table--loading': props.loading
                        },
                        props.class
                    ],
                    "style": props.style
                }, tableProps, {
                    "fixedHeader": props.fixedHeader || props.sticky
                }), {
                    top: ()=>slots.top?.(slotProps.value),
                    wrapper: ()=>vue.createElementVNode("div", {
                            "ref": containerRef,
                            "onScrollPassive": handleScroll,
                            "onScrollend": handleScrollend,
                            "class": "v-table__wrapper",
                            "style": {
                                height: convertToUnit(props.height)
                            }
                        }, [
                            vue.createElementVNode("table", vue.normalizeProps(vue.guardReactiveProps(tableAttrs)), [
                                slots.caption?.(),
                                slots.colgroup?.(slotProps.value),
                                !props.hideDefaultHeader && vue.createElementVNode("thead", {
                                    "key": "thead"
                                }, [
                                    vue.createVNode(VDataTableHeaders, vue.mergeProps(dataTableHeadersProps, {
                                        "multiSort": !!props.multiSort
                                    }), slots)
                                ]),
                                slots.thead?.(slotProps.value),
                                !props.hideDefaultBody && vue.createElementVNode("tbody", {
                                    "key": "tbody"
                                }, [
                                    vue.createElementVNode("tr", {
                                        "ref": markerRef,
                                        "style": {
                                            height: convertToUnit(paddingTop.value),
                                            border: 0
                                        }
                                    }, [
                                        vue.createElementVNode("td", {
                                            "colspan": columns.value.length,
                                            "style": {
                                                height: 0,
                                                border: 0
                                            }
                                        }, null)
                                    ]),
                                    slots['body.prepend']?.(slotProps.value),
                                    vue.createVNode(VDataTableRows, vue.mergeProps(attrs, dataTableRowsProps, {
                                        "items": displayItems.value,
                                        "getMatches": getMatches
                                    }), {
                                        ...omit(slots, [
                                            'expanded',
                                            'expanded-row'
                                        ]),
                                        item: (itemSlotProps)=>{
                                            const { props: rowProps, ...itemSlot } = itemSlotProps;
                                            const index = itemSlotProps.internalItem.virtualIndex ?? itemSlotProps.internalItem.index;
                                            const itemExpanded = isExpanded(itemSlotProps.internalItem);
                                            const expandedRows = props.showExpand && itemExpanded && slots['expanded-row'] ? elementNodes(slots['expanded-row'](itemSlot)) : [];
                                            // rows that stay never resize, so a shrunk slot reports nothing
                                            if (slots['expanded-row'] && (expandedHeights.get(index)?.length ?? 0) > expandedRows.length) vue.nextTick(()=>trimExpandedHeights(index, expandedRows.length));
                                            return vue.createElementVNode(vue.Fragment, null, [
                                                vue.createVNode(VVirtualScrollItem, {
                                                    "key": index,
                                                    "renderless": true,
                                                    "onUpdate:height": (height)=>setRowHeight(index, height)
                                                }, {
                                                    default: ({ itemRef: itemRef })=>slots.item?.({
                                                            ...itemSlotProps,
                                                            itemRef: itemRef
                                                        }) ?? vue.createVNode(VDataTableRow, vue.mergeProps(rowProps, {
                                                            "ref": itemRef,
                                                            "index": itemSlotProps.index,
                                                            "getMatches": getMatches
                                                        }), slots)
                                                }),
                                                props.showExpand && (slots['expanded-row'] ? expandedRows.map((node, row)=>vue.createVNode(VVirtualScrollItem, {
                                                        "key": `${index}-expanded-${row}`,
                                                        "renderless": true,
                                                        "onUpdate:height": (height)=>setExpandedHeight(index, row, height)
                                                    }, {
                                                        default: ({ itemRef: itemRef })=>vue.cloneVNode(node, {
                                                                ref: itemRef
                                                            }, true)
                                                    })) : slots.expanded && vue.createVNode(VVirtualScrollItem, {
                                                    "key": `${index}-expanded`,
                                                    "renderless": true,
                                                    "onUpdate:height": (height)=>setExpandedHeight(index, 0, height)
                                                }, {
                                                    default: ({ itemRef: itemRef })=>vue.createElementVNode("tr", {
                                                            "class": "v-data-table__tr--expanded",
                                                            "ref": itemRef
                                                        }, [
                                                            vue.createElementVNode("td", {
                                                                "colspan": columns.value.length
                                                            }, [
                                                                props.expandTransition ? vue.createVNode(MaybeTransition, {
                                                                    "transition": props.expandTransition
                                                                }, {
                                                                    default: ()=>[
                                                                            itemExpanded ? vue.createElementVNode("div", null, [
                                                                                slots.expanded(itemSlot)
                                                                            ]) : null
                                                                        ]
                                                                }) // bypass <Transition> to avoid flash when expand-strategy=single
                                                                 : itemExpanded && vue.createElementVNode("div", null, [
                                                                    slots.expanded(itemSlot)
                                                                ])
                                                            ])
                                                        ])
                                                }))
                                            ]);
                                        }
                                    }),
                                    slots['body.append']?.(slotProps.value),
                                    vue.createElementVNode("tr", {
                                        "style": {
                                            height: convertToUnit(paddingBottom.value),
                                            border: 0
                                        }
                                    }, [
                                        vue.createElementVNode("td", {
                                            "colspan": columns.value.length,
                                            "style": {
                                                height: 0,
                                                border: 0
                                            }
                                        }, null)
                                    ])
                                ]),
                                slots.tbody?.(slotProps.value),
                                slots.tfoot?.(slotProps.value)
                            ])
                        ]),
                    bottom: ()=>slots.bottom?.(slotProps.value)
                });
            });
            return {
                calculateVisibleItems: calculateVisibleItems,
                scrollToIndex: scrollToIndex
            };
        }
    });
    // Types
    const makeVDataTableServerProps = propsFactory({
        itemsLength: {
            type: [
                Number,
                String
            ],
            required: true
        },
        ...makeDataTablePaginateProps(),
        ...makeDataTableProps(),
        ...makeVDataTableFooterProps()
    }, 'VDataTableServer');
    const VDataTableServer = genericComponent()({
        name: 'VDataTableServer',
        props: makeVDataTableServerProps(),
        emits: {
            'update:modelValue': (value)=>true,
            'update:page': (page)=>true,
            'update:itemsPerPage': (page)=>true,
            'update:sortBy': (sortBy)=>true,
            'update:options': (options)=>true,
            'update:expanded': (options)=>true,
            'update:groupBy': (value)=>true,
            'update:opened': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const { groupBy: groupBy, opened: opened, openAll: openAll, groupKey: groupKey } = createGroupBy(props);
            const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = createSort(props);
            const { page: page, itemsPerPage: itemsPerPage } = createPagination(props);
            const { disableSort: disableSort } = vue.toRefs(props);
            const itemsLength = vue.computed(()=>parseInt(props.itemsLength, 10));
            const { columns: columns, headers: headers } = createHeaders(props, {
                groupBy: groupBy,
                showSelect: vue.toRef(()=>props.showSelect),
                showExpand: vue.toRef(()=>props.showExpand)
            });
            const { items: items } = useDataTableItems(props, columns);
            const { toggleSort: toggleSort } = provideSort({
                initialSortOrder: initialSortOrder,
                sortBy: sortBy,
                multiSort: multiSort,
                mustSort: mustSort,
                page: page
            });
            const { opened: openedGroups, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup, extractRows: extractRows } = provideGroupBy({
                groupBy: groupBy,
                sortBy: sortBy,
                disableSort: disableSort,
                opened: opened
            });
            useOpenAllGroups(openedGroups, openAll, items, groupBy, groupKey);
            const { pageCount: pageCount, setItemsPerPage: setItemsPerPage, prevPage: prevPage, nextPage: nextPage, setPage: setPage } = providePagination({
                page: page,
                itemsPerPage: itemsPerPage,
                itemsLength: itemsLength
            });
            const { flatItems: flatItems } = useGroupedItems(items, groupBy, openedGroups, ()=>!!slots['group-summary'], isGroupOpen, groupKey);
            const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = provideSelection(props, {
                allItems: items,
                currentPage: items
            });
            const { isExpanded: isExpanded, toggleExpand: toggleExpand } = provideExpanded(props);
            const itemsWithoutGroups = vue.computed(()=>extractRows(items.value));
            useOptions({
                page: page,
                itemsPerPage: itemsPerPage,
                sortBy: sortBy,
                groupBy: groupBy,
                search: vue.toRef(()=>props.search)
            });
            vue.provide('v-data-table', {
                toggleSort: toggleSort,
                sortBy: sortBy
            });
            provideDefaults({
                VDataTableRows: {
                    hideNoData: vue.toRef(()=>props.hideNoData),
                    noDataText: vue.toRef(()=>props.noDataText),
                    loading: vue.toRef(()=>props.loading),
                    loadingText: vue.toRef(()=>props.loadingText)
                }
            });
            const slotProps = vue.computed(()=>({
                    page: page.value,
                    itemsPerPage: itemsPerPage.value,
                    itemsLength: itemsLength.value,
                    sortBy: sortBy.value,
                    pageCount: pageCount.value,
                    toggleSort: toggleSort,
                    setItemsPerPage: setItemsPerPage,
                    prevPage: prevPage,
                    nextPage: nextPage,
                    setPage: setPage,
                    someSelected: someSelected.value,
                    allSelected: allSelected.value,
                    isSelected: isSelected,
                    select: select,
                    selectAll: selectAll,
                    toggleSelect: toggleSelect,
                    isExpanded: isExpanded,
                    toggleExpand: toggleExpand,
                    isGroupOpen: isGroupOpen,
                    toggleGroup: toggleGroup,
                    items: itemsWithoutGroups.value.map((item)=>item.raw),
                    internalItems: itemsWithoutGroups.value,
                    groupedItems: flatItems.value,
                    columns: columns.value,
                    headers: headers.value
                }));
            useRender(()=>{
                const dataTableFooterProps = VDataTableFooter.filterProps(props);
                const dataTableHeadersProps = VDataTableHeaders.filterProps(omit(props, [
                    'multiSort'
                ]));
                const dataTableRowsProps = VDataTableRows.filterProps(props);
                const tableProps = VTable.filterProps(props);
                return vue.createVNode(VTable, vue.mergeProps({
                    "class": [
                        'v-data-table',
                        {
                            'v-data-table--loading': props.loading
                        },
                        props.class
                    ],
                    "style": props.style
                }, tableProps, {
                    "fixedHeader": props.fixedHeader || props.sticky
                }), {
                    top: ()=>slots.top?.(slotProps.value),
                    caption: slots.caption,
                    default: ()=>slots.default ? slots.default(slotProps.value) : vue.createElementVNode(vue.Fragment, null, [
                            slots.colgroup?.(slotProps.value),
                            !props.hideDefaultHeader && vue.createElementVNode("thead", {
                                "key": "thead",
                                "class": "v-data-table__thead",
                                "role": "rowgroup"
                            }, [
                                vue.createVNode(VDataTableHeaders, vue.mergeProps(dataTableHeadersProps, {
                                    "multiSort": !!props.multiSort
                                }), slots)
                            ]),
                            slots.thead?.(slotProps.value),
                            !props.hideDefaultBody && vue.createElementVNode("tbody", {
                                "class": "v-data-table__tbody",
                                "role": "rowgroup"
                            }, [
                                slots['body.prepend']?.(slotProps.value),
                                slots.body ? slots.body(slotProps.value) : vue.createVNode(VDataTableRows, vue.mergeProps(attrs, dataTableRowsProps, {
                                    "items": flatItems.value
                                }), slots),
                                slots['body.append']?.(slotProps.value)
                            ]),
                            slots.tbody?.(slotProps.value),
                            slots.tfoot?.(slotProps.value)
                        ]),
                    bottom: ()=>slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VDivider, null, null),
                            vue.createVNode(VDataTableFooter, dataTableFooterProps, {
                                prepend: slots['footer.prepend']
                            })
                        ])
                });
            });
        }
    });
    const makeVContainerProps = propsFactory({
        fluid: {
            type: Boolean,
            default: false
        },
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeTagProps()
    }, 'VContainer');
    const VContainer = genericComponent()({
        name: 'VContainer',
        props: makeVContainerProps(),
        setup (props, { slots: slots }) {
            const { rtlClasses: rtlClasses } = useRtl();
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-container',
                        {
                            'v-container--fluid': props.fluid
                        },
                        rtlClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        dimensionStyles.value,
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Styles
    // Types
    const breakpointProps = (()=>{
        return breakpoints.reduce((props, val)=>{
            props[val] = {
                type: [
                    Boolean,
                    String,
                    Number
                ],
                default: false
            };
            return props;
        }, {});
    })();
    const offsetProps = (()=>{
        return breakpoints.reduce((props, val)=>{
            const offsetKey = 'offset' + vue.capitalize(val);
            props[offsetKey] = {
                type: [
                    String,
                    Number
                ],
                default: null
            };
            return props;
        }, {});
    })();
    const propMap$1 = {
        col: keys(breakpointProps),
        offset: keys(offsetProps),
        order: [
            'order',
            'orderSm',
            'orderMd',
            'orderLg',
            'orderXl',
            'orderXxl'
        ]
    };
    function parseCols(val) {
        if (typeof val === 'string' && val.includes('/')) {
            const [cols, size] = val.split('/');
            return {
                cols: Number(cols),
                size: Number(size)
            };
        }
        return {
            cols: val
        };
    }
    function parseBreakpoint(type, prop, val) {
        if (val == null || val === false) return {};
        const { cols: cols, size: size } = parseCols(val);
        const breakpoint = prop.replace(type, '').toLowerCase();
        if (type === 'offset') return {
            className: `v-col--offset-${breakpoint}-${cols}`,
            variables: [
                {
                    [`--v-col-offset-base-${breakpoint}`]: size
                }
            ]
        };
        else if (type === 'order') return {
            className: `order-${breakpoint}-${cols}`
        };
        // Handling the boolean style prop when accepting [Boolean, String, Number]
        // means Vue will not convert <v-col sm></v-col> to sm: true for us.
        // Since the default is false, an empty string indicates the prop's presence.
        return {
            className: cols === '' || cols === true ? `v-col--${breakpoint}` : `v-col--cols-${breakpoint}-${cols}`,
            variables: [
                {
                    [`--v-col-size-base-${breakpoint}`]: size
                }
            ]
        };
    }
    const ALIGN_SELF_VALUES = [
        'auto',
        'start',
        'end',
        'center',
        'baseline',
        'stretch'
    ];
    const alignSelfValidator = (str)=>ALIGN_SELF_VALUES.includes(str);
    const makeVColProps = propsFactory({
        cols: {
            type: [
                Boolean,
                String,
                Number
            ],
            default: false
        },
        ...breakpointProps,
        offset: {
            type: [
                String,
                Number
            ],
            default: null
        },
        ...offsetProps,
        /** @deprecated use order-* class instead */ order: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /** @deprecated use order-sm-* class instead */ orderSm: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /** @deprecated use order-md-* class instead */ orderMd: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /** @deprecated use order-lg-* class instead */ orderLg: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /** @deprecated use order-xl-* class instead */ orderXl: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /** @deprecated use order-xxl-* class instead */ orderXxl: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /** @deprecated use align-self-* class instead */ alignSelf: {
            type: String,
            default: null,
            validator: alignSelfValidator
        },
        ...makeComponentProps(),
        ...makeTagProps()
    }, 'VCol');
    const VCol = genericComponent()({
        name: 'VCol',
        props: makeVColProps(),
        setup (props, { slots: slots }) {
            const sizeBaseOverride = vue.computed(()=>parseCols(props.cols).size);
            const offsetBaseOverride = vue.computed(()=>parseCols(props.offset).size);
            const responsive = vue.computed(()=>{
                const classList = [
                    'v-col'
                ];
                const variablesList = [];
                // Loop through `col`, `offset`, `order` breakpoint props
                let type;
                for(type in propMap$1)propMap$1[type].forEach((prop)=>{
                    const value = props[prop];
                    const { className: className, variables: variables } = parseBreakpoint(type, prop, value);
                    if (className) classList.push(className);
                    if (variables) variablesList.push(...variables);
                });
                const { cols: cols } = parseCols(props.cols);
                const { cols: offset } = parseCols(props.offset);
                classList.push({
                    [`v-col--cols-${cols}`]: cols,
                    [`v-col--offset-${offset}`]: offset,
                    [`order-${props.order}`]: props.order,
                    [`align-self-${props.alignSelf}`]: props.alignSelf
                });
                return {
                    classes: classList,
                    variables: variablesList
                };
            });
            return ()=>vue.h(props.tag, {
                    class: [
                        responsive.value.classes,
                        props.class
                    ],
                    style: [
                        {
                            '--v-col-size-base': sizeBaseOverride.value
                        },
                        {
                            '--v-col-offset-base': offsetBaseOverride.value
                        },
                        responsive.value.variables,
                        props.style
                    ]
                }, slots.default?.());
        }
    });
    // Styles
    // Types
    const ALIGNMENT = [
        'start',
        'end',
        'center'
    ];
    const SPACE = [
        'space-between',
        'space-around',
        'space-evenly'
    ];
    const ALIGN_VALUES = [
        ...ALIGNMENT,
        'baseline',
        'stretch'
    ];
    const alignValidator = (str)=>ALIGN_VALUES.includes(str);
    const JUSTIFY_VALUES = [
        ...ALIGNMENT,
        ...SPACE
    ];
    const justifyValidator = (str)=>JUSTIFY_VALUES.includes(str);
    const ALIGN_CONTENT_VALUES = [
        ...ALIGNMENT,
        ...SPACE,
        'stretch'
    ];
    const alignContentValidator = (str)=>ALIGN_CONTENT_VALUES.includes(str);
    const propMap = {
        align: [
            'align',
            'alignSm',
            'alignMd',
            'alignLg',
            'alignXl',
            'alignXxl'
        ],
        justify: [
            'justify',
            'justifySm',
            'justifyMd',
            'justifyLg',
            'justifyXl',
            'justifyXxl'
        ],
        alignContent: [
            'alignContent',
            'alignContentSm',
            'alignContentMd',
            'alignContentLg',
            'alignContentXl',
            'alignContentXxl'
        ]
    };
    const classMap = {
        align: 'align',
        justify: 'justify',
        alignContent: 'align-content'
    };
    function breakpointClass(type, prop, val) {
        let className = classMap[type];
        if (val == null) return undefined;
        if (prop) {
            // alignSm -> Sm
            const breakpoint = prop.replace(type, '');
            className += `-${breakpoint}`;
        }
        // .align-items-sm-center
        className += `-${val}`;
        return className.toLowerCase();
    }
    const makeVRowProps = propsFactory({
        /** @deprecated use density="compact" instead */ dense: Boolean,
        /** @deprecated use align-* class instead */ align: {
            type: String,
            default: null,
            validator: alignValidator
        },
        /** @deprecated use align-sm-* class instead */ alignSm: {
            type: String,
            default: null,
            validator: alignValidator
        },
        /** @deprecated use align-md-* class instead */ alignMd: {
            type: String,
            default: null,
            validator: alignValidator
        },
        /** @deprecated use align-lg-* class instead */ alignLg: {
            type: String,
            default: null,
            validator: alignValidator
        },
        /** @deprecated use align-xl-* class instead */ alignXl: {
            type: String,
            default: null,
            validator: alignValidator
        },
        /** @deprecated use align-xxl-* class instead */ alignXxl: {
            type: String,
            default: null,
            validator: alignValidator
        },
        /** @deprecated use justify-* class instead */ justify: {
            type: String,
            default: null,
            validator: justifyValidator
        },
        /** @deprecated use justify-sm-* class instead */ justifySm: {
            type: String,
            default: null,
            validator: justifyValidator
        },
        /** @deprecated use justify-md-* class instead */ justifyMd: {
            type: String,
            default: null,
            validator: justifyValidator
        },
        /** @deprecated use justify-lg-* class instead */ justifyLg: {
            type: String,
            default: null,
            validator: justifyValidator
        },
        /** @deprecated use justify-xl-* class instead */ justifyXl: {
            type: String,
            default: null,
            validator: justifyValidator
        },
        /** @deprecated use justify-xxl-* class instead */ justifyXxl: {
            type: String,
            default: null,
            validator: justifyValidator
        },
        /** @deprecated use align-content-* class instead */ alignContent: {
            type: String,
            default: null,
            validator: alignContentValidator
        },
        /** @deprecated use align-content-sm-* class instead */ alignContentSm: {
            type: String,
            default: null,
            validator: alignContentValidator
        },
        /** @deprecated use align-content-md-* class instead */ alignContentMd: {
            type: String,
            default: null,
            validator: alignContentValidator
        },
        /** @deprecated use align-content-lg-* class instead */ alignContentLg: {
            type: String,
            default: null,
            validator: alignContentValidator
        },
        /** @deprecated use align-content-xl-* class instead */ alignContentXl: {
            type: String,
            default: null,
            validator: alignContentValidator
        },
        /** @deprecated use align-content-xxl-* class instead */ alignContentXxl: {
            type: String,
            default: null,
            validator: alignContentValidator
        },
        noGutters: Boolean,
        gap: [
            Number,
            String,
            Array
        ],
        size: [
            Number,
            String
        ],
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeTagProps()
    }, 'VRow');
    const VRow = genericComponent()({
        name: 'VRow',
        props: makeVRowProps(),
        setup (props, { slots: slots }) {
            if (props.dense) deprecate('dense', 'density="compact"');
            const classes = vue.computed(()=>{
                const classList = [];
                // Loop through `align`, `justify`, `alignContent` breakpoint props
                let type;
                for(type in propMap)propMap[type].forEach((prop)=>{
                    const value = props[prop];
                    const className = breakpointClass(type, prop, value);
                    if (className) classList.push(className);
                });
                classList.push({
                    'v-row--no-gutters': props.noGutters,
                    'v-row--density-default': props.density === 'default' && !props.noGutters && !props.dense,
                    'v-row--density-compact': props.density === 'compact' || props.dense,
                    'v-row--density-comfortable': props.density === 'comfortable',
                    [`align-${props.align}`]: props.align,
                    [`justify-${props.justify}`]: props.justify,
                    [`align-content-${props.alignContent}`]: props.alignContent
                });
                return classList;
            });
            const horizontalGap = vue.computed(()=>{
                return Array.isArray(props.gap) ? convertToUnit(props.gap[0] || 0) : convertToUnit(props.gap);
            });
            const verticalGap = vue.computed(()=>{
                return Array.isArray(props.gap) ? convertToUnit(props.gap[1] || 0) : horizontalGap.value;
            });
            return ()=>vue.h(props.tag, {
                    class: [
                        'v-row',
                        classes.value,
                        props.class
                    ],
                    style: [
                        {
                            '--v-col-gap-x': horizontalGap.value,
                            '--v-col-gap-y': verticalGap.value,
                            '--v-row-columns': props.size
                        },
                        props.style
                    ]
                }, slots.default?.());
        }
    });
    // Styles
    const VSpacer = createSimpleFunctional('v-spacer', 'div', 'VSpacer');
    // Types
    const makeVDatePickerControlsProps = propsFactory({
        active: {
            type: [
                String,
                Array
            ],
            default: undefined
        },
        controlHeight: [
            Number,
            String
        ],
        controlVariant: {
            type: String,
            default: 'docked'
        },
        noMonthPicker: Boolean,
        disabled: {
            type: [
                Boolean,
                String,
                Array
            ],
            default: null
        },
        nextIcon: {
            type: IconValue,
            default: '$next'
        },
        prevIcon: {
            type: IconValue,
            default: '$prev'
        },
        modeIcon: {
            type: IconValue,
            default: '$subgroup'
        },
        text: String,
        monthText: String,
        yearText: String,
        viewMode: {
            type: String,
            default: 'month'
        }
    }, 'VDatePickerControls');
    const VDatePickerControls = genericComponent()({
        name: 'VDatePickerControls',
        props: makeVDatePickerControlsProps(),
        emits: {
            'click:year': ()=>true,
            'click:month': ()=>true,
            'click:prev': ()=>true,
            'click:next': ()=>true,
            'click:prev-year': ()=>true,
            'click:next-year': ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const disableMonth = vue.computed(()=>{
                return Array.isArray(props.disabled) ? props.disabled.includes('text') : !!props.disabled;
            });
            const disableYear = vue.computed(()=>{
                return Array.isArray(props.disabled) ? props.disabled.includes('mode') : !!props.disabled;
            });
            const disablePrevMonth = vue.computed(()=>{
                return Array.isArray(props.disabled) ? props.disabled.includes('prev-month') : !!props.disabled;
            });
            const disableNextMonth = vue.computed(()=>{
                return Array.isArray(props.disabled) ? props.disabled.includes('next-month') : !!props.disabled;
            });
            const disablePrevYear = vue.computed(()=>{
                return Array.isArray(props.disabled) ? props.disabled.includes('prev-year') : !!props.disabled;
            });
            const disableNextYear = vue.computed(()=>{
                return Array.isArray(props.disabled) ? props.disabled.includes('next-year') : !!props.disabled;
            });
            function onClickPrevMonth() {
                emit('click:prev');
            }
            function onClickNextMonth() {
                emit('click:next');
            }
            function onClickPrevYear() {
                emit('click:prev-year');
            }
            function onClickNextYear() {
                emit('click:next-year');
            }
            function onClickYear() {
                emit('click:year');
            }
            function onClickMonth() {
                emit('click:month');
            }
            useRender(()=>{
                const innerDefaults = {
                    VBtn: {
                        density: 'comfortable',
                        variant: 'text'
                    }
                };
                const prevMonth = vue.createVNode(VBtn, {
                    "data-testid": "prev-month",
                    "disabled": disablePrevMonth.value,
                    "icon": props.prevIcon,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.previousMonth'),
                    "onClick": onClickPrevMonth
                }, null);
                const nextMonth = vue.createVNode(VBtn, {
                    "data-testid": "next-month",
                    "disabled": disableNextMonth.value,
                    "icon": props.nextIcon,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.nextMonth'),
                    "onClick": onClickNextMonth
                }, null);
                const prevYear = vue.createVNode(VBtn, {
                    "data-testid": "prev-year",
                    "disabled": disablePrevYear.value,
                    "icon": props.prevIcon,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.previousYear'),
                    "onClick": onClickPrevYear
                }, null);
                const nextYear = vue.createVNode(VBtn, {
                    "data-testid": "next-year",
                    "disabled": disableNextYear.value,
                    "icon": props.nextIcon,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.nextYear'),
                    "onClick": onClickNextYear
                }, null);
                const onlyMonthBtn = vue.createVNode(VBtn, {
                    "class": "v-date-picker-controls__only-month-btn",
                    "data-testid": "month-btn",
                    "density": "default",
                    "disabled": disableMonth.value,
                    "text": props.monthText,
                    "appendIcon": props.modeIcon,
                    "rounded": true,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.selectMonth'),
                    "onClick": onClickMonth
                }, null);
                const onlyYearBtn = vue.createVNode(VBtn, {
                    "class": "v-date-picker-controls__only-year-btn",
                    "data-testid": "year-btn",
                    "density": "default",
                    "disabled": disableYear.value,
                    "text": props.yearText,
                    "appendIcon": props.modeIcon,
                    "rounded": true,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.selectYear'),
                    "onClick": onClickYear
                }, null);
                const monthYearBtn = vue.createVNode(VBtn, {
                    "class": "v-date-picker-controls__year-btn",
                    "data-testid": "year-btn",
                    "density": "default",
                    "disabled": disableYear.value,
                    "text": props.text,
                    "appendIcon": props.modeIcon,
                    "rounded": true,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.selectYear'),
                    "onClick": onClickYear
                }, null);
                const monthYearSplit = vue.createElementVNode(vue.Fragment, null, [
                    vue.createVNode(VBtn, {
                        "class": "v-date-picker-controls__month-btn",
                        "data-testid": "month-btn",
                        "height": "36",
                        "disabled": disableMonth.value,
                        "text": props.text,
                        "rounded": true,
                        "aria-label": t('$vuetify.datePicker.ariaLabel.selectMonth'),
                        "onClick": onClickMonth
                    }, null),
                    vue.createVNode(VBtn, {
                        "class": "v-date-picker-controls__mode-btn",
                        "data-testid": "year-btn",
                        "disabled": disableYear.value,
                        "icon": props.modeIcon,
                        "aria-label": t('$vuetify.datePicker.ariaLabel.selectYear'),
                        "onClick": onClickYear
                    }, null)
                ]);
                const slotProps = {
                    viewMode: props.viewMode,
                    disabled: Array.isArray(props.disabled) ? props.disabled : [],
                    monthYearText: props.text ?? '',
                    monthText: props.monthText ?? '',
                    yearText: props.yearText ?? '',
                    openMonths: onClickMonth,
                    openYears: onClickYear,
                    prevMonth: onClickPrevMonth,
                    nextMonth: onClickNextMonth,
                    prevYear: onClickPrevYear,
                    nextYear: onClickNextYear
                };
                const modalControls = vue.createElementVNode(vue.Fragment, null, [
                    props.noMonthPicker ? monthYearBtn : monthYearSplit,
                    vue.createVNode(VSpacer, null, null),
                    vue.createElementVNode("div", {
                        "class": "v-date-picker-controls__month"
                    }, [
                        prevMonth,
                        nextMonth
                    ])
                ]);
                const dockedControls = vue.createElementVNode(vue.Fragment, null, [
                    vue.createElementVNode("div", {
                        "class": "v-date-picker-controls__month"
                    }, [
                        prevMonth,
                        onlyMonthBtn,
                        nextMonth
                    ]),
                    vue.createVNode(VSpacer, null, null),
                    vue.createElementVNode("div", {
                        "class": "v-date-picker-controls__year"
                    }, [
                        prevYear,
                        onlyYearBtn,
                        nextYear
                    ])
                ]);
                return vue.createVNode(VDefaultsProvider, {
                    "defaults": innerDefaults
                }, {
                    default: ()=>[
                            vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    'v-date-picker-controls',
                                    `v-date-picker-controls--variant-${props.controlVariant}`
                                ]),
                                "style": {
                                    '--v-date-picker-controls-height': convertToUnit(props.controlHeight)
                                }
                            }, [
                                slots.default?.(slotProps) ?? vue.createElementVNode(vue.Fragment, null, [
                                    props.controlVariant === 'modal' && modalControls,
                                    props.controlVariant === 'docked' && dockedControls
                                ])
                            ])
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const makeVDatePickerHeaderProps = propsFactory({
        appendIcon: IconValue,
        color: String,
        header: String,
        transition: String,
        onClick: EventProp(),
        onClickOnce: EventProp()
    }, 'VDatePickerHeader');
    const VDatePickerHeader = genericComponent()({
        name: 'VDatePickerHeader',
        props: makeVDatePickerHeaderProps(),
        emits: {
            click: ()=>true,
            'click:append': ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            function onClick() {
                emit('click');
            }
            function onClickAppend() {
                emit('click:append');
            }
            useRender(()=>{
                const hasContent = !!(slots.default || props.header);
                const hasAppend = !!(slots.append || props.appendIcon);
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-date-picker-header',
                        {
                            'v-date-picker-header--clickable': !!(props.onClick || props.onClickOnce)
                        },
                        backgroundColorClasses.value
                    ]),
                    "style": vue.normalizeStyle(backgroundColorStyles.value),
                    "onClick": (props.onClick || props.onClickOnce) && onClick
                }, [
                    slots.prepend && vue.createElementVNode("div", {
                        "key": "prepend",
                        "class": "v-date-picker-header__prepend"
                    }, [
                        slots.prepend()
                    ]),
                    hasContent && vue.createVNode(MaybeTransition, {
                        "key": "content",
                        "name": props.transition
                    }, {
                        default: ()=>[
                                vue.createElementVNode("div", {
                                    "key": props.header,
                                    "class": "v-date-picker-header__content"
                                }, [
                                    slots.default?.() ?? props.header
                                ])
                            ]
                    }),
                    hasAppend && vue.createElementVNode("div", {
                        "class": "v-date-picker-header__append"
                    }, [
                        !slots.append ? vue.createVNode(VBtn, {
                            "key": "append-btn",
                            "icon": props.appendIcon,
                            "variant": "text",
                            "onClick": onClickAppend
                        }, null) : vue.createVNode(VDefaultsProvider, {
                            "key": "append-defaults",
                            "disabled": !props.appendIcon,
                            "defaults": {
                                VBtn: {
                                    icon: props.appendIcon,
                                    variant: 'text'
                                }
                            }
                        }, {
                            default: ()=>[
                                    slots.append?.()
                                ]
                        })
                    ])
                ]);
            });
            return {};
        }
    });
    // Composables
    // Types
    // Types
    // Composables
    const makeCalendarProps = propsFactory({
        allowedDates: [
            Array,
            Function
        ],
        disabled: {
            type: Boolean,
            default: null
        },
        displayValue: null,
        modelValue: Array,
        month: [
            Number,
            String
        ],
        max: null,
        min: null,
        showAdjacentMonths: Boolean,
        year: [
            Number,
            String
        ],
        weekdays: {
            type: Array,
            default: ()=>[
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ]
        },
        weeksInMonth: {
            type: String,
            default: 'dynamic'
        },
        firstDayOfWeek: {
            type: [
                Number,
                String
            ],
            default: undefined
        },
        firstDayOfYear: {
            type: [
                Number,
                String
            ],
            default: undefined
        },
        weekdayFormat: String
    }, 'calendar');
    function useCalendar(props) {
        const adapter = useDate();
        const model = useProxiedModel(props, 'modelValue', [], (v)=>wrapInArray(v).map((i)=>adapter.date(i)));
        const displayValue = vue.computed(()=>{
            if (props.displayValue) return adapter.date(props.displayValue);
            if (model.value.length > 0) return adapter.date(model.value[0]);
            if (props.min) return adapter.date(props.min);
            if (Array.isArray(props.allowedDates)) return adapter.date(props.allowedDates[0]);
            return adapter.date();
        });
        const year = useProxiedModel(props, 'year', undefined, (v)=>{
            const value = v != null ? Number(v) : adapter.getYear(displayValue.value);
            return adapter.startOfYear(adapter.setYear(adapter.date(), value));
        }, (v)=>adapter.getYear(v));
        const month = useProxiedModel(props, 'month', undefined, (v)=>{
            const value = v != null ? Number(v) : adapter.getMonth(displayValue.value);
            const date = adapter.setYear(adapter.startOfMonth(adapter.date()), adapter.getYear(year.value));
            return adapter.setMonth(date, value);
        }, (v)=>adapter.getMonth(v));
        const weekdayLabels = vue.computed(()=>{
            const firstDayOfWeek = adapter.toJsDate(adapter.startOfWeek(adapter.date(), props.firstDayOfWeek)).getDay();
            return adapter.getWeekdays(props.firstDayOfWeek, props.weekdayFormat).filter((_, i)=>props.weekdays.includes((i + firstDayOfWeek) % 7));
        });
        const weeksInMonth = vue.computed(()=>{
            const weeks = adapter.getWeekArray(month.value, props.firstDayOfWeek);
            const days = weeks.flat();
            // Make sure there's always 6 weeks in month (6 * 7 days)
            // if weeksInMonth is 'static'
            const daysInMonth = 42;
            if (props.weeksInMonth === 'static' && days.length < daysInMonth) {
                const lastDay = days[days.length - 1];
                let week = [];
                for(let day = 1; day <= daysInMonth - days.length; day++){
                    week.push(adapter.addDays(lastDay, day));
                    if (day % 7 === 0) {
                        weeks.push(week);
                        week = [];
                    }
                }
            }
            return weeks;
        });
        function genDays(days, today) {
            return days.filter((date)=>{
                return props.weekdays.includes(adapter.toJsDate(date).getDay());
            }).map((date, index)=>{
                const isoDate = adapter.toISO(date);
                const isAdjacent = !adapter.isSameMonth(date, month.value);
                const isStart = adapter.isSameDay(date, adapter.startOfMonth(month.value));
                const isEnd = adapter.isSameDay(date, adapter.endOfMonth(month.value));
                const isSame = adapter.isSameDay(date, month.value);
                const weekdaysCount = props.weekdays.length;
                return {
                    date: date,
                    formatted: adapter.format(date, 'keyboardDate'),
                    isAdjacent: isAdjacent,
                    isDisabled: isDisabled(date),
                    isEnd: isEnd,
                    isHidden: isAdjacent && !props.showAdjacentMonths,
                    isSame: isSame,
                    isSelected: model.value.some((value)=>adapter.isSameDay(date, value)),
                    isStart: isStart,
                    isToday: adapter.isSameDay(date, today),
                    isWeekEnd: index % weekdaysCount === weekdaysCount - 1,
                    isWeekStart: index % weekdaysCount === 0,
                    isoDate: isoDate,
                    localized: adapter.format(date, 'dayOfMonth'),
                    month: adapter.getMonth(date),
                    year: adapter.getYear(date)
                };
            });
        }
        const daysInWeek = vue.computed(()=>{
            const lastDay = adapter.startOfWeek(displayValue.value, props.firstDayOfWeek);
            const week = [];
            for(let day = 0; day <= 6; day++)week.push(adapter.addDays(lastDay, day));
            const today = adapter.date();
            return genDays(week, today);
        });
        const daysInMonth = vue.computed(()=>{
            const days = weeksInMonth.value.flat();
            const today = adapter.date();
            return genDays(days, today);
        });
        const weekNumbers = vue.computed(()=>{
            return weeksInMonth.value.map((week)=>{
                return week.length ? adapter.getWeek(week[0], props.firstDayOfWeek, props.firstDayOfYear) : null;
            });
        });
        const { minDate: minDate, maxDate: maxDate } = useCalendarRange(props);
        function isDisabled(value) {
            if (props.disabled) return true;
            const date = adapter.date(value);
            if (minDate.value && adapter.isBefore(adapter.endOfDay(date), minDate.value)) return true;
            if (maxDate.value && adapter.isAfter(date, maxDate.value)) return true;
            if (Array.isArray(props.allowedDates) && props.allowedDates.length > 0) return !props.allowedDates.some((d)=>adapter.isSameDay(adapter.date(d), date));
            if (typeof props.allowedDates === 'function') return !props.allowedDates(date);
            return false;
        }
        return {
            displayValue: displayValue,
            daysInMonth: daysInMonth,
            daysInWeek: daysInWeek,
            genDays: genDays,
            model: model,
            weeksInMonth: weeksInMonth,
            weekdayLabels: weekdayLabels,
            weekNumbers: weekNumbers
        };
    }
    function useCalendarRange(props) {
        const adapter = useDate();
        const minDate = vue.computed(()=>{
            if (!props.min) return null;
            const date = adapter.date(props.min);
            return adapter.isValid(date) ? date : null;
        });
        const maxDate = vue.computed(()=>{
            if (!props.max) return null;
            const date = adapter.date(props.max);
            return adapter.isValid(date) ? date : null;
        });
        function clampDate(date) {
            if (minDate.value && adapter.isBefore(date, minDate.value)) return minDate.value;
            if (maxDate.value && adapter.isAfter(date, maxDate.value)) return maxDate.value;
            return date;
        }
        function isInAllowedRange(date) {
            return (!minDate.value || adapter.isAfter(date, minDate.value)) && (!maxDate.value || adapter.isBefore(date, maxDate.value));
        }
        return {
            minDate: minDate,
            maxDate: maxDate,
            clampDate: clampDate,
            isInAllowedRange: isInAllowedRange
        };
    }
    // Utilities
    // Types
    // pulled from v0, should be replaced by direct v0 import in v5.0
    // the only change was adapting to jsDOM by adding `?` in `el.scrollIntoView?.({ block: 'nearest' })`
    function useVirtualFocus(items, options) {
        const { control: control, orientation: orientation = 'vertical', circular: circular = false, columns: _columns, onHighlight: onHighlight } = options;
        const highlightedId = vue.shallowRef();
        let previousEl = null;
        function applyHighlight(id) {
            const item = items().find((i)=>i.id === id);
            if (!item?.el) return false;
            const el = vue.toValue(item.el);
            if (!el) return false;
            const controlEl = vue.toValue(control);
            if (controlEl) {
                const itemId = el.getAttribute('id');
                if (itemId) controlEl.setAttribute('aria-activedescendant', itemId);
            }
            if (previousEl) delete previousEl.dataset.highlighted;
            el.dataset.highlighted = '';
            previousEl = el;
            el.scrollIntoView?.({
                block: 'nearest'
            });
            onHighlight?.(id);
            return true;
        }
        function mod(n, i) {
            return (i % n + n) % n;
        }
        function indexOf(id) {
            return items().findIndex((item)=>item.id === id);
        }
        function go(id) {
            highlightedId.value = id;
            applyHighlight(id);
        }
        function step(stride) {
            const all = items();
            if (!all.length) return;
            const current = highlightedId.value == null ? -1 : indexOf(highlightedId.value);
            const dir = stride > 0 ? 1 : -1;
            const abs = Math.abs(stride);
            const maxHops = Math.ceil(all.length / abs);
            let index = current + stride;
            let hops = 0;
            if (circular) index = mod(all.length, index);
            else if (index < 0 || index >= all.length) return;
            while(hops < maxHops){
                const item = all[index];
                if (item && !vue.toValue(item.disabled)) {
                    go(item.id);
                    return;
                }
                hops++;
                index = circular ? mod(all.length, index + stride) : index + dir * abs;
                if (!circular && (index < 0 || index >= all.length)) return;
            }
        }
        function first() {
            const item = items().find((i)=>!vue.toValue(i.disabled));
            if (item) go(item.id);
        }
        function last() {
            const item = [
                ...items()
            ].reverse().find((i)=>!vue.toValue(i.disabled));
            if (item) go(item.id);
        }
        function rowFirst() {
            const cols = vue.toValue(_columns) ?? 0;
            if (!cols) return first();
            const all = items();
            const cur = highlightedId.value == null ? 0 : Math.max(0, indexOf(highlightedId.value));
            const start = cur - cur % cols;
            for(let i = start; i < Math.min(start + cols, all.length); i++)if (!vue.toValue(all[i]?.disabled)) {
                go(all[i].id);
                return;
            }
        }
        function rowLast() {
            const cols = vue.toValue(_columns) ?? 0;
            if (!cols) return last();
            const all = items();
            const cur = highlightedId.value == null ? 0 : Math.max(0, indexOf(highlightedId.value));
            const start = cur - cur % cols;
            const end = Math.min(start + cols, all.length);
            for(let i = end - 1; i >= start; i--)if (!vue.toValue(all[i]?.disabled)) {
                go(all[i].id);
                return;
            }
        }
        function highlight(id) {
            const prev = highlightedId.value;
            highlightedId.value = id;
            if (!applyHighlight(id)) highlightedId.value = prev;
        }
        function focusHighlighted() {
            if (highlightedId.value == null) return;
            const item = items().find((i)=>i.id === highlightedId.value);
            if (!item?.el) return;
            vue.toValue(item.el)?.focus();
        }
        function clear() {
            highlightedId.value = undefined;
            vue.toValue(control)?.removeAttribute('aria-activedescendant');
            if (previousEl) {
                delete previousEl.dataset.highlighted;
                previousEl = null;
            }
        }
        function isRtl(e) {
            const el = e.currentTarget;
            return el ? getComputedStyle(el).direction === 'rtl' : false;
        }
        function onKeydown(e) {
            const cols = vue.toValue(_columns);
            const rtl = isRtl(e);
            if (cols) {
                switch(e.key){
                    case 'ArrowRight':
                        e.preventDefault();
                        step(rtl ? -1 : 1);
                        break;
                    case 'ArrowLeft':
                        e.preventDefault();
                        step(rtl ? 1 : -1);
                        break;
                    case 'ArrowDown':
                        e.preventDefault();
                        step(cols);
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        step(-cols);
                        break;
                    case 'Home':
                        e.preventDefault();
                        e.ctrlKey ? first() : rowFirst();
                        break;
                    case 'End':
                        e.preventDefault();
                        e.ctrlKey ? last() : rowLast();
                        break;
                }
                return;
            }
            const prevKeys = [];
            const nextKeys = [];
            if (orientation === 'vertical' || orientation === 'both') {
                prevKeys.push('ArrowUp');
                nextKeys.push('ArrowDown');
            }
            if (orientation === 'horizontal' || orientation === 'both') {
                prevKeys.push(rtl ? 'ArrowRight' : 'ArrowLeft');
                nextKeys.push(rtl ? 'ArrowLeft' : 'ArrowRight');
            }
            if (prevKeys.includes(e.key)) {
                e.preventDefault();
                step(-1);
            } else if (nextKeys.includes(e.key)) {
                e.preventDefault();
                step(1);
            } else if (e.key === 'Home') {
                e.preventDefault();
                first();
            } else if (e.key === 'End') {
                e.preventDefault();
                last();
            }
        }
        vue.onScopeDispose(clear);
        return {
            highlightedId: highlightedId,
            highlight: highlight,
            focusHighlighted: focusHighlighted,
            clear: clear,
            next: ()=>step(1),
            prev: ()=>step(-1),
            first: first,
            last: last,
            onKeydown: onKeydown
        };
    }
    // Composables
    // Types
    function keyToDirection(key) {
        switch(key){
            case 'ArrowUp':
                return 'up';
            case 'ArrowDown':
                return 'down';
            case 'ArrowLeft':
                return 'left';
            case 'ArrowRight':
                return 'right';
            default:
                return null;
        }
    }
    function useGridSelection({ items: items, columns: columns, initialValue: initialValue, itemAttribute: itemAttribute, onSelect: onSelect, onNavigation: onNavigation, onHighlight: onHighlight, onEscape: onEscape }) {
        const hasFocusIn = vue.shallowRef(false);
        const containerEl = vue.shallowRef();
        const virtualFocus = useVirtualFocus(()=>items().map((item)=>({
                    id: item.value,
                    disabled: item.isDisabled,
                    el: ()=>containerEl.value?.querySelector(`[${itemAttribute}="${item.value}"]`)
                })), {
            control: containerEl,
            columns: columns
        });
        if (onHighlight) vue.watch(virtualFocus.highlightedId, (id)=>onHighlight(id));
        function onFocusin(e) {
            const grid = containerEl.value;
            if (!grid || grid.contains(e.relatedTarget)) return;
            hasFocusIn.value = true;
            const targetEl = e.target;
            const targetId = targetEl?.getAttribute?.(itemAttribute);
            if (targetId != null && items().some((item)=>String(item.value) === targetId)) {
                virtualFocus.highlight(targetId);
                return;
            }
            const initial = initialValue(virtualFocus.highlightedId.value);
            if (initial != null) virtualFocus.highlight(initial);
            virtualFocus.focusHighlighted();
        }
        function onFocusout(e) {
            if (containerEl.value?.contains(e.relatedTarget)) return;
            hasFocusIn.value = false;
            virtualFocus.clear();
        }
        function onActivate() {
            const id = virtualFocus.highlightedId.value;
            if (id == null) return;
            const item = items().find((x)=>x.value === id);
            if (item && !item.isDisabled) onSelect(id);
        }
        function selectItem(value) {
            virtualFocus.highlight(value);
            virtualFocus.focusHighlighted();
            onSelect(value);
        }
        function focusItem(value) {
            virtualFocus.highlight(value);
            if (virtualFocus.highlightedId.value == null) virtualFocus.first();
            virtualFocus.focusHighlighted();
        }
        function onContainerKeydown(e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                onEscape?.();
                return;
            }
            if ((e.key === 'Enter' || e.key === ' ') && virtualFocus.highlightedId.value != null) {
                e.preventDefault();
                onActivate();
                return;
            }
            const direction = keyToDirection(e.key);
            if (direction && onNavigation?.(direction, e, virtualFocus.highlightedId.value)) return;
            virtualFocus.onKeydown(e);
            virtualFocus.focusHighlighted();
        }
        const containerProps = vue.computed(()=>({
                ref: (el)=>containerEl.value = el ?? undefined,
                tabindex: hasFocusIn.value ? -1 : 0,
                onKeydown: onContainerKeydown,
                onFocusin: onFocusin,
                onFocusout: onFocusout
            }));
        return {
            containerProps: containerProps,
            containerEl: containerEl,
            selectItem: selectItem,
            focusItem: focusItem,
            clear: virtualFocus.clear
        };
    }
    // Utilities
    // Types
    function useRangePicker({ multiple: multiple, model: model, compare: compare, normalizeEnd: normalizeEnd = (v)=>v, previewValue: externalPreview }) {
        const rangeStart = vue.computed(()=>model.value.length >= 1 ? model.value[0] : undefined);
        const rangeEnd = vue.computed(()=>model.value.length >= 2 ? model.value[model.value.length - 1] : undefined);
        const previewValue = externalPreview ?? vue.shallowRef();
        const previewRange = vue.computed(()=>{
            if (multiple.value !== 'range') return null;
            if (!rangeStart.value || rangeEnd.value) return null;
            if (!previewValue.value) return null;
            const start = rangeStart.value;
            const preview = previewValue.value;
            if (compare(start, preview) === 0) return null;
            return compare(start, preview) < 0 ? [
                start,
                preview
            ] : [
                preview,
                start
            ];
        });
        function isSelected(value) {
            if (multiple.value === 'range' && model.value.length === 2) return isWithinRange(value);
            for (const v of model.value){
                if (compare(v, value) === 0) return true;
            }
            return false;
        }
        function isWithinRange(value) {
            if (multiple.value !== 'range' || model.value.length < 2) return false;
            const [start, end] = [
                model.value[0],
                model.value[model.value.length - 1]
            ];
            return compare(value, start) >= 0 && compare(value, end) <= 0;
        }
        function isRangeStart(value) {
            if (multiple.value !== 'range' || model.value.length < 2) return false;
            return compare(value, model.value[0]) === 0;
        }
        function isRangeEnd(value) {
            if (multiple.value !== 'range' || model.value.length < 2) return false;
            return compare(value, model.value[model.value.length - 1]) === 0;
        }
        function isRangeMiddle(value) {
            return isWithinRange(value) && !isRangeStart(value) && !isRangeEnd(value);
        }
        function select(value) {
            if (multiple.value === 'range') onRangeSelect(value);
            else if (multiple.value) onMultipleSelect(value);
            else model.value = [
                value
            ];
        }
        function onRangeSelect(value) {
            if (model.value.length === 0) model.value = [
                value
            ];
            else if (model.value.length === 1) {
                const start = model.value[0];
                if (compare(value, start) === 0) model.value = [];
                else if (compare(value, start) < 0) model.value = [
                    value,
                    normalizeEnd(start)
                ];
                else model.value = [
                    start,
                    normalizeEnd(value)
                ];
            } else model.value = [
                value
            ];
        }
        function setPreview(value) {
            previewValue.value = value;
        }
        function clearPreview() {
            previewValue.value = undefined;
        }
        function isPreviewStart(value) {
            const range = previewRange.value;
            if (!range) return false;
            return compare(value, range[0]) === 0;
        }
        function isPreviewEnd(value) {
            const range = previewRange.value;
            if (!range) return false;
            return compare(value, range[1]) === 0;
        }
        function isPreviewMiddle(value) {
            const range = previewRange.value;
            if (!range) return false;
            return compare(value, range[0]) > 0 && compare(value, range[1]) < 0;
        }
        function isInPreviewRange(value) {
            return isPreviewStart(value) || isPreviewEnd(value) || isPreviewMiddle(value);
        }
        function onMultipleSelect(value) {
            const index = model.value.findIndex((v)=>compare(v, value) === 0);
            if (index === -1) model.value = [
                ...model.value,
                value
            ];
            else {
                const copy = [
                    ...model.value
                ];
                copy.splice(index, 1);
                model.value = copy;
            }
        }
        return {
            isSelected: isSelected,
            isRangeStart: isRangeStart,
            isRangeEnd: isRangeEnd,
            isRangeMiddle: isRangeMiddle,
            select: select,
            setPreview: setPreview,
            clearPreview: clearPreview,
            isPreviewStart: isPreviewStart,
            isPreviewEnd: isPreviewEnd,
            isPreviewMiddle: isPreviewMiddle,
            isInPreviewRange: isInPreviewRange
        };
    }
    // Types
    const makeVDatePickerMonthProps = propsFactory({
        color: String,
        hideWeekdays: Boolean,
        multiple: [
            Boolean,
            Number,
            String
        ],
        showWeek: Boolean,
        readonly: Boolean,
        transition: {
            type: String,
            default: 'picker-transition'
        },
        reverseTransition: {
            type: String,
            default: 'picker-reverse-transition'
        },
        events: {
            type: [
                Array,
                Function,
                Object
            ],
            default: ()=>null
        },
        eventColor: {
            type: [
                Array,
                Function,
                Object,
                String
            ],
            default: ()=>null
        },
        noAutoNavigation: Boolean,
        previewValue: null,
        ...omit(makeCalendarProps(), [
            'displayValue'
        ])
    }, 'VDatePickerMonth');
    const VDatePickerMonth = genericComponent()({
        name: 'VDatePickerMonth',
        props: makeVDatePickerMonthProps(),
        emits: {
            'update:modelValue': (date)=>true,
            'update:month': (date)=>true,
            'update:year': (date)=>true,
            'update:previewValue': (_value)=>true,
            'boundary-navigate': (_payload)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const uid = vue.useId();
            const { t: t } = useLocale();
            const { daysInMonth: daysInMonth, model: model, weekNumbers: weekNumbers, weekdayLabels: weekdayLabels } = useCalendar(props);
            const adapter = useDate();
            const isReverse = vue.shallowRef(false);
            const transition = vue.toRef(()=>{
                return !isReverse.value ? props.transition : props.reverseTransition;
            });
            function compareDays(a, b) {
                if (adapter.isSameDay(a, b)) return 0;
                return adapter.isBefore(a, b) ? -1 : 1;
            }
            const previewValue = useProxiedModel(props, 'previewValue');
            const range = useRangePicker({
                multiple: vue.computed(()=>{
                    if (props.multiple === 'range') return 'range';
                    return !!props.multiple;
                }),
                model: model,
                compare: compareDays,
                normalizeEnd: (value)=>adapter.endOfDay(value),
                previewValue: previewValue
            });
            const selectionColor = vue.toRef(()=>props.color || 'surface-variant');
            const { backgroundColorClasses: rangeColorClasses, backgroundColorStyles: rangeColorStyles } = useBackgroundColor(selectionColor);
            const atMax = vue.computed(()=>{
                const max = [
                    'number',
                    'string'
                ].includes(typeof props.multiple) ? Number(props.multiple) : Infinity;
                return model.value.length >= max;
            });
            const dayRows = vue.computed(()=>{
                return chunkArray(daysInMonth.value, props.weekdays.length);
            });
            function isSelectedDay(item) {
                return range.isSelected(item.date);
            }
            function isDayDisabled(item) {
                return item.isDisabled || item.isHidden || atMax.value && !isSelectedDay(item);
            }
            function getDateAriaLabel(item) {
                const fullDate = adapter.format(item.date, 'fullDateWithWeekday');
                const localeKey = item.isToday ? 'currentDate' : 'selectDate';
                return t(`$vuetify.datePicker.ariaLabel.${localeKey}`, fullDate);
            }
            function onClick(value) {
                range.select(adapter.startOfDay(value));
            }
            function initialFocusDate(current) {
                const isVisible = (d)=>!d.isAdjacent && !d.isDisabled;
                // Preserve existing highlight if it's still pointing to a visible day in the current grid
                if (current != null) {
                    const cur = daysInMonth.value.find((d)=>d.isoDate === current);
                    if (cur && !cur.isAdjacent) return current;
                }
                const selected = daysInMonth.value.find((d)=>isVisible(d) && model.value.some((m)=>adapter.isSameDay(m, d.date)));
                return (selected ?? daysInMonth.value.find(isVisible))?.isoDate;
            }
            const { containerProps: containerProps, containerEl: containerEl, selectItem: selectItem, focusItem: focusItem, clear: clear } = useGridSelection({
                items: ()=>daysInMonth.value.map((d)=>({
                            value: d.isoDate,
                            isDisabled: isDayDisabled(d)
                        })),
                columns: ()=>props.weekdays.length,
                initialValue: initialFocusDate,
                itemAttribute: 'data-v-date',
                onSelect: onDaySelect,
                onNavigation: onNavigationBoundary,
                onEscape: onEscape
            });
            function onDaySelect(isoDate) {
                const item = daysInMonth.value.find((d)=>d.isoDate === isoDate);
                if (!item || isDayDisabled(item)) return;
                onClick(item.date);
                if (item.isAdjacent) {
                    emit('update:month', adapter.getMonth(item.date));
                    emit('update:year', adapter.getYear(item.date));
                    vue.nextTick(()=>focusItem(isoDate));
                }
            }
            function onNavigationBoundary(direction, e, curId) {
                if (curId == null) return false;
                const cols = props.weekdays.length;
                const rtl = getComputedStyle(e.currentTarget).direction === 'rtl';
                // stride = array-index delta; calendarDays = actual date offset for boundary crossing
                let stride;
                let calendarDays;
                if (direction === 'left') {
                    stride = rtl ? 1 : -1;
                    calendarDays = stride;
                } else if (direction === 'right') {
                    stride = rtl ? -1 : 1;
                    calendarDays = stride;
                } else if (direction === 'up') {
                    stride = -cols;
                    calendarDays = -7;
                } else {
                    stride = cols;
                    calendarDays = 7;
                }
                const all = daysInMonth.value;
                const curIndex = all.findIndex((d)=>d.isoDate === curId);
                if (curIndex < 0) return false;
                const targetItem = all[curIndex + stride];
                // isHidden = isAdjacent && !showAdjacentMonths — no button in DOM for this day
                if (targetItem && !targetItem.isHidden) return false;
                e.preventDefault();
                let targetIsoDate;
                if (targetItem) targetIsoDate = targetItem.isoDate;
                else {
                    const step = calendarDays < 0 ? -1 : 1;
                    let candidate = adapter.addDays(adapter.date(curId), calendarDays);
                    while(!props.weekdays.includes(adapter.toJsDate(candidate).getDay()))candidate = adapter.addDays(candidate, step);
                    targetIsoDate = adapter.toISO(candidate);
                }
                if (props.noAutoNavigation) {
                    emit('boundary-navigate', {
                        direction: direction,
                        targetIsoDate: targetIsoDate
                    });
                    return true;
                }
                const targetDate = adapter.date(targetIsoDate);
                emit('update:month', adapter.getMonth(targetDate));
                emit('update:year', adapter.getYear(targetDate));
                vue.nextTick(()=>focusItem(targetIsoDate));
                return true;
            }
            function onEscape() {
                const rawTarget = model.value[0] ?? adapter.date();
                const targetIso = adapter.toISO(adapter.date(rawTarget));
                const inCurrentMonth = daysInMonth.value.find((d)=>d.isoDate === targetIso && !d.isAdjacent);
                if (inCurrentMonth) {
                    focusItem(targetIso);
                    return;
                }
                const targetDate = adapter.date(rawTarget);
                emit('update:month', adapter.getMonth(targetDate));
                emit('update:year', adapter.getYear(targetDate));
                vue.nextTick(()=>focusItem(targetIso));
            }
            function onDayClick(item) {
                if (item.isAdjacent) onDaySelect(item.isoDate);
                else selectItem(item.isoDate);
            }
            function focusGrid() {
                containerEl.value?.focus();
            }
            vue.watch(daysInMonth, (val, oldVal)=>{
                if (!oldVal || val[0].isoDate === oldVal[0].isoDate) return; // only clear when the month actually changes
                isReverse.value = adapter.isBefore(val[0].date, oldVal[0].date);
                clear();
            });
            function getEventColors(date) {
                const { events: events, eventColor: eventColor } = props;
                let eventData;
                let eventColors = [];
                if (Array.isArray(events)) eventData = events.includes(date);
                else if (events instanceof Function) eventData = events(date) || false;
                else if (events) eventData = events[date] || false;
                else eventData = false;
                if (!eventData) return [];
                else if (eventData !== true) eventColors = wrapInArray(eventData);
                else if (typeof eventColor === 'string') eventColors = [
                    eventColor
                ];
                else if (typeof eventColor === 'function') eventColors = wrapInArray(eventColor(date));
                else if (Array.isArray(eventColor)) eventColors = eventColor;
                else if (typeof eventColor === 'object' && eventColor !== null) eventColors = wrapInArray(eventColor[date]);
                // Fallback to default color if no color is found
                return !eventColors.length ? [
                    'surface-variant'
                ] : eventColors.filter(Boolean).map((color)=>typeof color === 'string' ? color : 'surface-variant');
            }
            function genEvents(date) {
                const eventColors = getEventColors(date);
                if (!eventColors.length) return null;
                return vue.createElementVNode("div", {
                    "class": "v-date-picker-month__events"
                }, [
                    eventColors.map((color)=>vue.createVNode(VBadge, {
                            "dot": true,
                            "color": color
                        }, null))
                ]);
            }
            useRender(()=>vue.createElementVNode("div", {
                    "class": "v-date-picker-month",
                    "style": {
                        '--v-date-picker-days-in-week': props.weekdays.length
                    }
                }, [
                    props.showWeek && vue.createElementVNode("div", {
                        "key": "weeks",
                        "class": "v-date-picker-month__weeks"
                    }, [
                        !props.hideWeekdays && vue.createElementVNode("div", {
                            "key": "hide-week-days",
                            "class": "v-date-picker-month__day"
                        }, [
                            vue.createTextVNode("\xA0")
                        ]),
                        weekNumbers.value.map((week)=>vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    'v-date-picker-month__day',
                                    'v-date-picker-month__day--adjacent'
                                ])
                            }, [
                                week
                            ]))
                    ]),
                    vue.createVNode(MaybeTransition, {
                        "name": transition.value
                    }, {
                        default: ()=>[
                                vue.createElementVNode("div", vue.mergeProps({
                                    "key": daysInMonth.value[0].date?.toString(),
                                    "class": "v-date-picker-month__days",
                                    "role": "grid",
                                    "onMouseleave": range.clearPreview
                                }, containerProps.value), [
                                    !props.hideWeekdays && vue.createElementVNode("div", {
                                        "key": "weekday-labels",
                                        "class": "v-date-picker-month__days-row"
                                    }, [
                                        weekdayLabels.value.map((weekDay)=>vue.createElementVNode("div", {
                                                "class": vue.normalizeClass([
                                                    'v-date-picker-month__day',
                                                    'v-date-picker-month__weekday'
                                                ])
                                            }, [
                                                weekDay
                                            ]))
                                    ]),
                                    dayRows.value.map((row, rowIndex)=>vue.createElementVNode("div", {
                                            "class": "v-date-picker-month__days-row",
                                            "role": "row"
                                        }, [
                                            row.map((item, colIndex)=>{
                                                const i = rowIndex * props.weekdays.length + colIndex;
                                                const isSelected = isSelectedDay(item);
                                                const disabled = isDayDisabled(item);
                                                const rangeStart = range.isRangeStart(item.date);
                                                const rangeEnd = range.isRangeEnd(item.date);
                                                const rangeMiddle = range.isRangeMiddle(item.date);
                                                const previewStart = range.isPreviewStart(item.date);
                                                const previewEnd = range.isPreviewEnd(item.date);
                                                const previewMiddle = range.isPreviewMiddle(item.date);
                                                const slotProps = {
                                                    props: {
                                                        class: 'v-date-picker-month__day-btn',
                                                        color: isSelected && !rangeMiddle || item.isToday ? props.color : undefined,
                                                        disabled: disabled,
                                                        readonly: props.readonly,
                                                        icon: true,
                                                        ripple: false,
                                                        tabindex: -1,
                                                        variant: isSelected && !rangeMiddle ? 'flat' : item.isToday ? 'outlined' : 'text',
                                                        'aria-label': getDateAriaLabel(item),
                                                        'aria-current': item.isToday ? 'date' : undefined,
                                                        id: `${uid}-day-${item.isoDate}`,
                                                        'data-v-date': !disabled ? item.isoDate : undefined,
                                                        onMousedown: (e)=>e.preventDefault(),
                                                        // preserve virtual focus
                                                        onClick: ()=>onDayClick(item),
                                                        onMouseenter: ()=>range.setPreview(item.date),
                                                        onFocus: ()=>range.setPreview(item.date),
                                                        onBlur: range.clearPreview
                                                    },
                                                    item: item,
                                                    i: i
                                                };
                                                const hasRangeBg = rangeStart || rangeEnd || rangeMiddle;
                                                const hasPreviewBg = previewStart || previewEnd || previewMiddle;
                                                return vue.createElementVNode("div", {
                                                    "class": vue.normalizeClass([
                                                        'v-date-picker-month__day',
                                                        {
                                                            'v-date-picker-month__day--adjacent': item.isAdjacent,
                                                            'v-date-picker-month__day--hide-adjacent': item.isHidden,
                                                            'v-date-picker-month__day--selected': isSelected,
                                                            'v-date-picker-month__day--week-end': item.isWeekEnd,
                                                            'v-date-picker-month__day--week-start': item.isWeekStart,
                                                            'v-date-picker-month__day--range-start': rangeStart,
                                                            'v-date-picker-month__day--range-end': rangeEnd,
                                                            'v-date-picker-month__day--range-middle': rangeMiddle,
                                                            'v-date-picker-month__day--preview-start': previewStart,
                                                            'v-date-picker-month__day--preview-end': previewEnd,
                                                            'v-date-picker-month__day--preview-middle': previewMiddle
                                                        }
                                                    ]),
                                                    "role": "gridcell"
                                                }, [
                                                    (hasRangeBg || hasPreviewBg) && vue.createElementVNode("div", {
                                                        "key": "range-bg",
                                                        "class": vue.normalizeClass([
                                                            'v-date-picker-month__range-bg',
                                                            hasRangeBg ? 'v-date-picker-month__range-bg--range' : 'v-date-picker-month__range-bg--preview',
                                                            rangeColorClasses.value
                                                        ]),
                                                        "style": vue.normalizeStyle(rangeColorStyles.value)
                                                    }, null),
                                                    (props.showAdjacentMonths || !item.isAdjacent) && (slots.day?.(slotProps) ?? vue.createVNode(VBtn, slotProps.props, {
                                                        default: ()=>[
                                                                item.localized,
                                                                genEvents(item.isoDate)
                                                            ]
                                                    }))
                                                ]);
                                            })
                                        ]))
                                ])
                            ]
                    })
                ]));
            return {
                focusGrid: focusGrid,
                focusItem: focusItem
            };
        }
    });
    // Types
    const makeVDatePickerMonthsProps = propsFactory({
        color: String,
        columns: {
            type: Number,
            default: 2
        },
        height: [
            String,
            Number
        ],
        min: null,
        max: null,
        modelValue: Number,
        year: Number,
        allowedMonths: [
            Array,
            Function
        ]
    }, 'VDatePickerMonths');
    const VDatePickerMonths = genericComponent()({
        name: 'VDatePickerMonths',
        props: makeVDatePickerMonthsProps(),
        emits: {
            'update:modelValue': (date)=>true,
            escape: ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const adapter = useDate();
            const model = useProxiedModel(props, 'modelValue');
            const uid = vue.useId();
            const months = vue.computed(()=>{
                let date = adapter.startOfYear(adapter.date());
                if (props.year) date = adapter.setYear(date, props.year);
                return createRange(12).map((i)=>{
                    const text = adapter.format(date, 'monthShort');
                    const label = adapter.format(date, 'month');
                    const isDisabled = !!(!isMonthAllowed(i) || props.min && adapter.isAfter(adapter.startOfMonth(adapter.date(props.min)), date) || props.max && adapter.isAfter(date, adapter.startOfMonth(adapter.date(props.max))));
                    date = adapter.getNextMonth(date);
                    return {
                        isDisabled: isDisabled,
                        text: text,
                        label: label,
                        value: i
                    };
                });
            });
            vue.watchEffect(()=>{
                model.value = model.value ?? adapter.getMonth(adapter.date());
            });
            function isMonthAllowed(month) {
                if (Array.isArray(props.allowedMonths) && props.allowedMonths.length) return props.allowedMonths.includes(month);
                if (typeof props.allowedMonths === 'function') return props.allowedMonths(month);
                return true;
            }
            function onMonthSelect(value) {
                if (model.value === value) emit('update:modelValue', value);
                else model.value = value;
            }
            const { containerProps: containerProps, selectItem: selectItem } = useGridSelection({
                items: ()=>months.value,
                columns: ()=>props.columns,
                initialValue: (current)=>current ?? model.value ?? adapter.getMonth(adapter.date()),
                itemAttribute: 'data-v-month',
                onSelect: onMonthSelect,
                onEscape: ()=>emit('escape')
            });
            useRender(()=>vue.createElementVNode("div", {
                    "class": "v-date-picker-months",
                    "style": {
                        height: convertToUnit(props.height)
                    }
                }, [
                    vue.createElementVNode("div", vue.mergeProps({
                        "class": "v-date-picker-months__content",
                        "style": {
                            '--v-date-picker-months-columns': props.columns
                        }
                    }, containerProps.value), [
                        months.value.map((month, i)=>{
                            const btnProps = {
                                id: `${uid}-month-${i}`,
                                active: model.value === i,
                                ariaLabel: month.label,
                                color: model.value === i ? props.color : undefined,
                                disabled: month.isDisabled,
                                rounded: true,
                                tabindex: -1,
                                text: month.text,
                                variant: model.value === month.value ? 'flat' : 'text',
                                'data-v-month': month.value,
                                onMousedown: (e)=>e.preventDefault(),
                                // preserve virtual focus
                                onClick: ()=>selectItem(i)
                            };
                            return slots.month?.({
                                month: month,
                                i: i,
                                props: btnProps
                            }) ?? vue.createVNode(VBtn, vue.mergeProps({
                                "key": "month"
                            }, btnProps), null);
                        })
                    ])
                ]));
            return {};
        }
    });
    // Types
    // Types
    const makeVDatePickerYearsProps = propsFactory({
        color: String,
        columns: {
            type: Number,
            default: 3
        },
        height: [
            String,
            Number
        ],
        min: null,
        max: null,
        modelValue: Number,
        allowedYears: [
            Array,
            Function
        ]
    }, 'VDatePickerYears');
    const VDatePickerYears = genericComponent()({
        name: 'VDatePickerYears',
        props: makeVDatePickerYearsProps(),
        directives: {
            vIntersect: Intersect
        },
        emits: {
            'update:modelValue': (year)=>true,
            escape: ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const adapter = useDate();
            const model = useProxiedModel(props, 'modelValue');
            const containerRef = templateRef();
            const uid = vue.useId();
            const years = vue.computed(()=>{
                const year = adapter.getYear(adapter.date());
                let min = year - 100;
                let max = year + 52;
                if (props.min) min = adapter.getYear(adapter.date(props.min));
                if (props.max) max = adapter.getYear(adapter.date(props.max));
                let date = adapter.startOfYear(adapter.date());
                date = adapter.setYear(date, min);
                return createRange(max - min + 1, min).map((i)=>{
                    const text = adapter.format(date, 'year');
                    date = adapter.setYear(date, adapter.getYear(date) + 1);
                    return {
                        text: text,
                        value: i,
                        isDisabled: !isYearAllowed(i)
                    };
                });
            });
            vue.watchEffect(()=>{
                model.value = model.value ?? adapter.getYear(adapter.date());
            });
            function isYearAllowed(year) {
                if (Array.isArray(props.allowedYears) && props.allowedYears.length) return props.allowedYears.includes(year);
                if (typeof props.allowedYears === 'function') return props.allowedYears(year);
                return true;
            }
            function onYearSelect(value) {
                if (model.value === value) emit('update:modelValue', value);
                else model.value = value;
            }
            const { containerProps: containerProps, containerEl: containerEl, selectItem: selectItem } = useGridSelection({
                items: ()=>years.value,
                columns: ()=>props.columns,
                initialValue: (current)=>current ?? model.value ?? adapter.getYear(adapter.date()),
                itemAttribute: 'data-v-year',
                onSelect: onYearSelect,
                onEscape: ()=>emit('escape')
            });
            function scrollToSelected() {
                const container = containerRef.el;
                const target = containerEl.value?.querySelector(`[data-v-year="${model.value}"]`);
                if (!container || !target) return;
                const containerRect = container.getBoundingClientRect();
                const targetRect = target.getBoundingClientRect();
                container.scrollTop += targetRect.top - containerRect.top - container.clientHeight / 2 + targetRect.height / 2;
            }
            useRender(()=>vue.withDirectives(vue.createElementVNode("div", {
                    "class": "v-date-picker-years",
                    "ref": containerRef,
                    "tabindex": -1,
                    "style": {
                        height: convertToUnit(props.height)
                    }
                }, [
                    vue.createElementVNode("div", vue.mergeProps({
                        "class": "v-date-picker-years__content",
                        "style": {
                            '--v-date-picker-years-columns': props.columns
                        }
                    }, containerProps.value), [
                        years.value.map((year, i)=>{
                            const btnProps = {
                                id: `${uid}-year-${year.value}`,
                                active: model.value === year.value,
                                color: model.value === year.value ? props.color : undefined,
                                rounded: true,
                                tabindex: -1,
                                text: year.text,
                                disabled: year.isDisabled,
                                variant: model.value === year.value ? 'flat' : 'text',
                                'data-v-year': year.value,
                                onMousedown: (e)=>e.preventDefault(),
                                // preserve virtual focus
                                onClick: ()=>selectItem(year.value)
                            };
                            return slots.year?.({
                                year: year,
                                i: i,
                                props: btnProps
                            }) ?? vue.createVNode(VBtn, vue.mergeProps({
                                "key": "month"
                            }, btnProps), null);
                        })
                    ])
                ]), [
                    [
                        Intersect,
                        {
                            handler: scrollToSelected
                        },
                        null,
                        {
                            once: true
                        }
                    ]
                ]));
            return {};
        }
    });
    // Types
    // Types
    const makeVDatePickerProps = propsFactory({
        // TODO: implement in v3.5
        // calendarIcon: {
        //   type: String,
        //   default: '$calendar',
        // },
        // keyboardIcon: {
        //   type: String,
        //   default: '$edit',
        // },
        // inputMode: {
        //   type: String as PropType<'calendar' | 'keyboard'>,
        //   default: 'calendar',
        // },
        // inputText: {
        //   type: String,
        //   default: '$vuetify.datePicker.input.placeholder',
        // },
        // inputPlaceholder: {
        //   type: String,
        //   default: 'dd/mm/yyyy',
        // },
        header: {
            type: String,
            default: '$vuetify.datePicker.header'
        },
        headerColor: String,
        headerDateFormat: {
            type: String,
            default: 'normalDateWithWeekday'
        },
        landscapeHeaderWidth: [
            Number,
            String
        ],
        ...omit(makeVDatePickerControlsProps(), [
            'active',
            'monthText',
            'yearText'
        ]),
        ...makeVDatePickerMonthProps({
            weeksInMonth: 'static'
        }),
        ...omit(makeVDatePickerMonthsProps(), [
            'modelValue',
            'columns'
        ]),
        ...omit(makeVDatePickerYearsProps(), [
            'modelValue',
            'columns'
        ]),
        ...makeVPickerProps({
            title: '$vuetify.datePicker.title'
        }),
        modelValue: null
    }, 'VDatePicker');
    const VDatePicker = genericComponent()({
        name: 'VDatePicker',
        props: makeVDatePickerProps(),
        emits: {
            'update:modelValue': (date)=>true,
            'update:month': (date)=>true,
            'update:year': (date)=>true,
            'update:previewValue': (_value)=>true,
            // 'update:inputMode': (date: any) => true,
            'update:viewMode': (date)=>true,
            'boundary-navigate': (_payload)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const adapter = useDate();
            const { t: t } = useLocale();
            const { rtlClasses: rtlClasses } = useRtl();
            const model = useProxiedModel(props, 'modelValue', undefined, (v)=>wrapInArray(v).map((i)=>adapter.date(i)), (v)=>props.multiple ? v : v[0]);
            const viewMode = useProxiedModel(props, 'viewMode');
            // owns the hover preview so VDatePickerMonth isn't handed a prop nobody writes back
            const previewValue = useProxiedModel(props, 'previewValue');
            // const inputMode = useProxiedModel(props, 'inputMode')
            const { minDate: minDate, maxDate: maxDate, clampDate: clampDate } = useCalendarRange(props);
            const internal = vue.computed(()=>{
                const today = adapter.date();
                const value = model.value?.[0] ? adapter.date(model.value[0]) : clampDate(today);
                return value && adapter.isValid(value) ? value : today;
            });
            const headerColor = vue.toRef(()=>props.headerColor ?? props.color);
            const _month = useProxiedModel(props, 'month');
            const month = vue.computed({
                get: ()=>Number(_month.value ?? adapter.getMonth(adapter.startOfMonth(internal.value))),
                set: (v)=>_month.value = v
            });
            const _year = useProxiedModel(props, 'year');
            const year = vue.computed({
                get: ()=>Number(_year.value ?? adapter.getYear(adapter.startOfYear(adapter.setMonth(internal.value, month.value)))),
                set: (v)=>_year.value = v
            });
            const isReversing = vue.shallowRef(false);
            const header = vue.computed(()=>{
                if (props.multiple === 'range' && model.value.length === 2) {
                    const [startDate, endDate] = model.value;
                    const daysBetween = adapter.getDiff(endDate, startDate, 'days') + 1;
                    return t('$vuetify.datePicker.itemsSelected', daysBetween);
                }
                if (props.multiple && model.value.length > 1) return t('$vuetify.datePicker.itemsSelected', model.value.length);
                const formattedDate = model.value[0] && adapter.isValid(model.value[0]) ? adapter.format(adapter.date(model.value[0]), props.headerDateFormat) : t(props.header);
                return props.landscape && formattedDate.split(' ').length === 3 ? formattedDate.replace(' ', '\n') : formattedDate;
            });
            const monthStart = vue.toRef(()=>{
                let date = adapter.date();
                date = adapter.setDate(date, 1);
                date = adapter.setMonth(date, month.value);
                date = adapter.setYear(date, year.value); // year is not always ISO
                return date;
            });
            const monthYearText = vue.toRef(()=>adapter.format(monthStart.value, 'monthAndYear'));
            const monthText = vue.toRef(()=>adapter.format(monthStart.value, 'monthShort'));
            const yearText = vue.toRef(()=>adapter.format(monthStart.value, 'year'));
            // const headerIcon = toRef(() => props.inputMode === 'calendar' ? props.keyboardIcon : props.calendarIcon)
            const headerTransition = vue.toRef(()=>`date-picker-header${isReversing.value ? '-reverse' : ''}-transition`);
            const disabled = vue.computed(()=>{
                if (props.disabled) return true;
                const targets = [];
                if (viewMode.value !== 'month') targets.push(...[
                    'prev-month',
                    'next-month',
                    'prev-year',
                    'next-year'
                ]);
                else {
                    let _date = adapter.date();
                    _date = adapter.startOfMonth(_date);
                    _date = adapter.setMonth(_date, month.value);
                    _date = adapter.setYear(_date, year.value);
                    if (minDate.value) {
                        const prevMonthEnd = adapter.addDays(adapter.startOfMonth(_date), -1);
                        const prevYearEnd = adapter.addDays(adapter.startOfYear(_date), -1);
                        adapter.isAfter(minDate.value, prevMonthEnd) && targets.push('prev-month');
                        adapter.isAfter(minDate.value, prevYearEnd) && targets.push('prev-year');
                    }
                    if (maxDate.value) {
                        const nextMonthStart = adapter.addDays(adapter.endOfMonth(_date), 1);
                        const nextYearStart = adapter.addDays(adapter.endOfYear(_date), 1);
                        adapter.isAfter(nextMonthStart, maxDate.value) && targets.push('next-month');
                        adapter.isAfter(nextYearStart, maxDate.value) && targets.push('next-year');
                    }
                }
                return targets;
            });
            const allowedYears = vue.computed(()=>{
                return props.allowedYears || isYearAllowed;
            });
            const allowedMonths = vue.computed(()=>{
                return props.allowedMonths || isMonthAllowed;
            });
            function isAllowedInRange(start, end) {
                const allowedDates = props.allowedDates;
                if (typeof allowedDates !== 'function') return true;
                const days = 1 + daysDiff(adapter, start, end);
                for(let i = 0; i < days; i++){
                    if (allowedDates(adapter.addDays(start, i))) return true;
                }
                return false;
            }
            function isYearAllowed(year) {
                if (typeof props.allowedDates === 'function') {
                    const startOfYear = adapter.parseISO(`${year}-01-01`);
                    return isAllowedInRange(startOfYear, adapter.endOfYear(startOfYear));
                }
                if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                    for (const date of props.allowedDates){
                        if (adapter.getYear(adapter.date(date)) === year) return true;
                    }
                    return false;
                }
                return true;
            }
            function isMonthAllowed(month) {
                if (typeof props.allowedDates === 'function') {
                    const monthTwoDigits = String(month + 1).padStart(2, '0');
                    const startOfMonth = adapter.parseISO(`${year.value}-${monthTwoDigits}-01`);
                    return isAllowedInRange(startOfMonth, adapter.endOfMonth(startOfMonth));
                }
                if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                    for (const date of props.allowedDates){
                        if (adapter.getYear(adapter.date(date)) === year.value && adapter.getMonth(adapter.date(date)) === month) return true;
                    }
                    return false;
                }
                return true;
            }
            // function onClickAppend () {
            //   inputMode.value = inputMode.value === 'calendar' ? 'keyboard' : 'calendar'
            // }
            function onClickNextMonth() {
                if (month.value < 11) month.value++;
                else {
                    year.value++;
                    month.value = 0;
                    onUpdateYear();
                }
                onUpdateMonth();
            }
            function onClickPrevMonth() {
                if (month.value > 0) month.value--;
                else {
                    year.value--;
                    month.value = 11;
                    onUpdateYear();
                }
                onUpdateMonth();
            }
            function onClickNextYear() {
                year.value++;
                if (maxDate.value) {
                    const monthTwoDigits = String(month.value + 1).padStart(2, '0');
                    const monthStart = adapter.parseISO(`${year.value}-${monthTwoDigits}-01`);
                    if (adapter.isAfter(monthStart, maxDate.value)) month.value = adapter.getMonth(maxDate.value);
                }
                onUpdateYear();
            }
            function onClickPrevYear() {
                year.value--;
                if (minDate.value) {
                    const monthTwoDigits = String(month.value + 1).padStart(2, '0');
                    const monthStart = adapter.endOfMonth(adapter.parseISO(`${year.value}-${monthTwoDigits}-01`));
                    if (adapter.isAfter(minDate.value, monthStart)) month.value = adapter.getMonth(minDate.value);
                }
                onUpdateYear();
            }
            const monthGridRef = vue.shallowRef();
            function focusDate(isoDate) {
                monthGridRef.value?.focusItem(isoDate);
            }
            function onClickDate() {
                viewMode.value = 'month';
            }
            function onEscape() {
                viewMode.value = 'month';
                vue.nextTick(()=>monthGridRef.value?.focusGrid());
            }
            function onClickMonth() {
                viewMode.value = viewMode.value === 'months' ? 'month' : 'months';
            }
            function onClickYear() {
                viewMode.value = viewMode.value === 'year' ? 'month' : 'year';
            }
            function onUpdateMonth() {
                if (viewMode.value === 'months') onClickMonth();
            }
            function onUpdateYear() {
                if (viewMode.value === 'year') onClickYear();
            }
            vue.watch(model, (val, oldVal)=>{
                if (props.noAutoNavigation) return;
                const arrBefore = wrapInArray(oldVal);
                const arrAfter = wrapInArray(val);
                if (!arrAfter.length) return;
                const before = adapter.date(arrBefore[arrBefore.length - 1]);
                const after = adapter.date(arrAfter[arrAfter.length - 1]);
                if (adapter.isSameDay(before, after)) return;
                const newMonth = adapter.getMonth(after);
                const newYear = adapter.getYear(after);
                if (newMonth !== month.value) {
                    month.value = newMonth;
                    onUpdateMonth();
                }
                if (newYear !== year.value) {
                    year.value = newYear;
                    onUpdateYear();
                }
                isReversing.value = adapter.isBefore(before, after);
            });
            useRender(()=>{
                const pickerProps = VPicker.filterProps(props);
                const datePickerControlsProps = omit(VDatePickerControls.filterProps(props), [
                    'viewMode'
                ]);
                const datePickerHeaderProps = VDatePickerHeader.filterProps(props);
                const datePickerMonthProps = VDatePickerMonth.filterProps(props);
                const datePickerMonthsProps = omit(VDatePickerMonths.filterProps(props), [
                    'modelValue'
                ]);
                const datePickerYearsProps = omit(VDatePickerYears.filterProps(props), [
                    'modelValue'
                ]);
                const headerProps = {
                    color: headerColor.value,
                    header: header.value,
                    transition: headerTransition.value
                };
                return vue.createVNode(VPicker, vue.mergeProps(pickerProps, {
                    "color": headerColor.value,
                    "class": [
                        'v-date-picker',
                        `v-date-picker--${viewMode.value}`,
                        {
                            'v-date-picker--show-week': props.showWeek
                        },
                        rtlClasses.value,
                        props.class
                    ],
                    "style": [
                        {
                            '--v-date-picker-landscape-header-width': convertToUnit(props.landscapeHeaderWidth)
                        },
                        props.style
                    ]
                }), {
                    title: ()=>slots.title?.() ?? vue.createElementVNode("div", {
                            "class": "v-date-picker__title"
                        }, [
                            t(props.title)
                        ]),
                    header: ()=>slots.header ? vue.createVNode(VDefaultsProvider, {
                            "defaults": {
                                VDatePickerHeader: {
                                    ...headerProps
                                }
                            }
                        }, {
                            default: ()=>[
                                    slots.header?.(headerProps)
                                ]
                        }) : vue.createVNode(VDatePickerHeader, vue.mergeProps({
                            "key": "header"
                        }, datePickerHeaderProps, headerProps, {
                            "onClick": viewMode.value !== 'month' ? onClickDate : undefined
                        }), {
                            prepend: slots.prepend,
                            append: slots.append
                        }),
                    default: ()=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VDatePickerControls, vue.mergeProps(datePickerControlsProps, {
                                "disabled": disabled.value,
                                "viewMode": viewMode.value,
                                "text": monthYearText.value,
                                "monthText": monthText.value,
                                "yearText": yearText.value,
                                "onClick:next": onClickNextMonth,
                                "onClick:prev": onClickPrevMonth,
                                "onClick:nextYear": onClickNextYear,
                                "onClick:prevYear": onClickPrevYear,
                                "onClick:month": onClickMonth,
                                "onClick:year": onClickYear
                            }), {
                                default: slots.controls
                            }),
                            vue.createVNode(VFadeTransition, {
                                "hideOnLeave": true
                            }, {
                                default: ()=>[
                                        viewMode.value === 'months' ? vue.createVNode(VDatePickerMonths, vue.mergeProps({
                                            "key": "date-picker-months"
                                        }, datePickerMonthsProps, {
                                            "modelValue": month.value,
                                            "onUpdate:modelValue": [
                                                ($event)=>month.value = $event,
                                                onUpdateMonth
                                            ],
                                            "min": minDate.value,
                                            "max": maxDate.value,
                                            "year": year.value,
                                            "allowedMonths": allowedMonths.value,
                                            "onEscape": onEscape
                                        }), {
                                            month: slots.month
                                        }) : viewMode.value === 'year' ? vue.createVNode(VDatePickerYears, vue.mergeProps({
                                            "key": "date-picker-years"
                                        }, datePickerYearsProps, {
                                            "modelValue": year.value,
                                            "onUpdate:modelValue": [
                                                ($event)=>year.value = $event,
                                                onUpdateYear
                                            ],
                                            "min": minDate.value,
                                            "max": maxDate.value,
                                            "allowedYears": allowedYears.value,
                                            "onEscape": onEscape
                                        }), {
                                            year: slots.year
                                        }) : vue.createVNode(VDatePickerMonth, vue.mergeProps({
                                            "ref": monthGridRef,
                                            "key": "date-picker-month"
                                        }, datePickerMonthProps, {
                                            "modelValue": model.value,
                                            "onUpdate:modelValue": ($event)=>model.value = $event,
                                            "month": month.value,
                                            "onUpdate:month": [
                                                ($event)=>month.value = $event,
                                                onUpdateMonth
                                            ],
                                            "year": year.value,
                                            "onUpdate:year": [
                                                ($event)=>year.value = $event,
                                                onUpdateYear
                                            ],
                                            "previewValue": previewValue.value,
                                            "onUpdate:previewValue": ($event)=>previewValue.value = $event,
                                            "onBoundaryNavigate": (payload)=>emit('boundary-navigate', payload),
                                            "min": minDate.value,
                                            "max": maxDate.value
                                        }), {
                                            day: slots.day
                                        })
                                    ]
                            })
                        ]),
                    actions: slots.actions
                });
            });
            return {
                focusDate: focusDate
            };
        }
    });
    // Composables
    // Types
    // Types
    class DateFormatSpec {
        constructor(order, // mdy | dmy | ymd
        separator // / | - | .
        ){
            this.order = order;
            this.separator = separator;
        }
        get format() {
            return this.order.split('').map((sign)=>`${sign}${sign}`).join(this.separator).replace('yy', 'yyyy');
        }
        static canBeParsed(v) {
            if (typeof v !== 'string') return false;
            const lowercase = v.toLowerCase();
            return [
                'y',
                'm',
                'd'
            ].every((sign)=>lowercase.includes(sign)) && [
                '/',
                '-',
                '.'
            ].some((sign)=>v.includes(sign));
        }
        static parse(v) {
            if (!DateFormatSpec.canBeParsed(v)) throw new Error(`[${v}] cannot be parsed into date format specification`);
            const order = v.toLowerCase().split('').filter((c, i, all)=>'dmy'.includes(c) && all.indexOf(c) === i).join('');
            const separator = [
                '/',
                '-',
                '.'
            ].find((sign)=>v.includes(sign));
            return new DateFormatSpec(order, separator);
        }
    }
    const makeDateFormatProps = propsFactory({
        inputFormat: {
            type: String,
            validator: (v)=>!v || DateFormatSpec.canBeParsed(v)
        }
    }, 'date-format');
    function useDateFormat(props, locale) {
        const adapter = useDate();
        function inferFromLocale() {
            const localeForDateFormat = locale.value ?? 'en-US';
            const formatFromLocale = Intl.DateTimeFormat(localeForDateFormat, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).format(adapter.toJsDate(adapter.parseISO('1999-12-07'))).replace(/(07)|(٠٧)|(٢٩)|(۱۶)|(০৭)/, 'dd').replace(/(12)|(١٢)|(٠٨)|(۰۹)|(১২)/, 'mm').replace(/(1999)|(2542)|(١٩٩٩)|(١٤٢٠)|(۱۳۷۸)|(১৯৯৯)/, 'yyyy').replace(/[^ymd\-/.]/g, '').replace(/\.$/, '');
            if (!DateFormatSpec.canBeParsed(formatFromLocale)) {
                consoleWarn(`Date format inferred from locale [${localeForDateFormat}] is invalid: [${formatFromLocale}]`);
                return 'mm/dd/yyyy';
            }
            return formatFromLocale;
        }
        const currentFormat = vue.toRef(()=>{
            return DateFormatSpec.canBeParsed(props.inputFormat) ? DateFormatSpec.parse(props.inputFormat) : DateFormatSpec.parse(inferFromLocale());
        });
        function parseDate(dateString) {
            function parseDateParts(text) {
                const parts = text.trim().split(currentFormat.value.separator);
                return {
                    y: Number(parts[currentFormat.value.order.indexOf('y')]),
                    m: Number(parts[currentFormat.value.order.indexOf('m')]),
                    d: Number(parts[currentFormat.value.order.indexOf('d')])
                };
            }
            function validateDateParts(dateParts) {
                const { y: year, m: month, d: day } = dateParts;
                if (!year || !month || !day) return null;
                if (month < 1 || month > 12) return null;
                if (day < 1 || day > 31) return null;
                return {
                    year: autoFixYear(year),
                    month: month,
                    day: day
                };
            }
            function autoFixYear(year) {
                const currentYear = adapter.getYear(adapter.date());
                if (year > 100 || currentYear % 100 >= 50) return year;
                const currentCentury = ~~(currentYear / 100) * 100;
                return year < 50 ? currentCentury + year : currentCentury - 100 + year;
            }
            const dateParts = parseDateParts(dateString);
            const validatedParts = validateDateParts(dateParts);
            if (!validatedParts) return null;
            const { year: year, month: month, day: day } = validatedParts;
            const pad = (v)=>String(v).padStart(2, '0');
            return adapter.parseISO(`${year}-${pad(month)}-${pad(day)}`);
        }
        function isValid(text) {
            return !!parseDate(text);
        }
        function formatDate(value) {
            const parts = adapter.toISO(value).split('T')[0].split('-');
            return currentFormat.value.order.split('').map((sign)=>parts['ymd'.indexOf(sign)]).join(currentFormat.value.separator);
        }
        return {
            isValid: isValid,
            parseDate: parseDate,
            formatDate: formatDate,
            parserFormat: vue.toRef(()=>currentFormat.value.format)
        };
    }
    // Types
    // Types
    const makeVDateInputProps = propsFactory({
        displayFormat: {
            type: [
                Function,
                String
            ],
            default: undefined
        },
        location: {
            type: String,
            default: 'bottom start'
        },
        menu: Boolean,
        menuProps: Object,
        updateOn: {
            type: Array,
            default: ()=>[
                    'blur',
                    'enter'
                ]
        },
        pickerProps: Object,
        ...makeDateFormatProps(),
        ...makeDisplayProps({
            mobile: null
        }),
        ...makeFocusProps(),
        ...makeVConfirmEditProps({
            hideActions: true
        }),
        ...makeVTextFieldProps({
            prependIcon: '$calendar'
        }),
        ...omit(makeVDatePickerProps({
            hideHeader: true,
            showAdjacentMonths: true
        }), [
            'location',
            'rounded',
            'height',
            'minHeight',
            'maxHeight'
        ])
    }, 'VDateInput');
    const VDateInput = genericComponent()({
        name: 'VDateInput',
        props: makeVDateInputProps(),
        emits: {
            save: (value)=>true,
            cancel: ()=>true,
            'update:focused': (val)=>true,
            'update:modelValue': (val)=>true,
            'update:menu': (val)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const adapter = useDate();
            const adapterLocale = vue.computed(()=>adapter.locale);
            const { isValid: isValid, parseDate: parseDate, formatDate: formatDate, parserFormat: parserFormat } = useDateFormat(props, adapterLocale);
            const { mobile: mobile } = useDisplay(props);
            const { InputIcon: InputIcon } = useInputIcon(props);
            const { clampDate: clampDate, isInAllowedRange: isInAllowedRange } = useCalendarRange(props);
            const emptyModelValue = ()=>props.multiple ? [] : null;
            const model = useProxiedModel(props, 'modelValue', emptyModelValue(), (val)=>Array.isArray(val) ? val.map((item)=>adapter.toJsDate(item)) : val ? adapter.toJsDate(val) : val, (val)=>Array.isArray(val) ? val.map((item)=>adapter.date(item)) : val ? adapter.date(val) : val);
            const menu = useProxiedModel(props, 'menu');
            const isEditingInput = vue.shallowRef(false);
            const isFocused = vue.shallowRef(props.focused);
            const vTextFieldRef = vue.ref();
            const disabledActions = vue.ref([
                'save'
            ]);
            function format(date) {
                if (typeof props.displayFormat === 'function') return props.displayFormat(date);
                if (props.displayFormat) return adapter.format(date, props.displayFormat ?? 'keyboardDate');
                return formatDate(date);
            }
            const display = vue.computed(()=>{
                const value = wrapInArray(model.value);
                if (!value.length) return null;
                if (props.multiple === true) return t('$vuetify.datePicker.itemsSelected', value.length);
                if (props.multiple === 'range') {
                    const start = value[0];
                    const end = value[value.length - 1];
                    if (!adapter.isValid(start) || !adapter.isValid(end)) return '';
                    return `${format(adapter.date(start))} - ${format(adapter.date(end))}`;
                }
                return adapter.isValid(model.value) ? format(adapter.date(model.value)) : '';
            });
            const inputmode = vue.computed(()=>{
                if (!mobile.value) return undefined;
                if (isEditingInput.value) return 'text';
                return 'none';
            });
            const isInteractive = vue.computed(()=>!props.disabled && !props.readonly);
            const isReadonly = vue.computed(()=>{
                if (!props.updateOn.length) return true;
                return !(mobile.value && isEditingInput.value) && props.readonly;
            });
            vue.watch(menu, (val)=>{
                if (val) return;
                isEditingInput.value = false;
                disabledActions.value = [
                    'save'
                ];
            });
            function onKeydown(e) {
                if (e.key !== 'Enter') return;
                if (!menu.value || !isFocused.value) menu.value = true;
                if (props.updateOn.includes('enter') && !props.readonly) onUserInput(e.target);
            }
            function onClick(e) {
                if (props.disabled) return;
                e.preventDefault();
                e.stopPropagation();
                if (menu.value && mobile.value) isEditingInput.value = !props.readonly;
                else menu.value = true;
            }
            function onCancel() {
                emit('cancel');
                menu.value = false;
                isEditingInput.value = false;
            }
            function onSave(value) {
                emit('save', value);
                menu.value = false;
            }
            function onUpdateDisplayModel(value) {
                if (value != null) return;
                model.value = emptyModelValue();
            }
            function onBlur(e) {
                if (e.relatedTarget?.closest('[data-v-date]')) return; // first click on a day
                if (props.updateOn.includes('blur') && !props.readonly) onUserInput(e.target);
                // When in mobile mode and editing is done (due to keyboard dismissal), close the menu
                if (mobile.value && isEditingInput.value && !isFocused.value) {
                    menu.value = false;
                    isEditingInput.value = false;
                }
            }
            function onUserInput({ value: value }) {
                if (!value.trim()) model.value = emptyModelValue();
                else if (!props.multiple) {
                    if (isValid(value)) model.value = clampDate(parseDate(value));
                } else {
                    const parts = value.trim().split(/\D+-\D+|[^\d\-/.]+/);
                    if (parts.every(isValid)) {
                        if (props.multiple === 'range') {
                            const [start, stop] = parts.map(parseDate).map(clampDate).toSorted((a, b)=>adapter.isAfter(a, b) ? 1 : -1);
                            model.value = stop == null ? [
                                start
                            ] : [
                                start,
                                adapter.endOfDay(stop)
                            ];
                        } else model.value = parts.map(parseDate).filter(isInAllowedRange);
                    }
                }
            }
            useRender(()=>{
                const hasPrepend = !!(props.prependIcon || slots.prepend);
                const confirmEditProps = VConfirmEdit.filterProps(props);
                const datePickerProps = {
                    ...VDatePicker.filterProps(omit(props, [
                        'active',
                        'bgColor',
                        'color',
                        'location',
                        'rounded',
                        'maxWidth',
                        'minWidth',
                        'width'
                    ])),
                    ...props.pickerProps
                };
                const datePickerSlots = pick(slots, [
                    'title',
                    'header',
                    'day',
                    'month',
                    'year'
                ]);
                const textFieldProps = VTextField.filterProps(omit(props, [
                    'placeholder'
                ]));
                return vue.createVNode(VTextField, vue.mergeProps({
                    "ref": vTextFieldRef
                }, textFieldProps, {
                    "class": [
                        'v-date-input',
                        props.class
                    ],
                    "style": props.style,
                    "modelValue": display.value,
                    "inputmode": inputmode.value,
                    "placeholder": props.placeholder ?? parserFormat.value,
                    "readonly": isReadonly.value,
                    "onKeydown": isInteractive.value ? onKeydown : undefined,
                    "focused": menu.value || isFocused.value,
                    "onBlur": onBlur,
                    "validationValue": model.value,
                    "onClick:control": onClick,
                    "onUpdate:modelValue": onUpdateDisplayModel,
                    "onUpdate:focused": (event)=>isFocused.value = event
                }), {
                    ...slots,
                    default: ()=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VMenu, vue.mergeProps({
                                "modelValue": menu.value,
                                "onUpdate:modelValue": ($event)=>menu.value = $event,
                                "activator": "parent",
                                "minWidth": "0",
                                "eager": isFocused.value,
                                "location": props.location,
                                "closeOnContentClick": false,
                                "openOnClick": false
                            }, props.menuProps), {
                                default: ()=>[
                                        vue.createVNode(VConfirmEdit, vue.mergeProps(confirmEditProps, {
                                            "modelValue": model.value,
                                            "onUpdate:modelValue": ($event)=>model.value = $event,
                                            "disabled": disabledActions.value,
                                            "onSave": onSave,
                                            "onCancel": onCancel
                                        }), {
                                            default: ({ actions: actions, model: proxyModel, save: save, cancel: cancel, isPristine: isPristine })=>{
                                                function onUpdateModel(value) {
                                                    if (!props.hideActions) proxyModel.value = value;
                                                    else {
                                                        model.value = value;
                                                        if (!props.multiple) menu.value = false;
                                                    }
                                                    emit('save', value);
                                                    disabledActions.value = [];
                                                }
                                                return vue.createVNode(VDatePicker, vue.mergeProps(datePickerProps, {
                                                    "modelValue": props.hideActions ? model.value : proxyModel.value,
                                                    "onUpdate:modelValue": (value)=>onUpdateModel(value),
                                                    "onMousedown": (e)=>e.preventDefault()
                                                }), {
                                                    ...datePickerSlots,
                                                    actions: !props.hideActions ? ()=>slots.actions?.({
                                                            save: save,
                                                            cancel: cancel,
                                                            isPristine: isPristine
                                                        }) ?? actions() : undefined
                                                });
                                            }
                                        })
                                    ]
                            }),
                            slots.default?.()
                        ]),
                    prepend: hasPrepend ? (prependSlotProps)=>slots.prepend ? slots.prepend(prependSlotProps) : props.prependIcon && vue.createVNode(InputIcon, {
                            "key": "prepend-icon",
                            "name": "prepend",
                            "tabindex": props['onClick:prepend'] ? undefined : -1,
                            "onClick": isInteractive.value ? onClick : undefined
                        }, null) : undefined
                });
            });
            return forwardRefs({}, vTextFieldRef);
        }
    });
    // Types
    // Types
    const makeVEmptyStateProps = propsFactory({
        actionText: String,
        bgColor: String,
        color: String,
        icon: IconValue,
        image: String,
        justify: {
            type: String,
            default: 'center'
        },
        headline: String,
        title: String,
        text: String,
        textWidth: {
            type: [
                Number,
                String
            ],
            default: 500
        },
        href: String,
        to: String,
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeSizeProps({
            size: undefined
        }),
        ...makeThemeProps()
    }, 'VEmptyState');
    const VEmptyState = genericComponent()({
        name: 'VEmptyState',
        props: makeVEmptyStateProps(),
        emits: {
            'click:action': (e)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { displayClasses: displayClasses } = useDisplay();
            function onClickAction(e) {
                emit('click:action', e);
            }
            useRender(()=>{
                const hasActions = !!(slots.actions || props.actionText);
                const hasHeadline = !!(slots.headline || props.headline);
                const hasTitle = !!(slots.title || props.title);
                const hasText = !!(slots.text || props.text);
                const hasMedia = !!(slots.media || props.image || props.icon);
                const size = props.size || (props.image ? 200 : 96);
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-empty-state',
                        {
                            [`v-empty-state--${props.justify}`]: true
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        displayClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        dimensionStyles.value,
                        props.style
                    ])
                }, [
                    hasMedia && vue.createElementVNode("div", {
                        "key": "media",
                        "class": "v-empty-state__media"
                    }, [
                        !slots.media ? vue.createElementVNode(vue.Fragment, null, [
                            props.image ? vue.createVNode(VImg, {
                                "key": "image",
                                "src": props.image,
                                "height": size
                            }, null) : props.icon ? vue.createVNode(VIcon, {
                                "key": "icon",
                                "color": props.color,
                                "size": size,
                                "icon": props.icon
                            }, null) : undefined
                        ]) : vue.createVNode(VDefaultsProvider, {
                            "key": "media-defaults",
                            "defaults": {
                                VImg: {
                                    src: props.image,
                                    height: size
                                },
                                VIcon: {
                                    size: size,
                                    icon: props.icon
                                }
                            }
                        }, {
                            default: ()=>[
                                    slots.media()
                                ]
                        })
                    ]),
                    hasHeadline && vue.createElementVNode("div", {
                        "key": "headline",
                        "class": "v-empty-state__headline"
                    }, [
                        slots.headline?.() ?? props.headline
                    ]),
                    hasTitle && vue.createElementVNode("div", {
                        "key": "title",
                        "class": "v-empty-state__title"
                    }, [
                        slots.title?.() ?? props.title
                    ]),
                    hasText && vue.createElementVNode("div", {
                        "key": "text",
                        "class": "v-empty-state__text",
                        "style": {
                            maxWidth: convertToUnit(props.textWidth)
                        }
                    }, [
                        slots.text?.() ?? props.text
                    ]),
                    slots.default && vue.createElementVNode("div", {
                        "key": "content",
                        "class": "v-empty-state__content"
                    }, [
                        slots.default()
                    ]),
                    hasActions && vue.createElementVNode("div", {
                        "key": "actions",
                        "class": "v-empty-state__actions"
                    }, [
                        vue.createVNode(VDefaultsProvider, {
                            "defaults": {
                                VBtn: {
                                    class: 'v-empty-state__action-btn',
                                    color: props.color ?? 'surface-variant',
                                    href: props.href,
                                    text: props.actionText,
                                    to: props.to
                                }
                            }
                        }, {
                            default: ()=>[
                                    slots.actions?.({
                                        props: {
                                            onClick: onClickAction
                                        }
                                    }) ?? vue.createVNode(VBtn, {
                                        "onClick": onClickAction
                                    }, null)
                                ]
                        })
                    ])
                ]);
            });
            return {};
        }
    });
    // Types
    const VExpansionPanelSymbol = Symbol.for('vuetify:v-expansion-panel');
    const makeVExpansionPanelTextProps = propsFactory({
        ...makeComponentProps(),
        ...makeLazyProps()
    }, 'VExpansionPanelText');
    const VExpansionPanelText = genericComponent()({
        name: 'VExpansionPanelText',
        props: makeVExpansionPanelTextProps(),
        setup (props, { slots: slots }) {
            const expansionPanel = vue.inject(VExpansionPanelSymbol);
            if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel');
            const { hasContent: hasContent, onAfterLeave: onAfterLeave } = useLazy(props, expansionPanel.isSelected);
            useRender(()=>vue.createVNode(VExpandTransition, {
                    "onAfterLeave": onAfterLeave
                }, {
                    default: ()=>[
                            vue.withDirectives(vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    'v-expansion-panel-text',
                                    props.class
                                ]),
                                "style": vue.normalizeStyle(props.style)
                            }, [
                                slots.default && hasContent.value && vue.createElementVNode("div", {
                                    "class": "v-expansion-panel-text__wrapper"
                                }, [
                                    slots.default?.()
                                ])
                            ]), [
                                [
                                    vue.vShow,
                                    expansionPanel.isSelected.value
                                ]
                            ])
                        ]
                }));
            return {};
        }
    });
    // Types
    const makeVExpansionPanelTitleProps = propsFactory({
        color: String,
        expandIcon: {
            type: IconValue,
            default: '$expand'
        },
        collapseIcon: {
            type: IconValue,
            default: '$collapse'
        },
        hideActions: Boolean,
        focusable: Boolean,
        static: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: false
        },
        readonly: Boolean,
        hover: {
            type: Boolean,
            default: true
        },
        ...makeComponentProps(),
        ...makeDimensionProps()
    }, 'VExpansionPanelTitle');
    const VExpansionPanelTitle = genericComponent()({
        name: 'VExpansionPanelTitle',
        directives: {
            vRipple: Ripple
        },
        props: makeVExpansionPanelTitleProps(),
        setup (props, { slots: slots }) {
            const expansionPanel = vue.inject(VExpansionPanelSymbol);
            if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel');
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const slotProps = vue.computed(()=>({
                    collapseIcon: props.collapseIcon,
                    disabled: expansionPanel.disabled.value,
                    expanded: expansionPanel.isSelected.value,
                    expandIcon: props.expandIcon,
                    readonly: props.readonly
                }));
            const icon = vue.toRef(()=>expansionPanel.isSelected.value ? props.collapseIcon : props.expandIcon);
            useRender(()=>vue.withDirectives(vue.createElementVNode("button", {
                    "class": vue.normalizeClass([
                        'v-expansion-panel-title',
                        {
                            'v-expansion-panel-title--active': expansionPanel.isSelected.value,
                            'v-expansion-panel-title--focusable': props.focusable,
                            'v-expansion-panel-title--static': props.static,
                            'v-expansion-panel-title--hover': props.hover
                        },
                        backgroundColorClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        dimensionStyles.value,
                        props.style
                    ]),
                    "type": "button",
                    "tabindex": expansionPanel.disabled.value ? -1 : undefined,
                    "disabled": expansionPanel.disabled.value,
                    "aria-expanded": expansionPanel.isSelected.value,
                    "onClick": !props.readonly ? expansionPanel.toggle : undefined
                }, [
                    vue.createElementVNode("span", {
                        "class": "v-expansion-panel-title__overlay"
                    }, null),
                    slots.default?.(slotProps.value),
                    !props.hideActions && vue.createVNode(VDefaultsProvider, {
                        "defaults": {
                            VIcon: {
                                icon: icon.value
                            }
                        }
                    }, {
                        default: ()=>[
                                vue.createElementVNode("span", {
                                    "class": "v-expansion-panel-title__icon"
                                }, [
                                    slots.actions?.(slotProps.value) ?? vue.createVNode(VIcon, null, null)
                                ])
                            ]
                    })
                ]), [
                    [
                        Ripple,
                        props.ripple
                    ]
                ]));
            return {};
        }
    });
    const makeVExpansionPanelProps = propsFactory({
        title: String,
        text: String,
        bgColor: String,
        ...makeElevationProps(),
        ...makeGroupItemProps(),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeVExpansionPanelTitleProps(),
        ...makeVExpansionPanelTextProps()
    }, 'VExpansionPanel');
    const VExpansionPanel = genericComponent()({
        name: 'VExpansionPanel',
        props: makeVExpansionPanelProps(),
        emits: {
            'group:selected': (val)=>true
        },
        setup (props, { slots: slots }) {
            const groupItem = useGroupItem(props, VExpansionPanelSymbol);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const isDisabled = vue.toRef(()=>groupItem?.disabled.value || props.disabled);
            const selectedIndices = vue.computed(()=>groupItem.group.items.value.reduce((arr, item, index)=>{
                    if (groupItem.group.selected.value.includes(item.id)) arr.push(index);
                    return arr;
                }, []));
            const isBeforeSelected = vue.computed(()=>{
                const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
                return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === 1);
            });
            const isAfterSelected = vue.computed(()=>{
                const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
                return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === -1);
            });
            vue.provide(VExpansionPanelSymbol, groupItem);
            useRender(()=>{
                const hasText = !!(slots.text || props.text);
                const hasTitle = !!(slots.title || props.title);
                const expansionPanelTitleProps = VExpansionPanelTitle.filterProps(props);
                const expansionPanelTextProps = VExpansionPanelText.filterProps(props);
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-expansion-panel',
                        {
                            'v-expansion-panel--active': groupItem.isSelected.value,
                            'v-expansion-panel--before-active': isBeforeSelected.value,
                            'v-expansion-panel--after-active': isAfterSelected.value,
                            'v-expansion-panel--disabled': isDisabled.value
                        },
                        roundedClasses.value,
                        backgroundColorClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    'v-expansion-panel__shadow',
                                    ...elevationClasses.value
                                ])
                            }, null),
                            vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VExpansionPanelTitle: {
                                        ...expansionPanelTitleProps
                                    },
                                    VExpansionPanelText: {
                                        ...expansionPanelTextProps
                                    }
                                }
                            }, {
                                default: ()=>[
                                        hasTitle && vue.createVNode(VExpansionPanelTitle, {
                                            "key": "title"
                                        }, {
                                            default: ()=>[
                                                    slots.title ? slots.title() : props.title
                                                ]
                                        }),
                                        hasText && vue.createVNode(VExpansionPanelText, {
                                            "key": "text"
                                        }, {
                                            default: ()=>[
                                                    slots.text ? slots.text() : props.text
                                                ]
                                        }),
                                        slots.default?.()
                                    ]
                            })
                        ]
                });
            });
            return {
                groupItem: groupItem
            };
        }
    });
    // Types
    const allowedVariants = [
        'default',
        'accordion',
        'inset',
        'popout'
    ];
    const makeVExpansionPanelsProps = propsFactory({
        flat: Boolean,
        gap: [
            String,
            Number
        ],
        noDivider: Boolean,
        rounded: [
            Boolean,
            Number,
            String,
            Array
        ],
        ...makeGroupProps(),
        ...pick(makeVExpansionPanelProps(), [
            'bgColor',
            'collapseIcon',
            'color',
            'eager',
            'elevation',
            'expandIcon',
            'focusable',
            'hideActions',
            'hover',
            'readonly',
            'ripple',
            'static',
            'tile'
        ]),
        ...makeThemeProps(),
        ...makeComponentProps(),
        ...makeTagProps(),
        variant: {
            type: String,
            default: 'default',
            validator: (v)=>allowedVariants.includes(v)
        }
    }, 'VExpansionPanels');
    const VExpansionPanels = genericComponent()({
        name: 'VExpansionPanels',
        props: makeVExpansionPanelsProps(),
        emits: {
            'update:modelValue': (val)=>true
        },
        setup (props, { slots: slots }) {
            const { next: next, prev: prev } = useGroup(props, VExpansionPanelSymbol);
            const { themeClasses: themeClasses } = provideTheme(props);
            const outerRounded = vue.toRef(()=>Array.isArray(props.rounded) ? props.rounded[0] : props.rounded);
            const innerRounded = vue.toRef(()=>Array.isArray(props.rounded) ? props.rounded[1] : undefined);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(outerRounded);
            const variantClass = vue.toRef(()=>props.variant && `v-expansion-panels--variant-${props.variant}`);
            provideDefaults({
                VExpansionPanel: {
                    bgColor: vue.toRef(()=>props.bgColor),
                    collapseIcon: vue.toRef(()=>props.collapseIcon),
                    color: vue.toRef(()=>props.color),
                    eager: vue.toRef(()=>props.eager),
                    elevation: vue.toRef(()=>props.elevation),
                    expandIcon: vue.toRef(()=>props.expandIcon),
                    focusable: vue.toRef(()=>props.focusable),
                    hideActions: vue.toRef(()=>props.hideActions),
                    hover: vue.toRef(()=>props.hover),
                    readonly: vue.toRef(()=>props.readonly),
                    ripple: vue.toRef(()=>props.ripple),
                    static: vue.toRef(()=>props.static)
                }
            });
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-expansion-panels',
                        {
                            'v-expansion-panels--flat': props.flat,
                            'v-expansion-panels--tile': props.tile,
                            'v-expansion-panels--no-divider': props.noDivider || !!props.gap
                        },
                        themeClasses.value,
                        roundedClasses.value,
                        variantClass.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        roundedStyles.value,
                        {
                            '--v-expansion-panels-inner-radius': convertToUnit(innerRounded.value),
                            gap: props.gap ? convertToUnit(props.gap) : undefined
                        },
                        props.style
                    ])
                }, {
                    default: ()=>[
                            slots.default?.({
                                prev: prev,
                                next: next
                            })
                        ]
                }));
            return {
                next: next,
                prev: prev
            };
        }
    });
    // Types
    const makeVFabProps = propsFactory({
        app: Boolean,
        appear: Boolean,
        extended: Boolean,
        layout: Boolean,
        offset: Boolean,
        modelValue: {
            type: Boolean,
            default: true
        },
        ...omit(makeVBtnProps({
            active: true
        }), [
            'location',
            'spaced'
        ]),
        ...makeLayoutItemProps(),
        ...makeLocationProps(),
        ...makeTransitionProps({
            transition: 'fab-transition'
        })
    }, 'VFab');
    const VFab = genericComponent()({
        name: 'VFab',
        props: makeVFabProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const height = vue.shallowRef(56);
            const layoutItemStyles = vue.ref();
            const { resizeRef: resizeRef } = useResizeObserver((entries)=>{
                if (!entries.length) return;
                height.value = entries[0].target.clientHeight;
            });
            const hasPosition = vue.toRef(()=>props.app || props.absolute);
            const position = vue.computed(()=>{
                if (!hasPosition.value) return false;
                return props.location?.split(' ').shift() ?? 'bottom';
            });
            const orientation = vue.computed(()=>{
                if (!hasPosition.value) return false;
                return props.location?.split(' ')[1] ?? 'end';
            });
            useToggleScope(()=>props.app, ()=>{
                const layout = useLayoutItem({
                    id: props.name,
                    order: vue.computed(()=>parseInt(props.order, 10)),
                    position: position,
                    layoutSize: vue.computed(()=>props.layout ? height.value + 24 : 0),
                    elementSize: vue.computed(()=>height.value + 24),
                    active: vue.computed(()=>props.app && model.value),
                    absolute: vue.toRef(()=>props.absolute)
                });
                vue.watchEffect(()=>{
                    layoutItemStyles.value = layout.layoutItemStyles.value;
                });
            });
            const vFabRef = vue.ref();
            useRender(()=>{
                const btnProps = VBtn.filterProps(props);
                return vue.createElementVNode("div", {
                    "ref": vFabRef,
                    "class": vue.normalizeClass([
                        'v-fab',
                        {
                            'v-fab--absolute': props.absolute,
                            'v-fab--app': !!props.app,
                            'v-fab--extended': props.extended,
                            'v-fab--offset': props.offset,
                            [`v-fab--${position.value}`]: hasPosition.value,
                            [`v-fab--${orientation.value}`]: hasPosition.value
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        props.app ? {
                            ...layoutItemStyles.value
                        } : {
                            height: props.absolute ? '100%' : 'inherit'
                        },
                        props.style
                    ])
                }, [
                    vue.createElementVNode("div", {
                        "class": "v-fab__container"
                    }, [
                        vue.createVNode(MaybeTransition, {
                            "appear": props.appear,
                            "transition": props.transition
                        }, {
                            default: ()=>[
                                    vue.withDirectives(vue.createVNode(VBtn, vue.mergeProps({
                                        "ref": resizeRef
                                    }, btnProps, {
                                        "active": undefined,
                                        "location": undefined
                                    }), slots), [
                                        [
                                            vue.vShow,
                                            props.active
                                        ]
                                    ])
                                ]
                        })
                    ])
                ]);
            });
            return {};
        }
    });
    // Types
    function useFileDrop() {
        function getTransfer(e) {
            return e.dataTransfer ?? e.clipboardData ?? null;
        }
        function hasFilesOrFolders(e) {
            const transfer = getTransfer(e);
            const entries = [
                ...transfer?.items ?? []
            ].filter((x)=>x.kind === 'file').map((x)=>x.webkitGetAsEntry()).filter(Boolean);
            return entries.length > 0 || [
                ...transfer?.files ?? []
            ].length > 0;
        }
        async function handleDrop(e) {
            const transfer = getTransfer(e);
            const result = [];
            const entries = [
                ...transfer?.items ?? []
            ].filter((x)=>x.kind === 'file').map((x)=>x.webkitGetAsEntry()).filter(Boolean);
            if (entries.length) for (const entry of entries){
                const files = await traverseFileTree(entry, appendIfDirectory('.', entry));
                result.push(...files.map((x)=>x.file));
            }
            else result.push(...[
                ...transfer?.files ?? []
            ]);
            return result;
        }
        return {
            handleDrop: handleDrop,
            hasFilesOrFolders: hasFilesOrFolders
        };
    }
    function traverseFileTree(item, path = '') {
        return new Promise((resolve, reject)=>{
            if (item.isFile) {
                const fileEntry = item;
                fileEntry.file((file)=>resolve([
                        {
                            file: file,
                            path: path
                        }
                    ]), reject);
            } else if (item.isDirectory) {
                const directoryReader = item.createReader();
                directoryReader.readEntries(async (entries)=>{
                    const files = [];
                    for (const entry of entries)files.push(...await traverseFileTree(entry, appendIfDirectory(path, entry)));
                    resolve(files);
                });
            }
        });
    }
    function appendIfDirectory(path, item) {
        return item.isDirectory ? `${path}/${item.name}` : path;
    }
    // Utilities
    // Composables
    const makeFileFilterProps = propsFactory({
        filterByType: String
    }, 'file-accept');
    function useFileFilter(props) {
        const fileFilter = vue.computed(()=>props.filterByType ? createFilter(props.filterByType) : null);
        function filterAccepted(files) {
            if (fileFilter.value) {
                const accepted = files.filter(fileFilter.value);
                return {
                    accepted: accepted,
                    rejected: files.filter((f)=>!accepted.includes(f))
                };
            }
            return {
                accepted: files,
                rejected: []
            };
        }
        return {
            filterAccepted: filterAccepted
        };
    }
    function createFilter(v) {
        const types = v.split(',').map((x)=>x.trim().toLowerCase());
        const extensionsToMatch = types.filter((x)=>x.startsWith('.'));
        const wildcards = types.filter((x)=>x.endsWith('/*'));
        const typesToMatch = types.filter((x)=>!extensionsToMatch.includes(x) && !wildcards.includes(x));
        return (file)=>{
            const extension = file.name.split('.').at(-1)?.toLowerCase() ?? '';
            const typeGroup = file.type.split('/').at(0)?.toLowerCase() ?? '';
            return typesToMatch.includes(file.type) || extensionsToMatch.includes(`.${extension}`) || wildcards.includes(`${typeGroup}/*`);
        };
    }
    // Types
    const makeVFileInputProps = propsFactory({
        chips: Boolean,
        counter: Boolean,
        counterSizeString: {
            type: String,
            default: '$vuetify.fileInput.counterSize'
        },
        counterString: {
            type: String,
            default: '$vuetify.fileInput.counter'
        },
        hideInput: Boolean,
        multiple: Boolean,
        showSize: {
            type: [
                Boolean,
                Number,
                String
            ],
            default: false,
            validator: (v)=>{
                return typeof v === 'boolean' || [
                    1000,
                    1024
                ].includes(Number(v));
            }
        },
        truncateLength: {
            type: [
                Number,
                String
            ],
            default: 22
        },
        ...omit(makeVInputProps({
            prependIcon: '$file'
        }), [
            'direction'
        ]),
        modelValue: {
            type: [
                Array,
                Object
            ],
            default: (props)=>props.multiple ? [] : null,
            validator: (val)=>{
                return wrapInArray(val).every((v)=>v != null && typeof v === 'object');
            }
        },
        ...makeFileFilterProps(),
        ...makeVFieldProps({
            clearable: true
        })
    }, 'VFileInput');
    const VFileInput = genericComponent()({
        name: 'VFileInput',
        inheritAttrs: false,
        props: makeVFileInputProps(),
        emits: {
            'click:control': (e)=>true,
            'mousedown:control': (e)=>true,
            'update:focused': (focused)=>true,
            'update:modelValue': (files)=>true,
            rejected: (files)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const { filterAccepted: filterAccepted } = useFileFilter(props);
            const model = useProxiedModel(props, 'modelValue', props.modelValue, (val)=>wrapInArray(val), (val)=>!props.multiple && Array.isArray(val) ? val[0] : val);
            const { isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const base = vue.computed(()=>typeof props.showSize !== 'boolean' ? props.showSize : undefined);
            const totalBytes = vue.computed(()=>(model.value ?? []).reduce((bytes, { size: size = 0 })=>bytes + size, 0));
            const totalBytesReadable = vue.computed(()=>humanReadableFileSize(totalBytes.value, base.value));
            const fileNames = vue.computed(()=>(model.value ?? []).map((file)=>{
                    const { name: name = '', size: size = 0 } = file;
                    const truncatedText = truncateText(name);
                    return !props.showSize ? truncatedText : `${truncatedText} (${humanReadableFileSize(size, base.value)})`;
                }));
            const counterValue = vue.computed(()=>{
                const fileCount = model.value?.length ?? 0;
                if (props.showSize) return t(props.counterSizeString, fileCount, totalBytesReadable.value);
                else return t(props.counterString, fileCount);
            });
            const vInputRef = vue.ref();
            const vFieldRef = vue.ref();
            const inputRef = vue.ref();
            const isActive = vue.toRef(()=>isFocused.value || props.active);
            const isPlainOrUnderlined = vue.computed(()=>[
                    'plain',
                    'underlined'
                ].includes(props.variant));
            const isDragging = vue.shallowRef(false);
            const { handleDrop: handleDrop, hasFilesOrFolders: hasFilesOrFolders } = useFileDrop();
            function onFocus() {
                if (inputRef.value !== getActiveElement()) inputRef.value?.focus();
                if (!isFocused.value) focus();
            }
            function onClickPrepend(e) {
                inputRef.value?.click();
            }
            function onControlMousedown(e) {
                emit('mousedown:control', e);
            }
            function onControlClick(e) {
                inputRef.value?.click();
                emit('click:control', e);
            }
            function onClear(e) {
                e.stopPropagation();
                onFocus();
                vue.nextTick(()=>{
                    model.value = [];
                    callEvent(props['onClick:clear'], e);
                });
            }
            function truncateText(str) {
                if (str.length < Number(props.truncateLength)) return str;
                const charsKeepOneSide = Math.floor((Number(props.truncateLength) - 1) / 2);
                return `${str.slice(0, charsKeepOneSide)}\u{2026}${str.slice(str.length - charsKeepOneSide)}`;
            }
            function onDragover(e) {
                if (props.disabled || props.readonly) return;
                e.preventDefault();
                e.stopImmediatePropagation();
                isDragging.value = true;
            }
            function onDragleave(e) {
                e.preventDefault();
                isDragging.value = false;
            }
            async function onDrop(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                isDragging.value = false;
                if (!inputRef.value || props.disabled || props.readonly || !hasFilesOrFolders(e)) return;
                const allDroppedFiles = await handleDrop(e);
                selectAccepted(allDroppedFiles);
            }
            async function onPaste(e) {
                if (!inputRef.value || props.disabled || props.readonly || !hasFilesOrFolders(e)) return;
                e.preventDefault();
                const files = await handleDrop(e);
                if (files.length) selectAccepted(files);
            }
            function onFileSelection(e) {
                if (!e.target || e.repack) return; // prevent loop
                if (!props.filterByType) {
                    const target = e.target;
                    model.value = [
                        ...target.files ?? []
                    ];
                } else selectAccepted([
                    ...e.target.files
                ]);
            }
            function selectAccepted(files) {
                const dataTransfer = new DataTransfer();
                const { accepted: accepted, rejected: rejected } = filterAccepted(files);
                if (rejected.length) emit('rejected', rejected);
                for (const file of accepted)dataTransfer.items.add(file);
                inputRef.value.files = dataTransfer.files;
                model.value = [
                    ...dataTransfer.files
                ];
                const event = new Event('change', {
                    bubbles: true
                });
                event.repack = true;
                inputRef.value.dispatchEvent(event);
            }
            vue.watch(model, (newValue)=>{
                const hasModelReset = !Array.isArray(newValue) || !newValue.length;
                if (hasModelReset && inputRef.value) inputRef.value.value = '';
            });
            useRender(()=>{
                const hasCounter = !!(slots.counter || props.counter);
                const hasDetails = props.hideDetails !== true && !!(slots.details || hasCounter && (props.hideDetails === false || model.value?.length));
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                const { modelValue: _, ...inputProps } = VInput.filterProps(props);
                const fieldProps = {
                    ...VField.filterProps(props),
                    'onClick:clear': onClear
                };
                const expectsDirectory = attrs.webkitdirectory !== undefined && attrs.webkitdirectory !== false;
                const acceptFallback = attrs.accept ? String(attrs.accept) : undefined;
                const inputAccept = expectsDirectory ? undefined : props.filterByType ?? acceptFallback;
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": vInputRef,
                    "modelValue": props.multiple ? model.value : model.value[0],
                    "class": [
                        'v-file-input',
                        {
                            'v-file-input--chips': !!props.chips,
                            'v-file-input--dragging': isDragging.value,
                            'v-file-input--hide': props.hideInput,
                            'v-input--plain-underlined': isPlainOrUnderlined.value
                        },
                        props.class
                    ],
                    "style": props.style,
                    "onClick:prepend": onClickPrepend
                }, rootAttrs, inputProps, {
                    "centerAffix": !isPlainOrUnderlined.value,
                    "focused": isFocused.value,
                    "indentDetails": props.indentDetails ?? !isPlainOrUnderlined.value
                }), {
                    ...slots,
                    default: ({ id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails })=>vue.createVNode(VField, vue.mergeProps({
                            "ref": vFieldRef,
                            "prependIcon": props.prependIcon,
                            "onMousedown": onControlMousedown,
                            "onClick": onControlClick,
                            "onClick:prependInner": props['onClick:prependInner'],
                            "onClick:appendInner": props['onClick:appendInner']
                        }, fieldProps, {
                            "id": id.value,
                            "active": isActive.value || isDirty.value,
                            "dirty": isDirty.value || props.dirty,
                            "disabled": isDisabled.value,
                            "focused": isFocused.value,
                            "details": hasDetails.value,
                            "error": isValid.value === false,
                            "onDragover": onDragover,
                            "onDrop": onDrop
                        }), {
                            ...slots,
                            default: ({ props: { class: fieldClass, ...slotProps }, controlRef: controlRef })=>vue.createElementVNode(vue.Fragment, null, [
                                    vue.createElementVNode("input", vue.mergeProps({
                                        "ref": (val)=>inputRef.value = controlRef.value = val,
                                        "type": "file",
                                        "accept": inputAccept,
                                        "readonly": isReadonly.value,
                                        "disabled": isDisabled.value,
                                        "multiple": props.multiple,
                                        "name": props.name,
                                        "onClick": (e)=>{
                                            e.stopPropagation();
                                            if (isReadonly.value) e.preventDefault();
                                            onFocus();
                                        },
                                        "onChange": onFileSelection,
                                        "onDragleave": onDragleave,
                                        "onFocus": onFocus,
                                        "onBlur": blur,
                                        "onPaste": onPaste
                                    }, slotProps, inputAttrs), null),
                                    vue.createElementVNode("div", {
                                        "class": vue.normalizeClass(fieldClass)
                                    }, [
                                        !!model.value?.length && !props.hideInput && (slots.selection ? slots.selection({
                                            fileNames: fileNames.value,
                                            totalBytes: totalBytes.value,
                                            totalBytesReadable: totalBytesReadable.value
                                        }) : props.chips ? fileNames.value.map((text)=>vue.createVNode(VChip, {
                                                "key": text,
                                                "size": "small",
                                                "text": text
                                            }, null)) : fileNames.value.join(', '))
                                    ])
                                ])
                        }),
                    details: hasDetails ? (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            slots.details?.(slotProps),
                            hasCounter && vue.createElementVNode(vue.Fragment, null, [
                                vue.createElementVNode("span", null, null),
                                vue.createVNode(VCounter, {
                                    "active": !!model.value?.length,
                                    "value": counterValue.value,
                                    "disabled": props.disabled
                                }, slots.counter)
                            ])
                        ]) : undefined
                });
            });
            return forwardRefs({}, vInputRef, vFieldRef, inputRef);
        }
    });
    // Types
    const makeVFileUploadItemProps = propsFactory({
        clearable: Boolean,
        file: {
            type: Object,
            default: null
        },
        fileIcon: {
            type: String,
            // TODO: setup up a proper aliased icon
            default: 'mdi-file-document'
        },
        showSize: Boolean,
        ...makeVListItemProps({
            border: true,
            rounded: true,
            lines: 'two'
        })
    }, 'VFileUploadItem');
    const VFileUploadItem = genericComponent()({
        name: 'VFileUploadItem',
        props: makeVFileUploadItemProps(),
        emits: {
            'click:remove': ()=>true,
            click: (e)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const preview = vue.ref();
            const base = vue.computed(()=>typeof props.showSize !== 'boolean' ? props.showSize : undefined);
            function onClickRemove() {
                emit('click:remove');
            }
            vue.watchEffect(()=>{
                preview.value = props.file?.type.startsWith('image') ? URL.createObjectURL(props.file) : undefined;
            });
            useRender(()=>{
                const listItemProps = VListItem.filterProps(props);
                return vue.createVNode(VListItem, vue.mergeProps(listItemProps, {
                    "class": [
                        'v-file-upload-item',
                        props.class
                    ],
                    "title": props.title ?? props.file?.name,
                    "subtitle": props.showSize ? humanReadableFileSize(props.file?.size, base.value) : props.file?.type,
                    "style": props.style
                }), {
                    ...slots,
                    title: slots.title ?? (()=>props?.title ?? props.file?.name),
                    prepend: (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            !slots.prepend ? vue.createVNode(VAvatar, {
                                "icon": props.fileIcon,
                                "image": preview.value,
                                "rounded": true
                            }, null) : vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VAvatar: {
                                        image: preview.value,
                                        icon: !preview.value ? props.fileIcon : undefined,
                                        rounded: true
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.prepend?.(slotProps) ?? vue.createVNode(VAvatar, null, null)
                                    ]
                            })
                        ]),
                    append: (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            props.clearable && vue.createElementVNode(vue.Fragment, null, [
                                !slots.clear ? vue.createVNode(VBtn, {
                                    "icon": "$clear",
                                    "density": "comfortable",
                                    "variant": "text",
                                    "onClick": onClickRemove
                                }, null) : vue.createVNode(VDefaultsProvider, {
                                    "defaults": {
                                        VBtn: {
                                            icon: '$clear',
                                            density: 'comfortable',
                                            variant: 'text'
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.clear?.({
                                                ...slotProps,
                                                props: {
                                                    onClick: onClickRemove
                                                }
                                            }) ?? vue.createVNode(VBtn, null, null)
                                        ]
                                })
                            ]),
                            slots.append?.(slotProps)
                        ])
                });
            });
        }
    });
    let nextId = 0;
    const fileIds = new WeakMap();
    function getFileKey(file) {
        let id = fileIds.get(file);
        if (id == null) {
            id = ++nextId;
            fileIds.set(file, id);
        }
        return id;
    }
    // Types
    const VFileUploadKey = Symbol.for('vuetify:file-upload');
    const makeVFileUploadDropzoneProps = propsFactory({
        browseText: {
            type: String,
            default: '$vuetify.fileUpload.browse'
        },
        dividerText: {
            type: String,
            default: '$vuetify.fileUpload.divider'
        },
        title: {
            type: String,
            default: '$vuetify.fileUpload.title'
        },
        subtitle: String,
        icon: {
            type: IconValue,
            default: '$upload'
        },
        clearable: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        error: Boolean,
        hideBrowse: Boolean,
        insetFileList: Boolean,
        multiple: Boolean,
        scrim: {
            type: [
                Boolean,
                String
            ],
            default: true
        },
        showSize: Boolean,
        ...makeDelayProps(),
        ...makeDensityProps(),
        ...pick(makeVDividerProps({
            length: 150
        }), [
            'length',
            'thickness',
            'opacity'
        ]),
        ...makeVSheetProps(),
        modelValue: {
            type: Array,
            default: ()=>[]
        }
    }, 'VFileUploadDropzone');
    const VFileUploadDropzone = genericComponent()({
        name: 'VFileUploadDropzone',
        props: makeVFileUploadDropzoneProps(),
        emits: {
            'click:browse': ()=>true,
            'click:remove': (index)=>true,
            drop: (files)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const { densityClasses: densityClasses } = useDensity(props);
            const { handleDrop: handleDrop, hasFilesOrFolders: hasFilesOrFolders } = useFileDrop();
            const context = vue.inject(VFileUploadKey, null);
            const vSheetRef = vue.ref();
            const isDragging = vue.shallowRef(false);
            const isDisabled = vue.toRef(()=>context?.disabled.value ?? props.disabled);
            const isReadonly = vue.toRef(()=>context?.readonly.value ?? props.readonly);
            const isInteractive = vue.toRef(()=>!isDisabled.value && !isReadonly.value);
            function onDragover(e) {
                if (!isInteractive.value) return;
                e.preventDefault();
                e.stopImmediatePropagation();
                isDragging.value = true;
            }
            function onDragleave(e) {
                e.preventDefault();
                const container = e.currentTarget;
                if (!container.contains(e.relatedTarget)) isDragging.value = false;
            }
            async function onDrop(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                isDragging.value = false;
                if (!isInteractive.value || !hasFilesOrFolders(e)) return;
                const files = await handleDrop(e);
                if (context) context.onDrop(files);
                else emit('drop', files);
            }
            function onClickBrowse() {
                if (!isInteractive.value) return;
                if (context) context.onClickBrowse();
                else emit('click:browse');
            }
            function onKeydown(e) {
                if (!isInteractive.value) return;
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClickBrowse();
                }
            }
            function onClickRemove(index) {
                if (!isInteractive.value) return;
                if (context) context.onClickRemove(index);
                else emit('click:remove', index);
            }
            async function onPaste(e) {
                if (!isInteractive.value || !hasFilesOrFolders(e)) return;
                e.preventDefault();
                const files = await handleDrop(e);
                if (!files.length) return;
                if (context) context.onDrop(files);
                else emit('drop', files);
            }
            useRender(()=>{
                const modelValue = context?.files.value ?? props.modelValue;
                const disabled = isDisabled.value;
                const readonly = isReadonly.value;
                const interactive = isInteractive.value;
                const error = context?.error.value || props.error;
                const hasTitle = !!(slots.title || props.title);
                const hasIcon = !!(slots.icon || props.icon);
                const hasBrowse = !!(!props.hideBrowse && (slots.browse || props.density === 'default'));
                const hasFiles = modelValue.length > 0;
                const isInset = props.insetFileList && hasFiles;
                const sheetProps = VSheet.filterProps(props);
                const dividerProps = VDivider.filterProps(props);
                return vue.createVNode(VSheet, vue.mergeProps({
                    "ref": vSheetRef,
                    "tabindex": disabled ? -1 : 0
                }, sheetProps, {
                    "class": [
                        'v-file-upload-dropzone',
                        {
                            'v-file-upload-dropzone--clickable': !hasBrowse,
                            'v-file-upload-dropzone--disabled': disabled,
                            'v-file-upload-dropzone--readonly': readonly,
                            'v-file-upload-dropzone--dragging': isDragging.value,
                            'v-file-upload-dropzone--has-files': hasFiles,
                            'v-file-upload-dropzone--inset': isInset,
                            'v-file-upload-dropzone--error': error
                        },
                        densityClasses.value,
                        props.class
                    ],
                    "style": props.style,
                    "onDragleave": onDragleave,
                    "onDragover": onDragover,
                    "onDrop": onDrop,
                    "onPaste": onPaste,
                    "onClick": !hasBrowse && !(isInset && hasFiles) ? onClickBrowse : undefined,
                    "onKeydown": onKeydown
                }), {
                    default: ()=>[
                            slots.default?.({
                                isDragging: isDragging.value,
                                hasFiles: hasFiles,
                                files: modelValue,
                                props: {
                                    onClick: onClickBrowse
                                }
                            }) ?? (isInset ? vue.createElementVNode("div", {
                                "key": "inset",
                                "class": "v-file-upload-inset"
                            }, [
                                modelValue.length === 1 && !props.multiple ? slots.single?.({
                                    file: modelValue[0],
                                    props: {
                                        'onClick:remove': ()=>onClickRemove(0)
                                    }
                                }) ?? vue.createVNode(VDefaultsProvider, {
                                    "defaults": {
                                        VFileUploadItem: {
                                            file: modelValue[0],
                                            clearable: props.clearable && !readonly,
                                            disabled: disabled,
                                            showSize: props.showSize,
                                            border: false
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            vue.createVNode(VFileUploadItem, {
                                                "onClick:remove": ()=>onClickRemove(0)
                                            }, null)
                                        ]
                                }) : modelValue.map((file, i)=>{
                                    const key = getFileKey(file);
                                    const slotProps = {
                                        file: file,
                                        props: {
                                            'onClick:remove': ()=>onClickRemove(i)
                                        }
                                    };
                                    return vue.createVNode(VDefaultsProvider, {
                                        "key": key,
                                        "defaults": {
                                            VFileUploadItem: {
                                                file: file,
                                                clearable: props.clearable && !readonly,
                                                disabled: disabled,
                                                showSize: props.showSize,
                                                border: false
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slots.item?.(slotProps) ?? vue.createVNode(VFileUploadItem, {
                                                    "key": key,
                                                    "onClick:remove": ()=>onClickRemove(i)
                                                }, null)
                                            ]
                                    });
                                }),
                                vue.createVNode(VDivider, null, null),
                                vue.createElementVNode("div", {
                                    "class": "v-file-upload-inset__action"
                                }, [
                                    !slots.browse ? vue.createVNode(VBtn, {
                                        "readonly": !interactive,
                                        "text": t(props.browseText),
                                        "variant": "text",
                                        "onClick": onClickBrowse
                                    }, null) : vue.createVNode(VDefaultsProvider, {
                                        "defaults": {
                                            VBtn: {
                                                readonly: !interactive,
                                                text: t(props.browseText),
                                                variant: 'text'
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slots.browse({
                                                    props: {
                                                        onClick: onClickBrowse
                                                    }
                                                })
                                            ]
                                    })
                                ])
                            ]) : vue.createElementVNode(vue.Fragment, null, [
                                hasIcon && vue.createElementVNode("div", {
                                    "key": "icon",
                                    "class": "v-file-upload-icon"
                                }, [
                                    !slots.icon ? vue.createVNode(VIcon, {
                                        "key": "icon-icon",
                                        "icon": props.icon
                                    }, null) : vue.createVNode(VDefaultsProvider, {
                                        "key": "icon-defaults",
                                        "defaults": {
                                            VIcon: {
                                                icon: props.icon
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slots.icon()
                                            ]
                                    })
                                ]),
                                hasTitle && vue.createElementVNode("div", {
                                    "key": "title",
                                    "class": "v-file-upload-title"
                                }, [
                                    slots.title?.() ?? t(props.title)
                                ]),
                                props.density === 'default' && vue.createElementVNode(vue.Fragment, null, [
                                    hasBrowse && vue.createElementVNode(vue.Fragment, null, [
                                        vue.createElementVNode("div", {
                                            "key": "upload-divider",
                                            "class": "v-file-upload-divider"
                                        }, [
                                            slots.divider?.() ?? vue.createVNode(VDivider, dividerProps, {
                                                default: ()=>[
                                                        t(props.dividerText)
                                                    ]
                                            })
                                        ]),
                                        !slots.browse ? vue.createVNode(VBtn, {
                                            "readonly": !interactive,
                                            "size": "large",
                                            "text": t(props.browseText),
                                            "variant": "tonal",
                                            "onClick": onClickBrowse
                                        }, null) : vue.createVNode(VDefaultsProvider, {
                                            "defaults": {
                                                VBtn: {
                                                    readonly: !interactive,
                                                    size: 'large',
                                                    text: t(props.browseText),
                                                    variant: 'tonal'
                                                }
                                            }
                                        }, {
                                            default: ()=>[
                                                    slots.browse({
                                                        props: {
                                                            onClick: onClickBrowse
                                                        }
                                                    })
                                                ]
                                        })
                                    ]),
                                    props.subtitle && vue.createElementVNode("div", {
                                        "class": "v-file-upload-subtitle"
                                    }, [
                                        props.subtitle
                                    ])
                                ])
                            ])),
                            vue.createVNode(VOverlay, {
                                "modelValue": isDragging.value,
                                "contained": true,
                                "scrim": props.scrim
                            }, null),
                            slots.input?.(),
                            slots.loader?.()
                        ]
                });
            });
            return forwardRefs({}, vSheetRef);
        }
    });
    // Types
    const makeVFileUploadListProps = propsFactory({
        clearable: Boolean,
        showSize: Boolean,
        files: Array,
        ...makeVListProps({
            border: false,
            elevation: 0,
            lines: false
        })
    }, 'VFileUploadList');
    const VFileUploadList = genericComponent()({
        name: 'VFileUploadList',
        props: makeVFileUploadListProps(),
        setup (props, { slots: slots }) {
            const context = vue.inject(VFileUploadKey, null);
            useRender(()=>{
                const files = props.files ?? context?.files.value ?? [];
                const disabled = context?.disabled.value ?? props.disabled;
                const readonly = context?.readonly.value ?? false;
                const listProps = VList.filterProps(props);
                if (!slots.default && !files.length) return vue.createCommentVNode();
                return vue.createVNode(VList, vue.mergeProps(listProps, {
                    "disabled": disabled,
                    "class": [
                        'v-file-upload-list',
                        props.class
                    ],
                    "style": props.style,
                    "bgColor": "transparent"
                }), {
                    default: ()=>[
                            slots.default?.({
                                files: files,
                                onClickRemove: (i)=>context?.onClickRemove(i)
                            }) ?? files.map((file, index)=>{
                                const key = getFileKey(file);
                                const slotProps = {
                                    file: file,
                                    props: {
                                        'onClick:remove': ()=>context?.onClickRemove(index)
                                    }
                                };
                                return vue.createVNode(VDefaultsProvider, {
                                    "key": key,
                                    "defaults": {
                                        VFileUploadItem: {
                                            file: file,
                                            clearable: props.clearable && !readonly,
                                            disabled: disabled,
                                            showSize: props.showSize,
                                            variant: 'flat'
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.item?.(slotProps) ?? vue.createVNode(VFileUploadItem, {
                                                "key": key,
                                                "onClick:remove": ()=>context?.onClickRemove(index)
                                            }, null)
                                        ]
                                });
                            })
                        ]
                });
            });
        }
    });
    // Types
    const makeVFileUploadProps = propsFactory({
        browseText: {
            type: String,
            default: '$vuetify.fileUpload.browse'
        },
        dividerText: {
            type: String,
            default: '$vuetify.fileUpload.divider'
        },
        title: {
            type: String,
            default: '$vuetify.fileUpload.title'
        },
        subtitle: String,
        icon: {
            type: IconValue,
            default: '$upload'
        },
        clearable: Boolean,
        insetFileList: Boolean,
        hideBrowse: Boolean,
        multiple: Boolean,
        scrim: {
            type: [
                Boolean,
                String
            ],
            default: true
        },
        showSize: Boolean,
        ...makeFileFilterProps(),
        ...makeLoaderProps(),
        ...omit(makeVInputProps(), [
            'direction'
        ]),
        modelValue: {
            type: [
                Array,
                Object
            ],
            default: null,
            validator: (val)=>{
                return wrapInArray(val).every((v)=>v != null && typeof v === 'object');
            }
        }
    }, 'VFileUpload');
    const VFileUpload = genericComponent()({
        name: 'VFileUpload',
        inheritAttrs: false,
        props: makeVFileUploadProps(),
        emits: {
            'update:modelValue': (files)=>true,
            'update:focused': (focused)=>true,
            rejected: (files)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { filterAccepted: filterAccepted } = useFileFilter(props);
            const { isFocused: isFocused } = useFocus(props);
            const { loaderClasses: loaderClasses } = useLoader(props);
            const form = useForm(props);
            const model = useProxiedModel(props, 'modelValue', props.modelValue, (val)=>wrapInArray(val), (val)=>props.multiple || Array.isArray(props.modelValue) ? val : val[0]);
            const vInputRef = vue.ref();
            const vDropzoneRef = vue.ref();
            const inputRef = vue.ref(null);
            const isError = vue.toRef(()=>vInputRef.value?.isValid === false);
            const isInteractive = vue.toRef(()=>!form.isDisabled.value && !form.isReadonly.value);
            const loadingColor = vue.shallowRef(undefined);
            vue.watch(()=>props.loading, (val, old)=>{
                loadingColor.value = !val && typeof old === 'string' ? old : typeof val === 'boolean' ? undefined : val;
            }, {
                immediate: true
            });
            vue.provide(VFileUploadKey, {
                files: model,
                disabled: form.isDisabled,
                readonly: form.isReadonly,
                error: isError,
                onDrop: onDrop,
                onClickBrowse: onClick,
                onClickRemove: onClickRemove
            });
            vue.watch(model, (newValue)=>{
                const hasModelReset = !Array.isArray(newValue) || !newValue.length;
                if (hasModelReset && inputRef.value) inputRef.value.value = '';
            });
            function onDrop(files) {
                if (!isInteractive.value) return;
                selectAccepted(files);
            }
            function onFileSelection(e) {
                if (!e.target || e.repack) return; // prevent loop
                const target = e.target;
                const selectedFiles = [
                    ...target.files ?? []
                ];
                if (!selectedFiles.length) return;
                if (!props.filterByType) model.value = props.multiple ? [
                    ...model.value,
                    ...selectedFiles
                ] : selectedFiles;
                else selectAccepted(selectedFiles);
            }
            function selectAccepted(files) {
                const dataTransfer = new DataTransfer();
                const { accepted: accepted, rejected: rejected } = filterAccepted(files);
                if (rejected.length) emit('rejected', rejected);
                for (const file of accepted)dataTransfer.items.add(file);
                inputRef.value.files = dataTransfer.files;
                const newFiles = [
                    ...dataTransfer.files
                ];
                model.value = props.multiple ? [
                    ...model.value,
                    ...newFiles
                ] : newFiles;
                const event = new Event('change', {
                    bubbles: true
                });
                event.repack = true;
                inputRef.value.dispatchEvent(event);
            }
            function onClick() {
                if (!isInteractive.value) return;
                inputRef.value?.click();
            }
            function onClickRemove(index) {
                if (!isInteractive.value) return;
                const newValue = model.value.filter((_, i)=>i !== index);
                model.value = newValue;
                if (newValue.length > 0 || !inputRef.value) return;
                inputRef.value.value = '';
            }
            useRender(()=>{
                const { modelValue: _, ...inputProps } = VInput.filterProps(props);
                const { modelValue: __, ...dropzoneProps } = VFileUploadDropzone.filterProps(props);
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                const expectsDirectory = attrs.webkitdirectory !== undefined && attrs.webkitdirectory !== false;
                const acceptFallback = attrs.accept ? String(attrs.accept) : undefined;
                const inputAccept = expectsDirectory ? undefined : props.filterByType ?? acceptFallback;
                const inputNode = vue.createElementVNode("input", vue.mergeProps({
                    "ref": inputRef,
                    "type": "file",
                    "accept": inputAccept,
                    "disabled": props.disabled ?? undefined,
                    "multiple": props.multiple,
                    "name": props.name,
                    "onChange": onFileSelection
                }, inputAttrs), null);
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": vInputRef,
                    "modelValue": props.multiple ? model.value : model.value[0],
                    "onUpdate:modelValue": (val)=>{
                        if (val == null || Array.isArray(val) && !val.length) model.value = [];
                    },
                    "class": [
                        'v-file-upload',
                        loaderClasses.value,
                        props.class
                    ],
                    "style": props.style,
                    "focused": isFocused.value
                }, rootAttrs, inputProps), {
                    ...slots,
                    default: ()=>{
                        return vue.createElementVNode(vue.Fragment, null, [
                            slots.default ? vue.createElementVNode(vue.Fragment, null, [
                                slots.default(),
                                vue.createElementVNode("input", vue.mergeProps({
                                    "ref": inputRef,
                                    "type": "file",
                                    "accept": inputAccept,
                                    "disabled": props.disabled ?? undefined,
                                    "multiple": props.multiple,
                                    "name": props.name,
                                    "style": "display: none;",
                                    "onChange": onFileSelection
                                }, inputAttrs), null)
                            ]) : vue.createVNode(VFileUploadDropzone, vue.mergeProps({
                                "ref": vDropzoneRef
                            }, dropzoneProps), {
                                browse: slots.browse,
                                icon: slots.icon,
                                title: slots.title,
                                divider: slots.divider,
                                single: slots.single,
                                item: slots.item,
                                input: ()=>slots.input?.({
                                        inputNode: inputNode
                                    }) ?? inputNode,
                                loader: ()=>vue.createVNode(LoaderSlot, {
                                        "name": "v-file-upload",
                                        "active": !!props.loading,
                                        "color": loadingColor.value
                                    }, {
                                        default: slots.loader
                                    })
                            }),
                            !slots.default && !props.insetFileList && vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VFileUploadList: {
                                        clearable: props.clearable,
                                        showSize: props.showSize
                                    }
                                }
                            }, {
                                default: ()=>[
                                        vue.createVNode(VFileUploadList, null, {
                                            item: slots.item
                                        })
                                    ]
                            })
                        ]);
                    }
                });
            });
            return forwardRefs({
                controlRef: inputRef
            }, vInputRef, vDropzoneRef);
        }
    });
    const makeVFooterProps = propsFactory({
        app: Boolean,
        color: String,
        height: {
            type: [
                Number,
                String
            ],
            default: 'auto'
        },
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeElevationProps(),
        ...makeLayoutItemProps(),
        ...makeRoundedProps(),
        ...makeTagProps({
            tag: 'footer'
        }),
        ...makeThemeProps()
    }, 'VFooter');
    const VFooter = genericComponent()({
        name: 'VFooter',
        props: makeVFooterProps(),
        setup (props, { slots: slots }) {
            const layoutItemStyles = vue.ref();
            const { themeClasses: themeClasses } = provideTheme(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { borderClasses: borderClasses } = useBorder(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const autoHeight = vue.shallowRef(32);
            const { resizeRef: resizeRef } = useResizeObserver((entries)=>{
                if (!entries.length) return;
                autoHeight.value = entries[0].target.clientHeight;
            });
            const height = vue.computed(()=>props.height === 'auto' ? autoHeight.value : parseInt(props.height, 10));
            useToggleScope(()=>props.app, ()=>{
                const layout = useLayoutItem({
                    id: props.name,
                    order: vue.computed(()=>parseInt(props.order, 10)),
                    position: vue.toRef(()=>'bottom'),
                    layoutSize: height,
                    elementSize: vue.computed(()=>props.height === 'auto' ? undefined : height.value),
                    active: vue.toRef(()=>props.app),
                    absolute: vue.toRef(()=>props.absolute)
                });
                vue.watchEffect(()=>{
                    layoutItemStyles.value = layout.layoutItemStyles.value;
                });
            });
            useRender(()=>vue.createVNode(props.tag, {
                    "ref": resizeRef,
                    "class": vue.normalizeClass([
                        'v-footer',
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        props.app ? layoutItemStyles.value : {
                            height: convertToUnit(props.height)
                        },
                        roundedStyles.value,
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Types
    const makeVFormProps = propsFactory({
        ...makeComponentProps(),
        ...makeFormProps()
    }, 'VForm');
    const VForm = genericComponent()({
        name: 'VForm',
        props: makeVFormProps(),
        emits: {
            'update:modelValue': (val)=>true,
            submit: (e)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            const form = createForm(props);
            const formRef = vue.ref();
            function onReset(e) {
                e.preventDefault();
                form.reset();
            }
            function onSubmit(_e) {
                const e = _e;
                const ready = form.validate();
                e.then = ready.then.bind(ready);
                e.catch = ready.catch.bind(ready);
                e.finally = ready.finally.bind(ready);
                emit('submit', e);
                if (!e.defaultPrevented) ready.then(({ valid: valid })=>{
                    if (valid) formRef.value?.submit();
                });
                e.preventDefault();
            }
            useRender(()=>vue.createElementVNode("form", {
                    "ref": formRef,
                    "class": vue.normalizeClass([
                        'v-form',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "novalidate": true,
                    "onReset": onReset,
                    "onSubmit": onSubmit
                }, [
                    slots.default?.({
                        get errors () {
                            return form.errors.value;
                        },
                        get isDisabled () {
                            return form.isDisabled.value;
                        },
                        get isReadonly () {
                            return form.isReadonly.value;
                        },
                        get isValidating () {
                            return form.isValidating.value;
                        },
                        get isValid () {
                            return form.isValid.value;
                        },
                        get items () {
                            return form.items.value;
                        },
                        validate: form.validate,
                        reset: form.reset,
                        resetValidation: form.resetValidation
                    })
                ]));
            return forwardRefs(form, formRef);
        }
    });
    const makeVKbdProps = propsFactory({
        color: String,
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeRoundedProps(),
        ...makeTagProps({
            tag: 'kbd'
        }),
        ...makeThemeProps(),
        ...makeElevationProps()
    }, 'VKbd');
    const VKbd = genericComponent()({
        name: 'VKbd',
        props: makeVKbdProps(),
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { elevationClasses: elevationClasses } = useElevation(props);
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-kbd',
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Types
    // Display mode types for different visual representations
    // Extended variant type that includes our custom 'contained' variant
    // Key display tuple: [mode, content] where content is string or IconValue
    // Key tuple: [mode, content, keycode] where content is string or IconValue
    function processKey(config, requestedMode, isMac) {
        const keyCfg = isMac && config.mac ? config.mac : config.default;
        // 1. Resolve the safest display mode for the current platform
        const mode = (()=>{
            // If the requested mode lacks an asset, fall back to text
            if (requestedMode === 'icon' && !keyCfg.icon) return 'text';
            if (requestedMode === 'symbol' && !keyCfg.symbol) return 'text';
            return requestedMode;
        })();
        // 2. Pick value for the chosen mode, defaulting to text representation
        let value = keyCfg[mode] ?? keyCfg.text;
        // 3. Guard against icon tokens leaking into text mode (e.g. "$ctrl")
        if (mode === 'text' && typeof value === 'string' && value.startsWith('$') && !value.startsWith('$vuetify.')) value = value.slice(1).toUpperCase(); // "$ctrl" → "CTRL"
        return mode === 'icon' ? [
            'icon',
            value
        ] : [
            mode,
            value
        ];
    }
    const hotkeyMap = {
        ctrl: {
            mac: {
                symbol: "\u2303",
                icon: '$ctrl',
                text: '$vuetify.hotkey.ctrl'
            },
            default: {
                text: 'Ctrl'
            }
        },
        meta: {
            mac: {
                symbol: "\u2318",
                icon: '$command',
                text: '$vuetify.hotkey.command'
            },
            default: {
                text: 'Ctrl'
            }
        },
        cmd: {
            mac: {
                symbol: "\u2318",
                icon: '$command',
                text: '$vuetify.hotkey.command'
            },
            default: {
                text: 'Ctrl'
            }
        },
        shift: {
            mac: {
                symbol: "\u21E7",
                icon: '$shift',
                text: '$vuetify.hotkey.shift'
            },
            default: {
                text: 'Shift'
            }
        },
        alt: {
            mac: {
                symbol: "\u2325",
                icon: '$alt',
                text: '$vuetify.hotkey.option'
            },
            default: {
                text: 'Alt'
            }
        },
        enter: {
            default: {
                symbol: "\u21B5",
                icon: '$enter',
                text: '$vuetify.hotkey.enter'
            }
        },
        arrowup: {
            default: {
                symbol: "\u2191",
                icon: '$arrowup',
                text: '$vuetify.hotkey.upArrow'
            }
        },
        arrowdown: {
            default: {
                symbol: "\u2193",
                icon: '$arrowdown',
                text: '$vuetify.hotkey.downArrow'
            }
        },
        arrowleft: {
            default: {
                symbol: "\u2190",
                icon: '$arrowleft',
                text: '$vuetify.hotkey.leftArrow'
            }
        },
        arrowright: {
            default: {
                symbol: "\u2192",
                icon: '$arrowright',
                text: '$vuetify.hotkey.rightArrow'
            }
        },
        backspace: {
            default: {
                symbol: "\u232B",
                icon: '$backspace',
                text: '$vuetify.hotkey.backspace'
            }
        },
        escape: {
            default: {
                text: '$vuetify.hotkey.escape'
            }
        },
        ' ': {
            mac: {
                symbol: "\u2423",
                icon: '$space',
                text: '$vuetify.hotkey.space'
            },
            default: {
                text: '$vuetify.hotkey.space'
            }
        },
        '-': {
            default: {
                text: '-'
            }
        },
        '+': {
            default: {
                text: '+'
            }
        }
    };
    const makeVHotkeyProps = propsFactory({
        // String representing keyboard shortcuts (e.g., "ctrl+k", "meta+shift+p")
        keys: String,
        // How to display keys: 'symbol' uses special characters (⌘, ⌃), 'icon' uses SVG icons, 'text' uses words
        displayMode: {
            type: String,
            default: 'icon'
        },
        // Custom key mapping configuration. Users can import and modify the exported hotkeyMap as needed
        keyMap: {
            type: Object,
            default: ()=>hotkeyMap
        },
        platform: {
            type: String,
            default: 'auto'
        },
        inline: Boolean,
        disabled: Boolean,
        prefix: String,
        suffix: String,
        variant: {
            type: String,
            default: 'elevated',
            validator: (v)=>[
                    'elevated',
                    'flat',
                    'tonal',
                    'outlined',
                    'text',
                    'plain',
                    'contained'
                ].includes(v)
        },
        ...makeComponentProps(),
        ...makeThemeProps(),
        ...makeBorderProps(),
        ...makeRoundedProps(),
        ...makeElevationProps(),
        color: String
    }, 'VHotkey');
    const AND_DELINEATOR = Symbol('VHotkey:AND_DELINEATOR'); // For +_ separators
    const OR_DELINEATOR = Symbol('VHotkey:OR_DELINEATOR'); // For / separators
    const THEN_DELINEATOR = Symbol('VHotkey:THEN_DELINEATOR'); // For - separators
    function getKeyText(keyMap, key, isMac) {
        const lowerKey = key.toLowerCase();
        if (lowerKey in keyMap) {
            const result = processKey(keyMap[lowerKey], 'text', isMac);
            return typeof result[1] === 'string' ? result[1] : String(result[1]);
        }
        return key.toUpperCase();
    }
    function applyDisplayModeToKey(keyMap, mode, key, isMac) {
        const lowerKey = key.toLowerCase();
        if (lowerKey in keyMap) {
            const result = processKey(keyMap[lowerKey], mode, isMac);
            if (result[0] === 'text' && typeof result[1] === 'string' && result[1].startsWith('$') && !result[1].startsWith('$vuetify.')) return [
                'text',
                result[1].replace('$', '').toUpperCase(),
                key
            ];
            return [
                ...result,
                key
            ];
        }
        return [
            'text',
            key.toUpperCase(),
            key
        ];
    }
    const VHotkey = genericComponent()({
        name: 'VHotkey',
        props: makeVHotkeyProps(),
        setup (props) {
            const { t: t } = useLocale();
            const { themeClasses: themeClasses } = provideTheme(props);
            const { rtlClasses: rtlClasses } = useRtl();
            const { borderClasses: borderClasses } = useBorder(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(()=>({
                    color: props.color,
                    variant: props.variant === 'contained' ? 'elevated' : props.variant
                }));
            const isMac = vue.computed(()=>props.platform === 'auto' ? typeof navigator !== 'undefined' && /macintosh/i.test(navigator.userAgent) : props.platform === 'mac');
            const keyCombinations = vue.computed(()=>{
                if (!props.keys) return [];
                // Split by spaces to handle multiple key combinations
                // Example: "ctrl+k meta+p" -> ["ctrl+k", "meta+p"]
                return props.keys.split(/\b \b/).map((combination)=>{
                    const result = [];
                    function visit(node) {
                        if (typeof node === 'string') {
                            if (node !== '') result.push(applyDisplayModeToKey(props.keyMap, props.displayMode, node, isMac.value));
                        } else for(let i = 0; i < node.parts.length; i++){
                            if (i > 0) {
                                if (node.type === 'sequence') result.push(THEN_DELINEATOR);
                                else if (node.type === 'alternate') result.push(OR_DELINEATOR);
                                else if (node.type === 'combo') result.push(AND_DELINEATOR);
                            }
                            visit(node.parts[i]);
                        }
                    }
                    visit(parseKeyCombination(combination));
                    return result;
                });
            });
            const accessibleLabel = vue.computed(()=>{
                if (!props.keys) return '';
                // Convert the parsed key combinations into readable text
                const readableShortcuts = keyCombinations.value.map((combination)=>{
                    const readableParts = [];
                    for (const key of combination)if (Array.isArray(key)) {
                        // Always use text representation for screen readers
                        const textKey = key[0] === 'icon' || key[0] === 'symbol' ? applyDisplayModeToKey(mergeDeep(hotkeyMap, props.keyMap), 'text', String(key[1]), isMac.value)[1] : key[1];
                        readableParts.push(translateKey(textKey));
                    } else {
                        if (key === AND_DELINEATOR) readableParts.push(t('$vuetify.hotkey.plus'));
                        else if (key === OR_DELINEATOR) readableParts.push(t('$vuetify.hotkey.or'));
                        else if (key === THEN_DELINEATOR) readableParts.push(t('$vuetify.hotkey.then'));
                    }
                    return readableParts.join(' ');
                });
                const shortcutText = readableShortcuts.join(', ');
                return t('$vuetify.hotkey.shortcut', shortcutText);
            });
            function translateKey(key) {
                return key.startsWith('$vuetify.') ? t(key) : key;
            }
            function getKeyTooltip(key) {
                if (props.displayMode === 'text') return undefined;
                const textKey = getKeyText(props.keyMap, String(key[2]), isMac.value);
                return translateKey(textKey);
            }
            function renderKey(key, keyIndex) {
                const isContained = props.variant === 'contained';
                const KeyComponent = isContained ? 'kbd' : VKbd;
                const keyClasses = [
                    'v-hotkey__key',
                    `v-hotkey__key-${key[0]}`,
                    ...isContained ? [
                        'v-hotkey__key--nested'
                    ] : [
                        borderClasses.value,
                        roundedClasses.value,
                        elevationClasses.value,
                        colorClasses.value
                    ]
                ];
                return vue.createVNode(KeyComponent, {
                    "key": keyIndex,
                    "class": vue.normalizeClass(keyClasses),
                    "style": vue.normalizeStyle(isContained ? undefined : [
                        colorStyles.value,
                        roundedStyles.value
                    ]),
                    "aria-hidden": "true",
                    "title": getKeyTooltip(key)
                }, {
                    default: ()=>[
                            key[0] === 'icon' ? vue.createVNode(VIcon, {
                                "icon": key[1],
                                "aria-hidden": "true"
                            }, null) : translateKey(key[1])
                        ]
                });
            }
            function renderDivider(key, keyIndex) {
                return vue.createElementVNode("span", {
                    "key": keyIndex,
                    "class": "v-hotkey__divider",
                    "aria-hidden": "true"
                }, [
                    key === AND_DELINEATOR ? '+' : key === OR_DELINEATOR ? t('$vuetify.hotkey.or') : t('$vuetify.hotkey.then')
                ]);
            }
            useRender(()=>{
                const content = vue.createElementVNode(vue.Fragment, null, [
                    props.prefix && vue.createElementVNode("span", {
                        "key": "prefix",
                        "class": "v-hotkey__prefix"
                    }, [
                        props.prefix
                    ]),
                    keyCombinations.value.map((combination, comboIndex)=>vue.createElementVNode("span", {
                            "class": "v-hotkey__combination",
                            "key": comboIndex
                        }, [
                            combination.map((key, keyIndex)=>Array.isArray(key) ? renderKey(key, keyIndex) : renderDivider(key, keyIndex)),
                            comboIndex < keyCombinations.value.length - 1 && vue.createElementVNode("span", {
                                "aria-hidden": "true"
                            }, [
                                vue.createTextVNode("\xA0")
                            ])
                        ])),
                    props.suffix && vue.createElementVNode("span", {
                        "key": "suffix",
                        "class": "v-hotkey__suffix"
                    }, [
                        props.suffix
                    ])
                ]);
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-hotkey',
                        {
                            'v-hotkey--disabled': props.disabled,
                            'v-hotkey--inline': props.inline,
                            'v-hotkey--contained': props.variant === 'contained'
                        },
                        themeClasses.value,
                        rtlClasses.value,
                        variantClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "role": "img",
                    "aria-label": accessibleLabel.value
                }, [
                    props.variant !== 'contained' ? content : vue.createVNode(VKbd, {
                        "key": "contained",
                        "class": vue.normalizeClass([
                            'v-hotkey__contained-wrapper',
                            borderClasses.value,
                            roundedClasses.value,
                            elevationClasses.value,
                            colorClasses.value
                        ]),
                        "style": vue.normalizeStyle([
                            colorStyles.value,
                            roundedStyles.value
                        ]),
                        "aria-hidden": "true"
                    }, {
                        default: ()=>[
                                content
                            ]
                    })
                ]);
            });
        }
    });
    // Composables
    const makeVHoverProps = propsFactory({
        disabled: Boolean,
        modelValue: {
            type: Boolean,
            default: null
        },
        ...makeDelayProps()
    }, 'VHover');
    const VHover = genericComponent()({
        name: 'VHover',
        props: makeVHoverProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const isHovering = useProxiedModel(props, 'modelValue');
            // track hover state regardless of disabled, so we can reconcile
            const internal = vue.shallowRef(false);
            const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = useDelay(props, (value)=>{
                internal.value = value;
                if (!props.disabled) isHovering.value = value;
            });
            vue.watch(()=>props.disabled, (val, old)=>{
                if (old && !val) isHovering.value = internal.value;
            });
            return ()=>slots.default?.({
                    isHovering: isHovering.value,
                    props: {
                        onMouseenter: runOpenDelay,
                        onMouseleave: runCloseDelay
                    }
                });
        }
    });
    // Types
    const makeVInfiniteScrollProps = propsFactory({
        color: String,
        direction: {
            type: String,
            default: 'vertical',
            validator: (v)=>[
                    'vertical',
                    'horizontal'
                ].includes(v)
        },
        side: {
            type: String,
            default: 'end',
            validator: (v)=>[
                    'start',
                    'end',
                    'both'
                ].includes(v)
        },
        mode: {
            type: String,
            default: 'intersect',
            validator: (v)=>[
                    'intersect',
                    'manual'
                ].includes(v)
        },
        margin: [
            Number,
            String
        ],
        loadMoreText: {
            type: String,
            default: '$vuetify.infiniteScroll.loadMore'
        },
        emptyText: {
            type: String,
            default: '$vuetify.infiniteScroll.empty'
        },
        ...makeDimensionProps(),
        ...makeTagProps()
    }, 'VInfiniteScroll');
    const VInfiniteScrollIntersect = defineComponent({
        name: 'VInfiniteScrollIntersect',
        props: {
            side: {
                type: String,
                required: true
            },
            rootMargin: String
        },
        emits: {
            intersect: (side, isIntersecting)=>true
        },
        setup (props, { emit: emit }) {
            const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = useIntersectionObserver();
            vue.watch(isIntersecting, async (val)=>{
                emit('intersect', props.side, val);
            });
            useRender(()=>vue.createElementVNode("div", {
                    "class": "v-infinite-scroll-intersect",
                    "style": {
                        '--v-infinite-margin-size': props.rootMargin
                    },
                    "ref": intersectionRef
                }, [
                    vue.createTextVNode("\xA0")
                ]));
            return {};
        }
    });
    const VInfiniteScroll = genericComponent()({
        name: 'VInfiniteScroll',
        props: makeVInfiniteScrollProps(),
        emits: {
            load: (options)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            const rootEl = vue.ref();
            const startStatus = vue.shallowRef('ok');
            const endStatus = vue.shallowRef('ok');
            const margin = vue.computed(()=>convertToUnit(props.margin));
            const isIntersecting = vue.shallowRef(false);
            function setScrollAmount(amount) {
                if (!rootEl.value) return;
                const property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
                rootEl.value[property] = amount;
            }
            function getScrollAmount() {
                if (!rootEl.value) return 0;
                const property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
                return rootEl.value[property];
            }
            function getScrollSize() {
                if (!rootEl.value) return 0;
                const property = props.direction === 'vertical' ? 'scrollHeight' : 'scrollWidth';
                return rootEl.value[property];
            }
            function getContainerSize() {
                if (!rootEl.value) return 0;
                const property = props.direction === 'vertical' ? 'clientHeight' : 'clientWidth';
                return rootEl.value[property];
            }
            vue.onMounted(()=>{
                if (!rootEl.value) return;
                if (props.side === 'start') setScrollAmount(getScrollSize());
                else if (props.side === 'both') setScrollAmount(getScrollSize() / 2 - getContainerSize() / 2);
            });
            function setStatus(side, status) {
                if (side === 'start') startStatus.value = status;
                else if (side === 'end') endStatus.value = status;
                else if (side === 'both') {
                    startStatus.value = status;
                    endStatus.value = status;
                }
            }
            function getStatus(side) {
                return side === 'start' ? startStatus.value : endStatus.value;
            }
            let previousScrollSize = 0;
            function handleIntersect(side, _isIntersecting) {
                isIntersecting.value = _isIntersecting;
                if (isIntersecting.value) intersecting(side);
            }
            function intersecting(side) {
                if (props.mode !== 'manual' && !isIntersecting.value) return;
                const status = getStatus(side);
                if (!rootEl.value || [
                    'empty',
                    'loading'
                ].includes(status)) return;
                previousScrollSize = getScrollSize();
                setStatus(side, 'loading');
                function done(status) {
                    setStatus(side, status);
                    vue.nextTick(()=>{
                        if (status === 'empty' || status === 'error') return;
                        if (status === 'ok' && side === 'start') setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                        if (props.mode !== 'manual') vue.nextTick(()=>{
                            // Browser takes 2 - 3 animation frames to trigger IntersectionObserver after
                            // VInfiniteScrollIntersect leaves the viewpoint. So far I couldn't come up
                            // with a better solution than using 3 nested window.requestAnimationFrame. (#17475)
                            window.requestAnimationFrame(()=>{
                                window.requestAnimationFrame(()=>{
                                    window.requestAnimationFrame(()=>{
                                        intersecting(side);
                                    });
                                });
                            });
                        });
                    });
                }
                emit('load', {
                    side: side,
                    done: done
                });
            }
            const { t: t } = useLocale();
            function renderSide(side, status) {
                if (props.side !== side && props.side !== 'both') return;
                const onClick = ()=>intersecting(side);
                const slotProps = {
                    side: side,
                    props: {
                        onClick: onClick,
                        color: props.color
                    }
                };
                if (status === 'error') return slots.error?.(slotProps);
                if (status === 'empty') return slots.empty?.(slotProps) ?? vue.createElementVNode("div", null, [
                    t(props.emptyText)
                ]);
                if (props.mode === 'manual') {
                    if (status === 'loading') return slots.loading?.(slotProps) ?? vue.createVNode(VProgressCircular, {
                        "indeterminate": true,
                        "color": props.color
                    }, null);
                    return slots['load-more']?.(slotProps) ?? vue.createVNode(VBtn, {
                        "variant": "outlined",
                        "color": props.color,
                        "onClick": onClick
                    }, {
                        default: ()=>[
                                t(props.loadMoreText)
                            ]
                    });
                }
                return slots.loading?.(slotProps) ?? vue.createVNode(VProgressCircular, {
                    "indeterminate": true,
                    "color": props.color
                }, null);
            }
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            useRender(()=>{
                const Tag = props.tag;
                const hasStartIntersect = props.side === 'start' || props.side === 'both';
                const hasEndIntersect = props.side === 'end' || props.side === 'both';
                const intersectMode = props.mode === 'intersect';
                return vue.createVNode(Tag, {
                    "ref": rootEl,
                    "class": vue.normalizeClass([
                        'v-infinite-scroll',
                        `v-infinite-scroll--${props.direction}`,
                        {
                            'v-infinite-scroll--start': hasStartIntersect,
                            'v-infinite-scroll--end': hasEndIntersect
                        }
                    ]),
                    "style": vue.normalizeStyle(dimensionStyles.value)
                }, {
                    default: ()=>[
                            vue.createElementVNode("div", {
                                "class": "v-infinite-scroll__side"
                            }, [
                                renderSide('start', startStatus.value)
                            ]),
                            hasStartIntersect && intersectMode && vue.createVNode(VInfiniteScrollIntersect, {
                                "key": "start",
                                "side": "start",
                                "onIntersect": handleIntersect,
                                "rootMargin": margin.value
                            }, null),
                            slots.default?.(),
                            hasEndIntersect && intersectMode && vue.createVNode(VInfiniteScrollIntersect, {
                                "key": "end",
                                "side": "end",
                                "onIntersect": handleIntersect,
                                "rootMargin": margin.value
                            }, null),
                            vue.createElementVNode("div", {
                                "class": "v-infinite-scroll__side"
                            }, [
                                renderSide('end', endStatus.value)
                            ])
                        ]
                });
            });
            function reset(side) {
                const effectiveSide = side ?? props.side;
                setStatus(effectiveSide, 'ok');
                vue.nextTick(()=>{
                    if (effectiveSide !== 'end') setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                    if (props.mode !== 'manual') vue.nextTick(()=>{
                        // See #17475
                        window.requestAnimationFrame(()=>{
                            window.requestAnimationFrame(()=>{
                                window.requestAnimationFrame(()=>{
                                    if (effectiveSide === 'both') {
                                        intersecting('start');
                                        intersecting('end');
                                    } else intersecting(effectiveSide);
                                });
                            });
                        });
                    });
                });
            }
            return {
                reset: reset
            };
        }
    });
    // Types
    const VItemGroupSymbol = Symbol.for('vuetify:v-item-group');
    const makeVItemGroupProps = propsFactory({
        ...makeComponentProps(),
        ...makeGroupProps({
            selectedClass: 'v-item--selected'
        }),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VItemGroup');
    const VItemGroup = genericComponent()({
        name: 'VItemGroup',
        props: makeVItemGroupProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { isSelected: isSelected, select: select, next: next, prev: prev, selected: selected } = useGroup(props, VItemGroupSymbol);
            return ()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-item-group',
                        themeClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, {
                    default: ()=>[
                            slots.default?.({
                                isSelected: isSelected,
                                select: select,
                                next: next,
                                prev: prev,
                                selected: selected.value
                            })
                        ]
                });
        }
    });
    // Composables
    const VItem = genericComponent()({
        name: 'VItem',
        props: makeGroupItemProps(),
        emits: {
            'group:selected': (val)=>true
        },
        setup (props, { slots: slots }) {
            const { isSelected: isSelected, select: select, toggle: toggle, selectedClass: selectedClass, value: value, disabled: disabled } = useGroupItem(props, VItemGroupSymbol);
            return ()=>slots.default?.({
                    isSelected: isSelected.value,
                    selectedClass: selectedClass.value,
                    select: select,
                    toggle: toggle,
                    value: value.value,
                    disabled: disabled.value
                });
        }
    });
    const makeVLayoutProps = propsFactory({
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeLayoutProps()
    }, 'VLayout');
    const VLayout = genericComponent()({
        name: 'VLayout',
        props: makeVLayoutProps(),
        setup (props, { slots: slots }) {
            const { layoutClasses: layoutClasses, layoutStyles: layoutStyles, getLayoutItem: getLayoutItem, items: items, layoutRef: layoutRef } = createLayout(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            useRender(()=>vue.createElementVNode("div", {
                    "ref": layoutRef,
                    "class": vue.normalizeClass([
                        layoutClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        dimensionStyles.value,
                        layoutStyles.value,
                        props.style
                    ])
                }, [
                    slots.default?.()
                ]));
            return {
                getLayoutItem: getLayoutItem,
                items: items
            };
        }
    });
    // Types
    const makeVLayoutItemProps = propsFactory({
        position: {
            type: String,
            required: true
        },
        size: {
            type: [
                Number,
                String
            ],
            default: 300
        },
        modelValue: Boolean,
        ...makeComponentProps(),
        ...makeLayoutItemProps()
    }, 'VLayoutItem');
    const VLayoutItem = genericComponent()({
        name: 'VLayoutItem',
        props: makeVLayoutItemProps(),
        setup (props, { slots: slots }) {
            const { layoutItemStyles: layoutItemStyles } = useLayoutItem({
                id: props.name,
                order: vue.computed(()=>parseInt(props.order, 10)),
                position: vue.toRef(()=>props.position),
                elementSize: vue.toRef(()=>props.size),
                layoutSize: vue.toRef(()=>props.size),
                active: vue.toRef(()=>props.modelValue),
                absolute: vue.toRef(()=>props.absolute)
            });
            return ()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-layout-item',
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        layoutItemStyles.value,
                        props.style
                    ])
                }, [
                    slots.default?.()
                ]);
        }
    });
    // Types
    const makeVLazyProps = propsFactory({
        modelValue: Boolean,
        options: {
            type: Object,
            // For more information on types, navigate to:
            // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
            default: ()=>({
                    root: undefined,
                    rootMargin: undefined,
                    threshold: undefined
                })
        },
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeTagProps(),
        ...makeTransitionProps({
            transition: 'fade-transition'
        })
    }, 'VLazy');
    const VLazy = genericComponent()({
        name: 'VLazy',
        directives: {
            vIntersect: Intersect
        },
        props: makeVLazyProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const isActive = useProxiedModel(props, 'modelValue');
            function onIntersect(isIntersecting) {
                if (isActive.value) return;
                isActive.value = isIntersecting;
            }
            useRender(()=>vue.withDirectives(vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-lazy',
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        dimensionStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            isActive.value && vue.createVNode(MaybeTransition, {
                                "transition": props.transition,
                                "appear": true
                            }, {
                                default: ()=>[
                                        slots.default?.()
                                    ]
                            })
                        ]
                }), [
                    [
                        Intersect,
                        {
                            handler: onIntersect,
                            options: props.options
                        },
                        null
                    ]
                ]));
            return {};
        }
    });
    const makeVLocaleProviderProps = propsFactory({
        locale: String,
        fallbackLocale: String,
        messages: Object,
        rtl: {
            type: Boolean,
            default: undefined
        },
        ...makeComponentProps()
    }, 'VLocaleProvider');
    const VLocaleProvider = genericComponent()({
        name: 'VLocaleProvider',
        props: makeVLocaleProviderProps(),
        setup (props, { slots: slots }) {
            const { rtlClasses: rtlClasses } = provideLocale(props);
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-locale-provider',
                        rtlClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, [
                    slots.default?.()
                ]));
            return {};
        }
    });
    const makeVMainProps = propsFactory({
        scrollable: Boolean,
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeTagProps({
            tag: 'main'
        })
    }, 'VMain');
    const VMain = genericComponent()({
        name: 'VMain',
        props: makeVMainProps(),
        setup (props, { slots: slots }) {
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { mainStyles: mainStyles } = useLayout();
            const { ssrBootStyles: ssrBootStyles } = useSsrBoot();
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-main',
                        {
                            'v-main--scrollable': props.scrollable
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        mainStyles.value,
                        ssrBootStyles.value,
                        dimensionStyles.value,
                        props.style
                    ])
                }, {
                    default: ()=>[
                            props.scrollable ? vue.createElementVNode("div", {
                                "class": "v-main__scroller"
                            }, [
                                slots.default?.()
                            ]) : slots.default?.()
                        ]
                }));
            return {};
        }
    });
    // Utilities
    // Types
    function useSticky({ rootEl: rootEl, isSticky: isSticky, layoutItemStyles: layoutItemStyles }) {
        const isStuck = vue.shallowRef(false);
        const stuckPosition = vue.shallowRef(0);
        const stickyStyles = vue.computed(()=>{
            const side = typeof isStuck.value === 'boolean' ? 'top' : isStuck.value;
            return [
                isSticky.value ? {
                    top: 'auto',
                    bottom: 'auto',
                    height: undefined
                } : undefined,
                isStuck.value ? {
                    [side]: convertToUnit(stuckPosition.value)
                } : {
                    top: layoutItemStyles.value.top
                }
            ];
        });
        vue.onMounted(()=>{
            vue.watch(isSticky, (val)=>{
                if (val) window.addEventListener('scroll', onScroll, {
                    passive: true
                });
                else window.removeEventListener('scroll', onScroll);
            }, {
                immediate: true
            });
        });
        vue.onBeforeUnmount(()=>{
            window.removeEventListener('scroll', onScroll);
        });
        let lastScrollTop = 0;
        function onScroll() {
            const direction = lastScrollTop > window.scrollY ? 'up' : 'down';
            const rect = rootEl.value.getBoundingClientRect();
            const layoutTop = parseFloat(layoutItemStyles.value.top ?? 0);
            const top = window.scrollY - Math.max(0, stuckPosition.value - layoutTop);
            const bottom = rect.height + Math.max(stuckPosition.value, layoutTop) - window.scrollY - window.innerHeight;
            const bodyScroll = parseFloat(getComputedStyle(rootEl.value).getPropertyValue('--v-body-scroll-y')) || 0;
            if (rect.height < window.innerHeight - layoutTop) {
                isStuck.value = 'top';
                stuckPosition.value = layoutTop;
            } else if (direction === 'up' && isStuck.value === 'bottom' || direction === 'down' && isStuck.value === 'top') {
                stuckPosition.value = window.scrollY + rect.top - bodyScroll;
                isStuck.value = true;
            } else if (direction === 'down' && bottom <= 0) {
                stuckPosition.value = 0;
                isStuck.value = 'bottom';
            } else if (direction === 'up' && top <= 0) {
                if (!bodyScroll) {
                    stuckPosition.value = rect.top + top;
                    isStuck.value = 'top';
                } else if (isStuck.value !== 'top') {
                    stuckPosition.value = -top + bodyScroll + layoutTop;
                    isStuck.value = 'top';
                }
            }
            lastScrollTop = window.scrollY;
        }
        return {
            isStuck: isStuck,
            stickyStyles: stickyStyles
        };
    }
    // Utilities
    const HORIZON = 100; // ms
    const HISTORY = 20; // number of samples to keep
    /** @see https://android.googlesource.com/platform/frameworks/native/+/master/libs/input/VelocityTracker.cpp */ function kineticEnergyToVelocity(work) {
        const sqrt2 = 1.41421356237;
        return (work < 0 ? -1 : 1.0) * Math.sqrt(Math.abs(work)) * sqrt2;
    }
    /**
   * Returns pointer velocity in px/s
   */ function calculateImpulseVelocity(samples) {
        // The input should be in reversed time order (most recent sample at index i=0)
        if (samples.length < 2) // if 0 or 1 points, velocity is zero
        return 0;
        // if (samples[1].t > samples[0].t) {
        //   // Algorithm will still work, but not perfectly
        //   consoleWarn('Samples provided to calculateImpulseVelocity in the wrong order')
        // }
        if (samples.length === 2) {
            // if 2 points, basic linear calculation
            if (samples[1].t === samples[0].t) // consoleWarn(`Events have identical time stamps t=${samples[0].t}, setting velocity = 0`)
            return 0;
            return (samples[1].d - samples[0].d) / (samples[1].t - samples[0].t);
        }
        // Guaranteed to have at least 3 points here
        // start with the oldest sample and go forward in time
        let work = 0;
        for(let i = samples.length - 1; i > 0; i--){
            if (samples[i].t === samples[i - 1].t) continue;
            const vprev = kineticEnergyToVelocity(work); // v[i-1]
            const vcurr = (samples[i].d - samples[i - 1].d) / (samples[i].t - samples[i - 1].t); // v[i]
            work += (vcurr - vprev) * Math.abs(vcurr);
            if (i === samples.length - 1) work *= 0.5;
        }
        return kineticEnergyToVelocity(work) * 1000;
    }
    function useVelocity() {
        const touches = {};
        function addMovement(e) {
            Array.from(e.changedTouches).forEach((touch)=>{
                const samples = touches[touch.identifier] ?? (touches[touch.identifier] = new CircularBuffer(HISTORY));
                samples.push([
                    e.timeStamp,
                    touch
                ]);
            });
        }
        function endTouch(e) {
            Array.from(e.changedTouches).forEach((touch)=>{
                delete touches[touch.identifier];
            });
        }
        function getVelocity(id) {
            const samples = touches[id]?.values().reverse();
            if (!samples) throw new Error(`No samples for touch id ${id}`);
            const newest = samples[0];
            const x = [];
            const y = [];
            for (const val of samples){
                if (newest[0] - val[0] > HORIZON) break;
                x.push({
                    t: val[0],
                    d: val[1].clientX
                });
                y.push({
                    t: val[0],
                    d: val[1].clientY
                });
            }
            return {
                x: calculateImpulseVelocity(x),
                y: calculateImpulseVelocity(y),
                get direction () {
                    const { x: x, y: y } = this;
                    const [absX, absY] = [
                        Math.abs(x),
                        Math.abs(y)
                    ];
                    return absX > absY && x >= 0 ? 'right' : absX > absY && x <= 0 ? 'left' : absY > absX && y >= 0 ? 'down' : absY > absX && y <= 0 ? 'up' : oops$1();
                }
            };
        }
        return {
            addMovement: addMovement,
            endTouch: endTouch,
            getVelocity: getVelocity
        };
    }
    function oops$1() {
        throw new Error();
    }
    // Composables
    // Types
    function useTouch({ el: el, isActive: isActive, isTemporary: isTemporary, width: width, touchless: touchless, position: position }) {
        vue.onMounted(()=>{
            window.addEventListener('touchstart', onTouchstart, {
                passive: true
            });
            window.addEventListener('touchmove', onTouchmove, {
                passive: false
            });
            window.addEventListener('touchend', onTouchend, {
                passive: true
            });
        });
        vue.onBeforeUnmount(()=>{
            window.removeEventListener('touchstart', onTouchstart);
            window.removeEventListener('touchmove', onTouchmove);
            window.removeEventListener('touchend', onTouchend);
        });
        const isHorizontal = vue.computed(()=>[
                'left',
                'right'
            ].includes(position.value));
        const { addMovement: addMovement, endTouch: endTouch, getVelocity: getVelocity } = useVelocity();
        let maybeDragging = false;
        const isDragging = vue.shallowRef(false);
        const dragProgress = vue.shallowRef(0);
        const offset = vue.shallowRef(0);
        let start;
        function getOffset(pos, active) {
            return (position.value === 'left' ? pos : position.value === 'right' ? document.documentElement.clientWidth - pos : position.value === 'top' ? pos : position.value === 'bottom' ? document.documentElement.clientHeight - pos : oops()) - (active ? width.value : 0);
        }
        function getProgress(pos, limit = true) {
            const progress = position.value === 'left' ? (pos - offset.value) / width.value : position.value === 'right' ? (document.documentElement.clientWidth - pos - offset.value) / width.value : position.value === 'top' ? (pos - offset.value) / width.value : position.value === 'bottom' ? (document.documentElement.clientHeight - pos - offset.value) / width.value : oops();
            return limit ? clamp(progress) : progress;
        }
        function onTouchstart(e) {
            if (touchless.value) return;
            const touchX = e.changedTouches[0].clientX;
            const touchY = e.changedTouches[0].clientY;
            const touchZone = 25;
            const inTouchZone = position.value === 'left' ? touchX < touchZone : position.value === 'right' ? touchX > document.documentElement.clientWidth - touchZone : position.value === 'top' ? touchY < touchZone : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - touchZone : oops();
            const inElement = isActive.value && (position.value === 'left' ? touchX < width.value : position.value === 'right' ? touchX > document.documentElement.clientWidth - width.value : position.value === 'top' ? touchY < width.value : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - width.value : oops());
            if (inTouchZone || inElement || isActive.value && isTemporary.value) {
                start = [
                    touchX,
                    touchY
                ];
                offset.value = getOffset(isHorizontal.value ? touchX : touchY, isActive.value);
                dragProgress.value = getProgress(isHorizontal.value ? touchX : touchY);
                maybeDragging = offset.value > -20 && offset.value < 80;
                endTouch(e);
                addMovement(e);
            }
        }
        function onTouchmove(e) {
            const touchX = e.changedTouches[0].clientX;
            const touchY = e.changedTouches[0].clientY;
            if (maybeDragging) {
                if (!e.cancelable) {
                    maybeDragging = false;
                    return;
                }
                const dx = Math.abs(touchX - start[0]);
                const dy = Math.abs(touchY - start[1]);
                const thresholdMet = isHorizontal.value ? dx > dy && dx > 3 : dy > dx && dy > 3;
                if (thresholdMet) {
                    isDragging.value = true;
                    maybeDragging = false;
                } else if ((isHorizontal.value ? dy : dx) > 3) maybeDragging = false;
            }
            if (!isDragging.value) return;
            e.preventDefault();
            addMovement(e);
            const progress = getProgress(isHorizontal.value ? touchX : touchY, false);
            dragProgress.value = Math.max(0, Math.min(1, progress));
            if (progress > 1) offset.value = getOffset(isHorizontal.value ? touchX : touchY, true);
            else if (progress < 0) offset.value = getOffset(isHorizontal.value ? touchX : touchY, false);
        }
        function onTouchend(e) {
            maybeDragging = false;
            if (!isDragging.value) return;
            addMovement(e);
            isDragging.value = false;
            const velocity = getVelocity(e.changedTouches[0].identifier);
            const vx = Math.abs(velocity.x);
            const vy = Math.abs(velocity.y);
            const thresholdMet = isHorizontal.value ? vx > vy && vx > 400 : vy > vx && vy > 3;
            if (thresholdMet) isActive.value = velocity.direction === (({
                left: 'right',
                right: 'left',
                top: 'down',
                bottom: 'up'
            })[position.value] || oops());
            else isActive.value = dragProgress.value > 0.5;
        }
        const dragStyles = vue.computed(()=>{
            return isDragging.value ? {
                transform: position.value === 'left' ? `translateX(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'right' ? `translateX(calc(100% - ${dragProgress.value * width.value}px))` : position.value === 'top' ? `translateY(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'bottom' ? `translateY(calc(100% - ${dragProgress.value * width.value}px))` : oops(),
                transition: 'none'
            } : undefined;
        });
        useToggleScope(isDragging, ()=>{
            const transform = el.value?.style.transform ?? null;
            const transition = el.value?.style.transition ?? null;
            vue.watchEffect(()=>{
                el.value?.style.setProperty('transform', dragStyles.value?.transform || 'none');
                el.value?.style.setProperty('transition', dragStyles.value?.transition || null);
            });
            vue.onScopeDispose(()=>{
                el.value?.style.setProperty('transform', transform);
                el.value?.style.setProperty('transition', transition);
            });
        });
        return {
            isDragging: isDragging,
            dragProgress: dragProgress,
            dragStyles: dragStyles
        };
    }
    function oops() {
        throw new Error();
    }
    // Types
    const locations = [
        'start',
        'end',
        'left',
        'right',
        'top',
        'bottom'
    ];
    const makeVNavigationDrawerProps = propsFactory({
        color: String,
        disableResizeWatcher: Boolean,
        disableRouteWatcher: Boolean,
        expandOnHover: Boolean,
        floating: Boolean,
        modelValue: {
            type: Boolean,
            default: null
        },
        permanent: Boolean,
        rail: {
            type: Boolean,
            default: null
        },
        railWidth: {
            type: [
                Number,
                String
            ],
            default: 56
        },
        scrim: {
            type: [
                Boolean,
                String
            ],
            default: true
        },
        image: String,
        temporary: Boolean,
        persistent: Boolean,
        touchless: Boolean,
        width: {
            type: [
                Number,
                String
            ],
            default: 256
        },
        location: {
            type: String,
            default: 'start',
            validator: (value)=>locations.includes(value)
        },
        sticky: Boolean,
        ...makeBorderProps(),
        ...makeComponentProps(),
        ...makeDelayProps(),
        ...makeDisplayProps({
            mobile: null
        }),
        ...makeElevationProps(),
        ...makeLayoutItemProps(),
        ...makeRoundedProps(),
        ...omit(makeFocusTrapProps(), [
            'disableInitialFocus'
        ]),
        ...makeTagProps({
            tag: 'nav'
        }),
        ...makeThemeProps()
    }, 'VNavigationDrawer');
    const VNavigationDrawer = genericComponent()({
        name: 'VNavigationDrawer',
        props: makeVNavigationDrawerProps(),
        emits: {
            'update:modelValue': (val)=>true,
            'update:rail': (val)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { isRtl: isRtl } = useRtl();
            const { themeClasses: themeClasses } = provideTheme(props);
            const { borderClasses: borderClasses } = useBorder(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { displayClasses: displayClasses, mobile: mobile } = useDisplay(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const router = useRouter();
            const isActive = useProxiedModel(props, 'modelValue', null, (v)=>!!v);
            const { ssrBootStyles: ssrBootStyles } = useSsrBoot();
            const { scopeId: scopeId } = useScopeId();
            const rootEl = vue.ref();
            const isHovering = vue.shallowRef(false);
            const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = useDelay(props, (value)=>{
                isHovering.value = value;
            });
            const width = vue.computed(()=>{
                return props.rail && props.expandOnHover && isHovering.value ? Number(props.width) : Number(props.rail ? props.railWidth : props.width);
            });
            const location = vue.computed(()=>{
                return toPhysical(props.location, isRtl.value);
            });
            const isPersistent = vue.toRef(()=>props.persistent);
            const isTemporary = vue.computed(()=>!props.permanent && (mobile.value || props.temporary));
            const isSticky = vue.computed(()=>props.sticky && !isTemporary.value && location.value !== 'bottom');
            useFocusTrap(props, {
                isActive: isActive,
                localTop: isTemporary,
                contentEl: rootEl
            });
            useToggleScope(()=>props.expandOnHover && props.rail != null, ()=>{
                vue.watch(isHovering, (val)=>emit('update:rail', !val));
            });
            useToggleScope(()=>!props.disableResizeWatcher, ()=>{
                vue.watch(isTemporary, (val)=>!props.permanent && vue.nextTick(()=>isActive.value = !val));
            });
            useToggleScope(()=>!props.disableRouteWatcher && !!router, ()=>{
                vue.watch(router.currentRoute, ()=>isTemporary.value && (isActive.value = false));
            });
            vue.watch(()=>props.permanent, (val)=>{
                if (val) isActive.value = true;
            });
            if (props.modelValue == null && !isTemporary.value) isActive.value = props.permanent || !mobile.value;
            const { isDragging: isDragging, dragProgress: dragProgress } = useTouch({
                el: rootEl,
                isActive: isActive,
                isTemporary: isTemporary,
                width: width,
                touchless: vue.toRef(()=>props.touchless),
                position: location
            });
            const layoutSize = vue.computed(()=>{
                const size = isTemporary.value ? 0 : props.rail && props.expandOnHover ? Number(props.railWidth) : width.value;
                return isDragging.value ? size * dragProgress.value : size;
            });
            const { layoutItemStyles: layoutItemStyles, layoutItemScrimStyles: layoutItemScrimStyles } = useLayoutItem({
                id: props.name,
                order: vue.computed(()=>parseInt(props.order, 10)),
                position: location,
                layoutSize: layoutSize,
                elementSize: width,
                active: vue.readonly(isActive),
                disableTransitions: vue.toRef(()=>isDragging.value),
                absolute: vue.computed(()=>// eslint-disable-next-line @typescript-eslint/no-use-before-define
                    props.absolute || isSticky.value && typeof isStuck.value !== 'string')
            });
            const { isStuck: isStuck, stickyStyles: stickyStyles } = useSticky({
                rootEl: rootEl,
                isSticky: isSticky,
                layoutItemStyles: layoutItemStyles
            });
            const scrimColor = useBackgroundColor(()=>{
                return typeof props.scrim === 'string' ? props.scrim : null;
            });
            const scrimStyles = vue.computed(()=>({
                    ...isDragging.value ? {
                        opacity: dragProgress.value * 0.2,
                        transition: 'none'
                    } : undefined,
                    ...layoutItemScrimStyles.value
                }));
            provideDefaults({
                VList: {
                    bgColor: 'transparent'
                }
            });
            useRender(()=>{
                const hasImage = slots.image || props.image;
                return vue.createElementVNode(vue.Fragment, null, [
                    vue.createVNode(props.tag, vue.mergeProps({
                        "ref": rootEl,
                        "onMouseenter": runOpenDelay,
                        "onMouseleave": runCloseDelay,
                        "class": [
                            'v-navigation-drawer',
                            `v-navigation-drawer--${location.value}`,
                            {
                                'v-navigation-drawer--expand-on-hover': props.expandOnHover,
                                'v-navigation-drawer--floating': props.floating,
                                'v-navigation-drawer--is-hovering': isHovering.value,
                                'v-navigation-drawer--rail': props.rail,
                                'v-navigation-drawer--temporary': isTemporary.value,
                                'v-navigation-drawer--persistent': isPersistent.value,
                                'v-navigation-drawer--active': isActive.value,
                                'v-navigation-drawer--sticky': isSticky.value
                            },
                            themeClasses.value,
                            backgroundColorClasses.value,
                            borderClasses.value,
                            displayClasses.value,
                            elevationClasses.value,
                            roundedClasses.value,
                            props.class
                        ],
                        "style": [
                            backgroundColorStyles.value,
                            layoutItemStyles.value,
                            ssrBootStyles.value,
                            stickyStyles.value,
                            roundedStyles.value,
                            props.style
                        ],
                        "inert": !isActive.value
                    }, scopeId, attrs), {
                        default: ()=>[
                                hasImage && vue.createElementVNode("div", {
                                    "key": "image",
                                    "class": "v-navigation-drawer__img"
                                }, [
                                    !slots.image ? vue.createVNode(VImg, {
                                        "key": "image-img",
                                        "alt": "",
                                        "cover": true,
                                        "height": "inherit",
                                        "src": props.image
                                    }, null) : vue.createVNode(VDefaultsProvider, {
                                        "key": "image-defaults",
                                        "disabled": !props.image,
                                        "defaults": {
                                            VImg: {
                                                alt: '',
                                                cover: true,
                                                height: 'inherit',
                                                src: props.image
                                            }
                                        }
                                    }, slots.image)
                                ]),
                                slots.prepend && vue.createElementVNode("div", {
                                    "class": "v-navigation-drawer__prepend"
                                }, [
                                    slots.prepend?.()
                                ]),
                                vue.createElementVNode("div", {
                                    "class": "v-navigation-drawer__content"
                                }, [
                                    slots.default?.()
                                ]),
                                slots.append && vue.createElementVNode("div", {
                                    "class": "v-navigation-drawer__append"
                                }, [
                                    slots.append?.()
                                ])
                            ]
                    }),
                    vue.createVNode(vue.Transition, {
                        "name": "fade-transition"
                    }, {
                        default: ()=>[
                                isTemporary.value && (isDragging.value || isActive.value) && !!props.scrim && vue.createElementVNode("div", vue.mergeProps({
                                    "class": [
                                        'v-navigation-drawer__scrim',
                                        scrimColor.backgroundColorClasses.value
                                    ],
                                    "style": [
                                        scrimStyles.value,
                                        scrimColor.backgroundColorStyles.value
                                    ],
                                    "onClick": ()=>{
                                        if (isPersistent.value) return;
                                        isActive.value = false;
                                    }
                                }, scopeId), null)
                            ]
                    })
                ]);
            });
            return {
                isStuck: isStuck
            };
        }
    });
    // Composables
    const VNoSsr = defineComponent({
        name: 'VNoSsr',
        setup (_, { slots: slots }) {
            const show = useHydration();
            return ()=>show.value && slots.default?.();
        }
    });
    const NUMERAL_ZEROS = [
        0x0660,
        // Arabic-Indic
        0x06F0,
        // Extended Arabic-Indic — Persian, Dari
        0x0966,
        // Devanagari
        0x09E6,
        // Bengali
        0x0A66,
        // Gurmukhi
        0x0AE6,
        // Gujarati
        0x0B66,
        // Oriya
        0x0BE6,
        // Tamil
        0x0C66,
        // Telugu
        0x0CE6,
        // Kannada
        0x0D66,
        // Malayalam
        0x0E50,
        // Thai
        0x0ED0,
        // Lao
        0x0F20,
        // Tibetan
        0x1040,
        // Myanmar
        0x17E0,
        // Khmer
        0x1810,
        // Mongolian
        0xFF10 // Fullwidth
    ];
    function normalizeDigits(str) {
        return str.replace(/[^\x20-\x7F]/g, (char)=>{
            const code = char.codePointAt(0);
            for (const zero of NUMERAL_ZEROS){
                if (code >= zero && code <= zero + 9) return String(code - zero);
            }
            return char;
        });
    }
    function formatNumber(val, options) {
        const { precision: precision, minFractionDigits: minFractionDigits } = options;
        const formatter = new Intl.NumberFormat(options.locale, {
            minimumFractionDigits: minFractionDigits && precision != null ? Math.min(minFractionDigits, precision) : minFractionDigits ?? precision ?? undefined,
            maximumFractionDigits: precision ?? 20,
            // Intl defaults are dynamic (0, 2, 3)
            useGrouping: options.useGrouping
        });
        return formatter.formatToParts(val).map((p)=>{
            if (p.type === 'group') return options.groupSeparator;
            if (p.type === 'decimal') return options.decimalSeparator;
            return normalizeDigits(p.value);
        }).join('');
    }
    // Utilities
    const HOLD_REPEAT = 50;
    const HOLD_DELAY = 500;
    function useHold({ toggleUpDown: toggleUpDown }) {
        let timeout = -1;
        let interval = -1;
        vue.onScopeDispose(holdStop);
        function holdStart(value) {
            holdStop();
            tick(value);
            window.addEventListener('pointerup', holdStop);
            document.addEventListener('blur', holdStop);
            timeout = window.setTimeout(()=>{
                interval = window.setInterval(()=>tick(value), HOLD_REPEAT);
            }, HOLD_DELAY);
        }
        function holdStop() {
            if (!IN_BROWSER) return;
            window.clearTimeout(timeout);
            window.clearInterval(interval);
            window.removeEventListener('pointerup', holdStop);
            document.removeEventListener('blur', holdStop);
        }
        vue.onScopeDispose(holdStop);
        function tick(value) {
            toggleUpDown(value === 'up');
        }
        return {
            holdStart: holdStart,
            holdStop: holdStop
        };
    }
    /* eslint-disable complexity */ function localizeMinusSign(text, minusSign) {
        return minusSign === '-' ? text : text.replace('-', minusSign);
    }
    function stripGrouping(text, groupSeparator) {
        return text.replaceAll(groupSeparator, '');
    }
    /** Fallback: fixed 3-digit groups */ function formatWithoutLocale(digits, groupSeparator, grouping) {
        if (grouping === 'min2' && digits.length <= 4) return digits;
        const groups = [];
        for(let i = digits.length; i > 0; i -= 3)groups.unshift(digits.slice(Math.max(0, i - 3), i));
        return groups.join(groupSeparator);
    }
    function addGrouping(raw, groupSeparator, decimalSeparator, grouping, locale) {
        if (!grouping) return raw;
        const decimalIndex = raw.indexOf(decimalSeparator);
        const integerPart = decimalIndex >= 0 ? raw.slice(0, decimalIndex) : raw;
        const rest = decimalIndex >= 0 ? raw.slice(decimalIndex) : '';
        const sign = integerPart.startsWith('-') ? '-' : '';
        const digits = sign ? integerPart.slice(1) : integerPart;
        if (!digits) return raw;
        if (locale) {
            const num = Number(digits);
            if (!Number.isFinite(num)) return raw;
            const grouped = new Intl.NumberFormat(locale, {
                useGrouping: grouping,
                numberingSystem: 'latn'
            }).formatToParts(num).map((p)=>p.type === 'group' ? groupSeparator : p.value).join('');
            return sign + grouped + rest;
        }
        return sign + formatWithoutLocale(digits, groupSeparator, grouping) + rest;
    }
    /** Count non-separator characters before displayPosition */ function toLogicalPosition(text, groupSeparator, displayPosition) {
        let logical = 0;
        for(let i = 0; i < displayPosition && i < text.length; i++)if (text[i] !== groupSeparator) logical++;
        return logical;
    }
    function toDisplayPosition(text, groupSeparator, logicalPosition) {
        let logical = 0;
        for(let i = 0; i <= text.length; i++){
            if (logical === logicalPosition) return i;
            if (i < text.length && text[i] !== groupSeparator) logical++;
        }
        return text.length;
    }
    /**
   * Process a beforeinput event for plain (non-grouped) number input.
   * Returns { text, cursor } when the input needs correction, or null to let browser handle it.
   */ function processPlainInput(data, value, selectionStart, selectionEnd, options) {
        if (!data) return null;
        const { decimalSeparator: decimalSeparator, precision: precision, minusSign: minusSign } = options;
        value = normalizeMinusSign(value);
        const beforePart = value.slice(0, selectionStart);
        let cleanData = extractNumber(data, precision, decimalSeparator);
        if (cleanData.startsWith('-') && beforePart.length > 0) cleanData = cleanData.slice(1);
        if (cleanData.includes(decimalSeparator) && beforePart.includes(decimalSeparator)) cleanData = cleanData.replace(decimalSeparator, '');
        const candidate = beforePart + cleanData + value.slice(selectionEnd);
        const validPattern = new RegExp(`^-?\\d*${escapeForRegex(decimalSeparator)}?\\d*$`);
        if (!validPattern.test(candidate)) return {
            text: localizeMinusSign(extractNumber(candidate, precision, decimalSeparator), minusSign),
            cursor: selectionStart
        };
        if (precision != null && (candidate.split(decimalSeparator)[1]?.length ?? 0) > precision) {
            const text = extractNumber(candidate, precision, decimalSeparator);
            return {
                text: localizeMinusSign(text, minusSign),
                cursor: text === beforePart + value.slice(selectionEnd) ? selectionStart : selectionStart + cleanData.length
            };
        }
        if (cleanData === data) return null;
        return {
            text: localizeMinusSign(candidate, minusSign),
            cursor: selectionStart + cleanData.length
        };
    }
    /**
   * Process a beforeinput event for grouped number input.
   * Returns { text, cursor } to apply, or null for interactions that do not need override
   */ function processGroupedInput(inputType, data, value, selectionStart, selectionEnd, options) {
        const { groupSeparator: groupSeparator, decimalSeparator: decimalSeparator, precision: precision, grouping: grouping, locale: locale, minusSign: minusSign } = options;
        value = normalizeMinusSign(value);
        data = data && normalizeMinusSign(data);
        const raw = stripGrouping(value, groupSeparator);
        const logicalStart = toLogicalPosition(value, groupSeparator, selectionStart);
        const logicalEnd = toLogicalPosition(value, groupSeparator, selectionEnd);
        const hasSelection = logicalStart !== logicalEnd;
        let newRaw;
        let newLogicalCursor;
        switch(inputType){
            case 'insertText':
                if (!data) return null;
                newRaw = raw.slice(0, logicalStart) + data + raw.slice(logicalEnd);
                newLogicalCursor = logicalStart + data.length;
                break;
            case 'insertFromPaste':
            case 'insertFromDrop':
                {
                    if (!data) return null;
                    const rawBefore = raw.slice(0, logicalStart);
                    let cleanData = extractNumber(data, precision, decimalSeparator);
                    if (cleanData.startsWith('-') && rawBefore.length > 0) cleanData = cleanData.slice(1);
                    if (cleanData.includes(decimalSeparator) && rawBefore.includes(decimalSeparator)) cleanData = cleanData.replace(decimalSeparator, '');
                    newRaw = rawBefore + cleanData + raw.slice(logicalEnd);
                    newLogicalCursor = logicalStart + cleanData.length;
                    break;
                }
            case 'deleteContentBackward':
                if (hasSelection) {
                    newRaw = raw.slice(0, logicalStart) + raw.slice(logicalEnd);
                    newLogicalCursor = logicalStart;
                } else if (logicalStart > 0) {
                    newRaw = raw.slice(0, logicalStart - 1) + raw.slice(logicalStart);
                    newLogicalCursor = logicalStart - 1;
                } else {
                    // At the start, nothing to delete
                    newRaw = raw;
                    newLogicalCursor = 0;
                }
                break;
            case 'deleteContentForward':
                if (hasSelection) {
                    newRaw = raw.slice(0, logicalStart) + raw.slice(logicalEnd);
                    newLogicalCursor = logicalStart;
                } else if (logicalStart < raw.length) {
                    newRaw = raw.slice(0, logicalStart) + raw.slice(logicalStart + 1);
                    newLogicalCursor = logicalStart;
                } else {
                    // At the end, nothing to delete
                    newRaw = raw;
                    newLogicalCursor = logicalStart;
                }
                break;
            case 'deleteByCut':
                newRaw = raw.slice(0, logicalStart) + raw.slice(logicalEnd);
                newLogicalCursor = logicalStart;
                break;
            case 'deleteWordBackward':
                if (hasSelection) {
                    newRaw = raw.slice(0, logicalStart) + raw.slice(logicalEnd);
                    newLogicalCursor = logicalStart;
                } else {
                    let deleteEnd = logicalStart;
                    // Skip non-digits first (e.g., decimal separator)
                    while(deleteEnd > 0 && !/\d/.test(raw[deleteEnd - 1]))deleteEnd--;
                    // Then skip digits
                    while(deleteEnd > 0 && /\d/.test(raw[deleteEnd - 1]))deleteEnd--;
                    newRaw = raw.slice(0, deleteEnd) + raw.slice(logicalStart);
                    newLogicalCursor = deleteEnd;
                }
                break;
            case 'deleteWordForward':
                if (hasSelection) {
                    newRaw = raw.slice(0, logicalStart) + raw.slice(logicalEnd);
                    newLogicalCursor = logicalStart;
                } else {
                    let deleteEnd = logicalStart;
                    while(deleteEnd < raw.length && !/\d/.test(raw[deleteEnd]))deleteEnd++;
                    while(deleteEnd < raw.length && /\d/.test(raw[deleteEnd]))deleteEnd++;
                    newRaw = raw.slice(0, logicalStart) + raw.slice(deleteEnd);
                    newLogicalCursor = logicalStart;
                }
                break;
            case 'deleteSoftLineBackward':
                newRaw = raw.slice(logicalEnd);
                newLogicalCursor = 0;
                break;
            case 'deleteSoftLineForward':
                newRaw = raw.slice(0, logicalStart);
                newLogicalCursor = logicalStart;
                break;
            default:
                return null;
        }
        const validPattern = new RegExp(`^-?\\d*${escapeForRegex(decimalSeparator)}?\\d*$`);
        if (!validPattern.test(newRaw)) {
            newRaw = extractNumber(newRaw, precision, decimalSeparator);
            newLogicalCursor = Math.min(newLogicalCursor, newRaw.length);
        }
        if (precision != null) {
            const parts = newRaw.split(decimalSeparator);
            if (parts[1]?.length > precision) {
                newRaw = parts[0] + decimalSeparator + parts[1].slice(0, precision);
                newLogicalCursor = Math.min(newLogicalCursor, newRaw.length);
            }
            if (precision === 0 && newRaw.endsWith(decimalSeparator)) {
                newRaw = newRaw.slice(0, -1);
                newLogicalCursor = Math.min(newLogicalCursor, newRaw.length);
            }
        }
        const formatted = addGrouping(newRaw, groupSeparator, decimalSeparator, grouping, locale);
        const cursor = toDisplayPosition(formatted, groupSeparator, newLogicalCursor);
        return {
            text: localizeMinusSign(formatted, minusSign),
            cursor: cursor
        };
    }
    // Types
    const makeVNumberInputProps = propsFactory({
        controlVariant: {
            type: String,
            default: 'default'
        },
        inset: Boolean,
        hideInput: Boolean,
        modelValue: {
            type: Number,
            default: null
        },
        min: {
            type: Number,
            default: Number.MIN_SAFE_INTEGER
        },
        max: {
            type: Number,
            default: Number.MAX_SAFE_INTEGER
        },
        step: {
            type: Number,
            default: 1
        },
        precision: {
            type: Number,
            default: 0
        },
        minFractionDigits: {
            type: Number,
            default: null
        },
        decimalSeparator: {
            type: String,
            validator: (v)=>!v || v.length === 1
        },
        grouping: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        groupSeparator: {
            type: String,
            validator: (v)=>!v || v.length === 1 && !/[0-9+-]/.test(v)
        },
        ...omit(makeVTextFieldProps(), [
            'modelValue',
            'validationValue'
        ])
    }, 'VNumberInput');
    const VNumberInput = genericComponent()({
        name: 'VNumberInput',
        props: {
            ...makeVNumberInputProps()
        },
        emits: {
            'update:focused': (val)=>true,
            'update:modelValue': (val)=>true
        },
        setup (props, { slots: slots }) {
            const vTextFieldRef = vue.ref();
            const { holdStart: holdStart, holdStop: holdStop } = useHold({
                toggleUpDown: toggleUpDown
            });
            const form = useForm(props);
            const controlsDisabled = vue.computed(()=>form.isDisabled.value || form.isReadonly.value);
            const isFocused = vue.shallowRef(props.focused);
            const { current: locale, decimalSeparator: decimalSeparatorFromLocale, numericGroupSeparator: numericGroupSeparatorFromLocale } = useLocale();
            const decimalSeparator = vue.computed(()=>props.decimalSeparator?.[0] || decimalSeparatorFromLocale.value);
            const groupSeparator = vue.computed(()=>{
                const separator = props.groupSeparator?.[0] || numericGroupSeparatorFromLocale.value;
                if (separator !== decimalSeparator.value) return separator;
                if (props.grouping) consoleWarn(`decimalSeparator and groupSeparator are both "${separator}", groups will not be separated`);
                return '';
            });
            const minusSign = vue.computed(()=>new Intl.NumberFormat(locale.value).formatToParts(-1).find((p)=>p.type === 'minusSign')?.value ?? '-');
            function toNumber(val) {
                return Number(normalizeMinusSign(val ?? '').replaceAll(groupSeparator.value, '').replace(decimalSeparator.value, '.').replace(/[^0-9.-]/g, ''));
            }
            function correctPrecision(val, precision, trim = true) {
                precision ??= isFocused.value && trim ? undefined : props.precision ?? undefined;
                return formatNumber(val, {
                    locale: locale.value,
                    precision: precision,
                    minFractionDigits: props.minFractionDigits,
                    useGrouping: props.grouping,
                    decimalSeparator: decimalSeparator.value,
                    groupSeparator: groupSeparator.value
                });
            }
            const model = useProxiedModel(props, 'modelValue', null, (val)=>val ?? null, (val)=>val == null ? val ?? null : clamp(Number(val), props.min, props.max));
            const _inputText = vue.shallowRef(null);
            const _lastParsedValue = vue.shallowRef(null);
            vue.watch(model, (val)=>{
                if (isFocused.value && !controlsDisabled.value && toNumber(_inputText.value) === val) ;
                else if (val == null) {
                    _inputText.value = null;
                    _lastParsedValue.value = null;
                } else if (!isNaN(val)) {
                    _inputText.value = correctPrecision(val);
                    _lastParsedValue.value = toNumber(_inputText.value);
                }
            }, {
                immediate: true
            });
            const inputText = vue.computed({
                get: ()=>_inputText.value,
                set (val) {
                    if (val === null || val === '') {
                        model.value = null;
                        _inputText.value = null;
                        _lastParsedValue.value = null;
                        return;
                    }
                    const parsedValue = toNumber(val);
                    if (!isNaN(parsedValue)) {
                        _inputText.value = val;
                        _lastParsedValue.value = parsedValue;
                        if (parsedValue <= props.max && parsedValue >= props.min) model.value = parsedValue;
                    }
                }
            });
            const isOutOfRange = vue.computed(()=>{
                if (_lastParsedValue.value === null) return false;
                const numberFromText = toNumber(_inputText.value);
                return numberFromText !== clamp(numberFromText, props.min, props.max);
            });
            function stepResult(increment) {
                const current = toNumber(inputText.value);
                const stepped = current + (increment ? props.step : -props.step);
                return {
                    current: current,
                    stepped: stepped,
                    next: clamp(stepped, props.min, props.max)
                };
            }
            const canIncrease = vue.computed(()=>{
                if (controlsDisabled.value) return false;
                if (model.value == null) return true;
                const { current: current, next: next } = stepResult(true);
                return next !== current;
            });
            const canDecrease = vue.computed(()=>{
                if (controlsDisabled.value) return false;
                if (model.value == null) return true;
                const { current: current, next: next } = stepResult(false);
                return next !== current;
            });
            const controlVariant = vue.computed(()=>{
                return props.hideInput ? 'stacked' : props.controlVariant;
            });
            const incrementIcon = vue.toRef(()=>controlVariant.value === 'split' ? '$plus' : '$collapse');
            const decrementIcon = vue.toRef(()=>controlVariant.value === 'split' ? '$minus' : '$expand');
            const controlNodeSize = vue.toRef(()=>controlVariant.value === 'split' ? 'default' : 'small');
            const controlNodeDefaultHeight = vue.toRef(()=>controlVariant.value === 'stacked' ? 'auto' : '100%');
            const incrementSlotProps = {
                props: {
                    onClick: onControlClick,
                    onPointerup: onControlMouseup,
                    onPointerdown: onUpControlMousedown,
                    onPointercancel: onControlMouseup
                }
            };
            const decrementSlotProps = {
                props: {
                    onClick: onControlClick,
                    onPointerup: onControlMouseup,
                    onPointerdown: onDownControlMousedown,
                    onPointercancel: onControlMouseup
                }
            };
            vue.watch(()=>[
                    locale.value,
                    decimalSeparator.value,
                    groupSeparator.value,
                    props.precision,
                    props.minFractionDigits
                ], ()=>formatInputValue());
            function inferPrecision(value) {
                if (value == null) return 0;
                const str = value.toString();
                const idx = str.indexOf('.') + 1;
                return idx ? str.length - idx : 0;
            }
            function emitChange() {
                vTextFieldRef.value?.controlRef?.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }
            function toggleUpDown(increment = true) {
                if (controlsDisabled.value) return;
                if (increment ? !canIncrease.value : !canDecrease.value) return;
                if (model.value == null) {
                    inputText.value = correctPrecision(clamp(0, props.min, props.max));
                    emitChange();
                    return;
                }
                const { current: current, stepped: stepped, next: next } = stepResult(increment);
                inputText.value = next === stepped ? correctPrecision(next, Math.max(inferPrecision(current), inferPrecision(props.step))) : correctPrecision(next);
                emitChange();
            }
            function onBeforeinput(e) {
                if (controlsDisabled.value) return;
                const inputElement = e.target;
                const result = props.grouping ? processGroupedInput(e.inputType, e.data, inputElement.value ?? '', inputElement.selectionStart ?? 0, inputElement.selectionEnd ?? 0, {
                    groupSeparator: groupSeparator.value,
                    decimalSeparator: decimalSeparator.value,
                    precision: props.precision,
                    grouping: props.grouping,
                    locale: locale.value,
                    minusSign: minusSign.value
                }) : processPlainInput(e.data, inputElement.value ?? '', inputElement.selectionStart ?? 0, inputElement.selectionEnd ?? 0, {
                    decimalSeparator: decimalSeparator.value,
                    precision: props.precision,
                    minusSign: minusSign.value
                });
                if (result === null) return;
                e.preventDefault();
                inputElement.value = result.text;
                inputElement.setSelectionRange(result.cursor, result.cursor);
                vue.nextTick(()=>inputText.value = result.text);
            }
            function onKeydown(e) {
                if ([
                    'Enter',
                    'ArrowLeft',
                    'ArrowRight',
                    'Backspace',
                    'Delete',
                    'Tab'
                ].includes(e.key) || e.ctrlKey) return;
                if ([
                    'ArrowDown',
                    'ArrowUp'
                ].includes(e.key)) {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleUpDown(e.key === 'ArrowUp');
                }
            }
            function onControlClick(e) {
                e.stopPropagation();
            }
            function onControlMouseup(e) {
                const el = e.currentTarget;
                el?.releasePointerCapture(e.pointerId);
                e.preventDefault();
                holdStop();
            }
            function onUpControlMousedown(e) {
                const el = e.currentTarget;
                el?.setPointerCapture(e.pointerId);
                e.preventDefault();
                e.stopPropagation();
                holdStart('up');
            }
            function onDownControlMousedown(e) {
                const el = e.currentTarget;
                el?.setPointerCapture(e.pointerId);
                e.preventDefault();
                e.stopPropagation();
                holdStart('down');
            }
            function clampModel() {
                if (controlsDisabled.value) return;
                if (!vTextFieldRef.value) return;
                const actualText = vTextFieldRef.value.value;
                const parsedValue = toNumber(actualText);
                if (actualText && !isNaN(parsedValue)) inputText.value = correctPrecision(clamp(parsedValue, props.min, props.max));
                else inputText.value = null;
            }
            function formatInputValue() {
                if (controlsDisabled.value) return;
                inputText.value = model.value !== null && !isNaN(model.value) ? correctPrecision(model.value, props.precision, false) : null;
            }
            function trimDecimalZeros() {
                if (controlsDisabled.value) return;
                if (model.value === null || isNaN(model.value)) {
                    inputText.value = null;
                    return;
                }
                inputText.value = correctPrecision(model.value);
            }
            function onFocus() {
                trimDecimalZeros();
            }
            function onBlur() {
                clampModel();
            }
            useRender(()=>{
                const { modelValue: _, type: type, ...textFieldProps } = VTextField.filterProps(props);
                function incrementControlNode() {
                    return !slots.increment ? vue.createVNode(VBtn, {
                        "aria-hidden": "true",
                        "data-testid": "increment",
                        "disabled": !canIncrease.value,
                        "height": controlNodeDefaultHeight.value,
                        "icon": incrementIcon.value,
                        "key": "increment-btn",
                        "onClick": onControlClick,
                        "onPointerdown": onUpControlMousedown,
                        "onPointerup": onControlMouseup,
                        "onPointercancel": onControlMouseup,
                        "size": controlNodeSize.value,
                        "variant": "text",
                        "tabindex": "-1"
                    }, null) : vue.createVNode(VDefaultsProvider, {
                        "key": "increment-defaults",
                        "defaults": {
                            VBtn: {
                                disabled: !canIncrease.value,
                                height: controlNodeDefaultHeight.value,
                                size: controlNodeSize.value,
                                icon: incrementIcon.value,
                                variant: 'text'
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.increment(incrementSlotProps)
                            ]
                    });
                }
                function decrementControlNode() {
                    return !slots.decrement ? vue.createVNode(VBtn, {
                        "aria-hidden": "true",
                        "data-testid": "decrement",
                        "disabled": !canDecrease.value,
                        "height": controlNodeDefaultHeight.value,
                        "icon": decrementIcon.value,
                        "key": "decrement-btn",
                        "onClick": onControlClick,
                        "onPointerdown": onDownControlMousedown,
                        "onPointerup": onControlMouseup,
                        "onPointercancel": onControlMouseup,
                        "size": controlNodeSize.value,
                        "variant": "text",
                        "tabindex": "-1"
                    }, null) : vue.createVNode(VDefaultsProvider, {
                        "key": "decrement-defaults",
                        "defaults": {
                            VBtn: {
                                disabled: !canDecrease.value,
                                height: controlNodeDefaultHeight.value,
                                size: controlNodeSize.value,
                                icon: decrementIcon.value,
                                variant: 'text'
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.decrement(decrementSlotProps)
                            ]
                    });
                }
                function controlNode() {
                    return vue.createElementVNode("div", {
                        "class": "v-number-input__control"
                    }, [
                        decrementControlNode(),
                        vue.createVNode(VDivider, {
                            "vertical": controlVariant.value !== 'stacked'
                        }, null),
                        incrementControlNode()
                    ]);
                }
                function dividerNode() {
                    return !props.hideInput && !props.inset ? vue.createVNode(VDivider, {
                        "vertical": true
                    }, null) : undefined;
                }
                const appendInnerControl = controlVariant.value === 'split' ? vue.createElementVNode("div", {
                    "class": "v-number-input__control"
                }, [
                    vue.createVNode(VDivider, {
                        "vertical": true
                    }, null),
                    incrementControlNode()
                ]) : props.reverse || controlVariant.value === 'hidden' ? undefined : vue.createElementVNode(vue.Fragment, null, [
                    dividerNode(),
                    controlNode()
                ]);
                const hasAppendInner = slots['append-inner'] || appendInnerControl;
                const prependInnerControl = controlVariant.value === 'split' ? vue.createElementVNode("div", {
                    "class": "v-number-input__control"
                }, [
                    decrementControlNode(),
                    vue.createVNode(VDivider, {
                        "vertical": true
                    }, null)
                ]) : props.reverse && controlVariant.value !== 'hidden' ? vue.createElementVNode(vue.Fragment, null, [
                    controlNode(),
                    dividerNode()
                ]) : undefined;
                const hasPrependInner = slots['prepend-inner'] || prependInnerControl;
                return vue.createVNode(VTextField, vue.mergeProps({
                    "ref": vTextFieldRef
                }, textFieldProps, {
                    "modelValue": inputText.value,
                    "onUpdate:modelValue": ($event)=>inputText.value = $event,
                    "focused": isFocused.value,
                    "onUpdate:focused": ($event)=>isFocused.value = $event,
                    "validationValue": model.value,
                    "error": props.error || isOutOfRange.value || undefined,
                    "onBeforeinput": onBeforeinput,
                    "onFocus": onFocus,
                    "onBlur": onBlur,
                    "onKeydown": onKeydown,
                    "class": [
                        'v-number-input',
                        {
                            'v-number-input--default': controlVariant.value === 'default',
                            'v-number-input--hide-input': props.hideInput,
                            'v-number-input--inset': props.inset,
                            'v-number-input--reverse': props.reverse,
                            'v-number-input--split': controlVariant.value === 'split',
                            'v-number-input--stacked': controlVariant.value === 'stacked'
                        },
                        props.class
                    ],
                    "style": props.style,
                    "inputmode": "decimal"
                }), {
                    ...slots,
                    'append-inner': hasAppendInner ? (...args)=>vue.createElementVNode(vue.Fragment, null, [
                            slots['append-inner']?.(...args),
                            appendInnerControl
                        ]) : undefined,
                    'prepend-inner': hasPrependInner ? (...args)=>vue.createElementVNode(vue.Fragment, null, [
                            prependInnerControl,
                            slots['prepend-inner']?.(...args)
                        ]) : undefined
                });
            });
            return forwardRefs({}, vTextFieldRef);
        }
    });
    // Types
    const VOtpInputSymbol = Symbol.for('vuetify:v-otp-input');
    const makeVOtpFieldProps = propsFactory({
        index: {
            type: Number,
            required: true
        }
    }, 'VOtpField');
    const VOtpField = genericComponent()({
        name: 'VOtpField',
        props: makeVOtpFieldProps(),
        setup (props) {
            const otpInput = vue.inject(VOtpInputSymbol);
            if (!otpInput) throw new Error('[Vuetify] VOtpField must be used inside VOtpInput');
            const slot = vue.computed(()=>otpInput.otpSlots.value[props.index]);
            const isHighlighted = vue.computed(()=>otpInput.isFocused.value && otpInput.focusAll.value && !slot.value?.isActive);
            useRender(()=>{
                if (!slot.value) return vue.createCommentVNode();
                return vue.createVNode(VField, {
                    "data-otp-index": props.index,
                    "focused": slot.value.isActive || isHighlighted.value,
                    "class": vue.normalizeClass({
                        'v-otp-input__field--highlighted': isHighlighted.value
                    }),
                    "onMousedown": (e)=>e.preventDefault(),
                    "onClick": ()=>otpInput.focusAt(props.index)
                }, {
                    loader: undefined,
                    default: ()=>vue.createElementVNode("div", {
                            "class": "v-otp-input__field"
                        }, [
                            vue.createElementVNode("input", {
                                "class": "v-otp-input__spacer",
                                "aria-hidden": "true",
                                "tabindex": "-1"
                            }, null),
                            slot.value.compositionChar ? vue.createElementVNode("span", {
                                "class": "v-otp-input__composition"
                            }, [
                                slot.value.compositionChar
                            ]) : slot.value.hasFakeCaret ? vue.createElementVNode("span", {
                                "class": "v-otp-input__caret"
                            }, null) : vue.createElementVNode("span", {
                                "class": vue.normalizeClass(!slot.value.char ? 'v-otp-input__placeholder' : undefined)
                            }, [
                                slot.value.char ?? slot.value.placeholderChar ?? ''
                            ])
                        ])
                });
            });
        }
    });
    // Utilities
    // Types
    function countSlotChildren(vnodes) {
        let count = 0;
        for (const vnode of vnodes)if (vnode.type === vue.Fragment && Array.isArray(vnode.children)) count += countSlotChildren(vnode.children);
        else count++;
        return count;
    }
    const makeVOtpGroupProps = propsFactory({
        merged: {
            type: Boolean,
            default: null
        }
    }, 'VOtpGroup');
    const VOtpGroup = genericComponent()({
        name: 'VOtpGroup',
        props: makeVOtpGroupProps(),
        setup (props, { slots: slots }) {
            const otpInput = vue.inject(VOtpInputSymbol);
            const isMerged = vue.computed(()=>props.merged ?? otpInput?.merged.value ?? false);
            useRender(()=>{
                const children = slots.default?.() ?? [];
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-otp-group',
                        {
                            'v-otp-group--merged': isMerged.value
                        }
                    ]),
                    "style": vue.normalizeStyle(isMerged.value ? {
                        flex: countSlotChildren(children)
                    } : undefined)
                }, [
                    children
                ]);
            });
        }
    });
    // Utilities
    const VOtpSeparator = createSimpleFunctional('v-otp-input__divider');
    // to be replaced by v0 implementation in v5.0
    // Types
    const OtpInputPatterns = {
        numeric: /[0-9]/,
        alpha: /[a-zA-Z]/,
        alphanumeric: /[a-zA-Z0-9]/,
        'unicode-alpha': /\p{L}/u,
        'unicode-alphanumeric': /[\p{L}\p{N}]/u
    };
    const IME_SCRIPT_RE = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}\p{Script=Bopomofo}]/u;
    const graphemeSegmenter = /* @__PURE__ */ new Intl.Segmenter(undefined, {
        granularity: 'grapheme'
    });
    function useOtpInput(options) {
        const { value: value, length: _length = 6, pattern: pattern, type: type = 'number', masked: masked = false, placeholder: placeholder, isFocused: isFocused = vue.shallowRef(false) } = options;
        const selection = vue.shallowRef(null);
        const composition = vue.shallowRef('');
        const isComposing = vue.shallowRef(false);
        let prevSelection = null;
        // Shift+Arrow anchor/focus tracked in grapheme space.
        let anchorG = null;
        let focusG = null;
        const length = vue.toRef(()=>Number(vue.toValue(_length)));
        const isMasked = vue.toRef(()=>vue.toValue(masked) || vue.toValue(type) === 'password');
        const effectivePattern = vue.toRef(()=>{
            const p = vue.toValue(pattern);
            if (p instanceof RegExp) return p;
            if (p != null) return OtpInputPatterns[p] ?? null;
            if (vue.toValue(type) === 'number') return OtpInputPatterns.numeric;
            return null;
        });
        const inputMode = vue.toRef(()=>effectivePattern.value === OtpInputPatterns.numeric ? 'numeric' : 'text');
        // Selection is stored in code units (for `setSelectionRange`), but every slot
        // boundary works in grapheme space so emoji, ZWJ sequences and skin-tone
        // modifiers each occupy one slot.
        function graphemes(s) {
            return Array.from(graphemeSegmenter.segment(s), (seg)=>seg.segment);
        }
        function codeUnitsToGraphemeIndex(s, pos) {
            let count = 0;
            for (const seg of graphemeSegmenter.segment(s)){
                if (seg.index >= pos) break;
                count++;
            }
            return count;
        }
        function graphemeIndexToCodeUnits(s, gIndex) {
            if (gIndex <= 0) return 0;
            let count = 0;
            for (const seg of graphemeSegmenter.segment(s)){
                if (count === gIndex) return seg.index;
                count++;
            }
            return s.length;
        }
        const slots = vue.computed(()=>{
            const chars = graphemes(value.value);
            const compositionChars = graphemes(composition.value);
            const placeholderChar = vue.toValue(placeholder) ?? null;
            const currentSelection = selection.value;
            const startG = currentSelection ? codeUnitsToGraphemeIndex(value.value, currentSelection.start) : null;
            const endG = currentSelection ? codeUnitsToGraphemeIndex(value.value, currentSelection.end) : null;
            const compositionStart = startG ?? chars.length;
            return Array.from({
                length: length.value
            }, (_, i)=>{
                const char = chars[i] ?? null;
                const displayChar = char !== null && isMasked.value ? "\u2022" : char;
                let compositionChar = null;
                if (composition.value && i >= compositionStart) {
                    const offset = i - compositionStart;
                    const c = compositionChars[offset];
                    if (c != null) compositionChar = isMasked.value ? "\u2022" : c;
                }
                const isActive = isFocused.value && startG !== null && endG !== null && (startG === endG && i === startG || i >= startG && i < endG);
                return {
                    char: displayChar,
                    compositionChar: compositionChar,
                    placeholderChar: placeholderChar,
                    isActive: isActive,
                    hasFakeCaret: isActive && char === null && compositionChar === null
                };
            });
        });
        function filter(text) {
            const re = effectivePattern.value;
            if (!re) return text;
            return graphemes(text).filter((c)=>re.test(c)).join('');
        }
        function clampGraphemes(text, max) {
            const chars = graphemes(text);
            if (chars.length <= max) return text;
            return chars.slice(0, max).join('');
        }
        function isImeText(text) {
            return IME_SCRIPT_RE.test(text);
        }
        function setValue(text) {
            const next = clampGraphemes(filter(text), length.value);
            value.value = next;
            return next;
        }
        function insert(text, range) {
            const current = value.value;
            const start = range?.start ?? current.length;
            const end = range?.end ?? current.length;
            const filtered = filter(text);
            const next = clampGraphemes(current.slice(0, start) + filtered + current.slice(end), length.value);
            value.value = next;
            const insertEnd = Math.min(start + filtered.length, next.length);
            const insertEndG = codeUnitsToGraphemeIndex(next, insertEnd);
            const cursorG = Math.min(insertEndG, length.value - 1);
            const cursor = graphemeIndexToCodeUnits(next, cursorG);
            setSelection(cursor, insertEnd, 'forward');
            return next;
        }
        function deleteRange(start, end) {
            const current = value.value;
            const next = current.slice(0, start) + current.slice(end);
            value.value = next;
            const newEnd = Math.min(start + 1, next.length);
            setSelection(start, newEnd, 'forward');
            return next;
        }
        function bulkDelete(isBackward) {
            const current = value.value;
            const currentSelection = selection.value;
            const next = isBackward ? current.slice(currentSelection?.end ?? current.length) : current.slice(0, currentSelection?.start ?? 0);
            value.value = next;
            if (next.length === 0) setSelection(0, 0, 'none');
            else if (isBackward) setSelection(0, 1, 'forward');
            else setSelection(next.length, next.length, 'none');
            return next;
        }
        function setSelection(start, end, direction = 'none') {
            if (start === null || end === null) {
                selection.value = null;
                anchorG = null;
                focusG = null;
                return;
            }
            const next = {
                start: start,
                end: end,
                direction: direction
            };
            selection.value = next;
            prevSelection = next;
            const startG = codeUnitsToGraphemeIndex(value.value, start);
            anchorG = startG;
            focusG = startG;
        }
        function clearSelection() {
            selection.value = null;
            anchorG = null;
            focusG = null;
        }
        function selectAtEnd() {
            const current = value.value;
            const graphemeCount = graphemes(current).length;
            let start;
            let end;
            if (graphemeCount >= length.value) {
                // Full: range over the last slot so it renders as active.
                start = graphemeIndexToCodeUnits(current, length.value - 1);
                end = current.length;
            } else {
                // Partial: single caret at the end of the typed content.
                start = current.length;
                end = current.length;
            }
            const next = {
                start: start,
                end: end,
                direction: 'forward'
            };
            selection.value = next;
            prevSelection = next;
            anchorG = graphemeCount >= length.value ? length.value - 1 : graphemeCount;
            focusG = anchorG;
            return next;
        }
        function selectSlot(index) {
            const current = value.value;
            const graphemeCount = graphemes(current).length;
            const clamped = Math.min(index, graphemeCount);
            const start = graphemeIndexToCodeUnits(current, clamped);
            const end = clamped < graphemeCount ? graphemeIndexToCodeUnits(current, clamped + 1) : current.length;
            const next = {
                start: start,
                end: end,
                direction: 'forward'
            };
            selection.value = next;
            prevSelection = next;
            anchorG = clamped;
            focusG = clamped;
            return next;
        }
        function moveCaret(direction) {
            const current = value.value;
            if (graphemes(current).length === 0) return null;
            const currentSelection = selection.value;
            const currentG = currentSelection ? codeUnitsToGraphemeIndex(current, currentSelection.start) : 0;
            return selectSlot(Math.max(0, currentG + direction));
        }
        function extendSelection(direction) {
            const current = value.value;
            const valueG = graphemes(current).length;
            if (valueG === 0) return null;
            const maxFocus = Math.min(length.value - 1, valueG);
            // Fallback when Shift+Arrow fires before anchor/focus were tracked.
            if (anchorG === null || focusG === null) {
                const currentSelection = selection.value;
                if (!currentSelection) return null;
                const selectionStartG = codeUnitsToGraphemeIndex(current, currentSelection.start);
                const selectionEndG = codeUnitsToGraphemeIndex(current, currentSelection.end);
                if (selectionEndG - selectionStartG <= 1) {
                    anchorG = selectionStartG;
                    focusG = selectionStartG;
                } else if (currentSelection.direction === 'backward') {
                    anchorG = selectionEndG - 1;
                    focusG = selectionStartG;
                } else {
                    anchorG = selectionStartG;
                    focusG = selectionEndG - 1;
                }
            }
            const newFocus = Math.max(0, Math.min(maxFocus, focusG + direction));
            focusG = newFocus;
            const minG = Math.min(anchorG, newFocus);
            const maxG = Math.max(anchorG, newFocus);
            const start = graphemeIndexToCodeUnits(current, minG);
            const end = maxG + 1 >= valueG ? current.length : graphemeIndexToCodeUnits(current, maxG + 1);
            const newDirection = newFocus < anchorG ? 'backward' : 'forward';
            const next = {
                start: start,
                end: end,
                direction: newDirection
            };
            selection.value = next;
            prevSelection = next;
            return next;
        }
        // Force the rendered selection to always cover at least one slot, so a slot
        // stays "active" when a caret would otherwise be between two.
        function syncSelection(raw) {
            if (isComposing.value) return selection.value;
            const { value: inputValue, selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection, maxLength: maxLength } = raw;
            if (selectionStart === null || selectionEnd === null) {
                selection.value = null;
                prevSelection = null;
                return null;
            }
            const valueG = graphemes(inputValue).length;
            const startG = codeUnitsToGraphemeIndex(inputValue, selectionStart);
            const endG = codeUnitsToGraphemeIndex(inputValue, selectionEnd);
            let outStartG = -1;
            let outEndG = -1;
            let direction;
            if (valueG !== 0) {
                const isSingleCaret = startG === endG;
                const isInsertMode = startG === valueG && valueG < maxLength;
                if (isSingleCaret && !isInsertMode) {
                    if (startG === 0) {
                        outStartG = 0;
                        outEndG = 1;
                        direction = 'forward';
                    } else if (startG === maxLength) {
                        outStartG = startG - 1;
                        outEndG = startG;
                        direction = 'backward';
                    } else if (maxLength > 1 && valueG > 1) {
                        let offset = 0;
                        if (prevSelection !== null) {
                            const prevStartG = codeUnitsToGraphemeIndex(inputValue, prevSelection.start);
                            const prevEndG = codeUnitsToGraphemeIndex(inputValue, prevSelection.end);
                            direction = startG < prevEndG ? 'backward' : 'forward';
                            const wasPreviouslyInserting = prevStartG === prevEndG && prevStartG < maxLength;
                            // Multi-slot collapse: caret landed at an edge of the prior range,
                            // user didn't navigate between slots, so don't shift the slot back.
                            const wasMultiSlot = prevEndG - prevStartG > 1;
                            if (direction === 'backward' && !wasPreviouslyInserting && !wasMultiSlot) offset = -1;
                        }
                        outStartG = offset + startG;
                        outEndG = offset + startG + 1;
                    }
                }
            }
            const finalStartG = outStartG !== -1 ? outStartG : startG;
            const finalEndG = outEndG !== -1 ? outEndG : endG;
            const finalStart = graphemeIndexToCodeUnits(inputValue, finalStartG);
            const finalEnd = graphemeIndexToCodeUnits(inputValue, finalEndG);
            const finalDirection = direction ?? selectionDirection ?? 'none';
            const next = {
                start: finalStart,
                end: finalEnd,
                direction: finalDirection
            };
            selection.value = next;
            prevSelection = next;
            // Reset anchor on plain navigation; preserve it during extendSelection's round-trip.
            if (finalEndG - finalStartG <= 1) {
                anchorG = finalStartG;
                focusG = finalStartG;
            }
            return next;
        }
        function startComposition() {
            isComposing.value = true;
            composition.value = '';
        }
        function updateComposition(data) {
            composition.value = IME_SCRIPT_RE.test(data) ? data : '';
        }
        function endComposition() {
            isComposing.value = false;
            composition.value = '';
        }
        function reset() {
            value.value = '';
            selection.value = null;
            composition.value = '';
            isComposing.value = false;
            prevSelection = null;
            anchorG = null;
            focusG = null;
        }
        return {
            value: value,
            length: length,
            slots: slots,
            selection: selection,
            composition: composition,
            isComposing: isComposing,
            isFocused: isFocused,
            effectivePattern: effectivePattern,
            inputMode: inputMode,
            filter: filter,
            isImeText: isImeText,
            setValue: setValue,
            insert: insert,
            deleteRange: deleteRange,
            bulkDelete: bulkDelete,
            syncSelection: syncSelection,
            setSelection: setSelection,
            clearSelection: clearSelection,
            selectAtEnd: selectAtEnd,
            selectSlot: selectSlot,
            moveCaret: moveCaret,
            extendSelection: extendSelection,
            startComposition: startComposition,
            updateComposition: updateComposition,
            endComposition: endComposition,
            reset: reset
        };
    }
    const makeVOtpInputProps = propsFactory({
        autofocus: Boolean,
        divider: String,
        focusAll: Boolean,
        merged: Boolean,
        label: {
            type: String,
            default: '$vuetify.input.otp'
        },
        length: {
            type: [
                Number,
                String
            ],
            default: 6
        },
        masked: Boolean,
        modelValue: {
            type: [
                Number,
                String
            ],
            default: undefined
        },
        pattern: {
            type: [
                String,
                Object
            ],
            default: undefined
        },
        placeholder: String,
        type: {
            type: String,
            default: 'number'
        },
        ...makeDensityProps(),
        ...makeDimensionProps(),
        ...makeFocusProps(),
        ...pick(makeVFieldProps({
            variant: 'outlined'
        }), [
            'baseColor',
            'bgColor',
            'class',
            'color',
            'disabled',
            'error',
            'loading',
            'rounded',
            'style',
            'theme',
            'variant'
        ])
    }, 'VOtpInput');
    const VOtpInput = genericComponent()({
        name: 'VOtpInput',
        props: makeVOtpInputProps(),
        emits: {
            finish: (value)=>true,
            'update:focused': (value)=>true,
            'update:modelValue': (value)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { densityClasses: densityClasses } = useDensity(props);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { isFocused: isFocused } = useFocus(props);
            const { t: t } = useLocale();
            const { isRtl: isRtl } = useRtl();
            const model = useProxiedModel(props, 'modelValue', '', (val)=>val == null ? '' : String(val));
            const inputRef = vue.ref();
            const length = vue.toRef(()=>Number(props.length));
            let focusAtPending = false;
            const otp = useOtpInput({
                value: model,
                length: length,
                pattern: ()=>props.pattern,
                type: ()=>props.type,
                masked: ()=>props.masked,
                placeholder: ()=>props.placeholder,
                isFocused: isFocused
            });
            function applySelection() {
                const input = inputRef.value;
                const selection = otp.selection.value;
                if (!input || !selection) return;
                input.setSelectionRange(selection.start, selection.end, selection.direction);
            }
            function syncDOM() {
                const input = inputRef.value;
                if (!input) return;
                if (input.value !== otp.value.value) input.value = otp.value.value;
                applySelection();
            }
            function onSelectionChange() {
                const input = inputRef.value;
                if (!input) {
                    otp.clearSelection();
                    return;
                }
                const result = otp.syncSelection({
                    value: input.value,
                    selectionStart: input.selectionStart,
                    selectionEnd: input.selectionEnd,
                    selectionDirection: input.selectionDirection,
                    // Slot count, not `input.maxLength` (code units).
                    maxLength: length.value
                });
                if (!result) return;
                if (input.selectionStart !== result.start || input.selectionEnd !== result.end) input.setSelectionRange(result.start, result.end, result.direction);
            }
            function onInput(e) {
                const ev = e;
                const target = e.target;
                const composing = ev.isComposing || otp.isComposing.value;
                // CJK composition renders via the overlay until compositionend.
                if (composing && otp.isImeText(target.value)) return;
                // Non-CJK composition (dead keys, Samsung predictive, Chrome OTP autofill)
                // commits into the model now; don't end composition early or selection
                // will advance past the model length on the next selectionchange.
                const next = otp.setValue(target.value);
                if (target.value !== next) target.value = next;
            }
            function onCompositionstart() {
                otp.startComposition();
            }
            function onCompositionupdate(e) {
                otp.updateComposition(e.data ?? '');
            }
            function onCompositionend(e) {
                otp.endComposition();
                onInput(e);
            }
            function onFocus() {
                isFocused.value = true;
                if (focusAtPending) return;
                if (!inputRef.value) return;
                otp.selectAtEnd();
                applySelection();
            }
            function onBlur() {
                isFocused.value = false;
                otp.clearSelection();
            }
            function onKeydown(e) {
                if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                    const direction = (e.key === 'ArrowLeft' ? -1 : 1) * (isRtl.value ? -1 : 1);
                    const moved = e.shiftKey ? otp.extendSelection(direction) : otp.moveCaret(direction);
                    if (moved) {
                        e.preventDefault();
                        syncDOM();
                    }
                    return;
                }
                if (e.key !== 'Backspace' && e.key !== 'Delete') return;
                if (!e.metaKey && !e.ctrlKey && !e.altKey) return;
                e.preventDefault();
                otp.bulkDelete(e.key === 'Backspace');
                syncDOM();
            }
            function onBeforeinput(e) {
                if (e.inputType === 'insertText' && e.data && otp.effectivePattern.value && !otp.effectivePattern.value.test(e.data)) {
                    e.preventDefault();
                    return;
                }
                if (e.inputType === 'deleteContentForward') {
                    e.preventDefault();
                    const input = inputRef.value;
                    if (!input) return;
                    const selection = otp.selection.value;
                    const start = selection?.start ?? 0;
                    const end = selection?.end ?? input.value.length;
                    otp.deleteRange(start, end);
                    syncDOM();
                    return;
                }
                const isBackward = [
                    'deleteWordBackward',
                    'deleteSoftLineBackward',
                    'deleteHardLineBackward'
                ].includes(e.inputType);
                const isForward = [
                    'deleteWordForward',
                    'deleteSoftLineForward',
                    'deleteHardLineForward'
                ].includes(e.inputType);
                if (!isBackward && !isForward) return;
                e.preventDefault();
                otp.bulkDelete(isBackward);
                syncDOM();
            }
            function onPaste(e) {
                e.preventDefault();
                const input = inputRef.value;
                if (!input) return;
                const text = e.clipboardData?.getData('text/plain').trim() ?? '';
                const selection = otp.selection.value;
                otp.insert(text, {
                    start: selection?.start ?? 0,
                    end: selection?.end ?? input.value.length
                });
                syncDOM();
            }
            function focusAt(index) {
                const input = inputRef.value;
                if (!input) return;
                focusAtPending = true;
                input.focus();
                focusAtPending = false;
                otp.selectSlot(index);
                applySelection();
            }
            function slotIndexAtPoint(x, y) {
                const slot = document.elementsFromPoint(x, y).find((el)=>el.hasAttribute('data-otp-index'));
                const index = slot ? Number(slot.getAttribute('data-otp-index')) : NaN;
                return Number.isNaN(index) ? null : index;
            }
            function onClick(e) {
                const index = slotIndexAtPoint(e.clientX, e.clientY);
                if (index != null) focusAt(index);
            }
            // selectionchange is not in InputHTMLAttributes types
            vue.watch(inputRef, (input, _, onCleanup)=>{
                if (!input) return;
                input.addEventListener('selectionchange', onSelectionChange);
                onCleanup(()=>input.removeEventListener('selectionchange', onSelectionChange));
            }, {
                immediate: true
            });
            useToggleScope(()=>props.autofocus, ()=>{
                const intersectScope = vue.effectScope();
                intersectScope.run(()=>{
                    const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = useIntersectionObserver();
                    vue.watchEffect(()=>{
                        intersectionRef.value = inputRef.value;
                    });
                    vue.watch(isIntersecting, (v)=>{
                        if (!v) return;
                        intersectionRef.value?.focus();
                        intersectScope.stop();
                    });
                });
            });
            vue.watch(model, (val)=>{
                if (otp.isComposing.value) return;
                if (val.length === length.value) emit('finish', val);
            });
            provideDefaults({
                VField: {
                    color: vue.toRef(()=>props.color),
                    bgColor: vue.toRef(()=>props.color),
                    baseColor: vue.toRef(()=>props.baseColor),
                    disabled: vue.toRef(()=>props.disabled),
                    error: vue.toRef(()=>props.error),
                    variant: vue.toRef(()=>props.variant),
                    rounded: vue.toRef(()=>props.rounded)
                }
            }, {
                scoped: true
            });
            vue.provide(VOtpInputSymbol, {
                otpSlots: otp.slots,
                isFocused: isFocused,
                focusAll: vue.toRef(()=>props.focusAll),
                divider: vue.toRef(()=>props.divider),
                merged: vue.toRef(()=>props.merged),
                focusAt: focusAt
            });
            useRender(()=>{
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                return vue.createElementVNode("div", vue.mergeProps({
                    "class": [
                        'v-otp-input',
                        {
                            'v-otp-input--divided': !!props.divider
                        },
                        densityClasses.value,
                        props.class
                    ],
                    "style": [
                        props.style
                    ]
                }, rootAttrs), [
                    vue.createElementVNode("div", {
                        "class": "v-otp-input__content",
                        "style": vue.normalizeStyle([
                            dimensionStyles.value
                        ])
                    }, [
                        slots.fields ? slots.fields() : props.merged ? vue.createVNode(VOtpGroup, {
                            "merged": true
                        }, {
                            default: ()=>[
                                    Array.from({
                                        length: length.value
                                    }, (_, i)=>vue.createVNode(VOtpField, {
                                            "index": i,
                                            "key": i
                                        }, null))
                                ]
                        }) : Array.from({
                            length: length.value
                        }, (_, i)=>vue.createElementVNode(vue.Fragment, null, [
                                (props.divider || slots.divider) && i !== 0 && vue.createVNode(VOtpSeparator, {
                                    "key": `d-${i}`
                                }, {
                                    default: ()=>[
                                            slots.divider?.({
                                                index: i - 1
                                            }) ?? props.divider
                                        ]
                                }),
                                vue.createVNode(VOtpField, {
                                    "index": i,
                                    "key": i
                                }, null)
                            ])),
                        vue.createElementVNode("input", vue.mergeProps({
                            "ref": inputRef,
                            "class": "v-otp-input__input",
                            "type": "text",
                            "inputmode": otp.inputMode.value,
                            "dir": isRtl.value ? 'rtl' : 'ltr',
                            "autocomplete": "one-time-code",
                            "autocorrect": "off",
                            "autocapitalize": "off",
                            "spellcheck": false,
                            "disabled": props.disabled,
                            "aria-label": t(props.label),
                            "value": model.value
                        }, inputAttrs, {
                            "onClick": onClick,
                            "onInput": onInput,
                            "onKeydown": onKeydown,
                            "onBeforeinput": onBeforeinput,
                            "onFocus": onFocus,
                            "onBlur": onBlur,
                            "onPaste": onPaste,
                            "onCompositionstart": onCompositionstart,
                            "onCompositionupdate": onCompositionupdate,
                            "onCompositionend": onCompositionend
                        }), null),
                        vue.createVNode(VOverlay, {
                            "contained": true,
                            "contentClass": "v-otp-input__loader",
                            "modelValue": !!props.loading,
                            "persistent": true
                        }, {
                            default: ()=>[
                                    slots.loader?.() ?? vue.createVNode(VProgressCircular, {
                                        "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                        "indeterminate": true,
                                        "size": "24",
                                        "width": "2"
                                    }, null)
                                ]
                        }),
                        slots.default?.()
                    ])
                ]);
            });
            return {
                blur: ()=>{
                    inputRef.value?.blur();
                },
                focus: ()=>{
                    inputRef.value?.focus();
                },
                reset: otp.reset,
                isFocused: isFocused
            };
        }
    });
    // Types
    function floor(val) {
        return Math.floor(Math.abs(val)) * Math.sign(val);
    }
    const makeVParallaxProps = propsFactory({
        scale: {
            type: [
                Number,
                String
            ],
            default: 0.5
        },
        ...makeComponentProps()
    }, 'VParallax');
    const VParallax = genericComponent()({
        name: 'VParallax',
        props: makeVParallaxProps(),
        setup (props, { slots: slots }) {
            const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = useIntersectionObserver();
            const { resizeRef: resizeRef, contentRect: contentRect } = useResizeObserver();
            const { height: displayHeight } = useDisplay();
            const root = vue.ref();
            vue.watchEffect(()=>{
                intersectionRef.value = resizeRef.value = root.value?.$el;
            });
            let scrollParent;
            vue.watch(isIntersecting, (val)=>{
                if (val) {
                    scrollParent = getScrollParent(intersectionRef.value);
                    scrollParent = scrollParent === document.scrollingElement ? document : scrollParent;
                    scrollParent.addEventListener('scroll', onScroll, {
                        passive: true
                    });
                    onScroll();
                } else scrollParent.removeEventListener('scroll', onScroll);
            });
            vue.onBeforeUnmount(()=>{
                scrollParent?.removeEventListener('scroll', onScroll);
            });
            vue.watch(displayHeight, onScroll);
            vue.watch(()=>contentRect.value?.height, onScroll);
            const scale = vue.computed(()=>{
                return 1 - clamp(Number(props.scale));
            });
            let frame = -1;
            function onScroll() {
                if (!isIntersecting.value || PREFERS_REDUCED_MOTION()) return;
                cancelAnimationFrame(frame);
                frame = requestAnimationFrame(()=>{
                    const el = (root.value?.$el).querySelector('.v-img__img');
                    if (!el) return;
                    const scrollHeight = scrollParent instanceof Document ? document.documentElement.clientHeight : scrollParent.clientHeight;
                    const scrollPos = scrollParent instanceof Document ? window.scrollY : scrollParent.scrollTop;
                    const top = intersectionRef.value.getBoundingClientRect().top + scrollPos;
                    const height = contentRect.value.height;
                    const center = top + (height - scrollHeight) / 2;
                    const translate = floor((scrollPos - center) * scale.value);
                    const sizeScale = Math.max(1, (scale.value * (scrollHeight - height) + height) / height);
                    el.style.setProperty('transform', `translateY(${translate}px) scale(${sizeScale})`);
                });
            }
            useRender(()=>vue.createVNode(VImg, {
                    "class": vue.normalizeClass([
                        'v-parallax',
                        {
                            'v-parallax--active': isIntersecting.value
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "ref": root,
                    "cover": true,
                    "onLoadstart": onScroll,
                    "onLoad": onScroll
                }, slots));
            return {};
        }
    });
    const VPullToRefresh = genericComponent()({
        name: 'VPullToRefresh',
        props: {
            disabled: Boolean,
            pullDownThreshold: {
                type: Number,
                default: 64
            }
        },
        emits: {
            load: (options)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            let touchstartY = 0;
            let scrollParents = [];
            const touchDiff = vue.shallowRef(0);
            const containerRef = vue.ref();
            const refreshing = vue.shallowRef(false);
            const goingUp = vue.shallowRef(false);
            const touching = vue.shallowRef(false);
            const canRefresh = vue.computed(()=>touchDiff.value >= props.pullDownThreshold && !refreshing.value);
            const topOffset = vue.computed(()=>clamp(touchDiff.value, 0, props.pullDownThreshold));
            function onTouchstart(e) {
                if (refreshing.value || props.disabled) return;
                touching.value = true;
                touchstartY = 'clientY' in e ? e.clientY : e.touches[0].clientY;
            }
            function onTouchmove(e) {
                if (refreshing.value || !touching.value || props.disabled) return;
                const touchY = 'clientY' in e ? e.clientY : e.touches[0].clientY;
                if (scrollParents.length && !scrollParents[0].scrollTop) touchDiff.value = touchY - touchstartY;
            }
            function onTouchend(e) {
                if (refreshing.value || props.disabled) return;
                touching.value = false;
                if (canRefresh.value) {
                    function done() {
                        if (!refreshing.value) return;
                        touchDiff.value = 0;
                        refreshing.value = false;
                    }
                    emit('load', {
                        done: done
                    });
                    refreshing.value = true;
                } else touchDiff.value = 0;
            }
            vue.onMounted(()=>{
                scrollParents = getScrollParents(containerRef.value);
            });
            vue.watch([
                topOffset,
                refreshing
            ], ()=>{
                if (scrollParents.length) {
                    const stopScrolling = topOffset.value && !refreshing.value;
                    scrollParents.forEach((p)=>p.style.overflow = stopScrolling ? 'hidden' : 'auto');
                }
            });
            vue.watch(topOffset, (newVal, oldVal)=>{
                goingUp.value = newVal < oldVal;
            });
            useRender(()=>{
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-pull-to-refresh'
                    ]),
                    "onTouchstart": onTouchstart,
                    "onTouchmove": onTouchmove,
                    "onTouchend": onTouchend,
                    "onMousedown": onTouchstart,
                    "onMouseup": onTouchend,
                    "onMouseleave": onTouchend,
                    "onMousemove": onTouchmove,
                    "ref": containerRef
                }, [
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-pull-to-refresh__pull-down',
                            {
                                'v-pull-to-refresh__pull-down--touching': touching.value
                            }
                        ]),
                        "style": {
                            top: convertToUnit(-1 * props.pullDownThreshold + topOffset.value),
                            height: convertToUnit(props.pullDownThreshold)
                        }
                    }, [
                        slots.pullDownPanel ? slots.pullDownPanel({
                            canRefresh: canRefresh.value,
                            goingUp: goingUp.value,
                            refreshing: refreshing.value
                        }) : vue.createElementVNode("div", {
                            "class": vue.normalizeClass([
                                'v-pull-to-refresh__pull-down-default'
                            ])
                        }, [
                            refreshing.value ? vue.createVNode(VProgressCircular, {
                                "indeterminate": true,
                                "active": false
                            }, null) : vue.createVNode(VIcon, {
                                "icon": canRefresh.value || goingUp.value ? '$sortAsc' : '$sortDesc'
                            }, null)
                        ])
                    ]),
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-pull-to-refresh__scroll-container',
                            {
                                'v-pull-to-refresh__scroll-container--touching': touching.value
                            }
                        ]),
                        "style": {
                            top: convertToUnit(topOffset.value)
                        }
                    }, [
                        slots.default?.()
                    ])
                ]);
            });
        }
    });
    // Types
    const makeVRadioProps = propsFactory({
        ...omit(makeVSelectionControlProps({
            falseIcon: '$radioOff',
            trueIcon: '$radioOn'
        }), [
            'indeterminate',
            'indeterminateIcon'
        ])
    }, 'VRadio');
    const VRadio = genericComponent()({
        name: 'VRadio',
        props: makeVRadioProps(),
        setup (props, { slots: slots }) {
            useRender(()=>{
                const controlProps = VSelectionControl.filterProps(props);
                return vue.createVNode(VSelectionControl, vue.mergeProps(controlProps, {
                    "class": [
                        'v-radio',
                        props.class
                    ],
                    "style": props.style,
                    "type": "radio"
                }), slots);
            });
            return {};
        }
    });
    // Types
    const makeVRadioGroupProps = propsFactory({
        height: {
            type: [
                Number,
                String
            ],
            default: 'auto'
        },
        ...omit(makeVInputProps(), [
            'direction',
            'glow'
        ]),
        ...omit(makeSelectionControlGroupProps(), [
            'multiple'
        ]),
        trueIcon: {
            type: IconValue,
            default: '$radioOn'
        },
        falseIcon: {
            type: IconValue,
            default: '$radioOff'
        },
        type: {
            type: String,
            default: 'radio'
        }
    }, 'VRadioGroup');
    const VRadioGroup = genericComponent()({
        name: 'VRadioGroup',
        inheritAttrs: false,
        props: makeVRadioGroupProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const uid = vue.useId();
            const id = vue.computed(()=>props.id || `radio-group-${uid}`);
            const model = useProxiedModel(props, 'modelValue');
            const inputRef = vue.ref();
            useRender(()=>{
                const [rootAttrs, controlAttrs] = filterInputAttrs(attrs);
                const inputProps = VInput.filterProps(props);
                const controlProps = VSelectionControl.filterProps(props);
                const label = slots.label ? slots.label({
                    label: props.label,
                    props: {
                        for: id.value
                    }
                }) : props.label;
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": inputRef,
                    "class": [
                        'v-radio-group',
                        props.class
                    ],
                    "style": props.style
                }, rootAttrs, inputProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "id": id.value
                }), {
                    ...slots,
                    default: ({ id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly })=>vue.createElementVNode(vue.Fragment, null, [
                            label && vue.createVNode(VLabel, {
                                "id": id.value
                            }, {
                                default: ()=>[
                                        label
                                    ]
                            }),
                            vue.createVNode(VSelectionControlGroup, vue.mergeProps(controlProps, {
                                "id": id.value,
                                "aria-describedby": messagesId.value,
                                "defaultsTarget": "VRadio",
                                "trueIcon": props.trueIcon,
                                "falseIcon": props.falseIcon,
                                "type": props.type,
                                "disabled": isDisabled.value,
                                "readonly": isReadonly.value,
                                "aria-labelledby": label ? id.value : undefined,
                                "multiple": false
                            }, controlAttrs, {
                                "modelValue": model.value,
                                "onUpdate:modelValue": ($event)=>model.value = $event
                            }), slots)
                        ])
                });
            });
            return forwardRefs({}, inputRef);
        }
    });
    // Types
    const makeVRangeSliderProps = propsFactory({
        ...makeFocusProps(),
        ...makeVInputProps(),
        ...makeSliderProps(),
        strict: Boolean,
        modelValue: {
            type: Array,
            default: ()=>[
                    0,
                    0
                ]
        }
    }, 'VRangeSlider');
    const VRangeSlider = genericComponent()({
        name: 'VRangeSlider',
        inheritAttrs: false,
        props: makeVRangeSliderProps(),
        emits: {
            'update:focused': (value)=>true,
            'update:modelValue': (value)=>true,
            end: (value)=>true,
            start: (value)=>true
        },
        setup (props, { slots: slots, emit: emit, attrs: attrs }) {
            const startThumbRef = vue.ref();
            const stopThumbRef = vue.ref();
            const inputRef = vue.ref();
            const { rtlClasses: rtlClasses } = useRtl();
            function getActiveThumb(e) {
                if (!startThumbRef.value || !stopThumbRef.value) return;
                const startOffset = getOffset(e, startThumbRef.value.$el, props.direction);
                const stopOffset = getOffset(e, stopThumbRef.value.$el, props.direction);
                const a = Math.abs(startOffset);
                const b = Math.abs(stopOffset);
                return a < b || a === b && startOffset < 0 ? startThumbRef.value.$el : stopThumbRef.value.$el;
            }
            const steps = useSteps(props);
            const model = useProxiedModel(props, 'modelValue', undefined, (arr)=>{
                if (!arr?.length) return [
                    0,
                    0
                ];
                return arr.map((value)=>steps.roundValue(value));
            });
            const { activeThumbRef: activeThumbRef, hasLabels: hasLabels, max: max, min: min, mousePressed: mousePressed, onSliderMousedown: onSliderMousedown, onSliderTouchstart: onSliderTouchstart, position: position, trackContainerRef: trackContainerRef, disabled: disabled, readonly: readonly } = useSlider({
                props: props,
                steps: steps,
                onSliderStart: ()=>{
                    if (disabled.value || readonly.value) {
                        activeThumbRef.value?.blur();
                        return;
                    }
                    emit('start', model.value);
                },
                onSliderEnd: ({ value: value })=>{
                    if (disabled.value || readonly.value) activeThumbRef.value?.blur();
                    else {
                        const newValue = activeThumbRef.value === startThumbRef.value?.$el ? [
                            value,
                            model.value[1]
                        ] : [
                            model.value[0],
                            value
                        ];
                        if (!props.strict && newValue[0] < newValue[1]) model.value = newValue;
                    }
                    emit('end', model.value);
                },
                onSliderMove: ({ value: value })=>{
                    const [start, stop] = model.value;
                    if (disabled.value || readonly.value) {
                        activeThumbRef.value?.blur();
                        return;
                    }
                    if (!props.strict && start === stop && start !== min.value) {
                        activeThumbRef.value = value > start ? stopThumbRef.value?.$el : startThumbRef.value?.$el;
                        activeThumbRef.value?.focus();
                    }
                    if (activeThumbRef.value === startThumbRef.value?.$el) model.value = [
                        Math.min(value, stop),
                        stop
                    ];
                    else model.value = [
                        start,
                        Math.max(start, value)
                    ];
                },
                getActiveThumb: getActiveThumb
            });
            const { isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const trackStart = vue.computed(()=>position(model.value[0]));
            const trackStop = vue.computed(()=>position(model.value[1]));
            useRender(()=>{
                const inputProps = VInput.filterProps(props);
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                const hasPrepend = !!(props.label || slots.label || slots.prepend);
                return vue.createVNode(VInput, vue.mergeProps({
                    "class": [
                        'v-slider',
                        'v-range-slider',
                        {
                            'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                            'v-slider--focused': isFocused.value,
                            'v-slider--pressed': mousePressed.value,
                            'v-slider--disabled': disabled.value
                        },
                        rtlClasses.value,
                        props.class
                    ],
                    "style": props.style,
                    "ref": inputRef
                }, inputProps, rootAttrs, {
                    "focused": isFocused.value
                }), {
                    ...slots,
                    prepend: hasPrepend ? (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            slots.label?.(slotProps) ?? (props.label ? vue.createVNode(VLabel, {
                                "class": "v-slider__label",
                                "text": props.label
                            }, null) : undefined),
                            slots.prepend?.(slotProps)
                        ]) : undefined,
                    default: ({ id: id, messagesId: messagesId })=>vue.createElementVNode("div", {
                            "class": "v-slider__container",
                            "onMousedown": !readonly.value ? onSliderMousedown : undefined,
                            "onTouchstartPassive": !readonly.value ? onSliderTouchstart : undefined
                        }, [
                            vue.createElementVNode("input", {
                                "id": `${id.value}_start`,
                                "name": props.name || id.value,
                                "disabled": disabled.value,
                                "readonly": readonly.value,
                                "tabindex": "-1",
                                "value": model.value[0]
                            }, null),
                            vue.createElementVNode("input", {
                                "id": `${id.value}_stop`,
                                "name": props.name || id.value,
                                "disabled": disabled.value,
                                "readonly": readonly.value,
                                "tabindex": "-1",
                                "value": model.value[1]
                            }, null),
                            vue.createVNode(VSliderTrack, {
                                "ref": trackContainerRef,
                                "start": trackStart.value,
                                "stop": trackStop.value
                            }, {
                                'tick-label': slots['tick-label']
                            }),
                            vue.createVNode(VSliderThumb, vue.mergeProps({
                                "ref": startThumbRef,
                                "aria-describedby": messagesId.value,
                                "focused": isFocused && activeThumbRef.value === startThumbRef.value?.$el,
                                "modelValue": model.value[0],
                                "onUpdate:modelValue": (v)=>model.value = [
                                        v,
                                        model.value[1]
                                    ],
                                "onFocus": (e)=>{
                                    focus();
                                    activeThumbRef.value = startThumbRef.value?.$el;
                                    // Make sure second thumb is focused if
                                    // the thumbs are on top of each other
                                    // and they are both at minimum value
                                    // but only if focused from outside.
                                    if (max.value !== min.value && model.value[0] === model.value[1] && model.value[1] === min.value && e.relatedTarget !== stopThumbRef.value?.$el) {
                                        startThumbRef.value?.$el.blur();
                                        stopThumbRef.value?.$el.focus();
                                    }
                                },
                                "onBlur": ()=>{
                                    blur();
                                    activeThumbRef.value = undefined;
                                },
                                "min": min.value,
                                "max": model.value[1],
                                "position": trackStart.value,
                                "ripple": props.ripple
                            }, inputAttrs), {
                                'thumb-label': slots['thumb-label']
                            }),
                            vue.createVNode(VSliderThumb, vue.mergeProps({
                                "ref": stopThumbRef,
                                "aria-describedby": messagesId.value,
                                "focused": isFocused && activeThumbRef.value === stopThumbRef.value?.$el,
                                "modelValue": model.value[1],
                                "onUpdate:modelValue": (v)=>model.value = [
                                        model.value[0],
                                        v
                                    ],
                                "onFocus": (e)=>{
                                    focus();
                                    activeThumbRef.value = stopThumbRef.value?.$el;
                                    // Make sure first thumb is focused if
                                    // the thumbs are on top of each other
                                    // and they are both at maximum value
                                    // but only if focused from outside.
                                    if (max.value !== min.value && model.value[0] === model.value[1] && model.value[0] === max.value && e.relatedTarget !== startThumbRef.value?.$el) {
                                        stopThumbRef.value?.$el.blur();
                                        startThumbRef.value?.$el.focus();
                                    }
                                },
                                "onBlur": ()=>{
                                    blur();
                                    activeThumbRef.value = undefined;
                                },
                                "min": model.value[0],
                                "max": max.value,
                                "position": trackStop.value,
                                "ripple": props.ripple
                            }, inputAttrs), {
                                'thumb-label': slots['thumb-label']
                            })
                        ])
                });
            });
            return forwardRefs({
                focus: ()=>startThumbRef.value?.$el.focus()
            }, inputRef);
        }
    });
    // Types
    const makeVRatingProps = propsFactory({
        name: String,
        itemAriaLabel: {
            type: String,
            default: '$vuetify.rating.ariaLabel.item'
        },
        activeColor: String,
        color: String,
        clearable: Boolean,
        disabled: Boolean,
        emptyIcon: {
            type: IconValue,
            default: '$ratingEmpty'
        },
        fullIcon: {
            type: IconValue,
            default: '$ratingFull'
        },
        halfIncrements: Boolean,
        hover: Boolean,
        length: {
            type: [
                Number,
                String
            ],
            default: 5
        },
        readonly: Boolean,
        modelValue: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        itemLabels: Array,
        itemLabelPosition: {
            type: String,
            default: 'top',
            validator: (v)=>[
                    'top',
                    'bottom'
                ].includes(v)
        },
        ripple: Boolean,
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeSizeProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VRating');
    const VRating = genericComponent()({
        name: 'VRating',
        props: makeVRatingProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const { t: t } = useLocale();
            const { themeClasses: themeClasses } = provideTheme(props);
            const root = vue.ref();
            const rating = useProxiedModel(props, 'modelValue');
            const normalizedValue = vue.computed(()=>clamp(parseFloat(rating.value), 0, Number(props.length)));
            const range = vue.computed(()=>createRange(Number(props.length), 1));
            const increments = vue.computed(()=>range.value.flatMap((v)=>props.halfIncrements ? [
                        v - 0.5,
                        v
                    ] : [
                        v
                    ]));
            const hoverIndex = vue.shallowRef(-1);
            const itemState = vue.computed(()=>increments.value.map((value)=>{
                    const isHovering = props.hover && hoverIndex.value > -1;
                    const isFilled = normalizedValue.value >= value;
                    const isHovered = hoverIndex.value >= value;
                    const isFullIcon = isHovering ? isHovered : isFilled;
                    const icon = isFullIcon ? props.fullIcon : props.emptyIcon;
                    const activeColor = props.activeColor ?? props.color;
                    const color = isFilled || isHovered ? activeColor : props.color;
                    return {
                        isFilled: isFilled,
                        isHovered: isHovered,
                        icon: icon,
                        color: color,
                        activeColor: activeColor
                    };
                }));
            const eventState = vue.computed(()=>[
                    0,
                    ...increments.value
                ].map((value)=>{
                    function onMouseenter() {
                        hoverIndex.value = value;
                    }
                    function onMouseleave() {
                        hoverIndex.value = -1;
                    }
                    function onClick() {
                        if (props.disabled || props.readonly) return;
                        rating.value = normalizedValue.value === value && props.clearable ? 0 : value;
                    }
                    return {
                        onMouseenter: props.hover ? onMouseenter : undefined,
                        onMouseleave: props.hover ? onMouseleave : undefined,
                        onClick: onClick
                    };
                }));
            const currentItemIndex = vue.computed(()=>{
                return props.halfIncrements ? 1 + Math.floor(Math.max(0, Number(rating.value ?? 0) - 0.5)) * 2 : Math.floor(Math.max(0, Number(rating.value ?? 0) - 1));
            });
            function moveCurrentFocus() {
                const currentItem = root.value?.querySelector('[tabindex="0"]');
                currentItem?.focus();
            }
            function onItemKeydown(event) {
                if (props.disabled || props.readonly) return;
                if (event.ctrlKey || event.altKey) return;
                const step = props.halfIncrements ? 0.5 : 1;
                if (event.key === 'ArrowRight') {
                    const newValue = Math.min(Number(props.length), Number(rating.value ?? 0) + step);
                    rating.value = newValue;
                    vue.nextTick(()=>moveCurrentFocus());
                }
                if (event.key === 'ArrowLeft') {
                    const newValue = Math.max(0, Number(rating.value ?? 0) - step);
                    rating.value = newValue;
                    vue.nextTick(()=>moveCurrentFocus());
                }
            }
            const uid = vue.useId();
            const name = vue.computed(()=>props.name ?? `v-rating-${uid}`);
            function VRatingItem({ value: value, index: index, showStar: showStar = true }) {
                const { onMouseenter: onMouseenter, onMouseleave: onMouseleave, onClick: onClick } = eventState.value[index + 1];
                const id = `${name.value}-${String(value).replace('.', '-')}`;
                const isFocusable = index === currentItemIndex.value;
                const btnProps = {
                    color: itemState.value[index]?.color,
                    density: props.density,
                    disabled: props.disabled,
                    icon: itemState.value[index]?.icon,
                    ripple: props.ripple,
                    size: props.size,
                    variant: 'plain',
                    tabindex: isFocusable ? 0 : -1,
                    onKeydown: onItemKeydown
                };
                return vue.createElementVNode(vue.Fragment, null, [
                    vue.createElementVNode("label", {
                        "for": id,
                        "class": vue.normalizeClass({
                            'v-rating__item--half': props.halfIncrements && value % 1 > 0,
                            'v-rating__item--full': props.halfIncrements && value % 1 === 0
                        }),
                        "onMouseenter": onMouseenter,
                        "onMouseleave": onMouseleave,
                        "onClick": onClick
                    }, [
                        vue.createElementVNode("span", {
                            "class": "v-rating__hidden"
                        }, [
                            t(props.itemAriaLabel, value, props.length)
                        ]),
                        !showStar ? undefined : slots.item ? slots.item({
                            ...itemState.value[index],
                            props: btnProps,
                            value: value,
                            index: index,
                            rating: normalizedValue.value
                        }) : vue.createVNode(VBtn, vue.mergeProps({
                            "aria-label": t(props.itemAriaLabel, value, props.length)
                        }, btnProps), null)
                    ]),
                    vue.createElementVNode("input", {
                        "class": "v-rating__hidden",
                        "name": name.value,
                        "id": id,
                        "type": "radio",
                        "value": value,
                        "checked": normalizedValue.value === value,
                        "tabindex": -1,
                        "readonly": props.readonly,
                        "disabled": props.disabled
                    }, null)
                ]);
            }
            function createLabel(labelProps) {
                if (slots['item-label']) return slots['item-label'](labelProps);
                if (labelProps.label) return vue.createElementVNode("span", null, [
                    labelProps.label
                ]);
                return vue.createElementVNode("span", null, [
                    vue.createTextVNode("\xA0")
                ]);
            }
            useRender(()=>{
                const hasLabels = !!props.itemLabels?.length || slots['item-label'];
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-rating',
                        {
                            'v-rating--hover': props.hover,
                            'v-rating--readonly': props.readonly
                        },
                        themeClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style),
                    "ref": root
                }, {
                    default: ()=>[
                            vue.createVNode(VRatingItem, {
                                "value": 0,
                                "index": -1,
                                "showStar": false
                            }, null),
                            range.value.map((value, i)=>vue.createElementVNode("div", {
                                    "class": "v-rating__wrapper"
                                }, [
                                    hasLabels && props.itemLabelPosition === 'top' ? createLabel({
                                        value: value,
                                        index: i,
                                        label: props.itemLabels?.[i]
                                    }) : undefined,
                                    vue.createElementVNode("div", {
                                        "class": "v-rating__item"
                                    }, [
                                        props.halfIncrements ? vue.createElementVNode(vue.Fragment, null, [
                                            vue.createVNode(VRatingItem, {
                                                "value": value - 0.5,
                                                "index": i * 2
                                            }, null),
                                            vue.createVNode(VRatingItem, {
                                                "value": value,
                                                "index": i * 2 + 1
                                            }, null)
                                        ]) : vue.createVNode(VRatingItem, {
                                            "value": value,
                                            "index": i
                                        }, null)
                                    ]),
                                    hasLabels && props.itemLabelPosition === 'bottom' ? createLabel({
                                        value: value,
                                        index: i,
                                        label: props.itemLabels?.[i]
                                    }) : undefined
                                ]))
                        ]
                });
            });
            return {};
        }
    });
    // Types
    const rootTypes = {
        actions: 'button@2',
        article: 'heading, paragraph',
        avatar: 'avatar',
        button: 'button',
        card: 'image, heading',
        'card-avatar': 'image, list-item-avatar',
        chip: 'chip',
        'date-picker': 'list-item, heading, divider, date-picker-options, date-picker-days, actions',
        'date-picker-options': 'text, avatar@2',
        'date-picker-days': 'avatar@28',
        divider: 'divider',
        heading: 'heading',
        image: 'image',
        'list-item': 'text',
        'list-item-avatar': 'avatar, text',
        'list-item-two-line': 'sentences',
        'list-item-avatar-two-line': 'avatar, sentences',
        'list-item-three-line': 'paragraph',
        'list-item-avatar-three-line': 'avatar, paragraph',
        ossein: 'ossein',
        paragraph: 'text@3',
        sentences: 'text@2',
        subtitle: 'text',
        table: 'table-heading, table-thead, table-tbody, table-tfoot',
        'table-heading': 'chip, text',
        'table-thead': 'heading@6',
        'table-tbody': 'table-row-divider@6',
        'table-row-divider': 'table-row, divider',
        'table-row': 'text@6',
        'table-tfoot': 'text@2, avatar@2',
        text: 'text'
    };
    function genBone(type, children = []) {
        return vue.createElementVNode("div", {
            "class": vue.normalizeClass([
                'v-skeleton-loader__bone',
                `v-skeleton-loader__${type}`
            ])
        }, [
            children
        ]);
    }
    function genBones(bone) {
        // e.g. 'text@3'
        const [type, length] = bone.split('@');
        // Generate a length array based upon
        // value after @ in the bone string
        return Array.from({
            length: length
        }).map(()=>genStructure(type));
    }
    function genStructure(type) {
        let children = [];
        if (!type) return children;
        // TODO: figure out a better way to type this
        const bone = rootTypes[type];
        // End of recursion, do nothing
        /* eslint-disable-next-line no-empty, brace-style */ if (type === bone) ;
        else if (type.includes(',')) return mapBones(type);
        else if (type.includes('@')) return genBones(type);
        else if (bone.includes(',')) children = mapBones(bone);
        else if (bone.includes('@')) children = genBones(bone);
        else if (bone) children.push(genStructure(bone));
        return [
            genBone(type, children)
        ];
    }
    function mapBones(bones) {
        // Remove spaces and return array of structures
        return bones.replace(/\s/g, '').split(',').map(genStructure);
    }
    const makeVSkeletonLoaderProps = propsFactory({
        boilerplate: Boolean,
        color: String,
        loading: Boolean,
        loadingText: {
            type: String,
            default: '$vuetify.loading'
        },
        type: {
            type: [
                String,
                Array
            ],
            default: 'ossein'
        },
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeThemeProps()
    }, 'VSkeletonLoader');
    const VSkeletonLoader = genericComponent()({
        name: 'VSkeletonLoader',
        inheritAttrs: false,
        props: makeVSkeletonLoaderProps(),
        setup (props, { attrs: attrs, slots: slots }) {
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { themeClasses: themeClasses } = provideTheme(props);
            const { t: t } = useLocale();
            const items = vue.computed(()=>genStructure(wrapInArray(props.type).join(',')));
            useRender(()=>{
                const isLoading = !slots.default || props.loading;
                const loadingProps = props.boilerplate || !isLoading ? {} : {
                    ariaLive: 'polite',
                    ariaLabel: t(props.loadingText),
                    role: 'alert'
                };
                return isLoading ? vue.createElementVNode("div", vue.mergeProps({
                    "class": [
                        'v-skeleton-loader',
                        {
                            'v-skeleton-loader--boilerplate': props.boilerplate
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        elevationClasses.value
                    ],
                    "style": [
                        backgroundColorStyles.value,
                        dimensionStyles.value
                    ]
                }, loadingProps, attrs), [
                    items.value
                ]) : vue.createElementVNode(vue.Fragment, null, [
                    slots.default?.()
                ]);
            });
            return {};
        }
    });
    // Composables
    // Types
    const VSlideGroupItem = genericComponent()({
        name: 'VSlideGroupItem',
        props: makeGroupItemProps(),
        emits: {
            'group:selected': (val)=>true
        },
        setup (props, { slots: slots }) {
            const slideGroupItem = useGroupItem(props, VSlideGroupSymbol);
            return ()=>slots.default?.({
                    isSelected: slideGroupItem.isSelected.value,
                    select: slideGroupItem.select,
                    toggle: slideGroupItem.toggle,
                    selectedClass: slideGroupItem.selectedClass.value
                });
        }
    });
    // Composables
    // Types
    const VSnackbarQueueSymbol = Symbol.for('vuetify:v-snackbar-queue');
    function useSnackbarQueue(props) {
        const items = vue.ref(new Map());
        const gap = vue.toRef(()=>Number(props.gap));
        function register(id) {
            items.value.set(id, {
                height: 0,
                width: 0
            });
        }
        function unregister(id) {
            items.value.delete(id);
        }
        function setSize(id, height, width) {
            const item = items.value.get(id);
            if (!item || item.height === height && item.width === width) return;
            item.height = height;
            item.width = width;
        }
        const lastItemSize = vue.computed(()=>{
            for (const { width: width, height: height } of [
                ...items.value.values()
            ].toReversed()){
                if (!width || !height) continue;
                return {
                    width: width,
                    height: height
                };
            }
            return {
                width: 0,
                height: 0
            };
        });
        function getOffset(id) {
            if (!items.value.has(id)) return null;
            let offset = 0;
            for (const [itemId, state] of [
                ...items.value.entries()
            ].toReversed()){
                if (itemId === id) break;
                offset += state.height + gap.value;
            }
            return offset;
        }
        const state = {
            register: register,
            unregister: unregister,
            setSize: setSize,
            getOffset: getOffset,
            items: items,
            gap: gap,
            lastItemSize: lastItemSize
        };
        vue.provide(VSnackbarQueueSymbol, state);
        return state;
    }
    function useSnackbarItem(isActive, contentEl) {
        const queue = vue.inject(VSnackbarQueueSymbol, null);
        if (!queue) return null;
        const id = vue.useId();
        queue.register(id);
        vue.onBeforeUnmount(()=>queue.unregister(id));
        vue.watch(isActive, (val)=>!val && queue.unregister(id), {
            flush: 'sync'
        });
        const { resizeRef: resizeRef, contentRect: contentRect } = useResizeObserver();
        vue.watch(contentEl, (el)=>{
            resizeRef.value = el ?? null;
        });
        vue.watch(contentRect, (rect)=>{
            if (rect?.width) queue.setSize(id, rect.height, rect.width);
        });
        const offset = vue.computed(()=>queue.getOffset(id));
        return {
            id: id,
            offset: offset
        };
    }
    // Types
    function useCountdown(milliseconds) {
        const time = vue.shallowRef(milliseconds());
        let timer = -1;
        function clear() {
            clearInterval(timer);
        }
        function reset() {
            clear();
            vue.nextTick(()=>time.value = milliseconds());
        }
        function start(el) {
            const style = el ? getComputedStyle(el) : {
                transitionDuration: 0.2
            };
            const interval = parseFloat(style.transitionDuration) * 1000 || 200;
            clear();
            if (time.value <= 0) return;
            const startTime = performance.now();
            timer = window.setInterval(()=>{
                const elapsed = performance.now() - startTime + interval;
                time.value = Math.max(milliseconds() - elapsed, 0);
                if (time.value <= 0) clear();
            }, interval);
        }
        vue.onScopeDispose(clear);
        return {
            clear: clear,
            time: time,
            start: start,
            reset: reset
        };
    }
    const makeVSnackbarProps = propsFactory({
        collapsed: Object,
        loading: Boolean,
        prependAvatar: String,
        prependIcon: IconValue,
        queueGap: Number,
        queueIndex: Number,
        title: String,
        text: String,
        reverseTimer: Boolean,
        timer: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        timerColor: String,
        timeout: {
            type: [
                Number,
                String
            ],
            default: 5000
        },
        vertical: Boolean,
        ...makeLocationProps({
            location: 'bottom center'
        }),
        ...makePositionProps(),
        ...makeRoundedProps(),
        ...makeVariantProps(),
        ...makeThemeProps(),
        ...omit(makeVOverlayProps({
            closeOnBack: false,
            locationStrategy: null,
            transition: 'v-snackbar-transition'
        }), [
            'persistent',
            'noClickAnimation',
            'offset',
            'retainFocus',
            'captureFocus',
            'disableInitialFocus',
            'location',
            'scrim',
            'scrollStrategy',
            'stickToTarget',
            'viewportMargin'
        ])
    }, 'VSnackbar');
    const VSnackbar = genericComponent()({
        name: 'VSnackbar',
        props: makeVSnackbarProps(),
        emits: {
            'update:modelValue': (v)=>true
        },
        setup (props, { slots: slots }) {
            const isActive = useProxiedModel(props, 'modelValue');
            const { positionClasses: positionClasses } = usePosition(props);
            const { scopeId: scopeId } = useScopeId();
            const { themeClasses: themeClasses } = provideTheme(props);
            const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = useVariant(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const countdown = useCountdown(()=>Number(props.timeout));
            const overlay = vue.ref();
            const queueItem = useSnackbarItem(isActive, ()=>overlay.value?.contentEl);
            let _lastOffset;
            const timerRef = vue.ref();
            const isHovering = vue.shallowRef(false);
            const isFocused = vue.shallowRef(false);
            const startY = vue.shallowRef(0);
            const mainStyles = vue.ref();
            const hasLayout = vue.inject(VuetifyLayoutKey, undefined);
            useToggleScope(()=>!!hasLayout, ()=>{
                const layout = useLayout();
                vue.watchEffect(()=>{
                    mainStyles.value = layout.mainStyles.value;
                });
            });
            vue.watch(isActive, startTimeout);
            vue.watch(()=>props.timeout, startTimeout);
            vue.onMounted(()=>{
                if (isActive.value) startTimeout();
            });
            let activeTimeout = -1;
            function startTimeout() {
                countdown.clear();
                window.clearTimeout(activeTimeout);
                const timeout = Number(props.timeout);
                if (!isActive.value || timeout === -1) return;
                countdown.reset();
                const element = refElement(timerRef.value);
                vue.nextTick(()=>countdown.start(element));
                activeTimeout = window.setTimeout(()=>{
                    isActive.value = false;
                }, timeout);
            }
            function clearTimeout1() {
                countdown.reset();
                window.clearTimeout(activeTimeout);
            }
            function onPointerenter() {
                isHovering.value = true;
                clearTimeout1();
            }
            function onPointerleave() {
                isHovering.value = false;
                if (!isFocused.value) startTimeout();
            }
            function onFocusin() {
                isFocused.value = true;
                clearTimeout1();
            }
            function onFocusout(event) {
                const contentEl = overlay.value?.contentEl;
                if (contentEl?.contains(event.relatedTarget)) return;
                isFocused.value = false;
                if (!isHovering.value) startTimeout();
            }
            function onTouchstart(event) {
                startY.value = event.touches[0].clientY;
            }
            function onTouchend(event) {
                if (Math.abs(startY.value - event.changedTouches[0].clientY) > 50) isActive.value = false;
            }
            function onAfterLeave() {
                if (isHovering.value) onPointerleave();
                isFocused.value = false;
            }
            const locationClasses = vue.computed(()=>{
                return props.location.split(' ').reduce((acc, loc)=>{
                    acc[`v-snackbar--${loc}`] = true;
                    return acc;
                }, {});
            });
            const queueDirection = vue.computed(()=>{
                const [side, align] = props.location.split(' ');
                return side === 'bottom' || [
                    'left',
                    'right'
                ].includes(side) && align === 'end' ? -1 : 1;
            });
            const collapsedStyles = vue.computed(()=>{
                if (!props.collapsed) return null;
                return {
                    '--v-snackbar-collapsed-height': convertToUnit(props.collapsed.height),
                    '--v-snackbar-collapsed-width': convertToUnit(props.collapsed.width)
                };
            });
            const offset = vue.computed(()=>{
                if (!queueItem) return undefined;
                if (queueItem.offset.value === null) return _lastOffset;
                return _lastOffset = convertToUnit(queueItem.offset.value);
            });
            const transition = vue.computed(()=>{
                if (typeof props.transition !== 'string' || !props.transition.endsWith('-auto')) return props.transition;
                const prefix = props.transition.replace('-auto', '');
                const [side, align] = props.location.split(' ');
                const axis = [
                    'start',
                    'end',
                    'left',
                    'right'
                ].includes(align) || [
                    'left',
                    'right'
                ].includes(side) ? 'x' : 'y';
                const reverse = [
                    'end',
                    'right'
                ].includes(align) || ![
                    'start',
                    'left'
                ].includes(align) && [
                    'bottom',
                    'right'
                ].includes(side) ? '-reverse' : '';
                return `${prefix}-${axis}${reverse}-transition`;
            });
            useRender(()=>{
                const overlayProps = VOverlay.filterProps({
                    ...props,
                    location: props.location,
                    locationStrategy: props.locationStrategy ?? noop
                });
                const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
                const hasPrepend = !!(hasPrependMedia || props.loading || slots.prepend);
                const hasContent = !!(slots.default || slots.text || slots.title || props.text || props.title);
                return vue.createVNode(VOverlay, vue.mergeProps({
                    "ref": overlay,
                    "class": [
                        'v-snackbar',
                        {
                            'v-snackbar--active': isActive.value,
                            'v-snackbar--collapsed': !!props.collapsed,
                            'v-snackbar--timer': !!props.timer,
                            'v-snackbar--vertical': props.vertical
                        },
                        locationClasses.value,
                        positionClasses.value,
                        props.class
                    ],
                    "style": [
                        mainStyles.value,
                        {
                            '--v-snackbar-offset': offset.value,
                            '--v-snackbar-gap': convertToUnit(props.queueGap),
                            '--v-snackbar-index': props.queueIndex,
                            '--v-snackbar-direction': queueDirection.value
                        },
                        collapsedStyles.value,
                        props.style
                    ]
                }, overlayProps, {
                    "transition": transition.value,
                    "modelValue": isActive.value,
                    "onUpdate:modelValue": ($event)=>isActive.value = $event,
                    "contentProps": vue.mergeProps({
                        class: [
                            'v-snackbar__wrapper',
                            themeClasses.value,
                            colorClasses.value,
                            roundedClasses.value,
                            variantClasses.value
                        ],
                        style: [
                            colorStyles.value,
                            roundedStyles.value
                        ],
                        onPointerenter: onPointerenter,
                        onPointerleave: onPointerleave,
                        onFocusin: onFocusin,
                        onFocusout: onFocusout
                    }, overlayProps.contentProps),
                    "persistent": true,
                    "noClickAnimation": true,
                    "scrim": false,
                    "scrollStrategy": "none",
                    "onTouchstartPassive": onTouchstart,
                    "onTouchend": onTouchend,
                    "onAfterLeave": onAfterLeave
                }, scopeId), {
                    default: ()=>[
                            genOverlays(false, 'v-snackbar'),
                            slots.header && vue.createElementVNode("div", {
                                "class": "v-snackbar__header"
                            }, [
                                slots.header?.()
                            ]),
                            props.timer && Number(props.timeout) > 0 && !isHovering.value && vue.createElementVNode("div", {
                                "key": "timer",
                                "class": vue.normalizeClass([
                                    'v-snackbar__timer',
                                    `v-snackbar__timer--${props.timer === 'bottom' ? 'bottom' : 'top'}`
                                ])
                            }, [
                                vue.createVNode(VProgressLinear, {
                                    "ref": timerRef,
                                    "color": props.timerColor ?? 'info',
                                    "max": props.timeout,
                                    "modelValue": props.reverseTimer ? Number(props.timeout) - countdown.time.value : countdown.time.value
                                }, null)
                            ]),
                            hasPrepend && vue.createVNode(VDefaultsProvider, {
                                "key": "prepend-defaults",
                                "disabled": !hasPrependMedia && !props.loading,
                                "defaults": {
                                    VAvatar: {
                                        image: props.prependAvatar
                                    },
                                    VIcon: {
                                        icon: props.prependIcon
                                    },
                                    VProgressCircular: {
                                        indeterminate: true,
                                        size: 24,
                                        width: 3
                                    }
                                }
                            }, {
                                default: ()=>[
                                        vue.createElementVNode("div", {
                                            "class": "v-snackbar__prepend"
                                        }, [
                                            slots.prepend ? slots.prepend() : vue.createElementVNode(vue.Fragment, null, [
                                                props.loading && vue.createVNode(VProgressCircular, null, null),
                                                !props.loading && props.prependAvatar && vue.createVNode(VAvatar, null, null),
                                                !props.loading && props.prependIcon && vue.createVNode(VIcon, null, null)
                                            ])
                                        ])
                                    ]
                            }),
                            hasContent && vue.createElementVNode("div", {
                                "key": "content",
                                "class": "v-snackbar__content",
                                "role": "status",
                                "aria-live": "polite"
                            }, [
                                slots.title?.() ?? (props.title ? vue.createElementVNode("div", {
                                    "class": "v-snackbar__title",
                                    "key": "title"
                                }, [
                                    props.title
                                ]) : ''),
                                slots.text?.() ?? props.text,
                                slots.default?.()
                            ]),
                            slots.actions && vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VBtn: {
                                        variant: 'text',
                                        ripple: false,
                                        slim: true
                                    }
                                }
                            }, {
                                default: ()=>[
                                        vue.createElementVNode("div", {
                                            "class": "v-snackbar__actions"
                                        }, [
                                            slots.actions({
                                                isActive: isActive
                                            })
                                        ])
                                    ]
                            })
                        ],
                    activator: slots.activator
                });
            });
            return forwardRefs({}, overlay);
        }
    });
    // Utilities
    function useDocumentVisibility() {
        const visibility = vue.shallowRef(IN_BROWSER ? document.visibilityState : 'visible');
        if (IN_BROWSER) {
            const onVisibilityChange = ()=>{
                visibility.value = document.visibilityState;
            };
            document.addEventListener('visibilitychange', onVisibilityChange, {
                passive: true
            });
            vue.onBeforeUnmount(()=>{
                document.removeEventListener('visibilitychange', onVisibilityChange);
            });
        }
        return visibility;
    }
    // Types
    const makeVSnackbarQueueProps = propsFactory({
        // TODO: Port this to Snackbar on dev
        closable: [
            Boolean,
            String
        ],
        closeText: {
            type: String,
            default: '$vuetify.dismiss'
        },
        collapsed: Boolean,
        displayStrategy: {
            type: String,
            default: 'hold'
        },
        modelValue: {
            type: Array,
            default: ()=>[]
        },
        totalVisible: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        gap: {
            type: [
                Number,
                String
            ],
            default: 8
        },
        ...omit(makeVSnackbarProps(), [
            'modelValue',
            'collapsed',
            'queueIndex',
            'queueGap'
        ])
    }, 'VSnackbarQueue');
    const VSnackbarQueue = genericComponent()({
        name: 'VSnackbarQueue',
        inheritAttrs: false,
        props: makeVSnackbarQueueProps(),
        emits: {
            'update:modelValue': (val)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const documentVisibility = useDocumentVisibility();
            const queue = useSnackbarQueue(props);
            const isHovered = vue.shallowRef(false);
            const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = useDelay({
                openDelay: 0,
                closeDelay: 500
            }, (val)=>{
                isHovered.value = val;
                updateDynamicProps();
            });
            let _lastId = 0;
            const visibleItems = vue.ref([]);
            const limit = vue.toRef(()=>Number(props.totalVisible));
            vue.watch(()=>props.modelValue.length, showNext);
            function removeItem(id) {
                visibleItems.value = visibleItems.value.filter((x)=>x.id !== id);
                if (visibleItems.value.length === 0) isHovered.value = false;
                showNext();
            }
            function showNext() {
                if (!props.modelValue.length) return;
                const activeCount = visibleItems.value.filter((x)=>x.active).length;
                if (activeCount >= limit.value) {
                    if (props.displayStrategy !== 'overflow') return;
                    // Dismiss oldest active items to make room
                    visibleItems.value.filter((x)=>x.active).slice(limit.value - 1).forEach((item)=>{
                        item.active = false;
                        item.onDismiss?.('overflow');
                    });
                }
                const [next, ...rest] = props.modelValue;
                emit('update:modelValue', rest);
                const item = typeof next === 'string' ? {
                    text: next
                } : next;
                const { promise: promise, success: success, error: error, onDismiss: onDismiss, ...itemProps } = item;
                const newItem = {
                    id: _lastId++,
                    item: {
                        ...promise ? {
                            timeout: -1,
                            loading: true
                        } : {},
                        ...itemProps
                    },
                    active: true,
                    onDismiss: onDismiss
                };
                visibleItems.value.unshift(newItem);
                updateDynamicProps();
                promise?.then((data)=>{
                    if (!newItem.active) return;
                    newItem.item = success?.(data) ?? {
                        ...newItem.item,
                        timeout: 1
                    };
                    updateDynamicProps();
                    vue.triggerRef(visibleItems);
                }, (data)=>{
                    if (!newItem.active) return;
                    newItem.item = error?.(data) ?? {
                        ...newItem.item,
                        timeout: 1
                    };
                    updateDynamicProps();
                    vue.triggerRef(visibleItems);
                });
            }
            function dismiss(id, reason) {
                const item = visibleItems.value.find((x)=>x.id === id);
                if (!item) return;
                item.active = false;
                item.onDismiss?.(reason);
                updateDynamicProps();
            }
            function clear() {
                emit('update:modelValue', []);
                visibleItems.value.toReversed().forEach((item, i)=>setTimeout(()=>{
                        item.active = false;
                        item.onDismiss?.('cleared');
                    }, 100 * i));
            }
            const btnProps = vue.computed(()=>({
                    color: typeof props.closable === 'string' ? props.closable : undefined,
                    text: t(props.closeText)
                }));
            function updateDynamicProps() {
                let activeIndex = 0;
                visibleItems.value.forEach(({ item: item, active: active })=>{
                    item.queueIndex = activeIndex;
                    if (active) activeIndex++;
                });
                if (!props.collapsed || isHovered.value) {
                    visibleItems.value.forEach(({ item: item })=>item.collapsed = undefined);
                    return;
                }
                for (const { item: item } of visibleItems.value)item.collapsed = item.queueIndex > 0 ? {
                    width: queue.lastItemSize.value.width,
                    height: queue.lastItemSize.value.height
                } : undefined;
            }
            vue.watch(queue.lastItemSize, updateDynamicProps);
            vue.watch(()=>props.collapsed, updateDynamicProps);
            useRender(()=>{
                const hasActions = !!(props.closable || slots.actions);
                const snackbarProps = omit(VSnackbar.filterProps(props), [
                    'modelValue',
                    'collapsed'
                ]);
                const pauseAll = documentVisibility.value === 'hidden' || props.collapsed && isHovered.value;
                return vue.createElementVNode(vue.Fragment, null, [
                    visibleItems.value.map(({ id: id, item: item, active: active })=>slots.item ? vue.createVNode(VDefaultsProvider, {
                            "defaults": {
                                VSnackbar: item
                            }
                        }, {
                            default: ()=>[
                                    slots.item({
                                        item: item
                                    })
                                ]
                        }) : vue.createVNode(VSnackbar, vue.mergeProps({
                            "key": id
                        }, attrs, snackbarProps, item, pauseAll ? {
                            timeout: -1
                        } : {}, {
                            "queueGap": Number(props.gap),
                            "contentProps": vue.mergeProps(snackbarProps.contentProps, {
                                onMouseenter: runOpenDelay,
                                onMouseleave: ()=>runCloseDelay()
                            }),
                            "modelValue": active,
                            "onUpdate:modelValue": ()=>dismiss(id, 'auto'),
                            "onAfterLeave": ()=>removeItem(id)
                        }), {
                            header: slots.header ? ()=>slots.header?.({
                                    item: item
                                }) : undefined,
                            text: slots.text ? ()=>slots.text?.({
                                    item: item
                                }) : undefined,
                            actions: hasActions ? ()=>vue.createElementVNode(vue.Fragment, null, [
                                    !slots.actions ? vue.createVNode(VBtn, vue.mergeProps(btnProps.value, {
                                        "onClick": ()=>dismiss(id, 'dismissed')
                                    }), null) : vue.createVNode(VDefaultsProvider, {
                                        "defaults": {
                                            VBtn: btnProps.value
                                        }
                                    }, {
                                        default: ()=>[
                                                slots.actions({
                                                    item: item,
                                                    props: {
                                                        onClick: ()=>dismiss(id, 'dismissed')
                                                    }
                                                })
                                            ]
                                    })
                                ]) : undefined
                        }))
                ]);
            });
            return {
                clear: clear
            };
        }
    });
    // Types
    const makeVTooltipProps = propsFactory({
        id: String,
        interactive: Boolean,
        text: String,
        color: String,
        ...omit(makeVOverlayProps({
            closeOnBack: false,
            location: 'end',
            locationStrategy: 'connected',
            eager: true,
            minWidth: 0,
            offset: 10,
            openOnClick: false,
            openOnHover: true,
            origin: 'auto',
            scrim: false,
            scrollStrategy: 'reposition',
            transition: null
        }), [
            'absolute',
            'retainFocus',
            'captureFocus',
            'disableInitialFocus'
        ])
    }, 'VTooltip');
    const VTooltip = genericComponent()({
        name: 'VTooltip',
        props: makeVTooltipProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const isActive = useProxiedModel(props, 'modelValue');
            const { scopeId: scopeId } = useScopeId();
            const { colorClasses: colorClasses, colorStyles: colorStyles } = useColor(()=>({
                    background: props.color
                }));
            const uid = vue.useId();
            const id = vue.toRef(()=>props.id || `v-tooltip-${uid}`);
            const overlay = vue.ref();
            const location = vue.computed(()=>{
                return props.location.split(' ').length > 1 ? props.location : props.location + ' center';
            });
            const origin = vue.computed(()=>{
                return props.origin === 'auto' || props.origin === 'overlap' || props.origin.split(' ').length > 1 || props.location.split(' ').length > 1 ? props.origin : props.origin + ' center';
            });
            const transition = vue.toRef(()=>{
                if (props.transition != null) return props.transition;
                return isActive.value ? 'scale-transition' : 'fade-transition';
            });
            const activatorProps = vue.computed(()=>vue.mergeProps({
                    'aria-describedby': id.value
                }, props.activatorProps));
            useRender(()=>{
                const overlayProps = VOverlay.filterProps(props);
                return vue.createVNode(VOverlay, vue.mergeProps({
                    "ref": overlay,
                    "class": [
                        'v-tooltip',
                        {
                            'v-tooltip--interactive': props.interactive
                        },
                        props.class
                    ],
                    "style": [
                        props.style
                    ],
                    "id": id.value
                }, overlayProps, {
                    "contentClass": [
                        colorClasses.value,
                        props.contentClass
                    ],
                    "contentProps": vue.mergeProps({
                        style: [
                            colorStyles.value
                        ]
                    }, props.contentProps),
                    "modelValue": isActive.value,
                    "onUpdate:modelValue": ($event)=>isActive.value = $event,
                    "transition": transition.value,
                    "absolute": true,
                    "location": location.value,
                    "origin": origin.value,
                    "role": "tooltip",
                    "activatorProps": activatorProps.value,
                    "_disableGlobalStack": true
                }, scopeId), {
                    activator: slots.activator,
                    default: (...args)=>slots.default?.(...args) ?? props.text
                });
            });
            return forwardRefs({}, overlay);
        }
    });
    // Types
    const makeVSparklineTooltipProps = propsFactory({
        modelValue: Boolean,
        target: Object,
        index: {
            type: Number,
            default: null
        },
        value: {
            type: Number,
            default: 0
        },
        titleFormat: {
            type: Function,
            default: (item)=>String(item.value)
        },
        offset: Number,
        contentClass: null,
        location: String
    }, 'VSparklineTooltip');
    const VSparklineTooltip = genericComponent()({
        name: 'VSparklineTooltip',
        props: makeVSparklineTooltipProps(),
        emits: {
            afterLeave: ()=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            return ()=>vue.createVNode(VTooltip, {
                    "modelValue": props.modelValue,
                    "target": props.target,
                    "offset": props.offset,
                    "contentClass": props.contentClass,
                    "location": props.location,
                    "onAfterLeave": ()=>emit('afterLeave')
                }, {
                    default: ()=>[
                            props.index !== null && (slots.default?.({
                                index: props.index,
                                value: props.value
                            }) ?? props.titleFormat({
                                index: props.index,
                                value: props.value
                            }))
                        ]
                });
        }
    });
    // Types
    /**
   * Monotone cubic Hermite interpolation (Fritsch-Carlson) converted to cubic Bezier.
   * Prevents overshoot at local extrema (e.g. consecutive equal min/max values)
   * by zeroing tangents at turning points and applying an alpha-beta constraint.
   *
   * `smooth` controls tension: 0 = straight lines, 8 (default true) = full curve.
   */ function genMonotonePath(points, smooth, fill = false, height = 75) {
        if (points.length === 0) return '';
        const start = points[0];
        const end = points[points.length - 1];
        const prefix = fill ? `M${start.x} ${height - start.x + 2} L${start.x} ${start.y}` : `M${start.x} ${start.y}`;
        const suffix = fill ? `L${end.x} ${height - start.x + 2} Z` : '';
        if (smooth === 0 || points.length < 3) return prefix + points.slice(1).map((point)=>`L${point.x} ${point.y}`).join('') + suffix;
        const tension = Math.min(smooth / 8, 1);
        const n = points.length;
        const delta = [];
        for(let i = 0; i < n - 1; i++){
            const dx = points[i + 1].x - points[i].x;
            delta[i] = dx === 0 ? 0 : (points[i + 1].y - points[i].y) / dx;
        }
        const tangent = new Array(n);
        tangent[0] = delta[0];
        tangent[n - 1] = delta[n - 2];
        for(let i = 1; i < n - 1; i++)if (delta[i - 1] === 0 || delta[i] === 0 || delta[i - 1] > 0 !== delta[i] > 0) tangent[i] = 0;
        else tangent[i] = (delta[i - 1] + delta[i]) / 2;
        for(let i = 0; i < n - 1; i++)if (delta[i] === 0) {
            tangent[i] = 0;
            tangent[i + 1] = 0;
        } else {
            const alpha = tangent[i] / delta[i];
            const beta = tangent[i + 1] / delta[i];
            const squaredSum = alpha * alpha + beta * beta;
            if (squaredSum > 9) {
                const tau = 3 / Math.sqrt(squaredSum);
                tangent[i] = tau * alpha * delta[i];
                tangent[i + 1] = tau * beta * delta[i];
            }
        }
        const curves = points.slice(1).map((curr, index)=>{
            const prev = points[index];
            const dx = curr.x - prev.x;
            const controlPoint1X = prev.x + dx * tension / 3;
            const controlPoint1Y = prev.y + tangent[index] * dx * tension / 3;
            const controlPoint2X = curr.x - dx * tension / 3;
            const controlPoint2Y = curr.y - tangent[index + 1] * dx * tension / 3;
            return `C${controlPoint1X} ${controlPoint1Y} ${controlPoint2X} ${controlPoint2Y} ${curr.x} ${curr.y}`;
        });
        return prefix + curves.join('') + suffix;
    }
    // @ts-nocheck
    /* eslint-disable */ // import { checkCollinear, getDistance, moveTo } from './math'
    /**
   * From https://github.com/unsplash/react-trend/blob/master/src/helpers/DOM.helpers.js#L18
   */ function genRoundedPath(points, radius, fill = false, height = 75, consistentStructure = false) {
        if (points.length === 0) return '';
        const start = points.shift();
        const end = points[points.length - 1];
        return (fill ? `M${start.x} ${height - start.x + 2} L${start.x} ${start.y}` : `M${start.x} ${start.y}`) + points.map((point, index)=>{
            const next = points[index + 1];
            const prev = points[index - 1] || start;
            const isCollinear = next && checkCollinear(next, point, prev);
            if (!next) return consistentStructure ? `L${point.x} ${point.y}S${point.x} ${point.y} ${point.x} ${point.y}` : `L${point.x} ${point.y}`;
            if (isCollinear && !consistentStructure) return `L${point.x} ${point.y}`;
            const threshold = Math.min(getDistance(prev, point), getDistance(next, point));
            const isTooCloseForRadius = threshold / 2 < radius;
            const radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;
            const before = moveTo(prev, point, radiusForPoint);
            const after = moveTo(next, point, radiusForPoint);
            return `L${before.x} ${before.y}S${point.x} ${point.y} ${after.x} ${after.y}`;
        }).join('') + (fill ? `L${end.x} ${height - start.x + 2} Z` : '');
    }
    function int(value) {
        return parseInt(value, 10);
    }
    /**
   * https://en.wikipedia.org/wiki/Collinearity
   * x=(x1+x2)/2
   * y=(y1+y2)/2
   */ function checkCollinear(p0, p1, p2) {
        return int(p0.x + p2.x) === int(2 * p1.x) && int(p0.y + p2.y) === int(2 * p1.y);
    }
    function getDistance(p1, p2) {
        return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    }
    function moveTo(to, from, radius) {
        const vector = {
            x: to.x - from.x,
            y: to.y - from.y
        };
        const length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
        const unitVector = {
            x: vector.x / length,
            y: vector.y / length
        };
        return {
            x: from.x + unitVector.x * radius,
            y: from.y + unitVector.y * radius
        };
    }
    // Utilities
    // Types
    const makeLineProps = propsFactory({
        animation: {
            type: [
                Boolean,
                Object
            ],
            default: false
        },
        autoDraw: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        autoDrawDuration: [
            Number,
            String
        ],
        autoDrawEasing: {
            type: String,
            default: 'ease'
        },
        color: String,
        gradient: {
            type: Array,
            default: ()=>[]
        },
        gradientDirection: {
            type: String,
            validator: (val)=>[
                    'top',
                    'bottom',
                    'left',
                    'right'
                ].includes(val),
            default: 'top'
        },
        height: {
            type: [
                String,
                Number
            ],
            default: 75
        },
        labels: {
            type: Array,
            default: ()=>[]
        },
        labelSize: {
            type: [
                Number,
                String
            ],
            default: 7
        },
        lineWidth: {
            type: [
                String,
                Number
            ],
            default: 4
        },
        id: String,
        itemValue: {
            type: String,
            default: 'value'
        },
        modelValue: {
            type: Array,
            default: ()=>[]
        },
        min: [
            String,
            Number
        ],
        max: [
            String,
            Number
        ],
        padding: {
            type: [
                String,
                Number
            ],
            default: 8
        },
        markerSize: {
            type: [
                Number,
                String
            ],
            default: 8
        },
        markerStroke: {
            type: String,
            default: '#fff'
        },
        inset: Boolean,
        showLabels: Boolean,
        showMarkers: Boolean,
        smooth: [
            Boolean,
            String,
            Number
        ],
        smoothMode: {
            type: String,
            default: 'default'
        },
        interactive: Boolean,
        tooltip: {
            type: [
                Boolean,
                Object
            ],
            default: false
        },
        width: {
            type: [
                Number,
                String
            ],
            default: 300
        }
    }, 'Line');
    function resample(values, targetCount) {
        const length = values.length;
        if (length === 0) return Array(targetCount).fill(0);
        if (length === 1) return Array(targetCount).fill(values[0]);
        const result = [];
        for(let i = 0; i < targetCount; i++){
            const t = i / (targetCount - 1) * (length - 1);
            const low = Math.floor(t);
            const high = Math.min(low + 1, length - 1);
            const fraction = t - low;
            result.push(values[low] + (values[high] - values[low]) * fraction);
        }
        return result;
    }
    function extendPoints(points, inset, totalWidth) {
        if (!inset || points.length < 2) return points;
        const first = points[0];
        const second = points[1];
        const last = points[points.length - 1];
        const secondLast = points[points.length - 2];
        const slopeStart = (second.y - first.y) / (second.x - first.x);
        const slopeEnd = (last.y - secondLast.y) / (last.x - secondLast.x);
        const ghostStart = {
            x: 0,
            y: first.y - first.x * slopeStart,
            value: first.value
        };
        const ghostEnd = {
            x: totalWidth,
            y: last.y + (totalWidth - last.x) * slopeEnd,
            value: last.value
        };
        return [
            ghostStart,
            ...points,
            ghostEnd
        ];
    }
    function buildPath(points, options) {
        const smoothValue = typeof options.smooth === 'boolean' ? options.smooth ? 8 : 0 : Number(options.smooth ?? 0);
        // genRoundedPath mutates via shift(); slice defensively so callers don't have to
        const copy = points.slice();
        if (options.smoothMode === 'monotone') return genMonotonePath(copy, smoothValue, options.fill, options.height);
        return genRoundedPath(copy, smoothValue, options.fill, options.height, options.animation);
    }
    // Types
    const makeVBarlineProps = propsFactory({
        autoLineWidth: Boolean,
        ...makeLineProps()
    }, 'VBarline');
    const VBarline = genericComponent()({
        name: 'VBarline',
        inheritAttrs: false,
        props: makeVBarlineProps(),
        emits: {
            'update:currentIndex': (_index)=>true
        },
        setup (props, { slots: slots, attrs: attrs, emit: emit }) {
            const uid = vue.useId();
            const id = vue.computed(()=>props.id || `barline-${uid}`);
            const autoDrawDuration = vue.computed(()=>Number(props.autoDrawDuration) || 500);
            const hasDrawn = vue.ref(false);
            const clipRects = vue.shallowRef([]);
            const animationDuration = vue.computed(()=>typeof props.animation === 'object' ? props.animation.duration ?? 300 : 300);
            const animationEasing = vue.computed(()=>typeof props.animation === 'object' ? props.animation.easing ?? 'ease' : 'ease');
            const hasLabels = vue.computed(()=>{
                return Boolean(props.showLabels || props.labels.length > 0 || !!slots?.label);
            });
            const lineWidth = vue.computed(()=>parseFloat(props.lineWidth) || 4);
            const items = vue.computed(()=>props.modelValue.map((item)=>getPropertyFromItem(item, props.itemValue, item)));
            const totalWidth = vue.computed(()=>Math.max(items.value.length * lineWidth.value, Number(props.width)));
            const boundary = vue.computed(()=>{
                return {
                    minX: 0,
                    maxX: totalWidth.value,
                    minY: 0,
                    maxY: parseInt(props.height, 10)
                };
            });
            function genBars(values, boundary) {
                const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = boundary;
                const totalValues = values.length;
                let maxValue = props.max != null ? Number(props.max) : Math.max(...values);
                let minValue = props.min != null ? Number(props.min) : Math.min(...values);
                if (minValue > 0 && props.min == null) minValue = 0;
                if (maxValue < 0 && props.max == null) maxValue = 0;
                const gridX = maxX / (totalValues === 1 ? 2 : totalValues);
                const gridY = (maxY - minY) / (maxValue - minValue || 1);
                const horizonY = maxY - Math.abs(minValue * gridY);
                return values.map((value, index)=>{
                    const height = Math.abs(gridY * value);
                    return {
                        x: minX + index * gridX,
                        y: horizonY - height + Number(value < 0) * height,
                        height: height,
                        value: value
                    };
                });
            }
            const bars = vue.computed(()=>genBars(items.value, boundary.value));
            const prevBarCount = vue.ref(0);
            function applyTransition(el, duration, easing) {
                el.style.transition = `y ${duration}ms ${easing}, height ${duration}ms ${easing}`;
            }
            function collapseNewBars(bars, fromIndex, duration, easing) {
                for(let i = fromIndex; i < bars.length; i++){
                    const el = clipRects.value[i];
                    if (!el) continue;
                    // Snap to collapsed at bar's baseline
                    el.style.transition = 'none';
                    el.setAttribute('y', String(bars[i].y + bars[i].height));
                    el.setAttribute('height', '0');
                    el.getBoundingClientRect();
                    // Animate to final state
                    applyTransition(el, duration, easing);
                    el.setAttribute('y', String(bars[i].y));
                    el.setAttribute('height', String(bars[i].height));
                }
            }
            function applyBarsTransition(oldCount) {
                if (!props.animation) return;
                clipRects.value.forEach((el)=>{
                    if (el) applyTransition(el, animationDuration.value, animationEasing.value);
                });
                if (bars.value.length > oldCount && oldCount > 0) collapseNewBars(bars.value, oldCount, animationDuration.value, animationEasing.value);
            }
            vue.watch(()=>props.modelValue, async ()=>{
                await vue.nextTick();
                if (PREFERS_REDUCED_MOTION() || !clipRects.value.length) return;
                const oldCount = prevBarCount.value;
                prevBarCount.value = bars.value.length;
                // Animation-only mode (no auto-draw), or draw-once after first draw: just ensure transition is set
                if (!props.autoDraw || props.autoDraw === 'once' && hasDrawn.value) {
                    applyBarsTransition(oldCount);
                    return;
                }
                hasDrawn.value = true;
                const shouldDrawOnce = props.autoDraw === 'once';
                clipRects.value.forEach((el, i)=>{
                    const bar = bars.value[i];
                    if (!el || !bar) return;
                    // Snap to collapsed state
                    el.style.transition = 'none';
                    el.setAttribute('y', String(bar.y + bar.height));
                    el.setAttribute('height', '0');
                    el.getBoundingClientRect();
                    // Animate to final state
                    applyTransition(el, autoDrawDuration.value, props.autoDrawEasing);
                    el.setAttribute('y', String(bar.y));
                    el.setAttribute('height', String(bar.height));
                    // After initial draw, switch to animation timing for subsequent changes
                    if (shouldDrawOnce && props.animation) el.addEventListener('transitionend', ()=>{
                        applyTransition(el, animationDuration.value, animationEasing.value);
                    }, {
                        once: true
                    });
                });
            }, {
                immediate: true
            });
            const parsedLabels = vue.computed(()=>{
                return bars.value.map((bar, i)=>({
                        x: bar.x,
                        value: String(props.labels[i] ?? bar.value)
                    }));
            });
            const offsetX = vue.computed(()=>bars.value.length === 1 ? (boundary.value.maxX - lineWidth.value) / 2 : (Math.abs(bars.value[0].x - bars.value[1].x) - lineWidth.value) / 2);
            const smooth = vue.computed(()=>typeof props.smooth === 'boolean' ? props.smooth ? 2 : 0 : Number(props.smooth));
            const columnWidth = vue.computed(()=>{
                const len = bars.value.length;
                return totalWidth.value / (len === 1 ? 2 : len);
            });
            // Hover / tooltip state
            const svgRef = vue.shallowRef(null);
            const currentIndex = vue.shallowRef(null);
            const tooltipVisible = vue.shallowRef(false);
            const targetX = vue.shallowRef(0);
            const targetY = vue.shallowRef(0);
            const targetHeight = vue.shallowRef(0);
            vue.watch(currentIndex, (index)=>{
                if (index === null) return;
                const bar = bars.value[index];
                if (!bar) return;
                targetX.value = bar.x + offsetX.value;
                targetY.value = bar.y;
                targetHeight.value = bar.height;
            });
            const transitionOptions = {
                duration: 150,
                transition: easingPatterns.easeOutQuad
            };
            const animatedX = useTransition(targetX, transitionOptions);
            const animatedY = useTransition(targetY, transitionOptions);
            const tooltipTarget = vue.computed(()=>{
                if (currentIndex.value === null || !svgRef.value) return undefined;
                const ctm = svgRef.value.getScreenCTM();
                if (!ctm) return undefined;
                const svgPoint = svgRef.value.createSVGPoint();
                svgPoint.x = animatedX.value + lineWidth.value / 2;
                svgPoint.y = animatedY.value;
                const { x: x, y: y } = svgPoint.matrixTransform(ctm);
                return [
                    x,
                    y
                ];
            });
            const tooltipConfig = vue.computed(()=>({
                    showCrosshair: false,
                    titleFormat: (item)=>String(item.value),
                    ...typeof props.tooltip === 'object' ? props.tooltip : {}
                }));
            let frame = -1;
            function onSvgMousemove(e) {
                const target = e.currentTarget;
                cancelAnimationFrame(frame);
                frame = requestAnimationFrame(()=>{
                    const rect = target.getBoundingClientRect();
                    const svgX = (e.clientX - rect.left) / rect.width * totalWidth.value;
                    let nearest = 0;
                    let minDist = Infinity;
                    bars.value.forEach((bar, i)=>{
                        const barCenter = bar.x + offsetX.value + lineWidth.value / 2;
                        const dist = Math.abs(barCenter - svgX);
                        if (dist < minDist) {
                            minDist = dist;
                            nearest = i;
                        }
                    });
                    currentIndex.value = nearest;
                    emit('update:currentIndex', nearest);
                    tooltipVisible.value = true;
                });
            }
            function onSvgMouseleave() {
                cancelAnimationFrame(frame);
                tooltipVisible.value = false;
                if (!props.tooltip) {
                    currentIndex.value = null;
                    emit('update:currentIndex', null);
                }
            }
            function onTooltipAfterLeave() {
                currentIndex.value = null;
                emit('update:currentIndex', null);
            }
            function setIndex(index) {
                currentIndex.value = index;
                emit('update:currentIndex', index);
                tooltipVisible.value = index !== null;
            }
            function onSvgFocus() {
                if (!bars.value.length) return;
                setIndex(bars.value.length - 1);
            }
            function onSvgBlur() {
                tooltipVisible.value = false;
                if (!props.tooltip) setIndex(null);
            }
            function onSvgKeydown(e) {
                if (!bars.value.length) return;
                const len = bars.value.length;
                if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                    e.preventDefault();
                    const direction = e.key === 'ArrowLeft' ? -1 : 1;
                    const current = currentIndex.value ?? (direction === 1 ? -1 : len);
                    const next = Math.max(0, Math.min(len - 1, current + direction));
                    setIndex(next);
                }
            }
            useRender(()=>{
                const gradientData = !props.gradient.slice().length ? [
                    ''
                ] : props.gradient.slice().reverse();
                return vue.createElementVNode(vue.Fragment, null, [
                    vue.createElementVNode("svg", vue.mergeProps({
                        "ref": svgRef,
                        "display": "block",
                        "tabindex": props.interactive ? 0 : undefined,
                        "onMousemove": props.interactive ? onSvgMousemove : undefined,
                        "onMouseleave": props.interactive ? onSvgMouseleave : undefined,
                        "onFocus": props.interactive ? onSvgFocus : undefined,
                        "onBlur": props.interactive ? onSvgBlur : undefined,
                        "onKeydown": props.interactive ? onSvgKeydown : undefined
                    }, attrs), [
                        vue.createElementVNode("defs", null, [
                            vue.createElementVNode("linearGradient", {
                                "id": id.value,
                                "gradientUnits": "userSpaceOnUse",
                                "x1": props.gradientDirection === 'left' ? '100%' : '0',
                                "y1": props.gradientDirection === 'top' ? '100%' : '0',
                                "x2": props.gradientDirection === 'right' ? '100%' : '0',
                                "y2": props.gradientDirection === 'bottom' ? '100%' : '0'
                            }, [
                                gradientData.map((color, index)=>vue.createElementVNode("stop", {
                                        "offset": index / Math.max(gradientData.length - 1, 1),
                                        "stop-color": color || 'currentColor'
                                    }, null))
                            ])
                        ]),
                        vue.createElementVNode("clipPath", {
                            "id": `${id.value}-clip`
                        }, [
                            bars.value.map((item, i)=>vue.createElementVNode("rect", {
                                    "ref": (el)=>{
                                        if (el) clipRects.value[i] = el;
                                    },
                                    "x": item.x + offsetX.value,
                                    "y": item.y,
                                    "width": lineWidth.value,
                                    "height": item.height,
                                    "rx": smooth.value,
                                    "ry": smooth.value
                                }, null))
                        ]),
                        hasLabels.value && vue.createElementVNode("g", {
                            "key": "labels",
                            "style": {
                                textAnchor: 'middle',
                                dominantBaseline: 'mathematical',
                                fill: 'currentColor'
                            }
                        }, [
                            parsedLabels.value.map((item, i)=>vue.createElementVNode("text", {
                                    "x": item.x + offsetX.value + lineWidth.value / 2,
                                    "y": parseInt(props.height, 10) - 2 + (parseInt(props.labelSize, 10) || 5.25),
                                    "font-size": Number(props.labelSize) || 7
                                }, [
                                    slots.label?.({
                                        index: i,
                                        value: item.value
                                    }) ?? item.value
                                ]))
                        ]),
                        props.interactive && currentIndex.value !== null && vue.createElementVNode("rect", {
                            "key": "highlight",
                            "x": animatedX.value - offsetX.value,
                            "y": 0,
                            "width": columnWidth.value,
                            "height": props.height,
                            "fill": "currentColor",
                            "opacity": 0.1,
                            "pointer-events": "none"
                        }, null),
                        vue.createElementVNode("g", {
                            "clip-path": `url(#${id.value}-clip)`,
                            "fill": `url(#${id.value})`
                        }, [
                            vue.createElementVNode("rect", {
                                "x": 0,
                                "y": 0,
                                "width": totalWidth.value,
                                "height": props.height
                            }, null)
                        ])
                    ]),
                    !!props.tooltip && vue.createVNode(VSparklineTooltip, {
                        "key": "tooltip",
                        "modelValue": tooltipVisible.value,
                        "target": tooltipTarget.value,
                        "index": currentIndex.value,
                        "value": currentIndex.value !== null ? bars.value[currentIndex.value].value : 0,
                        "offset": tooltipConfig.value.offset,
                        "contentClass": tooltipConfig.value.class,
                        "titleFormat": tooltipConfig.value.titleFormat,
                        "location": "top center",
                        "onAfterLeave": onTooltipAfterLeave
                    }, {
                        default: slots.tooltip
                    })
                ]);
            });
        }
    });
    // Types
    const makeVTrendlineProps = propsFactory({
        fill: Boolean,
        ...makeLineProps()
    }, 'VTrendline');
    const VTrendline = genericComponent()({
        name: 'VTrendline',
        inheritAttrs: false,
        props: makeVTrendlineProps(),
        emits: {
            'update:currentIndex': (_index)=>true
        },
        setup (props, { slots: slots, attrs: attrs, emit: emit }) {
            const uid = vue.useId();
            const id = vue.computed(()=>props.id || `trendline-${uid}`);
            const autoDrawDuration = vue.computed(()=>Number(props.autoDrawDuration) || (props.fill ? 500 : 2000));
            const hasDrawn = vue.ref(false);
            const fillPath = vue.ref(null);
            const strokePath = vue.ref(null);
            const animationDuration = vue.computed(()=>typeof props.animation === 'object' ? props.animation.duration ?? 300 : 300);
            const animationEasing = vue.computed(()=>typeof props.animation === 'object' ? props.animation.easing ?? 'ease' : 'ease');
            function genPoints(values, boundary) {
                const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = boundary;
                if (values.length === 1) values = [
                    values[0],
                    values[0]
                ];
                const totalValues = values.length;
                const maxValue = props.max != null ? Number(props.max) : Math.max(...values);
                const minValue = props.min != null ? Number(props.min) : Math.min(...values);
                const gridX = (maxX - minX) / (totalValues - 1);
                const gridY = (maxY - minY) / (maxValue - minValue || 1);
                return values.map((value, index)=>({
                        x: minX + index * gridX,
                        y: maxY - (value - minValue) * gridY,
                        value: value
                    }));
            }
            const hasLabels = vue.computed(()=>{
                return Boolean(props.showLabels || props.labels.length > 0 || !!slots?.label);
            });
            const totalWidth = vue.computed(()=>Number(props.width));
            const boundary = vue.computed(()=>{
                const padding = Number(props.padding);
                return {
                    minX: padding,
                    maxX: totalWidth.value - padding,
                    minY: padding,
                    maxY: parseInt(props.height, 10) - padding
                };
            });
            const items = vue.computed(()=>props.modelValue.map((item)=>getPropertyFromItem(item, props.itemValue, item)));
            // When animation is enabled, resample to a consistent point count
            // so the SVG path always has the same number of commands for CSS d transitions
            const sampleCount = vue.ref(0);
            // When sampleCount grows (new dataset is longer than any seen before),
            // manually patch the DOM path to old-data-at-new-count before Vue re-renders,
            // so the browser sees same-structure paths and can CSS-transition between them.
            vue.watch(items, (newVal, oldVal)=>{
                if (!props.animation) return;
                const prevCount = sampleCount.value;
                if (newVal.length > prevCount) {
                    sampleCount.value = newVal.length;
                    if (prevCount > 0 && oldVal) {
                        const oldResampled = resample(oldVal, sampleCount.value);
                        for (const [pathRef, fill] of [
                            [
                                strokePath,
                                false
                            ],
                            [
                                fillPath,
                                true
                            ]
                        ]){
                            const path = pathRef.value;
                            if (!path) continue;
                            path.setAttribute('d', genPath(oldResampled, fill));
                        }
                    }
                }
            }, {
                immediate: true
            });
            const normalizedItems = vue.computed(()=>{
                if (!props.animation || !sampleCount.value || items.value.length === sampleCount.value) return items.value;
                return resample(items.value, sampleCount.value);
            });
            const points = vue.computed(()=>genPoints(normalizedItems.value, boundary.value));
            const extendedPoints = vue.computed(()=>extendPoints(points.value, props.inset, totalWidth.value));
            function genPath(input, fill) {
                const points = typeof input[0] === 'number' ? extendPoints(genPoints(input, boundary.value), props.inset, totalWidth.value) : input;
                return buildPath(points, {
                    smooth: props.smooth,
                    smoothMode: props.smoothMode,
                    height: parseInt(props.height, 10),
                    fill: fill,
                    animation: !!props.animation
                });
            }
            const parsedLabels = vue.computed(()=>{
                const labels = [];
                const len = points.value.length;
                for(let i = 0; labels.length < len; i++){
                    const point = points.value[i];
                    let value = props.labels[i];
                    if (!value) value = point.value;
                    labels.push({
                        x: point.x,
                        value: String(value)
                    });
                }
                return labels;
            });
            function applyDTransition(path, duration, easing) {
                path.style.transition = `d ${duration}ms ${easing}`;
            }
            vue.watch(()=>props.modelValue, async ()=>{
                await vue.nextTick();
                if (PREFERS_REDUCED_MOTION()) return;
                // Animation-only mode (no auto-draw): just ensure d transition is set
                if (!props.autoDraw) {
                    if (props.animation && strokePath.value) {
                        for (const path of [
                            fillPath.value,
                            strokePath.value
                        ])if (path) applyDTransition(path, animationDuration.value, animationEasing.value);
                    }
                    return;
                }
                if (!strokePath.value) return;
                if (props.autoDraw === 'once' && hasDrawn.value) return;
                hasDrawn.value = true;
                const shouldDrawOnce = props.autoDraw === 'once';
                if (!props.fill) {
                    const path = strokePath.value;
                    const length = path.getTotalLength();
                    path.style.transition = 'none';
                    path.style.strokeDasharray = `${length}`;
                    path.style.strokeDashoffset = `${length}`;
                    path.getBoundingClientRect();
                    const dTransition = props.animation ? `, d ${animationDuration.value}ms ${animationEasing.value}` : '';
                    path.style.transition = `stroke-dashoffset ${autoDrawDuration.value}ms ${props.autoDrawEasing}${dTransition}`;
                    path.style.strokeDashoffset = '0';
                    if (shouldDrawOnce) path.addEventListener('transitionend', (e)=>{
                        if (e.propertyName !== 'stroke-dashoffset') return;
                        path.style.strokeDasharray = '';
                        path.style.strokeDashoffset = '';
                        if (props.animation) applyDTransition(path, animationDuration.value, animationEasing.value);
                        else path.style.transition = '';
                    }, {
                        once: true
                    });
                } else for (const path of [
                    fillPath.value,
                    strokePath.value
                ]){
                    if (!path) continue;
                    path.style.transformOrigin = 'bottom center';
                    path.style.transition = 'none';
                    path.style.transform = `scaleY(0)`;
                    path.getBoundingClientRect();
                    const dTransition = props.animation ? `, d ${animationDuration.value}ms ${animationEasing.value}` : '';
                    path.style.transition = `transform ${autoDrawDuration.value}ms ${props.autoDrawEasing}${dTransition}`;
                    path.style.transform = `scaleY(1)`;
                    if (shouldDrawOnce) path.addEventListener('transitionend', (e)=>{
                        if (e.propertyName !== 'transform') return;
                        path.style.transform = '';
                        path.style.transformOrigin = '';
                        if (props.animation) applyDTransition(path, animationDuration.value, animationEasing.value);
                        else path.style.transition = '';
                    }, {
                        once: true
                    });
                }
            }, {
                immediate: true
            });
            // Hover / tooltip state
            const svgRef = vue.shallowRef(null);
            const currentIndex = vue.shallowRef(null);
            const tooltipVisible = vue.shallowRef(false);
            const currentPoint = vue.computed(()=>currentIndex.value !== null ? points.value[currentIndex.value] : null);
            function getPathLengthAtX(svgPath, targetX) {
                const total = svgPath.getTotalLength();
                let low = 0;
                let high = total;
                // 32 bisections ≈ sub-pixel accuracy on any reasonable chart width
                for(let i = 0; i < 32; i++){
                    const mid = (low + high) / 2;
                    if (svgPath.getPointAtLength(mid).x < targetX) low = mid;
                    else high = mid;
                }
                return (low + high) / 2;
            }
            const markerPathLength = vue.shallowRef(0);
            vue.watch(currentPoint, (point)=>{
                if (!point || !strokePath.value) return;
                markerPathLength.value = getPathLengthAtX(strokePath.value, point.x);
            });
            const animatedLength = useTransition(markerPathLength, {
                duration: 150,
                transition: easingPatterns.easeOutQuad
            });
            const markerPoint = vue.computed(()=>{
                const { x: x, y: y } = strokePath.value?.getPointAtLength(animatedLength.value) ?? {
                    x: 0,
                    y: 0
                };
                return {
                    x: x,
                    y: y
                };
            });
            const tooltipTarget = vue.computed(()=>{
                if (!currentPoint.value || !svgRef.value) return undefined;
                const matrix = svgRef.value.getScreenCTM();
                if (!matrix) return undefined;
                const svgPoint = svgRef.value.createSVGPoint();
                svgPoint.x = markerPoint.value.x;
                svgPoint.y = markerPoint.value.y;
                const { x: x, y: y } = svgPoint.matrixTransform(matrix);
                return [
                    x,
                    y
                ];
            });
            const tooltipConfig = vue.computed(()=>({
                    showCrosshair: true,
                    offset: 16,
                    titleFormat: (item)=>String(item.value),
                    ...typeof props.tooltip === 'object' ? props.tooltip : {}
                }));
            let frame = -1;
            function onSvgMousemove(e) {
                const target = e.currentTarget;
                cancelAnimationFrame(frame);
                frame = requestAnimationFrame(()=>{
                    const rect = target.getBoundingClientRect();
                    const svgX = (e.clientX - rect.left) / rect.width * Number(props.width);
                    let nearest = 0;
                    let minDist = Infinity;
                    points.value.forEach((point, index)=>{
                        const dist = Math.abs(point.x - svgX);
                        if (dist < minDist) {
                            minDist = dist;
                            nearest = index;
                        }
                    });
                    currentIndex.value = nearest;
                    emit('update:currentIndex', nearest);
                    tooltipVisible.value = true;
                });
            }
            function onSvgMouseleave() {
                cancelAnimationFrame(frame);
                tooltipVisible.value = false;
                if (!props.tooltip) {
                    currentIndex.value = null;
                    emit('update:currentIndex', null);
                }
            }
            function onTooltipAfterLeave() {
                currentIndex.value = null;
                emit('update:currentIndex', null);
            }
            function setIndex(index) {
                currentIndex.value = index;
                emit('update:currentIndex', index);
                tooltipVisible.value = index !== null;
            }
            function onSvgFocus() {
                if (!points.value.length) return;
                setIndex(points.value.length - 1);
            }
            function onSvgBlur() {
                tooltipVisible.value = false;
                if (!props.tooltip) setIndex(null);
            }
            function onSvgKeydown(e) {
                if (!points.value.length) return;
                const length = points.value.length;
                if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                    e.preventDefault();
                    const direction = e.key === 'ArrowLeft' ? -1 : 1;
                    const current = currentIndex.value ?? (direction === 1 ? -1 : length);
                    const next = Math.max(0, Math.min(length - 1, current + direction));
                    setIndex(next);
                }
            }
            useRender(()=>{
                const gradientData = !props.gradient.slice().length ? [
                    ''
                ] : props.gradient.slice().reverse();
                const markerRadius = (parseFloat(props.markerSize) || 8) / 2;
                return vue.createElementVNode(vue.Fragment, null, [
                    vue.createElementVNode("svg", vue.mergeProps({
                        "ref": svgRef,
                        "display": "block",
                        "stroke-width": parseFloat(props.lineWidth) ?? 4,
                        "tabindex": props.interactive ? 0 : undefined,
                        "onMousemove": props.interactive ? onSvgMousemove : undefined,
                        "onMouseleave": props.interactive ? onSvgMouseleave : undefined,
                        "onFocus": props.interactive ? onSvgFocus : undefined,
                        "onBlur": props.interactive ? onSvgBlur : undefined,
                        "onKeydown": props.interactive ? onSvgKeydown : undefined
                    }, attrs), [
                        vue.createElementVNode("defs", null, [
                            vue.createElementVNode("linearGradient", {
                                "id": id.value,
                                "gradientUnits": "userSpaceOnUse",
                                "x1": props.gradientDirection === 'left' ? '100%' : '0',
                                "y1": props.gradientDirection === 'top' ? '100%' : '0',
                                "x2": props.gradientDirection === 'right' ? '100%' : '0',
                                "y2": props.gradientDirection === 'bottom' ? '100%' : '0'
                            }, [
                                gradientData.map((color, index)=>vue.createElementVNode("stop", {
                                        "offset": index / Math.max(gradientData.length - 1, 1),
                                        "stop-color": color || 'currentColor'
                                    }, null))
                            ])
                        ]),
                        hasLabels.value && vue.createElementVNode("g", {
                            "key": "labels",
                            "style": {
                                textAnchor: 'middle',
                                dominantBaseline: 'mathematical',
                                fill: 'currentColor'
                            }
                        }, [
                            parsedLabels.value.map((item, i)=>vue.createElementVNode("text", {
                                    "x": item.x,
                                    "y": parseInt(props.height, 10) - 4 + (parseInt(props.labelSize, 10) || 5.25),
                                    "font-size": Number(props.labelSize) || 7
                                }, [
                                    slots.label?.({
                                        index: i,
                                        value: item.value
                                    }) ?? item.value
                                ]))
                        ]),
                        vue.createElementVNode("path", {
                            "key": "fill",
                            "ref": props.fill ? fillPath : strokePath,
                            "d": genPath(extendedPoints.value, props.fill),
                            "fill": props.fill ? `url(#${id.value})` : 'none',
                            "stroke": props.fill ? 'none' : `url(#${id.value})`
                        }, null),
                        props.fill && vue.createElementVNode("path", {
                            "key": "trendline",
                            "ref": strokePath,
                            "d": genPath(extendedPoints.value, false),
                            "fill": "none",
                            "stroke": "currentColor"
                        }, null),
                        props.showMarkers && vue.createElementVNode("g", {
                            "key": "markers"
                        }, [
                            points.value.map((point, i)=>vue.createElementVNode("circle", {
                                    "key": i,
                                    "cx": point.x,
                                    "cy": point.y,
                                    "r": markerRadius,
                                    "fill": "currentColor",
                                    "stroke": props.markerStroke,
                                    "stroke-width": 2,
                                    "pointer-events": "none"
                                }, null))
                        ]),
                        props.interactive && currentPoint.value && vue.createElementVNode("g", {
                            "key": "hover",
                            "pointer-events": "none"
                        }, [
                            tooltipConfig.value.showCrosshair && vue.createElementVNode("line", {
                                "key": "crosshair-line",
                                "x1": markerPoint.value.x,
                                "y1": props.inset ? 0 : boundary.value.minY,
                                "x2": markerPoint.value.x,
                                "y2": props.inset ? parseInt(props.height, 10) : boundary.value.maxY,
                                "stroke": "currentColor",
                                "stroke-width": 1,
                                "stroke-dasharray": "4 2",
                                "opacity": 0.5
                            }, null),
                            vue.createElementVNode("circle", {
                                "key": "marker",
                                "cx": markerPoint.value.x,
                                "cy": markerPoint.value.y,
                                "r": markerRadius,
                                "fill": "currentColor",
                                "stroke": props.markerStroke,
                                "stroke-width": 2
                            }, null)
                        ])
                    ]),
                    !!props.tooltip && vue.createVNode(VSparklineTooltip, {
                        "key": "tooltip",
                        "modelValue": tooltipVisible.value,
                        "target": tooltipTarget.value,
                        "index": currentIndex.value,
                        "value": currentIndex.value !== null ? points.value[currentIndex.value].value : 0,
                        "offset": tooltipConfig.value.offset,
                        "contentClass": tooltipConfig.value.class,
                        "titleFormat": tooltipConfig.value.titleFormat,
                        "onAfterLeave": onTooltipAfterLeave
                    }, {
                        default: slots.tooltip
                    })
                ]);
            });
        }
    });
    // Types
    const makeVSparklineProps = propsFactory({
        type: {
            type: String,
            default: 'trend'
        },
        ...makeVBarlineProps(),
        ...makeVTrendlineProps()
    }, 'VSparkline');
    const VSparkline = genericComponent()({
        name: 'VSparkline',
        props: makeVSparklineProps(),
        emits: {
            'update:currentIndex': (_index)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            const hasLabels = vue.computed(()=>{
                return Boolean(props.showLabels || props.labels.length > 0 || !!slots?.label);
            });
            const totalHeight = vue.computed(()=>{
                let height = parseInt(props.height, 10);
                if (hasLabels.value) height += parseInt(props.labelSize, 10) * 1.5;
                return height;
            });
            useRender(()=>{
                const Tag = props.type === 'trend' ? VTrendline : VBarline;
                const lineProps = props.type === 'trend' ? VTrendline.filterProps(props) : VBarline.filterProps(props);
                return vue.createVNode(Tag, vue.mergeProps({
                    "key": props.type,
                    "class": textColorClasses.value,
                    "style": textColorStyles.value,
                    "viewBox": `0 0 ${props.width} ${totalHeight.value}`
                }, lineProps, {
                    "onUpdate:currentIndex": (v)=>emit('update:currentIndex', v)
                }), slots);
            });
        }
    });
    // Types
    const makeVSpeedDialProps = propsFactory({
        ...makeComponentProps(),
        ...makeVMenuProps({
            offset: 8,
            minWidth: 0,
            openDelay: 0,
            closeDelay: 100,
            location: 'top center',
            transition: 'scale-transition'
        })
    }, 'VSpeedDial');
    const VSpeedDial = genericComponent()({
        name: 'VSpeedDial',
        props: makeVSpeedDialProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const menuRef = vue.ref();
            const location = vue.computed(()=>{
                const [y, x = 'center'] = props.location?.split(' ') ?? [];
                return `${y} ${x}`;
            });
            const locationClasses = vue.computed(()=>({
                    [`v-speed-dial__content--${location.value.replace(' ', '-')}`]: true
                }));
            useRender(()=>{
                const menuProps = VMenu.filterProps(props);
                return vue.createVNode(VMenu, vue.mergeProps(menuProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": props.class,
                    "style": props.style,
                    "contentClass": [
                        'v-speed-dial__content',
                        locationClasses.value,
                        props.contentClass
                    ],
                    "location": location.value,
                    "ref": menuRef,
                    "transition": "fade-transition"
                }), {
                    ...slots,
                    default: (slotProps)=>vue.createVNode(VDefaultsProvider, {
                            "defaults": {
                                VBtn: {
                                    size: 'small'
                                }
                            }
                        }, {
                            default: ()=>[
                                    vue.createVNode(MaybeTransition, {
                                        "appear": true,
                                        "group": true,
                                        "transition": props.transition
                                    }, {
                                        default: ()=>[
                                                slots.default?.(slotProps)
                                            ]
                                    })
                                ]
                        })
                });
            });
            return {};
        }
    });
    // Types
    const VStepperSymbol = Symbol.for('vuetify:v-stepper');
    // Types
    const makeVStepperActionsProps = propsFactory({
        color: String,
        disabled: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        prevText: {
            type: String,
            default: '$vuetify.stepper.prev'
        },
        nextText: {
            type: String,
            default: '$vuetify.stepper.next'
        }
    }, 'VStepperActions');
    const VStepperActions = genericComponent()({
        name: 'VStepperActions',
        props: makeVStepperActionsProps(),
        emits: {
            'click:prev': ()=>true,
            'click:next': ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            function onClickPrev() {
                emit('click:prev');
            }
            function onClickNext() {
                emit('click:next');
            }
            useRender(()=>{
                const prevSlotProps = {
                    onClick: onClickPrev
                };
                const nextSlotProps = {
                    onClick: onClickNext
                };
                return vue.createElementVNode("div", {
                    "class": "v-stepper-actions"
                }, [
                    vue.createVNode(VDefaultsProvider, {
                        "defaults": {
                            VBtn: {
                                disabled: [
                                    'prev',
                                    true
                                ].includes(props.disabled),
                                text: t(props.prevText),
                                variant: 'text'
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.prev?.({
                                    props: prevSlotProps
                                }) ?? vue.createVNode(VBtn, prevSlotProps, null)
                            ]
                    }),
                    vue.createVNode(VDefaultsProvider, {
                        "defaults": {
                            VBtn: {
                                color: props.color,
                                disabled: [
                                    'next',
                                    true
                                ].includes(props.disabled),
                                text: t(props.nextText),
                                variant: 'tonal'
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.next?.({
                                    props: nextSlotProps
                                }) ?? vue.createVNode(VBtn, nextSlotProps, null)
                            ]
                    })
                ]);
            });
            return {};
        }
    });
    // Utilities
    const VStepperHeader = createSimpleFunctional('v-stepper-header');
    // Types
    const makeStepperItemProps = propsFactory({
        color: String,
        title: String,
        subtitle: String,
        complete: Boolean,
        completeIcon: {
            type: IconValue,
            default: '$complete'
        },
        editable: Boolean,
        editIcon: {
            type: IconValue,
            default: '$edit'
        },
        error: Boolean,
        errorIcon: {
            type: IconValue,
            default: '$error'
        },
        icon: IconValue,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        },
        rules: {
            type: Array,
            default: ()=>[]
        }
    }, 'StepperItem');
    const makeVStepperItemProps = propsFactory({
        ...makeStepperItemProps(),
        ...makeGroupItemProps()
    }, 'VStepperItem');
    const VStepperItem = genericComponent()({
        name: 'VStepperItem',
        directives: {
            vRipple: Ripple
        },
        props: makeVStepperItemProps(),
        emits: {
            'group:selected': (val)=>true
        },
        setup (props, { slots: slots }) {
            const group = useGroupItem(props, VStepperSymbol, true);
            const step = vue.computed(()=>group?.value.value ?? props.value);
            const isValid = vue.computed(()=>props.rules.every((handler)=>handler() === true));
            const isClickable = vue.computed(()=>!props.disabled && props.editable);
            const canEdit = vue.computed(()=>!props.disabled && props.editable);
            const hasError = vue.computed(()=>props.error || !isValid.value);
            const hasCompleted = vue.computed(()=>props.complete || props.rules.length > 0 && isValid.value);
            const icon = vue.computed(()=>{
                if (hasError.value) return props.errorIcon;
                if (hasCompleted.value) return props.completeIcon;
                if (group.isSelected.value && props.editable) return props.editIcon;
                return props.icon;
            });
            const slotProps = vue.computed(()=>({
                    canEdit: canEdit.value,
                    hasError: hasError.value,
                    hasCompleted: hasCompleted.value,
                    title: props.title,
                    subtitle: props.subtitle,
                    step: step.value,
                    value: props.value
                }));
            useRender(()=>{
                const hasColor = (!group || group.isSelected.value || hasCompleted.value || canEdit.value) && !hasError.value && !props.disabled;
                const hasTitle = !!(props.title != null || slots.title);
                const hasSubtitle = !!(props.subtitle != null || slots.subtitle);
                function onClick() {
                    group?.toggle();
                }
                return vue.withDirectives(vue.createElementVNode("button", {
                    "class": vue.normalizeClass([
                        'v-stepper-item',
                        {
                            'v-stepper-item--complete': hasCompleted.value,
                            'v-stepper-item--disabled': props.disabled,
                            'v-stepper-item--error': hasError.value
                        },
                        group?.selectedClass.value
                    ]),
                    "disabled": !props.editable,
                    "type": "button",
                    "onClick": onClick
                }, [
                    isClickable.value && genOverlays(true, 'v-stepper-item'),
                    vue.createVNode(VAvatar, {
                        "key": "stepper-avatar",
                        "class": "v-stepper-item__avatar",
                        "color": hasColor ? props.color : undefined,
                        "size": 24
                    }, {
                        default: ()=>[
                                slots.icon?.(slotProps.value) ?? (icon.value ? vue.createVNode(VIcon, {
                                    "icon": icon.value
                                }, null) : step.value)
                            ]
                    }),
                    vue.createElementVNode("div", {
                        "class": "v-stepper-item__content"
                    }, [
                        hasTitle && vue.createElementVNode("div", {
                            "key": "title",
                            "class": "v-stepper-item__title"
                        }, [
                            slots.title?.(slotProps.value) ?? props.title
                        ]),
                        hasSubtitle && vue.createElementVNode("div", {
                            "key": "subtitle",
                            "class": "v-stepper-item__subtitle"
                        }, [
                            slots.subtitle?.(slotProps.value) ?? props.subtitle
                        ]),
                        slots.default?.(slotProps.value)
                    ])
                ]), [
                    [
                        Ripple,
                        props.editable && props.ripple,
                        null
                    ]
                ]);
            });
            return {};
        }
    });
    // Types
    const makeVStepperWindowProps = propsFactory({
        ...omit(makeVWindowProps(), [
            'continuous',
            'nextIcon',
            'prevIcon',
            'showArrows',
            'touch',
            'mandatory'
        ])
    }, 'VStepperWindow');
    const VStepperWindow = genericComponent()({
        name: 'VStepperWindow',
        props: makeVStepperWindowProps(),
        emits: {
            'update:modelValue': (v)=>true
        },
        setup (props, { slots: slots }) {
            const group = vue.inject(VStepperSymbol, null);
            const _model = useProxiedModel(props, 'modelValue');
            const model = vue.computed({
                get () {
                    // Always return modelValue if defined
                    // or if not within a VStepper group
                    if (_model.value != null || !group) return _model.value;
                    // If inside of a VStepper, find the currently selected
                    // item by id. Item value may be assigned by its index
                    return group.items.value.find((item)=>group.selected.value.includes(item.id))?.value;
                },
                set (val) {
                    _model.value = val;
                }
            });
            useRender(()=>{
                const windowProps = VWindow.filterProps(props);
                return vue.createVNode(VWindow, vue.mergeProps({
                    "_as": "VStepperWindow"
                }, windowProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": [
                        'v-stepper-window',
                        props.class
                    ],
                    "style": props.style,
                    "mandatory": false,
                    "touch": false
                }), slots);
            });
            return {};
        }
    });
    const makeVStepperWindowItemProps = propsFactory({
        ...makeVWindowItemProps()
    }, 'VStepperWindowItem');
    const VStepperWindowItem = genericComponent()({
        name: 'VStepperWindowItem',
        props: makeVStepperWindowItemProps(),
        setup (props, { slots: slots }) {
            useRender(()=>{
                const windowItemProps = VWindowItem.filterProps(props);
                return vue.createVNode(VWindowItem, vue.mergeProps({
                    "_as": "VStepperWindowItem"
                }, windowItemProps, {
                    "class": [
                        'v-stepper-window-item',
                        props.class
                    ],
                    "style": props.style
                }), slots);
            });
            return {};
        }
    });
    // Types
    const makeStepperProps = propsFactory({
        altLabels: Boolean,
        bgColor: String,
        completeIcon: IconValue,
        editIcon: IconValue,
        editable: Boolean,
        errorIcon: IconValue,
        hideActions: Boolean,
        items: {
            type: Array,
            default: ()=>[]
        },
        itemTitle: {
            type: [
                String,
                Array,
                Function
            ],
            default: 'title'
        },
        itemValue: {
            type: [
                String,
                Array,
                Function
            ],
            default: 'value'
        },
        itemProps: {
            type: [
                Boolean,
                String,
                Array,
                Function
            ],
            default: 'props'
        },
        nonLinear: Boolean,
        flat: Boolean,
        ...makeDisplayProps()
    }, 'Stepper');
    const makeVStepperProps = propsFactory({
        ...makeStepperProps(),
        ...makeGroupProps({
            mandatory: 'force',
            selectedClass: 'v-stepper-item--selected'
        }),
        ...makeVSheetProps(),
        ...pick(makeVStepperActionsProps(), [
            'prevText',
            'nextText'
        ])
    }, 'VStepper');
    const VStepper = genericComponent()({
        name: 'VStepper',
        props: makeVStepperProps(),
        emits: {
            'update:modelValue': (v)=>true
        },
        setup (props, { slots: slots }) {
            const { items: _items, next: next, prev: prev, selected: selected } = useGroup(props, VStepperSymbol);
            const { displayClasses: displayClasses, mobile: mobile } = useDisplay(props);
            const { completeIcon: completeIcon, editIcon: editIcon, errorIcon: errorIcon, color: color, editable: editable, prevText: prevText, nextText: nextText } = vue.toRefs(props);
            const items = vue.computed(()=>props.items.map((item, index)=>{
                    const title = getPropertyFromItem(item, props.itemTitle, item);
                    const value = getPropertyFromItem(item, props.itemValue, index + 1);
                    const itemProps = props.itemProps === true ? item : getPropertyFromItem(item, props.itemProps);
                    const _props = {
                        title: title,
                        value: value,
                        ...itemProps
                    };
                    return {
                        title: _props.title,
                        value: _props.value,
                        props: _props,
                        raw: item
                    };
                }));
            const activeIndex = vue.computed(()=>{
                return _items.value.findIndex((item)=>selected.value.includes(item.id));
            });
            const disabled = vue.computed(()=>{
                if (props.disabled) return props.disabled;
                if (activeIndex.value === 0) return 'prev';
                if (activeIndex.value === _items.value.length - 1) return 'next';
                return false;
            });
            provideDefaults({
                VStepperItem: {
                    editable: editable,
                    errorIcon: errorIcon,
                    completeIcon: completeIcon,
                    editIcon: editIcon,
                    prevText: prevText,
                    nextText: nextText
                },
                VStepperActions: {
                    color: color,
                    disabled: disabled,
                    prevText: prevText,
                    nextText: nextText
                }
            });
            useRender(()=>{
                const sheetProps = VSheet.filterProps(props);
                const hasHeader = !!(slots.header || props.items.length);
                const hasWindow = props.items.length > 0;
                const hasActions = !props.hideActions && !!(hasWindow || slots.actions);
                return vue.createVNode(VSheet, vue.mergeProps(sheetProps, {
                    "color": props.bgColor,
                    "class": [
                        'v-stepper',
                        {
                            'v-stepper--alt-labels': props.altLabels,
                            'v-stepper--flat': props.flat,
                            'v-stepper--non-linear': props.nonLinear,
                            'v-stepper--mobile': mobile.value
                        },
                        displayClasses.value,
                        props.class
                    ],
                    "style": props.style
                }), {
                    default: ()=>[
                            hasHeader && vue.createVNode(VStepperHeader, {
                                "key": "stepper-header"
                            }, {
                                default: ()=>[
                                        items.value.map(({ raw: raw, ...item }, index)=>vue.createElementVNode(vue.Fragment, null, [
                                                !!index && vue.createVNode(VDivider, null, null),
                                                vue.createVNode(VStepperItem, item.props, {
                                                    default: slots[`header-item.${item.value}`] ?? slots.header,
                                                    icon: slots.icon,
                                                    title: slots.title,
                                                    subtitle: slots.subtitle
                                                })
                                            ]))
                                    ]
                            }),
                            hasWindow && vue.createVNode(VStepperWindow, {
                                "key": "stepper-window"
                            }, {
                                default: ()=>[
                                        items.value.map((item)=>vue.createVNode(VStepperWindowItem, {
                                                "value": item.value
                                            }, {
                                                default: ()=>slots[`item.${item.value}`]?.(item) ?? slots.item?.(item)
                                            }))
                                    ]
                            }),
                            slots.default?.({
                                prev: prev,
                                next: next
                            }),
                            hasActions && (slots.actions?.({
                                next: next,
                                prev: prev
                            }) ?? vue.createVNode(VStepperActions, {
                                "key": "stepper-actions",
                                "onClick:prev": prev,
                                "onClick:next": next
                            }, slots))
                        ]
                });
            });
            return {
                prev: prev,
                next: next
            };
        }
    });
    // Types
    const makeVStepperVerticalActionsProps = propsFactory({
        ...makeVStepperActionsProps()
    }, 'VStepperActions');
    const VStepperVerticalActions = genericComponent()({
        name: 'VStepperVerticalActions',
        props: makeVStepperVerticalActionsProps(),
        emits: {
            'click:prev': ()=>true,
            'click:next': ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            function onClickPrev() {
                emit('click:prev');
            }
            function onClickNext() {
                emit('click:next');
            }
            useRender(()=>{
                const stepperActionsProps = VStepperActions.filterProps(props);
                return vue.createVNode(VStepperActions, vue.mergeProps({
                    "class": "v-stepper-vertical-actions"
                }, stepperActionsProps, {
                    "onClick:prev": onClickPrev,
                    "onClick:next": onClickNext
                }), slots);
            });
            return {};
        }
    });
    // Types
    const makeVStepperVerticalItemProps = propsFactory({
        hideActions: Boolean,
        ...makeStepperItemProps(),
        ...omit(makeVExpansionPanelProps({
            expandIcon: '',
            collapseIcon: ''
        }), [
            'hideActions'
        ])
    }, 'VStepperVerticalItem');
    const VStepperVerticalItem = genericComponent()({
        name: 'VStepperVerticalItem',
        props: makeVStepperVerticalItemProps(),
        emits: {
            'click:next': ()=>true,
            'click:prev': ()=>true,
            'click:finish': ()=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const vExpansionPanelRef = vue.ref();
            const step = vue.computed(()=>!isNaN(parseInt(props.value)) ? Number(props.value) : props.value);
            const groupItem = vue.computed(()=>vExpansionPanelRef.value?.groupItem);
            const isValid = vue.computed(()=>props.rules.every((handler)=>handler() === true));
            const canEdit = vue.computed(()=>!props.disabled && props.editable);
            const hasError = vue.computed(()=>props.error || !isValid.value);
            const hasCompleted = vue.computed(()=>props.complete || props.rules.length > 0 && isValid.value);
            const disabled = vue.computed(()=>{
                if (props.disabled) return props.disabled;
                if (groupItem.value?.isFirst.value) return 'prev';
                return false;
            });
            const icon = vue.computed(()=>{
                if (hasError.value) return props.errorIcon;
                if (hasCompleted.value) return props.completeIcon;
                if (groupItem.value?.isSelected.value && props.editable) return props.editIcon;
                return props.icon;
            });
            const slotProps = vue.computed(()=>({
                    canEdit: canEdit.value,
                    hasError: hasError.value,
                    hasCompleted: hasCompleted.value,
                    title: props.title,
                    subtitle: props.subtitle,
                    step: step.value
                }));
            const actionProps = vue.computed(()=>({
                    ...slotProps.value,
                    prev: onClickPrev,
                    next: onClickNext
                }));
            function onClickNext() {
                emit('click:next');
                if (groupItem.value?.isLast.value) return;
                groupItem.value.group.next();
            }
            function onClickPrev() {
                emit('click:prev');
                groupItem.value.group.prev();
            }
            useRender(()=>{
                const hasColor = (!groupItem.value || groupItem.value?.isSelected.value || hasCompleted.value || canEdit.value) && !hasError.value && !props.disabled;
                const hasActions = !props.hideActions || !!slots.actions;
                const expansionPanelProps = VExpansionPanel.filterProps(props);
                return vue.createVNode(VExpansionPanel, vue.mergeProps({
                    "_as": "VStepperVerticalItem",
                    "ref": vExpansionPanelRef
                }, expansionPanelProps, {
                    "class": [
                        'v-stepper-vertical-item',
                        {
                            'v-stepper-vertical-item--complete': hasCompleted.value,
                            'v-stepper-vertical-item--disabled': props.disabled,
                            'v-stepper-vertical-item--editable': canEdit.value,
                            'v-stepper-vertical-item--error': hasError.value
                        },
                        props.class
                    ],
                    "readonly": !props.editable,
                    "style": props.style,
                    "color": "",
                    "hideActions": false,
                    "value": step.value
                }), {
                    title: ()=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VAvatar, {
                                "key": "stepper-avatar",
                                "class": "v-stepper-vertical-item__avatar",
                                "color": hasColor ? props.color : undefined,
                                "size": 24,
                                "start": true
                            }, {
                                default: ()=>[
                                        slots.icon?.(slotProps.value) ?? (icon.value ? vue.createVNode(VIcon, {
                                            "icon": icon.value
                                        }, null) : step.value)
                                    ]
                            }),
                            vue.createElementVNode("div", null, [
                                vue.createElementVNode("div", {
                                    "class": "v-stepper-vertical-item__title"
                                }, [
                                    slots.title?.(slotProps.value) ?? props.title
                                ]),
                                vue.createElementVNode("div", {
                                    "class": "v-stepper-vertical-item__subtitle"
                                }, [
                                    slots.subtitle?.(slotProps.value) ?? props.subtitle
                                ])
                            ])
                        ]),
                    text: ()=>vue.createElementVNode(vue.Fragment, null, [
                            slots.default?.(slotProps.value) ?? props.text,
                            hasActions && vue.createVNode(VDefaultsProvider, {
                                "defaults": {
                                    VStepperVerticalActions: {
                                        disabled: disabled.value,
                                        finish: groupItem.value?.isLast.value
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.actions?.(actionProps.value) ?? vue.createVNode(VStepperVerticalActions, {
                                            "onClick:next": onClickNext,
                                            "onClick:prev": onClickPrev
                                        }, {
                                            prev: slots.prev ? ()=>slots.prev?.(actionProps.value) : undefined,
                                            next: slots.next ? ()=>slots.next?.(actionProps.value) : undefined
                                        })
                                    ]
                            })
                        ])
                });
            });
            return {};
        }
    });
    // Types
    const makeVStepperVerticalProps = propsFactory({
        prevText: {
            type: String,
            default: '$vuetify.stepper.prev'
        },
        nextText: {
            type: String,
            default: '$vuetify.stepper.next'
        },
        ...makeStepperProps(),
        ...omit(makeVExpansionPanelsProps({
            mandatory: 'force',
            variant: 'accordion'
        }), [
            'static'
        ])
    }, 'VStepperVertical');
    const VStepperVertical = genericComponent()({
        name: 'VStepperVertical',
        props: makeVStepperVerticalProps(),
        emits: {
            'update:modelValue': (val)=>true
        },
        setup (props, { slots: slots }) {
            const vExpansionPanelsRef = vue.ref();
            const { color: color, eager: eager, editable: editable, prevText: prevText, nextText: nextText, hideActions: hideActions } = vue.toRefs(props);
            const model = useProxiedModel(props, 'modelValue');
            const items = vue.computed(()=>props.items.map((item, index)=>{
                    const title = getPropertyFromItem(item, props.itemTitle, item);
                    const value = getPropertyFromItem(item, props.itemValue, index + 1);
                    const itemProps = props.itemProps === true ? item : getPropertyFromItem(item, props.itemProps);
                    const _props = {
                        title: title,
                        value: value,
                        ...itemProps
                    };
                    return {
                        title: _props.title,
                        value: _props.value,
                        props: _props,
                        raw: item
                    };
                }));
            provideDefaults({
                VStepperVerticalItem: {
                    color: color,
                    eager: eager,
                    editable: editable,
                    hideActions: hideActions,
                    static: true
                },
                VStepperVerticalActions: {
                    color: color,
                    nextText: nextText,
                    prevText: prevText
                }
            });
            useRender(()=>{
                const expansionPanelProps = VExpansionPanels.filterProps(props);
                return vue.createVNode(VExpansionPanels, vue.mergeProps(expansionPanelProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "ref": vExpansionPanelsRef,
                    "class": [
                        'v-stepper',
                        {
                            'v-stepper--alt-labels': props.altLabels,
                            'v-stepper--flat': props.flat,
                            'v-stepper--non-linear': props.nonLinear,
                            'v-stepper--mobile': props.mobile
                        },
                        props.class
                    ],
                    "style": props.style
                }), {
                    ...slots,
                    default: ({ prev: prev, next: next })=>{
                        return vue.createElementVNode(vue.Fragment, null, [
                            items.value.map(({ raw: raw, ...item })=>vue.createVNode(VStepperVerticalItem, item.props, {
                                    ...slots,
                                    default: slots[`item.${item.value}`]
                                })),
                            slots.default?.({
                                prev: prev,
                                next: next,
                                step: model.value
                            })
                        ]);
                    }
                });
            });
            return {};
        }
    });
    // Types
    const makeVSwitchProps = propsFactory({
        inset: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        flat: Boolean,
        thumbColor: String,
        loading: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        ...omit(makeVInputProps(), [
            'glow'
        ]),
        ...makeVSelectionControlProps(),
        ...makeSizeProps()
    }, 'VSwitch');
    const predefinedSizes = [
        'x-small',
        'small',
        'default',
        'large',
        'x-large'
    ];
    const iconSizes = {
        'x-small': 11,
        small: 14,
        default: 16,
        large: 18,
        'x-large': 22
    };
    const VSwitch = genericComponent()({
        name: 'VSwitch',
        inheritAttrs: false,
        props: makeVSwitchProps(),
        emits: {
            'update:focused': (focused)=>true,
            'update:modelValue': (value)=>true,
            'update:indeterminate': (value)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const indeterminate = useProxiedModel(props, 'indeterminate');
            const model = useProxiedModel(props, 'modelValue');
            const { loaderClasses: loaderClasses } = useLoader(props);
            const { isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const { backgroundColorClasses: thumbColorClasses, backgroundColorStyles: thumbColorStyles } = useBackgroundColor(()=>props.thumbColor);
            const control = vue.ref();
            const inputRef = vue.ref();
            const isForcedColorsModeActive = SUPPORTS_MATCH_MEDIA && window.matchMedia('(forced-colors: active)').matches;
            const loaderColor = vue.toRef(()=>{
                return typeof props.loading === 'string' && props.loading !== '' ? props.loading : props.color;
            });
            const uid = vue.useId();
            const id = vue.toRef(()=>props.id || `switch-${uid}`);
            const isPredefinedSize = vue.toRef(()=>predefinedSizes.includes(props.size));
            const iconSize = vue.toRef(()=>{
                return isPredefinedSize.value ? iconSizes[props.size] : Math.round(16 * Number(props.size) / 32);
            });
            function onChange() {
                if (indeterminate.value) indeterminate.value = false;
            }
            function onTrackClick(e) {
                e.stopPropagation();
                e.preventDefault();
                control.value?.input?.click();
            }
            useRender(()=>{
                const [rootAttrs, controlAttrs] = filterInputAttrs(attrs);
                const inputProps = VInput.filterProps(props);
                const controlProps = VSelectionControl.filterProps(props);
                const isMaterial = [
                    'material',
                    'square'
                ].includes(String(props.inset));
                const hasThumbColor = !isForcedColorsModeActive && !!props.thumbColor;
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": inputRef,
                    "class": [
                        'v-switch',
                        {
                            'v-switch--flat': props.flat
                        },
                        {
                            'v-switch--inset': !!props.inset
                        },
                        {
                            'v-switch--inset-material': isMaterial
                        },
                        {
                            'v-switch--inset-square': props.inset === 'square'
                        },
                        {
                            'v-switch--indeterminate': indeterminate.value
                        },
                        isPredefinedSize.value ? `v-switch--size-${props.size}` : undefined,
                        loaderClasses.value,
                        props.class
                    ]
                }, rootAttrs, inputProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "id": id.value,
                    "focused": isFocused.value,
                    "style": [
                        {
                            '--v-switch-scale': isPredefinedSize.value ? undefined : Number(props.size) / 32
                        },
                        props.style
                    ]
                }), {
                    ...slots,
                    default: ({ id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly, isValid: isValid })=>{
                        const slotProps = {
                            model: model,
                            isValid: isValid
                        };
                        return vue.createVNode(VSelectionControl, vue.mergeProps({
                            "ref": control
                        }, controlProps, {
                            "modelValue": model.value,
                            "onUpdate:modelValue": [
                                ($event)=>model.value = $event,
                                onChange
                            ],
                            "id": id.value,
                            "aria-describedby": messagesId.value,
                            "type": "checkbox",
                            "aria-checked": indeterminate.value ? 'mixed' : undefined,
                            "disabled": isDisabled.value,
                            "readonly": isReadonly.value,
                            "onFocus": focus,
                            "onBlur": blur
                        }, controlAttrs), {
                            ...slots,
                            default: ({ backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles })=>vue.createElementVNode("div", {
                                    "class": vue.normalizeClass([
                                        'v-switch__track',
                                        !isForcedColorsModeActive ? backgroundColorClasses.value : undefined
                                    ]),
                                    "style": vue.normalizeStyle(backgroundColorStyles.value),
                                    "onClick": onTrackClick
                                }, [
                                    slots['track-true'] && vue.createElementVNode("div", {
                                        "key": "prepend",
                                        "class": "v-switch__track-true"
                                    }, [
                                        slots['track-true'](slotProps)
                                    ]),
                                    slots['track-false'] && vue.createElementVNode("div", {
                                        "key": "append",
                                        "class": "v-switch__track-false"
                                    }, [
                                        slots['track-false'](slotProps)
                                    ])
                                ]),
                            input: ({ inputNode: inputNode, icon: icon, model: isSelected, backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles, textColorClasses: textColorClasses, textColorStyles: textColorStyles })=>vue.createElementVNode(vue.Fragment, null, [
                                    inputNode,
                                    vue.createElementVNode("div", {
                                        "class": vue.normalizeClass([
                                            'v-switch__thumb',
                                            {
                                                'v-switch__thumb--filled': icon || props.loading
                                            },
                                            isForcedColorsModeActive ? undefined : hasThumbColor && isSelected.value ? thumbColorClasses.value : isMaterial ? backgroundColorClasses.value : props.inset ? undefined : backgroundColorClasses.value
                                        ]),
                                        "style": vue.normalizeStyle([
                                            hasThumbColor && isSelected.value ? thumbColorStyles.value : isMaterial ? backgroundColorClasses.value.length || backgroundColorStyles.value.backgroundColor ? {
                                                backgroundColor: 'currentColor'
                                            } : undefined : props.inset ? undefined : backgroundColorStyles.value
                                        ])
                                    }, [
                                        slots.thumb ? vue.createVNode(VDefaultsProvider, {
                                            "defaults": {
                                                VIcon: {
                                                    icon: icon,
                                                    size: isMaterial ? iconSize.value : 'x-small'
                                                }
                                            }
                                        }, {
                                            default: ()=>[
                                                    slots.thumb({
                                                        ...slotProps,
                                                        icon: icon
                                                    })
                                                ]
                                        }) : vue.createVNode(VScaleTransition, null, {
                                            default: ()=>[
                                                    !props.loading ? icon && vue.createVNode(VIcon, {
                                                        "key": String(icon),
                                                        "class": vue.normalizeClass(isMaterial ? textColorClasses.value : undefined),
                                                        "style": vue.normalizeStyle(isMaterial ? textColorStyles.value : undefined),
                                                        "icon": icon,
                                                        "size": isMaterial ? iconSize.value : 'x-small'
                                                    }, null) : vue.createVNode(LoaderSlot, {
                                                        "name": "v-switch",
                                                        "active": true,
                                                        "color": isValid.value === false ? undefined : loaderColor.value
                                                    }, {
                                                        default: (slotProps)=>slots.loader ? slots.loader(slotProps) : vue.createVNode(VProgressCircular, {
                                                                "active": slotProps.isActive,
                                                                "color": slotProps.color,
                                                                "indeterminate": true,
                                                                "size": iconSize.value,
                                                                "width": "2"
                                                            }, null)
                                                    })
                                                ]
                                        })
                                    ])
                                ])
                        });
                    }
                });
            });
            return forwardRefs({}, inputRef);
        }
    });
    const makeVSystemBarProps = propsFactory({
        color: String,
        height: [
            Number,
            String
        ],
        window: Boolean,
        ...makeComponentProps(),
        ...makeElevationProps(),
        ...makeLayoutItemProps(),
        ...makeRoundedProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VSystemBar');
    const VSystemBar = genericComponent()({
        name: 'VSystemBar',
        props: makeVSystemBarProps(),
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props);
            const { ssrBootStyles: ssrBootStyles } = useSsrBoot();
            const height = vue.computed(()=>props.height ?? (props.window ? 32 : 24));
            const { layoutItemStyles: layoutItemStyles } = useLayoutItem({
                id: props.name,
                order: vue.computed(()=>parseInt(props.order, 10)),
                position: vue.shallowRef('top'),
                layoutSize: height,
                elementSize: height,
                active: vue.computed(()=>true),
                absolute: vue.toRef(()=>props.absolute)
            });
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-system-bar',
                        {
                            'v-system-bar--window': props.window
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        backgroundColorStyles.value,
                        layoutItemStyles.value,
                        ssrBootStyles.value,
                        roundedStyles.value,
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Types
    const VTabsSymbol = Symbol.for('vuetify:v-tabs');
    // Types
    const makeVTabProps = propsFactory({
        fixed: Boolean,
        sliderColor: String,
        sliderTransition: String,
        sliderTransitionDuration: [
            String,
            Number
        ],
        hideSlider: Boolean,
        inset: Boolean,
        direction: {
            type: String,
            default: 'horizontal'
        },
        ...omit(makeVBtnProps({
            selectedClass: 'v-tab--selected',
            variant: 'text'
        }), [
            'active',
            'block',
            'flat',
            'location',
            'position',
            'symbol'
        ])
    }, 'VTab');
    const VTab = genericComponent()({
        name: 'VTab',
        props: makeVTabProps(),
        setup (props, { slots: slots, attrs: attrs }) {
            const { textColorClasses: sliderColorClasses, textColorStyles: sliderColorStyles } = useTextColor(()=>props.sliderColor);
            const { backgroundColorClasses: insetColorClasses, backgroundColorStyles: insetColorStyles } = useBackgroundColor(()=>props.sliderColor);
            const rootEl = vue.ref();
            const sliderEl = vue.ref();
            const isHorizontal = vue.computed(()=>props.direction === 'horizontal');
            const isSelected = vue.computed(()=>rootEl.value?.group?.isSelected.value ?? false);
            function fade(nextEl, prevEl) {
                return {
                    opacity: [
                        0,
                        1
                    ]
                };
            }
            function grow(nextEl, prevEl) {
                return props.direction === 'vertical' ? {
                    transform: [
                        'scaleY(0)',
                        'scaleY(1)'
                    ]
                } : {
                    transform: [
                        'scaleX(0)',
                        'scaleX(1)'
                    ]
                };
            }
            function shift(nextEl, prevEl) {
                const prevBox = prevEl.getBoundingClientRect();
                const nextBox = nextEl.getBoundingClientRect();
                const xy = isHorizontal.value ? 'x' : 'y';
                const XY = isHorizontal.value ? 'X' : 'Y';
                const rightBottom = isHorizontal.value ? 'right' : 'bottom';
                const widthHeight = isHorizontal.value ? 'width' : 'height';
                const prevPos = prevBox[xy];
                const nextPos = nextBox[xy];
                const delta = prevPos > nextPos ? prevBox[rightBottom] - nextBox[rightBottom] : prevBox[xy] - nextBox[xy];
                const origin = Math.sign(delta) > 0 ? isHorizontal.value ? 'right' : 'bottom' : Math.sign(delta) < 0 ? isHorizontal.value ? 'left' : 'top' : 'center';
                const size = Math.abs(delta) + (Math.sign(delta) < 0 ? prevBox[widthHeight] : nextBox[widthHeight]);
                const scale = size / Math.max(prevBox[widthHeight], nextBox[widthHeight]) || 0;
                const initialScale = prevBox[widthHeight] / nextBox[widthHeight] || 0;
                const sigma = 1.5;
                return {
                    transform: [
                        `translate${XY}(${delta}px) scale${XY}(${initialScale})`,
                        `translate${XY}(${delta / sigma}px) scale${XY}(${(scale - 1) / sigma + 1})`,
                        'none'
                    ],
                    transformOrigin: Array(3).fill(origin)
                };
            }
            function updateSlider({ value: value }) {
                if (value) {
                    const prevEl = rootEl.value?.$el.parentElement?.querySelector('.v-tab--selected .v-tab__slider');
                    const nextEl = sliderEl.value;
                    if (!prevEl || !nextEl) return;
                    const color = getComputedStyle(prevEl).backgroundColor;
                    const keyframes = {
                        fade: fade,
                        grow: grow,
                        shift: shift
                    }[props.sliderTransition ?? 'shift'] ?? shift;
                    const duration = Number(props.sliderTransitionDuration) || (({
                        fade: 400,
                        grow: 350,
                        shift: 225
                    })[props.sliderTransition ?? 'shift'] ?? 225);
                    animate(nextEl, {
                        backgroundColor: [
                            color,
                            color
                        ],
                        ...keyframes(nextEl, prevEl)
                    }, {
                        duration: duration,
                        easing: standardEasing
                    });
                }
            }
            useRender(()=>{
                const btnProps = VBtn.filterProps(props);
                return vue.createVNode(VBtn, vue.mergeProps({
                    "symbol": VTabsSymbol,
                    "ref": rootEl,
                    "class": [
                        'v-tab',
                        props.class,
                        isSelected.value && props.inset ? insetColorClasses.value : []
                    ],
                    "style": [
                        props.style,
                        isSelected.value && props.inset ? insetColorStyles.value : [],
                        {
                            backgroundColor: isSelected.value && props.inset ? 'transparent !important' : undefined
                        }
                    ],
                    "tabindex": isSelected.value ? 0 : -1,
                    "role": "tab",
                    "aria-selected": String(isSelected.value),
                    "active": false
                }, btnProps, attrs, {
                    "block": props.fixed,
                    "maxWidth": props.fixed ? 300 : undefined,
                    "onGroup:selected": updateSlider
                }), {
                    ...slots,
                    default: ()=>vue.createElementVNode(vue.Fragment, null, [
                            slots.default?.() ?? props.text,
                            !props.hideSlider && vue.createElementVNode("div", {
                                "ref": sliderEl,
                                "class": vue.normalizeClass([
                                    'v-tab__slider',
                                    props.inset ? insetColorClasses.value : sliderColorClasses.value
                                ]),
                                "style": vue.normalizeStyle([
                                    sliderColorStyles.value,
                                    props.inset ? insetColorStyles.value : sliderColorClasses.value
                                ])
                            }, null)
                        ])
                });
            });
            return forwardRefs({}, rootEl);
        }
    });
    const makeVTabsWindowProps = propsFactory({
        ...omit(makeVWindowProps(), [
            'continuous',
            'nextIcon',
            'prevIcon',
            'showArrows',
            'touch',
            'mandatory'
        ])
    }, 'VTabsWindow');
    const VTabsWindow = genericComponent()({
        name: 'VTabsWindow',
        props: makeVTabsWindowProps(),
        emits: {
            'update:modelValue': (v)=>true
        },
        setup (props, { slots: slots }) {
            const group = vue.inject(VTabsSymbol, null);
            const _model = useProxiedModel(props, 'modelValue');
            const model = vue.computed({
                get () {
                    // Always return modelValue if defined
                    // or if not within a VTabs group
                    if (_model.value != null || !group) return _model.value;
                    // If inside of a VTabs, find the currently selected
                    // item by id. Item value may be assigned by its index
                    return group.items.value.find((item)=>group.selected.value.includes(item.id))?.value;
                },
                set (val) {
                    _model.value = val;
                }
            });
            useRender(()=>{
                const windowProps = VWindow.filterProps(props);
                return vue.createVNode(VWindow, vue.mergeProps({
                    "_as": "VTabsWindow"
                }, windowProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": [
                        'v-tabs-window',
                        props.class
                    ],
                    "style": props.style,
                    "mandatory": false,
                    "touch": false
                }), slots);
            });
            return {};
        }
    });
    const makeVTabsWindowItemProps = propsFactory({
        ...makeVWindowItemProps()
    }, 'VTabsWindowItem');
    const VTabsWindowItem = genericComponent()({
        name: 'VTabsWindowItem',
        props: makeVTabsWindowItemProps(),
        setup (props, { slots: slots }) {
            useRender(()=>{
                const windowItemProps = VWindowItem.filterProps(props);
                return vue.createVNode(VWindowItem, vue.mergeProps({
                    "_as": "VTabsWindowItem"
                }, windowItemProps, {
                    "class": [
                        'v-tabs-window-item',
                        props.class
                    ],
                    "style": props.style
                }), slots);
            });
            return {};
        }
    });
    // Types
    function parseItems(items) {
        if (!items) return [];
        return items.map((item)=>{
            if (!isObject(item)) return {
                text: item,
                value: item
            };
            return item;
        });
    }
    const makeVTabsProps = propsFactory({
        alignTabs: {
            type: String,
            default: 'start'
        },
        color: String,
        fixedTabs: Boolean,
        items: {
            type: Array,
            default: ()=>[]
        },
        stacked: Boolean,
        bgColor: String,
        grow: Boolean,
        height: {
            type: [
                Number,
                String
            ],
            default: undefined
        },
        hideSlider: Boolean,
        inset: Boolean,
        insetPadding: [
            String,
            Number
        ],
        insetRadius: [
            String,
            Number
        ],
        sliderColor: String,
        ...pick(makeVTabProps(), [
            'spaced',
            'sliderTransition',
            'sliderTransitionDuration'
        ]),
        ...makeVSlideGroupProps({
            mandatory: 'force',
            selectedClass: 'v-tab-item--selected'
        }),
        ...makeDensityProps(),
        ...makeTagProps()
    }, 'VTabs');
    const VTabs = genericComponent()({
        name: 'VTabs',
        props: makeVTabsProps(),
        emits: {
            'update:modelValue': (v)=>true
        },
        setup (props, { attrs: attrs, slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const items = vue.computed(()=>parseItems(props.items));
            const { densityClasses: densityClasses } = useDensity(props);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.bgColor);
            const { scopeId: scopeId } = useScopeId();
            provideDefaults({
                VTab: {
                    color: vue.toRef(props, 'color'),
                    direction: vue.toRef(props, 'direction'),
                    stacked: vue.toRef(props, 'stacked'),
                    fixed: vue.toRef(props, 'fixedTabs'),
                    inset: vue.toRef(props, 'inset'),
                    sliderColor: vue.toRef(props, 'sliderColor'),
                    sliderTransition: vue.toRef(props, 'sliderTransition'),
                    sliderTransitionDuration: vue.toRef(props, 'sliderTransitionDuration'),
                    hideSlider: vue.toRef(props, 'hideSlider')
                }
            });
            useRender(()=>{
                const slideGroupProps = VSlideGroup.filterProps(props);
                const hasWindow = !!(slots.window || props.items.length > 0);
                return vue.createElementVNode(vue.Fragment, null, [
                    vue.createVNode(VSlideGroup, vue.mergeProps(slideGroupProps, {
                        "modelValue": model.value,
                        "onUpdate:modelValue": ($event)=>model.value = $event,
                        "class": [
                            'v-tabs',
                            `v-tabs--${props.direction}`,
                            `v-tabs--align-tabs-${props.alignTabs}`,
                            {
                                'v-tabs--fixed-tabs': props.fixedTabs,
                                'v-tabs--grow': props.grow,
                                'v-tabs--inset': props.inset,
                                'v-tabs--stacked': props.stacked
                            },
                            densityClasses.value,
                            backgroundColorClasses.value,
                            props.class
                        ],
                        "style": [
                            {
                                '--v-tabs-height': convertToUnit(props.height),
                                '--v-tabs-inset-padding': props.inset ? convertToUnit(props.insetPadding) : undefined,
                                '--v-tabs-inset-radius': props.inset ? convertToUnit(props.insetRadius) : undefined
                            },
                            backgroundColorStyles.value,
                            props.style
                        ],
                        "role": "tablist",
                        "symbol": VTabsSymbol
                    }, scopeId, attrs), {
                        default: slots.default ?? (()=>items.value.map((item)=>slots.tab?.({
                                    item: item
                                }) ?? vue.createVNode(VTab, vue.mergeProps(item, {
                                    "key": item.text,
                                    "value": item.value,
                                    "spaced": props.spaced
                                }), {
                                    default: slots[`tab.${item.value}`] ? ()=>slots[`tab.${item.value}`]?.({
                                            item: item
                                        }) : undefined
                                }))),
                        prev: slots.prev,
                        next: slots.next
                    }),
                    hasWindow && vue.createVNode(VTabsWindow, vue.mergeProps({
                        "modelValue": model.value,
                        "onUpdate:modelValue": ($event)=>model.value = $event,
                        "key": "tabs-window"
                    }, scopeId), {
                        default: ()=>[
                                items.value.map((item)=>slots.item?.({
                                        item: item
                                    }) ?? vue.createVNode(VTabsWindowItem, {
                                        "value": item.value
                                    }, {
                                        default: ()=>slots[`item.${item.value}`]?.({
                                                item: item
                                            })
                                    })),
                                slots.window?.()
                            ]
                    })
                ]);
            });
            return {};
        }
    });
    // Types
    const makeVTextareaProps = propsFactory({
        autoGrow: Boolean,
        autofocus: Boolean,
        counter: [
            Boolean,
            Number,
            String
        ],
        counterValue: Function,
        prefix: String,
        placeholder: String,
        persistentPlaceholder: Boolean,
        persistentCounter: Boolean,
        noResize: Boolean,
        rows: {
            type: [
                Number,
                String
            ],
            default: 5,
            validator: (v)=>!isNaN(parseFloat(v))
        },
        maxHeight: {
            type: [
                Number,
                String
            ],
            validator: (v)=>!isNaN(parseFloat(v))
        },
        maxRows: {
            type: [
                Number,
                String
            ],
            validator: (v)=>!isNaN(parseFloat(v))
        },
        suffix: String,
        modelModifiers: Object,
        ...makeAutocompleteProps(),
        ...omit(makeVInputProps(), [
            'direction'
        ]),
        ...makeVFieldProps()
    }, 'VTextarea');
    const VTextarea = genericComponent()({
        name: 'VTextarea',
        directives: {
            vIntersect: Intersect
        },
        inheritAttrs: false,
        props: makeVTextareaProps(),
        emits: {
            'click:control': (e)=>true,
            'mousedown:control': (e)=>true,
            'update:focused': (focused)=>true,
            'update:modelValue': (val)=>true,
            'update:rows': (rows)=>true
        },
        setup (props, { attrs: attrs, emit: emit, slots: slots }) {
            const model = useProxiedModel(props, 'modelValue');
            const { isFocused: isFocused, focus: focus, blur: blur } = useFocus(props);
            const { onIntersect: onIntersect } = useAutofocus(props);
            const counterValue = vue.computed(()=>{
                return typeof props.counterValue === 'function' ? props.counterValue(model.value) : (model.value || '').toString().length;
            });
            const max = vue.computed(()=>{
                if (attrs.maxlength) return attrs.maxlength;
                if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
                return props.counter;
            });
            const vInputRef = vue.ref();
            const vFieldRef = vue.ref();
            const controlHeight = vue.shallowRef('');
            const textareaRef = vue.ref();
            const scrollbarWidth = vue.ref(0);
            const { platform: platform } = useDisplay();
            const autocomplete = useAutocomplete(props);
            const isActive = vue.computed(()=>props.persistentPlaceholder || isFocused.value || props.active);
            function onFocus() {
                if (autocomplete.isSuppressing.value) autocomplete.update();
                if (textareaRef.value !== getActiveElement()) textareaRef.value?.focus();
                if (!isFocused.value) focus();
            }
            function onControlClick(e) {
                onFocus();
                emit('click:control', e);
            }
            function onControlMousedown(e) {
                emit('mousedown:control', e);
            }
            function onClear(e) {
                e.stopPropagation();
                onFocus();
                vue.nextTick(()=>{
                    model.value = '';
                    callEvent(props['onClick:clear'], e);
                });
            }
            function onInput(e) {
                const el = e.target;
                if (!props.modelModifiers?.trim) {
                    model.value = el.value;
                    return;
                }
                const value = el.value;
                const start = el.selectionStart;
                const end = el.selectionEnd;
                model.value = value;
                vue.nextTick(()=>{
                    let offset = 0;
                    if (value.trimStart().length === el.value.length) // #22307 - Whitespace has been removed from the
                    // start, offset the caret position to compensate
                    offset = value.length - el.value.length;
                    if (start != null) el.selectionStart = start - offset;
                    if (end != null) el.selectionEnd = end - offset;
                });
            }
            const sizerRef = vue.ref();
            const rows = vue.ref(Number(props.rows));
            const isPlainOrUnderlined = vue.computed(()=>[
                    'plain',
                    'underlined'
                ].includes(props.variant));
            vue.watchEffect(()=>{
                if (!props.autoGrow) rows.value = Number(props.rows);
            });
            function calculateInputHeight() {
                vue.nextTick(()=>{
                    if (!textareaRef.value) return;
                    if (platform.value.firefox) {
                        scrollbarWidth.value = 12;
                        return;
                    }
                    const { offsetWidth: offsetWidth, clientWidth: clientWidth } = textareaRef.value;
                    scrollbarWidth.value = Math.max(0, offsetWidth - clientWidth);
                });
                if (!props.autoGrow) return;
                vue.nextTick(()=>{
                    if (!sizerRef.value || !vFieldRef.value) return;
                    const style = getComputedStyle(sizerRef.value);
                    const fieldStyle = getComputedStyle(vFieldRef.value.$el);
                    const padding = parseFloat(style.getPropertyValue('--v-field-padding-top')) + parseFloat(style.getPropertyValue('--v-input-padding-top')) + parseFloat(style.getPropertyValue('--v-field-padding-bottom'));
                    const height = sizerRef.value.scrollHeight;
                    const lineHeight = parseFloat(style.lineHeight);
                    const minHeight = Math.max(parseFloat(props.rows) * lineHeight + padding, parseFloat(fieldStyle.getPropertyValue('--v-input-control-height')));
                    const maxHeight = props.maxHeight ? parseFloat(props.maxHeight) : parseFloat(props.maxRows) * lineHeight + padding || Infinity;
                    const newHeight = clamp(height ?? 0, minHeight, maxHeight);
                    rows.value = Math.floor((newHeight - padding) / lineHeight);
                    controlHeight.value = convertToUnit(newHeight);
                });
            }
            vue.onMounted(calculateInputHeight);
            vue.watch(model, calculateInputHeight);
            vue.watch(()=>props.rows, calculateInputHeight);
            vue.watch(()=>props.maxHeight, calculateInputHeight);
            vue.watch(()=>props.maxRows, calculateInputHeight);
            vue.watch(()=>props.density, calculateInputHeight);
            vue.watch(rows, (val)=>{
                emit('update:rows', val);
            });
            let observer;
            vue.watch(sizerRef, (val)=>{
                if (val) {
                    observer = new ResizeObserver(calculateInputHeight);
                    observer.observe(sizerRef.value);
                } else observer?.disconnect();
            });
            vue.onBeforeUnmount(()=>{
                observer?.disconnect();
            });
            useRender(()=>{
                const hasCounter = !!(slots.counter || props.counter || props.counterValue);
                const hasDetails = props.hideDetails !== true && !!(slots.details || hasCounter && (props.persistentCounter || props.hideDetails === false || isFocused.value));
                const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
                const { modelValue: _, ...inputProps } = VInput.filterProps(props);
                const fieldProps = {
                    ...VField.filterProps(props),
                    'onClick:clear': onClear
                };
                return vue.createVNode(VInput, vue.mergeProps({
                    "ref": vInputRef,
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": [
                        'v-textarea v-text-field',
                        {
                            'v-textarea--prefixed': props.prefix,
                            'v-textarea--suffixed': props.suffix,
                            'v-text-field--prefixed': props.prefix,
                            'v-text-field--suffixed': props.suffix,
                            'v-textarea--auto-grow': props.autoGrow,
                            'v-textarea--no-resize': props.noResize || props.autoGrow,
                            'v-input--plain-underlined': isPlainOrUnderlined.value
                        },
                        props.class
                    ],
                    "style": [
                        {
                            '--v-textarea-max-height': props.maxHeight ? convertToUnit(props.maxHeight) : undefined,
                            '--v-textarea-scroll-bar-width': convertToUnit(scrollbarWidth.value)
                        },
                        props.style
                    ]
                }, rootAttrs, inputProps, {
                    "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
                    "focused": isFocused.value,
                    "indentDetails": props.indentDetails ?? !isPlainOrUnderlined.value
                }), {
                    ...slots,
                    default: ({ id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails })=>vue.createVNode(VField, vue.mergeProps({
                            "ref": vFieldRef,
                            "style": {
                                '--v-textarea-control-height': controlHeight.value
                            },
                            "onClick": onControlClick,
                            "onMousedown": onControlMousedown,
                            "onClick:prependInner": props['onClick:prependInner'],
                            "onClick:appendInner": props['onClick:appendInner']
                        }, fieldProps, {
                            "id": id.value,
                            "active": isActive.value || isDirty.value,
                            "labelId": `${id.value}-label`,
                            "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
                            "dirty": isDirty.value || props.dirty,
                            "disabled": isDisabled.value,
                            "focused": isFocused.value,
                            "details": hasDetails.value,
                            "error": isValid.value === false
                        }), {
                            ...slots,
                            default: ({ props: { class: fieldClass, ...slotProps }, controlRef: controlRef })=>vue.createElementVNode(vue.Fragment, null, [
                                    props.prefix && vue.createElementVNode("span", {
                                        "class": "v-text-field__prefix"
                                    }, [
                                        props.prefix
                                    ]),
                                    vue.withDirectives(vue.createElementVNode("textarea", vue.mergeProps({
                                        "ref": (val)=>textareaRef.value = controlRef.value = val,
                                        "class": fieldClass,
                                        "value": model.value,
                                        "onInput": onInput,
                                        "autofocus": props.autofocus,
                                        "readonly": isReadonly.value,
                                        "disabled": isDisabled.value,
                                        "placeholder": props.placeholder,
                                        "rows": props.rows,
                                        "name": autocomplete.fieldName.value,
                                        "autocomplete": autocomplete.fieldAutocomplete.value,
                                        "onFocus": onFocus,
                                        "onBlur": blur,
                                        "aria-labelledby": `${id.value}-label`
                                    }, slotProps, inputAttrs), null), [
                                        [
                                            Intersect,
                                            {
                                                handler: onIntersect
                                            },
                                            null,
                                            {
                                                once: true
                                            }
                                        ]
                                    ]),
                                    props.autoGrow && vue.withDirectives(vue.createElementVNode("textarea", {
                                        "class": vue.normalizeClass([
                                            fieldClass,
                                            'v-textarea__sizer'
                                        ]),
                                        "id": `${slotProps.id}-sizer`,
                                        "onUpdate:modelValue": ($event)=>model.value = $event,
                                        "ref": sizerRef,
                                        "readonly": true,
                                        "aria-hidden": "true"
                                    }, null), [
                                        [
                                            vue.vModelText,
                                            model.value
                                        ]
                                    ]),
                                    props.suffix && vue.createElementVNode("span", {
                                        "class": "v-text-field__suffix"
                                    }, [
                                        props.suffix
                                    ])
                                ])
                        }),
                    details: hasDetails ? (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            slots.details?.(slotProps),
                            hasCounter && vue.createElementVNode(vue.Fragment, null, [
                                vue.createElementVNode("span", null, null),
                                vue.createVNode(VCounter, {
                                    "active": props.persistentCounter || isFocused.value,
                                    "value": counterValue.value,
                                    "max": max.value,
                                    "disabled": props.disabled
                                }, slots.counter)
                            ])
                        ]) : undefined
                });
            });
            return forwardRefs({}, vInputRef, vFieldRef, textareaRef);
        }
    });
    const makeVThemeProviderProps = propsFactory({
        withBackground: Boolean,
        ...makeComponentProps(),
        ...makeThemeProps(),
        ...makeTagProps()
    }, 'VThemeProvider');
    const VThemeProvider = genericComponent()({
        name: 'VThemeProvider',
        props: makeVThemeProviderProps(),
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            return ()=>{
                if (!props.withBackground) return slots.default?.();
                return vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-theme-provider',
                        themeClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, {
                    default: ()=>[
                            slots.default?.()
                        ]
                });
            };
        }
    });
    const makeVTimelineDividerProps = propsFactory({
        dotColor: String,
        fillDot: Boolean,
        hideDot: Boolean,
        icon: IconValue,
        iconColor: String,
        lineColor: String,
        ...makeComponentProps(),
        ...makeRoundedProps(),
        ...makeSizeProps(),
        ...makeElevationProps()
    }, 'VTimelineDivider');
    const VTimelineDivider = genericComponent()({
        name: 'VTimelineDivider',
        props: makeVTimelineDividerProps(),
        setup (props, { slots: slots }) {
            const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = useSize(props, 'v-timeline-divider__dot');
            const { backgroundColorStyles: backgroundColorStyles, backgroundColorClasses: backgroundColorClasses } = useBackgroundColor(()=>props.dotColor);
            const { roundedClasses: roundedClasses, roundedStyles: roundedStyles } = useRounded(props, 'v-timeline-divider__dot');
            const { elevationClasses: elevationClasses } = useElevation(props);
            const { backgroundColorClasses: lineColorClasses, backgroundColorStyles: lineColorStyles } = useBackgroundColor(()=>props.lineColor);
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-timeline-divider',
                        {
                            'v-timeline-divider--fill-dot': props.fillDot
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, [
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-timeline-divider__before',
                            lineColorClasses.value
                        ]),
                        "style": vue.normalizeStyle(lineColorStyles.value)
                    }, null),
                    !props.hideDot && vue.createElementVNode("div", {
                        "key": "dot",
                        "class": vue.normalizeClass([
                            'v-timeline-divider__dot',
                            elevationClasses.value,
                            roundedClasses.value,
                            sizeClasses.value
                        ]),
                        "style": vue.normalizeStyle([
                            sizeStyles.value,
                            roundedStyles.value
                        ])
                    }, [
                        vue.createElementVNode("div", {
                            "class": vue.normalizeClass([
                                'v-timeline-divider__inner-dot',
                                backgroundColorClasses.value,
                                roundedClasses.value
                            ]),
                            "style": vue.normalizeStyle([
                                backgroundColorStyles.value,
                                roundedStyles.value
                            ])
                        }, [
                            !slots.default ? vue.createVNode(VIcon, {
                                "key": "icon",
                                "color": props.iconColor,
                                "icon": props.icon,
                                "size": props.size
                            }, null) : vue.createVNode(VDefaultsProvider, {
                                "key": "icon-defaults",
                                "disabled": !props.icon,
                                "defaults": {
                                    VIcon: {
                                        color: props.iconColor,
                                        icon: props.icon,
                                        size: props.size
                                    }
                                }
                            }, slots.default)
                        ])
                    ]),
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass([
                            'v-timeline-divider__after',
                            lineColorClasses.value
                        ]),
                        "style": vue.normalizeStyle(lineColorStyles.value)
                    }, null)
                ]));
            return {};
        }
    });
    // Types
    // Types
    const makeVTimelineItemProps = propsFactory({
        density: String,
        dotColor: String,
        fillDot: Boolean,
        hideDot: Boolean,
        hideOpposite: {
            type: Boolean,
            default: undefined
        },
        icon: IconValue,
        iconColor: String,
        lineInset: [
            Number,
            String
        ],
        side: {
            type: String,
            validator: (v)=>v == null || [
                    'start',
                    'end'
                ].includes(v)
        },
        ...makeComponentProps(),
        ...makeDimensionProps(),
        ...makeElevationProps(),
        ...makeRoundedProps(),
        ...makeSizeProps(),
        ...makeTagProps()
    }, 'VTimelineItem');
    const VTimelineItem = genericComponent()({
        name: 'VTimelineItem',
        props: makeVTimelineItemProps(),
        setup (props, { slots: slots }) {
            const { dimensionStyles: dimensionStyles } = useDimension(props);
            const dotSize = vue.shallowRef(0);
            const dotRef = vue.ref();
            vue.watch(dotRef, (newValue)=>{
                if (!newValue) return;
                dotSize.value = newValue.$el.querySelector('.v-timeline-divider__dot')?.getBoundingClientRect().width ?? 0;
            }, {
                flush: 'post'
            });
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-timeline-item',
                        {
                            'v-timeline-item--fill-dot': props.fillDot,
                            'v-timeline-item--side-start': props.side === 'start',
                            'v-timeline-item--side-end': props.side === 'end'
                        },
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-timeline-dot-size': convertToUnit(dotSize.value),
                            '--v-timeline-line-inset': props.lineInset ? `calc(var(--v-timeline-dot-size) / 2 + ${convertToUnit(props.lineInset)})` : convertToUnit(0)
                        },
                        props.style
                    ])
                }, [
                    vue.createElementVNode("div", {
                        "class": "v-timeline-item__body",
                        "style": vue.normalizeStyle(dimensionStyles.value)
                    }, [
                        slots.default?.()
                    ]),
                    vue.createVNode(VTimelineDivider, {
                        "ref": dotRef,
                        "hideDot": props.hideDot,
                        "icon": props.icon,
                        "iconColor": props.iconColor,
                        "size": props.size,
                        "elevation": props.elevation,
                        "dotColor": props.dotColor,
                        "fillDot": props.fillDot,
                        "rounded": props.rounded
                    }, {
                        default: slots.icon
                    }),
                    props.density !== 'compact' && vue.createElementVNode("div", {
                        "class": "v-timeline-item__opposite"
                    }, [
                        !props.hideOpposite && slots.opposite?.()
                    ])
                ]));
            return {};
        }
    });
    const makeVTimelineProps = propsFactory({
        align: {
            type: String,
            default: 'center',
            validator: (v)=>[
                    'center',
                    'start'
                ].includes(v)
        },
        direction: {
            type: String,
            default: 'vertical',
            validator: (v)=>[
                    'vertical',
                    'horizontal'
                ].includes(v)
        },
        justify: {
            type: String,
            default: 'auto',
            validator: (v)=>[
                    'auto',
                    'center'
                ].includes(v)
        },
        side: {
            type: String,
            validator: (v)=>v == null || [
                    'start',
                    'end'
                ].includes(v)
        },
        lineThickness: {
            type: [
                String,
                Number
            ],
            default: 2
        },
        lineColor: String,
        truncateLine: {
            type: String,
            validator: (v)=>[
                    'start',
                    'end',
                    'both'
                ].includes(v)
        },
        ...pick(makeVTimelineItemProps({
            lineInset: 0
        }), [
            'dotColor',
            'fillDot',
            'hideOpposite',
            'iconColor',
            'lineInset',
            'size'
        ]),
        ...makeComponentProps(),
        ...makeDensityProps(),
        ...makeTagProps(),
        ...makeThemeProps()
    }, 'VTimeline');
    const VTimeline = genericComponent()({
        name: 'VTimeline',
        props: makeVTimelineProps(),
        setup (props, { slots: slots }) {
            const { themeClasses: themeClasses } = provideTheme(props);
            const { densityClasses: densityClasses } = useDensity(props);
            const { rtlClasses: rtlClasses } = useRtl();
            provideDefaults({
                VTimelineDivider: {
                    lineColor: vue.toRef(()=>props.lineColor)
                },
                VTimelineItem: {
                    density: vue.toRef(()=>props.density),
                    dotColor: vue.toRef(()=>props.dotColor),
                    fillDot: vue.toRef(()=>props.fillDot),
                    hideOpposite: vue.toRef(()=>props.hideOpposite),
                    iconColor: vue.toRef(()=>props.iconColor),
                    lineColor: vue.toRef(()=>props.lineColor),
                    lineInset: vue.toRef(()=>props.lineInset),
                    size: vue.toRef(()=>props.size)
                }
            });
            const sideClasses = vue.computed(()=>{
                const side = props.side ? props.side : props.density !== 'default' ? 'end' : null;
                return side && `v-timeline--side-${side}`;
            });
            const truncateClasses = vue.computed(()=>{
                const classes = [
                    'v-timeline--truncate-line-start',
                    'v-timeline--truncate-line-end'
                ];
                switch(props.truncateLine){
                    case 'both':
                        return classes;
                    case 'start':
                        return classes[0];
                    case 'end':
                        return classes[1];
                    default:
                        return null;
                }
            });
            useRender(()=>vue.createVNode(props.tag, {
                    "class": vue.normalizeClass([
                        'v-timeline',
                        `v-timeline--${props.direction}`,
                        `v-timeline--align-${props.align}`,
                        `v-timeline--justify-${props.justify}`,
                        truncateClasses.value,
                        {
                            'v-timeline--inset-line': !!props.lineInset
                        },
                        themeClasses.value,
                        densityClasses.value,
                        sideClasses.value,
                        rtlClasses.value,
                        props.class
                    ]),
                    "style": vue.normalizeStyle([
                        {
                            '--v-timeline-line-thickness': convertToUnit(props.lineThickness)
                        },
                        props.style
                    ])
                }, slots));
            return {};
        }
    });
    // Types
    const makeVTimePickerClockProps = propsFactory({
        allowedValues: Function,
        ampm: Boolean,
        color: String,
        disabled: Boolean,
        displayedValue: null,
        double: Boolean,
        format: {
            type: Function,
            default: (val)=>val
        },
        max: {
            type: Number,
            required: true
        },
        min: {
            type: Number,
            required: true
        },
        scrollable: Boolean,
        readonly: Boolean,
        rotate: {
            type: Number,
            default: 0
        },
        step: {
            type: Number,
            default: 1
        },
        modelValue: {
            type: Number
        }
    }, 'VTimePickerClock');
    const VTimePickerClock = genericComponent()({
        name: 'VTimePickerClock',
        props: makeVTimePickerClockProps(),
        emits: {
            change: (val)=>true,
            input: (val)=>true
        },
        setup (props, { emit: emit }) {
            const clockRef = vue.ref(null);
            const innerClockRef = vue.ref(null);
            const inputValue = vue.ref(undefined);
            const isDragging = vue.ref(false);
            const valueOnMouseDown = vue.ref(null);
            const valueOnMouseUp = vue.ref(null);
            const emitChangeDebounced = debounce((value)=>emit('change', value), 750);
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = useBackgroundColor(()=>props.color);
            const count = vue.computed(()=>props.max - props.min + 1);
            const roundCount = vue.computed(()=>props.double ? count.value / 2 : count.value);
            const degreesPerUnit = vue.computed(()=>360 / roundCount.value);
            const degrees = vue.computed(()=>degreesPerUnit.value * Math.PI / 180);
            const displayedValue = vue.computed(()=>props.modelValue == null ? props.min : props.modelValue);
            const innerRadiusScale = vue.computed(()=>0.62);
            const genChildren = vue.computed(()=>{
                const children = [];
                for(let value = props.min; value <= props.max; value = value + props.step)children.push(value);
                return children;
            });
            vue.watch(()=>props.modelValue, (val)=>{
                inputValue.value = val;
            });
            function update(value) {
                if (inputValue.value !== value) inputValue.value = value;
                emit('input', value);
            }
            function isAllowed(value) {
                return !props.allowedValues || props.allowedValues(value);
            }
            function wheel(e) {
                if (!props.scrollable || props.disabled) return;
                e.preventDefault();
                const delta = Math.sign(-e.deltaY || 1);
                let value = displayedValue.value;
                do {
                    value = value + delta;
                    value = (value - props.min + count.value) % count.value + props.min;
                }while (!isAllowed(value) && value !== displayedValue.value);
                if (value !== props.displayedValue) update(value);
                emitChangeDebounced(value);
            }
            function isInner(value) {
                return props.double && value - props.min >= roundCount.value;
            }
            function handScale(value) {
                return isInner(value) ? innerRadiusScale.value : 1;
            }
            function getPosition(value) {
                const rotateRadians = props.rotate * Math.PI / 180;
                return {
                    x: Math.sin((value - props.min) * degrees.value + rotateRadians) * handScale(value),
                    y: -Math.cos((value - props.min) * degrees.value + rotateRadians) * handScale(value)
                };
            }
            function angleToValue(angle, insideClick) {
                const value = (Math.round(angle / degreesPerUnit.value) + (insideClick ? roundCount.value : 0)) % count.value + props.min;
                // Necessary to fix edge case when selecting left part of the value(s) at 12 o'clock
                if (angle < 360 - degreesPerUnit.value / 2) return value;
                return insideClick ? props.max - roundCount.value + 1 : props.min;
            }
            function getTransform(i) {
                const { x: x, y: y } = getPosition(i);
                return {
                    left: `${Math.round(50 + x * 50)}%`,
                    top: `${Math.round(50 + y * 50)}%`
                };
            }
            function euclidean(p0, p1) {
                const dx = p1.x - p0.x;
                const dy = p1.y - p0.y;
                return Math.sqrt(dx * dx + dy * dy);
            }
            function angle(center, p1) {
                const value = 2 * Math.atan2(p1.y - center.y - euclidean(center, p1), p1.x - center.x);
                return Math.abs(value * 180 / Math.PI);
            }
            function setMouseDownValue(value) {
                if (valueOnMouseDown.value === null) valueOnMouseDown.value = value;
                valueOnMouseUp.value = value;
                update(value);
            }
            function onDragMove(e) {
                e.preventDefault();
                if (!isDragging.value && e.type !== 'click' || !clockRef.value) return;
                const { width: width, top: top, left: left } = clockRef.value?.getBoundingClientRect();
                const { width: innerWidth } = innerClockRef.value?.getBoundingClientRect() ?? {
                    width: 0
                };
                const { clientX: clientX, clientY: clientY } = 'touches' in e ? e.touches[0] : e;
                const center = {
                    x: width / 2,
                    y: -width / 2
                };
                const coords = {
                    x: clientX - left,
                    y: top - clientY
                };
                const handAngle = Math.round(angle(center, coords) - props.rotate + 360) % 360;
                const insideClick = props.double && euclidean(center, coords) < (innerWidth + innerWidth * innerRadiusScale.value) / 4;
                const checksCount = Math.ceil(15 / degreesPerUnit.value);
                let value;
                for(let i = 0; i < checksCount; i++){
                    value = angleToValue(handAngle + i * degreesPerUnit.value, insideClick);
                    if (isAllowed(value)) return setMouseDownValue(value);
                    value = angleToValue(handAngle - i * degreesPerUnit.value, insideClick);
                    if (isAllowed(value)) return setMouseDownValue(value);
                }
            }
            function onMouseDown(e) {
                if (props.disabled) return;
                e.preventDefault();
                window.addEventListener('mousemove', onDragMove);
                window.addEventListener('touchmove', onDragMove);
                window.addEventListener('mouseup', onMouseUp);
                window.addEventListener('touchend', onMouseUp);
                valueOnMouseDown.value = null;
                valueOnMouseUp.value = null;
                isDragging.value = true;
                onDragMove(e);
            }
            function onMouseUp(e) {
                e.stopPropagation();
                removeListeners();
                isDragging.value = false;
                if (valueOnMouseUp.value !== null && isAllowed(valueOnMouseUp.value)) emit('change', valueOnMouseUp.value);
            }
            function removeListeners() {
                if (!IN_BROWSER) return;
                window.removeEventListener('mousemove', onDragMove);
                window.removeEventListener('touchmove', onDragMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
            }
            vue.onScopeDispose(removeListeners);
            useRender(()=>{
                return vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        {
                            'v-time-picker-clock': true,
                            'v-time-picker-clock--indeterminate': props.modelValue == null,
                            'v-time-picker-clock--readonly': props.readonly
                        }
                    ]),
                    "onMousedown": onMouseDown,
                    "onTouchstart": onMouseDown,
                    "onWheel": wheel,
                    "ref": clockRef
                }, [
                    vue.createElementVNode("div", {
                        "class": "v-time-picker-clock__inner",
                        "ref": innerClockRef
                    }, [
                        vue.createElementVNode("div", {
                            "class": vue.normalizeClass([
                                {
                                    'v-time-picker-clock__hand': true,
                                    'v-time-picker-clock__hand--inner': isInner(props.modelValue)
                                },
                                textColorClasses.value
                            ]),
                            "style": vue.normalizeStyle([
                                {
                                    transform: `rotate(${props.rotate + degreesPerUnit.value * (displayedValue.value - props.min)}deg) scaleY(${handScale(displayedValue.value)})`
                                },
                                textColorStyles.value
                            ])
                        }, null),
                        genChildren.value.map((value)=>{
                            const isActive = value === displayedValue.value;
                            return vue.createElementVNode("div", {
                                "class": vue.normalizeClass([
                                    {
                                        'v-time-picker-clock__item': true,
                                        'v-time-picker-clock__item--active': isActive,
                                        'v-time-picker-clock__item--disabled': props.disabled || !isAllowed(value)
                                    },
                                    isActive && backgroundColorClasses.value
                                ]),
                                "style": vue.normalizeStyle([
                                    getTransform(value),
                                    isActive && backgroundColorStyles.value
                                ])
                            }, [
                                vue.createElementVNode("span", null, [
                                    props.format(value)
                                ])
                            ]);
                        })
                    ])
                ]);
            });
        }
    });
    // Types
    const makeVTimePickerFieldProps = propsFactory({
        active: Boolean,
        color: String,
        disabled: Boolean,
        label: String,
        modelValue: String,
        error: String,
        showHint: Boolean,
        readonly: Boolean
    }, 'VTimePickerField');
    const VTimePickerField = genericComponent()({
        name: 'VTimePickerField',
        props: makeVTimePickerFieldProps(),
        emits: {
            'update:modelValue': (v)=>true
        },
        setup (props, { emit: emit }) {
            const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = useTextColor(()=>props.color);
            const vTextInputRef = vue.ref();
            const isFocused = vue.shallowRef(false);
            function onKeydown(e) {
                if ([
                    'Backspace',
                    'Delete'
                ].includes(e.key)) {
                    e.preventDefault();
                    const target = e.target;
                    target.value = '';
                    emit('update:modelValue', null);
                }
            }
            useRender(()=>{
                return vue.createVNode(VTextField, {
                    "ref": vTextInputRef,
                    "_as": "VTimePickerField",
                    "autocomplete": "off",
                    "class": vue.normalizeClass([
                        'v-time-picker-controls__time__field',
                        {
                            'v-time-picker-controls__time__field--active': props.active
                        },
                        props.active ? textColorClasses.value : []
                    ]),
                    "style": vue.normalizeStyle(props.active ? textColorStyles.value : []),
                    "disabled": props.disabled,
                    "variant": "solo-filled",
                    "inputmode": "numeric",
                    "hideDetails": "auto",
                    "aria-label": props.label,
                    "aria-invalid": !!props.error,
                    "aria-errormessage": props.error,
                    "error": !!props.error,
                    "hint": props.showHint ? props.label : undefined,
                    "persistentHint": true,
                    "flat": true,
                    "modelValue": props.modelValue ?? (isFocused.value ? '' : '--'),
                    "onUpdate:modelValue": (v)=>emit('update:modelValue', v),
                    "onKeydown": onKeydown,
                    "onFocus": ()=>isFocused.value = true,
                    "onBlur": ()=>isFocused.value = false
                }, null);
            });
            return forwardRefs({}, vTextInputRef);
        }
    });
    // Types
    function pad(n, length = 2) {
        return String(n).padStart(length, '0');
    }
    function convert24to12(hour) {
        return hour ? (hour - 1) % 12 + 1 : 12;
    }
    function convert12to24(hour, period) {
        return hour % 12 + (period === 'pm' ? 12 : 0);
    }
    function extractInteger(v) {
        const digits = v.replaceAll(/\D/g, '');
        return digits.length > 0 ? Number(digits) : null;
    }
    function incrementHour(hour, increment, period) {
        if (hour === 23 && increment) return {
            value: 0
        };
        if (hour === 0 && !increment) return {
            value: 23
        };
        return {
            value: hour + (increment ? 1 : -1)
        };
    }
    function incrementMinuteOrSecond(val, increment) {
        if (val === 59 && increment) return 0;
        if (val === 0 && !increment) return 59;
        return val + (increment ? 1 : -1);
    }
    // Utilities
    // Types
    const makeTimeValidationProps = propsFactory({
        allowedHours: [
            Function,
            Array
        ],
        allowedMinutes: [
            Function,
            Array
        ],
        allowedSeconds: [
            Function,
            Array
        ],
        max: String,
        min: String
    }, 'time-validation');
    function useTimeValidation(props) {
        const isAllowedHour = vue.computed(()=>{
            const minHour = props.min ? Number(props.min.split(':')[0]) : 0;
            const maxHour = props.max ? Number(props.max.split(':')[0]) : 23;
            return (val)=>{
                if (val < minHour) return false;
                if (val > maxHour) return false;
                if (Array.isArray(props.allowedHours)) return props.allowedHours.includes(val);
                if (typeof props.allowedHours === 'function') return props.allowedHours(val);
                return true;
            };
        });
        const isAllowedMinute = vue.computed(()=>{
            const [minHour, minMinute] = props.min ? props.min.split(':').map(Number) : [
                0,
                0
            ];
            const [maxHour, maxMinute] = props.max ? props.max.split(':').map(Number) : [
                23,
                59
            ];
            const minTime = minHour * 60 + minMinute;
            const maxTime = maxHour * 60 + maxMinute;
            return (hour24hr, val)=>{
                if (hour24hr !== null) {
                    const time = 60 * hour24hr + val;
                    if (time < minTime) return false;
                    if (time > maxTime) return false;
                }
                if (Array.isArray(props.allowedMinutes)) return props.allowedMinutes.includes(val);
                if (typeof props.allowedMinutes === 'function') return props.allowedMinutes(val);
                return true;
            };
        });
        const isAllowedSecond = vue.computed(()=>{
            const [minHour, minMinute, minSecond] = props.min ? props.min.split(':').map(Number) : [
                0,
                0,
                0
            ];
            const [maxHour, maxMinute, maxSecond] = props.max ? props.max.split(':').map(Number) : [
                23,
                59,
                59
            ];
            const minTime = minHour * 3600 + minMinute * 60 + (minSecond || 0);
            const maxTime = maxHour * 3600 + maxMinute * 60 + (maxSecond || 0);
            return (hour24hr, minute, val)=>{
                if (hour24hr !== null && minute !== null) {
                    const time = 3600 * hour24hr + 60 * minute + val;
                    if (time < minTime) return false;
                    if (time > maxTime) return false;
                }
                if (Array.isArray(props.allowedSeconds)) return props.allowedSeconds.includes(val);
                if (typeof props.allowedSeconds === 'function') return props.allowedSeconds(val);
                return true;
            };
        });
        function findNextAllowed(type, value, increment, currentHour = null, currentMinute = null) {
            const isAllowed = type === 'hour' ? isAllowedHour.value : type === 'minute' ? (v)=>isAllowedMinute.value(currentHour, v) : (v)=>isAllowedSecond.value(currentHour, currentMinute, v);
            const nextValue = type === 'hour' ? (v)=>incrementHour(v, increment).value : (v)=>incrementMinuteOrSecond(v, increment);
            const limit = type === 'hour' ? 24 : 60;
            for(let i = 1; i <= limit; i++){
                value = nextValue(value);
                if (isAllowed(value)) break;
            }
            return value;
        }
        return {
            isAllowedHour: isAllowedHour,
            isAllowedMinute: isAllowedMinute,
            isAllowedSecond: isAllowedSecond,
            findNextAllowed: findNextAllowed
        };
    }
    // Types
    const makeVTimePickerControlsProps = propsFactory({
        ampm: Boolean,
        color: String,
        disabled: Boolean,
        inputHints: Boolean,
        hour: [
            Number,
            String
        ],
        minute: [
            Number,
            String
        ],
        second: [
            Number,
            String
        ],
        period: String,
        readonly: Boolean,
        useSeconds: Boolean,
        value: Number,
        viewMode: String,
        ...makeTimeValidationProps()
    }, 'VTimePickerControls');
    const VTimePickerControls = genericComponent()({
        name: 'VTimePickerControls',
        props: makeVTimePickerControlsProps(),
        emits: {
            'update:period': (data)=>true,
            'update:viewMode': (data)=>true,
            'update:hour': (v)=>true,
            'update:minute': (v)=>true,
            'update:second': (v)=>true
        },
        setup (props, { emit: emit }) {
            const { t: t } = useLocale();
            const { isAllowedHour: isAllowedHour, isAllowedMinute: isAllowedMinute, isAllowedSecond: isAllowedSecond, findNextAllowed: findNextAllowed } = useTimeValidation(props);
            const currentHour = vue.computed(()=>props.hour !== null ? props.ampm ? convert12to24(Number(props.hour), props.period ?? 'am') : Number(props.hour) : null);
            const currentMinute = vue.computed(()=>props.minute !== null ? Number(props.minute) : null);
            const isHourValid = vue.computed(()=>{
                if (props.hour === null) return true;
                return isAllowedHour.value?.(Number(currentHour.value)) ?? true;
            });
            const isMinuteValid = vue.computed(()=>{
                if (props.minute === null) return true;
                return isAllowedMinute.value?.(currentHour.value, Number(props.minute)) ?? true;
            });
            const isSecondValid = vue.computed(()=>{
                if (props.second === null) return true;
                return isAllowedSecond.value?.(currentHour.value, currentMinute.value, Number(props.second)) ?? true;
            });
            const transformHours = {
                in: (v)=>{
                    if (v == null || isNaN(Number(v))) return null;
                    const val = Number(v);
                    return props.ampm ? pad(convert24to12(val)) : pad(val);
                },
                out: (v)=>{
                    if (isNaN(Number(v)) || v == null || v === '') return null;
                    const val = typeof v === 'string' ? extractInteger(v) : Number(v);
                    if (val === null) return null;
                    return props.ampm ? convert12to24(val, props.period ?? 'am') : clamp(val, 0, 23);
                }
            };
            const hour = useProxiedModel(props, 'hour', undefined, transformHours.in, transformHours.out);
            const transformMinutesOrSeconds = {
                in: (v)=>v != null && !isNaN(Number(v)) ? pad(`${v}`) : null,
                out: (v)=>{
                    if (isNaN(Number(v)) || v == null || v === '') return null;
                    const val = typeof v === 'string' ? extractInteger(v) : Number(v);
                    return val !== null ? clamp(val, 0, 59) : null;
                }
            };
            const minute = useProxiedModel(props, 'minute', undefined, transformMinutesOrSeconds.in, transformMinutesOrSeconds.out);
            const second = useProxiedModel(props, 'second', undefined, transformMinutesOrSeconds.in, transformMinutesOrSeconds.out);
            function onHourFieldKeydown(e) {
                if (![
                    'ArrowUp',
                    'ArrowDown'
                ].includes(e.key)) return;
                e.preventDefault();
                e.stopPropagation();
                const isAm = props.period === 'am';
                const current = props.ampm ? convert12to24(Number(hour.value ?? 0), isAm ? 'am' : 'pm') : Number(hour.value ?? 0);
                const next = findNextAllowed('hour', current, e.key === 'ArrowUp');
                const togglePeriod = isAm && next >= 12 || !isAm && next < 12;
                if (props.ampm && togglePeriod) {
                    emit('update:period', props.period === 'am' ? 'pm' : 'am');
                    vue.nextTick(()=>hour.value = pad(next));
                } else hour.value = pad(next);
            }
            function onMinuteFieldKeydown(e) {
                if (![
                    'ArrowUp',
                    'ArrowDown'
                ].includes(e.key)) return;
                e.preventDefault();
                e.stopPropagation();
                const current = Number(minute.value ?? 0);
                const next = findNextAllowed('minute', current, e.key === 'ArrowUp', currentHour.value);
                minute.value = pad(next);
            }
            function onSecondFieldKeydown(e) {
                if (![
                    'ArrowUp',
                    'ArrowDown'
                ].includes(e.key)) return;
                e.preventDefault();
                e.stopPropagation();
                const current = Number(second.value ?? 0);
                const next = findNextAllowed('second', current, e.key === 'ArrowUp', currentHour.value, currentMinute.value);
                second.value = pad(next);
            }
            function createInputInterceptor(valueTransformOut, compare, apply) {
                return (e)=>{
                    if (!e.data) return;
                    const inputElement = e.target;
                    const { value: existingTxt, selectionStart: selectionStart, selectionEnd: selectionEnd } = inputElement ?? {};
                    if (extractInteger(e.data) === null) {
                        e.preventDefault();
                        return;
                    }
                    const potentialNewInputVal = existingTxt ? existingTxt.slice(0, selectionStart) + e.data + existingTxt.slice(selectionEnd) : e.data;
                    if (potentialNewInputVal.length > 2) {
                        if (selectionStart === selectionEnd && selectionEnd === 0 && e.data.trim().startsWith('0')) {
                            e.preventDefault();
                            inputElement.value = potentialNewInputVal.trim().substring(0, 2);
                            apply(inputElement.value);
                            if (e.data.trim().length === 1) inputElement.setSelectionRange(1, 1);
                            return;
                        }
                        if (selectionStart === selectionEnd && selectionEnd === 1 && existingTxt.startsWith('0')) {
                            e.preventDefault();
                            inputElement.value = potentialNewInputVal.trim().substring(0, 2);
                            apply(inputElement.value);
                            return;
                        }
                        const maxValue = props.viewMode === 'hour' ? props.ampm ? 12 : 23 : 59;
                        const value = extractInteger(potentialNewInputVal);
                        if (value > maxValue) {
                            e.preventDefault();
                            inputElement.value = pad(String(extractInteger(e.data)).substring(0, 2));
                            apply(inputElement.value);
                            return;
                        }
                    }
                    const potentialNewNumber = valueTransformOut(potentialNewInputVal);
                    if (compare(potentialNewNumber)) // ignore input when results in the same number
                    // prevents typing more digits
                    e.preventDefault();
                };
            }
            function setPeriod(val) {
                emit('update:period', val);
            }
            const hourInputRef = vue.ref();
            const minuteInputRef = vue.ref();
            const secondInputRef = vue.ref();
            vue.watch(()=>props.viewMode, (_, old)=>{
                switch(old){
                    case 'hour':
                        hourInputRef.value.blur();
                        break;
                    case 'minute':
                        minuteInputRef.value.blur();
                        break;
                    case 'second':
                        secondInputRef.value.blur();
                        break;
                }
            });
            const hourInputFilter = createInputInterceptor(transformHours.out, (v)=>transformHours.in(v) === hour.value, (v)=>hour.value = v);
            const minuteInputFilter = createInputInterceptor(transformMinutesOrSeconds.out, (v)=>transformMinutesOrSeconds.in(v) === minute.value, (v)=>minute.value = v);
            const secondInputFilter = createInputInterceptor(transformMinutesOrSeconds.out, (v)=>transformMinutesOrSeconds.in(v) === second.value, (v)=>second.value = v);
            useRender(()=>{
                return vue.createElementVNode("div", {
                    "class": "v-time-picker-controls"
                }, [
                    vue.createElementVNode("div", {
                        "class": vue.normalizeClass({
                            'v-time-picker-controls__time': true,
                            'v-time-picker-controls__time--with-ampm': props.ampm,
                            'v-time-picker-controls__time--with-seconds': props.useSeconds
                        })
                    }, [
                        vue.createVNode(VTimePickerField, {
                            "ref": hourInputRef,
                            "active": props.viewMode === 'hour',
                            "color": props.color,
                            "disabled": props.disabled,
                            "label": t('$vuetify.timePicker.hour'),
                            "showHint": props.inputHints,
                            "error": isHourValid.value ? undefined : t('$vuetify.timePicker.notAllowed'),
                            "modelValue": hour.value,
                            "onUpdate:modelValue": (v)=>hour.value = v,
                            "onKeydown": onHourFieldKeydown,
                            "onBeforeinput": hourInputFilter,
                            "onFocus": ()=>emit('update:viewMode', 'hour')
                        }, null),
                        vue.createElementVNode("span", {
                            "class": "v-time-picker-controls__time__separator"
                        }, [
                            vue.createTextVNode(":")
                        ]),
                        vue.createVNode(VTimePickerField, {
                            "ref": minuteInputRef,
                            "active": props.viewMode === 'minute',
                            "color": props.color,
                            "disabled": props.disabled,
                            "label": t('$vuetify.timePicker.minute'),
                            "showHint": props.inputHints,
                            "error": isMinuteValid.value ? undefined : t('$vuetify.timePicker.notAllowed'),
                            "modelValue": minute.value,
                            "onUpdate:modelValue": (v)=>minute.value = v,
                            "onKeydown": onMinuteFieldKeydown,
                            "onBeforeinput": minuteInputFilter,
                            "onFocus": ()=>emit('update:viewMode', 'minute')
                        }, null),
                        props.useSeconds && vue.createElementVNode("span", {
                            "key": "secondsDivider",
                            "class": "v-time-picker-controls__time__separator"
                        }, [
                            vue.createTextVNode(":")
                        ]),
                        props.useSeconds && vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VTimePickerField, {
                                "key": "secondsVal",
                                "ref": secondInputRef,
                                "active": props.viewMode === 'second',
                                "color": props.color,
                                "disabled": props.disabled,
                                "label": t('$vuetify.timePicker.second'),
                                "showHint": props.inputHints,
                                "error": isSecondValid.value ? undefined : t('$vuetify.timePicker.notAllowed'),
                                "modelValue": second.value,
                                "onUpdate:modelValue": (v)=>second.value = v,
                                "onKeydown": onSecondFieldKeydown,
                                "onBeforeinput": secondInputFilter,
                                "onFocus": ()=>emit('update:viewMode', 'second')
                            }, null)
                        ]),
                        props.ampm && vue.createElementVNode("div", {
                            "class": "v-time-picker-controls__ampm"
                        }, [
                            vue.createVNode(VBtn, {
                                "active": props.period === 'am',
                                "color": props.period === 'am' ? props.color : undefined,
                                "class": vue.normalizeClass({
                                    'v-time-picker-controls__ampm__am': true,
                                    'v-time-picker-controls__ampm__btn': true,
                                    'v-time-picker-controls__ampm__btn__active': props.period === 'am'
                                }),
                                "disabled": props.disabled,
                                "text": t('$vuetify.timePicker.am'),
                                "variant": props.disabled && props.period === 'am' ? 'elevated' : 'tonal',
                                "onClick": ()=>props.period !== 'am' ? setPeriod('am') : null
                            }, null),
                            vue.createVNode(VBtn, {
                                "active": props.period === 'pm',
                                "color": props.period === 'pm' ? props.color : undefined,
                                "class": vue.normalizeClass({
                                    'v-time-picker-controls__ampm__pm': true,
                                    'v-time-picker-controls__ampm__btn': true,
                                    'v-time-picker-controls__ampm__btn__active': props.period === 'pm'
                                }),
                                "disabled": props.disabled,
                                "text": t('$vuetify.timePicker.pm'),
                                "variant": props.disabled && props.period === 'pm' ? 'elevated' : 'tonal',
                                "onClick": ()=>props.period !== 'pm' ? setPeriod('pm') : null
                            }, null)
                        ])
                    ])
                ]);
            });
            return {};
        }
    });
    // Types
    const makeVTimePickerProps = propsFactory({
        disabled: Boolean,
        format: {
            type: String,
            default: 'ampm'
        },
        viewMode: {
            type: String,
            default: 'hour'
        },
        period: {
            type: String,
            default: 'am',
            validator: (v)=>[
                    'am',
                    'pm'
                ].includes(v)
        },
        modelValue: null,
        readonly: Boolean,
        scrollable: Boolean,
        useSeconds: Boolean,
        variant: {
            type: String,
            default: 'dial'
        },
        ...makeTimeValidationProps(),
        ...omit(makeVPickerProps({
            title: '$vuetify.timePicker.title'
        }), [
            'landscape'
        ]),
        ...makeDensityProps()
    }, 'VTimePicker');
    const VTimePicker = genericComponent()({
        name: 'VTimePicker',
        props: makeVTimePickerProps(),
        emits: {
            'update:hour': (val)=>true,
            'update:minute': (val)=>true,
            'update:period': (val)=>true,
            'update:second': (val)=>true,
            'update:modelValue': (val)=>true,
            'update:viewMode': (val)=>true
        },
        setup (props, { emit: emit, slots: slots }) {
            const { t: t } = useLocale();
            const { densityClasses: densityClasses } = useDensity(props);
            const inputHour = vue.ref(null);
            const inputMinute = vue.ref(null);
            const inputSecond = vue.ref(null);
            const lazyInputHour = vue.ref(null);
            const lazyInputMinute = vue.ref(null);
            const lazyInputSecond = vue.ref(null);
            const period = useProxiedModel(props, 'period', 'am');
            const viewMode = useProxiedModel(props, 'viewMode', 'hour');
            const controlsRef = vue.ref(null);
            const clockRef = vue.ref(null);
            const isAmPm = vue.computed(()=>{
                return props.format === 'ampm';
            });
            const { isAllowedHour: isAllowedHour, isAllowedMinute: isAllowedMinute, isAllowedSecond: isAllowedSecond } = useTimeValidation(props);
            const shouldClear = vue.toRef(()=>{
                return props.modelValue !== null && inputHour.value === null && inputMinute.value === null && (!props.useSeconds || inputSecond.value === null);
            });
            function emitValue() {
                const value = genValue();
                if (value !== null && value !== props.modelValue) emit('update:modelValue', value);
                if (shouldClear.value) emit('update:modelValue', null);
            }
            vue.watch(inputHour, emitValue);
            vue.watch(inputMinute, emitValue);
            vue.watch(inputSecond, emitValue);
            vue.watch(period, (newPeriod, oldPeriod)=>{
                if (inputHour.value == null || newPeriod === oldPeriod) return;
                if (newPeriod === 'pm' && inputHour.value < 12) inputHour.value = inputHour.value + 12;
                else if (newPeriod === 'am' && inputHour.value >= 12) inputHour.value = inputHour.value - 12;
            });
            vue.watch(()=>props.modelValue, (val)=>setInputData(val));
            vue.watch(()=>props.useSeconds, (val, old)=>{
                if (old && !val && viewMode.value === 'second') viewMode.value = 'minute';
                if (!val && inputSecond.value !== null) inputSecond.value = null;
            });
            vue.onMounted(()=>{
                setInputData(props.modelValue);
            });
            function genValue() {
                if (inputHour.value != null && inputMinute.value != null && (!props.useSeconds || inputSecond.value != null)) return `${pad(inputHour.value)}:${pad(inputMinute.value)}` + (props.useSeconds ? `:${pad(inputSecond.value)}` : '');
                return null;
            }
            function setInputData(value) {
                if (value == null || value === '') {
                    inputHour.value = null;
                    inputMinute.value = null;
                    inputSecond.value = null;
                } else if (value instanceof Date) {
                    inputHour.value = value.getHours();
                    inputMinute.value = value.getMinutes();
                    inputSecond.value = value.getSeconds();
                } else {
                    const [hour, , minute, , second, period] = value.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6);
                    inputHour.value = period ? convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
                    inputMinute.value = parseInt(minute, 10);
                    inputSecond.value = parseInt(second || 0, 10);
                }
                period.value = inputHour.value == null || inputHour.value < 12 ? 'am' : 'pm';
            }
            function onInput(value) {
                if (viewMode.value === 'hour') inputHour.value = isAmPm.value ? convert12to24(value, period.value) : value;
                else if (viewMode.value === 'minute') inputMinute.value = value;
                else inputSecond.value = value;
            }
            function onChange(value) {
                switch(viewMode.value || 'hour'){
                    case 'hour':
                        emit('update:hour', value);
                        break;
                    case 'minute':
                        emit('update:minute', value);
                        break;
                    case 'second':
                        emit('update:second', value);
                        break;
                }
                const emitChange = inputHour.value !== null && inputMinute.value !== null && (props.useSeconds ? inputSecond.value !== null : true);
                if (viewMode.value === 'hour') viewMode.value = 'minute';
                else if (props.useSeconds && viewMode.value === 'minute') viewMode.value = 'second';
                if (inputHour.value === lazyInputHour.value && inputMinute.value === lazyInputMinute.value && (!props.useSeconds || inputSecond.value === lazyInputSecond.value)) return;
                const time = genValue();
                if (time === null) return;
                lazyInputHour.value = inputHour.value;
                lazyInputMinute.value = inputMinute.value;
                props.useSeconds && (lazyInputSecond.value = inputSecond.value);
                emitChange && emitValue();
            }
            useRender(()=>{
                const pickerProps = omit(VPicker.filterProps(props), [
                    'hideHeader'
                ]);
                const timePickerControlsProps = VTimePickerControls.filterProps(props);
                const timePickerClockProps = VTimePickerClock.filterProps(omit(props, [
                    'format',
                    'modelValue',
                    'min',
                    'max'
                ]));
                const clockValidation = viewMode.value === 'hour' ? isAllowedHour.value : viewMode.value === 'minute' ? (v)=>isAllowedMinute.value(inputHour.value, v) : (v)=>isAllowedSecond.value(inputHour.value, inputMinute.value, v);
                return vue.createVNode(VPicker, vue.mergeProps(pickerProps, {
                    "color": undefined,
                    "class": [
                        'v-time-picker',
                        `v-time-picker--variant-${props.variant}`,
                        props.class,
                        densityClasses.value
                    ],
                    "hideHeader": props.hideHeader && props.variant !== 'input',
                    "style": props.style
                }), {
                    title: ()=>slots.title?.() ?? vue.createElementVNode("div", {
                            "class": "v-time-picker__title"
                        }, [
                            t(props.title)
                        ]),
                    header: ()=>vue.createVNode(VTimePickerControls, vue.mergeProps(timePickerControlsProps, {
                            "ampm": isAmPm.value,
                            "hour": inputHour.value,
                            "minute": inputMinute.value,
                            "period": period.value,
                            "second": inputSecond.value,
                            "viewMode": viewMode.value,
                            "inputHints": props.variant === 'input',
                            "onUpdate:hour": (val)=>inputHour.value = val,
                            "onUpdate:minute": (val)=>inputMinute.value = val,
                            "onUpdate:second": (val)=>inputSecond.value = val,
                            "onUpdate:period": (val)=>period.value = val,
                            "onUpdate:viewMode": (value)=>viewMode.value = value,
                            "ref": controlsRef
                        }), null),
                    default: ()=>vue.createVNode(VTimePickerClock, vue.mergeProps(timePickerClockProps, {
                            "allowedValues": clockValidation,
                            "double": viewMode.value === 'hour' && !isAmPm.value,
                            "format": viewMode.value === 'hour' ? isAmPm.value ? convert24to12 : (val)=>val : (val)=>pad(val, 2),
                            "max": viewMode.value === 'hour' ? isAmPm.value && period.value === 'am' ? 11 : 23 : 59,
                            "min": viewMode.value === 'hour' && isAmPm.value && period.value === 'pm' ? 12 : 0,
                            "size": 20,
                            "step": viewMode.value === 'hour' ? 1 : 5,
                            "modelValue": viewMode.value === 'hour' ? inputHour.value : viewMode.value === 'minute' ? inputMinute.value : inputSecond.value,
                            "onChange": onChange,
                            "onInput": onInput,
                            "ref": clockRef
                        }), null),
                    actions: slots.actions
                });
            });
        }
    });
    const makeVToolbarItemsProps = propsFactory({
        ...makeComponentProps(),
        ...makeVariantProps({
            variant: 'text'
        })
    }, 'VToolbarItems');
    const VToolbarItems = genericComponent()({
        name: 'VToolbarItems',
        props: makeVToolbarItemsProps(),
        setup (props, { slots: slots }) {
            provideDefaults({
                VBtn: {
                    color: vue.toRef(()=>props.color),
                    height: 'inherit',
                    variant: vue.toRef(()=>props.variant)
                }
            });
            useRender(()=>vue.createElementVNode("div", {
                    "class": vue.normalizeClass([
                        'v-toolbar-items',
                        props.class
                    ]),
                    "style": vue.normalizeStyle(props.style)
                }, [
                    slots.default?.()
                ]));
            return {};
        }
    });
    // Types
    const makeVTreeviewGroupProps = propsFactory({
        ...omit(makeVListGroupProps({
            collapseIcon: '$treeviewCollapse',
            expandIcon: '$treeviewExpand'
        }), [
            'subgroup'
        ])
    }, 'VTreeviewGroup');
    const VTreeviewGroup = genericComponent()({
        name: 'VTreeviewGroup',
        props: makeVTreeviewGroupProps(),
        setup (props, { slots: slots }) {
            const vListGroupRef = vue.ref();
            const toggleIcon = vue.computed(()=>vListGroupRef.value?.isOpen ? props.collapseIcon : props.expandIcon);
            const activatorDefaults = vue.computed(()=>({
                    VTreeviewItem: {
                        prependIcon: undefined,
                        appendIcon: undefined,
                        toggleIcon: toggleIcon.value
                    }
                }));
            useRender(()=>{
                const listGroupProps = VListGroup.filterProps(props);
                return vue.createVNode(VListGroup, vue.mergeProps(listGroupProps, {
                    "ref": vListGroupRef,
                    "class": [
                        'v-treeview-group',
                        props.class
                    ],
                    "subgroup": true
                }), {
                    ...slots,
                    activator: slots.activator ? (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                            vue.createVNode(VDefaultsProvider, {
                                "defaults": activatorDefaults.value
                            }, {
                                default: ()=>[
                                        slots.activator?.(slotProps)
                                    ]
                            })
                        ]) : undefined
                });
            });
            return {};
        }
    });
    // Types
    const VTreeviewSymbol = Symbol.for('vuetify:v-treeview');
    // Types
    const makeVTreeviewItemProps = propsFactory({
        loading: Boolean,
        hideActions: Boolean,
        hasCustomPrepend: Boolean,
        indentLines: Array,
        toggleIcon: IconValue,
        ...makeVListItemProps({
            slim: true
        })
    }, 'VTreeviewItem');
    const VTreeviewItem = genericComponent()({
        name: 'VTreeviewItem',
        props: makeVTreeviewItemProps(),
        emits: {
            toggleExpand: (value)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            const visibleIds = vue.inject(VTreeviewSymbol, {
                visibleIds: vue.ref()
            }).visibleIds;
            const vListItemRef = vue.ref();
            const isActivatableGroupActivator = vue.computed(()=>vListItemRef.value?.root.activatable.value && vListItemRef.value?.isGroupActivator);
            const isActivatable = vue.computed(()=>!props.disabled && props.link !== false && isActivatableGroupActivator.value);
            const isFiltered = vue.computed(()=>visibleIds.value && !visibleIds.value.has(vue.toRaw(vListItemRef.value?.id)));
            function activateGroupActivator(e) {
                vListItemRef.value?.activate(!vListItemRef.value?.isActivated, e);
            }
            function onClickAction(e) {
                e.preventDefault();
                e.stopPropagation();
                emit('toggleExpand', e);
            }
            useRender(()=>{
                const listItemProps = VListItem.filterProps(props);
                const hasPrepend = slots.prepend || props.toggleIcon || props.indentLines || props.prependIcon || props.prependAvatar;
                return vue.createVNode(VListItem, vue.mergeProps({
                    "ref": vListItemRef
                }, listItemProps, {
                    "active": vListItemRef.value?.isActivated || undefined,
                    "class": [
                        'v-treeview-item',
                        {
                            'v-treeview-item--activatable-group-activator': isActivatableGroupActivator.value,
                            'v-treeview-item--filtered': isFiltered.value
                        },
                        props.class
                    ],
                    "role": "treeitem",
                    "ripple": false,
                    "onClick": isActivatable.value ? activateGroupActivator : undefined
                }), {
                    ...slots,
                    prepend: hasPrepend ? (slotProps)=>{
                        return vue.createElementVNode(vue.Fragment, null, [
                            props.indentLines && props.indentLines.length > 0 ? vue.createElementVNode("div", {
                                "key": "indent-lines",
                                "class": "v-treeview-indent-lines",
                                "style": {
                                    '--v-indent-parts': props.indentLines.length
                                }
                            }, [
                                props.indentLines.map((type)=>vue.createElementVNode("div", {
                                        "class": vue.normalizeClass(`v-treeview-indent-line v-treeview-indent-line--${type}`)
                                    }, null))
                            ]) : '',
                            !props.hideActions && vue.createVNode(VListItemAction, {
                                "start": true
                            }, {
                                default: ()=>[
                                        props.toggleIcon ? vue.createElementVNode(vue.Fragment, null, [
                                            !slots.toggle ? vue.createVNode(VBtn, {
                                                "key": "prepend-toggle",
                                                "density": "compact",
                                                "icon": props.toggleIcon,
                                                "loading": props.loading,
                                                "variant": "text",
                                                "onClick": onClickAction
                                            }, {
                                                loader: ()=>vue.createVNode(VProgressCircular, {
                                                        "indeterminate": "disable-shrink",
                                                        "size": "20",
                                                        "width": "2"
                                                    }, null)
                                            }) : vue.createVNode(VDefaultsProvider, {
                                                "key": "prepend-defaults",
                                                "defaults": {
                                                    VBtn: {
                                                        density: 'compact',
                                                        icon: props.toggleIcon,
                                                        variant: 'text',
                                                        loading: props.loading
                                                    },
                                                    VProgressCircular: {
                                                        indeterminate: 'disable-shrink',
                                                        size: 20,
                                                        width: 2
                                                    }
                                                }
                                            }, {
                                                default: ()=>[
                                                        slots.toggle({
                                                            ...slotProps,
                                                            loading: props.loading,
                                                            props: {
                                                                onClick: onClickAction
                                                            }
                                                        })
                                                    ]
                                            })
                                        ]) : vue.createElementVNode("div", {
                                            "class": "v-treeview-item__level"
                                        }, null)
                                    ]
                            }),
                            !props.hasCustomPrepend ? vue.createElementVNode(vue.Fragment, null, [
                                slots.prepend?.(slotProps),
                                props.prependAvatar && vue.createVNode(VAvatar, {
                                    "key": "prepend-avatar",
                                    "density": props.density,
                                    "image": props.prependAvatar
                                }, null),
                                props.prependIcon && vue.createVNode(VIcon, {
                                    "key": "prepend-icon",
                                    "density": props.density,
                                    "icon": props.prependIcon
                                }, null)
                            ]) : vue.createVNode(VDefaultsProvider, {
                                "key": "prepend-defaults",
                                "defaults": {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.appendIcon
                                    },
                                    VListItemAction: {
                                        start: true
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.prepend?.(slotProps)
                                    ]
                            })
                        ]);
                    } : undefined
                });
            });
            return forwardRefs({}, vListItemRef);
        }
    });
    // Types
    const makeVTreeviewChildrenProps = propsFactory({
        fluid: Boolean,
        disabled: Boolean,
        loadChildren: Function,
        loadingIcon: {
            type: String,
            default: '$loading'
        },
        items: Array,
        openOnClick: {
            type: Boolean,
            default: undefined
        },
        indeterminateIcon: {
            type: IconValue,
            default: '$checkboxIndeterminate'
        },
        falseIcon: IconValue,
        trueIcon: IconValue,
        returnObject: Boolean,
        activatable: Boolean,
        selectable: Boolean,
        selectedColor: String,
        selectStrategy: [
            String,
            Function,
            Object
        ],
        index: Number,
        isLastGroup: Boolean,
        separateRoots: Boolean,
        parentIndentLines: Array,
        indentLinesVariant: String,
        path: {
            type: Array,
            default: ()=>[]
        },
        ...pick(makeVTreeviewItemProps(), [
            'hideActions'
        ]),
        ...makeDensityProps()
    }, 'VTreeviewChildren');
    const VTreeviewChildren = genericComponent()({
        name: 'VTreeviewChildren',
        props: makeVTreeviewChildrenProps(),
        setup (props, { slots: slots }) {
            const isLoading = vue.reactive(new Set());
            const activatorItems = vue.ref([]);
            const isClickOnOpen = vue.computed(()=>!props.disabled && (props.openOnClick != null ? props.openOnClick : props.selectable && !props.activatable));
            async function checkChildren(item) {
                try {
                    if (!props.items?.length || !props.loadChildren) return;
                    if (item?.children?.length === 0) {
                        isLoading.add(item.value);
                        await props.loadChildren(item.raw);
                    }
                } finally{
                    isLoading.delete(item.value);
                }
            }
            function selectItem(select, isSelected) {
                if (props.selectable) select(isSelected);
            }
            return ()=>slots.default?.() ?? props.items?.map((item, index, items)=>{
                    const { children: children, props: itemProps } = item;
                    const loading = isLoading.has(item.value);
                    const nextItemHasChildren = !!items.at(index + 1)?.children;
                    const depth = props.path?.length ?? 0;
                    const isLast = items.length - 1 === index;
                    const nodePositionProps = {
                        index: index,
                        depth: depth,
                        isFirst: index === 0,
                        isLast: isLast,
                        path: [
                            ...props.path,
                            index
                        ]
                    };
                    const indentLines = getIndentLines({
                        depth: depth,
                        isLast: isLast,
                        isLastGroup: props.isLastGroup,
                        leafLinks: !props.hideActions && !props.fluid,
                        separateRoots: props.separateRoots,
                        parentIndentLines: props.parentIndentLines,
                        variant: props.indentLinesVariant
                    });
                    const treeItemProps = {
                        ...itemProps,
                        hideActions: props.hideActions,
                        indentLines: children ? indentLines.node : indentLines.leaf
                    };
                    const slotsWithItem = {
                        toggle: slots.toggle ? (slotProps)=>slots.toggle?.({
                                ...slotProps,
                                ...nodePositionProps,
                                item: item.raw,
                                internalItem: item,
                                loading: loading
                            }) : undefined,
                        prepend: (slotProps)=>vue.createElementVNode(vue.Fragment, null, [
                                props.selectable && (!children || children && ![
                                    'leaf',
                                    'single-leaf'
                                ].includes(props.selectStrategy)) && vue.createVNode(VListItemAction, {
                                    "start": true
                                }, {
                                    default: ()=>[
                                            vue.createVNode(VCheckboxBtn, {
                                                "key": item.value,
                                                "modelValue": slotProps.isSelected,
                                                "disabled": props.disabled || itemProps.disabled,
                                                "loading": loading,
                                                "color": props.selectedColor,
                                                "density": props.density,
                                                "indeterminate": slotProps.isIndeterminate,
                                                "indeterminateIcon": props.indeterminateIcon,
                                                "falseIcon": props.falseIcon,
                                                "trueIcon": props.trueIcon,
                                                "onUpdate:modelValue": (v)=>selectItem(slotProps.select, v),
                                                "onClick": (e)=>e.stopPropagation(),
                                                "onKeydown": (e)=>{
                                                    if (![
                                                        'Enter',
                                                        'Space'
                                                    ].includes(e.key)) return;
                                                    e.stopPropagation();
                                                    selectItem(slotProps.select, slotProps.isSelected);
                                                }
                                            }, null)
                                        ]
                                }),
                                slots.prepend?.({
                                    ...slotProps,
                                    ...nodePositionProps,
                                    item: item.raw,
                                    internalItem: item
                                })
                            ]),
                        append: slots.append ? (slotProps)=>slots.append?.({
                                ...slotProps,
                                ...nodePositionProps,
                                item: item.raw,
                                internalItem: item
                            }) : undefined,
                        title: slots.title ? (slotProps)=>slots.title?.({
                                ...slotProps,
                                item: item.raw,
                                internalItem: item
                            }) : undefined,
                        subtitle: slots.subtitle ? (slotProps)=>slots.subtitle?.({
                                ...slotProps,
                                item: item.raw,
                                internalItem: item
                            }) : undefined
                    };
                    const treeviewGroupProps = VTreeviewGroup.filterProps(itemProps);
                    const treeviewChildrenProps = VTreeviewChildren.filterProps({
                        ...props,
                        ...nodePositionProps
                    });
                    const footerProps = {
                        hideActions: props.hideActions,
                        indentLines: indentLines.footer
                    };
                    return children ? vue.createVNode(VTreeviewGroup, vue.mergeProps(treeviewGroupProps, {
                        "value": props.returnObject ? item.raw : treeviewGroupProps?.value,
                        "rawId": treeviewGroupProps?.value
                    }), {
                        activator: ({ props: activatorProps, isOpen: isOpen })=>{
                            const listItemProps = {
                                ...treeItemProps,
                                ...activatorProps,
                                value: treeItemProps?.value,
                                ariaExpanded: isOpen,
                                onToggleExpand: [
                                    ()=>checkChildren(item),
                                    activatorProps.onClick
                                ],
                                onClick: props.disabled || treeItemProps.disabled ? undefined : isClickOnOpen.value ? [
                                    ()=>checkChildren(item),
                                    activatorProps.onClick
                                ] : ()=>selectItem(activatorItems.value[index]?.select, !activatorItems.value[index]?.isSelected)
                            };
                            return renderSlot(slots.header, {
                                props: listItemProps,
                                item: item.raw,
                                internalItem: item,
                                loading: loading
                            }, ()=>vue.createVNode(VTreeviewItem, vue.mergeProps({
                                    "ref": (el)=>activatorItems.value[index] = el
                                }, listItemProps, {
                                    "hasCustomPrepend": !!slots.prepend,
                                    "value": props.returnObject ? item.raw : itemProps.value,
                                    "loading": loading
                                }), slotsWithItem));
                        },
                        default: ()=>vue.createElementVNode(vue.Fragment, null, [
                                vue.createVNode(VTreeviewChildren, vue.mergeProps(treeviewChildrenProps, {
                                    "items": children,
                                    "indentLinesVariant": props.indentLinesVariant,
                                    "parentIndentLines": indentLines.children,
                                    "isLastGroup": nextItemHasChildren,
                                    "returnObject": props.returnObject
                                }), slots),
                                slots.footer?.({
                                    props: footerProps,
                                    item: item.raw,
                                    internalItem: item,
                                    loading: loading
                                })
                            ])
                    }) : renderSlot(slots.item, {
                        props: treeItemProps,
                        item: item.raw,
                        internalItem: item,
                        ...nodePositionProps
                    }, ()=>{
                        if (item.type === 'divider') return renderSlot(slots.divider, {
                            props: item.raw
                        }, ()=>vue.createVNode(VDivider, item.props, null));
                        if (item.type === 'subheader') return renderSlot(slots.subheader, {
                            props: item.raw
                        }, ()=>vue.createVNode(VListSubheader, item.props, null));
                        return vue.createVNode(VTreeviewItem, vue.mergeProps(treeItemProps, {
                            "hasCustomPrepend": !!slots.prepend,
                            "value": props.returnObject ? vue.toRaw(item.raw) : treeItemProps.value
                        }), slotsWithItem);
                    });
                });
        }
    });
    function flatten(items, flat = []) {
        for (const item of items){
            flat.push(item);
            if (item.children) flatten(item.children, flat);
        }
        return flat;
    }
    const makeVTreeviewProps = propsFactory({
        openAll: Boolean,
        indentLines: [
            Boolean,
            String
        ],
        indentLinesColor: String,
        indentLinesOpacity: [
            String,
            Number
        ],
        search: String,
        hideNoData: Boolean,
        noDataText: {
            type: String,
            default: '$vuetify.noDataText'
        },
        ...makeFilterProps({
            filterKeys: [
                'title'
            ]
        }),
        ...omit(makeVTreeviewChildrenProps(), [
            'index',
            'path',
            'indentLinesVariant',
            'parentIndentLines',
            'isLastGroup'
        ]),
        ...omit(makeVListProps({
            collapseIcon: '$treeviewCollapse',
            expandIcon: '$treeviewExpand',
            slim: true
        }), [
            'nav',
            'openStrategy'
        ]),
        modelValue: Array
    }, 'VTreeview');
    const VTreeview = genericComponent()({
        name: 'VTreeview',
        props: makeVTreeviewProps(),
        emits: {
            'update:opened': (val)=>true,
            'update:activated': (val)=>true,
            'update:selected': (val)=>true,
            'update:modelValue': (val)=>true,
            'click:open': (value)=>true,
            'click:select': (value)=>true
        },
        setup (props, { slots: slots, emit: emit }) {
            const { t: t } = useLocale();
            const { items: items } = useListItems(props);
            const activeColor = vue.toRef(()=>props.activeColor);
            const baseColor = vue.toRef(()=>props.baseColor);
            const color = vue.toRef(()=>props.color);
            const activated = useProxiedModel(props, 'activated');
            const _selected = useProxiedModel(props, 'selected');
            const selected = vue.computed({
                get: ()=>props.modelValue ?? _selected.value,
                set (val) {
                    _selected.value = val;
                    emit('update:modelValue', val);
                }
            });
            const vListRef = vue.ref();
            const opened = vue.computed(()=>props.openAll ? openAll(items.value) : props.opened);
            const flatItems = vue.computed(()=>flatten(items.value));
            const search = vue.toRef(()=>props.search);
            const { filteredItems: filteredItems } = useFilter(props, flatItems, search);
            const visibleIds = vue.computed(()=>{
                if (!search.value) return null;
                const getPath = vListRef.value?.getPath;
                if (!getPath) return null;
                return new Set(filteredItems.value.flatMap((item)=>{
                    const itemVal = props.returnObject ? item.raw : item.props.value;
                    return [
                        ...getPath(itemVal),
                        ...getChildren(itemVal)
                    ].map(vue.toRaw);
                }));
            });
            function getChildren(id) {
                const arr = [];
                const queue = (vListRef.value?.children.get(vue.toRaw(id)) ?? []).slice();
                while(queue.length){
                    const child = queue.shift();
                    if (!child) continue;
                    arr.push(child);
                    queue.push(...(vListRef.value?.children.get(child) ?? []).slice());
                }
                return arr;
            }
            function openAll(items) {
                let ids = [];
                for (const i of items){
                    if (!i.children) continue;
                    ids.push(props.returnObject ? vue.toRaw(i.raw) : i.value);
                    if (i.children) ids = ids.concat(openAll(i.children));
                }
                return ids;
            }
            vue.provide(VTreeviewSymbol, {
                visibleIds: visibleIds
            });
            provideDefaults({
                VTreeviewGroup: {
                    activeColor: activeColor,
                    baseColor: baseColor,
                    color: color,
                    collapseIcon: vue.toRef(()=>props.collapseIcon),
                    expandIcon: vue.toRef(()=>props.expandIcon)
                },
                VTreeviewItem: {
                    activeClass: vue.toRef(()=>props.activeClass),
                    activeColor: activeColor,
                    baseColor: baseColor,
                    color: color,
                    density: vue.toRef(()=>props.density),
                    disabled: vue.toRef(()=>props.disabled),
                    lines: vue.toRef(()=>props.lines),
                    variant: vue.toRef(()=>props.variant)
                }
            });
            useRender(()=>{
                const listProps = VList.filterProps(props);
                const treeviewChildrenProps = VTreeviewChildren.filterProps(props);
                const indentLinesVariant = typeof props.indentLines === 'boolean' ? 'default' : props.indentLines;
                return vue.createVNode(VList, vue.mergeProps({
                    "ref": vListRef
                }, listProps, {
                    "class": [
                        'v-treeview',
                        {
                            'v-treeview--fluid': props.fluid
                        },
                        props.class
                    ],
                    "role": "tree",
                    "openStrategy": "multiple",
                    "style": [
                        {
                            '--v-treeview-indent-line-color': props.indentLinesColor,
                            '--v-treeview-indent-line-opacity': props.indentLinesOpacity
                        },
                        props.style
                    ],
                    "opened": opened.value,
                    "activated": activated.value,
                    "onUpdate:activated": ($event)=>activated.value = $event,
                    "selected": selected.value,
                    "onUpdate:selected": ($event)=>selected.value = $event
                }), {
                    default: ()=>[
                            visibleIds.value?.size === 0 && !props.hideNoData && (slots['no-data']?.() ?? vue.createVNode(VListItem, {
                                "key": "no-data",
                                "title": t(props.noDataText)
                            }, null)),
                            vue.createVNode(VTreeviewChildren, vue.mergeProps(treeviewChildrenProps, {
                                "density": props.density,
                                "returnObject": props.returnObject,
                                "items": items.value,
                                "parentIndentLines": props.indentLines ? [] : undefined,
                                "indentLinesVariant": indentLinesVariant
                            }), slots)
                        ]
                });
            });
            return {};
        }
    });
    // Composables
    // Types
    const VValidation = genericComponent()({
        name: 'VValidation',
        props: makeValidationProps(),
        emits: {
            'update:modelValue': (value)=>true
        },
        setup (props, { slots: slots }) {
            const validation = useValidation(props, 'validation');
            return ()=>slots.default?.(validation);
        }
    });
    var components = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        VAlert: VAlert,
        VAlertTitle: VAlertTitle,
        VApp: VApp,
        VAppBar: VAppBar,
        VAppBarNavIcon: VAppBarNavIcon,
        VAppBarTitle: VAppBarTitle,
        VAutocomplete: VAutocomplete,
        VAvatar: VAvatar,
        VBadge: VBadge,
        VBanner: VBanner,
        VBannerActions: VBannerActions,
        VBannerText: VBannerText,
        VBottomNavigation: VBottomNavigation,
        VBottomSheet: VBottomSheet,
        VBreadcrumbs: VBreadcrumbs,
        VBreadcrumbsDivider: VBreadcrumbsDivider,
        VBreadcrumbsItem: VBreadcrumbsItem,
        VBtn: VBtn,
        VBtnGroup: VBtnGroup,
        VBtnToggle: VBtnToggle,
        VCalendar: VCalendar,
        VCard: VCard,
        VCardActions: VCardActions,
        VCardItem: VCardItem,
        VCardSubtitle: VCardSubtitle,
        VCardText: VCardText,
        VCardTitle: VCardTitle,
        VCarousel: VCarousel,
        VCarouselItem: VCarouselItem,
        VCheckbox: VCheckbox,
        VCheckboxBtn: VCheckboxBtn,
        VChip: VChip,
        VChipGroup: VChipGroup,
        VClassIcon: VClassIcon,
        VCode: VCode,
        VCol: VCol,
        VColorInput: VColorInput,
        VColorPicker: VColorPicker,
        VCombobox: VCombobox,
        VComponentIcon: VComponentIcon,
        VConfirmEdit: VConfirmEdit,
        VContainer: VContainer,
        VCounter: VCounter,
        VDataIterator: VDataIterator,
        VDataTable: VDataTable,
        VDataTableFooter: VDataTableFooter,
        VDataTableHeaders: VDataTableHeaders,
        VDataTableRow: VDataTableRow,
        VDataTableRows: VDataTableRows,
        VDataTableServer: VDataTableServer,
        VDataTableVirtual: VDataTableVirtual,
        VDateInput: VDateInput,
        VDatePicker: VDatePicker,
        VDatePickerControls: VDatePickerControls,
        VDatePickerHeader: VDatePickerHeader,
        VDatePickerMonth: VDatePickerMonth,
        VDatePickerMonths: VDatePickerMonths,
        VDatePickerYears: VDatePickerYears,
        VDefaultsProvider: VDefaultsProvider,
        VDialog: VDialog,
        VDialogBottomTransition: VDialogBottomTransition,
        VDialogTopTransition: VDialogTopTransition,
        VDialogTransition: VDialogTransition,
        VDivider: VDivider,
        VEmptyState: VEmptyState,
        VExpandBothTransition: VExpandBothTransition,
        VExpandTransition: VExpandTransition,
        VExpandXTransition: VExpandXTransition,
        VExpansionPanel: VExpansionPanel,
        VExpansionPanelText: VExpansionPanelText,
        VExpansionPanelTitle: VExpansionPanelTitle,
        VExpansionPanels: VExpansionPanels,
        VFab: VFab,
        VFabTransition: VFabTransition,
        VFadeTransition: VFadeTransition,
        VField: VField,
        VFieldLabel: VFieldLabel,
        VFileInput: VFileInput,
        VFileUpload: VFileUpload,
        VFileUploadDropzone: VFileUploadDropzone,
        VFileUploadItem: VFileUploadItem,
        VFileUploadList: VFileUploadList,
        VFooter: VFooter,
        VForm: VForm,
        VHotkey: VHotkey,
        VHover: VHover,
        VIcon: VIcon,
        VIconBtn: VIconBtn,
        VImg: VImg,
        VInfiniteScroll: VInfiniteScroll,
        VInput: VInput,
        VItem: VItem,
        VItemGroup: VItemGroup,
        VKbd: VKbd,
        VLabel: VLabel,
        VLayout: VLayout,
        VLayoutItem: VLayoutItem,
        VLazy: VLazy,
        VLigatureIcon: VLigatureIcon,
        VList: VList,
        VListGroup: VListGroup,
        VListImg: VListImg,
        VListItem: VListItem,
        VListItemAction: VListItemAction,
        VListItemMedia: VListItemMedia,
        VListItemSubtitle: VListItemSubtitle,
        VListItemTitle: VListItemTitle,
        VListSubheader: VListSubheader,
        VLocaleProvider: VLocaleProvider,
        VMain: VMain,
        VMenu: VMenu,
        VMessages: VMessages,
        VNavigationDrawer: VNavigationDrawer,
        VNoSsr: VNoSsr,
        VNumberInput: VNumberInput,
        VOtpField: VOtpField,
        VOtpGroup: VOtpGroup,
        VOtpInput: VOtpInput,
        VOtpSeparator: VOtpSeparator,
        VOverlay: VOverlay,
        VPagination: VPagination,
        VParallax: VParallax,
        VPicker: VPicker,
        VPickerTitle: VPickerTitle,
        VProgressCircular: VProgressCircular,
        VProgressLinear: VProgressLinear,
        VPullToRefresh: VPullToRefresh,
        VRadio: VRadio,
        VRadioGroup: VRadioGroup,
        VRangeSlider: VRangeSlider,
        VRating: VRating,
        VResponsive: VResponsive,
        VRow: VRow,
        VScaleTransition: VScaleTransition,
        VScrollXReverseTransition: VScrollXReverseTransition,
        VScrollXTransition: VScrollXTransition,
        VScrollYReverseTransition: VScrollYReverseTransition,
        VScrollYTransition: VScrollYTransition,
        VSelect: VSelect,
        VSelectionControl: VSelectionControl,
        VSelectionControlGroup: VSelectionControlGroup,
        VSheet: VSheet,
        VSkeletonLoader: VSkeletonLoader,
        VSlideGroup: VSlideGroup,
        VSlideGroupItem: VSlideGroupItem,
        VSlideXReverseTransition: VSlideXReverseTransition,
        VSlideXTransition: VSlideXTransition,
        VSlideYReverseTransition: VSlideYReverseTransition,
        VSlideYTransition: VSlideYTransition,
        VSlider: VSlider,
        VSnackbar: VSnackbar,
        VSnackbarQueue: VSnackbarQueue,
        VSpacer: VSpacer,
        VSparkline: VSparkline,
        VSparklineTooltip: VSparklineTooltip,
        VSpeedDial: VSpeedDial,
        VStepper: VStepper,
        VStepperActions: VStepperActions,
        VStepperHeader: VStepperHeader,
        VStepperItem: VStepperItem,
        VStepperVertical: VStepperVertical,
        VStepperVerticalActions: VStepperVerticalActions,
        VStepperVerticalItem: VStepperVerticalItem,
        VStepperWindow: VStepperWindow,
        VStepperWindowItem: VStepperWindowItem,
        VSvgIcon: VSvgIcon,
        VSwitch: VSwitch,
        VSystemBar: VSystemBar,
        VTab: VTab,
        VTable: VTable,
        VTabs: VTabs,
        VTabsWindow: VTabsWindow,
        VTabsWindowItem: VTabsWindowItem,
        VTextField: VTextField,
        VTextarea: VTextarea,
        VThemeProvider: VThemeProvider,
        VTimePicker: VTimePicker,
        VTimePickerClock: VTimePickerClock,
        VTimePickerControls: VTimePickerControls,
        VTimeline: VTimeline,
        VTimelineItem: VTimelineItem,
        VToolbar: VToolbar,
        VToolbarItems: VToolbarItems,
        VToolbarTitle: VToolbarTitle,
        VTooltip: VTooltip,
        VTreeview: VTreeview,
        VTreeviewGroup: VTreeviewGroup,
        VTreeviewItem: VTreeviewItem,
        VValidation: VValidation,
        VVirtualScroll: VVirtualScroll,
        VWindow: VWindow,
        VWindowItem: VWindowItem
    });
    // Types
    function mounted$1(el, binding) {
        const modifiers = binding.modifiers || {};
        const value = binding.value;
        const { once: once, immediate: immediate, ...modifierKeys } = modifiers;
        const defaultValue = !Object.keys(modifierKeys).length;
        const { handler: handler, options: options } = typeof value === 'object' ? value : {
            handler: value,
            options: {
                attributes: modifierKeys?.attr ?? defaultValue,
                characterData: modifierKeys?.char ?? defaultValue,
                childList: modifierKeys?.child ?? defaultValue,
                subtree: modifierKeys?.sub ?? defaultValue
            }
        };
        const observer = new MutationObserver((mutations = [], observer)=>{
            handler?.(mutations, observer);
            if (once) unmounted$1(el, binding);
        });
        if (immediate) handler?.([], observer);
        el._mutate = Object(el._mutate);
        el._mutate[binding.instance.$.uid] = {
            observer: observer
        };
        observer.observe(el, options);
    }
    function unmounted$1(el, binding) {
        if (!el._mutate?.[binding.instance.$.uid]) return;
        el._mutate[binding.instance.$.uid].observer.disconnect();
        delete el._mutate[binding.instance.$.uid];
    }
    const Mutate = {
        mounted: mounted$1,
        unmounted: unmounted$1
    };
    // Types
    function mounted(el, binding) {
        const { self: self = false } = binding.modifiers ?? {};
        const value = binding.value;
        const options = typeof value === 'object' && value.options || {
            passive: true
        };
        const handler = typeof value === 'function' || 'handleEvent' in value ? value : value.handler;
        const target = self ? el : binding.arg ? document.querySelector(binding.arg) : window;
        if (!target) return;
        target.addEventListener('scroll', handler, options);
        el._onScroll = Object(el._onScroll);
        el._onScroll[binding.instance.$.uid] = {
            handler: handler,
            options: options,
            // Don't reference self
            target: self ? undefined : target
        };
    }
    function unmounted(el, binding) {
        if (!el._onScroll?.[binding.instance.$.uid]) return;
        const { handler: handler, options: options, target: target = el } = el._onScroll[binding.instance.$.uid];
        target.removeEventListener('scroll', handler, options);
        delete el._onScroll[binding.instance.$.uid];
    }
    function updated(el, binding) {
        if (binding.value === binding.oldValue) return;
        unmounted(el, binding);
        mounted(el, binding);
    }
    const Scroll = {
        mounted: mounted,
        unmounted: unmounted,
        updated: updated
    };
    // Utilities
    // Types
    function useDirectiveComponent(component, props) {
        const concreteComponent = typeof component === 'string' ? vue.resolveComponent(component) : component;
        const hook = mountComponent(concreteComponent, props);
        return {
            mounted: hook,
            updated: hook,
            unmounted (el) {
                vue.render(null, el);
            }
        };
    }
    function mountComponent(component, props) {
        return function(el, binding, vnode) {
            const _props = typeof props === 'function' ? props(binding) : props;
            const text = binding.value?.text ?? binding.value ?? _props?.text;
            const value = isObject(binding.value) ? binding.value : {};
            // Get the children from the props or directive value, or the element's children
            const children = ()=>text ?? el.textContent;
            // If vnode.ctx is the same as the instance, then we're bound to a plain element
            // and need to find the nearest parent component instance to inherit provides from
            const provides = (vnode.ctx === binding.instance.$ ? findComponentParent(vnode, binding.instance.$)?.provides : vnode.ctx?.provides) ?? binding.instance.$.provides;
            const node = vue.h(component, vue.mergeProps(_props, value), children);
            node.appContext = Object.assign(Object.create(null), binding.instance.$.appContext, {
                provides: provides
            });
            vue.render(node, el);
        };
    }
    function findComponentParent(vnode, root) {
        // Walk the tree from root until we find the child vnode
        const stack = new Set();
        const walk = (children)=>{
            for (const child of children){
                if (!child) continue;
                if (child === vnode || child.el && vnode.el && child.el === vnode.el) return true;
                stack.add(child);
                let result;
                if (child.suspense) result = walk([
                    child.ssContent
                ]);
                else if (Array.isArray(child.children)) result = walk(child.children);
                else if (child.component?.vnode) result = walk([
                    child.component?.subTree
                ]);
                if (result) return result;
                stack.delete(child);
            }
            return false;
        };
        if (!walk([
            root.subTree
        ])) {
            consoleError('Could not find original vnode, component will not inherit provides');
            return root;
        }
        // Return the first component parent
        const result = Array.from(stack).reverse();
        for (const child of result){
            if (child.component) return child.component;
        }
        return root;
    }
    // Components
    // Types
    const Tooltip = useDirectiveComponent(VTooltip, (binding)=>{
        const disabled = isObject(binding.value) ? !binding.value.text : [
            '',
            false,
            null
        ].includes(binding.value); // undefined means true
        return {
            activator: disabled ? null : 'parent',
            location: binding.arg?.replace('-', ' '),
            text: typeof binding.value === 'boolean' ? undefined : binding.value
        };
    });
    var directives = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ClickOutside: ClickOutside,
        Intersect: Intersect,
        Mutate: Mutate,
        Resize: Resize,
        Ripple: Ripple,
        Scroll: Scroll,
        Tooltip: Tooltip,
        Touch: Touch
    });
    // Composables
    // Types
    function genDefaults() {
        return {
            svg: {
                component: VSvgIcon
            },
            class: {
                component: VClassIcon
            }
        };
    }
    function createIcons(options) {
        const sets = genDefaults();
        const defaultSet = options?.defaultSet ?? 'mdi';
        if (defaultSet === 'mdi' && !sets.mdi) sets.mdi = mdi;
        return mergeDeep({
            defaultSet: defaultSet,
            sets: sets,
            aliases: {
                ...aliases,
                /* eslint-disable max-len */ vuetify: [
                    'M8.2241 14.2009L12 21L22 3H14.4459L8.2241 14.2009Z',
                    [
                        'M7.26303 12.4733L7.00113 12L2 3H12.5261C12.5261 3 12.5261 3 12.5261 3L7.26303 12.4733Z',
                        0.6
                    ]
                ],
                'vuetify-outline': 'svg:M7.26 12.47 12.53 3H2L7.26 12.47ZM14.45 3 8.22 14.2 12 21 22 3H14.45ZM18.6 5 12 16.88 10.51 14.2 15.62 5ZM7.26 8.35 5.4 5H9.13L7.26 8.35Z',
                'vuetify-play': [
                    'm6.376 13.184-4.11-7.192C1.505 4.66 2.467 3 4.003 3h8.532l-.953 1.576-.006.01-.396.677c-.429.732-.214 1.507.194 2.015.404.503 1.092.878 1.869.806a3.72 3.72 0 0 1 1.005.022c.276.053.434.143.523.237.138.146.38.635-.25 2.09-.893 1.63-1.553 1.722-1.847 1.677-.213-.033-.468-.158-.756-.406a4.95 4.95 0 0 1-.8-.927c-.39-.564-1.04-.84-1.66-.846-.625-.006-1.316.27-1.693.921l-.478.826-.911 1.506Z',
                    [
                        'M9.093 11.552c.046-.079.144-.15.32-.148a.53.53 0 0 1 .43.207c.285.414.636.847 1.046 1.2.405.35.914.662 1.516.754 1.334.205 2.502-.698 3.48-2.495l.014-.028.013-.03c.687-1.574.774-2.852-.005-3.675-.37-.391-.861-.586-1.333-.676a5.243 5.243 0 0 0-1.447-.044c-.173.016-.393-.073-.54-.257-.145-.18-.127-.316-.082-.392l.393-.672L14.287 3h5.71c1.536 0 2.499 1.659 1.737 2.992l-7.997 13.996c-.768 1.344-2.706 1.344-3.473 0l-3.037-5.314 1.377-2.278.004-.006.004-.007.481-.831Z',
                        0.6
                    ]
                ]
            }
        }, options);
    }
    // Composables
    function createVuetify$1(vuetify = {}) {
        const { blueprint: blueprint, ...rest } = vuetify;
        const options = mergeDeep(blueprint, rest);
        const { aliases: aliases = {}, components: components = {}, directives: directives = {} } = options;
        const scope = vue.effectScope();
        return scope.run(()=>{
            const defaults = createDefaults(options.defaults);
            const display = createDisplay(options.display, options.ssr);
            const theme = createTheme(options.theme);
            const icons = createIcons(options.icons);
            const locale = createLocale(options.locale);
            const date = createDate(options.date, locale);
            const goTo = createGoTo(options.goTo, locale);
            function install(app) {
                for(const key in directives)app.directive(key, directives[key]);
                for(const key in components)app.component(key, components[key]);
                for(const key in aliases)app.component(key, defineComponent({
                    ...aliases[key],
                    name: key,
                    aliasName: aliases[key].name
                }));
                const appScope = vue.effectScope();
                appScope.run(()=>{
                    theme.install(app);
                });
                app.onUnmount(()=>appScope.stop());
                app.provide(DefaultsSymbol, defaults);
                app.provide(DisplaySymbol, display);
                app.provide(ThemeSymbol, theme);
                app.provide(IconSymbol, icons);
                app.provide(LocaleSymbol, locale);
                app.provide(DateOptionsSymbol, date.options);
                app.provide(DateAdapterSymbol, date.instance);
                app.provide(GoToSymbol, goTo);
                if (IN_BROWSER && options.ssr) {
                    if (app.$nuxt) app.$nuxt.hook('app:suspense:resolve', ()=>{
                        display.update();
                    });
                    else {
                        const { mount: mount } = app;
                        app.mount = (...args)=>{
                            const vm = mount(...args);
                            vue.nextTick(()=>display.update());
                            app.mount = mount;
                            return vm;
                        };
                    }
                }
                if (typeof __VUE_OPTIONS_API__ !== 'boolean' || __VUE_OPTIONS_API__) app.mixin({
                    computed: {
                        $vuetify () {
                            return vue.reactive({
                                defaults: inject.call(this, DefaultsSymbol),
                                display: inject.call(this, DisplaySymbol),
                                theme: inject.call(this, ThemeSymbol),
                                icons: inject.call(this, IconSymbol),
                                locale: inject.call(this, LocaleSymbol),
                                date: inject.call(this, DateAdapterSymbol)
                            });
                        }
                    }
                });
            }
            function unmount() {
                scope.stop();
            }
            return {
                install: install,
                unmount: unmount,
                defaults: defaults,
                display: display,
                theme: theme,
                icons: icons,
                locale: locale,
                date: date,
                goTo: goTo
            };
        });
    }
    const version$1 = "4.1.11";
    createVuetify$1.version = version$1;
    // Vue's inject() can only be used in setup
    function inject(key) {
        const vm = this.$;
        const provides = vm.parent?.provides ?? vm.vnode.appContext?.provides;
        if (provides && key in provides) return provides[key];
    }
    /* eslint-disable local-rules/sort-imports */ // Types
    const createVuetify = (options = {})=>{
        return createVuetify$1({
            components: components,
            directives: directives,
            ...options
        });
    };
    const version = "4.1.11";
    createVuetify.version = version;
    exports1.blueprints = index;
    exports1.components = components;
    exports1.createVuetify = createVuetify;
    exports1.directives = directives;
    exports1.useDate = useDate;
    exports1.useDefaults = useDefaults;
    exports1.useDisplay = useDisplay;
    exports1.useGoTo = useGoTo;
    exports1.useHotkey = useHotkey;
    exports1.useLayout = useLayout;
    exports1.useLocale = useLocale;
    exports1.useMask = useMask;
    exports1.useRtl = useRtl;
    exports1.useTheme = useTheme;
    exports1.version = version;
});


let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-7ce55e';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ /*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === 'function';


const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = 'plugin:settings:set';



let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}


class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2138e2947b5f69c4$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $55cc2ea2e53f2ca6$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}





function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $e0da45b668fffb6e$export$c22522a4dfa48e9c)();
    const hook = (0, $e0da45b668fffb6e$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $e0da45b668fffb6e$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $5dd8e5d828be8ae1$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


//#region src/utils/env.ts
const $e75a6c24923c03f0$export$3d8c2f653ac9d0b9 = typeof document !== "undefined";
//#endregion
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $e75a6c24923c03f0$export$8743009a87fcb00f = (v)=>v;
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $e75a6c24923c03f0$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $e75a6c24923c03f0$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $e75a6c24923c03f0$var$isRouteComponent(obj.default);
}
const $e75a6c24923c03f0$export$b4171a6734a65d42 = Object.assign;
function $e75a6c24923c03f0$export$9e5f44173e64f162(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $e75a6c24923c03f0$export$3722cfe417b6ed86 = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $e75a6c24923c03f0$export$78acf4525d8a74c4 = Array.isArray;
function $e75a6c24923c03f0$export$dc98b0b04f4c7758(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/warning.ts
function $e75a6c24923c03f0$export$3466f893ebf79586(msg) {
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $e75a6c24923c03f0$var$HASH_RE = /#/g;
const $e75a6c24923c03f0$var$AMPERSAND_RE = /&/g;
const $e75a6c24923c03f0$var$SLASH_RE = /\//g;
const $e75a6c24923c03f0$var$EQUAL_RE = /=/g;
const $e75a6c24923c03f0$var$IM_RE = /\?/g;
const $e75a6c24923c03f0$var$PLUS_RE = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $e75a6c24923c03f0$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $e75a6c24923c03f0$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $e75a6c24923c03f0$var$ENC_CARET_RE = /%5E/g;
const $e75a6c24923c03f0$var$ENC_BACKTICK_RE = /%60/g;
const $e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $e75a6c24923c03f0$var$ENC_PIPE_RE = /%7C/g;
const $e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $e75a6c24923c03f0$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($e75a6c24923c03f0$var$ENC_PIPE_RE, "|").replace($e75a6c24923c03f0$var$ENC_BRACKET_OPEN_RE, "[").replace($e75a6c24923c03f0$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$3a6d5c9ae78a2c08(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE, "{").replace($e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE, "}").replace($e75a6c24923c03f0$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$var$encodeQueryValue(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$PLUS_RE, "%2B").replace($e75a6c24923c03f0$var$ENC_SPACE_RE, "+").replace($e75a6c24923c03f0$var$HASH_RE, "%23").replace($e75a6c24923c03f0$var$AMPERSAND_RE, "%26").replace($e75a6c24923c03f0$var$ENC_BACKTICK_RE, "`").replace($e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE, "{").replace($e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE, "}").replace($e75a6c24923c03f0$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $e75a6c24923c03f0$var$encodeQueryKey(text) {
    return $e75a6c24923c03f0$var$encodeQueryValue(text).replace($e75a6c24923c03f0$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$2329c99376c9d0a4(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$HASH_RE, "%23").replace($e75a6c24923c03f0$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$71cec2538cb2c617(text) {
    return $e75a6c24923c03f0$export$2329c99376c9d0a4(text).replace($e75a6c24923c03f0$var$SLASH_RE, "%2F");
}
function $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $e75a6c24923c03f0$var$TRAILING_SLASH_RE = /\/$/;
const $e75a6c24923c03f0$var$removeTrailingSlash = (path)=>path.replace($e75a6c24923c03f0$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $e75a6c24923c03f0$export$db202ddc8be9136(parseQuery$1, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery$1(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $e75a6c24923c03f0$export$df995fae86a55f06(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(hash)
    };
}
function $e75a6c24923c03f0$export$a07804094c3ecf2d(stringifyQuery$1, path, query, hash = "") {
    const searchText = stringifyQuery$1(query);
    return path + (searchText && "?") + searchText + $e75a6c24923c03f0$export$3a6d5c9ae78a2c08(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $e75a6c24923c03f0$export$ef35774e6d314e91(stringifyQuery$1, location) {
    const query = location.query ? stringifyQuery$1(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $e75a6c24923c03f0$export$e7c866399fa523f5(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $e75a6c24923c03f0$export$d66501df72047452(stringifyQuery$1, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $e75a6c24923c03f0$export$61196ced6d74a310(a.matched[aLastIndex], b.matched[bLastIndex]) && $e75a6c24923c03f0$export$9bb611d729802a56(a.params, b.params) && stringifyQuery$1(a.query) === stringifyQuery$1(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $e75a6c24923c03f0$export$61196ced6d74a310(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $e75a6c24923c03f0$export$9bb611d729802a56(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$e75a6c24923c03f0$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $e75a6c24923c03f0$var$isSameRouteLocationParamsValue(a, b) {
    return $e75a6c24923c03f0$export$78acf4525d8a74c4(a) ? $e75a6c24923c03f0$var$isEquivalentArray(a, b) : $e75a6c24923c03f0$export$78acf4525d8a74c4(b) ? $e75a6c24923c03f0$var$isEquivalentArray(b, a) : a?.valueOf() === b?.valueOf();
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $e75a6c24923c03f0$var$isEquivalentArray(a, b) {
    return $e75a6c24923c03f0$export$78acf4525d8a74c4(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $e75a6c24923c03f0$export$df995fae86a55f06(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $e75a6c24923c03f0$export$56c0d5a1e737357d = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
let $e75a6c24923c03f0$export$342063e11d6c3cad = /* @__PURE__ */ function(NavigationType$1) {
    NavigationType$1["pop"] = "pop";
    NavigationType$1["push"] = "push";
    return NavigationType$1;
}({});
let $e75a6c24923c03f0$export$c4ce752e73470fba = /* @__PURE__ */ function(NavigationDirection$1) {
    NavigationDirection$1["back"] = "back";
    NavigationDirection$1["forward"] = "forward";
    NavigationDirection$1["unknown"] = "";
    return NavigationDirection$1;
}({});
/**
* Starting location for Histories
*/ const $e75a6c24923c03f0$export$ebd11618f299a286 = "";
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $e75a6c24923c03f0$export$3a1a48c8f6ef640e(base) {
    if (!base) {
        if ($e75a6c24923c03f0$export$3d8c2f653ac9d0b9) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $e75a6c24923c03f0$var$removeTrailingSlash(base);
}
const $e75a6c24923c03f0$var$BEFORE_HASH_RE = /^[^#]+#/;
function $e75a6c24923c03f0$export$35e795649ee09318(base, location) {
    return base.replace($e75a6c24923c03f0$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $e75a6c24923c03f0$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $e75a6c24923c03f0$export$e7094788287c5e9b = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $e75a6c24923c03f0$export$96f57966bedc81b4(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $e75a6c24923c03f0$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $e75a6c24923c03f0$export$971d5caa766a69d7(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $e75a6c24923c03f0$var$scrollPositions = /* @__PURE__ */ new Map();
function $e75a6c24923c03f0$export$a9c23c6ac3fc3eca(key, scrollPosition) {
    $e75a6c24923c03f0$var$scrollPositions.set(key, scrollPosition);
}
function $e75a6c24923c03f0$export$efccba1c4a2ef57b(key) {
    const scroll = $e75a6c24923c03f0$var$scrollPositions.get(key);
    $e75a6c24923c03f0$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $e75a6c24923c03f0$export$d141bba7fdc215a3(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $e75a6c24923c03f0$export$25ce5a424b770e84(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/errors.ts
/**
* Flags so we can combine them when checking for multiple errors. This is the internal version of
* {@link NavigationFailureType}.
*
* @internal
*/ let $e75a6c24923c03f0$export$71511d61b312f219 = /* @__PURE__ */ function(ErrorTypes$1) {
    ErrorTypes$1[ErrorTypes$1["MATCHER_NOT_FOUND"] = 1] = "MATCHER_NOT_FOUND";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_GUARD_REDIRECT"] = 2] = "NAVIGATION_GUARD_REDIRECT";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_ABORTED"] = 4] = "NAVIGATION_ABORTED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_CANCELLED"] = 8] = "NAVIGATION_CANCELLED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_DUPLICATED"] = 16] = "NAVIGATION_DUPLICATED";
    return ErrorTypes$1;
}({});
const $e75a6c24923c03f0$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $e75a6c24923c03f0$export$90a7f3efeed30595 = /* @__PURE__ */ function(NavigationFailureType$1) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType$1[NavigationFailureType$1["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType$1[NavigationFailureType$1["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType$1[NavigationFailureType$1["duplicated"] = 16] = "duplicated";
    return NavigationFailureType$1;
}({});
const $e75a6c24923c03f0$var$ErrorTypeMessages = {
    [$e75a6c24923c03f0$export$71511d61b312f219.MATCHER_NOT_FOUND] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$e75a6c24923c03f0$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_ABORTED] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_CANCELLED] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_DUPLICATED] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $e75a6c24923c03f0$export$4a5767248b18ef41(type, params) {
    return $e75a6c24923c03f0$export$b4171a6734a65d42(/* @__PURE__ */ new Error(), {
        type: type,
        [$e75a6c24923c03f0$var$NavigationFailureSymbol]: true
    }, params);
}
function $e75a6c24923c03f0$export$8b22cf2602fb60ce(error, type) {
    return error instanceof Error && $e75a6c24923c03f0$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $e75a6c24923c03f0$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $e75a6c24923c03f0$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $e75a6c24923c03f0$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $e75a6c24923c03f0$export$dda1d9f60106f0e9(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($e75a6c24923c03f0$var$PLUS_RE, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!$e75a6c24923c03f0$export$78acf4525d8a74c4(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $e75a6c24923c03f0$export$39b482c5e57630a8(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $e75a6c24923c03f0$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ($e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map((v)=>v && $e75a6c24923c03f0$var$encodeQueryValue(v)) : [
            value && $e75a6c24923c03f0$var$encodeQueryValue(value)
        ]).forEach((value$1)=>{
            if (value$1 !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value$1 != null) search += "=" + value$1;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $e75a6c24923c03f0$export$953cecd6e717a553(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = $e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $e75a6c24923c03f0$export$882b5998b3b9117c = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $e75a6c24923c03f0$export$ffb5f4729a158638 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $e75a6c24923c03f0$export$4368d992c4eafac0 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $e75a6c24923c03f0$export$3b14a55fb2447963 = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $e75a6c24923c03f0$export$2d1720544b23b823 = Symbol("");
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $e75a6c24923c03f0$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $e75a6c24923c03f0$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $e75a6c24923c03f0$export$ae1af26003f05816(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($e75a6c24923c03f0$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $e75a6c24923c03f0$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $e75a6c24923c03f0$export$2408f22a0fab9ae5(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($e75a6c24923c03f0$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $e75a6c24923c03f0$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($e75a6c24923c03f0$export$4a5767248b18ef41($e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_ABORTED, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($e75a6c24923c03f0$export$d141bba7fdc215a3(valid)) reject($e75a6c24923c03f0$export$4a5767248b18ef41($e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $e75a6c24923c03f0$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $e75a6c24923c03f0$export$3466f893ebf79586(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $e75a6c24923c03f0$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($e75a6c24923c03f0$var$isRouteComponent(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $e75a6c24923c03f0$var$isESModule(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $e75a6c24923c03f0$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $e75a6c24923c03f0$var$isESModule(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $e75a6c24923c03f0$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$e75a6c24923c03f0$export$61196ced6d74a310(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$e75a6c24923c03f0$export$61196ced6d74a310(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $e75a6c24923c03f0$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $e75a6c24923c03f0$export$b4171a6734a65d42({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$e75a6c24923c03f0$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $e75a6c24923c03f0$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $e75a6c24923c03f0$var$routerId = 0;
function $e75a6c24923c03f0$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $e75a6c24923c03f0$var$routerId++;
    (0, $de8f43bece76d38a$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $e75a6c24923c03f0$export$3466f893ebf79586("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $e75a6c24923c03f0$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $e75a6c24923c03f0$var$PINK_500
                });
            }
            if ($e75a6c24923c03f0$export$78acf4525d8a74c4(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $e75a6c24923c03f0$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $e75a6c24923c03f0$var$RED_100;
                        textColor = $e75a6c24923c03f0$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $e75a6c24923c03f0$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $e75a6c24923c03f0$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $TusQn.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $e75a6c24923c03f0$var$formatDisplay("beforeEach"),
                from: $e75a6c24923c03f0$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $e75a6c24923c03f0$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $e75a6c24923c03f0$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $e75a6c24923c03f0$var$formatDisplay("\u274C");
            } else data.status = $e75a6c24923c03f0$var$formatDisplay("\u2705");
            data.from = $e75a6c24923c03f0$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $e75a6c24923c03f0$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($e75a6c24923c03f0$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$e75a6c24923c03f0$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$e75a6c24923c03f0$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($e75a6c24923c03f0$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route$1)=>route$1.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $e75a6c24923c03f0$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $e75a6c24923c03f0$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $e75a6c24923c03f0$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$e75a6c24923c03f0$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $e75a6c24923c03f0$var$PINK_500 = 15485081;
const $e75a6c24923c03f0$var$BLUE_600 = 2450411;
const $e75a6c24923c03f0$var$LIME_500 = 8702998;
const $e75a6c24923c03f0$var$CYAN_400 = 2282478;
const $e75a6c24923c03f0$var$ORANGE_400 = 16486972;
const $e75a6c24923c03f0$var$DARK = 6710886;
const $e75a6c24923c03f0$var$RED_100 = 16704226;
const $e75a6c24923c03f0$var$RED_700 = 12131356;
function $e75a6c24923c03f0$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $e75a6c24923c03f0$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($e75a6c24923c03f0$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($e75a6c24923c03f0$var$formatRouteRecordForInspector)
    };
}
let $e75a6c24923c03f0$var$routeRecordId = 0;
const $e75a6c24923c03f0$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $e75a6c24923c03f0$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $e75a6c24923c03f0$export$61196ced6d74a310(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$e75a6c24923c03f0$export$61196ced6d74a310(match, route.record));
    route.children.forEach((childRoute)=>$e75a6c24923c03f0$var$markRouteRecordActive(childRoute, currentRoute));
}
function $e75a6c24923c03f0$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($e75a6c24923c03f0$var$resetMatchStateOnRouteRecord);
}
function $e75a6c24923c03f0$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($e75a6c24923c03f0$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$e75a6c24923c03f0$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(path);
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$e75a6c24923c03f0$var$isRouteMatching(child, filter));
}
function $e75a6c24923c03f0$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
//#region src/history/html5.ts
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $a809ac530d32f081$var$createCurrentLocation(base, location$1) {
    const { pathname: pathname, search: search, hash: hash } = location$1;
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $e75a6c24923c03f0$export$e7c866399fa523f5)(pathFromHash, "");
    }
    return (0, $e75a6c24923c03f0$export$e7c866399fa523f5)(pathname, base) + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: (0, $e75a6c24923c03f0$export$342063e11d6c3cad).pop,
                direction: delta ? delta > 0 ? (0, $e75a6c24923c03f0$export$c4ce752e73470fba).forward : (0, $e75a6c24923c03f0$export$c4ce752e73470fba).back : (0, $e75a6c24923c03f0$export$c4ce752e73470fba).unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        if (document.visibilityState === "hidden") {
            const { history: history$1 } = window;
            if (!history$1.state) return;
            history$1.replaceState((0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, history$1.state, {
                scroll: (0, $e75a6c24923c03f0$export$e7094788287c5e9b)()
            }), "");
        }
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
        document.removeEventListener("visibilitychange", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    document.addEventListener("visibilitychange", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? (0, $e75a6c24923c03f0$export$e7094788287c5e9b)() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history$1, location: location$1 } = window;
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location$1)
    };
    const historyState = {
        value: history$1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history$1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace$1) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location$1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            history$1[replace$1 ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location$1[replace$1 ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, history$1.state, $a809ac530d32f081$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        const currentState = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, historyState.value, history$1.state, {
            forward: to,
            scroll: (0, $e75a6c24923c03f0$export$e7094788287c5e9b)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = (0, $e75a6c24923c03f0$export$3a1a48c8f6ef640e)(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $e75a6c24923c03f0$export$35e795649ee09318).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        [
            (0, $e75a6c24923c03f0$export$ebd11618f299a286),
            {}
        ]
    ];
    let position = 0;
    base = (0, $e75a6c24923c03f0$export$3a1a48c8f6ef640e)(base);
    function setLocation(location$1, state = {}) {
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location$1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: (0, $e75a6c24923c03f0$export$342063e11d6c3cad).pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        location: (0, $e75a6c24923c03f0$export$ebd11618f299a286),
        state: {},
        base: base,
        createHref: (0, $e75a6c24923c03f0$export$35e795649ee09318).bind(null, base),
        replace (to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    (0, $e75a6c24923c03f0$export$ebd11618f299a286),
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = delta < 0 ? (0, $e75a6c24923c03f0$export$c4ce752e73470fba).back : (0, $e75a6c24923c03f0$export$c4ce752e73470fba).forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/matcher/pathTokenizer.ts
let $a809ac530d32f081$var$TokenType = /* @__PURE__ */ function(TokenType$1) {
    TokenType$1[TokenType$1["Static"] = 0] = "Static";
    TokenType$1[TokenType$1["Param"] = 1] = "Param";
    TokenType$1[TokenType$1["Group"] = 2] = "Group";
    return TokenType$1;
}({});
var $a809ac530d32f081$var$TokenizerState = /* @__PURE__ */ function(TokenizerState$1) {
    TokenizerState$1[TokenizerState$1["Static"] = 0] = "Static";
    TokenizerState$1[TokenizerState$1["Param"] = 1] = "Param";
    TokenizerState$1[TokenizerState$1["ParamRegExp"] = 2] = "ParamRegExp";
    TokenizerState$1[TokenizerState$1["ParamRegExpEnd"] = 3] = "ParamRegExpEnd";
    TokenizerState$1[TokenizerState$1["EscapeNext"] = 4] = "EscapeNext";
    return TokenizerState$1;
}($a809ac530d32f081$var$TokenizerState || {});
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: $a809ac530d32f081$var$TokenType.Static,
    value: ""
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = $a809ac530d32f081$var$TokenizerState.Static;
    let previousState = state;
    const tokens = [];
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    let i = 0;
    let char;
    let buffer = "";
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === $a809ac530d32f081$var$TokenizerState.Static) segment.push({
            type: $a809ac530d32f081$var$TokenType.Static,
            value: buffer
        });
        else if (state === $a809ac530d32f081$var$TokenizerState.Param || state === $a809ac530d32f081$var$TokenizerState.ParamRegExp || state === $a809ac530d32f081$var$TokenizerState.ParamRegExpEnd) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: $a809ac530d32f081$var$TokenType.Param,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== $a809ac530d32f081$var$TokenizerState.ParamRegExp) {
            previousState = state;
            state = $a809ac530d32f081$var$TokenizerState.EscapeNext;
            continue;
        }
        switch(state){
            case $a809ac530d32f081$var$TokenizerState.Static:
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = $a809ac530d32f081$var$TokenizerState.Param;
                } else addCharToBuffer();
                break;
            case $a809ac530d32f081$var$TokenizerState.EscapeNext:
                addCharToBuffer();
                state = previousState;
                break;
            case $a809ac530d32f081$var$TokenizerState.Param:
                if (char === "(") state = $a809ac530d32f081$var$TokenizerState.ParamRegExp;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = $a809ac530d32f081$var$TokenizerState.Static;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case $a809ac530d32f081$var$TokenizerState.ParamRegExp:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = $a809ac530d32f081$var$TokenizerState.ParamRegExpEnd;
                } else customRe += char;
                break;
            case $a809ac530d32f081$var$TokenizerState.ParamRegExpEnd:
                consumeBuffer();
                state = $a809ac530d32f081$var$TokenizerState.Static;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === $a809ac530d32f081$var$TokenizerState.ParamRegExp) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = "[^/]+?";
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
var $a809ac530d32f081$var$PathScore = /* @__PURE__ */ function(PathScore$1) {
    PathScore$1[PathScore$1["_multiplier"] = 10] = "_multiplier";
    PathScore$1[PathScore$1["Root"] = 90] = "Root";
    PathScore$1[PathScore$1["Segment"] = 40] = "Segment";
    PathScore$1[PathScore$1["SubSegment"] = 30] = "SubSegment";
    PathScore$1[PathScore$1["Static"] = 40] = "Static";
    PathScore$1[PathScore$1["Dynamic"] = 20] = "Dynamic";
    PathScore$1[PathScore$1["BonusCustomRegExp"] = 10] = "BonusCustomRegExp";
    PathScore$1[PathScore$1["BonusWildcard"] = -50] = "BonusWildcard";
    PathScore$1[PathScore$1["BonusRepeatable"] = -20] = "BonusRepeatable";
    PathScore$1[PathScore$1["BonusOptional"] = -8] = "BonusOptional";
    PathScore$1[PathScore$1["BonusStrict"] = .7000000000000001] = "BonusStrict";
    PathScore$1[PathScore$1["BonusCaseSensitive"] = .25] = "BonusCaseSensitive";
    return PathScore$1;
}($a809ac530d32f081$var$PathScore || {});
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    const score = [];
    let pattern = options.start ? "^" : "";
    const keys = [];
    for (const segment of segments){
        const segmentScores = segment.length ? [] : [
            $a809ac530d32f081$var$PathScore.Root
        ];
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            let subSegmentScore = $a809ac530d32f081$var$PathScore.Segment + (options.sensitive ? $a809ac530d32f081$var$PathScore.BonusCaseSensitive : 0);
            if (token.type === $a809ac530d32f081$var$TokenType.Static) {
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += $a809ac530d32f081$var$PathScore.Static;
            } else if (token.type === $a809ac530d32f081$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re$1 = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                if (re$1 !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) subSegmentScore += $a809ac530d32f081$var$PathScore.BonusCustomRegExp;
                let subPattern = repeatable ? `((?:${re$1})(?:/(?:${re$1}))*)` : `(${re$1})`;
                if (!tokenIndex) subPattern = optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += $a809ac530d32f081$var$PathScore.Dynamic;
                if (optional) subSegmentScore += $a809ac530d32f081$var$PathScore.BonusOptional;
                if (repeatable) subSegmentScore += $a809ac530d32f081$var$PathScore.BonusRepeatable;
                if (re$1 === ".*") subSegmentScore += $a809ac530d32f081$var$PathScore.BonusWildcard;
            }
            segmentScores.push(subSegmentScore);
        }
        score.push(segmentScores);
    }
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += $a809ac530d32f081$var$PathScore.BonusStrict;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment)if (token.type === $a809ac530d32f081$var$TokenType.Static) path += token.value;
            else if (token.type === $a809ac530d32f081$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional } = token;
                const param = value in params ? params[value] : "";
                if ((0, $e75a6c24923c03f0$export$78acf4525d8a74c4)(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                const text = (0, $e75a6c24923c03f0$export$78acf4525d8a74c4)(param) ? param.join("/") : param;
                if (!text) {
                    if (optional) {
                        if (segment.length < 2) {
                            if (path.endsWith("/")) path = path.slice(0, -1);
                            else avoidDuplicatedSlash = true;
                        }
                    } else throw new Error(`Missing required param "${value}"`);
                }
                path += text;
            }
        }
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === $a809ac530d32f081$var$PathScore.Static + $a809ac530d32f081$var$PathScore.Segment ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === $a809ac530d32f081$var$PathScore.Static + $a809ac530d32f081$var$PathScore.Segment ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    const matchers = [];
    const matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $e75a6c24923c03f0$export$dc98b0b04f4c7758)($a809ac530d32f081$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = (0, $e75a6c24923c03f0$export$dc98b0b04f4c7758)(globalOptions, record);
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($a809ac530d32f081$var$normalizeRouteRecord((0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, mainNormalizedRecord, {
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if ($a809ac530d32f081$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            originalRecord = originalRecord || matcher;
        }
        return originalMatcher ? ()=>{
            removeRoute(originalMatcher);
        } : (0, $e75a6c24923c03f0$export$3722cfe417b6ed86);
    }
    function removeRoute(matcherRef) {
        if ((0, $e75a6c24923c03f0$export$25ce5a424b770e84)(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $a809ac530d32f081$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location$1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location$1 && location$1.name) {
            matcher = matcherMap.get(location$1.name);
            if (!matcher) throw (0, $e75a6c24923c03f0$export$4a5767248b18ef41)((0, $e75a6c24923c03f0$export$71511d61b312f219).MATCHER_NOT_FOUND, {
                location: location$1
            });
            name = matcher.record.name;
            params = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)($a809ac530d32f081$var$pickParams(currentLocation.params, matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), location$1.params && $a809ac530d32f081$var$pickParams(location$1.params, matcher.keys.map((k)=>k.name)));
            path = matcher.stringify(params);
        } else if (location$1.path != null) {
            path = location$1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw (0, $e75a6c24923c03f0$export$4a5767248b18ef41)((0, $e75a6c24923c03f0$export$71511d61b312f219).MATCHER_NOT_FOUND, {
                location: location$1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, currentLocation.params, location$1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $a809ac530d32f081$var$pickParams(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>(0, $e75a6c24923c03f0$export$b4171a6734a65d42)(meta, record.meta), {});
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys)if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return (0, $e75a6c24923c03f0$export$3466f893ebf79586)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    for (const key of b.keys)if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return (0, $e75a6c24923c03f0$export$3466f893ebf79586)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) (0, $e75a6c24923c03f0$export$3466f893ebf79586)(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys)if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return (0, $e75a6c24923c03f0$export$3466f893ebf79586)(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $a809ac530d32f081$var$findInsertionIndex(matcher, matchers) {
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        if ($a809ac530d32f081$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    const insertionAncestor = $a809ac530d32f081$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $a809ac530d32f081$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent)if ($a809ac530d32f081$var$isMatchable(ancestor) && $a809ac530d32f081$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $a809ac530d32f081$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)((0, $e75a6c24923c03f0$export$4368d992c4eafac0));
    const currentRoute = (0, $TusQn.inject)((0, $e75a6c24923c03f0$export$3b14a55fb2447963));
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $TusQn.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $TusQn.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex((0, $e75a6c24923c03f0$export$61196ced6d74a310).bind(null, routeMatched));
        if (index > -1) return index;
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $e75a6c24923c03f0$export$61196ced6d74a310).bind(null, matched[length - 2])) : index;
    });
    const isActive = (0, $TusQn.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $TusQn.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $e75a6c24923c03f0$export$9bb611d729802a56)(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) {
            const p = router[(0, $01W3b.unref)(props.replace) ? "replace" : "push"]((0, $01W3b.unref)(props.to)).catch((0, $e75a6c24923c03f0$export$3722cfe417b6ed86));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9)) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $e75a6c24923c03f0$export$d141bba7fdc215a3)((0, $01W3b.unref)(props.to)) ? null : "Invalid \"to\" value";
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $TusQn.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $a809ac530d32f081$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $a809ac530d32f081$var$RouterLinkImpl = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)((0, $e75a6c24923c03f0$export$4368d992c4eafac0));
        const elClass = (0, $TusQn.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $a809ac530d32f081$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $TusQn.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
/**
* Component to render a link that triggers a navigation on click.
*/ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else if (!(0, $e75a6c24923c03f0$export$78acf4525d8a74c4)(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value.valueOf() !== outerValue[i].valueOf())) return false;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
//#endregion
//#region src/RouterView.ts
const $a809ac530d32f081$var$RouterViewImpl = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)((0, $e75a6c24923c03f0$export$2d1720544b23b823));
        const routeToDisplay = (0, $TusQn.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)((0, $e75a6c24923c03f0$export$ffb5f4729a158638), 0);
        const depth = (0, $TusQn.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $TusQn.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)((0, $e75a6c24923c03f0$export$ffb5f4729a158638), (0, $TusQn.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)((0, $e75a6c24923c03f0$export$882b5998b3b9117c), matchedRouteRef);
        (0, $TusQn.provide)((0, $e75a6c24923c03f0$export$2d1720544b23b823), routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        (0, $TusQn.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $e75a6c24923c03f0$export$61196ced6d74a310)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9) && component.ref) {
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $e75a6c24923c03f0$export$78acf4525d8a74c4)(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ]).forEach((instance)=>{
                    instance.__vrv_devtools = info;
                });
            }
            return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $e75a6c24923c03f0$export$3466f893ebf79586)(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${comp}>\n    <component :is="Component" />\n  </${comp}>\n</router-view>`);
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || (0, $e75a6c24923c03f0$export$dda1d9f60106f0e9);
    const stringifyQuery$1 = options.stringifyQuery || (0, $e75a6c24923c03f0$export$39b482c5e57630a8);
    const routerHistory = options.history;
    const beforeGuards = (0, $e75a6c24923c03f0$export$db3b6bfb95261072)();
    const beforeResolveGuards = (0, $e75a6c24923c03f0$export$db3b6bfb95261072)();
    const afterGuards = (0, $e75a6c24923c03f0$export$db3b6bfb95261072)();
    const currentRoute = (0, $01W3b.shallowRef)((0, $e75a6c24923c03f0$export$56c0d5a1e737357d));
    let pendingLocation = (0, $e75a6c24923c03f0$export$56c0d5a1e737357d);
    if ((0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = (0, $e75a6c24923c03f0$export$9e5f44173e64f162).bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = (0, $e75a6c24923c03f0$export$9e5f44173e64f162).bind(null, (0, $e75a6c24923c03f0$export$71cec2538cb2c617));
    const decodeParams = (0, $e75a6c24923c03f0$export$9e5f44173e64f162).bind(null, (0, $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd));
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ((0, $e75a6c24923c03f0$export$25ce5a424b770e84)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        currentLocation = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = (0, $e75a6c24923c03f0$export$db202ddc8be9136)(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute$1 = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href$1 = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $e75a6c24923c03f0$export$b4171a6734a65d42)(locationNormalized, matchedRoute$1, {
                params: decodeParams(matchedRoute$1.params),
                hash: (0, $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd)(locationNormalized.hash),
                redirectedFrom: void 0,
                href: href$1
            });
        }
        let matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, rawLocation, {
            path: (0, $e75a6c24923c03f0$export$db202ddc8be9136)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            const targetParams = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = (0, $e75a6c24923c03f0$export$ef35774e6d314e91)(stringifyQuery$1, (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, rawLocation, {
            hash: (0, $e75a6c24923c03f0$export$3a6d5c9ae78a2c08)(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $e75a6c24923c03f0$export$39b482c5e57630a8) ? (0, $e75a6c24923c03f0$export$953cecd6e717a553)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: void 0,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $e75a6c24923c03f0$export$db202ddc8be9136)(parseQuery$1, to, currentRoute.value.path) : (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $e75a6c24923c03f0$export$4a5767248b18ef41)((0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_CANCELLED, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $e75a6c24923c03f0$export$b4171a6734a65d42)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        const replace$1 = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $e75a6c24923c03f0$export$b4171a6734a65d42)(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace$1
        }), redirectedFrom || targetLocation);
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && (0, $e75a6c24923c03f0$export$d66501df72047452)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $e75a6c24923c03f0$export$4a5767248b18ef41)((0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_DUPLICATED, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>(0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(error) ? (0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(error, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT) ? error : markAsReady(error) : triggerError(error, toLocation, from)).then((failure$1)=>{
            if (failure$1) {
                if ((0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(failure$1, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT)) return pushWithRedirect((0, $e75a6c24923c03f0$export$b4171a6734a65d42)({
                    replace: replace$1
                }, locationAsObject(failure$1.to), {
                    state: typeof failure$1.to === "object" ? (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({}, data, failure$1.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure$1 = finalizeNavigation(toLocation, from, true, replace$1, data);
            triggerAfterEach(toLocation, from, failure$1);
            return failure$1;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = (0, $e75a6c24923c03f0$export$7ccc53e8f1e7dfc5)(to, from);
        guards = (0, $e75a6c24923c03f0$export$43caf9889c228507)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push((0, $e75a6c24923c03f0$export$23f2a1d2818174ef)(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(()=>{
            guards = [];
            for (const guard of beforeGuards.list())guards.push((0, $e75a6c24923c03f0$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = (0, $e75a6c24923c03f0$export$43caf9889c228507)(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push((0, $e75a6c24923c03f0$export$23f2a1d2818174ef)(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const record of enteringRecords)if (record.beforeEnter) {
                if ((0, $e75a6c24923c03f0$export$78acf4525d8a74c4)(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push((0, $e75a6c24923c03f0$export$23f2a1d2818174ef)(beforeEnter, to, from));
                else guards.push((0, $e75a6c24923c03f0$export$23f2a1d2818174ef)(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            to.matched.forEach((record)=>record.enterCallbacks = {});
            guards = (0, $e75a6c24923c03f0$export$43caf9889c228507)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push((0, $e75a6c24923c03f0$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch((err)=>(0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(err, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_CANCELLED) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace$1, data) {
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        const isFirstNavigation = from === (0, $e75a6c24923c03f0$export$56c0d5a1e737357d);
        const state = !(0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9) ? {} : history.state;
        if (isPush) {
            if (replace$1 || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $e75a6c24923c03f0$export$b4171a6734a65d42)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            const toLocation = resolve(to);
            const shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $e75a6c24923c03f0$export$b4171a6734a65d42)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $e75a6c24923c03f0$export$3722cfe417b6ed86));
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            if (0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9) (0, $e75a6c24923c03f0$export$a9c23c6ac3fc3eca)((0, $e75a6c24923c03f0$export$971d5caa766a69d7)(from.fullPath, info.delta), (0, $e75a6c24923c03f0$export$e7094788287c5e9b)());
            navigate(toLocation, from).catch((error)=>{
                if ((0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(error, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_CANCELLED)) return error;
                if ((0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(error, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT)) {
                    pushWithRedirect((0, $e75a6c24923c03f0$export$b4171a6734a65d42)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        if ((0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(failure, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_DUPLICATED) && !info.delta && info.type === (0, $e75a6c24923c03f0$export$342063e11d6c3cad).pop) routerHistory.go(-1, false);
                    }).catch((0, $e75a6c24923c03f0$export$3722cfe417b6ed86));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(failure, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_CANCELLED)) routerHistory.go(-info.delta, false);
                    else if (info.type === (0, $e75a6c24923c03f0$export$342063e11d6c3cad).pop && (0, $e75a6c24923c03f0$export$8b22cf2602fb60ce)(failure, (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $e75a6c24923c03f0$export$71511d61b312f219).NAVIGATION_DUPLICATED)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $e75a6c24923c03f0$export$3722cfe417b6ed86));
        });
    }
    let readyHandlers = (0, $e75a6c24923c03f0$export$db3b6bfb95261072)();
    let errorListeners = (0, $e75a6c24923c03f0$export$db3b6bfb95261072)();
    let ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $e75a6c24923c03f0$export$56c0d5a1e737357d)) return Promise.resolve();
        return new Promise((resolve$1, reject)=>{
            readyHandlers.add([
                resolve$1,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve$1, reject])=>err ? reject(err) : resolve$1());
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!(0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9) || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && (0, $e75a6c24923c03f0$export$efccba1c4a2ef57b)((0, $e75a6c24923c03f0$export$971d5caa766a69d7)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && (0, $e75a6c24923c03f0$export$96f57966bedc81b4)(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = /* @__PURE__ */ new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            app.component("RouterLink", $a809ac530d32f081$export$fce709ebdac448ed);
            app.component("RouterView", $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            if ((0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9) && !started && currentRoute.value === (0, $e75a6c24923c03f0$export$56c0d5a1e737357d)) {
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in 0, $e75a6c24923c03f0$export$56c0d5a1e737357d)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide((0, $e75a6c24923c03f0$export$4368d992c4eafac0), router);
            app.provide((0, $e75a6c24923c03f0$export$3b14a55fb2447963), (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide((0, $e75a6c24923c03f0$export$2d1720544b23b823), currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $e75a6c24923c03f0$export$56c0d5a1e737357d);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $e75a6c24923c03f0$export$56c0d5a1e737357d);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $e75a6c24923c03f0$export$3d8c2f653ac9d0b9)) (0, $e75a6c24923c03f0$export$625550452a3fa3ec)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)((0, $e75a6c24923c03f0$export$4368d992c4eafac0));
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $a809ac530d32f081$export$3f79f0b98112cf57(_name) {
    return (0, $TusQn.inject)((0, $e75a6c24923c03f0$export$3b14a55fb2447963));
}


let $9cb1ef1a035b0cbc$var$script;




let $9cb1ef1a035b0cbc$var$initialize = ()=>{
    $9cb1ef1a035b0cbc$var$script = (parcelRequire("6xlhX"));
    if ($9cb1ef1a035b0cbc$var$script.__esModule) $9cb1ef1a035b0cbc$var$script = $9cb1ef1a035b0cbc$var$script.default;
    $9cb1ef1a035b0cbc$var$script.render = (parcelRequire("cPp6y")).render;
    $9cb1ef1a035b0cbc$var$script.__cssModules = {};
    (parcelRequire("1fW17")).default($9cb1ef1a035b0cbc$var$script);
    $9cb1ef1a035b0cbc$var$script.__scopeId = 'data-v-467256';
    $9cb1ef1a035b0cbc$var$script.__file = "About.vue";
};
$9cb1ef1a035b0cbc$var$initialize();
var $9cb1ef1a035b0cbc$export$2e2bcd8739ae039 = $9cb1ef1a035b0cbc$var$script;


let $a4d0c4d5e27c3a39$var$script;




let $a4d0c4d5e27c3a39$var$initialize = ()=>{
    $a4d0c4d5e27c3a39$var$script = (parcelRequire("eIvmH"));
    if ($a4d0c4d5e27c3a39$var$script.__esModule) $a4d0c4d5e27c3a39$var$script = $a4d0c4d5e27c3a39$var$script.default;
    $a4d0c4d5e27c3a39$var$script.render = (parcelRequire("igJGC")).render;
    $a4d0c4d5e27c3a39$var$script.__cssModules = {};
    (parcelRequire("f9gbR")).default($a4d0c4d5e27c3a39$var$script);
    $a4d0c4d5e27c3a39$var$script.__scopeId = 'data-v-4f289d';
    $a4d0c4d5e27c3a39$var$script.__file = "Resume.vue";
};
$a4d0c4d5e27c3a39$var$initialize();
var $a4d0c4d5e27c3a39$export$2e2bcd8739ae039 = $a4d0c4d5e27c3a39$var$script;


var $758b8c194fe21e4f$export$2e2bcd8739ae039 = (0, $a809ac530d32f081$export$baddd0131ee8c05b)({
    history: (0, $a809ac530d32f081$export$542bc3a76486c94d)(),
    routes: [
        {
            path: '/',
            name: 'About',
            component: (0, $9cb1ef1a035b0cbc$export$2e2bcd8739ae039),
            meta: {
                title: 'Home',
                icon: 'mdi-home'
            },
            props: {}
        },
        {
            path: '/resume',
            name: 'Resume',
            component: (0, $a4d0c4d5e27c3a39$export$2e2bcd8739ae039),
            meta: {
                title: 'Resume',
                icon: 'mdi-file-document'
            },
            props: {}
        }
    ]
});




const $46b0125df3b201f4$var$vuetify = (0, $a0b080bdc0c7df32$exports.createVuetify)({
    theme: {
        defaultTheme: 'light'
    },
    display: {
        mobileBreakpoint: 'sm'
    }
});
const $46b0125df3b201f4$var$app = (0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
$46b0125df3b201f4$var$app.use((0, $758b8c194fe21e4f$export$2e2bcd8739ae039));
$46b0125df3b201f4$var$app.use($46b0125df3b201f4$var$vuetify);
$46b0125df3b201f4$var$app.mount('#app');


//# sourceMappingURL=matthewswar.73262d70.js.map
